const Locations = [
    'Abada,Ghoraghat,West Bengal',
    'Abhaipur,Abhaipur,Bihar',
    'Abhayapuri,Abhayapuri,Assam',
    'Abohar,Abohar,Punjab',
    'Abu Road,Sirohi,Rajasthan',
    'Abutara Halt,Kamatabutara,West Bengal',
    'Acharapakkam,Acharapakkam,Tamil Nadu',
    'Acharya Narendra Dev,Faizabad,Uttar Pradesh',
    'Achalganj,Bithar,Uttar Pradesh',
    'Achalpur,Amravati,Maharashtra',
    'Achhalda,Basauli,Uttar Pradesh',
    'Achhnera Junction,Agra,Uttar Pradesh',
    'Adarshnagar,Adarshnagar,Rajasthan',
    'Adarshnagar Delhi,West Delhi,Delhi',
    'Adas Road,Adas,Gujarat',
    'Adesar,Kutch,Gujarat',
    'Adgaon Buzurg,Adgaon Bk,Maharashtra',
    'Adilabad,Adilabad,Telangana',
    'Adipur,Gandhidham,Gujarat',
    'Adityapur,Seraikela Kharsawan,Jharkhand',
    'Adoni,Kurnool,Andhra Pradesh',
    'Adra Junction,Purulia,West Bengal',
    'Aduturai,Thanjavur,Tamil Nadu',
    'Agartala,Agartala,Tripura',
    'Agas,Boriya,Gujarat',
    'Agasod,Kalraoni,Madhya Pradesh',
    'Aghwanpur,Mustahk,Uttar Pradesh',
    'Agomani,Dhubri,Assam',
    'Agori Khas,Sonbhadra,Uttar Pradesh',
    'Agra Cantonment,Agra,Uttar Pradesh',
    'Agra City,Agra,Uttar Pradesh',
    'Agra Fort,Agra,Uttar Pradesh',
    'Ahalyapur,Deoria Meer,Uttar Pradesh',
    'Ahmadgarh,Ahmadgarh,Punjab',
    'Ahmednagar,Ahmednagar,Maharashtra',
    'Ahmedpur Junction,Birbhum,West Bengal',
    'Ahmedabad,Ahmedabad,Gujarat',
    'Ahraura Road,Narayanpur,Uttar Pradesh',
    'Airoli,Navi Mumbai,Maharashtra',
    'Aishbagh,Lucknow,Uttar Pradesh',
    'Ait,Jalaun,Uttar Pradesh',
    'Aithal,Aithal Buzurg,Uttarakhand',
    'Ajaibpur,Ajayabpur,Uttar Pradesh',
    'Ajanti,Khandwa,Madhya Pradesh',
    'Ajaraka,Ajaraka,Rajasthan',
    'Ajgain,Unnao,Uttar Pradesh',
    'Ajhai,Mathura,Uttar Pradesh',
    'Ajit,Barmer,Rajasthan',
    'Ajmer Junction,Ajmer,Rajasthan',
    'Ajni,Nagpur,Maharashtra',
    'Akalkot Road,Solapur,Maharashtra',
    'Akaltara,Janjgir-Champa,Chhattisgarh',
    'Akkannapet,Akkannapet,Telangana',
    'Akbarganj,Rae Bareli,Uttar Pradesh',
    'Akbarpur,Lucknow,Uttar Pradesh',
    'Akividu,Akividu,Andhra Pradesh',
    'Akodia,Akodia,Madhya Pradesh',
    'Akola Junction,Akola,Maharashtra',
    'Akolner,Akolner,Maharashtra',
    'Akona,Akona,Uttar Pradesh',
    'Akot,Akola,Maharashtra',
    'Akurdi,Pune,Maharashtra',
    'Alamnagar,Lucknow,Uttar Pradesh',
    'Aler,Alair,Telangana',
    'Algapur,Hailakandi,Assam',
    'Algawan,Jatpura,Uttar Pradesh',
    'Alia Bada,Alia Bada,Gujarat',
    'Aligarh Junction,Aligarh,Uttar Pradesh',
    'Alipurduar,Alipurduar,West Bengal',
    'Alipurduar Junction,Alipurduar,West Bengal',
    'Allahabad City,Allahabad,Uttar Pradesh',
    'Allahabad Junction,Allahabad,Uttar Pradesh',
    'Alappuzha,Alappuzha,Kerala',
    'Almatti,Almatti,Karnataka',
    'Alnavar Junction,Alnavar ,Karnataka',
    'Alniya,Kewal Nagar,Rajasthan',
    'Aluabari Road,Islampur,West Bengal',
    'Alwar,Alwar,Rajasthan',
    'Aluva,Thiruvananthapuram,Kerala',
    'Amalner,Jalgaon,Maharashtra',
    'Amalsad,Amalsad,Gujarat',
    'Aman Vadi,Aman Vadi,Maharashtra',
    'Amarpura,Baripol,Rajasthan',
    'Amausi,Lucknow ,Uttar Pradesh',
    'Amb Andaura,Una,Himachal Pradesh',
    'Ambagaon,Potanar,Odisha',
    'Ambala Cantonment,Kanpur,Haryana',
    'Ambala City,Kanpur,Haryana',
    'Ambalappuzha,Ambalappuzha,Kerala',
    'Ambale,Ambale,Maharashtra',
    'Ambari,Talaiguda,Maharashtra',
    'Ambari Falakata,Ambari,West Bengal',
    'Ambarnath,Mumbai,Maharashtra',
    'Ambassa,Dhalai ,Tripura',
    'Ambasamudram,Ambasamudram,Tamil Nadu',
    'Ambattur,Ambattur,Tamil Nadu',
    'Ambaturai,Chinnalapatti,Tamil Nadu',
    'Ambiapur,Sarkaura,Uttar Pradesh',
    'Ambika Kalna,Kalna,West Bengal',
    'Ambikapur,Raipur,Chhattisgarh',
    'Ambikeshwar,Gwalior,Madhya Pradesh',
    'Ambivli,Ambivli,Maharashtra',
    'Ambli Road,Ahmedabad,Gujarat',
    'Ambliyasan,Mahesana,Gujarat',
    'Ambodala,Ambodala,Odisha',
    'Ambur,Tirupattur,Tamil Nadu',
    'Amethi,Amethi,Uttar Pradesh',
    'Amgaon,Jalgaon,Maharashtra',
    'Amguri,Sivasagar,Assam',
    'Amla Junction,Betul,Madhya Pradesh',
    'Amlai,Anuppur ,Madhya Pradesh',
    'Amlakhurd,Amlakhurd,Madhya Pradesh',
    'Amli,Sawai Madhopur,Rajasthan',
    'Ammasandra,Ammasandra,Karnataka',
    'Amoni,Nonoi Village,Assam',
    'Amravati,Amravati,Maharashtra',
    'Amreli,Amreli,Gujarat',
    'Amritsar Junction,Amritsar,Punjab',
    'Amritvel,Amritvel,Gujarat',
    'Amroha,Amroha,Uttar Pradesh',
    'Anakapalle,Anakapalle,Andhra Pradesh',
    'Anand Junction,Anand,Gujarat',
    'Anand Nagar,Maharajganj,Uttar Pradesh',
    'Anand Vihar,Anand Vihar,Delhi',
    'Anandpur Sahib,Rupnagar,Punjab',
    'Anandtandavpur,Anandtandavpur,Tamil Nadu',
    'Anantapur,Anantapur,Andhra Pradesh',
    'Anaparti,East Godavari,Andhra Pradesh',
    'Anara,Chapari,West Bengal',
    'Anas,Dahod,Gujarat',
    'Andal Junction,Paschim Bardhaman,West Bengal',
    'Andheri,Mumbai,Maharashtra',
    'Angadippuram,Malappuram,Kerala',
    'Angamaly,Ernakulam,Kerala',
    'Angar,Angar,Maharashtra',
    'Angul,Angul,Odisha',
    'Anipur,Hailakandi,Assam',
    'Anjangaon,Anjangaon,Maharashtra',
    'Anjani,Mulgaon,Maharashtra',
    'Anjar,Kutch,Gujarat',
    'Anjhi Shahabad,Shahabad,Uttar Pradesh',
    'Ankai,Manmad,Maharashtra',
    'Ankleshwar Junction,Bharuch,Gujarat',
    'Ankola,Ankola,Karnataka',
    'Annanur,Arakkonam,Tamil Nadu',
    'Annavaram,East Godavari,Andhra Pradesh',
    'Annigeri,Annigeri,Karnataka',
    'Anpara,Auri,Uttar Pradesh',
    'Antah,Baran,Rajasthan',
    'Antu,Pratapgarh,Uttar Pradesh',
    'Anugraha Narayan Road,Aurangabad,Bihar',
    'Anupgarh,Sri Ganganagar,Rajasthan',
    'Anuppur Junction,Anuppur,Madhya Pradesh',
    'Anupshahr,Anupshahr,Uttar Pradesh',
    'Aonla,Rahtuiya,Uttar Pradesh',
    'Ara,Arrah,Bihar',
    'Arabagatta H,Arabagatta,Karnataka',
    'Arakkonam Junction,Ranipet,Tamil Nadu',
    'Araku,Visakhapatnam,Andhra Pradesh',
    'Aralvaymozhi,Aralvaimozhi,Tamil Nadu',
    'Arariya,Majkuri,Bihar',
    'Arariya Court,Majkuri,Bihar',
    'Arasur,Arasur,Tamil Nadu',
    'Aravalli Road,Murdav,Maharashtra',
    'Arunachal,Silchar,Assam',
    'Aravankadu,Nilgiris,Tamil Nadu',
    'Ariyalur,Ariyalur,Tamil Nadu',
    'Argora,Ranchi,Jharkhand',
    'Arjansar,Arjansar,Rajasthan',
    'Arjuni,Gondia,Maharashtra',
    'Arnetha,Shreepura,Rajasthan',
    'Arni Road,Tiruvannamalai,Tamil Nadu',
    'Arsikere Junction,Hassan,Karnataka',
    'Aruppukottai,Aruppukottai,Tamil Nadu',
    'Arvi,Arvi,Maharashtra',
    'Aryankavu,Aryankavu,Kerala',
    'Asafpur,Dagari,Uttar Pradesh',
    'Asalpur Jobner,Jaipur,Rajasthan',
    'Asangaon,Ulhasnagar,Maharashtra',
    'Asansol Junction,Ulhasnagar,West Bengal',
    'Asaoti,Asaoti,Haryana',
    'Ashok Nagar,Ashoknagar,Madhya Pradesh',
    'Asthal Bohar Junction,Rohtak,Haryana',
    'Aslana,Sadguwan,Madhya Pradesh',
    'Aslaoda,Ujjain,Madhya Pradesh',
    'Asnoti,Majali,Karnataka',
    'Asokhar,Bhind,Madhya Pradesh',
    'Asranada,Ram Nagar,Rajasthan',
    'Atari,Amritsar,Punjab',
    'Ataria,Amritsar,Uttar Pradesh',
    'Ateli,Khor,Haryana',
    'Atgaon,Atgaon,Maharashtra',
    'Athipattu,Minjur,Tamil Nadu',
    'Athipattu Pudhunagar,Athipattu Pudhunagar,Tamil Nadu',
    'Atrampur,Saraismail,Uttar Pradesh',
    'Atrauli Road,Khurja Rd,Uttar Pradesh',
    'Atru,Baran,Rajasthan',
    'Attabira,Tope,Odisha',
    'Attar,Khandwa,Madhya Pradesh',
    'Attur,Attur,Tamil Nadu',
    'Aujari,Jagiroad,Assam',
    'Aulenda,Aulenda,Uttar Pradesh',
    'Aunrihar Junction,Ghazipur,Uttar Pradesh',
    'Aurangabad,Aurangabad,Maharashtra',
    'Auvaneswarem,Auvaneswarem,Kerala',
    'Auwa,Kapari,Rajasthan',
    'Avadi,Chennai,Tamil Nadu',
    'Ayodhya,Ayodhya,Uttar Pradesh',
    'Azamgarh,Musapur,Uttar Pradesh',
    'Azamnagar Road,Barhat,Bihar',
    'Azara,Guwahati,Assam',
    'Azimganj City,Murshidabad,West Bengal',
    'Azimganj Junction,Murshidabad,West Bengal',
    'Babarpur,Panipat,Haryana',
    'Babatpur,Varanasi,Uttar Pradesh',
    'Bebejia,Bebejia,Assam',
    'Babhnan,Basti,Uttar Pradesh',
    'Babina,Jhansi,Madhya Pradesh',
    'Babrala,Sambhal,Uttar Pradesh',
    'Babugarh,Havispur Bigas,Uttar Pradesh',
    'Babupeth,Nagpur,Maharashtra',
    'Bacheli,Dantewada,Chhattisgarh',
    'Bachhrawan,Malhipur,Uttar Pradesh',
    'Bachwara Junction,Bachhawara,Bihar',
    'Badmal,Badmal,Odisha',
    'Baad,Haridwar,Uttar Pradesh',
    'Badami,Bagalkot,Karnataka',
    'Badampahar,Mayurbhanj,Jharkhand',
    'Badampudi,Pulla,Andhra Pradesh',
    'Badurpur Ghat,Uttarbadarpur,Assam',
    'Badarpur Junction,Karimganj,Assam',
    'Badausa,Badausa,Uttar Pradesh',
    'Badgam,Budgam,Jammu & Kashmir',
    'Badhada,Badhada,Gujarat',
    'Badhal,Kabron Ka Bas,Rajasthan',
    'Badlapur,Thane,Maharashtra',
    'Badli,North Delhi,Delhi',
    'Badnapur,Ramkheda,Maharashtra',
    'Badnera Junction,Amravati,Maharashtra',
    'Badshahnagar,Balmikinagar,Uttar Pradesh',
    'Badshahpur,Bahadurpur,Haryana',
    'Badwasi,Badwasi,Rajasthan',
    'Bagaha,Naraipur,Bihar',
    'Bagalkot,Bagalkot,Karnataka',
    'Bagbahra,Bagbahra,Chhattisgarh',
    'Bagetar,Bagetar,Assam',
    'Bagevadi Rd,Telgi,Karnataka',
    'Baghauli,Muzaffarnagar,Uttar Pradesh',
    'Baghnapara,Krishnadebpur,West Bengal',
    'Baghora,Ghatiyari,Madhya Pradesh',
    'Bagra Tawa,Hoshangabad,Madhya Pradesh',
    'Bagri Nagar,Khokhara,Rajasthan',
    'Bagri Sajjanpur,Bagri Sajjanpur,Rajasthan',
    'Bagula,Nadia,West Bengal',
    'Bagwali,Bandi,Punjab',
    'Bahadur Singh W,Bahadur Singh W,Punjab',
    'Bahadurgarh,Bahadurgarh,Haryana',
    'Bahadurpur,Nadia,West Bengal',
    'Baheri,Baheri,Uttar Pradesh',
    'Bahilpurwa,Jhilang,Uttar Pradesh',
    'Bahirkhand,Hooghly,West Bengal',
    'Bahjoi,Chandausi,Uttar Pradesh',
    'Bahraich,Bahraich,Uttar Pradesh',
    'Baidyanathdham,Deoghar,Jharkhand',
    'Baihata Chariali,Degunpar,Assam',
    'Baiguda,Bari,Odisha',
    'Baijnathpur,Saharsa,Bihar',
    'Baikunthpur Rd,Sardi,Chhattisgarh',
    'Bainchi / Boinchi,Boinchi,West Bengal',
    'Bairabi (Bhairabi),Kolasib,Mizoram',
    'Bairapur,Bairapur,Madhya Pradesh',
    'Bairagnia,Bairagnia,Bihar',
    'Baitalpur,Deoria,Uttar Pradesh',
    'Bajva,Vadodara,Gujarat',
    'Bakhtiyarpur Junction,Danapur,Bihar',
    'Bakra Road,Bakra Road,Rajasthan',
    'Balaghat,Balaghat,Madhya Pradesh',
    'Balamau Junction,Kachhauna Patseni,Uttar Pradesh',
    'Balangir,Balangir,Odisha',
    'Balasore,Balasore,Odisha',
    'Balauda Takun,Indore,Madhya Pradesh',
    'Balawala,Balawala,Uttarakhand',
    'Balawali,Bijnor,Uttar Pradesh',
    'Balharshah,Chandrapur,Maharashtra',
    'Baliakheri,Baliakheri,Uttar Pradesh',
    'Balikotia,Garia Kawai Mari,Assam',
    'Balipara,Patgaon T.E,Assam',
    'Ballabhgarh,Faridabad,Haryana',
    'Balli,Balli,Goa',
    'Ballia,Ballia,Uttar Pradesh',
    'Ballupur,Balloopur,Uttar Pradesh',
    'Bally,Bally,West Bengal',
    'Ballygunge Junction,Gariahat,West Bengal',
    'Balrampur,Balrampur,Madhya Pradesh',
    'Balsamand,Balsamand,Rajasthan',
    'Balugan,Balugaon,Odisha',
    'Balwa,Balva,Gujarat',
    'Balwara,Balwara,Rajasthan',
    'Bamangachhi,Parganas,West Bengal',
    'Bamanheri,Bamanheri,Uttar Pradesh',
    'Bamhani,Mandla,Madhya Pradesh',
    'Bamla,Bamla,Haryana',
    'Bamnia,Jhabua,Madhya Pradesh',
    'Bamsin,Bamsin,Rajasthan',
    'Bamra,Govindpur,Odisha',
    'Bamsin,Bamsin,Rajasthan',
    'Bamuni Gaon,Kamrup,Assam',
    'Banahi,Bagahi,Bihar',
    'Banapura,Seoni Malwa,Madhya Pradesh',
    'Banar,Jodhpur,Rajasthan',
    'Banarhat,Jalpaiguri,West Bengal',
    'Banas,Banas,Rajasthan',
    'Banaswadi,Bangalore,Karnataka',
    'Banasandra,Hulisandra,Karnataka',
    'Banbasa,Champawat,Uttarakhand',
    'Banda Junction,Banda,Uttar Pradesh',
    'Bandakpur,Bandakpur,Madhya Pradesh',
    'Bandanwara,Ajmer,Rajasthan',
    'Bandarkhal,Cachar,Assam',
    'Bandel Junction,Bandel,West Bengal',
    'Bandh Bareta,Mahmadpura,Rajasthan',
    'Bandikui Junction,Dausa,Rajasthan',
    'Bandra,Mumbai,Maharashtra',
    'Bandra Terminus,Mumbai,Maharashtra',
    'Bangalore Cantonment,Bangalore,Karnataka',
    'Bangalore City Junction,Bangalore,Karnataka',
    'Bangalore East,Bangalore,Karnataka',
    'Bangarapet,Kolar,Karnataka',
    'Bangarapet,Kolar,Karnataka',
    'Bangrod,Ratlam,Madhya Pradesh',
    'Bani,Guwawan,Uttar Pradesh',
    'Baniya Sanda DH,Baniya Sanda DH,Rajasthan',
    'Bankata,Gaura,Uttar Pradesh',
    'Bankura,Bankura,West Bengal',
    'Banmankhi Junction,Banmankhi,Bihar',
    'Banmor,Bamor,Madhya Pradesh',
    'Bansdih Road,Ghutia,Uttar Pradesh',
    'Banshlai Bridge,Ratanpur,West Bengal',
    'Bansi Paharpur,Mahalpur Choora,Rajasthan',
    'Bansipur,Rai Kundi,Bihar',
    'Banasthali Niwai,Tonk,Rajasthan',
    'Banta Raghunathgarh,Banta Raghunathgarh,Rajasthan',
    'Bantawala,Mangalore,Karnataka',
    'Banthra,Dalelpur,Uttar Pradesh',
    'Banwali,Banwala,Rajasthan',
    'Baori Thikria,Raisinghpura,Rajasthan',
    'Bapatla,Bapatla,Andhra Pradesh',
    'Bar,Kaya Bheela,Rajasthan',
    'Bara Jamda,Barajamda,Jharkhand',
    'Barabanki Junction,Barabanki,Uttar Pradesh',
    'Barabhum,Balarampur,West Bengal',
    'Barbil,Kendujhar ,Odisha',
    'Baradwar,Naya Baradwar,Chhattisgarh',
    'Baragaon,Missa,Uttar Pradesh',
    'Barahu,Guripathar,Assam',
    'Baraigram Junction,Baraigram,Assam',
    'Barakar,Paschim Bardhaman,West Bengal',
    'Baral,Baral,Uttar Pradesh',
    'Baramati,Pune,Maharashtra',
    'Baran,Baran,Rajasthan',
    'Baranagar,Baranagar,West Bengal',
    'Barara,Sharaqpur,Haryana',
    'Barasat Junction,Barasat,West Bengal',
    'Barauni Junction,Barauni,Bihar',
    'Barbatpur,Shahpur,Madhya Pradesh',
    'Barchi Road,Pastlai Mal,Madhya Pradesh',
    'Barddhaman Junction,Barddhaman,West Bengal',
    'Bardoli,Surat,Gujarat',
    'Bareilly,Bareilly,Uttar Pradesh',
    'Bareilly Cantt,Kandharpur,Uttar Pradesh',
    'Barejadi,Barejadi,Gujarat',
    'Bareta,Bareta,Punjab',
    'Bareth,Jhansi,Madhya Pradesh',
    'Bargarh Road,Bargarh,Odisha',
    'Bargawan,Bargawan,Madhya Pradesh',
    'Barh,Ibrahimpur,Bihar',
    'Barhan Junction,Barhan,Uttar Pradesh',
    'Barharwa Junction,Barharwa,Jharkhand',
    'Barhiya,Lakhisarai,Bihar',
    'Barhni,Siddharthnagar,Uttar Pradesh',
    'Bari Brahman,Samba,Jammu & Kashmir',
    'Bariarpur,Bariarpur,Bihar',
    'Barkakana,Ramgarh,Jharkhand',
    'Barkur,Moodahadu,Karnataka',
    'Barlai,Barlai Jagir,Madhya Pradesh',
    'Barmer,Barmer,Rajasthan',
    'Barnagar,Ujjain,West Bengal',
    'Barnala,Barnala,Punjab',
    'Barog,Solan,Himachal Pradesh',
    'Barpali,Barpali,Odisha',
    'Barpeta Road,Barpeta,Assam',
    'Barrackpore,Parganas,West Bengal',
    'Barsathi,Sarsara Khas,Uttar Pradesh',
    'Barsi Takli,Barsi Takli,Maharashtra',
    'Barsi Town,Barshi,Maharashtra',
    'Barsoi Junction,Raghunathpur,Bihar',
    'Barsola,Jind,Haryana',
    'Barsuan,Barsuan,Odisha',
    'Bartara,Bartara,Uttar Pradesh',
    'Baruva,Korlam,Andhra Pradesh',
    'Baruipur Junction,Baruipur,West Bengal',
    'Barwa Sagar,Dani Pura,Madhya Pradesh',
    'Barwadih Junction,Barwadih,Jharkhand',
    'Barwaha,Khargone,Madhya Pradesh',
    'Barya Ram,Soraon,Uttar Pradesh',
    'Basai,Manikpur,Haryana',
    'Basar,Basar,Telangana',
    'Basbari,Kokrajhar,Assam',
    'Basharatganj,Visharatganj,Uttar Pradesh',
    'Basi Kiratpur,Kiratpur,Uttar Pradesh',
    'Basin Bridge,Pulianthope,Tamil Nadu',
    'Basmat,Khajipura,Maharashtra',
    'Basni,Jodhpur,Rajasthan',
    'Bassi Pathana,Fatehgarh Sahib,Punjab',
    'Basta,Basta,Odisha',
    'Basti,Basti,Uttar Pradesh',
    'Basugaon,Basugaon,Assam',
    'Baswa,Dausa,Rajasthan',
    'Batadrowa Road,Aphala Pathar,Assam',
    'Batala Junction,Batala,Punjab',
    'Bauria Junction,Bauria,West Bengal',
    'Bavla,Bavla,Gujarat',
    'Bawal,Bawal,Haryana',
    'Bawani Khera,Bawani Khera,Haryana',
    'Bayana Junction,Bayana,Rajasthan',
    'Baytu,Barmer,Rajasthan',
    'Bazida Jatan,Kharkwali,Haryana',
    'Bazpur,Udham Singh Nagar,Uttarakhand',
    'Bazurghat,Nagendra Nagar,Assam',
    'Beas,Beas,Punjab',
    'Beawar,Ajmer,Rajasthan',
    'Begunkodor,Purulia,West Bengal',
    'Bedetti,Behali,Assam',
    'Begampet,Secunderabad,Telangana',
    'Begu Sarai,Begusarai,Bihar',
    'Behtagokul,Sikandarpur Bazar,Uttar Pradesh',
    'Behula,Behula,West Bengal',
    'Bejnal,Sanga Ka Khera,Rajasthan',
    'Bela Tal,Jaitpur,Uttar Pradesh',
    'Belampalli,Belampalli,Telangana',
    'Belapur,Navi Mumbai,Maharashtra',
    'Belgahna,Bilaspur,Chhattisgarh',
    'Belgharia,Kolkata,WEST BENGAL',
    'Belgaum,Belgaum,Karnataka',
    'Belha,Belha,Chhattisgarh',
    'Bellary Junction,Bellary,Karnataka',
    'Bellary Cantonment railway station,Bellary,Karnataka',
    'Belpahar,Belpahar,Odisha',
    'Belrayan,Bhedauri,Uttar Pradesh',
    'Belsiri,Sonitpur,Assam',
    'Belthara Road,Ballia,Uttar Pradesh',
    'Belur,Howrah,West Bengal',
    'Belvandi,Ahmadnagar,Maharashtra',
    'Beohari,Beohari,Madhya Pradesh',
    'Berchha,Berchha,Madhya Pradesh',
    'Berhampore Court,Berhampore,West Bengal',
    'Brahmapur,Brahmapur,Odisha',
    'Besroli,Besroli,Rajasthan',
    'Betavad,Betavad,Maharashtra',
    'Bettiah,Bettiah,Bihar',
    'Bethamcherla,Kurnool,Andhra Pradesh',
    'Betul,Badora,Madhya Pradesh',
    'Bhabhar,Banaskantha,Gujarat',
    'Bhabua Road,Mohania,Bihar',
    'Bhachau,Kutch,Gujarat',
    'Bhachau BG,Bhachau,Gujarat',
    'Bhadan,Alampur Jhapta,Uttar Pradesh',
    'Bhadaura,Gorasara,Uttar Pradesh',
    'Bhadbhadaghat,Balampur,Madhya Pradesh',
    'Bhadli,Bhadli,Maharashtra',
    'Bhadohi,Bhadohi,Uttar Pradesh',
    'Bhadra,Hanumangarh,Rajasthan',
    'Bhadrachalam Road,Bhadradri Kothagudem,Telangana',
    'Bhadrak,Charampa,Odisha',
    'Bhadran,Borsad,Gujarat',
    'Bhadravati,Bhadravati,Karnataka',
    'Bhadroli,Gwalior,Madhya Pradesh',
    'Bhaga Junction,Bhaga,Jharkhand',
    'Bhagalpur,Bhagalpur,Bihar',
    'Bhagat Ki Kothi,Jodhpur,Rajasthan',
    'Bhagega,Bhagega,Rajasthan',
    'Bhagtanwala,Amritsar,Punjab',
    'Bhagwanpur,Vaishali,Bihar',
    'Bhagwanpura,Bhagwanpura,Rajasthan',
    'Bhaini Khurd,Bhaini Khurd,Haryana',
    'Bhairongarh,Naharpura Khawasa,Madhya Pradesh',
    'Bhakti Nagar,Rajkot,Gujarat',
    'Bhalki,Bhalki,Karnataka',
    'Bhalumaska,Bhalumaska,Odisha',
    'Bhanapur,Koppal,Karnataka',
    'Bhandak,Bhadravati,Maharashtra',
    'Bhandara Road,Warthi,Maharashtra',
    'Bhandup,Mumbai,Maharashtra',
    'Bhanga,Mirjapur,Assam',
    'Bhankoda,Rampura,Gujarat',
    'Bharat Kup,Chitrakot,Uttar Pradesh',
    'Bharatkund,Bhadarsa,Uttar Pradesh',
    'Bharatpur Junction,Bharatpur,Rajasthan',
    'Bharatwada,Mahurzari,Maharashtra',
    'Bharthana,Gandhi Nagar,Uttar Pradesh',
    'Bharuch Junction,Bharuch,Gujarat',
    'Bharwa Sumerpur,Bharwa Sumerpur,Uttar Pradesh',
    'Bharwari,Berua Chauraha-Bharwari,Uttar Pradesh',
    'Bhatel,Bhatel,Gujarat',
    'Bhatgaon,Dhaneli,Chhattisgarh',
    'Bhatinda Junction,Bhatinda,Punjab',
    'Bhatiya,Ahmedabad,Gujarat',
    'Bhatkal,Belalkanda,Karnataka',
    'Bhatni Junction,Bhatni Bazar,Uttar Pradesh',
    'Bhaton Ki Gali,Bhaton Ki Gali,Rajasthan',
    'Bhatpar Rani,Bhatpar Rani,Uttar Pradesh',
    'Bhatpur,Bhatpur,Rajasthan',
    'Bhattu,Bhattu Mandi,Haryana',
    'Bhaunra,Kareerka Khe,Rajasthan',
    'Bhavnagar Para,Bhavnagar,Gujarat',
    'Bhavani Nagar,Bhavaninagar,Maharashtra',
    'Bhavnagar Terminus,Bhavnagar,Gujarat',
    'Bhawani Mandi,Jhalawar,Rajasthan',
    'Bhawanipatna,Kalahandi,Odisha',
    'Bhawanipur Kalan,Phrenda Kanoongo,Uttar Pradesh',
    'Bhayandar,Mumbai,Maharashtra',
    'Bhayavadar,Rajkot,Gujarat',
    'Bheempura,Bheempura,Rajasthan',
    'Bheerpur,Purani,Uttar Pradesh',
    'Bhemswadi,Bhemswadi,Gujarat',
    'Bheraghat,Sihoda,Madhya Pradesh',
    'Bhesana,Pali,Rajasthan',
    'Bhigwan,Pune,Maharashtra',
    'Bhilad,Valsad,Gujarat',
    'Bhilai Power House,Bhanwarpur,Chhattisgarh',
    'Bhilainagar,Bhilai,Chhattisgarh',
    'Bhilavdi,Sangli,Maharashtra',
    'Bhildi,Banaskantha,Gujarat',
    'Bhilwara,Bhilwara,Rajasthan',
    'Bhimal,Bhimal,Rajasthan',
    'Bhimana,Sirohi,Rajasthan',
    'Bhimarlai,Bhimarlai,Rajasthan',
    'Bhimasar,Bhimasar,Gujarat',
    'Bhimavaram Junction,Bhimavaram,Andhra Pradesh',
    'Bhimavaram Town,Bhimavaram,Andhra Pradesh',
    'Bhimnath,Polarpur,Gujarat',
    'Bhimsen,Garhi Kanpur,Uttar Pradesh',
    'Bhind,Kurthara,Madhya Pradesh',
    'Bhinwaliya,Indarwara,Rajasthan',
    'Bhitaura,Fatehganj Pashchimi,Uttar Pradesh',
    'Bhivpuri Road,Diksal,Maharashtra',
    'Bhiwandi,Mumbai,Maharashtra',
    'Bhiwani,Bhiwani,Haryana',
    'Bhiwani City,Bhiwani,Haryana',
    'Bhodwal Majri,Panipat,Haryana',
    'Bhogpur Sirwal,Jalandhar,Punjab',
    'Bhojipura Junction,Bareilly,Uttar Pradesh',
    'Bhojo,Bhojo,Assam',
    'Bhojras,Roopaheli,Rajasthan',
    'Bhojudih Junction,Bokaro,Jharkhand',
    'Bhoke,Phanasavale,Maharashtra',
    'Bhone,Bhone,Maharashtra',
    'Bhongaon,Mainpuri,Uttar Pradesh',
    'Bhongir,Bhuvanagiri,Telangana',
    'Bairagarh,Bhopal,Madhya Pradesh',
    'Dewanganj,Bhopal,Madhya Pradesh',
    'Habibganj,Bhopal,Madhya Pradesh',
    'Bhopal Junction,Bhopal,Madhya Pradesh',
    'Mandideep,Bhopal,Madhya Pradesh',
    'Misrod,Bhopal,Madhya Pradesh',
    'Nishatpura,Bhopal,Madhya Pradesh',
    'Bhubaneswar,Bhubaneswar,Odisha',
    'Bhuj,Bhuj,Gujarat',
    'Bhupalsagar,Bhupalsagar,Rajasthan',
    'Bhupia Mau,Bhurkunda,Uttar Pradesh',
    'Bhusaval Junction,Jalgaon,Maharashtra',
    'Bhutakia Bhimsa,Bhutakia Bhimsa,Gujarat',
    'Bhusaval,Jalgaon,Maharashtra',
    'Bibinagar Junction,Bhuvanagiri,Telangana',
    'Bichia,Bichia,Uttar Pradesh',
    'Bichpuri,Agra,Uttar Pradesh',
    'Bidadi,Gollara Palya,Karnataka',
    'Bidanpur,Amad Karari,Uttar Pradesh',
    'Bidar,Bidar,Karnataka',
    'Bidhan Nagar Road,Kolkata,West Bengal',
    'Bidupur,Bidupur,Bihar',
    'Bidyadabri,Dhubri,Assam',
    'Bighapur,Unnao,Uttar Pradesh',
    'Bihara,Chandranathpur,Assam',
    'Bihar Sharif,Bihar Sharif,Bihar',
    'Bihiya,Behea,Bihar',
    'Bihta,Patna,Bihar',
    'Bijainagar,Ajmer,Rajasthan',
    'Bijapur,Vijayapura,Karnataka',
    'Bijauli,Rund Balaura,Uttar Pradesh',
    'Bijaysota,Padri,Madhya Pradesh',
    'Bijni,Chirang,Assam',
    'Bijnor,Bijnor,Uttar Pradesh',
    'Bijoor,Udupi,Karnataka',
    'Bijora,Udupi,Karnataka',
    'Bijrotha,Daulta,Uttar Pradesh',
    'Bijuri,Kotma,Madhya Pradesh',
    'Bikaner Junction,Bikaner,Rajasthan',
    'Bikrampur,Narsingpur,Madhya Pradesh',
    'Bilaspur,Bilaspur,Chhattisgarh',
    'Bilaspur Road,Rampur,Uttar Pradesh',
    'Bildi,Biladi,Madhya Pradesh',
    'Bilhar Ghat,Kandipur,Uttar Pradesh',
    'Bilhaur,Kanpur,Uttar Pradesh',
    'Bilimora Junction,Bilimora,Gujarat',
    'Bilkha,Bilkha,Gujarat',
    'Billi,Obra,Uttar Pradesh',
    'Bilpur,Fatehganj Purbi,Uttar Pradesh',
    'Bilwai,Belwai,Uttar Pradesh',
    'Bina Junction,Bina,Madhya Pradesh',
    'Binaur,Kanpur,Uttar Pradesh',
    'Bindki Road,Pahur,Uttar Pradesh',
    'Binnaguri,Binnaguri,West Bengal',
    'Bir,Khandwa,Madhya Pradesh',
    'Biradhwal,Biradhwal,Rajasthan',
    'Birambad,Seedpur,Rajasthan',
    'Birang Khera,Birang Khera,Punjab',
    'Birapatti,Amawar,Uttar Pradesh',
    'Birlanagar,Gwalior,Madhya Pradesh',
    'Birmitrapur,Birmitrapur,Odisha',
    'Birohe,Akorhi,Uttar Pradesh',
    'Biroliya,Perwa,Rajasthan',
    'Birsinghpur,Pali,Madhya Pradesh',
    'Birur,Birur,Karnataka',
    'Bisalwas Kalan,Bisalwas Kalan,Madhya Pradesh',
    'Bishengarh,Bishengarh,Rajasthan',
    'Bishnathganj,Bhawanipur,Uttar Pradesh',
    'Bishnupur,Bankura,West Bengal',
    'Bishrampur,Sarguja,Chhattisgarh',
    'Bissam Cuttack,Chati Kona,Odisha',
    'Bissau,Bissau,Rajasthan',
    'Biswa Bridge,Buldhana,Maharashtra',
    'Biswan,Biswan,Uttar Pradesh',
    'Biyavra,Rajgarh,Madhya Pradesh',
    'Biyavra Rajgarh,Rajgarh,Madhya Pradesh',
    'Bobas,Dhakawala,Rajasthan',
    'Bobbili Junction,Bobbili,Andhra Pradesh',
    'Bodeli,Panch Mahals,Gujarat',
    'Bodhan,Nizamabad,Telangana',
    'Bodwad,Jalgaon,Maharashtra',
    'Boinda,Nunukapasi,Odisha',
    'Boisar,Mumbai,Maharashtra',
    'Bokajan,Bokajan,Assam',
    'Bokaro Steel City,Bokaro,Jharkhand',
    'Bokaro Thermal,Bokaro,Jharkhand',
    'Boko,Kamrup,Assam',
    'Bolai,Makhawad,Madhya Pradesh',
    'Bolarum,Secunderabad,Telangana',
    'Bolda,Yelegaon G,Maharashtra',
    'Bolpur — Santiniketan,Birbhum,West Bengal',
    'Bommidi,Bommidi,Andhra Pradesh',
    'Bongaigaon,Bongaigaon,Assam',
    'Borawar,Makrana,Rajasthan',
    'Bordhal,Harnya,Madhya Pradesh',
    'Bordi,Borigaon,Maharashtra',
    'Bordi Road,Borigaon,Maharashtra',
    'Borgaon,Anvi,Maharashtra',
    'Borivali,Mumbai,Maharashtra',
    'Borra Guhalu,Borra,Andhra Pradesh',
    'Borvihir,Dhule,Maharashtra',
    'Botad Junction,Botad,Gujarat',
    'Boxirhat,Cooch Behar,Assam',
    'Brahmavart,Kanpur,Uttar Pradesh',
    'Brajarajnagar,Brajrajnagar,Odisha',
    'Brayla Chaurasi,Badayla Chorasi,Madhya Pradesh',
    'Budalur,Putalur,Tamil Nadu',
    'Budaun,Budaun,Uttar Pradesh',
    'Budge Budge,Kolkata,West Bengal',
    'Budhlada,Budhlada,Punjab',
    'Budni,Budni,Madhya Pradesh',
    'Bulandshahr,Bulandshahr,Uttar Pradesh',
    'Bundi,Bundi,Rajasthan',
    'Bundki,Bundki,Uttar Pradesh',
    'Barddhaman,Bardhaman,West Bengal',
    'Burhanpur,Burhanpur,Madhya Pradesh',
    'Burhar,Burhar,Madhya Pradesh',
    'Burhwal,Barabanki,Uttar Pradesh',
    'Burnpur,Asansol,West Bengal',
    'Butari,Amritsar,Punjab',
    'Butewala,Butewala,Punjab',
    'Buxar,Buxar,Bihar',
    'Byadarahalli,Mandya,Karnataka',
    'Byculla,Mumbai,Maharashtra',
    'Boridand,Boridand,Chhattisgarh',
    'Barai Jalalpur,Krishnapur,Uttar Pradesh',
    'Bangaon,Bangaon,West Bengal',
    'B.B.D Bag,Kolkata,West Bengal',
    'Bamangachi,North 24 Parganas,West Bengal',
    'Bira,North 24 Parganas,West Bengal',
    'Birati,Kolkata,West Bengal',
    'Bibhuti Bhushan Halt,Barasehana,West Bengal',
    'Belur,Howrah,West Bengal',
    'Belur Math,Howrah,West Bengal',
    'Bisharpara Kodaliya,Kolkata,West Bengal',
    'Baghbazar,Kolkata,West Bengal',
    'Burra Bazar,Kolkata,West Bengal',
    'Birnagar,Nadia,West Bengal',
    'C Shahumaharaj T,Mumbai,Maharashtra',
    'Kozhikode,Calicut,Kerala',
    'Canacona,South Goa,Goa',
    'Kannur,Kannur,Kerala',
    'Cannanore South,Kannur,Kerala',
    'Cansaulim,South Goa,Goa',
    'Karmelaram,Bengaluru,Karnataka',
    'Castle Rock,Castlerock,Karnataka',
    'CBD Belapur,Navi Mumbai,Maharashtra',
    'Chandanathope,Kottamkara,Kerala',
    'Chabua,Dibrugarh ,Assam',
    'Chachaura Bngj,Chhan,Madhya Pradesh',
    'Chadotar,Chadotar,Gujarat',
    'Chaibasa,Chaibasa,Jharkhand',
    'Chainwa,Saran,Bihar',
    'Chajawa,Barana,Rajasthan',
    'Chajli,Chajli,Punjab',
    'Chakdaha,Nadia,West Bengal',
    'Chakdayala,Chak Dayala,Jammu & Kashmir',
    'Chakehri,Kanpur,Uttar Pradesh',
    'Chakia,Motihari,Bihar',
    'Chakradharpur,West Singhbhum,Jharkhand',
    'Chakraj Mal,Chakrajmal,Uttar Pradesh',
    'Chaksu,Jaipur,Rajasthan',
    'Chakulia,East Singhbhum,Jharkhand',
    'Chalakudy,Chalakudy,Kerala',
    'Chalala,Chalala,Gujarat',
    'Chalisgaon Junction,Jalgaon,Maharashtra',
    'Challakere,Challakere,Karnataka',
    'Chalthan,Kadodara,Gujarat',
    'Chamagram,Lakshmipur,West Bengal',
    'Chamarajanagar,Chamarajanagar,Karnataka',
    'Champa,Champa,Chhattisgarh',
    'Champaner Rd Junction,Khakhariya,Gujarat',
    'Chamraura,Chamraura,Uttar Pradesh',
    'Chand Siau,Chandpur,Uttar Pradesh',
    'Chanda Fort,Chandrapur,Maharashtra',
    'Chandan Nagar,Hooghly,West Bengal',
    'Chandar,South Goa,Goa',
    'Chandari,Kanpur,Uttar Pradesh',
    'Chandauli Majhwar,Chandauli,Uttar Pradesh',
    'Chandausi Junction,Sambhal,Uttar Pradesh',
    'Chandawal,Pali,Rajasthan',
    'Chanderiya,Chittaurgarh,Rajasthan',
    'Chandi Mandir,Panchkula,Haryana',
    'Chandia Road,Chandia,Madhya Pradesh',
    'Chandigarh,Singh Nagar,Punjab',
    'Chandil Junction,Seraikela Kharsawan,Jharkhand',
    'Chandiposi,Chandiposi,Odisha',
    'Chandisar,Chandisar,Gujarat',
    'Chandkhira Bagn,Chandkhira,Assam',
    'Chandlodiya,Ahmedabad,Gujarat',
    'Chandok,Daulatpur,Uttar Pradesh',
    'Chandranathpur,Panichar Grant,Assam',
    'Chandrapur,Chandrapur,Maharashtra',
    'Chandrapura,Bokaro,Jharkhand',
    'Chandresal,Ram Kherli,Rajasthan',
    'Chandur,Chandur,Maharashtra',
    'Chaneti,Bareilly,Uttar Pradesh',
    'Changanacheri,Kottayam,Kerala',
    'Changsari,Dhobartari,Assam',
    'Channani,Khera Mukundpura,Rajasthan',
    'Channapatna,Channapatna,Karnataka',
    'Chanpatia,Chanpatia,Bihar',
    'Chaparmukh Junction,Nagaon,Assam',
    'Chaprakata,Chaprakata,Assam',
    'Charaud,Charaud,Haryana',
    'Charbagh,Lucknow,Uttar Pradesh',
    'Charbatia,Chaudwar,Odisha',
    'Charbhuja Road,Dala Ka Khera,Rajasthan',
    'Chargola,Jabainpur Part 1,Assam',
    'Charkhari Road,Charkhari Road,Uttar Pradesh',
    'Charkhi Dadri,Charkhi Dadri,Haryana',
    'Charni Road,Mumbai,Maharashtra',
    'Charvattur,Cheruvathur,Kerala',
    'Chata,Chhata,Uttar Pradesh',
    'Chau Mahla,Jhalawar,Madhya Pradesh',
    'Chaube,Khari,Jharkhand',
    'Chaukhandi,Varanasi,Uttar Pradesh',
    'Chaunrah,Chaunrah,Uttar Pradesh',
    'Chaurakheri,Gola Khedi,Madhya Pradesh',
    'Chaure Bazar,Jamoli Khurd,Uttar Pradesh',
    'Chauri Chaura,Gorakhpur,Uttar Pradesh',
    'Chausa,Sauwanbandh,Bihar',
    'Chautara,Kokrajhar,Assam',
    'Chauth Ka Brwra,Sawai Madhopur,Rajasthan',
    'Chavalkhede,Chavalkhede,Maharashtra',
    'Chawapall,Jaspalon,Punjab',
    'Chaygaon,Kamrup,Assam',
    'Chemancheri,Kozhikode,Kerala',
    'Chembur,Mumbai,Maharashtra',
    'Chengalpattu,Chengalpattu,Tamil Nadu',
    'Chengannur,Chengannur,Kerala',
    'Chennai Beach,Chennai,Tamil Nadu',
    'Chennai Central railway station,Chennai,Tamil Nadu',
    'Chennai Egmore,Chennai,Tamil Nadu',
    'Chennai Fort,Chennai,Tamil Nadu',
    'Chennai Park,Chennai,Tamil Nadu',
    'Cheriyanad,Cheriyanad,Kerala',
    'Cherthala,Cherthala,Kerala',
    'Chetar,Sasang,Jharkhand',
    'Chettinad,Kanadukathan,Tamil Nadu',
    'Chhabra Gugor,Baran,Rajasthan',
    'Chhandrauli,Chhandrauli,Uttar Pradesh',
    'Chhansara,Chhansara,Gujarat',
    'Chhapi,Banaskantha,Gujarat',
    'Chhapra,Chhapra,Bihar',
    'Chhapra Kacheri,Chhapra,Bihar',
    'Chharodi,Iyava,Gujarat',
    'Chhatrapati Shivaji Terminus,Mumbai,Maharashtra',
    'Chhatarpur,Chhatarpur,Madhya Pradesh',
    'Chatrapur,Ganjam,Odisha',
    'Chhidgaon,Dethi,Madhya Pradesh',
    'Chhina,Chhina,Punjab',
    'Chhindwara Junction,Chhindwara,Madhya Pradesh',
    'Chhipadohar,Latehar,Jharkhand',
    'Chhitauni,Chhitauni,Uttar Pradesh',
    'Chhota Gudha,Chhota Gudha,Rajasthan',
    'Chhoti Odai,Udai Khurd,Rajasthan',
    'Chianki,Kauria,Jharkhand',
    'Chidambaram,Chidambaram,Tamil Nadu',
    'Chiheru,Kapurthala,Punjab',
    'Chikballapur,Chikballapur,Karnataka',
    'Chikkamagaluru,Chikkamagaluru,Karnataka',
    'Chikalthan,Aurangabad,Maharashtra',
    'Chikjajur Junction,Chikjajur,Karnataka',
    'Chikni Road,Chandrapur,Maharashtra',
    'Chikodi Road,Meerapurhatti,Karnataka',
    'Chilbila Junction,Pratapgarh,Uttar Pradesh',
    'Chilka,Barkul,Odisha',
    'Chilo,Bukaram Sotan,Rajasthan',
    'Chinchli,Belgaum,Karnataka',
    'Chinchpada,Kelpada,Maharashtra',
    'Chinchpokli,Mumbai,Maharashtra',
    'Chinchwad,Pune,Maharashtra',
    'Chinna Ganjam,Chinna Ganjam,Andhra Pradesh',
    'Chinna Salem,Chinnasalem,Tamil Nadu',
    'Chintamani,Chintamani,Karnataka',
    'Chiplun,Chiplun,Maharashtra',
    'Chipurupalle,Sumitrapuram,Andhra Pradesh',
    'Chirai,Chirai Moti,Gujarat',
    'Chirala,Prakasam,Andhra Pradesh',
    'Chirawa,Jhunjhunu,Rajasthan',
    'Chirayinkil,Thiruvananthapuram,Kerala',
    'Chirgaon,Chirgaon,Uttar Pradesh',
    'Chirmiri,Chirimiri,Chhattisgarh',
    'Chit Baragaon,Chitbaragaon,Uttar Pradesh',
    'Chitahra,Chaurehi,Madhya Pradesh',
    'Chital,Chital,Gujarat',
    'Chitali,Chitali,Maharashtra',
    'Chitradurga,Chitradurga,Karnataka',
    'Chitrakuta,Chitrakoot Dham,Uttar Pradesh',
    'Chitrapur,Chitrapur,Karnataka',
    'Chitrasani,Banaskatha,Gujarat',
    'Chitrawad,Borvav,Gujarat',
    'Chitrod,Dedarva,Gujarat',
    'Chitapur,Chitapur,Karnataka',
    'Chittaranjan,Jamtara,West Bengal',
    'Chittaurgarh,Chittaurgarh,Rajasthan',
    'Chittoor,Chittoor,Andhra Pradesh',
    'Chodiala,Saharanpur,Uttarakhand',
    'Choki Sorath,Choki Sorath,Gujarat',
    'Chola,Chola,Uttar Pradesh',
    'Cholang,Jalandhar,Punjab',
    'Chomun Samod,Chomu,Rajasthan',
    'Chondi,Ambala,Maharashtra',
    'Chopan,Sonbhadra,Uttar Pradesh',
    'Choral,Indore,Madhya Pradesh',
    'Chorvad Road,Junagadh,Gujarat',
    'Chosla,Malpura,Rajasthan',
    'Choti Khatu,Nagaur,Rajasthan',
    'Chuchura,Chinsurah,West Bengal',
    'Chuda,Bhrugupur,Gujarat',
    'Chunabhatti,Mumbai,Maharashtra',
    'Chunar,Mirzapur,Uttar Pradesh',
    'Churchgate,Mumbai,Maharashtra',
    'Churk,Harhuna,Uttar Pradesh',
    'Churu,Churu,Rajasthan',
    'Clutterbuckganj,Bareilly,Uttar Pradesh',
    'Cochin Harbour Terminus,Kochi,Kerala',
    'Coimbatore Junction,Coimbatore,Tamil Nadu',
    'Coimbatore North Junction,Coimbatore,Tamil Nadu',
    'Colonelganj,sakrora,Uttar Pradesh',
    'Contai Road,Belda,West Bengal',
    'Coonoor,Contai Road,Tamil Nadu',
    'Cotton Green,Mumbai,Maharashtra',
    'Cuddalore Junction,Cuddalore Old Town,Tamil Nadu',
    'Cuddalore Port,Cuddalore Old Town,Tamil Nadu',
    'Cuddapah,Kadapa,Andhra Pradesh',
    'Cumbum,Cumbum,Tamil Nadu',
    'Cuttack Junction,Cuttack,Odisha',
    'Currey Road,Mumbai,Maharashtra',
    'Dabhaura,Dabhaura,Madhya Pradesh',
    'Dabhoi Junction,Dabhoi,Gujarat',
    'Dabilpur,Dabilpur,Telangana',
    'Dabla,Sikar,Rajasthan',
    'Dabli Rathan,Dabli Rathan,Rajasthan',
    'Dabolim,South Goa,Goa',
    'Dabra ,Gwalior,Madhya Pradesh',
    'Dabtara,Guriyari,Uttar Pradesh',
    'Dadar (Western Railway),Mumbai,Maharashtra',
    'Dadri,Gautam Buddh Nagar,Uttar Pradesh',
    'Dagaon,Dagaon,Assam',
    'Dagmagpur,Newarhia,Uttar Pradesh',
    'Dahanu Road,Palghar,Maharashtra',
    'Dahar Ka Balaji,Jaipur,Rajasthan',
    'Dahina Zainabad,Dahina,Haryana',
    'Dahisar,Mumbai,Maharashtra',
    'Dahod,Dahod,Gujarat',
    'Dailwara,Dailwara,Uttar Pradesh',
    'Dakaniya Talav,Kota,Rajasthan',
    'Dakhineswar,Kolkata,West Bengal',
    'Dakor,Rakhiyal Part,Gujarat',
    'Daladi,Daladi,Gujarat',
    'Dalauda,Banikhedi,Madhya Pradesh',
    'Dalelnagar,Samodha,Uttar Pradesh',
    'Dalgaon,Alipurduar,West Bengal',
    'Daliganj,Lucknow,Uttar Pradesh',
    'Dalhousie Road,Pathankot,Punjab',
    'Dalkhola,Uttar Dinajpur,West Bengal',
    'Dalli-Rajhara,Dalli-Rajhara,Chhattisgarh',
    'Dalmau Junction,Rae Bareli,Uttar Pradesh',
    'Dalmera,Jakhar Wala,Rajasthan',
    'Dalpatpur,Dilari,Uttar Pradesh',
    'Dalsingh Sarai,Dalsingh Sarai,Bihar',
    'Daltonganj,Palamu,Jharkhand',
    'Damanjodi,Champapadar,Odisha',
    'Damchara,Damchara,Assam',
    'Damnagar,Damnagar,Gujarat',
    'Damoh,Damoh,Madhya Pradesh',
    'Danapur,Patna,Bihar',
    'Dandeli,Dandeli,Karnataka',
    'Dandupur,Pure Goliya,Uttar Pradesh',
    'Dangoaposi,Danguwaposi,Jharkhand',
    'Dangtal,Kakragaon,Assam',
    'Daniyawan Bzr H,Daniawan,Bihar',
    'Dankaur,Jamalpur,Uttar Pradesh',
    'Dankuni,Hooghly,West Bengal',
    'Danwar,Danwar,Uttar Pradesh',
    'Dapodi,Pune,Maharashtra',
    'Dappar,Sahibzada Ajit Singh Nagar,Punjab',
    'Daotuhaja,Dima Hasao,Assam',
    'Dara,Moru Khurd,Rajasthan',
    'Daraganj,Prayagraj,Uttar Pradesh',
    'Darbhanga Junction,Darbhanga,Bihar',
    'Darjeeling,Darjeeling,West Bengal',
    'Darritola,Jagatpur,Chhattisgarh',
    'Daryabad,Baranpur,Uttar Pradesh',
    'Daryapur,Munshiganj,Uttar Pradesh',
    'Dasna,Masuri,Uttar Pradesh',
    'Dasuya,Dasuya,Punjab',
    'Datia,Datia,Madhya Pradesh',
    'Dativali,Thane,Maharashtra',
    'Daudpur,Saran,Bihar',
    'Daulatabad,Talesaman,Maharashtra',
    'Daund Junction,Pune,Maharashtra',
    'Daundaj,Daundaj,Maharashtra',
    'Daurai,Ajmer,Rajasthan',
    'Daurala,Mataur,Uttar Pradesh',
    'Dauram Madhpura,Madhepura,Bihar',
    'Dausa,Dausa,Rajasthan',
    'Dausni,Dausni,Uttarakhand',
    'Davangere,Davangere,Karnataka',
    'Dayalpur,Jalandhar,Punjab',
    'Debari,Debari,Rajasthan',
    'Debipur,Purba Bardhaman,West Bengal',
    'Degana Junction,Nagaur,Rajasthan',
    'Dehradun,Dehradun,Uttarakhand',
    'Dehri On Sone,Dehri,Bihar',
    'Dehu Road,Dehu,Maharashtra',
    'Dekapam,Dhemaji,Assam',
    'Delhi,Delhi,Delhi',
    'Delhi MG,New Delhi,Delhi',
    'Delhi Azadpur,New Delhi,Delhi',
    'Delhi Cantonment,New Delhi,Delhi',
    'Delhi Kishanganj,New Delhi,Delhi',
    'Delhi Sarai Rohilla,New Delhi,Delhi',
    'Delhi Safdarjung,New Delhi,Delhi',
    'Delhi Shahdara,New Delhi,Delhi',
    'Delvada,Delvada,Gujarat',
    'Demu,Hundru,Jharkhand',
    'Deoband,Saharanpur,Uttar Pradesh',
    'Deogan Road,Deogan,Odisha',
    'Deoghar Junction,Deoghar,Jharkhand',
    'Deorakot,Dera Musi,Uttar Pradesh',
    'Deoria Sadar,Deoria,Uttar Pradesh',
    'Depalsar,Depalsar,Rajasthan',
    'Derol,Panchmahal,Gujarat',
    'Desari,Vaishali,Bihar',
    'Deshalpar,Bhuj,Gujarat',
    'Deshnok,Bikaner,Rajasthan',
    'Deswal,Deshwal,Rajasthan',
    'Detroj,Ahmedabad,Gujarat',
    'Devakottai Road,Devakottai Rasthaa,Tamil Nadu',
    'Devbaloda Charoda,Kumhari,Chhattisgarh',
    'Devgam,Chalwada,Gujarat',
    'Devgarh Madriya,Dhawala Khurd,Rajasthan',
    'Devlali,Devlali,Maharashtra',
    'Devpura,Bilopa,Rajasthan',
    'Dewalgaon,Nawegaon Bandh,Maharashtra',
    'Dewanganj,Raisen,Madhya Pradesh',
    'Dewas Junction,Dewas,Madhya Pradesh',
    'Dhaban,Sangaria,Rajasthan',
    'Dhalaibil,Dhalaibil,Assam',
    'Dhalgaon,Dhalgaon,Maharashtra',
    'Dhalpukhuri,Jamuhandal,Assam',
    'Dhamangaon,Amravati,Maharashtra',
    'Dhamni,Wasai,Maharashtra',
    'Dhamora,Nankar,Uttar Pradesh',
    'Dhampur,Kanpur,Uttar Pradesh',
    'Dhamtari,Dhamtari,Chhattisgarh',
    'Dhamua,Dhamua,West Bengal',
    'Dhana Kherli,Dhana,Rajasthan',
    'Dhanakwada,Dhanakwada,Gujarat',
    'Dhanakya,Nandgaon Barsana,Rajasthan',
    'Dhanari,Dhanari,Uttar Pradesh',
    'Dhanawala Wada,Gadhvala Vada,Gujarat',
    'Dhanbad Junction,Dhanbad,Jharkhand',
    'Dhandari Kalan,Ludhiana,Punjab',
    'Dhandhera,Roorkee,Uttarakhand',
    'Dhandhuka,Ahmedabad,Gujarat',
    'Dhanera,Banaskantha,Gujarat',
    'Dhaneta,Bareilly,Uttar Pradesh',
    'Dhangadra,Surendranagar,Gujarat',
    'Dhanmandal,Jajpur,Odisha',
    'Dharamtul,Morigaon,Assam',
    'Dharangaon,Jalgaon,Maharashtra',
    'Dhareshwar,Dhareshwar,Rajasthan',
    'Dhari Junction,Amreli,Gujarat',
    'Dhariwal,Dhariwal,Punjab',
    'Dharmabad,Nanded,Maharashtra',
    'Dharmanagar,North Tripura,Tripura',
    'Dharmapuri,Dharmapuri,Tamil Nadu',
    'Dharmavaram Junction,Anantapur,Andhra Pradesh',
    'Dharmpur Himachal,Solan,Himachal Pradesh',
    'Dharnaoda,Godalpur,Madhya Pradesh',
    'Dharwad,Dharwad,Karnataka',
    'Dhasa Junction,Dhasa,Gujarat',
    'Dhaulpur,Dholpur,Rajasthan',
    'Dhaura,Dhaura,Madhya Pradesh',
    'Dheena,Daina,Uttar Pradesh',
    'Dhekiajili Road,Sonitpur,Assam',
    'Dhemaji,Dhemaji,Assam',
    'Dhenkanal,Dhenkanal,Odisha',
    'Dhilwan,Kapurthala,Punjab',
    'Dhinda,Dhinda,Rajasthan',
    'Dhindhora HKMKD,Dhindora,Rajasthan',
    'Dhindsa,Machhiwara Alias Kamagar,Punjab',
    'Dhing,Nagaon,Assam',
    'Dhing Bazar,Nagaon,Assam',
    'Dhinoj,Dhinoj,Gujarat',
    'Dhirera,Khari,Rajasthan',
    'Dhirganj,Malkhanpur,Uttar Pradesh',
    'Dhirpur,Chanarthal,Haryana',
    'Dhoda Khedi,Adhaun,Haryana',
    'Dhodhar,Dhodhar,Madhya Pradesh',
    'Dhodra Mohar,Bhoura,Madhya Pradesh',
    'Dhola Junction,Bhavnagar,Gujarat',
    'Dhola Mazra,Ahmadpur,Haryana',
    'Dholi,Muzzafarpur,Bihar',
    'Dholka,Ahmedabad,Gujarat',
    'Dhondi,Dhondi,Maharashtra',
    'Dhoraji,Rajkot,Gujarat',
    'Dhrangadhra Junction,Surendranagar,Gujarat',
    'Dhubri ,Dhubri ,Assam',
    'Dhule,Dhule,Maharashtra',
    'Dhulghat ,Amravati,Maharashtra',
    'Dhulkot,Sadopur,Haryana',
    'Dhup Dhara,Jogipara Part - 3,Assam',
    'Dhupguri,Jalpaiguri,West Bengal',
    'Dhuri Junction,Sangrur,Punjab',
    'Diamond Harbour,Kolkata,West Bengal',
    'Dibai,Kaser Kalan,Uttar Pradesh',
    'Dibrugarh,Dibrugarh,Assam',
    'Dibrugarh Town,Dibrugarh,Assam',
    'Dichpalli,Nizamabad,Telangana',
    'Didwana,Nagaur,Rajasthan',
    'Digaru,Bijni Grant,Assam',
    'Digboi,Tinsukia,Assam',
    'Dighwara,Saran,Bihar',
    'Digod,Padliya,Rajasthan',
    'Dihakho,Dihakho,Assam',
    'Dilawarnagar,Dilawarnagar,Uttar Pradesh',
    'Dildarnagar Junction,Dildar Nagar,Uttar Pradesh',
    'Dimapur,Dimapur,Nagaland',
    'Dimow,Dhemaji,Assam',
    'Dina Nagar,Gurdaspur,Punjab',
    'Dinagaon,Dinagaon,Maharashtra',
    'Dindigul Junction,Dindigul,Tamil Nadu',
    'Dingwahi,Dingwahi,Uttar Pradesh',
    'Dipa,Dhemaji,Assam',
    'Diphu,Karbi Anglong,Assam',
    'Diplana,14 Barani,Rajasthan',
    'Dipore,Dipore,Maharashtra',
    'Disa,Banaskantha,Gujarat',
    'Ditokcherra,Dima Hasao,Assam',
    'Diva Junction,Thane,Maharashtra',
    'Divine Nagar,Thrissur,Kerala',
    'Diwana,Panipat,Haryana',
    'Diwankhavati,Khavati,Maharashtra',
    'Diyodar,Banaskantha,Gujarat',
    'Dobh Bahali,Dobh Bahali,Haryana',
    'Dockyard Road,Mumbai,Maharashtra',
    'Dodballapur,Bengaluru,Karnataka',
    'Dodbele,Tadasigatta,Karnataka',
    'Dohrighat,Dohrighat,Uttar Pradesh',
    'Doiwala,Missar Wala Khurd,Uttarakhand',
    'Dolavli,Khopoli,Maharashtra',
    'Dombivli,Mumbai,Maharashtra',
    'Domingarh,Gorakhpur,Uttar Pradesh',
    'Donakonda,Prakasam,Andhra Pradesh',
    'Dondaicha,Dhule,Maharashtra',
    'Dongargaon,East Nimar,Madhya Pradesh',
    'Dongargarh,Rajnandgaon,Chhattisgarh',
    'Donigal,Kumbardi Estate,Karnataka',
    'Doraha,Doraha,Punjab',
    'Doravart Chtram,Doravarisathram,Andhra Pradesh',
    'Dornakal Junction,Mahbubabad,Telangana',
    'Dhone Junction,Kurnool,Andhra Pradesh',
    'Dubaha,Dubahan Bujurg,Bihar',
    'Dubia,Dubia Bori,Assam',
    'Duddhinagar,Dumar Diha,Uttar Pradesh',
    'Dudh Sagar,South Goa,Goa',
    'Dudhsagar Waterfalls,South Goa,Goa',
    'Dudhani,Dudhani,Maharashtra',
    'Dudhia Khurd,Dharampur Kalan,Uttar Pradesh',
    'Dudhnoi,Goalpara,Assam',
    'Dudhwakhara,Dudhwakhara,Rajasthan',
    'Dudia,Doodiya,Rajasthan',
    'Dudwindi,Chakkotla,Punjab',
    'Duganpur,Menhdipur,Uttar Pradesh',
    'Dugdol,Banaskantha,Gujarat',
    'Duggirala,Guntur,Andhra Pradesh',
    'Duhai,Ghaziabad,Uttar Pradesh',
    'Duliajan,Bordubi No.1,Assam',
    'Dullabcherra,Karimganj,Assam',
    'Dullahapur,Dullahapur,Uttar Pradesh',
    'Dulrasar,Udashar Charanan,Rajasthan',
    'Dum Dum,Kolkata,West Bengal',
    'Dum Dum Cantonment,Kolkata,West Bengal',
    'Dumariya,Sarai Bhamboo,Rajasthan',
    'Dumraon,Dumraon,Bihar',
    'Dumka,Dumka,Jharkhand',
    'Dumuriput,Dumuriput,Odisha',
    'Dundara,Dhundhara,Rajasthan',
    'Dundlod MKDGRH,Jhunjhunu,Rajasthan',
    'Dungar Junction,Ringaniyala Mota,Gujarat',
    'Dungarpur,Dadoriya,Rajasthan',
    'Duraundha Junction,Duraundha,Bihar',
    'Durgauti,Raj Nagar,Delhi',
    'Durg,Durg,Chhattisgarh',
    'Durgapur,Paschim Bardhaman,West Bengal',
    'Duttapukur,North 24 Parganas,West Bengal',
    'Durgapura,Jaipur,Rajasthan',
    'Duskheda,Sudgaon,Maharashtra',
    'Duvvada,Visakhapatnam,Andhra Pradesh',
    'Dwarka,Dwarka,Gujarat',
    'Dwarkaganj,Balramau,Uttar Pradesh',
    'Errupalem,Khammam,Telangana',
    'Ekambara kuppam,Nagari,Andhra Pradesh',
    'Ekangarsarai,Ekangar Sarai,Bihar',
    'Ekchari,Ekchari,Bihar',
    'Ekma,Saran,Bihar',
    'Elamanur,Elamanur,Tamil Nadu',
    'Yelamanchili,Visakhapatnam,Andhra Pradesh',
    'Ellenabad,Sirsa,Haryana',
    'Eluru,West Godavari,Andhra Pradesh',
    'Ennore,Ennore,Tamil Nadu',
    'Eraligu,Purbo Tatirbond,Assam',
    'Eraniel,Kanyakumari,Tamil nadu',
    'Eravipuram,Kollam,Kerala',
    'Ernakulam Junction,Kochi,Kerala',
    'Ernakulam Town,Kochi,Kerala',
    'Ernakulam Terminus,Kochi,Kerala',
    'Erode Junction,Erode,Tamil Nadu',
    'Etah,Etah,Uttar Pradesh',
    'Etawah Junction,Etawah,Uttar Pradesh',
    'Ettimadai,Ettimadai,Tamil Nadu',
    'Etmadpur,Bhikanpur,Uttar Pradesh',
    'Etakkot,Edakkad,Kerala',
    'Faizabad Junction,Faizabad,Uttar Pradesh',
    'Faizullapur,Hajipur Chakmay,Uttar Pradesh',
    'Fakhrabad,Kosli,Telangana',
    'Fakiragram Junction,Kokrajhar,Assam',
    'Falakata,Parangarpar,West Bengal',
    'Falna,Pali,Rajasthan',
    'Farah Town,Farah,Uttar Pradesh',
    'Farhedi,Kulwara,Uttar Pradesh',
    'Faridabad,Faridabad,Haryana',
    'Faridabad New Town,Faridabad,Haryana',
    'Faridkot,Faridkot,Punjab',
    'Farrukhabad,Farrukhabad,Uttar Pradesh',
    'Fateh Singhpura,Suroth,Rajasthan',
    'Fatehabad Chandrawati Ganj Junction,Ujjain,Madhya Pradesh',
    'Fatehgarh,Farrukhabad,Uttar Pradesh',
    'Fatehgarh Sahib,Fatehgarh Sahib,Punjab',
    'Fatehnagar,Udaipur,Rajasthan',
    'Fatehpur,Fatehpur,Uttar Pradesh',
    'Fatehpur Sikri,Fatehpur,Uttar Pradesh',
    'Fatehpur Shekhawati,Sikar,Rajasthan',
    'Fatuha,Patna,Bihar',
    'Fazalpur,Humayun Puriddu,Uttar Pradesh',
    'Fazilka,Fazilka,Punjab',
    'Ferok,Kozhikode,Kerala',
    'Firozabad,Firozabad,Uttar Pradesh',
    'Firozpur Cant.,Firozpur,Punjab',
    'Firozpur City,Firozpur,Punjab',
    'Forbesganj,Araria,Bihar',
    'Furkating Junction,Golaghat,Assam',
    'Fursatganj,Brahmani,Uttar Pradesh',
    'Gachhipura,Gachhipura,Rajasthan',
    'Gardhrubeswar,Kashipur Purulia,West Bengal',
    'Gadag Junction,Gadag,Karnataka',
    'Gadarwara,Narsinghpur,Madhya Pradesh',
    'Gadhakda,Gadhakda,Gujarat',
    'Gadra Road,Barmer,Rajasthan',
    'Gadwal,Gadwal,Telangana',
    'Gahmar,Ghazipur,Uttar Pradesh',
    'Gainjahwa,Gainjahwa,Uttar Pradesh',
    'Gainsari Junction,Balrampur,Uttar Pradesh',
    'Gaipura,Lucknow,Uttar Pradesh',
    'Gajraula Junction,Gajraula,Uttar Pradesh',
    'Galan,Jalgaon,Maharashtra',
    'Gambhiri Road,Mangrol,Rajasthan',
    'Ganagapur Road,Ganagapur Road,Karnataka',
    'Ganj Dundwara,Ganj Dundwara,Uttar Pradesh',
    'Ganaur,Ganaur,Haryana',
    'Gandhi Smarak Road,Akola,Maharashtra',
    'Gandhidham Junction,Gandhidham,Gujarat',
    'Gandhigram,Gandhidham,Gujarat',
    'Gandhinagar, Jaipur,Rajasthan',
    'Gandhinagar Capital, Jaipur,Gujarat',
    'Ganeshganj,Ganeshganj,Madhya Pradesh',
    'Gangaganj,Shora,Madhya Pradesh',
    'Gangakher,Gangakhed,Maharashtra',
    'Gangapur City,Gangapur,Rajasthan',
    'Gangarampur,Dakshin Dinajpur,West Bengal',
    'Gangrar,Chittorgarh,Rajasthan',
    'Gangsar Jaitu,Jaito,Haryana',
    'Ganj Basoda,Vidisha,Madhya Pradesh',
    'Ganjmuradabad,Ganjmuradabad,Uttar Pradesh',
    'Gannavaram,Krishna,Andhra Pradesh',
    'Garhi Harsaru Junction,Gurgaon,Haryana',
    'Garhi Manikpur,Manikpur,Uttar Pradesh',
    'Garhmuktesar,Garhmuktesar,Uttar Pradesh',
    'Garhmuktesar BR,Garhmuktesar,Uttar Pradesh',
    'Garhwa,Garhwa,Jharkhand',
    'Garia,Kolkata,West Bengal',
    'Garwa Road Junction,Palamu,Jharkhand',
    'Garot,Phoolkheda,Madhya Pradesh',
    'Gaura,Kaulapur,Uttar Pradesh',
    'Gauri Bazar,Gauri Bazar,Uttar Pradesh',
    'Gauri Phanta,Gauri Phanta,Uttarakhand',
    'Gauribidanur,Gauribidanur,Karnataka',
    'Gauriganj,Amethi,Uttar Pradesh',
    'Gauripur,Gauripur,Assam',
    'Gauriyamau,Karimpur,Uttar Pradesh',
    'Gaushala,Gaushala,Uttarakhand',
    'Gautampura Road,Bahirampur,Madhya Pradesh',
    'Gaya Junction,Gaya,Bihar',
    'Geratpur,Ahmadabad,Gujarat',
    'Gerita Kolvada,Gerita Kolvada,Gujarat',
    'Gevra Road,Korba,Chhattisgarh',
    'Gevrai,Aurangabad,Maharashtra',
    'Ghaggar,Sahibzada Ajit Singh Nagar,Punjab',
    'Ghagwal,Samba,Jammu and Kashmir',
    'Ghanauli,Ghanauli,Punjab',
    'Ghansoli,Navi Mumbai,Maharashtra',
    'Gharaunda,Gharaunda,Haryana',
    'Ghaso,Ghaso,Haryana',
    'Ghataka Varana,Ghat Ka Barana,Rajasthan',
    'Ghatampur,Kanpur,Uttar Pradesh',
    'Ghatkopar ,Mumbai,Maharashtra',
    'Ghatsila,East Singhbhum,Jharkhand',
    'Ghaziabad Junction,Ghaziabad,Uttar Pradesh',
    'Ghazipur City,Ghazipur,Uttar Pradesh',
    'Ghograpur,Niz-Barigog,Assam',
    'Gholvad,Gholvad,Maharashtra',
    'Ghoradongri,Betul,Madhya Pradesh',
    'Ghorawadi,Talegaon Dabhade,Maharashtra',
    'Ghorpuri,Pune,Maharashtra',
    'Ghorpuri West,Pune,Maharashtra',
    'Ghosipura,Gwalior,Madhya Pradesh',
    'Ghosunda,Gadariyawas,Rajasthan',
    'Ghughuli,Bandi,Uttar Pradesh',
    'Ghugus,Chandur,Maharashtra',
    'Ghutai,Teli Pahari,Uttar Pradesh',
    'Gidarpindi,Shahkot,Punjab',
    'Giddalur,Giddalur,Andhra Pradesh',
    'Giddarbaha,Giddarbaha,Punjab',
    'Gidhaur,Gidhaur,Bihar',
    'Gir Gadhara,Gir Gadhara,Gujarat',
    'Gir Hadmatiya,Gir Hadmatiya,Gujarat',
    'Giridih,Giridih,Jharkhand',
    'Girwar,Chandwar,Madhya Pradesh',
    'Goalpara Town,Bhalukdubi,Assam',
    'Godha,Godha,Uttar Pradesh',
    'Godhra Junction,Panchmahal,Gujarat',
    'Gogameri,11 Dpn,Rajasthan',
    'Gogamukh,Gogamukh,Assam',
    'Gohad Road,Gohad Road,Madhya Pradesh',
    'Gohana,Gohana,Haryana',
    'Gohpur,Biswanath,Assam',
    'Gokak Road,Konnur,Karnataka',
    'Gokarna Road,Devigadde,Karnataka',
    'Gola Gokarannath,Lakhimpur Kheri,Uttar Pradesh',
    'Golakganj Junction,Golakganj,Assam',
    'Golanthra,Ganjam,Odisha',
    'Gole,Gole,Rajasthan',
    'Golsar,Golsar,Rajasthan',
    'Gomti Nagar,Lucknow,Uttar Pradesh',
    'Gonda Junction,Gonda,Uttar Pradesh',
    'Gonda Kachahri,Gonda,Uttar Pradesh',
    'Gonda MG,Gonda,Uttar Pradesh',
    'Gondal,Rajkot,Gujarat',
    'Gondia Junction,Gondia,Maharashtra',
    'Gondumri,Bhandara,Maharashtra',
    'Goneana,Goneana,Punjab',
    'Gooty Junction,Gooty,Andhra Pradesh',
    'Gop Jam,Jamnagar,Gujarat',
    'Gopalganj,Gopalganj,Bihar',
    'Gopalpur,Cuttack,Odisha',
    'Gora Ghuma,Ahmedabad,Gujarat',
    'Gorakhpur Cantonment,Gorakhpur,Uttar Pradesh',
    'Gorakhpur Junction,Gorakhpur,Uttar Pradesh',
    'Goram Ghat,Kachhbali,Rajasthan',
    'Ghorasahan,Purnahia,Bihar',
    'Goraul,Goraul,Bihar',
    'Goraya,Goraya,Punjab',
    'Goregaon,Mumbai,Maharashtra',
    'Goregaon Road Halt,Mumbai,Maharashtra',
    'Goresuar,Goresuar,Assam',
    'Goriyan,Todi Madhopura,Rajasthan',
    'Goshainganj,Goshainganj,Uttar Pradesh',
    'Gossaigaon Hat,Gossaigaon,Assam',
    'Gotan,Nagaur,Rajasthan',
    'Gotegaon,Jabalpur,Madhya Pradesh',
    'Gothaj,Kachhai,Gujarat',
    'Govandi,Mumbai,Maharashtra',
    'Goverdhan,Mathura,Uttar Pradesh',
    'Govindgarh,Khanna,Punjab',
    'Govindgarh Malk,Govindgarh,Rajasthan',
    'Govindi Marwar,Nagaur,Rajasthan',
    'Govindnagar,Baheria,Uttar Pradesh',
    'Govindpuri,Kanpur,Uttar Pradesh',
    'Grant Road,Mumbai,Maharashtra',
    'Gudha,Nagaur,Rajasthan',
    'Guindy,Chennai,Tamil Nadu',
    'Gubbi,Gubbi,Karnataka',
    'Gudivada Junction,Gudivada,Andhra Pradesh',
    'Gudiyattam,Veppur,Tamil Nadu',
    'Gudur Junction,Gudur,Andhra Pradesh',
    'Gujhandi,Gujhandi,Jharkhand',
    'Gulabhganj,Gulabhganj,Madhya Pradesh',
    'Gulabpura,Bhilwara,Rajasthan',
    'Gulaothi,Gulaothi,Uttar Pradesh',
    'Gularbhoj,Udham Singh Nagar,Uttarakhand',
    'Gulbarga,Gulbarga,Karnataka',
    'Guldhar,Ghaziabad,Uttar Pradesh',
    'Guledagudda Road,Kelawadi,Karnataka',
    'Guler,Thalla,Himachal Pradesh',
    'Gulzarbagh,Patna,Bihar',
    'Guma,Bara Bamonia,West Bengal',
    'Gumia,Gumia,Jharkhand',
    'Gumman,Parwanoo,Himachal Pradesh',
    'Gummidipundi,Gummidipundi,Tamil Nadu',
    'Gumthal,Gumthal,Uttar Pradesh',
    'Guna Junction,Guna,Madhya Pradesh',
    'Gundardehi,Gunderdehi,Chhattisgarh',
    'Guneru Bamori,Guneru Bamori,Madhya Pradesh',
    'Guntakal Junction,Anantapur,Andhra Pradesh',
    'Guntur Junction,Guntur,Andhra Pradesh',
    'Guptipara,Hooghly,West Bengal',
    'Guraru,Guraru,Bihar',
    'Gurap,Hooghly,West Bengal',
    'Gurdaspur,Gurdaspur,Punjab',
    'Gurgaon,Gurgaon,Haryana',
    'Gurhi,Chandpur Ryt,Madhya Pradesh',
    'Guriya,Guriya,Rajasthan',
    'Gurla,Bundi,Rajasthan',
    'Gurmura,Gurmura,Uttar Pradesh',
    'Gurpa,Gurpa,Bihar',
    'Gursahaiganj,Gursahaiganj,Uttar Pradesh',
    'Gursar Shnewala,Gursar Shnewala,Punjab',
    'Gauravpur,Gauravpur,Kerala',
    'Guru Tegh Bahadur Nagar,Mumbai,Maharashtra',
    'Guwahati,Guwahati,Assam',
    'Gwalior Junction,Gwalior,Madhya Pradesh',
    'Gyanpur Road,Bhadohi,Uttar Pradesh',
    'Habaipur,Mosoka,Assam',
    'Habibganj,Bhopal,Madhya Pradesh',
    'Habibwala,Manjupura,Uttar Pradesh',
    'Habra,Habra,West Bengal',
    'Hadapsar,Pune,Maharashtra',
    'Hadmadiya,Hadmadiya,Gujarat',
    'Hadmatiya Junction,Hadmadiya,Gujarat',
    'Hafizpur,Hafizpur,Uttar Pradesh',
    'Haflong Hill,Haflong,Assam',
    'Haiaghat,Darbhanga,Bihar',
    'Haibargaon,Nagaon,Assam',
    'Haidergarh,Satrahi,Uttar Pradesh',
    'Hailakandi,Hailakandi,Assam',
    'Hajipur Junction,Hajipur,Bihar',
    'Hakimpur,Mithanpur,Uttar Pradesh',
    'Haldaur,Haldaur,Uttar Pradesh',
    'Haldi Road,Tanda Range,Uttarakhand',
    'Haldibari,Cooch Behar,West Bengal',
    'Haldwani,Nainital,Uttarakhand',
    'Halisahar,Kanchrapara,West Bengal',
    'Halvad,Morbi,Gujarat',
    'Hamira,Kapurthala,Punjab',
    'Hamirgarh,Bhilwara,Rajasthan',
    'Hamirpur Road,Pandri Gangadin,Uttar Pradesh',
    'Hanakere,Hanakere,Karnataka',
    'Handia Khas,Handia,Uttar Pradesh',
    'Hansi,Hansi,Haryana',
    'Hansiawas,Chubkiya,Rajasthan',
    'Hanumangarh Junction,Hanumangarh,Rajasthan',
    'Hanumangarh Town,Hanumangarh,Rajasthan',
    'Hanwant,Hanwant,Rajasthan',
    'Hapa,Jamnagar,Gujarat',
    'Hapa Road,Jamnagar,Gujarat',
    'Hapur Junction,Hapur,Uttar Pradesh',
    'Harangajao,Dima hasao,Assam',
    'Harangul,Patil Nagar,Maharashtra',
    'Haranya Kheri,Haranya Kheri,Madhya Pradesh',
    'Harauni,Harauni,Uttar Pradesh',
    'Harwada,Harwada,Karnataka',
    'Harchandpur,Rae Bareli,Uttar Pradesh',
    'Harda,Harda,Madhya Pradesh',
    'Hardoi,Maholiya Sheopar,Uttar Pradesh',
    'Harduaganj,Kasimpur,Uttar Pradesh',
    'Haridwar,Haridwar,Uttarakhand',
    'Harihar,Davanagere,Karnataka',
    'Harinagar,Ramnagar,Bihar',
    'Haripad,Alappuzha,Kerala',
    'Haripur,Pali,Rajasthan',
    'Haripur Gram,Godiputamatiapara,Odisha',
    'Harischandrapur,Maldah,West Bengal',
    'Harishanker Road,Harishanker,Odisha',
    'Harisinga,Merbangchuba,Assam',
    'Harkia Khal,Harkiyakhal,Madhya Pradesh',
    'Harmuti,Lokampur,Assam',
    'Harnaut,Harnaut,Bihar',
    'Harpalganj,Rajinipur,Uttar Pradesh',
    'Harpalpur,Chhatarpur,Madhya Pradesh',
    'Harrawala,Dehradun,Uttarakhand',
    'Harsauli,Pataliya,Rajasthan',
    'Harsud,Harsud,Madhya Pradesh',
    'Harthala,Moradabad,Uttar Pradesh',
    'Harwada,Harwada,Karnataka',
    'Hasimara,Hasimara,West Bengal',
    'Hassan Junction,Hassan,Karnataka',
    'Hasanparthi Road,Yellapur,Telangana',
    'Hathbandh,Raipur,Chhattisgarh',
    'Hathidah Junction,Murarpur,Bihar',
    'Hathigadh,Haripar,Gujarat',
    'Hathras City,Hathras,Uttar Pradesh',
    'Hathras Junction,Hathras,Uttar Pradesh',
    'Hathras Road,Hathras,Uttar Pradesh',
    'Hathras Qilla,Hathras,Uttar Pradesh',
    'Hatia,Ranchi,Jharkhand',
    'Hatikhali,Hatikhali,Assam',
    'Hatkanagale,Hatkanagale,Maharashtra',
    'Hatundi,Khajpura,Rajasthan',
    'Haveri,Haveri,Karnataka',
    'Hazaribagh Road,Suriya,Jharkhand',
    'Hazrat Nizamuddin,New Delhi,Delhi',
    'Hejjala,Bengaluru,Karnataka',
    'Helak,Bharatpur,Rajasthan',
    'Helem,Biswanath,Assam',
    'Hempur,Aithilia Girant,Uttar Pradesh',
    'Hendegir,Hazaribagh,Jharkhand',
    'Hilara,Burunga Part 3,Assam',
    'Hilsa,Hilsa,Bihar',
    'Himayatnagar,Himayatnagar,Maharashtra',
    'Himmatnagar Junction,Sabarkantha,Gujarat',
    'Hindaun City,Karauli,Rajasthan',
    'Hind Motor,Hooghly,West Bengal',
    'Hindu College,Pattabiram,Tamil Nadu',
    'Hindumalkote,Hindumalkote,Rajasthan',
    'Hindupur,Anantapur,Andhra Pradesh',
    'Hinganghat,Hinganghat,Maharashtra',
    'Hingoli Deccan,Hingoli,Maharashtra',
    'Hira Nagar,Kathua,Jammu and Kashmir',
    'Hirakud,Sambalpur,Odisha',
    'Hirapur,Khadaki Bk,Maharashtra',
    'Hirdagarh,Chhindikamath,Maharashtra',
    'Hirnoda,Jaipur,Rajasthan',
    'Hisar,Hisar,Haryana',
    'Hisvahal,Mandwad,Maharashtra',
    'Hodal,Hodal,Haryana',
    'Hojai,Hojai,Assam',
    'Hol,Dabli,Maharashtra',
    'Holambi Kalan,New Delhi,Delhi',
    'Hole Alur,Hole Alur,Karnataka',
    'Honnavar,Karki,Karnataka',
    'Hooghly,Hooghly,West Bengal',
    'Hooghly Ghat,Hooghly,West Bengal',
    'Homnabad,Bidar,Karnataka',
    'Hosdurga Road,Bidarakere,Karnataka',
    'Hoshangabad,Hoshangabad,Madhya Pradesh',
    'Hoshiarpur,Hoshiarpur,Punjab',
    'Hosapete Junction,Ballari,Karnataka',
    'Hosur,Krishnagiri,Tamil Nadu',
    'Hotgi Junction,Solapur,Maharashtra',
    'Howbagh Jabalpur,Jabalpur,Madhya Pradesh',
    'Howrah Junction,Howrah,West Bengal',
    'Hubli Junction,Hubli,Karnataka',
    'Hugrajuli,Sonitpur,Assam',
    'Husainpur,Husainpur,Punjab',
    'Hyderabad Deccan,Hyderabad,Telangana',
    'Ib,Jharsuguda,Odisha',
    'Ichhapur,North 24 Parganas,West Bengal',
    'Ichapuram,Srikakulam,Andhra Pradesh',
    'Ichauli,Hamirpur,Uttar Pradesh',
    'Idar,Sabarkantha,Gujarat',
    'Idgah Agra Junction,Agra,Uttar Pradesh',
    'Igatpuri,Nashik,Maharashtra',
    'Ikkar,Ikkar,Uttarakhand',
    'Iklehra,Bhajipani,Madhya Pradesh',
    'Inchhapuri,Dadawas,Haryana',
    'Indalvai,Tirmanpally,Telangana',
    'Indapur,Raigad,Maharashtra',
    'Indara Junction,Mau,Uttar Pradesh',
    'Indargarh,Indargarh,Rajasthan',
    'Indi Road,Indi Road,Karnataka',
    'Indore Junction (BG),Indore,Madhya Pradesh',
    'Indore Junction (MG),Indore,Madhya Pradesh',
    'Innanje,Innanje,Karnataka',
    'Intikanne,Intikanne,Andhra Pradesh',
    'Intiyathok,Karuwa Para,Uttar Pradesh',
    'Itehar,Itehar,Madhya Pradesh',
    'Iqbal Gadh,Iqbalgadh,Gujarat',
    'Iqbalpur,Amarpur Qazi,Uttarakhand',
    'Irinjalakuda,Kalletumkara,Kerala',
    'Irugur(Coimbatore),Irugur,Tamil Nadu',
    'Isarda,Sawai Madhopur,Rajasthan',
    'Islampur,Islampur,Bihar',
    'Ismaila Haryana,Ismaila-B,Haryana',
    'Itarsi Junction,Hoshangabad,Madhya Pradesh',
    'Itola,Itola,Gujarat',
    'Itwari,Nagpur,Maharashtra',
    'Izzatnagar,Bareilly,Uttar Pradesh',
    'Jabalpur,Jabalpur,Madhya Pradesh',
    'Jabli,Kasauli Solan,Himachal Pradesh',
    'Jabri,Jabadiya Bheel,Madhya Pradesh',
    'Jadar,Jadar,Gujarat',
    'Jadavpur,Kolkata,West Bengal',
    'Jadcherla,Mahabubnagar,Telangana',
    'Jagadhri,Yamuna Nagar,Haryana',
    'Jagadhri Workshop,Yamuna Nagar,Haryana',
    'Jagadishpur,Pindra,Jharkhand',
    'Jagaddal,North 24 Parganas,West Bengal',
    'Jessore Road,Kolkata,West Bengal',
    'Jagatbela,Jagatbela,Uttar Pradesh',
    'Jagdalpur,Bastar,Chhattisgarh',
    'Jagdevwala,Jagdevwala,Rajasthan',
    'Jagesharganj,Chaubepur,Uttar Pradesh',
    'Jagi road,Kuyadal,Assam',
    'Jagnath Road Halt,Jagnath,Rajasthan',
    'Jagraon,Jagraon,Punjab',
    'Jahanikhera,Hannpasigawan,Uttar Pradesh',
    'Jaipur,Jaipur,Rajasthan',
    'Jais,Bahadurpur Da Jayas,Uttar Pradesh',
    'Jaisalmer,Jaisalmer,Rajasthan',
    'Jaithari,Nigaura,Madhya Pradesh',
    'Jaitipur,Rampur,Uttar Pradesh',
    'Jaitwar,Jaitwar,Madhya Pradesh',
    'Jajiwal,Jajiwal Kalan,Rajasthan',
    'Jajpur Kheonjhar Road,Jajpur,Odisha',
    'Jakhal Junction,Fatehabad,Haryana',
    'Jakhalabandha,Nagaon,Assam',
    'Jakhalaun,Jamundhana Kalan,Uttar Pradesh',
    'Jakhania,Jakhania,Uttar Pradesh',
    'Jakhaura,Raipur,Uttar Pradesh',
    'Jakhim,Jakhim,Bihar',
    'Jakhvada,Virochannagar,Gujarat',
    'Jaksi,Mota Karanpura,Gujarat',
    'Jalalganj,Lalpur,Uttar Pradesh',
    'Jalalpur Dhai,Charuhar Ziayak,Uttar Pradesh',
    'Jalamb Junction,Buldhana,Maharashtra',
    'Jalandhar Cantonment,Jalandhar,Punjab',
    'Jalandhar City,Jalandhar,Punjab',
    'Jalesar Road,Nagla Salem,Uttar Pradesh',
    'Jaleswar,Etah,Odisha',
    'Jalgaon Junction,Jalgaon,Maharashtra',
    'Jalila Road,Jalila,Gujarat',
    'Jaliya Devani,Jaliya Devani,Gujarat',
    'Jalna,Jalna,Maharashtra',
    'Jalor,Jalore,Rajasthan',
    'Jalpaiguri,Jalpaiguri,West Bengal',
    'Jalpaiguri Road,Jalpaiguri,West Bengal',
    'Jalsu,Jalsu,Rajasthan',
    'Jalsu Nanak,Jalsu Nanak,Rajasthan',
    'Jam Jodhpur Junction,Jamnagar,Gujarat',
    'Jam Wanthali,Jam Wanthali,Gujarat',
    'Jamalpur Junction,Munger,Bihar',
    'Jambara,Jambari Khurd,Madhya Pradesh',
    'Jambur,Jambur,Gujarat',
    'Jamira,Hailakandi,Assam',
    'Jammalamadugu,Jammalamadugu,Andhra Pradesh',
    'Jammikunta,Karimnagar,Telangana',
    'Jammu Tawi,Jammu,Jammu & Kashmir',
    'Jamnagar,Jamnagar,Gujarat',
    'Jamsar,Bikaner,Rajasthan',
    'Jamtara,Jamtara,Jharkhand',
    'Jamui,Mallehpur,Bihar',
    'Jamunamukh,Jamunamukh,Assam',
    'Jamwala,Kansariya,Gujarat',
    'Janakpur Road,Sitamarhi,Bihar',
    'Jandiala,Jandiala,Punjab',
    'Jangaon,Jangaon,Telangana',
    'Janghai Junction,Janghai,Uttar Pradesh',
    'Jangipur Road,Jangipur,West Bengal',
    'Janiyana,Janiyana,Rajasthan',
    'Jankampet Junction,Nizamabad,Telangana',
    'Jaora,Jaora,Madhya Pradesh',
    'Japla,Japla,Jharkhand',
    'Jarandeshwar,Jarandeshwar,Maharashtra',
    'Jargaon,Bhoori,Uttar Pradesh',
    'Jari,Banaskantha,Gujarat',
    'Jaruda Naraa,Bahadarpur,Uttar Pradesh',
    'Jarwal Road,Bambhaura,Uttar Pradesh',
    'Jasia,Ghilor Khurd,Haryana',
    'Jasali,Soni,Gujarat',
    'Jasidih Junction,Deoghar,Jharkhand',
    'Jasra,Jasra,Uttar Pradesh',
    'Jaswantgarh,Khanpur,Rajasthan',
    'Jaswantnagar railway station,Jaswantnagar,Uttar Pradesh',
    'Jataula Samphka,Rampur Rampura,Haryana',
    'Jath Road,Walekhindi,Maharashtra',
    'Jatinga,Dima Hasao,Assam',
    'Jatusana,Parkhotampur,Haryana',
    'Jaulka,Jamkhed,Maharashtra',
    'Jaunpur City,Jaunpur,Uttar Pradesh',
    'Jaunpur Junction,Jaunpur,Uttar Pradesh',
    'Javale,Javale,Maharashtra',
    'Jawad Road,Neemuch,Madhya Pradesh',
    'Jawai Bandh,Pali,Rajasthan',
    'Jawali,Dhariya,Rajasthan',
    'Jawalamukhi Road,Kangra,Himachal Pradesh',
    'Jayasingpur,Jayasingpur,Maharashtra',
    'Jaynagar,Madhubani,Bihar',
    'Jaynagar Majilpur,Kolkata,West Bengal',
    'Jehanabad,Chichmhi,Bihar',
    'Jejuri,Pune,Maharashtra',
    'Jenal,Banaskantha,Gujarat',
    'Jeonathpur,Deoria,Uttar Pradesh',
    'Jetalsar Junction,Rajkot,Gujarat',
    'Jetalvad,Junagadh,Gujarat',
    'Jetpur,Rajkot,Gujarat',
    'Jeur,Jeur,Maharashtra',
    'Jagannath Temple Gate,Kannur,Kerala',
    'Jhadupudi,Jadupudi,Andhra Pradesh',
    'Jhagadiya Junction,Jhagadiya,Gujarat',
    'Jhajha,Jhajha,Bihar',
    'Jhalawar Road,Dharnawad,Rajasthan',
    'Jhalida,Purulia,West Bengal',
    'Jhanjharpur,Behat North,Bihar',
    'Jhansi Junction,Jhansi,Uttar Pradesh',
    'Jhargram,Jhargram,West Bengal',
    'Jharia,Jharia,Jharkhand',
    'Jharokhas,Jharo Khurd,Uttar Pradesh',
    'Jharsuguda Junction,Jharsuguda,Odisha',
    'Jharwasaa,Ajmer,Rajasthan',
    'Jhingura,Imambara,Uttar Pradesh',
    'Jhinjhak,Kanpur Dehat,Uttar Pradesh',
    'Jhunjhunu,Jhunjhunu,Rajasthan',
    'Jhunpa,Gothyan Bari,Rajasthan',
    'Jigna,Mirzapur,Uttar Pradesh',
    'Jind Junction,Jind ,Haryana',
    'Jira Road,Jira,Gujarat',
    'Jiradei,Thepaha,Bihar',
    'Jiribam,Jiribam,Manipur',
    'Jirighat,Howkip Punji,Assam',
    'Jiron,Bamhori Kalan,Uttar Pradesh',
    'Jiyapuram,Jeeyapuram,Tamil Nadu',
    'Jodhpur Junction,Jodhpur,Rajasthan',
    'Jogbani,Araria,Bihar',
    'Jogeshwari,Mumbai,Maharashtra',
    'Jogi Magra,Riya-Shyamdas,Rajasthan',
    'Jogidih,Belhatthi,Uttar Pradesh',
    'Jogighopa,Chatpara N.C.,Assam',
    'Joginder Nagar,Joginder Nagar,Himachal Pradesh',
    'Jogiwala,Ferozepur,Punjab',
    'Jolarpettai Junction,Tirupattur,Tamil Nadu',
    'Jone Karrang,Ngabang Gamsuk,Assam',
    'Joravaragar,Surendranagar,Gujarat',
    'Jorhat,Jorhat,Assam',
    'Jorhat Town,Jorhat,Assam',
    'Jotana,Jotana,Gujarat',
    'Joychandi Pahar ,Purulia,West Bengal',
    'Juchandra,Mumbai,Maharashtra',
    'Jugijan,Jugijan,Assam',
    'Juinagar,Navi Mumbai,Maharashtra',
    'Jukehi,Nainiya,Madhya Pradesh',
    'Julana,Julana,Haryana',
    'Junagadh C B,Junagadh,Gujarat',
    'Junagadh Junction,Junagadh,Gujarat',
    'Jung Bahadurganj,Jung Bahadurganj,Uttar Pradesh',
    'Junichavand,Chavand Navi,Gujarat',
    'Junnor Deo,Junnardeo,Madhya Pradesh',
    'Juriagaon,Theo Tangani,Assam',
    'Jutogh,Shimla,Himachal Pradesh',
    'Jwalapur,Haridwar,Uttarakhand',
    'Kacheguda,Hyderabad,Telangana',
    'Kachhwa Road,Mirzapur,Uttar Pradesh',
    'Kondapalli,Kondapalli,Andhra Pradesh',
    'Kadalundi,Kadalundi,Tamil Nadu',
    'Kadambur,Kadambur,Tamil Nadu',
    'Kadaynallur,Tenkasi,Tamil Nadu',
    'Kadiri,Anantapuram,Andhra Pradesh',
    'Kadur Junction,Kadur,Karnataka',
    'Kaithalkuchi,Nalbari,Assam',
    'Kakinada Port,East Godavari,Andhra Pradesh',
    'Kakinada Town,Kakinada,Andhra Pradesh',
    'Kankinara,North 24 Parganas,West Bengal',
    'Kalachand,Kalachand,Assam',
    'Kalamboli,Navi Mumbai,Maharashtra',
    'Kalanaur kalan,Kalanaur,Haryana',
    'Kalianpur,Kanpur,Uttar Pradesh',
    'Kalka,Kalka,Haryana',
    'Kalkalighat,Paschim Lalkhira,Assam',
    'Kalwa,Thane,Maharashtra',
    'Kalwan,Kamalwala,Haryana',
    'Kalyan,Kalyan,Maharashtra',
    'Kondapalli,Kondapalli,Andhra Pradesh',
    'Kanchrapara,North 24 Parganas,West Bengal',
    'Kalyani,Kolkata,West Bengal',
    'Kalyanadurg,Kalyanadurg,Andhra Pradesh',
    'Kalinarayanpur Junction,Kamgachhi,West Bengal',
    'Kalol Junction,Gandhinagar,Gujarat',
    'Kamakhya Junction,Maligaon,Assam',
    'Kaman Road,Navghar,Maharashtra',
    'Kamareddi,Kamareddi,Telangana',
    'Kampil Road,Katiya,Uttar Pradesh',
    'Kamshet,Pune,Maharashtra',
    'Kamakhya Junction,Guwahati,Assam',
    'Kampur,Dakhin Chang Chaki,Assam',
    'Kamrup Khetri,Khetri,Assam',
    'Kanaibazar,Karimganj,Assam',
    'Kanakpura,Jaipur,Rajasthan',
    'Kanchausi,Kanchausi,Uttar Pradesh',
    'Kanchipuram,Kanchipuram,Tamil Nadu',
    'Kandivali,Mumbai,Maharashtra',
    'Kangra,Kangra,Himachal Pradesh',
    'Kanhangad,Kanhangad,Kerala',
    'Kanina Khas,Kanina Khas,Haryana',
    'Kaniyapuram,Kaniyapuram,Kerala',
    'Kanjiramittam,Kochi,Kerala',
    'Kanjurmarg,Mumbai,Maharashtra',
    'Kankanadi,Mangaluru,Karnataka',
    'Kannauj,Kannauj,Uttar Pradesh',
    'Kanpur Anwarganj,Kanpur,Uttar Pradesh',
    'Kanpur Central,Kanpur,Uttar Pradesh',
    'Kanpur Rooma,Kanpur,Uttar Pradesh',
    'Kanpur SMU CBSA CPSM,Kanpur,Uttar Pradesh',
    'Kanpur Govindpuri Railway Station,Kanpur,Uttar Pradesh',
    'Kanpur Panki,Kanpur,Uttar Pradesh',
    'Kanpur Bridge Left Bank,Kanpur,Uttar Pradesh',
    'Kanyakumari,Kanyakumari,Tamil Nadu',
    'Kapurthala,Kapurthala,Punjab',
    'Karad,Satara,Maharashtra',
    'Karaikkudi Junction,Sivaganga,Tamil Nadu',
    'Karanja,Karanja,Maharashtra',
    'Karchha,Ujjain,Madhya Pradesh',
    'Karimganj Junction,Karimganj,Assam',
    'Karimnagar,Karimnagar,Telangana',
    'Karjat,Karjat,Maharashtra',
    'Karmali,South Goa,Goa',
    'Karnal,Karnal,Haryana',
    'Karur Junction,Neelimedu,Tamil Nadu',
    'Karunagappalli,Kollam,Kerala',
    'Karwar,Shirwada,Karnataka',
    'Kasara,Kasara,Maharashtra',
    'Kasaragod,Kasaragod,Kerala',
    'Kashi,Varanasi,Uttar Pradesh',
    'Kashipur,Udham Singh Nagar,Uttarakhand',
    'Katakhal Junction,Hailakandi,Assam',
    'Kathgodam,Haldwani,Uttarakhand',
    'Kathivakkam,Ennore,Tamil Nadu',
    'Kathua,Chak Luden,Jammu and Kashmir',
    'Katihar,Katihar,Bihar',
    'Katlicherra,Katlicherra,Assam',
    'Katni,Katni,Madhya Pradesh',
    'Katol,Katol,Maharashtra',
    'Katpadi Junction,Vellore,Tamil Nadu',
    'Katra,Katra,Jammu and Kashmir',
    'Kavali,Kavali,Andhra Pradesh',
    'Kayamkulam,Alappuzha,Kerala',
    'Kayasthagram,karimganj,Assam',
    'Kazhakoottam TechnoPark Trivandrum,Kazhakoottam,Kerala',
    'Kazipet Junction,Warangal Urban,Telangana',
    'Kelavli,Navandhe,Maharashtra',
    'Kelve Road,Palghar,Maharashtra',
    'Kendukana,Ghopla,Assam',
    'Kengeri,Nagara,Karnataka',
    'Kesinga,Kesinga,Odisha',
    'Kesamudram,Kesamudram,Telangana',
    'Khadavli,Thane,Maharashtra',
    'Khadki,Pune,Maharashtra',
    'Khairthal,Alwar,Rajasthan',
    'Khajuraho,Chhatarpur,Madhya Pradesh',
    'Khalilpur,Chillar,Haryana',
    'Khambhaliya,Khambhaliya,Gujarat',
    'Khamgaon,Khamgaon,Maharashtra',
    'Khamkhed,Buldhana,Maharashtra',
    'Khammam,Khammam,Telangana',
    'Khana Junction,Purba Bardhaman,West Bengal',
    'Khandala,Pune,Maharashtra',
    'Khandeshwar,Navi Mumbai,Maharashtra',
    'Khandwa,Khandwa,Madhya Pradesh',
    'Khanna,Ludhiana,Punjab',
    'Kharagpur Junction,Paschim Medinipur,West Bengal',
    'Kharbao,Vasai,Maharashtra',
    'Khardi,Khardi,Maharashtra',
    'Kharghar,Navi Mumbai,Maharashtra',
    'Khar Road,Mumbai,Maharashtra',
    'Khatauli,Muzaffarnagar,Uttar Pradesh',
    'Khatu,Dheejpura,Rajasthan',
    'Khed,Khed,Maharashtra',
    'Khera Kalan,North Delhi,Delhi',
    'Khopoli,Khopoli,Maharashtra',
    'Khurai,Khurai,Madhya Pradesh',
    'Kinwat,Kinwat,Maharashtra',
    'Kirakat ,Chhitauna,Uttar Pradesh',
    'Kirloskarvadi,Sangli,Maharashtra',
    'Kirnahar,Birbhum,West Bengal',
    'Kilikolloor,Peroor,Kerala',
    'King\'s Circle,Mumbai,Maharashtra',
    'Kishanganj,Kishanganj,Bihar',
    'Kiul Junction,Lakhisarai,Bihar',
    'Kochuveli ,Thiruvananthapuram,Kerala',
    'Kodaikanal road,Kodaikanal road,Tamil Nadu',
    'Koderma,Jhumri Telaiya,Jharkhand',
    'Kodinar,Junagadh,Gujarat',
    'Kodumudi,Erode,Tamil Nadu',
    'Koduru,Kadapa,Andhra Pradesh',
    'Kokrajhar,Kokrajhar,Assam',
    'Kolar,Kolar,Karnataka',
    'Kollidam,Kollidam,Tamil Nadu',
    'Kolhapur,Kolhapur,Maharashtra',
    'Kolad,Raigad,Maharashtra',
    'Kolkata,Kolkata,West Bengal',
    'Kollam Junction,Kollam,Kerala',
    'Konnagar,Baidyabati,West Bengal',
    'Kopar,Dombivli,Maharashtra',
    'Kopargaon,Ahmednagar,Maharashtra',
    'Kopar Khairane,Navi Mumbai,Maharashtra',
    'Koraput Junction,Koraput,Odisha',
    'Korattiangadi,Ernakulam,Kerala',
    'Korattur,Chennai,Tamil Nadu',
    'Korba,Korba,Chhattisgarh',
    'Koregaon,Satara,Maharashtra',
    'Korukkupet,Chennai,Tamil Nadu',
    'Kosamba,Kosamba,Gujarat',
    'Kosi Kalan,Kosi Kalan,Uttar Pradesh',
    'Kosli,Kosli,Haryana',
    'Kotdwar,Pauri Garhwal,Uttarakhand',
    'Kot Kapura,Kot Kapura,Punjab',
    'Kota Junction,Kota,Rajasthan',
    'Kotli Kalan,Kotli Kalan,Punjab',
    'Kotma,Bijuri,Madhya Pradesh',
    'Kotshila Junction,Purulia,West Bengal',
    'Kottapalli,Kottapalli,Telangana',
    'Kottavalasa,Kottavalasa,Andhra Pradesh',
    'Kottayam,Kottayam,Kerala',
    'Kottarakkara,Kollam,Kerala',
    'Kotikulam,Bekal,Kerala',
    'Kotturu,Ballari,Andhra Pradesh',
    'Kovilpatti,Kovilpatti,Tamil Nadu',
    'Koyilandy,Kozhikode,Kerala',
    'Kozhikode,Kozhikode,Kerala',
    'Krishna,Gurujala,Andhra Pradesh',
    'Krishna Canal,Tadepalli,Andhra Pradesh',
    'Krishnai,Goalpara,Assam',
    'Krishnarajapuram,Bengaluru,Karnataka',
    'Kuchaman City,Mandawara,Rajasthan',
    'Kudal,Kudal,Maharashtra',
    'Kulitalai,Kulitalai,Tamil Nadu',
    'Kulpahar,Kulpahar,Uttar Pradesh',
    'Kulti,Kulti,West Bengal',
    'Kulukkallur,Palakkad,Kerala',
    'Kumgaon Burti,Buldhana,Maharashtra',
    'Kumbakonam,Kumbakonam,Tamil Nadu',
    'Kumta,Kumta,Karnataka',
    'Kundapura,Satvadi,Karnataka',
    'Kuppam,Kuppam,Andhra Pradesh',
    'Kuram,Pedhi,Maharashtra',
    'Kuri,Thalavoor,Kerala',
    'Kurichedu,Kurichedu,Andhra Pradesh',
    'Kurduvadi,Solapur,Maharashtra',
    'Kurla,Mumbai,Maharashtra',
    'Kurnool Town,Kurnool,Andhra Pradesh',
    'Kurukshetra Junction,Kurukshetra,Haryana',
    'Kuttippuram,Malappuram,Kerala',
    'Khurda Road,Khordha,Odisha',
    'kursela,Katihar,bihar',
    'Laban,Bundi,Rajasthan',
    'Labha,Lalganj Teghra English,bihar',
    'Labhpur,Birbhum,West Bengal',
    'Lachhipura,Bankura,West Bengal',
    'Lachhmangarh SK,Laxmangarh,Rajasthan',
    'Lachhmanpur,Jagatpur,Uttar Pradesh',
    'Lachyan,Lachyan,Karnataka',
    'Ladhowal,Jalandhar,Punjab',
    'Ladnun,Nagaur,Rajasthan',
    'Laheria Sarai,Darbhanga,Bihar',
    'Lahli,Rohtak,Haryana',
    'Laimekuri,Laimekuri,Assam',
    'Lakadiya,Lakadiya,Gujarat',
    'Lakheri,Bundi,Rajasthan',
    'Lakhimpur,Kheri,Uttar Pradesh',
    'Lakhminia,Rudarpur,Bihar',
    'Lakhnauria,Sonauwa,Uttar Pradesh',
    'Lakhtar,Lakhtar,Gujarat',
    'Lakkidi,Palakkad,Kerala',
    'Laksar Junction,Haridwar,Uttarakhand',
    'Lakshmibai Nagar,Indore,Madhya Pradesh',
    'Lal Kuan,Lalkuan,Uttarakhand',
    'Lalabazar,Lalapur,Assam',
    'Lalapet,Secunderabad,Telangana',
    'Lalganj,Bhagwanpur,Uttar Pradesh',
    'Lalgarh Junction,Bikaner,Rajasthan',
    'Lalgopalganj,Rasoolpur Nindura,Uttar Pradesh',
    'Lalgudi,Tiruchirappalli,Tamil Nadu',
    'Lalitpur,Lalitpur,Uttar Pradesh',
    'Lalkuan Junction,Lalkuan,Uttarakhand',
    'Lalpur,Jamnagar,Gujarat',
    'Lalpur Chandra,Jamnagar,Gujarat',
    'Lalpur Jam,Jamnagar,Gujarat',
    'Lalpur Umri,Umri,Rajasthan',
    'Lalru,Sahibzada Ajit Singh Nagar,Punjab',
    'Lamana,Lamana,Rajasthan',
    'Lambhua,Baidauli,Uttar Pradesh',
    'Lambiya,Lambiya,Rajasthan',
    'Lamsakhang,Lamsakhan,Assam',
    'Landaura,Haridwar,Uttarakhand',
    'Langting,Dima Hasao,Assam',
    'Lanka,Lanka,Assam',
    'Laopani,Niz-Jarabari,Assam',
    'Lar Road,Karjaha,Uttar Pradesh',
    'Lasalgaon,Lasalgaon,Maharashtra',
    'Lasur,aurangabad,Maharashtra',
    'Latehar,Latehar,Jharkhand',
    'Lathi,Lathi,Gujarat',
    'Latur,Latur,Maharashtra',
    'Latur Road Junction,Latur,Maharashtra',
    'Laukaha Bazar,Madhubani,bihar',
    'Laul,Laul,Maharashtra',
    'Lawa Sardargarh,Rajsamand,Rajasthan',
    'Ledarmer,Jalor,Rajasthan',
    'Lehra Gaga,Lehra Gaga,Punjab',
    'Lidhora Khurd,Pipariya Karkat,Madhya Pradesh',
    'Liliya Mota,Amreli,Gujarat',
    'Limbdi,Surendranagar,Gujarat',
    'Limkheda,Dahod,Gujarat',
    'Linch,Boriyavi,Gujarat',
    'Lingampalli,Hyderabad,Telangana',
    'Liluah,Howrah,West Bengal',
    'Lodipur Bishnpr,Lodhipur,Uttar Pradesh',
    'Loha,Loha,Rajasthan',
    'Loharu,Bhiwani,Haryana',
    'Loharwara,Jaipur,Rajasthan',
    'Lohian Khas Junction,Jalandhar,Punjab',
    'Lohna Road,Darbhanga,Bihar',
    'Lohogad,Pune,Maharashtra',
    'Loisingha,Loisingha,Odisha',
    'Lokmanya Tilak Terminus,Mumbai,Maharashtra',
    'Lonand,Lonand,Maharashtra',
    'Lonavala,Lonavala,Maharashtra',
    'Londa Junction,Belgaum,Karnataka',
    'Loni,Pune,Maharashtra',
    'Lorwada,Banaskantha,Gujarat',
    'Lower Haflong,Haflong,Assam',
    'Lower Parel,Mumbai,Maharashtra',
    'Lowjee,Khopoli,Maharashtra',
    'Luckeesarai Junction,Lakhisarai,Bihar',
    'Lucknow Junction,Lucknow,Uttar Pradesh',
    'Lucknow,Lucknow,Uttar Pradesh',
    'Lucknow City,Lucknow,Uttar Pradesh',
    'Ludhiana Junction,Ludhiana,Punjab',
    'Lumding Junction,Nagaon,Assam',
    'Lunavada,Lunavada,Gujarat',
    'Luni Junction,Jodhpur,Rajasthan',
    'Luni Richha,Luni,Madhya Pradesh',
    'Lunidhar,Lunidhar,Gujarat',
    'Lunkaransar,Lunkaransar,Rajasthan',
    'Lusa,Lusa,Uttar Pradesh',
    'Lusadiya,Rampur,Gujarat',
    'Lushala,Junagadh,Gujarat',
    'Lalgola,Murshidabad,West Bengal',
    'Macharya,Bhikanpur Fatehullah,Uttar Pradesh',
    'Machavaram,Machavaram,Andhra Pradesh',
    'Machelipatnam,Machelipatnam,Andhra Pradesh',
    'Macherla,Macherla,Andhra Pradesh',
    'Madan Mahal,Jabalpur,Madhya Pradesh',
    'Madanapalle Rd,Nethaji Colony,Andhra Pradesh',
    'Madanpur,Madanpur,West Bengal',
    'Maddur,Maddur,Karnataka',
    'Madhavnagar,Katni,Maharashtra',
    'Madukarai(Coimbatore),Madukkarai,Tamil Nadu',
    'Madgaon,Margao,Goa',
    'Mithlanchal Deep,Godhanpur,Bihar',
    'Madha,Solapur,Maharashtra',
    'Madhabpur,South 24 Paraganas,West Bengal',
    'Madhapar,Kutch,Gujarat',
    'Madhapur Road,Bhuj,Gujarat',
    'Madhi,Madhi,Gujarat',
    'Madhira,Madhira,Telangana',
    'Madhopur Punjab,Madhopur,Punjab',
    'Madhorajpur,Jaipur,Rajasthan',
    'Madhosingh,Bhadohi,Uttar Pradesh',
    'Madhubani,Madhubani,Bihar',
    'Madhupur Junction,Deoghar,Jharkhand',
    'Madurai Junction,Madurai,Tamil Nadu',
    'Madurantakam,Kanchipuram,Tamil Nadu',
    'Madure,Madura,Maharashtra',
    'Maghar,Sant Kabeer Nagar,Uttar Pradesh',
    'Mahadanapuram,Mahadanapuram,Tamil Nadu',
    'Mahadevpara,Sabar Kantha,Gujarat',
    'Mahajan,Mahajan,Rajasthan',
    'Mahalam,Jiwa Bhedi,Punjab',
    'Mahalaxmi,Mumbai,Maharashtra',
    'Mahamandir,Jodhpur,Rajasthan',
    'Mahansar,Jhunjhunu,Rajasthan',
    'Mahasamund,Mahasamund,Chhattisgarh',
    'Mahbubabad,Mahbubabad,Telangana',
    'Mahbubnagar,Mahbubnagar,Telangana',
    'Mahe,Mahe,Puducherry',
    'Maheji,jalgaon,Maharashtra',
    'Mahendragarh,Mohindergarh,Haryana',
    'Mahes Khunt,Maheskhunt,Bihar',
    'Mahesana Junction,Mehsana,Gujarat',
    'Maheshmunda,Baidadih,Jharkhand',
    'Mahidpur Road,Mahidpur Road,Madhya Pradesh',
    'Mahim,Mumbai,Maharashtra',
    'Mahisgaon,solapur,Maharashtra',
    'Mahmudabad Avdh,Mahmudabad,Uttar Pradesh',
    'Mahmudpur SRYN,Del Pandarwa,Uttar Pradesh',
    'Mahoba,Mahoba,Uttar Pradesh',
    'Maholi,Maholi,Uttar Pradesh',
    'Mahpur,Mahpur,Uttar Pradesh',
    'Mahuamilan,Malhan,Jharkhand',
    'Mahuariya,Mahuli,Uttar Pradesh',
    'Mahuda Junction,Dhanbad,Jharkhand',
    'Mahugarha,Barodiya Khurd,Madhya Pradesh',
    'Mahur,Mahur,Assam',
    'Mahuva Junction,Bhavnagar,Gujarat',
    'Maibang,Dima Hasao,Assam',
    'Maihar,Satna,Madhya Pradesh',
    'Maikalganj,Maikalganj,Uttar Pradesh',
    'Mailani Junction,Lakhimpur Kheri,Uttar Pradesh',
    'Mailongdisa,Dima Hasao,Assam',
    'Mainpuri,Mainpuri,Uttar Pradesh',
    'Mairabari,Morigaon,Assam',
    'Mairwa,Mairwa,Bihar',
    'Majbat,Udalguri,Assam',
    'Majgaon,Majgaon,Assam',
    'Majhagawan,Majhgawa,Uttar Pradesh',
    'Majhola Pakarya,Pilibhit,Uttar Pradesh',
    'Majorda,South Goa,Goa',
    'Makhu,Makhu,Punjab',
    'Makrana Junction,Nagaur,Rajasthan',
    'Makrera,Ajmer,Rajasthan',
    'Makronia,Rajakhedi,Madhya Pradesh',
    'Maksi,Maksi,Madhya Pradesh',
    'Malad,Mumbai,Maharashtra',
    'Malarna,Sawai Madhopur,Rajasthan',
    'Malavli,Pune,Maharashtra',
    'Malda Town,Sanpaulu,West Bengal',
    'Malerkotla,Malerkotla,Punjab',
    'Malethu Kanak,Bikapur,Uttar Pradesh',
    'Malhargarh,Kachariya,Madhya Pradesh',
    'Malhour,Lucknow,Uttar Pradesh',
    'Malihabad,Firozpur,Uttar Pradesh',
    'Malipur,Jalalpur,Uttar Pradesh',
    'Maliya Hatina,Junagadh,Gujarat',
    'Maliya Miyana,Morbi,Gujarat',
    'Malkapur,Buldhana,Maharashtra',
    'Malkhaid Road,Bhimnagar,Karnataka',
    'Malkisar,Bikaner,Rajasthan',
    'Mallanwala Khas,Mallan Wala,Punjab',
    'Malleswaram,Bangalore,Karnataka',
    'Malliyam,Malliyam,Tamil Nadu',
    'Malout,Malout,Punjab',
    'Malpura,Tonk,Rajasthan',
    'Malsailu,Ekamba,Maharashtra',
    'Malsian Shahkht,Laksian,Punjab',
    'Malugur,Malugur,Andhra Pradesh',
    'Malur,Kolar,Karnataka',
    'Malwan,Fatehpur,Uttar Pradesh',
    'Malwara,Kotra,Rajasthan',
    'Maman,Khurja,Uttar Pradesh',
    'Manaksar,Hanumangarh,Rajasthan',
    'Manamadurai Junction,Manamadurai,Tamil Nadu',
    'Mananpur,Jamui,Bihar',
    'Manaparai,Manaparai,Tamil Nadu',
    'Manauri,Prayagraj,Uttar Pradesh',
    'Manavadar,Manavadar,Gujarat',
    'Mancherial,Mancherial,Telangana',
    'Mancheswar,Bhubaneswar,Odisha',
    'Manda Road,Salia,Uttar Pradesh',
    'Mandagere,Mandya,Karnataka',
    'Mandal,Mandal,Rajasthan',
    'Mandalgarh,Bhilwara,Rajasthan',
    'Mandapam,Mandapam,Tamil Nadu',
    'Mandapam Camp,Mandapam,Tamil Nadu',
    'Mandar Hill,Banka,Bihar',
    'Mandasa Road,Suvarnapuram,Andhra Pradesh',
    'Mandasor,Mandasor,Madhya Pradesh',
    'Manderdisa,Dima Hasao,Assam',
    'Mandhana Junction ,Kanpur,Uttar Pradesh',
    'Mandi Adampur,Adampur,Haryana',
    'Mandi Bamora,Sagar,Madhya Pradesh',
    'Mandi Dabwali,Sirsa,Haryana',
    'Mandi Dhanaura,Jyotiba Phule Nagar,Uttar Pradesh',
    'Mandi Dip,Raisen,Madhya Pradesh',
    'Mandla Fort,Mandla,Madhya Pradesh',
    'Mandor,Jodhpur,Rajasthan',
    'Mandrak,Mandrak Road,Uttar Pradesh',
    'Manduadih,Varanasi,Uttar Pradesh',
    'Mandya,Mandya,Karnataka',
    'Manendragarh,Korea,Madhya Pradesh',
    'Mangalagiri,Amaravati,Andhra Pradesh',
    'Mangaliyawas,Mangaliyawas,Rajasthan',
    'Mangaluru Central,Mangalore,Karnataka',
    'Mangaluru Junction,Mangalore,Karnataka',
    'Mangaon,Raigad,Maharashtra',
    'Mangliya Gaon,Dhabli,Madhya Pradesh',
    'Mangolpuri,New Delhi,Delhi',
    'Mangra,Mangra,Jharkhand',
    'Manheru,Bhiwani,Haryana',
    'Manigachi,Darbhanga,Bihar',
    'Manikpur Junction,Chitrakoot,Uttar Pradesh',
    'Maninagar,Ahmedabad,Gujarat',
    'Manipur Bagan,Nehal Chandpur,Assam',
    'Vanchi Maniyachchi Junction,Thoothukudi,Tamil Nadu',
    'Manjeshwar,Kasaragod,Kerala',
    'Mankapur Junction,Gonda,Uttar Pradesh',
    'Mankar,Mankar,West Bengal',
    'Mankarai,Mankarai,Kerala',
    'Mankatha,Barhia English,Bihar',
    'Mankhurd,Mumbai,Maharashtra',
    'Manki,Manki,Karnataka',
    'Manmad Junction,Manmad,Maharashtra',
    'Mannanur,Mannanur,Kerala',
    'Manoharganj,Manoharganj,Uttar Pradesh',
    'Manoharpur,Manoharpur,Jharkhand',
    'Mansa,Mansa,Punjab',
    'Mansarovar,Navi Mumbai,Maharashtra',
    'Mansi Junction,Khagaria,Bihar',
    'Mansurpur,Mansurpur,Uttar Pradesh',
    'Manthralayam Road,Dibbanadoddi,Andhra Pradesh',
    'Manuguru,Samathsingaram,Telangana',
    'Manwath Road,Parbhani,Maharashtra',
    'Manzurgarhi,Sikandrapur Cherat,Uttar Pradesh',
    'Marahra,Mahmoodpur Nagaria,Uttar Pradesh',
    'Maramjhiri,Betul,Madhya Pradesh',
    'Marauda,Maroda Basti,Chhattisgarh',
    'Mariahu,Narayanpur,Uttar Pradesh',
    'Mariani Junction,Jorhat,Assam',
    'Marikuppam,Kolar Gold Fields,Karnataka',
    'Marine Lines,Mumbai,Maharashtra',
    'Maripat,Greater Noida,Uttar Pradesh',
    'Markapur Road,Goguladinne,Andhra Pradesh',
    'Markundi,Kihunia,Uttar Pradesh',
    'Marmagao,Vasco da Gama,Goa',
    'Maroli,Maroli,Gujarat',
    'Marsul,Pimpala lokhande,Maharashtra',
    'Marthipalayam,Karur,Karnataka',
    'Marwar Bagra,Bagra,Rajasthan',
    'Marwar Balia,Baliya,Rajasthan',
    'Marwar Bhinmal,Bhinmal,Rajasthan',
    'Marwar Birthi,Birthi,Rajasthan',
    'Marwar Chapri,Chapri,Rajasthan',
    'Marwar Junction,Pali,Rajasthan',
    'Marwar Kori,Jalore,Rajasthan',
    'Marwar Lohwat,Lohawat,Rajasthan',
    'Marwar Mathanya,Jodhpur,Rajasthan',
    'Marwar Ratanpur,Jakhari,Rajasthan',
    'Masit,Karim Nagar Saidapur,Uttar Pradesh',
    'Masjid Bunder,Mumbai,Maharashtra',
    'Maskanwa,Khale Gaon,Uttar Pradesh',
    'Masodha,Mahawan,Uttar Pradesh',
    'Masrakh,Masrakh,Bihar',
    'Masur,Wanyachiwadi,Maharashtra',
    'Matana Buzurg,Chandesari,Madhya Pradesh',
    'Mataundh,Mataundh,Uttar Pradesh',
    'Mathura Cantonment,Mathura,Uttar Pradesh',
    'Mathura Junction,Mathura,Uttar Pradesh',
    'Matlabpur,Samadpur Buniyadpur,Uttar Pradesh',
    'Matmari,Matmari,Karnataka',
    'Mattancheri Halt,Kochi,Kerala',
    'Matunga,Mumbai,Maharashtra',
    'Matunga Road,Mumbai,Maharashtra',
    'Mau Aimma,Bharana,Uttar Pradesh',
    'Mau Junction,Mau,Uttar Pradesh',
    'Mau Ranipur,Mau Ranipur,Uttar Pradesh',
    'Maur,Maur,Punjab',
    'Maval,Maval,Rajasthan',
    'Mavelikara,Alappuzha,Kerala',
    'Mavli Junction,Udaipur,Rajasthan',
    'Mayanoor,Mayanur,Tamil Nadu',
    'Mayiladuturai Junction,Mayiladuthurai,Tamil Nadu',
    'Mayyanad,Kollam,Kerala',
    'McCluskieganj,Mccluskieganj,Jharkhand',
    'Mecheda,Raksa Chak,West Bengal',
    'Medchal,Secunderabad,Telangana',
    'Meerut Cantonment,Meerut,Uttar Pradesh',
    'Meerut City,Meerut,Uttar Pradesh',
    'Meghnagar,Jhabua,Madhya Pradesh',
    'Mehnar Road,Chamarhara,Bihar',
    'Mehsi,Mehsi,Bihar',
    'Meja Road,Soranv Pati,Uttar Pradesh',
    'Melmaruvattur,Nettapakkam,Puducherry',
    'Melusar,Meloosar,Rajasthan',
    'Mendipathar,Resubelpara,Meghalaya',
    'Memari,Purba Bardhaman,West Bengal',
    'Meralgram,Meral,Jharkhand',
    'Merta City,Nagaur,Rajasthan',
    'Merta Road Junction,Nagaur,Rajasthan',
    'Mettur,Salem,Tamil Nadu',
    'Metupalaiyam,Mettupalayam,Tamil Nadu',
    'Mettur Dam,Salem,Tamil Nadu',
    'Mhasavad,Mhasavad,Maharashtra',
    'Mahemdavad Kheda Road,Mahemdavad,Gujarat',
    'Mhow,Dr. Ambedkar Nagar,Madhya Pradesh',
    'Midnapore,Paschim Medinipur,West Bengal',
    'Migrendisa,Dima Hasao,Assam',
    'Mihinpurwa,Ray Bojha,Uttar Pradesh',
    'Mihrawan,Mehrawan,Uttar Pradesh',
    'Milak,Rampur,Uttar Pradesh',
    'Minjur,Minjur,Tamil Nadu',
    'Miraj Junction,Miraj,Maharashtra',
    'Miranpur Katra,Katra,Uttar Pradesh',
    'Mira Road,Mumbai,Maharashtra',
    'Mirchadhori,Jogendra,Madhya Pradesh',
    'Mirhakur,Mirhakur,Uttar Pradesh',
    'Mirthal,Mirthal,Punjab',
    'Mirza,Mirza,Assam',
    'Mirzapali,Mirzapali,Telangana',
    'Miryalaguda,Nalgonda,Telangana',
    'Mirzapur,Mirzapur,Uttar Pradesh',
    'Misamari,Patidoi Bherala Gaon,Assam',
    'Misrauli,Amethi,Uttar Pradesh',
    'Mitha,Mitha,Gujarat',
    'Mithapur,Mithapur,Gujarat',
    'Miyagam Karjan,Karjan,Gujarat',
    'Miyana,Miyana,Gujarat',
    'Miyona ka Bara,Barmer,Rajasthan',
    'Modelgram,Ludhiana,Punjab',
    'Modinagar,Ghaziabad,Uttar Pradesh',
    'Modnimb,Solapur,Maharashtra',
    'Modpur,Lalpur,Gujarat',
    'Modran,Modran,Rajasthan',
    'Moga,Moga,Punjab',
    'Mohammadkhera,Shajapur,Madhya Pradesh',
    'Mohanlalganj,Mau,Uttar Pradesh',
    'Mohiuddinnagar,Kalyanpur Basti West,Bihar',
    'Mohiuddinpur,Mohiuddinpur,Uttar Pradesh',
    'Mohol,Kolegaon,Maharashtra',
    'Mohri,Mohri,Haryana',
    'Mokalsar,Barmer,Rajasthan',
    'Mokama Junction,Mokameh Khas,Bihar',
    'Mokholi,Rahitha Khurd,Rajasthan',
    'Monabari,Biswanath,Assam',
    'Monacherra,Monacherra,Assam',
    'Mondh,Bhadohi,Uttar Pradesh',
    'Munger,Munger,Bihar',
    'Monglajhora,Monglajhora,Assam',
    'Moore Market Complex ,Chennai,Tamil Nadu',
    'Moradabad,Moradabad,Uttar Pradesh',
    'Morak,Morak,Rajasthan',
    'Morappur,Morappur,Tamil Nadu',
    'Morbi,Mahendra Para,Gujarat',
    'Mordar,Ajmer,Rajasthan',
    'Morena,Morena,Madhya Pradesh',
    'Mori Bera,Rughnathpura,Rajasthan',
    'Morinda,Morinda,Punjab',
    'Morthala,Sirohi,Rajasthan',
    'Mota Jadra,Mota Jadra,Gujarat',
    'Moterjhar,Moterjhar,Assam',
    'Moth,Jhansi,Uttar Pradesh',
    'Mothala,Kutch,Gujarat',
    'Mothala Halt,Kutch,Gujarat',
    'Motichur,Haridwar,Uttarakhand',
    'Bapudham Motihari,Motihari,Bihar',
    'Motipur,Motipur,Bihar',
    'Motipura Chauki,Faridpur,Rajasthan',
    'Moula-Ali,Secunderabad,Telangana',
    'Muddanuru,Muddanuru,Andhra Pradesh',
    'Mudkhed Junction,Nanded,Maharashtra',
    'Muftiganj,Muftiganj,Uttar Pradesh',
    'Mughal Sarai Junction,Chandauli,Uttar Pradesh',
    'Muhammadabad,Gohna,Uttar Pradesh',
    'Muirpur Road,Rantola,Uttar Pradesh',
    'Mukerian,Hoshiarpur,Punjab',
    'Mukhtiar Balwar,Balwara,Madhya Pradesh',
    'Muktsar,Sri Muktsar Sahib,Punjab',
    'Mukundarayapuram,Ranipet,Tamil Nadu',
    'Muli Road,Tikar Parmar,Gujarat',
    'Mulki,Mulki,Karnataka',
    'Mullanpur,Mullanpur Dakha,Punjab',
    'Mulanur,Mallanuru,Andhra Pradesh',
    'Multai,Multai,Madhya Pradesh',
    'Mulund,Mumbai,Maharashtra',
    'Mumbai Central,Mumbai,Maharashtra',
    'Mumbra,Mumbai,Maharashtra',
    'Munabao,Barmer,Rajasthan',
    'Mundalaram,Mundalaram,Madhya Pradesh',
    'Mundha Pande,Moradabad,Uttar Pradesh',
    'Mundhewadi,Solapur,Maharashtra',
    'Mungaoli,Mungaoli,Madhya Pradesh',
    'Muniguda,Muniguda,Odisha',
    'Munirabad,Huligi,Karnataka',
    'Munroturuttu,Munroe Island,Kerala',
    'Mupa,Dima Hasao,Assam',
    'Muradnagar,Muradnagar,Uttar Pradesh',
    'Murdeshwar,Mavalli,Karnataka',
    'Muri,Ranchi,Jharkhand',
    'Murkeongselek,Jonai,Assam',
    'Murliganj,Murliganj,Bihar',
    'Murshadpur,Shajhanpur,Uttar Pradesh',
    'Murshidabad,Murshidabad,West Bengal',
    'Murtizapur Junction,Akola,Maharashtra',
    'Musafir Khana,Musafirkhana,Uttar Pradesh',
    'Mustafabad,Uchachandana,Haryana',
    'Muttarasanallur,Tiruchirappalli,Tamil Nadu',
    'Mutupet,Mutupet,Tamil Nadu',
    'Muzaffarnagar,Muzaffarnagar,Uttar Pradesh',
    'Muzaffarpur Junction,Muzaffarpur,Bihar',
    'Muzzampur Narayan,Mungerpur,Uttar Pradesh',
    'Mysuru Junction,Mysuru,Karnataka',
    'Naya Ghaziabad,Ghaziabad,Uttar Pradesh',
    'N J Ramanal,Naruana,Punjab',
    'Nabadwip Dham,Nabadwip,West Bengal',
    'Nabha,Patiala,Punjab',
    'Nadauj,Nadaul,Bihar',
    'Nadiad Junction,Kheda,Gujarat',
    'Nandikoor,Nandikur,Karnataka',
    'Nadikudi,Dachepalle,Andhra Pradesh',
    'Nagal,Nangal,Uttar Pradesh',
    'Naganahalli,Mysuru,Karnataka',
    'Nagaon,Nagaon,Assam',
    'Nagappattinam junction,Nagappattinam,Tamil Nadu',
    'Nagar,Nagar,Rajasthan',
    'Nagar Untari,Garhwa,Jharkhand',
    'Nagercoil Junction,Kanyakumari,Tamil Nadu',
    'Nagardevla,Wadgaon Bk,Maharashtra',
    'Nagargali,Nagaragali,Karnataka',
    'Nagari,Nethamkhandriga,Andhra Pradesh',
    'Nagaria Sadat,Mirganj,Uttar Pradesh',
    'Nagarur,Nagarur,Andhra Pradesh',
    'Nagaur,jodhpur mandal,Rajasthan',
    'Nagbhir Junction,Chandrapur,Maharashtra',
    'Nagda Junction,Ujjain,Madhya Pradesh',
    'Nagercoil Town,Kanyakumari,Tamil Nadu',
    'Nagina,Nagina,Uttar Pradesh',
    'Naglatula,Dumriya,Rajasthan',
    'Nagore,Nagapattinam,Tamil Nadu',
    'Nagpur,Nagpur,Maharashtra',
    'Nagrota,Nagrota Bagwan,Himachal Pradesh',
    'Naharkatiya,Dibrugarh,Assam',
    'Naharlagun,Papum Pare,Arunachal Pradesh',
    'Nahur,Mumbai,Maharashtra',
    'Naigaon,Mumbai,Maharashtra',
    'Naihati Junction,North 24 Parganas,West Bengal',
    'Naikheri,Ujjain,Madhya Pradesh',
    'Naila,Janjgir-Champa,Chhattisgarh',
    'Naini,Dabhaon,Uttar Pradesh',
    'Nainpur Junction,Mandla,Madhya Pradesh',
    'Najibabad Junction,Bijnor,Uttar Pradesh',
    'Nakodar Junction,Jalandhar,Punjab',
    'Nalanda,Nalanda,Bihar',
    'Nala Sopara,Mumbai,Maharashtra',
    'Nalbari,Nalbari,Assam',
    'Nalgonda,Nalgonda,Telangana',
    'Nalhati,Nalhati,West Bengal',
    'Naliya,Kutch,Gujarat',
    'Naliya Cantonment,Kutch,Gujarat',
    'Nalwar,Nalwar,Karnataka',
    'Namakkal,Namakkal,Tamil Nadu',
    'Namburu,Namburu,Andhra Pradesh',
    'Namkom,Ranchi,Jharkhand',
    'Namli,Ratlam,Madhya Pradesh',
    'Namrup,Namrup Chah Bagich,Assam',
    'Nana,Chimanpura,Rajasthan',
    'Nana Bhamodra,Amreli,Gujarat',
    'Nanaksar,Nanaksar,Punjab',
    'Nandalur,Nandalur,Andhra Pradesh',
    'Nandapur,hingoli,Maharashtra',
    'Hazur Sahib Nanded,Nanded,Maharashtra',
    'Nandganj,Isopur,Uttar Pradesh',
    'Nandgaon,Nashik,Maharashtra',
    'Nandgaon Road,Sindhudurg,Maharashtra',
    'Nandiambakkam,Minjur,Tamil Nadu',
    'Nandol Dehegam,Dahegam,Gujarat',
    'Nandura,Buldhana,Maharashtra',
    'Nandurbar,Nandurbar,Maharashtra',
    'Nandyal Junction,Nandyala,Andhra Pradesh',
    'Nangal Dam,Rupnagar,Punjab',
    'Nangloi,North Delhi,Delhi',
    'Nanguneri,Nanguneri,Tamil Nadu',
    'Nanjangud Town,Mysore,Karnataka',
    'Nanpara Junction,Bahraich,Uttar Pradesh',
    'Naojan,Golaghat,Assam',
    'Napasar,Bikaner,Rajasthan',
    'Nar Town,Anand,Gujarat',
    'Naraikkinar,Marudanvalvoonaraikinar,Tamil Nadu',
    'Naraina,Jaipur,Rajasthan',
    'Narangi,Guwahati,Assam',
    'Naranjipur,Dewas,Madhya Pradesh',
    'Narasapur,Narasapur,Andhra Pradesh',
    'Narasaraopet,Narasaraopet,Andhra Pradesh',
    'Narayanpet Road,Saidapur,Karnataka',
    'Narayanpur,Narayanpur,Assam',
    'Narayanpur Anant,Muzaffarpur,Bihar',
    'Nardana,Dhule,Maharashtra',
    'Narela,New Delhi,Delhi',
    'Nari Road,Bhavnagar,Gujarat',
    'Nariaoli,Badora,Madhya Pradesh',
    'Narkatiaganj Junction,Narkatiaganj,Bihar',
    'Narkher,Narkhed,Maharashtra',
    'Narnaul,Mahendragarh,Haryana',
    'Naroda,Ahmedabad,Gujarat',
    'Narsinghpur,Narsinghpur,Madhya Pradesh',
    'Narwana Junction,Narwana Rural,Haryana',
    'Narwasi,Khyali,Rajasthan',
    'Nasik Road,Nashik,Maharashtra',
    'Nasirabad,Ajmer,Rajasthan',
    'Nathdwara,Mandiyana,Rajasthan',
    'Nathwana,Nathwana,Rajasthan',
    'Naugachia,Naugachia,Bihar',
    'Nauganwan,Asindiya,Madhya Pradesh',
    'Naugarh,Naugarh,Uttar Pradesh',
    'Naupada Junction,Srikakulam,Andhra Pradesh',
    'Nautanwa,Maharajganj,Uttar Pradesh',
    'Navade Road,Mumbai,Maharashtra',
    'Navagadh,Jetpur,Gujarat',
    'Navalur,Sattur Colony,Karnataka',
    'Navapur,Nandurbar,Maharashtra',
    'Navlakhi,Navlakhi,Gujarat',
    'Navsari,Navsari,Gujarat',
    'Nawa City,Nagaur,Rajasthan',
    'Nawadah,Nawada,Bihar',
    'Nawagaon,Nayagaon,Madhya Pradesh',
    'Nawalgarh,Jhunjhunu,Rajasthan',
    'Nawalgohan,Jhunjhunu,Rajasthan',
    'Naya Azadpur,New Delhi,Delhi',
    'Naya Kharadia,Khardiyan,Rajasthan',
    'Naya Nangal,Rupnagar,Punjab',
    'Nayadupeta,Nellore,Andhra Pradesh',
    'Nayagaon,Saran,Bihar',
    'Naydongri,Nashik,Maharashtra',
    'Nazareth,Thoothukudi,Tamil Nadu',
    'Nazirganj,Chand Chour,Bihar',
    'Nekonda,Nekonda,Telangana',
    'Nellimaria,Solipisomarajupeta,Andhra Pradesh',
    'Nellore,Nellore,Andhra Pradesh',
    'Nemilichery,Pattabiram,Tamil Nadu',
    'Nemom,Trivandrum,Kerala',
    'Nenpur,Mandla,Madhya Pradesh',
    'Nepalganj Road,Rupaidiha,Uttar Pradesh',
    'Nepanagar,Burhanpur,Madhya Pradesh',
    'Neral,Neral,Maharashtra',
    'Nergundi,Alarpur,Odisha',
    'Neri,Chheheliya,Uttar Pradesh',
    'Nerul,Navi Mumbai,Maharashtra',
    'Netawal,Panchli,Rajasthan',
    'New Alipurduar,Alipurduar,West Bengal',
    'New Bhuj,Bhuj,Gujarat',
    'New Bongaigaon Junction,Bhakarivita,Assam',
    'New Cooch Behar,Cooch Behar,West Bengal',
    'New Delhi,New Delhi,Delhi',
    'New Farakka Junction,Farakka,West Bengal',
    'New Garia,Kolkata,West Bengal',
    'New Guntur,Guntur,Andhra Pradesh',
    'New Jalpaiguri,Siliguri,West Bengal',
    'New Mal Junction,Jalpaiguri,West Bengal',
    'New Maynaguri,Jalpaiguri,West Bengal',
    'New Misamari,Dhekiajuli,Assam',
    'Neyveli,Neyveli,Tamil Nadu',
    'Neyyattinkara,Kovalam,Kerala',
    'Nibhapur,Jaunpur,Uttar Pradesh',
    'Nidadavolu Junction,Nidadavole,Andhra Pradesh',
    'Nidamangalam Junction,Needamangalam,Tamil Nadu',
    'Nidubrolu,Nidubrolu,Andhra Pradesh',
    'Nigohan,Bairisal Pur,Uttar Pradesh',
    'Nihalgarh,Jagdishpur,Uttar Pradesh',
    'Nilaje,Nilje Gaon,Maharashtra',
    'Nilambazar,Nilambazar,Assam',
    'Nilambur Road,Malappuram,Kerala',
    'Nileshwar,Kasaragod,Kerala',
    'Nilokheri,Nilokheri,Haryana',
    'Nim Ka Thana,Sikar,Rajasthan',
    'Nimach,Neemuch,Madhya Pradesh',
    'Nimar Kheri,Khandwa,Madhya Pradesh',
    'Nimbahera,Chittaurgarh,Rajasthan',
    'Nimbhora,Khirdi Kh,Maharashtra',
    'Nimtita,Dafahat,West Bengal',
    'Nindhar Benar,Boytawala,Rajasthan',
    'Ningala Junction,Ningala,Gujarat',
    'Nipani Vadgaon,Ashok Nagar,Maharashtra',
    'Niphad,Niphad,Maharashtra',
    'Nira,Satara,Maharashtra',
    'Nirakarpur,Nirakarpur,Odisha',
    'Nirmali,Supaul,Bihar',
    'Nisui,Nisui,Uttar Pradesh',
    'Nivari,Siddha Toriya,Uttar Pradesh',
    'Nivasar,Vesurle,Maharashtra',
    'Nizamabad,Nizamabad,Telangana',
    'Nizampur,Narnaul,Haryana',
    'Nizbarganj,Biswanath,Assam',
    'Nizchatia,Biswanath,Assam',
    'Noamundi,Noamundi,Jharkhand',
    'Nohar,Hanumangarh,Rajasthan',
    'Nokha,Bikaner,Rajasthan',
    'Nomoda,Kherla,Rajasthan',
    'Nonera,Nonera,Madhya Pradesh',
    'Norla Road,Kalahandi,Odisha',
    'North Lakhimpur,Lakhimpur,Assam',
    'Nosaria,Nosariya,Rajasthan',
    'Nowrozabad,Nipaniya,Madhya Pradesh',
    'Noyal,Karur,Tamil Nadu',
    'Narayanpur Tatwar,Sawai Madhopur,Rajasthan',
    'Nua,Jhunjhunu,Rajasthan',
    'Nunkhar,Achaula,Uttar Pradesh',
    'Nurmahal,Jalandhar,Punjab',
    'Okha,Rajkot,Gujarat',
    'Old Delhi Junction,Old Delhi,Delhi',
    'Old Malda Junction,Malda,West Bengal',
    'Omkareshwar Road,Khandwa,Madhya Pradesh',
    'Ondagram,Bankura,West Bengal',
    'Ongole,Prakasam,Andhra Pradesh',
    'Ontimitta,Kadapa,Andhra Pradesh',
    'Orai,Jalaun,Uttar Pradesh',
    'Ottapalam,Ottapalam,Kerala',
    'Oorgaum,Kolar Gold Fields,Karnataka',
    'Pabai,Pawai,Madhya Pradesh',
    'Pabli Khas,Meerut,Uttar Pradesh',
    'Pachrukhi,Pachrukhi,Bihar',
    'Pachhapur,Belgaum,Karnataka',
    'Pachor Road,Rajgarh,Madhya Pradesh',
    'Pachora Junction,Jalgaon,Maharashtra',
    'Pachperwa,Balrampur,Uttar Pradesh',
    'Paddhari,Rajkot,Gujarat',
    'Padhegaon,Ahmednagar,Maharashtra',
    'Padrauna,Padrauna,Uttar Pradesh',
    'Padse,Eklahare,Maharashtra',
    'Padubidri,Padubidri,Karnataka',
    'Pagara,Guna,Madhya Pradesh',
    'Pahara,Bharuhia,Uttar Pradesh',
    'Paharpur,Gaya,Bihar',
    'Pajian,Karahal Nauabad,Punjab',
    'Pakala Junction,Chittoor,Andhra Pradesh',
    'Pakki,Muktsar,Punjab',
    'Pakur,Pakur,Jharkhand',
    'Palachauri,Pal Chourai,Madhya Pradesh',
    'Palam,New Delhi,Delhi',
    'Palampur Himachal ,Kangra,Himachal Pradesh',
    'Palampur HP OA,Kangra,Himachal Pradesh',
    'Palana,Bikaner,Rajasthan',
    'Palani,Madurai,Tamil Nadu',
    'Palanpur Junction,Palanpur,Gujarat',
    'Palappuram,Palakkad,Kerala',
    'Palasa,Srikakulam,Andhra Pradesh',
    'Palasdari,Varne,Maharashtra',
    'Paldhi,Jalgaon,Maharashtra',
    'Pahlejaghat Junction,Saran,Bihar',
    'Palej,Palej,Gujarat',
    'Palghar,Palghar,Maharashtra',
    'Palakkad Junction,Palakkad,Kerala',
    'Palakkad Town,Palakkad,Kerala',
    'Palakollu,West Godavari,Andhra Pradesh',
    'Pali Marwar,Pali,Rajasthan',
    'Palia,Palia,Madhya Pradesh',
    'Palia Kalan,Kheri,Uttar Pradesh',
    'Palitana,Bhavnagar,Gujarat',
    'Palpara,Chakdaha,West Bengal',
    'Palsana,Sikar,Rajasthan',
    'Palsora Makrawa,Makdawan,Madhya Pradesh',
    'Palwal,Palwal,Haryana',
    'Pamban Junction,Ramanathapuram,Tamil Nadu',
    'Panagarh,Shokna,West Bengal',
    'Panbari,Burha Mayang Par,Assam',
    'Panch Pipila,Panch Pipila,Madhya Pradesh',
    'Panch Rukhi,Kangra,Himachal Pradesh',
    'Pancharatna,Makri,Assam',
    'Panchgram,Hailakandi,Assam',
    'Panchtalavda Rd,Amreli,Gujarat',
    'Pandavapura,Kennalu,Karnataka',
    'Pandaravadai,Thanjavur,Tamil Nadu',
    'Pandharpur,Solapur,Maharashtra',
    'Pandhurna,Pandhurna,Madhya Pradesh',
    'Pandoli,Chittorgarh,Rajasthan',
    'Paneli Moti,Paneli Moti,Gujarat',
    'Paniahwa,Malhia,Uttar Pradesh',
    'Panikhaiti,Barchapari,Assam',
    'Panipat Junction,Panipat,Haryana',
    'Panitola,Tinsukia,Assam',
    'Panjhan,Mandwad,Maharashtra',
    'Panki,Kanpur,Uttar Pradesh',
    'Panruti,Panruti,Tamil Nadu',
    'Panskura Junction,Purba Medinipur,West Bengal',
    'Pantnagar,Udham Singh Nagar,Uttarakhand',
    'Panvel,Navi Mumbai,Maharashtra',
    'Papanasam,Thanjavur,Tamil Nadu',
    'Paradgaon,Jalna,Maharashtra',
    'Paralakhemundi,Gajapati,Odisha',
    'Paramakkudi,Paramakudi,Tamil Nadu',
    'Paras,akola,Maharashtra',
    'Parasia,Dongar Parasia,Madhya Pradesh',
    'Parasnath Station,Isri,Jharkhand',
    'Paravur,Kollam,Kerala',
    'Parbati,Jangi Khedi,Madhya Pradesh',
    'Parbhani Junction,Parbhani,Maharashtra',
    'Pardhande,Pardhade,Maharashtra',
    'Pardi,Valsad,Gujarat',
    'Parel,Mumbai,Maharashtra',
    'Parhihara,Parihara,Rajasthan',
    'Parkham,Mathura,Uttar Pradesh',
    'Parli,Parli,Kerala',
    'Parli Vaijnath,Beed,Maharashtra',
    'Parlu,Barmer,Rajasthan',
    'Parappanangadi,Malappuram,Kerala',
    'Parsa Bazar,Patna,Bihar',
    'Parsa Khera,Bareilly,Uttar Pradesh',
    'Parsabad,Parsabad,Jharkhand',
    'Parsipur,Jagdishpur Sujan,Uttar Pradesh',
    'Parsoda,Parsoda,Maharashtra',
    'Partapgarh Junction,Pratapgarh,Uttar Pradesh',
    'Partapur,Meerut,Uttar Pradesh',
    'Partur,Partur,Maharashtra',
    'Parvatipuram,Vizianagaram,Andhra Pradesh',
    'Parvatipuram Town,Vizianagaram,Andhra Pradesh',
    'Pasur,Erode,Tamil Nadu',
    'Patal Pani,Borkhedi,Madhya Pradesh',
    'Patan,Patan,Gujarat',
    'Patara,Kanpur Nagar,Uttar Pradesh',
    'Patas,Pune,Maharashtra',
    'Pataudi Road,Gurgaon,Haryana',
    'Pathankot Junction,Pathankot,Punjab',
    'Pathankot Cantt,Pathankot,Punjab',
    'Pathardih Junction,Pathardih,Jharkhand',
    'Patharkandi,Patharkandi,Assam',
    'Patharkhola,Patharkhola,Assam',
    'Patharia,Damoh,Madhya Pradesh',
    'Pathauli,Agra,Uttar Pradesh',
    'Pathri,Chandi Range,Uttarakhand',
    'Pathsala,Barpeta,Assam',
    'Patiala,Patiala,Punjab',
    'Patiladaha,Bawbari,Assam',
    'Patli,Patli,Haryana',
    'Patna Junction,Patna,Bihar',
    'Patna Saheb,Patna,Bihar',
    'Patranga,Patranga,Uttar Pradesh',
    'Patratu,Ramgarh,Jharkhand',
    'Patsul,Patsul,Maharashtra',
    'Pattabiram,Pattabiram,Tamil Nadu',
    'Pattabiram West,Pattabiram,Tamil Nadu',
    'Pattabiram East Depot,Pattabiram,Tamil Nadu',
    'Pattambi,Palakkad,Kerala',
    'Pattaravakkam,Chennai,Tamil Nadu',
    'Pattukkottai,Nadimuthu Nagar,Tamil Nadu',
    'Pavur Chatram,Tiruchirappalli,Tamil Nadu',
    'Pawapuri Road,Bijwanpar,Bihar',
    'Payagpur,Jhala Tarhar,Uttar Pradesh',
    'Payangadi,Kannur,Kerala',
    'Payyanur,Kannur,Kerala',
    'Payyoli,Kozhikode,Kerala',
    'Peddapalli,Peddapalli,Telangana',
    'Pendra Road,Bilaspur,Chhattisgarh',
    'Penganga,Washim,Maharashtra',
    'Penukonda,Vasudevapuram,Andhra Pradesh',
    'Perambur,Chennai,Tamil Nadu',
    'Perambur Carriage Works,Chennai,Tamil Nadu',
    'Perambur Loco Works,Chennai,Tamil Nadu',
    'Pernem,North Goa,Goa',
    'Perugamani,Tiruchirappalli,Tamil Nadu',
    'Petlad Junction,Petlad,Gujarat',
    'Pethanaickenpalayam,Pethanaickenpalayam,Tamil Nadu',
    'Pettaivayatalai,Pettaivayatalai,Tamil Nadu',
    'Phagwara Junction,Kapurthala,Punjab',
    'Phakhoagram,Fakiragram,Assam',
    'Phalodi,Jodhpur,Rajasthan',
    'Phanda,Bhopal,Madhya Pradesh',
    'Phaphamau Junction,Allahabad,Uttar Pradesh',
    'Phaphund,Dibiyapur,Uttar Pradesh',
    'Phephna Junction,Fefana,Rajasthan',
    'Phesar,Sohraiya,Bihar',
    'Phillaur Junction,Jalandhar,Punjab',
    'Phulad,Pali,Rajasthan',
    'Phulaguri,Dhemaji Gaon,Assam',
    'Phulera Junction,Jaipur,Rajasthan',
    'Phulpur,Allahabad,Uttar Pradesh',
    'Pij,Kheda,Gujarat',
    'Pilamedu,Coimbatore,Tamil Nadu',
    'Pili Bangan,Hanumangarh,Rajasthan',
    'Pilibhit Junction,Pilibhit,Uttar Pradesh',
    'Pilioda,Khedli,Rajasthan',
    'Pilkhua,Pilkhuwa,Uttar Pradesh',
    'Pimpar Khed,Nashik,Maharashtra',
    'Pimpri,Pimpri-Chinchwad,Maharashtra',
    'Pindra Road,Varanasi,Uttar Pradesh',
    'Pingleshwar,Ujjain,Madhya Pradesh',
    'Pipalda Road,Pipalda,Rajasthan',
    'Pipalsana,Bhojpur,Uttar Pradesh',
    'Pipar Road Junction,Jodhpur,Rajasthan',
    'Pipariya,Hoshangabad,Madhya Pradesh',
    'Piparpur,Khanapur,Uttar Pradesh',
    'Piparsand,Lonha,Uttar Pradesh',
    'Piplaj,Ajmer,Rajasthan',
    'Piplee,Moti Pipli,Gujarat',
    'Piplia,Panth Pipalia,Madhya Pradesh',
    'Piplod Junction,Dahod,Gujarat',
    'Piploda Bagla,Piploda Sagotimata,Madhya Pradesh',
    'Pipraich,Gorakhpur,Uttar Pradesh',
    'Pipraigaon,Pipraigaon,Madhya Pradesh',
    'Piprala,Patan,Gujarat',
    'Pipri Dih,Pipri,Uttar Pradesh',
    'Pirjhalar,Ratlam,Madhya Pradesh',
    'Pirpainti,Maheshram,Bihar',
    'Pirthiganj,Bhagesara,Uttar Pradesh',
    'Pirumadara,Ramnagar,Uttarakhand',
    'Pirwa,Ruwan,Rajasthan',
    'Pitambarpur,Faridpur,Uttar Pradesh',
    'Pithapuram,East Godavari,Andhra Pradesh',
    'Plassey,Nadia,West Bengal',
    'Podanur Junction,Coimbatore,Tamil Nadu',
    'Pokhrayan,Kanpur Dehat,Uttar Pradesh',
    'Pokran,Pokran,Rajasthan',
    'Pollachi Junction,Pollachi,Tamil Nadu',
    'Polur,Polur,Tamil Nadu',
    'Ponmalai Golden Rock,Tiruchirappalli,Tamil Nadu',
    'Ponneri,Ponneri,Tamil Nadu',
    'Porbandar,Porbandar,Gujarat',
    'Potul,Aurangabad,Maharashtra',
    'Prabhadevi,Mumbai,Maharashtra',
    'Prachi Road Junction,Junagadh,Gujarat',
    'Pranpur Road,Belgachi,Bihar',
    'Prantij,Prantij,Gujarat',
    'Prantik,Birbhum,West Bengal',
    'Prayag,Allahabad,Uttar Pradesh',
    'Prayag Ghat,Allahabad,Uttar Pradesh',
    'Pritam Nagar,Dhar,Madhya Pradesh',
    'Proddatur,Proddatur,Andhra Pradesh',
    'Puducherry,Colas Nagar,Puducherry',
    'Pudukad,Pudukad,Kerala',
    'Pudukkottai,Kavinad West,Tamil Nadu',
    'Pugalur,Nanjaipugalur,Tamil Nadu',
    'Pulgaon Junction,Pulgaon,Maharashtra',
    'Punalur,Kollam,Kerala',
    'Punarakh,Diara Pandarakh,Bihar',
    'Pundhag,Pundhag,Jharkhand',
    'Pune Junction,Pune,Maharashtra',
    'Punkunnam,Thrissur,Kerala',
    'Punpun,Punpun,Bihar',
    'Puntamba,Ahmednagar,Maharashtra',
    'Purab Sarai,Munger,Bihar',
    'Puraini,Puraini,Jharkhand',
    'Puranigudam,Nagaon,Assam',
    'Puranpur,Pilibhit,Uttar Pradesh',
    'Puri,Puri,Odisha',
    'Purna Junction,Parbhani,Maharashtra',
    'Purnia Junction,Purnia,Bihar',
    'Purnia Court,Purnia,Bihar',
    'Purua Khera,Malkhanpur,Uttar Pradesh',
    'Pusad,Yavatmal,Maharashtra',
    'Purulia Junction,Purulia,West Bengal',
    'Puttur,Puttur,Andhra Pradesh',
    'Quarry SDG,Rourkela,Odisha',
    'Rabale,Navi Mumbai,Maharashtra',
    'Radhanpur,Patan,Gujarat',
    'Radhikapur,Uttar Dinajpur,West Bengal',
    'Rae Bareli Junction,Rae Bareli,Uttar Pradesh',
    'Rafiganj,Aurangabad,Bihar',
    'Ragaul,Maudaha,Uttar Pradesh',
    'Raghunathpur,Kantuar,Bihar',
    'Raha,Raha,Assam',
    'Rahimabad,Tarauna,Uttar Pradesh',
    'Rahimatpur,Sasurve,Maharashtra',
    'Rahul Road,nalanda,Bihar',
    'Rahuri,Deswandi,Maharashtra',
    'Rai Singh Nagar,Rai Singh Nagar,Rajasthan',
    'Raibha,Bichpuri,Uttar Pradesh',
    'Raichur,Raichur,Karnataka',
    'Raiganj,Uttar Dinajpur,West Bengal',
    'Raigarh,Raigarh,Chhattisgarh',
    'Raika Bagh,Jodhpur,Rajasthan',
    'Raila Road,Raila,Rajasthan',
    'Raimehatpur,Raipur Sahoran,Himachal Pradesh',
    'Raipur Junction,Gudhiyari,Chhattisgarh',
    'Rairakhol,Damgarh,Odisha',
    'Raisi,Netwala Saidabad,Uttarakhand',
    'Raiwala,Dehradun,Uttarakhand',
    'Raj Gangpur,Rajgangpur,Odisha',
    'Raj Nandgaon,Rajnandgaon,Chhattisgarh',
    'Raja Bhat Khawa,Alipurduar,West Bengal',
    'Raja Ka Sahaspur,Dhakia Naroo,Uttar Pradesh',
    'Raja Ki Mandi,Agra,Uttar Pradesh',
    'Rajaldesar,Churu,Rajasthan',
    'Rajamundry,East Godavari,Andhra Pradesh',
    'Rajapalayam,Rajapalayam,Tamil Nadu',
    'Rajapur Road,Nikharewadi,Maharashtra',
    'Rajawari,Varanasi,Uttar Pradesh',
    'Rajendranagar Terminal,Patna,Bihar',
    'Rajgarh,Alwar,Rajasthan',
    'Rajghat Narora,Rajghat Bangar,Uttar Pradesh',
    'Rajgir,Danapur,Bihar',
    'Rajhura,Chechanha,Jharkhand',
    'Rajiyasar,Ganganagar,Rajasthan',
    'Rajkharsawan Junction,Chhota Amda,Jharkhand',
    'Rajkot Junction,Rajkot,Gujarat',
    'Rajlu Garhi,Garhi Kalan,Haryana',
    'Rajmahal,Sahibganj,Jharkhand',
    'Rajmane,Kunzar Road,Maharashtra',
    'Rajosi,Ajmer,Rajasthan',
    'Rajpipla,Narmada,Gujarat',
    'Rajpura Junction,Patiala,Punjab',
    'Rajula City,Ringaniyala Nana,Gujarat',
    'Rajula Junction,Vavera,Gujarat',
    'Rajur,Chandrapur,Maharashtra',
    'Rakha Mines,Kuldiha,Jharkhand',
    'Rakhi,Rakhi,Rajasthan',
    'Ram Chaura Road,Goshpur,Uttar Pradesh',
    'Raman,Bathinda,Punjab',
    'Ram Dayalu Nagar,Muzaffarpur,Bihar',
    'Ramanagaram,Nainital,Karnataka',
    'Ramanathapuram,Ramanathapuram,Tamil Nadu',
    'Ramdevra,Jaisalmer,Rajasthan',
    'Rameswaram,Rameswaram,Tamil Nadu',
    'Ramganga,Bareilly,Uttar Pradesh',
    'Ramganj Mandi,Ramganj,Rajasthan',
    'Ramgarh Cantonment,Ramgarh Cantonment,Jharkhand',
    'Ramgarhwa,Inarwa,Bihar',
    'Ramagundam,Peddapalli,Telangana',
    'Ramkola,Ramkola,Uttar Pradesh',
    'Ram Mandir,Mumbai,Maharashtra',
    'Ramna,Bataua,Jharkhand',
    'Ramnagar,Shivlalpur Pandey,Uttarakhand',
    'Rampur,Rampur,Uttar Pradesh',
    'Rampur Dumra,Rampur Dumra,Bihar',
    'Rampurhat,Rampurhat,West Bengal',
    'Rampura Phul,Rampura Phul,Punjab',
    'Ramsan,Ramsan,Gujarat',
    'Ramsar,Barmer,Rajasthan',
    'Ramtek,Nagpur,Maharashtra',
    'Rana Bordi,Bordi,Gujarat',
    'Ranaghat Junction,Kolkata,West Bengal',
    'Ranala,Nandurbar,Maharashtra',
    'Ranapratapnagar,Udaipur,Rajasthan',
    'Ranavav,Porbandar,Gujarat',
    'Marwar Ranawas,Pali,Rajasthan',
    'Ranchi,Ranchi,Jharkhand',
    'Ranchi Road,Ranchi,Jharkhand',
    'Rangapara North,Sonitpur,Assam',
    'Rangiya Junction,Rangia,Assam',
    'Rangjuli,Goalpara,Assam',
    'Rangmahal,Ganganagar,Rajasthan',
    'Rani,Pali,Rajasthan',
    'Ranibennur,Ranebennur,Karnataka',
    'Raniganj,Asansol,West Bengal',
    'Ranipur Road,Bamhauri Suhagi,Uttar Pradesh',
    'Raniwara,Jalor,Rajasthan',
    'Ranjangaon Road,Ahmadnagar,Maharashtra',
    'Ranjani,Jalna,Maharashtra',
    'Ranoli,Vadodara,Gujarat',
    'Ranolishishu,Sikar,Rajasthan',
    'Ranpur,Botad,Gujarat',
    'Ranthambhore,Dhanoli,Rajasthan',
    'Ranuj,Patan,Gujarat',
    'Rasra,Rasra,Uttar Pradesh',
    'Rasulabad,Fatehpur,Uttar Pradesh',
    'Rasull,Sursanda,Uttar Pradesh',
    'Rasuriya,Manpur Ahaiyapur,Uttar Pradesh',
    'Rasipuram,Rasipuram,Tamil Nadu',
    'Ratabari,Karimganj,Assam',
    'Ratan Shahr,Jhunjhunu,Rajasthan',
    'Ratangaon,Adhrand,Madhya Pradesh',
    'Ratangarh Junction,Churu,Rajasthan',
    'Ratangarh West,Churu,Rajasthan',
    'Ratanpura,Banshibajar,Uttar Pradesh',
    'Rathdhana,Sonipat,Haryana',
    'Ratlam Junction,Ratlam,Madhya Pradesh',
    'Ratnagiri,Ratnagiri,Maharashtra',
    'Ratnal,Kutch,Gujarat',
    'Rau,Indore,Madhya Pradesh',
    'Rauzagaon,Ganawli,Uttar Pradesh',
    'Raver,Jalgaon,Maharashtra',
    'Rawania Dungar,Shyopura,Rajasthan',
    'Rawatpur,Kanpur,Uttar Pradesh',
    'Raxaul Junction,East Champaran,Bihar',
    'Rayagada,Rayagada,Odisha',
    'Rayalcheruvu,Anantapur,Andhra Pradesh',
    'Raybag,Raibag Rural,Karnataka',
    'Rayadurg,Rayadurgam,Andhra Pradesh',
    'Razampeta,Rajampet,Andhra Pradesh',
    'Reay Road,Mumbai,Maharashtra',
    'Rechni Road,Adilabad,Telangana',
    'Ren,Nagaur,Rajasthan',
    'Renigunta Junction,Tirupati,Andhra Pradesh',
    'Renukut,Sonbhadra,Uttar Pradesh',
    'Renwal,Jaipur,Rajasthan',
    'Reoti B Khera,Reoti,Uttar Pradesh',
    'Repalle,Repalle,Andhra Pradesh',
    'Rethorakalan,Aiti,Madhya Pradesh',
    'Rewa Terminal,Rewa,Madhya Pradesh',
    'Rewari Junction,Rewari,Haryana',
    'Richha Road,Maqsoodanpur,Uttar Pradesh',
    'Richughutu,Richughutu,Jharkhand',
    'Ridhore,Vadashinge,Maharashtra',
    'Ringas Junction,Sikar,Rajasthan',
    'Risama,Chirpoli,Chhattisgarh',
    'Rishikesh,Dehradun,Uttarakhand',
    'Rishra,Hooghly,West Bengal',
    'Risia,Risia Bazaar,Uttar Pradesh',
    'Rithi,Katni,Madhya Pradesh',
    'Rajendar Nagar Bihar,Patna,Bihar',
    'Ramgarh Shekhwati,Sikar,Rajasthan',
    'Raninagar Jalpaiguri,Jalpaiguri,West Bengal',
    'Robertsganj,Sonbhadra,Uttar Pradesh',
    'Roha,Raigad,Maharashtra',
    'Rohana Kalan,Muzaffarnagar,Uttar Pradesh',
    'Rohini,Rohini,Maharashtra',
    'Rohtak Junction,Rohtak,Haryana',
    'Roorkee,Haridwar,Uttarakhand',
    'Rora,Rora,Uttar Pradesh',
    'Roshanpur,Roshanpur,Uttar Pradesh',
    'Rotegaon,Aurangabad,Maharashtra',
    'Rourkela,Rourkela,Odisha',
    'Rowta Bagan,Bajarajhar,Assam',
    'Roza Junction,Settlement Roza,Uttar Pradesh',
    'Rudauli,Chetaipur,Uttar Pradesh',
    'Rudrapur City,Udham Singh Nagar,Uttarakhand',
    'Rudrapur Road,Dibdiba,Uttar Pradesh',
    'Rukadi,Rukadi,Maharashtra',
    'Runija,Runija,Madhya Pradesh',
    'Runkhera,Thadoda,Madhya Pradesh',
    'Rupaheli,Roopaheli,Rajasthan',
    'Rupahigaon,Rupahi Bhakat Gaon,Assam',
    'Rupamau,Dohri,Uttar Pradesh',
    'Rupaund,Bachharwara,Madhya Pradesh',
    'Rupasibari,Srigouri,Assam',
    'Rupbas,Roopvas,Rajasthan',
    'Rupnagar,Rupnagar,Punjab',
    'Rupnarayanpur,Mihijam,West Bengal',
    'Rupra Road,Bilat,Odisha',
    'Rupsa Junction,Balasore,Odisha',
    'Rura,Kanpur,Uttar Pradesh',
    'Rusera Ghat,Rosera,Bihar',
    'Ruthiyai Junction,Guna,Madhya Pradesh',
    'Swami Narayan Chhapia,Chhapaiya,Uttar Pradesh',
    'Sabalgarh,Sabalgarh,Madhya Pradesh',
    'Sabarmati Bridge,Ahmedabad,Gujarat',
    'Sabarmati Junction,Ahmedabad,Gujarat',
    'Sabarmati South,Ahmedabad,Gujarat',
    'Sabaur,Bhagalpur,Bihar',
    'Sabroom,Paschim Jalefa,Tripura',
    'Sachin,Surat,Gujarat',
    'Sadar Bazar,New Delhi,Delhi',
    'Sadat,Sadat,Uttar Pradesh',
    'Sadhoo Garh,Fatak Majri,Punjab',
    'Sadisopur,Bazidpur,Bihar',
    'Sadulpur Junction,Churu,Rajasthan',
    'Sadulshahr,Ganganagar,Rajasthan',
    'Safdarjung,New Delhi,Delhi',
    'Safedabad,Safedabad,Uttar Pradesh',
    'Sagardighi,Murshidabad,West Bengal',
    'Sagar Jambagaru,Sagar,Karnataka',
    'Sagarpali,Bijora,Uttar Pradesh',
    'Sagauli Junction,Sugauli,Bihar',
    'Sagoni,Kitni Murwara,Madhya Pradesh',
    'Saharanpur Junction,Saharanpur,Uttar Pradesh',
    'Saharsa Junction,Saharsa,Bihar',
    'Sahatwar,Baghaw,Uttar Pradesh',
    'Sahawar Town,Sahawar,Uttar Pradesh',
    'Sahibabad Junction,Ghaziabad,Uttar Pradesh',
    'Sahibganj Junction,Sahibganj,Jharkhand',
    'Sahibpur Kamal Junction,Begusarai,Bihar',
    'Sahjanwa,Sahjanwa,Uttar Pradesh',
    'Sri Sathya Sai Prasanthi Nilayam,Mamillakunta,Andhra Pradesh',
    'Saidkhanpur,Hamidnagar,Uttar Pradesh',
    'Saidraja,Saiyadraja,Uttar Pradesh',
    'Sainthia,Sainthia,West Bengal',
    'Saiyid Sarawan,Saiyed Sarawan,Uttar Pradesh',
    'Sajanvar Road,Sajanvar,Gujarat',
    'Sajiyavadar,Amreli,Gujarat',
    'Sakaldiha,Tenwar,Uttar Pradesh',
    'Sakharayapatna,Sakrepatna,Karnataka',
    'Sakhi Gopal,Puri,Odisha',
    'Sakhoti Tanda,Sakoti,Uttar Pradesh',
    'Sakhpur,Sukhpur,Gujarat',
    'Sakleshpur,Sakleshpur,Karnataka',
    'Sakri Junction,Bramhpur,Bihar',
    'Saktesgarh,Mirzapur,Uttar Pradesh',
    'Sakti,Sakti,Chhattisgarh',
    'Salakati,Kokrajhar,Assam',
    'Salamatpur,Salamatpur,Madhya Pradesh',
    'Salar,Salar,West Bengal',
    'Salarpur,Jaganpur,Uttar Pradesh',
    'Salawas,Jodhpur,Rajasthan',
    'Salchapra,Srikona Part 3,Assam',
    'Salekasa,Salekasa,Maharashtra',
    'Salem Junction,Salem,Tamil Nadu',
    'Salem Market,Salem,Tamil Nadu',
    'Salem Town,Salem,Tamil Nadu',
    'Salemgarhmasani,Hanumangarh,Rajasthan',
    'Salempur Junction,Salempur,Uttar Pradesh',
    'Salogra,Salogra,Himachal Pradesh',
    'Salona,Salona,Assam',
    'Salpura,Baran,Rajasthan',
    'Salur,Vizianagaram,Andhra Pradesh',
    'Salwa,Salwa,Maharashtra',
    'Samaguri,Kuruabahi,Assam',
    'Samakhiali,Ahmedabad,Gujarat',
    'Samakhiali B G,Ahmedabad,Gujarat',
    'Samalkha,Samalkha,Haryana',
    'Samalpatti,Krishnagiri,Tamil Nadu',
    'Samalkot Junction,East Godavari,Andhra Pradesh',
    'Samastipur Junction,Samastipur,Bihar',
    'Samba,Samba,Jammu And Kashmir',
    'Sambalpur,Sambalpur,Odisha',
    'Sambalpur Road,Jharsuguda,Odisha',
    'Sambhar Lake,Jaipur,Rajasthan',
    'Samdhari Junction,Barmer,Rajasthan',
    'Samlaya Junction,Pratapnagar,Gujarat',
    'Sampla,Sampla,Haryana',
    'Samrau,Jodhpur,Rajasthan',
    'Samsi,Malda,West Bengal',
    'Sanehwal,Ludhiana,Punjab',
    'Sanand,Ahmedabad,Gujarat',
    'Sanaura,Jalandhar,Punjab',
    'Sanawad,Khargone,Madhya Pradesh',
    'Sanchi,Raisen,Madhya Pradesh',
    'Sandal Kalan,Sandal Kalan,Haryana',
    'Sandila,Hardoi,Uttar Pradesh',
    'Sanathnagar,Hyderabad,Telangana',
    'Sandhurst Road,Mumbai,Maharashtra',
    'Saneh Road,Jafrabad,Uttar Pradesh',
    'Sanganapur,Singnapur,Maharashtra',
    'Sanganer,Jaipur,Rajasthan',
    'Sangar,Jammu,Jammu And Kashmir',
    'Sangaria,Hanumangarh,Rajasthan',
    'Sangat,Bathinda,Punjab',
    'Sangli,Sangli,Maharashtra',
    'Sangmeshwar Road,Sangameshwar,Maharashtra',
    'Sangola,Sangola,Maharashtra',
    'Sangrampur,South 24 Parganas,West Bengal',
    'Sangrana Sahib,Gurwali,Punjab',
    'Sangrur,Sangrur,Punjab',
    'Sanichara,Piparseva,Madhya Pradesh',
    'Sanjan,Valsad,Gujarat',
    'Sankarankovil,Sankarankoil,Tamil Nadu',
    'SankariDurg,Narappanchavadi,Tamil Nadu',
    'Sankval,South Goa,Goa',
    'Sanosara Nandra,Vavdi,Gujarat',
    'Sanosra,Bhavnaagr,Gujarat',
    'Sanpada,Navi Mumbai,Maharashtra',
    'Sant Road,Saliya,Gujarat',
    'Santacruz,Mumbai,Maharashtra',
    'Santaldih,Bagra P,West Bengal',
    'Santalpur,Patan,Gujarat',
    'Santragachi Junction,Howrah,West Bengal',
    'Santir Bazar,Gardang,Tripura',
    'Sanvordam Curchorem,Curchorem,Goa',
    'Sanvatsar,Ahmadnagar,Maharashtra',
    'Sanvrad,Sanvrad,Rajasthan',
    'Sapatgram,Balapara 2,Assam',
    'Saphale,Palghar,Maharashtra',
    'Saradhna,Saradhana,Rajasthan',
    'Sarai Chandi,Chaqsaban,Uttar Pradesh',
    'Sarai Harkhu,Sarai Harkhu,Uttar Pradesh',
    'Sarai Kansrai,Barana,Uttar Pradesh',
    'Sarai Mir,Sarai Meer,Uttar Pradesh',
    'Sarai Rani,Pali,Rajasthan',
    'Sarangpur,Rajgarh,Madhya Pradesh',
    'Sardarnagar,Ramnagar Karjaha,Uttar Pradesh',
    'Sardarshahr,Sardarshahr,Rajasthan',
    'Sardiha,Dhadkinala,West Bengal',
    'Sareigram,Sarai,Madhya Pradesh',
    'Sareri,Sareri,Rajasthan',
    'Sarkoni,Kadeepur,Uttar Pradesh',
    'Sarnath,Varanasi,Uttar Pradesh',
    'Sarojini Nagar,New Delhi,Delhi',
    'Sarola,Sarola,Maharashtra',
    'Sarotra Road,Banas Kantha,Gujarat',
    'Sarsawa,Saharanpur,Uttar Pradesh',
    'Sarupathar,Sarupathar,Assam',
    'Sarwari,jalna,Maharashtra',
    'Sasan Gir,Gir Somnath,Gujarat',
    'Sasaram,Rohtas,Bihar',
    'Sasni,Virra,Uttar Pradesh',
    'Satadhar,Junagadh,Gujarat',
    'Satara,Satara,Maharashtra',
    'Sathajagat,Gobindpur Part,Bihar',
    'Sathiaon,Satiyava,Uttar Pradesh',
    'Sathin Road,Bhundana,Rajasthan',
    'Satna,Jabalpur,Madhya Pradesh',
    'Satnali,Bhiwani,Haryana',
    'Satuna,Satuna,Maharashtra',
    'Satur,Sattur,Tamil Nadu',
    'Saugor,Sagar,Madhya Pradesh',
    'Savarda,Savarde,Maharashtra',
    'Savarkundla,Amreli,Gujarat',
    'Savda,Savda,Maharashtra',
    'Sawai Madhopur,Sawai Madhopur,Rajasthan',
    'Sawantwadi Road,Niravade,Maharashtra',
    'Sealdah,Kolkata,West Bengal',
    'Seawoods-Darave,Navi Mumbai,Maharashtra',
    'Secunderabad Junction,Secunderabad,Telangana',
    'Sehore,Sehore,Madhya Pradesh',
    'Sehramau,Jograjpur,Uttar Pradesh',
    'Selu,Sailu,Maharashtra',
    'Semarkheri,Agasod,Madhya Pradesh',
    'Senapura,Udupi,Karnataka',
    'Senchoa Junction,Garikuri Bebejia,Assam',
    'Sendra,Sabalpura,Rajasthan',
    'Sengottai,Viswanathapuram,Tamil Nadu',
    'Seohara,Seohara,Uttar Pradesh',
    'Seoraphuli,Kolkata,West Bengal',
    'Seram,Kalaburagi,Karnataka',
    'Serampore,Hooghly,West Bengal',
    'Settihally,Settihalli,Karnataka',
    'Sevagram,Wardha,Maharashtra',
    'Sevaliya,Sevaliya,Gujarat',
    'Sewapuri,Gopal Pur,Uttar Pradesh',
    'Sewri,Mumbai,Maharashtra',
    'Shadhoragaon,Jhagar,Madhya Pradesh',
    'Shahabad,Kalaburagi,Karnataka',
    'Shahad,Mumbai,Maharashtra',
    'Saharsa Junction,Saharsa,Bihar',
    'Shahbad Markanda,Shahbad,Haryana',
    'Shahbad Mohammadpur,New Delhi,Delhi',
    'Shahdol,Shahdol,Madhya Pradesh',
    'Shahganj Junction,Shahganj,Uttar Pradesh',
    'Shahjehanpur,Shahjahanpur,Uttar Pradesh',
    'Shahpur Patoree,Tara Dhamaun,Bihar',
    'Shahzad Nagar,Faizullah Nagar,Uttar Pradesh',
    'Shajahanpur court,Shahjahanpur,Uttar Pradesh',
    'Shajapur,Shajapur,Madhya Pradesh',
    'Shakti Nagar,Sonbhadra,Uttar Pradesh',
    'Shakurbasti,North Delhi,Delhi',
    'Shambhupura,Chittaurgarh,Rajasthan',
    'Shamgarh,Mandsaur,Madhya Pradesh',
    'Shamlaji Road,Lalpur,Gujarat',
    'Shankargarh,Chundwa,Uttar Pradesh',
    'Shankarpalli,Hyderabad,Telangana',
    'Shantipur,Kolkata,West Bengal',
    'Shapur Sorath Junction,Junagadh,Gujarat',
    'Sharma,Jharsa Alampur,Uttar Pradesh',
    'SHDSPRA PADMPRA,Malwa,Rajasthan',
    'Shedbal,Barakotri,Maharashtra',
    'Shegaon,Shegaon,Maharashtra',
    'Sheikpura,Sheikhpura,Bihar',
    'Shelu,Mumbai,Maharashtra',
    'Shendri,Solapur,Maharashtra',
    'Shenoli,Shenoli,Maharashtra',
    'Sheo Singh Pura,Keshyawala,Rajasthan',
    'Sheopur Kalan,Sheopur,Madhya Pradesh',
    'Sherekan,Hanumangarh,Rajasthan',
    'Shertalai,Alappuzha,Kerala',
    'Shikohabad Junction,Firozabad,Uttar Pradesh',
    'Shimla,Shimla,Himachal Pradesh',
    'Shimoga,Shimoga,Karnataka',
    'Shimoga Town,Shimoga,Karnataka',
    'Shirdi ,Shirdi ,Maharashtra',
    'Shiribagilu,Shiribagilu,Kerala',
    'Shiroor,Shiroor,Karnataka',
    'Shirravde,Satara,Maharashtra',
    'Shirsoli,Jalgaon,Maharashtra',
    'Shiupur,Varanasi,Uttar Pradesh',
    'Shivamogga,Shivamogga,Karnataka',
    'Shivarampur,Satauli,Uttar Pradesh',
    'Shivnagar,Maniari Aliganj,Uttar Pradesh',
    'Shivni Shivapur,Shivani,Maharashtra',
    'Shivpuri,Shivpuri,Madhya Pradesh',
    'Shivrampur,Varanasi,Uttar Pradesh',
    'Shivaji Bridge,New Delhi,Delhi',
    'Shoghi,Shoghi,Himachal Pradesh',
    'Shohratgarh,Siddharthnagar,Uttar Pradesh',
    'Sholapur CB,Solapur,Maharashtra',
    'Sholavandan,Madurai,Tamil Nadu',
    'Shoranur Junction,Palakkad,Kerala',
    'Shri Amirgadh,Banaskantha,Gujarat',
    'Shri Ganganagar,Shri Ganganagar,Rajasthan',
    'Shri Karanpur,Srikaranpur,Rajasthan',
    'Shri Madhopur,Sikar,Rajasthan',
    'Shri Mahabirji,Pataunda,Rajasthan',
    'Shri Mata Vaishno Devi Katra,Katra,Jammu and Kashmir',
    'Shridham,Gotegaon,Madhya Pradesh',
    'Shrigonda Road,Ahmadnagar,Maharashtra',
    'Shrikalyanpura,Kareerka Khe,Rajasthan',
    'ShriKshetra Nagzari,Unhalkhed,Maharashtra',
    'Shrirajnagar,Rae Bareli,Uttar Pradesh',
    'Shrirangapatna,Mandya,Karnataka',
    'Shrivagilu,Mysore,Karnataka',
    'Shujaatpur,Shayara Meethepur,Madhya Pradesh',
    'Shujalpur,Shujalpur,Madhya Pradesh',
    'Shyamnagar,Kolkata,West Bengal',
    'Siajuli,Bokanala No.2,Assam',
    'Sibsagar Town,Sivasagar,Assam',
    'Siddhpur,Patan,Gujarat',
    'Sidhauli,Sidhauli,Uttar Pradesh',
    'Sidmukh,Sidmukh,Rajasthan',
    'Sihapar,Bhiti Rawot,Uttar Pradesh',
    'Siho,Muzaffarpur,Bihar',
    'Sihor Gujarat,Bhavnagar,Gujarat',
    'Sihora Road,Sihora,Gujarat',
    'Sikandarpur,Samaspur,Uttar Pradesh',
    'Sikandra Rao,Hathras,Uttar Pradesh',
    'Sikar Junction,Sikar,Rajasthan',
    'Sikir,Sikar,Rajasthan',
    'Silanibari,Lakhimpur,Assam',
    'Silao,Nalanda,Bihar',
    'Silapathar,Silapathar,Assam',
    'Silaut,Raghunathpur,Bihar',
    'Silchar,Silchar,Assam',
    'Siliguri Junction,Darjeeling,West Bengal',
    'Siliguru Town,Darjeeling,West Bengal',
    'Silli,Lupung,Jharkhand',
    'Simaluguri Junction,Simolu Guri Town,Assam',
    'Simaria,begusaria,Bihar',
    'Simbhooli,Gordhanpur,Uttar Pradesh',
    'Simen Chapari,Dhemaji,Assam',
    'Simhachalam,Visakhapatnam,Andhra Pradesh',
    'Simlagarh,Kolkata,West Bengal',
    'Simultala,Jamui,Bihar',
    'Simurali,Nadia,West Bengal',
    'Sindhudurg,Oros,Maharashtra',
    'Sindi,Wardha,Maharashtra',
    'Sindkheda,Dhule,Maharashtra',
    'Sindpan,Burhanpur ,Madhya Pradesh',
    'Sindri Town,Sindri,Jharkhand',
    'Sindurwa,Utelwa,Uttar Pradesh',
    'Singanallur ,Coimbatore,Tamil Nadu',
    'Singapur Road,Jaykaypur,Andhra Pradesh',
    'Singarayakonda,Prakasam,Andhra Pradesh',
    'Singareni Colleries,Bhadradri Kothagudem,Telangana',
    'Singarpur,Korai,Uttar Pradesh',
    'Singrauli,Singrauli,Madhya Pradesh',
    'Singwal,Gowaliya,Rajasthan',
    'Sini Junction,Sohandih,Jharkhand',
    'Sion,Mumbai,Maharashtra',
    'Siras,Wazeerabad,Rajasthan',
    'Sirathu,Sirathu,Uttar Pradesh',
    'Sirhind Junction,Fatehgarh Sahib,Punjab',
    'Sirkazhi,Nagapattinam,Tamil Nadu',
    'Sirli,Sirli,Maharashtra',
    'Sirohi Road,Sirohi,Rajasthan',
    'Sirpur Kaghaznagar,Kaghaznagar,Telangana',
    'Sirpur Town,Sirpur,Telangana',
    'Sirran,khandwa,Madhya Pradesh',
    'Sirsa,Sirsa,Haryana',
    'Sisarka,Pipariya,Uttar Pradesh',
    'Sisvinhalli,Bennur,Karnataka',
    'Siswa Bazar,Siswa Bazar,Uttar Pradesh',
    'Sitamarhi,Sitamarhi,Bihar',
    'Sitapur,Sitapur,Uttar Pradesh',
    'Sitapur Cantonment,Sitapur,Uttar Pradesh',
    'Sitapur City,Sitapur,Uttar Pradesh',
    'Sitarampur,Paschim Bardhaman,West Bengal',
    'Sithalavai,Krishnarayapuram,Tamil Nadu',
    'Sithouli,Gwalior,Madhya Pradesh',
    'Sitimani,Bagalkot,Karnataka',
    'Sivaganga,Madurai,Tamil Nadu',
    'Sivajinagar,Pune,Maharashtra',
    'Sivakasi,Virudhunagar,Tamil Nadu',
    'Siwaith,Siwaith,Uttar Pradesh',
    'Siwan Junction,Siwan,Bihar',
    'Siwani,Siwani,Haryana',
    'Sodepur,Kolkata,West Bengal',
    'Sogariya,Kota,Rajasthan',
    'Sohagpur,Hoshangabad,Madhya Pradesh',
    'Sohwal,Faizabad,Uttar Pradesh',
    'Sojat Road,Pali,Rajasthan',
    'Sojitra,Anand,Gujarat',
    'Solan,Solan,Himachal Pradesh',
    'Solan Brewery,Solan,Himachal Pradesh',
    'Solapur Junction,Solapur,Maharashtra',
    'Somanur,Somanur,Tamil Nadu',
    'Somesar,Somesar,Rajasthan',
    'Somna,Aligarh,Uttar Pradesh',
    'Somnath,Bhavnagar,Gujarat',
    'Sompeta,Kanchili,Andhra Pradesh',
    'Son Nagar,Aurangabad,Bihar',
    'Sonagir,Mahewa,Madhya Pradesh',
    'Sonarpur Junction,Kolkata,West Bengal',
    'Sondha Road,Sondha,Madhya Pradesh',
    'Sonegaon,Wardha,Maharashtra',
    'Songadh,Bhavnagar,Gujarat',
    'Soni,Soni,Madhya Pradesh',
    'Sonik,Sarai Katiyan,Uttar Pradesh',
    'Sonipat Junction,Sonipat,Haryana',
    'Sonpur Junction,Sonepur,Bihar',
    'Sonwara,Sanwara,Himachal Pradesh',
    'Sorbhog Junction,Bongaigaon,Assam',
    'Sorupeta,Gerua Para,Assam',
    'Soro,Soro,Odisha',
    'Soron,Kasganj,Uttar Pradesh',
    'Sri Dungargarh,Pundalsar,Rajasthan',
    'Sri Kalahasti,Srikalahasti,Andhra Pradesh',
    'Srikakulam Road,Amadalavalasa,Andhra Pradesh',
    'Srikrishna Nagar,Jaunpur,Uttar Pradesh',
    'Sriramnagar,Mahbubnagar,Andhra Pradesh',
    'Srirampur,Mathuraberia,West Bengal',
    'Srirangam,Tiruchirappalli,Tamil Nadu',
    'Srivilliputtur,Virudhunagar,Tamil Nadu',
    'Subansiri,Rajgarh Rupahi,Assam',
    'Subedarganj,Allahabad,Uttar Pradesh',
    'Subrahmanya Road,Dakshina Kannada,Karnataka',
    'Subzi Mandi,New Delhi,Delhi',
    'Suchipind,Jalandhar,Punjab',
    'Sudsar,Derajsar,Rajasthan',
    'Sujangarh,Churu,Rajasthan',
    'Sujanpur,Pathankot,Punjab',
    'Sukhisewaniyan,Sukhisewaniyan,Madhya Pradesh',
    'Sukhpar Roha,Kachchh,Gujarat',
    'Sukhpur,Junagadh,Gujarat',
    'Sukritipur,Jagadishpur Part 3,Assam',
    'Suladhal,Gujanal,Karnataka',
    'Sulah,Raipur Khas,Himachal Pradesh',
    'Sulgare,Sangli,Maharashtra',
    'Sullurupeta,Nellore,Andhra Pradesh',
    'Sultanganj,Bhagalpur,Bihar',
    'Sultanpur,Sultanpur,Uttar Pradesh',
    'Sultanpur Lodi,Sultanpur Lodhi,Punjab',
    'Sulur Road ,Coimbatore,Tamil Nadu',
    'Sumer,Sumerbarri,Madhya Pradesh',
    'Summadevi,Srikakulam,Andhra Pradesh',
    'Summer Hill,Shimla,Himachal Pradesh',
    'Sumreri,Sagar,Madhya Pradesh',
    'Sunam,Sangrur,Punjab',
    'Sundaraperumal Koil,Vellalapillayampettai,Tamil Nadu',
    'Sunderabad,Secunderabad,Telangana',
    'Sundlak,Rajpura,Rajasthan',
    'Supaul,Supaul,Bihar',
    'Suraimanpur,Ballia,Uttar Pradesh',
    'Surajgarh,Jhunjhunu,Rajasthan',
    'Surajpur,Unchdih,Chhattisgarh',
    'Surajpur Road,Unchdih,Chhattisgarh',
    'Surat,Surat,Gujarat',
    'Suratgarh Junction,Sri Ganganagar,Rajasthan',
    'Surathkal,Mangalore,Karnataka',
    'Suravali,South Goa,Goa',
    'Sureli,Tonk,Rajasthan',
    'Surendranagar,Rajkot,Gujarat',
    'Suriawan,Suriyawa,Uttar Pradesh',
    'Surla Road,Ganjam,Odisha',
    'Surpura,Surpura,Rajasthan',
    'Suwansa,Baimrpur,Uttar Pradesh',
    'Suwasra,Mandsaur,Madhya Pradesh',
    'Swamimalai,Kumbakonam,Tamil Nadu',
    'Swarupganj,Sirohi,Rajasthan',
    'Tadali,Chandrapur,Maharashtra',
    'Tadepalligudem,West Godavari,Andhra Pradesh',
    'Tadipatri,Nandalapadu Rural,Andhra Pradesh',
    'Tadwal,Bijapur,Maharashtra',
    'Tahsil Bhadra,Hanumangarh,Rajasthan',
    'Tahsil Fatehpur,Fatehpur,Uttar Pradesh',
    'Tajpur,Tajpur,Madhya Pradesh',
    'Tajpur Dehma,Gosalpur Road,Uttar Pradesh',
    'Tamluk,Tamluk,West Bengal',
    'Tamuriya,Tamuriya,Bihar',
    'Takal,Piplod Khas,Maharashtra',
    'Takari,Sangli,Maharashtra',
    'Takarkhede,Kurhe Kh,Maharashtra',
    'Takia,Takiya,Uttar Pradesh',
    'Taksal,Parwanoo,Himachal Pradesh',
    'Taku,Taku,Madhya Pradesh',
    'Talaiyuthu,Sankarnagar,Tamil Nadu',
    'Talara,Kangra,Himachal Pradesh',
    'Talakhajuri,Amethi,Uttar Pradesh',
    'Talala Junction,Talala,Gujarat',
    'Talvadiya Junction,Khandwa,Madhya Pradesh',
    'Talbahat,Khandi,Uttar Pradesh',
    'Talcher,Talcher,Odisha',
    'Talchhapar,Churu,Rajasthan',
    'Talegaon Dabhade,Pune,Maharashtra',
    'Talguppa,Talaguppa,Karnataka',
    'Talheri Buzurg,Manoharpur,Uttar Pradesh',
    'Talli Saidasahu,Arifke,Punjab',
    'Talod,Sabar Kantha,Gujarat',
    'Taloja,Navi Mumbai,Maharashtra',
    'Talwandi,Talwandi Bhai,Punjab',
    'Tambaram,Chennai,Tamil Nadu',
    'Tamkuhi Road,Kushinagar,Uttar Pradesh',
    'Tanakpur,Champawat,Uttarakhand',
    'Tanda Urmar,Urmar Tanda,Punjab',
    'Tandur,Vikarabad,Telangana',
    'Tangla,Udalguri,Assam',
    'Tangra,Tangra,West Bengal',
    'Tankuppa,Ichoi,Bihar',
    'Tanuku,West Godavari,Andhra Pradesh',
    'Tanur,Malappuram,Kerala',
    'Tapa,Mandi,Punjab',
    'Tapri,Saharanpur,Uttar Pradesh',
    'Tarabari,Barpaka,Assam',
    'Taradevi,shimla,Himachal Pradesh',
    'Tarak Nagar,Nadia,West Bengal',
    'Tarana Road,Ujjain,Madhya Pradesh',
    'Taranga Hill,Mehsana,Gujarat',
    'Taraori,Taraori,Haryana',
    'Taregna,Kumahartoli,Bihar',
    'Targaon,Satara,Maharashtra',
    'Tarighat,Gangbarar Tari,Uttar Pradesh',
    'Tarlupadu,Tellapadu,Andhra Pradesh',
    'Tarn Taran,Tarn Taran Sahib,Punjab',
    'Tarsai,Tarsai,Gujarat',
    'Tatanagar Junction,Jamshedpur,Jharkhand',
    'Tatibahar,Lakhimpur,Assam',
    'Tatisilwai,Ranchi,Jharkhand',
    'Teghra,Chakdad,Bihar',
    'Teharka,Tikamgarh,Madhya Pradesh',
    'Telam,Arun Chapori,Assam',
    'Tellicherry,Thalassery,Kerala',
    'Tenali Junction,Tenali,Andhra Pradesh',
    'Theni,Allinagaram,Tamil Nadu',
    'Tenkasi,Chennai,Tamil Nadu',
    'Tenmalai,Tenmalai,Tamil Nadu',
    'Tetelia,Helagog,Assam',
    'Tetulmari,Nagri Kalan,Jharkhand',
    'Tezpore,Sonitpur,Assam',
    'Thakurkuchi,Chandrapur Bagicha,Assam',
    'Thakurli,Mumbai,Maharashtra',
    'Than Junction,Thangadh,Gujarat',
    'Thana Bihpur Junction,Bhagalpur,Bihar',
    'Thandla Rd,Sajeli Damanasath,Madhya Pradesh',
    'Thane,Thane,Maharashtra',
    'Thanjavur Junction,Thanjavur,Tamil Nadu',
    'Thathana Mithri,Palri,Rajasthan',
    'Thawe Junction,Gopalganj,Bihar',
    'Thekeraguri,Morakolong,Assam',
    'Therubali,Relibadigam,Odisha',
    'Thrissur,Thrissur,Kerala',
    'Trivandrum Central,Thiruvananthapuram,Kerala',
    'Thirumullaivoyal,Chennai,Tamil Nadu',
    'Thiruninravur,Thiruvenkada Nagar,Tamil Nadu',
    'Thiruvananthapuram Pettah,Thiruvananthapuram,Kerala',
    'Thoothukudi Melur,Thoothukudi,Tamil Nadu',
    'Thoothukudi,Thoothukudi,Tamil Nadu',
    'Thiruvarur Junction,Thiruvarur,Tamil Nadu',
    'Tiruvallur,Periyakuppam,Tamil Nadu',
    'Thivim,Sircaim,Goa',
    'Thokur,Mangalore,Karnataka',
    'Thuria,Dhaturiya,Madhya Pradesh',
    'Tibi,Dahiya,Rajasthan',
    'Tihu,Nalbari,Assam',
    'Tikaria,Mangawan,Uttar Pradesh',
    'Tikekarwadi,Solapur,Maharashtra',
    'Tikunia,Barsola Kalan,Uttar Pradesh',
    'Tilak Bridge,New Delhi,Delhi',
    'Tilak Nagar,Mumbai,Maharashtra',
    'Tilaru,Tilaru,Andhra Pradesh',
    'Tilaiya,Nawada,Bihar',
    'Tilda,Raipur,Chhattisgarh',
    'Tilhar,Tilhar,Uttar Pradesh',
    'Tilrath,Milki Zamira,Bihar',
    'Tilwara,Barmer,Rajasthan',
    'Timarni,Timarni,Madhya Pradesh',
    'Timba Road,Tulsigam,Gujarat',
    'Timmapur,Karimnagar,Telangana',
    'Tinai Ghat,Castlerock,Karnataka',
    'Tindivanam,Viluppuram,Tamil Nadu',
    'Tinpahar Junction,Sahibganj,Jharkhand',
    'Tinsukia Junction,Tinsukia,Assam',
    'Tipkai,Kokrajhar,Assam',
    'Tipling,Harmuti,Assam',
    'Tiptur,Tiptur,Karnataka',
    'Tiruchirapalli Fort,Tiruchirappalli,Tamil Nadu',
    'Tirodi,Balaghat,Madhya Pradesh',
    'Tirora,Bhandara,Maharashtra',
    'Tiruchirapalli Junction,Tiruchirappalli,Tamil Nadu',
    'Tiruchendur,Thoothukudi,Tamil Nadu',
    'Tiruchirapalli Palakkarai,Tiruchirappalli,Tamil Nadu',
    'Tirukoilur,Kottamarudur,Tamil Nadu',
    'Tirumangalam,Tirumangalam,Tamil Nadu',
    'Tirunagesvaram,Thepperumanallur,Tamil Nadu',
    'Tirunelveli Junction,Tirunelveli,Tamil Nadu',
    'Tirupadripuliyur,Cuddalore,Tamil Nadu',
    'Tirupati,Tirupati,Andhra Pradesh',
    'Tirupattur Junction,Tirupattur,Tamil Nadu',
    'Tiruppappuliyur,Cuddalore,Tamil Nadu',
    'Tiruppur,Tiruppur,Tamil Nadu',
    'Tirur,Malappuram,Kerala',
    'Tiruttani,Thiruttani,Tamil Nadu',
    'Tiruttangal,Virudhunagar,Tamil Nadu',
    'Tiruturaipundi Junction,Thiruvallur,Tamil Nadu',
    'Tiruvalla,Pathanamthitta,Kerala',
    'Tiruvannamalai ,Tiruvannamalai,Tamil Nadu',
    'Tiruverumbur,Tiruchirappalli,Tamil Nadu',
    'Tiruvidaimarudur,Thiruvidaimaruthur,Tamil Nadu',
    'Tiruvottiyur,Chennai,Tamil Nadu',
    'Tisi,Tishi,Maharashtra',
    'Tisua,Galsthua,Uttar Pradesh',
    'Titabar,Handique Gaon,Assam',
    'Titlagarh,Balangir,Odisha',
    'Titlagarh Junction,Balangir,Odisha',
    'Titwala,Titwala,Maharashtra',
    'Tivari,Jodhpur,Rajasthan',
    'Todarpur,Hardoi,Uttar Pradesh',
    'Tohana,Tohana,Haryana',
    'Toranagallu,Ballari,Karnataka',
    'Tori,Chandwa,Jharkhand',
    'Trichur,Trichur,Kerala',
    'Trikarpur,Kasaragod,Kerala',
    'Trilochan Mahdo,Dingurpur,Uttar Pradesh',
    'Tripunittura,Ernakulam,Kerala',
    'Tondiarpet,Chennai,Tamil Nadu',
    'Tsunduru,Tsunduru,Andhra Pradesh',
    'Tughlakabad,Tughlakabad,Delhi',
    'Tukaithad,Burhanpur,Maharashtra',
    'Tulsipur,Balrampur,Uttar Pradesh',
    'Tulwara Jhil,Tulwara Jhil,Rajasthan',
    'Tumkur,Tumakuru,Karnataka',
    'Tumsar Road,Stationtoli,Maharashtra',
    'Tundla Junction,Tundla,Uttar Pradesh',
    'Tuni,East Godavari,Andhra Pradesh',
    'Turbhe,Navi Mumbai,Maharashtra',
    'Turtipar,Ishrauli,Uttar Pradesh',
    'Tuwa,Panch Mahals,Gujarat',
    'Twining Ganj,Kumbhi,Bihar',
    'Tada,Tada,Andhra Pradesh',
    'Ubarni,Bela Khara,Uttar Pradesh',
    'Uchana,Jind,Haryana',
    'Uchippuli,Uchipuli,Tamil Nadu',
    'Udagamandalam,Ooty,Tamil Nadu',
    'Udaipur City,Gomati,Rajasthan',
    'Udaipur Khurd Halt,Udaipur Kalan,Uttar Pradesh',
    'Udaipur Tripura,Murapara part,Tripura',
    'Udaipura,Mirchwara,Uttar Pradesh',
    'Udairampur,Udairampur,West Bengal',
    'Udalguri,Odalguri,Assam',
    'Udalkachar,Udalkachar,Chhattisgarh',
    'Udasar,Udashar Charanan,Rajasthan',
    'Udgir,Udgir,Maharashtra',
    'Udhampur,Udhampur,Jammu & Kashmir',
    'Udhna Junction,Surat,Gujarat',
    'Udramsar,Udramsar,Rajasthan',
    'Udupi,Udupi,Karnataka',
    'Udvada,Rentlav,Gujarat',
    'Udwantnagar Halt,Patar,Bihar',
    'Udyankheri,Udankhedi,Madhya Pradesh',
    'Ugaon,Nashik,Maharashtra',
    'Ugar Khurd,Belgaum,Karnataka',
    'Ugarpur,Pipar Gaon,Uttar Pradesh',
    'Ugna Halt,Bhawanipur,Bihar',
    'Ugrasenpur,Jaunpur,Uttar pradesh',
    'Ugu,Daroli,Uttar Pradesh',
    'Ugwe,Akola,Maharashtra',
    'Ujalvav,Ramanka,Gujarat',
    'Ujhani,Budaun,Uttar Pradesh',
    'Ujiarpur,Ujiarpur,Bihar',
    'Ujjain Junction,Ujjain,Madhya Pradesh',
    'Ukai Songadh,Songadh,Gujarat',
    'Ukhali,Ukhali,Maharashtra',
    'Ukhra,Paschim Bardhaman,West Bengal',
    'Ukilerhat Halt,Bishalakshmipur,West Bengal',
    'Uklana,Budha Khera,Haryana',
    'Ukshi,Ratnagiri,Maharashtra',
    'Ulavapadu,Ulavapadu,Andhra Pradesh',
    'Ulhasnagar,Ulhasnagar,Maharashtra',
    'Ulindakonda,Chetla Mallapuram,Andhra Pradesh',
    'Ullal,Dakshina Kannada,Karnataka',
    'Ulnabhari,Ratanpur,Uttar Pradesh',
    'Ulubaria,Howrah,West Bengal',
    'Ulundurpet,Kallakurichi,Tamil Nadu',
    'Umar Tali,Mahsona,Uttar Pradesh',
    'Umardashi,Sedrasana,Gujarat',
    'Umaria,Umaria,Madhya Pradesh',
    'Umariaispah Halt,Chhindwara,Madhya Pradesh',
    'Umarpada,Umarpada,Gujarat',
    'Umbargam Road,Valsad,Gujarat',
    'Umdanagar,Hyderabad,Telangana',
    'Umed,Umed,Rajasthan',
    'Umeshnagar,Chawki,Bihar',
    'Umra,Udaipur,Rajasthan',
    'Umranala,Umranala,Madhya Pradesh',
    'Umram,Umram,Andhra Pradesh',
    'Umred,Umred,Maharashtra',
    'Umreth,Umreth,Gujarat',
    'Umri,Bhandara,Maharashtra',
    'Umroli,old Thane,Maharashtra',
    'Una,Una,Gujarat',
    'Una Himachal,Una,Himachal Pradesh',
    'Unai Vansada Rd,Unai,Gujarat',
    'Unaula,Unaula Awal,Uttar Pradesh',
    'Unchahar Junction,Rae Bareli,Uttar Pradesh',
    'Unchaulia,Uncholia,Uttar Pradesh',
    'Unchdih,Jabalpur,Uttar Pradesh',
    'Unchhera,Satna,Madhya Pradesh',
    'Unchi Bassi,Unchi Bassi,Punjab',
    'Undasa Madhawpu,Madhopur,Madhya Pradesh',
    'Undi,Undi,Andhra Pradesh',
    'Unguturu,Unguturu,Andhra Pradesh',
    'Unhel,Ujjain,Madhya Pradesh',
    'Unjalur,Unjalur,Tamil Nadu',
    'Unjha,Mahesana,Gujarat',
    'Unkal,Hubli,Uttar Pradesh',
    'Unnao Junction,Unnao,Uttar Pradesh',
    'Untare Road,Sirha,Jharkhand',
    'Uplai,Khandavi,Maharashtra',
    'Upleta,Rajkot,Gujarat',
    'Uppal,Warangal Urban,Telangana',
    'Uppala,Kasaragod,Kerala',
    'Uppalavai,Uppalwai,Telangana',
    'Uppalur,Nidamanuru,Andhra Pradesh',
    'Uppuguda,Hyderabad,Telangana',
    'Uppugunduru,Prakasam,Andhra Pradesh',
    'Urappakkam,Chennai,Tamil Nadu',
    'Urdauli,Urdauli,Uttar Pradesh',
    'Uren,Lakhisarai,Bihar',
    'Urga,Korba,Chhattisgarh',
    'Urkura,Raipur,Chhattisgarh',
    'Urlam,Kothapolavalasa,Andhra Pradesh',
    'Urma,Chhota Urmma,West Bengal',
    'Uruli,Pune,Maharashtra',
    'Usalapur,Bilaspur,Chhattisgarh',
    'Usia Khas,Dildarnagar,Bihar',
    'Uska Bazar,Juthahi,Uttar Pradesh',
    'Usmanpur,Jalna,Maharashtra',
    'Usra,Mangal Mahudi,Gujarat',
    'Utarlai,Barmer,Rajasthan',
    'Utarsanda,Utarsanda,Gujarat',
    'Utrahtia,Lucknow,Uttar Pradesh',
    'Utran,Utran,Gujarat',
    'Utripura,Utripura,Uttar Pradesh',
    'Uttamarkovil,Uttamarkovil,Tamil Nadu',
    'Uttangal Mangalam,Uttangal Mangalam,Tamil Nadu',
    'Uttar Radhanagar Halt,Kolkata,West Bengal',
    'Uttarpara,Hooghly,West Bengal',
    'Uttukuli,Uttukuli,Tamil Nadu',
    'Udumalpettai,Udumalaipettai,Tamil Nadu',
    'V.O.C Nagar,Chennai,Tamil Nadu',
    'Vachaspati Nagar,Andhratharhi ,Bihar',
    'Vadaj,Vadaj,Gujarat',
    'Vadakara,Kozhikode,Kerala',
    'Vadal,Vadal,Gujarat',
    'Vadali,Vadali,Gujarat',
    'Vadali Luter Road,Dantali,Gujarat',
    'Vadalur,Vadalure,Tamil Nadu',
    'Vadamadura,Vadamadurai,Tamil Nadu',
    'Vadanam Kurussi Halt,Palakkad,Kerala',
    'Vadgaon,Vadgaon,Maharashtra',
    'Vadgaon Nila,Parbhani,Maharashtra',
    'Vadhvana,Samsherpura,Gujarat',
    'Vadippatti,Vadippatti,Tamil Nadu',
    'Vadiya Devli,Barvala Baval,Gujarat',
    'Vadlamannadu,Gadepudi,Andhra Pradesh',
    'Vadnagar,Mehsana,Gujarat',
    'Vadod,Vadod,Gujarat',
    'Vadodara Junction,Vadodara,Gujarat',
    'Vadtal Swaminarayan,Vadtal,Gujarat',
    'Vadviyala,Vadviyala,Gujarat',
    'Vagdiya,Vagadiya,Gujarat',
    'Vaghli,Nashik,Maharashtra',
    'Vaibhavwadi Road,Sindhudurg,Maharashtra',
    'Vaikom Road,Kottayam,Kerala',
    'Vailapuzha,Vallapuzha,Kerala',
    'Vaitarna,Kasarali,Maharashtra',
    'Vaitheeswaran Koil,Pullirukkuvelur,Tamil Nadu',
    'Vakav,Solapur,Maharashtra',
    'Valadar,Valadar,Gujarat',
    'Valadi,Tiruchirappalli,Tamil Nadu',
    'Valantaravai,Valantaravai,Tamil Nadu',
    'Valapattanam,Kannur,Kerala',
    'Valappadi G Halt,Vazhapadi,Tamil Nadu',
    'Valaramanikkam,Valarmanickam,Tamil Nadu',
    'Valathoor,Ulli,Tamil Nadu',
    'Valavanur,Valavanur,Tamil Nadu',
    'Valha,Walhe,Maharashtra',
    'Valivade,Kolhapur,Maharashtra',
    'Vallabhnagar,Dungarpur,Rajasthan',
    'Vallabh Vidyanagar,Anand,Gujarat',
    'Vallampadugai,Vallampadugai,Tamil Nadu',
    'Vallathol Nagar,Cheruthuruthi,Kerala',
    'Vallikkunnu,DescriptionVallikkunnu,Kerala',
    'Valliveedu,Bandaruvaripalle,Andhra Pradesh',
    'Valliyur,Valliyur,Tamil Nadu',
    'Valmikinagar Road,Rampurwa,Bihar',
    'Valsad,Valsad,Gujarat',
    'Valyampatti,Malayandipatti,Tamil Nadu',
    'Vambori,Dhamori Kh,Maharashtra',
    'Vandalu,Vandalur,Tamil Nadu',
    'Vangani,Vangani,Maharashtra',
    'Vanganur,Vanganur,Andhra Pradesh',
    'Vangaon,Vangaon,Maharashtra',
    'Vangal,Karur,Tamil Nadu',
    'Vani Road,Dumana,Gujarat',
    'Vanigonda,Vanigonda,Andhra Pradesh',
    'Vaniyambadi,Vaniyambadi,Tamil Nadu',
    'Vaniyambalam,Malapuram,Kerala',
    'Vanji Maniyachi Junction,Thoothukudi,Tamil Nadu',
    'Vankal,Nani Fali,Gujarat',
    'Vapi,Vapi,Gujarat',
    'Varahi,Banaskantha,Gujarat',
    'Varakalpattu,Cuddalore,Tamil Nadu',
    'Varanasi City,Varanasi,Uttar Pradesh',
    'Varanasi Junction,Varanasi,Uttar Pradesh',
    'Varangaon,Jalgaon,Maharashtra',
    'Varediya,Varedia,Gujarat',
    'Varkala,Thiruvananthapuram,Kerala',
    'Varkhedi,Varkhedi Bk,Maharashtra',
    'Varnama,Varnama,Gujarat',
    'Vartej,Bhavnaagr,Gujarat',
    'Varvala,Varvala,Gujarat',
    'Vasad Junction,Vasad,Gujarat',
    'Vasai Road,Mumbai,Maharashtra',
    'Vasan Iyawa,Vasna Iyava,Gujarat',
    'Vasco da Gama,Vasco da Gama,Goa',
    'Vashi,Navi Mumbai,Maharashtra',
    'Vasind,Vasind,Maharashtra',
    'Vaso,Kheda,Gujarat',
    'Vastrapur,Ahmedabad,Gujarat',
    'Vatluru,Vatluru,Andhra Pradesh',
    'Vatva,Ahmedabad,Gujarat',
    'Vavdi,Vavdi,Gujarat',
    'Vavdi Khurd,Panch Mahals,Gujarat',
    'Vavera,Vavera,Gujarat',
    'Vayalar,Ponnamveli,Kerala',
    'Vayalpad,Valmikipuram,Andhra Pradesh',
    'Vazeerpur Halt,Babar,Uttar Pradesh',
    'Vedayapalem,Nellore,Andhra Pradesh',
    'Vedchha,Navsari,Gujarat',
    'Veer,Mahad,Maharashtra',
    'Vejalka,surendranagar,Gujarat',
    'Vejendla,Guntur,Andhra Pradesh',
    'Velachery,Chennai,Tamil Nadu',
    'Velaccha,Velaccha,Gujarat',
    'Veldurti,Veldurthi,Andhra Pradesh',
    'Vellanur,Cauvery Nagar,Tamil Nadu',
    'Vellarakkad,Moodadi,Kerala',
    'Vellayil,Kozhikode,Kerala',
    'Vellipalayem,Vellipalayem,Tamil Nadu',
    'Velliyani,Karur,Tamil Nadu',
    'Vellodu,Narasingapuram Road,Tamil Nadu',
    'Vellore Cantonment,Vellore,Tamil Nadu',
    'Vellore Town,Vellore,Tamil Nadu',
    'Vellur Halt,Pottaveli,Tamil Nadu',
    'Velpuru,Tanuku,Andhra Pradesh',
    'Velpuru Road,Tanuku,Andhra Pradesh',
    'Vemuru,Guntur,Andhra Pradesh',
    'Vendodu,Jayampu,Andhra Pradesh',
    'Vendra,Vendra,Andhra Pradesh',
    'Venkatachalam,Nellore,Andhra Pradesh',
    'Venkatagiri,Venkatagiri,Andhra Pradesh',
    'Venkatagiri Kote Halt,Venkatagiri Kote,Karnataka',
    'Venkatampalli,Nagasamudram,Andhra Pradesh',
    'Venkatanarashimarajuvaripeta,Venkatanarashimarajuvaripeta,Andhra Pradesh',
    'Venkatnagar,Venkatnagar,Madhya Pradesh',
    'Ventraptagada,Krishna,Andhra Pradesh',
    'Vepagunta,Chittoor,Andhra Pradesh',
    'Veppampattu,Chennai,Tamil Nadu',
    'Veraval,Veraval,Gujarat',
    'Verka Junction,Amritsar,Punjab',
    'Verna,South Goa,Goa',
    'Vetapalemu,Prakasam,Andhra Pradesh',
    'Vidisha,Vidisha,Madhya Pradesh',
    'Vidhraswattha,Yerrahalli,Karnataka',
    'Vidya Nagar,Hyderabad,Telangana',
    'Vidyapatinagar,Samastipur,Bihar',
    'Vidyasagar,Karmatanr,Jharkhand',
    'Vidyavihar,Mumbai,Maharashtra',
    'Vijapur,Mahesana,Gujarat',
    'Vijayamangalam,Voipadi,Tamil Nadu',
    'Vijianagar,Bengaluru,Maharashtra',
    'Vijayawada Junction,Vijayawada,Andhra Pradesh',
    'Vijaypur Jammu,Samba,Jammu and Kashmir',
    'Vijpadi Road,Bhamar,Gujarat',
    'Vikarabad Junction,Vikarabad,Telangana',
    'Vikhran,Rahimpur,Maharashtra',
    'Vikhroli,Mumbai,Maharashtra',
    'Vikramgarh Alot,Ratlam,Madhya Pradesh',
    'Vikramnagar,Ujjain,Madhya Pradesh',
    'Vikravandi,Villupuram,Tamil Nadu',
    'Vilad,Ahmednagar,Maharashtra',
    'Vilavade,Vilavade,Maharashtra',
    'Vialayatkalan Road,Salaiya,Madhya Pradesh',
    'Ville Parle,Mumbai,Maharashtra',
    'Vilegaon,Vilegaon,Maharashtra',
    'Villianur,Sulthanpet,Pondicherry',
    'Villivakkam,Chennai,Tamil Nadu',
    'Villiyambakkam,Reddipalayam,Tamil Nadu',
    'Villupuram Junction,V. Marudur,Tamil Nadu',
    'Vindhyachal,Mirzapur,Uttar Pradesh',
    'Vinhere,Vinhere,Maharashtra',
    'Vinnamangalam,Vellore,Tamil Nadu',
    'Vinukonda,Vinukonda,Andhra Pradesh',
    'Viramdad,Viramdad,Gujarat',
    'Viramgam Junction,Ahmedabad,Gujarat',
    'Virani Alur,Alur,Tamil Nadu',
    'Virapandy Road,Salem,Tamil Nadu',
    'Viraput,Viraput,Andhra Pradesh',
    'Virar,Mumbai,Maharashtra',
    'Virarakkiyam,Virarakkiyam,Tamil Nadu',
    'Viravada,Viravada,Gujarat',
    'Viravalli,Veeravalli,Andhra Pradesh',
    'Viravasaram,West Godavari,Andhra Pradesh',
    'Virbhadra,Rishikesh,Uttarakhand',
    'Virichipuram,Vellore,Tamil Nadu',
    'Virochannagar,Khoraj,Gujarat',
    'Virol,Virol,Gujarat',
    'Virpur,Rajkot,Gujarat',
    'Virudunagar Junction,Virudhunagar,Tamil Nadu',
    'Virul,Virul,Maharashtra',
    'Visakhapatnam,Visakhapatnam,Andhra Pradesh',
    'Visapur,Pune,Maharashtra',
    'Visavadar,Junagadh,Gujarat',
    'Vishnupuram,Vadapalle,Telangana',
    'Vishrambag,Sangli,Maharashtra',
    'Vishvamitri,Vadodara,Gujarat',
    'Visnagar,Visnagar,Gujarat',
    'Viswanath Chrli,Lehu Gaon,Assam',
    'Vithalwadi,Ulhasnagar,Maharashtra',
    'Viveka Vihar,New Delhi,Delhi',
    'Vivekanandpuri Halt,New Delhi,Delhi',
    'Vizianagaram Junction,Vizianagaram,Andhra Pradesh',
    'V. O. C. Nagar,Chennai,Tamil Nadu',
    'Vondh,Kutch,Gujarat',
    'Vriddhachalam Junction,Cuddalore,Tamil nadu',
    'Vrindhachalam Town,Cuddalore,Tamil Nadu',
    'Vrindaban Road,Mathura,Uttar Pradesh',
    'Vyara,Tapi,Gujarat',
    'Vyasarpadi Jeeva,Chennai,Tamil Nadu',
    'Vyasnagar,Varanasi,Uttar Pradesh',
    'Wadakanchery,Thrissur,Kerala',
    'Wadala Road,Mumbai,Maharashtra',
    'Wadegaon,Wadegaon,Maharashtra',
    'Wadhwan City,Surendranagar,Gujarat',
    'Wadi Junction,Kalaburagi,Karnataka',
    'Wadiaram,Chegunta,Telangana',
    'Wadrengdisa,Wadrengdisa,Assam',
    'Wadsa,Gadchiroli,Maharashtra',
    'Wadsinge,Tadavale,Maharashtra',
    'Wadwal Nagnath,Wadwal Nagnath,Maharashtra',
    'Waghai,Waghai,Gujarat',
    'Waghoda,Nirul,Madhya Pradesh',
    'Wair,Bhanvra,Uttar Pradesh',
    'Walajabad,Walajabad,Tamil Nadu',
    'Walajah Road,Ammoor,Tamil Nadu',
    'Walayar,Palakkad,Kerala',
    'Wan Road,Amravati,Maharashtra',
    'Wandal,Gudadinni,Karnataka',
    'Wanderjatana,faridkot,Punjab',
    'Wanegaon,Daryapur,Maharashtra',
    'Wangapalli,Yadadri-Bhuvanagiri,Telangana',
    'Wani,Wani,Maharashtra',
    'Wankaner City,Morbi,Gujarat',
    'Wankaner Junction,Morbi,Gujarat',
    'Wanparti Road,Madanapur,Telangana',
    'Wansjaliya,Jamnagar,Gujarat',
    'Warangal,Warangal,Telangana',
    'Wardha East,Wardha,Maharashtra',
    'Wardha Junction,Wardha,Maharashtra',
    'Waria,Durgapur,West Bengal',
    'Warigaon Newada,Chak Dost Barigaon,Uttar Pradesh',
    'Waris Aleganj,Nawada,Bihar',
    'Warora,Chandrapur,Maharashtra',
    'Warud,Amravati,Maharashtra',
    'Warudkhed,Warud,Maharashtra',
    'Wasanapura,Vasanpura,Gujarat',
    'Washermanpet,Chennai,Tamil Nadu',
    'Washim,Washim,Maharashtra',
    'Washimbe,Washimbe,Maharashtra',
    'Wasud,Akola,Maharashtra',
    'Wathar,Satara,Maharashtra',
    'Wazerganj,Babhandih Wajirganj,Bihar',
    'Wellington,Coonoor,Tamil Nadu',
    'Wena,Harnaut,Bihar',
    'West Hill,Kozhikode,Kerala',
    'West Mambalam,Chennai,Tamil Nadu',
    'Whitefield,Bengaluru,Karnataka',
    'Wihirgaon,Chandrapur,Maharashtra',
    'Wimco Nagar,Chennai,Tamil Nadu',
    'Wirur,Wirur,Maharashtra',
    'WRS Colony PH,Raipur,Chhattisgarh',
    'Wyndhamganj,Garhwa,Uttar Pradesh',
    'Yadalapur,Shaktinagar,Andhra Pradesh',
    'Yadgir,Yadgir,Karnataka',
    'Yadudih,Tilokari,Jharkhand',
    'Yadvendranagar,Chaukia Yakub,Uttar Pradesh',
    'Yakutpura,Hyderabad,Telangana',
    'Yalvigi,Yalvigi,Karnataka',
    'Yamuna Bridge,Agra,Uttar Pradesh',
    'Yamuna South Bank,Patyora,Uttar Pradesh',
    'Yaqutganj,Farrukhabad,Uttar Pradesh',
    'Yataluru,Yataluru,Andhra Pradesh',
    'Yavatmal,Yavatmal,Maharashtra',
    'Yedamangala,Dakshin Kannad,Karnataka',
    'Yedapalli,Nilgiris,Andhra Pradesh',
    'Yedakumeri,Kagenari,Karnataka',
    'Yedshi,Osmanabad,Maharashtra',
    'Yelahanka Junction,Bengaluru,Karnataka',
    'Yelgur,Warangal,Telangana',
    'Yeliyur,Mandya,Karnataka',
    'Yellakaru,Kalavalapudi,Andhra Pradesh',
    'Yeola,Nashik,Maharashtra',
    'Yermaras,Raichur,Karnataka',
    'Yerpedu,Chittoor,Andhra Pradesh',
    'Yerra Goppa Halt,Bagalkot,Karnataka',
    'Yerraguntla Junction,Kadapa,Andhra Pradesh',
    'Yesvantapur Junction,Bengaluru,Karnataka',
    'Yeulkhed,Buldhana,Maharashtra',
    'Yevat,Pune,Maharashtra',
    'Yogendra Dham Halt,Sarsa,Uttar Pradesh',
    'Yusufpur,Gangaram Patti,Uttar Pradesh',
    'Zafarabad Junction,Jaunpur,Uttar Pradesh',
    'Zahirabad,Sangareddy,Telangana',
    'Zamania,Ghazipur,Uttar Pradesh',
    'Zampini,Guntur,Andhra Pradesh',
    'Zantalapalle,kandukuru,Andhra Pradesh',
    'Zankhvav,Surat,Gujarat',
    'Zarap,Sindhudurg,Maharashtra',
    'Zarpur Pali,Mandola,Haryana',
    'Zawar,Zawar,Rajasthan',
    'Zindpura,Jathiura,Uttar Pradesh',
    'Sarola Kasar,Ahmednagar,Maharashtra',
'Shiradhon,Ahmednagar,Maharashtra',
'Ac.Depot,Ahmednagar,Maharashtra',
'Agadgaon,Ahmednagar,Maharashtra',
'Ahmednagar Camp,Ahmednagar,Maharashtra',
'Ahmednagar City,Ahmednagar,Maharashtra',
'Ahmednagar H.O,Ahmednagar,Maharashtra',
'Ahmednagar R.S.,Ahmednagar,Maharashtra',
'Akolner,Ahmednagar,Maharashtra',
'Anandibazar,Ahmednagar,Maharashtra',
'Astagaon,Ahmednagar,Maharashtra',
'Baburdi Ghumat,Ahmednagar,Maharashtra',
'Bhatodi,Ahmednagar,Maharashtra',
'Bhingar,Ahmednagar,Maharashtra',
'Bhingar Wes,Ahmednagar,Maharashtra',
'Bhorwadi,Ahmednagar,Maharashtra',
'Bhoyare Pathar,Ahmednagar,Maharashtra',
'Burhan Nagar,Ahmednagar,Maharashtra',
'Chas,Ahmednagar,Maharashtra',
'Chichondi Patil,Ahmednagar,Maharashtra',
'Dehere,Ahmednagar,Maharashtra',
'Deulgaon Sidhhi,Ahmednagar,Maharashtra',
'Dharewadi,Ahmednagar,Maharashtra',
'Ghospuri,Ahmednagar,Maharashtra',
'Gunwadi,Ahmednagar,Maharashtra',
'Hivare Zare,Ahmednagar,Maharashtra',
'Jeur,Ahmednagar,Maharashtra',
'Kamargaon,Ahmednagar,Maharashtra',
'Kapurwadi,Ahmednagar,Maharashtra',
'Karjune Khare,Ahmednagar,Maharashtra',
'Kaudgaon,Ahmednagar,Maharashtra',
'Kedgaon,Ahmednagar,Maharashtra',
'Khandala,Ahmednagar,Maharashtra',
'M.G.Udyan,Ahmednagar,Maharashtra',
'Mehekari,Ahmednagar,Maharashtra',
'Meherabad,Ahmednagar,Maharashtra',
'MIDC (ANR),Ahmednagar,Maharashtra',
'Mintolines,Ahmednagar,Maharashtra',
'MIRC,Ahmednagar,Maharashtra',
'Nagardeola,Ahmednagar,Maharashtra',
'Narayan Doho,Ahmednagar,Maharashtra',
'Nepti,Ahmednagar,Maharashtra',
'Nimblak,Ahmednagar,Maharashtra',
'Nimbodi,Ahmednagar,Maharashtra',
'Nimgaon Wagha,Ahmednagar,Maharashtra',
'Pimpalgaon Kauda,Ahmednagar,Maharashtra',
'Pimpalgaon Malvi,Ahmednagar,Maharashtra',
'Pimpalgaon Ujjani,Ahmednagar,Maharashtra',
'Rui Chattisi,Ahmednagar,Maharashtra',
'Sandve,Ahmednagar,Maharashtra',
'Sarjepura,Ahmednagar,Maharashtra',
'Sarolabadhi,Ahmednagar,Maharashtra',
'Savedi Road,Ahmednagar,Maharashtra',
'Shendi,Ahmednagar,Maharashtra',
'Shingave Naik,Ahmednagar,Maharashtra',
'Takali Kazi,Ahmednagar,Maharashtra',
'Vadgaon Gupta,Ahmednagar,Maharashtra',
'Vadgaon Tandali,Ahmednagar,Maharashtra',
'Vahannagar,Ahmednagar,Maharashtra',
'Vilad,Ahmednagar,Maharashtra',
'Walki,Ahmednagar,Maharashtra',
'Watephal,Ahmednagar,Maharashtra',
'Akole,Shrirampur,Maharashtra',
'Kotul,Shrirampur,Maharashtra',
'Rajur,Shrirampur,Maharashtra',
'Arangaon,Ahmednagar,Maharashtra',
'Bavi,Ahmednagar,Maharashtra',
'Chondi,Ahmednagar,Maharashtra',
'Dhondpargaon,Ahmednagar,Maharashtra',
'Dighol,Ahmednagar,Maharashtra',
'Fakrabad,Ahmednagar,Maharashtra',
'Ghodegaon,Ahmednagar,Maharashtra',
'Halgaon,Ahmednagar,Maharashtra',
'Jamkhed,Ahmednagar,Maharashtra',
'Jategaon,Ahmednagar,Maharashtra',
'Javala,Ahmednagar,Maharashtra',
'Kaudgaon,Ahmednagar,Maharashtra',
'Kharda,Ahmednagar,Maharashtra',
'Kusadgaon,Ahmednagar,Maharashtra',
'Moha,Ahmednagar,Maharashtra',
'Naigaon,Ahmednagar,Maharashtra',
'Nanaj,Ahmednagar,Maharashtra',
'Nimbodi,Ahmednagar,Maharashtra',
'Patoda,Ahmednagar,Maharashtra',
'Pimparkhed,Ahmednagar,Maharashtra',
'Rajuri,Ahmednagar,Maharashtra',
'Sakat,Ahmednagar,Maharashtra',
'Sonegaon,Ahmednagar,Maharashtra',
'Telanghashi,Ahmednagar,Maharashtra',
'Alsunde,Ahmednagar,Maharashtra',
'Ambi Jalgaon,Ahmednagar,Maharashtra',
'Babhulgaon Khalsa,Ahmednagar,Maharashtra',
'Bahirobawadi,Ahmednagar,Maharashtra',
'Baradgaon Sudrik,Ahmednagar,Maharashtra',
'Benwadi,Ahmednagar,Maharashtra',
'Bhambora,Ahmednagar,Maharashtra',
'Bitkewadi,Ahmednagar,Maharashtra',
'Chande BK,Ahmednagar,Maharashtra',
'Chapadgaon,Ahmednagar,Maharashtra',
'Chilwadi,Ahmednagar,Maharashtra',
'Chincholi Kaldat,Ahmednagar,Maharashtra',
'Dighi,Ahmednagar,Maharashtra',
'Diksal,Ahmednagar,Maharashtra',
'Durgaon,Ahmednagar,Maharashtra',
'Ghogargaon,Ahmednagar,Maharashtra',
'Guravpimpri,Ahmednagar,Maharashtra',
'Jalalpur,Ahmednagar,Maharashtra',
'Jssk,Ahmednagar,Maharashtra',
'Karjat,Ahmednagar,Maharashtra',
'Kaundane,Ahmednagar,Maharashtra',
'Khandvi,Ahmednagar,Maharashtra',
'Khednagar,Ahmednagar,Maharashtra',
'Kokangaon,Ahmednagar,Maharashtra',
'Kombli,Ahmednagar,Maharashtra',
'Koregoan,Ahmednagar,Maharashtra',
'Kuldharan,Ahmednagar,Maharashtra',
'Loni Masadpur,Ahmednagar,Maharashtra',
'Mahijalgaon,Ahmednagar,Maharashtra',
'Malangi,Ahmednagar,Maharashtra',
'Mirajgaon,Ahmednagar,Maharashtra',
'Nimgaon Daku,Ahmednagar,Maharashtra',
'Nimgaon Gangarda,Ahmednagar,Maharashtra',
'Pategaon,Ahmednagar,Maharashtra',
'Patewadi,Ahmednagar,Maharashtra',
'Rashin,Ahmednagar,Maharashtra',
'Rehekuri,Ahmednagar,Maharashtra',
'Shinde,Ahmednagar,Maharashtra',
'Takali Khandeshwari,Ahmednagar,Maharashtra',
'Thergaon,Ahmednagar,Maharashtra',
'Chas-nali,Shrirampur,Maharashtra',
'Dhamori,Shrirampur,Maharashtra',
'Kolpewadi,Shrirampur,Maharashtra',
'Kopergaon,Shrirampur,Maharashtra',
'Pohegaon,Shrirampur,Maharashtra',
'Sakarwadi,Shrirampur,Maharashtra',
'Shinganapur,Shrirampur,Maharashtra',
'Bhanashivara,Shrirampur,Maharashtra',
'Bhende SK,Shrirampur,Maharashtra',
'Kukana,Shrirampur,Maharashtra',
'Nevasa,Shrirampur,Maharashtra',
'Brahmni,Ahmednagar,Maharashtra',
'Chanda,Ahmednagar,Maharashtra',
'Ghodegaon,Ahmednagar,Maharashtra',
'Kangoni,Ahmednagar,Maharashtra',
'Karajgaon,Ahmednagar,Maharashtra',
'Kauthe,Ahmednagar,Maharashtra',
'Kendal BK,Ahmednagar,Maharashtra',
'Kharwandi,Ahmednagar,Maharashtra',
'Khedle Permananda,Ahmednagar,Maharashtra',
'Lohgaon,Ahmednagar,Maharashtra',
'Mali Chinchore,Ahmednagar,Maharashtra',
'Ranjangaondevi,Ahmednagar,Maharashtra',
'Rastapur,Ahmednagar,Maharashtra',
'Shani Shinganapur,Ahmednagar,Maharashtra',
'Singave Tukai,Ahmednagar,Maharashtra',
'Sonai,Ahmednagar,Maharashtra',
'Tamaswadi,Ahmednagar,Maharashtra',
'Umbra,Ahmednagar,Maharashtra',
'Vadalamission,Ahmednagar,Maharashtra',
'Alkuti,Ahmednagar,Maharashtra',
'Apdhup,Ahmednagar,Maharashtra',
'Babulwade,Ahmednagar,Maharashtra',
'Bhandgaon,Ahmednagar,Maharashtra',
'Bhawlani,Ahmednagar,Maharashtra',
'Chincholi,Ahmednagar,Maharashtra',
'Chombhut,Ahmednagar,Maharashtra',
'Daithane Gunjal,Ahmednagar,Maharashtra',
'Darodi,Ahmednagar,Maharashtra',
'Devi Bhoyare,Ahmednagar,Maharashtra',
'Dhawalpuri,Ahmednagar,Maharashtra',
'Dhotre BK,Ahmednagar,Maharashtra',
'Ganjibhoyare,Ahmednagar,Maharashtra',
'Gargundi,Ahmednagar,Maharashtra',
'Goregaon,Ahmednagar,Maharashtra',
'Gunore,Ahmednagar,Maharashtra',
'Hanga,Ahmednagar,Maharashtra',
'Hingangaon,Ahmednagar,Maharashtra',
'Hiware Korda,Ahmednagar,Maharashtra',
'Jamgaon,Ahmednagar,Maharashtra',
'Jategaon,Ahmednagar,Maharashtra',
'Jawala,Ahmednagar,Maharashtra',
'Kalas,Ahmednagar,Maharashtra',
'Kanhur,Ahmednagar,Maharashtra',
'Karandi,Ahmednagar,Maharashtra',
'Karjule Hariya,Ahmednagar,Maharashtra',
'Khadakwadi,Ahmednagar,Maharashtra',
'Kinhi,Ahmednagar,Maharashtra',
'Loni Haveli,Ahmednagar,Maharashtra',
'Loni Mavala,Ahmednagar,Maharashtra',
'Malkup,Ahmednagar,Maharashtra',
'Mhasane,Ahmednagar,Maharashtra',
'Nandur Pathar,Ahmednagar,Maharashtra',
'Narayan Gavan,Ahmednagar,Maharashtra',
'Nighoj,Ahmednagar,Maharashtra',
'Padali Ale,Ahmednagar,Maharashtra',
'Padali Darya,Ahmednagar,Maharashtra',
'Palashi,Ahmednagar,Maharashtra',
'Palaspur,Ahmednagar,Maharashtra',
'Palve BK,Ahmednagar,Maharashtra',
'Panoli,Ahmednagar,Maharashtra',
'Parner,Ahmednagar,Maharashtra',
'Parner SSK,Ahmednagar,Maharashtra',
'Pimpalgaon Rotha,Ahmednagar,Maharashtra',
'Pimpalner,Ahmednagar,Maharashtra',
'Pimprijalsen,Ahmednagar,Maharashtra',
'Pokhari Kanher,Ahmednagar,Maharashtra',
'Punewadi,Ahmednagar,Maharashtra',
'Ralegan Siddhi,Ahmednagar,Maharashtra',
'Ralegan Therpal,Ahmednagar,Maharashtra',
'Savargaon,Ahmednagar,Maharashtra',
'Supa,Ahmednagar,Maharashtra',
'Takali Dhokeshwar,Ahmednagar,Maharashtra',
'Takali Khatgaon,Ahmednagar,Maharashtra',
'Vadegavan,Ahmednagar,Maharashtra',
'Vadner BK,Ahmednagar,Maharashtra',
'Vadner Haveli,Ahmednagar,Maharashtra',
'Vadzire,Ahmednagar,Maharashtra',
'Vaghunde KH,Ahmednagar,Maharashtra',
'Valvane,Ahmednagar,Maharashtra',
'Vankute,Ahmednagar,Maharashtra',
'Vasunde,Ahmednagar,Maharashtra',
'Chichondi Shiral,Ahmednagar,Maharashtra',
'Akhegaon Titarfa,Ahmednagar,Maharashtra',
'Akola,Ahmednagar,Maharashtra',
'Alhanwadi,Ahmednagar,Maharashtra',
'Amarapur,Ahmednagar,Maharashtra',
'Avane BK,Ahmednagar,Maharashtra',
'Bhalgaon,Ahmednagar,Maharashtra',
'Bhutetakali,Ahmednagar,Maharashtra',
'Chichpur Pangul,Ahmednagar,Maharashtra',
'Chinchpur Ijde,Ahmednagar,Maharashtra',
'Devrai,Ahmednagar,Maharashtra',
'Dhorjalgaon,Ahmednagar,Maharashtra',
'Ghatshiras,Ahmednagar,Maharashtra',
'Jatdeola,Ahmednagar,Maharashtra',
'Jawkhede Khalsa,Ahmednagar,Maharashtra',
'Karanji,Ahmednagar,Maharashtra',
'Kasar Pimpalgaon,Ahmednagar,Maharashtra',
'Kasba Pathardi,Ahmednagar,Maharashtra',
'Khandgaon Lohsar,Ahmednagar,Maharashtra',
'Kharwandi Kasar,Ahmednagar,Maharashtra',
'Khospuri,Ahmednagar,Maharashtra',
'Kolhar,Ahmednagar,Maharashtra',
'Koradgaon,Ahmednagar,Maharashtra',
'Mahalaxmi Hiware,Ahmednagar,Maharashtra',
'Majle Chincholi,Ahmednagar,Maharashtra',
'Maka,Ahmednagar,Maharashtra',
'Mandve,Ahmednagar,Maharashtra',
'Manikdaundi,Ahmednagar,Maharashtra',
'Midsangavi,Ahmednagar,Maharashtra',
'Miri,Ahmednagar,Maharashtra',
'Mohoj BK,Ahmednagar,Maharashtra',
'Mohojdeoda,Ahmednagar,Maharashtra',
'Mohote,Ahmednagar,Maharashtra',
'Munguswade,Ahmednagar,Maharashtra',
'Nandur Nimba Daitya,Ahmednagar,Maharashtra',
'Nimbe Nandur,Ahmednagar,Maharashtra',
'Nipani Jalgaon,Ahmednagar,Maharashtra',
'Nivdunga,Ahmednagar,Maharashtra',
'Padali,Ahmednagar,Maharashtra',
'Pagori Pimpalgaon,Ahmednagar,Maharashtra',
'Pathardi,Ahmednagar,Maharashtra',
'Pimpalgaontappa,Ahmednagar,Maharashtra',
'Sakegaon,Ahmednagar,Maharashtra',
'Shingave Keshav,Ahmednagar,Maharashtra',
'Shiral,Ahmednagar,Maharashtra',
'Shirapur,Ahmednagar,Maharashtra',
'Sultanpur KHD,Ahmednagar,Maharashtra',
'Susare,Ahmednagar,Maharashtra',
'Takali Manur,Ahmednagar,Maharashtra',
'Tisgaon,Ahmednagar,Maharashtra',
'Tondoli,Ahmednagar,Maharashtra',
'Vagholi,Ahmednagar,Maharashtra',
'Vaiju Babhulgaon,Ahmednagar,Maharashtra',
'Vridheshwar SSK,Ahmednagar,Maharashtra',
'Wadgaon,Ahmednagar,Maharashtra',
'Yeli,Ahmednagar,Maharashtra',
'Babhleshwar,Shrirampur,Maharashtra',
'Changdeonagar,Shrirampur,Maharashtra',
'Kolhar,Shrirampur,Maharashtra',
'Loni Bk,Shrirampur,Maharashtra',
'Loni Kurd,Shrirampur,Maharashtra',
'Pravaranagar,Shrirampur,Maharashtra',
'Pun Tamba,Shrirampur,Maharashtra',
'Rahata,Shrirampur,Maharashtra',
'Ranjangaon Khurd,Shrirampur,Maharashtra',
'Shirdi,Shrirampur,Maharashtra',
'Deolali -pravara,Shrirampur,Maharashtra',
'Dhamori,Ahmednagar,Maharashtra',
'Katrad,Ahmednagar,Maharashtra',
'Khadamba,Ahmednagar,Maharashtra',
'Rahuri Factory,Shrirampur,Maharashtra',
'Rahuri MPKV,Shrirampur,Maharashtra',
'Rahuri,Shrirampur,Maharashtra',
'Rahuri Town,Shrirampur,Maharashtra',
'Sade,Ahmednagar,Maharashtra',
'Vambori,Ahmednagar,Maharashtra',
'Ashvi BK,Shrirampur,Maharashtra',
'Ashvi KH,Shrirampur,Maharashtra',
'Bota,Shrirampur,Maharashtra',
'Dhandharphal,Shrirampur,Maharashtra',
'Nanaj Dumala,Shrirampur,Maharashtra',
'Sakur,Shrirampur,Maharashtra',
'Sangamner,Shrirampur,Maharashtra',
'Sangamner S.K.,Shrirampur,Maharashtra',
'Ghargaon,Shrirampur,Maharashtra',
'Akhatwade,Ahmednagar,Maharashtra',
'Balamtakali,Ahmednagar,Maharashtra',
'Bhatkudgaon,Ahmednagar,Maharashtra',
'Bhavinimgaon,Ahmednagar,Maharashtra',
'Bodhegaon,Ahmednagar,Maharashtra',
'Chapadgaon,Ahmednagar,Maharashtra',
'Dahigaon,Ahmednagar,Maharashtra',
'Deotakli,Ahmednagar,Maharashtra',
'Gaikwad Jalgaon,Ahmednagar,Maharashtra',
'Ghotan,Ahmednagar,Maharashtra',
'Golegaon,Ahmednagar,Maharashtra',
'Hasnapur,Ahmednagar,Maharashtra',
'Hatgaon,Ahmednagar,Maharashtra',
'Joharapur,Ahmednagar,Maharashtra',
'Kambi,Ahmednagar,Maharashtra',
'Khampimpri,Ahmednagar,Maharashtra',
'Kharadgaon,Ahmednagar,Maharashtra',
'Ladjalgaon,Ahmednagar,Maharashtra',
'Malegaon,Ahmednagar,Maharashtra',
'Mungi,Ahmednagar,Maharashtra',
'Rakshi,Ahmednagar,Maharashtra',
'Samangaon,Ahmednagar,Maharashtra',
'Samsud Erandgaon,Ahmednagar,Maharashtra',
'Shahar Takali,Ahmednagar,Maharashtra',
'Shekte,Ahmednagar,Maharashtra',
'Shevgaon,Ahmednagar,Maharashtra',
'Shingori,Ahmednagar,Maharashtra',
'Sultanpur BK,Ahmednagar,Maharashtra',
'Tajnapur,Ahmednagar,Maharashtra',
'Thakur Pimpalgaon,Ahmednagar,Maharashtra',
'Vadule BK,Ahmednagar,Maharashtra',
'Varur BK,Ahmednagar,Maharashtra',
'Pedgaon,Ahmednagar,Maharashtra',
'Adhalgaon,Ahmednagar,Maharashtra',
'Ajnuj,Ahmednagar,Maharashtra',
'Arangaon Dumala,Ahmednagar,Maharashtra',
'Babhurdi,Ahmednagar,Maharashtra',
'Belwandi S.F.,Ahmednagar,Maharashtra',
'Belwandi,Ahmednagar,Maharashtra',
'Bhangaon,Ahmednagar,Maharashtra',
'Bhoyare Gangarda,Ahmednagar,Maharashtra',
'Chamburdi,Ahmednagar,Maharashtra',
'Chandgaon,Ahmednagar,Maharashtra',
'Chikhali,Ahmednagar,Maharashtra',
'Chimbhale,Ahmednagar,Maharashtra',
'Deodaithan,Ahmednagar,Maharashtra',
'Deulgaon,Ahmednagar,Maharashtra',
'Dhavalgaon,Ahmednagar,Maharashtra',
'Dhorje,Ahmednagar,Maharashtra',
'Erandoli,Ahmednagar,Maharashtra',
'Ghargaon,Ahmednagar,Maharashtra',
'Ghotvi,Ahmednagar,Maharashtra',
'Gundegaon,Ahmednagar,Maharashtra',
'Hangewadi,Ahmednagar,Maharashtra',
'Hiradgaon,Ahmednagar,Maharashtra',
'Kashti,Ahmednagar,Maharashtra',
'Kolgaon,Ahmednagar,Maharashtra',
'Kotul,Ahmednagar,Maharashtra',
'Limpangaon,Ahmednagar,Maharashtra',
'Loni Vyanknath,Ahmednagar,Maharashtra',
'Madhe Wadgaon,Ahmednagar,Maharashtra',
'Mandavgan,Ahmednagar,Maharashtra',
'Math Pimpari,Ahmednagar,Maharashtra',
'Mhase,Ahmednagar,Maharashtra',
'Nibavi,Ahmednagar,Maharashtra',
'Nimgaon Khalu,Ahmednagar,Maharashtra',
'Padali Ranjangaon,Ahmednagar,Maharashtra',
'Pargaon Sudrik,Ahmednagar,Maharashtra',
'Pimpalgaon Pisa,Ahmednagar,Maharashtra',
'Pimpri Kolandar,Ahmednagar,Maharashtra',
'Pisorekhand,Ahmednagar,Maharashtra',
'Rajapur,Ahmednagar,Maharashtra',
'Ralegan,Ahmednagar,Maharashtra',
'Ranjangaon,Ahmednagar,Maharashtra',
'Rui Chhatrapati,Ahmednagar,Maharashtra',
'Sarolasomvanshi,Ahmednagar,Maharashtra',
'Shedgaon,Ahmednagar,Maharashtra',
'Shrigonda,Ahmednagar,Maharashtra',
'Shrigonda SSK,Ahmednagar,Maharashtra',
'Suregaon,Ahmednagar,Maharashtra',
'Takali Kadewalit,Ahmednagar,Maharashtra',
'Takali Lonar,Ahmednagar,Maharashtra',
'Tandali Dumala,Ahmednagar,Maharashtra',
'Ukkadgaon,Ahmednagar,Maharashtra',
'Ukkhalgaon,Ahmednagar,Maharashtra',
'Vangdari,Ahmednagar,Maharashtra',
'Visapur,Ahmednagar,Maharashtra',
'Wadali,Ahmednagar,Maharashtra',
'Yelapane,Ahmednagar,Maharashtra',
'Karegaon Factory,Shrirampur,Maharashtra',
'Shrirampur H.O,Shrirampur,Maharashtra',
'Belapur,Shrirampur,Maharashtra',
'Harigaon,Shrirampur,Maharashtra',
'IE Shrirampur. Shrirampur.,Shrirampur,Maharashtra',
'Padhegaon,Shrirampur,Maharashtra',
'Songaon,Shrirampur,Maharashtra',
'Takalibhan,Shrirampur,Maharashtra',
'Tilaknagar,Shrirampur,Maharashtra',
'Vadala Mahadeo,Shrirampur,Maharashtra',
'Akola City,Akola,Maharashtra',
'Akola H.O,Akola,Maharashtra',
'Akot,Akola,Maharashtra',
'Apoti,Akola,Maharashtra',
'Babhulgaon,Akola,Maharashtra',
'Babhulgaon Jahangir,Akola,Maharashtra',
'Balapur,Akola,Maharashtra',
'Balegaon,Akola,Maharashtra',
'Barshitakli,Akola,Maharashtra',
'Bhandaraj,Akola,Maharashtra',
'Bhar,Akola,Maharashtra',
'Bhendi Mahal,Akola,Maharashtra',
'Borgaon KD,Akola,Maharashtra',
'Borgaon Manju,Akola,Maharashtra',
'Channi,Akola,Maharashtra',
'Chatari,Akola,Maharashtra',
'Chohatta,Akola,Maharashtra',
'Dahihanda,Akola,Maharashtra',
'Dapura,Akola,Maharashtra',
'Deulgaon Bramhan,Akola,Maharashtra',
'Digras,Akola,Maharashtra',
'Dongargaon,Akola,Maharashtra',
'Donwada,Akola,Maharashtra',
'Gandhinagar,Akola,Maharashtra',
'Gawandgaon,Akola,Maharashtra',
'Ghusar,Akola,Maharashtra',
'Hatola,Akola,Maharashtra',
'Jamakeshwar,Akola,Maharashtra',
'Januna,Akola,Maharashtra',
'Jatherpeth Akola,Akola,Maharashtra',
'Kaulkhed,Akola,Maharashtra',
'Khanapur,Akola,Maharashtra',
'Kherda Bhagai,Akola,Maharashtra',
'Khetri,Akola,Maharashtra',
'Kothali,Akola,Maharashtra',
'Krishinagar Akola,Akola,Maharashtra',
'Mahan,Akola,Maharashtra',
'Malrajura,Akola,Maharashtra',
'Malsoor,Akola,Maharashtra',
'Mathodi,Akola,Maharashtra',
'Mhaisang,Akola,Maharashtra',
'Midc Shivar,Akola,Maharashtra',
'Mundgaon,Akola,Maharashtra',
'Pathardi,Akola,Maharashtra',
'Patur Nandapur,Akola,Maharashtra',
'Patur,Akola,Maharashtra',
'Pimpalkhuta,Akola,Maharashtra',
'Pinjar,Akola,Maharashtra',
'Rahit,Akola,Maharashtra',
'Ramdaspeth Akola,Akola,Maharashtra',
'Ranpisenagar Akola,Akola,Maharashtra',
'Rpts Akola,Akola,Maharashtra',
'Sasti,Akola,Maharashtra',
'Sawargaon,Akola,Maharashtra',
'Shirla Andhare,Akola,Maharashtra',
'Shivaji Park Akola,Akola,Maharashtra',
'Shoni,Akola,Maharashtra',
'Tajnapeth Akola,Akola,Maharashtra',
'Tandali,Akola,Maharashtra',
'Tilak Road Akola,Akola,Maharashtra',
'Titwa,Akola,Maharashtra',
'Tulanga BK,Akola,Maharashtra',
'Umara Balapur,Akola,Maharashtra',
'Viwara,Akola,Maharashtra',
'Wadad,Akola,Maharashtra',
'Wagha,Akola,Maharashtra',
'Zodga,Akola,Maharashtra',
'Achalpur City,Amaravati,Maharashtra',
'Dhamangaon Gadhi,Amaravati,Maharashtra',
'Pathrot,Amaravati,Maharashtra',
'Amravati H.O,Amaravati,Maharashtra',
'Bhaji Bazar Amravati,Amaravati,Maharashtra',
'Congress Nagar,Amaravati,Maharashtra',
'Gokul Market,Amaravati,Maharashtra',
'H. V. Nagar,Amaravati,Maharashtra',
'Jaistambh Chowk,Amaravati,Maharashtra',
'Nandgaon Peth,Amaravati,Maharashtra',
'New Cotton Market,Amaravati,Maharashtra',
'Old Cotton Market,Amaravati,Maharashtra',
'Rajapeth,Amaravati,Maharashtra',
'Rukhmini Nagar,Amaravati,Maharashtra',
'Sai Nagar,Amaravati,Maharashtra',
'Sakkarsath,Amaravati,Maharashtra',
'Shirala,Amaravati,Maharashtra',
'Shivaji Nagar,Amaravati,Maharashtra',
'V.M.V. (Amravati),Amaravati,Maharashtra',
'Walgaon Road Tso Amravati,Amaravati,Maharashtra',
'Yawali,Amaravati,Maharashtra',
'Anjangaon,Amaravati,Maharashtra',
'Surji (Anjangaon),Amaravati,Maharashtra',
'Purna Nagar,Amaravati,Maharashtra',
'Wadnergangai,Amaravati,Maharashtra',
'Walgaon,Amaravati,Maharashtra',
'Wathoda Sh.,Amaravati,Maharashtra',
'Asegaon Purna,Amaravati,Maharashtra',
'Belora,Amaravati,Maharashtra',
'Brahmanwada Thadi,Amaravati,Maharashtra',
'Chandur Bazar,Amaravati,Maharashtra',
'Karajgaon,Amaravati,Maharashtra',
'Sirajgaon Band,Amaravati,Maharashtra',
'Sirasgaon Kasba,Amaravati,Maharashtra',
'Baggi,Amaravati,Maharashtra',
'Bhankheda Khurd,Amaravati,Maharashtra',
'Dhanora Mhali,Amaravati,Maharashtra',
'Ghuikhed,Amaravati,Maharashtra',
'Jalka Jagtap,Amaravati,Maharashtra',
'Jawala,Amaravati,Maharashtra',
'Kalamgaon,Amaravati,Maharashtra',
'Karla,Amaravati,Maharashtra',
'Kawatha Kadu,Amaravati,Maharashtra',
'Malkhed,Amaravati,Maharashtra',
'Manjarkhed,Amaravati,Maharashtra',
'Mardi,Amaravati,Maharashtra',
'Nimgavan,Amaravati,Maharashtra',
'Palaskhed,Amaravati,Maharashtra',
'Pimpalkhuta,Amaravati,Maharashtra',
'Pohara,Amaravati,Maharashtra',
'Satephal,Amaravati,Maharashtra',
'Sawangi Magrapur,Amaravati,Maharashtra',
'Sirasgaon Korde,Amaravati,Maharashtra',
'Sonora BK,Amaravati,Maharashtra',
'Amla Vishweshwar,Amaravati,Maharashtra',
'Kurha,Amaravati,Maharashtra',
'Chandur Railway,Amaravati,Maharashtra',
'Chikhaldara,Amaravati,Maharashtra',
'Thilori,Amaravati,Maharashtra',
'Arala,Amaravati,Maharashtra',
'Badhli,Amaravati,Maharashtra',
'Chincholi Shinghane,Amaravati,Maharashtra',
'Darapur,Amaravati,Maharashtra',
'Daryapur,Amaravati,Maharashtra',
'Daryapur Town,Amaravati,Maharashtra',
'Dhamodi,Amaravati,Maharashtra',
'Gaiwadi,Amaravati,Maharashtra',
'Itki Antargaon,Amaravati,Maharashtra',
'Kalashi,Amaravati,Maharashtra',
'Kamalpur Taroda,Amaravati,Maharashtra',
'Kanholi,Amaravati,Maharashtra',
'Kapustalni,Amaravati,Maharashtra',
'Khallar,Amaravati,Maharashtra',
'Khaspur,Amaravati,Maharashtra',
'Kholapur,Amaravati,Maharashtra',
'Kokarda,Amaravati,Maharashtra',
'Lehegaon,Amaravati,Maharashtra',
'Mahuli Dhande,Amaravati,Maharashtra',
'Nalwada,Amaravati,Maharashtra',
'Ramtirth,Amaravati,Maharashtra',
'Samda,Amaravati,Maharashtra',
'Shivar,Amaravati,Maharashtra',
'Takli,Amaravati,Maharashtra',
'Tonglabad,Amaravati,Maharashtra',
'Yeoda,Amaravati,Maharashtra',
'Dhamangaon Town,Amaravati,Maharashtra',
'Dhamangaon R.S.,Amaravati,Maharashtra',
'Chincholi,Wardha,Maharashtra',
'Mangrul Dastgir,Amaravati,Maharashtra',
'Talegaon Dashasar,Amaravati,Maharashtra',
'Dharni,Amaravati,Maharashtra',
'Kalamkhar,Amaravati,Maharashtra',
'Semadoh,Amaravati,Maharashtra',
'Hiwarkhed,Amaravati,Maharashtra',
'Morshi,Amaravati,Maharashtra',
'Nerpingalai,Amaravati,Maharashtra',
'Rithpur,Amaravati,Maharashtra',
'Shirkhed,Amaravati,Maharashtra',
'Nandgaon Khandeshwar,Amaravati,Maharashtra',
'Chhota Bazar,Amaravati,Maharashtra',
'Cotton Market,Amaravati,Maharashtra',
'Paratwada H.O,Amaravati,Maharashtra',
'Gurukunj Ashram,Amaravati,Maharashtra',
'Tiosa,Amaravati,Maharashtra',
'Benoda,Amaravati,Maharashtra',
'Jarud,Amaravati,Maharashtra',
'Loni,Amaravati,Maharashtra',
'Pusla,Amaravati,Maharashtra',
'Shendurjana Ghat,Amaravati,Maharashtra',
'Warud,Amaravati,Maharashtra',
'Adgaon BK,Aurangabad(Maharashtra),Maharashtra',
'Adgaon Sarak,Aurangabad(Maharashtra),Maharashtra',
'Assegaon,Aurangabad(Maharashtra),Maharashtra',
'Aurangabad Cantonment,Aurangabad(Maharashtra),Maharashtra',
'Aurangabad City,Aurangabad(Maharashtra),Maharashtra',
'Aurangabad H.O,Aurangabad(Maharashtra),Maharashtra',
'Aurangabad Railway Station,Aurangabad(Maharashtra),Maharashtra',
'Badod Bazar,Aurangabad(Maharashtra),Maharashtra',
'Begumpura,Aurangabad(Maharashtra),Maharashtra',
'Bhakarwadi,Aurangabad(Maharashtra),Maharashtra',
'Bhalgaon,Aurangabad(Maharashtra),Maharashtra',
'Chikalthana Industrial Area,Aurangabad(Maharashtra),Maharashtra',
'Chikalthana,Aurangabad(Maharashtra),Maharashtra',
'Chittepimpalgaon,Aurangabad(Maharashtra),Maharashtra',
'Chouka,Aurangabad(Maharashtra),Maharashtra',
'Cidco Colony,Aurangabad(Maharashtra),Maharashtra',
'Daulatabad,Aurangabad(Maharashtra),Maharashtra',
'Dr. B.A. Marathwada University,Aurangabad(Maharashtra),Maharashtra',
'Dudhad,Aurangabad(Maharashtra),Maharashtra',
'Fazalpura,Aurangabad(Maharashtra),Maharashtra',
'Gadhejalgaon,Aurangabad(Maharashtra),Maharashtra',
'Garkheda,Aurangabad(Maharashtra),Maharashtra',
'Gevarai,Aurangabad(Maharashtra),Maharashtra',
'Gevrai Kubri,Aurangabad(Maharashtra),Maharashtra',
'Ghardon,Aurangabad(Maharashtra),Maharashtra',
'Golatgaon,Aurangabad(Maharashtra),Maharashtra',
'Harsool,Aurangabad(Maharashtra),Maharashtra',
'High Court Building,Aurangabad(Maharashtra),Maharashtra',
'Jatwada,Aurangabad(Maharashtra),Maharashtra',
'Kachner,Aurangabad(Maharashtra),Maharashtra',
'Karmad,Aurangabad(Maharashtra),Maharashtra',
'Khodegaon,Aurangabad(Maharashtra),Maharashtra',
'Khumbhephal,Aurangabad(Maharashtra),Maharashtra',
'Kotwalpura,Aurangabad(Maharashtra),Maharashtra',
'Kranti Chowk,Aurangabad(Maharashtra),Maharashtra',
'Ladsawangi,Aurangabad(Maharashtra),Maharashtra',
'Maliwada,Aurangabad(Maharashtra),Maharashtra',
'Medical College,Aurangabad(Maharashtra),Maharashtra',
'Naigavhan,Aurangabad(Maharashtra),Maharashtra',
'Nakshtrawadi,Aurangabad(Maharashtra),Maharashtra',
'Naregaon,Aurangabad(Maharashtra),Maharashtra',
'Nizamganj,Aurangabad(Maharashtra),Maharashtra',
'Osmanpura,Aurangabad(Maharashtra),Maharashtra',
'Padegaon,Aurangabad(Maharashtra),Maharashtra',
'Palshi (Shahar),Aurangabad(Maharashtra),Maharashtra',
'Pimpri Raja,Aurangabad(Maharashtra),Maharashtra',
'Samarthnagar,Aurangabad(Maharashtra),Maharashtra',
'Sarafa,Aurangabad(Maharashtra),Maharashtra',
'Saraswati Colony,Aurangabad(Maharashtra),Maharashtra',
'Satara,Aurangabad(Maharashtra),Maharashtra',
'Session Court,Aurangabad(Maharashtra),Maharashtra',
'Shahaganj,Aurangabad(Maharashtra),Maharashtra',
'Shekta,Aurangabad(Maharashtra),Maharashtra',
'Shevga,Aurangabad(Maharashtra),Maharashtra',
'Tuljapur Sawangi,Aurangabad(Maharashtra),Maharashtra',
'Wakulni,Aurangabad(Maharashtra),Maharashtra',
'Waladgaon,Aurangabad(Maharashtra),Maharashtra',
'Warudkazi,Aurangabad(Maharashtra),Maharashtra',
'Warzadi,Aurangabad(Maharashtra),Maharashtra',
'Badnapur,Aurangabad(Maharashtra),Maharashtra',
'Bhokardan,Aurangabad(Maharashtra),Maharashtra',
'Agarwadgaon,Aurangabad(Maharashtra),Maharashtra',
'Ambelohal,Aurangabad(Maharashtra),Maharashtra',
'Bajaj Nagar Midc Waluj,Aurangabad(Maharashtra),Maharashtra',
'Bhendala,Aurangabad(Maharashtra),Maharashtra',
'Dongaon,Aurangabad(Maharashtra),Maharashtra',
'Gajgaon,Aurangabad(Maharashtra),Maharashtra',
'Gangapur,Aurangabad(Maharashtra),Maharashtra',
'Gawali Shivra,Aurangabad(Maharashtra),Maharashtra',
'Ghanegaon,Aurangabad(Maharashtra),Maharashtra',
'Ghodegaon,Aurangabad(Maharashtra),Maharashtra',
'Jalgaon,Aurangabad(Maharashtra),Maharashtra',
'Jikthan,Aurangabad(Maharashtra),Maharashtra',
'Kaigaon,Aurangabad(Maharashtra),Maharashtra',
'Kankori,Aurangabad(Maharashtra),Maharashtra',
'Kasoda,Aurangabad(Maharashtra),Maharashtra',
'Lasur Station,Aurangabad(Maharashtra),Maharashtra',
'Mali Wadgaon,Aurangabad(Maharashtra),Maharashtra',
'Malunja,Aurangabad(Maharashtra),Maharashtra',
'Manjri,Aurangabad(Maharashtra),Maharashtra',
'Mehaboobkheda,Aurangabad(Maharashtra),Maharashtra',
'Nevargaon,Aurangabad(Maharashtra),Maharashtra',
'Pendapur,Aurangabad(Maharashtra),Maharashtra',
'Pimpalgaon Diwashi,Aurangabad(Maharashtra),Maharashtra',
'Raghunath Nagar,Aurangabad(Maharashtra),Maharashtra',
'Ranjagaon Pol,Aurangabad(Maharashtra),Maharashtra',
'Sawkheda,Aurangabad(Maharashtra),Maharashtra',
'Shendurwada,Aurangabad(Maharashtra),Maharashtra',
'Sidhanath Wadgaon,Aurangabad(Maharashtra),Maharashtra',
'Sillegaon,Aurangabad(Maharashtra),Maharashtra',
'Singhi,Aurangabad(Maharashtra),Maharashtra',
'Solegaon,Aurangabad(Maharashtra),Maharashtra',
'Takali Kadim,Aurangabad(Maharashtra),Maharashtra',
'Talpimpri,Aurangabad(Maharashtra),Maharashtra',
'Tembhapuri,Aurangabad(Maharashtra),Maharashtra',
'Turkabad,Aurangabad(Maharashtra),Maharashtra',
'Wahegaon,Aurangabad(Maharashtra),Maharashtra',
'Waluj,Aurangabad(Maharashtra),Maharashtra',
'Warkheda,Aurangabad(Maharashtra),Maharashtra',
'Yesgaon,Aurangabad(Maharashtra),Maharashtra',
'Adgaon,Aurangabad(Maharashtra),Maharashtra',
'Amba (Upla),Aurangabad(Maharashtra),Maharashtra',
'Andhaner,Aurangabad(Maharashtra),Maharashtra',
'Aurala,Aurangabad(Maharashtra),Maharashtra',
'Bahirgaon,Aurangabad(Maharashtra),Maharashtra',
'Banshendra,Aurangabad(Maharashtra),Maharashtra',
'Basadi,Aurangabad(Maharashtra),Maharashtra',
'Bharamba,Aurangabad(Maharashtra),Maharashtra',
'Bramhani,Aurangabad(Maharashtra),Maharashtra',
'Chapaner,Aurangabad(Maharashtra),Maharashtra',
'Chikhalthan,Aurangabad(Maharashtra),Maharashtra',
'Chincholi Limbaji,Aurangabad(Maharashtra),Maharashtra',
'Dahegaon,Aurangabad(Maharashtra),Maharashtra',
'Debhegaon,Aurangabad(Maharashtra),Maharashtra',
'Deogaon Rangari,Aurangabad(Maharashtra),Maharashtra',
'Devlana,Aurangabad(Maharashtra),Maharashtra',
'Eta,Aurangabad(Maharashtra),Maharashtra',
'Ghat Shendra,Aurangabad(Maharashtra),Maharashtra',
'Hasta,Aurangabad(Maharashtra),Maharashtra',
'Hatnoor,Aurangabad(Maharashtra),Maharashtra',
'Jaitapur,Aurangabad(Maharashtra),Maharashtra',
'Jaitkheda,Aurangabad(Maharashtra),Maharashtra',
'Jamdi Jahangir,Aurangabad(Maharashtra),Maharashtra',
'Jehur,Aurangabad(Maharashtra),Maharashtra',
'Kalimath,Aurangabad(Maharashtra),Maharashtra',
'Kannad,Aurangabad(Maharashtra),Maharashtra',
'Karanjkheda,Aurangabad(Maharashtra),Maharashtra',
'Kolwadi,Aurangabad(Maharashtra),Maharashtra',
'Lamangaon,Aurangabad(Maharashtra),Maharashtra',
'Mahora,Aurangabad(Maharashtra),Maharashtra',
'Mundwadi,Aurangabad(Maharashtra),Maharashtra',
'Nachanwel,Aurangabad(Maharashtra),Maharashtra',
'Nagad,Aurangabad(Maharashtra),Maharashtra',
'Nagapur,Aurangabad(Maharashtra),Maharashtra',
'Nevpur,Aurangabad(Maharashtra),Maharashtra',
'Nimbhora,Aurangabad(Maharashtra),Maharashtra',
'Palshi BK,Aurangabad(Maharashtra),Maharashtra',
'Pimparkheda,Aurangabad(Maharashtra),Maharashtra',
'Pishore,Aurangabad(Maharashtra),Maharashtra',
'Rail,Aurangabad(Maharashtra),Maharashtra',
'Saigavan,Aurangabad(Maharashtra),Maharashtra',
'Sarola,Aurangabad(Maharashtra),Maharashtra',
'Tadpimpalgaon,Aurangabad(Maharashtra),Maharashtra',
'Tapargaon,Aurangabad(Maharashtra),Maharashtra',
'Umarkheda,Aurangabad(Maharashtra),Maharashtra',
'Wadali,Aurangabad(Maharashtra),Maharashtra',
'Wadner,Aurangabad(Maharashtra),Maharashtra',
'Wakod,Aurangabad(Maharashtra),Maharashtra',
'Bodkha,Aurangabad(Maharashtra),Maharashtra',
'Borsar BK,Aurangabad(Maharashtra),Maharashtra',
'Ellora Caves,Aurangabad(Maharashtra),Maharashtra',
'Ellora,Aurangabad(Maharashtra),Maharashtra',
'Gadana,Aurangabad(Maharashtra),Maharashtra',
'Galle Borgaon,Aurangabad(Maharashtra),Maharashtra',
'Golegaon,Aurangabad(Maharashtra),Maharashtra',
'Kagazipura,Aurangabad(Maharashtra),Maharashtra',
'Kalandrabad (Kasabkheda),Aurangabad(Maharashtra),Maharashtra',
'Khirdi,Aurangabad(Maharashtra),Maharashtra',
'Khuldabad,Aurangabad(Maharashtra),Maharashtra',
'Palaswadi,Aurangabad(Maharashtra),Maharashtra',
'Pimpri,Aurangabad(Maharashtra),Maharashtra',
'Sawangi Bazar,Aurangabad(Maharashtra),Maharashtra',
'Sultanpur,Aurangabad(Maharashtra),Maharashtra',
'Takali Raje Rai,Aurangabad(Maharashtra),Maharashtra',
'Tisgaon,Aurangabad(Maharashtra),Maharashtra',
'Yesgaon,Aurangabad(Maharashtra),Maharashtra',
'Adul Budruk,Aurangabad(Maharashtra),Maharashtra',
'Antarwali Khandi,Aurangabad(Maharashtra),Maharashtra',
'Apegaon,Aurangabad(Maharashtra),Maharashtra',
'Balanagar,Aurangabad(Maharashtra),Maharashtra',
'Bidkingaon,Aurangabad(Maharashtra),Maharashtra',
'Bihamandwa,Aurangabad(Maharashtra),Maharashtra',
'Bokud Jalgaon,Aurangabad(Maharashtra),Maharashtra',
'Changatpuri,Aurangabad(Maharashtra),Maharashtra',
'Chitegaon,Aurangabad(Maharashtra),Maharashtra',
'Dawarwadi,Aurangabad(Maharashtra),Maharashtra',
'Dhkephal,Aurangabad(Maharashtra),Maharashtra',
'Dhorkingaon,Aurangabad(Maharashtra),Maharashtra',
'Dhupkheda,Aurangabad(Maharashtra),Maharashtra',
'Ektuni,Aurangabad(Maharashtra),Maharashtra',
'Gevarai BK,Aurangabad(Maharashtra),Maharashtra',
'Gharegaon Ektuni,Aurangabad(Maharashtra),Maharashtra',
'Harshi,Aurangabad(Maharashtra),Maharashtra',
'Hiradpuri,Aurangabad(Maharashtra),Maharashtra',
'Issarwadi,Aurangabad(Maharashtra),Maharashtra',
'Kadethan,Aurangabad(Maharashtra),Maharashtra',
'Karkin,Aurangabad(Maharashtra),Maharashtra',
'Katpur,Aurangabad(Maharashtra),Maharashtra',
'Khadgaon,Aurangabad(Maharashtra),Maharashtra',
'Lakhegaon,Aurangabad(Maharashtra),Maharashtra',
'Lohgaon,Aurangabad(Maharashtra),Maharashtra',
'Mulani Wadgaon,Aurangabad(Maharashtra),Maharashtra',
'Nander,Aurangabad(Maharashtra),Maharashtra',
'Narayangaon,Aurangabad(Maharashtra),Maharashtra',
'Nathnagar North,Aurangabad(Maharashtra),Maharashtra',
'Navgaon,Aurangabad(Maharashtra),Maharashtra',
'Nilajgaon,Aurangabad(Maharashtra),Maharashtra',
'Pachod,Aurangabad(Maharashtra),Maharashtra',
'Paithan,Aurangabad(Maharashtra),Maharashtra',
'Paithan Sakhar Karkhana,Aurangabad(Maharashtra),Maharashtra',
'Parundi,Aurangabad(Maharashtra),Maharashtra',
'Pimpalwadi (Pirachi),Aurangabad(Maharashtra),Maharashtra',
'Porgaon,Aurangabad(Maharashtra),Maharashtra',
'Rahatgaon,Aurangabad(Maharashtra),Maharashtra',
'Ranjangaon Pan,Aurangabad(Maharashtra),Maharashtra',
'Shekta,Aurangabad(Maharashtra),Maharashtra',
'Shevta,Aurangabad(Maharashtra),Maharashtra',
'Takali Ambad,Aurangabad(Maharashtra),Maharashtra',
'Thergaon,Aurangabad(Maharashtra),Maharashtra',
'Wadwali,Aurangabad(Maharashtra),Maharashtra',
'Wahegaon,Aurangabad(Maharashtra),Maharashtra',
'Padali,Aurangabad(Maharashtra),Maharashtra',
'Aland,Aurangabad(Maharashtra),Maharashtra',
'Babra,Aurangabad(Maharashtra),Maharashtra',
'Bilda,Aurangabad(Maharashtra),Maharashtra',
'Bodhegaon,Aurangabad(Maharashtra),Maharashtra',
'Borgaon Arj,Aurangabad(Maharashtra),Maharashtra',
'Dhamangaon,Aurangabad(Maharashtra),Maharashtra',
'Ganori,Aurangabad(Maharashtra),Maharashtra',
'Jategaon,Aurangabad(Maharashtra),Maharashtra',
'Kanhori,Aurangabad(Maharashtra),Maharashtra',
'Khamgaon,Aurangabad(Maharashtra),Maharashtra',
'Kingaon,Aurangabad(Maharashtra),Maharashtra',
'Marsawali,Aurangabad(Maharashtra),Maharashtra',
'Nandra,Aurangabad(Maharashtra),Maharashtra',
'Nidhona,Aurangabad(Maharashtra),Maharashtra',
'Pal,Aurangabad(Maharashtra),Maharashtra',
'Pampalgaon Gangdev,Aurangabad(Maharashtra),Maharashtra',
'Pathri,Aurangabad(Maharashtra),Maharashtra',
'Phulumbri,Aurangabad(Maharashtra),Maharashtra',
'Pir Bawada,Aurangabad(Maharashtra),Maharashtra',
'Shirodi,Aurangabad(Maharashtra),Maharashtra',
'Wanegaon,Aurangabad(Maharashtra),Maharashtra',
'Waregaon,Aurangabad(Maharashtra),Maharashtra',
'Ajantha Caves,Aurangabad(Maharashtra),Maharashtra',
'Ajantha,Aurangabad(Maharashtra),Maharashtra',
'Ambhai,Aurangabad(Maharashtra),Maharashtra',
'Amthana,Aurangabad(Maharashtra),Maharashtra',
'Andhari,Aurangabad(Maharashtra),Maharashtra',
'Anwa,Aurangabad(Maharashtra),Maharashtra',
'Anwi,Aurangabad(Maharashtra),Maharashtra',
'Badod Pan,Aurangabad(Maharashtra),Maharashtra',
'Bahulkheda,Aurangabad(Maharashtra),Maharashtra',
'Balapur,Aurangabad(Maharashtra),Maharashtra',
'Bankinhola,Aurangabad(Maharashtra),Maharashtra',
'Bharadi,Aurangabad(Maharashtra),Maharashtra',
'Borgaon Bazar,Aurangabad(Maharashtra),Maharashtra',
'Borgaon Kasari,Aurangabad(Maharashtra),Maharashtra',
'Charner,Aurangabad(Maharashtra),Maharashtra',
'Deulgaon Bazar,Aurangabad(Maharashtra),Maharashtra',
'Gavli Tanda,Aurangabad(Maharashtra),Maharashtra',
'Gevrai Shami,Aurangabad(Maharashtra),Maharashtra',
'Ghatnanadra,Aurangabad(Maharashtra),Maharashtra',
'Golegaon,Aurangabad(Maharashtra),Maharashtra',
'Halda,Aurangabad(Maharashtra),Maharashtra',
'Hasnabad,Aurangabad(Maharashtra),Maharashtra',
'Hatti,Aurangabad(Maharashtra),Maharashtra',
'Jalgaon,Aurangabad(Maharashtra),Maharashtra',
'Kaigaon,Aurangabad(Maharashtra),Maharashtra',
'Kelgaon,Aurangabad(Maharashtra),Maharashtra',
'Kerhala,Aurangabad(Maharashtra),Maharashtra',
'Liha Khedi,Aurangabad(Maharashtra),Maharashtra',
'Lonwadi,Aurangabad(Maharashtra),Maharashtra',
'Madni,Aurangabad(Maharashtra),Maharashtra',
'Mangrul,Aurangabad(Maharashtra),Maharashtra',
'Modha BK,Aurangabad(Maharashtra),Maharashtra',
'Nillod,Aurangabad(Maharashtra),Maharashtra',
'Palod,Aurangabad(Maharashtra),Maharashtra',
'Palshi,Aurangabad(Maharashtra),Maharashtra',
'Rahemabad,Aurangabad(Maharashtra),Maharashtra',
'Relgaon,Aurangabad(Maharashtra),Maharashtra',
'Shivna,Aurangabad(Maharashtra),Maharashtra',
'Sillod,Aurangabad(Maharashtra),Maharashtra',
'Sillod Sakhar Karkhana,Aurangabad(Maharashtra),Maharashtra',
'Talni,Aurangabad(Maharashtra),Maharashtra',
'Tanda Bazar,Aurangabad(Maharashtra),Maharashtra',
'Undangaon,Aurangabad(Maharashtra),Maharashtra',
'Upali,Aurangabad(Maharashtra),Maharashtra',
'Wangi Khurd,Aurangabad(Maharashtra),Maharashtra',
'Warud KH,Aurangabad(Maharashtra),Maharashtra',
'Banoti,Aurangabad(Maharashtra),Maharashtra',
'Gondegaon,Aurangabad(Maharashtra),Maharashtra',
'Hanumantkheda,Aurangabad(Maharashtra),Maharashtra',
'Jamthi,Aurangabad(Maharashtra),Maharashtra',
'Jarandi,Aurangabad(Maharashtra),Maharashtra',
'Palaskheda,Aurangabad(Maharashtra),Maharashtra',
'Phardapur,Aurangabad(Maharashtra),Maharashtra',
'Sawaladbara,Aurangabad(Maharashtra),Maharashtra',
'Soegaon,Aurangabad(Maharashtra),Maharashtra',
'Tidka,Aurangabad(Maharashtra),Maharashtra',
'Wadgaon Tigji,Aurangabad(Maharashtra),Maharashtra',
'Akoli Wadgaon,Aurangabad(Maharashtra),Maharashtra',
'Babhulgaon (Pirachi),Aurangabad(Maharashtra),Maharashtra',
'Bhaggaon,Aurangabad(Maharashtra),Maharashtra',
'Bhagur,Aurangabad(Maharashtra),Maharashtra',
'Bhivgaon,Aurangabad(Maharashtra),Maharashtra',
'Biloni,Aurangabad(Maharashtra),Maharashtra',
'Borsar(Bhingi),Aurangabad(Maharashtra),Maharashtra',
'Chandgon,Aurangabad(Maharashtra),Maharashtra',
'Chikatgaon,Aurangabad(Maharashtra),Maharashtra',
'Chinchadgaon,Aurangabad(Maharashtra),Maharashtra',
'Chorwaghalgaon,Aurangabad(Maharashtra),Maharashtra',
'Dahegaon,Aurangabad(Maharashtra),Maharashtra',
'Dhondalgaon,Aurangabad(Maharashtra),Maharashtra',
'Gadhepimpalgaon,Aurangabad(Maharashtra),Maharashtra',
'Garaj,Aurangabad(Maharashtra),Maharashtra',
'Hingoni,Aurangabad(Maharashtra),Maharashtra',
'Jambhargaon,Aurangabad(Maharashtra),Maharashtra',
'Janephal,Aurangabad(Maharashtra),Maharashtra',
'Jategaon,Aurangabad(Maharashtra),Maharashtra',
'Karanjgaon,Aurangabad(Maharashtra),Maharashtra',
'Katepimpalgaon,Aurangabad(Maharashtra),Maharashtra',
'Khandala,Aurangabad(Maharashtra),Maharashtra',
'Kolhi,Aurangabad(Maharashtra),Maharashtra',
'Ladgaon,Aurangabad(Maharashtra),Maharashtra',
'Lakhani,Aurangabad(Maharashtra),Maharashtra',
'Lasurgaon,Aurangabad(Maharashtra),Maharashtra',
'Loni KH,Aurangabad(Maharashtra),Maharashtra',
'Mahalgaon,Aurangabad(Maharashtra),Maharashtra',
'Maleghogargaon,Aurangabad(Maharashtra),Maharashtra',
'Manur,Aurangabad(Maharashtra),Maharashtra',
'Nagamthan,Aurangabad(Maharashtra),Maharashtra',
'Nalegaon,Aurangabad(Maharashtra),Maharashtra',
'Palkheda,Aurangabad(Maharashtra),Maharashtra',
'Parala,Aurangabad(Maharashtra),Maharashtra',
'Parsoda,Aurangabad(Maharashtra),Maharashtra',
'Parsoda Sk,Aurangabad(Maharashtra),Maharashtra',
'Pokhari,Aurangabad(Maharashtra),Maharashtra',
'Rahegaon,Aurangabad(Maharashtra),Maharashtra',
'Rotegaon R.S.,Aurangabad(Maharashtra),Maharashtra',
'Savandgaon,Aurangabad(Maharashtra),Maharashtra',
'Shivar,Aurangabad(Maharashtra),Maharashtra',
'Shivrai,Aurangabad(Maharashtra),Maharashtra',
'Sirasgaon,Aurangabad(Maharashtra),Maharashtra',
'Talwada,Aurangabad(Maharashtra),Maharashtra',
'Tunki,Aurangabad(Maharashtra),Maharashtra',
'Vaijapur,Aurangabad(Maharashtra),Maharashtra',
'Vaijapur Town,Aurangabad(Maharashtra),Maharashtra',
'Veergaon,Aurangabad(Maharashtra),Maharashtra',
'Wakla,Aurangabad(Maharashtra),Maharashtra',
'Wanjargaon,Aurangabad(Maharashtra),Maharashtra',
'Balegaon,Aurangabad(Maharashtra),Maharashtra',
'Bardapur,Beed,Maharashtra',
'Saigaon,Beed,Maharashtra',
'Yusuf Wadgaon,Beed,Maharashtra',
'Adas,Beed,Maharashtra',
'Ambajogai,Beed,Maharashtra',
'Ambasakhar,Beed,Maharashtra',
'Apegaon,Beed,Maharashtra',
'Bansorala,Beed,Maharashtra',
'Borisawargaon,Beed,Maharashtra',
'Chanai,Beed,Maharashtra',
'Deola,Beed,Maharashtra',
'Dhanegaon Camp,Beed,Maharashtra',
'Dhanora,Beed,Maharashtra',
'Dighol Amba,Beed,Maharashtra',
'Dongar Pimpla,Beed,Maharashtra',
'Ghatnandur,Beed,Maharashtra',
'Girwali,Beed,Maharashtra',
'Hatola,Beed,Maharashtra',
'Hoal,Beed,Maharashtra',
'Jawalban,Beed,Maharashtra',
'Jawalgaon,Beed,Maharashtra',
'Ladewadgaon,Beed,Maharashtra',
'Lokhandi Sawargaon,Beed,Maharashtra',
'Naigaon,Beed,Maharashtra',
'Patoda,Beed,Maharashtra',
'Pattiwadgaon,Beed,Maharashtra',
'Pimpla Dhaiguda,Beed,Maharashtra',
'Poos,Beed,Maharashtra',
'Radi,Beed,Maharashtra',
'Reaviwar Peth,Beed,Maharashtra',
'Salunkwadi,Beed,Maharashtra',
'Sawaleswar Paithan,Beed,Maharashtra',
'Somnath Borgaon,Beed,Maharashtra',
'Sonwala,Beed,Maharashtra',
'Suggaon,Beed,Maharashtra',
'Ujani,Beed,Maharashtra',
'Warwati,Beed,Maharashtra',
'Yelda,Beed,Maharashtra',
'Ambhora,Beed,Maharashtra',
'Ashta Harinarayan,Beed,Maharashtra',
'Ashti,Beed,Maharashtra',
'Beed Sangvi,Beed,Maharashtra',
'Belgaon,Beed,Maharashtra',
'Bhalwani,Beed,Maharashtra',
'Brahmagaon,Beed,Maharashtra',
'Chikhali,Beed,Maharashtra',
'Dadegaon,Beed,Maharashtra',
'Deolali,Beed,Maharashtra',
'Deulgaon Ghat,Beed,Maharashtra',
'Devinimgaon,Beed,Maharashtra',
'Dhamangaon,Beed,Maharashtra',
'Dhanora,Beed,Maharashtra',
'Doithan,Beed,Maharashtra',
'Dongargan,Beed,Maharashtra',
'Gangadevi,Beed,Maharashtra',
'Ghatapimpri,Beed,Maharashtra',
'Hiwara,Beed,Maharashtra',
'Jamgoan,Beed,Maharashtra',
'Jogeswari Pargaon,Beed,Maharashtra',
'Kada,Beed,Maharashtra',
'Kadasakhar,Beed,Maharashtra',
'Karhewadgaon,Beed,Maharashtra',
'Kelsangvi,Beed,Maharashtra',
'Kerul,Beed,Maharashtra',
'Khadkat,Beed,Maharashtra',
'Khilad,Beed,Maharashtra',
'Kuntephal Pundi,Beed,Maharashtra',
'Loni,Beed,Maharashtra',
'Matawali,Beed,Maharashtra',
'Matkuli,Beed,Maharashtra',
'Nagtala,Beed,Maharashtra',
'Nimgaon Choba,Beed,Maharashtra',
'Patsara,Beed,Maharashtra',
'Pimpla,Beed,Maharashtra',
'Ruinalkol,Beed,Maharashtra',
'Saratewadgoan,Beed,Maharashtra',
'Sawargaon,Beed,Maharashtra',
'Shiral,Beed,Maharashtra',
'Suleman Deola,Beed,Maharashtra',
'Takalsingi,Beed,Maharashtra',
'Takli Amiya,Beed,Maharashtra',
'Wadgaon Daula,Beed,Maharashtra',
'Waghluj,Beed,Maharashtra',
'Wahira,Beed,Maharashtra',
'Welturi,Beed,Maharashtra',
'Adgaon,Beed,Maharashtra',
'Anjanwati,Beed,Maharashtra',
'Antharwan Pimpri,Beed,Maharashtra',
'Beed H.O,Beed,Maharashtra',
'Belura,Beed,Maharashtra',
'Borkhed,Beed,Maharashtra',
'Borphadi,Beed,Maharashtra',
'Chakarwadi,Beed,Maharashtra',
'Chartha,Beed,Maharashtra',
'Chousala,Beed,Maharashtra',
'Deola,Beed,Maharashtra',
'Devi Babhulgoan,Beed,Maharashtra',
'Dhekanmoha,Beed,Maharashtra',
'Dongar Patoda,Beed,Maharashtra',
'Ghatsawali,Beed,Maharashtra',
'Harichanra Pimpri,Beed,Maharashtra',
'Hingni BK,Beed,Maharashtra',
'Jeba Pimpri,Beed,Maharashtra',
'Kadiwadgaon,Beed,Maharashtra',
'Kalsambar,Beed,Maharashtra',
'Kamkheda,Beed,Maharashtra',
'Kawadgaon,Beed,Maharashtra',
'Khadkighat,Beed,Maharashtra',
'Khalwatnimgaon,Beed,Maharashtra',
'Kurla,Beed,Maharashtra',
'Limbaganesh,Beed,Maharashtra',
'Lonighat,Beed,Maharashtra',
'Mahalas Jawala,Beed,Maharashtra',
'Malapuri,Beed,Maharashtra',
'Manarsumba,Beed,Maharashtra',
'Mauj,Beed,Maharashtra',
'Morgaon,Beed,Maharashtra',
'Murshadpur,Beed,Maharashtra',
'Naholi,Beed,Maharashtra',
'Naiknoor,Beed,Maharashtra',
'Nalwandi,Beed,Maharashtra',
'Nandurghat,Beed,Maharashtra',
'Nathapur,Beed,Maharashtra',
'Nirgudi,Beed,Maharashtra',
'Pali,Beed,Maharashtra',
'Palshingan,Beed,Maharashtra',
'Palwan,Beed,Maharashtra',
'Parbhani Kesapuri,Beed,Maharashtra',
'Pargaon Shiras,Beed,Maharashtra',
'Pimpalgaon Ghat,Beed,Maharashtra',
'Pimpalner,Beed,Maharashtra',
'Pimpalwadi,Beed,Maharashtra',
'Pipmarkhed,Beed,Maharashtra',
'Pothra,Beed,Maharashtra',
'Rajuri Navgan,Beed,Maharashtra',
'Sakshas Pimpri,Beed,Maharashtra',
'Shirurghat,Beed,Maharashtra',
'Shivni,Beed,Maharashtra',
'Tadsonna,Beed,Maharashtra',
'Waghebabhulgaon,Beed,Maharashtra',
'Yellambghat,Beed,Maharashtra',
'Aherwahegaon,Beed,Maharashtra',
'Antarwali BK,Beed,Maharashtra',
'Ardha Pimpri,Beed,Maharashtra',
'Bagpimpalgoan,Beed,Maharashtra',
'Bangali Pimpla,Beed,Maharashtra',
'Bhogalgaon,Beed,Maharashtra',
'Borgaon BK,Beed,Maharashtra',
'Chaklamba,Beed,Maharashtra',
'Daithan,Beed,Maharashtra',
'Deo Pimpri,Beed,Maharashtra',
'Dhondrai,Beed,Maharashtra',
'Gevrai,Beed,Maharashtra',
'Ghogas Pargaon,Beed,Maharashtra',
'Gulaj,Beed,Maharashtra',
'Hirapur,Beed,Maharashtra',
'Jategaon,Beed,Maharashtra',
'Kekat Pangri,Beed,Maharashtra',
'Khalegaon,Beed,Maharashtra',
'Khandvi,Beed,Maharashtra',
'Kolgaon,Beed,Maharashtra',
'Madalmohi,Beed,Maharashtra',
'Malegaon KHD,Beed,Maharashtra',
'Mategoan,Beed,Maharashtra',
'Matori,Beed,Maharashtra',
'Nimgaon Mayamba,Beed,Maharashtra',
'Pachegaon,Beed,Maharashtra',
'Padalsingi,Beed,Maharashtra',
'Phulsangvi,Beed,Maharashtra',
'Raj Pimpri,Beed,Maharashtra',
'Rakashasbhuwan Shani,Beed,Maharashtra',
'Ranjani,Beed,Maharashtra',
'Reoki,Beed,Maharashtra',
'Ruithal,Beed,Maharashtra',
'Shekta,Beed,Maharashtra',
'Shirasdevi,Beed,Maharashtra',
'Shirasmarg,Beed,Maharashtra',
'Sushi,Beed,Maharashtra',
'Talnewadi,Beed,Maharashtra',
'Talwada,Beed,Maharashtra',
'Tintarwani,Beed,Maharashtra',
'Umapur,Beed,Maharashtra',
'Ambewadgaon,Beed,Maharashtra',
'Bhogalwadi,Beed,Maharashtra',
'Chardari,Beed,Maharashtra',
'Chikhalbeed,Beed,Maharashtra',
'Chinchwan,Beed,Maharashtra',
'Chondi,Beed,Maharashtra',
'Choramba,Beed,Maharashtra',
'Ghagarwada,Beed,Maharashtra',
'Kari,Beed,Maharashtra',
'Borgaon,Beed,Maharashtra',
'Chandan Sawargaon,Beed,Maharashtra',
'Chincholi,Beed,Maharashtra',
'Dahiphal Wadmauli,Beed,Maharashtra',
'Deogaon,Beed,Maharashtra',
'Jiwachiwadi,Beed,Maharashtra',
'Kaij,Beed,Maharashtra',
'Kalamamba,Beed,Maharashtra',
'Kalegoanghat,Beed,Maharashtra',
'Kumbephal,Beed,Maharashtra',
'Lahuri,Beed,Maharashtra',
'Malegaon,Beed,Maharashtra',
'Mangwadgaon,Beed,Maharashtra',
'Massajog,Beed,Maharashtra',
'Pahadi Pargaon,Beed,Maharashtra',
'Salegaon,Beed,Maharashtra',
'Sarni Sangvi,Beed,Maharashtra',
'Shindi,Beed,Maharashtra',
'Sonasangvi,Beed,Maharashtra',
'Takli,Beed,Maharashtra',
'Tambwa,Beed,Maharashtra',
'Undri,Beed,Maharashtra',
'Vida,Beed,Maharashtra',
'Warapgoan,Beed,Maharashtra',
'Yeota,Beed,Maharashtra',
'Asardoha,Beed,Maharashtra',
'Anjandoha,Beed,Maharashtra',
'Kille Dharur,Beed,Maharashtra',
'Anandgaon,Beed,Maharashtra',
'Badibadi,Beed,Maharashtra',
'Belura,Beed,Maharashtra',
'Bhendtakli,Beed,Maharashtra',
'Chinchala,Beed,Maharashtra',
'Deodahiphal,Beed,Maharashtra',
'Dindrood,Beed,Maharashtra',
'Gangamasla,Beed,Maharashtra',
'Goverdhan Hiwara,Beed,Maharashtra',
'Harkinnimgaon,Beed,Maharashtra',
'Hiwara,Beed,Maharashtra',
'Kesapuri Camp,Beed,Maharashtra',
'Kittiadgaon,Beed,Maharashtra',
'Kuppa,Beed,Maharashtra',
'Laul,Beed,Maharashtra',
'Majalgaon,Beed,Maharashtra',
'Mangrul,Beed,Maharashtra',
'Manjrath,Beed,Maharashtra',
'Nithrud,Beed,Maharashtra',
'Pathrood,Beed,Maharashtra',
'Pimpri BK,Beed,Maharashtra',
'Purshottampuri,Beed,Maharashtra',
'Rajegaon,Beed,Maharashtra',
'Rajewadi,Beed,Maharashtra',
'Rampuri,Beed,Maharashtra',
'Sadola,Beed,Maharashtra',
'Sandas Chincholi,Beed,Maharashtra',
'Sirsala,Beed,Maharashtra',
'Sonnathadi,Beed,Maharashtra',
'Takarwan,Beed,Maharashtra',
'Talkhed,Beed,Maharashtra',
'Telgoan,Beed,Maharashtra',
'Upali,Beed,Maharashtra',
'Waghora,Beed,Maharashtra',
'Wahegaon Amla,Beed,Maharashtra',
'Wangi,Beed,Maharashtra',
'Warola,Beed,Maharashtra',
'Phulepimpalgoan,Beed,Maharashtra',
'Hingni BK,Beed,Maharashtra',
'Moha,Beed,Maharashtra',
'Mohkhed,Beed,Maharashtra',
'Pohner,Beed,Maharashtra',
'Rui,Beed,Maharashtra',
'Umri,Beed,Maharashtra',
'Parli Tps,Beed,Maharashtra',
'Tokwadi,Beed,Maharashtra',
'Belamba,Beed,Maharashtra',
'Dharmapuri,Beed,Maharashtra',
'Halam,Beed,Maharashtra',
'Kanherwadi,Beed,Maharashtra',
'Kauthali,Beed,Maharashtra',
'Khodwa Sawargaon,Beed,Maharashtra',
'Mandva,Beed,Maharashtra',
'Mirwat,Beed,Maharashtra',
'Nagapur,Beed,Maharashtra',
'Nandagaul,Beed,Maharashtra',
'Pangri,Beed,Maharashtra',
'Pimpalgoan Gadhe,Beed,Maharashtra',
'Parli Vaijinath,Beed,Maharashtra',
'Vssk Pangri,Beed,Maharashtra',
'Dadahari Wadgaon,Beed,Maharashtra',
'Amalner,Beed,Maharashtra',
'Bensur,Beed,Maharashtra',
'Chikhali,Beed,Maharashtra',
'Daskhed,Beed,Maharashtra',
'Dhangarjawalka,Beed,Maharashtra',
'Domri,Beed,Maharashtra',
'Dongarkinhi,Beed,Maharashtra',
'Jatnandur,Beed,Maharashtra',
'Karegaon,Beed,Maharashtra',
'Kotan,Beed,Maharashtra',
'Kuslamb,Beed,Maharashtra',
'Muggaon,Beed,Maharashtra',
'Naigaon,Beed,Maharashtra',
'Pachangri,Beed,Maharashtra',
'Pangri,Beed,Maharashtra',
'Pargaon Ghumra,Beed,Maharashtra',
'Parner,Beed,Maharashtra',
'Patoda,Beed,Maharashtra',
'Pimpalgaon Dhas,Beed,Maharashtra',
'Pimpalner,Beed,Maharashtra',
'Pimpalwandi,Beed,Maharashtra',
'Rohatwadi,Beed,Maharashtra',
'Sautada,Beed,Maharashtra',
'Sawargaon Ghat,Beed,Maharashtra',
'Tambarajuri,Beed,Maharashtra',
'Therla,Beed,Maharashtra',
'Vaidyakinhi,Beed,Maharashtra',
'Waghira,Beed,Maharashtra',
'Ghatshilpargaon,Beed,Maharashtra',
'Loni,Beed,Maharashtra',
'Manur,Beed,Maharashtra',
'Padali,Beed,Maharashtra',
'Rakshas Bhuwan Tamba,Beed,Maharashtra',
'Shirur,Beed,Maharashtra',
'Warni,Beed,Maharashtra',
'Yellamb Bhrahmanath,Beed,Maharashtra',
'Arvi,Beed,Maharashtra',
'Raimoha,Beed,Maharashtra',
'Khalapuri,Beed,Maharashtra',
'Khokarmoha,Beed,Maharashtra',
'Wadwani,Beed,Maharashtra',
'Bhandara H.O,Nagpur Moffusil,Maharashtra',
'Bhandara Of,Nagpur Moffusil,Maharashtra',
'Bhandara Road,Nagpur Moffusil,Maharashtra',
'Bhandara Town,Nagpur Moffusil,Maharashtra',
'Chandori,Nagpur Moffusil,Maharashtra',
'Dawadipar,Nagpur Moffusil,Maharashtra',
'Kardha,Nagpur Moffusil,Maharashtra',
'Kothurna,Nagpur Moffusil,Maharashtra',
'Mandvi,Nagpur Moffusil,Maharashtra',
'Manegaon,Nagpur Moffusil,Maharashtra',
'Matora,Nagpur Moffusil,Maharashtra',
'Minshi,Nagpur Moffusil,Maharashtra',
'Mohdura,Nagpur Moffusil,Maharashtra',
'Pahela,Nagpur Moffusil,Maharashtra',
'Pipri,Nagpur Moffusil,Maharashtra',
'Shahpur,Nagpur Moffusil,Maharashtra',
'Silli,Nagpur Moffusil,Maharashtra',
'Thana Petrol Pump,Nagpur Moffusil,Maharashtra',
'Bela,Nagpur Moffusil,Maharashtra',
'Barwa,Nagpur Moffusil,Maharashtra',
'Bhagdi,Nagpur Moffusil,Maharashtra',
'Dighori,Nagpur Moffusil,Maharashtra',
'Hardoli,Nagpur Moffusil,Maharashtra',
'Kharashi,Nagpur Moffusil,Maharashtra',
'Kudegaon,Nagpur Moffusil,Maharashtra',
'Lakhandur,Nagpur Moffusil,Maharashtra',
'Moharna,Nagpur Moffusil,Maharashtra',
'Opera,Nagpur Moffusil,Maharashtra',
'Palandur,Nagpur Moffusil,Maharashtra',
'Pardi,Nagpur Moffusil,Maharashtra',
'Pimpalgaon Kohli,Nagpur Moffusil,Maharashtra',
'Soni Chapral,Nagpur Moffusil,Maharashtra',
'Amgaon Dighori,Nagpur Moffusil,Maharashtra',
'Bhugaon,Nagpur Moffusil,Maharashtra',
'Channa,Nagpur Moffusil,Maharashtra',
'Dhargaon,Nagpur Moffusil,Maharashtra',
'Gadegaon,Nagpur Moffusil,Maharashtra',
'Gunthara,Nagpur Moffusil,Maharashtra',
'Gurdha,Nagpur Moffusil,Maharashtra',
'Kanheri,Nagpur Moffusil,Maharashtra',
'Kesalwada,Nagpur Moffusil,Maharashtra',
'Kolari,Nagpur Moffusil,Maharashtra',
'Lakhni,Nagpur Moffusil,Maharashtra',
'Lakhori,Nagpur Moffusil,Maharashtra',
'Miregaon,Nagpur Moffusil,Maharashtra',
'Murmadi,Nagpur Moffusil,Maharashtra',
'Pimpalgaon Sadak,Nagpur Moffusil,Maharashtra',
'Pohra,Nagpur Moffusil,Maharashtra',
'Rengepar,Nagpur Moffusil,Maharashtra',
'Salebhata,Nagpur Moffusil,Maharashtra',
'Seloti,Nagpur Moffusil,Maharashtra',
'Shioni,Nagpur Moffusil,Maharashtra',
'Andhalgaon,Nagpur Moffusil,Maharashtra',
'Betara,Nagpur Moffusil,Maharashtra',
'Dongargaon,Nagpur Moffusil,Maharashtra',
'Hardoli,Nagpur Moffusil,Maharashtra',
'Jamb,Nagpur Moffusil,Maharashtra',
'Kanalgaon,Nagpur Moffusil,Maharashtra',
'Kandri,Nagpur Moffusil,Maharashtra',
'Kardi,Nagpur Moffusil,Maharashtra',
'Koka,Nagpur Moffusil,Maharashtra',
'Mandesar,Nagpur Moffusil,Maharashtra',
'Mohadi,Nagpur Moffusil,Maharashtra',
'Mohgaon Devi,Nagpur Moffusil,Maharashtra',
'Mundri BK,Nagpur Moffusil,Maharashtra',
'Navegaon BK,Nagpur Moffusil,Maharashtra',
'Neri,Nagpur Moffusil,Maharashtra',
'Palora,Nagpur Moffusil,Maharashtra',
'Salaikhurd,Nagpur Moffusil,Maharashtra',
'Adyar,Nagpur Moffusil,Maharashtra',
'Akot,Nagpur Moffusil,Maharashtra',
'Amgaon Adarsh Pauni,Nagpur Moffusil,Maharashtra',
'Asgaon,Nagpur Moffusil,Maharashtra',
'Belati,Nagpur Moffusil,Maharashtra',
'Bhawad,Nagpur Moffusil,Maharashtra',
'Bhendala,Nagpur Moffusil,Maharashtra',
'Bhuyar,Nagpur Moffusil,Maharashtra',
'Chinchal,Nagpur Moffusil,Maharashtra',
'Erli Khandar,Nagpur Moffusil,Maharashtra',
'Gosi BK,Nagpur Moffusil,Maharashtra',
'Irli BK,Nagpur Moffusil,Maharashtra',
'Itan,Nagpur Moffusil,Maharashtra',
'Kanhalgaon,Nagpur Moffusil,Maharashtra',
'Khapri,Nagpur Moffusil,Maharashtra',
'Kitadi,Nagpur Moffusil,Maharashtra',
'Kodurli,Nagpur Moffusil,Maharashtra',
'Konda Kosra,Nagpur Moffusil,Maharashtra',
'Kurza,Nagpur Moffusil,Maharashtra',
'Mangli,Nagpur Moffusil,Maharashtra',
'Masal,Nagpur Moffusil,Maharashtra',
'Nerla,Nagpur Moffusil,Maharashtra',
'Palora,Nagpur Moffusil,Maharashtra',
'Pauni,Nagpur Moffusil,Maharashtra',
'Pimpalgaon Nipani,Nagpur Moffusil,Maharashtra',
'Sarandi,Nagpur Moffusil,Maharashtra',
'Sawarla,Nagpur Moffusil,Maharashtra',
'Walni,Nagpur Moffusil,Maharashtra',
'Amgaon BK,Nagpur Moffusil,Maharashtra',
'Bampewada,Nagpur Moffusil,Maharashtra',
'Chandori,Nagpur Moffusil,Maharashtra',
'Khandala,Nagpur Moffusil,Maharashtra',
'Kumbhali,Nagpur Moffusil,Maharashtra',
'Lawri Umri,Nagpur Moffusil,Maharashtra',
'Malutola,Nagpur Moffusil,Maharashtra',
'Pindkepar,Nagpur Moffusil,Maharashtra',
'Sakoli,Nagpur Moffusil,Maharashtra',
'Sangadi,Nagpur Moffusil,Maharashtra',
'Sasra,Nagpur Moffusil,Maharashtra',
'Satalwada,Nagpur Moffusil,Maharashtra',
'Sendurwafa,Nagpur Moffusil,Maharashtra',
'Virshi,Nagpur Moffusil,Maharashtra',
'Wadad,Nagpur Moffusil,Maharashtra',
'Yekodi (Sakoli),Nagpur Moffusil,Maharashtra',
'Ashti,Nagpur Moffusil,Maharashtra',
'Bapera,Nagpur Moffusil,Maharashtra',
'Chikhla Basti,Nagpur Moffusil,Maharashtra',
'Chikhla,Nagpur Moffusil,Maharashtra',
'Chincholi (Tumsar),Nagpur Moffusil,Maharashtra',
'Chulhad,Nagpur Moffusil,Maharashtra',
'Devada Bzk,Nagpur Moffusil,Maharashtra',
'Dongri BK,Nagpur Moffusil,Maharashtra',
'Garra Bageda,Nagpur Moffusil,Maharashtra',
'Gobarwahi,Nagpur Moffusil,Maharashtra',
'Khapa,Nagpur Moffusil,Maharashtra',
'Lendezari,Nagpur Moffusil,Maharashtra',
'Lobhi,Nagpur Moffusil,Maharashtra',
'Madgi,Nagpur Moffusil,Maharashtra',
'Mitewani,Nagpur Moffusil,Maharashtra',
'Mohgaon Khadan,Nagpur Moffusil,Maharashtra',
'Nakadongri,Nagpur Moffusil,Maharashtra',
'Sihora,Nagpur Moffusil,Maharashtra',
'Tumsar Road,Nagpur Moffusil,Maharashtra',
'Tumsar,Nagpur Moffusil,Maharashtra',
'Umarwada,Nagpur Moffusil,Maharashtra',
'Wahani,Nagpur Moffusil,Maharashtra',
'Yerli,Nagpur Moffusil,Maharashtra',
'Dahid,Buldana,Maharashtra',
'Dhotra Bhangoji,Buldana,Maharashtra',
'Bhadgaon,Buldana,Maharashtra',
'Bhadola,Buldana,Maharashtra',
'Buldana H.O,Buldana,Maharashtra',
'Chaitanya Wadi,Buldana,Maharashtra',
'Chandol,Buldana,Maharashtra',
'Deulghat,Buldana,Maharashtra',
'Dhad,Buldana,Maharashtra',
'Dhalsawangi,Buldana,Maharashtra',
'Dhamangaon,Buldana,Maharashtra',
'Dongar Khandala,Buldana,Maharashtra',
'Dongarshewali,Buldana,Maharashtra',
'Dudha,Buldana,Maharashtra',
'Gummi,Buldana,Maharashtra',
'Hatedi,Buldana,Maharashtra',
'Jamb,Buldana,Maharashtra',
'Kesapur,Buldana,Maharashtra',
'Kolwad,Buldana,Maharashtra',
'Madh,Buldana,Maharashtra',
'Masrul,Buldana,Maharashtra',
'Mhasla BK,Buldana,Maharashtra',
'Nandra Koli,Buldana,Maharashtra',
'Padali,Buldana,Maharashtra',
'Pangri,Buldana,Maharashtra',
'Pimpalgaon Sarai,Buldana,Maharashtra',
'Raipur,Buldana,Maharashtra',
'Sagwan,Buldana,Maharashtra',
'Sakhali,Buldana,Maharashtra',
'Sao,Buldana,Maharashtra',
'Satgaon Mhasla,Buldana,Maharashtra',
'Shirpur,Buldana,Maharashtra',
'Sundarkhed,Buldana,Maharashtra',
'Warud,Buldana,Maharashtra',
'Warwand,Buldana,Maharashtra',
'Yelgaon,Buldana,Maharashtra',
'Isoli,Buldana,Maharashtra',
'Karwand,Buldana,Maharashtra',
'Mangrul Navghare,Buldana,Maharashtra',
'Takarkhed Helga,Buldana,Maharashtra',
'Toranwada,Buldana,Maharashtra',
'Amdapur,Buldana,Maharashtra',
'Borgaon Kakde,Buldana,Maharashtra',
'Chikhli,Buldana,Maharashtra',
'Cotton Market Chikhli,Buldana,Maharashtra',
'Dahigaon,Buldana,Maharashtra',
'Eklara,Buldana,Maharashtra',
'Godri,Buldana,Maharashtra',
'Hatni,Buldana,Maharashtra',
'Kawhala,Buldana,Maharashtra',
'Kelwad,Buldana,Maharashtra',
'Khandala Makardhwaj,Buldana,Maharashtra',
'Kinhola,Buldana,Maharashtra',
'Mera BK,Buldana,Maharashtra',
'Mera Khurd,Buldana,Maharashtra',
'Palaskhed Daulat,Buldana,Maharashtra',
'Peth,Buldana,Maharashtra',
'Sakegaon,Buldana,Maharashtra',
'Satgaon Bhusari,Buldana,Maharashtra',
'Savkhed Nagare,Buldana,Maharashtra',
'Sawana,Buldana,Maharashtra',
'Sawargaon Dukare,Buldana,Maharashtra',
'Shelsur,Buldana,Maharashtra',
'Undri,Buldana,Maharashtra',
'Digras BK,Buldana,Maharashtra',
'Mehuna,Buldana,Maharashtra',
'Pimpalgaon BK,Buldana,Maharashtra',
'Saramba,Buldana,Maharashtra',
'Sawangi Tekale,Buldana,Maharashtra',
'Aland,Buldana,Maharashtra',
'Ambashi,Buldana,Maharashtra',
'Ancharwadi,Buldana,Maharashtra',
'Andhera,Buldana,Maharashtra',
'Antri Khedekar,Buldana,Maharashtra',
'Bharosa,Buldana,Maharashtra',
'Borakhedi Bawra,Buldana,Maharashtra',
'Deulgaon Dhangar,Buldana,Maharashtra',
'Deulgaon Mahi,Buldana,Maharashtra',
'Deulgaon Raja,Buldana,Maharashtra',
'Isrul,Buldana,Maharashtra',
'Khallad Gavhan,Buldana,Maharashtra',
'Kolara,Buldana,Maharashtra',
'Mendgaon,Buldana,Maharashtra',
'Saokhed Bhoi,Buldana,Maharashtra',
'Shelgaon Atol,Buldana,Maharashtra',
'Singaon Jahagir,Buldana,Maharashtra',
'Tuljapur,Buldana,Maharashtra',
'Umbarkhed,Buldana,Maharashtra',
'Gangalgaon,Buldana,Maharashtra',
'Asalgaon,Buldana,Maharashtra',
'Bhenwad,Buldana,Maharashtra',
'Chaora,Buldana,Maharashtra',
'Jalgaon,Buldana,Maharashtra',
'Jamod,Buldana,Maharashtra',
'Kherda,Buldana,Maharashtra',
'Madakhed,Buldana,Maharashtra',
'Pimpalgaon Kale,Buldana,Maharashtra',
'Sawargaon,Buldana,Maharashtra',
'Sungaon,Buldana,Maharashtra',
'Wadner Bholaji,Buldana,Maharashtra',
'Wadshingi,Buldana,Maharashtra',
'Borjawala,Buldana,Maharashtra',
'Adol BK,Buldana,Maharashtra',
'Ambetakli,Buldana,Maharashtra',
'Antraj,Buldana,Maharashtra',
'Atali,Buldana,Maharashtra',
'Awar,Buldana,Maharashtra',
'Bori Adgaon,Buldana,Maharashtra',
'Botha Kazi,Buldana,Maharashtra',
'Chinchpur,Buldana,Maharashtra',
'Chitoda,Buldana,Maharashtra',
'Dhanora Mahasidha,Buldana,Maharashtra',
'Dhorapgaon,Buldana,Maharashtra',
'Dhotra Naik,Buldana,Maharashtra',
'G.S.College Khamgaon,Buldana,Maharashtra',
'Gadegaon Khurd,Buldana,Maharashtra',
'Ganeshpur,Buldana,Maharashtra',
'Ghanegaon,Buldana,Maharashtra',
'Gharod,Buldana,Maharashtra',
'Gondhanapur,Buldana,Maharashtra',
'Hingna Karegaon,Buldana,Maharashtra',
'Hiwarkhed,Buldana,Maharashtra',
'Jalka Bhadang,Buldana,Maharashtra',
'Kalegaon,Buldana,Maharashtra',
'Kelanagar,Buldana,Maharashtra',
'Khamgaon H.O,Buldana,Maharashtra',
'Khandvi,Buldana,Maharashtra',
'Lakhanwada,Buldana,Maharashtra',
'Lasura Khurd,Buldana,Maharashtra',
'Lokhanda,Buldana,Maharashtra',
'Loni Gurao,Buldana,Maharashtra',
'M.I.D.C. (Khamgaon),Buldana,Maharashtra',
'Nipana,Buldana,Maharashtra',
'Palshi BK,Buldana,Maharashtra',
'Palsi Supo,Buldana,Maharashtra',
'Pimpalgaon Raja,Buldana,Maharashtra',
'Pimpri Gaoli,Buldana,Maharashtra',
'Poraj,Buldana,Maharashtra',
'Rohana,Buldana,Maharashtra',
'Sarafa Khamgaon,Buldana,Maharashtra',
'Shahapur,Buldana,Maharashtra',
'Shirala Nemane,Buldana,Maharashtra',
'Sutala BK,Buldana,Maharashtra',
'Tembhurna,Buldana,Maharashtra',
'Vihigaon,Buldana,Maharashtra',
'Warna,Buldana,Maharashtra',
'Wazar,Buldana,Maharashtra',
'Bhalegaon Bazar,Buldana,Maharashtra',
'Dadulgaon,Buldana,Maharashtra',
'Garadgaon,Buldana,Maharashtra',
'Veni,Buldana,Maharashtra',
'Anjani Khurd,Buldana,Maharashtra',
'Bhumrala,Buldana,Maharashtra',
'Bibi,Buldana,Maharashtra',
'Gandhari,Buldana,Maharashtra',
'Hirdao,Buldana,Maharashtra',
'Jambhul,Buldana,Maharashtra',
'Khalegaon,Buldana,Maharashtra',
'Kingaon Jattu,Buldana,Maharashtra',
'Lonar,Buldana,Maharashtra',
'Naigaon,Buldana,Maharashtra',
'Nandra,Buldana,Maharashtra',
'Pangra Dole,Buldana,Maharashtra',
'Pimpri Khandare,Buldana,Maharashtra',
'Shara,Buldana,Maharashtra',
'Shioni Pisa,Buldana,Maharashtra',
'Somthana,Buldana,Maharashtra',
'Sultanpur,Buldana,Maharashtra',
'Tambola,Buldana,Maharashtra',
'Tivtivi,Buldana,Maharashtra',
'Wadgaon Tejan,Buldana,Maharashtra',
'Wadhao,Buldana,Maharashtra',
'Belad,Buldana,Maharashtra',
'Bhadgani,Buldana,Maharashtra',
'Bhalegaon,Buldana,Maharashtra',
'Chikhali,Buldana,Maharashtra',
'Dabhadi,Buldana,Maharashtra',
'Dasarkhed,Buldana,Maharashtra',
'Datala,Buldana,Maharashtra',
'Deodhaba,Buldana,Maharashtra',
'Dharangaon,Buldana,Maharashtra',
'Dighi,Buldana,Maharashtra',
'Dudhalgaon BK,Buldana,Maharashtra',
'Ghirni,Buldana,Maharashtra',
'Harankhed,Buldana,Maharashtra',
'Harsoda,Buldana,Maharashtra',
'Jambhuldhaba,Buldana,Maharashtra',
'Khamkhed,Buldana,Maharashtra',
'Malkapur City,Buldana,Maharashtra',
'Malkapur,Buldana,Maharashtra',
'Mhaiswadi,Buldana,Maharashtra',
'Narvel,Buldana,Maharashtra',
'Panhera Wadoda,Buldana,Maharashtra',
'Shiradhon,Buldana,Maharashtra',
'Tadulwadi,Buldana,Maharashtra',
'Umali,Buldana,Maharashtra',
'Vivara,Buldana,Maharashtra',
'Wadaji,Buldana,Maharashtra',
'Warkhed,Buldana,Maharashtra',
'Zodga,Buldana,Maharashtra',
'Anjani BK,Buldana,Maharashtra',
'Antri Deshmukh,Buldana,Maharashtra',
'Aregaon,Buldana,Maharashtra',
'Belgaon,Buldana,Maharashtra',
'Bhosa,Buldana,Maharashtra',
'Bramhapuri,Buldana,Maharashtra',
'Chaigaon,Buldana,Maharashtra',
'Chincholi Bore,Buldana,Maharashtra',
'Deulgaon Mali,Buldana,Maharashtra',
'Deulgaon Sakharsha,Buldana,Maharashtra',
'Dongaon,Buldana,Maharashtra',
'Ghatbori,Buldana,Maharashtra',
'Gohogaon,Buldana,Maharashtra',
'Hiwara BK,Buldana,Maharashtra',
'Hiwara Khurd,Buldana,Maharashtra',
'Janephal,Buldana,Maharashtra',
'Kalambeshwar,Buldana,Maharashtra',
'Kalyana,Buldana,Maharashtra',
'Lawhala,Buldana,Maharashtra',
'Loni Gaoli,Buldana,Maharashtra',
'Mehkar,Buldana,Maharashtra',
'Mola,Buldana,Maharashtra',
'Naigaon Duttapur,Buldana,Maharashtra',
'Pangarkhed,Buldana,Maharashtra',
'Parkhed,Buldana,Maharashtra',
'Pimpalgaon Unda,Buldana,Maharashtra',
'Pimpri Mali,Buldana,Maharashtra',
'Sarshiv,Buldana,Maharashtra',
'Shelgaon Deshmukh,Buldana,Maharashtra',
'Shendla,Buldana,Maharashtra',
'Sonati,Buldana,Maharashtra',
'Ukali,Buldana,Maharashtra',
'Uti,Buldana,Maharashtra',
'Vishvi,Buldana,Maharashtra',
'Wadgaon Mali,Buldana,Maharashtra',
'Warwand,Buldana,Maharashtra',
'Advihir,Buldana,Maharashtra',
'Awha Yunuspur,Buldana,Maharashtra',
'Borakhedi,Buldana,Maharashtra',
'Dhamangaon Badhe,Buldana,Maharashtra',
'Jaipur,Buldana,Maharashtra',
'Khaira,Buldana,Maharashtra',
'Kharbadi,Buldana,Maharashtra',
'Korhala,Buldana,Maharashtra',
'Kothali,Buldana,Maharashtra',
'Liha BK,Buldana,Maharashtra',
'Makodi,Buldana,Maharashtra',
'Motala,Buldana,Maharashtra',
'Nalgangapur,Buldana,Maharashtra',
'Nimkhed,Buldana,Maharashtra',
'Nipana,Buldana,Maharashtra',
'Panhera,Buldana,Maharashtra',
'Pimpalgaon Devi,Buldana,Maharashtra',
'Pimpri Gawali,Buldana,Maharashtra',
'Pophali,Buldana,Maharashtra',
'Rajur,Buldana,Maharashtra',
'Rohinkhed,Buldana,Maharashtra',
'Sarola Maroti,Buldana,Maharashtra',
'Shelapur,Buldana,Maharashtra',
'Shelgaon Bazar,Buldana,Maharashtra',
'Shemba,Buldana,Maharashtra',
'Sindkhed Lapali,Buldana,Maharashtra',
'Takarkhed,Buldana,Maharashtra',
'Talkhed,Buldana,Maharashtra',
'Talni,Buldana,Maharashtra',
'Yerli,Buldana,Maharashtra',
'Alampur,Buldana,Maharashtra',
'Bhajisath Nandura,Buldana,Maharashtra',
'Chandur Biswa,Buldana,Maharashtra',
'Dahigaon M,Buldana,Maharashtra',
'Dhanora Vitali,Buldana,Maharashtra',
'Jigaon,Buldana,Maharashtra',
'Khumgaon,Buldana,Maharashtra',
'Malegaon,Buldana,Maharashtra',
'Mamulwadi,Buldana,Maharashtra',
'Mendhali,Buldana,Maharashtra',
'Mominabad,Buldana,Maharashtra',
'Naigaon,Buldana,Maharashtra',
'Nandura,Buldana,Maharashtra',
'Nandura Town,Buldana,Maharashtra',
'Narkhed,Buldana,Maharashtra',
'Nimgaon,Buldana,Maharashtra',
'Shelgaon Mukund,Buldana,Maharashtra',
'Wadi,Buldana,Maharashtra',
'Wasadi BK,Buldana,Maharashtra',
'Bodkha,Buldana,Maharashtra',
'Jastgaon,Buldana,Maharashtra',
'Kankanwada,Buldana,Maharashtra',
'Kavthal,Buldana,Maharashtra',
'Kodri,Buldana,Maharashtra',
'Niwana,Buldana,Maharashtra',
'Palsi Zanshi,Buldana,Maharashtra',
'Paturda,Buldana,Maharashtra',
'Rudhana,Buldana,Maharashtra',
'Sangrampur,Buldana,Maharashtra',
'Sonala,Buldana,Maharashtra',
'Wankhed,Buldana,Maharashtra',
'Warwat Bakal,Buldana,Maharashtra',
'Warwat Khanderao,Buldana,Maharashtra',
'Jawala BK,Buldana,Maharashtra',
'Adsul,Buldana,Maharashtra',
'Alsana,Buldana,Maharashtra',
'Amboda,Buldana,Maharashtra',
'Bhongaon,Buldana,Maharashtra',
'Bhota,Buldana,Maharashtra',
'Chincholi Karfarma,Buldana,Maharashtra',
'Gawhan,Buldana,Maharashtra',
'Jalamb,Buldana,Maharashtra',
'Janori Nipana,Buldana,Maharashtra',
'Kherda,Buldana,Maharashtra',
'Lanjud,Buldana,Maharashtra',
'Manasgaon,Buldana,Maharashtra',
'Matergaon,Buldana,Maharashtra',
'Nagzari,Buldana,Maharashtra',
'Pahurjira,Buldana,Maharashtra',
'Pimpri Deshmukh,Buldana,Maharashtra',
'Rokdiya Nagar,Buldana,Maharashtra',
'Sagoda,Buldana,Maharashtra',
'Shegaon,Buldana,Maharashtra',
'Takli Viro,Buldana,Maharashtra',
'Zadegaon,Buldana,Maharashtra',
'Adgaon Raja,Buldana,Maharashtra',
'Changephal,Buldana,Maharashtra',
'Daregaon,Buldana,Maharashtra',
'Dawargaon,Buldana,Maharashtra',
'Deulgaon Kol,Buldana,Maharashtra',
'Gunj,Buldana,Maharashtra',
'Hiwarkhed,Buldana,Maharashtra',
'Jambhora,Buldana,Maharashtra',
'Kingaon Raja,Buldana,Maharashtra',
'Malkapur Pangra,Buldana,Maharashtra',
'Raheri BK,Buldana,Maharashtra',
'Rajegaon,Buldana,Maharashtra',
'Sakhar Kherda,Buldana,Maharashtra',
'Saokhed Tejan,Buldana,Maharashtra',
'Sawadad,Buldana,Maharashtra',
'Shendurjan,Buldana,Maharashtra',
'Shioni Taka,Buldana,Maharashtra',
'Sindi,Buldana,Maharashtra',
'Sindkhed Raja,Buldana,Maharashtra',
'Sonoshi,Buldana,Maharashtra',
'Tadshioni,Buldana,Maharashtra',
'Umrad,Buldana,Maharashtra',
'Waghala,Buldana,Maharashtra',
'Wardadi BK,Buldana,Maharashtra',
'Zotinga,Buldana,Maharashtra',
'Dusarbid,Buldana,Maharashtra',
'Banoda Eklara,Buldana,Maharashtra',
'Bawanbir,Buldana,Maharashtra',
'Katel Kolad,Buldana,Maharashtra',
'Ladnapur,Buldana,Maharashtra',
'Tunki,Buldana,Maharashtra',
'Chargaon KD,Chandrapur,Maharashtra',
'Dewada Khurd,Chandrapur,Maharashtra',
'Durgapur,Chandrapur,Maharashtra',
'Gogaon,Chandrapur,Maharashtra',
'Nandpa,Chandrapur,Maharashtra',
'Palasgaon Jat,Chandrapur,Maharashtra',
'Pardi,Chandrapur,Maharashtra',
'Ballarpur Colliery,Chandrapur,Maharashtra',
'Ballarpur Paper Mill,Chandrapur,Maharashtra',
'Ballarpur Power House,Chandrapur,Maharashtra',
'Ballarpur,Chandrapur,Maharashtra',
'Dudholi Bamini,Chandrapur,Maharashtra',
'Kothari,Chandrapur,Maharashtra',
'Manora,Chandrapur,Maharashtra',
'Nandgaon Podey,Chandrapur,Maharashtra',
'Palasgaon,Chandrapur,Maharashtra',
'Umari Potdar,Chandrapur,Maharashtra',
'Visapur,Chandrapur,Maharashtra',
'Ashta,Chandrapur,Maharashtra',
'Belgaon,Chandrapur,Maharashtra',
'Bhadrawati,Chandrapur,Maharashtra',
'Chandankheda,Chandrapur,Maharashtra',
'Chora,Chandrapur,Maharashtra',
'Ghodpeth,Chandrapur,Maharashtra',
'Gulgaon,Chandrapur,Maharashtra',
'Jena,Chandrapur,Maharashtra',
'Kacharala,Chandrapur,Maharashtra',
'Khadsangi,Chandrapur,Maharashtra',
'Kondha,Chandrapur,Maharashtra',
'Kuchana,Chandrapur,Maharashtra',
'Mohorli,Chandrapur,Maharashtra',
'Patala,Chandrapur,Maharashtra',
'Pirli,Chandrapur,Maharashtra',
'Sagra,Chandrapur,Maharashtra',
'Segaon KD,Chandrapur,Maharashtra',
'Shivjinagar,Chandrapur,Maharashtra',
'Sumthana,Chandrapur,Maharashtra',
'Viloda,Chandrapur,Maharashtra',
'Wadadha,Chandrapur,Maharashtra',
'Waigaon Tukum,Chandrapur,Maharashtra',
'Kurumwelli,Chandrapur,Maharashtra',
'Adyal Tekadi,Chandrapur,Maharashtra',
'Arher Nawargaon,Chandrapur,Maharashtra',
'Awalgaon,Chandrapur,Maharashtra',
'Baradkinhi,Chandrapur,Maharashtra',
'Bramhapuri,Chandrapur,Maharashtra',
'Chaugaon,Chandrapur,Maharashtra',
'Gangalwadi,Chandrapur,Maharashtra',
'Halda,Chandrapur,Maharashtra',
'Hardoli,Chandrapur,Maharashtra',
'Jugnala,Chandrapur,Maharashtra',
'Kahali,Chandrapur,Maharashtra',
'Kalamgaon,Chandrapur,Maharashtra',
'Kalamgaon,Chandrapur,Maharashtra',
'Khed,Chandrapur,Maharashtra',
'Kinhi,Chandrapur,Maharashtra',
'Kirmitimendha,Chandrapur,Maharashtra',
'Kurza,Chandrapur,Maharashtra',
'Mendki,Chandrapur,Maharashtra',
'Mudza,Chandrapur,Maharashtra',
'Nandgaon Jani,Chandrapur,Maharashtra',
'Nanhori,Chandrapur,Maharashtra',
'Nilaj,Chandrapur,Maharashtra',
'Paradgaon,Chandrapur,Maharashtra',
'Pimpalgaon,Chandrapur,Maharashtra',
'Waigaon,Chandrapur,Maharashtra',
'Potegaon,Chandrapur,Maharashtra',
'Babupeth,Chandrapur,Maharashtra',
'Cementnagar,Chandrapur,Maharashtra',
'Chandrapur City,Chandrapur,Maharashtra',
'Chandrapur Ord Fact,Chandrapur,Maharashtra',
'Chandrapur TPS,Chandrapur,Maharashtra',
'Chichpalli,Chandrapur,Maharashtra',
'Dhanora Pipri,Chandrapur,Maharashtra',
'Ghugus,Chandrapur,Maharashtra',
'Ghugus Colliery,Chandrapur,Maharashtra',
'H.L.C.,Chandrapur,Maharashtra',
'Junona,Chandrapur,Maharashtra',
'Marda,Chandrapur,Maharashtra',
'Mel,Chandrapur,Maharashtra',
'MIDC (P),Chandrapur,Maharashtra',
'Padmapur Rayatwari,Chandrapur,Maharashtra',
'Padoli,Chandrapur,Maharashtra',
'Pathanpura,Chandrapur,Maharashtra',
'Payali Bhatali,Chandrapur,Maharashtra',
'Sakharwahi,Chandrapur,Maharashtra',
'Shashtrinagar,Chandrapur,Maharashtra',
'Shengaon,Chandrapur,Maharashtra',
'Tadali,Chandrapur,Maharashtra',
'Chandrapur H.O,Chandrapur,Maharashtra',
'Chandur,Chandrapur,Maharashtra',
'Adegaon,Chandrapur,Maharashtra',
'Amadi Beguide,Chandrapur,Maharashtra',
'Ambeneri,Chandrapur,Maharashtra',
'Amboli,Chandrapur,Maharashtra',
'Arjuni,Chandrapur,Maharashtra',
'Bhisi,Chandrapur,Maharashtra',
'Chimur,Chandrapur,Maharashtra',
'Doma,Chandrapur,Maharashtra',
'Hirapur,Chandrapur,Maharashtra',
'Jambhulghat,Chandrapur,Maharashtra',
'Jamgaon Komti,Chandrapur,Maharashtra',
'Kajalsar,Chandrapur,Maharashtra',
'Kewada Mokasa,Chandrapur,Maharashtra',
'Khambada,Chandrapur,Maharashtra',
'Khutala Mokasa,Chandrapur,Maharashtra',
'Kolara Tukum,Chandrapur,Maharashtra',
'Kolari,Chandrapur,Maharashtra',
'Madnapur,Chandrapur,Maharashtra',
'Mahalgaon Kalu,Chandrapur,Maharashtra',
'Malewada,Chandrapur,Maharashtra',
'Mangalgaon,Chandrapur,Maharashtra',
'Masal,Chandrapur,Maharashtra',
'Metepar,Chandrapur,Maharashtra',
'Mhasali,Chandrapur,Maharashtra',
'Motegaon,Chandrapur,Maharashtra',
'Neri,Chandrapur,Maharashtra',
'Palasgaon Piparda,Chandrapur,Maharashtra',
'Pendhari,Chandrapur,Maharashtra',
'Pimpalneri,Chandrapur,Maharashtra',
'Sathgaon,Chandrapur,Maharashtra',
'Sawargaon,Chandrapur,Maharashtra',
'Shankarpur,Chandrapur,Maharashtra',
'Shiora,Chandrapur,Maharashtra',
'Sirpur,Chandrapur,Maharashtra',
'Talodhi Naik,Chandrapur,Maharashtra',
'Wadsi,Chandrapur,Maharashtra',
'Wahangaon,Chandrapur,Maharashtra',
'Navtala,Chandrapur,Maharashtra',
'Amgaon Buti,Chandrapur,Maharashtra',
'Chikhli,Chandrapur,Maharashtra',
'Gewardha,Chandrapur,Maharashtra',
'Kokdi,Chandrapur,Maharashtra',
'Kondali,Chandrapur,Maharashtra',
'Koregaon,Chandrapur,Maharashtra',
'Kurud,Chandrapur,Maharashtra',
'Sawangi,Chandrapur,Maharashtra',
'Vihirgaon,Chandrapur,Maharashtra',
'Visora,Chandrapur,Maharashtra',
'Wadegaon,Chandrapur,Maharashtra',
'Dudhmala,Chandrapur,Maharashtra',
'Aksapur,Chandrapur,Maharashtra',
'Borgaon,Chandrapur,Maharashtra',
'Chintaldhaba,Chandrapur,Maharashtra',
'Dhamangaon,Chandrapur,Maharashtra',
'Gojoli Maktha,Chandrapur,Maharashtra',
'Lathi,Chandrapur,Maharashtra',
'Nawegaon More,Chandrapur,Maharashtra',
'Chakdarur,Chandrapur,Maharashtra',
'Dhaba,Chandrapur,Maharashtra',
'Dighori,Chandrapur,Maharashtra',
'Futana,Chandrapur,Maharashtra',
'Ghatkul,Chandrapur,Maharashtra',
'Gondpipri,Chandrapur,Maharashtra',
'Karanji,Chandrapur,Maharashtra',
'Likithwada,Chandrapur,Maharashtra',
'Sonapur Deshpande,Chandrapur,Maharashtra',
'Talodhi Bhangaram,Chandrapur,Maharashtra',
'Tohogaon,Chandrapur,Maharashtra',
'Vithalwada,Chandrapur,Maharashtra',
'Wadholi,Chandrapur,Maharashtra',
'Wadkuli,Chandrapur,Maharashtra',
'Bhari,Chandrapur,Maharashtra',
'Jiwati,Chandrapur,Maharashtra',
'Nanda,Chandrapur,Maharashtra',
'Nandgaon,Chandrapur,Maharashtra',
'Nokewada,Chandrapur,Maharashtra',
'Patan,Chandrapur,Maharashtra',
'Pudiyal Mohada,Chandrapur,Maharashtra',
'Tekamandava,Chandrapur,Maharashtra',
'Yellapur,Chandrapur,Maharashtra',
'Awalpur Cement Project,Chandrapur,Maharashtra',
'Dhanoli,Chandrapur,Maharashtra',
'Kadholi,Chandrapur,Maharashtra',
'Kanhalgaon,Chandrapur,Maharashtra',
'Khirdi,Chandrapur,Maharashtra',
'Kodsi,Chandrapur,Maharashtra',
'Korpana,Chandrapur,Maharashtra',
'Kothada,Chandrapur,Maharashtra',
'Mandwa,Chandrapur,Maharashtra',
'Matha,Chandrapur,Maharashtra',
'Naranda,Chandrapur,Maharashtra',
'Pardi,Chandrapur,Maharashtra',
'Pipri (Naranda),Chandrapur,Maharashtra',
'Rupapet,Chandrapur,Maharashtra',
'Serja,Chandrapur,Maharashtra',
'Sonurli,Chandrapur,Maharashtra',
'Vansadi,Chandrapur,Maharashtra',
'Yergavhan,Chandrapur,Maharashtra',
'Antargaon,Chandrapur,Maharashtra',
'Awalapur,Chandrapur,Maharashtra',
'Bakhardi,Chandrapur,Maharashtra',
'Bhoygaon,Chandrapur,Maharashtra',
'Lakhampur,Chandrapur,Maharashtra',
'Man Cem Fact,Chandrapur,Maharashtra',
'Uparwahi,Chandrapur,Maharashtra',
'Virur Gadegaon,Chandrapur,Maharashtra',
'Bembal,Chandrapur,Maharashtra',
'Bhejgaon,Chandrapur,Maharashtra',
'Borda,Chandrapur,Maharashtra',
'Chikhali,Chandrapur,Maharashtra',
'Chimda,Chandrapur,Maharashtra',
'Chinchala,Chandrapur,Maharashtra',
'Chiroli,Chandrapur,Maharashtra',
'Dabgaon Maktha,Chandrapur,Maharashtra',
'Dongargaon,Chandrapur,Maharashtra',
'Fiskuti,Chandrapur,Maharashtra',
'Gowardhan,Chandrapur,Maharashtra',
'Jamtukam,Chandrapur,Maharashtra',
'Kelzar,Chandrapur,Maharashtra',
'Kolsa,Chandrapur,Maharashtra',
'Maroda,Chandrapur,Maharashtra',
'Mul,Chandrapur,Maharashtra',
'Nandgaon,Chandrapur,Maharashtra',
'Navegaon Lonkhairi,Chandrapur,Maharashtra',
'Rajoli,Chandrapur,Maharashtra',
'Somnath Prakala,Chandrapur,Maharashtra',
'Surla,Chandrapur,Maharashtra',
'Nagbhid,Chandrapur,Maharashtra',
'Dongargaon BK,Chandrapur,Maharashtra',
'Kanpa,Chandrapur,Maharashtra',
'Kotgaon,Chandrapur,Maharashtra',
'Mangali Arab,Chandrapur,Maharashtra',
'Mindhala,Chandrapur,Maharashtra',
'Mohali Mokasa,Chandrapur,Maharashtra',
'Navegaon Hundeshwari,Chandrapur,Maharashtra',
'Navegaon Pandav,Chandrapur,Maharashtra',
'Navkhala,Chandrapur,Maharashtra',
'Paharni,Chandrapur,Maharashtra',
'Talodhi Balapur,Chandrapur,Maharashtra',
'Vilam,Chandrapur,Maharashtra',
'Alwahi,Chandrapur,Maharashtra',
'Balapur,Chandrapur,Maharashtra',
'Kanhalgaon Sonule,Chandrapur,Maharashtra',
'Kitali Bormal,Chandrapur,Maharashtra',
'Mangrul,Chandrapur,Maharashtra',
'Maushi,Chandrapur,Maharashtra',
'Nanded,Chandrapur,Maharashtra',
'Palasgaon Khurd,Chandrapur,Maharashtra',
'Sawargaon,Chandrapur,Maharashtra',
'Sonurli BK,Chandrapur,Maharashtra',
'Ushral Mendha,Chandrapur,Maharashtra',
'Wadhona,Chandrapur,Maharashtra',
'Bond,Chandrapur,Maharashtra',
'Govindpur,Chandrapur,Maharashtra',
'Pombhurna,Chandrapur,Maharashtra',
'Aheri,Chandrapur,Maharashtra',
'Arvi,Chandrapur,Maharashtra',
'Bhedoda,Chandrapur,Maharashtra',
'Chandanwahi,Chandrapur,Maharashtra',
'Charli,Chandrapur,Maharashtra',
'Chincholi,Chandrapur,Maharashtra',
'Chunala,Chandrapur,Maharashtra',
'Dewada,Chandrapur,Maharashtra',
'Gowari,Chandrapur,Maharashtra',
'Kadholi,Chandrapur,Maharashtra',
'Lakhadkot,Chandrapur,Maharashtra',
'Nalfadi,Chandrapur,Maharashtra',
'Pachgaon,Chandrapur,Maharashtra',
'Pandharpauni,Chandrapur,Maharashtra',
'Rajura (M),Chandrapur,Maharashtra',
'Sakhari,Chandrapur,Maharashtra',
'Sasti,Chandrapur,Maharashtra',
'Shengaon,Chandrapur,Maharashtra',
'Sindhi,Chandrapur,Maharashtra',
'Sondo,Chandrapur,Maharashtra',
'Subai,Chandrapur,Maharashtra',
'Tembhuwahi,Chandrapur,Maharashtra',
'Vihirgaon,Chandrapur,Maharashtra',
'Vir R.S.,Chandrapur,Maharashtra',
'Warud Road,Chandrapur,Maharashtra',
'Yergawhan (Dewada),Chandrapur,Maharashtra',
'Antargaon,Chandrapur,Maharashtra',
'Bormala,Chandrapur,Maharashtra',
'Bothali,Chandrapur,Maharashtra',
'Gunjewahi,Chandrapur,Maharashtra',
'Haramba,Chandrapur,Maharashtra',
'Jibgaon,Chandrapur,Maharashtra',
'Kapsi,Chandrapur,Maharashtra',
'Kawathi,Chandrapur,Maharashtra',
'Keroda,Chandrapur,Maharashtra',
'Londholi,Chandrapur,Maharashtra',
'Meha BK,Chandrapur,Maharashtra',
'Mokhala,Chandrapur,Maharashtra',
'Nifandra,Chandrapur,Maharashtra',
'Nilsani Pedgaon,Chandrapur,Maharashtra',
'Nimgaon,Chandrapur,Maharashtra',
'Palebarsa,Chandrapur,Maharashtra',
'Pathari,Chandrapur,Maharashtra',
'Pedgaon,Chandrapur,Maharashtra',
'Pendhari Maktha,Chandrapur,Maharashtra',
'Rajgad,Chandrapur,Maharashtra',
'Samda Buzruk,Chandrapur,Maharashtra',
'Saoli,Chandrapur,Maharashtra',
'Saradpar,Chandrapur,Maharashtra',
'Vihirgaon,Chandrapur,Maharashtra',
'Vyahad BK,Chandrapur,Maharashtra',
'Vyhad Khurd,Chandrapur,Maharashtra',
'Antargaon,Chandrapur,Maharashtra',
'Gadbori,Chandrapur,Maharashtra',
'Gewara BK,Chandrapur,Maharashtra',
'Girgaon,Chandrapur,Maharashtra',
'Gramsevak Trg,Chandrapur,Maharashtra',
'Jamsala,Chandrapur,Maharashtra',
'Kalamgaon Ganna,Chandrapur,Maharashtra',
'Khatgaon,Chandrapur,Maharashtra',
'Kinhi,Chandrapur,Maharashtra',
'Ladbori,Chandrapur,Maharashtra',
'Mohali Naleshwar,Chandrapur,Maharashtra',
'Nachanbhatti,Chandrapur,Maharashtra',
'Nandgaon,Chandrapur,Maharashtra',
'Nawargaon,Chandrapur,Maharashtra',
'Ratnapur,Chandrapur,Maharashtra',
'Sheoni,Chandrapur,Maharashtra',
'Sindewahi,Chandrapur,Maharashtra',
'Tambegadimendha,Chandrapur,Maharashtra',
'Waneri,Chandrapur,Maharashtra',
'Wasera,Chandrapur,Maharashtra',
'Janampalli,Chandrapur,Maharashtra',
'Anandwan,Chandrapur,Maharashtra',
'Bhatala,Chandrapur,Maharashtra',
'Bhendala,Chandrapur,Maharashtra',
'Bothali,Chandrapur,Maharashtra',
'Chargaon BK,Chandrapur,Maharashtra',
'Charur Khati,Chandrapur,Maharashtra',
'Chikani,Chandrapur,Maharashtra',
'Chinora,Chandrapur,Maharashtra',
'Dahegaon,Chandrapur,Maharashtra',
'Dongargaon,Chandrapur,Maharashtra',
'Dongargaon Khadi,Chandrapur,Maharashtra',
'Ekarjuna,Chandrapur,Maharashtra',
'Jamni,Chandrapur,Maharashtra',
'Khambada,Chandrapur,Maharashtra',
'Khemjai,Chandrapur,Maharashtra',
'Kosarsar,Chandrapur,Maharashtra',
'Madheli,Chandrapur,Maharashtra',
'Mudholi,Chandrapur,Maharashtra',
'Nagari,Chandrapur,Maharashtra',
'Nandori,Chandrapur,Maharashtra',
'Panjurni,Chandrapur,Maharashtra',
'Sakhara Rajapur,Chandrapur,Maharashtra',
'Salori,Chandrapur,Maharashtra',
'Saori,Chandrapur,Maharashtra',
'Segaon,Chandrapur,Maharashtra',
'Sembal,Chandrapur,Maharashtra',
'Soit,Chandrapur,Maharashtra',
'Tembhurda,Chandrapur,Maharashtra',
'Waghnakh,Chandrapur,Maharashtra',
'Warora,Chandrapur,Maharashtra',
'Agriculture College,Dhule,Maharashtra',
'Ajang,Dhule,Maharashtra',
'Ambode,Dhule,Maharashtra',
'Arvi,Dhule,Maharashtra',
'Babhulvadi,Dhule,Maharashtra',
'Bhadane,Dhule,Maharashtra',
'Boris,Dhule,Maharashtra',
'Borkund,Dhule,Maharashtra',
'Borvihir,Dhule,Maharashtra',
'Burzad,Dhule,Maharashtra',
'Chaugaon,Dhule,Maharashtra',
'Chinchkheda,Dhule,Maharashtra',
'Chinchkhede,Dhule,Maharashtra',
'Chinchwar,Dhule,Maharashtra',
'Dayane,Dhule,Maharashtra',
'Deobhane,Dhule,Maharashtra',
'Deour-bk,Dhule,Maharashtra',
'Dhadre,Dhule,Maharashtra',
'Dhamangaon,Dhule,Maharashtra',
'Dhanur,Dhule,Maharashtra',
'Dhule Chaini Road,Dhule,Maharashtra',
'Dhule City,Dhule,Maharashtra',
'Dhule Collectorate,Dhule,Maharashtra',
'Dhule Deopur,Dhule,Maharashtra',
'Dhule H.O,Dhule,Maharashtra',
'Dhule Jaihind Colony,Dhule,Maharashtra',
'Dhule Market Yard,Dhule,Maharashtra',
'Dhule Midc,Dhule,Maharashtra',
'Dhule N P Mills,Dhule,Maharashtra',
'Dhule Station Road,Dhule,Maharashtra',
'Dhule Vidya Nagari,Dhule,Maharashtra',
'Fagana,Dhule,Maharashtra',
'Gondur,Dhule,Maharashtra',
'Gorane,Dhule,Maharashtra',
'Hendrun,Dhule,Maharashtra',
'Junawane,Dhule,Maharashtra',
'Kakani,Dhule,Maharashtra',
'Kalkheda,Dhule,Maharashtra',
'Kapadna,Dhule,Maharashtra',
'Khandalai,Dhule,Maharashtra',
'Kheda,Dhule,Maharashtra',
'Kumar Nagar,Dhule,Maharashtra',
'Kusumba,Dhule,Maharashtra',
'Laling,Dhule,Maharashtra',
'Lamkani,Dhule,Maharashtra',
'Lonkheda,Dhule,Maharashtra',
'Lonkhedi,Dhule,Maharashtra',
'Mehergaon,Dhule,Maharashtra',
'Mhasdi,Dhule,Maharashtra',
'Moghan,Dhule,Maharashtra',
'Mohadi Laling,Dhule,Maharashtra',
'Mohadi-dangri,Dhule,Maharashtra',
'Morane-laling,Dhule,Maharashtra',
'Morane-pner,Dhule,Maharashtra',
'Mordad,Dhule,Maharashtra',
'Mukti,Dhule,Maharashtra',
'Nagaon,Dhule,Maharashtra',
'Nakane,Dhule,Maharashtra',
'Nandale,Dhule,Maharashtra',
'Nandane,Dhule,Maharashtra',
'Nandre,Dhule,Maharashtra',
'Narvhal,Dhule,Maharashtra',
'Naval Nagar,Dhule,Maharashtra',
'Navara-navari,Dhule,Maharashtra',
'Ner,Dhule,Maharashtra',
'Nihalod,Dhule,Maharashtra',
'Nimdale,Dhule,Maharashtra',
'Nimgul,Dhule,Maharashtra',
'Old Dhule,Dhule,Maharashtra',
'Padalda,Dhule,Maharashtra',
'Phohare,Dhule,Maharashtra',
'Pimparkheda,Dhule,Maharashtra',
'Purmepada,Dhule,Maharashtra',
'Rami,Dhule,Maharashtra',
'Ramwadi,Dhule,Maharashtra',
'Sadgaon,Dhule,Maharashtra',
'Satarne,Dhule,Maharashtra',
'Shirdane,Dhule,Maharashtra',
'Shirdhane,Dhule,Maharashtra',
'Shirud,Dhule,Maharashtra',
'Talvade,Dhule,Maharashtra',
'Tikhi,Dhule,Maharashtra',
'Udane,Dhule,Maharashtra',
'Vadjai,Dhule,Maharashtra',
'Valvadi,Dhule,Maharashtra',
'Vani,Dhule,Maharashtra',
'Varkheda,Dhule,Maharashtra',
'Velhane,Dhule,Maharashtra',
'Vinchur,Dhule,Maharashtra',
'Vishvanath,Dhule,Maharashtra',
'Waghadi-bk,Dhule,Maharashtra',
'Walkheda,Dhule,Maharashtra',
'War,Dhule,Maharashtra',
'Waypur,Dhule,Maharashtra',
'Akhade,Dhule,Maharashtra',
'Amkhel,Dhule,Maharashtra',
'Ashtane,Dhule,Maharashtra',
'Balhane,Dhule,Maharashtra',
'Balsane,Dhule,Maharashtra',
'Behed,Dhule,Maharashtra',
'Bhadne,Dhule,Maharashtra',
'Bhamer,Dhule,Maharashtra',
'Bodgaon,Dhule,Maharashtra',
'Brahamanvel,Dhule,Maharashtra',
'Chadvel,Dhule,Maharashtra',
'Chaupale,Dhule,Maharashtra',
'Chhail,Dhule,Maharashtra',
'Chikase,Dhule,Maharashtra',
'Dahivel,Dhule,Maharashtra',
'Dangshirvade,Dhule,Maharashtra',
'Datarti,Dhule,Maharashtra',
'Degaon,Dhule,Maharashtra',
'Deshshirwade,Dhule,Maharashtra',
'Devjipada,Dhule,Maharashtra',
'Dhadne,Dhule,Maharashtra',
'Dhamnar,Dhule,Maharashtra',
'Dighave,Dhule,Maharashtra',
'Dusane,Dhule,Maharashtra',
'Ganeshpur,Dhule,Maharashtra',
'Ghodade,Dhule,Maharashtra',
'Jebapur,Dhule,Maharashtra',
'Kalambhir,Dhule,Maharashtra',
'Kasara,Dhule,Maharashtra',
'Kavthe,Dhule,Maharashtra',
'Kharadbari,Dhule,Maharashtra',
'Khori,Dhule,Maharashtra',
'Khudane,Dhule,Maharashtra',
'Kudashi,Dhule,Maharashtra',
'Malpur,Dhule,Maharashtra',
'Mauje-chadvel,Dhule,Maharashtra',
'Mhasale,Dhule,Maharashtra',
'Nadse,Dhule,Maharashtra',
'Navapada,Dhule,Maharashtra',
'Nizampur,Dhule,Maharashtra',
'Pankheda,Dhule,Maharashtra',
'Perejpur,Dhule,Maharashtra',
'Pimpalenr,Dhule,Maharashtra',
'Pimpalgaon,Dhule,Maharashtra',
'Pinjarzadi,Dhule,Maharashtra',
'Pratappur,Dhule,Maharashtra',
'Rohod,Dhule,Maharashtra',
'Runmaili,Dhule,Maharashtra',
'S.P. Bhadne,Dhule,Maharashtra',
'Sakri,Dhule,Maharashtra',
'Samode,Dhule,Maharashtra',
'Shendwad,Dhule,Maharashtra',
'Shenpur,Dhule,Maharashtra',
'Shevge,Dhule,Maharashtra',
'Shewali,Dhule,Maharashtra',
'Shirsole,Dhule,Maharashtra',
'Sukapur,Dhule,Maharashtra',
'Tamasvadi,Dhule,Maharashtra',
'Tembhe,Dhule,Maharashtra',
'Titane,Dhule,Maharashtra',
'Umarpatta,Dhule,Maharashtra',
'Umbharti,Dhule,Maharashtra',
'Vardhane,Dhule,Maharashtra',
'Vaskhedi,Dhule,Maharashtra',
'Vasmar,Dhule,Maharashtra',
'Vehergaon,Dhule,Maharashtra',
'Vitai,Dhule,Maharashtra',
'Warsa,Dhule,Maharashtra',
'Chinoda,Dhule,Maharashtra',
'Modalpada,Dhule,Maharashtra',
'Nala,Dhule,Maharashtra',
'Nalgavhan,Dhule,Maharashtra',
'Shivre,Dhule,Maharashtra',
'Ajande KH,Dhule,Maharashtra',
'Bhadne,Dhule,Maharashtra',
'Chilane,Dhule,Maharashtra',
'Chimthana,Dhule,Maharashtra',
'Daul,Dhule,Maharashtra',
'Dhandarne,Dhule,Maharashtra',
'Divi,Dhule,Maharashtra',
'Dondaicha-town,Dhule,Maharashtra',
'Hatti-kh,Dhule,Maharashtra',
'Hol,Dhule,Maharashtra',
'Jakhane,Dhule,Maharashtra',
'Jogshelu,Dhule,Maharashtra',
'Kadane,Dhule,Maharashtra',
'Kamkheda,Dhule,Maharashtra',
'Karle,Dhule,Maharashtra',
'Khalane,Dhule,Maharashtra',
'Kodade,Dhule,Maharashtra',
'Kurkwade,Dhule,Maharashtra',
'Mahalpur,Dhule,Maharashtra',
'Malpur,Dhule,Maharashtra',
'Methi,Dhule,Maharashtra',
'Mudawad,Dhule,Maharashtra',
'Nardana,Dhule,Maharashtra',
'Nihali,Dhule,Maharashtra',
'Nimgul,Dhule,Maharashtra',
'Pashta,Dhule,Maharashtra',
'Patan,Dhule,Maharashtra',
'Rajale,Dhule,Maharashtra',
'Rami,Dhule,Maharashtra',
'Ranjane,Dhule,Maharashtra',
'Salve,Dhule,Maharashtra',
'Savaimukti,Dhule,Maharashtra',
'Shanimandal,Dhule,Maharashtra',
'Shevade,Dhule,Maharashtra',
'Shindkheda,Dhule,Maharashtra',
'Sonewadi,Dhule,Maharashtra',
'Suray,Dhule,Maharashtra',
'Tamthare,Dhule,Maharashtra',
'Tavkheda,Dhule,Maharashtra',
'Vaindane,Dhule,Maharashtra',
'Varpada,Dhule,Maharashtra',
'Varshi,Dhule,Maharashtra',
'Varud,Dhule,Maharashtra',
'Varul,Dhule,Maharashtra',
'Vikhran,Dhule,Maharashtra',
'Virdel,Dhule,Maharashtra',
'Ajande BK,Dhule,Maharashtra',
'Dhamane,Dhule,Maharashtra',
'Padhavad,Dhule,Maharashtra',
'Ambe,Dhule,Maharashtra',
'Arthe,Dhule,Maharashtra',
'Babhalaj,Dhule,Maharashtra',
'Balde,Dhule,Maharashtra',
'Balkuwa,Dhule,Maharashtra',
'Bhamte,Dhule,Maharashtra',
'Bhatpure,Dhule,Maharashtra',
'Bhorkheda,Dhule,Maharashtra',
'Boradi,Dhule,Maharashtra',
'Dabhashi,Dhule,Maharashtra',
'Dahivad,Dhule,Maharashtra',
'Gartad,Dhule,Maharashtra',
'Gidhade,Dhule,Maharashtra',
'Hisale,Dhule,Maharashtra',
'Holnantha,Dhule,Maharashtra',
'Jatode,Dhule,Maharashtra',
'Karvand,Dhule,Maharashtra',
'Khambale,Dhule,Maharashtra',
'Khamkheda,Dhule,Maharashtra',
'Kodid,Dhule,Maharashtra',
'Lakdya-hanuman,Dhule,Maharashtra',
'Lauki,Dhule,Maharashtra',
'Maikatar,Dhule,Maharashtra',
'Mandi-shirpur,Dhule,Maharashtra',
'Palasner,Dhule,Maharashtra',
'Piloda,Dhule,Maharashtra',
'Rohini,Dhule,Maharashtra',
'Sangvi,Dhule,Maharashtra',
'Savalde,Dhule,Maharashtra',
'Sukwad,Dhule,Maharashtra',
'Sule,Dhule,Maharashtra',
'Talner,Dhule,Maharashtra',
'Tarhadi T.T.,Dhule,Maharashtra',
'Tarhadkasbe,Dhule,Maharashtra',
'Tekvade,Dhule,Maharashtra',
'Tembhe,Dhule,Maharashtra',
'Umarde,Dhule,Maharashtra',
'Umtavad,Dhule,Maharashtra',
'Uppr Shirpur,Dhule,Maharashtra',
'Varul,Dhule,Maharashtra',
'Varzadi,Dhule,Maharashtra',
'Vikharan (Shirpur),Dhule,Maharashtra',
'Wadi,Dhule,Maharashtra',
'Waghadi,Dhule,Maharashtra',
'Wakvad,Dhule,Maharashtra',
'Wasardi,Dhule,Maharashtra',
'Wathode,Dhule,Maharashtra',
'Aichale,Dhule,Maharashtra',
'Amrale,Dhule,Maharashtra',
'Bamhane,Dhule,Maharashtra',
'Betawad,Dhule,Maharashtra',
'Dangurne,Dhule,Maharashtra',
'Dondaicha,Dhule,Maharashtra',
'Indave,Dhule,Maharashtra',
'Kharde-BK,Dhule,Maharashtra',
'Kharde-KH,Dhule,Maharashtra',
'Rohane,Dhule,Maharashtra',
'Songir,Dhule,Maharashtra',
'Aheri,Chandrapur,Maharashtra',
'Allapalli,Chandrapur,Maharashtra',
'Bori,Chandrapur,Maharashtra',
'Challewada,Chandrapur,Maharashtra',
'Dampur,Chandrapur,Maharashtra',
'Dechalipeta,Chandrapur,Maharashtra',
'Devalmari,Chandrapur,Maharashtra',
'Dhamrancha,Chandrapur,Maharashtra',
'Elgur,Chandrapur,Maharashtra',
'Govindpur,Chandrapur,Maharashtra',
'Gudigudam,Chandrapur,Maharashtra',
'Indaram,Chandrapur,Maharashtra',
'Jimalgatta,Chandrapur,Maharashtra',
'Kamlapur,Chandrapur,Maharashtra',
'Khamancheru,Chandrapur,Maharashtra',
'Lagam,Chandrapur,Maharashtra',
'Mahagaon BK,Chandrapur,Maharashtra',
'Manne Rajaram,Chandrapur,Maharashtra',
'Marpalli,Chandrapur,Maharashtra',
'Medpalli,Chandrapur,Maharashtra',
'Permelli,Chandrapur,Maharashtra',
'Rajaram,Chandrapur,Maharashtra',
'Tadgaon,Chandrapur,Maharashtra',
'Venkatraopetta,Chandrapur,Maharashtra',
'Angara,Chandrapur,Maharashtra',
'Armori,Chandrapur,Maharashtra',
'Arsoda,Chandrapur,Maharashtra',
'Bhakrondi,Chandrapur,Maharashtra',
'Churmura,Chandrapur,Maharashtra',
'Delanwadi,Chandrapur,Maharashtra',
'Deulgaon,Chandrapur,Maharashtra',
'Ghati,Chandrapur,Maharashtra',
'Jogisakhara,Chandrapur,Maharashtra',
'Kadholi,Chandrapur,Maharashtra',
'Kurundi,Chandrapur,Maharashtra',
'Manapur,Chandrapur,Maharashtra',
'Sawalkheda,Chandrapur,Maharashtra',
'Shioni BK,Chandrapur,Maharashtra',
'Sirshi,Chandrapur,Maharashtra',
'Sukala,Chandrapur,Maharashtra',
'Thanegaon,Chandrapur,Maharashtra',
'Vairagadh,Chandrapur,Maharashtra',
'Wasala,Chandrapur,Maharashtra',
'Bhamragadh,Chandrapur,Maharashtra',
'Kandoli,Chandrapur,Maharashtra',
'Farda,Chandrapur,Maharashtra',
'Thakri,Chandrapur,Maharashtra',
'Amgaon (Mal),Chandrapur,Maharashtra',
'Ankhoda,Chandrapur,Maharashtra',
'Ashti,Chandrapur,Maharashtra',
'Bhadbhidi,Chandrapur,Maharashtra',
'Bhendala,Chandrapur,Maharashtra',
'Chakpetala,Chandrapur,Maharashtra',
'Chamorshi,Chandrapur,Maharashtra',
'Chandankhedi,Chandrapur,Maharashtra',
'Chapalwada,Chandrapur,Maharashtra',
'Chittaranjan,Chandrapur,Maharashtra',
'Ganpur Rayatwari,Chandrapur,Maharashtra',
'Ghot,Chandrapur,Maharashtra',
'Jairampur,Chandrapur,Maharashtra',
'Kurud,Chandrapur,Maharashtra',
'Lakhamapur,Chandrapur,Maharashtra',
'Makepalli,Chandrapur,Maharashtra',
'Mallermal,Chandrapur,Maharashtra',
'Markanda Deo,Chandrapur,Maharashtra',
'Mudholi Chak No. Ii,Chandrapur,Maharashtra',
'Murkhada,Chandrapur,Maharashtra',
'Murkhada Chak,Chandrapur,Maharashtra',
'Murmuri,Chandrapur,Maharashtra',
'Navegaon Rayatwari,Chandrapur,Maharashtra',
'Pavimuranda,Chandrapur,Maharashtra',
'Ramala,Chandrapur,Maharashtra',
'Regadi,Chandrapur,Maharashtra',
'Sonapur,Chandrapur,Maharashtra',
'Talodhi Mokasa,Chandrapur,Maharashtra',
'Vikaspalli,Chandrapur,Maharashtra',
'Vikrampur,Chandrapur,Maharashtra',
'Vishnupur,Chandrapur,Maharashtra',
'Wagholi,Chandrapur,Maharashtra',
'Walsara,Chandrapur,Maharashtra',
'Yenapur,Chandrapur,Maharashtra',
'Kunghada,Chandrapur,Maharashtra',
'Andhali,Chandrapur,Maharashtra',
'Desaiganj,Chandrapur,Maharashtra',
'Chatgaon,Chandrapur,Maharashtra',
'Chavela,Chandrapur,Maharashtra',
'Dhanora,Chandrapur,Maharashtra',
'Gatta,Chandrapur,Maharashtra',
'Heti,Chandrapur,Maharashtra',
'Jarawandi,Chandrapur,Maharashtra',
'Karwafa,Chandrapur,Maharashtra',
'Mendhatola,Chandrapur,Maharashtra',
'Mohali,Chandrapur,Maharashtra',
'Muramgaon,Chandrapur,Maharashtra',
'Pendhari,Chandrapur,Maharashtra',
'Rangi,Chandrapur,Maharashtra',
'Sawargaon,Chandrapur,Maharashtra',
'Sode,Chandrapur,Maharashtra',
'Yerkad,Chandrapur,Maharashtra',
'Burgi,Chandrapur,Maharashtra',
'Ettapalli,Chandrapur,Maharashtra',
'Gatta,Chandrapur,Maharashtra',
'Geda,Chandrapur,Maharashtra',
'Ghotsur,Chandrapur,Maharashtra',
'Jivangatta,Chandrapur,Maharashtra',
'Kasansur,Chandrapur,Maharashtra',
'Salebhatti,Chandrapur,Maharashtra',
'Todsa,Chandrapur,Maharashtra',
'Tumargunda,Chandrapur,Maharashtra',
'Udera,Chandrapur,Maharashtra',
'Ambeshioni,Chandrapur,Maharashtra',
'Amirza,Chandrapur,Maharashtra',
'Bamni,Chandrapur,Maharashtra',
'Bodhali,Chandrapur,Maharashtra',
'Churchura,Chandrapur,Maharashtra',
'Deloda,Chandrapur,Maharashtra',
'Gadchiroli Coll,Chandrapur,Maharashtra',
'Gadchiroli,Chandrapur,Maharashtra',
'Guruwala,Chandrapur,Maharashtra',
'Jambhali,Chandrapur,Maharashtra',
'Jepra,Chandrapur,Maharashtra',
'Kaneri,Chandrapur,Maharashtra',
'Lanjeda,Chandrapur,Maharashtra',
'Maushi Khamb,Chandrapur,Maharashtra',
'Mudza,Chandrapur,Maharashtra',
'Murmadi,Chandrapur,Maharashtra',
'Nagrinavegaon,Chandrapur,Maharashtra',
'Pardikupi,Chandrapur,Maharashtra',
'Porla,Chandrapur,Maharashtra',
'Sakhara,Chandrapur,Maharashtra',
'Wadadha,Chandrapur,Maharashtra',
'Wasa,Chandrapur,Maharashtra',
'Yeoli,Chandrapur,Maharashtra',
'Korchi,Chandrapur,Maharashtra',
'Malewada,Chandrapur,Maharashtra',
'Masali,Chandrapur,Maharashtra',
'Nanhi,Chandrapur,Maharashtra',
'Armurkasa,Chandrapur,Maharashtra',
'Bedgaon,Chandrapur,Maharashtra',
'Bethakathi,Chandrapur,Maharashtra',
'Botekasa,Chandrapur,Maharashtra',
'Chandagad,Chandrapur,Maharashtra',
'Charbhatti,Chandrapur,Maharashtra',
'Gothangaon,Chandrapur,Maharashtra',
'Kotgul,Chandrapur,Maharashtra',
'Kotra,Chandrapur,Maharashtra',
'Kurkheda,Chandrapur,Maharashtra',
'Palasgad,Chandrapur,Maharashtra',
'Purada,Chandrapur,Maharashtra',
'Ramgarh,Chandrapur,Maharashtra',
'Sonsari,Chandrapur,Maharashtra',
'Sursundi,Chandrapur,Maharashtra',
'Talegaon,Chandrapur,Maharashtra',
'Yengalkheda,Chandrapur,Maharashtra',
'Adapalli,Chandrapur,Maharashtra',
'Chaudampalli,Chandrapur,Maharashtra',
'Gundapalli,Chandrapur,Maharashtra',
'Kalinagar,Chandrapur,Maharashtra',
'Khudirampalli,Chandrapur,Maharashtra',
'Konsari,Chandrapur,Maharashtra',
'Koparalli,Chandrapur,Maharashtra',
'Markhanda (K),Chandrapur,Maharashtra',
'Mulchera,Chandrapur,Maharashtra',
'Asaralli,Chandrapur,Maharashtra',
'Ankisa,Chandrapur,Maharashtra',
'Arda,Chandrapur,Maharashtra',
'Bamni,Chandrapur,Maharashtra',
'Jinganur,Chandrapur,Maharashtra',
'Korla Mal,Chandrapur,Maharashtra',
'Moyabinpetta,Chandrapur,Maharashtra',
'Nagram,Chandrapur,Maharashtra',
'Narayanpur,Chandrapur,Maharashtra',
'Rangaapalli,Chandrapur,Maharashtra',
'Regunta,Chandrapur,Maharashtra',
'Sironcha Mal,Chandrapur,Maharashtra',
'Sironcha,Chandrapur,Maharashtra',
'Tekada,Chandrapur,Maharashtra',
'Amgaon Basti,Nagpur Moffusil,Maharashtra',
'Amgaon,Nagpur Moffusil,Maharashtra',
'Anjora,Nagpur Moffusil,Maharashtra',
'Bijepar,Nagpur Moffusil,Maharashtra',
'Borkanhar,Nagpur Moffusil,Maharashtra',
'Kalimati,Nagpur Moffusil,Maharashtra',
'Kattipar,Nagpur Moffusil,Maharashtra',
'Kotra,Nagpur Moffusil,Maharashtra',
'Lohara,Nagpur Moffusil,Maharashtra',
'Makkatola,Nagpur Moffusil,Maharashtra',
'Pandharwani,Nagpur Moffusil,Maharashtra',
'Phukimeta,Nagpur Moffusil,Maharashtra',
'Purada,Nagpur Moffusil,Maharashtra',
'Saoli Dongargaon,Nagpur Moffusil,Maharashtra',
'Sarkartola,Nagpur Moffusil,Maharashtra',
'Satgaon,Nagpur Moffusil,Maharashtra',
'Suplipar,Nagpur Moffusil,Maharashtra',
'Thana,Nagpur Moffusil,Maharashtra',
'Tigaon,Nagpur Moffusil,Maharashtra',
'Arjuni Morgaon,Nagpur Moffusil,Maharashtra',
'Bakti,Nagpur Moffusil,Maharashtra',
'Barabhati,Nagpur Moffusil,Maharashtra',
'Bhivkhidki,Nagpur Moffusil,Maharashtra',
'Bondegaon (Surban),Nagpur Moffusil,Maharashtra',
'Bondgaon Devi,Nagpur Moffusil,Maharashtra',
'Channa,Nagpur Moffusil,Maharashtra',
'Dhabetekdi,Nagpur Moffusil,Maharashtra',
'Etikheda,Nagpur Moffusil,Maharashtra',
'Ghonadi,Nagpur Moffusil,Maharashtra',
'Gothangaon,Nagpur Moffusil,Maharashtra',
'Kesori,Nagpur Moffusil,Maharashtra',
'Korambitola,Nagpur Moffusil,Maharashtra',
'Mohgaon R.S.,Nagpur Moffusil,Maharashtra',
'Navegaon Bandh,Nagpur Moffusil,Maharashtra',
'Palandur Zamindari,Nagpur Moffusil,Maharashtra',
'Palasgaon,Nagpur Moffusil,Maharashtra',
'Parastola,Nagpur Moffusil,Maharashtra',
'Parsodi Rayatwadi,Nagpur Moffusil,Maharashtra',
'Pimpalgaon Khambi,Nagpur Moffusil,Maharashtra',
'Pratapgarh,Nagpur Moffusil,Maharashtra',
'Tukum Narayan,Nagpur Moffusil,Maharashtra',
'Wadegaon R.S.,Nagpur Moffusil,Maharashtra',
'Zarpada,Nagpur Moffusil,Maharashtra',
'Alewada,Nagpur Moffusil,Maharashtra',
'Borgaon,Nagpur Moffusil,Maharashtra',
'Chichgarh,Nagpur Moffusil,Maharashtra',
'Dawki,Nagpur Moffusil,Maharashtra',
'Deori,Nagpur Moffusil,Maharashtra',
'Futana,Nagpur Moffusil,Maharashtra',
'Kadikasa,Nagpur Moffusil,Maharashtra',
'Kokodi,Nagpur Moffusil,Maharashtra',
'Murdoli,Nagpur Moffusil,Maharashtra',
'Nilaj,Nagpur Moffusil,Maharashtra',
'Shirpurbagh Colony,Nagpur Moffusil,Maharashtra',
'Adasi,Nagpur Moffusil,Maharashtra',
'Asoli,Nagpur Moffusil,Maharashtra',
'Banathar,Nagpur Moffusil,Maharashtra',
'Batana,Nagpur Moffusil,Maharashtra',
'Berdipar,Nagpur Moffusil,Maharashtra',
'Boda,Nagpur Moffusil,Maharashtra',
'Chipiya,Nagpur Moffusil,Maharashtra',
'Chirchal Bandh,Nagpur Moffusil,Maharashtra',
'Chutiya,Nagpur Moffusil,Maharashtra',
'Dandegaon,Nagpur Moffusil,Maharashtra',
'Dasgaon Khurd,Nagpur Moffusil,Maharashtra',
'Datora,Nagpur Moffusil,Maharashtra',
'Dawaniwada,Nagpur Moffusil,Maharashtra',
'Dhakni,Nagpur Moffusil,Maharashtra',
'Dongargaon,Nagpur Moffusil,Maharashtra',
'Gangazari,Nagpur Moffusil,Maharashtra',
'Garra,Nagpur Moffusil,Maharashtra',
'Girola,Nagpur Moffusil,Maharashtra',
'Gondia Bazar,Nagpur Moffusil,Maharashtra',
'Gondia City,Nagpur Moffusil,Maharashtra',
'Gondia H.O,Nagpur Moffusil,Maharashtra',
'Gondia Khurd,Nagpur Moffusil,Maharashtra',
'Gondia Ramnagar,Nagpur Moffusil,Maharashtra',
'Kachewani,Nagpur Moffusil,Maharashtra',
'Kamtha,Nagpur Moffusil,Maharashtra',
'Karanja,Nagpur Moffusil,Maharashtra',
'Kati (Birsola),Nagpur Moffusil,Maharashtra',
'Kawlewada,Nagpur Moffusil,Maharashtra',
'Khamari,Nagpur Moffusil,Maharashtra',
'Khatiya,Nagpur Moffusil,Maharashtra',
'Kudwa,Nagpur Moffusil,Maharashtra',
'Mohgaon BK,Nagpur Moffusil,Maharashtra',
'Nagpura,Nagpur Moffusil,Maharashtra',
'Nagra,Nagpur Moffusil,Maharashtra',
'Nagrakatangi,Nagpur Moffusil,Maharashtra',
'Navegaon Kalan,Nagpur Moffusil,Maharashtra',
'Pandharbodi,Nagpur Moffusil,Maharashtra',
'Paraswada,Nagpur Moffusil,Maharashtra',
'Phulchur,Nagpur Moffusil,Maharashtra',
'Rajegaon,Nagpur Moffusil,Maharashtra',
'Ratnara,Nagpur Moffusil,Maharashtra',
'Rawanwadi,Nagpur Moffusil,Maharashtra',
'Satona,Nagpur Moffusil,Maharashtra',
'Sawri,Nagpur Moffusil,Maharashtra',
'Shejgaon,Nagpur Moffusil,Maharashtra',
'Sitepar,Nagpur Moffusil,Maharashtra',
'Tanda,Nagpur Moffusil,Maharashtra',
'Tumkheda Khurd,Nagpur Moffusil,Maharashtra',
'Yekodi (Gondia),Nagpur Moffusil,Maharashtra',
'Bhasgaon,Nagpur Moffusil,Maharashtra',
'Gankhaira,Nagpur Moffusil,Maharashtra',
'Ghoti,Nagpur Moffusil,Maharashtra',
'Gidhadi,Nagpur Moffusil,Maharashtra',
'Goregaon,Nagpur Moffusil,Maharashtra',
'Hirapur,Nagpur Moffusil,Maharashtra',
'Hirdamali,Nagpur Moffusil,Maharashtra',
'Kalimati,Nagpur Moffusil,Maharashtra',
'Katangi BK,Nagpur Moffusil,Maharashtra',
'Khodseoni,Nagpur Moffusil,Maharashtra',
'Kosamthondi,Nagpur Moffusil,Maharashtra',
'Kurhadi,Nagpur Moffusil,Maharashtra',
'Mundipar (Ishwar),Nagpur Moffusil,Maharashtra',
'Pandhari,Nagpur Moffusil,Maharashtra',
'Pathri (Gondia),Nagpur Moffusil,Maharashtra',
'Soni,Nagpur Moffusil,Maharashtra',
'Timezari,Nagpur Moffusil,Maharashtra',
'Bamni,Nagpur Moffusil,Maharashtra',
'Bopabodi,Nagpur Moffusil,Maharashtra',
'Chikhali,Nagpur Moffusil,Maharashtra',
'Chopa,Nagpur Moffusil,Maharashtra',
'Dawwa,Nagpur Moffusil,Maharashtra',
'Dongargaon Sadak,Nagpur Moffusil,Maharashtra',
'Gondumri,Nagpur Moffusil,Maharashtra',
'Khajari Dongargaon,Nagpur Moffusil,Maharashtra',
'Kokna,Nagpur Moffusil,Maharashtra',
'Mohadi,Nagpur Moffusil,Maharashtra',
'Mundipar,Nagpur Moffusil,Maharashtra',
'Palasgaon,Nagpur Moffusil,Maharashtra',
'Parsodi,Nagpur Moffusil,Maharashtra',
'Sadak Arjuni,Nagpur Moffusil,Maharashtra',
'Shenda,Nagpur Moffusil,Maharashtra',
'Soundad,Nagpur Moffusil,Maharashtra',
'Tedha,Nagpur Moffusil,Maharashtra',
'Tilli Mohgaon,Nagpur Moffusil,Maharashtra',
'Darekasa,Nagpur Moffusil,Maharashtra',
'Dhanoli,Nagpur Moffusil,Maharashtra',
'Kawarabandh,Nagpur Moffusil,Maharashtra',
'Latori,Nagpur Moffusil,Maharashtra',
'Lohara,Nagpur Moffusil,Maharashtra',
'Pauldauna,Nagpur Moffusil,Maharashtra',
'Pipariya,Nagpur Moffusil,Maharashtra',
'Salekasa,Nagpur Moffusil,Maharashtra',
'Sonpuri,Nagpur Moffusil,Maharashtra',
'Tirkhedi,Nagpur Moffusil,Maharashtra',
'Arjuni (Tirora),Nagpur Moffusil,Maharashtra',
'Chikhali,Nagpur Moffusil,Maharashtra',
'Dhapewada,Nagpur Moffusil,Maharashtra',
'Gangla,Nagpur Moffusil,Maharashtra',
'Gond Mohadi,Nagpur Moffusil,Maharashtra',
'Gumdhawada,Nagpur Moffusil,Maharashtra',
'Indora Khurd,Nagpur Moffusil,Maharashtra',
'Karti BK,Nagpur Moffusil,Maharashtra',
'Kawalewada,Nagpur Moffusil,Maharashtra',
'Kesalwada,Nagpur Moffusil,Maharashtra',
'Kodelohara,Nagpur Moffusil,Maharashtra',
'Lakhegaon,Nagpur Moffusil,Maharashtra',
'Mundikota,Nagpur Moffusil,Maharashtra',
'Murdada,Nagpur Moffusil,Maharashtra',
'Navezari,Nagpur Moffusil,Maharashtra',
'Paraswada,Nagpur Moffusil,Maharashtra',
'Sarandi,Nagpur Moffusil,Maharashtra',
'Sukhali Dakaram,Nagpur Moffusil,Maharashtra',
'Thanegaon,Nagpur Moffusil,Maharashtra',
'Tirora,Nagpur Moffusil,Maharashtra',
'Wadegaon,Nagpur Moffusil,Maharashtra',
'Aundha Nagnath,Pharbhani,Maharashtra',
'Daudgaon,Pharbhani,Maharashtra',
'Gojegaon,Pharbhani,Maharashtra',
'Golegaon Camp,Pharbhani,Maharashtra',
'Gunda,Pharbhani,Maharashtra',
'Jawala Bazar,Pharbhani,Maharashtra',
'Lakh,Pharbhani,Maharashtra',
'Lohara BK,Pharbhani,Maharashtra',
'Murtijapur Sawangi,Pharbhani,Maharashtra',
'Pimpaldari,Pharbhani,Maharashtra',
'Purjal,Pharbhani,Maharashtra',
'Salna,Pharbhani,Maharashtra',
'Sendursena,Pharbhani,Maharashtra',
'Shirad Shahapur,Pharbhani,Maharashtra',
'Siddheshwar,Pharbhani,Maharashtra',
'Siddheshwar Camp,Pharbhani,Maharashtra',
'Undegaon,Pharbhani,Maharashtra',
'Yehlegaon Solanke,Pharbhani,Maharashtra',
'Adgaon,Pharbhani,Maharashtra',
'Amba,Pharbhani,Maharashtra',
'Aral,Pharbhani,Maharashtra',
'Borisawant,Pharbhani,Maharashtra',
'Chondi,Pharbhani,Maharashtra',
'Darefal,Pharbhani,Maharashtra',
'Girgaon,Pharbhani,Maharashtra',
'Hatta,Pharbhani,Maharashtra',
'Hayatnagar,Pharbhani,Maharashtra',
'Karanjala,Pharbhani,Maharashtra',
'Kautha,Pharbhani,Maharashtra',
'Khandegaon,Pharbhani,Maharashtra',
'Kurunda,Pharbhani,Maharashtra',
'Nahad,Pharbhani,Maharashtra',
'Pardi BK,Pharbhani,Maharashtra',
'Sawangi BK,Pharbhani,Maharashtra',
'Basmathnagar,Pharbhani,Maharashtra',
'Basmathnagar,Pharbhani,Maharashtra',
'Adgaon,Pharbhani,Maharashtra',
'Adol,Pharbhani,Maharashtra',
'Basamba,Pharbhani,Maharashtra',
'Bhandegaon,Pharbhani,Maharashtra',
'Bhatsawangi,Pharbhani,Maharashtra',
'Chincholi,Pharbhani,Maharashtra',
'Digras,Pharbhani,Maharashtra',
'Ganjapur,Pharbhani,Maharashtra',
'Hingani,Pharbhani,Maharashtra',
'Hingoli,Pharbhani,Maharashtra',
'Kanergaon,Pharbhani,Maharashtra',
'Khandala,Pharbhani,Maharashtra',
'Khudaj,Pharbhani,Maharashtra',
'Lohgaon,Pharbhani,Maharashtra',
'Malhiwara,Pharbhani,Maharashtra',
'Mangalwara Hingoli,Pharbhani,Maharashtra',
'Narsi Namdev,Pharbhani,Maharashtra',
'Paheni,Pharbhani,Maharashtra',
'Pedgaon,Pharbhani,Maharashtra',
'Phalegaon,Pharbhani,Maharashtra',
'Pusegaon,Pharbhani,Maharashtra',
'Sawad,Pharbhani,Maharashtra',
'Sawargaon,Pharbhani,Maharashtra',
'Sirsam BK,Pharbhani,Maharashtra',
'Akhada Balapur,Pharbhani,Maharashtra',
'Babhali,Pharbhani,Maharashtra',
'Bolda,Pharbhani,Maharashtra',
'Bour,Pharbhani,Maharashtra',
'Dhawanda Kasba,Pharbhani,Maharashtra',
'Dongargaon Pool,Pharbhani,Maharashtra',
'Dongarkada,Pharbhani,Maharashtra',
'Gaul,Pharbhani,Maharashtra',
'Ghoda,Pharbhani,Maharashtra',
'Jawala Panchal,Pharbhani,Maharashtra',
'Kalamnuri,Pharbhani,Maharashtra',
'Kandali,Pharbhani,Maharashtra',
'Khanapur Chitta,Pharbhani,Maharashtra',
'Kharwad,Pharbhani,Maharashtra',
'Kille Wadgaon,Pharbhani,Maharashtra',
'Kondhur,Pharbhani,Maharashtra',
'Kurtadi,Pharbhani,Maharashtra',
'Masod,Pharbhani,Maharashtra',
'Mssk Dongarkada,Pharbhani,Maharashtra',
'Nandapur,Pharbhani,Maharashtra',
'Pangra Shinde,Pharbhani,Maharashtra',
'Potra,Pharbhani,Maharashtra',
'Rameshwar Tanda,Pharbhani,Maharashtra',
'Salva,Pharbhani,Maharashtra',
'Sandas,Pharbhani,Maharashtra',
'Shewala,Pharbhani,Maharashtra',
'Sindagi,Pharbhani,Maharashtra',
'Sirli,Pharbhani,Maharashtra',
'Sukli Veer,Pharbhani,Maharashtra',
'Wakodi,Pharbhani,Maharashtra',
'Wapti,Pharbhani,Maharashtra',
'Waranga,Pharbhani,Maharashtra',
'Yedsi,Pharbhani,Maharashtra',
'Yelegaon (T),Pharbhani,Maharashtra',
'Yelegaon Gawali,Pharbhani,Maharashtra',
'Yelki,Pharbhani,Maharashtra',
'Ajegaon,Pharbhani,Maharashtra',
'Babhulgaon,Pharbhani,Maharashtra',
'Bhankheda,Pharbhani,Maharashtra',
'Datala,Pharbhani,Maharashtra',
'Goregaon,Pharbhani,Maharashtra',
'Hatala,Pharbhani,Maharashtra',
'Hatta,Pharbhani,Maharashtra',
'Jaipur,Pharbhani,Maharashtra',
'Jawala BK,Pharbhani,Maharashtra',
'Kadoli,Pharbhani,Maharashtra',
'Kautha,Pharbhani,Maharashtra',
'Kendra BK,Pharbhani,Maharashtra',
'Mazod,Pharbhani,Maharashtra',
'Palsi,Pharbhani,Maharashtra',
'Pankanhergaon,Pharbhani,Maharashtra',
'Sakhra,Pharbhani,Maharashtra',
'Sapatgaon,Pharbhani,Maharashtra',
'Sawana,Pharbhani,Maharashtra',
'Sengaon,Pharbhani,Maharashtra',
'Shegaon,Pharbhani,Maharashtra',
'Sindagikhamba,Pharbhani,Maharashtra',
'Warud Chakrapani,Pharbhani,Maharashtra',
'Amalgaon,Jalgaon,Maharashtra',
'Amalner Pratap Nagar,Jalgaon,Maharashtra',
'Amalner,Jalgaon,Maharashtra',
'Amalner Town,Jalgaon,Maharashtra',
'Amba Pimpri,Jalgaon,Maharashtra',
'Bharwas,Jalgaon,Maharashtra',
'Bohare,Jalgaon,Maharashtra',
'Chaubari,Jalgaon,Maharashtra',
'Dahiwad,Jalgaon,Maharashtra',
'Dangar,Jalgaon,Maharashtra',
'Dangari,Jalgaon,Maharashtra',
'Devgaon,Jalgaon,Maharashtra',
'Dhar,Jalgaon,Maharashtra',
'Dodhwad,Jalgaon,Maharashtra',
'Eklahare,Jalgaon,Maharashtra',
'Galwade BK,Jalgaon,Maharashtra',
'Gandhli,Jalgaon,Maharashtra',
'Hedave,Jalgaon,Maharashtra',
'Jaitpeer,Jalgaon,Maharashtra',
'Jalod,Jalgaon,Maharashtra',
'Janve,Jalgaon,Maharashtra',
'Javkhede,Jalgaon,Maharashtra',
'Kalali,Jalgaon,Maharashtra',
'Kalamsare,Jalgaon,Maharashtra',
'Karankheda,Jalgaon,Maharashtra',
'Kavpimpri,Jalgaon,Maharashtra',
'Kol Pimpri,Jalgaon,Maharashtra',
'Lon BK,Jalgaon,Maharashtra',
'Londhave,Jalgaon,Maharashtra',
'Mandal,Jalgaon,Maharashtra',
'Mangrul,Jalgaon,Maharashtra',
'Marwad,Jalgaon,Maharashtra',
'Mudi,Jalgaon,Maharashtra',
'Nagav,Jalgaon,Maharashtra',
'Nimb,Jalgaon,Maharashtra',
'Nimbhora,Jalgaon,Maharashtra',
'Patonda,Jalgaon,Maharashtra',
'Phafore,Jalgaon,Maharashtra',
'Pilode,Jalgaon,Maharashtra',
'Pimpale Budruk,Jalgaon,Maharashtra',
'Pimpali,Jalgaon,Maharashtra',
'Ranaiche,Jalgaon,Maharashtra',
'Shahpur,Jalgaon,Maharashtra',
'Shirsale,Jalgaon,Maharashtra',
'Shirud,Jalgaon,Maharashtra',
'Taskheda,Jalgaon,Maharashtra',
'Wavde,Jalgaon,Maharashtra',
'Amadade,Jalgaon,Maharashtra',
'Anjanvihire,Jalgaon,Maharashtra',
'Bhadgaon,Jalgaon,Maharashtra',
'Gudhe,Jalgaon,Maharashtra',
'Kajgaon,Jalgaon,Maharashtra',
'Khedgaon Khurd,Jalgaon,Maharashtra',
'Mahindale,Jalgaon,Maharashtra',
'Nimbhora,Jalgaon,Maharashtra',
'Picharde,Jalgaon,Maharashtra',
'Pimparkhed,Jalgaon,Maharashtra',
'Savde,Jalgaon,Maharashtra',
'Shivani,Jalgaon,Maharashtra',
'Vadji,Jalgaon,Maharashtra',
'Bhusawal Athawade Bazar,Bhusaval,Maharashtra',
'Bhusawal H.O,Bhusaval,Maharashtra',
'Bhusawal Kutchery,Bhusaval,Maharashtra',
'Bhusawal Ordnance Factory,Bhusaval,Maharashtra',
'Bhusawal Shivaji Nagar,Bhusaval,Maharashtra',
'Deepnagar,Bhusaval,Maharashtra',
'Kurha,Bhusaval,Maharashtra',
'Varangaon Ord.Factory,Bhusaval,Maharashtra',
'Varangaon,Bhusaval,Maharashtra',
'Bodwad,Bhusaval,Maharashtra',
'Bahal,Jalgaon,Maharashtra',
'Beldarwadi,Jalgaon,Maharashtra',
'Belganga,Jalgaon,Maharashtra',
'Bhaur,Jalgaon,Maharashtra',
'Bhoras Budruk,Jalgaon,Maharashtra',
'Bilakhed,Jalgaon,Maharashtra',
'Borkheda,Jalgaon,Maharashtra',
'Bramhanshevage,Jalgaon,Maharashtra',
'Chalisgaon Adarsha Nagar,Jalgaon,Maharashtra',
'Chalisgaon H.O,Jalgaon,Maharashtra',
'Chalisgaon R S,Jalgaon,Maharashtra',
'Chalisgaon Town,Jalgaon,Maharashtra',
'Dahiwad,Jalgaon,Maharashtra',
'Deoli,Jalgaon,Maharashtra',
'Dhamangaon,Jalgaon,Maharashtra',
'Ganeshpur,Jalgaon,Maharashtra',
'Ghodegaon,Jalgaon,Maharashtra',
'Gondgaon,Jalgaon,Maharashtra',
'Hatgaon,Jalgaon,Maharashtra',
'Hatle,Jalgaon,Maharashtra',
'Hingone Khurd,Jalgaon,Maharashtra',
'Hirapur,Jalgaon,Maharashtra',
'Jamda,Jalgaon,Maharashtra',
'Juvardi,Jalgaon,Maharashtra',
'Kalmadu,Jalgaon,Maharashtra',
'Kargaon,Jalgaon,Maharashtra',
'Khakdesim,Jalgaon,Maharashtra',
'Kharjai,Jalgaon,Maharashtra',
'Khedgaon,Jalgaon,Maharashtra',
'Kherde,Jalgaon,Maharashtra',
'Kolegaon,Jalgaon,Maharashtra',
'Kunjhar,Jalgaon,Maharashtra',
'Lon Pirache,Jalgaon,Maharashtra',
'Londhe,Jalgaon,Maharashtra',
'Lonje,Jalgaon,Maharashtra',
'Malshevage,Jalgaon,Maharashtra',
'Mehunbare,Jalgaon,Maharashtra',
'Nagardeola,Jalgaon,Maharashtra',
'Ozar,Jalgaon,Maharashtra',
'Patnadevi,Jalgaon,Maharashtra',
'Patonda,Jalgaon,Maharashtra',
'Pilkhod,Jalgaon,Maharashtra',
'Pimparkhed,Jalgaon,Maharashtra',
'Pimpri Budruk,Jalgaon,Maharashtra',
'Pohara,Jalgaon,Maharashtra',
'Rohini,Jalgaon,Maharashtra',
'Sangavi,Jalgaon,Maharashtra',
'Saygaon,Jalgaon,Maharashtra',
'Shindi,Jalgaon,Maharashtra',
'Shindi,Jalgaon,Maharashtra',
'Shirasgaon,Jalgaon,Maharashtra',
'Takli P.D.,Jalgaon,Maharashtra',
'Talki Budruk,Jalgaon,Maharashtra',
'Talonde Digar,Jalgaon,Maharashtra',
'Tambole Budruk,Jalgaon,Maharashtra',
'Tandulwadi,Jalgaon,Maharashtra',
'Tarwade,Jalgaon,Maharashtra',
'Umbarkhed,Jalgaon,Maharashtra',
'Upkhed,Jalgaon,Maharashtra',
'Vadale Vadali,Jalgaon,Maharashtra',
'Vadgaon Lambe,Jalgaon,Maharashtra',
'Varkhede Budruk,Jalgaon,Maharashtra',
'Wade,Jalgaon,Maharashtra',
'Waghali,Jalgaon,Maharashtra',
'Waghdu,Jalgaon,Maharashtra',
'Ranjangaon,Jalgaon,Maharashtra',
'Talegaon,Jalgaon,Maharashtra',
'Adavad,Bhusaval,Maharashtra',
'Akulkheda,Bhusaval,Maharashtra',
'Chahardi,Bhusaval,Maharashtra',
'Chopda,Bhusaval,Maharashtra',
'Hated,Bhusaval,Maharashtra',
'Khardi,Bhusaval,Maharashtra',
'Khardi,Bhusaval,Maharashtra',
'Kurhe Khurd,Jalgaon,Maharashtra',
'Anjanvihire,Jalgaon,Maharashtra',
'Bhone,Jalgaon,Maharashtra',
'Borkheda,Jalgaon,Maharashtra',
'Chandsar,Jalgaon,Maharashtra',
'Choragaon,Jalgaon,Maharashtra',
'Dhanora,Jalgaon,Maharashtra',
'Dharangaon,Jalgaon,Maharashtra',
'Dheku,Jalgaon,Maharashtra',
'Dongaon,Jalgaon,Maharashtra',
'Hingona Budruk,Jalgaon,Maharashtra',
'Jambhore,Jalgaon,Maharashtra',
'Kadholi,Jalgaon,Maharashtra',
'Kharchi,Jalgaon,Maharashtra',
'Kharde,Jalgaon,Maharashtra',
'Mathgavan,Jalgaon,Maharashtra',
'Nanded,Jalgaon,Maharashtra',
'Paldhi,Jalgaon,Maharashtra',
'Pashtane Budruk,Jalgaon,Maharashtra',
'Pimpalkotha,Jalgaon,Maharashtra',
'Pimpri Khurd,Jalgaon,Maharashtra',
'Rajwad,Jalgaon,Maharashtra',
'Ravanje,Jalgaon,Maharashtra',
'Ringangaon,Jalgaon,Maharashtra',
'Rotwad,Jalgaon,Maharashtra',
'Sakare,Jalgaon,Maharashtra',
'Salve,Jalgaon,Maharashtra',
'Sarbete,Jalgaon,Maharashtra',
'Satkheda,Jalgaon,Maharashtra',
'Savkheda,Jalgaon,Maharashtra',
'Shelave,Jalgaon,Maharashtra',
'Sonwad,Jalgaon,Maharashtra',
'Takarkheda,Jalgaon,Maharashtra',
'Varad,Jalgaon,Maharashtra',
'Zurkheda,Jalgaon,Maharashtra',
'Adgaon,Jalgaon,Maharashtra',
'Bhatkheda,Jalgaon,Maharashtra',
'Bhavarkheda,Jalgaon,Maharashtra',
'Borgaon BK,Jalgaon,Maharashtra',
'Erandol,Jalgaon,Maharashtra',
'Farkande,Jalgaon,Maharashtra',
'Hanmantkheda,Jalgaon,Maharashtra',
'Kasoda,Jalgaon,Maharashtra',
'Khadke Budruk,Jalgaon,Maharashtra',
'Khadke Khurd,Jalgaon,Maharashtra',
'Nipane,Jalgaon,Maharashtra',
'Savkheda Hol,Jalgaon,Maharashtra',
'Talai,Jalgaon,Maharashtra',
'Toli Khurd,Jalgaon,Maharashtra',
'Utran,Jalgaon,Maharashtra',
'Vankothe,Jalgaon,Maharashtra',
'Vikhran,Jalgaon,Maharashtra',
'Amoda,Jalgaon,Maharashtra',
'Asoda,Jalgaon,Maharashtra',
'Audyogik Vasahat Jalgaon,Jalgaon,Maharashtra',
'Avhane,Jalgaon,Maharashtra',
'Bambhori,Jalgaon,Maharashtra',
'Bhadli BK,Jalgaon,Maharashtra',
'Bhokar,Jalgaon,Maharashtra',
'Bholane,Jalgaon,Maharashtra',
'Bornar,Jalgaon,Maharashtra',
'Chincholi,Jalgaon,Maharashtra',
'Dahigaon,Jalgaon,Maharashtra',
'Dhamangaon,Jalgaon,Maharashtra',
'Dhanwad,Jalgaon,Maharashtra',
'Idgaon,Jalgaon,Maharashtra',
'Jalgaon Bazar,Jalgaon,Maharashtra',
'Jalgaon Collectorate,Jalgaon,Maharashtra',
'Jalgaon H.O,Jalgaon,Maharashtra',
'Jalgaon Kawarnagar,Jalgaon,Maharashtra',
'Jalgaon Peth,Jalgaon,Maharashtra',
'Jalgaon Ram Peth,Jalgaon,Maharashtra',
'Jalke,Jalgaon,Maharashtra',
'Kadgaon,Jalgaon,Maharashtra',
'Kanalda,Jalgaon,Maharashtra',
'Kandari,Jalgaon,Maharashtra',
'Kathora,Jalgaon,Maharashtra',
'Kinod,Jalgaon,Maharashtra',
'M.J.College Jalgaon,Jalgaon,Maharashtra',
'Mamurabad,Jalgaon,Maharashtra',
'Meharun,Jalgaon,Maharashtra',
'Mhasawad,Jalgaon,Maharashtra',
'Mohadi,Jalgaon,Maharashtra',
'N M University Jalgaon,Jalgaon,Maharashtra',
'Nandra,Jalgaon,Maharashtra',
'Nashirabad,Bhusaval,Maharashtra',
'Navi Peth Jalgaon,Jalgaon,Maharashtra',
'Phupnagari,Jalgaon,Maharashtra',
'Pimprala,Jalgaon,Maharashtra',
'Shirsoli,Jalgaon,Maharashtra',
'Tarsod,Jalgaon,Maharashtra',
'Vitner,Jalgaon,Maharashtra',
'Wavdade,Jalgaon,Maharashtra',
'Fattepur,Bhusaval,Maharashtra',
'Jamner,Bhusaval,Maharashtra',
'Neri BK,Bhusaval,Maharashtra',
'Pahur,Bhusaval,Maharashtra',
'Shendurni,Bhusaval,Maharashtra',
'Wakadi,Bhusaval,Maharashtra',
'Kurha-kakoda,Bhusaval,Maharashtra',
'Muktainagar,Bhusaval,Maharashtra',
'Old Muktainagar,Bhusaval,Maharashtra',
'Akhatwade,Jalgaon,Maharashtra',
'Anturli - Ii,Jalgaon,Maharashtra',
'Anturli -- IIi,Jalgaon,Maharashtra',
'Anturli --i,Jalgaon,Maharashtra',
'Asankheda,Jalgaon,Maharashtra',
'Badarkha Hardo,Jalgaon,Maharashtra',
'Balad,Jalgaon,Maharashtra',
'Bambrud Raniche,Jalgaon,Maharashtra',
'Bamrud Budruk,Jalgaon,Maharashtra',
'Chinchpure,Jalgaon,Maharashtra',
'Galan,Jalgaon,Maharashtra',
'Girad,Jalgaon,Maharashtra',
'Goradkheda,Jalgaon,Maharashtra',
'Kasampura,Jalgaon,Maharashtra',
'Khadakdeola,Jalgaon,Maharashtra',
'Khedgaon Nandiche,Jalgaon,Maharashtra',
'Kurangi,Jalgaon,Maharashtra',
'Kurhad,Jalgaon,Maharashtra',
'Lohare,Jalgaon,Maharashtra',
'Lohari Budruk,Jalgaon,Maharashtra',
'Lohtar,Jalgaon,Maharashtra',
'Maheji,Jalgaon,Maharashtra',
'Nagardeola R S,Jalgaon,Maharashtra',
'Nandra Pachora,Jalgaon,Maharashtra',
'Neri,Jalgaon,Maharashtra',
'Nimbhori,Jalgaon,Maharashtra',
'Pachora,Jalgaon,Maharashtra',
'Pahan,Jalgaon,Maharashtra',
'Pardhade,Jalgaon,Maharashtra',
'Pathri,Jalgaon,Maharashtra',
'Pimpalgaon,Jalgaon,Maharashtra',
'Samner,Jalgaon,Maharashtra',
'Sarole,Jalgaon,Maharashtra',
'Satgaon,Jalgaon,Maharashtra',
'Shindad,Jalgaon,Maharashtra',
'Tarkheda,Jalgaon,Maharashtra',
'Vadali,Jalgaon,Maharashtra',
'Vadgaon Ambe,Jalgaon,Maharashtra',
'Vadgaon Budruk,Jalgaon,Maharashtra',
'Vadgaon Khurd,Jalgaon,Maharashtra',
'Varad Budruk,Jalgaon,Maharashtra',
'Varkhedi,Jalgaon,Maharashtra',
'Veruli Khurd,Jalgaon,Maharashtra',
'Wadi,Jalgaon,Maharashtra',
'Adgaon,Jalgaon,Maharashtra',
'Bahadarpur,Jalgaon,Maharashtra',
'Bahute,Jalgaon,Maharashtra',
'Bhilali,Jalgaon,Maharashtra',
'Bholane,Jalgaon,Maharashtra',
'Bole,Jalgaon,Maharashtra',
'Chorwad,Jalgaon,Maharashtra',
'Deogaon,Jalgaon,Maharashtra',
'Dholi,Jalgaon,Maharashtra',
'Dhul Pimpri,Jalgaon,Maharashtra',
'Hol Pimrpi,Jalgaon,Maharashtra',
'Jirali,Jalgaon,Maharashtra',
'Karmad,Jalgaon,Maharashtra',
'Mangrul,Jalgaon,Maharashtra',
'Mhasave,Jalgaon,Maharashtra',
'Mondhale,Jalgaon,Maharashtra',
'Mundane,Jalgaon,Maharashtra',
'Palaskheda Sim,Jalgaon,Maharashtra',
'Parola,Jalgaon,Maharashtra',
'Sadavan,Jalgaon,Maharashtra',
'Sarve,Jalgaon,Maharashtra',
'Shevge,Jalgaon,Maharashtra',
'Shirasmani,Jalgaon,Maharashtra',
'Shivare Digar,Jalgaon,Maharashtra',
'Tamaswadi,Jalgaon,Maharashtra',
'Tehu,Jalgaon,Maharashtra',
'Titvi,Jalgaon,Maharashtra',
'Toli,Jalgaon,Maharashtra',
'Undirkhede,Jalgaon,Maharashtra',
'Ainpur,Bhusaval,Maharashtra',
'Chinawal,Bhusaval,Maharashtra',
'Khirdi,Bhusaval,Maharashtra',
'Khiroda,Bhusaval,Maharashtra',
'Nimbhora,Bhusaval,Maharashtra',
'Raver,Bhusaval,Maharashtra',
'Savda,Bhusaval,Maharashtra',
'Thorgavhan,Bhusaval,Maharashtra',
'Vivra,Bhusaval,Maharashtra',
'Bamnod,Bhusaval,Maharashtra',
'Bhalod,Bhusaval,Maharashtra',
'Faizpur,Bhusaval,Maharashtra',
'Kingaon,Bhusaval,Maharashtra',
'M.S.S.K.Faizpur,Bhusaval,Maharashtra',
'Nhavi,Bhusaval,Maharashtra',
'Padalse,Bhusaval,Maharashtra',
'Sakali,Bhusaval,Maharashtra',
'Sangvi,Bhusaval,Maharashtra',
'Yawal,Bhusaval,Maharashtra',
'Ambad Bazar,Aurangabad(Maharashtra),Maharashtra',
'Ambad,Aurangabad(Maharashtra),Maharashtra',
'Chikangaon,Aurangabad(Maharashtra),Maharashtra',
'Chinchkheda,Aurangabad(Maharashtra),Maharashtra',
'Dahipuri,Aurangabad(Maharashtra),Maharashtra',
'Dahyala,Aurangabad(Maharashtra),Maharashtra',
'Dhakalgaon,Aurangabad(Maharashtra),Maharashtra',
'Dongaon,Aurangabad(Maharashtra),Maharashtra',
'Ghungurde Hadgaon,Aurangabad(Maharashtra),Maharashtra',
'Gondi,Aurangabad(Maharashtra),Maharashtra',
'Guru Pimpri,Aurangabad(Maharashtra),Maharashtra',
'Hastepokhari,Aurangabad(Maharashtra),Maharashtra',
'Jamkhed,Aurangabad(Maharashtra),Maharashtra',
'Mahakala,Aurangabad(Maharashtra),Maharashtra',
'Nalewadi,Aurangabad(Maharashtra),Maharashtra',
'Panewadi,Aurangabad(Maharashtra),Maharashtra',
'Parner,Aurangabad(Maharashtra),Maharashtra',
'Parundi,Aurangabad(Maharashtra),Maharashtra',
'Patharwala,Aurangabad(Maharashtra),Maharashtra',
'Pimpalgaon Saste,Aurangabad(Maharashtra),Maharashtra',
'Rani Unchegaon,Aurangabad(Maharashtra),Maharashtra',
'Rohilagad,Aurangabad(Maharashtra),Maharashtra',
'Shahagad,Aurangabad(Maharashtra),Maharashtra',
'Shahapur,Aurangabad(Maharashtra),Maharashtra',
'Sheoga,Aurangabad(Maharashtra),Maharashtra',
'Sonakpimpalgaon,Aurangabad(Maharashtra),Maharashtra',
'Sukhapuri,Aurangabad(Maharashtra),Maharashtra',
'Tadhadgaon,Aurangabad(Maharashtra),Maharashtra',
'Wadigodri,Aurangabad(Maharashtra),Maharashtra',
'Zirpi,Aurangabad(Maharashtra),Maharashtra',
'Akola (Niklak),Aurangabad(Maharashtra),Maharashtra',
'Chikhli,Aurangabad(Maharashtra),Maharashtra',
'Dabhadi,Aurangabad(Maharashtra),Maharashtra',
'Deogaon Kusali,Aurangabad(Maharashtra),Maharashtra',
'Dhasala,Aurangabad(Maharashtra),Maharashtra',
'Georai(Bazar),Aurangabad(Maharashtra),Maharashtra',
'Hiswan,Aurangabad(Maharashtra),Maharashtra',
'Hivra Roshangaon,Aurangabad(Maharashtra),Maharashtra',
'Kandhari (Bk),Aurangabad(Maharashtra),Maharashtra',
'Karla,Aurangabad(Maharashtra),Maharashtra',
'Keligavahan,Aurangabad(Maharashtra),Maharashtra',
'Khamgaon,Aurangabad(Maharashtra),Maharashtra',
'Nanegaon,Aurangabad(Maharashtra),Maharashtra',
'Roshangaon,Aurangabad(Maharashtra),Maharashtra',
'Saigaon (Dongargaon),Aurangabad(Maharashtra),Maharashtra',
'Shelgaon,Aurangabad(Maharashtra),Maharashtra',
'Somthana,Aurangabad(Maharashtra),Maharashtra',
'Adgaon,Aurangabad(Maharashtra),Maharashtra',
'Avana,Aurangabad(Maharashtra),Maharashtra',
'Babhulgaon,Aurangabad(Maharashtra),Maharashtra',
'Chandai Eko,Aurangabad(Maharashtra),Maharashtra',
'Danapur,Aurangabad(Maharashtra),Maharashtra',
'Dhavda,Aurangabad(Maharashtra),Maharashtra',
'Kathora,Aurangabad(Maharashtra),Maharashtra',
'Kedarkheda,Aurangabad(Maharashtra),Maharashtra',
'Kosgaon,Aurangabad(Maharashtra),Maharashtra',
'Nalni,Aurangabad(Maharashtra),Maharashtra',
'Pimalgaon Kolte,Aurangabad(Maharashtra),Maharashtra',
'Pimpalgaon R,Aurangabad(Maharashtra),Maharashtra',
'Rajur,Aurangabad(Maharashtra),Maharashtra',
'Sawangi A,Aurangabad(Maharashtra),Maharashtra',
'Shelud,Aurangabad(Maharashtra),Maharashtra',
'Sipora,Aurangabad(Maharashtra),Maharashtra',
'Soegaon Devi,Aurangabad(Maharashtra),Maharashtra',
'Surangali,Aurangabad(Maharashtra),Maharashtra',
'Tadegaon,Aurangabad(Maharashtra),Maharashtra',
'Takli Kolta,Aurangabad(Maharashtra),Maharashtra',
'Talegaon,Aurangabad(Maharashtra),Maharashtra',
'Wadi BK,Aurangabad(Maharashtra),Maharashtra',
'Walsa Khalsa,Aurangabad(Maharashtra),Maharashtra',
'Walsawangi,Aurangabad(Maharashtra),Maharashtra',
'Warud BK,Aurangabad(Maharashtra),Maharashtra',
'Warud Tangde,Aurangabad(Maharashtra),Maharashtra',
'Pahtepur,Aurangabad(Maharashtra),Maharashtra',
'Walsa Wadala,Aurangabad(Maharashtra),Maharashtra',
'Antarwali Tmbhi,Aurangabad(Maharashtra),Maharashtra',
'Bodkha BK,Aurangabad(Maharashtra),Maharashtra',
'Dhakephal,Aurangabad(Maharashtra),Maharashtra',
'Ghansawangi,Aurangabad(Maharashtra),Maharashtra',
'Gunj BK,Aurangabad(Maharashtra),Maharashtra',
'Jam Samarth,Aurangabad(Maharashtra),Maharashtra',
'Jiradgaon,Aurangabad(Maharashtra),Maharashtra',
'Kandharai Partur,Aurangabad(Maharashtra),Maharashtra',
'Karadgaon,Aurangabad(Maharashtra),Maharashtra',
'Khapardev Hivra,Aurangabad(Maharashtra),Maharashtra',
'Kumbhar Pimpalgaon,Aurangabad(Maharashtra),Maharashtra',
'Machindra Chincholi,Aurangabad(Maharashtra),Maharashtra',
'Mangrul,Aurangabad(Maharashtra),Maharashtra',
'Paradggaon,Aurangabad(Maharashtra),Maharashtra',
'Pimparkheda (Bk),Aurangabad(Maharashtra),Maharashtra',
'Raja Takli,Aurangabad(Maharashtra),Maharashtra',
'Ramasgaon,Aurangabad(Maharashtra),Maharashtra',
'Tirthpuri,Aurangabad(Maharashtra),Maharashtra',
'Ranjani,Aurangabad(Maharashtra),Maharashtra',
'Akola,Aurangabad(Maharashtra),Maharashtra',
'Bharaj,Aurangabad(Maharashtra),Maharashtra',
'Devlegavhan,Aurangabad(Maharashtra),Maharashtra',
'Hivra Kabli,Aurangabad(Maharashtra),Maharashtra',
'Jaffrabad,Aurangabad(Maharashtra),Maharashtra',
'Janephal,Aurangabad(Maharashtra),Maharashtra',
'Khasgaon,Aurangabad(Maharashtra),Maharashtra',
'Kumbharzari,Aurangabad(Maharashtra),Maharashtra',
'Mahora,Aurangabad(Maharashtra),Maharashtra',
'Sipora Ambhora,Aurangabad(Maharashtra),Maharashtra',
'Tapowan Gondhan,Aurangabad(Maharashtra),Maharashtra',
'Tembhurni,Aurangabad(Maharashtra),Maharashtra',
'Warud BK,Aurangabad(Maharashtra),Maharashtra',
'Warud KH,Aurangabad(Maharashtra),Maharashtra',
'Ambika Market Jalna,Aurangabad(Maharashtra),Maharashtra',
'Ankush Nagar,Aurangabad(Maharashtra),Maharashtra',
'Bawne Pangri,Aurangabad(Maharashtra),Maharashtra',
'Bhatepuri,Aurangabad(Maharashtra),Maharashtra',
'Borgaon,Aurangabad(Maharashtra),Maharashtra',
'Chitili Putli,Aurangabad(Maharashtra),Maharashtra',
'Collectorate Complex Jalna,Aurangabad(Maharashtra),Maharashtra',
'Dongaon,Aurangabad(Maharashtra),Maharashtra',
'Dudhna Kelgaon,Aurangabad(Maharashtra),Maharashtra',
'Golapangri,Aurangabad(Maharashtra),Maharashtra',
'Gondegaon,Aurangabad(Maharashtra),Maharashtra',
'Hastepimpalgaon,Aurangabad(Maharashtra),Maharashtra',
'Jalna H.O,Aurangabad(Maharashtra),Maharashtra',
'Jalna Industrial Area,Aurangabad(Maharashtra),Maharashtra',
'Jalna Mondha,Aurangabad(Maharashtra),Maharashtra',
'Jalna Railway Station,Aurangabad(Maharashtra),Maharashtra',
'Jamwadi,Aurangabad(Maharashtra),Maharashtra',
'Javkheda BK,Aurangabad(Maharashtra),Maharashtra',
'Kajala,Aurangabad(Maharashtra),Maharashtra',
'Longaon,Aurangabad(Maharashtra),Maharashtra',
'Manegaon,Aurangabad(Maharashtra),Maharashtra',
'Maujpuri,Aurangabad(Maharashtra),Maharashtra',
'Midc Jalna,Aurangabad(Maharashtra),Maharashtra',
'Navha,Aurangabad(Maharashtra),Maharashtra',
'Ner,Aurangabad(Maharashtra),Maharashtra',
'Old Jalna,Aurangabad(Maharashtra),Maharashtra',
'Pachan Wadgaon,Aurangabad(Maharashtra),Maharashtra',
'Pathrud,Aurangabad(Maharashtra),Maharashtra',
'Pir Pimpalgaon,Aurangabad(Maharashtra),Maharashtra',
'Pirkalyan,Aurangabad(Maharashtra),Maharashtra',
'Rakhiv Police Bal Jalna,Aurangabad(Maharashtra),Maharashtra',
'Revgaon,Aurangabad(Maharashtra),Maharashtra',
'Sawargaon Hadap,Aurangabad(Maharashtra),Maharashtra',
'Seoli,Aurangabad(Maharashtra),Maharashtra',
'Shindekelgaon,Aurangabad(Maharashtra),Maharashtra',
'Utwad,Aurangabad(Maharashtra),Maharashtra',
'Waghrul,Aurangabad(Maharashtra),Maharashtra',
'Wakhari,Aurangabad(Maharashtra),Maharashtra',
'Akani,Pharbhani,Maharashtra',
'Bellora,Pharbhani,Maharashtra',
'Dahifal,Pharbhani,Maharashtra',
'Devgaon,Pharbhani,Maharashtra',
'Helas,Pharbhani,Maharashtra',
'Idoli,Pharbhani,Maharashtra',
'Jaipur,Pharbhani,Maharashtra',
'K. Sawangi,Pharbhani,Maharashtra',
'Kendhali,Pharbhani,Maharashtra',
'Kirla,Pharbhani,Maharashtra',
'Mantha,Pharbhani,Maharashtra',
'Pangri BK,Pharbhani,Maharashtra',
'Pangri Gosavi,Pharbhani,Maharashtra',
'Patoda,Pharbhani,Maharashtra',
'Pimparkheda,Pharbhani,Maharashtra',
'Talni,Pharbhani,Maharashtra',
'Uswad,Pharbhani,Maharashtra',
'Vaidya Wadgaon,Pharbhani,Maharashtra',
'Amba,Pharbhani,Maharashtra',
'Anandwadi,Pharbhani,Maharashtra',
'Ashti,Pharbhani,Maharashtra',
'Babultara,Pharbhani,Maharashtra',
'Golegaon,Pharbhani,Maharashtra',
'Hatdi,Pharbhani,Maharashtra',
'K. Hadgaon,Pharbhani,Maharashtra',
'Khandavi,Pharbhani,Maharashtra',
'Lingasa,Pharbhani,Maharashtra',
'Loni,Pharbhani,Maharashtra',
'Mapegaon,Pharbhani,Maharashtra',
'Osmanpur,Pharbhani,Maharashtra',
'P. Dhamangaon,Pharbhani,Maharashtra',
'Pande Pokhari,Pharbhani,Maharashtra',
'Partur,Pharbhani,Maharashtra',
'Patoda Mav,Pharbhani,Maharashtra',
'Raigavan,Pharbhani,Maharashtra',
'Rohina,Pharbhani,Maharashtra',
'Satona,Pharbhani,Maharashtra',
'Shelgaon,Pharbhani,Maharashtra',
'Shrishti,Pharbhani,Maharashtra',
'Warphal,Pharbhani,Maharashtra',
'Watur,Pharbhani,Maharashtra',
'Ajara,Kolhapur,Maharashtra',
'Ardal,Kolhapur,Maharashtra',
'Bahirewadi,Kolhapur,Maharashtra',
'Bhadvan,Kolhapur,Maharashtra',
'Chimane,Kolhapur,Maharashtra',
'Dhamane,Kolhapur,Maharashtra',
'Halewadi,Kolhapur,Maharashtra',
'Hativade,Kolhapur,Maharashtra',
'Honyali,Kolhapur,Maharashtra',
'Kasar Kandgaon,Kolhapur,Maharashtra',
'Kitawade,Kolhapur,Maharashtra',
'Madilage,Kolhapur,Maharashtra',
'Mahagond,Kolhapur,Maharashtra',
'Masewadi,Kolhapur,Maharashtra',
'Mumewadi,Kolhapur,Maharashtra',
'Pernoli,Kolhapur,Maharashtra',
'Shipur T/F Ajara,Kolhapur,Maharashtra',
'Sohale,Kolhapur,Maharashtra',
'Uttur,Kolhapur,Maharashtra',
'Vite,Kolhapur,Maharashtra',
'Yerandol,Kolhapur,Maharashtra',
'Zulpewadi,Kolhapur,Maharashtra',
'Adoli,Kolhapur,Maharashtra',
'Anap Khurd,Kolhapur,Maharashtra',
'Barve,Kolhapur,Maharashtra',
'Bhativade,Kolhapur,Maharashtra',
'Gangapur,Kolhapur,Maharashtra',
'Gargoti,Kolhapur,Maharashtra',
'Hedawade,Kolhapur,Maharashtra',
'Kadgaon Gargoti,Kolhapur,Maharashtra',
'Kalnakwadi,Kolhapur,Maharashtra',
'Karadwadi,Kolhapur,Maharashtra',
'Kolwan,Kolhapur,Maharashtra',
'Kondoshi,Kolhapur,Maharashtra',
'Koor,Kolhapur,Maharashtra',
'Madilage BK,Kolhapur,Maharashtra',
'Manawale,Kolhapur,Maharashtra',
'Mangnoor,Kolhapur,Maharashtra',
'Mathgaon,Kolhapur,Maharashtra',
'Mhasrang,Kolhapur,Maharashtra',
'Mhasve,Kolhapur,Maharashtra',
'Minche BK,Kolhapur,Maharashtra',
'Minche KH,Kolhapur,Maharashtra',
'Nadhavade,Kolhapur,Maharashtra',
'Navale,Kolhapur,Maharashtra',
'Nilpan,Kolhapur,Maharashtra',
'Pal,Kolhapur,Maharashtra',
'Palshivane,Kolhapur,Maharashtra',
'Patgaon,Kolhapur,Maharashtra',
'Phanaswadi,Kolhapur,Maharashtra',
'Pimpalgaon,Kolhapur,Maharashtra',
'Sheloli,Kolhapur,Maharashtra',
'Shengaon,Kolhapur,Maharashtra',
'Shivdav,Kolhapur,Maharashtra',
'Sonarwadi,Kolhapur,Maharashtra',
'Tambale,Kolhapur,Maharashtra',
'Tambyachiwadi,Kolhapur,Maharashtra',
'Tikkewadi,Kolhapur,Maharashtra',
'Vengrul,Kolhapur,Maharashtra',
'Vesarde,Kolhapur,Maharashtra',
'Waghapur,Kolhapur,Maharashtra',
'Adkur,Kolhapur,Maharashtra',
'Ambewadi,Kolhapur,Maharashtra',
'Amroli,Kolhapur,Maharashtra',
'Arjunwadi,Kolhapur,Maharashtra',
'Basarge,Kolhapur,Maharashtra',
'Chandgad,Kolhapur,Maharashtra',
'Date,Kolhapur,Maharashtra',
'Daulat Sugar Factory,Kolhapur,Maharashtra',
'Dholgarwadi,Kolhapur,Maharashtra',
'Dukkarwadi,Kolhapur,Maharashtra',
'Dundage,Kolhapur,Maharashtra',
'Gavase,Kolhapur,Maharashtra',
'Hadalage,Kolhapur,Maharashtra',
'Hajgoli,Kolhapur,Maharashtra',
'Halkarni (Chandgad),Kolhapur,Maharashtra',
'Hanimnal,Kolhapur,Maharashtra',
'Hasur Champu,Kolhapur,Maharashtra',
'Hebbal,Kolhapur,Maharashtra',
'Hera,Kolhapur,Maharashtra',
'Hindgaon,Kolhapur,Maharashtra',
'Hitni,Kolhapur,Maharashtra',
'Hosur,Kolhapur,Maharashtra',
'Ibrahimpur,Kolhapur,Maharashtra',
'Isapur,Kolhapur,Maharashtra',
'Jangamhatti,Kolhapur,Maharashtra',
'Jarali,Kolhapur,Maharashtra',
'Kalkundri,Kolhapur,Maharashtra',
'Kanadewadi,Kolhapur,Maharashtra',
'Kanur Khurd,Kolhapur,Maharashtra',
'Karve,Kolhapur,Maharashtra',
'Keravade,Kolhapur,Maharashtra',
'Khandal,Kolhapur,Maharashtra',
'Kine,Kolhapur,Maharashtra',
'Kini,Kolhapur,Maharashtra',
'Kowad,Kolhapur,Maharashtra',
'Kudnur,Kolhapur,Maharashtra',
'Kurani Buzawade,Kolhapur,Maharashtra',
'Mahalewadi,Kolhapur,Maharashtra',
'Malatwadi,Kolhapur,Maharashtra',
'Mangaon,Kolhapur,Maharashtra',
'Mhalunge Khalsa,Kolhapur,Maharashtra',
'Mugali,Kolhapur,Maharashtra',
'Mutnal,Kolhapur,Maharashtra',
'Naganwadi,Kolhapur,Maharashtra',
'Nagave,Kolhapur,Maharashtra',
'Nandavade,Kolhapur,Maharashtra',
'Nangnoor,Kolhapur,Maharashtra',
'Nesari,Kolhapur,Maharashtra',
'Nilji,Kolhapur,Maharashtra',
'Nittur,Kolhapur,Maharashtra',
'Patne,Kolhapur,Maharashtra',
'Rajagoli KH,Kolhapur,Maharashtra',
'Sambre,Kolhapur,Maharashtra',
'Satavane,Kolhapur,Maharashtra',
'Shinoli KH,Kolhapur,Maharashtra',
'Shippur T/F Nesari,Kolhapur,Maharashtra',
'Shivanage Lakkikatte,Kolhapur,Maharashtra',
'Sundi,Kolhapur,Maharashtra',
'Surute,Kolhapur,Maharashtra',
'Teurwadi,Kolhapur,Maharashtra',
'Tillarinagar,Kolhapur,Maharashtra',
'Tudiye,Kolhapur,Maharashtra',
'Turkewadi,Kolhapur,Maharashtra',
'Umgaon,Kolhapur,Maharashtra',
'Watangi,Kolhapur,Maharashtra',
'Ainapur,Kolhapur,Maharashtra',
'Aralgundi,Kolhapur,Maharashtra',
'Atyal,Kolhapur,Maharashtra',
'Badyachiwadi,Kolhapur,Maharashtra',
'Basarge BK,Kolhapur,Maharashtra',
'Batkangale,Kolhapur,Maharashtra',
'Bhadgaon,Kolhapur,Maharashtra',
'Bugadikatti,Kolhapur,Maharashtra',
'Channe Kuppi,Kolhapur,Maharashtra',
'Gadhinglaj,Kolhapur,Maharashtra',
'Gadhinglaj Shivaji Chowk,Kolhapur,Maharashtra',
'Gadhinglaj Tilakpath,Kolhapur,Maharashtra',
'Gajargaon,Kolhapur,Maharashtra',
'Gijawane,Kolhapur,Maharashtra',
'Halkarni,Kolhapur,Maharashtra',
'Harali BK,Kolhapur,Maharashtra',
'Hasur Sasgiri,Kolhapur,Maharashtra',
'Hebbal Jaldyal,Kolhapur,Maharashtra',
'Hiralge,Kolhapur,Maharashtra',
'Inchnal,Kolhapur,Maharashtra',
'Kadalage,Kolhapur,Maharashtra',
'Kadgaon Gadhinglaj,Kolhapur,Maharashtra',
'Kalvikatti,Kolhapur,Maharashtra',
'Kanoli,Kolhapur,Maharashtra',
'Karambali,Kolhapur,Maharashtra',
'Kolindre,Kolhapur,Maharashtra',
'Koulage,Kolhapur,Maharashtra',
'Kowade,Kolhapur,Maharashtra',
'Lakudwadi,Kolhapur,Maharashtra',
'Mahagaon,Kolhapur,Maharashtra',
'Maligre,Kolhapur,Maharashtra',
'Mangnoor T/F Sawantwadi,Kolhapur,Maharashtra',
'Manwad,Kolhapur,Maharashtra',
'Mungurwadi,Kolhapur,Maharashtra',
'Nandanwad,Kolhapur,Maharashtra',
'Narewadi,Kolhapur,Maharashtra',
'Navkud,Kolhapur,Maharashtra',
'Ningudage,Kolhapur,Maharashtra',
'Nool,Kolhapur,Maharashtra',
'Sarambalwadi,Kolhapur,Maharashtra',
'Sule,Kolhapur,Maharashtra',
'Terni,Kolhapur,Maharashtra',
'Vadarage Majare,Kolhapur,Maharashtra',
'Yenechavandi,Kolhapur,Maharashtra',
'Asandoli,Kolhapur,Maharashtra',
'Aslaj,Kolhapur,Maharashtra',
'Borbet,Kolhapur,Maharashtra',
'Gaganbavada,Kolhapur,Maharashtra',
'Gariwade,Kolhapur,Maharashtra',
'Katali,Kolhapur,Maharashtra',
'Mandukali,Kolhapur,Maharashtra',
'Salvan,Kolhapur,Maharashtra',
'Sangashi,Kolhapur,Maharashtra',
'Shenawade,Kolhapur,Maharashtra',
'Tisangi,Kolhapur,Maharashtra',
'Bahubali,Kolhapur,Maharashtra',
'Hatkalangada,Kolhapur,Maharashtra',
'ICO Spinning Mills,Kolhapur,Maharashtra',
'Kabnur,Kolhapur,Maharashtra',
'Kapadmarket Ichalkaranji,Kolhapur,Maharashtra',
'MIDC Shiroli,Kolhapur,Maharashtra',
'Nadivesh Ichalkaranji,Kolhapur,Maharashtra',
'Pattankodoli,Kolhapur,Maharashtra',
'Randivewadi,Kolhapur,Maharashtra',
'Rangoli,Kolhapur,Maharashtra',
'Rukadi,Kolhapur,Maharashtra',
'Sangavade,Kolhapur,Maharashtra',
'Shivajinagar Ichalkaranji,Kolhapur,Maharashtra',
'Udyog Nagar Ichalkaranji,Kolhapur,Maharashtra',
'Vadgaon,Kolhapur,Maharashtra',
'Alate,Kolhapur,Maharashtra',
'Ambap,Kolhapur,Maharashtra',
'Atigre,Kolhapur,Maharashtra',
'Bhadole,Kolhapur,Maharashtra',
'Bhendwade,Kolhapur,Maharashtra',
'Buvache Vathar,Kolhapur,Maharashtra',
'Chandur,Kolhapur,Maharashtra',
'Chavare,Kolhapur,Maharashtra',
'Chipri,Kolhapur,Maharashtra',
'Chokak,Kolhapur,Maharashtra',
'Danoli,Kolhapur,Maharashtra',
'Dharangutti,Kolhapur,Maharashtra',
'Ghunki,Kolhapur,Maharashtra',
'Halsawade,Kolhapur,Maharashtra',
'Haroli,Kolhapur,Maharashtra',
'Hupari,Kolhapur,Maharashtra',
'Ichalkaranji H.O,Kolhapur,Maharashtra',
'Ingali,Kolhapur,Maharashtra',
'Jakhale,Kolhapur,Maharashtra',
'Jaysingp R.S.,Kolhapur,Maharashtra',
'June Pargaon,Kolhapur,Maharashtra',
'Kavathesar,Kolhapur,Maharashtra',
'Khochi,Kolhapur,Maharashtra',
'Kini,Kolhapur,Maharashtra',
'Korochi,Kolhapur,Maharashtra',
'Kothali,Kolhapur,Maharashtra',
'Latwade,Kolhapur,Maharashtra',
'Majale,Kolhapur,Maharashtra',
'Male,Kolhapur,Maharashtra',
'Manapadale,Kolhapur,Maharashtra',
'Mangaon,Kolhapur,Maharashtra',
'Minche,Kolhapur,Maharashtra',
'Narande,Kolhapur,Maharashtra',
'Nej,Kolhapur,Maharashtra',
'Nimshirgaon,Kolhapur,Maharashtra',
'Pulachi Shiroli,Kolhapur,Maharashtra',
'R K Nagar Ichalkaranji,Kolhapur,Maharashtra',
'Rendal,Kolhapur,Maharashtra',
'Rui,Kolhapur,Maharashtra',
'Sajani,Kolhapur,Maharashtra',
'Savarde,Kolhapur,Maharashtra',
'Shiradwad,Kolhapur,Maharashtra',
'Talandage,Kolhapur,Maharashtra',
'Talasande,Kolhapur,Maharashtra',
'Tamadalage,Kolhapur,Maharashtra',
'Tilwani,Kolhapur,Maharashtra',
'Umalwad,Kolhapur,Maharashtra',
'Vasagade,Kolhapur,Maharashtra',
'Vathar T/F vadgaon,Kolhapur,Maharashtra',
'Yadrav,Kolhapur,Maharashtra',
'Yalgud,Kolhapur,Maharashtra',
'Ganganagar Ichalkaranji,Kolhapur,Maharashtra',
'Jawaharnagar Ichalkaranji,Kolhapur,Maharashtra',
'Anur,Kolhapur,Maharashtra',
'Arjuni,Kolhapur,Maharashtra',
'Arjunwada,Kolhapur,Maharashtra',
'Baleghol,Kolhapur,Maharashtra',
'Bamani,Kolhapur,Maharashtra',
'Banage,Kolhapur,Maharashtra',
'Baradwadi,Kolhapur,Maharashtra',
'Bastavade,Kolhapur,Maharashtra',
'Belewadi Kalamma,Kolhapur,Maharashtra',
'Bidri,Kolhapur,Maharashtra',
'Bolavi,Kolhapur,Maharashtra',
'Boravade,Kolhapur,Maharashtra',
'Chikhali,Kolhapur,Maharashtra',
'Chuye,Kolhapur,Maharashtra',
'Dindnerli,Kolhapur,Maharashtra',
'Ekondi,Kolhapur,Maharashtra',
'Gorambe,Kolhapur,Maharashtra',
'Hamidwada,Kolhapur,Maharashtra',
'Hasur Khurd,Kolhapur,Maharashtra',
'Ispurli,Kolhapur,Maharashtra',
'Kagal,Kolhapur,Maharashtra',
'Kapshi,Kolhapur,Maharashtra',
'Karanjivane,Kolhapur,Maharashtra',
'Kardyal,Kolhapur,Maharashtra',
'Karnur,Kolhapur,Maharashtra',
'Kasari,Kolhapur,Maharashtra',
'Kasba Sangaon,Kolhapur,Maharashtra',
'Kavane,Kolhapur,Maharashtra',
'Kenavade,Kolhapur,Maharashtra',
'Khadakewada,Kolhapur,Maharashtra',
'Koulage,Kolhapur,Maharashtra',
'Lingnur Dumala,Kolhapur,Maharashtra',
'Madyal,Kolhapur,Maharashtra',
'Malage BK,Kolhapur,Maharashtra',
'Mhakave,Kolhapur,Maharashtra',
'Mhalunge,Kolhapur,Maharashtra',
'MIDC Gokul Shirgaon,Kolhapur,Maharashtra',
'Mouje Haladi,Kolhapur,Maharashtra',
'Mouje Sangaon,Kolhapur,Maharashtra',
'Mudhal,Kolhapur,Maharashtra',
'Mugali,Kolhapur,Maharashtra',
'Murgud,Kolhapur,Maharashtra',
'Nandgaon,Kolhapur,Maharashtra',
'Nidhori,Kolhapur,Maharashtra',
'Nigave Khalasa,Kolhapur,Maharashtra',
'Pimpalgaon BK,Kolhapur,Maharashtra',
'Pimpalgaon KH,Kolhapur,Maharashtra',
'Sadashivnagar,Kolhapur,Maharashtra',
'Savarde BK,Kolhapur,Maharashtra',
'Shankarwadi,Kolhapur,Maharashtra',
'Shendur,Kolhapur,Maharashtra',
'Sidhnerli,Kolhapur,Maharashtra',
'Sonage,Kolhapur,Maharashtra',
'Sonali,Kolhapur,Maharashtra',
'Sulkud,Kolhapur,Maharashtra',
'Surupali,Kolhapur,Maharashtra',
'Talashi,Kolhapur,Maharashtra',
'Tamnakwada,Kolhapur,Maharashtra',
'Thikpurli,Kolhapur,Maharashtra',
'Titave,Kolhapur,Maharashtra',
'Turambe,Kolhapur,Maharashtra',
'Undarwadi,Kolhapur,Maharashtra',
'Vadgaon,Kolhapur,Maharashtra',
'Vandur,Kolhapur,Maharashtra',
'Vhannur,Kolhapur,Maharashtra',
'Walwa Bk,Kolhapur,Maharashtra',
'Yamage,Kolhapur,Maharashtra',
'Ambewadi,Kolhapur,Maharashtra',
'Amshi Dumala,Kolhapur,Maharashtra',
'Are,Kolhapur,Maharashtra',
'Babujamal,Kolhapur,Maharashtra',
'Bachani,Kolhapur,Maharashtra',
'Bahireshwar,Kolhapur,Maharashtra',
'Balinge,Kolhapur,Maharashtra',
'Beed,Kolhapur,Maharashtra',
'Bhendegalli,Kolhapur,Maharashtra',
'Bhuye,Kolhapur,Maharashtra',
'Chikhali,Kolhapur,Maharashtra',
'Chinchwad,Kolhapur,Maharashtra',
'Gadmudshingi,Kolhapur,Maharashtra',
'Gandhinagar,Kolhapur,Maharashtra',
'Girgaon,Kolhapur,Maharashtra',
'Gur Market Yard,Kolhapur,Maharashtra',
'Haldi,Kolhapur,Maharashtra',
'Hanmantwadi,Kolhapur,Maharashtra',
'Hasur Dumala,Kolhapur,Maharashtra',
'Herla,Kolhapur,Maharashtra',
'Jatharwadi,Kolhapur,Maharashtra',
'Kalamba,Kolhapur,Maharashtra',
'Kandgaon,Kolhapur,Maharashtra',
'Kaneri,Kolhapur,Maharashtra',
'Kasba Bavada,Kolhapur,Maharashtra',
'Kerle,Kolhapur,Maharashtra',
'Kerli,Kolhapur,Maharashtra',
'Khatangale,Kolhapur,Maharashtra',
'Koge,Kolhapur,Maharashtra',
'Kolhapur City H.O,Kolhapur,Maharashtra',
'Kolhapur H.O,Kolhapur,Maharashtra',
'Kolhapur RS,Kolhapur,Maharashtra',
'Kothali,Kolhapur,Maharashtra',
'Kuditre,Kolhapur,Maharashtra',
'Laxmipuri,Kolhapur,Maharashtra',
'Malyachi Shiroli,Kolhapur,Maharashtra',
'Mangalwar Peth,Kolhapur,Maharashtra',
'Nagaon,Kolhapur,Maharashtra',
'Nerli,Kolhapur,Maharashtra',
'Nigave Dumala,Kolhapur,Maharashtra',
'Pachgaon,Kolhapur,Maharashtra',
'Padali Khurd,Kolhapur,Maharashtra',
'Parite,Kolhapur,Maharashtra',
'Phulewadi,Kolhapur,Maharashtra',
'Pohale Turf Alate,Kolhapur,Maharashtra',
'Porle Turf Thane,Kolhapur,Maharashtra',
'Pratibhanagar,Kolhapur,Maharashtra',
'R K Nagar,Kolhapur,Maharashtra',
'Rajarampuri,Kolhapur,Maharashtra',
'Rankala,Kolhapur,Maharashtra',
'Ruikar Colony,Kolhapur,Maharashtra',
'Sadoli Khalsa,Kolhapur,Maharashtra',
'Sangrul,Kolhapur,Maharashtra',
'Savarde Dumala,Kolhapur,Maharashtra',
'Shahupuri,Kolhapur,Maharashtra',
'Shaniwar Peth,Kolhapur,Maharashtra',
'Shingnapur,Kolhapur,Maharashtra',
'Shivaji Peth,Kolhapur,Maharashtra',
'Shivaji Udyam Nagar,Kolhapur,Maharashtra',
'Shivaji University,Kolhapur,Maharashtra',
'Shivaji Veedyapeeth Marg,Kolhapur,Maharashtra',
'Shiye,Kolhapur,Maharashtra',
'Shukrawar Peth,Kolhapur,Maharashtra',
'Tasgaon,Kolhapur,Maharashtra',
'Top,Kolhapur,Maharashtra',
'Uchgaon,Kolhapur,Maharashtra',
'Vadange,Kolhapur,Maharashtra',
'Vakare,Kolhapur,Maharashtra',
'Valivade,Kolhapur,Maharashtra',
'Varange Padali,Kolhapur,Maharashtra',
'Wadi Ratnagiri,Kolhapur,Maharashtra',
'Waghave,Kolhapur,Maharashtra',
'Washi,Kolhapur,Maharashtra',
'Kurukali,Kolhapur,Maharashtra',
'Ambavade,Kolhapur,Maharashtra',
'Bajar Bhogaon,Kolhapur,Maharashtra',
'Bandiwade,Kolhapur,Maharashtra',
'Bhamate,Kolhapur,Maharashtra',
'Borgaon,Kolhapur,Maharashtra',
'Dhundwade,Kolhapur,Maharashtra',
'Ghotavade,Kolhapur,Maharashtra',
'Kakhe,Kolhapur,Maharashtra',
'Kale,Kolhapur,Maharashtra',
'Kaneri (Panhala),Kolhapur,Maharashtra',
'Karanjphen,Kolhapur,Maharashtra',
'Karanjphen,Kolhapur,Maharashtra',
'Kasba Thane,Kolhapur,Maharashtra',
'Kate Bhogaon,Kolhapur,Maharashtra',
'Khupire,Kolhapur,Maharashtra',
'Kisrul,Kolhapur,Maharashtra',
'Kodoli,Kolhapur,Maharashtra',
'Kolik,Kolhapur,Maharashtra',
'Kololi,Kolhapur,Maharashtra',
'Koparde,Kolhapur,Maharashtra',
'Kotoli,Kolhapur,Maharashtra',
'Majgaon,Kolhapur,Maharashtra',
'Malapude,Kolhapur,Maharashtra',
'Male,Kolhapur,Maharashtra',
'Mhasurli,Kolhapur,Maharashtra',
'Mohare,Kolhapur,Maharashtra',
'Nandgaon,Kolhapur,Maharashtra',
'Padal,Kolhapur,Maharashtra',
'Panhala,Kolhapur,Maharashtra',
'Panutre,Kolhapur,Maharashtra',
'Parkhandale,Kolhapur,Maharashtra',
'Pat Panhala,Kolhapur,Maharashtra',
'Pisatri,Kolhapur,Maharashtra',
'Pohale T/F Borgaon,Kolhapur,Maharashtra',
'Punal,Kolhapur,Maharashtra',
'Rakshi,Kolhapur,Maharashtra',
'Satave,Kolhapur,Maharashtra',
'Savarde T/F Satave,Kolhapur,Maharashtra',
'Sule,Kolhapur,Maharashtra',
'Tirpan,Kolhapur,Maharashtra',
'Vetawade,Kolhapur,Maharashtra',
'Warnanagar,Kolhapur,Maharashtra',
'Yavluj,Kolhapur,Maharashtra',
'Nivsar,Ratnagiri,Maharashtra',
'Palu,Ratnagiri,Maharashtra',
'Panhale,Ratnagiri,Maharashtra',
'Prabhanvalli,Ratnagiri,Maharashtra',
'Punas,Ratnagiri,Maharashtra',
'Ringane,Ratnagiri,Maharashtra',
'Roon,Ratnagiri,Maharashtra',
'Salpe,Ratnagiri,Maharashtra',
'Satavali,Ratnagiri,Maharashtra',
'Shiposhi,Ratnagiri,Maharashtra',
'Shirambavali,Ratnagiri,Maharashtra',
'Shiravali,Ratnagiri,Maharashtra',
'Talavade,Ratnagiri,Maharashtra',
'Upale,Ratnagiri,Maharashtra',
'Vadgaon,Ratnagiri,Maharashtra',
'Vangule,Ratnagiri,Maharashtra',
'Veral,Ratnagiri,Maharashtra',
'Veravali Budruk,Ratnagiri,Maharashtra',
'Veravali Khurd,Ratnagiri,Maharashtra',
'Vhel,Ratnagiri,Maharashtra',
'Vilavade,Ratnagiri,Maharashtra',
'Waghangaon,Ratnagiri,Maharashtra',
'Waghrat,Ratnagiri,Maharashtra',
'Waked,Ratnagiri,Maharashtra',
'Zapade,Ratnagiri,Maharashtra',
'Amdave,Ratnagiri,Maharashtra',
'Bankot,Ratnagiri,Maharashtra',
'Chinchghar,Ratnagiri,Maharashtra',
'Dahagaon,Ratnagiri,Maharashtra',
'Devhare,Ratnagiri,Maharashtra',
'Dhutroli,Ratnagiri,Maharashtra',
'Gharadi,Ratnagiri,Maharashtra',
'Gothe,Ratnagiri,Maharashtra',
'Kumbale,Ratnagiri,Maharashtra',
'Latwan,Ratnagiri,Maharashtra',
'Mandangad,Ratnagiri,Maharashtra',
'Mhapral,Ratnagiri,Maharashtra',
'Nigadi,Ratnagiri,Maharashtra',
'Padve,Ratnagiri,Maharashtra',
'Peve,Ratnagiri,Maharashtra',
'Pimploli,Ratnagiri,Maharashtra',
'Shipole,Ratnagiri,Maharashtra',
'Soveli,Ratnagiri,Maharashtra',
'Takede,Ratnagiri,Maharashtra',
'Tide,Ratnagiri,Maharashtra',
'Tulshi,Ratnagiri,Maharashtra',
'Umroli,Ratnagiri,Maharashtra',
'Valote,Ratnagiri,Maharashtra',
'Velas,Ratnagiri,Maharashtra',
'Veshvi,Ratnagiri,Maharashtra',
'Adivare,Ratnagiri,Maharashtra',
'Ajiwali,Ratnagiri,Maharashtra',
'Ambolgad,Ratnagiri,Maharashtra',
'Angale,Ratnagiri,Maharashtra',
'Ansure,Ratnagiri,Maharashtra',
'Bagave Wadi,Ratnagiri,Maharashtra',
'Bhalavali,Ratnagiri,Maharashtra',
'Bhoo,Ratnagiri,Maharashtra',
'Burambe Wadi,Ratnagiri,Maharashtra',
'Dale,Ratnagiri,Maharashtra',
'Dasur,Ratnagiri,Maharashtra',
'Devache Gothane,Ratnagiri,Maharashtra',
'Devihasol,Ratnagiri,Maharashtra',
'Dhaulwali,Ratnagiri,Maharashtra',
'Dhopeshwar,Ratnagiri,Maharashtra',
'Dongar,Ratnagiri,Maharashtra',
'Donivade,Ratnagiri,Maharashtra',
'Gothane Doniwade,Ratnagiri,Maharashtra',
'Goval,Ratnagiri,Maharashtra',
'Haral,Ratnagiri,Maharashtra',
'Hasol Tarf Saundal,Ratnagiri,Maharashtra',
'Hatade,Ratnagiri,Maharashtra',
'Holi,Ratnagiri,Maharashtra',
'Jaitapur,Ratnagiri,Maharashtra',
'Jawalethar,Ratnagiri,Maharashtra',
'Juwathi,Ratnagiri,Maharashtra',
'Kajirda,Ratnagiri,Maharashtra',
'Kalsavali,Ratnagiri,Maharashtra',
'Karak,Ratnagiri,Maharashtra',
'Karavali,Ratnagiri,Maharashtra',
'Kasheli,Ratnagiri,Maharashtra',
'Katali Sagave,Ratnagiri,Maharashtra',
'Kelavali,Ratnagiri,Maharashtra',
'Kharvate,Ratnagiri,Maharashtra',
'Kodavali,Ratnagiri,Maharashtra',
'Kolamb,Ratnagiri,Maharashtra',
'Kolwan Chuna,Ratnagiri,Maharashtra',
'Kolwan Khadi,Ratnagiri,Maharashtra',
'Kondsur Budruk,Ratnagiri,Maharashtra',
'Kondye,Ratnagiri,Maharashtra',
'Kotapur,Ratnagiri,Maharashtra',
'Kumbhavade,Ratnagiri,Maharashtra',
'Kuveshi,Ratnagiri,Maharashtra',
'Madban,Ratnagiri,Maharashtra',
'Miland,Ratnagiri,Maharashtra',
'Mithgavane,Ratnagiri,Maharashtra',
'Moor,Ratnagiri,Maharashtra',
'Moroshi,Ratnagiri,Maharashtra',
'Mosam,Ratnagiri,Maharashtra',
'Nanar,Ratnagiri,Maharashtra',
'Nata,Ratnagiri,Maharashtra',
'Niveli,Ratnagiri,Maharashtra',
'Oni,Ratnagiri,Maharashtra',
'Oshivale,Ratnagiri,Maharashtra',
'Ozare,Ratnagiri,Maharashtra',
'Pachal,Ratnagiri,Maharashtra',
'Padave,Ratnagiri,Maharashtra',
'Pangare,Ratnagiri,Maharashtra',
'Panhale Tarf Saundal,Ratnagiri,Maharashtra',
'Parule,Ratnagiri,Maharashtra',
'Pendkhale,Ratnagiri,Maharashtra',
'Prindavan,Ratnagiri,Maharashtra',
'Rajapur,Ratnagiri,Maharashtra',
'Rajwadi,Ratnagiri,Maharashtra',
'Raypatan,Ratnagiri,Maharashtra',
'Sagave,Ratnagiri,Maharashtra',
'Sakhar,Ratnagiri,Maharashtra',
'Sasale,Ratnagiri,Maharashtra',
'Saundal,Ratnagiri,Maharashtra',
'Savdav,Ratnagiri,Maharashtra',
'Shivane Budruk,Ratnagiri,Maharashtra',
'Shivane Khurd,Ratnagiri,Maharashtra',
'Solgaon,Ratnagiri,Maharashtra',
'Soliwade,Ratnagiri,Maharashtra',
'Talavade,Ratnagiri,Maharashtra',
'Talgaon,Ratnagiri,Maharashtra',
'Tamhane,Ratnagiri,Maharashtra',
'Taral,Ratnagiri,Maharashtra',
'Tiware,Ratnagiri,Maharashtra',
'Upale,Ratnagiri,Maharashtra',
'Vadad Hasol,Ratnagiri,Maharashtra',
'Vilye,Ratnagiri,Maharashtra',
'Wadavali,Ratnagiri,Maharashtra',
'Walye,Ratnagiri,Maharashtra',
'Watul,Ratnagiri,Maharashtra',
'Yelvan,Ratnagiri,Maharashtra',
'Yerdav,Ratnagiri,Maharashtra',
'Agave,Ratnagiri,Maharashtra',
'Ambed Budruk,Ratnagiri,Maharashtra',
'Basani,Ratnagiri,Maharashtra',
'Bhatye,Ratnagiri,Maharashtra',
'Bhoke,Ratnagiri,Maharashtra',
'Chafe,Ratnagiri,Maharashtra',
'Chandor,Ratnagiri,Maharashtra',
'Charveli,Ratnagiri,Maharashtra',
'Chave,Ratnagiri,Maharashtra',
'Chinchkhari,Ratnagiri,Maharashtra',
'Dande Adom,Ratnagiri,Maharashtra',
'Deud,Ratnagiri,Maharashtra',
'Dhamanse,Ratnagiri,Maharashtra',
'Dorle,Ratnagiri,Maharashtra',
'Ganeshgule,Ratnagiri,Maharashtra',
'Ganpatipule,Ratnagiri,Maharashtra',
'Gavade Ambere,Ratnagiri,Maharashtra',
'Gavkhadi,Ratnagiri,Maharashtra',
'Golap,Ratnagiri,Maharashtra',
'Harcheri,Ratnagiri,Maharashtra',
'Hatkhamba,Ratnagiri,Maharashtra',
'Ibrahimpattan,Ratnagiri,Maharashtra',
'Jaigad,Ratnagiri,Maharashtra',
'Jambhari,Ratnagiri,Maharashtra',
'Kalbadevi,Ratnagiri,Maharashtra',
'Kalzondi,Ratnagiri,Maharashtra',
'Kapad Gaon,Ratnagiri,Maharashtra',
'Karbude,Ratnagiri,Maharashtra',
'Karla,Ratnagiri,Maharashtra',
'Kasarveli,Ratnagiri,Maharashtra',
'Kelye,Ratnagiri,Maharashtra',
'Kespuri,Ratnagiri,Maharashtra',
'Khalgaon,Ratnagiri,Maharashtra',
'Khanu,Ratnagiri,Maharashtra',
'Khedashi,Ratnagiri,Maharashtra',
'Kolambe,Ratnagiri,Maharashtra',
'Kolisare,Ratnagiri,Maharashtra',
'Kondye,Ratnagiri,Maharashtra',
'Kotawada,Ratnagiri,Maharashtra',
'Majgaon,Ratnagiri,Maharashtra',
'Malgund,Ratnagiri,Maharashtra',
'Manjare,Ratnagiri,Maharashtra',
'Mavlange,Ratnagiri,Maharashtra',
'Mervi,Ratnagiri,Maharashtra',
'MIDC (RTG),Ratnagiri,Maharashtra',
'Mirjole,Ratnagiri,Maharashtra',
'Mirya,Ratnagiri,Maharashtra',
'Nachane,Ratnagiri,Maharashtra',
'Nakhare,Ratnagiri,Maharashtra',
'Nanij,Ratnagiri,Maharashtra',
'Nevare,Ratnagiri,Maharashtra',
'Nirul,Ratnagiri,Maharashtra',
'Nivendi,Ratnagiri,Maharashtra',
'Niwali,Ratnagiri,Maharashtra',
'Ori,Ratnagiri,Maharashtra',
'Pali (RTG),Ratnagiri,Maharashtra',
'Panval,Ratnagiri,Maharashtra',
'Pawas,Ratnagiri,Maharashtra',
'Phansavale,Ratnagiri,Maharashtra',
'Phansop,Ratnagiri,Maharashtra',
'Pirandavane,Ratnagiri,Maharashtra',
'Pochari,Ratnagiri,Maharashtra',
'Pomendi Budruk,Ratnagiri,Maharashtra',
'Pomendi Khurd,Ratnagiri,Maharashtra',
'Purnagad,Ratnagiri,Maharashtra',
'Rai,Ratnagiri,Maharashtra',
'Ranpat,Ratnagiri,Maharashtra',
'Ratnagiri Collectorate,Ratnagiri,Maharashtra',
'Ratnagiri H.O,Ratnagiri,Maharashtra',
'Saitavada,Ratnagiri,Maharashtra',
'Sathare Bambar,Ratnagiri,Maharashtra',
'Shirgaon (RTG),Ratnagiri,Maharashtra',
'Shivaji Nagar (RTG),Ratnagiri,Maharashtra',
'Shivar Ambere,Ratnagiri,Maharashtra',
'Someshwar,Ratnagiri,Maharashtra',
'Tarval,Ratnagiri,Maharashtra',
'Tembye,Ratnagiri,Maharashtra',
'Tike,Ratnagiri,Maharashtra',
'Tilak Memorial (RTG),Ratnagiri,Maharashtra',
'Tonade,Ratnagiri,Maharashtra',
'Varawade,Ratnagiri,Maharashtra',
'Velvand,Ratnagiri,Maharashtra',
'Vetoshi,Ratnagiri,Maharashtra',
'Wanke,Ratnagiri,Maharashtra',
'Watad,Ratnagiri,Maharashtra',
'Zare Wadi,Ratnagiri,Maharashtra',
'Ambav,Ratnagiri,Maharashtra',
'Ambav,Ratnagiri,Maharashtra',
'Ambavali,Ratnagiri,Maharashtra',
'Angavali,Ratnagiri,Maharashtra',
'Antravali,Ratnagiri,Maharashtra',
'Aravali,Ratnagiri,Maharashtra',
'Bamnoli,Ratnagiri,Maharashtra',
'Belari Budruk,Ratnagiri,Maharashtra',
'Bhadkamba,Ratnagiri,Maharashtra',
'Chafavali,Ratnagiri,Maharashtra',
'Chikhali,Ratnagiri,Maharashtra',
'Choravane,Ratnagiri,Maharashtra',
'Dabhole,Ratnagiri,Maharashtra',
'Deole Ghera Prachitgad,Ratnagiri,Maharashtra',
'Devade,Ratnagiri,Maharashtra',
'Devale,Ratnagiri,Maharashtra',
'Devrukh,Ratnagiri,Maharashtra',
'Dhamani,Ratnagiri,Maharashtra',
'Dhamapur,Ratnagiri,Maharashtra',
'Dingni,Ratnagiri,Maharashtra',
'Fungus,Ratnagiri,Maharashtra',
'Ghativale,Ratnagiri,Maharashtra',
'Golavali,Ratnagiri,Maharashtra',
'Harpude,Ratnagiri,Maharashtra',
'Hativ,Ratnagiri,Maharashtra',
'Kadwai,Ratnagiri,Maharashtra',
'Kalambaste,Ratnagiri,Maharashtra',
'Kalambushi,Ratnagiri,Maharashtra',
'Kankadi,Ratnagiri,Maharashtra',
'Karambele Tarf Devale,Ratnagiri,Maharashtra',
'Karbhatale,Ratnagiri,Maharashtra',
'Karjuve,Ratnagiri,Maharashtra',
'Karli,Ratnagiri,Maharashtra',
'Kasar Kolwan,Ratnagiri,Maharashtra',
'Kasba,Ratnagiri,Maharashtra',
'Kase,Ratnagiri,Maharashtra',
'Katavali,Ratnagiri,Maharashtra',
'Kirbet,Ratnagiri,Maharashtra',
'Kirduve,Ratnagiri,Maharashtra',
'Kolambe(S),Ratnagiri,Maharashtra',
'Kondivare,Ratnagiri,Maharashtra',
'Kosumb,Ratnagiri,Maharashtra',
'Kumbharkhani,Ratnagiri,Maharashtra',
'Kundi,Ratnagiri,Maharashtra',
'Kurdhunda,Ratnagiri,Maharashtra',
'Lowale,Ratnagiri,Maharashtra',
'Mabhale,Ratnagiri,Maharashtra',
'Makhajan,Ratnagiri,Maharashtra',
'Maral,Ratnagiri,Maharashtra',
'Masrang,Ratnagiri,Maharashtra',
'Meghi,Ratnagiri,Maharashtra',
'Morde,Ratnagiri,Maharashtra',
'Muchari,Ratnagiri,Maharashtra',
'Murdav,Ratnagiri,Maharashtra',
'Murshi,Ratnagiri,Maharashtra',
'Narduve,Ratnagiri,Maharashtra',
'Nayari,Ratnagiri,Maharashtra',
'Nive Budruk,Ratnagiri,Maharashtra',
'Ozare Budruk,Ratnagiri,Maharashtra',
'Ozare Khurd,Ratnagiri,Maharashtra',
'Pachambe,Ratnagiri,Maharashtra',
'Pangari,Ratnagiri,Maharashtra',
'Parchuri,Ratnagiri,Maharashtra',
'Patgaon,Ratnagiri,Maharashtra',
'Phansavane,Ratnagiri,Maharashtra',
'Pirandavane,Ratnagiri,Maharashtra',
'Rajivili,Ratnagiri,Maharashtra',
'Rajwadi,Ratnagiri,Maharashtra',
'Sadavali,Ratnagiri,Maharashtra',
'Sakharpa,Ratnagiri,Maharashtra',
'Sangave,Ratnagiri,Maharashtra',
'Sangmeshwar,Ratnagiri,Maharashtra',
'Sayale,Ratnagiri,Maharashtra',
'Shirambe,Ratnagiri,Maharashtra',
'Shringarpur,Ratnagiri,Maharashtra',
'Sonavade,Ratnagiri,Maharashtra',
'Talekante,Ratnagiri,Maharashtra',
'Tambedi,Ratnagiri,Maharashtra',
'Tamhane,Ratnagiri,Maharashtra',
'Terye,Ratnagiri,Maharashtra',
'Tiware Ghera Prachitgad,Ratnagiri,Maharashtra',
'Tulsani,Ratnagiri,Maharashtra',
'Tural,Ratnagiri,Maharashtra',
'Ujgaon,Ratnagiri,Maharashtra',
'Ukshi,Ratnagiri,Maharashtra',
'Umare,Ratnagiri,Maharashtra',
'Vandri,Ratnagiri,Maharashtra',
'Vanzole,Ratnagiri,Maharashtra',
'Waingane,Ratnagiri,Maharashtra',
'Washi Tarf Devrukh,Ratnagiri,Maharashtra',
'Washi Tarf Sangmeshwar,Ratnagiri,Maharashtra',
'Ghodavali,Ratnagiri,Maharashtra',
'Shembavane,Ratnagiri,Maharashtra',
'Burambad,Ratnagiri,Maharashtra',
'Atpadi,Sangli,Maharashtra',
'Awalai,Sangli,Maharashtra',
'Banpuri,Sangli,Maharashtra',
'Dighanchi,Sangli,Maharashtra',
'Ghanand,Sangli,Maharashtra',
'Gharniki,Sangli,Maharashtra',
'Gomewadi,Sangli,Maharashtra',
'Hivtad,Sangli,Maharashtra',
'Kargani,Sangli,Maharashtra',
'Kautholi,Sangli,Maharashtra',
'Kharsundi,Sangli,Maharashtra',
'Lingiware,Sangli,Maharashtra',
'Madgule,Sangli,Maharashtra',
'Nelkaranji,Sangli,Maharashtra',
'Nimbavade,Sangli,Maharashtra',
'Pimpri Budruk,Sangli,Maharashtra',
'Shetphale,Sangli,Maharashtra',
'Tadawale,Sangli,Maharashtra',
'Valvan,Sangli,Maharashtra',
'Vibhutwadi,Sangli,Maharashtra',
'Zare,Sangli,Maharashtra',
'Ankalagi,Sangli,Maharashtra',
'Ankale,Sangli,Maharashtra',
'Antral,Sangli,Maharashtra',
'Asangi J,Sangli,Maharashtra',
'Asangi K,Sangli,Maharashtra',
'Baj,Sangli,Maharashtra',
'Balgaon,Sangli,Maharashtra',
'Belondgi,Sangli,Maharashtra',
'Boblad K,Sangli,Maharashtra',
'Borgi(Khurd),Sangli,Maharashtra',
'Daribadachi,Sangli,Maharashtra',
'Dorli,Sangli,Maharashtra',
'Girgaon,Sangli,Maharashtra',
'Jadar Bobalad,Sangli,Maharashtra',
'Jirgyal,Sangli,Maharashtra',
'Khalati,Sangli,Maharashtra',
'Madgyal,Sangli,Maharashtra',
'Sankh,Sangli,Maharashtra',
'Sidhnath,Sangli,Maharashtra',
'Sonyal,Sangli,Maharashtra',
'Sordi,Sangli,Maharashtra',
'Suslad,Sangli,Maharashtra',
'Tikundi,Sangli,Maharashtra',
'Utagi,Sangli,Maharashtra',
'Vhaspet,Sangli,Maharashtra',
'Washan,Sangli,Maharashtra',
'Avandhi,Sangli,Maharashtra',
'Banali,Sangli,Maharashtra',
'Basargi,Sangli,Maharashtra',
'Bevnur,Sangli,Maharashtra',
'Daphalapur,Sangli,Maharashtra',
'Gugwad,Sangli,Maharashtra',
'Jath,Sangli,Maharashtra',
'Kunikonnur,Sangli,Maharashtra',
'Mendhigiri,Sangli,Maharashtra',
'Muchandi,Sangli,Maharashtra',
'Nigdi Khurd,Sangli,Maharashtra',
'Revnal,Sangli,Maharashtra',
'Sanmadi,Sangli,Maharashtra',
'Shegaon,Sangli,Maharashtra',
'Shinganapur,Sangli,Maharashtra',
'Shinganhalli,Sangli,Maharashtra',
'Sindur,Sangli,Maharashtra',
'Umadi,Sangli,Maharashtra',
'Umarani,Sangli,Maharashtra',
'Vajrawad,Sangli,Maharashtra',
'Valsang,Sangli,Maharashtra',
'Walekhindi,Sangli,Maharashtra',
'Yelvi,Sangli,Maharashtra',
'Agran Dhulgaon,Sangli,Maharashtra',
'Alkud (S),Sangli,Maharashtra',
'Jakhapur,Sangli,Maharashtra',
'Karoli T,Sangli,Maharashtra',
'Kokale,Sangli,Maharashtra',
'Kundalapur,Sangli,Maharashtra',
'Langarpeth,Sangli,Maharashtra',
'Lonarwadi,Sangli,Maharashtra',
'Nangole,Sangli,Maharashtra',
'Tisangi,Sangli,Maharashtra',
'Kuchi,Sangli,Maharashtra',
'Dhalewadi,Sangli,Maharashtra',
'Ghatnandre,Sangli,Maharashtra',
'Hingangaon,Sangli,Maharashtra',
'Irali,Sangli,Maharashtra',
'Amarapur,Sangli,Maharashtra',
'Ambak,Sangli,Maharashtra',
'Belavade,Sangli,Maharashtra',
'Chinchani Ambak,Sangli,Maharashtra',
'Hanmant Vadiye,Sangli,Maharashtra',
'Hingangaon,Sangli,Maharashtra',
'Hingangaon Khurd,Sangli,Maharashtra',
'Kadegaon,Sangli,Maharashtra',
'Kadepur,Sangli,Maharashtra',
'Khambale,Sangli,Maharashtra',
'Kherade,Sangli,Maharashtra',
'Nagewadi,Sangli,Maharashtra',
'Nerli,Sangli,Maharashtra',
'Nevari,Sangli,Maharashtra',
'Ramapur,Sangli,Maharashtra',
'Saholi,Sangli,Maharashtra',
'Shalgaon,Sangli,Maharashtra',
'Shelakbav,Sangli,Maharashtra',
'Shirasgaon,Sangli,Maharashtra',
'Shivajinagar,Sangli,Maharashtra',
'Shivani,Sangli,Maharashtra',
'Sonkire,Sangli,Maharashtra',
'Tadsar,Sangli,Maharashtra',
'Tondoli,Sangli,Maharashtra',
'Upale Mayani,Sangli,Maharashtra',
'Vadgaon Mohite,Sangli,Maharashtra',
'Vadiye Raibag,Sangli,Maharashtra',
'Vangi,Sangli,Maharashtra',
'Vihapur,Sangli,Maharashtra',
'Yetgaon,Sangli,Maharashtra',
'Hingangade,Sangli,Maharashtra',
'Palashi,Sangli,Maharashtra',
'Karve,Sangli,Maharashtra',
'Agalgaon,Sangli,Maharashtra',
'Alkud (M),Sangli,Maharashtra',
'Arewadi,Sangli,Maharashtra',
'Banewadi,Sangli,Maharashtra',
'Borgaon,Sangli,Maharashtra',
'Chorochi,Sangli,Maharashtra',
'Deshing,Sangli,Maharashtra',
'Dhalgaon,Sangli,Maharashtra',
'Dhavadwadi,Sangli,Maharashtra',
'Jaigavan,Sangli,Maharashtra',
'Kavathe Mahankal,Sangli,Maharashtra',
'Khrashing,Sangli,Maharashtra',
'Kognoli,Sangli,Maharashtra',
'Kosari,Sangli,Maharashtra',
'Kuktoli,Sangli,Maharashtra',
'Kumbhari,Sangli,Maharashtra',
'Landgewadi,Sangli,Maharashtra',
'Malangaon,Sangli,Maharashtra',
'Nagaj,Sangli,Maharashtra',
'Ranjani,Sangli,Maharashtra',
'Ghorpadi,Sangli,Maharashtra',
'Kerewadi,Sangli,Maharashtra',
'Shirdhon,Sangli,Maharashtra',
'Ainwadi,Sangli,Maharashtra',
'Alsund,Sangli,Maharashtra',
'Bamani,Sangli,Maharashtra',
'Belavade (KHN),Sangli,Maharashtra',
'Bhalavani,Sangli,Maharashtra',
'Bhendavade,Sangli,Maharashtra',
'Bhikavadi BK,Sangli,Maharashtra',
'Bhikawadi Kurd,Sangli,Maharashtra',
'Bhood,Sangli,Maharashtra',
'Chinchani Mangrul,Sangli,Maharashtra',
'Devikhindi,Sangli,Maharashtra',
'Dhavaleshwar,Sangli,Maharashtra',
'Gardi,Sangli,Maharashtra',
'Ghoti Khurd,Sangli,Maharashtra',
'Hivare,Sangli,Maharashtra',
'Jadhavwadi,Sangli,Maharashtra',
'Jondhalkhindi,Sangli,Maharashtra',
'Karanje,Sangli,Maharashtra',
'Khanapur,Sangli,Maharashtra',
'Lengare,Sangli,Maharashtra',
'Mahuli,Sangli,Maharashtra',
'Mohi,Sangli,Maharashtra',
'Pare,Sangli,Maharashtra',
'Renavi,Sangli,Maharashtra',
'Revangaon,Sangli,Maharashtra',
'Salshinge,Sangli,Maharashtra',
'Sultangade,Sangli,Maharashtra',
'Valkhad,Sangli,Maharashtra',
'Valuj,Sangli,Maharashtra',
'Vasumbe,Sangli,Maharashtra',
'Vejegaon,Sangli,Maharashtra',
'Vite City,Sangli,Maharashtra',
'Vite,Sangli,Maharashtra',
'Chikhalhol,Sangli,Maharashtra',
'Ankali,Sangli,Maharashtra',
'Arag,Sangli,Maharashtra',
'Bamnoli,Sangli,Maharashtra',
'Bedagedso,Sangli,Maharashtra',
'Belanki,Sangli,Maharashtra',
'Bhose,Sangli,Maharashtra',
'Billur,Sangli,Maharashtra',
'Bisur,Sangli,Maharashtra',
'Bolwad,Sangli,Maharashtra',
'Brahmanpuri Miraj,Sangli,Maharashtra',
'Budhgaon,Sangli,Maharashtra',
'Dhavali,Sangli,Maharashtra',
'Digraj Kasaba Agri School,Sangli,Maharashtra',
'Digraj Kasaba,Sangli,Maharashtra',
'Dongarwadi,Sangli,Maharashtra',
'Dudhgaon,Sangli,Maharashtra',
'Factory Area Sangli,Sangli,Maharashtra',
'Gajanan Mills Sangli,Sangli,Maharashtra',
'Ganpati Peth Sangli,Sangli,Maharashtra',
'Govt.Medical College Miraj,Sangli,Maharashtra',
'Gundewadi,Sangli,Maharashtra',
'Haripur,Sangli,Maharashtra',
'Inam Dhamni,Sangli,Maharashtra',
'Kalambi,Sangli,Maharashtra',
'Kanchanpur,Sangli,Maharashtra',
'Karnal,Sangli,Maharashtra',
'Karoli (M),Sangli,Maharashtra',
'Kavaji Khotwadi,Sangli,Maharashtra',
'Kavalapur,Sangli,Maharashtra',
'Kavathe Piran,Sangli,Maharashtra',
'Khanbhag,sangli At Midc Miraj,Sangli,Maharashtra',
'Khanderajuri,Sangli,Maharashtra',
'Khatav,Sangli,Maharashtra',
'Kupwad MIDC Area,Sangli,Maharashtra',
'Kupwad,Sangli,Maharashtra',
'Lingnoor,Sangli,Maharashtra',
'Madhavnagar,Sangli,Maharashtra',
'Malgaon,Sangli,Maharashtra',
'Mallewadi,Sangli,Maharashtra',
'Malwadi,Sangli,Maharashtra',
'Mangalwar Peth Miraj,Sangli,Maharashtra',
'Manjarde,Sangli,Maharashtra',
'Market Yard Sangli,Sangli,Maharashtra',
'Mhaisal,Sangli,Maharashtra',
'Miraj Audyogik Vasahat,Sangli,Maharashtra',
'Miraj H.O,Sangli,Maharashtra',
'Miraj Station Road,Sangli,Maharashtra',
'Mouje Digraj,Sangli,Maharashtra',
'Nandre,Sangli,Maharashtra',
'Narwad,Sangli,Maharashtra',
'Padmale,Sangli,Maharashtra',
'Payappachiwadi,Sangli,Maharashtra',
'Ped,Sangli,Maharashtra',
'R K Extension Sangli,Sangli,Maharashtra',
'S S K Sangli,Sangli,Maharashtra',
'Salgare,Sangli,Maharashtra',
'Samdolii,Sangli,Maharashtra',
'Sangalwadi,Sangli,Maharashtra',
'Sangli City,Sangli,Maharashtra',
'Sangli H.O,Sangli,Maharashtra',
'Shaniwar Peth Miraj,Sangli,Maharashtra',
'Shindewadi,Sangli,Maharashtra',
'Shipur,Sangli,Maharashtra',
'Siddhewadi,Sangli,Maharashtra',
'Soni,Sangli,Maharashtra',
'Subhashnagar,Sangli,Maharashtra',
'Tanang,Sangli,Maharashtra',
'Tung,Sangli,Maharashtra',
'Vaddi,Sangli,Maharashtra',
'Vasgade,Sangli,Maharashtra',
'Wanlsswadi,Sangli,Maharashtra',
'Willingdon College Sangli,Sangli,Maharashtra',
'Yerandoli,Sangli,Maharashtra',
'Amanapur,Sangli,Maharashtra',
'Andhali,Sangli,Maharashtra',
'Ankalkhop,Sangli,Maharashtra',
'Bambavade,Sangli,Maharashtra',
'Bhilavadi,Sangli,Maharashtra',
'Bhilwadi R.S.,Sangli,Maharashtra',
'Brahmanal,Sangli,Maharashtra',
'Burli,Sangli,Maharashtra',
'Devrashtra,Sangli,Maharashtra',
'Dudhondi,Sangli,Maharashtra',
'Ghogaon,Sangli,Maharashtra',
'Kirloskarwadi,Sangli,Maharashtra',
'Kundal,Sangli,Maharashtra',
'Morale,Sangli,Maharashtra',
'Nagarale,Sangli,Maharashtra',
'Palus,Sangli,Maharashtra',
'Punadi T/F Walwa,Sangli,Maharashtra',
'Ramanandnagar,Sangli,Maharashtra',
'Sawantpur,Sangli,Maharashtra',
'Tavadarwadi,Sangli,Maharashtra',
'Kalundre,Sangli,Maharashtra',
'Antri Budruk,Sangli,Maharashtra',
'Arala,Sangli,Maharashtra',
'Aundhi,Sangli,Maharashtra',
'Bambavade,Sangli,Maharashtra',
'Bhatshirgaon,Sangli,Maharashtra',
'Bilashi,Sangli,Maharashtra',
'Biur,Sangli,Maharashtra',
'Charan,Sangli,Maharashtra',
'Chikhali,Sangli,Maharashtra',
'Chikurde,Sangli,Maharashtra',
'Chincholi,Sangli,Maharashtra',
'Devwadi,Sangli,Maharashtra',
'Dhamavade,Sangli,Maharashtra',
'Ingrul,Sangli,Maharashtra',
'Kande,Sangli,Maharashtra',
'Kandur,Sangli,Maharashtra',
'Karanguli,Sangli,Maharashtra',
'Karmale,Sangli,Maharashtra',
'Khujgaon,Sangli,Maharashtra',
'Kokarud,Sangli,Maharashtra',
'Mangale,Sangli,Maharashtra',
'Mangrul,Sangli,Maharashtra',
'Meni,Sangli,Maharashtra',
'Nathawade,Sangli,Maharashtra',
'Natoli,Sangli,Maharashtra',
'Nigadi,Sangli,Maharashtra',
'Pachumbri,Sangli,Maharashtra',
'Padalichiwadi,Sangli,Maharashtra',
'Panumbre Turf Shirala,Sangli,Maharashtra',
'Panumbre Turf Warun,Sangli,Maharashtra',
'Phuphire,Sangli,Maharashtra',
'Punvat,Sangli,Maharashtra',
'Red,Sangli,Maharashtra',
'Rile,Sangli,Maharashtra',
'Sagaon,Sangli,Maharashtra',
'Shirala,Sangli,Maharashtra',
'Shirashi,Sangli,Maharashtra',
'Sonavade,Sangli,Maharashtra',
'Tadavale,Sangli,Maharashtra',
'Takave,Sangli,Maharashtra',
'Ukhalu,Sangli,Maharashtra',
'Wakurde BK,Sangli,Maharashtra',
'Wakurde Khurd,Sangli,Maharashtra',
'Warnavati Vasahat,Sangli,Maharashtra',
'Wategaon,Sangli,Maharashtra',
'Yelapur,Sangli,Maharashtra',
'Anjani,Sangli,Maharashtra',
'Arawade,Sangli,Maharashtra',
'Audumbar,Sangli,Maharashtra',
'Balagavade,Sangli,Maharashtra',
'Balavadi(Bhalavani),Sangli,Maharashtra',
'Banur,Sangli,Maharashtra',
'Bastawade,Sangli,Maharashtra',
'Bendri,Sangli,Maharashtra',
'Biranwadi,Sangli,Maharashtra',
'Borgaon (T),Sangli,Maharashtra',
'Chinchani (T),Sangli,Maharashtra',
'Dahiwadi,Sangli,Maharashtra',
'Dhavali (T),Sangli,Maharashtra',
'Dhulgaon,Sangli,Maharashtra',
'Dongarsoni,Sangli,Maharashtra',
'Gaurgaon,Sangli,Maharashtra',
'Gavan,Sangli,Maharashtra',
'Guruwar Peth,tasgaon,Sangli,Maharashtra',
'Hatnoli,Sangli,Maharashtra',
'Hatnur,Sangli,Maharashtra',
'Jarandi,Sangli,Maharashtra',
'Kavathe Ekand,Sangli,Maharashtra',
'Khujgaon,Sangli,Maharashtra',
'Kumatha,Sangli,Maharashtra',
'Limb,Sangli,Maharashtra',
'Lode,Sangli,Maharashtra',
'Manerajuri,Sangli,Maharashtra',
'Nimani,Sangli,Maharashtra',
'Nimblak,Sangli,Maharashtra',
'Padali,Sangli,Maharashtra',
'Punadi (T),Sangli,Maharashtra',
'Rajapur,Sangli,Maharashtra',
'Savarde,Sangli,Maharashtra',
'Savlaj,Sangli,Maharashtra',
'Siddhewadi Savalaj,Sangli,Maharashtra',
'Tasgaon M.D.G,Sangli,Maharashtra',
'Turchi,Sangli,Maharashtra',
'Upalavi,Sangli,Maharashtra',
'Vadgaon,Sangli,Maharashtra',
'Vasumbe (T),Sangli,Maharashtra',
'Visapur,Sangli,Maharashtra',
'Waiphale,Sangli,Maharashtra',
'Yamgarwadi,Sangli,Maharashtra',
'Yelavi,Sangli,Maharashtra',
'Aitawade BK,Sangli,Maharashtra',
'Ashte,Sangli,Maharashtra',
'Bagani,Sangli,Maharashtra',
'Bhavaninagar,Sangli,Maharashtra',
'Borgaon,Sangli,Maharashtra',
'Kameri,Sangli,Maharashtra',
'Kasegaon,Sangli,Maharashtra',
'Kurlap,Sangli,Maharashtra',
'Nerla,Sangli,Maharashtra',
'Peth,Sangli,Maharashtra',
'S S K Sakharale,Sangli,Maharashtra',
'Takari,Sangli,Maharashtra',
'Urun Islampur,Sangli,Maharashtra',
'Walwa,Sangli,Maharashtra',
'Yelur,Sangli,Maharashtra',
'Aitawade Khurd,Sangli,Maharashtra',
'Bahadurwadi,Sangli,Maharashtra',
'Bahe,Sangli,Maharashtra',
'Bavachi,Sangli,Maharashtra',
'Bhadkimbe,Sangli,Maharashtra',
'Bichud,Sangli,Maharashtra',
'Dhagewadi,Sangli,Maharashtra',
'Dhavali,Sangli,Maharashtra',
'Gotkhindi,Sangli,Maharashtra',
'Itkare,Sangli,Maharashtra',
'Junekhed,Sangli,Maharashtra',
'Kalamwadi,Sangli,Maharashtra',
'Kanegaon,Sangli,Maharashtra',
'Kapuskhed,Sangli,Maharashtra',
'Karandwadi,Sangli,Maharashtra',
'Karanjawade,Sangli,Maharashtra',
'Karve,Sangli,Maharashtra',
'Killemachindragad,Sangli,Maharashtra',
'Koregaon,Sangli,Maharashtra',
'Kundalwadi,Sangli,Maharashtra',
'Ladegaon,Sangli,Maharashtra',
'Manikwadi,Sangli,Maharashtra',
'Mardwadi,Sangli,Maharashtra',
'Masuchiwadi,Sangli,Maharashtra',
'Mirajwadi,Sangli,Maharashtra',
'Nagaon,Sangli,Maharashtra',
'Nagthane,Sangli,Maharashtra',
'Narsinhpur,Sangli,Maharashtra',
'Ozarde,Sangli,Maharashtra',
'Pokharni,Sangli,Maharashtra',
'Rethare Dharan,Sangli,Maharashtra',
'Rethare Harnaksha,Sangli,Maharashtra',
'Sakharale,Sangli,Maharashtra',
'Shigaon,Sangli,Maharashtra',
'Shirte,Sangli,Maharashtra',
'Surul,Sangli,Maharashtra',
'Tambave,Sangli,Maharashtra',
'Tandulwadi,Sangli,Maharashtra',
'Thanapude,Sangli,Maharashtra',
'Tujarpur,Sangli,Maharashtra',
'Tupari,Sangli,Maharashtra',
'Yedemachindra,Sangli,Maharashtra',
'Yedenipani,Sangli,Maharashtra',
'Shindi,Ratnagiri,Maharashtra',
'Ahir,Satara,Maharashtra',
'Alewadi,Satara,Maharashtra',
'Anewadi,Satara,Maharashtra',
'Apati,Satara,Maharashtra',
'Asani,Satara,Maharashtra',
'Bamanoli,Satara,Maharashtra',
'Bamnoli Tarf Kudal,Satara,Maharashtra',
'Bhanang,Satara,Maharashtra',
'Bhiwadi,Satara,Maharashtra',
'Bibhavi,Satara,Maharashtra',
'Dapavadi,Satara,Maharashtra',
'Dare Khurd,Satara,Maharashtra',
'Dund,Satara,Maharashtra',
'Ganje,Satara,Maharashtra',
'Gavadi,Satara,Maharashtra',
'Gavdoshi,Satara,Maharashtra',
'Gogave,Satara,Maharashtra',
'Harchandi,Satara,Maharashtra',
'Hateghar,Satara,Maharashtra',
'Humgaon,Satara,Maharashtra',
'Karandi (Kudal),Satara,Maharashtra',
'Kedambe,Satara,Maharashtra',
'Kelaghar,Satara,Maharashtra',
'Kharshi,Satara,Maharashtra',
'Kharshi,Satara,Maharashtra',
'Kuroshi,Satara,Maharashtra',
'Kusumbi,Satara,Maharashtra',
'Mahasave,Satara,Maharashtra',
'Mahathe BK,Satara,Maharashtra',
'Mahigaon,Satara,Maharashtra',
'Mamuradi,Satara,Maharashtra',
'Medha,Satara,Maharashtra',
'Mohat.,Satara,Maharashtra',
'Morawale,Satara,Maharashtra',
'Morghar,Satara,Maharashtra',
'Raigaon,Satara,Maharashtra',
'Ranjani,Satara,Maharashtra',
'Saigaon,Satara,Maharashtra',
'Sanpane,Satara,Maharashtra',
'Saratale,Satara,Maharashtra',
'Sarjapur,Satara,Maharashtra',
'Somardi,Satara,Maharashtra',
'Sonat,Satara,Maharashtra',
'Songaon,Satara,Maharashtra',
'Tetali,Satara,Maharashtra',
'Uchat,Ratnagiri,Maharashtra',
'Valuth,Satara,Maharashtra',
'Varoshi,Satara,Maharashtra',
'Kudal,Satara,Maharashtra',
'Padali (Lonand),Satara,Maharashtra',
'Pimpre BK,Satara,Maharashtra',
'Nidhal,Satara,Maharashtra',
'Kanheri,Satara,Maharashtra',
'Bawada,Satara,Maharashtra',
'Agashivnagar,Satara,Maharashtra',
'Ambrag,Satara,Maharashtra',
'Antavadi,Satara,Maharashtra',
'Arewadi,Satara,Maharashtra',
'Atake,Satara,Maharashtra',
'Banawadi Colony,Satara,Maharashtra',
'Beladare,Satara,Maharashtra',
'Belawade BK,Satara,Maharashtra',
'Belawade Hawali,Satara,Maharashtra',
'Charegaon,Satara,Maharashtra',
'Chchegaon,Satara,Maharashtra',
'Chikhali(Masur),Satara,Maharashtra',
'Chore,Satara,Maharashtra',
'Dhondewadi,Satara,Maharashtra',
'Gamewadi,Satara,Maharashtra',
'Gharewadi,Satara,Maharashtra',
'Ghogaon,Satara,Maharashtra',
'Govare,Satara,Maharashtra',
'Hajarmachi,Satara,Maharashtra',
'Helagaon,Satara,Maharashtra',
'Indoli,Satara,Maharashtra',
'Jinti (Ond),Satara,Maharashtra',
'K0rti,Satara,Maharashtra',
'Kalagaon(Umbraj),Satara,Maharashtra',
'Kalawade,Satara,Maharashtra',
'Kale,Satara,Maharashtra',
'Kapil Goleshwar,Satara,Maharashtra',
'Karad H.O,Satara,Maharashtra',
'Karadcity,Satara,Maharashtra',
'Karavadi,Satara,Maharashtra',
'Karve,Satara,Maharashtra',
'Kasarshirambe,Satara,Maharashtra',
'Kasur,Satara,Maharashtra',
'Kavathe.,Satara,Maharashtra',
'Khodoshi,Satara,Maharashtra',
'Khubi,Satara,Maharashtra',
'Kival,Satara,Maharashtra',
'Kodoli(Karad),Satara,Maharashtra',
'Kole,Satara,Maharashtra',
'Kolewadi,Satara,Maharashtra',
'Konegaon,Satara,Maharashtra',
'Koprde Hawali,Satara,Maharashtra',
'Korivale,Satara,Maharashtra',
'Malakapur Karad,Satara,Maharashtra',
'Mangalwar Peth Karad,Satara,Maharashtra',
'Marali(Chore),Satara,Maharashtra',
'Market Yard Karad,Satara,Maharashtra',
'Masur,Satara,Maharashtra',
'Mhaopre,Satara,Maharashtra',
'Mhasoli,Satara,Maharashtra',
'Mundhe,Satara,Maharashtra',
'Nandalapur,Satara,Maharashtra',
'Nandgaon (Ond),Satara,Maharashtra',
'Narayanwadi,Satara,Maharashtra',
'Nigadi Masur,Satara,Maharashtra',
'Ogalewadi,Satara,Maharashtra',
'Ond,Satara,Maharashtra',
'Padali Masur,Satara,Maharashtra',
'Pal,Satara,Maharashtra',
'Parle,Satara,Maharashtra',
'Perale,Satara,Maharashtra',
'Potale,Satara,Maharashtra',
'Rethare BK,Satara,Maharashtra',
'Rethare KH,Satara,Maharashtra',
'Riswad,Satara,Maharashtra',
'Saidapur,Satara,Maharashtra',
'Sajur,Satara,Maharashtra',
'Sakurdi,Satara,Maharashtra',
'Salshirambe,Satara,Maharashtra',
'Savade,Satara,Maharashtra',
'Shamgaon,Satara,Maharashtra',
'Shapur,Satara,Maharashtra',
'Shere,Satara,Maharashtra',
'Shirawade,Satara,Maharashtra',
'Shirgaon(Umbraj),Satara,Maharashtra',
'Shivanagar,Satara,Maharashtra',
'Shnoli,Satara,Maharashtra',
'Supane,Satara,Maharashtra',
'Suruli,Satara,Maharashtra',
'Tambave,Satara,Maharashtra',
'Tarukha,Satara,Maharashtra',
'Tembu,Satara,Maharashtra',
'Thomase,Satara,Maharashtra',
'Tilak Path Karad,Satara,Maharashtra',
'Tulsan,Satara,Maharashtra',
'Umbraj,Satara,Maharashtra',
'Undale,Satara,Maharashtra',
'Vadagaon,Satara,Maharashtra',
'Vadagaon Haweli,Satara,Maharashtra',
'Vadoli Bhikeshwar,Satara,Maharashtra',
'Vadoli Nileshwar,Satara,Maharashtra',
'Vahagaon,Satara,Maharashtra',
'Varungji,Satara,Maharashtra',
'Vasantgad,Satara,Maharashtra',
'Vathar KH,Satara,Maharashtra',
'Vidyanagar Karad,Satara,Maharashtra',
'Viravade,Satara,Maharashtra',
'Wagheri,Satara,Maharashtra',
'Wing,Satara,Maharashtra',
'Yashwantnagar,Satara,Maharashtra',
'Yelagaon,Satara,Maharashtra',
'Yenape,Satara,Maharashtra',
'Yenke,Satara,Maharashtra',
'Yeoti,Satara,Maharashtra',
'Yeravale,Satara,Maharashtra',
'Talbid,Satara,Maharashtra',
'Bhatghar,Pune City Moffusil,Maharashtra',
'Javale,Satara,Maharashtra',
'Khandala Bavada,Satara,Maharashtra',
'Naigaon,Satara,Maharashtra',
'Palshi,Satara,Maharashtra',
'Shindewadi,Satara,Maharashtra',
'Shirwal,Satara,Maharashtra',
'Wing (Shirwal),Satara,Maharashtra',
'Lonand,Satara,Maharashtra',
'Andori,Satara,Maharashtra',
'Bhade,Satara,Maharashtra',
'Dhawad Wadi,Satara,Maharashtra',
'Khed BK,Satara,Maharashtra',
'Koparde (Lonand),Satara,Maharashtra',
'Loni,Satara,Maharashtra',
'Mariechi Wadi,Satara,Maharashtra',
'Morve,Satara,Maharashtra',
'Shivajinagar,Satara,Maharashtra',
'Vathar BK,Satara,Maharashtra',
'Ahire,Satara,Maharashtra',
'Bholi,Satara,Maharashtra',
'Loham,Satara,Maharashtra',
'Asawali,Satara,Maharashtra',
'Atit,Satara,Maharashtra',
'Karnawadi,Satara,Maharashtra',
'Ambawade,Satara,Maharashtra',
'Ambheri,Satara,Maharashtra',
'Aundh,Satara,Maharashtra',
'Banpuri,Satara,Maharashtra',
'Bhosare,Satara,Maharashtra',
'Bhurkawadi,Satara,Maharashtra',
'Bombale,Satara,Maharashtra',
'Budh,Satara,Maharashtra',
'Chitali,Satara,Maharashtra',
'Chorade,Satara,Maharashtra',
'Daruj,Satara,Maharashtra',
'Dharpudi,Satara,Maharashtra',
'Dhondewadi (K. Khatav),Satara,Maharashtra',
'Diskal Mol,Satara,Maharashtra',
'Gopuj,Satara,Maharashtra',
'Goregaon Vangi,Satara,Maharashtra',
'Gurusale,Satara,Maharashtra',
'Holichagaon,Satara,Maharashtra',
'Jaigaon,Satara,Maharashtra',
'Jakhangaon,Satara,Maharashtra',
'Jamb(Khatav),Satara,Maharashtra',
'Kalambi,Satara,Maharashtra',
'Kaledhon,Satara,Maharashtra',
'Katarkhatav,Satara,Maharashtra',
'Katgun,Satara,Maharashtra',
'Khatagun,Satara,Maharashtra',
'Khatav,Satara,Maharashtra',
'Kokarale,Satara,Maharashtra',
'Kulakjai,Satara,Maharashtra',
'Kumathe Nagache,Satara,Maharashtra',
'Kuroli Sidheshwar,Satara,Maharashtra',
'Ladegaon,Satara,Maharashtra',
'Lalgun,Satara,Maharashtra',
'Loni,Satara,Maharashtra',
'Mandave,Satara,Maharashtra',
'Mayani,Satara,Maharashtra',
'Mhasurne,Satara,Maharashtra',
'Mol (Diskal),Satara,Maharashtra',
'Morale,Satara,Maharashtra',
'Nandoshi,Satara,Maharashtra',
'Ner,Satara,Maharashtra',
'Nimsode,Satara,Maharashtra',
'Padal,Satara,Maharashtra',
'Padegaon,Satara,Maharashtra',
'Palasgaon,Satara,Maharashtra',
'Palashi,Satara,Maharashtra',
'Panchwad,Satara,Maharashtra',
'Pimpari (K.Khatav),Satara,Maharashtra',
'Pusegaon,Satara,Maharashtra',
'Pusesawali,Satara,Maharashtra',
'Rajachekurale,Satara,Maharashtra',
'Rajapuri(Budh),Satara,Maharashtra',
'Ranashingwadi,Satara,Maharashtra',
'Senawadi,Satara,Maharashtra',
'Shinde Khurd,Satara,Maharashtra',
'Shirsurwadi,Satara,Maharashtra',
'Shri Palwan,Satara,Maharashtra',
'Tadavale(Vaduj),Satara,Maharashtra',
'Trimali,Satara,Maharashtra',
'Vadgaon J.S,Satara,Maharashtra',
'Vaduj,Satara,Maharashtra',
'Vaduj Town,Satara,Maharashtra',
'Varud,Satara,Maharashtra',
'Vetane,Satara,Maharashtra',
'Vikhale,Satara,Maharashtra',
'Visapur,Satara,Maharashtra',
'Wakeshwar,Satara,Maharashtra',
'Yeliv,Satara,Maharashtra',
'Yenkul,Satara,Maharashtra',
'Yeralwadi,Satara,Maharashtra',
'Ambavade S Wagholi,Satara,Maharashtra',
'Ambawade S Koregaon,Satara,Maharashtra',
'Ambheri,Satara,Maharashtra',
'Anapatwadi,Satara,Maharashtra',
'Apashinge (Rahimatpur),Satara,Maharashtra',
'Arale,Satara,Maharashtra',
'Arvi,Satara,Maharashtra',
'Banawadi,Satara,Maharashtra',
'Bhadale,Satara,Maharashtra',
'Bhaktawadi,Satara,Maharashtra',
'Bhose,Satara,Maharashtra',
'Bichukale,Satara,Maharashtra',
'Borgaon,Satara,Maharashtra',
'Borjaiwadi,Satara,Maharashtra',
'Chanchali,Satara,Maharashtra',
'Chimangaon,Satara,Maharashtra',
'Dahigaon,Satara,Maharashtra',
'Deur,Satara,Maharashtra',
'Dhamner,Satara,Maharashtra',
'Dhumalwadi,Satara,Maharashtra',
'Ekambe,Satara,Maharashtra',
'Hivare,Satara,Maharashtra',
'Jalgaon,Satara,Maharashtra',
'Jamb Budurk,Satara,Maharashtra',
'Jamb Khurd,Satara,Maharashtra',
'Kanher Khed,Satara,Maharashtra',
'Karanjkhop,Satara,Maharashtra',
'Katahapur,Satara,Maharashtra',
'Khed (Nandgiri),Satara,Maharashtra',
'Kinhai,Satara,Maharashtra',
'Kiroli,Satara,Maharashtra',
'Koregaon City,Satara,Maharashtra',
'Koregaon,Satara,Maharashtra',
'Kumathe,Satara,Maharashtra',
'Lahasurne,Satara,Maharashtra',
'Nagzari,Satara,Maharashtra',
'Naigaon,Satara,Maharashtra',
'Nandawal,Satara,Maharashtra',
'Nhavi BK,Satara,Maharashtra',
'Nigadi,Satara,Maharashtra',
'Palashi (Vaduth),Satara,Maharashtra',
'Pimpari,Satara,Maharashtra',
'Pimpode BK,Satara,Maharashtra',
'Pimpode KH,Satara,Maharashtra',
'Rahimatpur,Satara,Maharashtra',
'Randullahabad,Satara,Maharashtra',
'Rautwadi,Satara,Maharashtra',
'Revadi,Satara,Maharashtra',
'Rui,Satara,Maharashtra',
'Sap,Satara,Maharashtra',
'Sarkalwadi.,Satara,Maharashtra',
'Sasurve,Satara,Maharashtra',
'Satararoad,Satara,Maharashtra',
'Shendurjane,Satara,Maharashtra',
'Shirambe,Satara,Maharashtra',
'Shirdhon,Satara,Maharashtra',
'Sonake,Satara,Maharashtra',
'Surali,Satara,Maharashtra',
'Tadavale S. Koregaon,Satara,Maharashtra',
'Tadawale,Satara,Maharashtra',
'Taliye,Satara,Maharashtra',
'Tandulawadi,Satara,Maharashtra',
'Targaon,Satara,Maharashtra',
'Triputi,Satara,Maharashtra',
'Vardhangad,Satara,Maharashtra',
'Vathar Kiroli,Satara,Maharashtra',
'Vathar,Satara,Maharashtra',
'Velu,Satara,Maharashtra',
'Vikhale,Satara,Maharashtra',
'Wagholi,Satara,Maharashtra',
'Kumbharoshi,Satara,Maharashtra',
'Asi A Plato,Satara,Maharashtra',
'Bhilar,Satara,Maharashtra',
'Birwadi,Satara,Maharashtra',
'Hatlot,Satara,Maharashtra',
'Khengar,Satara,Maharashtra',
'Machutar,Satara,Maharashtra',
'Mahabaleshwar,Satara,Maharashtra',
'Met Gutad,Satara,Maharashtra',
'Panchgani,Satara,Maharashtra',
'Petpar,Satara,Maharashtra',
'Pratapgad,Satara,Maharashtra',
'Taldeo,Satara,Maharashtra',
'Tapola,Satara,Maharashtra',
'Velapur,Satara,Maharashtra',
'Zanzwad,Satara,Maharashtra',
'Biramani,Satara,Maharashtra',
'Kshetra Mahabaleshwar.,Satara,Maharashtra',
'Andali,Satara,Maharashtra',
'Bidal,Satara,Maharashtra',
'Bijawadi,Satara,Maharashtra',
'Dahivadi,Satara,Maharashtra',
'Devapur,Satara,Maharashtra',
'Dhuldev,Satara,Maharashtra',
'Divad,Satara,Maharashtra',
'Gondawale BK,Satara,Maharashtra',
'Gondawale KHD,Satara,Maharashtra',
'Injabav,Satara,Maharashtra',
'Kukudwad,Satara,Maharashtra',
'Malawadi,Satara,Maharashtra',
'Mardi,Satara,Maharashtra',
'Mhaswad,Satara,Maharashtra',
'Mohi,Satara,Maharashtra',
'Naravane,Satara,Maharashtra',
'Palashi (Man),Satara,Maharashtra',
'Pangari,Satara,Maharashtra',
'Parayanti,Satara,Maharashtra',
'Patole Khadaki,Satara,Maharashtra',
'Pimpari (Man),Satara,Maharashtra',
'Pingali BK,Satara,Maharashtra',
'Pulkoti,Satara,Maharashtra',
'Ranand,Satara,Maharashtra',
'Shinganapur,Satara,Maharashtra',
'Tondale,Satara,Maharashtra',
'Vadajal,Satara,Maharashtra',
'Varkute Mhaswad,Satara,Maharashtra',
'Vavarhire,Satara,Maharashtra',
'Virali,Satara,Maharashtra',
'Mahiamngad,Satara,Maharashtra',
'Varkute Malawadi,Satara,Maharashtra',
'Adul,Satara,Maharashtra',
'Ambale,Satara,Maharashtra',
'Ambavawde KHD,Satara,Maharashtra',
'Ambrule,Satara,Maharashtra',
'Avarde,Satara,Maharashtra',
'Bahule,Satara,Maharashtra',
'Bambawade,Satara,Maharashtra',
'Banpuri,Satara,Maharashtra',
'Belawade KH,Satara,Maharashtra',
'Bibi(Patan),Satara,Maharashtra',
'Bondri,Satara,Maharashtra',
'Bopoli,Satara,Maharashtra',
'Chaphal,Satara,Maharashtra',
'Chavanwadi,Satara,Maharashtra',
'Chikhaewadi,Satara,Maharashtra',
'Chopadi,Satara,Maharashtra',
'Dadholi,Satara,Maharashtra',
'Daulat Nagar,Satara,Maharashtra',
'Dervan,Satara,Maharashtra',
'Dhamni,Satara,Maharashtra',
'Dhebewadi,Satara,Maharashtra',
'Dhoroshi,Satara,Maharashtra',
'Divashi BK,Satara,Maharashtra',
'Divashi Khrud,Satara,Maharashtra',
'Dixi,Satara,Maharashtra',
'Galmewadi,Satara,Maharashtra',
'Garwade,Satara,Maharashtra',
'Ghosatawadi,Satara,Maharashtra',
'Ghot,Satara,Maharashtra',
'Govare,Satara,Maharashtra',
'Gudhe,Satara,Maharashtra',
'Helwak,Satara,Maharashtra',
'Jalagewadi,Satara,Maharashtra',
'Jalav,Satara,Maharashtra',
'Janugade Wadi,Satara,Maharashtra',
'Jinti.,Satara,Maharashtra',
'Kadavebuduruk,Satara,Maharashtra',
'Kadhane,Satara,Maharashtra',
'Kalgaon,Satara,Maharashtra',
'Kelambe,Satara,Maharashtra',
'Keloli,Satara,Maharashtra',
'Keral,Satara,Maharashtra',
'Khale,Satara,Maharashtra',
'Kokisare,Satara,Maharashtra',
'Koriwale,Satara,Maharashtra',
'Koyana,Satara,Maharashtra',
'Kumbhargaon,Satara,Maharashtra',
'Kusawade,Satara,Maharashtra',
'Kusurund,Satara,Maharashtra',
'Kuthare,Satara,Maharashtra',
'Mahawashi,Satara,Maharashtra',
'Mahind,Satara,Maharashtra',
'Majgaon,Satara,Maharashtra',
'Malashi,Satara,Maharashtra',
'Maldan,Satara,Maharashtra',
'Malharpeth Karad,Satara,Maharashtra',
'Mandrul Haveli,Satara,Maharashtra',
'Mandrulkole,Satara,Maharashtra',
'Mane Wadi,Satara,Maharashtra',
'Marali,Satara,Maharashtra',
'Marul,Satara,Maharashtra',
'Marul Haveli,Satara,Maharashtra',
'Mendh,Satara,Maharashtra',
'Mendhoshi,Satara,Maharashtra',
'Morgiri,Satara,Maharashtra',
'Murud,Satara,Maharashtra',
'Nade,Satara,Maharashtra',
'Nadoli,Satara,Maharashtra',
'Nanegaon BK,Satara,Maharashtra',
'Nanegaon KH,Satara,Maharashtra',
'Natoshi,Satara,Maharashtra',
'Navadi,Satara,Maharashtra',
'Navaja,Satara,Maharashtra',
'Nisare,Satara,Maharashtra',
'Nune,Satara,Maharashtra',
'Paparde,Satara,Maharashtra',
'Patan,Satara,Maharashtra',
'Pimpaloshi,Satara,Maharashtra',
'Rahude,Satara,Maharashtra',
'Rasati,Satara,Maharashtra',
'Sadawaghapur,Satara,Maharashtra',
'Saikade,Satara,Maharashtra',
'Salave,Satara,Maharashtra',
'Sangvad,Satara,Maharashtra',
'Savarghar,Satara,Maharashtra',
'Shantinagar,Satara,Maharashtra',
'Snboor,Satara,Maharashtra',
'Sonaichi Wadi,Satara,Maharashtra',
'Sonawade,Satara,Maharashtra',
'Talmavale,Satara,Maharashtra',
'Tamkane,Satara,Maharashtra',
'Tarale,Satara,Maharashtra',
'Tondhoshi,Satara,Maharashtra',
'Umarkanchan,Satara,Maharashtra',
'Urul,Satara,Maharashtra',
'Vajroshi,Satara,Maharashtra',
'Vanzole,Satara,Maharashtra',
'Vihe,Satara,Maharashtra',
'Vihe Vasahat,Satara,Maharashtra',
'Yerad,Satara,Maharashtra',
'Yeraphale,Satara,Maharashtra',
'Padaloshi,Satara,Maharashtra',
'Hol,Satara,Maharashtra',
'Jinti,Satara,Maharashtra',
'Marketyard Phaltan,Satara,Maharashtra',
'Nandal,Satara,Maharashtra',
'Nimbhore,Satara,Maharashtra',
'Rawadi BK,Satara,Maharashtra',
'Sakharwadi,Satara,Maharashtra',
'Surawadi,Satara,Maharashtra',
'Vakhari,Satara,Maharashtra',
'Vathar Mimbalkar,Satara,Maharashtra',
'Vidani,Satara,Maharashtra',
'Adarki BK,Satara,Maharashtra',
'Adarki Khurd,Satara,Maharashtra',
'Andarud,Satara,Maharashtra',
'Aradgaon,Satara,Maharashtra',
'Asu,Satara,Maharashtra',
'Barad,Satara,Maharashtra',
'Bibi,Satara,Maharashtra',
'Chavan Wadi,Satara,Maharashtra',
'Dhaval,Satara,Maharashtra',
'Dhudhebavi,Satara,Maharashtra',
'Ghadage Wadi,Satara,Maharashtra',
'Girvi,Satara,Maharashtra',
'Gokhali,Satara,Maharashtra',
'Gunavare,Satara,Maharashtra',
'Hingangaon,Satara,Maharashtra',
'Javli,Satara,Maharashtra',
'Kalaj,Satara,Maharashtra',
'Kapshi,Satara,Maharashtra',
'Khunte,Satara,Maharashtra',
'Nimblak,Satara,Maharashtra',
'Nirgudi,Satara,Maharashtra',
'Padegaon,Satara,Maharashtra',
'Pawar Wadi,Satara,Maharashtra',
'Phaltan,Satara,Maharashtra',
'Pimprad,Satara,Maharashtra',
'Rajale,Satara,Maharashtra',
'Rajuri,Satara,Maharashtra',
'Salpe,Satara,Maharashtra',
'Sangavi,Satara,Maharashtra',
'Sarde,Satara,Maharashtra',
'Saskal,Satara,Maharashtra',
'Saswad (Lonand),Satara,Maharashtra',
'Sherechiwadi,Satara,Maharashtra',
'Shindenagar,Satara,Maharashtra',
'Shukarwar Peth Phaltan,Satara,Maharashtra',
'Somanthali,Satara,Maharashtra',
'Sonavadi,Satara,Maharashtra',
'Songaon,Satara,Maharashtra',
'Sukhed,Satara,Maharashtra',
'Tambave (Lonand),Satara,Maharashtra',
'Taradgaon,Satara,Maharashtra',
'Tardaf,Satara,Maharashtra',
'Thathavada,Satara,Maharashtra',
'Upalave,Satara,Maharashtra',
'Vadale,Satara,Maharashtra',
'Ambadare,Satara,Maharashtra',
'Ambawade,Satara,Maharashtra',
'Andhari,Satara,Maharashtra',
'Angapur Vandan,Satara,Maharashtra',
'Apashinge,Satara,Maharashtra',
'Are,Satara,Maharashtra',
'Asagaon Vasahat,Satara,Maharashtra',
'Asangaon,Satara,Maharashtra',
'Atit,Satara,Maharashtra',
'Banghar,Satara,Maharashtra',
'Bharatgaon Wadi,Satara,Maharashtra',
'Bhatmarli,Satara,Maharashtra',
'Boposhi,Satara,Maharashtra',
'Boragaon,Satara,Maharashtra',
'Boregaon Agricultural School,Satara,Maharashtra',
'Borkhal,Satara,Maharashtra',
'Budhawar Naka Satara,Satara,Maharashtra',
'Chinchaner Vandan,Satara,Maharashtra',
'Dahivad,Satara,Maharashtra',
'Degaon Tambe,Satara,Maharashtra',
'Dhawadshi,Satara,Maharashtra',
'Gajavadi,Satara,Maharashtra',
'Gojegaon,Satara,Maharashtra',
'Gove,Satara,Maharashtra',
'Iti Satara,Satara,Maharashtra',
'Jakatwadi,Satara,Maharashtra',
'Jihe,Satara,Maharashtra',
'Kameri,Satara,Maharashtra',
'Karandi,Satara,Maharashtra',
'Kari,Satara,Maharashtra',
'Kashil,Satara,Maharashtra',
'Kelembe,Satara,Maharashtra',
'Khed(Wadhe),Satara,Maharashtra',
'Khojewadi,Satara,Maharashtra',
'Kidgaon,Satara,Maharashtra',
'Kindawadi,Satara,Maharashtra',
'Kodoli,Satara,Maharashtra',
'Kondhav Satara,Satara,Maharashtra',
'Koparde,Satara,Maharashtra',
'Kshatra Mahuli,Satara,Maharashtra',
'Kumthe,Satara,Maharashtra',
'Limbgove,Satara,Maharashtra',
'Mahawshi,Satara,Maharashtra',
'Majgaon,Satara,Maharashtra',
'Malagaon,Satara,Maharashtra',
'Mandhave,Satara,Maharashtra',
'Mangalwar Peth Satara,Satara,Maharashtra',
'Mardhe,Satara,Maharashtra',
'Midc Satara,Satara,Maharashtra',
'Mouje Tasgaon,Satara,Maharashtra',
'Munawale,Satara,Maharashtra',
'Nagewadi,Satara,Maharashtra',
'Nagthane,Satara,Maharashtra',
'Nandgaon,Satara,Maharashtra',
'Nigadi Traf,Satara,Maharashtra',
'Nisarale,Satara,Maharashtra',
'Nitral,Satara,Maharashtra',
'Nune,Satara,Maharashtra',
'Padali Ninam,Satara,Maharashtra',
'Parali,Satara,Maharashtra',
'Patkhal,Satara,Maharashtra',
'Prtri,Satara,Maharashtra',
'Rajapuri,Satara,Maharashtra',
'Rohot,Satara,Maharashtra',
'Sajjanghad,Satara,Maharashtra',
'Sangamnagar Satara,Satara,Maharashtra',
'Saspade,Satara,Maharashtra',
'Satara H.O,Satara,Maharashtra',
'Sataracity,Satara,Maharashtra',
'Shahupuri Satara,Satara,Maharashtra',
'Shendare,Satara,Maharashtra',
'Shivthar,Satara,Maharashtra',
'Songaon,Satara,Maharashtra',
'Thoseghar,Satara,Maharashtra',
'Vade,Satara,Maharashtra',
'Vaduth,Satara,Maharashtra',
'Varne,Satara,Maharashtra',
'Varye,Satara,Maharashtra',
'Vechale,Satara,Maharashtra',
'Veenanagar,Satara,Maharashtra',
'Vele (Kamthi),Satara,Maharashtra',
'Venegaon,Satara,Maharashtra',
'Yadogophal Peth,Satara,Maharashtra',
'Yevateshwar,Satara,Maharashtra',
'Chinchaner S. Nimb,Satara,Maharashtra',
'Kanher-akale,Satara,Maharashtra',
'Abhepuri,Satara,Maharashtra',
'Akoshi,Satara,Maharashtra',
'Asale,Satara,Maharashtra',
'Asare,Satara,Maharashtra',
'Baleghar,Satara,Maharashtra',
'Bavadhan,Satara,Maharashtra',
'Bhogaon,Satara,Maharashtra',
'Bhuinj,Satara,Maharashtra',
'Bopardi,Satara,Maharashtra',
'Borgaon BK,Satara,Maharashtra',
'Chandak,Satara,Maharashtra',
'Chikhali,Satara,Maharashtra',
'Chindhawali,Satara,Maharashtra',
'Degaon Shirgaon,Satara,Maharashtra',
'Dhavadi,Satara,Maharashtra',
'Dhom,Satara,Maharashtra',
'Eksare,Satara,Maharashtra',
'Gulumb,Satara,Maharashtra',
'Jamb (Kikali),Satara,Maharashtra',
'Kadegaon,Satara,Maharashtra',
'Kanur,Satara,Maharashtra',
'Kavathe,Satara,Maharashtra',
'Kenjal,Satara,Maharashtra',
'Khanapur,Satara,Maharashtra',
'Kikali,Satara,Maharashtra',
'Kisanveernagar,Satara,Maharashtra',
'Mandhar Deo,Satara,Maharashtra',
'Menavali,Satara,Maharashtra',
'Ozarde,Satara,Maharashtra',
'Pachvad,Satara,Maharashtra',
'Pande,Satara,Maharashtra',
'Parkhandi,Satara,Maharashtra',
'Pasarni,Satara,Maharashtra',
'Phulenagar Wai,Satara,Maharashtra',
'Shendurjane,Satara,Maharashtra',
'Shirgaon,Satara,Maharashtra',
'Surur,Satara,Maharashtra',
'Udatare,Satara,Maharashtra',
'Vaigaon,Satara,Maharashtra',
'Vasole,Satara,Maharashtra',
'Velang,Satara,Maharashtra',
'Vele,Satara,Maharashtra',
'Virmade,Satara,Maharashtra',
'Vyahali,Satara,Maharashtra',
'Vyajawadi,Satara,Maharashtra',
'Wai City,Satara,Maharashtra',
'Wai,Satara,Maharashtra',
'Are,Sindhudurg,Maharashtra',
'Asalda,Sindhudurg,Maharashtra',
'Baparde,Sindhudurg,Maharashtra',
'Belnekhurd,Sindhudurg,Maharashtra',
'Burambavade,Sindhudurg,Maharashtra',
'Dabhole,Sindhudurg,Maharashtra',
'Dahibav,Sindhudurg,Maharashtra',
'Damre,Sindhudurg,Maharashtra',
'Devgad,Sindhudurg,Maharashtra',
'Gadhitamhane,Sindhudurg,Maharashtra',
'Ghousari,Sindhudurg,Maharashtra',
'Girye,Sindhudurg,Maharashtra',
'Hadpid,Sindhudurg,Maharashtra',
'Harkul Khurd,Sindhudurg,Maharashtra',
'Hindale,Sindhudurg,Maharashtra',
'Ilye,Sindhudurg,Maharashtra',
'Jamsande,Sindhudurg,Maharashtra',
'Karul,Sindhudurg,Maharashtra',
'Katta,Sindhudurg,Maharashtra',
'Khudi,Sindhudurg,Maharashtra',
'Kinjavade,Sindhudurg,Maharashtra',
'Koloshi,Sindhudurg,Maharashtra',
'Kotkamte,Sindhudurg,Maharashtra',
'Kunkeshwar,Sindhudurg,Maharashtra',
'Kurli,Sindhudurg,Maharashtra',
'Kuvale,Sindhudurg,Maharashtra',
'Lore-i,Sindhudurg,Maharashtra',
'Lore-II,Sindhudurg,Maharashtra',
'Mahalunge,Sindhudurg,Maharashtra',
'Manche,Sindhudurg,Maharashtra',
'Mithbav,Sindhudurg,Maharashtra',
'Mithmumbari,Sindhudurg,Maharashtra',
'Mond,Sindhudurg,Maharashtra',
'Munge,Sindhudurg,Maharashtra',
'Mutat,Sindhudurg,Maharashtra',
'Nadan,Sindhudurg,Maharashtra',
'Naringre,Sindhudurg,Maharashtra',
'Padel,Sindhudurg,Maharashtra',
'Patgaon,Sindhudurg,Maharashtra',
'Pendhari,Sindhudurg,Maharashtra',
'Phanasgaon,Sindhudurg,Maharashtra',
'Phondaghat,Sindhudurg,Maharashtra',
'Pomburla,Sindhudurg,Maharashtra',
'Poyare,Sindhudurg,Maharashtra',
'Pural,Sindhudurg,Maharashtra',
'Salshi,Sindhudurg,Maharashtra',
'Shirgaon,Sindhudurg,Maharashtra',
'Soundale,Sindhudurg,Maharashtra',
'Talavade,Sindhudurg,Maharashtra',
'Talera,Sindhudurg,Maharashtra',
'Tambaldeg,Sindhudurg,Maharashtra',
'Taramumbari,Sindhudurg,Maharashtra',
'Tembavli,Sindhudurg,Maharashtra',
'Thakurwadi,Sindhudurg,Maharashtra',
'Tirlot,Sindhudurg,Maharashtra',
'Tondavali,Sindhudurg,Maharashtra',
'Torsole,Sindhudurg,Maharashtra',
'Vada,Sindhudurg,Maharashtra',
'Valivande,Sindhudurg,Maharashtra',
'Vijaydurg,Sindhudurg,Maharashtra',
'Wagheri,Sindhudurg,Maharashtra',
'Waghotan,Sindhudurg,Maharashtra',
'Waniwade,Sindhudurg,Maharashtra',
'Ayee,Sindhudurg,Maharashtra',
'Bhedshi,Sindhudurg,Maharashtra',
'Dodamarg,Sindhudurg,Maharashtra',
'Ghotage,Sindhudurg,Maharashtra',
'Ghotagewadi,Sindhudurg,Maharashtra',
'Ker,Sindhudurg,Maharashtra',
'Konal,Sindhudurg,Maharashtra',
'Konalkatta Colony,Sindhudurg,Maharashtra',
'Kudase,Sindhudurg,Maharashtra',
'Mangeli,Sindhudurg,Maharashtra',
'Parme,Sindhudurg,Maharashtra',
'Pikule,Sindhudurg,Maharashtra',
'Shirange,Sindhudurg,Maharashtra',
'Talekhol,Sindhudurg,Maharashtra',
'Tervan Medhe,Sindhudurg,Maharashtra',
'Usap,Sindhudurg,Maharashtra',
'Vazare,Sindhudurg,Maharashtra',
'Zarebambar Vasahat,Sindhudurg,Maharashtra',
'Talebazar,Sindhudurg,Maharashtra',
'Budhavale,Sindhudurg,Maharashtra',
'Gavane,Sindhudurg,Maharashtra',
'Gothane,Sindhudurg,Maharashtra',
'Korla,Sindhudurg,Maharashtra',
'Nadgive,Sindhudurg,Maharashtra',
'Nanivade,Sindhudurg,Maharashtra',
'Sandave,Sindhudurg,Maharashtra',
'Shravan,Sindhudurg,Maharashtra',
'Asrondi,Sindhudurg,Maharashtra',
'Aynal,Sindhudurg,Maharashtra',
'Bharni,Sindhudurg,Maharashtra',
'Bhirvande,Sindhudurg,Maharashtra',
'Bidwadi,Sindhudurg,Maharashtra',
'Dariste,Sindhudurg,Maharashtra',
'Digavle,Sindhudurg,Maharashtra',
'Gopuri,Sindhudurg,Maharashtra',
'Halval,Sindhudurg,Maharashtra',
'Harkul Budruk,Sindhudurg,Maharashtra',
'Humbrat,Sindhudurg,Maharashtra',
'Janavali,Sindhudurg,Maharashtra',
'Kalmath,Sindhudurg,Maharashtra',
'Kalsuli,Sindhudurg,Maharashtra',
'Kankavli,Sindhudurg,Maharashtra',
'Karanje,Sindhudurg,Maharashtra',
'Kasaral,Sindhudurg,Maharashtra',
'Kasarde,Sindhudurg,Maharashtra',
'Kasavan,Sindhudurg,Maharashtra',
'Kharepatan,Sindhudurg,Maharashtra',
'Kirlos,Sindhudurg,Maharashtra',
'Kumbhavade,Sindhudurg,Maharashtra',
'Kunkavan,Sindhudurg,Maharashtra',
'Kurangavane,Sindhudurg,Maharashtra',
'Main,Sindhudurg,Maharashtra',
'Math Budruk,Sindhudurg,Maharashtra',
'Nad,Sindhudurg,Maharashtra',
'Nagve,Sindhudurg,Maharashtra',
'Nandgaon,Sindhudurg,Maharashtra',
'Nardave,Sindhudurg,Maharashtra',
'Natal,Sindhudurg,Maharashtra',
'Nirom,Sindhudurg,Maharashtra',
'Otav,Sindhudurg,Maharashtra',
'Ozaram,Sindhudurg,Maharashtra',
'Ramgad,Sindhudurg,Maharashtra',
'Rathivade,Sindhudurg,Maharashtra',
'Sakedi,Sindhudurg,Maharashtra',
'Sangve,Sindhudurg,Maharashtra',
'Savdav,Sindhudurg,Maharashtra',
'Shidavane,Sindhudurg,Maharashtra',
'Shirval,Sindhudurg,Maharashtra',
'Shirvande,Sindhudurg,Maharashtra',
'Shivdav,Sindhudurg,Maharashtra',
'Tarandale,Sindhudurg,Maharashtra',
'Tithavli,Sindhudurg,Maharashtra',
'Varavde,Sindhudurg,Maharashtra',
'Waghivare,Sindhudurg,Maharashtra',
'Wargaon,Sindhudurg,Maharashtra',
'Ambrad,Sindhudurg,Maharashtra',
'Anav,Sindhudurg,Maharashtra',
'Andurla,Sindhudurg,Maharashtra',
'Avalegaon,Sindhudurg,Maharashtra',
'Bambuli,Sindhudurg,Maharashtra',
'Bav,Sindhudurg,Maharashtra',
'Bhadgaon Budruk,Sindhudurg,Maharashtra',
'Bharni,Sindhudurg,Maharashtra',
'Bibavane,Sindhudurg,Maharashtra',
'Bordave,Sindhudurg,Maharashtra',
'C.C.Oros,Sindhudurg,Maharashtra',
'Chendavan,Sindhudurg,Maharashtra',
'Dabhachiwadi,Sindhudurg,Maharashtra',
'Deulwada Nerur,Sindhudurg,Maharashtra',
'Digas,Sindhudurg,Maharashtra',
'Dukanwad,Sindhudurg,Maharashtra',
'Ghavanale,Sindhudurg,Maharashtra',
'Ghotage,Sindhudurg,Maharashtra',
'Gothos,Sindhudurg,Maharashtra',
'Goveri,Sindhudurg,Maharashtra',
'Hedul,Sindhudurg,Maharashtra',
'Hirlok,Sindhudurg,Maharashtra',
'Hiwale,Sindhudurg,Maharashtra',
'Humarmala,Sindhudurg,Maharashtra',
'Industrial Area Pinguli,Sindhudurg,Maharashtra',
'Jambhavade,Sindhudurg,Maharashtra',
'Kaleli,Sindhudurg,Maharashtra',
'Kasal,Sindhudurg,Maharashtra',
'Kavathi,Sindhudurg,Maharashtra',
'Kelus,Sindhudurg,Maharashtra',
'Keravade,Sindhudurg,Maharashtra',
'Khavane,Sindhudurg,Maharashtra',
'Khotale,Sindhudurg,Maharashtra',
'Khutvalwadi,Sindhudurg,Maharashtra',
'Kochara,Sindhudurg,Maharashtra',
'Kual Audyogik Samuha,Sindhudurg,Maharashtra',
'Kudal,Sindhudurg,Maharashtra',
'Kunde,Sindhudurg,Maharashtra',
'Kupavade,Sindhudurg,Maharashtra',
'Madyachiwadi,Sindhudurg,Maharashtra',
'Mahadevache Kervade,Sindhudurg,Maharashtra',
'Mandkuli,Sindhudurg,Maharashtra',
'Mangaon,Sindhudurg,Maharashtra',
'Mhapan,Sindhudurg,Maharashtra',
'Mulde,Sindhudurg,Maharashtra',
'Naneli,Sindhudurg,Maharashtra',
'Narur,Sindhudurg,Maharashtra',
'Nerur,Sindhudurg,Maharashtra',
'Nileli,Sindhudurg,Maharashtra',
'Nirukhe,Sindhudurg,Maharashtra',
'Nivaje,Sindhudurg,Maharashtra',
'Niwatiwadi,Sindhudurg,Maharashtra',
'Oros,Sindhudurg,Maharashtra',
'Osargaon,Sindhudurg,Maharashtra',
'Ovaliye,Sindhudurg,Maharashtra',
'Pandur,Sindhudurg,Maharashtra',
'Pangrad,Sindhudurg,Maharashtra',
'Pat,Sindhudurg,Maharashtra',
'Pawashi,Sindhudurg,Maharashtra',
'Pinguli,Sindhudurg,Maharashtra',
'Pokharan,Sindhudurg,Maharashtra',
'Ran Bambuli,Sindhudurg,Maharashtra',
'Sarambal,Sindhudurg,Maharashtra',
'Shivapur,Sindhudurg,Maharashtra',
'Sonavade,Sindhudurg,Maharashtra',
'Sonavade,Sindhudurg,Maharashtra',
'Tendoli,Sindhudurg,Maharashtra',
'Terse Bambarde,Sindhudurg,Maharashtra',
'Tulsuli,Sindhudurg,Maharashtra',
'Vadivaravde,Sindhudurg,Maharashtra',
'Vados,Sindhudurg,Maharashtra',
'Varde,Sindhudurg,Maharashtra',
'Vasoli,Sindhudurg,Maharashtra',
'Vetal Bambarde,Sindhudurg,Maharashtra',
'Waingavde,Sindhudurg,Maharashtra',
'Walaval,Sindhudurg,Maharashtra',
'Achara,Sindhudurg,Maharashtra',
'Adavli,Sindhudurg,Maharashtra',
'Amberi,Sindhudurg,Maharashtra',
'Bandivade,Sindhudurg,Maharashtra',
'Chafekhol,Sindhudurg,Maharashtra',
'Chindar,Sindhudurg,Maharashtra',
'Chindar Bazar,Sindhudurg,Maharashtra',
'Chouke,Sindhudurg,Maharashtra',
'Deulwada,Sindhudurg,Maharashtra',
'Devbag,Sindhudurg,Maharashtra',
'Devli,Sindhudurg,Maharashtra',
'Dhamapur,Sindhudurg,Maharashtra',
'Gaudwadi,Sindhudurg,Maharashtra',
'Gavrai,Sindhudurg,Maharashtra',
'Golvan,Sindhudurg,Maharashtra',
'Hadi,Sindhudurg,Maharashtra',
'Hirlewadi,Sindhudurg,Maharashtra',
'Kalse,Sindhudurg,Maharashtra',
'Kandalgaon,Sindhudurg,Maharashtra',
'Katta,Sindhudurg,Maharashtra',
'Khaida,Sindhudurg,Maharashtra',
'Kolamb,Sindhudurg,Maharashtra',
'Kunkavale,Sindhudurg,Maharashtra',
'Malgaon,Sindhudurg,Maharashtra',
'Malond,Sindhudurg,Maharashtra',
'Malvan H.O,Sindhudurg,Maharashtra',
'Masde,Sindhudurg,Maharashtra',
'Masura,Sindhudurg,Maharashtra',
'Mogarne,Sindhudurg,Maharashtra',
'Nandos,Sindhudurg,Maharashtra',
'Nandrukh,Sindhudurg,Maharashtra',
'Padve,Sindhudurg,Maharashtra',
'Palsamb,Sindhudurg,Maharashtra',
'Pendur,Sindhudurg,Maharashtra',
'Pirawadi,Sindhudurg,Maharashtra',
'Poip,Sindhudurg,Maharashtra',
'Revandi,Sindhudurg,Maharashtra',
'Salel,Sindhudurg,Maharashtra',
'Sarjekot,Sindhudurg,Maharashtra',
'Sukalwadi,Sindhudurg,Maharashtra',
'Talgaon,Sindhudurg,Maharashtra',
'Tarkarli,Sindhudurg,Maharashtra',
'Tiravade,Sindhudurg,Maharashtra',
'Tondavali,Sindhudurg,Maharashtra',
'Trimbak,Sindhudurg,Maharashtra',
'Varad,Sindhudurg,Maharashtra',
'Veral,Sindhudurg,Maharashtra',
'Waingani,Sindhudurg,Maharashtra',
'Wairy Bhutnath,Sindhudurg,Maharashtra',
'Kumbharmath,Sindhudurg,Maharashtra',
'Ajgaon,Sindhudurg,Maharashtra',
'Akeri,Sindhudurg,Maharashtra',
'Ambegaon,Sindhudurg,Maharashtra',
'Amboli,Sindhudurg,Maharashtra',
'Aronda,Sindhudurg,Maharashtra',
'Aros,Sindhudurg,Maharashtra',
'Banda,Sindhudurg,Maharashtra',
'Bhalaval,Sindhudurg,Maharashtra',
'Charatha,Sindhudurg,Maharashtra',
'Choukul,Sindhudurg,Maharashtra',
'Danoli,Sindhudurg,Maharashtra',
'Degave,Sindhudurg,Maharashtra',
'Devsu,Sindhudurg,Maharashtra',
'Insuli,Sindhudurg,Maharashtra',
'Kalane,Sindhudurg,Maharashtra',
'Kalmist,Sindhudurg,Maharashtra',
'Karivade,Sindhudurg,Maharashtra',
'Kas,Sindhudurg,Maharashtra',
'Kavathani,Sindhudurg,Maharashtra',
'Kolgaon,Sindhudurg,Maharashtra',
'Kolzar,Sindhudurg,Maharashtra',
'Kumbral,Sindhudurg,Maharashtra',
'Kunkeri,Sindhudurg,Maharashtra',
'Madkhol,Sindhudurg,Maharashtra',
'Madura,Sindhudurg,Maharashtra',
'Malewad,Sindhudurg,Maharashtra',
'Malgaon,Sindhudurg,Maharashtra',
'Mazgaon,Sindhudurg,Maharashtra',
'Morgaon,Sindhudurg,Maharashtra',
'Nemle,Sindhudurg,Maharashtra',
'Netarde,Sindhudurg,Maharashtra',
'Nhaveli,Sindhudurg,Maharashtra',
'Nigude,Sindhudurg,Maharashtra',
'Niravade,Sindhudurg,Maharashtra',
'Otavane,Sindhudurg,Maharashtra',
'Salgaon,Sindhudurg,Maharashtra',
'Sangeli,Sindhudurg,Maharashtra',
'Sarmale,Sindhudurg,Maharashtra',
'Sasoli,Sindhudurg,Maharashtra',
'Satarda,Sindhudurg,Maharashtra',
'Satose,Sindhudurg,Maharashtra',
'Sawantwadi H.O,Sindhudurg,Maharashtra',
'Sherla,Sindhudurg,Maharashtra',
'Shirshinge,Sindhudurg,Maharashtra',
'Sonurli,Sindhudurg,Maharashtra',
'Talavane,Sindhudurg,Maharashtra',
'Talkat,Sindhudurg,Maharashtra',
'Tambuli,Sindhudurg,Maharashtra',
'Verle,Sindhudurg,Maharashtra',
'Vilvade,Sindhudurg,Maharashtra',
'Wafoli,Sindhudurg,Maharashtra',
'Zarapi,Sindhudurg,Maharashtra',
'Zolambe,Sindhudurg,Maharashtra',
'Kadaval,Sindhudurg,Maharashtra',
'Achirne,Sindhudurg,Maharashtra',
'Akhavane,Sindhudurg,Maharashtra',
'Arule,Sindhudurg,Maharashtra',
'Bhuibavda,Sindhudurg,Maharashtra',
'Gadmath,Sindhudurg,Maharashtra',
'Het,Sindhudurg,Maharashtra',
'Jambhavade,Ratnagiri,Maharashtra',
'Karulbavada,Sindhudurg,Maharashtra',
'Khambale,Sindhudurg,Maharashtra',
'Kokisara,Sindhudurg,Maharashtra',
'Kumbhavade,Sindhudurg,Maharashtra',
'Kusur,Sindhudurg,Maharashtra',
'Mangavli,Sindhudurg,Maharashtra',
'Nadhavade,Sindhudurg,Maharashtra',
'Napne,Sindhudurg,Maharashtra',
'Nerle,Ratnagiri,Maharashtra',
'Sadure,Sindhudurg,Maharashtra',
'Sangulwadi,Sindhudurg,Maharashtra',
'Umbarde,Sindhudurg,Maharashtra',
'Upale,Sindhudurg,Maharashtra',
'Vaibhavwadi,Sindhudurg,Maharashtra',
'Adeli,Sindhudurg,Maharashtra',
'Ansur,Sindhudurg,Maharashtra',
'Aravli,Sindhudurg,Maharashtra',
'Asoli,Sindhudurg,Maharashtra',
'Asolipal,Sindhudurg,Maharashtra',
'Bhogave,Sindhudurg,Maharashtra',
'Dabholi,Sindhudurg,Maharashtra',
'Dhakore,Sindhudurg,Maharashtra',
'Hodavade,Sindhudurg,Maharashtra',
'Karliwadi,Sindhudurg,Maharashtra',
'Khanoli,Sindhudurg,Maharashtra',
'Math,Sindhudurg,Maharashtra',
'Matond,Sindhudurg,Maharashtra',
'Parula,Sindhudurg,Maharashtra',
'Pendhryachiwadi,Sindhudurg,Maharashtra',
'Redi,Sindhudurg,Maharashtra',
'Shiroda,Sindhudurg,Maharashtra',
'Tak,Sindhudurg,Maharashtra',
'Talavade,Sindhudurg,Maharashtra',
'Terawalewadi,Sindhudurg,Maharashtra',
'Tiravade,Sindhudurg,Maharashtra',
'Tulas,Sindhudurg,Maharashtra',
'Ubhadanda,Sindhudurg,Maharashtra',
'Vajarat,Sindhudurg,Maharashtra',
'Vengurla Camp,Sindhudurg,Maharashtra',
'Vengurla,Sindhudurg,Maharashtra',
'Vetore,Sindhudurg,Maharashtra',
'Wadkhol,Sindhudurg,Maharashtra',
'Wainganiwadi,Sindhudurg,Maharashtra',
'Bagechiwadi,Pandharpur,Maharashtra',
'Chakore,Pandharpur,Maharashtra',
'Kondbhav,Pandharpur,Maharashtra',
'Malewadi,Pandharpur,Maharashtra',
'Marapur,Pandharpur,Maharashtra',
'Rople BK,Pandharpur,Maharashtra',
'Bagehalli,Solapur,Maharashtra',
'Akkalkot,Solapur,Maharashtra',
'Ankalge,Solapur,Maharashtra',
'Babalad,Solapur,Maharashtra',
'Badole BK,Solapur,Maharashtra',
'Barhanpur,Solapur,Maharashtra',
'Basalegaon,Solapur,Maharashtra',
'Bhurikavathe,Solapur,Maharashtra',
'Borgaon,Solapur,Maharashtra',
'Boroti,Solapur,Maharashtra',
'Chapalgaon,Solapur,Maharashtra',
'Chikkehalli,Solapur,Maharashtra',
'Chungi,Solapur,Maharashtra',
'Dahitne,Solapur,Maharashtra',
'Dombarjawalge,Solapur,Maharashtra',
'Dudhani,Solapur,Maharashtra',
'Gaudgaon,Solapur,Maharashtra',
'Gholasgaon,Solapur,Maharashtra',
'Gogaon,Solapur,Maharashtra',
'Haidra,Solapur,Maharashtra',
'Hanjagi,Solapur,Maharashtra',
'Hannur,Solapur,Maharashtra',
'Hatti Kanabus,Solapur,Maharashtra',
'Jeur (Akkalkot),Solapur,Maharashtra',
'Kadabgaon,Solapur,Maharashtra',
'Kajikanabus,Solapur,Maharashtra',
'Karajagi,Solapur,Maharashtra',
'Kini,Solapur,Maharashtra',
'Korsegaon,Solapur,Maharashtra',
'Kurnoor,Solapur,Maharashtra',
'Maindargi,Solapur,Maharashtra',
'Mangrul,Solapur,Maharashtra',
'Mhaisalge,Solapur,Maharashtra',
'Motyal,Solapur,Maharashtra',
'Mugali,Solapur,Maharashtra',
'Mundewadi,Solapur,Maharashtra',
'Nagansur,Solapur,Maharashtra',
'Nagansur,Solapur,Maharashtra',
'Nagore,Solapur,Maharashtra',
'Navindgi,Solapur,Maharashtra',
'Pitapur,Solapur,Maharashtra',
'Ruddewadi,Solapur,Maharashtra',
'Safale,Solapur,Maharashtra',
'Salgar,Solapur,Maharashtra',
'Sangvi Budruk,Solapur,Maharashtra',
'Satan Dudhani,Solapur,Maharashtra',
'Shaval,Solapur,Maharashtra',
'Shirwal,Solapur,Maharashtra',
'Sinnur,Solapur,Maharashtra',
'Tadwal (Hotagi),Solapur,Maharashtra',
'Tolnur,Solapur,Maharashtra',
'Torni,Solapur,Maharashtra',
'Udagi,Solapur,Maharashtra',
'Umarge,Solapur,Maharashtra',
'Wagadari,Solapur,Maharashtra',
'Agalgaon,Solapur,Maharashtra',
'Babhulgaon,Solapur,Maharashtra',
'Barshi,Solapur,Maharashtra',
'Bavi,Solapur,Maharashtra',
'Bhalgaon,Solapur,Maharashtra',
'Bhatambre,Solapur,Maharashtra',
'Chare,Solapur,Maharashtra',
'Chikharde,Solapur,Maharashtra',
'Chumb,Solapur,Maharashtra',
'Dahitane,Solapur,Maharashtra',
'Deogaon,Solapur,Maharashtra',
'Dhamangaon,Solapur,Maharashtra',
'Gadegaon,Solapur,Maharashtra',
'Gaudgaon,Solapur,Maharashtra',
'Ghanegaon,Solapur,Maharashtra',
'Ghari,Solapur,Maharashtra',
'Gormale,Solapur,Maharashtra',
'Gulpoli,Solapur,Maharashtra',
'Halduge,Solapur,Maharashtra',
'Hattij,Solapur,Maharashtra',
'Irle,Solapur,Maharashtra',
'Jamgaon (Agalgaon),Solapur,Maharashtra',
'Jamgaon (Pangari),Solapur,Maharashtra',
'Javalgaon,Solapur,Maharashtra',
'K V Nagar Barshi,Solapur,Maharashtra',
'K.V.Nagar Barshi,Solapur,Maharashtra',
'Kalamwadi,Solapur,Maharashtra',
'Kari,Solapur,Maharashtra',
'Kategaon,Solapur,Maharashtra',
'Khamgaon,Solapur,Maharashtra',
'Khandvi,Solapur,Maharashtra',
'Korphale,Solapur,Maharashtra',
'Kuslumb,Solapur,Maharashtra',
'Malegaon (Vairag),Solapur,Maharashtra',
'Malegaon,Solapur,Maharashtra',
'Malvandi,Solapur,Maharashtra',
'Mandegaon,Solapur,Maharashtra',
'Market Yard Barshi,Solapur,Maharashtra',
'Mouje Tadvale,Solapur,Maharashtra',
'Nari,Solapur,Maharashtra',
'Pandhari,Solapur,Maharashtra',
'Pangaon,Solapur,Maharashtra',
'Pangri,Solapur,Maharashtra',
'Pimpalgaon,Solapur,Maharashtra',
'Raleras,Solapur,Maharashtra',
'Ratanjan,Solapur,Maharashtra',
'Sakat,Solapur,Maharashtra',
'Sarole,Solapur,Maharashtra',
'Sasure,Solapur,Maharashtra',
'Shendri,Solapur,Maharashtra',
'Shirale,Solapur,Maharashtra',
'Shripat Pimpari,Solapur,Maharashtra',
'Sondare,Solapur,Maharashtra',
'Subhash Nagar Barshi,Solapur,Maharashtra',
'Surdi,Solapur,Maharashtra',
'Tadsoundane,Solapur,Maharashtra',
'Ukadgaon,Solapur,Maharashtra',
'Umbarge,Solapur,Maharashtra',
'Upalai ( Thonge ),Solapur,Maharashtra',
'Upale Dhumala,Solapur,Maharashtra',
'Vairag,Solapur,Maharashtra',
'Yavali,Solapur,Maharashtra',
'Anjandoh,Pandharpur,Maharashtra',
'Awati,Pandharpur,Maharashtra',
'Bhalvani,Pandharpur,Maharashtra',
'Bhogewadi,Pandharpur,Maharashtra',
'Bitergaon ( Wangi ),Pandharpur,Maharashtra',
'Borgaon (Kml),Pandharpur,Maharashtra',
'Chikhalthan,Pandharpur,Maharashtra',
'Dahigaon ( Karmala ),Pandharpur,Maharashtra',
'Devlali,Pandharpur,Maharashtra',
'Ghoti,Pandharpur,Maharashtra',
'Gulsade,Pandharpur,Maharashtra',
'Jategaon,Pandharpur,Maharashtra',
'Jeur,Pandharpur,Maharashtra',
'Jinti,Pandharpur,Maharashtra',
'Kandar,Pandharpur,Maharashtra',
'Karanje,Pandharpur,Maharashtra',
'Karmala,Pandharpur,Maharashtra',
'Karmala Town ( Karmala),Pandharpur,Maharashtra',
'Kedgaon,Pandharpur,Maharashtra',
'Kem,Pandharpur,Maharashtra',
'Kettur-II,Pandharpur,Maharashtra',
'Kolegaon ( E),Pandharpur,Maharashtra',
'Kondhej,Pandharpur,Maharashtra',
'Korti,Pandharpur,Maharashtra',
'Kugaon,Pandharpur,Maharashtra',
'Kumbhargaon,Pandharpur,Maharashtra',
'Kumbhej,Pandharpur,Maharashtra',
'Mangi,Pandharpur,Maharashtra',
'Nerle,Pandharpur,Maharashtra',
'Pande,Pandharpur,Maharashtra',
'Phisare,Pandharpur,Maharashtra',
'Pothare,Pandharpur,Maharashtra',
'Rajuri,Pandharpur,Maharashtra',
'Raogaon,Pandharpur,Maharashtra',
'Sade,Pandharpur,Maharashtra',
'Salase,Pandharpur,Maharashtra',
'Sangavi ( BK),Pandharpur,Maharashtra',
'Sawadi,Pandharpur,Maharashtra',
'Shelgaon Kekan,Pandharpur,Maharashtra',
'Sogaon,Pandharpur,Maharashtra',
'Takli Rasin,Pandharpur,Maharashtra',
'Umrad,Pandharpur,Maharashtra',
'Upalwate,Pandharpur,Maharashtra',
'Varkute,Pandharpur,Maharashtra',
'Veet,Pandharpur,Maharashtra',
'Vihal,Pandharpur,Maharashtra',
'Wadshivane,Pandharpur,Maharashtra',
'Wangi- IIi,Pandharpur,Maharashtra',
'Wangi-i,Pandharpur,Maharashtra',
'Washimbe,Pandharpur,Maharashtra',
'Zare,Pandharpur,Maharashtra',
'Nimbhore,Pandharpur,Maharashtra',
'Shetphal ( Jeur ),Pandharpur,Maharashtra',
'Adhegaon,Pandharpur,Maharashtra',
'Akole(KH),Pandharpur,Maharashtra',
'Akulgaon,Pandharpur,Maharashtra',
'Akumbhe,Pandharpur,Maharashtra',
'Anjangaon Umate,Pandharpur,Maharashtra',
'Aran,Pandharpur,Maharashtra',
'Barloni,Pandharpur,Maharashtra',
'Bembale,Pandharpur,Maharashtra',
'Bhimanagar,Pandharpur,Maharashtra',
'Bhosare,Pandharpur,Maharashtra',
'Bhutashte,Pandharpur,Maharashtra',
'Chincholi,Pandharpur,Maharashtra',
'Dahiwali,Pandharpur,Maharashtra',
'Darfal,Pandharpur,Maharashtra',
'Degaon ( Valuj ),Solapur,Maharashtra',
'Dhavlas,Pandharpur,Maharashtra',
'Jamgaon,Pandharpur,Maharashtra',
'Kanhapuri,Pandharpur,Maharashtra',
'Khairao,Solapur,Maharashtra',
'Kurdu,Pandharpur,Maharashtra',
'Kurduvadi,Pandharpur,Maharashtra',
'Laul,Pandharpur,Maharashtra',
'Madha,Pandharpur,Maharashtra',
'Mahatpur,Pandharpur,Maharashtra',
'Mahisgaon,Pandharpur,Maharashtra',
'Manegaon,Solapur,Maharashtra',
'Manegaon,Solapur,Maharashtra',
'Mauje Ujani,Pandharpur,Maharashtra',
'Modnimb,Pandharpur,Maharashtra',
'Nimgaon T,Pandharpur,Maharashtra',
'Niranarshingpur,Pandharpur,Maharashtra',
'Padasali,Pandharpur,Maharashtra',
'Parite,Pandharpur,Maharashtra',
'Pimpalkhunte,Pandharpur,Maharashtra',
'Pimpelner,Pandharpur,Maharashtra',
'Ridhore,Pandharpur,Maharashtra',
'Ropla ( Kvd ),Pandharpur,Maharashtra',
'Sapatane ( Bhose ),Pandharpur,Maharashtra',
'Sapatane T,Pandharpur,Maharashtra',
'Tadvale,Pandharpur,Maharashtra',
'Tandulwadi,Pandharpur,Maharashtra',
'Tembhurni,Pandharpur,Maharashtra',
'Undargaon,Pandharpur,Maharashtra',
'Uplai Budruk,Pandharpur,Maharashtra',
'Uplai Khurd,Pandharpur,Maharashtra',
'Vadshinge,Pandharpur,Maharashtra',
'Warwade,Pandharpur,Maharashtra',
'Bavi,Pandharpur,Maharashtra',
'Bitergaon,Pandharpur,Maharashtra',
'Ghoti,Pandharpur,Maharashtra',
'Kavhe,Pandharpur,Maharashtra',
'Nimgaon,Pandharpur,Maharashtra',
'Akluj,Pandharpur,Maharashtra',
'Bhamburdi,Pandharpur,Maharashtra',
'Bondle,Pandharpur,Maharashtra',
'Borgaon,Pandharpur,Maharashtra',
'Chandapuri,Pandharpur,Maharashtra',
'Dahigaon,Pandharpur,Maharashtra',
'Dharmapuri,Pandharpur,Maharashtra',
'Ekshiv,Pandharpur,Maharashtra',
'Girvi,Pandharpur,Maharashtra',
'Gursale,Pandharpur,Maharashtra',
'Jainwadi,Pandharpur,Maharashtra',
'Jambhood,Pandharpur,Maharashtra',
'Khandali,Pandharpur,Maharashtra',
'Khudus,Pandharpur,Maharashtra',
'Kurbavi,Pandharpur,Maharashtra',
'Lavang,Pandharpur,Maharashtra',
'Lonand,Pandharpur,Maharashtra',
'Mahalung,Pandharpur,Maharashtra',
'Malkhambi,Pandharpur,Maharashtra',
'Maloli,Pandharpur,Maharashtra',
'Mandave,Pandharpur,Maharashtra',
'Morochi,Pandharpur,Maharashtra',
'Nevare,Pandharpur,Maharashtra',
'Palashi,Pandharpur,Maharashtra',
'Paniv,Pandharpur,Maharashtra',
'Phadtari,Pandharpur,Maharashtra',
'Phondshiras,Pandharpur,Maharashtra',
'Pimpri,Pandharpur,Maharashtra',
'Purandawade,Pandharpur,Maharashtra',
'Tandulwadi,Pandharpur,Maharashtra',
'Ughadewadi,Pandharpur,Maharashtra',
'Upari,Pandharpur,Maharashtra',
'Wagholi(E),Pandharpur,Maharashtra',
'Islampur,Pandharpur,Maharashtra',
'Malinagar,Pandharpur,Maharashtra',
'Malsiras,Pandharpur,Maharashtra',
'Mandki,Pandharpur,Maharashtra',
'Medad,Pandharpur,Maharashtra',
'Natepute,Pandharpur,Maharashtra',
'Palasmandal,Pandharpur,Maharashtra',
'Piliv,Pandharpur,Maharashtra',
'Sadashivenagar,Pandharpur,Maharashtra',
'Shindewadi,Pandharpur,Maharashtra',
'Shreepur,Pandharpur,Maharashtra',
'Tambave,Pandharpur,Maharashtra',
'Tarangphal,Pandharpur,Maharashtra',
'Velapur,Pandharpur,Maharashtra',
'Yeshwantnagar,Pandharpur,Maharashtra',
'Andhalgaon,Pandharpur,Maharashtra',
'Arali,Pandharpur,Maharashtra',
'Bhalvani,Pandharpur,Maharashtra',
'Bhosa (M),Pandharpur,Maharashtra',
'Borale,Pandharpur,Maharashtra',
'Bramhapuri,Pandharpur,Maharashtra',
'Donaj,Pandharpur,Maharashtra',
'Dongargaon,Pandharpur,Maharashtra',
'Gherdi,Pandharpur,Maharashtra',
'Gunjegaon,Pandharpur,Maharashtra',
'Huljanti,Pandharpur,Maharashtra',
'Hunnur,Pandharpur,Maharashtra',
'Laxmi-dahiwadi,Pandharpur,Maharashtra',
'Lendave Chinchali,Pandharpur,Maharashtra',
'Mangalvedha,Pandharpur,Maharashtra',
'Mangalvedha Town,Pandharpur,Maharashtra',
'Marwade,Pandharpur,Maharashtra',
'Nandeshwar,Pandharpur,Maharashtra',
'Nimboni,Pandharpur,Maharashtra',
'Patkhal,Pandharpur,Maharashtra',
'Redde,Pandharpur,Maharashtra',
'Shirnandgi,Pandharpur,Maharashtra',
'Siddhapur,Pandharpur,Maharashtra',
'Nandur,Pandharpur,Maharashtra',
'Salgar BK,Pandharpur,Maharashtra',
'Shivangi,Pandharpur,Maharashtra',
'Talsangi,Pandharpur,Maharashtra',
'Shirapur (Solapur),Solapur,Maharashtra',
'Anagar,Solapur,Maharashtra',
'Anjangaon Khilobache,Solapur,Maharashtra',
'Ankoli,Solapur,Maharashtra',
'Ashti,Solapur,Maharashtra',
'Aundhi,Solapur,Maharashtra',
'Bazarpeth Mohol,Solapur,Maharashtra',
'Bitale,Solapur,Maharashtra',
'Deodi,Solapur,Maharashtra',
'Dhokbabhulgaon,Solapur,Maharashtra',
'Ekurkhe,Solapur,Maharashtra',
'Ghatane,Solapur,Maharashtra',
'Ghodeshwar,Solapur,Maharashtra',
'Gotewadi,Solapur,Maharashtra',
'Hiware,Solapur,Maharashtra',
'Ichgaon,Solapur,Maharashtra',
'Kamati Khurd,Solapur,Maharashtra',
'Khandali,Solapur,Maharashtra',
'Kolegaon,Solapur,Maharashtra',
'Konheri,Solapur,Maharashtra',
'Koravali,Solapur,Maharashtra',
'Kurul,Solapur,Maharashtra',
'Lamboti,Solapur,Maharashtra',
'Londewadi,Solapur,Maharashtra',
'Malikpeth,Solapur,Maharashtra',
'Mohol,Solapur,Maharashtra',
'Narkhed,Solapur,Maharashtra',
'Papari,Solapur,Maharashtra',
'Patkul,Solapur,Maharashtra',
'Pennur,Solapur,Maharashtra',
'Pokharapur,Solapur,Maharashtra',
'Savaleshwar,Solapur,Maharashtra',
'Sayyed Virwade,Solapur,Maharashtra',
'Shetphal,Solapur,Maharashtra',
'Sohale,Solapur,Maharashtra',
'Takali Sikandar,Solapur,Maharashtra',
'Tambole,Solapur,Maharashtra',
'Virvade,Solapur,Maharashtra',
'Wadwal,Solapur,Maharashtra',
'Wafale,Solapur,Maharashtra',
'Wakaw,Solapur,Maharashtra',
'Yawali,Solapur,Maharashtra',
'Yeoti,Solapur,Maharashtra',
'Akolekati,Solapur,Maharashtra',
'Arali,Solapur,Maharashtra',
'Ashok Chowk,Solapur,Maharashtra',
'Barur,Solapur,Maharashtra',
'Belati,Solapur,Maharashtra',
'Boramani,Solapur,Maharashtra',
'Darganhalli,Solapur,Maharashtra',
'Darphalbibi,Solapur,Maharashtra',
'Darphalgawadi,Solapur,Maharashtra',
'Dayanand Collage,Solapur,Maharashtra',
'Degaon,Solapur,Maharashtra',
'Dongaon,Solapur,Maharashtra',
'Hagloor,Solapur,Maharashtra',
'Honsal,Solapur,Maharashtra',
'Ingalgi,Solapur,Maharashtra',
'Jawaharlal Nehru Vastigrah,Solapur,Maharashtra',
'Jule Solapur,Solapur,Maharashtra',
'Kalman,Solapur,Maharashtra',
'Karamba,Solapur,Maharashtra',
'Kasegaon,Solapur,Maharashtra',
'Kauthali,Solapur,Maharashtra',
'Kavathe,Solapur,Maharashtra',
'Khuneshwar,Solapur,Maharashtra',
'Mangalwar Peth,Solapur,Maharashtra',
'Mardi,Solapur,Maharashtra',
'Market Yard Solapur,Solapur,Maharashtra',
'Masale Chaudhari,Solapur,Maharashtra',
'Medical College,Solapur,Maharashtra',
'Musti,Solapur,Maharashtra',
'Nandani,Solapur,Maharashtra',
'Navi Peth Solapur,Solapur,Maharashtra',
'Neelanagar,Solapur,Maharashtra',
'Padsali,Solapur,Maharashtra',
'Pathari,Solapur,Maharashtra',
'Ranmasale,Solapur,Maharashtra',
'S.R.P.F. Camp Solapur,Solapur,Maharashtra',
'Sadar Bazar,Solapur,Maharashtra',
'Sakhar Peth,Solapur,Maharashtra',
'Shaniwar Peth,Solapur,Maharashtra',
'Shelgaon (R),Solapur,Maharashtra',
'Sidheswar Peth,Solapur,Maharashtra',
'Takali,Solapur,Maharashtra',
'Tandulwadi,Solapur,Maharashtra',
'Tirhe,Solapur,Maharashtra',
'Ule,Solapur,Maharashtra',
'Umedpur,Solapur,Maharashtra',
'Valuj,Solapur,Maharashtra',
'Wadala,Solapur,Maharashtra',
'Honmurgi,Solapur,Maharashtra',
'Kardehalli,Solapur,Maharashtra',
'Pakani,Solapur,Maharashtra',
'Kumbhari,Solapur,Maharashtra',
'Mulegaon,Solapur,Maharashtra',
'Aurad,Solapur,Maharashtra',
'Bale,Solapur,Maharashtra',
'Daji Peth,Solapur,Maharashtra',
'Hattur,Solapur,Maharashtra',
'Hiraj,Solapur,Maharashtra',
'Indiranagar,Solapur,Maharashtra',
'Kegaon,Solapur,Maharashtra',
'Kondi,Solapur,Maharashtra',
'Midc Chincholi,Solapur,Maharashtra',
'Midc Solapur,Solapur,Maharashtra',
'Nanaj,Solapur,Maharashtra',
'Solapur City,Solapur,Maharashtra',
'Solapur Mkt,Solapur,Maharashtra',
'Soregaon,Solapur,Maharashtra',
'Zilla Nayalaya Solapur,Solapur,Maharashtra',
'Korti,Pandharpur,Maharashtra',
'Ambe,Pandharpur,Maharashtra',
'Anawali,Pandharpur,Maharashtra',
'Babhulgaon,Pandharpur,Maharashtra',
'Bardi,Pandharpur,Maharashtra',
'Bhalwani,Pandharpur,Maharashtra',
'Bhandishegaon,Pandharpur,Maharashtra',
'Bhosa (K),Pandharpur,Maharashtra',
'Chale,Pandharpur,Maharashtra',
'Degaon (PPR),Pandharpur,Maharashtra',
'Gadegaon,Pandharpur,Maharashtra',
'Gopalpur,Pandharpur,Maharashtra',
'Gursale,Pandharpur,Maharashtra',
'Hole,Pandharpur,Maharashtra',
'Karkam,Pandharpur,Maharashtra',
'Kasegaon,Pandharpur,Maharashtra',
'Khardi,Pandharpur,Maharashtra',
'Mahadawar( Pandharpur),Pandharpur,Maharashtra',
'Manishanagar(Pandharpur),Pandharpur,Maharashtra',
'Mendhapur,Pandharpur,Maharashtra',
'Mundhewadi,Pandharpur,Maharashtra',
'Navi Peth (Pandharpur),Pandharpur,Maharashtra',
'Ozewadi,Pandharpur,Maharashtra',
'Pandharechiwadi,Pandharpur,Maharashtra',
'Pandharpur H.O,Pandharpur,Maharashtra',
'Patwardhan Kuroli,Pandharpur,Maharashtra',
'Phulchincholi,Pandharpur,Maharashtra',
'Puluj,Pandharpur,Maharashtra',
'Ranjani,Pandharpur,Maharashtra',
'Sarkoli,Pandharpur,Maharashtra',
'Shelve,Pandharpur,Maharashtra',
'Shevate,Pandharpur,Maharashtra',
'Siddhewadi,Pandharpur,Maharashtra',
'Sonka,Pandharpur,Maharashtra',
'Suste,Pandharpur,Maharashtra',
'Tarapur,Pandharpur,Maharashtra',
'Tawashi,Pandharpur,Maharashtra',
'Tulshi,Pandharpur,Maharashtra',
'Tungat,Pandharpur,Maharashtra',
'Umbare (Karkam ),Pandharpur,Maharashtra',
'Wakhari,Pandharpur,Maharashtra',
'Achegaon,Solapur,Maharashtra',
'Dhotri,Solapur,Maharashtra',
'Karjal,Solapur,Maharashtra',
'Limbi Chincholi,Solapur,Maharashtra',
'Shingadgaon,Solapur,Maharashtra',
'Achakdani,Pandharpur,Maharashtra',
'Ajnale,Pandharpur,Maharashtra',
'Akola Wasud,Pandharpur,Maharashtra',
'Alegaon,Pandharpur,Maharashtra',
'Balwadi,Pandharpur,Maharashtra',
'Bohali,Pandharpur,Maharashtra',
'Chikmahud,Pandharpur,Maharashtra',
'Chincholi,Pandharpur,Maharashtra',
'Chinke,Pandharpur,Maharashtra',
'Chopadi,Pandharpur,Maharashtra',
'Dhyati (E),Pandharpur,Maharashtra',
'Dongargaon,Pandharpur,Maharashtra',
'Ekhatpur,Pandharpur,Maharashtra',
'Gaigavan,Pandharpur,Maharashtra',
'Gardi,Pandharpur,Maharashtra',
'Gaudwadi,Pandharpur,Maharashtra',
'Hatid,Pandharpur,Maharashtra',
'Jawala,Pandharpur,Maharashtra',
'Junoni,Pandharpur,Maharashtra',
'Kadlas,Pandharpur,Maharashtra',
'Kamalapur,Pandharpur,Maharashtra',
'Katphal,Pandharpur,Maharashtra',
'Khavaspur,Pandharpur,Maharashtra',
'Kole,Pandharpur,Maharashtra',
'Kolegaon,Pandharpur,Maharashtra',
'Lonvire,Pandharpur,Maharashtra',
'Lotewadi,Pandharpur,Maharashtra',
'Mahim,Pandharpur,Maharashtra',
'Mahud,Pandharpur,Maharashtra',
'Manjari,Pandharpur,Maharashtra',
'Medshingi,Pandharpur,Maharashtra',
'Methawade,Pandharpur,Maharashtra',
'Nazara,Pandharpur,Maharashtra',
'Pachegaon (BK),Pandharpur,Maharashtra',
'Pachegaon,Pandharpur,Maharashtra',
'Pare,Pandharpur,Maharashtra',
'Rajuri,Pandharpur,Maharashtra',
'Sangewadi,Pandharpur,Maharashtra',
'Sangola,Pandharpur,Maharashtra',
'Save,Pandharpur,Maharashtra',
'Shetphal,Pandharpur,Maharashtra',
'Shirbhavi,Pandharpur,Maharashtra',
'Shivane,Pandharpur,Maharashtra',
'Sonand,Pandharpur,Maharashtra',
'Udanwadi,Pandharpur,Maharashtra',
'Wadhegaon,Pandharpur,Maharashtra',
'Waki,Pandharpur,Maharashtra',
'Waki(Sangola),Pandharpur,Maharashtra',
'Watambre,Pandharpur,Maharashtra',
'Yelmarmangewadi,Pandharpur,Maharashtra',
'Sangola Town (Sangola),Pandharpur,Maharashtra',
'Hangirge,Pandharpur,Maharashtra',
'Phalwani,Pandharpur,Maharashtra',
'Solapur H.O,Solapur,Maharashtra',
'Aherwadi,Solapur,Maharashtra',
'Antroli,Solapur,Maharashtra',
'Auj,Solapur,Maharashtra',
'Bhandar Kavathe,Solapur,Maharashtra',
'Gunjegaon,Solapur,Maharashtra',
'Hotagi,Solapur,Maharashtra',
'Hotgigaon,Solapur,Maharashtra',
'Kanbus (Gangadhar),Solapur,Maharashtra',
'Kandalgaon,Solapur,Maharashtra',
'Kusur,Solapur,Maharashtra',
'Malkavathe,Solapur,Maharashtra',
'Mandrup,Solapur,Maharashtra',
'Nimbargi,Solapur,Maharashtra',
'Suler Jawalage,Solapur,Maharashtra',
'Valsang,Solapur,Maharashtra',
'Vinchur,Solapur,Maharashtra',
'Wangi,Solapur,Maharashtra',
'Kumathe,Solapur,Maharashtra',
'Shivshahi,Solapur,Maharashtra',
'Tikekarwadi,Solapur,Maharashtra',
'Konkan Bhavan,Navi Mumbai,Maharashtra',
'Milleniu,m Business Park,Navi Mumbai,Maharashtra',
'Nerul Node-II,Navi Mumbai,Maharashtra',
'Nerul Sec-48,Navi Mumbai,Maharashtra',
'Vashi Sec-26,Navi Mumbai,Maharashtra',
'Belapur Node- V,Navi Mumbai,Maharashtra',
'K.U.Bazar,Navi Mumbai,Maharashtra',
'Kopar Khairne,Navi Mumbai,Maharashtra',
'Nerul Node-III,Navi Mumbai,Maharashtra',
'Turbhe Market,Navi Mumbai,Maharashtra',
'Turbhe,Navi Mumbai,Maharashtra',
'Vashi,Navi Mumbai,Maharashtra',
'Vashi-VII,Navi Mumbai,Maharashtra',
'Belapur Node-- III,Navi Mumbai,Maharashtra',
'Bassein Road,Thane West,Maharashtra',
'Bassein,Thane West,Maharashtra',
'Amane,Thane Central,Maharashtra',
'Angaon,Thane Central,Maharashtra',
'Anjur,Thane Central,Maharashtra',
'Bhiwandi,Thane Central,Maharashtra',
'Chimbipada,Thane Central,Maharashtra',
'Chinchwali,Thane Central,Maharashtra',
'Dabhad,Thane Central,Maharashtra',
'Dandekarwadi,Thane Central,Maharashtra',
'Dighashi,Thane Central,Maharashtra',
'Dugad,Thane Central,Maharashtra',
'Dunge,Thane Central,Maharashtra',
'Ganeshpuri,Thane West,Maharashtra',
'Kalher,Thane Central,Maharashtra',
'Kharbav,Thane Central,Maharashtra',
'Kon,Thane Central,Maharashtra',
'Kunde,Thane Central,Maharashtra',
'Lonad,Thane Central,Maharashtra',
'Mahapoli,Thane Central,Maharashtra',
'Pachhapur,Thane Central,Maharashtra',
'Padgha,Thane Central,Maharashtra',
'Paye,Thane Central,Maharashtra',
'Pimplas,Thane Central,Maharashtra',
'Rehnal,Thane Central,Maharashtra',
'Saravali,Thane Central,Maharashtra',
'Shantinagar,Thane Central,Maharashtra',
'Shastrinagar,Thane Central,Maharashtra',
'Shelar,Thane Central,Maharashtra',
'Vadavali,Thane Central,Maharashtra',
'Vadpe,Thane Central,Maharashtra',
'Vajreshwari,Thane West,Maharashtra',
'Vidyashram,Thane Central,Maharashtra',
'Bordi,Thane West,Maharashtra',
'Chinchani,Thane West,Maharashtra',
'Dahanu Road,Thane West,Maharashtra',
'Dahanu,Thane West,Maharashtra',
'Dahanu TPS,Thane West,Maharashtra',
'Dapchari,Thane West,Maharashtra',
'Gholvad,Thane West,Maharashtra',
'Kasa,Thane West,Maharashtra',
'Kosbad-hill,Thane West,Maharashtra',
'Suryanagar,Thane West,Maharashtra',
'Jawhar,Thane West,Maharashtra',
'Additional Ambernath,Thane Central,Maharashtra',
'Aghai,Thane Central,Maharashtra',
'Ambarje,Thane Central,Maharashtra',
'Ambernath,Thane Central,Maharashtra',
'Ambernath South,Thane Central,Maharashtra',
'Asangaon,Thane Central,Maharashtra',
'Atali,Thane Central,Maharashtra',
'Atgaon,Thane Central,Maharashtra',
'Badlapur,Thane Central,Maharashtra',
'Bhaji Market,Thane Central,Maharashtra',
'Bhatsanagar,Thane Central,Maharashtra',
'Bunder Road,Thane Central,Maharashtra',
'Chande,Thane Central,Maharashtra',
'Dalkhan,Thane Central,Maharashtra',
'Dombivali I.A.,Thane Central,Maharashtra',
'Dombivali,Thane Central,Maharashtra',
'Dwarli,Thane Central,Maharashtra',
'Ganeshwadi,Thane Central,Maharashtra',
'Jambhul,Thane Central,Maharashtra',
'Kalamgaon,Thane Central,Maharashtra',
'Kalyan City H.O,Thane Central,Maharashtra',
'Kalyan D.C.,Thane Central,Maharashtra',
'Kalyan Rs,Thane Central,Maharashtra',
'Katemanivali,Thane Central,Maharashtra',
'Khadvali,Thane Central,Maharashtra',
'Khardi,Thane Central,Maharashtra',
'Khoni,Thane Central,Maharashtra',
'Mamnoli,Thane Central,Maharashtra',
'Manda,Thane Central,Maharashtra',
'Mangrul,Thane Central,Maharashtra',
'Manivail,Thane Central,Maharashtra',
'Manpada,Thane Central,Maharashtra',
'Mohone,Thane Central,Maharashtra',
'Nilje,Thane Central,Maharashtra',
'Padle,Thane Central,Maharashtra',
'Phalegaon,Thane Central,Maharashtra',
'Piwali,Thane Central,Maharashtra',
'Ramnagar,Thane Central,Maharashtra',
'Rayate,Thane Central,Maharashtra',
'Shahad,Thane Central,Maharashtra',
'Shere,Thane Central,Maharashtra',
'Subhash Road,Thane Central,Maharashtra',
'Tansa,Thane Central,Maharashtra',
'Tilaknagar,Thane Central,Maharashtra',
'Titwala,Thane Central,Maharashtra',
'Vadi,Thane Central,Maharashtra',
'Vaholi,Thane Central,Maharashtra',
'Vaitarna,Thane Central,Maharashtra',
'Varap,Thane Central,Maharashtra',
'Vehele,Thane Central,Maharashtra',
'Vehloli,Thane Central,Maharashtra',
'Vishnunagar,Thane Central,Maharashtra',
'Mokhada,Thane West,Maharashtra',
'Kasegaon,Thane Central,Maharashtra',
'Khutal Baragaon,Thane Central,Maharashtra',
'Kishore,Thane Central,Maharashtra',
'Kolthan,Thane Central,Maharashtra',
'Majgaon,Thane Central,Maharashtra',
'Mhasa,Thane Central,Maharashtra',
'Milhe,Thane Central,Maharashtra',
'Moroshi,Thane Central,Maharashtra',
'Murbad I.A.,Thane Central,Maharashtra',
'Murbad,Thane Central,Maharashtra',
'Narivali,Thane Central,Maharashtra',
'Patgaon,Thane Central,Maharashtra',
'Saralgaon,Thane Central,Maharashtra',
'Sasne,Thane Central,Maharashtra',
'Sayale,Thane Central,Maharashtra',
'Shivale,Thane Central,Maharashtra',
'Talegaon,Thane Central,Maharashtra',
'Tulai,Thane Central,Maharashtra',
'Boisar,Thane West,Maharashtra',
'Kelwa,Thane West,Maharashtra',
'Kelwa-mahim,Thane West,Maharashtra',
'Manor,Thane West,Maharashtra',
'Palghar H.O,Thane West,Maharashtra',
'Satpati,Thane West,Maharashtra',
'Tarapur App,Thane West,Maharashtra',
'Tarapur,Thane West,Maharashtra',
'Tarapur Ti,Thane West,Maharashtra',
'Umbarpada,Thane West,Maharashtra',
'Vangaon,Thane West,Maharashtra',
'Ghansoli,Navi Mumbai,Maharashtra',
'Alyani,Thane Central,Maharashtra',
'Andad,Thane Central,Maharashtra',
'Aware,Thane Central,Maharashtra',
'Chondhe Colony,Thane Central,Maharashtra',
'Dhasai,Thane Central,Maharashtra',
'Dhasai,Thane Central,Maharashtra',
'Dolkhamb,Thane Central,Maharashtra',
'Gegaon,Thane Central,Maharashtra',
'Gunde,Thane Central,Maharashtra',
'Kasara,Thane Central,Maharashtra',
'Kharade,Thane Central,Maharashtra',
'Kharid,Thane Central,Maharashtra',
'Kharivali,Thane Central,Maharashtra',
'Khutghar,Thane Central,Maharashtra',
'Kinholi,Thane Central,Maharashtra',
'Lenad Khurd,Thane Central,Maharashtra',
'Malegaon,Thane Central,Maharashtra',
'Mugaon,Thane Central,Maharashtra',
'Nandgaon,Thane Central,Maharashtra',
'Sakadbav,Thane Central,Maharashtra',
'Sakurli,Thane Central,Maharashtra',
'Saralambe,Thane Central,Maharashtra',
'Sawaroli,Thane Central,Maharashtra',
'Shahapur,Thane Central,Maharashtra',
'Shenwa,Thane Central,Maharashtra',
'Shirgaon,Thane Central,Maharashtra',
'Sogaon,Thane Central,Maharashtra',
'Tembhurli,Thane Central,Maharashtra',
'Thune,Thane Central,Maharashtra',
'Vashind,Thane Central,Maharashtra',
'Vehloli,Thane Central,Maharashtra',
'Talasari,Thane West,Maharashtra',
'Airoli,Navi Mumbai,Maharashtra',
'Apna Bazar,Thane Central,Maharashtra',
'Balkum,Thane Central,Maharashtra',
'Bhayander East,Thane West,Maharashtra',
'Bhayander West,Thane West,Maharashtra',
'Chitalsar Manpada,Thane Central,Maharashtra',
'Dahisar,Thane Central,Maharashtra',
'Darave,Navi Mumbai,Maharashtra',
'Dawle,Thane Central,Maharashtra',
'Diwa,Thane Central,Maharashtra',
'Gokhale Road,Thane Central,Maharashtra',
'Jekegram,Thane Central,Maharashtra',
'Kalwa,Thane Central,Maharashtra',
'Kasarvadavali,Thane Central,Maharashtra',
'Kausa,Thane Central,Maharashtra',
'Kopri Colony,Thane Central,Maharashtra',
'Mira Road,Thane West,Maharashtra',
'Mira,Thane West,Maharashtra',
'Mumbra,Thane Central,Maharashtra',
'Naupada,Thane Central,Maharashtra',
'Sandozbaugh,Thane Central,Maharashtra',
'Shrirangnagar,Thane Central,Maharashtra',
'Tapasenagar,Thane Central,Maharashtra',
'Thane Bazar,Thane Central,Maharashtra',
'Thane East,Thane Central,Maharashtra',
'Thane H.O,Thane Central,Maharashtra',
'Thane R.S.,Thane Central,Maharashtra',
'Uttan,Thane West,Maharashtra',
'Wagle I.E.,Thane Central,Maharashtra',
'Waklan,Thane Central,Maharashtra',
'Bus Terminus,Thane Central,Maharashtra',
'Kansai,Thane Central,Maharashtra',
'Kulgaon,Thane Central,Maharashtra',
'Netaji Bazar,Thane Central,Maharashtra',
'O.E.Ambernath,Thane Central,Maharashtra',
'Station Road Unr-3,Thane Central,Maharashtra',
'Ulhasnagar-1,Thane Central,Maharashtra',
'Ulhasnagar-2,Thane Central,Maharashtra',
'Ulhasnagar-4,Thane Central,Maharashtra',
'Ulhasnagar-5,Thane Central,Maharashtra',
'Agashi,Thane West,Maharashtra',
'Arnala,Thane West,Maharashtra',
'Nallosapare E,Thane West,Maharashtra',
'Nirmal,Thane West,Maharashtra',
'Papdi,Thane West,Maharashtra',
'Sopara,Thane West,Maharashtra',
'Vasai East IE,Thane West,Maharashtra',
'Vasai Road E,Thane West,Maharashtra',
'Virar East,Thane West,Maharashtra',
'Virar,Thane West,Maharashtra',
'Vikramgad,Thane West,Maharashtra',
'Chamble,Thane Central,Maharashtra',
'Kondhale,Thane Central,Maharashtra',
'Kudus,Thane Central,Maharashtra',
'Met,Thane Central,Maharashtra',
'Nehroli,Thane Central,Maharashtra',
'Palsai,Thane Central,Maharashtra',
'Uchat,Thane Central,Maharashtra',
'Wada,Thane West,Maharashtra',
'Khupri,Thane Central,Maharashtra',
'Arvi,Wardha,Maharashtra',
'Bokenagar,Wardha,Maharashtra',
'Borgaon Hatla,Wardha,Maharashtra',
'Chincholi Dange,Wardha,Maharashtra',
'Chistur,Wardha,Maharashtra',
'Dahegaon Gondi,Wardha,Maharashtra',
'Dahegaon Mustafa,Wardha,Maharashtra',
'Deorwara,Wardha,Maharashtra',
'Dhanodi Bahaddarpur,Wardha,Maharashtra',
'Jalgaon,Wardha,Maharashtra',
'Jamalpur,Wardha,Maharashtra',
'Jasapur,Wardha,Maharashtra',
'Kachnoor,Wardha,Maharashtra',
'Kasarkheda,Wardha,Maharashtra',
'Kharangna,Wardha,Maharashtra',
'Khubgaon,Wardha,Maharashtra',
'Malegaon Theka,Wardha,Maharashtra',
'Masod,Wardha,Maharashtra',
'Nandpur,Wardha,Maharashtra',
'Neri Mirzapur,Wardha,Maharashtra',
'Nimboli,Wardha,Maharashtra',
'Panwadi,Wardha,Maharashtra',
'Pardi,Wardha,Maharashtra',
'Pimpalkhuta,Wardha,Maharashtra',
'Pipri Pargothan,Wardha,Maharashtra',
'Rasulabad,Wardha,Maharashtra',
'Rohana,Wardha,Maharashtra',
'Sawali BK,Wardha,Maharashtra',
'Sorta,Wardha,Maharashtra',
'Takarkheda,Wardha,Maharashtra',
'Virul,Wardha,Maharashtra',
'Wadhona,Wardha,Maharashtra',
'Wardhamaneri,Wardha,Maharashtra',
'Antora,Wardha,Maharashtra',
'Ashti,Wardha,Maharashtra',
'Bharaswara,Wardha,Maharashtra',
'Bhishnoor,Wardha,Maharashtra',
'Borgaon Tumni,Wardha,Maharashtra',
'Delwadi,Wardha,Maharashtra',
'Khadki,Wardha,Maharashtra',
'Lahan Arvi,Wardha,Maharashtra',
'Manikwara,Wardha,Maharashtra',
'Sahur,Wardha,Maharashtra',
'Talegaon (SP),Wardha,Maharashtra',
'Tarasawanga,Wardha,Maharashtra',
'Wadala,Wardha,Maharashtra',
'Agargaon,Wardha,Maharashtra',
'Andori,Wardha,Maharashtra',
'Bhidi,Wardha,Maharashtra',
'Chikni,Wardha,Maharashtra',
'Dahegaon Dhande,Wardha,Maharashtra',
'Deoli,Wardha,Maharashtra',
'Gaul,Wardha,Maharashtra',
'Giroli,Wardha,Maharashtra',
'Inzhala,Wardha,Maharashtra',
'Kandegaon,Wardha,Maharashtra',
'Kangaon,Wardha,Maharashtra',
'Kaotha,Wardha,Maharashtra',
'Kapsi,Wardha,Maharashtra',
'Khangaon,Wardha,Maharashtra',
'Mozari,Wardha,Maharashtra',
'Nachangaon,Wardha,Maharashtra',
'Nagzari,Wardha,Maharashtra',
'Nandora Dafre,Wardha,Maharashtra',
'Padegaon,Wardha,Maharashtra',
'Pimpalgaon Lute,Wardha,Maharashtra',
'Pulgaon Camp,Wardha,Maharashtra',
'Pulgaon,Wardha,Maharashtra',
'Rohani,Wardha,Maharashtra',
'Selsura,Wardha,Maharashtra',
'Shirpur,Wardha,Maharashtra',
'Sonegaon Abaji,Wardha,Maharashtra',
'Sonora,Wardha,Maharashtra',
'Vijaygopal,Wardha,Maharashtra',
'Wabgaon,Wardha,Maharashtra',
'Watkhed,Wardha,Maharashtra',
'Ajansara,Wardha,Maharashtra',
'Allipur,Wardha,Maharashtra',
'Arvi Chhoti,Wardha,Maharashtra',
'Bela,Wardha,Maharashtra',
'Bhankheda,Wardha,Maharashtra',
'Chincholi,Wardha,Maharashtra',
'Daroda,Wardha,Maharashtra',
'Dhotra,Wardha,Maharashtra',
'Dongargaon,Wardha,Maharashtra',
'Goji,Wardha,Maharashtra',
'Hinganghat,Wardha,Maharashtra',
'Hinganghat Town,Wardha,Maharashtra',
'Jam,Wardha,Maharashtra',
'Kandhali,Wardha,Maharashtra',
'Khandala,Wardha,Maharashtra',
'Kora,Wardha,Maharashtra',
'Mangrul Dasoda,Wardha,Maharashtra',
'Nandori,Wardha,Maharashtra',
'Nimbha,Wardha,Maharashtra',
'Pardi (Nagaji),Wardha,Maharashtra',
'Pipri,Wardha,Maharashtra',
'Pohana,Wardha,Maharashtra',
'Sawali Wagh,Wardha,Maharashtra',
'Shegaon Kund,Wardha,Maharashtra',
'Shekapur Bai,Wardha,Maharashtra',
'Sirasgaon Bazar,Wardha,Maharashtra',
'Wadner,Wardha,Maharashtra',
'Wagholi,Wardha,Maharashtra',
'Washi,Wardha,Maharashtra',
'Yerala,Wardha,Maharashtra',
'Kajalsara,Wardha,Maharashtra',
'Chincholi,Wardha,Maharashtra',
'Dhanoli,Wardha,Maharashtra',
'Junapani,Wardha,Maharashtra',
'Kajali,Wardha,Maharashtra',
'Kakda,Wardha,Maharashtra',
'Kannamwargram,Wardha,Maharashtra',
'Karanja,Wardha,Maharashtra',
'Nara,Wardha,Maharashtra',
'Sarwadi,Wardha,Maharashtra',
'Sawali Khurd,Wardha,Maharashtra',
'Sindi Vihiri,Wardha,Maharashtra',
'Thanegaon,Wardha,Maharashtra',
'Umri,Wardha,Maharashtra',
'Bothuda,Wardha,Maharashtra',
'Girad,Wardha,Maharashtra',
'Hamdapur,Wardha,Maharashtra',
'Samudrapur,Wardha,Maharashtra',
'Taroda,Wardha,Maharashtra',
'Waigaon Gond,Wardha,Maharashtra',
'Waigaon Haldya,Wardha,Maharashtra',
'Mandgaon,Wardha,Maharashtra',
'Akoli,Wardha,Maharashtra',
'Bori,Wardha,Maharashtra',
'Dahegaon Gosavi,Wardha,Maharashtra',
'Ghorad,Wardha,Maharashtra',
'Hingani,Wardha,Maharashtra',
'Junona,Wardha,Maharashtra',
'Juwadi,Wardha,Maharashtra',
'Kelzar,Wardha,Maharashtra',
'Khapari,Wardha,Maharashtra',
'Kopra,Wardha,Maharashtra',
'Kotamba,Wardha,Maharashtra',
'Mahabala,Wardha,Maharashtra',
'Rehaki Kala,Wardha,Maharashtra',
'Salaipevath,Wardha,Maharashtra',
'Seldoha,Wardha,Maharashtra',
'Seloo,Wardha,Maharashtra',
'Sindi,Wardha,Maharashtra',
'Sindi Shahar,Wardha,Maharashtra',
'Sukli Station,Wardha,Maharashtra',
'Surgaon,Wardha,Maharashtra',
'Yelakeli,Wardha,Maharashtra',
'Zadsi,Wardha,Maharashtra',
'Akpo Wardha,Wardha,Maharashtra',
'Anji,Wardha,Maharashtra',
'Borgaon Meghe,Wardha,Maharashtra',
'Cottom Market,Wardha,Maharashtra',
'Dahegaon Gawande,Wardha,Maharashtra',
'Dahegaon Miskin,Wardha,Maharashtra',
'Dattapur,Wardha,Maharashtra',
'Gopuri,Wardha,Maharashtra',
'Hindinagar,Wardha,Maharashtra',
'Indira Market-Wardha,Wardha,Maharashtra',
'Kharangna Gode,Wardha,Maharashtra',
'Madni Karanji,Wardha,Maharashtra',
'Manas Mandir-Wardha,Wardha,Maharashtra',
'Mandwa,Wardha,Maharashtra',
'Nalwadi,Wardha,Maharashtra',
'Paloti,Wardha,Maharashtra',
'Paunar,Wardha,Maharashtra',
'Paunoor,Wardha,Maharashtra',
'Pipri Meghe,Wardha,Maharashtra',
'Ramnagar-Wardha,Wardha,Maharashtra',
'Rt Road Tso Wardha,Wardha,Maharashtra',
'Salod Hirapur,Wardha,Maharashtra',
'Sawangi Meghe,Wardha,Maharashtra',
'Seloo Kate,Wardha,Maharashtra',
'Sewagram,Wardha,Maharashtra',
'Sukali Bai,Wardha,Maharashtra',
'Talegaon Talatule,Wardha,Maharashtra',
'Waifad,Wardha,Maharashtra',
'Waigaon Nipani,Wardha,Maharashtra',
'Wardha Ganj,Wardha,Maharashtra',
'Wardha H.O,Wardha,Maharashtra',
'Wardha Market,Wardha,Maharashtra',
'Yac Wardha,Wardha,Maharashtra',
'Zadgaon Gosavi,Wardha,Maharashtra',
'Kamargaon,Akola,Maharashtra',
'Ansing,Akola,Maharashtra',
'Bhatumra,Akola,Maharashtra',
'Chinchambapen,Akola,Maharashtra',
'Chivara,Akola,Maharashtra',
'Dhumka,Akola,Maharashtra',
'Gobhani,Akola,Maharashtra',
'Gowardhan,Akola,Maharashtra',
'Kajalamba,Akola,Maharashtra',
'Kalamba Mahali,Akola,Maharashtra',
'Karanja,Akola,Maharashtra',
'Karanji,Akola,Maharashtra',
'Karli,Akola,Maharashtra',
'Kata,Akola,Maharashtra',
'Kekatumara,Akola,Maharashtra',
'Keshavnagar,Akola,Maharashtra',
'Khandala Shinde,Akola,Maharashtra',
'Kokalgaon,Akola,Maharashtra',
'Lehani,Akola,Maharashtra',
'Linga Kotwal,Akola,Maharashtra',
'Mangrulzanak,Akola,Maharashtra',
'Masalapen,Akola,Maharashtra',
'Medshi,Akola,Maharashtra',
'Mohoja,Akola,Maharashtra',
'Navali,Akola,Maharashtra',
'Netansa,Akola,Maharashtra',
'Pardi Takmore,Akola,Maharashtra',
'Sirpur,Akola,Maharashtra',
'Soyata,Akola,Maharashtra',
'Tamsi,Akola,Maharashtra',
'Tandali BK,Akola,Maharashtra',
'Tandali Shewai,Akola,Maharashtra',
'Tiwali,Akola,Maharashtra',
'Tondgaon,Akola,Maharashtra',
'Tornala,Akola,Maharashtra',
'Ukali Jahangir,Akola,Maharashtra',
'Wasari,Akola,Maharashtra',
'Washim City,Akola,Maharashtra',
'Washim,Akola,Maharashtra',
'Yeota,Akola,Maharashtra',
'Yeranda,Akola,Maharashtra',
'Sukli Jehangir,Yeotmal,Maharashtra',
'Arni,Yeotmal,Maharashtra',
'Ayata,Yeotmal,Maharashtra',
'Bhamb Raja,Yeotmal,Maharashtra',
'Bhansara,Yeotmal,Maharashtra',
'Borgaon Vitholi,Yeotmal,Maharashtra',
'Chikhli Izara,Yeotmal,Maharashtra',
'Dabhadi,Yeotmal,Maharashtra',
'Datodi,Yeotmal,Maharashtra',
'Jawala,Yeotmal,Maharashtra',
'Kawatha Bazar,Yeotmal,Maharashtra',
'Khedbid,Yeotmal,Maharashtra',
'Lonbehel,Yeotmal,Maharashtra',
'Mahalungi,Yeotmal,Maharashtra',
'Nakapardi,Yeotmal,Maharashtra',
'Pahur Naskari,Yeotmal,Maharashtra',
'Palsi,Yeotmal,Maharashtra',
'Rani Dhanora,Yeotmal,Maharashtra',
'Sakur,Yeotmal,Maharashtra',
'Sawali Sadoba,Yeotmal,Maharashtra',
'Sheloo,Yeotmal,Maharashtra',
'Sukli,Yeotmal,Maharashtra',
'Talni,Yeotmal,Maharashtra',
'Umri Kap,Yeotmal,Maharashtra',
'Babhulgaon,Yeotmal,Maharashtra',
'Dabha (Pahur),Yeotmal,Maharashtra',
'Dighi,Yeotmal,Maharashtra',
'Falegaon,Yeotmal,Maharashtra',
'Ganori,Yeotmal,Maharashtra',
'Gharfal,Yeotmal,Maharashtra',
'Kharda,Yeotmal,Maharashtra',
'Kotamba,Yeotmal,Maharashtra',
'Madni,Yeotmal,Maharashtra',
'Naigaon,Yeotmal,Maharashtra',
'Pachkhed,Yeotmal,Maharashtra',
'Pahur (Dabha),Yeotmal,Maharashtra',
'Pimpalkhuta,Yeotmal,Maharashtra',
'Rani Amravati,Yeotmal,Maharashtra',
'Sarul,Yeotmal,Maharashtra',
'Veni Kasba,Yeotmal,Maharashtra',
'Watkhed,Yeotmal,Maharashtra',
'Bhandegaon,Yeotmal,Maharashtra',
'Bhulai,Yeotmal,Maharashtra',
'Bori Arab,Yeotmal,Maharashtra',
'Chikhali Ramnath,Yeotmal,Maharashtra',
'Daheli,Yeotmal,Maharashtra',
'Darwha,Yeotmal,Maharashtra',
'Deurwadi Lad,Yeotmal,Maharashtra',
'Dhamangaon Deo,Yeotmal,Maharashtra',
'Fubgaon Kharbi,Yeotmal,Maharashtra',
'Gondegaon,Yeotmal,Maharashtra',
'Haru,Yeotmal,Maharashtra',
'Hatola,Yeotmal,Maharashtra',
'Karajgaon,Yeotmal,Maharashtra',
'Khopadi BK,Yeotmal,Maharashtra',
'Ladkhed,Yeotmal,Maharashtra',
'Lakh Khind,Yeotmal,Maharashtra',
'Lohi,Yeotmal,Maharashtra',
'Loni,Yeotmal,Maharashtra',
'Mahagaon Kasba,Yeotmal,Maharashtra',
'Mang Kinhi,Yeotmal,Maharashtra',
'Mohatoli,Yeotmal,Maharashtra',
'Mozar Izara,Yeotmal,Maharashtra',
'Pimpalkhuta (R),Yeotmal,Maharashtra',
'Ramgaon Rameshwar,Yeotmal,Maharashtra',
'Shelodi,Yeotmal,Maharashtra',
'Shendri (Bk) B..,Yeotmal,Maharashtra',
'Talegaon Deshmukh,Yeotmal,Maharashtra',
'Tarnoli,Yeotmal,Maharashtra',
'Wadgaon Gadhwe,Yeotmal,Maharashtra',
'Arambhi,Yeotmal,Maharashtra',
'Dehni,Yeotmal,Maharashtra',
'Deurwada,Yeotmal,Maharashtra',
'Digras,Yeotmal,Maharashtra',
'Harsul,Yeotmal,Maharashtra',
'Kalgaon,Yeotmal,Maharashtra',
'Kandali,Yeotmal,Maharashtra',
'Lakh Rayachi,Yeotmal,Maharashtra',
'Mal Hivara,Yeotmal,Maharashtra',
'Mokh,Yeotmal,Maharashtra',
'Sakhara Wai,Yeotmal,Maharashtra',
'Singad,Yeotmal,Maharashtra',
'Tiwari,Yeotmal,Maharashtra',
'Tuptakli,Yeotmal,Maharashtra',
'Vasant Nagar,Yeotmal,Maharashtra',
'Vithala,Yeotmal,Maharashtra',
'Akola Bazar,Yeotmal,Maharashtra',
'Anji (Nrusinha),Yeotmal,Maharashtra',
'Arali,Yeotmal,Maharashtra',
'Chikhalwardha,Yeotmal,Maharashtra',
'Deodhari,Yeotmal,Maharashtra',
'Ghatanji,Yeotmal,Maharashtra',
'Ghoti,Yeotmal,Maharashtra',
'Jamb,Yeotmal,Maharashtra',
'Kurli,Yeotmal,Maharashtra',
'Mowada,Yeotmal,Maharashtra',
'Pandhurna Khurd,Yeotmal,Maharashtra',
'Pardi Naskari,Yeotmal,Maharashtra',
'Parwa,Yeotmal,Maharashtra',
'Patapangra,Yeotmal,Maharashtra',
'Pimpri Buti,Yeotmal,Maharashtra',
'Rajurwadi,Yeotmal,Maharashtra',
'Saikhada BK,Yeotmal,Maharashtra',
'Sakhra Khurd,Yeotmal,Maharashtra',
'Sayat Kharda,Yeotmal,Maharashtra',
'Shiroli,Yeotmal,Maharashtra',
'Shivani,Yeotmal,Maharashtra',
'Tadsawali,Yeotmal,Maharashtra',
'Waghar Takli,Yeotmal,Maharashtra',
'Yelabara,Yeotmal,Maharashtra',
'Zatala,Yeotmal,Maharashtra',
'Patanbori,Yeotmal,Maharashtra',
'Ashti,Yeotmal,Maharashtra',
'Dhotra,Yeotmal,Maharashtra',
'Dongarkharda,Yeotmal,Maharashtra',
'Jodmoha,Yeotmal,Maharashtra',
'Kalamb,Yeotmal,Maharashtra',
'Katri,Yeotmal,Maharashtra',
'Nanza,Yeotmal,Maharashtra',
'Pahur Izara,Yeotmal,Maharashtra',
'Pardi (Sawlapur),Yeotmal,Maharashtra',
'Pimpalgaon Raja,Yeotmal,Maharashtra',
'Sawargaon,Yeotmal,Maharashtra',
'Sonegaon,Yeotmal,Maharashtra',
'Veni (Kotha),Yeotmal,Maharashtra',
'Akhada Ward(Pandharkawada),Yeotmal,Maharashtra',
'Wai,Yeotmal,Maharashtra',
'Akoli,Yeotmal,Maharashtra',
'Both,Yeotmal,Maharashtra',
'Chalbardi,Yeotmal,Maharashtra',
'Chanakha,Yeotmal,Maharashtra',
'Dabha,Yeotmal,Maharashtra',
'Dharna,Yeotmal,Maharashtra',
'Dhoki,Yeotmal,Maharashtra',
'Karanji,Yeotmal,Maharashtra',
'Kelapur,Yeotmal,Maharashtra',
'Mangurda,Yeotmal,Maharashtra',
'Mohda,Yeotmal,Maharashtra',
'Munzala,Yeotmal,Maharashtra',
'Pahapal,Yeotmal,Maharashtra',
'Pandharkawda,Yeotmal,Maharashtra',
'Pimpri,Yeotmal,Maharashtra',
'Runza,Yeotmal,Maharashtra',
'Saikheda,Yeotmal,Maharashtra',
'Shibala,Yeotmal,Maharashtra',
'Sonbardi,Yeotmal,Maharashtra',
'Sunna,Yeotmal,Maharashtra',
'Umari Road,Yeotmal,Maharashtra',
'Amboda,Yeotmal,Maharashtra',
'Dongargaon,Yeotmal,Maharashtra',
'Fulsavangi,Yeotmal,Maharashtra',
'Gunj,Yeotmal,Maharashtra',
'Hiwara,Yeotmal,Maharashtra',
'Kanha,Yeotmal,Maharashtra',
'Kasola,Yeotmal,Maharashtra',
'Kondri,Yeotmal,Maharashtra',
'Mahagaon,Yeotmal,Maharashtra',
'Mohadi,Yeotmal,Maharashtra',
'Morath,Yeotmal,Maharashtra',
'Mudana,Yeotmal,Maharashtra',
'Pedhi,Yeotmal,Maharashtra',
'Pohandul,Yeotmal,Maharashtra',
'Sawana,Yeotmal,Maharashtra',
'Wadad,Yeotmal,Maharashtra',
'Buranda,Yeotmal,Maharashtra',
'Chinchala,Yeotmal,Maharashtra',
'Chinchmandal,Yeotmal,Maharashtra',
'Chinchoni Botoni,Yeotmal,Maharashtra',
'Chopan,Yeotmal,Maharashtra',
'Hiwra Majra,Yeotmal,Maharashtra',
'Jalka Road,Yeotmal,Maharashtra',
'Kumbha,Yeotmal,Maharashtra',
'Mardi,Yeotmal,Maharashtra',
'Maregaon Road,Yeotmal,Maharashtra',
'Mhaisdodka,Yeotmal,Maharashtra',
'Narsala,Yeotmal,Maharashtra',
'Nawargaon,Yeotmal,Maharashtra',
'Pendhari,Yeotmal,Maharashtra',
'Pisgaon,Yeotmal,Maharashtra',
'Sagnapur,Yeotmal,Maharashtra',
'Wegaon,Yeotmal,Maharashtra',
'Adegaon,Yeotmal,Maharashtra',
'Borgaon (Linga ),Yeotmal,Maharashtra',
'Jawalgaon,Yeotmal,Maharashtra',
'Ner Parsopant,Yeotmal,Maharashtra',
'Ajanti,Yeotmal,Maharashtra',
'Bangaon,Yeotmal,Maharashtra',
'Brahmanwada,Yeotmal,Maharashtra',
'Chikhali Domga,Yeotmal,Maharashtra',
'Chikhali Kanhoba,Yeotmal,Maharashtra',
'Kolura,Yeotmal,Maharashtra',
'Malked Khurd,Yeotmal,Maharashtra',
'Malkhed BK,Yeotmal,Maharashtra',
'Mangala Devi,Yeotmal,Maharashtra',
'Manikwada,Yeotmal,Maharashtra',
'Mozar,Yeotmal,Maharashtra',
'Patharot,Yeotmal,Maharashtra',
'Sirasgaon Pandhari,Yeotmal,Maharashtra',
'Uttarwadhona,Yeotmal,Maharashtra',
'Watfali,Yeotmal,Maharashtra',
'Satefal,Yeotmal,Maharashtra',
'Kharadgaon,Yeotmal,Maharashtra',
'Adegaon,Yeotmal,Maharashtra',
'Bansi,Yeotmal,Maharashtra',
'Belura,Yeotmal,Maharashtra',
'Bhandari,Yeotmal,Maharashtra',
'Bhojla,Yeotmal,Maharashtra',
'Bori Khurd,Yeotmal,Maharashtra',
'Brahmangaon,Yeotmal,Maharashtra',
'Chikhali Camp,Yeotmal,Maharashtra',
'Dhansal,Yeotmal,Maharashtra',
'Fetra,Yeotmal,Maharashtra',
'Gahuli,Yeotmal,Maharashtra',
'Gaul, Khurd,Yeotmal,Maharashtra',
'Harshi,Yeotmal,Maharashtra',
'Hudi,Yeotmal,Maharashtra',
'Issapur,Yeotmal,Maharashtra',
'Jamb Bazar,Yeotmal,Maharashtra',
'Jamni Dhundi,Yeotmal,Maharashtra',
'Januna,Yeotmal,Maharashtra',
'Kali Daulat Khan,Yeotmal,Maharashtra',
'Khadakdari,Yeotmal,Maharashtra',
'Khandala,Yeotmal,Maharashtra',
'Kurli,Yeotmal,Maharashtra',
'Lakhi Jehangir,Yeotmal,Maharashtra',
'Lewa,Yeotmal,Maharashtra',
'Lohara Izara,Yeotmal,Maharashtra',
'Mandawa,Yeotmal,Maharashtra',
'Manikdoh,Yeotmal,Maharashtra',
'Moha,Yeotmal,Maharashtra',
'Mokhad,Yeotmal,Maharashtra',
'Mop Jawala,Yeotmal,Maharashtra',
'P.N.C. Pusad,Yeotmal,Maharashtra',
'Pardi Limbi,Yeotmal,Maharashtra',
'Parwa,Yeotmal,Maharashtra',
'Pophali,Yeotmal,Maharashtra',
'Pusad,Yeotmal,Maharashtra',
'Pusad Town ( Pusad),Yeotmal,Maharashtra',
'Rohda,Yeotmal,Maharashtra',
'Sandawa,Yeotmal,Maharashtra',
'Sawargaon Bunglow,Yeotmal,Maharashtra',
'Sawargaon Gore,Yeotmal,Maharashtra',
'Shelu BK,Yeotmal,Maharashtra',
'Shembal Pimpri,Yeotmal,Maharashtra',
'Soot Girni,Yeotmal,Maharashtra',
'Wanwarla,Yeotmal,Maharashtra',
'Apti Rampur,Yeotmal,Maharashtra',
'Chahand,Yeotmal,Maharashtra',
'Chikhali Kelapur,Yeotmal,Maharashtra',
'Dahegaon,Yeotmal,Maharashtra',
'Jalka,Yeotmal,Maharashtra',
'Khairi,Yeotmal,Maharashtra',
'Loni,Yeotmal,Maharashtra',
'Pimpalapur,Yeotmal,Maharashtra',
'Ralegaon,Yeotmal,Maharashtra',
'Sawarkheda,Yeotmal,Maharashtra',
'Undari,Yeotmal,Maharashtra',
'Wadhona Bazar,Yeotmal,Maharashtra',
'Wadki,Yeotmal,Maharashtra',
'Wardh,Yeotmal,Maharashtra',
'Zadgaon,Yeotmal,Maharashtra',
'Gujari,Yeotmal,Maharashtra',
'Sawangi Perka,Yeotmal,Maharashtra',
'Warud JR,Yeotmal,Maharashtra',
'Dhanora,Yeotmal,Maharashtra',
'Akoli,Yeotmal,Maharashtra',
'Bhavani Jahagir,Yeotmal,Maharashtra',
'Bittergaon,Yeotmal,Maharashtra',
'Darati,Yeotmal,Maharashtra',
'Jeoli,Yeotmal,Maharashtra',
'Korta,Yeotmal,Maharashtra',
'Krishi Samiti (Umarkhed),Yeotmal,Maharashtra',
'Krishnapur,Yeotmal,Maharashtra',
'Tembhi,Yeotmal,Maharashtra',
'Umarkhed,Yeotmal,Maharashtra',
'Belkhed,Yeotmal,Maharashtra',
'Brahmangaon,Yeotmal,Maharashtra',
'Chatari,Yeotmal,Maharashtra',
'Deosari,Yeotmal,Maharashtra',
'Dhanki,Yeotmal,Maharashtra',
'Dhanora Sachaldev,Yeotmal,Maharashtra',
'Kharus BK,Yeotmal,Maharashtra',
'Marlegaon,Yeotmal,Maharashtra',
'Marsul,Yeotmal,Maharashtra',
'Mulawa,Yeotmal,Maharashtra',
'Ningnoor,Yeotmal,Maharashtra',
'Palsi,Yeotmal,Maharashtra',
'Taroda,Yeotmal,Maharashtra',
'Vidul,Yeotmal,Maharashtra',
'Belora,Yeotmal,Maharashtra',
'Bhalar,Yeotmal,Maharashtra',
'Borda,Yeotmal,Maharashtra',
'Chikparam,Yeotmal,Maharashtra',
'Ghonsa,Yeotmal,Maharashtra',
'Jatra Road(Wani),Yeotmal,Maharashtra',
'Kayar,Yeotmal,Maharashtra',
'Kona,Yeotmal,Maharashtra',
'Kurai,Yeotmal,Maharashtra',
'Mandar,Yeotmal,Maharashtra',
'Mendholi,Yeotmal,Maharashtra',
'Mohurli,Yeotmal,Maharashtra',
'Naigaon,Yeotmal,Maharashtra',
'Nandepera,Yeotmal,Maharashtra',
'Nerad Purad,Yeotmal,Maharashtra',
'Palsoni,Yeotmal,Maharashtra',
'Punwat,Yeotmal,Maharashtra',
'Rajur,Yeotmal,Maharashtra',
'Rasa,Yeotmal,Maharashtra',
'Sakharadara,Yeotmal,Maharashtra',
'Sakhra Kolgaon,Yeotmal,Maharashtra',
'Shirpur,Yeotmal,Maharashtra',
'Sindhola Mines,Yeotmal,Maharashtra',
'Suknegaon,Yeotmal,Maharashtra',
'Ukni,Yeotmal,Maharashtra',
'Velabai,Yeotmal,Maharashtra',
'Wani Bazar,Yeotmal,Maharashtra',
'Wani,Yeotmal,Maharashtra',
'Wanzari,Yeotmal,Maharashtra',
'Akpuri,Yeotmal,Maharashtra',
'Arjuna,Yeotmal,Maharashtra',
'Asegaon Devi,Yeotmal,Maharashtra',
'Asola,Yeotmal,Maharashtra',
'Awdhutwadi (Yavatma)l,Yeotmal,Maharashtra',
'Belora,Yeotmal,Maharashtra',
'Bhari,Yeotmal,Maharashtra',
'Bhosa,Yeotmal,Maharashtra',
'Borgaon,Yeotmal,Maharashtra',
'Chhoti Gujri (Yavatmal),Yeotmal,Maharashtra',
'Chikani,Yeotmal,Maharashtra',
'Chinchghat,Yeotmal,Maharashtra',
'Dhanora,Yeotmal,Maharashtra',
'Jamni,Yeotmal,Maharashtra',
'Marki,Yeotmal,Maharashtra',
'Matharjun,Yeotmal,Maharashtra',
'Mukutban,Yeotmal,Maharashtra',
'Patan,Yeotmal,Maharashtra',
'Satpalli,Yeotmal,Maharashtra',
'Zamkola,Yeotmal,Maharashtra',
'Carnicobar,A - N Islands,Andaman & Nicobar Islands',
'Kakana,A - N Islands,Andaman & Nicobar Islands',
'Lapathy,A - N Islands,Andaman & Nicobar Islands',
'Mus,A - N Islands,Andaman & Nicobar Islands',
'Kondul Island,A - N Islands,Andaman & Nicobar Islands',
'Little Nicobar,A - N Islands,Andaman & Nicobar Islands',
'Mildera,A - N Islands,Andaman & Nicobar Islands',
'Nancowrie,A - N Islands,Andaman & Nicobar Islands',
'Nehrugram,A - N Islands,Andaman & Nicobar Islands',
'Pilomilo Island,A - N Islands,Andaman & Nicobar Islands',
'Trinket,A - N Islands,Andaman & Nicobar Islands',
'Aerial Bay,A - N Islands,Andaman & Nicobar Islands',
'Diglipur,A - N Islands,Andaman & Nicobar Islands',
'Hathilevel,A - N Islands,Andaman & Nicobar Islands',
'Kalighat,A - N Islands,Andaman & Nicobar Islands',
'Kishorinagar,A - N Islands,Andaman & Nicobar Islands',
'Laxmipur,A - N Islands,Andaman & Nicobar Islands',
'Navagram,A - N Islands,Andaman & Nicobar Islands',
'Pashimsagar,A - N Islands,Andaman & Nicobar Islands',
'Ramnagar,A - N Islands,Andaman & Nicobar Islands',
'Sitanagar,A - N Islands,Andaman & Nicobar Islands',
'Smith Island,A - N Islands,Andaman & Nicobar Islands',
'Swarajgram,A - N Islands,Andaman & Nicobar Islands',
'Mayabander,A - N Islands,Andaman & Nicobar Islands',
'Nimbudera,A - N Islands,Andaman & Nicobar Islands',
'Pudumadurai,A - N Islands,Andaman & Nicobar Islands',
'Rampur,A - N Islands,Andaman & Nicobar Islands',
'Tugapur,A - N Islands,Andaman & Nicobar Islands',
'Weby,A - N Islands,Andaman & Nicobar Islands',
'Kanchangarh,A - N Islands,Andaman & Nicobar Islands',
'Oralkatcha,A - N Islands,Andaman & Nicobar Islands',
'Sankarnalla,A - N Islands,Andaman & Nicobar Islands',
'Bakultala,A - N Islands,Andaman & Nicobar Islands',
'Betapur,A - N Islands,Andaman & Nicobar Islands',
'Kadamtala,A - N Islands,Andaman & Nicobar Islands',
'Kaushalyanagar,A - N Islands,Andaman & Nicobar Islands',
'Long Island,A - N Islands,Andaman & Nicobar Islands',
'Nimbutala,A - N Islands,Andaman & Nicobar Islands',
'Panchawati,A - N Islands,Andaman & Nicobar Islands',
'Parnasala,A - N Islands,Andaman & Nicobar Islands',
'Pitchernalla,A - N Islands,Andaman & Nicobar Islands',
'Rangat,A - N Islands,Andaman & Nicobar Islands',
'Sabari,A - N Islands,Andaman & Nicobar Islands',
'Swdeshnagar,A - N Islands,Andaman & Nicobar Islands',
'Uttara,A - N Islands,Andaman & Nicobar Islands',
'Bambooflat,A - N Islands,Andaman & Nicobar Islands',
'Beachdera,A - N Islands,Andaman & Nicobar Islands',
'Dundas Point,A - N Islands,Andaman & Nicobar Islands',
'Herbertabad,A - N Islands,Andaman & Nicobar Islands',
'Humferygunj,A - N Islands,Andaman & Nicobar Islands',
'Jirkatong,A - N Islands,Andaman & Nicobar Islands',
'Kalatong,A - N Islands,Andaman & Nicobar Islands',
'Mathura,A - N Islands,Andaman & Nicobar Islands',
'Miletilak,A - N Islands,Andaman & Nicobar Islands',
'Ograbanj,A - N Islands,Andaman & Nicobar Islands',
'Rubber Research Station,A - N Islands,Andaman & Nicobar Islands',
'Shoalbay,A - N Islands,Andaman & Nicobar Islands',
'Stewertgunj,A - N Islands,Andaman & Nicobar Islands',
'Wimberlygunj,A - N Islands,Andaman & Nicobar Islands',
'Hut Bay,A - N Islands,Andaman & Nicobar Islands',
'Netajinagar,A - N Islands,Andaman & Nicobar Islands',
'Ramakrishnapur,A - N Islands,Andaman & Nicobar Islands',
'Vivekandapur,A - N Islands,Andaman & Nicobar Islands',
'Aberdeen Bazar,A - N Islands,Andaman & Nicobar Islands',
'Beodnabad,A - N Islands,Andaman & Nicobar Islands',
'Bimbiton,A - N Islands,Andaman & Nicobar Islands',
'Brijgunj,A - N Islands,Andaman & Nicobar Islands',
'Calicut,A - N Islands,Andaman & Nicobar Islands',
'Chouldari,A - N Islands,Andaman & Nicobar Islands',
'Shadipur,A - N Islands,Andaman & Nicobar Islands',
'Sippighat,A - N Islands,Andaman & Nicobar Islands',
'Sitapur,A - N Islands,Andaman & Nicobar Islands',
'Strait Island,A - N Islands,Andaman & Nicobar Islands',
'Tushnabad,A - N Islands,Andaman & Nicobar Islands',
'Wandoor,A - N Islands,Andaman & Nicobar Islands',
'Badankurthy,Adilabad,Andhra Pradesh',
'Beernandi,Adilabad,Andhra Pradesh',
'Dilawarpur,Adilabad,Andhra Pradesh',
'Madhurawada,Visakhapatnam,Andhra Pradesh',
'Mandapalli,Adilabad,Andhra Pradesh',
'Nachan Yelcapur,Adilabad,Andhra Pradesh',
'Patha Yelcapur,Adilabad,Andhra Pradesh',
'Pembi,Adilabad,Andhra Pradesh',
'Sathanapalli,Adilabad,Andhra Pradesh',
'Surjapur,Adilabad,Andhra Pradesh',
'Adilabad Collectorate,Adilabad,Andhra Pradesh',
'Adilabad H.O,Adilabad,Andhra Pradesh',
'Akoli,Adilabad,Andhra Pradesh',
'Ankoli,Adilabad,Andhra Pradesh',
'Arli (T),Adilabad,Andhra Pradesh',
'Bela,Adilabad,Andhra Pradesh',
'Bhagyanagar,Adilabad,Andhra Pradesh',
'Bharampur,Adilabad,Andhra Pradesh',
'Bheemsari,Adilabad,Andhra Pradesh',
'Bhuktapur,Adilabad,Andhra Pradesh',
'Chanda (T),Adilabad,Andhra Pradesh',
'Chaprala,Adilabad,Andhra Pradesh',
'Chinchughat,Adilabad,Andhra Pradesh',
'College Campus,Adilabad,Andhra Pradesh',
'Cotton Market,Adilabad,Andhra Pradesh',
'Dasnapur Colony,Adilabad,Andhra Pradesh',
'Deepaiguda,Adilabad,Andhra Pradesh',
'Devapur,Adilabad,Andhra Pradesh',
'Gandhi Chowk,Adilabad,Andhra Pradesh',
'Ghotkuri,Adilabad,Andhra Pradesh',
'Gonedhanora,Adilabad,Andhra Pradesh',
'Guda,Adilabad,Andhra Pradesh',
'Gumma,Adilabad,Andhra Pradesh',
'Jainad,Adilabad,Andhra Pradesh',
'Jhary,Adilabad,Andhra Pradesh',
'Kampamediguda,Adilabad,Andhra Pradesh',
'Kapparla,Adilabad,Andhra Pradesh',
'Karanji,Adilabad,Andhra Pradesh',
'Khodad,Adilabad,Andhra Pradesh',
'Khogdur,Adilabad,Andhra Pradesh',
'Koora,Adilabad,Andhra Pradesh',
'Kosai R.S.,Adilabad,Andhra Pradesh',
'Kuchlapur,Adilabad,Andhra Pradesh',
'Lachampur,Adilabad,Andhra Pradesh',
'Lingi,Adilabad,Andhra Pradesh',
'Mavala,Adilabad,Andhra Pradesh',
'Nirala,Adilabad,Andhra Pradesh',
'Palli (B),Adilabad,Andhra Pradesh',
'Pendalwada,Adilabad,Andhra Pradesh',
'Pippaldhari,Adilabad,Andhra Pradesh',
'Pippalkoti,Adilabad,Andhra Pradesh',
'Pochera,Adilabad,Andhra Pradesh',
'Ponnari,Adilabad,Andhra Pradesh',
'Ramai,Adilabad,Andhra Pradesh',
'Ruyyadi,Adilabad,Andhra Pradesh',
'Saidpur,Adilabad,Andhra Pradesh',
'Sangvi,Adilabad,Andhra Pradesh',
'Sawapur,Adilabad,Andhra Pradesh',
'Sirsanna,Adilabad,Andhra Pradesh',
'Sitagondi,Adilabad,Andhra Pradesh',
'Station Road,Adilabad,Andhra Pradesh',
'Sunkidi,Adilabad,Andhra Pradesh',
'Talamadugu,Adilabad,Andhra Pradesh',
'Tamsi,Adilabad,Andhra Pradesh',
'Tantoli,Adilabad,Andhra Pradesh',
'Toyaguda,Adilabad,Andhra Pradesh',
'Waghapur,Adilabad,Andhra Pradesh',
'Yapalguda,Adilabad,Andhra Pradesh',
'Achalapur,Adilabad,Andhra Pradesh',
'Ada,Adilabad,Andhra Pradesh',
'Ainam,Adilabad,Andhra Pradesh',
'Asifabad,Adilabad,Andhra Pradesh',
'Babapur,Adilabad,Andhra Pradesh',
'Bambara,Adilabad,Andhra Pradesh',
'Bareguda,Adilabad,Andhra Pradesh',
'Bhimini,Adilabad,Andhra Pradesh',
'Bibra,Adilabad,Andhra Pradesh',
'Bodepalli,Adilabad,Andhra Pradesh',
'Boyapalli,Adilabad,Andhra Pradesh',
'Burguda,Adilabad,Andhra Pradesh',
'Chakepalli,Adilabad,Andhra Pradesh',
'Chirrakunta,Adilabad,Andhra Pradesh',
'Dehgaon,Adilabad,Andhra Pradesh',
'Devaiguda,Adilabad,Andhra Pradesh',
'Devapur,Adilabad,Andhra Pradesh',
'Dwarakapur,Adilabad,Andhra Pradesh',
'Gangapur,Adilabad,Andhra Pradesh',
'Ginnedhari,Adilabad,Andhra Pradesh',
'Golleti,Adilabad,Andhra Pradesh',
'Goyagaon,Adilabad,Andhra Pradesh',
'Gudipet,Adilabad,Andhra Pradesh',
'Gundi,Adilabad,Andhra Pradesh',
'Hathini,Adilabad,Andhra Pradesh',
'Indhani,Adilabad,Andhra Pradesh',
'Ityal,Adilabad,Andhra Pradesh',
'Kalwada,Adilabad,Andhra Pradesh',
'Kannepalli,Adilabad,Andhra Pradesh',
'Kannergaon,Adilabad,Andhra Pradesh',
'Karjibheempur,Adilabad,Andhra Pradesh',
'Kerameri,Adilabad,Andhra Pradesh',
'Khairgaon,Adilabad,Andhra Pradesh',
'Khamana,Adilabad,Andhra Pradesh',
'Khirdi,Adilabad,Andhra Pradesh',
'Kondampally,Adilabad,Andhra Pradesh',
'Kothmeer,Adilabad,Andhra Pradesh',
'Malledi,Adilabad,Andhra Pradesh',
'Mangi,Adilabad,Andhra Pradesh',
'Manikyapur,Adilabad,Andhra Pradesh',
'Modi,Adilabad,Andhra Pradesh',
'Moindagudipet,Adilabad,Andhra Pradesh',
'Movad,Adilabad,Andhra Pradesh',
'Nambal,Adilabad,Andhra Pradesh',
'Narayanpur,Adilabad,Andhra Pradesh',
'Navegaon,Adilabad,Andhra Pradesh',
'Pangidimadra,Adilabad,Andhra Pradesh',
'Repallewada,Adilabad,Andhra Pradesh',
'Rompalli,Adilabad,Andhra Pradesh',
'Surdapur,Adilabad,Andhra Pradesh',
'Tiryani,Adilabad,Andhra Pradesh',
'Tumpalli,Adilabad,Andhra Pradesh',
'Ullipittadorli,Adilabad,Andhra Pradesh',
'Yellaram,Adilabad,Andhra Pradesh',
'Adegaon,Adilabad,Andhra Pradesh',
'Bazar Hathnur,Adilabad,Andhra Pradesh',
'Bhutai,Adilabad,Andhra Pradesh',
'Boath,Adilabad,Andhra Pradesh',
'Boregaon,Adilabad,Andhra Pradesh',
'Buggaram,Adilabad,Andhra Pradesh',
'Chintalbori,Adilabad,Andhra Pradesh',
'Dehgaon,Adilabad,Andhra Pradesh',
'Dhannoor,Adilabad,Andhra Pradesh',
'Echoda,Adilabad,Andhra Pradesh',
'Ghanpur,Adilabad,Andhra Pradesh',
'Girjam,Adilabad,Andhra Pradesh',
'Girnoor,Adilabad,Andhra Pradesh',
'Gokonda,Adilabad,Andhra Pradesh',
'Gowliguda,Adilabad,Andhra Pradesh',
'Gudihatnoor,Adilabad,Andhra Pradesh',
'Gurjamannur,Adilabad,Andhra Pradesh',
'Jatharla,Adilabad,Andhra Pradesh',
'Karathwada,Adilabad,Andhra Pradesh',
'Kokasmannur,Adilabad,Andhra Pradesh',
'Kolhari,Adilabad,Andhra Pradesh',
'Koutha (B),Adilabad,Andhra Pradesh',
'Kuchlapur,Adilabad,Andhra Pradesh',
'Kumhari,Adilabad,Andhra Pradesh',
'Malyal,Adilabad,Andhra Pradesh',
'Marlapally,Adilabad,Andhra Pradesh',
'Mukhra (B),Adilabad,Andhra Pradesh',
'Muthnur,Adilabad,Andhra Pradesh',
'Narsapur,Adilabad,Andhra Pradesh',
'Neradigonda,Adilabad,Andhra Pradesh',
'Pardi (K),Adilabad,Andhra Pradesh',
'Patnapur,Adilabad,Andhra Pradesh',
'Pipri,Adilabad,Andhra Pradesh',
'Pochera,Adilabad,Andhra Pradesh',
'Powna,Adilabad,Andhra Pradesh',
'Rampur,Adilabad,Andhra Pradesh',
'Shantapur,Adilabad,Andhra Pradesh',
'Sirchelma,Adilabad,Andhra Pradesh',
'Sirkonda,Adilabad,Andhra Pradesh',
'Soanpally,Adilabad,Andhra Pradesh',
'Sonala,Adilabad,Andhra Pradesh',
'Talamadri,Adilabad,Andhra Pradesh',
'Tarnam,Adilabad,Andhra Pradesh',
'Tembi,Adilabad,Andhra Pradesh',
'Waddur,Adilabad,Andhra Pradesh',
'Wankidi,Adilabad,Andhra Pradesh',
'Chinnoor,Adilabad,Andhra Pradesh',
'Alegaon,Adilabad,Andhra Pradesh',
'Angarajpally,Adilabad,Andhra Pradesh',
'Annaram,Adilabad,Andhra Pradesh',
'Arepally,Adilabad,Andhra Pradesh',
'Asnad,Adilabad,Andhra Pradesh',
'Awadam,Adilabad,Andhra Pradesh',
'Bheemaram,Adilabad,Andhra Pradesh',
'Dewalwada,Adilabad,Andhra Pradesh',
'Dugnepally,Adilabad,Andhra Pradesh',
'Indaram,Adilabad,Andhra Pradesh',
'Jaipur,Adilabad,Andhra Pradesh',
'Jangaon,Adilabad,Andhra Pradesh',
'Kistampet,Adilabad,Andhra Pradesh',
'Kistapur,Adilabad,Andhra Pradesh',
'Kollur,Adilabad,Andhra Pradesh',
'Kommera,Adilabad,Andhra Pradesh',
'Kotapalli,Adilabad,Andhra Pradesh',
'Kundaram,Adilabad,Andhra Pradesh',
'Kyathanpally,Adilabad,Andhra Pradesh',
'Maddikal,Adilabad,Andhra Pradesh',
'Mallampet,Adilabad,Andhra Pradesh',
'Mamidighat,Adilabad,Andhra Pradesh',
'Mittapalli Jagir,Adilabad,Andhra Pradesh',
'Mulkalpet,Adilabad,Andhra Pradesh',
'Nagapur,Adilabad,Andhra Pradesh',
'Nakkalapally,Adilabad,Andhra Pradesh',
'Nandarampally,Adilabad,Andhra Pradesh',
'Naseerabad,Adilabad,Andhra Pradesh',
'Neelwai,Adilabad,Andhra Pradesh',
'Parpally,Adilabad,Andhra Pradesh',
'Pegdapally,Adilabad,Andhra Pradesh',
'Pokkur,Adilabad,Andhra Pradesh',
'Ponnaram,Adilabad,Andhra Pradesh',
'Pownur,Adilabad,Andhra Pradesh',
'Shetpally,Adilabad,Andhra Pradesh',
'Sirsa,Adilabad,Andhra Pradesh',
'Somanpally,Adilabad,Andhra Pradesh',
'Srirampur Colony,Adilabad,Andhra Pradesh',
'Suddal,Adilabad,Andhra Pradesh',
'Tekumatla,Adilabad,Andhra Pradesh',
'Vemanpally,Adilabad,Andhra Pradesh',
'Wellal,Adilabad,Andhra Pradesh',
'Ambaripet,Adilabad,Andhra Pradesh',
'Bellalbadi,Adilabad,Andhra Pradesh',
'Chityal,Adilabad,Andhra Pradesh',
'Dasturabad,Adilabad,Andhra Pradesh',
'Khanapur,Adilabad,Andhra Pradesh',
'Lingapur,Adilabad,Andhra Pradesh',
'Maddipadaga,Adilabad,Andhra Pradesh',
'Munial,Adilabad,Andhra Pradesh',
'Peddur,Adilabad,Andhra Pradesh',
'Revojipet,Adilabad,Andhra Pradesh',
'Agm Colony,Adilabad,Andhra Pradesh',
'Aknepalli,Adilabad,Andhra Pradesh',
'Andugulpet,Adilabad,Andhra Pradesh',
'Badampally,Adilabad,Andhra Pradesh',
'Bellampalli R.S.,Adilabad,Andhra Pradesh',
'Bellampalli,Adilabad,Andhra Pradesh',
'Budakalan,Adilabad,Andhra Pradesh',
'Budakurd,Adilabad,Andhra Pradesh',
'Chandaram,Adilabad,Andhra Pradesh',
'Chintaguda,Adilabad,Andhra Pradesh',
'Coal Chemical Complex,Adilabad,Andhra Pradesh',
'Dandepalli,Adilabad,Andhra Pradesh',
'Devapur Cement Works,Adilabad,Andhra Pradesh',
'Dharmaram,Adilabad,Andhra Pradesh',
'Dharmaraopet,Adilabad,Andhra Pradesh',
'Donabanda,Adilabad,Andhra Pradesh',
'Dowdepally,Adilabad,Andhra Pradesh',
'Dwaraka,Adilabad,Andhra Pradesh',
'Gadapur,Adilabad,Andhra Pradesh',
'Girvelli,Adilabad,Andhra Pradesh',
'Gollakota,Adilabad,Andhra Pradesh',
'Grain Market,Adilabad,Andhra Pradesh',
'Gudem,Adilabad,Andhra Pradesh',
'Gurjal,Adilabad,Andhra Pradesh',
'Hazipur,Adilabad,Andhra Pradesh',
'Indanpally,Adilabad,Andhra Pradesh',
'Itikyal,Adilabad,Andhra Pradesh',
'Jajjarvelli,Adilabad,Andhra Pradesh',
'Janakapur,Adilabad,Andhra Pradesh',
'Jandavenkatapur,Adilabad,Andhra Pradesh',
'Jannaram,Adilabad,Andhra Pradesh',
'Jilleda,Adilabad,Andhra Pradesh',
'Kalamadugu,Adilabad,Andhra Pradesh',
'Kalyani Khani,Adilabad,Andhra Pradesh',
'Kanchevelli,Adilabad,Andhra Pradesh',
'Kannepalli,Adilabad,Andhra Pradesh',
'Karnamamidi,Adilabad,Andhra Pradesh',
'Kasipet,Adilabad,Andhra Pradesh',
'Kistapur,Adilabad,Andhra Pradesh',
'Korvichelma,Adilabad,Andhra Pradesh',
'Kushnepalli,Adilabad,Andhra Pradesh',
'Kyathanpalli,Adilabad,Andhra Pradesh',
'Laxmipur,Adilabad,Andhra Pradesh',
'Lingapur,Adilabad,Andhra Pradesh',
'Luxettipet,Adilabad,Andhra Pradesh',
'Madaram Township,Adilabad,Andhra Pradesh',
'Madaripeta,Adilabad,Andhra Pradesh',
'Mamidipalli,Adilabad,Andhra Pradesh',
'Mancherial Bazar,Adilabad,Andhra Pradesh',
'Mancherial Cement Works,Adilabad,Andhra Pradesh',
'Mancherial H.O,Adilabad,Andhra Pradesh',
'Mandamarri Colleries,Adilabad,Andhra Pradesh',
'Mandamarri R.S.,Adilabad,Andhra Pradesh',
'Metpalli,Adilabad,Andhra Pradesh',
'Metpally,Adilabad,Andhra Pradesh',
'Modela,Adilabad,Andhra Pradesh',
'Mulkala,Adilabad,Andhra Pradesh',
'Mulmadugu,Adilabad,Andhra Pradesh',
'Mylaram,Adilabad,Andhra Pradesh',
'Namnoor,Adilabad,Andhra Pradesh',
'Naspur,Adilabad,Andhra Pradesh',
'Nennel,Adilabad,Andhra Pradesh',
'Patha Mancherial,Adilabad,Andhra Pradesh',
'Peddampet,Adilabad,Andhra Pradesh',
'Peddapet,Adilabad,Andhra Pradesh',
'Perkapally,Adilabad,Andhra Pradesh',
'Police Colony,Adilabad,Andhra Pradesh',
'Ponkal,Adilabad,Andhra Pradesh',
'Qawal,Adilabad,Andhra Pradesh',
'Raipally,Adilabad,Andhra Pradesh',
'Ramakrishnapur,Adilabad,Andhra Pradesh',
'Rebbanapally,Adilabad,Andhra Pradesh',
'Rebbena,Adilabad,Andhra Pradesh',
'Shanthi Khani,Adilabad,Andhra Pradesh',
'Singapur,Adilabad,Andhra Pradesh',
'Somagudem Coal Mines,Adilabad,Andhra Pradesh',
'Tallapet,Adilabad,Andhra Pradesh',
'Tapalpur,Adilabad,Andhra Pradesh',
'Thimmapur,Adilabad,Andhra Pradesh',
'Udumpur,Adilabad,Andhra Pradesh',
'Velagnur,Adilabad,Andhra Pradesh',
'Vempalli,Adilabad,Andhra Pradesh',
'Venkatapur,Adilabad,Andhra Pradesh',
'Venkatapur,Adilabad,Andhra Pradesh',
'Venkatraopet,Adilabad,Andhra Pradesh',
'Wegaon,Adilabad,Andhra Pradesh',
'Ashta,Adilabad,Andhra Pradesh',
'Basar,Adilabad,Andhra Pradesh',
'Beltharoda,Adilabad,Andhra Pradesh',
'Bhainsa,Adilabad,Andhra Pradesh',
'Bholsa,Adilabad,Andhra Pradesh',
'Bhosi,Adilabad,Andhra Pradesh',
'Bidrelli,Adilabad,Andhra Pradesh',
'Boregaon,Adilabad,Andhra Pradesh',
'Brahmangaon,Adilabad,Andhra Pradesh',
'Chata,Adilabad,Andhra Pradesh',
'Chichondi,Adilabad,Andhra Pradesh',
'Chondi,Adilabad,Andhra Pradesh',
'Dehgaon,Adilabad,Andhra Pradesh',
'Doderna,Adilabad,Andhra Pradesh',
'Elegaon,Adilabad,Andhra Pradesh',
'Elvi,Adilabad,Andhra Pradesh',
'Jawla,Adilabad,Andhra Pradesh',
'Kamole,Adilabad,Andhra Pradesh',
'Kankapur,Adilabad,Andhra Pradesh',
'Kirgul,Adilabad,Andhra Pradesh',
'Kolur,Adilabad,Andhra Pradesh',
'Kothalgaon,Adilabad,Andhra Pradesh',
'Kubeer,Adilabad,Andhra Pradesh',
'Kuntala,Adilabad,Andhra Pradesh',
'Mahagaon,Adilabad,Andhra Pradesh',
'Mahalingi,Adilabad,Andhra Pradesh',
'Malegoan,Adilabad,Andhra Pradesh',
'Mudhole,Adilabad,Andhra Pradesh',
'Nigwa,Adilabad,Andhra Pradesh',
'Pardi (B),Adilabad,Andhra Pradesh',
'Pulsi,Adilabad,Andhra Pradesh',
'Puspur,Adilabad,Andhra Pradesh',
'Sawli,Adilabad,Andhra Pradesh',
'Sonari,Adilabad,Andhra Pradesh',
'Tanur,Adilabad,Andhra Pradesh',
'Yedbid,Adilabad,Andhra Pradesh',
'Yellawath,Adilabad,Andhra Pradesh',
'Aloor,Adilabad,Andhra Pradesh',
'Andukur,Adilabad,Andhra Pradesh',
'Bangalpet,Adilabad,Andhra Pradesh',
'Bansapalli,Adilabad,Andhra Pradesh',
'Birvelli,Adilabad,Andhra Pradesh',
'Borigaon,Adilabad,Andhra Pradesh',
'Chincholi (B),Adilabad,Andhra Pradesh',
'Chintalchanda,Adilabad,Andhra Pradesh',
'Chityal,Adilabad,Andhra Pradesh',
'Dhani,Adilabad,Andhra Pradesh',
'Dilawarpur,Adilabad,Andhra Pradesh',
'Dimmadurthy,Adilabad,Andhra Pradesh',
'Gadchanda,Adilabad,Andhra Pradesh',
'Gopalpet,Adilabad,Andhra Pradesh',
'Gulmadugu,Adilabad,Andhra Pradesh',
'Gundampalli,Adilabad,Andhra Pradesh',
'Indiranagar,Adilabad,Andhra Pradesh',
'Jam,Adilabad,Andhra Pradesh',
'Kadthal,Adilabad,Andhra Pradesh',
'Kallur,Adilabad,Andhra Pradesh',
'Kalwa,Adilabad,Andhra Pradesh',
'Kamalkot,Adilabad,Andhra Pradesh',
'Kasba,Adilabad,Andhra Pradesh',
'Koratkal,Adilabad,Andhra Pradesh',
'Kortakal,Adilabad,Andhra Pradesh',
'Koutla (K),Adilabad,Andhra Pradesh',
'Koutla,Adilabad,Andhra Pradesh',
'Kuchanpally,Adilabad,Andhra Pradesh',
'Laxmanchanda,Adilabad,Andhra Pradesh',
'Limba (K),Adilabad,Andhra Pradesh',
'Lohesra,Adilabad,Andhra Pradesh',
'Madapur,Adilabad,Andhra Pradesh',
'Malak Chincholi,Adilabad,Andhra Pradesh',
'Mallapur,Adilabad,Andhra Pradesh',
'Mamda,Adilabad,Andhra Pradesh',
'Manjulapur,Adilabad,Andhra Pradesh',
'Manmad,Adilabad,Andhra Pradesh',
'Medpalli,Adilabad,Andhra Pradesh',
'Mujgi,Adilabad,Andhra Pradesh',
'Narsapur,Adilabad,Andhra Pradesh',
'Natrajnagar,Adilabad,Andhra Pradesh',
'New Pipri,Adilabad,Andhra Pradesh',
'Nirmal,Adilabad,Andhra Pradesh',
'Ola,Adilabad,Andhra Pradesh',
'Pakpatla,Adilabad,Andhra Pradesh',
'Panchagudi,Adilabad,Andhra Pradesh',
'Parimandal,Adilabad,Andhra Pradesh',
'Parpally,Adilabad,Andhra Pradesh',
'Peechara,Adilabad,Andhra Pradesh',
'Pendapally,Adilabad,Andhra Pradesh',
'Ponkal,Adilabad,Andhra Pradesh',
'Ponkur,Adilabad,Andhra Pradesh',
'Raipur Kandli,Adilabad,Andhra Pradesh',
'Rajura,Adilabad,Andhra Pradesh',
'Rajura,Adilabad,Andhra Pradesh',
'Rampur,Adilabad,Andhra Pradesh',
'Ratnapur Kandli,Adilabad,Andhra Pradesh',
'Sarangapur,Adilabad,Andhra Pradesh',
'Siddalkunta,Adilabad,Andhra Pradesh',
'Sirgapur,Adilabad,Andhra Pradesh',
'Soan,Adilabad,Andhra Pradesh',
'Sunkli,Adilabad,Andhra Pradesh',
'Tandra,Adilabad,Andhra Pradesh',
'Thammapur,Adilabad,Andhra Pradesh',
'Vengwapet,Adilabad,Andhra Pradesh',
'Venkatapur,Adilabad,Andhra Pradesh',
'Waddial,Adilabad,Andhra Pradesh',
'Yelmal,Adilabad,Andhra Pradesh',
'Andavelli,Adilabad,Andhra Pradesh',
'Bapur,Adilabad,Andhra Pradesh',
'Bejjur,Adilabad,Andhra Pradesh',
'Chedwai,Adilabad,Andhra Pradesh',
'Chintaguda,Adilabad,Andhra Pradesh',
'Chintakunta,Adilabad,Andhra Pradesh',
'Chintalamanepalli,Adilabad,Andhra Pradesh',
'Dabba,Adilabad,Andhra Pradesh',
'Dhorpalli,Adilabad,Andhra Pradesh',
'Dimda,Adilabad,Andhra Pradesh',
'Easgaon - V,Adilabad,Andhra Pradesh',
'Easgaon Camp,Adilabad,Andhra Pradesh',
'Gudem,Adilabad,Andhra Pradesh',
'Gudlabori,Adilabad,Andhra Pradesh',
'Gundaipet,Adilabad,Andhra Pradesh',
'Gurudpet,Adilabad,Andhra Pradesh',
'Harnath Colony,Adilabad,Andhra Pradesh',
'Hudkuli,Adilabad,Andhra Pradesh',
'Industrial Area,Adilabad,Andhra Pradesh',
'Karjavelli,Adilabad,Andhra Pradesh',
'Kowthala,Adilabad,Andhra Pradesh',
'Lonavelli,Adilabad,Andhra Pradesh',
'M.G. Road,Adilabad,Andhra Pradesh',
'Marthidi,Adilabad,Andhra Pradesh',
'Mogardhagar,Adilabad,Andhra Pradesh',
'Moogavelli,Adilabad,Andhra Pradesh',
'Mosam,Adilabad,Andhra Pradesh',
'Munjampalli,Adilabad,Andhra Pradesh',
'Muthyampet,Adilabad,Andhra Pradesh',
'Old Town,Adilabad,Andhra Pradesh',
'Ootsurangapalli,Adilabad,Andhra Pradesh',
'Papannapet,Adilabad,Andhra Pradesh',
'Pardi,Adilabad,Andhra Pradesh',
'Penchikalpet,Adilabad,Andhra Pradesh',
'Raspalli,Adilabad,Andhra Pradesh',
'Rebbena,Adilabad,Andhra Pradesh',
'Rebbena,Adilabad,Andhra Pradesh',
'Rechini,Adilabad,Andhra Pradesh',
'Rp Colony,Adilabad,Andhra Pradesh',
'Sanjeevnagar,Adilabad,Andhra Pradesh',
'Sirpur (T),Adilabad,Andhra Pradesh',
'Sirpur Khagaznagar,Adilabad,Andhra Pradesh',
'Sirsilk Colony,Adilabad,Andhra Pradesh',
'Talodi,Adilabad,Andhra Pradesh',
'Tandur (A),Adilabad,Andhra Pradesh',
'Tungeda,Adilabad,Andhra Pradesh',
'Wankidi,Adilabad,Andhra Pradesh',
'Ankhoda,Adilabad,Andhra Pradesh',
'Babasagar,Adilabad,Andhra Pradesh',
'Vempalli,Adilabad,Andhra Pradesh',
'Ashepally,Adilabad,Andhra Pradesh',
'Bheempur,Adilabad,Andhra Pradesh',
'Birsaipet,Adilabad,Andhra Pradesh',
'Chandur,Adilabad,Andhra Pradesh',
'Chichdhari Khanapur,Adilabad,Andhra Pradesh',
'Chorpalli,Adilabad,Andhra Pradesh',
'Dantanpalli,Adilabad,Andhra Pradesh',
'Dasnapur,Adilabad,Andhra Pradesh',
'Dhaba,Adilabad,Andhra Pradesh',
'Dhaboli,Adilabad,Andhra Pradesh',
'Dhanora(B),Adilabad,Andhra Pradesh',
'Gadiguda,Adilabad,Andhra Pradesh',
'Ghanpur,Adilabad,Andhra Pradesh',
'Ginnera,Adilabad,Andhra Pradesh',
'Gourapur,Adilabad,Andhra Pradesh',
'Gudamamda,Adilabad,Andhra Pradesh',
'Gunjala,Adilabad,Andhra Pradesh',
'Harkapur,Adilabad,Andhra Pradesh',
'Hasnapur,Adilabad,Andhra Pradesh',
'Indervelli,Adilabad,Andhra Pradesh',
'Jainoor,Adilabad,Andhra Pradesh',
'Jamni,Adilabad,Andhra Pradesh',
'Kanchanpalli,Adilabad,Andhra Pradesh',
'Keslapur,Adilabad,Andhra Pradesh',
'Khairdatwa,Adilabad,Andhra Pradesh',
'Kothapalli,Adilabad,Andhra Pradesh',
'Lakkaram,Adilabad,Andhra Pradesh',
'Lingapur,Adilabad,Andhra Pradesh',
'Mahagaon,Adilabad,Andhra Pradesh',
'Mamidipalli,Adilabad,Andhra Pradesh',
'Mankapur,Adilabad,Andhra Pradesh',
'Marlawai,Adilabad,Andhra Pradesh',
'Muthnur,Adilabad,Andhra Pradesh',
'Nagalkonda,Adilabad,Andhra Pradesh',
'Nagapur,Adilabad,Andhra Pradesh',
'Narnoor,Adilabad,Andhra Pradesh',
'Narsapur,Adilabad,Andhra Pradesh',
'Netnoor,Adilabad,Andhra Pradesh',
'Ootnur,Adilabad,Andhra Pradesh',
'Pangdi,Adilabad,Andhra Pradesh',
'Patnapur,Adilabad,Andhra Pradesh',
'Phulara,Adilabad,Andhra Pradesh',
'Pipri,Adilabad,Andhra Pradesh',
'Pulimadugu,Adilabad,Andhra Pradesh',
'Rasimetta,Adilabad,Andhra Pradesh',
'Salewada,Adilabad,Andhra Pradesh',
'Sangvi,Adilabad,Andhra Pradesh',
'Shampur,Adilabad,Andhra Pradesh',
'Shettihadapnur,Adilabad,Andhra Pradesh',
'Sirpur (U),Adilabad,Andhra Pradesh',
'Tadihadapnur,Adilabad,Andhra Pradesh',
'Tosham,Adilabad,Andhra Pradesh',
'Umri,Adilabad,Andhra Pradesh',
'Ushegaon,Adilabad,Andhra Pradesh',
'Wadgaon,Adilabad,Andhra Pradesh',
'Yenda,Adilabad,Andhra Pradesh',
'Brahma Samudram,Anantapur,Andhra Pradesh',
'Jayalakshmipuram,Anantapur,Andhra Pradesh',
'Mulakaledu,Anantapur,Andhra Pradesh',
'Rudrampeta,Anantapur,Andhra Pradesh',
'Agali,Hindupur,Andhra Pradesh',
'Dokkalahalli,Hindupur,Andhra Pradesh',
'Hallikera,Hindupur,Andhra Pradesh',
'Hallikera Devarahalli,Hindupur,Andhra Pradesh',
'Haludi,Hindupur,Andhra Pradesh',
'Inagalur,Hindupur,Andhra Pradesh',
'Karidasanahalli,Hindupur,Andhra Pradesh',
'Kodihalli,Hindupur,Andhra Pradesh',
'Madhudi,Hindupur,Andhra Pradesh',
'Narasambudi,Hindupur,Andhra Pradesh',
'P.Byadagere,Hindupur,Andhra Pradesh',
'Ragalinganahalli,Hindupur,Andhra Pradesh',
'Amadagur,Hindupur,Andhra Pradesh',
'Chikirevulapalli,Hindupur,Andhra Pradesh',
'Chinnaganapalle,Hindupur,Andhra Pradesh',
'Kancharavandlapalli,Hindupur,Andhra Pradesh',
'Kassamudram,Hindupur,Andhra Pradesh',
'Pulikintapalli,Hindupur,Andhra Pradesh',
'Thummala,Hindupur,Andhra Pradesh',
'Javukulakothapalle,Hindupur,Andhra Pradesh',
'Mohammadabad,Hindupur,Andhra Pradesh',
'Niluvarathipalli,Hindupur,Andhra Pradesh',
'Agraharam,Hindupur,Andhra Pradesh',
'Aladahalli,Hindupur,Andhra Pradesh',
'Amarapuram,Hindupur,Andhra Pradesh',
'Basavanahalli,Hindupur,Andhra Pradesh',
'Chitnaduku,Hindupur,Andhra Pradesh',
'Halkur,Hindupur,Andhra Pradesh',
'Hemavathi,Hindupur,Andhra Pradesh',
'Kenkara,Hindupur,Andhra Pradesh',
'Maddanakunta,Hindupur,Andhra Pradesh',
'Nidraghatta,Hindupur,Andhra Pradesh',
'Sivaram,Hindupur,Andhra Pradesh',
'Tammadehalli,Hindupur,Andhra Pradesh',
'Valasa,Hindupur,Andhra Pradesh',
'Arakatavemula,Anantapur,Andhra Pradesh',
'Chikkepalli,Anantapur,Andhra Pradesh',
'Kadavakallu,Anantapur,Andhra Pradesh',
'Thabjula,Anantapur,Andhra Pradesh',
'A Narayanapuram,Anantapur,Andhra Pradesh',
'Alamuru,Anantapur,Andhra Pradesh',
'Anantapur Collectorate,Anantapur,Andhra Pradesh',
'Anantapur Engg College,Anantapur,Andhra Pradesh',
'Anantapur H.O,Anantapur,Andhra Pradesh',
'Aravindanagar,Anantapur,Andhra Pradesh',
'Ayyavaripalli,Anantapur,Andhra Pradesh',
'Bramhanayaleru,Anantapur,Andhra Pradesh',
'Bukkacherla,Anantapur,Andhra Pradesh',
'Chiyyedu,Anantapur,Andhra Pradesh',
'Gandhibazar,Anantapur,Andhra Pradesh',
'Georgepet,Anantapur,Andhra Pradesh',
'Kakkalapalli Colony,Anantapur,Andhra Pradesh',
'Kakkalpalli,Anantapur,Andhra Pradesh',
'Kamalanagar,Anantapur,Andhra Pradesh',
'Mannila,Anantapur,Andhra Pradesh',
'Motilal Street,Anantapur,Andhra Pradesh',
'Narasanenikunta,Anantapur,Andhra Pradesh',
'Old Town,Anantapur,Andhra Pradesh',
'P.T.C,Anantapur,Andhra Pradesh',
'Patel Road,Anantapur,Andhra Pradesh',
'Pulukunta,Anantapur,Andhra Pradesh',
'Rachanapalli,Anantapur,Andhra Pradesh',
'Rajaji Street,Anantapur,Andhra Pradesh',
'Ramachandra Nagar,Anantapur,Andhra Pradesh',
'Ramnagar,Anantapur,Andhra Pradesh',
'Revenue Colony,Anantapur,Andhra Pradesh',
'Sainagar,Anantapur,Andhra Pradesh',
'Satyanandanagar,Anantapur,Andhra Pradesh',
'Sbmv Raod,Anantapur,Andhra Pradesh',
'Somaladoddi,Anantapur,Andhra Pradesh',
'Sri Venkateswara Puram,Anantapur,Andhra Pradesh',
'Subash Road,Anantapur,Andhra Pradesh',
'Tapovanagar,Anantapur,Andhra Pradesh',
'Upparapalli,Anantapur,Andhra Pradesh',
'Atmakur(ATP),Anantapur,Andhra Pradesh',
'Goridindla,Anantapur,Andhra Pradesh',
'Kamarupalli,Anantapur,Andhra Pradesh',
'Kothapalli,Anantapur,Andhra Pradesh',
'Kurugunta,Anantapur,Andhra Pradesh',
'Madigubba,Anantapur,Andhra Pradesh',
'Muttala,Anantapur,Andhra Pradesh',
'Oddupalli,Anantapur,Andhra Pradesh',
'P Siddarampuram,Anantapur,Andhra Pradesh',
'P Yaleru,Anantapur,Andhra Pradesh',
'Sanapa,Anantapur,Andhra Pradesh',
'Talupuru,Anantapur,Andhra Pradesh',
'Danduvaripalli,Anantapur,Andhra Pradesh',
'Nallaboyanapalle,Hindupur,Andhra Pradesh',
'Obulapuram,Hindupur,Andhra Pradesh',
'Sangala,Hindupur,Andhra Pradesh',
'Apprascheruvu,Hindupur,Andhra Pradesh',
'Bathalapalli,Hindupur,Andhra Pradesh',
'D.Cherlopalli,Hindupur,Andhra Pradesh',
'Dampetla,Hindupur,Andhra Pradesh',
'Garisalapalli,Hindupur,Andhra Pradesh',
'Ghantapuram,Hindupur,Andhra Pradesh',
'Malyavantham,Hindupur,Andhra Pradesh',
'Musturu,Hindupur,Andhra Pradesh',
'Narasimpalli,Hindupur,Andhra Pradesh',
'Potlamarri,Hindupur,Andhra Pradesh',
'Sanjeevapuram,Hindupur,Andhra Pradesh',
'Ankampalli,Anantapur,Andhra Pradesh',
'Avulanna,Anantapur,Andhra Pradesh',
'Belguppa,Anantapur,Andhra Pradesh',
'Duddekunta,Anantapur,Andhra Pradesh',
'Gangavaram,Anantapur,Andhra Pradesh',
'Kalvapalli,Anantapur,Andhra Pradesh',
'Nakkalapalli,Anantapur,Andhra Pradesh',
'Narasapuram,Anantapur,Andhra Pradesh',
'Narinjagundlapalli,Anantapur,Andhra Pradesh',
'Ramasagaram,Anantapur,Andhra Pradesh',
'Seeripi,Anantapur,Andhra Pradesh',
'Srirangapuram,Anantapur,Andhra Pradesh',
'Thagguparthi,Anantapur,Andhra Pradesh',
'Yelagalavanka,Anantapur,Andhra Pradesh',
'Yerragudi,Anantapur,Andhra Pradesh',
'Bommaganipalli,Anantapur,Andhra Pradesh',
'Bollanaguddem,Guntakal,Andhra Pradesh',
'Bommanahal,Guntakal,Andhra Pradesh',
'Devagiri,Guntakal,Andhra Pradesh',
'Gonehal,Guntakal,Andhra Pradesh',
'Govindawada,Guntakal,Andhra Pradesh',
'Honnur,Guntakal,Andhra Pradesh',
'Kolaganahalli,Guntakal,Andhra Pradesh',
'Kudlur,Guntakal,Andhra Pradesh',
'Kuruvalli,Guntakal,Andhra Pradesh',
'Nemakallu,Guntakal,Andhra Pradesh',
'Singanahalli,Guntakal,Andhra Pradesh',
'Sreedharghatta,Guntakal,Andhra Pradesh',
'Uddihal,Guntakal,Andhra Pradesh',
'Unthakallu,Guntakal,Andhra Pradesh',
'Bhyrasamudram,Anantapur,Andhra Pradesh',
'Budimepalli,Anantapur,Andhra Pradesh',
'Gonchireddypalli,Anantapur,Andhra Pradesh',
'Kannepalli,Anantapur,Andhra Pradesh',
'Konapuram,Anantapur,Andhra Pradesh',
'Mamaduru,Anantapur,Andhra Pradesh',
'Muppalakunta,Anantapur,Andhra Pradesh',
'Pillalapalli,Anantapur,Andhra Pradesh',
'Gundiganipalli,Guntakal,Andhra Pradesh',
'Kodihalli West,Guntakal,Andhra Pradesh',
'Rayalappadoddi,Anantapur,Andhra Pradesh',
'Vepalaparthy,Guntakal,Andhra Pradesh',
'Cheliminahalli,Anantapur,Andhra Pradesh',
'Theetakallu,Anantapur,Andhra Pradesh',
'Agraharam,Hindupur,Andhra Pradesh',
'Buchayyagaripalli,Hindupur,Andhra Pradesh',
'Bukkapatnam,Hindupur,Andhra Pradesh',
'Gasikavaripalli,Hindupur,Andhra Pradesh',
'Gunipalli,Hindupur,Andhra Pradesh',
'Kothakota,Hindupur,Andhra Pradesh',
'Krishnapuram,Hindupur,Andhra Pradesh',
'Marala,Hindupur,Andhra Pradesh',
'Narasimpalli Thanda,Hindupur,Andhra Pradesh',
'Pamudurthi,Hindupur,Andhra Pradesh',
'Ramasagaram,Hindupur,Andhra Pradesh',
'Siddarampuram,Hindupur,Andhra Pradesh',
'Chennampalli,Anantapur,Andhra Pradesh',
'Julakalva,Anantapur,Andhra Pradesh',
'Podaralla,Anantapur,Andhra Pradesh',
'Vadiampeta,Anantapur,Andhra Pradesh',
'Janthaluru,Anantapur,Andhra Pradesh',
'K.K.Agraharam,Anantapur,Andhra Pradesh',
'Korrapadu,Anantapur,Andhra Pradesh',
'Peravali,Anantapur,Andhra Pradesh',
'Reddipalli,Anantapur,Andhra Pradesh',
'Rotarypuram,Anantapur,Andhra Pradesh',
'Siddarampuram,Anantapur,Andhra Pradesh',
'Venkatapuram,Anantapur,Andhra Pradesh',
'Bukkarayasamudram,Anantapur,Andhra Pradesh',
'Amidalakunta,Hindupur,Andhra Pradesh',
'Basampalli,Hindupur,Andhra Pradesh',
'Kanumukkala,Hindupur,Andhra Pradesh',
'Medapuram,Hindupur,Andhra Pradesh',
'Mustikovela,Hindupur,Andhra Pradesh',
'Nagasamudram,Hindupur,Andhra Pradesh',
'Nyamaddala,Hindupur,Andhra Pradesh',
'Puletipalli,Hindupur,Andhra Pradesh',
'Pyadindi,Hindupur,Andhra Pradesh',
'Veldurthi,Hindupur,Andhra Pradesh',
'Venkatampalli,Hindupur,Andhra Pradesh',
'Ganginepalli,Hindupur,Andhra Pradesh',
'Chennekothapalli,Hindupur,Andhra Pradesh',
'Bhupasamudram,Hindupur,Andhra Pradesh',
'Chagaleru,Hindupur,Andhra Pradesh',
'Chilamathur,Hindupur,Andhra Pradesh',
'Demakethapalli,Hindupur,Andhra Pradesh',
'Kanisettipalli,Hindupur,Andhra Pradesh',
'Kodikonda,Hindupur,Andhra Pradesh',
'Kodur,Hindupur,Andhra Pradesh',
'Lalepalli,Hindupur,Andhra Pradesh',
'Morampalle,Hindupur,Andhra Pradesh',
'Morasalapalli,Hindupur,Andhra Pradesh',
'Nesevandlapalli,Hindupur,Andhra Pradesh',
'Somagatta,Hindupur,Andhra Pradesh',
'Tekulodu,Hindupur,Andhra Pradesh',
'Thummalakunta,Hindupur,Andhra Pradesh',
'Veerapuram,Hindupur,Andhra Pradesh',
'Badannapalli,Hindupur,Andhra Pradesh',
'Chigicherla,Hindupur,Andhra Pradesh',
'Darsimala,Hindupur,Andhra Pradesh',
'Dharmavaram Bazar,Hindupur,Andhra Pradesh',
'Dharmavaram H.O,Hindupur,Andhra Pradesh',
'Dharmavaram R.S,Hindupur,Andhra Pradesh',
'Elukuntla,Hindupur,Andhra Pradesh',
'Gotluru,Hindupur,Andhra Pradesh',
'Kunuthuru,Hindupur,Andhra Pradesh',
'Mallakalva,Hindupur,Andhra Pradesh',
'Nelakota,Hindupur,Andhra Pradesh',
'Pinnadhari,Hindupur,Andhra Pradesh',
'Pothulanagepalli,Hindupur,Andhra Pradesh',
'Ravulacheruvu,Hindupur,Andhra Pradesh',
'Regatipalli,Hindupur,Andhra Pradesh',
'Subbaraopeta,Hindupur,Andhra Pradesh',
'Thummala,Hindupur,Andhra Pradesh',
'Gandlapenta,Hindupur,Andhra Pradesh',
'Jeenulakunta,Hindupur,Andhra Pradesh',
'Kamatampalle,Hindupur,Andhra Pradesh',
'Katakamvaripalli,Hindupur,Andhra Pradesh',
'Katarupalle,Hindupur,Andhra Pradesh',
'Kurumamidi,Hindupur,Andhra Pradesh',
'Malamidipalli,Hindupur,Andhra Pradesh',
'Guddalapalli,Anantapur,Andhra Pradesh',
'Jambuladinne,Anantapur,Andhra Pradesh',
'Kallur R.S.,Guntakal,Andhra Pradesh',
'Kanampalli,Anantapur,Andhra Pradesh',
'Kotanka,Anantapur,Andhra Pradesh',
'Kothapalli,Anantapur,Andhra Pradesh',
'M.P.R.Site,Anantapur,Andhra Pradesh',
'Marthadu,Anantapur,Andhra Pradesh',
'Penakacherla,Anantapur,Andhra Pradesh',
'Taticherla,Anantapur,Andhra Pradesh',
'Thimmampeta,Anantapur,Andhra Pradesh',
'Yerraguntla,Anantapur,Andhra Pradesh',
'Garladinne,Anantapur,Andhra Pradesh',
'Illuru,Guntakal,Andhra Pradesh',
'Kesavapuram,Guntakal,Andhra Pradesh',
'Koppalakonda,Guntakal,Andhra Pradesh',
'Muntimadugu,Guntakal,Andhra Pradesh',
'Basinepalli,Guntakal,Andhra Pradesh',
'Bethapalli,Guntakal,Andhra Pradesh',
'Brahmanapalli,Guntakal,Andhra Pradesh',
'Gollaladoddi,Guntakal,Andhra Pradesh',
'Gooty Bazaar,Guntakal,Andhra Pradesh',
'Gooty R.S.,Guntakal,Andhra Pradesh',
'Gooty,Guntakal,Andhra Pradesh',
'Gootyanantapur,Guntakal,Andhra Pradesh',
'Isurallapalli,Guntakal,Andhra Pradesh',
'Jakkalacheruvu,Guntakal,Andhra Pradesh',
'Karidikonda,Guntakal,Andhra Pradesh',
'Kojjepalli,Guntakal,Andhra Pradesh',
'Konganapalli,Guntakal,Andhra Pradesh',
'Kothapeta(Gooty),Guntakal,Andhra Pradesh',
'Mamadur,Guntakal,Andhra Pradesh',
'Nagasamudram,Guntakal,Andhra Pradesh',
'Pathakothacheruvu,Guntakal,Andhra Pradesh',
'Pedoddi,Guntakal,Andhra Pradesh',
'Rajapuram,Guntakal,Andhra Pradesh',
'Thondapadu,Guntakal,Andhra Pradesh',
'Y.T.Cheruvu,Guntakal,Andhra Pradesh',
'Budidagaddapalli,Hindupur,Andhra Pradesh',
'Budili,Hindupur,Andhra Pradesh',
'Budilisettipalli,Hindupur,Andhra Pradesh',
'Gangampalli,Hindupur,Andhra Pradesh',
'Gorantla,Hindupur,Andhra Pradesh',
'Gownivaripalli,Hindupur,Andhra Pradesh',
'Gummaiahgaripalli,Hindupur,Andhra Pradesh',
'Jakkasamudram,Hindupur,Andhra Pradesh',
'Kaganapalli,Hindupur,Andhra Pradesh',
'Kallagiri,Hindupur,Andhra Pradesh',
'Kammavaripalli,Hindupur,Andhra Pradesh',
'Karavulapalli,Hindupur,Andhra Pradesh',
'Kondapuram,Hindupur,Andhra Pradesh',
'Mallapalli,Hindupur,Andhra Pradesh',
'Mandalapalle,Hindupur,Andhra Pradesh',
'Palasamudram,Hindupur,Andhra Pradesh',
'Puleru,Hindupur,Andhra Pradesh',
'Reddicheruvupalli,Hindupur,Andhra Pradesh',
'Vadigepalli,Hindupur,Andhra Pradesh',
'Vanavolu,Hindupur,Andhra Pradesh',
'Bommagondanahalli,Hindupur,Andhra Pradesh',
'Chikkachoragiri,Hindupur,Andhra Pradesh',
'Guddadahalli,Hindupur,Andhra Pradesh',
'Gudibanda,Hindupur,Andhra Pradesh',
'Gunemorubagal,Hindupur,Andhra Pradesh',
'Hirethurpi,Hindupur,Andhra Pradesh',
'Jambalabanda,Hindupur,Andhra Pradesh',
'Karikera,Hindupur,Andhra Pradesh',
'Konkallu,Hindupur,Andhra Pradesh',
'Kumbaranagenahalli,Hindupur,Andhra Pradesh',
'Mandalahalli,Hindupur,Andhra Pradesh',
'Morubagalu,Hindupur,Andhra Pradesh',
'Muthukur,Hindupur,Andhra Pradesh',
'Nachenahalli,Hindupur,Andhra Pradesh',
'Phalaram,Hindupur,Andhra Pradesh',
'Rallahalli,Hindupur,Andhra Pradesh',
'S.Rayapuram,Hindupur,Andhra Pradesh',
'Sankarakallu,Hindupur,Andhra Pradesh',
'75-veerapuram,Guntakal,Andhra Pradesh',
'B.T.Project,Guntakal,Andhra Pradesh',
'Belodu,Guntakal,Andhra Pradesh',
'Gollapalli,Guntakal,Andhra Pradesh',
'Gonabhavi,Guntakal,Andhra Pradesh',
'Gummaghatta,Guntakal,Andhra Pradesh',
'Kalugodu,Guntakal,Andhra Pradesh',
'Pulakunta,Guntakal,Andhra Pradesh',
'R.Kothapalli,Guntakal,Andhra Pradesh',
'Tallakera,Guntakal,Andhra Pradesh',
'Netrapalli,Guntakal,Andhra Pradesh',
'Rangachedu,Guntakal,Andhra Pradesh',
'Ayyavaripalli,Guntakal,Andhra Pradesh',
'Dosaludiki,Guntakal,Andhra Pradesh',
'Guntakal H.O,Guntakal,Andhra Pradesh',
'Guntakal Market,Guntakal,Andhra Pradesh',
'Hanumesh Nagar,Guntakal,Andhra Pradesh',
'Kasapuram,Guntakal,Andhra Pradesh',
'Kottala,Guntakal,Andhra Pradesh',
'Modinabad,Guntakal,Andhra Pradesh',
'N.Narsapuram,Guntakal,Andhra Pradesh',
'N.Thimmapuram,Guntakal,Andhra Pradesh',
'Nakkanadoddi,Guntakal,Andhra Pradesh',
'Nelagonda,Guntakal,Andhra Pradesh',
'Old Guntakal,Guntakal,Andhra Pradesh',
'Railway Colony,Guntakal,Andhra Pradesh',
'Rajendra Nagar,Guntakal,Andhra Pradesh',
'Satyanarayanapete,Guntakal,Andhra Pradesh',
'Thimmapuram,Guntakal,Andhra Pradesh',
'Timmanacharla,Guntakal,Andhra Pradesh',
'Godasalapalli,Guntakal,Andhra Pradesh',
'Herial,Guntakal,Andhra Pradesh',
'Kadalur,Guntakal,Andhra Pradesh',
'Kalyam,Guntakal,Andhra Pradesh',
'Muradi,Guntakal,Andhra Pradesh',
'Muradi Hanumapuram,Guntakal,Andhra Pradesh',
'Nagalapuram,Guntakal,Andhra Pradesh',
'Obulapuram,Guntakal,Andhra Pradesh',
'Pulakurthy,Guntakal,Andhra Pradesh',
'Somalapuram,Guntakal,Andhra Pradesh',
'Bevinahalli,Hindupur,Andhra Pradesh',
'Birepalli,Hindupur,Andhra Pradesh',
'Chalivendla,Hindupur,Andhra Pradesh',
'Chowluru,Hindupur,Andhra Pradesh',
'Gollapuram,Hindupur,Andhra Pradesh',
'Hindupur Bazar,Hindupur,Andhra Pradesh',
'Hindupur Extns,Hindupur,Andhra Pradesh',
'Hindupur Fort,Hindupur,Andhra Pradesh',
'Hindupur H.O,Hindupur,Andhra Pradesh',
'Kaggallu,Hindupur,Andhra Pradesh',
'Kirikera,Hindupur,Andhra Pradesh',
'Kotipi,Hindupur,Andhra Pradesh',
'Kotnur,Hindupur,Andhra Pradesh',
'M.F.Road,Hindupur,Andhra Pradesh',
'Malugur,Hindupur,Andhra Pradesh',
'Manesamudram,Hindupur,Andhra Pradesh',
'Moda,Hindupur,Andhra Pradesh',
'Mothukapalli,Hindupur,Andhra Pradesh',
'Muddireddipalli,Hindupur,Andhra Pradesh',
'Pulakunta,Hindupur,Andhra Pradesh',
'S.Sadlapalli,Hindupur,Andhra Pradesh',
'Santhebidanur,Hindupur,Andhra Pradesh',
'Chippalamadugu,Hindupur,Andhra Pradesh',
'Clock Tower Kadiri,Hindupur,Andhra Pradesh',
'Erradoddi,Hindupur,Andhra Pradesh',
'K.Brahmanapalli,Hindupur,Andhra Pradesh',
'Kadiri Chowk,Hindupur,Andhra Pradesh',
'Kadiri,Hindupur,Andhra Pradesh',
'Kadirikuntalapalli,Hindupur,Andhra Pradesh',
'Kalasamudram,Hindupur,Andhra Pradesh',
'Kondamanayanipalem,Hindupur,Andhra Pradesh',
'Kowlepalli,Hindupur,Andhra Pradesh',
'Kutagulla,Hindupur,Andhra Pradesh',
'Mundy Bazar Kadiri,Hindupur,Andhra Pradesh',
'Muthyalacheruvu,Hindupur,Andhra Pradesh',
'Neerukuntapalle,Hindupur,Andhra Pradesh',
'Pandulakunta,Hindupur,Andhra Pradesh',
'Manirevu,Anantapur,Andhra Pradesh',
'Bavarampalli,Anantapur,Andhra Pradesh',
'Bhattuvanipalli,Anantapur,Andhra Pradesh',
'Chapiri,Anantapur,Andhra Pradesh',
'Dasampalli,Anantapur,Andhra Pradesh',
'Dodagatta,Anantapur,Andhra Pradesh',
'Durdakunta,Anantapur,Andhra Pradesh',
'Golla,Anantapur,Andhra Pradesh',
'Gubanapalli,Anantapur,Andhra Pradesh',
'K Garudapuram,Anantapur,Andhra Pradesh',
'Kalyandurg Bazar,Anantapur,Andhra Pradesh',
'Kalyandurg,Anantapur,Andhra Pradesh',
'Kodipalli East,Anantapur,Andhra Pradesh',
'Kurabanahalli,Anantapur,Andhra Pradesh',
'Muddinayanipalli,Anantapur,Andhra Pradesh',
'Mudigal,Anantapur,Andhra Pradesh',
'Narayanapuram,Anantapur,Andhra Pradesh',
'Ontimiddi,Anantapur,Andhra Pradesh',
'Palavoyi,Anantapur,Andhra Pradesh',
'Papampalli,Anantapur,Andhra Pradesh',
'Thimmasamudram,Anantapur,Andhra Pradesh',
'Virupapalli,Anantapur,Andhra Pradesh',
'Vitlampalli,Anantapur,Andhra Pradesh',
'Yatakal,Anantapur,Andhra Pradesh',
'Yerrampalli,Anantapur,Andhra Pradesh',
'Handepalli,Anantapur,Andhra Pradesh',
'Kadiridevarapalli,Anantapur,Andhra Pradesh',
'Kambadur,Anantapur,Andhra Pradesh',
'Karthanaparthi,Anantapur,Andhra Pradesh',
'Marrimakulapalli,Anantapur,Andhra Pradesh',
'Mulakanur,Anantapur,Andhra Pradesh',
'Nuthimadugu,Anantapur,Andhra Pradesh',
'Palluru,Anantapur,Andhra Pradesh',
'Ramapuram,Anantapur,Andhra Pradesh',
'Thimmapuram,Anantapur,Andhra Pradesh',
'Vontareddipalli,Anantapur,Andhra Pradesh',
'Yenumulachennampalli,Anantapur,Andhra Pradesh',
'Achampalle,Hindupur,Andhra Pradesh',
'Chennampalli,Hindupur,Andhra Pradesh',
'Kurakulapalli,Hindupur,Andhra Pradesh',
'Ralla Anantapuram,Hindupur,Andhra Pradesh',
'Tallimadugu,Hindupur,Andhra Pradesh',
'Bhadrapuram,Hindupur,Andhra Pradesh',
'Bhanukota,Hindupur,Andhra Pradesh',
'Chennamanayani Kota,Hindupur,Andhra Pradesh',
'Dadalur,Hindupur,Andhra Pradesh',
'Elakuntla,Hindupur,Andhra Pradesh',
'Gandlaparthi,Hindupur,Andhra Pradesh',
'Kanaganapalli,Hindupur,Andhra Pradesh',
'Konetinayanipalem,Hindupur,Andhra Pradesh',
'Maddalacheruvu,Hindupur,Andhra Pradesh',
'Mukthapuram,Hindupur,Andhra Pradesh',
'Narasampalli,Hindupur,Andhra Pradesh',
'Sandrascherla,Hindupur,Andhra Pradesh',
'Thogarakunta,Hindupur,Andhra Pradesh',
'Thopudurthi,Hindupur,Andhra Pradesh',
'Thumucherla,Hindupur,Andhra Pradesh',
'Vepakunta,Hindupur,Andhra Pradesh',
'Kandukur,Anantapur,Andhra Pradesh',
'Brahmasamudram,Guntakal,Andhra Pradesh',
'Ganigera,Guntakal,Andhra Pradesh',
'Garudachedu,Guntakal,Andhra Pradesh',
'Hanakanahal,Anantapur,Andhra Pradesh',
'Kalekurthy,Guntakal,Andhra Pradesh',
'Kanekal,Guntakal,Andhra Pradesh',
'Malyam,Guntakal,Andhra Pradesh',
'Pulicherla,Guntakal,Andhra Pradesh',
'Yerragunta,Guntakal,Andhra Pradesh',
'Bandlapalli,Hindupur,Andhra Pradesh',
'Byrapuram,Hindupur,Andhra Pradesh',
'Chennarajupalli,Hindupur,Andhra Pradesh',
'Kanisettipalli,Hindupur,Andhra Pradesh',
'Kesapuram,Hindupur,Andhra Pradesh',
'Kodapaganipalli,Hindupur,Andhra Pradesh',
'Kothacheruvu,Hindupur,Andhra Pradesh',
'Locherla,Hindupur,Andhra Pradesh',
'Marakuntapalli,Hindupur,Andhra Pradesh',
'Mirjapuram,Hindupur,Andhra Pradesh',
'Mylasamudram,Hindupur,Andhra Pradesh',
'Nagireddipalli,Hindupur,Andhra Pradesh',
'Narepalli,Hindupur,Andhra Pradesh',
'Pothulakunta,Hindupur,Andhra Pradesh',
'Talamarla,Hindupur,Andhra Pradesh',
'Cholasamudram,Anantapur,Andhra Pradesh',
'Gotkuru,Anantapur,Andhra Pradesh',
'Ipperu,Anantapur,Andhra Pradesh',
'Jallipalli,Anantapur,Andhra Pradesh',
'Kadadarakunta,Anantapur,Andhra Pradesh',
'Kalagalla,Anantapur,Andhra Pradesh',
'Kammuru,Anantapur,Andhra Pradesh',
'Karutlapalli,Anantapur,Andhra Pradesh',
'Korrakodu,Anantapur,Andhra Pradesh',
'Kuderu,Anantapur,Andhra Pradesh',
'Marutla,Anantapur,Andhra Pradesh',
'Muddalapuram,Anantapur,Andhra Pradesh',
'P Narayana Puram,Anantapur,Andhra Pradesh',
'Pabr Sam Site,Anantapur,Andhra Pradesh',
'Udiripikonda,Anantapur,Andhra Pradesh',
'Allapuram,Anantapur,Andhra Pradesh',
'Appilepalli,Anantapur,Andhra Pradesh',
'Basapuram,Anantapur,Andhra Pradesh',
'Bestharapalli,Anantapur,Andhra Pradesh',
'Jambugumpala,Anantapur,Andhra Pradesh',
'Kadarampalli,Anantapur,Andhra Pradesh',
'Kundurpi,Anantapur,Andhra Pradesh',
'Malayanuru,Anantapur,Andhra Pradesh',
'Nizava.Lli,Anantapur,Andhra Pradesh',
'Tenagal,Anantapur,Andhra Pradesh',
'Thumukunta,Anantapur,Andhra Pradesh',
'Vaddepalem,Anantapur,Andhra Pradesh',
'Yenumuladoddi,Anantapur,Andhra Pradesh',
'Bisalamanepalli,Hindupur,Andhra Pradesh',
'Cholasamudram,Hindupur,Andhra Pradesh',
'Galibipalli,Hindupur,Andhra Pradesh',
'Kalluru,Hindupur,Andhra Pradesh',
'Kanchisamudram,Hindupur,Andhra Pradesh',
'Kodihalli,Hindupur,Andhra Pradesh',
'Kondur,Hindupur,Andhra Pradesh',
'Lepakshi,Hindupur,Andhra Pradesh',
'Mamidimakulapalli,Hindupur,Andhra Pradesh',
'Manepalli,Hindupur,Andhra Pradesh',
'Mydugolam,Hindupur,Andhra Pradesh',
'P.Sadlapalli,Hindupur,Andhra Pradesh',
'Sirivaram,Hindupur,Andhra Pradesh',
'Amidalagondi,Hindupur,Andhra Pradesh',
'Aswartharayaniroppam,Hindupur,Andhra Pradesh',
'Bullasamudram,Hindupur,Andhra Pradesh',
'Byagarlapalli,Hindupur,Andhra Pradesh',
'Chandakacherla,Hindupur,Andhra Pradesh',
'Cheepuleti,Hindupur,Andhra Pradesh',
'Cherlokodigepalli,Hindupur,Andhra Pradesh',
'Gangulavaipalem,Hindupur,Andhra Pradesh',
'Govindapuram,Hindupur,Andhra Pradesh',
'Gowdanahalli,Hindupur,Andhra Pradesh',
'Guddamapalli,Hindupur,Andhra Pradesh',
'Gurrapukonda,Hindupur,Andhra Pradesh',
'Haresamudram,Hindupur,Andhra Pradesh',
'Kallumarri,Hindupur,Andhra Pradesh',
'Kothagundumala,Hindupur,Andhra Pradesh',
'Madakasira Bazar,Hindupur,Andhra Pradesh',
'Madakasira,Hindupur,Andhra Pradesh',
'Manur,Hindupur,Andhra Pradesh',
'Melavoy,Hindupur,Andhra Pradesh',
'Neelakantapuram,Hindupur,Andhra Pradesh',
'R.Anantapuram,Hindupur,Andhra Pradesh',
'Uppidipalli,Hindupur,Andhra Pradesh',
'Yelloti,Hindupur,Andhra Pradesh',
'Yerrabommanahalli,Hindupur,Andhra Pradesh',
'Zilladakunta,Hindupur,Andhra Pradesh',
'Venkayakalva,Anantapur,Andhra Pradesh',
'Budanampalle,Hindupur,Andhra Pradesh',
'Dorigallu,Hindupur,Andhra Pradesh',
'Enumulavaripalli,Hindupur,Andhra Pradesh',
'Gandlavandlapalli,Hindupur,Andhra Pradesh',
'Gunjepalli,Hindupur,Andhra Pradesh',
'Jonnalakothapalli,Hindupur,Andhra Pradesh',
'Kodavandlapalle,Hindupur,Andhra Pradesh',
'Kondaguttapalli,Hindupur,Andhra Pradesh',
'Malakavemula,Hindupur,Andhra Pradesh',
'Mallepalli,Hindupur,Andhra Pradesh',
'Mangalamadaka,Hindupur,Andhra Pradesh',
'Marthadu,Hindupur,Andhra Pradesh',
'Mudigubba,Hindupur,Andhra Pradesh',
'Mukthapuram,Hindupur,Andhra Pradesh',
'Nallacherlopalli,Hindupur,Andhra Pradesh',
'Podarallapalli,Hindupur,Andhra Pradesh',
'Sankepalle,Hindupur,Andhra Pradesh',
'Uppalapadu,Hindupur,Andhra Pradesh',
'Dhaniyancheruvu,Hindupur,Andhra Pradesh',
'East Nadimpalle,Hindupur,Andhra Pradesh',
'Gowkanapalle,Hindupur,Andhra Pradesh',
'Gutibailu,Hindupur,Andhra Pradesh',
'Marrikommadinne,Hindupur,Andhra Pradesh',
'Mekalacheruvu,Hindupur,Andhra Pradesh',
'N.P.Kunta,Hindupur,Andhra Pradesh',
'P.Kothapalli,Hindupur,Andhra Pradesh',
'Pedaballi,Hindupur,Andhra Pradesh',
'Velichelamala,Hindupur,Andhra Pradesh',
'Bommireddipalli,Hindupur,Andhra Pradesh',
'Chowtivaripalle,Hindupur,Andhra Pradesh',
'Kadiripulikunta,Hindupur,Andhra Pradesh',
'Nallacheruvu,Hindupur,Andhra Pradesh',
'P.Kothapalli,Hindupur,Andhra Pradesh',
'Peddayellampalli,Hindupur,Andhra Pradesh',
'Tavalamarri,Hindupur,Andhra Pradesh',
'Vubicherla,Hindupur,Andhra Pradesh',
'Vuruvoi-mallireddipalli,Hindupur,Andhra Pradesh',
'Badavandlapalli,Hindupur,Andhra Pradesh',
'Chinnarayanipalli,Hindupur,Andhra Pradesh',
'Chowtakuntapalli,Hindupur,Andhra Pradesh',
'Donnikota,Hindupur,Andhra Pradesh',
'Gopepalli,Hindupur,Andhra Pradesh',
'Kurumala,Hindupur,Andhra Pradesh',
'Kutalacheruvupalli,Hindupur,Andhra Pradesh',
'Nallamada,Hindupur,Andhra Pradesh',
'Patnam,Hindupur,Andhra Pradesh',
'Pemanakuntapalli Thanda,Hindupur,Andhra Pradesh',
'Pulagampalli,Hindupur,Andhra Pradesh',
'Reddipalli,Hindupur,Andhra Pradesh',
'Vankarakunta,Hindupur,Andhra Pradesh',
'Vellamaddi,Hindupur,Andhra Pradesh',
'Bandlapalli,Anantapur,Andhra Pradesh',
'Bondalawada,Anantapur,Andhra Pradesh',
'Chamaluru,Anantapur,Andhra Pradesh',
'Duggumarri,Anantapur,Andhra Pradesh',
'Ganganapalli,Anantapur,Andhra Pradesh',
'Gollapalli,Anantapur,Andhra Pradesh',
'Gugudu,Anantapur,Andhra Pradesh',
'H Sodanapalli,Anantapur,Andhra Pradesh',
'Kesepalli,Anantapur,Andhra Pradesh',
'Kuraganipalli,Anantapur,Andhra Pradesh',
'Madugupalli,Anantapur,Andhra Pradesh',
'Nadimidoddi,Anantapur,Andhra Pradesh',
'Narapla,Anantapur,Andhra Pradesh',
'Pappuru,Anantapur,Andhra Pradesh',
'Venkatampalli,Anantapur,Andhra Pradesh',
'Bonthalapalle,Hindupur,Andhra Pradesh',
'Dabburivaripalli,Hindupur,Andhra Pradesh',
'Eddulavaripalli,Hindupur,Andhra Pradesh',
'Gownipalli,Hindupur,Andhra Pradesh',
'Gowrapuram,Hindupur,Andhra Pradesh',
'Inagaluru,Hindupur,Andhra Pradesh',
'Kondakamarla,Hindupur,Andhra Pradesh',
'Nallaguttapalli,Hindupur,Andhra Pradesh',
'Nawabkota,Hindupur,Andhra Pradesh',
'Sunnampalle,Hindupur,Andhra Pradesh',
'Tangedikunta,Hindupur,Andhra Pradesh',
'Thippepalle,Hindupur,Andhra Pradesh',
'Thummalakuntapalli,Hindupur,Andhra Pradesh',
'Obula Devara Cheruvu,Hindupur,Andhra Pradesh',
'Anumpalli,Guntakal,Andhra Pradesh',
'Devarapalli,Guntakal,Andhra Pradesh',
'Eddulapalli,Guntakal,Andhra Pradesh',
'Edurur,Guntakal,Andhra Pradesh',
'G.Kottala,Guntakal,Andhra Pradesh',
'Gajarampalli,Guntakal,Andhra Pradesh',
'Kalapuram,Guntakal,Andhra Pradesh',
'Katakindapalli,Guntakal,Andhra Pradesh',
'Katrimala,Guntakal,Andhra Pradesh',
'Khaderpeta,Guntakal,Andhra Pradesh',
'Palyam,Guntakal,Andhra Pradesh',
'Pamidi Bus Stand,Guntakal,Andhra Pradesh',
'Pamidi,Guntakal,Andhra Pradesh',
'Ramarajupalli,Guntakal,Andhra Pradesh',
'Vankarajukalva,Guntakal,Andhra Pradesh',
'Beechaganipalli,Hindupur,Andhra Pradesh',
'Gollapalli,Hindupur,Andhra Pradesh',
'Hindupur Sevamandir,Hindupur,Andhra Pradesh',
'Honnampalli,Hindupur,Andhra Pradesh',
'Narasapuram,Hindupur,Andhra Pradesh',
'Parigi,Hindupur,Andhra Pradesh',
'Sasanakota,Hindupur,Andhra Pradesh',
'Sirekolam,Hindupur,Andhra Pradesh',
'Srirangarajupalli,Hindupur,Andhra Pradesh',
'Utakur,Hindupur,Andhra Pradesh',
'Vittapalli,Hindupur,Andhra Pradesh',
'Yerragunta,Hindupur,Andhra Pradesh',
'Chinnavadugur,Guntakal,Andhra Pradesh',
'Dimmagudi,Guntakal,Andhra Pradesh',
'Lachumpalli,Guntakal,Andhra Pradesh',
'Mallenipalli,Guntakal,Andhra Pradesh',
'Miduthur,Guntakal,Andhra Pradesh',
'Pedda Vadagur,Guntakal,Andhra Pradesh',
'Teliki,Guntakal,Andhra Pradesh',
'Brahmanapalli,Guntakal,Andhra Pradesh',
'Cheemalavagupalli,Guntakal,Andhra Pradesh',
'Narasapuram,Guntakal,Andhra Pradesh',
'Pasalur,Guntakal,Andhra Pradesh',
'Peddayakkalur,Guntakal,Andhra Pradesh',
'Juturu,Anantapur,Andhra Pradesh',
'Appecharla,Guntakal,Andhra Pradesh',
'Chintalacheruvu,Guntakal,Andhra Pradesh',
'Chitrachedu,Guntakal,Andhra Pradesh',
'Chittur,Guntakal,Andhra Pradesh',
'Krishtipadu,Guntakal,Andhra Pradesh',
'Ravuludiki,Guntakal,Andhra Pradesh',
'Adadakulapalli,Hindupur,Andhra Pradesh',
'Duddebanda,Hindupur,Andhra Pradesh',
'Gonipeta,Hindupur,Andhra Pradesh',
'Guttur,Hindupur,Andhra Pradesh',
'Hanumpalli,Hindupur,Andhra Pradesh',
'Konapuram,Hindupur,Andhra Pradesh',
'Kondapuram,Hindupur,Andhra Pradesh',
'Kurubavandlapalli,Hindupur,Andhra Pradesh',
'Mavatur,Hindupur,Andhra Pradesh',
'Munimadugu,Hindupur,Andhra Pradesh',
'Nagalur,Hindupur,Andhra Pradesh',
'Penukonda Fort,Hindupur,Andhra Pradesh',
'Penukonda,Hindupur,Andhra Pradesh',
'Puttaparthi,Hindupur,Andhra Pradesh',
'Settipalli,Hindupur,Andhra Pradesh',
'Suddakuntapalli,Hindupur,Andhra Pradesh',
'Thurukalapatnam,Hindupur,Andhra Pradesh',
'Venkatagiripalem,Hindupur,Andhra Pradesh',
'Venkatareddipalli,Hindupur,Andhra Pradesh',
'Prasanthinilayam,Hindupur,Andhra Pradesh',
'Chalivemula,Anantapur,Andhra Pradesh',
'Cherlopalli,Anantapur,Andhra Pradesh',
'Chintakunta,Anantapur,Andhra Pradesh',
'Garuguchintalapallo,Anantapur,Andhra Pradesh',
'Komatikuntla,Anantapur,Andhra Pradesh',
'Kummanamala,Anantapur,Andhra Pradesh',
'Maddipalli,Anantapur,Andhra Pradesh',
'Obulapuram,Anantapur,Andhra Pradesh',
'Putlur,Anantapur,Andhra Pradesh',
'Takkalapalli,Anantapur,Andhra Pradesh',
'Yellutla,Anantapur,Andhra Pradesh',
'Senagalaguduru,Anantapur,Andhra Pradesh',
'Amagondapalem,Hindupur,Andhra Pradesh',
'Badenaikthanda,Hindupur,Andhra Pradesh',
'Beedupalli,Hindupur,Andhra Pradesh',
'Brahmanapalle,Hindupur,Andhra Pradesh',
'Eguvagangireddipalli,Hindupur,Andhra Pradesh',
'Guvvalaguttapalli,Hindupur,Andhra Pradesh',
'Jagarajupalli,Hindupur,Andhra Pradesh',
'Kappalabanda,Hindupur,Andhra Pradesh',
'Kotlapalli,Hindupur,Andhra Pradesh',
'Nidimamidi,Hindupur,Andhra Pradesh',
'Pedaballi,Hindupur,Andhra Pradesh',
'Rachavaraipalli,Hindupur,Andhra Pradesh',
'Venkatagaripalli,Hindupur,Andhra Pradesh',
'Yenumulapalli,Hindupur,Andhra Pradesh',
'Vengalammacheruvu,Hindupur,Andhra Pradesh',
'Rayadurg Fort,Guntakal,Andhra Pradesh',
'Gantimarri,Hindupur,Andhra Pradesh',
'Garimakulapalli,Hindupur,Andhra Pradesh',
'Kondapuram,Hindupur,Andhra Pradesh',
'Kuntimaddi,Hindupur,Andhra Pradesh',
'Motorchintalapalle,Hindupur,Andhra Pradesh',
'N.Madapuram,Hindupur,Andhra Pradesh',
'Nasanakota,Hindupur,Andhra Pradesh',
'Pitchireddikottala,Hindupur,Andhra Pradesh',
'Polepalli,Hindupur,Andhra Pradesh',
'Ramagiri,Hindupur,Andhra Pradesh',
'Perur,Hindupur,Andhra Pradesh',
'Bandameedapalli,Hindupur,Andhra Pradesh',
'Maruru,Hindupur,Andhra Pradesh',
'Palacherla,Hindupur,Andhra Pradesh',
'Yerragunta,Hindupur,Andhra Pradesh',
'Gondireddypalli,Anantapur,Andhra Pradesh',
'Hampapuram,Anantapur,Andhra Pradesh',
'Raptadu,Anantapur,Andhra Pradesh',
'Avuladatla,Guntakal,Andhra Pradesh',
'B.N.Halli,Guntakal,Andhra Pradesh',
'Bhupasamudram,Guntakal,Andhra Pradesh',
'Bommakkapalli,Guntakal,Andhra Pradesh',
'Chadam,Guntakal,Andhra Pradesh',
'Darga Kondaopuram,Guntakal,Andhra Pradesh',
'Gramadatla,Guntakal,Andhra Pradesh',
'Junjurampalli,Guntakal,Andhra Pradesh',
'Kenchanapalli,Guntakal,Andhra Pradesh',
'Lakshmi Bazar,Guntakal,Andhra Pradesh',
'Pallepalli,Guntakal,Andhra Pradesh',
'Polepalli,Guntakal,Andhra Pradesh',
'R.B.Vanka,Guntakal,Andhra Pradesh',
'Rayadurg Bazar,Guntakal,Andhra Pradesh',
'Rayadurg,Guntakal,Andhra Pradesh',
'T.Veerapuram,Guntakal,Andhra Pradesh',
'Udegolam,Guntakal,Andhra Pradesh',
'Veparalla,Guntakal,Andhra Pradesh',
'Bucherla,Hindupur,Andhra Pradesh',
'Cherukuru,Hindupur,Andhra Pradesh',
'Chinnamanthur,Hindupur,Andhra Pradesh',
'Cholemarri,Hindupur,Andhra Pradesh',
'Dodaghatta,Hindupur,Andhra Pradesh',
'Gonimekalapalli,Hindupur,Andhra Pradesh',
'Gowrajupalle,Hindupur,Andhra Pradesh',
'Kalipi,Hindupur,Andhra Pradesh',
'Kogira,Hindupur,Andhra Pradesh',
'Mulakalacheruvu,Hindupur,Andhra Pradesh',
'Nallur,Hindupur,Andhra Pradesh',
'Naranagepalli,Hindupur,Andhra Pradesh',
'Peddamanthur,Hindupur,Andhra Pradesh',
'R.Locherla,Hindupur,Andhra Pradesh',
'Rachuru,Hindupur,Andhra Pradesh',
'Roddam,Hindupur,Andhra Pradesh',
'Sanipalli,Hindupur,Andhra Pradesh',
'Dasappapalyam,Hindupur,Andhra Pradesh',
'Dodderi,Hindupur,Andhra Pradesh',
'Guddugurki,Hindupur,Andhra Pradesh',
'Hottebetta,Hindupur,Andhra Pradesh',
'Hottethimmanahalli,Hindupur,Andhra Pradesh',
'Hulikunta,Hindupur,Andhra Pradesh',
'Kaki,Hindupur,Andhra Pradesh',
'M.Rayapuram,Hindupur,Andhra Pradesh',
'Rathnagiri,Hindupur,Andhra Pradesh',
'Rolla,Hindupur,Andhra Pradesh',
'Tallikera,Hindupur,Andhra Pradesh',
'Thirumaladevarapalli,Hindupur,Andhra Pradesh',
'Parlachedu,Anantapur,Andhra Pradesh',
'Shettur,Anantapur,Andhra Pradesh',
'Aydukallu,Anantapur,Andhra Pradesh',
'Ayyagarlapalli,Anantapur,Andhra Pradesh',
'Cherlopalli,Anantapur,Andhra Pradesh',
'Chinnampalli,Anantapur,Andhra Pradesh',
'Chintarlapalli,Anantapur,Andhra Pradesh',
'Kanakuru,Anantapur,Andhra Pradesh',
'Khairevu,Anantapur,Andhra Pradesh',
'Lakshmampalli,Anantapur,Andhra Pradesh',
'Thippanapalli,Anantapur,Andhra Pradesh',
'Akuledu,Anantapur,Andhra Pradesh',
'C Bandameedapalli,Anantapur,Andhra Pradesh',
'Kallumadi,Guntakal,Andhra Pradesh',
'Narasapuram East,Anantapur,Andhra Pradesh',
'Narasapuram West,Anantapur,Andhra Pradesh',
'Rachepalli,Guntakal,Andhra Pradesh',
'Salakamcheruvu,Anantapur,Andhra Pradesh',
'Singanamala,Anantapur,Andhra Pradesh',
'Tarimala,Guntakal,Andhra Pradesh',
'Ullikallu,Guntakal,Andhra Pradesh',
'Brahmasamudram,Hindupur,Andhra Pradesh',
'Bussaiahgaripalli,Hindupur,Andhra Pradesh',
'Chakarlapalli,Hindupur,Andhra Pradesh',
'Chalakur,Hindupur,Andhra Pradesh',
'Challapalli,Hindupur,Andhra Pradesh',
'Edulaballapuram,Hindupur,Andhra Pradesh',
'Gudipalli,Hindupur,Andhra Pradesh',
'Mandli,Hindupur,Andhra Pradesh',
'Nadimpalli,Hindupur,Andhra Pradesh',
'Naginayanicheruvu Thanda,Hindupur,Andhra Pradesh',
'Pandiparthi,Hindupur,Andhra Pradesh',
'Pathikuntapalli,Hindupur,Andhra Pradesh',
'Rangepalli,Hindupur,Andhra Pradesh',
'Somandepalli,Hindupur,Andhra Pradesh',
'Thungodu,Hindupur,Andhra Pradesh',
'Atmakur,Hindupur,Andhra Pradesh',
'Chillakondayapalli,Hindupur,Andhra Pradesh',
'Chillavaripalle,Hindupur,Andhra Pradesh',
'Chinnachigullarevu,Hindupur,Andhra Pradesh',
'Dadithota,Hindupur,Andhra Pradesh',
'Kunukuntla,Hindupur,Andhra Pradesh',
'Maravapalli Agraharam,Hindupur,Andhra Pradesh',
'Marrimakulapalle,Hindupur,Andhra Pradesh',
'Modugulakunta,Hindupur,Andhra Pradesh',
'Nidigallu,Hindupur,Andhra Pradesh',
'Peddachigullarevu,Hindupur,Andhra Pradesh',
'Peddakotla,Hindupur,Andhra Pradesh',
'Tadimarri,Hindupur,Andhra Pradesh',
'Yerraguntapalle,Hindupur,Andhra Pradesh',
'Aluru,Anantapur,Andhra Pradesh',
'Bhogasamudram,Anantapur,Andhra Pradesh',
'Bondaladinne,Anantapur,Andhra Pradesh',
'Challavaripalli,Anantapur,Andhra Pradesh',
'Chinnapolamada,Anantapur,Andhra Pradesh',
'Diguvapalli,Anantapur,Andhra Pradesh',
'Igaduru,Anantapur,Andhra Pradesh',
'Kaverisamudram,Anantapur,Andhra Pradesh',
'Muchukota,Anantapur,Andhra Pradesh',
'Peddapappuru,Anantapur,Andhra Pradesh',
'Peddapolamada,Anantapur,Andhra Pradesh',
'Sajjaladinne,Anantapur,Andhra Pradesh',
'Therannapalli,Anantapur,Andhra Pradesh',
'Urichintala,Anantapur,Andhra Pradesh',
'Vanganuru,Anantapur,Andhra Pradesh',
'Velamakur,Anantapur,Andhra Pradesh',
'Venkatareddipalli,Anantapur,Andhra Pradesh',
'Yerraguntapalli,Anantapur,Andhra Pradesh',
'Ammaladinne,Anantapur,Andhra Pradesh',
'Chukkalur,Anantapur,Andhra Pradesh',
'Reddivaripalem,Anantapur,Andhra Pradesh',
'Tadpatri Bazar,Anantapur,Andhra Pradesh',
'Tadpatri Bus Stand,Anantapur,Andhra Pradesh',
'Tadpatri Extension,Anantapur,Andhra Pradesh',
'Tadpatri,Anantapur,Andhra Pradesh',
'Yellanur,Anantapur,Andhra Pradesh',
'Ganjuvaripalle,Hindupur,Andhra Pradesh',
'Kovvurivandlapalle,Hindupur,Andhra Pradesh',
'Kurlireddipalle,Hindupur,Andhra Pradesh',
'Lakkasamudram,Hindupur,Andhra Pradesh',
'Nuthanakalva,Hindupur,Andhra Pradesh',
'Obulareddipalli,Hindupur,Andhra Pradesh',
'Odulapalli,Hindupur,Andhra Pradesh',
'Peddannavaripalli,Hindupur,Andhra Pradesh',
'Somalavandlapalle,Hindupur,Andhra Pradesh',
'Talupula,Hindupur,Andhra Pradesh',
'Vepamanipeta,Hindupur,Andhra Pradesh',
'Balasamudram,Hindupur,Andhra Pradesh',
'Bonthalapalle,Hindupur,Andhra Pradesh',
'Cheekatimanipalli,Hindupur,Andhra Pradesh',
'Chinnaramannagaripalli,Hindupur,Andhra Pradesh',
'Diguvathotapalli,Hindupur,Andhra Pradesh',
'Errakuntapalle,Hindupur,Andhra Pradesh',
'Ethodu,Hindupur,Andhra Pradesh',
'Gandhodivandlapalli,Hindupur,Andhra Pradesh',
'Gurrambailu,Hindupur,Andhra Pradesh',
'K.Mallireddipalle,Hindupur,Andhra Pradesh',
'Kokkanti,Hindupur,Andhra Pradesh',
'Kondavenukapalli,Hindupur,Andhra Pradesh',
'Korthikota,Hindupur,Andhra Pradesh',
'Kotlapalli,Hindupur,Andhra Pradesh',
'Mundlavaripalli,Hindupur,Andhra Pradesh',
'Peddakadapalavaripalli,Hindupur,Andhra Pradesh',
'Tanakallu,Hindupur,Andhra Pradesh',
'Vankapalle,Hindupur,Andhra Pradesh',
'Amidyaya,Guntakal,Andhra Pradesh',
'Budagavi,Guntakal,Andhra Pradesh',
'Chinnamusturu,Guntakal,Andhra Pradesh',
'Kothapeta(Uravakonda),Guntakal,Andhra Pradesh',
'Lathavaram,Guntakal,Andhra Pradesh',
'Mopidi,Guntakal,Andhra Pradesh',
'N.Hanumapuram,Guntakal,Andhra Pradesh',
'Nimbagallu,Guntakal,Andhra Pradesh',
'Pedda Kowkuntla,Guntakal,Andhra Pradesh',
'Raketla,Guntakal,Andhra Pradesh',
'Rayampalli,Guntakal,Andhra Pradesh',
'Renimakulapalli,Guntakal,Andhra Pradesh',
'Shaikshanipalli,Guntakal,Andhra Pradesh',
'Sollapuram,Guntakal,Andhra Pradesh',
'Uravakonda (Bus Stand),Guntakal,Andhra Pradesh',
'Uravakonda,Guntakal,Andhra Pradesh',
'Vekigonda,Guntakal,Andhra Pradesh',
'Y Rama Puram,Anantapur,Andhra Pradesh',
'Chabala,Guntakal,Andhra Pradesh',
'Chayapuram,Guntakal,Andhra Pradesh',
'Dharmapuri,Guntakal,Andhra Pradesh',
'Gadehothur,Guntakal,Andhra Pradesh',
'Gulapalyam,Guntakal,Andhra Pradesh',
'Kamalapadu,Guntakal,Andhra Pradesh',
'Konakondla,Guntakal,Andhra Pradesh',
'P.C.Peapully,Guntakal,Andhra Pradesh',
'Pandikunta,Guntakal,Andhra Pradesh',
'Pottipadu,Guntakal,Andhra Pradesh',
'Ragulapadu,Guntakal,Andhra Pradesh',
'Tatrakallu,Guntakal,Andhra Pradesh',
'Vajrakarur,Guntakal,Andhra Pradesh',
'Venkatampalli,Guntakal,Andhra Pradesh',
'Cheekalagurki,Guntakal,Andhra Pradesh',
'Donekal,Guntakal,Andhra Pradesh',
'Gadekal,Guntakal,Andhra Pradesh',
'Hanchanahal,Guntakal,Andhra Pradesh',
'Janardhanapalli,Guntakal,Andhra Pradesh',
'Kadadarabenchi,Guntakal,Andhra Pradesh',
'Karakamukkala,Guntakal,Andhra Pradesh',
'Kothakota,Guntakal,Andhra Pradesh',
'Kottalapalli,Guntakal,Andhra Pradesh',
'Mallapuram,Guntakal,Andhra Pradesh',
'Palthur,Guntakal,Andhra Pradesh',
'Poliki,Guntakal,Andhra Pradesh',
'Undabanda,Guntakal,Andhra Pradesh',
'Velpumadugu,Guntakal,Andhra Pradesh',
'Vidapanakal,Guntakal,Andhra Pradesh',
'Havaligi,Guntakal,Andhra Pradesh',
'Chandana,Guntakal,Andhra Pradesh',
'Chintalayalapalli,Guntakal,Andhra Pradesh',
'Gudipadu,Guntakal,Andhra Pradesh',
'Kamalapadu,Guntakal,Andhra Pradesh',
'Konauppalapadu,Guntakal,Andhra Pradesh',
'Lakshumpalli,Guntakal,Andhra Pradesh',
'Nagarur,Guntakal,Andhra Pradesh',
'Nitturu,Guntakal,Andhra Pradesh',
'Puppala,Guntakal,Andhra Pradesh',
'Rayalacheruvu,Guntakal,Andhra Pradesh',
'Thutrallapalli,Guntakal,Andhra Pradesh',
'Vemulapadu,Guntakal,Andhra Pradesh',
'Yadiki,Guntakal,Andhra Pradesh',
'Araveedu,Anantapur,Andhra Pradesh',
'Chilamakuru,Anantapur,Andhra Pradesh',
'Chintakayamanda,Anantapur,Andhra Pradesh',
'Goddumarri,Anantapur,Andhra Pradesh',
'Jangampalli,Anantapur,Andhra Pradesh',
'Kalluru,Anantapur,Andhra Pradesh',
'Kuchivaripalli,Anantapur,Andhra Pradesh',
'Lakshmampalli,Anantapur,Andhra Pradesh',
'Lingareddipalli,Anantapur,Andhra Pradesh',
'Medikurthi,Anantapur,Andhra Pradesh',
'Singavaram,Anantapur,Andhra Pradesh',
'Thimmampalli,Anantapur,Andhra Pradesh',
'Vennupusalapalli,Anantapur,Andhra Pradesh',
'Appa Rao Street,Chittoor,Andhra Pradesh',
'Madanapalle Spinning Mills Gds,Chittoor,Andhra Pradesh',
'Akkurthi,Tirupati,Andhra Pradesh',
'Chiyyavaram,Tirupati,Andhra Pradesh',
'Chodavaram,Tirupati,Andhra Pradesh',
'Gottipudi,Tirupati,Andhra Pradesh',
'Kasaram,Tirupati,Andhra Pradesh',
'Muchivolu,Tirupati,Andhra Pradesh',
'Obulayapalle,Tirupati,Andhra Pradesh',
'Pillamadu,Tirupati,Andhra Pradesh',
'Arugonda,Chittoor,Andhra Pradesh',
'Diguvamagham,Chittoor,Andhra Pradesh',
'Eachaneri,Chittoor,Andhra Pradesh',
'Gazualapalle,Chittoor,Andhra Pradesh',
'Gollapalle,Chittoor,Andhra Pradesh',
'Kattakindapalle,Chittoor,Andhra Pradesh',
'Madhavaram,Chittoor,Andhra Pradesh',
'Mallakunta,Chittoor,Andhra Pradesh',
'Mathyam,Chittoor,Andhra Pradesh',
'Pallecheruvu,Chittoor,Andhra Pradesh',
'Putramaddi,Chittoor,Andhra Pradesh',
'Sadakuppam,Chittoor,Andhra Pradesh',
'Sarakallu,Chittoor,Andhra Pradesh',
'Todatara,Chittoor,Andhra Pradesh',
'Vengampalle,Chittoor,Andhra Pradesh',
'Errandlapalle,Chittoor,Andhra Pradesh',
'Jambuvaripalle,Chittoor,Andhra Pradesh',
'K.G. Satram,Chittoor,Andhra Pradesh',
'Karidirivaripalle,Chittoor,Andhra Pradesh',
'Katappagaripalle,Chittoor,Andhra Pradesh',
'Managalapalle,Chittoor,Andhra Pradesh',
'Muthukuru,Chittoor,Andhra Pradesh',
'Nalagampalle,Chittoor,Andhra Pradesh',
'Thambuganipalle,Chittoor,Andhra Pradesh',
'Thumabakuppam,Chittoor,Andhra Pradesh',
'Thumba,Chittoor,Andhra Pradesh',
'Bodevandlapalle,Tirupati,Andhra Pradesh',
'Ayithepalle,Tirupati,Andhra Pradesh',
'Bhimavaram,Tirupati,Andhra Pradesh',
'Bopparajupalle,Tirupati,Andhra Pradesh',
'Buchinaidupalle,Tirupati,Andhra Pradesh',
'Chandragiri Fort,Tirupati,Andhra Pradesh',
'Chandragiri H.O,Tirupati,Andhra Pradesh',
'Dornakambala,Tirupati,Andhra Pradesh',
'Kalyani Dam,Tirupati,Andhra Pradesh',
'Kotala,Tirupati,Andhra Pradesh',
'Mangapuram,Tirupati,Andhra Pradesh',
'Mungilipattu,Tirupati,Andhra Pradesh',
'Narasingapuram,Tirupati,Andhra Pradesh',
'Rangampet,Tirupati,Andhra Pradesh',
'Seshapuram,Tirupati,Andhra Pradesh',
'Cheruvumundarapalle,Tirupati,Andhra Pradesh',
'Chinthagunta,Tirupati,Andhra Pradesh',
'Chitticherla,Tirupati,Andhra Pradesh',
'Dudhevaripalle,Tirupati,Andhra Pradesh',
'Kotabailu,Tirupati,Andhra Pradesh',
'Kotakadapalle,Tirupati,Andhra Pradesh',
'Nerabailu,Tirupati,Andhra Pradesh',
'Rangannagarigadda,Tirupati,Andhra Pradesh',
'T.Sattevaripalle,Tirupati,Andhra Pradesh',
'Thatimakulapalle,Tirupati,Andhra Pradesh',
'Thettupalle,Tirupati,Andhra Pradesh',
'Thippireddigarialle,Tirupati,Andhra Pradesh',
'Udayamanikyam,Tirupati,Andhra Pradesh',
'Yegavuru,Tirupati,Andhra Pradesh',
'Yerravaripalem,Tirupati,Andhra Pradesh',
'Bhakarapet,Tirupati,Andhra Pradesh',
'Chinnagottigallu,Tirupati,Andhra Pradesh',
'13-gollapalle,Chittoor,Andhra Pradesh',
'155-kammapalle,Chittoor,Andhra Pradesh',
'Adilakshmambapuram,Chittoor,Andhra Pradesh',
'Amudala,Chittoor,Andhra Pradesh',
'Arimakulapalle,Chittoor,Andhra Pradesh',
'Avalkonda,Chittoor,Andhra Pradesh',
'Balaganganapalle,Chittoor,Andhra Pradesh',
'Bodaguttapalle,Chittoor,Andhra Pradesh',
'Bommasamudram,Chittoor,Andhra Pradesh',
'Budithireddipalle,Chittoor,Andhra Pradesh',
'Cheelapalle,Chittoor,Andhra Pradesh',
'Chennamagudipalle,Chittoor,Andhra Pradesh',
'Cherlopalle,Chittoor,Andhra Pradesh',
'Chinnamreddikandriga,Chittoor,Andhra Pradesh',
'Chittapara,Chittoor,Andhra Pradesh',
'Chittoor Bazar,Chittoor,Andhra Pradesh',
'Chittoor H.O,Chittoor,Andhra Pradesh',
'Chittoor North,Chittoor,Andhra Pradesh',
'Chittoor Sugarfactory,Chittoor,Andhra Pradesh',
'Ctr Collectorate,Chittoor,Andhra Pradesh',
'Ctr Court Buildings,Chittoor,Andhra Pradesh',
'Ctr Market,Chittoor,Andhra Pradesh',
'Devalampet,Chittoor,Andhra Pradesh',
'Devaragudipalle,Chittoor,Andhra Pradesh',
'Diguvamasapalle,Chittoor,Andhra Pradesh',
'Ellamarajupalle,Chittoor,Andhra Pradesh',
'Gangadhara Nellore,Chittoor,Andhra Pradesh',
'Gudipala,Chittoor,Andhra Pradesh',
'Gudyanampalle,Chittoor,Andhra Pradesh',
'Iral,Chittoor,Andhra Pradesh',
'Iruvaram,Chittoor,Andhra Pradesh',
'Jakkidona,Chittoor,Andhra Pradesh',
'Kajoor,Chittoor,Andhra Pradesh',
'Kamachinnayapalle,Chittoor,Andhra Pradesh',
'Kandriga,Chittoor,Andhra Pradesh',
'Kanipakam,Chittoor,Andhra Pradesh',
'Kasiralla,Chittoor,Andhra Pradesh',
'Keenatipalle,Chittoor,Andhra Pradesh',
'Kotalam,Chittoor,Andhra Pradesh',
'Kothapalle,Chittoor,Andhra Pradesh',
'Kothapalle,Chittoor,Andhra Pradesh',
'Kothavenkatapuram,Chittoor,Andhra Pradesh',
'Ksheerasamudram,Chittoor,Andhra Pradesh',
'Kukkalapalle,Chittoor,Andhra Pradesh',
'Lalugardens,Chittoor,Andhra Pradesh',
'Madhavaram,Chittoor,Andhra Pradesh',
'Madireddipalle,Chittoor,Andhra Pradesh',
'Mahadevamangalam,Chittoor,Andhra Pradesh',
'Mahasamudram,Chittoor,Andhra Pradesh',
'Mangunta,Chittoor,Andhra Pradesh',
'Mapakshi,Chittoor,Andhra Pradesh',
'Marakalakuppam,Chittoor,Andhra Pradesh',
'Marripalle,Chittoor,Andhra Pradesh',
'Mittoor-chittoor,Chittoor,Andhra Pradesh',
'Mukkalathur,Chittoor,Andhra Pradesh',
'Murukambattu,Chittoor,Andhra Pradesh',
'Muthukur,Chittoor,Andhra Pradesh',
'Nandanuru,Chittoor,Andhra Pradesh',
'Nangamangalam,Chittoor,Andhra Pradesh',
'Naragallu,Chittoor,Andhra Pradesh',
'Naraharipet,Chittoor,Andhra Pradesh',
'Narasimhapuram,Chittoor,Andhra Pradesh',
'Narasimharajapuram,Chittoor,Andhra Pradesh',
'Narasingarayanipettah,Chittoor,Andhra Pradesh',
'Narigapalle,Chittoor,Andhra Pradesh',
'Nelavoy,Chittoor,Andhra Pradesh',
'Nellaipalle,Chittoor,Andhra Pradesh',
'Oddepalle,Chittoor,Andhra Pradesh',
'Pachanapalle,Chittoor,Andhra Pradesh',
'Pachigunta,Chittoor,Andhra Pradesh',
'Pallur,Chittoor,Andhra Pradesh',
'Pantrampalle,Chittoor,Andhra Pradesh',
'Papisettipalle,Chittoor,Andhra Pradesh',
'Peddakalva,Chittoor,Andhra Pradesh',
'Penumur,Chittoor,Andhra Pradesh',
'Periyambadi,Chittoor,Andhra Pradesh',
'Pulikallu,Chittoor,Andhra Pradesh',
'Pullur,Chittoor,Andhra Pradesh',
'Puthalapattu,Chittoor,Andhra Pradesh',
'Ramanaidupalle,Chittoor,Andhra Pradesh',
'Ramapuram,Chittoor,Andhra Pradesh',
'Readspet,Chittoor,Andhra Pradesh',
'Reddigunta,Chittoor,Andhra Pradesh',
'Ripunjirajapuram,Chittoor,Andhra Pradesh',
'S.S.Konda,Chittoor,Andhra Pradesh',
'Samireddipalle,Chittoor,Andhra Pradesh',
'Settivanatham,Chittoor,Andhra Pradesh',
'Srirangarajapuram,Chittoor,Andhra Pradesh',
'T. Savatapalle,Chittoor,Andhra Pradesh',
'Tenebanda,Chittoor,Andhra Pradesh',
'Thalambedu,Chittoor,Andhra Pradesh',
'Thugundram,Chittoor,Andhra Pradesh',
'Thumminda,Chittoor,Andhra Pradesh',
'Thurupupalle,Chittoor,Andhra Pradesh',
'Ugranapalle,Chittoor,Andhra Pradesh',
'Varathur,Chittoor,Andhra Pradesh',
'Veerakanellore,Chittoor,Andhra Pradesh',
'Velkur,Chittoor,Andhra Pradesh',
'Vengalrajukuppam,Chittoor,Andhra Pradesh',
'Venkatapuram,Chittoor,Andhra Pradesh',
'Vepanapalle,Chittoor,Andhra Pradesh',
'Vepanjeri,Chittoor,Andhra Pradesh',
'Vinayakapuram,Chittoor,Andhra Pradesh',
'Yadamari,Chittoor,Andhra Pradesh',
'Yetteri,Chittoor,Andhra Pradesh',
'Damalacheruvu,Tirupati,Andhra Pradesh',
'Gundlaguttapalle,Tirupati,Andhra Pradesh',
'Gundlapalle,Tirupati,Andhra Pradesh',
'Krishnapuram,Tirupati,Andhra Pradesh',
'Mogarala,Tirupati,Andhra Pradesh',
'Vallivedu,Tirupati,Andhra Pradesh',
'Vedagirivaripalle,Tirupati,Andhra Pradesh',
'Batagundrevaripalle,Tirupati,Andhra Pradesh',
'Garnimitta,Tirupati,Andhra Pradesh',
'Gorantlapalle,Tirupati,Andhra Pradesh',
'Jangampalle,Tirupati,Andhra Pradesh',
'Kambhamvaripalle,Tirupati,Andhra Pradesh',
'Kuppamvandlapalle,Tirupati,Andhra Pradesh',
'Maddipatlavandlapalle,Tirupati,Andhra Pradesh',
'Maddulacheruvupalem,Tirupati,Andhra Pradesh',
'Mallarapuvandlapalle,Tirupati,Andhra Pradesh',
'Marella,Tirupati,Andhra Pradesh',
'Matampalle Agraharam,Tirupati,Andhra Pradesh',
'Moorevandlapalle,Tirupati,Andhra Pradesh',
'Nuthanakalava,Tirupati,Andhra Pradesh',
'Sorakayalapeta,Tirupati,Andhra Pradesh',
'T.Sandravaripalle,Tirupati,Andhra Pradesh',
'Vagalla,Tirupati,Andhra Pradesh',
'Amilepalle,Tirupati,Andhra Pradesh',
'Cherlopalle,Tirupati,Andhra Pradesh',
'Diguvapalem,Tirupati,Andhra Pradesh',
'Gurramkonda,Tirupati,Andhra Pradesh',
'Kadirirayacheruvu,Tirupati,Andhra Pradesh',
'Kalicherla,Tirupati,Andhra Pradesh',
'Kanumalopalle,Tirupati,Andhra Pradesh',
'Kotakonda,Tirupati,Andhra Pradesh',
'Kukkarajupalle,Tirupati,Andhra Pradesh',
'Marrimakulapalle,Tirupati,Andhra Pradesh',
'Nadimcherla,Tirupati,Andhra Pradesh',
'Nadimkandriga,Tirupati,Andhra Pradesh',
'Papepalle,Tirupati,Andhra Pradesh',
'Pasalavandlapalle,Tirupati,Andhra Pradesh',
'Peddamandyam,Tirupati,Andhra Pradesh',
'Ramapuram,Tirupati,Andhra Pradesh',
'Reddivaripalle,Tirupati,Andhra Pradesh',
'Sangasamudram,Tirupati,Andhra Pradesh',
'Sarimadugu,Tirupati,Andhra Pradesh',
'Settivaripalle,Tirupati,Andhra Pradesh',
'Siddavaram,Tirupati,Andhra Pradesh',
'T.Rachapalle,Tirupati,Andhra Pradesh',
'Veligallu,Tirupati,Andhra Pradesh',
'Yellutla,Tirupati,Andhra Pradesh',
'Yenugondapalem,Tirupati,Andhra Pradesh',
'Ellampalle Kothuru,Chittoor,Andhra Pradesh',
'Erlampalle,Chittoor,Andhra Pradesh',
'Govindareddipalle,Chittoor,Andhra Pradesh',
'Ialavaripalle,Chittoor,Andhra Pradesh',
'Nampalle,Chittoor,Andhra Pradesh',
'Polakala,Chittoor,Andhra Pradesh',
'Pullur,Chittoor,Andhra Pradesh',
'Yellampalle Santhagate,Chittoor,Andhra Pradesh',
'Yerrepalle,Chittoor,Andhra Pradesh',
'Adaram,Tirupati,Andhra Pradesh',
'Adavaram,Tirupati,Andhra Pradesh',
'Anjuru,Tirupati,Andhra Pradesh',
'Brahmanapalle,Tirupati,Andhra Pradesh',
'Chittathur,Tirupati,Andhra Pradesh',
'Kalathur,Tirupati,Andhra Pradesh',
'Kanchanapalle,Tirupati,Andhra Pradesh',
'Kovanur,Tirupati,Andhra Pradesh',
'M.A.Rajulakandriga,Tirupati,Andhra Pradesh',
'Ollur,Tirupati,Andhra Pradesh',
'Pudichennakesavapuram,Tirupati,Andhra Pradesh',
'Ragigunta,Tirupati,Andhra Pradesh',
'Sadasivapuram,Tirupati,Andhra Pradesh',
'Suramala,Tirupati,Andhra Pradesh',
'Gyarampalle-kothapalle,Tirupati,Andhra Pradesh',
'Aramadakalavandlapalle,Tirupati,Andhra Pradesh',
'Devalapalle,Tirupati,Andhra Pradesh',
'Galivaripalle,Tirupati,Andhra Pradesh',
'Kalakada Doddipalle,Tirupati,Andhra Pradesh',
'Kalakada,Tirupati,Andhra Pradesh',
'Kona,Tirupati,Andhra Pradesh',
'Kotagudibanda,Tirupati,Andhra Pradesh',
'Medikurthi,Tirupati,Andhra Pradesh',
'Thuvvapalle,Tirupati,Andhra Pradesh',
'Budithavedu,Tirupati,Andhra Pradesh',
'Chintalavaripalem,Tirupati,Andhra Pradesh',
'Errakotapalle,Tirupati,Andhra Pradesh',
'Gadi,Tirupati,Andhra Pradesh',
'Gundluru,Tirupati,Andhra Pradesh',
'Guttapalem,Tirupati,Andhra Pradesh',
'Kaamireddivaripalle,Tirupati,Andhra Pradesh',
'Kalikiri Kothapalle,Tirupati,Andhra Pradesh',
'Kalikiri,Tirupati,Andhra Pradesh',
'Kanduru,Tirupati,Andhra Pradesh',
'Marrikuntapalle,Tirupati,Andhra Pradesh',
'Moorevandlapalle,Tirupati,Andhra Pradesh',
'Mudiyamvaripalle,Tirupati,Andhra Pradesh',
'Nagaripalle,Tirupati,Andhra Pradesh',
'Nawabpet,Tirupati,Andhra Pradesh',
'Nayanicheruvupalle,Tirupati,Andhra Pradesh',
'Palamanda,Tirupati,Andhra Pradesh',
'Palem,Tirupati,Andhra Pradesh',
'Pallavolu,Tirupati,Andhra Pradesh',
'Ranganathapuram,Tirupati,Andhra Pradesh',
'Regallu,Tirupati,Andhra Pradesh',
'T.Sakirevupalle,Tirupati,Andhra Pradesh',
'Thimmapuram,Tirupati,Andhra Pradesh',
'Valligatla,Tirupati,Andhra Pradesh',
'Vootupalle,Tirupati,Andhra Pradesh',
'Diguvatadakara,Chittoor,Andhra Pradesh',
'Kothapalle,Chittoor,Andhra Pradesh',
'Paipalle,Chittoor,Andhra Pradesh',
'Patnam,Chittoor,Andhra Pradesh',
'Puthur,Chittoor,Andhra Pradesh',
'Thavanampalle,Chittoor,Andhra Pradesh',
'Uttarabrahmanapalle,Chittoor,Andhra Pradesh',
'Allamadugu,Tirupati,Andhra Pradesh',
'Annur,Tirupati,Andhra Pradesh',
'Chinnadoravarikandriga,Tirupati,Andhra Pradesh',
'Damodaramaharajapuram,Tirupati,Andhra Pradesh',
'Karvetinagar,Tirupati,Andhra Pradesh',
'Kathirapalle,Tirupati,Andhra Pradesh',
'Kollagunta,Tirupati,Andhra Pradesh',
'Nochilirajukandriga,Tirupati,Andhra Pradesh',
'R.K.V.Bahadurpet,Tirupati,Andhra Pradesh',
'Udamalakudithi,Tirupati,Andhra Pradesh',
'Vathalur,Tirupati,Andhra Pradesh',
'Agraharam,Chittoor,Andhra Pradesh',
'Angallu,Chittoor,Andhra Pradesh',
'Annagaripalle,Chittoor,Andhra Pradesh',
'Appinapalle,Chittoor,Andhra Pradesh',
'Aradigunta,Chittoor,Andhra Pradesh',
'Arikela,Chittoor,Andhra Pradesh',
'Arogyavaram,Chittoor,Andhra Pradesh',
'Badikayalapalle,Chittoor,Andhra Pradesh',
'Balireddigaripalle,Chittoor,Andhra Pradesh',
'Bandrevu,Chittoor,Andhra Pradesh',
'Basinikonda,Chittoor,Andhra Pradesh',
'Bayappagaripalle,Chittoor,Andhra Pradesh',
'Beerangi,Chittoor,Andhra Pradesh',
'Beerangi Kothakota,Chittoor,Andhra Pradesh',
'Belupalle,Chittoor,Andhra Pradesh',
'Bhimaganipalle,Chittoor,Andhra Pradesh',
'Booragamanda,Chittoor,Andhra Pradesh',
'Boorlapalle,Chittoor,Andhra Pradesh',
'Burakayalakota,Chittoor,Andhra Pradesh',
'Chandramakulapalle,Chittoor,Andhra Pradesh',
'Chappidipalle,Chittoor,Andhra Pradesh',
'Charala,Chittoor,Andhra Pradesh',
'Chedalla,Chittoor,Andhra Pradesh',
'Cheekalabailu,Chittoor,Andhra Pradesh',
'Chembakur,Chittoor,Andhra Pradesh',
'Cherukuvaipalle,Chittoor,Andhra Pradesh',
'Chinnatippasamudram,Chittoor,Andhra Pradesh',
'Chokkandlapalle,Chittoor,Andhra Pradesh',
'Dadepallerajulur,Chittoor,Andhra Pradesh',
'Devalacheruvu,Chittoor,Andhra Pradesh',
'Edigapalle,Chittoor,Andhra Pradesh',
'Erraballe,Chittoor,Andhra Pradesh',
'Gaddamvaripalle,Chittoor,Andhra Pradesh',
'Gajulavaripalle,Chittoor,Andhra Pradesh',
'Gandhiroad,Chittoor,Andhra Pradesh',
'Gandrajupalle,Chittoor,Andhra Pradesh',
'Gangivaripalle,Chittoor,Andhra Pradesh',
'Gattuvaripalle,Chittoor,Andhra Pradesh',
'Ghattu,Chittoor,Andhra Pradesh',
'Gollapalle,Chittoor,Andhra Pradesh',
'Gopidinne,Chittoor,Andhra Pradesh',
'Gudupalle,Chittoor,Andhra Pradesh',
'Gundagallu,Chittoor,Andhra Pradesh',
'Gundlapalle,Chittoor,Andhra Pradesh',
'Horsely Hills,Chittoor,Andhra Pradesh',
'Irikipenta,Chittoor,Andhra Pradesh',
'Itikanellore,Chittoor,Andhra Pradesh',
'Kadirinathunikota,Chittoor,Andhra Pradesh',
'Kagathi,Chittoor,Andhra Pradesh',
'Kalavapalle,Chittoor,Andhra Pradesh',
'Kandukuru,Chittoor,Andhra Pradesh',
'Kannemadugu,Chittoor,Andhra Pradesh',
'Karasanapalle,Chittoor,Andhra Pradesh',
'Katiperi,Chittoor,Andhra Pradesh',
'Katnagallu,Chittoor,Andhra Pradesh',
'Kondamarri,Chittoor,Andhra Pradesh',
'Kosuvaripalle,Chittoor,Andhra Pradesh',
'Kotala,Chittoor,Andhra Pradesh',
'Kotevaripalle,Chittoor,Andhra Pradesh',
'Kotevuru,Chittoor,Andhra Pradesh',
'Kothakota,Chittoor,Andhra Pradesh',
'Kothapeta Madanapalle,Chittoor,Andhra Pradesh',
'Kothavaripalle,Chittoor,Andhra Pradesh',
'Kudurucheemanapalle,Chittoor,Andhra Pradesh',
'Kurabalakota,Chittoor,Andhra Pradesh',
'Kurizala,Chittoor,Andhra Pradesh',
'Madanapalle Bazar,Chittoor,Andhra Pradesh',
'Madanapalle H.O,Chittoor,Andhra Pradesh',
'Madanapalle Society Colony,Chittoor,Andhra Pradesh',
'Maddinayanipalle,Chittoor,Andhra Pradesh',
'Madumuru,Chittoor,Andhra Pradesh',
'Malenatham,Chittoor,Andhra Pradesh',
'Malepadu,Chittoor,Andhra Pradesh',
'Mallela,Chittoor,Andhra Pradesh',
'Mamadugu,Chittoor,Andhra Pradesh',
'Marrimakulapalle,Chittoor,Andhra Pradesh',
'Matluvaripalle,Chittoor,Andhra Pradesh',
'Melamdoddi,Chittoor,Andhra Pradesh',
'Miniki,Chittoor,Andhra Pradesh',
'Mittachintavaripalle,Chittoor,Andhra Pradesh',
'Mittapalle,Chittoor,Andhra Pradesh',
'Moram,Chittoor,Andhra Pradesh',
'Mudivedu,Chittoor,Andhra Pradesh',
'Mulakalacheruvu,Chittoor,Andhra Pradesh',
'Mulakalacheruvu R.S.,Chittoor,Andhra Pradesh',
'Musalikunta,Chittoor,Andhra Pradesh',
'Mushtoor,Chittoor,Andhra Pradesh',
'Muthukur,Chittoor,Andhra Pradesh',
'Nadigadda,Chittoor,Andhra Pradesh',
'Nadimpalle,Chittoor,Andhra Pradesh',
'Nanasahebpet,Chittoor,Andhra Pradesh',
'Nanjampet,Chittoor,Andhra Pradesh',
'Narigapalle,Chittoor,Andhra Pradesh',
'Nawabkota,Chittoor,Andhra Pradesh',
'Nekalachinnapalle,Chittoor,Andhra Pradesh',
'Nekkondi,Chittoor,Andhra Pradesh',
'Nellapalle,Chittoor,Andhra Pradesh',
'Nellimanda,Chittoor,Andhra Pradesh',
'Nellipatla,Chittoor,Andhra Pradesh',
'Nidigunta,Chittoor,Andhra Pradesh',
'Nimmanapalle,Chittoor,Andhra Pradesh',
'Obireddipalle,Chittoor,Andhra Pradesh',
'Pachalamarri,Chittoor,Andhra Pradesh',
'Pandillapalle,Chittoor,Andhra Pradesh',
'Parikidona,Chittoor,Andhra Pradesh',
'Pathapeta-kuppam,Chittoor,Andhra Pradesh',
'Pathapolu,Chittoor,Andhra Pradesh',
'Pathikonda,Chittoor,Andhra Pradesh',
'Patrapalle,Chittoor,Andhra Pradesh',
'Pattamvandlapalle,Chittoor,Andhra Pradesh',
'Peddapalem,Chittoor,Andhra Pradesh',
'Peddatippasamudram,Chittoor,Andhra Pradesh',
'Peddaupparapalle,Chittoor,Andhra Pradesh',
'Peddavelagathur,Chittoor,Andhra Pradesh',
'Peddayellakunta,Chittoor,Andhra Pradesh',
'Peddur Reservoir,Chittoor,Andhra Pradesh',
'Penchupadu,Chittoor,Andhra Pradesh',
'Pitchalvandlapalle,Chittoor,Andhra Pradesh',
'Ponnutipalem,Chittoor,Andhra Pradesh',
'Pudipatla,Chittoor,Andhra Pradesh',
'Pulikallu,Chittoor,Andhra Pradesh',
'Punganur Bus Stand,Chittoor,Andhra Pradesh',
'Punganur,Chittoor,Andhra Pradesh',
'Rachavetivaripalle,Chittoor,Andhra Pradesh',
'Ramasamudram,Chittoor,Andhra Pradesh',
'Rangasamudram,Chittoor,Andhra Pradesh',
'Rapurivaripalle,Chittoor,Andhra Pradesh',
'Reddivaripalle,Chittoor,Andhra Pradesh',
'Reddivaripalle,Chittoor,Andhra Pradesh',
'Renumakulapalle,Chittoor,Andhra Pradesh',
'Rishivalley,Chittoor,Andhra Pradesh',
'Royalpet,Chittoor,Andhra Pradesh',
'Sampathikota,Chittoor,Andhra Pradesh',
'Sivadi,Chittoor,Andhra Pradesh',
'Sodam,Chittoor,Andhra Pradesh',
'Somala,Chittoor,Andhra Pradesh',
'Sompalem,Chittoor,Andhra Pradesh',
'Sompalle,Chittoor,Andhra Pradesh',
'Sugalimitta,Chittoor,Andhra Pradesh',
'Suraiahgaripalle,Chittoor,Andhra Pradesh',
'T.Salimamidi,Chittoor,Andhra Pradesh',
'T.Sodam,Chittoor,Andhra Pradesh',
'T.Sowdasamudram,Chittoor,Andhra Pradesh',
'Tavalam,Chittoor,Andhra Pradesh',
'Thamballapalle,Chittoor,Andhra Pradesh',
'Thatiguntapalem,Chittoor,Andhra Pradesh',
'Thettu,Chittoor,Andhra Pradesh',
'Thummanamgutta,Chittoor,Andhra Pradesh',
'Thurlapalle,Chittoor,Andhra Pradesh',
'Valasapalle,Chittoor,Andhra Pradesh',
'Vanamaladinne,Chittoor,Andhra Pradesh',
'Vemareddigaripalle,Chittoor,Andhra Pradesh',
'Vempalle,Chittoor,Andhra Pradesh',
'Vengamvaripale,Chittoor,Andhra Pradesh',
'Vepurikota,Chittoor,Andhra Pradesh',
'Yeddulavaripalle,Chittoor,Andhra Pradesh',
'Yetavakili,Chittoor,Andhra Pradesh',
'Boochipalle,Chittoor,Andhra Pradesh',
'Chowdepalle,Chittoor,Andhra Pradesh',
'Magandlapalle,Chittoor,Andhra Pradesh',
'Bandapalle,Chittoor,Andhra Pradesh',
'Chinnaickenpalle,Chittoor,Andhra Pradesh',
'Doddipalle,Chittoor,Andhra Pradesh',
'Kalavagunta,Chittoor,Andhra Pradesh',
'Kattmanchi,Chittoor,Andhra Pradesh',
'Kotrakona,Chittoor,Andhra Pradesh',
'Muthireval,Chittoor,Andhra Pradesh',
'Poonepallekandriga,Chittoor,Andhra Pradesh',
'Sathambakkam,Chittoor,Andhra Pradesh',
'Vavilthota,Chittoor,Andhra Pradesh',
'Adavikothuru,Tirupati,Andhra Pradesh',
'Bugga Agraharam,Tirupati,Andhra Pradesh',
'Ekambarakuppam,Tirupati,Andhra Pradesh',
'Gundrajukuppam,Tirupati,Andhra Pradesh',
'Iruguvoi,Tirupati,Andhra Pradesh',
'Kakavedu,Tirupati,Andhra Pradesh',
'Kavetipuram,Tirupati,Andhra Pradesh',
'Kothur Venkatapuram,Tirupati,Andhra Pradesh',
'Mangadu Kothur,Tirupati,Andhra Pradesh',
'Mudipalle,Tirupati,Andhra Pradesh',
'Nagari,Tirupati,Andhra Pradesh',
'Pudupet,Tirupati,Andhra Pradesh',
'Satravada,Tirupati,Andhra Pradesh',
'Tadukupet,Tirupati,Andhra Pradesh',
'Terani,Tirupati,Andhra Pradesh',
'Veerakaveri Rajapuram,Tirupati,Andhra Pradesh',
'Venkatapathi Rajuvaripet,Tirupati,Andhra Pradesh',
'Agaram,Tirupati,Andhra Pradesh',
'Alapakam,Tirupati,Andhra Pradesh',
'Aroor,Tirupati,Andhra Pradesh',
'Chavarambakam,Tirupati,Andhra Pradesh',
'Damarapakam,Tirupati,Andhra Pradesh',
'Elakatur,Tirupati,Andhra Pradesh',
'Nindra,Tirupati,Andhra Pradesh',
'Padiri,Tirupati,Andhra Pradesh',
'Cherukuvaripalle,Tirupati,Andhra Pradesh',
'Chittipiralla,Tirupati,Andhra Pradesh',
'Desireddigaripalle,Tirupati,Andhra Pradesh',
'Gadanki,Tirupati,Andhra Pradesh',
'Kalroadpalle,Tirupati,Andhra Pradesh',
'Kamavaram Kothapet,Tirupati,Andhra Pradesh',
'Kasipentla,Tirupati,Andhra Pradesh',
'Kavetigaripalle,Tirupati,Andhra Pradesh',
'Maddinayanipalle,Tirupati,Andhra Pradesh',
'Muthukuvaripalle,Tirupati,Andhra Pradesh',
'Nendragunta,Tirupati,Andhra Pradesh',
'Pakala Bazar,Tirupati,Andhra Pradesh',
'Pakala Kothakota,Tirupati,Andhra Pradesh',
'Pakala Railway Colony,Tirupati,Andhra Pradesh',
'Pakala,Tirupati,Andhra Pradesh',
'Panapakam,Tirupati,Andhra Pradesh',
'Peddagorpadu,Tirupati,Andhra Pradesh',
'Peddaramapuram,Tirupati,Andhra Pradesh',
'Pothukanuma,Tirupati,Andhra Pradesh',
'Pulicherla,Tirupati,Andhra Pradesh',
'Reddivaripalle,Tirupati,Andhra Pradesh',
'Sankampalle,Tirupati,Andhra Pradesh',
'V.P.V.Kothapalle,Tirupati,Andhra Pradesh',
'Venuthanapalle,Tirupati,Andhra Pradesh',
'64-peddur,Chittoor,Andhra Pradesh',
'Adavibudugur,Chittoor,Andhra Pradesh',
'Alapalle,Chittoor,Andhra Pradesh',
'Arimanipenta,Chittoor,Andhra Pradesh',
'Baireddipalle,Chittoor,Andhra Pradesh',
'Bairupalle,Chittoor,Andhra Pradesh',
'Balla,Chittoor,Andhra Pradesh',
'Bandarlapalle,Chittoor,Andhra Pradesh',
'Bangarupalem,Chittoor,Andhra Pradesh',
'Bisanatham,Chittoor,Andhra Pradesh',
'Boyanapalle,Chittoor,Andhra Pradesh',
'Chalamangalam,Chittoor,Andhra Pradesh',
'Cheekunatham,Chittoor,Andhra Pradesh',
'Cheldiganipalle,Chittoor,Andhra Pradesh',
'Chintamakulapalle,Chittoor,Andhra Pradesh',
'Danamaiahgarivuru,Chittoor,Andhra Pradesh',
'Dandapalle,Chittoor,Andhra Pradesh',
'Dandikuppam,Chittoor,Andhra Pradesh',
'Dasarlapalle,Chittoor,Andhra Pradesh',
'Dasegowniyur,Chittoor,Andhra Pradesh',
'Emaganipalle,Chittoor,Andhra Pradesh',
'Gonamakulapalle,Chittoor,Andhra Pradesh',
'Gudipalle,Chittoor,Andhra Pradesh',
'Gudlanayanipalle,Chittoor,Andhra Pradesh',
'Gurramkonda Vandlavuru,Chittoor,Andhra Pradesh',
'Javvanapalle,Chittoor,Andhra Pradesh',
'Kadapanatham,Chittoor,Andhra Pradesh',
'Kalagatur,Chittoor,Andhra Pradesh',
'Kallupalle,Chittoor,Andhra Pradesh',
'Kamathamur,Chittoor,Andhra Pradesh',
'Kanamanapalle,Chittoor,Andhra Pradesh',
'Kangundi,Chittoor,Andhra Pradesh',
'Karlagatta,Chittoor,Andhra Pradesh',
'Keelapatla,Chittoor,Andhra Pradesh',
'Keeramanda,Chittoor,Andhra Pradesh',
'Kolamasanapalle,Chittoor,Andhra Pradesh',
'Konerukuppam,Chittoor,Andhra Pradesh',
'Konganapalle,Chittoor,Andhra Pradesh',
'Kongattam,Chittoor,Andhra Pradesh',
'Krishnadasanapalle,Chittoor,Andhra Pradesh',
'Kuppam,Chittoor,Andhra Pradesh',
'Kurmai,Chittoor,Andhra Pradesh',
'L.S.Farm,Chittoor,Andhra Pradesh',
'Lakkanapalle,Chittoor,Andhra Pradesh',
'Lakshmipuram,Chittoor,Andhra Pradesh',
'Mallan R.S.,Chittoor,Andhra Pradesh',
'Mandipetkotur,Chittoor,Andhra Pradesh',
'Maredupalle,Chittoor,Andhra Pradesh',
'Marketyard-palamaner,Chittoor,Andhra Pradesh',
'Melmai,Chittoor,Andhra Pradesh',
'Mittapalle,Chittoor,Andhra Pradesh',
'Mittoor,Chittoor,Andhra Pradesh',
'Mogili Venkatagiri,Chittoor,Andhra Pradesh',
'Mudaramdoddi,Chittoor,Andhra Pradesh',
'Muddanapalle,Chittoor,Andhra Pradesh',
'Nadimpalle,Chittoor,Andhra Pradesh',
'Nallappareddiyuru,Chittoor,Andhra Pradesh',
'Naniyala,Chittoor,Andhra Pradesh',
'Nernipalle,Chittoor,Andhra Pradesh',
'Noolakunta,Chittoor,Andhra Pradesh',
'Palamakulapalle,Chittoor,Andhra Pradesh',
'Palamaner,Chittoor,Andhra Pradesh',
'Pallikuppam,Chittoor,Andhra Pradesh',
'Pamuganipalle,Chittoor,Andhra Pradesh',
'Panjani,Chittoor,Andhra Pradesh',
'Pathapeta-palamaner,Chittoor,Andhra Pradesh',
'Peddabangarunatham,Chittoor,Andhra Pradesh',
'Peddachellaragunta,Chittoor,Andhra Pradesh',
'Peddur,Chittoor,Andhra Pradesh',
'Pengaragunta,Chittoor,Andhra Pradesh',
'Pogurupalle,Chittoor,Andhra Pradesh',
'Ragimanipenta,Chittoor,Andhra Pradesh',
'Rajupeta,Chittoor,Andhra Pradesh',
'Rallabudugur,Chittoor,Andhra Pradesh',
'Ramakuppam,Chittoor,Andhra Pradesh',
'Sanganapalle,Chittoor,Andhra Pradesh',
'Santhabandapalle,Chittoor,Andhra Pradesh',
'Santhipuram,Chittoor,Andhra Pradesh',
'Settipalle,Chittoor,Andhra Pradesh',
'Singasamudram,Chittoor,Andhra Pradesh',
'Sivaramapuram,Chittoor,Andhra Pradesh',
'Sogadaballa,Chittoor,Andhra Pradesh',
'Sonnarasanapalle,Chittoor,Andhra Pradesh',
'Tekumanda,Chittoor,Andhra Pradesh',
'Theertham,Chittoor,Andhra Pradesh',
'Thotakanuma,Chittoor,Andhra Pradesh',
'Vasanadu,Chittoor,Andhra Pradesh',
'Veeranamala,Chittoor,Andhra Pradesh',
'Vendugampalle,Chittoor,Andhra Pradesh',
'Venkatagirikota,Chittoor,Andhra Pradesh',
'Vizalapuram,Chittoor,Andhra Pradesh',
'Pannur,Tirupati,Andhra Pradesh',
'Agraharam,Tirupati,Andhra Pradesh',
'Bandakindapalle,Tirupati,Andhra Pradesh',
'Bodumallulavaripalle,Tirupati,Andhra Pradesh',
'Doddipalle,Tirupati,Andhra Pradesh',
'Ellamanda,Tirupati,Andhra Pradesh',
'Ganugachinta,Tirupati,Andhra Pradesh',
'Gudarevupalle,Tirupati,Andhra Pradesh',
'Jandla,Tirupati,Andhra Pradesh',
'Kondreddigaripalle,Tirupati,Andhra Pradesh',
'Mellacheruvu,Tirupati,Andhra Pradesh',
'Mudupulavemula,Tirupati,Andhra Pradesh',
'Nehru Bazar (Piler),Tirupati,Andhra Pradesh',
'Palamgadda,Tirupati,Andhra Pradesh',
'Piler,Tirupati,Andhra Pradesh',
'Talupula,Tirupati,Andhra Pradesh',
'Ustikayalapenta,Tirupati,Andhra Pradesh',
'Vadlakunta,Tirupati,Andhra Pradesh',
'Vepulabailu,Tirupati,Andhra Pradesh',
'Adivikodiyambedu,Tirupati,Andhra Pradesh',
'Agaram,Tirupati,Andhra Pradesh',
'Arai,Tirupati,Andhra Pradesh',
'Beerakuppam,Tirupati,Andhra Pradesh',
'Bytikodiyambedu,Tirupati,Andhra Pradesh',
'Govardhanagiri,Tirupati,Andhra Pradesh',
'Kannavaram,Tirupati,Andhra Pradesh',
'Karani,Tirupati,Andhra Pradesh',
'Koppedu,Tirupati,Andhra Pradesh',
'Kotamangapuram,Tirupati,Andhra Pradesh',
'Krishnapuram,Tirupati,Andhra Pradesh',
'Nagalapuram,Tirupati,Andhra Pradesh',
'Pissatur,Tirupati,Andhra Pradesh',
'Pulikundram,Tirupati,Andhra Pradesh',
'Rajanagaram,Tirupati,Andhra Pradesh',
'Sadasiva Sankarapuram,Tirupati,Andhra Pradesh',
'Siddirajukandriga,Tirupati,Andhra Pradesh',
'Sriramapuram,Tirupati,Andhra Pradesh',
'Velur,Tirupati,Andhra Pradesh',
'Vengalathur,Tirupati,Andhra Pradesh',
'Kallur,Tirupati,Andhra Pradesh',
'Mangalampet,Tirupati,Andhra Pradesh',
'Akanambattu,Chittoor,Andhra Pradesh',
'Baitapalle,Chittoor,Andhra Pradesh',
'Chinnakalikiri,Chittoor,Andhra Pradesh',
'Erracheruvupalle,Chittoor,Andhra Pradesh',
'Kammguttapalle,Chittoor,Andhra Pradesh',
'Mudigolam,Chittoor,Andhra Pradesh',
'Palakur,Chittoor,Andhra Pradesh',
'Patoor,Chittoor,Andhra Pradesh',
'Polavaram,Chittoor,Andhra Pradesh',
'Tenepalle,Chittoor,Andhra Pradesh',
'Thalupulapalle,Chittoor,Andhra Pradesh',
'Vajjireddipalle,Chittoor,Andhra Pradesh',
'Alimelumangapuram,Tirupati,Andhra Pradesh',
'Aranyam Kandriga,Tirupati,Andhra Pradesh',
'Cherlopalle,Tirupati,Andhra Pradesh',
'Chinnarajukuppam,Tirupati,Andhra Pradesh',
'Govindapalem,Tirupati,Andhra Pradesh',
'Jagannathapuram,Tirupati,Andhra Pradesh',
'Jambada,Tirupati,Andhra Pradesh',
'K.M.Agraharam,Tirupati,Andhra Pradesh',
'Kaliyambakam,Tirupati,Andhra Pradesh',
'Kemparapalem,Tirupati,Andhra Pradesh',
'Kosalanagaram,Tirupati,Andhra Pradesh',
'Kshurikapuram,Tirupati,Andhra Pradesh',
'Kumarabommarajapuram,Tirupati,Andhra Pradesh',
'Nandimangalam,Tirupati,Andhra Pradesh',
'Narayanapuram,Tirupati,Andhra Pradesh',
'Narayanavaram,Tirupati,Andhra Pradesh',
'Nesanur,Tirupati,Andhra Pradesh',
'Palamangalam,Tirupati,Andhra Pradesh',
'Parameswaramangalam,Tirupati,Andhra Pradesh',
'Puttur,Tirupati,Andhra Pradesh',
'Puttur South,Tirupati,Andhra Pradesh',
'Rachapalem,Tirupati,Andhra Pradesh',
'Ramakrishnapuram,Tirupati,Andhra Pradesh',
'Seetharamapuram,Tirupati,Andhra Pradesh',
'Sri Bommarajapuram,Tirupati,Andhra Pradesh',
'Sriharipuram,Tirupati,Andhra Pradesh',
'Surendranagaram,Tirupati,Andhra Pradesh',
'Thimmarajukandriga,Tirupati,Andhra Pradesh',
'Thorur,Tirupati,Andhra Pradesh',
'Thumbur,Tirupati,Andhra Pradesh',
'Tirumala Kuppam,Tirupati,Andhra Pradesh',
'Venkatakrishnapalem,Tirupati,Andhra Pradesh',
'Vepagunta,Tirupati,Andhra Pradesh',
'Vijayapuram,Tirupati,Andhra Pradesh',
'Balijapalli,Tirupati,Andhra Pradesh',
'Chuttuguntaramapuram,Tirupati,Andhra Pradesh',
'Durga Samudram,Tirupati,Andhra Pradesh',
'Gangireddipalli,Tirupati,Andhra Pradesh',
'Kammapalle,Tirupati,Andhra Pradesh',
'Kannikapuram,Tirupati,Andhra Pradesh',
'Kattakindavenkatapuram,Tirupati,Andhra Pradesh',
'Kuntrapakam,Tirupati,Andhra Pradesh',
'Kuppam Badur,Tirupati,Andhra Pradesh',
'Mittakandriga,Tirupati,Andhra Pradesh',
'Nadavalur,Tirupati,Andhra Pradesh',
'Nennur,Tirupati,Andhra Pradesh',
'Nethakuppam,Tirupati,Andhra Pradesh',
'Thimmarajupalle,Tirupati,Andhra Pradesh',
'Athur,Tirupati,Andhra Pradesh',
'Cotton Mills,Tirupati,Andhra Pradesh',
'Gajulamandyam,Tirupati,Andhra Pradesh',
'Karakambadi,Tirupati,Andhra Pradesh',
'Kothapalem,Tirupati,Andhra Pradesh',
'Kummarapalle,Tirupati,Andhra Pradesh',
'Madhavamala,Tirupati,Andhra Pradesh',
'Mamanduru,Tirupati,Andhra Pradesh',
'Pillapalem,Tirupati,Andhra Pradesh',
'Renigunta,Tirupati,Andhra Pradesh',
'Settipalli,Tirupati,Andhra Pradesh',
'Thukivakam,Tirupati,Andhra Pradesh',
'Vedullacheruvu,Tirupati,Andhra Pradesh',
'Challavaripalle,Tirupati,Andhra Pradesh',
'Jangavandlapalle,Tirupati,Andhra Pradesh',
'Motumallela,Tirupati,Andhra Pradesh',
'Peddagottigallu,Tirupati,Andhra Pradesh',
'Peddamallela,Tirupati,Andhra Pradesh',
'Rompicherla,Tirupati,Andhra Pradesh',
'Ambakam,Tirupati,Andhra Pradesh',
'Dasukuppam,Tirupati,Andhra Pradesh',
'Irugulam,Tirupati,Andhra Pradesh',
'Kothamarikuppam,Tirupati,Andhra Pradesh',
'Madanambedu,Tirupati,Andhra Pradesh',
'Pravalvanneswarapuram,Tirupati,Andhra Pradesh',
'Rajagopalapuram,Tirupati,Andhra Pradesh',
'Rasapalem,Tirupati,Andhra Pradesh',
'Satyavedu,Tirupati,Andhra Pradesh',
'Sirunambudur,Tirupati,Andhra Pradesh',
'Agraharam,Tirupati,Andhra Pradesh',
'Alathur,Tirupati,Andhra Pradesh',
'Aravakothur,Tirupati,Andhra Pradesh',
'Ardhamalaputheri,Tirupati,Andhra Pradesh',
'Bhavanisankarapuram,Tirupati,Andhra Pradesh',
'Buchinaidukandriga,Tirupati,Andhra Pradesh',
'G.S.T.Centre,Tirupati,Andhra Pradesh',
'Gajulapellur,Tirupati,Andhra Pradesh',
'Karakollu,Tirupati,Andhra Pradesh',
'Katur,Tirupati,Andhra Pradesh',
'Konathaneri,Tirupati,Andhra Pradesh',
'Kothapet (Srikalahasti),Tirupati,Andhra Pradesh',
'Kukkambakam,Tirupati,Andhra Pradesh',
'Pallamala,Tirupati,Andhra Pradesh',
'Panagal,Tirupati,Andhra Pradesh',
'Peddakannali,Tirupati,Andhra Pradesh',
'Peddakanuparthi,Tirupati,Andhra Pradesh',
'Peddapalavedu,Tirupati,Andhra Pradesh',
'Poyya,Tirupati,Andhra Pradesh',
'Pudi,Tirupati,Andhra Pradesh',
'Santhavelur,Tirupati,Andhra Pradesh',
'Sri Sukabrahmasramam,Tirupati,Andhra Pradesh',
'Srikalahasti H.O,Tirupati,Andhra Pradesh',
'Srikalahasti North,Tirupati,Andhra Pradesh',
'Thondamanadu,Tirupati,Andhra Pradesh',
'Thotambedu,Tirupati,Andhra Pradesh',
'Upanishadvihar,Tirupati,Andhra Pradesh',
'Urandur,Tirupati,Andhra Pradesh',
'Ammapalem,Tirupati,Andhra Pradesh',
'Bandarupalle,Tirupati,Andhra Pradesh',
'Bokkasampalem,Tirupati,Andhra Pradesh',
'Challapalem,Tirupati,Andhra Pradesh',
'Kapugunneri,Tirupati,Andhra Pradesh',
'Maddiledu,Tirupati,Andhra Pradesh',
'Pullareddikandriga,Tirupati,Andhra Pradesh',
'Ramapuram,Tirupati,Andhra Pradesh',
'D.N.Choultry,Tirupati,Andhra Pradesh',
'Postal Colony,Tirupati,Andhra Pradesh',
'R.T.C.Bus Stand,Tirupati,Andhra Pradesh',
'A.P.H.B.Colony,Tirupati,Andhra Pradesh',
'Akkarampalli,Tirupati,Andhra Pradesh',
'Avilalal,Tirupati,Andhra Pradesh',
'Balajinagar,Tirupati,Andhra Pradesh',
'Chiguruvada,Tirupati,Andhra Pradesh',
'Mangalam,Tirupati,Andhra Pradesh',
'Padi,Tirupati,Andhra Pradesh',
'Panakam,Tirupati,Andhra Pradesh',
'Perumallapalle,Tirupati,Andhra Pradesh',
'Perur,Tirupati,Andhra Pradesh',
'Pudipatla,Tirupati,Andhra Pradesh',
'S.V.Agricultural College,Tirupati,Andhra Pradesh',
'S.V.Arts College,Tirupati,Andhra Pradesh',
'S.V.Medical College,Tirupati,Andhra Pradesh',
'S.V.Nagar,Tirupati,Andhra Pradesh',
'Sanambhatla,Tirupati,Andhra Pradesh',
'Satyanarayanapuram,Tirupati,Andhra Pradesh',
'Srinivasanagar,Tirupati,Andhra Pradesh',
'T.T.D.Press,Tirupati,Andhra Pradesh',
'Thandlam,Tirupati,Andhra Pradesh',
'Thondavada,Tirupati,Andhra Pradesh',
'Thummalagunta,Tirupati,Andhra Pradesh',
'Tiruchanoor,Tirupati,Andhra Pradesh',
'Tirumala North,Tirupati,Andhra Pradesh',
'Tirumala,Tirupati,Andhra Pradesh',
'Tirumala West,Tirupati,Andhra Pradesh',
'Vemur,Tirupati,Andhra Pradesh',
'Veterinary Science College,Tirupati,Andhra Pradesh',
'Bhavani Nagar,Tirupati,Andhra Pradesh',
'Jagannathapuram,Tirupati,Andhra Pradesh',
'Kapilateertham Road,Tirupati,Andhra Pradesh',
'Korlagunta,Tirupati,Andhra Pradesh',
'R.S.Gardens,Tirupati,Andhra Pradesh',
'S.V.University,Tirupati,Andhra Pradesh',
'Tiruchanoor Road,Tirupati,Andhra Pradesh',
'Tirupati Bazar,Tirupati,Andhra Pradesh',
'Tirupati East,Tirupati,Andhra Pradesh',
'Tirupati H.O,Tirupati,Andhra Pradesh',
'Tirupati North,Tirupati,Andhra Pradesh',
'Tirupati South,Tirupati,Andhra Pradesh',
'Tirupati West,Tirupati,Andhra Pradesh',
'Applayagunta,Tirupati,Andhra Pradesh',
'Brahmanapattu,Tirupati,Andhra Pradesh',
'Obularajukandriga,Tirupati,Andhra Pradesh',
'Padiredu,Tirupati,Andhra Pradesh',
'Pathiputtur,Tirupati,Andhra Pradesh',
'Pudi R.S.,Tirupati,Andhra Pradesh',
'S.V.R.Pet,Tirupati,Andhra Pradesh',
'Thirumanyam Rajula Kandriga,Tirupati,Andhra Pradesh',
'Vadamalpet,Tirupati,Andhra Pradesh',
'Ayyavaripalle,Tirupati,Andhra Pradesh',
'Gandaboyanapalle,Tirupati,Andhra Pradesh',
'Jarravaripalle,Tirupati,Andhra Pradesh',
'Kuraparthi,Tirupati,Andhra Pradesh',
'Manchuru,Tirupati,Andhra Pradesh',
'Marripadu,Tirupati,Andhra Pradesh',
'Mugalamarrikothapalle,Tirupati,Andhra Pradesh',
'Nagarimadugu,Tirupati,Andhra Pradesh',
'Obulampalle,Tirupati,Andhra Pradesh',
'Pullleticheruvupalle,Tirupati,Andhra Pradesh',
'Sakamvaripalle,Tirupati,Andhra Pradesh',
'Vittalam,Tirupati,Andhra Pradesh',
'Chilamathur,Tirupati,Andhra Pradesh',
'Kadur,Tirupati,Andhra Pradesh',
'Kancharapalem,Tirupati,Andhra Pradesh',
'Karipakam,Tirupati,Andhra Pradesh',
'Lingamanaidupalle,Tirupati,Andhra Pradesh',
'Pandur,Tirupati,Andhra Pradesh',
'Talarivettu,Tirupati,Andhra Pradesh',
'Varadaiahpalem,Tirupati,Andhra Pradesh',
'West Varathur,Tirupati,Andhra Pradesh',
'Chintaparthi,Tirupati,Andhra Pradesh',
'Mahal,Tirupati,Andhra Pradesh',
'Tarigonda,Tirupati,Andhra Pradesh',
'Vayalpad,Tirupati,Andhra Pradesh',
'Brahmanapalle,Tirupati,Andhra Pradesh',
'Erramaraju Palle,Tirupati,Andhra Pradesh',
'Komaragunta,Tirupati,Andhra Pradesh',
'Mambedu,Tirupati,Andhra Pradesh',
'Nallavenganapalli,Tirupati,Andhra Pradesh',
'Pathagunta,Tirupati,Andhra Pradesh',
'Perumallapalle,Tirupati,Andhra Pradesh',
'Thirumalayapalli,Tirupati,Andhra Pradesh',
'Vedurukuppam,Tirupati,Andhra Pradesh',
'Deenabandupuram,Chittoor,Andhra Pradesh',
'Matavalam,Chittoor,Andhra Pradesh',
'Palasamudram,Chittoor,Andhra Pradesh',
'Siddarajurangarajukandiga,Chittoor,Andhra Pradesh',
'Simharajapuram,Chittoor,Andhra Pradesh',
'Srikaverirajapuram,Chittoor,Andhra Pradesh',
'Vanadurgapurambo,Chittoor,Andhra Pradesh',
'Pachikapallam,Tirupati,Andhra Pradesh',
'Anjimedu,Tirupati,Andhra Pradesh',
'Chellur,Tirupati,Andhra Pradesh',
'Chindepalle,Tirupati,Andhra Pradesh',
'Durgaperi,Tirupati,Andhra Pradesh',
'Empedu,Tirupati,Andhra Pradesh',
'Gollapalle,Tirupati,Andhra Pradesh',
'Gudimallam,Tirupati,Andhra Pradesh',
'Inagalur,Tirupati,Andhra Pradesh',
'Kalavagunta,Tirupati,Andhra Pradesh',
'Kandadu,Tirupati,Andhra Pradesh',
'Krishnapuram,Tirupati,Andhra Pradesh',
'Madibaka,Tirupati,Andhra Pradesh',
'Mannavaram,Tirupati,Andhra Pradesh',
'Merlapaka,Tirupati,Andhra Pradesh',
'Modugulapalem,Tirupati,Andhra Pradesh',
'Munagalapalem,Tirupati,Andhra Pradesh',
'Pallam,Tirupati,Andhra Pradesh',
'Panguru,Tirupati,Andhra Pradesh',
'Papanaidupet,Tirupati,Andhra Pradesh',
'Poli,Tirupati,Andhra Pradesh',
'Ravillavarikandriga,Tirupati,Andhra Pradesh',
'Vagavedu,Tirupati,Andhra Pradesh',
'Velampadu,Tirupati,Andhra Pradesh',
'Vyasasramam,Tirupati,Andhra Pradesh',
'Yelavedu,Tirupati,Andhra Pradesh',
'Yerpedu,Tirupati,Andhra Pradesh',
'Bayanapalle,Proddatur,Andhra Pradesh',
'Bhimagundam,Proddatur,Andhra Pradesh',
'Bodithippanapadu,Proddatur,Andhra Pradesh',
'Chinnandlur,Proddatur,Andhra Pradesh',
'Chinnasinganapalle,Proddatur,Andhra Pradesh',
'Chirrajupalle,Proddatur,Andhra Pradesh',
'Errapalle,Proddatur,Andhra Pradesh',
'Gandhi Road,Proddatur,Andhra Pradesh',
'Gondipalle,Proddatur,Andhra Pradesh',
'Gudipadu,Proddatur,Andhra Pradesh',
'Gundlakunta,Proddatur,Andhra Pradesh',
'Idamadaka,Proddatur,Andhra Pradesh',
'Illur,Proddatur,Andhra Pradesh',
'Jillella,Proddatur,Andhra Pradesh',
'Kalamalla,Proddatur,Andhra Pradesh',
'Kamanur,Proddatur,Andhra Pradesh',
'Kanagudur,Proddatur,Andhra Pradesh',
'Karamalavandlapalle,Proddatur,Andhra Pradesh',
'Karnapapayapalle,Proddatur,Andhra Pradesh',
'Krishnampalle,Proddatur,Andhra Pradesh',
'M.Kambaladinne,Proddatur,Andhra Pradesh',
'Machanapalle,Proddatur,Andhra Pradesh',
'Madirepalle,Proddatur,Andhra Pradesh',
'Mekalabalayapalle,Proddatur,Andhra Pradesh',
'Narjampalle,Proddatur,Andhra Pradesh',
'Nawabpeta,Proddatur,Andhra Pradesh',
'Neelapuram,Proddatur,Andhra Pradesh',
'Nelatur,Proddatur,Andhra Pradesh',
'Nidizuvvi,Proddatur,Andhra Pradesh',
'Peddajonnavaram,Proddatur,Andhra Pradesh',
'Ponnampalle,Proddatur,Andhra Pradesh',
'Ponnathota,Proddatur,Andhra Pradesh',
'Pullareddypeta,Proddatur,Andhra Pradesh',
'Ramapuram,Proddatur,Andhra Pradesh',
'Ramasainagar,Proddatur,Andhra Pradesh',
'S.Uppalapadu,Proddatur,Andhra Pradesh',
'T.Sallabasayapalle,Proddatur,Andhra Pradesh',
'Talamanchipatnam,Proddatur,Andhra Pradesh',
'Torrivemmula,Proddatur,Andhra Pradesh',
'Vasudevapuram,Proddatur,Andhra Pradesh',
'Venkupalle,Proddatur,Andhra Pradesh',
'Veparala,Proddatur,Andhra Pradesh',
'Akkireddygaripalli,Cuddapah,Andhra Pradesh',
'Atlur,Cuddapah,Andhra Pradesh',
'Beebisahebpet,Cuddapah,Andhra Pradesh',
'Chenduvoyi,Cuddapah,Andhra Pradesh',
'Cherlopalli,Cuddapah,Andhra Pradesh',
'Konarachapalli,Cuddapah,Andhra Pradesh',
'Kumbhagiri,Cuddapah,Andhra Pradesh',
'Malinenipatnam,Cuddapah,Andhra Pradesh',
'Muthukur,Cuddapah,Andhra Pradesh',
'Uppatur,Cuddapah,Andhra Pradesh',
'Venkatasettipalli,Cuddapah,Andhra Pradesh',
'B . Kodur,Cuddapah,Andhra Pradesh',
'Kothapalli,Cuddapah,Andhra Pradesh',
'Basavapuram,Cuddapah,Andhra Pradesh',
'Jangamrajupalli,Cuddapah,Andhra Pradesh',
'Mallepalli,Cuddapah,Andhra Pradesh',
'Mudumala,Cuddapah,Andhra Pradesh',
'Pundlachennupalli,Cuddapah,Andhra Pradesh',
'Rekalakunta,Cuddapah,Andhra Pradesh',
'Somireddypalli,Cuddapah,Andhra Pradesh',
'T.Soudarivaripalli,Cuddapah,Andhra Pradesh',
'Konduvaripalli,Cuddapah,Andhra Pradesh',
'Palugurallapalli,Cuddapah,Andhra Pradesh',
'Anantharajupuram,Cuddapah,Andhra Pradesh',
'Ankanagodiganur,Cuddapah,Andhra Pradesh',
'Badvel Bus Stand,Cuddapah,Andhra Pradesh',
'Badvel,Cuddapah,Andhra Pradesh',
'Boyanapalli,Cuddapah,Andhra Pradesh',
'Boyanapalli,Cuddapah,Andhra Pradesh',
'Chinthalacheruvu,Cuddapah,Andhra Pradesh',
'Chinthalacheruvu,Cuddapah,Andhra Pradesh',
'Ethirajupalli,Cuddapah,Andhra Pradesh',
'Ethirajupalli,Cuddapah,Andhra Pradesh',
'Gudem,Cuddapah,Andhra Pradesh',
'Gudem,Cuddapah,Andhra Pradesh',
'Kalvapalli,Cuddapah,Andhra Pradesh',
'Kamalakur,Cuddapah,Andhra Pradesh',
'Kamalakur,Cuddapah,Andhra Pradesh',
'Mannemavaripalli,Cuddapah,Andhra Pradesh',
'Mannemvaripalli,Cuddapah,Andhra Pradesh',
'Mekalavaripalli,Cuddapah,Andhra Pradesh',
'Payalakunta,Cuddapah,Andhra Pradesh',
'Pedullapalli,Cuddapah,Andhra Pradesh',
'Prabhalaveedu,Cuddapah,Andhra Pradesh',
'Valleruvaripalli,Cuddapah,Andhra Pradesh',
'Valleruvaripalli,Cuddapah,Andhra Pradesh',
'Venkataramapuram,Cuddapah,Andhra Pradesh',
'Ankalammagudur,Proddatur,Andhra Pradesh',
'Bojjayapalle,Proddatur,Andhra Pradesh',
'Bonala,Proddatur,Andhra Pradesh',
'Dondlavagu,Proddatur,Andhra Pradesh',
'Kamasamudram,Proddatur,Andhra Pradesh',
'Koraguntapalle,Proddatur,Andhra Pradesh',
'Madur,Proddatur,Andhra Pradesh',
'Nakkalapalle,Proddatur,Andhra Pradesh',
'Kandimallayapalli,Cuddapah,Andhra Pradesh',
'Kattavaripalli,Cuddapah,Andhra Pradesh',
'Besthapalli,Cuddapah,Andhra Pradesh',
'Itimarpuram,Cuddapah,Andhra Pradesh',
'Malemarpuram,Cuddapah,Andhra Pradesh',
'Mudrapalli,Cuddapah,Andhra Pradesh',
'Nakkalapalli,Cuddapah,Andhra Pradesh',
'Obili,Cuddapah,Andhra Pradesh',
'Thimmaytagaripalli,Cuddapah,Andhra Pradesh',
'Thummachetlapalli,Cuddapah,Andhra Pradesh',
'Addalamarri,Cuddapah,Andhra Pradesh',
'Balathimmayyagaripalli,Cuddapah,Andhra Pradesh',
'Chakrayapet,Cuddapah,Andhra Pradesh',
'Chilakampalli,Cuddapah,Andhra Pradesh',
'Gangarapupalli,Cuddapah,Andhra Pradesh',
'Kalluripalli,Cuddapah,Andhra Pradesh',
'Katineni Erragudi,Cuddapah,Andhra Pradesh',
'Kondavandlapalli,Cuddapah,Andhra Pradesh',
'Kumarakalva,Cuddapah,Andhra Pradesh',
'Kuppagattupalli,Cuddapah,Andhra Pradesh',
'Kuppam,Cuddapah,Andhra Pradesh',
'Mulapalli,Cuddapah,Andhra Pradesh',
'Nersupalli,Cuddapah,Andhra Pradesh',
'Surabhi,Cuddapah,Andhra Pradesh',
'Thimmareddypalli,Cuddapah,Andhra Pradesh',
'Balayapalli,Cuddapah,Andhra Pradesh',
'Chennampalli,Cuddapah,Andhra Pradesh',
'Chinnakesampalli,Cuddapah,Andhra Pradesh',
'Diguvanelatur,Cuddapah,Andhra Pradesh',
'Dirasavantsa,Cuddapah,Andhra Pradesh',
'Eguvanelatur,Cuddapah,Andhra Pradesh',
'Gunthapalli,Cuddapah,Andhra Pradesh',
'Kongalaveedu,Cuddapah,Andhra Pradesh',
'Nandipalli,Cuddapah,Andhra Pradesh',
'Thangedupalli,Cuddapah,Andhra Pradesh',
'Thiruvengalapuram,Cuddapah,Andhra Pradesh',
'Peddarajupalli,Cuddapah,Andhra Pradesh',
'Bayanapalli,Cuddapah,Andhra Pradesh',
'Chennur,Cuddapah,Andhra Pradesh',
'Chinnamachupalli,Cuddapah,Andhra Pradesh',
'Cuddapah Coop Sugars,Cuddapah,Andhra Pradesh',
'Dumpalagattu,Cuddapah,Andhra Pradesh',
'Kokkarayapalli,Cuddapah,Andhra Pradesh',
'Kothapalli,Cuddapah,Andhra Pradesh',
'Kothapet,Cuddapah,Andhra Pradesh',
'Mundlapalli,Cuddapah,Andhra Pradesh',
'Obulampalli,Cuddapah,Andhra Pradesh',
'Pushpagiri,Cuddapah,Andhra Pradesh',
'Rachinnayapalli,Cuddapah,Andhra Pradesh',
'Ramanapalli,Cuddapah,Andhra Pradesh',
'Sivalapalli,Cuddapah,Andhra Pradesh',
'Upparapalli,Cuddapah,Andhra Pradesh',
'Bonamala,Cuddapah,Andhra Pradesh',
'Chinnamandem,Cuddapah,Andhra Pradesh',
'Devagudipalli,Cuddapah,Andhra Pradesh',
'Kalibanda,Cuddapah,Andhra Pradesh',
'Kesapuram,Cuddapah,Andhra Pradesh',
'Mallur,Cuddapah,Andhra Pradesh',
'Padamatikona,Cuddapah,Andhra Pradesh',
'Reddyvaripalli,Cuddapah,Andhra Pradesh',
'T. Sakibanda,Cuddapah,Andhra Pradesh',
'Yerragatlavandlapalli,Cuddapah,Andhra Pradesh',
'Anumpalli,Cuddapah,Andhra Pradesh',
'Chitvel,Cuddapah,Andhra Pradesh',
'Devamachupalli,Cuddapah,Andhra Pradesh',
'Kampasamudram,Cuddapah,Andhra Pradesh',
'Kandulavaripalli,Cuddapah,Andhra Pradesh',
'Mylapalli,Cuddapah,Andhra Pradesh',
'Polopalli,Cuddapah,Andhra Pradesh',
'Rajukunta,Cuddapah,Andhra Pradesh',
'Chakrapunayanipet,Cuddapah,Andhra Pradesh',
'Cuddapah R.S,Cuddapah,Andhra Pradesh',
'Alankhan Palli,Cuddapah,Andhra Pradesh',
'Almaspet,Cuddapah,Andhra Pradesh',
'Buddayapalli,Cuddapah,Andhra Pradesh',
'Chemmumiapet,Cuddapah,Andhra Pradesh',
'Chinna Musali Reddy Palli,Cuddapah,Andhra Pradesh',
'Chinnachowk,Cuddapah,Andhra Pradesh',
'Chinnakampalli,Cuddapah,Andhra Pradesh',
'Chintha Komma Dinne,Cuddapah,Andhra Pradesh',
'Cooperative Colony,Cuddapah,Andhra Pradesh',
'Cuddapah H.O,Cuddapah,Andhra Pradesh',
'Cuddapah Mundy Bazar,Cuddapah,Andhra Pradesh',
'Degalavandlapalli,Cuddapah,Andhra Pradesh',
'Industrial Estate,Cuddapah,Andhra Pradesh',
'Jayanagar,Cuddapah,Andhra Pradesh',
'Kopparthi,Cuddapah,Andhra Pradesh',
'Krishnapur R.S.,Cuddapah,Andhra Pradesh',
'Ksrm Engg College,Cuddapah,Andhra Pradesh',
'Lingampalli,Cuddapah,Andhra Pradesh',
'Lingareddy Palli,Cuddapah,Andhra Pradesh',
'Machupalli,Cuddapah,Andhra Pradesh',
'Mamillapalli,Cuddapah,Andhra Pradesh',
'Maruti Nagar,Cuddapah,Andhra Pradesh',
'Masapet,Cuddapah,Andhra Pradesh',
'Mochampet,Cuddapah,Andhra Pradesh',
'Nagarajupet,Cuddapah,Andhra Pradesh',
'Nagi Reddy Palli,Cuddapah,Andhra Pradesh',
'Nandimandalam,Proddatur,Andhra Pradesh',
'Pabbapuram,Cuddapah,Andhra Pradesh',
'Palampalli,Cuddapah,Andhra Pradesh',
'Patha Cuddapah,Cuddapah,Andhra Pradesh',
'Pendlimarri,Proddatur,Andhra Pradesh',
'Ramarajupalli,Cuddapah,Andhra Pradesh',
'Ramarajupalli,Cuddapah,Andhra Pradesh',
'Ravindra Nagar,Cuddapah,Andhra Pradesh',
'RTC Work Shop,Cuddapah,Andhra Pradesh',
'S.V.U. P.G .centre,Cuddapah,Andhra Pradesh',
'Sankarapuram,Cuddapah,Andhra Pradesh',
'Sunnapuralla Palli,Cuddapah,Andhra Pradesh',
'Tadigotla,Cuddapah,Andhra Pradesh',
'Takkolu,Cuddapah,Andhra Pradesh',
'Utukur,Cuddapah,Andhra Pradesh',
'Vallur,Proddatur,Andhra Pradesh',
'Yerramukkapalli,Cuddapah,Andhra Pradesh',
'Araveedu,Cuddapah,Andhra Pradesh',
'Burujupalli-1,Cuddapah,Andhra Pradesh',
'Burujupalli-2,Cuddapah,Andhra Pradesh',
'Cheemalacheruvupalli,Cuddapah,Andhra Pradesh',
'Galiveedu,Cuddapah,Andhra Pradesh',
'Gopanapalli,Cuddapah,Andhra Pradesh',
'Goramchervu,Cuddapah,Andhra Pradesh',
'Gundlacheruvu,Cuddapah,Andhra Pradesh',
'Kamalamarri,Cuddapah,Andhra Pradesh',
'Karimireddy Vandlapalli,Cuddapah,Andhra Pradesh',
'Nuliveedu,Cuddapah,Andhra Pradesh',
'Pandikunta,Cuddapah,Andhra Pradesh',
'Pandillapalli,Cuddapah,Andhra Pradesh',
'Pujalavandlapalli,Cuddapah,Andhra Pradesh',
'Pulikunta,Cuddapah,Andhra Pradesh',
'Pyarampalli,Cuddapah,Andhra Pradesh',
'Singamvaripalli,Cuddapah,Andhra Pradesh',
'Talamudipi,Cuddapah,Andhra Pradesh',
'Tamtamvandlapalli,Cuddapah,Andhra Pradesh',
'Thumukunta,Cuddapah,Andhra Pradesh',
'Veligallu,Cuddapah,Andhra Pradesh',
'Bethayapalli,Cuddapah,Andhra Pradesh',
'Brahmanapalli,Cuddapah,Andhra Pradesh',
'Gopavaram,Cuddapah,Andhra Pradesh',
'Gopavaram Project Site,Cuddapah,Andhra Pradesh',
'Madakalavaripalli,Cuddapah,Andhra Pradesh',
'Rachayapet,Cuddapah,Andhra Pradesh',
'Rekulakunta,Cuddapah,Andhra Pradesh',
'T. Sandrapalli,Cuddapah,Andhra Pradesh',
'Balapanagudur,Proddatur,Andhra Pradesh',
'Bestavemula,Proddatur,Andhra Pradesh',
'Chinnaventhurla,Proddatur,Andhra Pradesh',
'Devagudi,Proddatur,Andhra Pradesh',
'Dhodiyam,Proddatur,Andhra Pradesh',
'Diguvakalavatala,Proddatur,Andhra Pradesh',
'Dommaranandyala,Proddatur,Andhra Pradesh',
'Goriganur,Proddatur,Andhra Pradesh',
'Gudemcheruvu,Proddatur,Andhra Pradesh',
'J Kothapalle,Proddatur,Andhra Pradesh',
'Jammalamadugu East,Proddatur,Andhra Pradesh',
'Jammalamadugu North,Proddatur,Andhra Pradesh',
'Jammalamadugu,Proddatur,Andhra Pradesh',
'Kallutla,Proddatur,Andhra Pradesh',
'Kammavaripalle,Proddatur,Andhra Pradesh',
'Kondasunkesula,Proddatur,Andhra Pradesh',
'Moragudi,Proddatur,Andhra Pradesh',
'N Kottalapalle,Proddatur,Andhra Pradesh',
'Nemaladinne,Proddatur,Andhra Pradesh',
'Peddamudium,Proddatur,Andhra Pradesh',
'Peddapasupula,Proddatur,Andhra Pradesh',
'Ramachandrayapalle,Proddatur,Andhra Pradesh',
'Seshareddipalle,Proddatur,Andhra Pradesh',
'Vaddirala,Proddatur,Andhra Pradesh',
'Ambavaram,Proddatur,Andhra Pradesh',
'Chinnapasupula,Proddatur,Andhra Pradesh',
'Gandikota,Proddatur,Andhra Pradesh',
'Jangalapalle,Proddatur,Andhra Pradesh',
'Palur,Proddatur,Andhra Pradesh',
'Papayapalle,Proddatur,Andhra Pradesh',
'Peddanadlur,Proddatur,Andhra Pradesh',
'Purvabommepalle,Proddatur,Andhra Pradesh',
'Suddapalle,Proddatur,Andhra Pradesh',
'Sunnapurallapalle,Proddatur,Andhra Pradesh',
'Chinnakomerla,Proddatur,Andhra Pradesh',
'Brahmanapalli,Cuddapah,Andhra Pradesh',
'Chennupalli,Cuddapah,Andhra Pradesh',
'Eguvaramapuram,Cuddapah,Andhra Pradesh',
'Ganganapalli,Cuddapah,Andhra Pradesh',
'Kalasapadu,Cuddapah,Andhra Pradesh',
'Mamillapalli,Cuddapah,Andhra Pradesh',
'Narasapuram,Cuddapah,Andhra Pradesh',
'Pittigunta,Cuddapah,Andhra Pradesh',
'Tellapadu,Cuddapah,Andhra Pradesh',
'Varikunta,Cuddapah,Andhra Pradesh',
'Obayapalle,Proddatur,Andhra Pradesh',
'Seetharampuram,Proddatur,Andhra Pradesh',
'Thippireddipalle,Proddatur,Andhra Pradesh',
'Vedururu,Proddatur,Andhra Pradesh',
'Musalreddypalli,Cuddapah,Andhra Pradesh',
'Apparaopalle,Proddatur,Andhra Pradesh',
'Appayapalle,Proddatur,Andhra Pradesh',
'C Gopalapuram,Proddatur,Andhra Pradesh',
'Chilamakur,Proddatur,Andhra Pradesh',
'Chinnacheppale,Proddatur,Andhra Pradesh',
'Dadireddypalle,Proddatur,Andhra Pradesh',
'Devarajupalle,Proddatur,Andhra Pradesh',
'Gangavaram,Proddatur,Andhra Pradesh',
'Kamalapuram,Proddatur,Andhra Pradesh',
'Kokatam,Proddatur,Andhra Pradesh',
'Kondayapalle,Proddatur,Andhra Pradesh',
'Krishna Nagar,Proddatur,Andhra Pradesh',
'Kuppuruvaripalle,Proddatur,Andhra Pradesh',
'Letapalle,Proddatur,Andhra Pradesh',
'Nallingayapple,Proddatur,Andhra Pradesh',
'Pandillapalle,Proddatur,Andhra Pradesh',
'Payasampalle,Proddatur,Andhra Pradesh',
'Peddacheppalle,Proddatur,Andhra Pradesh',
'Podadurthy,Proddatur,Andhra Pradesh',
'Sambatur,Proddatur,Andhra Pradesh',
'Tsadipiralla,Proddatur,Andhra Pradesh',
'Veerapunayanipalle,Proddatur,Andhra Pradesh',
'Yerragudipadu,Proddatur,Andhra Pradesh',
'Yerraguntla,Proddatur,Andhra Pradesh',
'Yerraguntla West,Proddatur,Andhra Pradesh',
'Vv Reddy Nagar,Proddatur,Andhra Pradesh',
'Appanapalli,Cuddapah,Andhra Pradesh',
'Beechuvaripalli,Cuddapah,Andhra Pradesh',
'Bhumayapalli,Cuddapah,Andhra Pradesh',
'Etur,Cuddapah,Andhra Pradesh',
'K.Sunkesala,Cuddapah,Andhra Pradesh',
'Khajipet,Cuddapah,Andhra Pradesh',
'Kommaluru,Cuddapah,Andhra Pradesh',
'Koonavaripalli,Cuddapah,Andhra Pradesh',
'Kotlur,Cuddapah,Andhra Pradesh',
'Miduthur,Cuddapah,Andhra Pradesh',
'Nagapatnam,Cuddapah,Andhra Pradesh',
'Anantharajup R.S.,Cuddapah,Andhra Pradesh',
'Anantharajupet,Cuddapah,Andhra Pradesh',
'Balireddy Palli,Cuddapah,Andhra Pradesh',
'Barytes Factory,Cuddapah,Andhra Pradesh',
'Buduguntapalli,Cuddapah,Andhra Pradesh',
'Chennarajupodu,Cuddapah,Andhra Pradesh',
'Chiyyavaram,Cuddapah,Andhra Pradesh',
'Ganugapenta,Cuddapah,Andhra Pradesh',
'Govindampalli,Cuddapah,Andhra Pradesh',
'Kodur Rs,Cuddapah,Andhra Pradesh',
'Kodur,Cuddapah,Andhra Pradesh',
'Koneti Raju Kandrika,Cuddapah,Andhra Pradesh',
'Kukkala Doddi,Cuddapah,Andhra Pradesh',
'Lakshmigari Palli,Cuddapah,Andhra Pradesh',
'Mangampet,Cuddapah,Andhra Pradesh',
'Obanapalli,Cuddapah,Andhra Pradesh',
'Raghavarajupuram,Cuddapah,Andhra Pradesh',
'Reddivaripalli,Cuddapah,Andhra Pradesh',
'Settigunta,Cuddapah,Andhra Pradesh',
'Srinivasa Nagar,Cuddapah,Andhra Pradesh',
'Surapurajupalli,Cuddapah,Andhra Pradesh',
'Upparapalli,Cuddapah,Andhra Pradesh',
'Vellavari Kandrika,Cuddapah,Andhra Pradesh',
'Venkata Reddy Palli,Cuddapah,Andhra Pradesh',
'Venkatapathiraju Kandrika,Cuddapah,Andhra Pradesh',
'Yerraguntlakota,Cuddapah,Andhra Pradesh',
'Chowtapalle,Proddatur,Andhra Pradesh',
'Gandlur,Proddatur,Andhra Pradesh',
'Kondikandlapalle,Proddatur,Andhra Pradesh',
'Korrapadu,Proddatur,Andhra Pradesh',
'Mangapatnam,Proddatur,Andhra Pradesh',
'P Anantapuram,Proddatur,Andhra Pradesh',
'Settivaripalle,Proddatur,Andhra Pradesh',
'Ananthapuram,Cuddapah,Andhra Pradesh',
'Appanakondayapalli,Cuddapah,Andhra Pradesh',
'Brahmana Erragudi,Cuddapah,Andhra Pradesh',
'Budida Gunta Palli,Cuddapah,Andhra Pradesh',
'Dappepalli,Cuddapah,Andhra Pradesh',
'Gollapalli,Cuddapah,Andhra Pradesh',
'Guntimadugu,Cuddapah,Andhra Pradesh',
'Kasthurirajupalli,Cuddapah,Andhra Pradesh',
'Konampet,Cuddapah,Andhra Pradesh',
'Kurnoothala,Cuddapah,Andhra Pradesh',
'Maddirevula,Cuddapah,Andhra Pradesh',
'Reddivaripalli,Cuddapah,Andhra Pradesh',
'Lakkireddy Palli,Cuddapah,Andhra Pradesh',
'Chevvaripalle,Proddatur,Andhra Pradesh',
'Jangamreddypalle,Proddatur,Andhra Pradesh',
'Musalreddipalle,Proddatur,Andhra Pradesh',
'Nandyalampalle,Proddatur,Andhra Pradesh',
'Paidipalam,Proddatur,Andhra Pradesh',
'Pottipadu,Proddatur,Andhra Pradesh',
'Sunkesula,Proddatur,Andhra Pradesh',
'Thimmapuram,Proddatur,Andhra Pradesh',
'Y Kothapalle,Proddatur,Andhra Pradesh',
'Akkulugaripalle,Proddatur,Andhra Pradesh',
'Chinnakundala,Proddatur,Andhra Pradesh',
'Gunakanapalle,Proddatur,Andhra Pradesh',
'Kommanuthala,Proddatur,Andhra Pradesh',
'Lopatnuthala,Proddatur,Andhra Pradesh',
'Parnapalle,Proddatur,Andhra Pradesh',
'Peddakundala,Proddatur,Andhra Pradesh',
'Velidandla,Proddatur,Andhra Pradesh',
'Madhavaram,Cuddapah,Andhra Pradesh',
'Nekanapuram,Cuddapah,Andhra Pradesh',
'Peddapalle,Cuddapah,Andhra Pradesh',
'Venkateswara Puram,Cuddapah,Andhra Pradesh',
'Bondalakunta,Proddatur,Andhra Pradesh',
'Chinnadudyal,Proddatur,Andhra Pradesh',
'Chintakunta,Proddatur,Andhra Pradesh',
'K Kothapalle,Proddatur,Andhra Pradesh',
'Kondapuram,Proddatur,Andhra Pradesh',
'Lavanur,Proddatur,Andhra Pradesh',
'Muddanur,Proddatur,Andhra Pradesh',
'Mylavaram,Proddatur,Andhra Pradesh',
'Nallaballe,Proddatur,Andhra Pradesh',
'Penikalapadu,Proddatur,Andhra Pradesh',
'Rajulaguruvayapalle,Proddatur,Andhra Pradesh',
'Tallaproddatur,Proddatur,Andhra Pradesh',
'Uppaluru,Proddatur,Andhra Pradesh',
'Velpucherla,Proddatur,Andhra Pradesh',
'Yamavaram,Proddatur,Andhra Pradesh',
'Alladupalle,Proddatur,Andhra Pradesh',
'Anandashram,Proddatur,Andhra Pradesh',
'Anantapuram,Proddatur,Andhra Pradesh',
'Annaluru,Proddatur,Andhra Pradesh',
'Annapusastrulapalle,Proddatur,Andhra Pradesh',
'Bhadripalle,Proddatur,Andhra Pradesh',
'Chapadu,Proddatur,Andhra Pradesh',
'Chinnaguruvaluru,Proddatur,Andhra Pradesh',
'Chintakunta,Proddatur,Andhra Pradesh',
'Chiyyapadu,Proddatur,Andhra Pradesh',
'Ellampalle,Proddatur,Andhra Pradesh',
'Gallavandlapalle,Proddatur,Andhra Pradesh',
'Ganjikunta,Proddatur,Andhra Pradesh',
'Jandravaram,Proddatur,Andhra Pradesh',
'Krishnapuram,Proddatur,Andhra Pradesh',
'Lakshmipet,Proddatur,Andhra Pradesh',
'Lingaladinne,Proddatur,Andhra Pradesh',
'Mittamanipalle,Proddatur,Andhra Pradesh',
'Nagasanipalle,Proddatur,Andhra Pradesh',
'Nakkaladinne,Proddatur,Andhra Pradesh',
'Nandyalampeta,Proddatur,Andhra Pradesh',
'Obulareddypeta,Proddatur,Andhra Pradesh',
'Sankatithimmayapalle,Proddatur,Andhra Pradesh',
'Settivaripalle,Proddatur,Andhra Pradesh',
'Siddareddypalle,Proddatur,Andhra Pradesh',
'Sivapuram,Proddatur,Andhra Pradesh',
'Thippireddypalle,Proddatur,Andhra Pradesh',
'Uppaguntapalle,Proddatur,Andhra Pradesh',
'Viswanathapuram,Proddatur,Andhra Pradesh',
'Nadimpalli,Cuddapah,Andhra Pradesh',
'Adapur,Cuddapah,Andhra Pradesh',
'Akepadu,Cuddapah,Andhra Pradesh',
'Allwyn Nagar,Cuddapah,Andhra Pradesh',
'Cheyyeru Project,Cuddapah,Andhra Pradesh',
'Chintharajupalli,Cuddapah,Andhra Pradesh',
'Gundlur,Cuddapah,Andhra Pradesh',
'Konapuram,Cuddapah,Andhra Pradesh',
'Konarachapalli,Cuddapah,Andhra Pradesh',
'Kumpinipuram,Cuddapah,Andhra Pradesh',
'Lebaka,Cuddapah,Andhra Pradesh',
'Mandapalli,Cuddapah,Andhra Pradesh',
'Mantapampalli,Cuddapah,Andhra Pradesh',
'Nandalur Bazar,Cuddapah,Andhra Pradesh',
'Nandalur,Cuddapah,Andhra Pradesh',
'Naramrajupalli,Cuddapah,Andhra Pradesh',
'Patur,Cuddapah,Andhra Pradesh',
'Pothapi,Cuddapah,Andhra Pradesh',
'Pullapathur,Cuddapah,Andhra Pradesh',
'Seshamanbapuram,Cuddapah,Andhra Pradesh',
'Thogurupet,Cuddapah,Andhra Pradesh',
'Cheemalapenta,Proddatur,Andhra Pradesh',
'Diguvathuvvalapalle,Proddatur,Andhra Pradesh',
'Gondipalle,Proddatur,Andhra Pradesh',
'Kondur,Proddatur,Andhra Pradesh',
'Machanur,Proddatur,Andhra Pradesh',
'Minnaiahgaripalle,Proddatur,Andhra Pradesh',
'Thummalur,Proddatur,Andhra Pradesh',
'U Rajupalem,Proddatur,Andhra Pradesh',
'Botumeedipalli,Cuddapah,Andhra Pradesh',
'Chinnampelli,Cuddapah,Andhra Pradesh',
'Chinnaorampadu,Cuddapah,Andhra Pradesh',
'Gadela,Cuddapah,Andhra Pradesh',
'Korlakunta,Cuddapah,Andhra Pradesh',
'Mukkavaripalli,Cuddapah,Andhra Pradesh',
'Nukanapalli,Cuddapah,Andhra Pradesh',
'Obulavaripalli,Cuddapah,Andhra Pradesh',
'Peddaorampadu,Cuddapah,Andhra Pradesh',
'Upparapalli,Cuddapah,Andhra Pradesh',
'Bommavaram,Cuddapah,Andhra Pradesh',
'Cheruvukinda Rachapalli,Cuddapah,Andhra Pradesh',
'Nagavaram,Cuddapah,Andhra Pradesh',
'Venkatarajupalli,Cuddapah,Andhra Pradesh',
'Alidena,Proddatur,Andhra Pradesh',
'Garlamittapalle,Proddatur,Andhra Pradesh',
'Nagaripadu,Cuddapah,Andhra Pradesh',
'Peddarachapalli,Cuddapah,Andhra Pradesh',
'Kondur,Cuddapah,Andhra Pradesh',
'Narasingarajapuram,Cuddapah,Andhra Pradesh',
'Penagalur,Cuddapah,Andhra Pradesh',
'Perlakunta,Cuddapah,Andhra Pradesh',
'Siddavaram,Cuddapah,Andhra Pradesh',
'Singareddypalli,Cuddapah,Andhra Pradesh',
'Velagacherla,Cuddapah,Andhra Pradesh',
'Diguvapalle,Proddatur,Andhra Pradesh',
'Ganganapalle,Proddatur,Andhra Pradesh',
'Gopalapuram,Proddatur,Andhra Pradesh',
'Kammavaripalle,Proddatur,Andhra Pradesh',
'Moillakalava,Proddatur,Andhra Pradesh',
'Paidikalva,Proddatur,Andhra Pradesh',
'Pathasankatipalle,Proddatur,Andhra Pradesh',
'Rachavaripalle,Proddatur,Andhra Pradesh',
'Ramapuram,Proddatur,Andhra Pradesh',
'Srinivasapuram,Proddatur,Andhra Pradesh',
'Thippireddypalle,Proddatur,Andhra Pradesh',
'Vellatur,Proddatur,Andhra Pradesh',
'Akkalareddypalli,Cuddapah,Andhra Pradesh',
'Amagampalli,Cuddapah,Andhra Pradesh',
'Ayyavaripalli,Cuddapah,Andhra Pradesh',
'Boppapuram,Cuddapah,Andhra Pradesh',
'Chennavaram,Cuddapah,Andhra Pradesh',
'Chinthalapalli,Cuddapah,Andhra Pradesh',
'Dammanapalli,Cuddapah,Andhra Pradesh',
'Govindayapalli,Cuddapah,Andhra Pradesh',
'Itigullapadu,Cuddapah,Andhra Pradesh',
'Kodigudlapadu,Cuddapah,Andhra Pradesh',
'Munnelli,Cuddapah,Andhra Pradesh',
'Porumamilla,Cuddapah,Andhra Pradesh',
'Pullaveedu,Cuddapah,Andhra Pradesh',
'Rameswaram,Cuddapah,Andhra Pradesh',
'Rangasamudram,Cuddapah,Andhra Pradesh',
'Reddikottala,Cuddapah,Andhra Pradesh',
'Sankavaram,Cuddapah,Andhra Pradesh',
'Savisettipalli,Cuddapah,Andhra Pradesh',
'Vaddemanu,Cuddapah,Andhra Pradesh',
'Annavaram,Proddatur,Andhra Pradesh',
'Chennamarajupalle,Proddatur,Andhra Pradesh',
'Chowdur,Proddatur,Andhra Pradesh',
'Dorasanipalle,Proddatur,Andhra Pradesh',
'Duvvur,Proddatur,Andhra Pradesh',
'Gopavaram,Proddatur,Andhra Pradesh',
'Hanumanagutti,Proddatur,Andhra Pradesh',
'Holmespet,Proddatur,Andhra Pradesh',
'Kakirenipalle,Proddatur,Andhra Pradesh',
'Kallur,Proddatur,Andhra Pradesh',
'Khadarabad,Proddatur,Andhra Pradesh',
'Korrapadu Road,Proddatur,Andhra Pradesh',
'Korrapadu,Proddatur,Andhra Pradesh',
'Kothapalle,Proddatur,Andhra Pradesh',
'Maduru,Proddatur,Andhra Pradesh',
'Malepadu,Proddatur,Andhra Pradesh',
'Meenapuram,Proddatur,Andhra Pradesh',
'Modameedipalle,Proddatur,Andhra Pradesh',
'Mydekur,Proddatur,Andhra Pradesh',
'Nagalapalle,Proddatur,Andhra Pradesh',
'Onipenta,Proddatur,Andhra Pradesh',
'Pallavolu,Proddatur,Andhra Pradesh',
'Peddasettipalle,Proddatur,Andhra Pradesh',
'Potladurthi,Proddatur,Andhra Pradesh',
'Proddatur Bazaar,Proddatur,Andhra Pradesh',
'Proddatur East,Proddatur,Andhra Pradesh',
'Proddatur Fort,Proddatur,Andhra Pradesh',
'Proddatur H.O,Proddatur,Andhra Pradesh',
'Sankarapuram,Proddatur,Andhra Pradesh',
'Somulavaripalle,Proddatur,Andhra Pradesh',
'Tallamapuram,Proddatur,Andhra Pradesh',
'Upparapalle,Proddatur,Andhra Pradesh',
'Yerraguntlapalle,Proddatur,Andhra Pradesh',
'Simhadripuram,Proddatur,Andhra Pradesh',
'Achavalli,Proddatur,Andhra Pradesh',
'Agadur,Proddatur,Andhra Pradesh',
'Ambakapalle,Proddatur,Andhra Pradesh',
'Ankalammapeta,Proddatur,Andhra Pradesh',
'Balapanur,Proddatur,Andhra Pradesh',
'Bokkudupalle,Proddatur,Andhra Pradesh',
'Brahmanapalle,Proddatur,Andhra Pradesh',
'Chinnarangapuram,Proddatur,Andhra Pradesh',
'Chintalajutur,Proddatur,Andhra Pradesh',
'Erraballe,Proddatur,Andhra Pradesh',
'Erripalle,Proddatur,Andhra Pradesh',
'Ganganapalle,Proddatur,Andhra Pradesh',
'Gollalagudur,Proddatur,Andhra Pradesh',
'Gotur,Proddatur,Andhra Pradesh',
'Inagalur,Proddatur,Andhra Pradesh',
'Ippatla,Proddatur,Andhra Pradesh',
'Kondreddypalle,Proddatur,Andhra Pradesh',
'Krishnamgaripalle,Proddatur,Andhra Pradesh',
'Lingala,Proddatur,Andhra Pradesh',
'Murarichintala,Proddatur,Andhra Pradesh',
'Nallacheruvupalle,Proddatur,Andhra Pradesh',
'Nallapureddypalle,Proddatur,Andhra Pradesh',
'Palur,Proddatur,Andhra Pradesh',
'Peddajutur,Proddatur,Andhra Pradesh',
'Peddarangapuram,Proddatur,Andhra Pradesh',
'Pulivendla Bus-stand,Proddatur,Andhra Pradesh',
'Pulivendla H.O,Proddatur,Andhra Pradesh',
'Pulivendlakutcherry,Proddatur,Andhra Pradesh',
'R Thummalapalle,Proddatur,Andhra Pradesh',
'Saidapuram,Proddatur,Andhra Pradesh',
'Santhakovur,Proddatur,Andhra Pradesh',
'Tallapalle,Proddatur,Andhra Pradesh',
'Tondur,Proddatur,Andhra Pradesh',
'Udavagandla,Proddatur,Andhra Pradesh',
'Ulimella,Proddatur,Andhra Pradesh',
'Vaimpalle,Proddatur,Andhra Pradesh',
'Vemula,Proddatur,Andhra Pradesh',
'Venkatapuram,Proddatur,Andhra Pradesh',
'Ananthaiah Gari Palle,Cuddapah,Andhra Pradesh',
'Ananthasamudram,Cuddapah,Andhra Pradesh',
'Appayarajupet,Cuddapah,Andhra Pradesh',
'Dalavaipalli,Cuddapah,Andhra Pradesh',
'Dandlapalli,Cuddapah,Andhra Pradesh',
'Gopamambapuram,Cuddapah,Andhra Pradesh',
'Pouruvengannagaripalli,Cuddapah,Andhra Pradesh',
'Pullampet,Cuddapah,Andhra Pradesh',
'Puthanavaripalli,Cuddapah,Andhra Pradesh',
'T.Kammapalli,Cuddapah,Andhra Pradesh',
'Vathalur,Cuddapah,Andhra Pradesh',
'Kommanavaripalli,Cuddapah,Andhra Pradesh',
'Kothapet,Cuddapah,Andhra Pradesh',
'Ramasamudram,Cuddapah,Andhra Pradesh',
'Reddipalli,Cuddapah,Andhra Pradesh',
'Thippayyapalli,Cuddapah,Andhra Pradesh',
'Brahmanapalli,Cuddapah,Andhra Pradesh',
'Buduguntapalli,Cuddapah,Andhra Pradesh',
'Cherlopalli,Cuddapah,Andhra Pradesh',
'Galivaripalli,Cuddapah,Andhra Pradesh',
'Karampalli,Cuddapah,Andhra Pradesh',
'Kothaboyanapalli,Cuddapah,Andhra Pradesh',
'Kuchivaripalli,Cuddapah,Andhra Pradesh',
'Lingarajupalli,Cuddapah,Andhra Pradesh',
'Madanagopalapuram,Cuddapah,Andhra Pradesh',
'Mandaram,Cuddapah,Andhra Pradesh',
'Mannur,Cuddapah,Andhra Pradesh',
'Mittameedipalli,Cuddapah,Andhra Pradesh',
'Narayana(Nellore),Cuddapah,Andhra Pradesh',
'Poli,Cuddapah,Andhra Pradesh',
'Rajampet H.O,Cuddapah,Andhra Pradesh',
'Rajampet Rs,Cuddapah,Andhra Pradesh',
'Rollamadugu,Cuddapah,Andhra Pradesh',
'Seetharamapuram,Cuddapah,Andhra Pradesh',
'Tallapaka,Cuddapah,Andhra Pradesh',
'Utukur,Cuddapah,Andhra Pradesh',
'Varadaiahgaripalli,Cuddapah,Andhra Pradesh',
'Arakatavemula,Proddatur,Andhra Pradesh',
'Chinnasettipalle,Proddatur,Andhra Pradesh',
'Gadegudur,Proddatur,Andhra Pradesh',
'Gopayapalle,Proddatur,Andhra Pradesh',
'Kulur,Proddatur,Andhra Pradesh',
'Pagidala,Proddatur,Andhra Pradesh',
'Parlapadu,Proddatur,Andhra Pradesh',
'Rajupalam,Proddatur,Andhra Pradesh',
'Tanguturu,Proddatur,Andhra Pradesh',
'Velavali,Proddatur,Andhra Pradesh',
'Eruvapalem,Proddatur,Andhra Pradesh',
'Chitlur,Cuddapah,Andhra Pradesh',
'Dinnepadu,Cuddapah,Andhra Pradesh',
'Ekilapalli,Cuddapah,Andhra Pradesh',
'Gopagudi Palli,Cuddapah,Andhra Pradesh',
'Guvvalachervu,Cuddapah,Andhra Pradesh',
'Hasanapuram,Cuddapah,Andhra Pradesh',
'Kalpanayunicheruvu,Cuddapah,Andhra Pradesh',
'Kondavandlapalli,Cuddapah,Andhra Pradesh',
'Nallaguttapalli,Cuddapah,Andhra Pradesh',
'Neelakantaraopet,Cuddapah,Andhra Pradesh',
'Rajupalli,Cuddapah,Andhra Pradesh',
'Ramapuram,Cuddapah,Andhra Pradesh',
'Saraswatipalli,Cuddapah,Andhra Pradesh',
'Suddamalla,Cuddapah,Andhra Pradesh',
'Abbavaramvandlapalli,Cuddapah,Andhra Pradesh',
'Anumpalli,Cuddapah,Andhra Pradesh',
'Balireddygari Palli,Cuddapah,Andhra Pradesh',
'Botlachervu,Cuddapah,Andhra Pradesh',
'Chennamukka Palli,Cuddapah,Andhra Pradesh',
'Diguvagottiveedu,Cuddapah,Andhra Pradesh',
'Eguvagottiveedu,Cuddapah,Andhra Pradesh',
'Endapalli,Cuddapah,Andhra Pradesh',
'Gorlamudiveedu,Cuddapah,Andhra Pradesh',
'Gunnikuntla,Cuddapah,Andhra Pradesh',
'Kakulavaram,Cuddapah,Andhra Pradesh',
'Katinayakunta,Cuddapah,Andhra Pradesh',
'Madhavaram,Cuddapah,Andhra Pradesh',
'Masapet Bazar,Cuddapah,Andhra Pradesh',
'Mudumpadu,Cuddapah,Andhra Pradesh',
'Odiveedu,Cuddapah,Andhra Pradesh',
'Pemmadapalli,Cuddapah,Andhra Pradesh',
'Pothukurapalli,Cuddapah,Andhra Pradesh',
'Rayachoti,Cuddapah,Andhra Pradesh',
'Sanjeevi Nagar,Cuddapah,Andhra Pradesh',
'Sibyala,Cuddapah,Andhra Pradesh',
'Venkatreddygaripalli,Cuddapah,Andhra Pradesh',
'Abbavaram,Cuddapah,Andhra Pradesh',
'Bandlapalli,Cuddapah,Andhra Pradesh',
'Besthapalli,Cuddapah,Andhra Pradesh',
'Gutta Kinda Racha Palli,Cuddapah,Andhra Pradesh',
'Jangampalli,Cuddapah,Andhra Pradesh',
'Madithadu,Cuddapah,Andhra Pradesh',
'Peddabidiki,Cuddapah,Andhra Pradesh',
'Peddinenikalva,Cuddapah,Andhra Pradesh',
'Pincha Dam Site,Cuddapah,Andhra Pradesh',
'Rayavaram,Cuddapah,Andhra Pradesh',
'Adavikammapalli,Cuddapah,Andhra Pradesh',
'Devapatla,Cuddapah,Andhra Pradesh',
'Dudyala,Cuddapah,Andhra Pradesh',
'Guriginja Kunta,Cuddapah,Andhra Pradesh',
'Guttapalli,Cuddapah,Andhra Pradesh',
'Motakatla,Cuddapah,Andhra Pradesh',
'Muthukuvandla Palli,Cuddapah,Andhra Pradesh',
'Narayana Reddy Palli,Cuddapah,Andhra Pradesh',
'Rajuvaripalli,Cuddapah,Andhra Pradesh',
'Rowthukunta,Cuddapah,Andhra Pradesh',
'Sambepalli,Cuddapah,Andhra Pradesh',
'Settipalli,Cuddapah,Andhra Pradesh',
'T. Sadipirallavandla Palli,Cuddapah,Andhra Pradesh',
'Vaddevandlapalli,Cuddapah,Andhra Pradesh',
'Jangalapalli,Cuddapah,Andhra Pradesh',
'Jyothi,Cuddapah,Andhra Pradesh',
'P. Kothapalli,Cuddapah,Andhra Pradesh',
'Siddavattam,Cuddapah,Andhra Pradesh',
'Vontithatipalli,Cuddapah,Andhra Pradesh',
'Agraharam,Proddatur,Andhra Pradesh',
'B Cherlopalle,Proddatur,Andhra Pradesh',
'Bidinamcherla,Proddatur,Andhra Pradesh',
'Dudekunta,Proddatur,Andhra Pradesh',
'Gurijala,Proddatur,Andhra Pradesh',
'Himakunta,Proddatur,Andhra Pradesh',
'Kasanur,Proddatur,Andhra Pradesh',
'Bhagampalli,Cuddapah,Andhra Pradesh',
'Budidagunta Rachapalli,Cuddapah,Andhra Pradesh',
'Gundlapalli,Cuddapah,Andhra Pradesh',
'Kanchipativandlapalli,Cuddapah,Andhra Pradesh',
'Peddabalija Palli,Cuddapah,Andhra Pradesh',
'Polimerapalli,Cuddapah,Andhra Pradesh',
'Reddivaripalli,Cuddapah,Andhra Pradesh',
'Sanipaya,Cuddapah,Andhra Pradesh',
'T. Sundupalli,Cuddapah,Andhra Pradesh',
'Thimmasamudram,Cuddapah,Andhra Pradesh',
'Peddapalli,Cuddapah,Andhra Pradesh',
'Bedudur,Proddatur,Andhra Pradesh',
'Bukkapatnam,Proddatur,Andhra Pradesh',
'Chevvanagayapalle,Proddatur,Andhra Pradesh',
'Dattapuram,Proddatur,Andhra Pradesh',
'Erragudi,Proddatur,Andhra Pradesh',
'Eturu,Proddatur,Andhra Pradesh',
'K Sugumanchipalle,Proddatur,Andhra Pradesh',
'Kodur,Proddatur,Andhra Pradesh',
'Konavaripalle,Proddatur,Andhra Pradesh',
'Nedarapeta,Proddatur,Andhra Pradesh',
'Regadipalle,Proddatur,Andhra Pradesh',
'Siregepalle,Proddatur,Andhra Pradesh',
'Thirumallayapalle,Proddatur,Andhra Pradesh',
'Yenamalachintala,Proddatur,Andhra Pradesh',
'Tangatur,Cuddapah,Andhra Pradesh',
'Kalavakunta,Cuddapah,Andhra Pradesh',
'Rajasahebpet,Cuddapah,Andhra Pradesh',
'Siddavaram,Cuddapah,Andhra Pradesh',
'T.Sallagarigela,Cuddapah,Andhra Pradesh',
'Tekurpet,Cuddapah,Andhra Pradesh',
'Thokalapalli,Cuddapah,Andhra Pradesh',
'Bhadripalle,Proddatur,Andhra Pradesh',
'Buchupalle,Proddatur,Andhra Pradesh',
'Kamballe,Proddatur,Andhra Pradesh',
'Lomada,Proddatur,Andhra Pradesh',
'Mallela,Proddatur,Andhra Pradesh',
'Ravulakolanu,Proddatur,Andhra Pradesh',
'T Thummalapalle,Proddatur,Andhra Pradesh',
'Duggananagaripalle,Proddatur,Andhra Pradesh',
'Kathalur,Proddatur,Andhra Pradesh',
'Bakkananagaripalle,Proddatur,Andhra Pradesh',
'Alavalapadu,Proddatur,Andhra Pradesh',
'Ayyavaripalli,Proddatur,Andhra Pradesh',
'Giddankipalle,Proddatur,Andhra Pradesh',
'Kuppalapalle,Proddatur,Andhra Pradesh',
'Muthukur,Proddatur,Andhra Pradesh',
'Nagoor,Proddatur,Andhra Pradesh',
'Pamuluru,Proddatur,Andhra Pradesh',
'T Velamvaripalle,Proddatur,Andhra Pradesh',
'Tangedupalle,Proddatur,Andhra Pradesh',
'Veerannagattupalle,Proddatur,Andhra Pradesh',
'Ambavaram,Proddatur,Andhra Pradesh',
'C Kothapalle,Proddatur,Andhra Pradesh',
'Galivaripalle,Proddatur,Andhra Pradesh',
'Gangayapalle,Proddatur,Andhra Pradesh',
'Gotur,Proddatur,Andhra Pradesh',
'Komarunipalle,Proddatur,Andhra Pradesh',
'Koppalu,Proddatur,Andhra Pradesh',
'Lebaka,Proddatur,Andhra Pradesh',
'Peddaputta,Proddatur,Andhra Pradesh',
'Tappetla,Proddatur,Andhra Pradesh',
'Thollaganganapalle,Proddatur,Andhra Pradesh',
'Edapalli,Cuddapah,Andhra Pradesh',
'Gadikota,Cuddapah,Andhra Pradesh',
'Gurrappagaripalli,Cuddapah,Andhra Pradesh',
'Matli,Cuddapah,Andhra Pradesh',
'Peddiveedu,Cuddapah,Andhra Pradesh',
'Rachapalli,Cuddapah,Andhra Pradesh',
'Somavaram,Cuddapah,Andhra Pradesh',
'Veeraballi,Cuddapah,Andhra Pradesh',
'Vongimalla,Cuddapah,Andhra Pradesh',
'Busireddypalle,Proddatur,Andhra Pradesh',
'Gangireddypalle,Proddatur,Andhra Pradesh',
'Gonumakulapalle,Proddatur,Andhra Pradesh',
'Moillacheruvu,Proddatur,Andhra Pradesh',
'Obulareddypalle,Proddatur,Andhra Pradesh',
'Palagiri,Proddatur,Andhra Pradesh',
'Ramireddypalle,Proddatur,Andhra Pradesh',
'Yerramalapalle,Proddatur,Andhra Pradesh',
'Bhumayagaripalle,Proddatur,Andhra Pradesh',
'Chagaleru,Proddatur,Andhra Pradesh',
'Kanamakindkottala,Proddatur,Andhra Pradesh',
'Mobbuchintalapalle,Proddatur,Andhra Pradesh',
'Pendluru,Proddatur,Andhra Pradesh',
'V Kothapalle,Proddatur,Andhra Pradesh',
'Velpula,Proddatur,Andhra Pradesh',
'Animela,Proddatur,Andhra Pradesh',
'Gangaperur,Cuddapah,Andhra Pradesh',
'Gollapalli,Cuddapah,Andhra Pradesh',
'Kudumalur,Cuddapah,Andhra Pradesh',
'Mohiddin Sahib Palli,Cuddapah,Andhra Pradesh',
'Narvakatpalli,Cuddapah,Andhra Pradesh',
'Rachagudipalli,Cuddapah,Andhra Pradesh',
'Rachapalli,Cuddapah,Andhra Pradesh',
'Vontimitta,Cuddapah,Andhra Pradesh',
'Indukur,Proddatur,Andhra Pradesh',
'Pathapalle,Proddatur,Andhra Pradesh',
'A. Obayapalle,Proddatur,Andhra Pradesh',
'C Rajupalem,Proddatur,Andhra Pradesh',
'Kirthipalle,Proddatur,Andhra Pradesh',
'Kodur,Proddatur,Andhra Pradesh',
'Kommaddi,Proddatur,Andhra Pradesh',
'Peddanapadu,Proddatur,Andhra Pradesh',
'T Sunkesula,Proddatur,Andhra Pradesh',
'Talapanur,Proddatur,Andhra Pradesh',
'Thummalapalle,Proddatur,Andhra Pradesh',
'Urutur,Proddatur,Andhra Pradesh',
'Valasapalle,Proddatur,Andhra Pradesh',
'Veldurthi,Proddatur,Andhra Pradesh',
'D Vemavaram,Kakinada,Andhra Pradesh',
'Gangavaram,Rajahmundry,Andhra Pradesh',
'GSL Medical College,Rajahmundry,Andhra Pradesh',
'Konthamuru,Rajahmundry,Andhra Pradesh',
'Navara,Kakinada,Andhra Pradesh',
'Satellite City,Rajahmundry,Andhra Pradesh',
'Thungamadugula,Kakinada,Andhra Pradesh',
'Vetamamidi,Kakinada,Andhra Pradesh',
'Yellavaram,Kakinada,Andhra Pradesh',
'Yendapalli,Kakinada,Andhra Pradesh',
'Yerramreddypalem,Kakinada,Andhra Pradesh',
'Addatigala,Kakinada,Andhra Pradesh',
'Bhimavaram,Kakinada,Andhra Pradesh',
'Bodlanka,Kakinada,Andhra Pradesh',
'Cheedipalem,Kakinada,Andhra Pradesh',
'Dhanayampalem,Kakinada,Andhra Pradesh',
'Doramamidi,Kakinada,Andhra Pradesh',
'Gondolu,Kakinada,Andhra Pradesh',
'Jaderu,Kakinada,Andhra Pradesh',
'K Yeeragadda,Kakinada,Andhra Pradesh',
'Kinaparthi,Kakinada,Andhra Pradesh',
'Konalova,Kakinada,Andhra Pradesh',
'Marripalem,Kakinada,Andhra Pradesh',
'Marriveedu,Kakinada,Andhra Pradesh',
'Matlapadu,Kakinada,Andhra Pradesh',
'Mohanapuram,Kakinada,Andhra Pradesh',
'Pandraprolu,Kakinada,Andhra Pradesh',
'Pinjarakonda,Kakinada,Andhra Pradesh',
'Sommannapalem,Kakinada,Andhra Pradesh',
'Thimmapuram,Kakinada,Andhra Pradesh',
'Ainavalli,Amalapuram,Andhra Pradesh',
'Ainavillilanka,Amalapuram,Andhra Pradesh',
'K.Jagannadhapuram,Amalapuram,Andhra Pradesh',
'Kondukuduru,Amalapuram,Andhra Pradesh',
'Madupalli,Amalapuram,Andhra Pradesh',
'Magam,Amalapuram,Andhra Pradesh',
'Moolapolam,Amalapuram,Andhra Pradesh',
'Pothukurru,Amalapuram,Andhra Pradesh',
'Sanapallilanka,Amalapuram,Andhra Pradesh',
'Siripalli,Amalapuram,Andhra Pradesh',
'Tottaramudi,Amalapuram,Andhra Pradesh',
'Veeravallipelem,Amalapuram,Andhra Pradesh',
'Velavalapalli,Amalapuram,Andhra Pradesh',
'Mukteswaram,Amalapuram,Andhra Pradesh',
'Nallacheruvu,Amalapuram,Andhra Pradesh',
'Nedunuru,Amalapuram,Andhra Pradesh',
'Vilasa,Amalapuram,Andhra Pradesh',
'Alamuru,Rajahmundry,Andhra Pradesh',
'Baduguvanilanka,Rajahmundry,Andhra Pradesh',
'Chintaluru,Rajahmundry,Andhra Pradesh',
'Choppella,Rajahmundry,Andhra Pradesh',
'Gummileru,Rajahmundry,Andhra Pradesh',
'Jonnada,Rajahmundry,Andhra Pradesh',
'Madiki,Rajahmundry,Andhra Pradesh',
'Modukuru,Rajahmundry,Andhra Pradesh',
'Mulastanam,Rajahmundry,Andhra Pradesh',
'Narsipudi,Rajahmundry,Andhra Pradesh',
'Pedapalla,Rajahmundry,Andhra Pradesh',
'Penikeru,Rajahmundry,Andhra Pradesh',
'Pinapalla,Rajahmundry,Andhra Pradesh',
'Sandhipudi,Rajahmundry,Andhra Pradesh',
'Allavaram,Amalapuram,Andhra Pradesh',
'Bodasakurru,Amalapuram,Andhra Pradesh',
'Godilanka,Amalapuram,Andhra Pradesh',
'Goditippa,Amalapuram,Andhra Pradesh',
'Guthulavaripalem,Amalapuram,Andhra Pradesh',
'Kodurupadu,Amalapuram,Andhra Pradesh',
'Komaragiripatnam,Amalapuram,Andhra Pradesh',
'Samanthakurru,Amalapuram,Andhra Pradesh',
'Tummalapalli,Amalapuram,Andhra Pradesh',
'Turupulanka,Amalapuram,Andhra Pradesh',
'Vodalarevu,Amalapuram,Andhra Pradesh',
'Bendamurlanka,Amalapuram,Andhra Pradesh',
'Devaguptam,Amalapuram,Andhra Pradesh',
'Godi,Amalapuram,Andhra Pradesh',
'Mogallamori,Amalapuram,Andhra Pradesh',
'Vakkalanka,Amalapuram,Andhra Pradesh',
'Amalapuram Bus Complex,Amalapuram,Andhra Pradesh',
'Amalapuram H.O,Amalapuram,Andhra Pradesh',
'Gandhi Bazar,Amalapuram,Andhra Pradesh',
'Gangalakurru Agraharam,Amalapuram,Andhra Pradesh',
'Gudala,Amalapuram,Andhra Pradesh',
'Immidivarappadu,Amalapuram,Andhra Pradesh',
'Induppalli,Amalapuram,Andhra Pradesh',
'Janupalli,Amalapuram,Andhra Pradesh',
'Kamanagaruvu,Amalapuram,Andhra Pradesh',
'Moberlypeta,Amalapuram,Andhra Pradesh',
'Nadipudi,Amalapuram,Andhra Pradesh',
'New Colony,Amalapuram,Andhra Pradesh',
'Rdo\'s Office Road,Amalapuram,Andhra Pradesh',
'Rollapalem,Amalapuram,Andhra Pradesh',
'Sakurru,Amalapuram,Andhra Pradesh',
'Tandavapalli,Amalapuram,Andhra Pradesh',
'Vannechintalapudi,Amalapuram,Andhra Pradesh',
'Vidyanagaram,Amalapuram,Andhra Pradesh',
'Bandarlanka,Amalapuram,Andhra Pradesh',
'Bhatnavilli,Amalapuram,Andhra Pradesh',
'Peruru,Amalapuram,Andhra Pradesh',
'Samanasa,Amalapuram,Andhra Pradesh',
'A.Vemavaram,Amalapuram,Andhra Pradesh',
'Ambajipeta,Amalapuram,Andhra Pradesh',
'Irusumanda,Amalapuram,Andhra Pradesh',
'K.Pedapudi,Amalapuram,Andhra Pradesh',
'Kamujuvarilanka,Amalapuram,Andhra Pradesh',
'Machavaram,Amalapuram,Andhra Pradesh',
'Mosalapalli,Amalapuram,Andhra Pradesh',
'Nandampudi,Amalapuram,Andhra Pradesh',
'Pasupalli,Amalapuram,Andhra Pradesh',
'Mukkamala,Amalapuram,Andhra Pradesh',
'Pulletikurru,Amalapuram,Andhra Pradesh',
'Tondavaram,Amalapuram,Andhra Pradesh',
'Anaparthy,Rajahmundry,Andhra Pradesh',
'Kutukuluru,Rajahmundry,Andhra Pradesh',
'Laxminarasapuram,Rajahmundry,Andhra Pradesh',
'Lolla,Rajahmundry,Andhra Pradesh',
'Mahendrawada,Rajahmundry,Andhra Pradesh',
'Pedaparthy,Rajahmundry,Andhra Pradesh',
'Polamuru,Rajahmundry,Andhra Pradesh',
'Pulagurtha,Rajahmundry,Andhra Pradesh',
'Ramavaram,Rajahmundry,Andhra Pradesh',
'Ankampalem,Amalapuram,Andhra Pradesh',
'Bobbarlanka,Amalapuram,Andhra Pradesh',
'Kattunga,Amalapuram,Andhra Pradesh',
'Narkedmilli,Amalapuram,Andhra Pradesh',
'Peravaram,Amalapuram,Andhra Pradesh',
'Pulidindi,Amalapuram,Andhra Pradesh',
'Rajavaram,Amalapuram,Andhra Pradesh',
'Vadapalli,Amalapuram,Andhra Pradesh',
'Vaddiparru,Amalapuram,Andhra Pradesh',
'Vasanthavada,Amalapuram,Andhra Pradesh',
'Velicheru,Amalapuram,Andhra Pradesh',
'Vutchili,Amalapuram,Andhra Pradesh',
'Atreyapuram,Amalapuram,Andhra Pradesh',
'Ryali,Amalapuram,Andhra Pradesh',
'Vubalanka,Amalapuram,Andhra Pradesh',
'Lolla,Amalapuram,Andhra Pradesh',
'Arikarevula,Rajahmundry,Andhra Pradesh',
'Balabhadrapuram,Rajahmundry,Andhra Pradesh',
'Bikkavolu,Rajahmundry,Andhra Pradesh',
'Kapavaram,Rajahmundry,Andhra Pradesh',
'Kapavaram,Rajahmundry,Andhra Pradesh',
'Komaripalem,Rajahmundry,Andhra Pradesh',
'Konkuduru,Rajahmundry,Andhra Pradesh',
'Koppavaram,Rajahmundry,Andhra Pradesh',
'Pandalapaka,Rajahmundry,Andhra Pradesh',
'Rangapuram,Rajahmundry,Andhra Pradesh',
'Singampalli,Rajahmundry,Andhra Pradesh',
'Vulapalli,Rajahmundry,Andhra Pradesh',
'D.Gannavaram,Amalapuram,Andhra Pradesh',
'Chinaramanayyapeta,Rajahmundry,Andhra Pradesh',
'Choppakonda,Rajahmundry,Andhra Pradesh',
'Devaram,Rajahmundry,Andhra Pradesh',
'Devipatnam,Rajahmundry,Andhra Pradesh',
'Indukuru,Rajahmundry,Andhra Pradesh',
'Indukurupeta,Rajahmundry,Andhra Pradesh',
'Manturu,Rajahmundry,Andhra Pradesh',
'Palem,Rajahmundry,Andhra Pradesh',
'Pamugandi,Rajahmundry,Andhra Pradesh',
'Pudipalli,Rajahmundry,Andhra Pradesh',
'Sarabhavaram,Rajahmundry,Andhra Pradesh',
'Tunnuru,Rajahmundry,Andhra Pradesh',
'V.Ramannapalem,Rajahmundry,Andhra Pradesh',
'Donkarayi,Khammam,Andhra Pradesh',
'Forebey Dam Camp,Khammam,Andhra Pradesh',
'Mangampadu,Khammam,Andhra Pradesh',
'Gandepalli,Rajahmundry,Andhra Pradesh',
'Murari,Rajahmundry,Andhra Pradesh',
'N.T.Rajapuram,Rajahmundry,Andhra Pradesh',
'Singarampalem,Rajahmundry,Andhra Pradesh',
'Amudalabanda,Rajahmundry,Andhra Pradesh',
'Doramamidi,Rajahmundry,Andhra Pradesh',
'Goragummi,Rajahmundry,Andhra Pradesh',
'Jaggampalem,Rajahmundry,Andhra Pradesh',
'Kamarajupeta,Rajahmundry,Andhra Pradesh',
'Kothada,Rajahmundry,Andhra Pradesh',
'Lakkonda,Rajahmundry,Andhra Pradesh',
'Molleru,Rajahmundry,Andhra Pradesh',
'Nellipudi,Rajahmundry,Andhra Pradesh',
'Pidathamamidi,Rajahmundry,Andhra Pradesh',
'Soorampalem,Rajahmundry,Andhra Pradesh',
'Atchutapuram,Rajahmundry,Andhra Pradesh',
'Bhupatipalem,Rajahmundry,Andhra Pradesh',
'Chinabhimpalli,Rajahmundry,Andhra Pradesh',
'Gadelapalem,Rajahmundry,Andhra Pradesh',
'Gangampalem,Rajahmundry,Andhra Pradesh',
'Gokavaram,Rajahmundry,Andhra Pradesh',
'Gummaladoddi,Rajahmundry,Andhra Pradesh',
'Kothapalli,Rajahmundry,Andhra Pradesh',
'Mallavaram,Rajahmundry,Andhra Pradesh',
'Rampayerrampalem,Rajahmundry,Andhra Pradesh',
'Tantikonda,Rajahmundry,Andhra Pradesh',
'Tirumalayapalem,Rajahmundry,Andhra Pradesh',
'Vedurupaka,Rajahmundry,Andhra Pradesh',
'A Mallavaram,Kakinada,Andhra Pradesh',
'A V Nagaram,Kakinada,Andhra Pradesh',
'Bhogapuram,Kakinada,Andhra Pradesh',
'Chebrolu,Kakinada,Andhra Pradesh',
'Chendurti,Kakinada,Andhra Pradesh',
'Durgada,Kakinada,Andhra Pradesh',
'Gollaprolu,Kakinada,Andhra Pradesh',
'Kathipudi,Kakinada,Andhra Pradesh',
'Kodavali,Kakinada,Andhra Pradesh',
'Kommanapalli,Kakinada,Andhra Pradesh',
'Kothaperumallapuram,Kakinada,Andhra Pradesh',
'P Dantamuru,Kakinada,Andhra Pradesh',
'Raparthi,Kakinada,Andhra Pradesh',
'Rayavaram,Kakinada,Andhra Pradesh',
'Tatiparthi,Kakinada,Andhra Pradesh',
'Kesanakurru,Amalapuram,Andhra Pradesh',
'Komaragiri,Amalapuram,Andhra Pradesh',
'Muramalla,Amalapuram,Andhra Pradesh',
'Pasuvullanka,Amalapuram,Andhra Pradesh',
'Serilanka,Amalapuram,Andhra Pradesh',
'T.Kothapalli,Amalapuram,Andhra Pradesh',
'Tillakuppa,Amalapuram,Andhra Pradesh',
'I.Polavaram,Amalapuram,Andhra Pradesh',
'Kesanakurrupalem,Amalapuram,Andhra Pradesh',
'Gurrumpalem,Kakinada,Andhra Pradesh',
'Irripaka,Kakinada,Andhra Pradesh',
'J Burugupudi,Kakinada,Andhra Pradesh',
'Jaggampeta,Kakinada,Andhra Pradesh',
'Koturu,Kakinada,Andhra Pradesh',
'Mallepalli,Kakinada,Andhra Pradesh',
'Mallisala,Kakinada,Andhra Pradesh',
'Narendrapatnam,Kakinada,Andhra Pradesh',
'Rajapudi,Kakinada,Andhra Pradesh',
'Ramavaram,Kakinada,Andhra Pradesh',
'Somavaram,Kakinada,Andhra Pradesh',
'Talluru,Kakinada,Andhra Pradesh',
'Yerravaram,Kakinada,Andhra Pradesh',
'Z Ragampeta,Kakinada,Andhra Pradesh',
'Burilanka,Rajahmundry,Andhra Pradesh',
'Dulla,Rajahmundry,Andhra Pradesh',
'Jegurupadu,Rajahmundry,Andhra Pradesh',
'Kadiyam,Rajahmundry,Andhra Pradesh',
'Kadiyapulanka,Rajahmundry,Andhra Pradesh',
'Madhavarayudupalem,Rajahmundry,Andhra Pradesh',
'Muramanda,Rajahmundry,Andhra Pradesh',
'Pottilanka,Rajahmundry,Andhra Pradesh',
'Veeravaram,Rajahmundry,Andhra Pradesh',
'Vemagiri,Rajahmundry,Andhra Pradesh',
'Dugguduru,Rajahmundry,Andhra Pradesh',
'Gollapalem,Kakinada,Andhra Pradesh',
'Ithapudi,Rajahmundry,Andhra Pradesh',
'Jagannadhagiri,Rajahmundry,Andhra Pradesh',
'Kajuluru,Rajahmundry,Andhra Pradesh',
'Kuyyeru,Rajahmundry,Andhra Pradesh',
'Penumalla,Rajahmundry,Andhra Pradesh',
'Apiic,Kakinada,Andhra Pradesh',
'Apsp Camp Office,Kakinada,Andhra Pradesh',
'Aryavatam,Kakinada,Andhra Pradesh',
'Atchampeta,Kakinada,Andhra Pradesh',
'Atchutapuratriam,Kakinada,Andhra Pradesh',
'Bandanapudi,Kakinada,Andhra Pradesh',
'Bhaskarnagar,Kakinada,Andhra Pradesh',
'Chollangipeta,Kakinada,Andhra Pradesh',
'Church Square,Kakinada,Andhra Pradesh',
'Engg.College,Kakinada,Andhra Pradesh',
'Gandhinagar,Kakinada,Andhra Pradesh',
'Ganganapalli,Kakinada,Andhra Pradesh',
'Gorripudi,Kakinada,Andhra Pradesh',
'Govt.Gen Hospital,Kakinada,Andhra Pradesh',
'Indrapalem,Kakinada,Andhra Pradesh',
'Jagannaickpur,Kakinada,Andhra Pradesh',
'Kakinada Bazar,Kakinada,Andhra Pradesh',
'Kakinada H.O,Kakinada,Andhra Pradesh',
'KD-collectorate,Kakinada,Andhra Pradesh',
'Kothuru,Kakinada,Andhra Pradesh',
'Kovvuru,Kakinada,Andhra Pradesh',
'M S N Charties,Kakinada,Andhra Pradesh',
'Madhavapatnam,Kakinada,Andhra Pradesh',
'Manjeru,Kakinada,Andhra Pradesh',
'Mehernagar,Kakinada,Andhra Pradesh',
'Nemam,Kakinada,Andhra Pradesh',
'Panasapadu,Kakinada,Andhra Pradesh',
'Panduru,Kakinada,Andhra Pradesh',
'Patavala,Kakinada,Andhra Pradesh',
'Peddapurappadu,Kakinada,Andhra Pradesh',
'Ramanayyapeta,Kakinada,Andhra Pradesh',
'Ramaraopet,Kakinada,Andhra Pradesh',
'Samalkot H.O,Kakinada,Andhra Pradesh',
'Sarpavaram,Kakinada,Andhra Pradesh',
'Seela,Kakinada,Andhra Pradesh',
'Selapaka,Kakinada,Andhra Pradesh',
'Sriramnagar,Kakinada,Andhra Pradesh',
'Suryaraopeta,Kakinada,Andhra Pradesh',
'Tarlampudi,Kakinada,Andhra Pradesh',
'Thammavaram,Kakinada,Andhra Pradesh',
'Thimmaparam,Kakinada,Andhra Pradesh',
'Turangi,Kakinada,Andhra Pradesh',
'Valasapakala,Kakinada,Andhra Pradesh',
'Vijayaraidu Palem,Kakinada,Andhra Pradesh',
'Yandamuru,Kakinada,Andhra Pradesh',
'Angara,Rajahmundry,Andhra Pradesh',
'Atchutapuram,Rajahmundry,Andhra Pradesh',
'Kapileswarapuram,Rajahmundry,Andhra Pradesh',
'Korumilli,Rajahmundry,Andhra Pradesh',
'Machara,Rajahmundry,Andhra Pradesh',
'Nalluru,Rajahmundry,Andhra Pradesh',
'Nelaturu,Rajahmundry,Andhra Pradesh',
'Tatapudi,Rajahmundry,Andhra Pradesh',
'Teki,Rajahmundry,Andhra Pradesh',
'Vakatippa,Rajahmundry,Andhra Pradesh',
'Valluru,Rajahmundry,Andhra Pradesh',
'Vedurumudi,Rajahmundry,Andhra Pradesh',
'Aratlakatta,Kakinada,Andhra Pradesh',
'Gurazanapalli,Kakinada,Andhra Pradesh',
'Kandregula,Kakinada,Andhra Pradesh',
'Karapa,Kakinada,Andhra Pradesh',
'Kurada,Kakinada,Andhra Pradesh',
'Nadakuduru,Kakinada,Andhra Pradesh',
'Penuguduru,Kakinada,Andhra Pradesh',
'Sahapuram,Kakinada,Andhra Pradesh',
'Siripuram,Kakinada,Andhra Pradesh',
'Vakada,Kakinada,Andhra Pradesh',
'Velangi,Kakinada,Andhra Pradesh',
'Vemulavada,Kakinada,Andhra Pradesh',
'Z.Bhavaram,Kakinada,Andhra Pradesh',
'Balusutippa,Amalapuram,Andhra Pradesh',
'Battucheruvu,Amalapuram,Andhra Pradesh',
'Bojjavaripeta,Amalapuram,Andhra Pradesh',
'Dontikurru,Amalapuram,Andhra Pradesh',
'Geddanapalli,Amalapuram,Andhra Pradesh',
'Kandikuppa,Amalapuram,Andhra Pradesh',
'Koppigunta,Amalapuram,Andhra Pradesh',
'Mokkalitippa,Amalapuram,Andhra Pradesh',
'Nadavapalli,Amalapuram,Andhra Pradesh',
'Pallam,Amalapuram,Andhra Pradesh',
'Pallamkurru,Amalapuram,Andhra Pradesh',
'Penumalla,Amalapuram,Andhra Pradesh',
'Uppudi,Amalapuram,Andhra Pradesh',
'Cheyyuru,Amalapuram,Andhra Pradesh',
'Katrenikona,Amalapuram,Andhra Pradesh',
'B Kothuru,Kakinada,Andhra Pradesh',
'Chillangi,Kakinada,Andhra Pradesh',
'Geddanapalli,Kakinada,Andhra Pradesh',
'Jagapathinagaram,Kakinada,Andhra Pradesh',
'Kirlampudi,Kakinada,Andhra Pradesh',
'Mukkullu,Kakinada,Andhra Pradesh',
'Peddanapalli,Kakinada,Andhra Pradesh',
'Rajupalem,Kakinada,Andhra Pradesh',
'S Thimmapuram,Kakinada,Andhra Pradesh',
'Veeravaram,Kakinada,Andhra Pradesh',
'Bolledupalem,Rajahmundry,Andhra Pradesh',
'Burugupudi,Rajahmundry,Andhra Pradesh',
'Butchampeta,Rajahmundry,Andhra Pradesh',
'Dosakayapalli,Rajahmundry,Andhra Pradesh',
'Gadala,Rajahmundry,Andhra Pradesh',
'Gadarada,Rajahmundry,Andhra Pradesh',
'Itikayalapalli,Rajahmundry,Andhra Pradesh',
'Jambupatnam,Rajahmundry,Andhra Pradesh',
'Kanupura,Rajahmundry,Andhra Pradesh',
'Korukonda,Rajahmundry,Andhra Pradesh',
'Koti,Rajahmundry,Andhra Pradesh',
'Kotikesavaram,Rajahmundry,Andhra Pradesh',
'Kunavaram,Rajahmundry,Andhra Pradesh',
'Madhurapudi,Rajahmundry,Andhra Pradesh',
'Munagala,Rajahmundry,Andhra Pradesh',
'Narasimhapuram,Rajahmundry,Andhra Pradesh',
'Nidigatla,Rajahmundry,Andhra Pradesh',
'Raghavapuram,Rajahmundry,Andhra Pradesh',
'Srirangapatnam,Rajahmundry,Andhra Pradesh',
'Allipudi,Kakinada,Andhra Pradesh',
'Bhimavarapukota,Kakinada,Andhra Pradesh',
'Billananduru,Kakinada,Andhra Pradesh',
'Indugupalli,Kakinada,Andhra Pradesh',
'K E Chinnayyapalem,Kakinada,Andhra Pradesh',
'Kamatam Mallavaram,Kakinada,Andhra Pradesh',
'Kotananduru,Kakinada,Andhra Pradesh',
'Kothakottam,Kakinada,Andhra Pradesh',
'Rajavaram,Kakinada,Andhra Pradesh',
'Surapurajupegta,Kakinada,Andhra Pradesh',
'Amaravalli,Kakinada,Andhra Pradesh',
'Kothapalli (U),Kakinada,Andhra Pradesh',
'Mulapeta,Kakinada,Andhra Pradesh',
'Nagulapalli,Kakinada,Andhra Pradesh',
'Ponnada,Kakinada,Andhra Pradesh',
'Ramanakkapeta,Kakinada,Andhra Pradesh',
'Uppada,Kakinada,Andhra Pradesh',
'Yenapalli,Kakinada,Andhra Pradesh',
'Billakurru,Amalapuram,Andhra Pradesh',
'Ganti,Amalapuram,Andhra Pradesh',
'Vanapalli,Amalapuram,Andhra Pradesh',
'Avidi,Amalapuram,Andhra Pradesh',
'Chirata Pudi,Amalapuram,Andhra Pradesh',
'Devarapalli,Amalapuram,Andhra Pradesh',
'Devarapalli,Amalapuram,Andhra Pradesh',
'Kedarlanka,Amalapuram,Andhra Pradesh',
'Kothapeta,Amalapuram,Andhra Pradesh',
'Modekurru,Amalapuram,Andhra Pradesh',
'Narendrapuram,Amalapuram,Andhra Pradesh',
'Palivela,Amalapuram,Andhra Pradesh',
'Vadapalem,Amalapuram,Andhra Pradesh',
'Yenugulamahal,Amalapuram,Andhra Pradesh',
'Eastpalem,Amalapuram,Andhra Pradesh',
'Gudapalli,Amalapuram,Andhra Pradesh',
'Gudimellanka,Amalapuram,Andhra Pradesh',
'Irusumanda,Amalapuram,Andhra Pradesh',
'Kantevaripadu,Amalapuram,Andhra Pradesh',
'Kathimanda,Amalapuram,Andhra Pradesh',
'Kesanapalli,Amalapuram,Andhra Pradesh',
'Mattaparru,Amalapuram,Andhra Pradesh',
'Medicherlapalem,Amalapuram,Andhra Pradesh',
'Ramarajulanka,Amalapuram,Andhra Pradesh',
'Sankaraguptam,Amalapuram,Andhra Pradesh',
'Visweswarayapuram,Amalapuram,Andhra Pradesh',
'Lakkavaram,Amalapuram,Andhra Pradesh',
'Malikipuram,Amalapuram,Andhra Pradesh',
'Adurru,Amalapuram,Andhra Pradesh',
'B.Doddavaram,Amalapuram,Andhra Pradesh',
'Badava,Amalapuram,Andhra Pradesh',
'Gogannamatham,Amalapuram,Andhra Pradesh',
'Idarada,Amalapuram,Andhra Pradesh',
'Lutukurru,Amalapuram,Andhra Pradesh',
'Magatapalli,Amalapuram,Andhra Pradesh',
'Mamidikuduru,Amalapuram,Andhra Pradesh',
'Mogalikuduru,Amalapuram,Andhra Pradesh',
'Pasarlapudi,Amalapuram,Andhra Pradesh',
'Pasarlapudilanka,Amalapuram,Andhra Pradesh',
'Pedapatnam,Amalapuram,Andhra Pradesh',
'Pedapatnam Lanka,Amalapuram,Andhra Pradesh',
'Nagaram,Amalapuram,Andhra Pradesh',
'Arthamuru,Rajahmundry,Andhra Pradesh',
'Dwarapudi,Rajahmundry,Andhra Pradesh',
'Ippanapadu,Rajahmundry,Andhra Pradesh',
'Kesavaram,Rajahmundry,Andhra Pradesh',
'Mandapeta Bazar,Rajahmundry,Andhra Pradesh',
'Mandapeta H.O,Rajahmundry,Andhra Pradesh',
'Maredubaka,Rajahmundry,Andhra Pradesh',
'Palathodu,Rajahmundry,Andhra Pradesh',
'Seethanagaram,Rajahmundry,Andhra Pradesh',
'Tapeswaram,Rajahmundry,Andhra Pradesh',
'Velagathodu,Rajahmundry,Andhra Pradesh',
'Yeditha,Rajahmundry,Andhra Pradesh',
'Z.Medapadu,Rajahmundry,Andhra Pradesh',
'Chatlawada,Rajahmundry,Andhra Pradesh',
'Chavadikota,Rajahmundry,Andhra Pradesh',
'D.Vemulakota,Rajahmundry,Andhra Pradesh',
'Dorachintalapalem,Rajahmundry,Andhra Pradesh',
'Gujjumamidivalasa,Rajahmundry,Andhra Pradesh',
'Kundada,Rajahmundry,Andhra Pradesh',
'Kutrawada,Rajahmundry,Andhra Pradesh',
'Maredumilli,Rajahmundry,Andhra Pradesh',
'Pullangi,Rajahmundry,Andhra Pradesh',
'Sunnampadu,Rajahmundry,Andhra Pradesh',
'Tadepalle,Rajahmundry,Andhra Pradesh',
'Vetukuru,Rajahmundry,Andhra Pradesh',
'Ainapuram,Amalapuram,Andhra Pradesh',
'Annampalli,Amalapuram,Andhra Pradesh',
'Chinakothalanka,Amalapuram,Andhra Pradesh',
'Gadilanka,Amalapuram,Andhra Pradesh',
'Gedillanka,Amalapuram,Andhra Pradesh',
'Kamini,Amalapuram,Andhra Pradesh',
'Komanapalli,Amalapuram,Andhra Pradesh',
'Kothalanka,Amalapuram,Andhra Pradesh',
'Krapa Chintalapudi,Amalapuram,Andhra Pradesh',
'Somidevarapalem,Amalapuram,Andhra Pradesh',
'Thanelanka,Amalapuram,Andhra Pradesh',
'Gunnepalli,Amalapuram,Andhra Pradesh',
'Mummidivaram,Amalapuram,Andhra Pradesh',
'G.Pedapudi,Amalapuram,Andhra Pradesh',
'L.Gannavaram,Amalapuram,Andhra Pradesh',
'Mondepulanka,Amalapuram,Andhra Pradesh',
'Munganda,Amalapuram,Andhra Pradesh',
'Nagullanka,Amalapuram,Andhra Pradesh',
'Vadrevupalli,Amalapuram,Andhra Pradesh',
'Vudimudi,Amalapuram,Andhra Pradesh',
'Yenugupalli,Amalapuram,Andhra Pradesh',
'Munjavarapukottu,Amalapuram,Andhra Pradesh',
'Pothavaram,Amalapuram,Andhra Pradesh',
'Addampalli,Rajahmundry,Andhra Pradesh',
'Amjuru,Rajahmundry,Andhra Pradesh',
'Balantram,Rajahmundry,Andhra Pradesh',
'Dangeru,Rajahmundry,Andhra Pradesh',
'Gangavaram,Rajahmundry,Andhra Pradesh',
'Kota,Rajahmundry,Andhra Pradesh',
'Kotipalli,Rajahmundry,Andhra Pradesh',
'Kudupuru,Rajahmundry,Andhra Pradesh',
'Kulla,Rajahmundry,Andhra Pradesh',
'Kunduru,Rajahmundry,Andhra Pradesh',
'Masakapalli,Rajahmundry,Andhra Pradesh',
'Pamarru,Rajahmundry,Andhra Pradesh',
'Panangipalli,Rajahmundry,Andhra Pradesh',
'Pekeru,Rajahmundry,Andhra Pradesh',
'Satyavada,Rajahmundry,Andhra Pradesh',
'Sivala,Rajahmundry,Andhra Pradesh',
'Sundarapalli,Rajahmundry,Andhra Pradesh',
'Tamarapalli,Rajahmundry,Andhra Pradesh',
'Yandagandi,Rajahmundry,Andhra Pradesh',
'Bhatlapalika,Rajahmundry,Andhra Pradesh',
'Chintaplli,Kakinada,Andhra Pradesh',
'G.Mamidada,Kakinada,Andhra Pradesh',
'Gandredu,Kakinada,Andhra Pradesh',
'Kaikavolu,Kakinada,Andhra Pradesh',
'Karakuduru,Kakinada,Andhra Pradesh',
'Kumarapriyam,Kakinada,Andhra Pradesh',
'Pedapudi,Kakinada,Andhra Pradesh',
'Peddada,Kakinada,Andhra Pradesh',
'Pyna,Kakinada,Andhra Pradesh',
'Rajupalem,Kakinada,Andhra Pradesh',
'Repuru,Kakinada,Andhra Pradesh',
'Sampara,Kakinada,Andhra Pradesh',
'Vendra,Kakinada,Andhra Pradesh',
'Anuru,Kakinada,Andhra Pradesh',
'G Ragampeta,Kakinada,Andhra Pradesh',
'Goneda,Kakinada,Andhra Pradesh',
'Gudivada,Kakinada,Andhra Pradesh',
'Kandrakota,Kakinada,Andhra Pradesh',
'Katravulapalli,Kakinada,Andhra Pradesh',
'Kattamuru,Kakinada,Andhra Pradesh',
'Marlova,Kakinada,Andhra Pradesh',
'Marripudi,Kakinada,Andhra Pradesh',
'Nayakampalli,Kakinada,Andhra Pradesh',
'Peddapuram,Kakinada,Andhra Pradesh',
'Peddapuram Town,Kakinada,Andhra Pradesh',
'Rayabhupalapatnam,Kakinada,Andhra Pradesh',
'Surampalem,Kakinada,Andhra Pradesh',
'Tamarada,Kakinada,Andhra Pradesh',
'Vadlamuru,Kakinada,Andhra Pradesh',
'Chadalada,Kakinada,Andhra Pradesh',
'Chandanampalem,Kakinada,Andhra Pradesh',
'Chitrada,Kakinada,Andhra Pradesh',
'Divili,Kakinada,Andhra Pradesh',
'F K Palem,Kakinada,Andhra Pradesh',
'Gokivada,Kakinada,Andhra Pradesh',
'Gorinta,Kakinada,Andhra Pradesh',
'Gorsa,Kakinada,Andhra Pradesh',
'Isukapalli,Kakinada,Andhra Pradesh',
'Jalluru,Kakinada,Andhra Pradesh',
'Kolanka,Kakinada,Andhra Pradesh',
'Komarigiiri,Kakinada,Andhra Pradesh',
'Kondevaram,Kakinada,Andhra Pradesh',
'Kothapeta (PTP),Kakinada,Andhra Pradesh',
'Lakshminarasapuram,Kakinada,Andhra Pradesh',
'Mallam,Kakinada,Andhra Pradesh',
'Pavara,Kakinada,Andhra Pradesh',
'Pithapuram,Kakinada,Andhra Pradesh',
'Pithapuram Town,Kakinada,Andhra Pradesh',
'Pulimeru,Kakinada,Andhra Pradesh',
'Viravada,Kakinada,Andhra Pradesh',
'Virava,Kakinada,Andhra Pradesh',
'G.Moolapalem,Kakinada,Andhra Pradesh',
'Georgepeta,Kakinada,Andhra Pradesh',
'Guthenadeevi,Kakinada,Andhra Pradesh',
'Chinasankaralapudi,Kakinada,Andhra Pradesh',
'Dharamavaram,Kakinada,Andhra Pradesh',
'Lampakalova,Kakinada,Andhra Pradesh',
'Pedasankarlapudi,Kakinada,Andhra Pradesh',
'Pothuluru,Kakinada,Andhra Pradesh',
'Prathipadu,Kakinada,Andhra Pradesh',
'Rachapalli,Kakinada,Andhra Pradesh',
'Sarabahvaram,Kakinada,Andhra Pradesh',
'Siripuram,Kakinada,Andhra Pradesh',
'Uttarakanchi,Kakinada,Andhra Pradesh',
'Vommangi,Kakinada,Andhra Pradesh',
'Yelluru,Kakinada,Andhra Pradesh',
'Ilakolanu,Rajahmundry,Andhra Pradesh',
'Pidimgoyya,Rajahmundry,Andhra Pradesh',
'Alcot Gardens,Rajahmundry,Andhra Pradesh',
'APHB Colony,Rajahmundry,Andhra Pradesh',
'Aryapuram,Rajahmundry,Andhra Pradesh',
'Danavaipeta,Rajahmundry,Andhra Pradesh',
'Fort Gate,Rajahmundry,Andhra Pradesh',
'Gandhipuram,Rajahmundry,Andhra Pradesh',
'Government College,Rajahmundry,Andhra Pradesh',
'Prakashnagar,Rajahmundry,Andhra Pradesh',
'Rajahmundry H.O,Rajahmundry,Andhra Pradesh',
'Rtc Bus Complex Centre,Rajahmundry,Andhra Pradesh',
'Sarangadarametta,Rajahmundry,Andhra Pradesh',
'Spinning Mills Center,Rajahmundry,Andhra Pradesh',
'Sriramnagar,Rajahmundry,Andhra Pradesh',
'Stadium Road,Rajahmundry,Andhra Pradesh',
'Syamalamba Temple,Rajahmundry,Andhra Pradesh',
'Syamalanagar,Rajahmundry,Andhra Pradesh',
'Trunk Road Junction,Rajahmundry,Andhra Pradesh',
'Vullithota,Rajahmundry,Andhra Pradesh',
'Weavers Colony,Rajahmundry,Andhra Pradesh',
'Bommuru,Rajahmundry,Andhra Pradesh',
'Dowlaiswaram,Rajahmundry,Andhra Pradesh',
'Hukumpeta,Rajahmundry,Andhra Pradesh',
'Industrial Estate,Rajahmundry,Andhra Pradesh',
'Kateru,Rajahmundry,Andhra Pradesh',
'Kolamuru,Rajahmundry,Andhra Pradesh',
'Punyakshetram,Rajahmundry,Andhra Pradesh',
'Rajavolu,Rajahmundry,Andhra Pradesh',
'Ramadasupeta,Rajahmundry,Andhra Pradesh',
'Torredu,Rajahmundry,Andhra Pradesh',
'Visranthipuram,Rajahmundry,Andhra Pradesh',
'Chakradwarabandam,Rajahmundry,Andhra Pradesh',
'Dewancheruvu,Rajahmundry,Andhra Pradesh',
'East Gonagudem,Rajahmundry,Andhra Pradesh',
'Kalavacherala,Rajahmundry,Andhra Pradesh',
'Kanavaram,Rajahmundry,Andhra Pradesh',
'Kondagunturu,Rajahmundry,Andhra Pradesh',
'Mukkinada,Rajahmundry,Andhra Pradesh',
'Nandarada,Rajahmundry,Andhra Pradesh',
'Narendrapuram,Rajahmundry,Andhra Pradesh',
'Palacherla,Rajahmundry,Andhra Pradesh',
'Pallakadiyam,Rajahmundry,Andhra Pradesh',
'Pathatungapadu,Rajahmundry,Andhra Pradesh',
'Rajanagaram,Rajahmundry,Andhra Pradesh',
'Ramaswamipeta,Rajahmundry,Andhra Pradesh',
'Srikrishnapatnam,Rajahmundry,Andhra Pradesh',
'Srirampuram,Rajahmundry,Andhra Pradesh',
'Tokada,Rajahmundry,Andhra Pradesh',
'Velugubanda,Rajahmundry,Andhra Pradesh',
'Amminibada,Kakinada,Andhra Pradesh',
'Ammirekula,Kakinada,Andhra Pradesh',
'Ananthagiri,Kakinada,Andhra Pradesh',
'Badadanampalli,Kakinada,Andhra Pradesh',
'Chikilintha,Kakinada,Andhra Pradesh',
'Doddigunta,Kakinada,Andhra Pradesh',
'Donelapalem,Kakinada,Andhra Pradesh',
'Gaduvokurthi,Kakinada,Andhra Pradesh',
'Jaddangi,Kakinada,Andhra Pradesh',
'Kandra,Kakinada,Andhra Pradesh',
'Kirrabu,Kakinada,Andhra Pradesh',
'Kondapalli,Kakinada,Andhra Pradesh',
'Labbarthi,Kakinada,Andhra Pradesh',
'Lagarai,Kakinada,Andhra Pradesh',
'Lododdi,Kakinada,Andhra Pradesh',
'Mukundavaram,Kakinada,Andhra Pradesh',
'Pedarayavaram,Kakinada,Andhra Pradesh',
'Rajavommangi,Kakinada,Andhra Pradesh',
'Sarabhavaram,Kakinada,Andhra Pradesh',
'Subhadrampeta,Kakinada,Andhra Pradesh',
'Thantikonda,Kakinada,Andhra Pradesh',
'Urlakulapadu,Kakinada,Andhra Pradesh',
'Vathangi,Kakinada,Andhra Pradesh',
'Vottigadda,Kakinada,Andhra Pradesh',
'Chodavaram,Rajahmundry,Andhra Pradesh',
'Draksharamam,Rajahmundry,Andhra Pradesh',
'Hasanbada,Rajahmundry,Andhra Pradesh',
'Jagannaiyakulapalem,Rajahmundry,Andhra Pradesh',
'Kothuru,Rajahmundry,Andhra Pradesh',
'Muchimilli,Rajahmundry,Andhra Pradesh',
'Narasapurapupeta,Rajahmundry,Andhra Pradesh',
'Nelaparthipadu,Rajahmundry,Andhra Pradesh',
'Pasalapudi,Rajahmundry,Andhra Pradesh',
'Peketipakalu,Rajahmundry,Andhra Pradesh',
'Peraramachandrapuram,Rajahmundry,Andhra Pradesh',
'Ramachandrapuram H.O,Rajahmundry,Andhra Pradesh',
'Ramachandrapuram Old Town,Rajahmundry,Andhra Pradesh',
'Ratnampeta,Rajahmundry,Andhra Pradesh',
'Tallapolam,Rajahmundry,Andhra Pradesh',
'Vedurupakasavaram,Rajahmundry,Andhra Pradesh',
'Vegayampeta,Rajahmundry,Andhra Pradesh',
'Velampalem,Rajahmundry,Andhra Pradesh',
'Vella,Rajahmundry,Andhra Pradesh',
'Venkatayapalem,Rajahmundry,Andhra Pradesh',
'Yanamadala,Kakinada,Andhra Pradesh',
'Akuru,Rajahmundry,Andhra Pradesh',
'B.Vemulakota,Rajahmundry,Andhra Pradesh',
'Bandapalli,Rajahmundry,Andhra Pradesh',
'Beerampalli,Rajahmundry,Andhra Pradesh',
'Bolagonda,Rajahmundry,Andhra Pradesh',
'Busigudem,Rajahmundry,Andhra Pradesh',
'Foulspeta,Rajahmundry,Andhra Pradesh',
'Geddada,Rajahmundry,Andhra Pradesh',
'Ginnepalli,Rajahmundry,Andhra Pradesh',
'I.Polavaram,Rajahmundry,Andhra Pradesh',
'Madicherla,Rajahmundry,Andhra Pradesh',
'Marriwada,Rajahmundry,Andhra Pradesh',
'Musurumilli,Rajahmundry,Andhra Pradesh',
'Narasapuram,Rajahmundry,Andhra Pradesh',
'Rampa,Rajahmundry,Andhra Pradesh',
'Rampachodavaram,Rajahmundry,Andhra Pradesh',
'Seethapalli,Rajahmundry,Andhra Pradesh',
'Tamarapalli,Rajahmundry,Andhra Pradesh',
'Tatiwada,Rajahmundry,Andhra Pradesh',
'Utla,Rajahmundry,Andhra Pradesh',
'Vadapalli,Rajahmundry,Andhra Pradesh',
'Vemulukonda,Rajahmundry,Andhra Pradesh',
'G.Donthamuru,Rajahmundry,Andhra Pradesh',
'Rangampeta,Kakinada,Andhra Pradesh',
'Vadisaleru,Rajahmundry,Andhra Pradesh',
'Veerampalem,Rajahmundry,Andhra Pradesh',
'Ithakota,Amalapuram,Andhra Pradesh',
'Ketharajuupalli,Amalapuram,Andhra Pradesh',
'Komarajulanka,Amalapuram,Andhra Pradesh',
'Laxmi Polavaram,Amalapuram,Andhra Pradesh',
'Mummidivarappadu,Amalapuram,Andhra Pradesh',
'North Gopalapuram,Amalapuram,Andhra Pradesh',
'Podagatapalli,Amalapuram,Andhra Pradesh',
'Ravulapadu,Amalapuram,Andhra Pradesh',
'Vedureswaram,Amalapuram,Andhra Pradesh',
'Gopalapuram,Amalapuram,Andhra Pradesh',
'Ravulapalem,Amalapuram,Andhra Pradesh',
'Chelluru,Rajahmundry,Andhra Pradesh',
'Kurmapuram,Rajahmundry,Andhra Pradesh',
'Matsavaram,Rajahmundry,Andhra Pradesh',
'Rayavaram,Rajahmundry,Andhra Pradesh',
'Someswaram,Rajahmundry,Andhra Pradesh',
'Vedurupaka,Rajahmundry,Andhra Pradesh',
'Venturu,Rajahmundry,Andhra Pradesh',
'Appanapalli,Amalapuram,Andhra Pradesh',
'Aravapalem,Amalapuram,Andhra Pradesh',
'Chintalapalli,Amalapuram,Andhra Pradesh',
'Jaggannapeta,Amalapuram,Andhra Pradesh',
'Kadali,Amalapuram,Andhra Pradesh',
'Karavaka,Amalapuram,Andhra Pradesh',
'Katrenipadu,Amalapuram,Andhra Pradesh',
'Kunavaram,Amalapuram,Andhra Pradesh',
'Manepalli,Amalapuram,Andhra Pradesh',
'Mulikipalli,Amalapuram,Andhra Pradesh',
'Palagummi,Amalapuram,Andhra Pradesh',
'Podalada,Amalapuram,Andhra Pradesh',
'Razole H.O,Amalapuram,Andhra Pradesh',
'Tatipaka Bazar,Amalapuram,Andhra Pradesh',
'Vegivaripalem,Amalapuram,Andhra Pradesh',
'Appanaramunilanka,Amalapuram,Andhra Pradesh',
'Ponnamanda,Amalapuram,Andhra Pradesh',
'Sivakodu,Amalapuram,Andhra Pradesh',
'Tatipaka,Amalapuram,Andhra Pradesh',
'Antarvedi Devastanam,Amalapuram,Andhra Pradesh',
'Chintalamori,Amalapuram,Andhra Pradesh',
'Gondi,Amalapuram,Andhra Pradesh',
'Gudimula,Amalapuram,Andhra Pradesh',
'Padamatipalem,Amalapuram,Andhra Pradesh',
'Rameswaram,Amalapuram,Andhra Pradesh',
'Sakhinetipalli Lanka,Amalapuram,Andhra Pradesh',
'Sakhinetipallipalem,Amalapuram,Andhra Pradesh',
'Srirampuram,Amalapuram,Andhra Pradesh',
'Srungavarappadu,Amalapuram,Andhra Pradesh',
'Addalapalem,Amalapuram,Andhra Pradesh',
'Antarvedi,Amalapuram,Andhra Pradesh',
'Antarvedipalem,Amalapuram,Andhra Pradesh',
'Kesavadasupalem,Amalapuram,Andhra Pradesh',
'Mori,Amalapuram,Andhra Pradesh',
'Rambagh,Amalapuram,Andhra Pradesh',
'Sakhinetipalli,Amalapuram,Andhra Pradesh',
'Hussain Puram,Kakinada,Andhra Pradesh',
'Medapadu,Kakinada,Andhra Pradesh',
'P Vemavaram,Kakinada,Andhra Pradesh',
'Pedabrahmadevam,Kakinada,Andhra Pradesh',
'Samalkot Agricultural Form,Kakinada,Andhra Pradesh',
'Samalkot Pen Lines,Kakinada,Andhra Pradesh',
'Samalkot R S,Kakinada,Andhra Pradesh',
'Satyanarayanapuram,Kakinada,Andhra Pradesh',
'Unduru,Kakinada,Andhra Pradesh',
'V K Rayapuram,Kakinada,Andhra Pradesh',
'Vetlapalem,Kakinada,Andhra Pradesh',
'Annavaram Devasthanam,Kakinada,Andhra Pradesh',
'Annavaram,Kakinada,Andhra Pradesh',
'Bendapudi,Kakinada,Andhra Pradesh',
'Chintaluru,Kakinada,Andhra Pradesh',
'G Kothapalli,Kakinada,Andhra Pradesh',
'Koduru,Kakinada,Andhra Pradesh',
'Konthangi,Kakinada,Andhra Pradesh',
'Latchreddypalem,Kakinada,Andhra Pradesh',
'Mandapam,Kakinada,Andhra Pradesh',
'Meraka Chamavaram,Kakinada,Andhra Pradesh',
'Mulagapudi,Kakinada,Andhra Pradesh',
'N Naredrapatnam,Kakinada,Andhra Pradesh',
'Nellipudi,Kakinada,Andhra Pradesh',
'P T Chinnayyapalem,Kakinada,Andhra Pradesh',
'Pedamallapuram,Kakinada,Andhra Pradesh',
'Ravikampadu,Kakinada,Andhra Pradesh',
'Routhulapudi,Kakinada,Andhra Pradesh',
'Sankhavaram,Kakinada,Andhra Pradesh',
'Santhapaidipalem,Kakinada,Andhra Pradesh',
'Santhiashram,Kakinada,Andhra Pradesh',
'Srungadhara Agraharam,Kakinada,Andhra Pradesh',
'Teragunta,Kakinada,Andhra Pradesh',
'Thimmapuram,Kakinada,Andhra Pradesh',
'Chinakondepudi,Rajahmundry,Andhra Pradesh',
'Mirthipadu,Rajahmundry,Andhra Pradesh',
'Muggulla,Rajahmundry,Andhra Pradesh',
'Mulakallanka,Rajahmundry,Andhra Pradesh',
'Munikodali,Rajahmundry,Andhra Pradesh',
'Purushotapatnam,Rajahmundry,Andhra Pradesh',
'Raghudevapuram,Rajahmundry,Andhra Pradesh',
'Ramachandrapuram,Rajahmundry,Andhra Pradesh',
'Sithanagaram,Rajahmundry,Andhra Pradesh',
'Vangalapudi,Rajahmundry,Andhra Pradesh',
'Venkatanagram,Rajahmundry,Andhra Pradesh',
'Katavaram,Rajahmundry,Andhra Pradesh',
'Coringa,Kakinada,Andhra Pradesh',
'Gadimoga,Kakinada,Andhra Pradesh',
'Injaram,Kakinada,Andhra Pradesh',
'Kapulapalem,Kakinada,Andhra Pradesh',
'Kesavapuram,Kakinada,Andhra Pradesh',
'Kolanka,Kakinada,Andhra Pradesh',
'Neelapalli,Kakinada,Andhra Pradesh',
'P.Mallavaram,Kakinada,Andhra Pradesh',
'Pallipalem,Kakinada,Andhra Pradesh',
'Pathigondi,Kakinada,Andhra Pradesh',
'Pilanka,Kakinada,Andhra Pradesh',
'Silalanka,Kakinada,Andhra Pradesh',
'Tallarevu,Kakinada,Andhra Pradesh',
'Uppangala,Kakinada,Andhra Pradesh',
'Yedurulanka,Kakinada,Andhra Pradesh',
'A Kothapalli,Kakinada,Andhra Pradesh',
'Kodada,Kakinada,Andhra Pradesh',
'Krishnapuram,Kakinada,Andhra Pradesh',
'Srungavruksham,Kakinada,Andhra Pradesh',
'Thondangi,Kakinada,Andhra Pradesh',
'Vontimamidi,Kakinada,Andhra Pradesh',
'Addaripeta,Kakinada,Andhra Pradesh',
'Ammajipeta,Kakinada,Andhra Pradesh',
'Boddavaram,Kakinada,Andhra Pradesh',
'Chamavaram,Kakinada,Andhra Pradesh',
'D Polavaram,Kakinada,Andhra Pradesh',
'Hamsavarm,Kakinada,Andhra Pradesh',
'K Mallavaram,Kakinada,Andhra Pradesh',
'Nadigatla Vari Savara,Kakinada,Andhra Pradesh',
'Nandivompu,Kakinada,Andhra Pradesh',
'Paltheru,Kakinada,Andhra Pradesh',
'Pydi Konda,Kakinada,Andhra Pradesh',
'Rekhavanipalem,Kakinada,Andhra Pradesh',
'S Annavaram,Kakinada,Andhra Pradesh',
'Talluru,Kakinada,Andhra Pradesh',
'Tuni Old Bazar,Kakinada,Andhra Pradesh',
'Tuni,Kakinada,Andhra Pradesh',
'Velamakothuru,Kakinada,Andhra Pradesh',
'Vemavaram,Kakinada,Andhra Pradesh',
'Gollavilli,Amalapuram,Andhra Pradesh',
'Bheemanapalli,Amalapuram,Andhra Pradesh',
'Challapalli,Amalapuram,Andhra Pradesh',
'Gopavaram,Amalapuram,Andhra Pradesh',
'Kunavaram,Amalapuram,Andhra Pradesh',
'Pedagadavilli,Amalapuram,Andhra Pradesh',
'Sannavilli,Amalapuram,Andhra Pradesh',
'Saripalli,Amalapuram,Andhra Pradesh',
'Surasani Yanam,Amalapuram,Andhra Pradesh',
'Vilasavilli,Amalapuram,Andhra Pradesh',
'N.Kothapalli,Amalapuram,Andhra Pradesh',
'Uppalaguptam,Amalapuram,Andhra Pradesh',
'Anatavaram,Amalapuram,Andhra Pradesh',
'Chamagadda,Kakinada,Andhra Pradesh',
'Chavitidibbalu,Kakinada,Andhra Pradesh',
'Dakodu,Kakinada,Andhra Pradesh',
'Dalipadu,Kakinada,Andhra Pradesh',
'Durcharthi,Kakinada,Andhra Pradesh',
'Gurthedi,Kakinada,Andhra Pradesh',
'P Yerragonda,Kakinada,Andhra Pradesh',
'Panasalapalem,Kakinada,Andhra Pradesh',
'Pedavadiskarra,Kakinada,Andhra Pradesh',
'Rayapalli,Kakinada,Andhra Pradesh',
'Veeravaram,Kakinada,Andhra Pradesh',
'Y .Ramavaram,Kakinada,Andhra Pradesh',
'Bhadravaram,Kakinada,Andhra Pradesh',
'Gontuvanipalem,Kakinada,Andhra Pradesh',
'J Annavaram,Kakinada,Andhra Pradesh',
'Kimmuru,Kakinada,Andhra Pradesh',
'Lingaparthi,Kakinada,Andhra Pradesh',
'Maredubaka,Kakinada,Andhra Pradesh',
'Peravaram,Kakinada,Andhra Pradesh',
'Puligogulapadu,Kakinada,Andhra Pradesh',
'Ramanayyapeta,Kakinada,Andhra Pradesh',
'Tirumali,Kakinada,Andhra Pradesh',
'Vanchangi,Kakinada,Andhra Pradesh',
'Yeleswaram,Kakinada,Andhra Pradesh',
'China Ravuru Tenali,Tenali,Andhra Pradesh',
'Pedakancherla,Narasaraopet,Andhra Pradesh',
'Pitchikalapalem,Narasaraopet,Andhra Pradesh',
'Venugopalanagar Colony,Guntur,Andhra Pradesh',
'Dharanikota,Guntur,Andhra Pradesh',
'Didugu,Guntur,Andhra Pradesh',
'Harischandrapuram,Guntur,Andhra Pradesh',
'Malladi,Guntur,Andhra Pradesh',
'Muthayapalem,Guntur,Andhra Pradesh',
'Pedamadduru,Guntur,Andhra Pradesh',
'Vykuntapuram,Guntur,Andhra Pradesh',
'Amartaluru,Tenali,Andhra Pradesh',
'Chinagadelavarru,Tenali,Andhra Pradesh',
'Chinaparimi,Tenali,Andhra Pradesh',
'Govada,Tenali,Andhra Pradesh',
'Manduru,Tenali,Andhra Pradesh',
'Mulpuru,Tenali,Andhra Pradesh',
'Panchalavaram,Tenali,Andhra Pradesh',
'Pedapudi,Tenali,Andhra Pradesh',
'Yadavuru,Tenali,Andhra Pradesh',
'Anantavaram,Tenali,Andhra Pradesh',
'Annavaram,Tenali,Andhra Pradesh',
'Annavarapulanka,Tenali,Andhra Pradesh',
'Burripalem,Tenali,Andhra Pradesh',
'Chadalavada,Tenali,Andhra Pradesh',
'Chilumuru,Tenali,Andhra Pradesh',
'Hanumanpalem,Tenali,Andhra Pradesh',
'Ipuru,Tenali,Andhra Pradesh',
'Angalakudur,Tenali,Andhra Pradesh',
'Edlapalli,Tenali,Andhra Pradesh',
'Penugudurupadu,Tenali,Andhra Pradesh',
'Valiveru,Tenali,Andhra Pradesh',
'Appikatla,Tenali,Andhra Pradesh',
'Atchampet,Narasaraopet,Andhra Pradesh',
'Challagariga,Narasaraopet,Andhra Pradesh',
'Chamarru,Narasaraopet,Andhra Pradesh',
'Chintapalle,Narasaraopet,Andhra Pradesh',
'Kogantivaripalem,Narasaraopet,Andhra Pradesh',
'Kothapalle,Narasaraopet,Andhra Pradesh',
'Madipadu,Narasaraopet,Andhra Pradesh',
'Taduvai,Narasaraopet,Andhra Pradesh',
'Tallacheruvu,Narasaraopet,Andhra Pradesh',
'A F Station,Tenali,Andhra Pradesh',
'Bapatla H.O,Tenali,Andhra Pradesh',
'Bhavanamvaripalem,Tenali,Andhra Pradesh',
'Bhoolayapalem,Tenali,Andhra Pradesh',
'Brahmanakoduru,Tenali,Andhra Pradesh',
'Godavarru,Tenali,Andhra Pradesh',
'Gollamudipadu,Tenali,Andhra Pradesh',
'Gopapuram,Tenali,Andhra Pradesh',
'Gudipudiagraharam,Tenali,Andhra Pradesh',
'Gundavaram,Tenali,Andhra Pradesh',
'Iteru,Tenali,Andhra Pradesh',
'Jupudi,Tenali,Andhra Pradesh',
'Khajipalem,Tenali,Andhra Pradesh',
'Koduru-komali,Tenali,Andhra Pradesh',
'Kothapalli-narikellapalli,Tenali,Andhra Pradesh',
'Kothareddypalem,Tenali,Andhra Pradesh',
'Kovelamudi,Tenali,Andhra Pradesh',
'Lemellepadu,Tenali,Andhra Pradesh',
'Lingamguntlapalem,Tenali,Andhra Pradesh',
'Manchala,Tenali,Andhra Pradesh',
'Manthenavaripalem,Tenali,Andhra Pradesh',
'Marripudi,Tenali,Andhra Pradesh',
'Maruproluvaripalem,Tenali,Andhra Pradesh',
'Muthayapalem,Tenali,Andhra Pradesh',
'Mutluru,Tenali,Andhra Pradesh',
'Nandirajuthota,Tenali,Andhra Pradesh',
'Narakoduru,Tenali,Andhra Pradesh',
'Pathareddypalem,Tenali,Andhra Pradesh',
'Peddapalle,Tenali,Andhra Pradesh',
'Pittalavanipalem,Tenali,Andhra Pradesh',
'Poondla,Tenali,Andhra Pradesh',
'Railpeta Bapatla,Tenali,Andhra Pradesh',
'Rangaraothota,Tenali,Andhra Pradesh',
'Sangupalem,Tenali,Andhra Pradesh',
'Siripudi,Tenali,Andhra Pradesh',
'Snpagraharam,Tenali,Andhra Pradesh',
'Srirangapuram,Tenali,Andhra Pradesh',
'Vatticheruku,Tenali,Andhra Pradesh',
'Vellaluru,Tenali,Andhra Pradesh',
'Vetapalem,Tenali,Andhra Pradesh',
'Bellamkonda,Narasaraopet,Andhra Pradesh',
'Bodanam,Narasaraopet,Andhra Pradesh',
'Chandrajupalem,Narasaraopet,Andhra Pradesh',
'Chityala,Narasaraopet,Andhra Pradesh',
'Chityala Thanda,Narasaraopet,Andhra Pradesh',
'Chowtapapayapalem,Narasaraopet,Andhra Pradesh',
'Emmajigudem,Narasaraopet,Andhra Pradesh',
'Hassannabad,Narasaraopet,Andhra Pradesh',
'Kolluru,Narasaraopet,Andhra Pradesh',
'Machayapalem,Narasaraopet,Andhra Pradesh',
'Papayapalem,Narasaraopet,Andhra Pradesh',
'Perikapadu Thanda,Narasaraopet,Andhra Pradesh',
'Vannayapalem,Narasaraopet,Andhra Pradesh',
'Venkatayapalem,Narasaraopet,Andhra Pradesh',
'Amudarlanka,Tenali,Andhra Pradesh',
'Chinapulivarru,Tenali,Andhra Pradesh',
'Kiskindapalem,Tenali,Andhra Pradesh',
'Pedapulivarru,Tenali,Andhra Pradesh',
'Pesarlanka,Tenali,Andhra Pradesh',
'Allamudi,Tenali,Andhra Pradesh',
'Bhattiprolu,Tenali,Andhra Pradesh',
'Konetipuram,Tenali,Andhra Pradesh',
'Pallekona,Tenali,Andhra Pradesh',
'Penumarru,Tenali,Andhra Pradesh',
'Surepalli,Tenali,Andhra Pradesh',
'Chandole,Tenali,Andhra Pradesh',
'Anamarlapudi,Tenali,Andhra Pradesh',
'Chebrole,Tenali,Andhra Pradesh',
'Sekuru,Tenali,Andhra Pradesh',
'Selapadu,Tenali,Andhra Pradesh',
'Suddapalli,Tenali,Andhra Pradesh',
'Arepalle Agraharam,Tenali,Andhra Pradesh',
'Arumbaka,Tenali,Andhra Pradesh',
'Balusulapalem,Tenali,Andhra Pradesh',
'Cherukupalle,Tenali,Andhra Pradesh',
'Gullapalli,Tenali,Andhra Pradesh',
'Kavuru,Tenali,Andhra Pradesh',
'Ramabhotlapalem,Tenali,Andhra Pradesh',
'Vinayasramam,Tenali,Andhra Pradesh',
'Allavaripalem,Tenali,Andhra Pradesh',
'Gudavalli,Tenali,Andhra Pradesh',
'Ilavaram,Tenali,Andhra Pradesh',
'Nadimpalli,Tenali,Andhra Pradesh',
'Peddavaram,Tenali,Andhra Pradesh',
'Ponnapalli Agraharam,Tenali,Andhra Pradesh',
'Rajavole,Tenali,Andhra Pradesh',
'Thotapalli,Tenali,Andhra Pradesh',
'Mulapalem,Tenali,Andhra Pradesh',
'Cherukuru,Tenali,Andhra Pradesh',
'Cheruvu,Tenali,Andhra Pradesh',
'Jillellamudi,Tenali,Andhra Pradesh',
'Narasayapalem,Tenali,Andhra Pradesh',
'Ramnayyapalem,Tenali,Andhra Pradesh',
'Reteru,Tenali,Andhra Pradesh',
'Annavaram,Narasaraopet,Andhra Pradesh',
'Appapuram,Narasaraopet,Andhra Pradesh',
'Boppudi,Narasaraopet,Andhra Pradesh',
'Chilakaluripet Bazar,Narasaraopet,Andhra Pradesh',
'Chilakaluripet H.O,Narasaraopet,Andhra Pradesh',
'Edavalli,Narasaraopet,Andhra Pradesh',
'Gangannapalem,Narasaraopet,Andhra Pradesh',
'Gonepudi,Narasaraopet,Andhra Pradesh',
'Gopalamvaripalem,Narasaraopet,Andhra Pradesh',
'Gottipadu,Narasaraopet,Andhra Pradesh',
'Govindapuram,Narasaraopet,Andhra Pradesh',
'Irlapadu,Narasaraopet,Andhra Pradesh',
'Kammavaripalem,Narasaraopet,Andhra Pradesh',
'Kattubadivaripalem,Narasaraopet,Andhra Pradesh',
'Kavuru,Narasaraopet,Andhra Pradesh',
'Komaravallipadu,Narasaraopet,Andhra Pradesh',
'Maddirala,Narasaraopet,Andhra Pradesh',
'Manukondavaripalem,Narasaraopet,Andhra Pradesh',
'Murikipudi,Narasaraopet,Andhra Pradesh',
'Pasumarru,Narasaraopet,Andhra Pradesh',
'Pothavaram,Narasaraopet,Andhra Pradesh',
'Purushothapatnam,Narasaraopet,Andhra Pradesh',
'Rajapeta,Narasaraopet,Andhra Pradesh',
'Subbaiah Thota,Narasaraopet,Andhra Pradesh',
'Tatapudi,Narasaraopet,Andhra Pradesh',
'Uppalapadu,Narasaraopet,Andhra Pradesh',
'Chodayapalem,Tenali,Andhra Pradesh',
'Dachpalle,Narasaraopet,Andhra Pradesh',
'Gamalapadu,Narasaraopet,Andhra Pradesh',
'Gogulapadu,Narasaraopet,Andhra Pradesh',
'Kesanapalle,Narasaraopet,Andhra Pradesh',
'Madinapadu,Narasaraopet,Andhra Pradesh',
'Nadikudi,Narasaraopet,Andhra Pradesh',
'Pondugula,Narasaraopet,Andhra Pradesh',
'Ramapuram,Narasaraopet,Andhra Pradesh',
'Regulagadda,Narasaraopet,Andhra Pradesh',
'Sarangapalle,Narasaraopet,Andhra Pradesh',
'Srinagar,Narasaraopet,Andhra Pradesh',
'Tangeda,Narasaraopet,Andhra Pradesh',
'Mutyalampadu,Narasaraopet,Andhra Pradesh',
'Dhulipudi,Tenali,Andhra Pradesh',
'Chiluvuru,Tenali,Andhra Pradesh',
'Duggirala,Tenali,Andhra Pradesh',
'Kantamrajukonduru,Tenali,Andhra Pradesh',
'Manchikalapudi,Tenali,Andhra Pradesh',
'Morampudi,Tenali,Andhra Pradesh',
'Penumuli,Tenali,Andhra Pradesh',
'Tummapudi,Tenali,Andhra Pradesh',
'Vallabhapuram,Tenali,Andhra Pradesh',
'Adigoppula,Narasaraopet,Andhra Pradesh',
'Atmakuru,Narasaraopet,Andhra Pradesh',
'Dharmavaram,Narasaraopet,Andhra Pradesh',
'Durgi,Narasaraopet,Andhra Pradesh',
'Kakirala,Narasaraopet,Andhra Pradesh',
'Kolagutla,Narasaraopet,Andhra Pradesh',
'Mutukuru,Narasaraopet,Andhra Pradesh',
'Narmalapadu,Narasaraopet,Andhra Pradesh',
'Obulesunipalle,Narasaraopet,Andhra Pradesh',
'Patlaveedu,Narasaraopet,Andhra Pradesh',
'Polepalle,Narasaraopet,Andhra Pradesh',
'Syamarajapuram,Narasaraopet,Andhra Pradesh',
'Edlapadu,Narasaraopet,Andhra Pradesh',
'Jaladi,Narasaraopet,Andhra Pradesh',
'Karuchola,Narasaraopet,Andhra Pradesh',
'Thimmapuram,Narasaraopet,Andhra Pradesh',
'Unnava,Narasaraopet,Andhra Pradesh',
'Vankayalapadu,Narasaraopet,Andhra Pradesh',
'Jaggapuram,Narasaraopet,Andhra Pradesh',
'Emani,Tenali,Andhra Pradesh',
'A.T.Agraharam(Guntur),Guntur,Andhra Pradesh',
'Abbineniguntapalem,Guntur,Andhra Pradesh',
'Amaravathi Road(Guntur),Guntur,Andhra Pradesh',
'Amaravathi,Guntur,Andhra Pradesh',
'Ananthavarappadu,Guntur,Andhra Pradesh',
'Ankireddypalem,Guntur,Andhra Pradesh',
'Apsp Colony(Mangalagiri),Guntur,Andhra Pradesh',
'Brodipet(Guntur),Guntur,Andhra Pradesh',
'Budampadu,Guntur,Andhra Pradesh',
'Bus Stand(Guntur),Guntur,Andhra Pradesh',
'Chamallamudi,Guntur,Andhra Pradesh',
'Chandramoulinagar,Guntur,Andhra Pradesh',
'Chintapallipadu,Guntur,Andhra Pradesh',
'Choutra(Guntur),Guntur,Andhra Pradesh',
'Chowdaripeta(Guntur),Guntur,Andhra Pradesh',
'College Road(Guntur),Guntur,Andhra Pradesh',
'Donka Road(Guntur),Guntur,Andhra Pradesh',
'Etukuru Road(Guntur),Guntur,Andhra Pradesh',
'Etukuru,Guntur,Andhra Pradesh',
'Factories Ward,Guntur,Andhra Pradesh',
'Garapadu,Guntur,Andhra Pradesh',
'Gogulamudi,Guntur,Andhra Pradesh',
'Gorantla,Guntur,Andhra Pradesh',
'Govt. General Hospital,Guntur,Andhra Pradesh',
'Guntur Bazar,Guntur,Andhra Pradesh',
'Guntur Collectorate,Guntur,Andhra Pradesh',
'Guntur H.O,Guntur,Andhra Pradesh',
'Guntur Medical College,Guntur,Andhra Pradesh',
'Industrial Estate,Guntur,Andhra Pradesh',
'Jonnalagadda,Guntur,Andhra Pradesh',
'K.C.Works,Guntur,Andhra Pradesh',
'Kakumanu,Guntur,Andhra Pradesh',
'Katrapadu,Guntur,Andhra Pradesh',
'Kopparru,Guntur,Andhra Pradesh',
'Koritepadu(Guntur),Guntur,Andhra Pradesh',
'Kornepadu,Guntur,Andhra Pradesh',
'Kothapeta(Guntur),Guntur,Andhra Pradesh',
'Kurnuthala,Guntur,Andhra Pradesh',
'L.W.Works(Guntur),Guntur,Andhra Pradesh',
'Lalpuram,Guntur,Andhra Pradesh',
'Lam Ars,Guntur,Andhra Pradesh',
'Lam,Guntur,Andhra Pradesh',
'Layola Nagar,Guntur,Andhra Pradesh',
'Lemalle,Guntur,Andhra Pradesh',
'Mangalagiri Bazar,Guntur,Andhra Pradesh',
'Mangalagiri Busstand,Guntur,Andhra Pradesh',
'Municipal Office(Guntur),Guntur,Andhra Pradesh',
'Nagarjuna Nagar,Guntur,Andhra Pradesh',
'Nallapadu,Guntur,Andhra Pradesh',
'Namburu,Guntur,Andhra Pradesh',
'Nehru Nagar(Guntur),Guntur,Andhra Pradesh',
'Nutakki,Guntur,Andhra Pradesh',
'Old Guntur,Guntur,Andhra Pradesh',
'Old Mangalagiri,Guntur,Andhra Pradesh',
'Pallapadu,Guntur,Andhra Pradesh',
'Pattabhipuram(Guntur),Guntur,Andhra Pradesh',
'Pedakakani,Guntur,Andhra Pradesh',
'Pedanandipadu,Guntur,Andhra Pradesh',
'Pedapalakaluru,Guntur,Andhra Pradesh',
'Pedavadlapudi,Guntur,Andhra Pradesh',
'Perecherla,Guntur,Andhra Pradesh',
'Polakampadu Ind. Area,Guntur,Andhra Pradesh',
'Ponnekallu,Guntur,Andhra Pradesh',
'Pothuru,Guntur,Andhra Pradesh',
'Prathipadu,Guntur,Andhra Pradesh',
'Railpet(Guntur),Guntur,Andhra Pradesh',
'Ravipadu,Guntur,Andhra Pradesh',
'S.K.P.Temple(Guntur),Guntur,Andhra Pradesh',
'S.V.N.Colony(Guntur),Guntur,Andhra Pradesh',
'Tadepalle,Guntur,Andhra Pradesh',
'Tadikonda,Guntur,Andhra Pradesh',
'Tobacco Colony(Guntur),Guntur,Andhra Pradesh',
'Trunk Road(Guntur),Guntur,Andhra Pradesh',
'Tulluru,Guntur,Andhra Pradesh',
'Vangipuram,Guntur,Andhra Pradesh',
'Vengalayapalem,Guntur,Andhra Pradesh',
'Vinjanampadu,Guntur,Andhra Pradesh',
'Yamarru,Guntur,Andhra Pradesh',
'Ambapuram,Narasaraopet,Andhra Pradesh',
'Cherlagudipadu,Narasaraopet,Andhra Pradesh',
'Daida,Narasaraopet,Andhra Pradesh',
'Gangavaram,Narasaraopet,Andhra Pradesh',
'Gottimukkala,Narasaraopet,Andhra Pradesh',
'Gurazalla,Narasaraopet,Andhra Pradesh',
'Jangamaheswarapuram,Narasaraopet,Andhra Pradesh',
'Miriyala,Narasaraopet,Andhra Pradesh',
'Pallegunta,Narasaraopet,Andhra Pradesh',
'Pulipadu,Narasaraopet,Andhra Pradesh',
'Madugula,Narasaraopet,Andhra Pradesh',
'Intur,Tenali,Andhra Pradesh',
'Kondamudi,Tenali,Andhra Pradesh',
'Bodapadu,Tenali,Andhra Pradesh',
'Elavarru,Tenali,Andhra Pradesh',
'Pyaparru,Tenali,Andhra Pradesh',
'Angaluru,Narasaraopet,Andhra Pradesh',
'Bollapalle,Narasaraopet,Andhra Pradesh',
'Bommarajupalle,Narasaraopet,Andhra Pradesh',
'Butchipapannapalem,Narasaraopet,Andhra Pradesh',
'Chittapuram,Narasaraopet,Andhra Pradesh',
'Domalagundam,Narasaraopet,Andhra Pradesh',
'Gandiganumala,Narasaraopet,Andhra Pradesh',
'Gundepalle,Narasaraopet,Andhra Pradesh',
'Inumella,Narasaraopet,Andhra Pradesh',
'Ipuru,Narasaraopet,Andhra Pradesh',
'Kondayapalem,Narasaraopet,Andhra Pradesh',
'Mugachintalapalem,Narasaraopet,Andhra Pradesh',
'Ravulapuram,Narasaraopet,Andhra Pradesh',
'Remidicherla,Narasaraopet,Andhra Pradesh',
'Udjerla,Narasaraopet,Andhra Pradesh',
'Vanikunta,Narasaraopet,Andhra Pradesh',
'Kolanukonda,Guntur,Andhra Pradesh',
'Vaddeswaram,Guntur,Andhra Pradesh',
'Appapuram,Guntur,Andhra Pradesh',
'Ballukanudivari Palem,Guntur,Andhra Pradesh',
'Garikapadu,Guntur,Andhra Pradesh',
'Kondapaturu,Guntur,Andhra Pradesh',
'Pedapalem,Guntur,Andhra Pradesh',
'Kanagala,Tenali,Andhra Pradesh',
'Chinakodamagundla,Narasaraopet,Andhra Pradesh',
'Chintapalle,Narasaraopet,Andhra Pradesh',
'Gadevaripalle,Narasaraopet,Andhra Pradesh',
'Garikapadu,Narasaraopet,Andhra Pradesh',
'Gummanampadu,Narasaraopet,Andhra Pradesh',
'Karempudi,Narasaraopet,Andhra Pradesh',
'Marripalem,Narasaraopet,Andhra Pradesh',
'Mellavagu,Narasaraopet,Andhra Pradesh',
'Narasimhapuri,Narasaraopet,Andhra Pradesh',
'Pedakodamagundla,Narasaraopet,Andhra Pradesh',
'Petasannegandla,Narasaraopet,Andhra Pradesh',
'Sankarapuram,Narasaraopet,Andhra Pradesh',
'Voppicherla,Narasaraopet,Andhra Pradesh',
'Buddam,Tenali,Andhra Pradesh',
'Chintayapalem,Tenali,Andhra Pradesh',
'Ganapavaram,Tenali,Andhra Pradesh',
'Karlapalem,Tenali,Andhra Pradesh',
'Nalamothuvaripalem,Tenali,Andhra Pradesh',
'Pedagollapalem,Tenali,Andhra Pradesh',
'Pedapuluguvaripalem,Tenali,Andhra Pradesh',
'Perali,Tenali,Andhra Pradesh',
'Yazali,Tenali,Andhra Pradesh',
'Kolakaluru,Tenali,Andhra Pradesh',
'Chivaluru,Tenali,Andhra Pradesh',
'Davuluru,Tenali,Andhra Pradesh',
'Gudibandivaripalem,Tenali,Andhra Pradesh',
'Kollipara,Tenali,Andhra Pradesh',
'Munnangi,Tenali,Andhra Pradesh',
'Pidaparru,Tenali,Andhra Pradesh',
'Tumuluru,Tenali,Andhra Pradesh',
'Boddulurupadu,Tenali,Andhra Pradesh',
'Chintallanka,Tenali,Andhra Pradesh',
'Donepudi,Tenali,Andhra Pradesh',
'Gajullanka,Tenali,Andhra Pradesh',
'Kolluru,Tenali,Andhra Pradesh',
'Krapa,Tenali,Andhra Pradesh',
'Potharlanka,Tenali,Andhra Pradesh',
'Ravikampadu,Tenali,Andhra Pradesh',
'Ananthavaram,Narasaraopet,Andhra Pradesh',
'Andukuru,Narasaraopet,Andhra Pradesh',
'Balemarru,Narasaraopet,Andhra Pradesh',
'Dodleru,Narasaraopet,Andhra Pradesh',
'Grandhasiri,Narasaraopet,Andhra Pradesh',
'Gudipadu,Narasaraopet,Andhra Pradesh',
'Kastala,Narasaraopet,Andhra Pradesh',
'Konduru,Narasaraopet,Andhra Pradesh',
'Konuru,Narasaraopet,Andhra Pradesh',
'Krosuru,Narasaraopet,Andhra Pradesh',
'Pedapalem,Narasaraopet,Andhra Pradesh',
'Peesapadu,Narasaraopet,Andhra Pradesh',
'Talluru,Narasaraopet,Andhra Pradesh',
'Velpuru,Narasaraopet,Andhra Pradesh',
'Vipparla,Narasaraopet,Andhra Pradesh',
'Voravakallu,Narasaraopet,Andhra Pradesh',
'Vutukuru,Narasaraopet,Andhra Pradesh',
'Adavuladivi,Tenali,Andhra Pradesh',
'Allaparru,Tenali,Andhra Pradesh',
'Chinkapalem,Tenali,Andhra Pradesh',
'Dindi,Tenali,Andhra Pradesh',
'Gurunadhanagar,Tenali,Andhra Pradesh',
'Kallipalem,Tenali,Andhra Pradesh',
'Kuchinapudi,Tenali,Andhra Pradesh',
'Mantripalem,Tenali,Andhra Pradesh',
'Pallapatla,Tenali,Andhra Pradesh',
'Pragnam,Tenali,Andhra Pradesh',
'Kuchipudi,Tenali,Andhra Pradesh',
'Endroy,Guntur,Andhra Pradesh',
'Karlapudi,Guntur,Andhra Pradesh',
'Latchannagudipudi,Guntur,Andhra Pradesh',
'Mothadaka,Guntur,Andhra Pradesh',
'Mukkamala,Guntur,Andhra Pradesh',
'Narukullapadu,Guntur,Andhra Pradesh',
'Nevalikallu,Guntur,Andhra Pradesh',
'Nidumukkala,Guntur,Andhra Pradesh',
'Vunguturu,Guntur,Andhra Pradesh',
'Bodipalem,Tenali,Andhra Pradesh',
'Itikampadu,Tenali,Andhra Pradesh',
'Komali,Tenali,Andhra Pradesh',
'Kothapalem,Narasaraopet,Andhra Pradesh',
'Machavaram,Tenali,Andhra Pradesh',
'Machavaram,Narasaraopet,Andhra Pradesh',
'Mulukuduru,Tenali,Andhra Pradesh',
'Nanduru,Tenali,Andhra Pradesh',
'Pinnelli,Narasaraopet,Andhra Pradesh',
'Velampalle,Narasaraopet,Andhra Pradesh',
'Vemavaram,Narasaraopet,Andhra Pradesh',
'Gannavaram,Narasaraopet,Andhra Pradesh',
'Kambhampadu,Narasaraopet,Andhra Pradesh',
'Koppunuru,Narasaraopet,Andhra Pradesh',
'Kothapalle,Narasaraopet,Andhra Pradesh',
'Kotturu,Narasaraopet,Andhra Pradesh',
'Macherla,Narasaraopet,Andhra Pradesh',
'Mandadi,Narasaraopet,Andhra Pradesh',
'Nagulavaram,Narasaraopet,Andhra Pradesh',
'Pasivemula,Narasaraopet,Andhra Pradesh',
'PWD Colony,Narasaraopet,Andhra Pradesh',
'Rayavaram,Narasaraopet,Andhra Pradesh',
'Tallapalle,Narasaraopet,Andhra Pradesh',
'Thimmareddipuram,Narasaraopet,Andhra Pradesh',
'Vijayapuri South,Narasaraopet,Andhra Pradesh',
'Zammalamadaka,Narasaraopet,Andhra Pradesh',
'Mangalagiri H.O,Guntur,Andhra Pradesh',
'Atmakuru,Guntur,Andhra Pradesh',
'Bethapudi,Guntur,Andhra Pradesh',
'Chinakakani,Guntur,Andhra Pradesh',
'Kaza,Guntur,Andhra Pradesh',
'Krishnayapalem,Guntur,Andhra Pradesh',
'Kuragallu,Guntur,Andhra Pradesh',
'Mandadam,Guntur,Andhra Pradesh',
'Navuluru,Guntur,Andhra Pradesh',
'Neerukonda,Guntur,Andhra Pradesh',
'Nidamarru,Guntur,Andhra Pradesh',
'T.B.Sanitorium,Guntur,Andhra Pradesh',
'Velagapudi,Guntur,Andhra Pradesh',
'Venkatapalem,Guntur,Andhra Pradesh',
'Yerrabalem,Guntur,Andhra Pradesh',
'Kattavaripalem,Narasaraopet,Andhra Pradesh',
'Komerapudi,Narasaraopet,Andhra Pradesh',
'Korrapadu,Narasaraopet,Andhra Pradesh',
'Mandapadu,Narasaraopet,Andhra Pradesh',
'Medikonduru,Narasaraopet,Andhra Pradesh',
'Paladugu,Narasaraopet,Andhra Pradesh',
'Siripuram,Narasaraopet,Andhra Pradesh',
'Takkellapadu,Narasaraopet,Andhra Pradesh',
'Turakapalem,Narasaraopet,Andhra Pradesh',
'Varagani,Narasaraopet,Andhra Pradesh',
'Velavarthipadu,Narasaraopet,Andhra Pradesh',
'Visadala,Narasaraopet,Andhra Pradesh',
'Muppalla,Narasaraopet,Andhra Pradesh',
'Turkapalem,Narasaraopet,Andhra Pradesh',
'Dammalapadu,Narasaraopet,Andhra Pradesh',
'Kunduruvaripalem,Narasaraopet,Andhra Pradesh',
'Lankalakurapadu,Narasaraopet,Andhra Pradesh',
'Narnepadu,Narasaraopet,Andhra Pradesh',
'Paludevarlapadu,Narasaraopet,Andhra Pradesh',
'Bethapudi,Narasaraopet,Andhra Pradesh',
'Chandavaram,Narasaraopet,Andhra Pradesh',
'Chirumamilla,Narasaraopet,Andhra Pradesh',
'Dondapadu,Narasaraopet,Andhra Pradesh',
'Endugumpalem,Narasaraopet,Andhra Pradesh',
'Ganapavaram,Narasaraopet,Andhra Pradesh',
'Gorizavole,Narasaraopet,Andhra Pradesh',
'Gundalapadu,Narasaraopet,Andhra Pradesh',
'Kanaparru,Narasaraopet,Andhra Pradesh',
'Lingaraopalem,Narasaraopet,Andhra Pradesh',
'Merikapudi,Narasaraopet,Andhra Pradesh',
'Munagapadu,Narasaraopet,Andhra Pradesh',
'Nadendla,Narasaraopet,Andhra Pradesh',
'Ponugupadu,Narasaraopet,Andhra Pradesh',
'Sandepudi,Narasaraopet,Andhra Pradesh',
'Sankurathripadu,Narasaraopet,Andhra Pradesh',
'Satuluru,Narasaraopet,Andhra Pradesh',
'Solasa,Narasaraopet,Andhra Pradesh',
'Tubadu,Narasaraopet,Andhra Pradesh',
'Turlapadu,Narasaraopet,Andhra Pradesh',
'Veluru,Narasaraopet,Andhra Pradesh',
'Bellamvaripalem,Tenali,Andhra Pradesh',
'Idupalli,Tenali,Andhra Pradesh',
'Karankivaripalem,Tenali,Andhra Pradesh',
'Kolaganivaripalem,Tenali,Andhra Pradesh',
'Muttupalli Agraharam,Tenali,Andhra Pradesh',
'Nagaram,Tenali,Andhra Pradesh',
'Pamidimarru,Tenali,Andhra Pradesh',
'Pudivada,Tenali,Andhra Pradesh',
'Pushadapuvaripalem,Tenali,Andhra Pradesh',
'Venigallavaripalem,Tenali,Andhra Pradesh',
'Yeletipalem,Tenali,Andhra Pradesh',
'Kanteru,Guntur,Andhra Pradesh',
'Koppuravuru,Guntur,Andhra Pradesh',
'Nandivelugu,Tenali,Andhra Pradesh',
'Annavaram,Narasaraopet,Andhra Pradesh',
'Arundalpet (NSV),Narasaraopet,Andhra Pradesh',
'Bandlamottu,Narasaraopet,Andhra Pradesh',
'Chagallu,Narasaraopet,Andhra Pradesh',
'Ellamanda,Narasaraopet,Andhra Pradesh',
'Guravayapalem,Narasaraopet,Andhra Pradesh',
'Ikkurru,Narasaraopet,Andhra Pradesh',
'Jonnalagadda,Narasaraopet,Andhra Pradesh',
'Kakani,Narasaraopet,Andhra Pradesh',
'Kandlagunta,Narasaraopet,Andhra Pradesh',
'Kesanapalle,Narasaraopet,Andhra Pradesh',
'Lingamguntla Agraharam,Narasaraopet,Andhra Pradesh',
'Mulakaluru,Narasaraopet,Andhra Pradesh',
'N.S.C.Colony,Narasaraopet,Andhra Pradesh',
'Narasaraopet Bazar,Narasaraopet,Andhra Pradesh',
'Narasaraopet H.O,Narasaraopet,Andhra Pradesh',
'Palapadu,Narasaraopet,Andhra Pradesh',
'Petlurivaripalem,Narasaraopet,Andhra Pradesh',
'Prakashnagar,Narasaraopet,Andhra Pradesh',
'Ravipadu,Narasaraopet,Andhra Pradesh',
'Reddipalem,Narasaraopet,Andhra Pradesh',
'Rupenagunta,Narasaraopet,Andhra Pradesh',
'Uppalapadu,Narasaraopet,Andhra Pradesh',
'Vipparlapalle,Narasaraopet,Andhra Pradesh',
'Pamidipadu Agraharam,Narasaraopet,Andhra Pradesh',
'Cheemalamarri,Narasaraopet,Andhra Pradesh',
'Chejerla,Narasaraopet,Andhra Pradesh',
'Gundlapalle,Narasaraopet,Andhra Pradesh',
'Inumetla,Narasaraopet,Andhra Pradesh',
'Karlakunta,Narasaraopet,Andhra Pradesh',
'Kothapalle,Narasaraopet,Andhra Pradesh',
'Kunkalagunta,Narasaraopet,Andhra Pradesh',
'Machavaram,Narasaraopet,Andhra Pradesh',
'Narasingapadu,Narasaraopet,Andhra Pradesh',
'Nekarikallu,Narasaraopet,Andhra Pradesh',
'Santhagudipadu,Narasaraopet,Andhra Pradesh',
'Tsallagundla,Narasaraopet,Andhra Pradesh',
'Uppalapadu,Narasaraopet,Andhra Pradesh',
'Vipparla,Narasaraopet,Andhra Pradesh',
'Alluru,Tenali,Andhra Pradesh',
'Amudalapalli,Tenali,Andhra Pradesh',
'Bavajipalem,Tenali,Andhra Pradesh',
'Nizampatnam,Tenali,Andhra Pradesh',
'Pedamatlapudi,Tenali,Andhra Pradesh',
'Chirravuru,Guntur,Andhra Pradesh',
'Gundimeda,Guntur,Andhra Pradesh',
'Mellempudi,Guntur,Andhra Pradesh',
'Ainavole,Narasaraopet,Andhra Pradesh',
'Kambhampadu,Narasaraopet,Andhra Pradesh',
'Mulakaluru,Narasaraopet,Andhra Pradesh',
'Mupparajuvaripalem,Narasaraopet,Andhra Pradesh',
'Nuzendla,Narasaraopet,Andhra Pradesh',
'Pamidipadu,Narasaraopet,Andhra Pradesh',
'Pathakothapalem,Narasaraopet,Andhra Pradesh',
'Puvvada,Narasaraopet,Andhra Pradesh',
'Ramudipalem,Narasaraopet,Andhra Pradesh',
'Ravvavaram,Narasaraopet,Andhra Pradesh',
'Reddipalem,Narasaraopet,Andhra Pradesh',
'Talarlapalle,Narasaraopet,Andhra Pradesh',
'Vetrayuni Appapuram,Narasaraopet,Andhra Pradesh',
'Aremanda,Tenali,Andhra Pradesh',
'Dandamudi,Tenali,Andhra Pradesh',
'Doppalapudi,Tenali,Andhra Pradesh',
'Mannava,Tenali,Andhra Pradesh',
'Munipalli,Tenali,Andhra Pradesh',
'Patsalatadiparru,Tenali,Andhra Pradesh',
'Gollamudi,Guntur,Andhra Pradesh',
'Pathuru,Guntur,Andhra Pradesh',
'Reddypalem,Guntur,Andhra Pradesh',
'Takkellapadu,Guntur,Andhra Pradesh',
'Uppalapadu,Guntur,Andhra Pradesh',
'Venigandla,Guntur,Andhra Pradesh',
'Venkatakrishnapuram,Guntur,Andhra Pradesh',
'Attaluru,Narasaraopet,Andhra Pradesh',
'Balusupadu,Narasaraopet,Andhra Pradesh',
'Bayyavaram,Narasaraopet,Andhra Pradesh',
'Bhatluru,Narasaraopet,Andhra Pradesh',
'Garapadu,Narasaraopet,Andhra Pradesh',
'Hussainnagaram,Narasaraopet,Andhra Pradesh',
'Jalalapuram,Narasaraopet,Andhra Pradesh',
'Jupudi,Narasaraopet,Andhra Pradesh',
'Kambhampadu,Narasaraopet,Andhra Pradesh',
'Kasipadu,Narasaraopet,Andhra Pradesh',
'Kattamuru,Narasaraopet,Andhra Pradesh',
'Lagadapadu,Narasaraopet,Andhra Pradesh',
'Lingamguntla,Narasaraopet,Andhra Pradesh',
'Lingapuram,Narasaraopet,Andhra Pradesh',
'Munugodu,Narasaraopet,Andhra Pradesh',
'Parastyalluru,Narasaraopet,Andhra Pradesh',
'Patibandla,Narasaraopet,Andhra Pradesh',
'Pedamakkena,Narasaraopet,Andhra Pradesh',
'Tammavaram,Narasaraopet,Andhra Pradesh',
'Pedakurapadu,Narasaraopet,Andhra Pradesh',
'Anaparru,Guntur,Andhra Pradesh',
'Garlapadu,Guntur,Andhra Pradesh',
'Katrapadu,Guntur,Andhra Pradesh',
'Kommuru,Guntur,Andhra Pradesh',
'Nagualapadu,Guntur,Andhra Pradesh',
'Palaparru,Guntur,Andhra Pradesh',
'Pusuluru,Guntur,Andhra Pradesh',
'Rajupalem,Guntur,Andhra Pradesh',
'Varagani,Guntur,Andhra Pradesh',
'Chinapalem,Guntur,Andhra Pradesh',
'Godavarru Agraharam,Guntur,Andhra Pradesh',
'Pedakonduru,Guntur,Andhra Pradesh',
'Pedapalem,Guntur,Andhra Pradesh',
'Perikalapudi,Guntur,Andhra Pradesh',
'Srungarapuram,Guntur,Andhra Pradesh',
'Veerlapalem,Guntur,Andhra Pradesh',
'Ippatam,Guntur,Andhra Pradesh',
'Revendrapadu,Guntur,Andhra Pradesh',
'Ameenabad,Narasaraopet,Andhra Pradesh',
'Kandrika,Narasaraopet,Andhra Pradesh',
'Kondaveedu,Narasaraopet,Andhra Pradesh',
'Nudurupadu,Narasaraopet,Andhra Pradesh',
'Phirangipuram,Narasaraopet,Andhra Pradesh',
'Singhiskhanpet,Narasaraopet,Andhra Pradesh',
'Talluru,Narasaraopet,Andhra Pradesh',
'Vemavaram,Narasaraopet,Andhra Pradesh',
'Brahmanapalle,Narasaraopet,Andhra Pradesh',
'China Garlapadu,Narasaraopet,Andhra Pradesh',
'Chinaagraharam,Narasaraopet,Andhra Pradesh',
'Guttikonda,Narasaraopet,Andhra Pradesh',
'Janapadu,Narasaraopet,Andhra Pradesh',
'Karalapadu,Narasaraopet,Andhra Pradesh',
'Konanki,Narasaraopet,Andhra Pradesh',
'Kotanemalipuri,Narasaraopet,Andhra Pradesh',
'Kothaganesunipadu,Narasaraopet,Andhra Pradesh',
'Kubadpuram,Narasaraopet,Andhra Pradesh',
'Morjampadu,Narasaraopet,Andhra Pradesh',
'Nemalipuri,Narasaraopet,Andhra Pradesh',
'Panditivaripalem,Narasaraopet,Andhra Pradesh',
'Pedagarlapadu,Narasaraopet,Andhra Pradesh',
'Piduguralla,Narasaraopet,Andhra Pradesh',
'Sitarampuram Mines,Narasaraopet,Andhra Pradesh',
'Tummalacheruvu,Narasaraopet,Andhra Pradesh',
'Veerapuram,Narasaraopet,Andhra Pradesh',
'Zulakallu,Narasaraopet,Andhra Pradesh',
'Pillutla,Narasaraopet,Andhra Pradesh',
'Bandarupalle,Guntur,Andhra Pradesh',
'Bejathpuram,Guntur,Andhra Pradesh',
'Damarapalle,Guntur,Andhra Pradesh',
'Garikapadu,Guntur,Andhra Pradesh',
'Gorlavaripalem,Guntur,Andhra Pradesh',
'Mandepudi,Guntur,Andhra Pradesh',
'Pamulapadu,Guntur,Andhra Pradesh',
'Ravela,Guntur,Andhra Pradesh',
'Chinalingayapalem,Tenali,Andhra Pradesh',
'Chintalapudi,Tenali,Andhra Pradesh',
'Kondabalavaripalem,Tenali,Andhra Pradesh',
'Nidubrole,Tenali,Andhra Pradesh',
'Nidubrolu Old Town,Tenali,Andhra Pradesh',
'Pandrapadu,Tenali,Andhra Pradesh',
'Ponnur Bazar,Tenali,Andhra Pradesh',
'Ponnur,Tenali,Andhra Pradesh',
'Tallapalem,Tenali,Andhra Pradesh',
'Vaddemukkala,Tenali,Andhra Pradesh',
'Vallabharaopalem,Tenali,Andhra Pradesh',
'Valluru,Tenali,Andhra Pradesh',
'Vupparapalem,Tenali,Andhra Pradesh',
'Aluru,Tenali,Andhra Pradesh',
'Kasukarru,Tenali,Andhra Pradesh',
'Chowdavaram,Guntur,Andhra Pradesh',
'Enamadala,Guntur,Andhra Pradesh',
'Ganikapudi,Guntur,Andhra Pradesh',
'Gottipadu,Guntur,Andhra Pradesh',
'Kondepadu,Guntur,Andhra Pradesh',
'Koyavaripalem,Guntur,Andhra Pradesh',
'Mallayapalem,Guntur,Andhra Pradesh',
'Nadimpalem,Guntur,Andhra Pradesh',
'Nimmagaddavaripalem,Guntur,Andhra Pradesh',
'Tikkireddyvaripalem,Guntur,Andhra Pradesh',
'Balijepalle,Narasaraopet,Andhra Pradesh',
'Dhulipalla,Narasaraopet,Andhra Pradesh',
'Mokkapadu,Narasaraopet,Andhra Pradesh',
'Nagavaram,Narasaraopet,Andhra Pradesh',
'Rajupalem,Narasaraopet,Andhra Pradesh',
'Reddigudem,Narasaraopet,Andhra Pradesh',
'Tondapi,Narasaraopet,Andhra Pradesh',
'Goli,Narasaraopet,Andhra Pradesh',
'Jettipalem,Narasaraopet,Andhra Pradesh',
'Manchikallu,Narasaraopet,Andhra Pradesh',
'Mittagudipadu,Narasaraopet,Andhra Pradesh',
'Paluvai,Narasaraopet,Andhra Pradesh',
'Pasarlapadu,Narasaraopet,Andhra Pradesh',
'Rentachintala,Narasaraopet,Andhra Pradesh',
'Rentala,Narasaraopet,Andhra Pradesh',
'Tummercode,Narasaraopet,Andhra Pradesh',
'Bethapudi,Tenali,Andhra Pradesh',
'Chatragadda,Tenali,Andhra Pradesh',
'Gangadipalem,Tenali,Andhra Pradesh',
'Guddikayalanka,Tenali,Andhra Pradesh',
'Isukapalle,Tenali,Andhra Pradesh',
'Kaithepalle,Tenali,Andhra Pradesh',
'Kannegantivaripalem,Tenali,Andhra Pradesh',
'Karumuru,Tenali,Andhra Pradesh',
'Mrutyumjayapalem,Tenali,Andhra Pradesh',
'Murthota,Tenali,Andhra Pradesh',
'Nalluru,Tenali,Andhra Pradesh',
'Nallurupalem,Tenali,Andhra Pradesh',
'Penumudi,Tenali,Andhra Pradesh',
'Peteru,Tenali,Andhra Pradesh',
'Piratlanka,Tenali,Andhra Pradesh',
'Pothumeraka,Tenali,Andhra Pradesh',
'Railpeta - Repale,Tenali,Andhra Pradesh',
'Repalle Bazar,Tenali,Andhra Pradesh',
'Repalle H.O,Tenali,Andhra Pradesh',
'Sajjavaripalem,Tenali,Andhra Pradesh',
'Singupalem,Tenali,Andhra Pradesh',
'Tummala,Tenali,Andhra Pradesh',
'Vaddevaripalem,Tenali,Andhra Pradesh',
'Visweswaram,Tenali,Andhra Pradesh',
'Voleru,Tenali,Andhra Pradesh',
'Vullipalem,Tenali,Andhra Pradesh',
'Vuppudi,Tenali,Andhra Pradesh',
'Alavala,Narasaraopet,Andhra Pradesh',
'Annavarappadu,Narasaraopet,Andhra Pradesh',
'Gogulapadu,Narasaraopet,Andhra Pradesh',
'Konakanchivaripalem,Narasaraopet,Andhra Pradesh',
'Ramireddipalem,Narasaraopet,Andhra Pradesh',
'Rompicherla,Narasaraopet,Andhra Pradesh',
'Turumella,Narasaraopet,Andhra Pradesh',
'Vadlamudivaripalem,Narasaraopet,Andhra Pradesh',
'Sangamjagarlamudi,Tenali,Andhra Pradesh',
'Vadlamudi,Tenali,Andhra Pradesh',
'Vejendla,Tenali,Andhra Pradesh',
'Abburu,Narasaraopet,Andhra Pradesh',
'Bhimavaram,Narasaraopet,Andhra Pradesh',
'Bhrugubanda,Narasaraopet,Andhra Pradesh',
'Bollavaram,Narasaraopet,Andhra Pradesh',
'Gandhi Chowk,Narasaraopet,Andhra Pradesh',
'Gudipudi,Narasaraopet,Andhra Pradesh',
'Kandulavaripalem,Narasaraopet,Andhra Pradesh',
'Lakkarajugarlapadu,Narasaraopet,Andhra Pradesh',
'Nandigama,Narasaraopet,Andhra Pradesh',
'Pakalapadu,Narasaraopet,Andhra Pradesh',
'Panidem,Narasaraopet,Andhra Pradesh',
'Rentapalla,Narasaraopet,Andhra Pradesh',
'Rudravaram,Narasaraopet,Andhra Pradesh',
'Sattenapalle H.O,Narasaraopet,Andhra Pradesh',
'Yerraguntlapadu,Narasaraopet,Andhra Pradesh',
'Kanumarlapudi,Narasaraopet,Andhra Pradesh',
'Karumanchi,Narasaraopet,Andhra Pradesh',
'Kothaluru,Narasaraopet,Andhra Pradesh',
'Mathukumalli,Narasaraopet,Andhra Pradesh',
'Potluru,Narasaraopet,Andhra Pradesh',
'Sanampudi,Narasaraopet,Andhra Pradesh',
'Savalyapuram,Narasaraopet,Andhra Pradesh',
'Vayyakallu,Narasaraopet,Andhra Pradesh',
'Velpuru,Narasaraopet,Andhra Pradesh',
'Madala,Narasaraopet,Andhra Pradesh',
'Kankatapalem,Tenali,Andhra Pradesh',
'Murukondapadu,Tenali,Andhra Pradesh',
'Stuvartpuram Colony,Tenali,Andhra Pradesh',
'Stuvartpuram,Tenali,Andhra Pradesh',
'Kunchanapalle,Guntur,Andhra Pradesh',
'Penumaka,Guntur,Andhra Pradesh',
'Prathuru,Guntur,Andhra Pradesh',
'Ramayalam,Guntur,Andhra Pradesh',
'Undavalli,Guntur,Andhra Pradesh',
'Anantavaram,Guntur,Andhra Pradesh',
'Nekkallu,Guntur,Andhra Pradesh',
'Pedaparimi,Guntur,Andhra Pradesh',
'Vaddamanu,Guntur,Andhra Pradesh',
'Athota,Tenali,Andhra Pradesh',
'Dantaluru,Tenali,Andhra Pradesh',
'Gandhinagar,Tenali,Andhra Pradesh',
'Gudivada,Tenali,Andhra Pradesh',
'Ithanagar,Tenali,Andhra Pradesh',
'Kancherlapalem,Tenali,Andhra Pradesh',
'Katevaram,Tenali,Andhra Pradesh',
'Kazipeta,Tenali,Andhra Pradesh',
'Kopalle,Tenali,Andhra Pradesh',
'Kothapeta,Tenali,Andhra Pradesh',
'Kunchavaram,Tenali,Andhra Pradesh',
'Morrispeta,Tenali,Andhra Pradesh',
'Nelapadu,Tenali,Andhra Pradesh',
'Pedaravuru,Tenali,Andhra Pradesh',
'Pinapad Tenali,Tenali,Andhra Pradesh',
'Satyanarayanapuram,Tenali,Andhra Pradesh',
'Tenali Bazar,Tenali,Andhra Pradesh',
'Tenali H.O,Tenali,Andhra Pradesh',
'Wahabchowk-tenali,Tenali,Andhra Pradesh',
'Yerukalapudi,Tenali,Andhra Pradesh',
'Mamillapalli,Tenali,Andhra Pradesh',
'Modukur,Tenali,Andhra Pradesh',
'Nadigaddapalem,Tenali,Andhra Pradesh',
'Pedagadelavarru,Tenali,Andhra Pradesh',
'Tsunduru,Tenali,Andhra Pradesh',
'Abbarajupalem,Guntur,Andhra Pradesh',
'Ainavolu,Guntur,Andhra Pradesh',
'Borupalem,Guntur,Andhra Pradesh',
'Dondapadu,Guntur,Andhra Pradesh',
'Nelapadu,Guntur,Andhra Pradesh',
'Rayapudi,Guntur,Andhra Pradesh',
'Sakhamuru,Guntur,Andhra Pradesh',
'Alapadu,Tenali,Andhra Pradesh',
'Korutadiparru,Tenali,Andhra Pradesh',
'Moparru,Tenali,Andhra Pradesh',
'Turumella,Tenali,Andhra Pradesh',
'Bodilaveedu,Narasaraopet,Andhra Pradesh',
'Gottipalla,Narasaraopet,Andhra Pradesh',
'Gundalapadu,Narasaraopet,Andhra Pradesh',
'Kandlagunta,Narasaraopet,Andhra Pradesh',
'Kothapullareddipuram,Narasaraopet,Andhra Pradesh',
'Sirigiripadu,Narasaraopet,Andhra Pradesh',
'Uppalapadu,Narasaraopet,Andhra Pradesh',
'Veldurthy,Narasaraopet,Andhra Pradesh',
'Vellaturu,Tenali,Andhra Pradesh',
'Balijepalli,Tenali,Andhra Pradesh',
'Butumalli,Tenali,Andhra Pradesh',
'Champadu,Tenali,Andhra Pradesh',
'Chavali,Tenali,Andhra Pradesh',
'Jampani,Tenali,Andhra Pradesh',
'Kuchellapadu,Tenali,Andhra Pradesh',
'Peravali,Tenali,Andhra Pradesh',
'Peravalipalem,Tenali,Andhra Pradesh',
'Varahapuram Agraharam,Tenali,Andhra Pradesh',
'Vemuru,Tenali,Andhra Pradesh',
'Agnigundala,Narasaraopet,Andhra Pradesh',
'Andugula Kothapalem,Narasaraopet,Andhra Pradesh',
'Brahmanapalle,Narasaraopet,Andhra Pradesh',
'Chatragaddapadu,Narasaraopet,Andhra Pradesh',
'Cheekateegalapalem,Narasaraopet,Andhra Pradesh',
'Cheruvukommupalem,Narasaraopet,Andhra Pradesh',
'Chinakancherla,Narasaraopet,Andhra Pradesh',
'Chintalacheruvu,Narasaraopet,Andhra Pradesh',
'Dondapadu,Narasaraopet,Andhra Pradesh',
'Enugupalem,Narasaraopet,Andhra Pradesh',
'Gokanakonda,Narasaraopet,Andhra Pradesh',
'Gutlapalle,Narasaraopet,Andhra Pradesh',
'Hassannayunipalem,Narasaraopet,Andhra Pradesh',
'Jalalapalem,Narasaraopet,Andhra Pradesh',
'Jangalapalle,Narasaraopet,Andhra Pradesh',
'Kandrika,Narasaraopet,Andhra Pradesh',
'Kanumalacheruvu,Narasaraopet,Andhra Pradesh',
'Kondramutla,Narasaraopet,Andhra Pradesh',
'Koppukonda,Narasaraopet,Andhra Pradesh',
'Kotcherla,Narasaraopet,Andhra Pradesh',
'Kothapet(VKD),Narasaraopet,Andhra Pradesh',
'Lingamukkapalle,Narasaraopet,Andhra Pradesh',
'Mukkellapadu,Narasaraopet,Andhra Pradesh',
'Muppalla(VKD),Narasaraopet,Andhra Pradesh',
'Murthuzapuram,Narasaraopet,Andhra Pradesh',
'Nadigadda,Narasaraopet,Andhra Pradesh',
'Nagireddipalle,Narasaraopet,Andhra Pradesh',
'Nagulavaram,Narasaraopet,Andhra Pradesh',
'Naidupalem,Narasaraopet,Andhra Pradesh',
'Nirmalanagar,Narasaraopet,Andhra Pradesh',
'NSP Colony,Narasaraopet,Andhra Pradesh',
'Pedakancherla,Narasaraopet,Andhra Pradesh',
'Perurupadu,Narasaraopet,Andhra Pradesh',
'Pittambanda,Narasaraopet,Andhra Pradesh',
'Sivapuram,Narasaraopet,Andhra Pradesh',
'Tellabadu,Narasaraopet,Andhra Pradesh',
'Thimmayapalem,Narasaraopet,Andhra Pradesh',
'Vaddemgunta,Narasaraopet,Andhra Pradesh',
'Vellatur,Narasaraopet,Andhra Pradesh',
'Vinukonda,Narasaraopet,Andhra Pradesh',
'Vupparapalem,Narasaraopet,Andhra Pradesh',
'Jntu Kukat Pally,Secunderabad,Andhra Pradesh',
'New Maruthi Nagar,Hyderabad South East,Andhra Pradesh',
'Erragadda,Hyderabad City,Andhra Pradesh',
'Sanath Nagar Colony,Hyderabad City,Andhra Pradesh',
'Sanjeev Reddy Nagar,Hyderabad City,Andhra Pradesh',
'Dhoolpet,Hyderabad City,Andhra Pradesh',
'Dattatreya Colony,Hyderabad City,Andhra Pradesh',
'Humayunnagar,Hyderabad City,Andhra Pradesh',
'Karwan Sahu,Hyderabad City,Andhra Pradesh',
'Kulsumpura,Hyderabad City,Andhra Pradesh',
'Mangalhat,Hyderabad City,Andhra Pradesh',
'Murad Nagar,Hyderabad City,Andhra Pradesh',
'Shantinagar,Hyderabad City,Andhra Pradesh',
'Vijay Nagar Colony,Hyderabad City,Andhra Pradesh',
'Bharat Nagar Colony,Hyderabad City,Andhra Pradesh',
'Fathenagar Colony,Hyderabad City,Andhra Pradesh',
'Moosapet,Hyderabad City,Andhra Pradesh',
'Sanathnagar I E,Hyderabad City,Andhra Pradesh',
'Swarajyanagar,Hyderabad City,Andhra Pradesh',
'Dargah Hussain Shahwali,Hyderabad City,Andhra Pradesh',
'Golconda,Hyderabad City,Andhra Pradesh',
'Hyder Shah Kote,Hyderabad City,Andhra Pradesh',
'Ibrahim Bagh Lines,Hyderabad City,Andhra Pradesh',
'Kakatiya Nagar,Hyderabad City,Andhra Pradesh',
'Lunger House,Hyderabad City,Andhra Pradesh',
'Nanakramguda,Hyderabad City,Andhra Pradesh',
'Sakkubai Nagar,Hyderabad City,Andhra Pradesh',
'Toli Chowki,Hyderabad City,Andhra Pradesh',
'Gagan Mahal,Hyderabad City,Andhra Pradesh',
'Himayathnagar,Hyderabad City,Andhra Pradesh',
'LIC Division,Hyderabad City,Andhra Pradesh',
'Narayanguda,Hyderabad City,Andhra Pradesh',
'New Mla Quarters,Hyderabad City,Andhra Pradesh',
'Old Mla Quarters,Hyderabad City,Andhra Pradesh',
'Parishram Bhawan,Hyderabad City,Andhra Pradesh',
'Ramakrishna Mutt,Hyderabad City,Andhra Pradesh',
'Administrative Buildings,Secunderabad,Andhra Pradesh',
'Aliabad,Secunderabad,Andhra Pradesh',
'Anantagiri,Secunderabad,Andhra Pradesh',
'Anantaram,Secunderabad,Andhra Pradesh',
'Ankireddipalli,Secunderabad,Andhra Pradesh',
'Ankushapur,Secunderabad,Andhra Pradesh',
'Annajiguda,Secunderabad,Andhra Pradesh',
'Aphb Colony Moulali,Secunderabad,Andhra Pradesh',
'Ashoknagar,Secunderabad,Andhra Pradesh',
'Atvelli,Secunderabad,Andhra Pradesh',
'Begumpet Policelines,Secunderabad,Andhra Pradesh',
'Bholakpur,Secunderabad,Andhra Pradesh',
'Bogaram,Secunderabad,Andhra Pradesh',
'Cherial,Secunderabad,Andhra Pradesh',
'Cherlapalli,Secunderabad,Andhra Pradesh',
'Dabirpur,Secunderabad,Andhra Pradesh',
'Dr As Rao Nagar,Secunderabad,Andhra Pradesh',
'Gajularamaram,Secunderabad,Andhra Pradesh',
'Ghatkesar,Secunderabad,Andhra Pradesh',
'Girmapur,Secunderabad,Andhra Pradesh',
'Golconda Chowrastha,Secunderabad,Andhra Pradesh',
'Gowdavalli,Secunderabad,Andhra Pradesh',
'Hanumanpet,Secunderabad,Andhra Pradesh',
'Himmatnagar,Secunderabad,Andhra Pradesh',
'Hyd Airport II,Secunderabad,Andhra Pradesh',
'Hyd Airport I,Secunderabad,Andhra Pradesh',
'Hyderabad Jubilee H.O,Hyderabad South East,Andhra Pradesh',
'Ie Moulali,Secunderabad,Andhra Pradesh',
'IICT,Secunderabad,Andhra Pradesh',
'Jaggamguda,Secunderabad,Andhra Pradesh',
'Jama I Osmania,Secunderabad,Andhra Pradesh',
'Jeedimetla,Secunderabad,Andhra Pradesh',
'Katchvanisingaram,Secunderabad,Andhra Pradesh',
'Keesara,Secunderabad,Andhra Pradesh',
'Keesaragutta,Secunderabad,Andhra Pradesh',
'Khapra,Secunderabad,Andhra Pradesh',
'Kingsway,Secunderabad,Andhra Pradesh',
'Kolthur,Secunderabad,Andhra Pradesh',
'Korremal,Secunderabad,Andhra Pradesh',
'Kushaiguda,Secunderabad,Andhra Pradesh',
'Kutbullapur,Secunderabad,Andhra Pradesh',
'Kyasaram,Secunderabad,Andhra Pradesh',
'Lalgadi Malakpet,Secunderabad,Andhra Pradesh',
'Lallaguda,Secunderabad,Andhra Pradesh',
'Lallapet,Secunderabad,Andhra Pradesh',
'MG Road,Secunderabad,Andhra Pradesh',
'Moulali,Secunderabad,Andhra Pradesh',
'Mudchintanapalli,Secunderabad,Andhra Pradesh',
'Musheerabad DSO,Secunderabad,Andhra Pradesh',
'Musheerabad NDSO,Secunderabad,Andhra Pradesh',
'Napier Lines,Secunderabad,Andhra Pradesh',
'Nehrunagar,Secunderabad,Andhra Pradesh',
'Ngri,Secunderabad,Andhra Pradesh',
'Nutankal,Secunderabad,Andhra Pradesh',
'Padmaraonagar,Secunderabad,Andhra Pradesh',
'Pedalaxmapur,Secunderabad,Andhra Pradesh',
'Picket,Secunderabad,Andhra Pradesh',
'Pragatinagar,Secunderabad,Andhra Pradesh',
'Prakashamnagar,Secunderabad,Andhra Pradesh',
'Pratapsingaram,Secunderabad,Andhra Pradesh',
'Rail Nilayam,Secunderabad,Andhra Pradesh',
'Rajbolaram,Secunderabad,Andhra Pradesh',
'Rampallidiara,Secunderabad,Andhra Pradesh',
'Ravalkol,Secunderabad,Andhra Pradesh',
'Rompalli,Secunderabad,Andhra Pradesh',
'Sainagar,Secunderabad,Andhra Pradesh',
'Sitaphalmandi,Secunderabad,Andhra Pradesh',
'Suraram,Secunderabad,Andhra Pradesh',
'Tarnaka,Secunderabad,Andhra Pradesh',
'Thimmaipalli,Secunderabad,Andhra Pradesh',
'Thumkunta,Secunderabad,Andhra Pradesh',
'Turkapalliyadaram,Secunderabad,Andhra Pradesh',
'Vikarabad H.O,Secunderabad,Andhra Pradesh',
'Yadgarpalli,Secunderabad,Andhra Pradesh',
'Zamistanpur,Secunderabad,Andhra Pradesh',
'A.G.College,Hyderabad South East,Andhra Pradesh',
'Afzalgunj,Hyderabad South East,Andhra Pradesh',
'Ambernagar,Hyderabad South East,Andhra Pradesh',
'Amberpet,Hyderabad South East,Andhra Pradesh',
'Andhra Mahila Sabha,Hyderabad South East,Andhra Pradesh',
'Aperl,Hyderabad South East,Andhra Pradesh',
'Attapur,Hyderabad South East,Andhra Pradesh',
'Badangpet,Hyderabad South East,Andhra Pradesh',
'Bahadurpura,Hyderabad South East,Andhra Pradesh',
'Balapur,Hyderabad South East,Andhra Pradesh',
'Barkatpura,Hyderabad South East,Andhra Pradesh',
'Begumbazar,Hyderabad South East,Andhra Pradesh',
'Begumpet,Secunderabad,Andhra Pradesh',
'Begumpet,Secunderabad,Andhra Pradesh',
'Boduppal,Hyderabad South East,Andhra Pradesh',
'Central Police Lines,Hyderabad South East,Andhra Pradesh',
'Chanchalguda,Hyderabad South East,Andhra Pradesh',
'Chandulalbaradari,Hyderabad South East,Andhra Pradesh',
'Crp Camp,Hyderabad South East,Andhra Pradesh',
'Darushifa,Hyderabad South East,Andhra Pradesh',
'Dilsukhnagar Colony,Hyderabad South East,Andhra Pradesh',
'Ecil,Secunderabad,Andhra Pradesh',
'Falaknuma,Hyderabad South East,Andhra Pradesh',
'Fatehdarwaza,Hyderabad South East,Andhra Pradesh',
'Gandhinagar,Secunderabad,Andhra Pradesh',
'Gandhinagar,Secunderabad,Andhra Pradesh',
'Gsi(Sr) Bandlaguda,Hyderabad South East,Andhra Pradesh',
'Hasannagar,Hyderabad South East,Andhra Pradesh',
'High Court,Hyderabad South East,Andhra Pradesh',
'Hindustan Cables Ltd,Hyderabad South East,Andhra Pradesh',
'Huda Residential Complex,Hyderabad South East,Andhra Pradesh',
'Hussainialam,Hyderabad South East,Andhra Pradesh',
'Hyderabad G.P.O.,Hyderabad Gpo,Andhra Pradesh',
'Hyderabad Public School,Hyderabad South East,Andhra Pradesh',
'Hyderguda,Hyderabad South East,Andhra Pradesh',
'I.E.Nacharam,Hyderabad South East,Andhra Pradesh',
'Jillellaguda,Hyderabad South East,Andhra Pradesh',
'Kanchanbagh,Hyderabad South East,Andhra Pradesh',
'Karmanghat,Hyderabad South East,Andhra Pradesh',
'Kattedan Ie,Hyderabad South East,Andhra Pradesh',
'Keshogiri,Hyderabad South East,Andhra Pradesh',
'Kishanbagh,Hyderabad South East,Andhra Pradesh',
'Kismathpur,Hyderabad South East,Andhra Pradesh',
'L B Nagar,Hyderabad South East,Andhra Pradesh',
'Malakpet Colony,Hyderabad South East,Andhra Pradesh',
'Mallapur,Hyderabad South East,Andhra Pradesh',
'Mamidipalli,Hyderabad South East,Andhra Pradesh',
'Mansoorabad,Hyderabad South East,Andhra Pradesh',
'Moghalpura,Hyderabad South East,Andhra Pradesh',
'Nallakunta,Hyderabad South East,Andhra Pradesh',
'New Nallakunta,Hyderabad South East,Andhra Pradesh',
'Nimboliadda,Hyderabad South East,Andhra Pradesh',
'Old Malakpet,Hyderabad South East,Andhra Pradesh',
'Osmania General Hospital,Hyderabad South East,Andhra Pradesh',
'Osmannagar,Hyderabad South East,Andhra Pradesh',
'P & T Colony,Hyderabad South East,Andhra Pradesh',
'Pahadishareef,Hyderabad South East,Andhra Pradesh',
'Peerzadiguda,Hyderabad South East,Andhra Pradesh',
'Quazipura,Hyderabad South East,Andhra Pradesh',
'Rajendranagar,Hyderabad South East,Andhra Pradesh',
'Ramakrishanapuram,Hyderabad South East,Andhra Pradesh',
'Rangareddy Dt Courts,Hyderabad South East,Andhra Pradesh',
'Reinbazar,Hyderabad South East,Andhra Pradesh',
'Sahifa,Hyderabad South East,Andhra Pradesh',
'Saidabad Colony,Hyderabad South East,Andhra Pradesh',
'Saidabad,Hyderabad South East,Andhra Pradesh',
'Santoshnagar Colony,Hyderabad South East,Andhra Pradesh',
'Saroornagar,Hyderabad South East,Andhra Pradesh',
'Secunderabad H.O,Secunderabad,Andhra Pradesh',
'Seminary,Hyderabad South East,Andhra Pradesh',
'Shahalibanda,Hyderabad South East,Andhra Pradesh',
'Shivarampalli,Hyderabad South East,Andhra Pradesh',
'Snehapuri Colony,Hyderabad South East,Andhra Pradesh',
'Srinivasapuram,Hyderabad South East,Andhra Pradesh',
'Sripuram Colony,Hyderabad South East,Andhra Pradesh',
'Stn Kachiguda H.O,Hyderabad South East,Andhra Pradesh',
'Sultanshahi,Hyderabad South East,Andhra Pradesh',
'Survey Of India,Hyderabad South East,Andhra Pradesh',
'Svpnpa,Hyderabad South East,Andhra Pradesh',
'Tadbun,Hyderabad South East,Andhra Pradesh',
'Tagarikanaka,Hyderabad South East,Andhra Pradesh',
'Uppal,Hyderabad South East,Andhra Pradesh',
'Uppuguda,Hyderabad South East,Andhra Pradesh',
'Vaidehinagar,Hyderabad South East,Andhra Pradesh',
'Vaishalinagar,Hyderabad South East,Andhra Pradesh',
'Vanastalipuram,Hyderabad South East,Andhra Pradesh',
'Vidyanagar,Hyderabad South East,Andhra Pradesh',
'Yakutpura,Hyderabad South East,Andhra Pradesh',
'Zindatelismath,Hyderabad South East,Andhra Pradesh',
'R.C.Imarat,Hyderabad South East,Andhra Pradesh',
'A.Gs Office,Hyderabad City,Andhra Pradesh',
'A.Gs. Staff Quarters,Hyderabad City,Andhra Pradesh',
'Anandnagar,Hyderabad City,Andhra Pradesh',
'Banjara Hills,Hyderabad City,Andhra Pradesh',
'Bazarghat,Hyderabad City,Andhra Pradesh',
'Central Secretariat,Hyderabad City,Andhra Pradesh',
'I.M.Colony,Hyderabad City,Andhra Pradesh',
'Khairatabad H.O,Hyderabad City,Andhra Pradesh',
'Padmavathi Nagar,Hyderabad City,Andhra Pradesh',
'Rahmath Nagar,Hyderabad City,Andhra Pradesh',
'Raj Bhawan,Hyderabad City,Andhra Pradesh',
'Shyam Nagar,Hyderabad City,Andhra Pradesh',
'Srinagar Colony,Hyderabad City,Andhra Pradesh',
'Vengal Rao Nagar,Hyderabad City,Andhra Pradesh',
'Yousufguda,Hyderabad City,Andhra Pradesh',
'Gandhi Bhawan,Hyderabad City,Andhra Pradesh',
'Hindi Bhawan,Hyderabad City,Andhra Pradesh',
'Moazzampura,Hyderabad City,Andhra Pradesh',
'Putlibowli,Hyderabad City,Andhra Pradesh',
'Ramkoti,Hyderabad City,Andhra Pradesh',
'Seetharampet,Hyderabad City,Andhra Pradesh',
'Somajiguda,Hyderabad City,Andhra Pradesh',
'State Bank Of Hyderabad,Hyderabad City,Andhra Pradesh',
'State Bank Of India,Hyderabad City,Andhra Pradesh',
'Vidhan Sabha,Hyderabad City,Andhra Pradesh',
'Lallaguda,Secunderabad,Andhra Pradesh',
'Cyberabad,Hyderabad City,Andhra Pradesh',
'Jubilee Hills,Hyderabad City,Andhra Pradesh',
'Madhapur,Hyderabad City,Andhra Pradesh',
'South Banjara Hills,Hyderabad City,Andhra Pradesh',
'Ghatepalli,Secunderabad,Andhra Pradesh',
'Haridasapalli,Secunderabad,Andhra Pradesh',
'Karvelli,Secunderabad,Andhra Pradesh',
'Kotmarpalli,Secunderabad,Andhra Pradesh',
'Kukonda,Secunderabad,Andhra Pradesh',
'Mominkalan,Secunderabad,Andhra Pradesh',
'Nagawaram,Secunderabad,Andhra Pradesh',
'Pudur,Secunderabad,Andhra Pradesh',
'Rasnam,Secunderabad,Andhra Pradesh',
'Tarigopula,Secunderabad,Andhra Pradesh',
'Basheerabad,Secunderabad,Andhra Pradesh',
'Aziz Nagar,Hyderabad City,Andhra Pradesh',
'C.B.I.T,Hyderabad City,Andhra Pradesh',
'Himayathnagar,Hyderabad City,Andhra Pradesh',
'Bantwaram,Secunderabad,Andhra Pradesh',
'Appa Himayathsagar,Hyderabad City,Andhra Pradesh',
'Gandipet,Hyderabad City,Andhra Pradesh',
'Kokapet,Hyderabad City,Andhra Pradesh',
'Mancherevula,Hyderabad City,Andhra Pradesh',
'Narsingi,Hyderabad City,Andhra Pradesh',
'Wattinagulapalli,Hyderabad City,Andhra Pradesh',
'Puppalguda,Hyderabad City,Andhra Pradesh',
'Adibatla,Hyderabad South East,Andhra Pradesh',
'Agapalli,Hyderabad South East,Andhra Pradesh',
'Airforce Academy,Secunderabad,Andhra Pradesh',
'Akulamailaram,Hyderabad South East,Andhra Pradesh',
'Allembylines,Secunderabad,Andhra Pradesh',
'Anajpur,Hyderabad South East,Andhra Pradesh',
'Arutla,Hyderabad South East,Andhra Pradesh',
'Bandaraviryal,Hyderabad South East,Andhra Pradesh',
'Batasingaram,Hyderabad South East,Andhra Pradesh',
'Cherlapatel Guda,Hyderabad South East,Andhra Pradesh',
'Chinnagolkonda,Hyderabad South East,Andhra Pradesh',
'Chintapatla,Hyderabad South East,Andhra Pradesh',
'Chippalapalli,Hyderabad South East,Andhra Pradesh',
'Chowderpalli,Hyderabad South East,Andhra Pradesh',
'Dabbedguda,Hyderabad South East,Andhra Pradesh',
'Dandumailaram,Hyderabad South East,Andhra Pradesh',
'Eleminedu,Hyderabad South East,Andhra Pradesh',
'Gaganpahad,Hyderabad South East,Andhra Pradesh',
'Gollapalli Kalan,Hyderabad South East,Andhra Pradesh',
'Gowrelli,Hyderabad South East,Andhra Pradesh',
'Gudur,Hyderabad South East,Andhra Pradesh',
'Gummadavalli,Hyderabad South East,Andhra Pradesh',
'Gungal,Hyderabad South East,Andhra Pradesh',
'Hayatnagar,Hyderabad South East,Andhra Pradesh',
'Ibrahimpatnam,Hyderabad South East,Andhra Pradesh',
'Jaitwaram,Hyderabad South East,Andhra Pradesh',
'Japal,Hyderabad South East,Andhra Pradesh',
'Kandukur,Hyderabad South East,Andhra Pradesh',
'Kappapahad,Hyderabad South East,Andhra Pradesh',
'Kavadpalli,Hyderabad South East,Andhra Pradesh',
'Koheda,Hyderabad South East,Andhra Pradesh',
'Kongarakalan,Hyderabad South East,Andhra Pradesh',
'Kongaraviryla,Hyderabad South East,Andhra Pradesh',
'Kothapalli,Hyderabad South East,Andhra Pradesh',
'Kotwalguda,Hyderabad South East,Andhra Pradesh',
'Kuntloor,Hyderabad South East,Andhra Pradesh',
'Kurmidda,Hyderabad South East,Andhra Pradesh',
'Lemur,Hyderabad South East,Andhra Pradesh',
'Lingampalli,Hyderabad South East,Andhra Pradesh',
'Madhapur,Hyderabad South East,Andhra Pradesh',
'Maisaram,Hyderabad South East,Andhra Pradesh',
'Manchal,Hyderabad South East,Andhra Pradesh',
'Mangalpalli,Hyderabad South East,Andhra Pradesh',
'Mankhal,Hyderabad South East,Andhra Pradesh',
'Manthangowd Gowrelli,Hyderabad South East,Andhra Pradesh',
'Medipalli,Hyderabad South East,Andhra Pradesh',
'Meerkhanpet,Hyderabad South East,Andhra Pradesh',
'Mondigowrelli,Hyderabad South East,Andhra Pradesh',
'Nadergul,Hyderabad South East,Andhra Pradesh',
'Nagaram,Hyderabad South East,Andhra Pradesh',
'Nallavalli,Hyderabad South East,Andhra Pradesh',
'Nanajipur,Hyderabad South East,Andhra Pradesh',
'Nandiwanaparthy,Hyderabad South East,Andhra Pradesh',
'Narkhoda,Hyderabad South East,Andhra Pradesh',
'Nazdiksingaram,Hyderabad South East,Andhra Pradesh',
'Nedunur,Hyderabad South East,Andhra Pradesh',
'Pasmamala,Hyderabad South East,Andhra Pradesh',
'Pedda Amberpet,Hyderabad South East,Andhra Pradesh',
'Pocharam,Hyderabad South East,Andhra Pradesh',
'Polkampalli,Hyderabad South East,Andhra Pradesh',
'Pulmamidi,Hyderabad South East,Andhra Pradesh',
'Qutubullapur,Hyderabad South East,Andhra Pradesh',
'Rachaloor,Hyderabad South East,Andhra Pradesh',
'Ragannaguda X Roads,Hyderabad South East,Andhra Pradesh',
'Raipole,Hyderabad South East,Andhra Pradesh',
'Ramdaspalli,Hyderabad South East,Andhra Pradesh',
'Ramoji Film City,Hyderabad South East,Andhra Pradesh',
'Rangapur,Hyderabad South East,Andhra Pradesh',
'Sanghinagar,Hyderabad South East,Andhra Pradesh',
'Seriguda,Hyderabad South East,Andhra Pradesh',
'Shamshabad,Hyderabad South East,Andhra Pradesh',
'Tadlapalliguda,Hyderabad South East,Andhra Pradesh',
'Taramatipeta,Hyderabad South East,Andhra Pradesh',
'Tatiparthy,Hyderabad South East,Andhra Pradesh',
'Thimmapur,Hyderabad South East,Andhra Pradesh',
'Toolkalan,Hyderabad South East,Andhra Pradesh',
'Toolkhurd,Hyderabad South East,Andhra Pradesh',
'Torrur,Hyderabad South East,Andhra Pradesh',
'Trimulgherry H.O,Secunderabad,Andhra Pradesh',
'Tummalur,Hyderabad South East,Andhra Pradesh',
'Turkayamzal,Hyderabad South East,Andhra Pradesh',
'Vinjapur,Hyderabad South East,Andhra Pradesh',
'Yacharam,Hyderabad South East,Andhra Pradesh',
'Adikcherla,Secunderabad,Andhra Pradesh',
'Adraspalli,Secunderabad,Andhra Pradesh',
'Agnoor,Secunderabad,Andhra Pradesh',
'Ainapur,Secunderabad,Andhra Pradesh',
'Alampally,Secunderabad,Andhra Pradesh',
'Allapur,Secunderabad,Andhra Pradesh',
'Alur,Secunderabad,Andhra Pradesh',
'Alwal,Secunderabad,Andhra Pradesh',
'Amdapur,Secunderabad,Andhra Pradesh',
'Amradikalan,Secunderabad,Andhra Pradesh',
'Anandbagh,Secunderabad,Andhra Pradesh',
'Anantagiripally,Secunderabad,Andhra Pradesh',
'Ananthagiri,Secunderabad,Andhra Pradesh',
'Antaram,Secunderabad,Andhra Pradesh',
'Antharam,Secunderabad,Andhra Pradesh',
'Aoc Records,Secunderabad,Andhra Pradesh',
'Atveli,Secunderabad,Andhra Pradesh',
'Badampalli,Secunderabad,Andhra Pradesh',
'Balanagar Township,Secunderabad,Andhra Pradesh',
'Bandelkacherla,Secunderabad,Andhra Pradesh',
'Barwad,Secunderabad,Andhra Pradesh',
'Bhulkapur,Secunderabad,Andhra Pradesh',
'Bolarum Bazar,Secunderabad,Andhra Pradesh',
'Bolarum,Secunderabad,Andhra Pradesh',
'Bompalli,Secunderabad,Andhra Pradesh',
'Bompalli,Secunderabad,Andhra Pradesh',
'Bomraspet,Secunderabad,Andhra Pradesh',
'Bowenpally,Secunderabad,Andhra Pradesh',
'Bowrampet,Secunderabad,Andhra Pradesh',
'Buchampalli,Secunderabad,Andhra Pradesh',
'CCI Tandur,Secunderabad,Andhra Pradesh',
'Chanchalpet,Secunderabad,Andhra Pradesh',
'Chandanagar,Secunderabad,Andhra Pradesh',
'Chandanvelly,Secunderabad,Andhra Pradesh',
'Chengole,Secunderabad,Andhra Pradesh',
'Chengomal,Secunderabad,Andhra Pradesh',
'Chennaram,Secunderabad,Andhra Pradesh',
'Chenvelli,Secunderabad,Andhra Pradesh',
'Chevella,Secunderabad,Andhra Pradesh',
'Chilkur,Secunderabad,Andhra Pradesh',
'Chimaldari,Secunderabad,Andhra Pradesh',
'Chinna Mangalaram,Secunderabad,Andhra Pradesh',
'Chinnagottiga,Secunderabad,Andhra Pradesh',
'Chittigadda,Secunderabad,Andhra Pradesh',
'Chityal,Secunderabad,Andhra Pradesh',
'CIE Balangar,Secunderabad,Andhra Pradesh',
'Damarched,Secunderabad,Andhra Pradesh',
'Damargidda,Secunderabad,Andhra Pradesh',
'Devarampalli,Secunderabad,Andhra Pradesh',
'Deveryamjal,Secunderabad,Andhra Pradesh',
'Devnoor,Secunderabad,Andhra Pradesh',
'Devuniyerravalli,Secunderabad,Andhra Pradesh',
'Dhannaram,Secunderabad,Andhra Pradesh',
'Dharur,Secunderabad,Andhra Pradesh',
'Dhobhipet,Secunderabad,Andhra Pradesh',
'Dindigul,Secunderabad,Andhra Pradesh',
'Dirsampalli,Secunderabad,Andhra Pradesh',
'Doma,Secunderabad,Andhra Pradesh',
'Doolapalli,Secunderabad,Andhra Pradesh',
'Ekmamidi,Secunderabad,Andhra Pradesh',
'EME Records,Secunderabad,Andhra Pradesh',
'Enkatala,Secunderabad,Andhra Pradesh',
'Ethiraspalli,Secunderabad,Andhra Pradesh',
'Gagillapur,Secunderabad,Andhra Pradesh',
'Gazipur,Secunderabad,Andhra Pradesh',
'Gharsinghapur,Secunderabad,Andhra Pradesh',
'Gingurthi,Secunderabad,Andhra Pradesh',
'Godamguda,Secunderabad,Andhra Pradesh',
'Gottimukkala,Secunderabad,Andhra Pradesh',
'Gundal,Secunderabad,Andhra Pradesh',
'Gunj,Secunderabad,Andhra Pradesh',
'Haiglines,Secunderabad,Andhra Pradesh',
'Hakimpet,Secunderabad,Andhra Pradesh',
'Hal,Secunderabad,Andhra Pradesh',
'HMT Township,Secunderabad,Andhra Pradesh',
'IDA Jeedimetla,Secunderabad,Andhra Pradesh',
'Indur,Secunderabad,Andhra Pradesh',
'Jaidupalli,Secunderabad,Andhra Pradesh',
'Jangaon,Secunderabad,Andhra Pradesh',
'Jeevangi,Secunderabad,Andhra Pradesh',
'JJ Nagar Colony,Secunderabad,Andhra Pradesh',
'Juntapalli,Secunderabad,Andhra Pradesh',
'Kadcherla,Secunderabad,Andhra Pradesh',
'Kalkhoda,Secunderabad,Andhra Pradesh',
'Kanakamamidi,Secunderabad,Andhra Pradesh',
'Kandanhalli,Secunderabad,Andhra Pradesh',
'Kandlapalli,Secunderabad,Andhra Pradesh',
'Kandwada,Secunderabad,Andhra Pradesh',
'Kankal,Secunderabad,Andhra Pradesh',
'Kanmeta,Secunderabad,Andhra Pradesh',
'Karankot,Secunderabad,Andhra Pradesh',
'Kasimpur,Secunderabad,Andhra Pradesh',
'Kesaram,Secunderabad,Andhra Pradesh',
'Kethireddipalli,Secunderabad,Andhra Pradesh',
'Kistapur,Secunderabad,Andhra Pradesh',
'Kodalkal,Secunderabad,Andhra Pradesh',
'Kokat,Secunderabad,Andhra Pradesh',
'Kolkonda,Secunderabad,Andhra Pradesh',
'Kompally,Secunderabad,Andhra Pradesh',
'Kothagdi,Secunderabad,Andhra Pradesh',
'Kothapalli,Secunderabad,Andhra Pradesh',
'Kothapalli,Secunderabad,Andhra Pradesh',
'Kothlapur,Secunderabad,Andhra Pradesh',
'Kotpalli,Secunderabad,Andhra Pradesh',
'Kowkunta,Secunderabad,Andhra Pradesh',
'KPHB Colony,Secunderabad,Andhra Pradesh',
'Kudmoor,Secunderabad,Andhra Pradesh',
'Kudvandapur,Secunderabad,Andhra Pradesh',
'Kukatpally,Secunderabad,Andhra Pradesh',
'Kurviched,Secunderabad,Andhra Pradesh',
'Madanapalli,Secunderabad,Andhra Pradesh',
'Madireddipalli,Secunderabad,Andhra Pradesh',
'Maharajpet,Secunderabad,Andhra Pradesh',
'Mahidpur Lines,Secunderabad,Andhra Pradesh',
'Mailwar,Secunderabad,Andhra Pradesh',
'Malasomaram,Secunderabad,Andhra Pradesh',
'Malkajgiri,Secunderabad,Andhra Pradesh',
'Malkapur,Secunderabad,Andhra Pradesh',
'Malkapur,Secunderabad,Andhra Pradesh',
'Malwardevrampalli,Secunderabad,Andhra Pradesh',
'Manchanpalli,Secunderabad,Andhra Pradesh',
'Manneguda,Secunderabad,Andhra Pradesh',
'Manovikasnagar,Secunderabad,Andhra Pradesh',
'Manthangod,Secunderabad,Andhra Pradesh',
'Manthatti,Secunderabad,Andhra Pradesh',
'Marpallikalan,Secunderabad,Andhra Pradesh',
'Medchal,Secunderabad,Andhra Pradesh',
'Medipalli,Secunderabad,Andhra Pradesh',
'Medpalli,Secunderabad,Andhra Pradesh',
'Mekavanampalli,Secunderabad,Andhra Pradesh',
'Military College EME,Secunderabad,Andhra Pradesh',
'Mittabaspalle,Secunderabad,Andhra Pradesh',
'Mittakorud,Secunderabad,Andhra Pradesh',
'Miyapur,Secunderabad,Andhra Pradesh',
'Moinabad,Secunderabad,Andhra Pradesh',
'Mokila,Secunderabad,Andhra Pradesh',
'Mombapur,Secunderabad,Andhra Pradesh',
'Mominpet,Secunderabad,Andhra Pradesh',
'Morangpalli,Secunderabad,Andhra Pradesh',
'Mothukapalli,Secunderabad,Andhra Pradesh',
'Mubarakpur,Secunderabad,Andhra Pradesh',
'Mudgul Chittempalle,Secunderabad,Andhra Pradesh',
'Mudimial,Secunderabad,Andhra Pradesh',
'Mujahidpur,Secunderabad,Andhra Pradesh',
'Munnur Somaram,Secunderabad,Andhra Pradesh',
'Nagaram,Secunderabad,Andhra Pradesh',
'Nagasamunder,Secunderabad,Andhra Pradesh',
'Nagulapalli,Secunderabad,Andhra Pradesh',
'Narayanpur,Secunderabad,Andhra Pradesh',
'Naskal,Secunderabad,Andhra Pradesh',
'Navalga,Secunderabad,Andhra Pradesh',
'Nawabpet,Secunderabad,Andhra Pradesh',
'Neredmet,Secunderabad,Andhra Pradesh',
'Nisa Hakimpet,Secunderabad,Andhra Pradesh',
'Nizampet Medpalli,Secunderabad,Andhra Pradesh',
'Nyalata,Secunderabad,Andhra Pradesh',
'Orella,Secunderabad,Andhra Pradesh',
'Pagdyal,Secunderabad,Andhra Pradesh',
'Pamena,Secunderabad,Andhra Pradesh',
'Panchalingal,Secunderabad,Andhra Pradesh',
'Parveda,Secunderabad,Andhra Pradesh',
'Patloor,Secunderabad,Andhra Pradesh',
'Peda Umenthyal,Secunderabad,Andhra Pradesh',
'Pedda Mangalaram,Secunderabad,Andhra Pradesh',
'Peddimal,Secunderabad,Andhra Pradesh',
'Peta Madaram,Secunderabad,Andhra Pradesh',
'Phulmaddi,Secunderabad,Andhra Pradesh',
'Pochampally,Secunderabad,Andhra Pradesh',
'Ponnal,Secunderabad,Andhra Pradesh',
'Poruru,Secunderabad,Andhra Pradesh',
'Proddatur,Secunderabad,Andhra Pradesh',
'Pulapalli,Secunderabad,Andhra Pradesh',
'Pulmamidi,Secunderabad,Andhra Pradesh',
'Pulusmamidi,Secunderabad,Andhra Pradesh',
'Purgi,Secunderabad,Andhra Pradesh',
'Ramakrishna Puram,Secunderabad,Andhra Pradesh',
'Ramanathgudpally,Secunderabad,Andhra Pradesh',
'Ramapur,Secunderabad,Andhra Pradesh',
'Rangareddynagar,Secunderabad,Andhra Pradesh',
'Ravulapalli,Secunderabad,Andhra Pradesh',
'Regad Ghanapur,Secunderabad,Andhra Pradesh',
'Regondi,Secunderabad,Andhra Pradesh',
'Riapol,Secunderabad,Andhra Pradesh',
'Rompalli,Secunderabad,Andhra Pradesh',
'Rupkhanpet,Secunderabad,Andhra Pradesh',
'Sainikpuri,Secunderabad,Andhra Pradesh',
'Salbathapur,Secunderabad,Andhra Pradesh',
'Sangamkalan,Secunderabad,Andhra Pradesh',
'Shamirpet,Secunderabad,Andhra Pradesh',
'Shankarpalli,Secunderabad,Andhra Pradesh',
'Siddaloor,Secunderabad,Andhra Pradesh',
'Singapur,Secunderabad,Andhra Pradesh',
'Sirpura,Secunderabad,Andhra Pradesh',
'Sivareddipalli,Secunderabad,Andhra Pradesh',
'Sivareddypet,Secunderabad,Andhra Pradesh',
'Somangurthi,Secunderabad,Andhra Pradesh',
'Srirangavaram,Secunderabad,Andhra Pradesh',
'Sultanpur,Secunderabad,Andhra Pradesh',
'Surangal,Secunderabad,Andhra Pradesh',
'Syedpalli,Secunderabad,Andhra Pradesh',
'Tandur,Secunderabad,Andhra Pradesh',
'Tangadpalli,Secunderabad,Andhra Pradesh',
'Tangutoor,Secunderabad,Andhra Pradesh',
'Tekulapalli,Secunderabad,Andhra Pradesh',
'Thattepalli,Secunderabad,Andhra Pradesh',
'Thummalapalli,Secunderabad,Andhra Pradesh',
'Timmaipalli,Secunderabad,Andhra Pradesh',
'Turmamidi,Secunderabad,Andhra Pradesh',
'Velchal,Secunderabad,Andhra Pradesh',
'Venkatapur,Secunderabad,Andhra Pradesh',
'Vikasnagar,Secunderabad,Andhra Pradesh',
'Wootpalli,Secunderabad,Andhra Pradesh',
'Yakmai,Secunderabad,Andhra Pradesh',
'Yalal,Secunderabad,Andhra Pradesh',
'Yellakonda,Secunderabad,Andhra Pradesh',
'Yelvawthy,Secunderabad,Andhra Pradesh',
'Yenkepalle,Secunderabad,Andhra Pradesh',
'Yennaram,Secunderabad,Andhra Pradesh',
'Bennur,Secunderabad,Andhra Pradesh',
'Gachibowli,Hyderabad City,Andhra Pradesh',
'Kothaguda,Hyderabad City,Andhra Pradesh',
'Lingampalli,Hyderabad City,Andhra Pradesh',
'CUC,Hyderabad City,Andhra Pradesh',
'Kondapur,Hyderabad City,Andhra Pradesh',
'Janwada,Hyderabad City,Andhra Pradesh',
'Ambaripet,Karimnagar,Andhra Pradesh',
'Atmakur,Karimnagar,Andhra Pradesh',
'Baswapur,Karimnagar,Andhra Pradesh',
'Beerpur,Karimnagar,Andhra Pradesh',
'Gandhinagar,Karimnagar,Andhra Pradesh',
'Godhalpet,Karimnagar,Andhra Pradesh',
'Gullakota,Karimnagar,Andhra Pradesh',
'Jagadevpet,Karimnagar,Andhra Pradesh',
'Kandlapalli,Karimnagar,Andhra Pradesh',
'Kapparaopet,Karimnagar,Andhra Pradesh',
'Kishanraopet,Karimnagar,Andhra Pradesh',
'Kolvai,Karimnagar,Andhra Pradesh',
'Kondapur,Karimnagar,Andhra Pradesh',
'Kothapet,Karimnagar,Andhra Pradesh',
'Mallannapet,Karimnagar,Andhra Pradesh',
'Mangala,Karimnagar,Andhra Pradesh',
'Muthunur,Karimnagar,Andhra Pradesh',
'Nakkalapet,Karimnagar,Andhra Pradesh',
'Narayanpur,Karimnagar,Andhra Pradesh',
'Narsimulapalli,Karimnagar,Andhra Pradesh',
'Potharam,Karimnagar,Andhra Pradesh',
'Thungur,Karimnagar,Andhra Pradesh',
'Valbhapur,Karimnagar,Andhra Pradesh',
'Varkole,Karimnagar,Andhra Pradesh',
'Eligaid,Peddapalli,Andhra Pradesh',
'Fertilizercity,Peddapalli,Andhra Pradesh',
'Anthergan Textiles,Peddapalli,Andhra Pradesh',
'Abadi Ramagundam,Peddapalli,Andhra Pradesh',
'Adavi Srirampur,Peddapalli,Andhra Pradesh',
'Adavisoman Palli,Peddapalli,Andhra Pradesh',
'Adivarampet,Peddapalli,Andhra Pradesh',
'Akunur,Peddapalli,Andhra Pradesh',
'Ambala,Peddapalli,Andhra Pradesh',
'Ambalapur,Peddapalli,Andhra Pradesh',
'Ambatpalli,Peddapalli,Andhra Pradesh',
'Ammanagurthi,Peddapalli,Andhra Pradesh',
'Amudalapalli,Peddapalli,Andhra Pradesh',
'Annaram,Peddapalli,Andhra Pradesh',
'Appannapet,Peddapalli,Andhra Pradesh',
'Arenda,Peddapalli,Andhra Pradesh',
'Bavpet,Peddapalli,Andhra Pradesh',
'Bayyaram,Peddapalli,Andhra Pradesh',
'Bedigal,Peddapalli,Andhra Pradesh',
'Begampet,Peddapalli,Andhra Pradesh',
'Bheempalli,Peddapalli,Andhra Pradesh',
'Bijgir Shariff,Peddapalli,Andhra Pradesh',
'Bijnur,Peddapalli,Andhra Pradesh',
'Bojannapet,Peddapalli,Andhra Pradesh',
'Bommakal,Peddapalli,Andhra Pradesh',
'Bommanapalli,Peddapalli,Andhra Pradesh',
'Bommanapalli,Peddapalli,Andhra Pradesh',
'Bommapur,Peddapalli,Andhra Pradesh',
'Bonthakuntapalli,Peddapalli,Andhra Pradesh',
'Borlagudem,Peddapalli,Andhra Pradesh',
'Bornapalli,Peddapalli,Andhra Pradesh',
'Botlavanaparthi,Peddapalli,Andhra Pradesh',
'Brahmanpalli,Peddapalli,Andhra Pradesh',
'Buttareddy Gudem,Peddapalli,Andhra Pradesh',
'Challur,Peddapalli,Andhra Pradesh',
'Chamanapalli,Peddapalli,Andhra Pradesh',
'Chamanpalli,Peddapalli,Andhra Pradesh',
'Chandapalli,Peddapalli,Andhra Pradesh',
'Chegaon,Peddapalli,Andhra Pradesh',
'Chelpur,Peddapalli,Andhra Pradesh',
'Cherlabuthkur,Peddapalli,Andhra Pradesh',
'Chinnakalavala,Peddapalli,Andhra Pradesh',
'Chintakani,Peddapalli,Andhra Pradesh',
'Damera,Peddapalli,Andhra Pradesh',
'Damerakunta,Peddapalli,Andhra Pradesh',
'Dandepalli,Peddapalli,Andhra Pradesh',
'Desaipalli,Peddapalli,Andhra Pradesh',
'Deshrajpalli,Peddapalli,Andhra Pradesh',
'Devampalli,Peddapalli,Andhra Pradesh',
'Dhanwada,Peddapalli,Andhra Pradesh',
'Dharmarajpalli,Peddapalli,Andhra Pradesh',
'Dharmaram,Peddapalli,Andhra Pradesh',
'Dharmaram,Peddapalli,Andhra Pradesh',
'Dharmaram,Peddapalli,Andhra Pradesh',
'Dharmaram,Peddapalli,Andhra Pradesh',
'Dongathurthi,Peddapalli,Andhra Pradesh',
'Duddenapalli,Peddapalli,Andhra Pradesh',
'Dulikatta,Peddapalli,Andhra Pradesh',
'Eklaspur,Peddapalli,Andhra Pradesh',
'Eklsapur,Peddapalli,Andhra Pradesh',
'Elabotharam,Peddapalli,Andhra Pradesh',
'Elkalapalli,Peddapalli,Andhra Pradesh',
'Erukalagudem,Peddapalli,Andhra Pradesh',
'G Narsingapur,Peddapalli,Andhra Pradesh',
'Gaddapaka,Peddapalli,Andhra Pradesh',
'Gangaram,Peddapalli,Andhra Pradesh',
'Gangaram,Peddapalli,Andhra Pradesh',
'Gangipalli,Peddapalli,Andhra Pradesh',
'Gattepalli,Peddapalli,Andhra Pradesh',
'Ghanmukulu,Peddapalli,Andhra Pradesh',
'Ghanpur,Peddapalli,Andhra Pradesh',
'Godishala,Peddapalli,Andhra Pradesh',
'Gollapalli,Peddapalli,Andhra Pradesh',
'Gopalapur,Peddapalli,Andhra Pradesh',
'Gopalpur,Peddapalli,Andhra Pradesh',
'Goyalwada,Peddapalli,Andhra Pradesh',
'Gudur,Peddapalli,Andhra Pradesh',
'Gujulapalli,Peddapalli,Andhra Pradesh',
'Gumpula,Peddapalli,Andhra Pradesh',
'Gundedu,Peddapalli,Andhra Pradesh',
'Guniparthi,Peddapalli,Andhra Pradesh',
'Gunjapadugu,Peddapalli,Andhra Pradesh',
'Indurthi,Peddapalli,Andhra Pradesh',
'Isala Thakkallapalli,Peddapalli,Andhra Pradesh',
'Itharajpalli,Peddapalli,Andhra Pradesh',
'Jallaram,Peddapalli,Andhra Pradesh',
'Janagaon,Peddapalli,Andhra Pradesh',
'Jayyaram,Peddapalli,Andhra Pradesh',
'Jeelugula,Peddapalli,Andhra Pradesh',
'Julapalli,Peddapalli,Andhra Pradesh',
'Julapalli,Peddapalli,Andhra Pradesh',
'Jupaka,Peddapalli,Andhra Pradesh',
'Kachapur,Peddapalli,Andhra Pradesh',
'Kachapur,Peddapalli,Andhra Pradesh',
'Kaleswaram,Peddapalli,Andhra Pradesh',
'Kalleda,Peddapalli,Andhra Pradesh',
'Kalvacharla,Peddapalli,Andhra Pradesh',
'Kanagarthi,Peddapalli,Andhra Pradesh',
'Kanagarthi,Peddapalli,Andhra Pradesh',
'Kanagarthi,Peddapalli,Andhra Pradesh',
'Kanaparthi,Peddapalli,Andhra Pradesh',
'Kandugula,Peddapalli,Andhra Pradesh',
'Kaniparthi,Peddapalli,Andhra Pradesh',
'Kannal,Peddapalli,Andhra Pradesh',
'Kannal,Peddapalli,Andhra Pradesh',
'Kannapur,Peddapalli,Andhra Pradesh',
'Kannaram,Peddapalli,Andhra Pradesh',
'Kannur,Peddapalli,Andhra Pradesh',
'Kanukula,Peddapalli,Andhra Pradesh',
'Kanukulagidda,Peddapalli,Andhra Pradesh',
'Katekenapalli,Peddapalli,Andhra Pradesh',
'Katrapalli,Peddapalli,Andhra Pradesh',
'Keshanapalli,Peddapalli,Andhra Pradesh',
'Keshavapur,Peddapalli,Andhra Pradesh',
'Khammampalli,Peddapalli,Andhra Pradesh',
'Kistampet,Peddapalli,Andhra Pradesh',
'Kodurupaka,Peddapalli,Andhra Pradesh',
'Komera,Peddapalli,Andhra Pradesh',
'Kondapaka,Peddapalli,Andhra Pradesh',
'Kondapalakala,Peddapalli,Andhra Pradesh',
'Koppur,Peddapalli,Andhra Pradesh',
'Korapalli,Peddapalli,Andhra Pradesh',
'Korkal,Peddapalli,Andhra Pradesh',
'Kothagutta,Peddapalli,Andhra Pradesh',
'Kothakonda,Peddapalli,Andhra Pradesh',
'Kothapalli,Peddapalli,Andhra Pradesh',
'Kothapalli,Peddapalli,Andhra Pradesh',
'Kothur,Peddapalli,Andhra Pradesh',
'Kukkalaguduru,Peddapalli,Andhra Pradesh',
'Kummarikunta,Peddapalli,Andhra Pradesh',
'Kunaram,Peddapalli,Andhra Pradesh',
'Kundanapalli,Peddapalli,Andhra Pradesh',
'Ladnapur,Peddapalli,Andhra Pradesh',
'Lakkaram,Peddapalli,Andhra Pradesh',
'Laxmipur,Peddapalli,Andhra Pradesh',
'Legalamarri,Peddapalli,Andhra Pradesh',
'Machinapalli,Peddapalli,Andhra Pradesh',
'Madaka,Peddapalli,Andhra Pradesh',
'Madannapeta,Peddapalli,Andhra Pradesh',
'Madhuda,Peddapalli,Andhra Pradesh',
'Madupalli,Peddapalli,Andhra Pradesh',
'Maidambanda,Peddapalli,Andhra Pradesh',
'Maidpalli,Peddapalli,Andhra Pradesh',
'Maidpalli,Peddapalli,Andhra Pradesh',
'Mallapuram,Peddapalli,Andhra Pradesh',
'Mallaram,Peddapalli,Andhra Pradesh',
'Mallaram,Peddapalli,Andhra Pradesh',
'Mallial,Peddapalli,Andhra Pradesh',
'Mallial,Peddapalli,Andhra Pradesh',
'Mallialpalli,Peddapalli,Andhra Pradesh',
'Mamidalapalli,Peddapalli,Andhra Pradesh',
'Mangampet,Peddapalli,Andhra Pradesh',
'Manikyapur,Peddapalli,Andhra Pradesh',
'Maredugonda,Peddapalli,Andhra Pradesh',
'Maredupaka,Peddapalli,Andhra Pradesh',
'Metpalli,Peddapalli,Andhra Pradesh',
'Mirzampet,Peddapalli,Andhra Pradesh',
'Mogilipalem,Peddapalli,Andhra Pradesh',
'Mohammadapur,Peddapalli,Andhra Pradesh',
'Motlapalli,Peddapalli,Andhra Pradesh',
'Mudriyal,Peddapalli,Andhra Pradesh',
'Mukdumpur,Peddapalli,Andhra Pradesh',
'Mulasala,Peddapalli,Andhra Pradesh',
'Munjampalli,Peddapalli,Andhra Pradesh',
'Muppirithota,Peddapalli,Andhra Pradesh',
'Murmur,Peddapalli,Andhra Pradesh',
'Mustafapur,Peddapalli,Andhra Pradesh',
'Mutharam,Peddapalli,Andhra Pradesh',
'Mutharam,Peddapalli,Andhra Pradesh',
'Mutharam,Peddapalli,Andhra Pradesh',
'Mutharam,Peddapalli,Andhra Pradesh',
'Nagaram,Peddapalli,Andhra Pradesh',
'Narayanapur,Peddapalli,Andhra Pradesh',
'Narsingapur,Peddapalli,Andhra Pradesh',
'Neerukulla,Peddapalli,Andhra Pradesh',
'Nerella,Peddapalli,Andhra Pradesh',
'Nittur,Peddapalli,Andhra Pradesh',
'Odela,Peddapalli,Andhra Pradesh',
'Odelu,Peddapalli,Andhra Pradesh',
'Palakurthi,Peddapalli,Andhra Pradesh',
'Palimela,Peddapalli,Andhra Pradesh',
'Palitham,Peddapalli,Andhra Pradesh',
'Pandilla,Peddapalli,Andhra Pradesh',
'Papaiahpalli,Peddapalli,Andhra Pradesh',
'Pathagudur,Peddapalli,Andhra Pradesh',
'Pathipaka,Peddapalli,Andhra Pradesh',
'Peddabonkur,Peddapalli,Andhra Pradesh',
'Peddakalvala,Peddapalli,Andhra Pradesh',
'Peddampet,Peddapalli,Andhra Pradesh',
'Peddathundla,Peddapalli,Andhra Pradesh',
'Pegadapalli,Peddapalli,Andhra Pradesh',
'Penchiklapet,Peddapalli,Andhra Pradesh',
'Perapalli,Peddapalli,Andhra Pradesh',
'Poosala,Peddapalli,Andhra Pradesh',
'Pothireddy Palli,Peddapalli,Andhra Pradesh',
'Pothireddypet,Peddapalli,Andhra Pradesh',
'Potiyal,Peddapalli,Andhra Pradesh',
'Puchunur,Peddapalli,Andhra Pradesh',
'Purupalli,Peddapalli,Andhra Pradesh',
'Puttapaka,Peddapalli,Andhra Pradesh',
'Rachapalli,Peddapalli,Andhra Pradesh',
'Rachapalli,Peddapalli,Andhra Pradesh',
'Raghavapur,Peddapalli,Andhra Pradesh',
'Ragineedu,Peddapalli,Andhra Pradesh',
'Raikaldevpalli,Peddapalli,Andhra Pradesh',
'Rajapur,Peddapalli,Andhra Pradesh',
'Rajkal,Peddapalli,Andhra Pradesh',
'Ramchandrapur,Peddapalli,Andhra Pradesh',
'Rampalli,Peddapalli,Andhra Pradesh',
'Rampur,Peddapalli,Andhra Pradesh',
'Rangapuram,Peddapalli,Andhra Pradesh',
'Rathapalli,Peddapalli,Andhra Pradesh',
'Rathnagiri,Peddapalli,Andhra Pradesh',
'Rathnapur,Peddapalli,Andhra Pradesh',
'Reddypalli,Peddapalli,Andhra Pradesh',
'Regadi Maddikunta,Peddapalli,Andhra Pradesh',
'Rekonda,Peddapalli,Andhra Pradesh',
'Rompikunta,Peddapalli,Andhra Pradesh',
'Rudraram,Peddapalli,Andhra Pradesh',
'Sarsaid,Peddapalli,Andhra Pradesh',
'Shaimpet,Peddapalli,Andhra Pradesh',
'Shanagonda,Peddapalli,Andhra Pradesh',
'Shanigaram,Peddapalli,Andhra Pradesh',
'Shivapalli,Peddapalli,Andhra Pradesh',
'Shivarampalli,Peddapalli,Andhra Pradesh',
'Singapur,Peddapalli,Andhra Pradesh',
'Singapur,Peddapalli,Andhra Pradesh',
'Siripuram,Peddapalli,Andhra Pradesh',
'Sirsapalli,Peddapalli,Andhra Pradesh',
'Suddala,Peddapalli,Andhra Pradesh',
'Sultanpur,Peddapalli,Andhra Pradesh',
'Sundilla,Peddapalli,Andhra Pradesh',
'Suraram,Peddapalli,Andhra Pradesh',
'Suraram,Peddapalli,Andhra Pradesh',
'T Maddikunta,Peddapalli,Andhra Pradesh',
'Tadicherla,Peddapalli,Andhra Pradesh',
'Tekurthi,Peddapalli,Andhra Pradesh',
'Telukunta,Peddapalli,Andhra Pradesh',
'Thanugula,Peddapalli,Andhra Pradesh',
'Tharupalli,Peddapalli,Andhra Pradesh',
'Thummanapalli,Peddapalli,Andhra Pradesh',
'Tihimmapur,Peddapalli,Andhra Pradesh',
'Togarrai,Peddapalli,Andhra Pradesh',
'Ullampalli,Peddapalli,Andhra Pradesh',
'Vadupulavancha,Peddapalli,Andhra Pradesh',
'Valbhapur,Peddapalli,Andhra Pradesh',
'Valbhapur,Peddapalli,Andhra Pradesh',
'Vallamkunta,Peddapalli,Andhra Pradesh',
'Vangapalli,Peddapalli,Andhra Pradesh',
'Vanthadupula,Peddapalli,Andhra Pradesh',
'Veeranarayapur,Peddapalli,Andhra Pradesh',
'Vegurupalli,Peddapalli,Andhra Pradesh',
'Venkatapur,Peddapalli,Andhra Pradesh',
'Venkataraopalli,Peddapalli,Andhra Pradesh',
'Vennampalli,Peddapalli,Andhra Pradesh',
'Vennampalli,Peddapalli,Andhra Pradesh',
'Vilasagar,Peddapalli,Andhra Pradesh',
'Vilasagar,Peddapalli,Andhra Pradesh',
'Wadakapur,Peddapalli,Andhra Pradesh',
'Yedlapalli,Peddapalli,Andhra Pradesh',
'Yelbaka,Peddapalli,Andhra Pradesh',
'Yellanthakunta,Peddapalli,Andhra Pradesh',
'Yeradapalli,Peddapalli,Andhra Pradesh',
'Yerraballi,Peddapalli,Andhra Pradesh',
'Bejjanki,Karimnagar,Andhra Pradesh',
'Cheelapur,Karimnagar,Andhra Pradesh',
'Gagillapur,Karimnagar,Andhra Pradesh',
'Ganeervaram,Karimnagar,Andhra Pradesh',
'Gugilla,Karimnagar,Andhra Pradesh',
'Gunukula Kondapur,Karimnagar,Andhra Pradesh',
'Jangapalli,Karimnagar,Andhra Pradesh',
'Kallepalli,Karimnagar,Andhra Pradesh',
'Mylaram,Karimnagar,Andhra Pradesh',
'Parvella,Karimnagar,Andhra Pradesh',
'Regulapalli,Karimnagar,Andhra Pradesh',
'Thotapalli,Karimnagar,Andhra Pradesh',
'Vadloor,Karimnagar,Andhra Pradesh',
'Vadloorbegumpet,Karimnagar,Andhra Pradesh',
'Vinjapalli,Karimnagar,Andhra Pradesh',
'Narsingapur,Karimnagar,Andhra Pradesh',
'Ananthapalli,Karimnagar,Andhra Pradesh',
'Boenpalli,Karimnagar,Andhra Pradesh',
'Korem,Karimnagar,Andhra Pradesh',
'Mallapur,Karimnagar,Andhra Pradesh',
'Manwada,Karimnagar,Andhra Pradesh',
'Stambampalli,Karimnagar,Andhra Pradesh',
'Tadagonda,Karimnagar,Andhra Pradesh',
'Vardavelli,Karimnagar,Andhra Pradesh',
'Vilasagar,Karimnagar,Andhra Pradesh',
'Bandapalli,Karimnagar,Andhra Pradesh',
'Chandurthi,Karimnagar,Andhra Pradesh',
'Jogapur,Karimnagar,Andhra Pradesh',
'Lingampet,Karimnagar,Andhra Pradesh',
'Mallial,Karimnagar,Andhra Pradesh',
'Marrigadda,Karimnagar,Andhra Pradesh',
'Moodapalli,Karimnagar,Andhra Pradesh',
'Sangula,Karimnagar,Andhra Pradesh',
'Thimmapur,Karimnagar,Andhra Pradesh',
'Yengal,Karimnagar,Andhra Pradesh',
'Rudrangi,Karimnagar,Andhra Pradesh',
'Marripalli,Karimnagar,Andhra Pradesh',
'Chigurumamidi,Karimnagar,Andhra Pradesh',
'Indurthi,Karimnagar,Andhra Pradesh',
'Mudimanikyam,Karimnagar,Andhra Pradesh',
'Mulkanur,Karimnagar,Andhra Pradesh',
'Nawabpet,Karimnagar,Andhra Pradesh',
'Ramancha,Karimnagar,Andhra Pradesh',
'Sunderagiri,Karimnagar,Andhra Pradesh',
'Arnakonda,Karimnagar,Andhra Pradesh',
'Bhoopalapatnam,Karimnagar,Andhra Pradesh',
'Chityalapalli,Karimnagar,Andhra Pradesh',
'Choppadandi,Karimnagar,Andhra Pradesh',
'Gumlapur,Karimnagar,Andhra Pradesh',
'Katnapalli,Karimnagar,Andhra Pradesh',
'Kolimikunta,Karimnagar,Andhra Pradesh',
'Ragampet,Karimnagar,Andhra Pradesh',
'Revelli,Karimnagar,Andhra Pradesh',
'Rukmapur,Karimnagar,Andhra Pradesh',
'Vedurgatta,Karimnagar,Andhra Pradesh',
'Buggaram,Karimnagar,Andhra Pradesh',
'Dharmapuri,Karimnagar,Andhra Pradesh',
'Donthapur,Karimnagar,Andhra Pradesh',
'Donur,Karimnagar,Andhra Pradesh',
'Gopalpur,Karimnagar,Andhra Pradesh',
'Jaina,Karimnagar,Andhra Pradesh',
'Kamalapur,Karimnagar,Andhra Pradesh',
'Madhunur,Karimnagar,Andhra Pradesh',
'Nerella,Karimnagar,Andhra Pradesh',
'Raipatnam,Karimnagar,Andhra Pradesh',
'Rajaram,Karimnagar,Andhra Pradesh',
'Sirkonda,Karimnagar,Andhra Pradesh',
'Thimmapur,Karimnagar,Andhra Pradesh',
'Thimminala,Karimnagar,Andhra Pradesh',
'Velgonda,Karimnagar,Andhra Pradesh',
'Stambampalli,Karimnagar,Andhra Pradesh',
'Gv8incline,Peddapalli,Andhra Pradesh',
'Kamanpur,Peddapalli,Andhra Pradesh',
'Kolanur,Peddapalli,Andhra Pradesh',
'Manthani,Peddapalli,Andhra Pradesh',
'Molangur,Peddapalli,Andhra Pradesh',
'Ootur,Peddapalli,Andhra Pradesh',
'Peddapalli RS,Peddapalli,Andhra Pradesh',
'Sultanabad,Peddapalli,Andhra Pradesh',
'Uppal,Peddapalli,Andhra Pradesh',
'Vangara,Peddapalli,Andhra Pradesh',
'Vavilala,Peddapalli,Andhra Pradesh',
'Ananthagiri,Karimnagar,Andhra Pradesh',
'Anantharam,Karimnagar,Andhra Pradesh',
'Dacharam,Karimnagar,Andhra Pradesh',
'Dacharam,Karimnagar,Andhra Pradesh',
'Ellanthakunta,Karimnagar,Andhra Pradesh',
'Galipalli,Karimnagar,Andhra Pradesh',
'Gundaram,Karimnagar,Andhra Pradesh',
'Kandikatkur,Karimnagar,Andhra Pradesh',
'Kodurpaka,Karimnagar,Andhra Pradesh',
'Mukshanpet,Karimnagar,Andhra Pradesh',
'Peddalingapur,Karimnagar,Andhra Pradesh',
'Rahimkhanpet,Karimnagar,Andhra Pradesh',
'Repaka,Karimnagar,Andhra Pradesh',
'Tallapalli,Karimnagar,Andhra Pradesh',
'Vallampatla,Karimnagar,Andhra Pradesh',
'Vanthadupula,Karimnagar,Andhra Pradesh',
'Velgipur,Karimnagar,Andhra Pradesh',
'Pothur,Karimnagar,Andhra Pradesh',
'Dammannapet,Karimnagar,Andhra Pradesh',
'Gajasingaram,Karimnagar,Andhra Pradesh',
'Gambhiraopet,Karimnagar,Andhra Pradesh',
'Gorintial,Karimnagar,Andhra Pradesh',
'Kothapalli,Karimnagar,Andhra Pradesh',
'Lingannapet,Karimnagar,Andhra Pradesh',
'Mallareddipet,Karimnagar,Andhra Pradesh',
'Manair Project,Karimnagar,Andhra Pradesh',
'Mucherla,Karimnagar,Andhra Pradesh',
'Nagumpet,Karimnagar,Andhra Pradesh',
'Narmala,Karimnagar,Andhra Pradesh',
'Samudralingapur,Karimnagar,Andhra Pradesh',
'Srigadha,Karimnagar,Andhra Pradesh',
'Achampalli,Karimnagar,Andhra Pradesh',
'Gangadhara,Karimnagar,Andhra Pradesh',
'Garshakurthy,Karimnagar,Andhra Pradesh',
'Gattubhuthkur,Karimnagar,Andhra Pradesh',
'Kurikyal,Karimnagar,Andhra Pradesh',
'Mallapur,Karimnagar,Andhra Pradesh',
'Nagireddipur,Karimnagar,Andhra Pradesh',
'Narayanpur,Karimnagar,Andhra Pradesh',
'Ryalapalli,Karimnagar,Andhra Pradesh',
'Sarvareddypalli,Karimnagar,Andhra Pradesh',
'Uppermallial,Karimnagar,Andhra Pradesh',
'Venkataipalli,Karimnagar,Andhra Pradesh',
'Aggimalla,Karimnagar,Andhra Pradesh',
'Chandoli,Karimnagar,Andhra Pradesh',
'Chilvakodur,Karimnagar,Andhra Pradesh',
'Gollapalli,Karimnagar,Andhra Pradesh',
'Ibrahimnagar,Karimnagar,Andhra Pradesh',
'Raghavapatnam,Karimnagar,Andhra Pradesh',
'Rapalli,Karimnagar,Andhra Pradesh',
'Shakkella,Karimnagar,Andhra Pradesh',
'Thirumalapur,Karimnagar,Andhra Pradesh',
'Venugumatla,Karimnagar,Andhra Pradesh',
'Regonda,Karimnagar,Andhra Pradesh',
'Akkannapet,Karimnagar,Andhra Pradesh',
'Anthakpet,Karimnagar,Andhra Pradesh',
'Choutapalli,Karimnagar,Andhra Pradesh',
'Gandipalli,Karimnagar,Andhra Pradesh',
'Gouravelli,Karimnagar,Andhra Pradesh',
'Husnabad,Karimnagar,Andhra Pradesh',
'Jangaon,Karimnagar,Andhra Pradesh',
'Katkur,Karimnagar,Andhra Pradesh',
'Keshavapur,Karimnagar,Andhra Pradesh',
'Kuchanapalli,Karimnagar,Andhra Pradesh',
'Mallampalli,Karimnagar,Andhra Pradesh',
'Mirzapur,Karimnagar,Andhra Pradesh',
'Pandilla,Karimnagar,Andhra Pradesh',
'Potharam,Karimnagar,Andhra Pradesh',
'Potlapalli,Karimnagar,Andhra Pradesh',
'Ramavaram,Karimnagar,Andhra Pradesh',
'Thotapalli,Karimnagar,Andhra Pradesh',
'Bheemadevarapally,Peddapalli,Andhra Pradesh',
'Huzurabad H.O,Peddapalli,Andhra Pradesh',
'Kakathiya Canal Campus,Peddapalli,Andhra Pradesh',
'Kalvasrirampur,Peddapalli,Andhra Pradesh',
'Kamalapur,Peddapalli,Andhra Pradesh',
'Kareemabadi,Peddapalli,Andhra Pradesh',
'Keshavapatnam,Peddapalli,Andhra Pradesh',
'Mulkanur,Peddapalli,Andhra Pradesh',
'Pothkapalli,Peddapalli,Andhra Pradesh',
'Saidapur,Peddapalli,Andhra Pradesh',
'Tadikal,Peddapalli,Andhra Pradesh',
'Veenavanka,Peddapalli,Andhra Pradesh',
'Yelkathurthi,Peddapalli,Andhra Pradesh',
'Ammakkapet,Karimnagar,Andhra Pradesh',
'Dabba,Karimnagar,Andhra Pradesh',
'Erdandi,Karimnagar,Andhra Pradesh',
'Gudur,Karimnagar,Andhra Pradesh',
'Ibrahimpatnam,Karimnagar,Andhra Pradesh',
'Komatikondapur,Karimnagar,Andhra Pradesh',
'Lingapur,Karimnagar,Andhra Pradesh',
'Maidpalli,Karimnagar,Andhra Pradesh',
'Vamulakurthi,Karimnagar,Andhra Pradesh',
'Varsikonda,Karimnagar,Andhra Pradesh',
'Yamapur,Karimnagar,Andhra Pradesh',
'Khila Jagtial,Karimnagar,Andhra Pradesh',
'Anthergaon,Karimnagar,Andhra Pradesh',
'Chelgal,Karimnagar,Andhra Pradesh',
'Darur,Karimnagar,Andhra Pradesh',
'Habshipur,Karimnagar,Andhra Pradesh',
'Jabithapur,Karimnagar,Andhra Pradesh',
'Jagtial H.O,Karimnagar,Andhra Pradesh',
'Kalleda,Karimnagar,Andhra Pradesh',
'Laxmipur,Karimnagar,Andhra Pradesh',
'Morapalli,Karimnagar,Andhra Pradesh',
'Motha,Karimnagar,Andhra Pradesh',
'New Abadi Jagtial,Karimnagar,Andhra Pradesh',
'New Bus Stand Jagtial,Karimnagar,Andhra Pradesh',
'Pochampad Project Colony,Karimnagar,Andhra Pradesh',
'Polas,Karimnagar,Andhra Pradesh',
'Porandla,Karimnagar,Andhra Pradesh',
'Takkallapalli,Karimnagar,Andhra Pradesh',
'Thippannapet,Karimnagar,Andhra Pradesh',
'Jammikunta,Peddapalli,Andhra Pradesh',
'Peddapur,Karimnagar,Andhra Pradesh',
'Arepalli,Karimnagar,Andhra Pradesh',
'Asifnagar,Karimnagar,Andhra Pradesh',
'Bommakal,Karimnagar,Andhra Pradesh',
'Chakunta,Karimnagar,Andhra Pradesh',
'Chegurthi,Karimnagar,Andhra Pradesh',
'Chinthakunta,Karimnagar,Andhra Pradesh',
'Collectorate Complex,Karimnagar,Andhra Pradesh',
'Dist. Court Building,Karimnagar,Andhra Pradesh',
'Durshed,Karimnagar,Andhra Pradesh',
'Elgandal,Karimnagar,Andhra Pradesh',
'Jawaharnagar,Karimnagar,Andhra Pradesh',
'Jublikaman,Karimnagar,Andhra Pradesh',
'Kamanpur,Karimnagar,Andhra Pradesh',
'Karimnagar H.O,Karimnagar,Andhra Pradesh',
'Kothapalli,Karimnagar,Andhra Pradesh',
'Left Flank Katta Rampur,Karimnagar,Andhra Pradesh',
'Malkapur,Karimnagar,Andhra Pradesh',
'Mukarampura,Karimnagar,Andhra Pradesh',
'Nagnoor,Karimnagar,Andhra Pradesh',
'Nagulamallial,Karimnagar,Andhra Pradesh',
'Ramnagar,Karimnagar,Andhra Pradesh',
'Rampur,Karimnagar,Andhra Pradesh',
'Ambaripet,Karimnagar,Andhra Pradesh',
'Bhushanraopet,Karimnagar,Andhra Pradesh',
'Bommena,Karimnagar,Andhra Pradesh',
'Chintakunta,Karimnagar,Andhra Pradesh',
'Dulur,Karimnagar,Andhra Pradesh',
'Dumpet,Karimnagar,Andhra Pradesh',
'Gambirpur,Karimnagar,Andhra Pradesh',
'Kathalapur,Karimnagar,Andhra Pradesh',
'Potharam,Karimnagar,Andhra Pradesh',
'Sirikonda,Karimnagar,Andhra Pradesh',
'Takkallapalli,Karimnagar,Andhra Pradesh',
'Tandrial,Karimnagar,Andhra Pradesh',
'Bandalingampalli,Karimnagar,Andhra Pradesh',
'Dumala,Karimnagar,Andhra Pradesh',
'Narayanapur,Karimnagar,Andhra Pradesh',
'Padira,Karimnagar,Andhra Pradesh',
'Cheppial,Karimnagar,Andhra Pradesh',
'Kodimial,Karimnagar,Andhra Pradesh',
'Nachupalli,Karimnagar,Andhra Pradesh',
'Namilikonda,Karimnagar,Andhra Pradesh',
'Poodur,Karimnagar,Andhra Pradesh',
'Ramsagar(Dabbathimmayapalli),Karimnagar,Andhra Pradesh',
'Tippaipalli,Karimnagar,Andhra Pradesh',
'Tirumalapur,Karimnagar,Andhra Pradesh',
'Baswapur,Karimnagar,Andhra Pradesh',
'Gundareddipalli,Karimnagar,Andhra Pradesh',
'Kachapur,Karimnagar,Andhra Pradesh',
'Koheda,Karimnagar,Andhra Pradesh',
'Kurella,Karimnagar,Andhra Pradesh',
'Parveda,Karimnagar,Andhra Pradesh',
'Ramchandrapuram,Karimnagar,Andhra Pradesh',
'Samudrala,Karimnagar,Andhra Pradesh',
'Shanigaram,Karimnagar,Andhra Pradesh',
'Sriramulapalli,Karimnagar,Andhra Pradesh',
'Thangallapalli,Karimnagar,Andhra Pradesh',
'Bavasaipet,Karimnagar,Andhra Pradesh',
'Dharmaram,Karimnagar,Andhra Pradesh',
'Kanagarthi,Karimnagar,Andhra Pradesh',
'Kolanur,Karimnagar,Andhra Pradesh',
'Konaraopet,Karimnagar,Andhra Pradesh',
'Malakpet,Karimnagar,Andhra Pradesh',
'Mamidipalli,Karimnagar,Andhra Pradesh',
'Marthanpet,Karimnagar,Andhra Pradesh',
'Nagaram,Karimnagar,Andhra Pradesh',
'Nimmapalli,Karimnagar,Andhra Pradesh',
'Nizamabad,Karimnagar,Andhra Pradesh',
'Suddala,Karimnagar,Andhra Pradesh',
'Venkatropet,Karimnagar,Andhra Pradesh',
'Peddapur,Karimnagar,Andhra Pradesh',
'Ailapur,Karimnagar,Andhra Pradesh',
'Chinnametpalli,Karimnagar,Andhra Pradesh',
'Ekeenpur,Karimnagar,Andhra Pradesh',
'Joganapalli,Karimnagar,Andhra Pradesh',
'Kallur,Karimnagar,Andhra Pradesh',
'Koratla Bazar,Karimnagar,Andhra Pradesh',
'Koratla,Karimnagar,Andhra Pradesh',
'Madhapur,Karimnagar,Andhra Pradesh',
'Mohanraopet,Karimnagar,Andhra Pradesh',
'Paidimadugu,Karimnagar,Andhra Pradesh',
'Venkatapur,Karimnagar,Andhra Pradesh',
'Yousufnagar,Karimnagar,Andhra Pradesh',
'Chittapur,Karimnagar,Andhra Pradesh',
'Dharmarajpalli,Karimnagar,Andhra Pradesh',
'Mallapur,Karimnagar,Andhra Pradesh',
'Mogalpet,Karimnagar,Andhra Pradesh',
'Muthyampet,Karimnagar,Andhra Pradesh',
'Ragavpet,Karimnagar,Andhra Pradesh',
'Ratnapur,Karimnagar,Andhra Pradesh',
'Sataram,Karimnagar,Andhra Pradesh',
'Siripuram,Karimnagar,Andhra Pradesh',
'Vempalli Venkatraopet,Karimnagar,Andhra Pradesh',
'Balwanthapur,Karimnagar,Andhra Pradesh',
'Madampalli,Karimnagar,Andhra Pradesh',
'Maddutla,Karimnagar,Andhra Pradesh',
'Mallial,Karimnagar,Andhra Pradesh',
'Manala,Karimnagar,Andhra Pradesh',
'Muthyampet,Karimnagar,Andhra Pradesh',
'Nookapalli,Karimnagar,Andhra Pradesh',
'Potharam,Karimnagar,Andhra Pradesh',
'Rampur,Karimnagar,Andhra Pradesh',
'Sharwapuram,Karimnagar,Andhra Pradesh',
'Tattupalli,Karimnagar,Andhra Pradesh',
'Thakkallapalli,Karimnagar,Andhra Pradesh',
'Annaram,Karimnagar,Andhra Pradesh',
'Chengerla,Karimnagar,Andhra Pradesh',
'Gattududdenapalli,Karimnagar,Andhra Pradesh',
'Lingapur,Karimnagar,Andhra Pradesh',
'Manakondur,Karimnagar,Andhra Pradesh',
'Munjampalli,Karimnagar,Andhra Pradesh',
'Veldi,Karimnagar,Andhra Pradesh',
'Kataram,Peddapalli,Andhra Pradesh',
'Mahadevpur,Peddapalli,Andhra Pradesh',
'Katlakunta,Karimnagar,Andhra Pradesh',
'Bheemaram,Karimnagar,Andhra Pradesh',
'Desaipet,Karimnagar,Andhra Pradesh',
'Govindaram,Karimnagar,Andhra Pradesh',
'Kalvakota,Karimnagar,Andhra Pradesh',
'Kondapur,Karimnagar,Andhra Pradesh',
'Lingampet,Karimnagar,Andhra Pradesh',
'Mannegudem,Karimnagar,Andhra Pradesh',
'Medpalli,Karimnagar,Andhra Pradesh',
'Pormalla,Karimnagar,Andhra Pradesh',
'Thatpalli,Karimnagar,Andhra Pradesh',
'Vallampalli,Karimnagar,Andhra Pradesh',
'Venkatropet,Karimnagar,Andhra Pradesh',
'Atmakur,Karimnagar,Andhra Pradesh',
'Chavulamaddi,Karimnagar,Andhra Pradesh',
'Jaggasagar,Karimnagar,Andhra Pradesh',
'Kandrikala,Karimnagar,Andhra Pradesh',
'Konapur,Karimnagar,Andhra Pradesh',
'Konaraopet,Karimnagar,Andhra Pradesh',
'Metpalli Bazar,Karimnagar,Andhra Pradesh',
'Metpalli,Karimnagar,Andhra Pradesh',
'Mettachittapur,Karimnagar,Andhra Pradesh',
'Peggarla,Karimnagar,Andhra Pradesh',
'Vellolla,Karimnagar,Andhra Pradesh',
'Vempet,Karimnagar,Andhra Pradesh',
'Venkatropet,Karimnagar,Andhra Pradesh',
'Bandankal,Karimnagar,Andhra Pradesh',
'Chekode,Karimnagar,Andhra Pradesh',
'Gudem,Karimnagar,Andhra Pradesh',
'Kondapur,Karimnagar,Andhra Pradesh',
'Maddikunta,Karimnagar,Andhra Pradesh',
'Mustabad,Karimnagar,Andhra Pradesh',
'Namapur,Karimnagar,Andhra Pradesh',
'Ounur,Karimnagar,Andhra Pradesh',
'Pothgal,Karimnagar,Andhra Pradesh',
'Terlamaddi,Karimnagar,Andhra Pradesh',
'Manala-i,Karimnagar,Andhra Pradesh',
'A.P.Colony,Peddapalli,Andhra Pradesh',
'Basanthnagar,Peddapalli,Andhra Pradesh',
'Centinary Colony,Peddapalli,Andhra Pradesh',
'Godavarikhani,Peddapalli,Andhra Pradesh',
'Jyothinagar,Peddapalli,Andhra Pradesh',
'Medaram,Peddapalli,Andhra Pradesh',
'Peddapalli H.O,Peddapalli,Andhra Pradesh',
'Pp Colony,Peddapalli,Andhra Pradesh',
'Ramagundam,Peddapalli,Andhra Pradesh',
'Scab,Peddapalli,Andhra Pradesh',
'Vittalanagar,Peddapalli,Andhra Pradesh',
'Aithpalli,Karimnagar,Andhra Pradesh',
'Arevelli,Karimnagar,Andhra Pradesh',
'Bathkapalli,Karimnagar,Andhra Pradesh',
'Lingapur,Karimnagar,Andhra Pradesh',
'Maddulapalli,Karimnagar,Andhra Pradesh',
'Namapur,Karimnagar,Andhra Pradesh',
'Nancherla,Karimnagar,Andhra Pradesh',
'Pegadapalli,Karimnagar,Andhra Pradesh',
'Vengalaipet,Karimnagar,Andhra Pradesh',
'Yellapur,Karimnagar,Andhra Pradesh',
'Allipur,Karimnagar,Andhra Pradesh',
'Bhoopathipur,Karimnagar,Andhra Pradesh',
'Bornapalli,Karimnagar,Andhra Pradesh',
'Itikyal,Karimnagar,Andhra Pradesh',
'Katkapur,Karimnagar,Andhra Pradesh',
'Kummarpalli,Karimnagar,Andhra Pradesh',
'Mehtapur,Karimnagar,Andhra Pradesh',
'Mootapalli,Karimnagar,Andhra Pradesh',
'Raikal,Karimnagar,Andhra Pradesh',
'Ramajipet,Karimnagar,Andhra Pradesh',
'Thatlavai,Karimnagar,Andhra Pradesh',
'Deshrajpalli,Karimnagar,Andhra Pradesh',
'Gopalraopet,Karimnagar,Andhra Pradesh',
'Gundi,Karimnagar,Andhra Pradesh',
'Laxmipur,Karimnagar,Andhra Pradesh',
'Mothe,Karimnagar,Andhra Pradesh',
'Ramadugu,Karimnagar,Andhra Pradesh',
'Rudraram,Karimnagar,Andhra Pradesh',
'Shanagar,Karimnagar,Andhra Pradesh',
'Thirumalapur,Karimnagar,Andhra Pradesh',
'Vannaram,Karimnagar,Andhra Pradesh',
'Vedira,Karimnagar,Andhra Pradesh',
'Velchal,Karimnagar,Andhra Pradesh',
'Arpapalli,Karimnagar,Andhra Pradesh',
'Nagnur Lachakkapet,Karimnagar,Andhra Pradesh',
'Pembatla,Karimnagar,Andhra Pradesh',
'Raichpapalli,Karimnagar,Andhra Pradesh',
'Sarangapur,Karimnagar,Andhra Pradesh',
'Badnapalli,Karimnagar,Andhra Pradesh',
'Bonala,Karimnagar,Andhra Pradesh',
'Chandrampet,Karimnagar,Andhra Pradesh',
'Cheerlavancha,Karimnagar,Andhra Pradesh',
'Chinnalingapur,Karimnagar,Andhra Pradesh',
'Chintalathana,Karimnagar,Andhra Pradesh',
'Gandhichowk Srisilla,Karimnagar,Andhra Pradesh',
'Jillella,Karimnagar,Andhra Pradesh',
'Katkur,Karimnagar,Andhra Pradesh',
'Laxmipuram,Karimnagar,Andhra Pradesh',
'Mandepalli,Karimnagar,Andhra Pradesh',
'Nerella,Karimnagar,Andhra Pradesh',
'Peddur,Karimnagar,Andhra Pradesh',
'Sarampalli,Karimnagar,Andhra Pradesh',
'Sirsilla,Karimnagar,Andhra Pradesh',
'Tadoor,Karimnagar,Andhra Pradesh',
'Tangallapalli,Karimnagar,Andhra Pradesh',
'Voblapur,Karimnagar,Andhra Pradesh',
'Garepalli,Peddapalli,Andhra Pradesh',
'Algunur,Karimnagar,Andhra Pradesh',
'Kothapalli,Karimnagar,Andhra Pradesh',
'Lower Manair Dam Colony,Karimnagar,Andhra Pradesh',
'Mallapur,Karimnagar,Andhra Pradesh',
'Mannempalli,Karimnagar,Andhra Pradesh',
'Nallagonda,Karimnagar,Andhra Pradesh',
'Nedunur,Karimnagar,Andhra Pradesh',
'Nustulapur,Karimnagar,Andhra Pradesh',
'Parlapalli,Karimnagar,Andhra Pradesh',
'Polampalli,Karimnagar,Andhra Pradesh',
'Porandla,Karimnagar,Andhra Pradesh',
'Renikunta,Karimnagar,Andhra Pradesh',
'Thimmapur,Karimnagar,Andhra Pradesh',
'Vachunur,Karimnagar,Andhra Pradesh',
'Endapalli,Karimnagar,Andhra Pradesh',
'Velgatur,Karimnagar,Andhra Pradesh',
'Anpur,Karimnagar,Andhra Pradesh',
'Balarajpalli,Karimnagar,Andhra Pradesh',
'Chekkapalli,Karimnagar,Andhra Pradesh',
'Fazilnagar,Karimnagar,Andhra Pradesh',
'Hanmajipet,Karimnagar,Andhra Pradesh',
'Mallaram,Karimnagar,Andhra Pradesh',
'Marpaka,Karimnagar,Andhra Pradesh',
'Nookalamarri,Karimnagar,Andhra Pradesh',
'Ottimalla,Karimnagar,Andhra Pradesh',
'Rudraram,Karimnagar,Andhra Pradesh',
'Sankepalli,Karimnagar,Andhra Pradesh',
'Satrajpalli,Karimnagar,Andhra Pradesh',
'Vemulawada,Karimnagar,Andhra Pradesh',
'Adivipadira,Karimnagar,Andhra Pradesh',
'Almaspur,Karimnagar,Andhra Pradesh',
'Garjanapalli,Karimnagar,Andhra Pradesh',
'Gollapalli,Karimnagar,Andhra Pradesh',
'Koratlapet,Karimnagar,Andhra Pradesh',
'Thimmapur,Karimnagar,Andhra Pradesh',
'Veerlapalli,Karimnagar,Andhra Pradesh',
'Venkatrapur,Karimnagar,Andhra Pradesh',
'Kishandaspet,Karimnagar,Andhra Pradesh',
'Racherla Boppapur,Karimnagar,Andhra Pradesh',
'Anantharam,Khammam,Andhra Pradesh',
'Aswaraopet,Khammam,Andhra Pradesh',
'Gummadivalli,Khammam,Andhra Pradesh',
'Naramvarigudem,Khammam,Andhra Pradesh',
'Tirumalakunta,Khammam,Andhra Pradesh',
'Vinayakapuram,Khammam,Andhra Pradesh',
'Asupaka,Khammam,Andhra Pradesh',
'Narayanapuram,Khammam,Andhra Pradesh',
'Banigandlapahad,Khammam,Andhra Pradesh',
'Balajipeta,Khammam,Andhra Pradesh',
'Bayyaram,Khammam,Andhra Pradesh',
'Gowraram,Khammam,Andhra Pradesh',
'Irusulapuram,Khammam,Andhra Pradesh',
'Kothapeta,Khammam,Andhra Pradesh',
'Ramachandrapuram,Khammam,Andhra Pradesh',
'S.N.Puram,Khammam,Andhra Pradesh',
'Uppalapahad,Khammam,Andhra Pradesh',
'V.R.Puram,Khammam,Andhra Pradesh',
'B.R.Colony,Khammam,Andhra Pradesh',
'Bhadrachalam H.O,Khammam,Andhra Pradesh',
'Chintalagudem,Khammam,Andhra Pradesh',
'Chodavaram,Khammam,Andhra Pradesh',
'Gundala,Khammam,Andhra Pradesh',
'Mothipattinagar,Khammam,Andhra Pradesh',
'Narasapuram,Khammam,Andhra Pradesh',
'Nellipaka,Khammam,Andhra Pradesh',
'Purushottapatnam,Khammam,Andhra Pradesh',
'Ramalayam,Khammam,Andhra Pradesh',
'Seetharampuram,Khammam,Andhra Pradesh',
'Singavaram,Khammam,Andhra Pradesh',
'Turubaka,Khammam,Andhra Pradesh',
'Venkatareddipeta,Khammam,Andhra Pradesh',
'Yatapaka,Khammam,Andhra Pradesh',
'Ayyavarigudem,Khammam,Andhra Pradesh',
'Bhimavaram,Khammam,Andhra Pradesh',
'Choppakatlapalem,Khammam,Andhra Pradesh',
'Guntupalli Gopavaram,Khammam,Andhra Pradesh',
'Mamnoor,Khammam,Andhra Pradesh',
'Pedagopavaram,Khammam,Andhra Pradesh',
'Bommakal,Khammam,Andhra Pradesh',
'Lakshmipuram,Khammam,Andhra Pradesh',
'Chirunomula,Khammam,Andhra Pradesh',
'Choppakatlapalem,Khammam,Andhra Pradesh',
'Motamarri,Khammam,Andhra Pradesh',
'Mustikuntla,Khammam,Andhra Pradesh',
'Narayanapuram,Khammam,Andhra Pradesh',
'Allapadu,Khammam,Andhra Pradesh',
'Pedabeeravalli,Khammam,Andhra Pradesh',
'Ravinoothala,Khammam,Andhra Pradesh',
'Krishnasagar,Khammam,Andhra Pradesh',
'Amaravaram,Khammam,Andhra Pradesh',
'Burgampahad,Khammam,Andhra Pradesh',
'Damaracharla,Khammam,Andhra Pradesh',
'Kukunoor,Khammam,Andhra Pradesh',
'Madhavaram,Khammam,Andhra Pradesh',
'Morampalli,Khammam,Andhra Pradesh',
'Musalimadugu,Khammam,Andhra Pradesh',
'Nagineniprolu,Khammam,Andhra Pradesh',
'Pinapaka Pattinagar,Khammam,Andhra Pradesh',
'Ravigudem,Khammam,Andhra Pradesh',
'Sridhar Velair,Khammam,Andhra Pradesh',
'Thondipaka,Khammam,Andhra Pradesh',
'Timmampeta,Khammam,Andhra Pradesh',
'Upperu,Khammam,Andhra Pradesh',
'Vinjaram,Khammam,Andhra Pradesh',
'Dachavaram,Khammam,Andhra Pradesh',
'Kattukacharam,Khammam,Andhra Pradesh',
'Appalanarasimhapuram,Khammam,Andhra Pradesh',
'Banapuram,Khammam,Andhra Pradesh',
'Buddaram,Khammam,Andhra Pradesh',
'Cheruvumadharam,Khammam,Andhra Pradesh',
'Kongara,Khammam,Andhra Pradesh',
'Mangapuram,Khammam,Andhra Pradesh',
'Rayagudem,Khammam,Andhra Pradesh',
'Veerabhadravaram,Khammam,Andhra Pradesh',
'Alubaka,Khammam,Andhra Pradesh',
'Charla,Khammam,Andhra Pradesh',
'Edira,Khammam,Andhra Pradesh',
'Lingapuram,Khammam,Andhra Pradesh',
'Mogallapalli,Khammam,Andhra Pradesh',
'Pathapuram,Khammam,Andhra Pradesh',
'Ramachandrapuram,Khammam,Andhra Pradesh',
'Subbampeta,Khammam,Andhra Pradesh',
'Suraveedu,Khammam,Andhra Pradesh',
'Vallabhi,Khammam,Andhra Pradesh',
'Mallaram,Khammam,Andhra Pradesh',
'Pedamandava,Khammam,Andhra Pradesh',
'Ananthasagar,Khammam,Andhra Pradesh',
'Chinamandava,Khammam,Andhra Pradesh',
'Chintakani,Khammam,Andhra Pradesh',
'Jagannadhapuram,Khammam,Andhra Pradesh',
'Kodumuru,Khammam,Andhra Pradesh',
'Komatlagudem,Khammam,Andhra Pradesh',
'Lachagudem,Khammam,Andhra Pradesh',
'Matkepalli Namavaram,Khammam,Andhra Pradesh',
'Nagiligonda,Khammam,Andhra Pradesh',
'Nagulavancha,Khammam,Andhra Pradesh',
'Nereda,Khammam,Andhra Pradesh',
'Pandillapalli,Khammam,Andhra Pradesh',
'Patharlapahad,Khammam,Andhra Pradesh',
'Proddutur,Khammam,Andhra Pradesh',
'Ramakrishnapuram,Khammam,Andhra Pradesh',
'Repallewada,Khammam,Andhra Pradesh',
'Seethampeta,Khammam,Andhra Pradesh',
'Timminenipalem,Khammam,Andhra Pradesh',
'Tootikuntla,Khammam,Andhra Pradesh',
'Chatti,Khammam,Andhra Pradesh',
'Chintur,Khammam,Andhra Pradesh',
'Ankampale,Khammam,Andhra Pradesh',
'Dammapeta,Khammam,Andhra Pradesh',
'Ganeshpadu,Khammam,Andhra Pradesh',
'Lingalapalli,Khammam,Andhra Pradesh',
'Maddulagudem,Khammam,Andhra Pradesh',
'Malkaram,Khammam,Andhra Pradesh',
'Mandalapalli,Khammam,Andhra Pradesh',
'Mustibanda,Khammam,Andhra Pradesh',
'Nacharam,Khammam,Andhra Pradesh',
'Patwarigudem,Khammam,Andhra Pradesh',
'Arlagudem,Khammam,Andhra Pradesh',
'Chinabandirevu,Khammam,Andhra Pradesh',
'Dabbanuthala,Khammam,Andhra Pradesh',
'Dummagudem,Khammam,Andhra Pradesh',
'Gangolu,Khammam,Andhra Pradesh',
'Laxminagaram,Khammam,Andhra Pradesh',
'Nallaballi,Khammam,Andhra Pradesh',
'Parnasala,Khammam,Andhra Pradesh',
'Pydigudem,Khammam,Andhra Pradesh',
'Sunnambatti,Khammam,Andhra Pradesh',
'Arikayalapadu,Khammam,Andhra Pradesh',
'Buradaraghavapuram,Khammam,Andhra Pradesh',
'Enkoor,Khammam,Andhra Pradesh',
'Jannaram,Khammam,Andhra Pradesh',
'Lachaguda,Khammam,Andhra Pradesh',
'Nacharam,Khammam,Andhra Pradesh',
'Rayamadharam,Khammam,Andhra Pradesh',
'Thootakalingannapeta,Khammam,Andhra Pradesh',
'Timmaraopeta,Khammam,Andhra Pradesh',
'Budharam,Khammam,Andhra Pradesh',
'Dubbagudem,Khammam,Andhra Pradesh',
'Garla,Khammam,Andhra Pradesh',
'Gopalapuram,Khammam,Andhra Pradesh',
'Kamalapuram,Khammam,Andhra Pradesh',
'Mulkanoor,Khammam,Andhra Pradesh',
'Ponnekal,Khammam,Andhra Pradesh',
'Pullur,Khammam,Andhra Pradesh',
'Rampuram,Khammam,Andhra Pradesh',
'Seethampeta,Khammam,Andhra Pradesh',
'Gannerugoyyapadu,Khammam,Andhra Pradesh',
'Gowridevipeta,Khammam,Andhra Pradesh',
'Kachavaram,Khammam,Andhra Pradesh',
'Murumuru,Khammam,Andhra Pradesh',
'Nandigama,Khammam,Andhra Pradesh',
'Tekubaka,Khammam,Andhra Pradesh',
'Thotapalli,Khammam,Andhra Pradesh',
'Ammapeta,Khammam,Andhra Pradesh',
'Chirumarri,Khammam,Andhra Pradesh',
'Gandhasiri,Khammam,Andhra Pradesh',
'Gokinepalli,Khammam,Andhra Pradesh',
'Guvvalagudem`,Khammam,Andhra Pradesh',
'Kamalapuram,Khammam,Andhra Pradesh',
'Kistapuram,Khammam,Andhra Pradesh',
'Mallannapalem,Khammam,Andhra Pradesh',
'Medepalli,Khammam,Andhra Pradesh',
'Mudigonda,Khammam,Andhra Pradesh',
'Pammi,Khammam,Andhra Pradesh',
'Suvarnapuram,Khammam,Andhra Pradesh',
'Vallapuram,Khammam,Andhra Pradesh',
'Venkatapuram,Khammam,Andhra Pradesh',
'Gouthampur,Khammam,Andhra Pradesh',
'Julurpahad,Khammam,Andhra Pradesh',
'Papakole,Khammam,Andhra Pradesh',
'Pokalagudem,Khammam,Andhra Pradesh',
'Ravikampadu,Khammam,Andhra Pradesh',
'Chnadrugonda,Khammam,Andhra Pradesh',
'Damarcharla,Khammam,Andhra Pradesh',
'Gundepudi,Khammam,Andhra Pradesh',
'Kakarla,Khammam,Andhra Pradesh',
'Maddukur,Khammam,Andhra Pradesh',
'P.N.Puram,Khammam,Andhra Pradesh',
'Bathulapalli,Khammam,Andhra Pradesh',
'Chandrupatla,Khammam,Andhra Pradesh',
'Chennur,Khammam,Andhra Pradesh',
'Chinakorukondi,Khammam,Andhra Pradesh',
'Kallur,Khammam,Andhra Pradesh',
'Korlagudem,Khammam,Andhra Pradesh',
'Mucharam,Khammam,Andhra Pradesh',
'Muthagudem,Khammam,Andhra Pradesh',
'Pedakorukondi,Khammam,Andhra Pradesh',
'Peruvancha,Khammam,Andhra Pradesh',
'Tallapenta,Khammam,Andhra Pradesh',
'Talluri Venkatapuram,Khammam,Andhra Pradesh',
'Tekulapalli,Khammam,Andhra Pradesh',
'Telgaram,Khammam,Andhra Pradesh',
'Yerraboinapalli,Khammam,Andhra Pradesh',
'Challasamudram,Khammam,Andhra Pradesh',
'Chimalapad,Khammam,Andhra Pradesh',
'Kamepalli,Khammam,Andhra Pradesh',
'Karepalli,Khammam,Andhra Pradesh',
'Komatlagudem,Khammam,Andhra Pradesh',
'Madhavaram,Khammam,Andhra Pradesh',
'Manikyaram,Khammam,Andhra Pradesh',
'Pathalingala,Khammam,Andhra Pradesh',
'Perupalli,Khammam,Andhra Pradesh',
'Pinjaramadugu,Khammam,Andhra Pradesh',
'Pocharam,Khammam,Andhra Pradesh',
'Relakayalapalli,Khammam,Andhra Pradesh',
'Singareni,Khammam,Andhra Pradesh',
'Tadakalapudi,Khammam,Andhra Pradesh',
'Viswanathapalli,Khammam,Andhra Pradesh',
'Vootukuru,Khammam,Andhra Pradesh',
'Ballepalli,Khammam,Andhra Pradesh',
'Burahanpuram,Khammam,Andhra Pradesh',
'Bus Station(KHM),Khammam,Andhra Pradesh',
'Church Road(KHM),Khammam,Andhra Pradesh',
'Collectorate,Khammam,Andhra Pradesh',
'Dabala Bazar,Khammam,Andhra Pradesh',
'Dharedu,Khammam,Andhra Pradesh',
'Gandhichowk,Khammam,Andhra Pradesh',
'Gollapahad,Khammam,Andhra Pradesh',
'Gopalapuram,Khammam,Andhra Pradesh',
'Gudimalla,Khammam,Andhra Pradesh',
'Gudurpahad,Khammam,Andhra Pradesh',
'Guttalabazar,Khammam,Andhra Pradesh',
'Industrial Area,Khammam,Andhra Pradesh',
'Kachirajugudem,Khammam,Andhra Pradesh',
'Kaikondaigudem,Khammam,Andhra Pradesh',
'Kamanchikal,Khammam,Andhra Pradesh',
'Khammam H.O,Khammam,Andhra Pradesh',
'Khanapuram Haweli,Khammam,Andhra Pradesh',
'Koyachelaka,Khammam,Andhra Pradesh',
'Laxmipuram,Khammam,Andhra Pradesh',
'Mallemadugu,Khammam,Andhra Pradesh',
'Nsc Campus,Khammam,Andhra Pradesh',
'Pandregupalli,Khammam,Andhra Pradesh',
'Papatpalli,Khammam,Andhra Pradesh',
'Raghunadhapalem,Khammam,Andhra Pradesh',
'Seetharampuram,Khammam,Andhra Pradesh',
'Tangampadu,Khammam,Andhra Pradesh',
'Tekulapalli,Khammam,Andhra Pradesh',
'Theerthala,Khammam,Andhra Pradesh',
'Trunk Road,Khammam,Andhra Pradesh',
'Venkatagiri,Khammam,Andhra Pradesh',
'Venkatayapalem,Khammam,Andhra Pradesh',
'Y.C. Roads,Khammam,Andhra Pradesh',
'Yerrupalem,Khammam,Andhra Pradesh',
'Budidampahad,Khammam,Andhra Pradesh',
'Chimmapudi,Khammam,Andhra Pradesh',
'Govindarala,Khammam,Andhra Pradesh',
'Irlapudi,Khammam,Andhra Pradesh',
'Komminepalli,Khammam,Andhra Pradesh',
'Kothalingala,Khammam,Andhra Pradesh',
'Maddulapalli,Khammam,Andhra Pradesh',
'Manchigonda,Khammam,Andhra Pradesh',
'Mucherla,Khammam,Andhra Pradesh',
'Allapalli,Khammam,Andhra Pradesh',
'Ananthogu,Khammam,Andhra Pradesh',
'Anisettipalli,Khammam,Andhra Pradesh',
'Bangaruchelka,Khammam,Andhra Pradesh',
'Bhajanamandir,Khammam,Andhra Pradesh',
'Bodu,Khammam,Andhra Pradesh',
'Chatagonda,Khammam,Andhra Pradesh',
'Chunchupalli,Khammam,Andhra Pradesh',
'Garibpeta,Khammam,Andhra Pradesh',
'Hemachandrapuram,Khammam,Andhra Pradesh',
'Kachanapalli,Khammam,Andhra Pradesh',
'Kothaguda,Khammam,Andhra Pradesh',
'Kothagudem Bazar,Khammam,Andhra Pradesh',
'Kothagudem Colls H.O,Khammam,Andhra Pradesh',
'Lachagudem,Khammam,Andhra Pradesh',
'Laxmidepalli,Khammam,Andhra Pradesh',
'M.E.Complex,Khammam,Andhra Pradesh',
'Mailaram,Khammam,Andhra Pradesh',
'Markodu,Khammam,Andhra Pradesh',
'Muthapuram,Khammam,Andhra Pradesh',
'Nargundukarnagar,Khammam,Andhra Pradesh',
'Ramavaram,Khammam,Andhra Pradesh',
'Regalla,Khammam,Andhra Pradesh',
'Sampathnagar,Khammam,Andhra Pradesh',
'Sca Bldg,Khammam,Andhra Pradesh',
'Venkateshkhani,Khammam,Andhra Pradesh',
'Abhicherla,Khammam,Andhra Pradesh',
'Chinchurevulagudem,Khammam,Andhra Pradesh',
'Kondrajupeta,Khammam,Andhra Pradesh',
'Kunavaram,Khammam,Andhra Pradesh',
'Kuturu,Khammam,Andhra Pradesh',
'Marrigudem,Khammam,Andhra Pradesh',
'Pedarkur,Khammam,Andhra Pradesh',
'Repakagommu,Khammam,Andhra Pradesh',
'Rudramkota,Khammam,Andhra Pradesh',
'Thatkurugommu,Khammam,Andhra Pradesh',
'Velairpahad,Khammam,Andhra Pradesh',
'Gattusingaram,Khammam,Andhra Pradesh',
'Guravaigudem,Khammam,Andhra Pradesh',
'Jakkepalli,Khammam,Andhra Pradesh',
'Kesavapuram,Khammam,Andhra Pradesh',
'Kistapuram,Khammam,Andhra Pradesh',
'Kothuru,Khammam,Andhra Pradesh',
'Kusumanchi,Khammam,Andhra Pradesh',
'Mallepalli,Khammam,Andhra Pradesh',
'Motapuram,Khammam,Andhra Pradesh',
'Mutyalagudem,Khammam,Andhra Pradesh',
'Narasimhulagudem,Khammam,Andhra Pradesh',
'Perikasingaram,Khammam,Andhra Pradesh',
'Turakagudem,Khammam,Andhra Pradesh',
'Allinagaram,Khammam,Andhra Pradesh',
'Ambarupeta,Khammam,Andhra Pradesh',
'Atukuru,Khammam,Andhra Pradesh',
'Chilkuru,Khammam,Andhra Pradesh',
'Dendukuru,Khammam,Andhra Pradesh',
'Desinenipalem,Khammam,Andhra Pradesh',
'Illuru,Khammam,Andhra Pradesh',
'Khammampadu,Khammam,Andhra Pradesh',
'Madhira Bazar,Khammam,Andhra Pradesh',
'Madhira,Khammam,Andhra Pradesh',
'Madupalli,Khammam,Andhra Pradesh',
'Mahadevapuram,Khammam,Andhra Pradesh',
'Maturu,Khammam,Andhra Pradesh',
'Nidanapuram,Khammam,Andhra Pradesh',
'Rayapatnam,Khammam,Andhra Pradesh',
'Vangaveedu,Khammam,Andhra Pradesh',
'Aswapur,Khammam,Andhra Pradesh',
'Chintrial,Khammam,Andhra Pradesh',
'Gondigudem,Khammam,Andhra Pradesh',
'Hwp Aswapur Colony,Khammam,Andhra Pradesh',
'Mittagudem,Khammam,Andhra Pradesh',
'Pagideru,Khammam,Andhra Pradesh',
'Anantharampatti Mallur,Khammam,Andhra Pradesh',
'Ammagaripalli,Khammam,Andhra Pradesh',
'Bayyaram,Khammam,Andhra Pradesh',
'Bhupathiraopeta,Khammam,Andhra Pradesh',
'Duginepalli,Khammam,Andhra Pradesh',
'Gopalaraopeta,Khammam,Andhra Pradesh',
'Janampeta,Khammam,Andhra Pradesh',
'Karakagudem,Khammam,Andhra Pradesh',
'Kondaigudem,Khammam,Andhra Pradesh',
'Mallaram,Khammam,Andhra Pradesh',
'Manuguru,Khammam,Andhra Pradesh',
'Manuguru Colls,Khammam,Andhra Pradesh',
'P.V.Township,Khammam,Andhra Pradesh',
'Pinapaka,Khammam,Andhra Pradesh',
'Singareddipalli,Khammam,Andhra Pradesh',
'Uppaka,Khammam,Andhra Pradesh',
'Mothugudem,Khammam,Andhra Pradesh',
'Pulluru Phc,Khammam,Andhra Pradesh',
'Cherupalli,Khammam,Andhra Pradesh',
'Chidumuru,Khammam,Andhra Pradesh',
'Choppalli,Khammam,Andhra Pradesh',
'Edurallapalli,Khammam,Andhra Pradesh',
'Godlagudem,Khammam,Andhra Pradesh',
'Gogubaka,Khammam,Andhra Pradesh',
'Kolturu,Khammam,Andhra Pradesh',
'Kommuru,Khammam,Andhra Pradesh',
'Laxmipuram,Khammam,Andhra Pradesh',
'Mukunuru,Khammam,Andhra Pradesh',
'Nellipaka,Khammam,Andhra Pradesh',
'Tummala,Khammam,Andhra Pradesh',
'Vegithota,Khammam,Andhra Pradesh',
'Nelakondapalli,Khammam,Andhra Pradesh',
'Acharlagudem,Khammam,Andhra Pradesh',
'Ammagudem,Khammam,Andhra Pradesh',
'Anasagaram,Khammam,Andhra Pradesh',
'Aregudem,Khammam,Andhra Pradesh',
'Bhairavunipalli,Khammam,Andhra Pradesh',
'Bodulabanda,Khammam,Andhra Pradesh',
'Chennaram,Khammam,Andhra Pradesh',
'Koratlagudem,Khammam,Andhra Pradesh',
'Mandrajupalli,Khammam,Andhra Pradesh',
'Mujjugudem,Khammam,Andhra Pradesh',
'Nachepalli,Khammam,Andhra Pradesh',
'Pynampalli,Khammam,Andhra Pradesh',
'Rajeswarapuram,Khammam,Andhra Pradesh',
'Ramachandrapuram,Khammam,Andhra Pradesh',
'Singareddipalem,Khammam,Andhra Pradesh',
'Surdepalli,Khammam,Andhra Pradesh',
'Tirumalapuram,Khammam,Andhra Pradesh',
'Peddireddigudem,Khammam,Andhra Pradesh',
'Abbugudem,Khammam,Andhra Pradesh',
'Annapureddipalli,Khammam,Andhra Pradesh',
'Bhavannapalem,Khammam,Andhra Pradesh',
'Chapralla Palli,Khammam,Andhra Pradesh',
'Pentlam,Khammam,Andhra Pradesh',
'Rajapuram,Khammam,Andhra Pradesh',
'Yatalakunta,Khammam,Andhra Pradesh',
'Bhagyavathaveedu,Khammam,Andhra Pradesh',
'Eswaramadharam,Khammam,Andhra Pradesh',
'Jujjularaopet,Khammam,Andhra Pradesh',
'Nayakangudem,Khammam,Andhra Pradesh',
'Palair,Khammam,Andhra Pradesh',
'Rajupeta,Khammam,Andhra Pradesh',
'Dantalaboru,Khammam,Andhra Pradesh',
'Jagannadhapuram (KP),Khammam,Andhra Pradesh',
'Jagannadhapuram,Khammam,Andhra Pradesh',
'Kamalapuram,Khammam,Andhra Pradesh',
'Karakavagu,Khammam,Andhra Pradesh',
'Kinnersani Project,Khammam,Andhra Pradesh',
'Mukamamidi,Khammam,Andhra Pradesh',
'Mulakalapalli,Khammam,Andhra Pradesh',
'Nagaram,Khammam,Andhra Pradesh',
'Paloncha,Khammam,Andhra Pradesh',
'Pandurangapuram,Khammam,Andhra Pradesh',
'Patha Paloncha,Khammam,Andhra Pradesh',
'Pogallapalli,Khammam,Andhra Pradesh',
'Posugudem,Khammam,Andhra Pradesh',
'Siil Campus,Khammam,Andhra Pradesh',
'T.P.Campus,Khammam,Andhra Pradesh',
'Thogugudem,Khammam,Andhra Pradesh',
'Ulvanoor,Khammam,Andhra Pradesh',
'Yanamboil,Khammam,Andhra Pradesh',
'Bayyannagudem,Khammam,Andhra Pradesh',
'Kuppanakuntla,Khammam,Andhra Pradesh',
'Lankapalli,Khammam,Andhra Pradesh',
'Lingagudem,Khammam,Andhra Pradesh',
'Mandalapahad,Khammam,Andhra Pradesh',
'New Karaigudem,Khammam,Andhra Pradesh',
'Pallewada,Khammam,Andhra Pradesh',
'Penuballi,Khammam,Andhra Pradesh',
'Uppalachelka,Khammam,Andhra Pradesh',
'Yerugatla,Khammam,Andhra Pradesh',
'Dammaigudem,Khammam,Andhra Pradesh',
'Edullacheruvu,Khammam,Andhra Pradesh',
'Hydersaipeta,Khammam,Andhra Pradesh',
'Jallepalli,Khammam,Andhra Pradesh',
'Patharlapahad,Khammam,Andhra Pradesh',
'Tetlapahad,Khammam,Andhra Pradesh',
'Tippareddiguem,Khammam,Andhra Pradesh',
'Pindipolu,Khammam,Andhra Pradesh',
'Rudrampur,Khammam,Andhra Pradesh',
'Kurnapalli,Khammam,Andhra Pradesh',
'Mamidigudem,Khammam,Andhra Pradesh',
'Tegada,Khammam,Andhra Pradesh',
'Sarapaka,Khammam,Andhra Pradesh',
'Bathupalli Ganagaram,Khammam,Andhra Pradesh',
'Duddepudi,Khammam,Andhra Pradesh',
'Gandugulapalli,Khammam,Andhra Pradesh',
'Kakarlapalli,Khammam,Andhra Pradesh',
'Kistaram,Khammam,Andhra Pradesh',
'Modivari,Khammam,Andhra Pradesh',
'Nagupalli,Khammam,Andhra Pradesh',
'Narayanapuram,Khammam,Andhra Pradesh',
'Sadasivunipalem,Khammam,Andhra Pradesh',
'Sathupalli,Khammam,Andhra Pradesh',
'Siddaram,Khammam,Andhra Pradesh',
'Taluk Office(STP),Khammam,Andhra Pradesh',
'Tumburu,Khammam,Andhra Pradesh',
'S.N.Puram,Khammam,Andhra Pradesh',
'Asthanagurthi,Khammam,Andhra Pradesh',
'Brahmanapalli,Khammam,Andhra Pradesh',
'Kalakota,Khammam,Andhra Pradesh',
'Mallaram,Khammam,Andhra Pradesh',
'Paladugu,Khammam,Andhra Pradesh',
'Repalle,Khammam,Andhra Pradesh',
'Siripuram,Khammam,Andhra Pradesh',
'Gommugudem,Khammam,Andhra Pradesh',
'Pedamatasileru,Khammam,Andhra Pradesh',
'Raithwari Kothagudem,Khammam,Andhra Pradesh',
'Bachodu,Khammam,Andhra Pradesh',
'Beerole,Khammam,Andhra Pradesh',
'Chowtapalli,Khammam,Andhra Pradesh',
'Gaigollapalli,Khammam,Andhra Pradesh',
'Hasnabad,Khammam,Andhra Pradesh',
'Jupeda,Khammam,Andhra Pradesh',
'Kakaravai,Khammam,Andhra Pradesh',
'Mahammadapuram,Khammam,Andhra Pradesh',
'Medidepalli,Khammam,Andhra Pradesh',
'Pynampalli,Khammam,Andhra Pradesh',
'Raghunadhapalem,Khammam,Andhra Pradesh',
'Subled,Khammam,Andhra Pradesh',
'Ganugapadu,Khammam,Andhra Pradesh',
'Karivarigudem,Khammam,Andhra Pradesh',
'Raghavapuram,Khammam,Andhra Pradesh',
'Sarvaram,Khammam,Andhra Pradesh',
'Seethampeta,Khammam,Andhra Pradesh',
'Singhabhupalem,Khammam,Andhra Pradesh',
'Sujathanagar,Khammam,Andhra Pradesh',
'Tippanapalli,Khammam,Andhra Pradesh',
'Arekodu,Khammam,Andhra Pradesh',
'Arempula,Khammam,Andhra Pradesh',
'Edulapuram,Khammam,Andhra Pradesh',
'Gopalapuram,Khammam,Andhra Pradesh',
'Kokkireni,Khammam,Andhra Pradesh',
'Muthagudem,Khammam,Andhra Pradesh',
'Pocharam,Khammam,Andhra Pradesh',
'Tallacheruvu,Khammam,Andhra Pradesh',
'Tirumalayapalem,Khammam,Andhra Pradesh',
'Annaruguda,Khammam,Andhra Pradesh',
'Billupahad,Khammam,Andhra Pradesh',
'Kalakodima,Khammam,Andhra Pradesh',
'Kurnavalli,Khammam,Andhra Pradesh',
'Mallaram,Khammam,Andhra Pradesh',
'Mittapalli,Khammam,Andhra Pradesh',
'Muddunuru,Khammam,Andhra Pradesh',
'Noothankal,Khammam,Andhra Pradesh',
'Tallada,Khammam,Andhra Pradesh',
'Chegomma,Khammam,Andhra Pradesh',
'Edavalli,Khammam,Andhra Pradesh',
'Jeelacheruvu,Khammam,Andhra Pradesh',
'Kattakuru,Khammam,Andhra Pradesh',
'Kondapuram,Khammam,Andhra Pradesh',
'Lokya Thanda,Khammam,Andhra Pradesh',
'Maddulapalli,Khammam,Andhra Pradesh',
'Madhapuram,Khammam,Andhra Pradesh',
'Munigepalli,Khammam,Andhra Pradesh',
'Nelapatla,Khammam,Andhra Pradesh',
'Ponnekal,Khammam,Andhra Pradesh',
'Tallampahad,Khammam,Andhra Pradesh',
'Teldarupalli,Khammam,Andhra Pradesh',
'Ammapalem,Khammam,Andhra Pradesh',
'Chinagopathi,Khammam,Andhra Pradesh',
'Gopathi,Khammam,Andhra Pradesh',
'Gopavaram,Khammam,Andhra Pradesh',
'Kondavanamala,Khammam,Andhra Pradesh',
'Konijerla,Khammam,Andhra Pradesh',
'Lingagudem,Khammam,Andhra Pradesh',
'Munagala,Khammam,Andhra Pradesh',
'Tanikella,Khammam,Andhra Pradesh',
'Tummalapalli,Khammam,Andhra Pradesh',
'Rekapalli,Khammam,Andhra Pradesh',
'V.R.Puram,Khammam,Andhra Pradesh',
'Arasarlapadu,Khammam,Andhra Pradesh',
'Kallorgudem,Khammam,Andhra Pradesh',
'Kandukur,Khammam,Andhra Pradesh',
'Kunchaparthi,Khammam,Andhra Pradesh',
'Marlapadu,Khammam,Andhra Pradesh',
'Racharla,Khammam,Andhra Pradesh',
'Vemsur,Khammam,Andhra Pradesh',
'Venkatapuram,Khammam,Andhra Pradesh',
'Chandrupatla,Khammam,Andhra Pradesh',
'Cherukuru,Khammam,Andhra Pradesh',
'Edicharlapalli,Khammam,Andhra Pradesh',
'Gummadidoddi,Khammam,Andhra Pradesh',
'Kongala,Khammam,Andhra Pradesh',
'Murumuru,Khammam,Andhra Pradesh',
'Pegallapalli,Khammam,Andhra Pradesh',
'Venkatapuram,Khammam,Andhra Pradesh',
'Wazeedu Nagaram,Khammam,Andhra Pradesh',
'Peruru,Khammam,Andhra Pradesh',
'Penagadapa,Khammam,Andhra Pradesh',
'Chintaregupalli,Khammam,Andhra Pradesh',
'Jeediguppa,Khammam,Andhra Pradesh',
'Katukuru,Khammam,Andhra Pradesh',
'Koida,Khammam,Andhra Pradesh',
'Pedamittapalli,Khammam,Andhra Pradesh',
'Sriramgiri,Khammam,Andhra Pradesh',
'Ummadivaram,Khammam,Andhra Pradesh',
'Vaddigudem,Khammam,Andhra Pradesh',
'Allipuram,Khammam,Andhra Pradesh',
'Basavapuram,Khammam,Andhra Pradesh',
'Mallepalli Chintagurthi,Khammam,Andhra Pradesh',
'V.V.Palem,Khammam,Andhra Pradesh',
'Vandanam,Khammam,Andhra Pradesh',
'Velugumatla,Khammam,Andhra Pradesh',
'Vepakuntla,Khammam,Andhra Pradesh',
'Gannavaram,Khammam,Andhra Pradesh',
'Garikapadu,Khammam,Andhra Pradesh',
'Gollapudi,Khammam,Andhra Pradesh',
'Gubbagurthi,Khammam,Andhra Pradesh',
'Khanapuram,Khammam,Andhra Pradesh',
'Kondakodima,Khammam,Andhra Pradesh',
'Musalimadugu,Khammam,Andhra Pradesh',
'Narapunenipalli,Khammam,Andhra Pradesh',
'Pallipadu,Khammam,Andhra Pradesh',
'Pinapaka,Khammam,Andhra Pradesh',
'Punyapur,Khammam,Andhra Pradesh',
'Rebbavaram,Khammam,Andhra Pradesh',
'Singarayapalem,Khammam,Andhra Pradesh',
'Siripuram Kanigiri,Khammam,Andhra Pradesh',
'Snanala Laxmipuram,Khammam,Andhra Pradesh',
'Somavaram,Khammam,Andhra Pradesh',
'Tatipudi,Khammam,Andhra Pradesh',
'Vippalamadaka,Khammam,Andhra Pradesh',
'Wyra,Khammam,Andhra Pradesh',
'Ragaboinagudem,Khammam,Andhra Pradesh',
'Seetharampuram,Khammam,Andhra Pradesh',
'B N Thanda,Khammam,Andhra Pradesh',
'Bethampudi,Khammam,Andhra Pradesh',
'Gundala,Khammam,Andhra Pradesh',
'Koyagudem,Khammam,Andhra Pradesh',
'Lingagudem,Khammam,Andhra Pradesh',
'Pegallapadu,Khammam,Andhra Pradesh',
'Sayanapalli,Khammam,Andhra Pradesh',
'Sudimalla,Khammam,Andhra Pradesh',
'Sulanagar,Khammam,Andhra Pradesh',
'Tekulapalli,Khammam,Andhra Pradesh',
'Usirikayalapalli,Khammam,Andhra Pradesh',
'Yellandu Colls,Khammam,Andhra Pradesh',
'Yellandu,Khammam,Andhra Pradesh',
'Komararam,Khammam,Andhra Pradesh',
'Manikyaram,Khammam,Andhra Pradesh',
'Rompaid,Khammam,Andhra Pradesh',
'Settipalli,Khammam,Andhra Pradesh',
'Enagali,Khammam,Andhra Pradesh',
'Jamalapuram,Khammam,Andhra Pradesh',
'Kothapalem,Khammam,Andhra Pradesh',
'Meenavolu,Khammam,Andhra Pradesh',
'Pegallapadu,Khammam,Andhra Pradesh',
'Ramannapalem,Khammam,Andhra Pradesh',
'Remidicherla,Khammam,Andhra Pradesh',
'Sakinaveedu,Khammam,Andhra Pradesh',
'Siddinenigudem,Khammam,Andhra Pradesh',
'Takkellapadu,Khammam,Andhra Pradesh',
'Tondalagopavaram,Khammam,Andhra Pradesh',
'Venkatapuram,Khammam,Andhra Pradesh',
'Konduru,Vijayawada,Andhra Pradesh',
'Serigolvepalli,Gudivada,Andhra Pradesh',
'Chinaogirala,Vijayawada,Andhra Pradesh',
'Kunderu,Vijayawada,Andhra Pradesh',
'Nepalli,Vijayawada,Andhra Pradesh',
'Pedaogirala,Vijayawada,Andhra Pradesh',
'Thotapalli,Vijayawada,Andhra Pradesh',
'Vattigudipadu,Vijayawada,Andhra Pradesh',
'Aswaraopalem,Machilipatnam,Andhra Pradesh',
'Avanigadda H.O,Machilipatnam,Andhra Pradesh',
'Bandlaicheruvu,Machilipatnam,Andhra Pradesh',
'Edlalanka,Machilipatnam,Andhra Pradesh',
'Gandhikshetram,Machilipatnam,Andhra Pradesh',
'Kothapet(Divi),Machilipatnam,Andhra Pradesh',
'Modumudi,Machilipatnam,Andhra Pradesh',
'Pittalalanka,Machilipatnam,Andhra Pradesh',
'Puligadda,Machilipatnam,Andhra Pradesh',
'Ramachandrapuram(Divi),Machilipatnam,Andhra Pradesh',
'Salempalem,Machilipatnam,Andhra Pradesh',
'V.Kothapalem,Machilipatnam,Andhra Pradesh',
'Vekanuru,Machilipatnam,Andhra Pradesh',
'Viswanadhapalli,Machilipatnam,Andhra Pradesh',
'Balaramunipet,Machilipatnam,Andhra Pradesh',
'Batchupet,Machilipatnam,Andhra Pradesh',
'Bhaskarapuram,Machilipatnam,Andhra Pradesh',
'Brahmapuram,Machilipatnam,Andhra Pradesh',
'Buttaipet,Machilipatnam,Andhra Pradesh',
'Chilakalapudi,Machilipatnam,Andhra Pradesh',
'Chinnapuram,Machilipatnam,Andhra Pradesh',
'Chintaguntapalem,Machilipatnam,Andhra Pradesh',
'Desaipet,Machilipatnam,Andhra Pradesh',
'Dt.Court,Machilipatnam,Andhra Pradesh',
'Gilakaladindi,Machilipatnam,Andhra Pradesh',
'Godugupet,Machilipatnam,Andhra Pradesh',
'Gundupalem,Machilipatnam,Andhra Pradesh',
'Inagudurupet,Machilipatnam,Andhra Pradesh',
'K.P.Pur,Machilipatnam,Andhra Pradesh',
'Kammavaricheruvu,Machilipatnam,Andhra Pradesh',
'Kanuru,Machilipatnam,Andhra Pradesh',
'Karagraharam,Machilipatnam,Andhra Pradesh',
'Machavaram,Machilipatnam,Andhra Pradesh',
'Machilipatnam H.O,Machilipatnam,Andhra Pradesh',
'Malakapatnam,Machilipatnam,Andhra Pradesh',
'Manginapudi,Machilipatnam,Andhra Pradesh',
'Mpm Fort,Machilipatnam,Andhra Pradesh',
'Pedapatnam,Machilipatnam,Andhra Pradesh',
'Pedayadara,Machilipatnam,Andhra Pradesh',
'Polatitippa,Machilipatnam,Andhra Pradesh',
'Pothepalli,Machilipatnam,Andhra Pradesh',
'Pothireddipalem,Machilipatnam,Andhra Pradesh',
'Rajupet,Machilipatnam,Andhra Pradesh',
'Rudravaram,Machilipatnam,Andhra Pradesh',
'S.N.Gollapalem,Machilipatnam,Andhra Pradesh',
'Saradanagar,Machilipatnam,Andhra Pradesh',
'Tallapalem,Machilipatnam,Andhra Pradesh',
'Tummalacheruvu,Machilipatnam,Andhra Pradesh',
'U.G.C.Works,Machilipatnam,Andhra Pradesh',
'Vadapalem,Machilipatnam,Andhra Pradesh',
'Valandapalem,Machilipatnam,Andhra Pradesh',
'Penumalli,Machilipatnam,Andhra Pradesh',
'Amudalapalli,Gudivada,Andhra Pradesh',
'Arthamuru,Machilipatnam,Andhra Pradesh',
'Bantumilli,Gudivada,Andhra Pradesh',
'Chinatummidi,Gudivada,Andhra Pradesh',
'Chorampudi,Gudivada,Andhra Pradesh',
'Jayapuram,Gudivada,Andhra Pradesh',
'Jinjeru,Machilipatnam,Andhra Pradesh',
'Kakarlamudi,Machilipatnam,Andhra Pradesh',
'Kanchadam,Machilipatnam,Andhra Pradesh',
'Korlapadu,Gudivada,Andhra Pradesh',
'Korlapadu,Gudivada,Andhra Pradesh',
'Lakshmipuram,Gudivada,Andhra Pradesh',
'Lodidalanka,Gudivada,Andhra Pradesh',
'Malleswaram,Gudivada,Andhra Pradesh',
'Mulaparru,Gudivada,Andhra Pradesh',
'Munjuluru,Machilipatnam,Andhra Pradesh',
'Nandamuru,Machilipatnam,Andhra Pradesh',
'Pedatummidi,Gudivada,Andhra Pradesh',
'Pendurru,Gudivada,Andhra Pradesh',
'Perekegudem,Gudivada,Andhra Pradesh',
'Satulru,Machilipatnam,Andhra Pradesh',
'Singanapudi,Gudivada,Andhra Pradesh',
'Arugolanu,Gudivada,Andhra Pradesh',
'Bapulapadu,Gudivada,Andhra Pradesh',
'Billanapalli,Gudivada,Andhra Pradesh',
'Bommuluru,Gudivada,Andhra Pradesh',
'Hanuman Junction,Gudivada,Andhra Pradesh',
'Kakulapadu,Gudivada,Andhra Pradesh',
'Kanumolu,Gudivada,Andhra Pradesh',
'Koyyuru,Gudivada,Andhra Pradesh',
'Mallavalli,Gudivada,Andhra Pradesh',
'Medicherla,Gudivada,Andhra Pradesh',
'Perikeedu Bridge,Gudivada,Andhra Pradesh',
'Ramannagudem,Gudivada,Andhra Pradesh',
'Serinarasannapalem,Gudivada,Andhra Pradesh',
'Tippanagunta,Gudivada,Andhra Pradesh',
'Kothapalli,Gudivada,Andhra Pradesh',
'Popuru,Vijayawada,Andhra Pradesh',
'Bhogireddipalli,Machilipatnam,Andhra Pradesh',
'Challapalli,Machilipatnam,Andhra Pradesh',
'Lakshmipuram,Machilipatnam,Andhra Pradesh',
'Majeru,Machilipatnam,Andhra Pradesh',
'Mangalapuram,Machilipatnam,Andhra Pradesh',
'Nadakuduru,Machilipatnam,Andhra Pradesh',
'Pagolu,Machilipatnam,Andhra Pradesh',
'Vakkalagadda,Machilipatnam,Andhra Pradesh',
'Velivolu,Machilipatnam,Andhra Pradesh',
'Yarlagadda,Machilipatnam,Andhra Pradesh',
'Kasarabad,Vijayawada,Andhra Pradesh',
'Gudimetla,Vijayawada,Andhra Pradesh',
'Kodavatikallu,Vijayawada,Andhra Pradesh',
'Konayapalem,Vijayawada,Andhra Pradesh',
'Pokkunuru,Vijayawada,Andhra Pradesh',
'Punnavalli,Vijayawada,Andhra Pradesh',
'Veladikothapalem,Vijayawada,Andhra Pradesh',
'Chatrai,Gudivada,Andhra Pradesh',
'Chinnampet,Gudivada,Andhra Pradesh',
'Chittapur,Gudivada,Andhra Pradesh',
'Gudipadu,Gudivada,Andhra Pradesh',
'Janardhanavaram,Gudivada,Andhra Pradesh',
'Kotapadu,Gudivada,Andhra Pradesh',
'Krishnaraopalem,Gudivada,Andhra Pradesh',
'Polavaram,Gudivada,Andhra Pradesh',
'Pothanapalli,Gudivada,Andhra Pradesh',
'Somavaram,Gudivada,Andhra Pradesh',
'Tsanubanda,Gudivada,Andhra Pradesh',
'Tummagudem,Gudivada,Andhra Pradesh',
'Ammireddigudem,Vijayawada,Andhra Pradesh',
'Arlapadu,Vijayawada,Andhra Pradesh',
'Erramadu,Vijayawada,Andhra Pradesh',
'Gosavedu,Vijayawada,Andhra Pradesh',
'Gullapudi,Vijayawada,Andhra Pradesh',
'Kanumuru,Vijayawada,Andhra Pradesh',
'Vinagadapa,Vijayawada,Andhra Pradesh',
'Kothapalli,Vijayawada,Andhra Pradesh',
'Chinakallepalli,Machilipatnam,Andhra Pradesh',
'Chitturupu,Machilipatnam,Andhra Pradesh',
'Daliparru,Machilipatnam,Andhra Pradesh',
'Devarakota,Machilipatnam,Andhra Pradesh',
'Endakuduru,Machilipatnam,Andhra Pradesh',
'Ghantasala,Machilipatnam,Andhra Pradesh',
'Ghantasalapalem,Machilipatnam,Andhra Pradesh',
'Kodali,Machilipatnam,Andhra Pradesh',
'Lankapalli,Machilipatnam,Andhra Pradesh',
'Mallampalli,Machilipatnam,Andhra Pradesh',
'Papanasanam,Machilipatnam,Andhra Pradesh',
'Srikakulam,Machilipatnam,Andhra Pradesh',
'Tadepalli,Machilipatnam,Andhra Pradesh',
'V.Rudravaram,Machilipatnam,Andhra Pradesh',
'Bethavolu,Gudivada,Andhra Pradesh',
'Bommuluru,Gudivada,Andhra Pradesh',
'Chinayerukapadu,Gudivada,Andhra Pradesh',
'Chowtapalli,Gudivada,Andhra Pradesh',
'Dondapadu,Gudivada,Andhra Pradesh',
'Gudivada H.O,Gudivada,Andhra Pradesh',
'Gudivada Railway Station,Gudivada,Andhra Pradesh',
'Guntakoduru,Gudivada,Andhra Pradesh',
'Jagannadhapuram,Gudivada,Andhra Pradesh',
'K.P.Agraharam,Gudivada,Andhra Pradesh',
'Lingavaram,Gudivada,Andhra Pradesh',
'Moturu,Gudivada,Andhra Pradesh',
'Rajendranagar Colony,Gudivada,Andhra Pradesh',
'Satyanarayanapuram,Gudivada,Andhra Pradesh',
'Siddantham,Gudivada,Andhra Pradesh',
'Tativarru,Gudivada,Andhra Pradesh',
'Valivarthipadu,Gudivada,Andhra Pradesh',
'Angaluru,Gudivada,Andhra Pradesh',
'Chandrala,Gudivada,Andhra Pradesh',
'Daggumailli,Machilipatnam,Andhra Pradesh',
'Gudlavalleru,Machilipatnam,Andhra Pradesh',
'Jakkamcherla,Machilipatnam,Andhra Pradesh',
'Kavipuram,Machilipatnam,Andhra Pradesh',
'Kongamcherla,Machilipatnam,Andhra Pradesh',
'Kurada,Machilipatnam,Andhra Pradesh',
'Mamidikolla,Machilipatnam,Andhra Pradesh',
'Mukkollu,Machilipatnam,Andhra Pradesh',
'Nagavaram,Machilipatnam,Andhra Pradesh',
'Nuzella,Gudivada,Andhra Pradesh',
'Penjendra,Machilipatnam,Andhra Pradesh',
'Pesaramilli,Machilipatnam,Andhra Pradesh',
'Serikalavapudi,Gudivada,Andhra Pradesh',
'Vadlamannadu,Machilipatnam,Andhra Pradesh',
'Vemavaram,Machilipatnam,Andhra Pradesh',
'Venturumilli,Machilipatnam,Andhra Pradesh',
'Vinnakota,Gudivada,Andhra Pradesh',
'Dokiparru,Machilipatnam,Andhra Pradesh',
'Kavutaram,Machilipatnam,Andhra Pradesh',
'Akumarru,Machilipatnam,Andhra Pradesh',
'Chittiguduru,Machilipatnam,Andhra Pradesh',
'Elakurru,Machilipatnam,Andhra Pradesh',
'Guduru,Machilipatnam,Andhra Pradesh',
'Kanchakoduru,Machilipatnam,Andhra Pradesh',
'Kankata,Machilipatnam,Andhra Pradesh',
'Kokanarayanapalem,Machilipatnam,Andhra Pradesh',
'Maddipatla,Machilipatnam,Andhra Pradesh',
'Mallavolu,Machilipatnam,Andhra Pradesh',
'Polavaram(K),Machilipatnam,Andhra Pradesh',
'Ramannapet,Machilipatnam,Andhra Pradesh',
'Rayavaram,Machilipatnam,Andhra Pradesh',
'Tarakaturu,Machilipatnam,Andhra Pradesh',
'Muktyala,Vijayawada,Andhra Pradesh',
'Vedadri,Vijayawada,Andhra Pradesh',
'Achavaram,Gudivada,Andhra Pradesh',
'Alapadu R.S.,Gudivada,Andhra Pradesh',
'Atapaka,Gudivada,Andhra Pradesh',
'Bhujabalapatnam,Gudivada,Andhra Pradesh',
'Doddipatla,Gudivada,Andhra Pradesh',
'Gopavaram,Gudivada,Andhra Pradesh',
'Kaikalur,Gudivada,Andhra Pradesh',
'Kolletikota,Gudivada,Andhra Pradesh',
'Kottada,Gudivada,Andhra Pradesh',
'Pallevada,Gudivada,Andhra Pradesh',
'Penchikalamarru,Gudivada,Andhra Pradesh',
'Seetanapalli,Gudivada,Andhra Pradesh',
'Tamarakollu,Gudivada,Andhra Pradesh',
'Vadarlapadu,Gudivada,Andhra Pradesh',
'Varahapatnam,Gudivada,Andhra Pradesh',
'Vemavarappadu,Gudivada,Andhra Pradesh',
'Vinjaram,Gudivada,Andhra Pradesh',
'Komatigunta Lock,Gudivada,Andhra Pradesh',
'Tenneru,Gudivada,Andhra Pradesh',
'Kalidindi Centre,Gudivada,Andhra Pradesh',
'Kalidindi,Gudivada,Andhra Pradesh',
'Kallapalem,Gudivada,Andhra Pradesh',
'Kondangi,Gudivada,Andhra Pradesh',
'Korukollu,Gudivada,Andhra Pradesh',
'Mattagunta,Gudivada,Andhra Pradesh',
'Mulaupparagudem,Gudivada,Andhra Pradesh',
'Pedalanka,Gudivada,Andhra Pradesh',
'Pothumarru,Gudivada,Andhra Pradesh',
'Sanarudravaram,Gudivada,Andhra Pradesh',
'Santhoshapuram,Gudivada,Andhra Pradesh',
'Tadinada,Gudivada,Andhra Pradesh',
'Venkatapuram,Gudivada,Andhra Pradesh',
'Konduru,Gudivada,Andhra Pradesh',
'Boddapadu,Vijayawada,Andhra Pradesh',
'Edupugallu,Vijayawada,Andhra Pradesh',
'Godavarru,Vijayawada,Andhra Pradesh',
'Madduru,Vijayawada,Andhra Pradesh',
'Manthena,Vijayawada,Andhra Pradesh',
'Proddutur,Vijayawada,Andhra Pradesh',
'Uppaluru,Vijayawada,Andhra Pradesh',
'Vanukuru,Vijayawada,Andhra Pradesh',
'Kalavapamula,Vijayawada,Andhra Pradesh',
'Divigollapalem,Machilipatnam,Andhra Pradesh',
'Hamsaladeevi,Machilipatnam,Andhra Pradesh',
'Jayapuram,Machilipatnam,Andhra Pradesh',
'Koduru,Machilipatnam,Andhra Pradesh',
'Lingareddipalem,Machilipatnam,Andhra Pradesh',
'Mandapakala,Machilipatnam,Andhra Pradesh',
'Swatantrapuram,Machilipatnam,Andhra Pradesh',
'Ullipalem,Machilipatnam,Andhra Pradesh',
'Ida Kondaplli,Vijayawada,Andhra Pradesh',
'Ilaprolu,Vijayawada,Andhra Pradesh',
'Kavuluru,Vijayawada,Andhra Pradesh',
'Pinapaka,Vijayawada,Andhra Pradesh',
'A.C.Company,Vijayawada,Andhra Pradesh',
'A.P.H.B.Colony,Vijayawada,Andhra Pradesh',
'A.P.U.H.S,Vijayawada,Andhra Pradesh',
'Adavinekkalam,Vijayawada,Andhra Pradesh',
'Agniparru,Vijayawada,Andhra Pradesh',
'Akunuru,Vijayawada,Andhra Pradesh',
'Allapuram,Vijayawada,Andhra Pradesh',
'Alluru,Vijayawada,Andhra Pradesh',
'Ambapuram,Vijayawada,Andhra Pradesh',
'Ambedkarnagar,Vijayawada,Andhra Pradesh',
'Aminapuram,Vijayawada,Andhra Pradesh',
'Anigandlapadu,Vijayawada,Andhra Pradesh',
'Anumanchipalli,Vijayawada,Andhra Pradesh',
'Arundalpet,Vijayawada,Andhra Pradesh',
'Atkur,Vijayawada,Andhra Pradesh',
'Atkuru,Vijayawada,Andhra Pradesh',
'Aukiripalli,Vijayawada,Andhra Pradesh',
'Autonagar,Vijayawada,Andhra Pradesh',
'Azitnagar,Vijayawada,Andhra Pradesh',
'Azzampudi,Vijayawada,Andhra Pradesh',
'Bacon Factory,Vijayawada,Andhra Pradesh',
'Bahubalendrunigudem,Vijayawada,Andhra Pradesh',
'Balusupadu,Vijayawada,Andhra Pradesh',
'Bandipalem,Vijayawada,Andhra Pradesh',
'Besant Road,Vijayawada,Andhra Pradesh',
'Bhadrirajupalem,Vijayawada,Andhra Pradesh',
'Bhavanipuram,Vijayawada,Andhra Pradesh',
'Bhimavaram,Vijayawada,Andhra Pradesh',
'Bobbellapadu,Vijayawada,Andhra Pradesh',
'Buckinghampet H.O,Vijayawada,Andhra Pradesh',
'Budavada,Vijayawada,Andhra Pradesh',
'Budhavaram,Vijayawada,Andhra Pradesh',
'Buthumillipadu,Vijayawada,Andhra Pradesh',
'Chagantipadu,Vijayawada,Andhra Pradesh',
'Chandapuram,Vijayawada,Andhra Pradesh',
'Chandarlapadu,Vijayawada,Andhra Pradesh',
'Chandrala,Vijayawada,Andhra Pradesh',
'Chandramoulipuram,Vijayawada,Andhra Pradesh',
'Chandrgudem,Vijayawada,Andhra Pradesh',
'Chavutapalli,Vijayawada,Andhra Pradesh',
'Cheemalapadu,Vijayawada,Andhra Pradesh',
'Chennaraopalem,Vijayawada,Andhra Pradesh',
'Cheruvu Madhavaram,Vijayawada,Andhra Pradesh',
'Cheruvukommupalem,Vijayawada,Andhra Pradesh',
'Chevitikallu,Vijayawada,Andhra Pradesh',
'Chevutur,Vijayawada,Andhra Pradesh',
'Chikkavaram,Vijayawada,Andhra Pradesh',
'Chillakallu,Vijayawada,Andhra Pradesh',
'Chilukuru,Vijayawada,Andhra Pradesh',
'China Nandigama,Vijayawada,Andhra Pradesh',
'Chintalapadu,Vijayawada,Andhra Pradesh',
'Chittinagar,Vijayawada,Andhra Pradesh',
'Chodavaram,Vijayawada,Andhra Pradesh',
'Chopparametla,Vijayawada,Andhra Pradesh',
'Choragudi,Vijayawada,Andhra Pradesh',
'Chowtapalli,Vijayawada,Andhra Pradesh',
'Civil Coursts,Vijayawada,Andhra Pradesh',
'Dabbakupalli,Vijayawada,Andhra Pradesh',
'Dachavaram,Vijayawada,Andhra Pradesh',
'Damulur,Vijayawada,Andhra Pradesh',
'Damuluru,Vijayawada,Andhra Pradesh',
'Devarapalli,Vijayawada,Andhra Pradesh',
'Doddadevarapadu,Vijayawada,Andhra Pradesh',
'Duggiralapadu,Vijayawada,Andhra Pradesh',
'Durga Agraharam,Vijayawada,Andhra Pradesh',
'Durgapuram,Vijayawada,Andhra Pradesh',
'Edara,Vijayawada,Andhra Pradesh',
'Enikepadu,Vijayawada,Andhra Pradesh',
'Eturu,Vijayawada,Andhra Pradesh',
'G Konduru,Vijayawada,Andhra Pradesh',
'Gampalagudem,Vijayawada,Andhra Pradesh',
'Ganapavaram,Vijayawada,Andhra Pradesh',
'Gandepalli,Vijayawada,Andhra Pradesh',
'Gandhinagaram,Vijayawada,Andhra Pradesh',
'Gandigunta,Vijayawada,Andhra Pradesh',
'Gandrai,Vijayawada,Andhra Pradesh',
'Gangapadu,Vijayawada,Andhra Pradesh',
'Ganginenipalem,Vijayawada,Andhra Pradesh',
'Ganguru,Vijayawada,Andhra Pradesh',
'Gani Atkuru,Vijayawada,Andhra Pradesh',
'Gannavaram Centre,Vijayawada,Andhra Pradesh',
'Gannavaram,Vijayawada,Andhra Pradesh',
'Garikiparru,Vijayawada,Andhra Pradesh',
'Gollamandala,Vijayawada,Andhra Pradesh',
'Gollamudi,Vijayawada,Andhra Pradesh',
'Gollanapalli,Vijayawada,Andhra Pradesh',
'Gollapudi,Vijayawada,Andhra Pradesh',
'Gopavarapugudem,Vijayawada,Andhra Pradesh',
'Gopinenipalem,Vijayawada,Andhra Pradesh',
'Gopuvanipalem,Vijayawada,Andhra Pradesh',
'Gottumukkala,Vijayawada,Andhra Pradesh',
'Gowravaram,Vijayawada,Andhra Pradesh',
'Gudavalli,Vijayawada,Andhra Pradesh',
'Gudem Madhavaram,Vijayawada,Andhra Pradesh',
'Gummadidurru,Vijayawada,Andhra Pradesh',
'Gunadala,Vijayawada,Andhra Pradesh',
'Guntupalli,Vijayawada,Andhra Pradesh',
'Gurazada,Vijayawada,Andhra Pradesh',
'Guruvindapalli,Vijayawada,Andhra Pradesh',
'Guttavaripalem,Vijayawada,Andhra Pradesh',
'H Mutyalampadu,Vijayawada,Andhra Pradesh',
'Hanumanthapuram,Vijayawada,Andhra Pradesh',
'Ibrahimpatnam,Vijayawada,Andhra Pradesh',
'Idulagudem,Vijayawada,Andhra Pradesh',
'Iluru,Vijayawada,Andhra Pradesh',
'Inapur,Vijayawada,Andhra Pradesh',
'Industrial Estate,Vijayawada,Andhra Pradesh',
'Ithavaram,Vijayawada,Andhra Pradesh',
'Jaccampudi,Vijayawada,Andhra Pradesh',
'Jaggaiahpet,Vijayawada,Andhra Pradesh',
'Jami Annavaram,Vijayawada,Andhra Pradesh',
'Jammavaram,Vijayawada,Andhra Pradesh',
'Jayanthi,Vijayawada,Andhra Pradesh',
'Jayanthipuram,Vijayawada,Andhra Pradesh',
'Jonnalagadda,Vijayawada,Andhra Pradesh',
'Jupudi,Vijayawada,Andhra Pradesh',
'Juzzuru,Vijayawada,Andhra Pradesh',
'Kadavakollu,Vijayawada,Andhra Pradesh',
'Kakaravai,Vijayawada,Andhra Pradesh',
'Kakarla,Vijayawada,Andhra Pradesh',
'Kamakotinagar,Vijayawada,Andhra Pradesh',
'Kammavaripalem,Vijayawada,Andhra Pradesh',
'Kanakavalli,Vijayawada,Andhra Pradesh',
'Kanasanapalli,Vijayawada,Andhra Pradesh',
'Kanchala,Vijayawada,Andhra Pradesh',
'Kanchikacharla,Vijayawada,Andhra Pradesh',
'Kankipadu,Vijayawada,Andhra Pradesh',
'Kannevidu,Vijayawada,Andhra Pradesh',
'Kanumuru,Vijayawada,Andhra Pradesh',
'Kanuru,Vijayawada,Andhra Pradesh',
'Kapileswarapuram,Vijayawada,Andhra Pradesh',
'Katuru,Vijayawada,Andhra Pradesh',
'Kesarapalli,Vijayawada,Andhra Pradesh',
'Ketanakonda,Vijayawada,Andhra Pradesh',
'Kethaveerunipadu,Vijayawada,Andhra Pradesh',
'Khambampadu,Vijayawada,Andhra Pradesh',
'Khambhampadu,Vijayawada,Andhra Pradesh',
'Koduru,Vijayawada,Andhra Pradesh',
'Konakanchi,Vijayawada,Andhra Pradesh',
'Konathamatmakur,Vijayawada,Andhra Pradesh',
'Kondapalli,Vijayawada,Andhra Pradesh',
'Konduru,Vijayawada,Andhra Pradesh',
'Konduru,Vijayawada,Andhra Pradesh',
'Kontalapalli,Vijayawada,Andhra Pradesh',
'Kotha Edara,Vijayawada,Andhra Pradesh',
'Kothapet,Vijayawada,Andhra Pradesh',
'Kotikalapudi,Vijayawada,Andhra Pradesh',
'Krishnapuram,Vijayawada,Andhra Pradesh',
'Kuderu,Vijayawada,Andhra Pradesh',
'Kumaraswamy Raja Nagar,Vijayawada,Andhra Pradesh',
'Kuntamukkala,Vijayawada,Andhra Pradesh',
'Lakshmana Nagar,Vijayawada,Andhra Pradesh',
'Lakshminagar,Vijayawada,Andhra Pradesh',
'Lime Stone Town Ship,Vijayawada,Andhra Pradesh',
'Lingagudem,Vijayawada,Andhra Pradesh',
'Lingala,Vijayawada,Andhra Pradesh',
'Lingalapadu,Vijayawada,Andhra Pradesh',
'Machinenipalem,Vijayawada,Andhra Pradesh',
'Madhurapuram,Vijayawada,Andhra Pradesh',
'Magallu,Vijayawada,Andhra Pradesh',
'Makkapeta,Vijayawada,Andhra Pradesh',
'Malkapuram,Vijayawada,Andhra Pradesh',
'Mangollu,Vijayawada,Andhra Pradesh',
'Mantada,Vijayawada,Andhra Pradesh',
'Marrivada,Vijayawada,Andhra Pradesh',
'Meduru,Vijayawada,Andhra Pradesh',
'Moguluru,Vijayawada,Andhra Pradesh',
'Morusumilli,Vijayawada,Andhra Pradesh',
'Muchintala,Vijayawada,Andhra Pradesh',
'Mulapadu,Vijayawada,Andhra Pradesh',
'Munagacherla,Vijayawada,Andhra Pradesh',
'Mundlapadu,Vijayawada,Andhra Pradesh',
'Munnaluru,Vijayawada,Andhra Pradesh',
'Muppalla,Vijayawada,Andhra Pradesh',
'Mustabad,Vijayawada,Andhra Pradesh',
'Mylavaram,Vijayawada,Andhra Pradesh',
'Naguluru,Vijayawada,Andhra Pradesh',
'Nandigama Bazar,Vijayawada,Andhra Pradesh',
'Nandigama,Vijayawada,Andhra Pradesh',
'Narasimharaopalem,Vijayawada,Andhra Pradesh',
'Narasingapalem,Vijayawada,Andhra Pradesh',
'Nawabpet,Vijayawada,Andhra Pradesh',
'Nugondapalli,Vijayawada,Andhra Pradesh',
'Nunna,Vijayawada,Andhra Pradesh',
'Paidurupadu,Vijayawada,Andhra Pradesh',
'Pallagiri,Vijayawada,Andhra Pradesh',
'Pamidimukkala,Vijayawada,Andhra Pradesh',
'Pamulalanka,Vijayawada,Andhra Pradesh',
'Paritala,Vijayawada,Andhra Pradesh',
'Patamatalankapalli,Vijayawada,Andhra Pradesh',
'Pathapadu,Vijayawada,Andhra Pradesh',
'Payakapuram.,Vijayawada,Andhra Pradesh',
'Peda Modugapalli,Vijayawada,Andhra Pradesh',
'Pedavutapalli,Vijayawada,Andhra Pradesh',
'Peddapuram,Vijayawada,Andhra Pradesh',
'Penamakuru,Vijayawada,Andhra Pradesh',
'Penamaluru,Vijayawada,Andhra Pradesh',
'Pendyala,Vijayawada,Andhra Pradesh',
'Pentalavarigudem,Vijayawada,Andhra Pradesh',
'Penuganchiprolu,Vijayawada,Andhra Pradesh',
'Penugolanu,Vijayawada,Andhra Pradesh',
'Penumatcha,Vijayawada,Andhra Pradesh',
'Pochampalli,Vijayawada,Andhra Pradesh',
'Polampalli,Vijayawada,Andhra Pradesh',
'Polisettipadu,Vijayawada,Andhra Pradesh',
'Pondugula,Vijayawada,Andhra Pradesh',
'Ponnavaram,Vijayawada,Andhra Pradesh',
'Poranki,Vijayawada,Andhra Pradesh',
'Pottipadu,Vijayawada,Andhra Pradesh',
'Pulluru,Vijayawada,Andhra Pradesh',
'Punadipadu,Vijayawada,Andhra Pradesh',
'Punnamathota,Vijayawada,Andhra Pradesh',
'Purnanandampet,Vijayawada,Andhra Pradesh',
'Purushothapatnam,Vijayawada,Andhra Pradesh',
'Putrela,Vijayawada,Andhra Pradesh',
'Raghavapuram,Vijayawada,Andhra Pradesh',
'Railway Wagon Work Shop,Vijayawada,Andhra Pradesh',
'Ramachandrapuram,Vijayawada,Andhra Pradesh',
'Ramavarappadu,Vijayawada,Andhra Pradesh',
'Ramireddipalli,Vijayawada,Andhra Pradesh',
'Rayanapadu,Vijayawada,Andhra Pradesh',
'Repudi,Vijayawada,Andhra Pradesh',
'Roynagar,Vijayawada,Andhra Pradesh',
'Royyur,Vijayawada,Andhra Pradesh',
'Rudravaram,Vijayawada,Andhra Pradesh',
'Rudravaram,Vijayawada,Andhra Pradesh',
'Sagguru,Vijayawada,Andhra Pradesh',
'Saipuram,Vijayawada,Andhra Pradesh',
'Sanagapadu,Vijayawada,Andhra Pradesh',
'Satyanarayanapuram,Vijayawada,Andhra Pradesh',
'Savaragudem,Vijayawada,Andhra Pradesh',
'Seetharampuram,Vijayawada,Andhra Pradesh',
'Shermohammadpet,Vijayawada,Andhra Pradesh',
'Singavaram,Vijayawada,Andhra Pradesh',
'Sivapuram,Vijayawada,Andhra Pradesh',
'Sobhanapuram,Vijayawada,Andhra Pradesh',
'Somavaram,Vijayawada,Andhra Pradesh',
'Srinivasa Nagar Colony,Vijayawada,Andhra Pradesh',
'Srirangapuram,Vijayawada,Andhra Pradesh',
'Subbayyagudem,Vijayawada,Andhra Pradesh',
'Sunnampadu,Vijayawada,Andhra Pradesh',
'Surampalli,Vijayawada,Andhra Pradesh',
'Suryaraopet,Vijayawada,Andhra Pradesh',
'Tadanki,Vijayawada,Andhra Pradesh',
'Tadepalli,Vijayawada,Andhra Pradesh',
'Takkellapadu,Vijayawada,Andhra Pradesh',
'Talluru,Vijayawada,Andhra Pradesh',
'Telaprolu,Vijayawada,Andhra Pradesh',
'Tempalli,Vijayawada,Andhra Pradesh',
'Thotaravulapadu,Vijayawada,Andhra Pradesh',
'Thotlavalluru,Vijayawada,Andhra Pradesh',
'Tirumalagiri,Vijayawada,Andhra Pradesh',
'Tiruvuru,Vijayawada,Andhra Pradesh',
'Tolukodu,Vijayawada,Andhra Pradesh',
'Torragudipadu,Vijayawada,Andhra Pradesh',
'Turlapadu,Vijayawada,Andhra Pradesh',
'Vallampatla,Vijayawada,Andhra Pradesh',
'Valluripalem,Vijayawada,Andhra Pradesh',
'Vasanthanagar,Vijayawada,Andhra Pradesh',
'Vatsavai,Vijayawada,Andhra Pradesh',
'Veerapanenigudem,Vijayawada,Andhra Pradesh',
'Veeravalli,Vijayawada,Andhra Pradesh',
'Veerullapadu,Vijayawada,Andhra Pradesh',
'Velagaleru,Vijayawada,Andhra Pradesh',
'Vellanki,Vijayawada,Andhra Pradesh',
'Vellaturu,Vijayawada,Andhra Pradesh',
'Velpuru,Vijayawada,Andhra Pradesh',
'Velpuru,Vijayawada,Andhra Pradesh',
'Velvdam,Vijayawada,Andhra Pradesh',
'Vemavaram,Vijayawada,Andhra Pradesh',
'Vemireddipalle,Vijayawada,Andhra Pradesh',
'Vemulanarva,Vijayawada,Andhra Pradesh',
'Vemulapalli,Vijayawada,Andhra Pradesh',
'Venkatapuram,Vijayawada,Andhra Pradesh',
'Venkatapuram,Vijayawada,Andhra Pradesh',
'Venkateswarapuram,Vijayawada,Andhra Pradesh',
'Vibharintapadu,Vijayawada,Andhra Pradesh',
'Vidyadharapuram,Vijayawada,Andhra Pradesh',
'Vijayawada Bus Stand,Vijayawada,Andhra Pradesh',
'Vijayawada H.O,Vijayawada,Andhra Pradesh',
'Vijayawada Municipal Offi,Vijayawada,Andhra Pradesh',
'Virankilock,Vijayawada,Andhra Pradesh',
'Vj Polytechnic,Vijayawada,Andhra Pradesh',
'Vja Railway Junction,Vijayawada,Andhra Pradesh',
'Vja Rly Divl Office,Vijayawada,Andhra Pradesh',
'VTPS,Vijayawada,Andhra Pradesh',
'Vuyyuru College,Vijayawada,Andhra Pradesh',
'Vuyyuru,Vijayawada,Andhra Pradesh',
'Wnchipet,Vijayawada,Andhra Pradesh',
'Yakamuru,Vijayawada,Andhra Pradesh',
'Yanamalakuduru,Vijayawada,Andhra Pradesh',
'Zakkulanekkalam,Vijayawada,Andhra Pradesh',
'Krithivennu,Gudivada,Andhra Pradesh',
'Matlam,Gudivada,Andhra Pradesh',
'Munipeda,Gudivada,Andhra Pradesh',
'Neelipudi,Gudivada,Andhra Pradesh',
'Nidamarru,Gudivada,Andhra Pradesh',
'Pandraka,Gudivada,Andhra Pradesh',
'Cherukumilli,Gudivada,Andhra Pradesh',
'Komallapudi,Gudivada,Andhra Pradesh',
'Ayyavarirudravaram,Gudivada,Andhra Pradesh',
'Bhyravapatnam,Gudivada,Andhra Pradesh',
'Chavalipadu,Gudivada,Andhra Pradesh',
'Chigurukota,Gudivada,Andhra Pradesh',
'Chintapadu,Gudivada,Andhra Pradesh',
'Gannavaram,Gudivada,Andhra Pradesh',
'Gunnanapudi,Gudivada,Andhra Pradesh',
'Ingilipakalanka,Gudivada,Andhra Pradesh',
'Kanukollu,Gudivada,Andhra Pradesh',
'Lingala,Gudivada,Andhra Pradesh',
'Mandavalli,Gudivada,Andhra Pradesh',
'Mokasakalvapudi,Gudivada,Andhra Pradesh',
'Nandigamalanka,Gudivada,Andhra Pradesh',
'Prathipadu,Gudivada,Andhra Pradesh',
'Putlacheruvu,Gudivada,Andhra Pradesh',
'Takkellapadu,Gudivada,Andhra Pradesh',
'Unikili,Gudivada,Andhra Pradesh',
'Chiruvolulanka,Machilipatnam,Andhra Pradesh',
'K.Kothapalem,Machilipatnam,Andhra Pradesh',
'Kokkiligadda,Machilipatnam,Andhra Pradesh',
'Kummaripalem,Machilipatnam,Andhra Pradesh',
'Mopidevi,Machilipatnam,Andhra Pradesh',
'Nagayatippa,Machilipatnam,Andhra Pradesh',
'Pedakallepalli,Machilipatnam,Andhra Pradesh',
'Pedaprolu,Machilipatnam,Andhra Pradesh',
'Venaktapuram,Machilipatnam,Andhra Pradesh',
'Ayyanki,Machilipatnam,Andhra Pradesh',
'Barlapudi,Machilipatnam,Andhra Pradesh',
'Bhatlapenumarru,Machilipatnam,Andhra Pradesh',
'Chinamuttevi,Machilipatnam,Andhra Pradesh',
'Chitturu,Machilipatnam,Andhra Pradesh',
'Eddanapudi,Machilipatnam,Andhra Pradesh',
'Gudapadu,Machilipatnam,Andhra Pradesh',
'Inampudi,Machilipatnam,Andhra Pradesh',
'K.P.Centre,Machilipatnam,Andhra Pradesh',
'Kaja,Machilipatnam,Andhra Pradesh',
'Kosuru,Machilipatnam,Andhra Pradesh',
'Mantripalem,Machilipatnam,Andhra Pradesh',
'Movva,Machilipatnam,Andhra Pradesh',
'Nidumolu,Machilipatnam,Andhra Pradesh',
'P.G.Lanka,Machilipatnam,Andhra Pradesh',
'Palankipadu,Machilipatnam,Andhra Pradesh',
'Pedamuttevi,Machilipatnam,Andhra Pradesh',
'Pedasanagallu,Machilipatnam,Andhra Pradesh',
'Turakapalem,Machilipatnam,Andhra Pradesh',
'Vemulamada,Machilipatnam,Andhra Pradesh',
'Bomminampadu,Gudivada,Andhra Pradesh',
'Chevuru,Gudivada,Andhra Pradesh',
'Chinapalaparru,Gudivada,Andhra Pradesh',
'Devapudi,Gudivada,Andhra Pradesh',
'Guraza,Gudivada,Andhra Pradesh',
'Koduru,Gudivada,Andhra Pradesh',
'Komarru,Gudivada,Andhra Pradesh',
'Korraguntapalem,Gudivada,Andhra Pradesh',
'Mudinepalli,Gudivada,Andhra Pradesh',
'Pedagonnuru,Gudivada,Andhra Pradesh',
'Pedakamanapudi,Gudivada,Andhra Pradesh',
'Pedapalaparru,Gudivada,Andhra Pradesh',
'Peruru,Gudivada,Andhra Pradesh',
'Peyyeru,Gudivada,Andhra Pradesh',
'Prodduvaka,Gudivada,Andhra Pradesh',
'Sankarshanapuram,Gudivada,Andhra Pradesh',
'Singarayapalem,Gudivada,Andhra Pradesh',
'Utukuru,Gudivada,Andhra Pradesh',
'Vadali,Gudivada,Andhra Pradesh',
'Vadavalli,Gudivada,Andhra Pradesh',
'Vaivaka,Gudivada,Andhra Pradesh',
'Vanudurru,Gudivada,Andhra Pradesh',
'Alluru,Gudivada,Andhra Pradesh',
'Akkireddygudem,Gudivada,Andhra Pradesh',
'Balive,Gudivada,Andhra Pradesh',
'Chekkapalli,Gudivada,Andhra Pradesh',
'Chintalavalli,Gudivada,Andhra Pradesh',
'Ellapuram,Gudivada,Andhra Pradesh',
'Gopavaram,Gudivada,Andhra Pradesh',
'Gudipadu,Gudivada,Andhra Pradesh',
'Gullapudi,Gudivada,Andhra Pradesh',
'Katrenipadu,Gudivada,Andhra Pradesh',
'Korlagunta,Gudivada,Andhra Pradesh',
'Lopudi,Gudivada,Andhra Pradesh',
'Musunuru,Gudivada,Andhra Pradesh',
'Ramanakkapet,Gudivada,Andhra Pradesh',
'Surepalli,Gudivada,Andhra Pradesh',
'Valasapalli,Gudivada,Andhra Pradesh',
'Velpucherla,Gudivada,Andhra Pradesh',
'Bhavadevarapalli,Machilipatnam,Andhra Pradesh',
'Chodavaram,Machilipatnam,Andhra Pradesh',
'Dd.Puram,Machilipatnam,Andhra Pradesh',
'Edurumondi,Machilipatnam,Andhra Pradesh',
'Etimogga,Machilipatnam,Andhra Pradesh',
'Ganapeswaram,Machilipatnam,Andhra Pradesh',
'Kammanamoulu,Machilipatnam,Andhra Pradesh',
'Nagayalanka East,Machilipatnam,Andhra Pradesh',
'Nagayalanka,Machilipatnam,Andhra Pradesh',
'Nali,Machilipatnam,Andhra Pradesh',
'Nangegadda,Machilipatnam,Andhra Pradesh',
'Parrachivara,Machilipatnam,Andhra Pradesh',
'Pedakammavaripalem,Machilipatnam,Andhra Pradesh',
'Sorlagondhi,Machilipatnam,Andhra Pradesh',
'T.Kothapalem,Machilipatnam,Andhra Pradesh',
'Talagadadeevi,Machilipatnam,Andhra Pradesh',
'Anamanapudi,Gudivada,Andhra Pradesh',
'Aripirala,Gudivada,Andhra Pradesh',
'Dandiganapudi,Gudivada,Andhra Pradesh',
'Ilaparru,Gudivada,Andhra Pradesh',
'Janardhanapuram,Gudivada,Andhra Pradesh',
'Kudaravalli,Gudivada,Andhra Pradesh',
'Lakshminarasimhapuram,Gudivada,Andhra Pradesh',
'Nandivada,Gudivada,Andhra Pradesh',
'Pedalingala,Gudivada,Andhra Pradesh',
'Pedavirivada,Gudivada,Andhra Pradesh',
'Polukonda,Gudivada,Andhra Pradesh',
'Ponukumada,Gudivada,Andhra Pradesh',
'Puttagunta,Gudivada,Andhra Pradesh',
'Ramapuram,Gudivada,Andhra Pradesh',
'Rudrapaka,Gudivada,Andhra Pradesh',
'Tamirisa,Gudivada,Andhra Pradesh',
'Tummalapalli,Gudivada,Andhra Pradesh',
'Vennanapudi,Gudivada,Andhra Pradesh',
'Ravicherla,Gudivada,Andhra Pradesh',
'Annavaram,Gudivada,Andhra Pradesh',
'Boruvancha,Gudivada,Andhra Pradesh',
'Devaragunta,Gudivada,Andhra Pradesh',
'Digavalli,Gudivada,Andhra Pradesh',
'Dum Dum Gardens,Gudivada,Andhra Pradesh',
'Enamadala,Gudivada,Andhra Pradesh',
'Gandhinagaram,Gudivada,Andhra Pradesh',
'Gollapalli,Gudivada,Andhra Pradesh',
'Hanumanthunigudem,Gudivada,Andhra Pradesh',
'Jangamgudem,Gudivada,Andhra Pradesh',
'Mirzapuram,Gudivada,Andhra Pradesh',
'Morsapudi,Gudivada,Andhra Pradesh',
'Mukkollupadu,Gudivada,Andhra Pradesh',
'Nuzvid H.O,Gudivada,Andhra Pradesh',
'Pallerlamudi,Gudivada,Andhra Pradesh',
'Polasanipalli,Gudivada,Andhra Pradesh',
'Pothureddipalli,Gudivada,Andhra Pradesh',
'Siddharthanagar,Gudivada,Andhra Pradesh',
'Sitaramapuram,Gudivada,Andhra Pradesh',
'Tukkuluru,Gudivada,Andhra Pradesh',
'Vidyanagar,Gudivada,Andhra Pradesh',
'Addada,Gudivada,Andhra Pradesh',
'Daggumilli(Z),Machilipatnam,Andhra Pradesh',
'Gandhi Asramam,Gudivada,Andhra Pradesh',
'Golvepalli (Zami),Gudivada,Andhra Pradesh',
'Jujjuvaram,Machilipatnam,Andhra Pradesh',
'Komaravolu,Gudivada,Andhra Pradesh',
'Kondiparru,Machilipatnam,Andhra Pradesh',
'Kurumaddali,Machilipatnam,Andhra Pradesh',
'Nimmakuru,Machilipatnam,Andhra Pradesh',
'Nimmaluru,Machilipatnam,Andhra Pradesh',
'Pamarru,Machilipatnam,Andhra Pradesh',
'Pasumarru,Machilipatnam,Andhra Pradesh',
'Pedamaddali,Gudivada,Andhra Pradesh',
'Perisepalli,Machilipatnam,Andhra Pradesh',
'Rimmanapudi,Machilipatnam,Andhra Pradesh',
'Undrapudi,Machilipatnam,Andhra Pradesh',
'Uruturu,Machilipatnam,Andhra Pradesh',
'Pamarru Bazar,Machilipatnam,Andhra Pradesh',
'Akulamannadu,Machilipatnam,Andhra Pradesh',
'Borrapothupalem,Machilipatnam,Andhra Pradesh',
'Chennuru,Machilipatnam,Andhra Pradesh',
'Chevendra,Machilipatnam,Andhra Pradesh',
'Chittipalem,Machilipatnam,Andhra Pradesh',
'K.P.Lock,Machilipatnam,Andhra Pradesh',
'Kappaladoddi,Machilipatnam,Andhra Pradesh',
'Konkepudi,Machilipatnam,Andhra Pradesh',
'L.K.Gunta,Machilipatnam,Andhra Pradesh',
'Lellagaruvu,Machilipatnam,Andhra Pradesh',
'Mutcherla,Machilipatnam,Andhra Pradesh',
'Nadupuru,Machilipatnam,Andhra Pradesh',
'Nandigama,Machilipatnam,Andhra Pradesh',
'Pedana,Machilipatnam,Andhra Pradesh',
'Pedanabazar,Machilipatnam,Andhra Pradesh',
'Urivi,Gudivada,Andhra Pradesh',
'Bhushanagulla,Gudivada,Andhra Pradesh',
'Chinaparupudi,Gudivada,Andhra Pradesh',
'Dosapadu,Gudivada,Andhra Pradesh',
'Edulamaddali,Gudivada,Andhra Pradesh',
'Elamarru,Gudivada,Andhra Pradesh',
'Guruvindagunta,Gudivada,Andhra Pradesh',
'Moparru,Gudivada,Andhra Pradesh',
'Pedaparupudi,Gudivada,Andhra Pradesh',
'Vanapumala,Gudivada,Andhra Pradesh',
'Ventrapragada,Gudivada,Andhra Pradesh',
'Chintalanerva,Vijayawada,Andhra Pradesh',
'Duggiralapadu,Vijayawada,Andhra Pradesh',
'Konijerla,Vijayawada,Andhra Pradesh',
'Nemali,Vijayawada,Andhra Pradesh',
'Satyalapadu,Vijayawada,Andhra Pradesh',
'Tunikipadu,Vijayawada,Andhra Pradesh',
'Vutukuru,Vijayawada,Andhra Pradesh',
'Pedapulipaka,Vijayawada,Andhra Pradesh',
'Tadigadapa,Vijayawada,Andhra Pradesh',
'Annaraopet,Gudivada,Andhra Pradesh',
'Jagannadhapuram,Gudivada,Andhra Pradesh',
'Kudapa,Gudivada,Andhra Pradesh',
'Kunaparajaparva,Gudivada,Andhra Pradesh',
'Maddulaparva,Gudivada,Andhra Pradesh',
'Muchinapalli,Gudivada,Andhra Pradesh',
'Reddigudem,Gudivada,Andhra Pradesh',
'Ambapuram,Vijayawada,Andhra Pradesh',
'Bandarugudem,Vijayawada,Andhra Pradesh',
'Chiravada,Vijayawada,Andhra Pradesh',
'Galigopuram,Vijayawada,Andhra Pradesh',
'Suravaram,Vijayawada,Andhra Pradesh',
'Chintalapadu,Vijayawada,Andhra Pradesh',
'Kokilampadu,Vijayawada,Andhra Pradesh',
'Kommireddipalli,Vijayawada,Andhra Pradesh',
'Lakshmipuram,Vijayawada,Andhra Pradesh',
'Mallela,Vijayawada,Andhra Pradesh',
'Munukulla,Vijayawada,Andhra Pradesh',
'Rolupadu,Vijayawada,Andhra Pradesh',
'Sriniketan,Vijayawada,Andhra Pradesh',
'Vamukuntla,Vijayawada,Andhra Pradesh',
'Vavilala,Vijayawada,Andhra Pradesh',
'Kondurupadu,Vijayawada,Andhra Pradesh',
'Rajagopalapuram,Vijayawada,Andhra Pradesh',
'Rangannagudem,Vijayawada,Andhra Pradesh',
'Remalle,Vijayawada,Andhra Pradesh',
'Veleru,Vijayawada,Andhra Pradesh',
'Krishnanagar,Vijayawada,Andhra Pradesh',
'Machavaram,Vijayawada,Andhra Pradesh',
'Moghalrajpuram,Vijayawada,Andhra Pradesh',
'Nidamanuru,Vijayawada,Andhra Pradesh',
'Panditnehru Bus Station,Vijayawada,Andhra Pradesh',
'Patamata Lanka,Vijayawada,Andhra Pradesh',
'Patamata,Vijayawada,Andhra Pradesh',
'Krishnalanka,Vijayawada,Andhra Pradesh',
'Chandrupatla,Gudivada,Andhra Pradesh',
'Kalagara,Gudivada,Andhra Pradesh',
'Kondaparva,Gudivada,Andhra Pradesh',
'Korlamanda,Gudivada,Andhra Pradesh',
'Narasapuram,Gudivada,Andhra Pradesh',
'Tatakuntla,Gudivada,Andhra Pradesh',
'Telladevarapalli,Gudivada,Andhra Pradesh',
'Vissannapet Bazar,Gudivada,Andhra Pradesh',
'Vissannapet,Gudivada,Andhra Pradesh',
'Krishnavaram,Vijayawada,Andhra Pradesh',
'Amudalapalli,Gudivada,Andhra Pradesh',
'Bokinala,Gudivada,Andhra Pradesh',
'Garapadu,Gudivada,Andhra Pradesh',
'Indupalli,Gudivada,Andhra Pradesh',
'Koyyagurapadu,Gudivada,Andhra Pradesh',
'Lankapalli Agraharam,Gudivada,Andhra Pradesh',
'Manikonda,Gudivada,Andhra Pradesh',
'Nandamuru,Gudivada,Andhra Pradesh',
'Ponukumada,Gudivada,Andhra Pradesh',
'Tarigoppula R.S.,Gudivada,Andhra Pradesh',
'Veldipadu,Gudivada,Andhra Pradesh',
'Velinuthala,Gudivada,Andhra Pradesh',
'Vemanda,Gudivada,Andhra Pradesh',
'Vempadu,Gudivada,Andhra Pradesh',
'Vunguturu,Gudivada,Andhra Pradesh',
'Mudunuru,Gudivada,Andhra Pradesh',
'Appikatla,Gudivada,Andhra Pradesh',
'Bollapadu,Gudivada,Andhra Pradesh',
'Kolavennu,Vijayawada,Andhra Pradesh',
'Vuyyuru East,Vijayawada,Andhra Pradesh',
'Alaganur,Kurnool,Andhra Pradesh',
'Albad,Kurnool,Andhra Pradesh',
'Banavasi,Kurnool,Andhra Pradesh',
'Bijina Vemula,Kurnool,Andhra Pradesh',
'Boyanacheruvupalle,Kurnool,Andhra Pradesh',
'Burugula,Kurnool,Andhra Pradesh',
'Chanugondla,Kurnool,Andhra Pradesh',
'Erramattam,Kurnool,Andhra Pradesh',
'Garladinne,Kurnool,Andhra Pradesh',
'Guvvalakunta,Kurnool,Andhra Pradesh',
'Kalugotla,Kurnool,Andhra Pradesh',
'Kanakaveedu,Kurnool,Andhra Pradesh',
'Kesanapalli,Kurnool,Andhra Pradesh',
'Komma Marri,Kurnool,Andhra Pradesh',
'Krishna Puram,Kurnool,Andhra Pradesh',
'Krishnapuram,Kurnool,Andhra Pradesh',
'Kurunur,Kurnool,Andhra Pradesh',
'Laddagiri,Kurnool,Andhra Pradesh',
'Machapuram,Kurnool,Andhra Pradesh',
'Mpendakallu,Kurnool,Andhra Pradesh',
'Mudamalakurthi,Kurnool,Andhra Pradesh',
'Mutsumarri,Kurnool,Andhra Pradesh',
'Neepudu Cherla,Kurnool,Andhra Pradesh',
'Nehru Nagar,Kurnool,Andhra Pradesh',
'Pasupula,Kurnool,Andhra Pradesh',
'Pulichinta,Kurnool,Andhra Pradesh',
'Pullagummi,Kurnool,Andhra Pradesh',
'Pyalakurthi,Kurnool,Andhra Pradesh',
'Racherla,Kurnool,Andhra Pradesh',
'Ramalla Kota,Kurnool,Andhra Pradesh',
'Sarparajapuram,Kurnool,Andhra Pradesh',
'Sboyanapalli,Kurnool,Andhra Pradesh',
'T Samala Gudur,Kurnool,Andhra Pradesh',
'Utakonda,Kurnool,Andhra Pradesh',
'Varkur,Kurnool,Andhra Pradesh',
'Venkatagiri,Kurnool,Andhra Pradesh',
'Venkatagiri,Kurnool,Andhra Pradesh',
'Doddanakeri,Kurnool,Andhra Pradesh',
'Jalimanchi,Kurnool,Andhra Pradesh',
'Kapati,Kurnool,Andhra Pradesh',
'Peddahothur,Kurnool,Andhra Pradesh',
'Pesalabanda,Kurnool,Andhra Pradesh',
'Urukunda,Kurnool,Andhra Pradesh',
'Ahobilam,Nandyal,Andhra Pradesh',
'Alamur,Nandyal,Andhra Pradesh',
'Allagadda,Nandyal,Andhra Pradesh',
'Bachepalle,Nandyal,Andhra Pradesh',
'Balavegammanagar,Nandyal,Andhra Pradesh',
'Bathalur,Nandyal,Andhra Pradesh',
'Beeravolu,Nandyal,Andhra Pradesh',
'Boyalakuntla,Nandyal,Andhra Pradesh',
'Chagalamarri,Nandyal,Andhra Pradesh',
'Chalama,Nandyal,Andhra Pradesh',
'Chandalur,Nandyal,Andhra Pradesh',
'Chennur,Nandyal,Andhra Pradesh',
'Chinnakambalur,Nandyal,Andhra Pradesh',
'Chinnavangali,Nandyal,Andhra Pradesh',
'Chintakommudinne,Nandyal,Andhra Pradesh',
'Chintalacheruvu,Nandyal,Andhra Pradesh',
'Deebaguntla,Nandyal,Andhra Pradesh',
'Erragudidinne,Nandyal,Andhra Pradesh',
'G.Jambuladinne,Nandyal,Andhra Pradesh',
'Gajulapalle,Nandyal,Andhra Pradesh',
'Gangavaram,Nandyal,Andhra Pradesh',
'Godiganur,Nandyal,Andhra Pradesh',
'Gopavaram,Nandyal,Andhra Pradesh',
'Gospadu,Nandyal,Andhra Pradesh',
'Gotlur,Nandyal,Andhra Pradesh',
'Govindapalle,Nandyal,Andhra Pradesh',
'Gumparamandinne,Nandyal,Andhra Pradesh',
'Gundampadu,Nandyal,Andhra Pradesh',
'Guntanala,Nandyal,Andhra Pradesh',
'Jeenepalle,Nandyal,Andhra Pradesh',
'Jillella,Nandyal,Andhra Pradesh',
'Julepalle,Nandyal,Andhra Pradesh',
'Kalugotlapalle,Nandyal,Andhra Pradesh',
'Kaminenipalle,Nandyal,Andhra Pradesh',
'Kondupalle,Nandyal,Andhra Pradesh',
'Kotakandukur,Nandyal,Andhra Pradesh',
'Kotakonda,Nandyal,Andhra Pradesh',
'Kotapadu,Nandyal,Andhra Pradesh',
'M.Chintakunta,Nandyal,Andhra Pradesh',
'M.V. Nagar,Nandyal,Andhra Pradesh',
'Maddur,Nandyal,Andhra Pradesh',
'Maddur,Nandyal,Andhra Pradesh',
'Mahadevapuram,Nandyal,Andhra Pradesh',
'Mallavemula,Nandyal,Andhra Pradesh',
'Mandalur,Nandyal,Andhra Pradesh',
'Maseedpuram,Nandyal,Andhra Pradesh',
'Mitnala,Nandyal,Andhra Pradesh',
'Mittapalle,Nandyal,Andhra Pradesh',
'Muthalur,Nandyal,Andhra Pradesh',
'Muthyalapadu,Nandyal,Andhra Pradesh',
'Nallagatla,Nandyal,Andhra Pradesh',
'Nelampadu,Nandyal,Andhra Pradesh',
'Obulampalle,Nandyal,Andhra Pradesh',
'Padakandla,Nandyal,Andhra Pradesh',
'Pasurapadu,Nandyal,Andhra Pradesh',
'Pathakandukur,Nandyal,Andhra Pradesh',
'Peddabodanam,Nandyal,Andhra Pradesh',
'Peddachintakunta,Nandyal,Andhra Pradesh',
'Peddakambalur,Nandyal,Andhra Pradesh',
'Peddavangali,Nandyal,Andhra Pradesh',
'R.Krishnapuram,Nandyal,Andhra Pradesh',
'R.Papampalle,Nandyal,Andhra Pradesh',
'Rajanagaram,Nandyal,Andhra Pradesh',
'Rudravaram,Nandyal,Andhra Pradesh',
'S.Lingam Dinne,Nandyal,Andhra Pradesh',
'Sarvaipalle,Nandyal,Andhra Pradesh',
'Srirangapuram,Nandyal,Andhra Pradesh',
'T.Lingamdinne,Nandyal,Andhra Pradesh',
'Veerareddypalle,Nandyal,Andhra Pradesh',
'Venkatapuram,Nandyal,Andhra Pradesh',
'Yellavathula,Nandyal,Andhra Pradesh',
'M.Krishnapuram,Nandyal,Andhra Pradesh',
'Ramakrishnapuram,Nandyal,Andhra Pradesh',
'Alamur,Nandyal,Andhra Pradesh',
'Anupur,Nandyal,Andhra Pradesh',
'Appalapuram,Nandyal,Andhra Pradesh',
'Balapanur,Nandyal,Andhra Pradesh',
'Banaganapalle,Nandyal,Andhra Pradesh',
'Banaganapalle South,Nandyal,Andhra Pradesh',
'Bhupanapadu,Nandyal,Andhra Pradesh',
'Biravolu,Nandyal,Andhra Pradesh',
'Cheruvupalle,Nandyal,Andhra Pradesh',
'G.Singavaram,Nandyal,Andhra Pradesh',
'Gollagutta,Nandyal,Andhra Pradesh',
'Illuri Kotha Peta,Nandyal,Andhra Pradesh',
'Itekala,Nandyal,Andhra Pradesh',
'Jillalla,Nandyal,Andhra Pradesh',
'Katikavanikunta,Nandyal,Andhra Pradesh',
'Kavulur,Nandyal,Andhra Pradesh',
'Kolimigundla,Nandyal,Andhra Pradesh',
'Konededu,Nandyal,Andhra Pradesh',
'Krishnagiri,Nandyal,Andhra Pradesh',
'Kypa,Nandyal,Andhra Pradesh',
'Lingambodu,Nandyal,Andhra Pradesh',
'Mangampeta,Nandyal,Andhra Pradesh',
'Meerapuram,Nandyal,Andhra Pradesh',
'Mittapalle,Nandyal,Andhra Pradesh',
'Nandavaram,Nandyal,Andhra Pradesh',
'Nandivargam,Nandyal,Andhra Pradesh',
'Palukur,Nandyal,Andhra Pradesh',
'Panem Bus Stand,Nandyal,Andhra Pradesh',
'Panem,Nandyal,Andhra Pradesh',
'Pathapadu,Nandyal,Andhra Pradesh',
'Ramathirtham,Nandyal,Andhra Pradesh',
'S.Kothur,Nandyal,Andhra Pradesh',
'Sugalithanda,Nandyal,Andhra Pradesh',
'Tamballapalle,Nandyal,Andhra Pradesh',
'Tangatur,Nandyal,Andhra Pradesh',
'Tellapuri,Nandyal,Andhra Pradesh',
'Thammarajupalle,Nandyal,Andhra Pradesh',
'Thollamadugu,Nandyal,Andhra Pradesh',
'Vaddugandla,Nandyal,Andhra Pradesh',
'Venkatapuram,Nandyal,Andhra Pradesh',
'Yagantipalle,Nandyal,Andhra Pradesh',
'Yanakandla,Nandyal,Andhra Pradesh',
'Yerragudi,Nandyal,Andhra Pradesh',
'Abdullapuram,Nandyal,Andhra Pradesh',
'Chintalayapalli,Nandyal,Andhra Pradesh',
'Kalvatala,Nandyal,Andhra Pradesh',
'Kanakadripalli,Nandyal,Andhra Pradesh',
'Meerjapuram,Nandyal,Andhra Pradesh',
'Nandipadu,Nandyal,Andhra Pradesh',
'Petnikota,Nandyal,Andhra Pradesh',
'Ramakrishnapuram,Nandyal,Andhra Pradesh',
'Thimmanayanipeta,Nandyal,Andhra Pradesh',
'Ankireddypalli,Nandyal,Andhra Pradesh',
'Gorivimanipalle,Nandyal,Andhra Pradesh',
'Thummalapenta,Nandyal,Andhra Pradesh',
'Dornipadu,Nandyal,Andhra Pradesh',
'Koilakuntla Bus Stand,Nandyal,Andhra Pradesh',
'Koilakuntla,Nandyal,Andhra Pradesh',
'Nossam,Nandyal,Andhra Pradesh',
'Owk,Nandyal,Andhra Pradesh',
'Perusomula,Nandyal,Andhra Pradesh',
'Sanjamala,Nandyal,Andhra Pradesh',
'Uyyalawada,Nandyal,Andhra Pradesh',
'Akkampalli,Nandyal,Andhra Pradesh',
'Akumalla,Nandyal,Andhra Pradesh',
'Alavakonda,Nandyal,Andhra Pradesh',
'Allur,Nandyal,Andhra Pradesh',
'Ammireddinagar,Nandyal,Andhra Pradesh',
'Belum,Nandyal,Andhra Pradesh',
'Bhimunipadu,Nandyal,Andhra Pradesh',
'Bijanavemula,Nandyal,Andhra Pradesh',
'Bodemmanur,Nandyal,Andhra Pradesh',
'Chakarajuvemula,Nandyal,Andhra Pradesh',
'Chanugondla,Nandyal,Andhra Pradesh',
'Chennampalli,Nandyal,Andhra Pradesh',
'Cherlopalli,Nandyal,Andhra Pradesh',
'Giddalur(Kkt),Nandyal,Andhra Pradesh',
'Gulladurthi,Nandyal,Andhra Pradesh',
'Gundupapala,Nandyal,Andhra Pradesh',
'Gunjalapadu,Nandyal,Andhra Pradesh',
'Harivaram,Nandyal,Andhra Pradesh',
'Injedu,Nandyal,Andhra Pradesh',
'Joladarasi,Nandyal,Andhra Pradesh',
'Kakaravada,Nandyal,Andhra Pradesh',
'Kalugotla,Nandyal,Andhra Pradesh',
'Kamalapuri,Nandyal,Andhra Pradesh',
'Kammavaripalle,Nandyal,Andhra Pradesh',
'Kampamalla,Nandyal,Andhra Pradesh',
'Kanala,Nandyal,Andhra Pradesh',
'Kondamanayunipalli,Nandyal,Andhra Pradesh',
'Kondapuram,Nandyal,Andhra Pradesh',
'Kristipadu,Nandyal,Andhra Pradesh',
'Kunukuntala,Nandyal,Andhra Pradesh',
'Lingala,Nandyal,Andhra Pradesh',
'Mayalur,Nandyal,Andhra Pradesh',
'Mettupalle,Nandyal,Andhra Pradesh',
'Mukkamalla,Nandyal,Andhra Pradesh',
'Peddaemmanur,Nandyal,Andhra Pradesh',
'Peddakopperla,Nandyal,Andhra Pradesh',
'Peddavanthurla,Nandyal,Andhra Pradesh',
'Pottipadu,Nandyal,Andhra Pradesh',
'R.Jammuladinne,Nandyal,Andhra Pradesh',
'R.Lingamdinne,Nandyal,Andhra Pradesh',
'Ramachandrapuram,Nandyal,Andhra Pradesh',
'Ramapuram,Nandyal,Andhra Pradesh',
'Ramapvaram,Nandyal,Andhra Pradesh',
'Ramireddipalle,Nandyal,Andhra Pradesh',
'Revanur,Nandyal,Andhra Pradesh',
'Rupanagudi,Nandyal,Andhra Pradesh',
'Sangapatnam,Nandyal,Andhra Pradesh',
'Singanapalle,Nandyal,Andhra Pradesh',
'Sivavaram,Nandyal,Andhra Pradesh',
'Suddamalla,Nandyal,Andhra Pradesh',
'Sunkesula,Nandyal,Andhra Pradesh',
'Thudumaladinne,Nandyal,Andhra Pradesh',
'U.Govindinne,Nandyal,Andhra Pradesh',
'U.Kothapalle,Nandyal,Andhra Pradesh',
'Uppalapadu,Nandyal,Andhra Pradesh',
'Vasanthapuram,Nandyal,Andhra Pradesh',
'Vonteddupalle,Nandyal,Andhra Pradesh',
'Yerragudi,Nandyal,Andhra Pradesh',
'A.Gokulapadu,Kurnool,Andhra Pradesh',
'Abdullapuram,Kurnool,Andhra Pradesh',
'Adoni Arts College,Kurnool,Andhra Pradesh',
'Adoni H.O,Kurnool,Andhra Pradesh',
'Adoni-town,Kurnool,Andhra Pradesh',
'Agaveli,Kurnool,Andhra Pradesh',
'Alaganur,Kurnool,Andhra Pradesh',
'Alardinne,Kurnool,Andhra Pradesh',
'Alavala,Kurnool,Andhra Pradesh',
'Aligera,Kurnool,Andhra Pradesh',
'Alur,Kurnool,Andhra Pradesh',
'Amadaguntla,Kurnool,Andhra Pradesh',
'Amakathadu,Kurnool,Andhra Pradesh',
'Aminabad,Kurnool,Andhra Pradesh',
'Anugonda,Kurnool,Andhra Pradesh',
'Arekallu,Kurnool,Andhra Pradesh',
'Arikera,Kurnool,Andhra Pradesh',
'Arlabanda,Kurnool,Andhra Pradesh',
'Ashoknagar,Kurnool,Andhra Pradesh',
'Aspari,Kurnool,Andhra Pradesh',
'Atikalagundu,Kurnool,Andhra Pradesh',
'Atmakur,Kurnool,Andhra Pradesh',
'B.Agraharam,Kurnool,Andhra Pradesh',
'B.Ramadurgam,Kurnool,Andhra Pradesh',
'Badinehal,Kurnool,Andhra Pradesh',
'Baichigeri,Kurnool,Andhra Pradesh',
'Bairluty,Kurnool,Andhra Pradesh',
'Balaji Nagar,Kurnool,Andhra Pradesh',
'Banakacherla,Kurnool,Andhra Pradesh',
'Banavanur,Kurnool,Andhra Pradesh',
'Bannuru,Kurnool,Andhra Pradesh',
'Bantanahal,Kurnool,Andhra Pradesh',
'Bantanahallu,Kurnool,Andhra Pradesh',
'Bapalapalli,Kurnool,Andhra Pradesh',
'Bapuram,Kurnool,Andhra Pradesh',
'Bapuram,Kurnool,Andhra Pradesh',
'Basapuram,Kurnool,Andhra Pradesh',
'Basarkodur,Kurnool,Andhra Pradesh',
'Bastipadu,Kurnool,Andhra Pradesh',
'Belagal,Kurnool,Andhra Pradesh',
'Belagallu,Kurnool,Andhra Pradesh',
'Beldona,Kurnool,Andhra Pradesh',
'Bethamcherla,Kurnool,Andhra Pradesh',
'Bevinahal,Kurnool,Andhra Pradesh',
'Bhagya Nagar-kurnool,Kurnool,Andhra Pradesh',
'Bhanumukkala,Kurnool,Andhra Pradesh',
'Bhar Peta Adoni,Kurnool,Andhra Pradesh',
'Bhojanam,Kurnool,Andhra Pradesh',
'Bilahalu,Kurnool,Andhra Pradesh',
'Bilakalaguduru,Kurnool,Andhra Pradesh',
'Billekallu,Kurnool,Andhra Pradesh',
'Biravolu,Kurnool,Andhra Pradesh',
'Bogolu,Kurnool,Andhra Pradesh',
'Bollavaram,Kurnool,Andhra Pradesh',
'Bollavaram,Kurnool,Andhra Pradesh',
'Bommireddipalli,Kurnool,Andhra Pradesh',
'Bondimadugula,Kurnool,Andhra Pradesh',
'Boyarevula,Kurnool,Andhra Pradesh',
'Brahmanadoddi,Kurnool,Andhra Pradesh',
'Brahmanakotkur,Kurnool,Andhra Pradesh',
'Bugganipalli,Kurnool,Andhra Pradesh',
'Bukkapuram,Kurnool,Andhra Pradesh',
'Burandoddi,Kurnool,Andhra Pradesh',
'Buruzula,Kurnool,Andhra Pradesh',
'Byluppala,Kurnool,Andhra Pradesh',
'Cement Nagar,Kurnool,Andhra Pradesh',
'Chakkaralla,Kurnool,Andhra Pradesh',
'Chandoli,Kurnool,Andhra Pradesh',
'Chandrapalli,Kurnool,Andhra Pradesh',
'Channampalli,Kurnool,Andhra Pradesh',
'Chatlamallapuram,Kurnool,Andhra Pradesh',
'Chatnihalli,Kurnool,Andhra Pradesh',
'Chelimilla,Kurnool,Andhra Pradesh',
'Chellelichelimala,Kurnool,Andhra Pradesh',
'Cherukucherla,Kurnool,Andhra Pradesh',
'Cherukulapadu,Kurnool,Andhra Pradesh',
'Chigali,Kurnool,Andhra Pradesh',
'Chilakaladona,Kurnool,Andhra Pradesh',
'Chinna Pendekallu,Kurnool,Andhra Pradesh',
'Chinnaharivanam,Kurnool,Andhra Pradesh',
'Chinnahotturu,Kurnool,Andhra Pradesh',
'Chinnahulthi,Kurnool,Andhra Pradesh',
'Chinnahyti,Kurnool,Andhra Pradesh',
'Chinnapodilla,Kurnool,Andhra Pradesh',
'Chinnatekur,Kurnool,Andhra Pradesh',
'Chinnathumbalam,Kurnool,Andhra Pradesh',
'Chintakunta,Kurnool,Andhra Pradesh',
'Chintalapalli,Kurnool,Andhra Pradesh',
'Chippagiri,Kurnool,Andhra Pradesh',
'Chirtanakallu,Kurnool,Andhra Pradesh',
'Chityala,Kurnool,Andhra Pradesh',
'Chowtkur,Kurnool,Andhra Pradesh',
'Chudi,Kurnool,Andhra Pradesh',
'Chunchu Erragudi,Kurnool,Andhra Pradesh',
'D. Kotakonda,Kurnool,Andhra Pradesh',
'Daivamdinne,Kurnool,Andhra Pradesh',
'Damagatla,Kurnool,Andhra Pradesh',
'Devanabanda,Kurnool,Andhra Pradesh',
'Devanakonda,Kurnool,Andhra Pradesh',
'Devanur,Kurnool,Andhra Pradesh',
'Devarabanda,Kurnool,Andhra Pradesh',
'Dhanapuram,Kurnool,Andhra Pradesh',
'Dharmavaram,Kurnool,Andhra Pradesh',
'Dhone,Kurnool,Andhra Pradesh',
'Dhone-bazar,Kurnool,Andhra Pradesh',
'Dibbanakallu,Kurnool,Andhra Pradesh',
'Diguvapadu,Kurnool,Andhra Pradesh',
'Dinnedevarapadu,Kurnool,Andhra Pradesh',
'Doddi,Kurnool,Andhra Pradesh',
'Doddimekala,Kurnool,Andhra Pradesh',
'Dommaladinne,Kurnool,Andhra Pradesh',
'Dudekonda,Kurnool,Andhra Pradesh',
'Dudyala,Kurnool,Andhra Pradesh',
'E.Thandrapadu,Kurnool,Andhra Pradesh',
'Edduladoddi,Kurnool,Andhra Pradesh',
'Edururu,Kurnool,Andhra Pradesh',
'Ellarthi,Kurnool,Andhra Pradesh',
'Enigabala,Kurnool,Andhra Pradesh',
'Erigeri,Kurnool,Andhra Pradesh',
'Errabadu,Kurnool,Andhra Pradesh',
'Erradoddi,Kurnool,Andhra Pradesh',
'Erraguduru,Kurnool,Andhra Pradesh',
'Erukalacheruvu,Kurnool,Andhra Pradesh',
'G.D.Project,Kurnool,Andhra Pradesh',
'G.Erragudi,Kurnool,Andhra Pradesh',
'G.Hosanahalli,Kurnool,Andhra Pradesh',
'G.Pulla Reddy Eng College,Kurnool,Andhra Pradesh',
'G.Singavaram,Kurnool,Andhra Pradesh',
'Gadivemula,Kurnool,Andhra Pradesh',
'Gajjahalli,Kurnool,Andhra Pradesh',
'Ganapuram,Kurnool,Andhra Pradesh',
'Gani,Kurnool,Andhra Pradesh',
'Ganjihalli,Kurnool,Andhra Pradesh',
'Gargeyapuram,Kurnool,Andhra Pradesh',
'Gokavaram,Kurnool,Andhra Pradesh',
'Gondiparla,Kurnool,Andhra Pradesh',
'Gonegandla,Kurnool,Andhra Pradesh',
'Gorantla,Kurnool,Andhra Pradesh',
'Govardhanagiri,Kurnool,Andhra Pradesh',
'Govt Live Stock Form,Kurnool,Andhra Pradesh',
'Grandhivemula,Kurnool,Andhra Pradesh',
'Gudikal,Kurnool,Andhra Pradesh',
'Gudikambali,Kurnool,Andhra Pradesh',
'Gudipadu,Kurnool,Andhra Pradesh',
'Gudipadu,Kurnool,Andhra Pradesh',
'Gudur,Kurnool,Andhra Pradesh',
'Gulyam,Kurnool,Andhra Pradesh',
'Gummanur,Kurnool,Andhra Pradesh',
'Gundlakonda,Kurnool,Andhra Pradesh',
'Gundrevula,Kurnool,Andhra Pradesh',
'Guntakandala,Kurnool,Andhra Pradesh',
'Guntupalli,Kurnool,Andhra Pradesh',
'H.Khairvadi,Kurnool,Andhra Pradesh',
'H.Kottala,Kurnool,Andhra Pradesh',
'H.Muravani,Kurnool,Andhra Pradesh',
'Halaharvi,Kurnool,Andhra Pradesh',
'Halaharvi,Kurnool,Andhra Pradesh',
'Halibidu,Kurnool,Andhra Pradesh',
'Halvi,Kurnool,Andhra Pradesh',
'Hampa,Kurnool,Andhra Pradesh',
'Hanavolu,Kurnool,Andhra Pradesh',
'Hardageri,Kurnool,Andhra Pradesh',
'Harivanam,Kurnool,Andhra Pradesh',
'Hattibelagallu,Kurnool,Andhra Pradesh',
'Hebbatam,Kurnool,Andhra Pradesh',
'Holalagondi,Kurnool,Andhra Pradesh',
'Honnur,Kurnool,Andhra Pradesh',
'Hosuru,Kurnool,Andhra Pradesh',
'Hussainapuram,Kurnool,Andhra Pradesh',
'Hussainapuram,Kurnool,Andhra Pradesh',
'Ibrahimpuram,Kurnool,Andhra Pradesh',
'Inagandla,Kurnool,Andhra Pradesh',
'Indireswaram,Kurnool,Andhra Pradesh',
'Industrial Estate,Kurnool,Andhra Pradesh',
'Ingaladahal,Kurnool,Andhra Pradesh',
'Iranbanda,Kurnool,Andhra Pradesh',
'Iskala,Kurnool,Andhra Pradesh',
'Isvi,Kurnool,Andhra Pradesh',
'Jagadurthi,Kurnool,Andhra Pradesh',
'Jakkasanikuntla,Kurnool,Andhra Pradesh',
'Jaladurgam,Kurnool,Andhra Pradesh',
'Jalakanur,Kurnool,Andhra Pradesh',
'Jampapuram,Kurnool,Andhra Pradesh',
'Jilladukala,Kurnool,Andhra Pradesh',
'Joharapuram,Kurnool,Andhra Pradesh',
'Joharapuram,Kurnool,Andhra Pradesh',
'Jonnagiri,Kurnool,Andhra Pradesh',
'Julekallu,Kurnool,Andhra Pradesh',
'Jummaladinne,Kurnool,Andhra Pradesh',
'Jutur,Kurnool,Andhra Pradesh',
'Jutur,Kurnool,Andhra Pradesh',
'K.Markapuram,Kurnool,Andhra Pradesh',
'K.N.Puram,Kurnool,Andhra Pradesh',
'Kadamakuntla,Kurnool,Andhra Pradesh',
'Kadimetla,Kurnool,Andhra Pradesh',
'Kadivella,Kurnool,Andhra Pradesh',
'Kadumur,Kurnool,Andhra Pradesh',
'Kaggallu,Kurnool,Andhra Pradesh',
'Kairuppala,Kurnool,Andhra Pradesh',
'Kalchatla,Kurnool,Andhra Pradesh',
'Kallabavaram,Kurnool,Andhra Pradesh',
'Kalludevakuntla,Kurnool,Andhra Pradesh',
'Kallukunta,Kurnool,Andhra Pradesh',
'Kalluru,Kurnool,Andhra Pradesh',
'Kalugotla,Kurnool,Andhra Pradesh',
'Kalva,Kurnool,Andhra Pradesh',
'Kamaganikuntla,Kurnool,Andhra Pradesh',
'Kamalapuram,Kurnool,Andhra Pradesh',
'Kamavaram,Kurnool,Andhra Pradesh',
'Kambadahal,Kurnool,Andhra Pradesh',
'Kambadahal,Kurnool,Andhra Pradesh',
'Kambaladinne,Kurnool,Andhra Pradesh',
'Kambalapadu,Kurnool,Andhra Pradesh',
'Kaminehal,Kurnool,Andhra Pradesh',
'Kammarchedu,Kurnool,Andhra Pradesh',
'Kandanathi,Kurnool,Andhra Pradesh',
'Kandikayapalli,Kurnool,Andhra Pradesh',
'Kandukuru,Kurnool,Andhra Pradesh',
'Kappatralla,Kurnool,Andhra Pradesh',
'Karivemula,Kurnool,Andhra Pradesh',
'Karivena,Kurnool,Andhra Pradesh',
'Karumanchi,Kurnool,Andhra Pradesh',
'Katarukonda,Kurnool,Andhra Pradesh',
'Katriki,Kurnool,Andhra Pradesh',
'Kauthalam,Kurnool,Andhra Pradesh',
'Kethavaram,Kurnool,Andhra Pradesh',
'Khajeepuram,Kurnool,Andhra Pradesh',
'KNL-camp-B,Kurnool,Andhra Pradesh',
'Knl-osmaniacollege,Kurnool,Andhra Pradesh',
'Kodumur,Kurnool,Andhra Pradesh',
'Kogilathota,Kurnool,Andhra Pradesh',
'Koilakonda,Kurnool,Andhra Pradesh',
'Kokkarchedu,Kurnool,Andhra Pradesh',
'Komarole,Kurnool,Andhra Pradesh',
'Kondapuram,Kurnool,Andhra Pradesh',
'Konganapadu,Kurnool,Andhra Pradesh',
'Konidela,Kurnool,Andhra Pradesh',
'Korrapolur,Kurnool,Andhra Pradesh',
'Kosigi,Kurnool,Andhra Pradesh',
'Kotakonda,Kurnool,Andhra Pradesh',
'Kotchervu,Kurnool,Andhra Pradesh',
'Kotekallu,Kurnool,Andhra Pradesh',
'Kothakota,Kurnool,Andhra Pradesh',
'Kothakota,Kurnool,Andhra Pradesh',
'Kothur,Kurnool,Andhra Pradesh',
'Kottapalli,Kurnool,Andhra Pradesh',
'Krishnagiri,Kurnool,Andhra Pradesh',
'Kulumala,Kurnool,Andhra Pradesh',
'Kulumalapalli,Kurnool,Andhra Pradesh',
'Kunkanur,Kurnool,Andhra Pradesh',
'Kuntanahal,Kurnool,Andhra Pradesh',
'Kuppagallu,Kurnool,Andhra Pradesh',
'Kurnool Bazar,Kurnool,Andhra Pradesh',
'Kurnool Dt Court,Kurnool,Andhra Pradesh',
'Kurnool H.O,Kurnool,Andhra Pradesh',
'Kurnool Kothapeta,Kurnool,Andhra Pradesh',
'Kurnool Medicalcollege,Kurnool,Andhra Pradesh',
'Kurnool-chowk,Kurnool,Andhra Pradesh',
'Kurukunda,Kurnool,Andhra Pradesh',
'Kuruvalli,Kurnool,Andhra Pradesh',
'L.Banda,Kurnool,Andhra Pradesh',
'Lakkasagaram,Kurnool,Andhra Pradesh',
'Laxmipuram,Kurnool,Andhra Pradesh',
'Lingadahalli,Kurnool,Andhra Pradesh',
'Loddipalli,Kurnool,Andhra Pradesh',
'M.Agraharam,Kurnool,Andhra Pradesh',
'M.Lingapuram,Kurnool,Andhra Pradesh',
'M.S.Nagar,Kurnool,Andhra Pradesh',
'Madananthapuram,Kurnool,Andhra Pradesh',
'Maddikera,Kurnool,Andhra Pradesh',
'Maddikera,Kurnool,Andhra Pradesh',
'Maddur,Kurnool,Andhra Pradesh',
'Madhavaram,Kurnool,Andhra Pradesh',
'Madhavaram,Kurnool,Andhra Pradesh',
'Madhira,Kurnool,Andhra Pradesh',
'Malapalli,Kurnool,Andhra Pradesh',
'Malkapuram,Kurnool,Andhra Pradesh',
'Mallapuram,Kurnool,Andhra Pradesh',
'Mallepalli,Kurnool,Andhra Pradesh',
'Mallikarjunahalli,Kurnool,Andhra Pradesh',
'Malliyala,Kurnool,Andhra Pradesh',
'Malyala,Kurnool,Andhra Pradesh',
'Mamidalapadu,Kurnool,Andhra Pradesh',
'Manchalakatta,Kurnool,Andhra Pradesh',
'Mandlem,Kurnool,Andhra Pradesh',
'Mannekurthi,Kurnool,Andhra Pradesh',
'Mantralayam,Kurnool,Andhra Pradesh',
'Mantriki,Kurnool,Andhra Pradesh',
'Marakattu,Kurnool,Andhra Pradesh',
'Marella,Kurnool,Andhra Pradesh',
'Marlamadiki,Kurnool,Andhra Pradesh',
'Masapeta,Kurnool,Andhra Pradesh',
'Medehal,Kurnool,Andhra Pradesh',
'Meedivemula,Kurnool,Andhra Pradesh',
'Mekadona,Kurnool,Andhra Pradesh',
'Mettupalli,Kurnool,Andhra Pradesh',
'Miduthur,Kurnool,Andhra Pradesh',
'Mittakandala,Kurnool,Andhra Pradesh',
'Molagavelli,Kurnool,Andhra Pradesh',
'Mothukuru,Kurnool,Andhra Pradesh',
'Muddanageri,Kurnool,Andhra Pradesh',
'Muddavaram,Kurnool,Andhra Pradesh',
'Mudumala,Kurnool,Andhra Pradesh',
'Mugati,Kurnool,Andhra Pradesh',
'Mukkella,Kurnool,Andhra Pradesh',
'Mulagundam,Kurnool,Andhra Pradesh',
'Munagala,Kurnool,Andhra Pradesh',
'Musalayamadugu,Kurnool,Andhra Pradesh',
'Musalimadugu,Kurnool,Andhra Pradesh',
'Musanahalli,Kurnool,Andhra Pradesh',
'Muthukur,Kurnool,Andhra Pradesh',
'N R Peta KNL,Kurnool,Andhra Pradesh',
'N.Khairavadi,Kurnool,Andhra Pradesh',
'N.Konthalapadu,Kurnool,Andhra Pradesh',
'N.Rangapuram,Kurnool,Andhra Pradesh',
'N.S.C.Form,Kurnool,Andhra Pradesh',
'N.Venkatapuram,Kurnool,Andhra Pradesh',
'Nadichagi,Kurnool,Andhra Pradesh',
'Nagaladinne,Kurnool,Andhra Pradesh',
'Naganathanahalli,Kurnool,Andhra Pradesh',
'Nagardona,Kurnool,Andhra Pradesh',
'Nagaruru,Kurnool,Andhra Pradesh',
'Nallachelimala,Kurnool,Andhra Pradesh',
'Nallakalva,Kurnool,Andhra Pradesh',
'Nancherla,Kurnool,Andhra Pradesh',
'Nandanapalli,Kurnool,Andhra Pradesh',
'Nandavaram,Kurnool,Andhra Pradesh',
'Nandikotkur,Kurnool,Andhra Pradesh',
'Nandikotkur-bazar,Kurnool,Andhra Pradesh',
'Nandikunta,Kurnool,Andhra Pradesh',
'Nannuru,Kurnool,Andhra Pradesh',
'Narayanapauram,Kurnool,Andhra Pradesh',
'Nayakallu,Kurnool,Andhra Pradesh',
'Nelatalamarri,Kurnool,Andhra Pradesh',
'Nellibanda,Kurnool,Andhra Pradesh',
'Nemakallu,Kurnool,Andhra Pradesh',
'Nerniki,Kurnool,Andhra Pradesh',
'Nidjur,Kurnool,Andhra Pradesh',
'Nitravatti,Kurnool,Andhra Pradesh',
'Om Nagar,Kurnool,Andhra Pradesh',
'P.Devalapuram,Kurnool,Andhra Pradesh',
'P.Lingala,Kurnool,Andhra Pradesh',
'P.R.Palli,Kurnool,Andhra Pradesh',
'Padidempadu,Kurnool,Andhra Pradesh',
'Pagidala,Kurnool,Andhra Pradesh',
'Pagidirai,Kurnool,Andhra Pradesh',
'Pallidoddi,Kurnool,Andhra Pradesh',
'Palukudoddi,Kurnool,Andhra Pradesh',
'Pamulapadu,Kurnool,Andhra Pradesh',
'Panchalingala,Kurnool,Andhra Pradesh',
'Pandikona,Kurnool,Andhra Pradesh',
'Parla,Kurnool,Andhra Pradesh',
'Parlapalli,Kurnool,Andhra Pradesh',
'Parumanchala,Kurnool,Andhra Pradesh',
'Pasupula,Kurnool,Andhra Pradesh',
'Pattikonda,Kurnool,Andhra Pradesh',
'Peapully,Kurnool,Andhra Pradesh',
'Peddakadubur,Kurnool,Andhra Pradesh',
'Peddakothali,Kurnool,Andhra Pradesh',
'Peddamarriveedu,Kurnool,Andhra Pradesh',
'Peddanelatur,Kurnool,Andhra Pradesh',
'Peddapadu,Kurnool,Andhra Pradesh',
'Peddapaya,Kurnool,Andhra Pradesh',
'Peddapodilla,Kurnool,Andhra Pradesh',
'Peddathumbalam,Kurnool,Andhra Pradesh',
'Pendekallu Bus Stand,Kurnool,Andhra Pradesh',
'Pendekallu,Kurnool,Andhra Pradesh',
'Peravali,Kurnool,Andhra Pradesh',
'Pinnapuram,Kurnool,Andhra Pradesh',
'Polukallu,Kurnool,Andhra Pradesh',
'Pothidoddi,Kurnool,Andhra Pradesh',
'Pothugal,Kurnool,Andhra Pradesh',
'Prakash Nagar,Kurnool,Andhra Pradesh',
'Prathakota,Kurnool,Andhra Pradesh',
'Prathakota-east,Kurnool,Andhra Pradesh',
'Pudur,Kurnool,Andhra Pradesh',
'Pulakurthi,Kurnool,Andhra Pradesh',
'Pulikonda,Kurnool,Andhra Pradesh',
'Puricherla,Kurnool,Andhra Pradesh',
'Putchakayalamada,Kurnool,Andhra Pradesh',
'R.Kanapuram,Kurnool,Andhra Pradesh',
'R.Konthalapadu,Kurnool,Andhra Pradesh',
'R.Kottapalli,Kurnool,Andhra Pradesh',
'Rahimanpuram,Kurnool,Andhra Pradesh',
'Rakasamarri,Kurnool,Andhra Pradesh',
'Ramadurgam,Kurnool,Andhra Pradesh',
'Rampalli,Kurnool,Andhra Pradesh',
'Rangapuram,Kurnool,Andhra Pradesh',
'Ratana,Kurnool,Andhra Pradesh',
'Regadagudur,Kurnool,Andhra Pradesh',
'Remata,Kurnool,Andhra Pradesh',
'Rollapadu,Kurnool,Andhra Pradesh',
'Rtc Complex Adoni,Kurnool,Andhra Pradesh',
'Rudravaram,Kurnool,Andhra Pradesh',
'Rudur,Kurnool,Andhra Pradesh',
'S.Erragudi,Kurnool,Andhra Pradesh',
'S.K.D.Nagar,Kurnool,Andhra Pradesh',
'S.R.P.M,Kurnool,Andhra Pradesh',
'S.S.Dam East,Kurnool,Andhra Pradesh',
'Salkapuram,Kurnool,Andhra Pradesh',
'Sammatageri,Kurnool,Andhra Pradesh',
'Sankirenipalli,Kurnool,Andhra Pradesh',
'Santhakudlur,Kurnool,Andhra Pradesh',
'SAP Camp-kNL,Kurnool,Andhra Pradesh',
'Sathanikota,Kurnool,Andhra Pradesh',
'Sathanur,Kurnool,Andhra Pradesh',
'Sebhaspuram,Kurnool,Andhra Pradesh',
'Seetharamapuram,Kurnool,Andhra Pradesh',
'Sekunala,Kurnool,Andhra Pradesh',
'Siddapuram,Kurnool,Andhra Pradesh',
'Siddapuram,Kurnool,Andhra Pradesh',
'Siddepalli,Kurnool,Andhra Pradesh',
'Sivapuram,Kurnool,Andhra Pradesh',
'Somayajulapalli,Kurnool,Andhra Pradesh',
'Sri Krishna Nagar,Kurnool,Andhra Pradesh',
'Srisailam,Kurnool,Andhra Pradesh',
'Sudepalli,Kurnool,Andhra Pradesh',
'Sugur,Kurnool,Andhra Pradesh',
'Sulekeri,Kurnool,Andhra Pradesh',
'Sunkeswari,Kurnool,Andhra Pradesh',
'T.Sakibanda,Kurnool,Andhra Pradesh',
'T.Sallakudlur,Kurnool,Andhra Pradesh',
'T.Sanugondla,Kurnool,Andhra Pradesh',
'Tadakanapalli,Kurnool,Andhra Pradesh',
'Talamudipi,Kurnool,Andhra Pradesh',
'Tall Gokulapadu,Kurnool,Andhra Pradesh',
'Tangadancha,Kurnool,Andhra Pradesh',
'Tangaradona,Kurnool,Andhra Pradesh',
'Tarigopula,Kurnool,Andhra Pradesh',
'Tarturu,Kurnool,Andhra Pradesh',
'Tbp.Colony,Kurnool,Andhra Pradesh',
'Ternekallu,Kurnool,Andhra Pradesh',
'Thatipadu,Kurnool,Andhra Pradesh',
'Thilisapuram,Kurnool,Andhra Pradesh',
'Thimmandoddi,Kurnool,Andhra Pradesh',
'Thippanuru,Kurnool,Andhra Pradesh',
'Thudicherla,Kurnool,Andhra Pradesh',
'Togerchedu,Kurnool,Andhra Pradesh',
'Tuggali,Kurnool,Andhra Pradesh',
'Tummalur,Kurnool,Andhra Pradesh',
'Tungabhadra,Kurnool,Andhra Pradesh',
'Udumulapadu,Kurnool,Andhra Pradesh',
'Ulchala,Kurnool,Andhra Pradesh',
'Ulindakonda,Kurnool,Andhra Pradesh',
'Ungaranigundla,Kurnool,Andhra Pradesh',
'Uppalapadu,Kurnool,Andhra Pradesh',
'Upparahal,Kurnool,Andhra Pradesh',
'Upparlapalli,Kurnool,Andhra Pradesh',
'Vaddeman,Kurnool,Andhra Pradesh',
'Vadlaramapuram,Kurnool,Andhra Pradesh',
'Vagarur,Kurnool,Andhra Pradesh',
'Vanala,Kurnool,Andhra Pradesh',
'Vandagallu,Kurnool,Andhra Pradesh',
'Vandavagaili,Kurnool,Andhra Pradesh',
'Veepanagandla,Kurnool,Andhra Pradesh',
'Veldurthi,Kurnool,Andhra Pradesh',
'Velgode,Kurnool,Andhra Pradesh',
'Velpanur,Kurnool,Andhra Pradesh',
'Vempenta,Kurnool,Andhra Pradesh',
'Vengalampalli,Kurnool,Andhra Pradesh',
'Venkatagiri,Kurnool,Andhra Pradesh',
'Venkatapuram,Kurnool,Andhra Pradesh',
'Virupapuram,Kurnool,Andhra Pradesh',
'Virupapuram,Kurnool,Andhra Pradesh',
'Vorvakallu,Kurnool,Andhra Pradesh',
'Vuyyalawada,Kurnool,Andhra Pradesh',
'Yatakallu,Kurnool,Andhra Pradesh',
'Yelamakur,Kurnool,Andhra Pradesh',
'Yembai,Kurnool,Andhra Pradesh',
'Yemmiganur,Kurnool,Andhra Pradesh',
'Yemmiganur-bazar,Kurnool,Andhra Pradesh',
'Yenugumarri,Kurnool,Andhra Pradesh',
'Yeruru,Kurnool,Andhra Pradesh',
'A.Kodur,Nandyal,Andhra Pradesh',
'Ayalur,Nandyal,Andhra Pradesh',
'B.Kodur,Nandyal,Andhra Pradesh',
'Bandi Atmakur,Nandyal,Andhra Pradesh',
'Bhillalapuram,Nandyal,Andhra Pradesh',
'Bhimavaram,Nandyal,Andhra Pradesh',
'Bollavaram,Nandyal,Andhra Pradesh',
'Chabolu,Nandyal,Andhra Pradesh',
'Chapirevula,Nandyal,Andhra Pradesh',
'Chidukur,Nandyal,Andhra Pradesh',
'Durvesi,Nandyal,Andhra Pradesh',
'Eernipadu,Nandyal,Andhra Pradesh',
'Erraguntla,Nandyal,Andhra Pradesh',
'Gadigarevula,Nandyal,Andhra Pradesh',
'Galichennayapalem,Nandyal,Andhra Pradesh',
'Industrial Estate,Nandyal,Andhra Pradesh',
'Kakanur,Nandyal,Andhra Pradesh',
'Kanala,Nandyal,Andhra Pradesh',
'Karimaddula,Nandyal,Andhra Pradesh',
'Kondajutur,Nandyal,Andhra Pradesh',
'Koratamaddi,Nandyal,Andhra Pradesh',
'Kothapalle,Nandyal,Andhra Pradesh',
'Kottala,Nandyal,Andhra Pradesh',
'Lingapuram,Nandyal,Andhra Pradesh',
'Mahanandi Cattle Farm,Nandyal,Andhra Pradesh',
'Mahanandi,Nandyal,Andhra Pradesh',
'N.G.O.S Coloy,Nandyal,Andhra Pradesh',
'Nandipalle,Nandyal,Andhra Pradesh',
'Nandyal Bazar,Nandyal,Andhra Pradesh',
'Nandyal H.O,Nandyal,Andhra Pradesh',
'Nandyal R.S.,Nandyal,Andhra Pradesh',
'Noone Palle,Nandyal,Andhra Pradesh',
'Parnapalle,Nandyal,Andhra Pradesh',
'Pesaravai,Nandyal,Andhra Pradesh',
'Polur,Nandyal,Andhra Pradesh',
'Pulimaddi,Nandyal,Andhra Pradesh',
'Pusulur,Nandyal,Andhra Pradesh',
'Raithunagaram,Nandyal,Andhra Pradesh',
'Ramapuram,Nandyal,Andhra Pradesh',
'Rayamalpuram,Nandyal,Andhra Pradesh',
'Sanjeeva Nagar,Nandyal,Andhra Pradesh',
'Santajutur,Nandyal,Andhra Pradesh',
'Singavaram,Nandyal,Andhra Pradesh',
'Srinivasa Nagar,Nandyal,Andhra Pradesh',
'Tekke,Nandyal,Andhra Pradesh',
'Thammadapalle,Nandyal,Andhra Pradesh',
'Thimmapuram,Nandyal,Andhra Pradesh',
'Togarchedu,Nandyal,Andhra Pradesh',
'Udumalpuram,Nandyal,Andhra Pradesh',
'S.Nagulavaram,Nandyal,Andhra Pradesh',
'Sirvel,Nandyal,Andhra Pradesh',
'Yallur,Nandyal,Andhra Pradesh',
'Yerraguntla,Nandyal,Andhra Pradesh',
'Abhangapur,Mahabubnagar,Andhra Pradesh',
'Addakal,Mahabubnagar,Andhra Pradesh',
'Advi Venkatapur,Mahabubnagar,Andhra Pradesh',
'Alampally,Mahabubnagar,Andhra Pradesh',
'Alampur,Mahabubnagar,Andhra Pradesh',
'Alur,Mahabubnagar,Andhra Pradesh',
'Alwalpad,Mahabubnagar,Andhra Pradesh',
'Amdipur,Mahabubnagar,Andhra Pradesh',
'Amerchinta,Mahabubnagar,Andhra Pradesh',
'Amervoi,Mahabubnagar,Andhra Pradesh',
'Amistapur,Mahabubnagar,Andhra Pradesh',
'Ammapur,Mahabubnagar,Andhra Pradesh',
'Ananthapur,Mahabubnagar,Andhra Pradesh',
'Angadi Raichur,Mahabubnagar,Andhra Pradesh',
'Ankilla,Mahabubnagar,Andhra Pradesh',
'Annaram,Mahabubnagar,Andhra Pradesh',
'Annasagar,Mahabubnagar,Andhra Pradesh',
'Annasagar,Mahabubnagar,Andhra Pradesh',
'Antharam,Mahabubnagar,Andhra Pradesh',
'Antharam,Mahabubnagar,Andhra Pradesh',
'Anugonda,Mahabubnagar,Andhra Pradesh',
'Appareddipalli,Mahabubnagar,Andhra Pradesh',
'Aragidda,Mahabubnagar,Andhra Pradesh',
'Arepally,Mahabubnagar,Andhra Pradesh',
'Atmakur,Mahabubnagar,Andhra Pradesh',
'Atmakur So (A),Mahabubnagar,Andhra Pradesh',
'Balajinagar,Mahabubnagar,Andhra Pradesh',
'Balampet,Mahabubnagar,Andhra Pradesh',
'Bandamedipally,Mahabubnagar,Andhra Pradesh',
'Bandarpally,Mahabubnagar,Andhra Pradesh',
'Bapanpally,Mahabubnagar,Andhra Pradesh',
'Baswaipalli,Mahabubnagar,Andhra Pradesh',
'Baswapur,Mahabubnagar,Andhra Pradesh',
'Beechpally,Mahabubnagar,Andhra Pradesh',
'Beerole,Mahabubnagar,Andhra Pradesh',
'Bhairamkonda,Mahabubnagar,Andhra Pradesh',
'Bhogaram,Mahabubnagar,Andhra Pradesh',
'Bhuneed,Mahabubnagar,Andhra Pradesh',
'Bhutpur,Mahabubnagar,Andhra Pradesh',
'Bhutpur,Mahabubnagar,Andhra Pradesh',
'Bichal,Mahabubnagar,Andhra Pradesh',
'Bijwar,Mahabubnagar,Andhra Pradesh',
'Bijwar,Mahabubnagar,Andhra Pradesh',
'Bingidoddi,Mahabubnagar,Andhra Pradesh',
'Bommanpad,Mahabubnagar,Andhra Pradesh',
'Bomraspet,Mahabubnagar,Andhra Pradesh',
'Bonkur,Mahabubnagar,Andhra Pradesh',
'Boyagudem,Mahabubnagar,Andhra Pradesh',
'Boyapally,Mahabubnagar,Andhra Pradesh',
'Buddaram,Mahabubnagar,Andhra Pradesh',
'Bukkapur,Mahabubnagar,Andhra Pradesh',
'Buranpur,Mahabubnagar,Andhra Pradesh',
'Chagadona,Mahabubnagar,Andhra Pradesh',
'Chagapur,Mahabubnagar,Andhra Pradesh',
'Challapur,Mahabubnagar,Andhra Pradesh',
'Chandapur,Mahabubnagar,Andhra Pradesh',
'Chandrakallu,Mahabubnagar,Andhra Pradesh',
'Chandraspalli,Mahabubnagar,Andhra Pradesh',
'Chandravancha,Mahabubnagar,Andhra Pradesh',
'Chegunta,Mahabubnagar,Andhra Pradesh',
'Chellapur,Mahabubnagar,Andhra Pradesh',
'Chennaram,Mahabubnagar,Andhra Pradesh',
'Chennipad,Mahabubnagar,Andhra Pradesh',
'Chilmulmailwar,Mahabubnagar,Andhra Pradesh',
'Chinna Jatram,Mahabubnagar,Andhra Pradesh',
'Chinna Tandrapad,Mahabubnagar,Andhra Pradesh',
'Chinnadarpalli,Mahabubnagar,Andhra Pradesh',
'Chinnaporla,Mahabubnagar,Andhra Pradesh',
'Chinta Kunta Kurd,Mahabubnagar,Andhra Pradesh',
'Chintalkunta,Mahabubnagar,Andhra Pradesh',
'Chintareval,Mahabubnagar,Andhra Pradesh',
'Chitlapally,Mahabubnagar,Andhra Pradesh',
'Chittanur,Mahabubnagar,Andhra Pradesh',
'Chityala,Mahabubnagar,Andhra Pradesh',
'Chowdarpalli,Mahabubnagar,Andhra Pradesh',
'Chowdarpalli,Mahabubnagar,Andhra Pradesh',
'Chowdarpally,Mahabubnagar,Andhra Pradesh',
'Dadapur,Mahabubnagar,Andhra Pradesh',
'Damargidda,Mahabubnagar,Andhra Pradesh',
'Damganpur,Mahabubnagar,Andhra Pradesh',
'Damganpur,Mahabubnagar,Andhra Pradesh',
'Dasardoddi,Mahabubnagar,Andhra Pradesh',
'Desai Pally,Mahabubnagar,Andhra Pradesh',
'Devalfaslawar,Mahabubnagar,Andhra Pradesh',
'Devarkadra,Mahabubnagar,Andhra Pradesh',
'Dhanwada,Mahabubnagar,Andhra Pradesh',
'Dharmapur,Mahabubnagar,Andhra Pradesh',
'Dharmavaram,Mahabubnagar,Andhra Pradesh',
'Dharur,Mahabubnagar,Andhra Pradesh',
'Dokur,Mahabubnagar,Andhra Pradesh',
'Dorepally,Mahabubnagar,Andhra Pradesh',
'Doultabad,Mahabubnagar,Andhra Pradesh',
'Dudiyal,Mahabubnagar,Andhra Pradesh',
'Edavally,Mahabubnagar,Andhra Pradesh',
'Eklaspur,Mahabubnagar,Andhra Pradesh',
'Eligandla,Mahabubnagar,Andhra Pradesh',
'Eranpally,Mahabubnagar,Andhra Pradesh',
'Erikichedu,Mahabubnagar,Andhra Pradesh',
'Erupmalla,Mahabubnagar,Andhra Pradesh',
'Fareedpur,Mahabubnagar,Andhra Pradesh',
'Fathepur,Mahabubnagar,Andhra Pradesh',
'Gaddegudem,Mahabubnagar,Andhra Pradesh',
'Gajulapet,Mahabubnagar,Andhra Pradesh',
'Gandwed,Mahabubnagar,Andhra Pradesh',
'Garlapahad,Mahabubnagar,Andhra Pradesh',
'Ghanpur,Mahabubnagar,Andhra Pradesh',
'Ghattu,Mahabubnagar,Andhra Pradesh',
'Gokhafaslawar,Mahabubnagar,Andhra Pradesh',
'Gokul Nagar,Mahabubnagar,Andhra Pradesh',
'Gopanpally,Mahabubnagar,Andhra Pradesh',
'Gopanpet,Mahabubnagar,Andhra Pradesh',
'Gorlakhan Doddi,Mahabubnagar,Andhra Pradesh',
'Gotur,Mahabubnagar,Andhra Pradesh',
'Gouraram,Mahabubnagar,Andhra Pradesh',
'Gudeballur,Mahabubnagar,Andhra Pradesh',
'Gudigandla,Mahabubnagar,Andhra Pradesh',
'Gudimunkan Pally,Mahabubnagar,Andhra Pradesh',
'Gundimalla,Mahabubnagar,Andhra Pradesh',
'Gundiyal,Mahabubnagar,Andhra Pradesh',
'Gundmal,Mahabubnagar,Andhra Pradesh',
'Gunumukla,Mahabubnagar,Andhra Pradesh',
'Gurakonda,Mahabubnagar,Andhra Pradesh',
'Gurukunta,Mahabubnagar,Andhra Pradesh',
'Hakeempet,Mahabubnagar,Andhra Pradesh',
'Hanumanpura,Mahabubnagar,Andhra Pradesh',
'Hindupur,Mahabubnagar,Andhra Pradesh',
'Hunwada,Mahabubnagar,Andhra Pradesh',
'Husnabad,Mahabubnagar,Andhra Pradesh',
'Ibrahimbad,Mahabubnagar,Andhra Pradesh',
'Ibrahimpatnam,Mahabubnagar,Andhra Pradesh',
'Ieeja,Mahabubnagar,Andhra Pradesh',
'Ind. Estate,Mahabubnagar,Andhra Pradesh',
'Indanur,Mahabubnagar,Andhra Pradesh',
'Induvasi,Mahabubnagar,Andhra Pradesh',
'Ippatur,Mahabubnagar,Andhra Pradesh',
'Irladinne,Mahabubnagar,Andhra Pradesh',
'Itkyala,Mahabubnagar,Andhra Pradesh',
'Itkyalapad,Mahabubnagar,Andhra Pradesh',
'Jajapur,Mahabubnagar,Andhra Pradesh',
'Jaklair,Mahabubnagar,Andhra Pradesh',
'Jalalpur,Mahabubnagar,Andhra Pradesh',
'Jallapur,Mahabubnagar,Andhra Pradesh',
'Jammiched,Mahabubnagar,Andhra Pradesh',
'Janampet,Mahabubnagar,Andhra Pradesh',
'Jatram Kalan,Mahabubnagar,Andhra Pradesh',
'Jingirala,Mahabubnagar,Andhra Pradesh',
'Jinnaram,Mahabubnagar,Andhra Pradesh',
'Julaikal,Mahabubnagar,Andhra Pradesh',
'Julapalli,Mahabubnagar,Andhra Pradesh',
'Juriyala,Mahabubnagar,Andhra Pradesh',
'Kachwar,Mahabubnagar,Andhra Pradesh',
'Kadmoor,Mahabubnagar,Andhra Pradesh',
'Kakarlapahad,Mahabubnagar,Andhra Pradesh',
'Kakulavaram,Mahabubnagar,Andhra Pradesh',
'Kalakuntla,Mahabubnagar,Andhra Pradesh',
'Kalwal,Mahabubnagar,Andhra Pradesh',
'Kamaluddinpur,Mahabubnagar,Andhra Pradesh',
'Kamsanpally,Mahabubnagar,Andhra Pradesh',
'Kancherla,Mahabubnagar,Andhra Pradesh',
'Kandanpally,Mahabubnagar,Andhra Pradesh',
'Kandur,Mahabubnagar,Andhra Pradesh',
'Kankurthy,Mahabubnagar,Andhra Pradesh',
'Kanmankalwa,Mahabubnagar,Andhra Pradesh',
'Kanmanur,Mahabubnagar,Andhra Pradesh',
'Karkonda,Mahabubnagar,Andhra Pradesh',
'Karni,Mahabubnagar,Andhra Pradesh',
'Karur,Mahabubnagar,Andhra Pradesh',
'Kasturpally,Mahabubnagar,Andhra Pradesh',
'Kazipur,Mahabubnagar,Andhra Pradesh',
'Kistapur,Mahabubnagar,Andhra Pradesh',
'Kodangal,Mahabubnagar,Andhra Pradesh',
'Kodur,Mahabubnagar,Andhra Pradesh',
'Koilkonda,Mahabubnagar,Andhra Pradesh',
'Koilsagar,Mahabubnagar,Andhra Pradesh',
'Kollampalli,Mahabubnagar,Andhra Pradesh',
'Kollur,Mahabubnagar,Andhra Pradesh',
'Komireddi Pally,Mahabubnagar,Andhra Pradesh',
'Kondair,Mahabubnagar,Andhra Pradesh',
'Kondapally,Mahabubnagar,Andhra Pradesh',
'Kondapur,Mahabubnagar,Andhra Pradesh',
'Kondapuram,Mahabubnagar,Andhra Pradesh',
'Kongat Pally,Mahabubnagar,Andhra Pradesh',
'Konkal,Mahabubnagar,Andhra Pradesh',
'Korvipad,Mahabubnagar,Andhra Pradesh',
'Kosgi,Mahabubnagar,Andhra Pradesh',
'Kotakadra,Mahabubnagar,Andhra Pradesh',
'Kotakonda,Mahabubnagar,Andhra Pradesh',
'Kothamolgara,Mahabubnagar,Andhra Pradesh',
'Kothapally,Mahabubnagar,Andhra Pradesh',
'Kothapally,Mahabubnagar,Andhra Pradesh',
'Kothapally,Mahabubnagar,Andhra Pradesh',
'Kothapally,Mahabubnagar,Andhra Pradesh',
'Kothapet,Mahabubnagar,Andhra Pradesh',
'Kothlabad,Mahabubnagar,Andhra Pradesh',
'Kothur,Mahabubnagar,Andhra Pradesh',
'Koukunt R.S.,Mahabubnagar,Andhra Pradesh',
'Koukuntla,Mahabubnagar,Andhra Pradesh',
'Kovaldinne,Mahabubnagar,Andhra Pradesh',
'Krishna Nagar,Mahabubnagar,Andhra Pradesh',
'Krishna,Mahabubnagar,Andhra Pradesh',
'Kuchur,Mahabubnagar,Andhra Pradesh',
'Kudirmalla,Mahabubnagar,Andhra Pradesh',
'Kulakcherla,Mahabubnagar,Andhra Pradesh',
'Kulpur,Mahabubnagar,Andhra Pradesh',
'Kunsi,Mahabubnagar,Andhra Pradesh',
'Kusumasamudram,Mahabubnagar,Andhra Pradesh',
'Kyathanpally,Mahabubnagar,Andhra Pradesh',
'Kyathur,Mahabubnagar,Andhra Pradesh',
'Lakcherla,Mahabubnagar,Andhra Pradesh',
'Lalkot,Mahabubnagar,Andhra Pradesh',
'Lankal,Mahabubnagar,Andhra Pradesh',
'Laxmipally,Mahabubnagar,Andhra Pradesh',
'Lingampally,Mahabubnagar,Andhra Pradesh',
'Lingampaly,Mahabubnagar,Andhra Pradesh',
'Linganvai,Mahabubnagar,Andhra Pradesh',
'Lokurthy,Mahabubnagar,Andhra Pradesh',
'Machanpalli,Mahabubnagar,Andhra Pradesh',
'Macherla,Mahabubnagar,Andhra Pradesh',
'Maddelabanda,Mahabubnagar,Andhra Pradesh',
'Maddigatla,Mahabubnagar,Andhra Pradesh',
'Maddur,Mahabubnagar,Andhra Pradesh',
'Madhwar,Mahabubnagar,Andhra Pradesh',
'Madhwar,Mahabubnagar,Andhra Pradesh',
'Maganur,Mahabubnagar,Andhra Pradesh',
'Makthal,Mahabubnagar,Andhra Pradesh',
'Malkapuram,Mahabubnagar,Andhra Pradesh',
'Mallepalli,Mahabubnagar,Andhra Pradesh',
'Malreddy Pally,Mahabubnagar,Andhra Pradesh',
'Mamidimada,Mahabubnagar,Andhra Pradesh',
'Manajipet,Mahabubnagar,Andhra Pradesh',
'Manavapad,Mahabubnagar,Andhra Pradesh',
'Mandipalli,Mahabubnagar,Andhra Pradesh',
'Mandoddi,Mahabubnagar,Andhra Pradesh',
'Mangampet,Mahabubnagar,Andhra Pradesh',
'Manikonda,Mahabubnagar,Andhra Pradesh',
'Mannapur,Mahabubnagar,Andhra Pradesh',
'Manthan Gode,Mahabubnagar,Andhra Pradesh',
'Marlabeed,Mahabubnagar,Andhra Pradesh',
'Marmungal,Mahabubnagar,Andhra Pradesh',
'Marrikal,Mahabubnagar,Andhra Pradesh',
'Marrikal,Mahabubnagar,Andhra Pradesh',
'Mastipur,Mahabubnagar,Andhra Pradesh',
'Mbn Rs,Mahabubnagar,Andhra Pradesh',
'Medikonda,Mahabubnagar,Andhra Pradesh',
'Metlakunta,Mahabubnagar,Andhra Pradesh',
'Mirzapur,Mahabubnagar,Andhra Pradesh',
'Mittadoddi,Mahabubnagar,Andhra Pradesh',
'Mogalmadka,Mahabubnagar,Andhra Pradesh',
'Mohammadabad,Mahabubnagar,Andhra Pradesh',
'Mothkur,Mahabubnagar,Andhra Pradesh',
'Motlampally,Mahabubnagar,Andhra Pradesh',
'Muchintala,Mahabubnagar,Andhra Pradesh',
'Mudmal,Mahabubnagar,Andhra Pradesh',
'Mulamalla,Mahabubnagar,Andhra Pradesh',
'Muldakal,Mahabubnagar,Andhra Pradesh',
'Mulkalpally,Mahabubnagar,Andhra Pradesh',
'Munimoksham,Mahabubnagar,Andhra Pradesh',
'Musapet,Mahabubnagar,Andhra Pradesh',
'Mushrifa,Mahabubnagar,Andhra Pradesh',
'Mustipalli,Mahabubnagar,Andhra Pradesh',
'Nagal Kadmoor,Mahabubnagar,Andhra Pradesh',
'Nagaram,Mahabubnagar,Andhra Pradesh',
'Nancherla,Mahabubnagar,Andhra Pradesh',
'Nandaram,Mahabubnagar,Andhra Pradesh',
'Nandigam,Mahabubnagar,Andhra Pradesh',
'Nandimalla,Mahabubnagar,Andhra Pradesh',
'Nandinne,Mahabubnagar,Andhra Pradesh',
'Narayanpet Bazar,Mahabubnagar,Andhra Pradesh',
'Narayanpet,Mahabubnagar,Andhra Pradesh',
'Narsapur,Mahabubnagar,Andhra Pradesh',
'Narva,Mahabubnagar,Andhra Pradesh',
'Nawabpet,Mahabubnagar,Andhra Pradesh',
'Neetur,Mahabubnagar,Andhra Pradesh',
'Nellikondi,Mahabubnagar,Andhra Pradesh',
'Neredgaon,Mahabubnagar,Andhra Pradesh',
'Nettampahad,Mahabubnagar,Andhra Pradesh',
'Nidgurthy,Mahabubnagar,Andhra Pradesh',
'Nidijinta,Mahabubnagar,Andhra Pradesh',
'Oppair,Mahabubnagar,Andhra Pradesh',
'Osmangunj,Mahabubnagar,Andhra Pradesh',
'P.C.Kunta,Mahabubnagar,Andhra Pradesh',
'Pagdimarri,Mahabubnagar,Andhra Pradesh',
'Pagidial,Mahabubnagar,Andhra Pradesh',
'Pagunta,Mahabubnagar,Andhra Pradesh',
'Paipadu,Mahabubnagar,Andhra Pradesh',
'Palkonda,Mahabubnagar,Andhra Pradesh',
'Pallamarri,Mahabubnagar,Andhra Pradesh',
'Pallepad,Mahabubnagar,Andhra Pradesh',
'Pallerla,Mahabubnagar,Andhra Pradesh',
'Palvoi,Mahabubnagar,Andhra Pradesh',
'Panchalingal,Mahabubnagar,Andhra Pradesh',
'Panchdev Pahad,Mahabubnagar,Andhra Pradesh',
'Parmal,Mahabubnagar,Andhra Pradesh',
'Parpally,Mahabubnagar,Andhra Pradesh',
'Parsapur,Mahabubnagar,Andhra Pradesh',
'Parvathapuram,Mahabubnagar,Andhra Pradesh',
'Pathamolgara,Mahabubnagar,Andhra Pradesh',
'Pathapalamur,Mahabubnagar,Andhra Pradesh',
'Pathapalem,Mahabubnagar,Andhra Pradesh',
'Patherched,Mahabubnagar,Andhra Pradesh',
'Pedda Darpally,Mahabubnagar,Andhra Pradesh',
'Pedda Mungalched,Mahabubnagar,Andhra Pradesh',
'Peddadinne,Mahabubnagar,Andhra Pradesh',
'Peddamamidala Padu,Mahabubnagar,Andhra Pradesh',
'Peddaporla,Mahabubnagar,Andhra Pradesh',
'Peddapothulapad,Mahabubnagar,Andhra Pradesh',
'Peddatandrapad,Mahabubnagar,Andhra Pradesh',
'Peddatandrapad,Mahabubnagar,Andhra Pradesh',
'Peddawarval,Mahabubnagar,Andhra Pradesh',
'Pedripadu,Mahabubnagar,Andhra Pradesh',
'Penchikalpadu,Mahabubnagar,Andhra Pradesh',
'Perapalla,Mahabubnagar,Andhra Pradesh',
'Perur,Mahabubnagar,Andhra Pradesh',
'Polepally,Mahabubnagar,Andhra Pradesh',
'Polkampally,Mahabubnagar,Andhra Pradesh',
'Ponnakallu,Mahabubnagar,Andhra Pradesh',
'Poodur,Mahabubnagar,Andhra Pradesh',
'Pothreddipalli,Mahabubnagar,Andhra Pradesh',
'Pothulmadugu,Mahabubnagar,Andhra Pradesh',
'Pragatur,Mahabubnagar,Andhra Pradesh',
'Priyadarshini Juriyala Project,Mahabubnagar,Andhra Pradesh',
'Pulikallu,Mahabubnagar,Andhra Pradesh',
'Pulimamidi,Mahabubnagar,Andhra Pradesh',
'Pullur,Mahabubnagar,Andhra Pradesh',
'Pusalpahad,Mahabubnagar,Andhra Pradesh',
'Puttandoddi,Mahabubnagar,Andhra Pradesh',
'Puttapahad,Mahabubnagar,Andhra Pradesh',
'Rachala,Mahabubnagar,Andhra Pradesh',
'Raikode,Mahabubnagar,Andhra Pradesh',
'Rajoli,Mahabubnagar,Andhra Pradesh',
'Rakonda,Mahabubnagar,Andhra Pradesh',
'Ramapuram,Mahabubnagar,Andhra Pradesh',
'Rampur,Mahabubnagar,Andhra Pradesh',
'Rampur,Mahabubnagar,Andhra Pradesh',
'Rawulapally,Mahabubnagar,Andhra Pradesh',
'Rechintala,Mahabubnagar,Andhra Pradesh',
'Regadmailwar,Mahabubnagar,Andhra Pradesh',
'Rekulampalli,Mahabubnagar,Andhra Pradesh',
'Renwatla,Mahabubnagar,Andhra Pradesh',
'Rudraram,Mahabubnagar,Andhra Pradesh',
'Rudrasamudram,Mahabubnagar,Andhra Pradesh',
'Ryalam Pahad,Mahabubnagar,Andhra Pradesh',
'Salkarpet,Mahabubnagar,Andhra Pradesh',
'Sangambanda,Mahabubnagar,Andhra Pradesh',
'Sarzakhanpet,Mahabubnagar,Andhra Pradesh',
'Satarla,Mahabubnagar,Andhra Pradesh',
'Satyawar,Mahabubnagar,Andhra Pradesh',
'Seri Venkatapur,Mahabubnagar,Andhra Pradesh',
'Shaik Pally,Mahabubnagar,Andhra Pradesh',
'Shanti Nagar,Mahabubnagar,Andhra Pradesh',
'Sindhanoor,Mahabubnagar,Andhra Pradesh',
'Singwar,Mahabubnagar,Andhra Pradesh',
'Singwar,Mahabubnagar,Andhra Pradesh',
'Solipur,Mahabubnagar,Andhra Pradesh',
'Suraram,Mahabubnagar,Andhra Pradesh',
'T.D. Gutta,Mahabubnagar,Andhra Pradesh',
'Takkasila,Mahabubnagar,Andhra Pradesh',
'Tangadgi,Mahabubnagar,Andhra Pradesh',
'Tangal,Mahabubnagar,Andhra Pradesh',
'Tankara,Mahabubnagar,Andhra Pradesh',
'Tatikonda,Mahabubnagar,Andhra Pradesh',
'Tatikunta,Mahabubnagar,Andhra Pradesh',
'Tekalkode,Mahabubnagar,Andhra Pradesh',
'Theelair,Mahabubnagar,Andhra Pradesh',
'Thimmapur,Mahabubnagar,Andhra Pradesh',
'Thipdampally,Mahabubnagar,Andhra Pradesh',
'Thirmalapur,Mahabubnagar,Andhra Pradesh',
'Thummala Chervu,Mahabubnagar,Andhra Pradesh',
'Tipraspalli,Mahabubnagar,Andhra Pradesh',
'Tirmalapur,Mahabubnagar,Andhra Pradesh',
'Tirumalapur,Mahabubnagar,Andhra Pradesh',
'Togapur,Mahabubnagar,Andhra Pradesh',
'Tottinon Doddi,Mahabubnagar,Andhra Pradesh',
'Tunkimetla,Mahabubnagar,Andhra Pradesh',
'Udamalgidda,Mahabubnagar,Andhra Pradesh',
'Udandapur,Mahabubnagar,Andhra Pradesh',
'Ujjali,Mahabubnagar,Andhra Pradesh',
'Undavelly,Mahabubnagar,Andhra Pradesh',
'Undekode,Mahabubnagar,Andhra Pradesh',
'Undiyal,Mahabubnagar,Andhra Pradesh',
'Uppal,Mahabubnagar,Andhra Pradesh',
'Uppal Camp,Mahabubnagar,Andhra Pradesh',
'Utkur,Mahabubnagar,Andhra Pradesh',
'Uttanur,Mahabubnagar,Andhra Pradesh',
'Vallur,Mahabubnagar,Andhra Pradesh',
'Varne,Mahabubnagar,Andhra Pradesh',
'Veeraipally,Mahabubnagar,Andhra Pradesh',
'Veerannapet,Mahabubnagar,Andhra Pradesh',
'Veltur,Mahabubnagar,Andhra Pradesh',
'Vemula,Mahabubnagar,Andhra Pradesh',
'Vemula,Mahabubnagar,Andhra Pradesh',
'Venkatreddypally,Mahabubnagar,Andhra Pradesh',
'Vennached,Mahabubnagar,Andhra Pradesh',
'Vepur,Mahabubnagar,Andhra Pradesh',
'Vinjamur,Mahabubnagar,Andhra Pradesh',
'Vitalapur,Mahabubnagar,Andhra Pradesh',
'Vithalapuram,Mahabubnagar,Andhra Pradesh',
'Wadcherla,Mahabubnagar,Andhra Pradesh',
'Waddeman,Mahabubnagar,Andhra Pradesh',
'Waddepalli,Mahabubnagar,Andhra Pradesh',
'Wadwat,Mahabubnagar,Andhra Pradesh',
'Warkur,Mahabubnagar,Andhra Pradesh',
'Wathugundla,Mahabubnagar,Andhra Pradesh',
'Yamki,Mahabubnagar,Andhra Pradesh',
'Yanmangandla,Mahabubnagar,Andhra Pradesh',
'Yapadinne,Mahabubnagar,Andhra Pradesh',
'Yedira,Mahabubnagar,Andhra Pradesh',
'Yelkur,Mahabubnagar,Andhra Pradesh',
'Yenkipalli,Mahabubnagar,Andhra Pradesh',
'Yenugonda,Mahabubnagar,Andhra Pradesh',
'Antharam,Wanaparthy,Andhra Pradesh',
'Ayyavaripalli,Wanaparthy,Andhra Pradesh',
'Boinpally,Wanaparthy,Andhra Pradesh',
'Chilivera,Wanaparthy,Andhra Pradesh',
'Chndradana,Wanaparthy,Andhra Pradesh',
'Donuru,Wanaparthy,Andhra Pradesh',
'Gudigani Pally,Wanaparthy,Andhra Pradesh',
'Julapally,Wanaparthy,Andhra Pradesh',
'Kothapally,Wanaparthy,Andhra Pradesh',
'Kothur,Wanaparthy,Andhra Pradesh',
'Ramapuram,Wanaparthy,Andhra Pradesh',
'Revally,Wanaparthy,Andhra Pradesh',
'Vadial,Wanaparthy,Andhra Pradesh',
'Vasupala,Wanaparthy,Andhra Pradesh',
'Vemula,Wanaparthy,Andhra Pradesh',
'Yelyal,Wanaparthy,Andhra Pradesh',
'Achampet,Wanaparthy,Andhra Pradesh',
'Akkaram,Wanaparthy,Andhra Pradesh',
'Bommanpally,Wanaparthy,Andhra Pradesh',
'Chandapur,Wanaparthy,Andhra Pradesh',
'Ghanpur,Wanaparthy,Andhra Pradesh',
'Hajipur,Wanaparthy,Andhra Pradesh',
'Inole,Wanaparthy,Andhra Pradesh',
'Mannevaripally,Wanaparthy,Andhra Pradesh',
'Nadimpally,Wanaparthy,Andhra Pradesh',
'Palkapally,Wanaparthy,Andhra Pradesh',
'Puljal,Wanaparthy,Andhra Pradesh',
'Rangapur,Wanaparthy,Andhra Pradesh',
'Siddapur,Wanaparthy,Andhra Pradesh',
'Akuthotapally,Wanaparthy,Andhra Pradesh',
'Amangal,Wanaparthy,Andhra Pradesh',
'Ekvaipally,Wanaparthy,Andhra Pradesh',
'Kadthal,Wanaparthy,Andhra Pradesh',
'Konapur,Wanaparthy,Andhra Pradesh',
'Mudwin,Wanaparthy,Andhra Pradesh',
'Polepally,Wanaparthy,Andhra Pradesh',
'Vittaipally,Wanaparthy,Andhra Pradesh',
'Cherikonda,Wanaparthy,Andhra Pradesh',
'Karkalpahad,Wanaparthy,Andhra Pradesh',
'Amrabad,Wanaparthy,Andhra Pradesh',
'Chitlamkunta,Wanaparthy,Andhra Pradesh',
'Ippalapally,Wanaparthy,Andhra Pradesh',
'Jangamreddypally,Wanaparthy,Andhra Pradesh',
'Kummaronipally,Wanaparthy,Andhra Pradesh',
'Laxmapur,Wanaparthy,Andhra Pradesh',
'Macharam,Wanaparthy,Andhra Pradesh',
'Maddimadugu,Wanaparthy,Andhra Pradesh',
'Madhavanipally,Wanaparthy,Andhra Pradesh',
'Mannanur,Wanaparthy,Andhra Pradesh',
'Maredu,Wanaparthy,Andhra Pradesh',
'Padara,Wanaparthy,Andhra Pradesh',
'Srisailam Dam (West),Wanaparthy,Andhra Pradesh',
'Thirumalapuram,Wanaparthy,Andhra Pradesh',
'Turkaplly,Wanaparthy,Andhra Pradesh',
'Udimilla,Wanaparthy,Andhra Pradesh',
'Vankeswaram,Wanaparthy,Andhra Pradesh',
'Vatvarlapally,Wanaparthy,Andhra Pradesh',
'Balanagar,Wanaparthy,Andhra Pradesh',
'Chinnarevally,Wanaparthy,Andhra Pradesh',
'Chowdur,Wanaparthy,Andhra Pradesh',
'Gunded,Wanaparthy,Andhra Pradesh',
'Kollur,Wanaparthy,Andhra Pradesh',
'Kucherkal,Wanaparthy,Andhra Pradesh',
'Mothighanapur,Wanaparthy,Andhra Pradesh',
'Peddarevally,Wanaparthy,Andhra Pradesh',
'Pomal,Wanaparthy,Andhra Pradesh',
'Rajapur,Wanaparthy,Andhra Pradesh',
'Rangareddyguda,Wanaparthy,Andhra Pradesh',
'Udithyala,Wanaparthy,Andhra Pradesh',
'Yemmajipur,Wanaparthy,Andhra Pradesh',
'Ananthavaram,Wanaparthy,Andhra Pradesh',
'Balmoor,Wanaparthy,Andhra Pradesh',
'Banala,Wanaparthy,Andhra Pradesh',
'Gattuthumman,Wanaparthy,Andhra Pradesh',
'Godal,Wanaparthy,Andhra Pradesh',
'Jinkunta,Wanaparthy,Andhra Pradesh',
'Kondanagula,Wanaparthy,Andhra Pradesh',
'Kondareddipally,Wanaparthy,Andhra Pradesh',
'Polisettipally,Wanaparthy,Andhra Pradesh',
'Ramojipally,Wanaparthy,Andhra Pradesh',
'Thummanpet,Wanaparthy,Andhra Pradesh',
'Maddigatla,Wanaparthy,Andhra Pradesh',
'Bijnapally,Wanaparthy,Andhra Pradesh',
'Gangaram,Wanaparthy,Andhra Pradesh',
'Gundlanarva,Wanaparthy,Andhra Pradesh',
'Khanapur,Wanaparthy,Andhra Pradesh',
'Latpally,Wanaparthy,Andhra Pradesh',
'Lingasanipally,Wanaparthy,Andhra Pradesh',
'Mahadeanpet,Wanaparthy,Andhra Pradesh',
'Manganoor,Wanaparthy,Andhra Pradesh',
'Palem,Wanaparthy,Andhra Pradesh',
'Polepally,Wanaparthy,Andhra Pradesh',
'Shayanpally,Wanaparthy,Andhra Pradesh',
'Vaddeman,Wanaparthy,Andhra Pradesh',
'Vattem,Wanaparthy,Andhra Pradesh',
'Velgonda,Wanaparthy,Andhra Pradesh',
'Yelkicherla,Wanaparthy,Andhra Pradesh',
'Alipur,Wanaparthy,Andhra Pradesh',
'Ammapuram,Wanaparthy,Andhra Pradesh',
'Appampally,Wanaparthy,Andhra Pradesh',
'C.Thirumalapuram,Wanaparthy,Andhra Pradesh',
'Duppalli,Wanaparthy,Andhra Pradesh',
'Maddur,Wanaparthy,Andhra Pradesh',
'Annaram,Wanaparthy,Andhra Pradesh',
'Burgula,Wanaparthy,Andhra Pradesh',
'Chatanpally,Wanaparthy,Andhra Pradesh',
'Chilkamarri,Wanaparthy,Andhra Pradesh',
'Chowlapally,Wanaparthy,Andhra Pradesh',
'Doskal,Wanaparthy,Andhra Pradesh',
'Farooqnagar,Wanaparthy,Andhra Pradesh',
'Kammadanam,Wanaparthy,Andhra Pradesh',
'Madhurapuram,Wanaparthy,Andhra Pradesh',
'Mogalgidda,Wanaparthy,Andhra Pradesh',
'Nagulapally,Wanaparthy,Andhra Pradesh',
'Pidikiryal,Wanaparthy,Andhra Pradesh',
'Rayakal,Wanaparthy,Andhra Pradesh',
'Sardarnagar,Wanaparthy,Andhra Pradesh',
'Velgerla,Wanaparthy,Andhra Pradesh',
'Yelikatta,Wanaparthy,Andhra Pradesh',
'Chinchod,Wanaparthy,Andhra Pradesh',
'Gadwal H.O,Mahabubnagar,Andhra Pradesh',
'Buddaram,Wanaparthy,Andhra Pradesh',
'Chennaram,Wanaparthy,Andhra Pradesh',
'Gopalpet,Wanaparthy,Andhra Pradesh',
'J.Thirumalapuram,Wanaparthy,Andhra Pradesh',
'Keshampet,Wanaparthy,Andhra Pradesh',
'Munnanoor,Wanaparthy,Andhra Pradesh',
'Nagapoor,Wanaparthy,Andhra Pradesh',
'Polkepahad,Wanaparthy,Andhra Pradesh',
'Ravipakula,Wanaparthy,Andhra Pradesh',
'Revally,Wanaparthy,Andhra Pradesh',
'Talpanoor,Wanaparthy,Andhra Pradesh',
'Tatiparthy,Wanaparthy,Andhra Pradesh',
'Yedula,Wanaparthy,Andhra Pradesh',
'Yedutla,Wanaparthy,Andhra Pradesh',
'Ediganipally,Wanaparthy,Andhra Pradesh',
'Gangapur,Wanaparthy,Andhra Pradesh',
'Gollapally,Wanaparthy,Andhra Pradesh',
'Karivena,Wanaparthy,Andhra Pradesh',
'Kodgal,Wanaparthy,Andhra Pradesh',
'Malleboinpally,Wanaparthy,Andhra Pradesh',
'Midjil,Wanaparthy,Andhra Pradesh',
'Nasrullabad,Wanaparthy,Andhra Pradesh',
'Pedda-adirala,Wanaparthy,Andhra Pradesh',
'Polepally,Wanaparthy,Andhra Pradesh',
'Tatiparthy,Wanaparthy,Andhra Pradesh',
'Town Jadcherla,Wanaparthy,Andhra Pradesh',
'Vallur,Wanaparthy,Andhra Pradesh',
'Mukurala,Wanaparthy,Andhra Pradesh',
'Gundur,Wanaparthy,Andhra Pradesh',
'Kalwakurthy,Wanaparthy,Andhra Pradesh',
'Kurumidda,Wanaparthy,Andhra Pradesh',
'Lingasanipally,Wanaparthy,Andhra Pradesh',
'Marchala,Wanaparthy,Andhra Pradesh',
'Panjugula,Wanaparthy,Andhra Pradesh',
'Raghupathipeta,Wanaparthy,Andhra Pradesh',
'Tarnikal,Wanaparthy,Andhra Pradesh',
'Thotapally,Wanaparthy,Andhra Pradesh',
'Vepur,Wanaparthy,Andhra Pradesh',
'Yellikal,Wanaparthy,Andhra Pradesh',
'Mucharla,Wanaparthy,Andhra Pradesh',
'Alwal,Wanaparthy,Andhra Pradesh',
'Chowlapally,Wanaparthy,Andhra Pradesh',
'Eklaskhanpet,Wanaparthy,Andhra Pradesh',
'Kakunur,Wanaparthy,Andhra Pradesh',
'Keshampet,Wanaparthy,Andhra Pradesh',
'Kothapeta,Wanaparthy,Andhra Pradesh',
'Nidadavelli,Wanaparthy,Andhra Pradesh',
'Papireddiguda,Wanaparthy,Andhra Pradesh',
'Pomalpally,Wanaparthy,Andhra Pradesh',
'Sangem,Wanaparthy,Andhra Pradesh',
'Santhapur,Wanaparthy,Andhra Pradesh',
'Thommidirekula,Wanaparthy,Andhra Pradesh',
'Vemulanarva,Wanaparthy,Andhra Pradesh',
'Janumpally,Wanaparthy,Andhra Pradesh',
'Kadirepahad,Wanaparthy,Andhra Pradesh',
'Kodair,Wanaparthy,Andhra Pradesh',
'Kondaraopally,Wanaparthy,Andhra Pradesh',
'Machupally,Wanaparthy,Andhra Pradesh',
'Muthireddypally,Wanaparthy,Andhra Pradesh',
'Nagulapally,Wanaparthy,Andhra Pradesh',
'Narsayapally,Wanaparthy,Andhra Pradesh',
'Rajapur,Wanaparthy,Andhra Pradesh',
'Singayapally,Wanaparthy,Andhra Pradesh',
'Yettam,Wanaparthy,Andhra Pradesh',
'Chintalapally,Wanaparthy,Andhra Pradesh',
'Kollapur,Wanaparthy,Andhra Pradesh',
'Kudikilla,Wanaparthy,Andhra Pradesh',
'Malleswaram,Wanaparthy,Andhra Pradesh',
'Molachinthalapally,Wanaparthy,Andhra Pradesh',
'Pentlavally,Wanaparthy,Andhra Pradesh',
'Singotam,Wanaparthy,Andhra Pradesh',
'Yellur,Wanaparthy,Andhra Pradesh',
'Yenmanbetla,Wanaparthy,Andhra Pradesh',
'Agrial,Wanaparthy,Andhra Pradesh',
'Chowdergudem,Wanaparthy,Andhra Pradesh',
'Kondurgu,Wanaparthy,Andhra Pradesh',
'Mutpur,Wanaparthy,Andhra Pradesh',
'Srirangapur,Wanaparthy,Andhra Pradesh',
'Tangellapally,Wanaparthy,Andhra Pradesh',
'Thummalapally,Wanaparthy,Andhra Pradesh',
'Uttaraspally,Wanaparthy,Andhra Pradesh',
'Yedra,Wanaparthy,Andhra Pradesh',
'Yelkicherla,Wanaparthy,Andhra Pradesh',
'Ajjakole,Wanaparthy,Andhra Pradesh',
'Amadabakula,Wanaparthy,Andhra Pradesh',
'Apparala,Wanaparthy,Andhra Pradesh',
'Dantanur,Wanaparthy,Andhra Pradesh',
'Kanimetta,Wanaparthy,Andhra Pradesh',
'Konnur,Wanaparthy,Andhra Pradesh',
'Kothakota,Wanaparthy,Andhra Pradesh',
'Madanapuram,Wanaparthy,Andhra Pradesh',
'Miraspally,Wanaparthy,Andhra Pradesh',
'Nyetvally,Wanaparthy,Andhra Pradesh',
'Palem,Wanaparthy,Andhra Pradesh',
'Rayanpet,Wanaparthy,Andhra Pradesh',
'Sankireddypally,Wanaparthy,Andhra Pradesh',
'Chegur,Wanaparthy,Andhra Pradesh',
'Fathimapur,Wanaparthy,Andhra Pradesh',
'Inmulnarva,Wanaparthy,Andhra Pradesh',
'Kothur,Wanaparthy,Andhra Pradesh',
'Mamidipally,Wanaparthy,Andhra Pradesh',
'Nandigaon,Wanaparthy,Andhra Pradesh',
'Penjerla,Wanaparthy,Andhra Pradesh',
'Reddipalem,Wanaparthy,Andhra Pradesh',
'Siddapur,Wanaparthy,Andhra Pradesh',
'Thimmapur,Wanaparthy,Andhra Pradesh',
'Veerlapally,Wanaparthy,Andhra Pradesh',
'Dhararam,Wanaparthy,Andhra Pradesh',
'Komatikunta,Wanaparthy,Andhra Pradesh',
'Vallabhapur,Wanaparthy,Andhra Pradesh',
'Ambatpally,Wanaparthy,Andhra Pradesh',
'Appayapally,Wanaparthy,Andhra Pradesh',
'Ausalikunta,Wanaparthy,Andhra Pradesh',
'Chennampally,Wanaparthy,Andhra Pradesh',
'Lingala,Wanaparthy,Andhra Pradesh',
'Surapuram,Wanaparthy,Andhra Pradesh',
'Andugula,Wanaparthy,Andhra Pradesh',
'Appareddipally,Wanaparthy,Andhra Pradesh',
'Arkepally,Wanaparthy,Andhra Pradesh',
'Aurpally,Wanaparthy,Andhra Pradesh',
'Bramhanpally,Wanaparthy,Andhra Pradesh',
'Girikothapally,Wanaparthy,Andhra Pradesh',
'Irwin,Wanaparthy,Andhra Pradesh',
'Kalakonda,Wanaparthy,Andhra Pradesh',
'Kulkulpally,Wanaparthy,Andhra Pradesh',
'Madgul,Wanaparthy,Andhra Pradesh',
'Nagilla,Wanaparthy,Andhra Pradesh',
'Mahabubnagar H.O,Mahabubnagar,Andhra Pradesh',
'Ameerpet,Wanaparthy,Andhra Pradesh',
'Dubbacherla,Wanaparthy,Andhra Pradesh',
'Kalwakole,Wanaparthy,Andhra Pradesh',
'Ippapahad,Wanaparthy,Andhra Pradesh',
'Jakinalapally,Wanaparthy,Andhra Pradesh',
'Madharam,Wanaparthy,Andhra Pradesh',
'Rachala Pally,Wanaparthy,Andhra Pradesh',
'Ramreddipally,Wanaparthy,Andhra Pradesh',
'Urkonda,Wanaparthy,Andhra Pradesh',
'Urkondapeta,Wanaparthy,Andhra Pradesh',
'Chandubatla,Wanaparthy,Andhra Pradesh',
'Gaggalapally,Wanaparthy,Andhra Pradesh',
'Ganyagula,Wanaparthy,Andhra Pradesh',
'Gudipally,Wanaparthy,Andhra Pradesh',
'Malkapur,Wanaparthy,Andhra Pradesh',
'Manthati,Wanaparthy,Andhra Pradesh',
'Naganool,Wanaparthy,Andhra Pradesh',
'Nagarkurnool,Wanaparthy,Andhra Pradesh',
'Nallavelly,Wanaparthy,Andhra Pradesh',
'Peddapur,Wanaparthy,Andhra Pradesh',
'Puljala,Wanaparthy,Andhra Pradesh',
'Sripur,Wanaparthy,Andhra Pradesh',
'Thoodukurthy,Wanaparthy,Andhra Pradesh',
'Uyyalawada,Wanaparthy,Andhra Pradesh',
'Wanapatla,Wanaparthy,Andhra Pradesh',
'Yendabetla,Wanaparthy,Andhra Pradesh',
'Pothireddipally,Wanaparthy,Andhra Pradesh',
'Bollavaram,Wanaparthy,Andhra Pradesh',
'Busireddypally,Wanaparthy,Andhra Pradesh',
'Chintakunta,Wanaparthy,Andhra Pradesh',
'Dawajipally,Wanaparthy,Andhra Pradesh',
'Gopulapuram,Wanaparthy,Andhra Pradesh',
'Kalwarala,Wanaparthy,Andhra Pradesh',
'Kethepally,Wanaparthy,Andhra Pradesh',
'Mahmadapur,Wanaparthy,Andhra Pradesh',
'Pangal,Wanaparthy,Andhra Pradesh',
'Remadla,Wanaparthy,Andhra Pradesh',
'Shagapuram,Wanaparthy,Andhra Pradesh',
'Ayyavaripally,Wanaparthy,Andhra Pradesh',
'Gummadam,Wanaparthy,Andhra Pradesh',
'Kanchiraopally,Wanaparthy,Andhra Pradesh',
'Pebbair,Wanaparthy,Andhra Pradesh',
'Rangapur,Wanaparthy,Andhra Pradesh',
'Shakapur,Wanaparthy,Andhra Pradesh',
'Srirangapur,Wanaparthy,Andhra Pradesh',
'Sugur,Wanaparthy,Andhra Pradesh',
'Venkatapur,Wanaparthy,Andhra Pradesh',
'Yaparla,Wanaparthy,Andhra Pradesh',
'Pamireddipally,Wanaparthy,Andhra Pradesh',
'Chandrakal,Wanaparthy,Andhra Pradesh',
'D.Thirumalapur,Wanaparthy,Andhra Pradesh',
'Gantaraopally,Wanaparthy,Andhra Pradesh',
'Jonnalabogada,Wanaparthy,Andhra Pradesh',
'Kalwakole,Wanaparthy,Andhra Pradesh',
'Marikal,Wanaparthy,Andhra Pradesh',
'Muddunurkalan,Wanaparthy,Andhra Pradesh',
'Mustipally,Wanaparthy,Andhra Pradesh',
'Pasupula,Wanaparthy,Andhra Pradesh',
'Peddakarpamula,Wanaparthy,Andhra Pradesh',
'Peddakothapally,Wanaparthy,Andhra Pradesh',
'Satapur,Wanaparthy,Andhra Pradesh',
'Vennacherla,Wanaparthy,Andhra Pradesh',
'Yapatla,Wanaparthy,Andhra Pradesh',
'Kanmanur,Wanaparthy,Andhra Pradesh',
'Peddamandadi,Wanaparthy,Andhra Pradesh',
'Shadnagar,Wanaparthy,Andhra Pradesh',
'Hythabad,Wanaparthy,Andhra Pradesh',
'Manmarri,Wanaparthy,Andhra Pradesh',
'Shahabad,Wanaparthy,Andhra Pradesh',
'Tallapally,Wanaparthy,Andhra Pradesh',
'Palmakole,Wanaparthy,Andhra Pradesh',
'Shapur,Wanaparthy,Andhra Pradesh',
'Tondapally,Wanaparthy,Andhra Pradesh',
'Stn. Jadcherla H.O,Wanaparthy,Andhra Pradesh',
'Aithole,Wanaparthy,Andhra Pradesh',
'Balanpally,Wanaparthy,Andhra Pradesh',
'Indrakal,Wanaparthy,Andhra Pradesh',
'Kummera,Wanaparthy,Andhra Pradesh',
'Medipur,Wanaparthy,Andhra Pradesh',
'Papagal,Wanaparthy,Andhra Pradesh',
'Sirsawada,Wanaparthy,Andhra Pradesh',
'Tadoor,Wanaparthy,Andhra Pradesh',
'Yadireddypally,Wanaparthy,Andhra Pradesh',
'Cheepununthala,Wanaparthy,Andhra Pradesh',
'Chukkapur,Wanaparthy,Andhra Pradesh',
'Gattuippalapally,Wanaparthy,Andhra Pradesh',
'Khanapur,Wanaparthy,Andhra Pradesh',
'Padakal,Wanaparthy,Andhra Pradesh',
'Ravichedu,Wanaparthy,Andhra Pradesh',
'Talakondapally,Wanaparthy,Andhra Pradesh',
'Guntakodur,Wanaparthy,Andhra Pradesh',
'Aleru,Wanaparthy,Andhra Pradesh',
'Gaddampally,Wanaparthy,Andhra Pradesh',
'Gattunellikuduru,Wanaparthy,Andhra Pradesh',
'Gouraram,Wanaparthy,Andhra Pradesh',
'Goureddipally,Wanaparthy,Andhra Pradesh',
'Karvanga,Wanaparthy,Andhra Pradesh',
'Laknaram,Wanaparthy,Andhra Pradesh',
'Peddapally,Wanaparthy,Andhra Pradesh',
'Peddur,Wanaparthy,Andhra Pradesh',
'Rakonda,Wanaparthy,Andhra Pradesh',
'Tallapally,Wanaparthy,Andhra Pradesh',
'Thelkapally,Wanaparthy,Andhra Pradesh',
'Vattipally,Wanaparthy,Andhra Pradesh',
'Appajipally,Wanaparthy,Andhra Pradesh',
'Avancha,Wanaparthy,Andhra Pradesh',
'Bawajipally,Wanaparthy,Andhra Pradesh',
'Buddasamudram,Wanaparthy,Andhra Pradesh',
'Chegunta,Wanaparthy,Andhra Pradesh',
'Gorita,Wanaparthy,Andhra Pradesh',
'Gumkonda,Wanaparthy,Andhra Pradesh',
'Ippalapally,Wanaparthy,Andhra Pradesh',
'Koduparthy,Wanaparthy,Andhra Pradesh',
'Marepally,Wanaparthy,Andhra Pradesh',
'Marrikal,Wanaparthy,Andhra Pradesh',
'Nerellapally,Wanaparthy,Andhra Pradesh',
'Thimmajipet,Wanaparthy,Andhra Pradesh',
'Yedurepally,Wanaparthy,Andhra Pradesh',
'Japtisadaguda,Wanaparthy,Andhra Pradesh',
'Upparapally,Wanaparthy,Andhra Pradesh',
'Kamsanipally,Wanaparthy,Andhra Pradesh',
'Penimilla,Wanaparthy,Andhra Pradesh',
'Piratvanipally,Wanaparthy,Andhra Pradesh',
'Tadoor,Wanaparthy,Andhra Pradesh',
'Uppununthala,Wanaparthy,Andhra Pradesh',
'Veltoor,Wanaparthy,Andhra Pradesh',
'Laxmapur,Wanaparthy,Andhra Pradesh',
'Mamidlapally,Wanaparthy,Andhra Pradesh',
'Charakonda,Wanaparthy,Andhra Pradesh',
'D.Chintalapally,Wanaparthy,Andhra Pradesh',
'Gajra,Wanaparthy,Andhra Pradesh',
'Jajala,Wanaparthy,Andhra Pradesh',
'Kondareddipally,Wanaparthy,Andhra Pradesh',
'Konetipur,Wanaparthy,Andhra Pradesh',
'Mittasadguda,Wanaparthy,Andhra Pradesh',
'Polkampally,Wanaparthy,Andhra Pradesh',
'Rangapur,Wanaparthy,Andhra Pradesh',
'Sarvareddypally,Wanaparthy,Andhra Pradesh',
'Sirasanagandla,Wanaparthy,Andhra Pradesh',
'Thippareddypally,Wanaparthy,Andhra Pradesh',
'Ulpera,Wanaparthy,Andhra Pradesh',
'Umapur,Wanaparthy,Andhra Pradesh',
'Uppalpahad,Wanaparthy,Andhra Pradesh',
'Vangoor,Wanaparthy,Andhra Pradesh',
'Ammayapally,Wanaparthy,Andhra Pradesh',
'Ayyavaripally,Wanaparthy,Andhra Pradesh',
'Bekkem,Wanaparthy,Andhra Pradesh',
'Chinnamarur,Wanaparthy,Andhra Pradesh',
'Dagada,Wanaparthy,Andhra Pradesh',
'Gopalapuram,Wanaparthy,Andhra Pradesh',
'Jetaprole,Wanaparthy,Andhra Pradesh',
'Kondur,Wanaparthy,Andhra Pradesh',
'Koppunur,Wanaparthy,Andhra Pradesh',
'Laxmipally,Wanaparthy,Andhra Pradesh',
'Peddamarur,Wanaparthy,Andhra Pradesh',
'Sanginenipally,Wanaparthy,Andhra Pradesh',
'Tumkunta,Wanaparthy,Andhra Pradesh',
'Veepangandla,Wanaparthy,Andhra Pradesh',
'Velgonda,Wanaparthy,Andhra Pradesh',
'Vellatur,Wanaparthy,Andhra Pradesh',
'Venkatampally,Wanaparthy,Andhra Pradesh',
'Ajilapuram,Wanaparthy,Andhra Pradesh',
'Barkatpally,Wanaparthy,Andhra Pradesh',
'Bhairampuram,Wanaparthy,Andhra Pradesh',
'Bollampally,Wanaparthy,Andhra Pradesh',
'Chedurpally,Wanaparthy,Andhra Pradesh',
'Cherkur,Wanaparthy,Andhra Pradesh',
'Gokaram,Wanaparthy,Andhra Pradesh',
'Jupally,Wanaparthy,Andhra Pradesh',
'Kotra,Wanaparthy,Andhra Pradesh',
'Kuppugandla,Wanaparthy,Andhra Pradesh',
'Peddapur,Wanaparthy,Andhra Pradesh',
'Pothepally,Wanaparthy,Andhra Pradesh',
'Rachur,Wanaparthy,Andhra Pradesh',
'Tandra,Wanaparthy,Andhra Pradesh',
'Veldanda,Wanaparthy,Andhra Pradesh',
'Chandapur,Wanaparthy,Andhra Pradesh',
'Chimanguntapally,Wanaparthy,Andhra Pradesh',
'Chityal,Wanaparthy,Andhra Pradesh',
'Gandhichowk,Wanaparthy,Andhra Pradesh',
'Kadukuntla,Wanaparthy,Andhra Pradesh',
'Manigilla,Wanaparthy,Andhra Pradesh',
'Peddagudem,Wanaparthy,Andhra Pradesh',
'Rajapet,Wanaparthy,Andhra Pradesh',
'Sawaigudem,Wanaparthy,Andhra Pradesh',
'Wanaparthy H.O,Wanaparthy,Andhra Pradesh',
'Ahmedpur,Medak,Andhra Pradesh',
'Akkannapet,Medak,Andhra Pradesh',
'Akkaram,Medak,Andhra Pradesh',
'Akkenapally,Medak,Andhra Pradesh',
'Alirajpet,Medak,Andhra Pradesh',
'Allipur,Medak,Andhra Pradesh',
'Alwal,Medak,Andhra Pradesh',
'Amsanipally,Medak,Andhra Pradesh',
'Ananthasagar,Medak,Andhra Pradesh',
'Ananthsagar,Medak,Andhra Pradesh',
'Ankireddipally,Medak,Andhra Pradesh',
'Ankshapur,Medak,Andhra Pradesh',
'Appanapally,Medak,Andhra Pradesh',
'Arkela,Medak,Andhra Pradesh',
'Ausulapally,Medak,Andhra Pradesh',
'Bacharam,Medak,Andhra Pradesh',
'Baddipadaga,Medak,Andhra Pradesh',
'Bakrichepial,Medak,Andhra Pradesh',
'Bandaram,Medak,Andhra Pradesh',
'Bangla Venkatapur,Medak,Andhra Pradesh',
'Begumpet,Medak,Andhra Pradesh',
'Bhailampur,Medak,Andhra Pradesh',
'Bhumpally,Medak,Andhra Pradesh',
'Bhupathipur,Medak,Andhra Pradesh',
'Bodagattu,Medak,Andhra Pradesh',
'Boguda Bhupathipur,Medak,Andhra Pradesh',
'Bonala,Medak,Andhra Pradesh',
'Brahamanpally,Medak,Andhra Pradesh',
'Bujrampet,Medak,Andhra Pradesh',
'Burugupally,Medak,Andhra Pradesh',
'Ch.Ankireddipally,Medak,Andhra Pradesh',
'Chandaipet,Medak,Andhra Pradesh',
'Chandampet,Medak,Andhra Pradesh',
'Chandi,Medak,Andhra Pradesh',
'Chandlapur,Medak,Andhra Pradesh',
'Chatlapally,Medak,Andhra Pradesh',
'Chebarthy,Medak,Andhra Pradesh',
'Cheelasagr,Medak,Andhra Pradesh',
'Chegunta,Medak,Andhra Pradesh',
'Chellapur,Medak,Andhra Pradesh',
'Chelmeda,Medak,Andhra Pradesh',
'Chepial,Medak,Andhra Pradesh',
'Chinna Gundavelli,Medak,Andhra Pradesh',
'Chinna Kistapur,Medak,Andhra Pradesh',
'Chinna Shivnoor,Medak,Andhra Pradesh',
'Chinthamadaka,Medak,Andhra Pradesh',
'Chittapur,Medak,Andhra Pradesh',
'Choudaram,Medak,Andhra Pradesh',
'Dacharam,Medak,Andhra Pradesh',
'Daripally,Medak,Andhra Pradesh',
'Daulapur,Medak,Andhra Pradesh',
'Dhamarakunta,Medak,Andhra Pradesh',
'Dhanoora,Medak,Andhra Pradesh',
'Dharmajipet,Medak,Andhra Pradesh',
'Dharmaram,Medak,Andhra Pradesh',
'Dommat,Medak,Andhra Pradesh',
'Dongala Dharmaram,Medak,Andhra Pradesh',
'Donthi,Medak,Andhra Pradesh',
'Doulathabad,Medak,Andhra Pradesh',
'Duddeda,Medak,Andhra Pradesh',
'Elakurthy,Medak,Andhra Pradesh',
'Erraballi,Medak,Andhra Pradesh',
'Errabally,Medak,Andhra Pradesh',
'Etigadda Kistapur,Medak,Andhra Pradesh',
'Fareedpur,Medak,Andhra Pradesh',
'Gangapur,Medak,Andhra Pradesh',
'Gatlamalyal,Medak,Andhra Pradesh',
'Gavvalapally,Medak,Andhra Pradesh',
'Ghanpur,Medak,Andhra Pradesh',
'Ghanpur,Medak,Andhra Pradesh',
'Gollapally,Medak,Andhra Pradesh',
'Gonepally,Medak,Andhra Pradesh',
'Gouraram,Medak,Andhra Pradesh',
'Gudikandula,Medak,Andhra Pradesh',
'Gunreddipally,Medak,Andhra Pradesh',
'Gurralagondi,Medak,Andhra Pradesh',
'Habsipur,Medak,Andhra Pradesh',
'Ibrahimnagar,Medak,Andhra Pradesh',
'Ibrahimpur,Medak,Andhra Pradesh',
'Ibrahimpur,Medak,Andhra Pradesh',
'Indupial,Medak,Andhra Pradesh',
'Insanpally,Medak,Andhra Pradesh',
'Irkode,Medak,Andhra Pradesh',
'Islampur,Medak,Andhra Pradesh',
'Itikyala,Medak,Andhra Pradesh',
'Jakkapur,Medak,Andhra Pradesh',
'Jaligaon,Medak,Andhra Pradesh',
'Jangapally,Medak,Andhra Pradesh',
'Kadlakal,Medak,Andhra Pradesh',
'Kadloor,Medak,Andhra Pradesh',
'Kalwakunta,Medak,Andhra Pradesh',
'Kanugal,Medak,Andhra Pradesh',
'Kaslabad,Medak,Andhra Pradesh',
'Katrial,Medak,Andhra Pradesh',
'Khajapur,Medak,Andhra Pradesh',
'Khajipur,Medak,Andhra Pradesh',
'Khata,Medak,Andhra Pradesh',
'Kodakandla,Medak,Andhra Pradesh',
'Kodurkurd,Medak,Andhra Pradesh',
'Kokonda,Medak,Andhra Pradesh',
'Kolgur,Medak,Andhra Pradesh',
'Konapur,Medak,Andhra Pradesh',
'Kondapak,Medak,Andhra Pradesh',
'Kondapaka,Medak,Andhra Pradesh',
'Kondapur,Medak,Andhra Pradesh',
'Kongal Ghanpur,Medak,Andhra Pradesh',
'Kothapally,Medak,Andhra Pradesh',
'Kuchavaram,Medak,Andhra Pradesh',
'Kuknoor,Medak,Andhra Pradesh',
'Kuknoorpally,Medak,Andhra Pradesh',
'Kulcharam,Medak,Andhra Pradesh',
'Kunthanpally,Medak,Andhra Pradesh',
'Kurthiwada,Medak,Andhra Pradesh',
'Lachapet,Medak,Andhra Pradesh',
'Laxmapur,Medak,Andhra Pradesh',
'Laxminagar,Medak,Andhra Pradesh',
'Lingaipally,Medak,Andhra Pradesh',
'Lingareddipally,Medak,Andhra Pradesh',
'M. Jalalpur.,Medak,Andhra Pradesh',
'Machapur,Medak,Andhra Pradesh',
'Maddulwai,Medak,Andhra Pradesh',
'Madur,Medak,Andhra Pradesh',
'Majeedpally,Medak,Andhra Pradesh',
'Makkarajpet,Medak,Andhra Pradesh',
'Mallampet,Medak,Andhra Pradesh',
'Malyal,Medak,Andhra Pradesh',
'Mamidial,Medak,Andhra Pradesh',
'Mandapally,Medak,Andhra Pradesh',
'Manepally,Medak,Andhra Pradesh',
'Mangalparthy,Medak,Andhra Pradesh',
'Mangole,Medak,Andhra Pradesh',
'Manoharabad,Medak,Andhra Pradesh',
'Markook,Medak,Andhra Pradesh',
'Marpadaga,Medak,Andhra Pradesh',
'Masaipet,Medak,Andhra Pradesh',
'Medipally,Medak,Andhra Pradesh',
'Meenajipet,Medak,Andhra Pradesh',
'Mirdiddi,Medak,Andhra Pradesh',
'Mirzapally,Medak,Andhra Pradesh',
'Mittapally,Medak,Andhra Pradesh',
'Mothe,Medak,Andhra Pradesh',
'Mulugu,Medak,Andhra Pradesh',
'Munigadapa,Medak,Andhra Pradesh',
'Mupparam,Medak,Andhra Pradesh',
'Mutrajpally,Medak,Andhra Pradesh',
'Mylaram,Medak,Andhra Pradesh',
'Mylaram,Medak,Andhra Pradesh',
'Nacharam,Medak,Andhra Pradesh',
'Nagapuram,Medak,Andhra Pradesh',
'Nagasanipally,Medak,Andhra Pradesh',
'Nagulapally,Medak,Andhra Pradesh',
'Nangnoor,Medak,Andhra Pradesh',
'Narayanaraopet,Medak,Andhra Pradesh',
'Narlapur,Medak,Andhra Pradesh',
'Narmetta,Medak,Andhra Pradesh',
'Narsampally,Medak,Andhra Pradesh',
'Narsingee,Medak,Andhra Pradesh',
'Naskal,Medak,Andhra Pradesh',
'Nemtur,Medak,Andhra Pradesh',
'Nizampet,Medak,Andhra Pradesh',
'Paitara,Medak,Andhra Pradesh',
'Palamakula,Medak,Andhra Pradesh',
'Pallepahad,Medak,Andhra Pradesh',
'Palvancha,Medak,Andhra Pradesh',
'Pambanda,Medak,Andhra Pradesh',
'Pamulaparthy,Medak,Andhra Pradesh',
'Papannapet,Medak,Andhra Pradesh',
'Parikibanda,Medak,Andhra Pradesh',
'Pathoor,Medak,Andhra Pradesh',
'Pedda Koduru,Medak,Andhra Pradesh',
'Pedda Masanipally,Medak,Andhra Pradesh',
'Peerlapally,Medak,Andhra Pradesh',
'Perur,Medak,Andhra Pradesh',
'Pidched,Medak,Andhra Pradesh',
'Podichanpally,Medak,Andhra Pradesh',
'Ponnal,Medak,Andhra Pradesh',
'Pothamshettipally,Medak,Andhra Pradesh',
'Pothireddipet,Medak,Andhra Pradesh',
'Pregnapur,Medak,Andhra Pradesh',
'Pullur,Medak,Andhra Pradesh',
'Raghavapur,Medak,Andhra Pradesh',
'Raiploe,Medak,Andhra Pradesh',
'Rajakkapat,Medak,Andhra Pradesh',
'Rajgopalpet,Medak,Andhra Pradesh',
'Rajpet,Medak,Andhra Pradesh',
'Ramakkapet,Medak,Andhra Pradesh',
'Ramancha,Medak,Andhra Pradesh',
'Ramaram,Medak,Andhra Pradesh',
'Ramasagar,Medak,Andhra Pradesh',
'Ramayampet,Medak,Andhra Pradesh',
'Rampur,Medak,Andhra Pradesh',
'Rampur,Medak,Andhra Pradesh',
'Ramunipatla,Medak,Andhra Pradesh',
'Rangampet,Medak,Andhra Pradesh',
'Raorukala,Medak,Andhra Pradesh',
'Ravelli,Medak,Andhra Pradesh',
'Rayalapur,Medak,Andhra Pradesh',
'Reddipally,Medak,Andhra Pradesh',
'Remanguda,Medak,Andhra Pradesh',
'Rudraram,Medak,Andhra Pradesh',
'Ryalamagudu,Medak,Andhra Pradesh',
'S. Kondapur,Medak,Andhra Pradesh',
'Sangaipally,Medak,Andhra Pradesh',
'Sardana,Medak,Andhra Pradesh',
'Settipally Kalan,Medak,Andhra Pradesh',
'Shankarampet,Medak,Andhra Pradesh',
'Shivampet,Medak,Andhra Pradesh',
'Sikindlapur,Medak,Andhra Pradesh',
'Singavatum,Medak,Andhra Pradesh',
'Sirigiripally,Medak,Andhra Pradesh',
'Sirisinagandla,Medak,Andhra Pradesh',
'Surampally,Medak,Andhra Pradesh',
'Suraram,Medak,Andhra Pradesh',
'Tadakapally,Medak,Andhra Pradesh',
'Tampulur,Medak,Andhra Pradesh',
'Teegul,Medak,Andhra Pradesh',
'Teegul Narsapur,Medak,Andhra Pradesh',
'Tekmal,Medak,Andhra Pradesh',
'Thonigandla,Medak,Andhra Pradesh',
'Timmaipally,Medak,Andhra Pradesh',
'Timmapur,Medak,Andhra Pradesh',
'Timmapur,Medak,Andhra Pradesh',
'Timmareddipally,Medak,Andhra Pradesh',
'Tipparam,Medak,Andhra Pradesh',
'Tirumalapur,Medak,Andhra Pradesh',
'Toguta,Medak,Andhra Pradesh',
'Toguta,Medak,Andhra Pradesh',
'Toopran,Medak,Andhra Pradesh',
'Tornal,Medak,Andhra Pradesh',
'Tuniki,Medak,Andhra Pradesh',
'Tuniki Bollaram,Medak,Andhra Pradesh',
'Uppu Lingapur,Medak,Andhra Pradesh',
'Varadarajapuram,Medak,Andhra Pradesh',
'Velikatta,Medak,Andhra Pradesh',
'Velkatur,Medak,Andhra Pradesh',
'Veloor,Medak,Andhra Pradesh',
'Vemulagattu,Medak,Andhra Pradesh',
'Venkatapur,Medak,Andhra Pradesh',
'Venkatapur,Medak,Andhra Pradesh',
'Venkatapur,Medak,Andhra Pradesh',
'Venkataraopet,Medak,Andhra Pradesh',
'Vittalapur,Medak,Andhra Pradesh',
'Waddepally,Medak,Andhra Pradesh',
'Wadiaram,Medak,Andhra Pradesh',
'Wargal,Medak,Andhra Pradesh',
'Wariguntham,Medak,Andhra Pradesh',
'Watipally,Medak,Andhra Pradesh',
'Yelapgonda,Medak,Andhra Pradesh',
'Yeldurthy,Medak,Andhra Pradesh',
'Yellapur,Medak,Andhra Pradesh',
'Yellareddipally,Medak,Andhra Pradesh',
'Yenagandla,Medak,Andhra Pradesh',
'Yenagurthy,Medak,Andhra Pradesh',
'Yousufpet,Medak,Andhra Pradesh',
'Zapthi Shivnoor,Medak,Andhra Pradesh',
'Zapti Lingareddipally,Medak,Andhra Pradesh',
'Zapti Nacharam,Medak,Andhra Pradesh',
'Alladurg,Sangareddy,Andhra Pradesh',
'Andole,Sangareddy,Andhra Pradesh',
'Akaram,Medak,Andhra Pradesh',
'Ande,Medak,Andhra Pradesh',
'Chikode,Medak,Andhra Pradesh',
'Dubbak,Medak,Andhra Pradesh',
'Dumpalapally,Medak,Andhra Pradesh',
'Gambheerpur,Medak,Andhra Pradesh',
'Gundavelly,Medak,Andhra Pradesh',
'Anajipur,Medak,Andhra Pradesh',
'Bayyaram,Medak,Andhra Pradesh',
'Bejgaon,Medak,Andhra Pradesh',
'Dharmareddipally,Medak,Andhra Pradesh',
'Dilalpur,Medak,Andhra Pradesh',
'Gujvail,Medak,Andhra Pradesh',
'Jagadevpur,Medak,Andhra Pradesh',
'Aksanpally,Sangareddy,Andhra Pradesh',
'Almaipet,Sangareddy,Andhra Pradesh',
'Bodamatpally,Sangareddy,Andhra Pradesh',
'Cheelapalli,Sangareddy,Andhra Pradesh',
'Chevella,Sangareddy,Andhra Pradesh',
'Chilver,Sangareddy,Andhra Pradesh',
'Chintakunta,Sangareddy,Andhra Pradesh',
'Chitkul,Sangareddy,Andhra Pradesh',
'Choutkur,Sangareddy,Andhra Pradesh',
'Dakoor,Sangareddy,Andhra Pradesh',
'Devnoor,Sangareddy,Andhra Pradesh',
'Gorrekal,Sangareddy,Andhra Pradesh',
'Jogipet,Sangareddy,Andhra Pradesh',
'Jukal,Sangareddy,Andhra Pradesh',
'Khadeerabad,Sangareddy,Andhra Pradesh',
'Korpole,Sangareddy,Andhra Pradesh',
'Kusangi,Sangareddy,Andhra Pradesh',
'Makta Laxmapur,Sangareddy,Andhra Pradesh',
'Marvelli,Sangareddy,Andhra Pradesh',
'Moosapet,Sangareddy,Andhra Pradesh',
'Mudimanik,Sangareddy,Andhra Pradesh',
'Muslapur,Sangareddy,Andhra Pradesh',
'Neredigunta,Sangareddy,Andhra Pradesh',
'Nidijipla,Sangareddy,Andhra Pradesh',
'Peddapur,Sangareddy,Andhra Pradesh',
'Posanipet,Sangareddy,Andhra Pradesh',
'Pothulaboguda,Sangareddy,Andhra Pradesh',
'Raipally,Sangareddy,Andhra Pradesh',
'Ramsanpalli,Sangareddy,Andhra Pradesh',
'Shankarampet Bazar,Sangareddy,Andhra Pradesh',
'Shankarampet,Sangareddy,Andhra Pradesh',
'Shivampet,Sangareddy,Andhra Pradesh',
'Sureddy Itikyal,Sangareddy,Andhra Pradesh',
'Tenkati,Sangareddy,Andhra Pradesh',
'Uthloor,Sangareddy,Andhra Pradesh',
'Vendikole,Sangareddy,Andhra Pradesh',
'Banda Posanipally,Medak,Andhra Pradesh',
'Haveli Ghanpur,Medak,Andhra Pradesh',
'Kuchanpally,Medak,Andhra Pradesh',
'Machavaram,Medak,Andhra Pradesh',
'Medak H.O,Medak,Andhra Pradesh',
'Rajpally,Medak,Andhra Pradesh',
'Abbenda,Sangareddy,Andhra Pradesh',
'Ananthasagar,Sangareddy,Andhra Pradesh',
'Anthargaon,Sangareddy,Andhra Pradesh',
'Audatpur,Sangareddy,Andhra Pradesh',
'Bachepally,Sangareddy,Andhra Pradesh',
'Badalgaon,Sangareddy,Andhra Pradesh',
'Bellapur,Sangareddy,Andhra Pradesh',
'Bibipet,Sangareddy,Andhra Pradesh',
'Borancha,Sangareddy,Andhra Pradesh',
'Chapta,Sangareddy,Andhra Pradesh',
'Damargidda,Sangareddy,Andhra Pradesh',
'Dawoor,Sangareddy,Andhra Pradesh',
'Gajwada,Sangareddy,Andhra Pradesh',
'Gottimukla,Sangareddy,Andhra Pradesh',
'Hanmanthraopet,Sangareddy,Andhra Pradesh',
'Kadpal,Sangareddy,Andhra Pradesh',
'Kalher,Sangareddy,Andhra Pradesh',
'Kangti,Sangareddy,Andhra Pradesh',
'Karamungi,Sangareddy,Andhra Pradesh',
'Karasgutti,Sangareddy,Andhra Pradesh',
'Krishnapur,Sangareddy,Andhra Pradesh',
'Lingampalli,Sangareddy,Andhra Pradesh',
'Lingapur,Sangareddy,Andhra Pradesh',
'Manur,Sangareddy,Andhra Pradesh',
'Mardi,Sangareddy,Andhra Pradesh',
'Masanpally,Sangareddy,Andhra Pradesh',
'Morgi,Sangareddy,Andhra Pradesh',
'Naganpally,Sangareddy,Andhra Pradesh',
'Nagdhar,Sangareddy,Andhra Pradesh',
'Nagoor,Sangareddy,Andhra Pradesh',
'Narayankhed,Sangareddy,Andhra Pradesh',
'Nizampet,Sangareddy,Andhra Pradesh',
'Pulkurthi,Sangareddy,Andhra Pradesh',
'Rasool,Sangareddy,Andhra Pradesh',
'Regode,Sangareddy,Andhra Pradesh',
'Rudrar,Sangareddy,Andhra Pradesh',
'Ryakal,Sangareddy,Andhra Pradesh',
'Sanjeevaraopet,Sangareddy,Andhra Pradesh',
'Shelgera,Sangareddy,Andhra Pradesh',
'Sirgapur,Sangareddy,Andhra Pradesh',
'Sultanabad,Sangareddy,Andhra Pradesh',
'Tadkal,Sangareddy,Andhra Pradesh',
'Tornal,Sangareddy,Andhra Pradesh',
'Vallur,Sangareddy,Andhra Pradesh',
'Wasar,Sangareddy,Andhra Pradesh',
'Yelgoi,Sangareddy,Andhra Pradesh',
'Yenkemuri,Sangareddy,Andhra Pradesh',
'Ajjamarry,Sangareddy,Andhra Pradesh',
'Annaram,Sangareddy,Andhra Pradesh',
'Bonthapalli,Sangareddy,Andhra Pradesh',
'Chandur,Sangareddy,Andhra Pradesh',
'Cheelpechedu,Sangareddy,Andhra Pradesh',
'Chinnagottimukla,Sangareddy,Andhra Pradesh',
'Faizabad,Sangareddy,Andhra Pradesh',
'Gomaram,Sangareddy,Andhra Pradesh',
'Gummadidala,Sangareddy,Andhra Pradesh',
'Kagazmaddur,Sangareddy,Andhra Pradesh',
'Kanchanpally,Sangareddy,Andhra Pradesh',
'Kanukunta,Sangareddy,Andhra Pradesh',
'Khajipet,Sangareddy,Andhra Pradesh',
'Konyal,Sangareddy,Andhra Pradesh',
'Kowdipally,Sangareddy,Andhra Pradesh',
'Lingapur,Sangareddy,Andhra Pradesh',
'Lingapur,Sangareddy,Andhra Pradesh',
'Mohammed Nagar,Sangareddy,Andhra Pradesh',
'Moosapet,Sangareddy,Andhra Pradesh',
'Mutrajpally,Sangareddy,Andhra Pradesh',
'Nagulapalli,Sangareddy,Andhra Pradesh',
'Nallvalli,Sangareddy,Andhra Pradesh',
'Narsapur,Sangareddy,Andhra Pradesh',
'Panyal,Sangareddy,Andhra Pradesh',
'Peddachintakunta,Sangareddy,Andhra Pradesh',
'Peddagottimukla,Sangareddy,Andhra Pradesh',
'Pillutla,Sangareddy,Andhra Pradesh',
'Ratnapur,Sangareddy,Andhra Pradesh',
'Rayalapur,Sangareddy,Andhra Pradesh',
'Rustumpet,Sangareddy,Andhra Pradesh',
'Sirpura,Sangareddy,Andhra Pradesh',
'Sommakkapet,Sangareddy,Andhra Pradesh',
'Tunki,Sangareddy,Andhra Pradesh',
'Yelmakanna,Sangareddy,Andhra Pradesh',
'Bdl Bhanur,Sangareddy,Andhra Pradesh',
'Chetlapotharam,Sangareddy,Andhra Pradesh',
'Elmela,Sangareddy,Andhra Pradesh',
'Icrisat,Sangareddy,Andhra Pradesh',
'IDA Pashamailaram,Sangareddy,Andhra Pradesh',
'Indresham,Sangareddy,Andhra Pradesh',
'Jinnaram,Sangareddy,Andhra Pradesh',
'Kistareddypet,Sangareddy,Andhra Pradesh',
'Kollur,Sangareddy,Andhra Pradesh',
'Madharam,Sangareddy,Andhra Pradesh',
'Mangapet,Sangareddy,Andhra Pradesh',
'Muthangi,Sangareddy,Andhra Pradesh',
'Nagulapalli,Sangareddy,Andhra Pradesh',
'Nandigaon,Sangareddy,Andhra Pradesh',
'Ootla,Sangareddy,Andhra Pradesh',
'Patancheru Ie,Sangareddy,Andhra Pradesh',
'Patancheru Ph.II,Sangareddy,Andhra Pradesh',
'Patancheru,Sangareddy,Andhra Pradesh',
'Pati,Sangareddy,Andhra Pradesh',
'Pati Ghanpur,Sangareddy,Andhra Pradesh',
'Peddakanjarla,Sangareddy,Andhra Pradesh',
'Shivanagar,Sangareddy,Andhra Pradesh',
'Sultanpur,Sangareddy,Andhra Pradesh',
'Vailal,Sangareddy,Andhra Pradesh',
'A.I.E. R.C.puram,Sangareddy,Andhra Pradesh',
'Admn. Bldgs,Sangareddy,Andhra Pradesh',
'Aie Bollaram,Sangareddy,Andhra Pradesh',
'Bharatinagar,Sangareddy,Andhra Pradesh',
'Mig Colony,Sangareddy,Andhra Pradesh',
'Ameenpur,Sangareddy,Andhra Pradesh',
'Ramachandrapuram He,Sangareddy,Andhra Pradesh',
'Ramachanrapuram Village,Sangareddy,Andhra Pradesh',
'Tellapur,Sangareddy,Andhra Pradesh',
'Ananthavaram,Sangareddy,Andhra Pradesh',
'Atmakur,Sangareddy,Andhra Pradesh',
'Babulgaon,Sangareddy,Andhra Pradesh',
'Budhera,Sangareddy,Andhra Pradesh',
'Kamkole,Sangareddy,Andhra Pradesh',
'Khammampally,Sangareddy,Andhra Pradesh',
'Kolkur,Sangareddy,Andhra Pradesh',
'Komshetpally,Sangareddy,Andhra Pradesh',
'Konapur,Sangareddy,Andhra Pradesh',
'Lingampalli,Sangareddy,Andhra Pradesh',
'Lonikurd,Sangareddy,Andhra Pradesh',
'Maddikunta,Sangareddy,Andhra Pradesh',
'Makta Kyasaram,Sangareddy,Andhra Pradesh',
'Mallikarjunpally,Sangareddy,Andhra Pradesh',
'Munipalli,Sangareddy,Andhra Pradesh',
'Nandikandi,Sangareddy,Andhra Pradesh',
'Nizampur,Sangareddy,Andhra Pradesh',
'Priyadarshininagar,Sangareddy,Andhra Pradesh',
'Sadasivpet,Sangareddy,Andhra Pradesh',
'Suraram,Sangareddy,Andhra Pradesh',
'Tangadpalli,Sangareddy,Andhra Pradesh',
'Tatpalli,Sangareddy,Andhra Pradesh',
'Veltoor,Sangareddy,Andhra Pradesh',
'Venkatapur,Sangareddy,Andhra Pradesh',
'Ananthsagar,Sangareddy,Andhra Pradesh',
'Baswapur,Sangareddy,Andhra Pradesh',
'Bhanur,Sangareddy,Andhra Pradesh',
'Bodupatla,Sangareddy,Andhra Pradesh',
'Cheriyal,Sangareddy,Andhra Pradesh',
'Chidruppa,Sangareddy,Andhra Pradesh',
'Chintalcheru,Sangareddy,Andhra Pradesh',
'Chitkul,Sangareddy,Andhra Pradesh',
'Doultabad,Sangareddy,Andhra Pradesh',
'Erdanur,Sangareddy,Andhra Pradesh',
'Fasalwadi,Sangareddy,Andhra Pradesh',
'Gollapalli,Sangareddy,Andhra Pradesh',
'Gonglur,Sangareddy,Andhra Pradesh',
'Gundlamachnoor,Sangareddy,Andhra Pradesh',
'Hathnura,Sangareddy,Andhra Pradesh',
'Indrakaran,Sangareddy,Andhra Pradesh',
'Ismailkhanpet,Sangareddy,Andhra Pradesh',
'Isnapur,Sangareddy,Andhra Pradesh',
'Kalivemula,Sangareddy,Andhra Pradesh',
'Kandi,Sangareddy,Andhra Pradesh',
'Kasala,Sangareddy,Andhra Pradesh',
'Konapur,Sangareddy,Andhra Pradesh',
'Kondapur,Sangareddy,Andhra Pradesh',
'Kowlampet,Sangareddy,Andhra Pradesh',
'Lakdaram,Sangareddy,Andhra Pradesh',
'Malkapur,Sangareddy,Andhra Pradesh',
'Mallepalli,Sangareddy,Andhra Pradesh',
'Manjira Barrage,Sangareddy,Andhra Pradesh',
'Manthoor,Sangareddy,Andhra Pradesh',
'Marepalli,Sangareddy,Andhra Pradesh',
'Minpur,Sangareddy,Andhra Pradesh',
'O.F.Yeddumailaram,Sangareddy,Andhra Pradesh',
'P.R.Pally Chowrasta,Sangareddy,Andhra Pradesh',
'Pashamailaram,Sangareddy,Andhra Pradesh',
'Peddapur,Sangareddy,Andhra Pradesh',
'Peddareddypet,Sangareddy,Andhra Pradesh',
'Pocharam,Sangareddy,Andhra Pradesh',
'Pulkal,Sangareddy,Andhra Pradesh',
'Rajampet Colony,Sangareddy,Andhra Pradesh',
'Rudraram,Sangareddy,Andhra Pradesh',
'Sangareddy B/s Complex,Sangareddy,Andhra Pradesh',
'Sangareddy Collectorate,Sangareddy,Andhra Pradesh',
'Sangareddy H.O,Sangareddy,Andhra Pradesh',
'Sikindaspur,Sangareddy,Andhra Pradesh',
'Singoor Project,Sangareddy,Andhra Pradesh',
'Tadlapally,Sangareddy,Andhra Pradesh',
'Taherkhanpet,Sangareddy,Andhra Pradesh',
'Terpole,Sangareddy,Andhra Pradesh',
'Togarpalli,Sangareddy,Andhra Pradesh',
'Topgonda,Sangareddy,Andhra Pradesh',
'Waddepalli,Sangareddy,Andhra Pradesh',
'Yeddumailaram,Sangareddy,Andhra Pradesh',
'Siddipet H.O,Medak,Andhra Pradesh',
'Algole,Sangareddy,Andhra Pradesh',
'Allipur,Sangareddy,Andhra Pradesh',
'Anegunta,Sangareddy,Andhra Pradesh',
'Bagareddypally,Sangareddy,Andhra Pradesh',
'Bilalpur,Sangareddy,Andhra Pradesh',
'Buchnelly,Sangareddy,Andhra Pradesh',
'Burdipahad,Sangareddy,Andhra Pradesh',
'Chalki,Sangareddy,Andhra Pradesh',
'Charakpally,Sangareddy,Andhra Pradesh',
'Cheekurthi,Sangareddy,Andhra Pradesh',
'Chilkepally,Sangareddy,Andhra Pradesh',
'Chintalghat,Sangareddy,Andhra Pradesh',
'Dappur,Sangareddy,Andhra Pradesh',
'Dhanasiri,Sangareddy,Andhra Pradesh',
'Didgi,Sangareddy,Andhra Pradesh',
'Digwal,Sangareddy,Andhra Pradesh',
'Edulapally,Sangareddy,Andhra Pradesh',
'Gopanpally,Sangareddy,Andhra Pradesh',
'Gotgarpally,Sangareddy,Andhra Pradesh',
'Gudpally,Sangareddy,Andhra Pradesh',
'Guntamarpally,Sangareddy,Andhra Pradesh',
'Guruzwada,Sangareddy,Andhra Pradesh',
'Hadnur,Sangareddy,Andhra Pradesh',
'Hasnabad,Sangareddy,Andhra Pradesh',
'Hoti (B),Sangareddy,Andhra Pradesh',
'Hulgera,Sangareddy,Andhra Pradesh',
'Ippepally,Sangareddy,Andhra Pradesh',
'Jambgi,Sangareddy,Andhra Pradesh',
'Jeerlapally,Sangareddy,Andhra Pradesh',
'Kakijanwada,Sangareddy,Andhra Pradesh',
'Kalbemal,Sangareddy,Andhra Pradesh',
'Karchal,Sangareddy,Andhra Pradesh',
'Kaveli,Sangareddy,Andhra Pradesh',
'Khanapur,Sangareddy,Andhra Pradesh',
'Khasimpur,Sangareddy,Andhra Pradesh',
'Kohir,Sangareddy,Andhra Pradesh',
'Krishnapur,Sangareddy,Andhra Pradesh',
'Kuppanagar,Sangareddy,Andhra Pradesh',
'Machireddypally,Sangareddy,Andhra Pradesh',
'Machnoor,Sangareddy,Andhra Pradesh',
'Madgi,Sangareddy,Andhra Pradesh',
'Madhunagar,Sangareddy,Andhra Pradesh',
'Madri,Sangareddy,Andhra Pradesh',
'Malchalma,Sangareddy,Andhra Pradesh',
'Malkapur (Jadi),Sangareddy,Andhra Pradesh',
'Mamidgi,Sangareddy,Andhra Pradesh',
'Maniyarpally,Sangareddy,Andhra Pradesh',
'Mannapur,Sangareddy,Andhra Pradesh',
'Metalkunta,Sangareddy,Andhra Pradesh',
'Mirzapur,Sangareddy,Andhra Pradesh',
'Mogudampally,Sangareddy,Andhra Pradesh',
'Mungi,Sangareddy,Andhra Pradesh',
'Ngo\'s Colony,Sangareddy,Andhra Pradesh',
'Nyalkal,Sangareddy,Andhra Pradesh',
'Paidigummal,Sangareddy,Andhra Pradesh',
'Pampad,Sangareddy,Andhra Pradesh',
'Pastapur,Sangareddy,Andhra Pradesh',
'Peepalpalli,Sangareddy,Andhra Pradesh',
'Picharagadi,Sangareddy,Andhra Pradesh',
'Pothareddypally,Sangareddy,Andhra Pradesh',
'Raikode,Sangareddy,Andhra Pradesh',
'Rajnelli,Sangareddy,Andhra Pradesh',
'Ranjhole,Sangareddy,Andhra Pradesh',
'Ratnapur,Sangareddy,Andhra Pradesh',
'Rejinthal,Sangareddy,Andhra Pradesh',
'Sajjapur,Sangareddy,Andhra Pradesh',
'Satwar,Sangareddy,Andhra Pradesh',
'Shaikapur,Sangareddy,Andhra Pradesh',
'Singtham,Sangareddy,Andhra Pradesh',
'Venkatapur,Sangareddy,Andhra Pradesh',
'Waddi,Sangareddy,Andhra Pradesh',
'Yedakulapalli,Sangareddy,Andhra Pradesh',
'Yelgoi,Sangareddy,Andhra Pradesh',
'Zaheerabad H.O,Sangareddy,Andhra Pradesh',
'Zarasangam,Sangareddy,Andhra Pradesh',
'Appajipet,Nalgonda,Andhra Pradesh',
'Cherlapally,Nalgonda,Andhra Pradesh',
'Dandampally,Nalgonda,Andhra Pradesh',
'Kakula Kondaram,Nalgonda,Andhra Pradesh',
'Kanchana Palli,Nalgonda,Andhra Pradesh',
'Kesharajpally,Nalgonda,Andhra Pradesh',
'Kondapur,Nalgonda,Andhra Pradesh',
'Marriguda,Nalgonda,Andhra Pradesh',
'Peepalpahad,Nalgonda,Andhra Pradesh',
'Nagaram,Nalgonda,Andhra Pradesh',
'Bhongir Gunj,Nalgonda,Andhra Pradesh',
'Bibinagar,Nalgonda,Andhra Pradesh',
'Raghunathpur,Nalgonda,Andhra Pradesh',
'Tekula Somaram,Nalgonda,Andhra Pradesh',
'Wangapalli,Nalgonda,Andhra Pradesh',
'Bhongir H.O,Nalgonda,Andhra Pradesh',
'Bollepally,Nalgonda,Andhra Pradesh',
'Hanumapur,Nalgonda,Andhra Pradesh',
'Ikkurthy,Nalgonda,Andhra Pradesh',
'Kanchanapally,Nalgonda,Andhra Pradesh',
'Mogilipaka,Nalgonda,Andhra Pradesh',
'Motakondur,Nalgonda,Andhra Pradesh',
'Peda Kandukur,Nalgonda,Andhra Pradesh',
'Suraram,Nalgonda,Andhra Pradesh',
'Chandur,Nalgonda,Andhra Pradesh',
'Peddatoor,Nalgonda,Andhra Pradesh',
'Akupamula,Suryapet,Andhra Pradesh',
'Amaravaram,Suryapet,Andhra Pradesh',
'Ameenabad,Suryapet,Andhra Pradesh',
'Ananthagiri,Suryapet,Andhra Pradesh',
'Balajinagar,Suryapet,Andhra Pradesh',
'Bethavolu,Suryapet,Andhra Pradesh',
'Booruggadda,Suryapet,Andhra Pradesh',
'Bothalapalem,Suryapet,Andhra Pradesh',
'Chanupally,Suryapet,Andhra Pradesh',
'Cheedella,Suryapet,Andhra Pradesh',
'Chilkur,Suryapet,Andhra Pradesh',
'Chimiryala,Suryapet,Andhra Pradesh',
'Chintalapalem,Suryapet,Andhra Pradesh',
'Chintriyala,Suryapet,Andhra Pradesh',
'Choutapally,Suryapet,Andhra Pradesh',
'Dacharam,Suryapet,Andhra Pradesh',
'Dirsencharla,Suryapet,Andhra Pradesh',
'Dondapadu,Suryapet,Andhra Pradesh',
'Dwarakunta,Suryapet,Andhra Pradesh',
'Gaddipally,Suryapet,Andhra Pradesh',
'Ganapavaram,Suryapet,Andhra Pradesh',
'Ganapavaram,Suryapet,Andhra Pradesh',
'Ganugabanda,Suryapet,Andhra Pradesh',
'Garidepally,Suryapet,Andhra Pradesh',
'Gondriyala,Suryapet,Andhra Pradesh',
'Gudibanda,Suryapet,Andhra Pradesh',
'Gudimalkapuram,Suryapet,Andhra Pradesh',
'Guduguntlapalem,Suryapet,Andhra Pradesh',
'Gundlapahad,Suryapet,Andhra Pradesh',
'Gundlapally,Suryapet,Andhra Pradesh',
'Huzurnagar,Suryapet,Andhra Pradesh',
'Jagannadhapuram,Suryapet,Andhra Pradesh',
'Janpahad,Suryapet,Andhra Pradesh',
'Jerripothula Gudem,Suryapet,Andhra Pradesh',
'Kagitaramachandrapuram,Suryapet,Andhra Pradesh',
'Kalakova,Suryapet,Andhra Pradesh',
'Kalmalacheruvu,Suryapet,Andhra Pradesh',
'Kandibanda,Suryapet,Andhra Pradesh',
'Kapugal,Suryapet,Andhra Pradesh',
'Karakkayala Gudem,Suryapet,Andhra Pradesh',
'Karivirala,Suryapet,Andhra Pradesh',
'Keethavarigudem,Suryapet,Andhra Pradesh',
'Kodad,Suryapet,Andhra Pradesh',
'Kokkireni,Suryapet,Andhra Pradesh',
'Komarabanda,Suryapet,Andhra Pradesh',
'Kondapuram,Suryapet,Andhra Pradesh',
'Kuchipudi,Suryapet,Andhra Pradesh',
'Lakkavaram,Suryapet,Andhra Pradesh',
'Lingagiri,Suryapet,Andhra Pradesh',
'Lingala,Suryapet,Andhra Pradesh',
'Mattampally,Suryapet,Andhra Pradesh',
'Medaram,Suryapet,Andhra Pradesh',
'Medlacheruvu,Suryapet,Andhra Pradesh',
'Mogalaikota,Suryapet,Andhra Pradesh',
'Mukundapuram,Suryapet,Andhra Pradesh',
'Munagala,Suryapet,Andhra Pradesh',
'Nadigudem,Suryapet,Andhra Pradesh',
'Nallabandagudem,Suryapet,Andhra Pradesh',
'Narayanagudem,Suryapet,Andhra Pradesh',
'Palakeedu,Suryapet,Andhra Pradesh',
'Palavaram,Suryapet,Andhra Pradesh',
'Pale Annaram,Suryapet,Andhra Pradesh',
'Pedaveedu,Suryapet,Andhra Pradesh',
'Penchikal Dinna,Suryapet,Andhra Pradesh',
'Ponugode,Suryapet,Andhra Pradesh',
'Raghunadhapalem,Suryapet,Andhra Pradesh',
'Rainiguda,Suryapet,Andhra Pradesh',
'Ramalaxmipuram,Suryapet,Andhra Pradesh',
'Ramapuram,Suryapet,Andhra Pradesh',
'Ramapuram,Suryapet,Andhra Pradesh',
'Ratnavaram,Suryapet,Andhra Pradesh',
'Redlakunta,Suryapet,Andhra Pradesh',
'Revoor,Suryapet,Andhra Pradesh',
'Sarvaram,Suryapet,Andhra Pradesh',
'Shantinagar,Suryapet,Andhra Pradesh',
'Shobhanadrigudem,Suryapet,Andhra Pradesh',
'Simhapuri,Suryapet,Andhra Pradesh',
'Singavaram,Suryapet,Andhra Pradesh',
'Siripuram,Suryapet,Andhra Pradesh',
'Somavaram,Suryapet,Andhra Pradesh',
'Srerangapuram,Suryapet,Andhra Pradesh',
'Sunyapahad,Suryapet,Andhra Pradesh',
'Taduvai,Suryapet,Andhra Pradesh',
'Tallamalkapuram,Suryapet,Andhra Pradesh',
'Tellaballi,Suryapet,Andhra Pradesh',
'Thammara,Suryapet,Andhra Pradesh',
'Thammavaram,Suryapet,Andhra Pradesh',
'Togarrai,Suryapet,Andhra Pradesh',
'Tripuravaram,Suryapet,Andhra Pradesh',
'Vallapuram,Suryapet,Andhra Pradesh',
'Velidanda,Suryapet,Andhra Pradesh',
'Vellatoor,Suryapet,Andhra Pradesh',
'Venkatramapuram,Suryapet,Andhra Pradesh',
'Venugopalapuram,Suryapet,Andhra Pradesh',
'Wardhapuram,Suryapet,Andhra Pradesh',
'X Roads, Kodad,Suryapet,Andhra Pradesh',
'Yathavakilla,Suryapet,Andhra Pradesh',
'Yepalasingaram,Suryapet,Andhra Pradesh',
'Yerravaram,Suryapet,Andhra Pradesh',
'Adavdevulapally,Suryapet,Andhra Pradesh',
'Agamothkur,Suryapet,Andhra Pradesh',
'Amangal,Suryapet,Andhra Pradesh',
'Amruth Nagar,Suryapet,Andhra Pradesh',
'Anjanapally,Suryapet,Andhra Pradesh',
'Annaram,Suryapet,Andhra Pradesh',
'Baba Saheb Peta,Suryapet,Andhra Pradesh',
'Bangarigadda,Suryapet,Andhra Pradesh',
'Bheemavaram,Suryapet,Andhra Pradesh',
'Bodaladinne,Suryapet,Andhra Pradesh',
'Bokkamunthalapahad,Suryapet,Andhra Pradesh',
'Bommakal,Suryapet,Andhra Pradesh',
'Borraipalem,Suryapet,Andhra Pradesh',
'Chennaipalem,Suryapet,Andhra Pradesh',
'Cheruvupally,Suryapet,Andhra Pradesh',
'Chirumarthy,Suryapet,Andhra Pradesh',
'Damarcharla,Suryapet,Andhra Pradesh',
'Devulapally Calan,Suryapet,Andhra Pradesh',
'Dilvarpur,Suryapet,Andhra Pradesh',
'Duggepally,Suryapet,Andhra Pradesh',
'Gudur,Suryapet,Andhra Pradesh',
'Hazarigudem,Suryapet,Andhra Pradesh',
'Indugula,Suryapet,Andhra Pradesh',
'Kamareddy Gudem,Suryapet,Andhra Pradesh',
'Kannekal,Suryapet,Andhra Pradesh',
'Keshavapuram,Suryapet,Andhra Pradesh',
'Kondrapole,Suryapet,Andhra Pradesh',
'Kukkadam,Suryapet,Andhra Pradesh',
'Marpaka,Suryapet,Andhra Pradesh',
'Matoor,Suryapet,Andhra Pradesh',
'Gavarampeta,Parvathipuram,Andhra Pradesh',
'Gijaba,Parvathipuram,Andhra Pradesh',
'Jiyyammavalasa,Parvathipuram,Andhra Pradesh',
'Joguladumma,Parvathipuram,Andhra Pradesh',
'Kannapudoravalasa,Parvathipuram,Andhra Pradesh',
'Kudama,Parvathipuram,Andhra Pradesh',
'Merangi,Parvathipuram,Andhra Pradesh',
'Parajapadu,Parvathipuram,Andhra Pradesh',
'Pedamerangi,Parvathipuram,Andhra Pradesh',
'Pippalabhadra,Parvathipuram,Andhra Pradesh',
'Ramabhadrapuram,Parvathipuram,Andhra Pradesh',
'Sikhabadi,Parvathipuram,Andhra Pradesh',
'Tamarakhandi Jammu,Parvathipuram,Andhra Pradesh',
'Tumbali,Parvathipuram,Andhra Pradesh',
'Turakanaiduvalasa,Parvathipuram,Andhra Pradesh',
'Antivalasa,Parvathipuram,Andhra Pradesh',
'Babbidi,Parvathipuram,Andhra Pradesh',
'Chinageesada,Parvathipuram,Andhra Pradesh',
'Chollapadam,Parvathipuram,Andhra Pradesh',
'Gangarevuvalasa,Parvathipuram,Andhra Pradesh',
'Goipaka,Parvathipuram,Andhra Pradesh',
'Gumada,Parvathipuram,Andhra Pradesh',
'Janjhavathi Colony,Parvathipuram,Andhra Pradesh',
'Kallikota,Parvathipuram,Andhra Pradesh',
'Kemiseela,Parvathipuram,Andhra Pradesh',
'Komarada,Parvathipuram,Andhra Pradesh',
'Kotipam,Parvathipuram,Andhra Pradesh',
'Kottu,Parvathipuram,Andhra Pradesh',
'Kuneru,Parvathipuram,Andhra Pradesh',
'Lakshminaiduvalasa,Parvathipuram,Andhra Pradesh',
'Madalangi,Parvathipuram,Andhra Pradesh',
'Palem,Parvathipuram,Andhra Pradesh',
'Pedasakha,Parvathipuram,Andhra Pradesh',
'Rajyalakshmipuram,Parvathipuram,Andhra Pradesh',
'Thodumu,Parvathipuram,Andhra Pradesh',
'Tulasivalasa,Parvathipuram,Andhra Pradesh',
'Konada,Vizianagaram,Andhra Pradesh',
'Kotagandredu,Vizianagaram,Andhra Pradesh',
'Bhaligattam,Vizianagaram,Andhra Pradesh',
'Cheepuruvalasa,Vizianagaram,Andhra Pradesh',
'Denderu,Vizianagaram,Andhra Pradesh',
'Devada,Vizianagaram,Andhra Pradesh',
'Kothavalasa,Vizianagaram,Andhra Pradesh',
'Mangalapalem,Vizianagaram,Andhra Pradesh',
'Pathavalasa,Vizianagaram,Andhra Pradesh',
'Pindrangi,Vizianagaram,Andhra Pradesh',
'Relli,Vizianagaram,Andhra Pradesh',
'Tangudubilli,Vizianagaram,Andhra Pradesh',
'Tummukapalli,Vizianagaram,Andhra Pradesh',
'Uttarapalli,Vizianagaram,Andhra Pradesh',
'V B Puram,Vizianagaram,Andhra Pradesh',
'Viyyammapeta,Vizianagaram,Andhra Pradesh',
'Buddemkharja,Parvathipuram,Andhra Pradesh',
'Charayabinnidi,Parvathipuram,Andhra Pradesh',
'Dalaipeta,Parvathipuram,Andhra Pradesh',
'Dharmalakshmipuram,Parvathipuram,Andhra Pradesh',
'Duddukhallu,Parvathipuram,Andhra Pradesh',
'Gorjipadu,Parvathipuram,Andhra Pradesh',
'Gotivada,Parvathipuram,Andhra Pradesh',
'Gujjuvai,Parvathipuram,Andhra Pradesh',
'Jumbiri,Parvathipuram,Andhra Pradesh',
'Kitchada,Parvathipuram,Andhra Pradesh',
'Kondabaridi,Parvathipuram,Andhra Pradesh',
'Kurupam,Parvathipuram,Andhra Pradesh',
'Maripalli,Parvathipuram,Andhra Pradesh',
'Mondemkhallu,Parvathipuram,Andhra Pradesh',
'Neelakanthapuram,Parvathipuram,Andhra Pradesh',
'Pedagottili,Parvathipuram,Andhra Pradesh',
'Rayagadajammu,Parvathipuram,Andhra Pradesh',
'Regidi,Parvathipuram,Andhra Pradesh',
'Sivada,Parvathipuram,Andhra Pradesh',
'Sivannapeta,Parvathipuram,Andhra Pradesh',
'Tittiri,Parvathipuram,Andhra Pradesh',
'Udayapuram,Parvathipuram,Andhra Pradesh',
'Valasaballeru,Parvathipuram,Andhra Pradesh',
'Vobbangi,Parvathipuram,Andhra Pradesh',
'Voosakonda,Parvathipuram,Andhra Pradesh',
'Zarada,Parvathipuram,Andhra Pradesh',
'Dasulapalem,Vizianagaram,Andhra Pradesh',
'Gangubudi,Vizianagaram,Andhra Pradesh',
'Golzam,Vizianagaram,Andhra Pradesh',
'Kallempudi,Vizianagaram,Andhra Pradesh',
'Kallepalli,Vizianagaram,Andhra Pradesh',
'Khasapeta,Vizianagaram,Andhra Pradesh',
'Kummapalli,Vizianagaram,Andhra Pradesh',
'L Kota,Vizianagaram,Andhra Pradesh',
'Malliveedu,Vizianagaram,Andhra Pradesh',
'R G Peta,Vizianagaram,Andhra Pradesh',
'Rangarayapuram,Vizianagaram,Andhra Pradesh',
'Seetharampuram,Vizianagaram,Andhra Pradesh',
'T Sanduluru,Vizianagaram,Andhra Pradesh',
'A.Venkampeta,Parvathipuram,Andhra Pradesh',
'Bangaruvalasa,Parvathipuram,Andhra Pradesh',
'Chappabutchampeta,Parvathipuram,Andhra Pradesh',
'Chemudu,Parvathipuram,Andhra Pradesh',
'Dabbagedda,Parvathipuram,Andhra Pradesh',
'Duggeru,Parvathipuram,Andhra Pradesh',
'Kannampeta,Parvathipuram,Andhra Pradesh',
'Kasipatnam,Parvathipuram,Andhra Pradesh',
'Kaviripalli,Parvathipuram,Andhra Pradesh',
'Koyyannapeta,Parvathipuram,Andhra Pradesh',
'Makkuva,Parvathipuram,Andhra Pradesh',
'Markondaputti,Parvathipuram,Andhra Pradesh',
'Sambara,Parvathipuram,Andhra Pradesh',
'Saraivalasa,Parvathipuram,Andhra Pradesh',
'Thurumamidi,Parvathipuram,Andhra Pradesh',
'Venkatabhyripuram,Parvathipuram,Andhra Pradesh',
'Bhudevipeta,Vizianagaram,Andhra Pradesh',
'Budathanapalli,Vizianagaram,Andhra Pradesh',
'G Ch Penta,Vizianagaram,Andhra Pradesh',
'Gollupalem,Vizianagaram,Andhra Pradesh',
'Jinnam Agrharam,Vizianagaram,Andhra Pradesh',
'Kenguva,Vizianagaram,Andhra Pradesh',
'Konisa,Vizianagaram,Andhra Pradesh',
'Korlam,Vizianagaram,Andhra Pradesh',
'Kotarupalli,Vizianagaram,Andhra Pradesh',
'Lakkidam,Vizianagaram,Andhra Pradesh',
'Lingalavalasa,Vizianagaram,Andhra Pradesh',
'Logisa,Vizianagaram,Andhra Pradesh',
'M Gumudam,Vizianagaram,Andhra Pradesh',
'M Kothavalasa,Vizianagaram,Andhra Pradesh',
'Madhupada,Vizianagaram,Andhra Pradesh',
'Marupalli,Vizianagaram,Andhra Pradesh',
'Mentada,Vizianagaram,Andhra Pradesh',
'Mutcherla,Vizianagaram,Andhra Pradesh',
'Narava,Vizianagaram,Andhra Pradesh',
'Neelavathi,Vizianagaram,Andhra Pradesh',
'Ompalli,Vizianagaram,Andhra Pradesh',
'P P Agraharam,Vizianagaram,Andhra Pradesh',
'P.S.R Puram,Vizianagaram,Andhra Pradesh',
'Pathabaggam,Vizianagaram,Andhra Pradesh',
'Pedakada,Vizianagaram,Andhra Pradesh',
'Pedavemali,Vizianagaram,Andhra Pradesh',
'Penasam,Vizianagaram,Andhra Pradesh',
'Ramavaram,Vizianagaram,Andhra Pradesh',
'S R R Puram,Vizianagaram,Andhra Pradesh',
'Tummikapalli,Vizianagaram,Andhra Pradesh',
'Garbham,Parvathipuram,Andhra Pradesh',
'Bhupalarajapuram,Parvathipuram,Andhra Pradesh',
'Bhyripuram,Parvathipuram,Andhra Pradesh',
'Billalavalasa,Parvathipuram,Andhra Pradesh',
'Budarayavalasa,Parvathipuram,Andhra Pradesh',
'Gadelamarrivalasa,Parvathipuram,Andhra Pradesh',
'Garugubilli,Parvathipuram,Andhra Pradesh',
'Gottipalli,Parvathipuram,Andhra Pradesh',
'Ippalavalasa,Parvathipuram,Andhra Pradesh',
'Merakamudidam,Parvathipuram,Andhra Pradesh',
'Mokhasa Lingalavalasa,Parvathipuram,Andhra Pradesh',
'Mudidam Ravivalasa,Parvathipuram,Andhra Pradesh',
'Timiteru Burjavalasa,Parvathipuram,Andhra Pradesh',
'Vootapalli,Parvathipuram,Andhra Pradesh',
'Yadika,Parvathipuram,Andhra Pradesh',
'Marrivalasa,Srikakulam,Andhra Pradesh',
'Rachagumadam,Srikakulam,Andhra Pradesh',
'Sathamvalasa,Srikakulam,Andhra Pradesh',
'Moida,Vizianagaram,Andhra Pradesh',
'A T Agraharam,Vizianagaram,Andhra Pradesh',
'Alugolu,Vizianagaram,Andhra Pradesh',
'Boppadam,Vizianagaram,Andhra Pradesh',
'Buradapeta,Vizianagaram,Andhra Pradesh',
'Damarasingi,Vizianagaram,Andhra Pradesh',
'Gushini,Vizianagaram,Andhra Pradesh',
'Jarajapupeta,Vizianagaram,Andhra Pradesh',
'Kondagumpam,Vizianagaram,Andhra Pradesh',
'Kondakarakam,Vizianagaram,Andhra Pradesh',
'Kondavelagada,Vizianagaram,Andhra Pradesh',
'Kothapeta,Vizianagaram,Andhra Pradesh',
'M J R Peta,Vizianagaram,Andhra Pradesh',
'Malayada,Vizianagaram,Andhra Pradesh',
'Manyapuripeta,Vizianagaram,Andhra Pradesh',
'Nellimarla Bazar,Vizianagaram,Andhra Pradesh',
'Nellimarla,Vizianagaram,Andhra Pradesh',
'Parasam,Vizianagaram,Andhra Pradesh',
'S S R Peta,Vizianagaram,Andhra Pradesh',
'Saripalli,Vizianagaram,Andhra Pradesh',
'Sativada,Vizianagaram,Andhra Pradesh',
'Tangudubilli,Vizianagaram,Andhra Pradesh',
'Tummalapeta,Vizianagaram,Andhra Pradesh',
'Vallapuram,Vizianagaram,Andhra Pradesh',
'Valluru,Vizianagaram,Andhra Pradesh',
'Gadivalasa,Parvathipuram,Andhra Pradesh',
'Guruvunaidupeta,Parvathipuram,Andhra Pradesh',
'Karivalasa,Parvathipuram,Andhra Pradesh',
'Kesali,Parvathipuram,Andhra Pradesh',
'Kompangi,Vizianagaram,Andhra Pradesh',
'Kuntinivalasa,Vizianagaram,Andhra Pradesh',
'Maradam,Vizianagaram,Andhra Pradesh',
'Matumuru,Parvathipuram,Andhra Pradesh',
'Mosuru,Parvathipuram,Andhra Pradesh',
'Pachipenta,Parvathipuram,Andhra Pradesh',
'Padmapuram,Parvathipuram,Andhra Pradesh',
'Panasapeddikonavalasa,Parvathipuram,Andhra Pradesh',
'Panchali,Parvathipuram,Andhra Pradesh',
'Panukuvalasa,Parvathipuram,Andhra Pradesh',
'Pedachamalapalli,Vizianagaram,Andhra Pradesh',
'Pedamedapalli,Vizianagaram,Andhra Pradesh',
'Poram,Vizianagaram,Andhra Pradesh',
'S Chintalavalasa,Vizianagaram,Andhra Pradesh',
'Taduru,Parvathipuram,Andhra Pradesh',
'Vijayaramapuram,Vizianagaram,Andhra Pradesh',
'Viswanadhapuram,Parvathipuram,Andhra Pradesh',
'Balagudaba,Parvathipuram,Andhra Pradesh',
'Bandaluppi,Parvathipuram,Andhra Pradesh',
'Buduruwada,Parvathipuram,Andhra Pradesh',
'Chinagudaba,Parvathipuram,Andhra Pradesh',
'Dokiseela,Parvathipuram,Andhra Pradesh',
'Donkala Kothapatnam,Parvathipuram,Andhra Pradesh',
'Duggi,Parvathipuram,Andhra Pradesh',
'Gochekka,Parvathipuram,Andhra Pradesh',
'Gunanupuram,Parvathipuram,Andhra Pradesh',
'Jagannadhapuram,Parvathipuram,Andhra Pradesh',
'Jamadala,Parvathipuram,Andhra Pradesh',
'Kavitibhadra,Parvathipuram,Andhra Pradesh',
'Kothabelagam,Parvathipuram,Andhra Pradesh',
'Kothavalasa,Parvathipuram,Andhra Pradesh',
'Krishnapalli,Parvathipuram,Andhra Pradesh',
'Lakshminarayanapuram,Parvathipuram,Andhra Pradesh',
'Mrutyunjayarayanagaram,Parvathipuram,Andhra Pradesh',
'Mulaga,Parvathipuram,Andhra Pradesh',
'Narsipuram,Parvathipuram,Andhra Pradesh',
'Parvatipuram Bus Stand,Parvathipuram,Andhra Pradesh',
'Parvatipuram H.O,Parvathipuram,Andhra Pradesh',
'Parvatipuram Town,Parvathipuram,Andhra Pradesh',
'Pedabondapalli,Parvathipuram,Andhra Pradesh',
'Pedamariki,Parvathipuram,Andhra Pradesh',
'Philipnagar,Parvathipuram,Andhra Pradesh',
'Puligummi,Parvathipuram,Andhra Pradesh',
'Putturu,Parvathipuram,Andhra Pradesh',
'Sangamvalasa,Parvathipuram,Andhra Pradesh',
'Seetharampuram,Parvathipuram,Andhra Pradesh',
'Sirlam,Parvathipuram,Andhra Pradesh',
'Sudigam,Parvathipuram,Andhra Pradesh',
'Tallaburidi,Parvathipuram,Andhra Pradesh',
'Venkampeta,Parvathipuram,Andhra Pradesh',
'Vikrampuram,Parvathipuram,Andhra Pradesh',
'Pedamajjipalem,Vizianagaram,Andhra Pradesh',
'Pedamanapuram,Vizianagaram,Andhra Pradesh',
'Alladapalem,Vizianagaram,Andhra Pradesh',
'Chintapalli,Vizianagaram,Andhra Pradesh',
'Chodamma Agraharam,Vizianagaram,Andhra Pradesh',
'Chollangipeta,Vizianagaram,Andhra Pradesh',
'Govindapuram,Vizianagaram,Andhra Pradesh',
'Gumpam Agraharam,Vizianagaram,Andhra Pradesh',
'Kandivalasa,Vizianagaram,Andhra Pradesh',
'Kanimella,Vizianagaram,Andhra Pradesh',
'Kg Pathasala,Vizianagaram,Andhra Pradesh',
'Kopperla,Vizianagaram,Andhra Pradesh',
'Kovvada Agraharam,Vizianagaram,Andhra Pradesh',
'Krishnapuram,Vizianagaram,Andhra Pradesh',
'Kumili,Vizianagaram,Andhra Pradesh',
'Lankapillipalem,Vizianagaram,Andhra Pradesh',
'Pasupam,Vizianagaram,Andhra Pradesh',
'Pathivada,Vizianagaram,Andhra Pradesh',
'Perapuram,Vizianagaram,Andhra Pradesh',
'Pusapatirega,Vizianagaram,Andhra Pradesh',
'Rellivalasa,Vizianagaram,Andhra Pradesh',
'Velduru,Vizianagaram,Andhra Pradesh',
'Vempadam,Vizianagaram,Andhra Pradesh',
'Arikathota,Parvathipuram,Andhra Pradesh',
'Busayavalasa,Parvathipuram,Andhra Pradesh',
'Duppalapudi,Parvathipuram,Andhra Pradesh',
'Itlamamidipalli,Parvathipuram,Andhra Pradesh',
'Jannivalasa,Parvathipuram,Andhra Pradesh',
'Kondakenguva,Parvathipuram,Andhra Pradesh',
'Kota Sirlam,Parvathipuram,Andhra Pradesh',
'Kottakki,Parvathipuram,Andhra Pradesh',
'Mamidivalasa,Parvathipuram,Andhra Pradesh',
'Patharega,Parvathipuram,Andhra Pradesh',
'Ramabhadrapuram,Parvathipuram,Andhra Pradesh',
'Rompalli,Parvathipuram,Andhra Pradesh',
'Sompuram,Parvathipuram,Andhra Pradesh',
'Tarapuram,Parvathipuram,Andhra Pradesh',
'Ramathirtam,Vizianagaram,Andhra Pradesh',
'Alugubilli,Vizianagaram,Andhra Pradesh',
'Gopalapalli,Vizianagaram,Andhra Pradesh',
'Kottam,Vizianagaram,Andhra Pradesh',
'Krishnapuram,Vizianagaram,Andhra Pradesh',
'Longuparthi,Vizianagaram,Andhra Pradesh',
'Madhupada,Vizianagaram,Andhra Pradesh',
'Mallipudi,Vizianagaram,Andhra Pradesh',
'Pedakandepalli,Vizianagaram,Andhra Pradesh',
'S G Peta,Vizianagaram,Andhra Pradesh',
'S Kota,Vizianagaram,Andhra Pradesh',
'Seethampeta,Vizianagaram,Andhra Pradesh',
'T B Vara,Vizianagaram,Andhra Pradesh',
'Talari,Vizianagaram,Andhra Pradesh',
'Timidi,Vizianagaram,Andhra Pradesh',
'Veeranaraynam,Vizianagaram,Andhra Pradesh',
'Vemulapalli,Vizianagaram,Andhra Pradesh',
'Seetharamapuram,Vizianagaram,Andhra Pradesh',
'Antivalasa,Parvathipuram,Andhra Pradesh',
'Bangarampeta,Parvathipuram,Andhra Pradesh',
'Dandigam,Parvathipuram,Andhra Pradesh',
'Kandulapadam,Parvathipuram,Andhra Pradesh',
'Kharasavalasa,Parvathipuram,Andhra Pradesh',
'Kothavalasa,Parvathipuram,Andhra Pradesh',
'Kottuparuva,Parvathipuram,Andhra Pradesh',
'Kurukutti,Parvathipuram,Andhra Pradesh',
'Lakshmipuram,Parvathipuram,Andhra Pradesh',
'Mamidipalle,Parvathipuram,Andhra Pradesh',
'Maripalli,Parvathipuram,Andhra Pradesh',
'Mavudi,Parvathipuram,Andhra Pradesh',
'Narlavalasa,Parvathipuram,Andhra Pradesh',
'Nelliparthi,Parvathipuram,Andhra Pradesh',
'Pandiri Mamidivalasa,Parvathipuram,Andhra Pradesh',
'Parannavalasa,Parvathipuram,Andhra Pradesh',
'Pedaborabanda,Parvathipuram,Andhra Pradesh',
'Pedapadam,Parvathipuram,Andhra Pradesh',
'Purohitunivalasa,Parvathipuram,Andhra Pradesh',
'Salur Fort,Parvathipuram,Andhra Pradesh',
'Salur,Parvathipuram,Andhra Pradesh',
'Sariki,Parvathipuram,Andhra Pradesh',
'Sivarampuram,Parvathipuram,Andhra Pradesh',
'Sivili Peddavalasa,Parvathipuram,Andhra Pradesh',
'Thonam,Parvathipuram,Andhra Pradesh',
'Thunda,Parvathipuram,Andhra Pradesh',
'Appayyapeta,Parvathipuram,Andhra Pradesh',
'Burja,Parvathipuram,Andhra Pradesh',
'Chinabhogili,Parvathipuram,Andhra Pradesh',
'Gadelavalasa,Parvathipuram,Andhra Pradesh',
'Geddaluppi,Parvathipuram,Andhra Pradesh',
'Gutchimi,Parvathipuram,Andhra Pradesh',
'Janumallavalasa,Parvathipuram,Andhra Pradesh',
'Khasapeta,Parvathipuram,Andhra Pradesh',
'Kotaseetharampuram,Parvathipuram,Andhra Pradesh',
'Krishnarayapuram,Parvathipuram,Andhra Pradesh',
'Lakshmipuram Agraharam,Parvathipuram,Andhra Pradesh',
'Latchayyapeta,Parvathipuram,Andhra Pradesh',
'Maripivalasa,Parvathipuram,Andhra Pradesh',
'Nidagallu,Parvathipuram,Andhra Pradesh',
'Pedankalam,Parvathipuram,Andhra Pradesh',
'Ramavaram,Parvathipuram,Andhra Pradesh',
'Seethanagaram,Parvathipuram,Andhra Pradesh',
'Surampeta,Parvathipuram,Andhra Pradesh',
'Tamarakhandi,Parvathipuram,Andhra Pradesh',
'Ss Korukonda,Vizianagaram,Andhra Pradesh',
'Amiti,Parvathipuram,Andhra Pradesh',
'Gangannapadu,Parvathipuram,Andhra Pradesh',
'Goluguvalasa,Parvathipuram,Andhra Pradesh',
'Koratam,Parvathipuram,Andhra Pradesh',
'Kunayavalasa,Parvathipuram,Andhra Pradesh',
'Kusumuru,Parvathipuram,Andhra Pradesh',
'Locherla,Parvathipuram,Andhra Pradesh',
'Nandabalaga,Parvathipuram,Andhra Pradesh',
'Nandigam,Parvathipuram,Andhra Pradesh',
'Nemalam,Parvathipuram,Andhra Pradesh',
'Therlam,Parvathipuram,Andhra Pradesh',
'Uttaravalli,Parvathipuram,Andhra Pradesh',
'Velagavalasa,Parvathipuram,Andhra Pradesh',
'Kagam,Srikakulam,Andhra Pradesh',
'Perumali,Srikakulam,Andhra Pradesh',
'Sundarada,Srikakulam,Andhra Pradesh',
'Gudivada Agraharam,Parvathipuram,Andhra Pradesh',
'Iruwada,Parvathipuram,Andhra Pradesh',
'Kinjangi,Parvathipuram,Andhra Pradesh',
'Koppara,Parvathipuram,Andhra Pradesh',
'Maruwada,Parvathipuram,Andhra Pradesh',
'A S Peta,Vizianagaram,Andhra Pradesh',
'Athava,Vizianagaram,Andhra Pradesh',
'Banadi,Vizianagaram,Andhra Pradesh',
'Boddam,Vizianagaram,Andhra Pradesh',
'Dabbirajupeta,Vizianagaram,Andhra Pradesh',
'Gudivada,Vizianagaram,Andhra Pradesh',
'K G Budi,Vizianagaram,Andhra Pradesh',
'K R Peta,Vizianagaram,Andhra Pradesh',
'N K R Puram,Vizianagaram,Andhra Pradesh',
'Nallaballi,Vizianagaram,Andhra Pradesh',
'Singarai,Vizianagaram,Andhra Pradesh',
'Sompuram Agraharam,Vizianagaram,Andhra Pradesh',
'Vavilapadu,Vizianagaram,Andhra Pradesh',
'Veeluparthi,Vizianagaram,Andhra Pradesh',
'Vepada,Vizianagaram,Andhra Pradesh',
'Apsp Quarters,Vizianagaram,Andhra Pradesh',
'Ayyannapeta,Vizianagaram,Andhra Pradesh',
'Cheluvuru,Vizianagaram,Andhra Pradesh',
'Dasannapeta,Vizianagaram,Andhra Pradesh',
'Dharmapuri,Vizianagaram,Andhra Pradesh',
'Duppada,Vizianagaram,Andhra Pradesh',
'Dwarapudi,Vizianagaram,Andhra Pradesh',
'Gokapeta,Vizianagaram,Andhra Pradesh',
'Gotlam,Vizianagaram,Andhra Pradesh',
'Gunkalam,Vizianagaram,Andhra Pradesh',
'Industrial Estate,Vizianagaram,Andhra Pradesh',
'Jammu,Vizianagaram,Andhra Pradesh',
'Jonnavalasa,Vizianagaram,Andhra Pradesh',
'Kanapaka,Vizianagaram,Andhra Pradesh',
'Khadarnagar,Vizianagaram,Andhra Pradesh',
'Korukonda,Vizianagaram,Andhra Pradesh',
'Kothapeta,Vizianagaram,Andhra Pradesh',
'Malicherala,Vizianagaram,Andhra Pradesh',
'Pinavemali,Vizianagaram,Andhra Pradesh',
'Rakodu,Vizianagaram,Andhra Pradesh',
'Sarika,Vizianagaram,Andhra Pradesh',
'Thotapalem,Vizianagaram,Andhra Pradesh',
'Vizianagaram City,Vizianagaram,Andhra Pradesh',
'Vizianagaram Collectorate,Vizianagaram,Andhra Pradesh',
'Vizianagaram Contonment,Vizianagaram,Andhra Pradesh',
'Vizianagaram Court Complex,Vizianagaram,Andhra Pradesh',
'Vizianagaram H.O,Vizianagaram,Andhra Pradesh',
'Vizianagaram Market,Vizianagaram,Andhra Pradesh',
'VizianagaramRTC Busstand,Vizianagaram,Andhra Pradesh',
'Vzm R.S,Vizianagaram,Andhra Pradesh',
'Gajularega,Vizianagaram,Andhra Pradesh',
'Bommakal,Warangal,Andhra Pradesh',
'Bhatpally,Hanamkonda,Andhra Pradesh',
'Chennapur,Hanamkonda,Andhra Pradesh',
'Gangaram,Hanamkonda,Andhra Pradesh',
'Gutta,Hanamkonda,Andhra Pradesh',
'Kodur,Hanamkonda,Andhra Pradesh',
'Machapur,Hanamkonda,Andhra Pradesh',
'Pullampet,Hanamkonda,Andhra Pradesh',
'Ramanujpur,Hanamkonda,Andhra Pradesh',
'Thimmapur,Hanamkonda,Andhra Pradesh',
'Venkatapur,Hanamkonda,Andhra Pradesh',
'Akkampet,Hanamkonda,Andhra Pradesh',
'Atmakur,Hanamkonda,Andhra Pradesh',
'Chowlapalli,Hanamkonda,Andhra Pradesh',
'Ladella,Warangal,Andhra Pradesh',
'Mallareddipalli,Warangal,Andhra Pradesh',
'Mustialapalli,Hanamkonda,Andhra Pradesh',
'Neerukulla,Hanamkonda,Andhra Pradesh',
'Oorugonda,Hanamkonda,Andhra Pradesh',
'Pasaragonda,Hanamkonda,Andhra Pradesh',
'Peddapur,Hanamkonda,Andhra Pradesh',
'Pulukurthy,Hanamkonda,Andhra Pradesh',
'Venkatapur,Warangal,Andhra Pradesh',
'Kogilvai,Warangal,Andhra Pradesh',
'Adavikamalapur,Hanamkonda,Andhra Pradesh',
'Azamnagar,Hanamkonda,Andhra Pradesh',
'Bhupalapalli,Hanamkonda,Andhra Pradesh',
'Gorlavaid,Hanamkonda,Andhra Pradesh',
'Jhengaid,Hanamkonda,Andhra Pradesh',
'Kompalli,Hanamkonda,Andhra Pradesh',
'Nagaram,Hanamkonda,Andhra Pradesh',
'Alimpur,Hanamkonda,Andhra Pradesh',
'Bandanagaram,Hanamkonda,Andhra Pradesh',
'Buchannapet,Hanamkonda,Andhra Pradesh',
'Dabbakunta Palli,Hanamkonda,Andhra Pradesh',
'Gangapur,Hanamkonda,Andhra Pradesh',
'Itikalapalli,Hanamkonda,Andhra Pradesh',
'Katkur,Hanamkonda,Andhra Pradesh',
'Kesireddypalli,Hanamkonda,Andhra Pradesh',
'Kodavatur,Hanamkonda,Andhra Pradesh',
'Konney,Hanamkonda,Andhra Pradesh',
'Lingampalli,Hanamkonda,Andhra Pradesh',
'Nagireddipalli,Hanamkonda,Andhra Pradesh',
'Padamatikeshavapur,Hanamkonda,Andhra Pradesh',
'Pochannapet,Hanamkonda,Andhra Pradesh',
'Ramachandrapuram,Hanamkonda,Andhra Pradesh',
'Salvapur,Hanamkonda,Andhra Pradesh',
'Tammadapalli,Hanamkonda,Andhra Pradesh',
'Chennaraopet,Warangal,Andhra Pradesh',
'Gundenga,Warangal,Andhra Pradesh',
'Gurijala,Warangal,Andhra Pradesh',
'Konapuram,Warangal,Andhra Pradesh',
'Lingapuram,Warangal,Andhra Pradesh',
'Papaiahpet,Warangal,Andhra Pradesh',
'Thimmarayanpahad,Warangal,Andhra Pradesh',
'Yellaigudem,Warangal,Andhra Pradesh',
'Maqdumpuram,Warangal,Andhra Pradesh',
'Ainapur,Hanamkonda,Andhra Pradesh',
'Aknoor,Hanamkonda,Andhra Pradesh',
'Chinchinkota,Hanamkonda,Andhra Pradesh',
'Chityal,Hanamkonda,Andhra Pradesh',
'Danampalli,Hanamkonda,Andhra Pradesh',
'Dommat,Hanamkonda,Andhra Pradesh',
'Gurujakunta,Hanamkonda,Andhra Pradesh',
'Guruvannapet,Hanamkonda,Andhra Pradesh',
'Kadaverugu,Hanamkonda,Andhra Pradesh',
'Komaravalli,Hanamkonda,Andhra Pradesh',
'Marrimuchal,Hanamkonda,Andhra Pradesh',
'Mustial,Hanamkonda,Andhra Pradesh',
'Nagapuri,Hanamkonda,Andhra Pradesh',
'Posanpalli,Hanamkonda,Andhra Pradesh',
'Pothireddipalli,Hanamkonda,Andhra Pradesh',
'Ramsagar,Hanamkonda,Andhra Pradesh',
'Tadur Bo\',Hanamkonda,Andhra Pradesh',
'Veecharani,Hanamkonda,Andhra Pradesh',
'Veerannapet,Hanamkonda,Andhra Pradesh',
'China Raman Cherla,Hanamkonda,Andhra Pradesh',
'Chiryal,Hanamkonda,Andhra Pradesh',
'Chainpak,Hanamkonda,Andhra Pradesh',
'Challagarige,Hanamkonda,Andhra Pradesh',
'Chityal,Hanamkonda,Andhra Pradesh',
'Empaid,Hanamkonda,Andhra Pradesh',
'Garimillapalli,Hanamkonda,Andhra Pradesh',
'Gopalpur,Hanamkonda,Andhra Pradesh',
'Jadalpet,Hanamkonda,Andhra Pradesh',
'Jookal,Hanamkonda,Andhra Pradesh',
'Kothapalli(V),Hanamkonda,Andhra Pradesh',
'Kundanpalli,Hanamkonda,Andhra Pradesh',
'Nainpak,Hanamkonda,Andhra Pradesh',
'Nawabpet,Hanamkonda,Andhra Pradesh',
'Pangidipalli,Hanamkonda,Andhra Pradesh',
'Ramakistapur,Hanamkonda,Andhra Pradesh',
'Tekumatla,Hanamkonda,Andhra Pradesh',
'Tirumalapur,Hanamkonda,Andhra Pradesh',
'Vadthal,Hanamkonda,Andhra Pradesh',
'Venkataraopalli,Hanamkonda,Andhra Pradesh',
'Devaruppal,Hanamkonda,Andhra Pradesh',
'Nirmal,Hanamkonda,Andhra Pradesh',
'Ramarajpalli,Hanamkonda,Andhra Pradesh',
'Singarajpalli,Hanamkonda,Andhra Pradesh',
'Appireddipalli,Hanamkonda,Andhra Pradesh',
'Dharmapuram,Hanamkonda,Andhra Pradesh',
'Gollapalli,Hanamkonda,Andhra Pradesh',
'Kadavendi,Hanamkonda,Andhra Pradesh',
'Kamareddigudem,Hanamkonda,Andhra Pradesh',
'Kolkonda,Hanamkonda,Andhra Pradesh',
'Madhapur,Hanamkonda,Andhra Pradesh',
'Marudkalan,Hanamkonda,Andhra Pradesh',
'Seetarampur,Hanamkonda,Andhra Pradesh',
'Dharmapuram,Hanamkonda,Andhra Pradesh',
'Janakipuram,Hanamkonda,Andhra Pradesh',
'Kyathampalli,Hanamkonda,Andhra Pradesh',
'Malakpalli,Hanamkonda,Andhra Pradesh',
'Mallikudurla,Hanamkonda,Andhra Pradesh',
'Mupparam,Hanamkonda,Andhra Pradesh',
'Narayanagiri,Hanamkonda,Andhra Pradesh',
'Peddapendyal,Hanamkonda,Andhra Pradesh',
'Peesara,Hanamkonda,Andhra Pradesh',
'Rampur,Hanamkonda,Andhra Pradesh',
'Saipet,Hanamkonda,Andhra Pradesh',
'Shalapalli,Hanamkonda,Andhra Pradesh',
'Shodesha Palli,Hanamkonda,Andhra Pradesh',
'Tatikayala,Hanamkonda,Andhra Pradesh',
'Unikicherla,Hanamkonda,Andhra Pradesh',
'Velair,Hanamkonda,Andhra Pradesh',
'Yelkurthy,Hanamkonda,Andhra Pradesh',
'Ammapalem,Warangal,Andhra Pradesh',
'Andanalapadu,Warangal,Andhra Pradesh',
'Balapala,Warangal,Andhra Pradesh',
'Cathedrol Compound,Warangal,Andhra Pradesh',
'Chilkode,Warangal,Andhra Pradesh',
'Dornakal,Warangal,Andhra Pradesh',
'Gollacherla,Warangal,Andhra Pradesh',
'Kannegundla,Warangal,Andhra Pradesh',
'Manneguda,Warangal,Andhra Pradesh',
'Mulkalapalli,Warangal,Andhra Pradesh',
'Perumandlasankeesa,Warangal,Andhra Pradesh',
'Vennaram,Warangal,Andhra Pradesh',
'Vuyyalawada,Warangal,Andhra Pradesh',
'Duggondi,Warangal,Andhra Pradesh',
'Mallampalli,Warangal,Andhra Pradesh',
'Mandapalli,Warangal,Andhra Pradesh',
'Mohammadapur,Warangal,Andhra Pradesh',
'Muddunur,Hanamkonda,Andhra Pradesh',
'Nachenapalli,Warangal,Andhra Pradesh',
'Timmapet,Warangal,Andhra Pradesh',
'Togarrai,Warangal,Andhra Pradesh',
'Venkatapuram,Warangal,Andhra Pradesh',
'Buttaigudem,Hanamkonda,Andhra Pradesh',
'Chelpak,Hanamkonda,Andhra Pradesh',
'Chinnaboinapalli,Hanamkonda,Andhra Pradesh',
'Etur,Hanamkonda,Andhra Pradesh',
'Eturunagaram,Hanamkonda,Andhra Pradesh',
'Gurrevula,Hanamkonda,Andhra Pradesh',
'Ilapuram,Hanamkonda,Andhra Pradesh',
'Kondai,Hanamkonda,Andhra Pradesh',
'Muppanapalli,Hanamkonda,Andhra Pradesh',
'Rajannapet,Hanamkonda,Andhra Pradesh',
'Ramannagudem,Hanamkonda,Andhra Pradesh',
'Roheer,Hanamkonda,Andhra Pradesh',
'Shahpalli,Hanamkonda,Andhra Pradesh',
'Shivapuram,Hanamkonda,Andhra Pradesh',
'Tupakulagudem,Hanamkonda,Andhra Pradesh',
'Geegugonda,Warangal,Andhra Pradesh',
'Dharmaram,Warangal,Andhra Pradesh',
'Elkurthy,Warangal,Andhra Pradesh',
'Machapur,Warangal,Andhra Pradesh',
'Manugonda,Warangal,Andhra Pradesh',
'Ookal,Warangal,Andhra Pradesh',
'Vancahnagiri,Warangal,Andhra Pradesh',
'Viswanathapur,Warangal,Andhra Pradesh',
'Mogilcherla,Warangal,Andhra Pradesh',
'Gorrekunta,Warangal,Andhra Pradesh',
'Shayampet (H),Warangal,Andhra Pradesh',
'Budharam,Hanamkonda,Andhra Pradesh',
'Ghanpur (Mulug),Hanamkonda,Andhra Pradesh',
'Chagal,Hanamkonda,Andhra Pradesh',
'Chilpur,Hanamkonda,Andhra Pradesh',
'Ghanpur Station,Hanamkonda,Andhra Pradesh',
'Kondapur,Hanamkonda,Andhra Pradesh',
'Lingampalli,Hanamkonda,Andhra Pradesh',
'Sreepathipalli,Hanamkonda,Andhra Pradesh',
'Venkatadripet,Hanamkonda,Andhra Pradesh',
'Venkeswaraswamygutta,Hanamkonda,Andhra Pradesh',
'Abadighanpur,Hanamkonda,Andhra Pradesh',
'Chinnapendyal,Hanamkonda,Andhra Pradesh',
'Fathepur,Hanamkonda,Andhra Pradesh',
'Govardanagiri,Hanamkonda,Andhra Pradesh',
'Ippaguda,Hanamkonda,Andhra Pradesh',
'Kothapalli,Hanamkonda,Andhra Pradesh',
'Krishnajigudem,Hanamkonda,Andhra Pradesh',
'Malkapur,Hanamkonda,Andhra Pradesh',
'Meedikonda,Hanamkonda,Andhra Pradesh',
'Naskal,Hanamkonda,Andhra Pradesh',
'Nemiligonda,Hanamkonda,Andhra Pradesh',
'Pallagutta,Hanamkonda,Andhra Pradesh',
'Pamnoor,Hanamkonda,Andhra Pradesh',
'Raghavapur,Hanamkonda,Andhra Pradesh',
'Rajavaram,Hanamkonda,Andhra Pradesh',
'Samudrala,Hanamkonda,Andhra Pradesh',
'Shivunipalli,Hanamkonda,Andhra Pradesh',
'Tanedarpalli,Hanamkonda,Andhra Pradesh',
'Tatikonda,Hanamkonda,Andhra Pradesh',
'Viswanathapur,Hanamkonda,Andhra Pradesh',
'Dharmaraopet,Hanamkonda,Andhra Pradesh',
'Kondapur,Hanamkonda,Andhra Pradesh',
'Mylaram,Hanamkonda,Andhra Pradesh',
'Chelpur,Hanamkonda,Andhra Pradesh',
'Laxmareddipalli,Hanamkonda,Andhra Pradesh',
'Bussapur,Hanamkonda,Andhra Pradesh',
'Chalvai,Hanamkonda,Andhra Pradesh',
'Dumpaligudem,Hanamkonda,Andhra Pradesh',
'Govindaraopet,Hanamkonda,Andhra Pradesh',
'Karlapalli,Hanamkonda,Andhra Pradesh',
'Laknavaram,Hanamkonda,Andhra Pradesh',
'Pasra,Hanamkonda,Andhra Pradesh',
'Raghavapatnam,Hanamkonda,Andhra Pradesh',
'Rangapur,Hanamkonda,Andhra Pradesh',
'Ayodhyapur,Warangal,Andhra Pradesh',
'Bhudharaopet,Warangal,Andhra Pradesh',
'Bhupathipet,Warangal,Andhra Pradesh',
'Bollepalli,Warangal,Andhra Pradesh',
'Dameravancha,Warangal,Andhra Pradesh',
'Dharmaraopet,Warangal,Andhra Pradesh',
'Gajulagattu,Warangal,Andhra Pradesh',
'Gudur,Warangal,Andhra Pradesh',
'Macherla,Warangal,Andhra Pradesh',
'Mangalvaripet,Warangal,Andhra Pradesh',
'Pungode,Warangal,Andhra Pradesh',
'Seethanagar,Warangal,Andhra Pradesh',
'Agricultur Research Station,Warangal,Andhra Pradesh',
'Arepalli,Warangal,Andhra Pradesh',
'Bapujinagar,Hanamkonda,Andhra Pradesh',
'Dharmasagar,Hanamkonda,Andhra Pradesh',
'Hanamkonda H.O,Hanamkonda,Andhra Pradesh',
'Kadipikonda,Hanamkonda,Andhra Pradesh',
'Kondaparthy,Hanamkonda,Andhra Pradesh',
'Madikonda,Hanamkonda,Andhra Pradesh',
'Mamnoor (V),Warangal,Andhra Pradesh',
'Mamnoor,Warangal,Andhra Pradesh',
'Mulkalagudem,Hanamkonda,Andhra Pradesh',
'Paidipalli,Warangal,Andhra Pradesh',
'Taralapalli,Hanamkonda,Andhra Pradesh',
'Tekulagudem,Hanamkonda,Andhra Pradesh',
'Timmapur,Warangal,Andhra Pradesh',
'Vidyaranyapuri,Hanamkonda,Andhra Pradesh',
'Waddepalli,Hanamkonda,Andhra Pradesh',
'Damera,Warangal,Andhra Pradesh',
'Kothapeta,Warangal,Andhra Pradesh',
'Yellapur,Hanamkonda,Andhra Pradesh',
'Ananthasagar,Hanamkonda,Andhra Pradesh',
'Bheemaram,Hanamkonda,Andhra Pradesh',
'Chintagattu,Hanamkonda,Andhra Pradesh',
'Devannapet,Hanamkonda,Andhra Pradesh',
'Devnoor,Hanamkonda,Andhra Pradesh',
'Hasanparthy,Hanamkonda,Andhra Pradesh',
'Jayagiri,Hanamkonda,Andhra Pradesh',
'K C Colony,Hanamkonda,Andhra Pradesh',
'Madipalli,Hanamkonda,Andhra Pradesh',
'Mucherla,Hanamkonda,Andhra Pradesh',
'Nagaram,Hanamkonda,Andhra Pradesh',
'Pegadapalli,Hanamkonda,Andhra Pradesh',
'Pembarthy,Hanamkonda,Andhra Pradesh',
'Seethampet,Hanamkonda,Andhra Pradesh',
'Vangapahad,Warangal,Andhra Pradesh',
'Siddapur,Warangal,Andhra Pradesh',
'Chitakodur,Hanamkonda,Andhra Pradesh',
'Gangupahad,Hanamkonda,Andhra Pradesh',
'Jangaon Bazar,Hanamkonda,Andhra Pradesh',
'Jangaon H.O,Hanamkonda,Andhra Pradesh',
'Marigadi,Hanamkonda,Andhra Pradesh',
'Obulkeshavapur,Hanamkonda,Andhra Pradesh',
'Pasaramadla,Hanamkonda,Andhra Pradesh',
'Peddapahad,Hanamkonda,Andhra Pradesh',
'Peddaramancherla,Hanamkonda,Andhra Pradesh',
'Pembarthy,Hanamkonda,Andhra Pradesh',
'Shamirpet,Hanamkonda,Andhra Pradesh',
'Siddanki,Hanamkonda,Andhra Pradesh',
'Vadlakonda,Hanamkonda,Andhra Pradesh',
'Yellamula,Hanamkonda,Andhra Pradesh',
'Yenkiryal,Hanamkonda,Andhra Pradesh',
'Yerragolla Pahad,Hanamkonda,Andhra Pradesh',
'Yeswantapur,Hanamkonda,Andhra Pradesh',
'Karkala,Warangal,Andhra Pradesh',
'Korepalli,Warangal,Andhra Pradesh',
'Alankhanipet,Warangal,Andhra Pradesh',
'Chinnagaram,Warangal,Andhra Pradesh',
'Dhansari,Warangal,Andhra Pradesh',
'Ingurthy,Warangal,Andhra Pradesh',
'Intikanne,Warangal,Andhra Pradesh',
'Kalvala,Warangal,Andhra Pradesh',
'Katrepalli,Warangal,Andhra Pradesh',
'Kesamudram,Warangal,Andhra Pradesh',
'Kesamudram Town,Warangal,Andhra Pradesh',
'Komatipalli,Warangal,Andhra Pradesh',
'Korukondapalli,Warangal,Andhra Pradesh',
'Mupparamkurd,Warangal,Andhra Pradesh',
'Naikpalli,Warangal,Andhra Pradesh',
'Peddakorpole,Warangal,Andhra Pradesh',
'Rajanpalli,Warangal,Andhra Pradesh',
'Teegalavenii,Warangal,Andhra Pradesh',
'Upparapalli,Warangal,Andhra Pradesh',
'Chityal,Warangal,Andhra Pradesh',
'Gantlakunta,Warangal,Andhra Pradesh',
'Laxmakkapalli,Hanamkonda,Andhra Pradesh',
'Mondrai,Hanamkonda,Andhra Pradesh',
'Mutharam,Warangal,Andhra Pradesh',
'Rangapur,Warangal,Andhra Pradesh',
'Kodakondla,Warangal,Andhra Pradesh',
'Manchuppal,Warangal,Andhra Pradesh',
'Pakhal,Warangal,Andhra Pradesh',
'Waddekothapally,Warangal,Andhra Pradesh',
'Walmidi,Warangal,Andhra Pradesh',
'Bhathulapalli,Warangal,Andhra Pradesh',
'Edulapalli,Warangal,Andhra Pradesh',
'Gangaram,Warangal,Andhra Pradesh',
'Inchaguda,Warangal,Andhra Pradesh',
'Jangamvarigudem,Warangal,Andhra Pradesh',
'Komatlagudem,Warangal,Andhra Pradesh',
'Kothaguda,Warangal,Andhra Pradesh',
'Madaguda,Warangal,Andhra Pradesh',
'Marrigudem,Warangal,Andhra Pradesh',
'Musmi,Warangal,Andhra Pradesh',
'Ootai,Warangal,Andhra Pradesh',
'Pogullapalli,Warangal,Andhra Pradesh',
'Punugondla,Warangal,Andhra Pradesh',
'Sadireddipalli,Warangal,Andhra Pradesh',
'Velbelli,Warangal,Andhra Pradesh',
'Ayyagaripalli,Warangal,Andhra Pradesh',
'Bethole,Warangal,Andhra Pradesh',
'Chintapalli,Warangal,Andhra Pradesh',
'Kamepalli,Warangal,Andhra Pradesh',
'Kandikonda,Warangal,Andhra Pradesh',
'Kuravi,Warangal,Andhra Pradesh',
'Madapur,Warangal,Andhra Pradesh',
'Modugulaguda,Warangal,Andhra Pradesh',
'Mogilcherla,Warangal,Andhra Pradesh',
'Nallela,Warangal,Andhra Pradesh',
'Serole,Warangal,Andhra Pradesh',
'Sudenapalli,Warangal,Andhra Pradesh',
'Tallasankeesa,Warangal,Andhra Pradesh',
'Tattupalli,Warangal,Andhra Pradesh',
'Upparguda,Warangal,Andhra Pradesh',
'Gummadavalli,Hanamkonda,Andhra Pradesh',
'Jeedikal,Hanamkonda,Andhra Pradesh',
'Kothapalli,Hanamkonda,Andhra Pradesh',
'Lingala Ghanpur,Hanamkonda,Andhra Pradesh',
'Nellutla,Hanamkonda,Andhra Pradesh',
'Siripuram,Hanamkonda,Andhra Pradesh',
'Waddicherla Nawabpet,Hanamkonda,Andhra Pradesh',
'Cheetur,Hanamkonda,Andhra Pradesh',
'Kalyam,Hanamkonda,Andhra Pradesh',
'Kundaram,Hanamkonda,Andhra Pradesh',
'Nelapogula,Hanamkonda,Andhra Pradesh',
'Waddicherla,Hanamkonda,Andhra Pradesh',
'Wanaparthy,Hanamkonda,Andhra Pradesh',
'Arjunpatla,Hanamkonda,Andhra Pradesh',
'Bhairanpalli,Hanamkonda,Andhra Pradesh',
'Bikkal,Hanamkonda,Andhra Pradesh',
'Dharmaram,Hanamkonda,Andhra Pradesh',
'Dhulmitta,Hanamkonda,Andhra Pradesh',
'Gagillapur,Hanamkonda,Andhra Pradesh',
'Jalapalli,Hanamkonda,Andhra Pradesh',
'Kondapur,Hanamkonda,Andhra Pradesh',
'Kootigal,Hanamkonda,Andhra Pradesh',
'Ladnoor,Hanamkonda,Andhra Pradesh',
'Lingapur,Hanamkonda,Andhra Pradesh',
'Maddur,Hanamkonda,Andhra Pradesh',
'Marmamul,Hanamkonda,Andhra Pradesh',
'Narsaipalli,Hanamkonda,Andhra Pradesh',
'Rebarthy,Hanamkonda,Andhra Pradesh',
'Salakpur,Hanamkonda,Andhra Pradesh',
'Vallampatla,Hanamkonda,Andhra Pradesh',
'Alair,Warangal,Andhra Pradesh',
'Mahabubabad H.O,Warangal,Andhra Pradesh',
'Mahabubabad,Warangal,Andhra Pradesh',
'Mudupugal,Warangal,Andhra Pradesh',
'New Abadi,Warangal,Andhra Pradesh',
'Amangala,Warangal,Andhra Pradesh',
'Anantharam,Warangal,Andhra Pradesh',
'Annaram,Warangal,Andhra Pradesh',
'Apparajpalli,Warangal,Andhra Pradesh',
'Bheriwada,Warangal,Andhra Pradesh',
'Buddugonda,Warangal,Andhra Pradesh',
'Edulapoosalapalli,Warangal,Andhra Pradesh',
'Gundrathimadugu,Warangal,Andhra Pradesh',
'Jamandlapalli,Warangal,Andhra Pradesh',
'Kambalapalli,Warangal,Andhra Pradesh',
'Kollapur,Warangal,Andhra Pradesh',
'Kothareddial,Warangal,Andhra Pradesh',
'Mallial,Warangal,Andhra Pradesh',
'Matwada,Warangal,Andhra Pradesh',
'Nadiwada,Warangal,Andhra Pradesh',
'Penugonda,Warangal,Andhra Pradesh',
'Rajole,Warangal,Andhra Pradesh',
'Reddial,Warangal,Andhra Pradesh',
'Stn. Gundrathimadugu,Warangal,Andhra Pradesh',
'Tadlapoosalapalli,Warangal,Andhra Pradesh',
'Vavilala,Warangal,Andhra Pradesh',
'Vemnoor,Warangal,Andhra Pradesh',
'Akinepalli Mallaram,Hanamkonda,Andhra Pradesh',
'Borenarsapur,Hanamkonda,Andhra Pradesh',
'Brahmanpalli,Hanamkonda,Andhra Pradesh',
'Buchannapet,Hanamkonda,Andhra Pradesh',
'Cherupalli,Hanamkonda,Andhra Pradesh',
'Chunchupalli,Hanamkonda,Andhra Pradesh',
'Domeda,Hanamkonda,Andhra Pradesh',
'Kamalapur Town Ship,Hanamkonda,Andhra Pradesh',
'Kathigudem,Hanamkonda,Andhra Pradesh',
'Komatipalli,Hanamkonda,Andhra Pradesh',
'Mallur,Hanamkonda,Andhra Pradesh',
'Mangapet,Hanamkonda,Andhra Pradesh',
'Narsimhasagar,Hanamkonda,Andhra Pradesh',
'Poredupalli,Hanamkonda,Andhra Pradesh',
'Rajupet,Hanamkonda,Andhra Pradesh',
'Ramachandrunipet,Hanamkonda,Andhra Pradesh',
'Ramanakkapet,Hanamkonda,Andhra Pradesh',
'Thimmampet,Hanamkonda,Andhra Pradesh',
'Vodagudem,Hanamkonda,Andhra Pradesh',
'Abbaipalem,Warangal,Andhra Pradesh',
'Anepur,Warangal,Andhra Pradesh',
'Bhavajigudem,Warangal,Andhra Pradesh',
'Burhanpur,Warangal,Andhra Pradesh',
'Chillamcherla,Warangal,Andhra Pradesh',
'Dharmaram,Warangal,Andhra Pradesh',
'Galivarigudem,Warangal,Andhra Pradesh',
'Gundepudi,Warangal,Andhra Pradesh',
'Maripeda (V),Warangal,Andhra Pradesh',
'Maripeda,Warangal,Andhra Pradesh',
'Neelkurthi,Warangal,Andhra Pradesh',
'Purushothamaigudem,Warangal,Andhra Pradesh',
'Rampur,Warangal,Andhra Pradesh',
'Tadla Ookal,Warangal,Andhra Pradesh',
'Thanamcherla,Warangal,Andhra Pradesh',
'Uggampalli,Warangal,Andhra Pradesh',
'Veeram,Warangal,Andhra Pradesh',
'Yellampet,Warangal,Andhra Pradesh',
'Yerjerla,Warangal,Andhra Pradesh',
'Akinepalli,Hanamkonda,Andhra Pradesh',
'Dubyal,Hanamkonda,Andhra Pradesh',
'Issipet,Hanamkonda,Andhra Pradesh',
'Metpalli,Hanamkonda,Andhra Pradesh',
'Mogullapalli,Hanamkonda,Andhra Pradesh',
'Motlapalli,Hanamkonda,Andhra Pradesh',
'Parlapalli,Hanamkonda,Andhra Pradesh',
'Peddakomati Palli,Hanamkonda,Andhra Pradesh',
'Pidicilla,Hanamkonda,Andhra Pradesh',
'Pothugal,Hanamkonda,Andhra Pradesh',
'Raghavareddipet,Hanamkonda,Andhra Pradesh',
'Rangapur,Hanamkonda,Andhra Pradesh',
'Vemulapalli,Hanamkonda,Andhra Pradesh',
'Mulkalapally,Hanamkonda,Andhra Pradesh',
'Abbapur,Hanamkonda,Andhra Pradesh',
'Ankannagudem,Hanamkonda,Andhra Pradesh',
'Bandarupalli,Hanamkonda,Andhra Pradesh',
'Devagiripatnam,Hanamkonda,Andhra Pradesh',
'Inchencherupalli,Hanamkonda,Andhra Pradesh',
'Incherla,Hanamkonda,Andhra Pradesh',
'Jaggannapet,Hanamkonda,Andhra Pradesh',
'Jakaram,Hanamkonda,Andhra Pradesh',
'Jangalapally,Hanamkonda,Andhra Pradesh',
'Kannaigudem,Hanamkonda,Andhra Pradesh',
'Kasimdevipet,Hanamkonda,Andhra Pradesh',
'Kothur,Hanamkonda,Andhra Pradesh',
'Madanpalli,Hanamkonda,Andhra Pradesh',
'Mallampalli,Hanamkonda,Andhra Pradesh',
'Mohd.Gouspalli,Hanamkonda,Andhra Pradesh',
'Mulug,Hanamkonda,Andhra Pradesh',
'Pathipalli,Hanamkonda,Andhra Pradesh',
'Ramachandrapuram,Hanamkonda,Andhra Pradesh',
'Sarvapur,Hanamkonda,Andhra Pradesh',
'Bollonipalli,Hanamkonda,Andhra Pradesh',
'Nallabelli,Hanamkonda,Andhra Pradesh',
'Pandikunta,Hanamkonda,Andhra Pradesh',
'Rangapur,Hanamkonda,Andhra Pradesh',
'Rudragudem,Hanamkonda,Andhra Pradesh',
'Shanigaram,Hanamkonda,Andhra Pradesh',
'Relakunta,Hanamkonda,Andhra Pradesh',
'Ravirala,Warangal,Andhra Pradesh',
'Madanthurthi,Warangal,Andhra Pradesh',
'Mecharajpalli,Warangal,Andhra Pradesh',
'Mungalveedu,Warangal,Andhra Pradesh',
'Nainala,Warangal,Andhra Pradesh',
'Nallikaddur,Warangal,Andhra Pradesh',
'Rajulakothapalli,Warangal,Andhra Pradesh',
'Sriramgiri,Warangal,Andhra Pradesh',
'Yerrabelligudem,Warangal,Andhra Pradesh',
'Agapet,Warangal,Andhra Pradesh',
'Bodlada,Warangal,Andhra Pradesh',
'Brahmanakothapalli,Warangal,Andhra Pradesh',
'Datla,Warangal,Andhra Pradesh',
'Gunnepalli,Warangal,Andhra Pradesh',
'Jaipur,Warangal,Andhra Pradesh',
'Kommulavancha,Warangal,Andhra Pradesh',
'Mungimadugu,Warangal,Andhra Pradesh',
'Nagaram,Warangal,Andhra Pradesh',
'Narasimulapet,Warangal,Andhra Pradesh',
'Reponi,Warangal,Andhra Pradesh',
'Vanthadapala,Warangal,Andhra Pradesh',
'Akkarajpalli,Hanamkonda,Andhra Pradesh',
'Ammapur,Hanamkonda,Andhra Pradesh',
'Ankushapur,Hanamkonda,Andhra Pradesh',
'Manchupahad,Hanamkonda,Andhra Pradesh',
'Narmetta,Hanamkonda,Andhra Pradesh',
'Veldanda,Hanamkonda,Andhra Pradesh',
'Abdulnagaram,Hanamkonda,Andhra Pradesh',
'Hanumanthapur,Hanamkonda,Andhra Pradesh',
'Narsapur,Hanamkonda,Andhra Pradesh',
'Solipuram,Hanamkonda,Andhra Pradesh',
'Tharigoppula,Hanamkonda,Andhra Pradesh',
'Ashoknagar,Warangal,Andhra Pradesh',
'Bhanjipet,Warangal,Andhra Pradesh',
'Dabeerpet,Warangal,Andhra Pradesh',
'Dwarakapet,Warangal,Andhra Pradesh',
'Govindapur,Warangal,Andhra Pradesh',
'Gundalpahad,Warangal,Andhra Pradesh',
'Itikalapalli,Warangal,Andhra Pradesh',
'Kammepalli,Warangal,Andhra Pradesh',
'Khanapur,Warangal,Andhra Pradesh',
'Kothur,Warangal,Andhra Pradesh',
'Laknepalli,Warangal,Andhra Pradesh',
'Madannapet,Warangal,Andhra Pradesh',
'Maheshwaram,Warangal,Andhra Pradesh',
'Medapalli,Warangal,Andhra Pradesh',
'Muthojipet,Warangal,Andhra Pradesh',
'Narakkapet,Warangal,Andhra Pradesh',
'Narsampet,Warangal,Andhra Pradesh',
'Dantalapalli,Warangal,Andhra Pradesh',
'Peddavangara,Warangal,Andhra Pradesh',
'Beersettigudem,Warangal,Andhra Pradesh',
'Kummarikunta,Warangal,Andhra Pradesh',
'Mupparamkalan,Warangal,Andhra Pradesh',
'Chengapur,Warangal,Andhra Pradesh',
'Gudur,Warangal,Andhra Pradesh',
'Gundamrajpalli,Warangal,Andhra Pradesh',
'Jangligonda,Warangal,Andhra Pradesh',
'Jayyaram,Warangal,Andhra Pradesh',
'Kousalyadevipalli,Warangal,Andhra Pradesh',
'Narasimlaguda,Warangal,Andhra Pradesh',
'Neerada,Warangal,Andhra Pradesh',
'Parvathagiri,Warangal,Andhra Pradesh',
'Singaram,Warangal,Andhra Pradesh',
'Ameenabad,Warangal,Andhra Pradesh',
'Appalraopet,Warangal,Andhra Pradesh',
'Chandrugonda,Warangal,Andhra Pradesh',
'Chintanekkonda,Warangal,Andhra Pradesh',
'Deekshakunta,Warangal,Andhra Pradesh',
'Engal,Warangal,Andhra Pradesh',
'Jhalli,Warangal,Andhra Pradesh',
'Lingagiri,Warangal,Andhra Pradesh',
'Mudigonda,Warangal,Andhra Pradesh',
'Nagaram,Warangal,Andhra Pradesh',
'Nekkonda,Warangal,Andhra Pradesh',
'Soorpalli,Warangal,Andhra Pradesh',
'Topanapalli,Warangal,Andhra Pradesh',
'Upparapalli,Warangal,Andhra Pradesh',
'Bommera,Hanamkonda,Andhra Pradesh',
'Chennur,Warangal,Andhra Pradesh',
'Edunuthala,Warangal,Andhra Pradesh',
'Gopanpalli,Warangal,Andhra Pradesh',
'Gudur,Hanamkonda,Andhra Pradesh',
'Iravennur,Hanamkonda,Andhra Pradesh',
'Kantharamavaram,Warangal,Andhra Pradesh',
'Konkapaka,Warangal,Andhra Pradesh',
'Palakurthy,Hanamkonda,Andhra Pradesh',
'Shatapur,Hanamkonda,Andhra Pradesh',
'Somaram,Warangal,Andhra Pradesh',
'Torrur,Hanamkonda,Andhra Pradesh',
'Visnoor,Warangal,Andhra Pradesh',
'Cherlapalli,Hanamkonda,Andhra Pradesh',
'Chowtaparthy,Hanamkonda,Andhra Pradesh',
'Kamareddipalli,Hanamkonda,Andhra Pradesh',
'Kantatmakur,Hanamkonda,Andhra Pradesh',
'Kowkonda,Hanamkonda,Andhra Pradesh',
'Laxmipur,Hanamkonda,Andhra Pradesh',
'Nagaram,Hanamkonda,Andhra Pradesh',
'Narlapur,Hanamkonda,Andhra Pradesh',
'Narsakkapalli,Hanamkonda,Andhra Pradesh',
'Parkal H.O,Hanamkonda,Andhra Pradesh',
'Puligilla,Hanamkonda,Andhra Pradesh',
'Raiparthy,Hanamkonda,Andhra Pradesh',
'Varikol,Hanamkonda,Andhra Pradesh',
'Vellampalli,Hanamkonda,Andhra Pradesh',
'Annaram,Warangal,Andhra Pradesh',
'Rollakal,Warangal,Andhra Pradesh',
'Wadlakonda,Warangal,Andhra Pradesh',
'Burgumadla,Warangal,Andhra Pradesh',
'Choutapalli,Warangal,Andhra Pradesh',
'Kalleda,Warangal,Andhra Pradesh',
'Parwathagiri,Warangal,Andhra Pradesh',
'Saireddipalli,Warangal,Andhra Pradesh',
'Aswaraopalli,Hanamkonda,Andhra Pradesh',
'Banjipet,Hanamkonda,Andhra Pradesh',
'Fatheshapur,Hanamkonda,Andhra Pradesh',
'Gabbeta,Hanamkonda,Andhra Pradesh',
'Ibrahimpur,Hanamkonda,Andhra Pradesh',
'Kanchanpalli,Hanamkonda,Andhra Pradesh',
'Komandla,Hanamkonda,Andhra Pradesh',
'Kurchapalli,Hanamkonda,Andhra Pradesh',
'Mandelagudem,Hanamkonda,Andhra Pradesh',
'Mekhal Ghat,Hanamkonda,Andhra Pradesh',
'Narayanpur,Hanamkonda,Andhra Pradesh',
'Quilashapur,Hanamkonda,Andhra Pradesh',
'Veldi,Hanamkonda,Andhra Pradesh',
'Raghunath Pally,Hanamkonda,Andhra Pradesh',
'Nidigonda,Hanamkonda,Andhra Pradesh',
'Thirumalaipalli,Warangal,Andhra Pradesh',
'Katrepalli,Warangal,Andhra Pradesh',
'Keshavapur,Warangal,Andhra Pradesh',
'Kolanpalli,Warangal,Andhra Pradesh',
'Kondapur,Warangal,Andhra Pradesh',
'Kondur,Warangal,Andhra Pradesh',
'Kothur,Warangal,Andhra Pradesh',
'Muripirala,Warangal,Andhra Pradesh',
'Mylaram,Warangal,Andhra Pradesh',
'Ookal Raiparthy,Warangal,Andhra Pradesh',
'Perkaveid,Warangal,Andhra Pradesh',
'Raiparthy,Warangal,Andhra Pradesh',
'Redlawada,Warangal,Andhra Pradesh',
'Bhagirathipet,Hanamkonda,Andhra Pradesh',
'Chinnakodepak,Hanamkonda,Andhra Pradesh',
'Dammannapet,Hanamkonda,Andhra Pradesh',
'Jaggaiahpet,Hanamkonda,Andhra Pradesh',
'Kaniparthy (Ch),Hanamkonda,Andhra Pradesh',
'Kodavatancha,Hanamkonda,Andhra Pradesh',
'Kothapalli (G),Hanamkonda,Andhra Pradesh',
'Lingal,Hanamkonda,Andhra Pradesh',
'Madthapalli,Hanamkonda,Andhra Pradesh',
'Ramannagudem,Hanamkonda,Andhra Pradesh',
'Rangaiahpalli,Hanamkonda,Andhra Pradesh',
'Regonda,Hanamkonda,Andhra Pradesh',
'Repak,Hanamkonda,Andhra Pradesh',
'Repakpalli,Hanamkonda,Andhra Pradesh',
'Sultanpur,Hanamkonda,Andhra Pradesh',
'Tirumalagiri,Hanamkonda,Andhra Pradesh',
'Elgur,Warangal,Andhra Pradesh',
'Sangem,Warangal,Andhra Pradesh',
'Ashalapalli,Warangal,Andhra Pradesh',
'Bollikunta,Warangal,Andhra Pradesh',
'Gadepalli,Warangal,Andhra Pradesh',
'Gavicherla,Warangal,Andhra Pradesh',
'Kapulakanparthy,Warangal,Andhra Pradesh',
'Teegarajpalli,Warangal,Andhra Pradesh',
'Chintalapalli,Warangal,Andhra Pradesh',
'Katrepalli,Warangal,Andhra Pradesh',
'Lohitha,Warangal,Andhra Pradesh',
'Mondrai,Warangal,Andhra Pradesh',
'Pallarguda,Warangal,Andhra Pradesh',
'Venkatapur Haveli,Warangal,Andhra Pradesh',
'Dongalasingaram,Hanamkonda,Andhra Pradesh',
'Gangireni Gudem,Hanamkonda,Andhra Pradesh',
'Gatlakaniparthy,Hanamkonda,Andhra Pradesh',
'Hussainpalli,Hanamkonda,Andhra Pradesh',
'Katrepalli,Hanamkonda,Andhra Pradesh',
'Koppula,Hanamkonda,Andhra Pradesh',
'Kothagattu Singaram,Hanamkonda,Andhra Pradesh',
'Neredupalli,Hanamkonda,Andhra Pradesh',
'Pathipak,Hanamkonda,Andhra Pradesh',
'Peddakodepak,Hanamkonda,Andhra Pradesh',
'Shayampet,Hanamkonda,Andhra Pradesh',
'Taharapur,Hanamkonda,Andhra Pradesh',
'Nadikuda,Hanamkonda,Andhra Pradesh',
'Beeravelli,Hanamkonda,Andhra Pradesh',
'Bittupalli,Hanamkonda,Andhra Pradesh',
'Kalvapalli,Hanamkonda,Andhra Pradesh',
'Kamaram,Hanamkonda,Andhra Pradesh',
'Katapur,Hanamkonda,Andhra Pradesh',
'Lingala,Hanamkonda,Andhra Pradesh',
'Narlapur,Hanamkonda,Andhra Pradesh',
'Narsapur(Bore),Hanamkonda,Andhra Pradesh',
'Oorattam,Hanamkonda,Andhra Pradesh',
'Pambapur,Hanamkonda,Andhra Pradesh',
'Rampur,Hanamkonda,Andhra Pradesh',
'Rangapur Project Nagar,Hanamkonda,Andhra Pradesh',
'Tadvai,Hanamkonda,Andhra Pradesh',
'Haripirala,Warangal,Andhra Pradesh',
'Ammapur,Warangal,Andhra Pradesh',
'Authapur,Warangal,Andhra Pradesh',
'Cheralpalem,Warangal,Andhra Pradesh',
'Chinnavangara,Warangal,Andhra Pradesh',
'Fathepur,Warangal,Andhra Pradesh',
'Gurthur,Warangal,Andhra Pradesh',
'Kantaipalem,Warangal,Andhra Pradesh',
'Madhupalli\',Warangal,Andhra Pradesh',
'Mallampally,Warangal,Andhra Pradesh',
'Matair,Warangal,Andhra Pradesh',
'Nancharimadur,Warangal,Andhra Pradesh',
'Pochampalli,Warangal,Andhra Pradesh',
'Regula,Warangal,Andhra Pradesh',
'Sannur,Warangal,Andhra Pradesh',
'Turrur,Warangal,Andhra Pradesh',
'Vavila,Warangal,Andhra Pradesh',
'Venkatapur,Warangal,Andhra Pradesh',
'Yelkatte,Warangal,Andhra Pradesh',
'Gurrampaet,Hanamkonda,Andhra Pradesh',
'Keshavapur,Hanamkonda,Andhra Pradesh',
'Laxmidevipet,Hanamkonda,Andhra Pradesh',
'Nallakunta,Hanamkonda,Andhra Pradesh',
'Narsapur,Hanamkonda,Andhra Pradesh',
'Palampet,Hanamkonda,Andhra Pradesh',
'Peddapur,Hanamkonda,Andhra Pradesh',
'Venkatapur,Hanamkonda,Andhra Pradesh',
'Beat Bazar,Warangal,Andhra Pradesh',
'D H Suthoon,Hanamkonda,Andhra Pradesh',
'Deshaipet,Warangal,Andhra Pradesh',
'Fatimanagar,Hanamkonda,Andhra Pradesh',
'Fort Warangal,Warangal,Andhra Pradesh',
'Gollabudharam,Hanamkonda,Andhra Pradesh',
'Grainmarket,Warangal,Andhra Pradesh',
'Industrial Estate,Warangal,Andhra Pradesh',
'K.M.College,Warangal,Andhra Pradesh',
'Karimabad,Warangal,Andhra Pradesh',
'Kasibugga,Warangal,Andhra Pradesh',
'Kazipet,Hanamkonda,Andhra Pradesh',
'Lashkar Bazar,Hanamkonda,Andhra Pradesh',
'Laxmipur,Warangal,Andhra Pradesh',
'M.G.M Hospital,Warangal,Andhra Pradesh',
'Mahathma Gandhi Road,Warangal,Andhra Pradesh',
'Mandi Bazar,Warangal,Andhra Pradesh',
'Matwada,Warangal,Andhra Pradesh',
'Naimnagar,Hanamkonda,Andhra Pradesh',
'Pragathi Industrial Estate,Warangal,Andhra Pradesh',
'R E College,Hanamkonda,Andhra Pradesh',
'Railway Gate,Warangal,Andhra Pradesh',
'Rangshaipet,Warangal,Andhra Pradesh',
'Reddicolony,Hanamkonda,Andhra Pradesh',
'Shivnagar,Warangal,Andhra Pradesh',
'Subedari,Hanamkonda,Andhra Pradesh',
'Svn Road,Warangal,Andhra Pradesh',
'Urus Jagir,Warangal,Andhra Pradesh',
'Warangal H.O,Warangal,Andhra Pradesh',
'Aanole,Warangal,Andhra Pradesh',
'Bandouthapur,Warangal,Andhra Pradesh',
'Chennaram,Warangal,Andhra Pradesh',
'Kakkiralapalli,Warangal,Andhra Pradesh',
'Katrial,Warangal,Andhra Pradesh',
'Liabarthy,Warangal,Andhra Pradesh',
'Nallballi,Warangal,Andhra Pradesh',
'Nandanam,Warangal,Andhra Pradesh',
'Ontimamidipalli,Warangal,Andhra Pradesh',
'Panthani,Warangal,Andhra Pradesh',
'Punnel,Warangal,Andhra Pradesh',
'Reddipalem,Warangal,Andhra Pradesh',
'Singaram,Warangal,Andhra Pradesh',
'Wardhannapet,Warangal,Andhra Pradesh',
'Yellanda,Warangal,Andhra Pradesh',
'Upparapalli,Warangal,Andhra Pradesh',
'Thimmampet,Hanamkonda,Andhra Pradesh',
'Kunur,Hanamkonda,Andhra Pradesh',
'Raghunathpalli,Hanamkonda,Andhra Pradesh',
'Garmillapalli,Hanamkonda,Andhra Pradesh',
'Teegaram,Hanamkonda,Andhra Pradesh',
'Thammadapalli,Hanamkonda,Andhra Pradesh',
'Uppugal,Hanamkonda,Andhra Pradesh',
'Venkatapur,Hanamkonda,Andhra Pradesh',
'Timmapuram,Warangal,Andhra Pradesh',
'Dammannapet,Warangal,Andhra Pradesh',
'Dardepalli,Warangal,Andhra Pradesh',
'Kondapur,Warangal,Andhra Pradesh',
'Oblapur,Warangal,Andhra Pradesh',
'Sagaram,Warangal,Andhra Pradesh',
'Thammadapalli,Warangal,Andhra Pradesh',
'Zaffargadh,Warangal,Andhra Pradesh',
'Abbiraju Palem,Bhimavaram,Andhra Pradesh',
'Aibhimavaram,Bhimavaram,Andhra Pradesh',
'Ainaparru,Bhimavaram,Andhra Pradesh',
'Akanivarithota,Bhimavaram,Andhra Pradesh',
'Alamuru,Bhimavaram,Andhra Pradesh',
'Andaluru,Bhimavaram,Andhra Pradesh',
'Ankoderu,Bhimavaram,Andhra Pradesh',
'Annavaram,Bhimavaram,Andhra Pradesh',
'Annavarappadu,Bhimavaram,Andhra Pradesh',
'Apparaopeta,Bhimavaram,Andhra Pradesh',
'Aratlakatta,Bhimavaram,Andhra Pradesh',
'Arjunudupalem,Bhimavaram,Andhra Pradesh',
'Arthamuru,Bhimavaram,Andhra Pradesh',
'Ayodhya Lanka,Bhimavaram,Andhra Pradesh',
'Bantummili,Bhimavaram,Andhra Pradesh',
'Bethapudi,Bhimavaram,Andhra Pradesh',
'Bhatlamaguturu,Bhimavaram,Andhra Pradesh',
'Bhimala Puram,Bhimavaram,Andhra Pradesh',
'Bondada,Bhimavaram,Andhra Pradesh',
'Brahmanacheruvu,Bhimavaram,Andhra Pradesh',
'Burugupalli,Bhimavaram,Andhra Pradesh',
'Cherukumilli,Bhimavaram,Andhra Pradesh',
'Cheurkuwada,Bhimavaram,Andhra Pradesh',
'Chilakapadu,Bhimavaram,Andhra Pradesh',
'Chilukuru,Bhimavaram,Andhra Pradesh',
'China-amiram,Bhimavaram,Andhra Pradesh',
'Chinagolla Palem,Bhimavaram,Andhra Pradesh',
'Chinakapavaram,Bhimavaram,Andhra Pradesh',
'Chinamallam,Bhimavaram,Andhra Pradesh',
'Chinamallipadu,Bhimavaram,Andhra Pradesh',
'Chinchinada,Bhimavaram,Andhra Pradesh',
'Chintaparru,Bhimavaram,Andhra Pradesh',
'Chittavaram,Bhimavaram,Andhra Pradesh',
'Chivatam,Bhimavaram,Andhra Pradesh',
'Dagguluru,Bhimavaram,Andhra Pradesh',
'Dammmennu,Bhimavaram,Andhra Pradesh',
'Darabharevu,Bhimavaram,Andhra Pradesh',
'Deva,Bhimavaram,Andhra Pradesh',
'Deyyalatippa,Bhimavaram,Andhra Pradesh',
'Doddanapudi,Bhimavaram,Andhra Pradesh',
'Dongaravipalem,Bhimavaram,Andhra Pradesh',
'Dumpagadapa,Bhimavaram,Andhra Pradesh',
'Dusanapudi,Bhimavaram,Andhra Pradesh',
'East Vipparru,Bhimavaram,Andhra Pradesh',
'Eletipadu,Bhimavaram,Andhra Pradesh',
'Ellamanchili Lanka,Bhimavaram,Andhra Pradesh',
'Enamadurru,Bhimavaram,Andhra Pradesh',
'Gavarlapalem,Bhimavaram,Andhra Pradesh',
'Gollalakoderu,Bhimavaram,Andhra Pradesh',
'Gollavanitippa,Bhimavaram,Andhra Pradesh',
'Goraganamudi,Bhimavaram,Andhra Pradesh',
'Goteru,Bhimavaram,Andhra Pradesh',
'Gummampadu,Bhimavaram,Andhra Pradesh',
'Gummuluru,Bhimavaram,Andhra Pradesh',
'Gumparru,Bhimavaram,Andhra Pradesh',
'Ilapakurru,Bhimavaram,Andhra Pradesh',
'Ilaparru,Bhimavaram,Andhra Pradesh',
'Jagannadhapurami,Bhimavaram,Andhra Pradesh',
'Jakkaram,Bhimavaram,Andhra Pradesh',
'Jonnalapalem,Bhimavaram,Andhra Pradesh',
'Juttiga,Bhimavaram,Andhra Pradesh',
'Juvvalapalem,Bhimavaram,Andhra Pradesh',
'K.Illindalaparru,Bhimavaram,Andhra Pradesh',
'Kakileru,Bhimavaram,Andhra Pradesh',
'Kalagam Pudi,Bhimavaram,Andhra Pradesh',
'Kalavapudi,Bhimavaram,Andhra Pradesh',
'Kalipatnam,Bhimavaram,Andhra Pradesh',
'Kalisipudi,Bhimavaram,Andhra Pradesh',
'Kallakuru,Bhimavaram,Andhra Pradesh',
'Kanchumarru,Bhimavaram,Andhra Pradesh',
'Kannai Kumudavalli,Bhimavaram,Andhra Pradesh',
'Kanteru,Bhimavaram,Andhra Pradesh',
'Kapavaram,Bhimavaram,Andhra Pradesh',
'Kapavaram,Bhimavaram,Andhra Pradesh',
'Karugorumilli,Bhimavaram,Andhra Pradesh',
'Kathavapadu,Bhimavaram,Andhra Pradesh',
'Kavalipuram,Bhimavaram,Andhra Pradesh',
'Koderu,Bhimavaram,Andhra Pradesh',
'Kolamuru,Bhimavaram,Andhra Pradesh',
'Kolanapalli,Bhimavaram,Andhra Pradesh',
'Kollaparru,Bhimavaram,Andhra Pradesh',
'Komarada,Bhimavaram,Andhra Pradesh',
'Komaravaram,Bhimavaram,Andhra Pradesh',
'Kommuchikkala,Bhimavaram,Andhra Pradesh',
'Kondepudi,Bhimavaram,Andhra Pradesh',
'Kopparru,Bhimavaram,Andhra Pradesh',
'Korukollu,Bhimavaram,Andhra Pradesh',
'Kothalaparru,Bhimavaram,Andhra Pradesh',
'Kothapadu,Bhimavaram,Andhra Pradesh',
'Kothapalli Agraharam,Bhimavaram,Andhra Pradesh',
'Koyyetipadu,Bhimavaram,Andhra Pradesh',
'Kummarapurugupalem,Bhimavaram,Andhra Pradesh',
'Kumudavalli,Bhimavaram,Andhra Pradesh',
'Kuppanapudi,Bhimavaram,Andhra Pradesh',
'Lakshmaneswaram,Bhimavaram,Andhra Pradesh',
'Lakshminarasimhapuram,Bhimavaram,Andhra Pradesh',
'Lakshminarayanapuram,Bhimavaram,Andhra Pradesh',
'Lingaboyinacherla,Bhimavaram,Andhra Pradesh',
'Losari-gutlapadu,Bhimavaram,Andhra Pradesh',
'Madapadu,Bhimavaram,Andhra Pradesh',
'Madugupolavaram,Bhimavaram,Andhra Pradesh',
'Mahadevapatnam,Bhimavaram,Andhra Pradesh',
'Mallavarm,Bhimavaram,Andhra Pradesh',
'Malleswaram,Bhimavaram,Andhra Pradesh',
'Mallipudi,Bhimavaram,Andhra Pradesh',
'Mamuduru,Bhimavaram,Andhra Pradesh',
'Matla Palem,Bhimavaram,Andhra Pradesh',
'Matsyapuri,Bhimavaram,Andhra Pradesh',
'Mattaparru,Bhimavaram,Andhra Pradesh',
'Military Colony,Bhimavaram,Andhra Pradesh',
'Miniminchilipadu,Bhimavaram,Andhra Pradesh',
'Mukkamala,Bhimavaram,Andhra Pradesh',
'Mulaparru,Bhimavaram,Andhra Pradesh',
'Munamarru,Bhimavaram,Andhra Pradesh',
'Mutyalapalli,Bhimavaram,Andhra Pradesh',
'Mutyalavaripalem,Bhimavaram,Andhra Pradesh',
'Mylavanilanka,Bhimavaram,Andhra Pradesh',
'N.R.P. Agraharam,Bhimavaram,Andhra Pradesh',
'Nadipudi,Bhimavaram,Andhra Pradesh',
'Narinameraka,Bhimavaram,Andhra Pradesh',
'Nattarameswaram,Bhimavaram,Andhra Pradesh',
'Navuduru,Bhimavaram,Andhra Pradesh',
'Neggipudi,Bhimavaram,Andhra Pradesh',
'Nelamuru,Bhimavaram,Andhra Pradesh',
'Nelapogula,Bhimavaram,Andhra Pradesh',
'Neredumilli,Bhimavaram,Andhra Pradesh',
'Palangi,Bhimavaram,Andhra Pradesh',
'Pamulaparru,Bhimavaram,Andhra Pradesh',
'Pandithavilluru,Bhimavaram,Andhra Pradesh',
'Panjavemavaram,Bhimavaram,Andhra Pradesh',
'Pasaladeevi,Bhimavaram,Andhra Pradesh',
'Peda-amiram,Bhimavaram,Andhra Pradesh',
'Pedagaruvu,Bhimavaram,Andhra Pradesh',
'Pedakapavaram,Bhimavaram,Andhra Pradesh',
'Pedamallam,Bhimavaram,Andhra Pradesh',
'Pedapulleru,Bhimavaram,Andhra Pradesh',
'Pekeru,Bhimavaram,Andhra Pradesh',
'Pemmaraju Polavaram,Bhimavaram,Andhra Pradesh',
'Pennada,Bhimavaram,Andhra Pradesh',
'Penumadam,Bhimavaram,Andhra Pradesh',
'Penumanchili,Bhimavaram,Andhra Pradesh',
'Penumarru,Bhimavaram,Andhra Pradesh',
'Perkipalem,Bhimavaram,Andhra Pradesh',
'Perupalem,Bhimavaram,Andhra Pradesh',
'Pidiparru,Bhimavaram,Andhra Pradesh',
'Pittalavemavarm,Bhimavaram,Andhra Pradesh',
'Podalada,Bhimavaram,Andhra Pradesh',
'Prakrutiashramam,Bhimavaram,Andhra Pradesh',
'Prathalameraka,Bhimavaram,Andhra Pradesh',
'Ramannapalem,Bhimavaram,Andhra Pradesh',
'Ramannapalem,Bhimavaram,Andhra Pradesh',
'Rapaka,Bhimavaram,Andhra Pradesh',
'Ravipadu,Bhimavaram,Andhra Pradesh',
'S.Illindalaparru,Bhimavaram,Andhra Pradesh',
'Saripalli,Bhimavaram,Andhra Pradesh',
'Satyavaram,Bhimavaram,Andhra Pradesh',
'Satyawada,Bhimavaram,Andhra Pradesh',
'Seethalm Kondepadu,Bhimavaram,Andhra Pradesh',
'Serepalem,Bhimavaram,Andhra Pradesh',
'Sidhapuram,Bhimavaram,Andhra Pradesh',
'Siragala Palli,Bhimavaram,Andhra Pradesh',
'Sisali,Bhimavaram,Andhra Pradesh',
'Sivadevunichikkala,Bhimavaram,Andhra Pradesh',
'Skinnerapuram,Bhimavaram,Andhra Pradesh',
'Surampudi,Bhimavaram,Andhra Pradesh',
'Taderu,Bhimavaram,Andhra Pradesh',
'Tadiparru,Bhimavaram,Andhra Pradesh',
'Tamarada,Bhimavaram,Andhra Pradesh',
'Tetali,Bhimavaram,Andhra Pradesh',
'Tillapudi,Bhimavaram,Andhra Pradesh',
'Tirupathipuram,Bhimavaram,Andhra Pradesh',
'Tokalapudi,Bhimavaram,Andhra Pradesh',
'Tokatippa,Bhimavaram,Andhra Pradesh',
'Toleru,Bhimavaram,Andhra Pradesh',
'Turputallu,Bhimavaram,Andhra Pradesh',
'Ulliamparru,Bhimavaram,Andhra Pradesh',
'Unikili,Bhimavaram,Andhra Pradesh',
'Uppuluru,Bhimavaram,Andhra Pradesh',
'Vadangi Palem,Bhimavaram,Andhra Pradesh',
'Vaddiparru,Bhimavaram,Andhra Pradesh',
'Vadlavani Palem,Bhimavaram,Andhra Pradesh',
'Vadluru,Bhimavaram,Andhra Pradesh',
'Valluru,Bhimavaram,Andhra Pradesh',
'Vandram,Bhimavaram,Andhra Pradesh',
'Vankayalapalem,Bhimavaram,Andhra Pradesh',
'Varighedu,Bhimavaram,Andhra Pradesh',
'Vedangi,Bhimavaram,Andhra Pradesh',
'Veerabhadrapuram,Bhimavaram,Andhra Pradesh',
'Velagaduuru,Bhimavaram,Andhra Pradesh',
'Velagalavariplalem,Bhimavaram,Andhra Pradesh',
'Velivela,Bhimavaram,Andhra Pradesh',
'Vempa,Bhimavaram,Andhra Pradesh',
'Vempadu,Bhimavaram,Andhra Pradesh',
'Vemuladeevi,Bhimavaram,Andhra Pradesh',
'Vendra,Bhimavaram,Andhra Pradesh',
'Venkata Puram,Bhimavaram,Andhra Pradesh',
'Venkatramapuram,Bhimavaram,Andhra Pradesh',
'Voduru,Bhimavaram,Andhra Pradesh',
'Yenuguvanilanka,Bhimavaram,Andhra Pradesh',
'Yeraih Cheruvu,Bhimavaram,Andhra Pradesh',
'Ravipadu,Tadepalligudem,Andhra Pradesh',
'Surya Rao Palem,Tadepalligudem,Andhra Pradesh',
'Vijjeswaram,Tadepalligudem,Andhra Pradesh',
'Akividu,Bhimavaram,Andhra Pradesh',
'Atchanta,Bhimavaram,Andhra Pradesh',
'Kodamanchili,Bhimavaram,Andhra Pradesh',
'Vemavaram,Bhimavaram,Andhra Pradesh',
'Aravalli,Bhimavaram,Andhra Pradesh',
'Attili H.O,Bhimavaram,Andhra Pradesh',
'Ballipadu,Bhimavaram,Andhra Pradesh',
'Eduru,Bhimavaram,Andhra Pradesh',
'K.Samudrapugattu,Bhimavaram,Andhra Pradesh',
'Komarru,Bhimavaram,Andhra Pradesh',
'Kommara,Bhimavaram,Andhra Pradesh',
'Mupparthipadu,Bhimavaram,Andhra Pradesh',
'Paluru,Bhimavaram,Andhra Pradesh',
'Bhimadole,Eluru,Andhra Pradesh',
'Challachintalapudi,Eluru,Andhra Pradesh',
'Gopalapuram,Eluru,Andhra Pradesh',
'Gunnampally,Eluru,Andhra Pradesh',
'M.Nagulapally,Eluru,Andhra Pradesh',
'Polasanipally,Eluru,Andhra Pradesh',
'R.Pangidigudem,Eluru,Andhra Pradesh',
'Surappagudem,Eluru,Andhra Pradesh',
'Rayalam,Bhimavaram,Andhra Pradesh',
'Bhimavaram Bazar,Bhimavaram,Andhra Pradesh',
'Bhimavaram H.O,Bhimavaram,Andhra Pradesh',
'Dirusumarru,Bhimavaram,Andhra Pradesh',
'Someswaralayam,Bhimavaram,Andhra Pradesh',
'Sreeramapuram,Bhimavaram,Andhra Pradesh',
'Bhimavaram Railway Colony,Bhimavaram,Andhra Pradesh',
'D.N.R.College,Bhimavaram,Andhra Pradesh',
'Sivaraopeta,Bhimavaram,Andhra Pradesh',
'Tundurru,Bhimavaram,Andhra Pradesh',
'Itikalakota,Tadepalligudem,Andhra Pradesh',
'Alivery,Eluru,Andhra Pradesh',
'Antervedigudem,Eluru,Andhra Pradesh',
'Buttayagudem,Eluru,Andhra Pradesh',
'Doramamidi,Eluru,Andhra Pradesh',
'Kommugudem,Eluru,Andhra Pradesh',
'Korasavarigudem,Eluru,Andhra Pradesh',
'Mangaiahpalem,Eluru,Andhra Pradesh',
'Mettagudem,Eluru,Andhra Pradesh',
'Muppinavarigudem,Eluru,Andhra Pradesh',
'Nimmalagudem,Eluru,Andhra Pradesh',
'Rachuru,Eluru,Andhra Pradesh',
'Ramannagudem,Eluru,Andhra Pradesh',
'Regulakunta,Eluru,Andhra Pradesh',
'Vippalapadu,Eluru,Andhra Pradesh',
'Reddinagampalem,Tadepalligudem,Andhra Pradesh',
'Chagallu,Tadepalligudem,Andhra Pradesh',
'Chikkala,Tadepalligudem,Andhra Pradesh',
'Mallavaram,Tadepalligudem,Andhra Pradesh',
'Unagatla,Tadepalligudem,Andhra Pradesh',
'Chandravaram,Tadepalligudem,Andhra Pradesh',
'Gudivakalanka,Eluru,Andhra Pradesh',
'Jalipudi,Eluru,Andhra Pradesh',
'Komadavole,Eluru,Andhra Pradesh',
'Prathikollanka,Eluru,Andhra Pradesh',
'Sriparru,Eluru,Andhra Pradesh',
'Chebrole,Eluru,Andhra Pradesh',
'Chinanindrakolanu,Eluru,Andhra Pradesh',
'Gollagudem,Eluru,Andhra Pradesh',
'Narayanapuram,Eluru,Andhra Pradesh',
'Rachuru,Eluru,Andhra Pradesh',
'Ravulaparru,Eluru,Andhra Pradesh',
'Thokalapally,Eluru,Andhra Pradesh',
'Balavarigudem,Eluru,Andhra Pradesh',
'Chintalapudi Cutchery,Eluru,Andhra Pradesh',
'Chintalapudi,Eluru,Andhra Pradesh',
'Kanthampalem,Eluru,Andhra Pradesh',
'Lingagudem,Eluru,Andhra Pradesh',
'Mallayagudem,Eluru,Andhra Pradesh',
'Pothunuru,Eluru,Andhra Pradesh',
'Racherla,Eluru,Andhra Pradesh',
'Ragavapuram,Eluru,Andhra Pradesh',
'Seethanagaram,Eluru,Andhra Pradesh',
'Utasamudram,Eluru,Andhra Pradesh',
'Venkatapuram,Eluru,Andhra Pradesh',
'Yendapalli,Eluru,Andhra Pradesh',
'Yerraguntapally,Eluru,Andhra Pradesh',
'APMC,Eluru,Andhra Pradesh',
'Dorasanipadu,Eluru,Andhra Pradesh',
'Dwaraka Tirumala,Eluru,Andhra Pradesh',
'East Yedavally,Eluru,Andhra Pradesh',
'Rallakunta,Eluru,Andhra Pradesh',
'Ramannagudem,Eluru,Andhra Pradesh',
'Tadicherla,Eluru,Andhra Pradesh',
'Timmapuram,Eluru,Andhra Pradesh',
'Tirumalampalem,Eluru,Andhra Pradesh',
'Venkatakrishnapuram,Eluru,Andhra Pradesh',
'Medinaraopalem,Eluru,Andhra Pradesh',
'Satynarayanapuram,Eluru,Andhra Pradesh',
'Sriramvaram,Eluru,Andhra Pradesh',
'Gowripatnam,Tadepalligudem,Andhra Pradesh',
'Bandapuram,Tadepalligudem,Andhra Pradesh',
'Krishnampalem,Tadepalligudem,Andhra Pradesh',
'Kurukuru,Tadepalligudem,Andhra Pradesh',
'Pallantla,Tadepalligudem,Andhra Pradesh',
'Ramannapalem,Tadepalligudem,Andhra Pradesh',
'Tyajampudi,Tadepalligudem,Andhra Pradesh',
'Yadavole,Tadepalligudem,Andhra Pradesh',
'Devarapalli,Tadepalligudem,Andhra Pradesh',
'Chinnayagudem,Tadepalligudem,Andhra Pradesh',
'Duddukuru,Tadepalligudem,Andhra Pradesh',
'Lakshmipuram,Tadepalligudem,Andhra Pradesh',
'Sangayagudem,Tadepalligudem,Andhra Pradesh',
'Yarnagudem,Tadepalligudem,Andhra Pradesh',
'Kutchuluru,Tadepalligudem,Andhra Pradesh',
'Talluru,Tadepalligudem,Andhra Pradesh',
'Kondamodaly,Tadepalligudem,Andhra Pradesh',
'Bhogole,Eluru,Andhra Pradesh',
'Dharmajigudem,Eluru,Andhra Pradesh',
'K.Gokavaram,Eluru,Andhra Pradesh',
'Kalarayanagudem,Eluru,Andhra Pradesh',
'Kothapally,Eluru,Andhra Pradesh',
'Mattamagudem,Eluru,Andhra Pradesh',
'Rangapuram,Eluru,Andhra Pradesh',
'Tch Rayudupalem,Eluru,Andhra Pradesh',
'Doddipatla,Bhimavaram,Andhra Pradesh',
'Ellamanchili,Bhimavaram,Andhra Pradesh',
'Ashok Nagar,Eluru,Andhra Pradesh',
'Benerjipeta,Eluru,Andhra Pradesh',
'Bhogapuram,Eluru,Andhra Pradesh',
'Chataparru,Eluru,Andhra Pradesh',
'Chodimella,Eluru,Andhra Pradesh',
'Denduluru,Eluru,Andhra Pradesh',
'Eluru Bazar,Eluru,Andhra Pradesh',
'Eluru Bus Station,Eluru,Andhra Pradesh',
'Eluru Collectorate,Eluru,Andhra Pradesh',
'Eluru H.O,Eluru,Andhra Pradesh',
'Eluru R.S,Eluru,Andhra Pradesh',
'Gandhinagaram,Eluru,Andhra Pradesh',
'Gopannapalem,Eluru,Andhra Pradesh',
'Gundugolanu So.,Eluru,Andhra Pradesh',
'Industrial Estate,Eluru,Andhra Pradesh',
'Kalaparru,Eluru,Andhra Pradesh',
'Kokkiripadu,Eluru,Andhra Pradesh',
'Kothuru,Eluru,Andhra Pradesh',
'Kovvali,Eluru,Andhra Pradesh',
'Malkapuram,Eluru,Andhra Pradesh',
'Mupparu,Eluru,Andhra Pradesh',
'Narasimharao Peta,Eluru,Andhra Pradesh',
'Old Bus Stand,Eluru,Andhra Pradesh',
'P&t Colony,Eluru,Andhra Pradesh',
'Pathebada,Eluru,Andhra Pradesh',
'Ponangi,Eluru,Andhra Pradesh',
'Power Peta,Eluru,Andhra Pradesh',
'Ramachandra Rao Peta,Eluru,Andhra Pradesh',
'Sanivarapu Peta,Eluru,Andhra Pradesh',
'Sb Colony,Eluru,Andhra Pradesh',
'Somavarapupadu,Eluru,Andhra Pradesh',
'Tangellamudi,Eluru,Andhra Pradesh',
'Vangayagudem,Eluru,Andhra Pradesh',
'Vanguru,Eluru,Andhra Pradesh',
'Venkata Rao Peta,Eluru,Andhra Pradesh',
'Westren Street,Eluru,Andhra Pradesh',
'Bhuvanapalli,Tadepalligudem,Andhra Pradesh',
'Chanamilli,Tadepalligudem,Andhra Pradesh',
'Kesavaram,Tadepalligudem,Andhra Pradesh',
'Pippara,Tadepalligudem,Andhra Pradesh',
'Adavikolanu,Tadepalligudem,Andhra Pradesh',
'Appannapeta,Tadepalligudem,Andhra Pradesh',
'Aredu,Tadepalligudem,Andhra Pradesh',
'Jallikakinada,Tadepalligudem,Andhra Pradesh',
'Kaligotla,Tadepalligudem,Andhra Pradesh',
'Kommara,Tadepalligudem,Andhra Pradesh',
'Kothapalli,Tadepalligudem,Andhra Pradesh',
'Krovvidi,Tadepalligudem,Andhra Pradesh',
'Panduvva,Tadepalligudem,Andhra Pradesh',
'Saripalli,Tadepalligudem,Andhra Pradesh',
'Vakapalli,Tadepalligudem,Andhra Pradesh',
'Velagapalli,Tadepalligudem,Andhra Pradesh',
'Yenikepalli,Tadepalligudem,Andhra Pradesh',
'A.Gopavaram,Tadepalligudem,Andhra Pradesh',
'Kasipadu,Tadepalligudem,Andhra Pradesh',
'Ardhavaram,Tadepalligudem,Andhra Pradesh',
'Muggalla,Tadepalligudem,Andhra Pradesh',
'Ganapavaram,Tadepalligudem,Andhra Pradesh',
'Valluru,Tadepalligudem,Andhra Pradesh',
'Gopalapuram,Tadepalligudem,Andhra Pradesh',
'Hukumpeta,Tadepalligudem,Andhra Pradesh',
'Bhimole,Tadepalligudem,Andhra Pradesh',
'Cherukumilli,Tadepalligudem,Andhra Pradesh',
'Chityala,Tadepalligudem,Andhra Pradesh',
'Dondapudi,Tadepalligudem,Andhra Pradesh',
'Gopavaram,Tadepalligudem,Andhra Pradesh',
'Guddigudem,Tadepalligudem,Andhra Pradesh',
'Karagapadu,Tadepalligudem,Andhra Pradesh',
'Kovvurupadu,Tadepalligudem,Andhra Pradesh',
'Lnd Peta,Tadepalligudem,Andhra Pradesh',
'Nandigudem,Tadepalligudem,Andhra Pradesh',
'Rampalem,Tadepalligudem,Andhra Pradesh',
'V.Ch.Gudem,Tadepalligudem,Andhra Pradesh',
'Vadalagunta,Tadepalligudem,Andhra Pradesh',
'Galayagudem,Eluru,Andhra Pradesh',
'Gangannagudem,Eluru,Andhra Pradesh',
'Kuchimpudi,Eluru,Andhra Pradesh',
'Pedavegi,Eluru,Andhra Pradesh',
'Ramasingavaram,Eluru,Andhra Pradesh',
'Agadalalanka,Eluru,Andhra Pradesh',
'Bhogapuram,Eluru,Andhra Pradesh',
'Chettunnapadu,Eluru,Andhra Pradesh',
'Krothagudem,Eluru,Andhra Pradesh',
'Iragavaram,Bhimavaram,Andhra Pradesh',
'Relangi,Bhimavaram,Andhra Pradesh',
'Akkampeta,Eluru,Andhra Pradesh',
'Challavarigudem,Eluru,Andhra Pradesh',
'Chinnavarigudem,Eluru,Andhra Pradesh',
'G.Pangidigudem,Eluru,Andhra Pradesh',
'Ganapavaram,Eluru,Andhra Pradesh',
'Gowrisankara Puram,Eluru,Andhra Pradesh',
'Jangareddigudem Bazar,Eluru,Andhra Pradesh',
'Jangareddygudem H.O,Eluru,Andhra Pradesh',
'Jonnavarigudem,Eluru,Andhra Pradesh',
'Maisammagudem,Eluru,Andhra Pradesh',
'Marlagudem,Eluru,Andhra Pradesh',
'Mulagampally,Eluru,Andhra Pradesh',
'Pattenapalem,Eluru,Andhra Pradesh',
'Perampeta,Eluru,Andhra Pradesh',
'Srinivaspuram,Eluru,Andhra Pradesh',
'Swarnavarigudem,Eluru,Andhra Pradesh',
'Taduvai,Eluru,Andhra Pradesh',
'Veerannapalem,Eluru,Andhra Pradesh',
'Vegavaram,Eluru,Andhra Pradesh',
'Gurvaigudem,Eluru,Andhra Pradesh',
'A.Polavaram,Eluru,Andhra Pradesh',
'Ankannagudem,Eluru,Andhra Pradesh',
'Appalarajugudem,Eluru,Andhra Pradesh',
'Bandivarigudem,Eluru,Andhra Pradesh',
'Darbhagudem,Eluru,Andhra Pradesh',
'Jeelugumilli,Eluru,Andhra Pradesh',
'Kamaiahpalem,Eluru,Andhra Pradesh',
'Makkinavarigudem,Eluru,Andhra Pradesh',
'P.Ankampalem,Eluru,Andhra Pradesh',
'P.Rajavaram,Eluru,Andhra Pradesh',
'Puchikapadu,Eluru,Andhra Pradesh',
'Ratsannagudem,Eluru,Andhra Pradesh',
'Tatiyakulagudem,Eluru,Andhra Pradesh',
'Vankavarigudem,Eluru,Andhra Pradesh',
'Adamilli,Eluru,Andhra Pradesh',
'Ankalampadu,Eluru,Andhra Pradesh',
'Jeelakarragudem,Eluru,Andhra Pradesh',
'Kamavarapukota,Eluru,Andhra Pradesh',
'Uppalapadu,Eluru,Andhra Pradesh',
'A.Gokavaram,Eluru,Andhra Pradesh',
'Kaikaram,Eluru,Andhra Pradesh',
'Kalla,Bhimavaram,Andhra Pradesh',
'Kopalle,Bhimavaram,Andhra Pradesh',
'S.R.K.R .Engg.college,Bhimavaram,Andhra Pradesh',
'Yelurupadu,Bhimavaram,Andhra Pradesh',
'Kamaiahkunta,Eluru,Andhra Pradesh',
'Kandrikagudem,Eluru,Andhra Pradesh',
'Kannapuram,Eluru,Andhra Pradesh',
'Kopalli,Eluru,Andhra Pradesh',
'Kotaramachandrapuram,Eluru,Andhra Pradesh',
'Koyarajahmundry,Eluru,Andhra Pradesh',
'Merakagudem,Eluru,Andhra Pradesh',
'Puliramannagudem,Eluru,Andhra Pradesh',
'Rajanagaram,Eluru,Andhra Pradesh',
'Ramannapalem,Eluru,Andhra Pradesh',
'Dosapadu,Eluru,Andhra Pradesh',
'Pothunuru,Eluru,Andhra Pradesh',
'Gowtaminagar,Tadepalligudem,Andhra Pradesh',
'Kovvur H.O,Tadepalligudem,Andhra Pradesh',
'Kovvur Old Town,Tadepalligudem,Andhra Pradesh',
'RTC Bustand(kovvur,Tadepalligudem,Andhra Pradesh',
'Dommeru,Tadepalligudem,Andhra Pradesh',
'I.Pangidi,Tadepalligudem,Andhra Pradesh',
'Arikirevula,Tadepalligudem,Andhra Pradesh',
'Chidipi,Tadepalligudem,Andhra Pradesh',
'Dharmavaram,Tadepalligudem,Andhra Pradesh',
'Kapavaram,Tadepalligudem,Andhra Pradesh',
'Kumaradevam,Tadepalligudem,Andhra Pradesh',
'Pasivedala,Tadepalligudem,Andhra Pradesh',
'Penkanametta,Tadepalligudem,Andhra Pradesh',
'Thogummi,Tadepalligudem,Andhra Pradesh',
'Vadapalli,Tadepalligudem,Andhra Pradesh',
'Vemuluru,Tadepalligudem,Andhra Pradesh',
'Atchuthapuram,Eluru,Andhra Pradesh',
'Bayyanagudem,Eluru,Andhra Pradesh',
'Bodigudem,Eluru,Andhra Pradesh',
'Dippakayalapadu,Eluru,Andhra Pradesh',
'Gavaravaram,Eluru,Andhra Pradesh',
'Jagannadhapuram,Eluru,Andhra Pradesh',
'Karicherlagudem,Eluru,Andhra Pradesh',
'Kethavaram,Eluru,Andhra Pradesh',
'Koyyalagudem,Eluru,Andhra Pradesh',
'Ponguturu,Eluru,Andhra Pradesh',
'Rajavaram,Eluru,Andhra Pradesh',
'Ramanujapuram,Eluru,Andhra Pradesh',
'Saripalli,Eluru,Andhra Pradesh',
'Seethampeta,Eluru,Andhra Pradesh',
'Tirumalapuram,Eluru,Andhra Pradesh',
'Vedanthapuram,Eluru,Andhra Pradesh',
'Yerrampeta,Eluru,Andhra Pradesh',
'Borrampalem,Eluru,Andhra Pradesh',
'Ch.Pothepalli,Eluru,Andhra Pradesh',
'Devulapalli,Eluru,Andhra Pradesh',
'G.Kothapalli,Eluru,Andhra Pradesh',
'I.S.Jagannadhapuram,Eluru,Andhra Pradesh',
'I.S.Raghavapuram,Eluru,Andhra Pradesh',
'Lakkavaram,Eluru,Andhra Pradesh',
'Ravikampadu,Eluru,Andhra Pradesh',
'Lingapalem,Eluru,Andhra Pradesh',
'Manchili,Bhimavaram,Andhra Pradesh',
'Minavilluru,Bhimavaram,Andhra Pradesh',
'Mogalturu,Bhimavaram,Andhra Pradesh',
'Moyyeru,Bhimavaram,Andhra Pradesh',
'Pothavaram,Tadepalligudem,Andhra Pradesh',
'Cheepurugudem,Tadepalligudem,Andhra Pradesh',
'Dubacharla,Tadepalligudem,Andhra Pradesh',
'Gantavarigudem,Tadepalligudem,Andhra Pradesh',
'Gundepalli,Tadepalligudem,Andhra Pradesh',
'Nabipeta,Tadepalligudem,Andhra Pradesh',
'Pothineedipalem,Tadepalligudem,Andhra Pradesh',
'Avapadu,Tadepalligudem,Andhra Pradesh',
'Marellamudi,Tadepalligudem,Andhra Pradesh',
'Prakasaraopalem,Tadepalligudem,Andhra Pradesh',
'Singarajupalem,Tadepalligudem,Andhra Pradesh',
'Ananthapallli,Tadepalligudem,Andhra Pradesh',
'Atchannapalem,Tadepalligudem,Andhra Pradesh',
'Nallajerla,Tadepalligudem,Andhra Pradesh',
'Telikecharla,Tadepalligudem,Andhra Pradesh',
'Pullalapadu,Tadepalligudem,Andhra Pradesh',
'Narsapur Bazar,Bhimavaram,Andhra Pradesh',
'Narsapur,Bhimavaram,Andhra Pradesh',
'Roypeta,Bhimavaram,Andhra Pradesh',
'Rustumbada,Bhimavaram,Andhra Pradesh',
'Sitaramapuram,Bhimavaram,Andhra Pradesh',
'Basivireddipeta,Tadepalligudem,Andhra Pradesh',
'Nidadavole O.T.,Tadepalligudem,Andhra Pradesh',
'Nidadavole,Tadepalligudem,Andhra Pradesh',
'Ramnagar,Tadepalligudem,Andhra Pradesh',
'Samisragudem,Tadepalligudem,Andhra Pradesh',
'Singavaram,Tadepalligudem,Andhra Pradesh',
'Tadimalla,Tadepalligudem,Andhra Pradesh',
'Atlapadu,Tadepalligudem,Andhra Pradesh',
'D.Muppavaram,Tadepalligudem,Andhra Pradesh',
'Gopavaram,Tadepalligudem,Andhra Pradesh',
'Jeedigunta,Tadepalligudem,Andhra Pradesh',
'Korumamidi,Tadepalligudem,Andhra Pradesh',
'Madduru,Tadepalligudem,Andhra Pradesh',
'Munipalli,Tadepalligudem,Andhra Pradesh',
'Pandalaparru,Tadepalligudem,Andhra Pradesh',
'Pendyala,Tadepalligudem,Andhra Pradesh',
'Purushottapalli,Tadepalligudem,Andhra Pradesh',
'Brahmanagudem,Tadepalligudem,Andhra Pradesh',
'Daravaram,Tadepalligudem,Andhra Pradesh',
'Kalavalapalli,Tadepalligudem,Andhra Pradesh',
'Kamsalipalem,Tadepalligudem,Andhra Pradesh',
'Markondapadu,Tadepalligudem,Andhra Pradesh',
'Ravimetla,Tadepalligudem,Andhra Pradesh',
'Settipeta,Tadepalligudem,Andhra Pradesh',
'Tallapalem,Tadepalligudem,Andhra Pradesh',
'Timmarajupalem,Tadepalligudem,Andhra Pradesh',
'D.Gopavaram,Tadepalligudem,Andhra Pradesh',
'Mandalaparru,Tadepalligudem,Andhra Pradesh',
'Nidamarru,Tadepalligudem,Andhra Pradesh',
'P.N.Kolanu,Tadepalligudem,Andhra Pradesh',
'Gudipadu,Eluru,Andhra Pradesh',
'Mogallu,Bhimavaram,Andhra Pradesh',
'Palakoderu,Bhimavaram,Andhra Pradesh',
'Srungavruksham,Bhimavaram,Andhra Pradesh',
'Garagaparru,Tadepalligudem,Andhra Pradesh',
'Mypa,Tadepalligudem,Andhra Pradesh',
'Vissakoderu,Bhimavaram,Andhra Pradesh',
'Adavipalem,Bhimavaram,Andhra Pradesh',
'Agarru,Bhimavaram,Andhra Pradesh',
'Agarthipalem,Bhimavaram,Andhra Pradesh',
'Digamarru,Bhimavaram,Andhra Pradesh',
'Jinnuru,Bhimavaram,Andhra Pradesh',
'Kaza,Bhimavaram,Andhra Pradesh',
'Konteru,Bhimavaram,Andhra Pradesh',
'Lajapathiroya Peta,Bhimavaram,Andhra Pradesh',
'Palakol Bazar,Bhimavaram,Andhra Pradesh',
'Pulapalli,Bhimavaram,Andhra Pradesh',
'Varidhanam,Bhimavaram,Andhra Pradesh',
'Bhaggeswaram,Bhimavaram,Andhra Pradesh',
'Palakol H.O,Bhimavaram,Andhra Pradesh',
'Gogunta,Eluru,Andhra Pradesh',
'Koniki,Eluru,Andhra Pradesh',
'Naidugudem,Eluru,Andhra Pradesh',
'Pedapadu,Eluru,Andhra Pradesh',
'Punikollu,Eluru,Andhra Pradesh',
'Raju Peta,Eluru,Andhra Pradesh',
'Satyavole,Eluru,Andhra Pradesh',
'Vadddigudem,Eluru,Andhra Pradesh',
'Vasanthavada,Eluru,Andhra Pradesh',
'Veerammakunta,Eluru,Andhra Pradesh',
'Pentapadu,Tadepalligudem,Andhra Pradesh',
'Ch.Agraharam,Tadepalligudem,Andhra Pradesh',
'West Vipparru,Tadepalligudem,Andhra Pradesh',
'Akuteegapadu,Tadepalligudem,Andhra Pradesh',
'Allampuram,Tadepalligudem,Andhra Pradesh',
'Arugolanu,Tadepalligudem,Andhra Pradesh',
'B.Kondepadu,Tadepalligudem,Andhra Pradesh',
'Chintapalli Agraharam,Tadepalligudem,Andhra Pradesh',
'Konala,Tadepalligudem,Andhra Pradesh',
'Korumilli,Tadepalligudem,Andhra Pradesh',
'Mounjipadu,Tadepalligudem,Andhra Pradesh',
'Mudunuru,Tadepalligudem,Andhra Pradesh',
'Prattipadu,Tadepalligudem,Andhra Pradesh',
'Darisaparru,Tadepalligudem,Andhra Pradesh',
'Jetlapalem,Tadepalligudem,Andhra Pradesh',
'K.Pentapadu,Tadepalligudem,Andhra Pradesh',
'Parimalla,Tadepalligudem,Andhra Pradesh',
'Racharla,Tadepalligudem,Andhra Pradesh',
'Yanalapalli,Tadepalligudem,Andhra Pradesh',
'Penugonda Bazar,Bhimavaram,Andhra Pradesh',
'Penugonda,Bhimavaram,Andhra Pradesh',
'Sidhantam,Bhimavaram,Andhra Pradesh',
'Vadali,Bhimavaram,Andhra Pradesh',
'Maruteru,Bhimavaram,Andhra Pradesh',
'Pali Gds,Bhimavaram,Andhra Pradesh',
'Penumantra,Bhimavaram,Andhra Pradesh',
'Polamuru,Bhimavaram,Andhra Pradesh',
'Kakaraparru,Tadepalligudem,Andhra Pradesh',
'Khandavalli,Bhimavaram,Andhra Pradesh',
'Peravali,Bhimavaram,Andhra Pradesh',
'Ajjaram,Tadepalligudem,Andhra Pradesh',
'K.Agraharam,Tadepalligudem,Andhra Pradesh',
'Kanuru,Tadepalligudem,Andhra Pradesh',
'Teeparru,Tadepalligudem,Andhra Pradesh',
'Usulumarru,Tadepalligudem,Andhra Pradesh',
'Gummaluru,Bhimavaram,Andhra Pradesh',
'Poduru,Bhimavaram,Andhra Pradesh',
'Kavitam,Bhimavaram,Andhra Pradesh',
'Polavaram,Tadepalligudem,Andhra Pradesh',
'Pragadapalli,Tadepalligudem,Andhra Pradesh',
'Bodigudem,Tadepalligudem,Andhra Pradesh',
'Chegondapalli,Tadepalligudem,Andhra Pradesh',
'Gunjavaram,Tadepalligudem,Andhra Pradesh',
'Gutala,Tadepalligudem,Andhra Pradesh',
'Koruturu,Tadepalligudem,Andhra Pradesh',
'Kunkala,Tadepalligudem,Andhra Pradesh',
'Mamidigondi,Tadepalligudem,Andhra Pradesh',
'Paidipaka,Tadepalligudem,Andhra Pradesh',
'Pattiseema,Tadepalligudem,Andhra Pradesh',
'Ramayyapeta,Tadepalligudem,Andhra Pradesh',
'Singanapalli,Tadepalligudem,Andhra Pradesh',
'Tekuru,Tadepalligudem,Andhra Pradesh',
'Tutigunta,Tadepalligudem,Andhra Pradesh',
'Vk.Reddigudem,Tadepalligudem,Andhra Pradesh',
'Bangarampeta,Tadepalligudem,Andhra Pradesh',
'Kondrukota,Tadepalligudem,Andhra Pradesh',
'Sivagiri,Tadepalligudem,Andhra Pradesh',
'Tallavaram,Tadepalligudem,Andhra Pradesh',
'Edavally,Eluru,Andhra Pradesh',
'Nagireddigudem,Eluru,Andhra Pradesh',
'Pragadavaram,Eluru,Andhra Pradesh',
'Sankuchakrapuram,Eluru,Andhra Pradesh',
'Tedlam,Eluru,Andhra Pradesh',
'Velagapally,Eluru,Andhra Pradesh',
'Yerrampally,Eluru,Andhra Pradesh',
'Amberpeta,Eluru,Andhra Pradesh',
'Kurellagudem,Eluru,Andhra Pradesh',
'M.M.Puram,Eluru,Andhra Pradesh',
'P.Kannapuram,Eluru,Andhra Pradesh',
'Pulla,Eluru,Andhra Pradesh',
'Koppaka,Eluru,Andhra Pradesh',
'Pedakadimi,Eluru,Andhra Pradesh',
'Ankannagudem,Eluru,Andhra Pradesh',
'Pinakadimi,Eluru,Andhra Pradesh',
'Epigunta,Eluru,Andhra Pradesh',
'Jaggavaram,Eluru,Andhra Pradesh',
'T.Narasapuram,Eluru,Andhra Pradesh',
'Tirumaladevipeta,Eluru,Andhra Pradesh',
'Aphb Colony,Tadepalligudem,Andhra Pradesh',
'Bodapadu,Tadepalligudem,Andhra Pradesh',
'Dandagarra,Tadepalligudem,Andhra Pradesh',
'Jagannadhapuram,Tadepalligudem,Andhra Pradesh',
'Kondruprolu,Tadepalligudem,Andhra Pradesh',
'Madhavaram,Tadepalligudem,Andhra Pradesh',
'Moduggunta,Tadepalligudem,Andhra Pradesh',
'Pmmarket,Tadepalligudem,Andhra Pradesh',
'Rc Rao Peta,Tadepalligudem,Andhra Pradesh',
'Subbaraopeta,Tadepalligudem,Andhra Pradesh',
'Tadepalligudem Bazar,Tadepalligudem,Andhra Pradesh',
'Tadepalligudem H.O,Tadepalligudem,Andhra Pradesh',
'Tadepalligudem Town,Tadepalligudem,Andhra Pradesh',
'Apparaopeta,Tadepalligudem,Andhra Pradesh',
'Jagannadhapuram,Tadepalligudem,Andhra Pradesh',
'Jaggannapeta,Tadepalligudem,Andhra Pradesh',
'Juvvalapalem,Tadepalligudem,Andhra Pradesh',
'Kadakatla,Tadepalligudem,Andhra Pradesh',
'Kadiyedda,Tadepalligudem,Andhra Pradesh',
'Kommugudem,Tadepalligudem,Andhra Pradesh',
'Krishnayampalemi,Tadepalligudem,Andhra Pradesh',
'Kunchinapalli,Tadepalligudem,Andhra Pradesh',
'Marampalli,Tadepalligudem,Andhra Pradesh',
'Moduggunta,Tadepalligudem,Andhra Pradesh',
'Nandamuru,Tadepalligudem,Andhra Pradesh',
'Navabpalem,Tadepalligudem,Andhra Pradesh',
'Padala,Tadepalligudem,Andhra Pradesh',
'Ramannagudem,Tadepalligudem,Andhra Pradesh',
'Sv Peta,Tadepalligudem,Andhra Pradesh',
'Tadepalli,Tadepalligudem,Andhra Pradesh',
'Veerampalem,Tadepalligudem,Andhra Pradesh',
'Venkatramannagudem,Tadepalligudem,Andhra Pradesh',
'Jogannapalem,Eluru,Andhra Pradesh',
'Kallacheruvu,Eluru,Andhra Pradesh',
'Koppulavarigudem,Eluru,Andhra Pradesh',
'Munduru,Eluru,Andhra Pradesh',
'Sagipadu,Eluru,Andhra Pradesh',
'T.Gokavaram,Eluru,Andhra Pradesh',
'Tadikalapudi,Eluru,Andhra Pradesh',
'Vegivada,Eluru,Andhra Pradesh',
'Vempally,Eluru,Andhra Pradesh',
'Vidyanagar,Eluru,Andhra Pradesh',
'Tallapudi,Tadepalligudem,Andhra Pradesh',
'Vegeswarapuram,Tadepalligudem,Andhra Pradesh',
'Annadevarapeta,Tadepalligudem,Andhra Pradesh',
'Ballipadu,Tadepalligudem,Andhra Pradesh',
'Gajjaram,Tadepalligudem,Andhra Pradesh',
'Malakapalli,Tadepalligudem,Andhra Pradesh',
'Peddavam,Tadepalligudem,Andhra Pradesh',
'Pochavaram,Tadepalligudem,Andhra Pradesh',
'Prakkilanka,Tadepalligudem,Andhra Pradesh',
'Tadipudi,Tadepalligudem,Andhra Pradesh',
'Tirugudumetta,Tadepalligudem,Andhra Pradesh',
'Hanumantharaopeta,Bhimavaram,Andhra Pradesh',
'Mandapaka,Bhimavaram,Andhra Pradesh',
'Sajjapuram,Bhimavaram,Andhra Pradesh',
'Tanuku Bazar,Bhimavaram,Andhra Pradesh',
'Tanuku H.O,Bhimavaram,Andhra Pradesh',
'Tanuku Old Town,Bhimavaram,Andhra Pradesh',
'Venkatrayapuram,Bhimavaram,Andhra Pradesh',
'Duvva,Tadepalligudem,Andhra Pradesh',
'Muddapuram,Tadepalligudem,Andhra Pradesh',
'Pasalapudi,Tadepalligudem,Andhra Pradesh',
'Mortha,Bhimavaram,Andhra Pradesh',
'Undi,Bhimavaram,Andhra Pradesh',
'Vundurru,Tadepalligudem,Andhra Pradesh',
'Yandagandi,Tadepalligudem,Andhra Pradesh',
'Velivennu,Tadepalligudem,Andhra Pradesh',
'Kaldhari,Tadepalligudem,Andhra Pradesh',
'Velpur,Bhimavaram,Andhra Pradesh',
'Bapirajugudem,Eluru,Andhra Pradesh',
'Janampeta,Eluru,Andhra Pradesh',
'Kavvagunta,Eluru,Andhra Pradesh',
'Nadipally,Eluru,Andhra Pradesh',
'Rayannapalem,Eluru,Andhra Pradesh',
'Vijayarai,Eluru,Andhra Pradesh',
'Rayakuduru,Bhimavaram,Andhra Pradesh',
'Viravasaram,Bhimavaram,Andhra Pradesh',
'Konithiwada,Bhimavaram,Andhra Pradesh',
'Lankalakoderu,Bhimavaram,Andhra Pradesh',
'Vundrajavaram,Bhimavaram,Andhra Pradesh',
'Vunguturu,Tadepalligudem,Andhra Pradesh',
'Badampudi,Tadepalligudem,Andhra Pradesh',
'Bommidi,Tadepalligudem,Andhra Pradesh',
'Kagupadu,Tadepalligudem,Andhra Pradesh',
'Kakarlamudi,Tadepalligudem,Andhra Pradesh',
'Nachugunta,Tadepalligudem,Andhra Pradesh',
'Uppakapadu,Tadepalligudem,Andhra Pradesh',
'Vellamilli,Tadepalligudem,Andhra Pradesh',
'Yerramalla,Tadepalligudem,Andhra Pradesh',
'Katakoteswaram,Tadepalligudem,Andhra Pradesh',
'Bordumsa,Arunachal Pradesh,Arunachal Pradesh',
'Bubang,Arunachal Pradesh,Arunachal Pradesh',
'Changlang,Arunachal Pradesh,Arunachal Pradesh',
'Rangfrah Covt College,Arunachal Pradesh,Arunachal Pradesh',
'Jairampur,Arunachal Pradesh,Arunachal Pradesh',
'Manmao,Arunachal Pradesh,Arunachal Pradesh',
'Khemiyong,Arunachal Pradesh,Arunachal Pradesh',
'Kherem Bisa,Arunachal Pradesh,Arunachal Pradesh',
'Lallung,Arunachal Pradesh,Arunachal Pradesh',
'Chopelling,Arunachal Pradesh,Arunachal Pradesh',
'Deban,Arunachal Pradesh,Arunachal Pradesh',
'Dharampur,Arunachal Pradesh,Arunachal Pradesh',
'Kharsang,Arunachal Pradesh,Arunachal Pradesh',
'Kutum Basti,Arunachal Pradesh,Arunachal Pradesh',
'Manabhum,Arunachal Pradesh,Arunachal Pradesh',
'Miao,Arunachal Pradesh,Arunachal Pradesh',
'Namchik,Arunachal Pradesh,Arunachal Pradesh',
'Namphai,Arunachal Pradesh,Arunachal Pradesh',
'Namdang,Arunachal Pradesh,Arunachal Pradesh',
'Namtok,Arunachal Pradesh,Arunachal Pradesh',
'New Mohang,Arunachal Pradesh,Arunachal Pradesh',
'Rajanagar,Arunachal Pradesh,Arunachal Pradesh',
'Ranglum,Arunachal Pradesh,Arunachal Pradesh',
'Gandhigram,Arunachal Pradesh,Arunachal Pradesh',
'Two-hat,Arunachal Pradesh,Arunachal Pradesh',
'Vijoynagar,Arunachal Pradesh,Arunachal Pradesh',
'Vijoypur,Arunachal Pradesh,Arunachal Pradesh',
'Yangkang,Arunachal Pradesh,Arunachal Pradesh',
'Alinye,Arunachal Pradesh,Arunachal Pradesh',
'Anelih,Arunachal Pradesh,Arunachal Pradesh',
'Anini,Arunachal Pradesh,Arunachal Pradesh',
'Seijosa,Arunachal Pradesh,Arunachal Pradesh',
'Bameng,Arunachal Pradesh,Arunachal Pradesh',
'Bana,Arunachal Pradesh,Arunachal Pradesh',
'Chyangtajo,Arunachal Pradesh,Arunachal Pradesh',
'Khenewa,Arunachal Pradesh,Arunachal Pradesh',
'Lada,Arunachal Pradesh,Arunachal Pradesh',
'P.Kessang,Arunachal Pradesh,Arunachal Pradesh',
'Palizi,Arunachal Pradesh,Arunachal Pradesh',
'Pipu-dipu,Arunachal Pradesh,Arunachal Pradesh',
'Seppa,Arunachal Pradesh,Arunachal Pradesh',
'Thrizino,Arunachal Pradesh,Arunachal Pradesh',
'Veo,Arunachal Pradesh,Arunachal Pradesh',
'Ayeng,Arunachal Pradesh,Arunachal Pradesh',
'Borguli,Arunachal Pradesh,Arunachal Pradesh',
'Mebo,Arunachal Pradesh,Arunachal Pradesh',
'Namsing,Arunachal Pradesh,Arunachal Pradesh',
'Ngopok,Arunachal Pradesh,Arunachal Pradesh',
'Silluk,Arunachal Pradesh,Arunachal Pradesh',
'Sirem,Arunachal Pradesh,Arunachal Pradesh',
'Adipasi,Arunachal Pradesh,Arunachal Pradesh',
'Balek,Arunachal Pradesh,Arunachal Pradesh',
'Bilat,Arunachal Pradesh,Arunachal Pradesh',
'Boleng,Arunachal Pradesh,Arunachal Pradesh',
'Dalbing,Arunachal Pradesh,Arunachal Pradesh',
'Damro,Arunachal Pradesh,Arunachal Pradesh',
'Debing,Arunachal Pradesh,Arunachal Pradesh',
'Hill Top,Arunachal Pradesh,Arunachal Pradesh',
'Kebang,Arunachal Pradesh,Arunachal Pradesh',
'Korang,Arunachal Pradesh,Arunachal Pradesh',
'Koyu,Arunachal Pradesh,Arunachal Pradesh',
'Ledum,Arunachal Pradesh,Arunachal Pradesh',
'Nari,Arunachal Pradesh,Arunachal Pradesh',
'Oyan,Arunachal Pradesh,Arunachal Pradesh',
'Pangin,Arunachal Pradesh,Arunachal Pradesh',
'Pasighat,Arunachal Pradesh,Arunachal Pradesh',
'Rani,Arunachal Pradesh,Arunachal Pradesh',
'Renging,Arunachal Pradesh,Arunachal Pradesh',
'Riga,Arunachal Pradesh,Arunachal Pradesh',
'Ruksin,Arunachal Pradesh,Arunachal Pradesh',
'Sille,Arunachal Pradesh,Arunachal Pradesh',
'Yagrung,Arunachal Pradesh,Arunachal Pradesh',
'GTC,Arunachal Pradesh,Arunachal Pradesh',
'Chambang,Arunachal Pradesh,Arunachal Pradesh',
'Damin,Arunachal Pradesh,Arunachal Pradesh',
'Koloriang,Arunachal Pradesh,Arunachal Pradesh',
'Sangram,Arunachal Pradesh,Arunachal Pradesh',
'Sarli,Arunachal Pradesh,Arunachal Pradesh',
'Hiya,Arunachal Pradesh,Arunachal Pradesh',
'Nyapin,Arunachal Pradesh,Arunachal Pradesh',
'Palin,Arunachal Pradesh,Arunachal Pradesh',
'Tali,Arunachal Pradesh,Arunachal Pradesh',
'Alubari,Arunachal Pradesh,Arunachal Pradesh',
'Chakma,Arunachal Pradesh,Arunachal Pradesh',
'Chowkham,Arunachal Pradesh,Arunachal Pradesh',
'Kherem,Arunachal Pradesh,Arunachal Pradesh',
'Kamlang Nagar,Arunachal Pradesh,Arunachal Pradesh',
'Kumari Kachari,Arunachal Pradesh,Arunachal Pradesh',
'Mahadevpur,Arunachal Pradesh,Arunachal Pradesh',
'Podumani,Arunachal Pradesh,Arunachal Pradesh',
'Medo,Arunachal Pradesh,Arunachal Pradesh',
'Momong,Arunachal Pradesh,Arunachal Pradesh',
'Diyun,Arunachal Pradesh,Arunachal Pradesh',
'Innao,Arunachal Pradesh,Arunachal Pradesh',
'Jaipur,Arunachal Pradesh,Arunachal Pradesh',
'Kumsai,Arunachal Pradesh,Arunachal Pradesh',
'Lathao,Arunachal Pradesh,Arunachal Pradesh',
'Manmao,Arunachal Pradesh,Arunachal Pradesh',
'Nampong,Arunachal Pradesh,Arunachal Pradesh',
'Namsai,Arunachal Pradesh,Arunachal Pradesh',
'Nanam,Arunachal Pradesh,Arunachal Pradesh',
'Peyong,Arunachal Pradesh,Arunachal Pradesh',
'Udaipur,Arunachal Pradesh,Arunachal Pradesh',
'Wingko,Arunachal Pradesh,Arunachal Pradesh',
'Sunpura,Arunachal Pradesh,Arunachal Pradesh',
'Yealing,Arunachal Pradesh,Arunachal Pradesh',
'Changliang,Arunachal Pradesh,Arunachal Pradesh',
'Danglat,Arunachal Pradesh,Arunachal Pradesh',
'Gohaingaon,Arunachal Pradesh,Arunachal Pradesh',
'Lohitpur,Arunachal Pradesh,Arunachal Pradesh',
'Loiliang,Arunachal Pradesh,Arunachal Pradesh',
'Tafragram,Arunachal Pradesh,Arunachal Pradesh',
'Tezu Covt.College,Arunachal Pradesh,Arunachal Pradesh',
'Tezu,Arunachal Pradesh,Arunachal Pradesh',
'Tindolong,Arunachal Pradesh,Arunachal Pradesh',
'Wakro,Arunachal Pradesh,Arunachal Pradesh',
'Abango,Arunachal Pradesh,Arunachal Pradesh',
'Anupam,Arunachal Pradesh,Arunachal Pradesh',
'Bijari,Arunachal Pradesh,Arunachal Pradesh',
'Bolung,Arunachal Pradesh,Arunachal Pradesh',
'Bomjir,Arunachal Pradesh,Arunachal Pradesh',
'Dambuk,Arunachal Pradesh,Arunachal Pradesh',
'Desali,Arunachal Pradesh,Arunachal Pradesh',
'Elopa,Arunachal Pradesh,Arunachal Pradesh',
'Etalin,Arunachal Pradesh,Arunachal Pradesh',
'Hunli,Arunachal Pradesh,Arunachal Pradesh',
'Iduli,Arunachal Pradesh,Arunachal Pradesh',
'Jia,Arunachal Pradesh,Arunachal Pradesh',
'Koranu,Arunachal Pradesh,Arunachal Pradesh',
'Kronli,Arunachal Pradesh,Arunachal Pradesh',
'Meka,Arunachal Pradesh,Arunachal Pradesh',
'Paglam,Arunachal Pradesh,Arunachal Pradesh',
'Parbuk,Arunachal Pradesh,Arunachal Pradesh',
'Roing,Arunachal Pradesh,Arunachal Pradesh',
'Santipur,Arunachal Pradesh,Arunachal Pradesh',
'Chimpu,Arunachal Pradesh,Arunachal Pradesh',
'Ranga Nadi Project,Arunachal Pradesh,Arunachal Pradesh',
'Boasimla,Arunachal Pradesh,Arunachal Pradesh',
'Deed,Arunachal Pradesh,Arunachal Pradesh',
'Godak,Arunachal Pradesh,Arunachal Pradesh',
'Hija,Arunachal Pradesh,Arunachal Pradesh',
'Joram,Arunachal Pradesh,Arunachal Pradesh',
'Mengio,Arunachal Pradesh,Arunachal Pradesh',
'Old Ziro,Arunachal Pradesh,Arunachal Pradesh',
'Raga,Arunachal Pradesh,Arunachal Pradesh',
'Talo,Arunachal Pradesh,Arunachal Pradesh',
'Yachuli,Arunachal Pradesh,Arunachal Pradesh',
'Yazali,Arunachal Pradesh,Arunachal Pradesh',
'Ziro,Arunachal Pradesh,Arunachal Pradesh',
'Balijan,Arunachal Pradesh,Arunachal Pradesh',
'Banderdewa,Arunachal Pradesh,Arunachal Pradesh',
'Doimukh,Arunachal Pradesh,Arunachal Pradesh',
'Kheel,Arunachal Pradesh,Arunachal Pradesh',
'Midpu,Arunachal Pradesh,Arunachal Pradesh',
'A P Sectt.,Arunachal Pradesh,Arunachal Pradesh',
'Donyi Polo,Arunachal Pradesh,Arunachal Pradesh',
'Itanagar H.O,Arunachal Pradesh,Arunachal Pradesh',
'Ram Krishna Mission,Arunachal Pradesh,Arunachal Pradesh',
'Vivek Vihar,Arunachal Pradesh,Arunachal Pradesh',
'Hawa Camp,Arunachal Pradesh,Arunachal Pradesh',
'Kimin,Arunachal Pradesh,Arunachal Pradesh',
'Kokila,Arunachal Pradesh,Arunachal Pradesh',
'Model Village,Arunachal Pradesh,Arunachal Pradesh',
'Naharlagun,Arunachal Pradesh,Arunachal Pradesh',
'Nirjuli,Arunachal Pradesh,Arunachal Pradesh',
'Saglee,Arunachal Pradesh,Arunachal Pradesh',
'Sonajuli,Arunachal Pradesh,Arunachal Pradesh',
'Arunachal University,Arunachal Pradesh,Arunachal Pradesh',
'Yupia,Arunachal Pradesh,Arunachal Pradesh',
'Lhou,Arunachal Pradesh,Arunachal Pradesh',
'Mukto,Arunachal Pradesh,Arunachal Pradesh',
'Thingbu,Arunachal Pradesh,Arunachal Pradesh',
'Gispu,Arunachal Pradesh,Arunachal Pradesh',
'Lumla,Arunachal Pradesh,Arunachal Pradesh',
'Zimithang,Arunachal Pradesh,Arunachal Pradesh',
'Jang,Arunachal Pradesh,Arunachal Pradesh',
'B.Supply,Arunachal Pradesh,Arunachal Pradesh',
'Kitpi,Arunachal Pradesh,Arunachal Pradesh',
'Lumberdung,Arunachal Pradesh,Arunachal Pradesh',
'Sakpret,Arunachal Pradesh,Arunachal Pradesh',
'Tawang,Arunachal Pradesh,Arunachal Pradesh',
'Temple Gompa,Arunachal Pradesh,Arunachal Pradesh',
'Deomali,Arunachal Pradesh,Arunachal Pradesh',
'Hukanjuri,Arunachal Pradesh,Arunachal Pradesh',
'Kanubari,Arunachal Pradesh,Arunachal Pradesh',
'Borduria,Arunachal Pradesh,Arunachal Pradesh',
'Dadam,Arunachal Pradesh,Arunachal Pradesh',
'Kaimai,Arunachal Pradesh,Arunachal Pradesh',
'Kapu,Arunachal Pradesh,Arunachal Pradesh',
'Khela,Arunachal Pradesh,Arunachal Pradesh',
'Kheti,Arunachal Pradesh,Arunachal Pradesh',
'Khonsa Basti,Arunachal Pradesh,Arunachal Pradesh',
'Bagra,Arunachal Pradesh,Arunachal Pradesh',
'Bame,Arunachal Pradesh,Arunachal Pradesh',
'Basar,Arunachal Pradesh,Arunachal Pradesh',
'Bene,Arunachal Pradesh,Arunachal Pradesh',
'Dali,Arunachal Pradesh,Arunachal Pradesh',
'Darak,Arunachal Pradesh,Arunachal Pradesh',
'Daring,Arunachal Pradesh,Arunachal Pradesh',
'Darka,Arunachal Pradesh,Arunachal Pradesh',
'Rumgong,Arunachal Pradesh,Arunachal Pradesh',
'Kambang,Arunachal Pradesh,Arunachal Pradesh',
'Kaying,Arunachal Pradesh,Arunachal Pradesh',
'Kombo,Arunachal Pradesh,Arunachal Pradesh',
'Garu,Arunachal Pradesh,Arunachal Pradesh',
'Gensi,Arunachal Pradesh,Arunachal Pradesh',
'Likabali,Arunachal Pradesh,Arunachal Pradesh',
'Liromoba,Arunachal Pradesh,Arunachal Pradesh',
'Logum Jining,Arunachal Pradesh,Arunachal Pradesh',
'Mechuka,Arunachal Pradesh,Arunachal Pradesh',
'Monigong,Arunachal Pradesh,Arunachal Pradesh',
'Nikte,Arunachal Pradesh,Arunachal Pradesh',
'Payum,Arunachal Pradesh,Arunachal Pradesh',
'Tato,Arunachal Pradesh,Arunachal Pradesh',
'Tirbin,Arunachal Pradesh,Arunachal Pradesh',
'Vivek Nagar,Arunachal Pradesh,Arunachal Pradesh',
'Yoji Yora,Arunachal Pradesh,Arunachal Pradesh',
'Yomcha,Arunachal Pradesh,Arunachal Pradesh',
'Baghmarabazar,Nalbari,Assam',
'Baharihat,Nalbari,Assam',
'Barpeta Bazar,Nalbari,Assam',
'Barpeta H.O,Nalbari,Assam',
'Thakurbazar,Nalbari,Assam',
'Barpeta Road,Nalbari,Assam',
'Bhella,Nalbari,Assam',
'Bhowanipur,Nalbari,Assam',
'Chenga,Nalbari,Assam',
'Howly,Nalbari,Assam',
'Jalahghat,Nalbari,Assam',
'Kalgachia,Nalbari,Assam',
'Kokilabari Farm,Nalbari,Assam',
'Mandia,Nalbari,Assam',
'Mayanbari,Nalbari,Assam',
'Nityananda,Nalbari,Assam',
'Patacharkuchi,Nalbari,Assam',
'Bajali College,Nalbari,Assam',
'Pathsala,Nalbari,Assam',
'Santinagar,Nalbari,Assam',
'Sarthebari,Nalbari,Assam',
'Sarupeta,Nalbari,Assam',
'Simlaguri,Nalbari,Assam',
'Sorbhog,Nalbari,Assam',
'Akaya,Nalbari,Assam',
'Ambari,Nalbari,Assam',
'Amdah,Nalbari,Assam',
'Amguri,Nalbari,Assam',
'Amrikhowa,Nalbari,Assam',
'Anandabazar,Nalbari,Assam',
'Anchali,Nalbari,Assam',
'B D Pathar,Nalbari,Assam',
'B Noontola,Nalbari,Assam',
'Baghbar,Nalbari,Assam',
'Baghogra,Nalbari,Assam',
'Bagodi,Nalbari,Assam',
'Bakua,Nalbari,Assam',
'Balabitha,Nalbari,Assam',
'Balagaon,Nalbari,Assam',
'Balapet,Nalbari,Assam',
'Balikuri,Nalbari,Assam',
'Bamakhata,Nalbari,Assam',
'Bamunkata,Nalbari,Assam',
'Bamunkuchi,Nalbari,Assam',
'Bankubhanga,Nalbari,Assam',
'Baradi,Nalbari,Assam',
'Barbala,Nalbari,Assam',
'Barbang,Nalbari,Assam',
'Barengabari,Nalbari,Assam',
'Barghol,Nalbari,Assam',
'Barkapla,Nalbari,Assam',
'Barmazara,Nalbari,Assam',
'Barnagarcollege,Nalbari,Assam',
'Barpalli,Nalbari,Assam',
'Baslajan,Nalbari,Assam',
'Batabari,Nalbari,Assam',
'Betbari,Nalbari,Assam',
'Bhakuamari,Nalbari,Assam',
'Bhalaguri,Nalbari,Assam',
'Bhalukadoba,Nalbari,Assam',
'Bhatkuchi,Nalbari,Assam',
'Bheraldi,Nalbari,Assam',
'Bhetua,Nalbari,Assam',
'Bhogarpar,Nalbari,Assam',
'Bhogdia,Nalbari,Assam',
'Bhogpur,Nalbari,Assam',
'Bhoiraguri,Nalbari,Assam',
'Bhoirarpam,Nalbari,Assam',
'Bhotanta,Nalbari,Assam',
'Bhotantasaderi,Nalbari,Assam',
'Bilashi Para Bazar,Nalbari,Assam',
'Bonghugi,Nalbari,Assam',
'Burikhamar,Nalbari,Assam',
'Byaskuchi,Nalbari,Assam',
'C Bazar,Nalbari,Assam',
'Chachaka,Nalbari,Assam',
'Chakabusi,Nalbari,Assam',
'Chandmama,Nalbari,Assam',
'Chaparbari Bazar,Nalbari,Assam',
'Charcharia,Nalbari,Assam',
'Charnabazar,Nalbari,Assam',
'Chenglimari,Nalbari,Assam',
'Dabaliapara,Nalbari,Assam',
'Daisingri,Nalbari,Assam',
'Deoldi,Nalbari,Assam',
'Dhakua,Nalbari,Assam',
'Dharmpur,Nalbari,Assam',
'Dpdeolsdi,Nalbari,Assam',
'Dubi,Nalbari,Assam',
'Duramari,Nalbari,Assam',
'Erabamundi,Nalbari,Assam',
'Gahia,Nalbari,Assam',
'Gajia,Nalbari,Assam',
'Galia,Nalbari,Assam',
'Ganakkuchi,Nalbari,Assam',
'Gandhipur,Nalbari,Assam',
'Garaimari,Nalbari,Assam',
'Garatari,Nalbari,Assam',
'Ghilajari,Nalbari,Assam',
'Ghugubari,Nalbari,Assam',
'Gobardhana,Nalbari,Assam',
'Gobindapur,Nalbari,Assam',
'Golagaon,Nalbari,Assam',
'Gomafulbari,Nalbari,Assam',
'Guagacha,Nalbari,Assam',
'Gunialguri,Nalbari,Assam',
'Habidongra Bazar,Nalbari,Assam',
'Hathinapur,Nalbari,Assam',
'Hudukhata,Nalbari,Assam',
'Ishapur,Nalbari,Assam',
'Jahurpam,Nalbari,Assam',
'Jania,Nalbari,Assam',
'Jarabari,Nalbari,Assam',
'Jasihatipara,Nalbari,Assam',
'Jatradia,Nalbari,Assam',
'K Bari,Nalbari,Assam',
'Kadang,Nalbari,Assam',
'Kadomtola,Nalbari,Assam',
'Kalahbhanga,Nalbari,Assam',
'Kalpani Bazar,Nalbari,Assam',
'Kamalabari,Nalbari,Assam',
'Kamalpur,Nalbari,Assam',
'Kamargaon,Nalbari,Assam',
'Kapahtolichikni,Nalbari,Assam',
'Karaguri,Nalbari,Assam',
'Kardoiguri,Nalbari,Assam',
'Katajhar,Nalbari,Assam',
'Kathalmurighat,Nalbari,Assam',
'Kayakuchi Bazar,Nalbari,Assam',
'Keotkuchi,Nalbari,Assam',
'Khablarvitha,Nalbari,Assam',
'Khairabari,Nalbari,Assam',
'Khangra,Nalbari,Assam',
'Khardhara,Nalbari,Assam',
'Khatslpara,Nalbari,Assam',
'Kohitama,Nalbari,Assam',
'Komardaisa,Nalbari,Assam',
'Kujarpith,Nalbari,Assam',
'Kurobaha,Nalbari,Assam',
'Labdanguri Gon,Nalbari,Assam',
'Langa,Nalbari,Assam',
'Lowkata,Nalbari,Assam',
'Mainamata,Nalbari,Assam',
'Mairajar,Nalbari,Assam',
'Makrikuchi,Nalbari,Assam',
'Manikpur,Nalbari,Assam',
'Maripur Anandapur,Nalbari,Assam',
'Mazgaon,Nalbari,Assam',
'Mespara,Nalbari,Assam',
'Moutupuri,Nalbari,Assam',
'Muguria,Nalbari,Assam',
'Nagaon,Nalbari,Assam',
'Nakuchi Pathar,Nalbari,Assam',
'Naligaon,Nalbari,Assam',
'Namsala,Nalbari,Assam',
'Nasatraphulbari,Nalbari,Assam',
'Nimua,Nalbari,Assam',
'Nirala,Nalbari,Assam',
'Niz Rampur,Nalbari,Assam',
'Nizbahari,Nalbari,Assam',
'Odalguri,Nalbari,Assam',
'Pacim Mazdia,Nalbari,Assam',
'Pahumara,Nalbari,Assam',
'Paka Bet Bari Pathar,Nalbari,Assam',
'Palhaji,Nalbari,Assam',
'Parakuchi,Nalbari,Assam',
'Patbaushi,Nalbari,Assam',
'Pathartolichatala,Nalbari,Assam',
'Pubrihabari,Nalbari,Assam',
'Puranbhowanipur,Nalbari,Assam',
'R B Hat,Nalbari,Assam',
'Radhakuchi,Nalbari,Assam',
'Ramaparapam,Nalbari,Assam',
'Raoli,Nalbari,Assam',
'Raypur,Nalbari,Assam',
'Rupahi,Nalbari,Assam',
'Salbari,Nalbari,Assam',
'Samuagati,Nalbari,Assam',
'Sarumanikpur,Nalbari,Assam',
'Sarutapa,Nalbari,Assam',
'Satrakanara Bazar,Nalbari,Assam',
'Saudarvitha,Nalbari,Assam',
'Saupur,Nalbari,Assam',
'Senimari,Nalbari,Assam',
'Sitoli,Nalbari,Assam',
'Sonabari,Nalbari,Assam',
'Sonafuli,Nalbari,Assam',
'Sonkuchi,Nalbari,Assam',
'Sukmanah,Nalbari,Assam',
'Sukurngbari,Nalbari,Assam',
'Suliakata,Nalbari,Assam',
'Sundaridia,Nalbari,Assam',
'Tarakansdi,Nalbari,Assam',
'Tuplaipanbari,Nalbari,Assam',
'Abhayapuri,Goalpara,Assam',
'Barigaon,Goalpara,Assam',
'Chalantapara,Goalpara,Assam',
'Dumerguri,Goalpara,Assam',
'Dumuria Piradhara,Goalpara,Assam',
'Golapara,Goalpara,Assam',
'Kirtanpara,Goalpara,Assam',
'Koreya,Goalpara,Assam',
'Majharalga,Goalpara,Assam',
'Nayagaon,Goalpara,Assam',
'Nayasatra,Goalpara,Assam',
'Rangapani,Goalpara,Assam',
'Santoshpur,Goalpara,Assam',
'Topgaon,Goalpara,Assam',
'A.P.Mill,Goalpara,Assam',
'Ambari,Goalpara,Assam',
'B.S.Gram,Goalpara,Assam',
'Balapara,Goalpara,Assam',
'Deohati,Goalpara,Assam',
'Latibari,Goalpara,Assam',
'Lengtisinga,Goalpara,Assam',
'Madrasapara,Goalpara,Assam',
'Nararbhita,Goalpara,Assam',
'Tilpukhuri,Goalpara,Assam',
'Kushbari,Goalpara,Assam',
'Lalmati,Goalpara,Assam',
'Barjana,Goalpara,Assam',
'Bhotguti Huramara,Goalpara,Assam',
'Garugaon,Goalpara,Assam',
'Ghilaguri,Goalpara,Assam',
'Kakaijana,Goalpara,Assam',
'Kayetpara,Goalpara,Assam',
'Khagarpur,Goalpara,Assam',
'Malegarh,Goalpara,Assam',
'Pachania,Goalpara,Assam',
'Salmara North,Goalpara,Assam',
'Bengtal,Goalpara,Assam',
'Chatonilibari,Goalpara,Assam',
'Patabari,Goalpara,Assam',
'Tukrijhora,Goalpara,Assam',
'Ouguri,Goalpara,Assam',
'Boitamari,Goalpara,Assam',
'Jogighopa,Goalpara,Assam',
'Barpara,Goalpara,Assam',
'Bongaigaon,Goalpara,Assam',
'Chakapara,Goalpara,Assam',
'Chapaguri,Goalpara,Assam',
'Chaprakata,Goalpara,Assam',
'Chipansila,Goalpara,Assam',
'Dhaligaon,Goalpara,Assam',
'Dongaigaon,Goalpara,Assam',
'Kajalgaon,Goalpara,Assam',
'Khagrabari,Goalpara,Assam',
'Khwaja Dolaigaon,Goalpara,Assam',
'Mulagaon,Goalpara,Assam',
'Natunpara,Goalpara,Assam',
'New Bongaigaon,Goalpara,Assam',
'North Baitamari,Goalpara,Assam',
'North Bongaigaon,Goalpara,Assam',
'Popragaon,Goalpara,Assam',
'Simlaguri,Goalpara,Assam',
'Boro Bazar,Goalpara,Assam',
'Dongshia Para,Goalpara,Assam',
'Amguri Bazar,Goalpara,Assam',
'Amteka Bazar,Goalpara,Assam',
'B.Ladanguri,Goalpara,Assam',
'Ballamguri Bazar,Goalpara,Assam',
'Betini,Goalpara,Assam',
'Betnapara,Goalpara,Assam',
'Joypur,Goalpara,Assam',
'Khungkhurajhara,Goalpara,Assam',
'Koilamoila,Goalpara,Assam',
'Malibhita,Goalpara,Assam',
'Malipara,Goalpara,Assam',
'Nehru Bazar,Goalpara,Assam',
'Silbari Abdaipara,Goalpara,Assam',
'Melopara,Goalpara,Assam',
'Adlaguri,Goalpara,Assam',
'Alukhunda Bazar,Goalpara,Assam',
'Ananda Bazar,Goalpara,Assam',
'Aolaguri,Goalpara,Assam',
'Bagargaon,Goalpara,Assam',
'Bangalijhora,Goalpara,Assam',
'Barpathar,Goalpara,Assam',
'Bhandra Bazar,Goalpara,Assam',
'Bholatol,Goalpara,Assam',
'Bhotgaon,Goalpara,Assam',
'Bijni,Goalpara,Assam',
'Chakihali,Goalpara,Assam',
'Chakla,Goalpara,Assam',
'Chatianguri,Goalpara,Assam',
'Dakshin Bijni,Goalpara,Assam',
'Dompara,Goalpara,Assam',
'Fagunagaon,Goalpara,Assam',
'Gerukabari,Goalpara,Assam',
'Goraimari,Goalpara,Assam',
'Hanchara,Goalpara,Assam',
'Hapachara,Goalpara,Assam',
'Jharbishpani,Goalpara,Assam',
'Kokila,Goalpara,Assam',
'Manikpur,Goalpara,Assam',
'Monakocha,Goalpara,Assam',
'Mongolian Bazar,Goalpara,Assam',
'Nowagaon,Goalpara,Assam',
'Nowapara,Goalpara,Assam',
'Numberpara,Goalpara,Assam',
'Panbari,Goalpara,Assam',
'Patiladaha,Goalpara,Assam',
'Salabila Bazar,Goalpara,Assam',
'Silkhaguri,Goalpara,Assam',
'Sonaikhola,Goalpara,Assam',
'Kaliagaon,Goalpara,Assam',
'Kawatika,Goalpara,Assam',
'Champabati Bazar,Goalpara,Assam',
'Duttapur,Goalpara,Assam',
'Garubhasa,Goalpara,Assam',
'Karigaon,Goalpara,Assam',
'Kashikotra,Goalpara,Assam',
'Mozabari,Goalpara,Assam',
'Sidli,Goalpara,Assam',
'Algapur,Cachar,Assam',
'Amaranagar T E,Cachar,Assam',
'Ambicapur,Cachar,Assam',
'Amjurghat,Cachar,Assam',
'Arkutipur,Cachar,Assam',
'Arunachal,Cachar,Assam',
'Assam University,Cachar,Assam',
'Atharotilla,Cachar,Assam',
'Badripar,Cachar,Assam',
'Bag O Bahar,Cachar,Assam',
'Baglaghat,Cachar,Assam',
'Bagpur,Cachar,Assam',
'Balacherra T E,Cachar,Assam',
'Baladhan T E,Cachar,Assam',
'Banskandi,Cachar,Assam',
'Barakhai T E,Cachar,Assam',
'Bararkap,Cachar,Assam',
'Barjatrapur,Cachar,Assam',
'Baroitoli,Cachar,Assam',
'Baromuni,Cachar,Assam',
'Barthal,Cachar,Assam',
'Barthal T E,Cachar,Assam',
'Batertal,Cachar,Assam',
'Behara Bazar,Cachar,Assam',
'Behara PT IV,Cachar,Assam',
'Bekirpar,Cachar,Assam',
'Berabak PT II,Cachar,Assam',
'Bhaga Bazar,Cachar,Assam',
'Bhairabpur,Cachar,Assam',
'Bhangarpar,Cachar,Assam',
'Bharakhai,Cachar,Assam',
'Bhuban Valley,Cachar,Assam',
'Bhubandhar T E,Cachar,Assam',
'Bhubaneswarnagar,Cachar,Assam',
'Bidyaratanpur,Cachar,Assam',
'Bilburunga,Cachar,Assam',
'Binnakandi,Cachar,Assam',
'Binnakandi Ghat,Cachar,Assam',
'Boali Basti,Cachar,Assam',
'Boaljur,Cachar,Assam',
'Borkhola,Cachar,Assam',
'Borodukan,Cachar,Assam',
'Buribail,Cachar,Assam',
'Chaligram,Cachar,Assam',
'Chandighat T E,Cachar,Assam',
'Chandpur,Cachar,Assam',
'Chandranathpur,Cachar,Assam',
'Chandrapur,Cachar,Assam',
'Channighat,Cachar,Assam',
'Chekarcham,Cachar,Assam',
'Chengjui Grant,Cachar,Assam',
'Chhoto Dudpatil,Cachar,Assam',
'Chhoto Dudpatil PT I,Cachar,Assam',
'Chhotomanda,Cachar,Assam',
'Chincuri T E,Cachar,Assam',
'Chirukandi,Cachar,Assam',
'Chittaranjan Avenue,Cachar,Assam',
'Chotojalenga,Cachar,Assam',
'Clever House,Cachar,Assam',
'Cossipur,Cachar,Assam',
'Dalu,Cachar,Assam',
'Daluagram,Cachar,Assam',
'Damcherra,Cachar,Assam',
'Darmikhal,Cachar,Assam',
'Dayapur,Cachar,Assam',
'Dayapur T E,Cachar,Assam',
'Debipur,Cachar,Assam',
'Derby,Cachar,Assam',
'Dewan,Cachar,Assam',
'Dewanji Bazar,Cachar,Assam',
'Dhakin Mohonpur,Cachar,Assam',
'Dhanehari,Cachar,Assam',
'Dhanipur,Cachar,Assam',
'Dholai Bazar,Cachar,Assam',
'Didarkush Basti,Cachar,Assam',
'Digarkhal Bazar,Cachar,Assam',
'Digor Srikona,Cachar,Assam',
'Dilkhush T E,Cachar,Assam',
'Dinanathpur,Cachar,Assam',
'Diska Grant,Cachar,Assam',
'Dudpatil,Cachar,Assam',
'Dudpur,Cachar,Assam',
'Dulalgram,Cachar,Assam',
'Dumkabazar,Cachar,Assam',
'Dumurghat,Cachar,Assam',
'Dungripar,Cachar,Assam',
'Durganagar T E,Cachar,Assam',
'Fulertal,Cachar,Assam',
'G C College,Cachar,Assam',
'Ganganagar,Cachar,Assam',
'Gangapur,Cachar,Assam',
'Ganirgram,Cachar,Assam',
'Ganirgram PT II,Cachar,Assam',
'Ghungoor Kuarpar,Cachar,Assam',
'Gojalghat,Cachar,Assam',
'Gossainagar,Cachar,Assam',
'Gossainpur PT I,Cachar,Assam',
'Govindanagar,Cachar,Assam',
'Govindapur East,Cachar,Assam',
'Govindapur West,Cachar,Assam',
'Gurudayalpur,Cachar,Assam',
'Hailakandi H.O,Cachar,Assam',
'Harinagar,Cachar,Assam',
'Harinagar Bazar,Cachar,Assam',
'Harinetilla,Cachar,Assam',
'Haticherra Grant PT VII,Cachar,Assam',
'Haticherra T E,Cachar,Assam',
'Hatikhal Bazar,Cachar,Assam',
'Hawaithang,Cachar,Assam',
'Hayairbond,Cachar,Assam',
'Hazarigram Bazar,Cachar,Assam',
'Hilara Colony,Cachar,Assam',
'Hmarkhawlin,Cachar,Assam',
'Hospital Road,Cachar,Assam',
'Irongmara Bazar,Cachar,Assam',
'Itkhola,Cachar,Assam',
'Jagadishpur,Cachar,Assam',
'Jalalpur,Cachar,Assam',
'Jamalpur,Cachar,Assam',
'Jarailtala Bazar,Cachar,Assam',
'Jhanjarbali,Cachar,Assam',
'Jhoragul,Cachar,Assam',
'Jibangram,Cachar,Assam',
'Jirighat,Cachar,Assam',
'Jogiabasti,Cachar,Assam',
'Joypur Rajabazar,Cachar,Assam',
'Joyput PT III,Cachar,Assam',
'Kabuganj Bazar,Cachar,Assam',
'Kachudaram,Cachar,Assam',
'Kachudaram PT I,Cachar,Assam',
'Kajidahar,Cachar,Assam',
'Kakmara,Cachar,Assam',
'Kalachandpur,Cachar,Assam',
'Kalain,Cachar,Assam',
'Kalaincherra,Cachar,Assam',
'Kalakhal,Cachar,Assam',
'Kamranga,Cachar,Assam',
'Kanakpur,Cachar,Assam',
'Kanakpur East,Cachar,Assam',
'Kanchanpur,Cachar,Assam',
'Kaptanpur,Cachar,Assam',
'Kaptanpur PT 18,Cachar,Assam',
'Karaikandi,Cachar,Assam',
'Karkori,Cachar,Assam',
'Katigorah,Cachar,Assam',
'Katirail,Cachar,Assam',
'Khelma PT VII,Cachar,Assam',
'Krishnapur,Cachar,Assam',
'Kumacherra,Cachar,Assam',
'Kumbhir,Cachar,Assam',
'Kumbhirgram Airport,Cachar,Assam',
'Labacpar PT III,Cachar,Assam',
'Laboc,Cachar,Assam',
'Lailapur,Cachar,Assam',
'Lakhipur,Cachar,Assam',
'Lallong,Cachar,Assam',
'Lallong T E,Cachar,Assam',
'Larsing T E,Cachar,Assam',
'Larsingpar,Cachar,Assam',
'Lathigram,Cachar,Assam',
'Lathimara,Cachar,Assam',
'Leburbond,Cachar,Assam',
'Leiri,Cachar,Assam',
'Link Road,Cachar,Assam',
'Loharband,Cachar,Assam',
'Longlacherra,Cachar,Assam',
'Machpara,Cachar,Assam',
'Machughat,Cachar,Assam',
'Madhura,Cachar,Assam',
'Madhurbond,Cachar,Assam',
'Madripar,Cachar,Assam',
'Mahadebpur PT I,Cachar,Assam',
'Mahadevpur,Cachar,Assam',
'Mahalthal,Cachar,Assam',
'Malugram,Cachar,Assam',
'Mangalpur,Cachar,Assam',
'Maniarkhal,Cachar,Assam',
'Manipur Pti,Cachar,Assam',
'Maniupr PT II,Cachar,Assam',
'Marchakhal,Cachar,Assam',
'Martycherra,Cachar,Assam',
'Matinagar,Cachar,Assam',
'Meherpur,Cachar,Assam',
'Nagar T E,Cachar,Assam',
'Nagdirgram,Cachar,Assam',
'Naraincherra,Cachar,Assam',
'Narsingpur,Cachar,Assam',
'Neairgram,Cachar,Assam',
'New Bag O Bahar,Cachar,Assam',
'Nizjoynagar,Cachar,Assam',
'Nutan Bazar,Cachar,Assam',
'Nutan Dayapur,Cachar,Assam',
'Nutan Ramnagar,Cachar,Assam',
'Pailapool,Cachar,Assam',
'Pallorbond,Cachar,Assam',
'Paloi,Cachar,Assam',
'Palonghat,Cachar,Assam',
'Pangram,Cachar,Assam',
'Panibhora,Cachar,Assam',
'Pratapur,Cachar,Assam',
'Punimukh,Cachar,Assam',
'Purandarpur,Cachar,Assam',
'Purnanagar,Cachar,Assam',
'R K Mission Road,Cachar,Assam',
'Rajartilla,Cachar,Assam',
'Rajnagar,Cachar,Assam',
'Rajyeswarpur West,Cachar,Assam',
'Rakhal Khalerpar,Cachar,Assam',
'Rammanikpur,Cachar,Assam',
'Ramnagar Tarapur,Cachar,Assam',
'Rangirkhari,Cachar,Assam',
'Ronghat PT I,Cachar,Assam',
'Rongpur PT II,Cachar,Assam',
'Rongpur,Cachar,Assam',
'Rukhni,Cachar,Assam',
'Rukhni PT I,Cachar,Assam',
'Rukhni T E,Cachar,Assam',
'Sachinpur,Cachar,Assam',
'Sadirkhal,Cachar,Assam',
'Saidpur,Cachar,Assam',
'Saidpur PT II,Cachar,Assam',
'Saint Katharine,Cachar,Assam',
'Salganga,Cachar,Assam',
'Santipur,Cachar,Assam',
'Saptagram,Cachar,Assam',
'Saradapally,Cachar,Assam',
'Sarbadaynagar,Cachar,Assam',
'Satkarakandi,Cachar,Assam',
'Sayedpur Amtala,Cachar,Assam',
'Selurpar,Cachar,Assam',
'Shyamacharanpur,Cachar,Assam',
'Sibbari Road,Cachar,Assam',
'Sibpur,Cachar,Assam',
'Silchar Court,Cachar,Assam',
'Silchar H.O,Cachar,Assam',
'Silchar Medical College,Cachar,Assam',
'Silchar REC,Cachar,Assam',
'Silcuri,Cachar,Assam',
'Sildhubi,Cachar,Assam',
'Singari,Cachar,Assam',
'Singerbond,Cachar,Assam',
'Sonabarighat,Cachar,Assam',
'Sonaimukh,Cachar,Assam',
'Sonapur,Cachar,Assam',
'Srikona,Cachar,Assam',
'Subedar Basti,Cachar,Assam',
'Subhang,Cachar,Assam',
'Suktola,Cachar,Assam',
'Sundari,Cachar,Assam',
'Sundari PT II,Cachar,Assam',
'Swastipally,Cachar,Assam',
'Tarapur Khelma,Cachar,Assam',
'Tarapur Pt VII,Cachar,Assam',
'Tarapur,Cachar,Assam',
'Thailoo,Cachar,Assam',
'Thaligram,Cachar,Assam',
'Thanjanlaikai,Cachar,Assam',
'Tikarburunga,Cachar,Assam',
'Tolengram,Cachar,Assam',
'Tulargram PT II,Cachar,Assam',
'Tupkhana,Cachar,Assam',
'Udarbond,Cachar,Assam',
'Ujan Tarapur,Cachar,Assam',
'Uttar Lalpani,Cachar,Assam',
'Uttar Sonpur,Cachar,Assam',
'Uttarkrishnapur,Cachar,Assam',
'Vivekananda Road,Cachar,Assam',
'Atterikhat,Darrang,Assam',
'Khagrabari,Darrang,Assam',
'No.2 Barangajuli,Darrang,Assam',
'No.3 Rajagarh,Darrang,Assam',
'Suklai,Darrang,Assam',
'Bhairabkunda,Darrang,Assam',
'Barbagan,Darrang,Assam',
'Bhakatpara,Darrang,Assam',
'Samuakhat,Darrang,Assam',
'Shamtilla,Darrang,Assam',
'Chakrabasti,Darrang,Assam',
'Dalgaon,Darrang,Assam',
'Jangalpara,Darrang,Assam',
'No.2 Sialmari,Darrang,Assam',
'Barigaon No.2,Darrang,Assam',
'Burargarh,Darrang,Assam',
'Burhi Nagar,Darrang,Assam',
'Chamatiapara,Darrang,Assam',
'Deodhani Ghat,Darrang,Assam',
'Deomornoi,Darrang,Assam',
'Naharbari,Darrang,Assam',
'Pati Darrang,Darrang,Assam',
'Balabari,Darrang,Assam',
'Dhula,Darrang,Assam',
'Minapara,Darrang,Assam',
'Mudoibari,Darrang,Assam',
'Dimakuchi,Darrang,Assam',
'Kalikhola,Darrang,Assam',
'Pachim Patla,Darrang,Assam',
'Andherighat,Darrang,Assam',
'Burha,Darrang,Assam',
'Duni,Darrang,Assam',
'Hengalpara,Darrang,Assam',
'Kenduguri,Darrang,Assam',
'Tengara,Darrang,Assam',
'Ambagan,Darrang,Assam',
'Barigoan,Darrang,Assam',
'Batakuchi,Darrang,Assam',
'Harisinga,Darrang,Assam',
'No.1 Amjuli,Darrang,Assam',
'Sastrapara,Darrang,Assam',
'Tamulbari,Darrang,Assam',
'Ajodhyapur,Darrang,Assam',
'Ghoghrabazar,Darrang,Assam',
'Hatigarh,Darrang,Assam',
'Teliapara,Darrang,Assam',
'Barampur Kalaigaon,Darrang,Assam',
'Barkalachowka,Darrang,Assam',
'Bhekulikanda,Darrang,Assam',
'Bherbheribill,Darrang,Assam',
'Bholabari,Darrang,Assam',
'Chengapathar,Darrang,Assam',
'Kabir Ali,Darrang,Assam',
'Kalaigaon,Darrang,Assam',
'Lakhimpur,Darrang,Assam',
'Majorchuba,Darrang,Assam',
'Outola,Darrang,Assam',
'Ranipukhuri,Darrang,Assam',
'Tengabari,Darrang,Assam',
'Galandi,Darrang,Assam',
'Ghansimali,Darrang,Assam',
'Kharupetiaghat Bazar,Darrang,Assam',
'Kharupetiaghat,Darrang,Assam',
'Kunwari Pukhuri,Darrang,Assam',
'Niz Kharupetia,Darrang,Assam',
'Punia No.1,Darrang,Assam',
'Bahmola,Darrang,Assam',
'Baralakhat,Darrang,Assam',
'Barangabari,Darrang,Assam',
'Bhirgaon,Darrang,Assam',
'Bholaguri,Darrang,Assam',
'Bogpuri,Darrang,Assam',
'Jalukbari,Darrang,Assam',
'Khoirabari,Darrang,Assam',
'Kuhiarkuchi,Darrang,Assam',
'Malmura,Darrang,Assam',
'Nichilamari,Darrang,Assam',
'Panichali,Darrang,Assam',
'Rangajuli,Darrang,Assam',
'Thakuriapara,Darrang,Assam',
'Bongaligaon,Darrang,Assam',
'Dolakati Borobazar,Darrang,Assam',
'Kopati,Darrang,Assam',
'Aminpara,Darrang,Assam',
'Bechimari,Darrang,Assam',
'Daipam,Darrang,Assam',
'Ekrabari,Darrang,Assam',
'Gerua Bazar,Darrang,Assam',
'Lalpul Bazar,Darrang,Assam',
'Padupuri Mazgaon,Darrang,Assam',
'Aulachowka,Darrang,Assam',
'Chamuapara,Darrang,Assam',
'Chapaichowka,Darrang,Assam',
'Dahinagaon,Darrang,Assam',
'Howli Mohanpur,Darrang,Assam',
'Jaljali,Darrang,Assam',
'Jonaramchowka,Darrang,Assam',
'Mangalanagar,Darrang,Assam',
'Mangaldoi H.O,Darrang,Assam',
'Rajghat,Darrang,Assam',
'Ramhari Chowka,Darrang,Assam',
'Rangamati,Darrang,Assam',
'Batabari,Darrang,Assam',
'Hoograjuli,Darrang,Assam',
'Khuchurabari,Darrang,Assam',
'Mahalia Para,Darrang,Assam',
'Mazbat,Darrang,Assam',
'Narengkati,Darrang,Assam',
'Pathakpur,Darrang,Assam',
'Raksyasmari,Darrang,Assam',
'Borjhar Bazar,Darrang,Assam',
'Dafalapota,Darrang,Assam',
'Dhansiri Bazar,Darrang,Assam',
'Jamuguri,Darrang,Assam',
'No.2 Saikia Chuburi,Darrang,Assam',
'Orang,Darrang,Assam',
'Silbori,Darrang,Assam',
'Bengbari,Darrang,Assam',
'Goriajhar,Darrang,Assam',
'Kachubilhat,Darrang,Assam',
'Panerihat,Darrang,Assam',
'Ratanpur,Darrang,Assam',
'Barampur,Darrang,Assam',
'Dighirpar,Darrang,Assam',
'Dipila Chowka,Darrang,Assam',
'Hatimara,Darrang,Assam',
'Pathorighat,Darrang,Assam',
'Santipukhuri,Darrang,Assam',
'Bhuyankhat,Darrang,Assam',
'Dalong Ghat,Darrang,Assam',
'Dhopguri,Darrang,Assam',
'Maugaon,Darrang,Assam',
'Nassansali,Darrang,Assam',
'Purani Tangla,Darrang,Assam',
'Shikari Banglow,Darrang,Assam',
'Bhalukmari,Darrang,Assam',
'Rowta Chariali,Darrang,Assam',
'Rowta,Darrang,Assam',
'Shillongkhuti,Darrang,Assam',
'Bajanapathar,Darrang,Assam',
'Bordolguri,Darrang,Assam',
'Byaspara,Darrang,Assam',
'Chengeliajhar,Darrang,Assam',
'Dhekipara,Darrang,Assam',
'Dholpur,Darrang,Assam',
'Ganesh Kunwari,Darrang,Assam',
'Garukhuti,Darrang,Assam',
'Hazarikapara,Darrang,Assam',
'Khandajan,Darrang,Assam',
'Kuruwa,Darrang,Assam',
'Maroi,Darrang,Assam',
'Marowachowka,Darrang,Assam',
'Muslimghopa,Darrang,Assam',
'Sanowa,Darrang,Assam',
'Satkhali,Darrang,Assam',
'Sipajhar,Darrang,Assam',
'Mechakapukhuri,Darrang,Assam',
'Murmela,Darrang,Assam',
'Palahgarh,Darrang,Assam',
'Purandia,Darrang,Assam',
'Tangla,Darrang,Assam',
'Bandarguri,Darrang,Assam',
'Barnagram,Darrang,Assam',
'Garaibari,Darrang,Assam',
'Kajiamati,Darrang,Assam',
'Khowrang,Darrang,Assam',
'Khuchurabari Habigaon,Darrang,Assam',
'Mazkhuti,Darrang,Assam',
'Mohanpur,Darrang,Assam',
'Nalkhamara,Darrang,Assam',
'Thana Udalguri,Darrang,Assam',
'Udalguri,Darrang,Assam',
'Bordoloni,Dibrugarh,Assam',
'Aradhal,Dibrugarh,Assam',
'Batgharia,Dibrugarh,Assam',
'Bauli,Dibrugarh,Assam',
'Bishnupur,Dibrugarh,Assam',
'Borachira Gaon,Dibrugarh,Assam',
'Borlung,Dibrugarh,Assam',
'Bulakata,Dibrugarh,Assam',
'Deuribarbam,Dibrugarh,Assam',
'Dhemaji,Dibrugarh,Assam',
'Goalchapori,Dibrugarh,Assam',
'Gohaingaon,Dibrugarh,Assam',
'Guttung,Dibrugarh,Assam',
'Hatigarh,Dibrugarh,Assam',
'Hollowdanga,Dibrugarh,Assam',
'Jairampur,Dibrugarh,Assam',
'Jamuguri Panchali,Dibrugarh,Assam',
'Jiadhal,Dibrugarh,Assam',
'Khubalia,Dibrugarh,Assam',
'Lakhipathar,Dibrugarh,Assam',
'Matikhola,Dibrugarh,Assam',
'Missamari,Dibrugarh,Assam',
'Moridhal,Dibrugarh,Assam',
'Nagakhelia,Dibrugarh,Assam',
'Perabari,Dibrugarh,Assam',
'Raiting,Dibrugarh,Assam',
'Salmari No.2,Dibrugarh,Assam',
'Samarajan Tiniali,Dibrugarh,Assam',
'Subahi,Dibrugarh,Assam',
'Mingmang,Dibrugarh,Assam',
'Nalbari Kachari,Dibrugarh,Assam',
'Kadamguri,Dibrugarh,Assam',
'Kaupatani,Dibrugarh,Assam',
'Khorachukgaon,Dibrugarh,Assam',
'Lotakigaon,Dibrugarh,Assam',
'Na Nadi Bhebeli Kahcari Gaon,Dibrugarh,Assam',
'Gali Borbali,Dibrugarh,Assam',
'Jonai,Dibrugarh,Assam',
'Kabu Chapori,Dibrugarh,Assam',
'Laimekuri,Dibrugarh,Assam',
'Leku,Dibrugarh,Assam',
'Ramdhan Dikhari,Dibrugarh,Assam',
'Ratanpur,Dibrugarh,Assam',
'Zonekareng,Dibrugarh,Assam',
'Bengenagarah,Dibrugarh,Assam',
'Dhubabari,Dibrugarh,Assam',
'Dighali Debera,Dibrugarh,Assam',
'Gohaingaon,Dibrugarh,Assam',
'Hapotia,Dibrugarh,Assam',
'Jorkata,Dibrugarh,Assam',
'Jugisuti,Dibrugarh,Assam',
'Kachari Pathar,Dibrugarh,Assam',
'Kaitung,Dibrugarh,Assam',
'Kalakata,Dibrugarh,Assam',
'Khaliamari Pamuagaon,Dibrugarh,Assam',
'Machkhowa,Dibrugarh,Assam',
'Nemutengani,Dibrugarh,Assam',
'Norowathan,Dibrugarh,Assam',
'Seujiapathar,Dibrugarh,Assam',
'Sissimukh,Dibrugarh,Assam',
'Akajan Bormuria,Dibrugarh,Assam',
'Betanipam,Dibrugarh,Assam',
'Bhagwan,Dibrugarh,Assam',
'Cementmukh,Dibrugarh,Assam',
'Madhuripathar,Dibrugarh,Assam',
'Majorbari Budhbaria Bazar,Dibrugarh,Assam',
'Silabaligaon,Dibrugarh,Assam',
'Silapathar,Dibrugarh,Assam',
'Demow Chariali,Dibrugarh,Assam',
'Dekapam,Dibrugarh,Assam',
'Dipa,Dibrugarh,Assam',
'Simen Chapori,Dibrugarh,Assam',
'Somkong Pagar,Dibrugarh,Assam',
'Talem,Dibrugarh,Assam',
'Aktai,Dibrugarh,Assam',
'Batuamukh,Dibrugarh,Assam',
'Bhebeli Gaon,Dibrugarh,Assam',
'Burisuti,Dibrugarh,Assam',
'Dhunaguri Borgaya Deori Gaon,Dibrugarh,Assam',
'Janakalyan Chariali,Dibrugarh,Assam',
'Kerekani Majgaon,Dibrugarh,Assam',
'Kulajan Tiniali,Dibrugarh,Assam',
'Mechaki Tongani Mirigaon,Dibrugarh,Assam',
'Muktiar Chapori,Dibrugarh,Assam',
'Namgharia,Dibrugarh,Assam',
'Nilakh Chariali,Dibrugarh,Assam',
'Pipalguri,Dibrugarh,Assam',
'Pukia,Dibrugarh,Assam',
'Ramyapur,Dibrugarh,Assam',
'Sissiborgaon,Dibrugarh,Assam',
'Palengi Pachali,Dibrugarh,Assam',
'Jhagrarpar,Goalpara,Assam',
'Chagolia,Goalpara,Assam',
'Satrasal,Goalpara,Assam',
'Agomoni,Goalpara,Assam',
'Bidyardabri,Goalpara,Assam',
'Chatoguma,Goalpara,Assam',
'Dighaltari,Goalpara,Assam',
'Jhapsabari,Goalpara,Assam',
'Jhaskal,Goalpara,Assam',
'Kaimari,Goalpara,Assam',
'Kaldoba,Goalpara,Assam',
'Kherbari,Goalpara,Assam',
'Mahamayahat,Goalpara,Assam',
'Maragadadhar,Goalpara,Assam',
'Pabarchara,Goalpara,Assam',
'Pokalagi,Goalpara,Assam',
'South Jhapsabari,Goalpara,Assam',
'Bagribari,Goalpara,Assam',
'Sidalsati,Goalpara,Assam',
'Bashbari,Goalpara,Assam',
'Dhanpur,Goalpara,Assam',
'Duligaon,Goalpara,Assam',
'Haraltari,Goalpara,Assam',
'Lakhiganj Bazar,Goalpara,Assam',
'Sapatgram,Goalpara,Assam',
'Tipkai,Goalpara,Assam',
'Monglajhora,Goalpara,Assam',
'Chapar,Goalpara,Assam',
'Alamganj,Goalpara,Assam',
'Boraibari Pt- V,Goalpara,Assam',
'Borshijhora,Goalpara,Assam',
'Debitola,Goalpara,Assam',
'Geramari,Goalpara,Assam',
'Jharnerchar,Goalpara,Assam',
'Kazigaon,Goalpara,Assam',
'Khopati,Goalpara,Assam',
'Podmeralga,Goalpara,Assam',
'Rangamati,Goalpara,Assam',
'Aironjongla,Goalpara,Assam',
'Amco Road,Goalpara,Assam',
'Bidyapara,Goalpara,Assam',
'Chagalchara,Goalpara,Assam',
'Dharmasala,Goalpara,Assam',
'Dhubri Balurchar,Goalpara,Assam',
'Dhubri Bazar,Goalpara,Assam',
'Dhubri H.O,Goalpara,Assam',
'Falimari Pt-i,Goalpara,Assam',
'Howrarpar,Goalpara,Assam',
'Khalilpur,Goalpara,Assam',
'Majerchar,Goalpara,Assam',
'Muthakhowa,Goalpara,Assam',
'Patamari,Goalpara,Assam',
'Tistarpar,Goalpara,Assam',
'Dhanuagaon,Goalpara,Assam',
'Fekamari,Goalpara,Assam',
'Fulerchar,Goalpara,Assam',
'Hatsingimari,Goalpara,Assam',
'Hazirhat,Goalpara,Assam',
'Kalapani,Goalpara,Assam',
'Kanaimara,Goalpara,Assam',
'Kokradanga,Goalpara,Assam',
'Manullapara,Goalpara,Assam',
'Muhurirchar,Goalpara,Assam',
'Nilokhia,Goalpara,Assam',
'Piazbari,Goalpara,Assam',
'Purandiara,Goalpara,Assam',
'Sukchar,Goalpara,Assam',
'Baladoba,Goalpara,Assam',
'Barundanga,Goalpara,Assam',
'Belguri,Goalpara,Assam',
'Bhatipetla,Goalpara,Assam',
'Bichandai,Goalpara,Assam',
'Bishkhowa,Goalpara,Assam',
'Borocharaikhola,Goalpara,Assam',
'Dafarpur,Goalpara,Assam',
'Debottar Hasdaha,Goalpara,Assam',
'Golakganj,Goalpara,Assam',
'Kachakhana,Goalpara,Assam',
'Kacharihat,Goalpara,Assam',
'Kismat Hasdaha,Goalpara,Assam',
'Lakhimari,Goalpara,Assam',
'Molandubi,Goalpara,Assam',
'Moterjhar,Goalpara,Assam',
'Paglahat,Goalpara,Assam',
'Raipur,Goalpara,Assam',
'Ratiadaha,Goalpara,Assam',
'Sonahat,Goalpara,Assam',
'Tokrerchara,Goalpara,Assam',
'Dimakuri,Goalpara,Assam',
'Bondihana,Goalpara,Assam',
'Choudhurirchar,Goalpara,Assam',
'Gutipara,Goalpara,Assam',
'Khanabari Araiani,Goalpara,Assam',
'Mahamayadham,Goalpara,Assam',
'Piazbari Makrijhora,Goalpara,Assam',
'Barkona,Goalpara,Assam',
'Jhowdanga,Goalpara,Assam',
'Kakripara,Goalpara,Assam',
'Mankachar,Goalpara,Assam',
'Radhamadhabhat,Goalpara,Assam',
'Bangalipara,Goalpara,Assam',
'Barkanda,Goalpara,Assam',
'Bilasipara,Goalpara,Assam',
'Boalkamari,Goalpara,Assam',
'Chirakuti Pt-i,Goalpara,Assam',
'Dhirbil,Goalpara,Assam',
'Gashbari,Goalpara,Assam',
'Gobardhanpara,Goalpara,Assam',
'Hakama,Goalpara,Assam',
'Hatipota,Goalpara,Assam',
'Jalabila,Goalpara,Assam',
'Jamduar,Goalpara,Assam',
'Kadamtala Pt-IIi,Goalpara,Assam',
'Kajaikata,Goalpara,Assam',
'Nayeralga,Goalpara,Assam',
'Salkocha,Goalpara,Assam',
'Silgara,Goalpara,Assam',
'Suapata,Goalpara,Assam',
'Tilapara,Goalpara,Assam',
'South Geramari,Goalpara,Assam',
'Tiamari,Goalpara,Assam',
'Asharikandi,Goalpara,Assam',
'Balajan,Goalpara,Assam',
'Banyaguri,Goalpara,Assam',
'Gauripur,Goalpara,Assam',
'Khudimari,Goalpara,Assam',
'Madhusoulmari,Goalpara,Assam',
'Rupsi,Goalpara,Assam',
'Sahebganj Naicherkuti,Goalpara,Assam',
'Silairpar,Goalpara,Assam',
'Kheluapara,Goalpara,Assam',
'Raijhora Bahalpur,Goalpara,Assam',
'Simlabari,Goalpara,Assam',
'Airkata Bazar,Goalpara,Assam',
'Barkaila Serso,Goalpara,Assam',
'Bauskata,Goalpara,Assam',
'Chirakuti Bazar,Goalpara,Assam',
'Dhumerghat,Goalpara,Assam',
'Fakirganj,Goalpara,Assam',
'Hamidabad,Goalpara,Assam',
'Jamadarhat,Goalpara,Assam',
'Khalisabhita,Goalpara,Assam',
'Madartari,Goalpara,Assam',
'Patakata,Goalpara,Assam',
'Pocharchar,Goalpara,Assam',
'Ravatari,Goalpara,Assam',
'Salmara South,Goalpara,Assam',
'Sarkarergaon,Goalpara,Assam',
'Simlabari,Goalpara,Assam',
'Tumni,Goalpara,Assam',
'Aghunibari,Dibrugarh,Assam',
'Baji Pohumara,Dibrugarh,Assam',
'Bamunbari,Dibrugarh,Assam',
'Borpathar,Dibrugarh,Assam',
'Diksam Ouphulia,Dibrugarh,Assam',
'Domur Dolong,Dibrugarh,Assam',
'Garbandhi Bamunpukhuri,Dibrugarh,Assam',
'Garpthar,Dibrugarh,Assam',
'Kekuri Sonowal,Dibrugarh,Assam',
'Lengeri Bazar,Dibrugarh,Assam',
'Nachani,Dibrugarh,Assam',
'Nahahpara Barbil,Dibrugarh,Assam',
'Nemupathar,Dibrugarh,Assam',
'Ouphulia Chariali,Dibrugarh,Assam',
'Sologuri,Dibrugarh,Assam',
'Balaibari,Dibrugarh,Assam',
'Barbam,Dibrugarh,Assam',
'Bam Kolakhowa,Dibrugarh,Assam',
'Barbaruah,Dibrugarh,Assam',
'Deurigaon,Dibrugarh,Assam',
'Dighaliagaon,Dibrugarh,Assam',
'Garudharia,Dibrugarh,Assam',
'Ghoorania,Dibrugarh,Assam',
'Gohaingaon,Dibrugarh,Assam',
'Itakhuli,Dibrugarh,Assam',
'Kalakhowa Chariali,Dibrugarh,Assam',
'Lalmati Gaon,Dibrugarh,Assam',
'Lezai,Dibrugarh,Assam',
'Medela,Dibrugarh,Assam',
'Balijan North Te,Dibrugarh,Assam',
'Bhardhara,Tinsukia,Assam',
'Bismile,Dibrugarh,Assam',
'Bogdung,Tinsukia,Assam',
'Chabua Air Field,Dibrugarh,Assam',
'Chabua,Dibrugarh,Assam',
'Chetia Gaon,Dibrugarh,Assam',
'Dinjoy,Dibrugarh,Assam',
'Hatiali Siding,Dibrugarh,Assam',
'Kanjikhowa,Tinsukia,Assam',
'Matiakhana,Dibrugarh,Assam',
'Pakharijania,Dibrugarh,Assam',
'Pulunga,Dibrugarh,Assam',
'Rang Changi,Dibrugarh,Assam',
'Assam Medical College,Dibrugarh,Assam',
'Bairagimath,Dibrugarh,Assam',
'Bamunibill,Dibrugarh,Assam',
'Banipur,Dibrugarh,Assam',
'Barpathar,Dibrugarh,Assam',
'Behating Tiniali,Dibrugarh,Assam',
'Bhurburi,Dibrugarh,Assam',
'Bogibil,Dibrugarh,Assam',
'Central Revenue Building,Dibrugarh,Assam',
'Chaulkhowa,Dibrugarh,Assam',
'Chowkidingee,Dibrugarh,Assam',
'Dhamalgaon,Dibrugarh,Assam',
'Dibrugarh H.O,Dibrugarh,Assam',
'Dibrugarh University,Dibrugarh,Assam',
'Graham Bazar,Dibrugarh,Assam',
'Harak Pathar,Dibrugarh,Assam',
'Hiloidhari,Dibrugarh,Assam',
'Jagoloni Grant,Dibrugarh,Assam',
'Jalan Nagar,Dibrugarh,Assam',
'Jamirah,Dibrugarh,Assam',
'Jokai,Dibrugarh,Assam',
'Jokai Bongaon,Dibrugarh,Assam',
'Kadamoni,Dibrugarh,Assam',
'Khaliamari,Dibrugarh,Assam',
'Khamti Ghat,Dibrugarh,Assam',
'Khania Gaon,Dibrugarh,Assam',
'Konwar Handique Gaon,Dibrugarh,Assam',
'Kumar Gaon,Dibrugarh,Assam',
'Mancotta,Dibrugarh,Assam',
'Mohanaghat,Dibrugarh,Assam',
'Naliapool,Dibrugarh,Assam',
'Nirmaligaon,Dibrugarh,Assam',
'Panchali,Dibrugarh,Assam',
'Purnananda Road,Dibrugarh,Assam',
'Raja Bheta,Dibrugarh,Assam',
'Ratanpur,Dibrugarh,Assam',
'Santipara,Dibrugarh,Assam',
'Sessa,Dibrugarh,Assam',
'Tingkhong Dighalia,Dibrugarh,Assam',
'Alimur,Dibrugarh,Assam',
'Bachapathar,Dibrugarh,Assam',
'Dighalia,Dibrugarh,Assam',
'Dihing Hola,Dibrugarh,Assam',
'Dikom,Dibrugarh,Assam',
'Garpara,Dibrugarh,Assam',
'Hazelbank,Dibrugarh,Assam',
'Mahmora,Dibrugarh,Assam',
'Moderkhat,Dibrugarh,Assam',
'Nadua,Dibrugarh,Assam',
'Oakland,Dibrugarh,Assam',
'Phukanarkhat,Dibrugarh,Assam',
'Anandapara,Dibrugarh,Assam',
'Duliajan,Dibrugarh,Assam',
'Jaloni Dibruduar,Dibrugarh,Assam',
'Kachari Pathar,Dibrugarh,Assam',
'Kathalguri,Dibrugarh,Assam',
'Kendriya Vidyalaya,Dibrugarh,Assam',
'Lilapur,Dibrugarh,Assam',
'Raja Ali,Dibrugarh,Assam',
'Tingrai Chariali,Dibrugarh,Assam',
'Jeypore Mobile,Dibrugarh,Assam',
'Kamargaon,Dibrugarh,Assam',
'Tipam,Dibrugarh,Assam',
'Ushapur,Dibrugarh,Assam',
'Khowang Chariali,Dibrugarh,Assam',
'Balai Nagaon,Dibrugarh,Assam',
'Buri Khowang,Dibrugarh,Assam',
'Dhemechi,Dibrugarh,Assam',
'Dihingia Gaon,Dibrugarh,Assam',
'Dikari Morang Gaon,Dibrugarh,Assam',
'Dikhari Kinar Gaon,Dibrugarh,Assam',
'Ghuguloni Ahumgaon,Dibrugarh,Assam',
'Gozpuria,Dibrugarh,Assam',
'Kathalguri,Dibrugarh,Assam',
'Khowang Ghat,Dibrugarh,Assam',
'Khowang,Dibrugarh,Assam',
'Kolowlowa,Dibrugarh,Assam',
'Krisipam Nigam,Dibrugarh,Assam',
'Lukumai,Dibrugarh,Assam',
'Majbam Chariali,Dibrugarh,Assam',
'Nagargaon,Dibrugarh,Assam',
'Nahazhar,Dibrugarh,Assam',
'Nakhat Sonowal Gaon,Dibrugarh,Assam',
'Padumoni Gaon No 1,Dibrugarh,Assam',
'Pathalibam,Dibrugarh,Assam',
'Rangchali,Dibrugarh,Assam',
'Sechowapukhuri,Dibrugarh,Assam',
'Sessughat,Dibrugarh,Assam',
'Silputa,Dibrugarh,Assam',
'Tarajan,Dibrugarh,Assam',
'Thengal,Dibrugarh,Assam',
'Tiloinagar,Dibrugarh,Assam',
'Tinthengia,Dibrugarh,Assam',
'Erameshlow Gaon,Dibrugarh,Assam',
'Adarsha Deurigaon,Dibrugarh,Assam',
'Baligaon,Dibrugarh,Assam',
'Barpathar Gaon,Dibrugarh,Assam',
'Bhogamurgaon,Dibrugarh,Assam',
'Chaharikata,Dibrugarh,Assam',
'Goroimari Gaon,Dibrugarh,Assam',
'Goroimarigaon,Dibrugarh,Assam',
'Haladhibari,Dibrugarh,Assam',
'Kotoha,Dibrugarh,Assam',
'Bokul,Dibrugarh,Assam',
'Chiringhula,Dibrugarh,Assam',
'Dibrugarh Polytechnic,Dibrugarh,Assam',
'Hatkhula,Dibrugarh,Assam',
'Konwaripathar,Dibrugarh,Assam',
'Lahoal,Dibrugarh,Assam',
'Melengial Gaon,Dibrugarh,Assam',
'Puthahula,Dibrugarh,Assam',
'Sarbodaya,Dibrugarh,Assam',
'Timonagaon,Dibrugarh,Assam',
'Romai Te,Dibrugarh,Assam',
'Harabari,Dibrugarh,Assam',
'Mohanbari Air Field,Dibrugarh,Assam',
'Naga Ghuli Kanaigaon,Dibrugarh,Assam',
'Konwarigaon,Dibrugarh,Assam',
'Balimora,Dibrugarh,Assam',
'Borbamgaon,Dibrugarh,Assam',
'Desam,Dibrugarh,Assam',
'Dhaman,Dibrugarh,Assam',
'Dibru Amguri,Dibrugarh,Assam',
'Dihing Kinar,Dibrugarh,Assam',
'Fakialgaon,Dibrugarh,Assam',
'Gojpuria,Dibrugarh,Assam',
'Jeypore,Dibrugarh,Assam',
'Koliapani,Dibrugarh,Assam',
'Mathawani,Dibrugarh,Assam',
'Naharkatia,Dibrugarh,Assam',
'Naoholia,Dibrugarh,Assam',
'Rangalipathar,Dibrugarh,Assam',
'Salmari,Dibrugarh,Assam',
'Sasoni,Dibrugarh,Assam',
'Tiniali Tea Estate,Dibrugarh,Assam',
'Tipling Bhadoi Gaon,Dibrugarh,Assam',
'Bhadoi Pachali,Dibrugarh,Assam',
'Bokuloni Chariali,Dibrugarh,Assam',
'Kamini Tea Estate,Dibrugarh,Assam',
'Mahmora Ali Kinar,Dibrugarh,Assam',
'Nagajan,Dibrugarh,Assam',
'Zutlibari,Dibrugarh,Assam',
'Ashabam,Dibrugarh,Assam',
'Borkhermia,Dibrugarh,Assam',
'Ghinai,Dibrugarh,Assam',
'Namrup,Dibrugarh,Assam',
'Namrup Thermal Power Station,Dibrugarh,Assam',
'Nigam,Dibrugarh,Assam',
'Silgrant,Dibrugarh,Assam',
'Parbatpur,Dibrugarh,Assam',
'Dangopara Chariali,Dibrugarh,Assam',
'Dhuapathar,Dibrugarh,Assam',
'Dirai Te,Dibrugarh,Assam',
'Kenduguri Te,Dibrugarh,Assam',
'Lachit Nagar,Dibrugarh,Assam',
'Mahkhowa,Dibrugarh,Assam',
'Pithaguti,Dibrugarh,Assam',
'Rajgarh,Dibrugarh,Assam',
'Balijan T.E.,Tinsukia,Assam',
'Bhajoni,Dibrugarh,Assam',
'Borabhayapuri,Dibrugarh,Assam',
'Chenibill Chungipathar,Dibrugarh,Assam',
'Hatibondha,Dibrugarh,Assam',
'Lengrai,Dibrugarh,Assam',
'Na Deoghoria,Dibrugarh,Assam',
'Niz Bhekulajan,Dibrugarh,Assam',
'Pan Dhua Tiniali,Dibrugarh,Assam',
'Tengakhat,Dibrugarh,Assam',
'Nilmoni Te,Dibrugarh,Assam',
'Dillibari,Dibrugarh,Assam',
'Bogadat,Dibrugarh,Assam',
'Garguri,Dibrugarh,Assam',
'Kasulugaon,Dibrugarh,Assam',
'Ouguri,Dibrugarh,Assam',
'Ratanpur,Dibrugarh,Assam',
'Sisumari Barpathar,Dibrugarh,Assam',
'Tingkhong,Dibrugarh,Assam',
'Agia,Goalpara,Assam',
'Badahapur,Goalpara,Assam',
'Baida,Goalpara,Assam',
'Balbala Kalapani,Goalpara,Assam',
'Bardamal,Goalpara,Assam',
'Barjhora,Goalpara,Assam',
'Depalsung,Goalpara,Assam',
'Dwarka,Goalpara,Assam',
'Jurigaon,Goalpara,Assam',
'Maladhara,Goalpara,Assam',
'Markula,Goalpara,Assam',
'Suarmari,Goalpara,Assam',
'Tisimpur,Goalpara,Assam',
'Manupara,Goalpara,Assam',
'Kachadal,Goalpara,Assam',
'Nishangram,Goalpara,Assam',
'Sesapani,Goalpara,Assam',
'Amjonga,Goalpara,Assam',
'Bandarshi,Goalpara,Assam',
'Damra,Goalpara,Assam',
'Darakh,Goalpara,Assam',
'Darragiri,Goalpara,Assam',
'Dudhnoi,Goalpara,Assam',
'Khusdhowa,Goalpara,Assam',
'Lela,Goalpara,Assam',
'Upartala,Goalpara,Assam',
'Baladmari,Goalpara,Assam',
'Baladmarirchar,Goalpara,Assam',
'Barbhita,Goalpara,Assam',
'Bhalukdubi,Goalpara,Assam',
'Dakurbhita,Goalpara,Assam',
'Jagibhakatgaon,Nagaon,Assam',
'Jalakiabari,Nagaon,Assam',
'Jaluguti,Nagaon,Assam',
'Jhargaon,Nagaon,Assam',
'Kachadhara Nakhanda,Nagaon,Assam',
'Kapahera,Nagaon,Assam',
'Karatipam,Nagaon,Assam',
'Katanigaon,Nagaon,Assam',
'Khaplangkuchi,Nagaon,Assam',
'Khulagaon,Nagaon,Assam',
'Killing Valley,Nagaon,Assam',
'Komoraguri,Nagaon,Assam',
'Kuranibori,Nagaon,Assam',
'Lahorighat,Nagaon,Assam',
'Lochanabori,Nagaon,Assam',
'Manaha Kacharigaon,Nagaon,Assam',
'Manipur,Nagaon,Assam',
'Mayang Kamarpur,Nagaon,Assam',
'Mikirbheta,Nagaon,Assam',
'Moirabari,Nagaon,Assam',
'Morigaon,Nagaon,Assam',
'Nagabandha,Nagaon,Assam',
'Natuagaon,Nagaon,Assam',
'Natun Bangalbori,Nagaon,Assam',
'Nellie,Nagaon,Assam',
'Nizdandua,Nagaon,Assam',
'No.1 Gayangaon,Nagaon,Assam',
'Patidaya,Nagaon,Assam',
'Patrabori,Nagaon,Assam',
'Patsari,Nagaon,Assam',
'Patuakata,Nagaon,Assam',
'Raja Mayang,Nagaon,Assam',
'Ramjanati,Nagaon,Assam',
'Sagunbahipathar,Nagaon,Assam',
'Sahariagaon,Nagaon,Assam',
'Salkati Pathar,Nagaon,Assam',
'Sapmarigaon,Nagaon,Assam',
'Sarubori,Nagaon,Assam',
'Satiantoli,Nagaon,Assam',
'Silchung,Nagaon,Assam',
'Solmari Mikirgaon,Nagaon,Assam',
'Sukdal Sarubori,Nagaon,Assam',
'Tarabori Kalsila Satra,Nagaon,Assam',
'Tengaguri,Nagaon,Assam',
'Tokonabori,Nagaon,Assam',
'Udari,Nagaon,Assam',
'Bharidhua,Nagaon,Assam',
'Borghuli Sapmar,Nagaon,Assam',
'Burhachaparigao,Nagaon,Assam',
'Dakhin Beloguri,Nagaon,Assam',
'Hatlaokhowa,Nagaon,Assam',
'Kathalguri,Nagaon,Assam',
'Kathpara Bazar,Nagaon,Assam',
'Lailuri,Nagaon,Assam',
'Ambagan,Nagaon,Assam',
'Bhuragaon,Nagaon,Assam',
'Dhing,Nagaon,Assam',
'Daboka,Nagaon,Assam',
'Ambari,Nagaon,Assam',
'Amtola,Nagaon,Assam',
'Azarbari Krishna Nagar,Nagaon,Assam',
'Barangatoli Bazar,Nagaon,Assam',
'Barhawar,Nagaon,Assam',
'Bhalukmari,Nagaon,Assam',
'Borboha,Nagaon,Assam',
'Charing,Nagaon,Assam',
'Debasthan Bazar,Nagaon,Assam',
'Dighaljar,Nagaon,Assam',
'Dimrupar,Nagaon,Assam',
'Golaghatiabasti,Nagaon,Assam',
'Gopalnagar,Nagaon,Assam',
'Hoj R.S.,Nagaon,Assam',
'Hojai Bazar,Nagaon,Assam',
'Hojai,Nagaon,Assam',
'Jogijan Bazar,Nagaon,Assam',
'Jorapukhuri,Nagaon,Assam',
'Joynagar Madrassa,Nagaon,Assam',
'Jurapukhuri,Nagaon,Assam',
'Kaki Chalchali,Nagaon,Assam',
'Kapashbari,Nagaon,Assam',
'Karayani,Nagaon,Assam',
'Komorakata,Nagaon,Assam',
'Lanka,Nagaon,Assam',
'Lumding,Nagaon,Assam',
'Murazar Bazar,Nagaon,Assam',
'Nandapur Chariali,Nagaon,Assam',
'Nilbagan,Nagaon,Assam',
'Padumpukhuri,Nagaon,Assam',
'Purana Kaki,Nagaon,Assam',
'Radhanagar,Nagaon,Assam',
'Samarail,Nagaon,Assam',
'Sankardev Nagar,Nagaon,Assam',
'Sibpur,Nagaon,Assam',
'Siliguri,Nagaon,Assam',
'Telibasti,Nagaon,Assam',
'Ulukunchi,Nagaon,Assam',
'Kuworitul,Nagaon,Assam',
'Kampur,Nagaon,Assam',
'Kathiatoli,Nagaon,Assam',
'Anneria,Nagaon,Assam',
'Derapathar,Nagaon,Assam',
'Fultoli Bazar,Nagaon,Assam',
'Gosaigaon,Nagaon,Assam',
'Hawaipur,Nagaon,Assam',
'Kaki,Nagaon,Assam',
'Kharikhana,Nagaon,Assam',
'Lachit Pathar,Nagaon,Assam',
'Lamsakhang,Nagaon,Assam',
'Lankeswarigrant,Nagaon,Assam',
'Laskarpathar,Nagaon,Assam',
'Mainapur Bazar,Nagaon,Assam',
'Nakhuti Bazar,Nagaon,Assam',
'Pipal Pukhuri,Nagaon,Assam',
'Sambari Dagaon,Nagaon,Assam',
'Sankarpur,Nagaon,Assam',
'Teralangso,Nagaon,Assam',
'Thaisupar,Nagaon,Assam',
'Tiniali Bazar,Nagaon,Assam',
'Udalani Bazar,Nagaon,Assam',
'Aibheti,Nagaon,Assam',
'Akorabori,Nagaon,Assam',
'Alitangani,Nagaon,Assam',
'Amguri,Nagaon,Assam',
'Amlakhi,Nagaon,Assam',
'Amolapatty,Nagaon,Assam',
'Amoni,Nagaon,Assam',
'Amsoi Bazar,Nagaon,Assam',
'Bagamukh,Nagaon,Assam',
'Bagari,Nagaon,Assam',
'Bagariguri,Nagaon,Assam',
'Bajbatamari,Nagaon,Assam',
'Bajiagaon,Nagaon,Assam',
'Baligaon,Nagaon,Assam',
'Balikatia,Nagaon,Assam',
'Balisatra,Nagaon,Assam',
'Bamuni,Nagaon,Assam',
'Bamunijan,Nagaon,Assam',
'Barangatoli,Nagaon,Assam',
'Barapatia,Nagaon,Assam',
'Barbhagia,Nagaon,Assam',
'Barchila,Nagaon,Assam',
'Barghat,Nagaon,Assam',
'Barhampur,Nagaon,Assam',
'Barmanipur,Nagaon,Assam',
'Barpanigaon,Nagaon,Assam',
'Batadraba,Nagaon,Assam',
'Batamari,Nagaon,Assam',
'Bebejia,Nagaon,Assam',
'Bechamari,Nagaon,Assam',
'Beltola,Nagaon,Assam',
'Bengenaati,Nagaon,Assam',
'Bengenaati,Nagaon,Assam',
'Bheleoguri,Nagaon,Assam',
'Bhomoraguri,Nagaon,Assam',
'Bhomoraguri,Nagaon,Assam',
'Biharigaon,Nagaon,Assam',
'Bihlangani,Nagaon,Assam',
'Biorbheti Dhing,Nagaon,Assam',
'Borbheti,Nagaon,Assam',
'Borghuli,Nagaon,Assam',
'Borkola,Nagaon,Assam',
'Burapahar,Nagaon,Assam',
'Chakalaghat,Nagaon,Assam',
'Chakitop,Nagaon,Assam',
'Chalapathar,Nagaon,Assam',
'Chalchali,Nagaon,Assam',
'Chamuagaon,Nagaon,Assam',
'Changmaji,Nagaon,Assam',
'Chapanalla,Nagaon,Assam',
'Chaparmukh,Nagaon,Assam',
'Chatabar,Nagaon,Assam',
'Chillangani,Nagaon,Assam',
'Chitalmari Beel,Nagaon,Assam',
'Chottahaibor,Nagaon,Assam',
'Dagaon,Nagaon,Assam',
'Dakarghat,Nagaon,Assam',
'Dakhin Sangchaki,Nagaon,Assam',
'Debnarikoli,Nagaon,Assam',
'Deorigaon,Nagaon,Assam',
'Dhaniabheti,Nagaon,Assam',
'Dhing Bazar,Nagaon,Assam',
'Dhupaguri,Nagaon,Assam',
'Dighaldori,Nagaon,Assam',
'Dighali,Nagaon,Assam',
'Dighaliati,Nagaon,Assam',
'Dimaruguri,Nagaon,Assam',
'Dumaihagi Dapara,Nagaon,Assam',
'Fakali Pathar,Nagaon,Assam',
'Fulaguri,Nagaon,Assam',
'Gakhajua,Nagaon,Assam',
'Garajan Bazar,Nagaon,Assam',
'Garukhunda,Nagaon,Assam',
'Gaspara,Nagaon,Assam',
'Gatonga,Nagaon,Assam',
'Gerjaipam,Nagaon,Assam',
'Geruaati Bazar,Nagaon,Assam',
'Ghahibhatikuri,Nagaon,Assam',
'Ghehua Chalchali,Nagaon,Assam',
'Ghilani,Nagaon,Assam',
'Gosaibori,Nagaon,Assam',
'Haiborgaon,Nagaon,Assam',
'Halowagaon,Nagaon,Assam',
'Hariamukh,Nagaon,Assam',
'Hatbor,Nagaon,Assam',
'Hatichung,Nagaon,Assam',
'Hatipara,Nagaon,Assam',
'Hatipukhuri,Nagaon,Assam',
'Hatizuzua,Nagaon,Assam',
'Herapatty,Nagaon,Assam',
'Huzrangagarah,Nagaon,Assam',
'Itachali,Nagaon,Assam',
'Jajori,Nagaon,Assam',
'Jakhalabandha,Nagaon,Assam',
'Jamuguri,Nagaon,Assam',
'Jamunamukh,Nagaon,Assam',
'Jengani,Nagaon,Assam',
'Jumurmur,Nagaon,Assam',
'Jungl Block,Nagaon,Assam',
'Juria,Nagaon,Assam',
'Jurirpar,Nagaon,Assam',
'Kachamari Boragaon,Nagaon,Assam',
'Kachua,Nagaon,Assam',
'Kadomoni,Nagaon,Assam',
'Kakatigaon,Nagaon,Assam',
'Kakhorigaon,Nagaon,Assam',
'Kaliadinga,Nagaon,Assam',
'Kalongpar Halowagaon,Nagaon,Assam',
'Kanchanpur,Nagaon,Assam',
'Kandali,Nagaon,Assam',
'Kandhulimari,Nagaon,Assam',
'Kashari,Nagaon,Assam',
'Kawaimari,Nagaon,Assam',
'Khaigarh,Nagaon,Assam',
'Khutikatia,Nagaon,Assam',
'Koroiguri,Nagaon,Assam',
'Kumargaon,Nagaon,Assam',
'Kurhimari,Nagaon,Assam',
'Kuthori,Nagaon,Assam',
'Lalunggaon,Nagaon,Assam',
'Laopani,Nagaon,Assam',
'Leteripar Bazar,Nagaon,Assam',
'Lumding Bazar,Nagaon,Assam',
'Madhupur,Nagaon,Assam',
'Magurmari,Nagaon,Assam',
'Majarati,Nagaon,Assam',
'Majgaon,Nagaon,Assam',
'Majpathori,Nagaon,Assam',
'Marangialgaon,Nagaon,Assam',
'Marwaripatty,Nagaon,Assam',
'Missa,Nagaon,Assam',
'Mithapukhuripar,Nagaon,Assam',
'Modertoli,Nagaon,Assam',
'Mohkhuli,Nagaon,Assam',
'Molankata,Nagaon,Assam',
'Morikolong,Nagaon,Assam',
'Mowamari,Nagaon,Assam',
'Nagaon Girls College,Nagaon,Assam',
'Nagaon H.O,Nagaon,Assam',
'Nagaon Padel,Nagaon,Assam',
'Nibukali,Nagaon,Assam',
'Niz-dhing,Nagaon,Assam',
'Niz-narikoli,Nagaon,Assam',
'Nonoi,Nagaon,Assam',
'Oper Uzaragaon,Nagaon,Assam',
'Padumoni,Nagaon,Assam',
'Palasani,Nagaon,Assam',
'Parkup Pahar,Nagaon,Assam',
'Pathori,Nagaon,Assam',
'Patiachapari,Nagaon,Assam',
'Patiapam,Nagaon,Assam',
'Potani Gomothagaon,Nagaon,Assam',
'Pub Amarakanda,Nagaon,Assam',
'Pub Baralimari,Nagaon,Assam',
'Pub Futaljar,Nagaon,Assam',
'Pub Lumding Bazar,Nagaon,Assam',
'Pubguimari,Nagaon,Assam',
'Pubsalpara,Nagaon,Assam',
'Pubthoria,Nagaon,Assam',
'Puranigudam,Nagaon,Assam',
'Puthikhaiti,Nagaon,Assam',
'Puthimari Bazar,Nagaon,Assam',
'Rahagaon,Nagaon,Assam',
'Rangagarah,Nagaon,Assam',
'Rantholi,Nagaon,Assam',
'Rengbeng,Nagaon,Assam',
'Rowmari,Nagaon,Assam',
'Rowmari Bill,Nagaon,Assam',
'Rupahi,Nagaon,Assam',
'Saidoria,Nagaon,Assam',
'Salana,Nagaon,Assam',
'Salmora,Nagaon,Assam',
'Samaguri,Nagaon,Assam',
'Saragaon,Nagaon,Assam',
'Sarishabari,Nagaon,Assam',
'Satlanga,Nagaon,Assam',
'Seconee Borhola,Nagaon,Assam',
'Senchowa,Nagaon,Assam',
'Sibasthan,Nagaon,Assam',
'Silghat,Nagaon,Assam',
'Silpukhuri,Nagaon,Assam',
'Simaluguri,Nagaon,Assam',
'Singari Madrassa,Nagaon,Assam',
'Singia,Nagaon,Assam',
'Singimari,Nagaon,Assam',
'Solmari,Nagaon,Assam',
'Sologuri,Nagaon,Assam',
'Sonarigaon,Nagaon,Assam',
'Sonarigaon,Nagaon,Assam',
'Sutirpar,Nagaon,Assam',
'Tarabari,Nagaon,Assam',
'Teliabebejia,Nagaon,Assam',
'Teliachapari,Nagaon,Assam',
'Teliagaon,Nagaon,Assam',
'Tetelisara,Nagaon,Assam',
'Tinsukia Juria,Nagaon,Assam',
'Tuktuki,Nagaon,Assam',
'Tulashimukh,Nagaon,Assam',
'Udmari,Nagaon,Assam',
'Uriagaon,Nagaon,Assam',
'Uttar Garajan,Nagaon,Assam',
'Uttar Khatowal,Nagaon,Assam',
'Uttar Petboha,Nagaon,Assam',
'Hindu Block,Nagaon,Assam',
'Barapujia,Nagaon,Assam',
'Raha,Nagaon,Assam',
'Adabari,Nalbari,Assam',
'Adalbari,Nalbari,Assam',
'Ahopa,Nalbari,Assam',
'Allia,Nalbari,Assam',
'Angardhowa,Nalbari,Assam',
'Angarkata,Nalbari,Assam',
'Arikuchi,Nalbari,Assam',
'Baganpara,Nalbari,Assam',
'Nayabasti,Nalbari,Assam',
'Bagulamari,Nalbari,Assam',
'Bakuajari,Nalbari,Assam',
'Bala,Nalbari,Assam',
'Bali,Nalbari,Assam',
'Balikaria,Nalbari,Assam',
'Balikuchi,Nalbari,Assam',
'Balilecha,Nalbari,Assam',
'Balowa,Nalbari,Assam',
'Banagram Chowk,Nalbari,Assam',
'Barnaddi,Nalbari,Assam',
'Batsar,Nalbari,Assam',
'Bihampur,Nalbari,Assam',
'Banagram,Nalbari,Assam',
'Banbari,Nalbari,Assam',
'Banekuchi,Nalbari,Assam',
'Kukundi,Nalbari,Assam',
'Bangaon,Nalbari,Assam',
'Rampur Dekapara,Nalbari,Assam',
'Barajol,Nalbari,Assam',
'Barama,Nalbari,Assam',
'Dahkaunia,Nalbari,Assam',
'Kathalbari,Nalbari,Assam',
'Merkuchi,Nalbari,Assam',
'Murmela,Nalbari,Assam',
'Baramchari,Nalbari,Assam',
'Barbari,Nalbari,Assam',
'Baridatara,Nalbari,Assam',
'Barimakha,Nalbari,Assam',
'Barimukh,Nalbari,Assam',
'Barpit,Nalbari,Assam',
'Barsimlaguri,Nalbari,Assam',
'Bartola,Nalbari,Assam',
'Kachupathar,Nalbari,Assam',
'Pachim Kajia Gaon,Nalbari,Assam',
'Barnibari,Nalbari,Assam',
'Belsor,Nalbari,Assam',
'Bonmaza,Nalbari,Assam',
'Bennabari,Nalbari,Assam',
'Bhadra,Nalbari,Assam',
'Bhojkuchi,Nalbari,Assam',
'Burinagar,Nalbari,Assam',
'Chaibari,Nalbari,Assam',
'Amani,Nalbari,Assam',
'Chamata,Nalbari,Assam',
'Gamurimuri,Nalbari,Assam',
'Pachimchamata,Nalbari,Assam',
'Rupia Bathan,Nalbari,Assam',
'Chanda,Nalbari,Assam',
'Chandkuchi,Nalbari,Assam',
'Chechapani,Nalbari,Assam',
'Chilling,Nalbari,Assam',
'Arara,Nalbari,Assam',
'Barazara,Nalbari,Assam',
'Bardigheli,Nalbari,Assam',
'Dalbari,Nalbari,Assam',
'Dangarmakha,Nalbari,Assam',
'Darangamela,Nalbari,Assam',
'Darangapara,Nalbari,Assam',
'Debachara,Nalbari,Assam',
'Amingaon Chowk,Nalbari,Assam',
'Dhanbil,Nalbari,Assam',
'Dighaldonga,Nalbari,Assam',
'Japadang,Nalbari,Assam',
'Pakhamara,Nalbari,Assam',
'Dihira,Nalbari,Assam',
'Dirua,Nalbari,Assam',
'Barchakadal,Nalbari,Assam',
'Doomni,Nalbari,Assam',
'Jalagaon,Nalbari,Assam',
'Gandhia,Nalbari,Assam',
'Gerua,Nalbari,Assam',
'Geruapara,Nalbari,Assam',
'Ghograpar,Nalbari,Assam',
'Gobradal,Nalbari,Assam',
'Golibandha,Nalbari,Assam',
'Gopalthan,Nalbari,Assam',
'Guakuchi,Nalbari,Assam',
'Haribhanga,Nalbari,Assam',
'Hatinamati,Nalbari,Assam',
'Haziragaon,Nalbari,Assam',
'Helana,Nalbari,Assam',
'Hidilatari,Nalbari,Assam',
'Bagrihati,Nalbari,Assam',
'Deharkalakuchi,Nalbari,Assam',
'Jagra,Nalbari,Assam',
'Khakrisal,Nalbari,Assam',
'Jalkhana,Nalbari,Assam',
'Janijog,Nalbari,Assam',
'Jaysagar,Nalbari,Assam',
'Kaithalkuchi,Nalbari,Assam',
'Kakaya,Nalbari,Assam',
'Kalag,Nalbari,Assam',
'Kalipur,Nalbari,Assam',
'Kaljar,Nalbari,Assam',
'Arangmow,Nalbari,Assam',
'Athgharia,Nalbari,Assam',
'Kamarkuchi,Nalbari,Assam',
'Kaplabari,Nalbari,Assam',
'Karemura,Nalbari,Assam',
'Karia,Nalbari,Assam',
'Kauli,Nalbari,Assam',
'Kekankuchi,Nalbari,Assam',
'Kendukuchi,Nalbari,Assam',
'Khgrabari,Nalbari,Assam',
'Kharsitha,Nalbari,Assam',
'Kharua,Nalbari,Assam',
'Khatikuchi,Nalbari,Assam',
'Kumarikata,Nalbari,Assam',
'Larkuchi,Nalbari,Assam',
'Loharkata,Nalbari,Assam',
'Lowtola,Nalbari,Assam',
'Madhapur,Nalbari,Assam',
'Bagalsroad Chowk,Nalbari,Assam',
'Barkuriha,Nalbari,Assam',
'Budrukuchi,Nalbari,Assam',
'Marowa,Nalbari,Assam',
'Pubkalakuchi,Nalbari,Assam',
'Medaghat,Nalbari,Assam',
'Menaka,Nalbari,Assam',
'Barkhanajan,Nalbari,Assam',
'Chengoi,Nalbari,Assam',
'Milanpur,Nalbari,Assam',
'Motipur,Nalbari,Assam',
'Mugkuchi,Nalbari,Assam',
'Bhangnamari,Nalbari,Assam',
'Dagapara,Nalbari,Assam',
'Kandhbari,Nalbari,Assam',
'Lowpara,Nalbari,Assam',
'Meritary,Nalbari,Assam',
'Mukalmua,Nalbari,Assam',
'Narayanpur,Nalbari,Assam',
'Muktapur,Nalbari,Assam',
'Mularkuchi,Nalbari,Assam',
'Kataligaon,Nalbari,Assam',
'Mussalpur,Nalbari,Assam',
'Narayanpur,Nalbari,Assam',
'Nagrijuli,Nalbari,Assam',
'Bidyapur,Nalbari,Assam',
'Chowkbazar,Nalbari,Assam',
'Gopalbazar,Nalbari,Assam',
'Kazipara,Nalbari,Assam',
'Khatabari,Nalbari,Assam',
'Nalbari H.O,Nalbari,Assam',
'Nizpakoa,Nalbari,Assam',
'Nankarbhaira,Nalbari,Assam',
'Narua,Nalbari,Assam',
'Nathkuchi,Nalbari,Assam',
'Nikashi,Nalbari,Assam',
'Assam Syntex,Nalbari,Assam',
'Niz Namati,Nalbari,Assam',
'Niz Bahjani,Nalbari,Assam',
'Nizdhamdhama,Nalbari,Assam',
'Nizbangalipara,Nalbari,Assam',
'Paharpur,Nalbari,Assam',
'Pakribari,Nalbari,Assam',
'Panigaon,Nalbari,Assam',
'Patkijuli,Nalbari,Assam',
'Pub Baramchari,Nalbari,Assam',
'Rampur,Nalbari,Assam',
'Sandheli,Nalbari,Assam',
'Sanekuchi,Nalbari,Assam',
'Sathimuka,Nalbari,Assam',
'Saukuchi,Nalbari,Assam',
'Solmara,Nalbari,Assam',
'Sondha,Nalbari,Assam',
'Suradi,Nalbari,Assam',
'Tambulpur,Nalbari,Assam',
'Terechia,Nalbari,Assam',
'Thamna,Nalbari,Assam',
'Thanguri,Nalbari,Assam',
'Tihu,Nalbari,Assam',
'Ulabari,Nalbari,Assam',
'Amayapur,Nalbari,Assam',
'Athiabari,Nalbari,Assam',
'Bagrikuthi,Nalbari,Assam',
'Balitara,Nalbari,Assam',
'Bamunbari,Nalbari,Assam',
'Barenghati,Nalbari,Assam',
'Barghopa,Nalbari,Assam',
'Barkhopa,Nalbari,Assam',
'Bhaluki,Nalbari,Assam',
'Bori,Nalbari,Assam',
'Chatama,Nalbari,Assam',
'Chinadi,Nalbari,Assam',
'Dakhingaon,Nalbari,Assam',
'Dangarkuchi,Nalbari,Assam',
'Daulasal,Nalbari,Assam',
'Dhekipota,Nalbari,Assam',
'Dhuhi,Nalbari,Assam',
'Digheli,Nalbari,Assam',
'Dongpar,Nalbari,Assam',
'Dumuria,Nalbari,Assam',
'Gandhibari,Nalbari,Assam',
'Garamdew,Nalbari,Assam',
'Ghogpar,Nalbari,Assam',
'Helacha,Nalbari,Assam',
'Jalkhana,Nalbari,Assam',
'Kachubari,Nalbari,Assam',
'Kachukata,Nalbari,Assam',
'Kalarchar,Nalbari,Assam',
'Kalaskuchi,Nalbari,Assam',
'Kalbari,Nalbari,Assam',
'Kalcheni,Nalbari,Assam',
'Kamrupbarkhola,Nalbari,Assam',
'Lachima,Nalbari,Assam',
'Lafakuxchi,Nalbari,Assam',
'Lahkarpara,Nalbari,Assam',
'Lakhopur,Nalbari,Assam',
'Latibari,Nalbari,Assam',
'Mahina,Nalbari,Assam',
'Makhibaha,Nalbari,Assam',
'Mazdia,Nalbari,Assam',
'Mugdi,Nalbari,Assam',
'Naherbari,Nalbari,Assam',
'Nakhara,Nalbari,Assam',
'Natunhowly,Nalbari,Assam',
'Nichalamari,Nalbari,Assam',
'Nizdafeli,Nalbari,Assam',
'Nizsantipur,Nalbari,Assam',
'Niztapa,Nalbari,Assam',
'Pachimjargaon,Nalbari,Assam',
'Paddapar,Nalbari,Assam',
'Pamuapathar,Nalbari,Assam',
'Peradhara,Nalbari,Assam',
'Piplibari,Nalbari,Assam',
'Rampur,Nalbari,Assam',
'Raumaripathar,Nalbari,Assam',
'Saraimari,Nalbari,Assam',
'Satala,Nalbari,Assam',
'Sauramari,Nalbari,Assam',
'Sialmari,Nalbari,Assam',
'Sidhinathpur,Nalbari,Assam',
'Subankhata,Nalbari,Assam',
'Tinpukhuri,Nalbari,Assam',
'Trbitola,Nalbari,Assam',
'Ulubari,Nalbari,Assam',
'Uttarbarsiral,Nalbari,Assam',
'Uttarkuchi,Nalbari,Assam',
'Zarkona,Nalbari,Assam',
'Assam Quary,Cachar,Assam',
'Bagetar,Cachar,Assam',
'Bandarkhal,Cachar,Assam',
'Baro Mulkoi,Cachar,Assam',
'Borolabang,Cachar,Assam',
'Christiankempai,Cachar,Assam',
'Dautohaza,Cachar,Assam',
'Dehangi,Cachar,Assam',
'Dezabra,Cachar,Assam',
'Dibari,Cachar,Assam',
'Dintharveng,Cachar,Assam',
'Dittakcherra,Cachar,Assam',
'Diyumbra,Cachar,Assam',
'Dwarband,Cachar,Assam',
'Electric Veng,Cachar,Assam',
'Fengpui,Cachar,Assam',
'Garampani,Cachar,Assam',
'Govindanagar,Cachar,Assam',
'Gunjung,Cachar,Assam',
'Haflo R.S.,Cachar,Assam',
'Haflong Bazar,Cachar,Assam',
'Haflong Ptc,Cachar,Assam',
'Haflong,Cachar,Assam',
'Hajang,Cachar,Assam',
'Hange,Cachar,Assam',
'Hangrum,Cachar,Assam',
'Harengajao,Cachar,Assam',
'Hatikhali,Cachar,Assam',
'Hazadisha,Cachar,Assam',
'Impui Hindu,Cachar,Assam',
'Jatinga,Cachar,Assam',
'Jatinga Tenali,Cachar,Assam',
'Kanaan,Cachar,Assam',
'Kanabasti,Cachar,Assam',
'Kaprey,Cachar,Assam',
'Kharthang,Cachar,Assam',
'Khejurbond,Cachar,Assam',
'Khognam,Cachar,Assam',
'Laisang Bagan,Cachar,Assam',
'Langting Hasin,Cachar,Assam',
'Langting,Cachar,Assam',
'Lasang,Cachar,Assam',
'Lodikachari,Cachar,Assam',
'Longkhu,Cachar,Assam',
'Mahur,Cachar,Assam',
'Maibong,Cachar,Assam',
'Mailongdisha,Cachar,Assam',
'Mandardisha,Cachar,Assam',
'Manigipur,Cachar,Assam',
'Michidui,Cachar,Assam',
'Mouthoi,Cachar,Assam',
'Mupa,Cachar,Assam',
'Nablaidisha,Cachar,Assam',
'Narainpur,Cachar,Assam',
'Narsingwari,Cachar,Assam',
'Panch Kilometer,Cachar,Assam',
'Pangmoul,Cachar,Assam',
'Redzol,Cachar,Assam',
'Sangbar,Cachar,Assam',
'Santilla,Cachar,Assam',
'Saran,Cachar,Assam',
'Sarkari Bagan,Cachar,Assam',
'Simtuilong,Cachar,Assam',
'Sonpijang,Cachar,Assam',
'Topadisa,Cachar,Assam',
'Tulpoi,Cachar,Assam',
'Umrangshu,Cachar,Assam',
'Venzaul,Cachar,Assam',
'Wardendisha,Cachar,Assam',
'Zion,Cachar,Assam',
'Bogidole,Sibsagar,Assam',
'Amguri Haloating,Sibsagar,Assam',
'Amguri,Sibsagar,Assam',
'Betbari,Sibsagar,Assam',
'Bhojo,Sibsagar,Assam',
'Borhat,Sibsagar,Assam',
'Charing,Sibsagar,Assam',
'Demow,Sibsagar,Assam',
'Disangmukh,Sibsagar,Assam',
'Gaurisagar,Sibsagar,Assam',
'Geleky,Sibsagar,Assam',
'Hahchara,Sibsagar,Assam',
'Jhanji,Sibsagar,Assam',
'Joysagar,Sibsagar,Assam',
'Kaloogaon,Sibsagar,Assam',
'Konwarpur,Sibsagar,Assam',
'Lakowah,Sibsagar,Assam',
'Lakwah R.S.,Sibsagar,Assam',
'Moranhat,Sibsagar,Assam',
'Namtidoll,Sibsagar,Assam',
'Nazira,Sibsagar,Assam',
'Nemuguri,Sibsagar,Assam',
'Nitaipukhuri,Sibsagar,Assam',
'Ongc Colony,Sibsagar,Assam',
'Phukannagar,Sibsagar,Assam',
'Rongpurnagar,Sibsagar,Assam',
'Santak,Sibsagar,Assam',
'Sapekhati,Sibsagar,Assam',
'Sepon,Sibsagar,Assam',
'Simaluguri,Sibsagar,Assam',
'Sonari,Sibsagar,Assam',
'Suffry,Sibsagar,Assam',
'Tamulichiga,Sibsagar,Assam',
'Teokghat,Sibsagar,Assam',
'Towkok,Sibsagar,Assam',
'Bhitarual,Sibsagar,Assam',
'Borahibari,Sibsagar,Assam',
'Rajmai,Sibsagar,Assam',
'Sivasagar H.O,Sibsagar,Assam',
'Afala,Sibsagar,Assam',
'Aideopukhuri,Sibsagar,Assam',
'Ailamukh,Sibsagar,Assam',
'Akhoi Phutia,Sibsagar,Assam',
'Amkotia,Sibsagar,Assam',
'Amtoll Chintamoni,Sibsagar,Assam',
'Arjun Guri,Sibsagar,Assam',
'Athkhel,Sibsagar,Assam',
'Baghjan Grant,Sibsagar,Assam',
'Baghshumout,Sibsagar,Assam',
'Bakhor Bengena,Sibsagar,Assam',
'Baliaghat,Sibsagar,Assam',
'Bam Rajabari,Sibsagar,Assam',
'Bamunpukhuri,Sibsagar,Assam',
'Bamunpukhuri,Sibsagar,Assam',
'Banmukh,Sibsagar,Assam',
'Barbaruakhat,Sibsagar,Assam',
'Barhoiting,Sibsagar,Assam',
'Barpatra Te,Sibsagar,Assam',
'Barua Ali,Sibsagar,Assam',
'Barua Chali,Sibsagar,Assam',
'Baruagaon,Sibsagar,Assam',
'Baruanagar,Sibsagar,Assam',
'Baruatigaon,Sibsagar,Assam',
'Bauli Maidam,Sibsagar,Assam',
'Baulipukhuri Sensua,Sibsagar,Assam',
'Bekadolong,Sibsagar,Assam',
'Bengenabari,Sibsagar,Assam',
'Betena,Sibsagar,Assam',
'Bhadhara,Sibsagar,Assam',
'Bhalukaguri,Sibsagar,Assam',
'Bharali Pukhuri,Sibsagar,Assam',
'Bharalua Tiniali SVS,Sibsagar,Assam',
'Bhatiapar,Sibsagar,Assam',
'Bhogamukh,Sibsagar,Assam',
'Bhogbari Kanugaon,Sibsagar,Assam',
'Bhuyanhat,Sibsagar,Assam',
'Bihubar,Sibsagar,Assam',
'Bihubar Te,Sibsagar,Assam',
'Bishrampur,Sibsagar,Assam',
'Bokota Chand Bessa,Sibsagar,Assam',
'Bonai,Sibsagar,Assam',
'Chariali,Darrang,Assam',
'Alisinga,Darrang,Assam',
'Bhangamandir,Darrang,Assam',
'Bogipukhuri,Darrang,Assam',
'Orientoli,Darrang,Assam',
'Bakola,Darrang,Assam',
'Ameribari,Darrang,Assam',
'Balipara,Darrang,Assam',
'Godamghat,Darrang,Assam',
'Khelmati Bazar,Darrang,Assam',
'Nankey Patgaon,Darrang,Assam',
'Silonigaon,Darrang,Assam',
'Bandarmari,Darrang,Assam',
'Bakori Doloni,Darrang,Assam',
'Balijan,Darrang,Assam',
'Barangabari,Darrang,Assam',
'Brahmajan,Darrang,Assam',
'Dipara Pukhuri,Darrang,Assam',
'Gameri,Darrang,Assam',
'Helemguri,Darrang,Assam',
'Batiamari,Darrang,Assam',
'Bedeti,Darrang,Assam',
'Bihmari,Darrang,Assam',
'Borjuli Nepaligaon,Darrang,Assam',
'Buroi Ghat,Darrang,Assam',
'Janata,Darrang,Assam',
'Behali,Darrang,Assam',
'Da Besseria,Darrang,Assam',
'Besseria,Darrang,Assam',
'Da Parbatia,Darrang,Assam',
'Dipota,Darrang,Assam',
'Bapubheti,Darrang,Assam',
'Bihaguri,Darrang,Assam',
'Gabharu,Darrang,Assam',
'Pithakhowa,Darrang,Assam',
'Bahbari,Darrang,Assam',
'Bindukuri,Darrang,Assam',
'Manijharni,Darrang,Assam',
'Biswanathghat,Darrang,Assam',
'Solemari No.1,Darrang,Assam',
'Arragaon No.1,Darrang,Assam',
'Bhimdanga,Darrang,Assam',
'Borgong,Darrang,Assam',
'Cherelia,Darrang,Assam',
'Gangmouthan,Darrang,Assam',
'Rampur Darrang,Darrang,Assam',
'Borjuli,Darrang,Assam',
'Dhendoi,Darrang,Assam',
'Fulaguri,Darrang,Assam',
'Borsola,Darrang,Assam',
'Lahorijan,Darrang,Assam',
'Lehugaon,Darrang,Assam',
'Monabari,Darrang,Assam',
'Panibharal,Darrang,Assam',
'Sakomato,Darrang,Assam',
'Aujuli Rangagora,Darrang,Assam',
'Chariduar,Darrang,Assam',
'Chengelimara,Darrang,Assam',
'Gamani,Darrang,Assam',
'Uttar Amloga,Darrang,Assam',
'Burigong,Darrang,Assam',
'Gelapukhuri,Darrang,Assam',
'Geruabari,Darrang,Assam',
'Kunwari,Darrang,Assam',
'Batashipur,Darrang,Assam',
'Darrang Panbari,Darrang,Assam',
'Dibru Darrang,Darrang,Assam',
'Gormara,Darrang,Assam',
'Mejengjuli,Darrang,Assam',
'Dekargaon,Darrang,Assam',
'Rangapukhuri,Darrang,Assam',
'Solmara,Darrang,Assam',
'Chitalmari,Darrang,Assam',
'Dhekiajuli,Darrang,Assam',
'Farshipam,Darrang,Assam',
'Ghogra,Darrang,Assam',
'Keherukhanda,Darrang,Assam',
'Mitham Bangali,Darrang,Assam',
'Natun Sirajuli,Darrang,Assam',
'Palasbasti Pathar,Darrang,Assam',
'Pirakata No.2,Darrang,Assam',
'Rangagora Darrang,Darrang,Assam',
'Singri,Darrang,Assam',
'Upper Panbari,Darrang,Assam',
'Bokajan,Darrang,Assam',
'Ghoramari,Darrang,Assam',
'Mansiri,Darrang,Assam',
'Natun Baithabhonga,Darrang,Assam',
'Borjharani,Darrang,Assam',
'Gingia,Darrang,Assam',
'Ghogra Basti,Darrang,Assam',
'Gobinda Elengisatra,Darrang,Assam',
'Gohpur,Darrang,Assam',
'Kakila Chariali,Darrang,Assam',
'Magoni,Darrang,Assam',
'Milanpur,Darrang,Assam',
'Poken No.1,Darrang,Assam',
'Rajabari,Darrang,Assam',
'Simaluguri,Darrang,Assam',
'Simaluguri No.2,Darrang,Assam',
'Sonapur,Darrang,Assam',
'Amlakhi Dalani,Darrang,Assam',
'Ghahigaon Chariali,Darrang,Assam',
'Halem,Darrang,Assam',
'Karibil Bangali,Darrang,Assam',
'Kauri Pathar,Darrang,Assam',
'Mail Bazar,Darrang,Assam',
'Mukoli Gaon,Darrang,Assam',
'Hazarapar,Darrang,Assam',
'Diphalu Satra,Darrang,Assam',
'Howajan,Darrang,Assam',
'Kamdewal,Darrang,Assam',
'Kharaiguri,Darrang,Assam',
'Khatargaon,Darrang,Assam',
'Lohitmukh,Darrang,Assam',
'Rawanmukh,Darrang,Assam',
'Subansirimukh,Darrang,Assam',
'Gameripal,Darrang,Assam',
'Jamugurihat,Darrang,Assam',
'Nandikeswar,Darrang,Assam',
'Panpur,Darrang,Assam',
'Solaguri,Darrang,Assam',
'Kacharigaon,Darrang,Assam',
'Alupara,Darrang,Assam',
'Bordupsonalibari,Darrang,Assam',
'Dubia,Darrang,Assam',
'Kalabari,Darrang,Assam',
'Kalmowguri,Darrang,Assam',
'Majukuchi,Darrang,Assam',
'Mikirborachuk,Darrang,Assam',
'Pulisomoni No.1,Darrang,Assam',
'Santipur Dewrigaon,Darrang,Assam',
'Balichapori,Darrang,Assam',
'Bhojkhowa Chapori,Darrang,Assam',
'Dolabari,Darrang,Assam',
'Kaliabhomora,Darrang,Assam',
'Karsontala,Darrang,Assam',
'Balipukhuri Tiniali,Darrang,Assam',
'Barika Chuburi,Darrang,Assam',
'Nikamul Satra,Darrang,Assam',
'Khalihamari,Darrang,Assam',
'Khelmati,Darrang,Assam',
'Lokra,Darrang,Assam',
'Sonaipam,Darrang,Assam',
'Mijikajan,Darrang,Assam',
'Tinikhuti,Darrang,Assam',
'Bashbera,Darrang,Assam',
'Dhankhana,Darrang,Assam',
'Dighalijuli,Darrang,Assam',
'Garubandha,Darrang,Assam',
'Jiagabharu,Darrang,Assam',
'Missamari,Darrang,Assam',
'Nepalibasti,Darrang,Assam',
'Nagshankar,Darrang,Assam',
'Balijuri,Darrang,Assam',
'Bordikorai,Darrang,Assam',
'Hatinga,Darrang,Assam',
'Itakhola,Darrang,Assam',
'Naharbari,Darrang,Assam',
'Towbhanga,Darrang,Assam',
'Napaam,Darrang,Assam',
'Balichang,Darrang,Assam',
'Dholi Kuhiarbari,Darrang,Assam',
'Pabhoi,Darrang,Assam',
'Salaikati,Darrang,Assam',
'Panchmile,Darrang,Assam',
'Singitoli,Darrang,Assam',
'Tengabasti,Darrang,Assam',
'Uriumguri,Darrang,Assam',
'Rangachakua,Darrang,Assam',
'Dopdopi,Darrang,Assam',
'Kailajuli,Darrang,Assam',
'Rangapara,Darrang,Assam',
'Thakurbari,Darrang,Assam',
'Urahiloga,Darrang,Assam',
'Haleswar,Darrang,Assam',
'Shalonibari,Darrang,Assam',
'Balipukhuri Joradia,Darrang,Assam',
'Biskhuti,Darrang,Assam',
'Fatasimalugaon,Darrang,Assam',
'Kacharison,Darrang,Assam',
'Mazrowmari,Darrang,Assam',
'Sirajuli,Darrang,Assam',
'Bakrapatta,Darrang,Assam',
'Bokabil,Darrang,Assam',
'Borpam Tiniali,Darrang,Assam',
'Chengamari,Darrang,Assam',
'Garpal,Darrang,Assam',
'Khanaguri,Darrang,Assam',
'Niz Sootea,Darrang,Assam',
'No.2 Ghahigaon,Darrang,Assam',
'No.3 Nalbari,Darrang,Assam',
'Pratapgarh,Darrang,Assam',
'Samardalani,Darrang,Assam',
'Solal Sonari,Darrang,Assam',
'Sootea,Darrang,Assam',
'Tewaripal,Darrang,Assam',
'Balijan Barua,Darrang,Assam',
'Daflagarh,Darrang,Assam',
'Tetenbari,Darrang,Assam',
'Kalibari,Darrang,Assam',
'Ketekibari,Darrang,Assam',
'Mahabhairab,Darrang,Assam',
'Sonitpur,Darrang,Assam',
'Tezpur Bazar,Darrang,Assam',
'Tezpur H.O,Darrang,Assam',
'Bargaon,Darrang,Assam',
'Bhergaon Kochgaon,Darrang,Assam',
'Borbil Kachari,Darrang,Assam',
'Garuduba,Darrang,Assam',
'Ghatua,Darrang,Assam',
'Jahamari,Darrang,Assam',
'Kalakuchi,Darrang,Assam',
'Silikhabari,Darrang,Assam',
'Teliagaon,Darrang,Assam',
'Thelamara,Darrang,Assam',
'Ulubari,Darrang,Assam',
'Dinjan,Tinsukia,Assam',
'Panitola,Tinsukia,Assam',
'Amarpur,Tinsukia,Assam',
'Buraburi Than,Tinsukia,Assam',
'Islampur,Tinsukia,Assam',
'Kukuremara,Tinsukia,Assam',
'Kundil,Tinsukia,Assam',
'Natun Balijan,Tinsukia,Assam',
'Sadiya,Tinsukia,Assam',
'Saikhowaghat,Tinsukia,Assam',
'Santipur Bazar,Tinsukia,Assam',
'Amguri,Tinsukia,Assam',
'Arunodaya,Tinsukia,Assam',
'Borali,Tinsukia,Assam',
'Bordoloinagar,Tinsukia,Assam',
'Bordubi Te,Tinsukia,Assam',
'Doom Dooma,Tinsukia,Assam',
'Hahkhati,Tinsukia,Assam',
'Hatighuli,Tinsukia,Assam',
'Kachari Maithong,Tinsukia,Assam',
'Kordoiguri,Tinsukia,Assam',
'Laupati,Tinsukia,Assam',
'Megela,Tinsukia,Assam',
'Phillobari,Tinsukia,Assam',
'Santipur,Tinsukia,Assam',
'Sukriting,Tinsukia,Assam',
'Talap,Tinsukia,Assam',
'Aroimuria,Tinsukia,Assam',
'Barhapjan,Tinsukia,Assam',
'Bordirak,Tinsukia,Assam',
'Bormuchai,Tinsukia,Assam',
'Chellenguri,Tinsukia,Assam',
'Dangrigaon,Tinsukia,Assam',
'Dighal Tarrang,Tinsukia,Assam',
'Dirak Maithong,Tinsukia,Assam',
'Dohotiagaon,Tinsukia,Assam',
'Gakhirbheti,Tinsukia,Assam',
'Gobarbheti,Tinsukia,Assam',
'Hansara,Tinsukia,Assam',
'Kakapathar,Tinsukia,Assam',
'Kakojan,Tinsukia,Assam',
'Kashijan,Tinsukia,Assam',
'Koomsang,Tinsukia,Assam',
'Lainagaon,Tinsukia,Assam',
'Makum Junction,Tinsukia,Assam',
'Netaji Road,Tinsukia,Assam',
'Rupaisiding,Tinsukia,Assam',
'Rupbon,Tinsukia,Assam',
'Sarudhadum,Tinsukia,Assam',
'Tinali Nowgong,Tinsukia,Assam',
'Tonganabazar,Tinsukia,Assam',
'Tonganagaon,Tinsukia,Assam',
'Bisagaon,Tinsukia,Assam',
'3 No Borbil,Tinsukia,Assam',
'Adarshgaon,Tinsukia,Assam',
'Agbandha Bengali Gaon,Tinsukia,Assam',
'Alubari,Tinsukia,Assam',
'Balijan,Tinsukia,Assam',
'Barhullung,Tinsukia,Assam',
'Barmajan,Tinsukia,Assam',
'Bhimpathar,Tinsukia,Assam',
'Bishnupur,Tinsukia,Assam',
'Borgolai,Tinsukia,Assam',
'Challet,Tinsukia,Assam',
'Chikarajan,Tinsukia,Assam',
'Dhekiajan,Tinsukia,Assam',
'Dibong,Tinsukia,Assam',
'Digboi Charali,Tinsukia,Assam',
'Digboi,Tinsukia,Assam',
'Golai,Tinsukia,Assam',
'Hamuk Jan,Tinsukia,Assam',
'Hollong Gutibari,Tinsukia,Assam',
'Inthemgaon,Tinsukia,Assam',
'Jagun,Tinsukia,Assam',
'Jubilee Digboi,Tinsukia,Assam',
'Kailash Pur,Tinsukia,Assam',
'Kathalguri,Tinsukia,Assam',
'Ketetong,Tinsukia,Assam',
'Kumchai,Tinsukia,Assam',
'Laklapathar,Tinsukia,Assam',
'Lamagaon,Tinsukia,Assam',
'Ledo,Tinsukia,Assam',
'Ledo Tikok,Tinsukia,Assam',
'Lekhapani,Tinsukia,Assam',
'Long Gaon,Tinsukia,Assam',
'Makum Pathar,Tinsukia,Assam',
'Makumkilla,Tinsukia,Assam',
'Margherita New Colony,Tinsukia,Assam',
'Margherita,Tinsukia,Assam',
'Muliabari,Tinsukia,Assam',
'Mullang,Tinsukia,Assam',
'Navajyoti,Tinsukia,Assam',
'Nazirating,Tinsukia,Assam',
'Pengri,Tinsukia,Assam',
'Purani Pukhuri,Tinsukia,Assam',
'Rampur,Tinsukia,Assam',
'Talpathar,Tinsukia,Assam',
'Tipong,Tinsukia,Assam',
'Tirap,Tinsukia,Assam',
'Udai Pur,Tinsukia,Assam',
'Ulup Gaon,Tinsukia,Assam',
'Chapakhowa,Tinsukia,Assam',
'Ashok Nagar,Tinsukia,Assam',
'Baghbari Gaon,Tinsukia,Assam',
'Barchapri,Tinsukia,Assam',
'Baruahola,Tinsukia,Assam',
'Bisfootia,Tinsukia,Assam',
'Bogapani,Tinsukia,Assam',
'Borgaon,Tinsukia,Assam',
'Borguri,Tinsukia,Assam',
'Chalihanagar,Tinsukia,Assam',
'Dihingia Gaon,Tinsukia,Assam',
'Durgabari,Tinsukia,Assam',
'Gahoripam,Tinsukia,Assam',
'Gellapukhuri,Tinsukia,Assam',
'Hijiguri,Tinsukia,Assam',
'Hoogrijan,Tinsukia,Assam',
'Kadamoni,Tinsukia,Assam',
'Khamti Gowali,Tinsukia,Assam',
'Khetopathargaon,Tinsukia,Assam',
'Kukurekhowa,Tinsukia,Assam',
'Laika,Tinsukia,Assam',
'Laipuli,Tinsukia,Assam',
'Limbuguri,Tinsukia,Assam',
'Lohari,Tinsukia,Assam',
'Mamorani,Tinsukia,Assam',
'Mankhooli,Tinsukia,Assam',
'Mulukgaon,Tinsukia,Assam',
'Pakharijan,Tinsukia,Assam',
'Parbotia,Tinsukia,Assam',
'Powai,Tinsukia,Assam',
'Prakash Bazar,Tinsukia,Assam',
'Rangagora,Tinsukia,Assam',
'Samdang,Tinsukia,Assam',
'Senairam Bazar,Tinsukia,Assam',
'Sripuria Bengali Gaon,Tinsukia,Assam',
'Sripuria,Tinsukia,Assam',
'Sukhanpukhuri,Tinsukia,Assam',
'Tingrai,Tinsukia,Assam',
'Tinsukia H.O,Tinsukia,Assam',
'Lakhipather,Tinsukia,Assam',
'Branch Post Office,Purnea,Bihar',
'Sub Post Office,Purnea,Bihar',
'Branch Post Office,Purnea,Bihar',
'Branch Post Office,Purnea,Bihar',
'Branch Post Office,Purnea,Bihar',
'Branch Post Office,Purnea,Bihar',
'Sub Post Office,Purnea,Bihar',
'Sub Post Office,Purnea,Bihar',
'Branch Post Office,Purnea,Bihar',
'Branch Post Office,Purnea,Bihar',
'Branch Post Office,Purnea,Bihar',
'Branch Post Office,Purnea,Bihar',
'Branch Post Office,Purnea,Bihar',
'Branch Post Office,Purnea,Bihar',
'Branch Post Office,Purnea,Bihar',
'Branch Post Office,Purnea,Bihar',
'Branch Post Office,Purnea,Bihar',
'Branch Post Office,Purnea,Bihar',
'Branch Post Office,Purnea,Bihar',
'Branch Post Office,Purnea,Bihar',
'Branch Post Office,Purnea,Bihar',
'Branch Post Office,Purnea,Bihar',
'Sub Post Office,Purnea,Bihar',
'Branch Post Office,Purnea,Bihar',
'Branch Post Office,Purnea,Bihar',
'Branch Post Office,Purnea,Bihar',
'Branch Post Office,Purnea,Bihar',
'Branch Post Office,Purnea,Bihar',
'Branch Post Office,Purnea,Bihar',
'Branch Post Office,Purnea,Bihar',
'Branch Post Office,Purnea,Bihar',
'Branch Post Office,Purnea,Bihar',
'Branch Post Office,Purnea,Bihar',
'Branch Post Office,Purnea,Bihar',
'Branch Post Office,Purnea,Bihar',
'Branch Post Office,Purnea,Bihar',
'Branch Post Office,Purnea,Bihar',
'Branch Post Office,Purnea,Bihar',
'Branch Post Office,Purnea,Bihar',
'Branch Post Office,Purnea,Bihar',
'Branch Post Office,Purnea,Bihar',
'Branch Post Office,Purnea,Bihar',
'Branch Post Office,Purnea,Bihar',
'Branch Post Office,Purnea,Bihar',
'Branch Post Office,Purnea,Bihar',
'Branch Post Office,Purnea,Bihar',
'Branch Post Office,Purnea,Bihar',
'Branch Post Office,Purnea,Bihar',
'Sub Post Office,Purnea,Bihar',
'Branch Post Office,Purnea,Bihar',
'Branch Post Office,Purnea,Bihar',
'Branch Post Office,Purnea,Bihar',
'Branch Post Office,Purnea,Bihar',
'Branch Post Office,Purnea,Bihar',
'Branch Post Office,Purnea,Bihar',
'Branch Post Office,Purnea,Bihar',
'Branch Post Office,Purnea,Bihar',
'Branch Post Office,Purnea,Bihar',
'Branch Post Office,Purnea,Bihar',
'Branch Post Office,Purnea,Bihar',
'Branch Post Office,Purnea,Bihar',
'Branch Post Office,Purnea,Bihar',
'Branch Post Office,Purnea,Bihar',
'Branch Post Office,Purnea,Bihar',
'Sub Post Office,Purnea,Bihar',
'Sub Post Office,Purnea,Bihar',
'Branch Post Office,Purnea,Bihar',
'Branch Post Office,Purnea,Bihar',
'Branch Post Office,Purnea,Bihar',
'Branch Post Office,Purnea,Bihar',
'Branch Post Office,Purnea,Bihar',
'Branch Post Office,Purnea,Bihar',
'Branch Post Office,Purnea,Bihar',
'Branch Post Office,Purnea,Bihar',
'Branch Post Office,Purnea,Bihar',
'Branch Post Office,Purnea,Bihar',
'Branch Post Office,Purnea,Bihar',
'Sub Post Office,Purnea,Bihar',
'Branch Post Office,Purnea,Bihar',
'Sub Post Office,Purnea,Bihar',
'Branch Post Office,Purnea,Bihar',
'Branch Post Office,Purnea,Bihar',
'Branch Post Office,Purnea,Bihar',
'Sub Post Office,Purnea,Bihar',
'Branch Post Office,Purnea,Bihar',
'Branch Post Office,Purnea,Bihar',
'Branch Post Office,Purnea,Bihar',
'Branch Post Office,Purnea,Bihar',
'Branch Post Office,Purnea,Bihar',
'Branch Post Office,Purnea,Bihar',
'Branch Post Office,Purnea,Bihar',
'Branch Post Office,Purnea,Bihar',
'Sub Post Office,Purnea,Bihar',
'Branch Post Office,Purnea,Bihar',
'Branch Post Office,Purnea,Bihar',
'Branch Post Office,Purnea,Bihar',
'Branch Post Office,Purnea,Bihar',
'Branch Post Office,Purnea,Bihar',
'Branch Post Office,Purnea,Bihar',
'Branch Post Office,Purnea,Bihar',
'Branch Post Office,Purnea,Bihar',
'Branch Post Office,Purnea,Bihar',
'Sub Post Office,Purnea,Bihar',
'Branch Post Office,Purnea,Bihar',
'Branch Post Office,Purnea,Bihar',
'Branch Post Office,Purnea,Bihar',
'Branch Post Office,Purnea,Bihar',
'Branch Post Office,Purnea,Bihar',
'Branch Post Office,Purnea,Bihar',
'Branch Post Office,Purnea,Bihar',
'Branch Post Office,Purnea,Bihar',
'Branch Post Office,Purnea,Bihar',
'Branch Post Office,Purnea,Bihar',
'Branch Post Office,Purnea,Bihar',
'Branch Post Office,Purnea,Bihar',
'Branch Post Office,Purnea,Bihar',
'Branch Post Office,Purnea,Bihar',
'Branch Post Office,Purnea,Bihar',
'Branch Post Office,Purnea,Bihar',
'Branch Post Office,Purnea,Bihar',
'Branch Post Office,Purnea,Bihar',
'Branch Post Office,Purnea,Bihar',
'Branch Post Office,Purnea,Bihar',
'Branch Post Office,Purnea,Bihar',
'Branch Post Office,Purnea,Bihar',
'Branch Post Office,Purnea,Bihar',
'Branch Post Office,Purnea,Bihar',
'Sub Post Office,Purnea,Bihar',
'Branch Post Office,Purnea,Bihar',
'Branch Post Office,Purnea,Bihar',
'Branch Post Office,Purnea,Bihar',
'Branch Post Office,Purnea,Bihar',
'Branch Post Office,Purnea,Bihar',
'Branch Post Office,Purnea,Bihar',
'Branch Post Office,Purnea,Bihar',
'Branch Post Office,Purnea,Bihar',
'Branch Post Office,Purnea,Bihar',
'Branch Post Office,Purnea,Bihar',
'Branch Post Office,Purnea,Bihar',
'Branch Post Office,Purnea,Bihar',
'Branch Post Office,Purnea,Bihar',
'Branch Post Office,Purnea,Bihar',
'Branch Post Office,Purnea,Bihar',
'Branch Post Office,Purnea,Bihar',
'Branch Post Office,Purnea,Bihar',
'Branch Post Office,Purnea,Bihar',
'Sub Post Office,Aurangabad(Bihar),Bihar',
'Branch Post Office,Aurangabad(Bihar),Bihar',
'Branch Post Office,Aurangabad(Bihar),Bihar',
'Branch Post Office,Aurangabad(Bihar),Bihar',
'Branch Post Office,Aurangabad(Bihar),Bihar',
'Branch Post Office,Aurangabad(Bihar),Bihar',
'Branch Post Office,Aurangabad(Bihar),Bihar',
'Branch Post Office,Aurangabad(Bihar),Bihar',
'Branch Post Office,Aurangabad(Bihar),Bihar',
'Branch Post Office,Aurangabad(Bihar),Bihar',
'Branch Post Office,Aurangabad(Bihar),Bihar',
'Head Post Office,Aurangabad(Bihar),Bihar',
'Sub Post Office,Aurangabad(Bihar),Bihar',
'Branch Post Office,Aurangabad(Bihar),Bihar',
'Branch Post Office,Aurangabad(Bihar),Bihar',
'Branch Post Office,Aurangabad(Bihar),Bihar',
'Branch Post Office,Aurangabad(Bihar),Bihar',
'Branch Post Office,Aurangabad(Bihar),Bihar',
'Branch Post Office,Aurangabad(Bihar),Bihar',
'Sub Post Office,Aurangabad(Bihar),Bihar',
'Branch Post Office,Aurangabad(Bihar),Bihar',
'Branch Post Office,Aurangabad(Bihar),Bihar',
'Branch Post Office,Aurangabad(Bihar),Bihar',
'Branch Post Office,Aurangabad(Bihar),Bihar',
'Branch Post Office,Aurangabad(Bihar),Bihar',
'Branch Post Office,Aurangabad(Bihar),Bihar',
'Branch Post Office,Aurangabad(Bihar),Bihar',
'Branch Post Office,Aurangabad(Bihar),Bihar',
'Branch Post Office,Aurangabad(Bihar),Bihar',
'Branch Post Office,Aurangabad(Bihar),Bihar',
'Branch Post Office,Aurangabad(Bihar),Bihar',
'Branch Post Office,Aurangabad(Bihar),Bihar',
'Sub Post Office,Aurangabad(Bihar),Bihar',
'Branch Post Office,Aurangabad(Bihar),Bihar',
'Branch Post Office,Aurangabad(Bihar),Bihar',
'Branch Post Office,Aurangabad(Bihar),Bihar',
'Sub Post Office,Aurangabad(Bihar),Bihar',
'Branch Post Office,Aurangabad(Bihar),Bihar',
'Sub Post Office,Aurangabad(Bihar),Bihar',
'Branch Post Office,Aurangabad(Bihar),Bihar',
'Branch Post Office,Aurangabad(Bihar),Bihar',
'Branch Post Office,Aurangabad(Bihar),Bihar',
'Branch Post Office,Aurangabad(Bihar),Bihar',
'Branch Post Office,Aurangabad(Bihar),Bihar',
'Branch Post Office,Aurangabad(Bihar),Bihar',
'Branch Post Office,Aurangabad(Bihar),Bihar',
'Branch Post Office,Aurangabad(Bihar),Bihar',
'Branch Post Office,Aurangabad(Bihar),Bihar',
'Branch Post Office,Aurangabad(Bihar),Bihar',
'Branch Post Office,Aurangabad(Bihar),Bihar',
'Branch Post Office,Aurangabad(Bihar),Bihar',
'Branch Post Office,Aurangabad(Bihar),Bihar',
'Branch Post Office,Aurangabad(Bihar),Bihar',
'Branch Post Office,Aurangabad(Bihar),Bihar',
'Branch Post Office,Aurangabad(Bihar),Bihar',
'Branch Post Office,Aurangabad(Bihar),Bihar',
'Branch Post Office,Aurangabad(Bihar),Bihar',
'Branch Post Office,Aurangabad(Bihar),Bihar',
'Branch Post Office,Aurangabad(Bihar),Bihar',
'Sub Post Office,Aurangabad(Bihar),Bihar',
'Branch Post Office,Aurangabad(Bihar),Bihar',
'Sub Post Office,Aurangabad(Bihar),Bihar',
'Branch Post Office,Aurangabad(Bihar),Bihar',
'Branch Post Office,Aurangabad(Bihar),Bihar',
'Branch Post Office,Aurangabad(Bihar),Bihar',
'Branch Post Office,Aurangabad(Bihar),Bihar',
'Branch Post Office,Aurangabad(Bihar),Bihar',
'Branch Post Office,Aurangabad(Bihar),Bihar',
'Branch Post Office,Aurangabad(Bihar),Bihar',
'Branch Post Office,Aurangabad(Bihar),Bihar',
'Branch Post Office,Aurangabad(Bihar),Bihar',
'Branch Post Office,Aurangabad(Bihar),Bihar',
'Sub Post Office,Aurangabad(Bihar),Bihar',
'Branch Post Office,Aurangabad(Bihar),Bihar',
'Branch Post Office,Aurangabad(Bihar),Bihar',
'Branch Post Office,Aurangabad(Bihar),Bihar',
'Branch Post Office,Aurangabad(Bihar),Bihar',
'Branch Post Office,Aurangabad(Bihar),Bihar',
'Branch Post Office,Aurangabad(Bihar),Bihar',
'Branch Post Office,Aurangabad(Bihar),Bihar',
'Branch Post Office,Aurangabad(Bihar),Bihar',
'Sub Post Office,Aurangabad(Bihar),Bihar',
'Branch Post Office,Aurangabad(Bihar),Bihar',
'Branch Post Office,Aurangabad(Bihar),Bihar',
'Branch Post Office,Aurangabad(Bihar),Bihar',
'Branch Post Office,Aurangabad(Bihar),Bihar',
'Branch Post Office,Aurangabad(Bihar),Bihar',
'Sub Post Office,Aurangabad(Bihar),Bihar',
'Branch Post Office,Aurangabad(Bihar),Bihar',
'Branch Post Office,Aurangabad(Bihar),Bihar',
'Branch Post Office,Aurangabad(Bihar),Bihar',
'Branch Post Office,Aurangabad(Bihar),Bihar',
'Branch Post Office,Aurangabad(Bihar),Bihar',
'Branch Post Office,Aurangabad(Bihar),Bihar',
'Branch Post Office,Aurangabad(Bihar),Bihar',
'Branch Post Office,Aurangabad(Bihar),Bihar',
'Branch Post Office,Aurangabad(Bihar),Bihar',
'Branch Post Office,Aurangabad(Bihar),Bihar',
'Branch Post Office,Aurangabad(Bihar),Bihar',
'Branch Post Office,Aurangabad(Bihar),Bihar',
'Branch Post Office,Aurangabad(Bihar),Bihar',
'Branch Post Office,Aurangabad(Bihar),Bihar',
'Branch Post Office,Aurangabad(Bihar),Bihar',
'Branch Post Office,Aurangabad(Bihar),Bihar',
'Branch Post Office,Aurangabad(Bihar),Bihar',
'Sub Post Office,Aurangabad(Bihar),Bihar',
'Branch Post Office,Aurangabad(Bihar),Bihar',
'Branch Post Office,Aurangabad(Bihar),Bihar',
'Branch Post Office,Aurangabad(Bihar),Bihar',
'Sub Post Office,Aurangabad(Bihar),Bihar',
'Branch Post Office,Aurangabad(Bihar),Bihar',
'Branch Post Office,Aurangabad(Bihar),Bihar',
'Branch Post Office,Aurangabad(Bihar),Bihar',
'Branch Post Office,Aurangabad(Bihar),Bihar',
'Branch Post Office,Aurangabad(Bihar),Bihar',
'Branch Post Office,Aurangabad(Bihar),Bihar',
'Branch Post Office,Aurangabad(Bihar),Bihar',
'Branch Post Office,Aurangabad(Bihar),Bihar',
'Sub Post Office,Aurangabad(Bihar),Bihar',
'Branch Post Office,Aurangabad(Bihar),Bihar',
'Branch Post Office,Aurangabad(Bihar),Bihar',
'Branch Post Office,Aurangabad(Bihar),Bihar',
'Branch Post Office,Aurangabad(Bihar),Bihar',
'Branch Post Office,Aurangabad(Bihar),Bihar',
'Branch Post Office,Aurangabad(Bihar),Bihar',
'Branch Post Office,Aurangabad(Bihar),Bihar',
'Branch Post Office,Aurangabad(Bihar),Bihar',
'Branch Post Office,Aurangabad(Bihar),Bihar',
'Branch Post Office,Aurangabad(Bihar),Bihar',
'Branch Post Office,Aurangabad(Bihar),Bihar',
'Branch Post Office,Aurangabad(Bihar),Bihar',
'Branch Post Office,Aurangabad(Bihar),Bihar',
'Branch Post Office,Aurangabad(Bihar),Bihar',
'Branch Post Office,Aurangabad(Bihar),Bihar',
'Branch Post Office,Aurangabad(Bihar),Bihar',
'Branch Post Office,Aurangabad(Bihar),Bihar',
'Sub Post Office,Aurangabad(Bihar),Bihar',
'Branch Post Office,Aurangabad(Bihar),Bihar',
'Branch Post Office,Aurangabad(Bihar),Bihar',
'Branch Post Office,Aurangabad(Bihar),Bihar',
'Branch Post Office,Aurangabad(Bihar),Bihar',
'Branch Post Office,Aurangabad(Bihar),Bihar',
'Branch Post Office,Aurangabad(Bihar),Bihar',
'Sub Post Office,Aurangabad(Bihar),Bihar',
'Branch Post Office,Aurangabad(Bihar),Bihar',
'Branch Post Office,Aurangabad(Bihar),Bihar',
'Branch Post Office,Aurangabad(Bihar),Bihar',
'Branch Post Office,Aurangabad(Bihar),Bihar',
'Branch Post Office,Aurangabad(Bihar),Bihar',
'Branch Post Office,Aurangabad(Bihar),Bihar',
'Branch Post Office,Aurangabad(Bihar),Bihar',
'Branch Post Office,Aurangabad(Bihar),Bihar',
'Branch Post Office,Aurangabad(Bihar),Bihar',
'Branch Post Office,Aurangabad(Bihar),Bihar',
'Branch Post Office,Aurangabad(Bihar),Bihar',
'Branch Post Office,Aurangabad(Bihar),Bihar',
'Branch Post Office,Aurangabad(Bihar),Bihar',
'Branch Post Office,Aurangabad(Bihar),Bihar',
'Branch Post Office,Aurangabad(Bihar),Bihar',
'Sub Post Office,Aurangabad(Bihar),Bihar',
'Branch Post Office,Aurangabad(Bihar),Bihar',
'Branch Post Office,Aurangabad(Bihar),Bihar',
'Branch Post Office,Aurangabad(Bihar),Bihar',
'Branch Post Office,Aurangabad(Bihar),Bihar',
'Branch Post Office,Aurangabad(Bihar),Bihar',
'Branch Post Office,Aurangabad(Bihar),Bihar',
'Sub Post Office,Aurangabad(Bihar),Bihar',
'Branch Post Office,Aurangabad(Bihar),Bihar',
'Branch Post Office,Aurangabad(Bihar),Bihar',
'Branch Post Office,Aurangabad(Bihar),Bihar',
'Branch Post Office,Aurangabad(Bihar),Bihar',
'Branch Post Office,Aurangabad(Bihar),Bihar',
'Branch Post Office,Aurangabad(Bihar),Bihar',
'Branch Post Office,Aurangabad(Bihar),Bihar',
'Sub Post Office,Aurangabad(Bihar),Bihar',
'Branch Post Office,Aurangabad(Bihar),Bihar',
'Branch Post Office,Aurangabad(Bihar),Bihar',
'Branch Post Office,Aurangabad(Bihar),Bihar',
'Branch Post Office,Aurangabad(Bihar),Bihar',
'Branch Post Office,Aurangabad(Bihar),Bihar',
'Branch Post Office,Aurangabad(Bihar),Bihar',
'Branch Post Office,Aurangabad(Bihar),Bihar',
'Branch Post Office,Aurangabad(Bihar),Bihar',
'Branch Post Office,Aurangabad(Bihar),Bihar',
'Branch Post Office,Aurangabad(Bihar),Bihar',
'Sub Post Office,Aurangabad(Bihar),Bihar',
'Branch Post Office,Aurangabad(Bihar),Bihar',
'Branch Post Office,Aurangabad(Bihar),Bihar',
'Branch Post Office,Aurangabad(Bihar),Bihar',
'Branch Post Office,Aurangabad(Bihar),Bihar',
'Branch Post Office,Aurangabad(Bihar),Bihar',
'Branch Post Office,Aurangabad(Bihar),Bihar',
'Branch Post Office,Aurangabad(Bihar),Bihar',
'Branch Post Office,Aurangabad(Bihar),Bihar',
'Branch Post Office,Aurangabad(Bihar),Bihar',
'Branch Post Office,Aurangabad(Bihar),Bihar',
'Branch Post Office,Aurangabad(Bihar),Bihar',
'Branch Post Office,Aurangabad(Bihar),Bihar',
'Branch Post Office,Aurangabad(Bihar),Bihar',
'Sub Post Office,Aurangabad(Bihar),Bihar',
'Branch Post Office,Aurangabad(Bihar),Bihar',
'Branch Post Office,Aurangabad(Bihar),Bihar',
'Branch Post Office,Aurangabad(Bihar),Bihar',
'Branch Post Office,Aurangabad(Bihar),Bihar',
'Branch Post Office,Aurangabad(Bihar),Bihar',
'Branch Post Office,Aurangabad(Bihar),Bihar',
'Branch Post Office,Aurangabad(Bihar),Bihar',
'Branch Post Office,Aurangabad(Bihar),Bihar',
'Branch Post Office,Aurangabad(Bihar),Bihar',
'Branch Post Office,Aurangabad(Bihar),Bihar',
'Branch Post Office,Aurangabad(Bihar),Bihar',
'Branch Post Office,Aurangabad(Bihar),Bihar',
'Branch Post Office,Aurangabad(Bihar),Bihar',
'Branch Post Office,Aurangabad(Bihar),Bihar',
'Sub Post Office,Aurangabad(Bihar),Bihar',
'Sub Post Office,Aurangabad(Bihar),Bihar',
'Branch Post Office,Aurangabad(Bihar),Bihar',
'Branch Post Office,Aurangabad(Bihar),Bihar',
'Branch Post Office,Aurangabad(Bihar),Bihar',
'Branch Post Office,Aurangabad(Bihar),Bihar',
'Branch Post Office,Aurangabad(Bihar),Bihar',
'Branch Post Office,Aurangabad(Bihar),Bihar',
'Branch Post Office,Aurangabad(Bihar),Bihar',
'Sub Post Office,Aurangabad(Bihar),Bihar',
'Branch Post Office,Aurangabad(Bihar),Bihar',
'Branch Post Office,Aurangabad(Bihar),Bihar',
'Branch Post Office,Aurangabad(Bihar),Bihar',
'Branch Post Office,Aurangabad(Bihar),Bihar',
'Branch Post Office,Aurangabad(Bihar),Bihar',
'Branch Post Office,Aurangabad(Bihar),Bihar',
'Branch Post Office,Aurangabad(Bihar),Bihar',
'Branch Post Office,Aurangabad(Bihar),Bihar',
'Branch Post Office,Aurangabad(Bihar),Bihar',
'Branch Post Office,Aurangabad(Bihar),Bihar',
'Branch Post Office,Aurangabad(Bihar),Bihar',
'Branch Post Office,Aurangabad(Bihar),Bihar',
'Branch Post Office,Aurangabad(Bihar),Bihar',
'Branch Post Office,Aurangabad(Bihar),Bihar',
'Sub Post Office,Aurangabad(Bihar),Bihar',
'Branch Post Office,Aurangabad(Bihar),Bihar',
'Branch Post Office,Aurangabad(Bihar),Bihar',
'Branch Post Office,Aurangabad(Bihar),Bihar',
'Branch Post Office,Aurangabad(Bihar),Bihar',
'Branch Post Office,Aurangabad(Bihar),Bihar',
'Sub Post Office,Aurangabad(Bihar),Bihar',
'Branch Post Office,Aurangabad(Bihar),Bihar',
'Sub Post Office,Aurangabad(Bihar),Bihar',
'Branch Post Office,Aurangabad(Bihar),Bihar',
'Branch Post Office,Aurangabad(Bihar),Bihar',
'Branch Post Office,Aurangabad(Bihar),Bihar',
'Branch Post Office,Aurangabad(Bihar),Bihar',
'Branch Post Office,Aurangabad(Bihar),Bihar',
'Branch Post Office,Aurangabad(Bihar),Bihar',
'Branch Post Office,Gaya,Bihar',
'Branch Post Office,Aurangabad(Bihar),Bihar',
'Branch Post Office,Aurangabad(Bihar),Bihar',
'Branch Post Office,Aurangabad(Bihar),Bihar',
'Branch Post Office,Aurangabad(Bihar),Bihar',
'Branch Post Office,Aurangabad(Bihar),Bihar',
'Branch Post Office,Aurangabad(Bihar),Bihar',
'Branch Post Office,Aurangabad(Bihar),Bihar',
'Branch Post Office,Aurangabad(Bihar),Bihar',
'Branch Post Office,Aurangabad(Bihar),Bihar',
'Branch Post Office,Aurangabad(Bihar),Bihar',
'Branch Post Office,Aurangabad(Bihar),Bihar',
'Branch Post Office,Aurangabad(Bihar),Bihar',
'Branch Post Office,Aurangabad(Bihar),Bihar',
'Branch Post Office,Aurangabad(Bihar),Bihar',
'Branch Post Office,Aurangabad(Bihar),Bihar',
'Branch Post Office,Aurangabad(Bihar),Bihar',
'Branch Post Office,Aurangabad(Bihar),Bihar',
'Branch Post Office,Aurangabad(Bihar),Bihar',
'Branch Post Office,Aurangabad(Bihar),Bihar',
'Sub Post Office,Aurangabad(Bihar),Bihar',
'Branch Post Office,Aurangabad(Bihar),Bihar',
'Branch Post Office,Aurangabad(Bihar),Bihar',
'Branch Post Office,Aurangabad(Bihar),Bihar',
'Branch Post Office,Aurangabad(Bihar),Bihar',
'Branch Post Office,Aurangabad(Bihar),Bihar',
'Branch Post Office,Aurangabad(Bihar),Bihar',
'Branch Post Office,Aurangabad(Bihar),Bihar',
'Branch Post Office,Aurangabad(Bihar),Bihar',
'Branch Post Office,Aurangabad(Bihar),Bihar',
'Branch Post Office,Aurangabad(Bihar),Bihar',
'Branch Post Office,Aurangabad(Bihar),Bihar',
'Branch Post Office,Aurangabad(Bihar),Bihar',
'Branch Post Office,Aurangabad(Bihar),Bihar',
'Branch Post Office,Aurangabad(Bihar),Bihar',
'Branch Post Office,Bhagalpur,Bihar',
'Branch Post Office,Bhagalpur,Bihar',
'Branch Post Office,Bhagalpur,Bihar',
'Branch Post Office,Bhagalpur,Bihar',
'Branch Post Office,Bhagalpur,Bihar',
'Branch Post Office,Bhagalpur,Bihar',
'Branch Post Office,Bhagalpur,Bihar',
'Sub Post Office,Bhagalpur,Bihar',
'Sub Post Office,Bhagalpur,Bihar',
'Branch Post Office,Bhagalpur,Bihar',
'Branch Post Office,Bhagalpur,Bihar',
'Branch Post Office,Bhagalpur,Bihar',
'Head Post Office,Bhagalpur,Bihar',
'Branch Post Office,Bhagalpur,Bihar',
'Sub Post Office,Bhagalpur,Bihar',
'Branch Post Office,Bhagalpur,Bihar',
'Branch Post Office,Bhagalpur,Bihar',
'Sub Post Office,Bhagalpur,Bihar',
'Branch Post Office,Bhagalpur,Bihar',
'Sub Post Office,Bhagalpur,Bihar',
'Branch Post Office,Bhagalpur,Bihar',
'Sub Post Office,Bhagalpur,Bihar',
'Branch Post Office,Bhagalpur,Bihar',
'Branch Post Office,Bhagalpur,Bihar',
'Branch Post Office,Bhagalpur,Bihar',
'Sub Post Office,Bhagalpur,Bihar',
'Sub Post Office,Bhagalpur,Bihar',
'Branch Post Office,Bhagalpur,Bihar',
'Sub Post Office,Bhagalpur,Bihar',
'Branch Post Office,Bhagalpur,Bihar',
'Branch Post Office,Bhagalpur,Bihar',
'Branch Post Office,Bhagalpur,Bihar',
'Branch Post Office,Bhagalpur,Bihar',
'Branch Post Office,Bhagalpur,Bihar',
'Branch Post Office,Bhagalpur,Bihar',
'Branch Post Office,Bhagalpur,Bihar',
'Branch Post Office,Bhagalpur,Bihar',
'Branch Post Office,Bhagalpur,Bihar',
'Branch Post Office,Bhagalpur,Bihar',
'Branch Post Office,Bhagalpur,Bihar',
'Branch Post Office,Bhagalpur,Bihar',
'Sub Post Office,Bhagalpur,Bihar',
'Branch Post Office,Bhagalpur,Bihar',
'Sub Post Office,Bhagalpur,Bihar',
'Branch Post Office,Bhagalpur,Bihar',
'Sub Post Office,Bhagalpur,Bihar',
'Sub Post Office,Bhagalpur,Bihar',
'Branch Post Office,Bhagalpur,Bihar',
'Branch Post Office,Bhagalpur,Bihar',
'Branch Post Office,Bhagalpur,Bihar',
'Branch Post Office,Bhagalpur,Bihar',
'Branch Post Office,Bhagalpur,Bihar',
'Branch Post Office,Bhagalpur,Bihar',
'Branch Post Office,Bhagalpur,Bihar',
'Branch Post Office,Bhagalpur,Bihar',
'Sub Post Office,Bhagalpur,Bihar',
'Branch Post Office,Bhagalpur,Bihar',
'Branch Post Office,Bhagalpur,Bihar',
'Branch Post Office,Bhagalpur,Bihar',
'Branch Post Office,Bhagalpur,Bihar',
'Branch Post Office,Bhagalpur,Bihar',
'Branch Post Office,Bhagalpur,Bihar',
'Branch Post Office,Bhagalpur,Bihar',
'Branch Post Office,Bhagalpur,Bihar',
'Branch Post Office,Bhagalpur,Bihar',
'Branch Post Office,Bhagalpur,Bihar',
'Branch Post Office,Bhagalpur,Bihar',
'Branch Post Office,Bhagalpur,Bihar',
'Sub Post Office,Bhagalpur,Bihar',
'Branch Post Office,Bhagalpur,Bihar',
'Branch Post Office,Bhagalpur,Bihar',
'Branch Post Office,Bhagalpur,Bihar',
'Sub Post Office,Bhagalpur,Bihar',
'Sub Post Office,Bhagalpur,Bihar',
'Branch Post Office,Bhagalpur,Bihar',
'Sub Post Office,Bhagalpur,Bihar',
'Sub Post Office,Bhagalpur,Bihar',
'Branch Post Office,Bhagalpur,Bihar',
'Branch Post Office,Bhagalpur,Bihar',
'Branch Post Office,Bhagalpur,Bihar',
'Branch Post Office,Bhagalpur,Bihar',
'Branch Post Office,Bhagalpur,Bihar',
'Branch Post Office,Bhagalpur,Bihar',
'Branch Post Office,Bhagalpur,Bihar',
'Sub Post Office,Bhagalpur,Bihar',
'Branch Post Office,Bhagalpur,Bihar',
'Sub Post Office,Bhagalpur,Bihar',
'Sub Post Office,Bhagalpur,Bihar',
'Branch Post Office,Bhagalpur,Bihar',
'Branch Post Office,Bhagalpur,Bihar',
'Branch Post Office,Bhagalpur,Bihar',
'Branch Post Office,Bhagalpur,Bihar',
'Branch Post Office,Bhagalpur,Bihar',
'Branch Post Office,Bhagalpur,Bihar',
'Branch Post Office,Bhagalpur,Bihar',
'Branch Post Office,Bhagalpur,Bihar',
'Branch Post Office,Bhagalpur,Bihar',
'Branch Post Office,Bhagalpur,Bihar',
'Branch Post Office,Bhagalpur,Bihar',
'Branch Post Office,Bhagalpur,Bihar',
'Branch Post Office,Bhagalpur,Bihar',
'Branch Post Office,Bhagalpur,Bihar',
'Branch Post Office,Bhagalpur,Bihar',
'Branch Post Office,Bhagalpur,Bihar',
'Branch Post Office,Bhagalpur,Bihar',
'Branch Post Office,Bhagalpur,Bihar',
'Branch Post Office,Bhagalpur,Bihar',
'Branch Post Office,Bhagalpur,Bihar',
'Branch Post Office,Bhagalpur,Bihar',
'Branch Post Office,Bhagalpur,Bihar',
'Branch Post Office,Bhagalpur,Bihar',
'Branch Post Office,Bhagalpur,Bihar',
'Branch Post Office,Bhagalpur,Bihar',
'Branch Post Office,Bhagalpur,Bihar',
'Branch Post Office,Bhagalpur,Bihar',
'Branch Post Office,Bhagalpur,Bihar',
'Branch Post Office,Bhagalpur,Bihar',
'Branch Post Office,Monghyr,Bihar',
'Sub Post Office,Bhagalpur,Bihar',
'Branch Post Office,Bhagalpur,Bihar',
'Branch Post Office,Bhagalpur,Bihar',
'Branch Post Office,Bhagalpur,Bihar',
'Branch Post Office,Bhagalpur,Bihar',
'Branch Post Office,Bhagalpur,Bihar',
'Branch Post Office,Bhagalpur,Bihar',
'Branch Post Office,Bhagalpur,Bihar',
'Branch Post Office,Bhagalpur,Bihar',
'Branch Post Office,Bhagalpur,Bihar',
'Branch Post Office,Bhagalpur,Bihar',
'Branch Post Office,Bhagalpur,Bihar',
'Branch Post Office,Bhagalpur,Bihar',
'Branch Post Office,Bhagalpur,Bihar',
'Branch Post Office,Bhagalpur,Bihar',
'Branch Post Office,Bhagalpur,Bihar',
'Branch Post Office,Bhagalpur,Bihar',
'Branch Post Office,Bhagalpur,Bihar',
'Branch Post Office,Bhagalpur,Bihar',
'Branch Post Office,Bhagalpur,Bihar',
'Branch Post Office,Bhagalpur,Bihar',
'Branch Post Office,Bhagalpur,Bihar',
'Branch Post Office,Bhagalpur,Bihar',
'Branch Post Office,Bhagalpur,Bihar',
'Branch Post Office,Bhagalpur,Bihar',
'Branch Post Office,Bhagalpur,Bihar',
'Branch Post Office,Bhagalpur,Bihar',
'Branch Post Office,Bhagalpur,Bihar',
'Branch Post Office,Bhagalpur,Bihar',
'Branch Post Office,Bhagalpur,Bihar',
'Branch Post Office,Bhagalpur,Bihar',
'Branch Post Office,Bhagalpur,Bihar',
'Branch Post Office,Bhagalpur,Bihar',
'Branch Post Office,Bhagalpur,Bihar',
'Branch Post Office,Bhagalpur,Bihar',
'Branch Post Office,Bhagalpur,Bihar',
'Branch Post Office,Bhagalpur,Bihar',
'Branch Post Office,Bhagalpur,Bihar',
'Branch Post Office,Bhagalpur,Bihar',
'Branch Post Office,Bhagalpur,Bihar',
'Branch Post Office,Bhagalpur,Bihar',
'Branch Post Office,Bhagalpur,Bihar',
'Branch Post Office,Bhagalpur,Bihar',
'Branch Post Office,Bhagalpur,Bihar',
'Branch Post Office,Bhagalpur,Bihar',
'Branch Post Office,Bhagalpur,Bihar',
'Branch Post Office,Bhagalpur,Bihar',
'Branch Post Office,Bhagalpur,Bihar',
'Branch Post Office,Bhagalpur,Bihar',
'Branch Post Office,Bhagalpur,Bihar',
'Branch Post Office,Bhagalpur,Bihar',
'Branch Post Office,Bhagalpur,Bihar',
'Branch Post Office,Bhagalpur,Bihar',
'Branch Post Office,Bhagalpur,Bihar',
'Branch Post Office,Bhagalpur,Bihar',
'Branch Post Office,Bhagalpur,Bihar',
'Branch Post Office,Bhagalpur,Bihar',
'Branch Post Office,Bhagalpur,Bihar',
'Branch Post Office,Bhagalpur,Bihar',
'Branch Post Office,Bhagalpur,Bihar',
'Branch Post Office,Bhagalpur,Bihar',
'Branch Post Office,Bhagalpur,Bihar',
'Branch Post Office,Bhagalpur,Bihar',
'Branch Post Office,Bhagalpur,Bihar',
'Branch Post Office,Bhagalpur,Bihar',
'Branch Post Office,Begusarai,Bihar',
'Branch Post Office,Begusarai,Bihar',
'Branch Post Office,Begusarai,Bihar',
'Branch Post Office,Begusarai,Bihar',
'Branch Post Office,Begusarai,Bihar',
'Branch Post Office,Begusarai,Bihar',
'Branch Post Office,Begusarai,Bihar',
'Branch Post Office,Begusarai,Bihar',
'Branch Post Office,Begusarai,Bihar',
'Branch Post Office,Begusarai,Bihar',
'Sub Post Office,Begusarai,Bihar',
'Sub Post Office,Begusarai,Bihar',
'Branch Post Office,Begusarai,Bihar',
'Branch Post Office,Begusarai,Bihar',
'Branch Post Office,Begusarai,Bihar',
'Branch Post Office,Begusarai,Bihar',
'Branch Post Office,Begusarai,Bihar',
'Branch Post Office,Begusarai,Bihar',
'Branch Post Office,Begusarai,Bihar',
'Branch Post Office,Begusarai,Bihar',
'Branch Post Office,Begusarai,Bihar',
'Branch Post Office,Begusarai,Bihar',
'Sub Post Office,Begusarai,Bihar',
'Sub Post Office,Begusarai,Bihar',
'Sub Post Office,Begusarai,Bihar',
'Sub Post Office,Begusarai,Bihar',
'Branch Post Office,Begusarai,Bihar',
'Branch Post Office,Begusarai,Bihar',
'Branch Post Office,Begusarai,Bihar',
'Sub Post Office,Begusarai,Bihar',
'Branch Post Office,Begusarai,Bihar',
'Sub Post Office,Begusarai,Bihar',
'Head Post Office,Begusarai,Bihar',
'Branch Post Office,Begusarai,Bihar',
'Branch Post Office,Begusarai,Bihar',
'Branch Post Office,Begusarai,Bihar',
'Branch Post Office,Begusarai,Bihar',
'Sub Post Office,Begusarai,Bihar',
'Branch Post Office,Begusarai,Bihar',
'Branch Post Office,Begusarai,Bihar',
'Branch Post Office,Begusarai,Bihar',
'Branch Post Office,Begusarai,Bihar',
'Branch Post Office,Begusarai,Bihar',
'Branch Post Office,Begusarai,Bihar',
'Branch Post Office,Begusarai,Bihar',
'Branch Post Office,Begusarai,Bihar',
'Branch Post Office,Begusarai,Bihar',
'Branch Post Office,Begusarai,Bihar',
'Branch Post Office,Begusarai,Bihar',
'Branch Post Office,Begusarai,Bihar',
'Branch Post Office,Begusarai,Bihar',
'Branch Post Office,Begusarai,Bihar',
'Branch Post Office,Begusarai,Bihar',
'Branch Post Office,Begusarai,Bihar',
'Branch Post Office,Begusarai,Bihar',
'Branch Post Office,Begusarai,Bihar',
'Branch Post Office,Begusarai,Bihar',
'Branch Post Office,Begusarai,Bihar',
'Branch Post Office,Begusarai,Bihar',
'Branch Post Office,Begusarai,Bihar',
'Branch Post Office,Begusarai,Bihar',
'Branch Post Office,Begusarai,Bihar',
'Branch Post Office,Begusarai,Bihar',
'Branch Post Office,Begusarai,Bihar',
'Branch Post Office,Begusarai,Bihar',
'Branch Post Office,Begusarai,Bihar',
'Branch Post Office,Begusarai,Bihar',
'Branch Post Office,Begusarai,Bihar',
'Branch Post Office,Begusarai,Bihar',
'Branch Post Office,Begusarai,Bihar',
'Branch Post Office,Begusarai,Bihar',
'Branch Post Office,Begusarai,Bihar',
'Branch Post Office,Begusarai,Bihar',
'Sub Post Office,Begusarai,Bihar',
'Branch Post Office,Begusarai,Bihar',
'Branch Post Office,Begusarai,Bihar',
'Sub Post Office,Begusarai,Bihar',
'Branch Post Office,Begusarai,Bihar',
'Branch Post Office,Begusarai,Bihar',
'Branch Post Office,Begusarai,Bihar',
'Branch Post Office,Begusarai,Bihar',
'Branch Post Office,Begusarai,Bihar',
'Branch Post Office,Begusarai,Bihar',
'Branch Post Office,Begusarai,Bihar',
'Branch Post Office,Begusarai,Bihar',
'Branch Post Office,Begusarai,Bihar',
'Branch Post Office,Begusarai,Bihar',
'Branch Post Office,Begusarai,Bihar',
'Branch Post Office,Begusarai,Bihar',
'Branch Post Office,Begusarai,Bihar',
'Branch Post Office,Begusarai,Bihar',
'Branch Post Office,Begusarai,Bihar',
'Branch Post Office,Begusarai,Bihar',
'Branch Post Office,Begusarai,Bihar',
'Branch Post Office,Begusarai,Bihar',
'Branch Post Office,Begusarai,Bihar',
'Branch Post Office,Begusarai,Bihar',
'Branch Post Office,Begusarai,Bihar',
'Branch Post Office,Begusarai,Bihar',
'Branch Post Office,Begusarai,Bihar',
'Branch Post Office,Begusarai,Bihar',
'Branch Post Office,Begusarai,Bihar',
'Branch Post Office,Begusarai,Bihar',
'Branch Post Office,Begusarai,Bihar',
'Branch Post Office,Begusarai,Bihar',
'Branch Post Office,Begusarai,Bihar',
'Branch Post Office,Begusarai,Bihar',
'Branch Post Office,Begusarai,Bihar',
'Branch Post Office,Begusarai,Bihar',
'Branch Post Office,Begusarai,Bihar',
'Sub Post Office,Begusarai,Bihar',
'Branch Post Office,Begusarai,Bihar',
'Branch Post Office,Begusarai,Bihar',
'Branch Post Office,Begusarai,Bihar',
'Branch Post Office,Begusarai,Bihar',
'Branch Post Office,Begusarai,Bihar',
'Branch Post Office,Begusarai,Bihar',
'Branch Post Office,Begusarai,Bihar',
'Branch Post Office,Begusarai,Bihar',
'Branch Post Office,Begusarai,Bihar',
'Branch Post Office,Begusarai,Bihar',
'Sub Post Office,Begusarai,Bihar',
'Branch Post Office,Begusarai,Bihar',
'Branch Post Office,Begusarai,Bihar',
'Branch Post Office,Begusarai,Bihar',
'Sub Post Office,Begusarai,Bihar',
'Branch Post Office,Begusarai,Bihar',
'Sub Post Office,Begusarai,Bihar',
'Branch Post Office,Begusarai,Bihar',
'Branch Post Office,Begusarai,Bihar',
'Sub Post Office,Begusarai,Bihar',
'Branch Post Office,Begusarai,Bihar',
'Sub Post Office,Begusarai,Bihar',
'Sub Post Office,Begusarai,Bihar',
'Branch Post Office,Begusarai,Bihar',
'Branch Post Office,Begusarai,Bihar',
'Branch Post Office,Begusarai,Bihar',
'Branch Post Office,Begusarai,Bihar',
'Branch Post Office,Begusarai,Bihar',
'Branch Post Office,Begusarai,Bihar',
'Branch Post Office,Begusarai,Bihar',
'Branch Post Office,Begusarai,Bihar',
'Branch Post Office,Begusarai,Bihar',
'Branch Post Office,Begusarai,Bihar',
'Sub Post Office,Begusarai,Bihar',
'Branch Post Office,Begusarai,Bihar',
'Branch Post Office,Begusarai,Bihar',
'Branch Post Office,Begusarai,Bihar',
'Branch Post Office,Begusarai,Bihar',
'Branch Post Office,Begusarai,Bihar',
'Branch Post Office,Begusarai,Bihar',
'Branch Post Office,Begusarai,Bihar',
'Branch Post Office,Begusarai,Bihar',
'Branch Post Office,Begusarai,Bihar',
'Branch Post Office,Begusarai,Bihar',
'Branch Post Office,Begusarai,Bihar',
'Branch Post Office,Begusarai,Bihar',
'Sub Post Office,Begusarai,Bihar',
'Branch Post Office,Begusarai,Bihar',
'Branch Post Office,Begusarai,Bihar',
'Branch Post Office,Begusarai,Bihar',
'Branch Post Office,Begusarai,Bihar',
'Branch Post Office,Begusarai,Bihar',
'Branch Post Office,Begusarai,Bihar',
'Branch Post Office,Begusarai,Bihar',
'Branch Post Office,Begusarai,Bihar',
'Branch Post Office,Begusarai,Bihar',
'Branch Post Office,Begusarai,Bihar',
'Branch Post Office,Begusarai,Bihar',
'Branch Post Office,Begusarai,Bihar',
'Branch Post Office,Begusarai,Bihar',
'Branch Post Office,Begusarai,Bihar',
'Branch Post Office,Begusarai,Bihar',
'Branch Post Office,Begusarai,Bihar',
'Sub Post Office,Begusarai,Bihar',
'Branch Post Office,Begusarai,Bihar',
'Branch Post Office,Begusarai,Bihar',
'Branch Post Office,Begusarai,Bihar',
'Branch Post Office,Begusarai,Bihar',
'Branch Post Office,Begusarai,Bihar',
'Sub Post Office,Begusarai,Bihar',
'Branch Post Office,Begusarai,Bihar',
'Branch Post Office,Begusarai,Bihar',
'Branch Post Office,Begusarai,Bihar',
'Branch Post Office,Begusarai,Bihar',
'Branch Post Office,Begusarai,Bihar',
'Branch Post Office,Begusarai,Bihar',
'Branch Post Office,Begusarai,Bihar',
'Branch Post Office,Begusarai,Bihar',
'Branch Post Office,Begusarai,Bihar',
'Branch Post Office,Begusarai,Bihar',
'Branch Post Office,Begusarai,Bihar',
'Branch Post Office,Begusarai,Bihar',
'Branch Post Office,Begusarai,Bihar',
'Branch Post Office,Begusarai,Bihar',
'Branch Post Office,Begusarai,Bihar',
'Branch Post Office,Begusarai,Bihar',
'Branch Post Office,Begusarai,Bihar',
'Branch Post Office,Begusarai,Bihar',
'Sub Post Office,Begusarai,Bihar',
'Branch Post Office,Begusarai,Bihar',
'Branch Post Office,Begusarai,Bihar',
'Branch Post Office,Begusarai,Bihar',
'Branch Post Office,Begusarai,Bihar',
'Branch Post Office,Begusarai,Bihar',
'Branch Post Office,Begusarai,Bihar',
'Branch Post Office,Begusarai,Bihar',
'Branch Post Office,Begusarai,Bihar',
'Branch Post Office,Begusarai,Bihar',
'Branch Post Office,Begusarai,Bihar',
'Branch Post Office,Begusarai,Bihar',
'Branch Post Office,Begusarai,Bihar',
'Sub Post Office,Begusarai,Bihar',
'Sub Post Office,Begusarai,Bihar',
'Sub Post Office,Begusarai,Bihar',
'Branch Post Office,Begusarai,Bihar',
'Branch Post Office,Begusarai,Bihar',
'Branch Post Office,Begusarai,Bihar',
'Branch Post Office,Begusarai,Bihar',
'Branch Post Office,Begusarai,Bihar',
'Branch Post Office,Begusarai,Bihar',
'Sub Post Office,Begusarai,Bihar',
'Branch Post Office,Begusarai,Bihar',
'Branch Post Office,Begusarai,Bihar',
'Sub Post Office,Begusarai,Bihar',
'Sub Post Office,Begusarai,Bihar',
'Branch Post Office,Begusarai,Bihar',
'Branch Post Office,Begusarai,Bihar',
'Sub Post Office,Begusarai,Bihar',
'Sub Post Office,Begusarai,Bihar',
'Sub Post Office,Begusarai,Bihar',
'Sub Post Office,Begusarai,Bihar',
'Branch Post Office,Monghyr,Bihar',
'Branch Post Office,Monghyr,Bihar',
'Branch Post Office,Monghyr,Bihar',
'Sub Post Office,Begusarai,Bihar',
'Branch Post Office,Bhagalpur,Bihar',
'Branch Post Office,Bhagalpur,Bihar',
'Branch Post Office,Bhagalpur,Bihar',
'Branch Post Office,Bhagalpur,Bihar',
'Branch Post Office,Bhagalpur,Bihar',
'Branch Post Office,Bhagalpur,Bihar',
'Branch Post Office,Bhagalpur,Bihar',
'Branch Post Office,Bhagalpur,Bihar',
'Branch Post Office,Bhagalpur,Bihar',
'Branch Post Office,Bhagalpur,Bihar',
'Head Post Office,Bhagalpur,Bihar',
'Sub Post Office,Bhagalpur,Bihar',
'Branch Post Office,Bhagalpur,Bihar',
'Branch Post Office,Bhagalpur,Bihar',
'Branch Post Office,Bhagalpur,Bihar',
'Branch Post Office,Bhagalpur,Bihar',
'Sub Post Office,Bhagalpur,Bihar',
'Branch Post Office,Bhagalpur,Bihar',
'Branch Post Office,Bhagalpur,Bihar',
'Branch Post Office,Bhagalpur,Bihar',
'Branch Post Office,Bhagalpur,Bihar',
'Branch Post Office,Bhagalpur,Bihar',
'Branch Post Office,Bhagalpur,Bihar',
'Branch Post Office,Bhagalpur,Bihar',
'Branch Post Office,Bhagalpur,Bihar',
'Branch Post Office,Bhagalpur,Bihar',
'Branch Post Office,Bhagalpur,Bihar',
'Branch Post Office,Bhagalpur,Bihar',
'Branch Post Office,Bhagalpur,Bihar',
'Branch Post Office,Bhagalpur,Bihar',
'Sub Post Office,Bhagalpur,Bihar',
'Branch Post Office,Bhagalpur,Bihar',
'Branch Post Office,Bhagalpur,Bihar',
'Sub Post Office,Bhagalpur,Bihar',
'Branch Post Office,Bhagalpur,Bihar',
'Branch Post Office,Bhagalpur,Bihar',
'Branch Post Office,Bhagalpur,Bihar',
'Branch Post Office,Bhagalpur,Bihar',
'Sub Post Office,Bhagalpur,Bihar',
'Branch Post Office,Bhagalpur,Bihar',
'Sub Post Office,Bhagalpur,Bihar',
'Branch Post Office,Bhagalpur,Bihar',
'Sub Post Office,Bhagalpur,Bihar',
'Branch Post Office,Bhagalpur,Bihar',
'Branch Post Office,Bhagalpur,Bihar',
'Branch Post Office,Bhagalpur,Bihar',
'Branch Post Office,Bhagalpur,Bihar',
'Branch Post Office,Bhagalpur,Bihar',
'Sub Post Office,Bhagalpur,Bihar',
'Branch Post Office,Bhagalpur,Bihar',
'Sub Post Office,Bhagalpur,Bihar',
'Branch Post Office,Bhagalpur,Bihar',
'Branch Post Office,Bhagalpur,Bihar',
'Branch Post Office,Bhagalpur,Bihar',
'Branch Post Office,Bhagalpur,Bihar',
'Branch Post Office,Bhagalpur,Bihar',
'Branch Post Office,Bhagalpur,Bihar',
'Sub Post Office,Bhagalpur,Bihar',
'Branch Post Office,Bhagalpur,Bihar',
'Branch Post Office,Bhagalpur,Bihar',
'Branch Post Office,Bhagalpur,Bihar',
'Branch Post Office,Bhagalpur,Bihar',
'Branch Post Office,Bhagalpur,Bihar',
'Branch Post Office,Bhagalpur,Bihar',
'Branch Post Office,Bhagalpur,Bihar',
'Branch Post Office,Bhagalpur,Bihar',
'Branch Post Office,Bhagalpur,Bihar',
'Branch Post Office,Bhagalpur,Bihar',
'Branch Post Office,Bhagalpur,Bihar',
'Sub Post Office,Bhagalpur,Bihar',
'Branch Post Office,Bhagalpur,Bihar',
'Sub Post Office,Bhagalpur,Bihar',
'Sub Post Office,Bhagalpur,Bihar',
'Sub Post Office,Bhagalpur,Bihar',
'Branch Post Office,Bhagalpur,Bihar',
'Branch Post Office,Bhagalpur,Bihar',
'Sub Post Office,Bhagalpur,Bihar',
'Branch Post Office,Bhagalpur,Bihar',
'Sub Post Office,Bhagalpur,Bihar',
'Sub Post Office,Bhagalpur,Bihar',
'Branch Post Office,Bhagalpur,Bihar',
'Branch Post Office,Bhagalpur,Bihar',
'Branch Post Office,Bhagalpur,Bihar',
'Branch Post Office,Bhagalpur,Bihar',
'Branch Post Office,Bhagalpur,Bihar',
'Branch Post Office,Bhagalpur,Bihar',
'Branch Post Office,Bhagalpur,Bihar',
'Branch Post Office,Bhagalpur,Bihar',
'Branch Post Office,Bhagalpur,Bihar',
'Branch Post Office,Bhagalpur,Bihar',
'Branch Post Office,Bhagalpur,Bihar',
'Branch Post Office,Bhagalpur,Bihar',
'Branch Post Office,Bhagalpur,Bihar',
'Branch Post Office,Bhagalpur,Bihar',
'Branch Post Office,Bhagalpur,Bihar',
'Branch Post Office,Bhagalpur,Bihar',
'Branch Post Office,Bhagalpur,Bihar',
'Branch Post Office,Bhagalpur,Bihar',
'Branch Post Office,Bhagalpur,Bihar',
'Branch Post Office,Bhagalpur,Bihar',
'Branch Post Office,Bhagalpur,Bihar',
'Branch Post Office,Bhagalpur,Bihar',
'Branch Post Office,Bhagalpur,Bihar',
'Branch Post Office,Bhagalpur,Bihar',
'Branch Post Office,Bhagalpur,Bihar',
'Branch Post Office,Bhagalpur,Bihar',
'Branch Post Office,Bhagalpur,Bihar',
'Branch Post Office,Bhagalpur,Bihar',
'Branch Post Office,Bhagalpur,Bihar',
'Branch Post Office,Bhagalpur,Bihar',
'Branch Post Office,Bhagalpur,Bihar',
'Branch Post Office,Bhagalpur,Bihar',
'Branch Post Office,Bhagalpur,Bihar',
'Branch Post Office,Bhagalpur,Bihar',
'Branch Post Office,Bhagalpur,Bihar',
'Branch Post Office,Bhagalpur,Bihar',
'Branch Post Office,Bhagalpur,Bihar',
'Branch Post Office,Bhagalpur,Bihar',
'Branch Post Office,Bhagalpur,Bihar',
'Branch Post Office,Bhagalpur,Bihar',
'Branch Post Office,Bhagalpur,Bihar',
'Branch Post Office,Bhagalpur,Bihar',
'Branch Post Office,Bhagalpur,Bihar',
'Branch Post Office,Bhagalpur,Bihar',
'Branch Post Office,Bhagalpur,Bihar',
'Branch Post Office,Bhagalpur,Bihar',
'Branch Post Office,Bhagalpur,Bihar',
'Branch Post Office,Bhagalpur,Bihar',
'Branch Post Office,Bhagalpur,Bihar',
'Branch Post Office,Bhagalpur,Bihar',
'Branch Post Office,Bhagalpur,Bihar',
'Sub Post Office,Bhagalpur,Bihar',
'Branch Post Office,Bhagalpur,Bihar',
'Branch Post Office,Bhagalpur,Bihar',
'Branch Post Office,Bhagalpur,Bihar',
'Branch Post Office,Bhagalpur,Bihar',
'Branch Post Office,Bhagalpur,Bihar',
'Branch Post Office,Bhagalpur,Bihar',
'Branch Post Office,Bhagalpur,Bihar',
'Branch Post Office,Bhagalpur,Bihar',
'Branch Post Office,Bhagalpur,Bihar',
'Branch Post Office,Bhagalpur,Bihar',
'Branch Post Office,Bhagalpur,Bihar',
'Branch Post Office,Bhagalpur,Bihar',
'Branch Post Office,Bhagalpur,Bihar',
'Branch Post Office,Bhagalpur,Bihar',
'Branch Post Office,Bhagalpur,Bihar',
'Sub Post Office,Bhagalpur,Bihar',
'Branch Post Office,Bhagalpur,Bihar',
'Branch Post Office,Bhagalpur,Bihar',
'Branch Post Office,Bhagalpur,Bihar',
'Branch Post Office,Bhagalpur,Bihar',
'Sub Post Office,Bhagalpur,Bihar',
'Branch Post Office,Bhagalpur,Bihar',
'Branch Post Office,Bhagalpur,Bihar',
'Branch Post Office,Bhagalpur,Bihar',
'Branch Post Office,Bhagalpur,Bihar',
'Branch Post Office,Bhagalpur,Bihar',
'Branch Post Office,Bhagalpur,Bihar',
'Branch Post Office,Bhagalpur,Bihar',
'Branch Post Office,Bhagalpur,Bihar',
'Sub Post Office,Bhagalpur,Bihar',
'Branch Post Office,Bhagalpur,Bihar',
'Branch Post Office,Bhagalpur,Bihar',
'Sub Post Office,Bhagalpur,Bihar',
'Branch Post Office,Bhagalpur,Bihar',
'Branch Post Office,Bhagalpur,Bihar',
'Branch Post Office,Bhagalpur,Bihar',
'Branch Post Office,Bhagalpur,Bihar',
'Branch Post Office,Bhagalpur,Bihar',
'Branch Post Office,Bhagalpur,Bihar',
'Branch Post Office,Bhagalpur,Bihar',
'Branch Post Office,Bhagalpur,Bihar',
'Branch Post Office,Bhagalpur,Bihar',
'Branch Post Office,Bhagalpur,Bihar',
'Branch Post Office,Bhagalpur,Bihar',
'Branch Post Office,Bhagalpur,Bihar',
'Branch Post Office,Bhagalpur,Bihar',
'Branch Post Office,Bhagalpur,Bihar',
'Branch Post Office,Bhagalpur,Bihar',
'Branch Post Office,Bhagalpur,Bihar',
'Branch Post Office,Bhagalpur,Bihar',
'Branch Post Office,Bhagalpur,Bihar',
'Branch Post Office,Bhagalpur,Bihar',
'Branch Post Office,Bhagalpur,Bihar',
'Branch Post Office,Bhagalpur,Bihar',
'Branch Post Office,Bhagalpur,Bihar',
'Branch Post Office,Bhagalpur,Bihar',
'Branch Post Office,Bhagalpur,Bihar',
'Branch Post Office,Bhagalpur,Bihar',
'Branch Post Office,Bhagalpur,Bihar',
'Branch Post Office,Bhagalpur,Bihar',
'Sub Post Office,Bhagalpur,Bihar',
'Branch Post Office,Bhagalpur,Bihar',
'Branch Post Office,Bhagalpur,Bihar',
'Branch Post Office,Bhagalpur,Bihar',
'Branch Post Office,Bhagalpur,Bihar',
'Branch Post Office,Bhagalpur,Bihar',
'Branch Post Office,Bhagalpur,Bihar',
'Branch Post Office,Bhagalpur,Bihar',
'Branch Post Office,Bhagalpur,Bihar',
'Branch Post Office,Bhagalpur,Bihar',
'Branch Post Office,Bhagalpur,Bihar',
'Sub Post Office,Bhagalpur,Bihar',
'Branch Post Office,Bhagalpur,Bihar',
'Branch Post Office,Bhagalpur,Bihar',
'Branch Post Office,Bhagalpur,Bihar',
'Branch Post Office,Bhagalpur,Bihar',
'Branch Post Office,Bhagalpur,Bihar',
'Branch Post Office,Bhagalpur,Bihar',
'Sub Post Office,Bhagalpur,Bihar',
'Branch Post Office,Bhagalpur,Bihar',
'Branch Post Office,Bhagalpur,Bihar',
'Branch Post Office,Bhagalpur,Bihar',
'Branch Post Office,Bhagalpur,Bihar',
'Branch Post Office,Bhagalpur,Bihar',
'Branch Post Office,Bhagalpur,Bihar',
'Branch Post Office,Bhagalpur,Bihar',
'Branch Post Office,Bhagalpur,Bihar',
'Branch Post Office,Bhagalpur,Bihar',
'Branch Post Office,Bhagalpur,Bihar',
'Branch Post Office,Bhagalpur,Bihar',
'Branch Post Office,Bhagalpur,Bihar',
'Branch Post Office,Bhagalpur,Bihar',
'Branch Post Office,Bhagalpur,Bihar',
'Branch Post Office,Bhagalpur,Bihar',
'Branch Post Office,Bhagalpur,Bihar',
'Branch Post Office,Bhagalpur,Bihar',
'Branch Post Office,Bhagalpur,Bihar',
'Sub Post Office,Bhagalpur,Bihar',
'Branch Post Office,Bhagalpur,Bihar',
'Branch Post Office,Bhagalpur,Bihar',
'Branch Post Office,Bhagalpur,Bihar',
'Branch Post Office,Bhagalpur,Bihar',
'Branch Post Office,Bhagalpur,Bihar',
'Branch Post Office,Bhagalpur,Bihar',
'Sub Post Office,Bhagalpur,Bihar',
'Branch Post Office,Bhagalpur,Bihar',
'Branch Post Office,Bhagalpur,Bihar',
'Branch Post Office,Bhagalpur,Bihar',
'Branch Post Office,Bhagalpur,Bihar',
'Branch Post Office,Bhagalpur,Bihar',
'Branch Post Office,Bhagalpur,Bihar',
'Branch Post Office,Bhagalpur,Bihar',
'Branch Post Office,Bhagalpur,Bihar',
'Branch Post Office,Bhagalpur,Bihar',
'Branch Post Office,Bhagalpur,Bihar',
'Branch Post Office,Bhagalpur,Bihar',
'Branch Post Office,Bhagalpur,Bihar',
'Branch Post Office,Bhagalpur,Bihar',
'Branch Post Office,Bhagalpur,Bihar',
'Branch Post Office,Bhagalpur,Bihar',
'Sub Post Office,Bhagalpur,Bihar',
'Sub Post Office,Bhagalpur,Bihar',
'Branch Post Office,Bhagalpur,Bihar',
'Sub Post Office,Bhagalpur,Bihar',
'Branch Post Office,Monghyr,Bihar',
'Branch Post Office,Bhagalpur,Bihar',
'Branch Post Office,Bhagalpur,Bihar',
'Branch Post Office,Bhagalpur,Bihar',
'Branch Post Office,Bhagalpur,Bihar',
'Branch Post Office,Bhagalpur,Bihar',
'Sub Post Office,Bhagalpur,Bihar',
'Branch Post Office,Bhagalpur,Bihar',
'Branch Post Office,Bhagalpur,Bihar',
'Branch Post Office,Bhagalpur,Bihar',
'Sub Post Office,Bhagalpur,Bihar',
'Branch Post Office,Bhagalpur,Bihar',
'Branch Post Office,Bhagalpur,Bihar',
'Branch Post Office,Bhagalpur,Bihar',
'Branch Post Office,Bhagalpur,Bihar',
'Branch Post Office,Bhagalpur,Bihar',
'Sub Post Office,Bhojpur,Bihar',
'Branch Post Office,Bhojpur,Bihar',
'Branch Post Office,Bhojpur,Bihar',
'Branch Post Office,Bhojpur,Bihar',
'Sub Post Office,Bhojpur,Bihar',
'Sub Post Office,Bhojpur,Bihar',
'Sub Post Office,Bhojpur,Bihar',
'Branch Post Office,Bhojpur,Bihar',
'Branch Post Office,Bhojpur,Bihar',
'Branch Post Office,Bhojpur,Bihar',
'Branch Post Office,Bhojpur,Bihar',
'Branch Post Office,Bhojpur,Bihar',
'Branch Post Office,Bhojpur,Bihar',
'Branch Post Office,Bhojpur,Bihar',
'Branch Post Office,Bhojpur,Bihar',
'Branch Post Office,Bhojpur,Bihar',
'Branch Post Office,Bhojpur,Bihar',
'Branch Post Office,Bhojpur,Bihar',
'Branch Post Office,Bhojpur,Bihar',
'Branch Post Office,Bhojpur,Bihar',
'Sub Post Office,Bhojpur,Bihar',
'Branch Post Office,Bhojpur,Bihar',
'Branch Post Office,Bhojpur,Bihar',
'Branch Post Office,Bhojpur,Bihar',
'Branch Post Office,Bhojpur,Bihar',
'Branch Post Office,Bhojpur,Bihar',
'Branch Post Office,Bhojpur,Bihar',
'Sub Post Office,Bhojpur,Bihar',
'Branch Post Office,Bhojpur,Bihar',
'Branch Post Office,Bhojpur,Bihar',
'Branch Post Office,Bhojpur,Bihar',
'Branch Post Office,Bhojpur,Bihar',
'Branch Post Office,Bhojpur,Bihar',
'Branch Post Office,Bhojpur,Bihar',
'Branch Post Office,Bhojpur,Bihar',
'Sub Post Office,Bhojpur,Bihar',
'Branch Post Office,Bhojpur,Bihar',
'Branch Post Office,Bhojpur,Bihar',
'Branch Post Office,Bhojpur,Bihar',
'Branch Post Office,Bhojpur,Bihar',
'Branch Post Office,Bhojpur,Bihar',
'Branch Post Office,Bhojpur,Bihar',
'Branch Post Office,Bhojpur,Bihar',
'Branch Post Office,Bhojpur,Bihar',
'Branch Post Office,Bhojpur,Bihar',
'Branch Post Office,Bhojpur,Bihar',
'Branch Post Office,Bhojpur,Bihar',
'Sub Post Office,Bhojpur,Bihar',
'Branch Post Office,Bhojpur,Bihar',
'Branch Post Office,Bhojpur,Bihar',
'Branch Post Office,Bhojpur,Bihar',
'Branch Post Office,Bhojpur,Bihar',
'Branch Post Office,Bhojpur,Bihar',
'Sub Post Office,Bhojpur,Bihar',
'Branch Post Office,Bhojpur,Bihar',
'Sub Post Office,Bhojpur,Bihar',
'Branch Post Office,Bhojpur,Bihar',
'Branch Post Office,Bhojpur,Bihar',
'Sub Post Office,Bhojpur,Bihar',
'Sub Post Office,Bhojpur,Bihar',
'Branch Post Office,Bhojpur,Bihar',
'Branch Post Office,Bhojpur,Bihar',
'Branch Post Office,Bhojpur,Bihar',
'Branch Post Office,Bhojpur,Bihar',
'Branch Post Office,Bhojpur,Bihar',
'Branch Post Office,Bhojpur,Bihar',
'Branch Post Office,Bhojpur,Bihar',
'Sub Post Office,Bhojpur,Bihar',
'Branch Post Office,Bhojpur,Bihar',
'Branch Post Office,Bhojpur,Bihar',
'Sub Post Office,Bhojpur,Bihar',
'Branch Post Office,Bhojpur,Bihar',
'Branch Post Office,Bhojpur,Bihar',
'Branch Post Office,Bhojpur,Bihar',
'Branch Post Office,Bhojpur,Bihar',
'Sub Post Office,Bhojpur,Bihar',
'Branch Post Office,Bhojpur,Bihar',
'Branch Post Office,Bhojpur,Bihar',
'Branch Post Office,Bhojpur,Bihar',
'Branch Post Office,Bhojpur,Bihar',
'Branch Post Office,Bhojpur,Bihar',
'Sub Post Office,Bhojpur,Bihar',
'Branch Post Office,Bhojpur,Bihar',
'Sub Post Office,Bhojpur,Bihar',
'Branch Post Office,Bhojpur,Bihar',
'Branch Post Office,Bhojpur,Bihar',
'Branch Post Office,Bhojpur,Bihar',
'Branch Post Office,Bhojpur,Bihar',
'Branch Post Office,Bhojpur,Bihar',
'Branch Post Office,Bhojpur,Bihar',
'Branch Post Office,Bhojpur,Bihar',
'Branch Post Office,Bhojpur,Bihar',
'Branch Post Office,Bhojpur,Bihar',
'Sub Post Office,Bhojpur,Bihar',
'Branch Post Office,Bhojpur,Bihar',
'Branch Post Office,Bhojpur,Bihar',
'Sub Post Office,Bhojpur,Bihar',
'Sub Post Office,Bhojpur,Bihar',
'Branch Post Office,Bhojpur,Bihar',
'Branch Post Office,Bhojpur,Bihar',
'Sub Post Office,Bhojpur,Bihar',
'Branch Post Office,Bhojpur,Bihar',
'Branch Post Office,Bhojpur,Bihar',
'Branch Post Office,Bhojpur,Bihar',
'Branch Post Office,Bhojpur,Bihar',
'Branch Post Office,Bhojpur,Bihar',
'Branch Post Office,Bhojpur,Bihar',
'Branch Post Office,Bhojpur,Bihar',
'Branch Post Office,Bhojpur,Bihar',
'Branch Post Office,Bhojpur,Bihar',
'Branch Post Office,Bhojpur,Bihar',
'Branch Post Office,Bhojpur,Bihar',
'Branch Post Office,Bhojpur,Bihar',
'Branch Post Office,Bhojpur,Bihar',
'Branch Post Office,Bhojpur,Bihar',
'Branch Post Office,Bhojpur,Bihar',
'Branch Post Office,Bhojpur,Bihar',
'Branch Post Office,Bhojpur,Bihar',
'Branch Post Office,Bhojpur,Bihar',
'Branch Post Office,Bhojpur,Bihar',
'Branch Post Office,Bhojpur,Bihar',
'Branch Post Office,Bhojpur,Bihar',
'Sub Post Office,Bhojpur,Bihar',
'Branch Post Office,Bhojpur,Bihar',
'Branch Post Office,Bhojpur,Bihar',
'Branch Post Office,Bhojpur,Bihar',
'Branch Post Office,Bhojpur,Bihar',
'Sub Post Office,Bhojpur,Bihar',
'Sub Post Office,Bhojpur,Bihar',
'Sub Post Office,Bhojpur,Bihar',
'Branch Post Office,Bhojpur,Bihar',
'Branch Post Office,Bhojpur,Bihar',
'Branch Post Office,Bhojpur,Bihar',
'Branch Post Office,Bhojpur,Bihar',
'Sub Post Office,Bhojpur,Bihar',
'Sub Post Office,Bhojpur,Bihar',
'Head Post Office,Bhojpur,Bihar',
'Sub Post Office,Bhojpur,Bihar',
'Branch Post Office,Bhojpur,Bihar',
'Branch Post Office,Bhojpur,Bihar',
'Branch Post Office,Bhojpur,Bihar',
'Branch Post Office,Bhojpur,Bihar',
'Branch Post Office,Bhojpur,Bihar',
'Branch Post Office,Bhojpur,Bihar',
'Branch Post Office,Bhojpur,Bihar',
'Branch Post Office,Bhojpur,Bihar',
'Branch Post Office,Bhojpur,Bihar',
'Branch Post Office,Bhojpur,Bihar',
'Branch Post Office,Bhojpur,Bihar',
'Branch Post Office,Bhojpur,Bihar',
'Branch Post Office,Bhojpur,Bihar',
'Branch Post Office,Bhojpur,Bihar',
'Branch Post Office,Bhojpur,Bihar',
'Sub Post Office,Bhojpur,Bihar',
'Sub Post Office,Bhojpur,Bihar',
'Branch Post Office,Bhojpur,Bihar',
'Branch Post Office,Bhojpur,Bihar',
'Branch Post Office,Bhojpur,Bihar',
'Sub Post Office,Bhojpur,Bihar',
'Branch Post Office,Bhojpur,Bihar',
'Sub Post Office,Bhojpur,Bihar',
'Branch Post Office,Bhojpur,Bihar',
'Branch Post Office,Bhojpur,Bihar',
'Sub Post Office,Bhojpur,Bihar',
'Branch Post Office,Bhojpur,Bihar',
'Branch Post Office,Bhojpur,Bihar',
'Branch Post Office,Bhojpur,Bihar',
'Sub Post Office,Bhojpur,Bihar',
'Branch Post Office,Bhojpur,Bihar',
'Branch Post Office,Bhojpur,Bihar',
'Branch Post Office,Bhojpur,Bihar',
'Branch Post Office,Bhojpur,Bihar',
'Branch Post Office,Bhojpur,Bihar',
'Branch Post Office,Bhojpur,Bihar',
'Branch Post Office,Bhojpur,Bihar',
'Branch Post Office,Bhojpur,Bihar',
'Branch Post Office,Bhojpur,Bihar',
'Branch Post Office,Bhojpur,Bihar',
'Branch Post Office,Bhojpur,Bihar',
'Branch Post Office,Bhojpur,Bihar',
'Branch Post Office,Bhojpur,Bihar',
'Branch Post Office,Bhojpur,Bihar',
'Branch Post Office,Bhojpur,Bihar',
'Branch Post Office,Bhojpur,Bihar',
'Branch Post Office,Bhojpur,Bihar',
'Branch Post Office,Bhojpur,Bihar',
'Branch Post Office,Bhojpur,Bihar',
'Branch Post Office,Bhojpur,Bihar',
'Sub Post Office,Bhojpur,Bihar',
'Branch Post Office,Bhojpur,Bihar',
'Branch Post Office,Bhojpur,Bihar',
'Branch Post Office,Bhojpur,Bihar',
'Branch Post Office,Bhojpur,Bihar',
'Branch Post Office,Bhojpur,Bihar',
'Branch Post Office,Bhojpur,Bihar',
'Branch Post Office,Bhojpur,Bihar',
'Sub Post Office,Bhojpur,Bihar',
'Branch Post Office,Bhojpur,Bihar',
'Branch Post Office,Bhojpur,Bihar',
'Branch Post Office,Bhojpur,Bihar',
'Sub Post Office,Bhojpur,Bihar',
'Branch Post Office,Bhojpur,Bihar',
'Branch Post Office,Bhojpur,Bihar',
'Branch Post Office,Bhojpur,Bihar',
'Branch Post Office,Bhojpur,Bihar',
'Branch Post Office,Bhojpur,Bihar',
'Branch Post Office,Bhojpur,Bihar',
'Branch Post Office,Bhojpur,Bihar',
'Branch Post Office,Bhojpur,Bihar',
'Branch Post Office,Bhojpur,Bihar',
'Sub Post Office,Bhojpur,Bihar',
'Branch Post Office,Bhojpur,Bihar',
'Branch Post Office,Bhojpur,Bihar',
'Branch Post Office,Bhojpur,Bihar',
'Branch Post Office,Bhojpur,Bihar',
'Branch Post Office,Bhojpur,Bihar',
'Branch Post Office,Bhojpur,Bihar',
'Branch Post Office,Bhojpur,Bihar',
'Branch Post Office,Bhojpur,Bihar',
'Sub Post Office,Bhojpur,Bihar',
'Branch Post Office,Bhojpur,Bihar',
'Branch Post Office,Bhojpur,Bihar',
'Branch Post Office,Bhojpur,Bihar',
'Branch Post Office,Bhojpur,Bihar',
'Branch Post Office,Bhojpur,Bihar',
'Branch Post Office,Bhojpur,Bihar',
'Branch Post Office,Bhojpur,Bihar',
'Branch Post Office,Bhojpur,Bihar',
'Branch Post Office,Bhojpur,Bihar',
'Branch Post Office,Bhojpur,Bihar',
'Branch Post Office,Bhojpur,Bihar',
'Branch Post Office,Bhojpur,Bihar',
'Branch Post Office,Bhojpur,Bihar',
'Branch Post Office,Bhojpur,Bihar',
'Branch Post Office,Bhojpur,Bihar',
'Sub Post Office,Bhojpur,Bihar',
'Branch Post Office,Bhojpur,Bihar',
'Branch Post Office,Bhojpur,Bihar',
'Branch Post Office,Bhojpur,Bihar',
'Branch Post Office,Bhojpur,Bihar',
'Branch Post Office,Bhojpur,Bihar',
'Sub Post Office,Bhojpur,Bihar',
'Branch Post Office,Bhojpur,Bihar',
'Branch Post Office,Bhojpur,Bihar',
'Sub Post Office,Bhojpur,Bihar',
'Branch Post Office,Bhojpur,Bihar',
'Branch Post Office,Bhojpur,Bihar',
'Branch Post Office,Bhojpur,Bihar',
'Sub Post Office,Bhojpur,Bihar',
'Branch Post Office,Bhojpur,Bihar',
'Branch Post Office,Bhojpur,Bihar',
'Branch Post Office,Bhojpur,Bihar',
'Branch Post Office,Bhojpur,Bihar',
'Branch Post Office,Bhojpur,Bihar',
'Branch Post Office,Bhojpur,Bihar',
'Branch Post Office,Bhojpur,Bihar',
'Branch Post Office,Bhojpur,Bihar',
'Branch Post Office,Bhojpur,Bihar',
'Branch Post Office,Bhojpur,Bihar',
'Branch Post Office,Bhojpur,Bihar',
'Branch Post Office,Bhojpur,Bihar',
'Branch Post Office,Bhojpur,Bihar',
'Branch Post Office,Bhojpur,Bihar',
'Branch Post Office,Bhojpur,Bihar',
'Branch Post Office,Bhojpur,Bihar',
'Branch Post Office,Bhojpur,Bihar',
'Branch Post Office,Bhojpur,Bihar',
'Branch Post Office,Bhojpur,Bihar',
'Branch Post Office,Bhojpur,Bihar',
'Branch Post Office,Bhojpur,Bihar',
'Branch Post Office,Bhojpur,Bihar',
'Branch Post Office,Bhojpur,Bihar',
'Branch Post Office,Bhojpur,Bihar',
'Branch Post Office,Bhojpur,Bihar',
'Branch Post Office,Bhojpur,Bihar',
'Branch Post Office,Bhojpur,Bihar',
'Branch Post Office,Bhojpur,Bihar',
'Branch Post Office,Bhojpur,Bihar',
'Sub Post Office,Bhojpur,Bihar',
'Branch Post Office,Bhojpur,Bihar',
'Branch Post Office,Bhojpur,Bihar',
'Branch Post Office,Bhojpur,Bihar',
'Branch Post Office,Bhojpur,Bihar',
'Branch Post Office,Bhojpur,Bihar',
'Sub Post Office,Bhojpur,Bihar',
'Branch Post Office,Bhojpur,Bihar',
'Branch Post Office,Bhojpur,Bihar',
'Branch Post Office,Bhojpur,Bihar',
'Branch Post Office,Bhojpur,Bihar',
'Branch Post Office,Bhojpur,Bihar',
'Branch Post Office,Bhojpur,Bihar',
'Branch Post Office,Bhojpur,Bihar',
'Branch Post Office,Bhojpur,Bihar',
'Branch Post Office,Bhojpur,Bihar',
'Branch Post Office,Bhojpur,Bihar',
'Branch Post Office,Bhojpur,Bihar',
'Branch Post Office,Bhojpur,Bihar',
'Sub Post Office,Bhojpur,Bihar',
'Branch Post Office,Bhojpur,Bihar',
'Branch Post Office,Bhojpur,Bihar',
'Branch Post Office,Bhojpur,Bihar',
'Branch Post Office,Bhojpur,Bihar',
'Branch Post Office,Bhojpur,Bihar',
'Branch Post Office,Bhojpur,Bihar',
'Branch Post Office,Bhojpur,Bihar',
'Branch Post Office,Bhojpur,Bihar',
'Branch Post Office,Bhojpur,Bihar',
'Branch Post Office,Bhojpur,Bihar',
'Sub Post Office,Bhojpur,Bihar',
'Branch Post Office,Bhojpur,Bihar',
'Branch Post Office,Bhojpur,Bihar',
'Branch Post Office,Bhojpur,Bihar',
'Branch Post Office,Bhojpur,Bihar',
'Branch Post Office,Bhojpur,Bihar',
'Head Post Office,Bhojpur,Bihar',
'Sub Post Office,Bhojpur,Bihar',
'Branch Post Office,Bhojpur,Bihar',
'Sub Post Office,Bhojpur,Bihar',
'Branch Post Office,Bhojpur,Bihar',
'Branch Post Office,Bhojpur,Bihar',
'Sub Post Office,Bhojpur,Bihar',
'Branch Post Office,Bhojpur,Bihar',
'Branch Post Office,Bhojpur,Bihar',
'Branch Post Office,Bhojpur,Bihar',
'Branch Post Office,Bhojpur,Bihar',
'Sub Post Office,Bhojpur,Bihar',
'Branch Post Office,Bhojpur,Bihar',
'Sub Post Office,Bhojpur,Bihar',
'Branch Post Office,Bhojpur,Bihar',
'Branch Post Office,Bhojpur,Bihar',
'Branch Post Office,Bhojpur,Bihar',
'Branch Post Office,Bhojpur,Bihar',
'Branch Post Office,Bhojpur,Bihar',
'Branch Post Office,Bhojpur,Bihar',
'Sub Post Office,Bhojpur,Bihar',
'Branch Post Office,Bhojpur,Bihar',
'Sub Post Office,Bhojpur,Bihar',
'Branch Post Office,Bhojpur,Bihar',
'Branch Post Office,Bhojpur,Bihar',
'Branch Post Office,Bhojpur,Bihar',
'Branch Post Office,Bhojpur,Bihar',
'Branch Post Office,Bhojpur,Bihar',
'Branch Post Office,Bhojpur,Bihar',
'Branch Post Office,Bhojpur,Bihar',
'Branch Post Office,Bhojpur,Bihar',
'Branch Post Office,Bhojpur,Bihar',
'Branch Post Office,Bhojpur,Bihar',
'Branch Post Office,Bhojpur,Bihar',
'Branch Post Office,Bhojpur,Bihar',
'Branch Post Office,Bhojpur,Bihar',
'Sub Post Office,Bhojpur,Bihar',
'Branch Post Office,Bhojpur,Bihar',
'Branch Post Office,Bhojpur,Bihar',
'Branch Post Office,Bhojpur,Bihar',
'Branch Post Office,Bhojpur,Bihar',
'Branch Post Office,Bhojpur,Bihar',
'Sub Post Office,Bhojpur,Bihar',
'Branch Post Office,Bhojpur,Bihar',
'Branch Post Office,Bhojpur,Bihar',
'Branch Post Office,Bhojpur,Bihar',
'Branch Post Office,Bhojpur,Bihar',
'Branch Post Office,Bhojpur,Bihar',
'Sub Post Office,Bhojpur,Bihar',
'Branch Post Office,Bhojpur,Bihar',
'Sub Post Office,Bhojpur,Bihar',
'Branch Post Office,Bhojpur,Bihar',
'Branch Post Office,Bhojpur,Bihar',
'Branch Post Office,Bhojpur,Bihar',
'Branch Post Office,Bhojpur,Bihar',
'Branch Post Office,Bhojpur,Bihar',
'Branch Post Office,Bhojpur,Bihar',
'Branch Post Office,Bhojpur,Bihar',
'Branch Post Office,Bhojpur,Bihar',
'Branch Post Office,Bhojpur,Bihar',
'Sub Post Office,Bhojpur,Bihar',
'Branch Post Office,Bhojpur,Bihar',
'Sub Post Office,Bhojpur,Bihar',
'Branch Post Office,Bhojpur,Bihar',
'Branch Post Office,Bhojpur,Bihar',
'Branch Post Office,Bhojpur,Bihar',
'Branch Post Office,Bhojpur,Bihar',
'Branch Post Office,Bhojpur,Bihar',
'Branch Post Office,Bhojpur,Bihar',
'Branch Post Office,Bhojpur,Bihar',
'Branch Post Office,Bhojpur,Bihar',
'Branch Post Office,Bhojpur,Bihar',
'Branch Post Office,Bhojpur,Bihar',
'Branch Post Office,Bhojpur,Bihar',
'Branch Post Office,Bhojpur,Bihar',
'Branch Post Office,Bhojpur,Bihar',
'Branch Post Office,Bhojpur,Bihar',
'Branch Post Office,Bhojpur,Bihar',
'Branch Post Office,Bhojpur,Bihar',
'Branch Post Office,Bhojpur,Bihar',
'Branch Post Office,Bhojpur,Bihar',
'Branch Post Office,Bhojpur,Bihar',
'Branch Post Office,Bhojpur,Bihar',
'Branch Post Office,Bhojpur,Bihar',
'Branch Post Office,Bhojpur,Bihar',
'Branch Post Office,Bhojpur,Bihar',
'Branch Post Office,Bhojpur,Bihar',
'Branch Post Office,Bhojpur,Bihar',
'Branch Post Office,Bhojpur,Bihar',
'Branch Post Office,Bhojpur,Bihar',
'Branch Post Office,Bhojpur,Bihar',
'Branch Post Office,Bhojpur,Bihar',
'Sub Post Office,Bhojpur,Bihar',
'Branch Post Office,Bhojpur,Bihar',
'Branch Post Office,Bhojpur,Bihar',
'Sub Post Office,Bhojpur,Bihar',
'Branch Post Office,Bhojpur,Bihar',
'Branch Post Office,Bhojpur,Bihar',
'Branch Post Office,Bhojpur,Bihar',
'Branch Post Office,Bhojpur,Bihar',
'Branch Post Office,Bhojpur,Bihar',
'Branch Post Office,Bhojpur,Bihar',
'Branch Post Office,Bhojpur,Bihar',
'Branch Post Office,Bhojpur,Bihar',
'Sub Post Office,Bhojpur,Bihar',
'Sub Post Office,Bhojpur,Bihar',
'Sub Post Office,Bhojpur,Bihar',
'Branch Post Office,Bhojpur,Bihar',
'Branch Post Office,Bhojpur,Bihar',
'Branch Post Office,Bhojpur,Bihar',
'Branch Post Office,Bhojpur,Bihar',
'Branch Post Office,Bhojpur,Bihar',
'Branch Post Office,Bhojpur,Bihar',
'Branch Post Office,Bhojpur,Bihar',
'Branch Post Office,Bhojpur,Bihar',
'Branch Post Office,Bhojpur,Bihar',
'Branch Post Office,Bhojpur,Bihar',
'Branch Post Office,Bhojpur,Bihar',
'Branch Post Office,Bhojpur,Bihar',
'Branch Post Office,Bhojpur,Bihar',
'Branch Post Office,Bhojpur,Bihar',
'Branch Post Office,Bhojpur,Bihar',
'Branch Post Office,Bhojpur,Bihar',
'Branch Post Office,Bhojpur,Bihar',
'Branch Post Office,Bhojpur,Bihar',
'Sub Post Office,Bhojpur,Bihar',
'Branch Post Office,Bhojpur,Bihar',
'Branch Post Office,Bhojpur,Bihar',
'Branch Post Office,Bhojpur,Bihar',
'Branch Post Office,Bhojpur,Bihar',
'Sub Post Office,Bhojpur,Bihar',
'Branch Post Office,Bhojpur,Bihar',
'Branch Post Office,Bhojpur,Bihar',
'Branch Post Office,Bhojpur,Bihar',
'Branch Post Office,Bhojpur,Bihar',
'Branch Post Office,Bhojpur,Bihar',
'Branch Post Office,Bhojpur,Bihar',
'Branch Post Office,Bhojpur,Bihar',
'Sub Post Office,Bhojpur,Bihar',
'Branch Post Office,Bhojpur,Bihar',
'Branch Post Office,Bhojpur,Bihar',
'Branch Post Office,Bhojpur,Bihar',
'Branch Post Office,Bhojpur,Bihar',
'Branch Post Office,Bhojpur,Bihar',
'Sub Post Office,Bhojpur,Bihar',
'Branch Post Office,Bhojpur,Bihar',
'Branch Post Office,Bhojpur,Bihar',
'Sub Post Office,Bhojpur,Bihar',
'Branch Post Office,Bhojpur,Bihar',
'Branch Post Office,Bhojpur,Bihar',
'Branch Post Office,Bhojpur,Bihar',
'Branch Post Office,Bhojpur,Bihar',
'Branch Post Office,Bhojpur,Bihar',
'Branch Post Office,Bhojpur,Bihar',
'Branch Post Office,Bhojpur,Bihar',
'Sub Post Office,Bhojpur,Bihar',
'Sub Post Office,Bhojpur,Bihar',
'Branch Post Office,Bhojpur,Bihar',
'Branch Post Office,Bhojpur,Bihar',
'Branch Post Office,Bhojpur,Bihar',
'Branch Post Office,Bhojpur,Bihar',
'Branch Post Office,Bhojpur,Bihar',
'Branch Post Office,Bhojpur,Bihar',
'Branch Post Office,Bhojpur,Bihar',
'Branch Post Office,Bhojpur,Bihar',
'Branch Post Office,Bhojpur,Bihar',
'Branch Post Office,Bhojpur,Bihar',
'Branch Post Office,Bhojpur,Bihar',
'Branch Post Office,Bhojpur,Bihar',
'Branch Post Office,Bhojpur,Bihar',
'Sub Post Office,Bhojpur,Bihar',
'Branch Post Office,Bhojpur,Bihar',
'Branch Post Office,Darbhanga,Bihar',
'Branch Post Office,Saharsa,Bihar',
'Branch Post Office,Darbhanga,Bihar',
'Branch Post Office,Darbhanga,Bihar',
'Branch Post Office,Darbhanga,Bihar',
'Branch Post Office,Darbhanga,Bihar',
'Branch Post Office,Darbhanga,Bihar',
'Branch Post Office,Darbhanga,Bihar',
'Branch Post Office,Darbhanga,Bihar',
'Branch Post Office,Darbhanga,Bihar',
'Branch Post Office,Darbhanga,Bihar',
'Branch Post Office,Darbhanga,Bihar',
'Branch Post Office,Darbhanga,Bihar',
'Branch Post Office,Darbhanga,Bihar',
'Branch Post Office,Darbhanga,Bihar',
'Branch Post Office,Darbhanga,Bihar',
'Branch Post Office,Darbhanga,Bihar',
'Branch Post Office,Darbhanga,Bihar',
'Branch Post Office,Darbhanga,Bihar',
'Branch Post Office,Darbhanga,Bihar',
'Branch Post Office,Darbhanga,Bihar',
'Branch Post Office,Darbhanga,Bihar',
'Branch Post Office,Darbhanga,Bihar',
'Branch Post Office,Darbhanga,Bihar',
'Branch Post Office,Darbhanga,Bihar',
'Branch Post Office,Darbhanga,Bihar',
'Branch Post Office,Darbhanga,Bihar',
'Branch Post Office,Darbhanga,Bihar',
'Branch Post Office,Darbhanga,Bihar',
'Branch Post Office,Darbhanga,Bihar',
'Branch Post Office,Darbhanga,Bihar',
'Branch Post Office,Darbhanga,Bihar',
'Branch Post Office,Darbhanga,Bihar',
'Branch Post Office,Darbhanga,Bihar',
'Branch Post Office,Darbhanga,Bihar',
'Branch Post Office,Darbhanga,Bihar',
'Branch Post Office,Darbhanga,Bihar',
'Branch Post Office,Darbhanga,Bihar',
'Branch Post Office,Darbhanga,Bihar',
'Branch Post Office,Darbhanga,Bihar',
'Branch Post Office,Darbhanga,Bihar',
'Branch Post Office,Darbhanga,Bihar',
'Branch Post Office,Darbhanga,Bihar',
'Branch Post Office,Darbhanga,Bihar',
'Branch Post Office,Darbhanga,Bihar',
'Branch Post Office,Darbhanga,Bihar',
'Branch Post Office,Darbhanga,Bihar',
'Branch Post Office,Darbhanga,Bihar',
'Branch Post Office,Darbhanga,Bihar',
'Sub Post Office,Darbhanga,Bihar',
'Branch Post Office,Darbhanga,Bihar',
'Branch Post Office,Darbhanga,Bihar',
'Branch Post Office,Darbhanga,Bihar',
'Branch Post Office,Darbhanga,Bihar',
'Branch Post Office,Darbhanga,Bihar',
'Sub Post Office,Darbhanga,Bihar',
'Branch Post Office,Darbhanga,Bihar',
'Branch Post Office,Darbhanga,Bihar',
'Branch Post Office,Darbhanga,Bihar',
'Branch Post Office,Darbhanga,Bihar',
'Branch Post Office,Madhubani,Bihar',
'Branch Post Office,Darbhanga,Bihar',
'Branch Post Office,Darbhanga,Bihar',
'Sub Post Office,Darbhanga,Bihar',
'Branch Post Office,Darbhanga,Bihar',
'Branch Post Office,Madhubani,Bihar',
'Branch Post Office,Darbhanga,Bihar',
'Sub Post Office,Darbhanga,Bihar',
'Branch Post Office,Madhubani,Bihar',
'Branch Post Office,Darbhanga,Bihar',
'Branch Post Office,Darbhanga,Bihar',
'Branch Post Office,Darbhanga,Bihar',
'Branch Post Office,Darbhanga,Bihar',
'Branch Post Office,Darbhanga,Bihar',
'Branch Post Office,Darbhanga,Bihar',
'Branch Post Office,Darbhanga,Bihar',
'Branch Post Office,Darbhanga,Bihar',
'Branch Post Office,Darbhanga,Bihar',
'Branch Post Office,Darbhanga,Bihar',
'Branch Post Office,Darbhanga,Bihar',
'Branch Post Office,Darbhanga,Bihar',
'Branch Post Office,Darbhanga,Bihar',
'Branch Post Office,Darbhanga,Bihar',
'Branch Post Office,Darbhanga,Bihar',
'Branch Post Office,Darbhanga,Bihar',
'Branch Post Office,Darbhanga,Bihar',
'Branch Post Office,Darbhanga,Bihar',
'Branch Post Office,Darbhanga,Bihar',
'Branch Post Office,Darbhanga,Bihar',
'Branch Post Office,Darbhanga,Bihar',
'Branch Post Office,Darbhanga,Bihar',
'Branch Post Office,Darbhanga,Bihar',
'Branch Post Office,Darbhanga,Bihar',
'Branch Post Office,Darbhanga,Bihar',
'Branch Post Office,Darbhanga,Bihar',
'Branch Post Office,Darbhanga,Bihar',
'Branch Post Office,Darbhanga,Bihar',
'Sub Post Office,Darbhanga,Bihar',
'Branch Post Office,Darbhanga,Bihar',
'Branch Post Office,Darbhanga,Bihar',
'Sub Post Office,Darbhanga,Bihar',
'Branch Post Office,Darbhanga,Bihar',
'Branch Post Office,Darbhanga,Bihar',
'Branch Post Office,Darbhanga,Bihar',
'Branch Post Office,Darbhanga,Bihar',
'Branch Post Office,Darbhanga,Bihar',
'Branch Post Office,Darbhanga,Bihar',
'Branch Post Office,Darbhanga,Bihar',
'Branch Post Office,Darbhanga,Bihar',
'Branch Post Office,Darbhanga,Bihar',
'Branch Post Office,Darbhanga,Bihar',
'Branch Post Office,Darbhanga,Bihar',
'Branch Post Office,Darbhanga,Bihar',
'Branch Post Office,Darbhanga,Bihar',
'Branch Post Office,Darbhanga,Bihar',
'Branch Post Office,Darbhanga,Bihar',
'Branch Post Office,Darbhanga,Bihar',
'Sub Post Office,Darbhanga,Bihar',
'Branch Post Office,Darbhanga,Bihar',
'Branch Post Office,Darbhanga,Bihar',
'Branch Post Office,Darbhanga,Bihar',
'Branch Post Office,Darbhanga,Bihar',
'Branch Post Office,Darbhanga,Bihar',
'Branch Post Office,Darbhanga,Bihar',
'Branch Post Office,Darbhanga,Bihar',
'Branch Post Office,Darbhanga,Bihar',
'Branch Post Office,Darbhanga,Bihar',
'Branch Post Office,Darbhanga,Bihar',
'Branch Post Office,Darbhanga,Bihar',
'Branch Post Office,Darbhanga,Bihar',
'Branch Post Office,Darbhanga,Bihar',
'Branch Post Office,Darbhanga,Bihar',
'Branch Post Office,Darbhanga,Bihar',
'Sub Post Office,Darbhanga,Bihar',
'Branch Post Office,Darbhanga,Bihar',
'Branch Post Office,Darbhanga,Bihar',
'Branch Post Office,Darbhanga,Bihar',
'Branch Post Office,Darbhanga,Bihar',
'Branch Post Office,Darbhanga,Bihar',
'Branch Post Office,Darbhanga,Bihar',
'Branch Post Office,Darbhanga,Bihar',
'Branch Post Office,Darbhanga,Bihar',
'Branch Post Office,Darbhanga,Bihar',
'Branch Post Office,Darbhanga,Bihar',
'Branch Post Office,Darbhanga,Bihar',
'Branch Post Office,Darbhanga,Bihar',
'Branch Post Office,Darbhanga,Bihar',
'Branch Post Office,Darbhanga,Bihar',
'Sub Post Office,Darbhanga,Bihar',
'Branch Post Office,Darbhanga,Bihar',
'Branch Post Office,Darbhanga,Bihar',
'Branch Post Office,Madhubani,Bihar',
'Sub Post Office,Darbhanga,Bihar',
'Sub Post Office,Darbhanga,Bihar',
'Branch Post Office,Darbhanga,Bihar',
'Branch Post Office,Darbhanga,Bihar',
'Branch Post Office,Darbhanga,Bihar',
'Branch Post Office,Darbhanga,Bihar',
'Branch Post Office,Darbhanga,Bihar',
'Branch Post Office,Darbhanga,Bihar',
'Branch Post Office,Darbhanga,Bihar',
'Branch Post Office,Darbhanga,Bihar',
'Sub Post Office,Darbhanga,Bihar',
'Branch Post Office,Darbhanga,Bihar',
'Sub Post Office,Darbhanga,Bihar',
'Branch Post Office,Darbhanga,Bihar',
'Branch Post Office,Darbhanga,Bihar',
'Sub Post Office,Darbhanga,Bihar',
'Branch Post Office,Darbhanga,Bihar',
'Branch Post Office,Darbhanga,Bihar',
'Branch Post Office,Darbhanga,Bihar',
'Branch Post Office,Darbhanga,Bihar',
'Branch Post Office,Darbhanga,Bihar',
'Branch Post Office,Darbhanga,Bihar',
'Branch Post Office,Darbhanga,Bihar',
'Branch Post Office,Darbhanga,Bihar',
'Branch Post Office,Darbhanga,Bihar',
'Sub Post Office,Darbhanga,Bihar',
'Branch Post Office,Madhubani,Bihar',
'Branch Post Office,Darbhanga,Bihar',
'Sub Post Office,Darbhanga,Bihar',
'Sub Post Office,Darbhanga,Bihar',
'Sub Post Office,Darbhanga,Bihar',
'Head Post Office,Darbhanga,Bihar',
'Branch Post Office,Darbhanga,Bihar',
'Branch Post Office,Darbhanga,Bihar',
'Branch Post Office,Darbhanga,Bihar',
'Branch Post Office,Darbhanga,Bihar',
'Branch Post Office,Darbhanga,Bihar',
'Branch Post Office,Darbhanga,Bihar',
'Branch Post Office,Darbhanga,Bihar',
'Branch Post Office,Darbhanga,Bihar',
'Branch Post Office,Darbhanga,Bihar',
'Branch Post Office,Darbhanga,Bihar',
'Branch Post Office,Darbhanga,Bihar',
'Branch Post Office,Darbhanga,Bihar',
'Branch Post Office,Darbhanga,Bihar',
'Branch Post Office,Darbhanga,Bihar',
'Branch Post Office,Darbhanga,Bihar',
'Branch Post Office,Darbhanga,Bihar',
'Branch Post Office,Darbhanga,Bihar',
'Branch Post Office,Darbhanga,Bihar',
'Branch Post Office,Darbhanga,Bihar',
'Branch Post Office,Darbhanga,Bihar',
'Branch Post Office,Darbhanga,Bihar',
'Sub Post Office,Darbhanga,Bihar',
'Branch Post Office,Darbhanga,Bihar',
'Sub Post Office,Darbhanga,Bihar',
'Branch Post Office,Darbhanga,Bihar',
'Branch Post Office,Darbhanga,Bihar',
'Branch Post Office,Darbhanga,Bihar',
'Branch Post Office,Darbhanga,Bihar',
'Branch Post Office,Darbhanga,Bihar',
'Sub Post Office,Darbhanga,Bihar',
'Branch Post Office,Darbhanga,Bihar',
'Branch Post Office,Darbhanga,Bihar',
'Sub Post Office,Darbhanga,Bihar',
'Branch Post Office,Darbhanga,Bihar',
'Sub Post Office,Darbhanga,Bihar',
'Branch Post Office,Darbhanga,Bihar',
'Branch Post Office,Darbhanga,Bihar',
'Branch Post Office,Darbhanga,Bihar',
'Branch Post Office,Darbhanga,Bihar',
'Branch Post Office,Darbhanga,Bihar',
'Branch Post Office,Darbhanga,Bihar',
'Sub Post Office,Darbhanga,Bihar',
'Branch Post Office,Darbhanga,Bihar',
'Branch Post Office,Darbhanga,Bihar',
'Branch Post Office,Madhubani,Bihar',
'Branch Post Office,Darbhanga,Bihar',
'Sub Post Office,Darbhanga,Bihar',
'Branch Post Office,Darbhanga,Bihar',
'Branch Post Office,Darbhanga,Bihar',
'Branch Post Office,Darbhanga,Bihar',
'Branch Post Office,Darbhanga,Bihar',
'Sub Post Office,Darbhanga,Bihar',
'Branch Post Office,Darbhanga,Bihar',
'Branch Post Office,Darbhanga,Bihar',
'Sub Post Office,Darbhanga,Bihar',
'Branch Post Office,Darbhanga,Bihar',
'Branch Post Office,Darbhanga,Bihar',
'Branch Post Office,Darbhanga,Bihar',
'Branch Post Office,Darbhanga,Bihar',
'Branch Post Office,Darbhanga,Bihar',
'Sub Post Office,Darbhanga,Bihar',
'Branch Post Office,Darbhanga,Bihar',
'Branch Post Office,Darbhanga,Bihar',
'Branch Post Office,Darbhanga,Bihar',
'Branch Post Office,Darbhanga,Bihar',
'Branch Post Office,Darbhanga,Bihar',
'Branch Post Office,Darbhanga,Bihar',
'Sub Post Office,Darbhanga,Bihar',
'Branch Post Office,Darbhanga,Bihar',
'Branch Post Office,Darbhanga,Bihar',
'Branch Post Office,Darbhanga,Bihar',
'Sub Post Office,Darbhanga,Bihar',
'Head Post Office,Darbhanga,Bihar',
'Branch Post Office,Darbhanga,Bihar',
'Branch Post Office,Darbhanga,Bihar',
'Branch Post Office,Darbhanga,Bihar',
'Sub Post Office,Darbhanga,Bihar',
'Branch Post Office,Darbhanga,Bihar',
'Sub Post Office,Darbhanga,Bihar',
'Branch Post Office,Darbhanga,Bihar',
'Branch Post Office,Darbhanga,Bihar',
'Branch Post Office,Darbhanga,Bihar',
'Branch Post Office,Darbhanga,Bihar',
'Branch Post Office,Darbhanga,Bihar',
'Branch Post Office,Darbhanga,Bihar',
'Branch Post Office,Darbhanga,Bihar',
'Branch Post Office,Darbhanga,Bihar',
'Branch Post Office,Darbhanga,Bihar',
'Branch Post Office,Darbhanga,Bihar',
'Branch Post Office,Darbhanga,Bihar',
'Branch Post Office,Darbhanga,Bihar',
'Branch Post Office,Darbhanga,Bihar',
'Sub Post Office,Darbhanga,Bihar',
'Branch Post Office,Darbhanga,Bihar',
'Branch Post Office,Darbhanga,Bihar',
'Branch Post Office,Madhubani,Bihar',
'Branch Post Office,Darbhanga,Bihar',
'Branch Post Office,Darbhanga,Bihar',
'Branch Post Office,Darbhanga,Bihar',
'Branch Post Office,Darbhanga,Bihar',
'Branch Post Office,Darbhanga,Bihar',
'Branch Post Office,Darbhanga,Bihar',
'Branch Post Office,Darbhanga,Bihar',
'Branch Post Office,Darbhanga,Bihar',
'Branch Post Office,Darbhanga,Bihar',
'Branch Post Office,Darbhanga,Bihar',
'Branch Post Office,Darbhanga,Bihar',
'Branch Post Office,Darbhanga,Bihar',
'Branch Post Office,Darbhanga,Bihar',
'Branch Post Office,Darbhanga,Bihar',
'Branch Post Office,Darbhanga,Bihar',
'Branch Post Office,Darbhanga,Bihar',
'Branch Post Office,Darbhanga,Bihar',
'Branch Post Office,Darbhanga,Bihar',
'Branch Post Office,Darbhanga,Bihar',
'Sub Post Office,Darbhanga,Bihar',
'Branch Post Office,Darbhanga,Bihar',
'Sub Post Office,Darbhanga,Bihar',
'Sub Post Office,Darbhanga,Bihar',
'Branch Post Office,Darbhanga,Bihar',
'Branch Post Office,Darbhanga,Bihar',
'Branch Post Office,Darbhanga,Bihar',
'Branch Post Office,Darbhanga,Bihar',
'Branch Post Office,Darbhanga,Bihar',
'Sub Post Office,Darbhanga,Bihar',
'Branch Post Office,Darbhanga,Bihar',
'Branch Post Office,Darbhanga,Bihar',
'Branch Post Office,Darbhanga,Bihar',
'Branch Post Office,Darbhanga,Bihar',
'Branch Post Office,Darbhanga,Bihar',
'Branch Post Office,Darbhanga,Bihar',
'Sub Post Office,Darbhanga,Bihar',
'Branch Post Office,Darbhanga,Bihar',
'Sub Post Office,Darbhanga,Bihar',
'Branch Post Office,Darbhanga,Bihar',
'Branch Post Office,Darbhanga,Bihar',
'Branch Post Office,Darbhanga,Bihar',
'Branch Post Office,Darbhanga,Bihar',
'Branch Post Office,Darbhanga,Bihar',
'Branch Post Office,Madhubani,Bihar',
'Branch Post Office,Darbhanga,Bihar',
'Sub Post Office,Darbhanga,Bihar',
'Branch Post Office,Darbhanga,Bihar',
'Branch Post Office,Darbhanga,Bihar',
'Branch Post Office,Darbhanga,Bihar',
'Branch Post Office,Darbhanga,Bihar',
'Branch Post Office,Darbhanga,Bihar',
'Branch Post Office,Darbhanga,Bihar',
'Branch Post Office,Darbhanga,Bihar',
'Branch Post Office,Darbhanga,Bihar',
'Branch Post Office,Darbhanga,Bihar',
'Branch Post Office,Darbhanga,Bihar',
'Branch Post Office,Darbhanga,Bihar',
'Branch Post Office,Darbhanga,Bihar',
'Branch Post Office,Darbhanga,Bihar',
'Branch Post Office,Darbhanga,Bihar',
'Branch Post Office,Darbhanga,Bihar',
'Branch Post Office,Darbhanga,Bihar',
'Sub Post Office,Darbhanga,Bihar',
'Branch Post Office,Darbhanga,Bihar',
'Branch Post Office,Darbhanga,Bihar',
'Branch Post Office,Darbhanga,Bihar',
'Branch Post Office,Darbhanga,Bihar',
'Branch Post Office,Darbhanga,Bihar',
'Branch Post Office,Darbhanga,Bihar',
'Branch Post Office,Darbhanga,Bihar',
'Branch Post Office,Darbhanga,Bihar',
'Branch Post Office,Darbhanga,Bihar',
'Branch Post Office,Darbhanga,Bihar',
'Sub Post Office,Darbhanga,Bihar',
'Sub Post Office,Darbhanga,Bihar',
'Branch Post Office,Darbhanga,Bihar',
'Branch Post Office,Samastipur,Bihar',
'Branch Post Office,Samastipur,Bihar',
'Branch Post Office,Samastipur,Bihar',
'Branch Post Office,Samastipur,Bihar',
'Branch Post Office,Samastipur,Bihar',
'Branch Post Office,Samastipur,Bihar',
'Branch Post Office,Samastipur,Bihar',
'Branch Post Office,Samastipur,Bihar',
'Branch Post Office,Samastipur,Bihar',
'Branch Post Office,Samastipur,Bihar',
'Branch Post Office,Samastipur,Bihar',
'Branch Post Office,Samastipur,Bihar',
'Sub Post Office,Samastipur,Bihar',
'Branch Post Office,Samastipur,Bihar',
'Branch Post Office,Samastipur,Bihar',
'Branch Post Office,Samastipur,Bihar',
'Branch Post Office,Samastipur,Bihar',
'Branch Post Office,Samastipur,Bihar',
'Branch Post Office,Samastipur,Bihar',
'Branch Post Office,Samastipur,Bihar',
'Branch Post Office,Samastipur,Bihar',
'Branch Post Office,Samastipur,Bihar',
'Sub Post Office,East Champaran,Bihar',
'Branch Post Office,East Champaran,Bihar',
'Branch Post Office,East Champaran,Bihar',
'Branch Post Office,East Champaran,Bihar',
'Sub Post Office,East Champaran,Bihar',
'Branch Post Office,East Champaran,Bihar',
'Branch Post Office,East Champaran,Bihar',
'Branch Post Office,East Champaran,Bihar',
'Branch Post Office,East Champaran,Bihar',
'Branch Post Office,East Champaran,Bihar',
'Branch Post Office,East Champaran,Bihar',
'Branch Post Office,East Champaran,Bihar',
'Branch Post Office,East Champaran,Bihar',
'Branch Post Office,East Champaran,Bihar',
'Branch Post Office,East Champaran,Bihar',
'Branch Post Office,East Champaran,Bihar',
'Sub Post Office,East Champaran,Bihar',
'Branch Post Office,East Champaran,Bihar',
'Branch Post Office,East Champaran,Bihar',
'Branch Post Office,East Champaran,Bihar',
'Branch Post Office,East Champaran,Bihar',
'Branch Post Office,East Champaran,Bihar',
'Sub Post Office,East Champaran,Bihar',
'Branch Post Office,East Champaran,Bihar',
'Sub Post Office,East Champaran,Bihar',
'Branch Post Office,East Champaran,Bihar',
'Branch Post Office,East Champaran,Bihar',
'Branch Post Office,East Champaran,Bihar',
'Sub Post Office,East Champaran,Bihar',
'Branch Post Office,East Champaran,Bihar',
'Branch Post Office,East Champaran,Bihar',
'Branch Post Office,East Champaran,Bihar',
'Branch Post Office,East Champaran,Bihar',
'Branch Post Office,East Champaran,Bihar',
'Branch Post Office,East Champaran,Bihar',
'Branch Post Office,East Champaran,Bihar',
'Branch Post Office,East Champaran,Bihar',
'Branch Post Office,East Champaran,Bihar',
'Sub Post Office,East Champaran,Bihar',
'Branch Post Office,East Champaran,Bihar',
'Branch Post Office,East Champaran,Bihar',
'Branch Post Office,East Champaran,Bihar',
'Sub Post Office,East Champaran,Bihar',
'Branch Post Office,East Champaran,Bihar',
'Branch Post Office,East Champaran,Bihar',
'Branch Post Office,East Champaran,Bihar',
'Branch Post Office,East Champaran,Bihar',
'Branch Post Office,East Champaran,Bihar',
'Branch Post Office,East Champaran,Bihar',
'Branch Post Office,East Champaran,Bihar',
'Branch Post Office,East Champaran,Bihar',
'Branch Post Office,East Champaran,Bihar',
'Branch Post Office,East Champaran,Bihar',
'Branch Post Office,East Champaran,Bihar',
'Branch Post Office,East Champaran,Bihar',
'Branch Post Office,East Champaran,Bihar',
'Branch Post Office,East Champaran,Bihar',
'Branch Post Office,East Champaran,Bihar',
'Sub Post Office,East Champaran,Bihar',
'Branch Post Office,East Champaran,Bihar',
'Branch Post Office,East Champaran,Bihar',
'Branch Post Office,East Champaran,Bihar',
'Branch Post Office,East Champaran,Bihar',
'Branch Post Office,East Champaran,Bihar',
'Branch Post Office,East Champaran,Bihar',
'Branch Post Office,East Champaran,Bihar',
'Branch Post Office,East Champaran,Bihar',
'Branch Post Office,East Champaran,Bihar',
'Sub Post Office,East Champaran,Bihar',
'Branch Post Office,East Champaran,Bihar',
'Branch Post Office,East Champaran,Bihar',
'Branch Post Office,East Champaran,Bihar',
'Sub Post Office,East Champaran,Bihar',
'Branch Post Office,East Champaran,Bihar',
'Branch Post Office,East Champaran,Bihar',
'Branch Post Office,East Champaran,Bihar',
'Branch Post Office,East Champaran,Bihar',
'Sub Post Office,East Champaran,Bihar',
'Branch Post Office,East Champaran,Bihar',
'Branch Post Office,East Champaran,Bihar',
'Branch Post Office,East Champaran,Bihar',
'Branch Post Office,East Champaran,Bihar',
'Branch Post Office,East Champaran,Bihar',
'Branch Post Office,East Champaran,Bihar',
'Branch Post Office,East Champaran,Bihar',
'Branch Post Office,East Champaran,Bihar',
'Branch Post Office,East Champaran,Bihar',
'Branch Post Office,East Champaran,Bihar',
'Branch Post Office,East Champaran,Bihar',
'Branch Post Office,East Champaran,Bihar',
'Branch Post Office,East Champaran,Bihar',
'Branch Post Office,East Champaran,Bihar',
'Branch Post Office,East Champaran,Bihar',
'Branch Post Office,East Champaran,Bihar',
'Branch Post Office,East Champaran,Bihar',
'Branch Post Office,East Champaran,Bihar',
'Branch Post Office,East Champaran,Bihar',
'Branch Post Office,East Champaran,Bihar',
'Branch Post Office,East Champaran,Bihar',
'Branch Post Office,East Champaran,Bihar',
'Sub Post Office,East Champaran,Bihar',
'Branch Post Office,East Champaran,Bihar',
'Branch Post Office,East Champaran,Bihar',
'Branch Post Office,East Champaran,Bihar',
'Branch Post Office,East Champaran,Bihar',
'Branch Post Office,East Champaran,Bihar',
'Branch Post Office,East Champaran,Bihar',
'Branch Post Office,East Champaran,Bihar',
'Branch Post Office,East Champaran,Bihar',
'Sub Post Office,East Champaran,Bihar',
'Branch Post Office,East Champaran,Bihar',
'Branch Post Office,East Champaran,Bihar',
'Branch Post Office,East Champaran,Bihar',
'Branch Post Office,East Champaran,Bihar',
'Branch Post Office,East Champaran,Bihar',
'Branch Post Office,East Champaran,Bihar',
'Branch Post Office,East Champaran,Bihar',
'Branch Post Office,East Champaran,Bihar',
'Branch Post Office,East Champaran,Bihar',
'Branch Post Office,East Champaran,Bihar',
'Branch Post Office,East Champaran,Bihar',
'Branch Post Office,East Champaran,Bihar',
'Branch Post Office,East Champaran,Bihar',
'Branch Post Office,East Champaran,Bihar',
'Branch Post Office,East Champaran,Bihar',
'Branch Post Office,East Champaran,Bihar',
'Branch Post Office,East Champaran,Bihar',
'Branch Post Office,East Champaran,Bihar',
'Branch Post Office,East Champaran,Bihar',
'Branch Post Office,East Champaran,Bihar',
'Branch Post Office,East Champaran,Bihar',
'Branch Post Office,East Champaran,Bihar',
'Branch Post Office,East Champaran,Bihar',
'Branch Post Office,East Champaran,Bihar',
'Branch Post Office,East Champaran,Bihar',
'Branch Post Office,East Champaran,Bihar',
'Branch Post Office,East Champaran,Bihar',
'Branch Post Office,East Champaran,Bihar',
'Branch Post Office,East Champaran,Bihar',
'Branch Post Office,East Champaran,Bihar',
'Branch Post Office,East Champaran,Bihar',
'Branch Post Office,East Champaran,Bihar',
'Branch Post Office,East Champaran,Bihar',
'Branch Post Office,East Champaran,Bihar',
'Branch Post Office,East Champaran,Bihar',
'Sub Post Office,East Champaran,Bihar',
'Branch Post Office,East Champaran,Bihar',
'Branch Post Office,East Champaran,Bihar',
'Branch Post Office,East Champaran,Bihar',
'Branch Post Office,East Champaran,Bihar',
'Branch Post Office,East Champaran,Bihar',
'Sub Post Office,East Champaran,Bihar',
'Branch Post Office,East Champaran,Bihar',
'Branch Post Office,East Champaran,Bihar',
'Sub Post Office,East Champaran,Bihar',
'Branch Post Office,East Champaran,Bihar',
'Branch Post Office,East Champaran,Bihar',
'Branch Post Office,East Champaran,Bihar',
'Branch Post Office,East Champaran,Bihar',
'Branch Post Office,East Champaran,Bihar',
'Branch Post Office,East Champaran,Bihar',
'Branch Post Office,East Champaran,Bihar',
'Branch Post Office,East Champaran,Bihar',
'Branch Post Office,East Champaran,Bihar',
'Branch Post Office,East Champaran,Bihar',
'Branch Post Office,East Champaran,Bihar',
'Branch Post Office,East Champaran,Bihar',
'Branch Post Office,East Champaran,Bihar',
'Branch Post Office,East Champaran,Bihar',
'Branch Post Office,East Champaran,Bihar',
'Branch Post Office,East Champaran,Bihar',
'Branch Post Office,East Champaran,Bihar',
'Sub Post Office,East Champaran,Bihar',
'Branch Post Office,East Champaran,Bihar',
'Branch Post Office,East Champaran,Bihar',
'Branch Post Office,East Champaran,Bihar',
'Branch Post Office,East Champaran,Bihar',
'Branch Post Office,East Champaran,Bihar',
'Branch Post Office,East Champaran,Bihar',
'Branch Post Office,East Champaran,Bihar',
'Branch Post Office,East Champaran,Bihar',
'Branch Post Office,East Champaran,Bihar',
'Sub Post Office,East Champaran,Bihar',
'Branch Post Office,East Champaran,Bihar',
'Sub Post Office,East Champaran,Bihar',
'Branch Post Office,East Champaran,Bihar',
'Branch Post Office,East Champaran,Bihar',
'Branch Post Office,East Champaran,Bihar',
'Branch Post Office,East Champaran,Bihar',
'Branch Post Office,East Champaran,Bihar',
'Branch Post Office,East Champaran,Bihar',
'Branch Post Office,East Champaran,Bihar',
'Branch Post Office,East Champaran,Bihar',
'Branch Post Office,East Champaran,Bihar',
'Branch Post Office,East Champaran,Bihar',
'Branch Post Office,East Champaran,Bihar',
'Branch Post Office,East Champaran,Bihar',
'Branch Post Office,East Champaran,Bihar',
'Branch Post Office,East Champaran,Bihar',
'Branch Post Office,East Champaran,Bihar',
'Branch Post Office,East Champaran,Bihar',
'Branch Post Office,East Champaran,Bihar',
'Branch Post Office,East Champaran,Bihar',
'Branch Post Office,East Champaran,Bihar',
'Sub Post Office,East Champaran,Bihar',
'Branch Post Office,East Champaran,Bihar',
'Branch Post Office,East Champaran,Bihar',
'Branch Post Office,East Champaran,Bihar',
'Branch Post Office,East Champaran,Bihar',
'Branch Post Office,East Champaran,Bihar',
'Branch Post Office,East Champaran,Bihar',
'Branch Post Office,East Champaran,Bihar',
'Branch Post Office,East Champaran,Bihar',
'Sub Post Office,East Champaran,Bihar',
'Branch Post Office,East Champaran,Bihar',
'Branch Post Office,East Champaran,Bihar',
'Branch Post Office,East Champaran,Bihar',
'Branch Post Office,East Champaran,Bihar',
'Branch Post Office,East Champaran,Bihar',
'Branch Post Office,East Champaran,Bihar',
'Branch Post Office,East Champaran,Bihar',
'Branch Post Office,East Champaran,Bihar',
'Branch Post Office,East Champaran,Bihar',
'Branch Post Office,East Champaran,Bihar',
'Branch Post Office,East Champaran,Bihar',
'Branch Post Office,East Champaran,Bihar',
'Branch Post Office,East Champaran,Bihar',
'Branch Post Office,East Champaran,Bihar',
'Branch Post Office,East Champaran,Bihar',
'Branch Post Office,East Champaran,Bihar',
'Branch Post Office,East Champaran,Bihar',
'Branch Post Office,East Champaran,Bihar',
'Sub Post Office,East Champaran,Bihar',
'Branch Post Office,East Champaran,Bihar',
'Branch Post Office,East Champaran,Bihar',
'Branch Post Office,East Champaran,Bihar',
'Branch Post Office,East Champaran,Bihar',
'Branch Post Office,East Champaran,Bihar',
'Sub Post Office,East Champaran,Bihar',
'Sub Post Office,East Champaran,Bihar',
'Branch Post Office,East Champaran,Bihar',
'Branch Post Office,East Champaran,Bihar',
'Branch Post Office,East Champaran,Bihar',
'Branch Post Office,East Champaran,Bihar',
'Branch Post Office,East Champaran,Bihar',
'Branch Post Office,East Champaran,Bihar',
'Branch Post Office,East Champaran,Bihar',
'Branch Post Office,East Champaran,Bihar',
'Branch Post Office,East Champaran,Bihar',
'Branch Post Office,East Champaran,Bihar',
'Branch Post Office,East Champaran,Bihar',
'Branch Post Office,East Champaran,Bihar',
'Branch Post Office,East Champaran,Bihar',
'Branch Post Office,East Champaran,Bihar',
'Branch Post Office,East Champaran,Bihar',
'Branch Post Office,East Champaran,Bihar',
'Branch Post Office,East Champaran,Bihar',
'Branch Post Office,East Champaran,Bihar',
'Branch Post Office,East Champaran,Bihar',
'Branch Post Office,East Champaran,Bihar',
'Branch Post Office,East Champaran,Bihar',
'Branch Post Office,East Champaran,Bihar',
'Branch Post Office,East Champaran,Bihar',
'Sub Post Office,East Champaran,Bihar',
'Branch Post Office,East Champaran,Bihar',
'Branch Post Office,East Champaran,Bihar',
'Branch Post Office,East Champaran,Bihar',
'Branch Post Office,East Champaran,Bihar',
'Branch Post Office,East Champaran,Bihar',
'Branch Post Office,East Champaran,Bihar',
'Sub Post Office,East Champaran,Bihar',
'Sub Post Office,East Champaran,Bihar',
'Sub Post Office,East Champaran,Bihar',
'Sub Post Office,East Champaran,Bihar',
'Head Post Office,East Champaran,Bihar',
'Branch Post Office,East Champaran,Bihar',
'Branch Post Office,East Champaran,Bihar',
'Branch Post Office,East Champaran,Bihar',
'Branch Post Office,East Champaran,Bihar',
'Branch Post Office,East Champaran,Bihar',
'Branch Post Office,East Champaran,Bihar',
'Branch Post Office,East Champaran,Bihar',
'Sub Post Office,East Champaran,Bihar',
'Branch Post Office,East Champaran,Bihar',
'Branch Post Office,East Champaran,Bihar',
'Branch Post Office,East Champaran,Bihar',
'Branch Post Office,East Champaran,Bihar',
'Branch Post Office,East Champaran,Bihar',
'Branch Post Office,East Champaran,Bihar',
'Branch Post Office,East Champaran,Bihar',
'Branch Post Office,East Champaran,Bihar',
'Sub Post Office,East Champaran,Bihar',
'Branch Post Office,East Champaran,Bihar',
'Branch Post Office,East Champaran,Bihar',
'Branch Post Office,East Champaran,Bihar',
'Branch Post Office,East Champaran,Bihar',
'Branch Post Office,East Champaran,Bihar',
'Branch Post Office,East Champaran,Bihar',
'Branch Post Office,East Champaran,Bihar',
'Branch Post Office,East Champaran,Bihar',
'Branch Post Office,East Champaran,Bihar',
'Sub Post Office,East Champaran,Bihar',
'Branch Post Office,East Champaran,Bihar',
'Branch Post Office,East Champaran,Bihar',
'Branch Post Office,East Champaran,Bihar',
'Branch Post Office,East Champaran,Bihar',
'Sub Post Office,East Champaran,Bihar',
'Branch Post Office,East Champaran,Bihar',
'Branch Post Office,East Champaran,Bihar',
'Sub Post Office,East Champaran,Bihar',
'Branch Post Office,East Champaran,Bihar',
'Branch Post Office,East Champaran,Bihar',
'Branch Post Office,East Champaran,Bihar',
'Branch Post Office,East Champaran,Bihar',
'Branch Post Office,East Champaran,Bihar',
'Branch Post Office,East Champaran,Bihar',
'Branch Post Office,East Champaran,Bihar',
'Branch Post Office,East Champaran,Bihar',
'Branch Post Office,East Champaran,Bihar',
'Branch Post Office,East Champaran,Bihar',
'Branch Post Office,East Champaran,Bihar',
'Sub Post Office,East Champaran,Bihar',
'Branch Post Office,East Champaran,Bihar',
'Branch Post Office,East Champaran,Bihar',
'Branch Post Office,East Champaran,Bihar',
'Branch Post Office,East Champaran,Bihar',
'Branch Post Office,East Champaran,Bihar',
'Branch Post Office,East Champaran,Bihar',
'Branch Post Office,East Champaran,Bihar',
'Branch Post Office,East Champaran,Bihar',
'Branch Post Office,East Champaran,Bihar',
'Branch Post Office,East Champaran,Bihar',
'Sub Post Office,East Champaran,Bihar',
'Branch Post Office,East Champaran,Bihar',
'Branch Post Office,East Champaran,Bihar',
'Branch Post Office,East Champaran,Bihar',
'Branch Post Office,East Champaran,Bihar',
'Branch Post Office,East Champaran,Bihar',
'Branch Post Office,East Champaran,Bihar',
'Branch Post Office,East Champaran,Bihar',
'Sub Post Office,East Champaran,Bihar',
'Branch Post Office,East Champaran,Bihar',
'Branch Post Office,East Champaran,Bihar',
'Branch Post Office,East Champaran,Bihar',
'Branch Post Office,East Champaran,Bihar',
'Branch Post Office,East Champaran,Bihar',
'Branch Post Office,East Champaran,Bihar',
'Branch Post Office,East Champaran,Bihar',
'Branch Post Office,East Champaran,Bihar',
'Sub Post Office,East Champaran,Bihar',
'Branch Post Office,East Champaran,Bihar',
'Sub Post Office,East Champaran,Bihar',
'Sub Post Office,East Champaran,Bihar',
'Branch Post Office,East Champaran,Bihar',
'Branch Post Office,East Champaran,Bihar',
'Branch Post Office,East Champaran,Bihar',
'Branch Post Office,East Champaran,Bihar',
'Branch Post Office,East Champaran,Bihar',
'Branch Post Office,East Champaran,Bihar',
'Branch Post Office,East Champaran,Bihar',
'Branch Post Office,East Champaran,Bihar',
'Branch Post Office,East Champaran,Bihar',
'Branch Post Office,East Champaran,Bihar',
'Branch Post Office,East Champaran,Bihar',
'Branch Post Office,East Champaran,Bihar',
'Branch Post Office,East Champaran,Bihar',
'Branch Post Office,East Champaran,Bihar',
'Branch Post Office,East Champaran,Bihar',
'Branch Post Office,East Champaran,Bihar',
'Branch Post Office,East Champaran,Bihar',
'Branch Post Office,East Champaran,Bihar',
'Branch Post Office,East Champaran,Bihar',
'Branch Post Office,East Champaran,Bihar',
'Branch Post Office,East Champaran,Bihar',
'Branch Post Office,East Champaran,Bihar',
'Branch Post Office,East Champaran,Bihar',
'Branch Post Office,East Champaran,Bihar',
'Branch Post Office,East Champaran,Bihar',
'Branch Post Office,East Champaran,Bihar',
'Branch Post Office,East Champaran,Bihar',
'Branch Post Office,East Champaran,Bihar',
'Branch Post Office,East Champaran,Bihar',
'Branch Post Office,East Champaran,Bihar',
'Branch Post Office,East Champaran,Bihar',
'Branch Post Office,East Champaran,Bihar',
'Branch Post Office,East Champaran,Bihar',
'Branch Post Office,East Champaran,Bihar',
'Branch Post Office,East Champaran,Bihar',
'Branch Post Office,East Champaran,Bihar',
'Branch Post Office,East Champaran,Bihar',
'Branch Post Office,East Champaran,Bihar',
'Branch Post Office,East Champaran,Bihar',
'Branch Post Office,East Champaran,Bihar',
'Branch Post Office,East Champaran,Bihar',
'Branch Post Office,East Champaran,Bihar',
'Branch Post Office,East Champaran,Bihar',
'Branch Post Office,East Champaran,Bihar',
'Branch Post Office,East Champaran,Bihar',
'Sub Post Office,East Champaran,Bihar',
'Sub Post Office,East Champaran,Bihar',
'Sub Post Office,East Champaran,Bihar',
'Branch Post Office,East Champaran,Bihar',
'Branch Post Office,East Champaran,Bihar',
'Branch Post Office,East Champaran,Bihar',
'Branch Post Office,East Champaran,Bihar',
'Branch Post Office,East Champaran,Bihar',
'Branch Post Office,East Champaran,Bihar',
'Branch Post Office,East Champaran,Bihar',
'Branch Post Office,East Champaran,Bihar',
'Branch Post Office,East Champaran,Bihar',
'Branch Post Office,East Champaran,Bihar',
'Branch Post Office,East Champaran,Bihar',
'Branch Post Office,East Champaran,Bihar',
'Branch Post Office,East Champaran,Bihar',
'Branch Post Office,East Champaran,Bihar',
'Branch Post Office,East Champaran,Bihar',
'Branch Post Office,East Champaran,Bihar',
'Sub Post Office,East Champaran,Bihar',
'Branch Post Office,East Champaran,Bihar',
'Branch Post Office,Nawadha,Bihar',
'Branch Post Office,Nawadha,Bihar',
'Branch Post Office,Nawadha,Bihar',
'Branch Post Office,Nawadha,Bihar',
'Branch Post Office,Nawadha,Bihar',
'Branch Post Office,Nawadha,Bihar',
'Branch Post Office,Nawadha,Bihar',
'Branch Post Office,Nawadha,Bihar',
'Branch Post Office,Nawadha,Bihar',
'Branch Post Office,Nawadha,Bihar',
'Branch Post Office,Nawadha,Bihar',
'Branch Post Office,Nawadha,Bihar',
'Branch Post Office,Nawadha,Bihar',
'Branch Post Office,Nawadha,Bihar',
'Branch Post Office,Nawadha,Bihar',
'Branch Post Office,Nawadha,Bihar',
'Branch Post Office,Nawadha,Bihar',
'Branch Post Office,Nawadha,Bihar',
'Branch Post Office,Nawadha,Bihar',
'Branch Post Office,Nawadha,Bihar',
'Branch Post Office,Nawadha,Bihar',
'Branch Post Office,Nawadha,Bihar',
'Branch Post Office,Nawadha,Bihar',
'Branch Post Office,Nawadha,Bihar',
'Branch Post Office,Nawadha,Bihar',
'Branch Post Office,Nawadha,Bihar',
'Branch Post Office,Nawadha,Bihar',
'Branch Post Office,Nawadha,Bihar',
'Branch Post Office,Nawadha,Bihar',
'Branch Post Office,Nawadha,Bihar',
'Branch Post Office,Nawadha,Bihar',
'Branch Post Office,Nawadha,Bihar',
'Sub Post Office,Nawadha,Bihar',
'Sub Post Office,Nawadha,Bihar',
'Sub Post Office,Gaya,Bihar',
'Branch Post Office,Gaya,Bihar',
'Branch Post Office,Gaya,Bihar',
'Branch Post Office,Gaya,Bihar',
'Branch Post Office,Gaya,Bihar',
'Branch Post Office,Gaya,Bihar',
'Branch Post Office,Gaya,Bihar',
'Branch Post Office,Gaya,Bihar',
'Branch Post Office,Gaya,Bihar',
'Branch Post Office,Gaya,Bihar',
'Branch Post Office,Gaya,Bihar',
'Branch Post Office,Gaya,Bihar',
'Branch Post Office,Gaya,Bihar',
'Branch Post Office,Gaya,Bihar',
'Branch Post Office,Gaya,Bihar',
'Branch Post Office,Gaya,Bihar',
'Branch Post Office,Gaya,Bihar',
'Branch Post Office,Gaya,Bihar',
'Sub Post Office,Aurangabad(Bihar),Bihar',
'Branch Post Office,Aurangabad(Bihar),Bihar',
'Branch Post Office,Aurangabad(Bihar),Bihar',
'Branch Post Office,Aurangabad(Bihar),Bihar',
'Branch Post Office,Aurangabad(Bihar),Bihar',
'Branch Post Office,Aurangabad(Bihar),Bihar',
'Branch Post Office,Aurangabad(Bihar),Bihar',
'Branch Post Office,Aurangabad(Bihar),Bihar',
'Branch Post Office,Aurangabad(Bihar),Bihar',
'Branch Post Office,Aurangabad(Bihar),Bihar',
'Branch Post Office,Aurangabad(Bihar),Bihar',
'Branch Post Office,Aurangabad(Bihar),Bihar',
'Branch Post Office,Aurangabad(Bihar),Bihar',
'Branch Post Office,Aurangabad(Bihar),Bihar',
'Branch Post Office,Aurangabad(Bihar),Bihar',
'Branch Post Office,Aurangabad(Bihar),Bihar',
'Branch Post Office,Aurangabad(Bihar),Bihar',
'Branch Post Office,Aurangabad(Bihar),Bihar',
'Branch Post Office,Aurangabad(Bihar),Bihar',
'Branch Post Office,Aurangabad(Bihar),Bihar',
'Branch Post Office,Aurangabad(Bihar),Bihar',
'Branch Post Office,Aurangabad(Bihar),Bihar',
'Branch Post Office,Aurangabad(Bihar),Bihar',
'Branch Post Office,Aurangabad(Bihar),Bihar',
'Branch Post Office,Aurangabad(Bihar),Bihar',
'Branch Post Office,Aurangabad(Bihar),Bihar',
'Branch Post Office,Aurangabad(Bihar),Bihar',
'Branch Post Office,Aurangabad(Bihar),Bihar',
'Branch Post Office,Aurangabad(Bihar),Bihar',
'Branch Post Office,Aurangabad(Bihar),Bihar',
'Branch Post Office,Aurangabad(Bihar),Bihar',
'Branch Post Office,Aurangabad(Bihar),Bihar',
'Branch Post Office,Aurangabad(Bihar),Bihar',
'Branch Post Office,Aurangabad(Bihar),Bihar',
'Branch Post Office,Gaya,Bihar',
'Branch Post Office,Gaya,Bihar',
'Sub Post Office,Gaya,Bihar',
'Branch Post Office,Gaya,Bihar',
'Branch Post Office,Gaya,Bihar',
'Branch Post Office,Gaya,Bihar',
'Branch Post Office,Gaya,Bihar',
'Branch Post Office,Gaya,Bihar',
'Branch Post Office,Gaya,Bihar',
'Branch Post Office,Gaya,Bihar',
'Branch Post Office,Gaya,Bihar',
'Branch Post Office,Gaya,Bihar',
'Branch Post Office,Gaya,Bihar',
'Branch Post Office,Gaya,Bihar',
'Branch Post Office,Gaya,Bihar',
'Branch Post Office,Gaya,Bihar',
'Branch Post Office,Gaya,Bihar',
'Branch Post Office,Gaya,Bihar',
'Branch Post Office,Gaya,Bihar',
'Branch Post Office,Gaya,Bihar',
'Branch Post Office,Gaya,Bihar',
'Branch Post Office,Gaya,Bihar',
'Branch Post Office,Gaya,Bihar',
'Branch Post Office,Gaya,Bihar',
'Sub Post Office,Gaya,Bihar',
'Branch Post Office,Gaya,Bihar',
'Branch Post Office,Gaya,Bihar',
'Branch Post Office,Gaya,Bihar',
'Sub Post Office,Gaya,Bihar',
'Branch Post Office,Gaya,Bihar',
'Branch Post Office,Gaya,Bihar',
'Sub Post Office,Aurangabad(Bihar),Bihar',
'Branch Post Office,Gaya,Bihar',
'Branch Post Office,Gaya,Bihar',
'Branch Post Office,Gaya,Bihar',
'Branch Post Office,Gaya,Bihar',
'Branch Post Office,Gaya,Bihar',
'Branch Post Office,Gaya,Bihar',
'Branch Post Office,Gaya,Bihar',
'Branch Post Office,Gaya,Bihar',
'Branch Post Office,Gaya,Bihar',
'Branch Post Office,Gaya,Bihar',
'Branch Post Office,Gaya,Bihar',
'Branch Post Office,Gaya,Bihar',
'Branch Post Office,Gaya,Bihar',
'Branch Post Office,Gaya,Bihar',
'Branch Post Office,Gaya,Bihar',
'Branch Post Office,Gaya,Bihar',
'Branch Post Office,Gaya,Bihar',
'Branch Post Office,Gaya,Bihar',
'Branch Post Office,Gaya,Bihar',
'Branch Post Office,Gaya,Bihar',
'Branch Post Office,Gaya,Bihar',
'Sub Post Office,Gaya,Bihar',
'Branch Post Office,Gaya,Bihar',
'Branch Post Office,Gaya,Bihar',
'Branch Post Office,Gaya,Bihar',
'Branch Post Office,Gaya,Bihar',
'Branch Post Office,Gaya,Bihar',
'Branch Post Office,Gaya,Bihar',
'Branch Post Office,Gaya,Bihar',
'Branch Post Office,Gaya,Bihar',
'Branch Post Office,Gaya,Bihar',
'Branch Post Office,Gaya,Bihar',
'Branch Post Office,Gaya,Bihar',
'Branch Post Office,Gaya,Bihar',
'Branch Post Office,Gaya,Bihar',
'Branch Post Office,Gaya,Bihar',
'Branch Post Office,Gaya,Bihar',
'Sub Post Office,Gaya,Bihar',
'Sub Post Office,Gaya,Bihar',
'Sub Post Office,Gaya,Bihar',
'Sub Post Office,Gaya,Bihar',
'Sub Post Office,Gaya,Bihar',
'Sub Post Office,Gaya,Bihar',
'Head Post Office,Gaya,Bihar',
'Sub Post Office,Gaya,Bihar',
'Sub Post Office,Gaya,Bihar',
'Sub Post Office,Gaya,Bihar',
'Sub Post Office,Gaya,Bihar',
'Branch Post Office,Gaya,Bihar',
'Sub Post Office,Gaya,Bihar',
'Branch Post Office,Gaya,Bihar',
'Branch Post Office,Aurangabad(Bihar),Bihar',
'Branch Post Office,Aurangabad(Bihar),Bihar',
'Branch Post Office,Aurangabad(Bihar),Bihar',
'Branch Post Office,Aurangabad(Bihar),Bihar',
'Sub Post Office,Aurangabad(Bihar),Bihar',
'Branch Post Office,Aurangabad(Bihar),Bihar',
'Branch Post Office,Aurangabad(Bihar),Bihar',
'Branch Post Office,Aurangabad(Bihar),Bihar',
'Branch Post Office,Aurangabad(Bihar),Bihar',
'Branch Post Office,Aurangabad(Bihar),Bihar',
'Branch Post Office,Aurangabad(Bihar),Bihar',
'Branch Post Office,Gaya,Bihar',
'Branch Post Office,Gaya,Bihar',
'Branch Post Office,Aurangabad(Bihar),Bihar',
'Branch Post Office,Aurangabad(Bihar),Bihar',
'Branch Post Office,Aurangabad(Bihar),Bihar',
'Branch Post Office,Aurangabad(Bihar),Bihar',
'Branch Post Office,Aurangabad(Bihar),Bihar',
'Branch Post Office,Aurangabad(Bihar),Bihar',
'Branch Post Office,Aurangabad(Bihar),Bihar',
'Branch Post Office,Aurangabad(Bihar),Bihar',
'Branch Post Office,Aurangabad(Bihar),Bihar',
'Sub Post Office,Aurangabad(Bihar),Bihar',
'Sub Post Office,Gaya,Bihar',
'Branch Post Office,Gaya,Bihar',
'Branch Post Office,Gaya,Bihar',
'Branch Post Office,Gaya,Bihar',
'Branch Post Office,Gaya,Bihar',
'Branch Post Office,Gaya,Bihar',
'Branch Post Office,Gaya,Bihar',
'Branch Post Office,Gaya,Bihar',
'Branch Post Office,Gaya,Bihar',
'Branch Post Office,Gaya,Bihar',
'Branch Post Office,Gaya,Bihar',
'Branch Post Office,Gaya,Bihar',
'Branch Post Office,Gaya,Bihar',
'Branch Post Office,Gaya,Bihar',
'Branch Post Office,Gaya,Bihar',
'Sub Post Office,Gaya,Bihar',
'Branch Post Office,Aurangabad(Bihar),Bihar',
'Branch Post Office,Aurangabad(Bihar),Bihar',
'Branch Post Office,Aurangabad(Bihar),Bihar',
'Branch Post Office,Gaya,Bihar',
'Branch Post Office,Aurangabad(Bihar),Bihar',
'Branch Post Office,Aurangabad(Bihar),Bihar',
'Branch Post Office,Gaya,Bihar',
'Branch Post Office,Aurangabad(Bihar),Bihar',
'Branch Post Office,Aurangabad(Bihar),Bihar',
'Branch Post Office,Aurangabad(Bihar),Bihar',
'Branch Post Office,Aurangabad(Bihar),Bihar',
'Branch Post Office,Gaya,Bihar',
'Branch Post Office,Aurangabad(Bihar),Bihar',
'Sub Post Office,Aurangabad(Bihar),Bihar',
'Branch Post Office,Gaya,Bihar',
'Branch Post Office,Gaya,Bihar',
'Branch Post Office,Aurangabad(Bihar),Bihar',
'Branch Post Office,Gaya,Bihar',
'Branch Post Office,Gaya,Bihar',
'Branch Post Office,Aurangabad(Bihar),Bihar',
'Branch Post Office,Aurangabad(Bihar),Bihar',
'Branch Post Office,Aurangabad(Bihar),Bihar',
'Branch Post Office,Gaya,Bihar',
'Branch Post Office,Aurangabad(Bihar),Bihar',
'Branch Post Office,Gaya,Bihar',
'Branch Post Office,Gaya,Bihar',
'Branch Post Office,Gaya,Bihar',
'Branch Post Office,Gaya,Bihar',
'Branch Post Office,Gaya,Bihar',
'Branch Post Office,Gaya,Bihar',
'Branch Post Office,Gaya,Bihar',
'Branch Post Office,Gaya,Bihar',
'Sub Post Office,Gaya,Bihar',
'Branch Post Office,Gaya,Bihar',
'Branch Post Office,Gaya,Bihar',
'Sub Post Office,Gaya,Bihar',
'Branch Post Office,Gaya,Bihar',
'Branch Post Office,Gaya,Bihar',
'Branch Post Office,Gaya,Bihar',
'Branch Post Office,Gaya,Bihar',
'Branch Post Office,Gaya,Bihar',
'Branch Post Office,Gaya,Bihar',
'Branch Post Office,Gaya,Bihar',
'Branch Post Office,Gaya,Bihar',
'Branch Post Office,Gaya,Bihar',
'Branch Post Office,Gaya,Bihar',
'Branch Post Office,Gaya,Bihar',
'Branch Post Office,Gaya,Bihar',
'Branch Post Office,Gaya,Bihar',
'Branch Post Office,Gaya,Bihar',
'Branch Post Office,Gaya,Bihar',
'Branch Post Office,Gaya,Bihar',
'Branch Post Office,Gaya,Bihar',
'Branch Post Office,Gaya,Bihar',
'Branch Post Office,Gaya,Bihar',
'Branch Post Office,Gaya,Bihar',
'Sub Post Office,Gaya,Bihar',
'Branch Post Office,Gaya,Bihar',
'Branch Post Office,Gaya,Bihar',
'Branch Post Office,Gaya,Bihar',
'Branch Post Office,Gaya,Bihar',
'Branch Post Office,Gaya,Bihar',
'Branch Post Office,Aurangabad(Bihar),Bihar',
'Branch Post Office,Aurangabad(Bihar),Bihar',
'Branch Post Office,Aurangabad(Bihar),Bihar',
'Branch Post Office,Aurangabad(Bihar),Bihar',
'Sub Post Office,Aurangabad(Bihar),Bihar',
'Branch Post Office,Aurangabad(Bihar),Bihar',
'Branch Post Office,Aurangabad(Bihar),Bihar',
'Branch Post Office,Aurangabad(Bihar),Bihar',
'Branch Post Office,Aurangabad(Bihar),Bihar',
'Branch Post Office,Aurangabad(Bihar),Bihar',
'Branch Post Office,Aurangabad(Bihar),Bihar',
'Branch Post Office,Aurangabad(Bihar),Bihar',
'Branch Post Office,Aurangabad(Bihar),Bihar',
'Branch Post Office,Aurangabad(Bihar),Bihar',
'Branch Post Office,Gaya,Bihar',
'Sub Post Office,Gaya,Bihar',
'Branch Post Office,Aurangabad(Bihar),Bihar',
'Branch Post Office,Gaya,Bihar',
'Sub Post Office,Aurangabad(Bihar),Bihar',
'Branch Post Office,Aurangabad(Bihar),Bihar',
'Branch Post Office,Aurangabad(Bihar),Bihar',
'Sub Post Office,Aurangabad(Bihar),Bihar',
'Branch Post Office,Aurangabad(Bihar),Bihar',
'Branch Post Office,Aurangabad(Bihar),Bihar',
'Branch Post Office,Gaya,Bihar',
'Branch Post Office,Gaya,Bihar',
'Branch Post Office,Gaya,Bihar',
'Branch Post Office,Gaya,Bihar',
'Branch Post Office,Gaya,Bihar',
'Branch Post Office,Gaya,Bihar',
'Branch Post Office,Gaya,Bihar',
'Branch Post Office,Gaya,Bihar',
'Branch Post Office,Gaya,Bihar',
'Branch Post Office,Gaya,Bihar',
'Branch Post Office,Gaya,Bihar',
'Branch Post Office,Gaya,Bihar',
'Branch Post Office,Gaya,Bihar',
'Branch Post Office,Gaya,Bihar',
'Branch Post Office,Gaya,Bihar',
'Branch Post Office,Gaya,Bihar',
'Branch Post Office,Gaya,Bihar',
'Branch Post Office,Gaya,Bihar',
'Sub Post Office,Gaya,Bihar',
'Branch Post Office,Gaya,Bihar',
'Branch Post Office,Gaya,Bihar',
'Branch Post Office,Gaya,Bihar',
'Branch Post Office,Gaya,Bihar',
'Branch Post Office,Gaya,Bihar',
'Branch Post Office,Gaya,Bihar',
'Branch Post Office,Gaya,Bihar',
'Branch Post Office,Gaya,Bihar',
'Sub Post Office,Gaya,Bihar',
'Branch Post Office,Gaya,Bihar',
'Sub Post Office,Gaya,Bihar',
'Branch Post Office,Gaya,Bihar',
'Branch Post Office,Gaya,Bihar',
'Branch Post Office,Gaya,Bihar',
'Branch Post Office,Gaya,Bihar',
'Sub Post Office,Gaya,Bihar',
'Sub Post Office,Gaya,Bihar',
'Sub Post Office,Gaya,Bihar',
'Branch Post Office,Gaya,Bihar',
'Sub Post Office,Gaya,Bihar',
'Branch Post Office,Gaya,Bihar',
'Sub Post Office,Gaya,Bihar',
'Branch Post Office,Gaya,Bihar',
'Branch Post Office,Gaya,Bihar',
'Branch Post Office,Gaya,Bihar',
'Sub Post Office,Gaya,Bihar',
'Sub Post Office,Gaya,Bihar',
'Branch Post Office,Gaya,Bihar',
'Branch Post Office,Gaya,Bihar',
'Branch Post Office,Gaya,Bihar',
'Sub Post Office,Gaya,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Sub Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Sub Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Sub Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Sub Post Office,Siwan,Bihar',
'Sub Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Sub Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Sub Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Sub Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Sub Post Office,Siwan,Bihar',
'Head Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Sub Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Sub Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Sub Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Sub Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Sub Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Sub Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Sub Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Sub Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Sub Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Sub Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Monghyr,Bihar',
'Branch Post Office,Monghyr,Bihar',
'Branch Post Office,Nawadha,Bihar',
'Branch Post Office,Nawadha,Bihar',
'Branch Post Office,Nawadha,Bihar',
'Branch Post Office,Nawadha,Bihar',
'Sub Post Office,Monghyr,Bihar',
'Branch Post Office,Monghyr,Bihar',
'Branch Post Office,Monghyr,Bihar',
'Branch Post Office,Monghyr,Bihar',
'Branch Post Office,Monghyr,Bihar',
'Branch Post Office,Monghyr,Bihar',
'Branch Post Office,Monghyr,Bihar',
'Branch Post Office,Monghyr,Bihar',
'Branch Post Office,Monghyr,Bihar',
'Branch Post Office,Monghyr,Bihar',
'Branch Post Office,Monghyr,Bihar',
'Branch Post Office,Monghyr,Bihar',
'Sub Post Office,Monghyr,Bihar',
'Branch Post Office,Monghyr,Bihar',
'Branch Post Office,Monghyr,Bihar',
'Branch Post Office,Monghyr,Bihar',
'Branch Post Office,Monghyr,Bihar',
'Branch Post Office,Monghyr,Bihar',
'Branch Post Office,Monghyr,Bihar',
'Branch Post Office,Monghyr,Bihar',
'Branch Post Office,Monghyr,Bihar',
'Branch Post Office,Monghyr,Bihar',
'Branch Post Office,Monghyr,Bihar',
'Branch Post Office,Monghyr,Bihar',
'Branch Post Office,Monghyr,Bihar',
'Branch Post Office,Monghyr,Bihar',
'Branch Post Office,Monghyr,Bihar',
'Branch Post Office,Monghyr,Bihar',
'Sub Post Office,Monghyr,Bihar',
'Branch Post Office,Monghyr,Bihar',
'Branch Post Office,Monghyr,Bihar',
'Branch Post Office,Monghyr,Bihar',
'Branch Post Office,Monghyr,Bihar',
'Branch Post Office,Monghyr,Bihar',
'Branch Post Office,Monghyr,Bihar',
'Branch Post Office,Monghyr,Bihar',
'Branch Post Office,Monghyr,Bihar',
'Branch Post Office,Monghyr,Bihar',
'Branch Post Office,Monghyr,Bihar',
'Branch Post Office,Monghyr,Bihar',
'Branch Post Office,Monghyr,Bihar',
'Branch Post Office,Monghyr,Bihar',
'Branch Post Office,Monghyr,Bihar',
'Branch Post Office,Monghyr,Bihar',
'Branch Post Office,Monghyr,Bihar',
'Branch Post Office,Monghyr,Bihar',
'Branch Post Office,Monghyr,Bihar',
'Branch Post Office,Monghyr,Bihar',
'Branch Post Office,Monghyr,Bihar',
'Branch Post Office,Monghyr,Bihar',
'Branch Post Office,Monghyr,Bihar',
'Branch Post Office,Monghyr,Bihar',
'Branch Post Office,Monghyr,Bihar',
'Branch Post Office,Monghyr,Bihar',
'Branch Post Office,Monghyr,Bihar',
'Branch Post Office,Monghyr,Bihar',
'Branch Post Office,Monghyr,Bihar',
'Branch Post Office,Monghyr,Bihar',
'Branch Post Office,Monghyr,Bihar',
'Sub Post Office,Monghyr,Bihar',
'Head Post Office,Monghyr,Bihar',
'Branch Post Office,Monghyr,Bihar',
'Branch Post Office,Monghyr,Bihar',
'Branch Post Office,Monghyr,Bihar',
'Branch Post Office,Monghyr,Bihar',
'Branch Post Office,Monghyr,Bihar',
'Branch Post Office,Monghyr,Bihar',
'Branch Post Office,Monghyr,Bihar',
'Branch Post Office,Monghyr,Bihar',
'Branch Post Office,Monghyr,Bihar',
'Branch Post Office,Monghyr,Bihar',
'Branch Post Office,Monghyr,Bihar',
'Branch Post Office,Monghyr,Bihar',
'Branch Post Office,Monghyr,Bihar',
'Branch Post Office,Monghyr,Bihar',
'Sub Post Office,Monghyr,Bihar',
'Sub Post Office,Monghyr,Bihar',
'Branch Post Office,Monghyr,Bihar',
'Branch Post Office,Monghyr,Bihar',
'Branch Post Office,Monghyr,Bihar',
'Branch Post Office,Monghyr,Bihar',
'Branch Post Office,Monghyr,Bihar',
'Branch Post Office,Monghyr,Bihar',
'Branch Post Office,Monghyr,Bihar',
'Sub Post Office,Monghyr,Bihar',
'Branch Post Office,Monghyr,Bihar',
'Branch Post Office,Monghyr,Bihar',
'Branch Post Office,Monghyr,Bihar',
'Branch Post Office,Monghyr,Bihar',
'Branch Post Office,Monghyr,Bihar',
'Branch Post Office,Monghyr,Bihar',
'Branch Post Office,Monghyr,Bihar',
'Branch Post Office,Monghyr,Bihar',
'Branch Post Office,Monghyr,Bihar',
'Branch Post Office,Monghyr,Bihar',
'Branch Post Office,Monghyr,Bihar',
'Branch Post Office,Monghyr,Bihar',
'Branch Post Office,Monghyr,Bihar',
'Branch Post Office,Monghyr,Bihar',
'Sub Post Office,Monghyr,Bihar',
'Branch Post Office,Monghyr,Bihar',
'Branch Post Office,Monghyr,Bihar',
'Branch Post Office,Monghyr,Bihar',
'Branch Post Office,Monghyr,Bihar',
'Branch Post Office,Monghyr,Bihar',
'Branch Post Office,Monghyr,Bihar',
'Branch Post Office,Monghyr,Bihar',
'Branch Post Office,Monghyr,Bihar',
'Branch Post Office,Monghyr,Bihar',
'Branch Post Office,Monghyr,Bihar',
'Branch Post Office,Monghyr,Bihar',
'Branch Post Office,Monghyr,Bihar',
'Branch Post Office,Monghyr,Bihar',
'Branch Post Office,Monghyr,Bihar',
'Branch Post Office,Monghyr,Bihar',
'Branch Post Office,Monghyr,Bihar',
'Branch Post Office,Monghyr,Bihar',
'Sub Post Office,Monghyr,Bihar',
'Sub Post Office,Samastipur,Bihar',
'Branch Post Office,Samastipur,Bihar',
'Branch Post Office,Samastipur,Bihar',
'Branch Post Office,Samastipur,Bihar',
'Branch Post Office,Samastipur,Bihar',
'Branch Post Office,Samastipur,Bihar',
'Branch Post Office,Samastipur,Bihar',
'Branch Post Office,Samastipur,Bihar',
'Branch Post Office,Samastipur,Bihar',
'Branch Post Office,Samastipur,Bihar',
'Branch Post Office,Samastipur,Bihar',
'Sub Post Office,Samastipur,Bihar',
'Branch Post Office,Samastipur,Bihar',
'Branch Post Office,Samastipur,Bihar',
'Branch Post Office,Samastipur,Bihar',
'Branch Post Office,Samastipur,Bihar',
'Branch Post Office,Samastipur,Bihar',
'Branch Post Office,Samastipur,Bihar',
'Sub Post Office,Samastipur,Bihar',
'Branch Post Office,Samastipur,Bihar',
'Branch Post Office,Samastipur,Bihar',
'Branch Post Office,Samastipur,Bihar',
'Branch Post Office,Samastipur,Bihar',
'Branch Post Office,Samastipur,Bihar',
'Branch Post Office,Samastipur,Bihar',
'Branch Post Office,Samastipur,Bihar',
'Branch Post Office,Samastipur,Bihar',
'Branch Post Office,Samastipur,Bihar',
'Branch Post Office,Samastipur,Bihar',
'Branch Post Office,Samastipur,Bihar',
'Branch Post Office,Samastipur,Bihar',
'Branch Post Office,Samastipur,Bihar',
'Branch Post Office,Samastipur,Bihar',
'Branch Post Office,Samastipur,Bihar',
'Branch Post Office,Samastipur,Bihar',
'Branch Post Office,Samastipur,Bihar',
'Branch Post Office,Samastipur,Bihar',
'Branch Post Office,Samastipur,Bihar',
'Branch Post Office,Samastipur,Bihar',
'Branch Post Office,Samastipur,Bihar',
'Branch Post Office,Samastipur,Bihar',
'Branch Post Office,Samastipur,Bihar',
'Branch Post Office,Darbhanga,Bihar',
'Branch Post Office,Samastipur,Bihar',
'Branch Post Office,Samastipur,Bihar',
'Branch Post Office,Samastipur,Bihar',
'Branch Post Office,Samastipur,Bihar',
'Branch Post Office,Samastipur,Bihar',
'Sub Post Office,Samastipur,Bihar',
'Branch Post Office,Samastipur,Bihar',
'Branch Post Office,Darbhanga,Bihar',
'Branch Post Office,Samastipur,Bihar',
'Branch Post Office,Samastipur,Bihar',
'Branch Post Office,Samastipur,Bihar',
'Branch Post Office,Samastipur,Bihar',
'Branch Post Office,Samastipur,Bihar',
'Branch Post Office,Samastipur,Bihar',
'Branch Post Office,Samastipur,Bihar',
'Branch Post Office,Samastipur,Bihar',
'Branch Post Office,Samastipur,Bihar',
'Branch Post Office,Samastipur,Bihar',
'Branch Post Office,Samastipur,Bihar',
'Head Post Office,Samastipur,Bihar',
'Sub Post Office,Samastipur,Bihar',
'Branch Post Office,Samastipur,Bihar',
'Branch Post Office,Samastipur,Bihar',
'Branch Post Office,Samastipur,Bihar',
'Branch Post Office,Samastipur,Bihar',
'Branch Post Office,Samastipur,Bihar',
'Branch Post Office,Samastipur,Bihar',
'Sub Post Office,Samastipur,Bihar',
'Branch Post Office,Samastipur,Bihar',
'Branch Post Office,Samastipur,Bihar',
'Branch Post Office,Samastipur,Bihar',
'Branch Post Office,Samastipur,Bihar',
'Branch Post Office,Samastipur,Bihar',
'Branch Post Office,Samastipur,Bihar',
'Branch Post Office,Samastipur,Bihar',
'Sub Post Office,Samastipur,Bihar',
'Sub Post Office,Samastipur,Bihar',
'Branch Post Office,Samastipur,Bihar',
'Branch Post Office,Samastipur,Bihar',
'Branch Post Office,Samastipur,Bihar',
'Branch Post Office,Samastipur,Bihar',
'Branch Post Office,Samastipur,Bihar',
'Branch Post Office,Samastipur,Bihar',
'Branch Post Office,Samastipur,Bihar',
'Branch Post Office,Samastipur,Bihar',
'Branch Post Office,Samastipur,Bihar',
'Branch Post Office,Samastipur,Bihar',
'Branch Post Office,Samastipur,Bihar',
'Branch Post Office,Samastipur,Bihar',
'Branch Post Office,Samastipur,Bihar',
'Branch Post Office,Samastipur,Bihar',
'Branch Post Office,Samastipur,Bihar',
'Sub Post Office,Samastipur,Bihar',
'Branch Post Office,Samastipur,Bihar',
'Branch Post Office,Samastipur,Bihar',
'Branch Post Office,Samastipur,Bihar',
'Branch Post Office,Samastipur,Bihar',
'Branch Post Office,Samastipur,Bihar',
'Branch Post Office,Samastipur,Bihar',
'Sub Post Office,Samastipur,Bihar',
'Sub Post Office,Samastipur,Bihar',
'Sub Post Office,Samastipur,Bihar',
'Branch Post Office,Samastipur,Bihar',
'Sub Post Office,Samastipur,Bihar',
'Branch Post Office,Saran,Bihar',
'Branch Post Office,Saran,Bihar',
'Branch Post Office,Saran,Bihar',
'Branch Post Office,Saran,Bihar',
'Branch Post Office,Saran,Bihar',
'Branch Post Office,Saran,Bihar',
'Branch Post Office,Saran,Bihar',
'Sub Post Office,Saran,Bihar',
'Branch Post Office,Saran,Bihar',
'Branch Post Office,Saran,Bihar',
'Sub Post Office,Saran,Bihar',
'Branch Post Office,Saran,Bihar',
'Branch Post Office,Saran,Bihar',
'Branch Post Office,Saran,Bihar',
'Branch Post Office,Saran,Bihar',
'Branch Post Office,Saran,Bihar',
'Branch Post Office,Saran,Bihar',
'Branch Post Office,Saran,Bihar',
'Branch Post Office,Saran,Bihar',
'Branch Post Office,Saran,Bihar',
'Branch Post Office,Saran,Bihar',
'Branch Post Office,Saran,Bihar',
'Branch Post Office,Saran,Bihar',
'Branch Post Office,Saran,Bihar',
'Branch Post Office,Saran,Bihar',
'Branch Post Office,Saran,Bihar',
'Branch Post Office,Saran,Bihar',
'Branch Post Office,Saran,Bihar',
'Branch Post Office,Saran,Bihar',
'Branch Post Office,Saran,Bihar',
'Branch Post Office,Saran,Bihar',
'Branch Post Office,Saran,Bihar',
'Branch Post Office,Saran,Bihar',
'Branch Post Office,Saran,Bihar',
'Sub Post Office,Saran,Bihar',
'Branch Post Office,Saran,Bihar',
'Branch Post Office,Saran,Bihar',
'Branch Post Office,Saran,Bihar',
'Branch Post Office,Saran,Bihar',
'Branch Post Office,Saran,Bihar',
'Branch Post Office,Saran,Bihar',
'Sub Post Office,Saran,Bihar',
'Branch Post Office,Saran,Bihar',
'Branch Post Office,Saran,Bihar',
'Branch Post Office,Saran,Bihar',
'Branch Post Office,Saran,Bihar',
'Branch Post Office,Saran,Bihar',
'Sub Post Office,Saran,Bihar',
'Branch Post Office,Saran,Bihar',
'Branch Post Office,Saran,Bihar',
'Branch Post Office,Saran,Bihar',
'Branch Post Office,Saran,Bihar',
'Branch Post Office,Saran,Bihar',
'Branch Post Office,Saran,Bihar',
'Sub Post Office,Saran,Bihar',
'Branch Post Office,Saran,Bihar',
'Branch Post Office,Saran,Bihar',
'Branch Post Office,Saran,Bihar',
'Branch Post Office,Saran,Bihar',
'Branch Post Office,Saran,Bihar',
'Branch Post Office,Saran,Bihar',
'Branch Post Office,Saran,Bihar',
'Branch Post Office,Saran,Bihar',
'Sub Post Office,Saran,Bihar',
'Branch Post Office,Saran,Bihar',
'Branch Post Office,Saran,Bihar',
'Branch Post Office,Saran,Bihar',
'Branch Post Office,Saran,Bihar',
'Branch Post Office,Saran,Bihar',
'Branch Post Office,Saran,Bihar',
'Branch Post Office,Saran,Bihar',
'Branch Post Office,Saran,Bihar',
'Branch Post Office,Saran,Bihar',
'Branch Post Office,Saran,Bihar',
'Branch Post Office,Saran,Bihar',
'Branch Post Office,Saran,Bihar',
'Sub Post Office,Saran,Bihar',
'Branch Post Office,Saran,Bihar',
'Branch Post Office,Saran,Bihar',
'Branch Post Office,Saran,Bihar',
'Branch Post Office,Saran,Bihar',
'Head Post Office,Saran,Bihar',
'Branch Post Office,Saran,Bihar',
'Branch Post Office,Saran,Bihar',
'Branch Post Office,Saran,Bihar',
'Branch Post Office,Saran,Bihar',
'Branch Post Office,Saran,Bihar',
'Branch Post Office,Saran,Bihar',
'Branch Post Office,Saran,Bihar',
'Branch Post Office,Saran,Bihar',
'Sub Post Office,Saran,Bihar',
'Sub Post Office,Saran,Bihar',
'Sub Post Office,Saran,Bihar',
'Branch Post Office,Saran,Bihar',
'Branch Post Office,Saran,Bihar',
'Branch Post Office,Saran,Bihar',
'Branch Post Office,Saran,Bihar',
'Branch Post Office,Saran,Bihar',
'Branch Post Office,Saran,Bihar',
'Branch Post Office,Saran,Bihar',
'Branch Post Office,Saran,Bihar',
'Branch Post Office,Saran,Bihar',
'Branch Post Office,Saran,Bihar',
'Branch Post Office,Saran,Bihar',
'Branch Post Office,Saran,Bihar',
'Branch Post Office,Saran,Bihar',
'Branch Post Office,Saran,Bihar',
'Sub Post Office,Saran,Bihar',
'Sub Post Office,Saran,Bihar',
'Branch Post Office,Saran,Bihar',
'Branch Post Office,Saran,Bihar',
'Branch Post Office,Saran,Bihar',
'Branch Post Office,Saran,Bihar',
'Branch Post Office,Saran,Bihar',
'Branch Post Office,Saran,Bihar',
'Branch Post Office,Saran,Bihar',
'Sub Post Office,Saran,Bihar',
'Branch Post Office,Saran,Bihar',
'Branch Post Office,Saran,Bihar',
'Branch Post Office,Saran,Bihar',
'Branch Post Office,Saran,Bihar',
'Sub Post Office,Saran,Bihar',
'Branch Post Office,Saran,Bihar',
'Branch Post Office,Saran,Bihar',
'Branch Post Office,Saran,Bihar',
'Branch Post Office,Saran,Bihar',
'Branch Post Office,Saran,Bihar',
'Sub Post Office,Saran,Bihar',
'Branch Post Office,Saran,Bihar',
'Branch Post Office,Saran,Bihar',
'Branch Post Office,Saran,Bihar',
'Branch Post Office,Saran,Bihar',
'Branch Post Office,Saran,Bihar',
'Branch Post Office,Saran,Bihar',
'Branch Post Office,Saran,Bihar',
'Sub Post Office,Saran,Bihar',
'Sub Post Office,Saran,Bihar',
'Sub Post Office,Saran,Bihar',
'Branch Post Office,Saran,Bihar',
'Branch Post Office,Saran,Bihar',
'Branch Post Office,Saran,Bihar',
'Branch Post Office,Saran,Bihar',
'Branch Post Office,Saran,Bihar',
'Branch Post Office,Saran,Bihar',
'Branch Post Office,Saran,Bihar',
'Branch Post Office,Saran,Bihar',
'Sub Post Office,Saran,Bihar',
'Branch Post Office,Saran,Bihar',
'Branch Post Office,Saran,Bihar',
'Branch Post Office,Saran,Bihar',
'Sub Post Office,Saran,Bihar',
'Branch Post Office,Saran,Bihar',
'Branch Post Office,Saran,Bihar',
'Branch Post Office,Saran,Bihar',
'Branch Post Office,Saran,Bihar',
'Branch Post Office,Saran,Bihar',
'Branch Post Office,Saran,Bihar',
'Branch Post Office,Saran,Bihar',
'Sub Post Office,Saran,Bihar',
'Branch Post Office,Saran,Bihar',
'Branch Post Office,Saran,Bihar',
'Branch Post Office,Saran,Bihar',
'Branch Post Office,Saran,Bihar',
'Sub Post Office,Saran,Bihar',
'Branch Post Office,Saran,Bihar',
'Branch Post Office,Saran,Bihar',
'Branch Post Office,Saran,Bihar',
'Sub Post Office,Saran,Bihar',
'Branch Post Office,Saran,Bihar',
'Branch Post Office,Saran,Bihar',
'Branch Post Office,Saran,Bihar',
'Branch Post Office,Saran,Bihar',
'Branch Post Office,Saran,Bihar',
'Sub Post Office,Saran,Bihar',
'Branch Post Office,Saran,Bihar',
'Branch Post Office,Saran,Bihar',
'Branch Post Office,Saran,Bihar',
'Branch Post Office,Saran,Bihar',
'Branch Post Office,Saran,Bihar',
'Branch Post Office,Saran,Bihar',
'Branch Post Office,Saran,Bihar',
'Branch Post Office,Saran,Bihar',
'Branch Post Office,Saran,Bihar',
'Branch Post Office,Saran,Bihar',
'Branch Post Office,Saran,Bihar',
'Branch Post Office,Saran,Bihar',
'Branch Post Office,Saran,Bihar',
'Branch Post Office,Saran,Bihar',
'Branch Post Office,Saran,Bihar',
'Branch Post Office,Saran,Bihar',
'Branch Post Office,Saran,Bihar',
'Branch Post Office,Saran,Bihar',
'Sub Post Office,Saran,Bihar',
'Branch Post Office,Saran,Bihar',
'Branch Post Office,Saran,Bihar',
'Branch Post Office,Saran,Bihar',
'Branch Post Office,Saran,Bihar',
'Branch Post Office,Saran,Bihar',
'Branch Post Office,Saran,Bihar',
'Branch Post Office,Saran,Bihar',
'Branch Post Office,Saran,Bihar',
'Sub Post Office,Saran,Bihar',
'Branch Post Office,Saran,Bihar',
'Branch Post Office,Saran,Bihar',
'Branch Post Office,Saran,Bihar',
'Sub Post Office,Saran,Bihar',
'Sub Post Office,Saran,Bihar',
'Branch Post Office,Saran,Bihar',
'Branch Post Office,Saran,Bihar',
'Branch Post Office,Saran,Bihar',
'Branch Post Office,Saran,Bihar',
'Branch Post Office,Saran,Bihar',
'Branch Post Office,Saran,Bihar',
'Branch Post Office,Saran,Bihar',
'Branch Post Office,Saran,Bihar',
'Branch Post Office,Saran,Bihar',
'Branch Post Office,Saran,Bihar',
'Branch Post Office,Saran,Bihar',
'Branch Post Office,Saran,Bihar',
'Branch Post Office,Saran,Bihar',
'Branch Post Office,Saran,Bihar',
'Branch Post Office,Saran,Bihar',
'Branch Post Office,Saran,Bihar',
'Branch Post Office,Saran,Bihar',
'Branch Post Office,Saran,Bihar',
'Branch Post Office,Saran,Bihar',
'Branch Post Office,Saran,Bihar',
'Branch Post Office,Saran,Bihar',
'Sub Post Office,Saran,Bihar',
'Branch Post Office,Saran,Bihar',
'Branch Post Office,Saran,Bihar',
'Branch Post Office,Saran,Bihar',
'Branch Post Office,Saran,Bihar',
'Branch Post Office,Saran,Bihar',
'Sub Post Office,Saran,Bihar',
'Branch Post Office,Saran,Bihar',
'Branch Post Office,Saran,Bihar',
'Branch Post Office,Saran,Bihar',
'Head Post Office,Saran,Bihar',
'Branch Post Office,Saran,Bihar',
'Sub Post Office,Saran,Bihar',
'Branch Post Office,Saran,Bihar',
'Branch Post Office,Saran,Bihar',
'Sub Post Office,Saran,Bihar',
'Branch Post Office,Saran,Bihar',
'Branch Post Office,Saran,Bihar',
'Branch Post Office,Saran,Bihar',
'Branch Post Office,Saran,Bihar',
'Branch Post Office,Saran,Bihar',
'Sub Post Office,Saran,Bihar',
'Sub Post Office,Saran,Bihar',
'Branch Post Office,Saran,Bihar',
'Branch Post Office,Saran,Bihar',
'Branch Post Office,Saran,Bihar',
'Branch Post Office,Saran,Bihar',
'Branch Post Office,Saran,Bihar',
'Branch Post Office,Saran,Bihar',
'Branch Post Office,Saran,Bihar',
'Branch Post Office,Saran,Bihar',
'Branch Post Office,Saran,Bihar',
'Branch Post Office,Saran,Bihar',
'Sub Post Office,Saran,Bihar',
'Sub Post Office,Saran,Bihar',
'Branch Post Office,Saran,Bihar',
'Sub Post Office,Saran,Bihar',
'Branch Post Office,Saran,Bihar',
'Branch Post Office,Saran,Bihar',
'Branch Post Office,Saran,Bihar',
'Branch Post Office,Saran,Bihar',
'Branch Post Office,Saran,Bihar',
'Branch Post Office,Saran,Bihar',
'Branch Post Office,Saran,Bihar',
'Sub Post Office,Saran,Bihar',
'Branch Post Office,Saran,Bihar',
'Branch Post Office,Saran,Bihar',
'Branch Post Office,Saran,Bihar',
'Branch Post Office,Saran,Bihar',
'Branch Post Office,Saran,Bihar',
'Branch Post Office,Saran,Bihar',
'Branch Post Office,Saran,Bihar',
'Branch Post Office,Saran,Bihar',
'Branch Post Office,Saran,Bihar',
'Sub Post Office,Saran,Bihar',
'Branch Post Office,Saran,Bihar',
'Branch Post Office,Saran,Bihar',
'Sub Post Office,Saran,Bihar',
'Branch Post Office,Saran,Bihar',
'Branch Post Office,Saran,Bihar',
'Sub Post Office,Saran,Bihar',
'Sub Post Office,Saran,Bihar',
'Branch Post Office,Saran,Bihar',
'Branch Post Office,Saran,Bihar',
'Branch Post Office,Saran,Bihar',
'Branch Post Office,Saran,Bihar',
'Branch Post Office,Saran,Bihar',
'Branch Post Office,Saran,Bihar',
'Branch Post Office,Saran,Bihar',
'Branch Post Office,Saran,Bihar',
'Branch Post Office,Saran,Bihar',
'Branch Post Office,Saran,Bihar',
'Branch Post Office,Saran,Bihar',
'Branch Post Office,Saran,Bihar',
'Sub Post Office,Saran,Bihar',
'Branch Post Office,Saran,Bihar',
'Branch Post Office,Saran,Bihar',
'Branch Post Office,Saran,Bihar',
'Branch Post Office,Saran,Bihar',
'Sub Post Office,Saran,Bihar',
'Branch Post Office,Saran,Bihar',
'Branch Post Office,Saran,Bihar',
'Sub Post Office,Saran,Bihar',
'Branch Post Office,Saran,Bihar',
'Branch Post Office,Saran,Bihar',
'Branch Post Office,Saran,Bihar',
'Branch Post Office,Saran,Bihar',
'Branch Post Office,Saran,Bihar',
'Branch Post Office,Saran,Bihar',
'Branch Post Office,Saran,Bihar',
'Branch Post Office,Saran,Bihar',
'Branch Post Office,Saran,Bihar',
'Branch Post Office,Saran,Bihar',
'Sub Post Office,Saran,Bihar',
'Branch Post Office,Saran,Bihar',
'Branch Post Office,Saran,Bihar',
'Sub Post Office,Saran,Bihar',
'Branch Post Office,Saran,Bihar',
'Branch Post Office,Saran,Bihar',
'Branch Post Office,Saran,Bihar',
'Branch Post Office,Saran,Bihar',
'Branch Post Office,Saran,Bihar',
'Branch Post Office,Saran,Bihar',
'Branch Post Office,Saran,Bihar',
'Sub Post Office,Saran,Bihar',
'Branch Post Office,Saran,Bihar',
'Branch Post Office,Saran,Bihar',
'Branch Post Office,Saran,Bihar',
'Branch Post Office,Saran,Bihar',
'Branch Post Office,Saran,Bihar',
'Branch Post Office,Saran,Bihar',
'Branch Post Office,Saran,Bihar',
'Branch Post Office,Saran,Bihar',
'Branch Post Office,Saran,Bihar',
'Branch Post Office,Saran,Bihar',
'Branch Post Office,Saran,Bihar',
'Branch Post Office,Saran,Bihar',
'Branch Post Office,Saran,Bihar',
'Branch Post Office,Saran,Bihar',
'Branch Post Office,Saran,Bihar',
'Sub Post Office,Saran,Bihar',
'Branch Post Office,Saran,Bihar',
'Branch Post Office,Saran,Bihar',
'Branch Post Office,Saran,Bihar',
'Branch Post Office,Saran,Bihar',
'Branch Post Office,Saran,Bihar',
'Branch Post Office,Saran,Bihar',
'Branch Post Office,Saran,Bihar',
'Branch Post Office,Saran,Bihar',
'Branch Post Office,Saran,Bihar',
'Branch Post Office,Saran,Bihar',
'Branch Post Office,Saran,Bihar',
'Branch Post Office,Saran,Bihar',
'Branch Post Office,Saran,Bihar',
'Branch Post Office,Saran,Bihar',
'Branch Post Office,Saran,Bihar',
'Branch Post Office,Saran,Bihar',
'Branch Post Office,Saran,Bihar',
'Branch Post Office,Saran,Bihar',
'Sub Post Office,Saran,Bihar',
'Branch Post Office,Saran,Bihar',
'Branch Post Office,Saran,Bihar',
'Branch Post Office,Saran,Bihar',
'Sub Post Office,Saran,Bihar',
'Sub Post Office,Saran,Bihar',
'Branch Post Office,Saran,Bihar',
'Sub Post Office,Saran,Bihar',
'Sub Post Office,Saran,Bihar',
'Sub Post Office,Saran,Bihar',
'Branch Post Office,Saran,Bihar',
'Branch Post Office,Saran,Bihar',
'Branch Post Office,Saran,Bihar',
'Branch Post Office,Saran,Bihar',
'Branch Post Office,Saran,Bihar',
'Branch Post Office,Saran,Bihar',
'Branch Post Office,Saran,Bihar',
'Branch Post Office,Saran,Bihar',
'Branch Post Office,Saran,Bihar',
'Branch Post Office,Saran,Bihar',
'Branch Post Office,Saran,Bihar',
'Branch Post Office,Saran,Bihar',
'Branch Post Office,Monghyr,Bihar',
'Branch Post Office,Monghyr,Bihar',
'Branch Post Office,Monghyr,Bihar',
'Branch Post Office,Monghyr,Bihar',
'Branch Post Office,Monghyr,Bihar',
'Branch Post Office,Monghyr,Bihar',
'Branch Post Office,Monghyr,Bihar',
'Branch Post Office,Monghyr,Bihar',
'Branch Post Office,Monghyr,Bihar',
'Branch Post Office,Monghyr,Bihar',
'Branch Post Office,Monghyr,Bihar',
'Branch Post Office,Monghyr,Bihar',
'Branch Post Office,Monghyr,Bihar',
'Branch Post Office,Monghyr,Bihar',
'Branch Post Office,Monghyr,Bihar',
'Branch Post Office,Monghyr,Bihar',
'Branch Post Office,Monghyr,Bihar',
'Branch Post Office,Monghyr,Bihar',
'Sub Post Office,Monghyr,Bihar',
'Branch Post Office,Monghyr,Bihar',
'Branch Post Office,Monghyr,Bihar',
'Branch Post Office,Monghyr,Bihar',
'Branch Post Office,Monghyr,Bihar',
'Branch Post Office,Monghyr,Bihar',
'Branch Post Office,Monghyr,Bihar',
'Branch Post Office,Monghyr,Bihar',
'Branch Post Office,Monghyr,Bihar',
'Branch Post Office,Monghyr,Bihar',
'Branch Post Office,Monghyr,Bihar',
'Branch Post Office,Monghyr,Bihar',
'Branch Post Office,Monghyr,Bihar',
'Branch Post Office,Monghyr,Bihar',
'Branch Post Office,Monghyr,Bihar',
'Branch Post Office,Monghyr,Bihar',
'Branch Post Office,Monghyr,Bihar',
'Branch Post Office,Monghyr,Bihar',
'Branch Post Office,Monghyr,Bihar',
'Branch Post Office,Monghyr,Bihar',
'Branch Post Office,Monghyr,Bihar',
'Branch Post Office,Monghyr,Bihar',
'Branch Post Office,Monghyr,Bihar',
'Branch Post Office,Monghyr,Bihar',
'Branch Post Office,Monghyr,Bihar',
'Branch Post Office,Monghyr,Bihar',
'Branch Post Office,Monghyr,Bihar',
'Branch Post Office,Monghyr,Bihar',
'Branch Post Office,Monghyr,Bihar',
'Branch Post Office,Monghyr,Bihar',
'Sub Post Office,Monghyr,Bihar',
'Branch Post Office,Monghyr,Bihar',
'Branch Post Office,Monghyr,Bihar',
'Branch Post Office,Monghyr,Bihar',
'Branch Post Office,Monghyr,Bihar',
'Branch Post Office,Monghyr,Bihar',
'Branch Post Office,Monghyr,Bihar',
'Branch Post Office,Monghyr,Bihar',
'Branch Post Office,Monghyr,Bihar',
'Branch Post Office,Monghyr,Bihar',
'Branch Post Office,Monghyr,Bihar',
'Branch Post Office,Monghyr,Bihar',
'Branch Post Office,Monghyr,Bihar',
'Branch Post Office,Monghyr,Bihar',
'Branch Post Office,Monghyr,Bihar',
'Branch Post Office,Monghyr,Bihar',
'Branch Post Office,Monghyr,Bihar',
'Branch Post Office,Monghyr,Bihar',
'Branch Post Office,Monghyr,Bihar',
'Sub Post Office,Monghyr,Bihar',
'Branch Post Office,Monghyr,Bihar',
'Branch Post Office,Monghyr,Bihar',
'Branch Post Office,Monghyr,Bihar',
'Sub Post Office,Monghyr,Bihar',
'Sub Post Office,Monghyr,Bihar',
'Sub Post Office,Monghyr,Bihar',
'Sub Post Office,Monghyr,Bihar',
'Branch Post Office,Monghyr,Bihar',
'Sub Post Office,Monghyr,Bihar',
'Branch Post Office,Monghyr,Bihar',
'Branch Post Office,Monghyr,Bihar',
'Branch Post Office,Monghyr,Bihar',
'Branch Post Office,Monghyr,Bihar',
'Branch Post Office,Monghyr,Bihar',
'Branch Post Office,Monghyr,Bihar',
'Branch Post Office,Sitamarhi,Bihar',
'Branch Post Office,Sitamarhi,Bihar',
'Branch Post Office,Sitamarhi,Bihar',
'Branch Post Office,Sitamarhi,Bihar',
'Branch Post Office,Sitamarhi,Bihar',
'Branch Post Office,Sitamarhi,Bihar',
'Branch Post Office,Sitamarhi,Bihar',
'Branch Post Office,Sitamarhi,Bihar',
'Branch Post Office,Sitamarhi,Bihar',
'Branch Post Office,Sitamarhi,Bihar',
'Branch Post Office,Sitamarhi,Bihar',
'Branch Post Office,Sitamarhi,Bihar',
'Branch Post Office,Sitamarhi,Bihar',
'Branch Post Office,Sitamarhi,Bihar',
'Branch Post Office,Sitamarhi,Bihar',
'Branch Post Office,Sitamarhi,Bihar',
'Branch Post Office,Sitamarhi,Bihar',
'Branch Post Office,Sitamarhi,Bihar',
'Branch Post Office,Sitamarhi,Bihar',
'Branch Post Office,Sitamarhi,Bihar',
'Branch Post Office,Sitamarhi,Bihar',
'Branch Post Office,Sitamarhi,Bihar',
'Sub Post Office,Sitamarhi,Bihar',
'Branch Post Office,Sitamarhi,Bihar',
'Branch Post Office,Sitamarhi,Bihar',
'Sub Post Office,Sitamarhi,Bihar',
'Branch Post Office,Sitamarhi,Bihar',
'Sub Post Office,Sitamarhi,Bihar',
'Branch Post Office,Sitamarhi,Bihar',
'Branch Post Office,Sitamarhi,Bihar',
'Branch Post Office,Sitamarhi,Bihar',
'Branch Post Office,Sitamarhi,Bihar',
'Branch Post Office,Sitamarhi,Bihar',
'Branch Post Office,Sitamarhi,Bihar',
'Branch Post Office,Sitamarhi,Bihar',
'Branch Post Office,Sitamarhi,Bihar',
'Branch Post Office,Sitamarhi,Bihar',
'Branch Post Office,Sitamarhi,Bihar',
'Branch Post Office,Sitamarhi,Bihar',
'Branch Post Office,Sitamarhi,Bihar',
'Branch Post Office,Sitamarhi,Bihar',
'Branch Post Office,Sitamarhi,Bihar',
'Branch Post Office,Sitamarhi,Bihar',
'Sub Post Office,Sitamarhi,Bihar',
'Branch Post Office,Sitamarhi,Bihar',
'Branch Post Office,Sitamarhi,Bihar',
'Branch Post Office,Sitamarhi,Bihar',
'Branch Post Office,Sitamarhi,Bihar',
'Branch Post Office,Sitamarhi,Bihar',
'Branch Post Office,Sitamarhi,Bihar',
'Branch Post Office,Sitamarhi,Bihar',
'Branch Post Office,Sitamarhi,Bihar',
'Branch Post Office,Sitamarhi,Bihar',
'Branch Post Office,Sitamarhi,Bihar',
'Branch Post Office,Sitamarhi,Bihar',
'Branch Post Office,Sitamarhi,Bihar',
'Sub Post Office,Sitamarhi,Bihar',
'Branch Post Office,Sitamarhi,Bihar',
'Branch Post Office,Sitamarhi,Bihar',
'Branch Post Office,Sitamarhi,Bihar',
'Branch Post Office,Sitamarhi,Bihar',
'Branch Post Office,Sitamarhi,Bihar',
'Branch Post Office,Sitamarhi,Bihar',
'Branch Post Office,Sitamarhi,Bihar',
'Branch Post Office,Sitamarhi,Bihar',
'Branch Post Office,Sitamarhi,Bihar',
'Branch Post Office,Sitamarhi,Bihar',
'Branch Post Office,Sitamarhi,Bihar',
'Branch Post Office,Sitamarhi,Bihar',
'Branch Post Office,Sitamarhi,Bihar',
'Sub Post Office,Sitamarhi,Bihar',
'Branch Post Office,Sitamarhi,Bihar',
'Branch Post Office,Sitamarhi,Bihar',
'Branch Post Office,Sitamarhi,Bihar',
'Branch Post Office,Sitamarhi,Bihar',
'Branch Post Office,Sitamarhi,Bihar',
'Branch Post Office,Sitamarhi,Bihar',
'Branch Post Office,Sitamarhi,Bihar',
'Sub Post Office,Sitamarhi,Bihar',
'Branch Post Office,Sitamarhi,Bihar',
'Branch Post Office,Sitamarhi,Bihar',
'Branch Post Office,Sitamarhi,Bihar',
'Branch Post Office,Sitamarhi,Bihar',
'Branch Post Office,Sitamarhi,Bihar',
'Branch Post Office,Sitamarhi,Bihar',
'Branch Post Office,Sitamarhi,Bihar',
'Branch Post Office,Sitamarhi,Bihar',
'Branch Post Office,Sitamarhi,Bihar',
'Branch Post Office,Sitamarhi,Bihar',
'Branch Post Office,Sitamarhi,Bihar',
'Branch Post Office,Sitamarhi,Bihar',
'Branch Post Office,Sitamarhi,Bihar',
'Branch Post Office,Sitamarhi,Bihar',
'Branch Post Office,Sitamarhi,Bihar',
'Branch Post Office,Sitamarhi,Bihar',
'Branch Post Office,Sitamarhi,Bihar',
'Branch Post Office,Sitamarhi,Bihar',
'Branch Post Office,Sitamarhi,Bihar',
'Branch Post Office,Sitamarhi,Bihar',
'Branch Post Office,Sitamarhi,Bihar',
'Branch Post Office,Sitamarhi,Bihar',
'Branch Post Office,Sitamarhi,Bihar',
'Branch Post Office,Sitamarhi,Bihar',
'Branch Post Office,Sitamarhi,Bihar',
'Branch Post Office,Sitamarhi,Bihar',
'Sub Post Office,Sitamarhi,Bihar',
'Head Post Office,Sitamarhi,Bihar',
'Branch Post Office,Sitamarhi,Bihar',
'Branch Post Office,Sitamarhi,Bihar',
'Branch Post Office,Sitamarhi,Bihar',
'Sub Post Office,Sitamarhi,Bihar',
'Branch Post Office,Sitamarhi,Bihar',
'Branch Post Office,Sitamarhi,Bihar',
'Branch Post Office,Sitamarhi,Bihar',
'Branch Post Office,Sitamarhi,Bihar',
'Branch Post Office,Sitamarhi,Bihar',
'Branch Post Office,Sitamarhi,Bihar',
'Branch Post Office,Sitamarhi,Bihar',
'Branch Post Office,Sitamarhi,Bihar',
'Branch Post Office,Sitamarhi,Bihar',
'Branch Post Office,Sitamarhi,Bihar',
'Branch Post Office,Sitamarhi,Bihar',
'Branch Post Office,Sitamarhi,Bihar',
'Branch Post Office,Sitamarhi,Bihar',
'Branch Post Office,Sitamarhi,Bihar',
'Branch Post Office,Sitamarhi,Bihar',
'Branch Post Office,Sitamarhi,Bihar',
'Branch Post Office,Sitamarhi,Bihar',
'Branch Post Office,Sitamarhi,Bihar',
'Branch Post Office,Sitamarhi,Bihar',
'Branch Post Office,Sitamarhi,Bihar',
'Branch Post Office,Sitamarhi,Bihar',
'Branch Post Office,Sitamarhi,Bihar',
'Branch Post Office,Sitamarhi,Bihar',
'Sub Post Office,Sitamarhi,Bihar',
'Sub Post Office,Sitamarhi,Bihar',
'Branch Post Office,Sitamarhi,Bihar',
'Branch Post Office,Sitamarhi,Bihar',
'Branch Post Office,Sitamarhi,Bihar',
'Branch Post Office,Sitamarhi,Bihar',
'Branch Post Office,Sitamarhi,Bihar',
'Branch Post Office,Sitamarhi,Bihar',
'Branch Post Office,Sitamarhi,Bihar',
'Branch Post Office,Sitamarhi,Bihar',
'Branch Post Office,Sitamarhi,Bihar',
'Branch Post Office,Sitamarhi,Bihar',
'Branch Post Office,Sitamarhi,Bihar',
'Branch Post Office,Sitamarhi,Bihar',
'Branch Post Office,Sitamarhi,Bihar',
'Branch Post Office,Sitamarhi,Bihar',
'Branch Post Office,Sitamarhi,Bihar',
'Branch Post Office,Sitamarhi,Bihar',
'Sub Post Office,Sitamarhi,Bihar',
'Branch Post Office,Sitamarhi,Bihar',
'Branch Post Office,Sitamarhi,Bihar',
'Sub Post Office,Sitamarhi,Bihar',
'Branch Post Office,Sitamarhi,Bihar',
'Branch Post Office,Sitamarhi,Bihar',
'Branch Post Office,Sitamarhi,Bihar',
'Branch Post Office,Sitamarhi,Bihar',
'Branch Post Office,Sitamarhi,Bihar',
'Branch Post Office,Sitamarhi,Bihar',
'Branch Post Office,Sitamarhi,Bihar',
'Branch Post Office,Sitamarhi,Bihar',
'Branch Post Office,Sitamarhi,Bihar',
'Branch Post Office,Sitamarhi,Bihar',
'Branch Post Office,Sitamarhi,Bihar',
'Branch Post Office,Sitamarhi,Bihar',
'Branch Post Office,Sitamarhi,Bihar',
'Branch Post Office,Sitamarhi,Bihar',
'Branch Post Office,Sitamarhi,Bihar',
'Branch Post Office,Sitamarhi,Bihar',
'Branch Post Office,Sitamarhi,Bihar',
'Branch Post Office,Sitamarhi,Bihar',
'Sub Post Office,Sitamarhi,Bihar',
'Branch Post Office,Sitamarhi,Bihar',
'Branch Post Office,Sitamarhi,Bihar',
'Branch Post Office,Sitamarhi,Bihar',
'Branch Post Office,Sitamarhi,Bihar',
'Branch Post Office,Sitamarhi,Bihar',
'Branch Post Office,Sitamarhi,Bihar',
'Branch Post Office,Sitamarhi,Bihar',
'Branch Post Office,Sitamarhi,Bihar',
'Branch Post Office,Sitamarhi,Bihar',
'Branch Post Office,Sitamarhi,Bihar',
'Branch Post Office,Sitamarhi,Bihar',
'Branch Post Office,Sitamarhi,Bihar',
'Branch Post Office,Sitamarhi,Bihar',
'Sub Post Office,Sitamarhi,Bihar',
'Branch Post Office,Sitamarhi,Bihar',
'Branch Post Office,Sitamarhi,Bihar',
'Branch Post Office,Sitamarhi,Bihar',
'Branch Post Office,Sitamarhi,Bihar',
'Branch Post Office,Sitamarhi,Bihar',
'Branch Post Office,Sitamarhi,Bihar',
'Branch Post Office,Sitamarhi,Bihar',
'Branch Post Office,Sitamarhi,Bihar',
'Branch Post Office,Sitamarhi,Bihar',
'Branch Post Office,Sitamarhi,Bihar',
'Branch Post Office,Sitamarhi,Bihar',
'Branch Post Office,Sitamarhi,Bihar',
'Branch Post Office,Sitamarhi,Bihar',
'Branch Post Office,Sitamarhi,Bihar',
'Branch Post Office,Sitamarhi,Bihar',
'Branch Post Office,Sitamarhi,Bihar',
'Sub Post Office,Sitamarhi,Bihar',
'Branch Post Office,Sitamarhi,Bihar',
'Branch Post Office,Sitamarhi,Bihar',
'Branch Post Office,Sitamarhi,Bihar',
'Branch Post Office,Sitamarhi,Bihar',
'Branch Post Office,Sitamarhi,Bihar',
'Branch Post Office,Sitamarhi,Bihar',
'Branch Post Office,Sitamarhi,Bihar',
'Branch Post Office,Sitamarhi,Bihar',
'Branch Post Office,Sitamarhi,Bihar',
'Branch Post Office,Darbhanga,Bihar',
'Branch Post Office,Sitamarhi,Bihar',
'Branch Post Office,Sitamarhi,Bihar',
'Branch Post Office,Sitamarhi,Bihar',
'Branch Post Office,Sitamarhi,Bihar',
'Branch Post Office,Sitamarhi,Bihar',
'Sub Post Office,Sitamarhi,Bihar',
'Branch Post Office,Sitamarhi,Bihar',
'Branch Post Office,Sitamarhi,Bihar',
'Branch Post Office,Sitamarhi,Bihar',
'Branch Post Office,Darbhanga,Bihar',
'Branch Post Office,Sitamarhi,Bihar',
'Branch Post Office,Sitamarhi,Bihar',
'Branch Post Office,Sitamarhi,Bihar',
'Branch Post Office,Sitamarhi,Bihar',
'Branch Post Office,Sitamarhi,Bihar',
'Branch Post Office,Sitamarhi,Bihar',
'Branch Post Office,Sitamarhi,Bihar',
'Branch Post Office,Sitamarhi,Bihar',
'Branch Post Office,Sitamarhi,Bihar',
'Branch Post Office,Sitamarhi,Bihar',
'Branch Post Office,Sitamarhi,Bihar',
'Branch Post Office,Sitamarhi,Bihar',
'Branch Post Office,Sitamarhi,Bihar',
'Branch Post Office,Sitamarhi,Bihar',
'Branch Post Office,Sitamarhi,Bihar',
'Branch Post Office,Sitamarhi,Bihar',
'Branch Post Office,Sitamarhi,Bihar',
'Branch Post Office,Sitamarhi,Bihar',
'Branch Post Office,Sitamarhi,Bihar',
'Branch Post Office,Sitamarhi,Bihar',
'Branch Post Office,Sitamarhi,Bihar',
'Branch Post Office,Sitamarhi,Bihar',
'Branch Post Office,Sitamarhi,Bihar',
'Branch Post Office,Sitamarhi,Bihar',
'Branch Post Office,Sitamarhi,Bihar',
'Branch Post Office,Sitamarhi,Bihar',
'Branch Post Office,Sitamarhi,Bihar',
'Branch Post Office,Sitamarhi,Bihar',
'Branch Post Office,Sitamarhi,Bihar',
'Branch Post Office,Sitamarhi,Bihar',
'Branch Post Office,Sitamarhi,Bihar',
'Branch Post Office,Sitamarhi,Bihar',
'Branch Post Office,Sitamarhi,Bihar',
'Branch Post Office,Sitamarhi,Bihar',
'Branch Post Office,Sitamarhi,Bihar',
'Branch Post Office,Sitamarhi,Bihar',
'Branch Post Office,Sitamarhi,Bihar',
'Branch Post Office,Sitamarhi,Bihar',
'Branch Post Office,Sitamarhi,Bihar',
'Branch Post Office,Sitamarhi,Bihar',
'Branch Post Office,Sitamarhi,Bihar',
'Branch Post Office,Sitamarhi,Bihar',
'Branch Post Office,Sitamarhi,Bihar',
'Branch Post Office,Sitamarhi,Bihar',
'Branch Post Office,Sitamarhi,Bihar',
'Branch Post Office,Sitamarhi,Bihar',
'Branch Post Office,Sitamarhi,Bihar',
'Branch Post Office,Sitamarhi,Bihar',
'Sub Post Office,Sitamarhi,Bihar',
'Branch Post Office,Sitamarhi,Bihar',
'Sub Post Office,Sitamarhi,Bihar',
'Sub Post Office,Sitamarhi,Bihar',
'Branch Post Office,Sitamarhi,Bihar',
'Sub Post Office,Sitamarhi,Bihar',
'Sub Post Office,Sitamarhi,Bihar',
'Branch Post Office,Sitamarhi,Bihar',
'Branch Post Office,Sitamarhi,Bihar',
'Branch Post Office,Sitamarhi,Bihar',
'Branch Post Office,Sitamarhi,Bihar',
'Branch Post Office,Sitamarhi,Bihar',
'Branch Post Office,Sitamarhi,Bihar',
'Branch Post Office,Sitamarhi,Bihar',
'Branch Post Office,Sitamarhi,Bihar',
'Branch Post Office,Sitamarhi,Bihar',
'Branch Post Office,Sitamarhi,Bihar',
'Branch Post Office,Sitamarhi,Bihar',
'Branch Post Office,Sitamarhi,Bihar',
'Branch Post Office,Sitamarhi,Bihar',
'Branch Post Office,Sitamarhi,Bihar',
'Branch Post Office,Sitamarhi,Bihar',
'Branch Post Office,Sitamarhi,Bihar',
'Branch Post Office,Sitamarhi,Bihar',
'Sub Post Office,Sitamarhi,Bihar',
'Branch Post Office,Sitamarhi,Bihar',
'Branch Post Office,Sitamarhi,Bihar',
'Sub Post Office,Sitamarhi,Bihar',
'Branch Post Office,Sitamarhi,Bihar',
'Branch Post Office,Sitamarhi,Bihar',
'Branch Post Office,Sitamarhi,Bihar',
'Branch Post Office,Sitamarhi,Bihar',
'Sub Post Office,Sitamarhi,Bihar',
'Branch Post Office,Sitamarhi,Bihar',
'Branch Post Office,Sitamarhi,Bihar',
'Branch Post Office,Sitamarhi,Bihar',
'Branch Post Office,Sitamarhi,Bihar',
'Branch Post Office,Sitamarhi,Bihar',
'Branch Post Office,Sitamarhi,Bihar',
'Branch Post Office,Sitamarhi,Bihar',
'Branch Post Office,Sitamarhi,Bihar',
'Branch Post Office,Sitamarhi,Bihar',
'Branch Post Office,Sitamarhi,Bihar',
'Branch Post Office,Sitamarhi,Bihar',
'Branch Post Office,Sitamarhi,Bihar',
'Branch Post Office,Sitamarhi,Bihar',
'Branch Post Office,Sitamarhi,Bihar',
'Branch Post Office,Sitamarhi,Bihar',
'Branch Post Office,Sitamarhi,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Sub Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Sub Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Sub Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Sub Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Sub Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Sub Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Sub Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Sub Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Sub Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Sub Post Office,Siwan,Bihar',
'Sub Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Sub Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Sub Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Sub Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Sub Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Sub Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Sub Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Sub Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Sub Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Sub Post Office,Siwan,Bihar',
'Sub Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Sub Post Office,Siwan,Bihar',
'Sub Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Sub Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Sub Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Sub Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Sub Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Sub Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Sub Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Sub Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Sub Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Sub Post Office,Siwan,Bihar',
'Head Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Sub Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Sub Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Sub Post Office,Siwan,Bihar',
'Branch Post Office,Siwan,Bihar',
'Branch Post Office,Saharsa,Bihar',
'Branch Post Office,Saharsa,Bihar',
'Branch Post Office,Saharsa,Bihar',
'Branch Post Office,Saharsa,Bihar',
'Branch Post Office,Saharsa,Bihar',
'Branch Post Office,Saharsa,Bihar',
'Branch Post Office,Saharsa,Bihar',
'Branch Post Office,Saharsa,Bihar',
'Branch Post Office,Saharsa,Bihar',
'Branch Post Office,Saharsa,Bihar',
'Branch Post Office,Saharsa,Bihar',
'Branch Post Office,Saharsa,Bihar',
'Branch Post Office,Saharsa,Bihar',
'Branch Post Office,Saharsa,Bihar',
'Branch Post Office,Saharsa,Bihar',
'Branch Post Office,Saharsa,Bihar',
'Branch Post Office,Saharsa,Bihar',
'Branch Post Office,Saharsa,Bihar',
'Branch Post Office,Saharsa,Bihar',
'Branch Post Office,Saharsa,Bihar',
'Branch Post Office,Saharsa,Bihar',
'Branch Post Office,Saharsa,Bihar',
'Branch Post Office,Saharsa,Bihar',
'Branch Post Office,Saharsa,Bihar',
'Branch Post Office,Saharsa,Bihar',
'Branch Post Office,Saharsa,Bihar',
'Branch Post Office,Saharsa,Bihar',
'Branch Post Office,Saharsa,Bihar',
'Branch Post Office,Saharsa,Bihar',
'Branch Post Office,Saharsa,Bihar',
'Branch Post Office,Saharsa,Bihar',
'Sub Post Office,Saharsa,Bihar',
'Sub Post Office,Saharsa,Bihar',
'Sub Post Office,Saharsa,Bihar',
'Branch Post Office,Saharsa,Bihar',
'Branch Post Office,Saharsa,Bihar',
'Branch Post Office,Saharsa,Bihar',
'Branch Post Office,Saharsa,Bihar',
'Branch Post Office,Saharsa,Bihar',
'Branch Post Office,Saharsa,Bihar',
'Branch Post Office,Saharsa,Bihar',
'Branch Post Office,Saharsa,Bihar',
'Branch Post Office,Saharsa,Bihar',
'Branch Post Office,Saharsa,Bihar',
'Branch Post Office,Saharsa,Bihar',
'Branch Post Office,Saharsa,Bihar',
'Branch Post Office,Saharsa,Bihar',
'Branch Post Office,Saharsa,Bihar',
'Branch Post Office,Saharsa,Bihar',
'Branch Post Office,Saharsa,Bihar',
'Branch Post Office,Saharsa,Bihar',
'Branch Post Office,Saharsa,Bihar',
'Branch Post Office,Saharsa,Bihar',
'Branch Post Office,Saharsa,Bihar',
'Branch Post Office,Saharsa,Bihar',
'Branch Post Office,Saharsa,Bihar',
'Branch Post Office,Saharsa,Bihar',
'Sub Post Office,Saharsa,Bihar',
'Branch Post Office,Saharsa,Bihar',
'Sub Post Office,Saharsa,Bihar',
'Branch Post Office,Saharsa,Bihar',
'Branch Post Office,Saharsa,Bihar',
'Branch Post Office,Saharsa,Bihar',
'Branch Post Office,Saharsa,Bihar',
'Branch Post Office,Saharsa,Bihar',
'Sub Post Office,Saharsa,Bihar',
'Branch Post Office,Saharsa,Bihar',
'Branch Post Office,Saharsa,Bihar',
'Branch Post Office,Saharsa,Bihar',
'Branch Post Office,Saharsa,Bihar',
'Branch Post Office,Saharsa,Bihar',
'Branch Post Office,Saharsa,Bihar',
'Branch Post Office,Saharsa,Bihar',
'Branch Post Office,Saharsa,Bihar',
'Branch Post Office,Saharsa,Bihar',
'Sub Post Office,Saharsa,Bihar',
'Branch Post Office,Madhubani,Bihar',
'Branch Post Office,Madhubani,Bihar',
'Branch Post Office,Madhubani,Bihar',
'Branch Post Office,Madhubani,Bihar',
'Branch Post Office,Madhubani,Bihar',
'Branch Post Office,Madhubani,Bihar',
'Branch Post Office,Madhubani,Bihar',
'Branch Post Office,Madhubani,Bihar',
'Branch Post Office,Madhubani,Bihar',
'Branch Post Office,Madhubani,Bihar',
'Branch Post Office,Madhubani,Bihar',
'Branch Post Office,Madhubani,Bihar',
'Branch Post Office,Madhubani,Bihar',
'Branch Post Office,Madhubani,Bihar',
'Branch Post Office,Madhubani,Bihar',
'Sub Post Office,Madhubani,Bihar',
'Branch Post Office,Madhubani,Bihar',
'Branch Post Office,Madhubani,Bihar',
'Branch Post Office,Saharsa,Bihar',
'Branch Post Office,Saharsa,Bihar',
'Branch Post Office,Saharsa,Bihar',
'Branch Post Office,Saharsa,Bihar',
'Branch Post Office,Saharsa,Bihar',
'Branch Post Office,Saharsa,Bihar',
'Branch Post Office,Saharsa,Bihar',
'Branch Post Office,Saharsa,Bihar',
'Sub Post Office,Saharsa,Bihar',
'Branch Post Office,Saharsa,Bihar',
'Branch Post Office,Saharsa,Bihar',
'Branch Post Office,Saharsa,Bihar',
'Branch Post Office,Saharsa,Bihar',
'Branch Post Office,Saharsa,Bihar',
'Branch Post Office,Saharsa,Bihar',
'Branch Post Office,Saharsa,Bihar',
'Branch Post Office,Saharsa,Bihar',
'Branch Post Office,Saharsa,Bihar',
'Branch Post Office,Saharsa,Bihar',
'Branch Post Office,Saharsa,Bihar',
'Branch Post Office,Saharsa,Bihar',
'Branch Post Office,Saharsa,Bihar',
'Branch Post Office,Saharsa,Bihar',
'Branch Post Office,Saharsa,Bihar',
'Branch Post Office,Saharsa,Bihar',
'Sub Post Office,Saharsa,Bihar',
'Branch Post Office,Saharsa,Bihar',
'Branch Post Office,Saharsa,Bihar',
'Branch Post Office,Saharsa,Bihar',
'Branch Post Office,Saharsa,Bihar',
'Branch Post Office,Saharsa,Bihar',
'Branch Post Office,Saharsa,Bihar',
'Sub Post Office,Saharsa,Bihar',
'Sub Post Office,Saharsa,Bihar',
'Branch Post Office,Saharsa,Bihar',
'Branch Post Office,Saharsa,Bihar',
'Branch Post Office,Saharsa,Bihar',
'Branch Post Office,Saharsa,Bihar',
'Branch Post Office,Saharsa,Bihar',
'Branch Post Office,Saharsa,Bihar',
'Branch Post Office,Saharsa,Bihar',
'Branch Post Office,Saharsa,Bihar',
'Branch Post Office,Saharsa,Bihar',
'Branch Post Office,Saharsa,Bihar',
'Branch Post Office,Saharsa,Bihar',
'Branch Post Office,Saharsa,Bihar',
'Branch Post Office,Saharsa,Bihar',
'Branch Post Office,Saharsa,Bihar',
'Branch Post Office,Saharsa,Bihar',
'Sub Post Office,Saharsa,Bihar',
'Branch Post Office,Saharsa,Bihar',
'Branch Post Office,Saharsa,Bihar',
'Branch Post Office,Saharsa,Bihar',
'Branch Post Office,Saharsa,Bihar',
'Branch Post Office,Saharsa,Bihar',
'Branch Post Office,Saharsa,Bihar',
'Branch Post Office,Saharsa,Bihar',
'Branch Post Office,Madhubani,Bihar',
'Branch Post Office,Saharsa,Bihar',
'Branch Post Office,Saharsa,Bihar',
'Sub Post Office,Saharsa,Bihar',
'Branch Post Office,Saharsa,Bihar',
'Branch Post Office,Saharsa,Bihar',
'Branch Post Office,Saharsa,Bihar',
'Branch Post Office,Saharsa,Bihar',
'Branch Post Office,Saharsa,Bihar',
'Branch Post Office,Madhubani,Bihar',
'Branch Post Office,Saharsa,Bihar',
'Branch Post Office,Saharsa,Bihar',
'Branch Post Office,Saharsa,Bihar',
'Branch Post Office,Saharsa,Bihar',
'Branch Post Office,Madhubani,Bihar',
'Branch Post Office,Saharsa,Bihar',
'Branch Post Office,Saharsa,Bihar',
'Branch Post Office,Saharsa,Bihar',
'Branch Post Office,Saharsa,Bihar',
'Branch Post Office,Saharsa,Bihar',
'Branch Post Office,Saharsa,Bihar',
'Branch Post Office,Saharsa,Bihar',
'Branch Post Office,Saharsa,Bihar',
'Branch Post Office,Saharsa,Bihar',
'Branch Post Office,Saharsa,Bihar',
'Branch Post Office,Saharsa,Bihar',
'Branch Post Office,Saharsa,Bihar',
'Branch Post Office,Madhubani,Bihar',
'Sub Post Office,Saharsa,Bihar',
'Sub Post Office,Saharsa,Bihar',
'Sub Post Office,Saharsa,Bihar',
'Branch Post Office,Saharsa,Bihar',
'Branch Post Office,Saharsa,Bihar',
'Branch Post Office,Saharsa,Bihar',
'Branch Post Office,Saharsa,Bihar',
'Branch Post Office,Saharsa,Bihar',
'Branch Post Office,Saharsa,Bihar',
'Branch Post Office,Saharsa,Bihar',
'Branch Post Office,Saharsa,Bihar',
'Branch Post Office,Saharsa,Bihar',
'Branch Post Office,Saharsa,Bihar',
'Branch Post Office,Saharsa,Bihar',
'Branch Post Office,Saharsa,Bihar',
'Branch Post Office,Saharsa,Bihar',
'Branch Post Office,Saharsa,Bihar',
'Branch Post Office,Saharsa,Bihar',
'Branch Post Office,Saharsa,Bihar',
'Branch Post Office,Saharsa,Bihar',
'Sub Post Office,Saharsa,Bihar',
'Branch Post Office,Saharsa,Bihar',
'Branch Post Office,Saharsa,Bihar',
'Branch Post Office,Saharsa,Bihar',
'Branch Post Office,Saharsa,Bihar',
'Branch Post Office,Saharsa,Bihar',
'Branch Post Office,Saharsa,Bihar',
'Branch Post Office,Saharsa,Bihar',
'Branch Post Office,Saharsa,Bihar',
'Branch Post Office,Saharsa,Bihar',
'Branch Post Office,Saharsa,Bihar',
'Sub Post Office,Saharsa,Bihar',
'Branch Post Office,Saharsa,Bihar',
'Branch Post Office,Vaishali,Bihar',
'Branch Post Office,Vaishali,Bihar',
'Branch Post Office,Vaishali,Bihar',
'Branch Post Office,Vaishali,Bihar',
'Branch Post Office,Vaishali,Bihar',
'Branch Post Office,Vaishali,Bihar',
'Branch Post Office,Vaishali,Bihar',
'Branch Post Office,Vaishali,Bihar',
'Branch Post Office,Vaishali,Bihar',
'Sub Post Office,Vaishali,Bihar',
'Branch Post Office,Vaishali,Bihar',
'Branch Post Office,Vaishali,Bihar',
'Branch Post Office,Vaishali,Bihar',
'Branch Post Office,Vaishali,Bihar',
'Sub Post Office,Vaishali,Bihar',
'Branch Post Office,Vaishali,Bihar',
'Branch Post Office,Vaishali,Bihar',
'Branch Post Office,Vaishali,Bihar',
'Branch Post Office,Vaishali,Bihar',
'Branch Post Office,Vaishali,Bihar',
'Sub Post Office,Vaishali,Bihar',
'Branch Post Office,Vaishali,Bihar',
'Branch Post Office,Vaishali,Bihar',
'Branch Post Office,Vaishali,Bihar',
'Branch Post Office,Vaishali,Bihar',
'Sub Post Office,Vaishali,Bihar',
'Branch Post Office,Vaishali,Bihar',
'Branch Post Office,Vaishali,Bihar',
'Branch Post Office,Vaishali,Bihar',
'Branch Post Office,Vaishali,Bihar',
'Branch Post Office,Vaishali,Bihar',
'Branch Post Office,Vaishali,Bihar',
'Sub Post Office,Vaishali,Bihar',
'Sub Post Office,Vaishali,Bihar',
'Branch Post Office,Vaishali,Bihar',
'Branch Post Office,Vaishali,Bihar',
'Sub Post Office,Vaishali,Bihar',
'Branch Post Office,Vaishali,Bihar',
'Branch Post Office,Vaishali,Bihar',
'Branch Post Office,Vaishali,Bihar',
'Branch Post Office,Vaishali,Bihar',
'Branch Post Office,Vaishali,Bihar',
'Branch Post Office,Vaishali,Bihar',
'Branch Post Office,Vaishali,Bihar',
'Branch Post Office,Vaishali,Bihar',
'Branch Post Office,Vaishali,Bihar',
'Branch Post Office,Vaishali,Bihar',
'Branch Post Office,Vaishali,Bihar',
'Branch Post Office,Vaishali,Bihar',
'Branch Post Office,Vaishali,Bihar',
'Branch Post Office,Vaishali,Bihar',
'Branch Post Office,Vaishali,Bihar',
'Branch Post Office,Vaishali,Bihar',
'Branch Post Office,Vaishali,Bihar',
'Branch Post Office,Vaishali,Bihar',
'Branch Post Office,Vaishali,Bihar',
'Branch Post Office,Vaishali,Bihar',
'Branch Post Office,Vaishali,Bihar',
'Branch Post Office,Vaishali,Bihar',
'Branch Post Office,Vaishali,Bihar',
'Branch Post Office,Vaishali,Bihar',
'Branch Post Office,Vaishali,Bihar',
'Branch Post Office,Vaishali,Bihar',
'Sub Post Office,Vaishali,Bihar',
'Branch Post Office,Vaishali,Bihar',
'Branch Post Office,Vaishali,Bihar',
'Branch Post Office,Vaishali,Bihar',
'Sub Post Office,Vaishali,Bihar',
'Sub Post Office,Vaishali,Bihar',
'Branch Post Office,Vaishali,Bihar',
'Branch Post Office,Vaishali,Bihar',
'Branch Post Office,Vaishali,Bihar',
'Branch Post Office,Vaishali,Bihar',
'Sub Post Office,Vaishali,Bihar',
'Branch Post Office,Vaishali,Bihar',
'Branch Post Office,Vaishali,Bihar',
'Branch Post Office,Vaishali,Bihar',
'Branch Post Office,Vaishali,Bihar',
'Branch Post Office,Vaishali,Bihar',
'Branch Post Office,Vaishali,Bihar',
'Branch Post Office,Vaishali,Bihar',
'Sub Post Office,Vaishali,Bihar',
'Head Post Office,Vaishali,Bihar',
'Sub Post Office,Vaishali,Bihar',
'Branch Post Office,Vaishali,Bihar',
'Branch Post Office,Vaishali,Bihar',
'Branch Post Office,Vaishali,Bihar',
'Branch Post Office,Vaishali,Bihar',
'Branch Post Office,Vaishali,Bihar',
'Branch Post Office,Vaishali,Bihar',
'Branch Post Office,Vaishali,Bihar',
'Branch Post Office,Vaishali,Bihar',
'Branch Post Office,Vaishali,Bihar',
'Branch Post Office,Vaishali,Bihar',
'Branch Post Office,Vaishali,Bihar',
'Branch Post Office,Vaishali,Bihar',
'Branch Post Office,Vaishali,Bihar',
'Branch Post Office,Vaishali,Bihar',
'Sub Post Office,Vaishali,Bihar',
'Branch Post Office,Vaishali,Bihar',
'Branch Post Office,Vaishali,Bihar',
'Branch Post Office,Vaishali,Bihar',
'Branch Post Office,Vaishali,Bihar',
'Branch Post Office,Vaishali,Bihar',
'Branch Post Office,Vaishali,Bihar',
'Branch Post Office,Vaishali,Bihar',
'Branch Post Office,Vaishali,Bihar',
'Branch Post Office,Vaishali,Bihar',
'Branch Post Office,Vaishali,Bihar',
'Branch Post Office,Vaishali,Bihar',
'Branch Post Office,Vaishali,Bihar',
'Sub Post Office,Vaishali,Bihar',
'Branch Post Office,Vaishali,Bihar',
'Branch Post Office,Vaishali,Bihar',
'Branch Post Office,Vaishali,Bihar',
'Branch Post Office,Vaishali,Bihar',
'Branch Post Office,Vaishali,Bihar',
'Branch Post Office,Vaishali,Bihar',
'Branch Post Office,Vaishali,Bihar',
'Branch Post Office,Vaishali,Bihar',
'Branch Post Office,Vaishali,Bihar',
'Branch Post Office,Vaishali,Bihar',
'Branch Post Office,Vaishali,Bihar',
'Branch Post Office,Vaishali,Bihar',
'Branch Post Office,Vaishali,Bihar',
'Branch Post Office,Vaishali,Bihar',
'Branch Post Office,Vaishali,Bihar',
'Branch Post Office,Vaishali,Bihar',
'Branch Post Office,Vaishali,Bihar',
'Branch Post Office,Vaishali,Bihar',
'Sub Post Office,Vaishali,Bihar',
'Branch Post Office,Vaishali,Bihar',
'Branch Post Office,Vaishali,Bihar',
'Branch Post Office,Vaishali,Bihar',
'Branch Post Office,Vaishali,Bihar',
'Sub Post Office,Vaishali,Bihar',
'Branch Post Office,Vaishali,Bihar',
'Branch Post Office,Vaishali,Bihar',
'Branch Post Office,Vaishali,Bihar',
'Branch Post Office,Vaishali,Bihar',
'Branch Post Office,Vaishali,Bihar',
'Branch Post Office,Vaishali,Bihar',
'Branch Post Office,Vaishali,Bihar',
'Branch Post Office,Vaishali,Bihar',
'Branch Post Office,Vaishali,Bihar',
'Sub Post Office,Vaishali,Bihar',
'Branch Post Office,Vaishali,Bihar',
'Branch Post Office,Vaishali,Bihar',
'Branch Post Office,Vaishali,Bihar',
'Branch Post Office,Vaishali,Bihar',
'Branch Post Office,Vaishali,Bihar',
'Branch Post Office,Vaishali,Bihar',
'Branch Post Office,Vaishali,Bihar',
'Branch Post Office,Vaishali,Bihar',
'Sub Post Office,Vaishali,Bihar',
'Sub Post Office,Vaishali,Bihar',
'Branch Post Office,Vaishali,Bihar',
'Branch Post Office,Vaishali,Bihar',
'Branch Post Office,Vaishali,Bihar',
'Branch Post Office,Vaishali,Bihar',
'Branch Post Office,Vaishali,Bihar',
'Branch Post Office,Vaishali,Bihar',
'Branch Post Office,Vaishali,Bihar',
'Sub Post Office,Vaishali,Bihar',
'Branch Post Office,Vaishali,Bihar',
'Sub Post Office,Vaishali,Bihar',
'Branch Post Office,Vaishali,Bihar',
'Branch Post Office,Vaishali,Bihar',
'Branch Post Office,Vaishali,Bihar',
'Branch Post Office,Vaishali,Bihar',
'Branch Post Office,Vaishali,Bihar',
'Branch Post Office,Vaishali,Bihar',
'Branch Post Office,Vaishali,Bihar',
'Branch Post Office,Vaishali,Bihar',
'Branch Post Office,Vaishali,Bihar',
'Branch Post Office,Vaishali,Bihar',
'Branch Post Office,Vaishali,Bihar',
'Sub Post Office,Vaishali,Bihar',
'Branch Post Office,Vaishali,Bihar',
'Branch Post Office,Vaishali,Bihar',
'Branch Post Office,Vaishali,Bihar',
'Branch Post Office,Vaishali,Bihar',
'Branch Post Office,Vaishali,Bihar',
'Branch Post Office,Vaishali,Bihar',
'Branch Post Office,Vaishali,Bihar',
'Branch Post Office,Vaishali,Bihar',
'Sub Post Office,Vaishali,Bihar',
'Branch Post Office,Vaishali,Bihar',
'Branch Post Office,Vaishali,Bihar',
'Branch Post Office,Vaishali,Bihar',
'Branch Post Office,Vaishali,Bihar',
'Branch Post Office,Vaishali,Bihar',
'Branch Post Office,Vaishali,Bihar',
'Branch Post Office,Vaishali,Bihar',
'Branch Post Office,Vaishali,Bihar',
'Sub Post Office,Vaishali,Bihar',
'Branch Post Office,Vaishali,Bihar',
'Branch Post Office,Vaishali,Bihar',
'Branch Post Office,Vaishali,Bihar',
'Branch Post Office,Vaishali,Bihar',
'Branch Post Office,Vaishali,Bihar',
'Branch Post Office,Vaishali,Bihar',
'Branch Post Office,Vaishali,Bihar',
'Sub Post Office,Vaishali,Bihar',
'Branch Post Office,Vaishali,Bihar',
'Branch Post Office,Vaishali,Bihar',
'Branch Post Office,Vaishali,Bihar',
'Branch Post Office,Vaishali,Bihar',
'Sub Post Office,Vaishali,Bihar',
'Branch Post Office,Vaishali,Bihar',
'Branch Post Office,Vaishali,Bihar',
'Branch Post Office,Vaishali,Bihar',
'Branch Post Office,Vaishali,Bihar',
'Branch Post Office,Vaishali,Bihar',
'Branch Post Office,Vaishali,Bihar',
'Branch Post Office,Vaishali,Bihar',
'Branch Post Office,Vaishali,Bihar',
'Branch Post Office,Vaishali,Bihar',
'Branch Post Office,Vaishali,Bihar',
'Branch Post Office,Vaishali,Bihar',
'Sub Post Office,Vaishali,Bihar',
'Branch Post Office,Vaishali,Bihar',
'Branch Post Office,Vaishali,Bihar',
'Branch Post Office,Vaishali,Bihar',
'Branch Post Office,Vaishali,Bihar',
'Branch Post Office,Vaishali,Bihar',
'Branch Post Office,Vaishali,Bihar',
'Branch Post Office,Vaishali,Bihar',
'Branch Post Office,Vaishali,Bihar',
'Branch Post Office,Vaishali,Bihar',
'Branch Post Office,Vaishali,Bihar',
'Sub Post Office,Vaishali,Bihar',
'Branch Post Office,Vaishali,Bihar',
'Branch Post Office,Vaishali,Bihar',
'Branch Post Office,Vaishali,Bihar',
'Sub Post Office,Vaishali,Bihar',
'Branch Post Office,Vaishali,Bihar',
'Branch Post Office,Vaishali,Bihar',
'Branch Post Office,Vaishali,Bihar',
'Branch Post Office,Vaishali,Bihar',
'Branch Post Office,Vaishali,Bihar',
'Branch Post Office,Vaishali,Bihar',
'Branch Post Office,Vaishali,Bihar',
'Branch Post Office,Vaishali,Bihar',
'Branch Post Office,Vaishali,Bihar',
'Branch Post Office,Vaishali,Bihar',
'Branch Post Office,Vaishali,Bihar',
'Branch Post Office,Vaishali,Bihar',
'Branch Post Office,Vaishali,Bihar',
'Branch Post Office,Vaishali,Bihar',
'Branch Post Office,Vaishali,Bihar',
'Branch Post Office,Vaishali,Bihar',
'Branch Post Office,Vaishali,Bihar',
'Branch Post Office,Vaishali,Bihar',
'Branch Post Office,Vaishali,Bihar',
'Branch Post Office,Vaishali,Bihar',
'Branch Post Office,Vaishali,Bihar',
'Sub Post Office,Vaishali,Bihar',
'Branch Post Office,Vaishali,Bihar',
'Branch Post Office,Vaishali,Bihar',
'Branch Post Office,Vaishali,Bihar',
'Branch Post Office,Vaishali,Bihar',
'Sub Post Office,Vaishali,Bihar',
'Branch Post Office,Vaishali,Bihar',
'Branch Post Office,Vaishali,Bihar',
'Branch Post Office,Vaishali,Bihar',
'Branch Post Office,Vaishali,Bihar',
'Branch Post Office,Vaishali,Bihar',
'Branch Post Office,Vaishali,Bihar',
'Branch Post Office,Vaishali,Bihar',
'Branch Post Office,Vaishali,Bihar',
'Branch Post Office,Vaishali,Bihar',
'Sub Post Office,Vaishali,Bihar',
'Sub Post Office,West Champaran,Bihar',
'Branch Post Office,West Champaran,Bihar',
'Branch Post Office,West Champaran,Bihar',
'Branch Post Office,West Champaran,Bihar',
'Branch Post Office,West Champaran,Bihar',
'Branch Post Office,West Champaran,Bihar',
'Branch Post Office,West Champaran,Bihar',
'Branch Post Office,West Champaran,Bihar',
'Branch Post Office,West Champaran,Bihar',
'Branch Post Office,West Champaran,Bihar',
'Branch Post Office,West Champaran,Bihar',
'Branch Post Office,West Champaran,Bihar',
'Branch Post Office,West Champaran,Bihar',
'Branch Post Office,West Champaran,Bihar',
'Branch Post Office,West Champaran,Bihar',
'Branch Post Office,West Champaran,Bihar',
'Branch Post Office,West Champaran,Bihar',
'Branch Post Office,West Champaran,Bihar',
'Branch Post Office,West Champaran,Bihar',
'Branch Post Office,West Champaran,Bihar',
'Branch Post Office,West Champaran,Bihar',
'Branch Post Office,West Champaran,Bihar',
'Branch Post Office,West Champaran,Bihar',
'Branch Post Office,West Champaran,Bihar',
'Branch Post Office,West Champaran,Bihar',
'Branch Post Office,West Champaran,Bihar',
'Branch Post Office,West Champaran,Bihar',
'Branch Post Office,West Champaran,Bihar',
'Branch Post Office,West Champaran,Bihar',
'Branch Post Office,West Champaran,Bihar',
'Branch Post Office,West Champaran,Bihar',
'Branch Post Office,West Champaran,Bihar',
'Branch Post Office,West Champaran,Bihar',
'Branch Post Office,West Champaran,Bihar',
'Branch Post Office,West Champaran,Bihar',
'Branch Post Office,West Champaran,Bihar',
'Sub Post Office,West Champaran,Bihar',
'Branch Post Office,West Champaran,Bihar',
'Branch Post Office,West Champaran,Bihar',
'Branch Post Office,West Champaran,Bihar',
'Branch Post Office,West Champaran,Bihar',
'Sub Post Office,West Champaran,Bihar',
'Branch Post Office,West Champaran,Bihar',
'Head Post Office,West Champaran,Bihar',
'Sub Post Office,West Champaran,Bihar',
'Branch Post Office,West Champaran,Bihar',
'Branch Post Office,West Champaran,Bihar',
'Branch Post Office,West Champaran,Bihar',
'Branch Post Office,West Champaran,Bihar',
'Branch Post Office,West Champaran,Bihar',
'Branch Post Office,West Champaran,Bihar',
'Branch Post Office,West Champaran,Bihar',
'Branch Post Office,West Champaran,Bihar',
'Branch Post Office,West Champaran,Bihar',
'Branch Post Office,West Champaran,Bihar',
'Branch Post Office,West Champaran,Bihar',
'Branch Post Office,West Champaran,Bihar',
'Branch Post Office,West Champaran,Bihar',
'Branch Post Office,West Champaran,Bihar',
'Branch Post Office,West Champaran,Bihar',
'Branch Post Office,West Champaran,Bihar',
'Branch Post Office,West Champaran,Bihar',
'Branch Post Office,West Champaran,Bihar',
'Branch Post Office,West Champaran,Bihar',
'Branch Post Office,West Champaran,Bihar',
'Branch Post Office,West Champaran,Bihar',
'Branch Post Office,West Champaran,Bihar',
'Branch Post Office,West Champaran,Bihar',
'Sub Post Office,West Champaran,Bihar',
'Sub Post Office,West Champaran,Bihar',
'Branch Post Office,West Champaran,Bihar',
'Branch Post Office,West Champaran,Bihar',
'Branch Post Office,West Champaran,Bihar',
'Branch Post Office,West Champaran,Bihar',
'Sub Post Office,West Champaran,Bihar',
'Sub Post Office,West Champaran,Bihar',
'Branch Post Office,West Champaran,Bihar',
'Branch Post Office,West Champaran,Bihar',
'Branch Post Office,West Champaran,Bihar',
'Branch Post Office,West Champaran,Bihar',
'Branch Post Office,West Champaran,Bihar',
'Branch Post Office,West Champaran,Bihar',
'Branch Post Office,West Champaran,Bihar',
'Branch Post Office,West Champaran,Bihar',
'Branch Post Office,West Champaran,Bihar',
'Branch Post Office,West Champaran,Bihar',
'Branch Post Office,West Champaran,Bihar',
'Branch Post Office,West Champaran,Bihar',
'Branch Post Office,West Champaran,Bihar',
'Branch Post Office,West Champaran,Bihar',
'Branch Post Office,West Champaran,Bihar',
'Branch Post Office,West Champaran,Bihar',
'Branch Post Office,West Champaran,Bihar',
'Branch Post Office,West Champaran,Bihar',
'Sub Post Office,West Champaran,Bihar',
'Branch Post Office,West Champaran,Bihar',
'Branch Post Office,West Champaran,Bihar',
'Branch Post Office,West Champaran,Bihar',
'Branch Post Office,West Champaran,Bihar',
'Branch Post Office,West Champaran,Bihar',
'Branch Post Office,West Champaran,Bihar',
'Branch Post Office,West Champaran,Bihar',
'Branch Post Office,West Champaran,Bihar',
'Branch Post Office,West Champaran,Bihar',
'Branch Post Office,West Champaran,Bihar',
'Branch Post Office,West Champaran,Bihar',
'Branch Post Office,West Champaran,Bihar',
'Sub Post Office,West Champaran,Bihar',
'Branch Post Office,West Champaran,Bihar',
'Branch Post Office,West Champaran,Bihar',
'Branch Post Office,West Champaran,Bihar',
'Branch Post Office,West Champaran,Bihar',
'Branch Post Office,West Champaran,Bihar',
'Branch Post Office,West Champaran,Bihar',
'Branch Post Office,West Champaran,Bihar',
'Branch Post Office,West Champaran,Bihar',
'Sub Post Office,West Champaran,Bihar',
'Branch Post Office,West Champaran,Bihar',
'Branch Post Office,West Champaran,Bihar',
'Branch Post Office,West Champaran,Bihar',
'Branch Post Office,West Champaran,Bihar',
'Branch Post Office,West Champaran,Bihar',
'Branch Post Office,West Champaran,Bihar',
'Sub Post Office,West Champaran,Bihar',
'Branch Post Office,West Champaran,Bihar',
'Branch Post Office,West Champaran,Bihar',
'Branch Post Office,West Champaran,Bihar',
'Branch Post Office,West Champaran,Bihar',
'Branch Post Office,West Champaran,Bihar',
'Branch Post Office,West Champaran,Bihar',
'Branch Post Office,West Champaran,Bihar',
'Branch Post Office,West Champaran,Bihar',
'Branch Post Office,West Champaran,Bihar',
'Branch Post Office,West Champaran,Bihar',
'Branch Post Office,West Champaran,Bihar',
'Branch Post Office,West Champaran,Bihar',
'Branch Post Office,West Champaran,Bihar',
'Branch Post Office,West Champaran,Bihar',
'Branch Post Office,West Champaran,Bihar',
'Sub Post Office,West Champaran,Bihar',
'Branch Post Office,West Champaran,Bihar',
'Branch Post Office,West Champaran,Bihar',
'Branch Post Office,West Champaran,Bihar',
'Sub Post Office,West Champaran,Bihar',
'Branch Post Office,West Champaran,Bihar',
'Branch Post Office,West Champaran,Bihar',
'Branch Post Office,West Champaran,Bihar',
'Branch Post Office,West Champaran,Bihar',
'Branch Post Office,West Champaran,Bihar',
'Sub Post Office,West Champaran,Bihar',
'Branch Post Office,West Champaran,Bihar',
'Branch Post Office,West Champaran,Bihar',
'Branch Post Office,West Champaran,Bihar',
'Sub Post Office,West Champaran,Bihar',
'Branch Post Office,West Champaran,Bihar',
'Branch Post Office,West Champaran,Bihar',
'Branch Post Office,West Champaran,Bihar',
'Sub Post Office,West Champaran,Bihar',
'Branch Post Office,West Champaran,Bihar',
'Branch Post Office,West Champaran,Bihar',
'Branch Post Office,West Champaran,Bihar',
'Branch Post Office,West Champaran,Bihar',
'Branch Post Office,West Champaran,Bihar',
'Branch Post Office,West Champaran,Bihar',
'Branch Post Office,West Champaran,Bihar',
'Branch Post Office,West Champaran,Bihar',
'Branch Post Office,West Champaran,Bihar',
'Branch Post Office,West Champaran,Bihar',
'Branch Post Office,West Champaran,Bihar',
'Branch Post Office,West Champaran,Bihar',
'Sub Post Office,West Champaran,Bihar',
'Branch Post Office,West Champaran,Bihar',
'Branch Post Office,West Champaran,Bihar',
'Branch Post Office,West Champaran,Bihar',
'Branch Post Office,West Champaran,Bihar',
'Branch Post Office,West Champaran,Bihar',
'Branch Post Office,West Champaran,Bihar',
'Branch Post Office,West Champaran,Bihar',
'Branch Post Office,West Champaran,Bihar',
'Sub Post Office,West Champaran,Bihar',
'Sub Post Office,West Champaran,Bihar',
'Branch Post Office,West Champaran,Bihar',
'Branch Post Office,West Champaran,Bihar',
'Branch Post Office,West Champaran,Bihar',
'Branch Post Office,West Champaran,Bihar',
'Sub Post Office,West Champaran,Bihar',
'Branch Post Office,West Champaran,Bihar',
'Branch Post Office,West Champaran,Bihar',
'Branch Post Office,West Champaran,Bihar',
'Branch Post Office,West Champaran,Bihar',
'Branch Post Office,West Champaran,Bihar',
'Branch Post Office,West Champaran,Bihar',
'Branch Post Office,West Champaran,Bihar',
'Branch Post Office,West Champaran,Bihar',
'Branch Post Office,West Champaran,Bihar',
'Branch Post Office,West Champaran,Bihar',
'Branch Post Office,West Champaran,Bihar',
'Branch Post Office,West Champaran,Bihar',
'Branch Post Office,West Champaran,Bihar',
'Branch Post Office,West Champaran,Bihar',
'Branch Post Office,West Champaran,Bihar',
'Branch Post Office,West Champaran,Bihar',
'Branch Post Office,West Champaran,Bihar',
'Branch Post Office,West Champaran,Bihar',
'Branch Post Office,West Champaran,Bihar',
'Branch Post Office,West Champaran,Bihar',
'Branch Post Office,West Champaran,Bihar',
'Branch Post Office,West Champaran,Bihar',
'Branch Post Office,West Champaran,Bihar',
'Sub Post Office,West Champaran,Bihar',
'Branch Post Office,West Champaran,Bihar',
'Branch Post Office,West Champaran,Bihar',
'Branch Post Office,West Champaran,Bihar',
'Branch Post Office,West Champaran,Bihar',
'Branch Post Office,West Champaran,Bihar',
'Branch Post Office,West Champaran,Bihar',
'Branch Post Office,West Champaran,Bihar',
'Branch Post Office,West Champaran,Bihar',
'Branch Post Office,West Champaran,Bihar',
'Branch Post Office,West Champaran,Bihar',
'Branch Post Office,West Champaran,Bihar',
'Branch Post Office,West Champaran,Bihar',
'Branch Post Office,West Champaran,Bihar',
'Branch Post Office,West Champaran,Bihar',
'Branch Post Office,West Champaran,Bihar',
'Branch Post Office,West Champaran,Bihar',
'Branch Post Office,West Champaran,Bihar',
'Branch Post Office,West Champaran,Bihar',
'Branch Post Office,West Champaran,Bihar',
'Branch Post Office,West Champaran,Bihar',
'Branch Post Office,West Champaran,Bihar',
'Branch Post Office,West Champaran,Bihar',
'Branch Post Office,West Champaran,Bihar',
'Branch Post Office,West Champaran,Bihar',
'Branch Post Office,West Champaran,Bihar',
'Branch Post Office,West Champaran,Bihar',
'Branch Post Office,West Champaran,Bihar',
'Branch Post Office,West Champaran,Bihar',
'Branch Post Office,West Champaran,Bihar',
'Branch Post Office,West Champaran,Bihar',
'Branch Post Office,West Champaran,Bihar',
'Branch Post Office,West Champaran,Bihar',
'Branch Post Office,West Champaran,Bihar',
'Branch Post Office,West Champaran,Bihar',
'Sub Post Office,West Champaran,Bihar',
'Branch Post Office,West Champaran,Bihar',
'Branch Post Office,West Champaran,Bihar',
'Branch Post Office,West Champaran,Bihar',
'Branch Post Office,West Champaran,Bihar',
'Branch Post Office,West Champaran,Bihar',
'Branch Post Office,West Champaran,Bihar',
'Branch Post Office,West Champaran,Bihar',
'Branch Post Office,West Champaran,Bihar',
'Branch Post Office,West Champaran,Bihar',
'Branch Post Office,West Champaran,Bihar',
'Branch Post Office,West Champaran,Bihar',
'Branch Post Office,West Champaran,Bihar',
'Branch Post Office,West Champaran,Bihar',
'Branch Post Office,West Champaran,Bihar',
'Branch Post Office,West Champaran,Bihar',
'Branch Post Office,West Champaran,Bihar',
'Branch Post Office,West Champaran,Bihar',
'Branch Post Office,West Champaran,Bihar',
'Branch Post Office,West Champaran,Bihar',
'Branch Post Office,West Champaran,Bihar',
'Branch Post Office,West Champaran,Bihar',
'Branch Post Office,West Champaran,Bihar',
'Branch Post Office,West Champaran,Bihar',
'Branch Post Office,West Champaran,Bihar',
'Branch Post Office,West Champaran,Bihar',
'Sub Post Office,West Champaran,Bihar',
'Branch Post Office,West Champaran,Bihar',
'Branch Post Office,West Champaran,Bihar',
'Sector 21 (Chandigarh),Chandigarh,Chandigarh',
'Sector 21 (Chandigarh),Chandigarh,Chandigarh',
'Sector 21 (Chandigarh),Chandigarh,Chandigarh',
'Sector 21 (Chandigarh),Chandigarh,Chandigarh',
'Sector 21 (Chandigarh),Chandigarh,Chandigarh',
'Sector 21 (Chandigarh),Chandigarh,Chandigarh',
'Sector 21 (Chandigarh),Chandigarh,Chandigarh',
'Sector 21 (Chandigarh),Chandigarh,Chandigarh',
'Sector 21 (Chandigarh),Chandigarh,Chandigarh',
'Sector 21 (Chandigarh),Chandigarh,Chandigarh',
'Sector 21 (Chandigarh),Chandigarh,Chandigarh',
'Sector 21 (Chandigarh),Chandigarh,Chandigarh',
'Sector 21 (Chandigarh),Chandigarh,Chandigarh',
'Sector 21 (Chandigarh),Chandigarh,Chandigarh',
'Sector 21 (Chandigarh),Chandigarh,Chandigarh',
'Sector 21 (Chandigarh),Chandigarh,Chandigarh',
'Sector 21 (Chandigarh),Chandigarh,Chandigarh',
'Sector 21 (Chandigarh),Chandigarh,Chandigarh',
'Sector 21 (Chandigarh),Chandigarh,Chandigarh',
'Sector 21 (Chandigarh),Chandigarh,Chandigarh',
'Sector 21 (Chandigarh),Chandigarh,Chandigarh',
'Adawal,Bastar,Chattisgarh',
'Amaguda,Bastar,Chattisgarh',
'Asna,Bastar,Chattisgarh',
'Babusemra,Bastar,Chattisgarh',
'Badanji,Bastar,Chattisgarh',
'Badeamabal,Bastar,Chattisgarh',
'Badebodenar,Bastar,Chattisgarh',
'Badechakwa,Bastar,Chattisgarh',
'Badedeoda,Bastar,Chattisgarh',
'Badedharaur,Bastar,Chattisgarh',
'Badekakloor,Bastar,Chattisgarh',
'Badekilepal,Bastar,Chattisgarh',
'Bademurma,Bastar,Chattisgarh',
'Baghmohlai,Bastar,Chattisgarh',
'Bajawand,Bastar,Chattisgarh',
'Bakawand,Bastar,Chattisgarh',
'Baniyagaon,Bastar,Chattisgarh',
'Barda,Bastar,Chattisgarh',
'Bastanar,Bastar,Chattisgarh',
'Bastar,Bastar,Chattisgarh',
'Belar,Bastar,Chattisgarh',
'Bhainsgaon,Bastar,Chattisgarh',
'Bhanpuri Basti,Bastar,Chattisgarh',
'Bhanpuri,Bastar,Chattisgarh',
'Binta,Bastar,Chattisgarh',
'Burdi,Bastar,Chattisgarh',
'Chapka,Bastar,Chattisgarh',
'Chhaparbhanpuri,Bastar,Chattisgarh',
'Chingpal,Bastar,Chattisgarh',
'Chitaloor,Bastar,Chattisgarh',
'Chitapur,Bastar,Chattisgarh',
'Chitrakote,Bastar,Chattisgarh',
'Chiurgaon,Bastar,Chattisgarh',
'Chokar,Bastar,Chattisgarh',
'Chotedeoda,Bastar,Chattisgarh',
'Dhanpunji,Bastar,Chattisgarh',
'Dharampura,Bastar,Chattisgarh',
'Dilmili,Bastar,Chattisgarh',
'Dimrapal,Bastar,Chattisgarh',
'Dubeumargaon,Bastar,Chattisgarh',
'Ermur,Bastar,Chattisgarh',
'Errakot,Bastar,Chattisgarh',
'Gadhiya,Bastar,Chattisgarh',
'Garda,Bastar,Chattisgarh',
'Garenga,Bastar,Chattisgarh',
'Ghotia,Bastar,Chattisgarh',
'Guria,Bastar,Chattisgarh',
'Hatkachora,Bastar,Chattisgarh',
'Iti Bastar,Bastar,Chattisgarh',
'Jagdalpur H.O,Bastar,Chattisgarh',
'Jagdalpur Kutchery,Bastar,Chattisgarh',
'Jagdalpur Rly Colony,Bastar,Chattisgarh',
'Jagdalpur Sadar Bzr,Bastar,Chattisgarh',
'Jaibel,Bastar,Chattisgarh',
'Jaitgiri,Bastar,Chattisgarh',
'Kachnar,Bastar,Chattisgarh',
'Kaknar,Bastar,Chattisgarh',
'Karanji,Bastar,Chattisgarh',
'Karitgaon,Bastar,Chattisgarh',
'Karpawand,Bastar,Chattisgarh',
'Kesarpal,Bastar,Chattisgarh',
'Khorkosa,Bastar,Chattisgarh',
'Kinjoli,Bastar,Chattisgarh',
'Kodenar,Bastar,Chattisgarh',
'Kohkapal,Bastar,Chattisgarh',
'Kolawali,Bastar,Chattisgarh',
'Kolchur,Bastar,Chattisgarh',
'Korta,Bastar,Chattisgarh',
'Kumhali,Bastar,Chattisgarh',
'Kumharawand,Bastar,Chattisgarh',
'Kumharsandra,Bastar,Chattisgarh',
'Kumhli,Bastar,Chattisgarh',
'Kurandi,Bastar,Chattisgarh',
'Kurenga,Bastar,Chattisgarh',
'Kuruspal,Bastar,Chattisgarh',
'Kuthar,Bastar,Chattisgarh',
'Lamker,Bastar,Chattisgarh',
'Lohandiguda,Bastar,Chattisgarh',
'Madhota,Bastar,Chattisgarh',
'Madlapal,Bastar,Chattisgarh',
'Madpal,Bastar,Chattisgarh',
'Malgaon,Bastar,Chattisgarh',
'Mangnar,Bastar,Chattisgarh',
'Mardum,Bastar,Chattisgarh',
'Markel,Bastar,Chattisgarh',
'Matnar,Bastar,Chattisgarh',
'Matnar,Bastar,Chattisgarh',
'Michnar,Bastar,Chattisgarh',
'Mohlai,Bastar,Chattisgarh',
'Mongrapal,Bastar,Chattisgarh',
'Muli,Bastar,Chattisgarh',
'Mundagaon,Bastar,Chattisgarh',
'Mutanpal,Bastar,Chattisgarh',
'Nagarnaar,Bastar,Chattisgarh',
'Nalpawand,Bastar,Chattisgarh',
'Nangur,Bastar,Chattisgarh',
'Narayanpal,Bastar,Chattisgarh',
'Neganar,Bastar,Chattisgarh',
'Netanaar,Bastar,Chattisgarh',
'Niyanaar,Bastar,Chattisgarh',
'Pahurbel,Bastar,Chattisgarh',
'Pandripani,Bastar,Chattisgarh',
'Parapur,Bastar,Chattisgarh',
'Puspal,Bastar,Chattisgarh',
'Raikot,Bastar,Chattisgarh',
'Rajnagar,Bastar,Chattisgarh',
'Ratenga,Bastar,Chattisgarh',
'Retawand,Bastar,Chattisgarh',
'Rotma,Bastar,Chattisgarh',
'Sadgud,Bastar,Chattisgarh',
'Salemeta,Bastar,Chattisgarh',
'Sandkarmari,Bastar,Chattisgarh',
'Sargipal,Bastar,Chattisgarh',
'Satosa,Bastar,Chattisgarh',
'Seoni,Bastar,Chattisgarh',
'Singanpur,Bastar,Chattisgarh',
'Sirisguda,Bastar,Chattisgarh',
'Sonarpal,Bastar,Chattisgarh',
'Sonpur,Bastar,Chattisgarh',
'Sorgaon,Bastar,Chattisgarh',
'Sudhapal,Bastar,Chattisgarh',
'Talnar,Bastar,Chattisgarh',
'Talur,Bastar,Chattisgarh',
'Taragaon,Bastar,Chattisgarh',
'Tarapur,Bastar,Chattisgarh',
'Telemarenga,Bastar,Chattisgarh',
'Titirgaon,Bastar,Chattisgarh',
'Tokapal Rajoor,Bastar,Chattisgarh',
'Usari,Bastar,Chattisgarh',
'Adenga,Bastar,Chattisgarh',
'Alor,Bastar,Chattisgarh',
'Amabeda,Bastar,Chattisgarh',
'Arandi,Bastar,Chattisgarh',
'Arra,Bastar,Chattisgarh',
'Badagaon,Bastar,Chattisgarh',
'Bade Rajpur,Bastar,Chattisgarh',
'Badedongar,Bastar,Chattisgarh',
'Badekhauli,Bastar,Chattisgarh',
'Bangaon,Bastar,Chattisgarh',
'Banjoda,Bastar,Chattisgarh',
'Banskote,Bastar,Chattisgarh',
'Barkai,Bastar,Chattisgarh',
'Bhandarseoni,Bastar,Chattisgarh',
'Bhanpuri,Bastar,Chattisgarh',
'Binjhe,Bastar,Chattisgarh',
'Cherbeda,Bastar,Chattisgarh',
'Choteodagaon,Bastar,Chattisgarh',
'Dhanora,Bastar,Chattisgarh',
'Eragaon,Bastar,Chattisgarh',
'Ghutkel,Bastar,Chattisgarh',
'Hirri,Bastar,Chattisgarh',
'Jodekera,Bastar,Chattisgarh',
'Juganikalar,Bastar,Chattisgarh',
'Kaurgaon,Bastar,Chattisgarh',
'Keshkal,Bastar,Chattisgarh',
'Khalari,Bastar,Chattisgarh',
'Khetarpal,Bastar,Chattisgarh',
'Kohkameta,Bastar,Chattisgarh',
'Kongud,Bastar,Chattisgarh',
'Kopra,Bastar,Chattisgarh',
'Kotpad,Bastar,Chattisgarh',
'Lihagaon,Bastar,Chattisgarh',
'Lubha,Bastar,Chattisgarh',
'Manghiatgaon,Bastar,Chattisgarh',
'Marangpuri,Bastar,Chattisgarh',
'Nagarbeda,Bastar,Chattisgarh',
'Piprabahigaon,Bastar,Chattisgarh',
'Piprakhas,Bastar,Chattisgarh',
'Randhna,Bastar,Chattisgarh',
'Salna,Bastar,Chattisgarh',
'Sawala,Bastar,Chattisgarh',
'Sikagaon,Bastar,Chattisgarh',
'Singanpur,Bastar,Chattisgarh',
'Taraibeda,Bastar,Chattisgarh',
'Tenwsa,Bastar,Chattisgarh',
'Titirwand,Bastar,Chattisgarh',
'Todasi,Bastar,Chattisgarh',
'Urandabeda,Bastar,Chattisgarh',
'Useli,Bastar,Chattisgarh',
'Vishrampuri,Bastar,Chattisgarh',
'Babai,Bastar,Chattisgarh',
'Badekanera,Bastar,Chattisgarh',
'Bafna,Bastar,Chattisgarh',
'Bamni Bazar,Bastar,Chattisgarh',
'Baniyagaon,Bastar,Chattisgarh',
'Banjugani,Bastar,Chattisgarh',
'Bayanar,Bastar,Chattisgarh',
'Bijapur,Bastar,Chattisgarh',
'Bunagaon,Bastar,Chattisgarh',
'Chema,Bastar,Chattisgarh',
'Chhinari,Bastar,Chattisgarh',
'Chipawand,Bastar,Chattisgarh',
'Dahikonga,Bastar,Chattisgarh',
'Dharli,Bastar,Chattisgarh',
'Dnk Colony,Bastar,Chattisgarh',
'Girola,Bastar,Chattisgarh',
'Golawand,Bastar,Chattisgarh',
'Heerapur,Bastar,Chattisgarh',
'Jaitpuri,Bastar,Chattisgarh',
'Joba,Bastar,Chattisgarh',
'Kerawahi,Bastar,Chattisgarh',
'Kibaibalenga,Bastar,Chattisgarh',
'Kokodi,Bastar,Chattisgarh',
'Kondagaon Naka,Bastar,Chattisgarh',
'Kondagaon,Bastar,Chattisgarh',
'Kongera,Bastar,Chattisgarh',
'Lanjoda,Bastar,Chattisgarh',
'Makdi,Bastar,Chattisgarh',
'Malakot,Bastar,Chattisgarh',
'Malgaon,Bastar,Chattisgarh',
'Mardapal,Bastar,Chattisgarh',
'Matwal,Bastar,Chattisgarh',
'Mohlai,Bastar,Chattisgarh',
'Mulmula,Bastar,Chattisgarh',
'Otenda,Bastar,Chattisgarh',
'Palari,Bastar,Chattisgarh',
'Pharasgaon Camp,Bastar,Chattisgarh',
'Pharasgaon,Bastar,Chattisgarh',
'Shampur,Bastar,Chattisgarh',
'Sonabal,Bastar,Chattisgarh',
'Umargaon,Bastar,Chattisgarh',
'Gadiras,Bastar,Chattisgarh',
'Atukpalli,Bastar,Chattisgarh',
'Awapalli,Bastar,Chattisgarh',
'Bareguda,Bastar,Chattisgarh',
'Basaguda,Bastar,Chattisgarh',
'Bhopalpatnam,Bastar,Chattisgarh',
'Chandangiri,Bastar,Chattisgarh',
'Chandur,Bastar,Chattisgarh',
'Cherpalli,Bastar,Chattisgarh',
'Chinnakawali,Bastar,Chattisgarh',
'Dharmaram,Bastar,Chattisgarh',
'Dudheda (Kottaguda),Bastar,Chattisgarh',
'Elmidi,Bastar,Chattisgarh',
'Kandulnar,Bastar,Chattisgarh',
'Kottaguda,Bastar,Chattisgarh',
'Madded,Bastar,Chattisgarh',
'Mallepalli,Bastar,Chattisgarh',
'Marudbaka,Bastar,Chattisgarh',
'Munjalkanker,Bastar,Chattisgarh',
'Murdanda,Bastar,Chattisgarh',
'Pakela,Bastar,Chattisgarh',
'Pamed,Bastar,Chattisgarh',
'Pamgal,Bastar,Chattisgarh',
'Pujarikanker,Bastar,Chattisgarh',
'Pusbaka,Bastar,Chattisgarh',
'Pusgudi,Bastar,Chattisgarh',
'Rudraram,Bastar,Chattisgarh',
'Sankanpalli,Bastar,Chattisgarh',
'Tarlaguda,Bastar,Chattisgarh',
'Tekmetla,Bastar,Chattisgarh',
'Timed,Bastar,Chattisgarh',
'Usoor,Bastar,Chattisgarh',
'Badekakler,Bastar,Chattisgarh',
'Bhairamgarh,Bastar,Chattisgarh',
'Bijapur,Bastar,Chattisgarh',
'Cherpal,Bastar,Chattisgarh',
'Dhanora,Bastar,Chattisgarh',
'Etpal,Bastar,Chattisgarh',
'Gangaloor,Bastar,Chattisgarh',
'Gudma,Bastar,Chattisgarh',
'Kaika,Bastar,Chattisgarh',
'Karkeli,Bastar,Chattisgarh',
'Kutru,Bastar,Chattisgarh',
'Lanka,Bastar,Chattisgarh',
'Matwada,Bastar,Chattisgarh',
'Nemed,Bastar,Chattisgarh',
'Padeda,Bastar,Chattisgarh',
'Pharsegarh,Bastar,Chattisgarh',
'Pidiya,Bastar,Chattisgarh',
'Pusnar,Bastar,Chattisgarh',
'Ranibodli,Bastar,Chattisgarh',
'Sagmeta,Bastar,Chattisgarh',
'Sandra,Bastar,Chattisgarh',
'Toynar,Bastar,Chattisgarh',
'Tumnar,Bastar,Chattisgarh',
'Etepal,Bastar,Chattisgarh',
'Ujwal Nagar,Bilaspur,Chattisgarh',
'Chhatauna,Bilaspur,Chattisgarh',
'Kenda,Bilaspur,Chattisgarh',
'Khairjhiti,Bilaspur,Chattisgarh',
'Khongsara,Bilaspur,Chattisgarh',
'Majhgaon,Bilaspur,Chattisgarh',
'Majhwani,Bilaspur,Chattisgarh',
'Mithunawagaon,Bilaspur,Chattisgarh',
'Pudu,Bilaspur,Chattisgarh',
'Semariya,Bilaspur,Chattisgarh',
'Tenganmada,Bilaspur,Chattisgarh',
'Umariyadadar,Bilaspur,Chattisgarh',
'Bahtarai,Bilaspur,Chattisgarh',
'Baimanagoi,Bilaspur,Chattisgarh',
'Bilaspur H.O,Bilaspur,Chattisgarh',
'Bilaspur Industrial Estate,Bilaspur,Chattisgarh',
'Bilaspur Kutchery,Bilaspur,Chattisgarh',
'Bilaspur R.S.,Bilaspur,Chattisgarh',
'Chantidih,Bilaspur,Chattisgarh',
'Cmd College Bilaspur,Bilaspur,Chattisgarh',
'Deorikhurd,Bilaspur,Chattisgarh',
'Dhuma,Bilaspur,Chattisgarh',
'Girdhauna,Bilaspur,Chattisgarh',
'Gole Bazar Bilaspur,Bilaspur,Chattisgarh',
'Harditonakala,Bilaspur,Chattisgarh',
'High Court Bilaspur,Bilaspur,Chattisgarh',
'Juna Bilaspur,Bilaspur,Chattisgarh',
'Kathakoni,Bilaspur,Chattisgarh',
'Kilaward Bilaspur,Bilaspur,Chattisgarh',
'Koni,Bilaspur,Chattisgarh',
'Mangla,Bilaspur,Chattisgarh',
'Mochh,Bilaspur,Chattisgarh',
'Mopka,Bilaspur,Chattisgarh',
'Pandhi,Bilaspur,Chattisgarh',
'Ramdas Nagar,Bilaspur,Chattisgarh',
'Saida,Bilaspur,Chattisgarh',
'Sakri,Bilaspur,Chattisgarh',
'Sarkanda Bilaspur,Bilaspur,Chattisgarh',
'Secl Bilaspur,Bilaspur,Chattisgarh',
'Sirgitti,Bilaspur,Chattisgarh',
'Spinning Mills Bilaspur,Bilaspur,Chattisgarh',
'Torwa,Bilaspur,Chattisgarh',
'Urtum,Bilaspur,Chattisgarh',
'Anda,Bilaspur,Chattisgarh',
'Badrathakur,Bilaspur,Chattisgarh',
'Baitalpur,Bilaspur,Chattisgarh',
'Baoli,Bilaspur,Chattisgarh',
'Bartori,Bilaspur,Chattisgarh',
'Bilha,Bilaspur,Chattisgarh',
'Bitkuli,Bilaspur,Chattisgarh',
'Bortara,Bilaspur,Chattisgarh',
'Chakarbhata Camp,Bilaspur,Chattisgarh',
'Dagori,Bilaspur,Chattisgarh',
'Hirri Mines,Bilaspur,Chattisgarh',
'Pasid,Bilaspur,Chattisgarh',
'Piraiya,Bilaspur,Chattisgarh',
'Sargaon,Bilaspur,Chattisgarh',
'Sarwani,Bilaspur,Chattisgarh',
'Sewar,Bilaspur,Chattisgarh',
'Muru,Bilaspur,Chattisgarh',
'Sagar,Bilaspur,Chattisgarh',
'Sakarra,Bilaspur,Chattisgarh',
'Bharari,Bilaspur,Chattisgarh',
'Bharni,Bilaspur,Chattisgarh',
'Ghutku,Bilaspur,Chattisgarh',
'Lamer,Bilaspur,Chattisgarh',
'Neora,Bilaspur,Chattisgarh',
'Pipartarai,Bilaspur,Chattisgarh',
'Tanda,Bilaspur,Chattisgarh',
'Hirri,Bilaspur,Chattisgarh',
'Aramsahi,Bilaspur,Chattisgarh',
'Gatora,Bilaspur,Chattisgarh',
'Gudi,Bilaspur,Chattisgarh',
'Janji,Bilaspur,Chattisgarh',
'Kaudia,Bilaspur,Chattisgarh',
'Mudpar,Bilaspur,Chattisgarh',
'Nargoda,Bilaspur,Chattisgarh',
'Pondi,Bilaspur,Chattisgarh',
'Hardi (J),Bilaspur,Chattisgarh',
'Achanakmar,Bilaspur,Chattisgarh',
'Amoli,Bilaspur,Chattisgarh',
'Bansajhal,Bilaspur,Chattisgarh',
'Bhaisajhar,Bilaspur,Chattisgarh',
'Bija,Bilaspur,Chattisgarh',
'Bijaypur,Bilaspur,Chattisgarh',
'Billiband,Bilaspur,Chattisgarh',
'Dhuma,Bilaspur,Chattisgarh',
'Gobripat,Bilaspur,Chattisgarh',
'Jhingatpur,Bilaspur,Chattisgarh',
'Kargi Road,Bilaspur,Chattisgarh',
'Kargikala,Bilaspur,Chattisgarh',
'Krgikhurd,Bilaspur,Chattisgarh',
'Pali,Bilaspur,Chattisgarh',
'Parsada,Bilaspur,Chattisgarh',
'Salkhanowgaon,Bilaspur,Chattisgarh',
'Shivtarai,Bilaspur,Chattisgarh',
'Belgahana,Bilaspur,Chattisgarh',
'Birkona,Bilaspur,Chattisgarh',
'Lofandi,Bilaspur,Chattisgarh',
'Paunsara,Bilaspur,Chattisgarh',
'Semartal,Bilaspur,Chattisgarh',
'Sendri,Bilaspur,Chattisgarh',
'Akhrar,Bilaspur,Chattisgarh',
'Baigakapa,Bilaspur,Chattisgarh',
'Bandha,Bilaspur,Chattisgarh',
'Barampur,Bilaspur,Chattisgarh',
'Bodtara,Bilaspur,Chattisgarh',
'Chandeli,Bilaspur,Chattisgarh',
'Chilfi,Bilaspur,Chattisgarh',
'Daukapa,Bilaspur,Chattisgarh',
'Deorhat,Bilaspur,Chattisgarh',
'Dindori,Bilaspur,Chattisgarh',
'Dongariya,Bilaspur,Chattisgarh',
'Fulwari,Bilaspur,Chattisgarh',
'Ghanaghat,Bilaspur,Chattisgarh',
'Jhajhpurikala,Bilaspur,Chattisgarh',
'Jhapal,Bilaspur,Chattisgarh',
'Junapara,Bilaspur,Chattisgarh',
'Khamhi,Bilaspur,Chattisgarh',
'Khaprikala,Bilaspur,Chattisgarh',
'Khudia,Bilaspur,Chattisgarh',
'Kotri,Bilaspur,Chattisgarh',
'Lagra,Bilaspur,Chattisgarh',
'Lormi,Bilaspur,Chattisgarh',
'Nawadih,Bilaspur,Chattisgarh',
'Ramhepur,Bilaspur,Chattisgarh',
'Salheghori,Bilaspur,Chattisgarh',
'Sardha,Bilaspur,Chattisgarh',
'Sukli,Bilaspur,Chattisgarh',
'Surhi,Bilaspur,Chattisgarh',
'Bharari,Bilaspur,Chattisgarh',
'Bhatchaura,Bilaspur,Chattisgarh',
'Darrighat,Bilaspur,Chattisgarh',
'Deogaon,Bilaspur,Chattisgarh',
'Gondadih,Bilaspur,Chattisgarh',
'Gopal Nagar,Bilaspur,Chattisgarh',
'Jairam Nagar,Bilaspur,Chattisgarh',
'Jondhra,Bilaspur,Chattisgarh',
'Koni,Bilaspur,Chattisgarh',
'Loharsison,Bilaspur,Chattisgarh',
'Malhar,Bilaspur,Chattisgarh',
'Manikchauri,Bilaspur,Chattisgarh',
'Masturi,Bilaspur,Chattisgarh',
'Okhar,Bilaspur,Chattisgarh',
'Pachpedi,Bilaspur,Chattisgarh',
'Risda,Bilaspur,Chattisgarh',
'Son,Bilaspur,Chattisgarh',
'Sukulkari,Bilaspur,Chattisgarh',
'Tikari,Bilaspur,Chattisgarh',
'Banki,Bilaspur,Chattisgarh',
'Bhalapur,Bilaspur,Chattisgarh',
'Bhalukhondhra,Bilaspur,Chattisgarh',
'Bijatarai,Bilaspur,Chattisgarh',
'Chakrabhatha,Bilaspur,Chattisgarh',
'Chhatan,Bilaspur,Chattisgarh',
'Chhindbhog,Bilaspur,Chattisgarh',
'Chirhula,Bilaspur,Chattisgarh',
'Deori,Bilaspur,Chattisgarh',
'Dharampura,Bilaspur,Chattisgarh',
'Donda,Bilaspur,Chattisgarh',
'Fasterpur,Bilaspur,Chattisgarh',
'Gidha,Bilaspur,Chattisgarh',
'Kanteli,Bilaspur,Chattisgarh',
'Karesara,Bilaspur,Chattisgarh',
'Karhi,Bilaspur,Chattisgarh',
'Khairwar,Bilaspur,Chattisgarh',
'Kodwa,Bilaspur,Chattisgarh',
'Kosamtara,Bilaspur,Chattisgarh',
'Lalpur,Bilaspur,Chattisgarh',
'Manoharpur,Bilaspur,Chattisgarh',
'Mungeli,Bilaspur,Chattisgarh',
'Nawagaon,Bilaspur,Chattisgarh',
'Nawaspur,Bilaspur,Chattisgarh',
'Nirjam,Bilaspur,Chattisgarh',
'Pandarbhattha,Bilaspur,Chattisgarh',
'Patharia,Bilaspur,Chattisgarh',
'Phandwani,Bilaspur,Chattisgarh',
'Puran,Bilaspur,Chattisgarh',
'Rajpur (S),Bilaspur,Chattisgarh',
'Terhadhaura,Bilaspur,Chattisgarh',
'Badrabukhari,Bilaspur,Chattisgarh',
'Bhatgaon,Bilaspur,Chattisgarh',
'Goindri,Bilaspur,Chattisgarh',
'Jareli,Bilaspur,Chattisgarh',
'Kukusda,Bilaspur,Chattisgarh',
'Lauda,Bilaspur,Chattisgarh',
'Pandiyain,Bilaspur,Chattisgarh',
'Puchheli,Bilaspur,Chattisgarh',
'Sildaha,Bilaspur,Chattisgarh',
'Siltara,Bilaspur,Chattisgarh',
'Sonthi (M),Bilaspur,Chattisgarh',
'Amadand,Bilaspur,Chattisgarh',
'Amarpur,Bilaspur,Chattisgarh',
'Amaru,Bilaspur,Chattisgarh',
'Andi,Bilaspur,Chattisgarh',
'Bacharwar,Bilaspur,Chattisgarh',
'Bagadi,Bilaspur,Chattisgarh',
'Basti Bagra,Bilaspur,Chattisgarh',
'Dhobhar,Bilaspur,Chattisgarh',
'Dongaria,Bilaspur,Chattisgarh',
'Karri,Bilaspur,Chattisgarh',
'Kotgar,Bilaspur,Chattisgarh',
'Kotmi,Bilaspur,Chattisgarh',
'Kudkai,Bilaspur,Chattisgarh',
'Kudri,Bilaspur,Chattisgarh',
'Lainga,Bilaspur,Chattisgarh',
'Nawagaon,Bilaspur,Chattisgarh',
'Nimdha,Bilaspur,Chattisgarh',
'Pasan,Bilaspur,Chattisgarh',
'Patgawan,Bilaspur,Chattisgarh',
'Piparia,Bilaspur,Chattisgarh',
'Pondikala,Bilaspur,Chattisgarh',
'Putipakhna,Bilaspur,Chattisgarh',
'Semra,Bilaspur,Chattisgarh',
'Silpahri,Bilaspur,Chattisgarh',
'Andhiyarkhoh,Bilaspur,Chattisgarh',
'Darri,Bilaspur,Chattisgarh',
'Marwahi,Bilaspur,Chattisgarh',
'Pendra Road R.S.,Bilaspur,Chattisgarh',
'Pendra Road,Bilaspur,Chattisgarh',
'Pendra,Bilaspur,Chattisgarh',
'Choktipani,Bilaspur,Chattisgarh',
'Gorakhpur,Bilaspur,Chattisgarh',
'Jogisar,Bilaspur,Chattisgarh',
'Keonchi,Bilaspur,Chattisgarh',
'Khodri,Bilaspur,Chattisgarh',
'Korja,Bilaspur,Chattisgarh',
'Lalpur,Bilaspur,Chattisgarh',
'Neosa,Bilaspur,Chattisgarh',
'Pakaria,Bilaspur,Chattisgarh',
'Pendra Road Sanotorium,Bilaspur,Chattisgarh',
'Piparkhunti,Bilaspur,Chattisgarh',
'Sadhwani,Bilaspur,Chattisgarh',
'Chapora,Bilaspur,Chattisgarh',
'Garwat,Bilaspur,Chattisgarh',
'Khaira,Bilaspur,Chattisgarh',
'Lakhram,Bilaspur,Chattisgarh',
'Mohda,Bilaspur,Chattisgarh',
'Pondi,Bilaspur,Chattisgarh',
'Ranigaon,Bilaspur,Chattisgarh',
'Ratanpur,Bilaspur,Chattisgarh',
'Sarwandeori,Bilaspur,Chattisgarh',
'Selar,Bilaspur,Chattisgarh',
'Silli,Bilaspur,Chattisgarh',
'Singhri,Bilaspur,Chattisgarh',
'Seepat,Bilaspur,Chattisgarh',
'Amora,Bilaspur,Chattisgarh',
'Barela,Bilaspur,Chattisgarh',
'Belsari,Bilaspur,Chattisgarh',
'Birgaon,Bilaspur,Chattisgarh',
'Dashrangpur,Bilaspur,Chattisgarh',
'Dhandhan,Bilaspur,Chattisgarh',
'Dhangaongosai,Bilaspur,Chattisgarh',
'Ganiyari,Bilaspur,Chattisgarh',
'Jarhagaon,Bilaspur,Chattisgarh',
'Jarondha,Bilaspur,Chattisgarh',
'Matsagra,Bilaspur,Chattisgarh',
'Padampur,Bilaspur,Chattisgarh',
'Pharhada,Bilaspur,Chattisgarh',
'Pura,Bilaspur,Chattisgarh',
'Rajpur,Bilaspur,Chattisgarh',
'Semarsal,Bilaspur,Chattisgarh',
'Siltara,Bilaspur,Chattisgarh',
'Takhatpur,Bilaspur,Chattisgarh',
'Modakpal,Bastar,Chattisgarh',
'Balood,Bastar,Chattisgarh',
'Bagmundi Panera,Bastar,Chattisgarh',
'Aranpur,Bastar,Chattisgarh',
'Bache R.S.,Bastar,Chattisgarh',
'Bacheli,Bastar,Chattisgarh',
'Badebedma,Bastar,Chattisgarh',
'Badegudra,Bastar,Chattisgarh',
'Badelakhapal,Bastar,Chattisgarh',
'Balpet,Bastar,Chattisgarh',
'Bangali Camp,Bastar,Chattisgarh',
'Barsoor,Bastar,Chattisgarh',
'Belnar,Bastar,Chattisgarh',
'Bhansi,Bastar,Chattisgarh',
'Bhusaras,Bastar,Chattisgarh',
'Burgum,Bastar,Chattisgarh',
'Chhindnar,Bastar,Chattisgarh',
'Chhotetumnar,Bastar,Chattisgarh',
'Dabpal,Bastar,Chattisgarh',
'Dantewada,Bastar,Chattisgarh',
'Dugeli,Bastar,Chattisgarh',
'Gadapal,Bastar,Chattisgarh',
'Gadmiri,Bastar,Chattisgarh',
'Gamawada,Bastar,Chattisgarh',
'Geedam,Bastar,Chattisgarh',
'Ghotpal,Bastar,Chattisgarh',
'Gondras,Bastar,Chattisgarh',
'Gumda,Bastar,Chattisgarh',
'Gumyapal,Bastar,Chattisgarh',
'Guphadi,Bastar,Chattisgarh',
'Harrakoder,Bastar,Chattisgarh',
'Heeranar,Bastar,Chattisgarh',
'Jabeli,Bastar,Chattisgarh',
'Kamaloor,Bastar,Chattisgarh',
'Kanwalnar,Bastar,Chattisgarh',
'Karli,Bastar,Chattisgarh',
'Katekalyan,Bastar,Chattisgarh',
'Kawadgaon,Bastar,Chattisgarh',
'Kirandul Hill Top,Bastar,Chattisgarh',
'Kirandul R.S.,Bastar,Chattisgarh',
'Kirandul,Bastar,Chattisgarh',
'Kondasawli,Bastar,Chattisgarh',
'Korgaon,Bastar,Chattisgarh',
'Korlapal,Bastar,Chattisgarh',
'Koshalnar,Bastar,Chattisgarh',
'Kuakonda,Bastar,Chattisgarh',
'Kumharras,Bastar,Chattisgarh',
'Kuper,Bastar,Chattisgarh',
'Mailawada,Bastar,Chattisgarh',
'Masenar,Bastar,Chattisgarh',
'Matenar,Bastar,Chattisgarh',
'Metapal,Bastar,Chattisgarh',
'Mirtur,Bastar,Chattisgarh',
'Mokhpal,Bastar,Chattisgarh',
'Nakulnar,Bastar,Chattisgarh',
'Palnar,Bastar,Chattisgarh',
'Parcheli,Bastar,Chattisgarh',
'Pedka,Bastar,Chattisgarh',
'Pharaspal,Bastar,Chattisgarh',
'Phulpad,Bastar,Chattisgarh',
'Pinkonda,Bastar,Chattisgarh',
'Pondoom,Bastar,Chattisgarh',
'Potali,Bastar,Chattisgarh',
'Ronje,Bastar,Chattisgarh',
'Sameli,Bastar,Chattisgarh',
'Shivanandashram,Bastar,Chattisgarh',
'Shyamgiri,Bastar,Chattisgarh',
'Surnar,Bastar,Chattisgarh',
'Teknar,Bastar,Chattisgarh',
'Telam,Bastar,Chattisgarh',
'Tikanpal,Bastar,Chattisgarh',
'Kakadi,Bastar,Chattisgarh',
'Argatta,Bastar,Chattisgarh',
'Badegadam,Bastar,Chattisgarh',
'Badesatti,Bastar,Chattisgarh',
'Banda,Bastar,Chattisgarh',
'Bheji,Bastar,Chattisgarh',
'Chandangiri,Bastar,Chattisgarh',
'Chhindgarh,Bastar,Chattisgarh',
'Chindawada,Bastar,Chattisgarh',
'Chintagupha,Bastar,Chattisgarh',
'Chintalnar,Bastar,Chattisgarh',
'Darbha,Bastar,Chattisgarh',
'Dornapal,Bastar,Chattisgarh',
'Dubbatota,Bastar,Chattisgarh',
'Errabore,Bastar,Chattisgarh',
'Gaganpalli,Bastar,Chattisgarh',
'Gogunda,Bastar,Chattisgarh',
'Gollapalli,Bastar,Chattisgarh',
'Gondpalli,Bastar,Chattisgarh',
'Gorli,Bastar,Chattisgarh',
'Hameergarh,Bastar,Chattisgarh',
'Idjepal,Bastar,Chattisgarh',
'Injeram,Bastar,Chattisgarh',
'Jagargunda,Bastar,Chattisgarh',
'Jeerampal,Bastar,Chattisgarh',
'Jhapra,Bastar,Chattisgarh',
'Kanjipani,Bastar,Chattisgarh',
'Kerlapal,Bastar,Chattisgarh',
'Kikirpal,Bastar,Chattisgarh',
'Kistaram,Bastar,Chattisgarh',
'Kodripal,Bastar,Chattisgarh',
'Kokawada,Bastar,Chattisgarh',
'Koleng,Bastar,Chattisgarh',
'Konta,Bastar,Chattisgarh',
'Korra,Bastar,Chattisgarh',
'Kukanar,Bastar,Chattisgarh',
'Kundanpal,Bastar,Chattisgarh',
'Kunna,Bastar,Chattisgarh',
'Leda,Bastar,Chattisgarh',
'Mehta,Bastar,Chattisgarh',
'Michwar,Bastar,Chattisgarh',
'Misma,Bastar,Chattisgarh',
'Nagaram,Bastar,Chattisgarh',
'Pakela,Bastar,Chattisgarh',
'Pakhnar,Bastar,Chattisgarh',
'Pendalnar,Bastar,Chattisgarh',
'Polampalli,Bastar,Chattisgarh',
'Pondum,Bastar,Chattisgarh',
'Pongabheji,Bastar,Chattisgarh',
'Puspal,Bastar,Chattisgarh',
'Ramaram,Bastar,Chattisgarh',
'Rokel,Bastar,Chattisgarh',
'Sautnar,Bastar,Chattisgarh',
'Sirsitti,Bastar,Chattisgarh',
'Sonakuknar,Bastar,Chattisgarh',
'Sukma,Bastar,Chattisgarh',
'Talnar,Bastar,Chattisgarh',
'Tirathgarh,Bastar,Chattisgarh',
'Tongpal,Bastar,Chattisgarh',
'Urmapal,Bastar,Chattisgarh',
'Bahigaon,Raipur,Chattisgarh',
'Ghorawad,Raipur,Chattisgarh',
'Sihawa,Raipur,Chattisgarh',
'Achhota,Raipur,Chattisgarh',
'Amdi,Raipur,Chattisgarh',
'Anwari,Raipur,Chattisgarh',
'Aroud,Raipur,Chattisgarh',
'Banraud,Raipur,Chattisgarh',
'Bazar Kurridih,Raipur,Chattisgarh',
'Bhakhara,Raipur,Chattisgarh',
'Bhothli,Raipur,Chattisgarh',
'Borsi,Raipur,Chattisgarh',
'Chanagaon,Raipur,Chattisgarh',
'Chhuhi,Raipur,Chattisgarh',
'Dahi,Raipur,Chattisgarh',
'Demar,Raipur,Chattisgarh',
'Dhamtari D.B.Ward,Raipur,Chattisgarh',
'Dhamtari I.Ward,Raipur,Chattisgarh',
'Dhamtari,Raipur,Chattisgarh',
'Doma,Raipur,Chattisgarh',
'Dugli,Raipur,Chattisgarh',
'G.Jamgoan,Raipur,Chattisgarh',
'Gattasilli,Raipur,Chattisgarh',
'Jhuratarai,Raipur,Chattisgarh',
'Joratarai,Raipur,Chattisgarh',
'Kachna,Raipur,Chattisgarh',
'Karaiha,Raipur,Chattisgarh',
'Keregaon,Raipur,Chattisgarh',
'Kharenga,Raipur,Chattisgarh',
'Korra,Raipur,Chattisgarh',
'Kosamsara,Raipur,Chattisgarh',
'Kukrel,Raipur,Chattisgarh',
'Loharsi,Raipur,Chattisgarh',
'Madeli,Raipur,Chattisgarh',
'Potiadih,Raipur,Chattisgarh',
'Rampur,Raipur,Chattisgarh',
'Rudri,Raipur,Chattisgarh',
'Sambalpur,Raipur,Chattisgarh',
'Semra,Raipur,Chattisgarh',
'Silouti,Raipur,Chattisgarh',
'Singhpur,Raipur,Chattisgarh',
'Tarsiwa,Raipur,Chattisgarh',
'Achhoti,Raipur,Chattisgarh',
'Bagod,Raipur,Chattisgarh',
'Belardona,Raipur,Chattisgarh',
'Bhaismundi,Raipur,Chattisgarh',
'Bhatagaon,Raipur,Chattisgarh',
'Bhothidih,Raipur,Chattisgarh',
'Birjhuli,Raipur,Chattisgarh',
'Charmudia,Raipur,Chattisgarh',
'Chhati,Raipur,Chattisgarh',
'Dahdaha,Raipur,Chattisgarh',
'Girod,Raipur,Chattisgarh',
'Jhiriya,Raipur,Chattisgarh',
'Kandel,Raipur,Chattisgarh',
'Kareli Chhoti,Raipur,Chattisgarh',
'Katalbod,Raipur,Chattisgarh',
'Kundel,Raipur,Chattisgarh',
'Kurud,Raipur,Chattisgarh',
'Magarlod,Raipur,Chattisgarh',
'Mandraud,Raipur,Chattisgarh',
'Marod,Raipur,Chattisgarh',
'Megha,Raipur,Chattisgarh',
'Mohdi,Raipur,Chattisgarh',
'Nari,Raipur,Chattisgarh',
'Parkhanda,Raipur,Chattisgarh',
'Puri,Raipur,Chattisgarh',
'Sankari,Raipur,Chattisgarh',
'Sargi,Raipur,Chattisgarh',
'Seonikala,Raipur,Chattisgarh',
'Sirri,Raipur,Chattisgarh',
'Sankra,Raipur,Chattisgarh',
'Amali,Raipur,Chattisgarh',
'Belar Bahra,Raipur,Chattisgarh',
'Belar Bazar,Raipur,Chattisgarh',
'Bhursidongri,Raipur,Chattisgarh',
'Birgudi,Raipur,Chattisgarh',
'Deopur,Raipur,Chattisgarh',
'Dongardulla,Raipur,Chattisgarh',
'Farsia,Raipur,Chattisgarh',
'Garhdongri,Raipur,Chattisgarh',
'Ghatula,Raipur,Chattisgarh',
'Ghotgaon,Raipur,Chattisgarh',
'Kaspur,Raipur,Chattisgarh',
'Khamaria,Raipur,Chattisgarh',
'Nagri,Raipur,Chattisgarh',
'Podagaon,Raipur,Chattisgarh',
'Rajpur,Raipur,Chattisgarh',
'Semra,Raipur,Chattisgarh',
'Sondur Project,Raipur,Chattisgarh',
'Umargaon,Raipur,Chattisgarh',
'Bhatgaon,Raipur,Chattisgarh',
'R.S.P.Colony Gangrel,Raipur,Chattisgarh',
'Bhilai,Durg,Chattisgarh',
'Borsi,Durg,Chattisgarh',
'Admabad,Durg,Chattisgarh',
'Badbhum,Durg,Chattisgarh',
'Baghmara,Durg,Chattisgarh',
'Balod,Durg,Chattisgarh',
'Balod Town,Durg,Chattisgarh',
'Baloda,Durg,Chattisgarh',
'Bazar Dallirajhara,Durg,Chattisgarh',
'Belmond,Durg,Chattisgarh',
'Bhaisbod,Durg,Chattisgarh',
'Dallirajhara,Durg,Chattisgarh',
'Dudhli,Durg,Chattisgarh',
'Gujra,Durg,Chattisgarh',
'Jamrua,Durg,Chattisgarh',
'Khapri,Durg,Chattisgarh',
'Khobha,Durg,Chattisgarh',
'Latabod,Durg,Chattisgarh',
'Newarikala,Durg,Chattisgarh',
'Pond,Durg,Chattisgarh',
'Sankra J,Durg,Chattisgarh',
'Singhola,Durg,Chattisgarh',
'Taraud,Durg,Chattisgarh',
'Tekapar,Durg,Chattisgarh',
'Baba Mohtara,Durg,Chattisgarh',
'Balsamund,Durg,Chattisgarh',
'Bemetara,Durg,Chattisgarh',
'Bijabhat,Durg,Chattisgarh',
'Chandanu,Durg,Chattisgarh',
'Dadhi,Durg,Chattisgarh',
'Jeora,Durg,Chattisgarh',
'Jhal,Durg,Chattisgarh',
'Kanhera,Durg,Chattisgarh',
'Karesara,Durg,Chattisgarh',
'Khandsara,Durg,Chattisgarh',
'Kurda,Durg,Chattisgarh',
'Matka,Durg,Chattisgarh',
'Mohrenga,Durg,Chattisgarh',
'Ninwa,Durg,Chattisgarh',
'Odia,Durg,Chattisgarh',
'Pendritarai,Durg,Chattisgarh',
'Ranka,Durg,Chattisgarh',
'Thengabhat,Durg,Chattisgarh',
'Anandgaon,Durg,Chattisgarh',
'Bargaon,Durg,Chattisgarh',
'Berla,Durg,Chattisgarh',
'Biroda,Durg,Chattisgarh',
'Dargaon,Durg,Chattisgarh',
'K.Mohrenga,Durg,Chattisgarh',
'Khudmuda,Durg,Chattisgarh',
'Kusmi,Durg,Chattisgarh',
'Lawatara,Durg,Chattisgarh',
'Lenjwara,Durg,Chattisgarh',
'Pahanda,Durg,Chattisgarh',
'Patora,Durg,Chattisgarh',
'Sarda,Durg,Chattisgarh',
'Semaria,Durg,Chattisgarh',
'Sondh,Durg,Chattisgarh',
'Ahiwara,Durg,Chattisgarh',
'Barhapur,Durg,Chattisgarh',
'Bhatagaon,Durg,Chattisgarh',
'Bhimbhori,Durg,Chattisgarh',
'Deokar,Durg,Chattisgarh',
'Deori,Durg,Chattisgarh',
'Dhamdha,Durg,Chattisgarh',
'Gadadih,Durg,Chattisgarh',
'Ghota,Durg,Chattisgarh',
'Ghotwani,Durg,Chattisgarh',
'Girhola,Durg,Chattisgarh',
'Gondgiri,Durg,Chattisgarh',
'Gondi,Durg,Chattisgarh',
'Gudheli,Durg,Chattisgarh',
'Hasda,Durg,Chattisgarh',
'Kareli,Durg,Chattisgarh',
'Kodia,Durg,Chattisgarh',
'Medesara,Durg,Chattisgarh',
'Murmunda,Durg,Chattisgarh',
'Nandini Khundini,Durg,Chattisgarh',
'Nandini,Durg,Chattisgarh',
'Parpodi,Durg,Chattisgarh',
'Pendrawan,Durg,Chattisgarh',
'Rajpur,Durg,Chattisgarh',
'Raunda,Durg,Chattisgarh',
'Sahaspur,Durg,Chattisgarh',
'Mines Office Dallirajhara,Durg,Chattisgarh',
'Amadula,Durg,Chattisgarh',
'Bharritola,Durg,Chattisgarh',
'Bital,Durg,Chattisgarh',
'Chikhlakasa,Durg,Chattisgarh',
'Chipra,Durg,Chattisgarh',
'Dondi Awari,Durg,Chattisgarh',
'Ghotia,Durg,Chattisgarh',
'Gudum,Durg,Chattisgarh',
'Khalari,Durg,Chattisgarh',
'Kondekasa,Durg,Chattisgarh',
'Kusumkasa,Durg,Chattisgarh',
'Mahamaya Mines,Durg,Chattisgarh',
'Narratola,Durg,Chattisgarh',
'Salhe,Durg,Chattisgarh',
'Surdongar,Durg,Chattisgarh',
'Themabuzurg,Durg,Chattisgarh',
'Acholi,Durg,Chattisgarh',
'Badgaon,Durg,Chattisgarh',
'Bhandera,Durg,Chattisgarh',
'Bhanwarmara,Durg,Chattisgarh',
'Bharda,Durg,Chattisgarh',
'Bhimkanhar,Durg,Chattisgarh',
'Deori,Durg,Chattisgarh',
'Dondi Lohara,Durg,Chattisgarh',
'Faradfod,Durg,Chattisgarh',
'Kamkapar,Durg,Chattisgarh',
'Kherthabazar,Durg,Chattisgarh',
'Kholjhar,Durg,Chattisgarh',
'Kodekasa,Durg,Chattisgarh',
'Nahanda,Durg,Chattisgarh',
'Sahgaon,Durg,Chattisgarh',
'Sambalpur,Durg,Chattisgarh',
'Sanjari,Durg,Chattisgarh',
'Tatenga,Durg,Chattisgarh',
'Aundhi,Durg,Chattisgarh',
'Auri,Durg,Chattisgarh',
'Bhendsar,Durg,Chattisgarh',
'Bhilai 1,Durg,Chattisgarh',
'Bhilai Boria,Durg,Chattisgarh',
'Bhilai East,Durg,Chattisgarh',
'Bhilai Marshalling Yard,Durg,Chattisgarh',
'Bhilai West,Durg,Chattisgarh',
'Borai,Durg,Chattisgarh',
'Bori,Durg,Chattisgarh',
'Chicha,Durg,Chattisgarh',
'Civic Centre Bhilai,Durg,Chattisgarh',
'Deobaloda,Durg,Chattisgarh',
'Dhaur,Durg,Chattisgarh',
'Durg H.O,Durg,Chattisgarh',
'Durg Kutchery,Durg,Chattisgarh',
'Durg R S,Durg,Chattisgarh',
'Durg Sadar Bazar,Durg,Chattisgarh',
'Hanoda,Durg,Chattisgarh',
'Hirri,Durg,Chattisgarh',
'I E Bhilai,Durg,Chattisgarh',
'Ibsb Bhilai H.O,Durg,Chattisgarh',
'Jamul Cement Works,Durg,Chattisgarh',
'Janjgiri,Durg,Chattisgarh',
'Jawahar Market Bhilai,Durg,Chattisgarh',
'Jeora Sirsa,Durg,Chattisgarh',
'Karanja Bhilai,Durg,Chattisgarh',
'Kasaridih Durg,Durg,Chattisgarh',
'Khoka Bhilai,Durg,Chattisgarh',
'Khursipar Bhilai,Durg,Chattisgarh',
'Kurud,Durg,Chattisgarh',
'Litia Semaria,Durg,Chattisgarh',
'Malvia Nagar Durg,Durg,Chattisgarh',
'Maroda Bhilai,Durg,Chattisgarh',
'Mohan Nagar Durg,Durg,Chattisgarh',
'Motilal Nehru Nagr Bhilai,Durg,Chattisgarh',
'Nagpura,Durg,Chattisgarh',
'Nandkatti,Durg,Chattisgarh',
'Nardha,Durg,Chattisgarh',
'Nawagaon Bhilai,Durg,Chattisgarh',
'Nawagaon Purda,Durg,Chattisgarh',
'New Khursipar Bhilai,Durg,Chattisgarh',
'Padmanabhpur Durg,Durg,Chattisgarh',
'Pisgaon,Durg,Chattisgarh',
'Rasmara,Durg,Chattisgarh',
'S A F Lines Bhilai,Durg,Chattisgarh',
'Sector 2,Durg,Chattisgarh',
'Sector 3 Bhilai,Durg,Chattisgarh',
'Sector 5 Bhilai,Durg,Chattisgarh',
'Sector 6 Bhilai,Durg,Chattisgarh',
'Sector 7 Bhilai,Durg,Chattisgarh',
'Sector 8 Bhilai,Durg,Chattisgarh',
'Sirsakala,Durg,Chattisgarh',
'Smriti Nagar Bhilai,Durg,Chattisgarh',
'Supela Bhilai,Durg,Chattisgarh',
'Surdung,Durg,Chattisgarh',
'Temri,Durg,Chattisgarh',
'Thanod,Durg,Chattisgarh',
'Tumakala,Durg,Chattisgarh',
'Urla,Durg,Chattisgarh',
'Vaishali Nagar Bhilai,Durg,Chattisgarh',
'Achaud,Durg,Chattisgarh',
'Albaras,Durg,Chattisgarh',
'Anda,Durg,Chattisgarh',
'Arjunda,Durg,Chattisgarh',
'Arkar,Durg,Chattisgarh',
'Armarikala,Durg,Chattisgarh',
'Barbaspur,Durg,Chattisgarh',
'Batrel,Durg,Chattisgarh',
'Belaudi,Durg,Chattisgarh',
'Belhari,Durg,Chattisgarh',
'Bhardakala,Durg,Chattisgarh',
'Bhatagaon,Durg,Chattisgarh',
'Bhatagaon,Durg,Chattisgarh',
'Chandkhuri,Durg,Chattisgarh',
'Chandnbirhi,Durg,Chattisgarh',
'Chaurel,Durg,Chattisgarh',
'Dagania,Durg,Chattisgarh',
'Dhamna,Durg,Chattisgarh',
'Dundera,Durg,Chattisgarh',
'Gabdi,Durg,Chattisgarh',
'Gorkapar,Durg,Chattisgarh',
'Gunderdehi,Durg,Chattisgarh',
'Hadgaon,Durg,Chattisgarh',
'Hardi,Durg,Chattisgarh',
'Jamgaon R,Durg,Chattisgarh',
'Kachandur,Durg,Chattisgarh',
'Kalangpur,Durg,Chattisgarh',
'Kanakote,Durg,Chattisgarh',
'Kandul,Durg,Chattisgarh',
'Karela,Durg,Chattisgarh',
'Kasahi,Durg,Chattisgarh',
'Kasaunda,Durg,Chattisgarh',
'Khursuni,Durg,Chattisgarh',
'Kuthrel,Durg,Chattisgarh',
'Machandur,Durg,Chattisgarh',
'Mahud,Durg,Chattisgarh',
'Marra,Durg,Chattisgarh',
'Matwari,Durg,Chattisgarh',
'Mohara,Durg,Chattisgarh',
'Nikum,Durg,Chattisgarh',
'Nipani Tipani,Durg,Chattisgarh',
'Pairi,Durg,Chattisgarh',
'Palari,Durg,Chattisgarh',
'Parsada,Durg,Chattisgarh',
'Pauha,Durg,Chattisgarh',
'Rahud,Durg,Chattisgarh',
'Rajauli,Durg,Chattisgarh',
'Ranchirai,Durg,Chattisgarh',
'Ranitarai,Durg,Chattisgarh',
'Risama,Durg,Chattisgarh',
'Sikosa,Durg,Chattisgarh',
'Sirri,Durg,Chattisgarh',
'Suregaon,Durg,Chattisgarh',
'Surpa,Durg,Chattisgarh',
'Tamora,Durg,Chattisgarh',
'Tavera,Durg,Chattisgarh',
'Tirga,Durg,Chattisgarh',
'Vinayakpur,Durg,Chattisgarh',
'Balod Gahan,Durg,Chattisgarh',
'Barhi,Durg,Chattisgarh',
'Basin,Durg,Chattisgarh',
'Charwahi,Durg,Chattisgarh',
'Chitod,Durg,Chattisgarh',
'Darra,Durg,Chattisgarh',
'Dhaneli,Durg,Chattisgarh',
'Fagundah,Durg,Chattisgarh',
'Gurur,Durg,Chattisgarh',
'Jamgaon B,Durg,Chattisgarh',
'Kaneri,Durg,Chattisgarh',
'Kanwar,Durg,Chattisgarh',
'Karhi Bhadar,Durg,Chattisgarh',
'Khundini,Durg,Chattisgarh',
'Limora,Durg,Chattisgarh',
'Mokha,Durg,Chattisgarh',
'Naragaon,Durg,Chattisgarh',
'Nipani,Durg,Chattisgarh',
'Shantipur,Durg,Chattisgarh',
'Sonai Dongri,Durg,Chattisgarh',
'Sorar,Durg,Chattisgarh',
'Tarri,Durg,Chattisgarh',
'Badnara,Durg,Chattisgarh',
'Ghursena,Durg,Chattisgarh',
'Kheda,Durg,Chattisgarh',
'Kunwa,Durg,Chattisgarh',
'Maro,Durg,Chattisgarh',
'Mau,Durg,Chattisgarh',
'Nagdha,Durg,Chattisgarh',
'Nandghat,Durg,Chattisgarh',
'Narayanpur,Durg,Chattisgarh',
'Putpura,Durg,Chattisgarh',
'Sambalpur,Durg,Chattisgarh',
'Temri,Durg,Chattisgarh',
'Nawagarh,Durg,Chattisgarh',
'Andhiarkhor,Durg,Chattisgarh',
'Chirha,Durg,Chattisgarh',
'Gadamore,Durg,Chattisgarh',
'Ghoghra,Durg,Chattisgarh',
'Hardi,Durg,Chattisgarh',
'Kanwarkapa,Durg,Chattisgarh',
'Kunwa,Durg,Chattisgarh',
'Murta,Durg,Chattisgarh',
'Nandal,Durg,Chattisgarh',
'Pratappur,Durg,Chattisgarh',
'Patan,Durg,Chattisgarh',
'Batang,Durg,Chattisgarh',
'Bathena,Durg,Chattisgarh',
'Bhansuli,Durg,Chattisgarh',
'Borid,Durg,Chattisgarh',
'Darbarmokhli,Durg,Chattisgarh',
'Devada,Durg,Chattisgarh',
'Dundera,Durg,Chattisgarh',
'Fekari,Durg,Chattisgarh',
'Gujra,Durg,Chattisgarh',
'Jamgaon,Durg,Chattisgarh',
'Kapasda,Durg,Chattisgarh',
'Kesra,Durg,Chattisgarh',
'Khamaria,Durg,Chattisgarh',
'Khopli,Durg,Chattisgarh',
'Kumhari,Durg,Chattisgarh',
'Limtara,Durg,Chattisgarh',
'Mahudajhit,Durg,Chattisgarh',
'Newai,Durg,Chattisgarh',
'Oteband,Durg,Chattisgarh',
'Pahanda,Durg,Chattisgarh',
'Pahandor,Durg,Chattisgarh',
'Patora,Durg,Chattisgarh',
'Pauwara,Durg,Chattisgarh',
'Purai,Durg,Chattisgarh',
'Sankra,Durg,Chattisgarh',
'Santra,Durg,Chattisgarh',
'Selud,Durg,Chattisgarh',
'Tarra,Durg,Chattisgarh',
'Teligundra,Durg,Chattisgarh',
'Utai Pedal,Durg,Chattisgarh',
'Utai,Durg,Chattisgarh',
'Bargada,Durg,Chattisgarh',
'Beltara,Durg,Chattisgarh',
'Bortara,Durg,Chattisgarh',
'Chilfi,Durg,Chattisgarh',
'Deorbija,Durg,Chattisgarh',
'Deurgaon,Durg,Chattisgarh',
'Hatranka,Durg,Chattisgarh',
'Kestaa,Durg,Chattisgarh',
'Khamaria,Durg,Chattisgarh',
'Mohbhatta,Durg,Chattisgarh',
'Mohgaon,Durg,Chattisgarh',
'Parasbod,Durg,Chattisgarh',
'Saja,Durg,Chattisgarh',
'Saldha,Durg,Chattisgarh',
'Tipni,Durg,Chattisgarh',
'Sonthi,Bilaspur,Chattisgarh',
'Bandora,Bilaspur,Chattisgarh',
'Charoda,Bilaspur,Chattisgarh',
'Faguram,Bilaspur,Chattisgarh',
'Kanwali,Bilaspur,Chattisgarh',
'Kirari,Bilaspur,Chattisgarh',
'Kusmul,Bilaspur,Chattisgarh',
'Singhitarai,Bilaspur,Chattisgarh',
'Tundri,Bilaspur,Chattisgarh',
'Sapia,Bilaspur,Chattisgarh',
'Arjuni,Bilaspur,Chattisgarh',
'Bargawan,Bilaspur,Chattisgarh',
'Birkoni,Bilaspur,Chattisgarh',
'Changori,Bilaspur,Chattisgarh',
'Kapan,Bilaspur,Chattisgarh',
'Katnai,Bilaspur,Chattisgarh',
'Kotmisonar,Bilaspur,Chattisgarh',
'Pandania,Bilaspur,Chattisgarh',
'Pondidalha,Bilaspur,Chattisgarh',
'Sankar,Bilaspur,Chattisgarh',
'Bachhaud,Bilaspur,Chattisgarh',
'Baloda,Bilaspur,Chattisgarh',
'Budganan,Bilaspur,Chattisgarh',
'Dhania,Bilaspur,Chattisgarh',
'Dongri,Bilaspur,Chattisgarh',
'Jawalpur,Bilaspur,Chattisgarh',
'Khamaria,Bilaspur,Chattisgarh',
'Khisora,Bilaspur,Chattisgarh',
'Mahuda,Bilaspur,Chattisgarh',
'Nirtu,Bilaspur,Chattisgarh',
'Ponch,Bilaspur,Chattisgarh',
'Rasota,Bilaspur,Chattisgarh',
'Basti Baradwar,Bilaspur,Chattisgarh',
'Darang,Bilaspur,Chattisgarh',
'Dumarpara,Bilaspur,Chattisgarh',
'Jarwe,Bilaspur,Chattisgarh',
'Jharna,Bilaspur,Chattisgarh',
'Kirari,Bilaspur,Chattisgarh',
'Muktaraja,Bilaspur,Chattisgarh',
'Nagarda,Bilaspur,Chattisgarh',
'Reda,Bilaspur,Chattisgarh',
'Sakreli,Bilaspur,Chattisgarh',
'Saragaon,Bilaspur,Chattisgarh',
'Sarhar,Bilaspur,Chattisgarh',
'Bamhni Bazar,Bilaspur,Chattisgarh',
'Basantpur,Bilaspur,Chattisgarh',
'Birgahni,Bilaspur,Chattisgarh',
'Birra,Bilaspur,Chattisgarh',
'Champa R.S.,Bilaspur,Chattisgarh',
'Champa,Bilaspur,Chattisgarh',
'Chicholi,Bilaspur,Chattisgarh',
'Faraswani,Bilaspur,Chattisgarh',
'Gaud,Bilaspur,Chattisgarh',
'Hathnewra,Bilaspur,Chattisgarh',
'Karainara,Bilaspur,Chattisgarh',
'Katrenagar,Bilaspur,Chattisgarh',
'Kosmanda,Bilaspur,Chattisgarh',
'Kothari,Bilaspur,Chattisgarh',
'Kurda,Bilaspur,Chattisgarh',
'Mahuda,Bilaspur,Chattisgarh',
'Pathiapali,Bilaspur,Chattisgarh',
'Pisaud,Bilaspur,Chattisgarh',
'Pithampur,Bilaspur,Chattisgarh',
'Seoni,Bilaspur,Chattisgarh',
'Sohagpur,Bilaspur,Chattisgarh',
'Sukhrikala,Bilaspur,Chattisgarh',
'Umreli,Bilaspur,Chattisgarh',
'Akoljamora,Bilaspur,Chattisgarh',
'Amaldiha,Bilaspur,Chattisgarh',
'Baghod,Bilaspur,Chattisgarh',
'Balpur,Bilaspur,Chattisgarh',
'Barapipar,Bilaspur,Chattisgarh',
'Dhurkot,Bilaspur,Chattisgarh',
'Girgira,Bilaspur,Chattisgarh',
'Gopalpur,Bilaspur,Chattisgarh',
'Jawali,Bilaspur,Chattisgarh',
'Kirari,Bilaspur,Chattisgarh',
'Kotmi,Bilaspur,Chattisgarh',
'Latesara,Bilaspur,Chattisgarh',
'Madwa,Bilaspur,Chattisgarh',
'Pendarwa,Bilaspur,Chattisgarh',
'Reda,Bilaspur,Chattisgarh',
'Salhe,Bilaspur,Chattisgarh',
'Sapos,Bilaspur,Chattisgarh',
'Chandrapur,Bilaspur,Chattisgarh',
'Chhotekatekoni,Bilaspur,Chattisgarh',
'Churaghata,Bilaspur,Chattisgarh',
'Churtela,Bilaspur,Chattisgarh',
'Dabhra,Bilaspur,Chattisgarh',
'Deorghata,Bilaspur,Chattisgarh',
'Faraswani,Bilaspur,Chattisgarh',
'Kansa,Bilaspur,Chattisgarh',
'Kawaljhar,Bilaspur,Chattisgarh',
'Khondhar,Bilaspur,Chattisgarh',
'Sakreli,Bilaspur,Chattisgarh',
'Saraskela,Bilaspur,Chattisgarh',
'Sukhapali,Bilaspur,Chattisgarh',
'Sukhda,Bilaspur,Chattisgarh',
'Amora,Bilaspur,Chattisgarh',
'Konar,Bilaspur,Chattisgarh',
'Kosa,Bilaspur,Chattisgarh',
'Mulmula,Bilaspur,Chattisgarh',
'Akaltara,Bilaspur,Chattisgarh',
'Akaltari,Bilaspur,Chattisgarh',
'Amoda,Bilaspur,Chattisgarh',
'Amora,Bilaspur,Chattisgarh',
'Banari,Bilaspur,Chattisgarh',
'Bhainstara,Bilaspur,Chattisgarh',
'Bodsara,Bilaspur,Chattisgarh',
'Cci Akaltara,Bilaspur,Chattisgarh',
'Dhaneli,Bilaspur,Chattisgarh',
'Dharasiv,Bilaspur,Chattisgarh',
'Dhurkot,Bilaspur,Chattisgarh',
'Hardi (S),Bilaspur,Chattisgarh',
'Jaijaipur,Bilaspur,Chattisgarh',
'Janjgir,Bilaspur,Chattisgarh',
'Jarwe,Bilaspur,Chattisgarh',
'Khaija,Bilaspur,Chattisgarh',
'Khokhra,Bilaspur,Chattisgarh',
'Khokhsa,Bilaspur,Chattisgarh',
'Kuthur,Bilaspur,Chattisgarh',
'Kutra,Bilaspur,Chattisgarh',
'Mahant,Bilaspur,Chattisgarh',
'Munund,Bilaspur,Chattisgarh',
'Naila R.S.,Bilaspur,Chattisgarh',
'Nariyara,Bilaspur,Chattisgarh',
'Paharia,Bilaspur,Chattisgarh',
'Pendri,Bilaspur,Chattisgarh',
'Sarkhon,Bilaspur,Chattisgarh',
'Semra,Bilaspur,Chattisgarh',
'Seoni,Bilaspur,Chattisgarh',
'Siud,Bilaspur,Chattisgarh',
'Sukli,Bilaspur,Chattisgarh',
'Taga,Bilaspur,Chattisgarh',
'Tilai,Bilaspur,Chattisgarh',
'Bilari,Bilaspur,Chattisgarh',
'Borda,Bilaspur,Chattisgarh',
'Borda,Bilaspur,Chattisgarh',
'Bundela,Bilaspur,Chattisgarh',
'Dhardei,Bilaspur,Chattisgarh',
'Godhna,Bilaspur,Chattisgarh',
'Kachanda,Bilaspur,Chattisgarh',
'Khisora,Bilaspur,Chattisgarh',
'Khorsi,Bilaspur,Chattisgarh',
'Loharsi,Bilaspur,Chattisgarh',
'Rahod,Bilaspur,Chattisgarh',
'Salkhan,Bilaspur,Chattisgarh',
'Tanod,Bilaspur,Chattisgarh',
'Tiwaripara,Bilaspur,Chattisgarh',
'Adbhar,Bilaspur,Chattisgarh',
'Basin,Bilaspur,Chattisgarh',
'Malkharoda,Bilaspur,Chattisgarh',
'Pandadah,Durg,Chattisgarh',
'Piparia,Durg,Chattisgarh',
'Singarghat,Durg,Chattisgarh',
'Aundhi,Durg,Chattisgarh',
'Bharritola,Durg,Chattisgarh',
'Bhawsha,Durg,Chattisgarh',
'Dhokla,Durg,Chattisgarh',
'Dighwadi,Durg,Chattisgarh',
'Ghotia,Durg,Chattisgarh',
'Kandadi,Durg,Chattisgarh',
'Khadgaon,Durg,Chattisgarh',
'Kumhari,Durg,Chattisgarh',
'Manpur,Durg,Chattisgarh',
'Nawagaon,Durg,Chattisgarh',
'Nedgaon,Durg,Chattisgarh',
'Sarkheda,Durg,Chattisgarh',
'Seoni,Durg,Chattisgarh',
'Sitagaon,Durg,Chattisgarh',
'Teregaon,Durg,Chattisgarh',
'Tohe,Durg,Chattisgarh',
'Alkanhar,Durg,Chattisgarh',
'Dumartola,Durg,Chattisgarh',
'Gotatola,Durg,Chattisgarh',
'Kakaipar,Durg,Chattisgarh',
'Kandadi,Durg,Chattisgarh',
'Kande,Durg,Chattisgarh',
'Korramtola,Durg,Chattisgarh',
'Kumhali,Durg,Chattisgarh',
'Mohla,Durg,Chattisgarh',
'Mukadah,Durg,Chattisgarh',
'Panbaras,Durg,Chattisgarh',
'Rengakathera,Durg,Chattisgarh',
'Somatola,Durg,Chattisgarh',
'Arjuni,Durg,Chattisgarh',
'Baghera,Durg,Chattisgarh',
'Bajrangpur Nawagaon,Durg,Chattisgarh',
'Bakal,Durg,Chattisgarh',
'Bazar Rajnadngaon,Durg,Chattisgarh',
'Bhainstara,Durg,Chattisgarh',
'Bharregaon,Durg,Chattisgarh',
'Bhedikala,Durg,Chattisgarh',
'Bijetala,Durg,Chattisgarh',
'Bori,Durg,Chattisgarh',
'Dhangaon,Durg,Chattisgarh',
'Dilapahari,Durg,Chattisgarh',
'Dumardihkhurd,Durg,Chattisgarh',
'G G Chowk Rajnandgaon,Durg,Chattisgarh',
'Gataparkala,Durg,Chattisgarh',
'Ghumka,Durg,Chattisgarh',
'Jangalpur,Durg,Chattisgarh',
'Kanharpuri,Durg,Chattisgarh',
'Karamtaa,Durg,Chattisgarh',
'Khaprikhurd,Durg,Chattisgarh',
'Lakholi,Durg,Chattisgarh',
'Mahrumkala,Durg,Chattisgarh',
'Mangata,Durg,Chattisgarh',
'Mohara,Durg,Chattisgarh',
'Nagaldah,Durg,Chattisgarh',
'Padumtaa,Durg,Chattisgarh',
'Paneka,Durg,Chattisgarh',
'Patewa,Durg,Chattisgarh',
'Pendri,Durg,Chattisgarh',
'Rajnandgaon H.O,Durg,Chattisgarh',
'Rajnandgaon Kutchery,Durg,Chattisgarh',
'Rajnandgaon Stadium,Durg,Chattisgarh',
'Rengakathera,Durg,Chattisgarh',
'Saloni,Durg,Chattisgarh',
'Singarpur,Durg,Chattisgarh',
'Singhola,Durg,Chattisgarh',
'Somni,Durg,Chattisgarh',
'Surgi,Durg,Chattisgarh',
'Tedesara,Durg,Chattisgarh',
'Tumdibod,Durg,Chattisgarh',
'Uparwah,Durg,Chattisgarh',
'Ramanujganj,Raigarh,Chattisgarh',
'Baneya,Raigarh,Chattisgarh',
'Barion,Raigarh,Chattisgarh',
'Sakalo,Raigarh,Chattisgarh',
'Ajabnagar,Raigarh,Chattisgarh',
'Ambikapur Nyalaya,Raigarh,Chattisgarh',
'Ambikapur Town,Raigarh,Chattisgarh',
'Arabalrampur,Raigarh,Chattisgarh',
'Baghima,Raigarh,Chattisgarh',
'Bardar,Raigarh,Chattisgarh',
'Bargwan,Raigarh,Chattisgarh',
'Baskepi,Raigarh,Chattisgarh',
'Bhithi,Raigarh,Chattisgarh',
'Chando,Raigarh,Chattisgarh',
'Darima,Raigarh,Chattisgarh',
'Dhandhapur,Raigarh,Chattisgarh',
'Fundul Dihari,Raigarh,Chattisgarh',
'Kakna,Raigarh,Chattisgarh',
'Kalyanpur,Raigarh,Chattisgarh',
'Karjee,Raigarh,Chattisgarh',
'Karwan,Raigarh,Chattisgarh',
'Kundikala,Raigarh,Chattisgarh',
'Latori,Raigarh,Chattisgarh',
'Maharajganj,Raigarh,Chattisgarh',
'Nandamali,Raigarh,Chattisgarh',
'Nawanagar,Raigarh,Chattisgarh',
'Parsa,Raigarh,Chattisgarh',
'Pratapgarh,Raigarh,Chattisgarh',
'Raghavpuri,Raigarh,Chattisgarh',
'Rajpur (SIJ),Raigarh,Chattisgarh',
'Sakhari,Raigarh,Chattisgarh',
'Sakholi,Raigarh,Chattisgarh',
'Sendur,Raigarh,Chattisgarh',
'Shahpur,Raigarh,Chattisgarh',
'Silphili,Raigarh,Chattisgarh',
'Songara,Raigarh,Chattisgarh',
'Ambikapur H.O,Raigarh,Chattisgarh',
'Balrampur,Raigarh,Chattisgarh',
'Bhulsikala,Raigarh,Chattisgarh',
'Dumarkhola,Raigarh,Chattisgarh',
'Gajadharpur,Raigarh,Chattisgarh',
'Jamirapath,Raigarh,Chattisgarh',
'Jawaharnagar,Raigarh,Chattisgarh',
'Karoundha,Raigarh,Chattisgarh',
'Katima,Raigarh,Chattisgarh',
'Kusmi,Raigarh,Chattisgarh',
'Larima,Raigarh,Chattisgarh',
'Madguri,Raigarh,Chattisgarh',
'Rehda,Raigarh,Chattisgarh',
'Sabag,Raigarh,Chattisgarh',
'Samri,Raigarh,Chattisgarh',
'Umko,Raigarh,Chattisgarh',
'Arooti,Raigarh,Chattisgarh',
'Dandgaon,Raigarh,Chattisgarh',
'Jamdih,Raigarh,Chattisgarh',
'Jamgala,Raigarh,Chattisgarh',
'Kedma,Raigarh,Chattisgarh',
'Khamhariya,Raigarh,Chattisgarh',
'Kunni,Raigarh,Chattisgarh',
'Lahpatra,Raigarh,Chattisgarh',
'Lakhanpur,Raigarh,Chattisgarh',
'Laxmangarh,Raigarh,Chattisgarh',
'Mahagai,Raigarh,Chattisgarh',
'Salka,Raigarh,Chattisgarh',
'Sayar,Raigarh,Chattisgarh',
'Tara,Raigarh,Chattisgarh',
'Turna,Raigarh,Chattisgarh',
'Udaipur,Raigarh,Chattisgarh',
'Balangi,Raigarh,Chattisgarh',
'Basantpur,Raigarh,Chattisgarh',
'Biharpur,Raigarh,Chattisgarh',
'Birendranagar,Raigarh,Chattisgarh',
'Janakpur,Raigarh,Chattisgarh',
'Karamdiha,Raigarh,Chattisgarh',
'Khod,Raigarh,Chattisgarh',
'Mahewa,Raigarh,Chattisgarh',
'Moharsop,Raigarh,Chattisgarh',
'Nagoi,Raigarh,Chattisgarh',
'Pasupatipur,Raigarh,Chattisgarh',
'Pendri,Raigarh,Chattisgarh',
'Pratappur,Raigarh,Chattisgarh',
'Raghunathnagar,Raigarh,Chattisgarh',
'Salwahi,Raigarh,Chattisgarh',
'Sulsuli,Raigarh,Chattisgarh',
'Wadrafnagar,Raigarh,Chattisgarh',
'Gudru,Raigarh,Chattisgarh',
'Babouli,Raigarh,Chattisgarh',
'Bargidih,Raigarh,Chattisgarh',
'Bataikela,Raigarh,Chattisgarh',
'Batouli,Raigarh,Chattisgarh',
'Bhusu,Raigarh,Chattisgarh',
'Chiranga,Raigarh,Chattisgarh',
'Deogarh,Raigarh,Chattisgarh',
'Dhodhagaon,Raigarh,Chattisgarh',
'Dhourpur,Raigarh,Chattisgarh',
'Dumardiha,Raigarh,Chattisgarh',
'Girhuildih,Raigarh,Chattisgarh',
'Jajga,Raigarh,Chattisgarh',
'Kamleshwarpur,Raigarh,Chattisgarh',
'Katkalo,Raigarh,Chattisgarh',
'Khadadorna,Raigarh,Chattisgarh',
'Kot,Raigarh,Chattisgarh',
'Lamgaon,Raigarh,Chattisgarh',
'Lundra,Raigarh,Chattisgarh',
'Narbadapur,Raigarh,Chattisgarh',
'Patora,Raigarh,Chattisgarh',
'Petla,Raigarh,Chattisgarh',
'Poksari,Raigarh,Chattisgarh',
'Raghunathpur,Raigarh,Chattisgarh',
'Sarga,Raigarh,Chattisgarh',
'Sedam,Raigarh,Chattisgarh',
'Sitapur,Raigarh,Chattisgarh',
'Sur,Raigarh,Chattisgarh',
'Udari,Raigarh,Chattisgarh',
'Urdara,Raigarh,Chattisgarh',
'Baijnathpur,Raigarh,Chattisgarh',
'Banja,Raigarh,Chattisgarh',
'Basdei,Raigarh,Chattisgarh',
'Batra,Raigarh,Chattisgarh',
'Bhaiyathan,Raigarh,Chattisgarh',
'Bhatgaon Colly,Raigarh,Chattisgarh',
'Bhuneshwarpur,Raigarh,Chattisgarh',
'Bishrampur,Raigarh,Chattisgarh',
'Chandramedha,Raigarh,Chattisgarh',
'Chungudi,Raigarh,Chattisgarh',
'Darripara,Raigarh,Chattisgarh',
'Dawna,Raigarh,Chattisgarh',
'Dedri,Raigarh,Chattisgarh',
'Deonagar,Raigarh,Chattisgarh',
'Ganeshpur,Raigarh,Chattisgarh',
'Gangikot,Raigarh,Chattisgarh',
'Jainagar,Raigarh,Chattisgarh',
'Jarhi,Raigarh,Chattisgarh',
'Kanchanpur,Raigarh,Chattisgarh',
'Kandrai,Raigarh,Chattisgarh',
'Karanji,Raigarh,Chattisgarh',
'Ketka,Raigarh,Chattisgarh',
'Krishnangar,Raigarh,Chattisgarh',
'Kumda Colly,Raigarh,Chattisgarh',
'Lanjit,Raigarh,Chattisgarh',
'Madanpur,Raigarh,Chattisgarh',
'Nawapurakalan,Raigarh,Chattisgarh',
'Orgi,Raigarh,Chattisgarh',
'Parshurampur,Raigarh,Chattisgarh',
'Patnakot,Raigarh,Chattisgarh',
'Patrapali,Raigarh,Chattisgarh',
'Premnagar,Raigarh,Chattisgarh',
'Ramanujnagar,Raigarh,Chattisgarh',
'Ramnagar,Raigarh,Chattisgarh',
'Salhi,Raigarh,Chattisgarh',
'Salka,Raigarh,Chattisgarh',
'Sirsi,Raigarh,Chattisgarh',
'Surajpur,Raigarh,Chattisgarh',
'Tiwragudi,Raigarh,Chattisgarh',
'Umeshwarpur,Raigarh,Chattisgarh',
'Annapara,Raigarh,Chattisgarh',
'Aragarhi Camp,Raigarh,Chattisgarh',
'Bakalo,Raigarh,Chattisgarh',
'Bartikala,Raigarh,Chattisgarh',
'Bhedia,Raigarh,Chattisgarh',
'Bhendri,Raigarh,Chattisgarh',
'Chaki,Raigarh,Chattisgarh',
'Chalgahikhas,Raigarh,Chattisgarh',
'Chandora,Raigarh,Chattisgarh',
'Chandranagar,Raigarh,Chattisgarh',
'Chhattarpur,Raigarh,Chattisgarh',
'Chiniya,Raigarh,Chattisgarh',
'Dawra,Raigarh,Chattisgarh',
'Dharampur,Raigarh,Chattisgarh',
'Dipadih,Raigarh,Chattisgarh',
'Dolangi,Raigarh,Chattisgarh',
'Durgapur,Raigarh,Chattisgarh',
'Ganjar,Raigarh,Chattisgarh',
'Ghughari,Raigarh,Chattisgarh',
'Gopalpur,Raigarh,Chattisgarh',
'Govindpur,Raigarh,Chattisgarh',
'Guturma,Raigarh,Chattisgarh',
'Jajawal,Raigarh,Chattisgarh',
'Jamkani,Raigarh,Chattisgarh',
'Jhalaria,Raigarh,Chattisgarh',
'Jhingo,Raigarh,Chattisgarh',
'Jigdi,Raigarh,Chattisgarh',
'Kamari,Raigarh,Chattisgarh',
'Karra,Raigarh,Chattisgarh',
'Karsi,Raigarh,Chattisgarh',
'Ketka,Raigarh,Chattisgarh',
'Kewra,Raigarh,Chattisgarh',
'Khadgaon,Raigarh,Chattisgarh',
'Koteya,Raigarh,Chattisgarh',
'Kotli,Raigarh,Chattisgarh',
'Krishnanagar,Raigarh,Chattisgarh',
'Lodha,Raigarh,Chattisgarh',
'Lolki,Raigarh,Chattisgarh',
'Lurgikala,Raigarh,Chattisgarh',
'Manoharpur,Raigarh,Chattisgarh',
'Masga,Raigarh,Chattisgarh',
'Mitgai,Raigarh,Chattisgarh',
'Narsinghpur,Raigarh,Chattisgarh',
'Padhi,Raigarh,Chattisgarh',
'Parsagudi,Raigarh,Chattisgarh',
'Peni,Raigarh,Chattisgarh',
'Ramchandranagar,Raigarh,Chattisgarh',
'Ramkola,Raigarh,Chattisgarh',
'Ranhat,Raigarh,Chattisgarh',
'Rewti,Raigarh,Chattisgarh',
'Sankargarh,Raigarh,Chattisgarh',
'Semarkalan,Raigarh,Chattisgarh',
'Sewari,Raigarh,Chattisgarh',
'Sihar,Raigarh,Chattisgarh',
'Sonawal,Raigarh,Chattisgarh',
'Tatapani,Raigarh,Chattisgarh',
'Ulkia,Raigarh,Chattisgarh',
'Vijaynagar,Raigarh,Chattisgarh',
'Amboli,Valsad,Dadra & Nagar Haveli',
'Amli,Valsad,Dadra & Nagar Haveli',
'Athola,Valsad,Dadra & Nagar Haveli',
'Bedpa,Valsad,Dadra & Nagar Haveli',
'Bonta,Valsad,Dadra & Nagar Haveli',
'Chibhadkutch,Valsad,Dadra & Nagar Haveli',
'Chikhli,Valsad,Dadra & Nagar Haveli',
'Chinchpada,Valsad,Dadra & Nagar Haveli',
'Chisda,Valsad,Dadra & Nagar Haveli',
'Rakholi,Valsad,Dadra & Nagar Haveli',
'Rudana,Valsad,Dadra & Nagar Haveli',
'Saily,Valsad,Dadra & Nagar Haveli',
'Samarvarni,Valsad,Dadra & Nagar Haveli',
'Selti,Valsad,Dadra & Nagar Haveli',
'Sili,Valsad,Dadra & Nagar Haveli',
'Silvassa,Valsad,Dadra & Nagar Haveli',
'Sindoni,Valsad,Dadra & Nagar Haveli',
'Surangi,Valsad,Dadra & Nagar Haveli',
'Umarkui,Valsad,Dadra & Nagar Haveli',
'Vasona,Valsad,Dadra & Nagar Haveli',
'Velugam,Valsad,Dadra & Nagar Haveli',
'Dungra,Valsad,Dadra & Nagar Haveli',
'Karvad,Valsad,Dadra & Nagar Haveli',
'Bhimpore,Valsad,Daman & Diu',
'Dabhel,Valsad,Daman & Diu',
'Daman I.E.,Valsad,Daman & Diu',
'Daman,Valsad,Daman & Diu',
'Varkund,Valsad,Daman & Diu',
'Bucharvada,Junagadh,Daman & Diu',
'Diu,Junagadh,Daman & Diu',
'Diu Zampa,Junagadh,Daman & Diu',
'Fudam,Junagadh,Daman & Diu',
'Ghoghla,Junagadh,Daman & Diu',
'Wanakbara,Junagadh,Daman & Diu',
'Hauz Qazi,New Delhi Central,Delhi',
'Jama Masjid,New Delhi Central,Delhi',
'A.G.C.R.,New Delhi Central,Delhi',
'A.K.Market,New Delhi Central,Delhi',
'Ajmeri Gate Extn.,New Delhi Central,Delhi',
'Anand Parbat Indl. Area,New Delhi Central,Delhi',
'Anand Parbat,New Delhi Central,Delhi',
'Bank Street,New Delhi Central,Delhi',
'Baroda House,New Delhi Central,Delhi',
'Bengali Market,New Delhi Central,Delhi',
'Bhagat Singh Market,New Delhi Central,Delhi',
'Connaught Place,New Delhi Central,Delhi',
'Constitution House,New Delhi Central,Delhi',
'Dada Ghosh Bhawan,New Delhi Central,Delhi',
'Darya Ganj,New Delhi Central,Delhi',
'Delhi High Court,New Delhi Central,Delhi',
'Desh Bandhu Gupta Road,New Delhi Central,Delhi',
'Election Commission,New Delhi Central,Delhi',
'Gandhi Smarak Nidhi,New Delhi Central,Delhi',
'Guru Gobind Singh Marg,New Delhi Central,Delhi',
'Gym Khana Club,New Delhi Central,Delhi',
'I.A.R.I.,New Delhi Central,Delhi',
'I.P.Estate,New Delhi Central,Delhi',
'Inderpuri,New Delhi Central,Delhi',
'Indraprastha H.O,New Delhi Central,Delhi',
'Janpath,New Delhi Central,Delhi',
'Karol Bagh,New Delhi Central,Delhi',
'Krishi Bhawan,New Delhi Central,Delhi',
'Lady Harding Medical College,New Delhi Central,Delhi',
'Master Prithvi Nath Marg,New Delhi Central,Delhi',
'Minto Road,New Delhi Central,Delhi',
'Multani Dhanda,New Delhi Central,Delhi',
'National Physical Laboratory,New Delhi Central,Delhi',
'Nirman Bhawan,New Delhi Central,Delhi',
'North Avenue,New Delhi Central,Delhi',
'Pahar Ganj,New Delhi Central,Delhi',
'Pandara Road,New Delhi Central,Delhi',
'Parliament House,New Delhi Central,Delhi',
'Patel Nagar East,New Delhi Central,Delhi',
'Patel Nagar,New Delhi Central,Delhi',
'Patel Nagar South,New Delhi Central,Delhi',
'Patel Nagar West,New Delhi Central,Delhi',
'Patiala House,New Delhi Central,Delhi',
'Pragati Maidan,New Delhi Central,Delhi',
'Rail Bhawan,New Delhi Central,Delhi',
'Rajender Nagar,New Delhi Central,Delhi',
'Rajghat Power House,New Delhi Central,Delhi',
'Rashtrapati Bhawan,New Delhi Central,Delhi',
'Sansad Marg H.O,New Delhi Central,Delhi',
'Sansadiya Soudh,New Delhi Central,Delhi',
'Sat Nagar,New Delhi Central,Delhi',
'Secretariat North,New Delhi Central,Delhi',
'Shastri Bhawan,New Delhi Central,Delhi',
'South Avenue,New Delhi Central,Delhi',
'Supreme Court,New Delhi Central,Delhi',
'Swami Ram Tirth Nagar,New Delhi Central,Delhi',
'Udyog Bhawan,New Delhi Central,Delhi',
'Union Public Service Commissio,New Delhi Central,Delhi',
'Babarpur,Delhi East,Delhi',
'Brahampuri,Delhi East,Delhi',
'Anand Vihar,Delhi East,Delhi',
'Azad Nagar,Delhi East,Delhi',
'Chilla,Delhi East,Delhi',
'Distt. Court (KKD),Delhi East,Delhi',
'Gandhi Nagar Bazar,Delhi East,Delhi',
'Gandhi Nagar,Delhi East,Delhi',
'Geeta Colony,Delhi East,Delhi',
'Ghazipur,Delhi East,Delhi',
'Govind Pura,Delhi East,Delhi',
'Himmatpuri,Delhi East,Delhi',
'Kailash Nagar,Delhi East,Delhi',
'Kalyanpuri,Delhi East,Delhi',
'Kalyanvas,Delhi East,Delhi',
'Krishna Nagar H.O,Delhi East,Delhi',
'Laxmi Nagar,Delhi East,Delhi',
'Mandawali Fazalpur,Delhi East,Delhi',
'Mayur Vihar Ph-I,Delhi East,Delhi',
'Mayur Vihar Ph-III,Delhi East,Delhi',
'Nirman Vihar,Delhi East,Delhi',
'Patparganj,Delhi East,Delhi',
'Raghubar Pura,Delhi East,Delhi',
'Rajgarh Colony,Delhi East,Delhi',
'Ram Nagar,Delhi East,Delhi',
'Shakarpur,Delhi East,Delhi',
'Shastri Nagar,Delhi East,Delhi',
'Surajmal Vihar,Delhi East,Delhi',
'Trilok Puri,Delhi East,Delhi',
'V.K. Nagar,Delhi East,Delhi',
'Vasundhra Enclave,Delhi East,Delhi',
'Vishwas Nagar,Delhi East,Delhi',
'Vivek Vihar,Delhi East,Delhi',
'Yozna Vihar,Delhi East,Delhi',
'Balbir Nagar,Delhi East,Delhi',
'Bhajan Pura,Delhi East,Delhi',
'Bhola Nath Nagar,Delhi East,Delhi',
'Dayalpur,Delhi East,Delhi',
'Dilshad Garden,Delhi East,Delhi',
'G.T.B. Hospital,Delhi East,Delhi',
'Ghonda,Delhi East,Delhi',
'Gokal Puri,Delhi East,Delhi',
'Goverdhan Bihari Colony,Delhi East,Delhi',
'Jafrabad,Delhi East,Delhi',
'Jagjit Nagar,Delhi East,Delhi',
'Jhilmil H.O,Delhi East,Delhi',
'Jhilmil Tahirpur,Delhi East,Delhi',
'Johripur,Delhi East,Delhi',
'Karawal Nagar,Delhi East,Delhi',
'Khazuri Khas,Delhi East,Delhi',
'Loni Road Housing Complex,Delhi East,Delhi',
'Loni Road,Delhi East,Delhi',
'Man Sarovar Park,Delhi East,Delhi',
'Mandoli Saboli,Delhi East,Delhi',
'Maujpur,Delhi East,Delhi',
'Nand Nagri "A",Delhi East,Delhi',
'Nand Nagri "C",Delhi East,Delhi',
'New Seemapuri,Delhi East,Delhi',
'New Usmanpur,Delhi East,Delhi',
'Old Seemapuri,Delhi East,Delhi',
'Rohtash Nagar,Delhi East,Delhi',
'Sabhapur,Delhi East,Delhi',
'Seelampur,Delhi East,Delhi',
'Shahdara Mandi,Delhi East,Delhi',
'Shahdara,Delhi East,Delhi',
'Shivaji Park,Delhi East,Delhi',
'Sonia Vihar,Delhi East,Delhi',
'Telewara,Delhi East,Delhi',
'Yamuna Vihar,Delhi East,Delhi',
'F F C Okhla,New Delhi South,Delhi',
'New Delhi G.P.O.,New Delhi Gpo,Delhi',
'New Delhi H.O,New Delhi Central,Delhi',
'Baratooti,Delhi North,Delhi',
'Jawahar Nagar,Delhi North,Delhi',
'Rana Pratap Bagh,Delhi North,Delhi',
'Birla Lines,Delhi North,Delhi',
'Burari,Delhi North,Delhi',
'C.C.I.,Delhi North,Delhi',
'Chandni Chowk,Delhi North,Delhi',
'Chawri Bazar,Delhi North,Delhi',
'Civil Lines,Delhi North,Delhi',
'Dareeba,Delhi North,Delhi',
'Delhi G.P.O.,Delhi Gpo,Delhi',
'Delhi Sadar Bazar,Delhi North,Delhi',
'Delhi University,Delhi North,Delhi',
'Distt Courts,Delhi North,Delhi',
'Gulabi Bagh,Delhi North,Delhi',
'Jagatpur,Delhi North,Delhi',
'Jharoda Majraa,Delhi North,Delhi',
'Kamla Nagar,Delhi North,Delhi',
'Malka Ganj,Delhi North,Delhi',
'Padam Nagar,Delhi North,Delhi',
'Patrachar Vidyalay,Delhi North,Delhi',
'R.C.A.O.,Delhi North,Delhi',
'R K Puram (Main),New Delhi South West,Delhi',
'R K Puram Sect-1,New Delhi South West,Delhi',
'R K Puram Sect-12,New Delhi South West,Delhi',
'R K Puram Sect-3,New Delhi South West,Delhi',
'R K Puram Sect-4,New Delhi South West,Delhi',
'R K Puram Sect-5,New Delhi South West,Delhi',
'R K Puram Sect7,New Delhi South West,Delhi',
'R K Puram Sect-8,New Delhi South West,Delhi',
'R K Puram West,New Delhi South West,Delhi',
'R R Hospital,New Delhi South West,Delhi',
'S J Enclave,New Delhi South West,Delhi',
'S P School,New Delhi South West,Delhi',
'South Delhi Campus,New Delhi South West,Delhi',
'Station Road,New Delhi South West,Delhi',
'Subroto Park,New Delhi South West,Delhi',
'Sultanpur,New Delhi South West,Delhi',
'T B Hospital,New Delhi South West,Delhi',
'Technology Bhawan,New Delhi South West,Delhi',
'Vasant Kunj Pkt-A,New Delhi South West,Delhi',
'Vasant Kunj,New Delhi South West,Delhi',
'Vasant Vihar-1,New Delhi South West,Delhi',
'Vasant Vihar-2,New Delhi South West,Delhi',
'Signal Enclave,New Delhi South West,Delhi',
'Sarojini Nagar H.O,New Delhi South West,Delhi',
'Amberhai,New Delhi West,Delhi',
'Badhosarai,New Delhi West,Delhi',
'Badusarai,New Delhi West,Delhi',
'Bagrola,New Delhi West,Delhi',
'Baprola,New Delhi West,Delhi',
'Barthal,New Delhi West,Delhi',
'Chhawla,New Delhi West,Delhi',
'CRPF Jharoda Kalan,New Delhi West,Delhi',
'D C Goyla,New Delhi West,Delhi',
'D C Nangli Sakravati,New Delhi West,Delhi',
'Dabri,New Delhi West,Delhi',
'Daulatpur,New Delhi West,Delhi',
'Dhulsiras,New Delhi West,Delhi',
'Dichaoal Kalan,New Delhi West,Delhi',
'Dindarpur,New Delhi West,Delhi',
'Dulsiras,New Delhi West,Delhi',
'Dwarka Sec-6,New Delhi West,Delhi',
'Galib Pur,New Delhi West,Delhi',
'Ghuman Hera,New Delhi West,Delhi',
'Indira Park,New Delhi West,Delhi',
'Indira Park,New Delhi West,Delhi',
'Issapur,New Delhi West,Delhi',
'Issapur,New Delhi West,Delhi',
'Jafarpur,New Delhi West,Delhi',
'Jharoda Kalan,New Delhi West,Delhi',
'Jhatikara,New Delhi West,Delhi',
'Kair,New Delhi West,Delhi',
'Kair,New Delhi West,Delhi',
'Kakrola,New Delhi West,Delhi',
'Kangan Heri,New Delhi West,Delhi',
'Khaira,New Delhi West,Delhi',
'Khaira,New Delhi West,Delhi',
'Khera Dabur,New Delhi West,Delhi',
'Malik Pur,New Delhi West,Delhi',
'Malik Pur,New Delhi West,Delhi',
'Maya Puri,New Delhi West,Delhi',
'Mitraon,New Delhi West,Delhi',
'Mundela Kalan,New Delhi West,Delhi',
'N.S.I.T. Dwarka,New Delhi West,Delhi',
'Najafgarh,New Delhi West,Delhi',
'Nangal Raya,New Delhi West,Delhi',
'Naraina Industrial Estate H.O,New Delhi West,Delhi',
'Naraina Village,New Delhi West,Delhi',
'Nasirpur,New Delhi West,Delhi',
'Palam Village,New Delhi West,Delhi',
'Pandwala Kalan,New Delhi West,Delhi',
'Papravat,New Delhi West,Delhi',
'Quazipur,New Delhi West,Delhi',
'Raj Nagar - II,New Delhi West,Delhi',
'Raota,New Delhi West,Delhi',
'Raota,New Delhi West,Delhi',
'Rewla Khanpur,New Delhi West,Delhi',
'Sagarpur,New Delhi West,Delhi',
'Shopping Centre Mayapuri,New Delhi West,Delhi',
'Surehra,New Delhi West,Delhi',
'Tilangpur Kotla,New Delhi West,Delhi',
'Ujwa,New Delhi West,Delhi',
'A-3 Janak Puri,New Delhi West,Delhi',
'Ashok Nagar,New Delhi West,Delhi',
'Ashoka Park Extn.,New Delhi West,Delhi',
'B-1 Janak Puri,New Delhi West,Delhi',
'Bakkarwala,New Delhi West,Delhi',
'C-4 Janak Puri,New Delhi West,Delhi',
'Chand Nagar,New Delhi West,Delhi',
'Chaukhandi,New Delhi West,Delhi',
'D. K. Mohan Garden,New Delhi West,Delhi',
'D.E.S.U. Colony,New Delhi West,Delhi',
'Delhi Industrial Area,New Delhi West,Delhi',
'ESI,New Delhi West,Delhi',
'Fateh Nagar,New Delhi West,Delhi',
'Hari Nagar BE Block,New Delhi West,Delhi',
'Hari Nagar Dadb Block,New Delhi West,Delhi',
'Hari Nagar,New Delhi West,Delhi',
'Hastal Village,New Delhi West,Delhi',
'Hirankudna,New Delhi West,Delhi',
'J-6 Rajouri Garden,New Delhi West,Delhi',
'Jail Road,New Delhi West,Delhi',
'Janta Market,New Delhi West,Delhi',
'Jawala Heri,New Delhi West,Delhi',
'Jeevan Park,New Delhi West,Delhi',
'Jeevan Park,New Delhi West,Delhi',
'Jwala Puri,New Delhi West,Delhi',
'Jwalaheri,New Delhi West,Delhi',
'Karam Pura,New Delhi West,Delhi',
'Khyala Phase - I,New Delhi West,Delhi',
'Khyala Phase - II,New Delhi West,Delhi',
'L. M. Nagar Indl. Area,New Delhi West,Delhi',
'M.B.S. Nagar,New Delhi West,Delhi',
'Madipur Slum Quarter,New Delhi West,Delhi',
'Madipur Village,New Delhi West,Delhi',
'Mahabir Nagar,New Delhi West,Delhi',
'Mansarover Garden,New Delhi West,Delhi',
'Matiala,New Delhi West,Delhi',
'Matiala,New Delhi West,Delhi',
'Mundka,New Delhi West,Delhi',
'N.I.Area,New Delhi West,Delhi',
'Nangloi - II,New Delhi West,Delhi',
'Nangloi - III,New Delhi West,Delhi',
'Nangloi,New Delhi West,Delhi',
'Nilothi,New Delhi West,Delhi',
'Paschim Vihar B Block,New Delhi West,Delhi',
'Paschim Vihar,New Delhi West,Delhi',
'Peeragarhi,New Delhi West,Delhi',
'Punjabi Bagh,New Delhi West,Delhi',
'Punjabi Bagh Sec - III,New Delhi West,Delhi',
'Rajouri Garden,New Delhi West,Delhi',
'Rajouri Market,New Delhi West,Delhi',
'Ramesh Nagar H.O,New Delhi West,Delhi',
'Ranhola,New Delhi West,Delhi',
'Shivaji Park,New Delhi West,Delhi',
'Subhash Nagar,New Delhi West,Delhi',
'Subhash Nagar West,New Delhi West,Delhi',
'Sunder Vihar,New Delhi West,Delhi',
'Tikri Kalan,New Delhi West,Delhi',
'Tilak Nagar East,New Delhi West,Delhi',
'Tilak Nagar,New Delhi West,Delhi',
'Uttam Nagar,New Delhi West,Delhi',
'Vikas Puri,New Delhi West,Delhi',
'Vishnu Garden,New Delhi West,Delhi',
'Zakhira,New Delhi West,Delhi',
'Aldona,Goa,Goa',
'Alto Betim,Goa,Goa',
'Anjuna,Goa,Goa',
'Arambol,Goa,Goa',
'Arpora,Goa,Goa',
'Assagao,Goa,Goa',
'Assonora,Goa,Goa',
'Baga,Goa,Goa',
'Bastora,Goa,Goa',
'Betim,Goa,Goa',
'Caisua,Goa,Goa',
'Calangute,Goa,Goa',
'Calvim,Goa,Goa',
'Camurlim,Goa,Goa',
'Canca,Goa,Goa',
'Candolim,Goa,Goa',
'Carona,Goa,Goa',
'Colvale,Goa,Goa',
'Corjuim,Goa,Goa',
'Dhagalim,Goa,Goa',
'Gurim,Goa,Goa',
'Mapusa I.E.,Goa,Goa',
'Mapusa,Goa,Goa',
'Menkurim,Goa,Goa',
'Moira,Goa,Goa',
'Nachinola,Goa,Goa',
'Oxel,Goa,Goa',
'Parra,Goa,Goa',
'Penha De France,Goa,Goa',
'Pernem,Goa,Goa',
'Pilerne,Goa,Goa',
'Pirna,Goa,Goa',
'Pomburpa,Goa,Goa',
'Porvorim,Goa,Goa',
'Revora,Goa,Goa',
'Saipem,Goa,Goa',
'Saligao,Goa,Goa',
'Salvador De Mond,Goa,Goa',
'Sangolda,Goa,Goa',
'Sem Saligao,Goa,Goa',
'Sinquerim,Goa,Goa',
'Siolim,Goa,Goa',
'Tivim Ie,Goa,Goa',
'Tivim,Goa,Goa',
'Ucassiam,Goa,Goa',
'Advalpal,Goa,Goa',
'Bicholim Industrial Estate,Goa,Goa',
'Bicholim,Goa,Goa',
'Carapur,Goa,Goa',
'Cudne,Goa,Goa',
'Dodamarg,Goa,Goa',
'Maulinge,Goa,Goa',
'Mayem,Goa,Goa',
'Morlem,Goa,Goa',
'Mulgao,Goa,Goa',
'Nanora,Goa,Goa',
'Navelim,Goa,Goa',
'Pilgao,Goa,Goa',
'Pratapnagar Harvale,Goa,Goa',
'Curchorem,Goa,Goa',
'Fatorpa,Goa,Goa',
'Pirla,Goa,Goa',
'Quepem,Goa,Goa',
'Sirvoi,Goa,Goa',
'Xeldem,Goa,Goa',
'Xelvona,Goa,Goa',
'Ambelim,Goa,Goa',
'Aquem,Goa,Goa',
'Assolda,Goa,Goa',
'Assolna,Goa,Goa',
'Balli,Goa,Goa',
'Benaulim,Goa,Goa',
'Betalbhatim,Goa,Goa',
'Betul,Goa,Goa',
'Camurlim,Goa,Goa',
'Cansaulim,Goa,Goa',
'Carmona,Goa,Goa',
'Cavelossim,Goa,Goa',
'Cavorim,Goa,Goa',
'Chandor,Goa,Goa',
'Chinchinim,Goa,Goa',
'Colva,Goa,Goa',
'Cortalim,Goa,Goa',
'Curtorim,Goa,Goa',
'Davorlim,Goa,Goa',
'Dramapur,Goa,Goa',
'Fatorda,Goa,Goa',
'Gandhi Market Complex Margao,Goa,Goa',
'Gogol,Goa,Goa',
'Guirdolim PSSK,Goa,Goa',
'Loutolim,Goa,Goa',
'Macazana,Goa,Goa',
'Majorda,Goa,Goa',
'Morpirla,Goa,Goa',
'Nagao,Goa,Goa',
'Navelim Camp,Goa,Goa',
'Navelim,Goa,Goa',
'Nuvem,Goa,Goa',
'Orlim,Goa,Goa',
'Raia,Goa,Goa',
'Sem-rachol Soso,Goa,Goa',
'Seraulim,Goa,Goa',
'St. Jose De Areal,Goa,Goa',
'Talaulim,Goa,Goa',
'Utorda,Goa,Goa',
'Vanelim,Goa,Goa',
'Varca,Goa,Goa',
'Velim,Goa,Goa',
'Velsao PSSK,Goa,Goa',
'Verna,Goa,Goa',
'Veroda,Goa,Goa',
'Margao H.O,Goa,Goa',
'Betul,Goa,Goa',
'Bati,Goa,Goa',
'Calem,Goa,Goa',
'Curdi,Goa,Goa',
'Molcarnem,Goa,Goa',
'Netorlim,Goa,Goa',
'Rivona,Goa,Goa',
'Ugvem,Goa,Goa',
'Valkini,Goa,Goa',
'Mollem,Goa,Goa',
'Sanguem,Goa,Goa',
'Sigao,Goa,Goa',
'Amona,Goa,Goa',
'Cundiam,Goa,Goa',
'Ahmedabad G.P.O.,Ahmedabad Gpo,Gujarat',
'Ambawadi,Ahmedabad City,Gujarat',
'Ambawadi Vistar,Ahmedabad City,Gujarat',
'Amraiwadi,Ahmedabad City,Gujarat',
'Anandnagar,Ahmedabad City,Gujarat',
'Asarwa Chakla,Ahmedabad City,Gujarat',
'Asarwa Ext South,Ahmedabad City,Gujarat',
'Ashram Road,Ahmedabad City,Gujarat',
'Azad Society,Ahmedabad City,Gujarat',
'Bapunagar,Ahmedabad City,Gujarat',
'Behrampura,Ahmedabad City,Gujarat',
'Bhairavnath Road,Ahmedabad City,Gujarat',
'Bilasia,Ahmedabad City,Gujarat',
'Bodakdev,Ahmedabad City,Gujarat',
'Calico Mills,Ahmedabad City,Gujarat',
'Cantonment,Ahmedabad City,Gujarat',
'Civil Hospital,Ahmedabad City,Gujarat',
'Ctm Char Rasta,Ahmedabad City,Gujarat',
'D Cabin,Ahmedabad City,Gujarat',
'Dariapur,Ahmedabad City,Gujarat',
'Daxini Society,Ahmedabad City,Gujarat',
'Delhi Gate,Ahmedabad City,Gujarat',
'District Court,Ahmedabad City,Gujarat',
'Dudheshwar Tavdipura,Ahmedabad City,Gujarat',
'Ellisbridge,Ahmedabad City,Gujarat',
'Gandhi Ashram,Ahmedabad City,Gujarat',
'Gandhi Road,Ahmedabad City,Gujarat',
'Ghatlodia,Ahmedabad City,Gujarat',
'Gheekanta Road,Ahmedabad City,Gujarat',
'Ghodasar,Ahmedabad City,Gujarat',
'Girdharnagar,Ahmedabad City,Gujarat',
'Gita Mandir Road,Ahmedabad City,Gujarat',
'Gomtipur,Ahmedabad City,Gujarat',
'Gujarat University,Ahmedabad City,Gujarat',
'I E Bapunagar,Ahmedabad City,Gujarat',
'I I M,Ahmedabad City,Gujarat',
'Isanpur,Ahmedabad City,Gujarat',
'Jamalpur,Ahmedabad City,Gujarat',
'Jawahar Chowk,Ahmedabad City,Gujarat',
'Jivraj Park,Ahmedabad City,Gujarat',
'Jodhpur Char Rasta,Ahmedabad City,Gujarat',
'Juhapura,Ahmedabad City,Gujarat',
'Kabir Chowk,Ahmedabad City,Gujarat',
'Kalupur Chakla,Ahmedabad City,Gujarat',
'Khadia,Ahmedabad City,Gujarat',
'Khanpur,Ahmedabad City,Gujarat',
'Khodiyarnagar,Ahmedabad City,Gujarat',
'Khokhara Mehmadabad,Ahmedabad City,Gujarat',
'Krishnanagar,Ahmedabad City,Gujarat',
'Kubernagar B A,Ahmedabad City,Gujarat',
'Kubernagar,Ahmedabad City,Gujarat',
'L G Hospital,Ahmedabad City,Gujarat',
'Lal Darwaja,Ahmedabad City,Gujarat',
'Limbadia,Ahmedabad City,Gujarat',
'M D Marg,Ahmedabad City,Gujarat',
'Madhupura Market,Ahmedabad City,Gujarat',
'Makarba,Ahmedabad City,Gujarat',
'Manek Chowk,Ahmedabad City,Gujarat',
'Maninagar,Ahmedabad City,Gujarat',
'Medra,Ahmedabad City,Gujarat',
'Meghaningar,Ahmedabad City,Gujarat',
'Memnagar,Ahmedabad City,Gujarat',
'Motera,Ahmedabad City,Gujarat',
'Municipal Corporation,Ahmedabad City,Gujarat',
'N C Market,Ahmedabad City,Gujarat',
'N C Mills,Ahmedabad City,Gujarat',
'Nana Chiloda,Ahmedabad City,Gujarat',
'Naranpura Vistar,Ahmedabad City,Gujarat',
'Narayannagar,Ahmedabad City,Gujarat',
'Naroda I E,Ahmedabad City,Gujarat',
'Naroda Road,Ahmedabad City,Gujarat',
'Naroda S A,Ahmedabad City,Gujarat',
'Naroda,Ahmedabad City,Gujarat',
'Nava Vadaj,Ahmedabad City,Gujarat',
'Navjivan,Ahmedabad City,Gujarat',
'Navrangpura H.O,Ahmedabad City,Gujarat',
'Nikol,Ahmedabad City,Gujarat',
'Noblenagar,Ahmedabad City,Gujarat',
'O N G C,Ahmedabad City,Gujarat',
'Paldi,Ahmedabad City,Gujarat',
'Pardhol,Ahmedabad City,Gujarat',
'Polytechnic,Ahmedabad City,Gujarat',
'Post Bureau Extn Counter,Ahmedabad City,Gujarat',
'Public Office,Ahmedabad City,Gujarat',
'Raikhad,Ahmedabad City,Gujarat',
'Railway Colony,Ahmedabad City,Gujarat',
'Railwaypura,Ahmedabad City,Gujarat',
'Raipur,Ahmedabad City,Gujarat',
'Rajpur Gomtipur,Ahmedabad City,Gujarat',
'Rakhial,Ahmedabad City,Gujarat',
'Rakhial Udyog Vistar,Ahmedabad City,Gujarat',
'Revdibazar H.O,Ahmedabad City,Gujarat',
'S A C,Ahmedabad City,Gujarat',
'S A Mills,Ahmedabad City,Gujarat',
'Sabarmati,Ahmedabad City,Gujarat',
'Saijpur Bogha,Ahmedabad City,Gujarat',
'Saraspur,Ahmedabad City,Gujarat',
'Sardarnagar,Ahmedabad City,Gujarat',
'Sarkhej Road,Ahmedabad City,Gujarat',
'Shah Alam Roza,Ahmedabad City,Gujarat',
'Shahibag,Ahmedabad City,Gujarat',
'Shahpur,Ahmedabad City,Gujarat',
'Shardanagar,Ahmedabad City,Gujarat',
'Shastrinagar,Ahmedabad City,Gujarat',
'Sola H B C,Ahmedabad City,Gujarat',
'Stadium Marg,Ahmedabad City,Gujarat',
'Sub Foreign,Ahmedabad City,Gujarat',
'Sukhrampura,Ahmedabad City,Gujarat',
'T B Nagar,Ahmedabad City,Gujarat',
'Thaltej Road,Ahmedabad City,Gujarat',
'Vadaj,Ahmedabad City,Gujarat',
'Vasisthnagar,Ahmedabad City,Gujarat',
'Vehlal,Ahmedabad City,Gujarat',
'Vejalpur,Ahmedabad City,Gujarat',
'Chandlodia,Gandhinagar,Gujarat',
'Gujrat High Court,Gandhinagar,Gujarat',
'Gyaspur,Gandhinagar,Gujarat',
'Kali,Gandhinagar,Gujarat',
'Nirnaynagar,Gandhinagar,Gujarat',
'Odhav Industrial Estate,Gandhinagar,Gujarat',
'Odhav,Gandhinagar,Gujarat',
'Ranip,Gandhinagar,Gujarat',
'Saijpur,Gandhinagar,Gujarat',
'Sarkhej,Gandhinagar,Gujarat',
'Shahwadi,Gandhinagar,Gujarat',
'Tragad,Gandhinagar,Gujarat',
'Barwala Ghelasha,Gandhinagar,Gujarat',
'Bela,Gandhinagar,Gujarat',
'Chokdi,Gandhinagar,Gujarat',
'Hebatpur,Gandhinagar,Gujarat',
'Khambhada,Gandhinagar,Gujarat',
'Khamidana,Gandhinagar,Gujarat',
'Kundal,Gandhinagar,Gujarat',
'Navda,Gandhinagar,Gujarat',
'Polarpur,Gandhinagar,Gujarat',
'Rampura,Gandhinagar,Gujarat',
'Refda,Gandhinagar,Gujarat',
'Rojid,Gandhinagar,Gujarat',
'Salangpur - Hanuman,Gandhinagar,Gujarat',
'Sangasar,Gandhinagar,Gujarat',
'Shahpur,Gandhinagar,Gujarat',
'Sodhi,Gandhinagar,Gujarat',
'Vadhela,Gandhinagar,Gujarat',
'Valhia,Gandhinagar,Gujarat',
'Adroda,Gandhinagar,Gujarat',
'Bagodara,Gandhinagar,Gujarat',
'Baldana,Gandhinagar,Gujarat',
'Bamsara,Gandhinagar,Gujarat',
'Bavla Market Yard,Gandhinagar,Gujarat',
'Bavla,Gandhinagar,Gujarat',
'Bhayla,Gandhinagar,Gujarat',
'Chhabasar,Gandhinagar,Gujarat',
'Chiada,Gandhinagar,Gujarat',
'Dehgamda,Gandhinagar,Gujarat',
'Deo Dholera,Gandhinagar,Gujarat',
'Dhanwada,Gandhinagar,Gujarat',
'Dhingada,Gandhinagar,Gujarat',
'Durgi,Gandhinagar,Gujarat',
'Gangad,Gandhinagar,Gujarat',
'Juval Rupavati,Gandhinagar,Gujarat',
'Kalyangadh,Gandhinagar,Gujarat',
'Kavitha,Gandhinagar,Gujarat',
'Kerala,Gandhinagar,Gujarat',
'Kesardi,Gandhinagar,Gujarat',
'Kocharia,Gandhinagar,Gujarat',
'Mithapur,Gandhinagar,Gujarat',
'Nanodara,Gandhinagar,Gujarat',
'Rajoda,Gandhinagar,Gujarat',
'Ranesar,Gandhinagar,Gujarat',
'Rasam,Gandhinagar,Gujarat',
'Rohika,Gandhinagar,Gujarat',
'Rupal,Gandhinagar,Gujarat',
'Salajada,Gandhinagar,Gujarat',
'Sankod,Gandhinagar,Gujarat',
'Shiyal,Gandhinagar,Gujarat',
'Ambli,Gandhinagar,Gujarat',
'Aslali,Gandhinagar,Gujarat',
'Bakrol,Gandhinagar,Gujarat',
'Bakrol,Gandhinagar,Gujarat',
'Bhat,Gandhinagar,Gujarat',
'Bhavda,Gandhinagar,Gujarat',
'Bhuvaldi,Gandhinagar,Gujarat',
'Bopal,Gandhinagar,Gujarat',
'Chandial,Gandhinagar,Gujarat',
'Dhamatvan,Gandhinagar,Gujarat',
'Digvijaynagar,Gandhinagar,Gujarat',
'Fatewadi,Gandhinagar,Gujarat',
'Gamdi,Gandhinagar,Gujarat',
'Gatrad,Gandhinagar,Gujarat',
'Geratpur,Gandhinagar,Gujarat',
'Ghuma,Gandhinagar,Gujarat',
'Girmatha,Gandhinagar,Gujarat',
'Gota,Gandhinagar,Gujarat',
'Harniav,Gandhinagar,Gujarat',
'Jagatpur,Gandhinagar,Gujarat',
'Jantanagar,Gandhinagar,Gujarat',
'Jetalpur,Gandhinagar,Gujarat',
'Kathwada Maize Product,Gandhinagar,Gujarat',
'Kuha,Gandhinagar,Gujarat',
'Mahijada,Gandhinagar,Gujarat',
'Miroli,Gandhinagar,Gujarat',
'Muktipur,Gandhinagar,Gujarat',
'Nandej,Gandhinagar,Gujarat',
'Narol,Gandhinagar,Gujarat',
'Paldi Kankaj,Gandhinagar,Gujarat',
'Pirana,Gandhinagar,Gujarat',
'Thaltej,Gandhinagar,Gujarat',
'Timba,Gandhinagar,Gujarat',
'Vasai,Gandhinagar,Gujarat',
'Vastral,Gandhinagar,Gujarat',
'Vatva Industrial Estate,Gandhinagar,Gujarat',
'Vatva,Gandhinagar,Gujarat',
'Bhadaj,Gandhinagar,Gujarat',
'Chaulaj,Gandhinagar,Gujarat',
'Hathijan,Gandhinagar,Gujarat',
'Hirapur,Gandhinagar,Gujarat',
'Kanbha,Gandhinagar,Gujarat',
'Kaniyel,Gandhinagar,Gujarat',
'Kathwada,Gandhinagar,Gujarat',
'Khodiyar,Gandhinagar,Gujarat',
'Kubadthal,Gandhinagar,Gujarat',
'Kujad,Gandhinagar,Gujarat',
'Lambha,Gandhinagar,Gujarat',
'Lapkaman,Gandhinagar,Gujarat',
'Ode,Gandhinagar,Gujarat',
'Ognaj,Gandhinagar,Gujarat',
'Pasunj,Gandhinagar,Gujarat',
'Ramol,Gandhinagar,Gujarat',
'Ranodra,Gandhinagar,Gujarat',
'Shilaj,Gandhinagar,Gujarat',
'Sola,Gandhinagar,Gujarat',
'Undrel,Gandhinagar,Gujarat',
'Vadod,Gandhinagar,Gujarat',
'Vanch,Gandhinagar,Gujarat',
'Vinzol,Gandhinagar,Gujarat',
'Vishalpur,Gandhinagar,Gujarat',
'Zanu,Gandhinagar,Gujarat',
'Bareja,Gandhinagar,Gujarat',
'Bamroli,Gandhinagar,Gujarat',
'Chuval Dangarva,Gandhinagar,Gujarat',
'Dekawada,Gandhinagar,Gujarat',
'Gunjala,Gandhinagar,Gujarat',
'Chhaniar,Gandhinagar,Gujarat',
'Gamanpura,Gandhinagar,Gujarat',
'Ghatisana,Gandhinagar,Gujarat',
'Abasana,Gandhinagar,Gujarat',
'Ashoknagar,Gandhinagar,Gujarat',
'Balsasan,Gandhinagar,Gujarat',
'Bhankoda,Gandhinagar,Gujarat',
'Bhoyani,Gandhinagar,Gujarat',
'Charol,Gandhinagar,Gujarat',
'Dabhsar,Gandhinagar,Gujarat',
'Detroj,Gandhinagar,Gujarat',
'Kanz,Gandhinagar,Gujarat',
'Katosan Road,Gandhinagar,Gujarat',
'Kointia,Gandhinagar,Gujarat',
'Kukvav,Gandhinagar,Gujarat',
'Madrisana,Gandhinagar,Gujarat',
'Marusana,Gandhinagar,Gujarat',
'Moti Rantai,Gandhinagar,Gujarat',
'Nadishala,Gandhinagar,Gujarat',
'Odhav,Gandhinagar,Gujarat',
'Panar,Gandhinagar,Gujarat',
'Rampura,Gandhinagar,Gujarat',
'Rudatal,Gandhinagar,Gujarat',
'Sadatpura,Gandhinagar,Gujarat',
'Sangpura,Gandhinagar,Gujarat',
'Sihor,Gandhinagar,Gujarat',
'Sobhasan,Gandhinagar,Gujarat',
'Sunvala,Gandhinagar,Gujarat',
'Telavi,Gandhinagar,Gujarat',
'Adval,Gandhinagar,Gujarat',
'Akru,Gandhinagar,Gujarat',
'Ambli,Gandhinagar,Gujarat',
'Aniali Bhimji,Gandhinagar,Gujarat',
'Badanpur,Gandhinagar,Gujarat',
'Bajarda,Gandhinagar,Gujarat',
'Bavaliary,Gandhinagar,Gujarat',
'Bhadiad,Gandhinagar,Gujarat',
'Bhangadh,Gandhinagar,Gujarat',
'Chandarva,Gandhinagar,Gujarat',
'Chhasiana,Gandhinagar,Gujarat',
'Dhanala,Gandhinagar,Gujarat',
'Dhandhuka,Gandhinagar,Gujarat',
'Dholera,Gandhinagar,Gujarat',
'Fatepur,Gandhinagar,Gujarat',
'Fedra,Gandhinagar,Gujarat',
'Galsana,Gandhinagar,Gujarat',
'Gamph,Gandhinagar,Gujarat',
'Gogla,Gandhinagar,Gujarat',
'Gorasu,Gandhinagar,Gujarat',
'Gunjar,Gandhinagar,Gujarat',
'Jaliya,Gandhinagar,Gujarat',
'Jeska,Gandhinagar,Gujarat',
'Kadipur,Gandhinagar,Gujarat',
'Kamiala,Gandhinagar,Gujarat',
'Kasindra,Gandhinagar,Gujarat',
'Kasindra,Gandhinagar,Gujarat',
'Khadol,Gandhinagar,Gujarat',
'Khandachora Dhandhuka,Gandhinagar,Gujarat',
'Kharad,Gandhinagar,Gujarat',
'Khasta,Gandhinagar,Gujarat',
'Khun,Gandhinagar,Gujarat',
'Kothadia,Gandhinagar,Gujarat',
'Mingalpur,Gandhinagar,Gujarat',
'Mota Tradia,Gandhinagar,Gujarat',
'Otaria,Gandhinagar,Gujarat',
'Otaria Sarvodaya Ashram,Gandhinagar,Gujarat',
'Padana,Gandhinagar,Gujarat',
'Panchham,Gandhinagar,Gujarat',
'Panchhi,Gandhinagar,Gujarat',
'Parabadi,Gandhinagar,Gujarat',
'Pipli,Gandhinagar,Gujarat',
'Rayka,Gandhinagar,Gujarat',
'Rojka,Gandhinagar,Gujarat',
'Salasar,Gandhinagar,Gujarat',
'Sandhida,Gandhinagar,Gujarat',
'Shela,Gandhinagar,Gujarat',
'Tagadi,Gandhinagar,Gujarat',
'Unchadi,Gandhinagar,Gujarat',
'Vagad,Gandhinagar,Gujarat',
'Valinda,Gandhinagar,Gujarat',
'Vasna,Gandhinagar,Gujarat',
'Zanzarka,Gandhinagar,Gujarat',
'Zinzar,Gandhinagar,Gujarat',
'Ambaliara,Gandhinagar,Gujarat',
'Ambareli,Gandhinagar,Gujarat',
'Arnej,Gandhinagar,Gujarat',
'Badarkha,Gandhinagar,Gujarat',
'Bholad,Gandhinagar,Gujarat',
'Bhurkhi,Gandhinagar,Gujarat',
'Chaloda,Gandhinagar,Gujarat',
'Chandisar,Gandhinagar,Gujarat',
'Dadusar,Gandhinagar,Gujarat',
'Dholi,Gandhinagar,Gujarat',
'Dholka H.O,Gandhinagar,Gujarat',
'Ganol,Gandhinagar,Gujarat',
'Gundi Sarvodaya Ashram,Gandhinagar,Gujarat',
'Ingoli,Gandhinagar,Gujarat',
'Jakhada,Gandhinagar,Gujarat',
'Jalalpur Vajifa,Gandhinagar,Gujarat',
'Jawaraj,Gandhinagar,Gujarat',
'Kauka,Gandhinagar,Gujarat',
'Kelia Vasna,Gandhinagar,Gujarat',
'Kharakuva Dholka,Gandhinagar,Gujarat',
'Koth,Gandhinagar,Gujarat',
'Loliya,Gandhinagar,Gujarat',
'Lothal Bhurkhi RS,Gandhinagar,Gujarat',
'Moti Boru,Gandhinagar,Gujarat',
'Nani Boru,Gandhinagar,Gujarat',
'Nesda,Gandhinagar,Gujarat',
'Pisawada,Gandhinagar,Gujarat',
'Rampur,Gandhinagar,Gujarat',
'Ranoda,Gandhinagar,Gujarat',
'Rupgadh,Gandhinagar,Gujarat',
'Sahij,Gandhinagar,Gujarat',
'Saiwada,Gandhinagar,Gujarat',
'Sarandi,Gandhinagar,Gujarat',
'Sargwala,Gandhinagar,Gujarat',
'Saroda,Gandhinagar,Gujarat',
'Sathal,Gandhinagar,Gujarat',
'Sherpura,Gandhinagar,Gujarat',
'Simej,Gandhinagar,Gujarat',
'Sindharej,Gandhinagar,Gujarat',
'Transad,Gandhinagar,Gujarat',
'Utelia,Gandhinagar,Gujarat',
'Valdhera,Gandhinagar,Gujarat',
'Varna,Gandhinagar,Gujarat',
'Vataman,Gandhinagar,Gujarat',
'Vautha,Gandhinagar,Gujarat',
'Vejalka,Gandhinagar,Gujarat',
'Virdi,Gandhinagar,Gujarat',
'Dadhana,Gandhinagar,Gujarat',
'Dalod,Gandhinagar,Gujarat',
'Dhedasana,Gandhinagar,Gujarat',
'Endla,Gandhinagar,Gujarat',
'Jalisana,Gandhinagar,Gujarat',
'Kadvasan,Gandhinagar,Gujarat',
'Kunpur,Gandhinagar,Gujarat',
'Mandal,Gandhinagar,Gujarat',
'Nana Ubhada,Gandhinagar,Gujarat',
'Navagam,Gandhinagar,Gujarat',
'Nayakpur,Gandhinagar,Gujarat',
'Rakhiana,Gandhinagar,Gujarat',
'Ribadi,Gandhinagar,Gujarat',
'Sher,Gandhinagar,Gujarat',
'Sinaj,Gandhinagar,Gujarat',
'Sitapur,Gandhinagar,Gujarat',
'Solgam,Gandhinagar,Gujarat',
'Trent,Gandhinagar,Gujarat',
'Ughroj,Gandhinagar,Gujarat',
'Ukardi,Gandhinagar,Gujarat',
'Vanpardi,Gandhinagar,Gujarat',
'Varmor,Gandhinagar,Gujarat',
'Vinchhan,Gandhinagar,Gujarat',
'Vinzuvada,Gandhinagar,Gujarat',
'Vithlpura,Gandhinagar,Gujarat',
'Zanzarva,Gandhinagar,Gujarat',
'Alampur,Gandhinagar,Gujarat',
'Alau,Gandhinagar,Gujarat',
'Aniali ( K ),Gandhinagar,Gujarat',
'Bagad,Gandhinagar,Gujarat',
'Bodia,Gandhinagar,Gujarat',
'Charanki,Gandhinagar,Gujarat',
'Devaliya,Gandhinagar,Gujarat',
'Dharpipla,Gandhinagar,Gujarat',
'Godhavata,Gandhinagar,Gujarat',
'Gunda,Gandhinagar,Gujarat',
'Jalila,Gandhinagar,Gujarat',
'Keria,Gandhinagar,Gujarat',
'Khas,Gandhinagar,Gujarat',
'Khokarnesh,Gandhinagar,Gujarat',
'Kundli,Gandhinagar,Gujarat',
'Moti Vavdi,Gandhinagar,Gujarat',
'Nani Vavdi,Gandhinagar,Gujarat',
'Rajpura,Gandhinagar,Gujarat',
'Ranpur,Gandhinagar,Gujarat',
'Sunderiana,Gandhinagar,Gujarat',
'Umrela,Gandhinagar,Gujarat',
'Andej,Gandhinagar,Gujarat',
'Bakrana,Gandhinagar,Gujarat',
'Bol,Gandhinagar,Gujarat',
'Changodar,Gandhinagar,Gujarat',
'Charel,Gandhinagar,Gujarat',
'Chekhla,Gandhinagar,Gujarat',
'Chharodi,Gandhinagar,Gujarat',
'Daran,Gandhinagar,Gujarat',
'Devtimoti,Gandhinagar,Gujarat',
'Dodar,Gandhinagar,Gujarat',
'Fangadi,Gandhinagar,Gujarat',
'Garodia,Gandhinagar,Gujarat',
'Godhavi,Gandhinagar,Gujarat',
'Goraj,Gandhinagar,Gujarat',
'Iawa (Vasna),Gandhinagar,Gujarat',
'Jamp,Gandhinagar,Gujarat',
'Jholapur,Gandhinagar,Gujarat',
'Juval,Gandhinagar,Gujarat',
'Kalana,Gandhinagar,Gujarat',
'Kaneti,Gandhinagar,Gujarat',
'Khoda,Gandhinagar,Gujarat',
'Khorajnanoda,Gandhinagar,Gujarat',
'Kolat,Gandhinagar,Gujarat',
'Kundal,Gandhinagar,Gujarat',
'Kunvar,Gandhinagar,Gujarat',
'Makhiav,Gandhinagar,Gujarat',
'Mankol,Gandhinagar,Gujarat',
'Matoda,Gandhinagar,Gujarat',
'Modasar,Gandhinagar,Gujarat',
'Moraiya,Gandhinagar,Gujarat',
'Nani Devti,Gandhinagar,Gujarat',
'Navapura,Gandhinagar,Gujarat',
'Nedharad,Gandhinagar,Gujarat',
'Pimpan,Gandhinagar,Gujarat',
'Rethal,Gandhinagar,Gujarat',
'Sanand,Gandhinagar,Gujarat',
'Sanathal,Gandhinagar,Gujarat',
'Sari,Gandhinagar,Gujarat',
'Shela,Gandhinagar,Gujarat',
'Siawada,Gandhinagar,Gujarat',
'Telav,Gandhinagar,Gujarat',
'Upardal,Gandhinagar,Gujarat',
'Vasna (Iawa),Gandhinagar,Gujarat',
'Vasna Chacharvadi,Gandhinagar,Gujarat',
'Vinchhiya,Gandhinagar,Gujarat',
'Virochannagar,Gandhinagar,Gujarat',
'Daduka,Gandhinagar,Gujarat',
'Asalgam,Gandhinagar,Gujarat',
'Bhadana,Gandhinagar,Gujarat',
'Bhojwa,Gandhinagar,Gujarat',
'Bordibazar Viramgam,Gandhinagar,Gujarat',
'Chandranagar,Gandhinagar,Gujarat',
'Daslana,Gandhinagar,Gujarat',
'Devpura,Gandhinagar,Gujarat',
'Dhakdi,Gandhinagar,Gujarat',
'Dumana,Gandhinagar,Gujarat',
'Ghoda,Gandhinagar,Gujarat',
'Goraiya,Gandhinagar,Gujarat',
'Hansalpur,Gandhinagar,Gujarat',
'Hirapura,Gandhinagar,Gujarat',
'Jakwada,Gandhinagar,Gujarat',
'Jalampur,Gandhinagar,Gujarat',
'Joshipura,Gandhinagar,Gujarat',
'Junapadhar,Gandhinagar,Gujarat',
'Kamijala,Gandhinagar,Gujarat',
'Kankravadi,Gandhinagar,Gujarat',
'Karakthal,Gandhinagar,Gujarat',
'Khudad,Gandhinagar,Gujarat',
'Kokta,Gandhinagar,Gujarat',
'Kumarkhan,Gandhinagar,Gujarat',
'Manipur,Gandhinagar,Gujarat',
'Melaj,Gandhinagar,Gujarat',
'Moti Kishol,Gandhinagar,Gujarat',
'Ogan,Gandhinagar,Gujarat',
'Rahemalpur,Gandhinagar,Gujarat',
'Rangpur,Gandhinagar,Gujarat',
'Sachana,Gandhinagar,Gujarat',
'Sarsavadi,Gandhinagar,Gujarat',
'Shahpur,Gandhinagar,Gujarat',
'Shivpura,Gandhinagar,Gujarat',
'Thori Mubarak,Gandhinagar,Gujarat',
'Thori Thumbha,Gandhinagar,Gujarat',
'Thuleta,Gandhinagar,Gujarat',
'Ukhlod,Gandhinagar,Gujarat',
'Vadgas,Gandhinagar,Gujarat',
'Vani,Gandhinagar,Gujarat',
'Vansva,Gandhinagar,Gujarat',
'Vanthal,Gandhinagar,Gujarat',
'Vekaria,Gandhinagar,Gujarat',
'Viramgam,Gandhinagar,Gujarat',
'Zezra,Gandhinagar,Gujarat',
'Amarpur,Amreli,Gujarat',
'Abhrampara,Amreli,Gujarat',
'Adsang,Amreli,Gujarat',
'Adtala,Amreli,Gujarat',
'Akala,Amreli,Gujarat',
'Amba,Amreli,Gujarat',
'Ambaradi,Amreli,Gujarat',
'Ambardi,Amreli,Gujarat',
'Ambardi J,Amreli,Gujarat',
'Amreli H.O,Amreli,Gujarat',
'Amreli J P,Amreli,Gujarat',
'Amreli M P,Amreli,Gujarat',
'Amreli S R,Amreli,Gujarat',
'Amreli,Amreli,Gujarat',
'Amrelit R,Amreli,Gujarat',
'Amrpur V,Amreli,Gujarat',
'Amrutpur,Amreli,Gujarat',
'Amrutvel,Amreli,Gujarat',
'Anida,Amreli,Gujarat',
'Anida,Amreli,Gujarat',
'Ankadia-nana,Amreli,Gujarat',
'Ansodar,Amreli,Gujarat',
'Arjansukh,Amreli,Gujarat',
'Babapur,Amreli,Gujarat',
'Babarkot,Amreli,Gujarat',
'Babra,Amreli,Gujarat',
'Babriyadhar,Amreli,Gujarat',
'Badhada,Amreli,Gujarat',
'Bagasra,Amreli,Gujarat',
'Bagoya,Amreli,Gujarat',
'Bagrsa Sr,Amreli,Gujarat',
'Balapur,Amreli,Gujarat',
'Balel-piparia,Amreli,Gujarat',
'Bambhaniya,Amreli,Gujarat',
'Bantva-devli,Amreli,Gujarat',
'Barbtana,Amreli,Gujarat',
'Barman-nana,Amreli,Gujarat',
'Barman-nana,Amreli,Gujarat',
'Barpatoli,Amreli,Gujarat',
'Barvala-baval,Amreli,Gujarat',
'Bhandaria Nana,Amreli,Gujarat',
'Bhandriya Mota,Amreli,Gujarat',
'Bordi,Amreli,Gujarat',
'Chadiya,Amreli,Gujarat',
'Chakkargadh,Amreli,Gujarat',
'Chakragadh,Amreli,Gujarat',
'Chandgadh,Amreli,Gujarat',
'Chhatadiya,Amreli,Gujarat',
'Chital,Amreli,Gujarat',
'Chrania,Amreli,Gujarat',
'Dadva(Randal),Amreli,Gujarat',
'Devaliya,Amreli,Gujarat',
'Devalki,Amreli,Gujarat',
'Devarajiya,Amreli,Gujarat',
'Dhargni,Amreli,Gujarat',
'Fatepur,Amreli,Gujarat',
'Gakharvalamota,Amreli,Gujarat',
'Gavdka,Amreli,Gujarat',
'Ingorala-2,Amreli,Gujarat',
'Ishavariya,Amreli,Gujarat',
'Jaliya,Amreli,Gujarat',
'Jangar,Amreli,Gujarat',
'Jasvantgadh,Amreli,Gujarat',
'Keriyanagas,Amreli,Gujarat',
'Kovaya,Amreli,Gujarat',
'Lakhapadar,Amreli,Gujarat',
'Lalavadar,Amreli,Gujarat',
'Machyalanana,Amreli,Gujarat',
'Mangvapal,Amreli,Gujarat',
'Monpur,Amreli,Gujarat',
'Mota-ankadiya,Amreli,Gujarat',
'Pipallag,Amreli,Gujarat',
'Pithvajal,Amreli,Gujarat',
'Rajsathli,Amreli,Gujarat',
'Randhiya,Amreli,Gujarat',
'Randhiya,Amreli,Gujarat',
'Rangpur,Amreli,Gujarat',
'Sanosara,Amreli,Gujarat',
'Sonariya,Amreli,Gujarat',
'Taraktalv,Amreli,Gujarat',
'Tarvada,Amreli,Gujarat',
'Vadera,Amreli,Gujarat',
'Vankiya,Amreli,Gujarat',
'Vathalpur K,Amreli,Gujarat',
'Chamaradi,Amreli,Gujarat',
'Vaghaniya,Amreli,Gujarat',
'Bhader,Amreli,Gujarat',
'Chalala,Amreli,Gujarat',
'Dhari,Amreli,Gujarat',
'Dhari SR,Amreli,Gujarat',
'Gopalgram,Amreli,Gujarat',
'Sarsiya,Amreli,Gujarat',
'Nageshri,Amreli,Gujarat',
'Timbi,Amreli,Gujarat',
'Dedan,Amreli,Gujarat',
'Khambha,Amreli,Gujarat',
'Motasamdhiyala,Amreli,Gujarat',
'Kunkavav,Amreli,Gujarat',
'Lunidhar,Amreli,Gujarat',
'Vadia,Amreli,Gujarat',
'Damnagar,Amreli,Gujarat',
'Lathi,Amreli,Gujarat',
'Krankach,Amreli,Gujarat',
'Liliya,Amreli,Gujarat',
'Dungar,Amreli,Gujarat',
'Jafrabad,Amreli,Gujarat',
'Rajula,Amreli,Gujarat',
'Utcl Kovaya,Amreli,Gujarat',
'Jira,Amreli,Gujarat',
'Nani-vadal,Amreli,Gujarat',
'Savar,Amreli,Gujarat',
'Savarkundla,Amreli,Gujarat',
'Thoradi,Amreli,Gujarat',
'Vanda,Amreli,Gujarat',
'Vijpadi,Amreli,Gujarat',
'District Court,Anand,Gujarat',
'Adas,Anand,Gujarat',
'Ajarpura,Anand,Gujarat',
'Ajupura,Anand,Gujarat',
'Amuldairy (Anand),Anand,Gujarat',
'Anand Agri Inst (Anand),Anand,Gujarat',
'Anand H.O,Anand,Gujarat',
'Anand Town (Anand),Anand,Gujarat',
'Bakrol,Anand,Gujarat',
'Bedva,Anand,Gujarat',
'Bhalej,Anand,Gujarat',
'Chaklashi,Kheda,Gujarat',
'Chikhodra,Anand,Gujarat',
'Gamdi,Anand,Gujarat',
'Gana,Anand,Gujarat',
'Gopalpura,Anand,Gujarat',
'Hadgood,Anand,Gujarat',
'Jitodia,Anand,Gujarat',
'Jol,Anand,Gujarat',
'Kanbhaipura,Anand,Gujarat',
'Karamsad,Anand,Gujarat',
'Kasor,Anand,Gujarat',
'Khambholej,Anand,Gujarat',
'Khandhli,Anand,Gujarat',
'Khanpur,Anand,Gujarat',
'Kherda,Anand,Gujarat',
'Kunjrav,Anand,Gujarat',
'Lambhvel,Kheda,Gujarat',
'Meghva,Anand,Gujarat',
'Mogar,Anand,Gujarat',
'Mogri,Anand,Gujarat',
'Napad,Anand,Gujarat',
'Navli,Anand,Gujarat',
'Ode,Anand,Gujarat',
'Rajupura,Anand,Gujarat',
'Ramnagar,Anand,Gujarat',
'Rasnol,Anand,Gujarat',
'Ravlapura,Anand,Gujarat',
'Samarkha,Anand,Gujarat',
'Sandesar,Anand,Gujarat',
'Sardarganj (Anand),Anand,Gujarat',
'Sarsa,Anand,Gujarat',
'Tranol,Anand,Gujarat',
'Vadod,Anand,Gujarat',
'Vaghashi,Anand,Gujarat',
'Valasan,Anand,Gujarat',
'Vallabh Vidyanagar,Anand,Gujarat',
'Vasad,Anand,Gujarat',
'Verakhadi,Anand,Gujarat',
'Veternary College (Anand),Anand,Gujarat',
'Vithal Udyognagar,Anand,Gujarat',
'Ambali,Anand,Gujarat',
'Ambav,Anand,Gujarat',
'Amrol,Anand,Gujarat',
'Anklav,Anand,Gujarat',
'Asarma,Anand,Gujarat',
'Asodar,Anand,Gujarat',
'Bamangam,Anand,Gujarat',
'Bhetasi,Anand,Gujarat',
'Joshikuva,Anand,Gujarat',
'Kahanvadi,Anand,Gujarat',
'Kantharia,Anand,Gujarat',
'Khadol,Anand,Gujarat',
'Kinkhlod,Anand,Gujarat',
'Kosindra,Anand,Gujarat',
'Mujkuva,Anand,Gujarat',
'Navakhal,Anand,Gujarat',
'Umeta,Anand,Gujarat',
'Alarsa,Anand,Gujarat',
'Amiyad,Kheda,Gujarat',
'Banejada,Kheda,Gujarat',
'Bhadran,Anand,Gujarat',
'Bilpad,Anand,Gujarat',
'Bodal,Anand,Gujarat',
'Boriavi,Kheda,Gujarat',
'Borsad,Anand,Gujarat',
'Chamara,Anand,Gujarat',
'Dabhasi,Kheda,Gujarat',
'Davol,Anand,Gujarat',
'Dedarda,Anand,Gujarat',
'Dehmi,Anand,Gujarat',
'Dharmaj-ranoli,Kheda,Gujarat',
'Dhundakuva,Anand,Gujarat',
'Gajna,Anand,Gujarat',
'Gambhira,Anand,Gujarat',
'Golel,Kheda,Gujarat',
'Jantral,Kheda,Gujarat',
'Jharola,Kheda,Gujarat',
'Kasari,Kheda,Gujarat',
'Kashipura (Borsad),Anand,Gujarat',
'Kasumbad,Anand,Gujarat',
'Kathol,Anand,Gujarat',
'Kavitha,Anand,Gujarat',
'Khanpur,Kheda,Gujarat',
'Khedasa,Anand,Gujarat',
'Kothiakhad,Anand,Gujarat',
'Napa,Anand,Gujarat',
'Navapura,Anand,Gujarat',
'Nisraya,Anand,Gujarat',
'Pamol,Anand,Gujarat',
'Pipli,Anand,Gujarat',
'Ras,Kheda,Gujarat',
'Rudel,Kheda,Gujarat',
'Saijpur,Kheda,Gujarat',
'Sarol,Anand,Gujarat',
'Singlav,Anand,Gujarat',
'Sisva,Anand,Gujarat',
'Surkuva,Anand,Gujarat',
'Vadeli,Kheda,Gujarat',
'Valvod,Anand,Gujarat',
'Vasna,Anand,Gujarat',
'Vera,Anand,Gujarat',
'Virsad,Kheda,Gujarat',
'Badalpur,Kheda,Gujarat',
'Bamanva,Kheda,Gujarat',
'Bhuvel,Kheda,Gujarat',
'Chitari Bazar,Kheda,Gujarat',
'Daheda,Kheda,Gujarat',
'Dahevan,Kheda,Gujarat',
'Dali,Kheda,Gujarat',
'Dhuvaran,Kheda,Gujarat',
'Dhuvaran Power Station,Kheda,Gujarat',
'Finav,Kheda,Gujarat',
'Golana,Kheda,Gujarat',
'Gudel,Kheda,Gujarat',
'Jalsan,Kheda,Gujarat',
'Jalundh,Kheda,Gujarat',
'Jinaj,Kheda,Gujarat',
'Kalamsar,Kheda,Gujarat',
'Kalitalavadi,Kheda,Gujarat',
'Kalu,Kheda,Gujarat',
'Kanbha,Kheda,Gujarat',
'Kanisa,Kheda,Gujarat',
'Kankapura,Kheda,Gujarat',
'Kansari,Kheda,Gujarat',
'Kanzat,Kheda,Gujarat',
'Kathana,Kheda,Gujarat',
'Kathana RS,Kheda,Gujarat',
'Khadodhi,Kheda,Gujarat',
'Khambhat,Kheda,Gujarat',
'Khatnal,Kheda,Gujarat',
'Lunej,Kheda,Gujarat',
'Malu,Kheda,Gujarat',
'Metpur,Kheda,Gujarat',
'Nagra,Kheda,Gujarat',
'Nana Kalodara,Kheda,Gujarat',
'Naviakhol,Kheda,Gujarat',
'Pandad,Kheda,Gujarat',
'Piploi,Kheda,Gujarat',
'Pith Baza- Khambhat,Kheda,Gujarat',
'Ralej,Kheda,Gujarat',
'Rangpur,Kheda,Gujarat',
'Sayma,Kheda,Gujarat',
'Shakarpur,Kheda,Gujarat',
'Timba,Kheda,Gujarat',
'Undel,Kheda,Gujarat',
'Vadgam,Kheda,Gujarat',
'Vadgam,Kheda,Gujarat',
'Vainaj,Kheda,Gujarat',
'Vatadara,Kheda,Gujarat',
'Vatra,Kheda,Gujarat',
'Bhalada,Kheda,Gujarat',
'Morad,Anand,Gujarat',
'Agas,Anand,Gujarat',
'Amod,Kheda,Gujarat',
'Ardi,Kheda,Gujarat',
'Ashi,Anand,Gujarat',
'Bamroli,Kheda,Gujarat',
'Bhavanipura,Kheda,Gujarat',
'Bhurakui,Kheda,Gujarat',
'Bochasan RS,Kheda,Gujarat',
'Boria,Anand,Gujarat',
'Dantali,Kheda,Gujarat',
'Davalpura,Kheda,Gujarat',
'Dharmaj,Kheda,Gujarat',
'Fangani,Kheda,Gujarat',
'Ghunteli,Kheda,Gujarat',
'Khadana,Kheda,Gujarat',
'Mahelav,Kheda,Gujarat',
'Manaj,Kheda,Gujarat',
'Manpura,Kheda,Gujarat',
'Mariumpura,Kheda,Gujarat',
'Nar,Kheda,Gujarat',
'Padgol,Kheda,Gujarat',
'Palaj,Kheda,Gujarat',
'Pandoli,Kheda,Gujarat',
'Petlad RS,Kheda,Gujarat',
'Petlad,Kheda,Gujarat',
'Rangaipura,Kheda,Gujarat',
'Rupiapura,Kheda,Gujarat',
'Sansej,Kheda,Gujarat',
'Simarda,Kheda,Gujarat',
'Sinhol,Anand,Gujarat',
'Sunav,Kheda,Gujarat',
'Sundarna,Kheda,Gujarat',
'Sundra,Kheda,Gujarat',
'Vadadla,Kheda,Gujarat',
'Virol [simarda],Kheda,Gujarat',
'Balinta,Kheda,Gujarat',
'Dabhou,Kheda,Gujarat',
'Devataj,Kheda,Gujarat',
'Gada,Kheda,Gujarat',
'Isnav,Kheda,Gujarat',
'Kasor,Kheda,Gujarat',
'Malataj,Kheda,Gujarat',
'Manghrol,Kheda,Gujarat',
'Palol,Kheda,Gujarat',
'Petli,Kheda,Gujarat',
'Piplav,Kheda,Gujarat',
'Runaj,Kheda,Gujarat',
'Sojitra,Kheda,Gujarat',
'Trambovad,Kheda,Gujarat',
'Virol,Kheda,Gujarat',
'Budhej,Kheda,Gujarat',
'Chagada,Kheda,Gujarat',
'Dugari,Kheda,Gujarat',
'Galiana,Kheda,Gujarat',
'Gorad,Kheda,Gujarat',
'Hadeva,Kheda,Gujarat',
'Indranaj,Kheda,Gujarat',
'Isarvada,Kheda,Gujarat',
'Jichka,Kheda,Gujarat',
'Kanavada,Kheda,Gujarat',
'Kasbara,Kheda,Gujarat',
'Khaksar,Kheda,Gujarat',
'Khanpur,Kheda,Gujarat',
'Laxmipura,Kheda,Gujarat',
'Mahiyari,Kheda,Gujarat',
'Milarampura,Kheda,Gujarat',
'Mobha,Kheda,Gujarat',
'Mobha,Kheda,Gujarat',
'Moraj,Kheda,Gujarat',
'Pachegam,Kheda,Gujarat',
'Padra,Kheda,Gujarat',
'Pariej,Kheda,Gujarat',
'Tarapur,Kheda,Gujarat',
'Untvada,Kheda,Gujarat',
'Varsada,Kheda,Gujarat',
'Mitli,Kheda,Gujarat',
'Ahima,Anand,Gujarat',
'Ashipura,Anand,Gujarat',
'Badapura,Anand,Gujarat',
'Bajipura,Anand,Gujarat',
'Bechri,Anand,Gujarat',
'Bharoda,Anand,Gujarat',
'Bhatpura,Anand,Gujarat',
'Dagjipura,Anand,Gujarat',
'Dholi,Anand,Gujarat',
'Ghora,Anand,Gujarat',
'Hamidpura,Anand,Gujarat',
'Jakhala,Anand,Gujarat',
'Khankhanpur,Anand,Gujarat',
'Khankuva,Anand,Gujarat',
'Lingda,Anand,Gujarat',
'Panchvati (Umreth),Anand,Gujarat',
'Pansora,Anand,Gujarat',
'Pratappura,Anand,Gujarat',
'Ratanpura,Anand,Gujarat',
'Shili,Anand,Gujarat',
'Sundalpura,Anand,Gujarat',
'Sureli,Anand,Gujarat',
'Thamna,Anand,Gujarat',
'Umreth,Anand,Gujarat',
'Khorvad,Anand,Gujarat',
'Untkhari,Anand,Gujarat',
'Jaswant Gadh,Banasanktha,Gujarat',
'Virampur,Banasanktha,Gujarat',
'Balodhan,Banasanktha,Gujarat',
'Barwala,Banasanktha,Gujarat',
'Bhabhar,Banasanktha,Gujarat',
'Chatra,Banasanktha,Gujarat',
'Chembuva,Banasanktha,Gujarat',
'Dhrechana,Banasanktha,Gujarat',
'Eta,Banasanktha,Gujarat',
'Garambadi,Banasanktha,Gujarat',
'Jasanwada,Banasanktha,Gujarat',
'Katav,Banasanktha,Gujarat',
'Kuvala,Banasanktha,Gujarat',
'Madhpura,Banasanktha,Gujarat',
'Mitha,Banasanktha,Gujarat',
'Morwada,Banasanktha,Gujarat',
'Radka,Banasanktha,Gujarat',
'Runi,Banasanktha,Gujarat',
'Ruvel,Banasanktha,Gujarat',
'Soneth,Banasanktha,Gujarat',
'Suthar Nesdi,Banasanktha,Gujarat',
'Tanvad,Banasanktha,Gujarat',
'Terwada,Banasanktha,Gujarat',
'Uchosan,Banasanktha,Gujarat',
'Ujjanwada,Banasanktha,Gujarat',
'Undai,Banasanktha,Gujarat',
'Vajapur Juna,Banasanktha,Gujarat',
'Varasada,Banasanktha,Gujarat',
'Ambaji,Banasanktha,Gujarat',
'Bamnoj,Banasanktha,Gujarat',
'Bhadli-kotha,Banasanktha,Gujarat',
'Bhakhari,Banasanktha,Gujarat',
'Dalpura,Banasanktha,Gujarat',
'Danta Bhavangadh,Banasanktha,Gujarat',
'Dhagadia,Banasanktha,Gujarat',
'Dhanali,Banasanktha,Gujarat',
'Gangva,Banasanktha,Gujarat',
'Gorad,Banasanktha,Gujarat',
'Hadad,Banasanktha,Gujarat',
'Jamru,Banasanktha,Gujarat',
'Jitpur,Banasanktha,Gujarat',
'Jodhsar,Banasanktha,Gujarat',
'Khandhor (U),Banasanktha,Gujarat',
'Koteshwar,Banasanktha,Gujarat',
'Kukadi,Banasanktha,Gujarat',
'Kundel,Banasanktha,Gujarat',
'Kuvarshi,Banasanktha,Gujarat',
'Mankdi,Banasanktha,Gujarat',
'Moria (N),Banasanktha,Gujarat',
'Motasada,Banasanktha,Gujarat',
'Mumanvas,Banasanktha,Gujarat',
'Navavas,Banasanktha,Gujarat',
'Panchha,Banasanktha,Gujarat',
'Pethapur,Banasanktha,Gujarat',
'Punjpur,Banasanktha,Gujarat',
'Rangpur,Banasanktha,Gujarat',
'Ranpur,Banasanktha,Gujarat',
'Sanali,Banasanktha,Gujarat',
'Sandhosi,Banasanktha,Gujarat',
'Sembal Pani,Banasanktha,Gujarat',
'Vasi,Banasanktha,Gujarat',
'Vijlasan,Banasanktha,Gujarat',
'Bhakodar,Banasanktha,Gujarat',
'Bhilachal,Banasanktha,Gujarat',
'Dantiwada,Banasanktha,Gujarat',
'Dantiwada Colony,Banasanktha,Gujarat',
'Jegol,Banasanktha,Gujarat',
'Odhava,Banasanktha,Gujarat',
'Sardar Krishinagar,Banasanktha,Gujarat',
'Bhesana,Banasanktha,Gujarat',
'Chibhada,Banasanktha,Gujarat',
'Deodar,Banasanktha,Gujarat',
'Dhanakwada,Banasanktha,Gujarat',
'Duchakwada,Banasanktha,Gujarat',
'Forna,Banasanktha,Gujarat',
'Golvi,Banasanktha,Gujarat',
'Jada,Banasanktha,Gujarat',
'Jalodha,Banasanktha,Gujarat',
'Jasali,Banasanktha,Gujarat',
'Kotarwada,Banasanktha,Gujarat',
'Ludra,Banasanktha,Gujarat',
'Nokha,Banasanktha,Gujarat',
'Paldi,Banasanktha,Gujarat',
'Raiya,Banasanktha,Gujarat',
'Ravel,Banasanktha,Gujarat',
'Soni,Banasanktha,Gujarat',
'Surana,Banasanktha,Gujarat',
'Vakha,Banasanktha,Gujarat',
'Vatam-juna,Banasanktha,Gujarat',
'Alwada,Banasanktha,Gujarat',
'Anapur Chhota,Banasanktha,Gujarat',
'Arkhi,Banasanktha,Gujarat',
'Bapla,Banasanktha,Gujarat',
'Bhadli (Jhat),Banasanktha,Gujarat',
'Bhandotra,Banasanktha,Gujarat',
'Bhanjana,Banasanktha,Gujarat',
'Bhatib,Banasanktha,Gujarat',
'Bhatram,Banasanktha,Gujarat',
'Dhakha,Banasanktha,Gujarat',
'Dhanera,Banasanktha,Gujarat',
'Dhaniawada,Banasanktha,Gujarat',
'Dharnodhar,Banasanktha,Gujarat',
'Dugdol,Banasanktha,Gujarat',
'Ghana,Banasanktha,Gujarat',
'Gundri,Banasanktha,Gujarat',
'Jadi,Banasanktha,Gujarat',
'Jadia,Banasanktha,Gujarat',
'Jadiali,Banasanktha,Gujarat',
'Jhat,Banasanktha,Gujarat',
'Jiwana,Banasanktha,Gujarat',
'Kherola,Banasanktha,Gujarat',
'Khimat,Banasanktha,Gujarat',
'Kuchawada,Banasanktha,Gujarat',
'Kumar,Banasanktha,Gujarat',
'Kuvarla,Banasanktha,Gujarat',
'Lavara,Banasanktha,Gujarat',
'Malotra,Banasanktha,Gujarat',
'Mandal,Banasanktha,Gujarat',
'Motimahudi,Banasanktha,Gujarat',
'Nandla,Banasanktha,Gujarat',
'Nani,Banasanktha,Gujarat',
'Nenava,Banasanktha,Gujarat',
'Panthawada,Banasanktha,Gujarat',
'Pechhadal,Banasanktha,Gujarat',
'Ramsan,Banasanktha,Gujarat',
'Raviya,Banasanktha,Gujarat',
'Runi,Banasanktha,Gujarat',
'Samarvada,Banasanktha,Gujarat',
'Saral,Banasanktha,Gujarat',
'Sia,Banasanktha,Gujarat',
'Thavar,Banasanktha,Gujarat',
'Vachhadal,Banasanktha,Gujarat',
'Vachhol,Banasanktha,Gujarat',
'Valer,Banasanktha,Gujarat',
'Vinchhivadi,Banasanktha,Gujarat',
'Viruna,Banasanktha,Gujarat',
'Zenal,Banasanktha,Gujarat',
'Agthala,Banasanktha,Gujarat',
'Asarada,Banasanktha,Gujarat',
'Baiwada,Banasanktha,Gujarat',
'Balodhar,Banasanktha,Gujarat',
'Bhachalva,Banasanktha,Gujarat',
'Bhadath,Banasanktha,Gujarat',
'Bhadramali,Banasanktha,Gujarat',
'Bhildi,Banasanktha,Gujarat',
'Bhoyan,Banasanktha,Gujarat',
'Chalva,Banasanktha,Gujarat',
'Chekra,Banasanktha,Gujarat',
'Chhatrala,Banasanktha,Gujarat',
'Dhuva,Banasanktha,Gujarat',
'Disa Bazar,Banasanktha,Gujarat',
'Disa M.Y. Pedal,Banasanktha,Gujarat',
'Disa Mukhya Dak Ghar,Banasanktha,Gujarat',
'Ghada,Banasanktha,Gujarat',
'Jetda,Banasanktha,Gujarat',
'Jhabadia,Banasanktha,Gujarat',
'Jherda,Banasanktha,Gujarat',
'Junadisa,Banasanktha,Gujarat',
'Kansari,Banasanktha,Gujarat',
'Kapra-mota,Banasanktha,Gujarat',
'Katarva,Banasanktha,Gujarat',
'Khardosan,Banasanktha,Gujarat',
'Khentva,Banasanktha,Gujarat',
'Kotda,Banasanktha,Gujarat',
'Kuda,Banasanktha,Gujarat',
'Lakhani,Banasanktha,Gujarat',
'Lavana,Banasanktha,Gujarat',
'Lorwada,Banasanktha,Gujarat',
'Lunpur,Banasanktha,Gujarat',
'Mahadevia,Banasanktha,Gujarat',
'Malgadh,Banasanktha,Gujarat',
'Mudetha,Banasanktha,Gujarat',
'Nagfana,Banasanktha,Gujarat',
'Nesada-juna,Banasanktha,Gujarat',
'Odhava (D),Banasanktha,Gujarat',
'Peplu,Banasanktha,Gujarat',
'Rajpur (D),Banasanktha,Gujarat',
'Rampura (D),Banasanktha,Gujarat',
'Ranpur V-vas,Banasanktha,Gujarat',
'Rantila,Banasanktha,Gujarat',
'Rasana Mota,Banasanktha,Gujarat',
'Robas Moti,Banasanktha,Gujarat',
'Samau,Banasanktha,Gujarat',
'Saviyana,Banasanktha,Gujarat',
'Thervada,Banasanktha,Gujarat',
'Tintoda,Banasanktha,Gujarat',
'Varnoda,Banasanktha,Gujarat',
'Vasana Vatam,Banasanktha,Gujarat',
'Vasna,Banasanktha,Gujarat',
'Velavapura,Banasanktha,Gujarat',
'Vithodar,Banasanktha,Gujarat',
'Kakar,Banasanktha,Gujarat',
'Manpur,Banasanktha,Gujarat',
'Padardi,Banasanktha,Gujarat',
'Aganwada,Banasanktha,Gujarat',
'Bhadrewadi,Banasanktha,Gujarat',
'Bhalgam,Banasanktha,Gujarat',
'Bukoli,Banasanktha,Gujarat',
'Changa,Banasanktha,Gujarat',
'Chekhala,Banasanktha,Gujarat',
'Dungrasan,Banasanktha,Gujarat',
'Isarva,Banasanktha,Gujarat',
'Jakhel,Banasanktha,Gujarat',
'Kamboi,Banasanktha,Gujarat',
'Kasara,Banasanktha,Gujarat',
'Kharia,Banasanktha,Gujarat',
'Khimana,Banasanktha,Gujarat',
'Khoda,Banasanktha,Gujarat',
'Khodla,Banasanktha,Gujarat',
'Kunvarva,Banasanktha,Gujarat',
'Laxmipura,Banasanktha,Gujarat',
'Mandla,Banasanktha,Gujarat',
'Mota-jampur,Banasanktha,Gujarat',
'Nathpura,Banasanktha,Gujarat',
'Nekaria,Banasanktha,Gujarat',
'Padar,Banasanktha,Gujarat',
'Raner,Banasanktha,Gujarat',
'Raviyana,Banasanktha,Gujarat',
'Sihori,Banasanktha,Gujarat',
'Siya,Banasanktha,Gujarat',
'Tatiyana,Banasanktha,Gujarat',
'Thara,Banasanktha,Gujarat',
'Totana,Banasanktha,Gujarat',
'Umbari,Banasanktha,Gujarat',
'Un,Banasanktha,Gujarat',
'Vada,Banasanktha,Gujarat',
'Valpura,Banasanktha,Gujarat',
'Zalmor,Banasanktha,Gujarat',
'Antroli,Banasanktha,Gujarat',
'Badargadh,Banasanktha,Gujarat',
'Bhagal (J),Banasanktha,Gujarat',
'Bhagal (P),Banasanktha,Gujarat',
'Bhakharmoti,Banasanktha,Gujarat',
'Bhatamal-moti,Banasanktha,Gujarat',
'Bhutedi,Banasanktha,Gujarat',
'Chadotar,Banasanktha,Gujarat',
'Chandisar,Banasanktha,Gujarat',
'Chitrasani,Banasanktha,Gujarat',
'Dalwada,Banasanktha,Gujarat',
'Dangia,Banasanktha,Gujarat',
'Dhandha,Banasanktha,Gujarat',
'Dhanpura,Banasanktha,Gujarat',
'Gadh,Banasanktha,Gujarat',
'Gathaman,Banasanktha,Gujarat',
'Hasanpur,Banasanktha,Gujarat',
'Hathidra,Banasanktha,Gujarat',
'Hoda,Banasanktha,Gujarat',
'Jagana,Banasanktha,Gujarat',
'Jasleni,Banasanktha,Gujarat',
'Kanodar,Banasanktha,Gujarat',
'Karjoda,Banasanktha,Gujarat',
'Khodla,Banasanktha,Gujarat',
'Kumbhalmer,Banasanktha,Gujarat',
'Kumbhasan,Banasanktha,Gujarat',
'Kushkal,Banasanktha,Gujarat',
'Lalawada,Banasanktha,Gujarat',
'Lunva,Banasanktha,Gujarat',
'Madana (Dangia ),Banasanktha,Gujarat',
'Madana,Banasanktha,Gujarat',
'Malan,Banasanktha,Gujarat',
'Malana,Banasanktha,Gujarat',
'Moria (P),Banasanktha,Gujarat',
'Mota,Banasanktha,Gujarat',
'Palanpur Delhigate,Banasanktha,Gujarat',
'Palanpur Ganjbazar,Banasanktha,Gujarat',
'Palanpur H.O,Banasanktha,Gujarat',
'Palanpur Kamalpura,Banasanktha,Gujarat',
'Palanpur Kirtistambh,Banasanktha,Gujarat',
'Patosan,Banasanktha,Gujarat',
'Ranavas,Banasanktha,Gujarat',
'Ratanpur Lokniketan,Banasanktha,Gujarat',
'Sadarpur,Banasanktha,Gujarat',
'Saghankshetra,Banasanktha,Gujarat',
'Sagrosana,Banasanktha,Gujarat',
'Salla,Banasanktha,Gujarat',
'Samdhi,Banasanktha,Gujarat',
'Sangra,Banasanktha,Gujarat',
'Sasam,Banasanktha,Gujarat',
'Vadhana,Banasanktha,Gujarat',
'Vagda,Banasanktha,Gujarat',
'Vaghrol,Banasanktha,Gujarat',
'Vasan,Banasanktha,Gujarat',
'Vedancha,Banasanktha,Gujarat',
'Balundra,Banasanktha,Gujarat',
'Dabhela,Banasanktha,Gujarat',
'Iqbalgadh,Banasanktha,Gujarat',
'Jethi,Banasanktha,Gujarat',
'Kapasia,Banasanktha,Gujarat',
'Kidotar,Banasanktha,Gujarat',
'Manpuria,Banasanktha,Gujarat',
'Sarotra,Banasanktha,Gujarat',
'Shri Amirgadh,Banasanktha,Gujarat',
'Dholia,Banasanktha,Gujarat',
'Asodar,Banasanktha,Gujarat',
'Bevta,Banasanktha,Gujarat',
'Bhordu,Banasanktha,Gujarat',
'Bhorol,Banasanktha,Gujarat',
'Changda,Banasanktha,Gujarat',
'Charda,Banasanktha,Gujarat',
'Chudmer,Banasanktha,Gujarat',
'Chuva,Banasanktha,Gujarat',
'Daiyap,Banasanktha,Gujarat',
'Dhima,Banasanktha,Gujarat',
'Dodgam,Banasanktha,Gujarat',
'Dudhava,Banasanktha,Gujarat',
'Duva,Banasanktha,Gujarat',
'Gadsisar,Banasanktha,Gujarat',
'Ghodasar,Banasanktha,Gujarat',
'Idhata,Banasanktha,Gujarat',
'Jamda,Banasanktha,Gujarat',
'Kamali,Banasanktha,Gujarat',
'Karbun,Banasanktha,Gujarat',
'Khengarpura,Banasanktha,Gujarat',
'Khoda,Banasanktha,Gujarat',
'Lalpur,Banasanktha,Gujarat',
'Luvana,Banasanktha,Gujarat',
'Madal,Banasanktha,Gujarat',
'Malupur,Banasanktha,Gujarat',
'Morthal,Banasanktha,Gujarat',
'Mota Mesra,Banasanktha,Gujarat',
'Moti Pavad,Banasanktha,Gujarat',
'Naroli,Banasanktha,Gujarat',
'Piluda,Banasanktha,Gujarat',
'Rah,Banasanktha,Gujarat',
'Rampura,Banasanktha,Gujarat',
'Sanavia,Banasanktha,Gujarat',
'Savapura,Banasanktha,Gujarat',
'Sherau,Banasanktha,Gujarat',
'Tharad,Banasanktha,Gujarat',
'Undrana,Banasanktha,Gujarat',
'Vadgamda,Banasanktha,Gujarat',
'Vaghasan,Banasanktha,Gujarat',
'Valadar,Banasanktha,Gujarat',
'Vami,Banasanktha,Gujarat',
'Pasvadal,Banasanktha,Gujarat',
'Badarpura,Banasanktha,Gujarat',
'Basu,Banasanktha,Gujarat',
'Bavalchudi,Banasanktha,Gujarat',
'Bhalgam,Banasanktha,Gujarat',
'Changa,Banasanktha,Gujarat',
'Changwada,Banasanktha,Gujarat',
'Chhaniyana,Banasanktha,Gujarat',
'Chhapi,Banasanktha,Gujarat',
'Dalwana,Banasanktha,Gujarat',
'Dhota,Banasanktha,Gujarat',
'Edrana,Banasanktha,Gujarat',
'Ghodiyal,Banasanktha,Gujarat',
'Gidasan,Banasanktha,Gujarat',
'Gola,Banasanktha,Gujarat',
'Jalotra,Banasanktha,Gujarat',
'Kaleda,Banasanktha,Gujarat',
'Kodram,Banasanktha,Gujarat',
'Magarwada,Banasanktha,Gujarat',
'Mahi,Banasanktha,Gujarat',
'Majadar,Banasanktha,Gujarat',
'Manpura,Banasanktha,Gujarat',
'Memadpur,Banasanktha,Gujarat',
'Meta,Banasanktha,Gujarat',
'Nandotra,Banasanktha,Gujarat',
'Navisana,Banasanktha,Gujarat',
'Panchada,Banasanktha,Gujarat',
'Pepol,Banasanktha,Gujarat',
'Pilucha,Banasanktha,Gujarat',
'Pirojpura,Banasanktha,Gujarat',
'Rupal,Banasanktha,Gujarat',
'Semodra,Banasanktha,Gujarat',
'Sendhani,Banasanktha,Gujarat',
'Sisrana,Banasanktha,Gujarat',
'Takarwada,Banasanktha,Gujarat',
'Teniwada,Banasanktha,Gujarat',
'Timbachudi,Banasanktha,Gujarat',
'Vadgam,Banasanktha,Gujarat',
'Vesa,Banasanktha,Gujarat',
'Akoli,Banasanktha,Gujarat',
'Asara,Banasanktha,Gujarat',
'Baiyak,Banasanktha,Gujarat',
'Baluntri,Banasanktha,Gujarat',
'Benap,Banasanktha,Gujarat',
'Bhachali,Banasanktha,Gujarat',
'Bhakhari,Banasanktha,Gujarat',
'Bharadva,Banasanktha,Gujarat',
'Bhatvar,Banasanktha,Gujarat',
'Bukna,Banasanktha,Gujarat',
'Chala,Banasanktha,Gujarat',
'Dendava,Banasanktha,Gujarat',
'Dethli,Banasanktha,Gujarat',
'Dharadhara,Banasanktha,Gujarat',
'Golgam,Banasanktha,Gujarat',
'Jelana,Banasanktha,Gujarat',
'Kumbharkha,Banasanktha,Gujarat',
'Kundaliya.,Banasanktha,Gujarat',
'Limbuni,Banasanktha,Gujarat',
'Lodrani,Banasanktha,Gujarat',
'Madka,Banasanktha,Gujarat',
'Mamana,Banasanktha,Gujarat',
'Mavsari,Banasanktha,Gujarat',
'Morikha,Banasanktha,Gujarat',
'Padan,Banasanktha,Gujarat',
'Radosan,Banasanktha,Gujarat',
'Sanval,Banasanktha,Gujarat',
'Sapreda,Banasanktha,Gujarat',
'Suigam,Banasanktha,Gujarat',
'Tadav,Banasanktha,Gujarat',
'Tithgam,Banasanktha,Gujarat',
'Vasarda,Banasanktha,Gujarat',
'Vav,Banasanktha,Gujarat',
'Vavdi,Banasanktha,Gujarat',
'Amod,Bharuch,Gujarat',
'Chaklad,Bharuch,Gujarat',
'Danda,Bharuch,Gujarat',
'Dora,Bharuch,Gujarat',
'Ikhar,Bharuch,Gujarat',
'Karena,Bharuch,Gujarat',
'Kobla,Bharuch,Gujarat',
'Mangrol,Bharuch,Gujarat',
'Manjola,Bharuch,Gujarat',
'Miamatar,Bharuch,Gujarat',
'Ochhan,Bharuch,Gujarat',
'Sarbhan,Bharuch,Gujarat',
'Sakkarpore,Bharuch,Gujarat',
'Alonj,Bharuch,Gujarat',
'Ambheta,Bharuch,Gujarat',
'Andada,Bharuch,Gujarat',
'Ankalva,Bharuch,Gujarat',
'Ankleshwar IE,Bharuch,Gujarat',
'Ankleshwar RS,Bharuch,Gujarat',
'Ankleshwar,Bharuch,Gujarat',
'Bhadi,Bharuch,Gujarat',
'Dhanturia,Bharuch,Gujarat',
'Ghodadra,Bharuch,Gujarat',
'Goya Bazar,Bharuch,Gujarat',
'Hajat,Bharuch,Gujarat',
'Kharod,Bharuch,Gujarat',
'Matied,Bharuch,Gujarat',
'Nangal,Bharuch,Gujarat',
'O.N.G.C. Colony,Bharuch,Gujarat',
'Panoli I.E.,Bharuch,Gujarat',
'Panoli,Bharuch,Gujarat',
'Pardi Idris,Bharuch,Gujarat',
'Piludra,Bharuch,Gujarat',
'Pungam,Bharuch,Gujarat',
'Ravidra,Bharuch,Gujarat',
'Sajod,Bharuch,Gujarat',
'Samor,Bharuch,Gujarat',
'Sanjali,Bharuch,Gujarat',
'Kansia,Bharuch,Gujarat',
'Bahruch City,Bharuch,Gujarat',
'Adol,Bharuch,Gujarat',
'Angareshwar,Bharuch,Gujarat',
'Argama,Bharuch,Gujarat',
'Bahruch R.S,Bharuch,Gujarat',
'Bhadbhut,Bharuch,Gujarat',
'Bharthana,Bharuch,Gujarat',
'Bharuch H.O,Bharuch,Gujarat',
'Bhersam,Bharuch,Gujarat',
'Dabhali,Bharuch,Gujarat',
'Dashan,Bharuch,Gujarat',
'Dayadra,Bharuch,Gujarat',
'Dehgam,Bharuch,Gujarat',
'Derol,Bharuch,Gujarat',
'Gayatri Nagar,Bharuch,Gujarat',
'Haldar,Bharuch,Gujarat',
'Haldarva,Bharuch,Gujarat',
'Haldarva,Bharuch,Gujarat',
'Hingalla,Bharuch,Gujarat',
'Hinglot,Bharuch,Gujarat',
'Janor,Bharuch,Gujarat',
'Jhangar,Bharuch,Gujarat',
'K.P.Bazar,Bharuch,Gujarat',
'Kahan,Bharuch,Gujarat',
'Kamboli,Bharuch,Gujarat',
'Kantharia,Bharuch,Gujarat',
'Kantharia,Bharuch,Gujarat',
'Karjan,Bharuch,Gujarat',
'Karmad,Bharuch,Gujarat',
'Kasad,Bharuch,Gujarat',
'Kavitha,Bharuch,Gujarat',
'Kelod,Bharuch,Gujarat',
'Kishnad,Bharuch,Gujarat',
'Koliad,Bharuch,Gujarat',
'Kothi,Bharuch,Gujarat',
'Kothi Vantarsa,Bharuch,Gujarat',
'Kurla,Bharuch,Gujarat',
'Kuvadar,Bharuch,Gujarat',
'L.B.Chakla,Bharuch,Gujarat',
'Luvara,Bharuch,Gujarat',
'Mahudhala,Bharuch,Gujarat',
'Maktampur,Bharuch,Gujarat',
'Mangleshwar,Bharuch,Gujarat',
'Manubar,Bharuch,Gujarat',
'Matroj,Bharuch,Gujarat',
'Mesrad,Bharuch,Gujarat',
'Nabipur,Bharuch,Gujarat',
'Nandeal,Bharuch,Gujarat',
'Narmada Nagar,Bharuch,Gujarat',
'Navetha,Bharuch,Gujarat',
'Nikora,Bharuch,Gujarat',
'Nikora,Bharuch,Gujarat',
'Pachhiapura,Bharuch,Gujarat',
'Paguthan,Bharuch,Gujarat',
'Palej,Bharuch,Gujarat',
'Panch Fanas,Bharuch,Gujarat',
'Pariej,Bharuch,Gujarat',
'Pariej,Bharuch,Gujarat',
'Parkhet,Bharuch,Gujarat',
'Pipaliya,Bharuch,Gujarat',
'Rahad,Bharuch,Gujarat',
'Saladra,Bharuch,Gujarat',
'Samlod,Bharuch,Gujarat',
'Sansrod,Bharuch,Gujarat',
'Saring,Bharuch,Gujarat',
'Segva,Bharuch,Gujarat',
'Shahpur,Bharuch,Gujarat',
'Sherpura,Bharuch,Gujarat',
'Shuklatirth,Bharuch,Gujarat',
'Simalia,Bharuch,Gujarat',
'Simartha,Bharuch,Gujarat',
'Sindhot,Bharuch,Gujarat',
'Sindhvai,Bharuch,Gujarat',
'Sitpon,Bharuch,Gujarat',
'Tankaria,Bharuch,Gujarat',
'Tavra,Bharuch,Gujarat',
'Tham,Bharuch,Gujarat',
'Tralsa,Bharuch,Gujarat',
'Umraj,Bharuch,Gujarat',
'Urja Nagar,Bharuch,Gujarat',
'Vadadla,Bharuch,Gujarat',
'Vahalu,Bharuch,Gujarat',
'Vansi,Bharuch,Gujarat',
'Varedia,Bharuch,Gujarat',
'Vilayat,Bharuch,Gujarat',
'Vora Samni,Bharuch,Gujarat',
'Zadeshwar,Bharuch,Gujarat',
'Amleshwar,Bharuch,Gujarat',
'Bhuva,Bharuch,Gujarat',
'Ambawadi,Bharuch,Gujarat',
'Dediapada,Bharuch,Gujarat',
'Asarma,Bharuch,Gujarat',
'Asta,Bharuch,Gujarat',
'Badodara,Bharuch,Gujarat',
'Balota,Bharuch,Gujarat',
'Dhamrad,Bharuch,Gujarat',
'Digas,Bharuch,Gujarat',
'Hansot,Bharuch,Gujarat',
'Ilav,Bharuch,Gujarat',
'Kalam,Bharuch,Gujarat',
'Kantiajal,Bharuch,Gujarat',
'Katpor,Bharuch,Gujarat',
'Kudadra,Bharuch,Gujarat',
'Malanpur,Bharuch,Gujarat',
'Obha,Bharuch,Gujarat',
'Parvat,Bharuch,Gujarat',
'Raima,Bharuch,Gujarat',
'Sayan,Bharuch,Gujarat',
'Shera,Bharuch,Gujarat',
'Sisodra,Bharuch,Gujarat',
'Sunevkalla,Bharuch,Gujarat',
'Vaghvan,Bharuch,Gujarat',
'Valner,Bharuch,Gujarat',
'Vamleshwar,Bharuch,Gujarat',
'Madafar,Bharuch,Gujarat',
'Samoj,Bharuch,Gujarat',
'Amanpur,Bharuch,Gujarat',
'Ankhi,Bharuch,Gujarat',
'Bhadkodra,Bharuch,Gujarat',
'Bhodar,Bharuch,Gujarat',
'Bojadra,Bharuch,Gujarat',
'Chhidra,Bharuch,Gujarat',
'Dabha,Bharuch,Gujarat',
'Dehgam,Bharuch,Gujarat',
'Devla,Bharuch,Gujarat',
'Dolia,Bharuch,Gujarat',
'Gajera,Bharuch,Gujarat',
'Islampur,Bharuch,Gujarat',
'Jambusar Bazar,Bharuch,Gujarat',
'Jambusar,Bharuch,Gujarat',
'Jantran,Bharuch,Gujarat',
'Kahanva,Bharuch,Gujarat',
'Kalak,Bharuch,Gujarat',
'Kaliari,Bharuch,Gujarat',
'Kangam,Bharuch,Gujarat',
'Kareli,Bharuch,Gujarat',
'Karmad,Bharuch,Gujarat',
'Kava,Bharuch,Gujarat',
'Kavi,Bharuch,Gujarat',
'Kavli,Bharuch,Gujarat',
'Khanpurdeh,Bharuch,Gujarat',
'Kimoj,Bharuch,Gujarat',
'Kora,Bharuch,Gujarat',
'Magnad,Bharuch,Gujarat',
'Malpur,Bharuch,Gujarat',
'Nada,Bharuch,Gujarat',
'Nahar,Bharuch,Gujarat',
'Nobar,Bharuch,Gujarat',
'Nodhna,Bharuch,Gujarat',
'Pipludra,Bharuch,Gujarat',
'Runad,Bharuch,Gujarat',
'Sambha,Bharuch,Gujarat',
'Sarod,Bharuch,Gujarat',
'Sigam,Bharuch,Gujarat',
'Tankari,Bharuch,Gujarat',
'Tundaj,Bharuch,Gujarat',
'Uber,Bharuch,Gujarat',
'Uchhad,Bharuch,Gujarat',
'Umra,Bharuch,Gujarat',
'Vadadala,Bharuch,Gujarat',
'Vahelam,Bharuch,Gujarat',
'Valvi,Bharuch,Gujarat',
'Vedach,Bharuch,Gujarat',
'Ambos,Bharuch,Gujarat',
'Anadhara,Bharuch,Gujarat',
'Avidha,Bharuch,Gujarat',
'Bamalla,Bharuch,Gujarat',
'Dadheda,Bharuch,Gujarat',
'Dharoli,Bharuch,Gujarat',
'Goratia,Bharuch,Gujarat',
'Gundecha,Bharuch,Gujarat',
'Haripura,Bharuch,Gujarat',
'Jarsad,Bharuch,Gujarat',
'Jespor,Bharuch,Gujarat',
'Jhagadia,Bharuch,Gujarat',
'Kadvali,Bharuch,Gujarat',
'Limodra,Bharuch,Gujarat',
'Mortalav,Bharuch,Gujarat',
'Mota Sorva,Bharuch,Gujarat',
'Motamalpur,Bharuch,Gujarat',
'Navagamvborjai,Bharuch,Gujarat',
'Padal,Bharuch,Gujarat',
'Padvania,Bharuch,Gujarat',
'Pipadhara,Bharuch,Gujarat',
'Raisingpura,Bharuch,Gujarat',
'Rajpardi,Bharuch,Gujarat',
'Ranipura,Bharuch,Gujarat',
'Razalwada,Bharuch,Gujarat',
'Sanjali,Bharuch,Gujarat',
'Sarsa,Bharuch,Gujarat',
'Sarsad,Bharuch,Gujarat',
'Simadhra,Bharuch,Gujarat',
'Siyali,Bharuch,Gujarat',
'Talodra,Bharuch,Gujarat',
'Uchedia,Bharuch,Gujarat',
'Umadhra,Bharuch,Gujarat',
'Umalla,Bharuch,Gujarat',
'Umarva,Bharuch,Gujarat',
'Vadkhunta,Bharuch,Gujarat',
'Vanakpore,Bharuch,Gujarat',
'Vankal,Bharuch,Gujarat',
'Vasna,Bharuch,Gujarat',
'Velugam,Bharuch,Gujarat',
'Wali,Bharuch,Gujarat',
'Asha,Bharuch,Gujarat',
'Fitchwada,Bharuch,Gujarat',
'Indore,Bharuch,Gujarat',
'Jamboi,Bharuch,Gujarat',
'Kapat,Bharuch,Gujarat',
'Panetha,Bharuch,Gujarat',
'Bharan,Surat,Gujarat',
'Boridra,Surat,Gujarat',
'Gora Colony,Bharuch,Gujarat',
'Kharach,Surat,Gujarat',
'Panjroli,Surat,Gujarat',
'Ambagam,Bharuch,Gujarat',
'Barkatura,Bharuch,Gujarat',
'Dhavliver,Bharuch,Gujarat',
'Jaoli,Bharuch,Gujarat',
'Kherpada,Bharuch,Gujarat',
'Kolvan,Bharuch,Gujarat',
'Langdi,Bharuch,Gujarat',
'Nevdiamba,Bharuch,Gujarat',
'Palaswada,Bharuch,Gujarat',
'Rajnivad,Bharuch,Gujarat',
'Sagbara,Bharuch,Gujarat',
'Selamba,Bharuch,Gujarat',
'Akod,Bharuch,Gujarat',
'Ghamnad,Bharuch,Gujarat',
'Khojbal,Bharuch,Gujarat',
'Ambheta,Bharuch,Gujarat',
'Anor,Bharuch,Gujarat',
'Atali,Bharuch,Gujarat',
'Chancvel,Bharuch,Gujarat',
'Dahej,Bharuch,Gujarat',
'Dungari,Bharuch,Gujarat',
'Eksal,Bharuch,Gujarat',
'Galenda,Bharuch,Gujarat',
'Gandhar,Bharuch,Gujarat',
'Goladra,Bharuch,Gujarat',
'Janiadra,Bharuch,Gujarat',
'Kadodara,Bharuch,Gujarat',
'Kalam,Bharuch,Gujarat',
'Karela,Bharuch,Gujarat',
'Kervada,Bharuch,Gujarat',
'Keshlu,Bharuch,Gujarat',
'Keshwan,Bharuch,Gujarat',
'Kolavana,Bharuch,Gujarat',
'Kothia,Bharuch,Gujarat',
'Kurchan,Bharuch,Gujarat',
'Lakhigam,Bharuch,Gujarat',
'Limdi,Bharuch,Gujarat',
'Manad,Bharuch,Gujarat',
'Mosam,Bharuch,Gujarat',
'Muler,Bharuch,Gujarat',
'Nandida,Bharuch,Gujarat',
'Narnavi,Bharuch,Gujarat',
'Ochhan,Bharuch,Gujarat',
'Ora,Bharuch,Gujarat',
'Padaria,Bharuch,Gujarat',
'Pahaj,Bharuch,Gujarat',
'Pakhajan,Bharuch,Gujarat',
'Paniadra,Bharuch,Gujarat',
'Pipalia,Bharuch,Gujarat',
'Rahiad,Bharuch,Gujarat',
'Roza Tankaria,Bharuch,Gujarat',
'Samni,Bharuch,Gujarat',
'Saran,Bharuch,Gujarat',
'Saykha,Bharuch,Gujarat',
'Sutrel,Bharuch,Gujarat',
'Tanchha,Bharuch,Gujarat',
'Trankal,Bharuch,Gujarat',
'Vadadla,Bharuch,Gujarat',
'Vagra,Bharuch,Gujarat',
'Vahial,Bharuch,Gujarat',
'Vasti Khandali,Bharuch,Gujarat',
'Vegni,Bharuch,Gujarat',
'Almawadi,Bharuch,Gujarat',
'Anjoli,Bharuch,Gujarat',
'Arethi,Bharuch,Gujarat',
'Atkhol,Bharuch,Gujarat',
'Babda,Bharuch,Gujarat',
'Baladva,Bharuch,Gujarat',
'Bhamadia,Bharuch,Gujarat',
'Bharadia,Bharuch,Gujarat',
'Bhenskhetar,Bharuch,Gujarat',
'Bhilod,Bharuch,Gujarat',
'Bilothi,Bharuch,Gujarat',
'Chandravan,Bharuch,Gujarat',
'Chasvad,Bharuch,Gujarat',
'Chikhli,Bharuch,Gujarat',
'Dattanagar,Bharuch,Gujarat',
'Dehali,Bharuch,Gujarat',
'Desad,Bharuch,Gujarat',
'Dholgam,Bharuch,Gujarat',
'Dolatpur,Bharuch,Gujarat',
'Gundia,Bharuch,Gujarat',
'Itakla,Bharuch,Gujarat',
'Jabugam,Bharuch,Gujarat',
'Kabirgam,Bharuch,Gujarat',
'Kamalia,Bharuch,Gujarat',
'Kambodia,Bharuch,Gujarat',
'Kantipada,Bharuch,Gujarat',
'Kara,Bharuch,Gujarat',
'Kavachia,Bharuch,Gujarat',
'Kelvikuva,Bharuch,Gujarat',
'Khardipada,Bharuch,Gujarat',
'Kharetha,Bharuch,Gujarat',
'Koyli Mandvi,Bharuch,Gujarat',
'Limet,Bharuch,Gujarat',
'Luna,Bharuch,Gujarat',
'Mandala,Bharuch,Gujarat',
'Mauza,Bharuch,Gujarat',
'Mela,Bharuch,Gujarat',
'Mokhdi,Bharuch,Gujarat',
'Moriana,Bharuch,Gujarat',
'Mota Jambuda,Bharuch,Gujarat',
'Naldhari,Bharuch,Gujarat',
'Netrang,Bharuch,Gujarat',
'Panuda,Bharuch,Gujarat',
'Pather,Bharuch,Gujarat',
'Rajgadh,Bharuch,Gujarat',
'Rajpara,Bharuch,Gujarat',
'Sabaria,Bharuch,Gujarat',
'Sevad,Bharuch,Gujarat',
'Siludi,Bharuch,Gujarat',
'Sodgam,Bharuch,Gujarat',
'Thava,Bharuch,Gujarat',
'Tuna,Bharuch,Gujarat',
'Umargam,Bharuch,Gujarat',
'Vadfalia,Bharuch,Gujarat',
'Valia,Bharuch,Gujarat',
'Zak,Bharuch,Gujarat',
'Adhewada,Bhavnagar,Gujarat',
'Akwada,Bhavnagar,Gujarat',
'Awaniya,Bhavnagar,Gujarat',
'Bhandariya,Bhavnagar,Gujarat',
'Bhavnagar Anandnagar,Bhavnagar,Gujarat',
'Bhavnagar BPTI,Bhavnagar,Gujarat',
'Bhavnagar Chavdigate,Bhavnagar,Gujarat',
'Bhavnagar Chitra,Bhavnagar,Gujarat',
'Bhavnagar Collectorate,Bhavnagar,Gujarat',
'Bhavnagar Gogha Circle,Bhavnagar,Gujarat',
'Bhavnagar H.O,Bhavnagar,Gujarat',
'Bhavnagar K K Road,Bhavnagar,Gujarat',
'Bhavnagar K Nagar,Bhavnagar,Gujarat',
'Bhavnagar Khargate,Bhavnagar,Gujarat',
'Bhavnagar Kumbharwada,Bhavnagar,Gujarat',
'Bhavnagar M K Road,Bhavnagar,Gujarat',
'Bhavnagar Nirmalnagar,Bhavnagar,Gujarat',
'Bhavnagar Para,Bhavnagar,Gujarat',
'Bhavnagar Station Road,Bhavnagar,Gujarat',
'Bhavnagar Takhteshwar,Bhavnagar,Gujarat',
'Bhavnagar Vora Bazar,Bhavnagar,Gujarat',
'Bhavnagar Wadva,Bhavnagar,Gujarat',
'Bhikhda,Bhavnagar,Gujarat',
'Bhojpara,Bhavnagar,Gujarat',
'Budhel,Bhavnagar,Gujarat',
'Concret Jetty,Bhavnagar,Gujarat',
'Fariyadka,Bhavnagar,Gujarat',
'Gadhesar,Bhavnagar,Gujarat',
'Hathab,Bhavnagar,Gujarat',
'Hoidad,Bhavnagar,Gujarat',
'Ingorala,Bhavnagar,Gujarat',
'Kamlej,Bhavnagar,Gujarat',
'Kardej,Bhavnagar,Gujarat',
'Khadsaliya,Bhavnagar,Gujarat',
'Koliyak,Bhavnagar,Gujarat',
'Lakhanka,Bhavnagar,Gujarat',
'Malanka,Bhavnagar,Gujarat',
'Malpara,Bhavnagar,Gujarat',
'Nari,Bhavnagar,Gujarat',
'Nava Ratanpar,Bhavnagar,Gujarat',
'Sidsar,Bhavnagar,Gujarat',
'Tajpar,Bhavnagar,Gujarat',
'Tana,Bhavnagar,Gujarat',
'Valukad,Bhavnagar,Gujarat',
'Vartej,Bhavnagar,Gujarat',
'Bambhan,Bhavnagar,Gujarat',
'Bhadla Nana,Bhavnagar,Gujarat',
'Bhadravadi,Bhavnagar,Gujarat',
'Bhimdad,Bhavnagar,Gujarat',
'Bodi,Bhavnagar,Gujarat',
'Botad,Bhavnagar,Gujarat',
'Botad Statoin Road,Bhavnagar,Gujarat',
'Botad Town,Bhavnagar,Gujarat',
'Dhakania,Bhavnagar,Gujarat',
'Gadhadia,Bhavnagar,Gujarat',
'Haddad,Bhavnagar,Gujarat',
'Kariyani,Bhavnagar,Gujarat',
'Kumbhara,Bhavnagar,Gujarat',
'Lathidad,Bhavnagar,Gujarat',
'Nagalpar,Bhavnagar,Gujarat',
'Ningala,Bhavnagar,Gujarat',
'Paliyad,Bhavnagar,Gujarat',
'Rangpur,Bhavnagar,Gujarat',
'Salaiya,Bhavnagar,Gujarat',
'Samadhiyala No. 1,Bhavnagar,Gujarat',
'Samadhiyala No. 2,Bhavnagar,Gujarat',
'Sangvadar,Bhavnagar,Gujarat',
'Sarva,Bhavnagar,Gujarat',
'Bandhvad,Patan,Gujarat',
'Bhilot,Patan,Gujarat',
'Chalvada,Patan,Gujarat',
'D R.S.,Patan,Gujarat',
'Dharvadi,Patan,Gujarat',
'Dholakda,Patan,Gujarat',
'Gotarka,Patan,Gujarat',
'Javantri,Patan,Gujarat',
'Kamalpur (D),Patan,Gujarat',
'Kamalpur (S),Patan,Gujarat',
'Lotia,Patan,Gujarat',
'Masali,Patan,Gujarat',
'Memdavad,Patan,Gujarat',
'Moti Pipli,Patan,Gujarat',
'Nani Pipli,Patan,Gujarat',
'Nanpura,Patan,Gujarat',
'Radhanpur Rajgadhi,Patan,Gujarat',
'Radhanpur Rly Colony,Patan,Gujarat',
'Radhanpur,Patan,Gujarat',
'Santhli,Patan,Gujarat',
'Satun,Patan,Gujarat',
'Sinad,Patan,Gujarat',
'Subapura,Patan,Gujarat',
'Adgam,Patan,Gujarat',
'Amrapuara,Patan,Gujarat',
'Anvarpura,Patan,Gujarat',
'Aritha,Patan,Gujarat',
'Baspa,Patan,Gujarat',
'Bhadrada,Patan,Gujarat',
'Bilia,Patan,Gujarat',
'Bolera,Patan,Gujarat',
'Chandur Moti,Patan,Gujarat',
'Chandur Nani,Patan,Gujarat',
'Dadar,Patan,Gujarat',
'Daudpur,Patan,Gujarat',
'Dhadhana,Patan,Gujarat',
'Dhanora,Patan,Gujarat',
'Dudkha,Patan,Gujarat',
'Gajdinpura,Patan,Gujarat',
'Gochnath,Patan,Gujarat',
'Gujarwada,Patan,Gujarat',
'Jakhel,Patan,Gujarat',
'Jesda,Patan,Gujarat',
'Kanij,Patan,Gujarat',
'Khijdiyari,Patan,Gujarat',
'Kukrana,Patan,Gujarat',
'Kunvar,Patan,Gujarat',
'Kunvarad,Patan,Gujarat',
'Lolada,Patan,Gujarat',
'Loteshwar,Patan,Gujarat',
'Mandvi,Patan,Gujarat',
'Matrota,Patan,Gujarat',
'Memna,Patan,Gujarat',
'Mota Joravarpura,Patan,Gujarat',
'Mujpur,Patan,Gujarat',
'Nayka,Patan,Gujarat',
'Panchasar,Patan,Gujarat',
'Rafu,Patan,Gujarat',
'Ranod,Patan,Gujarat',
'Ravad,Patan,Gujarat',
'Sami,Patan,Gujarat',
'Samsherpura,Patan,Gujarat',
'Sankheshwar,Patan,Gujarat',
'Sipur,Patan,Gujarat',
'Taranagar,Patan,Gujarat',
'Tarora,Patan,Gujarat',
'Tuvad,Patan,Gujarat',
'Vaghel,Patan,Gujarat',
'Vagosan,Patan,Gujarat',
'Varana,Patan,Gujarat',
'Ved,Patan,Gujarat',
'Zilvana,Patan,Gujarat',
'Abiyana,Patan,Gujarat',
'Babra,Patan,Gujarat',
'Bamroli,Patan,Gujarat',
'Charanka,Patan,Gujarat',
'Dantisana,Patan,Gujarat',
'Detrana,Patan,Gujarat',
'Dhokavada,Patan,Gujarat',
'Gadha,Patan,Gujarat',
'Gadsai,Patan,Gujarat',
'Ganjisar,Patan,Gujarat',
'Garambadi,Patan,Gujarat',
'Gokhantar,Patan,Gujarat',
'Jakhotra,Patan,Gujarat',
'Jarusha,Patan,Gujarat',
'Koliwada,Patan,Gujarat',
'Korda,Patan,Gujarat',
'Lodra,Patan,Gujarat',
'Madhutra,Patan,Gujarat',
'Padla,Patan,Gujarat',
'Par,Patan,Gujarat',
'Piprana,Patan,Gujarat',
'Santalpur,Patan,Gujarat',
'Sidhada,Patan,Gujarat',
'Vahuva,Patan,Gujarat',
'Varahi,Patan,Gujarat',
'Zandala,Patan,Gujarat',
'Zazam,Patan,Gujarat',
'Zekhada,Patan,Gujarat',
'Kilana,Patan,Gujarat',
'Bilia,Patan,Gujarat',
'Chandravati,Patan,Gujarat',
'Dasawada,Patan,Gujarat',
'Dethli,Patan,Gujarat',
'Dhanawada,Patan,Gujarat',
'Dindrol,Patan,Gujarat',
'Gangalasan,Patan,Gujarat',
'Ganvada,Patan,Gujarat',
'Kakoshi,Patan,Gujarat',
'Kalyana,Patan,Gujarat',
'Khali,Patan,Gujarat',
'Kholvada,Patan,Gujarat',
'Kunwara,Patan,Gujarat',
'Meloj,Patan,Gujarat',
'Methan,Patan,Gujarat',
'Metrana,Patan,Gujarat',
'Mudana,Patan,Gujarat',
'Mudvada,Patan,Gujarat',
'Nagvasana,Patan,Gujarat',
'Nandotri,Patan,Gujarat',
'Nedra,Patan,Gujarat',
'Pachakvada,Patan,Gujarat',
'Sahesa,Patan,Gujarat',
'Samoda,Patan,Gujarat',
'Sedrana,Patan,Gujarat',
'Sidhpur Jafri Baug,Patan,Gujarat',
'Sidhpur Jam Chakla,Patan,Gujarat',
'Sidhpur Market Yard,Patan,Gujarat',
'Sidhpur,Patan,Gujarat',
'Tavadia,Patan,Gujarat',
'Umru,Patan,Gujarat',
'Vadhana,Patan,Gujarat',
'Vanasan,Patan,Gujarat',
'Varsila,Patan,Gujarat',
'Bhomiyavadar,Jamnagar,Gujarat',
'Simar,Jamnagar,Gujarat',
'Ishwaria,Jamnagar,Gujarat',
'Amar,Porbandar,Gujarat',
'Amipur,Porbandar,Gujarat',
'Bhadula,Porbandar,Gujarat',
'Chauta,Porbandar,Gujarat',
'Chhatrava,Porbandar,Gujarat',
'Devda,Porbandar,Gujarat',
'Farer,Porbandar,Gujarat',
'Gokran,Porbandar,Gujarat',
'Ishwaria,Porbandar,Gujarat',
'Jamra,Porbandar,Gujarat',
'Kadegi,Porbandar,Gujarat',
'Kansabad,Porbandar,Gujarat',
'Kavalkva,Porbandar,Gujarat',
'Khageshri,Porbandar,Gujarat',
'Kotda,Porbandar,Gujarat',
'Mahiyari,Porbandar,Gujarat',
'Mahobatpara,Porbandar,Gujarat',
'Mal,Porbandar,Gujarat',
'Malanka,Gondal,Gujarat',
'Mandva,Porbandar,Gujarat',
'Moddar,Porbandar,Gujarat',
'Pasvali,Porbandar,Gujarat',
'Segras,Porbandar,Gujarat',
'Piplana,Junagadh,Gujarat',
'Divrana,Junagadh,Gujarat',
'Fulrama,Junagadh,Gujarat',
'Juthal,Junagadh,Gujarat',
'Osa,Junagadh,Gujarat',
'Sandha,Junagadh,Gujarat',
'Modhvada,Porbandar,Gujarat',
'Adityana,Porbandar,Gujarat',
'Advana,Porbandar,Gujarat',
'Bagvadar,Porbandar,Gujarat',
'Bakharla,Porbandar,Gujarat',
'Balej,Porbandar,Gujarat',
'Bhad,Porbandar,Gujarat',
'Bharvada,Porbandar,Gujarat',
'Bhavpara,Porbandar,Gujarat',
'Bhetakadi,Porbandar,Gujarat',
'Bokhira,Porbandar,Gujarat',
'Boricha,Porbandar,Gujarat',
'Chhaya,Porbandar,Gujarat',
'Degam,Porbandar,Gujarat',
'Erda,Porbandar,Gujarat',
'Fatana,Porbandar,Gujarat',
'Garej,Porbandar,Gujarat',
'Ghodadar,Porbandar,Gujarat',
'Gosa,Porbandar,Gujarat',
'Kadachh,Porbandar,Gujarat',
'Khambhodara,Porbandar,Gujarat',
'Khapat,Porbandar,Gujarat',
'Khistri,Porbandar,Gujarat',
'Kindarkheda,Porbandar,Gujarat',
'Kuchhdi,Porbandar,Gujarat',
'Kutiyana,Porbandar,Gujarat',
'Madhavpur,Porbandar,Gujarat',
'Majivana,Porbandar,Gujarat',
'Mander,Porbandar,Gujarat',
'Mitrala,Porbandar,Gujarat',
'Miyani,Porbandar,Gujarat',
'Morana,Porbandar,Gujarat',
'Mul Madhavpur,Porbandar,Gujarat',
'Nagka,Porbandar,Gujarat',
'Navibandar,Porbandar,Gujarat',
'Odadar,Porbandar,Gujarat',
'Pandavadar,Porbandar,Gujarat',
'Pata,Porbandar,Gujarat',
'Porbandar Birla Sagar,Porbandar,Gujarat',
'Porbandar G.I.D.C.,Porbandar,Gujarat',
'Porbandar H.O,Porbandar,Gujarat',
'Ranakandorana,Porbandar,Gujarat',
'Ranavav Railway Station,Porbandar,Gujarat',
'Ranavav,Porbandar,Gujarat',
'Ratdi,Porbandar,Gujarat',
'Ratia,Porbandar,Gujarat',
'Shingda,Porbandar,Gujarat',
'Sisli,Porbandar,Gujarat',
'Sodhana,Porbandar,Gujarat',
'Tukda Gosa,Porbandar,Gujarat',
'Tukda Miyan,Porbandar,Gujarat',
'Vadala Rana,Porbandar,Gujarat',
'Visavada,Porbandar,Gujarat',
'Amardad,Porbandar,Gujarat',
'Aniyari,Porbandar,Gujarat',
'Bapodar,Porbandar,Gujarat',
'Bhod,Porbandar,Gujarat',
'Bhodadar,Porbandar,Gujarat',
'Bileshwar,Porbandar,Gujarat',
'Dharampur,Porbandar,Gujarat',
'Jamboo,Porbandar,Gujarat',
'Mokal,Porbandar,Gujarat',
'Ranabordi,Porbandar,Gujarat',
'Ranakhirasara,Porbandar,Gujarat',
'Thoyana,Porbandar,Gujarat',
'Vadvalarana,Porbandar,Gujarat',
'Valotra,Porbandar,Gujarat',
'Devgam,Rajkot,Gujarat',
'Jivapar,Gondal,Gujarat',
'Kanpara,Gondal,Gujarat',
'Khirsara,Rajkot,Gujarat',
'Nagar Pipaliya,Rajkot,Gujarat',
'Panchavada,Gondal,Gujarat',
'Rajkot Metoda Gidc,Rajkot,Gujarat',
'Bhavpar,Rajkot,Gujarat',
'Bodki,Rajkot,Gujarat',
'Dahisara,Rajkot,Gujarat',
'Kuntasi,Rajkot,Gujarat',
'Lavanpur,Rajkot,Gujarat',
'Mota Bhela,Rajkot,Gujarat',
'Varsamedi,Rajkot,Gujarat',
'Vavania,Rajkot,Gujarat',
'Virparda,Rajkot,Gujarat',
'Bhadajalia,Gondal,Gujarat',
'Bhader,Gondal,Gujarat',
'Bhola,Gondal,Gujarat',
'Bhukhi,Gondal,Gujarat',
'Chhadvavadar,Gondal,Gujarat',
'Chhatrasa,Gondal,Gujarat',
'Chichod,Gondal,Gujarat',
'Dhoraji D.G.,Gondal,Gujarat',
'Dhoraji G.P.,Gondal,Gujarat',
'Dhoraji,Gondal,Gujarat',
'Dhoraji S.R.,Gondal,Gujarat',
'Jamnavad,Gondal,Gujarat',
'Kalana,Gondal,Gujarat',
'Moti Marad,Gondal,Gujarat',
'Moti Vavdi,Gondal,Gujarat',
'Nagalkhada,Gondal,Gujarat',
'Nani Vavdi,Gondal,Gujarat',
'Patanvav,Gondal,Gujarat',
'Pipaliya,Gondal,Gujarat',
'Supedi,Gondal,Gujarat',
'Vadodar,Gondal,Gujarat',
'Zanzmer,Gondal,Gujarat',
'Hadmatiya,Rajkot,Gujarat',
'Khajurdi,Rajkot,Gujarat',
'Khakhdabela,Rajkot,Gujarat',
'Suvag,Rajkot,Gujarat',
'Visaman,Rajkot,Gujarat',
'Ambardi,Gondal,Gujarat',
'Anida Bhalodi,Gondal,Gujarat',
'Bandhiya,Gondal,Gujarat',
'Bandra,Gondal,Gujarat',
'Bhunava,Gondal,Gujarat',
'Bildi,Gondal,Gujarat',
'Biliyala,Gondal,Gujarat',
'Charakhadi,Gondal,Gujarat',
'Chordi,Gondal,Gujarat',
'Dadva Mota,Gondal,Gujarat',
'Daiya,Gondal,Gujarat',
'Dalia,Gondal,Gujarat',
'Derdi Kumbaji,Gondal,Gujarat',
'Devchadi,Gondal,Gujarat',
'Dhudasiya,Gondal,Gujarat',
'Garnara,Gondal,Gujarat',
'Ghoghavadar,Gondal,Gujarat',
'Gomta,Gondal,Gujarat',
'Gondal Bhagvatpara,Gondal,Gujarat',
'Gondal Bhojrajpara,Gondal,Gujarat',
'Gondal Bhuvneshwari Pith,Gondal,Gujarat',
'Gondal College Chowk,Gondal,Gujarat',
'Gondal H.O,Gondal,Gujarat',
'Gondal Market Yard,Gondal,Gujarat',
'Gundasara,Gondal,Gujarat',
'Hadamtala (Kolithad),Gondal,Gujarat',
'Hadamtala (Shemla),Gondal,Gujarat',
'Jamvadi,Gondal,Gujarat',
'Kamar Kotda,Gondal,Gujarat',
'Khadvanthali,Gondal,Gujarat',
'Khambha,Gondal,Gujarat',
'Khandadhar,Gondal,Gujarat',
'Kolithad,Gondal,Gujarat',
'Lunivav,Gondal,Gujarat',
'Mandan Kundla,Gondal,Gujarat',
'Meta Khambhaliya,Gondal,Gujarat',
'Mota Mandva,Gondal,Gujarat',
'Moti Khilori,Gondal,Gujarat',
'Moviya,Gondal,Gujarat',
'Nana Mandva,Gondal,Gujarat',
'Navagam,Gondal,Gujarat',
'Patidad,Gondal,Gujarat',
'Pipaliya(Sadak),Gondal,Gujarat',
'Ramod,Gondal,Gujarat',
'Ravna,Gondal,Gujarat',
'Rib,Gondal,Gujarat',
'Ribda,Gondal,Gujarat',
'Sandhvaya,Gondal,Gujarat',
'Semla,Gondal,Gujarat',
'Shivrajgadh,Gondal,Gujarat',
'Shrinathgadh,Gondal,Gujarat',
'Sultanpur,Gondal,Gujarat',
'Trakuda,Gondal,Gujarat',
'Umrali,Gondal,Gujarat',
'Vachhra,Gondal,Gujarat',
'Vasavad,Gondal,Gujarat',
'Vekri,Gondal,Gujarat',
'Vinzivad,Gondal,Gujarat',
'Vora Kotda,Gondal,Gujarat',
'Baradiya,Gondal,Gujarat',
'Bhadra,Gondal,Gujarat',
'Boria,Gondal,Gujarat',
'Charel,Gondal,Gujarat',
'Chavandi,Gondal,Gujarat',
'Chitravad,Gondal,Gujarat',
'Dadar,Gondal,Gujarat',
'Dadvi,Gondal,Gujarat',
'Dholidhar,Gondal,Gujarat',
'Dudhivadar,Gondal,Gujarat',
'Gundasari,Gondal,Gujarat',
'Jamkandorna,Gondal,Gujarat',
'Khajurda,Gondal,Gujarat',
'Khatli,Gondal,Gujarat',
'Nava Matravad,Gondal,Gujarat',
'Pipardi,Gondal,Gujarat',
'Raidi,Gondal,Gujarat',
'Roghel,Gondal,Gujarat',
'Sajadiyali,Gondal,Gujarat',
'Satodad,Gondal,Gujarat',
'Sodvadar,Gondal,Gujarat',
'Vavdi,Gondal,Gujarat',
'Ishavariya,Gondal,Gujarat',
'Ajmer,Gondal,Gujarat',
'Amrapar,Gondal,Gujarat',
'Atkot,Gondal,Gujarat',
'Bakhalvad,Gondal,Gujarat',
'Baldhoi,Gondal,Gujarat',
'Bhadla,Gondal,Gujarat',
'Bhandaria,Rajkot,Gujarat',
'Bogharavadar,Rajkot,Gujarat',
'Chhasiya,Gondal,Gujarat',
'Dahisara,Rajkot,Gujarat',
'Devdhari,Gondal,Gujarat',
'Dodiyala,Gondal,Gujarat',
'Gadhadia,Gondal,Gujarat',
'Gadhdiya,Rajkot,Gujarat',
'Ghela Somnath,Gondal,Gujarat',
'Gokhlana,Gondal,Gujarat',
'Gundala (Jas),Gondal,Gujarat',
'Hathasani,Gondal,Gujarat',
'Jangvad,Gondal,Gujarat',
'Jasapar,Gondal,Gujarat',
'Jasdan,Gondal,Gujarat',
'Jivapar,Gondal,Gujarat',
'Juna Pipaliya,Gondal,Gujarat',
'Kaduka,Gondal,Gujarat',
'Kalasar,Gondal,Gujarat',
'Kamalapur,Rajkot,Gujarat',
'Kanesara,Rajkot,Gujarat',
'Kanpar,Gondal,Gujarat',
'Khandhevadia,Gondal,Gujarat',
'Kharachiya Jam,Gondal,Gujarat',
'Kothi,Rajkot,Gujarat',
'Kundani,Rajkot,Gujarat',
'Lakhavad Moti,Gondal,Gujarat',
'Lakhavad Nani,Gondal,Gujarat',
'Lilapur,Gondal,Gujarat',
'Meghpar,Gondal,Gujarat',
'Modhuka,Gondal,Gujarat',
'Panchavda,Gondal,Gujarat',
'Pipardi,Gondal,Gujarat',
'Sanali,Gondal,Gujarat',
'Sanathali,Gondal,Gujarat',
'Shivrajpur,Gondal,Gujarat',
'Vadod,Gondal,Gujarat',
'Vangadhra,Gondal,Gujarat',
'Vinchhiya,Gondal,Gujarat',
'Virnagar,Gondal,Gujarat',
'Zundala,Gondal,Gujarat',
'Akala,Gondal,Gujarat',
'Amarnagar,Gondal,Gujarat',
'Bava Pipaliya,Gondal,Gujarat',
'Champrajpur,Gondal,Gujarat',
'Charania,Amreli,Gujarat',
'Dedarva,Gondal,Gujarat',
'Derdi,Gondal,Gujarat',
'Devki Galol,Gondal,Gujarat',
'Devla,Gondal,Gujarat',
'Fareni,Gondal,Gujarat',
'Jambudi,Gondal,Gujarat',
'Jetalsar Gam,Gondal,Gujarat',
'Jetalsar Jn.,Gondal,Gujarat',
'Jetpur F.W.,Gondal,Gujarat',
'Jetpur K.B.,Gondal,Gujarat',
'Jetpur,Gondal,Gujarat',
'Juni Sankli,Gondal,Gujarat',
'Kagvad,Gondal,Gujarat',
'Kerali,Gondal,Gujarat',
'Kharachiya,Gondal,Gujarat',
'Khirasara,Gondal,Gujarat',
'Mandlikpur,Gondal,Gujarat',
'Mevasa,Gondal,Gujarat',
'Mota Gundala,Gondal,Gujarat',
'Moti Parabadi,Gondal,Gujarat',
'Nani Parabadi,Gondal,Gujarat',
'Navagadh,Gondal,Gujarat',
'Panch Pipla,Gondal,Gujarat',
'Pedhla,Gondal,Gujarat',
'Pipalva,Gondal,Gujarat',
'Pithadia,Gondal,Gujarat',
'Premgadh,Gondal,Gujarat',
'Rabarika,Gondal,Gujarat',
'Reshamdi Galol,Gondal,Gujarat',
'Rupavati,Gondal,Gujarat',
'Samadhiyala,Gondal,Gujarat',
'Sardharpur,Gondal,Gujarat',
'Thana Galol,Gondal,Gujarat',
'Timbdi Arab,Gondal,Gujarat',
'Torania,Gondal,Gujarat',
'Vadasada,Gondal,Gujarat',
'Vavdi Station,Gondal,Gujarat',
'Virpur,Gondal,Gujarat',
'Makajimeghpar,Rajkot,Gujarat',
'Anida Vachhra,Gondal,Gujarat',
'Ardoi,Gondal,Gujarat',
'Bhadva,Gondal,Gujarat',
'Champabeda,Gondal,Gujarat',
'Khareda,Gondal,Gujarat',
'Kotda Sangani,Gondal,Gujarat',
'Manekwada,Gondal,Gujarat',
'Nonghanchora,Gondal,Gujarat',
'Rajapara,Gondal,Gujarat',
'Satapar,Gondal,Gujarat',
'Shishak,Gondal,Gujarat',
'Juna Rajpipala,Rajkot,Gujarat',
'Mengni,Gondal,Gujarat',
'Shapar( Halar),Rajkot,Gujarat',
'Veraval (Shapar),Rajkot,Gujarat',
'Chandli,Gondal,Gujarat',
'Chibhda,Gondal,Gujarat',
'Dhudiadomda,Rajkot,Gujarat',
'Kotha Pipalia,Gondal,Gujarat',
'Lodhika,Gondal,Gujarat',
'Motavada,Rajkot,Gujarat',
'Pardi,Rajkot,Gujarat',
'Sal Pipalia,Rajkot,Gujarat',
'Sanganva,Gondal,Gujarat',
'Derala,Rajkot,Gujarat',
'Vaghpar,Rajkot,Gujarat',
'Jajasar,Rajkot,Gujarat',
'Juna Ghantila,Rajkot,Gujarat',
'Juna Nagdavas,Rajkot,Gujarat',
'Khakhrechi,Rajkot,Gujarat',
'Khirai,Rajkot,Gujarat',
'Kumbhariya,Rajkot,Gujarat',
'Maliya Miyana,Rajkot,Gujarat',
'Motibarar,Rajkot,Gujarat',
'Nani Barar,Rajkot,Gujarat',
'Navagam,Rajkot,Gujarat',
'Saravad,Rajkot,Gujarat',
'Sultanpur,Rajkot,Gujarat',
'Targhadi,Rajkot,Gujarat',
'Vadharva,Rajkot,Gujarat',
'Vejalpar,Rajkot,Gujarat',
'Venasar,Rajkot,Gujarat',
'Virvadrka,Rajkot,Gujarat',
'Bagathala,Rajkot,Gujarat',
'Barvala,Rajkot,Gujarat',
'Bela Rangpar,Rajkot,Gujarat',
'Bhadiyad,Rajkot,Gujarat',
'Biliya,Rajkot,Gujarat',
'Chachapar,Rajkot,Gujarat',
'Gala,Rajkot,Gujarat',
'Ghunda (S),Rajkot,Gujarat',
'Ghuntu,Rajkot,Gujarat',
'Gungan,Rajkot,Gujarat',
'Haripar,Rajkot,Gujarat',
'Jambudiya,Rajkot,Gujarat',
'Jetpar (M),Rajkot,Gujarat',
'Jivapar,Rajkot,Gujarat',
'Jodjpar Nadi,Rajkot,Gujarat',
'Khakhrala,Rajkot,Gujarat',
'Khanpar,Rajkot,Gujarat',
'Kherda,Rajkot,Gujarat',
'Khevaliya,Rajkot,Gujarat',
'Lilapar,Rajkot,Gujarat',
'Mahendranagar,Rajkot,Gujarat',
'Makansar,Rajkot,Gujarat',
'Manekwada,Rajkot,Gujarat',
'Morbi Eng.College,Rajkot,Gujarat',
'Morbi GIDC,Rajkot,Gujarat',
'Morbi Nani Bazar,Rajkot,Gujarat',
'Morbi Ppw,Rajkot,Gujarat',
'Morbi,Rajkot,Gujarat',
'Morbi Shakti Plot,Rajkot,Gujarat',
'Nani Vavdi,Rajkot,Gujarat',
'Nichimandal,Rajkot,Gujarat',
'Panchasar,Rajkot,Gujarat',
'Paneli,Rajkot,Gujarat',
'Pipaliya,Rajkot,Gujarat',
'Pipli,Rajkot,Gujarat',
'Rafaleshwar,Rajkot,Gujarat',
'Rajpar,Rajkot,Gujarat',
'Rangpar (Bela),Rajkot,Gujarat',
'Ravapar,Rajkot,Gujarat',
'Sadulkanava,Rajkot,Gujarat',
'Sapar,Rajkot,Gujarat',
'Shakat Sanala,Rajkot,Gujarat',
'Sokhda,Rajkot,Gujarat',
'Thorala,Rajkot,Gujarat',
'Unchi Mandal,Rajkot,Gujarat',
'Vankada,Rajkot,Gujarat',
'Virpar,Rajkot,Gujarat',
'Zinkiyali,Rajkot,Gujarat',
'Adbalka,Rajkot,Gujarat',
'Dungarka,Rajkot,Gujarat',
'Ishwariya,Rajkot,Gujarat',
'Khambhala,Rajkot,Gujarat',
'Khamta,Rajkot,Gujarat',
'Khandheri,Rajkot,Gujarat',
'Khodapipar,Rajkot,Gujarat',
'Motakhijadia,Rajkot,Gujarat',
'Motichanol,Rajkot,Gujarat',
'Nana Khijadia,Rajkot,Gujarat',
'Paddhari,Rajkot,Gujarat',
'Rampar Mota,Rajkot,Gujarat',
'Rampar Pati,Rajkot,Gujarat',
'Rupavati,Rajkot,Gujarat',
'Sarapdad,Rajkot,Gujarat',
'Targhari,Rajkot,Gujarat',
'Thoriyali,Rajkot,Gujarat',
'Ukarda,Rajkot,Gujarat',
'Zilariya,Rajkot,Gujarat',
'Anandpar Navagam,Rajkot,Gujarat',
'Anandpar(Morbi),Rajkot,Gujarat',
'Bedi(Rajkot),Rajkot,Gujarat',
'Bedla,Rajkot,Gujarat',
'Bhupgadh,Rajkot,Gujarat',
'Devgam,Rajkot,Gujarat',
'Dholara,Rajkot,Gujarat',
'Gadhaka,Rajkot,Gujarat',
'Gauridad,Rajkot,Gujarat',
'Hadmatia,Rajkot,Gujarat',
'Halenda,Rajkot,Gujarat',
'Haripar,Rajkot,Gujarat',
'Jaliya(Dhrol),Rajkot,Gujarat',
'Kagadadi,Rajkot,Gujarat',
'Kankot,Rajkot,Gujarat',
'Kasturbadham,Rajkot,Gujarat',
'Kharechiya,Rajkot,Gujarat',
'Kherdi,Rajkot,Gujarat',
'Khirasara,Rajkot,Gujarat',
'Khokhaddad,Rajkot,Gujarat',
'Khorana,Rajkot,Gujarat',
'Kotda Nayani,Rajkot,Gujarat',
'Kotharia,Rajkot,Gujarat',
'Kothariatbhospital,Rajkot,Gujarat',
'Kuchiyadad,Rajkot,Gujarat',
'Kuvadava,Rajkot,Gujarat',
'Madhapar,Rajkot,Gujarat',
'Mafatiyapara,Rajkot,Gujarat',
'Magharvada,Rajkot,Gujarat',
'Mahika,Rajkot,Gujarat',
'Maliyasan,Rajkot,Gujarat',
'Mavdi,Rajkot,Gujarat',
'Mesavada,Rajkot,Gujarat',
'Mota Mava,Rajkot,Gujarat',
'Padasan,Rajkot,Gujarat',
'Pal,Rajkot,Gujarat',
'Para Pipaliya,Rajkot,Gujarat',
'Pipaliya,Rajkot,Gujarat',
'Rafala,Rajkot,Gujarat',
'Raiya,Rajkot,Gujarat',
'Rajkot Raiya Road,Rajkot,Gujarat',
'Rajkot Aji Ind Estate,Rajkot,Gujarat',
'Rajkot Bedipara,Rajkot,Gujarat',
'Rajkot Bhaktinagar,Rajkot,Gujarat',
'Rajkot Bhomeshwar Plot,Rajkot,Gujarat',
'Rajkot City,Rajkot,Gujarat',
'Rajkot Collectorate,Rajkot,Gujarat',
'Rajkot D H College,Rajkot,Gujarat',
'Rajkot H.O,Rajkot,Gujarat',
'Rajkot Jairaj Plot,Rajkot,Gujarat',
'Rajkot Jn. Plot,Rajkot,Gujarat',
'Rajkot Kalavad Road,Rajkot,Gujarat',
'Rajkot Malviyanagar,Rajkot,Gujarat',
'Rajkot Manahar Plot,Rajkot,Gujarat',
'Rajkot Mandvi Chowk,Rajkot,Gujarat',
'Rajkot Marketing Yard,Rajkot,Gujarat',
'Rajkot Millpara,Rajkot,Gujarat',
'Rajkot Mochi Bazar,Rajkot,Gujarat',
'Rajkot Municipal Corporation,Rajkot,Gujarat',
'Rajkot New Jagnath Plot,Rajkot,Gujarat',
'Rajkot Parsi Agiyari Chowk,Rajkot,Gujarat',
'Rajkot Popatpara,Rajkot,Gujarat',
'Rajkot Postal Colony,Rajkot,Gujarat',
'Rajkot Race Course Road,Rajkot,Gujarat',
'Rajkot Sau Uni Area,Rajkot,Gujarat',
'Rajkot Sorathiawadi,Rajkot,Gujarat',
'Rajkot Udyognagar,Rajkot,Gujarat',
'Rajkot Vivekanandnagar,Rajkot,Gujarat',
'Ravki,Rajkot,Gujarat',
'Samadhiyala,Rajkot,Gujarat',
'Sanosara,Rajkot,Gujarat',
'Shri Shardanagar,Rajkot,Gujarat',
'Targhadia,Rajkot,Gujarat',
'Umrali,Rajkot,Gujarat',
'Vadali,Rajkot,Gujarat',
'Vavdi,Rajkot,Gujarat',
'Vavdi,Rajkot,Gujarat',
'Ziyana,Rajkot,Gujarat',
'Sardhar,Rajkot,Gujarat',
'Lajai,Rajkot,Gujarat',
'Bangavadi,Rajkot,Gujarat',
'Bedi( Tankara),Rajkot,Gujarat',
'Ghunda Khanpar,Rajkot,Gujarat',
'Hadmatiya,Rajkot,Gujarat',
'Harbatiyali,Rajkot,Gujarat',
'Hirapar,Rajkot,Gujarat',
'Jabalpur,Rajkot,Gujarat',
'Jivapar,Rajkot,Gujarat',
'Kotharia(Tankara),Rajkot,Gujarat',
'Meghpar Zala,Rajkot,Gujarat',
'Mitana,Rajkot,Gujarat',
'Mota Khijadia,Rajkot,Gujarat',
'Nasitpar,Rajkot,Gujarat',
'Neknam,Rajkot,Gujarat',
'Nesda (K),Rajkot,Gujarat',
'Otala,Rajkot,Gujarat',
'Rohishala,Rajkot,Gujarat',
'Sajanpar,Rajkot,Gujarat',
'Savadi,Rajkot,Gujarat',
'Tankara,Rajkot,Gujarat',
'Vachhakapar,Rajkot,Gujarat',
'Virvav,Rajkot,Gujarat',
'Arni,Gondal,Gujarat',
'Bhankh,Gondal,Gujarat',
'Bhayavadar,Gondal,Gujarat',
'Bhimora,Gondal,Gujarat',
'Chikhaliya,Gondal,Gujarat',
'Dhank,Gondal,Gujarat',
'Dumiyani,Gondal,Gujarat',
'Ganod,Gondal,Gujarat',
'Hariyasan,Gondal,Gujarat',
'Ishra,Gondal,Gujarat',
'Kalariya,Gondal,Gujarat',
'Khakhijaliya,Gondal,Gujarat',
'Kharachiya,Gondal,Gujarat',
'Khirsara (Ghed),Gondal,Gujarat',
'Kolki,Gondal,Gujarat',
'Lath,Gondal,Gujarat',
'Mekha Timbi,Gondal,Gujarat',
'Mervadar,Gondal,Gujarat',
'Mojira,Gondal,Gujarat',
'Nagvadar,Gondal,Gujarat',
'Nilakha,Gondal,Gujarat',
'Padavla,Gondal,Gujarat',
'Paneli,Gondal,Gujarat',
'Pransla,Gondal,Gujarat',
'Rabarika,Gondal,Gujarat',
'Sajadiyali,Gondal,Gujarat',
'Samadhiyala,Gondal,Gujarat',
'Talagana,Gondal,Gujarat',
'Tanasva,Gondal,Gujarat',
'Timbdi Jam,Gondal,Gujarat',
'Upleta Lati Plot,Gondal,Gujarat',
'Upleta,Gondal,Gujarat',
'Vadala,Gondal,Gujarat',
'Vadali,Gondal,Gujarat',
'Varjang Jalia,Gondal,Gujarat',
'Amarpara Wankaner,Rajkot,Gujarat',
'Arnitimba,Rajkot,Gujarat',
'Bhalgam,Rajkot,Gujarat',
'Bherda,Rajkot,Gujarat',
'Bhimguda,Rajkot,Gujarat',
'Chandrapur,Rajkot,Gujarat',
'Daldi,Rajkot,Gujarat',
'Dhuva,Rajkot,Gujarat',
'Gariya,Rajkot,Gujarat',
'Ghiyavad,Rajkot,Gujarat',
'Jadeshvar,Rajkot,Gujarat',
'Jalida,Rajkot,Gujarat',
'Kankot,Rajkot,Gujarat',
'Kerala,Rajkot,Gujarat',
'Kherva,Rajkot,Gujarat',
'Khijadia,Rajkot,Gujarat',
'Kotharia,Rajkot,Gujarat',
'Kothi,Rajkot,Gujarat',
'Lunsar,Rajkot,Gujarat',
'Lunsariya,Rajkot,Gujarat',
'Mahika,Rajkot,Gujarat',
'Matel,Rajkot,Gujarat',
'Mesariya,Rajkot,Gujarat',
'Paddhara,Rajkot,Gujarat',
'Panchasia,Rajkot,Gujarat',
'Panchdwarka,Rajkot,Gujarat',
'Pipaliya Raj,Rajkot,Gujarat',
'Rajavadala,Rajkot,Gujarat',
'Ranekpar,Rajkot,Gujarat',
'Ratidevdi,Rajkot,Gujarat',
'Samadhiyala,Rajkot,Gujarat',
'Sardharka,Rajkot,Gujarat',
'Sindhavadar,Rajkot,Gujarat',
'Tarakiya,Rajkot,Gujarat',
'Tithva,Rajkot,Gujarat',
'Vaghasiya,Rajkot,Gujarat',
'Valasan,Rajkot,Gujarat',
'Vardusar,Rajkot,Gujarat',
'Wankaner,Rajkot,Gujarat',
'Alwa,Sabarkantha,Gujarat',
'Ambagam,Sabarkantha,Gujarat',
'Ambaliara,Sabarkantha,Gujarat',
'Amiapura,Sabarkantha,Gujarat',
'Amodara,Sabarkantha,Gujarat',
'Badarpura,Sabarkantha,Gujarat',
'Bayad,Sabarkantha,Gujarat',
'Bayad Town,Sabarkantha,Gujarat',
'Bhukhel,Sabarkantha,Gujarat',
'Bhundasan,Sabarkantha,Gujarat',
'Bibinivav,Sabarkantha,Gujarat',
'Boral,Sabarkantha,Gujarat',
'Bordi,Sabarkantha,Gujarat',
'Chandrej,Sabarkantha,Gujarat',
'Chhabhou,Sabarkantha,Gujarat',
'Choila,Sabarkantha,Gujarat',
'Dabha,Sabarkantha,Gujarat',
'Dakhneshwar,Sabarkantha,Gujarat',
'Demai,Sabarkantha,Gujarat',
'Deroli,Sabarkantha,Gujarat',
'Desaipura,Sabarkantha,Gujarat',
'Gabat,Sabarkantha,Gujarat',
'Ganeshpura,Sabarkantha,Gujarat',
'Gotapur,Sabarkantha,Gujarat',
'Hathipura,Sabarkantha,Gujarat',
'Indran,Sabarkantha,Gujarat',
'Jalampur,Sabarkantha,Gujarat',
'Jitpur,Sabarkantha,Gujarat',
'Lank,Sabarkantha,Gujarat',
'Limb,Sabarkantha,Gujarat',
'Madhavgadh,Sabarkantha,Gujarat',
'Odha,Sabarkantha,Gujarat',
'Pipodara,Sabarkantha,Gujarat',
'Radodara,Sabarkantha,Gujarat',
'Ramos,Sabarkantha,Gujarat',
'Ranechi,Sabarkantha,Gujarat',
'Sarsoli,Sabarkantha,Gujarat',
'Sathamba,Sabarkantha,Gujarat',
'Savela,Sabarkantha,Gujarat',
'Talod,Sabarkantha,Gujarat',
'Tenpur,Sabarkantha,Gujarat',
'Untarda,Sabarkantha,Gujarat',
'Vantda Bayad,Sabarkantha,Gujarat',
'Vasnirel,Sabarkantha,Gujarat',
'Vatrakgadh,Sabarkantha,Gujarat',
'Ada Hathrol,Sabarkantha,Gujarat',
'Ambabar,Sabarkantha,Gujarat',
'Ansol,Sabarkantha,Gujarat',
'Bamna,Sabarkantha,Gujarat',
'Bhanmer,Sabarkantha,Gujarat',
'Bhatera,Sabarkantha,Gujarat',
'Bhetali,Sabarkantha,Gujarat',
'Bhiloda Bazar,Sabarkantha,Gujarat',
'Bhiloda,Sabarkantha,Gujarat',
'Bhutavad,Sabarkantha,Gujarat',
'Budheli,Sabarkantha,Gujarat',
'Budhrasan,Sabarkantha,Gujarat',
'Chiboda,Sabarkantha,Gujarat',
'Chorimala,Sabarkantha,Gujarat',
'Chunakhan,Sabarkantha,Gujarat',
'Dahegamda,Sabarkantha,Gujarat',
'Devnimori,Sabarkantha,Gujarat',
'Dhambolia,Sabarkantha,Gujarat',
'Dhandhasan,Sabarkantha,Gujarat',
'Dhansor,Sabarkantha,Gujarat',
'Dholvani,Sabarkantha,Gujarat',
'Dodisara,Sabarkantha,Gujarat',
'Gali Semro,Sabarkantha,Gujarat',
'Himmatpur,Sabarkantha,Gujarat',
'Jab Chitaria,Sabarkantha,Gujarat',
'Jayla,Sabarkantha,Gujarat',
'Jeshingpur,Sabarkantha,Gujarat',
'Jinjudi,Sabarkantha,Gujarat',
'Jumsar,Sabarkantha,Gujarat',
'Kagda Mahuda,Sabarkantha,Gujarat',
'Karchha,Sabarkantha,Gujarat',
'Khalvad,Sabarkantha,Gujarat',
'Kheradi,Sabarkantha,Gujarat',
'Kherancha,Sabarkantha,Gujarat',
'Khiloda,Sabarkantha,Gujarat',
'Kishangadh,Sabarkantha,Gujarat',
'Kundol Pal,Sabarkantha,Gujarat',
'Kushki,Sabarkantha,Gujarat',
'Lilchha,Sabarkantha,Gujarat',
'Lusadia,Sabarkantha,Gujarat',
'Malasa,Sabarkantha,Gujarat',
'Mankdi,Sabarkantha,Gujarat',
'Mau Bhavnath,Sabarkantha,Gujarat',
'Meditimba,Sabarkantha,Gujarat',
'Mehru,Sabarkantha,Gujarat',
'Mota Kantharia,Sabarkantha,Gujarat',
'Moti Bebar,Sabarkantha,Gujarat',
'Munai,Sabarkantha,Gujarat',
'Nandoj,Sabarkantha,Gujarat',
'Nankhi,Sabarkantha,Gujarat',
'Napda,Sabarkantha,Gujarat',
'Narsoli,Sabarkantha,Gujarat',
'Nava Bhavnath,Sabarkantha,Gujarat',
'Ode,Sabarkantha,Gujarat',
'Palla,Sabarkantha,Gujarat',
'Panch Mahudi,Sabarkantha,Gujarat',
'Punasan,Sabarkantha,Gujarat',
'Raipur,Sabarkantha,Gujarat',
'Raisingpur,Sabarkantha,Gujarat',
'Rajendranagar,Sabarkantha,Gujarat',
'Rampuri,Sabarkantha,Gujarat',
'Sarvoday Kendra,Sabarkantha,Gujarat',
'Shamlaji,Sabarkantha,Gujarat',
'Sunokh,Sabarkantha,Gujarat',
'Sunsar,Sabarkantha,Gujarat',
'Takatuka,Sabarkantha,Gujarat',
'Torda,Sabarkantha,Gujarat',
'Ubsal,Sabarkantha,Gujarat',
'Vagheswari,Sabarkantha,Gujarat',
'Vandhiyol,Sabarkantha,Gujarat',
'Vankaner,Sabarkantha,Gujarat',
'Vanzar,Sabarkantha,Gujarat',
'Vejpur,Sabarkantha,Gujarat',
'Virpur,Sabarkantha,Gujarat',
'Akrund,Sabarkantha,Gujarat',
'Ambasar,Sabarkantha,Gujarat',
'Amodara,Sabarkantha,Gujarat',
'Barnoli,Sabarkantha,Gujarat',
'Bhensawada,Sabarkantha,Gujarat',
'Bilwania,Sabarkantha,Gujarat',
'Borditimba,Sabarkantha,Gujarat',
'Butal,Sabarkantha,Gujarat',
'Dhamania,Sabarkantha,Gujarat',
'Dhansura,Sabarkantha,Gujarat',
'Dolpur,Sabarkantha,Gujarat',
'Hirapur,Sabarkantha,Gujarat',
'Jasvantpura Kampa,Sabarkantha,Gujarat',
'Khadoda,Sabarkantha,Gujarat',
'Khadol,Sabarkantha,Gujarat',
'Khilodia,Sabarkantha,Gujarat',
'Kidi,Sabarkantha,Gujarat',
'Kolvada,Sabarkantha,Gujarat',
'Lalinomath,Sabarkantha,Gujarat',
'Naranpura Kampa,Sabarkantha,Gujarat',
'Navi Shinol,Sabarkantha,Gujarat',
'Rajpur,Sabarkantha,Gujarat',
'Ramos,Sabarkantha,Gujarat',
'Rampura Kampa,Sabarkantha,Gujarat',
'Rampura Kampa,Sabarkantha,Gujarat',
'Shantipura,Sabarkantha,Gujarat',
'Shinol,Sabarkantha,Gujarat',
'Sika,Sabarkantha,Gujarat',
'Ujleshvar,Sabarkantha,Gujarat',
'Vadagam,Sabarkantha,Gujarat',
'Shravana,Sabarkantha,Gujarat',
'Adpodra,Sabarkantha,Gujarat',
'Agiol,Sabarkantha,Gujarat',
'Bankhor,Sabarkantha,Gujarat',
'Bavsar,Sabarkantha,Gujarat',
'Berna,Sabarkantha,Gujarat',
'Boria,Sabarkantha,Gujarat',
'Chandarni,Sabarkantha,Gujarat',
'Dedhrota,Sabarkantha,Gujarat',
'Derol,Sabarkantha,Gujarat',
'Dhundhar,Sabarkantha,Gujarat',
'Gadha,Sabarkantha,Gujarat',
'Gadhoda,Sabarkantha,Gujarat',
'Gambhoi,Sabarkantha,Gujarat',
'Hadiol,Sabarkantha,Gujarat',
'Hajipur,Sabarkantha,Gujarat',
'Hajipura,Sabarkantha,Gujarat',
'Hapa,Sabarkantha,Gujarat',
'Hathrol,Sabarkantha,Gujarat',
'Himatnagar H.O,Sabarkantha,Gujarat',
'Himatnagar Station Road,Sabarkantha,Gujarat',
'Hunj,Sabarkantha,Gujarat',
'Ilol,Sabarkantha,Gujarat',
'Jambudi,Sabarkantha,Gujarat',
'Jamla,Sabarkantha,Gujarat',
'Kadoli,Sabarkantha,Gujarat',
'Kanai,Sabarkantha,Gujarat',
'Kanda,Sabarkantha,Gujarat',
'Kankrol,Sabarkantha,Gujarat',
'Karanpur,Sabarkantha,Gujarat',
'Katwad,Sabarkantha,Gujarat',
'Khed,Sabarkantha,Gujarat',
'Khedavada,Sabarkantha,Gujarat',
'Likhi,Sabarkantha,Gujarat',
'Lolasan,Sabarkantha,Gujarat',
'Manorpur,Sabarkantha,Gujarat',
'Mathasulia,Sabarkantha,Gujarat',
'Mehtapura,Sabarkantha,Gujarat',
'Nava,Sabarkantha,Gujarat',
'Navalpur,Sabarkantha,Gujarat',
'Navanagar,Sabarkantha,Gujarat',
'Nikoda,Sabarkantha,Gujarat',
'Pedhmala,Sabarkantha,Gujarat',
'Pethapur,Sabarkantha,Gujarat',
'Prempur,Sabarkantha,Gujarat',
'Pural,Sabarkantha,Gujarat',
'Raigadh,Sabarkantha,Gujarat',
'Rajpur,Sabarkantha,Gujarat',
'Rampur (A),Sabarkantha,Gujarat',
'Rupal,Sabarkantha,Gujarat',
'Sachodar,Sabarkantha,Gujarat',
'Sadha,Sabarkantha,Gujarat',
'Sahebapura,Sabarkantha,Gujarat',
'Savgadh,Sabarkantha,Gujarat',
'Tajpuri,Sabarkantha,Gujarat',
'Vagdi,Sabarkantha,Gujarat',
'Vaktapur,Sabarkantha,Gujarat',
'Vavdi,Sabarkantha,Gujarat',
'Viravada,Sabarkantha,Gujarat',
'Virpur,Sabarkantha,Gujarat',
'Vishwamangalam,Sabarkantha,Gujarat',
'Kaniol,Sabarkantha,Gujarat',
'Ankala,Sabarkantha,Gujarat',
'Aroda,Sabarkantha,Gujarat',
'Arsodia,Sabarkantha,Gujarat',
'Badol,Sabarkantha,Gujarat',
'Badoli,Sabarkantha,Gujarat',
'Barvav,Sabarkantha,Gujarat',
'Bhadresar,Sabarkantha,Gujarat',
'Bhanpur,Sabarkantha,Gujarat',
'Bhutiya,Sabarkantha,Gujarat',
'Bolundra (S),Sabarkantha,Gujarat',
'Bolundra(R),Sabarkantha,Gujarat',
'Budheli,Sabarkantha,Gujarat',
'Chadasana,Sabarkantha,Gujarat',
'Chandap,Sabarkantha,Gujarat',
'Chhapi,Sabarkantha,Gujarat',
'Chitroda,Sabarkantha,Gujarat',
'Daramali,Sabarkantha,Gujarat',
'Davad,Sabarkantha,Gujarat',
'Deshotar,Sabarkantha,Gujarat',
'Dharapur,Sabarkantha,Gujarat',
'Diyoli,Sabarkantha,Gujarat',
'Dungri,Sabarkantha,Gujarat',
'Eklara,Sabarkantha,Gujarat',
'Falasan,Sabarkantha,Gujarat',
'Finchod,Sabarkantha,Gujarat',
'Gambhirpura,Sabarkantha,Gujarat',
'Ganthiol,Sabarkantha,Gujarat',
'Golwada,Sabarkantha,Gujarat',
'Goral,Sabarkantha,Gujarat',
'Gulabpura,Sabarkantha,Gujarat',
'Himatpur,Sabarkantha,Gujarat',
'Idar,Sabarkantha,Gujarat',
'Idar Town,Sabarkantha,Gujarat',
'Jadar,Sabarkantha,Gujarat',
'Kabso,Sabarkantha,Gujarat',
'Kadiadra,Sabarkantha,Gujarat',
'Kamalpur,Sabarkantha,Gujarat',
'Kanpur,Sabarkantha,Gujarat',
'Kapoda,Sabarkantha,Gujarat',
'Kava,Sabarkantha,Gujarat',
'Kesharpura,Sabarkantha,Gujarat',
'Kotda Nana,Sabarkantha,Gujarat',
'Kukadia,Sabarkantha,Gujarat',
'Laloda,Sabarkantha,Gujarat',
'Lalpur,Sabarkantha,Gujarat',
'Lei,Sabarkantha,Gujarat',
'Limbhoi,Sabarkantha,Gujarat',
'Mangadh,Sabarkantha,Gujarat',
'Maniyor,Sabarkantha,Gujarat',
'Masal,Sabarkantha,Gujarat',
'Mathasur,Sabarkantha,Gujarat',
'Mesan,Sabarkantha,Gujarat',
'Mota Kotda,Sabarkantha,Gujarat',
'Mudeti,Sabarkantha,Gujarat',
'Nava Revas,Sabarkantha,Gujarat',
'Netramali,Sabarkantha,Gujarat',
'Oda,Sabarkantha,Gujarat',
'Panol,Sabarkantha,Gujarat',
'Poshina,Sabarkantha,Gujarat',
'Pratappura,Sabarkantha,Gujarat',
'Ratanpur,Sabarkantha,Gujarat',
'Ravol,Sabarkantha,Gujarat',
'Rudardi,Sabarkantha,Gujarat',
'Sabalwad,Sabarkantha,Gujarat',
'Sabli,Sabarkantha,Gujarat',
'Sapawada,Sabarkantha,Gujarat',
'Sherpur,Sabarkantha,Gujarat',
'Singa,Sabarkantha,Gujarat',
'Siyasan,Sabarkantha,Gujarat',
'Surpur,Sabarkantha,Gujarat',
'Umedgadh,Sabarkantha,Gujarat',
'Umedpura,Sabarkantha,Gujarat',
'Vasai,Sabarkantha,Gujarat',
'Verabar,Sabarkantha,Gujarat',
'Virpur,Sabarkantha,Gujarat',
'Agiya,Sabarkantha,Gujarat',
'Ajavas,Sabarkantha,Gujarat',
'Ambaigadha,Sabarkantha,Gujarat',
'Ambamahuda,Sabarkantha,Gujarat',
'Bahediya,Sabarkantha,Gujarat',
'Bandiyana Talav,Sabarkantha,Gujarat',
'Bordi,Sabarkantha,Gujarat',
'Chandrana,Sabarkantha,Gujarat',
'Chikhala,Sabarkantha,Gujarat',
'Damavas,Sabarkantha,Gujarat',
'Dan Mahudi,Sabarkantha,Gujarat',
'Dantral,Sabarkantha,Gujarat',
'Delwada,Sabarkantha,Gujarat',
'Delwada,Sabarkantha,Gujarat',
'Demti,Sabarkantha,Gujarat',
'Dharoi,Sabarkantha,Gujarat',
'Didhiya,Sabarkantha,Gujarat',
'Dotad,Sabarkantha,Gujarat',
'Gadhada Shamlaji,Sabarkantha,Gujarat',
'Gadu,Sabarkantha,Gujarat',
'Galodiya,Sabarkantha,Gujarat',
'Ganer,Sabarkantha,Gujarat',
'Ganva,Sabarkantha,Gujarat',
'Gundel,Sabarkantha,Gujarat',
'Kalikankar,Sabarkantha,Gujarat',
'Kalol Kampa,Sabarkantha,Gujarat',
'Khedbrahma,Sabarkantha,Gujarat',
'Khedva,Sabarkantha,Gujarat',
'Khergadh,Sabarkantha,Gujarat',
'Kheroj,Sabarkantha,Gujarat',
'Kotda,Sabarkantha,Gujarat',
'Lambadiya,Sabarkantha,Gujarat',
'Laxmipura,Sabarkantha,Gujarat',
'Matoda,Sabarkantha,Gujarat',
'Mota Baval,Sabarkantha,Gujarat',
'Nada,Sabarkantha,Gujarat',
'Nana Sembalia,Sabarkantha,Gujarat',
'Nava Mota,Sabarkantha,Gujarat',
'Navi Metral,Sabarkantha,Gujarat',
'Nichi Dhanal,Sabarkantha,Gujarat',
'Padardi,Sabarkantha,Gujarat',
'Padhara,Sabarkantha,Gujarat',
'Panch Mahuda,Sabarkantha,Gujarat',
'Paroya,Sabarkantha,Gujarat',
'Patadiya,Sabarkantha,Gujarat',
'Petachhapra,Sabarkantha,Gujarat',
'Pipliya,Sabarkantha,Gujarat',
'Poshina,Sabarkantha,Gujarat',
'Radhiwad,Sabarkantha,Gujarat',
'Ratanpur,Sabarkantha,Gujarat',
'Salera,Sabarkantha,Gujarat',
'Sembalia (Poshina),Sabarkantha,Gujarat',
'Sitol,Sabarkantha,Gujarat',
'Tadhivedi,Sabarkantha,Gujarat',
'Tandaliya,Sabarkantha,Gujarat',
'Tembada,Sabarkantha,Gujarat',
'Unchi Dhanal,Sabarkantha,Gujarat',
'Vaghela Derol,Sabarkantha,Gujarat',
'Valaran,Sabarkantha,Gujarat',
'Vartol,Sabarkantha,Gujarat',
'Vasana,Sabarkantha,Gujarat',
'Vinchhi,Sabarkantha,Gujarat',
'Zanzva Panai,Sabarkantha,Gujarat',
'Ambalia,Sabarkantha,Gujarat',
'Aniyor,Sabarkantha,Gujarat',
'Aniyor Kampa,Sabarkantha,Gujarat',
'Bhempoda,Sabarkantha,Gujarat',
'Helodar,Sabarkantha,Gujarat',
'Kaswada,Sabarkantha,Gujarat',
'Khalikpur,Sabarkantha,Gujarat',
'Magodi,Sabarkantha,Gujarat',
'Mahiyapur,Sabarkantha,Gujarat',
'Malpur,Sabarkantha,Gujarat',
'Mangalpur,Sabarkantha,Gujarat',
'Mevda,Sabarkantha,Gujarat',
'Nanawada,Sabarkantha,Gujarat',
'Nathavas,Sabarkantha,Gujarat',
'Piprana,Sabarkantha,Gujarat',
'Satarda,Sabarkantha,Gujarat',
'Tunadar,Sabarkantha,Gujarat',
'Ubharan,Sabarkantha,Gujarat',
'Vankaneda,Sabarkantha,Gujarat',
'Vavdi,Sabarkantha,Gujarat',
'Banthiwada,Sabarkantha,Gujarat',
'Behdaj,Sabarkantha,Gujarat',
'Belyo,Sabarkantha,Gujarat',
'Bhemapur,Sabarkantha,Gujarat',
'Intva,Sabarkantha,Gujarat',
'Iploda,Sabarkantha,Gujarat',
'Isari,Sabarkantha,Gujarat',
'Kadvadi,Sabarkantha,Gujarat',
'Kaliya Kuva,Sabarkantha,Gujarat',
'Kasana,Sabarkantha,Gujarat',
'Kolundra,Sabarkantha,Gujarat',
'Kunol,Sabarkantha,Gujarat',
'Lalpur,Sabarkantha,Gujarat',
'Limbodara,Sabarkantha,Gujarat',
'Meghraj,Sabarkantha,Gujarat',
'Moti Mori,Sabarkantha,Gujarat',
'Moti Moydi,Sabarkantha,Gujarat',
'Moti Panduri,Sabarkantha,Gujarat',
'Navagam(Isri),Sabarkantha,Gujarat',
'Panchal,Sabarkantha,Gujarat',
'Panibar,Sabarkantha,Gujarat',
'Patelna Dhundha,Sabarkantha,Gujarat',
'Ramgadhi,Sabarkantha,Gujarat',
'Rayawada,Sabarkantha,Gujarat',
'Rellawada,Sabarkantha,Gujarat',
'Relyo,Sabarkantha,Gujarat',
'Shangal,Sabarkantha,Gujarat',
'Sisodara (A),Sabarkantha,Gujarat',
'Undava,Sabarkantha,Gujarat',
'Vaghpur,Sabarkantha,Gujarat',
'Vaghpur,Sabarkantha,Gujarat',
'Valuna,Sabarkantha,Gujarat',
'Vaniawada,Sabarkantha,Gujarat',
'Vasna,Sabarkantha,Gujarat',
'Zarda,Sabarkantha,Gujarat',
'Adhera,Sabarkantha,Gujarat',
'Amlai,Sabarkantha,Gujarat',
'Badodara,Sabarkantha,Gujarat',
'Bamanvad,Sabarkantha,Gujarat',
'Bayal Dhankhrol,Sabarkantha,Gujarat',
'Bhachediya,Sabarkantha,Gujarat',
'Bhavanpura Kampa,Sabarkantha,Gujarat',
'Bherunda,Sabarkantha,Gujarat',
'Bolundra,Sabarkantha,Gujarat',
'Dadhalia,Sabarkantha,Gujarat',
'Davli,Sabarkantha,Gujarat',
'Dugarvada,Sabarkantha,Gujarat',
'Faredi,Sabarkantha,Gujarat',
'Gadha,Sabarkantha,Gujarat',
'Gadhada,Sabarkantha,Gujarat',
'Gajan,Sabarkantha,Gujarat',
'Ganeshpur,Sabarkantha,Gujarat',
'Itadi,Sabarkantha,Gujarat',
'Jhalodar,Sabarkantha,Gujarat',
'Kau,Sabarkantha,Gujarat',
'Khambhisar,Sabarkantha,Gujarat',
'Kolikhad,Sabarkantha,Gujarat',
'Kudol,Sabarkantha,Gujarat',
'Limbhoi,Sabarkantha,Gujarat',
'Madapur Kampa,Sabarkantha,Gujarat',
'Mahadevgram,Sabarkantha,Gujarat',
'Mahadevpura Kampa,Sabarkantha,Gujarat',
'Medhasan,Sabarkantha,Gujarat',
'Modas,Sabarkantha,Gujarat',
'Modasa Bazar,Sabarkantha,Gujarat',
'Moti Chinchano,Sabarkantha,Gujarat',
'Moti Isrol,Sabarkantha,Gujarat',
'Muloj,Sabarkantha,Gujarat',
'Nandisan,Sabarkantha,Gujarat',
'Pahadpur,Sabarkantha,Gujarat',
'Rakhiyal,Sabarkantha,Gujarat',
'Ramana,Sabarkantha,Gujarat',
'Sakariya,Sabarkantha,Gujarat',
'Sardoi,Sabarkantha,Gujarat',
'Sayra,Sabarkantha,Gujarat',
'Shampur,Sabarkantha,Gujarat',
'Shinavad,Sabarkantha,Gujarat',
'Tintoi,Sabarkantha,Gujarat',
'Vaniad Kokapur,Sabarkantha,Gujarat',
'Varthu,Sabarkantha,Gujarat',
'Ambawada,Sabarkantha,Gujarat',
'Amrapur,Sabarkantha,Gujarat',
'Balisana,Sabarkantha,Gujarat',
'Bobha,Sabarkantha,Gujarat',
'Dalani Muvadi,Sabarkantha,Gujarat',
'Dalpur,Sabarkantha,Gujarat',
'Fatepur Mota,Sabarkantha,Gujarat',
'Ghadi,Sabarkantha,Gujarat',
'Ghadkan,Sabarkantha,Gujarat',
'Jenpur,Sabarkantha,Gujarat',
'Kamalpur,Sabarkantha,Gujarat',
'Karol,Sabarkantha,Gujarat',
'Mahadevpura,Sabarkantha,Gujarat',
'Majra,Sabarkantha,Gujarat',
'Mauchha,Sabarkantha,Gujarat',
'Moyad,Sabarkantha,Gujarat',
'Nananpur,Sabarkantha,Gujarat',
'Oran,Sabarkantha,Gujarat',
'Pallachar,Sabarkantha,Gujarat',
'Piludra,Sabarkantha,Gujarat',
'Poglu,Sabarkantha,Gujarat',
'Poyda,Sabarkantha,Gujarat',
'Prantij,Sabarkantha,Gujarat',
'Salal,Sabarkantha,Gujarat',
'Sampad,Sabarkantha,Gujarat',
'Sitwada,Sabarkantha,Gujarat',
'Sonasan,Sabarkantha,Gujarat',
'Tajpur,Sabarkantha,Gujarat',
'Takhatgadh,Sabarkantha,Gujarat',
'Unchha,Sabarkantha,Gujarat',
'Vadrad,Sabarkantha,Gujarat',
'Vadvasa,Sabarkantha,Gujarat',
'Vaghpur,Sabarkantha,Gujarat',
'Vaghrota,Sabarkantha,Gujarat',
'Zinzva,Sabarkantha,Gujarat',
'Aniod,Sabarkantha,Gujarat',
'Antroli,Sabarkantha,Gujarat',
'Badodara,Sabarkantha,Gujarat',
'Boria Bechraji,Sabarkantha,Gujarat',
'Dadarda,Sabarkantha,Gujarat',
'Doltabad,Sabarkantha,Gujarat',
'Gora Anjana,Sabarkantha,Gujarat',
'Harsol,Sabarkantha,Gujarat',
'Jorajini Muvadi,Sabarkantha,Gujarat',
'Kabodara,Sabarkantha,Gujarat',
'Kherol,Sabarkantha,Gujarat',
'Lavari,Sabarkantha,Gujarat',
'Madhavgadh,Sabarkantha,Gujarat',
'Mahiyal,Sabarkantha,Gujarat',
'Modhuka,Sabarkantha,Gujarat',
'Mohanpur,Sabarkantha,Gujarat',
'Mota Chekhla,Sabarkantha,Gujarat',
'Motesari,Sabarkantha,Gujarat',
'Mudhasana,Sabarkantha,Gujarat',
'Nana Chekhla,Sabarkantha,Gujarat',
'Nava,Sabarkantha,Gujarat',
'Padusan,Sabarkantha,Gujarat',
'Punsari,Sabarkantha,Gujarat',
'Ranasan,Sabarkantha,Gujarat',
'Ranipura,Sabarkantha,Gujarat',
'Sagpur,Sabarkantha,Gujarat',
'Salatpur,Sabarkantha,Gujarat',
'Semalia,Sabarkantha,Gujarat',
'Tajpur (Camp),Sabarkantha,Gujarat',
'Talod M Y,Sabarkantha,Gujarat',
'Talod,Sabarkantha,Gujarat',
'Ujedia,Sabarkantha,Gujarat',
'Valiampura,Sabarkantha,Gujarat',
'Varvada,Sabarkantha,Gujarat',
'Asai,Sabarkantha,Gujarat',
'Babsar,Sabarkantha,Gujarat',
'Bhandval,Sabarkantha,Gujarat',
'Bhavangadh,Sabarkantha,Gujarat',
'Choriwad,Sabarkantha,Gujarat',
'Chulla,Sabarkantha,Gujarat',
'Dantroli,Sabarkantha,Gujarat',
'Dhamadi (Gadu),Sabarkantha,Gujarat',
'Dobhada,Sabarkantha,Gujarat',
'Gajipur,Sabarkantha,Gujarat',
'Gota,Sabarkantha,Gujarat',
'Hatharva,Sabarkantha,Gujarat',
'Hathoj,Sabarkantha,Gujarat',
'Juna Chamu,Sabarkantha,Gujarat',
'Kesharganj,Sabarkantha,Gujarat',
'Kuba Dharol,Sabarkantha,Gujarat',
'Mahor,Sabarkantha,Gujarat',
'Medh,Sabarkantha,Gujarat',
'Nadri,Sabarkantha,Gujarat',
'Raheda,Sabarkantha,Gujarat',
'Rampur (Fudeda),Sabarkantha,Gujarat',
'Therasana,Sabarkantha,Gujarat',
'Vadali,Sabarkantha,Gujarat',
'Vadoth,Sabarkantha,Gujarat',
'Vasan,Sabarkantha,Gujarat',
'Abhapur,Sabarkantha,Gujarat',
'Androkha,Sabarkantha,Gujarat',
'Atarsumba,Sabarkantha,Gujarat',
'Baleta,Sabarkantha,Gujarat',
'Bhankhara,Sabarkantha,Gujarat',
'Biladia,Sabarkantha,Gujarat',
'Chamthan,Sabarkantha,Gujarat',
'Chandvasa,Sabarkantha,Gujarat',
'Chitariya,Sabarkantha,Gujarat',
'Chithoda,Sabarkantha,Gujarat',
'Chitrodi,Sabarkantha,Gujarat',
'Dadhvav,Sabarkantha,Gujarat',
'Dantod,Sabarkantha,Gujarat',
'Gadi,Sabarkantha,Gujarat',
'Itavadi,Sabarkantha,Gujarat',
'Jaleti,Sabarkantha,Gujarat',
'Kalvan,Sabarkantha,Gujarat',
'Kanadar,Sabarkantha,Gujarat',
'Kathvavdi,Sabarkantha,Gujarat',
'Kelava,Sabarkantha,Gujarat',
'Kodiawada,Sabarkantha,Gujarat',
'Limda,Sabarkantha,Gujarat',
'Masota,Sabarkantha,Gujarat',
'Nalseri,Sabarkantha,Gujarat',
'Navagam (Dhanela),Sabarkantha,Gujarat',
'Padela,Sabarkantha,Gujarat',
'Pal,Sabarkantha,Gujarat',
'Pratapgadh Kampa,Sabarkantha,Gujarat',
'Rajpur,Sabarkantha,Gujarat',
'Saroli,Sabarkantha,Gujarat',
'Sarsav,Sabarkantha,Gujarat',
'Ukhala Dungri,Sabarkantha,Gujarat',
'Vandhol,Sabarkantha,Gujarat',
'Vankda,Sabarkantha,Gujarat',
'Vasai,Sabarkantha,Gujarat',
'Vijaynagar,Sabarkantha,Gujarat',
'Parosada,Sabarkantha,Gujarat',
'Athwalines,Surat,Gujarat',
'Bedchit,Bardoli,Gujarat',
'Bhimpore,Surat,Gujarat',
'Bhutwada,Bardoli,Gujarat',
'Dabholi,Surat,Gujarat',
'Dhamkhadi,Bardoli,Gujarat',
'Dumasgam,Surat,Gujarat',
'G.I.P.C.L.,Surat,Gujarat',
'Gherivan,Bardoli,Gujarat',
'Gotalawadi,Surat,Gujarat',
'Kakadva,Bardoli,Gujarat',
'Kosam,Surat,Gujarat',
'Kosimda,Bardoli,Gujarat',
'Motived,Surat,Gujarat',
'Nagod,Bardoli,Gujarat',
'Sachin G.I.D.C.,Surat,Gujarat',
'Sherdi,Surat,Gujarat',
'Siganpore,Surat,Gujarat',
'Vadi,Surat,Gujarat',
'Bardipada,Bardoli,Gujarat',
'Bhalkhet,Bardoli,Gujarat',
'Chinchinagaontha,Bardoli,Gujarat',
'Kalibel,Bardoli,Gujarat',
'Khatal,Bardoli,Gujarat',
'Mahwshkatri,Bardoli,Gujarat',
'Sarovar,Bardoli,Gujarat',
'Afva Isroli,Bardoli,Gujarat',
'Akoti,Bardoli,Gujarat',
'Allu,Bardoli,Gujarat',
'Bamni,Bardoli,Gujarat',
'Bardoli H.O,Bardoli,Gujarat',
'Bhamaiya,Bardoli,Gujarat',
'Chhitra,Bardoli,Gujarat',
'Dhamdod Lumbha,Bardoli,Gujarat',
'Goji,Bardoli,Gujarat',
'Haripura,Bardoli,Gujarat',
'Kadod,Bardoli,Gujarat',
'Kantifalia,Bardoli,Gujarat',
'Kantifalia,Bardoli,Gujarat',
'Kharvasa,Bardoli,Gujarat',
'Khojpardi,Bardoli,Gujarat',
'Kikwad,Bardoli,Gujarat',
'Madhi,Bardoli,Gujarat',
'Manekpor,Bardoli,Gujarat',
'Masad,Bardoli,Gujarat',
'Mota,Bardoli,Gujarat',
'Motifalod,Bardoli,Gujarat',
'Naugama,Bardoli,Gujarat',
'Ninat,Bardoli,Gujarat',
'Nizar,Bardoli,Gujarat',
'Orgam,Bardoli,Gujarat',
'Palsod,Bardoli,Gujarat',
'Rayam,Bardoli,Gujarat',
'Samthan,Bardoli,Gujarat',
'Sarbhon,Bardoli,Gujarat',
'Sardarbaug (Bardoli),Bardoli,Gujarat',
'Sejvad,Bardoli,Gujarat',
'Singod,Bardoli,Gujarat',
'Sugar Factory Bardoli,Bardoli,Gujarat',
'Surali,Bardoli,Gujarat',
'Tarbhon,Bardoli,Gujarat',
'Timbarva Sankri,Bardoli,Gujarat',
'Umarakh,Bardoli,Gujarat',
'Uva,Bardoli,Gujarat',
'Vadhvania,Bardoli,Gujarat',
'Vadoli,Bardoli,Gujarat',
'Vaghecha,Bardoli,Gujarat',
'Vankaner (SR),Bardoli,Gujarat',
'Vanskui,Bardoli,Gujarat',
'Varad,Bardoli,Gujarat',
'Vatsalyadham,Bardoli,Gujarat',
'Chapra Bhatha,Surat,Gujarat',
'Fulpada,Surat,Gujarat',
'Kosad,Surat,Gujarat',
'Adityanagar,Surat,Gujarat',
'Amroli,Surat,Gujarat',
'Bhatha,Surat,Gujarat',
'Bhatpore,Surat,Gujarat',
'Bhedvad,Surat,Gujarat',
'Damka,Surat,Gujarat',
'Dumas,Surat,Gujarat',
'Godadara,Surat,Gujarat',
'Ichhapore,Surat,Gujarat',
'Kawas,Surat,Gujarat',
'Kribhconagar,Surat,Gujarat',
'Kumabharia,Surat,Gujarat',
'Limbayat,Surat,Gujarat',
'Mohni,Bardoli,Gujarat',
'Mora,Surat,Gujarat',
'Mota Varachha,Surat,Gujarat',
'Ongc Nagar,Surat,Gujarat',
'Pal Bhatha,Surat,Gujarat',
'Parvat,Surat,Gujarat',
'Samrod,Bardoli,Gujarat',
'Saroli,Surat,Gujarat',
'Suvali,Surat,Gujarat',
'Timbarva,Bardoli,Gujarat',
'Vasava,Surat,Gujarat',
'Pipaldahad,Bardoli,Gujarat',
'Centrap Pulp Mill,Bardoli,Gujarat',
'Fort Songadh,Bardoli,Gujarat',
'Raniamba,Bardoli,Gujarat',
'Abrama,Bardoli,Gujarat',
'Antroli,Bardoli,Gujarat',
'Asta,Bardoli,Gujarat',
'Chikhali Dungar,Bardoli,Gujarat',
'Delad,Bardoli,Gujarat',
'Dhatva,Bardoli,Gujarat',
'Dhoranpardi,Bardoli,Gujarat',
'Digas,Bardoli,Gujarat',
'Dungra,Bardoli,Gujarat',
'Ghala,Bardoli,Gujarat',
'Haldharu,Bardoli,Gujarat',
'Jokha,Bardoli,Gujarat',
'Kamrej Char Rasta,Bardoli,Gujarat',
'Kamrej,Bardoli,Gujarat',
'Karjan,Bardoli,Gujarat',
'Kathodara,Bardoli,Gujarat',
'Kathor,Bardoli,Gujarat',
'Khanpur,Bardoli,Gujarat',
'Kholeshwar,Bardoli,Gujarat',
'Kholvad,Bardoli,Gujarat',
'Kosmadi,Bardoli,Gujarat',
'Ladvi,Bardoli,Gujarat',
'Mankna,Bardoli,Gujarat',
'Morthana,Bardoli,Gujarat',
'Nansad,Bardoli,Gujarat',
'Navagam,Bardoli,Gujarat',
'Navipardi,Bardoli,Gujarat',
'Netrang,Bardoli,Gujarat',
'Orna,Bardoli,Gujarat',
'Parab,Bardoli,Gujarat',
'Segva,Bardoli,Gujarat',
'Sevni,Bardoli,Gujarat',
'Shampura,Bardoli,Gujarat',
'Timba,Bardoli,Gujarat',
'Umbhel,Bardoli,Gujarat',
'Vav Kathodara,Bardoli,Gujarat',
'Velanja,Bardoli,Gujarat',
'Vihan,Bardoli,Gujarat',
'Kachholi,Surat,Gujarat',
'Kafleta,Surat,Gujarat',
'Popda,Surat,Gujarat',
'Dhamdod,Surat,Gujarat',
'Dinod,Surat,Gujarat',
'Hathuran,Surat,Gujarat',
'Mahuvej,Surat,Gujarat',
'Nandav,Surat,Gujarat',
'Amchak,Bardoli,Gujarat',
'Anaval,Bardoli,Gujarat',
'Bartad,Bardoli,Gujarat',
'Bhagvanpura,Bardoli,Gujarat',
'Bhoria,Bardoli,Gujarat',
'Bilkhadi,Bardoli,Gujarat',
'Butwada,Bardoli,Gujarat',
'Dedvasan,Bardoli,Gujarat',
'Dholikui,Bardoli,Gujarat',
'Dungri,Bardoli,Gujarat',
'Gangadia,Bardoli,Gujarat',
'Ghadoi,Bardoli,Gujarat',
'Gunesvel,Bardoli,Gujarat',
'Haladva,Bardoli,Gujarat',
'Kadhaiya,Bardoli,Gujarat',
'Kani,Bardoli,Gujarat',
'Kankaria,Bardoli,Gujarat',
'Karachka,Bardoli,Gujarat',
'Karchelia,Bardoli,Gujarat',
'Kharvan,Bardoli,Gujarat',
'Kodada,Bardoli,Gujarat',
'Kos,Bardoli,Gujarat',
'Kumkotar,Bardoli,Gujarat',
'Lasanpor,Bardoli,Gujarat',
'Mahuva,Bardoli,Gujarat',
'Mahuvaria,Bardoli,Gujarat',
'Miyapur,Bardoli,Gujarat',
'Mordevi,Bardoli,Gujarat',
'Naldhara,Bardoli,Gujarat',
'Pathran,Bardoli,Gujarat',
'Puna,Bardoli,Gujarat',
'Ranat,Bardoli,Gujarat',
'Samba,Bardoli,Gujarat',
'Shekhpur,Bardoli,Gujarat',
'Sugar Factory Bamania,Bardoli,Gujarat',
'Tarsadi,Bardoli,Gujarat',
'Umra,Bardoli,Gujarat',
'Vadia,Bardoli,Gujarat',
'Vaheval,Bardoli,Gujarat',
'Valvada,Bardoli,Gujarat',
'Vanskui,Bardoli,Gujarat',
'Velanpur,Bardoli,Gujarat',
'Zervavra,Bardoli,Gujarat',
'Kolibharthana,Bardoli,Gujarat',
'Amba,Bardoli,Gujarat',
'Balda,Bardoli,Gujarat',
'Bodhan,Bardoli,Gujarat',
'Dadhwada,Bardoli,Gujarat',
'Fulwadi,Bardoli,Gujarat',
'Gamtalv Bujrang,Bardoli,Gujarat',
'Gavachhi,Bardoli,Gujarat',
'Ghantoli,Bardoli,Gujarat',
'Godawadi,Bardoli,Gujarat',
'Goddha,Bardoli,Gujarat',
'Godsamba,Bardoli,Gujarat',
'Jakhala,Bardoli,Gujarat',
'Jamankuva,Bardoli,Gujarat',
'Kakarapargam,Bardoli,Gujarat',
'Kakrapar,Bardoli,Gujarat',
'Kamlapore,Bardoli,Gujarat',
'Karvali,Bardoli,Gujarat',
'Kasal,Bardoli,Gujarat',
'Khanjroli,Bardoli,Gujarat',
'Kharoli,Bardoli,Gujarat',
'Khodamba,Bardoli,Gujarat',
'Kim Dungara,Bardoli,Gujarat',
'Kosadi,Bardoli,Gujarat',
'Lakhgam,Bardoli,Gujarat',
'Mandvi SR,Bardoli,Gujarat',
'Moritha,Bardoli,Gujarat',
'Moticheir,Bardoli,Gujarat',
'Munjlav,Bardoli,Gujarat',
'Nandpore,Bardoli,Gujarat',
'Naren,Bardoli,Gujarat',
'Patal,Bardoli,Gujarat',
'Puna,Bardoli,Gujarat',
'Ratania,Bardoli,Gujarat',
'Regama,Bardoli,Gujarat',
'Roswad,Bardoli,Gujarat',
'Rupan,Bardoli,Gujarat',
'Salaiya,Bardoli,Gujarat',
'Sarkui,Bardoli,Gujarat',
'Sathvav,Bardoli,Gujarat',
'Tadkeshwar,Bardoli,Gujarat',
'Tarsada,Bardoli,Gujarat',
'Tuked,Bardoli,Gujarat',
'Unteva,Bardoli,Gujarat',
'Vareli,Bardoli,Gujarat',
'Vareth,Bardoli,Gujarat',
'Virpur,Bardoli,Gujarat',
'Ankodod,Surat,Gujarat',
'Gijram,Surat,Gujarat',
'Mota Miya Mangrol,Surat,Gujarat',
'Amoda,Bardoli,Gujarat',
'Balde,Bardoli,Gujarat',
'Bhljamboli,Bardoli,Gujarat',
'Bortha,Bardoli,Gujarat',
'Chirmati,Bardoli,Gujarat',
'Chokhiamli,Bardoli,Gujarat',
'Gangtha,Bardoli,Gujarat',
'Gujarpur,Bardoli,Gujarat',
'Hathoda,Bardoli,Gujarat',
'Itwai,Bardoli,Gujarat',
'Khorda,Bardoli,Gujarat',
'Kukurmunda,Bardoli,Gujarat',
'Laxmikheda,Bardoli,Gujarat',
'Mataval,Bardoli,Gujarat',
'Moramba,Bardoli,Gujarat',
'Mubarakpur,Bardoli,Gujarat',
'Nijhar,Bardoli,Gujarat',
'Nimbhora,Bardoli,Gujarat',
'Phulwadi,Bardoli,Gujarat',
'Piplod,Bardoli,Gujarat',
'Pisavar,Bardoli,Gujarat',
'Raigadh,Bardoli,Gujarat',
'Rumkitalav,Bardoli,Gujarat',
'Sadgavan,Bardoli,Gujarat',
'Sarvala,Bardoli,Gujarat',
'Sayla,Bardoli,Gujarat',
'Vanka,Bardoli,Gujarat',
'Veldha,Bardoli,Gujarat',
'Vyaval,Bardoli,Gujarat',
'Amalsadi,Surat,Gujarat',
'Anita,Surat,Gujarat',
'Antroli,Surat,Gujarat',
'Areth,Surat,Gujarat',
'Asnad,Surat,Gujarat',
'Bhadol,Surat,Gujarat',
'Bhagwa,Surat,Gujarat',
'Bhatgam,Surat,Gujarat',
'Bhilvada,Surat,Gujarat',
'Borsad,Surat,Gujarat',
'Dandi,Surat,Gujarat',
'Delasa,Surat,Gujarat',
'Dhrampur,Surat,Gujarat',
'Dungri,Surat,Gujarat',
'Erthan,Surat,Gujarat',
'Fali,Surat,Gujarat',
'Harsani,Surat,Gujarat',
'Ishanpore,Surat,Gujarat',
'Kadrama,Surat,Gujarat',
'Kamroli,Surat,Gujarat',
'Karanj,Surat,Gujarat',
'Karanj,Surat,Gujarat',
'Kim Char Rasta,Surat,Gujarat',
'Kim,Surat,Gujarat',
'Koba,Surat,Gujarat',
'Kosamba Bazar,Surat,Gujarat',
'Kosamba,Surat,Gujarat',
'Kothwa,Surat,Gujarat',
'Kudiana,Surat,Gujarat',
'Kudsad,Surat,Gujarat',
'Kunvarda,Surat,Gujarat',
'Lavachha,Surat,Gujarat',
'Limodra,Surat,Gujarat',
'Madroi,Surat,Gujarat',
'Masma,Surat,Gujarat',
'Mohamedpur,Surat,Gujarat',
'Mor,Surat,Gujarat',
'Mosali,Surat,Gujarat',
'Mota Borsara,Surat,Gujarat',
'Mulad,Surat,Gujarat',
'Nani Naroli,Surat,Gujarat',
'Nogama,Surat,Gujarat',
'Olpad,Surat,Gujarat',
'Orma,Surat,Gujarat',
'Pardi Bhadol,Surat,Gujarat',
'Pipodara,Surat,Gujarat',
'Saras,Surat,Gujarat',
'Sava,Surat,Gujarat',
'Shah,Surat,Gujarat',
'Siyalaj,Surat,Gujarat',
'Sondla Khara,Surat,Gujarat',
'Sonsak,Surat,Gujarat',
'Takarma,Surat,Gujarat',
'Vadod,Surat,Gujarat',
'Vadoli,Surat,Gujarat',
'Varethi,Surat,Gujarat',
'Vasravi,Surat,Gujarat',
'Vegi,Surat,Gujarat',
'Vihara,Surat,Gujarat',
'Zab,Surat,Gujarat',
'Amalsadi,Bardoli,Gujarat',
'Ambheti,Bardoli,Gujarat',
'Antroli,Bardoli,Gujarat',
'Bagumara,Bardoli,Gujarat',
'Baleshwar,Bardoli,Gujarat',
'Barasado,Bardoli,Gujarat',
'Chalthan,Bardoli,Gujarat',
'Dastan,Bardoli,Gujarat',
'Ena,Bardoli,Gujarat',
'Gangadhara RS,Bardoli,Gujarat',
'Italva,Bardoli,Gujarat',
'Jolwa,Bardoli,Gujarat',
'Kadodara,Bardoli,Gujarat',
'Kanav,Bardoli,Gujarat',
'Karan,Bardoli,Gujarat',
'Lakhanpur,Bardoli,Gujarat',
'Malekpor,Bardoli,Gujarat',
'Niol,Bardoli,Gujarat',
'Palsana,Bardoli,Gujarat',
'Puni,Bardoli,Gujarat',
'Soyani,Bardoli,Gujarat',
'Taraj,Bardoli,Gujarat',
'Tatithaiya,Bardoli,Gujarat',
'Tundi,Bardoli,Gujarat',
'Vadadla Tanti,Bardoli,Gujarat',
'Vanisa Pisadi,Bardoli,Gujarat',
'Bonandh,Surat,Gujarat',
'Eklera,Surat,Gujarat',
'Gabheni,Surat,Gujarat',
'Kanakpur,Surat,Gujarat',
'Kansad,Surat,Gujarat',
'Lingad,Surat,Gujarat',
'Sachin R.S.,Surat,Gujarat',
'Talangpur,Surat,Gujarat',
'Umber,Surat,Gujarat',
'Vanz,Surat,Gujarat',
'Vektana,Surat,Gujarat',
'Atodara,Surat,Gujarat',
'Bharundi,Surat,Gujarat',
'Gothan,Surat,Gujarat',
'Karmala,Surat,Gujarat',
'Madhar,Surat,Gujarat',
'Morthana,Surat,Gujarat',
'Paria,Surat,Gujarat',
'Sadhier,Surat,Gujarat',
'Sayan,Surat,Gujarat',
'Segva,Surat,Gujarat',
'Sithan,Surat,Gujarat',
'Syadla,Surat,Gujarat',
'Umra,Surat,Gujarat',
'Agasvan,Bardoli,Gujarat',
'Amalgundi,Bardoli,Gujarat',
'Bhatwada,Bardoli,Gujarat',
'Borsavar,Bardoli,Gujarat',
'Chikhali Khadka,Bardoli,Gujarat',
'Chorvad,Bardoli,Gujarat',
'Dhajamba,Bardoli,Gujarat',
'Dhamodi,Bardoli,Gujarat',
'Doswada,Bardoli,Gujarat',
'Galkuva,Bardoli,Gujarat',
'Ghasiamedha,Bardoli,Gujarat',
'Ghoda,Bardoli,Gujarat',
'Gopalpura,Bardoli,Gujarat',
'Gunkhadi,Bardoli,Gujarat',
'Hindla,Bardoli,Gujarat',
'Hiravadi,Bardoli,Gujarat',
'Jamkhadi,Bardoli,Gujarat',
'Khanjar,Bardoli,Gujarat',
'Kikakui,Bardoli,Gujarat',
'Kumkuva,Bardoli,Gujarat',
'Limbi,Bardoli,Gujarat',
'Malangdev,Bardoli,Gujarat',
'Moghvan,Bardoli,Gujarat',
'Mota Tarpada,Bardoli,Gujarat',
'Moti Khervan,Bardoli,Gujarat',
'Nishana,Bardoli,Gujarat',
'Panchpipla,Bardoli,Gujarat',
'Pipalkuva,Bardoli,Gujarat',
'Sadadvel,Bardoli,Gujarat',
'Segupada,Bardoli,Gujarat',
'Singpur,Bardoli,Gujarat',
'Sisor,Bardoli,Gujarat',
'Taparwada,Bardoli,Gujarat',
'Ukahlda,Bardoli,Gujarat',
'Ukai Dam,Bardoli,Gujarat',
'Vadibehsrot,Bardoli,Gujarat',
'Vanzarda,Bardoli,Gujarat',
'Wcc Ukai,Bardoli,Gujarat',
'A. K. Road,Surat,Gujarat',
'Abhva,Surat,Gujarat',
'Adajan Dn,Surat,Gujarat',
'Aganovad,Surat,Gujarat',
'Althan,Surat,Gujarat',
'Ambheta,Surat,Gujarat',
'Ariana,Surat,Gujarat',
'Athwa,Surat,Gujarat',
'Barbodhan,Surat,Gujarat',
'Begampura,Surat,Gujarat',
'Bhagal,Surat,Gujarat',
'Bhandut,Surat,Gujarat',
'Bharthana,Surat,Gujarat',
'Bhavanivad,Surat,Gujarat',
'Bhesan,Surat,Gujarat',
'Bhestan,Surat,Gujarat',
'Bombay Market,Surat,Gujarat',
'Dihen,Surat,Gujarat',
'Fatehnagar,Surat,Gujarat',
'Gavir,Surat,Gujarat',
'Gopipura,Surat,Gujarat',
'Govt. Medical College,Surat,Gujarat',
'Hajira,Surat,Gujarat',
'Indrapura,Surat,Gujarat',
'Jhampa,Surat,Gujarat',
'Katargam,Surat,Gujarat',
'Khajod,Surat,Gujarat',
'Khatodara,Surat,Gujarat',
'Kosmada,Surat,Gujarat',
'Lajpore,Surat,Gujarat',
'Laskana,Surat,Gujarat',
'Magdalla,Surat,Gujarat',
'Mahidharmpura,Surat,Gujarat',
'Muglisara,Surat,Gujarat',
'Nanpura H.O,Surat,Gujarat',
'Narthan,Surat,Gujarat',
'Navyug College,Surat,Gujarat',
'Nawabwadi,Surat,Gujarat',
'Palanpur Nd,Surat,Gujarat',
'Pandesara,Surat,Gujarat',
'Pasodara,Surat,Gujarat',
'Pinjrat,Surat,Gujarat',
'Ramnagar,Surat,Gujarat',
'Rander,Surat,Gujarat',
'Rustampura,Surat,Gujarat',
'Sachin,Surat,Gujarat',
'Sagrampura Putli,Surat,Gujarat',
'Sania Hemad,Surat,Gujarat',
'Sayedpura,Surat,Gujarat',
'Segva Chhama,Surat,Gujarat',
'Selut,Surat,Gujarat',
'Surat City,Surat,Gujarat',
'Surat H.O,Surat,Gujarat',
'Surat RS,Surat,Gujarat',
'Surta Textile Market,Surat,Gujarat',
'Svr College,Surat,Gujarat',
'Umra,Surat,Gujarat',
'Valak,Surat,Gujarat',
'Varachha Road,Surat,Gujarat',
'Varachhali,Surat,Gujarat',
'Variavi Bhagal,Surat,Gujarat',
'Vasta Devdi Road,Surat,Gujarat',
'Vesu,Surat,Gujarat',
'Babarghat,Bardoli,Gujarat',
'Bhadbhunja,Bardoli,Gujarat',
'Bhitkhurd,Bardoli,Gujarat',
'Chhapti,Bardoli,Gujarat',
'Chhitpur,Bardoli,Gujarat',
'Gavan,Bardoli,Gujarat',
'Haripur,Bardoli,Gujarat',
'Karod,Bardoli,Gujarat',
'Khabda,Bardoli,Gujarat',
'Kulda,Bardoli,Gujarat',
'Magarbara,Bardoli,Gujarat',
'Mirkot,Bardoli,Gujarat',
'Narayanpur,Bardoli,Gujarat',
'Sankarda,Bardoli,Gujarat',
'Selud,Bardoli,Gujarat',
'Sunderpur,Bardoli,Gujarat',
'Thuti,Bardoli,Gujarat',
'Tokarva,Bardoli,Gujarat',
'Uchchhal,Bardoli,Gujarat',
'Bamroli,Surat,Gujarat',
'Budia,Surat,Gujarat',
'Deladva,Surat,Gujarat',
'Devadh,Surat,Gujarat',
'Dindoli,Surat,Gujarat',
'Kharvasa,Surat,Gujarat',
'Sania Kande,Surat,Gujarat',
'Udhna,Surat,Gujarat',
'Udhnagam,Surat,Gujarat',
'Un,Surat,Gujarat',
'Bilvan,Surat,Gujarat',
'Chavda,Surat,Gujarat',
'Chimipatal,Surat,Gujarat',
'Chokhvada,Surat,Gujarat',
'Ghanavad,Surat,Gujarat',
'Khota Rampura,Surat,Gujarat',
'Umarda,Surat,Gujarat',
'Umargot,Surat,Gujarat',
'Umarpada,Surat,Gujarat',
'Vadpada,Surat,Gujarat',
'Chapra Bhatha,Surat,Gujarat',
'Utran,Surat,Gujarat',
'Utran Power House,Surat,Gujarat',
'Algat,Bardoli,Gujarat',
'Ambach,Bardoli,Gujarat',
'Andhatri,Bardoli,Gujarat',
'Antapur,Bardoli,Gujarat',
'Bajipura,Bardoli,Gujarat',
'Bedkuva,Bardoli,Gujarat',
'Bhimpor,Bardoli,Gujarat',
'Buhari,Bardoli,Gujarat',
'Dadaria,Bardoli,Gujarat',
'Delvada,Bardoli,Gujarat',
'Dhamodla,Bardoli,Gujarat',
'Gandhi Vidyapith,Bardoli,Gujarat',
'Goddha,Bardoli,Gujarat',
'Hatuka,Bardoli,Gujarat',
'Jamania,Bardoli,Gujarat',
'Kaher,Bardoli,Gujarat',
'Kalamkui,Bardoli,Gujarat',
'Kanjod,Bardoli,Gujarat',
'Navafalia,Bardoli,Gujarat',
'Ranveri,Bardoli,Gujarat',
'Siker,Bardoli,Gujarat',
'Syadla,Bardoli,Gujarat',
'Valod,Bardoli,Gujarat',
'Vedchhi,Bardoli,Gujarat',
'Ambawadi,Surat,Gujarat',
'Amkhuta,Surat,Gujarat',
'Boria,Surat,Gujarat',
'Dholikui,Surat,Gujarat',
'Isanpur,Surat,Gujarat',
'Lavet,Surat,Gujarat',
'Nandola,Surat,Gujarat',
'Vankal,Surat,Gujarat',
'Verakui,Surat,Gujarat',
'Variav,Surat,Gujarat',
'Asaram,Surat,Gujarat',
'Hathoda,Surat,Gujarat',
'Kantva,Surat,Gujarat',
'Kosadi,Surat,Gujarat',
'Limbada,Surat,Gujarat',
'Luvara,Surat,Gujarat',
'Nogama,Surat,Gujarat',
'Simodra,Surat,Gujarat',
'Velachha,Surat,Gujarat',
'Ambia,Bardoli,Gujarat',
'Anumala,Bardoli,Gujarat',
'Bahedaraipura,Bardoli,Gujarat',
'Balpur,Bardoli,Gujarat',
'Bardipada,Bardoli,Gujarat',
'Bedkuvadoor,Bardoli,Gujarat',
'Bedkuvanajik,Bardoli,Gujarat',
'Bhojpur Najik,Bardoli,Gujarat',
'Borkhadi,Bardoli,Gujarat',
'Champavadi,Bardoli,Gujarat',
'Chhindia,Bardoli,Gujarat',
'Chikalda,Bardoli,Gujarat',
'Chikhalvav,Bardoli,Gujarat',
'Chikhlinani,Bardoli,Gujarat',
'Chunavadi,Bardoli,Gujarat',
'Degama,Bardoli,Gujarat',
'Dhanturi,Bardoli,Gujarat',
'Dhat,Bardoli,Gujarat',
'Dolara,Bardoli,Gujarat',
'Dolvan,Bardoli,Gujarat',
'Gadat,Bardoli,Gujarat',
'Ghani,Bardoli,Gujarat',
'Ghata,Bardoli,Gujarat',
'Jesingpur,Bardoli,Gujarat',
'Kalakva,Bardoli,Gujarat',
'Kalamkui,Bardoli,Gujarat',
'Kanjan,Bardoli,Gujarat',
'Kanpura,Bardoli,Gujarat',
'Kapura,Bardoli,Gujarat',
'Karanjkhed,Bardoli,Gujarat',
'Karanjvel,Bardoli,Gujarat',
'Kasvav,Bardoli,Gujarat',
'Katasvan,Bardoli,Gujarat',
'Kelkui,Bardoli,Gujarat',
'Khanpur,Bardoli,Gujarat',
'Khodtalav,Bardoli,Gujarat',
'Khurdi,Bardoli,Gujarat',
'Khushalpura,Bardoli,Gujarat',
'Khutadia,Bardoli,Gujarat',
'Lakhali,Bardoli,Gujarat',
'Limberda,Bardoli,Gujarat',
'Lotarva,Bardoli,Gujarat',
'Magalia,Bardoli,Gujarat',
'Magarkui,Bardoli,Gujarat',
'Mirpur,Bardoli,Gujarat',
'Padamdungri,Bardoli,Gujarat',
'Palawadi,Bardoli,Gujarat',
'Panchol,Bardoli,Gujarat',
'Paniyari,Bardoli,Gujarat',
'Pathakvadi,Bardoli,Gujarat',
'Pati,Bardoli,Gujarat',
'Pelad,Bardoli,Gujarat',
'Pithadara,Bardoli,Gujarat',
'Raniamba,Bardoli,Gujarat',
'Rupvada,Bardoli,Gujarat',
'Sankli,Bardoli,Gujarat',
'Umarkui,Bardoli,Gujarat',
'Umarkutch,Bardoli,Gujarat',
'Umarvavdoor,Bardoli,Gujarat',
'Unchamala,Bardoli,Gujarat',
'Vadkui,Bardoli,Gujarat',
'Vankla,Bardoli,Gujarat',
'Vanskui,Bardoli,Gujarat',
'Virpur,Bardoli,Gujarat',
'Vyara RS,Bardoli,Gujarat',
'Vyara,Bardoli,Gujarat',
'Zankhari,Bardoli,Gujarat',
'Balethi,Surat,Gujarat',
'Bundha,Surat,Gujarat',
'Chitalda,Surat,Gujarat',
'Chormba,Surat,Gujarat',
'Devadh,Surat,Gujarat',
'Godbar,Surat,Gujarat',
'Keori,Surat,Gujarat',
'Luharvad,Surat,Gujarat',
'Madan Boria,Surat,Gujarat',
'Maldha,Surat,Gujarat',
'Nasarpur,Surat,Gujarat',
'Sarda,Surat,Gujarat',
'Sarvan Fokdi,Surat,Gujarat',
'Tarapur,Surat,Gujarat',
'Udharia,Surat,Gujarat',
'Umarzar,Surat,Gujarat',
'Vad,Surat,Gujarat',
'Vahar,Surat,Gujarat',
'Zankhvav,Surat,Gujarat',
'Nagnesh,Surendranagar,Gujarat',
'Shirvaniya,Surendranagar,Gujarat',
'Anandpur Bhadla,Surendranagar,Gujarat',
'Bamanbor,Surendranagar,Gujarat',
'Chiroda,Surendranagar,Gujarat',
'Chobari,Surendranagar,Gujarat',
'Chorvira,Surendranagar,Gujarat',
'Chotila,Surendranagar,Gujarat',
'Devsar,Surendranagar,Gujarat',
'Dharai,Surendranagar,Gujarat',
'Dhokalva,Surendranagar,Gujarat',
'Gunda,Surendranagar,Gujarat',
'Janivadla,Surendranagar,Gujarat',
'Khatdi,Surendranagar,Gujarat',
'Kherana,Surendranagar,Gujarat',
'Kherdi,Surendranagar,Gujarat',
'Mandlasar,Surendranagar,Gujarat',
'Morthala,Surendranagar,Gujarat',
'Moti Moldi,Surendranagar,Gujarat',
'Nava,Surendranagar,Gujarat',
'Panchvada,Surendranagar,Gujarat',
'Pipaliya (Dhora),Surendranagar,Gujarat',
'Pipaliya Dhandhal,Surendranagar,Gujarat',
'Piyava,Surendranagar,Gujarat',
'Rajpara,Surendranagar,Gujarat',
'Ranipat,Surendranagar,Gujarat',
'Reshamiya,Surendranagar,Gujarat',
'Sanosara,Surendranagar,Gujarat',
'Sapar,Surendranagar,Gujarat',
'Songadh,Surendranagar,Gujarat',
'Tarnetar,Surendranagar,Gujarat',
'Thangadh,Surendranagar,Gujarat',
'Vadali,Surendranagar,Gujarat',
'Vagadiya,Surendranagar,Gujarat',
'Vijaliya,Surendranagar,Gujarat',
'Zinzuda,Surendranagar,Gujarat',
'Adariyana,Surendranagar,Gujarat',
'Bajana,Surendranagar,Gujarat',
'Bubvana,Surendranagar,Gujarat',
'Chikasar,Surendranagar,Gujarat',
'Dasada,Surendranagar,Gujarat',
'Degam,Surendranagar,Gujarat',
'Dhama,Surendranagar,Gujarat',
'Echhvada,Surendranagar,Gujarat',
'Ervada,Surendranagar,Gujarat',
'Fatepur,Surendranagar,Gujarat',
'Gavana,Surendranagar,Gujarat',
'Gediya,Surendranagar,Gujarat',
'Goriyavad,Surendranagar,Gujarat',
'Jainabad,Surendranagar,Gujarat',
'Jarvala,Surendranagar,Gujarat',
'Kacholiya,Surendranagar,Gujarat',
'Kathada,Surendranagar,Gujarat',
'Kharaghoda,Surendranagar,Gujarat',
'Kherva(Jat),Surendranagar,Gujarat',
'Malvan(Jat),Surendranagar,Gujarat',
'Motimajethi,Surendranagar,Gujarat',
'Nagadka(Jat),Surendranagar,Gujarat',
'Nagvada,Surendranagar,Gujarat',
'Nana Goraiya,Surendranagar,Gujarat',
'Nava Savlas,Surendranagar,Gujarat',
'Naviyani,Surendranagar,Gujarat',
'Odu,Surendranagar,Gujarat',
'Panva,Surendranagar,Gujarat',
'Patdi,Surendranagar,Gujarat',
'Pipali,Surendranagar,Gujarat',
'Porda,Surendranagar,Gujarat',
'Savda,Surendranagar,Gujarat',
'Sedla,Surendranagar,Gujarat',
'Sokhda,Surendranagar,Gujarat',
'Surel,Surendranagar,Gujarat',
'Sushiya,Surendranagar,Gujarat',
'Upariyala,Surendranagar,Gujarat',
'Vadgam,Surendranagar,Gujarat',
'Vanod,Surendranagar,Gujarat',
'Visavadi,Surendranagar,Gujarat',
'Zadiyana,Surendranagar,Gujarat',
'Zinzuwada,Surendranagar,Gujarat',
'Akhiyana,Surendranagar,Gujarat',
'Bamanva,Surendranagar,Gujarat',
'Bavli,Surendranagar,Gujarat',
'Bharad,Surendranagar,Gujarat',
'Bharada,Surendranagar,Gujarat',
'Bhechda,Surendranagar,Gujarat',
'Chuli,Surendranagar,Gujarat',
'Devcharadi,Surendranagar,Gujarat',
'Dholi,Surendranagar,Gujarat',
'Dhrumath,Surendranagar,Gujarat',
'Dumana,Surendranagar,Gujarat',
'Gajanvav,Surendranagar,Gujarat',
'Gala,Surendranagar,Gujarat',
'Ganjela,Surendranagar,Gujarat',
'Hampar,Surendranagar,Gujarat',
'Haripar,Surendranagar,Gujarat',
'Jasmatpur,Surendranagar,Gujarat',
'Jegadva,Surendranagar,Gujarat',
'Jesda,Surendranagar,Gujarat',
'Jiva,Surendranagar,Gujarat',
'Kankavati,Surendranagar,Gujarat',
'Khambhada,Surendranagar,Gujarat',
'Kondh,Surendranagar,Gujarat',
'Kuda,Surendranagar,Gujarat',
'Malvan,Surendranagar,Gujarat',
'Manpar,Surendranagar,Gujarat',
'Methan,Surendranagar,Gujarat',
'Narali,Surendranagar,Gujarat',
'Narichana,Surendranagar,Gujarat',
'Navalgadh,Surendranagar,Gujarat',
'Pratappur,Surendranagar,Gujarat',
'Rajcharadi,Surendranagar,Gujarat',
'Rajsitapur,Surendranagar,Gujarat',
'Sara,Surendranagar,Gujarat',
'Sarval,Surendranagar,Gujarat',
'Soldi,Surendranagar,Gujarat',
'Thala,Surendranagar,Gujarat',
'Vavdi,Surendranagar,Gujarat',
'Dhrangadhra,Surendranagar,Gujarat',
'Ramgadh,Surendranagar,Gujarat',
'Ajitgadh,Surendranagar,Gujarat',
'Charadva,Surendranagar,Gujarat',
'Devaliya,Surendranagar,Gujarat',
'Dhanala,Surendranagar,Gujarat',
'Dhavana,Surendranagar,Gujarat',
'Enjar,Surendranagar,Gujarat',
'Ghanshyampur,Surendranagar,Gujarat',
'Halvad,Surendranagar,Gujarat',
'Ingorala,Surendranagar,Gujarat',
'Isanpur,Surendranagar,Gujarat',
'Kadiyana,Surendranagar,Gujarat',
'Kavadiya,Surendranagar,Gujarat',
'Kidi,Surendranagar,Gujarat',
'Koparani,Surendranagar,Gujarat',
'Koyba,Surendranagar,Gujarat',
'Malaniyad,Surendranagar,Gujarat',
'Mathak,Surendranagar,Gujarat',
'Mayurnagar,Surendranagar,Gujarat',
'Merupar,Surendranagar,Gujarat',
'Navaghanshyamgadh,Surendranagar,Gujarat',
'Ranakpur,Surendranagar,Gujarat',
'Ranjitgadh,Surendranagar,Gujarat',
'Ranmalpur,Surendranagar,Gujarat',
'Ratabhe,Surendranagar,Gujarat',
'Sapakda,Surendranagar,Gujarat',
'Sundari,Surendranagar,Gujarat',
'Survadar,Surendranagar,Gujarat',
'Susvav,Surendranagar,Gujarat',
'Tikar (Ran),Surendranagar,Gujarat',
'Vegadvav,Surendranagar,Gujarat',
'Adalsar,Surendranagar,Gujarat',
'Anindra,Surendranagar,Gujarat',
'Bajarangpura,Surendranagar,Gujarat',
'Bhadena,Surendranagar,Gujarat',
'Bhadvana,Surendranagar,Gujarat',
'Chharad,Surendranagar,Gujarat',
'Dervala,Surendranagar,Gujarat',
'Devaliya,Surendranagar,Gujarat',
'Dhanki,Surendranagar,Gujarat',
'Gangad,Surendranagar,Gujarat',
'Ghanad,Surendranagar,Gujarat',
'Hebatpur,Surendranagar,Gujarat',
'Kadu,Surendranagar,Gujarat',
'Kalam,Surendranagar,Gujarat',
'Karala,Surendranagar,Gujarat',
'Lakhtar,Surendranagar,Gujarat',
'Lilapur,Surendranagar,Gujarat',
'Malika,Surendranagar,Gujarat',
'Modhvana,Surendranagar,Gujarat',
'Nana Ankevaliya,Surendranagar,Gujarat',
'Nanikathechi,Surendranagar,Gujarat',
'Olak,Surendranagar,Gujarat',
'Pedhda,Surendranagar,Gujarat',
'Sadad,Surendranagar,Gujarat',
'Sakar,Surendranagar,Gujarat',
'Savlana,Surendranagar,Gujarat',
'Tarmaniya,Surendranagar,Gujarat',
'Vana,Surendranagar,Gujarat',
'Vithalgadh,Surendranagar,Gujarat',
'Zamar,Surendranagar,Gujarat',
'Anandpur Bhal,Surendranagar,Gujarat',
'Ankevaliya,Surendranagar,Gujarat',
'Baldana,Surendranagar,Gujarat',
'Balol,Surendranagar,Gujarat',
'Bhalgamda,Surendranagar,Gujarat',
'Bhathan,Surendranagar,Gujarat',
'Bhensjal,Surendranagar,Gujarat',
'Bhoika,Surendranagar,Gujarat',
'Bhojpara,Surendranagar,Gujarat',
'Bhragupur,Surendranagar,Gujarat',
'Borana,Surendranagar,Gujarat',
'Borna,Surendranagar,Gujarat',
'Chachana,Surendranagar,Gujarat',
'Chachka,Surendranagar,Gujarat',
'Chhalala,Surendranagar,Gujarat',
'Chhatriyala,Surendranagar,Gujarat',
'Chokdi,Surendranagar,Gujarat',
'Choki,Surendranagar,Gujarat',
'Chuda,Surendranagar,Gujarat',
'Dholi Bhal,Surendranagar,Gujarat',
'Gedi,Surendranagar,Gujarat',
'Ghaghretiya,Surendranagar,Gujarat',
'Hadalabhal,Surendranagar,Gujarat',
'Jambu,Surendranagar,Gujarat',
'Janshali,Surendranagar,Gujarat',
'Jobala,Surendranagar,Gujarat',
'Kamalpar,Surendranagar,Gujarat',
'Kanthariya,Surendranagar,Gujarat',
'Karol,Surendranagar,Gujarat',
'Katariya,Surendranagar,Gujarat',
'Khajeli,Surendranagar,Gujarat',
'Khambhalav,Surendranagar,Gujarat',
'Khandiya,Surendranagar,Gujarat',
'Korda,Surendranagar,Gujarat',
'Laliyad,Surendranagar,Gujarat',
'Limbdi,Surendranagar,Gujarat',
'Loya,Surendranagar,Gujarat',
'Minapur,Surendranagar,Gujarat',
'Mojidad,Surendranagar,Gujarat',
'Morvad(Juni),Surendranagar,Gujarat',
'Motatimbla,Surendranagar,Gujarat',
'Mulbavla,Surendranagar,Gujarat',
'Nagadka,Surendranagar,Gujarat',
'Natvargadh,Surendranagar,Gujarat',
'Panshina,Surendranagar,Gujarat',
'Parali,Surendranagar,Gujarat',
'Parnala,Surendranagar,Gujarat',
'Ralol,Surendranagar,Gujarat',
'Ranagadh,Surendranagar,Gujarat',
'Raska,Surendranagar,Gujarat',
'Rojasar,Surendranagar,Gujarat',
'Samla,Surendranagar,Gujarat',
'Sauka,Surendranagar,Gujarat',
'Shiyani,Surendranagar,Gujarat',
'Talsana,Surendranagar,Gujarat',
'Tavi,Surendranagar,Gujarat',
'Tokrala,Surendranagar,Gujarat',
'Tuva,Surendranagar,Gujarat',
'Untadi,Surendranagar,Gujarat',
'Vadod,Surendranagar,Gujarat',
'Vanala,Surendranagar,Gujarat',
'Varsani,Surendranagar,Gujarat',
'Vastadi,Surendranagar,Gujarat',
'Devpara,Surendranagar,Gujarat',
'Rangpur,Gandhinagar,Gujarat',
'Kudla,Surendranagar,Gujarat',
'Ingrodi,Surendranagar,Gujarat',
'Bhaduka,Surendranagar,Gujarat',
'Danavada,Surendranagar,Gujarat',
'Digsar,Surendranagar,Gujarat',
'Dudhai,Surendranagar,Gujarat',
'Gadhad,Surendranagar,Gujarat',
'Gautamgadh,Surendranagar,Gujarat',
'Jasapar,Surendranagar,Gujarat',
'Kalmad,Surendranagar,Gujarat',
'Khatdi,Surendranagar,Gujarat',
'Kukda,Surendranagar,Gujarat',
'Kuntalpur,Surendranagar,Gujarat',
'Liya,Surendranagar,Gujarat',
'Muli,Surendranagar,Gujarat',
'Pandavara,Surendranagar,Gujarat',
'Sarla,Surendranagar,Gujarat',
'Shekhpar,Surendranagar,Gujarat',
'Somasar,Surendranagar,Gujarat',
'Tikar Parmar,Surendranagar,Gujarat',
'Umarda,Surendranagar,Gujarat',
'Malanpur,Gandhinagar,Gujarat',
'Vaghada,Gandhinagar,Gujarat',
'Dhajala,Surendranagar,Gujarat',
'Dhandhalpur,Surendranagar,Gujarat',
'Doliya,Surendranagar,Gujarat',
'Garambhadi,Surendranagar,Gujarat',
'Goraiya,Surendranagar,Gujarat',
'Gosal,Surendranagar,Gujarat',
'Junajasapar,Surendranagar,Gujarat',
'Khintala,Surendranagar,Gujarat',
'Nadala,Surendranagar,Gujarat',
'Nana Matra,Surendranagar,Gujarat',
'Navagam (S),Surendranagar,Gujarat',
'Navaniya,Surendranagar,Gujarat',
'Ninama,Surendranagar,Gujarat',
'Noli,Surendranagar,Gujarat',
'Ori,Gondal,Gujarat',
'Piprali,Surendranagar,Gujarat',
'Samadhiyala,Surendranagar,Gujarat',
'Sayla,Surendranagar,Gujarat',
'Sejakpar,Surendranagar,Gujarat',
'Sidhsar,Surendranagar,Gujarat',
'Sudamada,Surendranagar,Gujarat',
'Thoriyali,Surendranagar,Gujarat',
'Vadia,Surendranagar,Gujarat',
'Vakhatpar,Surendranagar,Gujarat',
'Bakarthali,Surendranagar,Gujarat',
'Bala,Surendranagar,Gujarat',
'Bhadreshi,Surendranagar,Gujarat',
'Chamaraj,Surendranagar,Gujarat',
'Dedadra,Surendranagar,Gujarat',
'Dudhrej,Surendranagar,Gujarat',
'Fulgram,Surendranagar,Gujarat',
'Gujarvadi,Surendranagar,Gujarat',
'Gundiyala,Surendranagar,Gujarat',
'Katuda,Surendranagar,Gujarat',
'Kharva,Surendranagar,Gujarat',
'Kherali,Surendranagar,Gujarat',
'Khodu,Surendranagar,Gujarat',
'Kholadiyad,Surendranagar,Gujarat',
'Kothariya,Surendranagar,Gujarat',
'Limli,Surendranagar,Gujarat',
'Malod,Surendranagar,Gujarat',
'Memka,Surendranagar,Gujarat',
'Mota Ankevaliya,Surendranagar,Gujarat',
'Motamadhad,Surendranagar,Gujarat',
'Munjpar,Surendranagar,Gujarat',
'Nagra,Surendranagar,Gujarat',
'Rajpar,Surendranagar,Gujarat',
'Rampara,Surendranagar,Gujarat',
'Ratanpar,Surendranagar,Gujarat',
'Ravaliyavadar,Surendranagar,Gujarat',
'Sankali,Surendranagar,Gujarat',
'Surendranaagr M.P.S.C.,Surendranagar,Gujarat',
'Surendranaagr Udyognagar,Surendranagar,Gujarat',
'Surendranaagr Vadipara,Surendranagar,Gujarat',
'Surendranagar Station Road,Surendranagar,Gujarat',
'Timba,Surendranagar,Gujarat',
'Vadla,Surendranagar,Gujarat',
'Vaghela,Surendranagar,Gujarat',
'Velavadar,Surendranagar,Gujarat',
'Wadhwancity Bazatr,Surendranagar,Gujarat',
'Wadhwancity Ind. Estate,Surendranagar,Gujarat',
'Wadhwancity,Surendranagar,Gujarat',
'Zampodad,Surendranagar,Gujarat',
'Surendranagar H.O,Surendranagar,Gujarat',
'Joravarnagar,Surendranagar,Gujarat',
'Ahwadangs,Bardoli,Gujarat',
'Pimpri,Bardoli,Gujarat',
'Saputara,Bardoli,Gujarat',
'Subir,Bardoli,Gujarat',
'Waghai,Bardoli,Gujarat',
'Barkhandhia,Bardoli,Gujarat',
'Chankhal,Bardoli,Gujarat',
'Chikar,Bardoli,Gujarat',
'Chikhali Dangs,Bardoli,Gujarat',
'Dagadiamba,Bardoli,Gujarat',
'Dagunia,Bardoli,Gujarat',
'Gotiamal,Bardoli,Gujarat',
'Jhavda,Bardoli,Gujarat',
'Kadmal,Bardoli,Gujarat',
'Keshbandh,Bardoli,Gujarat',
'Khambhala,Bardoli,Gujarat',
'Lavchali,Bardoli,Gujarat',
'Mahal,Bardoli,Gujarat',
'Malegaon,Bardoli,Gujarat',
'Manmodi,Bardoli,Gujarat',
'Nadagchond,Bardoli,Gujarat',
'Nakatia Hanvant,Bardoli,Gujarat',
'Nanapada,Bardoli,Gujarat',
'Nishana,Bardoli,Gujarat',
'Pandva,Bardoli,Gujarat',
'Piplaidevi,Bardoli,Gujarat',
'Rambhas,Bardoli,Gujarat',
'Sakarpatal,Bardoli,Gujarat',
'Samgahan,Bardoli,Gujarat',
'Singana,Bardoli,Gujarat',
'Tanklipada,Bardoli,Gujarat',
'Vasurna,Bardoli,Gujarat',
'Zaridungarda,Bardoli,Gujarat',
'Bhavandgad,Bardoli,Gujarat',
'Borkhal,Bardoli,Gujarat',
'Chikatia,Bardoli,Gujarat',
'Chinchli,Bardoli,Gujarat',
'Dhavlidhod,Bardoli,Gujarat',
'Galkund,Bardoli,Gujarat',
'Garakhadi,Bardoli,Gujarat',
'Ghadvi,Bardoli,Gujarat',
'Gondalvihir,Bardoli,Gujarat',
'Jakhana,Bardoli,Gujarat',
'Linga,Bardoli,Gujarat',
'Mahalpada,Bardoli,Gujarat',
'Morzira,Bardoli,Gujarat',
'Dena,Vadodara East,Gujarat',
'Dhanora,Vadodara West,Gujarat',
'Harni,Vadodara East,Gujarat',
'Sukal,Vadodara East,Gujarat',
'Tejgadh,Vadodara East,Gujarat',
'Vasna Road,Vadodara West,Gujarat',
'Bodeli,Vadodara East,Gujarat',
'Asar,Vadodara East,Gujarat',
'Kanalva,Vadodara East,Gujarat',
'Manavant,Vadodara East,Gujarat',
'Morangana,Vadodara East,Gujarat',
'Raichha,Vadodara East,Gujarat',
'Sadhli,Vadodara East,Gujarat',
'Sanada,Vadodara East,Gujarat',
'Singla,Vadodara East,Gujarat',
'Ambala,Vadodara East,Gujarat',
'Chhota-udepur,Vadodara East,Gujarat',
'Chisadiya,Vadodara East,Gujarat',
'Dhandhoda,Vadodara East,Gujarat',
'Dholi Simal,Vadodara East,Gujarat',
'Dolaria,Vadodara East,Gujarat',
'Dungargam,Vadodara East,Gujarat',
'Ekalbara,Vadodara East,Gujarat',
'Ghelawant,Vadodara East,Gujarat',
'Kadipani,Vadodara East,Gujarat',
'Karanjwant,Vadodara East,Gujarat',
'Kawant,Vadodara East,Gujarat',
'Khadkhad,Vadodara East,Gujarat',
'Kundal,Vadodara East,Gujarat',
'Mandlava,Vadodara East,Gujarat',
'Mithibor,Vadodara East,Gujarat',
'Motaghoda,Vadodara East,Gujarat',
'Nani Tokri,Vadodara East,Gujarat',
'Padharwant,Vadodara East,Gujarat',
'Panvad,Vadodara East,Gujarat',
'Puniavant,Vadodara East,Gujarat',
'Rangpur(Z),Vadodara East,Gujarat',
'Rodadha,Vadodara East,Gujarat',
'Rumadia,Vadodara East,Gujarat',
'Sanada,Vadodara East,Gujarat',
'Surkheda,Vadodara East,Gujarat',
'Virpur,Vadodara East,Gujarat',
'Zoz,Vadodara East,Gujarat',
'Bhorda,Vadodara East,Gujarat',
'Amreshwar,Vadodara West,Gujarat',
'Anguthan,Vadodara East,Gujarat',
'Bhilapur,Vadodara East,Gujarat',
'Bhilodia,Vadodara East,Gujarat',
'Borbar,Vadodara East,Gujarat',
'Chandod,Vadodara East,Gujarat',
'Chanvada,Vadodara East,Gujarat',
'Chhatral,Vadodara West,Gujarat',
'Dabhoi H.O,Vadodara East,Gujarat',
'Dabhoi R.S.,Vadodara East,Gujarat',
'Dabhoi Vadodari Bhagol,Vadodara East,Gujarat',
'Dharmpuri,Vadodara East,Gujarat',
'Dholar,Vadodara East,Gujarat',
'Fartikui,Vadodara East,Gujarat',
'Jiyatalavdi,Vadodara West,Gujarat',
'Kadadhara,Vadodara East,Gujarat',
'Karalipura,Vadodara East,Gujarat',
'Karmal,Vadodara West,Gujarat',
'Karnali,Vadodara East,Gujarat',
'Karnet,Vadodara East,Gujarat',
'Kukad,Vadodara East,Gujarat',
'Kundhela,Vadodara East,Gujarat',
'Kuvarpura,Vadodara West,Gujarat',
'Lingsthali,Vadodara West,Gujarat',
'Mandva,Vadodara East,Gujarat',
'Manjrol,Vadodara East,Gujarat',
'Meghakui,Vadodara East,Gujarat',
'Moletha,Vadodara East,Gujarat',
'Mota Habipura,Vadodara East,Gujarat',
'Nada,Vadodara West,Gujarat',
'Nana Fofalia,Vadodara West,Gujarat',
'Nanderia,Vadodara East,Gujarat',
'Naria,Vadodara East,Gujarat',
'Palaswada,Vadodara East,Gujarat',
'Pansoli,Vadodara East,Gujarat',
'Parikha,Vadodara West,Gujarat',
'Pisai,Vadodara East,Gujarat',
'Sathod,Vadodara East,Gujarat',
'Simalia,Vadodara East,Gujarat',
'Simli,Vadodara East,Gujarat',
'Sitpur,Vadodara East,Gujarat',
'Tentalav,Vadodara East,Gujarat',
'Thuwavi,Vadodara East,Gujarat',
'Vadaj,Vadodara East,Gujarat',
'Vanadara,Vadodara East,Gujarat',
'Vasai,Vadodara East,Gujarat',
'Wadhwana,Vadodara East,Gujarat',
'Anastu,Vadodara West,Gujarat',
'Atali,Vadodara West,Gujarat',
'Bachar,Vadodara West,Gujarat',
'Baman Gam,Vadodara West,Gujarat',
'Bhalod,Bharuch,Gujarat',
'Bharthana,Vadodara West,Gujarat',
'Bodka,Vadodara West,Gujarat',
'Chhanchava,Vadodara West,Gujarat',
'Choranda,Vadodara West,Gujarat',
'Chorbhuj,Vadodara West,Gujarat',
'Dhavat,Vadodara West,Gujarat',
'Gandhara,Vadodara West,Gujarat',
'Ganpatpura,Vadodara West,Gujarat',
'Handod,Vadodara West,Gujarat',
'Juni Jathardi,Vadodara West,Gujarat',
'Kanbha,Vadodara West,Gujarat',
'Kanbola,Vadodara West,Gujarat',
'Kandari,Vadodara West,Gujarat',
'Karamdi,Vadodara West,Gujarat',
'Kayavahron,Vadodara West,Gujarat',
'Kiya,Vadodara West,Gujarat',
'Kurai,Vadodara West,Gujarat',
'Kurali,Vadodara West,Gujarat',
'Lakodara,Vadodara West,Gujarat',
'Mandala,Vadodara West,Gujarat',
'Manglej,Vadodara West,Gujarat',
'Manpur,Vadodara West,Gujarat',
'Menpura,Vadodara West,Gujarat',
'Methi,Vadodara West,Gujarat',
'Miyagam Karjan,Vadodara West,Gujarat',
'Miyagam,Vadodara West,Gujarat',
'Oslam,Vadodara West,Gujarat',
'Pingalvada,Vadodara West,Gujarat',
'Sadhli,Vadodara West,Gujarat',
'Sambhoi,Vadodara West,Gujarat',
'Sampa,Vadodara West,Gujarat',
'Samra,Vadodara West,Gujarat',
'Saniad,Vadodara West,Gujarat',
'Simri,Vadodara West,Gujarat',
'Urad,Vadodara West,Gujarat',
'Valan,Vadodara West,Gujarat',
'Vemar,Vadodara West,Gujarat',
'Vemardi,Vadodara West,Gujarat',
'Virjai,Vadodara West,Gujarat',
'Ambadungar,Vadodara East,Gujarat',
'Athadungri,Vadodara East,Gujarat',
'Bedia,Vadodara East,Gujarat',
'Bhumaswada,Vadodara East,Gujarat',
'Khatiawant,Vadodara East,Gujarat',
'Manka,Vadodara East,Gujarat',
'Mankodi,Vadodara East,Gujarat',
'Motavanta,Vadodara East,Gujarat',
'Mundamore,Vadodara East,Gujarat',
'Navalja,Vadodara East,Gujarat',
'Pipaldi,Vadodara East,Gujarat',
'Raisingpura,Vadodara East,Gujarat',
'Rangpur (K),Vadodara East,Gujarat',
'Saidivasana,Vadodara East,Gujarat',
'Thadgam,Vadodara East,Gujarat',
'Umathi,Vadodara East,Gujarat',
'Vijli,Vadodara East,Gujarat',
'Akona,Vadodara East,Gujarat',
'Amroli,Vadodara East,Gujarat',
'Baroli,Vadodara East,Gujarat',
'Bhaka,Vadodara East,Gujarat',
'Bharvada,Vadodara East,Gujarat',
'Chametha,Vadodara East,Gujarat',
'Dani,Vadodara East,Gujarat',
'Dhamasiya,Vadodara East,Gujarat',
'Dugdha,Vadodara East,Gujarat',
'Gadhboriad,Vadodara East,Gujarat',
'Goyawant,Vadodara East,Gujarat',
'Haripura,Vadodara East,Gujarat',
'Jakshi,Vadodara East,Gujarat',
'Jamli,Vadodara East,Gujarat',
'Jemalgadh,Vadodara East,Gujarat',
'Kaliyapura,Vadodara East,Gujarat',
'Khapariya,Vadodara East,Gujarat',
'Kharmada,Vadodara East,Gujarat',
'Kolamba,Vadodara East,Gujarat',
'Kukarda,Vadodara East,Gujarat',
'Lavakui,Vadodara East,Gujarat',
'Moghela,Vadodara East,Gujarat',
'Nalvant,Vadodara East,Gujarat',
'Naswadi,Vadodara East,Gujarat',
'Navagam,Vadodara East,Gujarat',
'Pala,Vadodara East,Gujarat',
'Palasani,Vadodara East,Gujarat',
'Parvata,Vadodara East,Gujarat',
'Pochamba,Vadodara East,Gujarat',
'Raipur,Vadodara East,Gujarat',
'Savli,Vadodara East,Gujarat',
'Sengpur,Vadodara East,Gujarat',
'Shira,Vadodara East,Gujarat',
'Sindhikuva,Vadodara East,Gujarat',
'Sodhaliya,Vadodara East,Gujarat',
'Tanakhala,Vadodara East,Gujarat',
'Vaguma,Vadodara East,Gujarat',
'Vankla,Vadodara East,Gujarat',
'Wagach,Vadodara East,Gujarat',
'Zer,Vadodara East,Gujarat',
'Husepura,Vadodara West,Gujarat',
'Abhol,Vadodara West,Gujarat',
'Ambada,Vadodara West,Gujarat',
'Amla,Vadodara West,Gujarat',
'Anti,Vadodara West,Gujarat',
'Bhadara,Vadodara West,Gujarat',
'Bhoj,Vadodara West,Gujarat',
'Chansad,Vadodara West,Gujarat',
'Chitral,Vadodara West,Gujarat',
'Chokari,Vadodara West,Gujarat',
'Dabhasa,Vadodara West,Gujarat',
'Dabka,Vadodara West,Gujarat',
'Darapura,Vadodara West,Gujarat',
'Dudhwada,Vadodara West,Gujarat',
'Ekelbara,Vadodara West,Gujarat',
'Gametha,Vadodara West,Gujarat',
'Gavasad,Vadodara West,Gujarat',
'Ghayaj,Vadodara West,Gujarat',
'Goriyad,Vadodara West,Gujarat',
'Jalalpura,Vadodara West,Gujarat',
'Jaspura,Vadodara West,Gujarat',
'Kanda,Vadodara West,Gujarat',
'Karkhadi,Vadodara West,Gujarat',
'Kural,Vadodara West,Gujarat',
'Latipura,Vadodara West,Gujarat',
'Luna,Vadodara West,Gujarat',
'Mahmadpura,Vadodara West,Gujarat',
'Mahuvad,Vadodara West,Gujarat',
'Majatan,Vadodara West,Gujarat',
'Masar,Vadodara West,Gujarat',
'Masar Road,Vadodara West,Gujarat',
'Mobha,Vadodara West,Gujarat',
'Mobha Road,Vadodara West,Gujarat',
'Mujpur,Vadodara West,Gujarat',
'Muval,Vadodara West,Gujarat',
'Narshihpura,Vadodara West,Gujarat',
'Padra,Vadodara West,Gujarat',
'Pindappa,Vadodara West,Gujarat',
'Pipli,Vadodara West,Gujarat',
'Rajupura,Vadodara West,Gujarat',
'Ranu,Vadodara West,Gujarat',
'Sadra,Vadodara West,Gujarat',
'Sampla,Vadodara West,Gujarat',
'Sandha,Vadodara West,Gujarat',
'Sangma,Vadodara West,Gujarat',
'Sanpur,Vadodara West,Gujarat',
'Sarasavani,Vadodara West,Gujarat',
'Sejakuva,Vadodara West,Gujarat',
'Sihora,Vadodara West,Gujarat',
'Sokhdaradhu,Vadodara West,Gujarat',
'Tajpura,Vadodara West,Gujarat',
'Tithor,Vadodara West,Gujarat',
'Umaraya,Vadodara West,Gujarat',
'Vadadla,Vadodara West,Gujarat',
'Vadu,Vadodara West,Gujarat',
'Vanchhara,Vadodara West,Gujarat',
'Virpur,Vadodara West,Gujarat',
'Vistar,Vadodara West,Gujarat',
'Aniyadri,Vadodara East,Gujarat',
'Athavali,Vadodara East,Gujarat',
'Bar,Vadodara East,Gujarat',
'Baravad,Vadodara East,Gujarat',
'Bhanpur,Vadodara East,Gujarat',
'Bhensavali,Vadodara East,Gujarat',
'Bhikhapur,Vadodara East,Gujarat',
'Bhilpur,Vadodara East,Gujarat',
'Bhindol,Vadodara East,Gujarat',
'Bordha,Vadodara East,Gujarat',
'Chalamali,Vadodara East,Gujarat',
'Chhatrali,Vadodara East,Gujarat',
'Chudel,Vadodara East,Gujarat',
'Devalia,Vadodara East,Gujarat',
'Dumali,Vadodara East,Gujarat',
'Dungarvant,Vadodara East,Gujarat',
'Ferkuva,Vadodara East,Gujarat',
'Harakhapur,Vadodara East,Gujarat',
'Jabugam,Vadodara East,Gujarat',
'Jaloda,Vadodara East,Gujarat',
'Jamba,Vadodara East,Gujarat',
'Kadachhala,Vadodara East,Gujarat',
'Kadvad,Vadodara East,Gujarat',
'Kalarani,Vadodara East,Gujarat',
'Kalidoli,Vadodara East,Gujarat',
'Kanda,Vadodara East,Gujarat',
'Karali,Vadodara East,Gujarat',
'Kikavada,Vadodara East,Gujarat',
'Kohivav,Vadodara East,Gujarat',
'Moradungari,Vadodara East,Gujarat',
'Moti Amroli,Vadodara East,Gujarat',
'Moti Beg,Vadodara East,Gujarat',
'Moti Rasli,Vadodara East,Gujarat',
'Motibumadi,Vadodara East,Gujarat',
'Muldhar,Vadodara East,Gujarat',
'Muvada,Vadodara East,Gujarat',
'Nana Amadara,Vadodara East,Gujarat',
'Palsanda,Vadodara East,Gujarat',
'Pandhara,Vadodara East,Gujarat',
'Panej,Vadodara East,Gujarat',
'Pani,Vadodara East,Gujarat',
'Pavijetpur,Vadodara East,Gujarat',
'Rajbodeli,Vadodara East,Gujarat',
'Ratanpur,Vadodara East,Gujarat',
'Saloj,Vadodara East,Gujarat',
'Sankhandra,Vadodara East,Gujarat',
'Sargi,Vadodara East,Gujarat',
'Segwa Simli,Vadodara East,Gujarat',
'Sejwa,Vadodara East,Gujarat',
'Tadkachhla,Vadodara East,Gujarat',
'Uchapan,Vadodara East,Gujarat',
'Umarva,Vadodara East,Gujarat',
'Valothi,Vadodara East,Gujarat',
'Vanta,Vadodara East,Gujarat',
'Vasna,Vadodara East,Gujarat',
'Waghva,Vadodara East,Gujarat',
'Raisingpura,Vadodara East,Gujarat',
'Akakheda,Vadodara East,Gujarat',
'Alhadpura,Vadodara East,Gujarat',
'Ambapura,Vadodara East,Gujarat',
'Anandpura,Vadodara West,Gujarat',
'Bahadarpur,Vadodara East,Gujarat',
'Bamroli,Vadodara East,Gujarat',
'Bangapura,Vadodara East,Gujarat',
'Bhatpur,Vadodara East,Gujarat',
'Bortalav,Vadodara East,Gujarat',
'Chhuchhapura,Vadodara East,Gujarat',
'Chorngala,Vadodara East,Gujarat',
'Deroli,Vadodara East,Gujarat',
'Dormar,Vadodara East,Gujarat',
'Fanta,Vadodara East,Gujarat',
'Garda,Vadodara East,Gujarat',
'Ghantoli,Vadodara East,Gujarat',
'Gola Gamdi,Vadodara East,Gujarat',
'Gundicha,Vadodara East,Gujarat',
'Handod,Vadodara East,Gujarat',
'Hareshwar,Vadodara East,Gujarat',
'Indral,Vadodara East,Gujarat',
'Jojwa R.S.,Vadodara East,Gujarat',
'Kahndia,Vadodara West,Gujarat',
'Kaledia,Vadodara East,Gujarat',
'Kanteshwar,Vadodara East,Gujarat',
'Kasumbia,Vadodara West,Gujarat',
'Kavitha,Vadodara East,Gujarat',
'Khunvad,Vadodara East,Gujarat',
'Kosindra,Vadodara East,Gujarat',
'Kuvarpura,Vadodara West,Gujarat',
'Lachharas,Vadodara East,Gujarat',
'Ladod,Vadodara East,Gujarat',
'Lotia,Vadodara East,Gujarat',
'Makni,Vadodara East,Gujarat',
'Malpur,Vadodara East,Gujarat',
'Malu,Vadodara West,Gujarat',
'Modasar,Vadodara East,Gujarat',
'Morakhala,Vadodara East,Gujarat',
'Nandpur,Vadodara East,Gujarat',
'Navapura,Vadodara East,Gujarat',
'Picchuwada,Vadodara East,Gujarat',
'Pipalsat,Vadodara East,Gujarat',
'Rampura,Vadodara East,Gujarat',
'Ratanpura,Vadodara East,Gujarat',
'Sankheda,Vadodara East,Gujarat',
'Sarsinda,Vadodara East,Gujarat',
'Sunderpura,Vadodara East,Gujarat',
'Tandalja,Vadodara East,Gujarat',
'Targol,Vadodara East,Gujarat',
'Timba,Vadodara East,Gujarat',
'Totarmata,Vadodara East,Gujarat',
'Vadeli,Vadodara East,Gujarat',
'Vaniadri,Vadodara East,Gujarat',
'Vasan Sevada,Vadodara East,Gujarat',
'Wandarda,Vadodara West,Gujarat',
'Anjesar,Vadodara West,Gujarat',
'Bahutha,Vadodara West,Gujarat',
'Bhadarwa,Vadodara West,Gujarat',
'Champaner Road,Vadodara West,Gujarat',
'Chandranagar,Vadodara West,Gujarat',
'Chhaliar,Vadodara West,Gujarat',
'Dajipura,Vadodara West,Gujarat',
'Desar,Vadodara West,Gujarat',
'Dhanora,Vadodara West,Gujarat',
'Dhantej,Vadodara West,Gujarat',
'Gangadia,Vadodara West,Gujarat',
'Gardhia,Vadodara West,Gujarat',
'Ghantiyal,Vadodara West,Gujarat',
'Gothda,Vadodara West,Gujarat',
'Himmatpura,Vadodara West,Gujarat',
'Indrad,Vadodara West,Gujarat',
'Itwad,Vadodara West,Gujarat',
'Jambugoral,Vadodara West,Gujarat',
'Juna Samlaya,Vadodara West,Gujarat',
'Kadchhala,Vadodara West,Gujarat',
'Kamalpura,Vadodara West,Gujarat',
'Karchia,Vadodara West,Gujarat',
'Khakharia,Vadodara West,Gujarat',
'Lamdapura,Vadodara West,Gujarat',
'Lanchanpura,Vadodara West,Gujarat',
'Latwa,Vadodara West,Gujarat',
'Limdi,Vadodara West,Gujarat',
'Manjusar,Vadodara West,Gujarat',
'Merakuva,Vadodara West,Gujarat',
'Mevli,Vadodara West,Gujarat',
'Mokshi,Vadodara West,Gujarat',
'Motipura,Vadodara West,Gujarat',
'Motivarnoli,Vadodara West,Gujarat',
'Mudhela,Vadodara West,Gujarat',
'Muval,Vadodara West,Gujarat',
'Nahra,Vadodara West,Gujarat',
'Namisara,Vadodara West,Gujarat',
'Nani Bhadol,Vadodara West,Gujarat',
'Narpura,Vadodara West,Gujarat',
'Natwar Nagar,Vadodara West,Gujarat',
'Pandu,Vadodara West,Gujarat',
'Pasva,Vadodara West,Gujarat',
'Pilol,Vadodara West,Gujarat',
'Pipalchhat,Vadodara West,Gujarat',
'Poicha,Vadodara West,Gujarat',
'Poicha,Vadodara West,Gujarat',
'Pratappura,Vadodara West,Gujarat',
'Prathampura,Vadodara West,Gujarat',
'Prathampura,Vadodara West,Gujarat',
'Rajupura,Vadodara West,Gujarat',
'Rania,Vadodara West,Gujarat',
'Raniapura,Vadodara West,Gujarat',
'Ranjit Nagar,Vadodara West,Gujarat',
'Rasulpur,Vadodara West,Gujarat',
'Sadra,Vadodara West,Gujarat',
'Samlaya R S,Vadodara West,Gujarat',
'Sandasal,Vadodara West,Gujarat',
'Savli,Vadodara West,Gujarat',
'Sihora,Vadodara West,Gujarat',
'Subhelav,Vadodara West,Gujarat',
'Tulsipura,Vadodara West,Gujarat',
'Tundav,Vadodara West,Gujarat',
'Vachhesar,Panchmahals,Gujarat',
'Vadia,Vadodara West,Gujarat',
'Vakaner,Vadodara West,Gujarat',
'Vaktapura,Vadodara West,Gujarat',
'Valavav,Vadodara West,Gujarat',
'Vankaneda,Vadodara West,Gujarat',
'Varsada,Vadodara West,Gujarat',
'Vasanpura,Vadodara West,Gujarat',
'Vasia,Vadodara West,Gujarat',
'Vejpur,Vadodara West,Gujarat',
'Vemar,Vadodara West,Gujarat',
'Vintoz,Vadodara West,Gujarat',
'Sevasi,Vadodara West,Gujarat',
'Achisara,Vadodara East,Gujarat',
'Anandi,Vadodara East,Gujarat',
'Barkal,Vadodara East,Gujarat',
'Bithli,Vadodara East,Gujarat',
'Chhanbhoi,Vadodara East,Gujarat',
'Mota Karala,Vadodara East,Gujarat',
'Nana Karala,Vadodara East,Gujarat',
'Puniad,Vadodara East,Gujarat',
'Sagwa,Vadodara East,Gujarat',
'Sanor,Vadodara East,Gujarat',
'Sinor,Vadodara West,Gujarat',
'Vaniad,Vadodara East,Gujarat',
'Zanzad,Vadodara West,Gujarat',
'Agar,Vadodara East,Gujarat',
'Ajod,Vadodara West,Gujarat',
'Ajwa Road,Vadodara East,Gujarat',
'Akota,Vadodara West,Gujarat',
'Alkapuri,Vadodara West,Gujarat',
'Amaliyara,Vadodara East,Gujarat',
'Amodar,Vadodara East,Gujarat',
'Ampad,Vadodara West,Gujarat',
'Angadh,Vadodara West,Gujarat',
'Ankhol,Vadodara East,Gujarat',
'Ankodia,Vadodara West,Gujarat',
'Asoj,Vadodara West,Gujarat',
'Atladara,Vadodara West,Gujarat',
'Bajwa,Vadodara West,Gujarat',
'Bakrol,Vadodara East,Gujarat',
'Baranpura,Vadodara East,Gujarat',
'Bhaily,Vadodara West,Gujarat',
'Bill,Vadodara West,Gujarat',
'Brahamanvashi,Vadodara West,Gujarat',
'Chapad,Vadodara West,Gujarat',
'Chemical Industries,Vadodara West,Gujarat',
'Chhani Rd,Vadodara West,Gujarat',
'Chhani,Vadodara West,Gujarat',
'Chikhodara,Vadodara East,Gujarat',
'Danteshwar,Vadodara East,Gujarat',
'Dashrath,Vadodara West,Gujarat',
'Dhaniavi,Vadodara East,Gujarat',
'Dodka,Vadodara West,Gujarat',
'Dumad,Vadodara West,Gujarat',
'Eme,Vadodara West,Gujarat',
'Fartilizer Nagar,Vadodara West,Gujarat',
'Fateganj H.O,Vadodara West,Gujarat',
'Fatepura,Vadodara East,Gujarat',
'Fazalpur,Vadodara West,Gujarat',
'Geb,Vadodara West,Gujarat',
'Gorwa,Vadodara West,Gujarat',
'Gosindra,Vadodara West,Gujarat',
'Gotri,Vadodara West,Gujarat',
'Harni Colony,Vadodara East,Gujarat',
'Industrial Estate,Vadodara West,Gujarat',
'Itola,Vadodara West,Gujarat',
'Itola R.S.,Vadodara West,Gujarat',
'Jambuva,Vadodara East,Gujarat',
'Jawahar Nagar,Vadodara West,Gujarat',
'Kalali,Vadodara West,Gujarat',
'Kapurai,Vadodara East,Gujarat',
'Karelibaug,Vadodara East,Gujarat',
'Karodia,Vadodara West,Gujarat',
'Kelanpur,Vadodara East,Gujarat',
'Khanderao Market,Vadodara East,Gujarat',
'Kotna,Vadodara West,Gujarat',
'Koyali,Vadodara West,Gujarat',
'Kumetha,Vadodara East,Gujarat',
'M.I. Estate,Vadodara East,Gujarat',
'Madanzampa,Vadodara East,Gujarat',
'Makarpura,Vadodara East,Gujarat',
'Mandvi,Vadodara East,Gujarat',
'Maneja,Vadodara East,Gujarat',
'Manjalpur,Vadodara East,Gujarat',
'Nandesari,Vadodara West,Gujarat',
'Nandesari Ind. Estate,Vadodara West,Gujarat',
'Nimetha,Vadodara East,Gujarat',
'Ongc Col,Vadodara East,Gujarat',
'Padmala,Vadodara West,Gujarat',
'Patarveni,Vadodara West,Gujarat',
'Petrochemical T Ship,Vadodara West,Gujarat',
'Petrochemical,Vadodara West,Gujarat',
'Por,Vadodara West,Gujarat',
'Pratapganj,Vadodara West,Gujarat',
'Pratapnagar R.S.,Vadodara East,Gujarat',
'Pratapnagar,Vadodara East,Gujarat',
'Racecourse,Vadodara West,Gujarat',
'Raika,Vadodara West,Gujarat',
'Raipura,Vadodara West,Gujarat',
'Ramnath,Vadodara West,Gujarat',
'Ranoli,Vadodara West,Gujarat',
'Ruvand,Vadodara West,Gujarat',
'Saiyed Vasna,Vadodara West,Gujarat',
'Sama,Vadodara West,Gujarat',
'Samiyala,Vadodara West,Gujarat',
'Samsabad,Vadodara East,Gujarat',
'Sankarda,Vadodara West,Gujarat',
'Santkawnar Colony,Vadodara East,Gujarat',
'Sarar,Vadodara West,Gujarat',
'Sayajiganj,Vadodara West,Gujarat',
'Sayajipura,Vadodara East,Gujarat',
'Shahpura,Vadodara West,Gujarat',
'Sharadnagar,Vadodara East,Gujarat',
'Sherkhi,Vadodara West,Gujarat',
'Sindhrot,Vadodara West,Gujarat',
'Sisva,Vadodara West,Gujarat',
'Sokhda,Vadodara West,Gujarat',
'SRP Group I,Vadodara East,Gujarat',
'Subhanpura,Vadodara West,Gujarat',
'Sundarpura,Vadodara West,Gujarat',
'T B Sanatorium,Vadodara West,Gujarat',
'Tandalja,Vadodara West,Gujarat',
'Tarsali,Vadodara East,Gujarat',
'Tatarpura,Vadodara East,Gujarat',
'Undera,Vadodara West,Gujarat',
'Vadodara H.O,Vadodara East,Gujarat',
'Vadsala,Vadodara West,Gujarat',
'Vadsar,Vadodara East,Gujarat',
'Varnama,Vadodara West,Gujarat',
'Vasna Kotaria,Vadodara West,Gujarat',
'Vidhyut Nagar Colony,Vadodara West,Gujarat',
'Virod,Vadodara East,Gujarat',
'Wadi S.N. Road,Vadodara East,Gujarat',
'Waghodia Road,Vadodara East,Gujarat',
'Adiran,Vadodara West,Gujarat',
'Ajwa Compound,Vadodara West,Gujarat',
'Alva,Vadodara West,Gujarat',
'Ambali,Vadodara West,Gujarat',
'Antoli,Vadodara West,Gujarat',
'Asoj,Vadodara West,Gujarat',
'Bhaniara,Vadodara West,Gujarat',
'Chipad,Vadodara West,Gujarat',
'Gabhirpura,Vadodara West,Gujarat',
'Ganeshpura,Vadodara West,Gujarat',
'Ganpatpura,Vadodara West,Gujarat',
'Ghodadara,Vadodara West,Gujarat',
'Goraj,Vadodara West,Gujarat',
'Gutal,Vadodara West,Gujarat',
'Jarod,Vadodara West,Gujarat',
'Kamrol,Vadodara West,Gujarat',
'Karmaliyapura,Vadodara West,Gujarat',
'Khanda,Vadodara West,Gujarat',
'Kheda Karmasiya,Vadodara West,Gujarat',
'Khervadi,Vadodara West,Gujarat',
'Kotambi,Vadodara West,Gujarat',
'Kuvarvada,Vadodara West,Gujarat',
'Lilora,Vadodara West,Gujarat',
'Limda,Vadodara West,Gujarat',
'Madheli,Vadodara West,Gujarat',
'Motimanekpur,Vadodara West,Gujarat',
'Navagam,Vadodara West,Gujarat',
'Panchdevla,Vadodara West,Gujarat',
'Pipalia,Vadodara West,Gujarat',
'Rahkui,Vadodara West,Gujarat',
'Rajpura,Vadodara West,Gujarat',
'Rasulabad,Vadodara West,Gujarat',
'Raval,Vadodara West,Gujarat',
'Remeshwarpura,Vadodara West,Gujarat',
'Rustampura,Vadodara West,Gujarat',
'Saidal,Vadodara West,Gujarat',
'Sangadol,Vadodara West,Gujarat',
'Sarnej,Vadodara West,Gujarat',
'Vaghodia,Vadodara West,Gujarat',
'Vasvel,Vadodara West,Gujarat',
'Vedpur,Vadodara West,Gujarat',
'Vejalpura,Vadodara West,Gujarat',
'Vesania,Vadodara West,Gujarat',
'Vyankatpura,Vadodara West,Gujarat',
'Vyara Antoli,Vadodara West,Gujarat',
'Valva,Vadodara West,Gujarat',
'Falod,Vadodara West,Gujarat',
'Junarampura,Vadodara West,Gujarat',
'Karchiya,Vadodara West,Gujarat',
'Dhodipada,Valsad,Gujarat',
'Fanaswada,Valsad,Gujarat',
'Sarai,Valsad,Gujarat',
'Saronda,Valsad,Gujarat',
'Tadgam,Valsad,Gujarat',
'Athal,Valsad,Gujarat',
'Kachigam,Valsad,Gujarat',
'Kharadpada,Valsad,Gujarat',
'Lavachha,Valsad,Gujarat',
'Moti Tambadi,Valsad,Gujarat',
'Nani Tambadi,Valsad,Gujarat',
'Amba Talat,Valsad,Gujarat',
'Asura,Valsad,Gujarat',
'Avdha,Valsad,Gujarat',
'Bamti,Valsad,Gujarat',
'Baroliya,Valsad,Gujarat',
'Barsol,Valsad,Gujarat',
'Barumal,Valsad,Gujarat',
'Bhambha,Valsad,Gujarat',
'Bhavthan Ambosi,Valsad,Gujarat',
'Bhensdara,Valsad,Gujarat',
'Bildha,Valsad,Gujarat',
'Bilpudi,Valsad,Gujarat',
'Bopi,Valsad,Gujarat',
'Chichozar,Valsad,Gujarat',
'Deli,Valsad,Gujarat',
'Dhamani,Valsad,Gujarat',
'Dharampur,Valsad,Gujarat',
'Gadi,Valsad,Gujarat',
'Gundia,Valsad,Gujarat',
'Hanumatmal,Valsad,Gujarat',
'Jamalia,Valsad,Gujarat',
'Kakadkuva,Valsad,Gujarat',
'Kangvi,Valsad,Gujarat',
'Kaprada,Valsad,Gujarat',
'Karanjveri,Valsad,Gujarat',
'Khanda,Valsad,Gujarat',
'Kharvel,Valsad,Gujarat',
'Khatana,Valsad,Gujarat',
'Kosamkuwa,Valsad,Gujarat',
'Kurgam,Valsad,Gujarat',
'Manaichondi,Valsad,Gujarat',
'Meghval,Valsad,Gujarat',
'Mohpada,Valsad,Gujarat',
'Murdad,Valsad,Gujarat',
'Nadagdhari,Valsad,Gujarat',
'Nanapondha,Valsad,Gujarat',
'Nani Dholdungri,Valsad,Gujarat',
'Nanivahiyal,Valsad,Gujarat',
'Pindval,Valsad,Gujarat',
'Rajpur Talat,Valsad,Gujarat',
'Sidumber,Valsad,Gujarat',
'Tiskari,Valsad,Gujarat',
'Ukta,Valsad,Gujarat',
'Veribhavada,Valsad,Gujarat',
'Virval,Valsad,Gujarat',
'Makadban,Valsad,Gujarat',
'Dungri,Valsad,Gujarat',
'Hanuman Bhagda,Valsad,Gujarat',
'Amba Jungle,Valsad,Gujarat',
'Amdha,Valsad,Gujarat',
'Arnai,Valsad,Gujarat',
'Aslona,Valsad,Gujarat',
'Astol,Valsad,Gujarat',
'Babarkhadak,Valsad,Gujarat',
'Balohondi,Valsad,Gujarat',
'Barpuda,Valsad,Gujarat',
'Burla,Valsad,Gujarat',
'Chandvegan,Valsad,Gujarat',
'Chavshala,Valsad,Gujarat',
'Chepa,Valsad,Gujarat',
'Dabkhal,Valsad,Gujarat',
'Dhodhadkuva,Valsad,Gujarat',
'Divsi,Valsad,Gujarat',
'Ghanveri,Valsad,Gujarat',
'Ghotan,Valsad,Gujarat',
'Girnala,Valsad,Gujarat',
'Jirval,Valsad,Gujarat',
'Jogvel,Valsad,Gujarat',
'Kakadkopar,Valsad,Gujarat',
'Khadakwal,Valsad,Gujarat',
'Mandva,Valsad,Gujarat',
'Moti Vahiyal,Valsad,Gujarat',
'Ozarda,Valsad,Gujarat',
'Panas,Valsad,Gujarat',
'Sahuda,Valsad,Gujarat',
'Shildha,Valsad,Gujarat',
'Sukhala,Valsad,Gujarat',
'Vadoli,Valsad,Gujarat',
'Varna,Valsad,Gujarat',
'Varoli Talat,Valsad,Gujarat',
'Varvath,Valsad,Gujarat',
'Virakset,Valsad,Gujarat',
'Dholai Falia,Valsad,Gujarat',
'Ambach (Paria),Valsad,Gujarat',
'Ambheti,Valsad,Gujarat',
'Amli,Valsad,Gujarat',
'Asma,Valsad,Gujarat',
'Bagwada,Valsad,Gujarat',
'Balda,Valsad,Gujarat',
'Balitha,Valsad,Gujarat',
'Barai,Valsad,Gujarat',
'Chala,Valsad,Gujarat',
'Chandor,Valsad,Gujarat',
'Chanod Md,Valsad,Gujarat',
'Chhiri,Valsad,Gujarat',
'Chival,Valsad,Gujarat',
'Dumlav,Valsad,Gujarat',
'Dungri (Udava RS),Valsad,Gujarat',
'Goima,Valsad,Gujarat',
'Kalsar,Valsad,Gujarat',
'Karaya,Valsad,Gujarat',
'Khadki,Valsad,Gujarat',
'Kherlav,Valsad,Gujarat',
'Killa Pardi,Valsad,Gujarat',
'Kolak,Valsad,Gujarat',
'Koparli,Valsad,Gujarat',
'Kumbharia,Valsad,Gujarat',
'Machhiwad,Valsad,Gujarat',
'Morai,Valsad,Gujarat',
'Mota Pondha,Valsad,Gujarat',
'Namdha,Valsad,Gujarat',
'Nevri,Valsad,Gujarat',
'Ozar,Valsad,Gujarat',
'Pachlai,Valsad,Gujarat',
'Palsana Pardi,Valsad,Gujarat',
'Pandor,Valsad,Gujarat',
'Pardi Paria,Valsad,Gujarat',
'Pardi R.S.,Valsad,Gujarat',
'Parwasa,Valsad,Gujarat',
'Patel Faliya,Valsad,Gujarat',
'Rata,Valsad,Gujarat',
'Rohina,Valsad,Gujarat',
'Salvav,Valsad,Gujarat',
'Samarpada,Valsad,Gujarat',
'Sarodhi,Valsad,Gujarat',
'Sondhal Wada,Valsad,Gujarat',
'Sonwada,Valsad,Gujarat',
'Sukesh,Valsad,Gujarat',
'Sukhlav,Valsad,Gujarat',
'Tarmalia,Valsad,Gujarat',
'Tukwada,Valsad,Gujarat',
'Udvada R.S.,Valsad,Gujarat',
'Udvada,Valsad,Gujarat',
'Umarsadi,Valsad,Gujarat',
'Vaghchhipa,Valsad,Gujarat',
'Vapi I.E.,Valsad,Gujarat',
'Vapi,Valsad,Gujarat',
'Vatar,Valsad,Gujarat',
'Velparwa,Valsad,Gujarat',
'Achhari,Valsad,Gujarat',
'Angam,Valsad,Gujarat',
'Anklash,Valsad,Gujarat',
'Bhathi Karmbeli,Valsad,Gujarat',
'Bhilad,Valsad,Gujarat',
'Borigam,Valsad,Gujarat',
'Borlai,Valsad,Gujarat',
'Dehli,Valsad,Gujarat',
'Dehri,Valsad,Gujarat',
'Dhanoli,Valsad,Gujarat',
'Gowada,Valsad,Gujarat',
'Jamburi,Valsad,Gujarat',
'Kalai,Valsad,Gujarat',
'Kalgam,Valsad,Gujarat',
'Kanadu,Valsad,Gujarat',
'Karajgam,Valsad,Gujarat',
'Karambeli,Valsad,Gujarat',
'Karambeli R.S.,Valsad,Gujarat',
'Khatalwada,Valsad,Gujarat',
'Malav,Valsad,Gujarat',
'Manda,Valsad,Gujarat',
'Maroli Sanjan,Valsad,Gujarat',
'Mohan,Valsad,Gujarat',
'Nagvas,Valsad,Gujarat',
'Nahuli,Valsad,Gujarat',
'Nandigam,Valsad,Gujarat',
'Nargol,Valsad,Gujarat',
'Palgam,Valsad,Gujarat',
'Pali,Valsad,Gujarat',
'Punat,Valsad,Gujarat',
'Sanjan,Valsad,Gujarat',
'Sarigam,Valsad,Gujarat',
'Solsumba,Valsad,Gujarat',
'Tembhi,Valsad,Gujarat',
'Tumb,Valsad,Gujarat',
'Umargam I.E.,Valsad,Gujarat',
'Umargam,Valsad,Gujarat',
'Valvada,Valsad,Gujarat',
'Vankas,Valsad,Gujarat',
'Zaroli,Valsad,Gujarat',
'Phansa,Valsad,Gujarat',
'Anjlav,Valsad,Gujarat',
'Atak Pardi,Valsad,Gujarat',
'Atgam,Valsad,Gujarat',
'Atul,Valsad,Gujarat',
'Bhadeli,Valsad,Gujarat',
'Bhadeli Jagalala,Valsad,Gujarat',
'Bhagal,Valsad,Gujarat',
'Bhagod,Valsad,Gujarat',
'Bhutsar,Valsad,Gujarat',
'Binwada,Valsad,Gujarat',
'Bodlai,Valsad,Gujarat',
'Chanvai,Valsad,Gujarat',
'Chharwada,Valsad,Gujarat',
'Dhanori,Valsad,Gujarat',
'Dharasana,Valsad,Gujarat',
'Dived,Valsad,Gujarat',
'Dulsad,Valsad,Gujarat',
'Endergota,Valsad,Gujarat',
'Faldhara,Valsad,Gujarat',
'Gadaria,Valsad,Gujarat',
'Gorgam,Valsad,Gujarat',
'Haria,Valsad,Gujarat',
'Jesia,Valsad,Gujarat',
'Jespore,Valsad,Gujarat',
'Jujwa,Valsad,Gujarat',
'Kachigam,Valsad,Gujarat',
'Kakadmati,Valsad,Gujarat',
'Kakwadi,Valsad,Gujarat',
'Kalwada,Valsad,Gujarat',
'Kamparia,Valsad,Gujarat',
'Kanjan Hari,Valsad,Gujarat',
'Kanjan Ranchhod,Valsad,Gujarat',
'Kosamba (Valsad),Valsad,Gujarat',
'Kundi,Valsad,Gujarat',
'Lilapore,Valsad,Gujarat',
'Magod,Valsad,Gujarat',
'Magod Dungri,Valsad,Gujarat',
'Malvan,Valsad,Gujarat',
'Manekpore,Valsad,Gujarat',
'Marla,Valsad,Gujarat',
'Meh,Valsad,Gujarat',
'Muli,Valsad,Gujarat',
'Navera,Valsad,Gujarat',
'Ozar,Valsad,Gujarat',
'Parnera (Urban),Valsad,Gujarat',
'Parnera Pardi,Valsad,Gujarat',
'Pitha,Valsad,Gujarat',
'Rabda,Valsad,Gujarat',
'Rola,Valsad,Gujarat',
'Ronvel,Valsad,Gujarat',
'Sanjan Bandar,Valsad,Gujarat',
'Segva,Valsad,Gujarat',
'Segvi,Valsad,Gujarat',
'Shankar Talav,Valsad,Gujarat',
'Sonwada,Valsad,Gujarat',
'Surwada,Valsad,Gujarat',
'Tighasa,Valsad,Gujarat',
'Untdi,Valsad,Gujarat',
'Vaghaldhara,Valsad,Gujarat',
'Valsad - Vankal,Valsad,Gujarat',
'Valsad Abrama,Valsad,Gujarat',
'Valsad Chhipwad,Valsad,Gujarat',
'Valsad H.O,Valsad,Gujarat',
'Valsad I.E.,Valsad,Gujarat',
'Valsad Mograwadi,Valsad,Gujarat',
'Valsad Mota Bazar,Valsad,Gujarat',
'Valsad Sugar Factory,Valsad,Gujarat',
'Vasan,Valsad,Gujarat',
'Velvach,Valsad,Gujarat',
'Khanpur,Valsad,Gujarat',
'Anklash,Valsad,Gujarat',
'Bartad,Valsad,Gujarat',
'Lakadbari,Valsad,Gujarat',
'Satimal,Valsad,Gujarat',
'Derasalimpur,Ambala,Haryana',
'A.K. Line,Ambala,Haryana',
'Adhoya,Ambala,Haryana',
'Adhoyi,Ambala,Haryana',
'Alipur Jahangir,Ambala,Haryana',
'Ambala City H.O,Ambala,Haryana',
'Ambala G.P.O.,Ambala,Haryana',
'Auto Industries,Ambala,Haryana',
'Babyal,Ambala,Haryana',
'Baknaur,Ambala,Haryana',
'Ballana,Ambala,Haryana',
'Bara,Ambala,Haryana',
'Barara,Ambala,Haryana',
'Baraula,Ambala,Haryana',
'Bhanokheri,Ambala,Haryana',
'Bhareli,Ambala,Haryana',
'Bhojkoti,Ambala,Haryana',
'Bihta,Ambala,Haryana',
'Boh,Ambala,Haryana',
'Chaurmastpur,Ambala,Haryana',
'Chudiala,Ambala,Haryana',
'Commissioner Court,Ambala,Haryana',
'Danipur,Ambala,Haryana',
'Dhanana,Ambala,Haryana',
'Dhanaura,Ambala,Haryana',
'Dhankaur,Ambala,Haryana',
'Dhin,Ambala,Haryana',
'Dhulkot,Ambala,Haryana',
'Dhurkara,Ambala,Haryana',
'Dinarpur,Ambala,Haryana',
'Dukheri,Ambala,Haryana',
'Duliani,Ambala,Haryana',
'Durana,Ambala,Haryana',
'Fatehgarh,Ambala,Haryana',
'Ghail,Ambala,Haryana',
'Gobind Nagar,Ambala,Haryana',
'Gokal Garh,Ambala,Haryana',
'Hargolal,Ambala,Haryana',
'Holi,Ambala,Haryana',
'I.A.F.Line,Ambala,Haryana',
'Ind-estate,Ambala,Haryana',
'Jalbera,Ambala,Haryana',
'Jansui,Ambala,Haryana',
'Kacha Bazar,Ambala,Haryana',
'Kakroo,Ambala,Haryana',
'Kalarehri,Ambala,Haryana',
'Kalpi,Ambala,Haryana',
'Kambassi,Ambala,Haryana',
'Kanwala,Ambala,Haryana',
'Kaserla Kalan,Ambala,Haryana',
'Kathgarh Chhappar,Ambala,Haryana',
'Keshopur Samalkha,Ambala,Haryana',
'Kesri,Ambala,Haryana',
'Khanpur,Ambala,Haryana',
'Khanpur Brahmana,Ambala,Haryana',
'Kharanwali,Ambala,Haryana',
'Kharga Canteen,Ambala,Haryana',
'Khatauli,Ambala,Haryana',
'Khudda Kalan,Ambala,Haryana',
'Kot,Ambala,Haryana',
'Kuldeep Nagar,Ambala,Haryana',
'Landa,Ambala,Haryana',
'Mahesh Nagar,Ambala,Haryana',
'Mandhana,Ambala,Haryana',
'Mandhaur,Ambala,Haryana',
'Manka Manki,Ambala,Haryana',
'Manu Majra,Ambala,Haryana',
'Mardon Sahib,Ambala,Haryana',
'Matheri Sekhan,Ambala,Haryana',
'Mehmoodpur,Ambala,Haryana',
'Mohra,Ambala,Haryana',
'Mullana,Ambala,Haryana',
'Naggal,Ambala,Haryana',
'Nagla Jattan,Ambala,Haryana',
'Nahoni,Ambala,Haryana',
'Nasrauli,Ambala,Haryana',
'P&t Colony,Ambala,Haryana',
'Palam Vihar,Ambala,Haryana',
'Pasiala,Ambala,Haryana',
'Patwi,Ambala,Haryana',
'Pilkhani,Ambala,Haryana',
'Punjabi Mohalla,Ambala,Haryana',
'Rail Vihar,Ambala,Haryana',
'Rajo Kheri,Ambala,Haryana',
'Rajouli,Ambala,Haryana',
'Sadar Bazar,Ambala,Haryana',
'Saha,Ambala,Haryana',
'Samlerhi,Ambala,Haryana',
'Saran,Ambala,Haryana',
'Sarsehri,Ambala,Haryana',
'Saunta,Ambala,Haryana',
'Segti,Ambala,Haryana',
'Sewan Majra,Ambala,Haryana',
'Shah Pur,Ambala,Haryana',
'Sohana,Ambala,Haryana',
'Tandwal,Ambala,Haryana',
'Tandwal,Ambala,Haryana',
'Tepla,Ambala,Haryana',
'Thakar Pura,Ambala,Haryana',
'Tharwa,Ambala,Haryana',
'Thumber,Ambala,Haryana',
'Toda,Ambala,Haryana',
'Top Khana Bazar,Ambala,Haryana',
'Udaipur,Ambala,Haryana',
'Ugala,Ambala,Haryana',
'Ambala City Kucthery,Ambala,Haryana',
'Bazar Basti Ram,Ambala,Haryana',
'Jatwar,Ambala,Haryana',
'Morni,Ambala,Haryana',
'Naneola,Ambala,Haryana',
'Naraingarh,Ambala,Haryana',
'Panjokhra Sahib,Ambala,Haryana',
'Shahzadpur,Ambala,Haryana',
'Anaj Mandi,Ambala,Haryana',
'B.C.W. Suraj Pur,Ambala,Haryana',
'Baldev Nagar,Ambala,Haryana',
'Civil Line,Ambala,Haryana',
'D.A.V.College,Ambala,Haryana',
'Geeta Nagri,Ambala,Haryana',
'Model Town Ambala City,Ambala,Haryana',
'Motor Stand,Ambala,Haryana',
'Patel Nagri,Ambala,Haryana',
'Preet Nagar,Ambala,Haryana',
'Prem Nagar,Ambala,Haryana',
'Railway Road Ambala City,Ambala,Haryana',
'Subzi Mandi,Ambala,Haryana',
'Thendog,Ambala,Haryana',
'Akbarpur,Ambala,Haryana',
'Ambli,Ambala,Haryana',
'Bhareri Kalan,Ambala,Haryana',
'Gadhauli,Ambala,Haryana',
'Ganesh Pur,Ambala,Haryana',
'Garhi Kotaha,Ambala,Haryana',
'Hamidpur,Ambala,Haryana',
'Hangola,Ambala,Haryana',
'Haripur,Ambala,Haryana',
'Jeoli,Ambala,Haryana',
'Kakkar Majra,Ambala,Haryana',
'Kandiwala,Ambala,Haryana',
'Karasan,Ambala,Haryana',
'Kathe Majra,Ambala,Haryana',
'Korwa Khurd,Ambala,Haryana',
'Kurali,Ambala,Haryana',
'Laha,Ambala,Haryana',
'Lakhnaura,Ambala,Haryana',
'Lalpur,Ambala,Haryana',
'Manak Tabra,Ambala,Haryana',
'Panjlasa,Ambala,Haryana',
'Patrehri,Ambala,Haryana',
'Achina,Bhiwani,Haryana',
'Badhara,Bhiwani,Haryana',
'Baund,Bhiwani,Haryana',
'Barsi,Bhiwani,Haryana',
'Bawani Khera,Bhiwani,Haryana',
'Durjanpur,Bhiwani,Haryana',
'Jamalpur,Bhiwani,Haryana',
'Lohari Jatu,Bhiwani,Haryana',
'Mandhana,Bhiwani,Haryana',
'Milkpur,Bhiwani,Haryana',
'Pur,Bhiwani,Haryana',
'Siwara,Bhiwani,Haryana',
'Badesera,Bhiwani,Haryana',
'Bajina,Bhiwani,Haryana',
'Baliali,Bhiwani,Haryana',
'Bamla,Bhiwani,Haryana',
'Bapora,Bhiwani,Haryana',
'Bhaini Kungar,Bhiwani,Haryana',
'Bhangarh,Bhiwani,Haryana',
'Bhariwas,Bhiwani,Haryana',
'Bhera,Bhiwani,Haryana',
'Bhiwani H.O,Bhiwani,Haryana',
'Bhurtana,Bhiwani,Haryana',
'Bhushan,Bhiwani,Haryana',
'Biran,Bhiwani,Haryana',
'Birla Colony Bhiwani,Bhiwani,Haryana',
'Bseh Bhiwani,Bhiwani,Haryana',
'Bus Stand Bhiwani,Bhiwani,Haryana',
'Chandawas,Bhiwani,Haryana',
'Chang,Bhiwani,Haryana',
'Chappar Rangran,Bhiwani,Haryana',
'Dadam,Bhiwani,Haryana',
'Dandama,Bhiwani,Haryana',
'Dang,Bhiwani,Haryana',
'Daryapur,Bhiwani,Haryana',
'Devrala,Bhiwani,Haryana',
'Devsar,Bhiwani,Haryana',
'Dhabdhani,Bhiwani,Haryana',
'Dhana Ladan Pur,Bhiwani,Haryana',
'Dhanana,Bhiwani,Haryana',
'Dhani Mahu,Bhiwani,Haryana',
'Dhareru,Bhiwani,Haryana',
'Dhirana,Bhiwani,Haryana',
'Dinod,Bhiwani,Haryana',
'Dulheri,Bhiwani,Haryana',
'Fatehgarh Haryana,Bhiwani,Haryana',
'Garanpura Kalan,Bhiwani,Haryana',
'Golagarh,Bhiwani,Haryana',
'Golpura,Bhiwani,Haryana',
'Gujrani,Bhiwani,Haryana',
'Halu Bajar Bhiwani,Bhiwani,Haryana',
'Haluwas,Bhiwani,Haryana',
'Hetampura,Bhiwani,Haryana',
'Isharwal,Bhiwani,Haryana',
'Jalan Hospital Bhiwani,Bhiwani,Haryana',
'Jatai,Bhiwani,Haryana',
'Jhully,Bhiwani,Haryana',
'Jui Khurd,Bhiwani,Haryana',
'Kaila,Bhiwani,Haryana',
'Kairu,Bhiwani,Haryana',
'Kalinga,Bhiwani,Haryana',
'Kaunt,Bhiwani,Haryana',
'Khanak,Bhiwani,Haryana',
'Kharak Kalan,Bhiwani,Haryana',
'Kharkari Makhwan,Bhiwani,Haryana',
'Kharkhari Sohan,Bhiwani,Haryana',
'Kirawar,Bhiwani,Haryana',
'Kitlana,Bhiwani,Haryana',
'Kohar,Bhiwani,Haryana',
'Kungar,Bhiwani,Haryana',
'Kusumbhi,Bhiwani,Haryana',
'Leghan,Bhiwani,Haryana',
'Lohani,Bhiwani,Haryana',
'Lohar Bazar,Bhiwani,Haryana',
'Mandhan,Bhiwani,Haryana',
'Mandholi Kalan,Bhiwani,Haryana',
'Mansarbass,Bhiwani,Haryana',
'Mini Sect Bhiwani,Bhiwani,Haryana',
'Mitathal,Bhiwani,Haryana',
'Neemriwali,Bhiwani,Haryana',
'Paluwas,Bhiwani,Haryana',
'Paposa,Bhiwani,Haryana',
'Pohkarwas,Bhiwani,Haryana',
'Premnagar,Bhiwani,Haryana',
'Rajgarh,Bhiwani,Haryana',
'Ratera,Bhiwani,Haryana',
'Rewari Khera,Bhiwani,Haryana',
'Riwasa,Bhiwani,Haryana',
'Rodhan,Bhiwani,Haryana',
'Rohnat,Bhiwani,Haryana',
'Roopgarh,Bhiwani,Haryana',
'Sagban,Bhiwani,Haryana',
'Sai,Bhiwani,Haryana',
'Sandawa,Bhiwani,Haryana',
'Sanga,Bhiwani,Haryana',
'Siwana,Bhiwani,Haryana',
'Sui,Bhiwani,Haryana',
'Sungarpur,Bhiwani,Haryana',
'Talu,Bhiwani,Haryana',
'Thilod,Bhiwani,Haryana',
'Tigrana,Bhiwani,Haryana',
'Tosham,Bhiwani,Haryana',
'Umarwas,Bhiwani,Haryana',
'Asalwas Marheta,Bhiwani,Haryana',
'Nandgaon,Bhiwani,Haryana',
'Aun,Bhiwani,Haryana',
'Badhawana,Bhiwani,Haryana',
'Birhi Kalan,Bhiwani,Haryana',
'Chandeni,Bhiwani,Haryana',
'Charkhi Dadri Hsg-ii,Bhiwani,Haryana',
'Charkhi,Bhiwani,Haryana',
'Charkhi Dadri City,Bhiwani,Haryana',
'Dhadhi Adampur,Bhiwani,Haryana',
'Dhadhi Mandola,Bhiwani,Haryana',
'Dhani Phogat,Bhiwani,Haryana',
'Ghasola,Bhiwani,Haryana',
'Gudana Kalan,Bhiwani,Haryana',
'Imlota,Bhiwani,Haryana',
'Janta College Charkhi Dadri,Bhiwani,Haryana',
'Jawa,Bhiwani,Haryana',
'Jhojhu,Bhiwani,Haryana',
'Kalyana,Bhiwani,Haryana',
'Kheri Bura,Bhiwani,Haryana',
'Manheru,Bhiwani,Haryana',
'Mankawas,Bhiwani,Haryana',
'Misri,Bhiwani,Haryana',
'Naurangabass Jattan,Bhiwani,Haryana',
'Neemli,Bhiwani,Haryana',
'Paitawas Kalan,Bhiwani,Haryana',
'Palari,Bhiwani,Haryana',
'Pichopa Kalan,Bhiwani,Haryana',
'Rambass,Bhiwani,Haryana',
'Ranila,Bhiwani,Haryana',
'Rawaldhi,Bhiwani,Haryana',
'Samaspur,Bhiwani,Haryana',
'Sanjarwas,Bhiwani,Haryana',
'Sankror,Bhiwani,Haryana',
'Sanwar,Bhiwani,Haryana',
'Sarupgarh,Bhiwani,Haryana',
'Chiriya,Bhiwani,Haryana',
'Chang Road,Bhiwani,Haryana',
'Arya Nagar,Bhiwani,Haryana',
'Atela Khurd,Bhiwani,Haryana',
'Aun,Bhiwani,Haryana',
'Badal,Bhiwani,Haryana',
'Badrai,Bhiwani,Haryana',
'Barsana,Bhiwani,Haryana',
'Berla,Bhiwani,Haryana',
'Bhagesari,Bhiwani,Haryana',
'Bhagwi,Bhiwani,Haryana',
'Bigowa,Bhiwani,Haryana',
'Chandwas,Bhiwani,Haryana',
'Chappar,Bhiwani,Haryana',
'Dagroli,Bhiwani,Haryana',
'Dalawas,Bhiwani,Haryana',
'Dohka Harya,Bhiwani,Haryana',
'Dudhwa,Bhiwani,Haryana',
'Gopi,Bhiwani,Haryana',
'Harodi,Bhiwani,Haryana',
'Jewali,Bhiwani,Haryana',
'Jhijhar,Bhiwani,Haryana',
'Kadma,Bhiwani,Haryana',
'Kakroli Sardara,Bhiwani,Haryana',
'Kari Dharani,Bhiwani,Haryana',
'Kario Baniawalij,Bhiwani,Haryana',
'Lad,Bhiwani,Haryana',
'Loharwara,Bhiwani,Haryana',
'Makrana,Bhiwani,Haryana',
'Malkosh,Bhiwani,Haryana',
'Mandhi Harya,Bhiwani,Haryana',
'Mauri,Bhiwani,Haryana',
'Mehera,Bhiwani,Haryana',
'Morwala,Bhiwani,Haryana',
'Nandha,Bhiwani,Haryana',
'Rasiwas,Bhiwani,Haryana',
'Siswala,Bhiwani,Haryana',
'Tiwala,Bhiwani,Haryana',
'Bardu Chaina,Bhiwani,Haryana',
'Barwas,Bhiwani,Haryana',
'Bisalwas,Bhiwani,Haryana',
'Budhera,Bhiwani,Haryana',
'Chahar Kalan,Bhiwani,Haryana',
'Chahar Khurd,Bhiwani,Haryana',
'Dhani Dhola,Bhiwani,Haryana',
'Dhighawa Jattan,Bhiwani,Haryana',
'Fartia Bhima,Bhiwani,Haryana',
'Gignow,Bhiwani,Haryana',
'Jhanjra Sheoran,Bhiwani,Haryana',
'Kharkari,Bhiwani,Haryana',
'Kural,Bhiwani,Haryana',
'Loharu,Bhiwani,Haryana',
'Nakipur,Bhiwani,Haryana',
'Parvezpur,Bhiwani,Haryana',
'Sehar,Bhiwani,Haryana',
'Singhani,Bhiwani,Haryana',
'Sohansara,Bhiwani,Haryana',
'Mundhal Khurd,Bhiwani,Haryana',
'Barwa,Bhiwani,Haryana',
'Behl,Bhiwani,Haryana',
'Bidhwan,Bhiwani,Haryana',
'Dhani Miran,Bhiwani,Haryana',
'Gainadawas,Bhiwani,Haryana',
'Ghanghala,Bhiwani,Haryana',
'Gurera,Bhiwani,Haryana',
'Jhumpa Kalan,Bhiwani,Haryana',
'Kalod,Bhiwani,Haryana',
'Khera,Bhiwani,Haryana',
'Lilas,Bhiwani,Haryana',
'Mandholi Khurd,Bhiwani,Haryana',
'Matani,Bhiwani,Haryana',
'Miran,Bhiwani,Haryana',
'Mithi,Bhiwani,Haryana',
'Morka,Bhiwani,Haryana',
'Naloi,Bhiwani,Haryana',
'Noonsar,Bhiwani,Haryana',
'Obra,Bhiwani,Haryana',
'Patwan,Bhiwani,Haryana',
'Serla,Bhiwani,Haryana',
'Sidhanwa,Bhiwani,Haryana',
'Siwani,Bhiwani,Haryana',
'Surpura Khurd,Bhiwani,Haryana',
'Alipur,Faridabad,Haryana',
'Amarpur,Faridabad,Haryana',
'Atali,Faridabad,Haryana',
'Badarpur Syed,Faridabad,Haryana',
'Ballabgarh,Faridabad,Haryana',
'Baroli,Faridabad,Haryana',
'Bhainsrawali,Faridabad,Haryana',
'Bhuvapur,Faridabad,Haryana',
'Chandpur,Faridabad,Haryana',
'Chawla Colony Ballabgarh,Faridabad,Haryana',
'Chhainsa,Faridabad,Haryana',
'Dayalpur,Faridabad,Haryana',
'Deeg,Faridabad,Haryana',
'Dhauj,Faridabad,Haryana',
'Faridpur,Faridabad,Haryana',
'Fatehpur Billoch,Faridabad,Haryana',
'Fatehpur Tagga,Faridabad,Haryana',
'G.T. Road Faridabad,Faridabad,Haryana',
'Gadpuri,Faridabad,Haryana',
'Gonchhi,Faridabad,Haryana',
'Jawan,Faridabad,Haryana',
'Kurali,Faridabad,Haryana',
'Machhgar,Faridabad,Haryana',
'Manjhawali,Faridabad,Haryana',
'Mohna,Faridabad,Haryana',
'N.T.P.C./sector-10 Faridabad,Faridabad,Haryana',
'Neemka,Faridabad,Haryana',
'Pali,Faridabad,Haryana',
'Panhera Khurd,Faridabad,Haryana',
'Sagarpur,Faridabad,Haryana',
'Sector-3 Faridabad,Faridabad,Haryana',
'Sector-7 Faridabad,Faridabad,Haryana',
'Sector-8 Faridabad,Faridabad,Haryana',
'Sector-9 Faridabad,Faridabad,Haryana',
'Seekri,Faridabad,Haryana',
'Tigaon,Faridabad,Haryana',
'Amarnagar,Faridabad,Haryana',
'Anangpur,Faridabad,Haryana',
'Bhaskola,Faridabad,Haryana',
'Escortsnagar Faridabad,Faridabad,Haryana',
'Factory Area Faridabad,Faridabad,Haryana',
'Faridabad City,Faridabad,Haryana',
'Faridabad NIT H.O,Faridabad,Haryana',
'Feroz Gandhi Nagar Faridabad,Faridabad,Haryana',
'Gurukul Indraprashtha,Faridabad,Haryana',
'Industrial Area Faridabad,Faridabad,Haryana',
'Jawahar Colony Faridabad,Faridabad,Haryana',
'Kheri Kalan,Faridabad,Haryana',
'Mathura Road Faridabad,Faridabad,Haryana',
'N.I.F.M. Faridabad,Faridabad,Haryana',
'Nh-2 Faridabad,Faridabad,Haryana',
'Nh-3 Faridabad,Faridabad,Haryana',
'Nh-4 Faridabad,Faridabad,Haryana',
'Nhpc Colony Faridabad,Faridabad,Haryana',
'Press Colony Faridabad,Faridabad,Haryana',
'Sector-12 Faridabad,Faridabad,Haryana',
'Sector-15 Faridabad,Faridabad,Haryana',
'Sector-16 Faridabad,Faridabad,Haryana',
'Sector-16a Faridabad,Faridabad,Haryana',
'Sector-18 Faridabad,Faridabad,Haryana',
'Sector-22 Faridabad,Faridabad,Haryana',
'Sector-29 Faridabad,Faridabad,Haryana',
'Surajkund Faridabad,Faridabad,Haryana',
'Tilpat,Faridabad,Haryana',
'Chhainsa,Faridabad,Haryana',
'Gehlab,Faridabad,Haryana',
'Gharrot,Faridabad,Haryana',
'Hathin,Faridabad,Haryana',
'Hurithal,Faridabad,Haryana',
'Kondal,Faridabad,Haryana',
'Kot,Faridabad,Haryana',
'Madnaka,Faridabad,Haryana',
'Malai,Faridabad,Haryana',
'Mandkola,Faridabad,Haryana',
'Rupraka,Faridabad,Haryana',
'Uttawar,Faridabad,Haryana',
'Ali Meo,Faridabad,Haryana',
'Andhop,Faridabad,Haryana',
'Bahin,Faridabad,Haryana',
'Banchari,Faridabad,Haryana',
'Banswa,Faridabad,Haryana',
'Bhandoli,Faridabad,Haryana',
'Bhiduki,Faridabad,Haryana',
'Gorota,Faridabad,Haryana',
'Gulawad,Faridabad,Haryana',
'Hassanpur,Faridabad,Haryana',
'Hodal,Faridabad,Haryana',
'Khaika,Faridabad,Haryana',
'Khambi,Faridabad,Haryana',
'Likhi,Faridabad,Haryana',
'Lohina,Faridabad,Haryana',
'Manpur,Faridabad,Haryana',
'Marraoli,Faridabad,Haryana',
'Nangal Jat,Faridabad,Haryana',
'Seoli,Faridabad,Haryana',
'Sondh,Faridabad,Haryana',
'Tappa Bilochpur,Faridabad,Haryana',
'Aharwan,Faridabad,Haryana',
'Alawalpur,Faridabad,Haryana',
'Alika,Faridabad,Haryana',
'Amroli,Faridabad,Haryana',
'Asaota,Faridabad,Haryana',
'Asaoti,Faridabad,Haryana',
'Aurangabad,Faridabad,Haryana',
'Baghola,Faridabad,Haryana',
'Bamni Khera,Faridabad,Haryana',
'Baroli,Faridabad,Haryana',
'Chant,Faridabad,Haryana',
'Chhajju Nagar,Faridabad,Haryana',
'Dhatir,Faridabad,Haryana',
'Dighot,Faridabad,Haryana',
'Ghori,Faridabad,Haryana',
'Grain Market Palwal,Faridabad,Haryana',
'Jaindapur,Faridabad,Haryana',
'Janauli,Faridabad,Haryana',
'Jawahar Nagar Palwal,Faridabad,Haryana',
'Katesara,Faridabad,Haryana',
'Khatela Sarai,Faridabad,Haryana',
'New Township Palwal,Faridabad,Haryana',
'Palwal,Faridabad,Haryana',
'Pingore,Faridabad,Haryana',
'Prithla,Faridabad,Haryana',
'Rasulpur,Faridabad,Haryana',
'Siaroli,Faridabad,Haryana',
'Sihol,Faridabad,Haryana',
'Teekri Brahman,Faridabad,Haryana',
'Nai Mandi Fatehabad,Hissar,Haryana',
'Ahlisadar,Hissar,Haryana',
'Badopal,Hissar,Haryana',
'Baijalpur,Hissar,Haryana',
'Ban Mandori,Hissar,Haryana',
'Bangaon,Hissar,Haryana',
'Banwali,Hissar,Haryana',
'Bhirrana,Hissar,Haryana',
'Bhodia Bishnoian,Hissar,Haryana',
'Bhodia Khera,Hissar,Haryana',
'Bhuthan Kalan,Hissar,Haryana',
'Bighar,Hissar,Haryana',
'Chandrawal,Hissar,Haryana',
'Chaubara,Hissar,Haryana',
'Chinder,Hissar,Haryana',
'Daiyar,Hissar,Haryana',
'Daryapur,Hissar,Haryana',
'Dhabi Kalan,Hissar,Haryana',
'Dhand,Hissar,Haryana',
'Dhanger,Hissar,Haryana',
'Dhani Gopal,Hissar,Haryana',
'Dhani Majra,Hissar,Haryana',
'Dhingsara,Hissar,Haryana',
'Dhola,Hissar,Haryana',
'Dullat,Hissar,Haryana',
'Fatehabad,Hissar,Haryana',
'Fatehabd Kty,Hissar,Haryana',
'Gillan Khera,Hissar,Haryana',
'Hajrawan Kalan,Hissar,Haryana',
'Hajrawan Khurd,Hissar,Haryana',
'Jandli Kalan,Hissar,Haryana',
'Jandli Khurd,Hissar,Haryana',
'Jandwala,Hissar,Haryana',
'Jhalnia,Hissar,Haryana',
'Karnoli,Hissar,Haryana',
'Khabra Kalan,Hissar,Haryana',
'Khairati Khera,Hissar,Haryana',
'Khajuri Jatti,Hissar,Haryana',
'Khara Kheri,Hissar,Haryana',
'Kirdhan,Hissar,Haryana',
'Kukranwali,Hissar,Haryana',
'Mahmadpur Rohi,Hissar,Haryana',
'Mehuwala,Hissar,Haryana',
'Munawali,Hissar,Haryana',
'Nadhori,Hissar,Haryana',
'Nakhatia,Hissar,Haryana',
'Pili Mandori,Hissar,Haryana',
'Ramsara,Hissar,Haryana',
'Ratta Tibba,Hissar,Haryana',
'Sanchla,Hissar,Haryana',
'Sheikapur Daroli,Hissar,Haryana',
'Suli Khera,Hissar,Haryana',
'Thori,Hissar,Haryana',
'Thuiyan,Hissar,Haryana',
'Asrawan,Hissar,Haryana',
'Bagla,Hissar,Haryana',
'Bhattu Kalan,Hissar,Haryana',
'Bithmara,Hissar,Haryana',
'Bosti,Hissar,Haryana',
'Bowan,Hissar,Haryana',
'Aharwan,Hissar,Haryana',
'Alika,Hissar,Haryana',
'Ayalki,Hissar,Haryana',
'Badalgarh,Hissar,Haryana',
'Bahmanwala,Hissar,Haryana',
'Baliala,Hissar,Haryana',
'Biranbadi,Hissar,Haryana',
'Bora,Hissar,Haryana',
'Chandoh Kalan,Hissar,Haryana',
'Chimmon,Hissar,Haryana',
'Ganda,Hissar,Haryana',
'Gurusar,Hissar,Haryana',
'Hamzapur,Hissar,Haryana',
'Hanspur,Hissar,Haryana',
'Haroli,Hissar,Haryana',
'Hassanga,Hissar,Haryana',
'Jallopur,Hissar,Haryana',
'Kamana,Hissar,Haryana',
'Khunan,Hissar,Haryana',
'Laduwas,Hissar,Haryana',
'Lali,Hissar,Haryana',
'Mehmra,Hissar,Haryana',
'Mirana,Hissar,Haryana',
'Mohmadpur Sotter,Hissar,Haryana',
'Nagpur,Hissar,Haryana',
'Nangal,Hissar,Haryana',
'Nathwan,Hissar,Haryana',
'Phullan,Hissar,Haryana',
'Pilchhian,Hissar,Haryana',
'Ratta Khera,Hissar,Haryana',
'Sheikhpur Sotter,Hissar,Haryana',
'Akanwali,Hissar,Haryana',
'Bhuna,Hissar,Haryana',
'Chander Kalan,Hissar,Haryana',
'Dangra,Hissar,Haryana',
'Degoh,Hissar,Haryana',
'Dharsul Kalan,Hissar,Haryana',
'Diwana,Hissar,Haryana',
'Fatehpuri,Hissar,Haryana',
'Handalwala,Hissar,Haryana',
'Inda Chhoi,Hissar,Haryana',
'Jakhal Mandi,Hissar,Haryana',
'Jamalpur Sheikhan,Hissar,Haryana',
'Kanheri,Hissar,Haryana',
'Karandi,Hissar,Haryana',
'Kudni,Hissar,Haryana',
'Kullan,Hissar,Haryana',
'Lalauda,Hissar,Haryana',
'Lehraian,Hissar,Haryana',
'Manghera,Hissar,Haryana',
'Meond Kalan,Hissar,Haryana',
'Meond Khurd,Hissar,Haryana',
'Musa Khera,Hissar,Haryana',
'Nangla,Hissar,Haryana',
'Nanheri,Hissar,Haryana',
'Nathuwal,Hissar,Haryana',
'Partan,Hissar,Haryana',
'Pirthala,Hissar,Haryana',
'Rainwali,Hissar,Haryana',
'Ratta Theh,Hissar,Haryana',
'Rattia,Hissar,Haryana',
'Sadhanwas,Hissar,Haryana',
'Samain,Hissar,Haryana',
'Shakarpura,Hissar,Haryana',
'Sidhani,Hissar,Haryana',
'Talwara,Hissar,Haryana',
'Tohana Mandi,Hissar,Haryana',
'Tohana,Hissar,Haryana',
'Agon,Gurgaon,Haryana',
'Akhera,Gurgaon,Haryana',
'Baded,Gurgaon,Haryana',
'Badli,Gurgaon,Haryana',
'Baghanki,Gurgaon,Haryana',
'Basai,Gurgaon,Haryana',
'Baslambi,Gurgaon,Haryana',
'Baspadamka,Gurgaon,Haryana',
'Bewan,Gurgaon,Haryana',
'Bhadas,Gurgaon,Haryana',
'Bhangrola,Gurgaon,Haryana',
'Bhirauti,Gurgaon,Haryana',
'Bichhor,Gurgaon,Haryana',
'Bilaspur Khurd,Gurgaon,Haryana',
'Bisru,Gurgaon,Haryana',
'Budarpur,Gurgaon,Haryana',
'Budhera,Gurgaon,Haryana',
'Carterpuri,Gurgaon,Haryana',
'Chakkarpur,Gurgaon,Haryana',
'Chapera,Gurgaon,Haryana',
'Cheelarh,Gurgaon,Haryana',
'Damdama,Gurgaon,Haryana',
'Daulah,Gurgaon,Haryana',
'Daultabad,Gurgaon,Haryana',
'Dhani Chitarsain,Gurgaon,Haryana',
'Dhankot,Gurgaon,Haryana',
'Doha,Gurgaon,Haryana',
'Dulawat,Gurgaon,Haryana',
'Dundahera,Gurgaon,Haryana',
'Dungerwas,Gurgaon,Haryana',
'Fazilpur,Gurgaon,Haryana',
'Ferozepur Namak,Gurgaon,Haryana',
'Ghamroj,Gurgaon,Haryana',
'Ghasera,Gurgaon,Haryana',
'Ghungola,Gurgaon,Haryana',
'Gulalta,Gurgaon,Haryana',
'Gurgaon Village,Gurgaon,Haryana',
'Gwal Pahari,Gurgaon,Haryana',
'Hasanpur,Gurgaon,Haryana',
'Hirwari,Gurgaon,Haryana',
'Inchhapuri,Gurgaon,Haryana',
'Indir Mewat,Gurgaon,Haryana',
'Jagat,Gurgaon,Haryana',
'Jaitpur,Gurgaon,Haryana',
'Jamalgarh,Gurgaon,Haryana',
'Jamalpur,Gurgaon,Haryana',
'Janaula,Gurgaon,Haryana',
'Jant,Gurgaon,Haryana',
'Jataula,Gurgaon,Haryana',
'Jatauli,Gurgaon,Haryana',
'Jawasi,Gurgaon,Haryana',
'Jhamuwas,Gurgaon,Haryana',
'Jharsa,Gurgaon,Haryana',
'Kadipur,Gurgaon,Haryana',
'Kakoria,Gurgaon,Haryana',
'Kalwari,Gurgaon,Haryana',
'Karola,Gurgaon,Haryana',
'Kasan,Gurgaon,Haryana',
'Khandewia,Gurgaon,Haryana',
'Khandsa,Gurgaon,Haryana',
'Khatauli,Gurgaon,Haryana',
'Khera Khurampur,Gurgaon,Haryana',
'Kherki Daula,Gurgaon,Haryana',
'Kherla,Gurgaon,Haryana',
'Khor,Gurgaon,Haryana',
'Kiranj,Gurgaon,Haryana',
'Kurthala,Gurgaon,Haryana',
'Lakhnaula,Gurgaon,Haryana',
'Lala Kherli,Gurgaon,Haryana',
'Lohinga Kalan,Gurgaon,Haryana',
'Lokra,Gurgaon,Haryana',
'Malab,Gurgaon,Haryana',
'Mandikhera,Gurgaon,Haryana',
'Manesar,Gurgaon,Haryana',
'Maruthi Kunj,Gurgaon,Haryana',
'Mehchana,Gurgaon,Haryana',
'Mirpur,Gurgaon,Haryana',
'Mohamadpur Ahir,Gurgaon,Haryana',
'Moklawas,Gurgaon,Haryana',
'Moolthan,Gurgaon,Haryana',
'Naheda,Gurgaon,Haryana',
'Nai,Gurgaon,Haryana',
'Narhera,Gurgaon,Haryana',
'Nathupur,Gurgaon,Haryana',
'Noorgarh,Gurgaon,Haryana',
'Pachgaon,Gurgaon,Haryana',
'Pahari,Gurgaon,Haryana',
'Paltra,Gurgaon,Haryana',
'Pathreri,Gurgaon,Haryana',
'Patil R.S.,Gurgaon,Haryana',
'Pingwan,Gurgaon,Haryana',
'Raisina,Gurgaon,Haryana',
'Ramgarh,Gurgaon,Haryana',
'Rathiwas,Gurgaon,Haryana',
'Rawli,Gurgaon,Haryana',
'Rethath,Gurgaon,Haryana',
'Rewasan,Gurgaon,Haryana',
'Rithoj,Gurgaon,Haryana',
'Rojka Meo,Gurgaon,Haryana',
'Sakras,Gurgaon,Haryana',
'Sarhaul,Gurgaon,Haryana',
'Sec-56,Gurgaon,Haryana',
'Sewari,Gurgaon,Haryana',
'Shahchokha,Gurgaon,Haryana',
'Sherpur,Gurgaon,Haryana',
'Sidhrawali,Gurgaon,Haryana',
'Sihri Singhalheri,Gurgaon,Haryana',
'Sikanderpur,Gurgaon,Haryana',
'Sikohpur,Gurgaon,Haryana',
'Sikrawa,Gurgaon,Haryana',
'Singar,Gurgaon,Haryana',
'Smaspur,Gurgaon,Haryana',
'South City-I,Gurgaon,Haryana',
'South City-II,Gurgaon,Haryana',
'Sudaka,Gurgaon,Haryana',
'Sultanpur,Gurgaon,Haryana',
'Sundh,Gurgaon,Haryana',
'Syed Shahpur,Gurgaon,Haryana',
'Tain,Gurgaon,Haryana',
'Tapkan,Gurgaon,Haryana',
'Tatarpur,Gurgaon,Haryana',
'Teekli,Gurgaon,Haryana',
'Turkiawas,Gurgaon,Haryana',
'Ujina,Gurgaon,Haryana',
'Umra,Gurgaon,Haryana',
'Unchamajra,Gurgaon,Haryana',
'Wazipur,Gurgaon,Haryana',
'Wazirabad,Gurgaon,Haryana',
'Air Force,Gurgaon,Haryana',
'Arjun Nagar,Gurgaon,Haryana',
'Badshahpur,Gurgaon,Haryana',
'Basai Road,Gurgaon,Haryana',
'Bhondsi,Gurgaon,Haryana',
'Bhorakalan,Gurgaon,Haryana',
'DLF Ph-II,Gurgaon,Haryana',
'DLF Ph-III,Gurgaon,Haryana',
'DLF QE,Gurgaon,Haryana',
'Farrukh Nagar,Gurgaon,Haryana',
'Ferozepur Jhirka,Gurgaon,Haryana',
'Galleria DLF-IV,Gurgaon,Haryana',
'Garhi Harsaru,Gurgaon,Haryana',
'Gurgaon Kty.,Gurgaon,Haryana',
'Haillymandi,Gurgaon,Haryana',
'Industrial Complex Dundahera,Gurgaon,Haryana',
'Industrial Estate,Gurgaon,Haryana',
'Khalilpur,Gurgaon,Haryana',
'Mini Sectt.,Gurgaon,Haryana',
'Nagina,Gurgaon,Haryana',
'Nanukalan,Gurgaon,Haryana',
'Narsinghpur,Gurgaon,Haryana',
'New Colony,Gurgaon,Haryana',
'Nsg Camp Manesar,Gurgaon,Haryana',
'Nuh,Gurgaon,Haryana',
'Palam Road,Gurgaon,Haryana',
'Palam Vihar,Gurgaon,Haryana',
'Pataudi,Gurgaon,Haryana',
'Punhana,Gurgaon,Haryana',
'Railwary Road,Gurgaon,Haryana',
'Gurgaon H.O,Gurgaon,Haryana',
'Sector -45,Gurgaon,Haryana',
'Sector-17,Gurgaon,Haryana',
'Shivaji Nagar,Gurgaon,Haryana',
'Sohna,Gurgaon,Haryana',
'Sohna Adda,Gurgaon,Haryana',
'Tauru,Gurgaon,Haryana',
'Urban Estate,Gurgaon,Haryana',
'Zainabad,Gurgaon,Haryana',
'Garhi,Rohtak,Haryana',
'Gharauthi,Rohtak,Haryana',
'Saman,Rohtak,Haryana',
'Bainsi,Rohtak,Haryana',
'Basana,Rohtak,Haryana',
'Behlba,Rohtak,Haryana',
'Bhagwatipur,Rohtak,Haryana',
'Bhaini Bharon,Rohtak,Haryana',
'Bhaini Chanderpal,Rohtak,Haryana',
'Bhaini Surjan,Rohtak,Haryana',
'Chandi,Rohtak,Haryana',
'Farmana,Rohtak,Haryana',
'Ghrauthi,Rohtak,Haryana',
'Gugaheri,Rohtak,Haryana',
'Kharainti,Rohtak,Haryana',
'Kharkhara,Rohtak,Haryana',
'Lakhan Majra,Rohtak,Haryana',
'Madina,Rohtak,Haryana',
'Mehem,Rohtak,Haryana',
'Mokhra,Rohtak,Haryana',
'Nandal,Rohtak,Haryana',
'Nidana,Rohtak,Haryana',
'Nindana,Rohtak,Haryana',
'Sisarkhas,Rohtak,Haryana',
'Ajaib,Rohtak,Haryana',
'Anwal,Rohtak,Haryana',
'Assan,Rohtak,Haryana',
'Asthal Bohar,Rohtak,Haryana',
'Atail,Rohtak,Haryana',
'Bahu Akbarpur,Rohtak,Haryana',
'Bakheta,Rohtak,Haryana',
'Baland,Rohtak,Haryana',
'Baliana,Rohtak,Haryana',
'Bangla Sahib,Rohtak,Haryana',
'Banyani,Rohtak,Haryana',
'Basantpur,Rohtak,Haryana',
'Bhalaut,Rohtak,Haryana',
'Bhali Anandpur,Rohtak,Haryana',
'Bhambhewa,Rohtak,Haryana',
'Bhaproda,Rohtak,Haryana',
'Bharan,Rohtak,Haryana',
'Bhasro Kalan,Rohtak,Haryana',
'Bohar,Rohtak,Haryana',
'Bus Stand,Rohtak,Haryana',
'Chamaria,Rohtak,Haryana',
'Chimni,Rohtak,Haryana',
'Chiri,Rohtak,Haryana',
'Chuliyana,Rohtak,Haryana',
'Dehkora,Rohtak,Haryana',
'Dhamar,Rohtak,Haryana',
'Dharana,Rohtak,Haryana',
'Dlf Colony Rohtak,Rohtak,Haryana',
'Dobh,Rohtak,Haryana',
'Durga Bhawan,Rohtak,Haryana',
'Gaddi Kheri,Rohtak,Haryana',
'Gandhi Camp,Rohtak,Haryana',
'Gandhra,Rohtak,Haryana',
'Garhi,Rohtak,Haryana',
'Garhi Ballab,Rohtak,Haryana',
'Garnauthi,Rohtak,Haryana',
'Ghillaur Kalan,Rohtak,Haryana',
'Gijhi,Rohtak,Haryana',
'Girawar,Rohtak,Haryana',
'Gohana Road,Rohtak,Haryana',
'Gurukul Singhpura,Rohtak,Haryana',
'Humayunpur,Rohtak,Haryana',
'Ismaila,Rohtak,Haryana',
'Jassia,Rohtak,Haryana',
'Jhajjar Road Rohtak,Rohtak,Haryana',
'Kahnaur,Rohtak,Haryana',
'Kahni,Rohtak,Haryana',
'Kakrana,Rohtak,Haryana',
'Kalanaur,Rohtak,Haryana',
'Kanak Mandi Rohtak,Rohtak,Haryana',
'Kansala,Rohtak,Haryana',
'Karontha,Rohtak,Haryana',
'Karor,Rohtak,Haryana',
'Katesra,Rohtak,Haryana',
'Khairari,Rohtak,Haryana',
'Kharawar,Rohtak,Haryana',
'Kharhar,Rohtak,Haryana',
'Kheri Sadh,Rohtak,Haryana',
'Khidwali,Rohtak,Haryana',
'Kiloi,Rohtak,Haryana',
'Kultana,Rohtak,Haryana',
'Ladout,Rohtak,Haryana',
'Lahli,Rohtak,Haryana',
'Loharheri,Rohtak,Haryana',
'Maina,Rohtak,Haryana',
'Makrauli Kalan,Rohtak,Haryana',
'Marodi Jatan,Rohtak,Haryana',
'Matan,Rohtak,Haryana',
'Medical College,Rohtak,Haryana',
'Model Town,Rohtak,Haryana',
'Morekheri,Rohtak,Haryana',
'Mungain,Rohtak,Haryana',
'Nanaud,Rohtak,Haryana',
'Naya Bans,Rohtak,Haryana',
'Nigana,Rohtak,Haryana',
'Nilothi,Rohtak,Haryana',
'Paksma,Rohtak,Haryana',
'Patwapur,Rohtak,Haryana',
'Pehrawar,Rohtak,Haryana',
'Polangi,Rohtak,Haryana',
'Rithal,Rohtak,Haryana',
'Rohad,Rohtak,Haryana',
'Rohtak H.O,Rohtak,Haryana',
'Rohtak Mandi,Rohtak,Haryana',
'Rohtak Town,Rohtak,Haryana',
'Rurkee,Rohtak,Haryana',
'Samargopalpur,Rohtak,Haryana',
'Samchana,Rohtak,Haryana',
'Sampel,Rohtak,Haryana',
'Sanghi,Rohtak,Haryana',
'Shivaji Colony,Rohtak,Haryana',
'Sunari Kalan,Rohtak,Haryana',
'Sundana,Rohtak,Haryana',
'Sunderpur,Rohtak,Haryana',
'Titauli,Rohtak,Haryana',
'Kanheli,Rohtak,Haryana',
'Asa Khera,Hissar,Haryana',
'Janowala Bishnolan,Hissar,Haryana',
'Alika,Hissar,Haryana',
'Anandgarh,Hissar,Haryana',
'Bapp,Hissar,Haryana',
'Bhadra,Hissar,Haryana',
'Bhiwan,Hissar,Haryana',
'Jhiri,Hissar,Haryana',
'Jhorar Rohi,Hissar,Haryana',
'Kurangawali,Hissar,Haryana',
'Lehangewala,Hissar,Haryana',
'Nagoki,Hissar,Haryana',
'Thiraj,Hissar,Haryana',
'Dabwali Town,Hissar,Haryana',
'Poharkan,Hissar,Haryana',
'Phaggu,Hissar,Haryana',
'Taruana,Hissar,Haryana',
'Chakrian,Hissar,Haryana',
'Dadu,Hissar,Haryana',
'Desu Mulkana,Hissar,Haryana',
'Godrana,Hissar,Haryana',
'Jagmalwali,Hissar,Haryana',
'Jalalana,Hissar,Haryana',
'Lakarwali,Hissar,Haryana',
'Pakka,Hissar,Haryana',
'Pipli,Hissar,Haryana',
'Rori,Hissar,Haryana',
'Singhpura,Hissar,Haryana',
'Sukhchain,Hissar,Haryana',
'Surtia,Hissar,Haryana',
'Takhatmal,Hissar,Haryana',
'Mandi Dabwali,Hissar,Haryana',
'Abubshahar,Hissar,Haryana',
'Chatha,Hissar,Haryana',
'Dabwali Village,Hissar,Haryana',
'Desu Jodha,Hissar,Haryana',
'Habuana,Hissar,Haryana',
'Khuiyana Malkana,Hissar,Haryana',
'Lohgarh,Hissar,Haryana',
'Mangiana,Hissar,Haryana',
'Masitan,Hissar,Haryana',
'Maujgarbh,Hissar,Haryana',
'Mithri,Hissar,Haryana',
'Paniwala Ruldu,Hissar,Haryana',
'Sakta Khera,Hissar,Haryana',
'Shergarh,Hissar,Haryana',
'Buraj Bhangu,Hissar,Haryana',
'Chormar,Hissar,Haryana',
'Khairkan,Hissar,Haryana',
'Nezadela Khurd,Hissar,Haryana',
'Nuhianwali,Hissar,Haryana',
'Paniwala Mota,Hissar,Haryana',
'Panjuana,Hissar,Haryana',
'Sahuwala,Hissar,Haryana',
'Dohtar,Hissar,Haryana',
'Jodhpuria,Hissar,Haryana',
'Kharian,Hissar,Haryana',
'Nanuana,Hissar,Haryana',
'Sultanpuria,Hissar,Haryana',
'Ahmedpur,Hissar,Haryana',
'Amritsar Kalan,Hissar,Haryana',
'Arniawali,Hissar,Haryana',
'Bahaudin,Hissar,Haryana',
'Bahya,Hissar,Haryana',
'Baidwala,Hissar,Haryana',
'Bajekan,Hissar,Haryana',
'Balasar,Hissar,Haryana',
'Banni,Hissar,Haryana',
'Banwala,Hissar,Haryana',
'Baragudha,Hissar,Haryana',
'Barawala Khurd,Hissar,Haryana',
'Baruwali-i,Hissar,Haryana',
'Begu Road Sirsa,Hissar,Haryana',
'Bhamboor,Hissar,Haryana',
'Bharokhan,Hissar,Haryana',
'Bharolianwali,Hissar,Haryana',
'Bhratwala,Hissar,Haryana',
'Bijuwali,Hissar,Haryana',
'Chadiwal,Hissar,Haryana',
'Chaharwala,Hissar,Haryana',
'Chakarian,Hissar,Haryana',
'Chakkan,Hissar,Haryana',
'Chamal,Hissar,Haryana',
'Chattargarh Patti,Hissar,Haryana',
'Chautala,Hissar,Haryana',
'Chopta Nathu Sari,Hissar,Haryana',
'Damdama,Hissar,Haryana',
'Darba Kalan,Hissar,Haryana',
'Darbi,Hissar,Haryana',
'Dharampura,Hissar,Haryana',
'Ding,Hissar,Haryana',
'Dudianwali,Hissar,Haryana',
'Ellenabad,Hissar,Haryana',
'Ferozabad,Hissar,Haryana',
'Furwain Kalan,Hissar,Haryana',
'Ganda,Hissar,Haryana',
'Ghoranwali,Hissar,Haryana',
'Goriwala,Hissar,Haryana',
'Gudia Khera,Hissar,Haryana',
'Gussiana,Hissar,Haryana',
'Hanziran,Hissar,Haryana',
'Haripura,Hissar,Haryana',
'Jamal,Hissar,Haryana',
'Jhornali,Hissar,Haryana',
'Jodhkan,Hissar,Haryana',
'Kagdana,Hissar,Haryana',
'Kalanwali,Hissar,Haryana',
'Kaluana,Hissar,Haryana',
'Kariwala,Hissar,Haryana',
'Keharwala,Hissar,Haryana',
'Keshopura,Hissar,Haryana',
'Khairpur,Hissar,Haryana',
'Khari Sureran,Hissar,Haryana',
'Kusumbi,Hissar,Haryana',
'Kutewadh,Hissar,Haryana',
'Ludesar,Hissar,Haryana',
'Madho Singhana,Hissar,Haryana',
'Majudin,Hissar,Haryana',
'Makhosarani,Hissar,Haryana',
'Mallekan,Hissar,Haryana',
'Mamera Kalan,Hissar,Haryana',
'Mangala,Hissar,Haryana',
'Manjui Khera,Hissar,Haryana',
'Matdadu,Hissar,Haryana',
'Mauju Khera,Hissar,Haryana',
'Mini.Sectt.Sirsa,Hissar,Haryana',
'Mirzapur,Hissar,Haryana',
'Mithanpura,Hissar,Haryana',
'Mochiwali,Hissar,Haryana',
'Monnawali,Hissar,Haryana',
'Moriwala,Hissar,Haryana',
'Mts Sirsa,Hissar,Haryana',
'Nai Mandi Sirsa,Hissar,Haryana',
'Nakora,Hissar,Haryana',
'Nathore,Hissar,Haryana',
'Nathusari Kalan,Hissar,Haryana',
'Nozadela Kalan,Hissar,Haryana',
'Nozia Khera,Hissar,Haryana',
'Odhan,Hissar,Haryana',
'Ottu,Hissar,Haryana',
'Panihari,Hissar,Haryana',
'Patli Dabar,Hissar,Haryana',
'Phulkan,Hissar,Haryana',
'Rampur Bishnoian,Hissar,Haryana',
'Randhawa,Hissar,Haryana',
'Rania,Hissar,Haryana',
'Resalia Khera,Hissar,Haryana',
'Rupawas,Hissar,Haryana',
'Sahuwala -ii,Hissar,Haryana',
'Sant Nagar,Hissar,Haryana',
'Shahpur Begu,Hissar,Haryana',
'Shakar Mandori,Hissar,Haryana',
'Sherpura,Hissar,Haryana',
'Sikander Pur,Hissar,Haryana',
'Siri Jiwan Nagar,Hissar,Haryana',
'Sirsa H.O,Hissar,Haryana',
'Sirsa Town,Hissar,Haryana',
'Suchan Kotli,Hissar,Haryana',
'Talwara Khurd,Hissar,Haryana',
'Thersahidau,Hissar,Haryana',
'Umedpura,Hissar,Haryana',
'Ahulana,Sonepat,Haryana',
'Ahulana,Sonepat,Haryana',
'Akabarpur,Sonepat,Haryana',
'Anwali,Sonepat,Haryana',
'Asadpur,Sonepat,Haryana',
'Aterna,Sonepat,Haryana',
'Atlas Cycle,Sonepat,Haryana',
'Badhana,Sonepat,Haryana',
'Bajanakhurd,Sonepat,Haryana',
'Bali Brahman,Sonepat,Haryana',
'Bali Qutubpur,Sonepat,Haryana',
'Banwasa,Sonepat,Haryana',
'Bari,Sonepat,Haryana',
'Baroli,Sonepat,Haryana',
'Barona,Sonepat,Haryana',
'Barota,Sonepat,Haryana',
'Barota Mandora,Sonepat,Haryana',
'Barwasni,Sonepat,Haryana',
'Bayanpur,Sonepat,Haryana',
'Bega,Sonepat,Haryana',
'Bhagan,Sonepat,Haryana',
'Bhainswal Kalan,Sonepat,Haryana',
'Bhainswan Khurd,Sonepat,Haryana',
'Bhatgaon,Sonepat,Haryana',
'Bhawar,Sonepat,Haryana',
'Bhimnagar,Sonepat,Haryana',
'Bichpari,Sonepat,Haryana',
'Bidhal,Sonepat,Haryana',
'Bidhlan,Sonepat,Haryana',
'Bindroli,Sonepat,Haryana',
'Bohla,Sonepat,Haryana',
'Bus Stand Gohana,Sonepat,Haryana',
'Busana,Sonepat,Haryana',
'Butana,Sonepat,Haryana',
'Chhapra,Sonepat,Haryana',
'Chhetra,Sonepat,Haryana',
'Chhetra Bhahadurpur,Sonepat,Haryana',
'Chhichrana,Sonepat,Haryana',
'Chirana,Sonepat,Haryana',
'Churana,Sonepat,Haryana',
'Datauli,Sonepat,Haryana',
'Deepalpur,Sonepat,Haryana',
'Delhi Road,Sonepat,Haryana',
'Dhanana Ahladpur,Sonepat,Haryana',
'Engg College Muthal,Sonepat,Haryana',
'Farmana,Sonepat,Haryana',
'Fazilpur,Sonepat,Haryana',
'G.H.Bhainswal Kalan,Sonepat,Haryana',
'G.K.Matindu,Sonepat,Haryana',
'Ganaur City,Sonepat,Haryana',
'Ganaur,Sonepat,Haryana',
'Ganewari,Sonepat,Haryana',
'Gangana,Sonepat,Haryana',
'Ganzbazar,Sonepat,Haryana',
'Garhi Rajlu,Sonepat,Haryana',
'Garhwal,Sonepat,Haryana',
'Ghasauli,Sonepat,Haryana',
'Giwana,Sonepat,Haryana',
'Gohana Mandi,Sonepat,Haryana',
'Gohana Road,Sonepat,Haryana',
'Gohana,Sonepat,Haryana',
'Gopalpur,Sonepat,Haryana',
'Gorar,Sonepat,Haryana',
'Guhna,Sonepat,Haryana',
'Gumar,Sonepat,Haryana',
'Halalpur,Sonepat,Haryana',
'Harsana Kalan,Sonepat,Haryana',
'Housing Board Colony,Sonepat,Haryana',
'Industrial Area Sonipat,Sonepat,Haryana',
'Industrial Estate Kundli,Sonepat,Haryana',
'Jagsi,Sonepat,Haryana',
'Jainpur,Sonepat,Haryana',
'Jakhauli,Sonepat,Haryana',
'Janti Kalan,Sonepat,Haryana',
'Jasrana,Sonepat,Haryana',
'Jatheri,Sonepat,Haryana',
'Jauli,Sonepat,Haryana',
'Jawahra,Sonepat,Haryana',
'Jharot,Sonepat,Haryana',
'Jhs Butana,Sonepat,Haryana',
'Jhundpur,Sonepat,Haryana',
'Juan,Sonepat,Haryana',
'Kailana,Sonepat,Haryana',
'Kakroi,Sonepat,Haryana',
'Kanwali,Sonepat,Haryana',
'Kanyagurukul Khanpur,Sonepat,Haryana',
'Karewari,Sonepat,Haryana',
'Kasandi,Sonepat,Haryana',
'Kathura,Sonepat,Haryana',
'Kathura Block,Sonepat,Haryana',
'Katwal,Sonepat,Haryana',
'Khanda,Sonepat,Haryana',
'Khandrai,Sonepat,Haryana',
'Khanpur Kalan,Sonepat,Haryana',
'Kharkhauda,Sonepat,Haryana',
'Kheri Damkan,Sonepat,Haryana',
'Kheri Gujjar,Sonepat,Haryana',
'Kheri Manajat,Sonepat,Haryana',
'Khewra,Sonepat,Haryana',
'Khizarpur Ahir,Sonepat,Haryana',
'Kohla,Sonepat,Haryana',
'Kundal,Sonepat,Haryana',
'Kundli,Sonepat,Haryana',
'Kurar Brahimpur,Sonepat,Haryana',
'Larsauli,Sonepat,Haryana',
'Lath,Sonepat,Haryana',
'Lehrara,Sonepat,Haryana',
'Madina,Sonepat,Haryana',
'Mahra -II,Sonepat,Haryana',
'Mahra-I,Sonepat,Haryana',
'Malikpur,Sonepat,Haryana',
'Manauli,Sonepat,Haryana',
'Mehlana,Sonepat,Haryana',
'Mehmoodpur,Sonepat,Haryana',
'Model Town, Sonipat,Sonepat,Haryana',
'Mohana,Sonepat,Haryana',
'Moi Hooda,Sonepat,Haryana',
'Moi Majri,Sonepat,Haryana',
'Mundlana,Sonepat,Haryana',
'Murthal,Sonepat,Haryana',
'Nahra,Sonepat,Haryana',
'Nahri,Sonepat,Haryana',
'Nandpur,Sonepat,Haryana',
'Nangal Kalan,Sonepat,Haryana',
'Nathupur,Sonepat,Haryana',
'Nayat,Sonepat,Haryana',
'Nizampur,Sonepat,Haryana',
'Nuran Khera,Sonepat,Haryana',
'P.S.Rai,Sonepat,Haryana',
'Panchi Gujjaran,Sonepat,Haryana',
'Panchijatan,Sonepat,Haryana',
'Pehladpur Kiroli,Sonepat,Haryana',
'Pinana,Sonepat,Haryana',
'Pipli,Sonepat,Haryana',
'Pipli Khera,Sonepat,Haryana',
'Pritampura,Sonepat,Haryana',
'Pugthala,Sonepat,Haryana',
'Purkhas,Sonepat,Haryana',
'Puthi,Sonepat,Haryana',
'Qumaspur,Sonepat,Haryana',
'Rabra,Sonepat,Haryana',
'Rai,Sonepat,Haryana',
'Rajpur,Sonepat,Haryana',
'Ram Bazar-Sonipat,Sonepat,Haryana',
'Rathdhana,Sonepat,Haryana',
'Rattangarh,Sonepat,Haryana',
'Rinchana,Sonepat,Haryana',
'Riwara,Sonepat,Haryana',
'Rohat,Sonepat,Haryana',
'Rohna,Sonepat,Haryana',
'Rolad Latifpur,Sonepat,Haryana',
'Rukhi,Sonepat,Haryana',
'Saidpur,Sonepat,Haryana',
'Salimsar Majra,Sonepat,Haryana',
'Sandal Kalan,Sonepat,Haryana',
'Sanpera,Sonepat,Haryana',
'Saragthal,Sonepat,Haryana',
'Sector-14-Sonipat,Sonepat,Haryana',
'Sehri,Sonepat,Haryana',
'Sersa,Sonepat,Haryana',
'Shamri,Sonepat,Haryana',
'Shapur Turk,Sonepat,Haryana',
'Sheikhpura,Sonepat,Haryana',
'Sikenderpur Majra,Sonepat,Haryana',
'Silana,Sonepat,Haryana',
'Sisana,Sonepat,Haryana',
'Sitawali,Sonepat,Haryana',
'Sohti,Sonepat,Haryana',
'Sonipat Kty,Sonepat,Haryana',
'Sonipat Mandi,Sonepat,Haryana',
'Thanakalan,Sonepat,Haryana',
'Tharuoldepur,Sonepat,Haryana',
'Tihar,Sonepat,Haryana',
'Tihar Bagru,Sonepat,Haryana',
'Bahalgarh,Sonepat,Haryana',
'Baroda,Sonepat,Haryana',
'Sonipat H.O,Sonepat,Haryana',
'Alhar,Ambala,Haryana',
'Amadalpur,Ambala,Haryana',
'Aurangabad,Ambala,Haryana',
'Azizpur,Ambala,Haryana',
'Bakana,Ambala,Haryana',
'Bakarwala,Ambala,Haryana',
'Balachaur,Ambala,Haryana',
'Balchhapar,Ambala,Haryana',
'Banidi,Ambala,Haryana',
'Bapa,Ambala,Haryana',
'Barsan,Ambala,Haryana',
'Basatianwala,Ambala,Haryana',
'Bhagu Majra,Ambala,Haryana',
'Bhambol,Ambala,Haryana',
'Bherthal,Ambala,Haryana',
'Bilauli,Ambala,Haryana',
'Binjalpur,Ambala,Haryana',
'Bubka,Ambala,Haryana',
'Cagnoli,Ambala,Haryana',
'Chamrori,Ambala,Haryana',
'Chauli,Ambala,Haryana',
'Chhappar,Ambala,Haryana',
'Dadupur,Ambala,Haryana',
'Damla,Ambala,Haryana',
'Darpur,Ambala,Haryana',
'Dayalgarh,Ambala,Haryana',
'Deodhar,Ambala,Haryana',
'Fatehgarh Tumbi,Ambala,Haryana',
'Fatehpur,Ambala,Haryana',
'Gadhaula,Ambala,Haryana',
'Ghillaur,Ambala,Haryana',
'Gudhiana,Ambala,Haryana',
'Gumthala Rao,Ambala,Haryana',
'Hafizpur,Ambala,Haryana',
'Haibatpur,Ambala,Haryana',
'Hangoli,Ambala,Haryana',
'Harnaul,Ambala,Haryana',
'Hartan,Ambala,Haryana',
'Haveli,Ambala,Haryana',
'Jagdholi,Ambala,Haryana',
'Jaidhari,Ambala,Haryana',
'Jathlana,Ambala,Haryana',
'Jroda,Ambala,Haryana',
'Jubbal,Ambala,Haryana',
'Kalanaur,Ambala,Haryana',
'Kalesar,Ambala,Haryana',
'Kandhari Kalan,Ambala,Haryana',
'Khadri,Ambala,Haryana',
'Khera,Ambala,Haryana',
'Khera Khurd,Ambala,Haryana',
'Khurdban,Ambala,Haryana',
'Kopal Mochan,Ambala,Haryana',
'Kot Kalsia,Ambala,Haryana',
'Laharpur,Ambala,Haryana',
'Lalheri Kalan,Ambala,Haryana',
'Ledi,Ambala,Haryana',
'Machrauli,Ambala,Haryana',
'Malikpur Khadar,Ambala,Haryana',
'Mandhar,Ambala,Haryana',
'Mandhar,Ambala,Haryana',
'Manglore,Ambala,Haryana',
'Marwa Kalan,Ambala,Haryana',
'Marwa Khurd,Ambala,Haryana',
'Mehar Majra,Ambala,Haryana',
'Mehlanwali,Ambala,Haryana',
'Mehmoodpur,Ambala,Haryana',
'Milakpur Banger,Ambala,Haryana',
'Mughalwali,Ambala,Haryana',
'Mussimbal,Ambala,Haryana',
'Muzafatkalan,Ambala,Haryana',
'Nachron,Ambala,Haryana',
'Nagal Khajuri,Ambala,Haryana',
'Nahar Pur,Ambala,Haryana',
'Noshera,Ambala,Haryana',
'Pabni Kalan,Ambala,Haryana',
'Pansra,Ambala,Haryana',
'Pipli Majra,Ambala,Haryana',
'Pipliwala,Ambala,Haryana',
'Rampur Khadar,Ambala,Haryana',
'Rasulpur,Ambala,Haryana',
'Sabapur,Ambala,Haryana',
'Sadiqpur,Ambala,Haryana',
'Safilpur,Ambala,Haryana',
'Sahela,Ambala,Haryana',
'Salehpur,Ambala,Haryana',
'Salimpur Banger,Ambala,Haryana',
'Sankhera,Ambala,Haryana',
'Sardaheri,Ambala,Haryana',
'Shadi Pur,Ambala,Haryana',
'Shahpur Nurd,Ambala,Haryana',
'Sherpur Sulkhani,Ambala,Haryana',
'Silikalan,Ambala,Haryana',
'Taharpurkalan,Ambala,Haryana',
'Tajewala,Ambala,Haryana',
'Talakaur,Ambala,Haryana',
'Topra Kalan,Ambala,Haryana',
'Udhamgarh,Ambala,Haryana',
'Uncha Chandna,Ambala,Haryana',
'Zaffarpur,Ambala,Haryana',
'Bhatia Nagar,Ambala,Haryana',
'Bilaspur,Ambala,Haryana',
'Mud Hut Colony,Ambala,Haryana',
'Ram Pura Olony,Ambala,Haryana',
'Work Shop Road,Ambala,Haryana',
'Bhudkalan,Ambala,Haryana',
'Buriya,Ambala,Haryana',
'Chhachrauli,Ambala,Haryana',
'Jagadhri Court,Ambala,Haryana',
'Jagadhri,Ambala,Haryana',
'Jagadhri Town,Ambala,Haryana',
'Jagdhari Work Shop,Ambala,Haryana',
'Kalawar,Ambala,Haryana',
'Kharwan,Ambala,Haryana',
'Khirzrabad East,Ambala,Haryana',
'Model Town,Ambala,Haryana',
'Mustafabad,Ambala,Haryana',
'Radaur,Ambala,Haryana',
'Rly Road,Ambala,Haryana',
'Sadhaura,Ambala,Haryana',
'Sarawan,Ambala,Haryana',
'Sugar Mill,Ambala,Haryana',
'Yamunanagar H.O,Ambala,Haryana',
'Shirad,Mandi,Himachal Pradesh',
'Vashisht,Mandi,Himachal Pradesh',
'Arsu,Rampur Bushahr,Himachal Pradesh',
'Beoni,Rampur Bushahr,Himachal Pradesh',
'Deem,Rampur Bushahr,Himachal Pradesh',
'Durah,Rampur Bushahr,Himachal Pradesh',
'Ghatu,Rampur Bushahr,Himachal Pradesh',
'Jadoli,Rampur Bushahr,Himachal Pradesh',
'Jaon,Rampur Bushahr,Himachal Pradesh',
'Kharga,Rampur Bushahr,Himachal Pradesh',
'Koil,Rampur Bushahr,Himachal Pradesh',
'Kushwa,Rampur Bushahr,Himachal Pradesh',
'Nirmand,Rampur Bushahr,Himachal Pradesh',
'Nishani,Rampur Bushahr,Himachal Pradesh',
'Nither,Rampur Bushahr,Himachal Pradesh',
'Poshna,Rampur Bushahr,Himachal Pradesh',
'Sarahan,Rampur Bushahr,Himachal Pradesh',
'Sargha,Rampur Bushahr,Himachal Pradesh',
'Shamani,Rampur Bushahr,Himachal Pradesh',
'Sharvi,Rampur Bushahr,Himachal Pradesh',
'Tunan,Rampur Bushahr,Himachal Pradesh',
'Urtu,Rampur Bushahr,Himachal Pradesh',
'Gemour,Mandi,Himachal Pradesh',
'Gondhla,Mandi,Himachal Pradesh',
'Goshal,Mandi,Himachal Pradesh',
'Jahalman,Mandi,Himachal Pradesh',
'Jispa,Mandi,Himachal Pradesh',
'Jobrang,Mandi,Himachal Pradesh',
'Keylong H.O,Mandi,Himachal Pradesh',
'Koksar,Mandi,Himachal Pradesh',
'Kolang,Mandi,Himachal Pradesh',
'Kordang,Mandi,Himachal Pradesh',
'Lote,Mandi,Himachal Pradesh',
'Malang,Mandi,Himachal Pradesh',
'Mooling,Mandi,Himachal Pradesh',
'Mooring,Mandi,Himachal Pradesh',
'Peokar,Mandi,Himachal Pradesh',
'Samdoh,Mandi,Himachal Pradesh',
'Shansha,Mandi,Himachal Pradesh',
'Sissu,Mandi,Himachal Pradesh',
'Tandi,Mandi,Himachal Pradesh',
'Thirot,Mandi,Himachal Pradesh',
'Yurnath,Mandi,Himachal Pradesh',
'Demul,Rampur Bushahr,Himachal Pradesh',
'Dhanker,Rampur Bushahr,Himachal Pradesh',
'Gue,Rampur Bushahr,Himachal Pradesh',
'Gulling,Rampur Bushahr,Himachal Pradesh',
'Hansa,Rampur Bushahr,Himachal Pradesh',
'Hikkam,Rampur Bushahr,Himachal Pradesh',
'Hull,Rampur Bushahr,Himachal Pradesh',
'Kaza,Rampur Bushahr,Himachal Pradesh',
'Kee Gompa,Rampur Bushahr,Himachal Pradesh',
'Kibber,Rampur Bushahr,Himachal Pradesh',
'Lalung,Rampur Bushahr,Himachal Pradesh',
'Lara,Rampur Bushahr,Himachal Pradesh',
'Losser,Rampur Bushahr,Himachal Pradesh',
'Mane,Rampur Bushahr,Himachal Pradesh',
'Mud,Rampur Bushahr,Himachal Pradesh',
'Rangrik,Rampur Bushahr,Himachal Pradesh',
'Sagnam,Rampur Bushahr,Himachal Pradesh',
'Samdoo,Rampur Bushahr,Himachal Pradesh',
'Tabo,Rampur Bushahr,Himachal Pradesh',
'Chimrat,Mandi,Himachal Pradesh',
'Karpat,Mandi,Himachal Pradesh',
'Salugran,Mandi,Himachal Pradesh',
'Tindi,Mandi,Himachal Pradesh',
'Trilokinath,Mandi,Himachal Pradesh',
'Udaipur,Mandi,Himachal Pradesh',
'Badhu,Mandi,Himachal Pradesh',
'Bara,Mandi,Himachal Pradesh',
'Bassi,Mandi,Himachal Pradesh',
'Chachiot,Mandi,Himachal Pradesh',
'Chail Chowk,Mandi,Himachal Pradesh',
'Devdhar,Mandi,Himachal Pradesh',
'Gohar,Mandi,Himachal Pradesh',
'Jachh,Mandi,Himachal Pradesh',
'Jahal,Mandi,Himachal Pradesh',
'Kot,Mandi,Himachal Pradesh',
'Majhar,Mandi,Himachal Pradesh',
'Moviseri,Mandi,Himachal Pradesh',
'Parwara,Mandi,Himachal Pradesh',
'Sayanj,Mandi,Himachal Pradesh',
'Seghli,Mandi,Himachal Pradesh',
'Shala,Mandi,Himachal Pradesh',
'Shilhnu,Mandi,Himachal Pradesh',
'Sukibain,Mandi,Himachal Pradesh',
'Balh,Mandi,Himachal Pradesh',
'Basona,Mandi,Himachal Pradesh',
'Chukku,Mandi,Himachal Pradesh',
'Drang,Mandi,Himachal Pradesh',
'Gawali,Mandi,Himachal Pradesh',
'Joginder Nagar,Mandi,Himachal Pradesh',
'Karsal,Mandi,Himachal Pradesh',
'Khaddar,Mandi,Himachal Pradesh',
'Khajoor,Mandi,Himachal Pradesh',
'Kolang,Mandi,Himachal Pradesh',
'Kufri,Mandi,Himachal Pradesh',
'Kunnu,Mandi,Himachal Pradesh',
'Ladbharole,Mandi,Himachal Pradesh',
'Ootpur,Mandi,Himachal Pradesh',
'Padhar,Mandi,Himachal Pradesh',
'Padhwan,Mandi,Himachal Pradesh',
'Panjalag,Mandi,Himachal Pradesh',
'Ropa,Mandi,Himachal Pradesh',
'Shanan Power House,Mandi,Himachal Pradesh',
'Simas,Mandi,Himachal Pradesh',
'Sudhar,Mandi,Himachal Pradesh',
'Ahju,Mandi,Himachal Pradesh',
'Bag,Mandi,Himachal Pradesh',
'Balhjoli,Mandi,Himachal Pradesh',
'Balhkwar,Mandi,Himachal Pradesh',
'Barot,Mandi,Himachal Pradesh',
'Bassi,Mandi,Himachal Pradesh',
'Bhararu,Mandi,Himachal Pradesh',
'Bhiun,Mandi,Himachal Pradesh',
'Chalarag,Mandi,Himachal Pradesh',
'Chauntra,Mandi,Himachal Pradesh',
'Chimnu,Mandi,Himachal Pradesh',
'Dohag,Mandi,Himachal Pradesh',
'Drahal,Mandi,Himachal Pradesh',
'Drubbal,Mandi,Himachal Pradesh',
'Dul,Mandi,Himachal Pradesh',
'Gangoti,Mandi,Himachal Pradesh',
'Ghamiroo,Mandi,Himachal Pradesh',
'Golwan,Mandi,Himachal Pradesh',
'Gumma,Mandi,Himachal Pradesh',
'Harabagh,Mandi,Himachal Pradesh',
'Jalpehar,Mandi,Himachal Pradesh',
'Jhamerh,Mandi,Himachal Pradesh',
'Jhatingri,Mandi,Himachal Pradesh',
'Kathog,Mandi,Himachal Pradesh',
'Kuthera,Mandi,Himachal Pradesh',
'Langna,Mandi,Himachal Pradesh',
'Majharnoo,Mandi,Himachal Pradesh',
'Makreri,Mandi,Himachal Pradesh',
'Matroo,Mandi,Himachal Pradesh',
'Mohanghati,Mandi,Himachal Pradesh',
'Nohali,Mandi,Himachal Pradesh',
'Pali,Mandi,Himachal Pradesh',
'Pandol,Mandi,Himachal Pradesh',
'Pipli,Mandi,Himachal Pradesh',
'Prainsainthal,Mandi,Himachal Pradesh',
'Ropri Kalehru,Mandi,Himachal Pradesh',
'Thaltukhod,Mandi,Himachal Pradesh',
'Thara,Mandi,Himachal Pradesh',
'Tikroo,Mandi,Himachal Pradesh',
'Tramat,Mandi,Himachal Pradesh',
'Tullah,Mandi,Himachal Pradesh',
'Urla,Mandi,Himachal Pradesh',
'Silhbadhani,Mandi,Himachal Pradesh',
'Alsindi,Mandi,Himachal Pradesh',
'Bagshar,Mandi,Himachal Pradesh',
'Bahenara,Mandi,Himachal Pradesh',
'Bakhrot,Mandi,Himachal Pradesh',
'Balindi,Mandi,Himachal Pradesh',
'Banthal,Mandi,Himachal Pradesh',
'Behli,Mandi,Himachal Pradesh',
'Chauridhar,Mandi,Himachal Pradesh',
'Churag,Mandi,Himachal Pradesh',
'Dharmour Kheel,Mandi,Himachal Pradesh',
'Doghari,Mandi,Himachal Pradesh',
'Gowalpur,Mandi,Himachal Pradesh',
'Hara,Mandi,Himachal Pradesh',
'Jassal,Mandi,Himachal Pradesh',
'Karsog,Mandi,Himachal Pradesh',
'Katwachi,Mandi,Himachal Pradesh',
'Kaw,Mandi,Himachal Pradesh',
'Khenyol,Mandi,Himachal Pradesh',
'Kunho,Mandi,Himachal Pradesh',
'Mahog,Mandi,Himachal Pradesh',
'Mahun,Mandi,Himachal Pradesh',
'Marothi,Mandi,Himachal Pradesh',
'Mehndi,Mandi,Himachal Pradesh',
'Nanj,Mandi,Himachal Pradesh',
'Pangna,Mandi,Himachal Pradesh',
'Pokhi,Mandi,Himachal Pradesh',
'Pressi,Mandi,Himachal Pradesh',
'Sainj Bagra,Mandi,Himachal Pradesh',
'Sakra,Mandi,Himachal Pradesh',
'Sankar Dehra,Mandi,Himachal Pradesh',
'Sapnot,Mandi,Himachal Pradesh',
'Seri,Mandi,Himachal Pradesh',
'Shorshan,Mandi,Himachal Pradesh',
'Soma Kothi,Mandi,Himachal Pradesh',
'Surahan Suket,Mandi,Himachal Pradesh',
'Tattapani,Mandi,Himachal Pradesh',
'Teban,Mandi,Himachal Pradesh',
'Aut,Mandi,Himachal Pradesh',
'Alathu,Mandi,Himachal Pradesh',
'Baggi,Mandi,Himachal Pradesh',
'Baloh,Mandi,Himachal Pradesh',
'Balt,Mandi,Himachal Pradesh',
'Balu,Mandi,Himachal Pradesh',
'Bandhi,Mandi,Himachal Pradesh',
'Bardhan,Mandi,Himachal Pradesh',
'Bari Gumanu,Mandi,Himachal Pradesh',
'Barsu,Mandi,Himachal Pradesh',
'Barswan,Mandi,Himachal Pradesh',
'Baryara,Mandi,Himachal Pradesh',
'Batheri,Mandi,Himachal Pradesh',
'Behna,Mandi,Himachal Pradesh',
'Bhargaon,Mandi,Himachal Pradesh',
'Bijni,Mandi,Himachal Pradesh',
'Bir,Mandi,Himachal Pradesh',
'Boching,Mandi,Himachal Pradesh',
'Chunahan,Mandi,Himachal Pradesh',
'Dabhan,Mandi,Himachal Pradesh',
'Dasehra,Mandi,Himachal Pradesh',
'Dawahan,Mandi,Himachal Pradesh',
'Deori,Mandi,Himachal Pradesh',
'Dudar,Mandi,Himachal Pradesh',
'Gagal,Mandi,Himachal Pradesh',
'Galma,Mandi,Himachal Pradesh',
'Ghambhar Khad,Mandi,Himachal Pradesh',
'Gharan,Mandi,Himachal Pradesh',
'Gurkotha,Mandi,Himachal Pradesh',
'Gutkar,Mandi,Himachal Pradesh',
'Jail Road,Mandi,Himachal Pradesh',
'Kalhani,Mandi,Himachal Pradesh',
'Kalkhar,Mandi,Himachal Pradesh',
'Kamand,Mandi,Himachal Pradesh',
'Kataula,Mandi,Himachal Pradesh',
'Kathyaun,Mandi,Himachal Pradesh',
'Katindi,Mandi,Himachal Pradesh',
'Khadyad,Mandi,Himachal Pradesh',
'Khakhariana,Mandi,Himachal Pradesh',
'Khalanoo,Mandi,Himachal Pradesh',
'Khaliar,Mandi,Himachal Pradesh',
'Kholanal,Mandi,Himachal Pradesh',
'Kot,Mandi,Himachal Pradesh',
'Kothi,Mandi,Himachal Pradesh',
'Kotkamradha,Mandi,Himachal Pradesh',
'Kotli,Mandi,Himachal Pradesh',
'Kotmorse,Mandi,Himachal Pradesh',
'Kummi,Mandi,Himachal Pradesh',
'Lagdhar,Mandi,Himachal Pradesh',
'Leda,Mandi,Himachal Pradesh',
'Lohara,Mandi,Himachal Pradesh',
'Mahogi,Mandi,Himachal Pradesh',
'Majhwar,Mandi,Himachal Pradesh',
'Mandal,Mandi,Himachal Pradesh',
'Mandi H.O,Mandi,Himachal Pradesh',
'Mangwain Mohalla,Mandi,Himachal Pradesh',
'Marathu,Mandi,Himachal Pradesh',
'Meramasit,Mandi,Himachal Pradesh',
'Nagchala,Mandi,Himachal Pradesh',
'Nagwain,Mandi,Himachal Pradesh',
'Nandi,Mandi,Himachal Pradesh',
'Ner Chowk,Mandi,Himachal Pradesh',
'Paddal,Mandi,Himachal Pradesh',
'Padhiun,Mandi,Himachal Pradesh',
'Pairi,Mandi,Himachal Pradesh',
'Panarsa,Mandi,Himachal Pradesh',
'Pandoh,Mandi,Himachal Pradesh',
'Purani Mandi,Mandi,Himachal Pradesh',
'Rajgarh,Mandi,Himachal Pradesh',
'Rajwari,Mandi,Himachal Pradesh',
'Randhara,Mandi,Himachal Pradesh',
'Ratti,Mandi,Himachal Pradesh',
'Rehardhar,Mandi,Himachal Pradesh',
'Reur,Mandi,Himachal Pradesh',
'Rewalsar,Mandi,Himachal Pradesh',
'Sadhyani,Mandi,Himachal Pradesh',
'Sadyana,Mandi,Himachal Pradesh',
'Saigaloo,Mandi,Himachal Pradesh',
'Sakroha,Mandi,Himachal Pradesh',
'Saletar,Mandi,Himachal Pradesh',
'Samrahan,Mandi,Himachal Pradesh',
'Sardhwar,Mandi,Himachal Pradesh',
'Sarkidhar,Mandi,Himachal Pradesh',
'Saroa,Mandi,Himachal Pradesh',
'Segli,Mandi,Himachal Pradesh',
'Sehli,Mandi,Himachal Pradesh',
'Shiva,Mandi,Himachal Pradesh',
'Somnachi,Mandi,Himachal Pradesh',
'Surah,Mandi,Himachal Pradesh',
'Talyahar,Mandi,Himachal Pradesh',
'Tandu,Mandi,Himachal Pradesh',
'Tarnoh,Mandi,Himachal Pradesh',
'Thachi,Mandi,Himachal Pradesh',
'Thalout,Mandi,Himachal Pradesh',
'Thinagaloo,Mandi,Himachal Pradesh',
'Tihri,Mandi,Himachal Pradesh',
'Tikkar,Mandi,Himachal Pradesh',
'Tilli,Mandi,Himachal Pradesh',
'Troh,Mandi,Himachal Pradesh',
'Bhangrotu,Mandi,Himachal Pradesh',
'Bachwan,Mandi,Himachal Pradesh',
'Bahnu,Mandi,Himachal Pradesh',
'Baldwara,Mandi,Himachal Pradesh',
'Balhara,Mandi,Himachal Pradesh',
'Bararta,Mandi,Himachal Pradesh',
'Barin,Mandi,Himachal Pradesh',
'Baroti,Mandi,Himachal Pradesh',
'Basantpur,Mandi,Himachal Pradesh',
'Bathera,Mandi,Himachal Pradesh',
'Bhadarwar,Mandi,Himachal Pradesh',
'Bhambla,Mandi,Himachal Pradesh',
'Binga,Mandi,Himachal Pradesh',
'Brang,Mandi,Himachal Pradesh',
'Cholangarh,Mandi,Himachal Pradesh',
'Cholthra,Mandi,Himachal Pradesh',
'Chowk,Mandi,Himachal Pradesh',
'Darpa,Mandi,Himachal Pradesh',
'Darwar,Mandi,Himachal Pradesh',
'Dhalwan,Mandi,Himachal Pradesh',
'Dharampur,Mandi,Himachal Pradesh',
'Dhawali,Mandi,Himachal Pradesh',
'Dhurkhari,Mandi,Himachal Pradesh',
'Fatehpur,Mandi,Himachal Pradesh',
'Gahar,Mandi,Himachal Pradesh',
'Gehra,Mandi,Himachal Pradesh',
'Ghararu,Mandi,Himachal Pradesh',
'Gharwasra,Mandi,Himachal Pradesh',
'Giun,Mandi,Himachal Pradesh',
'Gopalpur,Mandi,Himachal Pradesh',
'Hari Behna,Mandi,Himachal Pradesh',
'Jahmet,Mandi,Himachal Pradesh',
'Jamni,Mandi,Himachal Pradesh',
'Jandhrukalan,Mandi,Himachal Pradesh',
'Jhangi,Mandi,Himachal Pradesh',
'Kamlahkhas,Mandi,Himachal Pradesh',
'Kangu Ka Gehra,Mandi,Himachal Pradesh',
'Kasmaila,Mandi,Himachal Pradesh',
'Khalardu,Mandi,Himachal Pradesh',
'Khan,Mandi,Himachal Pradesh',
'Khoda,Mandi,Himachal Pradesh',
'Khudla,Mandi,Himachal Pradesh',
'Kot,Mandi,Himachal Pradesh',
'Kot,Mandi,Himachal Pradesh',
'Kothwan,Mandi,Himachal Pradesh',
'Kujabalh,Mandi,Himachal Pradesh',
'Longni,Mandi,Himachal Pradesh',
'Lower Dhalara,Mandi,Himachal Pradesh',
'Lower Ghanala,Mandi,Himachal Pradesh',
'Marhi,Mandi,Himachal Pradesh',
'Maseran,Mandi,Himachal Pradesh',
'Nabahi Devi,Mandi,Himachal Pradesh',
'Nalyana,Mandi,Himachal Pradesh',
'Narola,Mandi,Himachal Pradesh',
'Patrighat,Mandi,Himachal Pradesh',
'Paunta,Mandi,Himachal Pradesh',
'Pehad,Mandi,Himachal Pradesh',
'Pingla,Mandi,Himachal Pradesh',
'Rakhoh,Mandi,Himachal Pradesh',
'Rissa,Mandi,Himachal Pradesh',
'Ropari,Mandi,Himachal Pradesh',
'Sadhot,Mandi,Himachal Pradesh',
'Sajao Pipluso,Mandi,Himachal Pradesh',
'Saklana,Mandi,Himachal Pradesh',
'Samaila,Mandi,Himachal Pradesh',
'Samour,Mandi,Himachal Pradesh',
'Sandhole,Mandi,Himachal Pradesh',
'Sari,Mandi,Himachal Pradesh',
'Sarkaghat,Mandi,Himachal Pradesh',
'Seoh,Mandi,Himachal Pradesh',
'Sidhpur,Mandi,Himachal Pradesh',
'Surajpur Bari,Mandi,Himachal Pradesh',
'Tanehar,Mandi,Himachal Pradesh',
'Tanihar,Mandi,Himachal Pradesh',
'Taurjajar,Mandi,Himachal Pradesh',
'Thona,Mandi,Himachal Pradesh',
'Tihra,Mandi,Himachal Pradesh',
'Tikkar,Mandi,Himachal Pradesh',
'Tikri Sidhwani,Mandi,Himachal Pradesh',
'Tourkhola,Mandi,Himachal Pradesh',
'Trifalghat,Mandi,Himachal Pradesh',
'Upper Bhambla,Mandi,Himachal Pradesh',
'Balag,Mandi,Himachal Pradesh',
'Baroti,Mandi,Himachal Pradesh',
'Batwara,Mandi,Himachal Pradesh',
'Bhojpur,Mandi,Himachal Pradesh',
'Brokhari,Mandi,Himachal Pradesh',
'Chambi,Mandi,Himachal Pradesh',
'Chowki,Mandi,Himachal Pradesh',
'Churad,Mandi,Himachal Pradesh',
'Dehar,Mandi,Himachal Pradesh',
'Diyargi,Mandi,Himachal Pradesh',
'Ghanghnoo,Mandi,Himachal Pradesh',
'Ghiri,Mandi,Himachal Pradesh',
'Jaidevi,Mandi,Himachal Pradesh',
'Jambla,Mandi,Himachal Pradesh',
'Jarol,Mandi,Himachal Pradesh',
'Jhungi,Mandi,Himachal Pradesh',
'Jugahan,Mandi,Himachal Pradesh',
'Kaloud,Mandi,Himachal Pradesh',
'Kanaid,Mandi,Himachal Pradesh',
'Kapahi,Mandi,Himachal Pradesh',
'Khurahal,Mandi,Himachal Pradesh',
'Mahadev,Mandi,Himachal Pradesh',
'Maloh,Mandi,Himachal Pradesh',
'Movi Devi Galoo,Mandi,Himachal Pradesh',
'Nalag,Mandi,Himachal Pradesh',
'Nihri,Mandi,Himachal Pradesh',
'Paura Kothi,Mandi,Himachal Pradesh',
'Purana Nagar,Mandi,Himachal Pradesh',
'Rakol,Mandi,Himachal Pradesh',
'Rohanda,Mandi,Himachal Pradesh',
'Salwana,Mandi,Himachal Pradesh',
'Sehli,Mandi,Himachal Pradesh',
'Seri Kothi,Mandi,Himachal Pradesh',
'Slapper,Mandi,Himachal Pradesh',
'Sudhan,Mandi,Himachal Pradesh',
'Sunder Nagar Town Ship H.O,Mandi,Himachal Pradesh',
'Sunder Nagar-1,Mandi,Himachal Pradesh',
'Syanji,Mandi,Himachal Pradesh',
'Taleli,Mandi,Himachal Pradesh',
'Upper Behli,Mandi,Himachal Pradesh',
'Brikhmani,Mandi,Himachal Pradesh',
'Kangoo,Mandi,Himachal Pradesh',
'Vayala,Mandi,Himachal Pradesh',
'Bagachanogi,Mandi,Himachal Pradesh',
'Bagsaid,Mandi,Himachal Pradesh',
'Balichowki,Mandi,Himachal Pradesh',
'Bihani,Mandi,Himachal Pradesh',
'Chathri,Mandi,Himachal Pradesh',
'Cheuni,Mandi,Himachal Pradesh',
'Dhamerh,Mandi,Himachal Pradesh',
'Ghaniar,Mandi,Himachal Pradesh',
'Janjehli,Mandi,Himachal Pradesh',
'Jarol,Mandi,Himachal Pradesh',
'Kandha,Mandi,Himachal Pradesh',
'Khuhan,Mandi,Himachal Pradesh',
'Kotla,Mandi,Himachal Pradesh',
'Panihar,Mandi,Himachal Pradesh',
'Panjain,Mandi,Himachal Pradesh',
'Ruhamani,Mandi,Himachal Pradesh',
'Sangalwara,Mandi,Himachal Pradesh',
'Shikawari,Mandi,Himachal Pradesh',
'Shillibagi,Mandi,Himachal Pradesh',
'Sunah Lamba Thach,Mandi,Himachal Pradesh',
'Thanashiva,Mandi,Himachal Pradesh',
'Thatibir,Mandi,Himachal Pradesh',
'Thunag,Mandi,Himachal Pradesh',
'Chilala,Shimla,Himachal Pradesh',
'Chirgaon,Shimla,Himachal Pradesh',
'Gaonsari,Shimla,Himachal Pradesh',
'Jangla,Shimla,Himachal Pradesh',
'Kanthli,Shimla,Himachal Pradesh',
'Khabal,Shimla,Himachal Pradesh',
'Khashdhar,Shimla,Himachal Pradesh',
'Larot,Shimla,Himachal Pradesh',
'Masli,Shimla,Himachal Pradesh',
'Pekha,Shimla,Himachal Pradesh',
'Rohal,Shimla,Himachal Pradesh',
'Sindhasli,Shimla,Himachal Pradesh',
'Tangnu,Shimla,Himachal Pradesh',
'Tikkari,Shimla,Himachal Pradesh',
'Bamta,Shimla,Himachal Pradesh',
'Bhalu,Shimla,Himachal Pradesh',
'Bharanu,Shimla,Himachal Pradesh',
'Bijmal,Shimla,Himachal Pradesh',
'Bour,Shimla,Himachal Pradesh',
'Chanana Dhar,Shimla,Himachal Pradesh',
'Charoli,Shimla,Himachal Pradesh',
'Chopal,Shimla,Himachal Pradesh',
'Deiya,Shimla,Himachal Pradesh',
'Dewat,Shimla,Himachal Pradesh',
'Dhawas,Shimla,Himachal Pradesh',
'Eera,Shimla,Himachal Pradesh',
'Giahan,Shimla,Himachal Pradesh',
'Jhiknipul,Shimla,Himachal Pradesh',
'Jokhar,Shimla,Himachal Pradesh',
'Jublee,Shimla,Himachal Pradesh',
'Kanda Banah,Shimla,Himachal Pradesh',
'Kedi,Shimla,Himachal Pradesh',
'Khagna,Shimla,Himachal Pradesh',
'Kiarla,Shimla,Himachal Pradesh',
'Kulag,Shimla,Himachal Pradesh',
'Kupvi,Shimla,Himachal Pradesh',
'Madhana,Shimla,Himachal Pradesh',
'Majholi,Shimla,Himachal Pradesh',
'Makrog,Shimla,Himachal Pradesh',
'Malat,Shimla,Himachal Pradesh',
'Marog,Shimla,Himachal Pradesh',
'Matal,Shimla,Himachal Pradesh',
'Nakorapul,Shimla,Himachal Pradesh',
'Pauria,Shimla,Himachal Pradesh',
'Pawan,Shimla,Himachal Pradesh',
'Ruslah,Shimla,Himachal Pradesh',
'Sarain,Shimla,Himachal Pradesh',
'Thangad,Shimla,Himachal Pradesh',
'Tharoach,Shimla,Himachal Pradesh',
'Tikkri Neol,Shimla,Himachal Pradesh',
'Chambi,Shimla,Himachal Pradesh',
'Nerwa,Shimla,Himachal Pradesh',
'Kawar,Shimla,Himachal Pradesh',
'Anti,Shimla,Himachal Pradesh',
'Barthata,Shimla,Himachal Pradesh',
'Bholad,Shimla,Himachal Pradesh',
'Deem,Shimla,Himachal Pradesh',
'Dhadighunsa,Shimla,Himachal Pradesh',
'Dhadirawat,Shimla,Himachal Pradesh',
'Dhar,Shimla,Himachal Pradesh',
'Giltari,Shimla,Himachal Pradesh',
'Hatkoti,Shimla,Himachal Pradesh',
'Jhagtan,Shimla,Himachal Pradesh',
'Jhalta,Shimla,Himachal Pradesh',
'Jharag,Shimla,Himachal Pradesh',
'Jubbal,Shimla,Himachal Pradesh',
'Kathasu,Shimla,Himachal Pradesh',
'Kayana,Shimla,Himachal Pradesh',
'Mandal,Shimla,Himachal Pradesh',
'Mandhole,Shimla,Himachal Pradesh',
'Nandpur,Shimla,Himachal Pradesh',
'Pandranu,Shimla,Himachal Pradesh',
'Praunthi,Shimla,Himachal Pradesh',
'Pujarli No-2,Shimla,Himachal Pradesh',
'Shailapani,Shimla,Himachal Pradesh',
'Sheel,Shimla,Himachal Pradesh',
'Solang,Shimla,Himachal Pradesh',
'Tikkar,Shimla,Himachal Pradesh',
'Tooran,Shimla,Himachal Pradesh',
'Baghi,Shimla,Himachal Pradesh',
'Chhaila,Shimla,Himachal Pradesh',
'Kiari,Shimla,Himachal Pradesh',
'Kotkhai,Shimla,Himachal Pradesh',
'Baghar,Shimla,Himachal Pradesh',
'Bakhol,Shimla,Himachal Pradesh',
'Chalnair,Shimla,Himachal Pradesh',
'Darkoti,Shimla,Himachal Pradesh',
'Deori Khaneti,Shimla,Himachal Pradesh',
'Devgarh,Shimla,Himachal Pradesh',
'Galeha,Shimla,Himachal Pradesh',
'Garog,Shimla,Himachal Pradesh',
'Gumma,Shimla,Himachal Pradesh',
'Himri,Shimla,Himachal Pradesh',
'Kalbog,Shimla,Himachal Pradesh',
'Kalind,Shimla,Himachal Pradesh',
'Khangteri,Shimla,Himachal Pradesh',
'Kiarvi,Shimla,Himachal Pradesh',
'Kokunala,Shimla,Himachal Pradesh',
'Mahasu,Shimla,Himachal Pradesh',
'Nagan,Shimla,Himachal Pradesh',
'Panog,Shimla,Himachal Pradesh',
'Parala,Shimla,Himachal Pradesh',
'Purag,Shimla,Himachal Pradesh',
'Quinal,Shimla,Himachal Pradesh',
'Ratnari,Shimla,Himachal Pradesh',
'Rawlakiar,Shimla,Himachal Pradesh',
'Sainj,Shimla,Himachal Pradesh',
'Tharola,Shimla,Himachal Pradesh',
'Baragaon,Rampur Bushahr,Himachal Pradesh',
'Batari,Rampur Bushahr,Himachal Pradesh',
'Bhalawag,Shimla,Himachal Pradesh',
'Bhareri,Rampur Bushahr,Himachal Pradesh',
'Bhutti,Rampur Bushahr,Himachal Pradesh',
'Chikul,Rampur Bushahr,Himachal Pradesh',
'Galani,Rampur Bushahr,Himachal Pradesh',
'Halanidhar,Shimla,Himachal Pradesh',
'Janjheli,Rampur Bushahr,Himachal Pradesh',
'Jar,Rampur Bushahr,Himachal Pradesh',
'Jarol,Rampur Bushahr,Himachal Pradesh',
'Kandyali,Shimla,Himachal Pradesh',
'Kingal,Rampur Bushahr,Himachal Pradesh',
'Kirti,Rampur Bushahr,Himachal Pradesh',
'Kotgarh,Rampur Bushahr,Himachal Pradesh',
'Kotighat,Shimla,Himachal Pradesh',
'Kotla,Rampur Bushahr,Himachal Pradesh',
'Kumarsain,Rampur Bushahr,Himachal Pradesh',
'Madhawani,Shimla,Himachal Pradesh',
'Narkanda,Shimla,Himachal Pradesh',
'Naula,Rampur Bushahr,Himachal Pradesh',
'Oddi,Shimla,Himachal Pradesh',
'Pharal,Rampur Bushahr,Himachal Pradesh',
'Shamathla,Rampur Bushahr,Himachal Pradesh',
'Sharambal Camp,Rampur Bushahr,Himachal Pradesh',
'Shiwan,Rampur Bushahr,Himachal Pradesh',
'Teshan,Rampur Bushahr,Himachal Pradesh',
'Thanedhar,Rampur Bushahr,Himachal Pradesh',
'Virgarh,Rampur Bushahr,Himachal Pradesh',
'Surad,Rampur Bushahr,Himachal Pradesh',
'Barach,Rampur Bushahr,Himachal Pradesh',
'Danawali,Rampur Bushahr,Himachal Pradesh',
'Delath,Rampur Bushahr,Himachal Pradesh',
'Khamadi,Rampur Bushahr,Himachal Pradesh',
'Kungal Balti,Rampur Bushahr,Himachal Pradesh',
'Lailon,Rampur Bushahr,Himachal Pradesh',
'Nankhari,Rampur Bushahr,Himachal Pradesh',
'Sholi,Rampur Bushahr,Himachal Pradesh',
'Thaili Chakti,Rampur Bushahr,Himachal Pradesh',
'Jahu,Shimla,Himachal Pradesh',
'Kharahan,Shimla,Himachal Pradesh',
'Khunni,Shimla,Himachal Pradesh',
'Bahli,Rampur Bushahr,Himachal Pradesh',
'Bharawali,Rampur Bushahr,Himachal Pradesh',
'Bonda,Rampur Bushahr,Himachal Pradesh',
'Dansa,Rampur Bushahr,Himachal Pradesh',
'Darkali,Rampur Bushahr,Himachal Pradesh',
'Dawara,Rampur Bushahr,Himachal Pradesh',
'Deothi,Rampur Bushahr,Himachal Pradesh',
'Dofda,Rampur Bushahr,Himachal Pradesh',
'Duttnagar,Rampur Bushahr,Himachal Pradesh',
'Ganvi,Rampur Bushahr,Himachal Pradesh',
'Gaura,Rampur Bushahr,Himachal Pradesh',
'Jaghori,Rampur Bushahr,Himachal Pradesh',
'Jeori,Rampur Bushahr,Himachal Pradesh',
'Jhakri,Rampur Bushahr,Himachal Pradesh',
'Kareri,Rampur Bushahr,Himachal Pradesh',
'Kartot,Rampur Bushahr,Himachal Pradesh',
'Kashapat,Rampur Bushahr,Himachal Pradesh',
'Kayab,Rampur Bushahr,Himachal Pradesh',
'Khaneri,Rampur Bushahr,Himachal Pradesh',
'Kinnu,Rampur Bushahr,Himachal Pradesh',
'Koot,Rampur Bushahr,Himachal Pradesh',
'Labana,Rampur Bushahr,Himachal Pradesh',
'Majauli,Rampur Bushahr,Himachal Pradesh',
'Mashnoo,Rampur Bushahr,Himachal Pradesh',
'Munish Bhali,Rampur Bushahr,Himachal Pradesh',
'Narain,Rampur Bushahr,Himachal Pradesh',
'Nirth,Rampur Bushahr,Himachal Pradesh',
'Nogli,Rampur Bushahr,Himachal Pradesh',
'Padam Nagar,Rampur Bushahr,Himachal Pradesh',
'Phancha,Rampur Bushahr,Himachal Pradesh',
'Rampur Bushahr H.O,Rampur Bushahr,Himachal Pradesh',
'Sarahan BSR,Rampur Bushahr,Himachal Pradesh',
'Sarpara,Rampur Bushahr,Himachal Pradesh',
'Shahdhar,Rampur Bushahr,Himachal Pradesh',
'Shingla,Rampur Bushahr,Himachal Pradesh',
'Sugha,Rampur Bushahr,Himachal Pradesh',
'Taklech,Rampur Bushahr,Himachal Pradesh',
'Arhal,Shimla,Himachal Pradesh',
'Bachhunchh,Shimla,Himachal Pradesh',
'Devidhar,Shimla,Himachal Pradesh',
'Dharara,Shimla,Himachal Pradesh',
'Dodra,Shimla,Himachal Pradesh',
'Gawas,Shimla,Himachal Pradesh',
'Ghasani,Shimla,Himachal Pradesh',
'Jagothi,Shimla,Himachal Pradesh',
'Jakha,Shimla,Himachal Pradesh',
'Kadiwan,Shimla,Himachal Pradesh',
'Kaloti,Shimla,Himachal Pradesh',
'Kansakoti,Shimla,Himachal Pradesh',
'Karasa,Shimla,Himachal Pradesh',
'Khadrala,Shimla,Himachal Pradesh',
'Kui,Shimla,Himachal Pradesh',
'Kuthara,Shimla,Himachal Pradesh',
'Lower Koti,Shimla,Himachal Pradesh',
'Pujarli No.4,Shimla,Himachal Pradesh',
'Pujarli No-3,Shimla,Himachal Pradesh',
'Ranol,Shimla,Himachal Pradesh',
'Samara,Shimla,Himachal Pradesh',
'Samoli,Shimla,Himachal Pradesh',
'Seema,Shimla,Himachal Pradesh',
'Sharontha,Shimla,Himachal Pradesh',
'Summer Kot,Shimla,Himachal Pradesh',
'Sungri,Shimla,Himachal Pradesh',
'Thana,Shimla,Himachal Pradesh',
'Todsa,Shimla,Himachal Pradesh',
'AGPO,Shimla,Himachal Pradesh',
'AHQ,Shimla,Himachal Pradesh',
'Ambedkarchowk,Shimla,Himachal Pradesh',
'Anandpur,Shimla,Himachal Pradesh',
'Badehari,Shimla,Himachal Pradesh',
'Baldeyan,Shimla,Himachal Pradesh',
'Beolia,Shimla,Himachal Pradesh',
'Bharari,Shimla,Himachal Pradesh',
'Bhont,Shimla,Himachal Pradesh',
'Boileauganj,Shimla,Himachal Pradesh',
'Busstand,Shimla,Himachal Pradesh',
'Bychari,Shimla,Himachal Pradesh',
'Chaili,Shimla,Himachal Pradesh',
'Chalahal,Shimla,Himachal Pradesh',
'Chanog,Shimla,Himachal Pradesh',
'Combermere,Shimla,Himachal Pradesh',
'CPRI,Shimla,Himachal Pradesh',
'Devnagar,Shimla,Himachal Pradesh',
'Dhalli,Shimla,Himachal Pradesh',
'Dhami,Shimla,Himachal Pradesh',
'Dhari,Shimla,Himachal Pradesh',
'Ghana-hatti,Shimla,Himachal Pradesh',
'HP.Sectt.,Shimla,Himachal Pradesh',
'IGMC,Shimla,Himachal Pradesh',
'Jabri,Shimla,Himachal Pradesh',
'Jathia Devi,Shimla,Himachal Pradesh',
'Jubbarhatti,Shimla,Himachal Pradesh',
'Junga,Shimla,Himachal Pradesh',
'Jutogh,Shimla,Himachal Pradesh',
'Kaithu,Shimla,Himachal Pradesh',
'Kalihatti,Shimla,Himachal Pradesh',
'Kamlanagar,Shimla,Himachal Pradesh',
'Kasumpti,Shimla,Himachal Pradesh',
'Khalini,Shimla,Himachal Pradesh',
'Kiarkoti,Shimla,Himachal Pradesh',
'Kohbag,Shimla,Himachal Pradesh',
'Lower Bazar,Shimla,Himachal Pradesh',
'Malyana,Shimla,Himachal Pradesh',
'Mashobra,Shimla,Himachal Pradesh',
'Nabha Estate,Shimla,Himachal Pradesh',
'Nehra,Shimla,Himachal Pradesh',
'New Shimla,Shimla,Himachal Pradesh',
'Okharoo,Shimla,Himachal Pradesh',
'Panesh,Shimla,Himachal Pradesh',
'Poabo,Shimla,Himachal Pradesh',
'Rajhana,Shimla,Himachal Pradesh',
'Rampur Keonthal,Shimla,Himachal Pradesh',
'Rauri,Shimla,Himachal Pradesh',
'Rohru,Shimla,Himachal Pradesh',
'Salana,Shimla,Himachal Pradesh',
'Sanjauli,Shimla,Himachal Pradesh',
'Shakarah,Shimla,Himachal Pradesh',
'Shimla East,Shimla,Himachal Pradesh',
'Shimla G.P.O.,Shimla,Himachal Pradesh',
'Shimla High Court,Shimla,Himachal Pradesh',
'Shoghi,Shimla,Himachal Pradesh',
'Summerhill,Shimla,Himachal Pradesh',
'Tara Devi,Shimla,Himachal Pradesh',
'Toon,Shimla,Himachal Pradesh',
'Totu,Shimla,Himachal Pradesh',
'Chharabra,Shimla,Himachal Pradesh',
'Darbhog,Shimla,Himachal Pradesh',
'Koti,Shimla,Himachal Pradesh',
'Kufri,Shimla,Himachal Pradesh',
'Mundghat,Shimla,Himachal Pradesh',
'Satlai,Shimla,Himachal Pradesh',
'Maloothi,Shimla,Himachal Pradesh',
'Basanatpur,Shimla,Himachal Pradesh',
'Bharara,Shimla,Himachal Pradesh',
'Chaba,Shimla,Himachal Pradesh',
'Chanawag,Shimla,Himachal Pradesh',
'Dewla,Shimla,Himachal Pradesh',
'Dharogra,Shimla,Himachal Pradesh',
'Durgapur,Shimla,Himachal Pradesh',
'Gadheri,Shimla,Himachal Pradesh',
'Ghaini,Shimla,Himachal Pradesh',
'Gumma,Shimla,Himachal Pradesh',
'Himri,Shimla,Himachal Pradesh',
'Jalog,Shimla,Himachal Pradesh',
'Juni,Shimla,Himachal Pradesh',
'Kadarghat,Shimla,Himachal Pradesh',
'Kangal,Shimla,Himachal Pradesh',
'Kariali,Shimla,Himachal Pradesh',
'Khatnol,Shimla,Himachal Pradesh',
'Khera,Shimla,Himachal Pradesh',
'Majhiwar,Shimla,Himachal Pradesh',
'Ogli,Shimla,Himachal Pradesh',
'Pahal,Shimla,Himachal Pradesh',
'Pandoa,Shimla,Himachal Pradesh',
'Rewag,Shimla,Himachal Pradesh',
'Sainj,Shimla,Himachal Pradesh',
'Thachi,Shimla,Himachal Pradesh',
'Thailla,Shimla,Himachal Pradesh',
'Sunni Bhajji,Shimla,Himachal Pradesh',
'Bagri,Shimla,Himachal Pradesh',
'Balag,Shimla,Himachal Pradesh',
'Balghar,Shimla,Himachal Pradesh',
'Barog,Shimla,Himachal Pradesh',
'Basadhar,Shimla,Himachal Pradesh',
'Bharana,Shimla,Himachal Pradesh',
'Bhogra,Shimla,Himachal Pradesh',
'Chanair,Shimla,Himachal Pradesh',
'Cheog,Shimla,Himachal Pradesh',
'Chikar,Shimla,Himachal Pradesh',
'Dehabalson,Shimla,Himachal Pradesh',
'Deothibalson,Shimla,Himachal Pradesh',
'Dhamandari,Shimla,Himachal Pradesh',
'Dharampur Madhan,Shimla,Himachal Pradesh',
'Dharech,Shimla,Himachal Pradesh',
'Fagu,Shimla,Himachal Pradesh',
'Ghoond,Shimla,Himachal Pradesh',
'Jais,Shimla,Himachal Pradesh',
'Kanahar,Shimla,Himachal Pradesh',
'Kandroo,Shimla,Himachal Pradesh',
'Kathog,Shimla,Himachal Pradesh',
'Kelvi,Shimla,Himachal Pradesh',
'Kiar,Shimla,Himachal Pradesh',
'Kiara,Shimla,Himachal Pradesh',
'Kiartoonal,Shimla,Himachal Pradesh',
'Kuthar,Shimla,Himachal Pradesh',
'Lafughati,Shimla,Himachal Pradesh',
'Mahog,Shimla,Himachal Pradesh',
'Mahori,Shimla,Himachal Pradesh',
'Majhar,Shimla,Himachal Pradesh',
'Matiana,Shimla,Himachal Pradesh',
'Mundu,Shimla,Himachal Pradesh',
'Nagjubber,Shimla,Himachal Pradesh',
'Pulbahal,Shimla,Himachal Pradesh',
'Sandhu,Shimla,Himachal Pradesh',
'Sari,Shimla,Himachal Pradesh',
'Sariun,Shimla,Himachal Pradesh',
'Sarog,Shimla,Himachal Pradesh',
'Satog,Shimla,Himachal Pradesh',
'Shari,Shimla,Himachal Pradesh',
'Shilaru,Shimla,Himachal Pradesh',
'Theog,Shimla,Himachal Pradesh',
'Tiyali,Shimla,Himachal Pradesh',
'Shawaga,Solan,Himachal Pradesh',
'Thana Kashoga,Solan,Himachal Pradesh',
'Udaina Kathwar,Solan,Himachal Pradesh',
'Banethi,Solan,Himachal Pradesh',
'Bikram Bag,Solan,Himachal Pradesh',
'Bramapapri,Solan,Himachal Pradesh',
'Chakli,Solan,Himachal Pradesh',
'Jamta,Solan,Himachal Pradesh',
'Kala Amb,Solan,Himachal Pradesh',
'Kw Bhood,Solan,Himachal Pradesh',
'Matar,Solan,Himachal Pradesh',
'Moginand,Solan,Himachal Pradesh',
'Nahan H.O,Solan,Himachal Pradesh',
'Palio,Solan,Himachal Pradesh',
'Panjahal,Solan,Himachal Pradesh',
'Ramadhaun,Solan,Himachal Pradesh',
'Sainwala,Solan,Himachal Pradesh',
'Shambhuwala,Solan,Himachal Pradesh',
'Surla,Solan,Himachal Pradesh',
'Trilokpur,Solan,Himachal Pradesh',
'Nohra,Solan,Himachal Pradesh',
'Bagpashog,Solan,Himachal Pradesh',
'Bagthan,Solan,Himachal Pradesh',
'Banahki Ser,Solan,Himachal Pradesh',
'Baru Sahib,Solan,Himachal Pradesh',
'Bhallan,Solan,Himachal Pradesh',
'Chapand,Solan,Himachal Pradesh',
'Dangyar,Solan,Himachal Pradesh',
'Daro Devria,Solan,Himachal Pradesh',
'Dingar Kinner,Solan,Himachal Pradesh',
'Gagal Shikor,Solan,Himachal Pradesh',
'Janot,Solan,Himachal Pradesh',
'Jehar,Solan,Himachal Pradesh',
'Malhoti,Solan,Himachal Pradesh',
'Mangarh,Solan,Himachal Pradesh',
'Mehandobag,Solan,Himachal Pradesh',
'Narag,Solan,Himachal Pradesh',
'Sarahan,Solan,Himachal Pradesh',
'Sarsoo,Solan,Himachal Pradesh',
'Sharia,Solan,Himachal Pradesh',
'Thakurdwara,Solan,Himachal Pradesh',
'Tikkari Kuthar,Solan,Himachal Pradesh',
'Upron,Solan,Himachal Pradesh',
'Wasni,Solan,Himachal Pradesh',
'Banaur,Solan,Himachal Pradesh',
'Bhagani,Solan,Himachal Pradesh',
'Bharog Baneri,Solan,Himachal Pradesh',
'Bhudhana,Solan,Himachal Pradesh',
'Chacheti,Solan,Himachal Pradesh',
'Danda Anj,Solan,Himachal Pradesh',
'Dhaula Kuan,Solan,Himachal Pradesh',
'Dugana,Solan,Himachal Pradesh',
'Girinagar,Solan,Himachal Pradesh',
'Gorkhuwala,Solan,Himachal Pradesh',
'Haripur Khol,Solan,Himachal Pradesh',
'Jamna,Solan,Himachal Pradesh',
'Jamniwala,Solan,Himachal Pradesh',
'Kamrau,Solan,Himachal Pradesh',
'Kantimashwa,Solan,Himachal Pradesh',
'Khadkan,Solan,Himachal Pradesh',
'Khodri,Solan,Himachal Pradesh',
'Kodga,Solan,Himachal Pradesh',
'Kolar,Solan,Himachal Pradesh',
'Kotribyas,Solan,Himachal Pradesh',
'Majra,Solan,Himachal Pradesh',
'Manpur Devra,Solan,Himachal Pradesh',
'Misserwala,Solan,Himachal Pradesh',
'Nagheta,Solan,Himachal Pradesh',
'Nihalgarh,Solan,Himachal Pradesh',
'Paonta,Solan,Himachal Pradesh',
'Poka,Solan,Himachal Pradesh',
'Puruwala,Solan,Himachal Pradesh',
'Rajban,Solan,Himachal Pradesh',
'Rajpur,Solan,Himachal Pradesh',
'Sainwala Mubarakpur,Solan,Himachal Pradesh',
'Sataun,Solan,Himachal Pradesh',
'Sharlimanpur,Solan,Himachal Pradesh',
'Shivpur,Solan,Himachal Pradesh',
'Tatiana,Solan,Himachal Pradesh',
'Udyankathwad,Solan,Himachal Pradesh',
'Watamandi,Solan,Himachal Pradesh',
'Chogtalli,Solan,Himachal Pradesh',
'Bharoli,Shimla,Himachal Pradesh',
'Bhuira,Solan,Himachal Pradesh',
'Bhujjal,Shimla,Himachal Pradesh',
'Churwadhar,Solan,Himachal Pradesh',
'Dahan,Solan,Himachal Pradesh',
'Deothi Manjghaon,Shimla,Himachal Pradesh',
'Dimber,Solan,Himachal Pradesh',
'Habban,Solan,Himachal Pradesh',
'Kathali Bharan,Solan,Himachal Pradesh',
'Neripul,Shimla,Himachal Pradesh',
'Pabiana,Solan,Himachal Pradesh',
'Rajgarh,Solan,Himachal Pradesh',
'Redughati,Solan,Himachal Pradesh',
'Sanio Didag,Solan,Himachal Pradesh',
'Ser Jegas,Solan,Himachal Pradesh',
'Shaya Chabron,Solan,Himachal Pradesh',
'Thorniwar,Solan,Himachal Pradesh',
'Bhawani,Solan,Himachal Pradesh',
'Devamanal,Solan,Himachal Pradesh',
'Badol,Solan,Himachal Pradesh',
'Rajana,Solan,Himachal Pradesh',
'Sertandula,Solan,Himachal Pradesh',
'Charna,Solan,Himachal Pradesh',
'Andheri,Solan,Himachal Pradesh',
'Badag,Solan,Himachal Pradesh',
'Bhalona,Solan,Himachal Pradesh',
'Bhatgarh,Solan,Himachal Pradesh',
'Bhujond,Solan,Himachal Pradesh',
'Birla,Solan,Himachal Pradesh',
'Bogdhar,Solan,Himachal Pradesh',
'Chalana,Solan,Himachal Pradesh',
'Chaukar,Solan,Himachal Pradesh',
'Dadahu,Solan,Himachal Pradesh',
'Devna,Solan,Himachal Pradesh',
'Ganduri,Solan,Himachal Pradesh',
'Haripurdhar,Solan,Himachal Pradesh',
'Harlog,Solan,Himachal Pradesh',
'Jamu,Solan,Himachal Pradesh',
'Jarag,Solan,Himachal Pradesh',
'Kangta Failag,Solan,Himachal Pradesh',
'Kansar,Solan,Himachal Pradesh',
'Korag,Solan,Himachal Pradesh',
'Korag,Solan,Himachal Pradesh',
'Kotidhiman,Solan,Himachal Pradesh',
'Kotla Molar,Solan,Himachal Pradesh',
'Kuffar Kiara,Solan,Himachal Pradesh',
'Lanacheta,Solan,Himachal Pradesh',
'Lanapalar,Solan,Himachal Pradesh',
'Mohipur,Solan,Himachal Pradesh',
'Panar,Solan,Himachal Pradesh',
'Parada,Solan,Himachal Pradesh',
'Punner,Solan,Himachal Pradesh',
'Redali,Solan,Himachal Pradesh',
'Sainj,Solan,Himachal Pradesh',
'Sangana,Solan,Himachal Pradesh',
'Sangrah,Solan,Himachal Pradesh',
'Seon,Solan,Himachal Pradesh',
'Shivpur,Solan,Himachal Pradesh',
'Bella,Solan,Himachal Pradesh',
'Ronhat,Solan,Himachal Pradesh',
'Kando Bhatnaul,Solan,Himachal Pradesh',
'Bakras,Solan,Himachal Pradesh',
'Gawali,Solan,Himachal Pradesh',
'Hallan,Solan,Himachal Pradesh',
'Jarwa,Solan,Himachal Pradesh',
'Jhakando,Solan,Himachal Pradesh',
'Koti Utraon,Solan,Himachal Pradesh',
'Kotibhunch,Solan,Himachal Pradesh',
'Kyari Gundaha,Solan,Himachal Pradesh',
'Loza,Solan,Himachal Pradesh',
'Manal,Solan,Himachal Pradesh',
'Millah,Solan,Himachal Pradesh',
'Nainidhar,Solan,Himachal Pradesh',
'Panog,Solan,Himachal Pradesh',
'Shilla,Solan,Himachal Pradesh',
'Shillai,Solan,Himachal Pradesh',
'Timbi,Solan,Himachal Pradesh',
'Walikoti,Solan,Himachal Pradesh',
'Baddal Goela,Solan,Himachal Pradesh',
'Badhaunighat,Solan,Himachal Pradesh',
'Baila,Solan,Himachal Pradesh',
'Bandh Bhaguri,Solan,Himachal Pradesh',
'Baruna,Solan,Himachal Pradesh',
'Batoli Kalan,Solan,Himachal Pradesh',
'Beral,Solan,Himachal Pradesh',
'Bhararighat,Solan,Himachal Pradesh',
'Bharti,Solan,Himachal Pradesh',
'Bhatian,Solan,Himachal Pradesh',
'Bhiyunkhari,Solan,Himachal Pradesh',
'Bhogpur,Solan,Himachal Pradesh',
'Bhojnagar,Solan,Himachal Pradesh',
'Bohli,Solan,Himachal Pradesh',
'Chakhar Bughar,Solan,Himachal Pradesh',
'Chamdar,Solan,Himachal Pradesh',
'Chandi,Solan,Himachal Pradesh',
'Chhausa,Solan,Himachal Pradesh',
'Chhiachi,Solan,Himachal Pradesh',
'Dabhota,Solan,Himachal Pradesh',
'Damkari,Solan,Himachal Pradesh',
'Danoghat,Solan,Himachal Pradesh',
'Darla,Solan,Himachal Pradesh',
'Darwa,Solan,Himachal Pradesh',
'Delgi,Solan,Himachal Pradesh',
'Dhakaryana,Solan,Himachal Pradesh',
'Dharmana,Solan,Himachal Pradesh',
'Dhundan,Solan,Himachal Pradesh',
'Doli,Solan,Himachal Pradesh',
'Ekhoo,Solan,Himachal Pradesh',
'Gaighat,Solan,Himachal Pradesh',
'Galanag,Solan,Himachal Pradesh',
'Galote,Solan,Himachal Pradesh',
'Ganghughat,Solan,Himachal Pradesh',
'Garkhal,Solan,Himachal Pradesh',
'Gaura,Solan,Himachal Pradesh',
'Gharsi,Solan,Himachal Pradesh',
'Goela Panner,Solan,Himachal Pradesh',
'Gunahkalan,Solan,Himachal Pradesh',
'Gurumajra,Solan,Himachal Pradesh',
'Hanuman Barog,Solan,Himachal Pradesh',
'Haripur,Solan,Himachal Pradesh',
'Jagjit Nagat,Solan,Himachal Pradesh',
'Jaunaji,Solan,Himachal Pradesh',
'Jhajra,Solan,Himachal Pradesh',
'Joghon,Solan,Himachal Pradesh',
'Jubbar,Solan,Himachal Pradesh',
'Kabakalan,Solan,Himachal Pradesh',
'Kakkar Hatti,Solan,Himachal Pradesh',
'Kalibari,Solan,Himachal Pradesh',
'Kasauli,Solan,Himachal Pradesh',
'Kashlog,Solan,Himachal Pradesh',
'Khera,Solan,Himachal Pradesh',
'Khillian,Solan,Himachal Pradesh',
'Kohu,Solan,Himachal Pradesh',
'Kot,Solan,Himachal Pradesh',
'Kot Beja,Solan,Himachal Pradesh',
'Kotla,Solan,Himachal Pradesh',
'Kujji,Solan,Himachal Pradesh',
'Kumarhatti,Solan,Himachal Pradesh',
'Kundlu,Solan,Himachal Pradesh',
'Kuthar,Solan,Himachal Pradesh',
'Lagdaghat,Solan,Himachal Pradesh',
'Lodhimajra,Solan,Himachal Pradesh',
'Loharghat,Solan,Himachal Pradesh',
'Lunas,Solan,Himachal Pradesh',
'Malera,Solan,Himachal Pradesh',
'Mangal,Solan,Himachal Pradesh',
'Manjholi,Solan,Himachal Pradesh',
'Manjiyat,Solan,Himachal Pradesh',
'Manpura,Solan,Himachal Pradesh',
'Masulkhana,Solan,Himachal Pradesh',
'Matuli,Solan,Himachal Pradesh',
'Mittian,Solan,Himachal Pradesh',
'Nagaon,Solan,Himachal Pradesh',
'Naina Tikkar,Solan,Himachal Pradesh',
'Nalagarh,Solan,Himachal Pradesh',
'Nangal,Solan,Himachal Pradesh',
'Nauni,Solan,Himachal Pradesh',
'Nayagram,Solan,Himachal Pradesh',
'Oachghat,Solan,Himachal Pradesh',
'Panjhera,Solan,Himachal Pradesh',
'Panwa,Solan,Himachal Pradesh',
'Parnoo,Solan,Himachal Pradesh',
'Parwanoo,Solan,Himachal Pradesh',
'Patta,Solan,Himachal Pradesh',
'Piplughat,Solan,Himachal Pradesh',
'Plassaikalan,Solan,Himachal Pradesh',
'Pole Da Khala,Solan,Himachal Pradesh',
'Pratha,Solan,Himachal Pradesh',
'Rajpura,Solan,Himachal Pradesh',
'Rampur,Solan,Himachal Pradesh',
'Ramshahar,Solan,Himachal Pradesh',
'Ratwari,Solan,Himachal Pradesh',
'Reru,Solan,Himachal Pradesh',
'Sanawar,Solan,Himachal Pradesh',
'Saryanj,Solan,Himachal Pradesh',
'Sewra Chandi,Solan,Himachal Pradesh',
'Shamti,Solan,Himachal Pradesh',
'Sour,Solan,Himachal Pradesh',
'Subathu,Solan,Himachal Pradesh',
'Sultanpur,Solan,Himachal Pradesh',
'Taksal,Solan,Himachal Pradesh',
'Bakhalag,Solan,Himachal Pradesh',
'Balera,Solan,Himachal Pradesh',
'Batal,Solan,Himachal Pradesh',
'Bhumati,Solan,Himachal Pradesh',
'Dhayawala,Solan,Himachal Pradesh',
'Domehar,Solan,Himachal Pradesh',
'Jainagar,Solan,Himachal Pradesh',
'Jobri,Solan,Himachal Pradesh',
'Jubla,Solan,Himachal Pradesh',
'Kunhar,Solan,Himachal Pradesh',
'Kunihar,Solan,Himachal Pradesh',
'Maan,Solan,Himachal Pradesh',
'Manjoo,Solan,Himachal Pradesh',
'Materani,Solan,Himachal Pradesh',
'Palania,Solan,Himachal Pradesh',
'Palog,Solan,Himachal Pradesh',
'Shahrol,Solan,Himachal Pradesh',
'Shalaghat,Solan,Himachal Pradesh',
'Sujhaila,Solan,Himachal Pradesh',
'Dangheel,Solan,Himachal Pradesh',
'Dubloo,Solan,Himachal Pradesh',
'Janedghat,Solan,Himachal Pradesh',
'Anji Brahamna,Solan,Himachal Pradesh',
'Arki,Solan,Himachal Pradesh',
'Basha,Solan,Himachal Pradesh',
'Bhainch Kuftoo,Solan,Himachal Pradesh',
'Bisha,Solan,Himachal Pradesh',
'Chail,Solan,Himachal Pradesh',
'Domeharbani,Solan,Himachal Pradesh',
'Hinner,Solan,Himachal Pradesh',
'Jhaja,Solan,Himachal Pradesh',
'Kahala,Solan,Himachal Pradesh',
'Kaitghalighat,Solan,Himachal Pradesh',
'Kandaghat,Solan,Himachal Pradesh',
'Kawarag,Solan,Himachal Pradesh',
'Kiarighat,Solan,Himachal Pradesh',
'Mamlig,Solan,Himachal Pradesh',
'Nagali,Solan,Himachal Pradesh',
'Peeran,Solan,Himachal Pradesh',
'Sayri,Solan,Himachal Pradesh',
'Tikkar,Solan,Himachal Pradesh',
'Tundal,Solan,Himachal Pradesh',
'Sadhupul,Solan,Himachal Pradesh',
'Barotiwala,Solan,Himachal Pradesh',
'Dhar Ki Ber,Solan,Himachal Pradesh',
'Dharampur,Solan,Himachal Pradesh',
'Jabali,Solan,Himachal Pradesh',
'Kanda,Solan,Himachal Pradesh',
'Mandhala,Solan,Himachal Pradesh',
'Mandodhar,Solan,Himachal Pradesh',
'Rouri,Solan,Himachal Pradesh',
'Surajpur,Solan,Himachal Pradesh',
'Baddi,Solan,Himachal Pradesh',
'Bhood,Solan,Himachal Pradesh',
'Haripur Sandoli,Solan,Himachal Pradesh',
'Karuana,Solan,Himachal Pradesh',
'Manpura,Solan,Himachal Pradesh',
'Sai,Solan,Himachal Pradesh',
'Thana,Solan,Himachal Pradesh',
'Thana,Solan,Himachal Pradesh',
'Badhokhari,Solan,Himachal Pradesh',
'Badlag,Solan,Himachal Pradesh',
'Diggal,Solan,Himachal Pradesh',
'Katal,Solan,Himachal Pradesh',
'Manlogkalan,Solan,Himachal Pradesh',
'Basal,Solan,Himachal Pradesh',
'Brauri,Solan,Himachal Pradesh',
'Chambaghat,Solan,Himachal Pradesh',
'Dagshai,Solan,Himachal Pradesh',
'Deothi,Solan,Himachal Pradesh',
'Dharot,Solan,Himachal Pradesh',
'Ghatti,Solan,Himachal Pradesh',
'Koti,Solan,Himachal Pradesh',
'Salogra,Solan,Himachal Pradesh',
'Saproon,Solan,Himachal Pradesh',
'Shardaghat,Solan,Himachal Pradesh',
'Solan Brewery,Solan,Himachal Pradesh',
'Solan H.O,Solan,Himachal Pradesh',
'Amb,Una,Himachal Pradesh',
'Amboa,Una,Himachal Pradesh',
'Ambota,Una,Himachal Pradesh',
'Andora,Una,Himachal Pradesh',
'Babehar,Una,Himachal Pradesh',
'Badoh,Una,Himachal Pradesh',
'Badoli,Una,Himachal Pradesh',
'Batuhi,Una,Himachal Pradesh',
'Bhadarkali,Una,Himachal Pradesh',
'Bhanjal,Una,Himachal Pradesh',
'Bharwain,Una,Himachal Pradesh',
'Bhera,Una,Himachal Pradesh',
'Chaksarai,Una,Himachal Pradesh',
'Chalet,Una,Himachal Pradesh',
'Chintpurni,Una,Himachal Pradesh',
'Chowar,Una,Himachal Pradesh',
'Churru,Una,Himachal Pradesh',
'Daloh,Una,Himachal Pradesh',
'Dangohkalan,Una,Himachal Pradesh',
'Daulatpurchowk,Una,Himachal Pradesh',
'Deoli,Una,Himachal Pradesh',
'Dhalwari,Una,Himachal Pradesh',
'Dhussara,Una,Himachal Pradesh',
'Diara,Una,Himachal Pradesh',
'Gagret,Una,Himachal Pradesh',
'Ganu,Una,Himachal Pradesh',
'Ghanari,Una,Himachal Pradesh',
'Gondpur Banera,Una,Himachal Pradesh',
'Guglehar,Una,Himachal Pradesh',
'Hamboli,Una,Himachal Pradesh',
'Jadla,Una,Himachal Pradesh',
'Jawar,Una,Himachal Pradesh',
'Joh,Una,Himachal Pradesh',
'Kadh,Una,Himachal Pradesh',
'Kaloh,Una,Himachal Pradesh',
'Kalruhi,Una,Himachal Pradesh',
'Katauhar Kalan,Una,Himachal Pradesh',
'Kataur Khurd,Una,Himachal Pradesh',
'Kathiari,Una,Himachal Pradesh',
'Kuneran,Una,Himachal Pradesh',
'Kuthera Jaswalan,Una,Himachal Pradesh',
'Kuthera Kherla,Una,Himachal Pradesh',
'Loharli,Una,Himachal Pradesh',
'Mairi,Una,Himachal Pradesh',
'Marwari,Una,Himachal Pradesh',
'Mawa Kaholan,Una,Himachal Pradesh',
'Mawa Sindhian,Una,Himachal Pradesh',
'Mubarikpur,Una,Himachal Pradesh',
'Nakroh,Una,Himachal Pradesh',
'Nandpur,Una,Himachal Pradesh',
'Nangal Jarialan,Una,Himachal Pradesh',
'Nari,Una,Himachal Pradesh',
'Nehri Nauranga,Una,Himachal Pradesh',
'Oel,Una,Himachal Pradesh',
'Paloh,Una,Himachal Pradesh',
'Panjoa Ladoli,Una,Himachal Pradesh',
'Pirthipur,Una,Himachal Pradesh',
'Polian Purohitan,Una,Himachal Pradesh',
'Rajpur Jaswan,Una,Himachal Pradesh',
'Ripoh Misran,Una,Himachal Pradesh',
'Sagnai,Una,Himachal Pradesh',
'Saloh Beri,Una,Himachal Pradesh',
'Saloi,Una,Himachal Pradesh',
'Sapauri,Una,Himachal Pradesh',
'Satother,Una,Himachal Pradesh',
'Sunkali,Una,Himachal Pradesh',
'Suri,Una,Himachal Pradesh',
'Takarala,Una,Himachal Pradesh',
'Thathal,Una,Himachal Pradesh',
'Ambehra Dhiraj,Una,Himachal Pradesh',
'Arlu,Una,Himachal Pradesh',
'Balh,Una,Himachal Pradesh',
'Bangana,Una,Himachal Pradesh',
'Bhadwar,Una,Himachal Pradesh',
'Bhalaun,Una,Himachal Pradesh',
'Bhindla,Una,Himachal Pradesh',
'Budhan,Una,Himachal Pradesh',
'Chamiari,Una,Himachal Pradesh',
'Charara,Una,Himachal Pradesh',
'Chhaproh,Una,Himachal Pradesh',
'Chowki Maniar,Una,Himachal Pradesh',
'Chulhari,Una,Himachal Pradesh',
'Dhundla,Una,Himachal Pradesh',
'Dohgi Upperli,Una,Himachal Pradesh',
'Ghaloon,Hamirpur,Himachal Pradesh',
'Harot,Una,Himachal Pradesh',
'Hatli,Una,Himachal Pradesh',
'Jassana,Una,Himachal Pradesh',
'Jatehri,Una,Himachal Pradesh',
'Khurwain,Una,Himachal Pradesh',
'Kohdra,Una,Himachal Pradesh',
'Lathiani,Una,Himachal Pradesh',
'Makrer,Una,Himachal Pradesh',
'Malangar,Una,Himachal Pradesh',
'Mandli,Una,Himachal Pradesh',
'Nari Devi Singh,Una,Himachal Pradesh',
'Paroian,Una,Himachal Pradesh',
'Raipur,Una,Himachal Pradesh',
'Sohari,Una,Himachal Pradesh',
'Talmehra,Una,Himachal Pradesh',
'Tanoh,Una,Himachal Pradesh',
'Thanakalan,Una,Himachal Pradesh',
'Thathoon,Una,Himachal Pradesh',
'Arn Behal,Una,Himachal Pradesh',
'Bhater,Una,Himachal Pradesh',
'Dharamsal,Una,Himachal Pradesh',
'Ghangret,Una,Himachal Pradesh',
'Gindpur,Una,Himachal Pradesh',
'Jajjar,Una,Himachal Pradesh',
'Jawal,Una,Himachal Pradesh',
'Kinoo,Una,Himachal Pradesh',
'Lohara,Una,Himachal Pradesh',
'Suhin,Una,Himachal Pradesh',
'Badhera,Una,Himachal Pradesh',
'Baliwal,Una,Himachal Pradesh',
'Bathri,Una,Himachal Pradesh',
'Bathu,Una,Himachal Pradesh',
'Beetan,Una,Himachal Pradesh',
'Bhadauri,Una,Himachal Pradesh',
'Bhadsali,Una,Himachal Pradesh',
'Biderwal,Una,Himachal Pradesh',
'Dharampur,Una,Himachal Pradesh',
'Dulehar,Una,Himachal Pradesh',
'Gondpurbulla,Una,Himachal Pradesh',
'Gondpurjaichand,Una,Himachal Pradesh',
'Haroli,Una,Himachal Pradesh',
'Hiran,Una,Himachal Pradesh',
'Ispur,Una,Himachal Pradesh',
'Kanger,Una,Himachal Pradesh',
'Khad,Una,Himachal Pradesh',
'Kungrat,Una,Himachal Pradesh',
'Kuthar Beet,Una,Himachal Pradesh',
'Lalri,Una,Himachal Pradesh',
'Nangal Kalan,Una,Himachal Pradesh',
'Nangal Khurd,Una,Himachal Pradesh',
'Palakwah,Una,Himachal Pradesh',
'Pandogha,Una,Himachal Pradesh',
'Panjawar,Una,Himachal Pradesh',
'Polian Beet,Una,Himachal Pradesh',
'Pubowal,Una,Himachal Pradesh',
'Sainsowal,Una,Himachal Pradesh',
'Saloh,Una,Himachal Pradesh',
'Santokhgarh,Una,Himachal Pradesh',
'Singan,Una,Himachal Pradesh',
'Ajauli,Una,Himachal Pradesh',
'Badehar,Una,Himachal Pradesh',
'Badsala,Una,Himachal Pradesh',
'Barnoh,Una,Himachal Pradesh',
'Basal,Una,Himachal Pradesh',
'Basdehra,Una,Himachal Pradesh',
'Basoli,Una,Himachal Pradesh',
'Behdala,Una,Himachal Pradesh',
'Bhatoli,Una,Himachal Pradesh',
'Chalola,Una,Himachal Pradesh',
'Charatghar,Una,Himachal Pradesh',
'Chatara,Una,Himachal Pradesh',
'Chhatarpur,Una,Himachal Pradesh',
'Dangoli,Una,Himachal Pradesh',
'Dathwara,Una,Himachal Pradesh',
'Dehlan,Una,Himachal Pradesh',
'Dera Baba Rudra Nand,Una,Himachal Pradesh',
'Dhamandri,Una,Himachal Pradesh',
'Distt.Court Una,Una,Himachal Pradesh',
'Jakhera,Una,Himachal Pradesh',
'Jankaur,Una,Himachal Pradesh',
'Jhamber,Una,Himachal Pradesh',
'Khanpur,Una,Himachal Pradesh',
'Kotla Kalan,Una,Himachal Pradesh',
'Kotla Khurd,Una,Himachal Pradesh',
'Kuriala,Una,Himachal Pradesh',
'Lamlehri,Una,Himachal Pradesh',
'Mehatpur,Una,Himachal Pradesh',
'Nagnoli,Una,Himachal Pradesh',
'Nangal Salangri,Una,Himachal Pradesh',
'Nangran,Una,Himachal Pradesh',
'Panoh,Una,Himachal Pradesh',
'Rainsary,Una,Himachal Pradesh',
'Raipur Sahoran,Una,Himachal Pradesh',
'Rakkar Colony,Una,Himachal Pradesh',
'Samoor Kalan,Una,Himachal Pradesh',
'Sanouli,Una,Himachal Pradesh',
'Tabba Behdala,Una,Himachal Pradesh',
'Takka,Una,Himachal Pradesh',
'Teuri,Una,Himachal Pradesh',
'Una H.O,Una,Himachal Pradesh',
'Ahalangodol,Srinagar,Jammu & Kashmir',
'Akhal,Srinagar,Jammu & Kashmir',
'Akingam,Srinagar,Jammu & Kashmir',
'Anantnag City,Srinagar,Jammu & Kashmir',
'Arrah,Srinagar,Jammu & Kashmir',
'Arwani,Srinagar,Jammu & Kashmir',
'Ashmuji,Srinagar,Jammu & Kashmir',
'Beerwara,Srinagar,Jammu & Kashmir',
'Bijbehara,Srinagar,Jammu & Kashmir',
'Brah,Srinagar,Jammu & Kashmir',
'Brinal Lamar,Srinagar,Jammu & Kashmir',
'Buchoo,Srinagar,Jammu & Kashmir',
'Buchroo,Srinagar,Jammu & Kashmir',
'Bulbul Nowgam,Srinagar,Jammu & Kashmir',
'Bumthan,Srinagar,Jammu & Kashmir',
'Chadder,Srinagar,Jammu & Kashmir',
'Chakilpora,Srinagar,Jammu & Kashmir',
'Chambgund,Srinagar,Jammu & Kashmir',
'Chanderwadi (Sessional),Srinagar,Jammu & Kashmir',
'Chattargui,Srinagar,Jammu & Kashmir',
'Chitragam,Srinagar,Jammu & Kashmir',
'Chowgam,Srinagar,Jammu & Kashmir',
'Dalseer,Srinagar,Jammu & Kashmir',
'Danipora,Srinagar,Jammu & Kashmir',
'Dethunagnarian,Srinagar,Jammu & Kashmir',
'Devsar,Srinagar,Jammu & Kashmir',
'Dhane Bougund,Srinagar,Jammu & Kashmir',
'Dhawtoo,Srinagar,Jammu & Kashmir',
'Digripora,Srinagar,Jammu & Kashmir',
'Fatehpora,Srinagar,Jammu & Kashmir',
'Gadipora,Srinagar,Jammu & Kashmir',
'Gosani Gund,Srinagar,Jammu & Kashmir',
'Guddar,Srinagar,Jammu & Kashmir',
'H.C.Gam,Srinagar,Jammu & Kashmir',
'Hakura Badasgam,Srinagar,Jammu & Kashmir',
'Hardtour,Srinagar,Jammu & Kashmir',
'Hiller Arahama,Srinagar,Jammu & Kashmir',
'Hiller Shahabad,Srinagar,Jammu & Kashmir',
'Hugam,Srinagar,Jammu & Kashmir',
'Janglath Mandi,Srinagar,Jammu & Kashmir',
'Kanilwan,Srinagar,Jammu & Kashmir',
'Kanipora,Srinagar,Jammu & Kashmir',
'Kapran,Srinagar,Jammu & Kashmir',
'Kathsoo,Srinagar,Jammu & Kashmir',
'Kharam,Srinagar,Jammu & Kashmir',
'Kharapora,Srinagar,Jammu & Kashmir',
'Khuri Bhatapora,Srinagar,Jammu & Kashmir',
'Kilam Bazgam,Srinagar,Jammu & Kashmir',
'Krandigam,Srinagar,Jammu & Kashmir',
'Kriri Nowpora,Srinagar,Jammu & Kashmir',
'Kullar,Srinagar,Jammu & Kashmir',
'Laripora,Srinagar,Jammu & Kashmir',
'Larkipora,Srinagar,Jammu & Kashmir',
'Malwan,Srinagar,Jammu & Kashmir',
'Marhama,Srinagar,Jammu & Kashmir',
'Mirhama,Srinagar,Jammu & Kashmir',
'Mnadhole,Srinagar,Jammu & Kashmir',
'Mohind,Srinagar,Jammu & Kashmir',
'Monghal,Srinagar,Jammu & Kashmir',
'Muti Handoo,Srinagar,Jammu & Kashmir',
'Naina,Srinagar,Jammu & Kashmir',
'Nalasundhari,Srinagar,Jammu & Kashmir',
'Nandigam,Srinagar,Jammu & Kashmir',
'Nellow,Srinagar,Jammu & Kashmir',
'Nowbug,Srinagar,Jammu & Kashmir',
'Nowgam,Srinagar,Jammu & Kashmir',
'Nowpora,Srinagar,Jammu & Kashmir',
'Omanagri,Srinagar,Jammu & Kashmir',
'Opzen,Srinagar,Jammu & Kashmir',
'Pahaloo,Srinagar,Jammu & Kashmir',
'Panchtarni(Sessional),Srinagar,Jammu & Kashmir',
'Panzgam,Srinagar,Jammu & Kashmir',
'Pariwan,Srinagar,Jammu & Kashmir',
'Quimoh,Srinagar,Jammu & Kashmir',
'Ratnipora,Srinagar,Jammu & Kashmir',
'Sallar,Srinagar,Jammu & Kashmir',
'Sarnal,Srinagar,Jammu & Kashmir',
'Shalgam,Srinagar,Jammu & Kashmir',
'Shamsipora,Srinagar,Jammu & Kashmir',
'Shangas,Srinagar,Jammu & Kashmir',
'Sheshanag (Sessional),Srinagar,Jammu & Kashmir',
'Shurat,Srinagar,Jammu & Kashmir',
'Sirhama,Srinagar,Jammu & Kashmir',
'Soaf Shali,Srinagar,Jammu & Kashmir',
'Sopat Tougpora,Srinagar,Jammu & Kashmir',
'Srigufwaea,Srinagar,Jammu & Kashmir',
'Telwani,Srinagar,Jammu & Kashmir',
'Tulkhana,Srinagar,Jammu & Kashmir',
'Urranhal,Srinagar,Jammu & Kashmir',
'Utersoo,Srinagar,Jammu & Kashmir',
'Vailobrang,Srinagar,Jammu & Kashmir',
'Vandevalgam,Srinagar,Jammu & Kashmir',
'Vanpoh,Srinagar,Jammu & Kashmir',
'Veeri,Srinagar,Jammu & Kashmir',
'Vessu,Srinagar,Jammu & Kashmir',
'Vokey,Srinagar,Jammu & Kashmir',
'Waghama,Srinagar,Jammu & Kashmir',
'Wallarhama,Srinagar,Jammu & Kashmir',
'Zanipora,Srinagar,Jammu & Kashmir',
'Achabal,Srinagar,Jammu & Kashmir',
'Achan,Srinagar,Jammu & Kashmir',
'Aharbal,Srinagar,Jammu & Kashmir',
'Ahmedabad,Srinagar,Jammu & Kashmir',
'Akura,Srinagar,Jammu & Kashmir',
'Anantnag H.O,Srinagar,Jammu & Kashmir',
'Awenura,Srinagar,Jammu & Kashmir',
'Barsoo,Srinagar,Jammu & Kashmir',
'Behibagh,Srinagar,Jammu & Kashmir',
'Bonagand,Srinagar,Jammu & Kashmir',
'Bugam,Srinagar,Jammu & Kashmir',
'Chimar,Srinagar,Jammu & Kashmir',
'D.H Pora,Srinagar,Jammu & Kashmir',
'D.K Marg,Srinagar,Jammu & Kashmir',
'Daksum,Srinagar,Jammu & Kashmir',
'Demidulla,Srinagar,Jammu & Kashmir',
'Dialgam,Srinagar,Jammu & Kashmir',
'Dooru,Srinagar,Jammu & Kashmir',
'Frisal,Srinagar,Jammu & Kashmir',
'Gopal Pora,Srinagar,Jammu & Kashmir',
'Gopalpora,Srinagar,Jammu & Kashmir',
'Halsidar,Srinagar,Jammu & Kashmir',
'Hutmarah,Srinagar,Jammu & Kashmir',
'Kaprin,Srinagar,Jammu & Kashmir',
'Katrasoo,Srinagar,Jammu & Kashmir',
'Khanabal,Srinagar,Jammu & Kashmir',
'Khigogipora,Srinagar,Jammu & Kashmir',
'Khull,Srinagar,Jammu & Kashmir',
'Kokarnag,Srinagar,Jammu & Kashmir',
'Kragsoo,Srinagar,Jammu & Kashmir',
'Narapora,Srinagar,Jammu & Kashmir',
'Sangam,Srinagar,Jammu & Kashmir',
'Larnoo,Srinagar,Jammu & Kashmir',
'Lower Mundah,Srinagar,Jammu & Kashmir',
'M/gufan,Srinagar,Jammu & Kashmir',
'Manjmoh,Srinagar,Jammu & Kashmir',
'Manzgam,Srinagar,Jammu & Kashmir',
'Martand,Srinagar,Jammu & Kashmir',
'Nambal,Srinagar,Jammu & Kashmir',
'Nandi Marg,Srinagar,Jammu & Kashmir',
'Nanil,Srinagar,Jammu & Kashmir',
'Nasnoor,Srinagar,Jammu & Kashmir',
'Nehama,Srinagar,Jammu & Kashmir',
'Nissu,Srinagar,Jammu & Kashmir',
'Noonmai,Srinagar,Jammu & Kashmir',
'Nowgam,Srinagar,Jammu & Kashmir',
'Phalgam,Srinagar,Jammu & Kashmir',
'Ludhoo,Srinagar,Jammu & Kashmir',
'Mandakpal,Srinagar,Jammu & Kashmir',
'Panzeth,Srinagar,Jammu & Kashmir',
'Chakura,Srinagar,Jammu & Kashmir',
'Chandhara,Srinagar,Jammu & Kashmir',
'Cheersoo,Srinagar,Jammu & Kashmir',
'Gairoo,Srinagar,Jammu & Kashmir',
'Gouripora,Srinagar,Jammu & Kashmir',
'Honipora,Srinagar,Jammu & Kashmir',
'Khanda,Srinagar,Jammu & Kashmir',
'Konibal,Srinagar,Jammu & Kashmir',
'Lathpora,Srinagar,Jammu & Kashmir',
'Litter,Srinagar,Jammu & Kashmir',
'Nehama,Srinagar,Jammu & Kashmir',
'Sambura,Srinagar,Jammu & Kashmir',
'Sugan,Srinagar,Jammu & Kashmir',
'Wachi,Srinagar,Jammu & Kashmir',
'Wasoora,Srinagar,Jammu & Kashmir',
'Zantrag,Srinagar,Jammu & Kashmir',
'Qanmar,Srinagar,Jammu & Kashmir',
'Qazigund,Srinagar,Jammu & Kashmir',
'Ranbirpora,Srinagar,Jammu & Kashmir',
'Reban Gund,Srinagar,Jammu & Kashmir',
'Sadinare,Srinagar,Jammu & Kashmir',
'Hef Shermal,Srinagar,Jammu & Kashmir',
'Turka Wangam,Srinagar,Jammu & Kashmir',
'Tarigam,Srinagar,Jammu & Kashmir',
'Verinaag,Srinagar,Jammu & Kashmir',
'Wangund,Srinagar,Jammu & Kashmir',
'Yarkhoshipora,Srinagar,Jammu & Kashmir',
'Yaripora,Srinagar,Jammu & Kashmir',
'Babareshi,Srinagar,Jammu & Kashmir',
'Chandilora,Srinagar,Jammu & Kashmir',
'Ferozpora,Srinagar,Jammu & Kashmir',
'Hajhal,Srinagar,Jammu & Kashmir',
'Hardichhloo,Srinagar,Jammu & Kashmir',
'Hariwatnoo,Srinagar,Jammu & Kashmir',
'Ajas,Baramulla,Jammu & Kashmir',
'Aloosa,Baramulla,Jammu & Kashmir',
'Arin,Baramulla,Jammu & Kashmir',
'Ashtingoo,Baramulla,Jammu & Kashmir',
'Ayatmulla,Baramulla,Jammu & Kashmir',
'Bandipora Chowk,Baramulla,Jammu & Kashmir',
'Bandipora,Baramulla,Jammu & Kashmir',
'Bankote,Baramulla,Jammu & Kashmir',
'Chetti Bandi,Baramulla,Jammu & Kashmir',
'Chutimulla,Baramulla,Jammu & Kashmir',
'Gamroo,Baramulla,Jammu & Kashmir',
'Garoora,Baramulla,Jammu & Kashmir',
'Kaloosa,Baramulla,Jammu & Kashmir',
'Khenusa,Baramulla,Jammu & Kashmir',
'Lawaypora,Baramulla,Jammu & Kashmir',
'Malangam,Baramulla,Jammu & Kashmir',
'Mantrigam,Baramulla,Jammu & Kashmir',
'Nadihal,Baramulla,Jammu & Kashmir',
'Onagam,Baramulla,Jammu & Kashmir',
'Quilmuqam,Baramulla,Jammu & Kashmir',
'Sonerwani,Baramulla,Jammu & Kashmir',
'Sultanpora,Baramulla,Jammu & Kashmir',
'Watpora,Baramulla,Jammu & Kashmir',
'Baramulla H.O,Baramulla,Jammu & Kashmir',
'Binner,Baramulla,Jammu & Kashmir',
'Chandooda,Baramulla,Jammu & Kashmir',
'Dangiwacha,Baramulla,Jammu & Kashmir',
'Delina,Baramulla,Jammu & Kashmir',
'Gantmulla,Baramulla,Jammu & Kashmir',
'Gohan,Baramulla,Jammu & Kashmir',
'Heavan,Baramulla,Jammu & Kashmir',
'Kachawa Muqam,Baramulla,Jammu & Kashmir',
'Kalantra,Baramulla,Jammu & Kashmir',
'Kanispora,Baramulla,Jammu & Kashmir',
'Khadnyar,Baramulla,Jammu & Kashmir',
'Khaitangan,Baramulla,Jammu & Kashmir',
'Khanpora,Baramulla,Jammu & Kashmir',
'Khawaja Bagh,Baramulla,Jammu & Kashmir',
'Laridora,Baramulla,Jammu & Kashmir',
'Malpora,Baramulla,Jammu & Kashmir',
'Nowpora,Baramulla,Jammu & Kashmir',
'Rajghat,Baramulla,Jammu & Kashmir',
'Shitloo,Baramulla,Jammu & Kashmir',
'Shree,Baramulla,Jammu & Kashmir',
'Singhpora,Baramulla,Jammu & Kashmir',
'Ushukura,Baramulla,Jammu & Kashmir',
'Wagoora,Baramulla,Jammu & Kashmir',
'Gulmarg,Srinagar,Jammu & Kashmir',
'Achoora,Baramulla,Jammu & Kashmir',
'Baduab,Baramulla,Jammu & Kashmir',
'Badugam,Baramulla,Jammu & Kashmir',
'Bagtore,Baramulla,Jammu & Kashmir',
'Barnoi Kashpeth,Baramulla,Jammu & Kashmir',
'Gujran,Baramulla,Jammu & Kashmir',
'Gurez,Baramulla,Jammu & Kashmir',
'Kanzalwan,Baramulla,Jammu & Kashmir',
'Markoot,Baramulla,Jammu & Kashmir',
'Puranatilel,Baramulla,Jammu & Kashmir',
'Saradab,Baramulla,Jammu & Kashmir',
'Tarbal,Baramulla,Jammu & Kashmir',
'Wampora,Baramulla,Jammu & Kashmir',
'Langate,Baramulla,Jammu & Kashmir',
'Magam,Srinagar,Jammu & Kashmir',
'Andergam,Baramulla,Jammu & Kashmir',
'Athoora,Baramulla,Jammu & Kashmir',
'Check Sariwarpora,Baramulla,Jammu & Kashmir',
'Ganasthan,Baramulla,Jammu & Kashmir',
'Goshbugh,Baramulla,Jammu & Kashmir',
'Gund Ibrahim,Baramulla,Jammu & Kashmir',
'Gund Kh. Qasim,Srinagar,Jammu & Kashmir',
'Hanjiwera,Baramulla,Jammu & Kashmir',
'Khaipora,Baramulla,Jammu & Kashmir',
'Khanpeth,Baramulla,Jammu & Kashmir',
'Khore,Baramulla,Jammu & Kashmir',
'Kreeri,Baramulla,Jammu & Kashmir',
'Lalpora Bangil,Baramulla,Jammu & Kashmir',
'Malmoh,Srinagar,Jammu & Kashmir',
'Mamoosa,Baramulla,Jammu & Kashmir',
'Matipora,Baramulla,Jammu & Kashmir',
'Mirgund,Baramulla,Jammu & Kashmir',
'Nehalpora,Baramulla,Jammu & Kashmir',
'Palhallan,Baramulla,Jammu & Kashmir',
'Pattan,Baramulla,Jammu & Kashmir',
'Saloosa,Baramulla,Jammu & Kashmir',
'Seru Dangerpora,Baramulla,Jammu & Kashmir',
'Shirpora Bangil,Baramulla,Jammu & Kashmir',
'Singhpora,Baramulla,Jammu & Kashmir',
'Tapper Waripora,Baramulla,Jammu & Kashmir',
'Tarhama,Srinagar,Jammu & Kashmir',
'Tilgam,Baramulla,Jammu & Kashmir',
'Wail Kralpora,Srinagar,Jammu & Kashmir',
'Wanigam,Baramulla,Jammu & Kashmir',
'Yal,Baramulla,Jammu & Kashmir',
'Amchikundal,Baramulla,Jammu & Kashmir',
'Batvina,Baramulla,Jammu & Kashmir',
'Gund Jahangir,Baramulla,Jammu & Kashmir',
'Hajin,Baramulla,Jammu & Kashmir',
'Madwan,Baramulla,Jammu & Kashmir',
'Naidkhai,Baramulla,Jammu & Kashmir',
'Nesbal,Baramulla,Jammu & Kashmir',
'Nowgam,Baramulla,Jammu & Kashmir',
'Panzinara,Baramulla,Jammu & Kashmir',
'Shadipora,Baramulla,Jammu & Kashmir',
'Shahgund,Baramulla,Jammu & Kashmir',
'Sonawari,Baramulla,Jammu & Kashmir',
'Sultanpora,Baramulla,Jammu & Kashmir',
'Ashpora,Baramulla,Jammu & Kashmir',
'Balhama,Baramulla,Jammu & Kashmir',
'Behrampora,Baramulla,Jammu & Kashmir',
'Bomai,Baramulla,Jammu & Kashmir',
'Botingoo,Baramulla,Jammu & Kashmir',
'Bulgam,Baramulla,Jammu & Kashmir',
'Chatloosa,Baramulla,Jammu & Kashmir',
'Chatoosa,Baramulla,Jammu & Kashmir',
'Chijhama,Baramulla,Jammu & Kashmir',
'Dangerpora,Baramulla,Jammu & Kashmir',
'Doabgah,Baramulla,Jammu & Kashmir',
'Dooru,Baramulla,Jammu & Kashmir',
'Hadipora,Baramulla,Jammu & Kashmir',
'Haigam,Baramulla,Jammu & Kashmir',
'Harduchanam,Baramulla,Jammu & Kashmir',
'Hardushiva,Baramulla,Jammu & Kashmir',
'Harwan,Baramulla,Jammu & Kashmir',
'Hathlangoo,Baramulla,Jammu & Kashmir',
'Jamia Qadim,Baramulla,Jammu & Kashmir',
'Khahmoh,Baramulla,Jammu & Kashmir',
'Krankshivam,Baramulla,Jammu & Kashmir',
'Ladoora,Baramulla,Jammu & Kashmir',
'Met , Sopore,Baramulla,Jammu & Kashmir',
'Mundji,Baramulla,Jammu & Kashmir',
'Nadihal,Baramulla,Jammu & Kashmir',
'Nowpora,Baramulla,Jammu & Kashmir',
'Panzala,Baramulla,Jammu & Kashmir',
'Rengpeth,Baramulla,Jammu & Kashmir',
'Rohama,Baramulla,Jammu & Kashmir',
'Sagipora,Baramulla,Jammu & Kashmir',
'Sangrama,Baramulla,Jammu & Kashmir',
'Seelu,Baramulla,Jammu & Kashmir',
'Seer,Baramulla,Jammu & Kashmir',
'Sopore Chowk,Baramulla,Jammu & Kashmir',
'Tujar,Baramulla,Jammu & Kashmir',
'Wadoora,Baramulla,Jammu & Kashmir',
'Warpora,Baramulla,Jammu & Kashmir',
'Watergam,Baramulla,Jammu & Kashmir',
'Watlab,Baramulla,Jammu & Kashmir',
'Zaloora,Baramulla,Jammu & Kashmir',
'Zethan,Baramulla,Jammu & Kashmir',
'Sopore,Baramulla,Jammu & Kashmir',
'Asham,Baramulla,Jammu & Kashmir',
'Chiva,Baramulla,Jammu & Kashmir',
'Hakbara,Baramulla,Jammu & Kashmir',
'Sadadkootbala,Baramulla,Jammu & Kashmir',
'Sadunara,Baramulla,Jammu & Kashmir',
'Safapora,Baramulla,Jammu & Kashmir',
'Chandil Waniyam,Srinagar,Jammu & Kashmir',
'Devbugh,Srinagar,Jammu & Kashmir',
'Devpora,Srinagar,Jammu & Kashmir',
'Hard Ahoora,Srinagar,Jammu & Kashmir',
'Hard Shora,Srinagar,Jammu & Kashmir',
'Kawarahama,Srinagar,Jammu & Kashmir',
'Kralweth,Srinagar,Jammu & Kashmir',
'Kunzar,Srinagar,Jammu & Kashmir',
'Mulgam,Srinagar,Jammu & Kashmir',
'Tangmarg,Srinagar,Jammu & Kashmir',
'Balkote,Baramulla,Jammu & Kashmir',
'Bijhama,Baramulla,Jammu & Kashmir',
'Boniyar,Baramulla,Jammu & Kashmir',
'Chandanwari,Baramulla,Jammu & Kashmir',
'Dachi,Baramulla,Jammu & Kashmir',
'Dhanisaidan,Baramulla,Jammu & Kashmir',
'Garkote,Baramulla,Jammu & Kashmir',
'Gingle,Baramulla,Jammu & Kashmir',
'Ijara,Baramulla,Jammu & Kashmir',
'Isham,Baramulla,Jammu & Kashmir',
'Jabla,Baramulla,Jammu & Kashmir',
'Kamalkote,Baramulla,Jammu & Kashmir',
'Lachipora,Baramulla,Jammu & Kashmir',
'Mohara,Baramulla,Jammu & Kashmir',
'Nambla,Baramulla,Jammu & Kashmir',
'Nowshera,Baramulla,Jammu & Kashmir',
'Parampilla,Baramulla,Jammu & Kashmir',
'Pringal,Baramulla,Jammu & Kashmir',
'Salamabad,Baramulla,Jammu & Kashmir',
'Salamabad,Baramulla,Jammu & Kashmir',
'Sultan Daki,Baramulla,Jammu & Kashmir',
'Tarzoo,Baramulla,Jammu & Kashmir',
'Trikanjan,Baramulla,Jammu & Kashmir',
'Uri,Baramulla,Jammu & Kashmir',
'Arigam,Srinagar,Jammu & Kashmir',
'Bandipora,Srinagar,Jammu & Kashmir',
'Bogam Batapora,Srinagar,Jammu & Kashmir',
'Brinjan,Srinagar,Jammu & Kashmir',
'Chattergam,Srinagar,Jammu & Kashmir',
'Gogjipathri,Srinagar,Jammu & Kashmir',
'Hamhama,Srinagar,Jammu & Kashmir',
'Hanjura,Srinagar,Jammu & Kashmir',
'Hayatpora,Srinagar,Jammu & Kashmir',
'Khan Shaib,Srinagar,Jammu & Kashmir',
'Nowgam,Srinagar,Jammu & Kashmir',
'Rangreth,Srinagar,Jammu & Kashmir',
'Wathura,Srinagar,Jammu & Kashmir',
'Abhama,Srinagar,Jammu & Kashmir',
'Arath,Srinagar,Jammu & Kashmir',
'Kralpora,Srinagar,Jammu & Kashmir',
'Bandgam,Srinagar,Jammu & Kashmir',
'Beerwah,Srinagar,Jammu & Kashmir',
'Chanthan Checkpora,Srinagar,Jammu & Kashmir',
'Chewdarah,Srinagar,Jammu & Kashmir',
'Dachan,Srinagar,Jammu & Kashmir',
'H Panzu,Srinagar,Jammu & Kashmir',
'Iskanderpora,Srinagar,Jammu & Kashmir',
'Kandoora,Srinagar,Jammu & Kashmir',
'Kanihama,Srinagar,Jammu & Kashmir',
'Kawoosa Khalisa,Srinagar,Jammu & Kashmir',
'Khag,Srinagar,Jammu & Kashmir',
'Lalpora,Srinagar,Jammu & Kashmir',
'Narhal,Srinagar,Jammu & Kashmir',
'Otligam,Srinagar,Jammu & Kashmir',
'Peth Kanihama,Srinagar,Jammu & Kashmir',
'Peth Makhama,Srinagar,Jammu & Kashmir',
'Poshkar,Srinagar,Jammu & Kashmir',
'Qumroo,Srinagar,Jammu & Kashmir',
'Raiyar,Srinagar,Jammu & Kashmir',
'Ratsoon,Srinagar,Jammu & Kashmir',
'Sail,Srinagar,Jammu & Kashmir',
'Sanoorkalipora,Srinagar,Jammu & Kashmir',
'Shonglipora,Srinagar,Jammu & Kashmir',
'Zugu Khyran,Srinagar,Jammu & Kashmir',
'Budgam,Srinagar,Jammu & Kashmir',
'Sk Airport,Srinagar,Jammu & Kashmir',
'Chadoora,Srinagar,Jammu & Kashmir',
'Pahroo,Srinagar,Jammu & Kashmir',
'Char-sharief,Srinagar,Jammu & Kashmir',
'Darwan Nawgam,Srinagar,Jammu & Kashmir',
'Gariend,Srinagar,Jammu & Kashmir',
'Hardudalwan,Srinagar,Jammu & Kashmir',
'Hyderpora,Srinagar,Jammu & Kashmir',
'Ichgam,Srinagar,Jammu & Kashmir',
'Jawalapora,Srinagar,Jammu & Kashmir',
'Kachwari,Srinagar,Jammu & Kashmir',
'Kenidajan,Srinagar,Jammu & Kashmir',
'Kenihama,Srinagar,Jammu & Kashmir',
'Krim Shore,Srinagar,Jammu & Kashmir',
'Lalgam,Srinagar,Jammu & Kashmir',
'Later Chadoora,Srinagar,Jammu & Kashmir',
'Nagam,Srinagar,Jammu & Kashmir',
'Natipora,Srinagar,Jammu & Kashmir',
'Nowgam,Srinagar,Jammu & Kashmir',
'Ompora,Srinagar,Jammu & Kashmir',
'Pakherpora,Srinagar,Jammu & Kashmir',
'R N Hall,Srinagar,Jammu & Kashmir',
'Raithan,Srinagar,Jammu & Kashmir',
'Rangar,Srinagar,Jammu & Kashmir',
'Sagam,Srinagar,Jammu & Kashmir',
'Soibugh,Srinagar,Jammu & Kashmir',
'Sanat Nagar,Srinagar,Jammu & Kashmir',
'Shogapora,Srinagar,Jammu & Kashmir',
'Sholipora,Srinagar,Jammu & Kashmir',
'Suraryan,Srinagar,Jammu & Kashmir',
'Wanpora,Srinagar,Jammu & Kashmir',
'Watakala,Srinagar,Jammu & Kashmir',
'Watterhail,Srinagar,Jammu & Kashmir',
'Bhaderwah,Udhampur,Jammu & Kashmir',
'Bhalla,Udhampur,Jammu & Kashmir',
'Bhalra,Udhampur,Jammu & Kashmir',
'Chanichinta,Udhampur,Jammu & Kashmir',
'Chattarsori,Udhampur,Jammu & Kashmir',
'Kursari,Udhampur,Jammu & Kashmir',
'Malhoti,Udhampur,Jammu & Kashmir',
'Sungli Sartingal,Udhampur,Jammu & Kashmir',
'Udrana,Udhampur,Jammu & Kashmir',
'Bajarni,Udhampur,Jammu & Kashmir',
'Beoli,Udhampur,Jammu & Kashmir',
'Bhagwa,Udhampur,Jammu & Kashmir',
'Bhalla,Udhampur,Jammu & Kashmir',
'Bhatni,Udhampur,Jammu & Kashmir',
'Chachwa,Udhampur,Jammu & Kashmir',
'Chirala,Udhampur,Jammu & Kashmir',
'Dachhan,Udhampur,Jammu & Kashmir',
'Dalwah,Udhampur,Jammu & Kashmir',
'Deedah,Udhampur,Jammu & Kashmir',
'Dessa,Udhampur,Jammu & Kashmir',
'Dhandal,Udhampur,Jammu & Kashmir',
'Dhara,Udhampur,Jammu & Kashmir',
'Dharamkund,Udhampur,Jammu & Kashmir',
'Doda,Udhampur,Jammu & Kashmir',
'Gandri,Udhampur,Jammu & Kashmir',
'Ganika,Udhampur,Jammu & Kashmir',
'Ghat,Udhampur,Jammu & Kashmir',
'Goha,Udhampur,Jammu & Kashmir',
'Gool,Udhampur,Jammu & Kashmir',
'Gundna,Udhampur,Jammu & Kashmir',
'Humble,Udhampur,Jammu & Kashmir',
'Ind,Udhampur,Jammu & Kashmir',
'Jodhpur,Udhampur,Jammu & Kashmir',
'Jogote,Udhampur,Jammu & Kashmir',
'Kanga,Udhampur,Jammu & Kashmir',
'Kastigarh,Udhampur,Jammu & Kashmir',
'Khalaini,Udhampur,Jammu & Kashmir',
'Maitra Bazar,Udhampur,Jammu & Kashmir',
'Malhori,Udhampur,Jammu & Kashmir',
'Malhota,Udhampur,Jammu & Kashmir',
'Malindal,Udhampur,Jammu & Kashmir',
'Mangota,Udhampur,Jammu & Kashmir',
'Manlnai,Udhampur,Jammu & Kashmir',
'Mohalla,Udhampur,Jammu & Kashmir',
'Mundhar,Udhampur,Jammu & Kashmir',
'Nai Bhalara,Udhampur,Jammu & Kashmir',
'Premnagar,Udhampur,Jammu & Kashmir',
'Puldoda,Udhampur,Jammu & Kashmir',
'Ramban Kutchery,Udhampur,Jammu & Kashmir',
'Roat,Udhampur,Jammu & Kashmir',
'Rukali,Udhampur,Jammu & Kashmir',
'Sangaldhan,Udhampur,Jammu & Kashmir',
'Shiva,Udhampur,Jammu & Kashmir',
'Sindra,Udhampur,Jammu & Kashmir',
'Thatharka,Udhampur,Jammu & Kashmir',
'Trewan,Udhampur,Jammu & Kashmir',
'Udyanpur,Udhampur,Jammu & Kashmir',
'Aftee,Udhampur,Jammu & Kashmir',
'Badhat,Udhampur,Jammu & Kashmir',
'Chhatroo,Udhampur,Jammu & Kashmir',
'Chingam,Udhampur,Jammu & Kashmir',
'Dachhan,Udhampur,Jammu & Kashmir',
'Dool,Udhampur,Jammu & Kashmir',
'Dul Hasti Project,Udhampur,Jammu & Kashmir',
'Galhar,Udhampur,Jammu & Kashmir',
'Gulabgarh,Udhampur,Jammu & Kashmir',
'Inderwal,Udhampur,Jammu & Kashmir',
'Kandni,Udhampur,Jammu & Kashmir',
'Kishtwar,Udhampur,Jammu & Kashmir',
'Kukerwas,Udhampur,Jammu & Kashmir',
'Kutal,Udhampur,Jammu & Kashmir',
'Mandel,Udhampur,Jammu & Kashmir',
'Mugal Maidan,Udhampur,Jammu & Kashmir',
'Nowpachi,Udhampur,Jammu & Kashmir',
'Padar,Udhampur,Jammu & Kashmir',
'Palmar,Udhampur,Jammu & Kashmir',
'Pechhal,Udhampur,Jammu & Kashmir',
'Sarthal,Udhampur,Jammu & Kashmir',
'Sidgi,Udhampur,Jammu & Kashmir',
'Tagood,Udhampur,Jammu & Kashmir',
'Thakrai,Udhampur,Jammu & Kashmir',
'Alambas,Udhampur,Jammu & Kashmir',
'Assar,Udhampur,Jammu & Kashmir',
'Baggar,Udhampur,Jammu & Kashmir',
'Banihal,Udhampur,Jammu & Kashmir',
'Batote,Udhampur,Jammu & Kashmir',
'Batroo,Udhampur,Jammu & Kashmir',
'Bhartund,Udhampur,Jammu & Kashmir',
'Chakka,Udhampur,Jammu & Kashmir',
'Chambalwas,Udhampur,Jammu & Kashmir',
'Chanderkot,Udhampur,Jammu & Kashmir',
'Chareel,Udhampur,Jammu & Kashmir',
'Duligam,Udhampur,Jammu & Kashmir',
'Halla,Udhampur,Jammu & Kashmir',
'Hoochak,Udhampur,Jammu & Kashmir',
'Kainthi,Udhampur,Jammu & Kashmir',
'Kaskoot,Udhampur,Jammu & Kashmir',
'Katyara,Udhampur,Jammu & Kashmir',
'Khari,Udhampur,Jammu & Kashmir',
'Khorial,Udhampur,Jammu & Kashmir',
'Kundi Karol,Udhampur,Jammu & Kashmir',
'Mahu,Udhampur,Jammu & Kashmir',
'Maligam,Udhampur,Jammu & Kashmir',
'Mangat,Udhampur,Jammu & Kashmir',
'Neel,Udhampur,Jammu & Kashmir',
'Neera,Udhampur,Jammu & Kashmir',
'Paristan,Udhampur,Jammu & Kashmir',
'Peera,Udhampur,Jammu & Kashmir',
'Pogal,Udhampur,Jammu & Kashmir',
'Porandhar,Udhampur,Jammu & Kashmir',
'Ramban,Udhampur,Jammu & Kashmir',
'Ramsu,Udhampur,Jammu & Kashmir',
'Ranka,Udhampur,Jammu & Kashmir',
'Samthi,Udhampur,Jammu & Kashmir',
'Sanasar,Udhampur,Jammu & Kashmir',
'Sawni,Udhampur,Jammu & Kashmir',
'Tarigam,Udhampur,Jammu & Kashmir',
'Thathar,Udhampur,Jammu & Kashmir',
'Thopal,Udhampur,Jammu & Kashmir',
'Topnel Chuchter,Udhampur,Jammu & Kashmir',
'Tringla,Udhampur,Jammu & Kashmir',
'Trungal,Udhampur,Jammu & Kashmir',
'Banoon,Udhampur,Jammu & Kashmir',
'Chilli,Udhampur,Jammu & Kashmir',
'Chouri,Udhampur,Jammu & Kashmir',
'Dhesa,Udhampur,Jammu & Kashmir',
'Gandoh,Udhampur,Jammu & Kashmir',
'Inharrah,Udhampur,Jammu & Kashmir',
'Jakyas,Udhampur,Jammu & Kashmir',
'Jora,Udhampur,Jammu & Kashmir',
'Kaljugasar,Udhampur,Jammu & Kashmir',
'Kilhotran,Udhampur,Jammu & Kashmir',
'Malanoo,Udhampur,Jammu & Kashmir',
'Nodinalla,Udhampur,Jammu & Kashmir',
'Thathri,Udhampur,Jammu & Kashmir',
'Bain Bajalta,Jammu,Jammu & Kashmir',
'Chak Salaria,Jammu,Jammu & Kashmir',
'Chandu Chak,Jammu,Jammu & Kashmir',
'Extra,Jammu,Jammu & Kashmir',
'Gharana,Jammu,Jammu & Kashmir',
'Guo Brahmna,Jammu,Jammu & Kashmir',
'Jammu Market,Jammu,Jammu & Kashmir',
'Khour Devian,Jammu,Jammu & Kashmir',
'Koulpur,Jammu,Jammu & Kashmir',
'Majeen,Jammu,Jammu & Kashmir',
'Sidhra Housing Colony,Jammu,Jammu & Kashmir',
'A.G.Office,Jammu,Jammu & Kashmir',
'Abtal,Jammu,Jammu & Kashmir',
'Adlehar,Jammu,Jammu & Kashmir',
'Agra Chak,Jammu,Jammu & Kashmir',
'Aitham,Jammu,Jammu & Kashmir',
'Akalpur,Jammu,Jammu & Kashmir',
'Akhnoor,Jammu,Jammu & Kashmir',
'Allah,Jammu,Jammu & Kashmir',
'Ambaran,Jammu,Jammu & Kashmir',
'Arnia,Jammu,Jammu & Kashmir',
'Badyal Brahmna,Jammu,Jammu & Kashmir',
'Bain Bajalta,Jammu,Jammu & Kashmir',
'Bakore,Jammu,Jammu & Kashmir',
'Bakshinagar,Jammu,Jammu & Kashmir',
'Bala,Jammu,Jammu & Kashmir',
'Bamal Colony,Jammu,Jammu & Kashmir',
'Banachak,Jammu,Jammu & Kashmir',
'Bantalab,Jammu,Jammu & Kashmir',
'Baran,Jammu,Jammu & Kashmir',
'Bardoh,Jammu,Jammu & Kashmir',
'Bari Brahmna I/complex,Jammu,Jammu & Kashmir',
'Bari Brahmna,Jammu,Jammu & Kashmir',
'Barigarh,Jammu,Jammu & Kashmir',
'Batehra,Jammu,Jammu & Kashmir',
'Bhadrod,Jammu,Jammu & Kashmir',
'Bhalwal Brahmna,Jammu,Jammu & Kashmir',
'Bhalwal,Jammu,Jammu & Kashmir',
'Bhatyari,Jammu,Jammu & Kashmir',
'Bhour Camp,Jammu,Jammu & Kashmir',
'Birpur,Jammu,Jammu & Kashmir',
'Bishnah Adda,Jammu,Jammu & Kashmir',
'Bishnah,Jammu,Jammu & Kashmir',
'Brui,Jammu,Jammu & Kashmir',
'Bsf Camp Paloura,Jammu,Jammu & Kashmir',
'Chak Chimna,Jammu,Jammu & Kashmir',
'Chak Kirpalpur,Jammu,Jammu & Kashmir',
'Chak Malal,Jammu,Jammu & Kashmir',
'Chak Shama,Jammu,Jammu & Kashmir',
'Chak Umrah,Jammu,Jammu & Kashmir',
'Chakrohi,Jammu,Jammu & Kashmir',
'Chani Himat,Jammu,Jammu & Kashmir',
'Chohala,Jammu,Jammu & Kashmir',
'Chowadi,Jammu,Jammu & Kashmir',
'Chowki Choura,Jammu,Jammu & Kashmir',
'Dablehar,Jammu,Jammu & Kashmir',
'Dansal,Jammu,Jammu & Kashmir',
'Danwal,Jammu,Jammu & Kashmir',
'Darap,Jammu,Jammu & Kashmir',
'Darbargarh,Jammu,Jammu & Kashmir',
'Datial,Jammu,Jammu & Kashmir',
'Deoli,Jammu,Jammu & Kashmir',
'Devipur,Jammu,Jammu & Kashmir',
'Dhana Dhanean,Jammu,Jammu & Kashmir',
'Dhiani,Jammu,Jammu & Kashmir',
'Dhoke Khalsa,Jammu,Jammu & Kashmir',
'Dhounthly Bazar,Jammu,Jammu & Kashmir',
'Doori Dugar,Jammu,Jammu & Kashmir',
'Dumana,Jammu,Jammu & Kashmir',
'Faloura,Jammu,Jammu & Kashmir',
'Gadigarh,Jammu,Jammu & Kashmir',
'Gajansoo,Jammu,Jammu & Kashmir',
'Gandharwan,Jammu,Jammu & Kashmir',
'Gandhinagar H.O,Jammu,Jammu & Kashmir',
'Gangyal,Jammu,Jammu & Kashmir',
'Garkhal,Jammu,Jammu & Kashmir',
'General Bus Stand,Jammu,Jammu & Kashmir',
'Ghar Majoor,Jammu,Jammu & Kashmir',
'Gharatal,Jammu,Jammu & Kashmir',
'Gharota,Jammu,Jammu & Kashmir',
'Gho Manhasan,Jammu,Jammu & Kashmir',
'Gigrial,Jammu,Jammu & Kashmir',
'Gol Gujral,Jammu,Jammu & Kashmir',
'Goondla,Jammu,Jammu & Kashmir',
'Goran,Jammu,Jammu & Kashmir',
'Gura Manhasan,Jammu,Jammu & Kashmir',
'Gurah Salathia,Jammu,Jammu & Kashmir',
'Gurha Brahmna,Jammu,Jammu & Kashmir',
'Guru Nanak Nagar,Jammu,Jammu & Kashmir',
'Halqa,Jammu,Jammu & Kashmir',
'Hamirpur Sidhar,Jammu,Jammu & Kashmir',
'Industrial Estate,Jammu,Jammu & Kashmir',
'J.Kotli,Jammu,Jammu & Kashmir',
'J.N.V. Nud,Jammu,Jammu & Kashmir',
'Jagti,Jammu,Jammu & Kashmir',
'Jakh,Jammu,Jammu & Kashmir',
'Jammu Cantt,Jammu,Jammu & Kashmir',
'Jammu H.O,Jammu,Jammu & Kashmir',
'Jandial,Jammu,Jammu & Kashmir',
'Janipur,Jammu,Jammu & Kashmir',
'Jassore,Jammu,Jammu & Kashmir',
'Jindrah,Jammu,Jammu & Kashmir',
'Jourian,Jammu,Jammu & Kashmir',
'Kachi Chowni,Jammu,Jammu & Kashmir',
'Kaink Jagir,Jammu,Jammu & Kashmir',
'Kakrai,Jammu,Jammu & Kashmir',
'Kaleetg,Jammu,Jammu & Kashmir',
'Kalibari,Jammu,Jammu & Kashmir',
'Kalu Chak,Jammu,Jammu & Kashmir',
'Kalyana,Jammu,Jammu & Kashmir',
'Kanachak,Jammu,Jammu & Kashmir',
'Kanachirgal,Jammu,Jammu & Kashmir',
'Kandoli Nagrota,Jammu,Jammu & Kashmir',
'Kangrial,Jammu,Jammu & Kashmir',
'Kanhal,Jammu,Jammu & Kashmir',
'Kanyala,Jammu,Jammu & Kashmir',
'Karan Nagar,Jammu,Jammu & Kashmir',
'Karloop,Jammu,Jammu & Kashmir',
'Kathar,Jammu,Jammu & Kashmir',
'Kesomanhasan,Jammu,Jammu & Kashmir',
'Khara Madana,Jammu,Jammu & Kashmir',
'Kharah,Jammu,Jammu & Kashmir',
'Kheri,Jammu,Jammu & Kashmir',
'Khour,Jammu,Jammu & Kashmir',
'Kirpind,Jammu,Jammu & Kashmir',
'Kishanpur,Jammu,Jammu & Kashmir',
'Kool Kalan,Jammu,Jammu & Kashmir',
'Kot,Jammu,Jammu & Kashmir',
'Kot Maira,Jammu,Jammu & Kashmir',
'Kothar,Jammu,Jammu & Kashmir',
'Kotli Colony,Jammu,Jammu & Kashmir',
'Kotli Mian Fateh,Jammu,Jammu & Kashmir',
'Kotlishah Daula,Jammu,Jammu & Kashmir',
'Krishna Nagar,Jammu,Jammu & Kashmir',
'Langotian,Jammu,Jammu & Kashmir',
'Lehar,Jammu,Jammu & Kashmir',
'Link Road,Jammu,Jammu & Kashmir',
'Magowali,Jammu,Jammu & Kashmir',
'Maira,Jammu,Jammu & Kashmir',
'Makwal,Jammu,Jammu & Kashmir',
'Mandal,Jammu,Jammu & Kashmir',
'Mandal,Jammu,Jammu & Kashmir',
'Mandarian,Jammu,Jammu & Kashmir',
'Mansar,Jammu,Jammu & Kashmir',
'Mawa,Jammu,Jammu & Kashmir',
'Mawa Brahmna,Jammu,Jammu & Kashmir',
'Miran Sahib,Jammu,Jammu & Kashmir',
'Misriwala,Jammu,Jammu & Kashmir',
'Muthi,Jammu,Jammu & Kashmir',
'Nadore,Jammu,Jammu & Kashmir',
'Nagbani,Jammu,Jammu & Kashmir',
'Nai Kali,Jammu,Jammu & Kashmir',
'Nanak Chak,Jammu,Jammu & Kashmir',
'Nandpur,Jammu,Jammu & Kashmir',
'Nanga,Jammu,Jammu & Kashmir',
'Naryana,Jammu,Jammu & Kashmir',
'NATC,Jammu,Jammu & Kashmir',
'Nathal,Jammu,Jammu & Kashmir',
'New Fruit Market,Jammu,Jammu & Kashmir',
'New Sectt.Jammu,Jammu,Jammu & Kashmir',
'New University Campus,Jammu,Jammu & Kashmir',
'Nikkian,Jammu,Jammu & Kashmir',
'O.H.Road,Jammu,Jammu & Kashmir',
'Pacca Danga Akhnoor,Jammu,Jammu & Kashmir',
'Pallanwala,Jammu,Jammu & Kashmir',
'Palli,Jammu,Jammu & Kashmir',
'Paloura,Jammu,Jammu & Kashmir',
'Pandorian Manhasan,Jammu,Jammu & Kashmir',
'Pangdour,Jammu,Jammu & Kashmir',
'Panjgrain,Jammu,Jammu & Kashmir',
'Pargwal,Jammu,Jammu & Kashmir',
'Parlah,Jammu,Jammu & Kashmir',
'Paryal,Jammu,Jammu & Kashmir',
'Peermitha,Jammu,Jammu & Kashmir',
'Pindicharka Kalan,Jammu,Jammu & Kashmir',
'Puran Nagar,Jammu,Jammu & Kashmir',
'Purmandal,Jammu,Jammu & Kashmir',
'Qilla Bahu,Jammu,Jammu & Kashmir',
'R.N.Bazar,Jammu,Jammu & Kashmir',
'R.S.Pura Adda,Jammu,Jammu & Kashmir',
'R.S.Pura,Jammu,Jammu & Kashmir',
'Rabta,Jammu,Jammu & Kashmir',
'Rahya,Jammu,Jammu & Kashmir',
'Raika,Jammu,Jammu & Kashmir',
'Railway Station,Jammu,Jammu & Kashmir',
'Raipur,Jammu,Jammu & Kashmir',
'Rajinderpura,Jammu,Jammu & Kashmir',
'Ramgarh,Jammu,Jammu & Kashmir',
'Rangpur Malania,Jammu,Jammu & Kashmir',
'Rangpur Trewa,Jammu,Jammu & Kashmir',
'Ranjan,Jammu,Jammu & Kashmir',
'Rathana,Jammu,Jammu & Kashmir',
'Rattisn,Jammu,Jammu & Kashmir',
'Rehal,Jammu,Jammu & Kashmir',
'Rehari Mohalla,Jammu,Jammu & Kashmir',
'Rehiyan,Jammu,Jammu & Kashmir',
'Roopnagar Jammu Tawi,Jammu,Jammu & Kashmir',
'Sadhoti,Jammu,Jammu & Kashmir',
'Sai Kalan,Jammu,Jammu & Kashmir',
'Sainik Colony,Jammu,Jammu & Kashmir',
'Sainth,Jammu,Jammu & Kashmir',
'Salehar,Jammu,Jammu & Kashmir',
'Samba Adda,Jammu,Jammu & Kashmir',
'Samba,Jammu,Jammu & Kashmir',
'Sangrampur,Jammu,Jammu & Kashmir',
'Sanjwan,Jammu,Jammu & Kashmir',
'Sarna,Jammu,Jammu & Kashmir',
'Sarore,Jammu,Jammu & Kashmir',
'Sarote,Jammu,Jammu & Kashmir',
'Satrayan,Jammu,Jammu & Kashmir',
'Seri Panditan,Jammu,Jammu & Kashmir',
'Shaheedi Chowk Jammu,Jammu,Jammu & Kashmir',
'Shaktinagar Jammu,Jammu,Jammu & Kashmir',
'Shamka,Jammu,Jammu & Kashmir',
'Shiba,Jammu,Jammu & Kashmir',
'Simble Camp,Jammu,Jammu & Kashmir',
'Smailpur,Jammu,Jammu & Kashmir',
'Sohanjana,Jammu,Jammu & Kashmir',
'Subash Nagar Jammu,Jammu,Jammu & Kashmir',
'Suchetgarh,Jammu,Jammu & Kashmir',
'Sumb,Jammu,Jammu & Kashmir',
'Sungal,Jammu,Jammu & Kashmir',
'Sunjwan,Jammu,Jammu & Kashmir',
'Surinsar,Jammu,Jammu & Kashmir',
'Suryavihar,Jammu,Jammu & Kashmir',
'Swankha,Jammu,Jammu & Kashmir',
'Tahra,Jammu,Jammu & Kashmir',
'Talab Tillo,Jammu,Jammu & Kashmir',
'Talhar,Jammu,Jammu & Kashmir',
'Taloor,Jammu,Jammu & Kashmir',
'Tarore,Jammu,Jammu & Kashmir',
'Topsherkhania,Jammu,Jammu & Kashmir',
'Transport Yard,Jammu,Jammu & Kashmir',
'Trikuta Nagar,Jammu,Jammu & Kashmir',
'University Campus,Jammu,Jammu & Kashmir',
'Utter Behni,Jammu,Jammu & Kashmir',
'Vijaypur,Jammu,Jammu & Kashmir',
'Vinaik Bazar,Jammu,Jammu & Kashmir',
'Drass,Leh,Jammu & Kashmir',
'Akchamal,Leh,Jammu & Kashmir',
'Baroo,Leh,Jammu & Kashmir',
'Barsoo,Leh,Jammu & Kashmir',
'Batalik,Leh,Jammu & Kashmir',
'Bhimbat,Leh,Jammu & Kashmir',
'Chanigund,Leh,Jammu & Kashmir',
'Chiktan,Leh,Jammu & Kashmir',
'Chokiyal,Leh,Jammu & Kashmir',
'Garkon,Leh,Jammu & Kashmir',
'Hardas,Leh,Jammu & Kashmir',
'Karamba,Leh,Jammu & Kashmir',
'Kargil,Leh,Jammu & Kashmir',
'Karkitchoo,Leh,Jammu & Kashmir',
'Lankarchey,Leh,Jammu & Kashmir',
'Lochum,Leh,Jammu & Kashmir',
'Matayan,Leh,Jammu & Kashmir',
'Minji,Leh,Jammu & Kashmir',
'Mushkoo,Leh,Jammu & Kashmir',
'Namsuru,Leh,Jammu & Kashmir',
'Pandrass,Leh,Jammu & Kashmir',
'Panikhar,Leh,Jammu & Kashmir',
'Parkachik,Leh,Jammu & Kashmir',
'Pashkum,Leh,Jammu & Kashmir',
'Purthikchey,Leh,Jammu & Kashmir',
'Safi,Leh,Jammu & Kashmir',
'Saliskot,Leh,Jammu & Kashmir',
'Samray,Leh,Jammu & Kashmir',
'Shaimshakharboo,Leh,Jammu & Kashmir',
'Shakar,Leh,Jammu & Kashmir',
'Shargol,Leh,Jammu & Kashmir',
'Silmoh,Leh,Jammu & Kashmir',
'Tache,Leh,Jammu & Kashmir',
'Tambis,Leh,Jammu & Kashmir',
'Thasgam,Leh,Jammu & Kashmir',
'Tikat,Leh,Jammu & Kashmir',
'Trespon,Leh,Jammu & Kashmir',
'Trespon,Leh,Jammu & Kashmir',
'Tumail,Leh,Jammu & Kashmir',
'Tumail Colony,Leh,Jammu & Kashmir',
'Yuljuk,Leh,Jammu & Kashmir',
'Yurbaltik,Leh,Jammu & Kashmir',
'Bodhkharboo,Leh,Jammu & Kashmir',
'Khasgam Thuina,Leh,Jammu & Kashmir',
'Omba,Leh,Jammu & Kashmir',
'Wakha,Leh,Jammu & Kashmir',
'Choskor,Leh,Jammu & Kashmir',
'Sangra,Leh,Jammu & Kashmir',
'Pashkum,Leh,Jammu & Kashmir',
'Mulbek,Leh,Jammu & Kashmir',
'Sankoo,Leh,Jammu & Kashmir',
'Karsha,Leh,Jammu & Kashmir',
'Padum,Leh,Jammu & Kashmir',
'Zangla,Leh,Jammu & Kashmir',
'Dilwan,Udhampur,Jammu & Kashmir',
'Kothera,Udhampur,Jammu & Kashmir',
'Bandhar,Udhampur,Jammu & Kashmir',
'Bani,Udhampur,Jammu & Kashmir',
'Chalog,Udhampur,Jammu & Kashmir',
'Daggar,Udhampur,Jammu & Kashmir',
'Duggan,Udhampur,Jammu & Kashmir',
'Dulangal,Udhampur,Jammu & Kashmir',
'Fatehpur,Udhampur,Jammu & Kashmir',
'Gitti,Udhampur,Jammu & Kashmir',
'Kanthal,Udhampur,Jammu & Kashmir',
'Lowang,Udhampur,Jammu & Kashmir',
'Roulka,Udhampur,Jammu & Kashmir',
'Sitti,Udhampur,Jammu & Kashmir',
'Banhore,Udhampur,Jammu & Kashmir',
'Banjal,Udhampur,Jammu & Kashmir',
'Basoli,Udhampur,Jammu & Kashmir',
'Bhoond,Udhampur,Jammu & Kashmir',
'Dhar Mahanpur,Udhampur,Jammu & Kashmir',
'Draman,Udhampur,Jammu & Kashmir',
'Farnot,Udhampur,Jammu & Kashmir',
'Hutt,Udhampur,Jammu & Kashmir',
'Jandrota,Udhampur,Jammu & Kashmir',
'Karanwara,Udhampur,Jammu & Kashmir',
'Mahanpur,Udhampur,Jammu & Kashmir',
'Marapatti,Udhampur,Jammu & Kashmir',
'Dhyangarh,Udhampur,Jammu & Kashmir',
'Gelhan,Udhampur,Jammu & Kashmir',
'Jyotipuram,Udhampur,Jammu & Kashmir',
'Katra,Udhampur,Jammu & Kashmir',
'Khairal,Udhampur,Jammu & Kashmir',
'Khairlarh,Udhampur,Jammu & Kashmir',
'Kund Kantari,Udhampur,Jammu & Kashmir',
'Mangal,Udhampur,Jammu & Kashmir',
'Mari,Udhampur,Jammu & Kashmir',
'Nomain,Udhampur,Jammu & Kashmir',
'Poni,Udhampur,Jammu & Kashmir',
'Porakotla,Udhampur,Jammu & Kashmir',
'Ransoo,Udhampur,Jammu & Kashmir',
'Reasi,Udhampur,Jammu & Kashmir',
'Salal,Udhampur,Jammu & Kashmir',
'Sarhoti,Udhampur,Jammu & Kashmir',
'Sila,Udhampur,Jammu & Kashmir',
'Sukhalghar,Udhampur,Jammu & Kashmir',
'Surjan Dhar,Udhampur,Jammu & Kashmir',
'Talwara Colony,Udhampur,Jammu & Kashmir',
'Taryath,Udhampur,Jammu & Kashmir',
'Tote,Udhampur,Jammu & Kashmir',
'Vaishno Devi,Udhampur,Jammu & Kashmir',
'Vijaypur,Udhampur,Jammu & Kashmir',
'Bainsta,Udhampur,Jammu & Kashmir',
'Bali,Udhampur,Jammu & Kashmir',
'Barerian,Udhampur,Jammu & Kashmir',
'Barmeen,Udhampur,Jammu & Kashmir',
'Barola,Udhampur,Jammu & Kashmir',
'Bhatiari,Udhampur,Jammu & Kashmir',
'Chak Rakhwalan,Udhampur,Jammu & Kashmir',
'Chanunta,Udhampur,Jammu & Kashmir',
'Charyari,Udhampur,Jammu & Kashmir',
'Chenani,Udhampur,Jammu & Kashmir',
'Damnet,Udhampur,Jammu & Kashmir',
'Dhandal,Udhampur,Jammu & Kashmir',
'Galiote,Udhampur,Jammu & Kashmir',
'Gandala,Udhampur,Jammu & Kashmir',
'Garhi,Udhampur,Jammu & Kashmir',
'Garnai,Udhampur,Jammu & Kashmir',
'Hartrian,Udhampur,Jammu & Kashmir',
'Hartriyan,Udhampur,Jammu & Kashmir',
'Jaganoo,Udhampur,Jammu & Kashmir',
'Jakhani,Udhampur,Jammu & Kashmir',
'Jangalgali,Udhampur,Jammu & Kashmir',
'Jib,Udhampur,Jammu & Kashmir',
'Johnu,Udhampur,Jammu & Kashmir',
'Kaghote,Udhampur,Jammu & Kashmir',
'Kainthgali,Udhampur,Jammu & Kashmir',
'Kakrial,Udhampur,Jammu & Kashmir',
'Kaldi,Udhampur,Jammu & Kashmir',
'Kalsote,Udhampur,Jammu & Kashmir',
'Karlah,Udhampur,Jammu & Kashmir',
'Krimchi,Udhampur,Jammu & Kashmir',
'Kud,Udhampur,Jammu & Kashmir',
'Kuddal,Udhampur,Jammu & Kashmir',
'Kuhritti,Udhampur,Jammu & Kashmir',
'Ladha,Udhampur,Jammu & Kashmir',
'Landhar,Udhampur,Jammu & Kashmir',
'Madha,Udhampur,Jammu & Kashmir',
'Malhar,Udhampur,Jammu & Kashmir',
'Mand,Udhampur,Jammu & Kashmir',
'Mantalai,Udhampur,Jammu & Kashmir',
'Mir,Udhampur,Jammu & Kashmir',
'Mj Road Nd,Udhampur,Jammu & Kashmir',
'Mongri,Udhampur,Jammu & Kashmir',
'Omara Morh,Udhampur,Jammu & Kashmir',
'Panjar,Udhampur,Jammu & Kashmir',
'Panthal,Udhampur,Jammu & Kashmir',
'PTC Udhampur,Udhampur,Jammu & Kashmir',
'PTS Udhampur,Udhampur,Jammu & Kashmir',
'Rambal,Udhampur,Jammu & Kashmir',
'Roan,Udhampur,Jammu & Kashmir',
'Salmeri,Udhampur,Jammu & Kashmir',
'Sangote,Udhampur,Jammu & Kashmir',
'Seen Bhramena,Udhampur,Jammu & Kashmir',
'Seen Thakrian,Udhampur,Jammu & Kashmir',
'Sermanjla,Udhampur,Jammu & Kashmir',
'Shaktinagar,Udhampur,Jammu & Kashmir',
'Tikri,Udhampur,Jammu & Kashmir',
'Udhampur District Court,Udhampur,Jammu & Kashmir',
'Udhampur H.O,Udhampur,Jammu & Kashmir',
'Lakrakhanda,Dhanbad,Jharkhand',
'Makdumpur,Dhanbad,Jharkhand',
'Maliachak,Santhal Parganas,Jharkhand',
'Sibandih,Dhanbad,Jharkhand',
'Turio,Giridih,Jharkhand',
'Amlo,Giridih,Jharkhand',
'Angwali,Giridih,Jharkhand',
'Argamo,Giridih,Jharkhand',
'Bedkaro,Giridih,Jharkhand',
'Chalkari,Giridih,Jharkhand',
'Guniato,Giridih,Jharkhand',
'Gunjardih,Giridih,Jharkhand',
'Hazari,Giridih,Jharkhand',
'Jaina,Dhanbad,Jharkhand',
'Kanjkiro,Giridih,Jharkhand',
'Kasmar,Dhanbad,Jharkhand',
'Khetko,Giridih,Jharkhand',
'Kurumba,Giridih,Jharkhand',
'Makoli,Giridih,Jharkhand',
'Narayanpur,Giridih,Jharkhand',
'Narra,Giridih,Jharkhand',
'Palamu,Giridih,Jharkhand',
'Parasbani,Giridih,Jharkhand',
'Pichari,Giridih,Jharkhand',
'Potso,Giridih,Jharkhand',
'Tantri,Giridih,Jharkhand',
'Taranari,Giridih,Jharkhand',
'Taranga,Giridih,Jharkhand',
'Telo,Giridih,Jharkhand',
'Adrakuri,Dhanbad,Jharkhand',
'Alkusa,Dhanbad,Jharkhand',
'Amdiha,Dhanbad,Jharkhand',
'Arajoo,Dhanbad,Jharkhand',
'Artah,Dhanbad,Jharkhand',
'B.Pindragoria,Dhanbad,Jharkhand',
'Bagda,Dhanbad,Jharkhand',
'Bahadurpur,Dhanbad,Jharkhand',
'Baidmara,Dhanbad,Jharkhand',
'Bandhdih,Dhanbad,Jharkhand',
'Banstore,Dhanbad,Jharkhand',
'Barmasia,Dhanbad,Jharkhand',
'Baroo,Dhanbad,Jharkhand',
'Batbinore,Dhanbad,Jharkhand',
'Bermo,Giridih,Jharkhand',
'Bhandaridah,Giridih,Jharkhand',
'Bhaski,Dhanbad,Jharkhand',
'Bijulia,Dhanbad,Jharkhand',
'Bokaro Steel City H.O,Dhanbad,Jharkhand',
'Bokaro Thermal,Giridih,Jharkhand',
'Chando,Dhanbad,Jharkhand',
'Chandra,Dhanbad,Jharkhand',
'Chandrapura,Giridih,Jharkhand',
'Chas Bazar,Dhanbad,Jharkhand',
'Chiksia,Dhanbad,Jharkhand',
'Chilgada,Dhanbad,Jharkhand',
'Dhori,Giridih,Jharkhand',
'Dudhigajar,Dhanbad,Jharkhand',
'Durgapur,Dhanbad,Jharkhand',
'Galgaltand,Dhanbad,Jharkhand',
'Gamhariya,Dhanbad,Jharkhand',
'Gangjori,Dhanbad,Jharkhand',
'Ghagri,Dhanbad,Jharkhand',
'Ghatiali,Dhanbad,Jharkhand',
'Gomia,Giridih,Jharkhand',
'Hissim,Dhanbad,Jharkhand',
'I.E.Gomia,Giridih,Jharkhand',
'Jamagoria,Dhanbad,Jharkhand',
'Jarangdih Colliery,Giridih,Jharkhand',
'Jaridih,Dhanbad,Jharkhand',
'Jaridih Bazar,Giridih,Jharkhand',
'Jhalbarda,Dhanbad,Jharkhand',
'K.R.Centre,Dhanbad,Jharkhand',
'Kanak Chas,Dhanbad,Jharkhand',
'Karma,Dhanbad,Jharkhand',
'Karmatand,Dhanbad,Jharkhand',
'Kashi Jharia,Dhanbad,Jharkhand',
'Kathara,Giridih,Jharkhand',
'Khaira Chatar,Dhanbad,Jharkhand',
'Khamarbendi,Dhanbad,Jharkhand',
'Kharkharee,Dhanbad,Jharkhand',
'Koria,Dhanbad,Jharkhand',
'Kumar Daga,Dhanbad,Jharkhand',
'Kumirdoba,Dhanbad,Jharkhand',
'Kunduari,Dhanbad,Jharkhand',
'Kurra,Dhanbad,Jharkhand',
'Manjura,Dhanbad,Jharkhand',
'Narayanpur,Dhanbad,Jharkhand',
'Olgora,Dhanbad,Jharkhand',
'Pathuria,Dhanbad,Jharkhand',
'Peterbar,Giridih,Jharkhand',
'Phusro Bazar,Giridih,Jharkhand',
'Pindrajora,Dhanbad,Jharkhand',
'Pirgul,Dhanbad,Jharkhand',
'Ponda,Dhanbad,Jharkhand',
'Pundru,Dhanbad,Jharkhand',
'Pupunkee Ashram,Dhanbad,Jharkhand',
'Radhanagar,Dhanbad,Jharkhand',
'Rangamatia,Dhanbad,Jharkhand',
'Right Bank Tenughat,Giridih,Jharkhand',
'Sardaha,Dhanbad,Jharkhand',
'Satanpur,Dhanbad,Jharkhand',
'Silphore,Dhanbad,Jharkhand',
'Sunday Bazar,Giridih,Jharkhand',
'Swang Colliery,Giridih,Jharkhand',
'T.T.P.S.Lalpania,Giridih,Jharkhand',
'Tangtona,Dhanbad,Jharkhand',
'Tenughat Dam,Giridih,Jharkhand',
'Amlabad Colliery,Dhanbad,Jharkhand',
'B.M.P. IV,Dhanbad,Jharkhand',
'B.S.City Plant,Dhanbad,Jharkhand',
'B.S.City R.S.,Dhanbad,Jharkhand',
'Balidih,Dhanbad,Jharkhand',
'Chandan Kiyari,Dhanbad,Jharkhand',
'Chandore,Dhanbad,Jharkhand',
'Chas,Dhanbad,Jharkhand',
'Garga Check Post,Dhanbad,Jharkhand',
'Marafari Colony,Dhanbad,Jharkhand',
'Sector- III,Dhanbad,Jharkhand',
'Sector- IV,Dhanbad,Jharkhand',
'Sector- IX,Dhanbad,Jharkhand',
'Sector-I,Dhanbad,Jharkhand',
'Sector-VI,Dhanbad,Jharkhand',
'Barkipunu,Giridih,Jharkhand',
'Dania,Giridih,Jharkhand',
'Hardiamo,Giridih,Jharkhand',
'Hossir,Giridih,Jharkhand',
'Kharki,Giridih,Jharkhand',
'Nerki,Giridih,Jharkhand',
'Penk,Giridih,Jharkhand',
'Saram,Giridih,Jharkhand',
'Birni,Giridih,Jharkhand',
'Chapri,Giridih,Jharkhand',
'Chirudih,Giridih,Jharkhand',
'Nawadih,Giridih,Jharkhand',
'Surhi,Giridih,Jharkhand',
'Arjuwa,Giridih,Jharkhand',
'Chandipur,Giridih,Jharkhand',
'Chargi,Giridih,Jharkhand',
'Dantoo,Giridih,Jharkhand',
'Mirzapur,Giridih,Jharkhand',
'Mungasarla,Giridih,Jharkhand',
'Rohar,Giridih,Jharkhand',
'Uttasara,Giridih,Jharkhand',
'Champi,Giridih,Jharkhand',
'Ulgada,Giridih,Jharkhand',
'Jogiara,Hazaribagh,Jharkhand',
'Bachra,Palamau,Jharkhand',
'Bandu,Palamau,Jharkhand',
'Aurugerua,Hazaribagh,Jharkhand',
'Baluri,Hazaribagh,Jharkhand',
'Baraini,Hazaribagh,Jharkhand',
'Chatra Bazar,Hazaribagh,Jharkhand',
'Chatra,Hazaribagh,Jharkhand',
'Haphuwa,Hazaribagh,Jharkhand',
'Jajlo,Hazaribagh,Jharkhand',
'Kamta,Hazaribagh,Jharkhand',
'Kanhachatti,Hazaribagh,Jharkhand',
'Kolhaiya,Hazaribagh,Jharkhand',
'Kuba,Hazaribagh,Jharkhand',
'Laralutudag,Hazaribagh,Jharkhand',
'Mktama,Hazaribagh,Jharkhand',
'Nawadih Panari,Hazaribagh,Jharkhand',
'Pandepura,Hazaribagh,Jharkhand',
'Tapej,Hazaribagh,Jharkhand',
'Tatra,Hazaribagh,Jharkhand',
'Tikar,Hazaribagh,Jharkhand',
'Tulbul,Hazaribagh,Jharkhand',
'Unta,Hazaribagh,Jharkhand',
'Gidhour,Hazaribagh,Jharkhand',
'Karni,Hazaribagh,Jharkhand',
'Bihiasarhachiya,Hazaribagh,Jharkhand',
'Dantar,Hazaribagh,Jharkhand',
'Ghanghari,Hazaribagh,Jharkhand',
'Hiring,Hazaribagh,Jharkhand',
'Hunterganj,Hazaribagh,Jharkhand',
'Kedlikala,Hazaribagh,Jharkhand',
'Kobna,Hazaribagh,Jharkhand',
'Kurkheta,Hazaribagh,Jharkhand',
'Pandeypura,Hazaribagh,Jharkhand',
'Pindra,Hazaribagh,Jharkhand',
'Sahi,Hazaribagh,Jharkhand',
'Salaiya,Hazaribagh,Jharkhand',
'Amjhar,Hazaribagh,Jharkhand',
'Bargaon,Hazaribagh,Jharkhand',
'Barisakhi,Hazaribagh,Jharkhand',
'Berhna,Hazaribagh,Jharkhand',
'Daihar,Hazaribagh,Jharkhand',
'Dhauthawa,Hazaribagh,Jharkhand',
'Dwaritelaiya,Hazaribagh,Jharkhand',
'Gangpur,Hazaribagh,Jharkhand',
'Itkhori,Hazaribagh,Jharkhand',
'Loram,Hazaribagh,Jharkhand',
'Mandhania,Hazaribagh,Jharkhand',
'Mayapur,Hazaribagh,Jharkhand',
'Mayurhand,Hazaribagh,Jharkhand',
'Navadih Damol,Hazaribagh,Jharkhand',
'Parsauni,Hazaribagh,Jharkhand',
'Pathalgada,Hazaribagh,Jharkhand',
'Pathra,Hazaribagh,Jharkhand',
'Peltol,Hazaribagh,Jharkhand',
'Pitiz,Hazaribagh,Jharkhand',
'Jori,Hazaribagh,Jharkhand',
'Karma,Hazaribagh,Jharkhand',
'Chandrikala,Hazaribagh,Jharkhand',
'Bichkila,Hazaribagh,Jharkhand',
'Chatti Anatpur,Hazaribagh,Jharkhand',
'Gerua,Hazaribagh,Jharkhand',
'Kaura,Hazaribagh,Jharkhand',
'Kunda,Hazaribagh,Jharkhand',
'Narayanpur,Hazaribagh,Jharkhand',
'Pratappur,Hazaribagh,Jharkhand',
'Yadavnagar,Hazaribagh,Jharkhand',
'Bagra,Hazaribagh,Jharkhand',
'Chopey,Hazaribagh,Jharkhand',
'Delho,Hazaribagh,Jharkhand',
'Dunduwa,Hazaribagh,Jharkhand',
'Edla,Hazaribagh,Jharkhand',
'Jabra,Hazaribagh,Jharkhand',
'Lawalong,Hazaribagh,Jharkhand',
'Piri,Hazaribagh,Jharkhand',
'Shila,Hazaribagh,Jharkhand',
'Shivrajpur,Hazaribagh,Jharkhand',
'Simaria,Hazaribagh,Jharkhand',
'Tutilawa,Hazaribagh,Jharkhand',
'Bahera,Hazaribagh,Jharkhand',
'Chattibariatu,Hazaribagh,Jharkhand',
'Dhangada,Hazaribagh,Jharkhand',
'Kasiadih,Hazaribagh,Jharkhand',
'Khadaiya,Hazaribagh,Jharkhand',
'Manatu,Hazaribagh,Jharkhand',
'Pachra,Hazaribagh,Jharkhand',
'Peto,Hazaribagh,Jharkhand',
'Raham,Hazaribagh,Jharkhand',
'Salga,Hazaribagh,Jharkhand',
'Saradhu,Hazaribagh,Jharkhand',
'Tandwa,Hazaribagh,Jharkhand',
'Banka,Santhal Parganas,Jharkhand',
'Debipur,Santhal Parganas,Jharkhand',
'Debipur,Santhal Parganas,Jharkhand',
'Deopur,Santhal Parganas,Jharkhand',
'Kenman-kathi,Santhal Parganas,Jharkhand',
'Madhopur,Santhal Parganas,Jharkhand',
'Upper Bahiyar,Santhal Parganas,Jharkhand',
'Baghmari,Santhal Parganas,Jharkhand',
'Barkikharkhar,Santhal Parganas,Jharkhand',
'Mathurapur,Santhal Parganas,Jharkhand',
'Punasi,Santhal Parganas,Jharkhand',
'A.K. Bad,Santhal Parganas,Jharkhand',
'B.Deoghar H.O,Santhal Parganas,Jharkhand',
'Chanddih,Santhal Parganas,Jharkhand',
'Dabar Gram,Santhal Parganas,Jharkhand',
'Deoghar College,Santhal Parganas,Jharkhand',
'Deosang B.T,Santhal Parganas,Jharkhand',
'Gurukul Vidyapith,Santhal Parganas,Jharkhand',
'Hindipith,Santhal Parganas,Jharkhand',
'Jasidih,Santhal Parganas,Jharkhand',
'Maladih,Santhal Parganas,Jharkhand',
'Rohani,Santhal Parganas,Jharkhand',
'Sakrigali,Santhal Parganas,Jharkhand',
'Sangrampur Lorhiya,Santhal Parganas,Jharkhand',
'Satsang,Santhal Parganas,Jharkhand',
'Simra,Santhal Parganas,Jharkhand',
'T. Balasi,Santhal Parganas,Jharkhand',
'Vidyapith,Santhal Parganas,Jharkhand',
'Bhojpur,Santhal Parganas,Jharkhand',
'Ghorlas,Santhal Parganas,Jharkhand',
'K. Banskola,Santhal Parganas,Jharkhand',
'Koiridih,Santhal Parganas,Jharkhand',
'Maniyarpur,Santhal Parganas,Jharkhand',
'Ramudih,Santhal Parganas,Jharkhand',
'Kunda,Santhal Parganas,Jharkhand',
'Bargo,Santhal Parganas,Jharkhand',
'Baratanr,Santhal Parganas,Jharkhand',
'Baskupi,Santhal Parganas,Jharkhand',
'Karanjo,Santhal Parganas,Jharkhand',
'Karogram,Santhal Parganas,Jharkhand',
'Madankatha,Santhal Parganas,Jharkhand',
'Pathrol,Santhal Parganas,Jharkhand',
'Margomunda,Santhal Parganas,Jharkhand',
'Ranidih,Santhal Parganas,Jharkhand',
'Bagjora,Santhal Parganas,Jharkhand',
'Bara Chapra,Santhal Parganas,Jharkhand',
'Barawan,Santhal Parganas,Jharkhand',
'Burhai,Santhal Parganas,Jharkhand',
'Charpa,Santhal Parganas,Jharkhand',
'Dhamni,Santhal Parganas,Jharkhand',
'Haripur Kolwa,Santhal Parganas,Jharkhand',
'Hussainabad,Santhal Parganas,Jharkhand',
'Jagdishpur,Santhal Parganas,Jharkhand',
'Kasathi,Santhal Parganas,Jharkhand',
'Kushmaha,Santhal Parganas,Jharkhand',
'Madhupur,Santhal Parganas,Jharkhand',
'Ojhadih,Santhal Parganas,Jharkhand',
'Ramchandrapur,Santhal Parganas,Jharkhand',
'Saptar,Santhal Parganas,Jharkhand',
'Sirsa,Santhal Parganas,Jharkhand',
'Bichgarha Kusumdih,Santhal Parganas,Jharkhand',
'Chulhiya,Santhal Parganas,Jharkhand',
'Dehijore,Santhal Parganas,Jharkhand',
'Ghormara,Santhal Parganas,Jharkhand',
'Jamunia,Santhal Parganas,Jharkhand',
'Jhallar,Santhal Parganas,Jharkhand',
'Jhillighat,Santhal Parganas,Jharkhand',
'Kharagdiha,Santhal Parganas,Jharkhand',
'Kusmaha,Santhal Parganas,Jharkhand',
'Malhara,Santhal Parganas,Jharkhand',
'Mohanpur Hat,Santhal Parganas,Jharkhand',
'Morney,Santhal Parganas,Jharkhand',
'Rarhiya,Santhal Parganas,Jharkhand',
'Rikhiya,Santhal Parganas,Jharkhand',
'Simarjore,Santhal Parganas,Jharkhand',
'T Basdiha,Santhal Parganas,Jharkhand',
'Tapoban,Santhal Parganas,Jharkhand',
'Asna,Santhal Parganas,Jharkhand',
'Bansbutia,Santhal Parganas,Jharkhand',
'Choudri Nawadih,Santhal Parganas,Jharkhand',
'Palojori,Santhal Parganas,Jharkhand',
'Poraiyahat,Santhal Parganas,Jharkhand',
'Daluraidih,Santhal Parganas,Jharkhand',
'Bamandiha,Santhal Parganas,Jharkhand',
'Bamangama,Santhal Parganas,Jharkhand',
'Baramsoli,Santhal Parganas,Jharkhand',
'Charak Mara,Santhal Parganas,Jharkhand',
'Gopibandh,Santhal Parganas,Jharkhand',
'Jhagrahi,Santhal Parganas,Jharkhand',
'Kukraha,Santhal Parganas,Jharkhand',
'Phulchuan,Santhal Parganas,Jharkhand',
'Sabaijore,Santhal Parganas,Jharkhand',
'Sarath,Santhal Parganas,Jharkhand',
'Siktiya,Santhal Parganas,Jharkhand',
'Baijukura,Santhal Parganas,Jharkhand',
'Dumaria,Santhal Parganas,Jharkhand',
'Lakhoria,Santhal Parganas,Jharkhand',
'Madhuban,Santhal Parganas,Jharkhand',
'Magdiha,Santhal Parganas,Jharkhand',
'Manigarhi,Santhal Parganas,Jharkhand',
'Paharidih,Santhal Parganas,Jharkhand',
'Pahariya,Santhal Parganas,Jharkhand',
'Paway,Santhal Parganas,Jharkhand',
'Purjori,Santhal Parganas,Jharkhand',
'Rakti,Santhal Parganas,Jharkhand',
'Sarwan,Santhal Parganas,Jharkhand',
'Sonaraithari,Santhal Parganas,Jharkhand',
'Tilakpur,Santhal Parganas,Jharkhand',
'Patharda,Santhal Parganas,Jharkhand',
'Jhagrahi,Dhanbad,Jharkhand',
'Kalimela,Dhanbad,Jharkhand',
'Khanoodih,Dhanbad,Jharkhand',
'Maheshpur,Dhanbad,Jharkhand',
'Bhojudih,Dhanbad,Jharkhand',
'A.C.C. Colony,Dhanbad,Jharkhand',
'Ambona,Dhanbad,Jharkhand',
'Amlapara Jharia,Dhanbad,Jharkhand',
'Amtal,Dhanbad,Jharkhand',
'Angarpathra,Dhanbad,Jharkhand',
'Ankduara,Dhanbad,Jharkhand',
'B.Polytechnic,Dhanbad,Jharkhand',
'Bagdaha,Dhanbad,Jharkhand',
'Bagdigi,Dhanbad,Jharkhand',
'Baghmara,Dhanbad,Jharkhand',
'Baghmara Bazar,Dhanbad,Jharkhand',
'Bagsuma,Dhanbad,Jharkhand',
'Baliapur,Dhanbad,Jharkhand',
'Balihari,Dhanbad,Jharkhand',
'Bansjora,Dhanbad,Jharkhand',
'Bara Putki,Dhanbad,Jharkhand',
'Barbendia,Dhanbad,Jharkhand',
'Bardohi,Dhanbad,Jharkhand',
'Barwa,Dhanbad,Jharkhand',
'Bastacola,Dhanbad,Jharkhand',
'BCCl Township,Dhanbad,Jharkhand',
'Benagoria,Dhanbad,Jharkhand',
'Benagoria,Dhanbad,Jharkhand',
'Bhadrichak,Dhanbad,Jharkhand',
'Bhaga,Dhanbad,Jharkhand',
'Bhagabandh,Dhanbad,Jharkhand',
'Bhagatdih,Dhanbad,Jharkhand',
'Bhatdih,Dhanbad,Jharkhand',
'Bhelatand,Dhanbad,Jharkhand',
'Bhendra,Dhanbad,Jharkhand',
'Bhitia,Dhanbad,Jharkhand',
'Bhowra,Dhanbad,Jharkhand',
'Bhulan Bararee,Dhanbad,Jharkhand',
'Bhuli,Dhanbad,Jharkhand',
'Bhutgoria,Dhanbad,Jharkhand',
'Birajpur,Dhanbad,Jharkhand',
'Birsinghpur,Dhanbad,Jharkhand',
'Bowakalan,Dhanbad,Jharkhand',
'Brahmandiha,Dhanbad,Jharkhand',
'Burragarh,Dhanbad,Jharkhand',
'Chanchpottery,Dhanbad,Jharkhand',
'Charak,Dhanbad,Jharkhand',
'Chasnalla,Dhanbad,Jharkhand',
'Chipkia,Dhanbad,Jharkhand',
'Chirkunda,Dhanbad,Jharkhand',
'Cmpf,Dhanbad,Jharkhand',
'Cmrs,Dhanbad,Jharkhand',
'D.S.E.,Dhanbad,Jharkhand',
'Daldali,Dhanbad,Jharkhand',
'Daludih,Dhanbad,Jharkhand',
'Damodarpur,Dhanbad,Jharkhand',
'Debiana,Dhanbad,Jharkhand',
'Dhanbad Bazar,Dhanbad,Jharkhand',
'Dhanbad H.O,Dhanbad,Jharkhand',
'Dhanbad Hirapur,Dhanbad,Jharkhand',
'Dhansar,Dhanbad,Jharkhand',
'Dhoria Mahubani,Dhanbad,Jharkhand',
'Dobari,Dhanbad,Jharkhand',
'Domgarh,Dhanbad,Jharkhand',
'Dumaria,Dhanbad,Jharkhand',
'Dumarkunda,Dhanbad,Jharkhand',
'Dumdumi,Dhanbad,Jharkhand',
'Fatehpur,Dhanbad,Jharkhand',
'Fri,Dhanbad,Jharkhand',
'G. Raghunathpur,Dhanbad,Jharkhand',
'Galfarbari,Dhanbad,Jharkhand',
'Gaukola,Dhanbad,Jharkhand',
'Gharbar,Dhanbad,Jharkhand',
'Ghunghusa,Dhanbad,Jharkhand',
'Gomoh,Dhanbad,Jharkhand',
'Gonudih,Dhanbad,Jharkhand',
'Goplaichak,Dhanbad,Jharkhand',
'Gortoppa,Dhanbad,Jharkhand',
'Govindpur,Dhanbad,Jharkhand',
'Hariharpur,Dhanbad,Jharkhand',
'Horladih,Dhanbad,Jharkhand',
'Indian School Of Mines,Dhanbad,Jharkhand',
'Jagjivan Nagar,Dhanbad,Jharkhand',
'Jamadoba,Dhanbad,Jharkhand',
'Jangalpur,Dhanbad,Jharkhand',
'Jealgora,Dhanbad,Jharkhand',
'Jharia Bazar,Dhanbad,Jharkhand',
'Jharia Manbad,Dhanbad,Jharkhand',
'Jharia,Dhanbad,Jharkhand',
'Jhiluwa,Dhanbad,Jharkhand',
'Jhinaki,Dhanbad,Jharkhand',
'Jitpur,Dhanbad,Jharkhand',
'Jogidih,Dhanbad,Jharkhand',
'K.G.Ashram,Dhanbad,Jharkhand',
'Kaliasole,Dhanbad,Jharkhand',
'Kalyanpur,Dhanbad,Jharkhand',
'Kankanee,Dhanbad,Jharkhand',
'Kankomath,Dhanbad,Jharkhand',
'Karitand,Dhanbad,Jharkhand',
'Katania Ojhadih,Dhanbad,Jharkhand',
'Katras Bazar,Dhanbad,Jharkhand',
'Katrasgarh,Dhanbad,Jharkhand',
'Kesarkural,Dhanbad,Jharkhand',
'Keshalpur,Dhanbad,Jharkhand',
'Keska,Dhanbad,Jharkhand',
'Khario,Dhanbad,Jharkhand',
'Kharni,Dhanbad,Jharkhand',
'Khasjeena Gora,Dhanbad,Jharkhand',
'Kirkend,Dhanbad,Jharkhand',
'Kujama,Dhanbad,Jharkhand',
'Kumardhubi,Dhanbad,Jharkhand',
'Kustore,Dhanbad,Jharkhand',
'Kusunda,Dhanbad,Jharkhand',
'Lakarka,Dhanbad,Jharkhand',
'Lalpur,Dhanbad,Jharkhand',
'Ledaharia,Dhanbad,Jharkhand',
'Lodna,Dhanbad,Jharkhand',
'Ludharia,Dhanbad,Jharkhand',
'Madaidih,Dhanbad,Jharkhand',
'Madanpur,Dhanbad,Jharkhand',
'Madhuban,Dhanbad,Jharkhand',
'Mahal,Dhanbad,Jharkhand',
'Maharajganj,Dhanbad,Jharkhand',
'Maira Nawatand,Dhanbad,Jharkhand',
'Maithon Dam,Dhanbad,Jharkhand',
'Malkera,Dhanbad,Jharkhand',
'Manaitand,Dhanbad,Jharkhand',
'Maniadih,Dhanbad,Jharkhand',
'Matari,Dhanbad,Jharkhand',
'Merrah,Dhanbad,Jharkhand',
'Mohuda,Dhanbad,Jharkhand',
'Moko,Dhanbad,Jharkhand',
'Moonidih,Dhanbad,Jharkhand',
'Moradih,Dhanbad,Jharkhand',
'Motinagar,Dhanbad,Jharkhand',
'Mugma,Dhanbad,Jharkhand',
'Murradih,Dhanbad,Jharkhand',
'Nagarkiary,Dhanbad,Jharkhand',
'Nagnagar,Dhanbad,Jharkhand',
'Nawagarh,Dhanbad,Jharkhand',
'Naya Bazar Wasseypur,Dhanbad,Jharkhand',
'Nirsa Chatti,Dhanbad,Jharkhand',
'Nudkhurkee,Dhanbad,Jharkhand',
'Palani,Dhanbad,Jharkhand',
'Panchet Dam,Dhanbad,Jharkhand',
'Pandra,Dhanbad,Jharkhand',
'Panjania,Dhanbad,Jharkhand',
'Pargha,Dhanbad,Jharkhand',
'Patherdih Coal Washery,Dhanbad,Jharkhand',
'Patherdih,Dhanbad,Jharkhand',
'Pindrahat,Dhanbad,Jharkhand',
'Pochari,Dhanbad,Jharkhand',
'Poddardih,Dhanbad,Jharkhand',
'Pokharia,Dhanbad,Jharkhand',
'Pradhan Khanta,Dhanbad,Jharkhand',
'Pradhankhanta,Dhanbad,Jharkhand',
'Purnadih,Dhanbad,Jharkhand',
'Rajganj,Dhanbad,Jharkhand',
'Rajpura,Dhanbad,Jharkhand',
'Ramakunda,Dhanbad,Jharkhand',
'Ramnagar Garh,Dhanbad,Jharkhand',
'Rampur,Dhanbad,Jharkhand',
'Roam,Dhanbad,Jharkhand',
'S.I.T.,Dhanbad,Jharkhand',
'Saharpura,Dhanbad,Jharkhand',
'Sahubahiyar,Dhanbad,Jharkhand',
'Salpatra,Dhanbad,Jharkhand',
'Salukchapra,Dhanbad,Jharkhand',
'Saraidhela,Dhanbad,Jharkhand',
'Sarkardih,Dhanbad,Jharkhand',
'Sarsapahari,Dhanbad,Jharkhand',
'Sendra,Dhanbad,Jharkhand',
'Shramik Nagar,Dhanbad,Jharkhand',
'Sijua,Dhanbad,Jharkhand',
'Silibari,Dhanbad,Jharkhand',
'Sindri,Dhanbad,Jharkhand',
'Singhdaha,Dhanbad,Jharkhand',
'Singhdih,Dhanbad,Jharkhand',
'Sonardih,Dhanbad,Jharkhand',
'Srirampur,Dhanbad,Jharkhand',
'Sudamdih,Dhanbad,Jharkhand',
'Sunderpahari,Dhanbad,Jharkhand',
'Suranga,Dhanbad,Jharkhand',
'Tantri,Dhanbad,Jharkhand',
'Thaparnagar,Dhanbad,Jharkhand',
'Tilaiya,Dhanbad,Jharkhand',
'Tisra,Dhanbad,Jharkhand',
'Topchanchi,Dhanbad,Jharkhand',
'Tundi,Dhanbad,Jharkhand',
'Tundoo,Dhanbad,Jharkhand',
'Ukma,Dhanbad,Jharkhand',
'Urma,Dhanbad,Jharkhand',
'Yadavpur,Dhanbad,Jharkhand',
'Satpahari,Santhal Parganas,Jharkhand',
'Amarapahari,Santhal Parganas,Jharkhand',
'Bhaturia,Santhal Parganas,Jharkhand',
'Danro,Santhal Parganas,Jharkhand',
'Dhanbasa,Santhal Parganas,Jharkhand',
'Patjore,Santhal Parganas,Jharkhand',
'Simaljore,Santhal Parganas,Jharkhand',
'Sinduria,Santhal Parganas,Jharkhand',
'Asansol,Santhal Parganas,Jharkhand',
'Bagnal,Santhal Parganas,Jharkhand',
'Bando Haripur,Santhal Parganas,Jharkhand',
'Bhurkunda,Santhal Parganas,Jharkhand',
'Chainpur Kairabani,Santhal Parganas,Jharkhand',
'Dhogariya,Santhal Parganas,Jharkhand',
'Dudhani,Santhal Parganas,Jharkhand',
'Dumka H.O,Santhal Parganas,Jharkhand',
'Dumka,Santhal Parganas,Jharkhand',
'Gando,Santhal Parganas,Jharkhand',
'Ghasipur,Santhal Parganas,Jharkhand',
'Guhiajori,Santhal Parganas,Jharkhand',
'K. Baskichowk,Santhal Parganas,Jharkhand',
'K. Madhuwadih,Santhal Parganas,Jharkhand',
'Kolharia,Santhal Parganas,Jharkhand',
'Kumrabad,Santhal Parganas,Jharkhand',
'Kurwa,Santhal Parganas,Jharkhand',
'Machkicha,Santhal Parganas,Jharkhand',
'Massanjore,Santhal Parganas,Jharkhand',
'Morbhanga,Santhal Parganas,Jharkhand',
'Pakiriya,Santhal Parganas,Jharkhand',
'Puranadumka,Santhal Parganas,Jharkhand',
'Rajbandh,Santhal Parganas,Jharkhand',
'Ranibahal,Santhal Parganas,Jharkhand',
'Shivpahar,Santhal Parganas,Jharkhand',
'Teliachak,Santhal Parganas,Jharkhand',
'Dharampur,Santhal Parganas,Jharkhand',
'Gopikandar,Santhal Parganas,Jharkhand',
'Karudih,Santhal Parganas,Jharkhand',
'T. Daldali,Santhal Parganas,Jharkhand',
'Karipahari,Santhal Parganas,Jharkhand',
'Seeltawatilar,Santhal Parganas,Jharkhand',
'Ajnaridudhani,Santhal Parganas,Jharkhand',
'Amlachatar,Santhal Parganas,Jharkhand',
'Amra Nawadih,Santhal Parganas,Jharkhand',
'Asanjore,Santhal Parganas,Jharkhand',
'Bagjhopa,Santhal Parganas,Jharkhand',
'Barapalasi,Santhal Parganas,Jharkhand',
'Bhirabpur,Santhal Parganas,Jharkhand',
'Bhutokoria,Santhal Parganas,Jharkhand',
'Chaila Pathar,Santhal Parganas,Jharkhand',
'Chikania,Santhal Parganas,Jharkhand',
'Goari,Santhal Parganas,Jharkhand',
'Gundlidangal,Santhal Parganas,Jharkhand',
'Jama,Santhal Parganas,Jharkhand',
'Laximipur,Santhal Parganas,Jharkhand',
'Lilatari,Santhal Parganas,Jharkhand',
'Maharo,Santhal Parganas,Jharkhand',
'Majhiandih,Santhal Parganas,Jharkhand',
'Nachangaria,Santhal Parganas,Jharkhand',
'Nakrapahari,Santhal Parganas,Jharkhand',
'Nischintpur,Santhal Parganas,Jharkhand',
'Nonihatwari,Santhal Parganas,Jharkhand',
'Pargodih,Santhal Parganas,Jharkhand',
'Siktia,Santhal Parganas,Jharkhand',
'Tarajora,Santhal Parganas,Jharkhand',
'Upparbahal,Santhal Parganas,Jharkhand',
'Uppersitwa,Santhal Parganas,Jharkhand',
'Rajan Amar Kunda,Santhal Parganas,Jharkhand',
'Amba Jarowadih,Santhal Parganas,Jharkhand',
'Banwara,Santhal Parganas,Jharkhand',
'Baratanr,Santhal Parganas,Jharkhand',
'Basukinathdham,Santhal Parganas,Jharkhand',
'Beldaha,Santhal Parganas,Jharkhand',
'Bishanpur,Santhal Parganas,Jharkhand',
'Chamrabahiar,Santhal Parganas,Jharkhand',
'Dhamnilata,Santhal Parganas,Jharkhand',
'Dudhani,Santhal Parganas,Jharkhand',
'Dumariahat,Santhal Parganas,Jharkhand',
'Gadibahirkunda,Santhal Parganas,Jharkhand',
'Hariharpur,Santhal Parganas,Jharkhand',
'Haripur,Santhal Parganas,Jharkhand',
'Jarmundi,Santhal Parganas,Jharkhand',
'Kaladumaria,Santhal Parganas,Jharkhand',
'Karma,Santhal Parganas,Jharkhand',
'Khutahari,Santhal Parganas,Jharkhand',
'Lakhna,Santhal Parganas,Jharkhand',
'Nonihat,Santhal Parganas,Jharkhand',
'P. Jaratikar,Santhal Parganas,Jharkhand',
'Petsar,Santhal Parganas,Jharkhand',
'Raikinari,Santhal Parganas,Jharkhand',
'Sahara,Santhal Parganas,Jharkhand',
'Singhni,Santhal Parganas,Jharkhand',
'Sultanatikar,Santhal Parganas,Jharkhand',
'Kadma,Santhal Parganas,Jharkhand',
'Amgachi,Santhal Parganas,Jharkhand',
'Astajora,Santhal Parganas,Jharkhand',
'B. Narganj,Santhal Parganas,Jharkhand',
'Bara Sarwapani,Santhal Parganas,Jharkhand',
'Kalajhar,Santhal Parganas,Jharkhand',
'Kathikund,Santhal Parganas,Jharkhand',
'Kolha,Santhal Parganas,Jharkhand',
'Masania,Santhal Parganas,Jharkhand',
'Pusaldih,Santhal Parganas,Jharkhand',
'Saldaha,Santhal Parganas,Jharkhand',
'Sarsabad,Santhal Parganas,Jharkhand',
'Babanbandhi,Santhal Parganas,Jharkhand',
'Baragamharia,Santhal Parganas,Jharkhand',
'Garapathar,Santhal Parganas,Jharkhand',
'Ghormala Hunja,Santhal Parganas,Jharkhand',
'Goasol,Santhal Parganas,Jharkhand',
'Golbandha,Santhal Parganas,Jharkhand',
'Gumro,Santhal Parganas,Jharkhand',
'K. Bhoktadih,Santhal Parganas,Jharkhand',
'Kendhghatta,Santhal Parganas,Jharkhand',
'Khairabani,Santhal Parganas,Jharkhand',
'Kusumghatta,Santhal Parganas,Jharkhand',
'Lattabar,Santhal Parganas,Jharkhand',
'Makrampur,Santhal Parganas,Jharkhand',
'Pindari,Santhal Parganas,Jharkhand',
'R.Masalia,Santhal Parganas,Jharkhand',
'Sapchalla,Santhal Parganas,Jharkhand',
'Shikarpur,Santhal Parganas,Jharkhand',
'Tasaria,Santhal Parganas,Jharkhand',
'Kathalia,Santhal Parganas,Jharkhand',
'Baijnathpur,Santhal Parganas,Jharkhand',
'Basaha,Santhal Parganas,Jharkhand',
'Birajpur,Santhal Parganas,Jharkhand',
'Chaglajore,Santhal Parganas,Jharkhand',
'Dubrajpur,Santhal Parganas,Jharkhand',
'Garsara,Santhal Parganas,Jharkhand',
'Jamua,Santhal Parganas,Jharkhand',
'Jarwadi,Santhal Parganas,Jharkhand',
'Karrasal,Santhal Parganas,Jharkhand',
'Kunjora,Santhal Parganas,Jharkhand',
'Sagarbanga,Santhal Parganas,Jharkhand',
'Sarsa,Santhal Parganas,Jharkhand',
'T.D.Dumaria,Santhal Parganas,Jharkhand',
'Talghara,Santhal Parganas,Jharkhand',
'Sushni,Santhal Parganas,Jharkhand',
'Thakur Nahar,Santhal Parganas,Jharkhand',
'Bandarjora,Santhal Parganas,Jharkhand',
'Bariranbahiyar,Santhal Parganas,Jharkhand',
'Khudimerkho,Santhal Parganas,Jharkhand',
'Lakhanpur,Santhal Parganas,Jharkhand',
'Mahubana,Santhal Parganas,Jharkhand',
'Piprakarudih,Santhal Parganas,Jharkhand',
'Ramgarah,Santhal Parganas,Jharkhand',
'Amarpur,Santhal Parganas,Jharkhand',
'Chaukri,Palamau,Jharkhand',
'Dangwar,Palamau,Jharkhand',
'Daruaboni,Palamau,Jharkhand',
'Goradih,Palamau,Jharkhand',
'Haidar Nagar,Palamau,Jharkhand',
'Hariharpur,Palamau,Jharkhand',
'Jagajamdiha,Palamau,Jharkhand',
'Jainagra,Palamau,Jharkhand',
'Japla C F,Palamau,Jharkhand',
'Japla,Palamau,Jharkhand',
'Jhargara,Palamau,Jharkhand',
'Kabrakhurd,Palamau,Jharkhand',
'Kadaikurmi,Palamau,Jharkhand',
'Kajrat Nawadih,Palamau,Jharkhand',
'Kamgarpur,Palamau,Jharkhand',
'Kandi,Palamau,Jharkhand',
'Karimandih,Palamau,Jharkhand',
'Kosiara,Palamau,Jharkhand',
'Kukahi,Palamau,Jharkhand',
'Kusha,Palamau,Jharkhand',
'Kushha,Palamau,Jharkhand',
'Lamarikala,Palamau,Jharkhand',
'Latheya,Palamau,Jharkhand',
'Mahuari,Palamau,Jharkhand',
'Manjhiaon,Palamau,Jharkhand',
'Mohammad Ganj,Palamau,Jharkhand',
'Morway,Palamau,Jharkhand',
'Pansa,Palamau,Jharkhand',
'Poldih-jagdishpur,Palamau,Jharkhand',
'Sabano,Palamau,Jharkhand',
'Satbahini,Palamau,Jharkhand',
'Shirpur,Palamau,Jharkhand',
'Sundipur,Palamau,Jharkhand',
'Utari Road,Palamau,Jharkhand',
'Semaura,Palamau,Jharkhand',
'Bansdih,Palamau,Jharkhand',
'Basaura,Palamau,Jharkhand',
'Champi,Palamau,Jharkhand',
'Dhangaon,Palamau,Jharkhand',
'Gentha,Palamau,Jharkhand',
'Gurha,Palamau,Jharkhand',
'Ashehar,Palamau,Jharkhand',
'Fhulang,Palamau,Jharkhand',
'Gurua,Palamau,Jharkhand',
'Kazi Pakri,Palamau,Jharkhand',
'Kundri,Palamau,Jharkhand',
'Lesliganj,Palamau,Jharkhand',
'Manjhigaon,Palamau,Jharkhand',
'Pathakpagar,Palamau,Jharkhand',
'Rajwadih,Palamau,Jharkhand',
'Sagalim,Palamau,Jharkhand',
'Sangbar,Palamau,Jharkhand',
'Sildiliya Kala,Palamau,Jharkhand',
'Tarhasi,Palamau,Jharkhand',
'Thakuraidabra,Palamau,Jharkhand',
'Tandwa,Palamau,Jharkhand',
'Adhsura,Palamau,Jharkhand',
'Ambakharis,Palamau,Jharkhand',
'Bhojpur,Palamau,Jharkhand',
'Birbal,Palamau,Jharkhand',
'Chitbishraen,Palamau,Jharkhand',
'Dhurki,Palamau,Jharkhand',
'Halwantakain,Palamau,Jharkhand',
'Jamui,Palamau,Jharkhand',
'Katharkala,Palamau,Jharkhand',
'Mahdeiya,Palamau,Jharkhand',
'Nagar Utari,Palamau,Jharkhand',
'Ambabar,Palamau,Jharkhand',
'Ballari,Palamau,Jharkhand',
'Champi Kala,Palamau,Jharkhand',
'Dandar Kala,Palamau,Jharkhand',
'Dhub,Palamau,Jharkhand',
'Dwarika,Palamau,Jharkhand',
'Kasmar,Palamau,Jharkhand',
'Konwai,Palamau,Jharkhand',
'Loharsi,Palamau,Jharkhand',
'Panki,Palamau,Jharkhand',
'Tal,Palamau,Jharkhand',
'Tetrain,Palamau,Jharkhand',
'Udaipru,Palamau,Jharkhand',
'Baidakala,Palamau,Jharkhand',
'Chetma,Palamau,Jharkhand',
'Dipauwa,Palamau,Jharkhand',
'Dulhi,Palamau,Jharkhand',
'Gahar Pathara,Palamau,Jharkhand',
'Ichak,Palamau,Jharkhand',
'Kankekala,Palamau,Jharkhand',
'Kishunpur,Palamau,Jharkhand',
'Lami Patra,Palamau,Jharkhand',
'Loinga,Palamau,Jharkhand',
'Manatu,Palamau,Jharkhand',
'Nawa Jaipur,Palamau,Jharkhand',
'Nawdiha,Palamau,Jharkhand',
'Paduma,Palamau,Jharkhand',
'Palhe Khurd,Palamau,Jharkhand',
'Pandeypura,Palamau,Jharkhand',
'Patan,Palamau,Jharkhand',
'Rajhara Rest,Palamau,Jharkhand',
'Roll,Palamau,Jharkhand',
'Sikki Kala,Palamau,Jharkhand',
'Sirma,Palamau,Jharkhand',
'Bakoriya,Palamau,Jharkhand',
'Barwaiya,Palamau,Jharkhand',
'Dhawadih,Palamau,Jharkhand',
'Jhabar,Palamau,Jharkhand',
'Khamdih,Palamau,Jharkhand',
'Manika,Palamau,Jharkhand',
'Matlong,Palamau,Jharkhand',
'Palheya,Palamau,Jharkhand',
'Polpol,Palamau,Jharkhand',
'Ranki Kala,Palamau,Jharkhand',
'Satbarwa,Palamau,Jharkhand',
'Dari,Hazaribagh,Jharkhand',
'Src,Hazaribagh,Jharkhand',
'Adalhatu,Ranchi,Jharkhand',
'Bero,Ranchi,Jharkhand',
'Brambe,Ranchi,Jharkhand',
'Rugari,Ranchi,Jharkhand',
'Angara,Ranchi,Jharkhand',
'Bisa,Ranchi,Jharkhand',
'Bongaibera,Ranchi,Jharkhand',
'Childag,Ranchi,Jharkhand',
'Getalsud,Ranchi,Jharkhand',
'Hesal,Ranchi,Jharkhand',
'Jon R.S.,Ranchi,Jharkhand',
'Maheshpur,Ranchi,Jharkhand',
'Mahilong,Ranchi,Jharkhand',
'Medha,Ranchi,Jharkhand',
'Nawagarh,Ranchi,Jharkhand',
'Rajadera,Ranchi,Jharkhand',
'Sugnu,Ranchi,Jharkhand',
'Tatisilway,Ranchi,Jharkhand',
'Deogaon,Ranchi,Jharkhand',
'Dolaicha,Ranchi,Jharkhand',
'Etta,Ranchi,Jharkhand',
'Gargaon,Ranchi,Jharkhand',
'Hatu Ghaghra,Ranchi,Jharkhand',
'Jaria,Ranchi,Jharkhand',
'Kakaria,Ranchi,Jharkhand',
'Kesha,Ranchi,Jharkhand',
'Khatri Khatanga,Ranchi,Jharkhand',
'Khukhra,Ranchi,Jharkhand',
'Nehalu,Ranchi,Jharkhand',
'Paharkandaria,Ranchi,Jharkhand',
'Tuko,Ranchi,Jharkhand',
'Tati,Ranchi,Jharkhand',
'Akashi,Ranchi,Jharkhand',
'Baragain,Ranchi,Jharkhand',
'Bhitta,Ranchi,Jharkhand',
'Gajni,Ranchi,Jharkhand',
'Kairo,Ranchi,Jharkhand',
'Kharta,Ranchi,Jharkhand',
'Mahuary,Ranchi,Jharkhand',
'Narauli,Ranchi,Jharkhand',
'Sero,Ranchi,Jharkhand',
'Sinjo,Ranchi,Jharkhand',
'Adalahatu,Ranchi,Jharkhand',
'Ambajharia,Ranchi,Jharkhand',
'Baredih,Ranchi,Jharkhand',
'Baruhatu,Ranchi,Jharkhand',
'Bundu,Ranchi,Jharkhand',
'Burhadih,Ranchi,Jharkhand',
'Danadih,Ranchi,Jharkhand',
'Edrumhatu,Ranchi,Jharkhand',
'Henjed,Ranchi,Jharkhand',
'Humta,Ranchi,Jharkhand',
'Jadeya,Ranchi,Jharkhand',
'Jamuadag,Ranchi,Jharkhand',
'Kanchi,Ranchi,Jharkhand',
'Lowahatu,Ranchi,Jharkhand',
'Noadih,Ranchi,Jharkhand',
'Rahe,Ranchi,Jharkhand',
'Reladih,Ranchi,Jharkhand',
'Sataki,Ranchi,Jharkhand',
'Sonahatu,Ranchi,Jharkhand',
'Taimara,Ranchi,Jharkhand',
'Chanho,Ranchi,Jharkhand',
'Dakra Colliery,Palamau,Jharkhand',
'Balsota,Ranchi,Jharkhand',
'Beyasi,Ranchi,Jharkhand',
'Bhawro,Ranchi,Jharkhand',
'Bisahakhatanga,Ranchi,Jharkhand',
'Charkidumri,Ranchi,Jharkhand',
'Mandru,Ranchi,Jharkhand',
'Murto,Ranchi,Jharkhand',
'Nagjua,Ranchi,Jharkhand',
'Narkopi,Ranchi,Jharkhand',
'Ranikhatanga,Ranchi,Jharkhand',
'Sakra,Ranchi,Jharkhand',
'Semra,Ranchi,Jharkhand',
'Silagain,Ranchi,Jharkhand',
'Tangarbasli,Ranchi,Jharkhand',
'Tikratoli,Ranchi,Jharkhand',
'Bukru,Ranchi,Jharkhand',
'Gagi,Ranchi,Jharkhand',
'Hussir,Ranchi,Jharkhand',
'Ichapiri,Ranchi,Jharkhand',
'Kanke,Ranchi,Jharkhand',
'Kokdoro,Ranchi,Jharkhand',
'Kumharia,Ranchi,Jharkhand',
'Pithoria,Ranchi,Jharkhand',
'Ranchi Agriculture College,Ranchi,Jharkhand',
'Satakanadu,Ranchi,Jharkhand',
'Sukurhutu,Ranchi,Jharkhand',
'Bikwadag,Ranchi,Jharkhand',
'Bingaon,Ranchi,Jharkhand',
'Birda,Ranchi,Jharkhand',
'Champadih,Ranchi,Jharkhand',
'Chata,Ranchi,Jharkhand',
'Govindpur Road,Ranchi,Jharkhand',
'Govindpur,Ranchi,Jharkhand',
'Jariadih,Ranchi,Jharkhand',
'Karra,Ranchi,Jharkhand',
'Koisera,Ranchi,Jharkhand',
'Kone,Ranchi,Jharkhand',
'Kurse,Ranchi,Jharkhand',
'Lapa,Ranchi,Jharkhand',
'Larta,Ranchi,Jharkhand',
'Late,Ranchi,Jharkhand',
'Pokta,Ranchi,Jharkhand',
'Rendwa,Ranchi,Jharkhand',
'Sangor,Ranchi,Jharkhand',
'Tilmi,Ranchi,Jharkhand',
'Angrabari,Ranchi,Jharkhand',
'Anigara,Ranchi,Jharkhand',
'Belwadag,Ranchi,Jharkhand',
'Bhandra,Ranchi,Jharkhand',
'Bichina,Ranchi,Jharkhand',
'Birhu,Ranchi,Jharkhand',
'Eta,Ranchi,Jharkhand',
'Ghunsuli,Ranchi,Jharkhand',
'Gutjora,Ranchi,Jharkhand',
'Hakadua,Ranchi,Jharkhand',
'Jaltanda,Ranchi,Jharkhand',
'Jurdag,Ranchi,Jharkhand',
'Khunti,Ranchi,Jharkhand',
'Koaselda,Ranchi,Jharkhand',
'Landup,Ranchi,Jharkhand',
'Maranghada,Ranchi,Jharkhand',
'Phudi,Ranchi,Jharkhand',
'Saiko,Ranchi,Jharkhand',
'Saparom,Ranchi,Jharkhand',
'Sirum,Ranchi,Jharkhand',
'Lapung,Ranchi,Jharkhand',
'Mahugaon,Ranchi,Jharkhand',
'Banapiri,Ranchi,Jharkhand',
'Baraudi,Ranchi,Jharkhand',
'Binja,Ranchi,Jharkhand',
'Brambe(R),Ranchi,Jharkhand',
'Burhakhukhra,Ranchi,Jharkhand',
'Burmu,Ranchi,Jharkhand',
'Chaingara,Ranchi,Jharkhand',
'Chakma,Ranchi,Jharkhand',
'Chittarkota,Ranchi,Jharkhand',
'Choreya,Ranchi,Jharkhand',
'Ginjothakurgaon,Ranchi,Jharkhand',
'Gitilgarh,Ranchi,Jharkhand',
'Gurgaon,Ranchi,Jharkhand',
'Hanhat,Ranchi,Jharkhand',
'Jaherbargari,Ranchi,Jharkhand',
'Kaimbo,Ranchi,Jharkhand',
'Kakargarh,Ranchi,Jharkhand',
'Karge,Ranchi,Jharkhand',
'Karkara,Ranchi,Jharkhand',
'Korambe,Ranchi,Jharkhand',
'Mahuajari,Ranchi,Jharkhand',
'Makka,Ranchi,Jharkhand',
'Mandar,Ranchi,Jharkhand',
'Murkuni,Ranchi,Jharkhand',
'Murma,Ranchi,Jharkhand',
'Murupiri,Ranchi,Jharkhand',
'Nagra,Ranchi,Jharkhand',
'Pali,Ranchi,Jharkhand',
'Patratu,Ranchi,Jharkhand',
'Purio,Ranchi,Jharkhand',
'Raghunathpur,Ranchi,Jharkhand',
'Sarle,Ranchi,Jharkhand',
'Soba,Ranchi,Jharkhand',
'Sona,Ranchi,Jharkhand',
'Sosai,Ranchi,Jharkhand',
'Susaimuru,Ranchi,Jharkhand',
'Tala,Ranchi,Jharkhand',
'Tangar,Ranchi,Jharkhand',
'Turmuli,Ranchi,Jharkhand',
'Umedanda,Ranchi,Jharkhand',
'Chama,Palamau,Jharkhand',
'Diwan Nagar,Palamau,Jharkhand',
'Hindgir,Palamau,Jharkhand',
'Khalari,Palamau,Jharkhand',
'Mc. Cluskiganj,Palamau,Jharkhand',
'Nawadih,Palamau,Jharkhand',
'Nindra,Palamau,Jharkhand',
'Ray,Palamau,Jharkhand',
'Bamhani,Ranchi,Jharkhand',
'Binda Bazar,Ranchi,Jharkhand',
'Birbanki,Ranchi,Jharkhand',
'Burju,Ranchi,Jharkhand',
'Ghaghra,Ranchi,Jharkhand',
'Jate,Ranchi,Jharkhand',
'Kandir,Ranchi,Jharkhand',
'Murhu,Ranchi,Jharkhand',
'Sarwada,Ranchi,Jharkhand',
'Bara Ghaghra,Ranchi,Jharkhand',
'Jamchuajaria,Ranchi,Jharkhand',
'Khijri,Ranchi,Jharkhand',
'Lali,Ranchi,Jharkhand',
'Rajaulatu,Ranchi,Jharkhand',
'Tetri,Ranchi,Jharkhand',
'Sanri,Ranchi,Jharkhand',
'Hendevelli,Ranchi,Jharkhand',
'Palu,Ranchi,Jharkhand',
'Baredih,Ranchi,Jharkhand',
'Baxidih,Ranchi,Jharkhand',
'Chakla,Ranchi,Jharkhand',
'Chandra,Ranchi,Jharkhand',
'Chutupalu,Ranchi,Jharkhand',
'Dahu,Ranchi,Jharkhand',
'Ichadag,Ranchi,Jharkhand',
'Irba,Ranchi,Jharkhand',
'Kuchu,Ranchi,Jharkhand',
'Ormanjhi,Ranchi,Jharkhand',
'Pancha,Ranchi,Jharkhand',
'Sadma,Ranchi,Jharkhand',
'Adalhatu,Ranchi,Jharkhand',
'AG Bihar,Ranchi,Jharkhand',
'Ashok Nagar,Ranchi,Jharkhand',
'Balalong,Ranchi,Jharkhand',
'Bariatu,Ranchi,Jharkhand',
'Barwadag,Ranchi,Jharkhand',
'Boreya,Ranchi,Jharkhand',
'Buti,Ranchi,Jharkhand',
'Chandwa,Ranchi,Jharkhand',
'Church Road,Ranchi,Jharkhand',
'Chutia,Ranchi,Jharkhand',
'Dahusodang,Ranchi,Jharkhand',
'Dhurwa,Ranchi,Jharkhand',
'Doranda H.O,Ranchi,Jharkhand',
'Dundigara,Ranchi,Jharkhand',
'Harmu Housing Colony,Ranchi,Jharkhand',
'Hathudani,Ranchi,Jharkhand',
'Hatia Dam,Ranchi,Jharkhand',
'Hatia,Ranchi,Jharkhand',
'HEC Adm Bldg,Ranchi,Jharkhand',
'HEC App Hostel,Ranchi,Jharkhand',
'HEC Colony,Ranchi,Jharkhand',
'HEC Expert Hostel,Ranchi,Jharkhand',
'Hehal,Ranchi,Jharkhand',
'Hindpiri,Ranchi,Jharkhand',
'Hindustan Steel Colony,Ranchi,Jharkhand',
'Hinoo,Ranchi,Jharkhand',
'Hotwar,Ranchi,Jharkhand',
'Hulhundu,Ranchi,Jharkhand',
'Hundru,Ranchi,Jharkhand',
'Hundur,Ranchi,Jharkhand',
'Hurdag,Ranchi,Jharkhand',
'Indrapuri Colony,Ranchi,Jharkhand',
'Itki,Ranchi,Jharkhand',
'Jagarnath Nagar Colony,Ranchi,Jharkhand',
'Jharkhand Vidhan Sabha,Ranchi,Jharkhand',
'Kanke Road,Ranchi,Jharkhand',
'Kantatoli,Ranchi,Jharkhand',
'Kokar,Ranchi,Jharkhand',
'Lalpur,Ranchi,Jharkhand',
'Lame Baragaon,Ranchi,Jharkhand',
'Lodhma,Ranchi,Jharkhand',
'Lower Bazar,Ranchi,Jharkhand',
'Mesra,Ranchi,Jharkhand',
'Morabadi,Ranchi,Jharkhand',
'Namkum,Ranchi,Jharkhand',
'Ncdc,Ranchi,Jharkhand',
'Neori Vikas Vidyalaya,Ranchi,Jharkhand',
'New Area Marabadi,Ranchi,Jharkhand',
'Nibaranpur,Ranchi,Jharkhand',
'Old Commissioner Compound,Ranchi,Jharkhand',
'Piskanagri,Ranchi,Jharkhand',
'Pundag,Ranchi,Jharkhand',
'Railway Colony Hatia,Ranchi,Jharkhand',
'Ramkrishna Sanatorium,Ranchi,Jharkhand',
'Ranchi Airport,Ranchi,Jharkhand',
'Ranchi Court,Ranchi,Jharkhand',
'Ranchi G.P.O.,Ranchi,Jharkhand',
'Ranchi Medical College Campus,Ranchi,Jharkhand',
'Ranchi Medical College,Ranchi,Jharkhand',
'Ranchi University,Ranchi,Jharkhand',
'Ranchi Veterinary College,Ranchi,Jharkhand',
'Satellite Colony,Ranchi,Jharkhand',
'Sikidiri,Ranchi,Jharkhand',
'Sithio,Ranchi,Jharkhand',
'Subarnrekha Hydai Project,Ranchi,Jharkhand',
'Tarasiladon,Ranchi,Jharkhand',
'Tiril,Ranchi,Jharkhand',
'Rania,Ranchi,Jharkhand',
'Sarbo,Ranchi,Jharkhand',
'Sode,Ranchi,Jharkhand',
'Barsa,Ranchi,Jharkhand',
'Bijjulia,Ranchi,Jharkhand',
'Bindhani,Ranchi,Jharkhand',
'Chinarpurio,Ranchi,Jharkhand',
'Chipra,Ranchi,Jharkhand',
'Guru,Ranchi,Jharkhand',
'Gutua,Ranchi,Jharkhand',
'Halhu,Ranchi,Jharkhand',
'Hurhuri,Ranchi,Jharkhand',
'Kamre,Ranchi,Jharkhand',
'Katamkuli,Ranchi,Jharkhand',
'Katarpa,Ranchi,Jharkhand',
'Katulahna,Ranchi,Jharkhand',
'Kuli,Ranchi,Jharkhand',
'Malsering,Ranchi,Jharkhand',
'Marwa,Ranchi,Jharkhand',
'Murma Nayasarai,Ranchi,Jharkhand',
'Patrachauli,Ranchi,Jharkhand',
'Ratu,Ranchi,Jharkhand',
'Saparam,Ranchi,Jharkhand',
'Simlia,Ranchi,Jharkhand',
'Urugutu,Ranchi,Jharkhand',
'Ajaygarh,Ranchi,Jharkhand',
'Bansiya,Ranchi,Jharkhand',
'Banthahazam,Ranchi,Jharkhand',
'Barachagru,Ranchi,Jharkhand',
'Barenda,Ranchi,Jharkhand',
'Bongaiburu,Ranchi,Jharkhand',
'Chotamuri,Ranchi,Jharkhand',
'Dowaru,Ranchi,Jharkhand',
'Goradih,Ranchi,Jharkhand',
'Hakedag,Ranchi,Jharkhand',
'Halmad,Ranchi,Jharkhand',
'Jhabri,Ranchi,Jharkhand',
'Kuchu,Ranchi,Jharkhand',
'Lagam,Ranchi,Jharkhand',
'Lota,Ranchi,Jharkhand',
'Pandadih,Ranchi,Jharkhand',
'Patrahatu,Ranchi,Jharkhand',
'Piska,Ranchi,Jharkhand',
'Pogra,Ranchi,Jharkhand',
'Silli,Ranchi,Jharkhand',
'T.T.Mankidih,Ranchi,Jharkhand',
'Tati,Ranchi,Jharkhand',
'Tetebandrampur,Ranchi,Jharkhand',
'Tetla,Ranchi,Jharkhand',
'Tutikinawadih,Ranchi,Jharkhand',
'Amlesha,Ranchi,Jharkhand',
'Arki,Ranchi,Jharkhand',
'Baburamdih,Ranchi,Jharkhand',
'Baredih,Ranchi,Jharkhand',
'Chirudih,Ranchi,Jharkhand',
'Chokahatu,Ranchi,Jharkhand',
'Doreya,Ranchi,Jharkhand',
'Haramlohar,Ranchi,Jharkhand',
'Janumpiri,Ranchi,Jharkhand',
'Jargo,Ranchi,Jharkhand',
'Jilling Soreng,Ranchi,Jharkhand',
'Jojohatu,Ranchi,Jharkhand',
'Kochasindri,Ranchi,Jharkhand',
'Kota,Ranchi,Jharkhand',
'Landupdih,Ranchi,Jharkhand',
'Lungtu,Ranchi,Jharkhand',
'Mankidih,Ranchi,Jharkhand',
'Norhi,Ranchi,Jharkhand',
'Parasi,Ranchi,Jharkhand',
'Pundidiri,Ranchi,Jharkhand',
'Rargaon,Ranchi,Jharkhand',
'Salgadih,Ranchi,Jharkhand',
'Sarjomdih,Ranchi,Jharkhand',
'Tamar,Ranchi,Jharkhand',
'Ulidih,Ranchi,Jharkhand',
'Ulilohar,Ranchi,Jharkhand',
'Vijaygiri,Ranchi,Jharkhand',
'Ambapakhna,Ranchi,Jharkhand',
'Barda,Ranchi,Jharkhand',
'Dorma,Ranchi,Jharkhand',
'Dumangdiri,Ranchi,Jharkhand',
'Gudri,Ranchi,Jharkhand',
'Icha,Ranchi,Jharkhand',
'Jaipur,Ranchi,Jharkhand',
'Kasmar,Ranchi,Jharkhand',
'Khatanga,Ranchi,Jharkhand',
'Marcha,Ranchi,Jharkhand',
'Patpur,Ranchi,Jharkhand',
'Raisimla,Ranchi,Jharkhand',
'Sundari,Ranchi,Jharkhand',
'Tirla,Ranchi,Jharkhand',
'Torpa,Ranchi,Jharkhand',
'Narayanpur East Diara,Santhal Parganas,Jharkhand',
'Barmasia,Santhal Parganas,Jharkhand',
'B.Kadma,Santhal Parganas,Jharkhand',
'Barhait,Santhal Parganas,Jharkhand',
'Bhognadih,Santhal Parganas,Jharkhand',
'Borbandh,Santhal Parganas,Jharkhand',
'Hatigarah,Santhal Parganas,Jharkhand',
'Kusmaha,Santhal Parganas,Jharkhand',
'Labri,Santhal Parganas,Jharkhand',
'P.K.Bazar,Santhal Parganas,Jharkhand',
'Phulbanga,Santhal Parganas,Jharkhand',
'Rohra,Santhal Parganas,Jharkhand',
'Barharwa,Santhal Parganas,Jharkhand',
'Binodpur,Santhal Parganas,Jharkhand',
'Bishanpur,Santhal Parganas,Jharkhand',
'Gaganpahari,Santhal Parganas,Jharkhand',
'Ganishpur,Santhal Parganas,Jharkhand',
'Goalkhor,Santhal Parganas,Jharkhand',
'Ishlampur,Santhal Parganas,Jharkhand',
'Jambad,Santhal Parganas,Jharkhand',
'Jampur,Santhal Parganas,Jharkhand',
'Kankjol,Santhal Parganas,Jharkhand',
'Kotalpokhar,Santhal Parganas,Jharkhand',
'Mayur Kola,Santhal Parganas,Jharkhand',
'Palasbona,Santhal Parganas,Jharkhand',
'Patharia,Santhal Parganas,Jharkhand',
'Ranigram,Santhal Parganas,Jharkhand',
'Reshore,Santhal Parganas,Jharkhand',
'Srikund,Santhal Parganas,Jharkhand',
'Talbaria,Santhal Parganas,Jharkhand',
'Sripurbazar,Santhal Parganas,Jharkhand',
'Aglio,Santhal Parganas,Jharkhand',
'Aprol,Santhal Parganas,Jharkhand',
'Banjhi,Santhal Parganas,Jharkhand',
'Bara Madansahi,Santhal Parganas,Jharkhand',
'Barajirwabari,Santhal Parganas,Jharkhand',
'Borio,Santhal Parganas,Jharkhand',
'Chotabangama,Santhal Parganas,Jharkhand',
'J.Kumarjori,Santhal Parganas,Jharkhand',
'Mirzachowki,Santhal Parganas,Jharkhand',
'Motipahari,Santhal Parganas,Jharkhand',
'Telo,Santhal Parganas,Jharkhand',
'Mandro,Santhal Parganas,Jharkhand',
'B.B. Mangladih,Santhal Parganas,Jharkhand',
'Banskola,Santhal Parganas,Jharkhand',
'Baradighi,Santhal Parganas,Jharkhand',
'Bartalla,Santhal Parganas,Jharkhand',
'Ghatiari,Santhal Parganas,Jharkhand',
'Lakhipur,Santhal Parganas,Jharkhand',
'Pathna,Santhal Parganas,Jharkhand',
'Kalyanchak,Santhal Parganas,Jharkhand',
'Atapur,Santhal Parganas,Jharkhand',
'Begamganj,Santhal Parganas,Jharkhand',
'Jonka,Santhal Parganas,Jharkhand',
'Kajigoun,Santhal Parganas,Jharkhand',
'Mahasinghpur,Santhal Parganas,Jharkhand',
'Narayanpur,Santhal Parganas,Jharkhand',
'P.K.Bazar,Santhal Parganas,Jharkhand',
'Palasgachi,Santhal Parganas,Jharkhand',
'Phudkipur,Santhal Parganas,Jharkhand',
'Piyarpur,Santhal Parganas,Jharkhand',
'Rajmahal,Santhal Parganas,Jharkhand',
'Tinpahar RS,Santhal Parganas,Jharkhand',
'Balapokhar,Santhal Parganas,Jharkhand',
'Baluagairah,Santhal Parganas,Jharkhand',
'Ganga Prasad Diara,Santhal Parganas,Jharkhand',
'Hariprasad Diara,Santhal Parganas,Jharkhand',
'Hazipur Bari Kodarjana,Santhal Parganas,Jharkhand',
'Mahadeo Ganj,Santhal Parganas,Jharkhand',
'Rampur,Santhal Parganas,Jharkhand',
'Sahibganj,Santhal Parganas,Jharkhand',
'Sakrigali Ghat,Santhal Parganas,Jharkhand',
'Bakudih,Santhal Parganas,Jharkhand',
'Bara Durgapur,Santhal Parganas,Jharkhand',
'Brindaban,Santhal Parganas,Jharkhand',
'Karanpura,Santhal Parganas,Jharkhand',
'Maharajpur,Santhal Parganas,Jharkhand',
'Mangalhat English,Santhal Parganas,Jharkhand',
'Sarkanda,Santhal Parganas,Jharkhand',
'Taljhari,Santhal Parganas,Jharkhand',
'Chandsaher,Santhal Parganas,Jharkhand',
'Choukidhab,Santhal Parganas,Jharkhand',
'Kathalbari,Santhal Parganas,Jharkhand',
'Kelabari,Santhal Parganas,Jharkhand',
'Jamnager,Santhal Parganas,Jharkhand',
'Udhwa,Santhal Parganas,Jharkhand',
'Sridhardira,Santhal Parganas,Jharkhand',
'Masna,Santhal Parganas,Jharkhand',
'Radhanager,Santhal Parganas,Jharkhand',
'Kharsawangarh,Singhbhum,Jharkhand',
'Adityapur Industrial Area,Singhbhum,Jharkhand',
'Adityapur,Singhbhum,Jharkhand',
'Amda,Singhbhum,Jharkhand',
'Chakradharpur Bazar,Singhbhum,Jharkhand',
'Asantalia,Singhbhum,Jharkhand',
'Chakradharpur Colony,Singhbhum,Jharkhand',
'Chakradharpur,Singhbhum,Jharkhand',
'Jarakel,Singhbhum,Jharkhand',
'Chopra,Singhbhum,Jharkhand',
'Dulmi,Singhbhum,Jharkhand',
'Ichadih,Singhbhum,Jharkhand',
'Janum,Singhbhum,Jharkhand',
'Kashipur,Singhbhum,Jharkhand',
'Kukra,Singhbhum,Jharkhand',
'Muru,Singhbhum,Jharkhand',
'Shirum,Singhbhum,Jharkhand',
'Situ,Singhbhum,Jharkhand',
'Soro,Singhbhum,Jharkhand',
'Gamharia,Singhbhum,Jharkhand',
'Hudu,Singhbhum,Jharkhand',
'Kandra,Singhbhum,Jharkhand',
'Urmal,Singhbhum,Jharkhand',
'Bhalurungi,Singhbhum,Jharkhand',
'Dugni,Singhbhum,Jharkhand',
'Kendua,Singhbhum,Jharkhand',
'Kolabira,Singhbhum,Jharkhand',
'Madhupur,Singhbhum,Jharkhand',
'Munda Tand,Singhbhum,Jharkhand',
'Narayanpur,Singhbhum,Jharkhand',
'Nengtasai,Singhbhum,Jharkhand',
'Raidih,Singhbhum,Jharkhand',
'Sindhukopa,Singhbhum,Jharkhand',
'Sindri,Singhbhum,Jharkhand',
'Arwan,Singhbhum,Jharkhand',
'Dalbhanga,Singhbhum,Jharkhand',
'Pathermara,Singhbhum,Jharkhand',
'Seraikella Block,Singhbhum,Jharkhand',
'Seraikella,Singhbhum,Jharkhand',
'Tablapur,Singhbhum,Jharkhand',
'Bamni Chaliyama,Singhbhum,Jharkhand',
'Bandu,Singhbhum,Jharkhand',
'Bansa,Singhbhum,Jharkhand',
'Baramari,Singhbhum,Jharkhand',
'Bareda,Singhbhum,Jharkhand',
'Bhadudih,Singhbhum,Jharkhand',
'Burudih,Singhbhum,Jharkhand',
'Buruhatu,Singhbhum,Jharkhand',
'Chainpur,Singhbhum,Jharkhand',
'Chelgu,Singhbhum,Jharkhand',
'Chipri,Singhbhum,Jharkhand',
'Deoltand,Singhbhum,Jharkhand',
'Dugdha,Singhbhum,Jharkhand',
'Gaurangkocha,Singhbhum,Jharkhand',
'Ghatdulmi,Singhbhum,Jharkhand',
'Ghoraling,Singhbhum,Jharkhand',
'Hesalkocha,Singhbhum,Jharkhand',
'Jhabri,Singhbhum,Jharkhand',
'Jugilong,Singhbhum,Jharkhand',
'Kanderbera,Singhbhum,Jharkhand',
'Kashidih,Singhbhum,Jharkhand',
'Khunti,Singhbhum,Jharkhand',
'Lepatand,Singhbhum,Jharkhand',
'Madhupur,Singhbhum,Jharkhand',
'Moisara,Singhbhum,Jharkhand',
'Nadisai,Singhbhum,Jharkhand',
'Nimdih,Singhbhum,Jharkhand',
'Nowagarh,Singhbhum,Jharkhand',
'Patkum,Singhbhum,Jharkhand',
'Pokharia,Singhbhum,Jharkhand',
'Sidhdih,Singhbhum,Jharkhand',
'Simagunda,Singhbhum,Jharkhand',
'Tikar,Singhbhum,Jharkhand',
'Tilla,Singhbhum,Jharkhand',
'Tuta,Singhbhum,Jharkhand',
'Tamari,Singhbhum,Jharkhand',
'Tankocha,Singhbhum,Jharkhand',
'Burudih,Singhbhum,Jharkhand',
'Kuchai,Singhbhum,Jharkhand',
'Sini,Singhbhum,Jharkhand',
'Banki,Ranchi,Jharkhand',
'Bano,Ranchi,Jharkhand',
'Genmer,Ranchi,Jharkhand',
'Gerda,Ranchi,Jharkhand',
'Hatinghore,Ranchi,Jharkhand',
'Hurda,Ranchi,Jharkhand',
'Jitutoli,Ranchi,Jharkhand',
'Kulburu,Ranchi,Jharkhand',
'Kurkura,Ranchi,Jharkhand',
'Kutunjia,Ranchi,Jharkhand',
'Lachragarh,Ranchi,Jharkhand',
'Lamgarh,Ranchi,Jharkhand',
'Latakel,Ranchi,Jharkhand',
'Orga,Ranchi,Jharkhand',
'Raikera,Ranchi,Jharkhand',
'Sikorda,Ranchi,Jharkhand',
'Bolba,Ranchi,Jharkhand',
'Barwadih,Ranchi,Jharkhand',
'Boroseta,Ranchi,Jharkhand',
'Itam,Ranchi,Jharkhand',
'Jaldega,Ranchi,Jharkhand',
'Kolebira,Ranchi,Jharkhand',
'Konmerla,Ranchi,Jharkhand',
'Rampur,Ranchi,Jharkhand',
'Sahpur,Ranchi,Jharkhand',
'Sukhajharia,Ranchi,Jharkhand',
'Tutikel,Ranchi,Jharkhand',
'Baribringa,Ranchi,Jharkhand',
'Lasia,Ranchi,Jharkhand',
'Agharma,Ranchi,Jharkhand',
'Bargaon,Ranchi,Jharkhand',
'Barsloya,Ranchi,Jharkhand',
'Bongera,Ranchi,Jharkhand',
'Lombai,Ranchi,Jharkhand',
'Ch. Munda,Ranchi,Jharkhand',
'Dhori,Ranchi,Jharkhand',
'Dumarpath,Ranchi,Jharkhand',
'Gariajore,Ranchi,Jharkhand',
'Gatadih,Ranchi,Jharkhand',
'Khinda,Ranchi,Jharkhand',
'Kurdeg,Ranchi,Jharkhand',
'B. Biura,Ranchi,Jharkhand',
'Bagdega,Ranchi,Jharkhand',
'Basain,Ranchi,Jharkhand',
'Bhelwadih,Ranchi,Jharkhand',
'Biru,Ranchi,Jharkhand',
'Bombalkera,Ranchi,Jharkhand',
'Deobahar,Ranchi,Jharkhand',
'Garja,Ranchi,Jharkhand',
'Gorarjora,Ranchi,Jharkhand',
'Gotra,Ranchi,Jharkhand',
'Gutbahar,Ranchi,Jharkhand',
'Hethma,Ranchi,Jharkhand',
'Jampani,Ranchi,Jharkhand',
'Jokbahar,Ranchi,Jharkhand',
'Karramunda,Ranchi,Jharkhand',
'Keonddih,Ranchi,Jharkhand',
'Kereya,Ranchi,Jharkhand',
'Kersai,Ranchi,Jharkhand',
'Keshalpur,Ranchi,Jharkhand',
'Khuntitoli,Ranchi,Jharkhand',
'Kinkel,Ranchi,Jharkhand',
'Kjijra,Ranchi,Jharkhand',
'Kochedega,Ranchi,Jharkhand',
'Kodapani,Ranchi,Jharkhand',
'Konaskela,Ranchi,Jharkhand',
'Konbegi,Ranchi,Jharkhand',
'Konjoba,Ranchi,Jharkhand',
'Konpala,Ranchi,Jharkhand',
'Kulukera,Ranchi,Jharkhand',
'Kundurmunda,Ranchi,Jharkhand',
'Kurmia,Ranchi,Jharkhand',
'Kuruskela,Ranchi,Jharkhand',
'Kutmakochar,Ranchi,Jharkhand',
'Lathakhaman,Ranchi,Jharkhand',
'Malsera,Ranchi,Jharkhand',
'Meromdega,Ranchi,Jharkhand',
'Pakardanr,Ranchi,Jharkhand',
'Phulwartangar,Ranchi,Jharkhand',
'Piriyapoch,Ranchi,Jharkhand',
'Pithra,Ranchi,Jharkhand',
'Rengari,Ranchi,Jharkhand',
'Samsera,Ranchi,Jharkhand',
'Sewai,Ranchi,Jharkhand',
'Sikariatand,Ranchi,Jharkhand',
'Simdega,Ranchi,Jharkhand',
'Taisera,Ranchi,Jharkhand',
'Taisera,Ranchi,Jharkhand',
'Tamra,Ranchi,Jharkhand',
'Tamra,Ranchi,Jharkhand',
'Taraboga,Ranchi,Jharkhand',
'Targa,Ranchi,Jharkhand',
'Tumdega,Ranchi,Jharkhand',
'Tupudega Pandripani,Ranchi,Jharkhand',
'Urta,Ranchi,Jharkhand',
'Baliajor,Ranchi,Jharkhand',
'Bansjor,Ranchi,Jharkhand',
'Behrinbasa,Ranchi,Jharkhand',
'Thethaitangar,Ranchi,Jharkhand',
'Chhota Bandi,Singhbhum,Jharkhand',
'Khedchalan,Singhbhum,Jharkhand',
'Urkia,Singhbhum,Jharkhand',
'Bandgaon,Ranchi,Jharkhand',
'Hesadih,Ranchi,Jharkhand',
'Kochang,Ranchi,Jharkhand',
'Leyangi,Ranchi,Jharkhand',
'Mahil,Ranchi,Jharkhand',
'Pronger,Ranchi,Jharkhand',
'Selda,Ranchi,Jharkhand',
'Swania,Ranchi,Jharkhand',
'Tebo,Ranchi,Jharkhand',
'Barajamda,Singhbhum,Jharkhand',
'Andhari,Singhbhum,Jharkhand',
'Asura,Singhbhum,Jharkhand',
'Bagabilla,Singhbhum,Jharkhand',
'Balandia,Singhbhum,Jharkhand',
'Balibandh,Singhbhum,Jharkhand',
'Barachiru,Singhbhum,Jharkhand',
'Baraiburu,Singhbhum,Jharkhand',
'Barajamni,Singhbhum,Jharkhand',
'Barajhinkpani,Singhbhum,Jharkhand',
'Baralagia,Singhbhum,Jharkhand',
'Baralagra,Singhbhum,Jharkhand',
'Bari Bazar,Singhbhum,Jharkhand',
'Barkella,Singhbhum,Jharkhand',
'Barkundia,Singhbhum,Jharkhand',
'Benisagar,Singhbhum,Jharkhand',
'Bensakaranjia,Singhbhum,Jharkhand',
'Bharbaria,Singhbhum,Jharkhand',
'Bharbharia,Singhbhum,Jharkhand',
'Bhoya,Singhbhum,Jharkhand',
'Chaibasa H.O,Singhbhum,Jharkhand',
'Chittimitti,Singhbhum,Jharkhand',
'D.S.E Chaibasa,Singhbhum,Jharkhand',
'Dalki,Singhbhum,Jharkhand',
'Dhobadhobin,Singhbhum,Jharkhand',
'Dholadih,Singhbhum,Jharkhand',
'Dumuria,Singhbhum,Jharkhand',
'Ghagri,Singhbhum,Jharkhand',
'Gitilipi,Singhbhum,Jharkhand',
'Guira,Singhbhum,Jharkhand',
'Gulia,Singhbhum,Jharkhand',
'Icha,Singhbhum,Jharkhand',
'Jaintgarh,Singhbhum,Jharkhand',
'Jhalak,Singhbhum,Jharkhand',
'Jojo Camp,Singhbhum,Jharkhand',
'Karanjia,Singhbhum,Jharkhand',
'Kathbari,Singhbhum,Jharkhand',
'Keshargaria,Singhbhum,Jharkhand',
'Khairbandh,Singhbhum,Jharkhand',
'Khairpal,Singhbhum,Jharkhand',
'Kheriatangar,Singhbhum,Jharkhand',
'Khuntpani,Singhbhum,Jharkhand',
'Khurpose,Singhbhum,Jharkhand',
'Kokcho,Singhbhum,Jharkhand',
'Kumardungi,Singhbhum,Jharkhand',
'Kundidhar,Singhbhum,Jharkhand',
'Majhgaon,Singhbhum,Jharkhand',
'N.Ashram,Singhbhum,Jharkhand',
'Nakahasa,Singhbhum,Jharkhand',
'Naogaon,Singhbhum,Jharkhand',
'Narsanda,Singhbhum,Jharkhand',
'Pandrasali,Singhbhum,Jharkhand',
'Parsagar Keshna,Singhbhum,Jharkhand',
'Pilka,Singhbhum,Jharkhand',
'Punga,Singhbhum,Jharkhand',
'Purnapani,Singhbhum,Jharkhand',
'Purnapani,Singhbhum,Jharkhand',
'Purunia,Singhbhum,Jharkhand',
'Roro,Singhbhum,Jharkhand',
'Runia,Singhbhum,Jharkhand',
'Sarda,Singhbhum,Jharkhand',
'Sindri Guiya,Singhbhum,Jharkhand',
'Sindriguia,Singhbhum,Jharkhand',
'Singhpokharia,Singhbhum,Jharkhand',
'Siyaljora,Singhbhum,Jharkhand',
'Sringgesia,Singhbhum,Jharkhand',
'Surjabasa,Singhbhum,Jharkhand',
'T.B.Dumuria,Singhbhum,Jharkhand',
'Tantnagar,Singhbhum,Jharkhand',
'Tata College Chaibasa,Singhbhum,Jharkhand',
'Tonto,Singhbhum,Jharkhand',
'Tonto,Singhbhum,Jharkhand',
'Baikera,Singhbhum,Jharkhand',
'Baipee,Singhbhum,Jharkhand',
'Barabamboo,Singhbhum,Jharkhand',
'Barposh,Singhbhum,Jharkhand',
'Bhalupani,Singhbhum,Jharkhand',
'Chainpur Khas,Singhbhum,Jharkhand',
'Chirubera,Singhbhum,Jharkhand',
'Dumrita,Singhbhum,Jharkhand',
'Gopinathpur,Singhbhum,Jharkhand',
'Hathia,Singhbhum,Jharkhand',
'Hesalkuti,Singhbhum,Jharkhand',
'Jamid,Singhbhum,Jharkhand',
'Jharjharia,Singhbhum,Jharkhand',
'Kera,Singhbhum,Jharkhand',
'Keraikela,Singhbhum,Jharkhand',
'Kuira,Singhbhum,Jharkhand',
'Lotapahar,Singhbhum,Jharkhand',
'Mahulpani,Singhbhum,Jharkhand',
'Nakti,Singhbhum,Jharkhand',
'Otar,Singhbhum,Jharkhand',
'Patherbasa,Singhbhum,Jharkhand',
'Posiata,Singhbhum,Jharkhand',
'Rajanand Pur,Singhbhum,Jharkhand',
'Robkera,Singhbhum,Jharkhand',
'Roladih,Singhbhum,Jharkhand',
'Sarjamhatu,Singhbhum,Jharkhand',
'Toklo,Singhbhum,Jharkhand',
'Unchibita,Singhbhum,Jharkhand',
'Lonjo,Singhbhum,Jharkhand',
'Chiria,Singhbhum,Jharkhand',
'Danguaposi,Singhbhum,Jharkhand',
'Bari,Singhbhum,Jharkhand',
'Goilkera,Singhbhum,Jharkhand',
'Kairam,Singhbhum,Jharkhand',
'Tuniagajpur,Singhbhum,Jharkhand',
'Gua,Singhbhum,Jharkhand',
'Hatgamaria,Singhbhum,Jharkhand',
'Jagannathpur,Singhbhum,Jharkhand',
'Jamdih,Singhbhum,Jharkhand',
'Maluka,Singhbhum,Jharkhand',
'Kochra,Singhbhum,Jharkhand',
'Jhinkpani,Singhbhum,Jharkhand',
'Kiriburu Base Camp,Singhbhum,Jharkhand',
'Chotanagra,Singhbhum,Jharkhand',
'Manoharpur,Singhbhum,Jharkhand',
'Salai,Singhbhum,Jharkhand',
'Meghahatuburu,Singhbhum,Jharkhand',
'Joteya,Singhbhum,Jharkhand',
'Kotgarh,Singhbhum,Jharkhand',
'Noamundi Bazar,Singhbhum,Jharkhand',
'Noamundi,Singhbhum,Jharkhand',
'Rajnagar,Singhbhum,Jharkhand',
'Sonua,Singhbhum,Jharkhand',
'Galudih,Singhbhum,Jharkhand',
'Gopidih,Singhbhum,Jharkhand',
'Jojokurma,Singhbhum,Jharkhand',
'Padampur,Singhbhum,Jharkhand',
'Govankoppa,Bagalkot,Karnataka',
'Adagal,Bagalkot,Karnataka',
'Agasarkoppa,Bagalkot,Karnataka',
'Alur S.K.,Bagalkot,Karnataka',
'Anawal,Bagalkot,Karnataka',
'Bachingudd,Bagalkot,Karnataka',
'Badami Extension,Bagalkot,Karnataka',
'Badami,Bagalkot,Karnataka',
'Belavalakoppa,Bagalkot,Karnataka',
'Belur,Bagalkot,Karnataka',
'Chikmuchalgudda,Bagalkot,Karnataka',
'Chinchalkatti,Bagalkot,Karnataka',
'Cholachagudd,Bagalkot,Karnataka',
'Dhanakshirur,Bagalkot,Karnataka',
'Guddadmallapur,Bagalkot,Karnataka',
'Gudur,Bagalkot,Karnataka',
'Guledgudd East,Bagalkot,Karnataka',
'Guledgudd,Bagalkot,Karnataka',
'Haladoor,Bagalkot,Karnataka',
'Haligeri,Bagalkot,Karnataka',
'Halkurki,Bagalkot,Karnataka',
'Hanapur,Bagalkot,Karnataka',
'Hangaragi,Bagalkot,Karnataka',
'Haunsnur,Bagalkot,Karnataka',
'Hebballi,Bagalkot,Karnataka',
'Hirebudihal,Bagalkot,Karnataka',
'Hirenabasi,Bagalkot,Karnataka',
'Hoolgeri,Bagalkot,Karnataka',
'Hospet- Kerur,Bagalkot,Karnataka',
'Hosur,Bagalkot,Karnataka',
'Hullikeri,Bagalkot,Karnataka',
'Jakanur,Bagalkot,Karnataka',
'Jalgeri,Bagalkot,Karnataka',
'Jalihal,Bagalkot,Karnataka',
'Jammankatti,Bagalkot,Karnataka',
'Kabbalgerii,Bagalkot,Karnataka',
'Kagalgomba,Bagalkot,Karnataka',
'Kainkatti,Bagalkot,Karnataka',
'Kakanur,Bagalkot,Karnataka',
'Katageri,Bagalkot,Karnataka',
'Katarki,Bagalkot,Karnataka',
'Kelawadi,Bagalkot,Karnataka',
'Kerakalmatti,Bagalkot,Karnataka',
'Kerur,Bagalkot,Karnataka',
'Khyad,Bagalkot,Karnataka',
'Kittali,Bagalkot,Karnataka',
'Kulgeri Cross,Bagalkot,Karnataka',
'Kutkankeri,Bagalkot,Karnataka',
'Lakhamapur,Bagalkot,Karnataka',
'Layadgundi,Bagalkot,Karnataka',
'Mamatgeri,Bagalkot,Karnataka',
'Mangalgudda,Bagalkot,Karnataka',
'Mushtigeri,Bagalkot,Karnataka',
'Muttalgeri,Bagalkot,Karnataka',
'Nandikeshwar,Bagalkot,Karnataka',
'Narasapur,Bagalkot,Karnataka',
'Narenur,Bagalkot,Karnataka',
'Nilgund,Bagalkot,Karnataka',
'Niralkeri,Bagalkot,Karnataka',
'Nirbudihal,Bagalkot,Karnataka',
'Parvati,Bagalkot,Karnataka',
'Pattadkal,Bagalkot,Karnataka',
'Radder Timmapur,Bagalkot,Karnataka',
'Shirbadagi,Bagalkot,Karnataka',
'Shivayogmandir,Bagalkot,Karnataka',
'Sulikeri,Bagalkot,Karnataka',
'Sulla,Bagalkot,Karnataka',
'Togunshi,Bagalkot,Karnataka',
'Ugalwat,Bagalkot,Karnataka',
'Yandigeri,Bagalkot,Karnataka',
'Yankanchi,Bagalkot,Karnataka',
'Yaragoppa,Bagalkot,Karnataka',
'Achanur,Bagalkot,Karnataka',
'Bagalkot Alokudyog,Bagalkot,Karnataka',
'Bagalkot B.H.School,Bagalkot,Karnataka',
'Bagalkot Bazar,Bagalkot,Karnataka',
'Bagalkot Grbc,Bagalkot,Karnataka',
'Bagalkot H.O,Bagalkot,Karnataka',
'Bagalkot Navanagar Extn. Count,Bagalkot,Karnataka',
'Bagalkot Navanagar,Bagalkot,Karnataka',
'Benkatti,Bagalkot,Karnataka',
'Bennur,Bagalkot,Karnataka',
'Bevinmattti,Bagalkot,Karnataka',
'Bhagavati,Bagalkot,Karnataka',
'Bhairmatti,Bagalkot,Karnataka',
'Bilkerur,Bagalkot,Karnataka',
'Bodanaikanadinni,Bagalkot,Karnataka',
'Chikhodlur,Bagalkot,Karnataka',
'Chikmyageri,Bagalkot,Karnataka',
'Chikshellikeri,Bagalkot,Karnataka',
'Choudapur,Bagalkot,Karnataka',
'Devanal,Bagalkot,Karnataka',
'Gaddankeri,Bagalkot,Karnataka',
'Gandhinagar,Bagalkot,Karnataka',
'Hallur,Bagalkot,Karnataka',
'Haveli,Bagalkot,Karnataka',
'Hiregulbal,Bagalkot,Karnataka',
'Honnakatti,Bagalkot,Karnataka',
'Hosur,Bagalkot,Karnataka',
'Illal,Bagalkot,Karnataka',
'Jadramkunti,Bagalkot,Karnataka',
'Kadampur,Bagalkot,Karnataka',
'Kadlimatti,Bagalkot,Karnataka',
'Kaladgi,Bagalkot,Karnataka',
'Khajjidoni,Bagalkot,Karnataka',
'Kirsur,Bagalkot,Karnataka',
'Mallapur,Bagalkot,Karnataka',
'Muchakandi,Bagalkot,Karnataka',
'Mugalolli,Bagalkot,Karnataka',
'Murnal,Bagalkot,Karnataka',
'Nainegali,Bagalkot,Karnataka',
'Niralkeri,Bagalkot,Karnataka',
'Rampur,Bagalkot,Karnataka',
'Shigikeri,Bagalkot,Karnataka',
'Shirur,Bagalkot,Karnataka',
'Simikeri,Bagalkot,Karnataka',
'Sokanadagi,Bagalkot,Karnataka',
'Sutagundar,Bagalkot,Karnataka',
'Tulsigeri,Bagalkot,Karnataka',
'Udagatti,Bagalkot,Karnataka',
'Yadahalli,Bagalkot,Karnataka',
'Algundi,Bagalkot,Karnataka',
'Amalzeri,Bagalkot,Karnataka',
'Anagwadi,Bagalkot,Karnataka',
'Arakeri,Bagalkot,Karnataka',
'Badagandi,Bagalkot,Karnataka',
'Badagi,Bagalkot,Karnataka',
'Bilgi,Bagalkot,Karnataka',
'Bisnal,Bagalkot,Karnataka',
'Dhavaleshwar,Bagalkot,Karnataka',
'Galagali,Bagalkot,Karnataka',
'Girisagar,Bagalkot,Karnataka',
'Hanchinal,Bagalkot,Karnataka',
'Herkal,Bagalkot,Karnataka',
'Honnihal,Bagalkot,Karnataka',
'Janmatti,Bagalkot,Karnataka',
'Kaladgi Bazar,Bagalkot,Karnataka',
'Kandgal,Bagalkot,Karnataka',
'Kataraki,Bagalkot,Karnataka',
'Kolur,Bagalkot,Karnataka',
'Koppa,Bagalkot,Karnataka',
'Kundaragi,Bagalkot,Karnataka',
'Lingapur,Bagalkot,Karnataka',
'Mannikeri,Bagalkot,Karnataka',
'Mundagnur,Bagalkot,Karnataka',
'Muttaldinni,Bagalkot,Karnataka',
'Rolli,Bagalkot,Karnataka',
'Shiraguppi,Bagalkot,Karnataka',
'Siddapur,Bagalkot,Karnataka',
'Sonna,Bagalkot,Karnataka',
'Sorkoppa,Bagalkot,Karnataka',
'Sunag,Bagalkot,Karnataka',
'Teggi,Bagalkot,Karnataka',
'Tolmatti,Bagalkot,Karnataka',
'Tummarmatti,Bagalkot,Karnataka',
'Yadahalli,Bagalkot,Karnataka',
'Aihole,Bagalkot,Karnataka',
'Amaravati,Bagalkot,Karnataka',
'Amarawadgi,Bagalkot,Karnataka',
'Amingad,Bagalkot,Karnataka',
'Balkundi,Bagalkot,Karnataka',
'Banakanadoni,Bagalkot,Karnataka',
'Belgal,Bagalkot,Karnataka',
'Bevinmatti,Bagalkot,Karnataka',
'Bhimangad,Bagalkot,Karnataka',
'Bisaldinni,Bagalkot,Karnataka',
'Budihal S.K.,Bagalkot,Karnataka',
'Chikkadapur,Bagalkot,Karnataka',
'Chikmagi,Bagalkot,Karnataka',
'Chilapur,Bagalkot,Karnataka',
'Chinnapur,Bagalkot,Karnataka',
'Chittargi,Bagalkot,Karnataka',
'Chitwadgi,Bagalkot,Karnataka',
'Dhannur,Bagalkot,Karnataka',
'Ganjihal,Bagalkot,Karnataka',
'Gorbal,Bagalkot,Karnataka',
'Hadagalli,Bagalkot,Karnataka',
'Havaragi,Bagalkot,Karnataka',
'Herur,Bagalkot,Karnataka',
'Hirebadwadgi,Bagalkot,Karnataka',
'Hirekodagali,Bagalkot,Karnataka',
'Hiremagi,Bagalkot,Karnataka',
'Hiremalgavi,Bagalkot,Karnataka',
'Hireotageri,Bagalkot,Karnataka',
'Hiresingangutti,Bagalkot,Karnataka',
'Hulaginal,Bagalkot,Karnataka',
'Hungund Bazar,Bagalkot,Karnataka',
'Hungund,Bagalkot,Karnataka',
'Huvanur,Bagalkot,Karnataka',
'Iddalgi,Bagalkot,Karnataka',
'Ilal,Bagalkot,Karnataka',
'Ilkal Alampurpet,Bagalkot,Karnataka',
'Ilkal Gandhi Chowk.,Bagalkot,Karnataka',
'Ilkal,Bagalkot,Karnataka',
'Jalkamaladinni,Bagalkot,Karnataka',
'Jammaldinni,Bagalkot,Karnataka',
'Kadiwal,Bagalkot,Karnataka',
'Kadiwal Kallapur,Bagalkot,Karnataka',
'Kamaldinni Village,Bagalkot,Karnataka',
'Kamatgi,Bagalkot,Karnataka',
'Kamblihal,Bagalkot,Karnataka',
'Kandgal,Bagalkot,Karnataka',
'Karadi,Bagalkot,Karnataka',
'Katagur,Bagalkot,Karnataka',
'Kelur,Bagalkot,Karnataka',
'Kodihal,Bagalkot,Karnataka',
'Marol,Bagalkot,Karnataka',
'Moratageri,Bagalkot,Karnataka',
'Muganur,Bagalkot,Karnataka',
'Murdi,Bagalkot,Karnataka',
'Nagur,Bagalkot,Karnataka',
'Nandwadgi,Bagalkot,Karnataka',
'Rakkasagi,Bagalkot,Karnataka',
'Ramthal,Bagalkot,Karnataka',
'Ramwadgi,Bagalkot,Karnataka',
'Sangam,Bagalkot,Karnataka',
'Sulebhavi,Bagalkot,Karnataka',
'Surlikal,Bagalkot,Karnataka',
'Tallikeri,Bagalkot,Karnataka',
'Timmapur,Bagalkot,Karnataka',
'Tumba,Bagalkot,Karnataka',
'Wadageri,Bagalkot,Karnataka',
'Bevur,Bagalkot,Karnataka',
'Ilkal Town,Bagalkot,Karnataka',
'Adihudi,Bijapur,Karnataka',
'Bidari (Jkd),Bijapur,Karnataka',
'Bolachikkalki (JKD),Bijapur,Karnataka',
'Gadyal,Bijapur,Karnataka',
'Gothe,Bijapur,Karnataka',
'Jambagi (Bk),Bijapur,Karnataka',
'Kalabilagi,Bijapur,Karnataka',
'Kannolli,Bijapur,Karnataka',
'Savalgi,Bijapur,Karnataka',
'Takkalki,Bijapur,Karnataka',
'Tungal,Bijapur,Karnataka',
'Kadapatti,Bagalkot,Karnataka',
'Jamkhandi Girishanagar,Bagalkot,Karnataka',
'Albal,Bagalkot,Karnataka',
'Algur,Bagalkot,Karnataka',
'Asangi,Bagalkot,Karnataka',
'Banahatti,Bagalkot,Karnataka',
'Banahatti Somaarpeth,Bagalkot,Karnataka',
'Budni,Bagalkot,Karnataka',
'Chikkalki,Bijapur,Karnataka',
'Chikpadasalagi,Bagalkot,Karnataka',
'Chimmad,Bagalkot,Karnataka',
'Chingundi,Bagalkot,Karnataka',
'Gani,Bagalkot,Karnataka',
'Golbhavi,Bagalkot,Karnataka',
'Halingali,Bagalkot,Karnataka',
'Hanagandi,Bagalkot,Karnataka',
'Hipparagi,Bagalkot,Karnataka',
'Hosur,Bagalkot,Karnataka',
'Hulyal,Bagalkot,Karnataka',
'Hunnur,Bagalkot,Karnataka',
'Hunshikatti,Bagalkot,Karnataka',
'Jagadal,Bagalkot,Karnataka',
'Jamkhandi B.S.R.,Bagalkot,Karnataka',
'Jamkhandi Chavadi,Bagalkot,Karnataka',
'Jamkhandi H.O,Bagalkot,Karnataka',
'Kadakol,Bagalkot,Karnataka',
'Kajibilgi,Bijapur,Karnataka',
'Kalahalli,Bagalkot,Karnataka',
'Kankanwadi,Bagalkot,Karnataka',
'Kavatagi,Bagalkot,Karnataka',
'Konnur,Bagalkot,Karnataka',
'Kulahalli,Bagalkot,Karnataka',
'Kumbarhal,Bagalkot,Karnataka',
'Kunchanur,Bagalkot,Karnataka',
'Linganur,Bagalkot,Karnataka',
'Madarkhandi,Bagalkot,Karnataka',
'Maigur,Bagalkot,Karnataka',
'Mareguddi,Bagalkot,Karnataka',
'Muttur,Bagalkot,Karnataka',
'Naganur,Bagalkot,Karnataka',
'Navalagi,Bagalkot,Karnataka',
'Rabkavi,Bagalkot,Karnataka',
'Rabkavi Town,Bagalkot,Karnataka',
'Rampur,Bagalkot,Karnataka',
'Sasalatti,Bagalkot,Karnataka',
'Shiraguppi,Bagalkot,Karnataka',
'Shurpali,Bagalkot,Karnataka',
'Siddapur,Bagalkot,Karnataka',
'Tamadaddi,Bagalkot,Karnataka',
'Terdal Bazar,Bagalkot,Karnataka',
'Terdal,Bagalkot,Karnataka',
'Todalbagi,Bagalkot,Karnataka',
'Tubachi,Bagalkot,Karnataka',
'Yallatti,Bagalkot,Karnataka',
'Hirepadasalagi,Bagalkot,Karnataka',
'Bantanur,Bagalkot,Karnataka',
'Baragi,Bagalkot,Karnataka',
'Belagali,Bagalkot,Karnataka',
'Bidari,Bagalkot,Karnataka',
'Chichakandi K.D.,Bagalkot,Karnataka',
'Chichakhandi B.K.,Bagalkot,Karnataka',
'Chikkur,Bagalkot,Karnataka',
'Dadnatti,Bagalkot,Karnataka',
'Dhavaleshwar,Bagalkot,Karnataka',
'Gulgal Jambgi,Bagalkot,Karnataka',
'Halagali,Bagalkot,Karnataka',
'Hebbal,Bagalkot,Karnataka',
'Ingalagi,Bagalkot,Karnataka',
'Jeergal,Bagalkot,Karnataka',
'Kadarkoppa,Bagalkot,Karnataka',
'Kasabajambgi,Bagalkot,Karnataka',
'Kesargoppa,Bagalkot,Karnataka',
'Kulali,Bagalkot,Karnataka',
'Lokapur,Bagalkot,Karnataka',
'Machakanur,Bagalkot,Karnataka',
'Madhabhavi,Bagalkot,Karnataka',
'Mahalingpur Apmc Yard,Bagalkot,Karnataka',
'Mahalingpur,Bagalkot,Karnataka',
'Malali,Bagalkot,Karnataka',
'Malapur,Bagalkot,Karnataka',
'Mantur,Bagalkot,Karnataka',
'Marapur,Bagalkot,Karnataka',
'Melligeri,Bagalkot,Karnataka',
'Metgudd,Bagalkot,Karnataka',
'Mirji,Bagalkot,Karnataka',
'Muddapur,Bagalkot,Karnataka',
'Mudhol Bazar,Bagalkot,Karnataka',
'Mudhol Extension,Bagalkot,Karnataka',
'Mudhol,Bagalkot,Karnataka',
'Mugalkhod,Bagalkot,Karnataka',
'Nagaral,Bagalkot,Karnataka',
'Nagaral,Bagalkot,Karnataka',
'Nandgaon,Bagalkot,Karnataka',
'Ningapur,Bagalkot,Karnataka',
'Petlur,Bagalkot,Karnataka',
'Rugi,Bagalkot,Karnataka',
'Saidapur,Bagalkot,Karnataka',
'Sameerwadi,Bagalkot,Karnataka',
'Shirol,Bagalkot,Karnataka',
'Sorgaon,Bagalkot,Karnataka',
'Uttur,Bagalkot,Karnataka',
'Vajjarmatti,Bagalkot,Karnataka',
'Vantigodi,Bagalkot,Karnataka',
'Varchagal,Bagalkot,Karnataka',
'Yadahalli,Bagalkot,Karnataka',
'Basavanagudi H.O,Bangalore South,Karnataka',
'Agara,Bangalore South,Karnataka',
'Air Force Hospital,Bangalore East,Karnataka',
'Amruthahalli,Bangalore East,Karnataka',
'Anandnagar,Bangalore East,Karnataka',
'Austin Town,Bangalore East,Karnataka',
'Banaswadi,Bangalore East,Karnataka',
'Bangalore Air Port,Bangalore East,Karnataka',
'Bangalore Bazaar,Bangalore East,Karnataka',
'Bangalore Sub Fgn Post,Bangalore East,Karnataka',
'Bhattarahalli,Bangalore East,Karnataka',
'Brigade Road,Bangalore East,Karnataka',
'BSF Campus Yelahanka,Bangalore East,Karnataka',
'Byatarayanapura,Bangalore East,Karnataka',
'CMP Centre And School,Bangalore East,Karnataka',
'CRPF Campus Yelahanka,Bangalore East,Karnataka',
'Cubban Road,Bangalore East,Karnataka',
'Devarjeevanahalli,Bangalore East,Karnataka',
'Devasandra,Bangalore East,Karnataka',
'Doddanekkundi,Bangalore East,Karnataka',
'Dr. Ambedkar Veedhi,Bangalore East,Karnataka',
'Hebbal Kempapura,Bangalore East,Karnataka',
'HighCourt,Bangalore East,Karnataka',
'Hoodi,Bangalore East,Karnataka',
'Hulsur Bazaar,Bangalore East,Karnataka',
'Indiranagar Com. Complex,Bangalore East,Karnataka',
'ISRO Anthariksha Bhavan,Bangalore East,Karnataka',
'Jakkur,Bangalore East,Karnataka',
'Jalavayuvihar,Bangalore East,Karnataka',
'Jeevanahalli,Bangalore East,Karnataka',
'Jeevanbhimanagar,Bangalore East,Karnataka',
'Kacharakanahalli,Bangalore East,Karnataka',
'Kendriya Vihar,Bangalore East,Karnataka',
'Kodigehalli,Bangalore East,Karnataka',
'Krishnarajapuram R S,Bangalore East,Karnataka',
'Kundalahalli,Bangalore East,Karnataka',
'Legislators Home,Bangalore East,Karnataka',
'Lingarajapuram,Bangalore East,Karnataka',
'Mahatma Gandhi Road,Bangalore East,Karnataka',
'Malkand Lines,Bangalore East,Karnataka',
'Mandalay Lines,Bangalore East,Karnataka',
'Medihalli,Bangalore East,Karnataka',
'Nagavara,Bangalore East,Karnataka',
'NAL,Bangalore East,Karnataka',
'Narayan Pillai Street,Bangalore East,Karnataka',
'P&T Col. Kavalbyrasandra,Bangalore East,Karnataka',
'Rajbhavan,Bangalore East,Karnataka',
'Ramagondanahalli,Bangalore East,Karnataka',
'Ramakrishna Hegde Nagar,Bangalore East,Karnataka',
'Ramamurthy Nagar,Bangalore East,Karnataka',
'Rameshnagar,Bangalore East,Karnataka',
'Richmond Town,Bangalore East,Karnataka',
'Someswarapura,Bangalore East,Karnataka',
'Thambuchetty Palya,Bangalore East,Karnataka',
'Training Command IAF,Bangalore East,Karnataka',
'Venkateshapura,Bangalore East,Karnataka',
'Vidhana Soudha,Bangalore East,Karnataka',
'Wheel And Axle Plant,Bangalore East,Karnataka',
'Yelahanka Satellite Town,Bangalore East,Karnataka',
'Yemalur,Bangalore East,Karnataka',
'Anekal,Channapatna,Karnataka',
'Anekalbazar,Channapatna,Karnataka',
'Attibele,Channapatna,Karnataka',
'Bestamaranahalli,Channapatna,Karnataka',
'Bidaraguppe,Channapatna,Karnataka',
'Dommasandra,Channapatna,Karnataka',
'Handenahalli,Channapatna,Karnataka',
'Harogadde,Channapatna,Karnataka',
'Hennagara,Channapatna,Karnataka',
'Hulimangala,Channapatna,Karnataka',
'Indalavadi,Channapatna,Karnataka',
'Jigani,Channapatna,Karnataka',
'Kugur,Channapatna,Karnataka',
'Marsur,Channapatna,Karnataka',
'Mayasandra,Channapatna,Karnataka',
'Neralur,Channapatna,Karnataka',
'Samandur,Channapatna,Karnataka',
'Sarjapura,Channapatna,Karnataka',
'Sidihoskote,Channapatna,Karnataka',
'Thammanayakanahalli,Channapatna,Karnataka',
'Vanakanahalli,Channapatna,Karnataka',
'Yadavanahalli,Channapatna,Karnataka',
'C.V.Raman Nagar,Bangalore East,Karnataka',
'Bangalore G.P.O.,Bangalore Gpo,Karnataka',
'Domlur,Bangalore East,Karnataka',
'H.A.L II Stage H.O,Bangalore East,Karnataka',
'R T Nagar H.O,Bangalore East,Karnataka',
'Doorvaninagar,Bangalore East,Karnataka',
'A F Station Yelahanka,Bangalore East,Karnataka',
'Arabic College,Bangalore East,Karnataka',
'Aranya Bhavan,Bangalore West,Karnataka',
'Attur,Bangalore East,Karnataka',
'Avani Sringeri Mutt,Bangalore West,Karnataka',
'Bagalgunte,Bangalore West,Karnataka',
'Bangalore City,Bangalore West,Karnataka',
'Bangalore Dist Offices Bldg,Bangalore West,Karnataka',
'Basaveshwaranagar,Bangalore West,Karnataka',
'Basaveswaranagar II Stage,Bangalore West,Karnataka',
'Benson Town,Bangalore East,Karnataka',
'Bettahalsur,Channapatna,Karnataka',
'Bhashyam Circle,Bangalore West,Karnataka',
'Chandra Lay Out,Bangalore West,Karnataka',
'Chikkabettahalli,Bangalore West,Karnataka',
'Dasarahalli,Bangalore West,Karnataka',
'Fraser Town,Bangalore East,Karnataka',
'G.K.V.K.,Bangalore East,Karnataka',
'Gayathrinagar,Bangalore West,Karnataka',
'Goraguntepalya,Bangalore West,Karnataka',
'Govindapalya,Bangalore West,Karnataka',
'H M T,Bangalore West,Karnataka',
'H.K.P. Road,Bangalore East,Karnataka',
'Hampinagar,Bangalore West,Karnataka',
'Horamavu,Bangalore East,Karnataka',
'Industrial Estate,Bangalore West,Karnataka',
'J.C.Nagar,Bangalore East,Karnataka',
'Jalahalli East,Bangalore West,Karnataka',
'Jalahalli H.O,Bangalore West,Karnataka',
'Jalahalli Village,Bangalore West,Karnataka',
'Jalahalli West,Bangalore West,Karnataka',
'K H B Colony,Bangalore West,Karnataka',
'K. G. Road,Bangalore West,Karnataka',
'K.P.West,Bangalore West,Karnataka',
'Kalyanagar,Bangalore East,Karnataka',
'Kamagondanahalli,Bangalore West,Karnataka',
'Kamakshipalya,Bangalore West,Karnataka',
'Kanteeravanagar,Bangalore West,Karnataka',
'Kothanur,Bangalore East,Karnataka',
'M S R Road,Bangalore West,Karnataka',
'Magadi Road,Bangalore West,Karnataka',
'Mahalakshmipuram Layout,Bangalore West,Karnataka',
'Malleswaram,Bangalore West,Karnataka',
'Malleswaram West,Bangalore West,Karnataka',
'Maruthi Sevanagar,Bangalore East,Karnataka',
'Mathikere,Bangalore West,Karnataka',
'Milk Colony,Bangalore West,Karnataka',
'Msrit,Bangalore West,Karnataka',
'Museum Road,Bangalore East,Karnataka',
'Nagarbhavi,Bangalore West,Karnataka',
'Nagasandra,Bangalore West,Karnataka',
'Nandinilayout,Bangalore West,Karnataka',
'Okalipuram,Bangalore West,Karnataka',
'Palace Guttahalli,Bangalore West,Karnataka',
'Peenya I Stage,Bangalore West,Karnataka',
'Peenya II Stage,Bangalore West,Karnataka',
'Peenya Small Industries,Bangalore West,Karnataka',
'R.M.V. Extension II Stage,Bangalore East,Karnataka',
'Rajajinagar H.O,Bangalore West,Karnataka',
'Rajajinagar I Block,Bangalore West,Karnataka',
'Rajajinagar IVth Block,Bangalore West,Karnataka',
'Rajanakunte,Bangalore East,Karnataka',
'Ramachandrapuram,Bangalore West,Karnataka',
'Sadashivanagar,Bangalore East,Karnataka',
'Sahakaranagar P.O,Bangalore East,Karnataka',
'Science Institute,Bangalore West,Karnataka',
'Seshadripuram,Bangalore West,Karnataka',
'Singanayakanahalli,Bangalore East,Karnataka',
'Sivan Chetty Gardens,Bangalore East,Karnataka',
'Srirampuram,Bangalore West,Karnataka',
'St. Thomas Town,Bangalore East,Karnataka',
'Subhashnagar,Bangalore West,Karnataka',
'Swimming Pool Extn,Bangalore West,Karnataka',
'Vasanthnagar,Bangalore East,Karnataka',
'Venkatarangapura,Bangalore West,Karnataka',
'Vidyaranyapura,Bangalore West,Karnataka',
'Vijayanagar East,Bangalore West,Karnataka',
'Vijayanagar,Bangalore West,Karnataka',
'Viswaneedam,Bangalore West,Karnataka',
'Vyalikaval Extn,Bangalore West,Karnataka',
'Yelahanka,Bangalore East,Karnataka',
'Yeshwanthpur Bazar,Bangalore West,Karnataka',
'Yeswanthpura,Bangalore West,Karnataka',
'Adugodi,Bangalore South,Karnataka',
'Agram,Bangalore East,Karnataka',
'Ashoknagar,Bangalore South,Karnataka',
'Avalahalli,Bangalore South,Karnataka',
'Avenue Road,Bangalore South,Karnataka',
'Balepete,Bangalore South,Karnataka',
'Banashankari III Stage,Bangalore South,Karnataka',
'Banashankari,Bangalore South,Karnataka',
'Bangalore Corporation Building,Bangalore South,Karnataka',
'Bangalore Fort,Bangalore South,Karnataka',
'Bannerghatta Road,Bangalore South,Karnataka',
'Bannerghatta,Bangalore South,Karnataka',
'Bapujinagar,Bangalore South,Karnataka',
'Basavaraja Market,Bangalore South,Karnataka',
'Bellandur,Bangalore East,Karnataka',
'Bidrahalli,Bangalore East,Karnataka',
'Bnagalore Viswavidalaya,Bangalore South,Karnataka',
'Bommanahalli,Bangalore South,Karnataka',
'Byatarayanapura,Bangalore South,Karnataka',
'Cahmrajendrapet,Bangalore South,Karnataka',
'Chamrajpet Bazar,Bangalore South,Karnataka',
'Chamrajpet,Bangalore South,Karnataka',
'Chickpet,Bangalore South,Karnataka',
'Chikkalasandra,Bangalore South,Karnataka',
'Dasarahalli,Bangalore South,Karnataka',
'Deepanjalinagar,Bangalore South,Karnataka',
'Devanagundi,Bangalore East,Karnataka',
'Dharmaram College,Bangalore South,Karnataka',
'Doddakallasandra,Bangalore South,Karnataka',
'Doddakallasandra,Bangalore South,Karnataka',
'Electronics City,Bangalore South,Karnataka',
'Gaviopuram Extension,Bangalore South,Karnataka',
'Gaviopuram Guttanahalli,Bangalore South,Karnataka',
'Girinagar,Bangalore South,Karnataka',
'Goripalya,Bangalore South,Karnataka',
'Goripalya,Bangalore South,Karnataka',
'Governmemnt Electric Factory,Bangalore South,Karnataka',
'Gunjur,Bangalore East,Karnataka',
'Hongasandra,Bangalore South,Karnataka',
'Hosakerehalli,Bangalore South,Karnataka',
'Hosur Road,Bangalore South,Karnataka',
'HSR Layout,Bangalore South,Karnataka',
'Hulimavu,Bangalore South,Karnataka',
'Immedihalli,Bangalore East,Karnataka',
'Indiranagar,Bangalore East,Karnataka',
'Ittamadu Layout,Bangalore South,Karnataka',
'J P Nagar,Bangalore South,Karnataka',
'Jayanagar H.O,Bangalore South,Karnataka',
'Jayanagar West,Bangalore South,Karnataka',
'Jayangar III Block,Bangalore South,Karnataka',
'Jp Nagar Iii Phase,Bangalore South,Karnataka',
'Kadugodi,Bangalore East,Karnataka',
'Kalkunte,Bangalore East,Karnataka',
'Kannamangala,Bangalore East,Karnataka',
'Kathriguppe,Bangalore South,Karnataka',
'Kenchanahalli,Bangalore South,Karnataka',
'Kendriya Sadan,Bangalore South,Karnataka',
'Konanakunte,Bangalore South,Karnataka',
'Koramangala I Block,Bangalore South,Karnataka',
'Koramangala,Bangalore South,Karnataka',
'Koramangala VI Bk,Bangalore South,Karnataka',
'Krishnarajapuram,Bangalore East,Karnataka',
'Kumaraswamy Layout,Bangalore South,Karnataka',
'Kumbalgodu,Bangalore South,Karnataka',
'Lalbagh West,Bangalore South,Karnataka',
'Madhavan Park,Bangalore South,Karnataka',
'Madivala,Bangalore South,Karnataka',
'Mahadevapura,Bangalore East,Karnataka',
'Mallathahalli,Bangalore South,Karnataka',
'Marathahalli Colony,Bangalore East,Karnataka',
'Mavalli,Bangalore South,Karnataka',
'Medimallasandra,Bangalore East,Karnataka',
'Mico Layout,Bangalore South,Karnataka',
'Mount St Joseph,Bangalore South,Karnataka',
'Mundur,Bangalore East,Karnataka',
'Muthanallur,Bangalore South,Karnataka',
'Muthusandra,Bangalore East,Karnataka',
'Naduvathi,Bangalore East,Karnataka',
'Narasimharaja Colony,Bangalore South,Karnataka',
'Narasimjharaja Road,Bangalore South,Karnataka',
'Nayandahalli,Bangalore South,Karnataka',
'New Tharaggupet,Bangalore South,Karnataka',
'New Thippasandra,Bangalore East,Karnataka',
'Padmanabhnagar,Bangalore South,Karnataka',
'Panathur,Bangalore East,Karnataka',
'Pasmpamahakavi Road,Bangalore South,Karnataka',
'Rajarajeshwarinagar,Bangalore South,Karnataka',
'Rv Niketan,Bangalore South,Karnataka',
'Samethanahalli,Bangalore East,Karnataka',
'Sampangiramnagar,Bangalore South,Karnataka',
'Shankarpura,Bangalore South,Karnataka',
'Shanthinagar,Bangalore South,Karnataka',
'Sri Jayachamarajendra Road,Bangalore South,Karnataka',
'St. John\'s Medical College,Bangalore South,Karnataka',
'State Bank Of Mysore Colony,Bangalore South,Karnataka',
'Subramanyapura,Bangalore South,Karnataka',
'Taverekere,Bangalore South,Karnataka',
'Tilaknagar,Bangalore South,Karnataka',
'Tyagrajnagar,Bangalore South,Karnataka',
'Ullalu Upanagara,Bangalore South,Karnataka',
'Vartur,Bangalore East,Karnataka',
'Vikramnagar,Bangalore South,Karnataka',
'Vimapura,Bangalore East,Karnataka',
'Virgonagar,Bangalore East,Karnataka',
'Visveswarapuram,Bangalore South,Karnataka',
'Vittalnagar,Bangalore South,Karnataka',
'Viveknagar,Bangalore East,Karnataka',
'Whitefield,Bangalore East,Karnataka',
'Wilson Garden,Bangalore South,Karnataka',
'Yediyur,Bangalore South,Karnataka',
'Yelachenahalli,Bangalore South,Karnataka',
'H.A. Farm,Bangalore East,Karnataka',
'Tavarekere,Channapatna,Karnataka',
'B Sk II Stage,Bangalore South,Karnataka',
'Jayangar East,Bangalore South,Karnataka',
'Bagalur,Channapatna,Karnataka',
'Chikkajala,Channapatna,Karnataka',
'Doddagubbi,Channapatna,Karnataka',
'Doddajala,Channapatna,Karnataka',
'Hunasamaranahalli,Channapatna,Karnataka',
'Kannur,Channapatna,Karnataka',
'Tarahunise,Channapatna,Karnataka',
'Vidyanagara,Channapatna,Karnataka',
'Chunchanakuppe,Channapatna,Karnataka',
'Bandikodigehalli,Channapatna,Karnataka',
'Chikkanahalli,Channapatna,Karnataka',
'Kadabagere,Channapatna,Karnataka',
'Chandapura,Bangalore South,Karnataka',
'Bapagrama,Bangalore West,Karnataka',
'Byatha,Bangalore West,Karnataka',
'Chikkabanavara,Bangalore West,Karnataka',
'Chikkabidarkal,Bangalore West,Karnataka',
'Herohalli,Bangalore West,Karnataka',
'Hessarghatta Lake,Bangalore West,Karnataka',
'Hessarghatta,Bangalore West,Karnataka',
'Kakolu,Bangalore West,Karnataka',
'Kodigehalli,Bangalore West,Karnataka',
'Nelakadiranahalli,Bangalore West,Karnataka',
'Shivakote,Bangalore West,Karnataka',
'Silvepura,Bangalore West,Karnataka',
'Tarabanahalli,Bangalore West,Karnataka',
'Anjanapura,Bangalore South,Karnataka',
'Bannerghatta,Bangalore South,Karnataka',
'Begur,Bangalore South,Karnataka',
'Bilekahalli,Bangalore South,Karnataka',
'Bolare,Bangalore South,Karnataka',
'Bommasandra Industrial Estate,Bangalore South,Karnataka',
'Carmelaram,Bangalore South,Karnataka',
'Chudenapura,Bangalore South,Karnataka',
'Gottigere,Bangalore South,Karnataka',
'Hebbagodi,Bangalore South,Karnataka',
'Huskur,Bangalore South,Karnataka',
'Kagalipura,Bangalore South,Karnataka',
'Kalkere,Bangalore South,Karnataka',
'Kengeri,Bangalore South,Karnataka',
'Kengeri Upanagara,Bangalore South,Karnataka',
'Kumbalgodu Gollahalli,Bangalore South,Karnataka',
'Ramohalli,Bangalore South,Karnataka',
'Sakalavara,Bangalore South,Karnataka',
'Singasandra,Bangalore South,Karnataka',
'Somanhalli,Bangalore South,Karnataka',
'Sulikere,Bangalore South,Karnataka',
'Talaghatapura,Bangalore South,Karnataka',
'Taralu,Bangalore South,Karnataka',
'Tataguni,Bangalore South,Karnataka',
'Thattekuppe,Bangalore South,Karnataka',
'Udaypura,Bangalore South,Karnataka',
'Kithanahalli,Channapatna,Karnataka',
'Alurduddanahalli,Channapatna,Karnataka',
'Anneshwara,Channapatna,Karnataka',
'Aradeshanahalli,Channapatna,Karnataka',
'Avathi,Channapatna,Karnataka',
'Bidalur,Channapatna,Karnataka',
'Bijjawara,Channapatna,Karnataka',
'Channarayapatna,Channapatna,Karnataka',
'Devanahalli,Channapatna,Karnataka',
'Devanahallifort,Channapatna,Karnataka',
'Doddasanne,Channapatna,Karnataka',
'Harohalli,Channapatna,Karnataka',
'Jalige,Channapatna,Karnataka',
'Kannamangala,Channapatna,Karnataka',
'Koira,Channapatna,Karnataka',
'Kundana,Channapatna,Karnataka',
'Mandibele,Channapatna,Karnataka',
'Narayanapura,Channapatna,Karnataka',
'Uganavadi,Channapatna,Karnataka',
'Venkatagirikote,Channapatna,Karnataka',
'Vijayapaura,Channapatna,Karnataka',
'Vishwanathapura,Channapatna,Karnataka',
'Hegganahalli,Channapatna,Karnataka',
'Karahalli,Channapatna,Karnataka',
'Sadahalli,Channapatna,Karnataka',
'Yeliyur,Channapatna,Karnataka',
'Heggadahalli,Channapatna,Karnataka',
'Arudi,Channapatna,Karnataka',
'Baktharahalli,Channapatna,Karnataka',
'Dodballapura Bazar,Channapatna,Karnataka',
'Doddahejjaji,Channapatna,Karnataka',
'Doddatumkur,Channapatna,Karnataka',
'Gantiganahalli,Channapatna,Karnataka',
'Hadonahalli,Channapatna,Karnataka',
'Hanabe,Channapatna,Karnataka',
'Hulikunte,Channapatna,Karnataka',
'Kadalappanahalli,Channapatna,Karnataka',
'Kadanur,Channapatna,Karnataka',
'Koligere,Channapatna,Karnataka',
'Kongadiyappa Road,Channapatna,Karnataka',
'Melekote,Channapatna,Karnataka',
'Purushanahalli,Channapatna,Karnataka',
'Rameshwara,Channapatna,Karnataka',
'Sakkaaregollahalli,Channapatna,Karnataka',
'Sasalu,Channapatna,Karnataka',
'Syakaladevanapura,Channapatna,Karnataka',
'Tubugere,Channapatna,Karnataka',
'Antharahalli,Channapatna,Karnataka',
'Arakere,Channapatna,Karnataka',
'Arallumallige,Channapatna,Karnataka',
'Basettihalli,Channapatna,Karnataka',
'Dodballapura,Channapatna,Karnataka',
'Doddabelavangala,Channapatna,Karnataka',
'Gundamgere,Channapatna,Karnataka',
'Hosahalli,Channapatna,Karnataka',
'Kanasavadi,Channapatna,Karnataka',
'Kannamangala,Channapatna,Karnataka',
'Kodigehalli,Channapatna,Karnataka',
'Konnagatta,Channapatna,Karnataka',
'Mallathahalli,Channapatna,Karnataka',
'Rajaghatta,Channapatna,Karnataka',
'Shivapura,Channapatna,Karnataka',
'Sri Subramanyaghati,Channapatna,Karnataka',
'Tippur,Channapatna,Karnataka',
'Veerapura,Channapatna,Karnataka',
'Begur,Channapatna,Karnataka',
'Bendiganahalli,Channapatna,Karnataka',
'Bettakote,Channapatna,Karnataka',
'Budigere,Channapatna,Karnataka',
'Bylanarasapura,Channapatna,Karnataka',
'Doddagattiganabbe,Channapatna,Karnataka',
'Doddanallala,Channapatna,Karnataka',
'Hasigala,Channapatna,Karnataka',
'Hindaganala,Channapatna,Karnataka',
'Hoskote Indl. Area,Channapatna,Karnataka',
'Hoskote,Channapatna,Karnataka',
'Ibasapura,Channapatna,Karnataka',
'Jadigenahalli,Channapatna,Karnataka',
'Jodidasarahalli,Channapatna,Karnataka',
'K.Satyavara,Channapatna,Karnataka',
'Kattigenahalli,Channapatna,Karnataka',
'Kembliganahalli,Channapatna,Karnataka',
'Kollathur,Channapatna,Karnataka',
'Korati,Channapatna,Karnataka',
'Kumbalahalli,Channapatna,Karnataka',
'Lakkondanahalli,Channapatna,Karnataka',
'Mugabala,Channapatna,Karnataka',
'Nandagudi,Channapatna,Karnataka',
'Nelavagilu,Channapatna,Karnataka',
'Reddihalli,Channapatna,Karnataka',
'Shivanapura,Channapatna,Karnataka',
'Sulebele,Channapatna,Karnataka',
'Tavarekere,Channapatna,Karnataka',
'Vagata Agrahara,Channapatna,Karnataka',
'Mullahalli,Channapatna,Karnataka',
'Adarangi,Channapatna,Karnataka',
'Ajjanahalli,Channapatna,Karnataka',
'Baginigere,Channapatna,Karnataka',
'Banavadi,Channapatna,Karnataka',
'Biskur,Channapatna,Karnataka',
'Bylakere,Channapatna,Karnataka',
'Doddamudigere,Channapatna,Karnataka',
'Doddasomanahalli,Channapatna,Karnataka',
'Gangonahalli,Channapatna,Karnataka',
'Gudemaranahalli,Channapatna,Karnataka',
'Hulikal,Channapatna,Karnataka',
'Hullenahalli,Channapatna,Karnataka',
'Kudur,Channapatna,Karnataka',
'Lakkenahalli,Channapatna,Karnataka',
'Madigondanahalli,Channapatna,Karnataka',
'Manniganahalli,Channapatna,Karnataka',
'Marasandra,Channapatna,Karnataka',
'Marikuppe,Channapatna,Karnataka',
'Mayasandra,Channapatna,Karnataka',
'Motagondanahalli,Channapatna,Karnataka',
'Narasandra,Channapatna,Karnataka',
'Sankighatta,Channapatna,Karnataka',
'Sirigiripura,Channapatna,Karnataka',
'Solur,Channapatna,Karnataka',
'Sugganahalli,Channapatna,Karnataka',
'Thippasandra,Channapatna,Karnataka',
'Udukunte,Channapatna,Karnataka',
'Yennegere,Channapatna,Karnataka',
'Mahadevapura,Channapatna,Karnataka',
'Aluru,Channapatna,Karnataka',
'Arasinakunte,Channapatna,Karnataka',
'Arebommnahalli,Channapatna,Karnataka',
'Baragenahalli,Channapatna,Karnataka',
'Billanakote,Channapatna,Karnataka',
'Budihal,Channapatna,Karnataka',
'Dasanapaura,Channapatna,Karnataka',
'Devarahosahalli,Channapatna,Karnataka',
'Dobbespet,Channapatna,Karnataka',
'Doddabele,Channapatna,Karnataka',
'Gollahalli,Channapatna,Karnataka',
'Heggunda,Channapatna,Karnataka',
'Honnasandra,Channapatna,Karnataka',
'Huskur,Channapatna,Karnataka',
'Jakkanahalli,Channapatna,Karnataka',
'Kambalu,Channapatna,Karnataka',
'Kollalagatta,Channapatna,Karnataka',
'Kuluvanahalli,Channapatna,Karnataka',
'Lakkur,Channapatna,Karnataka',
'Lakshmipura,Channapatna,Karnataka',
'Madalakote,Channapatna,Karnataka',
'Madavara,Channapatna,Karnataka',
'Makali,Channapatna,Karnataka',
'Mallarabanavadi,Channapatna,Karnataka',
'Mandigere,Channapatna,Karnataka',
'Manne,Channapatna,Karnataka',
'Maralakunte,Channapatna,Karnataka',
'Mathahalli,Channapatna,Karnataka',
'Mylanahalli,Channapatna,Karnataka',
'Narasipura,Channapatna,Karnataka',
'Nelamangala,Channapatna,Karnataka',
'Niduvanda,Channapatna,Karnataka',
'Obalapura,Channapatna,Karnataka',
'Shivagange,Channapatna,Karnataka',
'Shivanapura,Channapatna,Karnataka',
'Soladevanahalli,Channapatna,Karnataka',
'Sondekoppa,Channapatna,Karnataka',
'Teppadabeguru,Channapatna,Karnataka',
'Tyamagondlu,Channapatna,Karnataka',
'Yelekyathanahalli,Channapatna,Karnataka',
'Yentiganahalli,Channapatna,Karnataka',
'Bailur,Belgaum,Karnataka',
'Batakurki,Belgaum,Karnataka',
'Ghataknur,Belgaum,Karnataka',
'Haletorgal,Belgaum,Karnataka',
'Hudli,Belgaum,Karnataka',
'Idgal,Belgaum,Karnataka',
'Neginhal,Belgaum,Karnataka',
'Sulebhavi,Belgaum,Karnataka',
'Surpur Kerwad,Belgaum,Karnataka',
'VTU Campus Belgaum,Belgaum,Karnataka',
'Wagawade RC,Belgaum,Karnataka',
'Yellur,Belgaum,Karnataka',
'Abbihal,Chikodi,Karnataka',
'Aigali,Chikodi,Karnataka',
'Ainapur,Chikodi,Karnataka',
'Anantpur,Chikodi,Karnataka',
'Athani Bazar,Chikodi,Karnataka',
'Athani H.O,Chikodi,Karnataka',
'Awarkhod,Chikodi,Karnataka',
'Balwad,Chikodi,Karnataka',
'Darur,Chikodi,Karnataka',
'Ghatnatti,Chikodi,Karnataka',
'Gundewadi,Chikodi,Karnataka',
'Hallihal,Chikodi,Karnataka',
'Hulagbali,Chikodi,Karnataka',
'Ingalgaon,Chikodi,Karnataka',
'Kagvad,Chikodi,Karnataka',
'Katgeri,Chikodi,Karnataka',
'Kodaganur,Chikodi,Karnataka',
'Kokatnur,Chikodi,Karnataka',
'Madbhavi,Chikodi,Karnataka',
'Mangsuli,Chikodi,Karnataka',
'Murgundi,Chikodi,Karnataka',
'Nandgaon,Chikodi,Karnataka',
'Parthanhalli,Chikodi,Karnataka',
'Sankonhatti,Chikodi,Karnataka',
'Satti,Chikodi,Karnataka',
'Shedbal,Chikodi,Karnataka',
'Shirguppi,Chikodi,Karnataka',
'Shirhatti,Chikodi,Karnataka',
'Shivayoginagar,Chikodi,Karnataka',
'Telsang,Chikodi,Karnataka',
'Tirth,Chikodi,Karnataka',
'Ugarkhurd,Chikodi,Karnataka',
'Adhalli,Chikodi,Karnataka',
'Ajur,Chikodi,Karnataka',
'Aralihatti,Chikodi,Karnataka',
'Artal,Chikodi,Karnataka',
'Badchi,Chikodi,Karnataka',
'Badgi,Chikodi,Karnataka',
'Balligeri,Chikodi,Karnataka',
'Bannur,Chikodi,Karnataka',
'Bevanur,Chikodi,Karnataka',
'Chamakeri,Chikodi,Karnataka',
'Desairhatti,Chikodi,Karnataka',
'Faridkhanwadi,Chikodi,Karnataka',
'Halhalli,Chikodi,Karnataka',
'Hanamapur,Chikodi,Karnataka',
'Jakkarhatti,Chikodi,Karnataka',
'Jambagi,Chikodi,Karnataka',
'Janwad,Chikodi,Karnataka',
'Jugul,Chikodi,Karnataka',
'Kakmari,Chikodi,Karnataka',
'Kannal,Chikodi,Karnataka',
'Katral,Chikodi,Karnataka',
'Kempwadi,Chikodi,Karnataka',
'Khilegaon,Chikodi,Karnataka',
'Kirangi,Chikodi,Karnataka',
'Kohalli,Chikodi,Karnataka',
'Kottalgi,Chikodi,Karnataka',
'Krishna Kittur,Chikodi,Karnataka',
'Kusnal,Chikodi,Karnataka',
'Lokur,Chikodi,Karnataka',
'Mahishwadgi,Chikodi,Karnataka',
'Malabad,Chikodi,Karnataka',
'Mangavati,Chikodi,Karnataka',
'Masarguppi,Chikodi,Karnataka',
'Mole,Chikodi,Karnataka',
'Molwad,Chikodi,Karnataka',
'Nagnur P.K.,Chikodi,Karnataka',
'Nandeshwar,Chikodi,Karnataka',
'Navalihal,Chikodi,Karnataka',
'Phadatarwadi,Chikodi,Karnataka',
'Radderhatti,Chikodi,Karnataka',
'Ramtirth,Chikodi,Karnataka',
'Sambargi,Chikodi,Karnataka',
'Savadi,Chikodi,Karnataka',
'Shedbal R.S.,Chikodi,Karnataka',
'Shirur,Chikodi,Karnataka',
'Shivanur,Chikodi,Karnataka',
'Siddewadi,Chikodi,Karnataka',
'Suttatti,Chikodi,Karnataka',
'Tangadi,Chikodi,Karnataka',
'Tavashi,Chikodi,Karnataka',
'Ugarbudruk,Chikodi,Karnataka',
'Ugarkhurd Town,Chikodi,Karnataka',
'Vishnuwadi,Chikodi,Karnataka',
'Yelihadalgi,Chikodi,Karnataka',
'Zunzurwad,Chikodi,Karnataka',
'Tigadolli,Belgaum,Karnataka',
'Ambadgatti,Belgaum,Karnataka',
'Amtur,Belgaum,Karnataka',
'Anigol,Belgaum,Karnataka',
'Avaradi,Belgaum,Karnataka',
'Bailhongal Bazar,Belgaum,Karnataka',
'Bailhongal H.O,Belgaum,Karnataka',
'Bailhongal S.R. Chowk,Belgaum,Karnataka',
'Bailwad,Belgaum,Karnataka',
'Basarkod,Belgaum,Karnataka',
'Belvadi,Belgaum,Karnataka',
'Bhavihal,Belgaum,Karnataka',
'Budarkatti,Belgaum,Karnataka',
'Budihal,Belgaum,Karnataka',
'Chikbagewadi,Belgaum,Karnataka',
'Dastikop,Belgaum,Karnataka',
'Degaon,Belgaum,Karnataka',
'Deshnur,Belgaum,Karnataka',
'Devalapur,Belgaum,Karnataka',
'Devara Shigihalli,Belgaum,Karnataka',
'Dodwad,Belgaum,Karnataka',
'Gajminhal,Belgaum,Karnataka',
'Govankop,Belgaum,Karnataka',
'Hanabaratti,Belgaum,Karnataka',
'Hannikeri,Belgaum,Karnataka',
'Harugoppa,Belgaum,Karnataka',
'Hirebellikatti,Belgaum,Karnataka',
'Hirenandihalli,Belgaum,Karnataka',
'Holehosur,Belgaum,Karnataka',
'Holenaglapur,Belgaum,Karnataka',
'Hoolikatti (KTR),Belgaum,Karnataka',
'Hunshikatti,Belgaum,Karnataka',
'Inchal,Belgaum,Karnataka',
'Kadrolli,Belgaum,Karnataka',
'Kalbhavi,Belgaum,Karnataka',
'Kenganur,Belgaum,Karnataka',
'Khudanpur,Belgaum,Karnataka',
'Kittur Channamma School,Belgaum,Karnataka',
'Kittur,Belgaum,Karnataka',
'Kittur Somwarpeth,Belgaum,Karnataka',
'Kulvalli,Belgaum,Karnataka',
'Lakkundi,Belgaum,Karnataka',
'M.K.Hubli S.F.,Belgaum,Karnataka',
'M.K.Hubli,Belgaum,Karnataka',
'Madanbhavi,Belgaum,Karnataka',
'Mardinagalapur,Belgaum,Karnataka',
'Margankop,Belgaum,Karnataka',
'Marikatti,Belgaum,Karnataka',
'Mattikoppa,Belgaum,Karnataka',
'Mugbasav,Belgaum,Karnataka',
'Murkibhavi,Belgaum,Karnataka',
'Myakalmardi,Belgaum,Karnataka',
'Nagnur,Belgaum,Karnataka',
'Navalgatti,Belgaum,Karnataka',
'Nayanagar,Belgaum,Karnataka',
'Nesargi,Belgaum,Karnataka',
'Nichanki,Belgaum,Karnataka',
'Pattihal,Belgaum,Karnataka',
'Sampgaon,Belgaum,Karnataka',
'Sangolli,Belgaum,Karnataka',
'Sutgatti,Belgaum,Karnataka',
'Tigadi,Belgaum,Karnataka',
'Turkarshigihalli,Belgaum,Karnataka',
'Turmuri,Belgaum,Karnataka',
'Udikeri,Belgaum,Karnataka',
'Ugarkhod,Belgaum,Karnataka',
'Vakkund,Belgaum,Karnataka',
'Vannur,Belgaum,Karnataka',
'Veerapur,Belgaum,Karnataka',
'Yardal,Belgaum,Karnataka',
'Agasage,Belgaum,Karnataka',
'Alarwad,Belgaum,Karnataka',
'Aluminium Factory,Belgaum,Karnataka',
'Ambewadi,Belgaum,Karnataka',
'Angol,Belgaum,Karnataka',
'Ankalgi,Belgaum,Karnataka',
'Aralikatti,Belgaum,Karnataka',
'Ashte,Belgaum,Karnataka',
'Badas Khalsa,Belgaum,Karnataka',
'Bailur,Belgaum,Karnataka',
'Balekundri Kshetra,Belgaum,Karnataka',
'Balekundri,Belgaum,Karnataka',
'Bastwad,Belgaum,Karnataka',
'Basvan Kudchi,Belgaum,Karnataka',
'Bekkinkeri,Belgaum,Karnataka',
'Belagundi,Belgaum,Karnataka',
'Belavatti,Belgaum,Karnataka',
'Belgaum Bus Stand,Belgaum,Karnataka',
'Belgaum Camp,Belgaum,Karnataka',
'Belgaum City,Belgaum,Karnataka',
'Belgaum College Road,Belgaum,Karnataka',
'Belgaum Doordarshan Nagar,Belgaum,Karnataka',
'Belgaum Fort Road,Belgaum,Karnataka',
'Belgaum Fort,Belgaum,Karnataka',
'Belgaum H.O,Belgaum,Karnataka',
'Belgaum Kadolkar Galli Corner,Belgaum,Karnataka',
'Belgaum Kapileshwar Road,Belgaum,Karnataka',
'Belgaum Khasbag,Belgaum,Karnataka',
'Belgaum Kutchery,Belgaum,Karnataka',
'Belgaum M. Vadgaon,Belgaum,Karnataka',
'Belgaum Mal Marutu Extension,Belgaum,Karnataka',
'Belgaum Nehru Nagar,Belgaum,Karnataka',
'Belgaum Records MLI,Belgaum,Karnataka',
'Belgaum Shahapur Bazar,Belgaum,Karnataka',
'Belgaum Shahapur,Belgaum,Karnataka',
'Belgaum Shivaji Nagar,Belgaum,Karnataka',
'Belgaum Vishweswaraih Nagar,Belgaum,Karnataka',
'Benakanhalli,Belgaum,Karnataka',
'Bhagyanagar,Belgaum,Karnataka',
'Bhendigeri,Belgaum,Karnataka',
'Bhutaramanahatti,Belgaum,Karnataka',
'Bijagarni,Belgaum,Karnataka',
'Bombarge,Belgaum,Karnataka',
'Desur,Belgaum,Karnataka',
'Dhamne,Belgaum,Karnataka',
'Giriyal,Belgaum,Karnataka',
'Goavesh,Belgaum,Karnataka',
'Goddikurvinkoppa,Belgaum,Karnataka',
'Gojage,Belgaum,Karnataka',
'Halga,Belgaum,Karnataka',
'Handignur,Belgaum,Karnataka',
'Hindalga,Belgaum,Karnataka',
'Hindawadi,Belgaum,Karnataka',
'Hirebagewadi,Belgaum,Karnataka',
'Honge,Belgaum,Karnataka',
'Hosavanmuri,Belgaum,Karnataka',
'June Belgaum,Belgaum,Karnataka',
'K.K.Koppa,Belgaum,Karnataka',
'Kadoli,Belgaum,Karnataka',
'Kailasnagar,Belgaum,Karnataka',
'Kakati,Belgaum,Karnataka',
'Kallehal,Belgaum,Karnataka',
'Kanabargi,Belgaum,Karnataka',
'Kanakumbi,Belgaum,Karnataka',
'Kangali KH,Belgaum,Karnataka',
'Kangrali BK,Belgaum,Karnataka',
'Karadiguddi,Belgaum,Karnataka',
'Karvinkumpi,Belgaum,Karnataka',
'Kednur,Belgaum,Karnataka',
'Khanagaon,Belgaum,Karnataka',
'Kinaye,Belgaum,Karnataka',
'Kudarimani,Belgaum,Karnataka',
'Kukdolli,Belgaum,Karnataka',
'Kurihal,Belgaum,Karnataka',
'Machhe,Belgaum,Karnataka',
'Majagaon,Belgaum,Karnataka',
'Mandoli,Belgaum,Karnataka',
'Marihal,Belgaum,Karnataka',
'Mastamardi,Belgaum,Karnataka',
'Mavinkatti,Belgaum,Karnataka',
'Modge,Belgaum,Karnataka',
'Muchandi,Belgaum,Karnataka',
'Mutage,Belgaum,Karnataka',
'Mutnal,Belgaum,Karnataka',
'Nandihalli,Belgaum,Karnataka',
'Navage,Belgaum,Karnataka',
'Parwad,Belgaum,Karnataka',
'Rakasakoppa,Belgaum,Karnataka',
'Ranichannamma Nagar,Belgaum,Karnataka',
'Sambra,Belgaum,Karnataka',
'Santibastwad,Belgaum,Karnataka',
'Sindholi,Belgaum,Karnataka',
'Sulage,Belgaum,Karnataka',
'Sulge ( Yellur),Belgaum,Karnataka',
'Tarihal,Belgaum,Karnataka',
'Tilakwadi,Belgaum,Karnataka',
'Tummarguddi,Belgaum,Karnataka',
'Turamari,Belgaum,Karnataka',
'Uchgaon,Belgaum,Karnataka',
'Udyambag,Belgaum,Karnataka',
'Vijayanagar,Belgaum,Karnataka',
'Adi,Chikodi,Karnataka',
'Akol,Chikodi,Karnataka',
'Ankali,Chikodi,Karnataka',
'Appachiwadi,Chikodi,Karnataka',
'Bambalwad,Chikodi,Karnataka',
'Barwad,Chikodi,Karnataka',
'Bedkihal,Chikodi,Karnataka',
'Belkud,Chikodi,Karnataka',
'Benadi,Chikodi,Karnataka',
'Bhivashi,Chikodi,Karnataka',
'Bhoj,Chikodi,Karnataka',
'Borgaon,Chikodi,Karnataka',
'Chandur,Chikodi,Karnataka',
'Chikalwal,Chikodi,Karnataka',
'Chikodi College Road,Chikodi,Karnataka',
'Chikodi Extension,Chikodi,Karnataka',
'Chikodi H.O,Chikodi,Karnataka',
'Chikodi Road,Chikodi,Karnataka',
'Chikodi Sugar Factory,Chikodi,Karnataka',
'Chinchani,Chikodi,Karnataka',
'Chiokdi Bazar,Chikodi,Karnataka',
'Dhonewadi,Chikodi,Karnataka',
'Dhulaganwadi,Chikodi,Karnataka',
'Galataga,Chikodi,Karnataka',
'Gondikuppi,Chikodi,Karnataka',
'Hadnal,Chikodi,Karnataka',
'Hanchinal K.S.,Chikodi,Karnataka',
'Hattarwat,Chikodi,Karnataka',
'Hirekudi,Chikodi,Karnataka',
'Hunnargi,Chikodi,Karnataka',
'Ingali,Chikodi,Karnataka',
'Jainapur,Chikodi,Karnataka',
'Janwad,Chikodi,Karnataka',
'Jatrat,Chikodi,Karnataka',
'Jodkurli,Chikodi,Karnataka',
'Kabbur,Chikodi,Karnataka',
'Kadapur,Chikodi,Karnataka',
'Kallol,Chikodi,Karnataka',
'Karadaga,Chikodi,Karnataka',
'Kargaon,Chikodi,Karnataka',
'Karoshi,Chikodi,Karnataka',
'Kerur,Chikodi,Karnataka',
'Khadaklat,Chikodi,Karnataka',
'Kodni,Chikodi,Karnataka',
'Kognoli,Chikodi,Karnataka',
'Kothali,Chikodi,Karnataka',
'Kunnur,Chikodi,Karnataka',
'Kurli,Chikodi,Karnataka',
'Kuthali,Chikodi,Karnataka',
'Lakhanapur,Chikodi,Karnataka',
'Malikwad,Chikodi,Karnataka',
'Mamadapur K L,Chikodi,Karnataka',
'Mangur,Chikodi,Karnataka',
'Manjari,Chikodi,Karnataka',
'Mankapur,Chikodi,Karnataka',
'Mattiwade,Chikodi,Karnataka',
'Mugali,Chikodi,Karnataka',
'Nagarmunoli,Chikodi,Karnataka',
'Nagnur,Chikodi,Karnataka',
'Nagral,Chikodi,Karnataka',
'Nainglaj,Chikodi,Karnataka',
'Nanadi,Chikodi,Karnataka',
'Navalihal,Chikodi,Karnataka',
'Nej,Chikodi,Karnataka',
'Nipani Bazar,Chikodi,Karnataka',
'Nipani Malbag,Chikodi,Karnataka',
'Nipani Nehru Chowk,Chikodi,Karnataka',
'Nipani,Chikodi,Karnataka',
'Padlihal,Chikodi,Karnataka',
'Pangire (A),Chikodi,Karnataka',
'Pangire (B),Chikodi,Karnataka',
'Pattankudi,Chikodi,Karnataka',
'Rampur,Chikodi,Karnataka',
'Sadalga,Chikodi,Karnataka',
'Sankanwadi,Chikodi,Karnataka',
'Saundalga,Chikodi,Karnataka',
'Shamanewadi,Chikodi,Karnataka',
'Shendur,Chikodi,Karnataka',
'Shiradwad,Chikodi,Karnataka',
'Shirgaon,Chikodi,Karnataka',
'Shirguppi,Chikodi,Karnataka',
'Siddapurwadi,Chikodi,Karnataka',
'Sidnal,Chikodi,Karnataka',
'Sulgaon,Chikodi,Karnataka',
'Tavandi,Chikodi,Karnataka',
'Umarani,Chikodi,Karnataka',
'Vadral,Chikodi,Karnataka',
'Vijaynagar,Chikodi,Karnataka',
'Walki,Chikodi,Karnataka',
'Yadur,Chikodi,Karnataka',
'Yaksamba,Chikodi,Karnataka',
'Yamagarni,Chikodi,Karnataka',
'Akkatangerhal,Gokak,Karnataka',
'Ankalgi,Gokak,Karnataka',
'Arabhavifarm,Gokak,Karnataka',
'Arabhavimath,Gokak,Karnataka',
'Avaradi,Gokak,Karnataka',
'Badigwad,Gokak,Karnataka',
'Beerangaddi,Gokak,Karnataka',
'Benchinmardi,Gokak,Karnataka',
'Betageri,Gokak,Karnataka',
'Bhairnatti,Gokak,Karnataka',
'Chiknandi,Gokak,Karnataka',
'Dharmatti,Gokak,Karnataka',
'Dhavaleshwar,Gokak,Karnataka',
'Dhupdal,Gokak,Karnataka',
'Duradundi,Gokak,Karnataka',
'Fulgaddi,Gokak,Karnataka',
'Ghataprabha RS,Gokak,Karnataka',
'Ghataprabha SF,Gokak,Karnataka',
'Gokak College Road,Gokak,Karnataka',
'Gokak Falls,Gokak,Karnataka',
'Gokak Fort,Gokak,Karnataka',
'Gokak Guruwarpeth,Gokak,Karnataka',
'Gokak H.O,Gokak,Karnataka',
'Gosbal,Gokak,Karnataka',
'Gubalgudda,Gokak,Karnataka',
'Gudus,Gokak,Karnataka',
'Gurlapur,Gokak,Karnataka',
'Hadiginal,Gokak,Karnataka',
'Hallur,Gokak,Karnataka',
'Honakuppi,Gokak,Karnataka',
'Hunshyal P.Y,Gokak,Karnataka',
'Hunshyal PG,Gokak,Karnataka',
'Kaitnal,Gokak,Karnataka',
'Kalliguddi,Gokak,Karnataka',
'Kalloli,Gokak,Karnataka',
'Kamaldinni,Gokak,Karnataka',
'Kaujalgi,Gokak,Karnataka',
'Kemmankol,Gokak,Karnataka',
'Keshappanatti,Gokak,Karnataka',
'Khanatti,Gokak,Karnataka',
'Khandratti,Gokak,Karnataka',
'Khangaon,Gokak,Karnataka',
'Kolvi,Gokak,Karnataka',
'Konnur,Gokak,Karnataka',
'Kotabagi,Gokak,Karnataka',
'Kulgod,Gokak,Karnataka',
'Kundargi,Gokak,Karnataka',
'Lolsur,Gokak,Karnataka',
'Madwal,Gokak,Karnataka',
'Makkalgeri,Gokak,Karnataka',
'Maldinni,Gokak,Karnataka',
'Mallapur KA,Gokak,Karnataka',
'Mamadapur,Gokak,Karnataka',
'Mannikeri,Gokak,Karnataka',
'Maradimath,Gokak,Karnataka',
'Market Yard,Gokak,Karnataka',
'Masaguppi,Gokak,Karnataka',
'Melmanhatti,Gokak,Karnataka',
'Melvanki,Gokak,Karnataka',
'Mudalgi,Gokak,Karnataka',
'Munyal,Gokak,Karnataka',
'Naganur,Gokak,Karnataka',
'Nallanhatti,Gokak,Karnataka',
'Nandgaon,Gokak,Karnataka',
'Pamaldinni,Gokak,Karnataka',
'Patagundi,Gokak,Karnataka',
'Rajapur,Gokak,Karnataka',
'Sangankeri,Gokak,Karnataka',
'Shiltibhavi,Gokak,Karnataka',
'Shindikurbet,Gokak,Karnataka',
'Shivapur H,Gokak,Karnataka',
'Shivapur K,Gokak,Karnataka',
'Suldhal,Gokak,Karnataka',
'Sunadholi,Gokak,Karnataka',
'Talakatnal,Gokak,Karnataka',
'Tavag,Gokak,Karnataka',
'Tigadi,Gokak,Karnataka',
'Tukkanatti,Gokak,Karnataka',
'Urabinatti,Gokak,Karnataka',
'Venkatapur,Gokak,Karnataka',
'Waderhatti,Gokak,Karnataka',
'Yadwad,Gokak,Karnataka',
'Yaragudri,Gokak,Karnataka',
'Zangatihal,Gokak,Karnataka',
'Akkiwat,Gokak,Karnataka',
'Ammanagi,Gokak,Karnataka',
'Amminbhavi,Gokak,Karnataka',
'Ankle,Gokak,Karnataka',
'Arjunwad,Gokak,Karnataka',
'Avargol,Gokak,Karnataka',
'Bad,Gokak,Karnataka',
'Badakundri,Gokak,Karnataka',
'Basapur,Gokak,Karnataka',
'Bastwad,Gokak,Karnataka',
'Bellad Bagewadi,Gokak,Karnataka',
'Belvi(Bellumbi),Gokak,Karnataka',
'Beniwad,Gokak,Karnataka',
'Berranholi,Gokak,Karnataka',
'Bhartesh Gurukul,Gokak,Karnataka',
'Borgal,Gokak,Karnataka',
'Bugatealur,Gokak,Karnataka',
'Daddi,Gokak,Karnataka',
'Ghodgeri,Gokak,Karnataka',
'Gutagaddi,Gokak,Karnataka',
'Hadalga,Gokak,Karnataka',
'Hanchinal,Gokak,Karnataka',
'Haragapur,Gokak,Karnataka',
'Hattialur,Gokak,Karnataka',
'Hebbal,Gokak,Karnataka',
'Hidkal Dam,Gokak,Karnataka',
'Hitni,Gokak,Karnataka',
'Hukeri Bazar,Gokak,Karnataka',
'Hukeri Kutchery Road,Gokak,Karnataka',
'Hukeri,Gokak,Karnataka',
'Hulloli,Gokak,Karnataka',
'Islampur,Gokak,Karnataka',
'Jaganur,Gokak,Karnataka',
'Kamatnur,Gokak,Karnataka',
'Kanagala,Gokak,Karnataka',
'Karaguppi,Gokak,Karnataka',
'Karnata Health Institute,Gokak,Karnataka',
'Kesti,Gokak,Karnataka',
'Kochari,Gokak,Karnataka',
'Koninkeri,Gokak,Karnataka',
'Kot,Gokak,Karnataka',
'Kurni,Gokak,Karnataka',
'Madihali,Gokak,Karnataka',
'Managutti,Gokak,Karnataka',
'Mattiwade,Gokak,Karnataka',
'Mavanur,Gokak,Karnataka',
'Naganur KM,Gokak,Karnataka',
'Narasinghpur,Gokak,Karnataka',
'Nerli,Gokak,Karnataka',
'Nidasoshi,Gokak,Karnataka',
'Nirwanhatti,Gokak,Karnataka',
'Pachhapur,Gokak,Karnataka',
'Rashing,Gokak,Karnataka',
'Salamwadi,Gokak,Karnataka',
'Sanekshwar,Gokak,Karnataka',
'Sanekshwar Sugar Factory,Gokak,Karnataka',
'Sankeshwar Bazar,Gokak,Karnataka',
'Sankeshwar College Road,Gokak,Karnataka',
'Sankeshwar Market Yard,Gokak,Karnataka',
'Sankeshwar Subhas Circle,Gokak,Karnataka',
'Sarapur,Gokak,Karnataka',
'Shippur,Gokak,Karnataka',
'Shirgaon,Gokak,Karnataka',
'Shirhatti,Gokak,Karnataka',
'Solapur,Gokak,Karnataka',
'Sultanpur,Gokak,Karnataka',
'Sutagatti,Gokak,Karnataka',
'Thana Hattargi,Gokak,Karnataka',
'Ullagaddi Khanapur,Gokak,Karnataka',
'Yadgud,Gokak,Karnataka',
'Yamakanmardi,Gokak,Karnataka',
'Yarnal,Gokak,Karnataka',
'Yelimanoli,Gokak,Karnataka',
'Arjunnagar,Chikodi,Karnataka',
'Amte,Belgaum,Karnataka',
'Avarolli,Belgaum,Karnataka',
'Baragaon,Belgaum,Karnataka',
'Bidi,Belgaum,Karnataka',
'Buranaki,Belgaum,Karnataka',
'Chikahattiholi,Belgaum,Karnataka',
'Chikmanoli,Belgaum,Karnataka',
'Devalatti,Belgaum,Karnataka',
'Devarai,Belgaum,Karnataka',
'Gandigwad,Belgaum,Karnataka',
'Garalgunji,Belgaum,Karnataka',
'Godholi,Belgaum,Karnataka',
'Gunji,Belgaum,Karnataka',
'Halasal,Belgaum,Karnataka',
'Halashi,Belgaum,Karnataka',
'Hebbal,Belgaum,Karnataka',
'Hirehattiholi,Belgaum,Karnataka',
'Hiremanoli,Belgaum,Karnataka',
'Idalahonda,Belgaum,Karnataka',
'Itagi,Belgaum,Karnataka',
'Jamboti,Belgaum,Karnataka',
'Kakkeri,Belgaum,Karnataka',
'Kapoli,Belgaum,Karnataka',
'Karalga,Belgaum,Karnataka',
'Karambal,Belgaum,Karnataka',
'Kasaba Nandgad,Belgaum,Karnataka',
'Khanapur,Belgaum,Karnataka',
'Kodachwad,Belgaum,Karnataka',
'Linganmath,Belgaum,Karnataka',
'Lokali,Belgaum,Karnataka',
'Londa,Belgaum,Karnataka',
'Mangyankop,Belgaum,Karnataka',
'Manturge,Belgaum,Karnataka',
'Mugalihal,Belgaum,Karnataka',
'Nagaragali,Belgaum,Karnataka',
'Nandgad,Belgaum,Karnataka',
'Nerse,Belgaum,Karnataka',
'Nilwade,Belgaum,Karnataka',
'Nittur,Belgaum,Karnataka',
'Olmani,Belgaum,Karnataka',
'Pariswad,Belgaum,Karnataka',
'Peeranwadi,Belgaum,Karnataka',
'Ramgurwadi,Belgaum,Karnataka',
'Shiroli,Belgaum,Karnataka',
'Tolgi,Belgaum,Karnataka',
'Topinkatti,Belgaum,Karnataka',
'Khanapur Town,Belgaum,Karnataka',
'Bekwad,Belgaum,Karnataka',
'Chapagaon,Belgaum,Karnataka',
'Halga,Belgaum,Karnataka',
'Tavaragatti,Belgaum,Karnataka',
'Alagwadi,Chikodi,Karnataka',
'Alaknur,Chikodi,Karnataka',
'Bastwad,Chikodi,Karnataka',
'Bekkeri,Chikodi,Karnataka',
'Bhendwad,Chikodi,Karnataka',
'Bhiradi,Chikodi,Karnataka',
'Budhihal,Chikodi,Karnataka',
'Byakud,Chikodi,Karnataka',
'Chinchali,Chikodi,Karnataka',
'Gundwad,Chikodi,Karnataka',
'Handigund,Chikodi,Karnataka',
'Harugeri,Chikodi,Karnataka',
'Hidkal,Chikodi,Karnataka',
'Itnal,Chikodi,Karnataka',
'Jalalpur,Chikodi,Karnataka',
'Kankanwadi,Chikodi,Karnataka',
'Kappalguddi,Chikodi,Karnataka',
'Katakbhavi,Chikodi,Karnataka',
'Khanadal,Chikodi,Karnataka',
'Khavtkoppa,Chikodi,Karnataka',
'Khemalapur,Chikodi,Karnataka',
'Koligudda,Chikodi,Karnataka',
'Kudchi,Chikodi,Karnataka',
'Kudchi Town,Chikodi,Karnataka',
'Mantur,Chikodi,Karnataka',
'Mavinhunda,Chikodi,Karnataka',
'Mekhali,Chikodi,Karnataka',
'Morabbo,Chikodi,Karnataka',
'Mugalkhod,Chikodi,Karnataka',
'Nandikurli,Chikodi,Karnataka',
'Nasalapur,Chikodi,Karnataka',
'New Diggewadi,Chikodi,Karnataka',
'Nidagundi,Chikodi,Karnataka',
'Nilaji,Chikodi,Karnataka',
'Nipnal,Chikodi,Karnataka',
'Palbhavi,Chikodi,Karnataka',
'Parmanandwadi,Chikodi,Karnataka',
'Raibag R.S.Bo,Chikodi,Karnataka',
'Raibag,Chikodi,Karnataka',
'Raibag Vidyalaya,Chikodi,Karnataka',
'Sankratti,Chikodi,Karnataka',
'Saptasagar,Chikodi,Karnataka',
'Saundatti,Chikodi,Karnataka',
'Saunsuddi,Chikodi,Karnataka',
'Shegunshi,Chikodi,Karnataka',
'Shirgur,Chikodi,Karnataka',
'Sultanpur,Chikodi,Karnataka',
'Suttatti,Chikodi,Karnataka',
'Yabratti,Chikodi,Karnataka',
'Yadrav,Chikodi,Karnataka',
'Yelparhatti,Chikodi,Karnataka',
'Avaradi,Belgaum,Karnataka',
'Bannur,Belgaum,Karnataka',
'Bijaguppi,Belgaum,Karnataka',
'Chandargi,Belgaum,Karnataka',
'Channapur,Belgaum,Karnataka',
'Chilmur,Belgaum,Karnataka',
'Chipalkatti,Belgaum,Karnataka',
'Chunchnur,Belgaum,Karnataka',
'Godachi,Belgaum,Karnataka',
'Gonnagar,Belgaum,Karnataka',
'Halagatti,Belgaum,Karnataka',
'Hirekop,Belgaum,Karnataka',
'Hoskoti,Belgaum,Karnataka',
'Hulkund,Belgaum,Karnataka',
'Kalhal,Belgaum,Karnataka',
'Kalmad,Belgaum,Karnataka',
'Katkol,Belgaum,Karnataka',
'Kittur (SDT),Belgaum,Karnataka',
'Kullur,Belgaum,Karnataka',
'Kunnal,Belgaum,Karnataka',
'M Timmapur,Belgaum,Karnataka',
'Mudenur,Belgaum,Karnataka',
'Mudkavi,Belgaum,Karnataka',
'Mullur,Belgaum,Karnataka',
'Nandihal,Belgaum,Karnataka',
'Narasapur,Belgaum,Karnataka',
'Nekarpeth Ramdurg,Belgaum,Karnataka',
'Oblapur,Belgaum,Karnataka',
'Ramdurg H.O,Belgaum,Karnataka',
'Ramdurg Town,Belgaum,Karnataka',
'Salahalli,Belgaum,Karnataka',
'Salapur,Belgaum,Karnataka',
'Sangal,Belgaum,Karnataka',
'Sidnal,Belgaum,Karnataka',
'Sunnal,Belgaum,Karnataka',
'Sureban,Belgaum,Karnataka',
'Tondikatti,Belgaum,Karnataka',
'Torangatti,Belgaum,Karnataka',
'Torgal,Belgaum,Karnataka',
'Udpudi,Belgaum,Karnataka',
'Umtar,Belgaum,Karnataka',
'Achmatti,Belgaum,Karnataka',
'Akkisagar,Belgaum,Karnataka',
'Apmc Saundatti,Belgaum,Karnataka',
'Aratgal,Belgaum,Karnataka',
'Asundi,Belgaum,Karnataka',
'Badli,Belgaum,Karnataka',
'Benkatti,Belgaum,Karnataka',
'Betsur,Belgaum,Karnataka',
'Bhandarhalli,Belgaum,Karnataka',
'Chachadi,Belgaum,Karnataka',
'Chidambar Nagar Saundatti,Belgaum,Karnataka',
'Chikkop,Belgaum,Karnataka',
'Chikkumbi,Belgaum,Karnataka',
'Chulaki,Belgaum,Karnataka',
'Dhaderkoppa,Belgaum,Karnataka',
'Goravankolla,Belgaum,Karnataka',
'Gorbal,Belgaum,Karnataka',
'Halaki,Belgaum,Karnataka',
'Hanamgeri,Belgaum,Karnataka',
'Hanchinal,Belgaum,Karnataka',
'Hirebudnur,Belgaum,Karnataka',
'Hirekumbi,Belgaum,Karnataka',
'Hireulligeri,Belgaum,Karnataka',
'Hooli,Belgaum,Karnataka',
'Hoolikatti,Belgaum,Karnataka',
'Horalkatti,Belgaum,Karnataka',
'Hosur,Belgaum,Karnataka',
'Inamhongal,Belgaum,Karnataka',
'Ingalgi,Belgaum,Karnataka',
'Jakabal,Belgaum,Karnataka',
'Kadabi,Belgaum,Karnataka',
'Kagdhal,Belgaum,Karnataka',
'Karalkatti,Belgaum,Karnataka',
'Karikatti,Belgaum,Karnataka',
'Kodliwad,Belgaum,Karnataka',
'Madamgeri,Belgaum,Karnataka',
'Madlur,Belgaum,Karnataka',
'Mallur,Belgaum,Karnataka',
'Manoli,Belgaum,Karnataka',
'Markumbi,Belgaum,Karnataka',
'Mugalihal,Belgaum,Karnataka',
'Murgod,Belgaum,Karnataka',
'Mutwad,Belgaum,Karnataka',
'Naviluteertha,Belgaum,Karnataka',
'Nugganatti,Belgaum,Karnataka',
'Rainapur,Belgaum,Karnataka',
'Rudrapur,Belgaum,Karnataka',
'Sangreshkop,Belgaum,Karnataka',
'Sattigeri,Belgaum,Karnataka',
'Saundatti,Belgaum,Karnataka',
'Saundatti Spinning Mill,Belgaum,Karnataka',
'Shindogi,Belgaum,Karnataka',
'Shivapur,Belgaum,Karnataka',
'Sirsangi,Belgaum,Karnataka',
'Soppadla,Belgaum,Karnataka',
'Sutagatti (SDT),Belgaum,Karnataka',
'Tadsalur,Belgaum,Karnataka',
'Tallur,Belgaum,Karnataka',
'Tegghal,Belgaum,Karnataka',
'Ugargol,Belgaum,Karnataka',
'Yakkundi,Belgaum,Karnataka',
'Yallamma Hill,Belgaum,Karnataka',
'Yargatti,Belgaum,Karnataka',
'Yarzarvi,Belgaum,Karnataka',
'Allipur,Bellary,Karnataka',
'Anthapura,Bellary,Karnataka',
'Asundi,Bellary,Karnataka',
'B Belagal,Bellary,Karnataka',
'Badanahatti,Bellary,Karnataka',
'Bandihatti,Bellary,Karnataka',
'Basarakodu,Bellary,Karnataka',
'Belachinta,Bellary,Karnataka',
'Bellary Brucepettah,Bellary,Karnataka',
'Bellary Cantonment,Bellary,Karnataka',
'Bellary City,Bellary,Karnataka',
'Bellary Cowl Bazar,Bellary,Karnataka',
'Bellary District Court,Bellary,Karnataka',
'Bellary G T Street,Bellary,Karnataka',
'Bellary Gandhinagar,Bellary,Karnataka',
'Bellary H.O,Bellary,Karnataka',
'Bellary Herialkudam,Bellary,Karnataka',
'Bellary J C Market,Bellary,Karnataka',
'Bellary Millerpet,Bellary,Karnataka',
'Bellary Nehru Colony,Bellary,Karnataka',
'Bellary Parvathi Nagar,Bellary,Karnataka',
'Bellary Patel Nagar,Bellary,Karnataka',
'Bellary Satyanarayanapet,Bellary,Karnataka',
'Bellary Termal Power Station,Bellary,Karnataka',
'Bellary Zilla Parishad,Bellary,Karnataka',
'Bennikallu,Bellary,Karnataka',
'Bhairadevanahalli,Bellary,Karnataka',
'Bisilahalli,Bellary,Karnataka',
'Chaganur,Bellary,Karnataka',
'Chanahal,Bellary,Karnataka',
'Channapatna,Bellary,Karnataka',
'Chellakurki,Bellary,Karnataka',
'Chickantapura,Bellary,Karnataka',
'D Kaggal,Bellary,Karnataka',
'Dammur,Bellary,Karnataka',
'Dasaranagenahalli,Bellary,Karnataka',
'Emmiganoor,Bellary,Karnataka',
'Erragudi,Bellary,Karnataka',
'Genikihal,Bellary,Karnataka',
'Gotur,Bellary,Karnataka',
'Gududdur,Bellary,Karnataka',
'H Veerapura,Bellary,Karnataka',
'Hadligi,Bellary,Karnataka',
'Hagari Rs,Bellary,Karnataka',
'Halakundi,Bellary,Karnataka',
'Handihal Gududdur,Bellary,Karnataka',
'Hariginadoni,Bellary,Karnataka',
'Ibrahimpura,Bellary,Karnataka',
'Ittigi Muddapura,Bellary,Karnataka',
'Jalibenchi,Bellary,Karnataka',
'Jalihalu,Bellary,Karnataka',
'Janekunta,Bellary,Karnataka',
'Joladarasi,Bellary,Karnataka',
'K Veerapura,Bellary,Karnataka',
'Kakarlathota,Bellary,Karnataka',
'Kakkabevinahalli,Bellary,Karnataka',
'Kallukamba,Bellary,Karnataka',
'Kammarchedu,Bellary,Karnataka',
'Karekallu,Bellary,Karnataka',
'Karichedu,Bellary,Karnataka',
'Kolagallu,Bellary,Karnataka',
'Kolur,Bellary,Karnataka',
'Korlagundi,Bellary,Karnataka',
'Kottal,Bellary,Karnataka',
'Kudathini,Bellary,Karnataka',
'Kurugodu,Bellary,Karnataka',
'Laxmipura,Bellary,Karnataka',
'M S Kota,Bellary,Karnataka',
'M.Gonhal,Bellary,Karnataka',
'Metriki,Bellary,Karnataka',
'Moka,Bellary,Karnataka',
'Mustagatta,Bellary,Karnataka',
'Nelludi,Bellary,Karnataka',
'Orvai,Bellary,Karnataka',
'P D Halli,Bellary,Karnataka',
'Park Road,Bellary,Karnataka',
'Rajapura,Bellary,Karnataka',
'Rupanagudi,Bellary,Karnataka',
'Sanganakal,Bellary,Karnataka',
'Sanjay Gandhi Nagar,Bellary,Karnataka',
'Shankarabanda,Bellary,Karnataka',
'Shastri Nagar,Bellary,Karnataka',
'Siddammanahalli,Bellary,Karnataka',
'Sidiginamola,Bellary,Karnataka',
'Sindhavalam,Bellary,Karnataka',
'Siriwara Kappagal,Bellary,Karnataka',
'Somalapura,Bellary,Karnataka',
'Somasamudra,Bellary,Karnataka',
'Sreedharagadda,Bellary,Karnataka',
'Talur,Bellary,Karnataka',
'Vaddatti,Bellary,Karnataka',
'Veniveerapura,Bellary,Karnataka',
'Vittlapura,Bellary,Karnataka',
'Y.Kaggallu,Bellary,Karnataka',
'Yalpi,Bellary,Karnataka',
'Yellubenchi,Bellary,Karnataka',
'Yerriangaligi,Bellary,Karnataka',
'Yettinabudihal,Bellary,Karnataka',
'H B Halli Town,Bellary,Karnataka',
'Hampa Patna,Bellary,Karnataka',
'Bannigola,Bellary,Karnataka',
'Hagaribommanahalli,Bellary,Karnataka',
'Nelkudri,Bellary,Karnataka',
'Sonna,Bellary,Karnataka',
'Thambrahalli,Bellary,Karnataka',
'Anekal,Bellary,Karnataka',
'Ankasamudra,Bellary,Karnataka',
'Bachigondanahalli,Bellary,Karnataka',
'Bannikal,Bellary,Karnataka',
'Basarakodu,Bellary,Karnataka',
'Bennikallu,Bellary,Karnataka',
'Byasidgeri,Bellary,Karnataka',
'Chilugodu,Bellary,Karnataka',
'Chintrapalli,Bellary,Karnataka',
'Dashamapura,Bellary,Karnataka',
'Enigi,Bellary,Karnataka',
'Enigi Basapura,Bellary,Karnataka',
'G Kodihalli,Bellary,Karnataka',
'Gaddikere,Bellary,Karnataka',
'Hampasagara,Bellary,Karnataka',
'Kadalabalu,Bellary,Karnataka',
'Kittanur,Bellary,Karnataka',
'Malvi,Bellary,Karnataka',
'Marabbihal,Bellary,Karnataka',
'Muthukur,Bellary,Karnataka',
'Nanyapura,Bellary,Karnataka',
'Pinjarheggadahal,Bellary,Karnataka',
'Telugoli,Bellary,Karnataka',
'Ulavatti,Bellary,Karnataka',
'Upparagatta,Bellary,Karnataka',
'Varalahalli,Bellary,Karnataka',
'Amaravathi,Bellary,Karnataka',
'Ananthashayanagudi,Bellary,Karnataka',
'Belagoduhal,Bellary,Karnataka',
'Bukkasagara,Bellary,Karnataka',
'Byluvaddigere,Bellary,Karnataka',
'Chikkajayiganur,Bellary,Karnataka',
'Chitwadagai,Bellary,Karnataka',
'Dananayakanakere,Bellary,Karnataka',
'Danapura,Bellary,Karnataka',
'Devalapura,Bellary,Karnataka',
'Devasamudra,Bellary,Karnataka',
'Dharmasagara,Bellary,Karnataka',
'G Nagalapura,Bellary,Karnataka',
'Gadiganur,Bellary,Karnataka',
'Gunda,Bellary,Karnataka',
'Halagapura,Bellary,Karnataka',
'Hampadevanahalli,Bellary,Karnataka',
'Hampi Power House,Bellary,Karnataka',
'Hampi,Bellary,Karnataka',
'Hospet Co-operative Colony,Bellary,Karnataka',
'Hospet H.O,Bellary,Karnataka',
'Hospet J P Nagar,Bellary,Karnataka',
'Hospet N C C,Bellary,Karnataka',
'Hospet Patel Nagar,Bellary,Karnataka',
'Hospet Ranipet,Bellary,Karnataka',
'K S Factory,Bellary,Karnataka',
'K U Campus,Bellary,Karnataka',
'Kaddi Rampura,Bellary,Karnataka',
'Kakubal,Bellary,Karnataka',
'Kamalapura,Bellary,Karnataka',
'Kampli Bazar,Bellary,Karnataka',
'Kampli Fort,Bellary,Karnataka',
'Kampli,Bellary,Karnataka',
'Kanvi Thimalapura,Bellary,Karnataka',
'Kariganur,Bellary,Karnataka',
'Kondanayakanahalli,Bellary,Karnataka',
'Malapanagudi,Bellary,Karnataka',
'Mariyammana Halli,Bellary,Karnataka',
'Metri,Bellary,Karnataka',
'Muddapura,Bellary,Karnataka',
'Nagenahalli,Bellary,Karnataka',
'Nandibanda,Bellary,Karnataka',
'Papinayakanahalli,Bellary,Karnataka',
'Ramsagara,Bellary,Karnataka',
'Sanapura,Bellary,Karnataka',
'Srirama Rangapura,Bellary,Karnataka',
'Suggenahalli,Bellary,Karnataka',
'T B Dam,Bellary,Karnataka',
'Thimmalapur,Bellary,Karnataka',
'Venkatapura,Bellary,Karnataka',
'Vyasanakere,Bellary,Karnataka',
'Chilakanahatti,Bellary,Karnataka',
'Ittigi,Bellary,Karnataka',
'Alabur,Bellary,Karnataka',
'Beerabbi,Bellary,Karnataka',
'Budanur,Bellary,Karnataka',
'Dasanahalli,Bellary,Karnataka',
'Dasarahalli,Bellary,Karnataka',
'Devagondanahalli,Bellary,Karnataka',
'Hagarnur,Bellary,Karnataka',
'Hakkandi,Bellary,Karnataka',
'Harvi,Bellary,Karnataka',
'Hirebannimatti,Bellary,Karnataka',
'Hirehadagali,Bellary,Karnataka',
'Hirekolachi,Bellary,Karnataka',
'Hiremallanakere,Bellary,Karnataka',
'Holagundi,Bellary,Karnataka',
'Holalu,Bellary,Karnataka',
'Huvinahadagali Bazar,Bellary,Karnataka',
'Huvinahadagali,Bellary,Karnataka',
'Hyarada,Bellary,Karnataka',
'Kalvi,Bellary,Karnataka',
'Karadi Ayyanahalli,Bellary,Karnataka',
'Kattebennur,Bellary,Karnataka',
'Kogali,Bellary,Karnataka',
'Kuruvathi,Bellary,Karnataka',
'M M Wada,Bellary,Karnataka',
'Magala,Bellary,Karnataka',
'Mahajanadahalli,Bellary,Karnataka',
'Makarabbi,Bellary,Karnataka',
'Morigere,Bellary,Karnataka',
'Mudenoor,Bellary,Karnataka',
'Musuvinalli Kalahalli,Bellary,Karnataka',
'Mylar,Bellary,Karnataka',
'Nagatibasapura,Bellary,Karnataka',
'Nandi Halli,Bellary,Karnataka',
'Navali,Bellary,Karnataka',
'Sogi,Bellary,Karnataka',
'Sovenahalli,Bellary,Karnataka',
'Tamalapura,Bellary,Karnataka',
'Thippapur,Bellary,Karnataka',
'Uppanayakanahalli,Bellary,Karnataka',
'Uttangi,Bellary,Karnataka',
'Varakanalli,Bellary,Karnataka',
'Kombli,Bellary,Karnataka',
'Jarimale,Bellary,Karnataka',
'Alur Kudligi,Bellary,Karnataka',
'Amalapura,Bellary,Karnataka',
'Amaradevaragudda,Bellary,Karnataka',
'Ambli,Bellary,Karnataka',
'Appenahalli,Bellary,Karnataka',
'Badeladuku,Bellary,Karnataka',
'Banvikal,Bellary,Karnataka',
'Bellighatta,Bellary,Karnataka',
'Bylu Tumbaraguddi,Bellary,Karnataka',
'Chandrashekharapura,Bellary,Karnataka',
'Chapparada Halli,Bellary,Karnataka',
'Chikkajogihalli,Bellary,Karnataka',
'Chiratagundu,Bellary,Karnataka',
'Chowdapura,Bellary,Karnataka',
'Doopadahalli,Bellary,Karnataka',
'G.B. Halli,Bellary,Karnataka',
'Gangammanahalli,Bellary,Karnataka',
'Geddalagatta,Bellary,Karnataka',
'Gudekota,Bellary,Karnataka',
'Gundumunugu,Bellary,Karnataka',
'Hagari Gajapura,Bellary,Karnataka',
'Hansi,Bellary,Karnataka',
'Harakabhavi,Bellary,Karnataka',
'Harakanahalu,Bellary,Karnataka',
'Haralu,Bellary,Karnataka',
'Hireheggadahal,Bellary,Karnataka',
'Hirekumbalagunta,Bellary,Karnataka',
'Hosahalli,Bellary,Karnataka',
'Hudem,Bellary,Karnataka',
'Hulikere,Bellary,Karnataka',
'Hulikunta,Bellary,Karnataka',
'Huralihal,Bellary,Karnataka',
'Hyalya,Bellary,Karnataka',
'Imadapura,Bellary,Karnataka',
'Jolada Kudligi,Bellary,Karnataka',
'Jummobanahalli,Bellary,Karnataka',
'K Ayyanahalli,Bellary,Karnataka',
'K Gajapura,Bellary,Karnataka',
'K.Rayapura,Bellary,Karnataka',
'Kadekola,Bellary,Karnataka',
'Kakkuppi,Bellary,Karnataka',
'Kalapura,Bellary,Karnataka',
'Kanamadugu,Bellary,Karnataka',
'Katriki Halli,Bellary,Karnataka',
'Kenchammanahalli,Bellary,Karnataka',
'Kottur Bazar,Bellary,Karnataka',
'Kottur,Bellary,Karnataka',
'Kottur Temple Street,Bellary,Karnataka',
'Kudligi Bapuji Nagar,Bellary,Karnataka',
'Kudligi,Bellary,Karnataka',
'Kumati,Bellary,Karnataka',
'Kuppinakeri,Bellary,Karnataka',
'Lokikere,Bellary,Karnataka',
'M B Ayyanahalli,Bellary,Karnataka',
'Mahadevapura,Bellary,Karnataka',
'Makanadaku,Bellary,Karnataka',
'Mangapura,Bellary,Karnataka',
'Meenakere,Bellary,Karnataka',
'Moraba,Bellary,Karnataka',
'Nagarakatte,Bellary,Karnataka',
'Nimbalageri,Bellary,Karnataka',
'Oojein,Bellary,Karnataka',
'Poojarahalli,Bellary,Karnataka',
'Ramdurga,Bellary,Karnataka',
'Rampur,Bellary,Karnataka',
'Shivapura,Bellary,Karnataka',
'Siddapura,Bellary,Karnataka',
'Sidegalli,Bellary,Karnataka',
'Sooladahalli,Bellary,Karnataka',
'Srikanthapura,Bellary,Karnataka',
'Thayakanalli,Bellary,Karnataka',
'Thimalapur,Bellary,Karnataka',
'Thimmanahalli,Bellary,Karnataka',
'Toolahalli,Bellary,Karnataka',
'Uramma Temple,Bellary,Karnataka',
'Agrahara,Bellary,Karnataka',
'Bandri,Bellary,Karnataka',
'Bhujanganagar,Bellary,Karnataka',
'Bommagatta,Bellary,Karnataka',
'Choranur,Bellary,Karnataka',
'D Mallapura,Bellary,Karnataka',
'D T Ship,Bellary,Karnataka',
'Deogiri,Bellary,Karnataka',
'Doulatpur,Bellary,Karnataka',
'Gollalingammanahalli,Bellary,Karnataka',
'Hk Halli,Bellary,Karnataka',
'Jiginahalli,Bellary,Karnataka',
'Kalingere,Bellary,Karnataka',
'Krishna Nagar,Bellary,Karnataka',
'Kurekuppa,Bellary,Karnataka',
'Lakshmipura Sandur,Bellary,Karnataka',
'M Tumbaraguddi,Bellary,Karnataka',
'Motalakunta,Bellary,Karnataka',
'Nagalapura,Bellary,Karnataka',
'Nandihalli,Bellary,Karnataka',
'New Daroji,Bellary,Karnataka',
'Nidugurthi,Bellary,Karnataka',
'Old Daroji,Bellary,Karnataka',
'Sandur Bazar,Bellary,Karnataka',
'Sandur,Bellary,Karnataka',
'Shaliyappanahalli,Bellary,Karnataka',
'Sovenahalli,Bellary,Karnataka',
'Subbarayanahalli,Bellary,Karnataka',
'Sushilanagar,Bellary,Karnataka',
'Swamyhalli,Bellary,Karnataka',
'Talur,Bellary,Karnataka',
'Taranagar,Bellary,Karnataka',
'Toranagallu,Bellary,Karnataka',
'Tyagadahal,Bellary,Karnataka',
'Vaddu,Bellary,Karnataka',
'Vidyanagar,Bellary,Karnataka',
'Yaradammanahalli,Bellary,Karnataka',
'Yeshwantnagar,Bellary,Karnataka',
'Agasanur,Bellary,Karnataka',
'Agricultural Research Centre,Bellary,Karnataka',
'Araliganoor,Bellary,Karnataka',
'Bagewadi,Bellary,Karnataka',
'Balakundi,Bellary,Karnataka',
'Bandrahalu,Bellary,Karnataka',
'Basarahalli,Bellary,Karnataka',
'Beeravalli,Bellary,Karnataka',
'Bevinamarada Sugur,Bellary,Karnataka',
'Bhairapura,Bellary,Karnataka',
'Booduguppa,Bellary,Karnataka',
'Byloor,Bellary,Karnataka',
'Chanakanur,Bellary,Karnataka',
'Chickbellary,Bellary,Karnataka',
'Darur,Bellary,Karnataka',
'Devinagara,Bellary,Karnataka',
'H Hosahalli,Bellary,Karnataka',
'Halekota,Bellary,Karnataka',
'Hatcholi,Bellary,Karnataka',
'Havinal,Bellary,Karnataka',
'Herkal,Bellary,Karnataka',
'Hudegolam,Bellary,Karnataka',
'Ittigehal,Bellary,Karnataka',
'K.Belagal,Bellary,Karnataka',
'K.Sugur,Bellary,Karnataka',
'Karur,Bellary,Karnataka',
'Kenchanagudda,Bellary,Karnataka',
'Konchigere,Bellary,Karnataka',
'Kottalachinta,Bellary,Karnataka',
'Kududarahalu,Bellary,Karnataka',
'Kuruvalli,Bellary,Karnataka',
'Mannur Sugur,Bellary,Karnataka',
'Muddatanur,Bellary,Karnataka',
'Nadanga,Bellary,Karnataka',
'Nadavi,Bellary,Karnataka',
'Nagalapura,Bellary,Karnataka',
'Nagarahalu,Bellary,Karnataka',
'Nittur,Bellary,Karnataka',
'Raravi,Bellary,Karnataka',
'Ravihal,Bellary,Karnataka',
'Shanavasapura,Bellary,Karnataka',
'Sindigere,Bellary,Karnataka',
'Sirigere,Bellary,Karnataka',
'Siriguppa,Bellary,Karnataka',
'Siruguppa Bazar,Bellary,Karnataka',
'Siruguppa Sadashivanagar,Bellary,Karnataka',
'Tasalakudlur,Bellary,Karnataka',
'Tekkalakota,Bellary,Karnataka',
'Uppara Hosahalli,Bellary,Karnataka',
'Uttanur,Bellary,Karnataka',
'Vattamuruvani,Bellary,Karnataka',
'Mohmadapur,Bidar,Karnataka',
'Horandi,Bidar,Karnataka',
'Aurad (B),Bidar,Karnataka',
'Badalgaon,Bidar,Karnataka',
'Balat (K),Bidar,Karnataka',
'Bawalgaon,Bidar,Karnataka',
'Bedkunda,Bidar,Karnataka',
'Belkoni (M),Bidar,Karnataka',
'Belkoni,Bidar,Karnataka',
'Bhandarkumta,Bidar,Karnataka',
'Chandeshwar,Bidar,Karnataka',
'Chandori,Bidar,Karnataka',
'Chikli (J),Bidar,Karnataka',
'Chikli (U),Bidar,Karnataka',
'Chimegaon,Bidar,Karnataka',
'Chordapka,Bidar,Karnataka',
'Dhupat Mahagaon,Bidar,Karnataka',
'Diggi,Bidar,Karnataka',
'Dongam (M),Bidar,Karnataka',
'Ekamba,Bidar,Karnataka',
'Halhalli,Bidar,Karnataka',
'Hangarga(B),Bidar,Karnataka',
'Hedgapur,Bidar,Karnataka',
'Hokarana,Bidar,Karnataka',
'Holsamunder,Bidar,Karnataka',
'Hulsoor Khed,Bidar,Karnataka',
'Jamgi,Bidar,Karnataka',
'Jojana,Bidar,Karnataka',
'Kalgapur,Bidar,Karnataka',
'Kamalnagar,Bidar,Karnataka',
'Karkyal,Bidar,Karnataka',
'Kawadgaon,Bidar,Karnataka',
'Khatgaon,Bidar,Karnataka',
'Kherda (A),Bidar,Karnataka',
'Kollur (A),Bidar,Karnataka',
'Korekal,Bidar,Karnataka',
'Kotgyal,Bidar,Karnataka',
'Koutha (B),Bidar,Karnataka',
'Kushnoor Gadi,Bidar,Karnataka',
'Ladha (A),Bidar,Karnataka',
'Madnoor,Bidar,Karnataka',
'Maskal,Bidar,Karnataka',
'Medpalli,Bidar,Karnataka',
'Mudhol (B),Bidar,Karnataka',
'Mugnal,Bidar,Karnataka',
'Murki,Bidar,Karnataka',
'Nagmarpalli,Bidar,Karnataka',
'Nandi Bijalgaon,Bidar,Karnataka',
'Raipalli,Bidar,Karnataka',
'Sangam,Bidar,Karnataka',
'Santhpur,Bidar,Karnataka',
'Sawali,Bidar,Karnataka',
'Sawargaon,Bidar,Karnataka',
'Shembelli,Bidar,Karnataka',
'Sonala,Bidar,Karnataka',
'Sundal,Bidar,Karnataka',
'Surhalli,Bidar,Karnataka',
'Thanna Kushnoor,Bidar,Karnataka',
'Torna,Bidar,Karnataka',
'Ujani,Bidar,Karnataka',
'Wadgaon (D),Bidar,Karnataka',
'Yengunda,Bidar,Karnataka',
'Bonthi,Bidar,Karnataka',
'Chintaki,Bidar,Karnataka',
'Eklera,Bidar,Karnataka',
'Hippalgaon(A),Bidar,Karnataka',
'Nidoda,Bidar,Karnataka',
'Algood,Bidar,Karnataka',
'Basavakalyan Bazar,Bidar,Karnataka',
'Basavakalyan Eng College,Bidar,Karnataka',
'Basavakalyan,Bidar,Karnataka',
'Belura,Bidar,Karnataka',
'Bet Balkunda,Bidar,Karnataka',
'Betgera,Bidar,Karnataka',
'Bhosga,Bidar,Karnataka',
'Chandakapur,Bidar,Karnataka',
'Chiknagaon,Bidar,Karnataka',
'Chitta (K),Bidar,Karnataka',
'Dhannura(K),Bidar,Karnataka',
'Ekamba,Bidar,Karnataka',
'Gadlegaon,Bidar,Karnataka',
'Ghotala,Bidar,Karnataka',
'Gorta (B),Bidar,Karnataka',
'Goundgaon,Bidar,Karnataka',
'Gour,Bidar,Karnataka',
'Gundoor,Bidar,Karnataka',
'Halli,Bidar,Karnataka',
'Harkud,Bidar,Karnataka',
'Hattarga,Bidar,Karnataka',
'Hipparga Bagh,Bidar,Karnataka',
'Hipparga Ghat,Bidar,Karnataka',
'Hirenagaon,Bidar,Karnataka',
'Honalli,Bidar,Karnataka',
'Hulsoor,Bidar,Karnataka',
'Islampur,Bidar,Karnataka',
'Jajanmugali,Bidar,Karnataka',
'Kadepur,Bidar,Karnataka',
'Kalkhora,Bidar,Karnataka',
'Khanapur (K),Bidar,Karnataka',
'Kherda,Bidar,Karnataka',
'Kinni,Bidar,Karnataka',
'Kitta,Bidar,Karnataka',
'Kohinoor,Bidar,Karnataka',
'Ladwanti,Bidar,Karnataka',
'Maisalga,Bidar,Karnataka',
'Matala,Bidar,Karnataka',
'Mirkhal,Bidar,Karnataka',
'Morkhandi,Bidar,Karnataka',
'Muchlam,Bidar,Karnataka',
'Mudbi,Bidar,Karnataka',
'Narayanpur,Bidar,Karnataka',
'Nirgudi,Bidar,Karnataka',
'Pandargera,Bidar,Karnataka',
'Partapur,Bidar,Karnataka',
'Rajeshwar,Bidar,Karnataka',
'Rajola,Bidar,Karnataka',
'Rola,Bidar,Karnataka',
'Sastapur,Bidar,Karnataka',
'Tadola,Bidar,Karnataka',
'Toglur,Bidar,Karnataka',
'Ujlam,Bidar,Karnataka',
'Yeklera,Bidar,Karnataka',
'Yelladgundi,Bidar,Karnataka',
'Yerandi,Bidar,Karnataka',
'Yerbagh,Bidar,Karnataka',
'Ahmadabad,Bidar,Karnataka',
'Alandi,Bidar,Karnataka',
'Alwai,Bidar,Karnataka',
'Ambesangvi,Bidar,Karnataka',
'Attarga,Bidar,Karnataka',
'Balur,Bidar,Karnataka',
'Beeri (B),Bidar,Karnataka',
'Beeri (K),Bidar,Karnataka',
'Bhalki,Bidar,Karnataka',
'Bhalki Town,Bidar,Karnataka',
'Bhatambra,Bidar,Karnataka',
'Bhatasangvi,Bidar,Karnataka',
'Bolegaon,Bidar,Karnataka',
'Byalhalli,Bidar,Karnataka',
'C B College,Bidar,Karnataka',
'Chalakapur,Bidar,Karnataka',
'Chandapur,Bidar,Karnataka',
'Dadgi,Bidar,Karnataka',
'Dawargaon,Bidar,Karnataka',
'Dhannura (H),Bidar,Karnataka',
'Dongapur,Bidar,Karnataka',
'Gorchincholli,Bidar,Karnataka',
'Hajnal,Bidar,Karnataka',
'Halbarga,Bidar,Karnataka',
'Halhalli (K),Bidar,Karnataka',
'Halsi (L),Bidar,Karnataka',
'Halsi Tugaon,Bidar,Karnataka',
'Hupla,Bidar,Karnataka',
'Jaigaon,Bidar,Karnataka',
'Jamkhandi,Bidar,Karnataka',
'Janthi,Bidar,Karnataka',
'Joldapka,Bidar,Karnataka',
'Kalsar Tugaon,Bidar,Karnataka',
'Kanji,Bidar,Karnataka',
'Kardyal,Bidar,Karnataka',
'Kesar Jawalga,Bidar,Karnataka',
'Khatak Chincholli,Bidar,Karnataka',
'Kon Melkunda,Bidar,Karnataka',
'Kosam,Bidar,Karnataka',
'Kurubkhelagi,Bidar,Karnataka',
'Ladha (B),Bidar,Karnataka',
'Lakhangaon,Bidar,Karnataka',
'Madkatti,Bidar,Karnataka',
'Malchapur,Bidar,Karnataka',
'Maroor,Bidar,Karnataka',
'Masimadu,Bidar,Karnataka',
'Mehkar,Bidar,Karnataka',
'Methi Melkunda,Bidar,Karnataka',
'Morambi,Bidar,Karnataka',
'Nittur,Bidar,Karnataka',
'Rudnoor,Bidar,Karnataka',
'Saigaon,Bidar,Karnataka',
'Shivani,Bidar,Karnataka',
'Siddeshwar,Bidar,Karnataka',
'Talwada (K),Bidar,Karnataka',
'Talwada (M),Bidar,Karnataka',
'Telgaon,Bidar,Karnataka',
'Tugaon (C) Katti,Bidar,Karnataka',
'Wanjarkhed,Bidar,Karnataka',
'Warwatti (B),Bidar,Karnataka',
'Yenkura,Bidar,Karnataka',
'Aliember,Bidar,Karnataka',
'Amlapur,Bidar,Karnataka',
'Andur,Bidar,Karnataka',
'Astoor,Bidar,Karnataka',
'Aurad (S),Bidar,Karnataka',
'Bagdal,Bidar,Karnataka',
'Bakchowdi,Bidar,Karnataka',
'Baroor,Bidar,Karnataka',
'Bawgi,Bidar,Karnataka',
'Bhairnalli,Bidar,Karnataka',
'Bidar Bazar,Bidar,Karnataka',
'Bidar G.N.Jhira,Bidar,Karnataka',
'Bidar Gandhi Gunj,Bidar,Karnataka',
'Bidar H.O,Bidar,Karnataka',
'Bidar Osman Gunj,Bidar,Karnataka',
'Bidar Shah Gunj,Bidar,Karnataka',
'Budhera,Bidar,Karnataka',
'Chambol,Bidar,Karnataka',
'Chatnalli,Bidar,Karnataka',
'Chidri,Bidar,Karnataka',
'Chillargi,Bidar,Karnataka',
'Chimkod,Bidar,Karnataka',
'Chintalgera,Bidar,Karnataka',
'Chitta,Bidar,Karnataka',
'Gadgi,Bidar,Karnataka',
'Goonalli,Bidar,Karnataka',
'Haladkeri,Bidar,Karnataka',
'Hokrana (K),Bidar,Karnataka',
'IAF Stn ",Bidar,Karnataka',
'Janwada,Bidar,Karnataka',
'K.H.B. Colony Bidar,Bidar,Karnataka',
'Kadwad,Bidar,Karnataka',
'Kamthana,Bidar,Karnataka',
'Kaplapur (A),Bidar,Karnataka',
'Khasampur,Bidar,Karnataka',
'Kolhar (K),Bidar,Karnataka',
'Mailoor,Bidar,Karnataka',
'Malegaon,Bidar,Karnataka',
'Malkapur,Bidar,Karnataka',
'Mandaknalli,Bidar,Karnataka',
'Mangalpeth,Bidar,Karnataka',
'Manhalli,Bidar,Karnataka',
'Markhal,Bidar,Karnataka',
'Nagora,Bidar,Karnataka',
'Naubad,Bidar,Karnataka',
'Rajgira,Bidar,Karnataka',
'Rajnal,Bidar,Karnataka',
'Sangolgi,Bidar,Karnataka',
'Secundrapur,Bidar,Karnataka',
'Sindol,Bidar,Karnataka',
'Sirsi (A),Bidar,Karnataka',
'Srimandal,Bidar,Karnataka',
'Tadpalli,Bidar,Karnataka',
'Veterinary Univ. Campus,Bidar,Karnataka',
'Yakatpur,Bidar,Karnataka',
'Yedlapur,Bidar,Karnataka',
'Yernalli,Bidar,Karnataka',
'Alura,Bidar,Karnataka',
'Banhalli,Bidar,Karnataka',
'Belkhera,Bidar,Karnataka',
'Bemalkhed,Bidar,Karnataka',
'Bembalgi,Bidar,Karnataka',
'Benchincholli,Bidar,Karnataka',
'Chandanhalli,Bidar,Karnataka',
'Changler,Bidar,Karnataka',
'Chitguppa,Bidar,Karnataka',
'Dakulgi,Bidar,Karnataka',
'Dhannura (R),Bidar,Karnataka',
'Dhumansur,Bidar,Karnataka',
'Dubalgundi,Bidar,Karnataka',
'Gadwanti,Bidar,Karnataka',
'Ghatboral,Bidar,Karnataka',
'Ghodwadi,Bidar,Karnataka',
'Hallikhed (B),Bidar,Karnataka',
'Hallikhed (K),Bidar,Karnataka',
'Hallikhed SF,Bidar,Karnataka',
'Handikera,Bidar,Karnataka',
'Hankuni,Bidar,Karnataka',
'Hoodgi,Bidar,Karnataka',
'Humnabad Bazar,Bidar,Karnataka',
'Humnabad Industrial Area,Bidar,Karnataka',
'Humnabad,Bidar,Karnataka',
'Hunsgera,Bidar,Karnataka',
'Hunsnal,Bidar,Karnataka',
'Itga,Bidar,Karnataka',
'Jalsangi,Bidar,Karnataka',
'Kallur,Bidar,Karnataka',
'Kankatta,Bidar,Karnataka',
'Kappargaon,Bidar,Karnataka',
'Karaknalli,Bidar,Karnataka',
'Kodambal,Bidar,Karnataka',
'Kumar Chincholli,Bidar,Karnataka',
'Madargaon,Bidar,Karnataka',
'Madargi,Bidar,Karnataka',
'Mangalgi,Bidar,Karnataka',
'Maniknagar,Bidar,Karnataka',
'Mannakhelli,Bidar,Karnataka',
'Markhal,Bidar,Karnataka',
'Markunda,Bidar,Karnataka',
'Meenkera,Bidar,Karnataka',
'Mugnoor,Bidar,Karnataka',
'Mustari,Bidar,Karnataka',
'Muttangi,Bidar,Karnataka',
'Nagankhera,Bidar,Karnataka',
'Nandgaon,Bidar,Karnataka',
'Nirna,Bidar,Karnataka',
'Othagi,Bidar,Karnataka',
'Ranjol Kheni,Bidar,Karnataka',
'Rekulgi,Bidar,Karnataka',
'Sedol,Bidar,Karnataka',
'Sinbandgi,Bidar,Karnataka',
'Sindankera,Bidar,Karnataka',
'Sirkatnalli,Bidar,Karnataka',
'Sitalgera,Bidar,Karnataka',
'Sultanbad,Bidar,Karnataka',
'Talmadgi,Bidar,Karnataka',
'Udamnalli,Bidar,Karnataka',
'Udbal,Bidar,Karnataka',
'Walkhindi,Bidar,Karnataka',
'K.Salwadgi,Bijapur,Karnataka',
'Rabinal,Bijapur,Karnataka',
'Itagi,Bijapur,Karnataka',
'Asangi Khurd,Bijapur,Karnataka',
'Abbihal,Bijapur,Karnataka',
'Almat R.S.,Bijapur,Karnataka',
'Almatti Damsite,Bijapur,Karnataka',
'Aralichandi,Bijapur,Karnataka',
'B.Bagewadi Bazar,Bijapur,Karnataka',
'B.Salwadgi,Bijapur,Karnataka',
'Babanagar,Bijapur,Karnataka',
'Baluti,Bijapur,Karnataka',
'Benal,Bijapur,Karnataka',
'Bhairungi,Bijapur,Karnataka',
'Bhairwadgi,Bijapur,Karnataka',
'Bisnal,Bijapur,Karnataka',
'Byakod (BGW),Bijapur,Karnataka',
'Byalal,Bijapur,Karnataka',
'Chabanur,Bijapur,Karnataka',
'Chawadihal,Bijapur,Karnataka',
'Chimmalagi,Bijapur,Karnataka',
'Dindwar,Bijapur,Karnataka',
'Donur,Bijapur,Karnataka',
'Ghani,Bijapur,Karnataka',
'Halerolli,Bijapur,Karnataka',
'Halladgennur,Bijapur,Karnataka',
'Hanamapur,Bijapur,Karnataka',
'Harnal,Bijapur,Karnataka',
'Hebbal,Bijapur,Karnataka',
'Hunshyal,Bijapur,Karnataka',
'Huvin Hippargi,Bijapur,Karnataka',
'Ingaleshwar,Bijapur,Karnataka',
'Kadkol,Bijapur,Karnataka',
'Kalgurki,Bijapur,Karnataka',
'Kannal,Bijapur,Karnataka',
'Kolhar,Bijapur,Karnataka',
'Koulagi,Bijapur,Karnataka',
'Kudgi,Bijapur,Karnataka',
'Kupakaddi,Bijapur,Karnataka',
'Kurabardinni,Bijapur,Karnataka',
'Malghan,Bijapur,Karnataka',
'Mangoli,Bijapur,Karnataka',
'Mannur,Bijapur,Karnataka',
'Markabbinhalli,Bijapur,Karnataka',
'Masabinal,Bijapur,Karnataka',
'Mattihal,Bijapur,Karnataka',
'Mulawad,Bijapur,Karnataka',
'Muttagi,Bijapur,Karnataka',
'Nandihal,Bijapur,Karnataka',
'Narasalagi,Bijapur,Karnataka',
'Nidgundi,Bijapur,Karnataka',
'Ronihal,Bijapur,Karnataka',
'Sasanur,Bijapur,Karnataka',
'Satihal,Bijapur,Karnataka',
'Siddanath,Bijapur,Karnataka',
'Somanal,Bijapur,Karnataka',
'Takkalki,Bijapur,Karnataka',
'Talewad,Bijapur,Karnataka',
'Telgi,Bijapur,Karnataka',
'Ukkali,Bijapur,Karnataka',
'Utnal,Bijapur,Karnataka',
'Vandal,Bijapur,Karnataka',
'Wadwadgi,Bijapur,Karnataka',
'Yalwar,Bijapur,Karnataka',
'Yarnal,Bijapur,Karnataka',
'Basavan Bagewadi,Bijapur,Karnataka',
'Ainapur,Bijapur,Karnataka',
'Ankalgi,Bijapur,Karnataka',
'Arjunagi,Bijapur,Karnataka',
'Arkeri,Bijapur,Karnataka',
'Bablad,Bijapur,Karnataka',
'Bableshwar,Bijapur,Karnataka',
'Baratgi,Bijapur,Karnataka',
'Bellubbi,Bijapur,Karnataka',
'Bhutnal,Bijapur,Karnataka',
'Bijapur Amc,Bijapur,Karnataka',
'Bijapur Basava Nagar,Bijapur,Karnataka',
'Bijapur Bazar,Bijapur,Karnataka',
'Bijapur Chanda Bavadi,Bijapur,Karnataka',
'Bijapur Darbar Galli,Bijapur,Karnataka',
'Bijapur H.O,Bijapur,Karnataka',
'Bijapur Hudco Colony,Bijapur,Karnataka',
'Bijapur Jorapur Peth,Bijapur,Karnataka',
'Bijapur Jummamasjid,Bijapur,Karnataka',
'Bijapur Kutchery,Bijapur,Karnataka',
'Bijapur Laxmi Devi,Bijapur,Karnataka',
'Bijapur Market Yard,Bijapur,Karnataka',
'Bijapur Railway Station,Bijapur,Karnataka',
'Bijapur Sainik School,Bijapur,Karnataka',
'Bijapur Tajbavadi,Bijapur,Karnataka',
'Bijapur Vijaya College,Bijapur,Karnataka',
'Bijjargi,Bijapur,Karnataka',
'Darga (Bijapur),Bijapur,Karnataka',
'Dashyal,Bijapur,Karnataka',
'Devapur,Bijapur,Karnataka',
'Devar Gennur,Bijapur,Karnataka',
'Dhannargi,Bijapur,Karnataka',
'Dhanyal,Bijapur,Karnataka',
'Domanal,Bijapur,Karnataka',
'Ghonasagi,Bijapur,Karnataka',
'Gundal,Bijapur,Karnataka',
'Gunki,Bijapur,Karnataka',
'Hadagali,Bijapur,Karnataka',
'Halagani,Bijapur,Karnataka',
'Hangargi,Bijapur,Karnataka',
'Hebbalatti,Bijapur,Karnataka',
'Hegadihal,Bijapur,Karnataka',
'Hitinhalli,Bijapur,Karnataka',
'Hokkundi,Bijapur,Karnataka',
'Honaganhalli,Bijapur,Karnataka',
'Honawad,Bijapur,Karnataka',
'Honnutgi,Bijapur,Karnataka',
'Hosur,Bagalkot,Karnataka',
'Hubnur,Bijapur,Karnataka',
'Ittangihal,Bijapur,Karnataka',
'Ivanagi,Bijapur,Karnataka',
'Jainapur,Bijapur,Karnataka',
'Jalgeri,Bijapur,Karnataka',
'Jambagi,Bijapur,Karnataka',
'Jambagi,Bagalkot,Karnataka',
'Jumanal,Bijapur,Karnataka',
'Kaggod,Bijapur,Karnataka',
'Kakhandki,Bijapur,Karnataka',
'Kambagi,Bijapur,Karnataka',
'Kanabur,Bagalkot,Karnataka',
'Kanmadi,Bijapur,Karnataka',
'Kanmuchnal,Bijapur,Karnataka',
'Kannal,Bijapur,Karnataka',
'Kannur,Bijapur,Karnataka',
'Karjol,Bijapur,Karnataka',
'Katakanhalli,Bijapur,Karnataka',
'Khatijapur,Bijapur,Karnataka',
'Kotyal,Bijapur,Karnataka',
'Kumthe,Bijapur,Karnataka',
'Lohagaon,Bijapur,Karnataka',
'M.Devarhatti,Bijapur,Karnataka',
'Madasanal,Bijapur,Karnataka',
'Madhbhavi,Bijapur,Karnataka',
'Madikeshwar,Bijapur,Karnataka',
'Majre Sangapur,Bijapur,Karnataka',
'Makhanapur,Bijapur,Karnataka',
'Mamadapur,Bijapur,Karnataka',
'Minchanal Lt,Bijapur,Karnataka',
'Nagaral,Bijapur,Karnataka',
'Nagathan,Bijapur,Karnataka',
'Nidoni,Bijapur,Karnataka',
'Sangapur Sh,Bijapur,Karnataka',
'Sarwad,Bijapur,Karnataka',
'Shanti Kutir,Bijapur,Karnataka',
'Shegunshi,Bijapur,Karnataka',
'Shirbur,Bagalkot,Karnataka',
'Shirnal,Bijapur,Karnataka',
'Shivangi,Bijapur,Karnataka',
'Siddapur,Bijapur,Karnataka',
'Somadevarhatti,Bijapur,Karnataka',
'Tajpur,Bijapur,Karnataka',
'Tidgundi,Bijapur,Karnataka',
'Tiganibidari,Bijapur,Karnataka',
'Tikota,Bijapur,Karnataka',
'Tonshyal,Bijapur,Karnataka',
'Torvi,Bijapur,Karnataka',
'Uppaladinni,Bijapur,Karnataka',
'Yakkundi,Bijapur,Karnataka',
'Yatnal,Bijapur,Karnataka',
'Agarkhed,Bijapur,Karnataka',
'Agasanal,Bijapur,Karnataka',
'Aheri,Bijapur,Karnataka',
'Ahirsang,Bijapur,Karnataka',
'Aliyabad,Bijapur,Karnataka',
'Alur (Indi),Bijapur,Karnataka',
'Anjutgi,Bijapur,Karnataka',
'Arjanal,Bijapur,Karnataka',
'Arjunagi,Bijapur,Karnataka',
'Atharga,Bijapur,Karnataka',
'Bablad,Bijapur,Karnataka',
'Ballolli,Bijapur,Karnataka',
'Banthanal,Bijapur,Karnataka',
'Bardol,Bijapur,Karnataka',
'Bargudi,Bijapur,Karnataka',
'Basanal,Bijapur,Karnataka',
'Benakanhalli,Bijapur,Karnataka',
'Bhatgunki,Bijapur,Karnataka',
'Bhuyar,Bijapur,Karnataka',
'Chadachan Extn,Bijapur,Karnataka',
'Chadchan,Bijapur,Karnataka',
'Chattarki,Bijapur,Karnataka',
'Chik Bevanur,Bijapur,Karnataka',
'Chikrugi,Bijapur,Karnataka',
'Deginal,Bijapur,Karnataka',
'Dhulkhed,Bijapur,Karnataka',
'Dyaberi,Bijapur,Karnataka',
'Godihal,Bijapur,Karnataka',
'Golsar,Bijapur,Karnataka',
'Gornal,Bijapur,Karnataka',
'Gubbewad (Indi),Bijapur,Karnataka',
'Hadalsang,Bijapur,Karnataka',
'Halagunki,Bijapur,Karnataka',
'Halahalli,Bijapur,Karnataka',
'Halsangi,Bijapur,Karnataka',
'Hanjagi,Bijapur,Karnataka',
'Hattalli,Bijapur,Karnataka',
'Hattarkihal,Bijapur,Karnataka',
'Havinal,Bijapur,Karnataka',
'Hingani,Bijapur,Karnataka',
'Hirebevanur,Bijapur,Karnataka',
'Hiremasali,Bijapur,Karnataka',
'Hiremural,Bijapur,Karnataka',
'Hirerugi,Bijapur,Karnataka',
'Honnalli,Bijapur,Karnataka',
'Horti,Bijapur,Karnataka',
'Inchageri,Bijapur,Karnataka',
'Indi Bazar,Bijapur,Karnataka',
'Indi H.O,Bijapur,Karnataka',
'Indi Road,Bijapur,Karnataka',
'Ingalgi,Bijapur,Karnataka',
'Jeerankalgi,Bijapur,Karnataka',
'Jevoor,Bijapur,Karnataka',
'Jigjivani,Bijapur,Karnataka',
'Kapanimbargi,Bijapur,Karnataka',
'Kenginal,Bijapur,Karnataka',
'Khedgi,Bijapur,Karnataka',
'Lachyan,Bijapur,Karnataka',
'Loni BK,Bijapur,Karnataka',
'Manankalgi,Bijapur,Karnataka',
'Mannur,Bijapur,Karnataka',
'Manur,Bijapur,Karnataka',
'Masuti,Bijapur,Karnataka',
'Mirgi,Bijapur,Karnataka',
'Nadkhurd,Bijapur,Karnataka',
'Nandargi,Bijapur,Karnataka',
'Nimb R.S.,Bijapur,Karnataka',
'Nimbal,Bijapur,Karnataka',
'Nimbargi,Bijapur,Karnataka',
'Nivargi,Bijapur,Karnataka',
'Padnur,Bijapur,Karnataka',
'Revatgaon,Bijapur,Karnataka',
'Rodagi,Bijapur,Karnataka',
'Salotgi,Bijapur,Karnataka',
'Sankh,Bijapur,Karnataka',
'Satalgaon (PB),Bijapur,Karnataka',
'Satalgaon,Bijapur,Karnataka',
'Savalsang,Bijapur,Karnataka',
'Shiradon,Bijapur,Karnataka',
'Shirakanhalli,Bijapur,Karnataka',
'Shirshyad,Bijapur,Karnataka',
'Tadavalga,Bijapur,Karnataka',
'Taddewadi,Bijapur,Karnataka',
'Tamba,Bijapur,Karnataka',
'Teggihalli,Bijapur,Karnataka',
'Tenihalli,Bijapur,Karnataka',
'Umaraj,Bijapur,Karnataka',
'Umrani,Bijapur,Karnataka',
'Vibhuthalli,Bijapur,Karnataka',
'Zalki,Bijapur,Karnataka',
'Muddebiahl Fort,Bijapur,Karnataka',
'Alur,Bijapur,Karnataka',
'Amargol,Bijapur,Karnataka',
'Angadgeri,Bijapur,Karnataka',
'Balabatti,Bijapur,Karnataka',
'Balaganur,Bijapur,Karnataka',
'Balwat,Bijapur,Karnataka',
'Basarkod,Bijapur,Karnataka',
'Bavur,Bijapur,Karnataka',
'Bhantanur (TKT),Bijapur,Karnataka',
'Bidarkundi,Bijapur,Karnataka',
'Bijjur,Bijapur,Karnataka',
'Bilebhavi,Bijapur,Karnataka',
'Bommanahalli,Bijapur,Karnataka',
'Budihal Pn,Bijapur,Karnataka',
'Budihal;,Bijapur,Karnataka',
'Devar Hulagbal,Bijapur,Karnataka',
'Devur,Bijapur,Karnataka',
'Dhavalgi,Bijapur,Karnataka',
'Gadisomanal,Bijapur,Karnataka',
'Golasangi,Bijapur,Karnataka',
'Gundkarajagi,Bijapur,Karnataka',
'Hadalgeri,Bijapur,Karnataka',
'Hagargond,Bijapur,Karnataka',
'Hallur,Bijapur,Karnataka',
'Handargal,Bijapur,Karnataka',
'Hangargi,Bijapur,Karnataka',
'Hirur,Bijapur,Karnataka',
'Hulagbal,Bijapur,Karnataka',
'Hullur,Bijapur,Karnataka',
'Hullur Lt,Bijapur,Karnataka',
'Hunakunti,Bijapur,Karnataka',
'Ingalgeri,Bijapur,Karnataka',
'Jammaldinni,Bijapur,Karnataka',
'Kalgi,Bijapur,Karnataka',
'Kandaganur,Bijapur,Karnataka',
'Kankal,Bijapur,Karnataka',
'Kavadimatti,Bijapur,Karnataka',
'Kodaganur,Bijapur,Karnataka',
'Kolur,Bijapur,Karnataka',
'Kolur Lt,Bijapur,Karnataka',
'Konnur,Bijapur,Karnataka',
'Kunchaganur,Bijapur,Karnataka',
'Kuntoji,Bijapur,Karnataka',
'Lingadahalli,Bijapur,Karnataka',
'Madari,Bijapur,Karnataka',
'Madinal,Bijapur,Karnataka',
'Maileshwar,Bijapur,Karnataka',
'Minajagi,Bijapur,Karnataka',
'Muddebiahl,Bijapur,Karnataka',
'Muddebihal Bazar,Bijapur,Karnataka',
'Mukihal,Bijapur,Karnataka',
'Nagabenal,Bijapur,Karnataka',
'Nagarbetta,Bijapur,Karnataka',
'Nagur,Bijapur,Karnataka',
'Nalatwad,Bijapur,Karnataka',
'Narebenchi,Bijapur,Karnataka',
'Navadagi,Bijapur,Karnataka',
'Nebageri,Bijapur,Karnataka',
'Padekanur,Bijapur,Karnataka',
'Peerapur,Bijapur,Karnataka',
'Phattepur,Bijapur,Karnataka',
'Rakkasagi,Bijapur,Karnataka',
'Rudgi,Bijapur,Karnataka',
'Sarur,Bijapur,Karnataka',
'Shivapur,Bijapur,Karnataka',
'Siddapur Ds,Bijapur,Karnataka',
'Takkalki,Bijapur,Karnataka',
'Takkalki,Bijapur,Karnataka',
'Talikoti Bazar,Bijapur,Karnataka',
'Talikoti,Bijapur,Karnataka',
'Tamadaddi,Bijapur,Karnataka',
'Tangadgi,Bijapur,Karnataka',
'Tumbagi,Bijapur,Karnataka',
'Vanahalli,Bijapur,Karnataka',
'Yalgur,Bijapur,Karnataka',
'Yargal (TGD),Bijapur,Karnataka',
'Yarzeri,Bijapur,Karnataka',
'Aheri (Sindgi),Bijapur,Karnataka',
'Algur,Bijapur,Karnataka',
'Almel,Bijapur,Karnataka',
'Asantapur,Bijapur,Karnataka',
'Aski,Bijapur,Karnataka',
'Bagalur,Bijapur,Karnataka',
'Balaganur,Bijapur,Karnataka',
'Bandal,Bijapur,Karnataka',
'Bankalgi,Bijapur,Karnataka',
'Bannihatti Pa,Bijapur,Karnataka',
'Bekinal,Bijapur,Karnataka',
'Bhantanur,Bijapur,Karnataka',
'Bibi-ingalgi,Bijapur,Karnataka',
'Binjalbhavi,Bijapur,Karnataka',
'Bommanahalli,Bijapur,Karnataka',
'Bommanjogi,Bijapur,Karnataka',
'Borgi,Bijapur,Karnataka',
'Budihal Ph,Bijapur,Karnataka',
'Byakod,Bijapur,Karnataka',
'Chandkavathe,Bijapur,Karnataka',
'Channegaon,Bijapur,Karnataka',
'Chick Sindgi,Bijapur,Karnataka',
'Devangaon,Bijapur,Karnataka',
'Devar Hippargi,Bijapur,Karnataka',
'Devar Navadagi,Bijapur,Karnataka',
'Gabsavalgi,Bijapur,Karnataka',
'Ganihar,Bijapur,Karnataka',
'Golgeri,Bijapur,Karnataka',
'Goravgundgi,Bijapur,Karnataka',
'Gubbewad,Bijapur,Karnataka',
'Gundagi,Bijapur,Karnataka',
'Hachyal,Bijapur,Karnataka',
'Hanchli,Bijapur,Karnataka',
'Handiganur,Bijapur,Karnataka',
'Hikkangutti,Bijapur,Karnataka',
'Hittinhalli (LT),Bijapur,Karnataka',
'Honnalli,Bijapur,Karnataka',
'Hunsyal (SDG),Bijapur,Karnataka',
'Huvinhalli,Bijapur,Karnataka',
'Ingalgi,Bijapur,Karnataka',
'Jalwad,Bijapur,Karnataka',
'Kadlewad(Pa),Bijapur,Karnataka',
'Kadni,Bijapur,Karnataka',
'Kakkalmeli,Bijapur,Karnataka',
'Kalhalli,Bijapur,Karnataka',
'Kalkeri,Bijapur,Karnataka',
'Kannolli,Bijapur,Karnataka',
'Kerutgi,Bijapur,Karnataka',
'Kesaratti,Bijapur,Karnataka',
'Khainur,Bijapur,Karnataka',
'Khanapur,Bijapur,Karnataka',
'Kokatnur,Bijapur,Karnataka',
'Kondguli,Bijapur,Karnataka',
'Korahalli,Bijapur,Karnataka',
'Korwar,Bijapur,Karnataka',
'Kumshi,Bijapur,Karnataka',
'Kurabathalli,Bijapur,Karnataka',
'Madanahalli,Bijapur,Karnataka',
'Madbal,Bijapur,Karnataka',
'Malghan,Bijapur,Karnataka',
'Moratgi,Bijapur,Karnataka',
'Mulasavalgi,Bijapur,Karnataka',
'Nagavi,Bijapur,Karnataka',
'Neeralgi,Bijapur,Karnataka',
'Otihal,Bijapur,Karnataka',
'Padaganur,Bijapur,Karnataka',
'Rampur,Bijapur,Karnataka',
'Sindgi,Bijapur,Karnataka',
'Sindgi Town,Bijapur,Karnataka',
'Somjal,Bijapur,Karnataka',
'Sungthan,Bijapur,Karnataka',
'Surgihalli,Bijapur,Karnataka',
'Tilgul,Bijapur,Karnataka',
'Yalgod,Bijapur,Karnataka',
'Yambatnal,Bijapur,Karnataka',
'Yankanchi,Bijapur,Karnataka',
'Yargal,Bijapur,Karnataka',
'Sasabal,Bijapur,Karnataka',
'Alur,Nanjangud,Karnataka',
'Amachavadi,Nanjangud,Karnataka',
'Ankasettypura,Nanjangud,Karnataka',
'Arakalavadi,Nanjangud,Karnataka',
'Attagulipura,Nanjangud,Karnataka',
'Attikane,Nanjangud,Karnataka',
'Badanaguppe,Nanjangud,Karnataka',
'Bagali,Nanjangud,Karnataka',
'Bedaguli,Nanjangud,Karnataka',
'Bhogapura,Nanjangud,Karnataka',
'Bisalavadi,Nanjangud,Karnataka',
'Chamarajanagara Bazar,Nanjangud,Karnataka',
'Chamarajanagara Pwd Colony,Nanjangud,Karnataka',
'Chamarajanagara,Nanjangud,Karnataka',
'Chamarajanagara Town,Nanjangud,Karnataka',
'Chandakavadi,Nanjangud,Karnataka',
'Chikkahomma,Nanjangud,Karnataka',
'Cowdalli,Nanjangud,Karnataka',
'Dasanur,Nanjangud,Karnataka',
'Demahalli,Nanjangud,Karnataka',
'Doddamole,Nanjangud,Karnataka',
'Doddarayapet,Nanjangud,Karnataka',
'Gulipura,Nanjangud,Karnataka',
'Hanur,Nanjangud,Karnataka',
'Haradanahalli,Nanjangud,Karnataka',
'Harave,Nanjangud,Karnataka',
'Hebbasur,Nanjangud,Karnataka',
'Heggavady,Nanjangud,Karnataka',
'Hondarabalu,Nanjangud,Karnataka',
'Honganur,Nanjangud,Karnataka',
'Honnahalli,Nanjangud,Karnataka',
'Jannur,Nanjangud,Karnataka',
'Jyothigowdanapura,Nanjangud,Karnataka',
'Kagalavadi,Nanjangud,Karnataka',
'Kalanahundi,Nanjangud,Karnataka',
'Kalpura,Nanjangud,Karnataka',
'Kamakerai,Nanjangud,Karnataka',
'Kannagala,Nanjangud,Karnataka',
'Kastur Chamarajanagara,Nanjangud,Karnataka',
'Kavudavadi,Nanjangud,Karnataka',
'Kellamballi,Nanjangud,Karnataka',
'Kempanapura,Nanjangud,Karnataka',
'Kodimole,Nanjangud,Karnataka',
'Kotamballi,Nanjangud,Karnataka',
'Kuderu,Nanjangud,Karnataka',
'Kudlur,Nanjangud,Karnataka',
'Kyathadevaragudi,Nanjangud,Karnataka',
'M K Hundi,Nanjangud,Karnataka',
'Madapura,Nanjangud,Karnataka',
'Madhuvinahalli,Nanjangud,Karnataka',
'Mahadeshwara Malai,Nanjangud,Karnataka',
'Mahanthalapura,Nanjangud,Karnataka',
'Maleyur,Nanjangud,Karnataka',
'Mangala,Nanjangud,Karnataka',
'Mariyala,Nanjangud,Karnataka',
'Masanapura,Nanjangud,Karnataka',
'Mudnakudu,Nanjangud,Karnataka',
'Mukanapalya,Nanjangud,Karnataka',
'Mukkadahalli,Nanjangud,Karnataka',
'Nagavalli,Nanjangud,Karnataka',
'Nanjedevanapura,Nanjangud,Karnataka',
'Punajanur,Nanjangud,Karnataka',
'Ramasamudra,Nanjangud,Karnataka',
'Sagade,Nanjangud,Karnataka',
'Santhemaranahalli,Nanjangud,Karnataka',
'Saragur Chamarajanagara,Nanjangud,Karnataka',
'Shivapura,Nanjangud,Karnataka',
'Somvarpet,Nanjangud,Karnataka',
'Thammadahalli,Nanjangud,Karnataka',
'Udigala,Nanjangud,Karnataka',
'Ummathur,Nanjangud,Karnataka',
'Uttuvalli,Nanjangud,Karnataka',
'Venkatainachatra,Nanjangud,Karnataka',
'Yanaganahalli,Nanjangud,Karnataka',
'Yeraganahlli,Nanjangud,Karnataka',
'Annurkeri,Nanjangud,Karnataka',
'Alathur,Nanjangud,Karnataka',
'Bachahalli,Nanjangud,Karnataka',
'Balachavadi,Nanjangud,Karnataka',
'Bandipura,Nanjangud,Karnataka',
'Baragi,Nanjangud,Karnataka',
'Begur,Nanjangud,Karnataka',
'Belachalavadi,Nanjangud,Karnataka',
'Berambadi,Nanjangud,Karnataka',
'Berthahallli,Nanjangud,Karnataka',
'Bettahalli,Nanjangud,Karnataka',
'Bheemanabeedu,Nanjangud,Karnataka',
'Bnnithalapura,Nanjangud,Karnataka',
'Bommalapura,Nanjangud,Karnataka',
'Bommanahalli,Nanjangud,Karnataka',
'Chikkati,Nanjangud,Karnataka',
'Chikkatuppur,Nanjangud,Karnataka',
'Chirakanahalli,Nanjangud,Karnataka',
'Depapura,Nanjangud,Karnataka',
'Devarahalli,Nanjangud,Karnataka',
'Gundlupet Bazar,Nanjangud,Karnataka',
'Gundlupet,Nanjangud,Karnataka',
'Hangala,Nanjangud,Karnataka',
'Hasaguli,Nanjangud,Karnataka',
'Heggadahalli,Nanjangud,Karnataka',
'Hirikati,Nanjangud,Karnataka',
'Hongalli,Nanjangud,Karnataka',
'Horeyala,Nanjangud,Karnataka',
'Hundipura,Nanjangud,Karnataka',
'Kabbahalli,Nanjangud,Karnataka',
'Kaggala,Nanjangud,Karnataka',
'Kaligowdanahalli,Nanjangud,Karnataka',
'Kallahalli,Nanjangud,Karnataka',
'Kaniyanapura,Nanjangud,Karnataka',
'Kannegala,Nanjangud,Karnataka',
'Kelasur,Nanjangud,Karnataka',
'Kilagere,Nanjangud,Karnataka',
'Kodasoge,Nanjangud,Karnataka',
'Kotekere,Nanjangud,Karnataka',
'Kothalavadi,Nanjangud,Karnataka',
'Kulugana,Nanjangud,Karnataka',
'Kundakere,Nanjangud,Karnataka',
'Lakkur,Nanjangud,Karnataka',
'Maddur,Nanjangud,Karnataka',
'Mangala,Nanjangud,Karnataka',
'Muduguru,Nanjangud,Karnataka',
'Nenekatte,Nanjangud,Karnataka',
'Nitre,Nanjangud,Karnataka',
'Paduguru,Nanjangud,Karnataka',
'Puttanapura,Nanjangud,Karnataka',
'Raghavapura,Nanjangud,Karnataka',
'Shivapura,Nanjangud,Karnataka',
'Sindanapura,Nanjangud,Karnataka',
'Somahallli,Nanjangud,Karnataka',
'Thondavadi,Nanjangud,Karnataka',
'Tirukanambi,Nanjangud,Karnataka',
'Vaddagere,Nanjangud,Karnataka',
'Veeranapura,Nanjangud,Karnataka',
'Yeriyur,Nanjangud,Karnataka',
'Ajjipura,Nanjangud,Karnataka',
'Bailur,Nanjangud,Karnataka',
'Bandalli,Nanjangud,Karnataka',
'Bastipura,Nanjangud,Karnataka',
'Bodimuthanahalli,Nanjangud,Karnataka',
'Channalingadahalli,Nanjangud,Karnataka',
'Chikkamallapura,Nanjangud,Karnataka',
'Dinnahalli,Nanjangud,Karnataka',
'Doddalathur,Nanjangud,Karnataka',
'Doddinduvadi,Nanjangud,Karnataka',
'Ellemela,Nanjangud,Karnataka',
'Gopinatham,Nanjangud,Karnataka',
'Goreyur,Nanjangud,Karnataka',
'Hoogiam,Nanjangud,Karnataka',
'Kannur,Nanjangud,Karnataka',
'Kempanapalya,Nanjangud,Karnataka',
'Kollegal Devangapet,Nanjangud,Karnataka',
'Kollegal H.O,Nanjangud,Karnataka',
'Kollegal Southern Extension,Nanjangud,Karnataka',
'Kothanur,Nanjangud,Karnataka',
'Kudlur,Nanjangud,Karnataka',
'Kurahatti Hosur,Nanjangud,Karnataka',
'Lokkanahalli,Nanjangud,Karnataka',
'Managahalli,Nanjangud,Karnataka',
'Manchapura,Nanjangud,Karnataka',
'Mangalam,Nanjangud,Karnataka',
'Marthalli,Nanjangud,Karnataka',
'Minya,Nanjangud,Karnataka',
'Mudigundam,Nanjangud,Karnataka',
'Odeyarapalyam,Nanjangud,Karnataka',
'Palyam,Nanjangud,Karnataka',
'Parasegowdanapalya,Nanjangud,Karnataka',
'Ponnachi,Nanjangud,Karnataka',
'Ramapuram Ghat,Nanjangud,Karnataka',
'Saggiam,Nanjangud,Karnataka',
'Sargur Kollegal,Nanjangud,Karnataka',
'Sathegala,Nanjangud,Karnataka',
'Siddainapura,Nanjangud,Karnataka',
'Singanallur,Nanjangud,Karnataka',
'Suleripalyam,Nanjangud,Karnataka',
'Tellanur,Nanjangud,Karnataka',
'Tibetan Settlement,Nanjangud,Karnataka',
'Uddanur,Nanjangud,Karnataka',
'Agara,Nanjangud,Karnataka',
'Alahalli,Nanjangud,Karnataka',
'Ambale,Nanjangud,Karnataka',
'B R Hills,Nanjangud,Karnataka',
'Chilukavadi,Nanjangud,Karnataka',
'Ganiganur,Nanjangud,Karnataka',
'Gowdahalli,Nanjangud,Karnataka',
'Honnur,Nanjangud,Karnataka',
'Hosamalangi,Nanjangud,Karnataka',
'Irasavadi,Nanjangud,Karnataka',
'Kaliyur,Nanjangud,Karnataka',
'Kestur Yelandur,Nanjangud,Karnataka',
'Kinakanahalli,Nanjangud,Karnataka',
'Komaranapura,Nanjangud,Karnataka',
'Kunaganahalli,Nanjangud,Karnataka',
'Kunthur,Nanjangud,Karnataka',
'Maddur Yelandur,Nanjangud,Karnataka',
'Malangi,Nanjangud,Karnataka',
'Mamballi,Nanjangud,Karnataka',
'Mullur,Nanjangud,Karnataka',
'Shivakalli,Nanjangud,Karnataka',
'Uttamballi,Nanjangud,Karnataka',
'Yelandur Balepete,Nanjangud,Karnataka',
'Yelandur,Nanjangud,Karnataka',
'Yeragamballi,Nanjangud,Karnataka',
'Yeriyur,Nanjangud,Karnataka',
'Aldur,Chikmagalur,Karnataka',
'Amble,Chikmagalur,Karnataka',
'Anur,Chikmagalur,Karnataka',
'Attigundi,Chikmagalur,Karnataka',
'Avathi,Chikmagalur,Karnataka',
'Belavadi,Chikmagalur,Karnataka',
'Bidre,Chikmagalur,Karnataka',
'Bisagnimutt,Chikmagalur,Karnataka',
'Bogase,Chikmagalur,Karnataka',
'Chikmagalur District Office,Chikmagalur,Karnataka',
'Chikmagalur Fort,Chikmagalur,Karnataka',
'Chikmagalur H.O,Chikmagalur,Karnataka',
'Chikmagalur Market,Chikmagalur,Karnataka',
'Chikmagalur ZP,Chikmagalur,Karnataka',
'Eshwarahalli,Chikmagalur,Karnataka',
'Guddadamane,Chikmagalur,Karnataka',
'Gullanpet,Chikmagalur,Karnataka',
'Halasumane,Chikmagalur,Karnataka',
'Handi,Chikmagalur,Karnataka',
'Hangaravalli,Chikmagalur,Karnataka',
'Hiregouza,Chikmagalur,Karnataka',
'Hirekolale,Chikmagalur,Karnataka',
'Hiremagalur,Chikmagalur,Karnataka',
'Hosahallipet,Chikmagalur,Karnataka',
'Huigere,Chikmagalur,Karnataka',
'Hulikere,Chikmagalur,Karnataka',
'Indavara,Chikmagalur,Karnataka',
'Jagara,Chikmagalur,Karnataka',
'Jakkanahalli,Chikmagalur,Karnataka',
'Jannagadde,Chikmagalur,Karnataka',
'Jodimachenahalli,Chikmagalur,Karnataka',
'Joldal,Chikmagalur,Karnataka',
'Jyothinagar,Chikmagalur,Karnataka',
'K.R. Pete(Bigganahalli),Chikmagalur,Karnataka',
'Kabbinahalli,Chikmagalur,Karnataka',
'Kadavanthi,Chikmagalur,Karnataka',
'Kaimara,Chikmagalur,Karnataka',
'Kalasapura,Chikmagalur,Karnataka',
'Kanathi,Chikmagalur,Karnataka',
'Karthikere,Chikmagalur,Karnataka',
'Kelagur,Chikmagalur,Karnataka',
'Kuduvalli,Chikmagalur,Karnataka',
'Kurubarabudihal,Chikmagalur,Karnataka',
'Kuruvangi,Chikmagalur,Karnataka',
'Lakkammanahalli,Chikmagalur,Karnataka',
'Lakya,Chikmagalur,Karnataka',
'Malalur(CKM),Chikmagalur,Karnataka',
'Mallandur,Chikmagalur,Karnataka',
'Mallenahalli,Chikmagalur,Karnataka',
'Marle,Chikmagalur,Karnataka',
'Mugthihalli,Chikmagalur,Karnataka',
'Muguluvalli,Chikmagalur,Karnataka',
'Nagenahalli,Chikmagalur,Karnataka',
'Pandaavalli,Chikmagalur,Karnataka',
'Porterpet,Chikmagalur,Karnataka',
'Ramanahalli,Chikmagalur,Karnataka',
'Rampura,Chikmagalur,Karnataka',
'Sangameshwarapete,Chikmagalur,Karnataka',
'Sindigere,Chikmagalur,Karnataka',
'Sirvase,Chikmagalur,Karnataka',
'Uddeboranahalli,Chikmagalur,Karnataka',
'Vastare,Chikmagalur,Karnataka',
'Vijayapuram,Chikmagalur,Karnataka',
'Kesavinamane,Chikmagalur,Karnataka',
'Alaghatta,Chikmagalur,Karnataka',
'Anegere,Chikmagalur,Karnataka',
'Annigere(Y),Chikmagalur,Karnataka',
'Antharaghatta,Chikmagalur,Karnataka',
'Asandi,Chikmagalur,Karnataka',
'Balliganur,Chikmagalur,Karnataka',
'Banur,Chikmagalur,Karnataka',
'Basoor,Chikmagalur,Karnataka',
'Begur,Chikmagalur,Karnataka',
'Biluvala,Chikmagalur,Karnataka',
'Birur,Chikmagalur,Karnataka',
'Bisalehalli,Chikmagalur,Karnataka',
'Bislere,Chikmagalur,Karnataka',
'Chikkaballekere,Chikmagalur,Karnataka',
'Chikkanallur,Chikmagalur,Karnataka',
'Chikkangala,Chikmagalur,Karnataka',
'Chowlahiriyur,Chikmagalur,Karnataka',
'Devanur,Chikmagalur,Karnataka',
'G. Yaradakere,Chikmagalur,Karnataka',
'Gangenahalli,Chikmagalur,Karnataka',
'Garje,Chikmagalur,Karnataka',
'Giriyapura,Chikmagalur,Karnataka',
'Hirenallur,Chikmagalur,Karnataka',
'Hochihalli,Chikmagalur,Karnataka',
'Hogarehalli,Chikmagalur,Karnataka',
'Honnenahalli,Chikmagalur,Karnataka',
'Huligere,Chikmagalur,Karnataka',
'Jiganehalli,Chikmagalur,Karnataka',
'Kadur Fort,Chikmagalur,Karnataka',
'Kadur RS,Chikmagalur,Karnataka',
'Kadur,Chikmagalur,Karnataka',
'Kadur Town,Chikmagalur,Karnataka',
'Kadurhalli,Chikmagalur,Karnataka',
'Kalkere,Chikmagalur,Karnataka',
'Kamanakere,Chikmagalur,Karnataka',
'Kanchugal Bidre,Chikmagalur,Karnataka',
'Keresanthe,Chikmagalur,Karnataka',
'Kunkanadu,Chikmagalur,Karnataka',
'Maravanji,Chikmagalur,Karnataka',
'Mathighatta,Chikmagalur,Karnataka',
'Muthanagere,Chikmagalur,Karnataka',
'Nagaralu,Chikmagalur,Karnataka',
'Nidaghatta,Chikmagalur,Karnataka',
'Niduvalli,Chikmagalur,Karnataka',
'Panchanahalli,Chikmagalur,Karnataka',
'Patnagere,Chikmagalur,Karnataka',
'Pillenahally,Chikmagalur,Karnataka',
'S. Bidare,Chikmagalur,Karnataka',
'S. Madapura,Chikmagalur,Karnataka',
'Sakrepatna,Chikmagalur,Karnataka',
'Saraswathipura,Chikmagalur,Karnataka',
'Singatagere,Chikmagalur,Karnataka',
'Somanahalli,Chikmagalur,Karnataka',
'Tangli,Chikmagalur,Karnataka',
'Udugere,Chikmagalur,Karnataka',
'Vakkalagere,Chikmagalur,Karnataka',
'Y. Mallapura,Chikmagalur,Karnataka',
'Yagati,Chikmagalur,Karnataka',
'Yellambalase,Chikmagalur,Karnataka',
'Yemmedoddi,Chikmagalur,Karnataka',
'Addada,Chikmagalur,Karnataka',
'Agalagandi,Chikmagalur,Karnataka',
'Alageshwara,Chikmagalur,Karnataka',
'Andagaru,Chikmagalur,Karnataka',
'Balagady-koppa,Chikmagalur,Karnataka',
'Basarikatte,Chikmagalur,Karnataka',
'Belavinakodige,Chikmagalur,Karnataka',
'Berukodige,Chikmagalur,Karnataka',
'Bhandigadi,Chikmagalur,Karnataka',
'Bilagadde,Chikmagalur,Karnataka',
'Bomlapura,Chikmagalur,Karnataka',
'C.R.Station,Chikmagalur,Karnataka',
'Dayamballi,Chikmagalur,Karnataka',
'Devagodu,Chikmagalur,Karnataka',
'Durgadabetta,Chikmagalur,Karnataka',
'Guddethota,Chikmagalur,Karnataka',
'Gunavanthe,Chikmagalur,Karnataka',
'Halmathur,Chikmagalur,Karnataka',
'Hariharapura,Chikmagalur,Karnataka',
'Herur,Chikmagalur,Karnataka',
'Hiregadde,Chikmagalur,Karnataka',
'Hirekodige,Chikmagalur,Karnataka',
'Hosakoppa,Chikmagalur,Karnataka',
'Hosur(Koppa),Chikmagalur,Karnataka',
'Jayapura,Chikmagalur,Karnataka',
'Kachakalli,Chikmagalur,Karnataka',
'Kalkere,Chikmagalur,Karnataka',
'Kallugudde,Chikmagalur,Karnataka',
'Kammaradi,Chikmagalur,Karnataka',
'Kelakuli,Chikmagalur,Karnataka',
'Kesave,Chikmagalur,Karnataka',
'Koppa Bus Stand,Chikmagalur,Karnataka',
'Koppa H.O,Chikmagalur,Karnataka',
'Kudregundi,Chikmagalur,Karnataka',
'Kulur,Chikmagalur,Karnataka',
'Lokanathapura,Chikmagalur,Karnataka',
'Megur,Chikmagalur,Karnataka',
'Melubellare,Chikmagalur,Karnataka',
'Melukoppa,Chikmagalur,Karnataka',
'Narve,Chikmagalur,Karnataka',
'Niluvagilu,Chikmagalur,Karnataka',
'Shanthigrama,Chikmagalur,Karnataka',
'Shanuvalli,Chikmagalur,Karnataka',
'Suryadevasthana,Chikmagalur,Karnataka',
'Uttameshwara,Chikmagalur,Karnataka',
'Hesgal,Chikmagalur,Karnataka',
'Balehole,Chikmagalur,Karnataka',
'Balur,Chikmagalur,Karnataka',
'Banakal,Chikmagalur,Karnataka',
'Baskal,Chikmagalur,Karnataka',
'Bettadamane,Chikmagalur,Karnataka',
'Bettagere,Chikmagalur,Karnataka',
'Bidrehalli,Chikmagalur,Karnataka',
'Billurkadidal,Chikmagalur,Karnataka',
'Coove,Chikmagalur,Karnataka',
'Daradahalli,Chikmagalur,Karnataka',
'Devarinda,Chikmagalur,Karnataka',
'G. Hosahalli,Chikmagalur,Karnataka',
'Ganganakodige,Chikmagalur,Karnataka',
'Gonibeedu,Chikmagalur,Karnataka',
'Gowdahalli,Chikmagalur,Karnataka',
'Gubgal,Chikmagalur,Karnataka',
'Guthi,Chikmagalur,Karnataka',
'Halase,Chikmagalur,Karnataka',
'Haluvalli,Chikmagalur,Karnataka',
'Hanthur,Chikmagalur,Karnataka',
'Heggudlu,Chikmagalur,Karnataka',
'Hemmakki,Chikmagalur,Karnataka',
'Hirebyle,Chikmagalur,Karnataka',
'Horanadu,Chikmagalur,Karnataka',
'Hosahalli,Chikmagalur,Karnataka',
'Jannapura,Chikmagalur,Karnataka',
'Javali,Chikmagalur,Karnataka',
'Jogannakere,Chikmagalur,Karnataka',
'K.Kelagur,Chikmagalur,Karnataka',
'Kalasa,Chikmagalur,Karnataka',
'Kammaragodu,Chikmagalur,Karnataka',
'Kelagur(J),Chikmagalur,Karnataka',
'Kenjige,Chikmagalur,Karnataka',
'Kirugunda,Chikmagalur,Karnataka',
'Kottigehara,Chikmagalur,Karnataka',
'Kudremukh,Chikmagalur,Karnataka',
'Kundur,Chikmagalur,Karnataka',
'Makonahalli,Chikmagalur,Karnataka',
'Marasanige,Chikmagalur,Karnataka',
'Megur,Chikmagalur,Karnataka',
'Mekanagadde,Chikmagalur,Karnataka',
'Mudigere,Chikmagalur,Karnataka',
'Nandipura,Chikmagalur,Karnataka',
'Niduvale,Chikmagalur,Karnataka',
'Phalguni,Chikmagalur,Karnataka',
'Samse,Chikmagalur,Karnataka',
'Sunkasale,Chikmagalur,Karnataka',
'Thotadur,Chikmagalur,Karnataka',
'Urubage,Chikmagalur,Karnataka',
'Agrahara,Chikmagalur,Karnataka',
'B.H. Kaimara,Chikmagalur,Karnataka',
'Balehonnur,Chikmagalur,Karnataka',
'Bannur,Chikmagalur,Karnataka',
'Bellur,Chikmagalur,Karnataka',
'Bilalkoppa,Chikmagalur,Karnataka',
'Gubbiga (Sutta),Chikmagalur,Karnataka',
'Honnekodige,Chikmagalur,Karnataka',
'Kanabur,Chikmagalur,Karnataka',
'Kanur,Chikmagalur,Karnataka',
'Kattinamane,Chikmagalur,Karnataka',
'Konakere,Chikmagalur,Karnataka',
'Madabur,Chikmagalur,Karnataka',
'Magundi,Chikmagalur,Karnataka',
'Megaramakki,Chikmagalur,Karnataka',
'Melpal,Chikmagalur,Karnataka',
'Mudabagilu,Chikmagalur,Karnataka',
'Muthinakoppa,Chikmagalur,Karnataka',
'Narasimharajapura,Chikmagalur,Karnataka',
'Seethur,Chikmagalur,Karnataka',
'Shettykoppa,Chikmagalur,Karnataka',
'Darekoppa,Chikmagalur,Karnataka',
'Kerekatte,Chikmagalur,Karnataka',
'Addagadde,Chikmagalur,Karnataka',
'Begar,Chikmagalur,Karnataka',
'Gandaghatta,Chikmagalur,Karnataka',
'Halandur,Chikmagalur,Karnataka',
'Honnavalli,Chikmagalur,Karnataka',
'Kavadi,Chikmagalur,Karnataka',
'Kunchebyle,Chikmagalur,Karnataka',
'Masige,Chikmagalur,Karnataka',
'Melukoppa Begane,Chikmagalur,Karnataka',
'Nallur,Chikmagalur,Karnataka',
'Nemmar,Chikmagalur,Karnataka',
'Rushyashringapura,Chikmagalur,Karnataka',
'Sringeri,Chikmagalur,Karnataka',
'Tekkur,Chikmagalur,Karnataka',
'Thyavana,Chikmagalur,Karnataka',
'Vidyaranyapura,Chikmagalur,Karnataka',
'Hunsaghatta,Chikmagalur,Karnataka',
'Ajjampura Bazar,Chikmagalur,Karnataka',
'Ajjampura,Chikmagalur,Karnataka',
'Amruthapura,Chikmagalur,Karnataka',
'Baggavalli,Chikmagalur,Karnataka',
'Baragenahalli,Chikmagalur,Karnataka',
'Belanahalli,Chikmagalur,Karnataka',
'Bettadahalli,Chikmagalur,Karnataka',
'Bhavikere,Chikmagalur,Karnataka',
'Bukkambudhi,Chikmagalur,Karnataka',
'Cheeranahalli,Chikmagalur,Karnataka',
'Chikkanavangala,Chikmagalur,Karnataka',
'Dandur,Chikmagalur,Karnataka',
'Doddabokikere,Chikmagalur,Karnataka',
'Doranalu,Chikmagalur,Karnataka',
'Duglapura,Chikmagalur,Karnataka',
'Gadihalli,Chikmagalur,Karnataka',
'Gejjegondanahalli,Chikmagalur,Karnataka',
'Gopala,Chikmagalur,Karnataka',
'Hadikere,Chikmagalur,Karnataka',
'Halasur,Chikmagalur,Karnataka',
'Javoor,Chikmagalur,Karnataka',
'K. Chattnahalli,Chikmagalur,Karnataka',
'Kallathipura,Chikmagalur,Karnataka',
'Karakuchi,Chikmagalur,Karnataka',
'Katignere,Chikmagalur,Karnataka',
'Kudlur,Chikmagalur,Karnataka',
'Lakkavalli,Chikmagalur,Karnataka',
'Lingadahalli,Chikmagalur,Karnataka',
'Malalichennenahalli,Chikmagalur,Karnataka',
'Maruthi Extension,Chikmagalur,Karnataka',
'Mudigere,Chikmagalur,Karnataka',
'Mundre,Chikmagalur,Karnataka',
'Nandi,Chikmagalur,Karnataka',
'Nandibatlu,Chikmagalur,Karnataka',
'Neralakere,Chikmagalur,Karnataka',
'Rangenahalli,Chikmagalur,Karnataka',
'Sampigekhan,Chikmagalur,Karnataka',
'Santaveri,Chikmagalur,Karnataka',
'Shanuboganahalli,Chikmagalur,Karnataka',
'Siva R.S.,Chikmagalur,Karnataka',
'Sivane,Chikmagalur,Karnataka',
'Sokke,Chikmagalur,Karnataka',
'Sollapura,Chikmagalur,Karnataka',
'Tanigebyle,Chikmagalur,Karnataka',
'Tarikere,Chikmagalur,Karnataka',
'Tarikere Town,Chikmagalur,Karnataka',
'Thyagadakatte,Chikmagalur,Karnataka',
'Thyagarajanagar Extension,Chikmagalur,Karnataka',
'Togarihanakal,Chikmagalur,Karnataka',
'Udeva,Chikmagalur,Karnataka',
'Adanur,Chitradurga,Karnataka',
'Amruthapura,Chitradurga,Karnataka',
'Balenahalli,Chitradurga,Karnataka',
'Chikkandawadi,Chitradurga,Karnataka',
'Chikkayemmiganur,Chitradurga,Karnataka',
'Chitrahally,Chitradurga,Karnataka',
'Doddakittadahalli,Chitradurga,Karnataka',
'Echagatta,Chitradurga,Karnataka',
'Gonjiganur,Chitradurga,Karnataka',
'Hirekandawadi,Chitradurga,Karnataka',
'Hireyemmiganur,Chitradurga,Karnataka',
'Kadur,Chitradurga,Karnataka',
'Kalaghatta,Chitradurga,Karnataka',
'Kodagavalli,Chitradurga,Karnataka',
'Kolahalli,Chitradurga,Karnataka',
'Muthugadur,Chitradurga,Karnataka',
'Nahalli,Chitradurga,Karnataka',
'T.Nulenur,Chitradurga,Karnataka',
'Taralabalu Circle,Chitradurga,Karnataka',
'Tekalavatti,Chitradurga,Karnataka',
'Upparigenahalli,Chitradurga,Karnataka',
'Abbaiahnahalli,Chitradurga,Karnataka',
'Belagere,Chitradurga,Karnataka',
'Bosedevarahatti,Chitradurga,Karnataka',
'Buddanahatty,Chitradurga,Karnataka',
'Byadareddyhally,Chitradurga,Karnataka',
'Challakere Bazar,Chitradurga,Karnataka',
'Challakere,Chitradurga,Karnataka',
'Channammanagathihally,Chitradurga,Karnataka',
'Chikkammanahally,Chitradurga,Karnataka',
'Chitranaikanahalli,Chitradurga,Karnataka',
'Chowlur,Chitradurga,Karnataka',
'Doddabeeranahally,Chitradurga,Karnataka',
'Doddachelur,Chitradurga,Karnataka',
'Doddaullarthi,Chitradurga,Karnataka',
'Dodderi,Chitradurga,Karnataka',
'Donehalli,Chitradurga,Karnataka',
'Durgavara,Chitradurga,Karnataka',
'Ghataparthy,Chitradurga,Karnataka',
'Gopanahalli,Chitradurga,Karnataka',
'Gosikere,Chitradurga,Karnataka',
'Gowdagere,Chitradurga,Karnataka',
'Haravigondanahalli,Chitradurga,Karnataka',
'Hirehally,Chitradurga,Karnataka',
'Hottappanahalli,Chitradurga,Karnataka',
'Hulikunte,Chitradurga,Karnataka',
'Jajur,Chitradurga,Karnataka',
'Junjaragunte,Chitradurga,Karnataka',
'Kaparahally,Chitradurga,Karnataka',
'Karikere,Chitradurga,Karnataka',
'Katammadevarakote,Chitradurga,Karnataka',
'Kodihally,Chitradurga,Karnataka',
'Korlakunte,Chitradurga,Karnataka',
'Mallurahalli,Chitradurga,Karnataka',
'Mannekote,Chitradurga,Karnataka',
'Marikunte,Chitradurga,Karnataka',
'Meerasabihally,Chitradurga,Karnataka',
'Mustalagummi,Chitradurga,Karnataka',
'Mylanahally,Chitradurga,Karnataka',
'N.Mahadevapura,Chitradurga,Karnataka',
'Nagaramgere,Chitradurga,Karnataka',
'Nannivala,Chitradurga,Karnataka',
'Nayakanahatti,Chitradurga,Karnataka',
'Nelagathanahatti,Chitradurga,Karnataka',
'Nerlagunte,Chitradurga,Karnataka',
'Obalapura,Chitradurga,Karnataka',
'P. Mahadevapura,Chitradurga,Karnataka',
'Parasurampura,Chitradurga,Karnataka',
'Ramajogihally,Chitradurga,Karnataka',
'Renukapura,Chitradurga,Karnataka',
'Sanikere,Chitradurga,Karnataka',
'Siddeswaranadurga,Chitradurga,Karnataka',
'Somaguddu,Chitradurga,Karnataka',
'Suranahally,Chitradurga,Karnataka',
'Thallak,Chitradurga,Karnataka',
'Thimmanayakanakote,Chitradurga,Karnataka',
'Thimmappaiahnahally,Chitradurga,Karnataka',
'Thippareddyhally,Chitradurga,Karnataka',
'Valase,Chitradurga,Karnataka',
'Yadalaghatta,Chitradurga,Karnataka',
'Alagawadi,Chitradurga,Karnataka',
'Alaghatta,Chitradurga,Karnataka',
'Annehal,Chitradurga,Karnataka',
'Bangarakkanahally,Chitradurga,Karnataka',
'Basavasivanakere,Chitradurga,Karnataka',
'Belaghatta,Chitradurga,Karnataka',
'Bhahadurghatta,Chitradurga,Karnataka',
'Bharamasagara,Chitradurga,Karnataka',
'Bheemasamudra,Chitradurga,Karnataka',
'Bidarakere,Chitradurga,Karnataka',
'Bistuvalli,Chitradurga,Karnataka',
'Bommenahalli,Chitradurga,Karnataka',
'Byalahal,Chitradurga,Karnataka',
'Chikkabennur,Chitradurga,Karnataka',
'Chikkagondanahally,Chitradurga,Karnataka',
'Chikkapura,Chitradurga,Karnataka',
'Chitradurga Collegeroad,Chitradurga,Karnataka',
'Chitradurga Dist Office,Chitradurga,Karnataka',
'Chitradurga Fort,Chitradurga,Karnataka',
'Chitradurga Horapet,Chitradurga,Karnataka',
'Chitradurga Chickpet,Chitradurga,Karnataka',
'Chitradurga H.O,Chitradurga,Karnataka',
'Chowlihalli,Chitradurga,Karnataka',
'Dandinakurubarahatti,Chitradurga,Karnataka',
'Doddasiddavvanahalli,Chitradurga,Karnataka',
'Doddiganahal,Chitradurga,Karnataka',
'Dyamavvanahally,Chitradurga,Karnataka',
'Godabanahal,Chitradurga,Karnataka',
'Gonuru,Chitradurga,Karnataka',
'Guddadarangavanahally,Chitradurga,Karnataka',
'Haikal,Chitradurga,Karnataka',
'Halavadara,Chitradurga,Karnataka',
'Hampanur,Chitradurga,Karnataka',
'Hireguntanur,Chitradurga,Karnataka',
'Holalkere Road-Chitradurga,Chitradurga,Karnataka',
'Hullehal,Chitradurga,Karnataka',
'Hullur,Chitradurga,Karnataka',
'Hunsekatte,Chitradurga,Karnataka',
'Ingaladahal,Chitradurga,Karnataka',
'Isamudra,Chitradurga,Karnataka',
'Iyyanahalli,Chitradurga,Karnataka',
'J.C.R.Extension-Chitradurga,Chitradurga,Karnataka',
'Kadabanakatte,Chitradurga,Karnataka',
'Kadleguddu,Chitradurga,Karnataka',
'Kalgere,Chitradurga,Karnataka',
'Kattigehally,Chitradurga,Karnataka',
'Kogunde,Chitradurga,Karnataka',
'Kolahalu,Chitradurga,Karnataka',
'Kunabevu,Chitradurga,Karnataka',
'Kurubarahally,Chitradurga,Karnataka',
'Kurumaradikere,Chitradurga,Karnataka',
'Kyadigere,Chitradurga,Karnataka',
'Lakshmisagara,Chitradurga,Karnataka',
'Madanayakanahalli,Chitradurga,Karnataka',
'Madikerepura,Chitradurga,Karnataka',
'Matadakurabarahatty,Chitradurga,Karnataka',
'Megalahally,Chitradurga,Karnataka',
'Muddapura,Chitradurga,Karnataka',
'Palya,Chitradurga,Karnataka',
'Pandarahally,Chitradurga,Karnataka',
'Rayanahally,Chitradurga,Karnataka',
'Siddapura,Chitradurga,Karnataka',
'Sirigere,Chitradurga,Karnataka',
'Sondekola,Chitradurga,Karnataka',
'Station Road-chitradurga,Chitradurga,Karnataka',
'Tambranagara,Chitradurga,Karnataka',
'Toparamalige,Chitradurga,Karnataka',
'Toranaghatta,Chitradurga,Karnataka',
'Turuvanur,Chitradurga,Karnataka',
'Yelagodu,Chitradurga,Karnataka',
'Belagur,Chitradurga,Karnataka',
'Abbinahole,Chitradurga,Karnataka',
'Adivala,Chitradurga,Karnataka',
'Aimangala,Chitradurga,Karnataka',
'Alur,Chitradurga,Karnataka',
'Ambalagere,Chitradurga,Karnataka',
'Aranakatte,Chitradurga,Karnataka',
'Babbur Farm,Chitradurga,Karnataka',
'Beeranahally,Chitradurga,Karnataka',
'Bharampura,Chitradurga,Karnataka',
'Burujanaroppa,Chitradurga,Karnataka',
'Byadarahally,Chitradurga,Karnataka',
'Dharampura,Chitradurga,Karnataka',
'Dindavara,Chitradurga,Karnataka',
'Doddaghatta,Chitradurga,Karnataka',
'Ganaikanahally,Chitradurga,Karnataka',
'Gowdanahally,Chitradurga,Karnataka',
'Gownahally,Chitradurga,Karnataka',
'Guilal,Chitradurga,Karnataka',
'Halagaladdi,Chitradurga,Karnataka',
'Hariyabbe,Chitradurga,Karnataka',
'Harthikote,Chitradurga,Karnataka',
'Hemadala,Chitradurga,Karnataka',
'Hiremadhure,Chitradurga,Karnataka',
'Hiriyur Bazar,Chitradurga,Karnataka',
'Hiriyur Sugar Factory,Chitradurga,Karnataka',
'Hiriyur,Chitradurga,Karnataka',
'Hulithotlu,Chitradurga,Karnataka',
'Huvinahole,Chitradurga,Karnataka',
'Ikkanur,Chitradurga,Karnataka',
'Jampannaikanakote,Chitradurga,Karnataka',
'Javanagondanahally,Chitradurga,Karnataka',
'Kanajanahally,Chitradurga,Karnataka',
'Kariyala,Chitradurga,Karnataka',
'Kasavanahally,Chitradurga,Karnataka',
'Kasturirangappanahally,Chitradurga,Karnataka',
'Khandenahally,Chitradurga,Karnataka',
'Kodihally,Chitradurga,Karnataka',
'Kurubarahally,Chitradurga,Karnataka',
'Madakarinayakanakote,Chitradurga,Karnataka',
'Mallappanahally,Chitradurga,Karnataka',
'Maradihalli,Chitradurga,Karnataka',
'Maskal,Chitradurga,Karnataka',
'Metikurke,Chitradurga,Karnataka',
'Myaklurahally,Chitradurga,Karnataka',
'Palavvanahally,Chitradurga,Karnataka',
'Peelali,Chitradurga,Karnataka',
'Pitlali,Chitradurga,Karnataka',
'Ranganathapura,Chitradurga,Karnataka',
'Rangenahally,Chitradurga,Karnataka',
'Sidlaiahnakote,Chitradurga,Karnataka',
'Sondekere,Chitradurga,Karnataka',
'Sugur,Chitradurga,Karnataka',
'Suragondanahally,Chitradurga,Karnataka',
'T. Nagenahally,Chitradurga,Karnataka',
'Talavatti,Chitradurga,Karnataka',
'Uduvally,Chitradurga,Karnataka',
'Vanivilasapura,Chitradurga,Karnataka',
'Venkalgudda,Chitradurga,Karnataka',
'Yalanadu,Chitradurga,Karnataka',
'Yelladakere,Chitradurga,Karnataka',
'Yerabally,Chitradurga,Karnataka',
'Aralahalli,Chitradurga,Karnataka',
'Kurubarahally,Chitradurga,Karnataka',
'Malali,Chitradurga,Karnataka',
'Talakatta,Chitradurga,Karnataka',
'Adanur,Chitradurga,Karnataka',
'Beesanahally,Chitradurga,Karnataka',
'Chickjajur,Chitradurga,Karnataka',
'Dogganahal,Chitradurga,Karnataka',
'Dummi,Chitradurga,Karnataka',
'Gangasamudra,Chitradurga,Karnataka',
'Gilikenahalli,Chitradurga,Karnataka',
'Gowdihalli,Chitradurga,Karnataka',
'Gunderi,Chitradurga,Karnataka',
'Holalkere R.S,Chitradurga,Karnataka',
'Holalkere,Chitradurga,Karnataka',
'Kalkere,Chitradurga,Karnataka',
'Kengunte,Chitradurga,Karnataka',
'Kunigali,Chitradurga,Karnataka',
'Madderu,Chitradurga,Karnataka',
'Malenahalli,Chitradurga,Karnataka',
'Malladihalli,Chitradurga,Karnataka',
'Narayanagondanahally,Chitradurga,Karnataka',
'R. Nulenur,Chitradurga,Karnataka',
'Ramaghatta,Chitradurga,Karnataka',
'Ramagiri,Chitradurga,Karnataka',
'Rangapura,Chitradurga,Karnataka',
'Shivaganaga,Chitradurga,Karnataka',
'Shivapura,Chitradurga,Karnataka',
'Singenahally,Chitradurga,Karnataka',
'Talikatte,Chitradurga,Karnataka',
'Talya,Chitradurga,Karnataka',
'Tuppadahalli,Chitradurga,Karnataka',
'Vishwanathanahally,Chitradurga,Karnataka',
'Arundi,Shimoga,Karnataka',
'Alaghatta,Chitradurga,Karnataka',
'Annivala,Chitradurga,Karnataka',
'Arabhaghatta,Chitradurga,Karnataka',
'Aralihally,Chitradurga,Karnataka',
'Attimagge,Chitradurga,Karnataka',
'Bagur,Chitradurga,Karnataka',
'Ballalasamudra,Chitradurga,Karnataka',
'Bokikere,Chitradurga,Karnataka',
'Bukkasagara,Chitradurga,Karnataka',
'Burudekatte,Chitradurga,Karnataka',
'Kardigudda,Raichur,Karnataka',
'Kharabdinni,Raichur,Karnataka',
'Konapur Pet,Raichur,Karnataka',
'Korvi,Raichur,Karnataka',
'Kowthal,Raichur,Karnataka',
'Kurdi,Raichur,Karnataka',
'Kurkundi,Raichur,Karnataka',
'Kyadigera,Raichur,Karnataka',
'Lakkamdinni,Raichur,Karnataka',
'Machanur,Raichur,Karnataka',
'Madigera,Raichur,Karnataka',
'Madlapur,Raichur,Karnataka',
'Malladagudda,Raichur,Karnataka',
'Mallat,Raichur,Karnataka',
'Manvi,Raichur,Karnataka',
'Markam Dinni,Raichur,Karnataka',
'Mustoor,Raichur,Karnataka',
'Nagadadinni,Raichur,Karnataka',
'Nakkunda,Raichur,Karnataka',
'Nawalkal,Raichur,Karnataka',
'Neermanvi,Raichur,Karnataka',
'Pamanakalur,Raichur,Karnataka',
'Potnal,Raichur,Karnataka',
'Rabbanakal,Raichur,Karnataka',
'Rajalbanda,Raichur,Karnataka',
'Rajoli,Raichur,Karnataka',
'Sirwar,Raichur,Karnataka',
'Sunkeshwar,Raichur,Karnataka',
'Tadakal,Raichur,Karnataka',
'Toranadinni,Raichur,Karnataka',
'Watgal,Raichur,Karnataka',
'Alkur,Raichur,Karnataka',
'Arishangi,Raichur,Karnataka',
'Askihal,Raichur,Karnataka',
'Athnur,Raichur,Karnataka',
'Atkur,Raichur,Karnataka',
'Bichal,Raichur,Karnataka',
'Chandrabanda,Raichur,Karnataka',
'Channahalli,Raichur,Karnataka',
'Chicksugur,Raichur,Karnataka',
'Deosugur,Raichur,Karnataka',
'Dinni,Raichur,Karnataka',
'Dongarampur,Raichur,Karnataka',
'Ganamur,Raichur,Karnataka',
'Gandhal,Raichur,Karnataka',
'Ganjalli,Raichur,Karnataka',
'Gillesugur,Raichur,Karnataka',
'Gonal,Raichur,Karnataka',
'Gunjahalli,Raichur,Karnataka',
'Hanamapur,Raichur,Karnataka',
'Heggasanahalli,Raichur,Karnataka',
'Hembarhal,Raichur,Karnataka',
'Hirapur,Raichur,Karnataka',
'Hospet,Raichur,Karnataka',
'Idapanur,Raichur,Karnataka',
'Jagir Venkatapur,Raichur,Karnataka',
'Jegarkal,Raichur,Karnataka',
'Julumgera,Raichur,Karnataka',
'Kadlur,Raichur,Karnataka',
'Kalmala,Raichur,Karnataka',
'Kamalapur,Raichur,Karnataka',
'Katlatkur,Raichur,Karnataka',
'Korthakunda,Raichur,Karnataka',
'Kudlur,Raichur,Karnataka',
'Kuruvapur,Raichur,Karnataka',
'Lingankhan Doddi,Raichur,Karnataka',
'Maliabad,Raichur,Karnataka',
'Manjerla,Raichur,Karnataka',
'Manslapur,Raichur,Karnataka',
'Matmari,Raichur,Karnataka',
'Merchad,Raichur,Karnataka',
'Merchthal,Raichur,Karnataka',
'Mirzapur,Raichur,Karnataka',
'Mitti Malkapur,Raichur,Karnataka',
'Murhanpur,Raichur,Karnataka',
'Nelhal,Raichur,Karnataka',
'Puchaldinni,Raichur,Karnataka',
'Purtipli,Raichur,Karnataka',
'R R Station,Raichur,Karnataka',
'Raichur Golthana,Raichur,Karnataka',
'Raichur H.O,Raichur,Karnataka',
'Raichur Jawahar Nagar,Raichur,Karnataka',
'Raichur Maddipet,Raichur,Karnataka',
'Raichur Mukram Gunj,Raichur,Karnataka',
'Raichur Naya Bazar,Raichur,Karnataka',
'Raichur Nijalingappa Nagar,Raichur,Karnataka',
'Raichur Patel Road,Raichur,Karnataka',
'Raichur R.S.,Raichur,Karnataka',
'Raichur Saath Katchery,Raichur,Karnataka',
'Rampur,Raichur,Karnataka',
'Sagamkunta,Raichur,Karnataka',
'Shaktinagar,Raichur,Karnataka',
'Singanodi,Raichur,Karnataka',
'Sultanpur,Raichur,Karnataka',
'Talmari,Raichur,Karnataka',
'Turkondana,Raichur,Karnataka',
'Udamgal,Raichur,Karnataka',
'Upral,Raichur,Karnataka',
'Waddepalli,Raichur,Karnataka',
'Yadlapur,Raichur,Karnataka',
'Yapaladinni,Raichur,Karnataka',
'Yeganur,Raichur,Karnataka',
'Yeramarus Camp,Raichur,Karnataka',
'Yeramarus,Raichur,Karnataka',
'Yergera,Raichur,Karnataka',
'Alabanur,Raichur,Karnataka',
'Amarapur,Raichur,Karnataka',
'Arlihalli,Raichur,Karnataka',
'Badarli,Raichur,Karnataka',
'Balaganur,Raichur,Karnataka',
'Budiwal Camp,Raichur,Karnataka',
'C.S. Farm,Raichur,Karnataka',
'Dhadesugur,Raichur,Karnataka',
'Diddagi,Raichur,Karnataka',
'Gonwar,Raichur,Karnataka',
'Gorebal,Raichur,Karnataka',
'Gowdhan Bhavi,Raichur,Karnataka',
'Gudadur,Raichur,Karnataka',
'Gunda,Raichur,Karnataka',
'Gunjahalli,Raichur,Karnataka',
'Hampanahal,Raichur,Karnataka',
'Hanchinal Camp,Raichur,Karnataka',
'Harapur,Raichur,Karnataka',
'Hediginahal,Raichur,Karnataka',
'Hirebhergi,Raichur,Karnataka',
'Hogarnal,Raichur,Karnataka',
'Huda,Raichur,Karnataka',
'Huttigudda,Raichur,Karnataka',
'Jalihal,Raichur,Karnataka',
'Jalihal Camp,Raichur,Karnataka',
'Jawalgera,Raichur,Karnataka',
'Kalasa Hosahalli,Raichur,Karnataka',
'Kalmangi,Raichur,Karnataka',
'Kengal,Raichur,Karnataka',
'Kolbal,Raichur,Karnataka',
'Kurkunda,Raichur,Karnataka',
'Mada Sirwar,Raichur,Karnataka',
'Mallapur,Raichur,Karnataka',
'Mukkunda,Raichur,Karnataka',
'Nanjaladinni,Raichur,Karnataka',
'Pagadadinni,Raichur,Karnataka',
'R.H. Colony,Raichur,Karnataka',
'Ragalparvi,Raichur,Karnataka',
'Ramatnal,Raichur,Karnataka',
'Roudkunda,Raichur,Karnataka',
'Salgunda,Raichur,Karnataka',
'Sasalmardi Camp,Raichur,Karnataka',
'Sidrampur,Raichur,Karnataka',
'Sindhanur Bus Stand,Raichur,Karnataka',
'Sindhanur Camp,Raichur,Karnataka',
'Sindhanur,Raichur,Karnataka',
'Singapur,Raichur,Karnataka',
'Somalapur,Raichur,Karnataka',
'Tidigol,Raichur,Karnataka',
'Turvihal,Raichur,Karnataka',
'Udbal,Raichur,Karnataka',
'Umloti,Raichur,Karnataka',
'Uppal,Raichur,Karnataka',
'Uppaldoddi,Raichur,Karnataka',
'Valaballary,Raichur,Karnataka',
'Virupapur,Raichur,Karnataka',
'Yapalparvi,Raichur,Karnataka',
'Yeddaldoddi,Raichur,Karnataka',
'Abbur,Channapatna,Karnataka',
'Akkur,Channapatna,Karnataka',
'Ambadahalli,Channapatna,Karnataka',
'Aralalasandra,Channapatna,Karnataka',
'Bevur,Channapatna,Karnataka',
'Bevurmandya,Channapatna,Karnataka',
'Chakkalur,Channapatna,Karnataka',
'Chakkere,Channapatna,Karnataka',
'Channapatna Bazar,Channapatna,Karnataka',
'Channapatna H.O,Channapatna,Karnataka',
'Garakahalli,Channapatna,Karnataka',
'Govt.Silk Farm,Channapatna,Karnataka',
'Gowdagere,Channapatna,Karnataka',
'Honganur,Channapatna,Karnataka',
'Honnayakanahalli,Channapatna,Karnataka',
'Iggalur,Channapatna,Karnataka',
'Jagadapura,Channapatna,Karnataka',
'Kanva,Channapatna,Karnataka',
'Kodamballi,Channapatna,Karnataka',
'Kudlur,Channapatna,Karnataka',
'Kyasapura,Channapatna,Karnataka',
'Lalaghatta,Channapatna,Karnataka',
'Makali,Channapatna,Karnataka',
'Malur,Channapatna,Karnataka',
'Mankunda,Channapatna,Karnataka',
'Marchanhalli,Channapatna,Karnataka',
'Mogenahalli,Channapatna,Karnataka',
'Mudugere,Channapatna,Karnataka',
'Mylanayakanhalli,Channapatna,Karnataka',
'Nagavara,Channapatna,Karnataka',
'Neralur,Channapatna,Karnataka',
'Rampura,Channapatna,Karnataka',
'Shettihalli,Channapatna,Karnataka',
'Singarajipura,Channapatna,Karnataka',
'Sogala,Channapatna,Karnataka',
'Sulleri,Channapatna,Karnataka',
'Tagachagere,Channapatna,Karnataka',
'Virupakshipura,Channapatna,Karnataka',
'Yeletotadahalli,Channapatna,Karnataka',
'Sathanur,Channapatna,Karnataka',
'Achalu,Channapatna,Karnataka',
'Alahalli,Channapatna,Karnataka',
'Alanatha,Channapatna,Karnataka',
'Attihalli,Channapatna,Karnataka',
'Attikuppe,Channapatna,Karnataka',
'Banavasi,Channapatna,Karnataka',
'Bannimakodalu,Channapatna,Karnataka',
'Bijjahalli,Channapatna,Karnataka',
'Cheelur,Channapatna,Karnataka',
'Chikkalahalli,Channapatna,Karnataka',
'Chikkamuduvadi,Channapatna,Karnataka',
'Doddakabballi,Channapatna,Karnataka',
'Ganalu,Channapatna,Karnataka',
'Girenahalli,Channapatna,Karnataka',
'Gollahalli,Channapatna,Karnataka',
'Gottigehalli,Channapatna,Karnataka',
'Guttalahunase,Channapatna,Karnataka',
'H.Kothanuru,Channapatna,Karnataka',
'Hanchaguli,Channapatna,Karnataka',
'Harobele,Channapatna,Karnataka',
'Harohalli,Channapatna,Karnataka',
'Helagahalli,Channapatna,Karnataka',
'Herandyappanahalli,Channapatna,Karnataka',
'Honniganahalli,Channapatna,Karnataka',
'Horalagallu,Channapatna,Karnataka',
'Hosadurga,Channapatna,Karnataka',
'Hunasanahalli,Channapatna,Karnataka',
'Hunkunda,Channapatna,Karnataka',
'Jakkasandra,Channapatna,Karnataka',
'Kabbal,Channapatna,Karnataka',
'Kadahalli,Channapatna,Karnataka',
'Kaggala Halli,Channapatna,Karnataka',
'Kallahalli,Channapatna,Karnataka',
'Kallanakupppe,Channapatna,Karnataka',
'Kanakapura Bazar,Channapatna,Karnataka',
'Kanakapura,Channapatna,Karnataka',
'Karikaldoddi,Channapatna,Karnataka',
'Kodihalli,Channapatna,Karnataka',
'Kolagondanahalli,Channapatna,Karnataka',
'Kolliganahalli,Channapatna,Karnataka',
'Kottagalu,Channapatna,Karnataka',
'Kurupet,Channapatna,Karnataka',
'Malgal,Channapatna,Karnataka',
'Mallligemetlu,Channapatna,Karnataka',
'Maralavadi,Channapatna,Karnataka',
'Marale,Channapatna,Karnataka',
'Marlebekuppe,Channapatna,Karnataka',
'Medamaranahalli,Channapatna,Karnataka',
'Narayanapura,Channapatna,Karnataka',
'Shivanahalli,Channapatna,Karnataka',
'T.Hosahalli,Channapatna,Karnataka',
'Tattekere,Channapatna,Karnataka',
'Terubeedi,Channapatna,Karnataka',
'Torebekuppe,Channapatna,Karnataka',
'Tungani,Channapatna,Karnataka',
'Venkatarayanadoddi,Channapatna,Karnataka',
'Yadamaranahalli,Channapatna,Karnataka',
'Agalakote,Channapatna,Karnataka',
'Attimagere,Channapatna,Karnataka',
'Bachenahatti,Channapatna,Karnataka',
'Bilagumba,Channapatna,Karnataka',
'Chakarabhavi,Channapatna,Karnataka',
'Chamarajasagara,Channapatna,Karnataka',
'Gejjagaragupppe,Channapatna,Karnataka',
'Harathi,Channapatna,Karnataka',
'Kalari,Channapatna,Karnataka',
'Kalludevanahalli,Channapatna,Karnataka',
'Kalya,Channapatna,Karnataka',
'Karlamangala,Channapatna,Karnataka',
'Kempasagara,Channapatna,Karnataka',
'Lakshmipura,Channapatna,Karnataka',
'Madabal,Channapatna,Karnataka',
'Magadi,Channapatna,Karnataka',
'Mathikere,Channapatna,Karnataka',
'Sathanur,Channapatna,Karnataka',
'Savandurga,Channapatna,Karnataka',
'Thaggikuppe,Channapatna,Karnataka',
'Thimmasandra,Channapatna,Karnataka',
'Veeregowdanadoddi,Channapatna,Karnataka',
'Kanchugaranahalli,Channapatna,Karnataka',
'Akkur,Channapatna,Karnataka',
'Ankanahalli,Channapatna,Karnataka',
'Averahalli,Channapatna,Karnataka',
'Bidadi,Channapatna,Karnataka',
'Doddagangawadi,Channapatna,Karnataka',
'Hagalahalli,Channapatna,Karnataka',
'Ijoor Ramangaram,Channapatna,Karnataka',
'Jalamangala,Channapatna,Karnataka',
'Kailancha,Channapatna,Karnataka',
'Krishnapuradoddi,Channapatna,Karnataka',
'Kutgal,Channapatna,Karnataka',
'Lakkojanahalli,Channapatna,Karnataka',
'Mayaganahalli,Channapatna,Karnataka',
'Ramanagara,Channapatna,Karnataka',
'Shanumangala,Channapatna,Karnataka',
'Sugganahalli,Channapatna,Karnataka',
'Uragapura,Channapatna,Karnataka',
'Yerehalli,Channapatna,Karnataka',
'Anjanapura,Channapatna,Karnataka',
'Bannikuppe,Channapatna,Karnataka',
'Bilagumba,Channapatna,Karnataka',
'Byramangala,Channapatna,Karnataka',
'Ganakal,Channapatna,Karnataka',
'Hejjala,Channapatna,Karnataka',
'Hosur,Channapatna,Karnataka',
'Ittmadu,Channapatna,Karnataka',
'K.Karenahalli,Channapatna,Karnataka',
'Manchanayakanahalli,Channapatna,Karnataka',
'Manchegowdanapalya,Channapatna,Karnataka',
'Harisandra,Channapatna,Karnataka',
'Manchanabele,Channapatna,Karnataka',
'Mandli,Shimoga,Karnataka',
'New Hutha Ndt,Shimoga,Karnataka',
'Sunnadahalli,Shimoga,Karnataka',
'Agaradahalli,Shimoga,Karnataka',
'Anaveri,Shimoga,Karnataka',
'Antharagange,Shimoga,Karnataka',
'Arabilichi,Shimoga,Karnataka',
'Arakere,Shimoga,Karnataka',
'Aralihalli,Shimoga,Karnataka',
'Arhatolalu,Shimoga,Karnataka',
'Barandur,Shimoga,Karnataka',
'Bhadra Colony,Shimoga,Karnataka',
'Bhadra Reservoir Project,Shimoga,Karnataka',
'Bhadravathi Hudco Colony,Shimoga,Karnataka',
'Bhadravathi Hutha Colony,Shimoga,Karnataka',
'Bhadravathi Jannapura,Shimoga,Karnataka',
'Bhadravathi New Model Colony,Shimoga,Karnataka',
'Bhadravathi Old Town,Shimoga,Karnataka',
'Bhadravathi Paper Town,Shimoga,Karnataka',
'Bhadravathi Railway Stn,Shimoga,Karnataka',
'Dasarakallahalli,Shimoga,Karnataka',
'Devarahalli,Shimoga,Karnataka',
'Doddagoppenahalli,Shimoga,Karnataka',
'Donabaghatta,Shimoga,Karnataka',
'Gangur,Shimoga,Karnataka',
'Gonibeedu,Shimoga,Karnataka',
'Hiriyur,Shimoga,Karnataka',
'Holehonner,Shimoga,Karnataka',
'Hunasakatte Junction,Shimoga,Karnataka',
'J.P.S.Colony,Shimoga,Karnataka',
'Kallihal,Shimoga,Karnataka',
'Kambadahal Hosur,Shimoga,Karnataka',
'Kawalgundi,Shimoga,Karnataka',
'Kudligere,Shimoga,Karnataka',
'KVV Shankaraghattta,Shimoga,Karnataka',
'Mavinakere,Shimoga,Karnataka',
'Mydolalau,Shimoga,Karnataka',
'Sanyasikodamaggi,Shimoga,Karnataka',
'Siddapura,Shimoga,Karnataka',
'Sidlipura,Shimoga,Karnataka',
'Siriyur,Shimoga,Karnataka',
'Sydarakallahalli,Shimoga,Karnataka',
'Thallikatte,Shimoga,Karnataka',
'Yedehalli,Shimoga,Karnataka',
'Bandigudda,Shimoga,Karnataka',
'Bhadravati H.O,Shimoga,Karnataka',
'Kanivebilichi,Shimoga,Karnataka',
'Arasalu,Shimoga,Karnataka',
'Bellur(Hosanagar),Shimoga,Karnataka',
'Bheemanakere,Shimoga,Karnataka',
'Bidarehalli,Shimoga,Karnataka',
'Halugadde,Shimoga,Karnataka',
'Haniya,Shimoga,Karnataka',
'Harathalu,Shimoga,Karnataka',
'Harohithlu,Shimoga,Karnataka',
'Hebbige,Shimoga,Karnataka',
'Heddaripura,Shimoga,Karnataka',
'Hosanagar,Shimoga,Karnataka',
'Hulikal,Shimoga,Karnataka',
'Humcha,Shimoga,Karnataka',
'K.B.Circle,Shimoga,Karnataka',
'Kadasur,Shimoga,Karnataka',
'Kammachi,Shimoga,Karnataka',
'Kenchanala,Shimoga,Karnataka',
'Koduru,Shimoga,Karnataka',
'Kotethariga,Shimoga,Karnataka',
'Malali,Shimoga,Karnataka',
'Masthikatte,Shimoga,Karnataka',
'Mathikai,Shimoga,Karnataka',
'Mathimane,Shimoga,Karnataka',
'Melinabesige,Shimoga,Karnataka',
'Mumbar,Shimoga,Karnataka',
'Nagarakodige,Shimoga,Karnataka',
'Nagara-shimoga,Shimoga,Karnataka',
'Nagodi,Shimoga,Karnataka',
'Nilskal,Shimoga,Karnataka',
'Nittur,Shimoga,Karnataka',
'Purappemane,Shimoga,Karnataka',
'Ripponpet,Shimoga,Karnataka',
'Ryave,Shimoga,Karnataka',
'Sonale,Shimoga,Karnataka',
'Talale,Shimoga,Karnataka',
'Yedur,Shimoga,Karnataka',
'Achapura,Shimoga,Karnataka',
'Ambaragodlu,Shimoga,Karnataka',
'Anandapuram,Shimoga,Karnataka',
'Apmc Yard-sagar,Shimoga,Karnataka',
'Aralagodu,Shimoga,Karnataka',
'Avinahalli,Shimoga,Karnataka',
'Barur,Shimoga,Karnataka',
'Belur(Sagar),Shimoga,Karnataka',
'Bhanukuli,Shimoga,Karnataka',
'Bheemanakone,Shimoga,Karnataka',
'Brahmanakappige,Shimoga,Karnataka',
'Brahmanamanchale,Shimoga,Karnataka',
'Byacodu,Shimoga,Karnataka',
'Chadaravalli,Shimoga,Karnataka',
'Gandinagar-sagar,Shimoga,Karnataka',
'Genasinakuni,Shimoga,Karnataka',
'Gilalagundi,Shimoga,Karnataka',
'Gouthmapura,Shimoga,Karnataka',
'Hamsagaru,Shimoga,Karnataka',
'Haridravathi,Shimoga,Karnataka',
'Hebbarige,Shimoga,Karnataka',
'Hiremane,Shimoga,Karnataka',
'Hirenallur,Shimoga,Karnataka',
'Honnesara,Shimoga,Karnataka',
'Hosur-anandapuram,Shimoga,Karnataka',
'Hulidevarabana,Shimoga,Karnataka',
'Iduvani,Shimoga,Karnataka',
'Jog Falls,Shimoga,Karnataka',
'Jog Falls View,Shimoga,Karnataka',
'Kagodu,Shimoga,Karnataka',
'Kalmane(Sagar),Shimoga,Karnataka',
'Kanle,Shimoga,Karnataka',
'Kargal Colony,Shimoga,Karnataka',
'Keladi,Shimoga,Karnataka',
'Khandika,Shimoga,Karnataka',
'Kogar,Shimoga,Karnataka',
'Kugve,Shimoga,Karnataka',
'Linganamakki,Shimoga,Karnataka',
'Madasurlingadahalli,Shimoga,Karnataka',
'Maluru,Shimoga,Karnataka',
'Malve,Shimoga,Karnataka',
'Marathur,Shimoga,Karnataka',
'Maruthipura,Shimoga,Karnataka',
'Masur(Sagar),Shimoga,Karnataka',
'Melinasampalli,Shimoga,Karnataka',
'Nagavalli,Shimoga,Karnataka',
'Nanditale,Shimoga,Karnataka',
'Neechadi,Shimoga,Karnataka',
'Padavagodu,Shimoga,Karnataka',
'S.V.P.Colony,Shimoga,Karnataka',
'Sagar Bazar,Shimoga,Karnataka',
'Sagar H.O,Shimoga,Karnataka',
'Sagar Market Road,Shimoga,Karnataka',
'Sasaravalli,Shimoga,Karnataka',
'Shiravanthe,Shimoga,Karnataka',
'Sullali,Shimoga,Karnataka',
'Suntikoppa,Shimoga,Karnataka',
'Syduru,Shimoga,Karnataka',
'Tadagalale,Shimoga,Karnataka',
'Talaguppa,Shimoga,Karnataka',
'Talavata,Shimoga,Karnataka',
'Thagarthi,Shimoga,Karnataka',
'Tumary,Shimoga,Karnataka',
'Ullur,Shimoga,Karnataka',
'Varadamoola,Shimoga,Karnataka',
'Yedjigalamane,Shimoga,Karnataka',
'Banashankari Extension,Shimoga,Karnataka',
'Issur,Shimoga,Karnataka',
'Amatekoppa,Shimoga,Karnataka',
'Baganakatte,Shimoga,Karnataka',
'Begur(Shikaripur),Shimoga,Karnataka',
'Bhadrapura,Shimoga,Karnataka',
'Chikjambur,Shimoga,Karnataka',
'Gulladahalli,Shimoga,Karnataka',
'Hirejambur,Shimoga,Karnataka',
'Hosagodnakoppa,Shimoga,Karnataka',
'Hosur(Shikaaripur),Shimoga,Karnataka',
'Kadenandihalli,Shimoga,Karnataka',
'Kagenahalli,Shimoga,Karnataka',
'Kappanahalli,Shimoga,Karnataka',
'Kittadahalli,Shimoga,Karnataka',
'Kortikere,Shimoga,Karnataka',
'Kuskur,Shimoga,Karnataka',
'Malur,Shimoga,Karnataka',
'Manchikoppa,Shimoga,Karnataka',
'Maravalli,Shimoga,Karnataka',
'Mattikote,Shimoga,Karnataka',
'Muddanahalli,Shimoga,Karnataka',
'Nelavagilu,Shimoga,Karnataka',
'Sanda,Shimoga,Karnataka',
'Sunnadakoppa,Shimoga,Karnataka',
'Tadasanahalli,Shimoga,Karnataka',
'Yelagere,Shimoga,Karnataka',
'Agraharamuchadi,Shimoga,Karnataka',
'Ambaragoppa,Shimoga,Karnataka',
'Ambligola,Shimoga,Karnataka',
'Anjanapura,Shimoga,Karnataka',
'Arasinagere,Shimoga,Karnataka',
'Belagavi,Shimoga,Karnataka',
'Biliki,Shimoga,Karnataka',
'Chikjogihalli,Shimoga,Karnataka',
'Churchugundi,Shimoga,Karnataka',
'Gama,Shimoga,Karnataka',
'Harige,Shimoga,Karnataka',
'Harogoppa,Shimoga,Karnataka',
'Hithla,Shimoga,Karnataka',
'Kalmane,Shimoga,Karnataka',
'Kolagi,Shimoga,Karnataka',
'Mallenahalli,Shimoga,Karnataka',
'Narasapura,Shimoga,Karnataka',
'Salur,Shimoga,Karnataka',
'Shikaripur,Shimoga,Karnataka',
'Shikaripura Bazar,Shimoga,Karnataka',
'Shiralakoppa,Shimoga,Karnataka',
'Suragihalli,Shimoga,Karnataka',
'Talagunda,Shimoga,Karnataka',
'Togarsi,Shimoga,Karnataka',
'Abbalagere,Shimoga,Karnataka',
'Ayanur,Shimoga,Karnataka',
'B.Beeranahalli,Shimoga,Karnataka',
'Balekoppa,Shimoga,Karnataka',
'Bidare,Shimoga,Karnataka',
'Bullapura,Shimoga,Karnataka',
'Byranakoppa,Shimoga,Karnataka',
'Chordi,Shimoga,Karnataka',
'Gajanur,Shimoga,Karnataka',
'Garden Area Shimoga,Shimoga,Karnataka',
'Gondichatnahalli,Shimoga,Karnataka',
'Hadonahalli,Shimoga,Karnataka',
'Haihole,Shimoga,Karnataka',
'Hansawadi,Shimoga,Karnataka',
'Haramaghatta,Shimoga,Karnataka',
'Harnahalli,Shimoga,Karnataka',
'Holalur,Shimoga,Karnataka',
'Holebenavalli,Shimoga,Karnataka',
'Hosahalli,Shimoga,Karnataka',
'Hosudi,Shimoga,Karnataka',
'Jayanagar Nd,Shimoga,Karnataka',
'Kachinakatte,Shimoga,Karnataka',
'Kadekal,Shimoga,Karnataka',
'Kommanahalu,Shimoga,Karnataka',
'Kongavalli,Shimoga,Karnataka',
'Kote Gangur,Shimoga,Karnataka',
'Krishnarajendrapete-shimoga,Shimoga,Karnataka',
'Kumsi,Shimoga,Karnataka',
'Kunchenahalli,Shimoga,Karnataka',
'Madakechilur,Shimoga,Karnataka',
'Malavagoppa,Shimoga,Karnataka',
'Mandaghatta,Shimoga,Karnataka',
'Marketyard APMC-Shimoga,Shimoga,Karnataka',
'Mathur,Shimoga,Karnataka',
'Navile,Shimoga,Karnataka',
'Nidige,Shimoga,Karnataka',
'Pillanagere,Shimoga,Karnataka',
'Puradalu,Shimoga,Karnataka',
'Ravindranagr-shimoga,Shimoga,Karnataka',
'Santhekadur,Shimoga,Karnataka',
'Settihalli,Shimoga,Karnataka',
'Sheshadripuram Extn,Shimoga,Karnataka',
'Shimoga Ambedkarnagar,Shimoga,Karnataka',
'Shimoga District Office,Shimoga,Karnataka',
'Shimoga Doddapete,Shimoga,Karnataka',
'Shimoga H.O,Shimoga,Karnataka',
'Shimoga Kote,Shimoga,Karnataka',
'Shimoga Market,Shimoga,Karnataka',
'Shimoga Railway Station,Shimoga,Karnataka',
'Sirigere,Shimoga,Karnataka',
'Sogane,Shimoga,Karnataka',
'Suguru,Shimoga,Karnataka',
'Thuppur,Shimoga,Karnataka',
'Umblebylu,Shimoga,Karnataka',
'Urgadur,Shimoga,Karnataka',
'Veerannana Benavalli,Shimoga,Karnataka',
'Vidyanagar Shimoga,Shimoga,Karnataka',
'Vinobanagar Shimoga,Shimoga,Karnataka',
'Kudli,Shimoga,Karnataka',
'Anavatti,Shimoga,Karnataka',
'B.Dodderi,Shimoga,Karnataka',
'Bennur,Shimoga,Karnataka',
'Bilavani,Shimoga,Karnataka',
'Chandragutti,Shimoga,Karnataka',
'Dyavanahalli,Shimoga,Karnataka',
'Gendla,Shimoga,Karnataka',
'Gudavi,Shimoga,Karnataka',
'Halagalale,Shimoga,Karnataka',
'Halesorab,Shimoga,Karnataka',
'Harishi,Shimoga,Karnataka',
'Heche,Shimoga,Karnataka',
'Hirekasavi,Shimoga,Karnataka',
'Hosabale,Shimoga,Karnataka',
'Kerehalli,Shimoga,Karnataka',
'Kodakani,Shimoga,Karnataka',
'Kuppagadde,Shimoga,Karnataka',
'Malalagadde,Shimoga,Karnataka',
'Mallapura(Sorab),Shimoga,Karnataka',
'Mavali,Shimoga,Karnataka',
'Mutugoppe,Shimoga,Karnataka',
'Nisrani,Shimoga,Karnataka',
'Sakunavalli,Shimoga,Karnataka',
'Shigga,Shimoga,Karnataka',
'Sorab,Shimoga,Karnataka',
'Tattur,Shimoga,Karnataka',
'Tavanandi,Shimoga,Karnataka',
'Telagunda,Shimoga,Karnataka',
'Udri,Shimoga,Karnataka',
'Udugani,Shimoga,Karnataka',
'Ulavi,Shimoga,Karnataka',
'Agasanahalli,Shimoga,Karnataka',
'Bharangi,Shimoga,Karnataka',
'Huruli,Shimoga,Karnataka',
'Jade,Shimoga,Karnataka',
'Kubatur,Shimoga,Karnataka',
'Moody,Shimoga,Karnataka',
'Muguru,Shimoga,Karnataka',
'Samanavalli,Shimoga,Karnataka',
'Sorab Town,Shimoga,Karnataka',
'Talagadde,Shimoga,Karnataka',
'Tallur,Shimoga,Karnataka',
'Yennekoppa,Shimoga,Karnataka',
'Aralapura,Shimoga,Karnataka',
'Aralasurali,Shimoga,Karnataka',
'Arga,Shimoga,Karnataka',
'Basavani,Shimoga,Karnataka',
'Beguvalli,Shimoga,Karnataka',
'Bejjavalli,Shimoga,Karnataka',
'Bharathipura,Shimoga,Karnataka',
'Chakkodabylu,Shimoga,Karnataka',
'Demlapura,Shimoga,Karnataka',
'Devangi,Shimoga,Karnataka',
'Dooravasapura,Shimoga,Karnataka',
'Guddekoppa,Shimoga,Karnataka',
'Guthi Yedehalli,Shimoga,Karnataka',
'Hadigallu,Shimoga,Karnataka',
'Halaga,Shimoga,Karnataka',
'Hanagere,Shimoga,Karnataka',
'Harogulige,Shimoga,Karnataka',
'Heddur,Shimoga,Karnataka',
'Heggodu,Shimoga,Karnataka',
'Hosa Agrahara,Shimoga,Karnataka',
'Humchadakatte,Shimoga,Karnataka',
'Huruli,Shimoga,Karnataka',
'Kadathur,Shimoga,Karnataka',
'Kannangi,Shimoga,Karnataka',
'Karunapura,Shimoga,Karnataka',
'Kattehakklu,Shimoga,Karnataka',
'Keshavapura,Shimoga,Karnataka',
'Konandur,Shimoga,Karnataka',
'Kudumallige,Shimoga,Karnataka',
'Kuduvalli,Shimoga,Karnataka',
'Kukke,Shimoga,Karnataka',
'Kuruvalli Ndt,Shimoga,Karnataka',
'Mahishi,Shimoga,Karnataka',
'Makkimane,Shimoga,Karnataka',
'Malalur,Shimoga,Karnataka',
'Malur,Shimoga,Karnataka',
'Mandagadde,Shimoga,Karnataka',
'Megaravalli,Shimoga,Karnataka',
'Melige,Shimoga,Karnataka',
'Muniyur,Shimoga,Karnataka',
'Nalur,Shimoga,Karnataka',
'Nonabur,Shimoga,Karnataka',
'Salur(Thirthahalli),Shimoga,Karnataka',
'Saru,Shimoga,Karnataka',
'Seebinakere,Shimoga,Karnataka',
'Shedgaru,Shimoga,Karnataka',
'Sindhuvadi,Shimoga,Karnataka',
'Singanabidre,Shimoga,Karnataka',
'Sirur,Shimoga,Karnataka',
'Thenginakoppa,Shimoga,Karnataka',
'Thirthahalli,Shimoga,Karnataka',
'Thirthahalli Town,Shimoga,Karnataka',
'Thirthamathur,Shimoga,Karnataka',
'Tudur,Shimoga,Karnataka',
'Untoorkatte,Shimoga,Karnataka',
'Sankadahole,Shimoga,Karnataka',
'Agumbe,Shimoga,Karnataka',
'Guddekere,Shimoga,Karnataka',
'Hosagadde,Shimoga,Karnataka',
'Kawrihaklu,Shimoga,Karnataka',
'Kendalbailu,Shimoga,Karnataka',
'Malligehally,Tumkur,Karnataka',
'Chikkanayakana Halli,Tumkur,Karnataka',
'Kandikere,Tumkur,Karnataka',
'Settikere,Tumkur,Karnataka',
'Huliyar,Tumkur,Karnataka',
'Barakanalu,Tumkur,Karnataka',
'Belaguli,Tumkur,Karnataka',
'Bellara,Tumkur,Karnataka',
'Chikkabidare,Tumkur,Karnataka',
'Dabbegunte,Tumkur,Karnataka',
'Dasudi,Tumkur,Karnataka',
'Doddayennegere,Tumkur,Karnataka',
'Ganadhal,Tumkur,Karnataka',
'Godekere,Tumkur,Karnataka',
'Hoisalakatte,Tumkur,Karnataka',
'Jayachamarajapura,Tumkur,Karnataka',
'Kengalapura,Tumkur,Karnataka',
'Kenkere,Tumkur,Karnataka',
'Mathighatta,Tumkur,Karnataka',
'Muddenahalli,Tumkur,Karnataka',
'Naduvanahalli,Tumkur,Karnataka',
'Niruvagal,Tumkur,Karnataka',
'Puradakatte,Tumkur,Karnataka',
'Ramanahalli,Tumkur,Karnataka',
'Sadarahalli,Tumkur,Karnataka',
'Sasalu,Tumkur,Karnataka',
'Thammadihalli,Tumkur,Karnataka',
'Thimmanahalli,Tumkur,Karnataka',
'Thirthapura,Tumkur,Karnataka',
'Yelanadu,Tumkur,Karnataka',
'Baragihally,Tumkur,Karnataka',
'Baragur,Tumkur,Karnataka',
'Chowlakatte,Tumkur,Karnataka',
'Dugudihalli,Tumkur,Karnataka',
'Handanakere,Tumkur,Karnataka',
'Honnebagi,Tumkur,Karnataka',
'Kuppur,Tumkur,Karnataka',
'Navile,Tumkur,Karnataka',
'Northeren Extension,Tumkur,Karnataka',
'Soralamavu,Tumkur,Karnataka',
'Thirumalapura,Tumkur,Karnataka',
'Barasidlahalli,Tumkur,Karnataka',
'Adagur,Tumkur,Karnataka',
'Ajjenahalli,Tumkur,Karnataka',
'Alalaghatta,Tumkur,Karnataka',
'Ammanaghatta,Tumkur,Karnataka',
'Ammasandra,Tumkur,Karnataka',
'Anekere,Tumkur,Karnataka',
'Ankalakoppa,Tumkur,Karnataka',
'Ankasandra,Tumkur,Karnataka',
'Aralaguppe,Tumkur,Karnataka',
'Attikatte,Tumkur,Karnataka',
'Bandihalli,Tumkur,Karnataka',
'Beechanahalli,Tumkur,Karnataka',
'Belavatha,Tumkur,Karnataka',
'Bettadahalli,Tumkur,Karnataka',
'Bidare,Tumkur,Karnataka',
'Bittagondanahalli,Tumkur,Karnataka',
'Byadagere,Tumkur,Karnataka',
'C. Nandihalli,Tumkur,Karnataka',
'C.Kodigenahalli,Tumkur,Karnataka',
'Chandrashekarapura,Tumkur,Karnataka',
'Chelur,Tumkur,Karnataka',
'Chengavi,Tumkur,Karnataka',
'Chidambarashrama,Tumkur,Karnataka',
'Chikkonahally,Tumkur,Karnataka',
'Doddagoraghatta,Tumkur,Karnataka',
'Doddaguni,Tumkur,Karnataka',
'Doddakunnala,Tumkur,Karnataka',
'Galaga,Tumkur,Karnataka',
'Galigekere,Tumkur,Karnataka',
'Gopalapura,Tumkur,Karnataka',
'Gowripur,Tumkur,Karnataka',
'Gubbi Bazar,Tumkur,Karnataka',
'Gubbi Bazar,Tumkur,Karnataka',
'Gubbi Hosahalli,Tumkur,Karnataka',
'Gubbi,Tumkur,Karnataka',
'Hadalagere,Tumkur,Karnataka',
'Hadavanahalli,Tumkur,Karnataka',
'Hagalawadi,Tumkur,Karnataka',
'Handanahalli,Tumkur,Karnataka',
'Haradagere,Tumkur,Karnataka',
'Herur,Tumkur,Karnataka',
'Hindiskere,Tumkur,Karnataka',
'Hodalur,Tumkur,Karnataka',
'Hosakere,Tumkur,Karnataka',
'Idagur,Tumkur,Karnataka',
'Irkasandra,Tumkur,Karnataka',
'K.Kallahalli,Tumkur,Karnataka',
'K.Mathighatta,Tumkur,Karnataka',
'Kadaba,Tumkur,Karnataka',
'Kallur,Tumkur,Karnataka',
'Kodiyala,Tumkur,Karnataka',
'Kondli,Tumkur,Karnataka',
'Koppa,Tumkur,Karnataka',
'Kunikenahalli,Tumkur,Karnataka',
'Lakkenahalli,Tumkur,Karnataka',
'Madapura,Tumkur,Karnataka',
'Madenahalli,Tumkur,Karnataka',
'Madenahalli,Tumkur,Karnataka',
'Manchaladore,Tumkur,Karnataka',
'Marasettihalli,Tumkur,Karnataka',
'Mavinahalli,Tumkur,Karnataka',
'Mooganayakana Kote,Tumkur,Karnataka',
'Mukanahallipatna,Tumkur,Karnataka',
'N.Hosahalli,Tumkur,Karnataka',
'N.Mathighatta,Tumkur,Karnataka',
'Nagasandra-gubbi,Tumkur,Karnataka',
'Naranahalli,Tumkur,Karnataka',
'Neeragunda,Tumkur,Karnataka',
'Nittur,Tumkur,Karnataka',
'Prabhuvanahalli,Tumkur,Karnataka',
'S.Kodigehalli,Tumkur,Karnataka',
'Samige Road Railway Station.,Tumkur,Karnataka',
'Sampige,Tumkur,Karnataka',
'Sampige-hosahalli,Tumkur,Karnataka',
'Sathenahalli,Tumkur,Karnataka',
'Seegehalli,Tumkur,Karnataka',
'Shivapura,Tumkur,Karnataka',
'Singonahalli,Tumkur,Karnataka',
'Somalapura,Tumkur,Karnataka',
'Talavaranahalli,Tumkur,Karnataka',
'Talekoppa,Tumkur,Karnataka',
'Thoremavinahalli,Tumkur,Karnataka',
'Thuilahalli,Tumkur,Karnataka',
'Thyagatur,Tumkur,Karnataka',
'Tippur,Tumkur,Karnataka',
'Vajrapura Colony,Tumkur,Karnataka',
'A.Venkatapura,Tumkur,Karnataka',
'Agrahara,Tumkur,Karnataka',
'Arasapura,Tumkur,Karnataka',
'Bommaladevipura,Tumkur,Karnataka',
'Chikkanahalli,Tumkur,Karnataka',
'Dasarahally,Tumkur,Karnataka',
'Doddasaggere,Tumkur,Karnataka',
'Gokula Extn Koratagere,Tumkur,Karnataka',
'Hanchihalli,Tumkur,Karnataka',
'Holavanahalli,Tumkur,Karnataka',
'Hulikunte,Tumkur,Karnataka',
'Irakasandra,Tumkur,Karnataka',
'Kodlahalli,Tumkur,Karnataka',
'Koratagere,Tumkur,Karnataka',
'Kyshavara,Tumkur,Karnataka',
'Mallekavu,Tumkur,Karnataka',
'Mavathur,Tumkur,Karnataka',
'Pathaganahalli,Tumkur,Karnataka',
'Rampura,Tumkur,Karnataka',
'Sompura,Tumkur,Karnataka',
'Theetha,Tumkur,Karnataka',
'Thogarighatta,Tumkur,Karnataka',
'Tumbadi,Tumkur,Karnataka',
'Vaddagere,Tumkur,Karnataka',
'Vajjanakurke,Tumkur,Karnataka',
'Yelerampura,Tumkur,Karnataka',
'Bukkapatna,Tumkur,Karnataka',
'Amruthur,Tumkur,Karnataka',
'Arakere,Tumkur,Karnataka',
'Bandihalli,Tumkur,Karnataka',
'Begur,Tumkur,Karnataka',
'Bettahalli,Tumkur,Karnataka',
'Bettahallimutt,Tumkur,Karnataka',
'Bhaktharahalli,Tumkur,Karnataka',
'Bidanagere,Tumkur,Karnataka',
'Bilidevalaya,Tumkur,Karnataka',
'Chowdanakuppe,Tumkur,Karnataka',
'Dawoodsab Palya,Tumkur,Karnataka',
'Doddamadure,Tumkur,Karnataka',
'Doddamavathuru,Tumkur,Karnataka',
'Gowdagere,Tumkur,Karnataka',
'Gunnagere,Tumkur,Karnataka',
'Halagere,Tumkur,Karnataka',
'Halevoor,Tumkur,Karnataka',
'Herur,Tumkur,Karnataka',
'Holalagunda,Tumkur,Karnataka',
'Hosahalli,Tumkur,Karnataka',
'Hosakere,Tumkur,Karnataka',
'Huliyur Durga,Tumkur,Karnataka',
'Huthri,Tumkur,Karnataka',
'Ippadi,Tumkur,Karnataka',
'Jiddagere,Tumkur,Karnataka',
'Jinnagara,Tumkur,Karnataka',
'K R S Agrahara Kunigan,Tumkur,Karnataka',
'K.Honnamachanahalli,Tumkur,Karnataka',
'K.R.S.Agrahara,Tumkur,Karnataka',
'Kadasettihalli,Tumkur,Karnataka',
'Kaggere,Tumkur,Karnataka',
'Katrighatta,Tumkur,Karnataka',
'Kempanahalli,Tumkur,Karnataka',
'Kenchanahalli,Tumkur,Karnataka',
'Kilara,Tumkur,Karnataka',
'Kithanagamangala,Tumkur,Karnataka',
'Kodavathi,Tumkur,Karnataka',
'Koppa,Tumkur,Karnataka',
'Kothagere,Tumkur,Karnataka',
'Kunigal,Tumkur,Karnataka',
'Madikehalli,Tumkur,Karnataka',
'Markonahalli,Tumkur,Karnataka',
'Modur,Tumkur,Karnataka',
'Nadumavinapura,Tumkur,Karnataka',
'Nagasandra,Tumkur,Karnataka',
'Nidasale,Tumkur,Karnataka',
'P.Honnamchenahalli,Tumkur,Karnataka',
'Paduvagere,Tumkur,Karnataka',
'R.Bydarahalli,Tumkur,Karnataka',
'Ragihally,Tumkur,Karnataka',
'Sanaba,Tumkur,Karnataka',
'Santhmavathur,Tumkur,Karnataka',
'Seenappanahalli,Tumkur,Karnataka',
'Sondalagere,Tumkur,Karnataka',
'Tarikere,Tumkur,Karnataka',
'Tavarekere,Tumkur,Karnataka',
'Thippur,Tumkur,Karnataka',
'Turuganur,Tumkur,Karnataka',
'Tuvekere,Tumkur,Karnataka',
'Ujjini,Tumkur,Karnataka',
'Volagerepura,Tumkur,Karnataka',
'Yadavane,Tumkur,Karnataka',
'Yediyur,Tumkur,Karnataka',
'Yelagalavadi,Tumkur,Karnataka',
'Yelakadakalu,Tumkur,Karnataka',
'Yeliyur,Tumkur,Karnataka',
'Badakanahalli,Tumkur,Karnataka',
'Badavanahalli,Tumkur,Karnataka',
'Bedathur,Tumkur,Karnataka',
'Bijavara,Tumkur,Karnataka',
'Brahmasamudra,Tumkur,Karnataka',
'Byalya E.Edso,Tumkur,Karnataka',
'Chandragiri,Tumkur,Karnataka',
'Chikkadalavatta,Tumkur,Karnataka',
'Chikkamalur,Tumkur,Karnataka',
'Chinakavajra,Tumkur,Karnataka',
'Chinnenahally,Tumkur,Karnataka',
'Dabbeghatta,Tumkur,Karnataka',
'Doddahosahalli,Tumkur,Karnataka',
'Doddamalur,Tumkur,Karnataka',
'Doddaveeragondanahalli,Tumkur,Karnataka',
'Dodderi,Tumkur,Karnataka',
'Ganjalagunte,Tumkur,Karnataka',
'Garani,Tumkur,Karnataka',
'Gondhihalli,Tumkur,Karnataka',
'Gundagal,Tumkur,Karnataka',
'Hanumanahalli,Tumkur,Karnataka',
'Hanumanthapura,Tumkur,Karnataka',
'Hosahalli,Tumkur,Karnataka',
'Hoskere,Tumkur,Karnataka',
'Ittakadibbanahalli,Tumkur,Karnataka',
'Jakkenahalli,Tumkur,Karnataka',
'Janakaloti,Tumkur,Karnataka',
'Kadagathur,Tumkur,Karnataka',
'Kalidevarapura,Tumkur,Karnataka',
'Karpenahalli,Tumkur,Karnataka',
'Kavanadala,Tumkur,Karnataka',
'Kodagadala,Tumkur,Karnataka',
'Kodigenahalli,Tumkur,Karnataka',
'Kodlapura,Tumkur,Karnataka',
'Kondavadi,Tumkur,Karnataka',
'Kotagarlahalli,Tumkur,Karnataka',
'Kyathagondanahalli,Tumkur,Karnataka',
'Lakshmipura,Tumkur,Karnataka',
'Madhugiri Doddapet,Tumkur,Karnataka',
'Madhugiri Doddapet,Tumkur,Karnataka',
'Madhugiri,Tumkur,Karnataka',
'Medigeshi,Tumkur,Karnataka',
'Mydanahalli,Tumkur,Karnataka',
'Neralekere,Tumkur,Karnataka',
'Nitrahalli,Tumkur,Karnataka',
'P Wd Colony Madhugiri,Tumkur,Karnataka',
'Parthihalli,Tumkur,Karnataka',
'Puravara,Tumkur,Karnataka',
'Pwd Colony Madhugiri,Tumkur,Karnataka',
'R M Yard Madhugiri,Tumkur,Karnataka',
'Rantawalalu,Tumkur,Karnataka',
'Reddihalli,Tumkur,Karnataka',
'Rmyard Madhugiri,Tumkur,Karnataka',
'Settihally,Tumkur,Karnataka',
'Shravandanahally,Tumkur,Karnataka',
'Sidadaragal,Tumkur,Karnataka',
'Singonahally,Tumkur,Karnataka',
'Suddekunte,Tumkur,Karnataka',
'Teriyur,Tumkur,Karnataka',
'Thadi,Tumkur,Karnataka',
'Thimmalapura,Tumkur,Karnataka',
'Thippapura,Tumkur,Karnataka',
'Vaderahalli,Tumkur,Karnataka',
'Yelkur,Tumkur,Karnataka',
'Achammanahalli,Tumkur,Karnataka',
'Arasikere,Tumkur,Karnataka',
'B.K.Hally,Tumkur,Karnataka',
'Bommathanahally,Tumkur,Karnataka',
'Budibetta,Tumkur,Karnataka',
'Bydanur,Tumkur,Karnataka',
'Channakeshavapura,Tumkur,Karnataka',
'Chikkahalli,Tumkur,Karnataka',
'Dommathamari,Tumkur,Karnataka',
'Gowdety,Tumkur,Karnataka',
'Gujjanadu,Tumkur,Karnataka',
'Gummaghatta,Tumkur,Karnataka',
'Gundlahalli,Tumkur,Karnataka',
'Hussainpura,Tumkur,Karnataka',
'Jalodu,Tumkur,Karnataka',
'Jangamarahalli,Tumkur,Karnataka',
'Kanivenahalli,Tumkur,Karnataka',
'Kannamedi,Tumkur,Karnataka',
'Kilarlahalli,Tumkur,Karnataka',
'Kodamadagu,Tumkur,Karnataka',
'Kondethimmanahalli,Tumkur,Karnataka',
'Kotagudda,Tumkur,Karnataka',
'Kothur,Tumkur,Karnataka',
'Kyathaganahalli,Tumkur,Karnataka',
'Kyathaganakere,Tumkur,Karnataka',
'Lingadahalli,Tumkur,Karnataka',
'Madde,Tumkur,Karnataka',
'Mangalawada,Tumkur,Karnataka',
'Maridasanahalli,Tumkur,Karnataka',
'Mugadalabetta,Tumkur,Karnataka',
'Nagalamadike,Tumkur,Karnataka',
'Naliganahalli,Tumkur,Karnataka',
'Neelammanahalli,Tumkur,Karnataka',
'Nyayadagunte,Tumkur,Karnataka',
'Palavalli,Tumkur,Karnataka',
'Pavagaada Fort,Tumkur,Karnataka',
'Pavagada Fort,Tumkur,Karnataka',
'Pavagada,Tumkur,Karnataka',
'Ponnasamudra,Tumkur,Karnataka',
'Pothaganahalli,Tumkur,Karnataka',
'Rajavanthi,Tumkur,Karnataka',
'Rangasamudra,Tumkur,Karnataka',
'Rayacherlu,Tumkur,Karnataka',
'Roppa,Tumkur,Karnataka',
'Sailapura,Tumkur,Karnataka',
'Sasalakunte,Tumkur,Karnataka',
'Shamarayanapalya,Tumkur,Karnataka',
'Siddapura,Tumkur,Karnataka',
'Srirangapura,Tumkur,Karnataka',
'Sulanaikanahalli,Tumkur,Karnataka',
'Thimmalanayakanabetta,Tumkur,Karnataka',
'Thippaiahnadurga,Tumkur,Karnataka',
'Thirumani,Tumkur,Karnataka',
'Vallur,Tumkur,Karnataka',
'Venkatapura,Tumkur,Karnataka',
'Virupasamudra,Tumkur,Karnataka',
'Y N Hoskote,Tumkur,Karnataka',
'Yeguvapalli,Tumkur,Karnataka',
'Badamaranahalli,Tumkur,Karnataka',
'Bandakunte,Tumkur,Karnataka',
'Baragur,Tumkur,Karnataka',
'Bevinahalli,Tumkur,Karnataka',
'Bhoopasandra,Tumkur,Karnataka',
'Brahamasandra,Tumkur,Karnataka',
'Bukkapatna,Tumkur,Karnataka',
'Channanakunte,Tumkur,Karnataka',
'Chengavara,Tumkur,Karnataka',
'Chikkabanagere,Tumkur,Karnataka',
'Chikkanahalli,Tumkur,Karnataka',
'Chirathahalli,Tumkur,Karnataka',
'Dodda Agrahara,Tumkur,Karnataka',
'Dwaranakunte,Tumkur,Karnataka',
'Dyagerahalli,Tumkur,Karnataka',
'Ganadahunse,Tumkur,Karnataka',
'Gopaladeverahalli,Tumkur,Karnataka',
'Gowdagere,Tumkur,Karnataka',
'Guligenehalli,Tumkur,Karnataka',
'Halenahalli,Tumkur,Karnataka',
'Handikunte,Tumkur,Karnataka',
'Hemdore,Tumkur,Karnataka',
'Honnagondanahalli,Tumkur,Karnataka',
'Hosur,Tumkur,Karnataka',
'Huiludore,Tumkur,Karnataka',
'Hulikunte,Tumkur,Karnataka',
'Hunasehalli,Tumkur,Karnataka',
'Hunsekatte,Tumkur,Karnataka',
'Kadavigere,Tumkur,Karnataka',
'Kallambella,Tumkur,Karnataka',
'Kallembella Road,Tumkur,Karnataka',
'Kataveeranahalli,Tumkur,Karnataka',
'Kotta,Tumkur,Karnataka',
'Kuntegowdanahalli,Tumkur,Karnataka',
'Lakkenahalli,Tumkur,Karnataka',
'Lakshmisagara,Tumkur,Karnataka',
'Madalur,Tumkur,Karnataka',
'Maddakkanahalli,Tumkur,Karnataka',
'Magodu,Tumkur,Karnataka',
'Manangi,Tumkur,Karnataka',
'Mekerahally,Tumkur,Karnataka',
'Melkunte,Tumkur,Karnataka',
'Nadur,Tumkur,Karnataka',
'P N Halli,Tumkur,Karnataka',
'Ragalahalli,Tumkur,Karnataka',
'Ramalingapura,Tumkur,Karnataka',
'Rathnasandra,Tumkur,Karnataka',
'Santepet Sira,Tumkur,Karnataka',
'Santhpet Sira,Tumkur,Karnataka',
'Seebi Agrahara,Tumkur,Karnataka',
'Shakadadu,Tumkur,Karnataka',
'Sira Bazar,Tumkur,Karnataka',
'Sira Bazar Sira,Tumkur,Karnataka',
'Sira,Tumkur,Karnataka',
'Talagunda,Tumkur,Karnataka',
'Tarur,Tumkur,Karnataka',
'Tavarekere,Tumkur,Karnataka',
'Thadakalur,Tumkur,Karnataka',
'Tuppadakona,Tumkur,Karnataka',
'Vaddanahalli,Tumkur,Karnataka',
'Vajarahalli,Tumkur,Karnataka',
'Veeraganahalli,Tumkur,Karnataka',
'Yedaladaku,Tumkur,Karnataka',
'Yeliyur,Tumkur,Karnataka',
'Yenjalagere,Tumkur,Karnataka',
'Yeradakatte,Tumkur,Karnataka',
'Thandaga,Tumkur,Karnataka',
'Kallegowdanapalya,Tumkur,Karnataka',
'Albur,Tumkur,Karnataka',
'Aremallenahalli,Tumkur,Karnataka',
'Bajagur,Tumkur,Karnataka',
'Baluvaneralu,Tumkur,Karnataka',
'Beerasandra,Tumkur,Karnataka',
'Belagarahali,Tumkur,Karnataka',
'Bhyranayakanahalli,Tumkur,Karnataka',
'Biligere,Tumkur,Karnataka',
'Dasarighatta,Tumkur,Karnataka',
'Echanur,Tumkur,Karnataka',
'Gandhinagar Tiptur,Tumkur,Karnataka',
'Ganganaghatta,Tumkur,Karnataka',
'Goragondanahalli,Tumkur,Karnataka',
'Gudigondanahalli,Tumkur,Karnataka',
'Gungaramale,Tumkur,Karnataka',
'Gurugadahalli,Tumkur,Karnataka',
'H.V.L.Road,Tumkur,Karnataka',
'Halepalya,Tumkur,Karnataka',
'Halkurike,Tumkur,Karnataka',
'Honnavalli,Tumkur,Karnataka',
'Hulihalli,Tumkur,Karnataka',
'Hunuseghatta,Tumkur,Karnataka',
'K R Extn Tiptur,Tumkur,Karnataka',
'Kalkere,Tumkur,Karnataka',
'Kamalapura,Tumkur,Karnataka',
'Kanathur,Tumkur,Karnataka',
'Karadi,Tumkur,Karnataka',
'Kibbanahalli,Tumkur,Karnataka',
'Kondlighatta,Tumkur,Karnataka',
'Kotanayakanahalli,Tumkur,Karnataka',
'Kuppalu,Tumkur,Karnataka',
'Madenur,Tumkur,Karnataka',
'Malagondahalli,Tumkur,Karnataka',
'Masavanaghatta,Tumkur,Karnataka',
'Mathihally,Tumkur,Karnataka',
'Nagaraghatta,Tumkur,Karnataka',
'Nellikere,Tumkur,Karnataka',
'Nonavinakere,Tumkur,Karnataka',
'Rajathadripura,Tumkur,Karnataka',
'Ramachandrapura,Tumkur,Karnataka',
'Ramanahalli,Tumkur,Karnataka',
'Rangapura,Tumkur,Karnataka',
'Sarthvally,Tumkur,Karnataka',
'Sugur,Tumkur,Karnataka',
'Tadasur,Tumkur,Karnataka',
'Tiptur Bazar,Tumkur,Karnataka',
'Tiptur Bazar,Tumkur,Karnataka',
'Tiptur H.O,Tumkur,Karnataka',
'Vignasanthe,Tumkur,Karnataka',
'Anupanahalli,Tumkur,Karnataka',
'Arakere,Tumkur,Karnataka',
'Aregujjanahalli,Tumkur,Karnataka',
'Ariyur,Tumkur,Karnataka',
'Barline Tumkur,Tumkur,Karnataka',
'Beladhara,Tumkur,Karnataka',
'Belagumba,Tumkur,Karnataka',
'Bellavi,Tumkur,Karnataka',
'Bheemasandra,Tumkur,Karnataka',
'Brahmasandra,Tumkur,Karnataka',
'Bugudanahalli,Tumkur,Karnataka',
'Byatha,Tumkur,Karnataka',
'Channenahalli,Tumkur,Karnataka',
'Chikkasarangi,Tumkur,Karnataka',
'Chikkatottalakere,Tumkur,Karnataka',
'Dasalakunte,Tumkur,Karnataka',
'Devalapura,Tumkur,Karnataka',
'Devarayanadurga,Tumkur,Karnataka',
'Devarayapatna,Tumkur,Karnataka',
'Dibbur,Tumkur,Karnataka',
'Doddanaravangala,Tumkur,Karnataka',
'Gandinagar Tumkur,Tumkur,Karnataka',
'Gulur,Tumkur,Karnataka',
'Halanur,Tumkur,Karnataka',
'Haldodderi,Tumkur,Karnataka',
'Haralur,Tumkur,Karnataka',
'Hebbur,Tumkur,Karnataka',
'Hiredoddavadi,Tumkur,Karnataka',
'Hirehalli.,Tumkur,Karnataka',
'Honnudike,Tumkur,Karnataka',
'Honsigere,Tumkur,Karnataka',
'Hullenahalii,Tumkur,Karnataka',
'Hunjanal,Tumkur,Karnataka',
'Kabbigere,Tumkur,Karnataka',
'Kambathanahalli,Tumkur,Karnataka',
'Kanakuppe,Tumkur,Karnataka',
'Kattige Gollahalli,Tumkur,Karnataka',
'Kembalalu,Tumkur,Karnataka',
'Kempanadodderi,Tumkur,Karnataka',
'Kesaramadu,Tumkur,Karnataka',
'Kestur,Tumkur,Karnataka',
'Kolala,Tumkur,Karnataka',
'Kora,Tumkur,Karnataka',
'Kuramkote,Tumkur,Karnataka',
'Kuvempunagar,Tumkur,Karnataka',
'Kuvempunagara,Tumkur,Karnataka',
'Kyathasandra,Tumkur,Karnataka',
'M C Campus Tumkur,Tumkur,Karnataka',
'Makanahally,Tumkur,Karnataka',
'Mallasandra,Tumkur,Karnataka',
'Maralur,Tumkur,Karnataka',
'Maralur,Tumkur,Karnataka',
'Maskal,Tumkur,Karnataka',
'Melekote,Tumkur,Karnataka',
'Mulukunte,Tumkur,Karnataka',
'Mydala,Tumkur,Karnataka',
'Nagavalli,Tumkur,Karnataka',
'Nagavalli,Tumkur,Karnataka',
'Naruganahalli,Tumkur,Karnataka',
'Negalala,Tumkur,Karnataka',
'Nelahal,Tumkur,Karnataka',
'Niduvalalu,Tumkur,Karnataka',
'Northren Extension,Tumkur,Karnataka',
'Obalapura,Tumkur,Karnataka',
'Oorkere,Tumkur,Karnataka',
'P.H.Colony,Tumkur,Karnataka',
'Palasandra,Tumkur,Karnataka',
'Poor House Colony,Tumkur,Karnataka',
'R G Market Tumkur,Tumkur,Karnataka',
'R.G.Market,Tumkur,Karnataka',
'S G Extn Tumkur,Tumkur,Karnataka',
'S.G.Extension Tumkur,Tumkur,Karnataka',
'S.G.Mutt,Tumkur,Karnataka',
'Sasalu,Tumkur,Karnataka',
'Seethakal,Tumkur,Karnataka',
'Settihalli,Tumkur,Karnataka',
'Siddaganga Mutt,Tumkur,Karnataka',
'Siddarthanagar,Tumkur,Karnataka',
'Singonahally,Tumkur,Karnataka',
'Siravara,Tumkur,Karnataka',
'Sit Campus,Tumkur,Karnataka',
'Someswarapuram,Tumkur,Karnataka',
'Sorekunte,Tumkur,Karnataka',
'Swandenahalli,Tumkur,Karnataka',
'Taredakuppe,Tumkur,Karnataka',
'Tavarekere,Tumkur,Karnataka',
'Tovinakere,Tumkur,Karnataka',
'Tumkur City,Tumkur,Karnataka',
'Tumkur City,Tumkur,Karnataka',
'Tumkur H.O,Tumkur,Karnataka',
'Urdigere,Tumkur,Karnataka',
'Vinoba Nagara Tumkur,Tumkur,Karnataka',
'Vinobhanagar,Tumkur,Karnataka',
'Western Extn,Tumkur,Karnataka',
'Western Extn Tumkur,Tumkur,Karnataka',
'Yelachigere,Tumkur,Karnataka',
'Aralikere,Tumkur,Karnataka',
'Banasandra,Tumkur,Karnataka',
'Benakanakere,Tumkur,Karnataka',
'Dabbeghatta,Tumkur,Karnataka',
'Dandinashivara,Tumkur,Karnataka',
'Dasihalli,Tumkur,Karnataka',
'Doddamalligere,Tumkur,Karnataka',
'Doddasettikere,Tumkur,Karnataka',
'Dombaranahalli,Tumkur,Karnataka',
'Dunda,Tumkur,Karnataka',
'Dwaranahalli,Tumkur,Karnataka',
'Gonitumkur,Tumkur,Karnataka',
'Guddenahalli,Tumkur,Karnataka',
'Heggere,Tumkur,Karnataka',
'Hullekere,Tumkur,Karnataka',
'Jadeya,Tumkur,Karnataka',
'Kalkere,Tumkur,Karnataka',
'Kanakur,Tumkur,Karnataka',
'Kodagihally,Tumkur,Karnataka',
'Kondajji,Tumkur,Karnataka',
'Machenahalli,Tumkur,Karnataka',
'Madihally,Tumkur,Karnataka',
'Mavinakere,Tumkur,Karnataka',
'Mayasandra,Tumkur,Karnataka',
'Mugalur,Tumkur,Karnataka',
'Muniyur,Tumkur,Karnataka',
'Muthugadahalli,Tumkur,Karnataka',
'Nagalapura,Tumkur,Karnataka',
'Pura,Tumkur,Karnataka',
'S.Nagar,Tumkur,Karnataka',
'Soravanahalli,Tumkur,Karnataka',
'Subramanyanagar Turuvekere,Tumkur,Karnataka',
'Talkere,Tumkur,Karnataka',
'Turuvekere,Tumkur,Karnataka',
'Vittalapura,Tumkur,Karnataka',
'Western Extension,Tumkur,Karnataka',
'Ajekar,Puttur,Karnataka',
'Andar,Puttur,Karnataka',
'Attur,Puttur,Karnataka',
'Bailur,Puttur,Karnataka',
'Bajegoli,Puttur,Karnataka',
'Belady,Puttur,Karnataka',
'Belanje,Puttur,Karnataka',
'Belmannu,Mangalore,Karnataka',
'Bola,Puttur,Karnataka',
'Bolakodi,Mangalore,Karnataka',
'Borkatte,Puttur,Karnataka',
'Chara,Puttur,Karnataka',
'Doopadakatte,Puttur,Karnataka',
'Durga,Puttur,Karnataka',
'Ellare,Puttur,Karnataka',
'Gundyadka,Puttur,Karnataka',
'Hadiangady,Puttur,Karnataka',
'Hebri,Puttur,Karnataka',
'Hermunde,Puttur,Karnataka',
'Hirgana,Puttur,Karnataka',
'Hiriangady,Puttur,Karnataka',
'Hosmar,Puttur,Karnataka',
'Idu,Puttur,Karnataka',
'Inna,Mangalore,Karnataka',
'Iruvail,Mangalore,Karnataka',
'Irvathur,Puttur,Karnataka',
'Jarkala,Puttur,Karnataka',
'Kabbinale,Puttur,Karnataka',
'Kadthala,Puttur,Karnataka',
'Kallya,Puttur,Karnataka',
'Kanajar,Puttur,Karnataka',
'Kanthavara,Puttur,Karnataka',
'Karkala Bazar,Puttur,Karnataka',
'Karkala H.O,Puttur,Karnataka',
'Karkala West,Puttur,Karnataka',
'Kedinje,Puttur,Karnataka',
'Kervashe,Puttur,Karnataka',
'Kuchur,Puttur,Karnataka',
'Kukkuje,Puttur,Karnataka',
'Kukkundur,Puttur,Karnataka',
'Kukkundur West,Puttur,Karnataka',
'Kuntady,Puttur,Karnataka',
'Mala,Puttur,Karnataka',
'Manjalthar,Puttur,Karnataka',
'Miyar,Puttur,Karnataka',
'Mudradi,Puttur,Karnataka',
'Mundkur,Mangalore,Karnataka',
'Muniyal,Puttur,Karnataka',
'Nakre,Puttur,Karnataka',
'Nallur,Puttur,Karnataka',
'Nandalike,Mangalore,Karnataka',
'Ninjoor,Puttur,Karnataka',
'Nire,Puttur,Karnataka',
'Nitte,Puttur,Karnataka',
'Nooralbettu,Puttur,Karnataka',
'Palli,Puttur,Karnataka',
'Parappadi,Puttur,Karnataka',
'Renjala,Puttur,Karnataka',
'Sanur,Puttur,Karnataka',
'Shivapura,Puttur,Karnataka',
'Sitanadi,Puttur,Karnataka',
'Someshwara,Puttur,Karnataka',
'Sooda,Mangalore,Karnataka',
'Vanjarakatte,Puttur,Karnataka',
'Varanga,Puttur,Karnataka',
'Vishwasnagar,Puttur,Karnataka',
'Yennehole,Puttur,Karnataka',
'Yerlapady,Puttur,Karnataka',
'Ajrihara,Udupi,Karnataka',
'Alur,Udupi,Karnataka',
'Amasebail,Udupi,Karnataka',
'Ampar,Udupi,Karnataka',
'Anagalli,Udupi,Karnataka',
'Ardi,Udupi,Karnataka',
'Asodu,Udupi,Karnataka',
'Badakere,Udupi,Karnataka',
'Balkur,Udupi,Karnataka',
'Basrur,Udupi,Karnataka',
'Beejadi,Udupi,Karnataka',
'Belur Devasthanabettu,Udupi,Karnataka',
'Belve,Udupi,Karnataka',
'Bijur,Udupi,Karnataka',
'Byndoor,Udupi,Karnataka',
'Chittoor,Udupi,Karnataka',
'Devalkunda,Udupi,Karnataka',
'Gandhi-maidan,Udupi,Karnataka',
'Ganguli Bunder,Udupi,Karnataka',
'Ganguli,Udupi,Karnataka',
'Golihole,Udupi,Karnataka',
'Gujjadi,Udupi,Karnataka',
'Gulvadi,Udupi,Karnataka',
'Hadavu,Udupi,Karnataka',
'Hakladi,Udupi,Karnataka',
'Haladi-28,Udupi,Karnataka',
'Haladi-76,Udupi,Karnataka',
'Halladi-harkadi,Udupi,Karnataka',
'Hallihole,Udupi,Karnataka',
'Halnadu,Udupi,Karnataka',
'Hardalli-mandalli,Udupi,Karnataka',
'Harkur,Udupi,Karnataka',
'Hattiangadi,Udupi,Karnataka',
'Hemmadi,Udupi,Karnataka',
'Hengavalli,Udupi,Karnataka',
'Heranjal,Udupi,Karnataka',
'Herikudru,Udupi,Karnataka',
'Heskethur,Udupi,Karnataka',
'Hosadu,Udupi,Karnataka',
'Hosangadi,Udupi,Karnataka',
'Hunsemakki,Udupi,Karnataka',
'Idurkunhady,Udupi,Karnataka',
'Jadkal,Udupi,Karnataka',
'Jansale,Udupi,Karnataka',
'Japthi,Udupi,Karnataka',
'Kalthod,Udupi,Karnataka',
'Kamalashile,Udupi,Karnataka',
'Kandlur,Udupi,Karnataka',
'Kanyana,Udupi,Karnataka',
'Karkunje,Udupi,Karnataka',
'Kattebelthur,Udupi,Karnataka',
'Kavradi,Udupi,Karnataka',
'Kedur,Udupi,Karnataka',
'Kenchanur,Udupi,Karnataka',
'Keradi,Udupi,Karnataka',
'Kergal,Udupi,Karnataka',
'Khambadakone,Udupi,Karnataka',
'Kirimanjeshwara,Udupi,Karnataka',
'Koderi,Udupi,Karnataka',
'Kodi,Udupi,Karnataka',
'Kodladi,Udupi,Karnataka',
'Kollur,Udupi,Karnataka',
'Koni,Udupi,Karnataka',
'Korgi,Udupi,Karnataka',
'Koteshwara,Udupi,Karnataka',
'Krodabailur,Udupi,Karnataka',
'Kulanje,Udupi,Karnataka',
'Kumbhashi,Udupi,Karnataka',
'Kundabarandadi,Udupi,Karnataka',
'Kundapura Market,Udupi,Karnataka',
'Kundapura West,Udupi,Karnataka',
'Machattu,Udupi,Karnataka',
'Madamakki,Udupi,Karnataka',
'Maravanthe,Udupi,Karnataka',
'Mayyadi,Udupi,Karnataka',
'Melhosur,Udupi,Karnataka',
'Molahalli,Udupi,Karnataka',
'Moodumata,Udupi,Karnataka',
'Mudlakatte,Udupi,Karnataka',
'Mudmunda,Udupi,Karnataka',
'Mudur,Udupi,Karnataka',
'Nada,Udupi,Karnataka',
'Navunda,Udupi,Karnataka',
'Nujadi,Udupi,Karnataka',
'Paduvari,Udupi,Karnataka',
'Rattadi,Udupi,Karnataka',
'Salvadi,Udupi,Karnataka',
'Shankaranarayana,Udupi,Karnataka',
'Shedimane,Udupi,Karnataka',
'Shenapura,Udupi,Karnataka',
'Shiruru (Udupi),Udupi,Karnataka',
'Siddapura (Udupi),Udupi,Karnataka',
'Souda,Udupi,Karnataka',
'Taggarshe,Udupi,Karnataka',
'Tallur,Udupi,Karnataka',
'Tarapathi,Udupi,Karnataka',
'Tekkatte,Udupi,Karnataka',
'Trasi,Udupi,Karnataka',
'Ullur,Udupi,Karnataka',
'Ultoor,Udupi,Karnataka',
'Uppinakudru,Udupi,Karnataka',
'Uppunda,Udupi,Karnataka',
'Vakwadi,Udupi,Karnataka',
'Vandse,Udupi,Karnataka',
'Yadyadi-mathyadi,Udupi,Karnataka',
'Yedamoge,Udupi,Karnataka',
'Yedthare,Udupi,Karnataka',
'Yelajith,Udupi,Karnataka',
'Hanglur,Udupi,Karnataka',
'Ragihaklu,Udupi,Karnataka',
'Achladi,Udupi,Karnataka',
'Adi-udupi,Udupi,Karnataka',
'Admar,Udupi,Karnataka',
'Airody,Udupi,Karnataka',
'Alevoor,Udupi,Karnataka',
'Ambalapadi,Udupi,Karnataka',
'Arekandige,Udupi,Karnataka',
'Aroor,Udupi,Karnataka',
'Athradi,Udupi,Karnataka',
'Avarse,Udupi,Karnataka',
'Avral,Udupi,Karnataka',
'Bada,Udupi,Karnataka',
'Badagabettu,Udupi,Karnataka',
'Badanidiyur,Udupi,Karnataka',
'Baidabettu,Udupi,Karnataka',
'Baikadi,Udupi,Karnataka',
'Bannadi,Udupi,Karnataka',
'Bannanje,Udupi,Karnataka',
'Barkur,Udupi,Karnataka',
'Barkur Town,Udupi,Karnataka',
'Belapu,Udupi,Karnataka',
'Bellampalli,Udupi,Karnataka',
'Bellarpadi,Udupi,Karnataka',
'Bennekudru,Udupi,Karnataka',
'Bhairanje,Udupi,Karnataka',
'Bhantakal,Udupi,Karnataka',
'Brahmavara,Udupi,Karnataka',
'Car Street,Udupi,Karnataka',
'Chanthar,Udupi,Karnataka',
'Cherkadi,Udupi,Karnataka',
'Chitpadi,Udupi,Karnataka',
'Doddanagudde,Udupi,Karnataka',
'Guddeangadi,Udupi,Karnataka',
'Gummahola,Udupi,Karnataka',
'Halasinakatte,Udupi,Karnataka',
'Haluvalli,Udupi,Karnataka',
'Hanehalli,Udupi,Karnataka',
'Haradi,Udupi,Karnataka',
'Havanje,Udupi,Karnataka',
'Hejmadi,Udupi,Karnataka',
'Hejmadikodi,Udupi,Karnataka',
'Herga,Udupi,Karnataka',
'Herur,Udupi,Karnataka',
'Herur-92,Udupi,Karnataka',
'Hiliyana,Udupi,Karnataka',
'Hirebettu,Udupi,Karnataka',
'Hiriadka,Udupi,Karnataka',
'Hoode,Udupi,Karnataka',
'Hosala,Udupi,Karnataka',
'Hungarcutta,Udupi,Karnataka',
'Innanje,Udupi,Karnataka',
'Janvarkatte,Udupi,Karnataka',
'Kadekar,Udupi,Karnataka',
'Kadur,Udupi,Karnataka',
'Kakkunje,Udupi,Karnataka',
'Kalathur South,Udupi,Karnataka',
'Kallianapura,Udupi,Karnataka',
'Kalsanka,Udupi,Karnataka',
'Karje,Udupi,Karnataka',
'Karkada,Udupi,Karnataka',
'Katapadi(Udupi),Udupi,Karnataka',
'Kattingere,Udupi,Karnataka',
'Kaup,Udupi,Karnataka',
'Kavadi,Udupi,Karnataka',
'Kelarkalabettu,Udupi,Karnataka',
'Kemmannu,Udupi,Karnataka',
'Kemmundel,Udupi,Karnataka',
'Kenjur,Udupi,Karnataka',
'Kidiyur,Udupi,Karnataka',
'Kinnimulki,Udupi,Karnataka',
'Kodi Kanyana,Udupi,Karnataka',
'Kodibengre,Udupi,Karnataka',
'Kodupanjimar,Udupi,Karnataka',
'Kokkarne,Udupi,Karnataka',
'Kolalagiri,Udupi,Karnataka',
'Korangrapadi,Udupi,Karnataka',
'Kota,Udupi,Karnataka',
'Kotathattu,Udupi,Karnataka',
'Krodashrama,Udupi,Karnataka',
'Kudi,Udupi,Karnataka',
'Kudrukere,Udupi,Karnataka',
'Kukkehalli,Udupi,Karnataka',
'Kukkikatte,Udupi,Karnataka',
'Kumragodu,Udupi,Karnataka',
'Kundapura H.O,Udupi,Karnataka',
'Kunjal,Udupi,Karnataka',
'Kunjarugiri,Udupi,Karnataka',
'Kunjibettu,Udupi,Karnataka',
'Kuthpadi,Udupi,Karnataka',
'Kuthyar,Udupi,Karnataka',
'Majur,Udupi,Karnataka',
'Mallar,Udupi,Karnataka',
'Malpe,Udupi,Karnataka',
'Manchikodi,Udupi,Karnataka',
'Mandarthi,Udupi,Karnataka',
'Manipal East,Udupi,Karnataka',
'Manipal H.O,Udupi,Karnataka',
'Manipura,Udupi,Karnataka',
'Manipura West,Udupi,Karnataka',
'Manur,Udupi,Karnataka',
'Marne,Udupi,Karnataka',
'Matapadi,Udupi,Karnataka',
'Mattar,Udupi,Karnataka',
'Mattu,Udupi,Karnataka',
'Mission Compound,Udupi,Karnataka',
'Moodubelle,Udupi,Karnataka',
'Muddumane,Udupi,Karnataka',
'Nadur,Udupi,Karnataka',
'Nalkur,Udupi,Karnataka',
'Nanchar,Udupi,Karnataka',
'Nandikur,Udupi,Karnataka',
'Neelavara,Udupi,Karnataka',
'Nittur,Udupi,Karnataka',
'Padebettu,Udupi,Karnataka',
'Padubelle,Udupi,Karnataka',
'Padubidri,Udupi,Karnataka',
'Padur,Udupi,Karnataka',
'Paduyermal,Udupi,Karnataka',
'Palimar,Udupi,Karnataka',
'Panchanbettu,Udupi,Karnataka',
'Pangala,Udupi,Karnataka',
'Paniyur,Udupi,Karnataka',
'Parampalli,Udupi,Karnataka',
'Parkala,Udupi,Karnataka',
'Patla,Udupi,Karnataka',
'Perdur,Udupi,Karnataka',
'Pernal,Udupi,Karnataka',
'Pernankila,Udupi,Karnataka',
'Pilar,Udupi,Karnataka',
'Pithrodi,Udupi,Karnataka',
'Press Corner,Udupi,Karnataka',
'Puttur,Udupi,Karnataka',
'Saibarkatte,Udupi,Karnataka',
'Saligrama,Udupi,Karnataka',
'Salikeri,Udupi,Karnataka',
'Santhekatte,Udupi,Karnataka',
'Santhekatte-kalathur,Udupi,Karnataka',
'Santhur,Udupi,Karnataka',
'Sasthan,Udupi,Karnataka',
'Shankarapura,Udupi,Karnataka',
'Shiriyara,Udupi,Karnataka',
'Shiroor,Udupi,Karnataka',
'Shirva,Udupi,Karnataka',
'Shivalli,Udupi,Karnataka',
'Subhash Nagar,Udupi,Karnataka',
'Tenkabettu,Udupi,Karnataka',
'Tenkanidiyur,Udupi,Karnataka',
'Thottam,Udupi,Karnataka',
'Uchila,Udupi,Karnataka',
'Udupi Courts,Udupi,Karnataka',
'Udupi H.O,Udupi,Karnataka',
'Udyavara,Udupi,Karnataka',
'Uliyaragoli,Udupi,Karnataka',
'Uppur,Udupi,Karnataka',
'Vandar,Udupi,Karnataka',
'Yedabettu,Udupi,Karnataka',
'Yedthadi,Udupi,Karnataka',
'Yellur,Udupi,Karnataka',
'Yermal,Udupi,Karnataka',
'Algeri,Karwar,Karnataka',
'Baleguli,Karwar,Karnataka',
'Bobruwada,Karwar,Karnataka',
'Dongri,Karwar,Karnataka',
'Gersoppa,Karwar,Karnataka',
'Halvalli,Karwar,Karnataka',
'Heggar R.C.,Karwar,Karnataka',
'Kaiga Workers Colony,Karwar,Karnataka',
'Kalleswar,Karwar,Karnataka',
'Kanasagiri,Karwar,Karnataka',
'Keni,Karwar,Karnataka',
'Nilkod,Karwar,Karnataka',
'Ramanagulli,Karwar,Karnataka',
'Shirkuli,Karwar,Karnataka',
'Sunksal,Karwar,Karnataka',
'Tenkankeri,Karwar,Karnataka',
'Achve,Karwar,Karnataka',
'Adigon,Karwar,Karnataka',
'Aggargon,Karwar,Karnataka',
'Agsur,Karwar,Karnataka',
'Ankola,Karwar,Karnataka',
'Aversa,Karwar,Karnataka',
'Basgod,Karwar,Karnataka',
'Belambar,Karwar,Karnataka',
'Belekeri,Karwar,Karnataka',
'Belse,Karwar,Karnataka',
'Bhavikeri,Karwar,Karnataka',
'Hadav,Karwar,Karnataka',
'Harwada,Karwar,Karnataka',
'Hattikeri,Karwar,Karnataka',
'Hichkad,Karwar,Karnataka',
'Kodsani,Karwar,Karnataka',
'Manjuguni,Karwar,Karnataka',
'Sagadgeri,Karwar,Karnataka',
'Sakalben,Karwar,Karnataka',
'Shetgeri,Karwar,Karnataka',
'Shirur,Karwar,Karnataka',
'Vandige,Karwar,Karnataka',
'Vasarkudrige,Karwar,Karnataka',
'Alvekodi(BKTL),Karwar,Karnataka',
'Anantwadi,Karwar,Karnataka',
'Bailur,Karwar,Karnataka',
'Belke,Karwar,Karnataka',
'Bengre,Karwar,Karnataka',
'Bengre Ulman,Karwar,Karnataka',
'Bhatkal Bazar,Karwar,Karnataka',
'Bhatkal,Karwar,Karnataka',
'Gorte,Karwar,Karnataka',
'Hadavalli,Karwar,Karnataka',
'Hadil,Karwar,Karnataka',
'Heble,Karwar,Karnataka',
'Jali,Karwar,Karnataka',
'Kaikini,Karwar,Karnataka',
'Katgar,Karwar,Karnataka',
'Konar,Karwar,Karnataka',
'Koppa,Karwar,Karnataka',
'Marukeri,Karwar,Karnataka',
'Mathadhittal,Karwar,Karnataka',
'Mavinkurve,Karwar,Karnataka',
'Mundalli,Karwar,Karnataka',
'Murdeshwar,Karwar,Karnataka',
'Muttolli,Karwar,Karnataka',
'Navayat Colony,Karwar,Karnataka',
'Shirali Bazar,Karwar,Karnataka',
'Shirali,Karwar,Karnataka',
'Ternamakki,Karwar,Karnataka',
'Yelvadikavur,Karwar,Karnataka',
'Alur,Sirsi,Karnataka',
'Ambewadi,Sirsi,Karnataka',
'Ambikanagar,Sirsi,Karnataka',
'Ammankoppa,Sirsi,Karnataka',
'Aralwada,Sirsi,Karnataka',
'Barchi,Sirsi,Karnataka',
'Bazarkunchanalli,Sirsi,Karnataka',
'Belvatgi,Sirsi,Karnataka',
'Bhagwati,Sirsi,Karnataka',
'Channammacircle,Sirsi,Karnataka',
'Chibbalgeri,Sirsi,Karnataka',
'Dandeli Bazar,Sirsi,Karnataka',
'Dandeli Paper Mills,Sirsi,Karnataka',
'Dandeli,Sirsi,Karnataka',
'Ganeshgudi,Sirsi,Karnataka',
'Gund,Sirsi,Karnataka',
'Gundolli,Sirsi,Karnataka',
'Haliyal,Sirsi,Karnataka',
'Havagi,Sirsi,Karnataka',
'Hunswad,Sirsi,Karnataka',
'Jange,Sirsi,Karnataka',
'Kalginkoppa,Sirsi,Karnataka',
'Kawalwada,Sirsi,Karnataka',
'Kegdal,Sirsi,Karnataka',
'Kesrolli,Sirsi,Karnataka',
'Kulgi,Sirsi,Karnataka',
'Madnalli,Sirsi,Karnataka',
'Mangalwada,Sirsi,Karnataka',
'Murakwada,Sirsi,Karnataka',
'Muttalmuri,Sirsi,Karnataka',
'N.S.Koppa,Sirsi,Karnataka',
'Plywood Colony,Sirsi,Karnataka',
'Pradhani,Sirsi,Karnataka',
'Sambrani,Sirsi,Karnataka',
'Tattigeri,Sirsi,Karnataka',
'Teginhalli,Sirsi,Karnataka',
'Tergaon,Sirsi,Karnataka',
'Virnoli,Sirsi,Karnataka',
'Yedoga,Sirsi,Karnataka',
'Adukal,Karwar,Karnataka',
'Apsarkonda,Karwar,Karnataka',
'Areangadi,Karwar,Karnataka',
'Balkur,Karwar,Karnataka',
'Beranki,Karwar,Karnataka',
'Bhaskeri,Karwar,Karnataka',
'Chandavar,Karwar,Karnataka',
'Chikkankod,Karwar,Karnataka',
'Durgakeri,Karwar,Karnataka',
'Gersoppa Jyothinagar,Karwar,Karnataka',
'Gunavante,Karwar,Karnataka',
'Hadinbal,Karwar,Karnataka',
'Haldipur,Karwar,Karnataka',
'Herangadi,Karwar,Karnataka',
'Hodkeshirur,Karwar,Karnataka',
'Holegadde,Karwar,Karnataka',
'Honavar Bazar,Karwar,Karnataka',
'Honavar Port,Karwar,Karnataka',
'Honavar,Karwar,Karnataka',
'Hosad,Karwar,Karnataka',
'Hosakuli,Karwar,Karnataka',
'Hosapattan,Karwar,Karnataka',
'Jalavalli,Karwar,Karnataka',
'Jognikatte,Karwar,Karnataka',
'Kadle,Karwar,Karnataka',
'Kadtoka,Karwar,Karnataka',
'Karki,Karwar,Karnataka',
'Kasarkod,Karwar,Karnataka',
'Kasarkod Tonka,Karwar,Karnataka',
'Kavalakki,Karwar,Karnataka',
'Kekkar,Karwar,Karnataka',
'Kelagin Idgunji,Karwar,Karnataka',
'Kelagina Mudkani,Karwar,Karnataka',
'Kelaginoor,Karwar,Karnataka',
'Kharwa,Karwar,Karnataka',
'Kodani,Karwar,Karnataka',
'Konkar,Karwar,Karnataka',
'Kudrige,Karwar,Karnataka',
'Madgeri,Karwar,Karnataka',
'Magod,Karwar,Karnataka',
'Mallapur,Karwar,Karnataka',
'Manki Banasale,Karwar,Karnataka',
'Manki,Karwar,Karnataka',
'Mavinkurve,Karwar,Karnataka',
'Melin Idgunji,Karwar,Karnataka',
'Melina Mannige,Karwar,Karnataka',
'Molkod,Karwar,Karnataka',
'Mugva,Karwar,Karnataka',
'Mugva Surkatte,Karwar,Karnataka',
'Nagarbastikeri,Karwar,Karnataka',
'Nagre,Karwar,Karnataka',
'Navilgone,Karwar,Karnataka',
'Nilkod,Karwar,Karnataka',
'Pavinkurve,Karwar,Karnataka',
'Prabhatnagar,Karwar,Karnataka',
'Salkod,Karwar,Karnataka',
'Samsi,Karwar,Karnataka',
'Saralgi,Karwar,Karnataka',
'Talamakki,Karwar,Karnataka',
'Upponi,Karwar,Karnataka',
'Valki,Karwar,Karnataka',
'Vandur,Karwar,Karnataka',
'Anmod,Sirsi,Karnataka',
'Anshi,Sirsi,Karnataka',
'Asu,Sirsi,Karnataka',
'Aveda,Sirsi,Karnataka',
'Bazarkunang,Sirsi,Karnataka',
'Castlerock,Sirsi,Karnataka',
'Chapoli,Sirsi,Karnataka',
'Hudsa,Sirsi,Karnataka',
'Jagalbet,Sirsi,Karnataka',
'Joida,Sirsi,Karnataka',
'Kalasai,Sirsi,Karnataka',
'Karanjoida,Sirsi,Karnataka',
'Kumbarwada,Sirsi,Karnataka',
'Nagoda,Sirsi,Karnataka',
'Nujji,Sirsi,Karnataka',
'Ramnagar,Sirsi,Karnataka',
'Shingargaon,Sirsi,Karnataka',
'Tinaighat,Sirsi,Karnataka',
'Ulvi,Sirsi,Karnataka',
'Gaongeri,Karwar,Karnataka',
'Amdalli,Karwar,Karnataka',
'Angadi,Karwar,Karnataka',
'Arge,Karwar,Karnataka',
'Asnoti,Karwar,Karnataka',
'Awara Road,Karwar,Karnataka',
'Baad(KWR),Karwar,Karnataka',
'Balni,Karwar,Karnataka',
'Bhaire,Karwar,Karnataka',
'Binaga Bazar,Karwar,Karnataka',
'Binga,Karwar,Karnataka',
'Bolshitta,Karwar,Karnataka',
'Chendiye,Karwar,Karnataka',
'Devalmakki,Karwar,Karnataka',
'Devbag,Karwar,Karnataka',
'Gopshitta,Karwar,Karnataka',
'Gotegali,Karwar,Karnataka',
'Gotnibag,Karwar,Karnataka',
'Habbuwada,Karwar,Karnataka',
'Halge Joog,Karwar,Karnataka',
'Halge,Karwar,Karnataka',
'Hankon,Karwar,Karnataka',
'Hosali,Karwar,Karnataka',
'Hotegali,Karwar,Karnataka',
'Kadra Bazar,Karwar,Karnataka',
'Kadra,Karwar,Karnataka',
'Kadwad,Karwar,Karnataka',
'Kaiga,Karwar,Karnataka',
'Kajubag,Karwar,Karnataka',
'Karwar Baitkhol,Karwar,Karnataka',
'Karwar H.O,Karwar,Karnataka',
'Karwar Kutchery,Karwar,Karnataka',
'Karwar Market,Karwar,Karnataka',
'Kathinkon,Karwar,Karnataka',
'Kerwadi,Karwar,Karnataka',
'Kinnar,Karwar,Karnataka',
'Kodibag,Karwar,Karnataka',
'Majali,Karwar,Karnataka',
'Mallapur,Karwar,Karnataka',
'Mudga,Karwar,Karnataka',
'Mudgeri,Karwar,Karnataka',
'Nandangadda,Karwar,Karnataka',
'S S Auditorium,Karwar,Karnataka',
'Sadashivgad,Karwar,Karnataka',
'Shejwad,Karwar,Karnataka',
'Shirwada,Karwar,Karnataka',
'Siddar,Karwar,Karnataka',
'Sunkeri,Karwar,Karnataka',
'Todur,Karwar,Karnataka',
'Todur Camp,Karwar,Karnataka',
'Ulga,Karwar,Karnataka',
'Wailwada,Karwar,Karnataka',
'Aghanashini,Karwar,Karnataka',
'Alvekodi(KMT),Karwar,Karnataka',
'Andle,Karwar,Karnataka',
'Antravalli,Karwar,Karnataka',
'Baad,Karwar,Karnataka',
'Bankikodla,Karwar,Karnataka',
'Bargi,Karwar,Karnataka',
'Betkuli,Karwar,Karnataka',
'Brahmur,Karwar,Karnataka',
'Dhareshwar,Karwar,Karnataka',
'Divgi,Karwar,Karnataka',
'Dubbanshashi,Karwar,Karnataka',
'Gokarn Car Street,Karwar,Karnataka',
'Gokarn,Karwar,Karnataka',
'Gudeangadi,Karwar,Karnataka',
'Gundbala,Karwar,Karnataka',
'Halkar,Karwar,Karnataka',
'Handigon,Karwar,Karnataka',
'Hanehalli,Karwar,Karnataka',
'Hegde,Karwar,Karnataka',
'Herwatta,Karwar,Karnataka',
'Hillur,Karwar,Karnataka',
'Hiregutti,Karwar,Karnataka',
'Holangadde,Karwar,Karnataka',
'Honmav,Karwar,Karnataka',
'Hubbangeri,Karwar,Karnataka',
'Kadime,Karwar,Karnataka',
'Kagal,Karwar,Karnataka',
'Kalbag,Karwar,Karnataka',
'Kallabbe,Karwar,Karnataka',
'Katgal,Karwar,Karnataka',
'Kimani,Karwar,Karnataka',
'Kodambale,Karwar,Karnataka',
'Kodkani,Karwar,Karnataka',
'Konalli,Karwar,Karnataka',
'Kujalli,Karwar,Karnataka',
'Kumta H.O,Karwar,Karnataka',
'Kumta Kanara College Road,Karwar,Karnataka',
'Kumta Kutchery,Karwar,Karnataka',
'Kumta Town,Karwar,Karnataka',
'Lukkeri,Karwar,Karnataka',
'Madangeri,Karwar,Karnataka',
'Manaki,Karwar,Karnataka',
'Masur,Karwar,Karnataka',
'Mirjan,Karwar,Karnataka',
'Mogta,Karwar,Karnataka',
'Murur,Karwar,Karnataka',
'Mutta,Karwar,Karnataka',
'Nadumaskeri,Karwar,Karnataka',
'Nagur,Karwar,Karnataka',
'Nilkod,Karwar,Karnataka',
'Paduvani,Karwar,Karnataka',
'Sangtal,Karwar,Karnataka',
'Sanikatta,Karwar,Karnataka',
'Santeguli,Karwar,Karnataka',
'Soppinahosalli,Karwar,Karnataka',
'Tadri,Karwar,Karnataka',
'Torke,Karwar,Karnataka',
'Ulware,Karwar,Karnataka',
'Uppinapattan,Karwar,Karnataka',
'Urkeri,Karwar,Karnataka',
'Valgalli,Karwar,Karnataka',
'Yettinbail,Karwar,Karnataka',
'Andalgi,Sirsi,Karnataka',
'Bachanki,Sirsi,Karnataka',
'Bhedasgaon,Sirsi,Karnataka',
'Chavadalli,Sirsi,Karnataka',
'Chigalli,Sirsi,Karnataka',
'Dharma Colony,Sirsi,Karnataka',
'Gunjavati,Sirsi,Karnataka',
'Hanumapur,Sirsi,Karnataka',
'Hungund,Sirsi,Karnataka',
'Indoor,Sirsi,Karnataka',
'Katur,Sirsi,Karnataka',
'Kurli,Sirsi,Karnataka',
'Kusur,Sirsi,Karnataka',
'Mainalli,Sirsi,Karnataka',
'Malgi,Sirsi,Karnataka',
'Mundgod,Sirsi,Karnataka',
'Nandikatta,Sirsi,Karnataka',
'Neharunagar,Sirsi,Karnataka',
'Oralgi,Sirsi,Karnataka',
'Pala,Sirsi,Karnataka',
'Tibetan Colony,Sirsi,Karnataka',
'Siddapurcourts,Sirsi,Karnataka',
'Adkalli,Sirsi,Karnataka',
'Adukatta,Sirsi,Karnataka',
'Akkunji,Sirsi,Karnataka',
'Alvalli,Sirsi,Karnataka',
'Avarguppa,Sirsi,Karnataka',
'Balekoppa,Sirsi,Karnataka',
'Balesara,Sirsi,Karnataka',
'Bedkani,Sirsi,Karnataka',
'Bidrakan,Sirsi,Karnataka',
'Bilgi,Sirsi,Karnataka',
'Chapparmane,Sirsi,Karnataka',
'Devisara,Sirsi,Karnataka',
'Dodmane,Sirsi,Karnataka',
'Godlabeel,Sirsi,Karnataka',
'Golgod,Sirsi,Karnataka',
'Gubgod,Sirsi,Karnataka',
'Gunjagod,Sirsi,Karnataka',
'Halgeri,Sirsi,Karnataka',
'Hallibail,Sirsi,Karnataka',
'Harsikatta,Sirsi,Karnataka',
'Hasargod,Sirsi,Karnataka',
'Heggarni,Sirsi,Karnataka',
'Hegnoor,Sirsi,Karnataka',
'Herur,Sirsi,Karnataka',
'Hostota,Sirsi,Karnataka',
'Hukli,Sirsi,Karnataka',
'Hullunde,Sirsi,Karnataka',
'Itgi,Sirsi,Karnataka',
'Kanchikai,Sirsi,Karnataka',
'Kangod,Sirsi,Karnataka',
'Kansur,Sirsi,Karnataka',
'Karajgi,Sirsi,Karnataka',
'Kaunchur,Sirsi,Karnataka',
'Kodsar,Sirsi,Karnataka',
'Kodsaramuttalli,Sirsi,Karnataka',
'Kolsirsi,Sirsi,Karnataka',
'Kondli,Sirsi,Karnataka',
'Kyadgi,Sirsi,Karnataka',
'Manigar,Sirsi,Karnataka',
'Manmane,Sirsi,Karnataka',
'Mavingundi,Sirsi,Karnataka',
'Nejjur,Sirsi,Karnataka',
'Nidgod,Sirsi,Karnataka',
'Nidgod,Sirsi,Karnataka',
'Nilkund,Sirsi,Karnataka',
'Ravindranagar,Sirsi,Karnataka',
'Sampagod,Sirsi,Karnataka',
'Shelur,Sirsi,Karnataka',
'Shiralgi,Sirsi,Karnataka',
'Siddapur,Sirsi,Karnataka',
'Sovinkoppa,Sirsi,Karnataka',
'Thyagli,Sirsi,Karnataka',
'Tudguni,Sirsi,Karnataka',
'Tyarsi,Sirsi,Karnataka',
'Wajgod,Sirsi,Karnataka',
'Karkisaval,Sirsi,Karnataka',
'Sarkuli,Sirsi,Karnataka',
'Ajjibal,Sirsi,Karnataka',
'Akheti,Sirsi,Karnataka',
'Aminalli,Sirsi,Karnataka',
'Andagi,Sirsi,Karnataka',
'Arsapur,Sirsi,Karnataka',
'Bakkal,Sirsi,Karnataka',
'Balegadde,Sirsi,Karnataka',
'Balvalli,Sirsi,Karnataka',
'Banavasi,Sirsi,Karnataka',
'Bandal,Sirsi,Karnataka',
'Bankanal,Sirsi,Karnataka',
'Barur,Sirsi,Karnataka',
'Bhasi,Sirsi,Karnataka',
'Bhirumbe,Sirsi,Karnataka',
'Bommanalli,Sirsi,Karnataka',
'Boppanalli,Sirsi,Karnataka',
'C.P.Bazar,Sirsi,Karnataka',
'Chipgeri,Sirsi,Karnataka',
'Chipgi,Sirsi,Karnataka',
'Dasankoppa,Sirsi,Karnataka',
'Devanalli,Sirsi,Karnataka',
'Dodnalli,Sirsi,Karnataka',
'Gandhinagar,Sirsi,Karnataka',
'Gudnapur,Sirsi,Karnataka',
'Hebbatti,Sirsi,Karnataka',
'Heepnalli,Sirsi,Karnataka',
'Hegadekatta,Sirsi,Karnataka',
'Hemmadi,Sirsi,Karnataka',
'Hospet,Sirsi,Karnataka',
'Hulekal,Sirsi,Karnataka',
'Hulgol,Sirsi,Karnataka',
'Hunsekoppa,Sirsi,Karnataka',
'Husri,Sirsi,Karnataka',
'Isloor,Sirsi,Karnataka',
'Itguli,Sirsi,Karnataka',
'Janmane,Sirsi,Karnataka',
'Kadbal,Sirsi,Karnataka',
'Kakkalli,Sirsi,Karnataka',
'Kalve,Sirsi,Karnataka',
'Kangod,Sirsi,Karnataka',
'Khursi,Sirsi,Karnataka',
'Kodangadde,Sirsi,Karnataka',
'Koligar,Sirsi,Karnataka',
'Korlakatta,Sirsi,Karnataka',
'Kulve,Sirsi,Karnataka',
'Kundargi,Sirsi,Karnataka',
'Kupgadde,Sirsi,Karnataka',
'M.T.Street,Sirsi,Karnataka',
'Madralli,Sirsi,Karnataka',
'Malalgaon,Sirsi,Karnataka',
'Manjavalli,Sirsi,Karnataka',
'Manjguni,Sirsi,Karnataka',
'Maratikoppa,Sirsi,Karnataka',
'Mathadeval,Sirsi,Karnataka',
'Matttigar,Sirsi,Karnataka',
'Melinonikeri,Sirsi,Karnataka',
'Mensi,Sirsi,Karnataka',
'Mundganmane,Sirsi,Karnataka',
'Narur,Sirsi,Karnataka',
'Navilgar,Sirsi,Karnataka',
'Neggu,Sirsi,Karnataka',
'Nilekani,Sirsi,Karnataka',
'Onikeri,Sirsi,Karnataka',
'Puttanmane,Sirsi,Karnataka',
'Ragihosalli,Sirsi,Karnataka',
'Salkani,Sirsi,Karnataka',
'Sampkhanda,Sirsi,Karnataka',
'Shivalli,Sirsi,Karnataka',
'Sirsi Courts,Sirsi,Karnataka',
'Sirsi H.O,Sirsi,Karnataka',
'Sirsi Market,Sirsi,Karnataka',
'Sirsi Market,Sirsi,Karnataka',
'Sonda,Sirsi,Karnataka',
'Sugavi,Sirsi,Karnataka',
'Targod,Sirsi,Karnataka',
'Umblekoppa,Sirsi,Karnataka',
'Unchalli,Sirsi,Karnataka',
'Urtota,Sirsi,Karnataka',
'Vanalli,Sirsi,Karnataka',
'Yedalli,Sirsi,Karnataka',
'Yekkambi,Sirsi,Karnataka',
'Angod,Sirsi,Karnataka',
'Arbail,Sirsi,Karnataka',
'Balgimane,Sirsi,Karnataka',
'Bare,Sirsi,Karnataka',
'Chavatti,Sirsi,Karnataka',
'D.T.Road,Sirsi,Karnataka',
'Dehalli,Sirsi,Karnataka',
'Gullapur,Sirsi,Karnataka',
'Hasangi,Sirsi,Karnataka',
'Hittlalli,Sirsi,Karnataka',
'Hosalli,Sirsi,Karnataka',
'Idgundi,Sirsi,Karnataka',
'Kalache,Sirsi,Karnataka',
'Kirwatti,Sirsi,Karnataka',
'Kodlagadde,Sirsi,Karnataka',
'Madnoor,Sirsi,Karnataka',
'Manchikeri,Sirsi,Karnataka',
'Mavinmane,Sirsi,Karnataka',
'Nandolli,Sirsi,Karnataka',
'Shirnal,Sirsi,Karnataka',
'Telangeri,Sirsi,Karnataka',
'Ummachgi,Sirsi,Karnataka',
'Vajralli,Sirsi,Karnataka',
'Yellapur Bazar,Sirsi,Karnataka',
'Yellapur,Sirsi,Karnataka',
'Balgar,Sirsi,Karnataka',
'Bisgod,Sirsi,Karnataka',
'Chandguli,Sirsi,Karnataka',
'Geral,Sirsi,Karnataka',
'Hunshettikoppa,Sirsi,Karnataka',
'Kampli,Sirsi,Karnataka',
'Kannadgal,Sirsi,Karnataka',
'Kannigeri,Sirsi,Karnataka',
'Magod Colony,Sirsi,Karnataka',
'Sahasralli,Sirsi,Karnataka',
'Hutkhanda,Sirsi,Karnataka',
'Muttam,Mavelikara,Kerala',
'Amabalapuzha East,Alleppey,Kerala',
'Thiruvampady Junction,Alleppey,Kerala',
'Alappuzha North,Alleppey,Kerala',
'Alappuzha Bazar,Alleppey,Kerala',
'Alappuzha Collectorate,Alleppey,Kerala',
'Alappuzha District Hospital,Alleppey,Kerala',
'Alappuzha H.O,Alleppey,Kerala',
'Alappuzha Iron Bridge,Alleppey,Kerala',
'Alappuzha Medical College,Alleppey,Kerala',
'Alappuzha Mullackal,Alleppey,Kerala',
'Ambalapuzha,Alleppey,Kerala',
'Avalukunnu,Alleppey,Kerala',
'Chungom,Alleppey,Kerala',
'Illichira,Alleppey,Kerala',
'Kakkazhom,Alleppey,Kerala',
'Kalvoor,Alleppey,Kerala',
'Kanjipadom,Alleppey,Kerala',
'Kanjiramchira,Alleppey,Kerala',
'Karumady,Alleppey,Kerala',
'Kattoor Kalavoor,Alleppey,Kerala',
'Komalapuram,Alleppey,Kerala',
'Kommady Ward,Alleppey,Kerala',
'Kottankulangara,Alleppey,Kerala',
'Kuppapuram,Alleppey,Kerala',
'Mannancherry,Alleppey,Kerala',
'Pathirappally,Alleppey,Kerala',
'Pazhaveedu,Alleppey,Kerala',
'Pollethai,Alleppey,Kerala',
'Ponnad,Alleppey,Kerala',
'Punnapra North,Alleppey,Kerala',
'Punnapra,Alleppey,Kerala',
'Purakad,Alleppey,Kerala',
'Sanathanpuram,Alleppey,Kerala',
'Thathampally,Alleppey,Kerala',
'Thottappally,Alleppey,Kerala',
'Thumpoly,Alleppey,Kerala',
'Vadackal,Alleppey,Kerala',
'Vattayal Ward,Alleppey,Kerala',
'Vembanad Kayal,Alleppey,Kerala',
'Vysombhagom,Alleppey,Kerala',
'Thondankulangara,Alleppey,Kerala',
'Ala,Tiruvalla,Kerala',
'Angadical Chengannur,Tiruvalla,Kerala',
'Areekara,Mavelikara,Kerala',
'Bhudhanoor,Tiruvalla,Kerala',
'Chengannur H.O,Tiruvalla,Kerala',
'Chengannur RS,Tiruvalla,Kerala',
'Cheriyanadu,Tiruvalla,Kerala',
'Edanad,Tiruvalla,Kerala',
'Elanjimel,Tiruvalla,Kerala',
'Ennakkad,Mavelikara,Kerala',
'Eramallikkara,Tiruvalla,Kerala',
'Eramathoor,Mavelikara,Kerala',
'Kallisserry,Tiruvalla,Kerala',
'Karakkad,Mavelikara,Kerala',
'Kodukulanji,Mavelikara,Kerala',
'Kollakadavu,Mavelikara,Kerala',
'Kotta,Mavelikara,Kerala',
'Kozhuvallur,Mavelikara,Kerala',
'Kuttemperur,Mavelikara,Kerala',
'Mampra,Mavelikara,Kerala',
'Mannar,Mavelikara,Kerala',
'Mulakuzha,Mavelikara,Kerala',
'Mundancavu,Tiruvalla,Kerala',
'Neduvaramkodu,Mavelikara,Kerala',
'Olakettiambalam,Mavelikara,Kerala',
'Pandanad North,Tiruvalla,Kerala',
'Pavukara,Mavelikara,Kerala',
'Pennukkara,Mavelikara,Kerala',
'Peringala-mulakuzha,Mavelikara,Kerala',
'Peringilipuram,Mavelikara,Kerala',
'Perisserry,Tiruvalla,Kerala',
'Piralassery,Tiruvalla,Kerala',
'Poomala,Mavelikara,Kerala',
'Puliyoor,Tiruvalla,Kerala',
'Punthala,Mavelikara,Kerala',
'Puthencavu,Tiruvalla,Kerala',
'Thonackad,Tiruvalla,Kerala',
'Tiruvanvandur,Tiruvalla,Kerala',
'Vazharmangalam,Tiruvalla,Kerala',
'Venmony,Mavelikara,Kerala',
'Andhakaranazhy,Alleppey,Kerala',
'Arookutty,Alleppey,Kerala',
'Arthingal,Alleppey,Kerala',
'Chandiroor,Alleppey,Kerala',
'Cherthala Cutcherry,Alleppey,Kerala',
'Cherthala H.O,Alleppey,Kerala',
'Cherthala South,Alleppey,Kerala',
'Chethy,Alleppey,Kerala',
'Eramullur,Alleppey,Kerala',
'Ezhupunna,Alleppey,Kerala',
'Ezhupunna South,Alleppey,Kerala',
'Kadakkarapally,Alleppey,Kerala',
'Kalavamkodam,Alleppey,Kerala',
'Kanichukulangara,Alleppey,Kerala',
'Kannankara,Alleppey,Kerala',
'Karikad,Alleppey,Kerala',
'Kochuramapuram,Alleppey,Kerala',
'Kokothamangalam,Alleppey,Kerala',
'Kuruppankulangara,Alleppey,Kerala',
'Kuthiathode,Alleppey,Kerala',
'Manappuram,Alleppey,Kerala',
'Mararikulam North,Alleppey,Kerala',
'Maruthorvattom,Alleppey,Kerala',
'Mayithara Market,Alleppey,Kerala',
'Muhamma,Alleppey,Kerala',
'Muttathiparambu,Alleppey,Kerala',
'Naduathunagar,Alleppey,Kerala',
'Olavaipu,Alleppey,Kerala',
'Pallippuram,Alleppey,Kerala',
'Pallithode,Alleppey,Kerala',
'Panavally,Alleppey,Kerala',
'Parayakad,Alleppey,Kerala',
'Pattanacaud,Alleppey,Kerala',
'Perumbalam,Alleppey,Kerala',
'Poochackal,Alleppey,Kerala',
'Sethulekshmipuram,Alleppey,Kerala',
'Sreenarayapuram,Alleppey,Kerala',
'Thaickal,Alleppey,Kerala',
'Thanneermukkom,Alleppey,Kerala',
'Thirumalabhagom,Alleppey,Kerala',
'Thirunallur,Alleppey,Kerala',
'Thuravoor,Alleppey,Kerala',
'Thuravoor South,Alleppey,Kerala',
'Thycattussery,Alleppey,Kerala',
'Trichattukulam,Alleppey,Kerala',
'Vaduthala Jetty,Alleppey,Kerala',
'Valamnagalam,Alleppey,Kerala',
'Varanadu,Alleppey,Kerala',
'Varanam,Alleppey,Kerala',
'Vayalar,Alleppey,Kerala',
'Vettackal,Alleppey,Kerala',
'Arror,Alleppey,Kerala',
'Karuvatta North,Mavelikara,Kerala',
'Akamkudy,Mavelikara,Kerala',
'Arattupuzha North,Mavelikara,Kerala',
'Arattupuzha,Mavelikara,Kerala',
'Ayaparambu,Mavelikara,Kerala',
'Cheppaud,Mavelikara,Kerala',
'Cheruthana,Mavelikara,Kerala',
'Chingoli,Mavelikara,Kerala',
'Choolatheruvu,Mavelikara,Kerala',
'Erickavu,Mavelikara,Kerala',
'Eruva,Mavelikara,Kerala',
'Evur,Mavelikara,Kerala',
'Govindamuttom,Mavelikara,Kerala',
'Haripad,Mavelikara,Kerala',
'Kandallur,Mavelikara,Kerala',
'Kareelakulangara,Mavelikara,Kerala',
'Karthikappally,Mavelikara,Kerala',
'Karuvatta,Mavelikara,Kerala',
'Kayangulam College,Mavelikara,Kerala',
'Kayangulam H.O,Mavelikara,Kerala',
'Keerikad,Mavelikara,Kerala',
'Krishnapuram,Mavelikara,Kerala',
'Kumarapuram,Mavelikara,Kerala',
'Mahadevikadu,Mavelikara,Kerala',
'Mangalam,Mavelikara,Kerala',
'Mannarasala,Mavelikara,Kerala',
'Muthukulam,Mavelikara,Kerala',
'Muthukulam South,Mavelikara,Kerala',
'Muttom-alleppey,Mavelikara,Kerala',
'Naduvattom,Mavelikara,Kerala',
'Nangiarkulangara,Mavelikara,Kerala',
'Pallana,Mavelikara,Kerala',
'Pallipad,Mavelikara,Kerala',
'Pandy,Mavelikara,Kerala',
'Pathiyoor,Mavelikara,Kerala',
'Pattolimarket,Mavelikara,Kerala',
'Payipad,Mavelikara,Kerala',
'Perungala,Mavelikara,Kerala',
'Puthiyavila,Mavelikara,Kerala',
'Puthuppally,Mavelikara,Kerala',
'Thamallackal North,Mavelikara,Kerala',
'Thamallackal,Mavelikara,Kerala',
'Thrikkunnapuzha,Mavelikara,Kerala',
'Valiyaparambu,Mavelikara,Kerala',
'Valiyazheekkal,Mavelikara,Kerala',
'Veeyapuram,Mavelikara,Kerala',
'Neervilakom,Tiruvalla,Kerala',
'Anaprambal North,Tiruvalla,Kerala',
'Anaprambal,Tiruvalla,Kerala',
'Champakulam East,Alleppey,Kerala',
'Champakulam,Alleppey,Kerala',
'Changankary,Tiruvalla,Kerala',
'Chathurthiakary,Alleppey,Kerala',
'Chempumpuram,Alleppey,Kerala',
'Chennamkary,Alleppey,Kerala',
'Chennamkary East,Alleppey,Kerala',
'Cherukara Kuttanad,Alleppey,Kerala',
'Chirayakom,Alleppey,Kerala',
'Eara North,Changanacherry,Kerala',
'Kainady,Changanacherry,Kerala',
'Kainakary East,Alleppey,Kerala',
'Kainakary,Alleppey,Kerala',
'Kannady,Alleppey,Kerala',
'Kannady West,Alleppey,Kerala',
'Karikuzhy,Tiruvalla,Kerala',
'Kavalam,Alleppey,Kerala',
'Kavalam West,Alleppey,Kerala',
'Kavalm North,Alleppey,Kerala',
'Kayalpuram,Alleppey,Kerala',
'Kelemangalam,Alleppey,Kerala',
'Kunnumma Thakazhy,Alleppey,Kerala',
'Kunthirickal,Tiruvalla,Kerala',
'Kuttamangalam,Alleppey,Kerala',
'Moncombu,Alleppey,Kerala',
'Moncombu Thekkekara,Alleppey,Kerala',
'Narakathara,Alleppey,Kerala',
'Nedumudy,Alleppey,Kerala',
'Neelamperoor,Changanacherry,Kerala',
'Neerattupuram,Tiruvalla,Kerala',
'Ponga,Alleppey,Kerala',
'Pulincunnu,Alleppey,Kerala',
'Pullangadi,Alleppey,Kerala',
'Punnakunnathussery,Alleppey,Kerala',
'Punnakunnathussery South,Alleppey,Kerala',
'Ramankary,Tiruvalla,Kerala',
'Thakazhy,Alleppey,Kerala',
'Thalavady,Tiruvalla,Kerala',
'Thayamkary,Tiruvalla,Kerala',
'Thottuvathala,Alleppey,Kerala',
'Vezhapra,Tiruvalla,Kerala',
'Chekkidikkadu,Tiruvalla,Kerala',
'Kidangara,Changanacherry,Kerala',
'Kodupunna,Tiruvalla,Kerala',
'Kumarankary,Changanacherry,Kerala',
'Kunnamkary,Changanacherry,Kerala',
'Mithrakary,Tiruvalla,Kerala',
'Muttar,Tiruvalla,Kerala',
'Pandankary,Tiruvalla,Kerala',
'Thalavady South,Tiruvalla,Kerala',
'Veliyanadu North,Tiruvalla,Kerala',
'Veliyanadu,Tiruvalla,Kerala',
'Veliyanadu West,Tiruvalla,Kerala',
'Aryad North,Alleppey,Kerala',
'Arunoottimangalam,Mavelikara,Kerala',
'Athikattukulangara,Mavelikara,Kerala',
'Ayiranikudy,Mavelikara,Kerala',
'Bharanickavu,Mavelikara,Kerala',
'Charumoodu,Mavelikara,Kerala',
'Chennithala,Mavelikara,Kerala',
'Chennithala South,Mavelikara,Kerala',
'Cherukole,Mavelikara,Kerala',
'Chettikulangara,Mavelikara,Kerala',
'Chunakara,Mavelikara,Kerala',
'Eravankara,Mavelikara,Kerala',
'Erezha South,Mavelikara,Kerala',
'Ezhakadavu,Mavelikara,Kerala',
'Illippakulam,Mavelikara,Kerala',
'Kaduvinal,Mavelikara,Kerala',
'Kallimel,Mavelikara,Kerala',
'Kallumala,Mavelikara,Kerala',
'Kandiyoor,Mavelikara,Kerala',
'Kannamangalam,Mavelikara,Kerala',
'Kannanakuzhy,Mavelikara,Kerala',
'Kappil East,Mavelikara,Kerala',
'Karipuzha,Mavelikara,Kerala',
'Kattanam,Mavelikara,Kerala',
'Komallur,Mavelikara,Kerala',
'Kudassanad,Mavelikara,Kerala',
'Kunnam,Mavelikara,Kerala',
'Mankamkuzhy,Mavelikara,Kerala',
'Mavelikara Court,Mavelikara,Kerala',
'Mavelikara Cutcherry,Mavelikara,Kerala',
'Mavelikara H.O,Mavelikara,Kerala',
'Melpadom,Mavelikara,Kerala',
'Njakkanal,Mavelikara,Kerala',
'Nooranad,Mavelikara,Kerala',
'Nooranad Sanatorium,Mavelikara,Kerala',
'Padanilam,Mavelikara,Kerala',
'Pallarimangalam,Mavelikara,Kerala',
'Pallickal Naduvilemuri,Mavelikara,Kerala',
'Pallickal -nooranad,Mavelikara,Kerala',
'Pallickal,Mavelikara,Kerala',
'Panayil,Mavelikara,Kerala',
'Pattoor,Mavelikara,Kerala',
'Payyanallur,Mavelikara,Kerala',
'Pela,Mavelikara,Kerala',
'Pullikanakku,Mavelikara,Kerala',
'Punnamoodu,Mavelikara,Kerala',
'Puthenchantha,Mavelikara,Kerala',
'Puthiyacavu,Mavelikara,Kerala',
'Thamarakulam,Mavelikara,Kerala',
'Thannikunnu,Mavelikara,Kerala',
'Thattarambalam,Mavelikara,Kerala',
'Thazhakara,Mavelikara,Kerala',
'Thekkekara,Mavelikara,Kerala',
'Thripperunthura,Mavelikara,Kerala',
'Valiyakulangara,Mavelikara,Kerala',
'Vallikunnam,Mavelikara,Kerala',
'Varenickal,Mavelikara,Kerala',
'Vedaraplavu,Mavelikara,Kerala',
'Vetticode,Mavelikara,Kerala',
'Vettiyar,Mavelikara,Kerala',
'Erezha North,Mavelikara,Kerala',
'Airoor,Alwaye,Kerala',
'Aluva Bazar,Alwaye,Kerala',
'Aluva H.O,Alwaye,Kerala',
'Aluva Town Bus Stand,Alwaye,Kerala',
'Aluva-asokapuram,Alwaye,Kerala',
'Anappara-kalady,Alwaye,Kerala',
'Angamally,Alwaye,Kerala',
'Angamally South,Alwaye,Kerala',
'Athani,Alwaye,Kerala',
'Ayyampuzha,Alwaye,Kerala',
'Azhakam,Alwaye,Kerala',
'Chowara,Alwaye,Kerala',
'Chully,Alwaye,Kerala',
'Desom,Alwaye,Kerala',
'Edathala North,Alwaye,Kerala',
'Edathala,Alwaye,Kerala',
'Elavoor,Alwaye,Kerala',
'Erumathala,Alwaye,Kerala',
'Ezhattumugham,Alwaye,Kerala',
'Kalady Plantation,Alwaye,Kerala',
'Kalady,Alwaye,Kerala',
'Kanjoor,Alwaye,Kerala',
'Karukutty,Alwaye,Kerala',
'Kidangoor,Alwaye,Kerala',
'Kizhakkambalam,Alwaye,Kerala',
'Kochi Airport,Alwaye,Kerala',
'Kumarapuram,Alwaye,Kerala',
'Kurumassery,Alwaye,Kerala',
'Malayattoor,Alwaye,Kerala',
'Malayidumthuruth,Alwaye,Kerala',
'Manickamangalam,Alwaye,Kerala',
'Manjapra,Alwaye,Kerala',
'Mattoor,Alwaye,Kerala',
'Mekkad,Alwaye,Kerala',
'Mookkannur,Alwaye,Kerala',
'Naduvattam,Alwaye,Kerala',
'Naval Armament Depot - Aluva,Alwaye,Kerala',
'Nayathode,Alwaye,Kerala',
'Nedumbassery,Alwaye,Kerala',
'Neeleeswaram,Alwaye,Kerala',
'Paduvapuram,Alwaye,Kerala',
'Parakkadavu,Alwaye,Kerala',
'Parappuram,Alwaye,Kerala',
'Pattimattam,Alwaye,Kerala',
'Pazhamthottam,Alwaye,Kerala',
'Peringala,Alwaye,Kerala',
'Piraroor,Alwaye,Kerala',
'Puliyanam,Alwaye,Kerala',
'S.Aduvassery,Alwaye,Kerala',
'South Vazhakulam,Alwaye,Kerala',
'Sreemoolanagaram,Alwaye,Kerala',
'Thabore,Alwaye,Kerala',
'Thaikkattukara,Alwaye,Kerala',
'Thottakkattukara,Alwaye,Kerala',
'Thottumughom,Alwaye,Kerala',
'Thuravoor,Alwaye,Kerala',
'Thuravumkara,Alwaye,Kerala',
'Thuruthippuram,Irinjalakuda,Kerala',
'Uliyannoor,Alwaye,Kerala',
'Union Christian College,Alwaye,Kerala',
'Vadacode Kailas Colony,Ernakulam,Kerala',
'Vappalassery,Alwaye,Kerala',
'Vattaparambu,Alwaye,Kerala',
'Vellarappilly South,Alwaye,Kerala',
'Vempilly,Alwaye,Kerala',
'Vilangu,Alwaye,Kerala',
'Yordhanapuram,Alwaye,Kerala',
'Mannackanad,Kottayam,Kerala',
'Marangattupally,Kottayam,Kerala',
'Marangoli,Kottayam,Kerala',
'Maravanthuruthu,Kottayam,Kerala',
'Memuri,Kottayam,Kerala',
'Mevelloor,Kottayam,Kerala',
'Midayikunnu,Kottayam,Kerala',
'Mulakulam South,Kottayam,Kerala',
'Muttuchira,Kottayam,Kerala',
'Nazreth Hill,Kottayam,Kerala',
'Newsprint Nagar,Kottayam,Kerala',
'Njizhoor,Kottayam,Kerala',
'Ozhavur East,Kottayam,Kerala',
'Ozhavur,Kottayam,Kerala',
'Padinjarekkara,Kottayam,Kerala',
'Pakalomattom,Kottayam,Kerala',
'Palakkattumala,Kottayam,Kerala',
'Pallippurathussery,Kottayam,Kerala',
'Perumthuruth,Kottayam,Kerala',
'Peruva,Kottayam,Kerala',
'Pious Mount,Kottayam,Kerala',
'Poozhikole,Kottayam,Kerala',
'Puthuvely,Kottayam,Kerala',
'Thalayazham,Kottayam,Kerala',
'Thalayolaparambu,Kottayam,Kerala',
'Thirumani Venkita Puram,Kottayam,Kerala',
'Thiruvanpady,Kottayam,Kerala',
'Thottakom,Kottayam,Kerala',
'Udayanapuram,Kottayam,Kerala',
'Vadakara - Thalayolaparabu,Kottayam,Kerala',
'Vadakkenirappu,Kottayam,Kerala',
'Vadayar,Kottayam,Kerala',
'Vaikaprayar,Kottayam,Kerala',
'Vaikom H.O,Kottayam,Kerala',
'Vaikom Thekkenada,Kottayam,Kerala',
'Vakad,Kottayam,Kerala',
'Valavoor,Kottayam,Kerala',
'Vattukulam,Kottayam,Kerala',
'Vayala,Kottayam,Kerala',
'Vechoor,Kottayam,Kerala',
'Veliyannoor,Kottayam,Kerala',
'Vempally,Kottayam,Kerala',
'Edavarad,Vadakara,Kerala',
'Arikulam,Vadakara,Kerala',
'Athiyodi,Vadakara,Kerala',
'Avadukka,Vadakara,Kerala',
'Avala,Vadakara,Kerala',
'Avitanallur,Vadakara,Kerala',
'Balusseri,Vadakara,Kerala',
'Chakkittapara,Vadakara,Kerala',
'Cheekilode,Vadakara,Kerala',
'Cheliya,Vadakara,Kerala',
'Chemancheri,Vadakara,Kerala',
'Chempanoda,Vadakara,Kerala',
'Chengaroth,Vadakara,Kerala',
'Chenoli,Vadakara,Kerala',
'Cherukad,Vadakara,Kerala',
'Cheruvannur Meladi,Vadakara,Kerala',
'Chingapuram,Vadakara,Kerala',
'Edakulam Koyilandi,Vadakara,Kerala',
'Ekarool,Vadakara,Kerala',
'Emmamparamba,Vadakara,Kerala',
'Eramangalam,Vadakara,Kerala',
'Eravattur,Vadakara,Kerala',
'Iringath,Vadakara,Kerala',
'Iyyad,Vadakara,Kerala',
'Kadiyangad,Vadakara,Kerala',
'Kakkancheri,Vadakara,Kerala',
'Kakkayam,Vadakara,Kerala',
'Kallanode,Vadakara,Kerala',
'Kalpathur,Vadakara,Kerala',
'Kannadipoil,Vadakara,Kerala',
'Kappad,Vadakara,Kerala',
'Karayad,Vadakara,Kerala',
'Kariyathankavu,Vadakara,Kerala',
'Karumala,Vadakara,Kerala',
'Karuvannur,Vadakara,Kerala',
'Katalur,Vadakara,Kerala',
'Kavil,Vadakara,Kerala',
'Kayanna Bazar,Vadakara,Kerala',
'Kayanna,Vadakara,Kerala',
'Keezhariyur,Vadakara,Kerala',
'Kilinnanyam,Vadakara,Kerala',
'Kilur Meladi,Vadakara,Kerala',
'Kinalur,Vadakara,Kerala',
'Kizhpayur,Vadakara,Kerala',
'Kokkallur,Vadakara,Kerala',
'Kolakkad,Vadakara,Kerala',
'Kolathur,Vadakara,Kerala',
'Kollam,Vadakara,Kerala',
'Kongannur,Vadakara,Kerala',
'Koothali,Vadakara,Kerala',
'Kottur,Vadakara,Kerala',
'Koyilandi H.O,Vadakara,Kerala',
'Kozhukkallur,Vadakara,Kerala',
'Kunnathara,Vadakara,Kerala',
'Kurichagam,Vadakara,Kerala',
'Kuruvangad,Vadakara,Kerala',
'Kuttoth,Vadakara,Kerala',
'Mangad,Vadakara,Kerala',
'Mannankavu,Vadakara,Kerala',
'Mattanode,Vadakara,Kerala',
'Meladi,Vadakara,Kerala',
'Melur,Vadakara,Kerala',
'Mennaniam,Vadakara,Kerala',
'Meppayur,Vadakara,Kerala',
'Modakkallur,Vadakara,Kerala',
'Moolad,Vadakara,Kerala',
'Muchukunnu,Vadakara,Kerala',
'Mudadi North,Vadakara,Kerala',
'Mudadi,Vadakara,Kerala',
'Muthukad,Vadakara,Kerala',
'Muthuuvana,Vadakara,Kerala',
'Muthuvannacha,Vadakara,Kerala',
'Muyipoth,Vadakara,Kerala',
'Naderi,Vadakara,Kerala',
'Naduvannur,Vadakara,Kerala',
'Naduvathur,Vadakara,Kerala',
'Nochat,Vadakara,Kerala',
'Oravil,Vadakara,Kerala',
'Paleri,Vadakara,Kerala',
'Paleri Town,Vadakara,Kerala',
'Pallikara,Vadakara,Kerala',
'Panangad Qdi,Vadakara,Kerala',
'Payyoli Angadi,Vadakara,Kerala',
'Perampra,Vadakara,Kerala',
'Peruvannamuzhi,Vadakara,Kerala',
'Peruvattur,Vadakara,Kerala',
'Poozhithode,Vadakara,Kerala',
'Punath,Vadakara,Kerala',
'Purakkad,Vadakara,Kerala',
'Quilandibazar,Vadakara,Kerala',
'Talayad,Vadakara,Kerala',
'Thalakolathur,Vadakara,Kerala',
'Thandorapara,Vadakara,Kerala',
'Thuruthiyad,Vadakara,Kerala',
'Thuvakkode,Vadakara,Kerala',
'Tikkoti,Vadakara,Kerala',
'Tiruvangoor,Vadakara,Kerala',
'Tiruvode,Vadakara,Kerala',
'Ulliyeri,Vadakara,Kerala',
'Unnikulam,Vadakara,Kerala',
'Urallur,Vadakara,Kerala',
'Vakayad,Vadakara,Kerala',
'Vattoli Bazar,Vadakara,Kerala',
'Vayalada,Vadakara,Kerala',
'Velur West,Vadakara,Kerala',
'Atholi,Vadakara,Kerala',
'Thottumukkam,Manjeri,Kerala',
'Adivaram Pudupadi,Calicut,Kerala',
'Alli,Calicut,Kerala',
'Anakampoyil,Calicut,Kerala',
'Annasseri,Vadakara,Kerala',
'Arakinar,Calicut,Kerala',
'Avilora,Calicut,Kerala',
'Beypore North,Calicut,Kerala',
'Beypore,Calicut,Kerala',
'Calicut Arts & Science College,Calicut,Kerala',
'Calicut Beach,Calicut,Kerala',
'Calicut City,Calicut,Kerala',
'Calicut Civil Station H.O,Calicut,Kerala',
'Calicut Collectorate,Calicut,Kerala',
'Calicut Courts,Calicut,Kerala',
'Calicut H.O,Calicut,Kerala',
'Calicut Medical College,Calicut,Kerala',
'Calicut R.S.,Calicut,Kerala',
'Chalapuram,Calicut,Kerala',
'Chaliyam,Calicut,Kerala',
'Chamal,Calicut,Kerala',
'Chathamangalam,Calicut,Kerala',
'Chelannur,Calicut,Kerala',
'Chelavur,Calicut,Kerala',
'Chembu Kadavu,Calicut,Kerala',
'Chennamangallur,Calicut,Kerala',
'Cherooppa,Calicut,Kerala',
'Cherukulathur,Calicut,Kerala',
'Cheruvadi,Calicut,Kerala',
'Cheruvannur,Calicut,Kerala',
'Chevarambalam,Calicut,Kerala',
'Chevayur,Calicut,Kerala',
'Chulur,Calicut,Kerala',
'Devagiri College,Calicut,Kerala',
'East Hill,Calicut,Kerala',
'Edakkad - West Hill,Calicut,Kerala',
'Edakkara - Quilandy,Calicut,Kerala',
'Elathur,Calicut,Kerala',
'Elettil,Calicut,Kerala',
'Eranhikkal,Calicut,Kerala',
'Eranhipalam,Calicut,Kerala',
'Eravannur,Calicut,Kerala',
'Farook College,Calicut,Kerala',
'Feroke Pettah,Calicut,Kerala',
'Feroke,Calicut,Kerala',
'Govinda Puram,Calicut,Kerala',
'Guruvayurappan College,Calicut,Kerala',
'Iim Kozhikode Campus,Calicut,Kerala',
'Iringallur,Calicut,Kerala',
'Irivallur,Calicut,Kerala',
'Kadalundi,Calicut,Kerala',
'Kakkad Pudupadi,Calicut,Kerala',
'Kakkatampoyil,Calicut,Kerala',
'Kakkoti,Calicut,Kerala',
'Kakkur,Calicut,Kerala',
'Kallai-kozhikode,Calicut,Kerala',
'Kallurutty,Calicut,Kerala',
'Kannan Kara,Calicut,Kerala',
'Kannancheri,Calicut,Kerala',
'Kanni Paramba,Calicut,Kerala',
'Kannoth,Calicut,Kerala',
'Karad Paramba,Calicut,Kerala',
'Karanthur,Calicut,Kerala',
'Karaparamba,Calicut,Kerala',
'Karasseri,Calicut,Kerala',
'Karuvampoyil,Calicut,Kerala',
'Karuvanthuruthy,Calicut,Kerala',
'Karuvasseri,Calicut,Kerala',
'Kattippara,Calicut,Kerala',
'Kayal,Calicut,Kerala',
'Kilakkoth,Calicut,Kerala',
'Kizhakkumuri,Calicut,Kerala',
'Kodiyathur,Calicut,Kerala',
'Kolathara,Calicut,Kerala',
'Kommeri,Calicut,Kerala',
'Konott,Calicut,Kerala',
'Koombara,Calicut,Kerala',
'Koombara Bazar,Calicut,Kerala',
'Kotancheri-tamaracheri,Calicut,Kerala',
'Kottamparamba,Calicut,Kerala',
'Kottuli,Calicut,Kerala',
'Kotuvalli,Calicut,Kerala',
'Kudathai,Calicut,Kerala',
'Kudathai Bazar,Calicut,Kerala',
'Kuliramutty,Calicut,Kerala',
'Kumaranellur,Calicut,Kerala',
'Kundungal,Calicut,Kerala',
'Kunnamangalam Mini Industrial,Calicut,Kerala',
'Kunnamangalam,Calicut,Kerala',
'Kuppayakode,Calicut,Kerala',
'Kuruvattur,Calicut,Kerala',
'Kutaranni,Calicut,Kerala',
'Kuthiravattom,Calicut,Kerala',
'Kuttikkattur,Calicut,Kerala',
'Kythapoyil,Calicut,Kerala',
'Madavoor,Calicut,Kerala',
'Maikavu,Calicut,Kerala',
'Mailellampara,Calicut,Kerala',
'Makkada,Calicut,Kerala',
'Malaparamba,Calicut,Kerala',
'Malayamma,Calicut,Kerala',
'Manasseri,Calicut,Kerala',
'Manha Kadavu,Calicut,Kerala',
'Manipuram,Calicut,Kerala',
'Mankavu,Calicut,Kerala',
'Mannur,Calicut,Kerala',
'Marikunnu,Calicut,Kerala',
'Mavoor,Calicut,Kerala',
'Mayanad,Calicut,Kerala',
'Meemutty,Calicut,Kerala',
'Mokkam,Calicut,Kerala',
'Morikkara,Calicut,Kerala',
'Mundur -- Kozhikode,Calicut,Kerala',
'Murampathy,Calicut,Kerala',
'Muthappan Puzha,Calicut,Kerala',
'Muttancheri,Calicut,Kerala',
'Mysore Mala,Calicut,Kerala',
'Nadakavu,Calicut,Kerala',
'Nallalam,Calicut,Kerala',
'Nanminda,Calicut,Kerala',
'Narikkuni,Calicut,Kerala',
'Nayar Kuzhi,Calicut,Kerala',
'Nedungottur,Calicut,Kerala',
'Neeleswaram,Calicut,Kerala',
'Nellicode,Calicut,Kerala',
'Nellika Paramba,Calicut,Kerala',
'Nit Campus Po.Kozhikode,Calicut,Kerala',
'Nooramthode,Calicut,Kerala',
'Olavanna,Calicut,Kerala',
'Omasseri,Calicut,Kerala',
'Padanilam,Calicut,Kerala',
'Palath,Calicut,Kerala',
'Pannicode,Calicut,Kerala',
'Pannikkottur,Calicut,Kerala',
'Pantheerankavu,Calicut,Kerala',
'Parambil,Calicut,Kerala',
'Parannur,Calicut,Kerala',
'Parappanpoyil,Calicut,Kerala',
'Parappil,Calicut,Kerala',
'Paropadi,Calicut,Kerala',
'Pavandur,Calicut,Kerala',
'Payimbra,Calicut,Kerala',
'Pazhur,Calicut,Kerala',
'Peringalam,Calicut,Kerala',
'Perumanna,Calicut,Kerala',
'Perumukham,Calicut,Kerala',
'Peruvayal,Calicut,Kerala',
'Pilasseri,Calicut,Kerala',
'Pokkunnu,Calicut,Kerala',
'Ponnamkayam,Calicut,Kerala',
'Poovaranthod,Calicut,Kerala',
'Poovattu Paramba,Calicut,Kerala',
'Puduppadi,Calicut,Kerala',
'Pulluram Para,Calicut,Kerala',
'Punnakkal,Calicut,Kerala',
'Punnasseri,Calicut,Kerala',
'Punnur - Cherupalam,Calicut,Kerala',
'Puthiya Nirathu,Calicut,Kerala',
'Puthiyangadi,Calicut,Kerala',
'Puthiyara,Calicut,Kerala',
'Puthur- Kotuvalli,Calicut,Kerala',
'Ramanattukara,Calicut,Kerala',
'Santhi Nagar,Calicut,Kerala',
'Sreerama Krishna Mission,Calicut,Kerala',
'St.Vincent Colony,Calicut,Kerala',
'Tali,Calicut,Kerala',
'Tamaracheri,Calicut,Kerala',
'Thachampoyil,Calicut,Kerala',
'Thambalamanna,Calicut,Kerala',
'Theyyappara,Calicut,Kerala',
'Thiruthiyad,Calicut,Kerala',
'Tiruvambadi,Calicut,Kerala',
'Tiruvannur,Calicut,Kerala',
'Tiruvannur Nada,Calicut,Kerala',
'Vaidyarangadi,Calicut,Kerala',
'Valiyaparamba,Calicut,Kerala',
'Vavad,Calicut,Kerala',
'Velancode,Calicut,Kerala',
'Velimanna,Calicut,Kerala',
'Vellalasseri,Calicut,Kerala',
'Vellayikkode,Calicut,Kerala',
'Vellayil,Calicut,Kerala',
'Velliparamba,Calicut,Kerala',
'Venappara,Calicut,Kerala',
'Vengeri,Calicut,Kerala',
'Vrindavan Colony,Calicut,Kerala',
'West Hill Beach,Calicut,Kerala',
'West Hill Chungam,Calicut,Kerala',
'West Hill,Calicut,Kerala',
'Vengalam,Calicut,Kerala',
'Chembra,Calicut,Kerala',
'Kabanigiri,Calicut,Kerala',
'Abhayagiri,Vadakara,Kerala',
'Adukkath,Vadakara,Kerala',
'Akkal,Vadakara,Kerala',
'Arur,Vadakara,Kerala',
'Ayancheri,Vadakara,Kerala',
'Ayanikkad,Vadakara,Kerala',
'Azhiyur,Vadakara,Kerala',
'Bhumivathukkal,Vadakara,Kerala',
'Chaniyankadavu,Vadakara,Kerala',
'Chappanthottam,Vadakara,Kerala',
'Chathangottunada,Vadakara,Kerala',
'Cheekkonnummal,Vadakara,Kerala',
'Cheekonnummal West,Vadakara,Kerala',
'Chekkiyad,Vadakara,Kerala',
'Chelakkad,Vadakara,Kerala',
'Chemmarathur,Vadakara,Kerala',
'Cherandathur,Vadakara,Kerala',
'Cherapuram,Vadakara,Kerala',
'Cherumoth,Vadakara,Kerala',
'Chombala,Vadakara,Kerala',
'Chorode East,Vadakara,Kerala',
'Chorode,Vadakara,Kerala',
'Chuzhali,Vadakara,Kerala',
'Edacheri North,Vadakara,Kerala',
'Edacheri,Vadakara,Kerala',
'Eramala,Vadakara,Kerala',
'Indira Nagar,Vadakara,Kerala',
'Iringal,Vadakara,Kerala',
'Iringannur,Vadakara,Kerala',
'Iyyangode,Vadakara,Kerala',
'Kakkattil,Vadakara,Kerala',
'Kallachi,Vadakara,Kerala',
'Kallunira,Vadakara,Kerala',
'Kannookkara,Vadakara,Kerala',
'Karandode,Vadakara,Kerala',
'Karingad,Vadakara,Kerala',
'Karthikappally,Vadakara,Kerala',
'Katameri,Vadakara,Kerala',
'Katcheri,Vadakara,Kerala',
'Kavilampara,Vadakara,Kerala',
'Kayakodi,Vadakara,Kerala',
'Kayappanichi,Vadakara,Kerala',
'Keezhil,Vadakara,Kerala',
'Kodiyura,Vadakara,Kerala',
'Korothroad,Vadakara,Kerala',
'Kotancheri,Vadakara,Kerala',
'Kottakkal-igl,Vadakara,Kerala',
'Kottappalli,Vadakara,Kerala',
'Kunduthode,Vadakara,Kerala',
'Kuningad,Vadakara,Kerala',
'Kunnummakkara,Vadakara,Kerala',
'Kurikkilad,Vadakara,Kerala',
'Kurinhaliyode,Vadakara,Kerala',
'Kuttiadi,Vadakara,Kerala',
'Madappalli College,Vadakara,Kerala',
'Mahe,Vadakara,Kerala',
'Mandarathur,Vadakara,Kerala',
'Maniyur,Vadakara,Kerala',
'Marudonkara,Vadakara,Kerala',
'Mayyannur,Vadakara,Kerala',
'Memunda,Vadakara,Kerala',
'Meppayil,Vadakara,Kerala',
'Moilothara,Vadakara,Kerala',
'Mokeri Nadapuram,Vadakara,Kerala',
'Mudavantheri,Vadakara,Kerala',
'Mullambath,Vadakara,Kerala',
'Muthuvadathur,Vadakara,Kerala',
'Muttungal,Vadakara,Kerala',
'Muttungal West,Vadakara,Kerala',
'Nadakkuthala,Vadakara,Kerala',
'Nadapuram,Vadakara,Kerala',
'Naripetta,Vadakara,Kerala',
'Nedumparamba,Vadakara,Kerala',
'Nittur,Vadakara,Kerala',
'Nitumannur,Vadakara,Kerala',
'Nut Street,Vadakara,Kerala',
'Onchiyam,Vadakara,Kerala',
'Orkatteri,Vadakara,Kerala',
'Padiripetta,Vadakara,Kerala',
'Palayad Nada,Vadakara,Kerala',
'Parakkadavu,Vadakara,Kerala',
'Pasukkadavu,Vadakara,Kerala',
'Pathiyarakkara,Vadakara,Kerala',
'Perode,Vadakara,Kerala',
'Ponmeri Parambil,Vadakara,Kerala',
'Poolakkul,Vadakara,Kerala',
'Poothampara,Vadakara,Kerala',
'Puduppanam,Vadakara,Kerala',
'Puliyavil,Vadakara,Kerala',
'Purameri,Vadakara,Kerala',
'Puthur,Vadakara,Kerala',
'Rayarangoth,Vadakara,Kerala',
'Siddhasamaj,Vadakara,Kerala',
'Taliyil,Vadakara,Kerala',
'Thanakottur,Vadakara,Kerala',
'Tharopoyil,Vadakara,Kerala',
'Thinur,Vadakara,Kerala',
'Thiruvallur,Vadakara,Kerala',
'Thodannur,Vadakara,Kerala',
'Tuneri,Vadakara,Kerala',
'Vadakara Beach,Vadakara,Kerala',
'Vadakara H.O,Vadakara,Kerala',
'Valayam,Vadakara,Kerala',
'Valliyad,Vadakara,Kerala',
'Vanimal,Vadakara,Kerala',
'Vannathichira,Vadakara,Kerala',
'Varikoli,Vadakara,Kerala',
'Vatayam,Vadakara,Kerala',
'Vattoli,Vadakara,Kerala',
'Vayikkilassery,Vadakara,Kerala',
'Velom,Vadakara,Kerala',
'Velom Peruvayal,Vadakara,Kerala',
'Vilangad,Vadakara,Kerala',
'Villyappalli,Vadakara,Kerala',
'Vishnumangalam,Vadakara,Kerala',
'Azhinjilam,Calicut,Kerala',
'Puducode - Feroke,Calicut,Kerala',
'Vazhayur,Calicut,Kerala',
'Vazhayur East,Calicut,Kerala',
'Akkaparamba,Manjeri,Kerala',
'Amayur,Manjeri,Kerala',
'Anakkayam,Manjeri,Kerala',
'Andiyoorkunnu,Manjeri,Kerala',
'Areacode,Manjeri,Kerala',
'Arimbra,Manjeri,Kerala',
'Ayikkarapadi,Manjeri,Kerala',
'Calicut Airport,Manjeri,Kerala',
'Chathallur,Manjeri,Kerala',
'Chembrassei,Manjeri,Kerala',
'Chembrasseri East,Manjeri,Kerala',
'Chemmarakkattur,Manjeri,Kerala',
'Cheruvayur,Manjeri,Kerala',
'Chikkode,Manjeri,Kerala',
'Chirayil,Manjeri,Kerala',
'Downhill,Manjeri,Kerala',
'Edavanna,Manjeri,Kerala',
'Elankur,Manjeri,Kerala',
'Eranhikode,Manjeri,Kerala',
'Hajiarpalli,Manjeri,Kerala',
'Irumbuzhi,Manjeri,Kerala',
'Iruvetti,Manjeri,Kerala',
'Kadambode,Manjeri,Kerala',
'Kannamvettikavu,Manjeri,Kerala',
'Karakkunnu,Manjeri,Kerala',
'Karumarakkad,Manjeri,Kerala',
'Karuvambram West,Manjeri,Kerala',
'Kavanur,Manjeri,Kerala',
'Kizhuparamba,Manjeri,Kerala',
'Kolaparamba,Manjeri,Kerala',
'Kondotti,Manjeri,Kerala',
'Koomankulam,Manjeri,Kerala',
'Kuzhimanna,Manjeri,Kerala',
'Maithra,Manjeri,Kerala',
'Malappuram Civil Station,Manjeri,Kerala',
'Malappuram H.O,Manjeri,Kerala',
'Manhappatta,Manjeri,Kerala',
'Manjeri Bazar,Manjeri,Kerala',
'Manjeri College,Manjeri,Kerala',
'Manjeri-kla H.O,Manjeri,Kerala',
'Mariyad,Manjeri,Kerala',
'Melangadi,Manjeri,Kerala',
'Melmuri,Manjeri,Kerala',
'Mongam,Manjeri,Kerala',
'Morayur,Manjeri,Kerala',
'Mundakkal,Manjeri,Kerala',
'Munduparmba,Manjeri,Kerala',
'Muthuparamba,Manjeri,Kerala',
'Muthuvallur,Manjeri,Kerala',
'Narukara,Manjeri,Kerala',
'Nediyirippu,Manjeri,Kerala',
'Nellikuth,Manjeri,Kerala',
'Olamathil,Manjeri,Kerala',
'Olavattur,Manjeri,Kerala',
'Olukur,Manjeri,Kerala',
'Omanur,Manjeri,Kerala',
'Palakkad(MLP),Manjeri,Kerala',
'Panampilavu,Manjeri,Kerala',
'Pandallur,Manjeri,Kerala',
'Pandallur Hills,Manjeri,Kerala',
'Pandikkad,Manjeri,Kerala',
'Pannippara,Manjeri,Kerala',
'Pappinippara,Manjeri,Kerala',
'Pathappiriyam,Manjeri,Kerala',
'Pathiriyal,Manjeri,Kerala',
'Pattarkadavu,Manjeri,Kerala',
'Payyanad,Manjeri,Kerala',
'Perakamanna,Manjeri,Kerala',
'Perimbalam,Manjeri,Kerala',
'Peruparamba-ugrapuram,Manjeri,Kerala',
'Pookkottur,Manjeri,Kerala',
'Poolamanna,Manjeri,Kerala',
'Poovathikkal,Manjeri,Kerala',
'Porur,Manjeri,Kerala',
'Puliyakkode,Manjeri,Kerala',
'Pullancheri,Manjeri,Kerala',
'Pulliparamba,Manjeri,Kerala',
'Pulpatta,Manjeri,Kerala',
'Tavanur-feroke,Manjeri,Kerala',
'Thottilangadi,Manjeri,Kerala',
'Thurakkal,Manjeri,Kerala',
'Trikkalangode,Manjeri,Kerala',
'Trippanachi,Manjeri,Kerala',
'Urangattiri,Manjeri,Kerala',
'Vakkethodi,Manjeri,Kerala',
'Valillapuzha,Manjeri,Kerala',
'Valiyaparamba,Manjeri,Kerala',
'Valluvambram,Manjeri,Kerala',
'Valluvangad South,Manjeri,Kerala',
'Vazhakkad,Manjeri,Kerala',
'Vellur,Manjeri,Kerala',
'Vettilappara,Manjeri,Kerala',
'Vilayil,Manjeri,Kerala',
'Karuvambram,Manjeri,Kerala',
'Pulikkal,Manjeri,Kerala',
'Adakkakundu,Manjeri,Kerala',
'Amarambalam,Manjeri,Kerala',
'Amarambalam South,Manjeri,Kerala',
'Ambalakkadavu,Manjeri,Kerala',
'Anchachavady,Manjeri,Kerala',
'Arimanal,Manjeri,Kerala',
'Aurvacode,Manjeri,Kerala',
'Bhoodan Colony,Manjeri,Kerala',
'Chandakkunnu,Manjeri,Kerala',
'Chathangottupuram,Manjeri,Kerala',
'Chettippadam,Manjeri,Kerala',
'Chokkad,Manjeri,Kerala',
'Chulliyode,Manjeri,Kerala',
'Chungathara,Manjeri,Kerala',
'Edakkara-nilambur,Manjeri,Kerala',
'Edivanna,Manjeri,Kerala',
'Eranhimangad,Manjeri,Kerala',
'Erumamunda,Manjeri,Kerala',
'Ezhupathekkar,Manjeri,Kerala',
'Iringattiri,Manjeri,Kerala',
'Kalikavu,Manjeri,Kerala',
'Kalkundu,Manjeri,Kerala',
'Kambalakallu,Manjeri,Kerala',
'Kappil,Manjeri,Kerala',
'Karad,Manjeri,Kerala',
'Karakkode,Manjeri,Kerala',
'Karapuram,Manjeri,Kerala',
'Karulai,Manjeri,Kerala',
'Karuvarakundu,Manjeri,Kerala',
'Kavalamukkatta,Manjeri,Kerala',
'Kerala Estate,Manjeri,Kerala',
'Koorad,Manjeri,Kerala',
'Kunnummalpotti,Manjeri,Kerala',
'Kurumbalangode,Manjeri,Kerala',
'Kuttathy,Manjeri,Kerala',
'Mampad College,Manjeri,Kerala',
'Mampad,Manjeri,Kerala',
'Mampattumoola,Manjeri,Kerala',
'Manimooly,Manjeri,Kerala',
'Mannathipoyil,Manjeri,Kerala',
'Marutha,Manjeri,Kerala',
'Meppadam,Manjeri,Kerala',
'Modapoika,Manjeri,Kerala',
'Moothedam,Manjeri,Kerala',
'Munderi,Manjeri,Kerala',
'Naduvath,Manjeri,Kerala',
'Nallanthanni,Manjeri,Kerala',
'Nambooripotty,Manjeri,Kerala',
'Neelancheri,Manjeri,Kerala',
'Nilambur RS,Manjeri,Kerala',
'Nilambur,Manjeri,Kerala',
'Padiripadam,Manjeri,Kerala',
'Palakkalvetta,Manjeri,Kerala',
'Palemad,Manjeri,Kerala',
'Palengara,Manjeri,Kerala',
'Pallikuth,Manjeri,Kerala',
'Pathar,Manjeri,Kerala',
'Pookkottumpadam,Manjeri,Kerala',
'Pookottumanna,Manjeri,Kerala',
'Poongode,Manjeri,Kerala',
'Pullengode,Manjeri,Kerala',
'Pullippadam,Manjeri,Kerala',
'Pulvetta,Manjeri,Kerala',
'Punnappala,Manjeri,Kerala',
'Ramankuth,Manjeri,Kerala',
'T.K.Colony,Manjeri,Kerala',
'Tharis,Manjeri,Kerala',
'Theyyathumpadam,Manjeri,Kerala',
'Tiruvali,Manjeri,Kerala',
'Tuvvur,Manjeri,Kerala',
'Uppada,Manjeri,Kerala',
'Vadakkumpadam,Manjeri,Kerala',
'Vadapuram,Manjeri,Kerala',
'Vaniyambalam,Manjeri,Kerala',
'Vazhikkadavu,Manjeri,Kerala',
'Vellayur,Manjeri,Kerala',
'Wandoor,Manjeri,Kerala',
'Aliparamba,Manjeri,Kerala',
'Amminikkad,Manjeri,Kerala',
'Anamangad,Manjeri,Kerala',
'Angadipuram,Manjeri,Kerala',
'Aripra,Manjeri,Kerala',
'Arkkuparamba,Manjeri,Kerala',
'Chattipparamba,Manjeri,Kerala',
'Chelakkad,Manjeri,Kerala',
'Chemmalasseri,Manjeri,Kerala',
'Chemmaniyode,Manjeri,Kerala',
'Cherakkaparamba,Manjeri,Kerala',
'Cherukara,Manjeri,Kerala',
'Edapatta,Manjeri,Kerala',
'Edayattur,Manjeri,Kerala',
'Elad,Manjeri,Kerala',
'Eravimangalam,Manjeri,Kerala',
'Kadannamanna,Manjeri,Kerala',
'Kizhakkumpadam,Manjeri,Kerala',
'Kizhattur,Manjeri,Kerala',
'Kodur-malabar,Manjeri,Kerala',
'Kolathur-MLP,Manjeri,Kerala',
'Koottil,Manjeri,Kerala',
'Kottilangadi,Manjeri,Kerala',
'Kunnappally,Manjeri,Kerala',
'Kuruvambalam,Manjeri,Kerala',
'Makkaraparamba,Manjeri,Kerala',
'Manalaya,Manjeri,Kerala',
'Mankada Pallippuram,Manjeri,Kerala',
'Mankada,Manjeri,Kerala',
'Mannarmala,Manjeri,Kerala',
'Mattarakkal,Manjeri,Kerala',
'Melattur,Manjeri,Kerala',
'Moorkkanad,Manjeri,Kerala',
'Padinhattumuri,Manjeri,Kerala',
'Padirikode,Manjeri,Kerala',
'Palachode,Manjeri,Kerala',
'Palathole,Manjeri,Kerala',
'Panga,Manjeri,Kerala',
'Panga Chendy,Manjeri,Kerala',
'Panga South,Manjeri,Kerala',
'Pariyapuram,Manjeri,Kerala',
'Pathaikara,Manjeri,Kerala',
'Pattikkad,Manjeri,Kerala',
'Pazhamallur,Manjeri,Kerala',
'Perintalmanna Bazar,Manjeri,Kerala',
'Perintalmanna,Manjeri,Kerala',
'Perinthattiri,Manjeri,Kerala',
'Ponniyakurissi,Manjeri,Kerala',
'Poonthavanam,Manjeri,Kerala',
'Pulamanthole,Manjeri,Kerala',
'Puthanangadi,Manjeri,Kerala',
'Puzhakkattiri,Manjeri,Kerala',
'Ramapuram,Manjeri,Kerala',
'Talekode,Manjeri,Kerala',
'Talekode West,Manjeri,Kerala',
'Thachinganadam,Manjeri,Kerala',
'Thelakkad,Manjeri,Kerala',
'Thootha,Manjeri,Kerala',
'Tirurkad,Manjeri,Kerala',
'Vadakkangara,Manjeri,Kerala',
'Valambur,Manjeri,Kerala',
'Valamkulam,Manjeri,Kerala',
'Valapuram,Manjeri,Kerala',
'Vallikkapatta,Manjeri,Kerala',
'Vattalur,Manjeri,Kerala',
'Vazhenkada,Manjeri,Kerala',
'Vellila,Manjeri,Kerala',
'Velliyanchery,Manjeri,Kerala',
'Vengad,Manjeri,Kerala',
'Vengoor,Manjeri,Kerala',
'Vettathur,Manjeri,Kerala',
'Kadungapurm,Manjeri,Kerala',
'Alankode,Tirur,Kerala',
'Athalur,Tirur,Kerala',
'Ayankalam,Tirur,Kerala',
'Ayilakkad,Tirur,Kerala',
'Ayirur,Tirur,Kerala',
'Biyyam,Tirur,Kerala',
'Cheruvallur,Tirur,Kerala',
'Edapal,Tirur,Kerala',
'Eramangalam,Tirur,Kerala',
'Gramam,Tirur,Kerala',
'Iswaramangalam,Tirur,Kerala',
'Kadancheri,Tirur,Kerala',
'Kadavanad,Tirur,Kerala',
'Kaladi-MLP,Tirur,Kerala',
'Kanhiramukku,Tirur,Kerala',
'Karukathiruthy,Tirur,Kerala',
'Kokkur,Tirur,Kerala',
'Kololamba,Tirur,Kerala',
'Marancheri,Tirur,Kerala',
'Mookkuthala,Tirur,Kerala',
'Mudur,Tirur,Kerala',
'Nannamukku,Tirur,Kerala',
'Nannamukku South,Tirur,Kerala',
'Nariparamba,Tirur,Kerala',
'Othalur West,Tirur,Kerala',
'Palapetty,Tirur,Kerala',
'Pazhanji-mlp,Tirur,Kerala',
'Perumaparamba,Tirur,Kerala',
'Perumbadappu,Tirur,Kerala',
'Pidavannur,Tirur,Kerala',
'Polpakara,Tirur,Kerala',
'Ponani H.O,Tirur,Kerala',
'Ponani Nagaram,Tirur,Kerala',
'Ponani South,Tirur,Kerala',
'Puranga,Tirur,Kerala',
'Sugapuram,Tirur,Kerala',
'Tavanur,Tirur,Kerala',
'Trikkanapuram,Tirur,Kerala',
'Vattamkulam,Tirur,Kerala',
'Veliankode,Tirur,Kerala',
'Kunnakkavu,Manjeri,Kerala',
'Alathiyur,Tirur,Kerala',
'Ananthavur,Tirur,Kerala',
'Athavanad,Tirur,Kerala',
'Athrisseri,Tirur,Kerala',
'Bettath Pudiangadi,Tirur,Kerala',
'Chamravattom,Tirur,Kerala',
'Chappanangadi,Tirur,Kerala',
'Chengottur,Tirur,Kerala',
'Chennara,Tirur,Kerala',
'Cheriyamundam,Tirur,Kerala',
'Cherushola,Tirur,Kerala',
'Codacal,Tirur,Kerala',
'Edarikode,Tirur,Kerala',
'Edayur North,Tirur,Kerala',
'Edayur,Tirur,Kerala',
'Indianur,Tirur,Kerala',
'Irimbiliyam,Tirur,Kerala',
'Iringavur,Tirur,Kerala',
'Kadampuzha,Tirur,Kerala',
'Kallarmangalam,Tirur,Kerala',
'Kalpakancheri,Tirur,Kerala',
'Kanmanam,Tirur,Kerala',
'Kanmanam-thekkummuri,Tirur,Kerala',
'Karekkad,Tirur,Kerala',
'Karippol,Tirur,Kerala',
'Karthala,Tirur,Kerala',
'Kavancheri,Tirur,Kerala',
'Keraladheeswarapuram,Tirur,Kerala',
'Klari,Tirur,Kerala',
'Kottakkal,Tirur,Kerala',
'Kuruga,Tirur,Kerala',
'Kurumbathur,Tirur,Kerala',
'Kuttayi,Tirur,Kerala',
'Kuttippala,Tirur,Kerala',
'Kuttippuram,Tirur,Kerala',
'Kuttippuram-kottakkal,Tirur,Kerala',
'Mangalam-MLP,Tirur,Kerala',
'Mangattiri,Tirur,Kerala',
'Marakkara,Tirur,Kerala',
'Mattathur,Tirur,Kerala',
'Meenadathur,Tirur,Kerala',
'Muttanur,Tirur,Kerala',
'Naduvattom,Tirur,Kerala',
'Niramaruthur,Tirur,Kerala',
'Othukkungal,Tirur,Kerala',
'Ozhur,Tirur,Kerala',
'Pachattiri,Tirur,Kerala',
'Padinharekkara,Tirur,Kerala',
'Panangattur,Tirur,Kerala',
'Pandamangalam,Tirur,Kerala',
'Parammalangadi,Tirur,Kerala',
'Parappur,Tirur,Kerala',
'Paravanna,Tirur,Kerala',
'Pariyapuram,Tirur,Kerala',
'Pathayakallu,Tirur,Kerala',
'Payinkanniyur,Tirur,Kerala',
'Pazhur,Tirur,Kerala',
'Perasannur,Tirur,Kerala',
'Ponmala,Tirur,Kerala',
'Ponmundam,Tirur,Kerala',
'Pookayil Bazar,Tirur,Kerala',
'Poyilisseri,Tirur,Kerala',
'Puduppalli,Tirur,Kerala',
'Punnathala,Tirur,Kerala',
'Puramannur,Tirur,Kerala',
'Purathur,Tirur,Kerala',
'Puthiyakadappuram,Tirur,Kerala',
'Puthuparamba,Tirur,Kerala',
'Puthur -kottakkal,Tirur,Kerala',
'Randathani,Tirur,Kerala',
'Tanalur,Tirur,Kerala',
'Tanur Nagaram,Tirur,Kerala',
'Tanur-MBR,Tirur,Kerala',
'Thalakkadathur,Tirur,Kerala',
'Thekkankuttur,Tirur,Kerala',
'Thekkummuri,Tirur,Kerala',
'Tirunavaya,Tirur,Kerala',
'Tirur East Bazar,Tirur,Kerala',
'Tirur(kerala) H.O,Tirur,Kerala',
'Tolavanur,Tirur,Kerala',
'Trikkandiyur,Tirur,Kerala',
'Triprangode,Tirur,Kerala',
'Vadakkumbram,Tirur,Kerala',
'Vakkad,Tirur,Kerala',
'Valancheri,Tirur,Kerala',
'Valavannur,Tirur,Kerala',
'Valiyakunnu,Tirur,Kerala',
'Vellachal,Tirur,Kerala',
'Vengalur,Tirur,Kerala',
'Vettom,Tirur,Kerala',
'Vettom-pallippuram,Tirur,Kerala',
'Vyrancode,Tirur,Kerala',
'Abdurahiman Nagar,Tirur,Kerala',
'Anjapura,Tirur,Kerala',
'Ariyallur,Tirur,Kerala',
'Calicut University,Manjeri,Kerala',
'Chelembra,Manjeri,Kerala',
'Chenakkalangadi,Manjeri,Kerala',
'Cherumukku,Tirur,Kerala',
'Cherur,Tirur,Kerala',
'Chettipadi,Tirur,Kerala',
'Chullippara,Tirur,Kerala',
'Iringallur,Tirur,Kerala',
'Kadalundinagaram,Tirur,Kerala',
'Kakkad,Tirur,Kerala',
'Kannamangalam,Tirur,Kerala',
'Kannamangalam West,Tirur,Kerala',
'Kannattipadi,Tirur,Kerala',
'Karippur,Manjeri,Kerala',
'Kodinhi,Tirur,Kerala',
'Kolakkattuchali,Manjeri,Kerala',
'Kooriyad,Tirur,Kerala',
'Kotakkad,Tirur,Kerala',
'Kumminiparamba,Manjeri,Kerala',
'Kuttur North,Tirur,Kerala',
'Mampuram,Tirur,Kerala',
'Mooniyur,Tirur,Kerala',
'Moonniyur South,Tirur,Kerala',
'Nannambra,Tirur,Kerala',
'Neduva,Tirur,Kerala',
'Olakara,Tirur,Kerala',
'Omachapuzha,Tirur,Kerala',
'Oorakam Kizhumuri,Manjeri,Kerala',
'Oorakam Melmuri,Manjeri,Kerala',
'Pallikkal,Manjeri,Kerala',
'Pantarangadi,Tirur,Kerala',
'Parambilpeedika,Tirur,Kerala',
'Parpanangadi,Tirur,Kerala',
'Peruvallur,Manjeri,Kerala',
'Puthur-pallikkal,Manjeri,Kerala',
'Tayyalingal,Tirur,Kerala',
'Tenhipalam,Manjeri,Kerala',
'Thennala,Tirur,Kerala',
'Tirurangadi Bazar,Tirur,Kerala',
'Tirurangadi,Tirur,Kerala',
'Ullanam,Tirur,Kerala',
'Ullanam North,Tirur,Kerala',
'Valakolam,Tirur,Kerala',
'Valiyora,Tirur,Kerala',
'Vallikkunnu,Tirur,Kerala',
'Vallikkunnu North,Tirur,Kerala',
'Velimukku,Tirur,Kerala',
'Velimukku South,Tirur,Kerala',
'Vengara MLP,Tirur,Kerala',
'Venniyur,Tirur,Kerala',
'Agali-sholayar-pgt,Ottapalam,Kerala',
'Attasseri,Ottapalam,Kerala',
'Cherambattakavu,Ottapalam,Kerala',
'Chundabatta,Ottapalam,Kerala',
'Kadukkamkunnu,Palghat,Kerala',
'Kaithachira,Ottapalam,Kerala',
'Mulankavu,Ottapalam,Kerala',
'Puliyanamkunnu,Ottapalam,Kerala',
'Pullisseri,Ottapalam,Kerala',
'Sankaramangalam,Ottapalam,Kerala',
'Sreeramakrishnanagar,Ottapalam,Kerala',
'Taruvakonam,Ottapalam,Kerala',
'Thakke Vavannur,Ottapalam,Kerala',
'Thakkumuri(CPL),Ottapalam,Kerala',
'Thattanampully,Ottapalam,Kerala',
'Thirunayanapuram,Ottapalam,Kerala',
'Thrikallur,Ottapalam,Kerala',
'Tiruvalamkunnu,Ottapalam,Kerala',
'Ummanazhi,Ottapalam,Kerala',
'Uppukulam,Ottapalam,Kerala',
'Vakkadapuram,Ottapalam,Kerala',
'Valambillimangalam,Ottapalam,Kerala',
'Varode,Ottapalam,Kerala',
'Vattamannapuram,Ottapalam,Kerala',
'Vazhumbram,Ottapalam,Kerala',
'Veeramangalam,Ottapalam,Kerala',
'Veetampara,Ottapalam,Kerala',
'Vettakara,Ottapalam,Kerala',
'Vilathur,Ottapalam,Kerala',
'Vilayur West,Ottapalam,Kerala',
'Viyyakurissi,Ottapalam,Kerala',
'Anjumoorthy,Palghat,Kerala',
'Athipotta,Palghat,Kerala',
'Chennangad,Palghat,Kerala',
'Cherukulam,Palghat,Kerala',
'Chimbukat,Palghat,Kerala',
'Chithali,Palghat,Kerala',
'Chittilancheri,Palghat,Kerala',
'Coyalmanna,Palghat,Kerala',
'Elavampadam,Palghat,Kerala',
'Erimayur,Palghat,Kerala',
'Govindapuram,Palghat,Kerala',
'Kalapatti,Palghat,Kerala',
'Kannambra,Palghat,Kerala',
'Kannanur,Palghat,Kerala',
'Kavassery,Palghat,Kerala',
'Kilakkancheri,Palghat,Kerala',
'Koottala,Palghat,Kerala',
'Koranchira,Palghat,Kerala',
'Kottayi,Palghat,Kerala',
'Kunisseri,Palghat,Kerala',
'Kuttanur,Palghat,Kerala',
'Manappadam,Palghat,Kerala',
'Mannapra,Palghat,Kerala',
'Mathur PG,Palghat,Kerala',
'Melarcode,Palghat,Kerala',
'Mudappallur,Palghat,Kerala',
'Mulangot,Palghat,Kerala',
'Nechur,Palghat,Kerala',
'Nelliampathy,Palghat,Kerala',
'Nemmara College,Palghat,Kerala',
'Nenmeni,Palghat,Kerala',
'Padagiri,Palghat,Kerala',
'Padur Kavassery,Palghat,Kerala',
'Palakuzhy,Palghat,Kerala',
'Palampalakode,Palghat,Kerala',
'Pallanchathanur,Palghat,Kerala',
'Panangattiri,Palghat,Kerala',
'Paruthipulli,Palghat,Kerala',
'Paruvasseri,Palghat,Kerala',
'Peringottukurussi,Palghat,Kerala',
'Perinkulam,Palghat,Kerala',
'Perinkunnu,Palghat,Kerala',
'Pudiyankom,Palghat,Kerala',
'Puthucode,Palghat,Kerala',
'Tarur,Palghat,Kerala',
'Thekkepotta,Palghat,Kerala',
'Thenkurussi,Palghat,Kerala',
'Tolanur,Palghat,Kerala',
'Vadakkancherry MBR,Palghat,Kerala',
'Vandali,Palghat,Kerala',
'Varode-kottayi,Palghat,Kerala',
'Vattekkad,Palghat,Kerala',
'Vilayannur,Palghat,Kerala',
'Alathur Mbr H.O,Palghat,Kerala',
'Ayakkad,Palghat,Kerala',
'Cheramangalam,Palghat,Kerala',
'Chittadi,Palghat,Kerala',
'Chulanur,Palghat,Kerala',
'Coyalmanna Agraharam,Palghat,Kerala',
'Erattakulam Alathur,Palghat,Kerala',
'Kairady,Palghat,Kerala',
'Kalapatti,Palghat,Kerala',
'Kannakkanthuruthi,Palghat,Kerala',
'Karinkayam,Palghat,Kerala',
'Kariyamkode,Palghat,Kerala',
'Kattusseri,Palghat,Kerala',
'Kazhani,Palghat,Kerala',
'Mangalam Dam,Palghat,Kerala',
'Mathur Agraharam,Palghat,Kerala',
'Naduvathupara,Palghat,Kerala',
'Nochulli,Palghat,Kerala',
'Olinkadavu,Palghat,Kerala',
'Olivemount,Palghat,Kerala',
'Panniankara,Palghat,Kerala',
'Pulinelli,Palghat,Kerala',
'Pullode,Palghat,Kerala',
'Thachangad,Palghat,Kerala',
'Thannilapuram,Palghat,Kerala',
'Thiruvaliyad,Palghat,Kerala',
'Vavulliapuram,Palghat,Kerala',
'Vemballur,Palghat,Kerala',
'Alampallam,Palghat,Kerala',
'Anamari,Palghat,Kerala',
'Athicode,Palghat,Kerala',
'Attempathy,Palghat,Kerala',
'Ayalur,Palghat,Kerala',
'Chandramala Estate,Palghat,Kerala',
'Chathamangalam,Palghat,Kerala',
'Chenthamaranagar,Palghat,Kerala',
'Chittur Courts,Palghat,Kerala',
'Elavancherry,Palghat,Kerala',
'Eruthempathy,Palghat,Kerala',
'Kakkayur,Palghat,Kerala',
'Kanimangalam,Palghat,Kerala',
'Kannimari,Palghat,Kerala',
'Karipode,Palghat,Kerala',
'Karippali,Palghat,Kerala',
'Kizhakkumuri,Palghat,Kerala',
'Kollengo R.S.,Palghat,Kerala',
'Kollengode,Palghat,Kerala',
'Kollengode West,Palghat,Kerala',
'Kozhipara,Palghat,Kerala',
'Kudallur,Palghat,Kerala',
'Kuttipallam,Palghat,Kerala',
'Meenakshipuram,Palghat,Kerala',
'Meenkara Dam,Palghat,Kerala',
'Muthalamada,Palghat,Kerala',
'Nanniode,Palghat,Kerala',
'Nemmara Old Village,Palghat,Kerala',
'Nemmara,Palghat,Kerala',
'Olalapadi,Palghat,Kerala',
'Palaniyarpalayam,Palghat,Kerala',
'Pallassana,Palghat,Kerala',
'Pallavur,Palghat,Kerala',
'Parasikkal,Palghat,Kerala',
'Payyalur,Palghat,Kerala',
'Pothundy Dam,Palghat,Kerala',
'Pudunagaram,Palghat,Kerala',
'Rvp Pudur,Palghat,Kerala',
'Sitharkunda,Palghat,Kerala',
'Tattamangalam,Palghat,Kerala',
'Tattamangalam South,Palghat,Kerala',
'Thekkedesam,Palghat,Kerala',
'Thekkegramam,Palghat,Kerala',
'Thunacadavu,Palghat,Kerala',
'Vadavannur,Palghat,Kerala',
'Vallanghy,Palghat,Kerala',
'Vandithavalam,Palghat,Kerala',
'Velanthavalam,Palghat,Kerala',
'Vilayodi,Palghat,Kerala',
'Kallamala,Ottapalam,Kerala',
'Agali,Ottapalam,Kerala',
'Alanallur,Ottapalam,Kerala',
'Mannarkad College,Ottapalam,Kerala',
'Payyanadam,Ottapalam,Kerala',
'Perimbadari,Ottapalam,Kerala',
'Pombra,Ottapalam,Kerala',
'Poonchola,Ottapalam,Kerala',
'Pottasseri,Ottapalam,Kerala',
'Pudur,Ottapalam,Kerala',
'Pulappatta,Ottapalam,Kerala',
'Tachampara,Ottapalam,Kerala',
'Tenkara,Ottapalam,Kerala',
'Thavalam,Ottapalam,Kerala',
'Pallikunnu,Ottapalam,Kerala',
'Ariyur,Ottapalam,Kerala',
'Bhimanad,Ottapalam,Kerala',
'Changileri,Ottapalam,Kerala',
'Chavadiyur,Ottapalam,Kerala',
'Chindaki,Ottapalam,Kerala',
'Chittur -agali,Ottapalam,Kerala',
'Edathanttukara,Ottapalam,Kerala',
'Irimbakachola,Ottapalam,Kerala',
'Jellipara,Ottapalam,Kerala',
'Kacheriparamba,Ottapalam,Kerala',
'Kalkandi,Ottapalam,Kerala',
'Kalladikode,Ottapalam,Kerala',
'Kandamangalam,Ottapalam,Kerala',
'Kanhikulam,Ottapalam,Kerala',
'Kanhirapuzha Dam,Ottapalam,Kerala',
'Kanhirapuzha,Ottapalam,Kerala',
'Karakurissi,Ottapalam,Kerala',
'Karara,Ottapalam,Kerala',
'Karimba,Ottapalam,Kerala',
'Karkitamkunnu,Ottapalam,Kerala',
'Kavundikkal,Ottapalam,Kerala',
'Kodakkad,Ottapalam,Kerala',
'Konikazhi,Ottapalam,Kerala',
'Kottathara,Ottapalam,Kerala',
'Kottopadam,Ottapalam,Kerala',
'Kumaramputhur,Ottapalam,Kerala',
'Kundurkunnu,Ottapalam,Kerala',
'Mannarkkad,Ottapalam,Kerala',
'Mattathukad,Ottapalam,Kerala',
'Mukkali,Ottapalam,Kerala',
'Nattukal,Ottapalam,Kerala',
'Palakayam,Ottapalam,Kerala',
'Pallikurup,Ottapalam,Kerala',
'Palode,Ottapalam,Kerala',
'Paloor,Ottapalam,Kerala',
'Srikrishnapuram,Ottapalam,Kerala',
'Adakkaputhur,Ottapalam,Kerala',
'Akalur,Ottapalam,Kerala',
'Alangad,Ottapalam,Kerala',
'Amayur,Ottapalam,Kerala',
'Ambalapara,Ottapalam,Kerala',
'Ambalavattom,Ottapalam,Kerala',
'Anakkara,Ottapalam,Kerala',
'Angadi,Ottapalam,Kerala',
'Azhiyannur,Ottapalam,Kerala',
'Chalavara,Ottapalam,Kerala',
'Chalisseri,Ottapalam,Kerala',
'Chaliyattiri,Ottapalam,Kerala',
'Chathanur,Ottapalam,Kerala',
'Chembra,Ottapalam,Kerala',
'Cherottur,Ottapalam,Kerala',
'Cherpalcheri,Ottapalam,Kerala',
'Cherukattupulam,Ottapalam,Kerala',
'Cherukode,Ottapalam,Kerala',
'Cherukutangad,Ottapalam,Kerala',
'Cherumundasseri,Ottapalam,Kerala',
'Chethallur,Ottapalam,Kerala',
'Choorakode,Ottapalam,Kerala',
'Chunangad,Ottapalam,Kerala',
'Chundampatta,Ottapalam,Kerala',
'Edakode(Pavukonam),Ottapalam,Kerala',
'Elambulasseri,Ottapalam,Kerala',
'Eravakkad,Ottapalam,Kerala',
'Etapalam,Ottapalam,Kerala',
'Ezhuvanthala,Ottapalam,Kerala',
'Gandhiseva Sadanam,Ottapalam,Kerala',
'Ganeshgiri,Ottapalam,Kerala',
'Irimbalasseri,Ottapalam,Kerala',
'Kadambur,Ottapalam,Kerala',
'Kaipuram,Ottapalam,Kerala',
'Kalladathur,Ottapalam,Kerala',
'Kalladipatta,Ottapalam,Kerala',
'Kalluvazhi,Ottapalam,Kerala',
'Kanayam,Ottapalam,Kerala',
'Kanniampuram,Ottapalam,Kerala',
'Kappur,Ottapalam,Kerala',
'Karalmanna,Ottapalam,Kerala',
'Karattukurissi,Ottapalam,Kerala',
'Karimpuzha,Ottapalam,Kerala',
'Karumanamkurissi,Ottapalam,Kerala',
'Katambazhipuram,Ottapalam,Kerala',
'Kattukulam,Ottapalam,Kerala',
'Kattukulam South,Ottapalam,Kerala',
'Kavalappara,Ottapalam,Kerala',
'Kavukode,Ottapalam,Kerala',
'Kayiliad,Ottapalam,Kerala',
'Kilmuri,Ottapalam,Kerala',
'Kizhayur,Ottapalam,Kerala',
'Kizhur,Ottapalam,Kerala',
'Kodumunda,Ottapalam,Kerala',
'Kolikkottusseri,Ottapalam,Kerala',
'Kondurkara,Ottapalam,Kerala',
'Koonathara,Ottapalam,Kerala',
'Kothachira,Ottapalam,Kerala',
'Kottapadam(TTL),Ottapalam,Kerala',
'Kottappuram,Ottapalam,Kerala',
'Kudallur,Ottapalam,Kerala',
'Kulakkad,Ottapalam,Kerala',
'Kulakkattukurissi,Ottapalam,Kerala',
'Kulappulli,Ottapalam,Kerala',
'Kulukkallur,Ottapalam,Kerala',
'Kumaranellur,Ottapalam,Kerala',
'Kumbidi,Ottapalam,Kerala',
'Kunduvampadam,Ottapalam,Kerala',
'Kuttanad,Ottapalam,Kerala',
'Kuttanasseri,Ottapalam,Kerala',
'Lakkidi,Ottapalam,Kerala',
'Mala,Ottapalam,Kerala',
'Malamalkkavu,Ottapalam,Kerala',
'Mangalam(OPM),Ottapalam,Kerala',
'Mangode,Ottapalam,Kerala',
'Manisseri,Ottapalam,Kerala',
'Mannampatta,Ottapalam,Kerala',
'Mannanur,Ottapalam,Kerala',
'Mannengode,Ottapalam,Kerala',
'Marayamangalam,Ottapalam,Kerala',
'Marayamangalam South,Ottapalam,Kerala',
'Maruthur,Ottapalam,Kerala',
'Melepattambi,Ottapalam,Kerala',
'Melmuri,Ottapalam,Kerala',
'Melur,Ottapalam,Kerala',
'Met Ind Nagar,Ottapalam,Kerala',
'Mezhathur,Ottapalam,Kerala',
'Moonnekkar,Ottapalam,Kerala',
'Mudukurissi,Ottapalam,Kerala',
'Muduthala,Ottapalam,Kerala',
'Mulanhur,Ottapalam,Kerala',
'Mundakkottukurissi,Ottapalam,Kerala',
'Munnurkode,Ottapalam,Kerala',
'Naduvattom,Ottapalam,Kerala',
'Nagalassery,Ottapalam,Kerala',
'Nedungottur,Ottapalam,Kerala',
'Nellaya,Ottapalam,Kerala',
'Nellikattiri,Ottapalam,Kerala',
'Nhangattiri,Ottapalam,Kerala',
'Othalur - Ttl,Ottapalam,Kerala',
'Ottapalam H.O,Ottapalam,Kerala',
'Palappuram,Ottapalam,Kerala',
'Pallipuram,Ottapalam,Kerala',
'Panamanna,Ottapalam,Kerala',
'Panamanna South,Ottapalam,Kerala',
'Panayur,Ottapalam,Kerala',
'Panniyamkurissi,Ottapalam,Kerala',
'Parudur,Ottapalam,Kerala',
'Pathankulam,Ottapalam,Kerala',
'Pattambi,Ottapalam,Kerala',
'Pattithara,Ottapalam,Kerala',
'Peringannur,Ottapalam,Kerala',
'Peringode,Ottapalam,Kerala',
'Perumannur,Ottapalam,Kerala',
'Perumudiyur,Ottapalam,Kerala',
'Perur-OPM,Ottapalam,Kerala',
'Pombilaya,Ottapalam,Kerala',
'Pulasseri,Ottapalam,Kerala',
'Punchapadam,Ottapalam,Kerala',
'S G Press,Ottapalam,Kerala',
'Shornur,Ottapalam,Kerala',
'Thalakkasseri,Ottapalam,Kerala',
'Thirumittakode,Ottapalam,Kerala',
'Thiruvazhiyode,Ottapalam,Kerala',
'Thiruvegapura,Ottapalam,Kerala',
'Thottakkara,Ottapalam,Kerala',
'Trikkatiri,Ottapalam,Kerala',
'Trithala,Ottapalam,Kerala',
'Vadanamkurussi,Ottapalam,Kerala',
'Vallapuzha,Ottapalam,Kerala',
'Vaniamkulam,Ottapalam,Kerala',
'Vellinezhi,Ottapalam,Kerala',
'Vengasseri,Ottapalam,Kerala',
'Vilayur,Ottapalam,Kerala',
'Karambathur,Ottapalam,Kerala',
'Kuruvattur,Ottapalam,Kerala',
'Paruthipra,Ottapalam,Kerala',
'Akathethara,Palghat,Kerala',
'Ambikapuram,Palghat,Kerala',
'Anakkal,Palghat,Kerala',
'Chandranagar,Palghat,Kerala',
'Chandrapuram,Palghat,Kerala',
'Chandrasekharapuram,Palghat,Kerala',
'Cheraya,Palghat,Kerala',
'Chittur College,Palghat,Kerala',
'Chittur PG,Palghat,Kerala',
'Chokkanathapuram,Palghat,Kerala',
'Dhoni,Palghat,Kerala',
'Edathara,Palghat,Kerala',
'Eduppukulam,Palghat,Kerala',
'Elapulli,Palghat,Kerala',
'Elapulli South,Palghat,Kerala',
'Erattakulam,Palghat,Kerala',
'Ettanur,Palghat,Kerala',
'Ezhakkad,Palghat,Kerala',
'Kadukkamkunnu,Palghat,Kerala',
'Kallekkad,Palghat,Kerala',
'Kallekulangara,Palghat,Kerala',
'Kallepully,Palghat,Kerala',
'Kallur-palakkad,Palghat,Kerala',
'Kalpathy,Palghat,Kerala',
'Kanjikode Ind. Estate,Palghat,Kerala',
'Kanjikode,Palghat,Kerala',
'Kanjikode West,Palghat,Kerala',
'Kannadi,Palghat,Kerala',
'Karingarapully,Palghat,Kerala',
'Kavalpad,Palghat,Kerala',
'Keralasseri,Palghat,Kerala',
'Kilakkumbram,Palghat,Kerala',
'Kinasseri,Palghat,Kerala',
'Kinavallur,Palghat,Kerala',
'Kodunthirapulli,Palghat,Kerala',
'Koduvayur Agraharam,Palghat,Kerala',
'Koduvayur,Palghat,Kerala',
'Kongad,Palghat,Kerala',
'Kotambu,Palghat,Kerala',
'Kottekkad,Palghat,Kerala',
'Kozhinjampara,Palghat,Kerala',
'Kundalasseri,Palghat,Kerala',
'Kunnamkattupathy,Palghat,Kerala',
'Kunnathurmedu,Palghat,Kerala',
'Malampuzha Dam,Palghat,Kerala',
'Manikkasseri,Palghat,Kerala',
'Mankarai R.S.,Palghat,Kerala',
'Mankarai,Palghat,Kerala',
'Mankurussi,Palghat,Kerala',
'Mannalur,Palghat,Kerala',
'Mannur,Palghat,Kerala',
'Mannur West,Palghat,Kerala',
'Marutharoad,Palghat,Kerala',
'Menonpara,Palghat,Kerala',
'Moothanthara,Palghat,Kerala',
'Mucheeri,Palghat,Kerala',
'Mundur Palakkad,Palghat,Kerala',
'Muttikulangara,Palghat,Kerala',
'Nagaripuram,Palghat,Kerala',
'Nallepilly,Palghat,Kerala',
'Nambullipura,Palghat,Kerala',
'Nattukal,Palghat,Kerala',
'Newkalpathy,Palghat,Kerala',
'Nochipully,Palghat,Kerala',
'Nurani Agraharam,Palghat,Kerala',
'Nurani,Palghat,Kerala',
'Olasseri,Palghat,Kerala',
'Olavakkot H.O,Palghat,Kerala',
'Palakkad City,Palghat,Kerala',
'Palakkad Collectorate,Palghat,Kerala',
'Palakkad College,Palghat,Kerala',
'Palakkad Engineering College,Palghat,Kerala',
'Palakkad Fort,Palghat,Kerala',
'Palakkad H.O,Palghat,Kerala',
'Palakkad Industrial Estate,Palghat,Kerala',
'Pallatheri,Palghat,Kerala',
'Pallipuram PG,Palghat,Kerala',
'Pampampallam,Palghat,Kerala',
'Panayur,Palghat,Kerala',
'Parambikulam,Palghat,Kerala',
'Parasseri,Palghat,Kerala',
'Parli PG,Palghat,Kerala',
'Pattancheri,Palghat,Kerala',
'Peruvemba,Palghat,Kerala',
'Pirayiri,Palghat,Kerala',
'Polpully,Palghat,Kerala',
'Pudanur,Palghat,Kerala',
'Puduppariyaram,Palghat,Kerala',
'Pudussery,Palghat,Kerala',
'Puthur-palakkad,Palghat,Kerala',
'Ramassery,Palghat,Kerala',
'Sekharipuram,Palghat,Kerala',
'Tadukkasseri,Palghat,Kerala',
'Tenari,Palghat,Kerala',
'Tenur,Palghat,Kerala',
'Thannisseri,Palghat,Kerala',
'Thiruvalathur,Palghat,Kerala',
'Tirunilayi,Palghat,Kerala',
'Vadakkanthara,Palghat,Kerala',
'Vadasseri,Palghat,Kerala',
'Vallikode,Palghat,Kerala',
'Vannamada,Palghat,Kerala',
'Velikkad,Palghat,Kerala',
'Venody,Palghat,Kerala',
'Verkoli,Palghat,Kerala',
'Walayar Dam,Palghat,Kerala',
'Yakkara,Palghat,Kerala',
'Adur( Kla) H.O,Pathanamthitta,Kerala',
'Anandapally,Pathanamthitta,Kerala',
'Angadical North,Pathanamthitta,Kerala',
'Angadical South,Pathanamthitta,Kerala',
'Athirumkal,Pathanamthitta,Kerala',
'Chandanapally,Pathanamthitta,Kerala',
'Chayalode,Pathanamthitta,Kerala',
'Choorakode,Pathanamthitta,Kerala',
'Edathitta,Pathanamthitta,Kerala',
'Elamannur,Pathanamthitta,Kerala',
'Enathu,Pathanamthitta,Kerala',
'Kadambanad,Pathanamthitta,Kerala',
'Kadambanad South,Pathanamthitta,Kerala',
'Kaithaparambu,Pathanamthitta,Kerala',
'Kalanjoor,Pathanamthitta,Kerala',
'Karuvatta Adur,Pathanamthitta,Kerala',
'Keerukuzhy,Pathanamthitta,Kerala',
'Kodumon East,Pathanamthitta,Kerala',
'Kodumon,Pathanamthitta,Kerala',
'Koodal,Pathanamthitta,Kerala',
'Koonamkara,Pathanamthitta,Kerala',
'Kulathumon,Pathanamthitta,Kerala',
'Kurampala South,Pathanamthitta,Kerala',
'Mancode,Pathanamthitta,Kerala',
'Mannady,Pathanamthitta,Kerala',
'Mannam Nagar,Pathanamthitta,Kerala',
'Mannam Sugar Mills,Pathanamthitta,Kerala',
'Marur,Pathanamthitta,Kerala',
'Melood,Pathanamthitta,Kerala',
'Mudiyoorkonam,Pathanamthitta,Kerala',
'Murinjakal,Pathanamthitta,Kerala',
'Muttom Thumpamon,Pathanamthitta,Kerala',
'Nedumon,Pathanamthitta,Kerala',
'Nedumoncavu,Pathanamthitta,Kerala',
'Nellimukal,Pathanamthitta,Kerala',
'Nirathupara,Pathanamthitta,Kerala',
'Padam,Pathanamthitta,Kerala',
'Pandalam Medical Mission,Pathanamthitta,Kerala',
'Pandalam,Pathanamthitta,Kerala',
'Parakara,Pathanamthitta,Kerala',
'Parakode,Pathanamthitta,Kerala',
'Parakoottam,Pathanamthitta,Kerala',
'Paranthal,Pathanamthitta,Kerala',
'Pazhakulam,Pathanamthitta,Kerala',
'Peringanad,Pathanamthitta,Kerala',
'Puthumala,Pathanamthitta,Kerala',
'Thattayil,Pathanamthitta,Kerala',
'Thengamom,Pathanamthitta,Kerala',
'Theppupara,Pathanamthitta,Kerala',
'Thumpamon,Pathanamthitta,Kerala',
'Thuvayur South,Pathanamthitta,Kerala',
'Vadakkedathukavu Jn,Pathanamthitta,Kerala',
'Vayala Parakode,Pathanamthitta,Kerala',
'Pandanad,Tiruvalla,Kerala',
'Muthupezhumkal,Pathanamthitta,Kerala',
'Naranganam West,Pathanamthitta,Kerala',
'Elavanthitta,Pathanamthitta,Kerala',
'Kadammanitta,Pathanamthitta,Kerala',
'Aryavon,Pathanamthitta,Kerala',
'Chengalthadom,Pathanamthitta,Kerala',
'Cherukole Kozhencherri,Pathanamthitta,Kerala',
'Edapariyaram,Pathanamthitta,Kerala',
'Elanthur East,Pathanamthitta,Kerala',
'Elanthur Pariyaram,Pathanamthitta,Kerala',
'Elappupara,Pathanamthitta,Kerala',
'Ellimullumplackal,Pathanamthitta,Kerala',
'Kaipuzha North,Pathanamthitta,Kerala',
'Kallely,Pathanamthitta,Kerala',
'Kallely Thottam,Pathanamthitta,Kerala',
'Karamvely,Pathanamthitta,Kerala',
'Karithotta,Pathanamthitta,Kerala',
'Kizhakkupuram,Pathanamthitta,Kerala',
'Kokkathode,Pathanamthitta,Kerala',
'Kumbazhamuri,Pathanamthitta,Kerala',
'Kummannoor,Pathanamthitta,Kerala',
'Mammoodu,Pathanamthitta,Kerala',
'Mannarakulanji,Pathanamthitta,Kerala',
'Manneera,Pathanamthitta,Kerala',
'Mekozhur,Pathanamthitta,Kerala',
'Mundukottackal,Pathanamthitta,Kerala',
'Muttathukonam,Pathanamthitta,Kerala',
'Mylapra,Pathanamthitta,Kerala',
'Nellikkapara,Pathanamthitta,Kerala',
'Oonnukal,Pathanamthitta,Kerala',
'Oottupara,Pathanamthitta,Kerala',
'Panangad,Pathanamthitta,Kerala',
'Perinjottackal,Pathanamthitta,Kerala',
'Thekkuthode,Pathanamthitta,Kerala',
'Thengumcavu,Pathanamthitta,Kerala',
'Thumpamon North,Pathanamthitta,Kerala',
'Ulanad,Pathanamthitta,Kerala',
'Ullannur,Pathanamthitta,Kerala',
'Vadakkupuram,Pathanamthitta,Kerala',
'Vazhamuttom,Pathanamthitta,Kerala',
'Vazhamuttom East,Pathanamthitta,Kerala',
'Adumpumkulam,Pathanamthitta,Kerala',
'Anthiyalankavu,Pathanamthitta,Kerala',
'Aranmula,Tiruvalla,Kerala',
'Arattupuzha,Tiruvalla,Kerala',
'Aruvappulam,Pathanamthitta,Kerala',
'Attachakkal,Pathanamthitta,Kerala',
'Chenneerkara,Pathanamthitta,Kerala',
'Churulicode,Pathanamthitta,Kerala',
'Edayaramula West,Tiruvalla,Kerala',
'Elakollur,Pathanamthitta,Kerala',
'Elanthur,Pathanamthitta,Kerala',
'Erumakkad,Tiruvalla,Kerala',
'Kattoor Kozhencherry,Pathanamthitta,Kerala',
'Kidangannur,Pathanamthitta,Kerala',
'Konny,Pathanamthitta,Kerala',
'Kozhencherry Thekkemala,Pathanamthitta,Kerala',
'Kozhencherry College,Pathanamthitta,Kerala',
'Kozhencherry East,Pathanamthitta,Kerala',
'Kozhencherry,Pathanamthitta,Kerala',
'Kulanada,Pathanamthitta,Kerala',
'Kurichimuttom,Tiruvalla,Kerala',
'Kuzhikala,Pathanamthitta,Kerala',
'Makkankunnu,Pathanamthitta,Kerala',
'Malakara,Tiruvalla,Kerala',
'Mallasseri,Pathanamthitta,Kerala',
'Manthuka,Pathanamthitta,Kerala',
'Mathur,Pathanamthitta,Kerala',
'Melukara,Pathanamthitta,Kerala',
'Mezhuveli,Pathanamthitta,Kerala',
'Mylapra Town,Pathanamthitta,Kerala',
'Nalkallikkal,Tiruvalla,Kerala',
'Naranganam North,Pathanamthitta,Kerala',
'Naranganam,Pathanamthitta,Kerala',
'Nariapuram,Pathanamthitta,Kerala',
'Nellikala,Pathanamthitta,Kerala',
'Njakkunilam,Pathanamthitta,Kerala',
'Omallur-kla,Pathanamthitta,Kerala',
'Pathanamthitta H.O,Pathanamthitta,Kerala',
'Payyanamon,Pathanamthitta,Kerala',
'Prakkanam,Pathanamthitta,Kerala',
'Punnakkad,Pathanamthitta,Kerala',
'Thannithode,Pathanamthitta,Kerala',
'Thonniamala,Pathanamthitta,Kerala',
'Thumpamon Thazham,Pathanamthitta,Kerala',
'Vakayar,Pathanamthitta,Kerala',
'Vallicode Kottayam,Pathanamthitta,Kerala',
'Vallicode,Pathanamthitta,Kerala',
'Vayalathala,Pathanamthitta,Kerala',
'Vellappara,Pathanamthitta,Kerala',
'Vettur Kumbazha,Pathanamthitta,Kerala',
'Kaipattur,Pathanamthitta,Kerala',
'Edayarnmula,Tiruvalla,Kerala',
'Manakala,Pathanamthitta,Kerala',
'Parakadavu,Pathanamthitta,Kerala',
'Edathua,Tiruvalla,Kerala',
'Anikad,Tiruvalla,Kerala',
'Anj1lithanam,Tiruvalla,Kerala',
'Chalappally,Tiruvalla,Kerala',
'Chengaroor,Tiruvalla,Kerala',
'Chunkapara,Tiruvalla,Kerala',
'Ezhumattoor,Tiruvalla,Kerala',
'Kadamankulam,Tiruvalla,Kerala',
'Kallooppara,Tiruvalla,Kerala',
'Kariamplavu,Tiruvalla,Kerala',
'Kavungumprayar,Tiruvalla,Kerala',
'Keezhvaipur,Tiruvalla,Kerala',
'Kolabhagom,Tiruvalla,Kerala',
'Kottanad,Tiruvalla,Kerala',
'Kottangal,Tiruvalla,Kerala',
'Kulathur,Tiruvalla,Kerala',
'Madathumbhagom North,Tiruvalla,Kerala',
'Mallappally East,Tiruvalla,Kerala',
'Mallappally North,Tiruvalla,Kerala',
'Mallappally West,Tiruvalla,Kerala',
'Mundamala,Tiruvalla,Kerala',
'Narakathanni,Tiruvalla,Kerala',
'Padimon,Tiruvalla,Kerala',
'Paduthode,Tiruvalla,Kerala',
'Pariyaram,Tiruvalla,Kerala',
'Perumpatty,Tiruvalla,Kerala',
'Perumpramavu,Tiruvalla,Kerala',
'Punnavely,Tiruvalla,Kerala',
'Puramattom,Tiruvalla,Kerala',
'Puthusserry South,Tiruvalla,Kerala',
'Thelliyoor,Tiruvalla,Kerala',
'Theodical,Tiruvalla,Kerala',
'Thuruthicaud,Tiruvalla,Kerala',
'Vaipur,Tiruvalla,Kerala',
'Valakuzhy,Tiruvalla,Kerala',
'Vellayil,Tiruvalla,Kerala',
'Vennikulam,Tiruvalla,Kerala',
'Chelikuzhy,Pathanamthitta,Kerala',
'Thazhathuvadakku,Pathanamthitta,Kerala',
'Thekketheri,Pathanamthitta,Kerala',
'Ayroor North,Tiruvalla,Kerala',
'Chathenthara,Changanacherry,Kerala',
'Gavi,Idukki,Kerala',
'Kunnam Vechoochira,Changanacherry,Kerala',
'Mannadisala,Changanacherry,Kerala',
'Pampa Dam,Idukki,Kerala',
'Thulappally,Changanacherry,Kerala',
'Tiruvalla RS,Tiruvalla,Kerala',
'Adichipuzha,Pathanamthitta,Kerala',
'Angadi,Pathanamthitta,Kerala',
'Angamoozhy,Pathanamthitta,Kerala',
'Chellakkad,Pathanamthitta,Kerala',
'Chengara,Pathanamthitta,Kerala',
'Cherukulanji,Pathanamthitta,Kerala',
'Chethackal,Pathanamthitta,Kerala',
'Chittar,Pathanamthitta,Kerala',
'Edakulam,Pathanamthitta,Kerala',
'Edappavoor,Tiruvalla,Kerala',
'Ettichuvadu,Pathanamthitta,Kerala',
'Gurunathanmannu,Pathanamthitta,Kerala',
'Iythala,Pathanamthitta,Kerala',
'Kaithakody,Tiruvalla,Kerala',
'Kakkudumon,Pathanamthitta,Kerala',
'Kanjeettukara,Tiruvalla,Kerala',
'Karikayam,Pathanamthitta,Kerala',
'Karikulam,Pathanamthitta,Kerala',
'Keekozhur,Pathanamthitta,Kerala',
'Kochukoikkal,Pathanamthitta,Kerala',
'Kottamonpara,Pathanamthitta,Kerala',
'Kottathoor,Tiruvalla,Kerala',
'Kudamurutty,Pathanamthitta,Kerala',
'Kumaramperoor Thekkekkara,Pathanamthitta,Kerala',
'Kumpalampoika,Pathanamthitta,Kerala',
'Lahai,Pathanamthitta,Kerala',
'Madamon,Pathanamthitta,Kerala',
'Makkapuzha,Pathanamthitta,Kerala',
'Malayalapuzha Eram,Pathanamthitta,Kerala',
'Malayalapuzha Thazham,Pathanamthitta,Kerala',
'Mampara,Pathanamthitta,Kerala',
'Mandiram Jn,Pathanamthitta,Kerala',
'Maniyar,Pathanamthitta,Kerala',
'Moozhiar,Pathanamthitta,Kerala',
'Naranamoozhy,Pathanamthitta,Kerala',
'Neeliplavu,Pathanamthitta,Kerala',
'Nellikkamon,Pathanamthitta,Kerala',
'Oonnakavu,Pathanamthitta,Kerala',
'Pampa Triveni,Pathanamthitta,Kerala',
'Pampini,Pathanamthitta,Kerala',
'Pezhumpara,Pathanamthitta,Kerala',
'Pulloopram,Pathanamthitta,Kerala',
'Puthusserimala,Pathanamthitta,Kerala',
'Ranny Edamon,Pathanamthitta,Kerala',
'Ranny Perinad,Pathanamthitta,Kerala',
'Ranny,Pathanamthitta,Kerala',
'Ranny-pazhavangadi,Pathanamthitta,Kerala',
'Seethathode,Pathanamthitta,Kerala',
'Thadiyur,Tiruvalla,Kerala',
'Thalachira Eram,Pathanamthitta,Kerala',
'Thekkumkal,Tiruvalla,Kerala',
'Thombikandam,Pathanamthitta,Kerala',
'Uthimoodu,Pathanamthitta,Kerala',
'Vadasserikara,Pathanamthitta,Kerala',
'Valiyakavu,Pathanamthitta,Kerala',
'Vayyattupuzha,Pathanamthitta,Kerala',
'Velliyara,Tiruvalla,Kerala',
'Eraviperoor East,Tiruvalla,Kerala',
'Eraviperoor,Tiruvalla,Kerala',
'Kottoor,Tiruvalla,Kerala',
'Kozhimala,Tiruvalla,Kerala',
'Nedumpuram,Tiruvalla,Kerala',
'Niranam Central,Tiruvalla,Kerala',
'Niranam,Tiruvalla,Kerala',
'Poovathoor,Tiruvalla,Kerala',
'Vdakkumbhagom,Tiruvalla,Kerala',
'Alumthuruthy,Tiruvalla,Kerala',
'Alumthuruthy,Tiruvalla,Kerala',
'Amichikary,Tiruvalla,Kerala',
'Ayroor South,Tiruvalla,Kerala',
'Azhiyadathuchira,Tiruvalla,Kerala',
'Chathankary,Tiruvalla,Kerala',
'Chirayirambu,Tiruvalla,Kerala',
'Chumathra,Tiruvalla,Kerala',
'Kadapra Kumbanadu,Tiruvalla,Kerala',
'Kadapra Mannar,Tiruvalla,Kerala',
'Kallumkal,Tiruvalla,Kerala',
'Karakkal,Tiruvalla,Kerala',
'Kattode,Tiruvalla,Kerala',
'Kaviyoor,Tiruvalla,Kerala',
'Kavumbhagom,Tiruvalla,Kerala',
'Kizhakkumbhagom,Tiruvalla,Kerala',
'Koipuram,Tiruvalla,Kerala',
'Kumbanadu,Tiruvalla,Kerala',
'Kunnamthanam,Tiruvalla,Kerala',
'Kunnathukara HSC,Tiruvalla,Kerala',
'Kuravankuzhy,Tiruvalla,Kerala',
'Kuriannoor,Tiruvalla,Kerala',
'Kurunghazhabhagom,Tiruvalla,Kerala',
'Kuttapuzha,Tiruvalla,Kerala',
'Kuttur,Tiruvalla,Kerala',
'Mallappuzhassery,Tiruvalla,Kerala',
'Manjady Jn,Tiruvalla,Kerala',
'Manthanam,Tiruvalla,Kerala',
'Maramon,Tiruvalla,Kerala',
'Mepral,Tiruvalla,Kerala',
'Mundiappally,Tiruvalla,Kerala',
'Muthoor,Tiruvalla,Kerala',
'Muttumon,Tiruvalla,Kerala',
'Nellimala,Tiruvalla,Kerala',
'Othera,Tiruvalla,Kerala',
'Otherawest,Tiruvalla,Kerala',
'Palackathakidi,Tiruvalla,Kerala',
'Parumala,Tiruvalla,Kerala',
'Peringara,Tiruvalla,Kerala',
'Perumthuruthy,Tiruvalla,Kerala',
'Podiyadi,Tiruvalla,Kerala',
'Pullad,Tiruvalla,Kerala',
'Pushpagiri Tiruvalla,Tiruvalla,Kerala',
'Thengeli,Tiruvalla,Kerala',
'Thirumoolapuram,Tiruvalla,Kerala',
'Thottabhagom,Tiruvalla,Kerala',
'Tiruvalla H.O,Tiruvalla,Kerala',
'Tiruvalla Market Jn,Tiruvalla,Kerala',
'Urukari,Tiruvalla,Kerala',
'Valanjavattom,Tiruvalla,Kerala',
'Vallamkulam East,Tiruvalla,Kerala',
'Vallamkulam,Tiruvalla,Kerala',
'Varayannur,Tiruvalla,Kerala',
'Venpala,Tiruvalla,Kerala',
'Channamkara,Trivandrum North,Kerala',
'Cherunniyur,Trivandrum North,Kerala',
'Lourdepuram,Trivandrum South,Kerala',
'Avanavancherry,Trivandrum North,Kerala',
'Anathalavattom,Trivandrum North,Kerala',
'Kizhuvalam,Trivandrum North,Kerala',
'Alamcode,Trivandrum North,Kerala',
'Altharamoodu,Trivandrum North,Kerala',
'Anjengo,Trivandrum North,Kerala',
'Attingal H.O,Trivandrum North,Kerala',
'Ayilam,Trivandrum North,Kerala',
'Ayroor-varkala,Trivandrum North,Kerala',
'Bharathannur,Trivandrum North,Kerala',
'Charupara,Trivandrum North,Kerala',
'Chirayinkeezhu,Trivandrum North,Kerala',
'Edakode,Trivandrum North,Kerala',
'Edava,Trivandrum North,Kerala',
'Elakamon,Trivandrum North,Kerala',
'Elakamon-kizhakkepuram,Trivandrum North,Kerala',
'Hariharapuram,Trivandrum North,Kerala',
'Ilamba,Trivandrum North,Kerala',
'Kadakkavur,Trivandrum North,Kerala',
'Kaikara,Trivandrum North,Kerala',
'Kallambalam,Trivandrum North,Kerala',
'Kallara,Trivandrum North,Kerala',
'Kappil,Trivandrum North,Kerala',
'Karavaram,Trivandrum North,Kerala',
'Katakam,Trivandrum North,Kerala',
'Kattumpuram,Trivandrum North,Kerala',
'Kavalayur,Trivandrum North,Kerala',
'Keezhattingal,Trivandrum North,Kerala',
'Kilimanur Palace,Trivandrum North,Kerala',
'Kilimanur,Trivandrum North,Kerala',
'Kodithookiyakunnu,Trivandrum North,Kerala',
'Kokkottukonam,Trivandrum North,Kerala',
'Koonthallur,Trivandrum North,Kerala',
'Kudavur,Trivandrum North,Kerala',
'Kurakkada,Trivandrum North,Kerala',
'Kurumbayam,Trivandrum North,Kerala',
'Madavoor-pallickal,Trivandrum North,Kerala',
'Malakkal,Trivandrum North,Kerala',
'Manambur,Trivandrum North,Kerala',
'Manjamala,Trivandrum North,Kerala',
'Maruthikunnu,Trivandrum North,Kerala',
'Melkadakkavur,Trivandrum North,Kerala',
'Moongode,Trivandrum North,Kerala',
'Moothala,Trivandrum North,Kerala',
'Mudakkal,Trivandrum North,Kerala',
'Mudapuram,Trivandrum North,Kerala',
'Muthana,Trivandrum North,Kerala',
'Nagaroor,Trivandrum North,Kerala',
'Navaikulam,Trivandrum North,Kerala',
'Nedumparambu,Trivandrum North,Kerala',
'Nedunganda,Trivandrum North,Kerala',
'Nilakkamukku,Trivandrum North,Kerala',
'Njarayilkonam,Trivandrum North,Kerala',
'Odayam,Trivandrum North,Kerala',
'Oorupoika,Trivandrum North,Kerala',
'Pakalkuri,Trivandrum North,Kerala',
'Palayamkunnu,Trivandrum North,Kerala',
'Pallickal Kilimanur,Trivandrum North,Kerala',
'Parakunnu,Trivandrum North,Kerala',
'Parayathukonam,Trivandrum North,Kerala',
'Pazhayakunnummel,Trivandrum North,Kerala',
'Peroor,Trivandrum North,Kerala',
'Perumkulam,Trivandrum North,Kerala',
'Perunguzhi,Trivandrum North,Kerala',
'Poikamukku,Trivandrum North,Kerala',
'Ponganadu,Trivandrum North,Kerala',
'Poothura,Trivandrum North,Kerala',
'Pothencode,Trivandrum North,Kerala',
'Pulimath,Trivandrum North,Kerala',
'Puliyurkonam,Trivandrum North,Kerala',
'Pullanicode,Trivandrum North,Kerala',
'Pullayil,Trivandrum North,Kerala',
'Puthusserimukku,Trivandrum North,Kerala',
'Sreenivasapuram,Trivandrum North,Kerala',
'Thottakkad,Trivandrum North,Kerala',
'Vadasserikonam,Trivandrum North,Kerala',
'Vakkom,Trivandrum North,Kerala',
'Vanchiyur-attingal,Trivandrum North,Kerala',
'Varkala,Trivandrum North,Kerala',
'Varkala South,Trivandrum North,Kerala',
'Venjaramoodu,Trivandrum North,Kerala',
'Venkulam,Trivandrum North,Kerala',
'Vennicode,Trivandrum North,Kerala',
'Vettiyara,Trivandrum North,Kerala',
'Vettoor,Trivandrum North,Kerala',
'Vilayilmoola,Trivandrum North,Kerala',
'Adayamon,Trivandrum North,Kerala',
'Aliyadu,Trivandrum North,Kerala',
'Andoorkonam,Trivandrum North,Kerala',
'Azhurmarket,Trivandrum North,Kerala',
'Chilakur,Trivandrum North,Kerala',
'Iroorpara,Trivandrum North,Kerala',
'Janardhanapuram,Trivandrum North,Kerala',
'Kattaikonam,Trivandrum North,Kerala',
'Koduvazhannur,Trivandrum North,Kerala',
'Koithurkonam,Trivandrum North,Kerala',
'Koliakode,Trivandrum North,Kerala',
'Melvettoor,Trivandrum North,Kerala',
'Mukkudil,Trivandrum North,Kerala',
'Mulakkalathukavu,Trivandrum North,Kerala',
'Muttappalam,Trivandrum North,Kerala',
'Nethajipuram,Trivandrum North,Kerala',
'Palachira,Trivandrum North,Kerala',
'Palamkonam,Trivandrum North,Kerala',
'Pallithura,Trivandrum North,Kerala',
'Panayara,Trivandrum North,Kerala',
'Pirappancode,Trivandrum North,Kerala',
'Pullampara,Trivandrum North,Kerala',
'Puthenthope,Trivandrum North,Kerala',
'Santhigiri,Trivandrum North,Kerala',
'Sasthavattom,Trivandrum North,Kerala',
'Thalikuzhi,Trivandrum North,Kerala',
'Thokkad,Trivandrum North,Kerala',
'Vellallur,Trivandrum North,Kerala',
'Vellumannady,Trivandrum North,Kerala',
'Anad,Trivandrum South,Kerala',
'Anakudy,Trivandrum North,Kerala',
'Anappara,Trivandrum South,Kerala',
'Aruvikara,Trivandrum South,Kerala',
'Aryanad,Trivandrum South,Kerala',
'Bonaccord,Trivandrum South,Kerala',
'Changa,Trivandrum South,Kerala',
'Cheeranikkara,Trivandrum North,Kerala',
'Chekkakonam,Trivandrum South,Kerala',
'Chettachal,Trivandrum South,Kerala',
'Chullimanoor,Trivandrum South,Kerala',
'Daivapura,Trivandrum South,Kerala',
'Elavattom,Trivandrum South,Kerala',
'Ex-servicemen\'s Colony,Trivandrum South,Kerala',
'Idinjar,Trivandrum South,Kerala',
'Irinchayam,Trivandrum South,Kerala',
'Kalamachal,Trivandrum North,Kerala',
'Kallar Tvm,Trivandrum South,Kerala',
'Kalliyal,Trivandrum South,Kerala',
'Kanchinada,Trivandrum North,Kerala',
'Karimancode,Trivandrum South,Kerala',
'Karimkuttikara,Trivandrum North,Kerala',
'Karipur,Trivandrum South,Kerala',
'Karumom,Trivandrum South,Kerala',
'Kochuvila,Trivandrum South,Kerala',
'Kokkotela,Trivandrum South,Kerala',
'Konchira,Trivandrum North,Kerala',
'Koonanvenga,Trivandrum South,Kerala',
'Kottakkakom,Trivandrum South,Kerala',
'Kottoor(TVM),Trivandrum South,Kerala',
'Kottukunnam,Trivandrum North,Kerala',
'Kulappada,Trivandrum South,Kerala',
'Kuthirakalam-vellanad,Trivandrum South,Kerala',
'Kuthirakulam,Trivandrum North,Kerala',
'Mancha,Trivandrum South,Kerala',
'Mannurkonam,Trivandrum South,Kerala',
'Marangad,Trivandrum South,Kerala',
'Maruthamala,Trivandrum South,Kerala',
'Meenankal,Trivandrum South,Kerala',
'Meenmutty,Trivandrum South,Kerala',
'Memala,Trivandrum South,Kerala',
'Mithirmala,Trivandrum North,Kerala',
'Mithraniketan,Trivandrum South,Kerala',
'Moonnanakuzhy,Trivandrum North,Kerala',
'Moonnumukku,Trivandrum North,Kerala',
'Mulayara,Trivandrum South,Kerala',
'Mundela,Trivandrum South,Kerala',
'Muthuvila,Trivandrum North,Kerala',
'Mylamoodu,Trivandrum North,Kerala',
'Nedumangad,Trivandrum South,Kerala',
'Neeramankadavuu,Trivandrum North,Kerala',
'Nellanad,Trivandrum North,Kerala',
'Pacha,Trivandrum South,Kerala',
'Paluvally,Trivandrum South,Kerala',
'Panacode,Trivandrum South,Kerala',
'Panangode,Trivandrum South,Kerala',
'Panavoor,Trivandrum South,Kerala',
'Panayam,Trivandrum South,Kerala',
'Panayamuttom,Trivandrum South,Kerala',
'Pangode,Trivandrum North,Kerala',
'Panniyode,Trivandrum South,Kerala',
'Parandode,Trivandrum South,Kerala',
'Parappara,Trivandrum South,Kerala',
'Paruthikuzhy,Trivandrum South,Kerala',
'Paruthipally,Trivandrum South,Kerala',
'Pazhakutty,Trivandrum South,Kerala',
'Peppara Dam,Trivandrum South,Kerala',
'Perayam,Trivandrum South,Kerala',
'Ponmudi,Trivandrum South,Kerala',
'Poovachal,Trivandrum South,Kerala',
'Poovathur,Trivandrum South,Kerala',
'Punalal,Trivandrum South,Kerala',
'Puthukulangara,Trivandrum South,Kerala',
'Thennur,Trivandrum South,Kerala',
'Tholicode,Trivandrum South,Kerala',
'Uriakode,Trivandrum South,Kerala',
'Vamanapuram,Trivandrum North,Kerala',
'Vattakarikkakom,Trivandrum South,Kerala',
'Veliyannur,Trivandrum South,Kerala',
'Vellanad,Trivandrum South,Kerala',
'Vembayam,Trivandrum North,Kerala',
'Vinobaniketan,Trivandrum South,Kerala',
'Ilanchiyam,Trivandrum South,Kerala',
'Amachal,Trivandrum South,Kerala',
'Amaravila,Trivandrum South,Kerala',
'Ambalathinkala,Trivandrum South,Kerala',
'Amboori,Trivandrum South,Kerala',
'Anavoor,Trivandrum South,Kerala',
'Aralumoodu,Trivandrum South,Kerala',
'Arayur,Trivandrum South,Kerala',
'Arumanoor,Trivandrum South,Kerala',
'Aruvipuram,Trivandrum South,Kerala',
'Ayira,Trivandrum South,Kerala',
'Balaramapuram,Trivandrum South,Kerala',
'Bhagavathinada,Trivandrum South,Kerala',
'Chaikkottukonam,Trivandrum South,Kerala',
'Chenkal,Trivandrum South,Kerala',
'Cheriakolla,Trivandrum South,Kerala',
'Cheruvarakonam,Trivandrum South,Kerala',
'Chowara,Trivandrum South,Kerala',
'Dalmughom,Trivandrum South,Kerala',
'Dhanuvachapuram,Trivandrum South,Kerala',
'Elluvila,Trivandrum South,Kerala',
'Kakkavila,Trivandrum South,Kerala',
'Kandala,Trivandrum South,Kerala',
'Kanjampazhanji,Trivandrum South,Kerala',
'Kanjiramkulam,Trivandrum South,Kerala',
'Karakonam,Trivandrum South,Kerala',
'Karikuzhi,Trivandrum South,Kerala',
'Karode,Trivandrum South,Kerala',
'Kattachalkuzhy,Trivandrum South,Kerala',
'Kattacode,Trivandrum South,Kerala',
'Kattakada,Trivandrum South,Kerala',
'Kazhavur,Trivandrum South,Kerala',
'Keezharur,Trivandrum South,Kerala',
'Kidarakuzhy,Trivandrum South,Kerala',
'Kodungavila,Trivandrum South,Kerala',
'Kollode,Trivandrum South,Kerala',
'Koothali(TVM),Trivandrum South,Kerala',
'Kottackal (TVM),Trivandrum South,Kerala',
'Kottukal,Trivandrum South,Kerala',
'Kudappanamoodu,Trivandrum South,Kerala',
'Kudayal,Trivandrum South,Kerala',
'Kunnathukal,Trivandrum South,Kerala',
'Kuruthamcode,Trivandrum South,Kerala',
'Kuttamala,Trivandrum South,Kerala',
'Kuvalassery,Trivandrum South,Kerala',
'Lourdepuram,Trivandrum South,Kerala',
'Machel,Trivandrum South,Kerala',
'Malayam,Trivandrum South,Kerala',
'Malayinkil,Trivandrum South,Kerala',
'Manali,Trivandrum South,Kerala',
'Manchamcode,Trivandrum South,Kerala',
'Manchavilakom,Trivandrum South,Kerala',
'Mannamkonam,Trivandrum South,Kerala',
'Marayamuttom,Trivandrum South,Kerala',
'Mariyapuram,Trivandrum South,Kerala',
'Mayam,Trivandrum South,Kerala',
'Mulluvila,Trivandrum South,Kerala',
'Muttakadu,Trivandrum South,Kerala',
'Mylakkara,Trivandrum South,Kerala',
'Narimanmoodu,Trivandrum South,Kerala',
'Nellimoodu,Trivandrum South,Kerala',
'Nellivila,Trivandrum South,Kerala',
'Nemom,Trivandrum South,Kerala',
'Neyyar Dam,Trivandrum South,Kerala',
'Neyyattinkara Town,Trivandrum South,Kerala',
'Olathanni,Trivandrum South,Kerala',
'Ookode,Trivandrum South,Kerala',
'Ooruttambalam,Trivandrum South,Kerala',
'Ottasekharamangalam,Trivandrum South,Kerala',
'Pachallur,Trivandrum South,Kerala',
'Pallichal,Trivandrum South,Kerala',
'Panachamoodu,Trivandrum South,Kerala',
'Pantha,Trivandrum South,Kerala',
'Parassala,Trivandrum South,Kerala',
'Parasuvaickal,Trivandrum South,Kerala',
'Payattuvila,Trivandrum South,Kerala',
'Perumkadavila,Trivandrum South,Kerala',
'Perumpazhuthoor,Trivandrum South,Kerala',
'Plamootukada,Trivandrum South,Kerala',
'Poozhanad,Trivandrum South,Kerala',
'Pozhiyoor,Trivandrum South,Kerala',
'Pravachambalam,Trivandrum South,Kerala',
'Pulluvila,Trivandrum South,Kerala',
'Puthiathura,Trivandrum South,Kerala',
'Puvar,Trivandrum South,Kerala',
'Russelpuram,Trivandrum South,Kerala',
'Thannimoodu,Trivandrum South,Kerala',
'Thekkuppara,Trivandrum South,Kerala',
'Tirupuram,Trivandrum South,Kerala',
'Uchakada,Trivandrum South,Kerala',
'Vattavila,Trivandrum South,Kerala',
'Vazhichal,Trivandrum South,Kerala',
'Vedivachankoil,Trivandrum South,Kerala',
'Veeranakavu,Trivandrum South,Kerala',
'Veliyamcode,Trivandrum South,Kerala',
'Vellarada,Trivandrum South,Kerala',
'Venkadambu,Trivandrum South,Kerala',
'Venpakal,Trivandrum South,Kerala',
'Neyyattinkara H.O,Trivandrum South,Kerala',
'Kulamuttam,Trivandrum North,Kerala',
'Ambalamukku,Trivandrum South,Kerala',
'Ambalathara,Trivandrum South,Kerala',
'Anayara,Trivandrum North,Kerala',
'Aramada,Trivandrum South,Kerala',
'Attakulangara,Trivandrum North,Kerala',
'Attukal,Trivandrum South,Kerala',
'Cgo Complex Poonkulam,Trivandrum South,Kerala',
'Chempazhanthy,Trivandrum North,Kerala',
'Cheriyakonni,Trivandrum South,Kerala',
'Chittattumukku,Trivandrum North,Kerala',
'Cotton Hill,Trivandrum South,Kerala',
'Industrial Estate,Trivandrum South,Kerala',
'Jagathy,Trivandrum South,Kerala',
'Kachani,Trivandrum South,Kerala',
'Kaimanam,Trivandrum South,Kerala',
'Kaithamukku,Trivandrum North,Kerala',
'Kallayam,Trivandrum South,Kerala',
'Kalliyoor,Trivandrum South,Kerala',
'Kaniyapuram,Trivandrum North,Kerala',
'Kanjirampara,Trivandrum South,Kerala',
'Karakulam,Trivandrum South,Kerala',
'Karamana,Trivandrum South,Kerala',
'Karyavattom,Trivandrum North,Kerala',
'Kaudiar,Trivandrum South,Kerala',
'Kaudiar Square,Trivandrum South,Kerala',
'Kazhakuttam,Trivandrum North,Kerala',
'Kerala Governor\'s Camp,Trivandrum South,Kerala',
'Kodunganur,Trivandrum South,Kerala',
'Kottapuram,Trivandrum South,Kerala',
'Kovalam Beach,Trivandrum South,Kerala',
'Kovalam,Trivandrum South,Kerala',
'Kudappanakunnu,Trivandrum South,Kerala',
'Kulathur,Trivandrum North,Kerala',
'Kuravankonam,Trivandrum South,Kerala',
'Kuttichal,Trivandrum South,Kerala',
'Manacaud,Trivandrum South,Kerala',
'Manikanteswaram,Trivandrum South,Kerala',
'Moongode,Trivandrum South,Kerala',
'Mukkolackal,Trivandrum South,Kerala',
'Mullur,Trivandrum South,Kerala',
'Murukumpuzhaa,Trivandrum North,Kerala',
'Muttada,Trivandrum North,Kerala',
'Nalanchira,Trivandrum North,Kerala',
'Oolampara,Trivandrum South,Kerala',
'Palkulangara,Trivandrum North,Kerala',
'Pallipuram,Trivandrum North,Kerala',
'Pappanamcode,Trivandrum South,Kerala',
'Pattom Palace,Trivandrum North,Kerala',
'Peringamala,Trivandrum South,Kerala',
'Perukavu,Trivandrum South,Kerala',
'Perurkada,Trivandrum South,Kerala',
'Peyad,Trivandrum South,Kerala',
'PMG Jn,Trivandrum North,Kerala',
'Poojapura Junction,Trivandrum South,Kerala',
'Poojapura,Trivandrum South,Kerala',
'Poonthura,Trivandrum South,Kerala',
'Prasanth Nagar,Trivandrum North,Kerala',
'Ptp Nagar,Trivandrum South,Kerala',
'Puliyarakonam,Trivandrum South,Kerala',
'Puthencurichy,Trivandrum North,Kerala',
'Sainik School,Trivandrum North,Kerala',
'Sasthamangalam,Trivandrum South,Kerala',
'Sreekaryam,Trivandrum North,Kerala',
'St.Xavier\'s College,Trivandrum North,Kerala',
'Thamalam,Trivandrum South,Kerala',
'Thattathumala,Trivandrum North,Kerala',
'Thiruvallom,Trivandrum South,Kerala',
'Thiruvananthapuram G.P.O.,Trivandrum North,Kerala',
'Thonnakkal,Trivandrum North,Kerala',
'Thuruvikkal,Trivandrum North,Kerala',
'Thycaud H.O,Trivandrum South,Kerala',
'Tirumala,Trivandrum South,Kerala',
'Titanium,Trivandrum North,Kerala',
'TV Chalai,Trivandrum North,Kerala',
'TV Medical College,Trivandrum North,Kerala',
'TV Museum,Trivandrum North,Kerala',
'Tv Thampanoor,Trivandrum South,Kerala',
'TV University,Trivandrum North,Kerala',
'TVM R.K Mission,Trivandrum South,Kerala',
'TVM AG\'s,Trivandrum North,Kerala',
'TVM Beach,Trivandrum North,Kerala',
'TVM Engg College,Trivandrum North,Kerala',
'TVM Fort,Trivandrum North,Kerala',
'TVM Govt Press,Trivandrum North,Kerala',
'TVM ISRO,Trivandrum North,Kerala',
'TVM Pettah,Trivandrum North,Kerala',
'Valiamala,Trivandrum South,Kerala',
'Valiavila,Trivandrum South,Kerala',
'Vallakkadavoo,Trivandrum North,Kerala',
'Vanchiyoor Junction,Trivandrum North,Kerala',
'Vanchiyur,Trivandrum North,Kerala',
'Vattappara,Trivandrum North,Kerala',
'Vattiyoorkavu,Trivandrum South,Kerala',
'Vellayani,Trivandrum South,Kerala',
'Venganur,Trivandrum South,Kerala',
'Vikas Bhavan,Trivandrum North,Kerala',
'Vilappilsala,Trivandrum South,Kerala',
'Vithura,Trivandrum South,Kerala',
'Vizhinjam,Trivandrum South,Kerala',
'Beemapally,Trivandrum North,Kerala',
'Chakkai,Trivandrum North,Kerala',
'Cheruvikkal,Trivandrum North,Kerala',
'Goureesapattom,Trivandrum North,Kerala',
'Karimanal,Trivandrum North,Kerala',
'Mannanthala,Trivandrum North,Kerala',
'Mg College,Trivandrum North,Kerala',
'Pandalacode,Trivandrum North,Kerala',
'Pangappara,Trivandrum North,Kerala',
'Pattom,Trivandrum North,Kerala',
'Perumathura,Trivandrum North,Kerala',
'Powdikonam,Trivandrum North,Kerala',
'PTP Jn,Trivandrum North,Kerala',
'Thope,Trivandrum North,Kerala',
'Ulloor,Trivandrum North,Kerala',
'Valiathura,Trivandrum North,Kerala',
'Valiaveli,Trivandrum North,Kerala',
'Venkode,Trivandrum North,Kerala',
'Thundathil,Trivandrum North,Kerala',
'Kottai,Irinjalakuda,Kerala',
'Kukkulissery,Irinjalakuda,Kerala',
'Kuttamangalam,Irinjalakuda,Kerala',
'Madathumpady,Irinjalakuda,Kerala',
'Nenmenikkara,Irinjalakuda,Kerala',
'Panamkulam,Irinjalakuda,Kerala',
'Thirumukkulam,Irinjalakuda,Kerala',
'Triprayar,Irinjalakuda,Kerala',
'Agalad,Trichur,Kerala',
'Annakara,Trichur,Kerala',
'Blangad,Trichur,Kerala',
'Brahmakulam,Trichur,Kerala',
'Chakkumkandam,Trichur,Kerala',
'Chamakkala,Irinjalakuda,Kerala',
'Chammannur,Trichur,Kerala',
'Chavakkad,Trichur,Kerala',
'Chentrappinni East,Irinjalakuda,Kerala',
'Chittattukara,Trichur,Kerala',
'Chulur,Irinjalakuda,Kerala',
'Edakkara,Trichur,Kerala',
'Edakkazhiyur,Trichur,Kerala',
'Edamuttam,Irinjalakuda,Kerala',
'Edassery,Trichur,Kerala',
'Elavally,Trichur,Kerala',
'Elavally South,Trichur,Kerala',
'Enamakkal,Trichur,Kerala',
'Engandiyur,Trichur,Kerala',
'Guruvayur,Trichur,Kerala',
'Guruvayur Temple (N),Trichur,Kerala',
'Iringapuram,Trichur,Kerala',
'Kadappuram,Trichur,Kerala',
'Kakkassery,Trichur,Kerala',
'Kalimbram,Irinjalakuda,Kerala',
'Kallur,Trichur,Kerala',
'Kandanassery,Trichur,Kerala',
'Kannampallipuram,Irinjalakuda,Kerala',
'Kannoth,Trichur,Kerala',
'Karayamvattam,Irinjalakuda,Kerala',
'Kavida,Trichur,Kerala',
'Kochannur,Trichur,Kerala',
'Koonamoochi,Trichur,Kerala',
'Kottapadi,Trichur,Kerala',
'Kundaliyur,Trichur,Kerala',
'Kuranniyur,Trichur,Kerala',
'Madu,Trichur,Kerala',
'Mannalamkunu,Trichur,Kerala',
'Maruthayur,Trichur,Kerala',
'Mullassery,Trichur,Kerala',
'Naduvilkkara,Trichur,Kerala',
'Nattika,Irinjalakuda,Kerala',
'Nattikabeach,Irinjalakuda,Kerala',
'Nemmini,Trichur,Kerala',
'Nhamaghat,Trichur,Kerala',
'Orumanayur,Trichur,Kerala',
'Padoor,Trichur,Kerala',
'Palayur,Trichur,Kerala',
'Paluvai,Trichur,Kerala',
'Pavaratty,Trichur,Kerala',
'Peruvallur,Trichur,Kerala',
'Pookode,Trichur,Kerala',
'Punnayur,Trichur,Kerala',
'Punnayurkulam,Trichur,Kerala',
'Puthanpalli,Trichur,Kerala',
'Puvathur,Trichur,Kerala',
'Talikulam,Trichur,Kerala',
'Thaikkad,Trichur,Kerala',
'Thamarayur,Trichur,Kerala',
'Thampankadavu,Trichur,Kerala',
'Thirunellur,Trichur,Kerala',
'Thiruvenkitam,Trichur,Kerala',
'Thozhiyur,Trichur,Kerala',
'Tiruvatra,Trichur,Kerala',
'Toyakkavu,Trichur,Kerala',
'Trithallur,Trichur,Kerala',
'Trithallur West,Trichur,Kerala',
'Vadakkekad,Trichur,Kerala',
'Valapad,Irinjalakuda,Kerala',
'Vatanapally Beach,Trichur,Kerala',
'Vatanapilly,Trichur,Kerala',
'Vattekkad,Trichur,Kerala',
'Vemmanad,Trichur,Kerala',
'Venkitangu,Trichur,Kerala',
'Vylathur,Trichur,Kerala',
'Valapad Beach,Irinjalakuda,Kerala',
'Anapuzha,Irinjalakuda,Kerala',
'Azhikode Jetty,Irinjalakuda,Kerala',
'Azhikode-Thrissur,Irinjalakuda,Kerala',
'Chakkarappadam,Irinjalakuda,Kerala',
'Chalingad,Irinjalakuda,Kerala',
'Chentrappinni,Irinjalakuda,Kerala',
'Edavilangu,Irinjalakuda,Kerala',
'Eriyad,Irinjalakuda,Kerala',
'Kaipamangalam Beach,Irinjalakuda,Kerala',
'Kaipamangalam,Irinjalakuda,Kerala',
'Kandamkulam,Irinjalakuda,Kerala',
'Kara,Irinjalakuda,Kerala',
'Karupadanna,Irinjalakuda,Kerala',
'Kodungallur,Irinjalakuda,Kerala',
'Koolimuttam,Irinjalakuda,Kerala',
'Koorikuzhi,Irinjalakuda,Kerala',
'Kothaparamba,Irinjalakuda,Kerala',
'Kottappuram,Irinjalakuda,Kerala',
'Krishnankotta,Irinjalakuda,Kerala',
'Madavana,Irinjalakuda,Kerala',
'Mathilakam,Irinjalakuda,Kerala',
'Methala,Irinjalakuda,Kerala',
'Padinjare Vemballur,Irinjalakuda,Kerala',
'Panangad,Irinjalakuda,Kerala',
'Pathazhakkad,Irinjalakuda,Kerala',
'Perinjanam,Irinjalakuda,Kerala',
'Perinjanam West,Irinjalakuda,Kerala',
'Poyya,Irinjalakuda,Kerala',
'Pullut North,Irinjalakuda,Kerala',
'Pullut,Irinjalakuda,Kerala',
'Santhipuram,Irinjalakuda,Kerala',
'Vallivattam,Irinjalakuda,Kerala',
'Elinjipra,Irinjalakuda,Kerala',
'Alagappanagar,Irinjalakuda,Kerala',
'Alathur(Thrissur),Irinjalakuda,Kerala',
'Alur,Irinjalakuda,Kerala',
'Anandapuram,Irinjalakuda,Kerala',
'Annallur,Irinjalakuda,Kerala',
'Annamanada,Irinjalakuda,Kerala',
'Annanad,Irinjalakuda,Kerala',
'Aripalam,Irinjalakuda,Kerala',
'Ashtamichira,Irinjalakuda,Kerala',
'Avittathur,Irinjalakuda,Kerala',
'Chaipankuzhi,Irinjalakuda,Kerala',
'Chattikulam,Irinjalakuda,Kerala',
'Chattikulam,Irinjalakuda,Kerala',
'Chembuchira,Irinjalakuda,Kerala',
'Chengallur,Irinjalakuda,Kerala',
'Cheruvallur,Irinjalakuda,Kerala',
'Chimoni Dam,Irinjalakuda,Kerala',
'Chittissery,Irinjalakuda,Kerala',
'Chokkana,Irinjalakuda,Kerala',
'Edakulam,Irinjalakuda,Kerala',
'Edathirinji,Irinjalakuda,Kerala',
'Edathuruthy,Irinjalakuda,Kerala',
'Eravathur,Irinjalakuda,Kerala',
'Erayamkudi,Irinjalakuda,Kerala',
'Inchakundu,Irinjalakuda,Kerala',
'Iranikulam,Irinjalakuda,Kerala',
'Irinjalakuda North,Irinjalakuda,Kerala',
'Kadukutty,Irinjalakuda,Kerala',
'Kaduppassery,Irinjalakuda,Kerala',
'Kallettumkara,Irinjalakuda,Kerala',
'Kallur,Irinjalakuda,Kerala',
'Kanakamala,Irinjalakuda,Kerala',
'Kanjirappilly,Irinjalakuda,Kerala',
'Kannikulangara,Irinjalakuda,Kerala',
'Karalam,Irinjalakuda,Kerala',
'Karanchira,Irinjalakuda,Kerala',
'Karumathra,Irinjalakuda,Kerala',
'Karur,Irinjalakuda,Kerala',
'Karuvannur,Irinjalakuda,Kerala',
'Kathikkudam,Irinjalakuda,Kerala',
'Kattoor,Irinjalakuda,Kerala',
'Khannanagar-koratti,Irinjalakuda,Kerala',
'Kizhupillikkara,Irinjalakuda,Kerala',
'Koartti Kizhakkummuri,Irinjalakuda,Kerala',
'Kodakara,Irinjalakuda,Kerala',
'Kodassery,Irinjalakuda,Kerala',
'Kombathukadavu,Irinjalakuda,Kerala',
'Konathukunnu,Irinjalakuda,Kerala',
'Konnakuzhy,Irinjalakuda,Kerala',
'Koovakkattukunnu,Irinjalakuda,Kerala',
'Koratti,Irinjalakuda,Kerala',
'Koratti South,Irinjalakuda,Kerala',
'Kottamuri,Irinjalakuda,Kerala',
'Kottanallur,Irinjalakuda,Kerala',
'Kundur,Irinjalakuda,Kerala',
'Kunnappilly,Irinjalakuda,Kerala',
'Kuruvilassery,Irinjalakuda,Kerala',
'Kuttichira,Irinjalakuda,Kerala',
'Kuttikkad,Irinjalakuda,Kerala',
'Kuzhikkattussery,Irinjalakuda,Kerala',
'Kuzhur,Irinjalakuda,Kerala',
'Madayikonam,Irinjalakuda,Kerala',
'Mala-thrissur,Irinjalakuda,Kerala',
'Mambra,Irinjalakuda,Kerala',
'Manakulangara,Irinjalakuda,Kerala',
'Mattathur,Irinjalakuda,Kerala',
'Mattathurkkunnu,Irinjalakuda,Kerala',
'Melur,Irinjalakuda,Kerala',
'Moorkkanad,Irinjalakuda,Kerala',
'Mothirakkanni,Irinjalakuda,Kerala',
'Mupliyam,Irinjalakuda,Kerala',
'Murikkungal,Irinjalakuda,Kerala',
'Muringoor Vadakkummuri,Irinjalakuda,Kerala',
'Muriyad,Irinjalakuda,Kerala',
'Muttithadi,Irinjalakuda,Kerala',
'Nadavaramba,Irinjalakuda,Kerala',
'Nalukettu,Irinjalakuda,Kerala',
'Nandikkara,Irinjalakuda,Kerala',
'Nellayi-thrissur,Irinjalakuda,Kerala',
'Padiyur,Irinjalakuda,Kerala',
'Pady,Irinjalakuda,Kerala',
'Palappilly,Irinjalakuda,Kerala',
'Palayamparambu,Irinjalakuda,Kerala',
'Pallipuram,Irinjalakuda,Kerala',
'Parappukkara,Irinjalakuda,Kerala',
'Pariyaram,Irinjalakuda,Kerala',
'Pazhayi,Irinjalakuda,Kerala',
'Perambra-thrissur,Irinjalakuda,Kerala',
'Ponjanam,Irinjalakuda,Kerala',
'Pooppathy,Irinjalakuda,Kerala',
'Poovathussery,Irinjalakuda,Kerala',
'Porathissery,Irinjalakuda,Kerala',
'Poringalkuthu,Irinjalakuda,Kerala',
'Potta,Irinjalakuda,Kerala',
'Pudukad,Irinjalakuda,Kerala',
'Pullur,Irinjalakuda,Kerala',
'Puthenchira Kizhakkummuri,Irinjalakuda,Kerala',
'Puthenchira,Irinjalakuda,Kerala',
'Puthenchira Thekkummuri,Irinjalakuda,Kerala',
'Thanissery,Irinjalakuda,Kerala',
'Thazhekkad,Irinjalakuda,Kerala',
'Thottippal,Irinjalakuda,Kerala',
'Thumbur,Irinjalakuda,Kerala',
'Trikkur,Trichur,Kerala',
'Vadama,Irinjalakuda,Kerala',
'Varakara,Irinjalakuda,Kerala',
'Varandarappilly,Irinjalakuda,Kerala',
'Vattanathara,Irinjalakuda,Kerala',
'Vellanchira,Irinjalakuda,Kerala',
'Vellangallur,Irinjalakuda,Kerala',
'Vellani,Irinjalakuda,Kerala',
'Vellikulangara,Irinjalakuda,Kerala',
'Velupadam,Irinjalakuda,Kerala',
'Vettilappara,Irinjalakuda,Kerala',
'Vijayaraghavapuram,Irinjalakuda,Kerala',
'Chalakudi H.O,Irinjalakuda,Kerala',
'Irinjalakuda H.O,Irinjalakuda,Kerala',
'Nandipulam,Irinjalakuda,Kerala',
'Akathiyur,Trichur,Kerala',
'Akkikkavu,Trichur,Kerala',
'Alur Mattam,Trichur,Kerala',
'Andathode,Trichur,Kerala',
'Anjur-kunnamkulam,Trichur,Kerala',
'Arangottukara,Trichur,Kerala',
'Ariyannur,Trichur,Kerala',
'Arthat,Trichur,Kerala',
'Attur,Trichur,Kerala',
'Chelakkara,Trichur,Kerala',
'Chelakode,Trichur,Kerala',
'Chemmannur,Trichur,Kerala',
'Chemmanthatta,Trichur,Kerala',
'Cheruthuruthy,Trichur,Kerala',
'Chiramanangad,Trichur,Kerala',
'Chiranellur,Trichur,Kerala',
'Chittanda,Trichur,Kerala',
'Chittanjur,Trichur,Kerala',
'Choondal,Trichur,Kerala',
'Chowannur,Trichur,Kerala',
'Desamangalam,Trichur,Kerala',
'Elanad,Trichur,Kerala',
'Enkakad,Trichur,Kerala',
'Eranellur,Trichur,Kerala',
'Erumapetty,Trichur,Kerala',
'Eyyal,Trichur,Kerala',
'Irunilamcode,Trichur,Kerala',
'Kadavallur,Trichur,Kerala',
'Kajirakode,Trichur,Kerala',
'Kaliyarode,Trichur,Kerala',
'Kallepadam,Trichur,Kerala',
'Kanippayur,Trichur,Kerala',
'Kaniyarkod,Trichur,Kerala',
'Karikkad,Trichur,Kerala',
'Karumathra,Trichur,Kerala',
'Kattakampal,Trichur,Kerala',
'Kattilapoovam,Trichur,Kerala',
'Katungode,Trichur,Kerala',
'Kecheri,Trichur,Kerala',
'Killimangalam,Trichur,Kerala',
'Kiralur,Trichur,Kerala',
'Kizhur,Trichur,Kerala',
'Kondazhi,Trichur,Kerala',
'Korattikara,Trichur,Kerala',
'Kottappuram Wri,Trichur,Kerala',
'Kumaranellur TC,Trichur,Kerala',
'Kumarappanal,Trichur,Kerala',
'Kumbalacode,Trichur,Kerala',
'Kundannur,Trichur,Kerala',
'Kunnamkulam City,Trichur,Kerala',
'Kunnamkulam H.O,Trichur,Kerala',
'Kurumal,Trichur,Kerala',
'Kurumala,Trichur,Kerala',
'Kuthampilly,Trichur,Kerala',
'Kuttanchery,Trichur,Kerala',
'Malavattom,Trichur,Kerala',
'Malesamangalam,Trichur,Kerala',
'Manalithara,Trichur,Kerala',
'Mangad,Trichur,Kerala',
'Maruthancode,Trichur,Kerala',
'Mattam,Trichur,Kerala',
'Mayannur,Trichur,Kerala',
'Mullurkkara,Trichur,Kerala',
'Mundathicode,Trichur,Kerala',
'Mundathicode West,Trichur,Kerala',
'Nambazhikad,Trichur,Kerala',
'Nelluvaya,Trichur,Kerala',
'Netumpura,Trichur,Kerala',
'Painkulam,Trichur,Kerala',
'Pallam Kottambathur,Trichur,Kerala',
'Pallur,Trichur,Kerala',
'Pampady East,Trichur,Kerala',
'Pampady West,Trichur,Kerala',
'Panangattukara,Trichur,Kerala',
'Panjal,Trichur,Kerala',
'Panparappally,Trichur,Kerala',
'Parlikkad,Trichur,Kerala',
'Pattiparambu,Trichur,Kerala',
'Pazhanji,Trichur,Kerala',
'Pazhayannur,Trichur,Kerala',
'Perngamuck,Trichur,Kerala',
'Perumpilavu,Trichur,Kerala',
'Perumthuruthy,Trichur,Kerala',
'Porkolangad,Trichur,Kerala',
'Porkulam,Trichur,Kerala',
'Puduruthy,Trichur,Kerala',
'Pulakkad,Trichur,Kerala',
'Pulakode,Trichur,Kerala',
'South Kondazhi,Trichur,Kerala',
'Tali,Trichur,Kerala',
'Thalakkottukara,Trichur,Kerala',
'Thalassery,Trichur,Kerala',
'Thayyur,Trichur,Kerala',
'Thekkumkara,Trichur,Kerala',
'Thichur,Trichur,Kerala',
'Thippilissery,Trichur,Kerala',
'Thiruvilwamala,Trichur,Kerala',
'Thonnurkkara,Trichur,Kerala',
'Thozhupadam,Trichur,Kerala',
'Vadakkethara,Trichur,Kerala',
'Vaka,Trichur,Kerala',
'Varavur,Trichur,Kerala',
'Vazhani,Trichur,Kerala',
'Vellarakad,Trichur,Kerala',
'Vellattanjur,Trichur,Kerala',
'Velur Bazar,Trichur,Kerala',
'Velur Thrissur,Trichur,Kerala',
'Venganellur,Trichur,Kerala',
'Vennur,Trichur,Kerala',
'Vettikkatti R.S.,Trichur,Kerala',
'Vyasagiri,Trichur,Kerala',
'Wadakkancheri RS,Trichur,Kerala',
'Wadakkanchery H.O,Trichur,Kerala',
'Adat,Trichur,Kerala',
'Alapad,Trichur,Kerala',
'Amalanagar,Trichur,Kerala',
'Ammadam,Trichur,Kerala',
'Anchery,Trichur,Kerala',
'Anjur Mundur,Trichur,Kerala',
'Anthikad,Trichur,Kerala',
'Aranattukara,Trichur,Kerala',
'Arattupuzha,Irinjalakuda,Kerala',
'Arimpur,Trichur,Kerala',
'Asarikkad,Trichur,Kerala',
'Athani Trichur,Trichur,Kerala',
'Avanisseri,Trichur,Kerala',
'Avanur,Trichur,Kerala',
'Ayyanthole North,Trichur,Kerala',
'Ayyanthole,Trichur,Kerala',
'Ayyappankavu,Trichur,Kerala',
'Chazhur,Irinjalakuda,Kerala',
'Chennaipara,Trichur,Kerala',
'Cherpu Padinjattumuri,Irinjalakuda,Kerala',
'Cherpu,Irinjalakuda,Kerala',
'Cherur,Trichur,Kerala',
'Chettupuzha,Trichur,Kerala',
'Chittilapilly,Trichur,Kerala',
'Chiyyaram,Trichur,Kerala',
'Cholissery,Trichur,Kerala',
'Chottupara,Trichur,Kerala',
'Chovvur,Trichur,Kerala',
'Chuvannamannu,Trichur,Kerala',
'Edakkalathur,Trichur,Kerala',
'Elthuruth,Trichur,Kerala',
'Eravimangalam,Trichur,Kerala',
'Eravu,Trichur,Kerala',
'Inchamudy,Irinjalakuda,Kerala',
'Kainoor,Trichur,Kerala',
'Kaiparamba,Trichur,Kerala',
'Kanattukara,Trichur,Kerala',
'Kandassankadavu,Trichur,Kerala',
'Kanimangalam,Trichur,Kerala',
'Kanjani,Trichur,Kerala',
'Kannara,Trichur,Kerala',
'Kerala Agri-university,Trichur,Kerala',
'Kilakkummuri,Irinjalakuda,Kerala',
'Kodannur,Trichur,Kerala',
'Kolazhi Rm,Trichur,Kerala',
'Konikara,Trichur,Kerala',
'Kootala-trichur,Trichur,Kerala',
'Kozhukully,Trichur,Kerala',
'Kundukad,Trichur,Kerala',
'Kuriachira,Trichur,Kerala',
'Kurkancheri,Trichur,Kerala',
'Kuruchikkara,Trichur,Kerala',
'Kurumbilavu,Irinjalakuda,Kerala',
'Kuttanellur,Trichur,Kerala',
'Kuttur,Trichur,Kerala',
'Madakkathara,Trichur,Kerala',
'Manakkodi,Trichur,Kerala',
'Manalur Hs,Trichur,Kerala',
'Manalur,Trichur,Kerala',
'Mannamangalam,Trichur,Kerala',
'Mannuthy,Trichur,Kerala',
'Marathakkara,Trichur,Kerala',
'Marottichal,Trichur,Kerala',
'Minalur,Trichur,Kerala',
'Mulagunnathukavu,Trichur,Kerala',
'Mulayam,Trichur,Kerala',
'Mundur,Trichur,Kerala',
'Nadathara,Trichur,Kerala',
'Nedupuzha,Trichur,Kerala',
'Nehrunagar,Trichur,Kerala',
'Nellikunnu,Trichur,Kerala',
'Nettissery,Trichur,Kerala',
'Ollukkara,Trichur,Kerala',
'Ollur North,Trichur,Kerala',
'Ollur,Trichur,Kerala',
'Ollur Thaikkattussery,Trichur,Kerala',
'Padiyam,Trichur,Kerala',
'Palissery,Trichur,Kerala',
'Paralam,Trichur,Kerala',
'Parappur,Trichur,Kerala',
'Pathiyarkulangara,Trichur,Kerala',
'Pattikkad TC,Trichur,Kerala',
'Pazhuvil,Irinjalakuda,Kerala',
'Pazhuvil West,Irinjalakuda,Kerala',
'Peechi,Trichur,Kerala',
'Peramangalam,Trichur,Kerala',
'Perinchery,Trichur,Kerala',
'Peringandur,Trichur,Kerala',
'Peringavu,Trichur,Kerala',
'Peringottukara,Irinjalakuda,Kerala',
'Ponnore,Trichur,Kerala',
'Ponnukkara,Trichur,Kerala',
'Poomala,Trichur,Kerala',
'Pootharakkal,Irinjalakuda,Kerala',
'Poothole,Trichur,Kerala',
'Poovanchira,Trichur,Kerala',
'Pottore,Trichur,Kerala',
'Pullazhi,Trichur,Kerala',
'Pullu,Trichur,Kerala',
'Punkunnu,Trichur,Kerala',
'Puranattukara,Trichur,Kerala',
'Puthenpeedika,Trichur,Kerala',
'Puthur-trichur,Trichur,Kerala',
'Puzhakkal,Trichur,Kerala',
'Ramavarmapuram,Trichur,Kerala',
'Thalore,Trichur,Kerala',
'Thangalur,Trichur,Kerala',
'Thiruvambady TSR,Trichur,Kerala',
'Thrissur Central,Trichur,Kerala',
'Thrissur City,Trichur,Kerala',
'Thrissur East,Trichur,Kerala',
'Thrissur Engg College,Trichur,Kerala',
'Thrissur H.O,Trichur,Kerala',
'Thrissur R S,Trichur,Kerala',
'Tirur,Trichur,Kerala',
'Tolur-parappur,Trichur,Kerala',
'Urakam,Irinjalakuda,Kerala',
'Vadakkummuri,Irinjalakuda,Kerala',
'Vadookkara,Trichur,Kerala',
'Vallachira,Irinjalakuda,Kerala',
'Vaniampara,Trichur,Kerala',
'Velappaya,Trichur,Kerala',
'Vellanikkara,Trichur,Kerala',
'Veluthur,Trichur,Kerala',
'Vettukad,Trichur,Kerala',
'Viyyur,Trichur,Kerala',
'West Fort,Trichur,Kerala',
'Vatuvanchal,Calicut,Kerala',
'Vemom,Thalassery,Kerala',
'Cherakkara(wayanad),Thalassery,Kerala',
'Thondernadu,Thalassery,Kerala',
'Tirunelli,Thalassery,Kerala',
'Vanhode,Thalassery,Kerala',
'Alattil,Thalassery,Kerala',
'Anjukunnu,Thalassery,Kerala',
'Arattuthara,Thalassery,Kerala',
'Arinjerummal,Thalassery,Kerala',
'Bavali,Thalassery,Kerala',
'Cherukattoor,Thalassery,Kerala',
'Echchome,Thalassery,Kerala',
'Edavaka,Thalassery,Kerala',
'Ellumannam,Thalassery,Kerala',
'Kammana,Thalassery,Kerala',
'Kampatti,Thalassery,Kerala',
'Kappattumala,Thalassery,Kerala',
'Karakkamala,Thalassery,Kerala',
'Kartikulam,Thalassery,Kerala',
'Kattayad,Thalassery,Kerala',
'Kayakunnu,Thalassery,Kerala',
'Kellur,Thalassery,Kerala',
'Kottarakkunnu,Thalassery,Kerala',
'Kunhome,Thalassery,Kerala',
'Kunnamangalam Wayanad,Thalassery,Kerala',
'Makkiad,Thalassery,Kerala',
'Mananthavady,Thalassery,Kerala',
'Mattilayam,Thalassery,Kerala',
'Mundakutty,Thalassery,Kerala',
'Nadavayal,Thalassery,Kerala',
'Nallurnad,Thalassery,Kerala',
'Nirvaram,Thalassery,Kerala',
'Panamaram,Thalassery,Kerala',
'Panavally,Thalassery,Kerala',
'Payyampalli,Thalassery,Kerala',
'Periya,Thalassery,Kerala',
'Pilakavu,Thalassery,Kerala',
'Porur(wayanad),Thalassery,Kerala',
'Pudusseri,Thalassery,Kerala',
'Pudusserikadavu,Thalassery,Kerala',
'Tavinhal,Thalassery,Kerala',
'Thalapuzha,Thalassery,Kerala',
'Tharuvana,Thalassery,Kerala',
'Thettamala,Thalassery,Kerala',
'Tholpetty,Thalassery,Kerala',
'Thrissileri,Thalassery,Kerala',
'Tirunelli Temple,Thalassery,Kerala',
'Valery,Thalassery,Kerala',
'Vallat,Thalassery,Kerala',
'Vellamunda,Thalassery,Kerala',
'Vimalanagar,Thalassery,Kerala',
'Varayal,Thalassery,Kerala',
'Amara Kuni,Calicut,Kerala',
'Athirattu Kunnu,Calicut,Kerala',
'Beenachi,Calicut,Kerala',
'Bhoodanam Colony,Calicut,Kerala',
'Chedalath,Calicut,Kerala',
'Cheengeri,Calicut,Kerala',
'Cheeral,Calicut,Kerala',
'Cheeyambam,Calicut,Kerala',
'Chellangode,Calicut,Kerala',
'Choothupara,Calicut,Kerala',
'Chulliote,Calicut,Kerala',
'Cottanad,Calicut,Kerala',
'Kadalmat,Calicut,Kerala',
'Kakka Vayal,Calicut,Kerala',
'Kalanadi Kolli,Calicut,Kerala',
'Kalathu Vayal,Calicut,Kerala',
'Karachal,Calicut,Kerala',
'Karadipara,Calicut,Kerala',
'Karani,Calicut,Kerala',
'Kariyambadi,Calicut,Kerala',
'Kenichira,Calicut,Kerala',
'Kidanganad,Calicut,Kerala',
'Kolagapara,Calicut,Kerala',
'Koleri,Calicut,Kerala',
'Krishna Giri,Calicut,Kerala',
'Kumbaleri,Calicut,Kerala',
'Kuppadi,Calicut,Kerala',
'Manal Vayal,Calicut,Kerala',
'Marakadavu,Calicut,Kerala',
'Moodakolli,Calicut,Kerala',
'Mookuthi Kunnu,Calicut,Kerala',
'Moolan Kavu,Calicut,Kerala',
'Mullankolli,Calicut,Kerala',
'Mundakai,Calicut,Kerala',
'Muthanga,Calicut,Kerala',
'Mylambadi,Calicut,Kerala',
'Naiketty,Calicut,Kerala',
'Nallara Chal,Calicut,Kerala',
'Nambiar Kunnu,Calicut,Kerala',
'Narikkundu,Calicut,Kerala',
'Nathamkuni,Calicut,Kerala',
'Nenmeni,Calicut,Kerala',
'Nenmeni Kunnu,Calicut,Kerala',
'Nulpuzha,Calicut,Kerala',
'Padichira,Calicut,Kerala',
'Pakkom,Calicut,Kerala',
'Palakolli,Calicut,Kerala',
'Pambra,Calicut,Kerala',
'Pazhupathur,Calicut,Kerala',
'Perikallur,Calicut,Kerala',
'Poomulla,Calicut,Kerala',
'Poothadi,Calicut,Kerala',
'Puthan Kunnu,Calicut,Kerala',
'Puthumala,Calicut,Kerala',
'Ripon Wynad,Calicut,Kerala',
'Sasimala,Calicut,Kerala',
'Seetha Mount,Calicut,Kerala',
'Thazha Munda,Calicut,Kerala',
'Thazhathur,Calicut,Kerala',
'Thovari Mala,Calicut,Kerala',
'Trikai Petta,Calicut,Kerala',
'Vakeri,Calicut,Kerala',
'Vala Vayal,Calicut,Kerala',
'Valluvadi,Calicut,Kerala',
'Veliyambam,Calicut,Kerala',
'Chettapalam,Calicut,Kerala',
'Meenangadi,Calicut,Kerala',
'Meppadi,Calicut,Kerala',
'Pulpalli,Calicut,Kerala',
'Sulthan Bathery East,Calicut,Kerala',
'Sulthan Bathery,Calicut,Kerala',
'Vallarmala,Calicut,Kerala',
'Ambalavayal,Calicut,Kerala',
'Achooranam,Calicut,Kerala',
'Arambatta Kunnu,Calicut,Kerala',
'Bibleland,Calicut,Kerala',
'Chennalode,Calicut,Kerala',
'Chundale,Calicut,Kerala',
'Kalpetta H.O,Calicut,Kerala',
'Kalpetta North,Calicut,Kerala',
'Kaniyambetta,Calicut,Kerala',
'Karinkutty,Calicut,Kerala',
'Kavumannam,Calicut,Kerala',
'Kottathara,Calicut,Kerala',
'Kunnambetta,Calicut,Kerala',
'Lakkidi,Calicut,Kerala',
'Madakkimala,Calicut,Kerala',
'Madakunnu,Calicut,Kerala',
'Mandad,Calicut,Kerala',
'Maniyangode,Calicut,Kerala',
'Manjoora,Calicut,Kerala',
'Muttil,Calicut,Kerala',
'Padinhara Thara,Calicut,Kerala',
'Pallikunnu Wynad,Calicut,Kerala',
'Pariyaram - Wynad,Calicut,Kerala',
'Pinangode,Calicut,Kerala',
'Pozhuthana,Calicut,Kerala',
'Puthur Vayal,Calicut,Kerala',
'Puzhamutti,Calicut,Kerala',
'Sugandhagiri,Calicut,Kerala',
'Thariote North,Calicut,Kerala',
'Thariote,Calicut,Kerala',
'Thekkumthara,Calicut,Kerala',
'Varadoor,Calicut,Kerala',
'Varambetta,Calicut,Kerala',
'Vazhu Vatta,Calicut,Kerala',
'Vythiri,Calicut,Kerala',
'Kambalakkad,Calicut,Kerala',
'Agathi,Lakshadweep,Lakshadweep',
'Kalpeni,Lakshadweep,Lakshadweep',
'Kavaratti,Lakshadweep,Lakshadweep',
'Kiltan,Lakshadweep,Lakshadweep',
'Minicoy,Lakshadweep,Lakshadweep',
'Amai Colliery,Shahdol,Madhya Pradesh',
'Anuppur Basti,Shahdol,Madhya Pradesh',
'Anuppur,Shahdol,Madhya Pradesh',
'Audhera,Shahdol,Madhya Pradesh',
'Bahgarh,Shahdol,Madhya Pradesh',
'Balbahra,Shahdol,Madhya Pradesh',
'Bamhani,Shahdol,Madhya Pradesh',
'Barbaspur,Shahdol,Madhya Pradesh',
'Bargawan,Shahdol,Madhya Pradesh',
'Batura,Shahdol,Madhya Pradesh',
'Chachai,Shahdol,Madhya Pradesh',
'Chhilpa,Shahdol,Madhya Pradesh',
'Dhangawan,Shahdol,Madhya Pradesh',
'Dhurwasin,Shahdol,Madhya Pradesh',
'Dulhara,Shahdol,Madhya Pradesh',
'Jamudi,Shahdol,Madhya Pradesh',
'Kelhauri,Shahdol,Madhya Pradesh',
'Keshwahi,Shahdol,Madhya Pradesh',
'Khamhidol,Shahdol,Madhya Pradesh',
'Khoh,Shahdol,Madhya Pradesh',
'Malya,Shahdol,Madhya Pradesh',
'Mediaras,Shahdol,Madhya Pradesh',
'Pasla,Shahdol,Madhya Pradesh',
'Patnakalan,Shahdol,Madhya Pradesh',
'Piparia,Shahdol,Madhya Pradesh',
'Rampur,Shahdol,Madhya Pradesh',
'S.K. Nagar,Shahdol,Madhya Pradesh',
'Sonmauhari,Shahdol,Madhya Pradesh',
'Amgawan,Shahdol,Madhya Pradesh',
'Beed,Shahdol,Madhya Pradesh',
'Cholna,Shahdol,Madhya Pradesh',
'Dhangawan,Shahdol,Madhya Pradesh',
'Gaurela,Shahdol,Madhya Pradesh',
'Gorsi,Shahdol,Madhya Pradesh',
'Jaithari,Shahdol,Madhya Pradesh',
'Laharpur,Shahdol,Madhya Pradesh',
'Lapta,Shahdol,Madhya Pradesh',
'Pondi,Shahdol,Madhya Pradesh',
'Venkatnagar,Shahdol,Madhya Pradesh',
'Badra Colliery,Shahdol,Madhya Pradesh',
'Baherabandh,Shahdol,Madhya Pradesh',
'Baitola,Shahdol,Madhya Pradesh',
'Bangawan,Shahdol,Madhya Pradesh',
'Barbaspur,Shahdol,Madhya Pradesh',
'Beliabadi,Shahdol,Madhya Pradesh',
'Bhad,Shahdol,Madhya Pradesh',
'Bijuri Colliery,Shahdol,Madhya Pradesh',
'Bijuri,Shahdol,Madhya Pradesh',
'Biltukari,Shahdol,Madhya Pradesh',
'Chukan,Shahdol,Madhya Pradesh',
'Deogawan,Shahdol,Madhya Pradesh',
'Dola,Shahdol,Madhya Pradesh',
'Harad,Shahdol,Madhya Pradesh',
'Jamgaon,Shahdol,Madhya Pradesh',
'Jamuna Colliery,Shahdol,Madhya Pradesh',
'Jheek Bijuri,Shahdol,Madhya Pradesh',
'Jheemar Colliery,Shahdol,Madhya Pradesh',
'Kartora,Shahdol,Madhya Pradesh',
'Katkona,Shahdol,Madhya Pradesh',
'Khamraundh,Shahdol,Madhya Pradesh',
'Khodri,Shahdol,Madhya Pradesh',
'Kothi,Shahdol,Madhya Pradesh',
'Kotma Colliery,Shahdol,Madhya Pradesh',
'Kotma,Shahdol,Madhya Pradesh',
'Lamatola,Shahdol,Madhya Pradesh',
'Latar,Shahdol,Madhya Pradesh',
'Malga,Shahdol,Madhya Pradesh',
'Nigwani,Shahdol,Madhya Pradesh',
'Pasan,Shahdol,Madhya Pradesh',
'Payari,Shahdol,Madhya Pradesh',
'Rajnagar Colliery,Shahdol,Madhya Pradesh',
'Ramnagar Colliery,Shahdol,Madhya Pradesh',
'Reusa,Shahdol,Madhya Pradesh',
'Rupaula,Shahdol,Madhya Pradesh',
'Semra,Shahdol,Madhya Pradesh',
'Tengha,Shahdol,Madhya Pradesh',
'Thangaon,Shahdol,Madhya Pradesh',
'Thodaha,Shahdol,Madhya Pradesh',
'Urtan,Shahdol,Madhya Pradesh',
'Achalpur,Shahdol,Madhya Pradesh',
'Amarkantak,Shahdol,Madhya Pradesh',
'Amdari,Shahdol,Madhya Pradesh',
'Amgawan,Shahdol,Madhya Pradesh',
'Bamhani,Shahdol,Madhya Pradesh',
'Basantpur,Shahdol,Madhya Pradesh',
'Beldongari,Shahdol,Madhya Pradesh',
'Benibari,Shahdol,Madhya Pradesh',
'Bhejari,Shahdol,Madhya Pradesh',
'Bilaspur,Shahdol,Madhya Pradesh',
'Chhilhiyamar,Shahdol,Madhya Pradesh',
'Damehri,Shahdol,Madhya Pradesh',
'Dhirutola,Shahdol,Madhya Pradesh',
'Dhunmaniya,Shahdol,Madhya Pradesh',
'Ghoghari,Shahdol,Madhya Pradesh',
'Girari,Shahdol,Madhya Pradesh',
'Jarha,Shahdol,Madhya Pradesh',
'Jeelang,Shahdol,Madhya Pradesh',
'Johila Project,Shahdol,Madhya Pradesh',
'Kachhratola,Shahdol,Madhya Pradesh',
'Karanpathar,Shahdol,Madhya Pradesh',
'Karaundi,Shahdol,Madhya Pradesh',
'Karpa,Shahdol,Madhya Pradesh',
'Khamraundh,Shahdol,Madhya Pradesh',
'Khati,Shahdol,Madhya Pradesh',
'Koilari,Shahdol,Madhya Pradesh',
'Lakhaura,Shahdol,Madhya Pradesh',
'Lamsarai,Shahdol,Madhya Pradesh',
'Seorichandas,Shahdol,Madhya Pradesh',
'Tulra,Shahdol,Madhya Pradesh',
'Ufrikala,Shahdol,Madhya Pradesh',
'Umania,Shahdol,Madhya Pradesh',
'Rajendragram,Shahdol,Madhya Pradesh',
'Amrod,Guna,Madhya Pradesh',
'Ashoknagar,Guna,Madhya Pradesh',
'Athaikheda,Guna,Madhya Pradesh',
'Bagulya,Guna,Madhya Pradesh',
'Barodia,Guna,Madhya Pradesh',
'Berkhedi Tumen,Guna,Madhya Pradesh',
'Bhesarwas,Guna,Madhya Pradesh',
'Bilakhedi,Guna,Madhya Pradesh',
'Chhapar,Guna,Madhya Pradesh',
'Dangora Foot,Guna,Madhya Pradesh',
'Depalkhedi,Guna,Madhya Pradesh',
'Dhekan,Guna,Madhya Pradesh',
'Dungasara,Guna,Madhya Pradesh',
'Garroli,Guna,Madhya Pradesh',
'Hyder,Guna,Madhya Pradesh',
'Jalalpur,Guna,Madhya Pradesh',
'Jaleshwar,Guna,Madhya Pradesh',
'Jheela,Guna,Madhya Pradesh',
'Kachnar,Guna,Madhya Pradesh',
'Kariyya Rai,Guna,Madhya Pradesh',
'Kjajuriya Kala,Guna,Madhya Pradesh',
'Kukretha,Guna,Madhya Pradesh',
'Mathner,Guna,Madhya Pradesh',
'Mudra Bhadra,Guna,Madhya Pradesh',
'Naisarai,Guna,Madhya Pradesh',
'Narayanpur,Guna,Madhya Pradesh',
'Patkheda,Guna,Madhya Pradesh',
'Pilighata,Guna,Madhya Pradesh',
'Pipri,Guna,Madhya Pradesh',
'Raje Bamora,Guna,Madhya Pradesh',
'Rajpur,Guna,Madhya Pradesh',
'Raosar,Guna,Madhya Pradesh',
'Ratikheda,Guna,Madhya Pradesh',
'Renjha,Guna,Madhya Pradesh',
'Rijoda,Guna,Madhya Pradesh',
'Seji,Guna,Madhya Pradesh',
'Semrahat,Guna,Madhya Pradesh',
'Shadora,Guna,Madhya Pradesh',
'Shri Anandpur,Guna,Madhya Pradesh',
'Subash Ganj Ashoknagar,Guna,Madhya Pradesh',
'Taraoli,Guna,Madhya Pradesh',
'Tumen,Guna,Madhya Pradesh',
'Badera,Guna,Madhya Pradesh',
'Chanderi,Guna,Madhya Pradesh',
'Dungasara,Guna,Madhya Pradesh',
'Hansari,Guna,Madhya Pradesh',
'Khirkatanka,Guna,Madhya Pradesh',
'Maholi,Guna,Madhya Pradesh',
'Mohanpur,Guna,Madhya Pradesh',
'Naoli,Guna,Madhya Pradesh',
'Nayakheda,Guna,Madhya Pradesh',
'Pranpura,Guna,Madhya Pradesh',
'Tarai,Guna,Madhya Pradesh',
'Thubon,Guna,Madhya Pradesh',
'Vikrampur,Guna,Madhya Pradesh',
'Bamnawar,Guna,Madhya Pradesh',
'Chhapra,Guna,Madhya Pradesh',
'Derkha,Guna,Madhya Pradesh',
'Dhakoni,Guna,Madhya Pradesh',
'Dhurra,Guna,Madhya Pradesh',
'Endore,Guna,Madhya Pradesh',
'Esagarh,Guna,Madhya Pradesh',
'Gahora,Guna,Madhya Pradesh',
'Janghar,Guna,Madhya Pradesh',
'Kadwaya,Guna,Madhya Pradesh',
'Khiriyadewat,Guna,Madhya Pradesh',
'Mahidpur,Guna,Madhya Pradesh',
'Mahuan,Guna,Madhya Pradesh',
'Parsol,Guna,Madhya Pradesh',
'Pipresra,Guna,Madhya Pradesh',
'Rajtala,Guna,Madhya Pradesh',
'Raosar Jagir,Guna,Madhya Pradesh',
'Saraskhedi,Guna,Madhya Pradesh',
'Achalgarh,Guna,Madhya Pradesh',
'Babrod,Guna,Madhya Pradesh',
'Bahadurpur,Guna,Madhya Pradesh',
'Bilheru,Guna,Madhya Pradesh',
'Damdama,Guna,Madhya Pradesh',
'Dongra,Guna,Madhya Pradesh',
'Gaduli,Guna,Madhya Pradesh',
'Garenthi,Guna,Madhya Pradesh',
'Gunheru,Guna,Madhya Pradesh',
'Keshopur,Guna,Madhya Pradesh',
'Kirola,Guna,Madhya Pradesh',
'Madaukhedi,Guna,Madhya Pradesh',
'Mungaoli Bazar,Guna,Madhya Pradesh',
'Mungaoli,Guna,Madhya Pradesh',
'Onder,Guna,Madhya Pradesh',
'Parkana,Guna,Madhya Pradesh',
'Pathari,Guna,Madhya Pradesh',
'Piprai,Guna,Madhya Pradesh',
'Sehrai,Guna,Madhya Pradesh',
'Sigon,Guna,Madhya Pradesh',
'Singhada,Guna,Madhya Pradesh',
'Tamasha,Guna,Madhya Pradesh',
'Alna,Balaghat,Madhya Pradesh',
'Amgaon,Balaghat,Madhya Pradesh',
'Bagholi,Balaghat,Madhya Pradesh',
'Baihar,Balaghat,Madhya Pradesh',
'Bakal,Balaghat,Madhya Pradesh',
'Bhanderi,Balaghat,Madhya Pradesh',
'Bhidi,Balaghat,Madhya Pradesh',
'Bhikewada,Balaghat,Madhya Pradesh',
'Bijatola,Balaghat,Madhya Pradesh',
'Birsa,Balaghat,Madhya Pradesh',
'Birwa,Balaghat,Madhya Pradesh',
'Boda,Balaghat,Madhya Pradesh',
'Chandana,Balaghat,Madhya Pradesh',
'Damoh,Balaghat,Madhya Pradesh',
'Dongiriya,Balaghat,Madhya Pradesh',
'Dora,Balaghat,Madhya Pradesh',
'Garhi,Balaghat,Madhya Pradesh',
'Garra Tola,Balaghat,Madhya Pradesh',
'Gudma,Balaghat,Madhya Pradesh',
'Gudma,Balaghat,Madhya Pradesh',
'Jaitpuri,Balaghat,Madhya Pradesh',
'Janpur,Balaghat,Madhya Pradesh',
'Jatta,Balaghat,Madhya Pradesh',
'Kachnari,Balaghat,Madhya Pradesh',
'Kalegaon,Balaghat,Madhya Pradesh',
'Karamsara,Balaghat,Madhya Pradesh',
'Kareli,Balaghat,Madhya Pradesh',
'Karhu,Balaghat,Madhya Pradesh',
'Kharpadia,Balaghat,Madhya Pradesh',
'Khurmundi,Balaghat,Madhya Pradesh',
'Kinia,Balaghat,Madhya Pradesh',
'Kiniya Kandai,Balaghat,Madhya Pradesh',
'Kukarra,Balaghat,Madhya Pradesh',
'Kurenda,Balaghat,Madhya Pradesh',
'Linga,Balaghat,Madhya Pradesh',
'Lood,Balaghat,Madhya Pradesh',
'Majhgaon,Balaghat,Madhya Pradesh',
'Malanjkhand,Balaghat,Madhya Pradesh',
'Mandai,Balaghat,Madhya Pradesh',
'Manegaon,Balaghat,Madhya Pradesh',
'Mohgaon (B),Balaghat,Madhya Pradesh',
'Mukki,Balaghat,Madhya Pradesh',
'Nikkum,Balaghat,Madhya Pradesh',
'Pandutala,Balaghat,Madhya Pradesh',
'Paraswada,Balaghat,Madhya Pradesh',
'Piparia,Balaghat,Madhya Pradesh',
'Pondi,Balaghat,Madhya Pradesh',
'Pondi,Balaghat,Madhya Pradesh',
'Relwahi,Balaghat,Madhya Pradesh',
'Roopjhar,Balaghat,Madhya Pradesh',
'Saletekari,Balaghat,Madhya Pradesh',
'Sarekha,Balaghat,Madhya Pradesh',
'Sijhora,Balaghat,Madhya Pradesh',
'Sonpur,Balaghat,Madhya Pradesh',
'Thema,Balaghat,Madhya Pradesh',
'Tingipur,Balaghat,Madhya Pradesh',
'Ukwa,Balaghat,Madhya Pradesh',
'Ameda,Balaghat,Madhya Pradesh',
'Balaghat City,Balaghat,Madhya Pradesh',
'Balaghat H.O,Balaghat,Madhya Pradesh',
'Balaghat R.S.,Balaghat,Madhya Pradesh',
'Bharveli,Balaghat,Madhya Pradesh',
'Boda,Balaghat,Madhya Pradesh',
'Chalisbodi,Balaghat,Madhya Pradesh',
'Charega R.S.,Balaghat,Madhya Pradesh',
'Deori,Balaghat,Madhya Pradesh',
'Dhansua,Balaghat,Madhya Pradesh',
'Garra,Balaghat,Madhya Pradesh',
'Ghunadi,Balaghat,Madhya Pradesh',
'Gongalai,Balaghat,Madhya Pradesh',
'Gudru R.S.,Balaghat,Madhya Pradesh',
'Kochewada,Balaghat,Madhya Pradesh',
'Kumhari,Balaghat,Madhya Pradesh',
'Lamta,Balaghat,Madhya Pradesh',
'Linga,Balaghat,Madhya Pradesh',
'Magardarra,Balaghat,Madhya Pradesh',
'Mohgaon Batua,Balaghat,Madhya Pradesh',
'Moriya,Balaghat,Madhya Pradesh',
'Nagarwada R.S.,Balaghat,Madhya Pradesh',
'Padriganj R.S,Balaghat,Madhya Pradesh',
'Roshna,Balaghat,Madhya Pradesh',
'Samnapur,Balaghat,Madhya Pradesh',
'Sarekha-kosmi,Balaghat,Madhya Pradesh',
'Agasi,Balaghat,Madhya Pradesh',
'Agri,Balaghat,Madhya Pradesh',
'Banera,Balaghat,Madhya Pradesh',
'Deori,Balaghat,Madhya Pradesh',
'Digdha,Balaghat,Madhya Pradesh',
'Goreghat,Balaghat,Madhya Pradesh',
'Hardoli,Balaghat,Madhya Pradesh',
'Jam,Balaghat,Madhya Pradesh',
'Jarah Mohgaon,Balaghat,Madhya Pradesh',
'Katangi,Balaghat,Madhya Pradesh',
'Katedara,Balaghat,Madhya Pradesh',
'Katera,Balaghat,Madhya Pradesh',
'Khamaria,Balaghat,Madhya Pradesh',
'Koylari,Balaghat,Madhya Pradesh',
'Lingapounar,Balaghat,Madhya Pradesh',
'Mahkepar,Balaghat,Madhya Pradesh',
'Manegaon,Balaghat,Madhya Pradesh',
'Nandi,Balaghat,Madhya Pradesh',
'Paraswaraghat,Balaghat,Madhya Pradesh',
'Pouniya,Balaghat,Madhya Pradesh',
'Pulputta,Balaghat,Madhya Pradesh',
'Selwa,Balaghat,Madhya Pradesh',
'Sirpur,Balaghat,Madhya Pradesh',
'Sukli,Balaghat,Madhya Pradesh',
'Tekadi,Balaghat,Madhya Pradesh',
'Tirodi,Balaghat,Madhya Pradesh',
'Tumsar,Balaghat,Madhya Pradesh',
'Atri,Balaghat,Madhya Pradesh',
'Beni,Balaghat,Madhya Pradesh',
'Bhandarbodi,Balaghat,Madhya Pradesh',
'Bhaurgarh,Balaghat,Madhya Pradesh',
'Fulchur,Balaghat,Madhya Pradesh',
'Kachekhani,Balaghat,Madhya Pradesh',
'Katori,Balaghat,Madhya Pradesh',
'Khairi,Balaghat,Madhya Pradesh',
'Kumhali,Balaghat,Madhya Pradesh',
'Miragpur,Balaghat,Madhya Pradesh',
'Mowad,Balaghat,Madhya Pradesh',
'Saleteka,Balaghat,Madhya Pradesh',
'Saori,Balaghat,Madhya Pradesh',
'Shankar Pipariya,Balaghat,Madhya Pradesh',
'Sewati,Balaghat,Madhya Pradesh',
'Bhanegaon,Balaghat,Madhya Pradesh',
'Budhi,Balaghat,Madhya Pradesh',
'Chikhla,Balaghat,Madhya Pradesh',
'Dahedi,Balaghat,Madhya Pradesh',
'Hatta Road,Balaghat,Madhya Pradesh',
'Hatta,Balaghat,Madhya Pradesh',
'Hirri,Balaghat,Madhya Pradesh',
'Kandrikala,Balaghat,Madhya Pradesh',
'Kariadand,Balaghat,Madhya Pradesh',
'Keshalewada,Balaghat,Madhya Pradesh',
'Khara,Balaghat,Madhya Pradesh',
'Kinhi,Balaghat,Madhya Pradesh',
'Kirnapur,Balaghat,Madhya Pradesh',
'Laweri,Balaghat,Madhya Pradesh',
'Mate,Balaghat,Madhya Pradesh',
'Mauda,Balaghat,Madhya Pradesh',
'Mohgaon-khurd,Balaghat,Madhya Pradesh',
'Mohjhari,Balaghat,Madhya Pradesh',
'Nakshi,Balaghat,Madhya Pradesh',
'Newargaon Kala,Balaghat,Madhya Pradesh',
'Pala,Balaghat,Madhya Pradesh',
'Rajegaon,Balaghat,Madhya Pradesh',
'Ramgarhi,Balaghat,Madhya Pradesh',
'Rankakodi,Balaghat,Madhya Pradesh',
'Saleteka,Balaghat,Madhya Pradesh',
'Seoni Sarad,Balaghat,Madhya Pradesh',
'Temni,Balaghat,Madhya Pradesh',
'Kanki,Balaghat,Madhya Pradesh',
'Bagholi,Balaghat,Madhya Pradesh',
'Bori,Balaghat,Madhya Pradesh',
'Dadiya,Balaghat,Madhya Pradesh',
'Ghoti,Balaghat,Madhya Pradesh',
'Kanjai,Balaghat,Madhya Pradesh',
'Katanjhari,Balaghat,Madhya Pradesh',
'Khamariya Bazar,Balaghat,Madhya Pradesh',
'Lalbarra,Balaghat,Madhya Pradesh',
'Nagpura,Balaghat,Madhya Pradesh',
'Neelji,Balaghat,Madhya Pradesh',
'Newargaon,Balaghat,Madhya Pradesh',
'Sihora,Balaghat,Madhya Pradesh',
'Badgaon,Balaghat,Madhya Pradesh',
'Bakoda,Balaghat,Madhya Pradesh',
'Birsola,Balaghat,Madhya Pradesh',
'Jam,Balaghat,Madhya Pradesh',
'Khari,Balaghat,Madhya Pradesh',
'Mohgaon Dhapera,Balaghat,Madhya Pradesh',
'Ameda,Balaghat,Madhya Pradesh',
'Badgaon,Balaghat,Madhya Pradesh',
'Bahela,Balaghat,Madhya Pradesh',
'Bisoni,Balaghat,Madhya Pradesh',
'Bolegaon,Balaghat,Madhya Pradesh',
'Devalgaon,Balaghat,Madhya Pradesh',
'Ghansa,Balaghat,Madhya Pradesh',
'Kalimati,Balaghat,Madhya Pradesh',
'Karanja,Balaghat,Madhya Pradesh',
'Kulpa,Balaghat,Madhya Pradesh',
'Kumharikala,Balaghat,Madhya Pradesh',
'Ladsa,Balaghat,Madhya Pradesh',
'Lanji,Balaghat,Madhya Pradesh',
'Maneri,Balaghat,Madhya Pradesh',
'Miriya,Balaghat,Madhya Pradesh',
'Nandora,Balaghat,Madhya Pradesh',
'Newarwahi,Balaghat,Madhya Pradesh',
'Pathargaon,Balaghat,Madhya Pradesh',
'Risewara,Balaghat,Madhya Pradesh',
'Sadra,Balaghat,Madhya Pradesh',
'Sawari,Balaghat,Madhya Pradesh',
'Sonarkakodi,Balaghat,Madhya Pradesh',
'Bamhani,Balaghat,Madhya Pradesh',
'Amai,Balaghat,Madhya Pradesh',
'Arambha,Balaghat,Madhya Pradesh',
'Bakera,Balaghat,Madhya Pradesh',
'Bhendara,Balaghat,Madhya Pradesh',
'Budbuda,Balaghat,Madhya Pradesh',
'Chikhla Bandh,Balaghat,Madhya Pradesh',
'Chillod,Balaghat,Madhya Pradesh',
'Deeni,Balaghat,Madhya Pradesh',
'Garra,Balaghat,Madhya Pradesh',
'Ghoti,Balaghat,Madhya Pradesh',
'Jhaliwada,Balaghat,Madhya Pradesh',
'Kaspur,Balaghat,Madhya Pradesh',
'Kaydi,Balaghat,Madhya Pradesh',
'Khadkhadi,Balaghat,Madhya Pradesh',
'Khairlanji,Balaghat,Madhya Pradesh',
'Kochewahi,Balaghat,Madhya Pradesh',
'Koste,Balaghat,Madhya Pradesh',
'Kothurna,Balaghat,Madhya Pradesh',
'Ladsada,Balaghat,Madhya Pradesh',
'Lalpur,Balaghat,Madhya Pradesh',
'Lawni,Balaghat,Madhya Pradesh',
'Mangejhari,Balaghat,Madhya Pradesh',
'Mehndiwada,Balaghat,Madhya Pradesh',
'Mendki,Balaghat,Madhya Pradesh',
'Navegaon-3,Balaghat,Madhya Pradesh',
'Newargaon,Balaghat,Madhya Pradesh',
'Piparia Bhandi,Balaghat,Madhya Pradesh',
'Rampaily,Balaghat,Madhya Pradesh',
'Ramrama,Balaghat,Madhya Pradesh',
'Salebardi,Balaghat,Madhya Pradesh',
'Sawan R.S.,Balaghat,Madhya Pradesh',
'Thanegaon,Balaghat,Madhya Pradesh',
'Waraseoni Civil Line,Balaghat,Madhya Pradesh',
'Waraseoni,Balaghat,Madhya Pradesh',
'Goi,Khandwa,Madhya Pradesh',
'Anjad,Khandwa,Madhya Pradesh',
'Anjarada,Khandwa,Madhya Pradesh',
'Attarsambha,Khandwa,Madhya Pradesh',
'Balkuwan,Khandwa,Madhya Pradesh',
'Barda,Khandwa,Madhya Pradesh',
'Barwani,Khandwa,Madhya Pradesh',
'Bawangaja,Khandwa,Madhya Pradesh',
'Bhawati,Khandwa,Madhya Pradesh',
'Bokrata,Khandwa,Madhya Pradesh',
'Borlay,Khandwa,Madhya Pradesh',
'Chikliya,Khandwa,Madhya Pradesh',
'Gandhawal,Khandwa,Madhya Pradesh',
'Julwania,Khandwa,Madhya Pradesh',
'Kasrawad (S),Khandwa,Madhya Pradesh',
'Limbi,Khandwa,Madhya Pradesh',
'Lonsara Khurd,Khandwa,Madhya Pradesh',
'Matali,Khandwa,Madhya Pradesh',
'Menimata,Khandwa,Madhya Pradesh',
'Panchpula(N),Khandwa,Madhya Pradesh',
'Pati,Khandwa,Madhya Pradesh',
'Piplaj,Khandwa,Madhya Pradesh',
'Sajwani,Khandwa,Madhya Pradesh',
'Semali,Khandwa,Madhya Pradesh',
'Sondul,Khandwa,Madhya Pradesh',
'Sustikheda,Khandwa,Madhya Pradesh',
'Talun Khurd,Khandwa,Madhya Pradesh',
'Talwada Bujurg,Khandwa,Madhya Pradesh',
'Chatli,Khandwa,Madhya Pradesh',
'Diwaniya,Khandwa,Madhya Pradesh',
'Jogwada,Khandwa,Madhya Pradesh',
'Kunjari,Khandwa,Madhya Pradesh',
'Niwali,Khandwa,Madhya Pradesh',
'Wajhar,Khandwa,Madhya Pradesh',
'Bandhara Bujurg,Khandwa,Madhya Pradesh',
'Bhatki,Khandwa,Madhya Pradesh',
'Dondwada,Khandwa,Madhya Pradesh',
'Jahur,Khandwa,Madhya Pradesh',
'Jalgone,Khandwa,Madhya Pradesh',
'Junapani,Khandwa,Madhya Pradesh',
'Kansul,Khandwa,Madhya Pradesh',
'Malfa,Khandwa,Madhya Pradesh',
'Moida,Khandwa,Madhya Pradesh',
'Mortalai,Khandwa,Madhya Pradesh',
'Nisarpur,Khandwa,Madhya Pradesh',
'Pansemal,Khandwa,Madhya Pradesh',
'Rakhibujurg,Khandwa,Madhya Pradesh',
'Temala,Khandwa,Madhya Pradesh',
'Bakwadi,Khandwa,Madhya Pradesh',
'Balsamund,Khandwa,Madhya Pradesh',
'Baruphatak,Khandwa,Madhya Pradesh',
'Baswi,Khandwa,Madhya Pradesh',
'Bhorwada,Khandwa,Madhya Pradesh',
'Bilwa Road,Khandwa,Madhya Pradesh',
'Chitawal,Khandwa,Madhya Pradesh',
'Danod,Khandwa,Madhya Pradesh',
'Ghusgaon,Khandwa,Madhya Pradesh',
'Indrapur,Khandwa,Madhya Pradesh',
'Nagalwadi,Khandwa,Madhya Pradesh',
'Ojhar,Khandwa,Madhya Pradesh',
'Palsud,Khandwa,Madhya Pradesh',
'Pipari Bujurg,Khandwa,Madhya Pradesh',
'Rajpur Barwani,Khandwa,Madhya Pradesh',
'Rangaon Road,Khandwa,Madhya Pradesh',
'Revaja,Khandwa,Madhya Pradesh',
'Rui,Khandwa,Madhya Pradesh',
'Sali,Khandwa,Madhya Pradesh',
'Salikalan,Khandwa,Madhya Pradesh',
'Sangaon,Khandwa,Madhya Pradesh',
'Upla,Khandwa,Madhya Pradesh',
'Khetya,Khandwa,Madhya Pradesh',
'Achli,Khandwa,Madhya Pradesh',
'Balwadi,Khandwa,Madhya Pradesh',
'Bawdad,Khandwa,Madhya Pradesh',
'Bhakarli,Khandwa,Madhya Pradesh',
'Chachariya,Khandwa,Madhya Pradesh',
'Dhanora,Khandwa,Madhya Pradesh',
'Dhawali,Khandwa,Madhya Pradesh',
'Dugani,Khandwa,Madhya Pradesh',
'Jamathi,Khandwa,Madhya Pradesh',
'Jhopali,Khandwa,Madhya Pradesh',
'Mahitgaon,Khandwa,Madhya Pradesh',
'Malwan,Khandwa,Madhya Pradesh',
'Nawalpura,Khandwa,Madhya Pradesh',
'Sendhwa,Khandwa,Madhya Pradesh',
'Shahpura,Khandwa,Madhya Pradesh',
'Solwan,Khandwa,Madhya Pradesh',
'Warla,Khandwa,Madhya Pradesh',
'Badgaon,Khandwa,Madhya Pradesh',
'Baghadi,Khandwa,Madhya Pradesh',
'Brahamngaon,Khandwa,Madhya Pradesh',
'Chichali (D),Khandwa,Madhya Pradesh',
'Dawana,Khandwa,Madhya Pradesh',
'Deola,Khandwa,Madhya Pradesh',
'Fatyapur,Khandwa,Madhya Pradesh',
'Ghatwa,Khandwa,Madhya Pradesh',
'Haribad,Khandwa,Madhya Pradesh',
'Khajuri,Khandwa,Madhya Pradesh',
'Khurrampura,Khandwa,Madhya Pradesh',
'Koradiya,Khandwa,Madhya Pradesh',
'Kuwan,Khandwa,Madhya Pradesh',
'Lakhangaon,Khandwa,Madhya Pradesh',
'Mandwada,Khandwa,Madhya Pradesh',
'Mehgaon Deb,Khandwa,Madhya Pradesh',
'Mohipura,Khandwa,Madhya Pradesh',
'Rangaon Deb,Khandwa,Madhya Pradesh',
'Segwal,Khandwa,Madhya Pradesh',
'Talwada Deb,Khandwa,Madhya Pradesh',
'Thikari,Khandwa,Madhya Pradesh',
'Uchawad,Khandwa,Madhya Pradesh',
'Athanair,Chhindwara,Madhya Pradesh',
'Chudia,Chhindwara,Madhya Pradesh',
'Ambada,Chhindwara,Madhya Pradesh',
'Amla Depot,Chhindwara,Madhya Pradesh',
'Amla,Chhindwara,Madhya Pradesh',
'Andharia,Chhindwara,Madhya Pradesh',
'Anwaria,Chhindwara,Madhya Pradesh',
'Badgaon,Chhindwara,Madhya Pradesh',
'Barangwari,Chhindwara,Madhya Pradesh',
'Bordehi,Chhindwara,Madhya Pradesh',
'Chhipanya Pipariya,Chhindwara,Madhya Pradesh',
'Jambada,Chhindwara,Madhya Pradesh',
'Kalmeshwara,Chhindwara,Madhya Pradesh',
'Kanojia,Chhindwara,Madhya Pradesh',
'Khapakhateda,Chhindwara,Madhya Pradesh',
'Kutkhedai,Chhindwara,Madhya Pradesh',
'Lakhapur,Chhindwara,Madhya Pradesh',
'Lalawadi,Chhindwara,Madhya Pradesh',
'Morandhana,Chhindwara,Madhya Pradesh',
'Nahiya,Chhindwara,Madhya Pradesh',
'Parsodi,Chhindwara,Madhya Pradesh',
'Ramli,Chhindwara,Madhya Pradesh',
'Ratedkalan,Chhindwara,Madhya Pradesh',
'Toranwara,Chhindwara,Madhya Pradesh',
'Umaria,Chhindwara,Madhya Pradesh',
'Bakud,Chhindwara,Madhya Pradesh',
'Jawara,Chhindwara,Madhya Pradesh',
'Sawalmendha,Chhindwara,Madhya Pradesh',
'Amal,Chhindwara,Madhya Pradesh',
'Awaria,Chhindwara,Madhya Pradesh',
'Badora,Chhindwara,Madhya Pradesh',
'Bagholi,Chhindwara,Madhya Pradesh',
'Bansnerkala,Chhindwara,Madhya Pradesh',
'Baravi,Chhindwara,Madhya Pradesh',
'Betul Bazaar,Chhindwara,Madhya Pradesh',
'Betul Ganj,Chhindwara,Madhya Pradesh',
'Betul H.O,Chhindwara,Madhya Pradesh',
'Bhadus,Chhindwara,Madhya Pradesh',
'Bharat Bharti,Chhindwara,Madhya Pradesh',
'Bharkawarai,Chhindwara,Madhya Pradesh',
'Bhimpur,Chhindwara,Madhya Pradesh',
'Bhogiteda,Chhindwara,Madhya Pradesh',
'Bijadehi,Chhindwara,Madhya Pradesh',
'Borgaon,Chhindwara,Madhya Pradesh',
'Borgaon,Chhindwara,Madhya Pradesh',
'Chandbaheda,Chhindwara,Madhya Pradesh',
'Chicholi,Chhindwara,Madhya Pradesh',
'Chikhali,Chhindwara,Madhya Pradesh',
'Chikhali,Chhindwara,Madhya Pradesh',
'Chirapatla,Chhindwara,Madhya Pradesh',
'Chunahajuri,Chhindwara,Madhya Pradesh',
'Chunalohna,Chhindwara,Madhya Pradesh',
'Dhanora Adarsh,Chhindwara,Madhya Pradesh',
'Dudhiya,Chhindwara,Madhya Pradesh',
'Garha,Chhindwara,Madhya Pradesh',
'Ghisibagla,Chhindwara,Madhya Pradesh',
'Godhna,Chhindwara,Madhya Pradesh',
'Gondigoula,Chhindwara,Madhya Pradesh',
'Jawara,Chhindwara,Madhya Pradesh',
'Jeen,Chhindwara,Madhya Pradesh',
'Jhallar,Chhindwara,Madhya Pradesh',
'Jhapal,Chhindwara,Madhya Pradesh',
'Jogli,Chhindwara,Madhya Pradesh',
'Kesia,Chhindwara,Madhya Pradesh',
'Khandara,Chhindwara,Madhya Pradesh',
'Khedisaoligarh,Chhindwara,Madhya Pradesh',
'Kothi Bazaar,Chhindwara,Madhya Pradesh',
'Kurasna,Chhindwara,Madhya Pradesh',
'Malajpur,Chhindwara,Madhya Pradesh',
'Mandai Bujurg,Chhindwara,Madhya Pradesh',
'Mathani,Chhindwara,Madhya Pradesh',
'Mohda,Chhindwara,Madhya Pradesh',
'Nimpani Padhar,Chhindwara,Madhya Pradesh',
'Path,Chhindwara,Madhya Pradesh',
'Pathakheda,Chhindwara,Madhya Pradesh',
'Patri,Chhindwara,Madhya Pradesh',
'Pipariyagurwa,Chhindwara,Madhya Pradesh',
'Ratanpur,Chhindwara,Madhya Pradesh',
'Rondha,Chhindwara,Madhya Pradesh',
'Sakadehi,Chhindwara,Madhya Pradesh',
'Sehra,Chhindwara,Madhya Pradesh',
'Selgaon,Chhindwara,Madhya Pradesh',
'Sillot,Chhindwara,Madhya Pradesh',
'Sohagpur,Chhindwara,Madhya Pradesh',
'Temni,Chhindwara,Madhya Pradesh',
'Vijaygaram,Chhindwara,Madhya Pradesh',
'Vikasnagar Betul,Chhindwara,Madhya Pradesh',
'Kolgaon,Chhindwara,Madhya Pradesh',
'Badgaon,Chhindwara,Madhya Pradesh',
'Barhapur,Chhindwara,Madhya Pradesh',
'Belkund,Chhindwara,Madhya Pradesh',
'Bhainsdehi,Chhindwara,Madhya Pradesh',
'Bothi,Chhindwara,Madhya Pradesh',
'Chadu,Chhindwara,Madhya Pradesh',
'Dehgud,Chhindwara,Madhya Pradesh',
'Dhamangaon,Chhindwara,Madhya Pradesh',
'Dhanora,Chhindwara,Madhya Pradesh',
'Gargud,Chhindwara,Madhya Pradesh',
'Gudgaon,Chhindwara,Madhya Pradesh',
'Hidli,Chhindwara,Madhya Pradesh',
'Jamthi,Chhindwara,Madhya Pradesh',
'Khamla,Chhindwara,Madhya Pradesh',
'Khomai,Chhindwara,Madhya Pradesh',
'Kothalkund,Chhindwara,Madhya Pradesh',
'Kunkhedi,Chhindwara,Madhya Pradesh',
'Majarwani,Chhindwara,Madhya Pradesh',
'Mandvi,Chhindwara,Madhya Pradesh',
'Mendha Chhindwad,Chhindwara,Madhya Pradesh',
'Palasya,Chhindwara,Madhya Pradesh',
'Pusli,Chhindwara,Madhya Pradesh',
'Sakli,Chhindwara,Madhya Pradesh',
'Saongi,Chhindwara,Madhya Pradesh',
'Satner,Chhindwara,Madhya Pradesh',
'Seoni,Chhindwara,Madhya Pradesh',
'Tembhurni,Chhindwara,Madhya Pradesh',
'Temni,Chhindwara,Madhya Pradesh',
'Thopoda,Chhindwara,Madhya Pradesh',
'Wadali,Chhindwara,Madhya Pradesh',
'Dunawa,Chhindwara,Madhya Pradesh',
'Hirawari,Chhindwara,Madhya Pradesh',
'Sipawa,Chhindwara,Madhya Pradesh',
'Amraoti Ghat,Chhindwara,Madhya Pradesh',
'Ashta,Chhindwara,Madhya Pradesh',
'Bandli,Chhindwara,Madhya Pradesh',
'Barai,Chhindwara,Madhya Pradesh',
'Barkhed,Chhindwara,Madhya Pradesh',
'Bhagoda,Chhindwara,Madhya Pradesh',
'Bihargaon,Chhindwara,Madhya Pradesh',
'Birul Bazar,Chhindwara,Madhya Pradesh',
'Bisnoor,Chhindwara,Madhya Pradesh',
'Chandora Khurad,Chhindwara,Madhya Pradesh',
'Chhindi,Chhindwara,Madhya Pradesh',
'Chhindkheda,Chhindwara,Madhya Pradesh',
'Chichanda,Chhindwara,Madhya Pradesh',
'Chikhalikalan,Chhindwara,Madhya Pradesh',
'Chilhati,Chhindwara,Madhya Pradesh',
'Chouthia,Chhindwara,Madhya Pradesh',
'Dahua,Chhindwara,Madhya Pradesh',
'Dhabla,Chhindwara,Madhya Pradesh',
'Dhatora,Chhindwara,Madhya Pradesh',
'Etawa,Chhindwara,Madhya Pradesh',
'Gehubarsa,Chhindwara,Madhya Pradesh',
'Ghatbiroli,Chhindwara,Madhya Pradesh',
'Ghatpipariya,Chhindwara,Madhya Pradesh',
'Goula,Chhindwara,Madhya Pradesh',
'Gubrel,Chhindwara,Madhya Pradesh',
'Hathanapur,Chhindwara,Madhya Pradesh',
'Hirdi,Chhindwara,Madhya Pradesh',
'Hiwarkhed,Chhindwara,Madhya Pradesh',
'Jam,Chhindwara,Madhya Pradesh',
'Joulkheda,Chhindwara,Madhya Pradesh',
'Karpa,Chhindwara,Madhya Pradesh',
'Kathi,Chhindwara,Madhya Pradesh',
'Khairwani,Chhindwara,Madhya Pradesh',
'Khedicourt,Chhindwara,Madhya Pradesh',
'Khedlibazar,Chhindwara,Madhya Pradesh',
'Kujba,Chhindwara,Madhya Pradesh',
'Lilajhir,Chhindwara,Madhya Pradesh',
'Magnonakhurd,Chhindwara,Madhya Pradesh',
'Magonakalan,Chhindwara,Madhya Pradesh',
'Mahatpur,Chhindwara,Madhya Pradesh',
'Masod,Chhindwara,Madhya Pradesh',
'Mathani,Chhindwara,Madhya Pradesh',
'Mohi,Chhindwara,Madhya Pradesh',
'Morkha,Chhindwara,Madhya Pradesh',
'Multai Bazaar,Chhindwara,Madhya Pradesh',
'Multai,Chhindwara,Madhya Pradesh',
'Narkhed,Chhindwara,Madhya Pradesh',
'Paradsinga,Chhindwara,Madhya Pradesh',
'Parmandal,Chhindwara,Madhya Pradesh',
'Pohar,Chhindwara,Madhya Pradesh',
'Pouni,Chhindwara,Madhya Pradesh',
'Prabhat Pattan,Chhindwara,Madhya Pradesh',
'Ragadgaon,Chhindwara,Madhya Pradesh',
'Rai Amla,Chhindwara,Madhya Pradesh',
'Ridhora,Chhindwara,Madhya Pradesh',
'Sainkheda,Chhindwara,Madhya Pradesh',
'Sandia,Chhindwara,Madhya Pradesh',
'Saongi,Chhindwara,Madhya Pradesh',
'Sarai,Chhindwara,Madhya Pradesh',
'Sarra,Chhindwara,Madhya Pradesh',
'Sasundra,Chhindwara,Madhya Pradesh',
'Sehangaon,Chhindwara,Madhya Pradesh',
'Semjhira,Chhindwara,Madhya Pradesh',
'Shirdi,Chhindwara,Madhya Pradesh',
'Sonegaon,Chhindwara,Madhya Pradesh',
'Sonora,Chhindwara,Madhya Pradesh',
'Taikheda,Chhindwara,Madhya Pradesh',
'Tiwarkhed,Chhindwara,Madhya Pradesh',
'Umari,Chhindwara,Madhya Pradesh',
'Yenkheda,Chhindwara,Madhya Pradesh',
'Yenus,Chhindwara,Madhya Pradesh',
'Amdhana,Chhindwara,Madhya Pradesh',
'Badalpur,Chhindwara,Madhya Pradesh',
'Batkidoh,Chhindwara,Madhya Pradesh',
'Bhaiyawari,Chhindwara,Madhya Pradesh',
'Bhoura,Chhindwara,Madhya Pradesh',
'Chikhalpati,Chhindwara,Madhya Pradesh',
'Chopna,Chhindwara,Madhya Pradesh',
'Desawari,Chhindwara,Madhya Pradesh',
'Dhapoda,Chhindwara,Madhya Pradesh',
'Dharakhoh,Chhindwara,Madhya Pradesh',
'Hirapur,Chhindwara,Madhya Pradesh',
'Kachhar,Chhindwara,Madhya Pradesh',
'Kundi,Chhindwara,Madhya Pradesh',
'Pahawari,Chhindwara,Madhya Pradesh',
'Pathai,Chhindwara,Madhya Pradesh',
'Ranipur,Chhindwara,Madhya Pradesh',
'Salaiya,Chhindwara,Madhya Pradesh',
'Salimet,Chhindwara,Madhya Pradesh',
'Shabhapur Colloery,Chhindwara,Madhya Pradesh',
'Shahpur,Chhindwara,Madhya Pradesh',
'Shaktigarh,Chhindwara,Madhya Pradesh',
'Silpati,Chhindwara,Madhya Pradesh',
'Sitakamath,Chhindwara,Madhya Pradesh',
'Temru,Chhindwara,Madhya Pradesh',
'Ghoradongari,Chhindwara,Madhya Pradesh',
'Pathakheda,Chhindwara,Madhya Pradesh',
'Sarni,Chhindwara,Madhya Pradesh',
'Ahorli Kali,Morena,Madhya Pradesh',
'Akon,Morena,Madhya Pradesh',
'Attair,Morena,Madhya Pradesh',
'Balapura,Morena,Madhya Pradesh',
'Bindwa,Morena,Madhya Pradesh',
'Chomho,Morena,Madhya Pradesh',
'Jamsara,Morena,Madhya Pradesh',
'Jori Kotwal,Morena,Madhya Pradesh',
'Kanera,Morena,Madhya Pradesh',
'Khadit,Morena,Madhya Pradesh',
'Khanrika,Morena,Madhya Pradesh',
'Pratappura,Morena,Madhya Pradesh',
'Ridoli,Morena,Madhya Pradesh',
'Tarsokhar,Morena,Madhya Pradesh',
'Udhotgarh,Morena,Madhya Pradesh',
'Ahenti,Morena,Madhya Pradesh',
'Akaha,Morena,Madhya Pradesh',
'Akoda,Morena,Madhya Pradesh',
'Atarsuma,Morena,Madhya Pradesh',
'Attair Road Bhind,Morena,Madhya Pradesh',
'Babedi,Morena,Madhya Pradesh',
'Bagulari,Morena,Madhya Pradesh',
'Bajhai,Morena,Madhya Pradesh',
'Bara Kalan,Morena,Madhya Pradesh',
'Baran Khurd,Morena,Madhya Pradesh',
'Barhi,Morena,Madhya Pradesh',
'Bhad Khur,Morena,Madhya Pradesh',
'Bhagwasi,Morena,Madhya Pradesh',
'Bharoli,Morena,Madhya Pradesh',
'Bhawanpura,Morena,Madhya Pradesh',
'Bhind H.O,Morena,Madhya Pradesh',
'Bhind Kutchary,Morena,Madhya Pradesh',
'Bhind Mandi,Morena,Madhya Pradesh',
'Bijora,Morena,Madhya Pradesh',
'Bilao,Morena,Madhya Pradesh',
'Chachar,Morena,Madhya Pradesh',
'Chandupura,Morena,Madhya Pradesh',
'Chatthar,Morena,Madhya Pradesh',
'Daboha,Morena,Madhya Pradesh',
'Dharai,Morena,Madhya Pradesh',
'Didi,Morena,Madhya Pradesh',
'Donchara,Morena,Madhya Pradesh',
'Dulhangan,Morena,Madhya Pradesh',
'Ethar,Morena,Madhya Pradesh',
'Garhpara,Morena,Madhya Pradesh',
'Goara,Morena,Madhya Pradesh',
'Gopalpura,Morena,Madhya Pradesh',
'Gyanpura,Morena,Madhya Pradesh',
'Heera Lalka Pura,Morena,Madhya Pradesh',
'Housing Colony Bhind,Morena,Madhya Pradesh',
'Jakhmoli,Morena,Madhya Pradesh',
'Jamna,Morena,Madhya Pradesh',
'Jampura,Morena,Madhya Pradesh',
'Janora,Morena,Madhya Pradesh',
'Jari,Morena,Madhya Pradesh',
'Jawasa,Morena,Madhya Pradesh',
'Kachogra,Morena,Madhya Pradesh',
'Kakahara,Morena,Madhya Pradesh',
'Kanawar,Morena,Madhya Pradesh',
'Kishupura,Morena,Madhya Pradesh',
'Kosad,Morena,Madhya Pradesh',
'Kot,Morena,Madhya Pradesh',
'Lahroli,Morena,Madhya Pradesh',
'Lawan,Morena,Madhya Pradesh',
'Masuri,Morena,Madhya Pradesh',
'Misa,Morena,Madhya Pradesh',
'Nai Garhi,Morena,Madhya Pradesh',
'Nai Zameen Bhind,Morena,Madhya Pradesh',
'Naya Goun,Morena,Madhya Pradesh',
'Nunheta,Morena,Madhya Pradesh',
'Palawali,Morena,Madhya Pradesh',
'Pandori,Morena,Madhya Pradesh',
'Paragoun,Morena,Madhya Pradesh',
'Phoop,Morena,Madhya Pradesh',
'Pidora,Morena,Madhya Pradesh',
'Rama,Morena,Madhya Pradesh',
'Rani Birgoun,Morena,Madhya Pradesh',
'Sagra,Morena,Madhya Pradesh',
'Sakaraya,Morena,Madhya Pradesh',
'Sankari,Morena,Madhya Pradesh',
'Sapad,Morena,Madhya Pradesh',
'Sarsai,Morena,Madhya Pradesh',
'Sihunda,Morena,Madhya Pradesh',
'Simrao,Morena,Madhya Pradesh',
'Siyawali,Morena,Madhya Pradesh',
'Surpura,Morena,Madhya Pradesh',
'Tehangur,Morena,Madhya Pradesh',
'Udhotpura,Morena,Madhya Pradesh',
'Umri,Morena,Madhya Pradesh',
'Usha Nagar Colony Bhind,Morena,Madhya Pradesh',
'Mehgaon,Gwalior,Madhya Pradesh',
'Mehgaon,Gwalior,Madhya Pradesh',
'Aino,Morena,Madhya Pradesh',
'Bhagwasa,Morena,Madhya Pradesh',
'Birkhadi Dang,Morena,Madhya Pradesh',
'Chandokhar,Morena,Madhya Pradesh',
'Charetha,Morena,Madhya Pradesh',
'Chitora,Morena,Madhya Pradesh',
'Endori,Morena,Madhya Pradesh',
'Gohad Choraha,Morena,Madhya Pradesh',
'Gohad,Morena,Madhya Pradesh',
'Jhankri,Morena,Madhya Pradesh',
'Kathana Hazi,Morena,Madhya Pradesh',
'Khaneta,Morena,Madhya Pradesh',
'Khitoli,Morena,Madhya Pradesh',
'Malanpur,Morena,Madhya Pradesh',
'Pali Darman,Morena,Madhya Pradesh',
'Pipahadi,Morena,Madhya Pradesh',
'Piparsana,Morena,Madhya Pradesh',
'Raja Ki Pali,Morena,Madhya Pradesh',
'Sitaram Ki Lawan,Morena,Madhya Pradesh',
'Sondha,Morena,Madhya Pradesh',
'Suhsan,Morena,Madhya Pradesh',
'Ajnar,Morena,Madhya Pradesh',
'Akhdewa,Morena,Madhya Pradesh',
'Alampur,Morena,Madhya Pradesh',
'Andhiyari,Morena,Madhya Pradesh',
'Arusi,Morena,Madhya Pradesh',
'Aswar,Morena,Madhya Pradesh',
'Badokhari,Morena,Madhya Pradesh',
'Bahtpura,Morena,Madhya Pradesh',
'Baraua,Morena,Madhya Pradesh',
'Barha,Morena,Madhya Pradesh',
'Barthara,Morena,Madhya Pradesh',
'Bijpur,Morena,Madhya Pradesh',
'Chhiwaoli,Morena,Madhya Pradesh',
'Chiruli,Morena,Madhya Pradesh',
'Daboh,Morena,Madhya Pradesh',
'Dharampura,Morena,Madhya Pradesh',
'Gangepura,Morena,Madhya Pradesh',
'Girwasa,Morena,Madhya Pradesh',
'Heerapura,Morena,Madhya Pradesh',
'Jalalpura,Morena,Madhya Pradesh',
'Jamuha,Morena,Madhya Pradesh',
'Kurthar,Morena,Madhya Pradesh',
'Lahar,Morena,Madhya Pradesh',
'Lalpura,Morena,Madhya Pradesh',
'Mahua,Morena,Madhya Pradesh',
'Mehra Bujurg,Morena,Madhya Pradesh',
'Mihoni,Morena,Madhya Pradesh',
'Mitawali,Morena,Madhya Pradesh',
'Muraoli,Morena,Madhya Pradesh',
'Pariksha,Morena,Madhya Pradesh',
'Rahawali,Morena,Madhya Pradesh',
'Raipur Jakholi,Morena,Madhya Pradesh',
'Rohini Jagir,Morena,Madhya Pradesh',
'Rurai,Morena,Madhya Pradesh',
'Sundarpura,Morena,Madhya Pradesh',
'Tola,Morena,Madhya Pradesh',
'Amayan,Morena,Madhya Pradesh',
'Adokhar,Morena,Madhya Pradesh',
'Ajnodha,Morena,Madhya Pradesh',
'Akloni,Morena,Madhya Pradesh',
'Anto,Morena,Madhya Pradesh',
'Aroli,Morena,Madhya Pradesh',
'Baghora,Morena,Madhya Pradesh',
'Bahera,Morena,Madhya Pradesh',
'Bahonapura,Morena,Madhya Pradesh',
'Baranso,Morena,Madhya Pradesh',
'Barehad,Morena,Madhya Pradesh',
'Barehad,Morena,Madhya Pradesh',
'Baroli,Morena,Madhya Pradesh',
'Birgawan,Morena,Madhya Pradesh',
'Buderabhuta,Morena,Madhya Pradesh',
'Chhenkauri,Morena,Madhya Pradesh',
'Dehgoun,Morena,Madhya Pradesh',
'Gaheli,Morena,Madhya Pradesh',
'Ghamori,Morena,Madhya Pradesh',
'Gijurra,Morena,Madhya Pradesh',
'Gingarkhi,Morena,Madhya Pradesh',
'Girongi,Morena,Madhya Pradesh',
'Goar Khurd,Morena,Madhya Pradesh',
'Gona Kardaspur,Morena,Madhya Pradesh',
'Gormi,Morena,Madhya Pradesh',
'Guhsar,Morena,Madhya Pradesh',
'Gurikha,Morena,Madhya Pradesh',
'Gutor,Morena,Madhya Pradesh',
'Harikhsa,Morena,Madhya Pradesh',
'Ingosa Raipur,Morena,Madhya Pradesh',
'Jamdara,Morena,Madhya Pradesh',
'Jarsena,Morena,Madhya Pradesh',
'Jroi Brahman,Morena,Madhya Pradesh',
'Kachnao Kalan,Morena,Madhya Pradesh',
'Kanathar,Morena,Madhya Pradesh',
'Kanchanpura,Morena,Madhya Pradesh',
'Kathma,Morena,Madhya Pradesh',
'Katrol,Morena,Madhya Pradesh',
'Kheria Sindh,Morena,Madhya Pradesh',
'Kiti,Morena,Madhya Pradesh',
'Konhar,Morena,Madhya Pradesh',
'Kripe Ka Pura,Morena,Madhya Pradesh',
'Mau,Morena,Madhya Pradesh',
'Mehdoli,Morena,Madhya Pradesh',
'Mehgoun,Morena,Madhya Pradesh',
'Mehra,Morena,Madhya Pradesh',
'Menhad,Morena,Madhya Pradesh',
'Nanhad,Morena,Madhya Pradesh',
'Nonera,Morena,Madhya Pradesh',
'Pachera,Morena,Madhya Pradesh',
'Pali,Morena,Madhya Pradesh',
'Parghana,Morena,Madhya Pradesh',
'Parosa,Morena,Madhya Pradesh',
'Pawai,Morena,Madhya Pradesh',
'Pipadi,Morena,Madhya Pradesh',
'Raipura,Morena,Madhya Pradesh',
'Ramthiyankapura,Morena,Madhya Pradesh',
'Ratwa,Morena,Madhya Pradesh',
'Sada,Morena,Madhya Pradesh',
'Sarwa,Morena,Madhya Pradesh',
'Sayaana,Morena,Madhya Pradesh',
'Semara,Morena,Madhya Pradesh',
'Senthari,Morena,Madhya Pradesh',
'Sherpur,Morena,Madhya Pradesh',
'Sikroda,Morena,Madhya Pradesh',
'Simar,Morena,Madhya Pradesh',
'Soni,Morena,Madhya Pradesh',
'Sukand,Morena,Madhya Pradesh',
'Sunarpura,Morena,Madhya Pradesh',
'Tundila,Morena,Madhya Pradesh',
'Ujhaawl,Morena,Madhya Pradesh',
'Achalpura,Morena,Madhya Pradesh',
'Asnet,Morena,Madhya Pradesh',
'Bantharti,Morena,Madhya Pradesh',
'Barahet,Morena,Madhya Pradesh',
'Biswari,Morena,Madhya Pradesh',
'Bohara,Morena,Madhya Pradesh',
'Bonapura,Morena,Madhya Pradesh',
'Chandokh,Morena,Madhya Pradesh',
'Jaitpura Gudha,Morena,Madhya Pradesh',
'Katha,Morena,Madhya Pradesh',
'Lapwah,Morena,Madhya Pradesh',
'Larol,Morena,Madhya Pradesh',
'Machand,Morena,Madhya Pradesh',
'Mihona,Morena,Madhya Pradesh',
'Muratpura,Morena,Madhya Pradesh',
'Pachokhara,Morena,Madhya Pradesh',
'Raipura,Morena,Madhya Pradesh',
'Rari,Morena,Madhya Pradesh',
'Bahadurpura,Morena,Madhya Pradesh',
'Birkhadi Chochai,Morena,Madhya Pradesh',
'Gorai,Morena,Madhya Pradesh',
'Indurkhi,Morena,Madhya Pradesh',
'Jaipura Madhi,Morena,Madhya Pradesh',
'Mangarh,Morena,Madhya Pradesh',
'Mehda,Morena,Madhya Pradesh',
'Mehdwa,Morena,Madhya Pradesh',
'Nadna,Morena,Madhya Pradesh',
'Nandha,Morena,Madhya Pradesh',
'Nibsai,Morena,Madhya Pradesh',
'Padhora,Morena,Madhya Pradesh',
'Rarua,Morena,Madhya Pradesh',
'Raun,Morena,Madhya Pradesh',
'1100 Qrts.,Bhopal,Madhya Pradesh',
'3 Eme Center,Bhopal,Madhya Pradesh',
'Air Port,Bhopal,Madhya Pradesh',
'Amarawat Kalan,Bhopal,Madhya Pradesh',
'Anand Nagar,Bhopal,Madhya Pradesh',
'Arera Hills,Bhopal,Madhya Pradesh',
'Arwaliya,Bhopal,Madhya Pradesh',
'Ayodhaya Nagar,Bhopal,Madhya Pradesh',
'Bag Mungalia,Bhopal,Madhya Pradesh',
'Bagroda,Bhopal,Madhya Pradesh',
'Bairagarh Chichali,Bhopal,Madhya Pradesh',
'Bairagarh Kalan,Bhopal,Madhya Pradesh',
'Bairagarh,Bhopal,Madhya Pradesh',
'Balachoan,Bhopal,Madhya Pradesh',
'Balampur,Bhopal,Madhya Pradesh',
'Bangrasia,Bhopal,Madhya Pradesh',
'Barkheda Baramad,Bhopal,Madhya Pradesh',
'Barkheda H.E.,Bhopal,Madhya Pradesh',
'Barkheda Nathu,Bhopal,Madhya Pradesh',
'Barkhedi,Bhopal,Madhya Pradesh',
'Basai,Bhopal,Madhya Pradesh',
'Bawachiya,Bhopal,Madhya Pradesh',
'Bawadia Kalan,Bhopal,Madhya Pradesh',
'Bazaria Shahajahanabad,Bhopal,Madhya Pradesh',
'Berasia Bhopal,Bhopal,Madhya Pradesh',
'Berasia Road,Bhopal,Madhya Pradesh',
'Bhel H.O,Bhopal,Madhya Pradesh',
'Bhonri,Bhopal,Madhya Pradesh',
'Bhopal G.P.O.,Bhopal,Madhya Pradesh',
'Bhopal University,Bhopal,Madhya Pradesh',
'Bilakho,Bhopal,Madhya Pradesh',
'C.T.T.Nagar H.O,Bhopal,Madhya Pradesh',
'Chandbad,Bhopal,Madhya Pradesh',
'Chhola Road,Bhopal,Madhya Pradesh',
'Chouk,Bhopal,Madhya Pradesh',
'Dak Bhawan,Bhopal,Madhya Pradesh',
'Dhamarra,Bhopal,Madhya Pradesh',
'Dhaturiya,Bhopal,Madhya Pradesh',
'Dillod,Bhopal,Madhya Pradesh',
'Dungariya,Bhopal,Madhya Pradesh',
'Durga Chouk,Bhopal,Madhya Pradesh',
'E-2 Sector,Bhopal,Madhya Pradesh',
'Fanda,Bhopal,Madhya Pradesh',
'Gada Jangeer,Bhopal,Madhya Pradesh',
'Gandhi Medical College,Bhopal,Madhya Pradesh',
'Gandhi Nagar,Bhopal,Madhya Pradesh',
'Govindpura,Bhopal,Madhya Pradesh',
'Gunga,Bhopal,Madhya Pradesh',
'H.E. Hospital,Bhopal,Madhya Pradesh',
'Hamidia Road,Bhopal,Madhya Pradesh',
'Harra Kheda,Bhopal,Madhya Pradesh',
'Imaliya,Bhopal,Madhya Pradesh',
'Industrial Estate,Bhopal,Madhya Pradesh',
'Islam Nagar,Bhopal,Madhya Pradesh',
'Itwara,Bhopal,Madhya Pradesh',
'Jahangirabad,Bhopal,Madhya Pradesh',
'Jamunia Kalan,Bhopal,Madhya Pradesh',
'Jamusarkalan,Bhopal,Madhya Pradesh',
'Jhagaria Khurd,Bhopal,Madhya Pradesh',
'Jumerati,Bhopal,Madhya Pradesh',
'Kalara,Bhopal,Madhya Pradesh',
'Kamla Nagar,Bhopal,Madhya Pradesh',
'Kamla Park,Bhopal,Madhya Pradesh',
'Khajuri Kalan,Bhopal,Madhya Pradesh',
'Khajuri Sadak,Bhopal,Madhya Pradesh',
'Khamkheda,Bhopal,Madhya Pradesh',
'Khitwas,Bhopal,Madhya Pradesh',
'Khukharia,Bhopal,Madhya Pradesh',
'Kokata,Bhopal,Madhya Pradesh',
'Kolar Road,Bhopal,Madhya Pradesh',
'Kolua Khurd,Bhopal,Madhya Pradesh',
'Kolukhedi,Bhopal,Madhya Pradesh',
'Kotra Chopra,Bhopal,Madhya Pradesh',
'Kulhoar,Bhopal,Madhya Pradesh',
'Kurana,Bhopal,Madhya Pradesh',
'Kutakipura,Bhopal,Madhya Pradesh',
'Kuthar,Bhopal,Madhya Pradesh',
'Lalariya,Bhopal,Madhya Pradesh',
'Laloi,Bhopal,Madhya Pradesh',
'M.A.C.T.,Bhopal,Madhya Pradesh',
'M.L. Nagar,Bhopal,Madhya Pradesh',
'M.L.A.Rest House,Bhopal,Madhya Pradesh',
'M.P. Vidhan Sabha,Bhopal,Madhya Pradesh',
'Mahaveer Nagar,Bhopal,Madhya Pradesh',
'Mangal Garh,Bhopal,Madhya Pradesh',
'Meghra Kalan,Bhopal,Madhya Pradesh',
'Misrod,Bhopal,Madhya Pradesh',
'Mungalia Chhap,Bhopal,Madhya Pradesh',
'Mungaliya Hatt,Bhopal,Madhya Pradesh',
'Nabibagh,Bhopal,Madhya Pradesh',
'Naya Samund,Bhopal,Madhya Pradesh',
'Nayapura,Bhopal,Madhya Pradesh',
'Nazirabad,Bhopal,Madhya Pradesh',
'Nishatpura,Bhopal,Madhya Pradesh',
'North T.T.Nagar,Bhopal,Madhya Pradesh',
'Old Secretriate,Bhopal,Madhya Pradesh',
'Parwaliya Sadak,Bhopal,Madhya Pradesh',
'Pipal Khedi,Bhopal,Madhya Pradesh',
'Pipaliya Jaheerpeer,Bhopal,Madhya Pradesh',
'Piplani,Bhopal,Madhya Pradesh',
'R.S.Market,Bhopal,Madhya Pradesh',
'R.S.Nagar,Bhopal,Madhya Pradesh',
'Raipur,Bhopal,Madhya Pradesh',
'Raj Bhawan,Bhopal,Madhya Pradesh',
'Ratibad,Bhopal,Madhya Pradesh',
'Ratua Ratanpur,Bhopal,Madhya Pradesh',
'Regional College,Bhopal,Madhya Pradesh',
'Runaha,Bhopal,Madhya Pradesh',
'S.I. Line,Bhopal,Madhya Pradesh',
'Satpura,Bhopal,Madhya Pradesh',
'Sewaniya Gond,Bhopal,Madhya Pradesh',
'Shahajahanabad,Bhopal,Madhya Pradesh',
'Shastri Nagar,Bhopal,Madhya Pradesh',
'Shiksha Mandal,Bhopal,Madhya Pradesh',
'Shivaji Nagar,Bhopal,Madhya Pradesh',
'Sikandri Sarai,Bhopal,Madhya Pradesh',
'Sindhora,Bhopal,Madhya Pradesh',
'Sohaya,Bhopal,Madhya Pradesh',
'Sonkachh,Bhopal,Madhya Pradesh',
'South T.T. Nagar,Bhopal,Madhya Pradesh',
'Subhash Nagar,Bhopal,Madhya Pradesh',
'Sukaliya,Bhopal,Madhya Pradesh',
'Sukhi Sewania,Bhopal,Madhya Pradesh',
'Suraj Nagar,Bhopal,Madhya Pradesh',
'Tara Sewaniya,Bhopal,Madhya Pradesh',
'Tarawali Kalan,Bhopal,Madhya Pradesh',
'Tila Khedi,Bhopal,Madhya Pradesh',
'Trilanga,Bhopal,Madhya Pradesh',
'Tulsi Nagar,Bhopal,Madhya Pradesh',
'Tumada,Bhopal,Madhya Pradesh',
'University,Bhopal,Madhya Pradesh',
'Vallabh Bhawan,Bhopal,Madhya Pradesh',
'Vidya Vihar,Bhopal,Madhya Pradesh',
'Shahbazar Burhanpur,Khandwa,Madhya Pradesh',
'Bahadarpur,Khandwa,Madhya Pradesh',
'Bambhada,Khandwa,Madhya Pradesh',
'Bhawasa,Khandwa,Madhya Pradesh',
'Biroda,Khandwa,Madhya Pradesh',
'Bodarli,Khandwa,Madhya Pradesh',
'Bori Bujurg,Khandwa,Madhya Pradesh',
'Borsar,Khandwa,Madhya Pradesh',
'Burhanpur City,Khandwa,Madhya Pradesh',
'Burhanpur R.S.,Khandwa,Madhya Pradesh',
'Burhanpur Rajpura,Khandwa,Madhya Pradesh',
'Burhanpur,Khandwa,Madhya Pradesh',
'Chapora,Khandwa,Madhya Pradesh',
'Dapora,Khandwa,Madhya Pradesh',
'Dargah-e-hakimi,Khandwa,Madhya Pradesh',
'Daryapur,Khandwa,Madhya Pradesh',
'Dhamangaon,Khandwa,Madhya Pradesh',
'Dhulkot,Khandwa,Madhya Pradesh',
'Hasinabad,Khandwa,Madhya Pradesh',
'Ichhapur,Khandwa,Madhya Pradesh',
'Jainabad,Khandwa,Madhya Pradesh',
'Jasondi,Khandwa,Madhya Pradesh',
'Khamni,Khandwa,Madhya Pradesh',
'Loni,Khandwa,Madhya Pradesh',
'Mohad,Khandwa,Madhya Pradesh',
'Nachankheda,Khandwa,Madhya Pradesh',
'Nimbola,Khandwa,Madhya Pradesh',
'Patonda,Khandwa,Madhya Pradesh',
'Phophanar,Khandwa,Madhya Pradesh',
'Sangrampur,Khandwa,Madhya Pradesh',
'Shahpur,Khandwa,Madhya Pradesh',
'Turakgurada,Khandwa,Madhya Pradesh',
'Dedtalai,Khandwa,Madhya Pradesh',
'Doifodia,Khandwa,Madhya Pradesh',
'Gulai,Khandwa,Madhya Pradesh',
'Khaknar,Khandwa,Madhya Pradesh',
'Manjrodkala,Khandwa,Madhya Pradesh',
'Nagjhiri,Khandwa,Madhya Pradesh',
'Paretha,Khandwa,Madhya Pradesh',
'Pipalpani,Khandwa,Madhya Pradesh',
'Raitalai,Khandwa,Madhya Pradesh',
'Sheikhpur,Khandwa,Madhya Pradesh',
'Sheikhpura,Khandwa,Madhya Pradesh',
'Sirpur,Khandwa,Madhya Pradesh',
'Tukaithad,Khandwa,Madhya Pradesh',
'Ambada,Khandwa,Madhya Pradesh',
'Amulla,Khandwa,Madhya Pradesh',
'Asirgarh,Khandwa,Madhya Pradesh',
'Basad,Khandwa,Madhya Pradesh',
'Bhatkheda,Khandwa,Madhya Pradesh',
'Chandani,Khandwa,Madhya Pradesh',
'Dabhiyakheda,Khandwa,Madhya Pradesh',
'Ghagharla,Khandwa,Madhya Pradesh',
'Haidarpur,Khandwa,Madhya Pradesh',
'Khatla,Khandwa,Madhya Pradesh',
'Mahalgurada,Khandwa,Madhya Pradesh',
'Nawara,Khandwa,Madhya Pradesh',
'Nepanagar,Khandwa,Madhya Pradesh',
'Palasur,Khandwa,Madhya Pradesh',
'Sarola,Khandwa,Madhya Pradesh',
'Siwal,Khandwa,Madhya Pradesh',
'Madeora,Chhatarpur,Madhya Pradesh',
'Nenagiri,Chhatarpur,Madhya Pradesh',
'Newar,Chhatarpur,Madhya Pradesh',
'Pondi,Chhatarpur,Madhya Pradesh',
'Saidara,Chhatarpur,Madhya Pradesh',
'Sunwaha,Chhatarpur,Madhya Pradesh',
'Deori,Chhatarpur,Madhya Pradesh',
'Garhi Samri,Chhatarpur,Madhya Pradesh',
'Deopur,Chhatarpur,Madhya Pradesh',
'Amronia,Chhatarpur,Madhya Pradesh',
'Badagaon,Chhatarpur,Madhya Pradesh',
'Deora,Chhatarpur,Madhya Pradesh',
'Dharampura,Chhatarpur,Madhya Pradesh',
'Hatawaha,Chhatarpur,Madhya Pradesh',
'Jatashankar,Chhatarpur,Madhya Pradesh',
'Jetpur,Chhatarpur,Madhya Pradesh',
'Khariyani,Chhatarpur,Madhya Pradesh',
'Kherakla,Chhatarpur,Madhya Pradesh',
'Kishangarh,Chhatarpur,Madhya Pradesh',
'Kupishahpur,Chhatarpur,Madhya Pradesh',
'Nayatal,Chhatarpur,Madhya Pradesh',
'Panagar,Chhatarpur,Madhya Pradesh',
'Pipat,Chhatarpur,Madhya Pradesh',
'Ranital,Chhatarpur,Madhya Pradesh',
'Shahgarh,Chhatarpur,Madhya Pradesh',
'Sunwani,Chhatarpur,Madhya Pradesh',
'Surajpurkala,Chhatarpur,Madhya Pradesh',
'Bagouta,Chhatarpur,Madhya Pradesh',
'Bamitha,Chhatarpur,Madhya Pradesh',
'Bandani,Chhatarpur,Madhya Pradesh',
'Bandhikala,Chhatarpur,Madhya Pradesh',
'Bara,Chhatarpur,Madhya Pradesh',
'Bari,Chhatarpur,Madhya Pradesh',
'Basari,Chhatarpur,Madhya Pradesh',
'Bhera,Chhatarpur,Madhya Pradesh',
'Bijawar,Chhatarpur,Madhya Pradesh',
'Budrakh,Chhatarpur,Madhya Pradesh',
'Chandra Nagar,Chhatarpur,Madhya Pradesh',
'Chhatarpur CB,Chhatarpur,Madhya Pradesh',
'Chhatarpur City,Chhatarpur,Madhya Pradesh',
'Chhatarpur Coll.,Chhatarpur,Madhya Pradesh',
'Chhatarpur H.O,Chhatarpur,Madhya Pradesh',
'Darguwan,Chhatarpur,Madhya Pradesh',
'Deri,Chhatarpur,Madhya Pradesh',
'Dhadari,Chhatarpur,Madhya Pradesh',
'Dhamna,Chhatarpur,Madhya Pradesh',
'Dumra,Chhatarpur,Madhya Pradesh',
'Gaharwar,Chhatarpur,Madhya Pradesh',
'Ganj,Chhatarpur,Madhya Pradesh',
'Gatheora,Chhatarpur,Madhya Pradesh',
'Ghoora,Chhatarpur,Madhya Pradesh',
'Himmatpura,Chhatarpur,Madhya Pradesh',
'Imlaha,Chhatarpur,Madhya Pradesh',
'Isanagar,Chhatarpur,Madhya Pradesh',
'Jamtuli,Chhatarpur,Madhya Pradesh',
'Kalani,Chhatarpur,Madhya Pradesh',
'Karri,Chhatarpur,Madhya Pradesh',
'Kharrohi,Chhatarpur,Madhya Pradesh',
'Kheri,Chhatarpur,Madhya Pradesh',
'Kurraha,Chhatarpur,Madhya Pradesh',
'Lakhanguwa,Chhatarpur,Madhya Pradesh',
'Maharajpur,Chhatarpur,Madhya Pradesh',
'Maniya,Chhatarpur,Madhya Pradesh',
'Mankari,Chhatarpur,Madhya Pradesh',
'Naguwan,Chhatarpur,Madhya Pradesh',
'Nandgain Kal,Chhatarpur,Madhya Pradesh',
'Nandginbattan,Chhatarpur,Madhya Pradesh',
'Nathpur,Chhatarpur,Madhya Pradesh',
'Niwari,Chhatarpur,Madhya Pradesh',
'Nuna,Chhatarpur,Madhya Pradesh',
'Otapurwa,Chhatarpur,Madhya Pradesh',
'Padariya,Chhatarpur,Madhya Pradesh',
'Pahadgaon,Chhatarpur,Madhya Pradesh',
'Pahara,Chhatarpur,Madhya Pradesh',
'Panotha,Chhatarpur,Madhya Pradesh',
'Ragoli,Chhatarpur,Madhya Pradesh',
'Rangawana,Chhatarpur,Madhya Pradesh',
'Salaiya,Chhatarpur,Madhya Pradesh',
'Salaiya,Chhatarpur,Madhya Pradesh',
'Satai,Chhatarpur,Madhya Pradesh',
'Saura,Chhatarpur,Madhya Pradesh',
'Selon,Chhatarpur,Madhya Pradesh',
'Seondi,Chhatarpur,Madhya Pradesh',
'Sighpur,Chhatarpur,Madhya Pradesh',
'Tatam,Chhatarpur,Madhya Pradesh',
'Tila,Chhatarpur,Madhya Pradesh',
'Ujara,Chhatarpur,Madhya Pradesh',
'Urdmau,Chhatarpur,Madhya Pradesh',
'Thakurra,Chhatarpur,Madhya Pradesh',
'Abhau,Chhatarpur,Madhya Pradesh',
'Achatta,Chhatarpur,Madhya Pradesh',
'Aktonha,Chhatarpur,Madhya Pradesh',
'Bachhon,Chhatarpur,Madhya Pradesh',
'Badora Kala,Chhatarpur,Madhya Pradesh',
'Bagmau,Chhatarpur,Madhya Pradesh',
'Bakola,Chhatarpur,Madhya Pradesh',
'Balkora,Chhatarpur,Madhya Pradesh',
'Bamhori Pura,Chhatarpur,Madhya Pradesh',
'Banjari,Chhatarpur,Madhya Pradesh',
'Bansiya,Chhatarpur,Madhya Pradesh',
'Baraha,Chhatarpur,Madhya Pradesh',
'Behata,Chhatarpur,Madhya Pradesh',
'Belahari,Chhatarpur,Madhya Pradesh',
'Bhawanipur,Chhatarpur,Madhya Pradesh',
'Chandla,Chhatarpur,Madhya Pradesh',
'Chandowara,Chhatarpur,Madhya Pradesh',
'Chandpura,Chhatarpur,Madhya Pradesh',
'Chhati Bamhori,Chhatarpur,Madhya Pradesh',
'Chitehari,Chhatarpur,Madhya Pradesh',
'Churiyari,Chhatarpur,Madhya Pradesh',
'Didwara,Chhatarpur,Madhya Pradesh',
'Gahwara,Chhatarpur,Madhya Pradesh',
'Ghoorchitehri,Chhatarpur,Madhya Pradesh',
'Gohani,Chhatarpur,Madhya Pradesh',
'Gorihar,Chhatarpur,Madhya Pradesh',
'Goyara,Chhatarpur,Madhya Pradesh',
'Gudhora,Chhatarpur,Madhya Pradesh',
'Gurhakala,Chhatarpur,Madhya Pradesh',
'Hanukhera,Chhatarpur,Madhya Pradesh',
'Hathohan,Chhatarpur,Madhya Pradesh',
'Hinota,Chhatarpur,Madhya Pradesh',
'Jeoraha,Chhatarpur,Madhya Pradesh',
'Jujhar Nagar,Chhatarpur,Madhya Pradesh',
'Katia,Chhatarpur,Madhya Pradesh',
'Kethara,Chhatarpur,Madhya Pradesh',
'Khaddi,Chhatarpur,Madhya Pradesh',
'Khadeha,Chhatarpur,Madhya Pradesh',
'Khandela,Chhatarpur,Madhya Pradesh',
'Kherakasar,Chhatarpur,Madhya Pradesh',
'Kotheha,Chhatarpur,Madhya Pradesh',
'Laundi,Chhatarpur,Madhya Pradesh',
'Mahyawa,Chhatarpur,Madhya Pradesh',
'Manuriya,Chhatarpur,Madhya Pradesh',
'Mudahara,Chhatarpur,Madhya Pradesh',
'Muderi,Chhatarpur,Madhya Pradesh',
'Naharpur,Chhatarpur,Madhya Pradesh',
'Pahara,Chhatarpur,Madhya Pradesh',
'Pancham Pura,Chhatarpur,Madhya Pradesh',
'Patha,Chhatarpur,Madhya Pradesh',
'Persania,Chhatarpur,Madhya Pradesh',
'Prakashabami,Chhatarpur,Madhya Pradesh',
'Ragoli,Chhatarpur,Madhya Pradesh',
'Ramjhala,Chhatarpur,Madhya Pradesh',
'Rampur,Chhatarpur,Madhya Pradesh',
'Sarwai,Chhatarpur,Madhya Pradesh',
'Sijai,Chhatarpur,Madhya Pradesh',
'Singhpur,Chhatarpur,Madhya Pradesh',
'Tehanga,Chhatarpur,Madhya Pradesh',
'Bamhori,Chhatarpur,Madhya Pradesh',
'Angore,Chhatarpur,Madhya Pradesh',
'Atrar,Chhatarpur,Madhya Pradesh',
'Bajna,Chhatarpur,Madhya Pradesh',
'Bamni,Chhatarpur,Madhya Pradesh',
'Bamnora,Chhatarpur,Madhya Pradesh',
'Bandha,Chhatarpur,Madhya Pradesh',
'Bardwha,Chhatarpur,Madhya Pradesh',
'Barethi,Chhatarpur,Madhya Pradesh',
'Bhagwan,Chhatarpur,Madhya Pradesh',
'Budore,Chhatarpur,Madhya Pradesh',
'Budore,Chhatarpur,Madhya Pradesh',
'Buxwaha,Chhatarpur,Madhya Pradesh',
'Chauka,Chhatarpur,Madhya Pradesh',
'Dargawan,Chhatarpur,Madhya Pradesh',
'Deoran,Chhatarpur,Madhya Pradesh',
'Dhangawan,Chhatarpur,Madhya Pradesh',
'Dhimarwara,Chhatarpur,Madhya Pradesh',
'Dikoli,Chhatarpur,Madhya Pradesh',
'Gorakh Pura,Chhatarpur,Madhya Pradesh',
'Kayan,Chhatarpur,Madhya Pradesh',
'Kharduti,Chhatarpur,Madhya Pradesh',
'Kheron,Chhatarpur,Madhya Pradesh',
'Kutora,Chhatarpur,Madhya Pradesh',
'Maharajganj,Chhatarpur,Madhya Pradesh',
'Malehara,Chhatarpur,Madhya Pradesh',
'Matgawan,Chhatarpur,Madhya Pradesh',
'Melwar,Chhatarpur,Madhya Pradesh',
'Panwari,Chhatarpur,Madhya Pradesh',
'Ramtoriya,Chhatarpur,Madhya Pradesh',
'Sadawa,Chhatarpur,Madhya Pradesh',
'Sarkana,Chhatarpur,Madhya Pradesh',
'Semariya,Chhatarpur,Madhya Pradesh',
'Sendpa,Chhatarpur,Madhya Pradesh',
'Sewar,Chhatarpur,Madhya Pradesh',
'Ghaura,Chhatarpur,Madhya Pradesh',
'Gulganj,Chhatarpur,Madhya Pradesh',
'Alipura,Chhatarpur,Madhya Pradesh',
'Badagaon,Chhatarpur,Madhya Pradesh',
'Banchhora,Chhatarpur,Madhya Pradesh',
'Bangain,Chhatarpur,Madhya Pradesh',
'Barkiratpura,Chhatarpur,Madhya Pradesh',
'Bilahri,Chhatarpur,Madhya Pradesh',
'Chouwari,Chhatarpur,Madhya Pradesh',
'Dhamora,Chhatarpur,Madhya Pradesh',
'Doni (P),Chhatarpur,Madhya Pradesh',
'Doriya,Chhatarpur,Madhya Pradesh',
'Gadimalehara,Chhatarpur,Madhya Pradesh',
'Galan,Chhatarpur,Madhya Pradesh',
'Garroli,Chhatarpur,Madhya Pradesh',
'Harpalpur,Chhatarpur,Madhya Pradesh',
'Imaliya,Chhatarpur,Madhya Pradesh',
'Jhinijhan,Chhatarpur,Madhya Pradesh',
'Kararaganj,Chhatarpur,Madhya Pradesh',
'Kenthokar,Chhatarpur,Madhya Pradesh',
'Lugasi,Chhatarpur,Madhya Pradesh',
'Maheba,Chhatarpur,Madhya Pradesh',
'Mau Sahnia,Chhatarpur,Madhya Pradesh',
'Nowgong,Chhatarpur,Madhya Pradesh',
'Rampur,Chhatarpur,Madhya Pradesh',
'Sarsed,Chhatarpur,Madhya Pradesh',
'Sukwan,Chhatarpur,Madhya Pradesh',
'Tidani,Chhatarpur,Madhya Pradesh',
'Paharapurwa,Chhatarpur,Madhya Pradesh',
'Tikuri,Chhatarpur,Madhya Pradesh',
'Beniganj,Chhatarpur,Madhya Pradesh',
'Bikarampur,Chhatarpur,Madhya Pradesh',
'Daharra,Chhatarpur,Madhya Pradesh',
'Dhawad,Chhatarpur,Madhya Pradesh',
'Khajuraho,Chhatarpur,Madhya Pradesh',
'Khajuwa,Chhatarpur,Madhya Pradesh',
'Kurala,Chhatarpur,Madhya Pradesh',
'Lakheri,Chhatarpur,Madhya Pradesh',
'Lalpura,Chhatarpur,Madhya Pradesh',
'Nandeora,Chhatarpur,Madhya Pradesh',
'Rajnager,Chhatarpur,Madhya Pradesh',
'Udaipura,Chhatarpur,Madhya Pradesh',
'Willa,Chhatarpur,Madhya Pradesh',
'Chicholi Vad,Chhindwara,Madhya Pradesh',
'Barahira,Chhindwara,Madhya Pradesh',
'Richheda,Chhindwara,Madhya Pradesh',
'Amarwara,Chhindwara,Madhya Pradesh',
'Badegaon,Chhindwara,Madhya Pradesh',
'Bangaon,Chhindwara,Madhya Pradesh',
'Banka Mukasa,Chhindwara,Madhya Pradesh',
'Bhula Mohgaon,Chhindwara,Madhya Pradesh',
'Chania Kalan,Chhindwara,Madhya Pradesh',
'Chhui,Chhindwara,Madhya Pradesh',
'Dhadhra,Chhindwara,Madhya Pradesh',
'Dhasanwara,Chhindwara,Madhya Pradesh',
'Ghoghari,Chhindwara,Madhya Pradesh',
'Hiwarkhedi,Chhindwara,Madhya Pradesh',
'Jamuniya,Chhindwara,Madhya Pradesh',
'Jhirlinga,Chhindwara,Madhya Pradesh',
'Jungawani,Chhindwara,Madhya Pradesh',
'Keolari,Chhindwara,Madhya Pradesh',
'Koparwari,Chhindwara,Madhya Pradesh',
'Kudwari,Chhindwara,Madhya Pradesh',
'Manegaon,Chhindwara,Madhya Pradesh',
'Markawara,Chhindwara,Madhya Pradesh',
'Meghaseoni,Chhindwara,Madhya Pradesh',
'Petdeori,Chhindwara,Madhya Pradesh',
'Pipariya Rajguru,Chhindwara,Madhya Pradesh',
'Pounar,Chhindwara,Madhya Pradesh',
'Saliwara Sharda,Chhindwara,Madhya Pradesh',
'Sarna,Chhindwara,Madhya Pradesh',
'Seja,Chhindwara,Madhya Pradesh',
'Sihoramal,Chhindwara,Madhya Pradesh',
'Singodi,Chhindwara,Madhya Pradesh',
'Sonpur,Chhindwara,Madhya Pradesh',
'Tendani,Chhindwara,Madhya Pradesh',
'Bichhua,Chhindwara,Madhya Pradesh',
'Deori,Chhindwara,Madhya Pradesh',
'Dhanegaon,Chhindwara,Madhya Pradesh',
'Ghorad,Chhindwara,Madhya Pradesh',
'Kadaiya,Chhindwara,Madhya Pradesh',
'Khamarpani,Chhindwara,Madhya Pradesh',
'Khamra,Chhindwara,Madhya Pradesh',
'Moya,Chhindwara,Madhya Pradesh',
'Munganapar,Chhindwara,Madhya Pradesh',
'Pathari,Chhindwara,Madhya Pradesh',
'Tumragarhi,Chhindwara,Madhya Pradesh',
'Barkuhi,Chhindwara,Madhya Pradesh',
'Umaranala,Chhindwara,Madhya Pradesh',
'Bhutai,Chhindwara,Madhya Pradesh',
'Kamthi,Chhindwara,Madhya Pradesh',
'Mothar,Chhindwara,Madhya Pradesh',
'Ambamali,Chhindwara,Madhya Pradesh',
'Anjangaon,Chhindwara,Madhya Pradesh',
'Badnoor,Chhindwara,Madhya Pradesh',
'Bankanaganpur,Chhindwara,Madhya Pradesh',
'Bisapur,Chhindwara,Madhya Pradesh',
'Bohnakheri,Chhindwara,Madhya Pradesh',
'Boria,Chhindwara,Madhya Pradesh',
'Chandangaon,Chhindwara,Madhya Pradesh',
'Chhindwara City,Chhindwara,Madhya Pradesh',
'Chhindwara H.O,Chhindwara,Madhya Pradesh',
'Chikhalikalan,Chhindwara,Madhya Pradesh',
'Chitanvisganj,Chhindwara,Madhya Pradesh',
'Gangiwara,Chhindwara,Madhya Pradesh',
'Gualbra Chhindwara,Chhindwara,Madhya Pradesh',
'Gurriya,Chhindwara,Madhya Pradesh',
'Imlikheda,Chhindwara,Madhya Pradesh',
'Jam,Chhindwara,Madhya Pradesh',
'Jhilmili,Chhindwara,Madhya Pradesh',
'Kanhargaon,Chhindwara,Madhya Pradesh',
'Karaghat Kamthi,Chhindwara,Madhya Pradesh',
'Kaudia,Chhindwara,Madhya Pradesh',
'Khazari,Chhindwara,Madhya Pradesh',
'Kohat,Chhindwara,Madhya Pradesh',
'Kundalikalan,Chhindwara,Madhya Pradesh',
'Lalbagh Chhindwara,Chhindwara,Madhya Pradesh',
'Lawaghoghari,Chhindwara,Madhya Pradesh',
'Linga,Chhindwara,Madhya Pradesh',
'Lohangi Raiyat,Chhindwara,Madhya Pradesh',
'Machagora,Chhindwara,Madhya Pradesh',
'Mahalpur,Chhindwara,Madhya Pradesh',
'Mainikhapa,Chhindwara,Madhya Pradesh',
'Markahandi,Chhindwara,Madhya Pradesh',
'Mau,Chhindwara,Madhya Pradesh',
'Mohkhed,Chhindwara,Madhya Pradesh',
'Mordongari,Chhindwara,Madhya Pradesh',
'Mujawar,Chhindwara,Madhya Pradesh',
'Nonia Karbal,Chhindwara,Madhya Pradesh',
'Paladone,Chhindwara,Madhya Pradesh',
'Palakhed,Chhindwara,Madhya Pradesh',
'Parasgaon,Chhindwara,Madhya Pradesh',
'Paunar,Chhindwara,Madhya Pradesh',
'Pindraikalan,Chhindwara,Madhya Pradesh',
'Pradhan Ghoghari,Chhindwara,Madhya Pradesh',
'Rajada,Chhindwara,Madhya Pradesh',
'Rajegaon,Chhindwara,Madhya Pradesh',
'Rohna,Chhindwara,Madhya Pradesh',
'Saori Bazaar,Chhindwara,Madhya Pradesh',
'Sarangbihiri,Chhindwara,Madhya Pradesh',
'Sonakhar,Chhindwara,Madhya Pradesh',
'TB Senetorium,Chhindwara,Madhya Pradesh',
'Turkikhapa,Chhindwara,Madhya Pradesh',
'Ubhegaon,Chhindwara,Madhya Pradesh',
'Umaria Isra,Chhindwara,Madhya Pradesh',
'Mankadehi,Chhindwara,Madhya Pradesh',
'Samaswara,Chhindwara,Madhya Pradesh',
'Badgaon,Chhindwara,Madhya Pradesh',
'Bamhanwara,Chhindwara,Madhya Pradesh',
'Banskheda,Chhindwara,Madhya Pradesh',
'Chand,Chhindwara,Madhya Pradesh',
'Chourai,Chhindwara,Madhya Pradesh',
'Dilawar Mohgaon,Chhindwara,Madhya Pradesh',
'Gopalpur,Chhindwara,Madhya Pradesh',
'Gumgaon,Chhindwara,Madhya Pradesh',
'Harnakhedi,Chhindwara,Madhya Pradesh',
'Kapurdha,Chhindwara,Madhya Pradesh',
'Khireti,Chhindwara,Madhya Pradesh',
'Khuntpipariya,Chhindwara,Madhya Pradesh',
'Kuhiya,Chhindwara,Madhya Pradesh',
'Kunda,Chhindwara,Madhya Pradesh',
'Meghdone,Chhindwara,Madhya Pradesh',
'Panjara,Chhindwara,Madhya Pradesh',
'Parsoli,Chhindwara,Madhya Pradesh',
'Pipariya Mansingh,Chhindwara,Madhya Pradesh',
'Ramgarh,Chhindwara,Madhya Pradesh',
'Sankh,Chhindwara,Madhya Pradesh',
'Siregaon,Chhindwara,Madhya Pradesh',
'Sitajhir,Chhindwara,Madhya Pradesh',
'Top,Chhindwara,Madhya Pradesh',
'Umrad,Chhindwara,Madhya Pradesh',
'Badela,Chhindwara,Madhya Pradesh',
'Binjhawara,Chhindwara,Madhya Pradesh',
'Nandan,Chhindwara,Madhya Pradesh',
'Badsaliya,Chhindwara,Madhya Pradesh',
'Banka,Chhindwara,Madhya Pradesh',
'Bargi,Chhindwara,Madhya Pradesh',
'Basuriya,Chhindwara,Madhya Pradesh',
'Batkakhapa,Chhindwara,Madhya Pradesh',
'Bheda,Chhindwara,Madhya Pradesh',
'Bhumka,Chhindwara,Madhya Pradesh',
'Dhanora Jagir,Chhindwara,Madhya Pradesh',
'Gourpani,Chhindwara,Madhya Pradesh',
'Harrai,Chhindwara,Madhya Pradesh',
'Madai,Chhindwara,Madhya Pradesh',
'Partapur,Chhindwara,Madhya Pradesh',
'Ratamati,Chhindwara,Madhya Pradesh',
'Surlakhapa,Chhindwara,Madhya Pradesh',
'Ghorawari Khurd,Chhindwara,Madhya Pradesh',
'Ambada,Chhindwara,Madhya Pradesh',
'Ankhiya,Chhindwara,Madhya Pradesh',
'Bamanwara,Chhindwara,Madhya Pradesh',
'Bhajipani,Chhindwara,Madhya Pradesh',
'Bhamodi,Chhindwara,Madhya Pradesh',
'Bhatodia Khurd,Chhindwara,Madhya Pradesh',
'Chikalmau,Chhindwara,Madhya Pradesh',
'Damua,Chhindwara,Madhya Pradesh',
'Darbai,Chhindwara,Madhya Pradesh',
'Datla,Chhindwara,Madhya Pradesh',
'Dungaria,Chhindwara,Madhya Pradesh',
'Dungariabhardagarh,Chhindwara,Madhya Pradesh',
'Eklehra,Chhindwara,Madhya Pradesh',
'Ghorawari Kalan,Chhindwara,Madhya Pradesh',
'Hanotiya,Chhindwara,Madhya Pradesh',
'Hirdagarh,Chhindwara,Madhya Pradesh',
'Jamkunda,Chhindwara,Madhya Pradesh',
'Jatachhapar,Chhindwara,Madhya Pradesh',
'Junnardeo,Chhindwara,Madhya Pradesh',
'Navegaon,Chhindwara,Madhya Pradesh',
'Palachourai,Chhindwara,Madhya Pradesh',
'Rakhikol,Chhindwara,Madhya Pradesh',
'Rampur,Chhindwara,Madhya Pradesh',
'Barelipar,Chhindwara,Madhya Pradesh',
'Ambada,Chhindwara,Madhya Pradesh',
'Badegaon,Chhindwara,Madhya Pradesh',
'Bangaon,Chhindwara,Madhya Pradesh',
'Bhandargondi,Chhindwara,Madhya Pradesh',
'Changoba,Chhindwara,Madhya Pradesh',
'Chichkheda,Chhindwara,Madhya Pradesh',
'Dadimeta,Chhindwara,Madhya Pradesh',
'Dhanora,Chhindwara,Madhya Pradesh',
'Dhaodikhapa,Chhindwara,Madhya Pradesh',
'Etawa,Chhindwara,Madhya Pradesh',
'Ghoghari Sahani,Chhindwara,Madhya Pradesh',
'Hiwara Senadwar,Chhindwara,Madhya Pradesh',
'Khedikalan,Chhindwara,Madhya Pradesh',
'Kondhali,Chhindwara,Madhya Pradesh',
'Langha,Chhindwara,Madhya Pradesh',
'Ledori,Chhindwara,Madhya Pradesh',
'Lingajatlapur,Chhindwara,Madhya Pradesh',
'Mangurli,Chhindwara,Madhya Pradesh',
'Marud,Chhindwara,Madhya Pradesh',
'Mordongari,Chhindwara,Madhya Pradesh',
'Nandanwani,Chhindwara,Madhya Pradesh',
'Pandhurna Gujari,Chhindwara,Madhya Pradesh',
'Pandhurna,Chhindwara,Madhya Pradesh',
'Parsoli,Chhindwara,Madhya Pradesh',
'Pendoni,Chhindwara,Madhya Pradesh',
'Pipalpani,Chhindwara,Madhya Pradesh',
'Rajana,Chhindwara,Madhya Pradesh',
'Rajora Kalan,Chhindwara,Madhya Pradesh',
'Ringankhapa,Chhindwara,Madhya Pradesh',
'Saikheda,Chhindwara,Madhya Pradesh',
'Seoni Sausar,Chhindwara,Madhya Pradesh',
'Siratha,Chhindwara,Madhya Pradesh',
'Teegaon,Chhindwara,Madhya Pradesh',
'Jhurre Mines,Chhindwara,Madhya Pradesh',
'Baghbardia,Chhindwara,Madhya Pradesh',
'Belgaon,Chhindwara,Madhya Pradesh',
'Chandametta,Chhindwara,Madhya Pradesh',
'Chhinda,Chhindwara,Madhya Pradesh',
'Dighawani,Chhindwara,Madhya Pradesh',
'Dungaria,Chhindwara,Madhya Pradesh',
'Gajandoha,Chhindwara,Madhya Pradesh',
'Khirsadoha,Chhindwara,Madhya Pradesh',
'Kohka,Chhindwara,Madhya Pradesh',
'Lehgadua,Chhindwara,Madhya Pradesh',
'Newton Chikhali,Chhindwara,Madhya Pradesh',
'Pagara,Chhindwara,Madhya Pradesh',
'Paijanwara,Chhindwara,Madhya Pradesh',
'Palatwara,Chhindwara,Madhya Pradesh',
'Parasia,Chhindwara,Madhya Pradesh',
'Rawanwara,Chhindwara,Madhya Pradesh',
'Sirgora,Chhindwara,Madhya Pradesh',
'Umreth,Chhindwara,Madhya Pradesh',
'Urdhan,Chhindwara,Madhya Pradesh',
'Amladepot,Chhindwara,Madhya Pradesh',
'Banabakoda,Chhindwara,Madhya Pradesh',
'Berdi,Chhindwara,Madhya Pradesh',
'Bhimalgondi,Chhindwara,Madhya Pradesh',
'Borgaon,Chhindwara,Madhya Pradesh',
'Devi,Chhindwara,Madhya Pradesh',
'Ghoti,Chhindwara,Madhya Pradesh',
'Jamsaoli,Chhindwara,Madhya Pradesh',
'Jobnikhapa,Chhindwara,Madhya Pradesh',
'Kabarpipla,Chhindwara,Madhya Pradesh',
'Khairitaygoan,Chhindwara,Madhya Pradesh',
'Koparwarai,Chhindwara,Madhya Pradesh',
'Lodhikheda,Chhindwara,Madhya Pradesh',
'Lohangi,Chhindwara,Madhya Pradesh',
'Mohgaon Haveli,Chhindwara,Madhya Pradesh',
'Nandewani,Chhindwara,Madhya Pradesh',
'Nimni,Chhindwara,Madhya Pradesh',
'Pandharakheda,Chhindwara,Madhya Pradesh',
'Paradsinga,Chhindwara,Madhya Pradesh',
'Pindrai,Chhindwara,Madhya Pradesh',
'Piplanarayanwar,Chhindwara,Madhya Pradesh',
'Rajadi Pipla,Chhindwara,Madhya Pradesh',
'Ramakona,Chhindwara,Madhya Pradesh',
'Rangari,Chhindwara,Madhya Pradesh',
'Ranpeth,Chhindwara,Madhya Pradesh',
'Sausar,Chhindwara,Madhya Pradesh',
'Sawarni,Chhindwara,Madhya Pradesh',
'Saonga,Chhindwara,Madhya Pradesh',
'Bamni,Chhindwara,Madhya Pradesh',
'Bijori,Chhindwara,Madhya Pradesh',
'Chawalpani,Chhindwara,Madhya Pradesh',
'Chhindi,Chhindwara,Madhya Pradesh',
'Delakhari,Chhindwara,Madhya Pradesh',
'Dhusawani,Chhindwara,Madhya Pradesh',
'Etawa,Chhindwara,Madhya Pradesh',
'Jamuniya,Chhindwara,Madhya Pradesh',
'Jhirpa,Chhindwara,Madhya Pradesh',
'Jhontkalan,Chhindwara,Madhya Pradesh',
'Kursidhana,Chhindwara,Madhya Pradesh',
'Lotia,Chhindwara,Madhya Pradesh',
'Mahuljhir,Chhindwara,Madhya Pradesh',
'Muttor,Chhindwara,Madhya Pradesh',
'Nagri,Chhindwara,Madhya Pradesh',
'Sangakheda,Chhindwara,Madhya Pradesh',
'Sidholi,Chhindwara,Madhya Pradesh',
'Tamia,Chhindwara,Madhya Pradesh',
'Abhana,Sagar,Madhya Pradesh',
'Agara,Sagar,Madhya Pradesh',
'Ajni,Sagar,Madhya Pradesh',
'Amakheda,Sagar,Madhya Pradesh',
'Anu,Sagar,Madhya Pradesh',
'Aslana,Sagar,Madhya Pradesh',
'Badagaon,Sagar,Madhya Pradesh',
'Bakayan,Sagar,Madhya Pradesh',
'Bakeni,Sagar,Madhya Pradesh',
'Balakot,Sagar,Madhya Pradesh',
'Ballarpur,Sagar,Madhya Pradesh',
'Bamorimala,Sagar,Madhya Pradesh',
'Bandakpur,Sagar,Madhya Pradesh',
'Bangaon,Sagar,Madhya Pradesh',
'Bansa Tarkheda,Sagar,Madhya Pradesh',
'Banwar,Sagar,Madhya Pradesh',
'Batiagarh,Sagar,Madhya Pradesh',
'Belai,Sagar,Madhya Pradesh',
'Bhajiya,Sagar,Madhya Pradesh',
'Bhuri,Sagar,Madhya Pradesh',
'Bijadongary,Sagar,Madhya Pradesh',
'Bisnakheda,Sagar,Madhya Pradesh',
'Chaupra,Sagar,Madhya Pradesh',
'Chaurai Kalumar,Sagar,Madhya Pradesh',
'Chewala,Sagar,Madhya Pradesh',
'Chirola,Sagar,Madhya Pradesh',
'Damoh Bazaria,Sagar,Madhya Pradesh',
'Damoh City,Sagar,Madhya Pradesh',
'Damoh Civil Ward,Sagar,Madhya Pradesh',
'Damoh Collectrate,Sagar,Madhya Pradesh',
'Damoh H.O,Sagar,Madhya Pradesh',
'Damoh Phutera Ward,Sagar,Madhya Pradesh',
'Damoh R S,Sagar,Madhya Pradesh',
'Damoh,Sagar,Madhya Pradesh',
'Deodongra,Sagar,Madhya Pradesh',
'Deori Jmadar,Sagar,Madhya Pradesh',
'Dhangaur Kalan,Sagar,Madhya Pradesh',
'Dinari,Sagar,Madhya Pradesh',
'Emaliya Lanji,Sagar,Madhya Pradesh',
'Emlai,Sagar,Madhya Pradesh',
'Ghat Pipariya,Sagar,Madhya Pradesh',
'Ghatera,Sagar,Madhya Pradesh',
'Gubra Kalan,Sagar,Madhya Pradesh',
'Gunji,Sagar,Madhya Pradesh',
'Hardua Mangarh,Sagar,Madhya Pradesh',
'Harduya Sadak,Sagar,Madhya Pradesh',
'Hathana,Sagar,Madhya Pradesh',
'Hindoriya,Sagar,Madhya Pradesh',
'Hinoti Putrighat,Sagar,Madhya Pradesh',
'Jabera,Sagar,Madhya Pradesh',
'Jhlaun,Sagar,Madhya Pradesh',
'Jortala,Sagar,Madhya Pradesh',
'Jujhar,Sagar,Madhya Pradesh',
'Kaithora,Sagar,Madhya Pradesh',
'Kalehrakheda,Sagar,Madhya Pradesh',
'Kandipur,Sagar,Madhya Pradesh',
'Karanpura,Sagar,Madhya Pradesh',
'Kerwana,Sagar,Madhya Pradesh',
'Khaderi,Sagar,Madhya Pradesh',
'Khajari,Sagar,Madhya Pradesh',
'Khamriya Ajitpur,Sagar,Madhya Pradesh',
'Khamriya Mojilal,Sagar,Madhya Pradesh',
'Khojakhedi,Sagar,Madhya Pradesh',
'Kishangarh,Sagar,Madhya Pradesh',
'Kodakalan,Sagar,Madhya Pradesh',
'Korta,Sagar,Madhya Pradesh',
'Kuakheda,Sagar,Madhya Pradesh',
'Kudai,Sagar,Madhya Pradesh',
'Kumeriya,Sagar,Madhya Pradesh',
'Kumhari,Sagar,Madhya Pradesh',
'Kundalpur,Sagar,Madhya Pradesh',
'Kusmi Mangarh,Sagar,Madhya Pradesh',
'Lakhni,Sagar,Madhya Pradesh',
'Madankheda,Sagar,Madhya Pradesh',
'Majhguya Hansraj,Sagar,Madhya Pradesh',
'Mangola,Sagar,Madhya Pradesh',
'Mankaura,Sagar,Madhya Pradesh',
'Marutal,Sagar,Madhya Pradesh',
'Mojipura,Sagar,Madhya Pradesh',
'Mudia,Sagar,Madhya Pradesh',
'Muharai,Sagar,Madhya Pradesh',
'Narsingarh,Sagar,Madhya Pradesh',
'Nohata,Sagar,Madhya Pradesh',
'Padrai,Sagar,Madhya Pradesh',
'Pashwaha,Sagar,Madhya Pradesh',
'Pateriya,Sagar,Madhya Pradesh',
'Patna Bhangarh,Sagar,Madhya Pradesh',
'Patnakuya,Sagar,Madhya Pradesh',
'Patnaraja,Sagar,Madhya Pradesh',
'Phutera Kalan,Sagar,Madhya Pradesh',
'Piparia Champat,Sagar,Madhya Pradesh',
'Pipariya Tikari,Sagar,Madhya Pradesh',
'Podimangarh,Sagar,Madhya Pradesh',
'Pura,Sagar,Madhya Pradesh',
'Ramgarh,Sagar,Madhya Pradesh',
'Rasilpur,Sagar,Madhya Pradesh',
'Road,Sagar,Madhya Pradesh',
'Sadguya,Sagar,Madhya Pradesh',
'Sakha,Sagar,Madhya Pradesh',
'Salaiya,Sagar,Madhya Pradesh',
'Salwada,Sagar,Madhya Pradesh',
'Samnapur,Sagar,Madhya Pradesh',
'Sanga,Sagar,Madhya Pradesh',
'Sarkhadi,Sagar,Madhya Pradesh',
'Lalitpur,Rewa,Madhya Pradesh',
'Laxmanpur,Rewa,Madhya Pradesh',
'Lohi,Rewa,Madhya Pradesh',
'Maddepur,Rewa,Madhya Pradesh',
'Madwa,Rewa,Madhya Pradesh',
'Majhigawan,Rewa,Madhya Pradesh',
'Majhiyar,Rewa,Madhya Pradesh',
'Mankahari,Rewa,Madhya Pradesh',
'Mukundpur,Rewa,Madhya Pradesh',
'Neega,Rewa,Madhya Pradesh',
'Paipakhara,Rewa,Madhya Pradesh',
'Ratahara,Rewa,Madhya Pradesh',
'Rausar,Rewa,Madhya Pradesh',
'Rewa AG College,Rewa,Madhya Pradesh',
'Rewa APSU,Rewa,Madhya Pradesh',
'Rewa Bansagar Coloney,Rewa,Madhya Pradesh',
'Rewa Bicchiya Road,Rewa,Madhya Pradesh',
'Rewa Chauhatta,Rewa,Madhya Pradesh',
'Rewa Chirahula,Rewa,Madhya Pradesh',
'Rewa City,Rewa,Madhya Pradesh',
'Rewa Engineering College,Rewa,Madhya Pradesh',
'Rewa Ghoghar Mohalla,Rewa,Madhya Pradesh',
'Rewa H.O,Rewa,Madhya Pradesh',
'Rewa Medical College,Rewa,Madhya Pradesh',
'Rewa Uprahaty,Rewa,Madhya Pradesh',
'Rewa Venkat Bhawan,Rewa,Madhya Pradesh',
'Sagra,Rewa,Madhya Pradesh',
'Sathini,Rewa,Madhya Pradesh',
'Shukulgawan,Rewa,Madhya Pradesh',
'Sonaura,Rewa,Madhya Pradesh',
'Supiya,Rewa,Madhya Pradesh',
'Tamarabasi,Rewa,Madhya Pradesh',
'Tikar,Rewa,Madhya Pradesh',
'Akauri,Rewa,Madhya Pradesh',
'Akauri,Rewa,Madhya Pradesh',
'Andwa,Rewa,Madhya Pradesh',
'Atraila,Rewa,Madhya Pradesh',
'Baba Ki Barauli,Rewa,Madhya Pradesh',
'Barahula,Rewa,Madhya Pradesh',
'Basrehi,Rewa,Madhya Pradesh',
'Bhanigawan,Rewa,Madhya Pradesh',
'Bhungawan,Rewa,Madhya Pradesh',
'Champagarh,Rewa,Madhya Pradesh',
'Chaukhandi,Rewa,Madhya Pradesh',
'Deokhar,Rewa,Madhya Pradesh',
'Dondar,Rewa,Madhya Pradesh',
'Gada-137,Rewa,Madhya Pradesh',
'Gada-138,Rewa,Madhya Pradesh',
'Ghooman,Rewa,Madhya Pradesh',
'Hardoli,Rewa,Madhya Pradesh',
'Itma,Rewa,Madhya Pradesh',
'Janakhai,Rewa,Madhya Pradesh',
'Jawa,Rewa,Madhya Pradesh',
'Jonha,Rewa,Madhya Pradesh',
'Kanchanpur,Rewa,Madhya Pradesh',
'Khajha,Rewa,Madhya Pradesh',
'Konigadehara,Rewa,Madhya Pradesh',
'Koniyakala,Rewa,Madhya Pradesh',
'Kota,Rewa,Madhya Pradesh',
'Kotwa,Rewa,Madhya Pradesh',
'Kuthila,Rewa,Madhya Pradesh',
'Look,Rewa,Madhya Pradesh',
'Madri,Rewa,Madhya Pradesh',
'Negura,Rewa,Madhya Pradesh',
'Panwar,Rewa,Madhya Pradesh',
'Parasiya,Rewa,Madhya Pradesh',
'Pariharinpurwa,Rewa,Madhya Pradesh',
'Pathat,Rewa,Madhya Pradesh',
'Patiyari,Rewa,Madhya Pradesh',
'Purauna,Rewa,Madhya Pradesh',
'Sitlaha,Rewa,Madhya Pradesh',
'Tangha,Rewa,Madhya Pradesh',
'Unchi Auni,Rewa,Madhya Pradesh',
'Kapsa,Rewa,Madhya Pradesh',
'Khadda,Rewa,Madhya Pradesh',
'Amiliya,Rewa,Madhya Pradesh',
'Baheradabar,Rewa,Madhya Pradesh',
'Bahuti,Rewa,Madhya Pradesh',
'Barahata,Rewa,Madhya Pradesh',
'Baraon,Rewa,Madhya Pradesh',
'Bhaluha,Rewa,Madhya Pradesh',
'Bharigawan,Rewa,Madhya Pradesh',
'Bhir,Rewa,Madhya Pradesh',
'Bichharahta,Rewa,Madhya Pradesh',
'Damodar Garh,Rewa,Madhya Pradesh',
'Deorihangaon,Rewa,Madhya Pradesh',
'Deorisengran,Rewa,Madhya Pradesh',
'Deotalab,Rewa,Madhya Pradesh',
'Dhangan,Rewa,Madhya Pradesh',
'Dhera,Rewa,Madhya Pradesh',
'Farahada,Rewa,Madhya Pradesh',
'Garh,Rewa,Madhya Pradesh',
'Gauri,Rewa,Madhya Pradesh',
'Hanumana,Rewa,Madhya Pradesh',
'Judmaniya,Rewa,Madhya Pradesh',
'Katra,Rewa,Madhya Pradesh',
'Khatkhari,Rewa,Madhya Pradesh',
'Korigawan,Rewa,Madhya Pradesh',
'Kulbaheria,Rewa,Madhya Pradesh',
'Mangawan,Rewa,Madhya Pradesh',
'Mauganj,Rewa,Madhya Pradesh',
'Misirgawan,Rewa,Madhya Pradesh',
'Mudaria,Rewa,Madhya Pradesh',
'Naigarhi,Rewa,Madhya Pradesh',
'Naudhiya,Rewa,Madhya Pradesh',
'Padar,Rewa,Madhya Pradesh',
'Pahadi,Rewa,Madhya Pradesh',
'Panni,Rewa,Madhya Pradesh',
'Patehara,Rewa,Madhya Pradesh',
'Patulkhi,Rewa,Madhya Pradesh',
'Phool,Rewa,Madhya Pradesh',
'Purwa,Rewa,Madhya Pradesh',
'Raghunathganj,Rewa,Madhya Pradesh',
'Rajadhau,Rewa,Madhya Pradesh',
'Rampur Teonther,Rewa,Madhya Pradesh',
'Ratangawan,Rewa,Madhya Pradesh',
'Shahpur,Rewa,Madhya Pradesh',
'Sitapur,Rewa,Madhya Pradesh',
'Vasigada,Rewa,Madhya Pradesh',
'Moharba,Rewa,Madhya Pradesh',
'Purani Jagir,Rewa,Madhya Pradesh',
'Rahat,Rewa,Madhya Pradesh',
'Barati,Rewa,Madhya Pradesh',
'Belwapaikan,Rewa,Madhya Pradesh',
'Budhiya,Rewa,Madhya Pradesh',
'Delhi,Rewa,Madhya Pradesh',
'Deogaon,Rewa,Madhya Pradesh',
'Dhawaiya,Rewa,Madhya Pradesh',
'Dighwar,Rewa,Madhya Pradesh',
'Dubahai Khurd,Rewa,Madhya Pradesh',
'Dubgawan,Rewa,Madhya Pradesh',
'Dwari,Rewa,Madhya Pradesh',
'Gangeo,Rewa,Madhya Pradesh',
'Ghopi,Rewa,Madhya Pradesh',
'Gorgaon,Rewa,Madhya Pradesh',
'Hatwa,Rewa,Madhya Pradesh',
'Joraut,Rewa,Madhya Pradesh',
'Khaira Kankesra,Rewa,Madhya Pradesh',
'Kuiyakala,Rewa,Madhya Pradesh',
'Madhi,Rewa,Madhya Pradesh',
'Mahmoodpur,Rewa,Madhya Pradesh',
'Mahsua,Rewa,Madhya Pradesh',
'Manikwar,Rewa,Madhya Pradesh',
'Naudhia,Rewa,Madhya Pradesh',
'Nawagaon,Rewa,Madhya Pradesh',
'Pachpahra,Rewa,Madhya Pradesh',
'Padariya,Rewa,Madhya Pradesh',
'Padra,Rewa,Madhya Pradesh',
'Raghurajgarh,Rewa,Madhya Pradesh',
'Raipur Karchulion,Rewa,Madhya Pradesh',
'Ramnai,Rewa,Madhya Pradesh',
'Raura,Rewa,Madhya Pradesh',
'Shukulgawan,Rewa,Madhya Pradesh',
'Sirsa,Rewa,Madhya Pradesh',
'Suji,Rewa,Madhya Pradesh',
'Sura,Rewa,Madhya Pradesh',
'Sursa,Rewa,Madhya Pradesh',
'Tamradesh,Rewa,Madhya Pradesh',
'Teoni,Rewa,Madhya Pradesh',
'Ulahikhurd,Rewa,Madhya Pradesh',
'Umari,Rewa,Madhya Pradesh',
'Barahadi,Rewa,Madhya Pradesh',
'Rajgarh,Rewa,Madhya Pradesh',
'Kundanpur,Ratlam,Madhya Pradesh',
'Rupauli,Rewa,Madhya Pradesh',
'Ataria,Rewa,Madhya Pradesh',
'Babaiya,Rewa,Madhya Pradesh',
'Badagaon Kothar,Rewa,Madhya Pradesh',
'Badraon,Rewa,Madhya Pradesh',
'Baikunthpur,Rewa,Madhya Pradesh',
'Bandhwa,Rewa,Madhya Pradesh',
'Bara,Rewa,Madhya Pradesh',
'Baraon,Rewa,Madhya Pradesh',
'Beeda,Rewa,Madhya Pradesh',
'Belwa Badgaiyan,Rewa,Madhya Pradesh',
'Bhamra,Rewa,Madhya Pradesh',
'Bihra,Rewa,Madhya Pradesh',
'Busaul,Rewa,Madhya Pradesh',
'Chachai,Rewa,Madhya Pradesh',
'Chakdahi,Rewa,Madhya Pradesh',
'Chitgarh,Rewa,Madhya Pradesh',
'Dagardua,Rewa,Madhya Pradesh',
'Delhi,Rewa,Madhya Pradesh',
'Deora,Rewa,Madhya Pradesh',
'Deora,Rewa,Madhya Pradesh',
'Dewas,Rewa,Madhya Pradesh',
'Doha,Rewa,Madhya Pradesh',
'Duara,Rewa,Madhya Pradesh',
'Dulahara,Rewa,Madhya Pradesh',
'Golahata,Rewa,Madhya Pradesh',
'Handia,Rewa,Madhya Pradesh',
'Hardi Badi,Rewa,Madhya Pradesh',
'Hardua,Rewa,Madhya Pradesh',
'Harrai Badi,Rewa,Madhya Pradesh',
'Hatwa,Rewa,Madhya Pradesh',
'Jadua,Rewa,Madhya Pradesh',
'Jamu,Rewa,Madhya Pradesh',
'Jhalwar,Rewa,Madhya Pradesh',
'Jodauri,Rewa,Madhya Pradesh',
'Jodhpur,Rewa,Madhya Pradesh',
'Kakredi,Rewa,Madhya Pradesh',
'Kanchanpur,Rewa,Madhya Pradesh',
'Kandaila,Rewa,Madhya Pradesh',
'Keoti,Rewa,Madhya Pradesh',
'Khaira,Rewa,Madhya Pradesh',
'Khamaria Chaubey,Rewa,Madhya Pradesh',
'Kharihan,Rewa,Madhya Pradesh',
'Kharra,Rewa,Madhya Pradesh',
'Kumhra Judwani,Rewa,Madhya Pradesh',
'Kushwar,Rewa,Madhya Pradesh',
'Lalgaon,Rewa,Madhya Pradesh',
'Laulachh,Rewa,Madhya Pradesh',
'Laxmanpur,Rewa,Madhya Pradesh',
'Mado,Rewa,Madhya Pradesh',
'Madri,Rewa,Madhya Pradesh',
'Matima,Rewa,Madhya Pradesh',
'Mau,Rewa,Madhya Pradesh',
'Nadna,Rewa,Madhya Pradesh',
'Padri,Rewa,Madhya Pradesh',
'Paharkha,Rewa,Madhya Pradesh',
'Paikangaon,Rewa,Madhya Pradesh',
'Palhan,Rewa,Madhya Pradesh',
'Parasi,Rewa,Madhya Pradesh',
'Patehara,Rewa,Madhya Pradesh',
'Pathari,Rewa,Madhya Pradesh',
'Phulha,Rewa,Madhya Pradesh',
'Purwa,Rewa,Madhya Pradesh',
'Ragauli,Rewa,Madhya Pradesh',
'Sadahana,Rewa,Madhya Pradesh',
'Sagara,Rewa,Madhya Pradesh',
'Sansarpur,Rewa,Madhya Pradesh',
'Sarai Unmulan,Rewa,Madhya Pradesh',
'Saraisenger,Rewa,Madhya Pradesh',
'Semariya,Rewa,Madhya Pradesh',
'Shahpur,Rewa,Madhya Pradesh',
'Silpari,Rewa,Madhya Pradesh',
'Sirmour,Rewa,Madhya Pradesh',
'Sonversa,Rewa,Madhya Pradesh',
'Sujwar,Rewa,Madhya Pradesh',
'Tighara,Rewa,Madhya Pradesh',
'Tikuri Unmulan,Rewa,Madhya Pradesh',
'Tilkhan,Rewa,Madhya Pradesh',
'Umari,Rewa,Madhya Pradesh',
'Sukwar,Rewa,Madhya Pradesh',
'Atraila,Rewa,Madhya Pradesh',
'Badagaon,Rewa,Madhya Pradesh',
'Basahat,Rewa,Madhya Pradesh',
'Chak,Rewa,Madhya Pradesh',
'Chandai,Rewa,Madhya Pradesh',
'Chaura,Rewa,Madhya Pradesh',
'Dabhaura,Rewa,Madhya Pradesh',
'Dhakhara,Rewa,Madhya Pradesh',
'Kakarha,Rewa,Madhya Pradesh',
'Khaira,Rewa,Madhya Pradesh',
'Majhigawan,Rewa,Madhya Pradesh',
'Mangi,Rewa,Madhya Pradesh',
'Nipania,Rewa,Madhya Pradesh',
'Padri,Rewa,Madhya Pradesh',
'Raipur Sonauri,Rewa,Madhya Pradesh',
'Sohagi,Rewa,Madhya Pradesh',
'Sonauri,Rewa,Madhya Pradesh',
'Teonthar,Rewa,Madhya Pradesh',
'Umari Govindpur,Rewa,Madhya Pradesh',
'Amilkoni,Rewa,Madhya Pradesh',
'Anjora,Rewa,Madhya Pradesh',
'Atraila,Rewa,Madhya Pradesh',
'Bans,Rewa,Madhya Pradesh',
'Chandpur,Rewa,Madhya Pradesh',
'Chaukhadda,Rewa,Madhya Pradesh',
'Garhi Soharwa,Rewa,Madhya Pradesh',
'Garhwa,Rewa,Madhya Pradesh',
'Gondari,Rewa,Madhya Pradesh',
'Gondkala,Rewa,Madhya Pradesh',
'Hinauti,Rewa,Madhya Pradesh',
'Jamui,Rewa,Madhya Pradesh',
'Janeh,Rewa,Madhya Pradesh',
'Kalwari,Rewa,Madhya Pradesh',
'Kankar,Rewa,Madhya Pradesh',
'Kashiyargaon,Rewa,Madhya Pradesh',
'Kotrakala,Rewa,Madhya Pradesh',
'Rehi,Rewa,Madhya Pradesh',
'Sarui,Rewa,Madhya Pradesh',
'Soharwa,Rewa,Madhya Pradesh',
'Barha,Sagar,Madhya Pradesh',
'Beldhana,Sagar,Madhya Pradesh',
'Bijora,Sagar,Madhya Pradesh',
'Bina Deori,Sagar,Madhya Pradesh',
'Chauka,Sagar,Madhya Pradesh',
'Deori Nadipar,Sagar,Madhya Pradesh',
'Deori,Sagar,Madhya Pradesh',
'Dongar Salaiya,Sagar,Madhya Pradesh',
'Emra,Sagar,Madhya Pradesh',
'Ghana,Sagar,Madhya Pradesh',
'Gutori,Sagar,Madhya Pradesh',
'Gutori Pana,Sagar,Madhya Pradesh',
'Jaitpur,Sagar,Madhya Pradesh',
'Jhiriya Adharpur,Sagar,Madhya Pradesh',
'Kesli,Sagar,Madhya Pradesh',
'Kevlari Kalan,Sagar,Madhya Pradesh',
'Maharajpur,Sagar,Madhya Pradesh',
'Muhli,Sagar,Madhya Pradesh',
'Muyarkhas,Sagar,Madhya Pradesh',
'Padarai Buzurg,Sagar,Madhya Pradesh',
'Patha,Sagar,Madhya Pradesh',
'Rasena,Sagar,Madhya Pradesh',
'Sahajpur,Sagar,Madhya Pradesh',
'Simariya,Sagar,Madhya Pradesh',
'Singpur,Sagar,Madhya Pradesh',
'Singpur Sadguya,Sagar,Madhya Pradesh',
'Tada,Sagar,Madhya Pradesh',
'Basari,Sagar,Madhya Pradesh',
'Basari,Sagar,Madhya Pradesh',
'Chanauya Buzurg,Sagar,Madhya Pradesh',
'Chapra,Sagar,Madhya Pradesh',
'Chulla,Sagar,Madhya Pradesh',
'Garhakota Nadipar,Sagar,Madhya Pradesh',
'Garhakota,Sagar,Madhya Pradesh',
'Gunjora,Sagar,Madhya Pradesh',
'Haldi,Sagar,Madhya Pradesh',
'Kumarai,Sagar,Madhya Pradesh',
'Pipariaya Pachara,Sagar,Madhya Pradesh',
'Sewas,Sagar,Madhya Pradesh',
'Udaypura,Sagar,Madhya Pradesh',
'Umra,Sagar,Madhya Pradesh',
'Barodiya Nongar,Sagar,Madhya Pradesh',
'Dhanora,Sagar,Madhya Pradesh',
'Gadola Jageer,Sagar,Madhya Pradesh',
'Khaijra Harchand,Sagar,Madhya Pradesh',
'Khaira,Sagar,Madhya Pradesh',
'Khurai City,Sagar,Madhya Pradesh',
'Khurai,Sagar,Madhya Pradesh',
'Mukarampur,Sagar,Madhya Pradesh',
'Nirtala,Sagar,Madhya Pradesh',
'Sarkhadi,Sagar,Madhya Pradesh',
'Satnai,Sagar,Madhya Pradesh',
'Silodha,Sagar,Madhya Pradesh',
'Teora,Sagar,Madhya Pradesh',
'Agariya,Sagar,Madhya Pradesh',
'Agasaud,Sagar,Madhya Pradesh',
'Agasaud,Sagar,Madhya Pradesh',
'Amarmau,Sagar,Madhya Pradesh',
'Anantpura,Sagar,Madhya Pradesh',
'Anantpura,Sagar,Madhya Pradesh',
'Atta,Sagar,Madhya Pradesh',
'Baheriya Kalan,Sagar,Madhya Pradesh',
'Baheriya Sahani,Sagar,Madhya Pradesh',
'Bahrol,Sagar,Madhya Pradesh',
'Baleh,Sagar,Madhya Pradesh',
'Bamnora,Sagar,Madhya Pradesh',
'Bamori Bika,Sagar,Madhya Pradesh',
'Banda Belai,Sagar,Madhya Pradesh',
'Banda Nagar,Sagar,Madhya Pradesh',
'Bandri,Sagar,Madhya Pradesh',
'Bansa,Sagar,Madhya Pradesh',
'Bara,Sagar,Madhya Pradesh',
'Baraj,Sagar,Madhya Pradesh',
'Bararu,Sagar,Madhya Pradesh',
'Barayatha,Sagar,Madhya Pradesh',
'Bardha,Sagar,Madhya Pradesh',
'Baretha,Sagar,Madhya Pradesh',
'Barha,Sagar,Madhya Pradesh',
'Barkheda Sikandar,Sagar,Madhya Pradesh',
'Baroda Rehli,Sagar,Madhya Pradesh',
'Baroda Sagar,Sagar,Madhya Pradesh',
'Barodia Kala,Sagar,Madhya Pradesh',
'Basari,Sagar,Madhya Pradesh',
'Baxwaha,Sagar,Madhya Pradesh',
'Besra,Sagar,Madhya Pradesh',
'Bhaisa,Sagar,Madhya Pradesh',
'Bhangarh,Sagar,Madhya Pradesh',
'Bhapel,Sagar,Madhya Pradesh',
'Bharchha,Sagar,Madhya Pradesh',
'Bidwas,Sagar,Madhya Pradesh',
'Bidwasan,Sagar,Madhya Pradesh',
'Bilagram,Sagar,Madhya Pradesh',
'Bilahra Raja,Sagar,Madhya Pradesh',
'Bildho,Sagar,Madhya Pradesh',
'Bina Bazaria,Sagar,Madhya Pradesh',
'Bina Etawa,Sagar,Madhya Pradesh',
'Bina,Sagar,Madhya Pradesh',
'Bina West Colony,Sagar,Madhya Pradesh',
'Binaka,Sagar,Madhya Pradesh',
'Chakeri Bineka,Sagar,Madhya Pradesh',
'Chandamau,Sagar,Madhya Pradesh',
'Chandpur,Sagar,Madhya Pradesh',
'Chandrapur,Sagar,Madhya Pradesh',
'Chatubhata,Sagar,Madhya Pradesh',
'Chhapri,Sagar,Madhya Pradesh',
'Chhirari,Sagar,Madhya Pradesh',
'Chitora,Sagar,Madhya Pradesh',
'Dalppatpur,Sagar,Madhya Pradesh',
'Dehri,Sagar,Madhya Pradesh',
'Deori Naharmau,Sagar,Madhya Pradesh',
'Dewal,Sagar,Madhya Pradesh',
'Dhana Naryaoli,Sagar,Madhya Pradesh',
'Dhana,Sagar,Madhya Pradesh',
'Dugasara,Sagar,Madhya Pradesh',
'Dungariya,Sagar,Madhya Pradesh',
'Gadola Jawahar,Sagar,Madhya Pradesh',
'Gambhiriyia,Sagar,Madhya Pradesh',
'Gaurjhamar,Sagar,Madhya Pradesh',
'Gehuras,Sagar,Madhya Pradesh',
'Ghambhiriyahat,Sagar,Madhya Pradesh',
'Ghoghra Khurd,Sagar,Madhya Pradesh',
'Girwar,Sagar,Madhya Pradesh',
'Gorakhurd,Sagar,Madhya Pradesh',
'Gugra,Sagar,Madhya Pradesh',
'Hilgan,Sagar,Madhya Pradesh',
'Hirankheda,Sagar,Madhya Pradesh',
'Hirapur,Sagar,Madhya Pradesh',
'Isurwara,Sagar,Madhya Pradesh',
'Jagthar,Sagar,Madhya Pradesh',
'Jaisinagar,Sagar,Madhya Pradesh',
'Jaitpur Doga,Sagar,Madhya Pradesh',
'Jaitpur Kachya,Sagar,Madhya Pradesh',
'Jalandhar,Sagar,Madhya Pradesh',
'Jaruakheda,Sagar,Madhya Pradesh',
'Jerai,Sagar,Madhya Pradesh',
'Jhila,Sagar,Madhya Pradesh',
'Kandwa,Sagar,Madhya Pradesh',
'Kanera Gaund,Sagar,Madhya Pradesh',
'Kanera Neekhar,Sagar,Madhya Pradesh',
'Kanjiya,Sagar,Madhya Pradesh',
'Karaiya,Sagar,Madhya Pradesh',
'Karo R.S.,Sagar,Madhya Pradesh',
'Karrapur,Sagar,Madhya Pradesh',
'Kasal Pipariya,Sagar,Madhya Pradesh',
'Katangi,Sagar,Madhya Pradesh',
'Kerwana,Sagar,Madhya Pradesh',
'Khaijra Mafi,Sagar,Madhya Pradesh',
'Khairana,Sagar,Madhya Pradesh',
'Khataura Kalan,Sagar,Madhya Pradesh',
'Khera Udaet,Sagar,Madhya Pradesh',
'Khimlasa,Sagar,Madhya Pradesh',
'Khiriya Kala,Sagar,Madhya Pradesh',
'Khurai Thawari,Sagar,Madhya Pradesh',
'Korja,Sagar,Madhya Pradesh',
'Laloai,Sagar,Madhya Pradesh',
'Madi Jamuniya,Sagar,Madhya Pradesh',
'Magardha,Sagar,Madhya Pradesh',
'Mahuna,Sagar,Madhya Pradesh',
'Mahuna,Sagar,Madhya Pradesh',
'Mahuna Gujar,Sagar,Madhya Pradesh',
'Mahuyakheda,Sagar,Madhya Pradesh',
'Malthone,Sagar,Madhya Pradesh',
'Manjala,Sagar,Madhya Pradesh',
'Manki Salaiya,Sagar,Madhya Pradesh',
'Mardanpur,Sagar,Madhya Pradesh',
'Masurhai,Sagar,Madhya Pradesh',
'Meerkhedi,Sagar,Madhya Pradesh',
'Mehar,Sagar,Madhya Pradesh',
'Mokalpur,Sagar,Madhya Pradesh',
'Muhli,Sagar,Madhya Pradesh',
'Naindhara,Sagar,Madhya Pradesh',
'Narwa,Sagar,Madhya Pradesh',
'Naryaoliedso,Sagar,Madhya Pradesh',
'Naukheda,Sagar,Madhya Pradesh',
'Neemon,Sagar,Madhya Pradesh',
'Newtna,Sagar,Madhya Pradesh',
'Padarai,Sagar,Madhya Pradesh',
'Padaria,Sagar,Madhya Pradesh',
'Padaria,Sagar,Madhya Pradesh',
'Pamakhedi,Sagar,Madhya Pradesh',
'Papet,Sagar,Madhya Pradesh',
'Parasari Kalan,Sagar,Madhya Pradesh',
'Parsone,Sagar,Madhya Pradesh',
'Parsoriya,Sagar,Madhya Pradesh',
'Patauya,Sagar,Madhya Pradesh',
'Pathariya Jogan,Sagar,Madhya Pradesh',
'Patna Buzurg,Sagar,Madhya Pradesh',
'Patna Khurai,Sagar,Madhya Pradesh',
'Peepra,Sagar,Madhya Pradesh',
'Pidruya,Sagar,Madhya Pradesh',
'Pipariya Kachhi,Sagar,Madhya Pradesh',
'Piprasar,Sagar,Madhya Pradesh',
'Pithoriya,Sagar,Madhya Pradesh',
'Purbautori,Sagar,Madhya Pradesh',
'Rahatgarh,Sagar,Madhya Pradesh',
'Rajuya,Sagar,Madhya Pradesh',
'Rajwas,Sagar,Madhya Pradesh',
'Rampur,Sagar,Madhya Pradesh',
'Rehli,Sagar,Madhya Pradesh',
'Rond,Sagar,Madhya Pradesh',
'Rurawan,Sagar,Madhya Pradesh',
'Sagar B I Bazar,Sagar,Madhya Pradesh',
'Sagar Bada Bazar,Sagar,Madhya Pradesh',
'Sagar Cantt H.O,Sagar,Madhya Pradesh',
'Sagar Cantt,Sagar,Madhya Pradesh',
'Sagar Cavlari Hill,Sagar,Madhya Pradesh',
'Sagar City,Sagar,Madhya Pradesh',
'Sagar Collectrate,Sagar,Madhya Pradesh',
'Sagar Gallamandi,Sagar,Madhya Pradesh',
'Sagar Gopalganj,Sagar,Madhya Pradesh',
'Sagar Jnpa,Sagar,Madhya Pradesh',
'Sagar Luxmipura,Sagar,Madhya Pradesh',
'Sagar Makronia Camp,Sagar,Madhya Pradesh',
'Sagar Sadar Bazar,Sagar,Madhya Pradesh',
'Sagar Shanichri,Sagar,Madhya Pradesh',
'Sagar Subhash Nagar,Sagar,Madhya Pradesh',
'Sagar Tilli,Sagar,Madhya Pradesh',
'Sagar University,Sagar,Madhya Pradesh',
'Sagoni,Sagar,Madhya Pradesh',
'Sahawan,Sagar,Madhya Pradesh',
'Samnapur,Sagar,Madhya Pradesh',
'Sanodha,Sagar,Madhya Pradesh',
'Sarkhadi,Sagar,Madhya Pradesh',
'Sattadhana,Sagar,Madhya Pradesh',
'Sawal Khiriya,Sagar,Madhya Pradesh',
'Semra Lodhi,Sagar,Madhya Pradesh',
'Semrahat,Sagar,Madhya Pradesh',
'Sesai Saji,Sagar,Madhya Pradesh',
'Shahgarh,Sagar,Madhya Pradesh',
'Shahpur Magrone,Sagar,Madhya Pradesh',
'Shyampura,Sagar,Madhya Pradesh',
'Sidguya,Sagar,Madhya Pradesh',
'Sidguya,Sagar,Madhya Pradesh',
'Sihora,Sagar,Madhya Pradesh',
'Sothiya,Sagar,Madhya Pradesh',
'Surkhi,Sagar,Madhya Pradesh',
'Tada,Sagar,Madhya Pradesh',
'Thikari,Sagar,Madhya Pradesh',
'Tigoda,Sagar,Madhya Pradesh',
'Tila Buzurg,Sagar,Madhya Pradesh',
'Tinsi,Sagar,Madhya Pradesh',
'Toda Tarafdar,Sagar,Madhya Pradesh',
'Udaypura Tiwari,Sagar,Madhya Pradesh',
'Uldan,Sagar,Madhya Pradesh',
'Barua,Rewa,Madhya Pradesh',
'Kelhaura,Rewa,Madhya Pradesh',
'Kharemseda,Rewa,Madhya Pradesh',
'Sonsura Kothar,Rewa,Madhya Pradesh',
'Ahirgaon,Rewa,Madhya Pradesh',
'Amarpatan,Rewa,Madhya Pradesh',
'Asrar,Rewa,Madhya Pradesh',
'Babupur,Rewa,Madhya Pradesh',
'Beeda,Rewa,Madhya Pradesh',
'Bhikhampur,Rewa,Madhya Pradesh',
'Bigaudi,Rewa,Madhya Pradesh',
'Chorhata,Rewa,Madhya Pradesh',
'Dhaurahara,Rewa,Madhya Pradesh',
'Gora,Rewa,Madhya Pradesh',
'Itmanaditeer,Rewa,Madhya Pradesh',
'Kakra Karhi,Rewa,Madhya Pradesh',
'Kathaha,Rewa,Madhya Pradesh',
'Khajuri Tal,Rewa,Madhya Pradesh',
'Kharwahi,Rewa,Madhya Pradesh',
'Kumhari,Rewa,Madhya Pradesh',
'Lakhaha,Rewa,Madhya Pradesh',
'Madhi,Rewa,Madhya Pradesh',
'Majhgawan,Rewa,Madhya Pradesh',
'Mauhari Katra,Rewa,Madhya Pradesh',
'Obra,Rewa,Madhya Pradesh',
'Pal,Rewa,Madhya Pradesh',
'Paraswahi,Rewa,Madhya Pradesh',
'Pathara,Rewa,Madhya Pradesh',
'Raikwar,Rewa,Madhya Pradesh',
'Ramgarh,Rewa,Madhya Pradesh',
'Shivpurwa,Rewa,Madhya Pradesh',
'Sonaura Kothar,Rewa,Madhya Pradesh',
'Tala,Rewa,Madhya Pradesh',
'Ajmain,Rewa,Madhya Pradesh',
'Amadara,Rewa,Madhya Pradesh',
'Amatara,Rewa,Madhya Pradesh',
'Bathia,Rewa,Madhya Pradesh',
'Berma,Rewa,Madhya Pradesh',
'Bhadanpur,Rewa,Madhya Pradesh',
'Bhatigawan,Rewa,Madhya Pradesh',
'Bhenda,Rewa,Madhya Pradesh',
'Bihata,Rewa,Madhya Pradesh',
'Binaika,Rewa,Madhya Pradesh',
'Budherua,Rewa,Madhya Pradesh',
'Dhanwahi,Rewa,Madhya Pradesh',
'Dubehi,Rewa,Madhya Pradesh',
'Ghunwara,Rewa,Madhya Pradesh',
'Gobri,Rewa,Madhya Pradesh',
'Hinauta Kala,Rewa,Madhya Pradesh',
'Ichaul,Rewa,Madhya Pradesh',
'Itahara,Rewa,Madhya Pradesh',
'Itma,Rewa,Madhya Pradesh',
'Jariyari,Rewa,Madhya Pradesh',
'Jhukehi,Rewa,Madhya Pradesh',
'Jura,Rewa,Madhya Pradesh',
'Karhikala,Rewa,Madhya Pradesh',
'Kusendi,Rewa,Madhya Pradesh',
'Latagaon,Rewa,Madhya Pradesh',
'Madai,Rewa,Madhya Pradesh',
'Magraura,Rewa,Madhya Pradesh',
'Maihar,Rewa,Madhya Pradesh',
'Nadan,Rewa,Madhya Pradesh',
'Narwarkala,Rewa,Madhya Pradesh',
'Pahadi,Rewa,Madhya Pradesh',
'Pondi,Rewa,Madhya Pradesh',
'Sabhaganj,Rewa,Madhya Pradesh',
'Sarlanagar,Rewa,Madhya Pradesh',
'Semara,Rewa,Madhya Pradesh',
'Sharda Mata Mandir,Rewa,Madhya Pradesh',
'Sonwari,Rewa,Madhya Pradesh',
'Tighrakala,Rewa,Madhya Pradesh',
'Unchehara,Rewa,Madhya Pradesh',
'Badera,Rewa,Madhya Pradesh',
'Ama,Rewa,Madhya Pradesh',
'Amdarikala,Rewa,Madhya Pradesh',
'Amkui,Rewa,Madhya Pradesh',
'Atra,Rewa,Madhya Pradesh',
'Babupur,Rewa,Madhya Pradesh',
'Basudha,Rewa,Madhya Pradesh',
'Chorwari,Rewa,Madhya Pradesh',
'Chunha,Rewa,Madhya Pradesh',
'Dhaurahara,Rewa,Madhya Pradesh',
'Dureha,Rewa,Madhya Pradesh',
'Gangwaria,Rewa,Madhya Pradesh',
'Ginjara,Rewa,Madhya Pradesh',
'Gudha,Rewa,Madhya Pradesh',
'Hardua Kala,Rewa,Madhya Pradesh',
'Jaso,Rewa,Madhya Pradesh',
'Jhingodar,Rewa,Madhya Pradesh',
'Kadsara,Rewa,Madhya Pradesh',
'Karhi Kala,Rewa,Madhya Pradesh',
'Khamharia Khurd,Rewa,Madhya Pradesh',
'Kondar,Rewa,Madhya Pradesh',
'Kulgarhi,Rewa,Madhya Pradesh',
'Kumhari,Rewa,Madhya Pradesh',
'Madai,Rewa,Madhya Pradesh',
'Marhikala,Rewa,Madhya Pradesh',
'Nagod,Rewa,Madhya Pradesh',
'Pahadi,Rewa,Madhya Pradesh',
'Pangara,Rewa,Madhya Pradesh',
'Patwara,Rewa,Madhya Pradesh',
'Rahikwara,Rewa,Madhya Pradesh',
'Rajapur,Rewa,Madhya Pradesh',
'Raund,Rewa,Madhya Pradesh',
'Semari,Rewa,Madhya Pradesh',
'Semarwara,Rewa,Madhya Pradesh',
'Shivrajpur,Rewa,Madhya Pradesh',
'Shyamnagar,Rewa,Madhya Pradesh',
'Singhpur,Rewa,Madhya Pradesh',
'Surdaha,Rewa,Madhya Pradesh',
'Umarahat,Rewa,Madhya Pradesh',
'Usrar,Rewa,Madhya Pradesh',
'Asilash Ashram,Rewa,Madhya Pradesh',
'Garhwa Kala,Rewa,Madhya Pradesh',
'Satna H.O,Rewa,Madhya Pradesh',
'Satna Tikuria Tola,Rewa,Madhya Pradesh',
'Satna Semaria Chowk,Rewa,Madhya Pradesh',
'Chandai,Rewa,Madhya Pradesh',
'Aber,Rewa,Madhya Pradesh',
'Arjunpur,Rewa,Madhya Pradesh',
'Babupur,Rewa,Madhya Pradesh',
'Bachwai,Rewa,Madhya Pradesh',
'Badkhar,Rewa,Madhya Pradesh',
'Badkhera,Rewa,Madhya Pradesh',
'Bagha,Rewa,Madhya Pradesh',
'Bairahana,Rewa,Madhya Pradesh',
'Bamhauri,Rewa,Madhya Pradesh',
'Bamhraula,Rewa,Madhya Pradesh',
'Bandhi,Rewa,Madhya Pradesh',
'Barahana,Rewa,Madhya Pradesh',
'Baraundha,Rewa,Madhya Pradesh',
'Belhata,Rewa,Madhya Pradesh',
'Bhainswar,Rewa,Madhya Pradesh',
'Bharhut,Rewa,Madhya Pradesh',
'Bharjuna Kala,Rewa,Madhya Pradesh',
'Bhiamau,Rewa,Madhya Pradesh',
'Bhumkahar,Rewa,Madhya Pradesh',
'Birnai,Rewa,Madhya Pradesh',
'Birsinghpur,Rewa,Madhya Pradesh',
'Bitma,Rewa,Madhya Pradesh',
'Chitahara,Rewa,Madhya Pradesh',
'Chua,Rewa,Madhya Pradesh',
'Chund Khurd,Rewa,Madhya Pradesh',
'Dagdiha,Rewa,Madhya Pradesh',
'Deora,Rewa,Madhya Pradesh',
'Dhaurahara,Rewa,Madhya Pradesh',
'Domhai,Rewa,Madhya Pradesh',
'Gada,Rewa,Madhya Pradesh',
'Ghorkat,Rewa,Madhya Pradesh',
'Goraiya,Rewa,Madhya Pradesh',
'Hardua,Rewa,Madhya Pradesh',
'Hati,Rewa,Madhya Pradesh',
'Hatia,Rewa,Madhya Pradesh',
'Hilaundha,Rewa,Madhya Pradesh',
'Hiraundi,Rewa,Madhya Pradesh',
'Jaitwara,Rewa,Madhya Pradesh',
'Jamuani,Rewa,Madhya Pradesh',
'Jhakhaura,Rewa,Madhya Pradesh',
'Jhari,Rewa,Madhya Pradesh',
'Kailashpur,Rewa,Madhya Pradesh',
'Kalbalia,Rewa,Madhya Pradesh',
'Karigohi,Rewa,Madhya Pradesh',
'Khamaria,Rewa,Madhya Pradesh',
'Khanch,Rewa,Madhya Pradesh',
'Khohi,Rewa,Madhya Pradesh',
'Khutha,Rewa,Madhya Pradesh',
'Kitha,Rewa,Madhya Pradesh',
'Kondar,Rewa,Madhya Pradesh',
'Kotar,Rewa,Madhya Pradesh',
'Kothi,Rewa,Madhya Pradesh',
'Kripalpur Harijan Tola,Rewa,Madhya Pradesh',
'Kunwa,Rewa,Madhya Pradesh',
'Lagargawan,Rewa,Madhya Pradesh',
'Lakhanwah,Rewa,Madhya Pradesh',
'Loharaura,Rewa,Madhya Pradesh',
'M G G V chitrakoot,Rewa,Madhya Pradesh',
'Madhogarh,Rewa,Madhya Pradesh',
'Mahadeva,Rewa,Madhya Pradesh',
'Mahtain,Rewa,Madhya Pradesh',
'Majhgawa,Rewa,Madhya Pradesh',
'Majhgawan,Rewa,Madhya Pradesh',
'Mauhar,Rewa,Madhya Pradesh',
'Mednipur,Rewa,Madhya Pradesh',
'Mehuti,Rewa,Madhya Pradesh',
'Moodha,Rewa,Madhya Pradesh',
'Nakaila,Rewa,Madhya Pradesh',
'Nardaha,Rewa,Madhya Pradesh',
'Nawagaon,Rewa,Madhya Pradesh',
'Nawagaon,Rewa,Madhya Pradesh',
'Nayagaon,Rewa,Madhya Pradesh',
'Pathar Kachhar,Rewa,Madhya Pradesh',
'Patihar,Rewa,Madhya Pradesh',
'Patna,Rewa,Madhya Pradesh',
'Patura,Rewa,Madhya Pradesh',
'Pawaiya,Rewa,Madhya Pradesh',
'Pilikothi,Rewa,Madhya Pradesh',
'Pindra,Rewa,Madhya Pradesh',
'Pithurabad,Rewa,Madhya Pradesh',
'Raigaon,Rewa,Madhya Pradesh',
'Rajarwara,Rewa,Madhya Pradesh',
'Rajarwara,Rewa,Madhya Pradesh',
'Ramasthan,Rewa,Madhya Pradesh',
'Sagmania,Rewa,Madhya Pradesh',
'Sakaria,Rewa,Madhya Pradesh',
'Sarain,Rewa,Madhya Pradesh',
'Satna Birla Vikas,Rewa,Madhya Pradesh',
'Satna Civil Line,Rewa,Madhya Pradesh',
'Satna Jawahar Nagar,Rewa,Madhya Pradesh',
'Satna Kanwarnagar,Rewa,Madhya Pradesh',
'Satna Siding,Rewa,Madhya Pradesh',
'Singhpur,Rewa,Madhya Pradesh',
'Sitpura,Rewa,Madhya Pradesh',
'Sohawal,Rewa,Madhya Pradesh',
'Sukwaha,Rewa,Madhya Pradesh',
'Tighra,Rewa,Madhya Pradesh',
'Tihai,Rewa,Madhya Pradesh',
'Raipur,Rewa,Madhya Pradesh',
'Bhatnawara,Rewa,Madhya Pradesh',
'Deorikala,Rewa,Madhya Pradesh',
'Jhali,Rewa,Madhya Pradesh',
'Pagar Khurd,Rewa,Madhya Pradesh',
'Pratappur,Rewa,Madhya Pradesh',
'Rampur Gandhi Gram,Rewa,Madhya Pradesh',
'Remari,Rewa,Madhya Pradesh',
'Shahpur,Rewa,Madhya Pradesh',
'Mand,Rewa,Madhya Pradesh',
'Bakia,Rewa,Madhya Pradesh',
'Argat,Rewa,Madhya Pradesh',
'Babupur,Rewa,Madhya Pradesh',
'Barakhurd,Rewa,Madhya Pradesh',
'Belhai,Rewa,Madhya Pradesh',
'Chandwar,Rewa,Madhya Pradesh',
'Chhirhai,Rewa,Madhya Pradesh',
'Deodaha,Rewa,Madhya Pradesh',
'Dighiakala,Rewa,Madhya Pradesh',
'Ganjas,Rewa,Madhya Pradesh',
'Goraiya,Rewa,Madhya Pradesh',
'Gorhai,Rewa,Madhya Pradesh',
'Gorsari,Rewa,Madhya Pradesh',
'Govindpur,Rewa,Madhya Pradesh',
'Gulwargujara,Rewa,Madhya Pradesh',
'Harrai,Rewa,Madhya Pradesh',
'Hinauti,Rewa,Madhya Pradesh',
'Itma,Rewa,Madhya Pradesh',
'Jathaha,Rewa,Madhya Pradesh',
'Kandwari,Rewa,Madhya Pradesh',
'Karra,Rewa,Madhya Pradesh',
'Majhtolwa,Rewa,Madhya Pradesh',
'Mankisar,Rewa,Madhya Pradesh',
'Marjadpur,Rewa,Madhya Pradesh',
'Mirgauti,Rewa,Madhya Pradesh',
'New Deorajnagar,Rewa,Madhya Pradesh',
'Ramnagar,Rewa,Madhya Pradesh',
'Sagauni,Rewa,Madhya Pradesh',
'Saria,Rewa,Madhya Pradesh',
'Sonadi,Rewa,Madhya Pradesh',
'Sulkhama,Rewa,Madhya Pradesh',
'Aira,Rewa,Madhya Pradesh',
'Baheliabaht,Rewa,Madhya Pradesh',
'Bairiha,Rewa,Madhya Pradesh',
'Barti,Rewa,Madhya Pradesh',
'Bathia,Rewa,Madhya Pradesh',
'Bela,Rewa,Madhya Pradesh',
'Bihara,Rewa,Madhya Pradesh',
'Chhibaura,Rewa,Madhya Pradesh',
'Chormari,Rewa,Madhya Pradesh',
'Deomaudaldal,Rewa,Madhya Pradesh',
'Deora,Rewa,Madhya Pradesh',
'Ganjan,Rewa,Madhya Pradesh',
'Jamuna,Rewa,Madhya Pradesh',
'Janardanpur,Rewa,Madhya Pradesh',
'Jhand,Rewa,Madhya Pradesh',
'Jhinna,Rewa,Madhya Pradesh',
'Jhiriya,Rewa,Madhya Pradesh',
'Kakalpur,Rewa,Madhya Pradesh',
'Kandaila,Rewa,Madhya Pradesh',
'Krishngarh,Rewa,Madhya Pradesh',
'Mahudar,Rewa,Madhya Pradesh',
'Padkhuri,Rewa,Madhya Pradesh',
'Rampur Baghelan,Rewa,Madhya Pradesh',
'Ramvan,Rewa,Madhya Pradesh',
'Richhahari,Rewa,Madhya Pradesh',
'Semaria,Rewa,Madhya Pradesh',
'Sijehata,Rewa,Madhya Pradesh',
'Silpari,Rewa,Madhya Pradesh',
'Tapa,Rewa,Madhya Pradesh',
'Teondhari,Rewa,Madhya Pradesh',
'Karhilami,Rewa,Madhya Pradesh',
'Barethiya,Rewa,Madhya Pradesh',
'Barkheda Hasan,Sehore,Madhya Pradesh',
'Chandbad Jageer,Sehore,Madhya Pradesh',
'Charnal,Sehore,Madhya Pradesh',
'Magarda,Sehore,Madhya Pradesh',
'Aipur Ashta,Sehore,Madhya Pradesh',
'Aroliya,Sehore,Madhya Pradesh',
'Ashta Fort,Sehore,Madhya Pradesh',
'Bager,Sehore,Madhya Pradesh',
'Bamuliyabhati,Sehore,Madhya Pradesh',
'Barkheda,Sehore,Madhya Pradesh',
'Bhoura,Sehore,Madhya Pradesh',
'Chhapar,Sehore,Madhya Pradesh',
'Dabri,Sehore,Madhya Pradesh',
'Dhamnda,Sehore,Madhya Pradesh',
'Dupadiya,Sehore,Madhya Pradesh',
'Foodra,Sehore,Madhya Pradesh',
'Hakimabad,Sehore,Madhya Pradesh',
'Harrajkhedi,Sehore,Madhya Pradesh',
'Jawar,Sehore,Madhya Pradesh',
'Kannod,Sehore,Madhya Pradesh',
'Khachrod,Sehore,Madhya Pradesh',
'Khadi,Sehore,Madhya Pradesh',
'Kurawar,Sehore,Madhya Pradesh',
'Maina,Sehore,Madhya Pradesh',
'Metwada,Sehore,Madhya Pradesh',
'Mugli,Sehore,Madhya Pradesh',
'Muskara,Sehore,Madhya Pradesh',
'Siddikganj,Sehore,Madhya Pradesh',
'Aamon,Sehore,Madhya Pradesh',
'Jontala,Sehore,Madhya Pradesh',
'Nandner,Sehore,Madhya Pradesh',
'Aabidabad,Sehore,Madhya Pradesh',
'Bamulia,Sehore,Madhya Pradesh',
'Dhabla,Sehore,Madhya Pradesh',
'Heerapur,Sehore,Madhya Pradesh',
'Kulaskalan,Sehore,Madhya Pradesh',
'Uljhawan,Sehore,Madhya Pradesh',
'Veerpur Kolardem,Sehore,Madhya Pradesh',
'Bayan,Sehore,Madhya Pradesh',
'Jahajpura,Sehore,Madhya Pradesh',
'Joshipur,Sehore,Madhya Pradesh',
'Panguradiya,Sehore,Madhya Pradesh',
'Pilikarar,Sehore,Madhya Pradesh',
'Budni Ghat,Sehore,Madhya Pradesh',
'Chhatri,Sehore,Madhya Pradesh',
'Jharkheda,Sehore,Madhya Pradesh',
'Khaikheda,Sehore,Madhya Pradesh',
'Paatan,Sehore,Madhya Pradesh',
'Aarya,Sehore,Madhya Pradesh',
'Bhaukhedi,Sehore,Madhya Pradesh',
'Bishankhedi,Sehore,Madhya Pradesh',
'Bordikalan,Sehore,Madhya Pradesh',
'Brijisnagar,Sehore,Madhya Pradesh',
'Dabri,Sehore,Madhya Pradesh',
'Deevadia,Sehore,Madhya Pradesh',
'Dolatpur,Sehore,Madhya Pradesh',
'Guradi,Sehore,Madhya Pradesh',
'Jamoniya Fathepur,Sehore,Madhya Pradesh',
'Jhalki,Sehore,Madhya Pradesh',
'Kheri,Sehore,Madhya Pradesh',
'Narsinghkheda,Sehore,Madhya Pradesh',
'Semlijadid,Sehore,Madhya Pradesh',
'Torniya,Sehore,Madhya Pradesh',
'Arniyaganji,Sehore,Madhya Pradesh',
'Bhanwarikalan,Sehore,Madhya Pradesh',
'Kajlaas,Sehore,Madhya Pradesh',
'Murawar,Sehore,Madhya Pradesh',
'Bedakhedi,Sehore,Madhya Pradesh',
'Borkheda,Sehore,Madhya Pradesh',
'Chupadiya,Sehore,Madhya Pradesh',
'Gavakheda,Sehore,Madhya Pradesh',
'Lasudiakhas,Sehore,Madhya Pradesh',
'Molukhedi,Sehore,Madhya Pradesh',
'Nipaniakalan,Sehore,Madhya Pradesh',
'Baijnath,Sehore,Madhya Pradesh',
'Loraskhurd,Sehore,Madhya Pradesh',
'Sewda,Sehore,Madhya Pradesh',
'Guradiyavarma,Sehore,Madhya Pradesh',
'Gwali,Sehore,Madhya Pradesh',
'Dhoulpur,Sehore,Madhya Pradesh',
'Baibori,Sehore,Madhya Pradesh',
'Balagaon,Sehore,Madhya Pradesh',
'Basudev,Sehore,Madhya Pradesh',
'Bhadakui,Sehore,Madhya Pradesh',
'Borkheda,Sehore,Madhya Pradesh',
'Chhipaner,Sehore,Madhya Pradesh',
'Chhitgaonmoji,Sehore,Madhya Pradesh',
'Chinch,Sehore,Madhya Pradesh',
'Digwad,Sehore,Madhya Pradesh',
'Dimawar,Sehore,Madhya Pradesh',
'Gillor,Sehore,Madhya Pradesh',
'Gopalpur,Sehore,Madhya Pradesh',
'Itarshi,Sehore,Madhya Pradesh',
'Kurinayapura,Sehore,Madhya Pradesh',
'Ladkui,Sehore,Madhya Pradesh',
'Nandgaon,Sehore,Madhya Pradesh',
'Nimota,Sehore,Madhya Pradesh',
'Piplaani,Sehore,Madhya Pradesh',
'Rithwad,Sehore,Madhya Pradesh',
'Satrana,Sehore,Madhya Pradesh',
'Semalpani,Sehore,Madhya Pradesh',
'Sonthiya,Sehore,Madhya Pradesh',
'Sudamapuri,Sehore,Madhya Pradesh',
'Tiladiya,Sehore,Madhya Pradesh',
'Amirganj,Sehore,Madhya Pradesh',
'Chakaldi,Sehore,Madhya Pradesh',
'Khadli,Sehore,Madhya Pradesh',
'Kheri,Sehore,Madhya Pradesh',
'Manjharkui,Sehore,Madhya Pradesh',
'Mardanpur,Sehore,Madhya Pradesh',
'Salkanpur,Sehore,Madhya Pradesh',
'Semrikatkuna,Sehore,Madhya Pradesh',
'Soyat,Sehore,Madhya Pradesh',
'Ahmedpur,Sehore,Madhya Pradesh',
'Amlaha,Sehore,Madhya Pradesh',
'Ashta,Sehore,Madhya Pradesh',
'Badiyakhedi,Sehore,Madhya Pradesh',
'Baktal,Sehore,Madhya Pradesh',
'Baktara,Sehore,Madhya Pradesh',
'Bijlone,Sehore,Madhya Pradesh',
'Bijori,Sehore,Madhya Pradesh',
'Bilkisganj,Sehore,Madhya Pradesh',
'Budhni T.N.,Sehore,Madhya Pradesh',
'Doraha,Sehore,Madhya Pradesh',
'Hasnabad,Sehore,Madhya Pradesh',
'Ichawar,Sehore,Madhya Pradesh',
'Janpur Bavdiya,Sehore,Madhya Pradesh',
'Jatakheda,Sehore,Madhya Pradesh',
'Khamaliya,Sehore,Madhya Pradesh',
'Kotri,Sehore,Madhya Pradesh',
'Mahodiya,Sehore,Madhya Pradesh',
'Mograram,Sehore,Madhya Pradesh',
'Mundlakhurd,Sehore,Madhya Pradesh',
'Mungavli,Sehore,Madhya Pradesh',
'Naplakhedi,Sehore,Madhya Pradesh',
'Nasrllaganj,Sehore,Madhya Pradesh',
'Nipaniya,Sehore,Madhya Pradesh',
'Pachama,Sehore,Madhya Pradesh',
'Rehti,Sehore,Madhya Pradesh',
'Sehore City,Sehore,Madhya Pradesh',
'Sehore Englishpura,Sehore,Madhya Pradesh',
'Sehore Ganjbajariya,Sehore,Madhya Pradesh',
'Sehore H.O,Sehore,Madhya Pradesh',
'Sehore Mandi,Sehore,Madhya Pradesh',
'Sehore Rak,Sehore,Madhya Pradesh',
'Sehore Town,Sehore,Madhya Pradesh',
'Semradangi,Sehore,Madhya Pradesh',
'Shahganj,Sehore,Madhya Pradesh',
'Shyampur,Sehore,Madhya Pradesh',
'Akola,Sehore,Madhya Pradesh',
'Baneta,Sehore,Madhya Pradesh',
'Dobi,Sehore,Madhya Pradesh',
'Dungariya,Sehore,Madhya Pradesh',
'Jawaharkheda,Sehore,Madhya Pradesh',
'Paraswada,Sehore,Madhya Pradesh',
'Sardarnagar,Sehore,Madhya Pradesh',
'Bairagarhkhuman,Sehore,Madhya Pradesh',
'Kachnariya,Sehore,Madhya Pradesh',
'Khajuriyakalan,Sehore,Madhya Pradesh',
'Khandwa,Sehore,Madhya Pradesh',
'Muktarnagar,Sehore,Madhya Pradesh',
'Siradi,Sehore,Madhya Pradesh',
'Sonthi,Sehore,Madhya Pradesh',
'Dhuradakalan,Sehore,Madhya Pradesh',
'Jasmat,Sehore,Madhya Pradesh',
'Khajuriya Kasam,Sehore,Madhya Pradesh',
'Nougaon,Sehore,Madhya Pradesh',
'Amagarh,Balaghat,Madhya Pradesh',
'Antara,Balaghat,Madhya Pradesh',
'Ashta,Balaghat,Madhya Pradesh',
'Atari,Balaghat,Madhya Pradesh',
'Bamhani,Balaghat,Madhya Pradesh',
'Barghat,Balaghat,Madhya Pradesh',
'Behrai,Balaghat,Madhya Pradesh',
'Birholi,Balaghat,Madhya Pradesh',
'Borikala,Balaghat,Madhya Pradesh',
'Budhenakala,Balaghat,Madhya Pradesh',
'Darasikala,Balaghat,Madhya Pradesh',
'Dhapara,Balaghat,Madhya Pradesh',
'Dhobisarra,Balaghat,Madhya Pradesh',
'Dondiwada,Balaghat,Madhya Pradesh',
'Gokalpur,Balaghat,Madhya Pradesh',
'Gondegaon,Balaghat,Madhya Pradesh',
'Jeonara,Balaghat,Madhya Pradesh',
'Kekdai,Balaghat,Madhya Pradesh',
'Kesalekala,Balaghat,Madhya Pradesh',
'Khunt,Balaghat,Madhya Pradesh',
'Malara,Balaghat,Madhya Pradesh',
'Nandora,Balaghat,Madhya Pradesh',
'Nayegaon,Balaghat,Madhya Pradesh',
'Neewari,Balaghat,Madhya Pradesh',
'Pindraikala,Balaghat,Madhya Pradesh',
'Poniya,Balaghat,Madhya Pradesh',
'Salhe-khurd,Balaghat,Madhya Pradesh',
'Salhekosmi,Balaghat,Madhya Pradesh',
'Sukla,Balaghat,Madhya Pradesh',
'Takalakala,Balaghat,Madhya Pradesh',
'Tekari,Balaghat,Madhya Pradesh',
'Borikala,Balaghat,Madhya Pradesh',
'Dharnakala,Balaghat,Madhya Pradesh',
'Kindarai,Balaghat,Madhya Pradesh',
'Ataria,Balaghat,Madhya Pradesh',
'Balpur,Balaghat,Madhya Pradesh',
'Barela,Balaghat,Madhya Pradesh',
'Barelaghat,Balaghat,Madhya Pradesh',
'Baroda,Balaghat,Madhya Pradesh',
'Bewhari,Balaghat,Madhya Pradesh',
'Diwari,Balaghat,Madhya Pradesh',
'Ganeri,Balaghat,Madhya Pradesh',
'Ghansore,Balaghat,Madhya Pradesh',
'Ghatpipariya,Balaghat,Madhya Pradesh',
'Ghotkheda,Balaghat,Madhya Pradesh',
'Hardoli,Balaghat,Madhya Pradesh',
'Jhurki,Balaghat,Madhya Pradesh',
'Kahani,Balaghat,Madhya Pradesh',
'Kedarpur,Balaghat,Madhya Pradesh',
'Khamaria Bazar,Balaghat,Madhya Pradesh',
'Khatiya,Balaghat,Madhya Pradesh',
'Kudari Maghgaon,Balaghat,Madhya Pradesh',
'Manegaon,Balaghat,Madhya Pradesh',
'Mehta,Balaghat,Madhya Pradesh',
'Paddikona,Balaghat,Madhya Pradesh',
'Pahadi,Balaghat,Madhya Pradesh',
'Piparia Bhasunda,Balaghat,Madhya Pradesh',
'Sajpani-dhanora,Balaghat,Madhya Pradesh',
'Salhepani,Balaghat,Madhya Pradesh',
'Sikara,Balaghat,Madhya Pradesh',
'Sunwara,Balaghat,Madhya Pradesh',
'Baghai,Balaghat,Madhya Pradesh',
'Baglai,Balaghat,Madhya Pradesh',
'Banathar,Balaghat,Madhya Pradesh',
'Bandeli,Balaghat,Madhya Pradesh',
'Chhinda,Balaghat,Madhya Pradesh',
'Dhutera,Balaghat,Madhya Pradesh',
'Dobh,Balaghat,Madhya Pradesh',
'Durenda,Balaghat,Madhya Pradesh',
'Gangatola,Balaghat,Madhya Pradesh',
'Gwaria,Balaghat,Madhya Pradesh',
'Jewnara,Balaghat,Madhya Pradesh',
'Jhittarra,Balaghat,Madhya Pradesh',
'Keolari Kheda,Balaghat,Madhya Pradesh',
'Keolari,Balaghat,Madhya Pradesh',
'Khairapalari,Balaghat,Madhya Pradesh',
'Khairlanji,Balaghat,Madhya Pradesh',
'Khami,Balaghat,Madhya Pradesh',
'Khapa Bazar,Balaghat,Madhya Pradesh',
'Kharsaru,Balaghat,Madhya Pradesh',
'Khursara,Balaghat,Madhya Pradesh',
'Kohka,Balaghat,Madhya Pradesh',
'Kumhada,Balaghat,Madhya Pradesh',
'Lopa,Balaghat,Madhya Pradesh',
'Mohbarra,Balaghat,Madhya Pradesh',
'Pandiwada,Balaghat,Madhya Pradesh',
'Pandiya Chhapara,Balaghat,Madhya Pradesh',
'Panjara,Balaghat,Madhya Pradesh',
'Pipariya Kala,Balaghat,Madhya Pradesh',
'Rumal,Balaghat,Madhya Pradesh',
'Sakri,Balaghat,Madhya Pradesh',
'Sarekha,Balaghat,Madhya Pradesh',
'Sarekha Kala,Balaghat,Madhya Pradesh',
'Sonkhar,Balaghat,Madhya Pradesh',
'Tali,Balaghat,Madhya Pradesh',
'Tinduwa,Balaghat,Madhya Pradesh',
'Ugli,Balaghat,Madhya Pradesh',
'Chandarpur,Balaghat,Madhya Pradesh',
'Khandasa,Balaghat,Madhya Pradesh',
'Khawasa,Balaghat,Madhya Pradesh',
'Korai,Balaghat,Madhya Pradesh',
'Patan,Balaghat,Madhya Pradesh',
'Pindrai,Balaghat,Madhya Pradesh',
'Pindrai- Buttey,Balaghat,Madhya Pradesh',
'Piparwani,Balaghat,Madhya Pradesh',
'Ramli,Balaghat,Madhya Pradesh',
'Riddi,Balaghat,Madhya Pradesh',
'Turia,Balaghat,Madhya Pradesh',
'Anjania,Balaghat,Madhya Pradesh',
'Baigapiparia,Balaghat,Madhya Pradesh',
'Bakoda Seoni,Balaghat,Madhya Pradesh',
'Bhimgarh,Balaghat,Madhya Pradesh',
'Bhimgarh Project,Balaghat,Madhya Pradesh',
'Chhapara,Balaghat,Madhya Pradesh',
'Deogaon,Balaghat,Madhya Pradesh',
'Deori,Balaghat,Madhya Pradesh',
'Ghurwara,Balaghat,Madhya Pradesh',
'Gohana,Balaghat,Madhya Pradesh',
'Khut-khamaria,Balaghat,Madhya Pradesh',
'Nagandeori,Balaghat,Madhya Pradesh',
'Sadak Seoni,Balaghat,Madhya Pradesh',
'Sanaidongari,Balaghat,Madhya Pradesh',
'Adegaon,Balaghat,Madhya Pradesh',
'Bamhanwada,Balaghat,Madhya Pradesh',
'Banjari,Balaghat,Madhya Pradesh',
'Chamari(khurd),Balaghat,Madhya Pradesh',
'Dankakadi,Balaghat,Madhya Pradesh',
'Dargada,Balaghat,Madhya Pradesh',
'Deorikala,Balaghat,Madhya Pradesh',
'Dhuma,Balaghat,Madhya Pradesh',
'Ganesh Ganj,Balaghat,Madhya Pradesh',
'Gangai,Balaghat,Madhya Pradesh',
'Gorakhpur,Balaghat,Madhya Pradesh',
'Gorakhpur,Balaghat,Madhya Pradesh',
'Imaliya Raitwar,Balaghat,Madhya Pradesh',
'Jhiri,Balaghat,Madhya Pradesh',
'Karanpur,Balaghat,Madhya Pradesh',
'Kareli,Balaghat,Madhya Pradesh',
'Khairnara,Balaghat,Madhya Pradesh',
'Khamaria Gosai,Balaghat,Madhya Pradesh',
'Lakhnadon,Balaghat,Madhya Pradesh',
'Madhi,Balaghat,Madhya Pradesh',
'Mohgaon Kachhi,Balaghat,Madhya Pradesh',
'Mohgaon Kala,Balaghat,Madhya Pradesh',
'Parasiya,Balaghat,Madhya Pradesh',
'Patan,Balaghat,Madhya Pradesh',
'Pathadeori,Balaghat,Madhya Pradesh',
'Purwamal,Balaghat,Madhya Pradesh',
'Sihora,Balaghat,Madhya Pradesh',
'Sirmangani,Balaghat,Madhya Pradesh',
'Aloniya,Balaghat,Madhya Pradesh',
'Amgaon,Balaghat,Madhya Pradesh',
'Ari,Balaghat,Madhya Pradesh',
'Babaira,Balaghat,Madhya Pradesh',
'Badalpar,Balaghat,Madhya Pradesh',
'Bakhari,Balaghat,Madhya Pradesh',
'Bakodi,Balaghat,Madhya Pradesh',
'Bamhodi,Balaghat,Madhya Pradesh',
'Bandol,Balaghat,Madhya Pradesh',
'Banki,Balaghat,Madhya Pradesh',
'Belpeth,Balaghat,Madhya Pradesh',
'Bhoma,Balaghat,Madhya Pradesh',
'Bhongakheda,Balaghat,Madhya Pradesh',
'Binjhawada,Balaghat,Madhya Pradesh',
'Bordai,Balaghat,Madhya Pradesh',
'Chakki Khamariya,Balaghat,Madhya Pradesh',
'Chandori(khurd),Balaghat,Madhya Pradesh',
'Chawadi,Balaghat,Madhya Pradesh',
'Chhindbarri,Balaghat,Madhya Pradesh',
'Chhui,Balaghat,Madhya Pradesh',
'Chutka,Balaghat,Madhya Pradesh',
'Dhobisarra,Balaghat,Madhya Pradesh',
'Dighori,Balaghat,Madhya Pradesh',
'Dokarranjhi,Balaghat,Madhya Pradesh',
'Fulara,Balaghat,Madhya Pradesh',
'Gopalganj,Balaghat,Madhya Pradesh',
'Hathnapur,Balaghat,Madhya Pradesh',
'Hinotiya,Balaghat,Madhya Pradesh',
'Jaitpur Kala,Balaghat,Madhya Pradesh',
'Jam,Balaghat,Madhya Pradesh',
'Kalarbanki,Balaghat,Madhya Pradesh',
'Kanhan Piparia,Balaghat,Madhya Pradesh',
'Kanhiwada,Balaghat,Madhya Pradesh',
'Karirat,Balaghat,Madhya Pradesh',
'Marbodi,Balaghat,Madhya Pradesh',
'Mugwani Kala,Balaghat,Madhya Pradesh',
'Palari-chhidiya,Balaghat,Madhya Pradesh',
'Pipardahi,Balaghat,Madhya Pradesh',
'Piparia Bhoma,Balaghat,Madhya Pradesh',
'Pondi-jaharmau,Balaghat,Madhya Pradesh',
'Rajola,Balaghat,Madhya Pradesh',
'Seoni Barapathar,Balaghat,Madhya Pradesh',
'Seoni Budhwari Bazar,Balaghat,Madhya Pradesh',
'Seoni City,Balaghat,Madhya Pradesh',
'Seoni H.O,Balaghat,Madhya Pradesh',
'Sillore,Balaghat,Madhya Pradesh',
'Sindaria,Balaghat,Madhya Pradesh',
'Suktara,Balaghat,Madhya Pradesh',
'Tighra,Balaghat,Madhya Pradesh',
'Udepani,Balaghat,Madhya Pradesh',
'Vijaypani,Balaghat,Madhya Pradesh',
'Akhetpur,Shahdol,Madhya Pradesh',
'Bakeli Colloney,Shahdol,Madhya Pradesh',
'Bansagar,Shahdol,Madhya Pradesh',
'Barachh,Shahdol,Madhya Pradesh',
'Baraundha,Shahdol,Madhya Pradesh',
'Barkachh,Shahdol,Madhya Pradesh',
'Basahi,Shahdol,Madhya Pradesh',
'Beohari,Shahdol,Madhya Pradesh',
'Bhamraha,Shahdol,Madhya Pradesh',
'Bhanni,Shahdol,Madhya Pradesh',
'Bholhara,Shahdol,Madhya Pradesh',
'Bijha,Shahdol,Madhya Pradesh',
'Budwa,Shahdol,Madhya Pradesh',
'Chachai,Shahdol,Madhya Pradesh',
'Chauri,Shahdol,Madhya Pradesh',
'Chhuhi,Shahdol,Madhya Pradesh',
'Dhari No. 2,Shahdol,Madhya Pradesh',
'Dhondha,Shahdol,Madhya Pradesh',
'Jagmal,Shahdol,Madhya Pradesh',
'Janakpur,Shahdol,Madhya Pradesh',
'Khadda,Shahdol,Madhya Pradesh',
'Kharpa,Shahdol,Madhya Pradesh',
'Kuan,Shahdol,Madhya Pradesh',
'Mau,Shahdol,Madhya Pradesh',
'Naudhiya,Shahdol,Madhya Pradesh',
'Papaudh,Shahdol,Madhya Pradesh',
'Papaundh,Shahdol,Madhya Pradesh',
'Papderi,Shahdol,Madhya Pradesh',
'Pathrehi,Shahdol,Madhya Pradesh',
'Pondireusa,Shahdol,Madhya Pradesh',
'Saman,Shahdol,Madhya Pradesh',
'Sapta,Shahdol,Madhya Pradesh',
'Sarsi,Shahdol,Madhya Pradesh',
'Tagawar,Shahdol,Madhya Pradesh',
'Tihki,Shahdol,Madhya Pradesh',
'Tikhwa,Shahdol,Madhya Pradesh',
'Chuhiri,Shahdol,Madhya Pradesh',
'Deogarh,Shahdol,Madhya Pradesh',
'Jaitpur,Shahdol,Madhya Pradesh',
'Kadaudi,Shahdol,Madhya Pradesh',
'Khairahni,Shahdol,Madhya Pradesh',
'Kolhua,Shahdol,Madhya Pradesh',
'Kudeli,Shahdol,Madhya Pradesh',
'Lafda,Shahdol,Madhya Pradesh',
'Rasmohni,Shahdol,Madhya Pradesh',
'Sakhi,Shahdol,Madhya Pradesh',
'Tikuri,Shahdol,Madhya Pradesh',
'Uchehra,Shahdol,Madhya Pradesh',
'Amdih,Shahdol,Madhya Pradesh',
'Amjhor,Shahdol,Madhya Pradesh',
'Bansa,Shahdol,Madhya Pradesh',
'Bansukli,Shahdol,Madhya Pradesh',
'Chhakta,Shahdol,Madhya Pradesh',
'Chitraon,Shahdol,Madhya Pradesh',
'Darain,Shahdol,Madhya Pradesh',
'Deora,Shahdol,Madhya Pradesh',
'Giruibadi,Shahdol,Madhya Pradesh',
'Jaisinghnagar,Shahdol,Madhya Pradesh',
'Kanadikhurd,Shahdol,Madhya Pradesh',
'Karki,Shahdol,Madhya Pradesh',
'Khand,Shahdol,Madhya Pradesh',
'Kubra,Shahdol,Madhya Pradesh',
'Masira,Shahdol,Madhya Pradesh',
'Mithi,Shahdol,Madhya Pradesh',
'Nagnaudi,Shahdol,Madhya Pradesh',
'Sidhi,Shahdol,Madhya Pradesh',
'Thengreha,Shahdol,Madhya Pradesh',
'Khurkhuridadar,Shahdol,Madhya Pradesh',
'Patasi,Shahdol,Madhya Pradesh',
'Amlai Paper Mills,Shahdol,Madhya Pradesh',
'Amraha,Shahdol,Madhya Pradesh',
'Aswari,Shahdol,Madhya Pradesh',
'Bandhwabada,Shahdol,Madhya Pradesh',
'Bareli,Shahdol,Madhya Pradesh',
'Barkoda,Shahdol,Madhya Pradesh',
'Bartara,Shahdol,Madhya Pradesh',
'Bemhori,Shahdol,Madhya Pradesh',
'Bhuibandh,Shahdol,Madhya Pradesh',
'Biruhli,Shahdol,Madhya Pradesh',
'Bodri,Shahdol,Madhya Pradesh',
'Burhar,Shahdol,Madhya Pradesh',
'Chandela,Shahdol,Madhya Pradesh',
'Channaudi,Shahdol,Madhya Pradesh',
'Deori,Shahdol,Madhya Pradesh',
'Dhanpuri Colliery,Shahdol,Madhya Pradesh',
'Dhanpuri,Shahdol,Madhya Pradesh',
'Dhurwar,Shahdol,Madhya Pradesh',
'Diyapipar,Shahdol,Madhya Pradesh',
'Gohparu,Shahdol,Madhya Pradesh',
'Jodhpur,Shahdol,Madhya Pradesh',
'Karkat,Shahdol,Madhya Pradesh',
'Karkati,Shahdol,Madhya Pradesh',
'Kathautia,Shahdol,Madhya Pradesh',
'Khairaha,Shahdol,Madhya Pradesh',
'Khannaudhi,Shahdol,Madhya Pradesh',
'Kudri,Shahdol,Madhya Pradesh',
'Lalpur,Shahdol,Madhya Pradesh',
'Lodi,Shahdol,Madhya Pradesh',
'Malmathar,Shahdol,Madhya Pradesh',
'Mithori,Shahdol,Madhya Pradesh',
'Nawalpur,Shahdol,Madhya Pradesh',
'Nawangaon,Shahdol,Madhya Pradesh',
'Pachgaon,Shahdol,Madhya Pradesh',
'Padmaniakhurd,Shahdol,Madhya Pradesh',
'Pailwah,Shahdol,Madhya Pradesh',
'Palsau,Shahdol,Madhya Pradesh',
'Pongari,Shahdol,Madhya Pradesh',
'Rajendranagar Colony,Shahdol,Madhya Pradesh',
'Rungta Colliery,Shahdol,Madhya Pradesh',
'Samatpur,Shahdol,Madhya Pradesh',
'Saraikapa,Shahdol,Madhya Pradesh',
'Senduri,Shahdol,Madhya Pradesh',
'Shahdol Bus Stand,Shahdol,Madhya Pradesh',
'Shahdol Ganesh Ganj,Shahdol,Madhya Pradesh',
'Shahdol Gharola,Shahdol,Madhya Pradesh',
'Shahdol H.O,Shahdol,Madhya Pradesh',
'Shahdol R.S.,Shahdol,Madhya Pradesh',
'Singhpur,Shahdol,Madhya Pradesh',
'Sohagpur,Shahdol,Madhya Pradesh',
'Tetki,Shahdol,Madhya Pradesh',
'Pathratha,Shahdol,Madhya Pradesh',
'Agar Malwa,Ujjain,Madhya Pradesh',
'Bapcha,Ujjain,Madhya Pradesh',
'Bijanagri,Ujjain,Madhya Pradesh',
'Biyana,Ujjain,Madhya Pradesh',
'Gata,Ujjain,Madhya Pradesh',
'Ghurasiya,Ujjain,Madhya Pradesh',
'Lala,Ujjain,Madhya Pradesh',
'Mahudiya,Ujjain,Madhya Pradesh',
'Malwasa,Ujjain,Madhya Pradesh',
'Nipaniabajnath,Ujjain,Madhya Pradesh',
'Nipaniya Hanuman,Ujjain,Madhya Pradesh',
'Palda,Ujjain,Madhya Pradesh',
'Palkhedi,Ujjain,Madhya Pradesh',
'Piploankala,Ujjain,Madhya Pradesh',
'Sirpoi,Ujjain,Madhya Pradesh',
'Tanodiya,Ujjain,Madhya Pradesh',
'Akodia,Ujjain,Madhya Pradesh',
'Bhaisrod,Ujjain,Madhya Pradesh',
'Hadlaya Kala,Ujjain,Madhya Pradesh',
'Kethlay,Ujjain,Madhya Pradesh',
'Mohmmadkheda,Ujjain,Madhya Pradesh',
'Patlawada,Ujjain,Madhya Pradesh',
'Polaikhrud,Ujjain,Madhya Pradesh',
'Ranibarod,Ujjain,Madhya Pradesh',
'Uchod,Ujjain,Madhya Pradesh',
'Awantipur Barodia,Ujjain,Madhya Pradesh',
'Amba,Ujjain,Madhya Pradesh',
'Bapcha,Ujjain,Madhya Pradesh',
'Barode,Ujjain,Madhya Pradesh',
'Jhalara,Ujjain,Madhya Pradesh',
'Lotiakrishna,Ujjain,Madhya Pradesh',
'Madkota,Ujjain,Madhya Pradesh',
'Barodia Kumaria,Ujjain,Madhya Pradesh',
'Burlay,Ujjain,Madhya Pradesh',
'Burnavad,Ujjain,Madhya Pradesh',
'Dudhana,Ujjain,Madhya Pradesh',
'Karju,Ujjain,Madhya Pradesh',
'Khoriaama,Ujjain,Madhya Pradesh',
'Kumariakhas,Ujjain,Madhya Pradesh',
'Mandoda,Ujjain,Madhya Pradesh',
'Mohana,Ujjain,Madhya Pradesh',
'Nipaniyakarju,Ujjain,Madhya Pradesh',
'Tikon,Ujjain,Madhya Pradesh',
'Bardiason,Ujjain,Madhya Pradesh',
'Berchha,Ujjain,Madhya Pradesh',
'Choslakulmi,Ujjain,Madhya Pradesh',
'Dendla,Ujjain,Madhya Pradesh',
'Khoria Nayta,Ujjain,Madhya Pradesh',
'Ranth Bhanwar,Ujjain,Madhya Pradesh',
'Tilawad Govind,Ujjain,Madhya Pradesh',
'Amlay,Ujjain,Madhya Pradesh',
'Chakrod,Ujjain,Madhya Pradesh',
'Dhabla Ghosi,Ujjain,Madhya Pradesh',
'Jamner,Ujjain,Madhya Pradesh',
'Panch Dehria,Ujjain,Madhya Pradesh',
'Siloda,Ujjain,Madhya Pradesh',
'Behraval,Ujjain,Madhya Pradesh',
'Berchha Datar,Ujjain,Madhya Pradesh',
'Bhuria Khajuria,Ujjain,Madhya Pradesh',
'Dhabla Dheer,Ujjain,Madhya Pradesh',
'Farad,Ujjain,Madhya Pradesh',
'Jabdiya Bheel,Ujjain,Madhya Pradesh',
'Kalapipal Gaon,Ujjain,Madhya Pradesh',
'Kalapipal,Ujjain,Madhya Pradesh',
'Kamalpur,Ujjain,Madhya Pradesh',
'Khamlya,Ujjain,Madhya Pradesh',
'Lasuldiya Gori,Ujjain,Madhya Pradesh',
'Lasuldiya Malak,Ujjain,Madhya Pradesh',
'Mansaya,Ujjain,Madhya Pradesh',
'Nandni,Ujjain,Madhya Pradesh',
'Pipliyanagar,Ujjain,Madhya Pradesh',
'Pochaner,Ujjain,Madhya Pradesh',
'Ranayal,Ujjain,Madhya Pradesh',
'Ugli,Ujjain,Madhya Pradesh',
'Bolai,Ujjain,Madhya Pradesh',
'Dasta Khedi,Ujjain,Madhya Pradesh',
'Devla Bihar,Ujjain,Madhya Pradesh',
'Ghunsi,Ujjain,Madhya Pradesh',
'Gulana,Ujjain,Madhya Pradesh',
'Kalisindh,Ujjain,Madhya Pradesh',
'Ladavad,Ujjain,Madhya Pradesh',
'Lahori,Ujjain,Madhya Pradesh',
'Bijnakhedi,Ujjain,Madhya Pradesh',
'Choma Dak Bangla,Ujjain,Madhya Pradesh',
'Hargankhedi,Ujjain,Madhya Pradesh',
'Kanad,Ujjain,Madhya Pradesh',
'Kohadiya,Ujjain,Madhya Pradesh',
'Mathurakhedi,Ujjain,Madhya Pradesh',
'Pachlana,Ujjain,Madhya Pradesh',
'Shivgarh,Ujjain,Madhya Pradesh',
'Bhaisaygarh,Ujjain,Madhya Pradesh',
'Khardonkala,Ujjain,Madhya Pradesh',
'Khardonkhurd,Ujjain,Madhya Pradesh',
'Khokra Kalan,Ujjain,Madhya Pradesh',
'Mohammadpur Machnai,Ujjain,Madhya Pradesh',
'Semliya,Ujjain,Madhya Pradesh',
'Jhokar,Ujjain,Madhya Pradesh',
'Kapaliya,Ujjain,Madhya Pradesh',
'Maksi,Ujjain,Madhya Pradesh',
'Badagaon,Ujjain,Madhya Pradesh',
'Bhandavad,Ujjain,Madhya Pradesh',
'Bhesoda,Ujjain,Madhya Pradesh',
'Dharola,Ujjain,Madhya Pradesh',
'Gondalmau,Ujjain,Madhya Pradesh',
'Goyla,Ujjain,Madhya Pradesh',
'Nalkheda,Ujjain,Madhya Pradesh',
'Pilwas,Ujjain,Madhya Pradesh',
'Pipliaset,Ujjain,Madhya Pradesh',
'Suigaon,Ujjain,Madhya Pradesh',
'Takhala,Ujjain,Madhya Pradesh',
'Binaya,Ujjain,Madhya Pradesh',
'Devli,Ujjain,Madhya Pradesh',
'Khatsur,Ujjain,Madhya Pradesh',
'Mortakhevdi,Ujjain,Madhya Pradesh',
'Pagrawadkalan,Ujjain,Madhya Pradesh',
'Polai Kalan,Ujjain,Madhya Pradesh',
'Chitawad,Ujjain,Madhya Pradesh',
'Kadwala,Ujjain,Madhya Pradesh',
'Kevda Khedi,Ujjain,Madhya Pradesh',
'Killoda,Ujjain,Madhya Pradesh',
'Loharkheda,Ujjain,Madhya Pradesh',
'Madana,Ujjain,Madhya Pradesh',
'Manglaj,Ujjain,Madhya Pradesh',
'Salsalai,Ujjain,Madhya Pradesh',
'Abhaypur,Ujjain,Madhya Pradesh',
'Ala Umrod,Ujjain,Madhya Pradesh',
'Bharad,Ujjain,Madhya Pradesh',
'Bijana,Ujjain,Madhya Pradesh',
'Dhillod,Ujjain,Madhya Pradesh',
'Dupada,Ujjain,Madhya Pradesh',
'Gopipur,Ujjain,Madhya Pradesh',
'Morta,Ujjain,Madhya Pradesh',
'Panwadi,Ujjain,Madhya Pradesh',
'Sajod,Ujjain,Madhya Pradesh',
'Shajapur H.O,Ujjain,Madhya Pradesh',
'Sunhera,Ujjain,Madhya Pradesh',
'Shajapur Town,Ujjain,Madhya Pradesh',
'Shajapur Kutchery,Ujjain,Madhya Pradesh',
'Shujalpur City,Ujjain,Madhya Pradesh',
'Alisiriya,Ujjain,Madhya Pradesh',
'Arniya Kalan,Ujjain,Madhya Pradesh',
'Arniya Khurd,Ujjain,Madhya Pradesh',
'Bhilkhedi,Ujjain,Madhya Pradesh',
'Dehandi,Ujjain,Madhya Pradesh',
'Mayapur Mangrola,Ujjain,Madhya Pradesh',
'Padliya,Ujjain,Madhya Pradesh',
'Raipur,Ujjain,Madhya Pradesh',
'Rolakhedi,Ujjain,Madhya Pradesh',
'Shujalpur Mandi,Ujjain,Madhya Pradesh',
'Tilawadmena,Ujjain,Madhya Pradesh',
'Dehriyakulmi,Ujjain,Madhya Pradesh',
'Dogargaon,Ujjain,Madhya Pradesh',
'Loharia,Ujjain,Madhya Pradesh',
'Saliakhedi,Ujjain,Madhya Pradesh',
'Soyat Khurd,Ujjain,Madhya Pradesh',
'Soyat Kalan,Ujjain,Madhya Pradesh',
'Khadi,Ujjain,Madhya Pradesh',
'Makodi,Ujjain,Madhya Pradesh',
'Nipania Dhakar,Ujjain,Madhya Pradesh',
'Simrol,Ujjain,Madhya Pradesh',
'Sundersi,Ujjain,Madhya Pradesh',
'Amla,Ujjain,Madhya Pradesh',
'Barda Raoji,Ujjain,Madhya Pradesh',
'Chhapariya,Ujjain,Madhya Pradesh',
'Gangapur,Ujjain,Madhya Pradesh',
'Gelana,Ujjain,Madhya Pradesh',
'Laturi Gehlot,Ujjain,Madhya Pradesh',
'Modi,Ujjain,Madhya Pradesh',
'Payli,Ujjain,Madhya Pradesh',
'Semalkhedi,Ujjain,Madhya Pradesh',
'Shyampura,Ujjain,Madhya Pradesh',
'Susner,Ujjain,Madhya Pradesh',
'Bijaipur,Morena,Madhya Pradesh',
'Agra,Morena,Madhya Pradesh',
'Arrod,Morena,Madhya Pradesh',
'Bagord,Morena,Madhya Pradesh',
'Balawani,Morena,Madhya Pradesh',
'Beerpur,Morena,Madhya Pradesh',
'Chimalwani,Morena,Madhya Pradesh',
'Dhondha,Morena,Madhya Pradesh',
'Dord,Morena,Madhya Pradesh',
'Gadi,Morena,Madhya Pradesh',
'Gaswani,Morena,Madhya Pradesh',
'Ghunghas,Morena,Madhya Pradesh',
'Gohar,Morena,Madhya Pradesh',
'Gohta,Morena,Madhya Pradesh',
'Heerapura,Morena,Madhya Pradesh',
'Iklod,Morena,Madhya Pradesh',
'Kathon,Morena,Madhya Pradesh',
'Kemarakalan,Morena,Madhya Pradesh',
'Magrdha,Morena,Madhya Pradesh',
'Ochhapura,Morena,Madhya Pradesh',
'Palpur,Morena,Madhya Pradesh',
'Raghunathpur,Morena,Madhya Pradesh',
'Sahasram,Morena,Madhya Pradesh',
'Shyampur,Morena,Madhya Pradesh',
'Tarra Kalan,Morena,Madhya Pradesh',
'Asida,Morena,Madhya Pradesh',
'Awada,Morena,Madhya Pradesh',
'Bagadiya,Morena,Madhya Pradesh',
'Bargawan,Morena,Madhya Pradesh',
'Bukhari,Morena,Madhya Pradesh',
'Chambal Colony Sheopur,Morena,Madhya Pradesh',
'Dantarda Kalan,Morena,Madhya Pradesh',
'Dhondhar,Morena,Madhya Pradesh',
'Filozpura,Morena,Madhya Pradesh',
'Girdharpur,Morena,Madhya Pradesh',
'Goras,Morena,Madhya Pradesh',
'Gurunaawda,Morena,Madhya Pradesh',
'Jaida Mandi,Morena,Madhya Pradesh',
'Jaini,Morena,Madhya Pradesh',
'Jalalpura,Morena,Madhya Pradesh',
'Javasa,Morena,Madhya Pradesh',
'Javdeshwar,Morena,Madhya Pradesh',
'Kalarna,Morena,Madhya Pradesh',
'Kanapur,Morena,Madhya Pradesh',
'Karhal,Morena,Madhya Pradesh',
'Khirkhiri,Morena,Madhya Pradesh',
'Makdawadakalan,Morena,Madhya Pradesh',
'Manpur,Morena,Madhya Pradesh',
'Nagda,Morena,Madhya Pradesh',
'Pada,Morena,Madhya Pradesh',
'Pandola,Morena,Madhya Pradesh',
'Premsar,Morena,Madhya Pradesh',
'Randep,Morena,Madhya Pradesh',
'Ratodhan,Morena,Madhya Pradesh',
'Sarsai,Morena,Madhya Pradesh',
'Sheopur Baroda,Morena,Madhya Pradesh',
'Sheopur,Morena,Madhya Pradesh',
'Silpuri,Morena,Madhya Pradesh',
'Soi Kalan,Morena,Madhya Pradesh',
'Sonthwa,Morena,Madhya Pradesh',
'Sunswada,Morena,Madhya Pradesh',
'Tillipur,Morena,Madhya Pradesh',
'Tulsef,Morena,Madhya Pradesh',
'Udhotpura,Morena,Madhya Pradesh',
'Algi,Guna,Madhya Pradesh',
'Amola,Guna,Madhya Pradesh',
'Badhora,Guna,Madhya Pradesh',
'Bangawan,Guna,Madhya Pradesh',
'Bansgarh,Guna,Madhya Pradesh',
'Behgawa,Guna,Madhya Pradesh',
'Bhansda Khurd,Guna,Madhya Pradesh',
'Bilhari,Guna,Madhya Pradesh',
'Chhitipur,Guna,Madhya Pradesh',
'Chhitri,Guna,Madhya Pradesh',
'Chinod,Guna,Madhya Pradesh',
'Dabarbhat,Guna,Madhya Pradesh',
'Dabra Dinara,Guna,Madhya Pradesh',
'Damron Kalan,Guna,Madhya Pradesh',
'Dhand,Guna,Madhya Pradesh',
'Dhihala,Guna,Madhya Pradesh',
'Dinara,Guna,Madhya Pradesh',
'Doni,Guna,Madhya Pradesh',
'Himmatpur,Guna,Madhya Pradesh',
'Jhanda,Guna,Madhya Pradesh',
'Kalipahadi Mathure,Guna,Madhya Pradesh',
'Karahi,Guna,Madhya Pradesh',
'Karera,Guna,Madhya Pradesh',
'Karotha,Guna,Madhya Pradesh',
'Khadicha,Guna,Madhya Pradesh',
'Khudawli,Guna,Madhya Pradesh',
'Kuchlon,Guna,Madhya Pradesh',
'Lalpur,Guna,Madhya Pradesh',
'Lamkana,Guna,Madhya Pradesh',
'Machaoli,Guna,Madhya Pradesh',
'Mungaoli,Guna,Madhya Pradesh',
'Narahi,Guna,Madhya Pradesh',
'Papredu,Guna,Madhya Pradesh',
'Sad,Guna,Madhya Pradesh',
'Salaiya,Guna,Madhya Pradesh',
'Salaiya Damron,Guna,Madhya Pradesh',
'Samoha,Guna,Madhya Pradesh',
'Sehdora,Guna,Madhya Pradesh',
'Silanagar,Guna,Madhya Pradesh',
'Sunari,Guna,Madhya Pradesh',
'T.C.Karera,Guna,Madhya Pradesh',
'Teela,Guna,Madhya Pradesh',
'Thanra,Guna,Madhya Pradesh',
'Achhroni,Guna,Madhya Pradesh',
'Bamorkalan,Guna,Madhya Pradesh',
'Bharsula,Guna,Madhya Pradesh',
'Bijrawan,Guna,Madhya Pradesh',
'Dabia Jagan,Guna,Madhya Pradesh',
'Deokho,Guna,Madhya Pradesh',
'Gudar,Guna,Madhya Pradesh',
'Kafar,Guna,Madhya Pradesh',
'Kali Pahari,Guna,Madhya Pradesh',
'Khaniyadhana,Guna,Madhya Pradesh',
'Khirkit,Guna,Madhya Pradesh',
'Kumhrraondi,Guna,Madhya Pradesh',
'Kyara,Guna,Madhya Pradesh',
'Mehroli,Guna,Madhya Pradesh',
'Muhari,Guna,Madhya Pradesh',
'Pipra,Guna,Madhya Pradesh',
'Pura,Guna,Madhya Pradesh',
'Sila Nagar,Guna,Madhya Pradesh',
'Sinawalkala,Guna,Madhya Pradesh',
'Aijwara,Guna,Madhya Pradesh',
'Akajhiri,Guna,Madhya Pradesh',
'Amhara,Guna,Madhya Pradesh',
'Atalpur,Guna,Madhya Pradesh',
'Badarwas,Guna,Madhya Pradesh',
'Bamore,Guna,Madhya Pradesh',
'Bamore Kalan,Guna,Madhya Pradesh',
'Barai,Guna,Madhya Pradesh',
'Barod,Guna,Madhya Pradesh',
'Benhta,Guna,Madhya Pradesh',
'Bhadauta,Guna,Madhya Pradesh',
'Bijroni,Guna,Madhya Pradesh',
'Budadongar,Guna,Madhya Pradesh',
'Deharwara,Guna,Madhya Pradesh',
'Dehrog,Guna,Madhya Pradesh',
'Endar,Guna,Madhya Pradesh',
'Ganeshkjeda,Guna,Madhya Pradesh',
'Jagatpur,Guna,Madhya Pradesh',
'Karya,Guna,Madhya Pradesh',
'Kharai,Guna,Madhya Pradesh',
'Khareh,Guna,Madhya Pradesh',
'Khatora,Guna,Madhya Pradesh',
'Kilawani,Guna,Madhya Pradesh',
'Kolaras,Guna,Madhya Pradesh',
'Kutwara,Guna,Madhya Pradesh',
'Lewa,Guna,Madhya Pradesh',
'Lukwasa,Guna,Madhya Pradesh',
'Mada,Guna,Madhya Pradesh',
'Madwasa,Guna,Madhya Pradesh',
'Mathna,Guna,Madhya Pradesh',
'Mohra,Guna,Madhya Pradesh',
'Pachaoli,Guna,Madhya Pradesh',
'Padora,Guna,Madhya Pradesh',
'Pahada Khurd,Guna,Madhya Pradesh',
'Peeronth,Guna,Madhya Pradesh',
'Rai,Guna,Madhya Pradesh',
'Rajgarh,Guna,Madhya Pradesh',
'Ramgarh,Guna,Madhya Pradesh',
'Rannod,Guna,Madhya Pradesh',
'Sajai,Guna,Madhya Pradesh',
'Sakhnor,Guna,Madhya Pradesh',
'Sesai,Guna,Madhya Pradesh',
'Sunaj,Guna,Madhya Pradesh',
'Veera,Guna,Madhya Pradesh',
'Amolpatha,Guna,Madhya Pradesh',
'Dhigwas,Guna,Madhya Pradesh',
'Hateda,Guna,Madhya Pradesh',
'Jujhai,Guna,Madhya Pradesh',
'Kalipahadi Meda,Guna,Madhya Pradesh',
'Kanker,Guna,Madhya Pradesh',
'Magroni,Guna,Madhya Pradesh',
'Mohini,Guna,Madhya Pradesh',
'Naraua,Guna,Madhya Pradesh',
'Narwar,Guna,Madhya Pradesh',
'Rampur Dhamkan,Guna,Madhya Pradesh',
'Sehore,Guna,Madhya Pradesh',
'Shergarh,Guna,Madhya Pradesh',
'Tharkheda,Guna,Madhya Pradesh',
'Badarwas,Guna,Madhya Pradesh',
'Badera,Guna,Madhya Pradesh',
'Bamore Damron,Guna,Madhya Pradesh',
'Bhonti,Guna,Madhya Pradesh',
'Budhonrajapur,Guna,Madhya Pradesh',
'Chhirwaha,Guna,Madhya Pradesh',
'Dabiakala,Guna,Madhya Pradesh',
'Dargawa,Guna,Madhya Pradesh',
'Deokheda,Guna,Madhya Pradesh',
'Dhala,Guna,Madhya Pradesh',
'Gajora,Guna,Madhya Pradesh',
'Ganeshkheda,Guna,Madhya Pradesh',
'Garentha,Guna,Madhya Pradesh',
'Harinagar,Guna,Madhya Pradesh',
'Kachhauwa,Guna,Madhya Pradesh',
'Kakraua Thuni,Guna,Madhya Pradesh',
'Karar Kheda,Guna,Madhya Pradesh',
'Kherwas,Guna,Madhya Pradesh',
'Khod,Guna,Madhya Pradesh',
'Labheda,Guna,Madhya Pradesh',
'Malaoni,Guna,Madhya Pradesh',
'Manpura,Guna,Madhya Pradesh',
'Nand,Guna,Madhya Pradesh',
'Naoli,Guna,Madhya Pradesh',
'Pichhore,Guna,Madhya Pradesh',
'Pipal Kheda,Guna,Madhya Pradesh',
'Pipra Pichhore,Guna,Madhya Pradesh',
'Pipro,Guna,Madhya Pradesh',
'Piproda Ubari,Guna,Madhya Pradesh',
'Rahi,Guna,Madhya Pradesh',
'Rewai,Guna,Madhya Pradesh',
'Semri,Guna,Madhya Pradesh',
'Sirsaud,Guna,Madhya Pradesh',
'Sonher,Guna,Madhya Pradesh',
'Umri Kala,Guna,Madhya Pradesh',
'Ainchwara,Guna,Madhya Pradesh',
'Bagwasa,Guna,Madhya Pradesh',
'Bamra,Guna,Madhya Pradesh',
'Berad,Guna,Madhya Pradesh',
'Bhatnawar,Guna,Madhya Pradesh',
'Bhesrawan,Guna,Madhya Pradesh',
'Bilwara Mata,Guna,Madhya Pradesh',
'Burda,Guna,Madhya Pradesh',
'Chakrana,Guna,Madhya Pradesh',
'Chharch,Guna,Madhya Pradesh',
'Dulhara,Guna,Madhya Pradesh',
'Gajigarh,Guna,Madhya Pradesh',
'Galthuni,Guna,Madhya Pradesh',
'Gondari,Guna,Madhya Pradesh',
'Gopalpura,Guna,Madhya Pradesh',
'Jhiri,Guna,Madhya Pradesh',
'Jorai,Guna,Madhya Pradesh',
'Kakraua,Guna,Madhya Pradesh',
'Kharai Jalim,Guna,Madhya Pradesh',
'Khatka,Guna,Madhya Pradesh',
'Mahadeva,Guna,Madhya Pradesh',
'Mehloni,Guna,Madhya Pradesh',
'Nadora,Guna,Madhya Pradesh',
'Parichha,Guna,Madhya Pradesh',
'Piparghar,Guna,Madhya Pradesh',
'Pohari,Guna,Madhya Pradesh',
'Ranthkheda,Guna,Madhya Pradesh',
'Bamhari,Guna,Madhya Pradesh',
'Bara,Guna,Madhya Pradesh',
'Barodi Sadak,Guna,Madhya Pradesh',
'Bhangarh,Guna,Madhya Pradesh',
'Chak Kamalpur,Guna,Madhya Pradesh',
'Collectorate Bhawan Shiv,Guna,Madhya Pradesh',
'Dholagarh,Guna,Madhya Pradesh',
'Gangora,Guna,Madhya Pradesh',
'Garibarod,Guna,Madhya Pradesh',
'I.T.B.P Shivpuri,Guna,Madhya Pradesh',
'Kanker,Guna,Madhya Pradesh',
'Karmaj Kalan,Guna,Madhya Pradesh',
'Karsena,Guna,Madhya Pradesh',
'Katthamil Shivpuri,Guna,Madhya Pradesh',
'Khandi,Guna,Madhya Pradesh',
'Khorghar,Guna,Madhya Pradesh',
'Kota,Guna,Madhya Pradesh',
'Kunwarpur,Guna,Madhya Pradesh',
'Munderi,Guna,Madhya Pradesh',
'Piparsama,Guna,Madhya Pradesh',
'Raishree,Guna,Madhya Pradesh',
'Satanwada,Guna,Madhya Pradesh',
'Shivprui City,Guna,Madhya Pradesh',
'Shivpuri H.O,Guna,Madhya Pradesh',
'Singhniwas,Guna,Madhya Pradesh',
'Sirsaud,Guna,Madhya Pradesh',
'Subhashpura,Guna,Madhya Pradesh',
'Surwaya,Guna,Madhya Pradesh',
'Tharra Darroni,Guna,Madhya Pradesh',
'Theh,Guna,Madhya Pradesh',
'Tongra,Guna,Madhya Pradesh',
'V.R.Colony Shivpuri,Guna,Madhya Pradesh',
'Jhagrauha,Shahdol,Madhya Pradesh',
'Badkud,Shahdol,Madhya Pradesh',
'Bairdah,Shahdol,Madhya Pradesh',
'Bardi,Shahdol,Madhya Pradesh',
'Chitrangi,Shahdol,Madhya Pradesh',
'Deora,Shahdol,Madhya Pradesh',
'Dharauli,Shahdol,Madhya Pradesh',
'Dudhmania,Shahdol,Madhya Pradesh',
'Gangi,Shahdol,Madhya Pradesh',
'Ghoghra,Shahdol,Madhya Pradesh',
'Gondwali,Shahdol,Madhya Pradesh',
'Gopla,Shahdol,Madhya Pradesh',
'Gorbi,Shahdol,Madhya Pradesh',
'Karaila,Shahdol,Madhya Pradesh',
'Karthua,Shahdol,Madhya Pradesh',
'Keontali,Shahdol,Madhya Pradesh',
'Khaidar,Shahdol,Madhya Pradesh',
'Khatai,Shahdol,Madhya Pradesh',
'Khurmucha,Shahdol,Madhya Pradesh',
'Korsar,Shahdol,Madhya Pradesh',
'Lamsarai,Shahdol,Madhya Pradesh',
'Misirgrawan,Shahdol,Madhya Pradesh',
'Naikahwa,Shahdol,Madhya Pradesh',
'Pachaur,Shahdol,Madhya Pradesh',
'Pateri,Shahdol,Madhya Pradesh',
'Pipra,Shahdol,Madhya Pradesh',
'Pokhra,Shahdol,Madhya Pradesh',
'Rajabar,Shahdol,Madhya Pradesh',
'Sakaria,Shahdol,Madhya Pradesh',
'Suda,Shahdol,Madhya Pradesh',
'Badhaura,Shahdol,Madhya Pradesh',
'Badkhara,Shahdol,Madhya Pradesh',
'Badokhar,Shahdol,Madhya Pradesh',
'Baghaun,Shahdol,Madhya Pradesh',
'Chakdaur,Shahdol,Madhya Pradesh',
'Churhat,Shahdol,Madhya Pradesh',
'Dadhia,Shahdol,Madhya Pradesh',
'Dhanha,Shahdol,Madhya Pradesh',
'Dihuli,Shahdol,Madhya Pradesh',
'Hanumangarh,Shahdol,Madhya Pradesh',
'Hatwakhas,Shahdol,Madhya Pradesh',
'Jhalwar,Shahdol,Madhya Pradesh',
'Kamarjee,Shahdol,Madhya Pradesh',
'Kapuri,Shahdol,Madhya Pradesh',
'Karaundia,Shahdol,Madhya Pradesh',
'Kolhudih,Shahdol,Madhya Pradesh',
'Kushmahar,Shahdol,Madhya Pradesh',
'Kuspari,Shahdol,Madhya Pradesh',
'Lakauda,Shahdol,Madhya Pradesh',
'Mawai,Shahdol,Madhya Pradesh',
'Mohania,Shahdol,Madhya Pradesh',
'Pachokhar,Shahdol,Madhya Pradesh',
'Salaiya,Shahdol,Madhya Pradesh',
'Sanda,Shahdol,Madhya Pradesh',
'Semaria Pondi,Shahdol,Madhya Pradesh',
'Tikatkala,Shahdol,Madhya Pradesh',
'Ukarha,Shahdol,Madhya Pradesh',
'Jiawan,Shahdol,Madhya Pradesh',
'Sarai,Shahdol,Madhya Pradesh',
'Saraundha,Shahdol,Madhya Pradesh',
'Tingudi,Shahdol,Madhya Pradesh',
'Chandwar,Shahdol,Madhya Pradesh',
'Chatainiha,Shahdol,Madhya Pradesh',
'Darbari,Shahdol,Madhya Pradesh',
'Dhonga,Shahdol,Madhya Pradesh',
'Geer,Shahdol,Madhya Pradesh',
'Jhakhrawal,Shahdol,Madhya Pradesh',
'Purail,Shahdol,Madhya Pradesh',
'Amarpur,Shahdol,Madhya Pradesh',
'Amarwah,Shahdol,Madhya Pradesh',
'Baghwari,Shahdol,Madhya Pradesh',
'Bamhani,Shahdol,Madhya Pradesh',
'Bamuri,Shahdol,Madhya Pradesh',
'Banjari,Shahdol,Madhya Pradesh',
'Barambaba,Shahdol,Madhya Pradesh',
'Barbandha,Shahdol,Madhya Pradesh',
'Belha,Shahdol,Madhya Pradesh',
'Chandwahi,Shahdol,Madhya Pradesh',
'Chaufal,Shahdol,Madhya Pradesh',
'Deogawan,Shahdol,Madhya Pradesh',
'Gadababan Singh,Shahdol,Madhya Pradesh',
'Hadbado,Shahdol,Madhya Pradesh',
'Jamuar,Shahdol,Madhya Pradesh',
'Khoh Gandhi Gram,Shahdol,Madhya Pradesh',
'Khuteli,Shahdol,Madhya Pradesh',
'Kochila,Shahdol,Madhya Pradesh',
'Kubri,Shahdol,Madhya Pradesh',
'Kuchwahi,Shahdol,Madhya Pradesh',
'Kukrijhar,Shahdol,Madhya Pradesh',
'Laua,Shahdol,Madhya Pradesh',
'Madwa,Shahdol,Madhya Pradesh',
'Mahrajpur,Shahdol,Madhya Pradesh',
'Nakjhar,Shahdol,Madhya Pradesh',
'Naudhiya,Shahdol,Madhya Pradesh',
'Padainia,Shahdol,Madhya Pradesh',
'Padkhuri,Shahdol,Madhya Pradesh',
'Padri,Shahdol,Madhya Pradesh',
'Panwar,Shahdol,Madhya Pradesh',
'Paraswar,Shahdol,Madhya Pradesh',
'Patulkhi,Shahdol,Madhya Pradesh',
'Piprohar,Shahdol,Madhya Pradesh',
'Pokhra,Shahdol,Madhya Pradesh',
'Sarda,Shahdol,Madhya Pradesh',
'Tarka,Shahdol,Madhya Pradesh',
'Upni,Shahdol,Madhya Pradesh',
'Sidhi Bus Stand,Shahdol,Madhya Pradesh',
'Sidhi Collectorate,Shahdol,Madhya Pradesh',
'Sidhi H.O,Shahdol,Madhya Pradesh',
'Banjari,Shahdol,Madhya Pradesh',
'Barka,Shahdol,Madhya Pradesh',
'Barmani,Shahdol,Madhya Pradesh',
'Bhadaura,Shahdol,Madhya Pradesh',
'Bhagohar,Shahdol,Madhya Pradesh',
'Bhuimad,Shahdol,Madhya Pradesh',
'Chamradol,Shahdol,Madhya Pradesh',
'Chingwah,Shahdol,Madhya Pradesh',
'Danga,Shahdol,Madhya Pradesh',
'Dhauhani,Shahdol,Madhya Pradesh',
'Gajri,Shahdol,Madhya Pradesh',
'Gijwar,Shahdol,Madhya Pradesh',
'Jhara,Shahdol,Madhya Pradesh',
'Juri,Shahdol,Madhya Pradesh',
'Kamachh,Shahdol,Madhya Pradesh',
'Karda,Shahdol,Madhya Pradesh',
'Karmai,Shahdol,Madhya Pradesh',
'Karwahi,Shahdol,Madhya Pradesh',
'Khadaura,Shahdol,Madhya Pradesh',
'Kota,Shahdol,Madhya Pradesh',
'Kusmi,Shahdol,Madhya Pradesh',
'Lurghuti,Shahdol,Madhya Pradesh',
'Madwas,Shahdol,Madhya Pradesh',
'Mahkhor,Shahdol,Madhya Pradesh',
'Mahuagaon,Shahdol,Madhya Pradesh',
'Majauli,Shahdol,Madhya Pradesh',
'Medra,Shahdol,Madhya Pradesh',
'Naudhiya,Shahdol,Madhya Pradesh',
'Nigri,Shahdol,Madhya Pradesh',
'Niwas,Shahdol,Madhya Pradesh',
'Pand,Shahdol,Madhya Pradesh',
'Pathraula,Shahdol,Madhya Pradesh',
'Pondi Bastua,Shahdol,Madhya Pradesh',
'Pondi Jodauri,Shahdol,Madhya Pradesh',
'Rajaniya,Shahdol,Madhya Pradesh',
'Saleha,Shahdol,Madhya Pradesh',
'Tala,Shahdol,Madhya Pradesh',
'Tansar,Shahdol,Madhya Pradesh',
'Tikri,Shahdol,Madhya Pradesh',
'Umaria,Shahdol,Madhya Pradesh',
'Amiliha,Shahdol,Madhya Pradesh',
'Amlai,Shahdol,Madhya Pradesh',
'Bagad,Shahdol,Madhya Pradesh',
'Baghwar,Shahdol,Madhya Pradesh',
'Bharatpur,Shahdol,Madhya Pradesh',
'Bhitri,Shahdol,Madhya Pradesh',
'Budgauna,Shahdol,Madhya Pradesh',
'Chorgadhi,Shahdol,Madhya Pradesh',
'Gordaha,Shahdol,Madhya Pradesh',
'Gujder,Shahdol,Madhya Pradesh',
'Jhanjh,Shahdol,Madhya Pradesh',
'Kandhwar,Shahdol,Madhya Pradesh',
'Khaddi,Shahdol,Madhya Pradesh',
'Kudia,Shahdol,Madhya Pradesh',
'Madha,Shahdol,Madhya Pradesh',
'Mamdar,Shahdol,Madhya Pradesh',
'Maura,Shahdol,Madhya Pradesh',
'Naikin,Shahdol,Madhya Pradesh',
'Patna,Shahdol,Madhya Pradesh',
'Raghunathpur,Shahdol,Madhya Pradesh',
'Raiduaria,Shahdol,Madhya Pradesh',
'Rampur Naikin,Shahdol,Madhya Pradesh',
'Amilia,Shahdol,Madhya Pradesh',
'Baghor,Shahdol,Madhya Pradesh',
'Bamuri,Shahdol,Madhya Pradesh',
'Bichhi,Shahdol,Madhya Pradesh',
'Bithauli,Shahdol,Madhya Pradesh',
'Chitwaria,Shahdol,Madhya Pradesh',
'Ghoghra,Shahdol,Madhya Pradesh',
'Hinauti,Shahdol,Madhya Pradesh',
'Karauli Khurd,Shahdol,Madhya Pradesh',
'Kodaura,Shahdol,Madhya Pradesh',
'Kulakwar,Shahdol,Madhya Pradesh',
'Pahadi,Shahdol,Madhya Pradesh',
'Sihawal,Shahdol,Madhya Pradesh',
'Sonbarsha,Shahdol,Madhya Pradesh',
'Sudwar,Shahdol,Madhya Pradesh',
'Supela,Shahdol,Madhya Pradesh',
'Teekar,Shahdol,Madhya Pradesh',
'Amlori Project,Shahdol,Madhya Pradesh',
'Nigahi Project,Shahdol,Madhya Pradesh',
'Singrauli Colliery,Shahdol,Madhya Pradesh',
'Vindhyanagar,Shahdol,Madhya Pradesh',
'Waidhan,Shahdol,Madhya Pradesh',
'Bandha,Shahdol,Madhya Pradesh',
'Bindul,Shahdol,Madhya Pradesh',
'Churkee,Shahdol,Madhya Pradesh',
'Daga Bargawan,Shahdol,Madhya Pradesh',
'Dudhichua Project,Shahdol,Madhya Pradesh',
'Jamgadhi,Shahdol,Madhya Pradesh',
'Jarha,Shahdol,Madhya Pradesh',
'Jhingurdah,Shahdol,Madhya Pradesh',
'Kachnimamla,Shahdol,Madhya Pradesh',
'Karsualal,Shahdol,Madhya Pradesh',
'Khanua,Shahdol,Madhya Pradesh',
'Khutar,Shahdol,Madhya Pradesh',
'Mada,Shahdol,Madhya Pradesh',
'Makrohar,Shahdol,Madhya Pradesh',
'Odgadi,Shahdol,Madhya Pradesh',
'Pachaur,Shahdol,Madhya Pradesh',
'Piprakhurand,Shahdol,Madhya Pradesh',
'Pondi Naugai,Shahdol,Madhya Pradesh',
'Rajmilan,Shahdol,Madhya Pradesh',
'Shahpur,Shahdol,Madhya Pradesh',
'Singrauli R.S.,Shahdol,Madhya Pradesh',
'Tiyara,Shahdol,Madhya Pradesh',
'Jayant Colliery,Shahdol,Madhya Pradesh',
'Ahar,Chhatarpur,Madhya Pradesh',
'Airora,Chhatarpur,Madhya Pradesh',
'Bachhoda,Chhatarpur,Madhya Pradesh',
'Baisa,Chhatarpur,Madhya Pradesh',
'Baldeogarh,Chhatarpur,Madhya Pradesh',
'Barmadang,Chhatarpur,Madhya Pradesh',
'Bhelsi,Chhatarpur,Madhya Pradesh',
'Bijron,Chhatarpur,Madhya Pradesh',
'Budera,Chhatarpur,Madhya Pradesh',
'Darguwan,Chhatarpur,Madhya Pradesh',
'Dewarda,Chhatarpur,Madhya Pradesh',
'Dhamanakha,Chhatarpur,Madhya Pradesh',
'Digoda,Chhatarpur,Madhya Pradesh',
'Dikoli Chowk,Chhatarpur,Madhya Pradesh',
'Gukhrai,Chhatarpur,Madhya Pradesh',
'Hatta,Chhatarpur,Madhya Pradesh',
'Kailpura,Chhatarpur,Madhya Pradesh',
'Nanhitehtri,Chhatarpur,Madhya Pradesh',
'Narayanpura,Chhatarpur,Madhya Pradesh',
'Nayagaon,Chhatarpur,Madhya Pradesh',
'Ramnagar,Chhatarpur,Madhya Pradesh',
'Ranipura,Chhatarpur,Madhya Pradesh',
'Sujanpura,Chhatarpur,Madhya Pradesh',
'Bamhorikala,Chhatarpur,Madhya Pradesh',
'Berwarkhas,Chhatarpur,Madhya Pradesh',
'Chandera,Chhatarpur,Madhya Pradesh',
'Jarua,Chhatarpur,Madhya Pradesh',
'Jatara,Chhatarpur,Madhya Pradesh',
'Kalera,Chhatarpur,Madhya Pradesh',
'Kanera,Chhatarpur,Madhya Pradesh',
'Karmora,Chhatarpur,Madhya Pradesh',
'Muhara,Chhatarpur,Madhya Pradesh',
'Nibora,Chhatarpur,Madhya Pradesh',
'Pahadibujurg,Chhatarpur,Madhya Pradesh',
'Paitpura,Chhatarpur,Madhya Pradesh',
'Ramgarh,Chhatarpur,Madhya Pradesh',
'Sagarwara,Chhatarpur,Madhya Pradesh',
'Shah,Chhatarpur,Madhya Pradesh',
'Banne Bujraj,Chhatarpur,Madhya Pradesh',
'Bhanpura,Chhatarpur,Madhya Pradesh',
'Chandpura,Chhatarpur,Madhya Pradesh',
'Chaubara,Chhatarpur,Madhya Pradesh',
'Chhidari,Chhatarpur,Madhya Pradesh',
'Deri,Chhatarpur,Madhya Pradesh',
'Dohochak,Chhatarpur,Madhya Pradesh',
'Future,Chhatarpur,Madhya Pradesh',
'Gona,Chhatarpur,Madhya Pradesh',
'Gora,Chhatarpur,Madhya Pradesh',
'Hirapur,Chhatarpur,Madhya Pradesh',
'J.M. Khargapur,Chhatarpur,Madhya Pradesh',
'Khargapur,Chhatarpur,Madhya Pradesh',
'Kudila,Chhatarpur,Madhya Pradesh',
'Malguwn,Chhatarpur,Madhya Pradesh',
'Matol,Chhatarpur,Madhya Pradesh',
'Pathrguwa,Chhatarpur,Madhya Pradesh',
'Purenia,Chhatarpur,Madhya Pradesh',
'Ramnagar,Chhatarpur,Madhya Pradesh',
'Sarkanpur,Chhatarpur,Madhya Pradesh',
'Sijora,Chhatarpur,Madhya Pradesh',
'Asati,Chhatarpur,Madhya Pradesh',
'Binwara,Chhatarpur,Madhya Pradesh',
'Gidkhini,Chhatarpur,Madhya Pradesh',
'Harsmau,Chhatarpur,Madhya Pradesh',
'Kulua,Chhatarpur,Madhya Pradesh',
'Mudara,Chhatarpur,Madhya Pradesh',
'Pohakhas,Chhatarpur,Madhya Pradesh',
'Bangain,Chhatarpur,Madhya Pradesh',
'Barsoba,Chhatarpur,Madhya Pradesh',
'Bhelsa,Chhatarpur,Madhya Pradesh',
'Chakarpur,Chhatarpur,Madhya Pradesh',
'Dhilla,Chhatarpur,Madhya Pradesh',
'Jugiyai,Chhatarpur,Madhya Pradesh',
'Madore,Chhatarpur,Madhya Pradesh',
'Mohanpura,Chhatarpur,Madhya Pradesh',
'Orchha,Chhatarpur,Madhya Pradesh',
'Sunoniya,Chhatarpur,Madhya Pradesh',
'Kachhora,Chhatarpur,Madhya Pradesh',
'Alampura,Chhatarpur,Madhya Pradesh',
'Barana,Chhatarpur,Madhya Pradesh',
'Budore,Chhatarpur,Madhya Pradesh',
'Deoraha,Chhatarpur,Madhya Pradesh',
'Ghoorakhas,Chhatarpur,Madhya Pradesh',
'Gona,Chhatarpur,Madhya Pradesh',
'Gurha,Chhatarpur,Madhya Pradesh',
'Laron,Chhatarpur,Madhya Pradesh',
'Magrai,Chhatarpur,Madhya Pradesh',
'Mawai,Chhatarpur,Madhya Pradesh',
'Pali,Chhatarpur,Madhya Pradesh',
'Para,Chhatarpur,Madhya Pradesh',
'Pratappura,Chhatarpur,Madhya Pradesh',
'Smarakhurd,Chhatarpur,Madhya Pradesh',
'Tahanga,Chhatarpur,Madhya Pradesh',
'Toriya,Chhatarpur,Madhya Pradesh',
'Palera,Chhatarpur,Madhya Pradesh',
'Nuna,Chhatarpur,Madhya Pradesh',
'Acharra,Chhatarpur,Madhya Pradesh',
'Ajnore,Chhatarpur,Madhya Pradesh',
'Amarpur,Chhatarpur,Madhya Pradesh',
'Astari,Chhatarpur,Madhya Pradesh',
'Aston,Chhatarpur,Madhya Pradesh',
'Badagaon,Chhatarpur,Madhya Pradesh',
'Bahera,Chhatarpur,Madhya Pradesh',
'Bamhori Bar,Chhatarpur,Madhya Pradesh',
'Bandha,Chhatarpur,Madhya Pradesh',
'Banjaripura,Chhatarpur,Madhya Pradesh',
'Barethi Kala,Chhatarpur,Madhya Pradesh',
'Barethikhas,Chhatarpur,Madhya Pradesh',
'Bari,Chhatarpur,Madhya Pradesh',
'Bhadurpur,Chhatarpur,Madhya Pradesh',
'Bhitari,Chhatarpur,Madhya Pradesh',
'Bhopalpur,Chhatarpur,Madhya Pradesh',
'Bijore,Chhatarpur,Madhya Pradesh',
'Birorakhet,Chhatarpur,Madhya Pradesh',
'Birsagar,Chhatarpur,Madhya Pradesh',
'Chomokhas,Chhatarpur,Madhya Pradesh',
'Daretha,Chhatarpur,Madhya Pradesh',
'Dhajrai,Chhatarpur,Madhya Pradesh',
'Dumduma,Chhatarpur,Madhya Pradesh',
'Dunda,Chhatarpur,Madhya Pradesh',
'Ghoogsi,Chhatarpur,Madhya Pradesh',
'Gor,Chhatarpur,Madhya Pradesh',
'Guawali,Chhatarpur,Madhya Pradesh',
'Hiranagar,Chhatarpur,Madhya Pradesh',
'Iqbal Pura,Chhatarpur,Madhya Pradesh',
'Jeoramora,Chhatarpur,Madhya Pradesh',
'Jer,Chhatarpur,Madhya Pradesh',
'Jerakhas,Chhatarpur,Madhya Pradesh',
'Jeron,Chhatarpur,Madhya Pradesh',
'Jewaha,Chhatarpur,Madhya Pradesh',
'Jikhanguwan,Chhatarpur,Madhya Pradesh',
'Judawan,Chhatarpur,Madhya Pradesh',
'Kachhiyaguda,Chhatarpur,Madhya Pradesh',
'Kakarwaha,Chhatarpur,Madhya Pradesh',
'Kakwni,Chhatarpur,Madhya Pradesh',
'Karikhas,Chhatarpur,Madhya Pradesh',
'Khera,Chhatarpur,Madhya Pradesh',
'Kheron,Chhatarpur,Madhya Pradesh',
'Khiriya Naka,Chhatarpur,Madhya Pradesh',
'Khiston,Chhatarpur,Madhya Pradesh',
'Kudar,Chhatarpur,Madhya Pradesh',
'Kumarra,Chhatarpur,Madhya Pradesh',
'Kundshwer,Chhatarpur,Madhya Pradesh',
'Ladwari,Chhatarpur,Madhya Pradesh',
'Lar,Chhatarpur,Madhya Pradesh',
'Lidhora,Chhatarpur,Madhya Pradesh',
'Loharguwn,Chhatarpur,Madhya Pradesh',
'Mabai,Chhatarpur,Madhya Pradesh',
'Madia,Chhatarpur,Madhya Pradesh',
'Maharajpur,Chhatarpur,Madhya Pradesh',
'Mahobachak,Chhatarpur,Madhya Pradesh',
'Majna,Chhatarpur,Madhya Pradesh',
'Marguwna,Chhatarpur,Madhya Pradesh',
'Master Mogna,Chhatarpur,Madhya Pradesh',
'Mogna,Chhatarpur,Madhya Pradesh',
'Mohangarh,Chhatarpur,Madhya Pradesh',
'Naguwan,Chhatarpur,Madhya Pradesh',
'Nandanwara,Chhatarpur,Madhya Pradesh',
'Narguda,Chhatarpur,Madhya Pradesh',
'Niwari,Chhatarpur,Madhya Pradesh',
'Pahadi Tilwalran,Chhatarpur,Madhya Pradesh',
'Papawani,Chhatarpur,Madhya Pradesh',
'Papora,Chhatarpur,Madhya Pradesh',
'Patha,Chhatarpur,Madhya Pradesh',
'Patharam,Chhatarpur,Madhya Pradesh',
'Prithvipur,Chhatarpur,Madhya Pradesh',
'Puchikarguwan,Chhatarpur,Madhya Pradesh',
'Sakerabhadaran,Chhatarpur,Madhya Pradesh',
'Saktibheron,Chhatarpur,Madhya Pradesh',
'Samarra,Chhatarpur,Madhya Pradesh',
'Sapon,Chhatarpur,Madhya Pradesh',
'Satguwa,Chhatarpur,Madhya Pradesh',
'Sendri,Chhatarpur,Madhya Pradesh',
'Simra,Chhatarpur,Madhya Pradesh',
'Siyawanikha,Chhatarpur,Madhya Pradesh',
'Sunderpur,Chhatarpur,Madhya Pradesh',
'Taricharkala,Chhatarpur,Madhya Pradesh',
'Teharka,Chhatarpur,Madhya Pradesh',
'Thona,Chhatarpur,Madhya Pradesh',
'Tikamgarh City,Chhatarpur,Madhya Pradesh',
'Tikamgarh Coll,Chhatarpur,Madhya Pradesh',
'Tikamgarh H.O,Chhatarpur,Madhya Pradesh',
'Tikamgarh P.T,Chhatarpur,Madhya Pradesh',
'Ubora,Chhatarpur,Madhya Pradesh',
'Umari,Chhatarpur,Madhya Pradesh',
'Uparakhas,Chhatarpur,Madhya Pradesh',
'Baledi,Ujjain,Madhya Pradesh',
'Akasoda,Ujjain,Madhya Pradesh',
'Amla,Ujjain,Madhya Pradesh',
'Asawata,Ujjain,Madhya Pradesh',
'Bamnapati,Ujjain,Madhya Pradesh',
'Bangred,Ujjain,Madhya Pradesh',
'Barnagar Bunglow,Ujjain,Madhya Pradesh',
'Barnagar,Ujjain,Madhya Pradesh',
'Barnagar Town,Ujjain,Madhya Pradesh',
'Birakhedi,Ujjain,Madhya Pradesh',
'Chikli,Ujjain,Madhya Pradesh',
'Dangwada,Ujjain,Madhya Pradesh',
'Ghudawan,Ujjain,Madhya Pradesh',
'Harnawada,Ujjain,Madhya Pradesh',
'Ingoria,Ujjain,Madhya Pradesh',
'Jalodia,Ujjain,Madhya Pradesh',
'Khandoda,Ujjain,Madhya Pradesh',
'Kharsod Khurd,Ujjain,Madhya Pradesh',
'Lohana,Ujjain,Madhya Pradesh',
'Molana,Ujjain,Madhya Pradesh',
'Nalva,Ujjain,Madhya Pradesh',
'Nimboda,Ujjain,Madhya Pradesh',
'Palduna,Ujjain,Madhya Pradesh',
'Peerjhalar,Ujjain,Madhya Pradesh',
'Piplu,Ujjain,Madhya Pradesh',
'Sijavta,Ujjain,Madhya Pradesh',
'Bhatpachlana,Ujjain,Madhya Pradesh',
'Birlagram Nagda,Ujjain,Madhya Pradesh',
'Bolasa,Ujjain,Madhya Pradesh',
'Chandesara,Ujjain,Madhya Pradesh',
'Dhabla Hardu,Ujjain,Madhya Pradesh',
'Dungarkheda,Ujjain,Madhya Pradesh',
'Ghattia,Ujjain,Madhya Pradesh',
'Ghonsla,Ujjain,Madhya Pradesh',
'Jagoti,Ujjain,Madhya Pradesh',
'Jalwa,Ujjain,Madhya Pradesh',
'Jhitarkhedi,Ujjain,Madhya Pradesh',
'Kachnariya,Ujjain,Madhya Pradesh',
'Kadoudiya,Ujjain,Madhya Pradesh',
'Keson,Ujjain,Madhya Pradesh',
'Mahudi,Ujjain,Madhya Pradesh',
'Malikhedi,Ujjain,Madhya Pradesh',
'Matana Kalan,Ujjain,Madhya Pradesh',
'Nanded,Ujjain,Madhya Pradesh',
'Nauganwa,Ujjain,Madhya Pradesh',
'Nazarpur,Ujjain,Madhya Pradesh',
'Parsoli,Ujjain,Madhya Pradesh',
'Pat,Ujjain,Madhya Pradesh',
'Piploda Dwarkadhish,Ujjain,Madhya Pradesh',
'Roopakhedi,Ujjain,Madhya Pradesh',
'Tulaheda,Ujjain,Madhya Pradesh',
'Ujjainiya,Ujjain,Madhya Pradesh',
'Jharda,Ujjain,Madhya Pradesh',
'Kanasia,Ujjain,Madhya Pradesh',
'Akya Jagir,Ujjain,Madhya Pradesh',
'Banbana,Ujjain,Madhya Pradesh',
'Barkheda Pitramal,Ujjain,Madhya Pradesh',
'Batlawdi,Ujjain,Madhya Pradesh',
'Bhainsoda,Ujjain,Madhya Pradesh',
'Bhatisuda,Ujjain,Madhya Pradesh',
'Bhatkhedi,Ujjain,Madhya Pradesh',
'Bhikampur,Ujjain,Madhya Pradesh',
'Buranabad,Ujjain,Madhya Pradesh',
'Chapakhedi,Ujjain,Madhya Pradesh',
'Chapaner,Ujjain,Madhya Pradesh',
'Chirola Chhota,Ujjain,Madhya Pradesh',
'Chirola,Ujjain,Madhya Pradesh',
'Durgapura,Ujjain,Madhya Pradesh',
'Ghinoda,Ujjain,Madhya Pradesh',
'Hatai,Ujjain,Madhya Pradesh',
'Kamthana,Ujjain,Madhya Pradesh',
'Kanwas,Ujjain,Madhya Pradesh',
'Kesaria,Ujjain,Madhya Pradesh',
'Khachraud Rs,Ujjain,Madhya Pradesh',
'Khachraud,Ujjain,Madhya Pradesh',
'Kharsodkalan,Ujjain,Madhya Pradesh',
'Madawda,Ujjain,Madhya Pradesh',
'Mehatvas,Ujjain,Madhya Pradesh',
'Nandiyasi,Ujjain,Madhya Pradesh',
'Narsingarh,Ujjain,Madhya Pradesh',
'Pachlasi,Ujjain,Madhya Pradesh',
'Rohil Khurd,Ujjain,Madhya Pradesh',
'Run Kheda,Ujjain,Madhya Pradesh',
'Rupeta,Ujjain,Madhya Pradesh',
'Shrivatsa,Ujjain,Madhya Pradesh',
'Etawa,Ujjain,Madhya Pradesh',
'Kapeli,Ujjain,Madhya Pradesh',
'Makdone,Ujjain,Madhya Pradesh',
'Tilawad,Ujjain,Madhya Pradesh',
'Aajmabad,Ujjain,Madhya Pradesh',
'Bappiya,Ujjain,Madhya Pradesh',
'Barkheda Buzurg,Ujjain,Madhya Pradesh',
'Berchha,Ujjain,Madhya Pradesh',
'Chitavad,Ujjain,Madhya Pradesh',
'Delchi Buzurg,Ujjain,Madhya Pradesh',
'Dharakheda,Ujjain,Madhya Pradesh',
'Gogakheda,Ujjain,Madhya Pradesh',
'Indokh,Ujjain,Madhya Pradesh',
'Jhutawad,Ujjain,Madhya Pradesh',
'Kachria,Ujjain,Madhya Pradesh',
'Khedakhajuria,Ujjain,Madhya Pradesh',
'Kundikheda,Ujjain,Madhya Pradesh',
'Lalgarh,Ujjain,Madhya Pradesh',
'Lotiyajunarda,Ujjain,Madhya Pradesh',
'Mahu,Ujjain,Madhya Pradesh',
'Makla,Ujjain,Madhya Pradesh',
'Mehidpur Bazar,Ujjain,Madhya Pradesh',
'Mehidpur Road,Ujjain,Madhya Pradesh',
'Mehidpur,Ujjain,Madhya Pradesh',
'Rnayarapeer,Ujjain,Madhya Pradesh',
'Sagwali,Ujjain,Madhya Pradesh',
'Semliya,Ujjain,Madhya Pradesh',
'Shakkar Khedi,Ujjain,Madhya Pradesh',
'Tutiya Khedi,Ujjain,Madhya Pradesh',
'Nagda Town,Ujjain,Madhya Pradesh',
'Nagda,Ujjain,Madhya Pradesh',
'Narwar,Ujjain,Madhya Pradesh',
'Piploda Baghla,Ujjain,Madhya Pradesh',
'Aslavada,Ujjain,Madhya Pradesh',
'Badagaon,Ujjain,Madhya Pradesh',
'Lekoda Anjana,Ujjain,Madhya Pradesh',
'Makdavan,Ujjain,Madhya Pradesh',
'Palsoda Makdavan,Ujjain,Madhya Pradesh',
'Sandla,Ujjain,Madhya Pradesh',
'Suwasa,Ujjain,Madhya Pradesh',
'Jahagirpur,Ujjain,Madhya Pradesh',
'Aajdawada,Ujjain,Madhya Pradesh',
'Badagaon,Ujjain,Madhya Pradesh',
'Baloda Lakkha,Ujjain,Madhya Pradesh',
'Khedavada,Ujjain,Madhya Pradesh',
'Runija,Ujjain,Madhya Pradesh',
'Sundarabad,Ujjain,Madhya Pradesh',
'Badkummed,Ujjain,Madhya Pradesh',
'Harsodhan,Ujjain,Madhya Pradesh',
'Tajpur,Ujjain,Madhya Pradesh',
'Baghera,Ujjain,Madhya Pradesh',
'Bichrod,Ujjain,Madhya Pradesh',
'Chadawad,Ujjain,Madhya Pradesh',
'Jawasia Kumar,Ujjain,Madhya Pradesh',
'Kanardi,Ujjain,Madhya Pradesh',
'Karedimataji,Ujjain,Madhya Pradesh',
'Kathbarode,Ujjain,Madhya Pradesh',
'Kaytha,Ujjain,Madhya Pradesh',
'Khajuria,Ujjain,Madhya Pradesh',
'Nainawad,Ujjain,Madhya Pradesh',
'Nogaova,Ujjain,Madhya Pradesh',
'Samgi,Ujjain,Madhya Pradesh',
'Sumrakheda,Ujjain,Madhya Pradesh',
'Tarana Town,Ujjain,Madhya Pradesh',
'Tarana,Ujjain,Madhya Pradesh',
'Amodiya,Ujjain,Madhya Pradesh',
'Chintaman Jawasia,Ujjain,Madhya Pradesh',
'Goyalabujurg,Ujjain,Madhya Pradesh',
'Jethal,Ujjain,Madhya Pradesh',
'Kagdikaradia,Ujjain,Madhya Pradesh',
'Kaliadeh,Ujjain,Madhya Pradesh',
'Kaluheda,Ujjain,Madhya Pradesh',
'Karohan,Ujjain,Madhya Pradesh',
'Lekoda,Ujjain,Madhya Pradesh',
'Navakheda,Ujjain,Madhya Pradesh',
'Nayapura,Ujjain,Madhya Pradesh',
'Panbihar,Ujjain,Madhya Pradesh',
'Panthpiplai,Ujjain,Madhya Pradesh',
'Pipliahama,Ujjain,Madhya Pradesh',
'Ratadia,Ujjain,Madhya Pradesh',
'Rui,Ujjain,Madhya Pradesh',
'Sodang,Ujjain,Madhya Pradesh',
'Takwasa,Ujjain,Madhya Pradesh',
'Talod,Ujjain,Madhya Pradesh',
'Ujjain Bherugarh,Ujjain,Madhya Pradesh',
'Ujjain Chhota Sarafa,Ujjain,Madhya Pradesh',
'Ujjain City,Ujjain,Madhya Pradesh',
'Ujjain Danigate,Ujjain,Madhya Pradesh',
'Ujjain Desai Nagar,Ujjain,Madhya Pradesh',
'Ujjain Factory,Ujjain,Madhya Pradesh',
'Ujjain Govt. Engg. College,Ujjain,Madhya Pradesh',
'Ujjain Gujrati Samaj,Ujjain,Madhya Pradesh',
'Ujjain Kothi,Ujjain,Madhya Pradesh',
'Ujjain M.L.Nagar,Ujjain,Madhya Pradesh',
'Ujjain Madhonagar,Ujjain,Madhya Pradesh',
'Ujjain Pandariba,Ujjain,Madhya Pradesh',
'Ujjain Qumri Marg,Ujjain,Madhya Pradesh',
'Ujjain Rishi Nagar,Ujjain,Madhya Pradesh',
'Ujjain Shri Mahakal,Ujjain,Madhya Pradesh',
'Ujjain Sindhi Colony,Ujjain,Madhya Pradesh',
'Ujjain Daulatganj,Ujjain,Madhya Pradesh',
'Ujjain H.O,Ujjain,Madhya Pradesh',
'Ujjain Vikram University,Ujjain,Madhya Pradesh',
'Undasa,Ujjain,Madhya Pradesh',
'Alot Jagir,Ujjain,Madhya Pradesh',
'Barkheda Madan,Ujjain,Madhya Pradesh',
'Bedavan,Ujjain,Madhya Pradesh',
'Paslod,Ujjain,Madhya Pradesh',
'Unhel,Ujjain,Madhya Pradesh',
'Nowrrozabad R. S.,Shahdol,Madhya Pradesh',
'Amiliha,Shahdol,Madhya Pradesh',
'Bakeli,Shahdol,Madhya Pradesh',
'Bandhwatola,Shahdol,Madhya Pradesh',
'Baskuta,Shahdol,Madhya Pradesh',
'Chauri,Shahdol,Madhya Pradesh',
'Chhatwai,Shahdol,Madhya Pradesh',
'Gopalpur,Shahdol,Madhya Pradesh',
'Jarha,Shahdol,Madhya Pradesh',
'Kanchanpur,Shahdol,Madhya Pradesh',
'Kohka,Shahdol,Madhya Pradesh',
'Kudri,Shahdol,Madhya Pradesh',
'Nowrozabad,Shahdol,Madhya Pradesh',
'Parsel,Shahdol,Madhya Pradesh',
'Pathari,Shahdol,Madhya Pradesh',
'Pinaura,Shahdol,Madhya Pradesh',
'Rahta,Shahdol,Madhya Pradesh',
'Raipur,Shahdol,Madhya Pradesh',
'Shahpur,Shahdol,Madhya Pradesh',
'Sundardadar,Shahdol,Madhya Pradesh',
'Checheria,Shahdol,Madhya Pradesh',
'Ghunghuti,Shahdol,Madhya Pradesh',
'Salaiya,Shahdol,Madhya Pradesh',
'Sgtps Pali,Shahdol,Madhya Pradesh',
'Birsinghpur Pali,Shahdol,Madhya Pradesh',
'Akhdar,Shahdol,Madhya Pradesh',
'Amarpur,Shahdol,Madhya Pradesh',
'Badchhad,Shahdol,Madhya Pradesh',
'Baderi,Shahdol,Madhya Pradesh',
'Badwar,Shahdol,Madhya Pradesh',
'Balhaud,Shahdol,Madhya Pradesh',
'Banka,Shahdol,Madhya Pradesh',
'Baroda,Shahdol,Madhya Pradesh',
'Bharaula,Shahdol,Madhya Pradesh',
'Bharewa,Shahdol,Madhya Pradesh',
'Bhundi,Shahdol,Madhya Pradesh',
'Bijauri,Shahdol,Madhya Pradesh',
'Bilaspur,Shahdol,Madhya Pradesh',
'Chandia,Shahdol,Madhya Pradesh',
'Chansura,Shahdol,Madhya Pradesh',
'Chilhari,Shahdol,Madhya Pradesh',
'Dhamokhar,Shahdol,Madhya Pradesh',
'Dhanwar,Shahdol,Madhya Pradesh',
'Gobarde,Shahdol,Madhya Pradesh',
'Harrwah,Shahdol,Madhya Pradesh',
'Indwar,Shahdol,Madhya Pradesh',
'Jhall,Shahdol,Madhya Pradesh',
'Jobi,Shahdol,Madhya Pradesh',
'Kachharwar,Shahdol,Madhya Pradesh',
'Karkeli,Shahdol,Madhya Pradesh',
'Kathar,Shahdol,Madhya Pradesh',
'Kaudiya,Shahdol,Madhya Pradesh',
'Khalaundh,Shahdol,Madhya Pradesh',
'Kothari,Shahdol,Madhya Pradesh',
'Lorha,Shahdol,Madhya Pradesh',
'Mahroi,Shahdol,Madhya Pradesh',
'Majmanikala,Shahdol,Madhya Pradesh',
'Manpur,Shahdol,Madhya Pradesh',
'Mudgudi,Shahdol,Madhya Pradesh',
'Narwar,Shahdol,Madhya Pradesh',
'Naugawan,Shahdol,Madhya Pradesh',
'Nigahri,Shahdol,Madhya Pradesh',
'Obra,Shahdol,Madhya Pradesh',
'Padkhuri,Shahdol,Madhya Pradesh',
'Padwar,Shahdol,Madhya Pradesh',
'Panpatha,Shahdol,Madhya Pradesh',
'Pathrahta,Shahdol,Madhya Pradesh',
'Saraswahi,Shahdol,Madhya Pradesh',
'Semra,Shahdol,Madhya Pradesh',
'Tala,Shahdol,Madhya Pradesh',
'Tikuri,Shahdol,Madhya Pradesh',
'Umaria Bakeli,Shahdol,Madhya Pradesh',
'Umaria,Shahdol,Madhya Pradesh',
'Agrabarkheda,Vidisha,Madhya Pradesh',
'Ahemadnagar,Vidisha,Madhya Pradesh',
'Ahmedpur,Vidisha,Madhya Pradesh',
'Ambanagar,Vidisha,Madhya Pradesh',
'Ambar,Vidisha,Madhya Pradesh',
'Amkhedasukha,Vidisha,Madhya Pradesh',
'Ancheda,Vidisha,Madhya Pradesh',
'Andiakala,Vidisha,Madhya Pradesh',
'Atarikhejda,Vidisha,Madhya Pradesh',
'Attasemra,Vidisha,Madhya Pradesh',
'Balabarkheda,Vidisha,Madhya Pradesh',
'Bandraotha,Vidisha,Madhya Pradesh',
'Banshkhedia.,Vidisha,Madhya Pradesh',
'Baoli,Vidisha,Madhya Pradesh',
'Bareth,Vidisha,Madhya Pradesh',
'Barkhedajagir,Vidisha,Madhya Pradesh',
'Barrighat,Vidisha,Madhya Pradesh',
'Barwai,Vidisha,Madhya Pradesh',
'Beenjh,Vidisha,Madhya Pradesh',
'Bhadarbadagaon,Vidisha,Madhya Pradesh',
'Bhagwantpur,Vidisha,Madhya Pradesh',
'Bhalbamora,Vidisha,Madhya Pradesh',
'Bharro,Vidisha,Madhya Pradesh',
'Bhonriya,Vidisha,Madhya Pradesh',
'Bhorasa,Vidisha,Madhya Pradesh',
'Bichhiya,Vidisha,Madhya Pradesh',
'Bidhwasan,Vidisha,Madhya Pradesh',
'Biladhana,Vidisha,Madhya Pradesh',
'Bishanpur,Vidisha,Madhya Pradesh',
'Budhigagrod,Vidisha,Madhya Pradesh',
'Chatholi,Vidisha,Madhya Pradesh',
'Chatholi,Vidisha,Madhya Pradesh',
'Cherkheda,Vidisha,Madhya Pradesh',
'Chirodia,Vidisha,Madhya Pradesh',
'Chitawar,Vidisha,Madhya Pradesh',
'Dangarwada,Vidisha,Madhya Pradesh',
'Danwas,Vidisha,Madhya Pradesh',
'Deepankheda,Vidisha,Madhya Pradesh',
'Dehri,Vidisha,Madhya Pradesh',
'Deokhajuri,Vidisha,Madhya Pradesh',
'Dhamnod,Vidisha,Madhya Pradesh',
'Dhua,Vidisha,Madhya Pradesh',
'Dudhawari,Vidisha,Madhya Pradesh',
'Gadla,Vidisha,Madhya Pradesh',
'Gamkhar,Vidisha,Madhya Pradesh',
'Garantha,Vidisha,Madhya Pradesh',
'Ghatera,Vidisha,Madhya Pradesh',
'Ghatwar,Vidisha,Madhya Pradesh',
'Ghuuletha,Vidisha,Madhya Pradesh',
'Gunnotha,Vidisha,Madhya Pradesh',
'Hansua,Vidisha,Madhya Pradesh',
'Hinotia,Vidisha,Madhya Pradesh',
'Hydergarh,Vidisha,Madhya Pradesh',
'Imalia,Vidisha,Madhya Pradesh',
'Inderwas,Vidisha,Madhya Pradesh',
'Jaitpur,Vidisha,Madhya Pradesh',
'Javti,Vidisha,Madhya Pradesh',
'Jhandwa,Vidisha,Madhya Pradesh',
'Jhukarhoj,Vidisha,Madhya Pradesh',
'Johad,Vidisha,Madhya Pradesh',
'Kacchikheda,Vidisha,Madhya Pradesh',
'Kakrada,Vidisha,Madhya Pradesh',
'Karaiyahat,Vidisha,Madhya Pradesh',
'Karaiyahat,Vidisha,Madhya Pradesh',
'Karela,Vidisha,Madhya Pradesh',
'Khader,Vidisha,Madhya Pradesh',
'Khamkheda,Vidisha,Madhya Pradesh',
'Khamtala,Vidisha,Madhya Pradesh',
'Khari,Vidisha,Madhya Pradesh',
'Kharpari,Vidisha,Madhya Pradesh',
'Kirwaya,Vidisha,Madhya Pradesh',
'Kothicharkalan,Vidisha,Madhya Pradesh',
'Kulhar,Vidisha,Madhya Pradesh',
'Kurwaikathora,Vidisha,Madhya Pradesh',
'Lachayara,Vidisha,Madhya Pradesh',
'Lashkarpur,Vidisha,Madhya Pradesh',
'Layara,Vidisha,Madhya Pradesh',
'Mahelua,Vidisha,Madhya Pradesh',
'Mahoo,Vidisha,Madhya Pradesh',
'Mahoti,Vidisha,Madhya Pradesh',
'Mainwada,Vidisha,Madhya Pradesh',
'Manora,Vidisha,Madhya Pradesh',
'Markheda,Vidisha,Madhya Pradesh',
'Masoodpur,Vidisha,Madhya Pradesh',
'Mirzapur,Vidisha,Madhya Pradesh',
'Mohammadgarh,Vidisha,Madhya Pradesh',
'Mohnakhejda,Vidisha,Madhya Pradesh',
'Mugalsarai,Vidisha,Madhya Pradesh',
'Mundela,Vidisha,Madhya Pradesh',
'Mungwara,Vidisha,Madhya Pradesh',
'Muradpur,Vidisha,Madhya Pradesh',
'Murahar,Vidisha,Madhya Pradesh',
'Muraria,Vidisha,Madhya Pradesh',
'Murwas,Vidisha,Madhya Pradesh',
'Nagore,Vidisha,Madhya Pradesh',
'Naukund,Vidisha,Madhya Pradesh',
'Naulas,Vidisha,Madhya Pradesh',
'Okhlikheda,Vidisha,Madhya Pradesh',
'Parsora,Vidisha,Madhya Pradesh',
'Pauanala,Vidisha,Madhya Pradesh',
'Pawai,Vidisha,Madhya Pradesh',
'Phupher,Vidisha,Madhya Pradesh',
'Pilone,Vidisha,Madhya Pradesh',
'Pipaldhar,Vidisha,Madhya Pradesh',
'Pipraha,Vidisha,Madhya Pradesh',
'Ravan,Vidisha,Madhya Pradesh',
'Roshanpiparia,Vidisha,Madhya Pradesh',
'Rusalidama,Vidisha,Madhya Pradesh',
'Russallishahu,Vidisha,Madhya Pradesh',
'Sader,Vidisha,Madhya Pradesh',
'Sangeul,Vidisha,Madhya Pradesh',
'Sankalkheda,Vidisha,Madhya Pradesh',
'Sankalkheda,Vidisha,Madhya Pradesh',
'Satpada,Vidisha,Madhya Pradesh',
'Satpadahat,Vidisha,Madhya Pradesh',
'Sehod,Vidisha,Madhya Pradesh',
'Semalkhedi(S),Vidisha,Madhya Pradesh',
'Seo,Vidisha,Madhya Pradesh',
'Serwasa,Vidisha,Madhya Pradesh',
'Sheharkheda,Vidisha,Madhya Pradesh',
'Shekhpur,Vidisha,Madhya Pradesh',
'Simarhar,Vidisha,Madhya Pradesh',
'Sirnota,Vidisha,Madhya Pradesh',
'Siyalpur,Vidisha,Madhya Pradesh',
'Sojna,Vidisha,Madhya Pradesh',
'Sonther,Vidisha,Madhya Pradesh',
'Sumerr S,Vidisha,Madhya Pradesh',
'Sunkher,Vidisha,Madhya Pradesh',
'Tal,Vidisha,Madhya Pradesh',
'Teonda,Vidisha,Madhya Pradesh',
'Thanner,Vidisha,Madhya Pradesh',
'Tharr,Vidisha,Madhya Pradesh',
'Toribagrod,Vidisha,Madhya Pradesh',
'Uadigiri,Vidisha,Madhya Pradesh',
'Udaipur,Vidisha,Madhya Pradesh',
'Uhar,Vidisha,Madhya Pradesh',
'Unarshikala,Vidisha,Madhya Pradesh',
'Unarsikhurd,Vidisha,Madhya Pradesh',
'Wardha,Vidisha,Madhya Pradesh',
'Ganjbasoda,Vidisha,Madhya Pradesh',
'Gulabganj,Vidisha,Madhya Pradesh',
'Gyraspur,Vidisha,Madhya Pradesh',
'Khamkheda,Vidisha,Madhya Pradesh',
'Kurwai,Vidisha,Madhya Pradesh',
'Lateri,Vidisha,Madhya Pradesh',
'Nateran,Vidisha,Madhya Pradesh',
'Pathari,Vidisha,Madhya Pradesh',
'Pipalkheda,Vidisha,Madhya Pradesh',
'Shamshabad,Vidisha,Madhya Pradesh',
'Sironj,Vidisha,Madhya Pradesh',
'Vidisha H.O,Vidisha,Madhya Pradesh',
'Awangjiri,Manipur,Manipur',
'Bishnupur,Manipur,Manipur',
'Boroyangbi,Manipur,Manipur',
'Bunglon,Manipur,Manipur',
'Bungte Chiru,Manipur,Manipur',
'Charoi Khullel,Manipur,Manipur',
'Dolang,Manipur,Manipur',
'Dolang,Manipur,Manipur',
'Dolang Khunou,Manipur,Manipur',
'Dopkon,Manipur,Manipur',
'Ethai Bazar,Manipur,Manipur',
'Gelmol,Manipur,Manipur',
'Haotak Khullen,Manipur,Manipur',
'Haotakphailen,Manipur,Manipur',
'Heikrujam,Manipur,Manipur',
'Irengbam,Manipur,Manipur',
'Isok,Manipur,Manipur',
'Jiban Nager,Manipur,Manipur',
'Kabowakching,Manipur,Manipur',
'Kamong,Manipur,Manipur',
'Kangathei,Manipur,Manipur',
'Keinou,Manipur,Manipur',
'Khabi,Manipur,Manipur',
'Khathinunggei,Manipur,Manipur',
'Khoijuman,Manipur,Manipur',
'Khoirentak,Manipur,Manipur',
'Khongbung,Manipur,Manipur',
'Khordak Ichin,Manipur,Manipur',
'Khousabung,Manipur,Manipur',
'Khunpi Naosem,Manipur,Manipur',
'Kumbi (P),Manipur,Manipur',
'Kwakta,Manipur,Manipur',
'Lamdangmei,Manipur,Manipur',
'Langpok,Manipur,Manipur',
'Leimapokpam,Manipur,Manipur',
'Leimatak,Manipur,Manipur',
'Leimram,Manipur,Manipur',
'Loktak Project,Manipur,Manipur',
'Maibam,Manipur,Manipur',
'Manamayang,Manipur,Manipur',
'Mayuran,Manipur,Manipur',
'Moirang,Manipur,Manipur',
'Molphei Tampak,Manipur,Manipur',
'Nabil (P),Manipur,Manipur',
'Nambol,Manipur,Manipur',
'Naorem,Manipur,Manipur',
'Naransena,Manipur,Manipur',
'Ngaikhong Khullen,Manipur,Manipur',
'Ngangkha Lawi,Manipur,Manipur',
'Ngarian,Manipur,Manipur',
'Ningthoukhong,Manipur,Manipur',
'Nungsai Chiru,Manipur,Manipur',
'Nungthangtampak,Manipur,Manipur',
'Oinam,Manipur,Manipur',
'Phousabung,Manipur,Manipur',
'Phubala,Manipur,Manipur',
'Potsangbam,Manipur,Manipur',
'Pukhrambam,Manipur,Manipur',
'Sadukhoiroi,Manipur,Manipur',
'Sagang,Manipur,Manipur',
'Saiton,Manipur,Manipur',
'Terakhongshangbi,Manipur,Manipur',
'Thanga Karang,Manipur,Manipur',
'Thanga(P),Manipur,Manipur',
'Thangal,Manipur,Manipur',
'Tharoi Bomdiar,Manipur,Manipur',
'Thinkai Khullen,Manipur,Manipur',
'Thinungei,Manipur,Manipur',
'Thumkhonglok,Manipur,Manipur',
'Tokpalamdan,Manipur,Manipur',
'Torbung,Manipur,Manipur',
'Toubul,Manipur,Manipur',
'Tronglaobi,Manipur,Manipur',
'Tuisangthei,Manipur,Manipur',
'Utlou,Manipur,Manipur',
'Wangoo,Manipur,Manipur',
'Wangoo Tera,Manipur,Manipur',
'Zouzangtek,Manipur,Manipur',
'Aigejang,Manipur,Manipur',
'Anal Khullen,Manipur,Manipur',
'Bongajang,Manipur,Manipur',
'Bongjoi,Manipur,Manipur',
'Chakpikarong,Manipur,Manipur',
'Chandel,Manipur,Manipur',
'Chenpal,Manipur,Manipur',
'Duthang,Manipur,Manipur',
'Gamphajal,Manipur,Manipur',
'Gobok,Manipur,Manipur',
'Khengjoi,Manipur,Manipur',
'Khubungh Khullen,Manipur,Manipur',
'Khudengthabi,Manipur,Manipur',
'Larong,Manipur,Manipur',
'Liwasari,Manipur,Manipur',
'Maojam,Manipur,Manipur',
'Mittong,Manipur,Manipur',
'Molchamedbo,Manipur,Manipur',
'Monbi,Manipur,Manipur',
'Moreh,Manipur,Manipur',
'New Somtal,Manipur,Manipur',
'Pallel,Manipur,Manipur',
'Phiran Machet,Manipur,Manipur',
'Sajik Tampak,Manipur,Manipur',
'Sehao,Manipur,Manipur',
'Semol,Manipur,Manipur',
'Sugnu,Manipur,Manipur',
'T- Bongmun,Manipur,Manipur',
'Tengnoupal,Manipur,Manipur',
'Thorchom,Manipur,Manipur',
'T-minou,Manipur,Manipur',
'Toupokpi,Manipur,Manipur',
'Yangoulen,Manipur,Manipur',
'Zoupi,Manipur,Manipur',
'Aibulon,Manipur,Manipur',
'Aina,Manipur,Manipur',
'Behiang,Manipur,Manipur',
'Bukpi,Manipur,Manipur',
'Bungmual,Manipur,Manipur',
'Bungpilon,Manipur,Manipur',
'Chehjang,Manipur,Manipur',
'Chingkonpang,Manipur,Manipur',
'Chothemunpi,Manipur,Manipur',
'Churachandpur,Manipur,Manipur',
'Geljaing,Manipur,Manipur',
'Hamkeilon,Manipur,Manipur',
'Hanship,Manipur,Manipur',
'Henglep,Manipur,Manipur',
'Hengtam,Manipur,Manipur',
'Kangkap,Manipur,Manipur',
'Kangvai Bazar,Manipur,Manipur',
'Khajang,Manipur,Manipur',
'Khanpi,Manipur,Manipur',
'Khanpi,Manipur,Manipur',
'Khouwpuibung,Manipur,Manipur',
'Kolhen,Manipur,Manipur',
'Kumbipukhri,Manipur,Manipur',
'Kwanpui,Manipur,Manipur',
'Lailong,Manipur,Manipur',
'Lama Camp,Manipur,Manipur',
'Leijangphai,Manipur,Manipur',
'Leison,Manipur,Manipur',
'Lingshiphai,Manipur,Manipur',
'Lungchin,Manipur,Manipur',
'Lungsai,Manipur,Manipur',
'Lungshung,Manipur,Manipur',
'Lungthul,Manipur,Manipur',
'Millongmun,Manipur,Manipur',
'Mission Compound,Manipur,Manipur',
'Mual Vaiphei,Manipur,Manipur',
'Mualkoi,Manipur,Manipur',
'Mualmun,Manipur,Manipur',
'Munpi,Manipur,Manipur',
'Panglian,Manipur,Manipur',
'Parbung,Manipur,Manipur',
'Pearsonmun,Manipur,Manipur',
'Phaijang,Manipur,Manipur',
'Phaipheng,Manipur,Manipur',
'Pherazol,Manipur,Manipur',
'Pmzol,Manipur,Manipur',
'Saiden,Manipur,Manipur',
'Saikhul Village,Manipur,Manipur',
'Saikot,Manipur,Manipur',
'Saikul,Manipur,Manipur',
'Sangphou,Manipur,Manipur',
'Santing,Manipur,Manipur',
'Sawaiphaih (T/C/D),Manipur,Manipur',
'Semon,Manipur,Manipur',
'Siabu,Manipur,Manipur',
'Sielmet,Manipur,Manipur',
'Singhat,Manipur,Manipur',
'Singjawl,Manipur,Manipur',
'Songdoh,Manipur,Manipur',
'Songtal,Manipur,Manipur',
'South Kotlein,Manipur,Manipur',
'Taithu,Manipur,Manipur',
'Takvam,Manipur,Manipur',
'Teiyong,Manipur,Manipur',
'Thangshi,Manipur,Manipur',
'Thanlon,Manipur,Manipur',
'Thinkew,Manipur,Manipur',
'Tingsong,Manipur,Manipur',
'Tipaimukh (P),Manipur,Manipur',
'Tollen,Manipur,Manipur',
'Tolphei,Manipur,Manipur',
'Tuabung,Manipur,Manipur',
'Tuikham,Manipur,Manipur',
'Tuining,Manipur,Manipur',
'Tuinom,Manipur,Manipur',
'Tuitengphai,Manipur,Manipur',
'Tulaphei,Manipur,Manipur',
'Ukha,Manipur,Manipur',
'Vokbual,Manipur,Manipur',
'Awang Konmgpal,Manipur,Manipur',
'Chingmang,Manipur,Manipur',
'Dolaithabi,Manipur,Manipur',
'Haraorou,Manipur,Manipur',
'Heinoumakhong,Manipur,Manipur',
'Huidrom,Manipur,Manipur',
'Irilbung,Manipur,Manipur',
'Kairang Litan Makhong,Manipur,Manipur',
'Kameng Kakching,Manipur,Manipur',
'Keirao Bitra Salam,Manipur,Manipur',
'Keirao Makting,Manipur,Manipur',
'Keirao Wangkhem,Manipur,Manipur',
'Khongangpheidekpi,Manipur,Manipur',
'Khongbal Tangkhul,Manipur,Manipur',
'Khumidok (P),Manipur,Manipur',
'Khurai Khongnang Makhong,Manipur,Manipur',
'Kitnapanung,Manipur,Manipur',
'Kongba Bazar,Manipur,Manipur',
'Kshetribangoon,Manipur,Manipur',
'Kshetrigao,Manipur,Manipur',
'Laikoiching,Manipur,Manipur',
'Laiphrak Maring,Manipur,Manipur',
'Lamlai,Manipur,Manipur',
'Lamlong,Manipur,Manipur',
'Latingkhal,Manipur,Manipur',
'Liklikhong Bazar,Manipur,Manipur',
'Manipur University,Manipur,Manipur',
'Mapao Keithelmanbi,Manipur,Manipur',
'Moirang Kampu,Manipur,Manipur',
'Moirang Purel,Manipur,Manipur',
'Mongkhang Lambi,Manipur,Manipur',
'Ningthemchakhul,Manipur,Manipur',
'Nongdam Tangkhul,Manipur,Manipur',
'Nongoda,Manipur,Manipur',
'Oinam Thingel,Manipur,Manipur',
'Phaknung,Manipur,Manipur',
'Pngaei Yangdong,Manipur,Manipur',
'Porompat,Manipur,Manipur',
'Pukhao Ahallup,Manipur,Manipur',
'Sagolmang,Manipur,Manipur',
'Satang,Manipur,Manipur',
'Sawombung,Manipur,Manipur',
'Sekmai,Manipur,Manipur',
'Singjamei,Manipur,Manipur',
'Takhel,Manipur,Manipur',
'Tangkhul Hungdung,Manipur,Manipur',
'Taretkhul,Manipur,Manipur',
'Thangal Surung,Manipur,Manipur',
'Tulihal,Manipur,Manipur',
'Uchekon,Manipur,Manipur',
'Uyumpok,Manipur,Manipur',
'Waiton,Manipur,Manipur',
'Wakhen Phai,Manipur,Manipur',
'Yourbung,Manipur,Manipur',
'Yumnam Khunou,Manipur,Manipur',
'Ahallup,Manipur,Manipur',
'Arong,Manipur,Manipur',
'Awang Leikinthabi,Manipur,Manipur',
'Awangpotshangbam,Manipur,Manipur',
'Bengoon Maning Leikai,Manipur,Manipur',
'Bidyanagar,Manipur,Manipur',
'Bongmun,Manipur,Manipur',
'Borobekra,Manipur,Manipur',
'Br Colony,Manipur,Manipur',
'Canchipur (T/C/D),Manipur,Manipur',
'Central Agriculture University,Manipur,Manipur',
'Ch. Khongnangpokpi,Manipur,Manipur',
'Chabung Company,Manipur,Manipur',
'Champanagar,Manipur,Manipur',
'Chingmun,Manipur,Manipur',
'Chirai Muslim,Manipur,Manipur',
'Christan Centre Haochong,Manipur,Manipur',
'Crpf Langjing,Manipur,Manipur',
'D.M College,Manipur,Manipur',
'Gularthol,Manipur,Manipur',
'Haorang Kairel,Manipur,Manipur',
'Haoreibi,Manipur,Manipur',
'Heibong Makhong,Manipur,Manipur',
'Heibongpokpi,Manipur,Manipur',
'Heingang,Manipur,Manipur',
'Hiyangthang,Manipur,Manipur',
'Ijairong,Manipur,Manipur',
'Imphal Bazar,Manipur,Manipur',
'Imphal H.O,Manipur,Manipur',
'Irengnaga,Manipur,Manipur',
'Iroisemaba,Manipur,Manipur',
'Irom Meijrao,Manipur,Manipur',
'Irong Chessabal,Manipur,Manipur',
'Irong Umang Khunou,Manipur,Manipur',
'Jakurdhar,Manipur,Manipur',
'Jiribam Bazar,Manipur,Manipur',
'Kangchup Chiru,Manipur,Manipur',
'Kangchup Hill (P),Manipur,Manipur',
'Kangchup Makhong,Manipur,Manipur',
'Kanglatongbi,Manipur,Manipur',
'Karakhul,Manipur,Manipur',
'Karam Vaiphei,Manipur,Manipur',
'Kashimpur,Manipur,Manipur',
'Keimai,Manipur,Manipur',
'Kh Jaikhan,Manipur,Manipur',
'Khamnam Bazar,Manipur,Manipur',
'Khangakhul,Manipur,Manipur',
'Khelakhong,Manipur,Manipur',
'Khonghampat,Manipur,Manipur',
'Khoyathong,Manipur,Manipur',
'Khumbong Bazar,Manipur,Manipur',
'Khundong Khukhaiba,Manipur,Manipur',
'Khurukhul,Manipur,Manipur',
'Kodompokpi,Manipur,Manipur',
'Komlakhong,Manipur,Manipur',
'Konthakhabam,Manipur,Manipur',
'Konthoujam,Manipur,Manipur',
'Kunja (P),Manipur,Manipur',
'Kyamgei,Manipur,Manipur',
'Laiphrakom,Manipur,Manipur',
'Lairen Sajik,Manipur,Manipur',
'Lalkhai,Manipur,Manipur',
'Lamboi Khongnagkhong,Manipur,Manipur',
'Lamdeng,Manipur,Manipur',
'Lamphelpat,Manipur,Manipur',
'Lamsang,Manipur,Manipur',
'Langjing Achouba,Manipur,Manipur',
'Langol Housing Complex,Manipur,Manipur',
'Langthabal,Manipur,Manipur',
'Laphupat,Manipur,Manipur',
'Loitang Leikinthabi,Manipur,Manipur',
'Longa Koireng,Manipur,Manipur',
'Longpi,Manipur,Manipur',
'Loukok Mayai Leikai,Manipur,Manipur',
'Luwangsangbam,Manipur,Manipur',
'Luwangsangol,Manipur,Manipur',
'Maibam Konjil,Manipur,Manipur',
'Makhan,Manipur,Manipur',
'Maklang Bazar,Manipur,Manipur',
'Mantripukhri,Manipur,Manipur',
'Mayang Impahl Bengoon,Manipur,Manipur',
'Mayang Langjing,Manipur,Manipur',
'Mongsangei,Manipur,Manipur',
'Mutum Phibou,Manipur,Manipur',
'Natok Kabui,Manipur,Manipur',
'New Keiphundai,Manipur,Manipur',
'New Keithelmanbi,Manipur,Manipur',
'Ngairangbam,Manipur,Manipur',
'Ngaphabung,Manipur,Manipur',
'Ningombam,Manipur,Manipur',
'Noremthong Bazar,Manipur,Manipur',
'Oktan,Manipur,Manipur',
'Paobitek,Manipur,Manipur',
'Patpuimun,Manipur,Manipur',
'Patsoi Part II,Manipur,Manipur',
'Phaibok Mullen,Manipur,Manipur',
'Phayeng,Manipur,Manipur',
'Phoubakchao,Manipur,Manipur',
'Ponlian,Manipur,Manipur',
'Potsangbam Khoirou,Manipur,Manipur',
'Sagolband Thingom Leikai,Manipur,Manipur',
'Sagoltongba Bazar,Manipur,Manipur',
'Samurou,Manipur,Manipur',
'Sangaiprou,Manipur,Manipur',
'Santhel,Manipur,Manipur',
'Sayang Kuraomakhong,Manipur,Manipur',
'Sekmaijin Khunou Konuma,Manipur,Manipur',
'Sekmaijin,Manipur,Manipur',
'Sekmaijin Khunou Litan Makhong,Manipur,Manipur',
'Soibam Leikai,Manipur,Manipur',
'Sonapur,Manipur,Manipur',
'Suangpuimun,Manipur,Manipur',
'Tairenpokpi,Manipur,Manipur',
'Takyel Khongbal,Manipur,Manipur',
'Tendongyang (P),Manipur,Manipur',
'Tera Bazar,Manipur,Manipur',
'Tera Khoidum Mayai Leikai,Manipur,Manipur',
'Tharoijam,Manipur,Manipur',
'Tuitengmun,Manipur,Manipur',
'Uchiwa,Manipur,Manipur',
'Uchiwa Wangban,Manipur,Manipur',
'Wangoi,Manipur,Manipur',
'Yarrow Meitram,Manipur,Manipur',
'Yumnam Khunou,Manipur,Manipur',
'Yurembam,Manipur,Manipur',
'Bitrarakhong,Manipur,Manipur',
'Bunglong,Manipur,Manipur',
'Chalwa (P),Manipur,Manipur',
'Chandraman,Manipur,Manipur',
'Chawanamei,Manipur,Manipur',
'Cheljang,Manipur,Manipur',
'Chingai Khullen,Manipur,Manipur',
'Galam,Manipur,Manipur',
'Ganel,Manipur,Manipur',
'Gangpijang,Manipur,Manipur',
'Haipi,Manipur,Manipur',
'Hengbung,Manipur,Manipur',
'Ichaigojang,Manipur,Manipur',
'Irang,Manipur,Manipur',
'J Phaijang,Manipur,Manipur',
'Jangnoi,Manipur,Manipur',
'Kaibi,Manipur,Manipur',
'Kalapahar,Manipur,Manipur',
'Kangpokpi Mission,Manipur,Manipur',
'Sorang Phung,Manipur,Manipur',
'Sorde,Manipur,Manipur',
'T.C. Ground,Manipur,Manipur',
'Thawai,Manipur,Manipur',
'Thiwa,Manipur,Manipur',
'Tolloi,Manipur,Manipur',
'Tuinem,Manipur,Manipur',
'Tungou,Manipur,Manipur',
'Tushem,Manipur,Manipur',
'Ukhrul,Manipur,Manipur',
'Yangangpokpi,Manipur,Manipur',
'Jadigitim,Meghalaya,Meghalaya',
'Dagal,Meghalaya,Meghalaya',
'Daram,Meghalaya,Meghalaya',
'Haluapara,Meghalaya,Meghalaya',
'Rongrong,Meghalaya,Meghalaya',
'Thapa,Meghalaya,Meghalaya',
'Dabu,Meghalaya,Meghalaya',
'Dainadubi,Meghalaya,Meghalaya',
'Darugiri,Meghalaya,Meghalaya',
'Gairong,Meghalaya,Meghalaya',
'Mangsang,Meghalaya,Meghalaya',
'Nongcharan,Meghalaya,Meghalaya',
'Ronga Agal,Meghalaya,Meghalaya',
'Rongchek Akhong,Meghalaya,Meghalaya',
'Rongjeng,Meghalaya,Meghalaya',
'Rongmil,Meghalaya,Meghalaya',
'Wagachi,Meghalaya,Meghalaya',
'Dokangsi,Meghalaya,Meghalaya',
'Gambil,Meghalaya,Meghalaya',
'Balkinigiri,Meghalaya,Meghalaya',
'Rombagiri,Meghalaya,Meghalaya',
'Rongrengiri,Meghalaya,Meghalaya',
'Rongsakgiri,Meghalaya,Meghalaya',
'Sakhadongiri,Meghalaya,Meghalaya',
'Samanda,Meghalaya,Meghalaya',
'Songsak,Meghalaya,Meghalaya',
'Williamnagar,Meghalaya,Meghalaya',
'Tynger,Meghalaya,Meghalaya',
'Gumaghat,Meghalaya,Meghalaya',
'Khonjoy,Meghalaya,Meghalaya',
'Makali,Meghalaya,Meghalaya',
'Mawput,Meghalaya,Meghalaya',
'Munai,Meghalaya,Meghalaya',
'Neigrihms,Meghalaya,Meghalaya',
'Pyndeng Sohsaw,Meghalaya,Meghalaya',
'Sonatola,Meghalaya,Meghalaya',
'Telsora,Meghalaya,Meghalaya',
'Trangpleng,Meghalaya,Meghalaya',
'Wahkdait,Meghalaya,Meghalaya',
'Balat,Meghalaya,Meghalaya',
'Dholai,Meghalaya,Meghalaya',
'Bholaganj Bazar,Meghalaya,Meghalaya',
'Cherrabazar,Meghalaya,Meghalaya',
'Ladmawphlang,Meghalaya,Meghalaya',
'Laitduh,Meghalaya,Meghalaya',
'Laitryngew,Meghalaya,Meghalaya',
'Mawkdok,Meghalaya,Meghalaya',
'Ramdait,Meghalaya,Meghalaya',
'Tynrong,Meghalaya,Meghalaya',
'Cherrapunjee,Meghalaya,Meghalaya',
'Laitkynsew,Meghalaya,Meghalaya',
'Mahadeo,Meghalaya,Meghalaya',
'Mawblang,Meghalaya,Meghalaya',
'Mawlong,Meghalaya,Meghalaya',
'Mawmluh,Meghalaya,Meghalaya',
'Sohbarpunjee,Meghalaya,Meghalaya',
'Sohkmie,Meghalaya,Meghalaya',
'Tyrna,Meghalaya,Meghalaya',
'Wahlong,Meghalaya,Meghalaya',
'Dawki,Meghalaya,Meghalaya',
'Umsyiem,Meghalaya,Meghalaya',
'Lawsohtun,Meghalaya,Meghalaya',
'Laitkor,Meghalaya,Meghalaya',
'Pomlakrai,Meghalaya,Meghalaya',
'Kynton - U - Mon,Meghalaya,Meghalaya',
'Mawryngkneng,Meghalaya,Meghalaya',
'Pamora,Meghalaya,Meghalaya',
'Puriang,Meghalaya,Meghalaya',
'Kynton Massar,Meghalaya,Meghalaya',
'Mawroh,Meghalaya,Meghalaya',
'Mawtawar,Meghalaya,Meghalaya',
'Diengpasoh,Meghalaya,Meghalaya',
'Mawkhanu,Meghalaya,Meghalaya',
'Tynring,Meghalaya,Meghalaya',
'Lyngiong,Meghalaya,Meghalaya',
'Madan Bitaw,Meghalaya,Meghalaya',
'Marbisu,Meghalaya,Meghalaya',
'Mawkriah,Meghalaya,Meghalaya',
'Mawngap,Meghalaya,Meghalaya',
'Mawphlang,Meghalaya,Meghalaya',
'Mawpun,Meghalaya,Meghalaya',
'Mawreng,Meghalaya,Meghalaya',
'Nongspung,Meghalaya,Meghalaya',
'Pongkung,Meghalaya,Meghalaya',
'Rangshken,Meghalaya,Meghalaya',
'Sohiong,Meghalaya,Meghalaya',
'Sohpian,Meghalaya,Meghalaya',
'Tyrsad,Meghalaya,Meghalaya',
'Weiloi,Meghalaya,Meghalaya',
'Lawbah,Meghalaya,Meghalaya',
'Mawdongbazar,Meghalaya,Meghalaya',
'Mawhiang,Meghalaya,Meghalaya',
'Mawsynram,Meghalaya,Meghalaya',
'Phlang Mawsyrpat,Meghalaya,Meghalaya',
'Phlangwanbroi,Meghalaya,Meghalaya',
'Ryngkubazar,Meghalaya,Meghalaya',
'Syntein,Meghalaya,Meghalaya',
'Thyllaw,Meghalaya,Meghalaya',
'Mawklot,Meghalaya,Meghalaya',
'Mylliem Syllai U Lar,Meghalaya,Meghalaya',
'Iewmawiong,Meghalaya,Meghalaya',
'Laitlyngkot,Meghalaya,Meghalaya',
'Langkyrdem,Meghalaya,Meghalaya',
'Mawbeh,Meghalaya,Meghalaya',
'Myllat,Meghalaya,Meghalaya',
'Nongjri,Meghalaya,Meghalaya',
'Nongkynrih,Meghalaya,Meghalaya',
'Pynursla,Meghalaya,Meghalaya',
'Umniuh - Tmar,Meghalaya,Meghalaya',
'Wahshiarkhmut,Meghalaya,Meghalaya',
'Umkdait,Meghalaya,Meghalaya',
'Dalia,Meghalaya,Meghalaya',
'Disong,Meghalaya,Meghalaya',
'Ichamati,Meghalaya,Meghalaya',
'Kalatak,Meghalaya,Meghalaya',
'Shella,Meghalaya,Meghalaya',
'Assam Rifles,Meghalaya,Meghalaya',
'Bishnupur,Meghalaya,Meghalaya',
'Happy Valley,Meghalaya,Meghalaya',
'Iewduh,Meghalaya,Meghalaya',
'Jaiaw,Meghalaya,Meghalaya',
'Laban,Meghalaya,Meghalaya',
'Laitkor Peak,Meghalaya,Meghalaya',
'Laitumkhrah,Meghalaya,Meghalaya',
'Madanriting,Meghalaya,Meghalaya',
'Mawiong,Meghalaya,Meghalaya',
'Mawlai,Meghalaya,Meghalaya',
'Mawpat,Meghalaya,Meghalaya',
'Meghalaya Secretariat,Meghalaya,Meghalaya',
'Nehu,Meghalaya,Meghalaya',
'Nonglyer,Meghalaya,Meghalaya',
'Nongmynsong,Meghalaya,Meghalaya',
'Nongthymmai,Meghalaya,Meghalaya',
'Oakland,Meghalaya,Meghalaya',
'Phudmawri,Meghalaya,Meghalaya',
'Rilbong,Meghalaya,Meghalaya',
'Rynjah,Meghalaya,Meghalaya',
'Shillong G.P.O.,Meghalaya,Meghalaya',
'Smit,Meghalaya,Meghalaya',
'Upper Shillong,Meghalaya,Meghalaya',
'Jongksha,Meghalaya,Meghalaya',
'Kharang,Meghalaya,Meghalaya',
'Lynshing,Meghalaya,Meghalaya',
'Mawkynrew,Meghalaya,Meghalaya',
'Mawlat,Meghalaya,Meghalaya',
'Mawlong,Meghalaya,Meghalaya',
'Mawlyngngad,Meghalaya,Meghalaya',
'Nongkrem,Meghalaya,Meghalaya',
'Ryngibah,Meghalaya,Meghalaya',
'Sohryngkham,Meghalaya,Meghalaya',
'Thangsning,Meghalaya,Meghalaya',
'Thynroit,Meghalaya,Meghalaya',
'Umphyrnai,Meghalaya,Meghalaya',
'Umsning,Meghalaya,Meghalaya',
'Sumer,Meghalaya,Meghalaya',
'Diengiei,Meghalaya,Meghalaya',
'Nongumlong,Meghalaya,Meghalaya',
'Khatum,Meghalaya,Meghalaya',
'Umkiang,Meghalaya,Meghalaya',
'Yalang,Meghalaya,Meghalaya',
'Amlari,Meghalaya,Meghalaya',
'Darrang,Meghalaya,Meghalaya',
'Lamin,Meghalaya,Meghalaya',
'Lyngkhat,Meghalaya,Meghalaya',
'Muktapur,Meghalaya,Meghalaya',
'Naljuri,Meghalaya,Meghalaya',
'Nongbareh,Meghalaya,Meghalaya',
'Nongtalang,Meghalaya,Meghalaya',
'Nongtyngur,Meghalaya,Meghalaya',
'Padu,Meghalaya,Meghalaya',
'Pamshutia,Meghalaya,Meghalaya',
'Passadwar,Meghalaya,Meghalaya',
'Pongtung,Meghalaya,Meghalaya',
'Rongkhum,Meghalaya,Meghalaya',
'Sohkha,Meghalaya,Meghalaya',
'Syndai,Meghalaya,Meghalaya',
'Amlarem,Meghalaya,Meghalaya',
'Barato,Meghalaya,Meghalaya',
'Iawthymmai,Meghalaya,Meghalaya',
'Jarain,Meghalaya,Meghalaya',
'Jowai,Meghalaya,Meghalaya',
'Raksamgiri,Meghalaya,Meghalaya',
'Tikrikilla,Meghalaya,Meghalaya',
'Tura H.O,Meghalaya,Meghalaya',
'Nongnah,Meghalaya,Meghalaya',
'Puksora,Meghalaya,Meghalaya',
'Rajapara,Meghalaya,Meghalaya',
'Ranikor,Meghalaya,Meghalaya',
'Rongasora,Meghalaya,Meghalaya',
'Sarin,Meghalaya,Meghalaya',
'Umpung,Meghalaya,Meghalaya',
'Borsora,Meghalaya,Meghalaya',
'Dungki - Ingdong,Meghalaya,Meghalaya',
'Iewmaroid,Meghalaya,Meghalaya',
'Khlieh Lyngkhoi,Meghalaya,Meghalaya',
'Kynrut,Meghalaya,Meghalaya',
'Kynshi,Meghalaya,Meghalaya',
'Laitdombah,Meghalaya,Meghalaya',
'Langtor,Meghalaya,Meghalaya',
'Lawbyrtun,Meghalaya,Meghalaya',
'Lyngkhoi,Meghalaya,Meghalaya',
'Madanbynther,Meghalaya,Meghalaya',
'Mairang,Meghalaya,Meghalaya',
'Manai,Meghalaya,Meghalaya',
'Mawkarah,Meghalaya,Meghalaya',
'Myriaw,Meghalaya,Meghalaya',
'Nongkhlaw,Meghalaya,Meghalaya',
'Nongthliew,Meghalaya,Meghalaya',
'Nongum,Meghalaya,Meghalaya',
'Pariong,Meghalaya,Meghalaya',
'Tihnongbah,Meghalaya,Meghalaya',
'Umkrem,Meghalaya,Meghalaya',
'Umthlong,Meghalaya,Meghalaya',
'Mawshut,Meghalaya,Meghalaya',
'Jakrem,Meghalaya,Meghalaya',
'Jashier,Meghalaya,Meghalaya',
'Laitnongrim,Meghalaya,Meghalaya',
'Mawkyrwat,Meghalaya,Meghalaya',
'Mawlyngwir,Meghalaya,Meghalaya',
'Mawsaw,Meghalaya,Meghalaya',
'Mawten,Meghalaya,Meghalaya',
'Mawthapdoh,Meghalaya,Meghalaya',
'Ngunraw,Meghalaya,Meghalaya',
'Nonglang,Meghalaya,Meghalaya',
'Nongsynrih,Meghalaya,Meghalaya',
'Phlang Kynshi,Meghalaya,Meghalaya',
'Phudjaud,Meghalaya,Meghalaya',
'Pyndemsakwang,Meghalaya,Meghalaya',
'Rangmaw,Meghalaya,Meghalaya',
'Rangthong,Meghalaya,Meghalaya',
'Sngimawlein,Meghalaya,Meghalaya',
'Umjarain,Meghalaya,Meghalaya',
'Mawtiehbah,Meghalaya,Meghalaya',
'Byrki,Meghalaya,Meghalaya',
'Jaidoh,Meghalaya,Meghalaya',
'Khliehmawlieh,Meghalaya,Meghalaya',
'Laitkseh,Meghalaya,Meghalaya',
'Langdongdai,Meghalaya,Meghalaya',
'Marskuin,Meghalaya,Meghalaya',
'Maweitlyngngam,Meghalaya,Meghalaya',
'Mawkohngei,Meghalaya,Meghalaya',
'Mawlieh,Meghalaya,Meghalaya',
'Mawthengkut,Meghalaya,Meghalaya',
'Mawthungkper,Meghalaya,Meghalaya',
'Nongbah,Meghalaya,Meghalaya',
'Nongkasen,Meghalaya,Meghalaya',
'Nonglang,Meghalaya,Meghalaya',
'Nongpyndeng,Meghalaya,Meghalaya',
'Nongsdad Dkhar,Meghalaya,Meghalaya',
'Nongshyrkon,Meghalaya,Meghalaya',
'Nongstoin,Meghalaya,Meghalaya',
'Nongthynniew,Meghalaya,Meghalaya',
'Pam Briew,Meghalaya,Meghalaya',
'Phlangdiloin,Meghalaya,Meghalaya',
'Pyndengrei,Meghalaya,Meghalaya',
'Rambrai,Meghalaya,Meghalaya',
'Rangblang,Meghalaya,Meghalaya',
'Riangdo Bazar,Meghalaya,Meghalaya',
'Seinduli Bazar,Meghalaya,Meghalaya',
'Shallang,Meghalaya,Meghalaya',
'Thangpylleng Pyndemkseh,Meghalaya,Meghalaya',
'Umdohlun,Meghalaya,Meghalaya',
'Umsohpieng,Meghalaya,Meghalaya',
'Umyap,Meghalaya,Meghalaya',
'Wahkaji,Meghalaya,Meghalaya',
'Bualpui H,Mizoram,Mizoram',
'Aibawk,Mizoram,Mizoram',
'Hmuifang,Mizoram,Mizoram',
'Lamchhip,Mizoram,Mizoram',
'Maubuang,Mizoram,Mizoram',
'Phulpui,Mizoram,Mizoram',
'Sailam,Mizoram,Mizoram',
'Samlukhai,Mizoram,Mizoram',
'Sateek,Mizoram,Mizoram',
'Sumsuih,Mizoram,Mizoram',
'Tachhip,Mizoram,Mizoram',
'Thiak,Mizoram,Mizoram',
'Aizawl H.O,Mizoram,Mizoram',
'Bawngkawn,Mizoram,Mizoram',
'Lungdai,Mizoram,Mizoram',
'Muthi,Mizoram,Mizoram',
'Selesih,Mizoram,Mizoram',
'Zanlawn,Mizoram,Mizoram',
'Armed Veng,Mizoram,Mizoram',
'Bethlehem,Mizoram,Mizoram',
'Bukpui,Mizoram,Mizoram',
'Chandmary,Mizoram,Mizoram',
'Electric Veng,Mizoram,Mizoram',
'Lungmuat,Mizoram,Mizoram',
'N.Chaltlang,Mizoram,Mizoram',
'N.Hlimen,Mizoram,Mizoram',
'Ramthar,Mizoram,Mizoram',
'Serkhan,Mizoram,Mizoram',
'Thingthelh,Mizoram,Mizoram',
'Tuithiang,Mizoram,Mizoram',
'Nisapui,Mizoram,Mizoram',
'Darlawn,Mizoram,Mizoram',
'Khawpuar,Mizoram,Mizoram',
'Lungsum,Mizoram,Mizoram',
'Mauchar,Mizoram,Mizoram',
'N.Serzawl,Mizoram,Mizoram',
'N.Tinghmun,Mizoram,Mizoram',
'New Vervek,Mizoram,Mizoram',
'Palsang,Mizoram,Mizoram',
'Ratu,Mizoram,Mizoram',
'Sailutar,Mizoram,Mizoram',
'Sakawrdai,Mizoram,Mizoram',
'Thingsat,Mizoram,Mizoram',
'Vaitin,Mizoram,Mizoram',
'Vervek,Mizoram,Mizoram',
'Zohmun,Mizoram,Mizoram',
'Dawrpui,Mizoram,Mizoram',
'Durtlang,Mizoram,Mizoram',
'Bungkawn,Mizoram,Mizoram',
'College Veng,Mizoram,Mizoram',
'Hualngohmun,Mizoram,Mizoram',
'Kelsih,Mizoram,Mizoram',
'Khawchhete,Mizoram,Mizoram',
'Kulikawn,Mizoram,Mizoram',
'Maubawk,Mizoram,Mizoram',
'Missionvengthlang,Mizoram,Mizoram',
'Muallungthu,Mizoram,Mizoram',
'Mualmawi,Mizoram,Mizoram',
'Mualpui,Mizoram,Mizoram',
'N.Lungleng,Mizoram,Mizoram',
'Republic Veng,Mizoram,Mizoram',
'S,hlimen,Mizoram,Mizoram',
'Sabualkawn,Mizoram,Mizoram',
'Thakthingbazar,Mizoram,Mizoram',
'Thingdawlmelriat,Mizoram,Mizoram',
'Lengpui Airport,Mizoram,Mizoram',
'Chaltlang,Mizoram,Mizoram',
'Ramhlun,Mizoram,Mizoram',
'Aiduzawl,Mizoram,Mizoram',
'Buhban,Mizoram,Mizoram',
'Changzawl,Mizoram,Mizoram',
'Daido,Mizoram,Mizoram',
'Keifang,Mizoram,Mizoram',
'Khawlian,Mizoram,Mizoram',
'Luangpawn,Mizoram,Mizoram',
'Lungpher \'N\',Mizoram,Mizoram',
'Maite,Mizoram,Mizoram',
'Mualpheng,Mizoram,Mizoram',
'N.E.Bualpui,Mizoram,Mizoram',
'N.Khawlek,Mizoram,Mizoram',
'Pawlrang,Mizoram,Mizoram',
'Phuaibuang,Mizoram,Mizoram',
'Phullen,Mizoram,Mizoram',
'Ruallung,Mizoram,Mizoram',
'Saichal,Mizoram,Mizoram',
'Saitual,Mizoram,Mizoram',
'Sihfa,Mizoram,Mizoram',
'Suangpuilawn,Mizoram,Mizoram',
'Tualbung,Mizoram,Mizoram',
'Vanbawng,Mizoram,Mizoram',
'Zawngin,Mizoram,Mizoram',
'Sialsuk,Mizoram,Mizoram',
'Sihphir,Mizoram,Mizoram',
'Baktawng,Mizoram,Mizoram',
'Chhingchhip,Mizoram,Mizoram',
'Hmuntha,Mizoram,Mizoram',
'Hualtu,Mizoram,Mizoram',
'Khawbel,Mizoram,Mizoram',
'Khumtung,Mizoram,Mizoram',
'Seling,Mizoram,Mizoram',
'Thentlang,Mizoram,Mizoram',
'Thingsulthliah,Mizoram,Mizoram',
'Tlungvel,Mizoram,Mizoram',
'Tlangnuam,Mizoram,Mizoram',
'Chawlhhmun,Mizoram,Mizoram',
'Dinthar,Mizoram,Mizoram',
'Govt. Complex,Mizoram,Mizoram',
'Luangmual,Mizoram,Mizoram',
'Mizoram University,Mizoram,Mizoram',
'Rangvamual,Mizoram,Mizoram',
'Sakawrtuichhun,Mizoram,Mizoram',
'Tanhril,Mizoram,Mizoram',
'Vaivakawn,Mizoram,Mizoram',
'Boraibazar,Mizoram,Mizoram',
'Hriphaw,Mizoram,Mizoram',
'Kanhmunbazar,Mizoram,Mizoram',
'Lushaicherra,Mizoram,Mizoram',
'Momcherra,Mizoram,Mizoram',
'Zamuang,Mizoram,Mizoram',
'Zawlnuam,Mizoram,Mizoram',
'Cti Sesawng,Mizoram,Mizoram',
'Kepran,Mizoram,Mizoram',
'Khanpui,Mizoram,Mizoram',
'Khawruhlian,Mizoram,Mizoram',
'Phaileng \'E\',Mizoram,Mizoram',
'Sawleng,Mizoram,Mizoram',
'Sesawng,Mizoram,Mizoram',
'Zemabawk,Mizoram,Mizoram',
'Zuangtui,Mizoram,Mizoram',
'Champhai,Mizoram,Mizoram',
'Chhawkhlei,Mizoram,Mizoram',
'Hmunhmeltha,Mizoram,Mizoram',
'Hnahlan,Mizoram,Mizoram',
'Hruaikawn,Mizoram,Mizoram',
'Kelkang,Mizoram,Mizoram',
'Khawnuam,Mizoram,Mizoram',
'Khuangleng,Mizoram,Mizoram',
'Khuangphah,Mizoram,Mizoram',
'Leisenzo,Mizoram,Mizoram',
'Lungphunlian,Mizoram,Mizoram',
'Maulkawi,Mizoram,Mizoram',
'Murlen,Mizoram,Mizoram',
'N.Khawbung,Mizoram,Mizoram',
'Ngur,Mizoram,Mizoram',
'Ruantlang,Mizoram,Mizoram',
'Sesih,Mizoram,Mizoram',
'Tlangsam,Mizoram,Mizoram',
'Tualcheng,Mizoram,Mizoram',
'Vapar,Mizoram,Mizoram',
'Vengthlang,Mizoram,Mizoram',
'Zote \'e\',Mizoram,Mizoram',
'Haulawng,Mizoram,Mizoram',
'Hnahchang,Mizoram,Mizoram',
'Mualthuam \'N\',Mizoram,Mizoram',
'Pukpui,Mizoram,Mizoram',
'Ramlaitui,Mizoram,Mizoram',
'Serkawn,Mizoram,Mizoram',
'Zotlang,Mizoram,Mizoram',
'Dampui,Mizoram,Mizoram',
'Darlak,Mizoram,Mizoram',
'Kawrtethawveng,Mizoram,Mizoram',
'Kawrthah,Mizoram,Mizoram',
'Mamit,Mizoram,Mizoram',
'N.Sabual,Mizoram,Mizoram',
'Rengdil,Mizoram,Mizoram',
'Serhmun,Mizoram,Mizoram',
'Tlangkhang,Mizoram,Mizoram',
'Tuidam,Mizoram,Mizoram',
'Damparengpui,Mizoram,Mizoram',
'Hnahva,Mizoram,Mizoram',
'Khawhnai,Mizoram,Mizoram',
'Lallen,Mizoram,Mizoram',
'Marpara,Mizoram,Mizoram',
'N.Chhippui,Mizoram,Mizoram',
'Parvatui,Mizoram,Mizoram',
'Phaileng,Mizoram,Mizoram',
'Phuldungsei,Mizoram,Mizoram',
'Pukzing,Mizoram,Mizoram',
'Saithah,Mizoram,Mizoram',
'Silsury,Mizoram,Mizoram',
'Tuipuibari,Mizoram,Mizoram',
'Ailawng,Mizoram,Mizoram',
'Darlung,Mizoram,Mizoram',
'Kanghmun,Mizoram,Mizoram',
'Khawrihnim,Mizoram,Mizoram',
'Lungdar \'W\',Mizoram,Mizoram',
'Reiek,Mizoram,Mizoram',
'Rulpuihlim,Mizoram,Mizoram',
'S.Sabual,Mizoram,Mizoram',
'Dapchhuah,Mizoram,Mizoram',
'Hmunpui,Mizoram,Mizoram',
'Lengpui,Mizoram,Mizoram',
'Mualkhang,Mizoram,Mizoram',
'Ptc Lungverh,Mizoram,Mizoram',
'Rawpuichhip,Mizoram,Mizoram',
'Sairang,Mizoram,Mizoram',
'Bualpui \'ng\',Mizoram,Mizoram',
'Chakhang,Mizoram,Mizoram',
'Chapui,Mizoram,Mizoram',
'Chhuarlung,Mizoram,Mizoram',
'Fungkah,Mizoram,Mizoram',
'Lungbun,Mizoram,Mizoram',
'Lungpher \'S\',Mizoram,Mizoram',
'New Maubawk,Mizoram,Mizoram',
'Rawmibawk,Mizoram,Mizoram',
'Saiha,Mizoram,Mizoram',
'Tuipuiferry,Mizoram,Mizoram',
'Vawmbuk,Mizoram,Mizoram',
'Niawhtlang,Mizoram,Mizoram',
'Siata,Mizoram,Mizoram',
'Theiva,Mizoram,Mizoram',
'Khopai,Mizoram,Mizoram',
'Laki,Mizoram,Mizoram',
'Latawh,Mizoram,Mizoram',
'Lawngban,Mizoram,Mizoram',
'Phura,Mizoram,Mizoram',
'Serkawr,Mizoram,Mizoram',
'Tongkolong,Mizoram,Mizoram',
'Tuipang,Mizoram,Mizoram',
'Tuisih,Mizoram,Mizoram',
'Vahai,Mizoram,Mizoram',
'Zawngling,Mizoram,Mizoram',
'Biate,Mizoram,Mizoram',
'Lungdar,Mizoram,Mizoram',
'Bungtlang \'N\',Mizoram,Mizoram',
'Chekawn,Mizoram,Mizoram',
'Chhiahtlang,Mizoram,Mizoram',
'Chhipphir,Mizoram,Mizoram',
'Kanghmun \'S\',Mizoram,Mizoram',
'Keitum,Mizoram,Mizoram',
'Khawlailung,Mizoram,Mizoram',
'Leng,Mizoram,Mizoram',
'Lungchhuan,Mizoram,Mizoram',
'Lungkawlh,Mizoram,Mizoram',
'Lungpho,Mizoram,Mizoram',
'Mualcheng,Mizoram,Mizoram',
'N.Vanlaiphai,Mizoram,Mizoram',
'New Serchhip,Mizoram,Mizoram',
'Sailulak,Mizoram,Mizoram',
'Serchhip,Mizoram,Mizoram',
'Sialhau,Mizoram,Mizoram',
'Sialhawk,Mizoram,Mizoram',
'Sialsir,Mizoram,Mizoram',
'Thenzawl,Mizoram,Mizoram',
'Thinglian,Mizoram,Mizoram',
'Tlangpui,Mizoram,Mizoram',
'Zote \'S\',Mizoram,Mizoram',
'Aoyimti,Nagaland,Nagaland',
'Daroga Pathar,Nagaland,Nagaland',
'Diphupar,Nagaland,Nagaland',
'Eralibill,Nagaland,Nagaland',
'Showba Old,Nagaland,Nagaland',
'Suger Mill,Nagaland,Nagaland',
'Sukhovi,Nagaland,Nagaland',
'Khopoanaula,Nagaland,Nagaland',
'Moaikam,Nagaland,Nagaland',
'Nihekhu,Nagaland,Nagaland',
'P C College,Nagaland,Nagaland',
'Pimla,Nagaland,Nagaland',
'Tenyiphe,Nagaland,Nagaland',
'Artc,Nagaland,Nagaland',
'Chumukedima,Nagaland,Nagaland',
'Circular Road,Nagaland,Nagaland',
'Dimapur Bazar,Nagaland,Nagaland',
'Dimapur,Nagaland,Nagaland',
'Medziphema,Nagaland,Nagaland',
'New Nepaligaon,Nagaland,Nagaland',
'Khehekhu,Nagaland,Nagaland',
'Kuhuboto,Nagaland,Nagaland',
'Kushiabill,Nagaland,Nagaland',
'Padampukhuri,Nagaland,Nagaland',
'Vihokhu,Nagaland,Nagaland',
'Doyapur,Nagaland,Nagaland',
'Hening Kunglwa,Nagaland,Nagaland',
'Jalukiekam,Nagaland,Nagaland',
'Khermahal,Nagaland,Nagaland',
'Kuda,Nagaland,Nagaland',
'Nuiland,Nagaland,Nagaland',
'Phaipijan,Nagaland,Nagaland',
'Pwd Colony,Nagaland,Nagaland',
'Ralan,Nagaland,Nagaland',
'Rangapahar,Nagaland,Nagaland',
'Razaphima,Nagaland,Nagaland',
'Singal Village,Nagaland,Nagaland',
'Singrijan,Nagaland,Nagaland',
'Thahekhu,Nagaland,Nagaland',
'Yampha,Nagaland,Nagaland',
'Zeliangrong,Nagaland,Nagaland',
'Agri College,Nagaland,Nagaland',
'Jharnapani,Nagaland,Nagaland',
'Khaibung,Nagaland,Nagaland',
'Chozuba,Nagaland,Nagaland',
'Ketsapo,Nagaland,Nagaland',
'Khuzami,Nagaland,Nagaland',
'Losami,Nagaland,Nagaland',
'Luzaphuhu,Nagaland,Nagaland',
'Meluri,Nagaland,Nagaland',
'Old Phek,Nagaland,Nagaland',
'Pfutsero,Nagaland,Nagaland',
'Phek,Nagaland,Nagaland',
'Zavame,Nagaland,Nagaland',
'Angangba,Nagaland,Nagaland',
'Chungtore,Nagaland,Nagaland',
'Kongsang,Nagaland,Nagaland',
'Noksen,Nagaland,Nagaland',
'Yangli,Nagaland,Nagaland',
'Chimonger,Nagaland,Nagaland',
'Choklangan,Nagaland,Nagaland',
'Nokhu,Nagaland,Nagaland',
'Pangsha,Nagaland,Nagaland',
'Pessu,Nagaland,Nagaland',
'Sanglao,Nagaland,Nagaland',
'Chessore,Nagaland,Nagaland',
'Chingmei,Nagaland,Nagaland',
'Huker,Nagaland,Nagaland',
'Kuthur,Nagaland,Nagaland',
'Longkhim,Nagaland,Nagaland',
'Noklak,Nagaland,Nagaland',
'Panso,Nagaland,Nagaland',
'Sangsanyu,Nagaland,Nagaland',
'Saramati,Nagaland,Nagaland',
'Shamator,Nagaland,Nagaland',
'Shampur,Nagaland,Nagaland',
'Shiponger,Nagaland,Nagaland',
'Sotokur,Nagaland,Nagaland',
'Thonokhunyu,Nagaland,Nagaland',
'Tuensang,Nagaland,Nagaland',
'Tuensang Village,Nagaland,Nagaland',
'Aitepyong,Nagaland,Nagaland',
'Baghty,Nagaland,Nagaland',
'Englan,Nagaland,Nagaland',
'Longtsung,Nagaland,Nagaland',
'Lotsu,Nagaland,Nagaland',
'Moilan,Nagaland,Nagaland',
'Sanis,Nagaland,Nagaland',
'Yamhon,Nagaland,Nagaland',
'Bhandari,Nagaland,Nagaland',
'Chukitong,Nagaland,Nagaland',
'Doyang Hydel Project,Nagaland,Nagaland',
'Elumnyu,Nagaland,Nagaland',
'Humtsu,Nagaland,Nagaland',
'Mekhukla,Nagaland,Nagaland',
'N. Longidong,Nagaland,Nagaland',
'Nyiro,Nagaland,Nagaland',
'Pangti,Nagaland,Nagaland',
'Pongitong,Nagaland,Nagaland',
'Sungro,Nagaland,Nagaland',
'Tsungtsutong,Nagaland,Nagaland',
'Wokha,Nagaland,Nagaland',
'Wokha Village,Nagaland,Nagaland',
'Wozhru,Nagaland,Nagaland',
'Yikhum,Nagaland,Nagaland',
'Aizuto,Nagaland,Nagaland',
'Akuhaito,Nagaland,Nagaland',
'Asukuto,Nagaland,Nagaland',
'Aghunato,Nagaland,Nagaland',
'Akuluto,Nagaland,Nagaland',
'Asukhomi,Nagaland,Nagaland',
'Asuto,Nagaland,Nagaland',
'Hosephu,Nagaland,Nagaland',
'Kichilimi,Nagaland,Nagaland',
'Phisami,Nagaland,Nagaland',
'Saghemi,Nagaland,Nagaland',
'Satakha,Nagaland,Nagaland',
'Satami,Nagaland,Nagaland',
'Satoi,Nagaland,Nagaland',
'Suruhuto,Nagaland,Nagaland',
'Surumi,Nagaland,Nagaland',
'Tokiye,Nagaland,Nagaland',
'Zunheboto,Nagaland,Nagaland',
'Angul Bazar,Dhenkanal,Orissa',
'Angul H.O,Dhenkanal,Orissa',
'Ankula,Dhenkanal,Orissa',
'Arahat,Dhenkanal,Orissa',
'Badakantakul,Dhenkanal,Orissa',
'Badakera,Dhenkanal,Orissa',
'Badakhali,Dhenkanal,Orissa',
'Badkerjang,Dhenkanal,Orissa',
'Bagedia,Dhenkanal,Orissa',
'Balanga,Dhenkanal,Orissa',
'Balaramprasad,Dhenkanal,Orissa',
'Balasinga,Dhenkanal,Orissa',
'Balipatta,Dhenkanal,Orissa',
'Baluakata,Dhenkanal,Orissa',
'Banarpal,Dhenkanal,Orissa',
'Bantala,Dhenkanal,Orissa',
'Baragounia,Dhenkanal,Orissa',
'Barasahi,Dhenkanal,Orissa',
'Basala,Dhenkanal,Orissa',
'Basantapur,Dhenkanal,Orissa',
'Bedasasan,Dhenkanal,Orissa',
'Bonda,Dhenkanal,Orissa',
'Brahmanbil,Dhenkanal,Orissa',
'Budhapanka,Dhenkanal,Orissa',
'Champatimunda,Dhenkanal,Orissa',
'Changudia,Dhenkanal,Orissa',
'Dhokuta,Dhenkanal,Orissa',
'Garh Santiri,Dhenkanal,Orissa',
'Garh Taras,Dhenkanal,Orissa',
'Golabandha,Dhenkanal,Orissa',
'Gotamara,Dhenkanal,Orissa',
'Hakimpada,Dhenkanal,Orissa',
'Hamamira,Dhenkanal,Orissa',
'Hulurisinga,Dhenkanal,Orissa',
'Inkarabandha,Dhenkanal,Orissa',
'Jagannathpur,Dhenkanal,Orissa',
'Jarasingha,Dhenkanal,Orissa',
'Kalandapal,Dhenkanal,Orissa',
'Kampsala,Dhenkanal,Orissa',
'Kanaloi,Dhenkanal,Orissa',
'Kandasar,Dhenkanal,Orissa',
'Kangula,Dhenkanal,Orissa',
'Karadagadia,Dhenkanal,Orissa',
'Khalari,Dhenkanal,Orissa',
'Khalibereni,Dhenkanal,Orissa',
'Khandahatta,Dhenkanal,Orissa',
'Khinda,Dhenkanal,Orissa',
'Kosala,Dhenkanal,Orissa',
'Kuio,Dhenkanal,Orissa',
'Kukudang,Dhenkanal,Orissa',
'Kukurpeta,Dhenkanal,Orissa',
'Kulad,Dhenkanal,Orissa',
'Kumanda,Dhenkanal,Orissa',
'Kumursinga,Dhenkanal,Orissa',
'Kurudol,Dhenkanal,Orissa',
'Machhakuta,Dhenkanal,Orissa',
'Manapur,Dhenkanal,Orissa',
'Nalconagar,Dhenkanal,Orissa',
'Nandapur,Dhenkanal,Orissa',
'Natada,Dhenkanal,Orissa',
'Nisha,Dhenkanal,Orissa',
'Nuagaon,Dhenkanal,Orissa',
'Nuahata,Dhenkanal,Orissa',
'Nuakheta,Dhenkanal,Orissa',
'Nuapada,Dhenkanal,Orissa',
'P.T.C.,Angul,Dhenkanal,Orissa',
'Parang,Dhenkanal,Orissa',
'Paratara,Dhenkanal,Orissa',
'Patakumunda,Dhenkanal,Orissa',
'Patrapada,Dhenkanal,Orissa',
'Pipalabahal,Dhenkanal,Orissa',
'Podapada,Dhenkanal,Orissa',
'Pokatunga,Dhenkanal,Orissa',
'Purunagarh,Dhenkanal,Orissa',
'Purunakote,Dhenkanal,Orissa',
'Raijharan,Dhenkanal,Orissa',
'Rantalei,Dhenkanal,Orissa',
'Sakasingha,Dhenkanal,Orissa',
'Sanjapada,Dhenkanal,Orissa',
'Sankapur,Dhenkanal,Orissa',
'Santarabandha,Dhenkanal,Orissa',
'Sapoinali,Dhenkanal,Orissa',
'Saradhapur,Dhenkanal,Orissa',
'Talagarh,Dhenkanal,Orissa',
'Tangiri,Dhenkanal,Orissa',
'Tentuloi,Dhenkanal,Orissa',
'Tikarapada,Dhenkanal,Orissa',
'Tubey,Dhenkanal,Orissa',
'Tulasipal,Dhenkanal,Orissa',
'Turang,Dhenkanal,Orissa',
'Aida,Dhenkanal,Orissa',
'Amabapal,Dhenkanal,Orissa',
'Ambasarmunda,Dhenkanal,Orissa',
'Angapada,Dhenkanal,Orissa',
'Athamallik,Dhenkanal,Orissa',
'Bamur,Dhenkanal,Orissa',
'Bhejigotha,Dhenkanal,Orissa',
'Bileinali,Dhenkanal,Orissa',
'Bimalabeda,Dhenkanal,Orissa',
'Dandasinga,Dhenkanal,Orissa',
'Durgapur,Dhenkanal,Orissa',
'Ghosar,Dhenkanal,Orissa',
'Handapa,Dhenkanal,Orissa',
'Himitira,Dhenkanal,Orissa',
'Jamudoli,Dhenkanal,Orissa',
'Jarada,Dhenkanal,Orissa',
'Jarapada,Dhenkanal,Orissa',
'Jeranga Dehuri Sahi,Dhenkanal,Orissa',
'Kadalimunda,Dhenkanal,Orissa',
'Kalyanpur,Dhenkanal,Orissa',
'Kampala,Dhenkanal,Orissa',
'Kandhapada,Dhenkanal,Orissa',
'Kantapada,Dhenkanal,Orissa',
'Kanteikolia,Dhenkanal,Orissa',
'Katada,Dhenkanal,Orissa',
'Kiakata,Dhenkanal,Orissa',
'Kishoreganj,Dhenkanal,Orissa',
'Korada,Dhenkanal,Orissa',
'Kothabhuin,Dhenkanal,Orissa',
'Krutibaspur,Dhenkanal,Orissa',
'Kudugaon,Dhenkanal,Orissa',
'Luhamunda,Dhenkanal,Orissa',
'Luhasinga,Dhenkanal,Orissa',
'Lunahandi,Dhenkanal,Orissa',
'Madhapur,Dhenkanal,Orissa',
'Maimura,Dhenkanal,Orissa',
'Nagaon,Dhenkanal,Orissa',
'Nakchi,Dhenkanal,Orissa',
'Oskapalli,Dhenkanal,Orissa',
'Paiksahi,Dhenkanal,Orissa',
'Papsara,Dhenkanal,Orissa',
'Para,Dhenkanal,Orissa',
'Pedipathar,Dhenkanal,Orissa',
'Puruna Manitiri,Dhenkanal,Orissa',
'Rainali,Dhenkanal,Orissa',
'Rajkishorenagar,Dhenkanal,Orissa',
'Raniakata,Dhenkanal,Orissa',
'Sanahulla,Dhenkanal,Orissa',
'Sanjamura,Dhenkanal,Orissa',
'Tainsi,Dhenkanal,Orissa',
'Tapdhol,Dhenkanal,Orissa',
'Thakurgarh,Dhenkanal,Orissa',
'Tukuda,Dhenkanal,Orissa',
'Tusar,Dhenkanal,Orissa',
'Ugi,Dhenkanal,Orissa',
'Urukela,Dhenkanal,Orissa',
'Chhendipada,Dhenkanal,Orissa',
'Akhuapal,Dhenkanal,Orissa',
'Badasada,Dhenkanal,Orissa',
'Bandhabhuin,Dhenkanal,Orissa',
'Barkotia,Dhenkanal,Orissa',
'Chasagurjang,Dhenkanal,Orissa',
'Dimiria,Dhenkanal,Orissa',
'Injidi,Dhenkanal,Orissa',
'Jamardihi,Dhenkanal,Orissa',
'Jharabeda,Dhenkanal,Orissa',
'Karadapal,Dhenkanal,Orissa',
'Khamar,Dhenkanal,Orissa',
'Khemla,Dhenkanal,Orissa',
'Kunjam,Dhenkanal,Orissa',
'Munduribeda,Dhenkanal,Orissa',
'Nagira,Dhenkanal,Orissa',
'Odasha,Dhenkanal,Orissa',
'Pallahara,Dhenkanal,Orissa',
'Phapanda,Dhenkanal,Orissa',
'Rajdang,Dhenkanal,Orissa',
'Sahara Gurjang,Dhenkanal,Orissa',
'Saida,Dhenkanal,Orissa',
'Sankhamur,Dhenkanal,Orissa',
'Seegarh,Dhenkanal,Orissa',
'Siarimalia,Dhenkanal,Orissa',
'Arkil,Dhenkanal,Orissa',
'Badagundari,Dhenkanal,Orissa',
'Badajarada,Dhenkanal,Orissa',
'Badatribida,Dhenkanal,Orissa',
'Bajrakote,Dhenkanal,Orissa',
'Balanda,Dhenkanal,Orissa',
'Balipasi,Dhenkanal,Orissa',
'Bijigol,Dhenkanal,Orissa',
'Biru,Dhenkanal,Orissa',
'Burukuna,Dhenkanal,Orissa',
'Chainpal Colony,Dhenkanal,Orissa',
'Chitrakut,Dhenkanal,Orissa',
'Danra,Dhenkanal,Orissa',
'Deepasikha,Dhenkanal,Orissa',
'Dera,Dhenkanal,Orissa',
'Derang,Dhenkanal,Orissa',
'Deulbera Colliery,Dhenkanal,Orissa',
'Dharampur,Dhenkanal,Orissa',
'Durgapur,Dhenkanal,Orissa',
'Ekagharia,Dhenkanal,Orissa',
'Gaham,Dhenkanal,Orissa',
'Gandamala,Dhenkanal,Orissa',
'Ghantapada,Dhenkanal,Orissa',
'Gobara,Dhenkanal,Orissa',
'Gopalprasad,Dhenkanal,Orissa',
'Gurujang,Dhenkanal,Orissa',
'Handidhua,Dhenkanal,Orissa',
'Hensamul,Dhenkanal,Orissa',
'Jagannathpur,Dhenkanal,Orissa',
'Jarada,Dhenkanal,Orissa',
'Kakudia,Dhenkanal,Orissa',
'Kalamchhuin,Dhenkanal,Orissa',
'Kandhalo,Dhenkanal,Orissa',
'Kaniha,Dhenkanal,Orissa',
'Kankili,Dhenkanal,Orissa',
'Kansamunda,Dhenkanal,Orissa',
'Kantiapasi,Dhenkanal,Orissa',
'Karnapur,Dhenkanal,Orissa',
'Kuluma,Dhenkanal,Orissa',
'Kumunda,Dhenkanal,Orissa',
'Nalam,Dhenkanal,Orissa',
'Nehru Satabdi Nagar(Bharatpu)r,Dhenkanal,Orissa',
'Padmabatipur,Dhenkanal,Orissa',
'Parabil,Dhenkanal,Orissa',
'Podagarh,Dhenkanal,Orissa',
'Poipal,Dhenkanal,Orissa',
'Radharamanpur,Dhenkanal,Orissa',
'Rengali,Dhenkanal,Orissa',
'Rengali Dam Site,Dhenkanal,Orissa',
'Samal,Dhenkanal,Orissa',
'Samal Barrage Township,Dhenkanal,Orissa',
'Sanatribida,Dhenkanal,Orissa',
'Santhapada,Dhenkanal,Orissa',
'Saradhapur,Dhenkanal,Orissa',
'Seepur,Dhenkanal,Orissa',
'Solada,Dhenkanal,Orissa',
'Talcher High School,Dhenkanal,Orissa',
'Talcher R.S.,Dhenkanal,Orissa',
'Talcher,Dhenkanal,Orissa',
'Talcher Thermal,Dhenkanal,Orissa',
'Talcher Town,Dhenkanal,Orissa',
'Tentulei,Dhenkanal,Orissa',
'Vikrampur,Dhenkanal,Orissa',
'Ankriapadar,Balangir,Orissa',
'Arjunda,Balangir,Orissa',
'Atgaon,Balangir,Orissa',
'B.Fatkara,Balangir,Orissa',
'Bahalpadar,Balangir,Orissa',
'Bairasar,Balangir,Orissa',
'Balangir Court,Balangir,Orissa',
'Balangir H.O,Balangir,Orissa',
'Balangir RS,Balangir,Orissa',
'Barpudigia,Balangir,Orissa',
'Bhaler,Balangir,Orissa',
'Bhundimuhan,Balangir,Orissa',
'Bhutiarbahal,Balangir,Orissa',
'Bidighat,Balangir,Orissa',
'Bileisarda,Balangir,Orissa',
'Bubel,Balangir,Orissa',
'Chandanbhati,Balangir,Orissa',
'Chhatamakhana,Balangir,Orissa',
'Chhatapipal,Balangir,Orissa',
'Churapali,Balangir,Orissa',
'College Square,Balangir,Orissa',
'Daspur,Balangir,Orissa',
'Deogaon,Balangir,Orissa',
'Dumerpita,Balangir,Orissa',
'Durgapali,Balangir,Orissa',
'Fatkara,Balangir,Orissa',
'Gaintala,Balangir,Orissa',
'Gandhi Nagar,Balangir,Orissa',
'Jamgaon,Balangir,Orissa',
'Jhankarpali,Balangir,Orissa',
'Khaliapali,Balangir,Orissa',
'Kharjura,Balangir,Orissa',
'Khujenpali,Balangir,Orissa',
'Kudasingha,Balangir,Orissa',
'Kurul,Balangir,Orissa',
'Mahimunda,Balangir,Orissa',
'Malmunda,Balangir,Orissa',
'Manhira,Balangir,Orissa',
'Manoharpur,Balangir,Orissa',
'Marwari Bazar,Balangir,Orissa',
'Mirdhapali,Balangir,Orissa',
'Patharla,Balangir,Orissa',
'Pipirda,Balangir,Orissa',
'Puintala,Balangir,Orissa',
'Rajendra College,Balangir,Orissa',
'Randa,Balangir,Orissa',
'Rugudi Para,Balangir,Orissa',
'Sadeipali,Balangir,Orissa',
'Sahajbahal,Balangir,Orissa',
'Sakma,Balangir,Orissa',
'Sauntput,Balangir,Orissa',
'Sibtala,Balangir,Orissa',
'Sikachhida,Balangir,Orissa',
'Sudpara,Balangir,Orissa',
'Talpalipara,Balangir,Orissa',
'Thelkomunda,Balangir,Orissa',
'Tikrapara,Balangir,Orissa',
'Alanda,Balangir,Orissa',
'Badbanki,Balangir,Orissa',
'Baddakala,Balangir,Orissa',
'Banganmura,Balangir,Orissa',
'Belpara,Balangir,Orissa',
'Bhalumunda,Balangir,Orissa',
'Bhusaguda,Balangir,Orissa',
'Biripali,Balangir,Orissa',
'Chandotara,Balangir,Orissa',
'Chatuanka,Balangir,Orissa',
'Chaulsukha,Balangir,Orissa',
'Chuliphunka,Balangir,Orissa',
'Dedgaon,Balangir,Orissa',
'Dhamandanga,Balangir,Orissa',
'Dholmandal,Balangir,Orissa',
'Ghunesh,Balangir,Orissa',
'Jamkhunta,Balangir,Orissa',
'Jharial,Balangir,Orissa',
'Kantabanji Bazar,Balangir,Orissa',
'Kantabanji RS,Balangir,Orissa',
'Kantabanji,Balangir,Orissa',
'Kapalabhata,Balangir,Orissa',
'Khagsa,Balangir,Orissa',
'Khaira,Balangir,Orissa',
'Khujenbahali,Balangir,Orissa',
'Kuibahal,Balangir,Orissa',
'Kukurahad,Balangir,Orissa',
'Mahakhand,Balangir,Orissa',
'Mahulbahali,Balangir,Orissa',
'Mahulpati,Balangir,Orissa',
'Mundpadar,Balangir,Orissa',
'Salebarat,Balangir,Orissa',
'Salemudga,Balangir,Orissa',
'Sanmula,Balangir,Orissa',
'Sargul,Balangir,Orissa',
'Titisilet,Balangir,Orissa',
'Turekela,Balangir,Orissa',
'Agalapali,Balangir,Orissa',
'Agalpur,Balangir,Orissa',
'Badibahal,Balangir,Orissa',
'Badimunda,Balangir,Orissa',
'Badtika,Balangir,Orissa',
'Bakti,Balangir,Orissa',
'Bendra,Balangir,Orissa',
'Bharsuja,Balangir,Orissa',
'Burda,Balangir,Orissa',
'Duduka,Balangir,Orissa',
'G.S. Dungripali,Balangir,Orissa',
'Hirapur,Balangir,Orissa',
'Jharnipali,Balangir,Orissa',
'Jogisarda,Balangir,Orissa',
'Kandajuri,Balangir,Orissa',
'Kusang,Balangir,Orissa',
'Kushmel,Balangir,Orissa',
'Kutasingha,Balangir,Orissa',
'Loisingha,Balangir,Orissa',
'Mursundhi,Balangir,Orissa',
'Nagaon,Balangir,Orissa',
'Nagaon,Balangir,Orissa',
'Pandesara,Balangir,Orissa',
'Pardhiapali,Balangir,Orissa',
'Patuapali,Balangir,Orissa',
'Rampur,Balangir,Orissa',
'Rengali,Balangir,Orissa',
'Rengali,Balangir,Orissa',
'Rinbachan,Balangir,Orissa',
'Roth,Balangir,Orissa',
'Taliudar,Balangir,Orissa',
'Budula,Balangir,Orissa',
'Salebhata,Balangir,Orissa',
'Sargad,Balangir,Orissa',
'Harisankar Road,Balangir,Orissa',
'Bagdor,Balangir,Orissa',
'Bagmund,Balangir,Orissa',
'Bahabal,Balangir,Orissa',
'Balipata,Balangir,Orissa',
'Baneimunda,Balangir,Orissa',
'Barbahal,Balangir,Orissa',
'Barpadar,Balangir,Orissa',
'Batharla,Balangir,Orissa',
'Belpara,Balangir,Orissa',
'Bender,Balangir,Orissa',
'Bhainsa,Balangir,Orissa',
'Bhanpur,Balangir,Orissa',
'Bichhubahali,Balangir,Orissa',
'Damaipali,Balangir,Orissa',
'Damkipali,Balangir,Orissa',
'Dedarha,Balangir,Orissa',
'Deulgaon,Balangir,Orissa',
'Dhandamunda,Balangir,Orissa',
'Dumabhata,Balangir,Orissa',
'Fulkimunda,Balangir,Orissa',
'Gambhari,Balangir,Orissa',
'Gangasagar,Balangir,Orissa',
'Ghagurli,Balangir,Orissa',
'Ghasian,Balangir,Orissa',
'Ghunsar,Balangir,Orissa',
'Jogimunda,Balangir,Orissa',
'Juba,Balangir,Orissa',
'K. Larambha,Balangir,Orissa',
'Kandhenjhula,Balangir,Orissa',
'Kanut,Balangir,Orissa',
'Kapani,Balangir,Orissa',
'Kendumundi,Balangir,Orissa',
'Khairmal,Balangir,Orissa',
'Khalipathar,Balangir,Orissa',
'Khaprakhol,Balangir,Orissa',
'Khuntsamalei,Balangir,Orissa',
'Kutmunda,Balangir,Orissa',
'Luhasingha,Balangir,Orissa',
'Maharapadar,Balangir,Orissa',
'Malpara,Balangir,Orissa',
'Mandal,Balangir,Orissa',
'Matikhai,Balangir,Orissa',
'Mudghat,Balangir,Orissa',
'Mundomahul,Balangir,Orissa',
'Nandupala,Balangir,Orissa',
'P.Rampur,Balangir,Orissa',
'Padhel,Balangir,Orissa',
'Padiabahal,Balangir,Orissa',
'Pandamunda,Balangir,Orissa',
'Patnagarh Bazar,Balangir,Orissa',
'Patnagarh,Balangir,Orissa',
'Phatamunda,Balangir,Orissa',
'Rengali,Balangir,Orissa',
'Salandi,Balangir,Orissa',
'Sarmuhan,Balangir,Orissa',
'Solbandh,Balangir,Orissa',
'Sulekela,Balangir,Orissa',
'Sunamudi,Balangir,Orissa',
'Sunamudi,Balangir,Orissa',
'Tamia,Balangir,Orissa',
'Tankapani,Balangir,Orissa',
'Telenpali,Balangir,Orissa',
'Tendapadar,Balangir,Orissa',
'Turla,Balangir,Orissa',
'Udiapali,Balangir,Orissa',
'Ulba,Balangir,Orissa',
'Darlipali,Balangir,Orissa',
'Dungripali,Balangir,Orissa',
'Adabahal,Balangir,Orissa',
'Ampali,Balangir,Orissa',
'Badsaimara,Balangir,Orissa',
'Bankel,Balangir,Orissa',
'Belgaon,Balangir,Orissa',
'Bhadra,Balangir,Orissa',
'Bhatipara,Balangir,Orissa',
'Bijepur,Balangir,Orissa',
'Binekela,Balangir,Orissa',
'Budhabahal,Balangir,Orissa',
'Chalki,Balangir,Orissa',
'Chantipala,Balangir,Orissa',
'Desil,Balangir,Orissa',
'Gandpatrapali,Balangir,Orissa',
'Ganrei,Balangir,Orissa',
'Ghantabahali,Balangir,Orissa',
'Ghunsar,Balangir,Orissa',
'Goilbhadi,Balangir,Orissa',
'Goimund,Balangir,Orissa',
'Gudighat,Balangir,Orissa',
'Haldi,Balangir,Orissa',
'Hatpadapara,Balangir,Orissa',
'Ichhapara,Balangir,Orissa',
'Jagua,Balangir,Orissa',
'Jurabandh,Balangir,Orissa',
'Kamarlaga,Balangir,Orissa',
'Kandhkelgaon,Balangir,Orissa',
'Karamtala,Balangir,Orissa',
'Katarkela,Balangir,Orissa',
'Khasbahal,Balangir,Orissa',
'Kholan,Balangir,Orissa',
'Kuanrgaon,Balangir,Orissa',
'Kumbhari,Balangir,Orissa',
'Kursud,Balangir,Orissa',
'Kuskela,Balangir,Orissa',
'Lebda,Balangir,Orissa',
'Lenjha,Balangir,Orissa',
'Luthurbandh,Balangir,Orissa',
'Maingaon,Balangir,Orissa',
'Malisira,Balangir,Orissa',
'Marlad,Balangir,Orissa',
'Muribahal,Balangir,Orissa',
'Naren,Balangir,Orissa',
'Of Badmal,Balangir,Orissa',
'Parasara,Balangir,Orissa',
'Patrapali,Balangir,Orissa',
'Rigdol,Balangir,Orissa',
'Saintala,Balangir,Orissa',
'Sihini,Balangir,Orissa',
'Siker,Balangir,Orissa',
'Sindhekela,Balangir,Orissa',
'Sirul,Balangir,Orissa',
'Siskela,Balangir,Orissa',
'Tentulikhunti,Balangir,Orissa',
'Tikrapara,Balangir,Orissa',
'Titilagarh Bazar,Balangir,Orissa',
'Titilagarh Court,Balangir,Orissa',
'Titilagarh,Balangir,Orissa',
'Totopara,Balangir,Orissa',
'Arjunpur,Balangir,Orissa',
'Badangomunda,Balangir,Orissa',
'Badbahal,Balangir,Orissa',
'Badbandh,Balangir,Orissa',
'Bandhpara,Balangir,Orissa',
'Dahimal,Balangir,Orissa',
'Desandh,Balangir,Orissa',
'Deulgudi,Balangir,Orissa',
'Dhandamal,Balangir,Orissa',
'Ghuna,Balangir,Orissa',
'Gourgoth,Balangir,Orissa',
'Gudvella,Balangir,Orissa',
'Jamut,Balangir,Orissa',
'Jarasingha,Balangir,Orissa',
'Kapsila,Balangir,Orissa',
'Kultapara,Balangir,Orissa',
'Landapathar,Balangir,Orissa',
'Mahalei,Balangir,Orissa',
'Makundpur,Balangir,Orissa',
'Mayabarha,Balangir,Orissa',
'Mursingh,Balangir,Orissa',
'Nuapara,Balangir,Orissa',
'Ramchandrapur,Balangir,Orissa',
'Rusuda,Balangir,Orissa',
'Salepali,Balangir,Orissa',
'Samra,Balangir,Orissa',
'Sikuan,Balangir,Orissa',
'Tandigaon,Balangir,Orissa',
'Tusra,Balangir,Orissa',
'Udar,Balangir,Orissa',
'Uparjhar,Balangir,Orissa',
'Dhanpur,Balangir,Orissa',
'Armala,Balasore,Orissa',
'Azimabad,Balasore,Orissa',
'Badapal,Balasore,Orissa',
'Badasindhia,Balasore,Orissa',
'Balaramgadi,Balasore,Orissa',
'Balasore Court,Balasore,Orissa',
'Balasore H.O,Balasore,Orissa',
'Balasore RS,Balasore,Orissa',
'Balia Farm,Balasore,Orissa',
'Bankeswar,Balasore,Orissa',
'Barabati,Balasore,Orissa',
'Bardhanpur,Balasore,Orissa',
'Bhimpur,Balasore,Orissa',
'Chandipur,Balasore,Orissa',
'Chasakhand,Balasore,Orissa',
'Chhanapur,Balasore,Orissa',
'Dahapada,Balasore,Orissa',
'Fakirmohan College,Balasore,Orissa',
'Fulwar-kaswa,Balasore,Orissa',
'Genguti,Balasore,Orissa',
'Ghodapada,Balasore,Orissa',
'Gobindpur,Balasore,Orissa',
'Gududapatna,Balasore,Orissa',
'Gudupai,Balasore,Orissa',
'Haripur,Balasore,Orissa',
'Hidigaon,Balasore,Orissa',
'Inchudi,Balasore,Orissa',
'Issannagar,Balasore,Orissa',
'Januganj,Balasore,Orissa',
'Jaydev Kasba,Balasore,Orissa',
'Kanrali,Balasore,Orissa',
'Kashimpur,Balasore,Orissa',
'Kuanrpur,Balasore,Orissa',
'Kuruda,Balasore,Orissa',
'Makalpur,Balasore,Orissa',
'Manikula,Balasore,Orissa',
'Motiganj,Balasore,Orissa',
'Naraharipur,Balasore,Orissa',
'Nayabazar Balasore,Balasore,Orissa',
'Nijampur,Balasore,Orissa',
'Panjibag,Balasore,Orissa',
'Parkhi,Balasore,Orissa',
'Puruna Balasore,Balasore,Orissa',
'Ranasahi,Balasore,Orissa',
'Rasalpur,Balasore,Orissa',
'Reserve Police Line,Balasore,Orissa',
'Sahada,Balasore,Orissa',
'Sahadevkhunta,Balasore,Orissa',
'Sahid Park,Balasore,Orissa',
'Sahupada,Balasore,Orissa',
'Sargaon,Balasore,Orissa',
'Sindhia,Balasore,Orissa',
'Somnathpur,Balasore,Orissa',
'Sovarampur,Balasore,Orissa',
'Srikanthapur,Balasore,Orissa',
'Srikona,Balasore,Orissa',
'Sunhat,Balasore,Orissa',
'Udambar,Balasore,Orissa',
'Asti,Balasore,Orissa',
'Badakuruda,Balasore,Orissa',
'Badas,Balasore,Orissa',
'Badasimulia,Balasore,Orissa',
'Badhapal,Balasore,Orissa',
'Bagada,Balasore,Orissa',
'Balarampur,Balasore,Orissa',
'Baliapal Katisahi,Balasore,Orissa',
'Baliapal Narayanpur,Balasore,Orissa',
'Baliapal,Balasore,Orissa',
'Beladandia,Balasore,Orissa',
'Belli,Balasore,Orissa',
'Betagadia,Balasore,Orissa',
'Bishnupur,Balasore,Orissa',
'Bolang,Balasore,Orissa',
'Chandamani,Balasore,Orissa',
'Chaumukh,Balasore,Orissa',
'Dagra,Balasore,Orissa',
'Dalua,Balasore,Orissa',
'Dangapita,Balasore,Orissa',
'Debhog,Balasore,Orissa',
'Gadasahi Baliapal,Balasore,Orissa',
'Ghantiary,Balasore,Orissa',
'Ghantua,Balasore,Orissa',
'Jagai,Balasore,Orissa',
'Jamatkula,Balasore,Orissa',
'Jambhirai,Balasore,Orissa',
'Jamkunda,Balasore,Orissa',
'Jathia,Balasore,Orissa',
'Jharapimpal,Balasore,Orissa',
'Karanja,Balasore,Orissa',
'Kashafal,Balasore,Orissa',
'Khalamuhani,Balasore,Orissa',
'Kumbhari,Balasore,Orissa',
'Machharanka Simulia,Balasore,Orissa',
'Mandhatabazar,Balasore,Orissa',
'Nadbani,Balasore,Orissa',
'Nangaleswar,Balasore,Orissa',
'Nepura,Balasore,Orissa',
'Nikhira,Balasore,Orissa',
'Nuagaon,Balasore,Orissa',
'Panchupalli,Balasore,Orissa',
'Panchurukhi,Balasore,Orissa',
'Paschima Bad,Balasore,Orissa',
'Pratappur,Balasore,Orissa',
'Rella,Balasore,Orissa',
'Saudi,Balasore,Orissa',
'Srirampur Road,Balasore,Orissa',
'Bartana,Bhadrak,Orissa',
'Haripur,Bhadrak,Orissa',
'Ratina,Bhadrak,Orissa',
'Alumeda,Balasore,Orissa',
'Amarda Road,Balasore,Orissa',
'Ambapunja,Balasore,Orissa',
'Anko,Balasore,Orissa',
'Bahabalpur,Balasore,Orissa',
'Baharda Bazar,Balasore,Orissa',
'Bamada,Balasore,Orissa',
'Barada,Balasore,Orissa',
'Barunagadia,Balasore,Orissa',
'Basta,Balasore,Orissa',
'Bidyadharpur,Balasore,Orissa',
'Buanl,Balasore,Orissa',
'Chakrada,Balasore,Orissa',
'Chaksartha,Balasore,Orissa',
'Chasipada,Balasore,Orissa',
'Chhanua,Balasore,Orissa',
'Chinchlagadia,Balasore,Orissa',
'Dandika,Balasore,Orissa',
'Darada,Balasore,Orissa',
'Dhitpura,Balasore,Orissa',
'Dhobachakurai,Balasore,Orissa',
'Digdha,Balasore,Orissa',
'Dublagadi,Balasore,Orissa',
'Gopinathpur,Balasore,Orissa',
'Gudikhal,Balasore,Orissa',
'Haladiapada,Balasore,Orissa',
'Haldipada,Balasore,Orissa',
'Hatiadiha,Balasore,Orissa',
'Irda,Balasore,Orissa',
'Jamalpur,Balasore,Orissa',
'Jamsuli,Balasore,Orissa',
'Jhinkiria,Balasore,Orissa',
'Khadikapada,Balasore,Orissa',
'Kothapada,Balasore,Orissa',
'Kothia,Balasore,Orissa',
'Kuldiha,Balasore,Orissa',
'Kushadiha (A),Balasore,Orissa',
'Kushadiha (B)church,Balasore,Orissa',
'Lachman Khunta,Balasore,Orissa',
'Machhadiha,Balasore,Orissa',
'Mandrukula,Balasore,Orissa',
'Mathani,Balasore,Orissa',
'Mohammad Nagar,Balasore,Orissa',
'Mukulisi,Balasore,Orissa',
'Nagram,Balasore,Orissa',
'Nalabahar,Balasore,Orissa',
'Nuagaon,Balasore,Orissa',
'Odangi,Balasore,Orissa',
'Olipur,Balasore,Orissa',
'Panchupada,Balasore,Orissa',
'Pandurangi,Balasore,Orissa',
'Routpada,Balasore,Orissa',
'Rupsa,Balasore,Orissa',
'Sadanandapur,Balasore,Orissa',
'Sargaon,Balasore,Orissa',
'Sartha,Balasore,Orissa',
'Singla,Balasore,Orissa',
'Solpata,Balasore,Orissa',
'Srirampur,Balasore,Orissa',
'Uitikiri,Balasore,Orissa',
'Vellora,Balasore,Orissa',
'Adangapantei,Balasore,Orissa',
'Alalbindha,Balasore,Orissa',
'Aruhabruti,Balasore,Orissa',
'Ausha,Balasore,Orissa',
'Baharda,Balasore,Orissa',
'Baiganabadia,Balasore,Orissa',
'Baitpur,Balasore,Orissa',
'Bajitpur,Balasore,Orissa',
'Balim,Balasore,Orissa',
'Barbatia,Balasore,Orissa',
'Barbatia Bazar,Balasore,Orissa',
'Bartana,Balasore,Orissa',
'Batagramghat,Balasore,Orissa',
'Baunsadiha,Balasore,Orissa',
'Belda,Balasore,Orissa',
'Bhograi,Balasore,Orissa',
'Bichitrapur,Balasore,Orissa',
'Chakaisab,Balasore,Orissa',
'Chandakusumi,Balasore,Orissa',
'Chandaneswar,Balasore,Orissa',
'Dahunda,Balasore,Orissa',
'Dakhinanadbani,Balasore,Orissa',
'Dehurda,Balasore,Orissa',
'Deulahat,Balasore,Orissa',
'Dubsahi,Balasore,Orissa',
'Durpal,Balasore,Orissa',
'Fulbani,Balasore,Orissa',
'Gopinathpur,Balasore,Orissa',
'Guneibasan,Balasore,Orissa',
'Haridaspur,Balasore,Orissa',
'Iswarpur,Balasore,Orissa',
'Jaleswarpur,Balasore,Orissa',
'Jayarampur,Balasore,Orissa',
'Kachuadi,Balasore,Orissa',
'Kakhra,Balasore,Orissa',
'Karihanda,Balasore,Orissa',
'Khairda,Balasore,Orissa',
'Khalabadia,Balasore,Orissa',
'Kotisahi,Balasore,Orissa',
'Kumarjalina,Balasore,Orissa',
'Kumarmuli,Balasore,Orissa',
'Kusuda,Balasore,Orissa',
'Madhupura,Balasore,Orissa',
'Mahagab,Balasore,Orissa',
'Malaruan,Balasore,Orissa',
'Mankunda,Balasore,Orissa',
'Nachinda,Balasore,Orissa',
'Nafrai,Balasore,Orissa',
'Naranmohantypadia,Balasore,Orissa',
'Narayanpur,Balasore,Orissa',
'Naskarpur,Balasore,Orissa',
'Nayapalli,Balasore,Orissa',
'Nilpura,Balasore,Orissa',
'Nimatpur,Balasore,Orissa',
'Nishanpur,Balasore,Orissa',
'Pasarbindha,Balasore,Orissa',
'Pithapur,Balasore,Orissa',
'Purusottampur,Balasore,Orissa',
'Putina,Balasore,Orissa',
'Rasalpur,Balasore,Orissa',
'Rasalpur,Balasore,Orissa',
'Sankhari,Balasore,Orissa',
'Sardhapur,Balasore,Orissa',
'Soharia,Balasore,Orissa',
'Sukhsandhapatna,Balasore,Orissa',
'Sultanpur,Balasore,Orissa',
'Tarapur,Balasore,Orissa',
'Tukurihazira,Balasore,Orissa',
'Udayganjapatna,Balasore,Orissa',
'Upla Hat,Balasore,Orissa',
'Alalpur,Balasore,Orissa',
'Ambadiha,Balasore,Orissa',
'Ambliatha,Balasore,Orissa',
'Ashabandha,Balasore,Orissa',
'Badhan,Balasore,Orissa',
'Baliapati,Balasore,Orissa',
'Baradiha,Balasore,Orissa',
'Bartana,Balasore,Orissa',
'Bhandarikuli,Balasore,Orissa',
'Budhakusumi,Balasore,Orissa',
'Chalanti,Balasore,Orissa',
'Chamara Gaon,Balasore,Orissa',
'Chhamouza,Balasore,Orissa',
'Chormara,Balasore,Orissa',
'Chudamanipur,Balasore,Orissa',
'Dahamunda,Balasore,Orissa',
'Demuria,Balasore,Orissa',
'Dhansimulia,Balasore,Orissa',
'Dundukut,Balasore,Orissa',
'Gilajodi,Balasore,Orissa',
'Gop,Balasore,Orissa',
'Hatigarh,Balasore,Orissa',
'Ikida,Balasore,Orissa',
'Jaleswar H.O,Balasore,Orissa',
'Jaleswar RS,Balasore,Orissa',
'Jamalpur,Balasore,Orissa',
'Kabataghati,Balasore,Orissa',
'Kainagari,Balasore,Orissa',
'Kalama,Balasore,Orissa',
'Kamarda,Balasore,Orissa',
'Kamarsalia,Balasore,Orissa',
'Kankei,Balasore,Orissa',
'Kasida,Balasore,Orissa',
'Keshpura,Balasore,Orissa',
'Khalina,Balasore,Orissa',
'Khanabad,Balasore,Orissa',
'Khuard,Balasore,Orissa',
'Khuluda,Balasore,Orissa',
'Lakhananath,Balasore,Orissa',
'Lakhananath Road,Balasore,Orissa',
'Machhada,Balasore,Orissa',
'Mahuduma,Balasore,Orissa',
'Malipal,Balasore,Orissa',
'Mankidia,Balasore,Orissa',
'Masanbaria,Balasore,Orissa',
'Mathuranath,Balasore,Orissa',
'Mohammad Nagarpatna,Balasore,Orissa',
'Munutunia,Balasore,Orissa',
'Nabra,Balasore,Orissa',
'Naikudi,Balasore,Orissa',
'Nampo,Balasore,Orissa',
'Nayabazar Jaleswar,Balasore,Orissa',
'Netua,Balasore,Orissa',
'Nimpada,Balasore,Orissa',
'Olmara,Balasore,Orissa',
'Paiksida,Balasore,Orissa',
'Panasha,Balasore,Orissa',
'Paunsakuli,Balasore,Orissa',
'Putura,Balasore,Orissa',
'Raibania,Balasore,Orissa',
'Rairamchandrapur,Balasore,Orissa',
'Rajpur,Balasore,Orissa',
'Remu,Balasore,Orissa',
'Sahada,Balasore,Orissa',
'Salikotha,Balasore,Orissa',
'Sikharpur,Balasore,Orissa',
'Sugo,Balasore,Orissa',
'Tadada,Balasore,Orissa',
'Khirachora Gopinath,Balasore,Orissa',
'Mitrapur,Balasore,Orissa',
'Arabandha,Balasore,Orissa',
'Bahala,Balasore,Orissa',
'Barun Singh,Balasore,Orissa',
'Bhounriabad,Balasore,Orissa',
'Chhatrapur,Balasore,Orissa',
'Darkholi,Balasore,Orissa',
'Dharaganj,Balasore,Orissa',
'Dhobasila,Balasore,Orissa',
'Durgadevi,Balasore,Orissa',
'Garadihi,Balasore,Orissa',
'Gopalpur,Balasore,Orissa',
'Hatsahi,Balasore,Orissa',
'Jadibali,Balasore,Orissa',
'Jamudiha,Balasore,Orissa',
'Jamuna,Balasore,Orissa',
'Kahalia,Balasore,Orissa',
'Kalakad,Balasore,Orissa',
'Kans,Balasore,Orissa',
'Khairagobindapur,Balasore,Orissa',
'Khan Nagar,Balasore,Orissa',
'Kharadiha,Balasore,Orissa',
'Kishorchandrapur,Balasore,Orissa',
'Machhua,Balasore,Orissa',
'Mahispata,Balasore,Orissa',
'Matiali,Balasore,Orissa',
'Mirigini,Balasore,Orissa',
'Narasingpur,Balasore,Orissa',
'Narayanapur,Balasore,Orissa',
'Nilgiri College,Balasore,Orissa',
'Nimpal,Balasore,Orissa',
'Nuapadhi,Balasore,Orissa',
'Oupada,Balasore,Orissa',
'Patna,Balasore,Orissa',
'Pithahat,Balasore,Orissa',
'Podasul,Balasore,Orissa',
'Pundala,Balasore,Orissa',
'Raj Berhampur,Balasore,Orissa',
'Raj Nilgiri,Balasore,Orissa',
'Rasaslpur,Balasore,Orissa',
'Remuna,Balasore,Orissa',
'Sajanagarh,Balasore,Orissa',
'Sarugaon,Balasore,Orissa',
'Sathilabalbalia,Balasore,Orissa',
'Sergarh,Balasore,Orissa',
'Shyamsundarpur,Balasore,Orissa',
'Siadimal,Balasore,Orissa',
'Singiri,Balasore,Orissa',
'Srirampur,Balasore,Orissa',
'Telipal,Balasore,Orissa',
'Tenda,Balasore,Orissa',
'Tentulia,Balasore,Orissa',
'Tikirapal,Balasore,Orissa',
'Uppardiha,Balasore,Orissa',
'Aghirapada,Balasore,Orissa',
'Begunia,Balasore,Orissa',
'Chakajagannathpur,Balasore,Orissa',
'Ada,Bhadrak,Orissa',
'Aliha,Bhadrak,Orissa',
'Anandapur,Bhadrak,Orissa',
'Antara,Bhadrak,Orissa',
'Arakhpur,Bhadrak,Orissa',
'Baghua,Bhadrak,Orissa',
'Balikhanda,Bhadrak,Orissa',
'Barada,Bhadrak,Orissa',
'Bari,Bhadrak,Orissa',
'Bariha,Bhadrak,Orissa',
'Bati,Bhadrak,Orissa',
'Chandarpada,Bhadrak,Orissa',
'Damodarpur,Bhadrak,Orissa',
'Dungura,Bhadrak,Orissa',
'Garasang,Bhadrak,Orissa',
'Govindapur,Bhadrak,Orissa',
'Guapal,Balasore,Orissa',
'Jalanga Gandibed,Bhadrak,Orissa',
'Jamjhadi,Bhadrak,Orissa',
'Kaithagadia,Balasore,Orissa',
'Kalaspur,Bhadrak,Orissa',
'Kanchpada,Bhadrak,Orissa',
'Kupari,Balasore,Orissa',
'Markona,Bhadrak,Orissa',
'Mirjapur,Bhadrak,Orissa',
'Mohammadpur,Bhadrak,Orissa',
'Nahanga,Balasore,Orissa',
'Pani Chhatra,Balasore,Orissa',
'Parbatipur,Bhadrak,Orissa',
'Ramakrishnapur,Bhadrak,Orissa',
'Rudhunga,Bhadrak,Orissa',
'Sahigaon,Bhadrak,Orissa',
'Simulia Bazar,Bhadrak,Orissa',
'Simulia,Bhadrak,Orissa',
'Srimantapur,Bhadrak,Orissa',
'Sundarpur,Balasore,Orissa',
'Achutipur,Balasore,Orissa',
'Alasuan,Balasore,Orissa',
'Anantapur,Balasore,Orissa',
'Angula,Balasore,Orissa',
'Arjunpur,Balasore,Orissa',
'Aruhabad,Balasore,Orissa',
'Asuria,Balasore,Orissa',
'Attapur,Balasore,Orissa',
'Avana,Balasore,Orissa',
'Badapokhari,Balasore,Orissa',
'Bahanaga,Balasore,Orissa',
'Bainanda Mangarajpur,Balasore,Orissa',
'Balanga,Balasore,Orissa',
'Bana Bishnupur,Balasore,Orissa',
'Barahapur,Balasore,Orissa',
'Bidubazar,Balasore,Orissa',
'Bishnupur,Balasore,Orissa',
'Boita,Balasore,Orissa',
'Chakabarahapur,Balasore,Orissa',
'Dagarpada,Balasore,Orissa',
'Dahisada,Balasore,Orissa',
'Dalanga,Balasore,Orissa',
'Dwarika,Balasore,Orissa',
'Fatehpur,Balasore,Orissa',
'Gandasthapur,Balasore,Orissa',
'Gandibed,Balasore,Orissa',
'Ghasua,Balasore,Orissa',
'Gopalpur,Balasore,Orissa',
'Gud,Balasore,Orissa',
'Hatikhulia,Balasore,Orissa',
'Iswarpur,Balasore,Orissa',
'Jagannathpur,Balasore,Orissa',
'Jagannathpur Bachhada,Balasore,Orissa',
'Jageswarpada,Balasore,Orissa',
'Janhia,Balasore,Orissa',
'Jirtal,Balasore,Orissa',
'Kalyani,Balasore,Orissa',
'Kandagaridi,Balasore,Orissa',
'Karanjabindha,Balasore,Orissa',
'Kasba Jaipur,Balasore,Orissa',
'Kedarpur,Balasore,Orissa',
'Kesharipur,Balasore,Orissa',
'Khaira,Balasore,Orissa',
'Khantapada,Balasore,Orissa',
'Kharsahapur,Balasore,Orissa',
'Kochiakoili,Balasore,Orissa',
'Kudei Nadigaon,Balasore,Orissa',
'Kuligaon,Balasore,Orissa',
'Kumarpur,Balasore,Orissa',
'Kuruda-soro,Balasore,Orissa',
'Kurunta,Balasore,Orissa',
'Maharudrapur,Balasore,Orissa',
'Mahatipur,Balasore,Orissa',
'Mahu Muhana,Balasore,Orissa',
'Makhanpur,Balasore,Orissa',
'Mangalapur,Balasore,Orissa',
'Manipur,Balasore,Orissa',
'Mituani,Balasore,Orissa',
'Mobarakpur,Balasore,Orissa',
'Mulisingh,Balasore,Orissa',
'Nachhipur,Balasore,Orissa',
'Nachinta,Balasore,Orissa',
'Padagaon,Balasore,Orissa',
'Padhuan,Balasore,Orissa',
'Pakhar,Balasore,Orissa',
'Pandasuni,Balasore,Orissa',
'Panpana,Balasore,Orissa',
'Pratapada,Balasore,Orissa',
'Radhaballavpur,Balasore,Orissa',
'Rahaniaganj,Balasore,Orissa',
'Rairamchandrapur,Balasore,Orissa',
'Rupkhand,Balasore,Orissa',
'Sabira R.S.,Balasore,Orissa',
'Sahaspura,Balasore,Orissa',
'Sajanpur,Balasore,Orissa',
'Sampei,Balasore,Orissa',
'Sankhapodadiha,Balasore,Orissa',
'Santhapada,Balasore,Orissa',
'Santragadia,Balasore,Orissa',
'Sarkana,Balasore,Orissa',
'Sarsankha,Balasore,Orissa',
'Sarsatia,Balasore,Orissa',
'Saud,Balasore,Orissa',
'Saundia,Balasore,Orissa',
'Simulia,Balasore,Orissa',
'Singa Khunta,Balasore,Orissa',
'Sirapur,Balasore,Orissa',
'Soro Bazar,Balasore,Orissa',
'Soro College,Balasore,Orissa',
'Soro,Balasore,Orissa',
'Srijang,Balasore,Orissa',
'Talakurunia,Balasore,Orissa',
'Tentei,Balasore,Orissa',
'Thalasada,Balasore,Orissa',
'Turigaria,Balasore,Orissa',
'Uttareswar,Balasore,Orissa',
'Wada,Balasore,Orissa',
'Ambabhana,Sambalpur,Orissa',
'Banjipali,Sambalpur,Orissa',
'Bara,Sambalpur,Orissa',
'Bhainatora,Sambalpur,Orissa',
'Bhukta,Sambalpur,Orissa',
'Dungri,Sambalpur,Orissa',
'Dunguri Lsq Colony Campus,Sambalpur,Orissa',
'Kandapala,Sambalpur,Orissa',
'Kapasira,Sambalpur,Orissa',
'Karlasantara,Sambalpur,Orissa',
'Kumbho,Sambalpur,Orissa',
'Lakhanpur,Sambalpur,Orissa',
'Ruchida,Sambalpur,Orissa',
'Tamdei,Sambalpur,Orissa',
'Uttam,Sambalpur,Orissa',
'Attabira,Sambalpur,Orissa',
'Babebira,Sambalpur,Orissa',
'Banhar,Sambalpur,Orissa',
'Bugbuga,Sambalpur,Orissa',
'Dulampur,Sambalpur,Orissa',
'Godbhaga,Sambalpur,Orissa',
'Hirlipali,Sambalpur,Orissa',
'Janged,Sambalpur,Orissa',
'Janhapada,Sambalpur,Orissa',
'Kadobahal,Sambalpur,Orissa',
'Kultatukura,Sambalpur,Orissa',
'Kulunda,Sambalpur,Orissa',
'Kumelsingha,Sambalpur,Orissa',
'Lachida,Sambalpur,Orissa',
'Lahanda,Sambalpur,Orissa',
'Larambha,Sambalpur,Orissa',
'Larasara,Sambalpur,Orissa',
'Lastala,Sambalpur,Orissa',
'Manapada,Sambalpur,Orissa',
'Paharsirgida,Sambalpur,Orissa',
'Rengalipali Colony,Sambalpur,Orissa',
'Saranda,Sambalpur,Orissa',
'Silet,Sambalpur,Orissa',
'Tampersara,Sambalpur,Orissa',
'Tope,Sambalpur,Orissa',
'B. Katapali,Sambalpur,Orissa',
'Bardol,Sambalpur,Orissa',
'Bargarh Bazar,Sambalpur,Orissa',
'Bargarh Court,Sambalpur,Orissa',
'Bargarh H.O,Sambalpur,Orissa',
'Behera,Sambalpur,Orissa',
'Bhatli,Sambalpur,Orissa',
'Bheden,Sambalpur,Orissa',
'Chakarkend,Sambalpur,Orissa',
'Dang,Sambalpur,Orissa',
'Deogaon,Sambalpur,Orissa',
'Govindpur,Sambalpur,Orissa',
'Gudesira,Sambalpur,Orissa',
'J. Sirgida,Sambalpur,Orissa',
'Jamurda,Sambalpur,Orissa',
'Jatla,Sambalpur,Orissa',
'Kanbar PSSK,Sambalpur,Orissa',
'Karanda PSSK,Sambalpur,Orissa',
'Khuntapali,Sambalpur,Orissa',
'N. Jampali,Sambalpur,Orissa',
'Sarkanda,Sambalpur,Orissa',
'Sarsara,Sambalpur,Orissa',
'Tora,Sambalpur,Orissa',
'Tumgaon PSSK,Sambalpur,Orissa',
'Adagaon,Sambalpur,Orissa',
'Barhaguda,Sambalpur,Orissa',
'Birmal,Sambalpur,Orissa',
'Dhanger,Sambalpur,Orissa',
'Gaisama,Sambalpur,Orissa',
'Kalapani,Sambalpur,Orissa',
'Khandatha,Sambalpur,Orissa',
'Agalpur,Sambalpur,Orissa',
'B. Tileimal,Sambalpur,Orissa',
'Bagbadi,Sambalpur,Orissa',
'Bandhapali,Sambalpur,Orissa',
'Baramkela,Sambalpur,Orissa',
'Barguda PSSK,Sambalpur,Orissa',
'Barpali,Sambalpur,Orissa',
'Bhatigaon,Sambalpur,Orissa',
'Bijayapali,Sambalpur,Orissa',
'Gopeipali,Sambalpur,Orissa',
'Kainsir,Sambalpur,Orissa',
'Kantapali-barpali,Sambalpur,Orissa',
'Kebad,Sambalpur,Orissa',
'Khemsara PSSK,Sambalpur,Orissa',
'Kumbhari,Sambalpur,Orissa',
'Kusanpuri,Sambalpur,Orissa',
'Lenda,Sambalpur,Orissa',
'Mahada,Sambalpur,Orissa',
'Mahulpali,Sambalpur,Orissa',
'Nileswar,Sambalpur,Orissa',
'Patakulunda,Sambalpur,Orissa',
'Remta,Sambalpur,Orissa',
'S. Dumberpali PSSK,Sambalpur,Orissa',
'Satlama,Sambalpur,Orissa',
'Tulandi,Sambalpur,Orissa',
'Banda,Sambalpur,Orissa',
'Banda-kharmunda,Sambalpur,Orissa',
'Bargarh-bargaon,Sambalpur,Orissa',
'Beherapali,Sambalpur,Orissa',
'Bhadigaon,Sambalpur,Orissa',
'Bhatli-badmal,Sambalpur,Orissa',
'Bichuan,Sambalpur,Orissa',
'Chadeigaon,Sambalpur,Orissa',
'Chandipali PSSK,Sambalpur,Orissa',
'Gopalpur,Sambalpur,Orissa',
'Halupali,Sambalpur,Orissa',
'Hatisar,Sambalpur,Orissa',
'Jhikijhiki,Sambalpur,Orissa',
'Kamgaon,Sambalpur,Orissa',
'Kanakbira,Sambalpur,Orissa',
'Kesaipali,Sambalpur,Orissa',
'Kharsal,Sambalpur,Orissa',
'Mulbar,Sambalpur,Orissa',
'Nilji,Sambalpur,Orissa',
'Nuagarh,Sambalpur,Orissa',
'Routpara,Sambalpur,Orissa',
'Sakuda,Sambalpur,Orissa',
'Sulsulia,Sambalpur,Orissa',
'Tejgola,Sambalpur,Orissa',
'Urduna,Sambalpur,Orissa',
'Ainlapali,Sambalpur,Orissa',
'Areigudi,Sambalpur,Orissa',
'Arjunda,Sambalpur,Orissa',
'Bakti,Sambalpur,Orissa',
'Barapadar,Sambalpur,Orissa',
'Bhoipali,Sambalpur,Orissa',
'Burda,Sambalpur,Orissa',
'Chichinda,Sambalpur,Orissa',
'Dekulba,Sambalpur,Orissa',
'Deshbhatli,Sambalpur,Orissa',
'Gondturum,Sambalpur,Orissa',
'Jharpali,Sambalpur,Orissa',
'Jhilminda,Sambalpur,Orissa',
'Kubedega,Sambalpur,Orissa',
'Kudapali,Sambalpur,Orissa',
'Lupursingha,Sambalpur,Orissa',
'Mahule,Sambalpur,Orissa',
'Manpur,Sambalpur,Orissa',
'Papanga,Sambalpur,Orissa',
'Remunda,Sambalpur,Orissa',
'Resam,Sambalpur,Orissa',
'Rusuda,Sambalpur,Orissa',
'Sankhirda,Sambalpur,Orissa',
'Sialkhandata,Sambalpur,Orissa',
'Sunalarambha,Sambalpur,Orissa',
'Talmenda,Sambalpur,Orissa',
'Talsirgida,Sambalpur,Orissa',
'Kuruan,Sambalpur,Orissa',
'Badabrahmani PSSK,Sambalpur,Orissa',
'Badapali,Sambalpur,Orissa',
'Baddausen,Sambalpur,Orissa',
'Bijepur,Sambalpur,Orissa',
'Gunthiapali PSSK,Sambalpur,Orissa',
'Jaring,Sambalpur,Orissa',
'Jokhipali,Sambalpur,Orissa',
'Kharmunda,Sambalpur,Orissa',
'Laumunda,Sambalpur,Orissa',
'Majhipali,Sambalpur,Orissa',
'Pada,Sambalpur,Orissa',
'Pahandi,Sambalpur,Orissa',
'Patharia,Sambalpur,Orissa',
'Saipali,Sambalpur,Orissa',
'Samalaipadar,Sambalpur,Orissa',
'Sarandapali,Sambalpur,Orissa',
'Sirgida,Sambalpur,Orissa',
'Chikhili PSSK,Sambalpur,Orissa',
'Dangabahal,Sambalpur,Orissa',
'Firingimal PSSK,Sambalpur,Orissa',
'Gaisilet,Sambalpur,Orissa',
'Gourenmunda,Sambalpur,Orissa',
'Jagalpat,Sambalpur,Orissa',
'Jamutbahal,Sambalpur,Orissa',
'Kathaumal,Sambalpur,Orissa',
'Kundakhai,Sambalpur,Orissa',
'Raisalpadar PSSK,Sambalpur,Orissa',
'Saradhapali,Sambalpur,Orissa',
'Ammthi,Sambalpur,Orissa',
'Bhainsadhara,Sambalpur,Orissa',
'Bhandarpuri,Sambalpur,Orissa',
'Bijadhol,Sambalpur,Orissa',
'Bilaspur,Sambalpur,Orissa',
'Chandibhata,Sambalpur,Orissa',
'Dhaba,Sambalpur,Orissa',
'Gourmal,Sambalpur,Orissa',
'Guthuguda,Sambalpur,Orissa',
'Kumir PSSK,Sambalpur,Orissa',
'Laudidhara,Sambalpur,Orissa',
'Shakti,Sambalpur,Orissa',
'Badikata,Sambalpur,Orissa',
'Bartunda,Sambalpur,Orissa',
'Bhengrajpur,Sambalpur,Orissa',
'Bhubaneswarpur,Sambalpur,Orissa',
'Chendeikela,Sambalpur,Orissa',
'Chhetgaon PSSK,Sambalpur,Orissa',
'Jamseth,Sambalpur,Orissa',
'Jhitiki,Sambalpur,Orissa',
'Kansada PSSK,Sambalpur,Orissa',
'Kechhdadar PSSK,Sambalpur,Orissa',
'Kermelabahal PSSK,Sambalpur,Orissa',
'Mandosil,Sambalpur,Orissa',
'Mithapali,Sambalpur,Orissa',
'Mondiadhipa,Sambalpur,Orissa',
'Paikmal,Sambalpur,Orissa',
'Palsada,Sambalpur,Orissa',
'Temri,Sambalpur,Orissa',
'Barihapali PSSK,Sambalpur,Orissa',
'Bheunria,Sambalpur,Orissa',
'Boden,Sambalpur,Orissa',
'Budamal,Sambalpur,Orissa',
'Burkel,Sambalpur,Orissa',
'Chantipali,Sambalpur,Orissa',
'Dahigaon,Sambalpur,Orissa',
'Dahita,Sambalpur,Orissa',
'Diptipur,Sambalpur,Orissa',
'Guderpali,Sambalpur,Orissa',
'Jagdalpur,Sambalpur,Orissa',
'K. Katabahal,Sambalpur,Orissa',
'Kansingha,Sambalpur,Orissa',
'Khaliapali,Sambalpur,Orissa',
'Lakhamara,Sambalpur,Orissa',
'Mahulpali,Sambalpur,Orissa',
'Purena,Sambalpur,Orissa',
'Salepali,Sambalpur,Orissa',
'Saplahar,Sambalpur,Orissa',
'Sareikela,Sambalpur,Orissa',
'Talpali,Sambalpur,Orissa',
'Bisipali,Sambalpur,Orissa',
'Ganiapali,Sambalpur,Orissa',
'Jamla,Sambalpur,Orissa',
'Jharbandh,Sambalpur,Orissa',
'Melchhamunda,Sambalpur,Orissa',
'Phalsapali,Sambalpur,Orissa',
'Rajborasamber,Sambalpur,Orissa',
'Sargibahal,Sambalpur,Orissa',
'Bausenmura,Sambalpur,Orissa',
'Birjam,Sambalpur,Orissa',
'Chhuriapali,Sambalpur,Orissa',
'Chichinda,Sambalpur,Orissa',
'Garbhona,Sambalpur,Orissa',
'Ghess,Sambalpur,Orissa',
'Jhar,Sambalpur,Orissa',
'Jharpali,Sambalpur,Orissa',
'Kalangapali,Sambalpur,Orissa',
'Kangaon,Sambalpur,Orissa',
'Kuchipali,Sambalpur,Orissa',
'Lebidi,Sambalpur,Orissa',
'Madhupur,Sambalpur,Orissa',
'Negimunda,Sambalpur,Orissa',
'Pandikipali,Sambalpur,Orissa',
'Panimura,Sambalpur,Orissa',
'Petupali,Sambalpur,Orissa',
'Rengali,Sambalpur,Orissa',
'Sanimal,Sambalpur,Orissa',
'Sohella,Sambalpur,Orissa',
'Tabada,Sambalpur,Orissa',
'Talpadar,Sambalpur,Orissa',
'Tungibandhali,Sambalpur,Orissa',
'Adalpanka,Bhadrak,Orissa',
'Adia,Bhadrak,Orissa',
'Alauti,Bhadrak,Orissa',
'Andheipalli,Bhadrak,Orissa',
'Andhia,Bhadrak,Orissa',
'Anijo,Bhadrak,Orissa',
'Apanda,Bhadrak,Orissa',
'B T Pur,Bhadrak,Orissa',
'Badanuagaon,Bhadrak,Orissa',
'Bahudarada,Bhadrak,Orissa',
'Bangarpadi,Bhadrak,Orissa',
'Bant,Bhadrak,Orissa',
'Basantia,Bhadrak,Orissa',
'Begana,Bhadrak,Orissa',
'Bhagibindha,Bhadrak,Orissa',
'Chardia,Bhadrak,Orissa',
'Chhayalsingh,Bhadrak,Orissa',
'Dolapadi,Bhadrak,Orissa',
'Ganijang,Bhadrak,Orissa',
'Gopinath Tejpur,Bhadrak,Orissa',
'Ichhada,Bhadrak,Orissa',
'Jalamandua,Bhadrak,Orissa',
'Kantia,Bhadrak,Orissa',
'Kaupur,Bhadrak,Orissa',
'Kenduapada,Bhadrak,Orissa',
'Mohantipada,Bhadrak,Orissa',
'Naguan,Bhadrak,Orissa',
'Nalgira,Bhadrak,Orissa',
'Padhanpara,Bhadrak,Orissa',
'Patuli,Bhadrak,Orissa',
'Piripur,Bhadrak,Orissa',
'R N Betra,Bhadrak,Orissa',
'Ramachandrapur,Bhadrak,Orissa',
'Ramakrishnapur,Bhadrak,Orissa',
'Sandado,Bhadrak,Orissa',
'Sendtira,Bhadrak,Orissa',
'Silandi,Bhadrak,Orissa',
'Tarago,Bhadrak,Orissa',
'Tillo Barasahi,Bhadrak,Orissa',
'Todanga,Bhadrak,Orissa',
'Kiapada,Bhadrak,Orissa',
'Adhuan,Bhadrak,Orissa',
'Albaga,Bhadrak,Orissa',
'Andrai,Bhadrak,Orissa',
'Arandua,Bhadrak,Orissa',
'Aruha,Bhadrak,Orissa',
'Atto,Bhadrak,Orissa',
'Bachhipur,Bhadrak,Orissa',
'Baincha,Bhadrak,Orissa',
'Balimunda,Bhadrak,Orissa',
'Bansada Kuamara,Bhadrak,Orissa',
'Barandua,Bhadrak,Orissa',
'Basudevpur College,Bhadrak,Orissa',
'Basudevpur,Bhadrak,Orissa',
'Bedeipur,Bhadrak,Orissa',
'Bedeipurpal,Bhadrak,Orissa',
'Betada,Bhadrak,Orissa',
'Bhairabpur,Bhadrak,Orissa',
'Binayakpur,Bhadrak,Orissa',
'Biras,Bhadrak,Orissa',
'Brahmanigaon,Bhadrak,Orissa',
'Chalunigaon,Bhadrak,Orissa',
'Chudamani,Bhadrak,Orissa',
'Erada,Bhadrak,Orissa',
'Eram,Bhadrak,Orissa',
'Ertal,Bhadrak,Orissa',
'Gopaljew Sugo,Bhadrak,Orissa',
'Goramati,Bhadrak,Orissa',
'Govindpur,Bhadrak,Orissa',
'Guagadia,Bhadrak,Orissa',
'K K Pur,Bhadrak,Orissa',
'Kanheibindha,Bhadrak,Orissa',
'Karanjamal,Bhadrak,Orissa',
'Karanpalli,Bhadrak,Orissa',
'Khirkona,Bhadrak,Orissa',
'Lunga,Bhadrak,Orissa',
'Mandari,Bhadrak,Orissa',
'Matipaka,Bhadrak,Orissa',
'Naikanidihi,Bhadrak,Orissa',
'Narasinghpur,Bhadrak,Orissa',
'Nuagaon,Bhadrak,Orissa',
'Padamapur,Bhadrak,Orissa',
'Prabodhpur,Bhadrak,Orissa',
'Radhaballavpur,Bhadrak,Orissa',
'Sahada Sabrang,Bhadrak,Orissa',
'Samian,Bhadrak,Orissa',
'Sanahavelisahi,Bhadrak,Orissa',
'Sanakrishnapur,Bhadrak,Orissa',
'Suan,Bhadrak,Orissa',
'Aharapada,Bhadrak,Orissa',
'Amroli,Bhadrak,Orissa',
'Anandabazar,Bhadrak,Orissa',
'Arnapal,Bhadrak,Orissa',
'Badabarchikayan,Bhadrak,Orissa',
'Balabhadrapur,Bhadrak,Orissa',
'Balanta,Bhadrak,Orissa',
'Bandhagaon,Bhadrak,Orissa',
'Banitia,Bhadrak,Orissa',
'Baralpokhari,Bhadrak,Orissa',
'Barapada,Bhadrak,Orissa',
'Bhadrak Banka Bazar,Bhadrak,Orissa',
'Bhadrak Bypass,Bhadrak,Orissa',
'Bhadrak College,Bhadrak,Orissa',
'Bhadrak Court,Bhadrak,Orissa',
'Bhadrak H.O,Bhadrak,Orissa',
'Bhadrak Naya Bazar,Bhadrak,Orissa',
'Bhadrak Puruna Bazar,Bhadrak,Orissa',
'Bhadrak R S,Bhadrak,Orissa',
'Bishnupurbindha,Bhadrak,Orissa',
'Bodakpatna,Bhadrak,Orissa',
'Champulipada,Bhadrak,Orissa',
'Chandigaon,Bhadrak,Orissa',
'Charampa,Bhadrak,Orissa',
'Garadapur,Bhadrak,Orissa',
'Gelpur,Bhadrak,Orissa',
'Geltua,Bhadrak,Orissa',
'Ghosrabazar,Bhadrak,Orissa',
'Gourgadi,Bhadrak,Orissa',
'Gujidarada,Bhadrak,Orissa',
'Jalanga,Bhadrak,Orissa',
'Kadabaranga,Bhadrak,Orissa',
'Kalai,Bhadrak,Orissa',
'Kalasuni,Bhadrak,Orissa',
'Keshpur,Bhadrak,Orissa',
'Khaparpada,Bhadrak,Orissa',
'Korkora,Bhadrak,Orissa',
'Kuans,Bhadrak,Orissa',
'Kudabarua,Bhadrak,Orissa',
'Langudi,Bhadrak,Orissa',
'Lunia,Bhadrak,Orissa',
'Madhabnagar,Bhadrak,Orissa',
'Maitapur,Bhadrak,Orissa',
'Mouda,Bhadrak,Orissa',
'Nalanga,Bhadrak,Orissa',
'Nandore,Bhadrak,Orissa',
'Nangamahalla,Bhadrak,Orissa',
'Odanga,Bhadrak,Orissa',
'Olanga,Bhadrak,Orissa',
'Rahanja,Bhadrak,Orissa',
'Rajmukundapur,Bhadrak,Orissa',
'Rambhila,Bhadrak,Orissa',
'Randiahat,Bhadrak,Orissa',
'Ranital,Bhadrak,Orissa',
'Sabrang,Bhadrak,Orissa',
'Sahidnagar,Bhadrak,Orissa',
'Salandi Colony,Bhadrak,Orissa',
'Saragadia,Bhadrak,Orissa',
'Saramara,Bhadrak,Orissa',
'Sriganga,Bhadrak,Orissa',
'Susua,Bhadrak,Orissa',
'Talagopabindha,Bhadrak,Orissa',
'Tihiri,Bhadrak,Orissa',
'Uttarbahini,Bhadrak,Orissa',
'Motto,Bhadrak,Orissa',
'Amrutpur,Bhadrak,Orissa',
'Andiapat,Bhadrak,Orissa',
'Aradi,Bhadrak,Orissa',
'Baligaon,Bhadrak,Orissa',
'Batula,Bhadrak,Orissa',
'Bentalpur,Bhadrak,Orissa',
'Bhuinpur,Bhadrak,Orissa',
'Bijayanagar,Bhadrak,Orissa',
'Biriadia,Bhadrak,Orissa',
'Bouljoda,Bhadrak,Orissa',
'Chandbali Bazar,Bhadrak,Orissa',
'Chandbali,Bhadrak,Orissa',
'Chardia,Bhadrak,Orissa',
'Dhamara,Bhadrak,Orissa',
'Dosinga,Bhadrak,Orissa',
'Ghanteswar Baliapal,Bhadrak,Orissa',
'Ghanteswar,Bhadrak,Orissa',
'Goladia,Bhadrak,Orissa',
'Gopalpur,Bhadrak,Orissa',
'Goudunipokhari,Bhadrak,Orissa',
'Haladia,Bhadrak,Orissa',
'Harekrishnapur,Bhadrak,Orissa',
'Hatapur,Bhadrak,Orissa',
'Jaleswarpur,Bhadrak,Orissa',
'Kaithkhola,Bhadrak,Orissa',
'Karagola,Keonjhar,Orissa',
'Kathakata,Keonjhar,Orissa',
'Kendukhunta,Keonjhar,Orissa',
'Keshudurapal,Keonjhar,Orissa',
'Khalana,Keonjhar,Orissa',
'Khalapal,Keonjhar,Orissa',
'Khaliamenta,Keonjhar,Orissa',
'Kodapada,Keonjhar,Orissa',
'Kolimati,Keonjhar,Orissa',
'Kuchanendi,Keonjhar,Orissa',
'Kushaleswar,Keonjhar,Orissa',
'Machhala,Keonjhar,Orissa',
'Madanpur,Keonjhar,Orissa',
'Madhukeshari,Keonjhar,Orissa',
'Manoharpur,Keonjhar,Orissa',
'Mugupur,Keonjhar,Orissa',
'Naduan,Keonjhar,Orissa',
'Nandabara,Keonjhar,Orissa',
'Nuagaon,Keonjhar,Orissa',
'Padamapur,Keonjhar,Orissa',
'Panasadiha,Keonjhar,Orissa',
'Panchupally,Keonjhar,Orissa',
'Patsura,Keonjhar,Orissa',
'Purunabandagoda,Keonjhar,Orissa',
'Purunaghati,Keonjhar,Orissa',
'Purunia,Keonjhar,Orissa',
'Radhikadeipur,Keonjhar,Orissa',
'Raitola,Keonjhar,Orissa',
'Ramachandrapur,Keonjhar,Orissa',
'Sailong,Keonjhar,Orissa',
'Sainkul,Keonjhar,Orissa',
'Salabani,Keonjhar,Orissa',
'Salapada,Keonjhar,Orissa',
'Samana,Keonjhar,Orissa',
'Samukanendi,Keonjhar,Orissa',
'Sankho,Keonjhar,Orissa',
'Santoshpur,Keonjhar,Orissa',
'Sulana,Keonjhar,Orissa',
'Taneipal,Keonjhar,Orissa',
'Taratara,Keonjhar,Orissa',
'Tarimul,Keonjhar,Orissa',
'Taruan,Keonjhar,Orissa',
'Tolankapada,Keonjhar,Orissa',
'Toraniapal,Keonjhar,Orissa',
'Trilochanpur,Keonjhar,Orissa',
'Tukuna,Keonjhar,Orissa',
'Pandua,Keonjhar,Orissa',
'Balada,Keonjhar,Orissa',
'Balaguda,Keonjhar,Orissa',
'Bamebari,Keonjhar,Orissa',
'Baneikela,Keonjhar,Orissa',
'Bansapani,Keonjhar,Orissa',
'Barbil Bazar,Keonjhar,Orissa',
'Barbil,Keonjhar,Orissa',
'Basantapur,Keonjhar,Orissa',
'Bhadrasahi,Keonjhar,Orissa',
'Bhuyanroida,Keonjhar,Orissa',
'Bichakundi,Keonjhar,Orissa',
'Bileipada,Keonjhar,Orissa',
'Birikala,Keonjhar,Orissa',
'Bolani,Keonjhar,Orissa',
'Chormalda,Keonjhar,Orissa',
'Dabuna,Keonjhar,Orissa',
'Daduan,Keonjhar,Orissa',
'Deojhar,Keonjhar,Orissa',
'Dhanurjaypur Haramatha,Keonjhar,Orissa',
'Guali,Keonjhar,Orissa',
'Guruda,Keonjhar,Orissa',
'Gurutuan,Keonjhar,Orissa',
'Jajanga,Keonjhar,Orissa',
'Joda Bazar,Keonjhar,Orissa',
'Joda,Keonjhar,Orissa',
'Kasia(KA),Keonjhar,Orissa',
'Khandabandha,Keonjhar,Orissa',
'Kiriburu Hill Top,Keonjhar,Orissa',
'Kolahundula,Keonjhar,Orissa',
'Kolhabarapada,Keonjhar,Orissa',
'Matkambeda,Keonjhar,Orissa',
'Palasa (KHA),Keonjhar,Orissa',
'Serenda,Keonjhar,Orissa',
'Silijoda,Keonjhar,Orissa',
'Sundara Shiv Mandir,Keonjhar,Orissa',
'Thakurani,Keonjhar,Orissa',
'Amalaniguda,Keonjhar,Orissa',
'Anseikala,Keonjhar,Orissa',
'Arsala,Keonjhar,Orissa',
'Asanpat,Keonjhar,Orissa',
'Badadumuria,Keonjhar,Orissa',
'Badanai,Keonjhar,Orissa',
'Badaneuli,Keonjhar,Orissa',
'Balabhadrapur,Keonjhar,Orissa',
'Balibandha,Keonjhar,Orissa',
'Bankia,Keonjhar,Orissa',
'Baria,Keonjhar,Orissa',
'Basira,Keonjhar,Orissa',
'Basudevpur,Keonjhar,Orissa',
'Bhanda,Keonjhar,Orissa',
'Bhodaposi,Keonjhar,Orissa',
'Bhuinpur,Keonjhar,Orissa',
'Budhikapudi,Keonjhar,Orissa',
'Chamakpur,Keonjhar,Orissa',
'Champua,Keonjhar,Orissa',
'Chauthia,Keonjhar,Orissa',
'Chipinda,Keonjhar,Orissa',
'Dhobakuchuda,Keonjhar,Orissa',
'Gidhibas,Keonjhar,Orissa',
'Gumura,Keonjhar,Orissa',
'Gundunia,Keonjhar,Orissa',
'Jagannathpur Ashram,Keonjhar,Orissa',
'Jally,Keonjhar,Orissa',
'Jamadalak,Keonjhar,Orissa',
'Jhumpura,Keonjhar,Orissa',
'Jyotipur,Keonjhar,Orissa',
'Kainta,Keonjhar,Orissa',
'Kalikaprasad,Keonjhar,Orissa',
'Kalinga,Keonjhar,Orissa',
'Kandra,Keonjhar,Orissa',
'Kanjiasula,Keonjhar,Orissa',
'Karanjia,Keonjhar,Orissa',
'Kasipal,Keonjhar,Orissa',
'Kasipal,Keonjhar,Orissa',
'Kaunrikala(A),Keonjhar,Orissa',
'Khenda,Keonjhar,Orissa',
'Khuntapada,Keonjhar,Orissa',
'Kodagadia,Keonjhar,Orissa',
'Malda,Keonjhar,Orissa',
'Nandapur,Keonjhar,Orissa',
'Naradapur,Keonjhar,Orissa',
'Nayakrihsnapur,Keonjhar,Orissa',
'Nishitnapur,Keonjhar,Orissa',
'Niundi,Keonjhar,Orissa',
'Padmapur,Keonjhar,Orissa',
'Padua,Keonjhar,Orissa',
'Panchapokharia,Keonjhar,Orissa',
'Parasala,Keonjhar,Orissa',
'Pokharia,Keonjhar,Orissa',
'Radhikadeipur,Keonjhar,Orissa',
'Rajia,Keonjhar,Orissa',
'Rangamatia,Keonjhar,Orissa',
'Raruanguda,Keonjhar,Orissa',
'Rasabantala,Keonjhar,Orissa',
'Remuli,Keonjhar,Orissa',
'Sadangi,Keonjhar,Orissa',
'Sarasinga,Keonjhar,Orissa',
'Sarei,Keonjhar,Orissa',
'Sasang,Keonjhar,Orissa',
'Silitia,Keonjhar,Orissa',
'Sologuda,Keonjhar,Orissa',
'Sunaposi,Keonjhar,Orissa',
'Taduabahal,Keonjhar,Orissa',
'Tukudiha,Keonjhar,Orissa',
'Uchhabali,Keonjhar,Orissa',
'Ukhunda,Keonjhar,Orissa',
'Bhawanarpur,Keonjhar,Orissa',
'Alutuma,Keonjhar,Orissa',
'Badabaliposi,Keonjhar,Orissa',
'Badajamposi,Keonjhar,Orissa',
'Badanuagaon,Keonjhar,Orissa',
'Badapichhula,Keonjhar,Orissa',
'Badasialimal,Keonjhar,Orissa',
'Baiganpal,Keonjhar,Orissa',
'Balabhadrapur,Keonjhar,Orissa',
'Baliparbata,Keonjhar,Orissa',
'Balipokhari,Keonjhar,Orissa',
'Banabir,Keonjhar,Orissa',
'Bandakanda Haladharpur,Keonjhar,Orissa',
'Barahatipura,Keonjhar,Orissa',
'Baratania,Keonjhar,Orissa',
'Baxibarigaon,Keonjhar,Orissa',
'Begna,Keonjhar,Orissa',
'Bhagamunda,Keonjhar,Orissa',
'Bholabeda,Keonjhar,Orissa',
'Bholapada,Keonjhar,Orissa',
'Billa,Keonjhar,Orissa',
'Brahmanipal,Keonjhar,Orissa',
'Chakradharpur,Keonjhar,Orissa',
'Chilikdhara,Keonjhar,Orissa',
'Chinamaliposi,Keonjhar,Orissa',
'Damahuda,Keonjhar,Orissa',
'Dhangadadiha,Keonjhar,Orissa',
'Dhenkikote,Keonjhar,Orissa',
'Digiposi,Keonjhar,Orissa',
'Gadadharpur,Keonjhar,Orissa',
'Gandadiha,Keonjhar,Orissa',
'Ghatagaon,Keonjhar,Orissa',
'Gholkunda,Keonjhar,Orissa',
'Goras,Keonjhar,Orissa',
'Gujitangiri,Keonjhar,Orissa',
'Harichandanpur,Keonjhar,Orissa',
'Hunda,Keonjhar,Orissa',
'Hundapalasapal,Keonjhar,Orissa',
'Janghira,Keonjhar,Orissa',
'Jiranga,Keonjhar,Orissa',
'Junga,Keonjhar,Orissa',
'Kaduadiha,Keonjhar,Orissa',
'Kansa,Keonjhar,Orissa',
'Kapundi,Keonjhar,Orissa',
'Karadapal,Keonjhar,Orissa',
'Kathabari,Keonjhar,Orissa',
'Katrabeda,Keonjhar,Orissa',
'Kendudiha,Keonjhar,Orissa',
'Ketanga,Keonjhar,Orissa',
'Khadikapada,Keonjhar,Orissa',
'Khajuribani,Keonjhar,Orissa',
'Kundapitha,Keonjhar,Orissa',
'Kuntla,Keonjhar,Orissa',
'Kusunpur,Keonjhar,Orissa',
'Machhagarh,Keonjhar,Orissa',
'Manata,Keonjhar,Orissa',
'Manoharpur,Keonjhar,Orissa',
'Masinajoda,Keonjhar,Orissa',
'Masinajodi,Keonjhar,Orissa',
'Mirigikhoji,Keonjhar,Orissa',
'Mishramala,Keonjhar,Orissa',
'Muktapur,Keonjhar,Orissa',
'Mukundapur Patna,Keonjhar,Orissa',
'Nuagaon,Keonjhar,Orissa',
'Nusuriposi,Keonjhar,Orissa',
'Palanghati,Keonjhar,Orissa',
'Pipilia,Keonjhar,Orissa',
'Pitapiti,Keonjhar,Orissa',
'Pithagola,Keonjhar,Orissa',
'Poipani,Keonjhar,Orissa',
'Raidiha,Keonjhar,Orissa',
'Rajabandha,Keonjhar,Orissa',
'Rvenapalasapal,Keonjhar,Orissa',
'Sagadapata,Keonjhar,Orissa',
'Sanamasinabila,Keonjhar,Orissa',
'Santrapur,Keonjhar,Orissa',
'Somagiri,Keonjhar,Orissa',
'Sunapentha,Keonjhar,Orissa',
'Talapada,Keonjhar,Orissa',
'Tambahara,Keonjhar,Orissa',
'Tanda,Keonjhar,Orissa',
'Tangiriapal,Keonjhar,Orissa',
'Tara,Keonjhar,Orissa',
'Tavasarua,Keonjhar,Orissa',
'Tendra,Keonjhar,Orissa',
'Tentlaposi,Keonjhar,Orissa',
'Thakurapada,Keonjhar,Orissa',
'Toranipokhari,Keonjhar,Orissa',
'Badarampas,Keonjhar,Orissa',
'Balibarei,Keonjhar,Orissa',
'Bangore,Keonjhar,Orissa',
'Barigaon,Keonjhar,Orissa',
'Bidyadharpur,Keonjhar,Orissa',
'Chhenapadi,Keonjhar,Orissa',
'Danar,Bhadrak,Orissa',
'Dhanurnjaypur,Keonjhar,Orissa',
'Dhenka,Keonjhar,Orissa',
'Dimiria,Bhadrak,Orissa',
'Gedma,Bhadrak,Orissa',
'Hadagarh,Keonjhar,Orissa',
'Hatadihi,Keonjhar,Orissa',
'Inchola,Keonjhar,Orissa',
'Kahaliagadia,Keonjhar,Orissa',
'Kanpur,Keonjhar,Orissa',
'Mareigaon,Keonjhar,Orissa',
'Orali,Keonjhar,Orissa',
'Padhiaripally,Keonjhar,Orissa',
'Podasingidi,Keonjhar,Orissa',
'Raighati,Keonjhar,Orissa',
'Sadanga,Bhadrak,Orissa',
'Sadha,Keonjhar,Orissa',
'Salinia,Bhadrak,Orissa',
'Soso,Keonjhar,Orissa',
'Badaposi,Keonjhar,Orissa',
'Balibaruan,Cuttack North,Orissa',
'Baragoda,Keonjhar,Orissa',
'Barhagarh,Keonjhar,Orissa',
'Basantapur,Keonjhar,Orissa',
'Bauripada,Keonjhar,Orissa',
'Bayakumutia,Keonjhar,Orissa',
'Bhulda,Keonjhar,Orissa',
'Binida,Keonjhar,Orissa',
'Birakishorepur,Keonjhar,Orissa',
'Bodapalasa,Keonjhar,Orissa',
'Bolaniposi,Keonjhar,Orissa',
'Champei,Keonjhar,Orissa',
'Dhrupada,Keonjhar,Orissa',
'Dimba,Keonjhar,Orissa',
'Dimirimunda,Keonjhar,Orissa',
'Fuljhar,Keonjhar,Orissa',
'Ghutur,Keonjhar,Orissa',
'Gobardhan,Keonjhar,Orissa',
'Guptaganga,Keonjhar,Orissa',
'Haladharpur,Keonjhar,Orissa',
'Handibhanga,Keonjhar,Orissa',
'Jatra,Keonjhar,Orissa',
'Jharbeda,Keonjhar,Orissa',
'Kadagarh,Keonjhar,Orissa',
'Kadakala,Keonjhar,Orissa',
'Kandraposi,Keonjhar,Orissa',
'Kanjipani,Keonjhar,Orissa',
'Kanjipani,Keonjhar,Orissa',
'Karangadihi,Keonjhar,Orissa',
'Kathabaunsuli,Keonjhar,Orissa',
'Kaunrikala(B),Keonjhar,Orissa',
'Kempasada,Keonjhar,Orissa',
'Keonjhar Atopur,Keonjhar,Orissa',
'Keonjhar Bazar,Keonjhar,Orissa',
'Keonjhar Court,Keonjhar,Orissa',
'Keonjhar Mining School,Keonjhar,Orissa',
'Keonjhar New Markt,Keonjhar,Orissa',
'Keonjhar Science College,Keonjhar,Orissa',
'Keonjhargarh H.O,Keonjhar,Orissa',
'Khireitangiri,Keonjhar,Orissa',
'Kuanr,Keonjhar,Orissa',
'Kudipasa,Keonjhar,Orissa',
'Kumundi (KHA),Keonjhar,Orissa',
'Kushakala,Keonjhar,Orissa',
'Kusuminta,Keonjhar,Orissa',
'Madhapur,Keonjhar,Orissa',
'Mahadeijoda,Keonjhar,Orissa',
'Maidankela,Keonjhar,Orissa',
'Mandua,Keonjhar,Orissa',
'Nahabeda,Keonjhar,Orissa',
'Naranpur,Keonjhar,Orissa',
'Nayakote,Keonjhar,Orissa',
'Nelung,Keonjhar,Orissa',
'Nuagaon,Keonjhar,Orissa',
'Odapada,Cuttack North,Orissa',
'Padmapur,Keonjhar,Orissa',
'Palasapanda,Keonjhar,Orissa',
'Pandadar,Keonjhar,Orissa',
'Pandapara,Keonjhar,Orissa',
'Parajanpur,Keonjhar,Orissa',
'Patilo,Keonjhar,Orissa',
'Purumunda,Keonjhar,Orissa',
'Raghunathpur,Keonjhar,Orissa',
'Raigoda,Keonjhar,Orissa',
'Raikala,Keonjhar,Orissa',
'Raisuan,Keonjhar,Orissa',
'Ranki,Keonjhar,Orissa',
'Rutisila,Keonjhar,Orissa',
'Sankir,Keonjhar,Orissa',
'Sendkap,Keonjhar,Orissa',
'Silisuan,Keonjhar,Orissa',
'Singpur,Keonjhar,Orissa',
'Sirishpal,Keonjhar,Orissa',
'Suakati,Keonjhar,Orissa',
'Taramakanta,Keonjhar,Orissa',
'Tikarpada,Keonjhar,Orissa',
'Urumunda,Keonjhar,Orissa',
'Bansapal,Keonjhar,Orissa',
'Badagambharia,Keonjhar,Orissa',
'Baikala,Keonjhar,Orissa',
'Baunsuli,Keonjhar,Orissa',
'Brahmanideo,Keonjhar,Orissa',
'Chakundapal,Keonjhar,Orissa',
'Chemena,Keonjhar,Orissa',
'Childa,Keonjhar,Orissa',
'Dumuria,Keonjhar,Orissa',
'Erendei,Keonjhar,Orissa',
'Gobarbeda,Keonjhar,Orissa',
'Jadichatar,Keonjhar,Orissa',
'Jamuda,Keonjhar,Orissa',
'Jamunaposi,Keonjhar,Orissa',
'Kankada,Keonjhar,Orissa',
'Kantiapada,Keonjhar,Orissa',
'Kendeiposi,Keonjhar,Orissa',
'Khajirapat,Keonjhar,Orissa',
'Khuntapada,Keonjhar,Orissa',
'Khuntapingu,Keonjhar,Orissa',
'Malapada,Keonjhar,Orissa',
'Murusuan,Keonjhar,Orissa',
'Mushakhari,Keonjhar,Orissa',
'Phulkanlei,Keonjhar,Orissa',
'Rajanagar,Keonjhar,Orissa',
'Saharpada,Keonjhar,Orissa',
'Saraskola,Keonjhar,Orissa',
'Silida,Keonjhar,Orissa',
'Silipada,Keonjhar,Orissa',
'Swampatna,Keonjhar,Orissa',
'Tangarpada,Keonjhar,Orissa',
'Turumunga,Keonjhar,Orissa',
'Udayapur,Keonjhar,Orissa',
'Akula,Keonjhar,Orissa',
'Balabhadrapur,Keonjhar,Orissa',
'Bhimkand,Keonjhar,Orissa',
'Bimala,Keonjhar,Orissa',
'Binjabahal,Keonjhar,Orissa',
'Birabarpur Nuagaon,Keonjhar,Orissa',
'Chhamunda,Keonjhar,Orissa',
'Deoladiha,Keonjhar,Orissa',
'Doblapal,Keonjhar,Orissa',
'Goda,Keonjhar,Orissa',
'Jata,Keonjhar,Orissa',
'Kaliahota,Keonjhar,Orissa',
'Karadangi,Keonjhar,Orissa',
'Karamangi,Keonjhar,Orissa',
'Khuntapada Charigarh,Keonjhar,Orissa',
'Nuadihi,Keonjhar,Orissa',
'Nuagaon,Keonjhar,Orissa',
'Oriya,Keonjhar,Orissa',
'Padang,Keonjhar,Orissa',
'Purujoda,Keonjhar,Orissa',
'Raisuan Patkhuli,Keonjhar,Orissa',
'Saleikana,Keonjhar,Orissa',
'Saruali,Keonjhar,Orissa',
'Sirigida,Keonjhar,Orissa',
'Sunduria,Keonjhar,Orissa',
'Talapada,Keonjhar,Orissa',
'Tana,Keonjhar,Orissa',
'Telkoi,Keonjhar,Orissa',
'Ankulachati,Puri,Orissa',
'Antarkiari,Puri,Orissa',
'Ayatapur,Puri,Orissa',
'Badakul,Puri,Orissa',
'Badasereipur,Puri,Orissa',
'Badhantuad,Puri,Orissa',
'Baku,Puri,Orissa',
'Balidihi,Puri,Orissa',
'Banpur Odagaon,Puri,Orissa',
'Banpur,Puri,Orissa',
'Baradiharikunda,Puri,Orissa',
'Baradihi,Puri,Orissa',
'Baulabandha,Puri,Orissa',
'Belapada,Puri,Orissa',
'Bheteswar,Puri,Orissa',
'Bhimpur,Puri,Orissa',
'Biribadi,Puri,Orissa',
'Damiabarabara,Puri,Orissa',
'Dibyasinghpur,Puri,Orissa',
'Gambharimunda,Puri,Orissa',
'Ghiakhala,Puri,Orissa',
'Godabaris Mahavidyalaya,Puri,Orissa',
'Harichandanpur,Puri,Orissa',
'Haripursasan,Puri,Orissa',
'Khanat,Puri,Orissa',
'Kuhuri,Puri,Orissa',
'Kulei,Puri,Orissa',
'Kumaranga,Puri,Orissa',
'Kunjuri,Puri,Orissa',
'Lendu,Puri,Orissa',
'Nachuni,Puri,Orissa',
'Nairi,Puri,Orissa',
'Narendrapur,Puri,Orissa',
'Naval Base Chilika,Puri,Orissa',
'Niladriprasad,Puri,Orissa',
'Nilgiripatna,Puri,Orissa',
'Nirakarpur,Puri,Orissa',
'Panchugaon,Puri,Orissa',
'Pratap,Puri,Orissa',
'Punjiama Sasan,Puri,Orissa',
'Rahanbeli,Puri,Orissa',
'Sahaspur,Puri,Orissa',
'Salapdihi,Puri,Orissa',
'Saliadam,Puri,Orissa',
'Sanahantuad,Puri,Orissa',
'Singheswar,Puri,Orissa',
'Soran,Puri,Orissa',
'Sunakhala,Puri,Orissa',
'Begunia,Puri,Orissa',
'Botalama,Puri,Orissa',
'Chhatrapada,Puri,Orissa',
'Godikilo,Puri,Orissa',
'Goudapatna,Puri,Orissa',
'Sagadabhanga,Puri,Orissa',
'Siko,Puri,Orissa',
'A G,Bhubaneswar,Orissa',
'Abhayamukhi,Bhubaneswar,Orissa',
'Acharya Vihar,Bhubaneswar,Orissa',
'Aerodrome Area,Bhubaneswar,Orissa',
'Aiginia,Bhubaneswar,Orissa',
'Airport,Bhubaneswar,Orissa',
'Amankud,Bhubaneswar,Orissa',
'Andharua,Bhubaneswar,Orissa',
'Angarpada,Puri,Orissa',
'Arugul,Puri,Orissa',
'Ashok Nagar,Bhubaneswar,Orissa',
'Athantar,Bhubaneswar,Orissa',
'B J B Nagar,Bhubaneswar,Orissa',
'Badagarh Brit Colony,Bhubaneswar,Orissa',
'Balakati,Bhubaneswar,Orissa',
'Balianta,Bhubaneswar,Orissa',
'Balipatna,Bhubaneswar,Orissa',
'Banamalipur,Bhubaneswar,Orissa',
'Bankual,Bhubaneswar,Orissa',
'Bapujee Nagar,Bhubaneswar,Orissa',
'Baramunda Colony,Bhubaneswar,Orissa',
'Benupur,Bhubaneswar,Orissa',
'Bhainchua,Bhubaneswar,Orissa',
'Bhakarsahi,Bhubaneswar,Orissa',
'Bhanranizigarh,Bhubaneswar,Orissa',
'Bharatpur,Bhubaneswar,Orissa',
'Bhatpatna,Bhubaneswar,Orissa',
'Bhoinagar,Bhubaneswar,Orissa',
'Bhubaneswar Court,Bhubaneswar,Orissa',
'Bhubaneswar G.P.O.,Bhubaneswar,Orissa',
'Bhubaneswar R S,Bhubaneswar,Orissa',
'Bhubaneswar Secretariate,Bhubaneswar,Orissa',
'Biswanathpur,Bhubaneswar,Orissa',
'Brahman Suanlo,Bhubaneswar,Orissa',
'Brahmanasarangi,Bhubaneswar,Orissa',
'Budheswari Colony,Bhubaneswar,Orissa',
'C G Colony,Bhubaneswar,Orissa',
'C R P Lines,Bhubaneswar,Orissa',
'Chanahat,Bhubaneswar,Orissa',
'Chandra Sekhar Pur,Bhubaneswar,Orissa',
'Dandichhatabar,Puri,Orissa',
'Darada,Bhubaneswar,Orissa',
'Deulidharpur,Bhubaneswar,Orissa',
'Dolakasati,Bhubaneswar,Orissa',
'Dumduma Housing Board Colony,Bhubaneswar,Orissa',
'Gada Gopinath Prasad,Bhubaneswar,Orissa',
'Ganganagar,Bhubaneswar,Orissa',
'Gangapada,Puri,Orissa',
'Garh Srirampur,Bhubaneswar,Orissa',
'Garidipanchana,Bhubaneswar,Orissa',
'Ghatikia,Bhubaneswar,Orissa',
'Gopinathpur,Bhubaneswar,Orissa',
'Harachandi Sahi,Bhubaneswar,Orissa',
'Harirajpur,Puri,Orissa',
'I R C Village,Bhubaneswar,Orissa',
'Itipur,Bhubaneswar,Orissa',
'Jadupur,Bhubaneswar,Orissa',
'Jagannathpur,Bhubaneswar,Orissa',
'Jayapur,Bhubaneswar,Orissa',
'Jharapada,Bhubaneswar,Orissa',
'Jhinti Sasan,Bhubaneswar,Orissa',
'K I I T,Bhubaneswar,Orissa',
'Kaimatia,Puri,Orissa',
'Kakarudrapur,Bhubaneswar,Orissa',
'Kalarahanga,Bhubaneswar,Orissa',
'Kalpana Square,Bhubaneswar,Orissa',
'Kalyanpur Sasan,Bhubaneswar,Orissa',
'Kantabad,Puri,Orissa',
'Kantapada,Bhubaneswar,Orissa',
'Kantia,Puri,Orissa',
'Kausalyaganga,Bhubaneswar,Orissa',
'Kedargouri,Bhubaneswar,Orissa',
'Khandagiri,Bhubaneswar,Orissa',
'Kharavela Nagar,Bhubaneswar,Orissa',
'Kudiari,Puri,Orissa',
'Kuha,Bhubaneswar,Orissa',
'Kusumati,Puri,Orissa',
'Laxminarayanpur,Bhubaneswar,Orissa',
'Laxmisagar,Bhubaneswar,Orissa',
'Loco Settlement,Puri,Orissa',
'Madanpur,Puri,Orissa',
'Madhusudan Nagar,Bhubaneswar,Orissa',
'Mahukhanda,Bhubaneswar,Orissa',
'Majhihara,Bhubaneswar,Orissa',
'Malipada,Bhubaneswar,Orissa',
'Mancheswar,Bhubaneswar,Orissa',
'Mancheswar R S,Bhubaneswar,Orissa',
'Mancheswar Railway Colony,Bhubaneswar,Orissa',
'Mendhasala,Puri,Orissa',
'Naharakanta,Bhubaneswar,Orissa',
'Nayapalli,Bhubaneswar,Orissa',
'Nuapada,Bhubaneswar,Orissa',
'Old Town,Bhubaneswar,Orissa',
'Orissa Assembly,Bhubaneswar,Orissa',
'Osap Campus,Bhubaneswar,Orissa',
'Padmapur,Bhubaneswar,Orissa',
'Pahal,Bhubaneswar,Orissa',
'Paikerapur,Puri,Orissa',
'Palaspur,Puri,Orissa',
'Panchagaon,Puri,Orissa',
'Patia Gds,Bhubaneswar,Orissa',
'Patrapada,Bhubaneswar,Orissa',
'Prataprudrapur,Bhubaneswar,Orissa',
'Raghuagorada,Bhubaneswar,Orissa',
'Rajabazar,Puri,Orissa',
'Rajbhawan,Bhubaneswar,Orissa',
'Rasulgarh,Bhubaneswar,Orissa',
'Regional Research Laboratory,Bhubaneswar,Orissa',
'Reta R.S.,Puri,Orissa',
'Retang Colony,Puri,Orissa',
'S.E Rly.Proj. Complex,Bhubaneswar,Orissa',
'Saheed Nagar,Bhubaneswar,Orissa',
'Sailashree Vihar,Bhubaneswar,Orissa',
'Sainik School,Bhubaneswar,Orissa',
'Santarapur,Bhubaneswar,Orissa',
'Sarakana,Bhubaneswar,Orissa',
'Sarakantara,Bhubaneswar,Orissa',
'Sasan,Bhubaneswar,Orissa',
'Satyabhamapur,Bhubaneswar,Orissa',
'Satyanagar,Bhubaneswar,Orissa',
'Sisilo,Bhubaneswar,Orissa',
'Sisupalgarh,Bhubaneswar,Orissa',
'Station Bazar,Bhubaneswar,Orissa',
'Sundarpada,Bhubaneswar,Orissa',
'Suryanagar,Bhubaneswar,Orissa',
'Tamando,Puri,Orissa',
'Taraboi,Puri,Orissa',
'Turintira,Bhubaneswar,Orissa',
'Turumal,Puri,Orissa',
'Udyan Marg,Bhubaneswar,Orissa',
'Utkal University,Bhubaneswar,Orissa',
'V S S Nagar,Bhubaneswar,Orissa',
'Arakhapalli,Puri,Orissa',
'Bankoi,Puri,Orissa',
'Baradangi,Puri,Orissa',
'Bolagarh,Puri,Orissa',
'Dabardhuapatna,Puri,Orissa',
'Deuli,Puri,Orissa',
'Dighiri,Puri,Orissa',
'Gopalipada,Puri,Orissa',
'Haripur,Puri,Orissa',
'Kalanga,Puri,Orissa',
'Manibandha,Puri,Orissa',
'Manikagoda,Puri,Orissa',
'Mordabadi,Puri,Orissa',
'Patabandha,Puri,Orissa',
'Sagargaon,Puri,Orissa',
'Sampur,Puri,Orissa',
'Sanapadar,Puri,Orissa',
'Tangisahi,Puri,Orissa',
'Balugaon Bazar,Puri,Orissa',
'Balugaon,Puri,Orissa',
'Gangadharpur,Puri,Orissa',
'Janla,Puri,Orissa',
'Jatni,Puri,Orissa',
'Khurda Road RS,Puri,Orissa',
'Mahura,Puri,Orissa',
'Haldiapada,Puri,Orissa',
'Anda,Puri,Orissa',
'Arikama,Puri,Orissa',
'Asaral,Puri,Orissa',
'Badaberena,Puri,Orissa',
'Badatota,Puri,Orissa',
'Baghamari,Puri,Orissa',
'Bagheitangi,Puri,Orissa',
'Bajpur,Puri,Orissa',
'Bangida,Puri,Orissa',
'Bhimpur Padanpur,Puri,Orissa',
'Bhogada,Puri,Orissa',
'Bhuasunipatna,Puri,Orissa',
'Birakesharpur,Puri,Orissa',
'Brajamohanpur,Puri,Orissa',
'Chakapada,Puri,Orissa',
'Chhamundiapalli,Puri,Orissa',
'Chhanagiri,Puri,Orissa',
'Chhatipur,Puri,Orissa',
'Dadhimachhagadia,Puri,Orissa',
'Dalatola,Puri,Orissa',
'Daleiput,Puri,Orissa',
'Damanbhuin,Puri,Orissa',
'Dingar,Puri,Orissa',
'Gadanial,Puri,Orissa',
'Garhmanitri,Puri,Orissa',
'Garhsanput,Puri,Orissa',
'Goda,Puri,Orissa',
'Golabai,Puri,Orissa',
'Gudum,Puri,Orissa',
'Gurujanga,Puri,Orissa',
'Hadapada,Puri,Orissa',
'Haja,Puri,Orissa',
'Haladia,Puri,Orissa',
'Jankia,Puri,Orissa',
'Kadab,Puri,Orissa',
'Kaipadar,Puri,Orissa',
'Kalyanpur,Puri,Orissa',
'Kantabad,Puri,Orissa',
'Karadgadia,Puri,Orissa',
'Keranga,Puri,Orissa',
'Khurda H.O,Puri,Orissa',
'Kotapalla,Puri,Orissa',
'Kumarbasta,Puri,Orissa',
'Kunjuri,Puri,Orissa',
'Malipada,Puri,Orissa',
'Malipadar,Puri,Orissa',
'Motta,Puri,Orissa',
'Muktapur,Puri,Orissa',
'Mukundaprasad,Puri,Orissa',
'Nalipada Arjunpur,Puri,Orissa',
'Narangarh,Puri,Orissa',
'Nidhipur,Puri,Orissa',
'Nijigarhtapang,Puri,Orissa',
'Olasingh,Puri,Orissa',
'P N College,Puri,Orissa',
'Paikatigiria,Puri,Orissa',
'Pallahat,Puri,Orissa',
'Panabaraj,Puri,Orissa',
'Pangarsingh,Puri,Orissa',
'Parichhala,Puri,Orissa',
'Pichikuli,Puri,Orissa',
'Podadihi,Puri,Orissa',
'Pubusahi,Puri,Orissa',
'Raipur,Puri,Orissa',
'Ramchandi,Puri,Orissa',
'Routapada,Puri,Orissa',
'Sardhapur,Puri,Orissa',
'Sarua,Puri,Orissa',
'Simor,Puri,Orissa',
'Tartua,Puri,Orissa',
'Thanapalli,Puri,Orissa',
'Barikilo,Puri,Orissa',
'Gediapalli,Puri,Orissa',
'Narayanipada,Puri,Orissa',
'Kesharpur,Puri,Orissa',
'Raigurupur,Puri,Orissa',
'Bhatapada,Puri,Orissa',
'Garhkharad,Puri,Orissa',
'Odal,Puri,Orissa',
'Olhan,Puri,Orissa',
'Godiput Matiapada,Puri,Orissa',
'Abhimanpur,Puri,Orissa',
'Achyutpur,Puri,Orissa',
'Badapari,Puri,Orissa',
'Bhusundapur,Puri,Orissa',
'Chandeswar,Puri,Orissa',
'Haripur,Puri,Orissa',
'Jaripada,Puri,Orissa',
'Kaluparaghat,Puri,Orissa',
'Kamaguru,Puri,Orissa',
'Kusumi,Puri,Orissa',
'Mangalajodi,Puri,Orissa',
'Pariorada,Puri,Orissa',
'Patiamal,Puri,Orissa',
'Rameswar,Puri,Orissa',
'Singipur,Puri,Orissa',
'Sundarpur,Puri,Orissa',
'Tangi,Puri,Orissa',
'Tankol,Puri,Orissa',
'Bariniput,Koraput,Orissa',
'Kathargada,Koraput,Orissa',
'Anchala,Koraput,Orissa',
'Benagaon,Koraput,Orissa',
'Benasur,Koraput,Orissa',
'Bhairabsinghpur,Koraput,Orissa',
'Bijapur,Koraput,Orissa',
'Bodigaon,Koraput,Orissa',
'Borigumma,Koraput,Orissa',
'Champapadar,Koraput,Orissa',
'Chitra,Koraput,Orissa',
'Gujaniguda,Koraput,Orissa',
'Gumuda,Koraput,Orissa',
'Hardoli,Koraput,Orissa',
'Jayantgiri,Koraput,Orissa',
'Kabidi,Koraput,Orissa',
'Kabidi,Koraput,Orissa',
'Kamta,Koraput,Orissa',
'Konagam,Koraput,Orissa',
'Konagam,Koraput,Orissa',
'Kosaguda,Koraput,Orissa',
'Kosaguda,Koraput,Orissa',
'Kumuli,Koraput,Orissa',
'Malda,Koraput,Orissa',
'Munja,Koraput,Orissa',
'Narigam,Koraput,Orissa',
'Nuagaon,Koraput,Orissa',
'Panasaguda,Koraput,Orissa',
'Porli,Koraput,Orissa',
'Pujariput,Koraput,Orissa',
'Ranaspur,Koraput,Orissa',
'Raniguda,Koraput,Orissa',
'Sanparia,Koraput,Orissa',
'Sasahandi,Koraput,Orissa',
'Semlaguda,Koraput,Orissa',
'Sorgiguda,Koraput,Orissa',
'Hadia,Koraput,Orissa',
'Haradaput,Koraput,Orissa',
'Jamunda,Koraput,Orissa',
'Konga,Koraput,Orissa',
'Kusumi,Koraput,Orissa',
'Prasadraopeta,Koraput,Orissa',
'Ambaguda,Koraput,Orissa',
'Anta,Koraput,Orissa',
'Asana,Koraput,Orissa',
'B.D.Pur,Koraput,Orissa',
'Bagderi,Koraput,Orissa',
'Baligam,Koraput,Orissa',
'Baruaguda,Koraput,Orissa',
'Bhaminiput,Koraput,Orissa',
'Bhejahandi,Koraput,Orissa',
'Bhusanguda,Koraput,Orissa',
'Bobia,Koraput,Orissa',
'Bodaput,Koraput,Orissa',
'Boipariguda,Koraput,Orissa',
'Chikima,Koraput,Orissa',
'Chipakhor,Koraput,Orissa',
'D.Paunsi,Koraput,Orissa',
'Dabuguda,Koraput,Orissa',
'Dandabadi,Koraput,Orissa',
'Dasamanthpur,Koraput,Orissa',
'Dhanpur,Koraput,Orissa',
'Digapur,Koraput,Orissa',
'Dongerchinchi,Koraput,Orissa',
'Doraguda,Koraput,Orissa',
'Ghumar,Koraput,Orissa',
'Godapadar,Koraput,Orissa',
'Gondal,Koraput,Orissa',
'Haladikund,Koraput,Orissa',
'Jayanagar,Koraput,Orissa',
'Jeypore(K) Civil Court,Koraput,Orissa',
'Jeypore(K) Fort,Koraput,Orissa',
'Jeypore(K) H.O,Koraput,Orissa',
'Jeypore(K) Irrigation Colony,Koraput,Orissa',
'Jeypore(K) Koraput Road,Koraput,Orissa',
'Jeypore(K) R.S.,Koraput,Orissa',
'Kadamguda,Koraput,Orissa',
'Kaliagam,Koraput,Orissa',
'Karimiti,Koraput,Orissa',
'Kenduguda,Koraput,Orissa',
'Khairput,Koraput,Orissa',
'Kollar,Koraput,Orissa',
'Kudumuluguma,Koraput,Orissa',
'Kundura,Koraput,Orissa',
'Lima,Koraput,Orissa',
'Majhiguda,Koraput,Orissa',
'Mohuli,Koraput,Orissa',
'Mosigam,Koraput,Orissa',
'Mudulipada,Koraput,Orissa',
'Peta,Koraput,Orissa',
'Phampuni,Koraput,Orissa',
'Phupugaon,Koraput,Orissa',
'Podaghat,Koraput,Orissa',
'Ramgiri,Koraput,Orissa',
'Raniput,Koraput,Orissa',
'Rasbeda,Koraput,Orissa',
'Rondapalli,Koraput,Orissa',
'Somnathpur,Koraput,Orissa',
'Tankua,Koraput,Orissa',
'Taraput,Koraput,Orissa',
'Tentuligumma,Koraput,Orissa',
'Umuri,Koraput,Orissa',
'A.Malkangiri,Koraput,Orissa',
'Almonda,Koraput,Orissa',
'Bandhugam,Koraput,Orissa',
'Bhitarguda,Koraput,Orissa',
'Borigi,Koraput,Orissa',
'Chanabeda,Koraput,Orissa',
'D.P.Camp, Sunabeda,Koraput,Orissa',
'D.Padar,Koraput,Orissa',
'Damanjodi,Koraput,Orissa',
'Dambaguda,Koraput,Orissa',
'Dasamanthpur,Koraput,Orissa',
'Deoghati,Koraput,Orissa',
'Dudhari,Koraput,Orissa',
'Dumuriput,Koraput,Orissa',
'Garidi,Koraput,Orissa',
'Girliguma,Koraput,Orissa',
'Hataguda,Koraput,Orissa',
'Jabaguda,Koraput,Orissa',
'K.Guda,Koraput,Orissa',
'Kabirbadi,Koraput,Orissa',
'Kaploda,Koraput,Orissa',
'Kendar,Koraput,Orissa',
'Khudi,Koraput,Orissa',
'Kolab Nagar,Koraput,Orissa',
'Koraput Collectorate,Koraput,Orissa',
'Koraput H.O,Koraput,Orissa',
'Koraput R.S.,Koraput,Orissa',
'Kumbharput,Koraput,Orissa',
'Kunduli,Koraput,Orissa',
'Litiguda,Koraput,Orissa',
'Lulla,Koraput,Orissa',
'Mahadeiput,Koraput,Orissa',
'Mastiput,Koraput,Orissa',
'Mathalput,Koraput,Orissa',
'Murkur,Koraput,Orissa',
'Nad, Sunabeda,Koraput,Orissa',
'Nandigam,Koraput,Orissa',
'Nilabadi,Koraput,Orissa',
'Omp Line,Koraput,Orissa',
'P.Muthai,Koraput,Orissa',
'P.Phulbeda,Koraput,Orissa',
'Padavalda,Koraput,Orissa',
'Pakjhola,Koraput,Orissa',
'Pindapadar,Koraput,Orissa',
'R Zone(Sunabeda),Koraput,Orissa',
'Rajput,Koraput,Orissa',
'Ranjiput,Koraput,Orissa',
'Renga,Koraput,Orissa',
'Sadabari,Koraput,Orissa',
'Sector-VII(Sunabeda),Koraput,Orissa',
'Semiliguda,Koraput,Orissa',
'Suku,Koraput,Orissa',
'Sunabeda-1,Koraput,Orissa',
'Sunabeda-2,Koraput,Orissa',
'Umuri,Koraput,Orissa',
'Batasena,Koraput,Orissa',
'Bhansuli,Koraput,Orissa',
'Binjili,Koraput,Orissa',
'Chandili,Koraput,Orissa',
'Chirma,Koraput,Orissa',
'Dhamanahandi,Koraput,Orissa',
'Ghotarla,Koraput,Orissa',
'Ghumar,Koraput,Orissa',
'Girla,Koraput,Orissa',
'Kerla,Koraput,Orissa',
'Kotpad,Koraput,Orissa',
'Modeigaon,Koraput,Orissa',
'Muttahandi,Koraput,Orissa',
'Sadaranga,Koraput,Orissa',
'Sunarbelli (Nuagaon),Koraput,Orissa',
'Ukiapalli,Koraput,Orissa',
'Laxmipur,Koraput,Orissa',
'Badel,Koraput,Orissa',
'Balel,Koraput,Orissa',
'Bilaput,Koraput,Orissa',
'Jolaput,Koraput,Orissa',
'Machhkund,Koraput,Orissa',
'Badigada,Koraput,Orissa',
'Godihanjar,Koraput,Orissa',
'Guneipada,Koraput,Orissa',
'Jalahanjar,Koraput,Orissa',
'Lamtaput,Koraput,Orissa',
'Ondrahal,Koraput,Orissa',
'Onukadeli,Koraput,Orissa',
'Soguru,Koraput,Orissa',
'Tikarpada,Koraput,Orissa',
'Tusuba,Koraput,Orissa',
'Upperdural,Koraput,Orissa',
'Balipeta,Koraput,Orissa',
'Bilangsil,Koraput,Orissa',
'Burja,Koraput,Orissa',
'Champi,Koraput,Orissa',
'Gadiaguda,Koraput,Orissa',
'Goudaguda,Koraput,Orissa',
'Jogipalur,Koraput,Orissa',
'Kakirigumma,Koraput,Orissa',
'Khumbari,Koraput,Orissa',
'Kusumguda,Koraput,Orissa',
'Munjanga,Koraput,Orissa',
'Narayanpatna,Koraput,Orissa',
'Odiapentha,Koraput,Orissa',
'Panchada,Koraput,Orissa',
'Pipalpadar,Koraput,Orissa',
'Podagada,Koraput,Orissa',
'Podapadar,Koraput,Orissa',
'T.Gumandi,Koraput,Orissa',
'T.Padar,Koraput,Orissa',
'Toyaput,Koraput,Orissa',
'Upperkutinga,Koraput,Orissa',
'Ampawalli,Koraput,Orissa',
'B.Maliput,Koraput,Orissa',
'Balda,Koraput,Orissa',
'Bheja,Koraput,Orissa',
'Chatwa,Koraput,Orissa',
'Chendika,Koraput,Orissa',
'Deopotangi,Koraput,Orissa',
'Gangarajpur,Koraput,Orissa',
'Golur,Koraput,Orissa',
'Guntaput,Koraput,Orissa',
'Hakimput,Koraput,Orissa',
'Hatibari,Koraput,Orissa',
'Kadamguda,Koraput,Orissa',
'Kasandi,Koraput,Orissa',
'Khurjee,Koraput,Orissa',
'Kotiya,Koraput,Orissa',
'Kularsingi,Koraput,Orissa',
'Kumargandhana,Koraput,Orissa',
'Malbelagam,Koraput,Orissa',
'Maliput,Koraput,Orissa',
'Nandapur,Koraput,Orissa',
'Ondrangi,Koraput,Orissa',
'Padwa,Koraput,Orissa',
'Panthulunga,Koraput,Orissa',
'Peturu,Koraput,Orissa',
'Pithaguda,Koraput,Orissa',
'Pottangi,Koraput,Orissa',
'Pukali,Koraput,Orissa',
'Raisingi,Koraput,Orissa',
'Ralegada,Koraput,Orissa',
'Sadam,Koraput,Orissa',
'Sambai,Koraput,Orissa',
'Simla,Koraput,Orissa',
'Sorada,Koraput,Orissa',
'Subai,Koraput,Orissa',
'Sunki,Koraput,Orissa',
'T.Thuba,Koraput,Orissa',
'Turia,Koraput,Orissa',
'Wandergada,Koraput,Orissa',
'Panchabati,Koraput,Orissa',
'Pedakonda,Koraput,Orissa',
'Andrapali,Koraput,Orissa',
'Badapadar,Koraput,Orissa',
'Boiliguma,Koraput,Orissa',
'Chitrakonda,Koraput,Orissa',
'Doraguda,Koraput,Orissa',
'Gunthawada,Koraput,Orissa',
'Jodamba,Koraput,Orissa',
'Kambeda,Koraput,Orissa',
'Panasput,Koraput,Orissa',
'Papermetla,Koraput,Orissa',
'Populuru,Koraput,Orissa',
'Relageda,Koraput,Orissa',
'Attanda,Koraput,Orissa',
'Ambaguda,Koraput,Orissa',
'B.Mamidi,Koraput,Orissa',
'Balimela,Koraput,Orissa',
'Bhejaguda,Koraput,Orissa',
'Birlaxmipur,Koraput,Orissa',
'Bodili,Koraput,Orissa',
'Chalanguda,Koraput,Orissa',
'Chaulmendi,Koraput,Orissa',
'Chedenga,Koraput,Orissa',
'Chitapari,Koraput,Orissa',
'Chitrangpali,Koraput,Orissa',
'Dalapatiguda,Koraput,Orissa',
'Dungiaput,Koraput,Orissa',
'Dyke-1,Koraput,Orissa',
'Gongola,Koraput,Orissa',
'Goudaguda,Koraput,Orissa',
'Govindpalli,Koraput,Orissa',
'Gurakhunta,Koraput,Orissa',
'Jharapalli,Koraput,Orissa',
'Kalimela,Koraput,Orissa',
'Kartanpalli,Koraput,Orissa',
'Kiyanga,Koraput,Orissa',
'Korukonda,Koraput,Orissa',
'Kottapali,Koraput,Orissa',
'Kutunipalli,Koraput,Orissa',
'Malkangiri Colony,Koraput,Orissa',
'Malkangiri,Koraput,Orissa',
'Mariwada,Koraput,Orissa',
'Mathili,Koraput,Orissa',
'Mekka,Koraput,Orissa',
'Mendukuli,Koraput,Orissa',
'Metapoka,Koraput,Orissa',
'Mohupadar,Koraput,Orissa',
'Muduliguda,Koraput,Orissa',
'Naikaguda,Koraput,Orissa',
'Nakamamidi,Koraput,Orissa',
'Nilakhambari,Koraput,Orissa',
'Padmagiri,Koraput,Orissa',
'Pandripani,Koraput,Orissa',
'Pongam,Koraput,Orissa',
'Potrel,Koraput,Orissa',
'Pulimetla,Koraput,Orissa',
'Salimi,Koraput,Orissa',
'Saradhapalli,Koraput,Orissa',
'Sikhapali,Koraput,Orissa',
'Tamasa,Koraput,Orissa',
'Tandiki,Koraput,Orissa',
'Tarlakota,Koraput,Orissa',
'Temurupali,Koraput,Orissa',
'Tumusapalli,Koraput,Orissa',
'Udilibeda,Koraput,Orissa',
'Anantapali,Koraput,Orissa',
'Bapanpali,Koraput,Orissa',
'Bhejangiwada,Koraput,Orissa',
'Girikanpalli,Koraput,Orissa',
'Gopagonda,Koraput,Orissa',
'Kongurukonda,Koraput,Orissa',
'Lachipeta,Koraput,Orissa',
'Maharajpalli,Koraput,Orissa',
'Malavaram,Koraput,Orissa',
'Manyamkonda,Koraput,Orissa',
'Maranpalli,Koraput,Orissa',
'Motteru,Koraput,Orissa',
'Motu,Koraput,Orissa',
'Nallagunthi,Koraput,Orissa',
'Niliguda,Koraput,Orissa',
'Podia,Koraput,Orissa',
'Simlibamchha,Koraput,Orissa',
'Talarai,Koraput,Orissa',
'Tandabai,Koraput,Orissa',
'Venkatpallam,Koraput,Orissa',
'Baddalima,Mayurbhanj,Orissa',
'Badpalasa,Mayurbhanj,Orissa',
'Bahalda Rd RS,Mayurbhanj,Orissa',
'Bahalda,Mayurbhanj,Orissa',
'Bhagabandi,Mayurbhanj,Orissa',
'Changua,Mayurbhanj,Orissa',
'Dharamdihi,Mayurbhanj,Orissa',
'Jirei,Mayurbhanj,Orissa',
'Lupung,Mayurbhanj,Orissa',
'Maghua,Mayurbhanj,Orissa',
'Pandupani,Mayurbhanj,Orissa',
'Sanbhundu,Mayurbhanj,Orissa',
'Tiring,Mayurbhanj,Orissa',
'Baunsbilla,Mayurbhanj,Orissa',
'Ambapunja,Mayurbhanj,Orissa',
'Ambikasahi,Mayurbhanj,Orissa',
'Aniapal,Mayurbhanj,Orissa',
'Anlakuda,Mayurbhanj,Orissa',
'Asana,Mayurbhanj,Orissa',
'Asanjoda,Mayurbhanj,Orissa',
'Badbhalia,Mayurbhanj,Orissa',
'Badchatra,Mayurbhanj,Orissa',
'Baddhenkia,Mayurbhanj,Orissa',
'Badfera,Mayurbhanj,Orissa',
'Badgaon,Mayurbhanj,Orissa',
'Badmundhabani,Mayurbhanj,Orissa',
'Badsole,Mayurbhanj,Orissa',
'Bagbuda,Mayurbhanj,Orissa',
'Baghra,Mayurbhanj,Orissa',
'Baghra Road,Mayurbhanj,Orissa',
'Baghuasole,Mayurbhanj,Orissa',
'Bagjhumpa,Mayurbhanj,Orissa',
'Baiganbaria,Mayurbhanj,Orissa',
'Balidiha,Mayurbhanj,Orissa',
'Bangriposi,Mayurbhanj,Orissa',
'Bankati,Mayurbhanj,Orissa',
'Bankisole,Mayurbhanj,Orissa',
'Bari,Mayurbhanj,Orissa',
'Baripada Bazar,Mayurbhanj,Orissa',
'Baripada Court,Mayurbhanj,Orissa',
'Baripada H.O,Mayurbhanj,Orissa',
'Baripada Hospital,Mayurbhanj,Orissa',
'Baripada Municipal Market,Mayurbhanj,Orissa',
'Baripada R.S.,Mayurbhanj,Orissa',
'Baunsda,Mayurbhanj,Orissa',
'Bedhakudar,Mayurbhanj,Orissa',
'Belbaria,Mayurbhanj,Orissa',
'Belgadia,Mayurbhanj,Orissa',
'Bhaluki,Mayurbhanj,Orissa',
'Bhanjpur,Mayurbhanj,Orissa',
'Bhuasuni,Mayurbhanj,Orissa',
'Bhudrubani,Mayurbhanj,Orissa',
'Bhugudakata,Mayurbhanj,Orissa',
'Bhursani,Mayurbhanj,Orissa',
'Bijay Ramchandrapur,Mayurbhanj,Orissa',
'Brahmanmara,Mayurbhanj,Orissa',
'Budama R.S.,Mayurbhanj,Orissa',
'Budhikhamari,Mayurbhanj,Orissa',
'Chadheigaon,Mayurbhanj,Orissa',
'Chaksuliapada,Mayurbhanj,Orissa',
'Chandanpur,Mayurbhanj,Orissa',
'Chandua Ashram,Mayurbhanj,Orissa',
'Chhadkata,Mayurbhanj,Orissa',
'Chuhat,Mayurbhanj,Orissa',
'Dakoipodadiha,Mayurbhanj,Orissa',
'Damodar Pur,Mayurbhanj,Orissa',
'Danadar,Mayurbhanj,Orissa',
'Dardara,Mayurbhanj,Orissa',
'Darudihi,Mayurbhanj,Orissa',
'Deulasahi,Mayurbhanj,Orissa',
'Deuli,Mayurbhanj,Orissa',
'Dhangudisole,Mayurbhanj,Orissa',
'Dharampura,Mayurbhanj,Orissa',
'Dhatika,Mayurbhanj,Orissa',
'Dhemnasole,Mayurbhanj,Orissa',
'Dhenkinenjia,Mayurbhanj,Orissa',
'Dhobanisole,Mayurbhanj,Orissa',
'Digar Astia,Mayurbhanj,Orissa',
'Dighi,Mayurbhanj,Orissa',
'Dudhiasole,Mayurbhanj,Orissa',
'Dumurdiha,Mayurbhanj,Orissa',
'Dumurdiha,Mayurbhanj,Orissa',
'Ekdali,Mayurbhanj,Orissa',
'Fania,Mayurbhanj,Orissa',
'Futukisole,Mayurbhanj,Orissa',
'Gandipani,Mayurbhanj,Orissa',
'Gangraj,Mayurbhanj,Orissa',
'Garia,Mayurbhanj,Orissa',
'Garudnesa,Mayurbhanj,Orissa',
'Gayalkata,Mayurbhanj,Orissa',
'Gendapokhari,Mayurbhanj,Orissa',
'Ghatkuanri,Mayurbhanj,Orissa',
'Ghodapal,Mayurbhanj,Orissa',
'Golamundhakata,Mayurbhanj,Orissa',
'Gosanipal,Mayurbhanj,Orissa',
'Goudadiha,Mayurbhanj,Orissa',
'Goudruma,Mayurbhanj,Orissa',
'Gouduniduba,Mayurbhanj,Orissa',
'Haldia (Baripada),Mayurbhanj,Orissa',
'Haldibani,Mayurbhanj,Orissa',
'Hinjili,Mayurbhanj,Orissa',
'Jagannathkhunta,Mayurbhanj,Orissa',
'Jagannathpur,Mayurbhanj,Orissa',
'Jalda,Mayurbhanj,Orissa',
'Jaldiha,Mayurbhanj,Orissa',
'Jharpokharia,Mayurbhanj,Orissa',
'Joka,Mayurbhanj,Orissa',
'Kaduani,Mayurbhanj,Orissa',
'Kainfulia,Mayurbhanj,Orissa',
'Kakharusole,Mayurbhanj,Orissa',
'Kalabadia,Mayurbhanj,Orissa',
'Kanchhinda,Mayurbhanj,Orissa',
'Kandana,Mayurbhanj,Orissa',
'Kanimahuli,Mayurbhanj,Orissa',
'Kantapal,Mayurbhanj,Orissa',
'Kathsirsi,Mayurbhanj,Orissa',
'Katra Chandan Pur,Mayurbhanj,Orissa',
'Kendua,Mayurbhanj,Orissa',
'Kesharpur,Mayurbhanj,Orissa',
'Keshrasole,Mayurbhanj,Orissa',
'Keutunimari,Mayurbhanj,Orissa',
'Khadiasole,Mayurbhanj,Orissa',
'Khairbani,Mayurbhanj,Orissa',
'Khalapada,Mayurbhanj,Orissa',
'Kherna,Mayurbhanj,Orissa',
'Kisandahi,Mayurbhanj,Orissa',
'Kochilaghaty,Mayurbhanj,Orissa',
'Koilisuta,Mayurbhanj,Orissa',
'Kostha,Mayurbhanj,Orissa',
'Kothabila,Mayurbhanj,Orissa',
'Kuabuda,Mayurbhanj,Orissa',
'Kuanrdihi,Mayurbhanj,Orissa',
'Kuchei,Mayurbhanj,Orissa',
'Kudiapal,Mayurbhanj,Orissa',
'Kui,Mayurbhanj,Orissa',
'Kujidihi,Mayurbhanj,Orissa',
'Kuliana,Mayurbhanj,Orissa',
'Kumbharmundakata,Mayurbhanj,Orissa',
'Kundulia,Mayurbhanj,Orissa',
'Kusumasole,Mayurbhanj,Orissa',
'Kusumbandi,Mayurbhanj,Orissa',
'Labania,Mayurbhanj,Orissa',
'Laxmiposi,Mayurbhanj,Orissa',
'Lunia,Mayurbhanj,Orissa',
'Mahabila,Mayurbhanj,Orissa',
'Mahulbarei,Mayurbhanj,Orissa',
'Manbhanj,Mayurbhanj,Orissa',
'Marangtandi,Mayurbhanj,Orissa',
'Marudihi,Mayurbhanj,Orissa',
'Murunia,Mayurbhanj,Orissa',
'Nabedhi,Mayurbhanj,Orissa',
'Nafree,Mayurbhanj,Orissa',
'Naupada,Mayurbhanj,Orissa',
'Nischinta,Mayurbhanj,Orissa',
'Nodhana,Mayurbhanj,Orissa',
'Nuagaon,Mayurbhanj,Orissa',
'Nuagaon-talakchuin,Mayurbhanj,Orissa',
'Nuhajhalia,Mayurbhanj,Orissa',
'Nuhamalia,Mayurbhanj,Orissa',
'Nuhamalia,Mayurbhanj,Orissa',
'Padmapur Deuli,Mayurbhanj,Orissa',
'Paktia,Mayurbhanj,Orissa',
'Paktia,Mayurbhanj,Orissa',
'Palabani Chhak,Mayurbhanj,Orissa',
'Palasbani,Mayurbhanj,Orissa',
'Palpala Ambadali,Mayurbhanj,Orissa',
'Pandhada,Mayurbhanj,Orissa',
'Pandra Rolasahi,Mayurbhanj,Orissa',
'Parulia,Mayurbhanj,Orissa',
'Patharchakuli,Mayurbhanj,Orissa',
'Patharkham,Mayurbhanj,Orissa',
'Pathuri,Mayurbhanj,Orissa',
'Patihinja,Mayurbhanj,Orissa',
'Poda-astia,Mayurbhanj,Orissa',
'Pokhardiha,Mayurbhanj,Orissa',
'Pokharia,Mayurbhanj,Orissa',
'Pokharia,Mayurbhanj,Orissa',
'Pokpoka,Mayurbhanj,Orissa',
'Puruna Pani,Mayurbhanj,Orissa',
'Raikad Jharan,Mayurbhanj,Orissa',
'Rajabasa,Mayurbhanj,Orissa',
'Rajaloka,Mayurbhanj,Orissa',
'Rangamatia,Mayurbhanj,Orissa',
'Ratila,Mayurbhanj,Orissa',
'Saluadahar,Mayurbhanj,Orissa',
'Sanfutuka,Mayurbhanj,Orissa',
'Sankachimbila,Mayurbhanj,Orissa',
'Sankhabhanga,Mayurbhanj,Orissa',
'Sankhabhanga,Mayurbhanj,Orissa',
'Sankucha,Mayurbhanj,Orissa',
'Sanmundhabani,Mayurbhanj,Orissa',
'Sansarasposi,Mayurbhanj,Orissa',
'Saradiha,Mayurbhanj,Orissa',
'Saragchhida,Mayurbhanj,Orissa',
'Saraskana,Mayurbhanj,Orissa',
'Sarasposi,Mayurbhanj,Orissa',
'Saratchandrapur,Mayurbhanj,Orissa',
'Sarisapal,Mayurbhanj,Orissa',
'Shirsa,Mayurbhanj,Orissa',
'Shyamakhunta,Mayurbhanj,Orissa',
'Shyamsundarpur,Mayurbhanj,Orissa',
'Silfodi,Mayurbhanj,Orissa',
'Sindurgoura,Mayurbhanj,Orissa',
'Singda,Mayurbhanj,Orissa',
'Sirishbani,Mayurbhanj,Orissa',
'Sripad Ganja,Mayurbhanj,Orissa',
'Suliapada,Mayurbhanj,Orissa',
'Tadki,Mayurbhanj,Orissa',
'Takatpur,Mayurbhanj,Orissa',
'Tulasichoura,Mayurbhanj,Orissa',
'Ufalgadia,Mayurbhanj,Orissa',
'Unchagaon,Mayurbhanj,Orissa',
'Ambadali,Mayurbhanj,Orissa',
'Arpata,Mayurbhanj,Orissa',
'Astajharan,Mayurbhanj,Orissa',
'B. Chhelia,Mayurbhanj,Orissa',
'Badfeni,Mayurbhanj,Orissa',
'Badpathara,Mayurbhanj,Orissa',
'Bahalda,Mayurbhanj,Orissa',
'Bajratundi,Mayurbhanj,Orissa',
'Bangra,Mayurbhanj,Orissa',
'Barsahi,Mayurbhanj,Orissa',
'Belam,Mayurbhanj,Orissa',
'Bhimda,Mayurbhanj,Orissa',
'Bijipur,Mayurbhanj,Orissa',
'Bireswarpur,Mayurbhanj,Orissa',
'C.Mangalpur,Mayurbhanj,Orissa',
'Chadada,Mayurbhanj,Orissa',
'Chandanpur,Mayurbhanj,Orissa',
'Chandrapur,Mayurbhanj,Orissa',
'Chhelia,Mayurbhanj,Orissa',
'Daundia,Mayurbhanj,Orissa',
'Deopara,Mayurbhanj,Orissa',
'Deulia,Mayurbhanj,Orissa',
'Dukura,Mayurbhanj,Orissa',
'Gendagadia,Mayurbhanj,Orissa',
'Gudialbandh,Mayurbhanj,Orissa',
'Haripur,Mayurbhanj,Orissa',
'Itamundia,Mayurbhanj,Orissa',
'Jadunathpur,Mayurbhanj,Orissa',
'Kadualbandh,Mayurbhanj,Orissa',
'Kamalasole,Mayurbhanj,Orissa',
'Kamali,Mayurbhanj,Orissa',
'Kendudiha,Mayurbhanj,Orissa',
'Kerko Baiganbaria,Mayurbhanj,Orissa',
'Khanua,Mayurbhanj,Orissa',
'Khuntapal,Mayurbhanj,Orissa',
'Kuradiha,Mayurbhanj,Orissa',
'Lakhanasahi,Mayurbhanj,Orissa',
'Madhopur,Mayurbhanj,Orissa',
'Mirigidari,Mayurbhanj,Orissa',
'Nakhra,Mayurbhanj,Orissa',
'Nankua,Mayurbhanj,Orissa',
'Narangaon,Mayurbhanj,Orissa',
'Narankhunta,Mayurbhanj,Orissa',
'Orachandbilla,Mayurbhanj,Orissa',
'Paikabasa,Mayurbhanj,Orissa',
'Patarapada,Mayurbhanj,Orissa',
'Patisari,Mayurbhanj,Orissa',
'Pratappur,Mayurbhanj,Orissa',
'Ranibandh,Mayurbhanj,Orissa',
'Salbani,Mayurbhanj,Orissa',
'Salgaon,Mayurbhanj,Orissa',
'Sankerko,Mayurbhanj,Orissa',
'Sapanchua,Mayurbhanj,Orissa',
'Singtia,Mayurbhanj,Orissa',
'Suhagpura,Mayurbhanj,Orissa',
'Talakunda,Mayurbhanj,Orissa',
'Talanda,Mayurbhanj,Orissa',
'Talpada,Mayurbhanj,Orissa',
'Tangana,Mayurbhanj,Orissa',
'Tangasole,Mayurbhanj,Orissa',
'Tentuligaon,Mayurbhanj,Orissa',
'Uthani Nuagaon,Mayurbhanj,Orissa',
'Pruthunathpur,Mayurbhanj,Orissa',
'Agria,Mayurbhanj,Orissa',
'Aguad,Mayurbhanj,Orissa',
'Alda,Mayurbhanj,Orissa',
'Aldia Bartana,Mayurbhanj,Orissa',
'Ambagadia,Mayurbhanj,Orissa',
'Anla,Mayurbhanj,Orissa',
'Asanbani,Mayurbhanj,Orissa',
'Badchhuruni,Mayurbhanj,Orissa',
'Badjod,Mayurbhanj,Orissa',
'Badkhiripada,Mayurbhanj,Orissa',
'Bahanada Sathilo,Mayurbhanj,Orissa',
'Baisinga,Mayurbhanj,Orissa',
'Balka,Mayurbhanj,Orissa',
'Bartana,Mayurbhanj,Orissa',
'Betnoti,Mayurbhanj,Orissa',
'Bhalia,Mayurbhanj,Orissa',
'Bhudurbani,Mayurbhanj,Orissa',
'Bidukudia,Mayurbhanj,Orissa',
'Budhikhamari,Mayurbhanj,Orissa',
'Dahikoti,Mayurbhanj,Orissa',
'Dalki,Mayurbhanj,Orissa',
'Dantiamuhan,Mayurbhanj,Orissa',
'Dhanpur,Mayurbhanj,Orissa',
'Durgapur,Mayurbhanj,Orissa',
'Durgapur,Mayurbhanj,Orissa',
'Durgapur,Mayurbhanj,Orissa',
'Garhdeulia,Mayurbhanj,Orissa',
'Gobapal,Mayurbhanj,Orissa',
'Gosaingaon,Mayurbhanj,Orissa',
'Hatijhari,Mayurbhanj,Orissa',
'Hatikote,Mayurbhanj,Orissa',
'Hempur,Mayurbhanj,Orissa',
'Jamdapal,Mayurbhanj,Orissa',
'Jamsole,Mayurbhanj,Orissa',
'Jugal,Mayurbhanj,Orissa',
'Jugpura,Mayurbhanj,Orissa',
'Kadalia,Mayurbhanj,Orissa',
'Kalama,Mayurbhanj,Orissa',
'Kanchisole,Mayurbhanj,Orissa',
'Kantipur,Mayurbhanj,Orissa',
'Karamsole,Mayurbhanj,Orissa',
'Khadikapada,Mayurbhanj,Orissa',
'Khuntapur,Mayurbhanj,Orissa',
'Kochilakhunta,Mayurbhanj,Orissa',
'Krushnachandrapur,Mayurbhanj,Orissa',
'Kuliana Barsahi,Mayurbhanj,Orissa',
'Machhapada,Mayurbhanj,Orissa',
'Mahulpatna,Mayurbhanj,Orissa',
'Mantri,Mayurbhanj,Orissa',
'Merda,Mayurbhanj,Orissa',
'Muktapur,Mayurbhanj,Orissa',
'Nachhipuria,Mayurbhanj,Orissa',
'Nuagaon,Mayurbhanj,Orissa',
'Palasia,Mayurbhanj,Orissa',
'Patalipura,Mayurbhanj,Orissa',
'Paunsia,Mayurbhanj,Orissa',
'Purikhunta,Mayurbhanj,Orissa',
'Purinda,Mayurbhanj,Orissa',
'Purunia,Mayurbhanj,Orissa',
'Raghavpur,Mayurbhanj,Orissa',
'Raghupur,Mayurbhanj,Orissa',
'Raikama,Mayurbhanj,Orissa',
'Rangapani,Mayurbhanj,Orissa',
'Saitpur,Mayurbhanj,Orissa',
'Sakua,Mayurbhanj,Orissa',
'Sansa,Mayurbhanj,Orissa',
'Saria,Mayurbhanj,Orissa',
'Sialighati,Mayurbhanj,Orissa',
'Singlamundali,Mayurbhanj,Orissa',
'Sureidihi,Mayurbhanj,Orissa',
'Tarakothi,Mayurbhanj,Orissa',
'Tasarda,Mayurbhanj,Orissa',
'Tilapada,Mayurbhanj,Orissa',
'Totapada,Mayurbhanj,Orissa',
'Angarpada,Mayurbhanj,Orissa',
'Arjunbilla,Mayurbhanj,Orissa',
'Astakuanr,Mayurbhanj,Orissa',
'Badgaon,Mayurbhanj,Orissa',
'Badterenti,Mayurbhanj,Orissa',
'Baidyanath,Mayurbhanj,Orissa',
'Bakartala,Mayurbhanj,Orissa',
'Bakla,Mayurbhanj,Orissa',
'Bala,Mayurbhanj,Orissa',
'Barakamuda,Mayurbhanj,Orissa',
'Barehipani,Mayurbhanj,Orissa',
'Baria,Mayurbhanj,Orissa',
'Batpalasa,Mayurbhanj,Orissa',
'Baunsdiha,Mayurbhanj,Orissa',
'Baunsnali,Mayurbhanj,Orissa',
'Begunia,Mayurbhanj,Orissa',
'Bhadubeda,Mayurbhanj,Orissa',
'Bhanjkia,Mayurbhanj,Orissa',
'Bhanra,Mayurbhanj,Orissa',
'Bharandia,Mayurbhanj,Orissa',
'Brahmaniposi,Mayurbhanj,Orissa',
'Bramarposi,Mayurbhanj,Orissa',
'Budamara,Mayurbhanj,Orissa',
'Budhigambharia,Mayurbhanj,Orissa',
'Chakidi,Mayurbhanj,Orissa',
'Champajhar,Mayurbhanj,Orissa',
'Chanchbani,Mayurbhanj,Orissa',
'Chaturanjali,Mayurbhanj,Orissa',
'Chheligudhudi,Mayurbhanj,Orissa',
'Chitraposi,Mayurbhanj,Orissa',
'Dari,Mayurbhanj,Orissa',
'Denua,Mayurbhanj,Orissa',
'Dhalabani,Mayurbhanj,Orissa',
'Digdhar,Mayurbhanj,Orissa',
'Dudhiani,Mayurbhanj,Orissa',
'Durdura,Mayurbhanj,Orissa',
'Ektali,Mayurbhanj,Orissa',
'Gadapalasa,Mayurbhanj,Orissa',
'Galusahi,Mayurbhanj,Orissa',
'Ghagarbeda,Mayurbhanj,Orissa',
'Ghagarda,Mayurbhanj,Orissa',
'Ghosada,Mayurbhanj,Orissa',
'Gudugudia,Mayurbhanj,Orissa',
'Haldia,Mayurbhanj,Orissa',
'Hatibari,Mayurbhanj,Orissa',
'Hatigoda,Mayurbhanj,Orissa',
'Hindala,Mayurbhanj,Orissa',
'Indupur,Mayurbhanj,Orissa',
'Jamukeswar,Mayurbhanj,Orissa',
'Jamunti,Mayurbhanj,Orissa',
'Jamuti,Mayurbhanj,Orissa',
'Jarak,Mayurbhanj,Orissa',
'Jashipur,Mayurbhanj,Orissa',
'Jhadghosada,Mayurbhanj,Orissa',
'Jharbeda,Mayurbhanj,Orissa',
'Karanjia Bazar,Mayurbhanj,Orissa',
'Karanjia Court,Mayurbhanj,Orissa',
'Karanjia Golei,Mayurbhanj,Orissa',
'Karanjia,Mayurbhanj,Orissa',
'Kendujiani,Mayurbhanj,Orissa',
'Kendumundi,Mayurbhanj,Orissa',
'Kerkera,Mayurbhanj,Orissa',
'Keshdiha,Mayurbhanj,Orissa',
'Khairi Jashipur,Mayurbhanj,Orissa',
'Khandabandh,Mayurbhanj,Orissa',
'Khiching,Mayurbhanj,Orissa',
'Khuntapada,Mayurbhanj,Orissa',
'Kuliposi,Mayurbhanj,Orissa',
'Kumbhirda,Mayurbhanj,Orissa',
'Kushpada,Mayurbhanj,Orissa',
'M.Beuinria,Mayurbhanj,Orissa',
'Mahuldiha,Mayurbhanj,Orissa',
'Matiagarh,Mayurbhanj,Orissa',
'Mituani,Mayurbhanj,Orissa',
'Moto,Mayurbhanj,Orissa',
'Moudi,Mayurbhanj,Orissa',
'Naksara,Mayurbhanj,Orissa',
'Nedhuapal,Mayurbhanj,Orissa',
'Neuti,Mayurbhanj,Orissa',
'Nuabeda,Mayurbhanj,Orissa',
'Nuagaon,Mayurbhanj,Orissa',
'Padiabeda,Mayurbhanj,Orissa',
'Pandarsil,Mayurbhanj,Orissa',
'Pantho,Mayurbhanj,Orissa',
'Patarapada,Mayurbhanj,Orissa',
'Patbil,Mayurbhanj,Orissa',
'Podagarh,Mayurbhanj,Orissa',
'Raikala,Mayurbhanj,Orissa',
'Raruan,Mayurbhanj,Orissa',
'Rasamtala,Mayurbhanj,Orissa',
'Righa,Mayurbhanj,Orissa',
'Rugudi,Mayurbhanj,Orissa',
'Salarapada,Mayurbhanj,Orissa',
'Salchua,Mayurbhanj,Orissa',
'Saleibeda,Mayurbhanj,Orissa',
'San Deuli,Mayurbhanj,Orissa',
'Satkosia,Mayurbhanj,Orissa',
'Singada,Mayurbhanj,Orissa',
'Sirakuli,Mayurbhanj,Orissa',
'Sukruli,Mayurbhanj,Orissa',
'Talgaon,Mayurbhanj,Orissa',
'Talpada,Mayurbhanj,Orissa',
'Taramara,Mayurbhanj,Orissa',
'Tato,Mayurbhanj,Orissa',
'Thakurmunda,Mayurbhanj,Orissa',
'Tilakothi,Mayurbhanj,Orissa',
'Tongabilla,Mayurbhanj,Orissa',
'Bahanada,Mayurbhanj,Orissa',
'Basipitha,Mayurbhanj,Orissa',
'Baincha Nuagaon,Mayurbhanj,Orissa',
'Bhatchhatar,Mayurbhanj,Orissa',
'Chakulia,Mayurbhanj,Orissa',
'Debsole,Mayurbhanj,Orissa',
'Ghodabandha Khuntapal,Mayurbhanj,Orissa',
'Gobra,Mayurbhanj,Orissa',
'Manida,Mayurbhanj,Orissa',
'Tukpalasia,Mayurbhanj,Orissa',
'Bachhuripal,Mayurbhanj,Orissa',
'Barkand,Mayurbhanj,Orissa',
'Bhaduasole,Mayurbhanj,Orissa',
'Bhairangisole,Mayurbhanj,Orissa',
'Bhaliadiha,Mayurbhanj,Orissa',
'Bholaghati,Mayurbhanj,Orissa',
'Chandabilla,Mayurbhanj,Orissa',
'Chhatna,Mayurbhanj,Orissa',
'Dhansole,Mayurbhanj,Orissa',
'Gadigaon,Mayurbhanj,Orissa',
'Gholmuhan,Mayurbhanj,Orissa',
'Harekrushnapur,Mayurbhanj,Orissa',
'Idar,Mayurbhanj,Orissa',
'Jharia,Mayurbhanj,Orissa',
'Jhinkiria,Mayurbhanj,Orissa',
'Kamardiha,Mayurbhanj,Orissa',
'Kapoi,Mayurbhanj,Orissa',
'Khuntapal,Mayurbhanj,Orissa',
'Khuruntia,Mayurbhanj,Orissa',
'M. Kanpur,Mayurbhanj,Orissa',
'Mahulia,Mayurbhanj,Orissa',
'Maigaon,Mayurbhanj,Orissa',
'Makunda,Mayurbhanj,Orissa',
'Musagadia,Mayurbhanj,Orissa',
'N. Chhotraipur,Mayurbhanj,Orissa',
'Nichuapada,Mayurbhanj,Orissa',
'Paramananda,Mayurbhanj,Orissa',
'Patagadia,Mayurbhanj,Orissa',
'Patpur,Mayurbhanj,Orissa',
'Rakhinisahi,Mayurbhanj,Orissa',
'Rangiam,Mayurbhanj,Orissa',
'Rukuni,Mayurbhanj,Orissa',
'Sunahaja,Mayurbhanj,Orissa',
'Aharbandh,Mayurbhanj,Orissa',
'Ambadiha,Mayurbhanj,Orissa',
'Anladuva,Mayurbhanj,Orissa',
'Anlajo R.S.,Mayurbhanj,Orissa',
'Asana,Mayurbhanj,Orissa',
'Asana,Mayurbhanj,Orissa',
'Badampahar,Mayurbhanj,Orissa',
'Badamtalia,Mayurbhanj,Orissa',
'Badgaon,Mayurbhanj,Orissa',
'Badkedam,Mayurbhanj,Orissa',
'Badkuleibira,Mayurbhanj,Orissa',
'Badmouda,Mayurbhanj,Orissa',
'Badnalua,Mayurbhanj,Orissa',
'Badra,Mayurbhanj,Orissa',
'Banakati,Mayurbhanj,Orissa',
'Baneikala,Mayurbhanj,Orissa',
'Basilapir,Mayurbhanj,Orissa',
'Basingi,Mayurbhanj,Orissa',
'Bautibeda,Mayurbhanj,Orissa',
'Bhalubasa,Mayurbhanj,Orissa',
'Bhimkhanda,Mayurbhanj,Orissa',
'Bhitaramda,Mayurbhanj,Orissa',
'Bijatala,Mayurbhanj,Orissa',
'Binjhua,Mayurbhanj,Orissa',
'Bisoi,Mayurbhanj,Orissa',
'Chuapani,Mayurbhanj,Orissa',
'Damudigoda,Mayurbhanj,Orissa',
'Dolsara,Mayurbhanj,Orissa',
'Dova,Mayurbhanj,Orissa',
'Dundu,Mayurbhanj,Orissa',
'Gambharia,Mayurbhanj,Orissa',
'Gorumahisani,Mayurbhanj,Orissa',
'Guhaldangri,Mayurbhanj,Orissa',
'Halda,Mayurbhanj,Orissa',
'Hatbadra,Mayurbhanj,Orissa',
'Hatia,Mayurbhanj,Orissa',
'Hesda,Mayurbhanj,Orissa',
'Indukhali,Mayurbhanj,Orissa',
'Jamda,Mayurbhanj,Orissa',
'Jarkani,Mayurbhanj,Orissa',
'Jhipabandh,Mayurbhanj,Orissa',
'Jorda,Mayurbhanj,Orissa',
'Kaduani,Mayurbhanj,Orissa',
'Kathbharia,Mayurbhanj,Orissa',
'Khadambeda,Mayurbhanj,Orissa',
'Khairpal,Mayurbhanj,Orissa',
'Kukudimundi,Mayurbhanj,Orissa',
'Kulgi,Mayurbhanj,Orissa',
'Kumudasole,Mayurbhanj,Orissa',
'Kundulia,Mayurbhanj,Orissa',
'Kusumi,Mayurbhanj,Orissa',
'Luhakani,Mayurbhanj,Orissa',
'Luhasila,Mayurbhanj,Orissa',
'Mahadevdihi,Mayurbhanj,Orissa',
'Mahuldiha,Mayurbhanj,Orissa',
'Majhigaon,Mayurbhanj,Orissa',
'Manada,Mayurbhanj,Orissa',
'Manikpur,Mayurbhanj,Orissa',
'Moronda,Mayurbhanj,Orissa',
'N.B.Pokharia,Mayurbhanj,Orissa',
'Nuagaon-kurkutia,Mayurbhanj,Orissa',
'Padhia,Mayurbhanj,Orissa',
'Pasana,Mayurbhanj,Orissa',
'Pratapgarh,Mayurbhanj,Orissa',
'Purunaghati,Mayurbhanj,Orissa',
'Purunapani,Mayurbhanj,Orissa',
'Purunapani,Mayurbhanj,Orissa',
'Raihari,Mayurbhanj,Orissa',
'Rairangpur Bazar,Mayurbhanj,Orissa',
'Rairangpur H.O,Mayurbhanj,Orissa',
'Rairangpur R.S,Mayurbhanj,Orissa',
'Sanjambilla,Mayurbhanj,Orissa',
'Sanpakhana,Mayurbhanj,Orissa',
'Sanpurunapani,Mayurbhanj,Orissa',
'Sargoda,Mayurbhanj,Orissa',
'Sargoda Jashipur,Mayurbhanj,Orissa',
'Shyamsundar,Mayurbhanj,Orissa',
'Soroda Jashipur,Mayurbhanj,Orissa',
'Soso,Mayurbhanj,Orissa',
'Sudarsanpur,Mayurbhanj,Orissa',
'Suleipat,Mayurbhanj,Orissa',
'Sunajodia,Mayurbhanj,Orissa',
'Sundhal,Mayurbhanj,Orissa',
'Talakpokhari,Mayurbhanj,Orissa',
'Talgaon,Mayurbhanj,Orissa',
'Tamalbandh,Mayurbhanj,Orissa',
'Tarana,Mayurbhanj,Orissa',
'Tarana,Mayurbhanj,Orissa',
'Tendra,Mayurbhanj,Orissa',
'Tikhia,Mayurbhanj,Orissa',
'Ukam,Mayurbhanj,Orissa',
'Uparbeda,Mayurbhanj,Orissa',
'Amarda,Mayurbhanj,Orissa',
'Anua,Mayurbhanj,Orissa',
'Brahmapura,Mayurbhanj,Orissa',
'Chitrada,Mayurbhanj,Orissa',
'Haripur,Mayurbhanj,Orissa',
'Mangalpur,Mayurbhanj,Orissa',
'Moroda,Mayurbhanj,Orissa',
'Nalagaja,Mayurbhanj,Orissa',
'Panisapada,Mayurbhanj,Orissa',
'Purnachandrapur,Mayurbhanj,Orissa',
'Rasgovindpur,Mayurbhanj,Orissa',
'Sarisa,Mayurbhanj,Orissa',
'Badampur,Mayurbhanj,Orissa',
'Baladia,Mayurbhanj,Orissa',
'Ambadiha,Mayurbhanj,Orissa',
'Ambikadeipur,Mayurbhanj,Orissa',
'Atanati,Mayurbhanj,Orissa',
'Athapara,Mayurbhanj,Orissa',
'Badgudugudia,Mayurbhanj,Orissa',
'Badkaranjia,Mayurbhanj,Orissa',
'Badkhaladi,Mayurbhanj,Orissa',
'Badkhaman,Mayurbhanj,Orissa',
'Badmamundia,Mayurbhanj,Orissa',
'Badsimulia,Mayurbhanj,Orissa',
'Badsingaria,Mayurbhanj,Orissa',
'Bahubandh,Mayurbhanj,Orissa',
'Bairatpur,Mayurbhanj,Orissa',
'Baldiha Khunta,Mayurbhanj,Orissa',
'Balichhatra,Mayurbhanj,Orissa',
'Banakati,Mayurbhanj,Orissa',
'Baradihi,Mayurbhanj,Orissa',
'Bhandagaon,Mayurbhanj,Orissa',
'Bhimtali,Mayurbhanj,Orissa',
'Bholagadia,Mayurbhanj,Orissa',
'Brundaban Chandrapur,Mayurbhanj,Orissa',
'Chadada,Mayurbhanj,Orissa',
'Chakradharpur,Mayurbhanj,Orissa',
'Chandrapur,Mayurbhanj,Orissa',
'Chaturi,Mayurbhanj,Orissa',
'Chuinposi,Mayurbhanj,Orissa',
'Debgaon,Mayurbhanj,Orissa',
'Dengam,Mayurbhanj,Orissa',
'Dewan Bahali,Mayurbhanj,Orissa',
'Dhanghera,Mayurbhanj,Orissa',
'Dihirakul,Mayurbhanj,Orissa',
'Dimagadia,Mayurbhanj,Orissa',
'Dughdha,Mayurbhanj,Orissa',
'Gadigaon,Mayurbhanj,Orissa',
'Gayalmara,Mayurbhanj,Orissa',
'Golagadia,Mayurbhanj,Orissa',
'Goudagaon,Mayurbhanj,Orissa',
'Gour Chandra Pur,Mayurbhanj,Orissa',
'Hatisahi,Mayurbhanj,Orissa',
'Hill Block - 24,Mayurbhanj,Orissa',
'Hirapur,Mayurbhanj,Orissa',
'Jaida,Mayurbhanj,Orissa',
'Jaida,Mayurbhanj,Orissa',
'Jaipur,Mayurbhanj,Orissa',
'Jambani,Mayurbhanj,Orissa',
'Jualia,Mayurbhanj,Orissa',
'Kainsari,Mayurbhanj,Orissa',
'Kaladahi,Mayurbhanj,Orissa',
'Kalamgodia,Mayurbhanj,Orissa',
'Kaptipada,Mayurbhanj,Orissa',
'Karkachia,Mayurbhanj,Orissa',
'Katuria,Mayurbhanj,Orissa',
'Khaladi,Mayurbhanj,Orissa',
'Khunta,Mayurbhanj,Orissa',
'Kolialam,Mayurbhanj,Orissa',
'Kuamara,Mayurbhanj,Orissa',
'Kundabai,Mayurbhanj,Orissa',
'Kushalda,Mayurbhanj,Orissa',
'Kutling,Mayurbhanj,Orissa',
'Labanyadeipur,Mayurbhanj,Orissa',
'Mahulpankha,Mayurbhanj,Orissa',
'Majhigadia,Mayurbhanj,Orissa',
'Manikpur,Mayurbhanj,Orissa',
'Mankadapada,Mayurbhanj,Orissa',
'Mirigothana,Mayurbhanj,Orissa',
'Nayarangamatia,Mayurbhanj,Orissa',
'Nedam,Mayurbhanj,Orissa',
'Nuagaon,Mayurbhanj,Orissa',
'Nudadiha,Mayurbhanj,Orissa',
'Padmapokhari,Mayurbhanj,Orissa',
'Parasbani,Mayurbhanj,Orissa',
'Pasuda,Mayurbhanj,Orissa',
'Pathurikata,Mayurbhanj,Orissa',
'Patpur,Mayurbhanj,Orissa',
'Patsanipur,Mayurbhanj,Orissa',
'Peragari,Mayurbhanj,Orissa',
'Podadiha,Mayurbhanj,Orissa',
'Potaldiha,Mayurbhanj,Orissa',
'Puruna Baripada,Mayurbhanj,Orissa',
'Radho,Mayurbhanj,Orissa',
'Raipal,Mayurbhanj,Orissa',
'Rajat Nagar,Mayurbhanj,Orissa',
'Sainkula,Mayurbhanj,Orissa',
'Salchua,Mayurbhanj,Orissa',
'Salmundali,Mayurbhanj,Orissa',
'Sanbelakuti,Mayurbhanj,Orissa',
'Sanbisole,Mayurbhanj,Orissa',
'Saradiha,Mayurbhanj,Orissa',
'Sarat,Mayurbhanj,Orissa',
'Sarbanghati,Mayurbhanj,Orissa',
'Sikidia,Mayurbhanj,Orissa',
'Silaghati,Mayurbhanj,Orissa',
'Sirathali,Mayurbhanj,Orissa',
'Sridamchandrapur,Mayurbhanj,Orissa',
'Srinathpur,Mayurbhanj,Orissa',
'Sundhal,Mayurbhanj,Orissa',
'Talakadada,Mayurbhanj,Orissa',
'Taradasole,Mayurbhanj,Orissa',
'Teldihudi,Mayurbhanj,Orissa',
'Tikarpada,Mayurbhanj,Orissa',
'Udala Bazar,Mayurbhanj,Orissa',
'Udala College,Mayurbhanj,Orissa',
'Udala,Mayurbhanj,Orissa',
'B.M.Semla,Koraput,Orissa',
'Attigaon,Koraput,Orissa',
'B.Gumuda,Koraput,Orissa',
'Badambeda,Koraput,Orissa',
'Badaolama,Koraput,Orissa',
'Bajraguda,Koraput,Orissa',
'Basini,Koraput,Orissa',
'Belanga,Koraput,Orissa',
'Betal,Koraput,Orissa',
'Bhamini,Koraput,Orissa',
'Chhatahandi,Koraput,Orissa',
'Dongra,Koraput,Orissa',
'Ekori,Koraput,Orissa',
'Gadadhanua,Koraput,Orissa',
'Jhadakusumi,Koraput,Orissa',
'Kodinga,Koraput,Orissa',
'Kondapuri,Koraput,Orissa',
'Kosagumuda,Koraput,Orissa',
'Kotagaon,Koraput,Orissa',
'Kukudisemla,Koraput,Orissa',
'Kutubai,Koraput,Orissa',
'Majhidhanua,Koraput,Orissa',
'Motigaon,Koraput,Orissa',
'Panduguda,Koraput,Orissa',
'Papadahandi,Koraput,Orissa',
'Rajoda,Koraput,Orissa',
'Sanameda,Koraput,Orissa',
'Temera,Koraput,Orissa',
'Badakumuli,Koraput,Orissa',
'Baghsiuni,Koraput,Orissa',
'Dengapadar,Koraput,Orissa',
'Hirli,Koraput,Orissa',
'Mentri,Koraput,Orissa',
'Agnipur,Koraput,Orissa',
'Ambadola,Koraput,Orissa',
'Amlabhata,Koraput,Orissa',
'Anchalgumma,Koraput,Orissa',
'Aunli,Koraput,Orissa',
'Bangalaguda,Koraput,Orissa',
'Bharanpur,Koraput,Orissa',
'Bhatasiuni,Koraput,Orissa',
'Bhatigam,Koraput,Orissa',
'Bhejaguda,Koraput,Orissa',
'Bikrampur,Koraput,Orissa',
'Biriguda,Koraput,Orissa',
'Charmula,Koraput,Orissa',
'Cherchata,Koraput,Orissa',
'Dengaguda,Koraput,Orissa',
'Dhadra,Koraput,Orissa',
'Digisalpa,Koraput,Orissa',
'Dohona,Koraput,Orissa',
'Dongerbheja,Koraput,Orissa',
'J.B.Guda,Koraput,Orissa',
'Jambaguda,Koraput,Orissa',
'Jatabal,Koraput,Orissa',
'Jhariguma,Koraput,Orissa',
'Jujhari,Koraput,Orissa',
'Kamta,Koraput,Orissa',
'Kangra,Koraput,Orissa',
'Khatiguda,Koraput,Orissa',
'Khuntipadar,Koraput,Orissa',
'Kontagam,Koraput,Orissa',
'Kukudabai,Koraput,Orissa',
'Kurlughati,Koraput,Orissa',
'Maidalpur,Koraput,Orissa',
'Majhiguda,Koraput,Orissa',
'Majhiguda,Koraput,Orissa',
'Maliguda,Koraput,Orissa',
'Manchagaon,Koraput,Orissa',
'Mantriguda,Koraput,Orissa',
'Mokiya,Koraput,Orissa',
'Nabarangpur Bazar,Koraput,Orissa',
'Nabarangpur,Koraput,Orissa',
'Naktiguda,Koraput,Orissa',
'Nandahandi,Koraput,Orissa',
'Nuakote,Koraput,Orissa',
'Parajadeopalli,Koraput,Orissa',
'Patraput,Koraput,Orissa',
'Patri,Koraput,Orissa',
'Pendikote,Koraput,Orissa',
'Porsola,Koraput,Orissa',
'Pujariguda,Koraput,Orissa',
'Pujariguda,Koraput,Orissa',
'R.Jaganathpur,Koraput,Orissa',
'Rangamatiguda,Koraput,Orissa',
'Sanamasigaon,Koraput,Orissa',
'Semla,Koraput,Orissa',
'Sindhiguda,Koraput,Orissa',
'Sirisi,Koraput,Orissa',
'Taragaon,Koraput,Orissa',
'Tentulikhunti,Koraput,Orissa',
'Tumberla,Koraput,Orissa',
'Ushigaon,Koraput,Orissa',
'Mirganiguda,Koraput,Orissa',
'Sindhigaon,Koraput,Orissa',
'Adhikariguda,Koraput,Orissa',
'Anakabeda,Koraput,Orissa',
'B.S.Padar,Koraput,Orissa',
'Badabasini,Koraput,Orissa',
'Badabharandi,Koraput,Orissa',
'Badakumari,Koraput,Orissa',
'Badatemra,Koraput,Orissa',
'Baigam,Koraput,Orissa',
'Banuaguda,Koraput,Orissa',
'Beheda,Koraput,Orissa',
'Beheramunda,Koraput,Orissa',
'Belagaon,Koraput,Orissa',
'Benara,Koraput,Orissa',
'Bhamini,Koraput,Orissa',
'Bharsundi,Koraput,Orissa',
'Bhikhya,Koraput,Orissa',
'Bokadabeda,Koraput,Orissa',
'Bokoda,Koraput,Orissa',
'Borigaon,Koraput,Orissa',
'Bubei,Koraput,Orissa',
'Burja,Koraput,Orissa',
'Chandahandi,Koraput,Orissa',
'Chatiguda,Koraput,Orissa',
'Checherguda,Koraput,Orissa',
'Chikalpadar,Koraput,Orissa',
'Chitabeda,Koraput,Orissa',
'Chocha,Koraput,Orissa',
'Dabugam,Koraput,Orissa',
'Dalbeda,Koraput,Orissa',
'Damaniguda,Koraput,Orissa',
'Dandamunda,Koraput,Orissa',
'Debagaon,Koraput,Orissa',
'Deobharandi,Koraput,Orissa',
'Dhodra,Koraput,Orissa',
'Dongriguda,Koraput,Orissa',
'Ekamba,Koraput,Orissa',
'Gambhariguda,Koraput,Orissa',
'Ganjapara,Koraput,Orissa',
'Ghodakhuntia,Koraput,Orissa',
'Gona,Koraput,Orissa',
'Hatabharandi,Koraput,Orissa',
'Hirapur,Koraput,Orissa',
'Jabaguda,Koraput,Orissa',
'Jadapara,Koraput,Orissa',
'Jamadapada,Koraput,Orissa',
'Jamranda,Koraput,Orissa',
'Jharigam,Koraput,Orissa',
'Jodinga,Koraput,Orissa',
'Junapani,Koraput,Orissa',
'Kaudala,Koraput,Orissa',
'Khanda,Koraput,Orissa',
'Khuduku,Koraput,Orissa',
'Kolimunda,Koraput,Orissa',
'Koragam,Koraput,Orissa',
'Kumuli,Koraput,Orissa',
'Kundei,Koraput,Orissa',
'Kurbeda,Koraput,Orissa',
'Manigam,Koraput,Orissa',
'Medana,Koraput,Orissa',
'Melgam,Koraput,Orissa',
'Mohanda,Koraput,Orissa',
'Mohara,Koraput,Orissa',
'Mohendri,Koraput,Orissa',
'Murtuma,Koraput,Orissa',
'Naktisimla,Koraput,Orissa',
'Palia,Koraput,Orissa',
'Palsapara,Koraput,Orissa',
'Pandripakna,Koraput,Orissa',
'Parchipara,Koraput,Orissa',
'Patiki,Koraput,Orissa',
'Patkhalia,Koraput,Orissa',
'Phupugam,Koraput,Orissa',
'Raighar,Koraput,Orissa',
'Rajkote,Koraput,Orissa',
'Saradhapur,Koraput,Orissa',
'Sarguli,Koraput,Orissa',
'Singisari,Koraput,Orissa',
'Sirliguda,Koraput,Orissa',
'Sonepur,Koraput,Orissa',
'Sunabeda,Koraput,Orissa',
'Turudi,Koraput,Orissa',
'Umerkote Bazar,Koraput,Orissa',
'Umerkote,Koraput,Orissa',
'Badasahara,Puri,Orissa',
'Baunsabati,Puri,Orissa',
'Bhapur,Puri,Orissa',
'Bijipur,Puri,Orissa',
'Chakradharprasad,Puri,Orissa',
'Fategarh,Puri,Orissa',
'Gobardhan Prasad,Puri,Orissa',
'Golapokhari,Puri,Orissa',
'Kainfulia,Puri,Orissa',
'Karabar,Puri,Orissa',
'Nilakantheswarpur,Puri,Orissa',
'Nimani,Puri,Orissa',
'Padmabati,Puri,Orissa',
'Rakama,Puri,Orissa',
'Salapada,Puri,Orissa',
'Tarabalo,Puri,Orissa',
'Tikiripada,Puri,Orissa',
'Daspalla,Puri,Orissa',
'Gania,Puri,Orissa',
'Adakata,Puri,Orissa',
'Badagotha,Puri,Orissa',
'Chahali,Puri,Orissa',
'Dandor,Puri,Orissa',
'Dihagaon,Puri,Orissa',
'Giridipalli,Puri,Orissa',
'Gobindapurpanta,Puri,Orissa',
'Jagannathprasad,Puri,Orissa',
'Kalapangi,Puri,Orissa',
'Komand,Puri,Orissa',
'Koska,Puri,Orissa',
'Kumbharapada,Puri,Orissa',
'Madanpur,Puri,Orissa',
'Malisar,Puri,Orissa',
'Nuapada,Puri,Orissa',
'Rohibanka,Puri,Orissa',
'Similisahi,Puri,Orissa',
'Singhapada,Puri,Orissa',
'Sunamuhin,Puri,Orissa',
'Badabanpur,Puri,Orissa',
'Baigania,Puri,Orissa',
'Baladianuagaon,Puri,Orissa',
'Banmalipurpatna,Puri,Orissa',
'Barabati,Puri,Orissa',
'Benagadia,Puri,Orissa',
'Bhagabanpur,Puri,Orissa',
'Bodas,Puri,Orissa',
'Dhanchangada,Puri,Orissa',
'Gohiripada,Puri,Orissa',
'Jadunathpur,Puri,Orissa',
'Jagannathprasad,Puri,Orissa',
'K .Sikharpur,Puri,Orissa',
'Kantilo,Puri,Orissa',
'Khalisahi,Puri,Orissa',
'Khandapadagarh,Puri,Orissa',
'Kiajhar,Puri,Orissa',
'Madhapur,Puri,Orissa',
'Purusottamprasad,Puri,Orissa',
'Salajharia,Puri,Orissa',
'Sidhamula,Puri,Orissa',
'Durdura,Puri,Orissa',
'Badpandusar,Puri,Orissa',
'Bahadajhola,Puri,Orissa',
'Banigochha,Puri,Orissa',
'Banthapur,Puri,Orissa',
'Barasahi,Puri,Orissa',
'Baunsagadia,Puri,Orissa',
'Baunsiapada,Puri,Orissa',
'Beruanbadi,Puri,Orissa',
'Bhatasahi,Puri,Orissa',
'Bhogabadi,Puri,Orissa',
'Binayakpur,Puri,Orissa',
'Biruda,Puri,Orissa',
'Chadeyapalli,Puri,Orissa',
'Champatipur,Puri,Orissa',
'Dimiripali,Puri,Orissa',
'Duda,Puri,Orissa',
'Ekiri,Puri,Orissa',
'Gadadharprasad,Puri,Orissa',
'Gambharidihi,Puri,Orissa',
'Gaudaput,Puri,Orissa',
'Golagola,Puri,Orissa',
'Gotisahi,Puri,Orissa',
'Gumi,Puri,Orissa',
'Gunthuni,Puri,Orissa',
'Harakrushnapur,Puri,Orissa',
'Hariharpur,Puri,Orissa',
'Itamati,Puri,Orissa',
'Jakeda,Puri,Orissa',
'Jamusahi,Puri,Orissa',
'Kaibalyapur,Puri,Orissa',
'Kajaliapalli,Puri,Orissa',
'Kalikaprasad,Puri,Orissa',
'Kalyanpur,Puri,Orissa',
'Kankanamendhi,Puri,Orissa',
'Kaptapalli,Puri,Orissa',
'Kendudhipi,Puri,Orissa',
'Kesharpur,Puri,Orissa',
'Khalamada,Puri,Orissa',
'Khamarasahi,Puri,Orissa',
'Korada,Puri,Orissa',
'Korapitha,Puri,Orissa',
'Kridaspur,Puri,Orissa',
'Kujamendhi,Puri,Orissa',
'Kulurukumpa,Puri,Orissa',
'Kural,Puri,Orissa',
'Kurumabankatara,Puri,Orissa',
'Lenkudipada,Puri,Orissa',
'Madhyakhand,Puri,Orissa',
'Mahipur,Puri,Orissa',
'Malisahi,Puri,Orissa',
'Mandhatapur,Puri,Orissa',
'Nandighore,Puri,Orissa',
'Nayagarh Bazar,Puri,Orissa',
'Nayagarh College,Puri,Orissa',
'Nayagarh H.O,Puri,Orissa',
'Nuagaon,Puri,Orissa',
'Pancharida,Puri,Orissa',
'Poda Sahi,Puri,Orissa',
'Poibadi,Puri,Orissa',
'Pokharigochha,Puri,Orissa',
'Rabera,Puri,Orissa',
'Ranganipatna,Puri,Orissa',
'Sakeri,Puri,Orissa',
'Sampada,Puri,Orissa',
'Saradhapur,Puri,Orissa',
'Satpatna,Puri,Orissa',
'Sikharpur,Puri,Orissa',
'Sikrida,Puri,Orissa',
'Similisahi,Puri,Orissa',
'Sinduria,Puri,Orissa',
'Singarpalli,Puri,Orissa',
'Subalaya,Puri,Orissa',
'Tendabadi,Puri,Orissa',
'Udayapur,Puri,Orissa',
'Gambharidihi,Puri,Orissa',
'Machhipada,Puri,Orissa',
'Nabaghanapur,Puri,Orissa',
'Nuagaon,Puri,Orissa',
'Odagaon,Puri,Orissa',
'Padmadeipur,Puri,Orissa',
'Sarankul,Puri,Orissa',
'Godipada,Puri,Orissa',
'B M S Nivas,Puri,Orissa',
'Badabaramul,Puri,Orissa',
'Badakumari,Puri,Orissa',
'Badasilinga,Puri,Orissa',
'Balabhadrapur,Puri,Orissa',
'Balaramaprasad,Puri,Orissa',
'Balugaon,Puri,Orissa',
'Bandhamunda,Puri,Orissa',
'Barapalli,Puri,Orissa',
'Basudia,Puri,Orissa',
'Baulasahi,Puri,Orissa',
'Baunsagada,Puri,Orissa',
'Belapadapatna,Puri,Orissa',
'Bhaliadihi,Puri,Orissa',
'Brajarajpur,Puri,Orissa',
'Champagarh,Puri,Orissa',
'Chandapur,Puri,Orissa',
'Chhamundia,Puri,Orissa',
'Damasahi,Puri,Orissa',
'Darpanarayanpur,Puri,Orissa',
'Dimisar,Puri,Orissa',
'Garhbanikilo,Puri,Orissa',
'Ghugudipada,Puri,Orissa',
'Gopalpur,Puri,Orissa',
'Gourangapur,Puri,Orissa',
'Jamusahi,Puri,Orissa',
'Jasodapur,Puri,Orissa',
'Jharapada,Puri,Orissa',
'Kandhanayagarh,Puri,Orissa',
'Kansada,Puri,Orissa',
'Karadapada,Puri,Orissa',
'Kerandatangi,Puri,Orissa',
'Khairapalli,Puri,Orissa',
'Khatia,Puri,Orissa',
'Khuntabandha,Puri,Orissa',
'Kishoreprasad,Puri,Orissa',
'Kulasar,Puri,Orissa',
'Lathipara,Puri,Orissa',
'Lodhachua,Puri,Orissa',
'Mahatapalla,Puri,Orissa',
'Mayurjhalia,Puri,Orissa',
'Nakithana,Puri,Orissa',
'Narasinghpur,Puri,Orissa',
'Narendrapur,Puri,Orissa',
'Natimi,Puri,Orissa',
'Neliguda,Puri,Orissa',
'Notar,Puri,Orissa',
'Patanda,Puri,Orissa',
'Pimpal,Puri,Orissa',
'Raitadholamara,Puri,Orissa',
'Rajingi,Puri,Orissa',
'Rajranpur,Puri,Orissa',
'Rajsunakhala,Puri,Orissa',
'Rasanga,Puri,Orissa',
'Sarangadharpur,Puri,Orissa',
'Sinduria,Puri,Orissa',
'Srirampur,Puri,Orissa',
'Surukabadi,Puri,Orissa',
'Takera,Puri,Orissa',
'Taria,Puri,Orissa',
'Tumandi,Puri,Orissa',
'Khaira,Kalahandi,Orissa',
'Amguda,Kalahandi,Orissa',
'Bhainsadani,Kalahandi,Orissa',
'Boirgaon,Kalahandi,Orissa',
'Damjhar,Kalahandi,Orissa',
'Jayabahal,Kalahandi,Orissa',
'Karlakot,Kalahandi,Orissa',
'Kirejhola,Kalahandi,Orissa',
'Litisargi,Kalahandi,Orissa',
'Nagpada,Kalahandi,Orissa',
'Pharsara,Kalahandi,Orissa',
'Sunapur,Kalahandi,Orissa',
'Babebir,Kalahandi,Orissa',
'Karangamal,Kalahandi,Orissa',
'Kendupati,Kalahandi,Orissa',
'Badi,Kalahandi,Orissa',
'Badmaheswar,Kalahandi,Orissa',
'Bargaon,Kalahandi,Orissa',
'Bhuliasikun,Kalahandi,Orissa',
'Birighat,Kalahandi,Orissa',
'Boden,Kalahandi,Orissa',
'Chindaguda,Kalahandi,Orissa',
'Goimundi,Kalahandi,Orissa',
'Khariar,Kalahandi,Orissa',
'Khasbahal,Kalahandi,Orissa',
'Kirkita,Kalahandi,Orissa',
'Lanji,Kalahandi,Orissa',
'Larka,Kalahandi,Orissa',
'Palsada,Kalahandi,Orissa',
'Ranimunda,Kalahandi,Orissa',
'Sargadi,Kalahandi,Orissa',
'Tukla,Kalahandi,Orissa',
'Bhanpur,Kalahandi,Orissa',
'Gotma,Kalahandi,Orissa',
'Mangarapalli,Kalahandi,Orissa',
'Saradhapur,Kalahandi,Orissa',
'Agren,Kalahandi,Orissa',
'Bhella,Kalahandi,Orissa',
'Budhikomna,Kalahandi,Orissa',
'Jhagrahi,Kalahandi,Orissa',
'Kendetara,Kalahandi,Orissa',
'Konabira,Kalahandi,Orissa',
'Kureswar,Kalahandi,Orissa',
'Michhapali,Kalahandi,Orissa',
'Nuagaon,Kalahandi,Orissa',
'Pendraban,Kalahandi,Orissa',
'Rajna,Kalahandi,Orissa',
'Sunabeda,Kalahandi,Orissa',
'Tikrapara,Kalahandi,Orissa',
'Amnara,Kalahandi,Orissa',
'Amsena,Kalahandi,Orissa',
'Beltukri,Kalahandi,Orissa',
'Bhaleswer,Kalahandi,Orissa',
'Biromal,Kalahandi,Orissa',
'Bisora,Kalahandi,Orissa',
'Darlimunda,Kalahandi,Orissa',
'Dharambandha,Kalahandi,Orissa',
'Dumerpani,Kalahandi,Orissa',
'Gandamer,Kalahandi,Orissa',
'Godfurla,Kalahandi,Orissa',
'Jampani,Kalahandi,Orissa',
'Jatgarh,Kalahandi,Orissa',
'Jenjera,Kalahandi,Orissa',
'Kendubahara,Kalahandi,Orissa',
'Khariar Road,Kalahandi,Orissa',
'Kodomeri,Kalahandi,Orissa',
'Komna,Kalahandi,Orissa',
'Kuliabandh,Kalahandi,Orissa',
'Kurumpuri,Kalahandi,Orissa',
'Kutenchuan,Kalahandi,Orissa',
'Lakhana,Kalahandi,Orissa',
'Mahulibhata,Kalahandi,Orissa',
'Maraguda,Kalahandi,Orissa',
'Motanuapada,Kalahandi,Orissa',
'Nawapara Tanwat,Kalahandi,Orissa',
'Panchampur,Kalahandi,Orissa',
'Paraskhol,Kalahandi,Orissa',
'Parkod,Kalahandi,Orissa',
'Sahajat,Kalahandi,Orissa',
'Saipala,Kalahandi,Orissa',
'Sarbang,Kalahandi,Orissa',
'Sialati,Kalahandi,Orissa',
'Silva,Kalahandi,Orissa',
'Tanwat,Kalahandi,Orissa',
'Darlipara,Kalahandi,Orissa',
'Tarbod,Kalahandi,Orissa',
'Nuapada,Kalahandi,Orissa',
'Ranimunda,Kalahandi,Orissa',
'Chalana,Kalahandi,Orissa',
'Chatiaguda,Kalahandi,Orissa',
'Gochhaguda,Kalahandi,Orissa',
'Bargaon,Kalahandi,Orissa',
'Bharuamunda,Kalahandi,Orissa',
'Duajhar,Kalahandi,Orissa',
'Godal,Kalahandi,Orissa',
'Gorla,Kalahandi,Orissa',
'Hatibandha,Kalahandi,Orissa',
'Jharbandh,Kalahandi,Orissa',
'Karanbahali,Kalahandi,Orissa',
'Kendumunda,Kalahandi,Orissa',
'Kusumjore,Kalahandi,Orissa',
'Makhapadar,Kalahandi,Orissa',
'Nangalbod,Kalahandi,Orissa',
'Nilji,Kalahandi,Orissa',
'Singjhar,Kalahandi,Orissa',
'Sinhapalli,Kalahandi,Orissa',
'Timanpur,Kalahandi,Orissa',
'Ambapada,Puri,Orissa',
'Arakhakuda,Puri,Orissa',
'Bentapur,Puri,Orissa',
'Berhampur,Puri,Orissa',
'Bhagabanpur,Puri,Orissa',
'Bhandarikuda,Puri,Orissa',
'Bhubanapur,Puri,Orissa',
'Brahmagiri,Puri,Orissa',
'Brahmania,Puri,Orissa',
'Chapamanika,Puri,Orissa',
'Chhatabar,Puri,Orissa',
'Dimirisena,Puri,Orissa',
'Garhkokala,Puri,Orissa',
'Garhrodanga,Puri,Orissa',
'Gopinathpur,Puri,Orissa',
'Kandagoda,Puri,Orissa',
'Khajuria,Puri,Orissa',
'Kusubenti,Puri,Orissa',
'Manapada,Puri,Orissa',
'Nuagaonbadabhuin,Puri,Orissa',
'Palank,Puri,Orissa',
'Palli,Puri,Orissa',
'Panaspada,Puri,Orissa',
'Rebena Nuagaon,Puri,Orissa',
'Satapada,Puri,Orissa',
'Alasahi,Bhubaneswar,Orissa',
'Astaranga,Bhubaneswar,Orissa',
'Balidokan,Bhubaneswar,Orissa',
'Bangurigaon,Bhubaneswar,Orissa',
'Baulanga,Bhubaneswar,Orissa',
'Bhandisahi,Bhubaneswar,Orissa',
'Chitreswari,Bhubaneswar,Orissa',
'Derunia,Bhubaneswar,Orissa',
'Desthali,Bhubaneswar,Orissa',
'Dhanitri,Bhubaneswar,Orissa',
'Gambharipada,Bhubaneswar,Orissa',
'Jaleswarpada,Bhubaneswar,Orissa',
'Jharling,Bhubaneswar,Orissa',
'Junei,Bhubaneswar,Orissa',
'Kahal,Bhubaneswar,Orissa',
'Karamanga,Bhubaneswar,Orissa',
'Khalkatapatna,Bhubaneswar,Orissa',
'Khandasahi,Bhubaneswar,Orissa',
'Kotanga,Bhubaneswar,Orissa',
'Krushnanagarpatna,Bhubaneswar,Orissa',
'Kundheihat,Bhubaneswar,Orissa',
'Kurujanga,Bhubaneswar,Orissa',
'Kusumbar,Bhubaneswar,Orissa',
'Lataharan,Bhubaneswar,Orissa',
'Mahadevbasta,Bhubaneswar,Orissa',
'Mahalpada,Bhubaneswar,Orissa',
'Matiapada,Bhubaneswar,Orissa',
'Nagar,Bhubaneswar,Orissa',
'Namaro,Bhubaneswar,Orissa',
'Nayahat,Bhubaneswar,Orissa',
'Nuagarh,Bhubaneswar,Orissa',
'Othaka,Bhubaneswar,Orissa',
'Patalda,Bhubaneswar,Orissa',
'Patapur,Bhubaneswar,Orissa',
'Patasundarpur,Bhubaneswar,Orissa',
'Rasulpur,Bhubaneswar,Orissa',
'Risol,Bhubaneswar,Orissa',
'Sarada,Bhubaneswar,Orissa',
'Sisua,Bhubaneswar,Orissa',
'Sorava,Bhubaneswar,Orissa',
'Suhagpur,Bhubaneswar,Orissa',
'Udaypur,Bhubaneswar,Orissa',
'Kakatpur,Bhubaneswar,Orissa',
'Badjhada,Puri,Orissa',
'Malud,Puri,Orissa',
'Chilikanuapada,Puri,Orissa',
'Parikud Gdsso,Puri,Orissa',
'Ramlenka,Puri,Orissa',
'Sial,Puri,Orissa',
'Titip,Puri,Orissa',
'Bajrakote,Puri,Orissa',
'Palasahi,Bhubaneswar,Orissa',
'Chanrapada,Bhubaneswar,Orissa',
'Sahadapada,Bhubaneswar,Orissa',
'Tampalo,Bhubaneswar,Orissa',
'Alichar,Bhubaneswar,Orissa',
'Alipingal,Bhubaneswar,Orissa',
'Amareswar,Bhubaneswar,Orissa',
'Arisandha,Bhubaneswar,Orissa',
'Badalasasan,Bhubaneswar,Orissa',
'Badaninigaon,Bhubaneswar,Orissa',
'Baharana,Bhubaneswar,Orissa',
'Bakugram,Bhubaneswar,Orissa',
'Balanga,Bhubaneswar,Orissa',
'Bamanal,Bhubaneswar,Orissa',
'Bantugram,Bhubaneswar,Orissa',
'Bhanapur,Bhubaneswar,Orissa',
'Bharipur,Bhubaneswar,Orissa',
'Bhodar,Bhubaneswar,Orissa',
'Bhogasalada,Bhubaneswar,Orissa',
'Bhubanipur,Bhubaneswar,Orissa',
'Birtung,Bhubaneswar,Orissa',
'Bishnupur,Bhubaneswar,Orissa',
'Biswalpada,Bhubaneswar,Orissa',
'Brahmakundi,Bhubaneswar,Orissa',
'Chhannijanga,Bhubaneswar,Orissa',
'Dakhinradas,Bhubaneswar,Orissa',
'Dandipur,Bhubaneswar,Orissa',
'Dhaleswar,Bhubaneswar,Orissa',
'Dighalo,Bhubaneswar,Orissa',
'Dipideuli,Bhubaneswar,Orissa',
'Dolabedi Chhaka,Bhubaneswar,Orissa',
'Dovar,Bhubaneswar,Orissa',
'Erbang,Bhubaneswar,Orissa',
'Ganeswarpur,Bhubaneswar,Orissa',
'Garharmala,Bhubaneswar,Orissa',
'Garhchandrapur,Bhubaneswar,Orissa',
'Garhrupas,Bhubaneswar,Orissa',
'Gop,Bhubaneswar,Orissa',
'Jopan,Bhubaneswar,Orissa',
'Kamakantia,Bhubaneswar,Orissa',
'Khadiso,Bhubaneswar,Orissa',
'Konark,Bhubaneswar,Orissa',
'Kumarpada,Bhubaneswar,Orissa',
'Kusupur,Bhubaneswar,Orissa',
'Malagaon,Bhubaneswar,Orissa',
'Manijanga,Bhubaneswar,Orissa',
'Nagapur,Bhubaneswar,Orissa',
'Nahantara,Bhubaneswar,Orissa',
'Narua,Bhubaneswar,Orissa',
'Nimapara,Bhubaneswar,Orissa',
'Nuagopalpur,Bhubaneswar,Orissa',
'Nuasantha,Bhubaneswar,Orissa',
'Ohala,Bhubaneswar,Orissa',
'Olikana,Bhubaneswar,Orissa',
'Rahangorada,Bhubaneswar,Orissa',
'Rajas,Bhubaneswar,Orissa',
'Ratilo,Bhubaneswar,Orissa',
'Rench,Bhubaneswar,Orissa',
'Renghalo,Bhubaneswar,Orissa',
'Rupadeipur,Bhubaneswar,Orissa',
'Sagada,Bhubaneswar,Orissa',
'Salanga,Bhubaneswar,Orissa',
'Saraswatipur,Bhubaneswar,Orissa',
'Siaro,Bhubaneswar,Orissa',
'Siso,Bhubaneswar,Orissa',
'Sunugoradi,Bhubaneswar,Orissa',
'Taradapada,Bhubaneswar,Orissa',
'Tentuligaon,Bhubaneswar,Orissa',
'Terundia,Bhubaneswar,Orissa',
'Tulasipur,Bhubaneswar,Orissa',
'Uchhupur,Bhubaneswar,Orissa',
'Villigram,Bhubaneswar,Orissa',
'Bantalasingh,Bhubaneswar,Orissa',
'Binayakpur,Bhubaneswar,Orissa',
'Bindha,Bhubaneswar,Orissa',
'Danagohiri,Bhubaneswar,Orissa',
'Dandamukundapur Gds,Bhubaneswar,Orissa',
'Govindpur,Bhubaneswar,Orissa',
'Haripur,Bhubaneswar,Orissa',
'Kairi,Bhubaneswar,Orissa',
'Kanti,Bhubaneswar,Orissa',
'Makundadaspur,Bhubaneswar,Orissa',
'Mangalpur,Bhubaneswar,Orissa',
'Nuasasan,Bhubaneswar,Orissa',
'Pipili,Bhubaneswar,Orissa',
'Rainsol,Bhubaneswar,Orissa',
'Sangaleisasan,Bhubaneswar,Orissa',
'Siula,Bhubaneswar,Orissa',
'Sompur,Bhubaneswar,Orissa',
'Abhayamukhi Ramachandrapur,Puri,Orissa',
'Alasana,Puri,Orissa',
'Alibada,Puri,Orissa',
'Arisala,Puri,Orissa',
'B S Nagar,Puri,Orissa',
'Badagaon,Puri,Orissa',
'Badagualipada,Puri,Orissa',
'Badas,Puri,Orissa',
'Baliguali,Puri,Orissa',
'Balipada,Puri,Orissa',
'Balisahi,Puri,Orissa',
'Baniasahi,Puri,Orissa',
'Bantaligram,Puri,Orissa',
'Basantapur,Puri,Orissa',
'Baselisahi,Puri,Orissa',
'Basudevpur,Puri,Orissa',
'Berboi,Puri,Orissa',
'Bhimpur,Puri,Orissa',
'Bijayaramachandrapur,Puri,Orissa',
'Bilaspur,Puri,Orissa',
'Birabalabhadrapur,Puri,Orissa',
'Biragobindapur,Puri,Orissa',
'Biraharekrushnapur,Puri,Orissa',
'Biranarasinghpur,Puri,Orissa',
'Birapratappur,Puri,Orissa',
'Birapurusottampur,Puri,Orissa',
'Biraramachandrapur,Puri,Orissa',
'Biswanathpur,Puri,Orissa',
'Brahmanapada,Puri,Orissa',
'Chandanpur,Puri,Orissa',
'Chhaitana,Puri,Orissa',
'D. A. G.,Puri,Orissa',
'Dahan,Puri,Orissa',
'Delang,Puri,Orissa',
'Gadisagoda,Puri,Orissa',
'Ganganarayanpur,Puri,Orissa',
'Garhbadaput,Puri,Orissa',
'Garhbalabhadrapur,Puri,Orissa',
'Garhbhingura,Puri,Orissa',
'Garhmatiapada,Puri,Orissa',
'Garhmrugasira,Puri,Orissa',
'Garhsahi,Puri,Orissa',
'Ghanapana,Puri,Orissa',
'Ghoradia,Puri,Orissa',
'Gopinathpur,Puri,Orissa',
'Gorual,Puri,Orissa',
'Hakapada,Puri,Orissa',
'Hantuka,Puri,Orissa',
'Indipurdeuli,Puri,Orissa',
'Jagannath Ballav,Puri,Orissa',
'Jagannathpur,Puri,Orissa',
'Jenapur,Puri,Orissa',
'Jorakani,Puri,Orissa',
'Kalapadar,Puri,Orissa',
'Kalikadevisahi,Puri,Orissa',
'Kalyanpur,Puri,Orissa',
'Kanas,Puri,Orissa',
'Kanheibidyadharpur,Puri,Orissa',
'Kapileswarpur,Puri,Orissa',
'Kerandipur,Puri,Orissa',
'Khadipada,Puri,Orissa',
'Khandahata,Puri,Orissa',
'Khellore,Puri,Orissa',
'Kundhebentasahi,Puri,Orissa',
'Labanikhiachhak,Puri,Orissa',
'Mahapur,Puri,Orissa',
'Mahodadhi,Puri,Orissa',
'Manikarnika,Puri,Orissa',
'Markandeswar Sahi,Puri,Orissa',
'Motari,Puri,Orissa',
'Muninda,Puri,Orissa',
'Nalibasanta,Puri,Orissa',
'Nandigoda,Puri,Orissa',
'Ola,Puri,Orissa',
'Police Line,Puri,Orissa',
'Praharajpur,Puri,Orissa',
'Pratappurusottampur,Puri,Orissa',
'Puri H.O,Puri,Orissa',
'Puri Seabeach,Puri,Orissa',
'Puri Station Road,Puri,Orissa',
'Rahadamalla,Puri,Orissa',
'Rua,Puri,Orissa',
'S C S College,Puri,Orissa',
'Sadangoi,Puri,Orissa',
'Santidham,Puri,Orissa',
'Sasana Damodarpur,Puri,Orissa',
'Singhadwar,Puri,Orissa',
'Singhbrahmapur,Puri,Orissa',
'Sirei,Puri,Orissa',
'Sirpurusottampur,Puri,Orissa',
'Siruli,Puri,Orissa',
'Sriramachandrapur,Puri,Orissa',
'Srivihar,Puri,Orissa',
'Swargadwar,Puri,Orissa',
'Tadasaramahansapur,Puri,Orissa',
'Talajanga,Puri,Orissa',
'Tipuri,Puri,Orissa',
'Trilochanpur,Puri,Orissa',
'Balaramapurgarh,Puri,Orissa',
'Baliput,Puri,Orissa',
'Charishree,Puri,Orissa',
'Dubaipur,Puri,Orissa',
'Gualigorada,Puri,Orissa',
'Lalitapahandi,Puri,Orissa',
'Mahura,Puri,Orissa',
'Parakena,Puri,Orissa',
'Alagum,Puri,Orissa',
'Balapur,Puri,Orissa',
'Baralabalunkeswar,Puri,Orissa',
'Deypursasan,Puri,Orissa',
'Gabakunda,Puri,Orissa',
'Kothasahi,Puri,Orissa',
'Mula Alasa,Puri,Orissa',
'Nua Someswarpur,Puri,Orissa',
'Pattanaikia,Puri,Orissa',
'Raichakradharpur,Puri,Orissa',
'Sandarahat,Puri,Orissa',
'Sarangajodi,Puri,Orissa',
'Satasankha,Puri,Orissa',
'Sukal,Puri,Orissa',
'Teisipur,Puri,Orissa',
'Sakhigopal,Puri,Orissa',
'Bankara,Koraput,Orissa',
'Ambadola,Koraput,Orissa',
'B.Gotiguda,Koraput,Orissa',
'Batalpur,Koraput,Orissa',
'Batiapada,Koraput,Orissa',
'Bissamcuttack,Koraput,Orissa',
'Chatikona,Koraput,Orissa',
'Dukum,Koraput,Orissa',
'Dumurineli,Koraput,Orissa',
'Durgi,Koraput,Orissa',
'H.Donga,Koraput,Orissa',
'Ichhapur,Koraput,Orissa',
'Jhigidi,Koraput,Orissa',
'K.Dhamuni,Koraput,Orissa',
'K.Golmi,Koraput,Orissa',
'Kachapai,Koraput,Orissa',
'Kankubadi,Koraput,Orissa',
'Konabai,Koraput,Orissa',
'Kurli,Koraput,Orissa',
'Mundakota,Koraput,Orissa',
'Murtuli,Koraput,Orissa',
'P.Dokuluguda,Koraput,Orissa',
'Patraguda,Koraput,Orissa',
'Penta,Koraput,Orissa',
'Piskapanga,Koraput,Orissa',
'Raghubari,Koraput,Orissa',
'Sahada,Koraput,Orissa',
'Asada,Koraput,Orissa',
'Badapankal,Koraput,Orissa',
'Bellamguda,Koraput,Orissa',
'Bijapur,Koraput,Orissa',
'Dhepaguda,Koraput,Orissa',
'Gudari,Koraput,Orissa',
'Karlaghati,Koraput,Orissa',
'Khariguda,Koraput,Orissa',
'Kinalodi,Koraput,Orissa',
'Kodama,Koraput,Orissa',
'M.Khillingrai,Koraput,Orissa',
'Madhuban,Koraput,Orissa',
'Pendili,Koraput,Orissa',
'Sanahuma,Koraput,Orissa',
'Siriguda,Koraput,Orissa',
'Akhusingi,Koraput,Orissa',
'Ambabadi,Koraput,Orissa',
'Bagusala,Koraput,Orissa',
'Bankili,Koraput,Orissa',
'Bhamini,Koraput,Orissa',
'Bhimpur,Koraput,Orissa',
'Bhoimada,Koraput,Orissa',
'Bichikote,Koraput,Orissa',
'Bikrampur,Koraput,Orissa',
'Biripadar,Koraput,Orissa',
'Buthingi,Koraput,Orissa',
'Chalakamba,Koraput,Orissa',
'Chinasari,Koraput,Orissa',
'Dambasora,Koraput,Orissa',
'Derigam,Koraput,Orissa',
'G.Gulumunda,Koraput,Orissa',
'G.Laxmipur,Koraput,Orissa',
'G.Padar,Koraput,Orissa',
'Ghanatri,Koraput,Orissa',
'Godiabandha,Koraput,Orissa',
'Godiakhal,Koraput,Orissa',
'Gogupada,Koraput,Orissa',
'Guluguda,Koraput,Orissa',
'Gulunthi,Koraput,Orissa',
'Gunupur,Koraput,Orissa',
'Hatikhamba,Koraput,Orissa',
'Indupur,Koraput,Orissa',
'Jaganathpur,Koraput,Orissa',
'Jaltar,Koraput,Orissa',
'Jathili,Koraput,Orissa',
'K.Kota,Koraput,Orissa',
'Karini,Koraput,Orissa',
'Katiki,Koraput,Orissa',
'Khabariguda,Koraput,Orissa',
'Khaira,Koraput,Orissa',
'Kharlingi,Koraput,Orissa',
'Khilapadar,Koraput,Orissa',
'Khillingrai,Koraput,Orissa',
'Kinarimada,Koraput,Orissa',
'Kondajam,Koraput,Orissa',
'Kujendri,Koraput,Orissa',
'Kulusingi,Koraput,Orissa',
'Laba,Koraput,Orissa',
'Limapadar,Koraput,Orissa',
'Marathiguda,Koraput,Orissa',
'Marma,Koraput,Orissa',
'Naira,Koraput,Orissa',
'Neelamguda,Koraput,Orissa',
'Nuaguda,Koraput,Orissa',
'Omadingi,Koraput,Orissa',
'Padmapur,Koraput,Orissa',
'Panasaguda,Koraput,Orissa',
'Panichatra,Koraput,Orissa',
'Penakham,Koraput,Orissa',
'Perupanga,Koraput,Orissa',
'Puttasingi,Koraput,Orissa',
'Regada,Koraput,Orissa',
'Rekhapadar,Koraput,Orissa',
'S.Dhamini,Koraput,Orissa',
'Sagada,Koraput,Orissa',
'Serjholi,Koraput,Orissa',
'Tabalaguda,Koraput,Orissa',
'Taribili,Koraput,Orissa',
'Tembaguda,Koraput,Orissa',
'Tiitmari,Koraput,Orissa',
'Tolana,Koraput,Orissa',
'Ukkamba,Koraput,Orissa',
'D.Panga,Koraput,Orissa',
'Jaganathpur,Koraput,Orissa',
'K.Singhpur,Koraput,Orissa',
'Korapa,Koraput,Orissa',
'Narayanpur,Koraput,Orissa',
'Polama,Koraput,Orissa',
'Pujariguda,Koraput,Orissa',
'Singari,Koraput,Orissa',
'Sunakhandi,Koraput,Orissa',
'Adajori,Koraput,Orissa',
'Bankamba,Koraput,Orissa',
'Bilamala,Koraput,Orissa',
'Chandgiri,Koraput,Orissa',
'Chandragiri,Koraput,Orissa',
'Dongasil,Koraput,Orissa',
'Godibali,Koraput,Orissa',
'Gorakhpur,Koraput,Orissa',
'Kampara,Koraput,Orissa',
'Kashipur,Koraput,Orissa',
'Kodipari,Koraput,Orissa',
'Kuchipadar,Koraput,Orissa',
'Maikanch,Koraput,Orissa',
'Mandibisi,Koraput,Orissa',
'Mansugaon,Koraput,Orissa',
'Naktiguda,Koraput,Orissa',
'Panchali,Koraput,Orissa',
'Podapari,Koraput,Orissa',
'Renga,Koraput,Orissa',
'Sankarada,Koraput,Orissa',
'Siripai,Koraput,Orissa',
'Sunger,Koraput,Orissa',
'Tikiri,Koraput,Orissa',
'Turaighati,Koraput,Orissa',
'Agula,Koraput,Orissa',
'B.Bandili,Koraput,Orissa',
'Bhairabguda,Koraput,Orissa',
'Budubali,Koraput,Orissa',
'Chandrapur,Koraput,Orissa',
'Dangasorada,Koraput,Orissa',
'Dohikhal,Koraput,Orissa',
'Hanumanthpur,Koraput,Orissa',
'Hatamuniguda,Koraput,Orissa',
'Jagdalpur,Koraput,Orissa',
'Jarapa,Koraput,Orissa',
'Kumudabali,Koraput,Orissa',
'Kutraguda,Koraput,Orissa',
'Laxmipur,Koraput,Orissa',
'M.Patraguda,Koraput,Orissa',
'Muniguda,Koraput,Orissa',
'T.Padar,Koraput,Orissa',
'Antamoda,Koraput,Orissa',
'B.Alubadi,Koraput,Orissa',
'B.Haluva,Koraput,Orissa',
'B.Khillapadar,Koraput,Orissa',
'Badaguda,Koraput,Orissa',
'Buduni,Koraput,Orissa',
'Dangaladi,Koraput,Orissa',
'Dondili,Koraput,Orissa',
'Dumuriguda,Koraput,Orissa',
'G.Seshkhal,Koraput,Orissa',
'Gajigaon,Koraput,Orissa',
'Halva,Koraput,Orissa',
'J.D.Pentho,Koraput,Orissa',
'J.K.Pur Bazar,Koraput,Orissa',
'J.K.Pur,Koraput,Orissa',
'Jilunda,Koraput,Orissa',
'K.Gumma,Koraput,Orissa',
'Karubai,Koraput,Orissa',
'Kerada,Koraput,Orissa',
'Kolnara,Koraput,Orissa',
'Komtalpeta,Koraput,Orissa',
'Kothapeta,Koraput,Orissa',
'Kumbhikota,Koraput,Orissa',
'Kutuli,Koraput,Orissa',
'Majhiguda,Koraput,Orissa',
'Mirabali,Koraput,Orissa',
'Paikapada,Koraput,Orissa',
'Penta,Koraput,Orissa',
'Pipalguda,Koraput,Orissa',
'Pitamahal,Koraput,Orissa',
'R K Nagar, Rayagada,Koraput,Orissa',
'Ramanaguda,Koraput,Orissa',
'Rayagada Bazar,Koraput,Orissa',
'Rayagada Gandhinagar,Koraput,Orissa',
'Rayagada R.S,Koraput,Orissa',
'Rayagada S.F.,Koraput,Orissa',
'S.S.Khal,Koraput,Orissa',
'Sikarpai,Koraput,Orissa',
'Sirigumma,Koraput,Orissa',
'Sulava,Koraput,Orissa',
'Suri,Koraput,Orissa',
'Therubali,Koraput,Orissa',
'Todama,Koraput,Orissa',
'Rayagada(K) H.O,Koraput,Orissa',
'Badapada,Sambalpur,Orissa',
'Badumermunda,Sambalpur,Orissa',
'Bamphei,Sambalpur,Orissa',
'Bamra,Sambalpur,Orissa',
'Bamrabasti,Sambalpur,Orissa',
'Baunslaga,Sambalpur,Orissa',
'Burbuda,Sambalpur,Orissa',
'Dangajore,Sambalpur,Orissa',
'Gardega,Sambalpur,Orissa',
'Garposh,Sambalpur,Orissa',
'Ghunghuti,Sambalpur,Orissa',
'Kechhopani,Sambalpur,Orissa',
'Kinabaga,Sambalpur,Orissa',
'Kuturimal,Sambalpur,Orissa',
'Nuapali,Sambalpur,Orissa',
'Pankenpada,Sambalpur,Orissa',
'Pindapathar,Sambalpur,Orissa',
'Ragba,Sambalpur,Orissa',
'Rangiatikira,Sambalpur,Orissa',
'Sagra,Sambalpur,Orissa',
'Tileimal,Sambalpur,Orissa',
'Uchakapat,Sambalpur,Orissa',
'A.Katapali,Sambalpur,Orissa',
'Alind Colony,Sambalpur,Orissa',
'Baijamunda PSSK,Sambalpur,Orissa',
'Basantpur,Sambalpur,Orissa',
'Bishalkhinda,Sambalpur,Orissa',
'Bss Nagar,Sambalpur,Orissa',
'Burla,Sambalpur,Orissa',
'C.A. Chiplima,Sambalpur,Orissa',
'Chiplima,Sambalpur,Orissa',
'Dhankauda,Sambalpur,Orissa',
'Engineering College Burla,Sambalpur,Orissa',
'Garmunda,Sambalpur,Orissa',
'Hirakud,Sambalpur,Orissa',
'Jagruti Vihar Burla,Sambalpur,Orissa',
'Jamadarpali,Sambalpur,Orissa',
'Jyoti Vihar Burla,Sambalpur,Orissa',
'Kalamati,Sambalpur,Orissa',
'Kudgunderpur PSSK,Sambalpur,Orissa',
'Medical College Burla,Sambalpur,Orissa',
'Remed,Sambalpur,Orissa',
'Sangramal B. Camp,Sambalpur,Orissa',
'Sankarma,Sambalpur,Orissa',
'Tabadabahal PSSK,Sambalpur,Orissa',
'Talab,Sambalpur,Orissa',
'Badrama,Sambalpur,Orissa',
'Bamandagarh,Sambalpur,Orissa',
'Barhamundi,Sambalpur,Orissa',
'Bhatpura,Sambalpur,Orissa',
'Bhojpur,Sambalpur,Orissa',
'Chakuliabahal,Sambalpur,Orissa',
'Chinimahul,Sambalpur,Orissa',
'Fasimal,Sambalpur,Orissa',
'Gourpali,Sambalpur,Orissa',
'Gundurchuan,Sambalpur,Orissa',
'Jamankira,Sambalpur,Orissa',
'Jamumal,Sambalpur,Orissa',
'Katangapani,Sambalpur,Orissa',
'Katarkela,Sambalpur,Orissa',
'Kenadhipa,Sambalpur,Orissa',
'Kharsanmal,Sambalpur,Orissa',
'Kulundi,Sambalpur,Orissa',
'Mahalingkudar,Sambalpur,Orissa',
'Mudhenapali,Sambalpur,Orissa',
'Sarda,Sambalpur,Orissa',
'Shirod,Sambalpur,Orissa',
'Tikiba,Sambalpur,Orissa',
'Tikilipada,Sambalpur,Orissa',
'Badasahir,Sambalpur,Orissa',
'Baham,Sambalpur,Orissa',
'Basiapara,Sambalpur,Orissa',
'Birsinghgarh,Sambalpur,Orissa',
'Chhamunda,Sambalpur,Orissa',
'Dangarpara,Sambalpur,Orissa',
'Gadgadbahal,Sambalpur,Orissa',
'Godloisingh,Sambalpur,Orissa',
'Hatibari,Sambalpur,Orissa',
'J.Rengali,Sambalpur,Orissa',
'Jayantapur,Sambalpur,Orissa',
'Jujumura,Sambalpur,Orissa',
'Kabrapali,Sambalpur,Orissa',
'Keshapali,Sambalpur,Orissa',
'Kukudapali,Sambalpur,Orissa',
'Lipinda,Sambalpur,Orissa',
'Mochibahal,Sambalpur,Orissa',
'N.Barangamal,Sambalpur,Orissa',
'Nuaburda,Sambalpur,Orissa',
'Padiabahal,Sambalpur,Orissa',
'R.Badmal,Sambalpur,Orissa',
'Tampargarh,Sambalpur,Orissa',
'Ardabahal,Sambalpur,Orissa',
'Babu Nikitimal,Sambalpur,Orissa',
'Badbahal,Sambalpur,Orissa',
'Baliturei,Sambalpur,Orissa',
'Banke,Sambalpur,Orissa',
'Bauriguda,Sambalpur,Orissa',
'Baxma,Sambalpur,Orissa',
'Bhoipali,Sambalpur,Orissa',
'Bilung,Sambalpur,Orissa',
'Chandinimal,Sambalpur,Orissa',
'Chhatabar,Sambalpur,Orissa',
'Dhudipali,Sambalpur,Orissa',
'Gasinapada,Sambalpur,Orissa',
'Gochhara,Sambalpur,Orissa',
'Godrapara,Sambalpur,Orissa',
'Hardipali,Sambalpur,Orissa',
'Jorabaga,Sambalpur,Orissa',
'K. Jamankira,Sambalpur,Orissa',
'Kabribahal,Sambalpur,Orissa',
'Kesaibahal,Sambalpur,Orissa',
'Khalbilung,Sambalpur,Orissa',
'Khandakata,Sambalpur,Orissa',
'Kindira,Sambalpur,Orissa',
'Kuchinda,Sambalpur,Orissa',
'Kuleigarh,Sambalpur,Orissa',
'Kuntara,Sambalpur,Orissa',
'Kusumi,Sambalpur,Orissa',
'Kuturchuan,Sambalpur,Orissa',
'Lad,Sambalpur,Orissa',
'Laidaguma,Sambalpur,Orissa',
'Laigura,Sambalpur,Orissa',
'Lariapali,Sambalpur,Orissa',
'M. Balanda,Sambalpur,Orissa',
'Mahulpali,Sambalpur,Orissa',
'Nuadihi,Sambalpur,Orissa',
'P. Niktimal,Sambalpur,Orissa',
'Paruabhadi,Sambalpur,Orissa',
'Purunapani,Sambalpur,Orissa',
'Ramtileimal,Sambalpur,Orissa',
'Routbahal,Sambalpur,Orissa',
'Salebhadi,Sambalpur,Orissa',
'Sanmundaloi,Sambalpur,Orissa',
'Sargidihi,Sambalpur,Orissa',
'Satkama,Sambalpur,Orissa',
'Subarnapali,Sambalpur,Orissa',
'Tainsar,Sambalpur,Orissa',
'Talsara,Sambalpur,Orissa',
'Telitileimal,Sambalpur,Orissa',
'Turei,Sambalpur,Orissa',
'Turei-niktimal,Sambalpur,Orissa',
'Uttargaon,Sambalpur,Orissa',
'Babuchipidihi Ho,Sambalpur,Orissa',
'Amkuni,Sambalpur,Orissa',
'Baduapali,Sambalpur,Orissa',
'Bargaon,Sambalpur,Orissa',
'Batemura,Sambalpur,Orissa',
'Chaurpur,Sambalpur,Orissa',
'Dakra,Sambalpur,Orissa',
'Deogaon PSSK,Sambalpur,Orissa',
'Dhama,Sambalpur,Orissa',
'Jhankarpali,Sambalpur,Orissa',
'Maltigunderpur,Sambalpur,Orissa',
'Maneswar,Sambalpur,Orissa',
'Parmanpur,Sambalpur,Orissa',
'Rasanpur,Sambalpur,Orissa',
'Sahaspur,Sambalpur,Orissa',
'Salesingha,Sambalpur,Orissa',
'Sindurpank,Sambalpur,Orissa',
'Tabla,Sambalpur,Orissa',
'Themra,Sambalpur,Orissa',
'Batgaon,Sambalpur,Orissa',
'Daincha,Sambalpur,Orissa',
'Fulkusum PSSK,Sambalpur,Orissa',
'Ghosaramal,Sambalpur,Orissa',
'Girischandrapur,Sambalpur,Orissa',
'Jamujori,Sambalpur,Orissa',
'Kelloballam,Sambalpur,Orissa',
'Kisinda,Sambalpur,Orissa',
'Sarapali,Sambalpur,Orissa',
'Similipal,Sambalpur,Orissa',
'Bansajal,Sambalpur,Orissa',
'Bharatapur PSSK,Sambalpur,Orissa',
'Charmal,Sambalpur,Orissa',
'Kadaligarh,Sambalpur,Orissa',
'Luhapank,Sambalpur,Orissa',
'Naktideul Ed,Sambalpur,Orissa',
'R.Badbahal,Sambalpur,Orissa',
'Rairakhol,Sambalpur,Orissa',
'Tribanpur,Sambalpur,Orissa',
'Basupali,Sambalpur,Orissa',
'Binjipali,Sambalpur,Orissa',
'Bomaloi,Sambalpur,Orissa',
'Ghichamura,Sambalpur,Orissa',
'Jharghati Colony,Sambalpur,Orissa',
'K. Jhankarpali,Sambalpur,Orissa',
'Katarbaga,Sambalpur,Orissa',
'Khinda,Sambalpur,Orissa',
'Kilasama,Sambalpur,Orissa',
'Kinaloi,Sambalpur,Orissa',
'Kurla,Sambalpur,Orissa',
'Laida,Sambalpur,Orissa',
'Patrapali,Sambalpur,Orissa',
'Rengali,Sambalpur,Orissa',
'Tamperkela,Sambalpur,Orissa',
'Dhanupali,Sambalpur,Orissa',
'Ainthapali,Sambalpur,Orissa',
'Budharaja,Sambalpur,Orissa',
'Golebazar,Sambalpur,Orissa',
'Jharuapara,Sambalpur,Orissa',
'Khetrajpur,Sambalpur,Orissa',
'Modipara,Sambalpur,Orissa',
'Mudipara,Sambalpur,Orissa',
'Sambalpur Court,Sambalpur,Orissa',
'Sambalpur H.O,Sambalpur,Orissa',
'Sasan Rs,Sambalpur,Orissa',
'Barbazar,Sambalpur,Orissa',
'Bareipali,Sambalpur,Orissa',
'Harinapali,Balangir,Orissa',
'Babupali,Balangir,Orissa',
'Bankigirdi,Balangir,Orissa',
'Bausuni,Balangir,Orissa',
'Bhandar,Balangir,Orissa',
'Binka,Balangir,Orissa',
'Jullunda,Balangir,Orissa',
'Kartang,Balangir,Orissa',
'Mahada,Balangir,Orissa',
'Mahadevpali,Balangir,Orissa',
'Meghla,Balangir,Orissa',
'Sankara,Balangir,Orissa',
'Seledi,Balangir,Orissa',
'Silati,Balangir,Orissa',
'Sindurpur,Balangir,Orissa',
'Singhijuba,Balangir,Orissa',
'Amarpali,Balangir,Orissa',
'Bagbar,Balangir,Orissa',
'Birmaharajpur,Balangir,Orissa',
'Hillung,Balangir,Orissa',
'Jatesingha,Balangir,Orissa',
'Kenghriapali,Balangir,Orissa',
'Khandahata,Balangir,Orissa',
'Kumarkeli,Balangir,Orissa',
'Luthurpank,Balangir,Orissa',
'Pitamahul,Balangir,Orissa',
'Subalaya,Balangir,Orissa',
'Mursundhi,Balangir,Orissa',
'Bankipali,Balangir,Orissa',
'Beheramal,Balangir,Orissa',
'Badkarle,Balangir,Orissa',
'Bhimtikra,Balangir,Orissa',
'Cherupali,Balangir,Orissa',
'Chinajuri,Balangir,Orissa',
'Digsira,Balangir,Orissa',
'Gajbandh,Balangir,Orissa',
'Ichhapur,Balangir,Orissa',
'Karlajuri,Balangir,Orissa',
'Lingamani,Balangir,Orissa',
'R. Mayabarha,Balangir,Orissa',
'Samaleichuan,Balangir,Orissa',
'Sarasmal,Balangir,Orissa',
'Sargul,Balangir,Orissa',
'Sohela,Balangir,Orissa',
'Sonepur Rampur,Balangir,Orissa',
'Sukha,Balangir,Orissa',
'Tamamura,Balangir,Orissa',
'Baidyanath,Balangir,Orissa',
'Bisimunda,Balangir,Orissa',
'Ghodaghatpara,Balangir,Orissa',
'Khaliapali,Balangir,Orissa',
'Khambeswaripali,Balangir,Orissa',
'Lachhipur,Balangir,Orissa',
'Lupursingha,Balangir,Orissa',
'Matiapali,Balangir,Orissa',
'Mayurudan,Balangir,Orissa',
'Rengali,Balangir,Orissa',
'S. Kalapathar,Balangir,Orissa',
'Sonepur Badbazar,Balangir,Orissa',
'Sonepur,Balangir,Orissa',
'Spinning Mills,Balangir,Orissa',
'B.Sibtala,Balangir,Orissa',
'Badbhainro,Balangir,Orissa',
'Brahmani,Balangir,Orissa',
'Charbhata,Balangir,Orissa',
'Deulpadar,Balangir,Orissa',
'Dubula,Balangir,Orissa',
'Jhartarbha,Balangir,Orissa',
'Kamsara,Balangir,Orissa',
'Khari,Balangir,Orissa',
'Maradoguchha,Balangir,Orissa',
'Menda,Balangir,Orissa',
'Narayanpur,Balangir,Orissa',
'Pua,Balangir,Orissa',
'Ranisarda,Balangir,Orissa',
'Sargaj,Balangir,Orissa',
'Tarbha Bazar,Balangir,Orissa',
'Tarbha,Balangir,Orissa',
'Tullunda,Balangir,Orissa',
'Singhari,Balangir,Orissa',
'Chadeipank,Balangir,Orissa',
'Dharamsala,Balangir,Orissa',
'Hikudi,Balangir,Orissa',
'Jaloi,Balangir,Orissa',
'Kadodar,Balangir,Orissa',
'Kalapathar,Balangir,Orissa',
'Kamalpur,Balangir,Orissa',
'Kotsamalai,Balangir,Orissa',
'Naikpada,Balangir,Orissa',
'Nakdei,Balangir,Orissa',
'Panchamahala,Balangir,Orissa',
'Raksa,Balangir,Orissa',
'S.Mahada,Balangir,Orissa',
'S.Patrapali,Balangir,Orissa',
'Sindhol,Balangir,Orissa',
'Ullunda,Balangir,Orissa',
'B.Sankara,Sundargarh,Orissa',
'Bandhabal,Sundargarh,Orissa',
'Khampur,Sundargarh,Orissa',
'B.Karuabahal,Sundargarh,Orissa',
'Balisankara,Sundargarh,Orissa',
'Bandega,Sundargarh,Orissa',
'Barhadema,Sundargarh,Orissa',
'Beheradihi,Sundargarh,Orissa',
'Birkaldihi,Sundargarh,Orissa',
'Damkuda,Sundargarh,Orissa',
'Deobhubanpur,Sundargarh,Orissa',
'Dhamakpur,Sundargarh,Orissa',
'Gaikanpali,Sundargarh,Orissa',
'Hutupani,Sundargarh,Orissa',
'Kaintara,Sundargarh,Orissa',
'Kantabahal,Sundargarh,Orissa',
'Khamarimunda,Sundargarh,Orissa',
'Kinikibandha,Sundargarh,Orissa',
'Kinjirkela,Sundargarh,Orissa',
'Kurei,Sundargarh,Orissa',
'Kusumura,Sundargarh,Orissa',
'Lulkidihi,Sundargarh,Orissa',
'Rampur,Sundargarh,Orissa',
'Rouldega,Sundargarh,Orissa',
'Sagbahal,Sundargarh,Orissa',
'Sagjore,Sundargarh,Orissa',
'Sahanamara,Sundargarh,Orissa',
'Talsara,Sundargarh,Orissa',
'Telijore,Sundargarh,Orissa',
'Tildega,Sundargarh,Orissa',
'Tileikani,Sundargarh,Orissa',
'Tilia,Sundargarh,Orissa',
'Tumlia,Sundargarh,Orissa',
'Sikajore,Sundargarh,Orissa',
'Aludega,Sundargarh,Orissa',
'Bamdera,Sundargarh,Orissa',
'Barangakachhar,Sundargarh,Orissa',
'Bargaon,Sundargarh,Orissa',
'Bhoipali,Sundargarh,Orissa',
'Dandjamira,Sundargarh,Orissa',
'Ekma,Sundargarh,Orissa',
'Itma,Sundargarh,Orissa',
'Jarangloi,Sundargarh,Orissa',
'Kumbahal,Sundargarh,Orissa',
'Kureiboga,Sundargarh,Orissa',
'Kustuna,Sundargarh,Orissa',
'Kusumdegi,Sundargarh,Orissa',
'Lamti,Sundargarh,Orissa',
'Pamra,Sundargarh,Orissa',
'Phulbari,Sundargarh,Orissa',
'Rungaon,Sundargarh,Orissa',
'Sahajbahal,Sundargarh,Orissa',
'Salbira,Sundargarh,Orissa',
'Sankraposh,Sundargarh,Orissa',
'Tiklipara,Sundargarh,Orissa',
'Tudalaga,Sundargarh,Orissa',
'Ajaikela,Sundargarh,Orissa',
'Bandomunda,Sundargarh,Orissa',
'Bisra,Sundargarh,Orissa',
'Jabaghat,Sundargarh,Orissa',
'Jagda,Sundargarh,Orissa',
'Jhirpani,Sundargarh,Orissa',
'Karmabahal,Sundargarh,Orissa',
'Kulenbahal,Sundargarh,Orissa',
'Lahanda,Sundargarh,Orissa',
'Manko,Sundargarh,Orissa',
'Santoshpur,Sundargarh,Orissa',
'Tulsikani,Sundargarh,Orissa',
'Udusu,Sundargarh,Orissa',
'Bangerkela,Sundargarh,Orissa',
'Barsuan,Sundargarh,Orissa',
'Bhalulata,Sundargarh,Orissa',
'Birkera,Sundargarh,Orissa',
'Jareikela,Sundargarh,Orissa',
'Loco Colony Bandomunda,Sundargarh,Orissa',
'Badgogua,Sundargarh,Orissa',
'Bandhabhuin,Sundargarh,Orissa',
'Barghat,Sundargarh,Orissa',
'Bonaigarh,Sundargarh,Orissa',
'Gilli,Sundargarh,Orissa',
'Gopinathpur,Sundargarh,Orissa',
'Govindpur,Sundargarh,Orissa',
'Indrapur,Sundargarh,Orissa',
'Jakaikela,Sundargarh,Orissa',
'Jhirdapali,Sundargarh,Orissa',
'Kandrikela,Sundargarh,Orissa',
'Kasarda,Sundargarh,Orissa',
'Kenaveta,Sundargarh,Orissa',
'Kulkuta,Sundargarh,Orissa',
'Pandrisila,Sundargarh,Orissa',
'S.Bolang,Sundargarh,Orissa',
'Sarsara,Sundargarh,Orissa',
'Sole,Sambalpur,Orissa',
'Talita,Sundargarh,Orissa',
'Tendra,Sundargarh,Orissa',
'Tikayatpali,Sundargarh,Orissa',
'Banki Bazar,Sundargarh,Orissa',
'Bhaludungri,Sundargarh,Orissa',
'Bonaikela,Sundargarh,Orissa',
'Chandiposh,Sundargarh,Orissa',
'Gurundia,Sundargarh,Orissa',
'Jamdar,Sundargarh,Orissa',
'Jarda,Sundargarh,Orissa',
'Kansar,Sundargarh,Orissa',
'Kantapali,Sundargarh,Orissa',
'Kumakela,Sundargarh,Orissa',
'Kundheidiha,Sundargarh,Orissa',
'Lachada,Sundargarh,Orissa',
'Mayurdima,Sundargarh,Orissa',
'Narendra,Sundargarh,Orissa',
'Pankadihi,Sundargarh,Orissa',
'Satkura,Sundargarh,Orissa',
'Tamra,Sundargarh,Orissa',
'Balinga,Sundargarh,Orissa',
'Barpali,Sundargarh,Orissa',
'Basundhara,Sundargarh,Orissa',
'Beheramunda,Sundargarh,Orissa',
'Bileimunda,Sundargarh,Orissa',
'Daghora,Sundargarh,Orissa',
'Duduka,Sundargarh,Orissa',
'Durubaga,Sundargarh,Orissa',
'G. Tumulia,Sundargarh,Orissa',
'Garjanjore,Sundargarh,Orissa',
'Gopalpur,Sundargarh,Orissa',
'Hemgir Road,Sundargarh,Orissa',
'Hemgir,Sundargarh,Orissa',
'Jharpalam,Sundargarh,Orissa',
'Kalamegha,Sundargarh,Orissa',
'Kanaktura,Sundargarh,Orissa',
'Kendudihi,Sundargarh,Orissa',
'R.Ratansara,Sundargarh,Orissa',
'Rohini,Sundargarh,Orissa',
'Sanghumunda,Sundargarh,Orissa',
'Tangardihi,Sundargarh,Orissa',
'Tikilipara,Sundargarh,Orissa',
'Topria,Sundargarh,Orissa',
'Kuchedega,Sundargarh,Orissa',
'Bimlagarh,Sundargarh,Orissa',
'Chordhara,Sundargarh,Orissa',
'Dengula Ashram,Sundargarh,Orissa',
'Gopna,Sundargarh,Orissa',
'Jamdihi,Sundargarh,Orissa',
'Jharbeda Banki,Sundargarh,Orissa',
'K.Bolang,Sundargarh,Orissa',
'Kalta,Sundargarh,Orissa',
'Khariabahal,Sundargarh,Orissa',
'Koira,Sundargarh,Orissa',
'Patmunda,Sundargarh,Orissa',
'Roxy,Sundargarh,Orissa',
'Sayamba,Sundargarh,Orissa',
'Tensa,Sundargarh,Orissa',
'A.Jambahal,Sundargarh,Orissa',
'Biramitrapur,Sundargarh,Orissa',
'Dalki,Sundargarh,Orissa',
'Damdapara,Sundargarh,Orissa',
'Dumerjore,Sundargarh,Orissa',
'Gobira,Sundargarh,Orissa',
'Indrapur,Sundargarh,Orissa',
'Jhamankera,Sundargarh,Orissa',
'Jhunmur,Sundargarh,Orissa',
'Kacharu,Sundargarh,Orissa',
'Kadobahal,Sundargarh,Orissa',
'Kalosihiria,Sundargarh,Orissa',
'Kuarmunda,Sundargarh,Orissa',
'Kumjharia,Sundargarh,Orissa',
'Kunmendra,Sundargarh,Orissa',
'Majhapara,Sundargarh,Orissa',
'Padampur,Sundargarh,Orissa',
'Raiboga,Sundargarh,Orissa',
'Ratakhandi,Sundargarh,Orissa',
'Salangabahal,Sundargarh,Orissa',
'Gyanpali,Sundargarh,Orissa',
'Amgova,Sundargarh,Orissa',
'Biringatoli,Sundargarh,Orissa',
'Dahijira,Sundargarh,Orissa',
'Gairbahal,Sundargarh,Orissa',
'Jharbeda,Sundargarh,Orissa',
'Kahapani,Sundargarh,Orissa',
'Katang,Sundargarh,Orissa',
'Khatkurbahal,Sundargarh,Orissa',
'Koronga,Sundargarh,Orissa',
'Kutra,Sundargarh,Orissa',
'Lanjiberna,Sundargarh,Orissa',
'Latalaga,Sundargarh,Orissa',
'N.Jharen,Sundargarh,Orissa',
'Panchora,Sundargarh,Orissa',
'R.Kukuda,Sundargarh,Orissa',
'Tarkera,Sundargarh,Orissa',
'Tunmura,Sundargarh,Orissa',
'Barsuan,Sundargarh,Orissa',
'Bhutuda,Sundargarh,Orissa',
'Dalaisara,Sundargarh,Orissa',
'Darjing,Sundargarh,Orissa',
'Jangra,Sundargarh,Orissa',
'Juniany,Sundargarh,Orissa',
'Kalaiposh,Sundargarh,Orissa',
'Khuntgaon,Sundargarh,Orissa',
'Kuliposh,Sundargarh,Orissa',
'Kundheikela,Sundargarh,Orissa',
'Kurda,Sundargarh,Orissa',
'Lahunipara,Sundargarh,Orissa',
'Lalei,Sundargarh,Orissa',
'Mahuldiha,Sundargarh,Orissa',
'Mahulpada,Sundargarh,Orissa',
'Nandapara,Sundargarh,Orissa',
'Phuljhar,Sundargarh,Orissa',
'Ruguda,Sundargarh,Orissa',
'Sankhaposh,Sundargarh,Orissa',
'Sardhapur,Sundargarh,Orissa',
'Sashyakala,Sundargarh,Orissa',
'Sihidia,Sundargarh,Orissa',
'Topadihi,Sundargarh,Orissa',
'Tumkela,Sundargarh,Orissa',
'Asurchapal,Sundargarh,Orissa',
'Bad Dalki,Sundargarh,Orissa',
'Balanda,Sundargarh,Orissa',
'Barghat,Sundargarh,Orissa',
'Beldihi,Sundargarh,Orissa',
'Birda,Sundargarh,Orissa',
'Birkera,Sundargarh,Orissa',
'Bolani,Sundargarh,Orissa',
'Brahmani Tarang,Sundargarh,Orissa',
'Chandrapur,Sundargarh,Orissa',
'Chikatmati,Sundargarh,Orissa',
'Garjan,Sundargarh,Orissa',
'Jadakudar,Sundargarh,Orissa',
'Jalda,Sundargarh,Orissa',
'Jhartarang,Sundargarh,Orissa',
'Kalunga,Sundargarh,Orissa',
'Lathikata,Sundargarh,Orissa',
'Patua,Sundargarh,Orissa',
'Ramjodi,Sundargarh,Orissa',
'Sargigarh,Sundargarh,Orissa',
'Tainsar,Sundargarh,Orissa',
'Vedvyas,Sundargarh,Orissa',
'Alapaka,Sundargarh,Orissa',
'Aunlabahal,Sundargarh,Orissa',
'Bailama,Sundargarh,Orissa',
'Chhatenpali,Sundargarh,Orissa',
'Dandpani,Sundargarh,Orissa',
'Darlipali,Sundargarh,Orissa',
'Diamunda,Sundargarh,Orissa',
'Dumabahal,Sundargarh,Orissa',
'Giringkela,Sundargarh,Orissa',
'Gundiadihi,Sundargarh,Orissa',
'Karanjkhol,Sundargarh,Orissa',
'Kulabira,Sundargarh,Orissa',
'Kuturma,Sundargarh,Orissa',
'Laikera,Sundargarh,Orissa',
'Lephripara,Sundargarh,Orissa',
'Mosabira,Sundargarh,Orissa',
'Nuadihi,Sundargarh,Orissa',
'Patuadihi,Sundargarh,Orissa',
'Raidihi,Sundargarh,Orissa',
'Rajbahal,Sundargarh,Orissa',
'Sarafgarh,Sundargarh,Orissa',
'Sargipali,Sundargarh,Orissa',
'Suanjore,Sundargarh,Orissa',
'Suarijore,Sundargarh,Orissa',
'Surguda,Sundargarh,Orissa',
'Telendihi,Sundargarh,Orissa',
'Barilepta,Sundargarh,Orissa',
'Chitapedi,Sundargarh,Orissa',
'Hatibari,Sundargarh,Orissa',
'Kandarkela,Sundargarh,Orissa',
'Kaplas,Sundargarh,Orissa',
'Kardega,Sundargarh,Orissa',
'Khutgaon,Sundargarh,Orissa',
'Kokerama,Sundargarh,Orissa',
'Limida,Sundargarh,Orissa',
'Luaram,Sundargarh,Orissa',
'Nuagaon,Sundargarh,Orissa',
'Purnapani,Sundargarh,Orissa',
'Surda,Sundargarh,Orissa',
'Tainda,Sundargarh,Orissa',
'Bagdega,Sundargarh,Orissa',
'Alanda,Sundargarh,Orissa',
'Buchukupara,Sundargarh,Orissa',
'Chungimati,Sundargarh,Orissa',
'Garbhana,Sundargarh,Orissa',
'Jareikela,Sundargarh,Orissa',
'Kansbahal,Sundargarh,Orissa',
'Kesramal,Sundargarh,Orissa',
'Kutunia,Sundargarh,Orissa',
'Laing,Sundargarh,Orissa',
'Laing Colony,Sundargarh,Orissa',
'Malidihi,Sundargarh,Orissa',
'Railway Colony,Sundargarh,Orissa',
'Rajgangpur,Sundargarh,Orissa',
'Ranibandha,Sundargarh,Orissa',
'Ushra Colony,Sundargarh,Orissa',
'Luakera,Sundargarh,Orissa',
'Basanti Colony,Sundargarh,Orissa',
'Bisra Raod,Sundargarh,Orissa',
'Civil Township,Sundargarh,Orissa',
'Daily Market,Sundargarh,Orissa',
'Fertilizer Township,Sundargarh,Orissa',
'Jail Road,Sundargarh,Orissa',
'Kalinga Vihar,Sundargarh,Orissa',
'Katchery Road,Sundargarh,Orissa',
'Main Road,Sundargarh,Orissa',
'Panposh Road,Sundargarh,Orissa',
'Rourkela - 10,Sundargarh,Orissa',
'Rourkela - 11,Sundargarh,Orissa',
'Rourkela - 13,Sundargarh,Orissa',
'Rourkela - 14,Sundargarh,Orissa',
'Rourkela - 15,Sundargarh,Orissa',
'Rourkela - 2,Sundargarh,Orissa',
'Rourkela - 3,Sundargarh,Orissa',
'Rourkela - 4,Sundargarh,Orissa',
'Rourkela - 5,Sundargarh,Orissa',
'Rourkela - 6,Sundargarh,Orissa',
'Rourkela - 7,Sundargarh,Orissa',
'Rourkela - 8,Sundargarh,Orissa',
'Rourkela - 9,Sundargarh,Orissa',
'Rourkela -16,Sundargarh,Orissa',
'Rourkela H.O,Sundargarh,Orissa',
'Sector - 15,Sundargarh,Orissa',
'Sector - 16,Sundargarh,Orissa',
'Sector - 2,Sundargarh,Orissa',
'Sector - 5,Sundargarh,Orissa',
'Sector - 6,Sundargarh,Orissa',
'Sector - 7,Sundargarh,Orissa',
'Uditnagar H.O,Sundargarh,Orissa',
'Baurimundagaon,Sundargarh,Orissa',
'Chhotasargi,Sundargarh,Orissa',
'Deogaon,Sundargarh,Orissa',
'Gangpurgarh,Sundargarh,Orissa',
'Hamirpur,Sundargarh,Orissa',
'Jaisor,Sundargarh,Orissa',
'Jamuna,Sundargarh,Orissa',
'Karamdihi,Sundargarh,Orissa',
'Kiralaga,Sundargarh,Orissa',
'Kukridihi,Sundargarh,Orissa',
'Kulba,Sundargarh,Orissa',
'Kurumkel,Sundargarh,Orissa',
'Panchmahala,Sundargarh,Orissa',
'Raidihi,Sundargarh,Orissa',
'Ranpur,Sundargarh,Orissa',
'Rasrajpur,Sundargarh,Orissa',
'Sapdagar,Sundargarh,Orissa',
'Simdega,Sundargarh,Orissa',
'Subdega,Sundargarh,Orissa',
'Tangargaon,Sundargarh,Orissa',
'Badbahal,Sundargarh,Orissa',
'Badsalepali,Sundargarh,Orissa',
'Baladmal,Sundargarh,Orissa',
'Baragad,Sundargarh,Orissa',
'Bhasma,Sundargarh,Orissa',
'Bhedabahal,Sundargarh,Orissa',
'Birbira,Sundargarh,Orissa',
'Dengibhadi,Sundargarh,Orissa',
'Deuli,Sundargarh,Orissa',
'Dharuadihi,Sundargarh,Orissa',
'Gadiajore,Sundargarh,Orissa',
'Jamtalia,Sundargarh,Orissa',
'Karla,Sundargarh,Orissa',
'Kinjirma,Sundargarh,Orissa',
'Kirei,Sundargarh,Orissa',
'Kopsingha,Sundargarh,Orissa',
'Kulta,Sundargarh,Orissa',
'Kundukela,Sundargarh,Orissa',
'Lahandabud,Sundargarh,Orissa',
'Lankahuda,Sundargarh,Orissa',
'Ledhimong,Sundargarh,Orissa',
'Mahesdihi,Sundargarh,Orissa',
'Majhapara,Sundargarh,Orissa',
'Philingibahal,Sundargarh,Orissa',
'Pudajalanga,Sundargarh,Orissa',
'Rangadhipa,Sundargarh,Orissa',
'Regent Market,Sundargarh,Orissa',
'Salangabud,Sundargarh,Orissa',
'Sankara,Sundargarh,Orissa',
'Sundargarh College,Sundargarh,Orissa',
'Sundargarh Court,Sundargarh,Orissa',
'Sundargarh H.O,Sundargarh,Orissa',
'Sanpatrapali,Sundargarh,Orissa',
'Aleikera,Sundargarh,Orissa',
'Badbonga,Sundargarh,Orissa',
'Bandhpali,Sundargarh,Orissa',
'Belsara,Sundargarh,Orissa',
'Bilaigarh,Sundargarh,Orissa',
'Daldali,Sundargarh,Orissa',
'G. Mahulpali,Sundargarh,Orissa',
'Gambharidihi,Sundargarh,Orissa',
'J.Raiboga,Sundargarh,Orissa',
'Jhargaon,Sundargarh,Orissa',
'Jhariapali,Sundargarh,Orissa',
'Kanakjore,Sundargarh,Orissa',
'Katra,Sundargarh,Orissa',
'Kiakachhar,Sundargarh,Orissa',
'Kiripsira,Sundargarh,Orissa',
'Kuarboga,Sundargarh,Orissa',
'Kurga,Sundargarh,Orissa',
'Mangaspur,Sundargarh,Orissa',
'Meghdega,Sundargarh,Orissa',
'Nialipali,Sundargarh,Orissa',
'Ratanpur,Sundargarh,Orissa',
'Remanda,Sundargarh,Orissa',
'Tangarpali,Sundargarh,Orissa',
'Tasladihi,Sundargarh,Orissa',
'Ujalpur,Sundargarh,Orissa',
'Zincnagar,Sundargarh,Orissa',
'Rajpur,Sundargarh,Orissa',
'Akkaraivattam,Nagapattinam,Pondicherry',
'Ambagarathur,Nagapattinam,Pondicherry',
'Dharmapuram,Nagapattinam,Pondicherry',
'Karaikal Bazaar,Nagapattinam,Pondicherry',
'Karaikal,Nagapattinam,Pondicherry',
'Karaikal South,Nagapattinam,Pondicherry',
'Karaikalmedu,Nagapattinam,Pondicherry',
'Karaikoilpathu,Nagapattinam,Pondicherry',
'Karukangudi,Nagapattinam,Pondicherry',
'Kottuchery,Nagapattinam,Pondicherry',
'Kurumbagaram,Nagapattinam,Pondicherry',
'Madagadi,Nagapattinam,Pondicherry',
'Melakasakudi,Nagapattinam,Pondicherry',
'Nallambal,Nagapattinam,Pondicherry',
'Nallathur,Nagapattinam,Pondicherry',
'Nedungadu,Nagapattinam,Pondicherry',
'Neravy,Nagapattinam,Pondicherry',
'Seithur,Nagapattinam,Pondicherry',
'Sellur,Nagapattinam,Pondicherry',
'Surakudi,Nagapattinam,Pondicherry',
'T.R.Pattinam South,Nagapattinam,Pondicherry',
'Thalatheru,Nagapattinam,Pondicherry',
'Tirumalairayanpattinam,Nagapattinam,Pondicherry',
'Tirunallar,Nagapattinam,Pondicherry',
'Tiruvettakudi,Nagapattinam,Pondicherry',
'Varichikudi,Nagapattinam,Pondicherry',
'Vizhithiyur,Nagapattinam,Pondicherry',
'Naluthara,Vadakara,Pondicherry',
'Pallur,Vadakara,Pondicherry',
'Padmini Nagar,Pondicherry,Pondicherry',
'Abishegapakkam,Pondicherry,Pondicherry',
'Ariyankuppam,Pondicherry,Pondicherry',
'Arumbarthapuram,Pondicherry,Pondicherry',
'Bahoor,Pondicherry,Pondicherry',
'Botanical Garden,Pondicherry,Pondicherry',
'Calapet,Pondicherry,Pondicherry',
'Pondicherry H.O,Pondicherry,Pondicherry',
'Pondicherry North,Pondicherry,Pondicherry',
'Pondicherry University,Pondicherry,Pondicherry',
'Pooranankuppam,Pondicherry,Pondicherry',
'Poothurai,Pondicherry,Pondicherry',
'Rayapudupakkam,Pondicherry,Pondicherry',
'Reddiyarpalayam,Pondicherry,Pondicherry',
'Saram(Py),Pondicherry,Pondicherry',
'Sedarapet,Pondicherry,Pondicherry',
'Seliamedu,Pondicherry,Pondicherry',
'Sellipet,Pondicherry,Pondicherry',
'Sri Aurobindo Ashram,Pondicherry,Pondicherry',
'Sulthanpet,Pondicherry,Pondicherry',
'Thattanchavady,Pondicherry,Pondicherry',
'Thengaithittu,Pondicherry,Pondicherry',
'Thimmanaickenpalayam,Pondicherry,Pondicherry',
'Tirukkanur,Pondicherry,Pondicherry',
'Vadhanur,Pondicherry,Pondicherry',
'Veerampattinam,Pondicherry,Pondicherry',
'Venkata Nagar,Pondicherry,Pondicherry',
'Villiyanur,Pondicherry,Pondicherry',
'Vimacoundinpaleam,Pondicherry,Pondicherry',
'Viranam,Pondicherry,Pondicherry',
'Yanam,Kakinada,Pondicherry',
'Bommayarpalayam,Pondicherry,Pondicherry',
'Kilsirivi,Pondicherry,Pondicherry',
'Pandakkal,Vadakara,Pondicherry',
'Chheherta,Amritsar,Punjab',
'Sohal,Amritsar,Punjab',
'Thatian Mahatan,Amritsar,Punjab',
'Thoba,Amritsar,Punjab',
'Thothian,Amritsar,Punjab',
'Tmmowal,Amritsar,Punjab',
'Uggar Aulakh,Amritsar,Punjab',
'Usman,Amritsar,Punjab',
'Vachhoa,Amritsar,Punjab',
'Vallah,Amritsar,Punjab',
'Vanike,Amritsar,Punjab',
'Varnala,Amritsar,Punjab',
'Viring,Amritsar,Punjab',
'Wadal Johal,Amritsar,Punjab',
'Wadal Khurad,Amritsar,Punjab',
'Wadala Bhittewad,Amritsar,Punjab',
'Wadala Viram,Amritsar,Punjab',
'Wadali Guru,Amritsar,Punjab',
'Wadalkalan,Amritsar,Punjab',
'Wan Tara Singh,Amritsar,Punjab',
'Warah,Amritsar,Punjab',
'Warpal,Amritsar,Punjab',
'Waryam Nangal,Amritsar,Punjab',
'Nangal Dial Singh,Amritsar,Punjab',
'Aim A Kalan,Amritsar,Punjab',
'Allowal,Amritsar,Punjab',
'Amarkot,Amritsar,Punjab',
'Amritsar Bus Stand,Amritsar,Punjab',
'Amritsar Kty,Amritsar,Punjab',
'Amritsar Sadar Bazar,Amritsar,Punjab',
'Arjan Mang,Amritsar,Punjab',
'Assal Uttar,Amritsar,Punjab',
'Attari Rd. Check Post,Amritsar,Punjab',
'Azad Nagar,Amritsar,Punjab',
'B R Dhab,Amritsar,Punjab',
'Babowal,Amritsar,Punjab',
'Bagarian,Amritsar,Punjab',
'Bagga,Amritsar,Punjab',
'Bagga,Amritsar,Punjab',
'Bainka,Amritsar,Punjab',
'Bakipur,Amritsar,Punjab',
'Bal Khurd,Amritsar,Punjab',
'Bal Sarai,Amritsar,Punjab',
'Balbawa,Amritsar,Punjab',
'Balkalan,Amritsar,Punjab',
'Banian,Amritsar,Punjab',
'Bhagiari,Amritsar,Punjab',
'Bhagupura,Amritsar,Punjab',
'Bhagwanpura,Amritsar,Punjab',
'Bhai Ladhu,Amritsar,Punjab',
'Bhaini Rajputan,Amritsar,Punjab',
'Bhakna Kalan,Amritsar,Punjab',
'Bhalaipur Purban,Amritsar,Punjab',
'Bhalajola,Amritsar,Punjab',
'Bhangala,Amritsar,Punjab',
'Bhangali,Amritsar,Punjab',
'Bhangwan,Amritsar,Punjab',
'Bharowal,Amritsar,Punjab',
'Bhathal Bhai,Amritsar,Punjab',
'Bhatte Bhaini,Amritsar,Punjab',
'Bhattike,Amritsar,Punjab',
'Bhilowal Pacca,Amritsar,Punjab',
'Bhinder,Amritsar,Punjab',
'Bhittewad,Amritsar,Punjab',
'Bhopa Rai,Amritsar,Punjab',
'Bhuse,Amritsar,Punjab',
'Biharipura,Amritsar,Punjab',
'Bindiaulakh,Amritsar,Punjab',
'Bindisaidan,Amritsar,Punjab',
'Bopa Rai,Amritsar,Punjab',
'Brahampura,Amritsar,Punjab',
'Bsf Campus Bhikhiwind,Amritsar,Punjab',
'Bundala,Amritsar,Punjab',
'Chakkare Khan,Amritsar,Punjab',
'Chamba Kalan,Amritsar,Punjab',
'Chhajanwadi,Amritsar,Punjab',
'Chohan,Amritsar,Punjab',
'Chowk Darbar Sahib,Amritsar,Punjab',
'Chowk Rattan Singh,Amritsar,Punjab',
'Chutala,Amritsar,Punjab',
'Daleke,Amritsar,Punjab',
'Dall,Amritsar,Punjab',
'Devidaspura,Amritsar,Punjab',
'Dgardei,Amritsar,Punjab',
'Dhaburji,Amritsar,Punjab',
'Dhadupura,Amritsar,Punjab',
'Dhand,Amritsar,Punjab',
'Dhanoakalan,Amritsar,Punjab',
'Dhariwal,Amritsar,Punjab',
'Dhaul Kalan,Amritsar,Punjab',
'Dhianpur,Amritsar,Punjab',
'Dhulka,Amritsar,Punjab',
'Dhunda,Amritsar,Punjab',
'Dhundhai Wala,Amritsar,Punjab',
'Dibbi Pura,Amritsar,Punjab',
'Dinewal,Amritsar,Punjab',
'Dist Jail,Amritsar,Punjab',
'Fatahpur,Amritsar,Punjab',
'Gharinda,Amritsar,Punjab',
'Gharka Buwala,Amritsar,Punjab',
'Ghomanpura,Amritsar,Punjab',
'Gilwali,Amritsar,Punjab',
'Goggobua,Amritsar,Punjab',
'Gohalwar Warpal,Amritsar,Punjab',
'Golden Temple,Amritsar,Punjab',
'Grd Niwas,Amritsar,Punjab',
'Gumtala,Amritsar,Punjab',
'Guru Bazar,Amritsar,Punjab',
'Harsha Chhina,Amritsar,Punjab',
'Hide Market,Amritsar,Punjab',
'Hothian,Amritsar,Punjab',
'Hs College,Amritsar,Punjab',
'Iban Kalan,Amritsar,Punjab',
'Islamabad,Amritsar,Punjab',
'Jaintipur,Amritsar,Punjab',
'Jalalabad,Amritsar,Punjab',
'Jandiala Cb,Amritsar,Punjab',
'Jastarwal,Amritsar,Punjab',
'Jhamke,Amritsar,Punjab',
'Jhikalan,Amritsar,Punjab',
'Johal Raju Singh,Amritsar,Punjab',
'Kadgil,Amritsar,Punjab',
'Kangra Colony,Amritsar,Punjab',
'Katra Karam Singh,Amritsar,Punjab',
'Katra Sher Singh,Amritsar,Punjab',
'Khabedogran,Amritsar,Punjab',
'Kot Atma Ram,Amritsar,Punjab',
'Kot Ralia Ram,Amritsar,Punjab',
'Kotla Sultan Singh,Amritsar,Punjab',
'Lawrence Road,Amritsar,Punjab',
'Loharka Kalan,Amritsar,Punjab',
'Majith Mandi,Amritsar,Punjab',
'Manawala Khurd,Amritsar,Punjab',
'Manochahal,Amritsar,Punjab',
'Marhana,Amritsar,Punjab',
'Mari Kamboke,Amritsar,Punjab',
'Mattewal,Amritsar,Punjab',
'Medical College,Amritsar,Punjab',
'Meherbanapura,Amritsar,Punjab',
'Mehndipura,Amritsar,Punjab',
'Nangli,Amritsar,Punjab',
'Naurnagbad,Amritsar,Punjab',
'Nawan Kot,Amritsar,Punjab',
'Nrw Shop,Amritsar,Punjab',
'Nushera Nangli,Amritsar,Punjab',
'Palasaur,Amritsar,Punjab',
'Pandori Gola,Amritsar,Punjab',
'Pandori Ransingh,Amritsar,Punjab',
'Pandori Takhtmal,Amritsar,Punjab',
'Pandori Warraich,Amritsar,Punjab',
'Patti Kty,Amritsar,Punjab',
'Pindian,Amritsar,Punjab',
'Pratapnagar,Amritsar,Punjab',
'Qilla Kavi Santokh,Amritsar,Punjab',
'Rajatal,Amritsar,Punjab',
'Rajoke,Amritsar,Punjab',
'Ram Diwali Muslama,Amritsar,Punjab',
'Ram Talai,Amritsar,Punjab',
'Rampur Bhootwind,Amritsar,Punjab',
'Rani Ka Bagh,Amritsar,Punjab',
'Ruriwala,Amritsar,Punjab',
'Rusulpur,Amritsar,Punjab',
'Sabhra,Amritsar,Punjab',
'Saidpur,Amritsar,Punjab',
'Sangna,Amritsar,Punjab',
'Sarangra,Amritsar,Punjab',
'Shahabpur,Amritsar,Punjab',
'Sialka,Amritsar,Punjab',
'Sjs Avenue,Amritsar,Punjab',
'Sohawa,Amritsar,Punjab',
'Sohian Khurd,Amritsar,Punjab',
'Sugga,Amritsar,Punjab',
'Sultan Wind Gate,Amritsar,Punjab',
'Tharu,Amritsar,Punjab',
'Thathgarh,Amritsar,Punjab',
'Thathi Khara,Amritsar,Punjab',
'Tut,Amritsar,Punjab',
'Uddoke,Amritsar,Punjab',
'Udhonangal,Amritsar,Punjab',
'Vainboin,Amritsar,Punjab',
'Vairowal,Amritsar,Punjab',
'Vairowal Vawian,Amritsar,Punjab',
'Valtoha,Amritsar,Punjab',
'Vijayanagar,Amritsar,Punjab',
'Ajnala,Amritsar,Punjab',
'Balharwal,Amritsar,Punjab',
'Bhallapind,Amritsar,Punjab',
'Bhoewali,Amritsar,Punjab',
'Dahoorian,Amritsar,Punjab',
'Dhariwal Kaler,Amritsar,Punjab',
'Dujoowal,Amritsar,Punjab',
'Dujowal,Amritsar,Punjab',
'Fatehwal,Amritsar,Punjab',
'Fatehwal,Amritsar,Punjab',
'Gaggomahal,Amritsar,Punjab',
'Gaggomahal,Amritsar,Punjab',
'Gorala,Amritsar,Punjab',
'Guru Ka Bagh,Amritsar,Punjab',
'Jafarkot,Amritsar,Punjab',
'Jagdev Khurd,Amritsar,Punjab',
'Jasrur,Amritsar,Punjab',
'Kariyala,Amritsar,Punjab',
'Mehlanwala,Amritsar,Punjab',
'Othian,Amritsar,Punjab',
'Othian,Amritsar,Punjab',
'Sehensra,Amritsar,Punjab',
'Mohar,Amritsar,Punjab',
'Amritsar G.P.O.,Amritsar,Punjab',
'Baba Bakala,Amritsar,Punjab',
'Beas,Amritsar,Punjab',
'Bhikhiwind,Amritsar,Punjab',
'Bhilowal,Amritsar,Punjab',
'Butala,Amritsar,Punjab',
'Chamiari,Amritsar,Punjab',
'Chawinda Devi,Amritsar,Punjab',
'Chetanpura,Amritsar,Punjab',
'Chogawan,Amritsar,Punjab',
'Chogawan Sidpur,Amritsar,Punjab',
'Chola Sahib,Amritsar,Punjab',
'D.B.J.Singh,Amritsar,Punjab',
'Daburjit,Amritsar,Punjab',
'Dhotian,Amritsar,Punjab',
'Distrillery Khasa,Amritsar,Punjab',
'Fatehabad,Amritsar,Punjab',
'Fatehpur Rajputan,Amritsar,Punjab',
'Fatehwal,Amritsar,Punjab',
'Gandhi Bazar,Amritsar,Punjab',
'Ghandiwind Dhattal,Amritsar,Punjab',
'Guru Nanak Dev University,Amritsar,Punjab',
'Jahagir Khurd,Amritsar,Punjab',
'Jahangir,Amritsar,Punjab',
'Jalalpur,Amritsar,Punjab',
'Jalalusman,Amritsar,Punjab',
'Jallupura Khera,Amritsar,Punjab',
'Jamalpur,Amritsar,Punjab',
'Jandiala Guru,Amritsar,Punjab',
'Jandiala R.S,Amritsar,Punjab',
'Jaspal,Amritsar,Punjab',
'Jasrur,Amritsar,Punjab',
'Jaunke,Amritsar,Punjab',
'Jaura,Amritsar,Punjab',
'Jawala Flour Mills,Amritsar,Punjab',
'Jhander,Amritsar,Punjab',
'Jhanjoti,Amritsar,Punjab',
'Johal Dhai Wala,Amritsar,Punjab',
'Kacha Pacca,Amritsar,Punjab',
'Kale Ghanpur,Amritsar,Punjab',
'Kamalpur,Amritsar,Punjab',
'Kang,Amritsar,Punjab',
'Kasail,Amritsar,Punjab',
'Kathania,Amritsar,Punjab',
'Kathunangal,Amritsar,Punjab',
'Khabe Rajputana,Amritsar,Punjab',
'Khadoor Sahib,Amritsar,Punjab',
'Khalra,Amritsar,Punjab',
'Khalsa College,Amritsar,Punjab',
'Khalsa College,Amritsar,Punjab',
'Khankot Garden Colony,Amritsar,Punjab',
'Khanna Nagar,Amritsar,Punjab',
'Khanpur,Amritsar,Punjab',
'Khaper Kheri,Amritsar,Punjab',
'Khara,Amritsar,Punjab',
'Khatrian Kala N,Amritsar,Punjab',
'Khawaspur,Amritsar,Punjab',
'Khela,Amritsar,Punjab',
'Khem Karan,Amritsar,Punjab',
'Khiala Kalan,Amritsar,Punjab',
'Khilchian,Amritsar,Punjab',
'Kirtowal,Amritsar,Punjab',
'Kohala,Amritsar,Punjab',
'Kohali,Amritsar,Punjab',
'Kot Budha,Amritsar,Punjab',
'Kot Dharam Chand Kalan,Amritsar,Punjab',
'Kot Khera,Amritsar,Punjab',
'Kot Mit Singh,Amritsar,Punjab',
'Kot Mohd.Khan,Amritsar,Punjab',
'Kotla Gujran,Amritsar,Punjab',
'Kullah,Amritsar,Punjab',
'Ladehwal,Amritsar,Punjab',
'Lakhna,Amritsar,Punjab',
'Lalpura,Amritsar,Punjab',
'Lauka,Amritsar,Punjab',
'Leharka,Amritsar,Punjab',
'Lidhar,Amritsar,Punjab',
'Lola,Amritsar,Punjab',
'Ludhar,Amritsar,Punjab',
'Madhu Chhanga,Amritsar,Punjab',
'Madoke,Amritsar,Punjab',
'Majitha,Amritsar,Punjab',
'Manakpura,Amritsar,Punjab',
'Marrai Kalan,Amritsar,Punjab',
'Mehta Chow,Amritsar,Punjab',
'Mohawa,Amritsar,Punjab',
'Naraiangarh,Amritsar,Punjab',
'Naushera Panvan,Amritsar,Punjab',
'Patti,Amritsar,Punjab',
'Preet Nagar,Amritsar,Punjab',
'Raja Sansi,Amritsar,Punjab',
'Ramdass,Amritsar,Punjab',
'Rayya,Amritsar,Punjab',
'Rs Mills,Amritsar,Punjab',
'S.A.Khan,Amritsar,Punjab',
'Sarangdeo,Amritsar,Punjab',
'Sarhali,Amritsar,Punjab',
'Sathiala,Amritsar,Punjab',
'Sultanwind,Amritsar,Punjab',
'Sur Singh,Amritsar,Punjab',
'Tarsika,Amritsar,Punjab',
'Verka,Amritsar,Punjab',
'Assarapur,Amritsar,Punjab',
'Attari,Amritsar,Punjab',
'Bachiwind,Amritsar,Punjab',
'Mode,Amritsar,Punjab',
'Neshta,Amritsar,Punjab',
'Rangarh,Amritsar,Punjab',
'Shahura,Amritsar,Punjab',
'Lakhuwal,Amritsar,Punjab',
'Bhlaipur Purban,Amritsar,Punjab',
'Dulonangal,Amritsar,Punjab',
'Gagrewal,Amritsar,Punjab',
'Kot Mehtab,Amritsar,Punjab',
'Blair,Amritsar,Punjab',
'Pahuwind,Amritsar,Punjab',
'Singhpura,Amritsar,Punjab',
'Bundala,Amritsar,Punjab',
'Manawala Khurd,Amritsar,Punjab',
'Jhita Kalan,Amritsar,Punjab',
'Sheran Bagga,Amritsar,Punjab',
'Chabhal,Amritsar,Punjab',
'Lalu Ghuman,Amritsar,Punjab',
'Maluwal,Amritsar,Punjab',
'Panjwar,Amritsar,Punjab',
'Gaure Nangal,Amritsar,Punjab',
'Makowal,Amritsar,Punjab',
'Sidhar,Amritsar,Punjab',
'Tera Kalan,Amritsar,Punjab',
'Dhade,Amritsar,Punjab',
'Dhade,Amritsar,Punjab',
'Kotli Dhole Shah,Amritsar,Punjab',
'Ram Diwali Hinduan,Amritsar,Punjab',
'Shahzada,Amritsar,Punjab',
'Chak Sikandar,Amritsar,Punjab',
'Mohan Bhandari,Amritsar,Punjab',
'Sangatpura,Amritsar,Punjab',
'Basarke Gillan,Amritsar,Punjab',
'Mahal,Amritsar,Punjab',
'Bhullar,Amritsar,Punjab',
'Brar,Amritsar,Punjab',
'Chawinda,Amritsar,Punjab',
'Saurian,Amritsar,Punjab',
'Pakhopura,Amritsar,Punjab',
'Jodhe,Amritsar,Punjab',
'Chhidan,Amritsar,Punjab',
'Chicha,Amritsar,Punjab',
'Padri,Amritsar,Punjab',
'Ram Tirath,Amritsar,Punjab',
'Banwallipur,Amritsar,Punjab',
'Jamarai,Amritsar,Punjab',
'Phelke,Amritsar,Punjab',
'Sheron,Amritsar,Punjab',
'Tur,Amritsar,Punjab',
'Hoshiar Nagar,Amritsar,Punjab',
'Munda Pind,Amritsar,Punjab',
'Behal,Amritsar,Punjab',
'Nawapind,Amritsar,Punjab',
'Raipur Kalan,Amritsar,Punjab',
'Rasulpur Kalan,Amritsar,Punjab',
'Talwandi Dogran,Amritsar,Punjab',
'Goindwal,Amritsar,Punjab',
'Jhaner M.Purkhan,Amritsar,Punjab',
'Manak Dheke,Amritsar,Punjab',
'Alipur,Amritsar,Punjab',
'Pringri,Amritsar,Punjab',
'Ratta Gudda,Amritsar,Punjab',
'Sangna,Amritsar,Punjab',
'Dharar,Amritsar,Punjab',
'Mallian,Amritsar,Punjab',
'Ekal Gudda,Amritsar,Punjab',
'Manawala Kalan,Amritsar,Punjab',
'Sarli Kalan,Amritsar,Punjab',
'Sarli Khurd,Amritsar,Punjab',
'Taragarh,Amritsar,Punjab',
'Takhutuchak,Amritsar,Punjab',
'Tangra,Amritsar,Punjab',
'Chuslewar,Amritsar,Punjab',
'Dayal Pura,Amritsar,Punjab',
'Kaisian Kalan,Amritsar,Punjab',
'Majihalal Jai Singh,Amritsar,Punjab',
'Makhi Kalan,Amritsar,Punjab',
'Marjinpura,Amritsar,Punjab',
'Galalipur,Amritsar,Punjab',
'Nandpur,Amritsar,Punjab',
'Sakhira,Amritsar,Punjab',
'Sarhali Mandan,Amritsar,Punjab',
'Shahbazpra,Amritsar,Punjab',
'Sheikh,Amritsar,Punjab',
'Bath,Amritsar,Punjab',
'Deo,Amritsar,Punjab',
'Kallah,Amritsar,Punjab',
'Pakhoke,Amritsar,Punjab',
'Chogawan Rupwali,Amritsar,Punjab',
'Abdal,Amritsar,Punjab',
'Ajaiwali,Amritsar,Punjab',
'Jethuwal,Amritsar,Punjab',
'Talwandi Dasaunda Singh,Amritsar,Punjab',
'Nagoke,Amritsar,Punjab',
'Basarke,Amritsar,Punjab',
'Chhina Bidhi Chand,Amritsar,Punjab',
'Mandar Mathra Bhag,Amritsar,Punjab',
'Mari Megha,Amritsar,Punjab',
'Narli,Amritsar,Punjab',
'Sidhwa,Amritsar,Punjab',
'Algon Khurd,Amritsar,Punjab',
'Bhure Kalan,Amritsar,Punjab',
'Kalia Snbaktra,Amritsar,Punjab',
'Mahmoodpura,Amritsar,Punjab',
'Manawan,Amritsar,Punjab',
'Mastgarh,Amritsar,Punjab',
'Rattoke Gurudwara,Amritsar,Punjab',
'Bhure Nau,Amritsar,Punjab',
'Sidhar Rajputan,Amritsar,Punjab',
'Bhorchi Rajputana,Amritsar,Punjab',
'Butari,Amritsar,Punjab',
'Kaleke,Amritsar,Punjab',
'Lohgarh,Amritsar,Punjab',
'Muchal,Amritsar,Punjab',
'Chatiwind,Amritsar,Punjab',
'Chabha,Amritsar,Punjab',
'Mehma,Amritsar,Punjab',
'Rataul,Amritsar,Punjab',
'Begowal,Amritsar,Punjab',
'Budha The,Amritsar,Punjab',
'Jagdev Bar,Amritsar,Punjab',
'Nag Kalan,Amritsar,Punjab',
'Sham Nagar,Amritsar,Punjab',
'Tarpal,Amritsar,Punjab',
'Chananke,Amritsar,Punjab',
'Mehsampura,Amritsar,Punjab',
'Mehta,Amritsar,Punjab',
'Rajdhan,Amritsar,Punjab',
'Saidoke,Amritsar,Punjab',
'Mohanpura,Amritsar,Punjab',
'Rani Villa,Amritsar,Punjab',
'Sangatpura,Amritsar,Punjab',
'Barwala,Amritsar,Punjab',
'Dubli,Amritsar,Punjab',
'Gariyala,Amritsar,Punjab',
'Mahaneke Jandh,Amritsar,Punjab',
'Shaheed,Amritsar,Punjab',
'Takarpura,Amritsar,Punjab',
'Kakker,Amritsar,Punjab',
'Lopoke,Amritsar,Punjab',
'Mud Khokhar,Amritsar,Punjab',
'Ranian,Amritsar,Punjab',
'Adiwala,Amritsar,Punjab',
'Heir,Amritsar,Punjab',
'Jagdev Kalan,Amritsar,Punjab',
'Mallunangal,Amritsar,Punjab',
'Miran Kot,Amritsar,Punjab',
'Ghonewal,Amritsar,Punjab',
'Chima Bath,Amritsar,Punjab',
'Khojkipur,Amritsar,Punjab',
'Mainwind,Amritsar,Punjab',
'Pheruman,Amritsar,Punjab',
'Uppal,Amritsar,Punjab',
'Chahal,Amritsar,Punjab',
'Nausherha Dhall A,Amritsar,Punjab',
'Cheema Kalan,Amritsar,Punjab',
'Gandiwind,Amritsar,Punjab',
'Dadeha Sahib,Amritsar,Punjab',
'Thatha,Amritsar,Punjab',
'Butter Sivia,Amritsar,Punjab',
'Ghagar Bhana,Amritsar,Punjab',
'Bhuchr Kalan,Amritsar,Punjab',
'Jeowala,Amritsar,Punjab',
'Musse,Amritsar,Punjab',
'Padhir Kalan,Amritsar,Punjab',
'Harike,Amritsar,Punjab',
'Johal Raju Singh,Amritsar,Punjab',
'Kadgill,Amritsar,Punjab',
'Kairon,Amritsar,Punjab',
'Tarn Taran H.O,Amritsar,Punjab',
'Akalgarh Dhupaian,Amritsar,Punjab',
'Dehriwala,Amritsar,Punjab',
'Jabowal,Amritsar,Punjab',
'Mallowal,Amritsar,Punjab',
'Tanel,Amritsar,Punjab',
'Fatehgarh Sukarcharia,Amritsar,Punjab',
'Makhanwindi,Amritsar,Punjab',
'Mudhal,Amritsar,Punjab',
'Nizampura,Amritsar,Punjab',
'Rampura Phul,Bhatinda,Punjab',
'Bahadurpur,Bhatinda,Punjab',
'Gobindpura,Bhatinda,Punjab',
'Kahangarh,Bhatinda,Punjab',
'Kishangarh Saide Singh Wala,Bhatinda,Punjab',
'Kulrian,Bhatinda,Punjab',
'Ranghrial,Bhatinda,Punjab',
'Bajjoana,Bhatinda,Punjab',
'Bathinda Cantt,Bhatinda,Punjab',
'Bathinda H.O,Bhatinda,Punjab',
'Bathnda City,Bhatinda,Punjab',
'Behman Diwana,Bhatinda,Punjab',
'Bhagwan Garh,Bhatinda,Punjab',
'Bhisiana,Bhatinda,Punjab',
'Bhokhra,Bhatinda,Punjab',
'Bhucho Mandi,Bhatinda,Punjab',
'Bibi Wala,Bhatinda,Punjab',
'Bir Behman,Bhatinda,Punjab',
'Burj Mehma,Bhatinda,Punjab',
'Chughe Kalan,Bhatinda,Punjab',
'Dabwali Road,Bhatinda,Punjab',
'Dial Pura Mirja,Bhatinda,Punjab',
'Ganga,Bhatinda,Punjab',
'Gehri Baghi,Bhatinda,Punjab',
'Gndtp Bathinda,Bhatinda,Punjab',
'Goniana Mandi,Bhatinda,Punjab',
'Govind Pura,Bhatinda,Punjab',
'Gulab Garh,Bhatinda,Punjab',
'Guru Sar Sehne Wala,Bhatinda,Punjab',
'Harrai Pur,Bhatinda,Punjab',
'Ind. Estate Bathinda,Bhatinda,Punjab',
'Jai Singh Wala,Bhatinda,Punjab',
'Janda Wala,Bhatinda,Punjab',
'Jassi Pau Wali,Bhatinda,Punjab',
'Jeeda,Bhatinda,Punjab',
'Jhumba,Bhatinda,Punjab',
'Kalyan Sukha,Bhatinda,Punjab',
'Kamla Nehru Colony Bathinda,Bhatinda,Punjab',
'Khemuana,Bhatinda,Punjab',
'Kot Shamir,Bhatinda,Punjab',
'Mehma Bhagwana,Bhatinda,Punjab',
'Mehma Sarja,Bhatinda,Punjab',
'Mehma Sawai,Bhatinda,Punjab',
'Mehta,Bhatinda,Punjab',
'Multania,Bhatinda,Punjab',
'Nai Basti Bathinda,Bhatinda,Punjab',
'Naruana,Bhatinda,Punjab',
'Nasib Pura,Bhatinda,Punjab',
'Nathana,Bhatinda,Punjab',
'Nathpura,Bhatinda,Punjab',
'Nehian Wala,Bhatinda,Punjab',
'Nfl Bathinda,Bhatinda,Punjab',
'Poohla,Bhatinda,Punjab',
'Poohli,Bhatinda,Punjab',
'Railway Colony,Bhatinda,Punjab',
'Sangat,Bhatinda,Punjab',
'Sardargarh,Bhatinda,Punjab',
'Sirki Bazar,Bhatinda,Punjab',
'Teona,Bhatinda,Punjab',
'Virk Kalan,Bhatinda,Punjab',
'Virk Khurd,Bhatinda,Punjab',
'Hamirgarh,Bhatinda,Punjab',
'Kotha Guru,Bhatinda,Punjab',
'Maluka,Bhatinda,Punjab',
'Siryewala,Bhatinda,Punjab',
'Ghanda Bana,Bhatinda,Punjab',
'Gumti Kalan,Bhatinda,Punjab',
'Bhucho Khurd,Bhatinda,Punjab',
'Chak Bakhtu,Bhatinda,Punjab',
'Chak Fateh Sngh Wala,Bhatinda,Punjab',
'Kot Fatta,Bhatinda,Punjab',
'Rai Khanna,Bhatinda,Punjab',
'Sema,Bhatinda,Punjab',
'Tung Wali,Bhatinda,Punjab',
'Bhucho Kalan,Bhatinda,Punjab',
'Balluna,Bhatinda,Punjab',
'Deon,Bhatinda,Punjab',
'Sevian,Bhatinda,Punjab',
'Ablu,Bhatinda,Punjab',
'Akalia Kalan,Bhatinda,Punjab',
'Burj Sema,Bhatinda,Punjab',
'Gehri Bara Singh,Bhatinda,Punjab',
'Mai Sar Khana,Bhatinda,Punjab',
'Maur Kalan,Bhatinda,Punjab',
'Peer Kot,Bhatinda,Punjab',
'Raj Garh Kubbe,Bhatinda,Punjab',
'Ram Nagar,Bhatinda,Punjab',
'Ghuman Kalan,Bhatinda,Punjab',
'Jodhpur Pakhar,Bhatinda,Punjab',
'Kamalu Swaitch,Bhatinda,Punjab',
'Kotli Kalan,Bhatinda,Punjab',
'Kutti Wal Kalan,Bhatinda,Punjab',
'Aklia Jalal,Bhatinda,Punjab',
'Alike,Bhatinda,Punjab',
'Ballian Wali,Bhatinda,Punjab',
'Bhagta Bhai,Bhatinda,Punjab',
'Bhai Rupa,Bhatinda,Punjab',
'Bhaini Kani,Bhatinda,Punjab',
'Bhunder,Bhatinda,Punjab',
'Dhade,Bhatinda,Punjab',
'Dhapali,Bhatinda,Punjab',
'Dial Pura Bhai Ka,Bhatinda,Punjab',
'Dikh,Bhatinda,Punjab',
'Ghtp Lehra Mohabbat,Bhatinda,Punjab',
'Gill Kalan,Bhatinda,Punjab',
'Hakam Singh Wala,Bhatinda,Punjab',
'Jaidan,Bhatinda,Punjab',
'Jalal,Bhatinda,Punjab',
'Jethu Ke,Bhatinda,Punjab',
'Karar Wala,Bhatinda,Punjab',
'Kaur Singh Wala,Bhatinda,Punjab',
'Kotra Koreyan Wala,Bhatinda,Punjab',
'Lehra Bega,Bhatinda,Punjab',
'Lehra Dhur Kot,Bhatinda,Punjab',
'Lehra Khanna,Bhatinda,Punjab',
'Lehra Mohabbat,Bhatinda,Punjab',
'Mandi Kalan,Bhatinda,Punjab',
'Mehraj,Bhatinda,Punjab',
'Phul,Bhatinda,Punjab',
'Pitho,Bhatinda,Punjab',
'Raiya,Bhatinda,Punjab',
'Ramanvas,Bhatinda,Punjab',
'Rampura,Bhatinda,Punjab',
'Rampura Mandi,Bhatinda,Punjab',
'Ramu Wala Jalalka,Bhatinda,Punjab',
'Sailbrah,Bhatinda,Punjab',
'Salabatpura,Bhatinda,Punjab',
'Bandi,Bhatinda,Punjab',
'Chak Attar Singh Wala,Bhatinda,Punjab',
'Chak Ruldu Singh Wala,Bhatinda,Punjab',
'Dunne Wala,Bhatinda,Punjab',
'Gehri Butter,Bhatinda,Punjab',
'Ghudda,Bhatinda,Punjab',
'Jangi Rana,Bhatinda,Punjab',
'Jassi Bag Wali,Bhatinda,Punjab',
'Kishan Pura Kutti,Bhatinda,Punjab',
'Kot Guru,Bhatinda,Punjab',
'Kotli Sabo,Bhatinda,Punjab',
'Nand Garh,Bhatinda,Punjab',
'Pakka Kalan,Bhatinda,Punjab',
'Pathrala,Bhatinda,Punjab',
'Rai Ke Kalan,Bhatinda,Punjab',
'Jaga Ram Tirath,Bhatinda,Punjab',
'Natheha,Bhatinda,Punjab',
'Bangi Rughu,Bhatinda,Punjab',
'Bangi Ruldu,Bhatinda,Punjab',
'Chethewala,Bhatinda,Punjab',
'Dhingar,Bhatinda,Punjab',
'Giana,Bhatinda,Punjab',
'Jiwan Singh Wala,Bhatinda,Punjab',
'Kalal Wala,Bhatinda,Punjab',
'Kaureana,Bhatinda,Punjab',
'Kot Bakhtu,Bhatinda,Punjab',
'Laleana,Bhatinda,Punjab',
'Malkana,Bhatinda,Punjab',
'Sekhpura,Bhatinda,Punjab',
'Sekhu,Bhatinda,Punjab',
'Singo,Bhatinda,Punjab',
'Teona Pujarian,Bhatinda,Punjab',
'Behman Jassa Singh Wala,Bhatinda,Punjab',
'Bhagi Bander,Bhatinda,Punjab',
'Chehlanwali,Bhatinda,Punjab',
'Behniwal,Bhatinda,Punjab',
'Raman,Bhatinda,Punjab',
'Talwandi Sabo,Bhatinda,Punjab',
'Chandbaja,Faridkot,Punjab',
'Ghugiana,Faridkot,Punjab',
'Moranwali,Faridkot,Punjab',
'Arryan Wala,Faridkot,Punjab',
'Baja Khana,Faridkot,Punjab',
'Bargari,Faridkot,Punjab',
'Bhagthala Kalan,Faridkot,Punjab',
'Bhaloor,Faridkot,Punjab',
'Bihle Wala,Faridkot,Punjab',
'Deep Singh Wala,Faridkot,Punjab',
'Dhudhi,Faridkot,Punjab',
'Dhurkot,Faridkot,Punjab',
'Faridkot H.O,Faridkot,Punjab',
'Faridkot Mandi,Faridkot,Punjab',
'Faridkot Sectt,Faridkot,Punjab',
'Ghania Wala,Faridkot,Punjab',
'Golewala,Faridkot,Punjab',
'Gurudwara Jand Sahib,Faridkot,Punjab',
'Janeria,Faridkot,Punjab',
'Jiwan Wala,Faridkot,Punjab',
'Kammiana,Faridkot,Punjab',
'Kanianwali,Faridkot,Punjab',
'Kot Sukhia,Faridkot,Punjab',
'Machaki Kalan,Faridkot,Punjab',
'Malke,Faridkot,Punjab',
'Mehmuana,Faridkot,Punjab',
'Momara,Faridkot,Punjab',
'Pakhi Kalan,Faridkot,Punjab',
'PG Khurd,Faridkot,Punjab',
'Pipli,Faridkot,Punjab',
'Quila Nau,Faridkot,Punjab',
'Rajowala,Faridkot,Punjab',
'Sadiq,Faridkot,Punjab',
'Sandhwan,Faridkot,Punjab',
'Seerwali,Faridkot,Punjab',
'Sibian,Faridkot,Punjab',
'Sukhan Wala,Faridkot,Punjab',
'Tehna,Faridkot,Punjab',
'Bambhia Bhai Ka,Faridkot,Punjab',
'Behbal Khurd,Faridkot,Punjab',
'Bishnandi,Faridkot,Punjab',
'Chaina,Faridkot,Punjab',
'Chandbhan,Faridkot,Punjab',
'Dod,Faridkot,Punjab',
'Fatehgarh Dabri Khana,Faridkot,Punjab',
'Gumti Khurd,Faridkot,Punjab',
'Jaitu,Faridkot,Punjab',
'Jhakhar Wala,Faridkot,Punjab',
'Kasam Bhatti,Faridkot,Punjab',
'Kotli,Faridkot,Punjab',
'Madhak,Faridkot,Punjab',
'Rameana,Faridkot,Punjab',
'Romana Ajit Singh,Faridkot,Punjab',
'Rorikapura,Faridkot,Punjab',
'Saho Ke,Faridkot,Punjab',
'Seda Singh Wala,Faridkot,Punjab',
'Wandar,Faridkot,Punjab',
'Wara Bhai Ka,Faridkot,Punjab',
'Aulakh,Faridkot,Punjab',
'Dhaipai,Faridkot,Punjab',
'Dhilwana Kalan,Faridkot,Punjab',
'Dhimanwali,Faridkot,Punjab',
'Hari Nau,Faridkot,Punjab',
'Koharwala,Faridkot,Punjab',
'Kotkapura,Faridkot,Punjab',
'Machaki Mal Singh,Faridkot,Punjab',
'Matta,Faridkot,Punjab',
'Mour Suhag,Faridkot,Punjab',
'Panj Grain Kalan,Faridkot,Punjab',
'Rb Kotkapura,Faridkot,Punjab',
'Romana Albel Singh,Faridkot,Punjab',
'Sarawan,Faridkot,Punjab',
'Wandar Jatana,Faridkot,Punjab',
'Wara Daraka,Faridkot,Punjab',
'Bharpurgarh,Patiala,Punjab',
'Sidhupur Kalan,Chandigarh,Punjab',
'Bassi,Patiala,Punjab',
'Bazidpur,Patiala,Punjab',
'Bhedwala,Patiala,Punjab',
'Dhundan,Patiala,Punjab',
'Ghumandgarhj,Patiala,Punjab',
'Nandpur Kalaur,Patiala,Punjab',
'Nogawan,Patiala,Punjab',
'Amloh,Patiala,Punjab',
'Kaulgarh,Patiala,Punjab',
'Khanian,Patiala,Punjab',
'Khumna,Patiala,Punjab',
'Machrai Kalan,Patiala,Punjab',
'Naraingarh,Patiala,Punjab',
'Noorpur,Patiala,Punjab',
'Samaspur,Patiala,Punjab',
'Tanda Badha,Patiala,Punjab',
'Tibbi,Patiala,Punjab',
'Mandigobindgarh It,Patiala,Punjab',
'Sanghol,Ludhiana Moffusil,Punjab',
'Fatehgarh Sahib,Patiala,Punjab',
'Kumbh,Patiala,Punjab',
'Mandigobindgarh Rr,Patiala,Punjab',
'RR Sirhind,Patiala,Punjab',
'Salana,Patiala,Punjab',
'Sangatpur Sodhian,Patiala,Punjab',
'Shahpur,Patiala,Punjab',
'Sirhind City,Patiala,Punjab',
'Sirhind,Patiala,Punjab',
'Chunni Kalan,Chandigarh,Punjab',
'Garangan,Chandigarh,Punjab',
'Hawara Kalan,Chandigarh,Punjab',
'Khant,Chandigarh,Punjab',
'Majatri,Chandigarh,Punjab',
'Manela,Chandigarh,Punjab',
'Maneli,Chandigarh,Punjab',
'Panjkoha,Chandigarh,Punjab',
'Ratangarh-1,Chandigarh,Punjab',
'Tajpura,Chandigarh,Punjab',
'Rajindergarh,Patiala,Punjab',
'Sahugarh,Patiala,Punjab',
'Saidpura,Patiala,Punjab',
'Talania,Patiala,Punjab',
'Alamgarh,Ferozpur,Punjab',
'Dod R.S.,Ferozpur,Punjab',
'Khandwala Hazarakhan,Ferozpur,Punjab',
'Rajanwali,Ferozpur,Punjab',
'Abohar Mandi,Ferozpur,Punjab',
'Abohar,Ferozpur,Punjab',
'Bahadur Khera,Ferozpur,Punjab',
'Bahawal Bassi,Ferozpur,Punjab',
'Balluana,Ferozpur,Punjab',
'Bazidpur Bhooma,Ferozpur,Punjab',
'Bhagoo,Ferozpur,Punjab',
'Bhangar Khera,Ferozpur,Punjab',
'Bhangerkhera,Ferozpur,Punjab',
'Bhungal,Ferozpur,Punjab',
'Burj Mohar,Ferozpur,Punjab',
'Chanan Khera,Ferozpur,Punjab',
'D.A.V Campus Abohar,Ferozpur,Punjab',
'Dalmir Khera,Ferozpur,Punjab',
'Danewala,Ferozpur,Punjab',
'Dhab Kokerian,Ferozpur,Punjab',
'Dharampura,Ferozpur,Punjab',
'Dhigan Wali,Ferozpur,Punjab',
'Diwan Khera,Ferozpur,Punjab',
'Dodewala,Ferozpur,Punjab',
'Dutaran Wala,Ferozpur,Punjab',
'Gaddan Dob,Ferozpur,Punjab',
'Giddranwali,Ferozpur,Punjab',
'Gobindgarh,Ferozpur,Punjab',
'Govt Seed Form,Ferozpur,Punjab',
'Gumjal,Ferozpur,Punjab',
'Haripura,Ferozpur,Punjab',
'Himatpura,Ferozpur,Punjab',
'Jandwala Hanumanta,Ferozpur,Punjab',
'Jhurar Khera,Ferozpur,Punjab',
'Jodhpura,Ferozpur,Punjab',
'Kandwala Amarkot,Ferozpur,Punjab',
'Kera Khera,Ferozpur,Punjab',
'Khairpur,Ferozpur,Punjab',
'Khuban,Ferozpur,Punjab',
'Khuyian Sarwar,Ferozpur,Punjab',
'Kikar Khera,Ferozpur,Punjab',
'Killianwali,Ferozpur,Punjab',
'Krishna Nagari Abohar,Ferozpur,Punjab',
'Kular,Ferozpur,Punjab',
'Kundal,Ferozpur,Punjab',
'Mallukpur,Ferozpur,Punjab',
'Maujgarh,Ferozpur,Punjab',
'Mehrana,Ferozpur,Punjab',
'Nai Abadi Abohar,Ferozpur,Punjab',
'New Grain Market Abohar,Ferozpur,Punjab',
'Panjawan Mandal,Ferozpur,Punjab',
'Panjkosi,Ferozpur,Punjab',
'Panniwala Mohala,Ferozpur,Punjab',
'Patti Sadiq,Ferozpur,Punjab',
'Raipura,Ferozpur,Punjab',
'Rajpura,Ferozpur,Punjab',
'Ramgarh,Ferozpur,Punjab',
'Rampura,Ferozpur,Punjab',
'Ramsara,Ferozpur,Punjab',
'Rukanpura,Ferozpur,Punjab',
'Sahitya Sadan Abohar,Ferozpur,Punjab',
'Sappanwali,Ferozpur,Punjab',
'Sardarpura,Ferozpur,Punjab',
'Sayadwala,Ferozpur,Punjab',
'Shergarh,Ferozpur,Punjab',
'Sitto Gunno,Ferozpur,Punjab',
'Tootwala,Ferozpur,Punjab',
'Usman Khera,Ferozpur,Punjab',
'Wahabwala,Ferozpur,Punjab',
'Waryam Khera,Ferozpur,Punjab',
'Arniwala Sheikh Subhan,Ferozpur,Punjab',
'Aslamwala,Ferozpur,Punjab',
'Azamwala,Ferozpur,Punjab',
'Bakainwala,Ferozpur,Punjab',
'Bazidpur Kattianwali,Ferozpur,Punjab',
'Behak,Ferozpur,Punjab',
'Chak Banwala,Ferozpur,Punjab',
'Chak Gulam Rasool Wala,Ferozpur,Punjab',
'Chak Janisar,Ferozpur,Punjab',
'Chak Suterian,Ferozpur,Punjab',
'Chimnewala,Ferozpur,Punjab',
'Churiwala Dhanna,Ferozpur,Punjab',
'Dabwala Kalan,Ferozpur,Punjab',
'Danger Khera,Ferozpur,Punjab',
'Dharangwala,Ferozpur,Punjab',
'Dhippanwali,Ferozpur,Punjab',
'Faridewala,Ferozpur,Punjab',
'Fazilka,Ferozpur,Punjab',
'Gandhi Nagar Fazilka,Ferozpur,Punjab',
'Ghallu,Ferozpur,Punjab',
'Ghattianwali Jattan,Ferozpur,Punjab',
'Hasta Kalan,Ferozpur,Punjab',
'Jandwala,Ferozpur,Punjab',
'Jandwala Bhimeshah,Ferozpur,Punjab',
'Jandwala Mira Sangla,Ferozpur,Punjab',
'Jaurki Andhewali,Ferozpur,Punjab',
'Jhottianwali,Ferozpur,Punjab',
'Jhummianwali,Ferozpur,Punjab',
'Kamal Wala,Ferozpur,Punjab',
'Karni Khera,Ferozpur,Punjab',
'Katehra,Ferozpur,Punjab',
'Kheowali Dhab,Ferozpur,Punjab',
'Khippanwali,Ferozpur,Punjab',
'Khui Khera,Ferozpur,Punjab',
'Kirianwali,Ferozpur,Punjab',
'Kohrianwali,Ferozpur,Punjab',
'Koil Khera,Ferozpur,Punjab',
'Ladhuka,Ferozpur,Punjab',
'Mahuana Bodla,Ferozpur,Punjab',
'Mamu Khera,Ferozpur,Punjab',
'Mandi Amin Ganj,Ferozpur,Punjab',
'Mandi Ladhuka,Ferozpur,Punjab',
'Maujzam,Ferozpur,Punjab',
'Mullianwali,Ferozpur,Punjab',
'Muradwala Dal Singh,Ferozpur,Punjab',
'Nihal Khera,Ferozpur,Punjab',
'Pakkan,Ferozpur,Punjab',
'Patrewala,Ferozpur,Punjab',
'Rana,Ferozpur,Punjab',
'Roop Nagar,Ferozpur,Punjab',
'Sabuana,Ferozpur,Punjab',
'Shajrana,Ferozpur,Punjab',
'Shatirwala,Ferozpur,Punjab',
'Sherewala,Ferozpur,Punjab',
'Tahliwal Bodla,Ferozpur,Punjab',
'Tahliwala Jattan,Ferozpur,Punjab',
'Wool Market Fazilka,Ferozpur,Punjab',
'Lalle,Ferozpur,Punjab',
'Aliwal Lines Ferozepur,Ferozpur,Punjab',
'Bazidpur,Ferozpur,Punjab',
'Bhangali Kalan,Ferozpur,Punjab',
'Bhanger,Ferozpur,Punjab',
'Canal Colony Ferozepur,Ferozpur,Punjab',
'Cantt Railway Station Ferozepu,Ferozpur,Punjab',
'Chak Haraj,Ferozpur,Punjab',
'Chowk Arya Samaj Ferozepur,Ferozpur,Punjab',
'Dastoor Sahib,Ferozpur,Punjab',
'Dhindsa,Ferozpur,Punjab',
'Dhira Patra,Ferozpur,Punjab',
'District Board Ferozpeur,Ferozpur,Punjab',
'Dod R.S,Ferozpur,Punjab',
'Dulchike,Ferozpur,Punjab',
'Fatttuwala,Ferozpur,Punjab',
'Ferozepur City,Ferozpur,Punjab',
'Ferozepur H.O,Ferozpur,Punjab',
'Ferozeshah,Ferozpur,Punjab',
'General Bus Stand Ferozepur,Ferozpur,Punjab',
'Ghall Khurd,Ferozpur,Punjab',
'Hamad,Ferozpur,Punjab',
'Haraj,Ferozpur,Punjab',
'Hazara Singh Wala,Ferozpur,Punjab',
'Itanwali,Ferozpur,Punjab',
'Jhok Tehal Singh,Ferozpur,Punjab',
'Jhoke Harihar,Ferozpur,Punjab',
'Kabbar Wacha,Ferozpur,Punjab',
'Karma,Ferozpur,Punjab',
'Karmuwala,Ferozpur,Punjab',
'Khai Pheme Ki,Ferozpur,Punjab',
'Khunder Uttar,Ferozpur,Punjab',
'Kohar Singh Wala,Ferozpur,Punjab',
'Kot Karor Kalan,Ferozpur,Punjab',
'Lakho Ke Behram,Ferozpur,Punjab',
'Loham,Ferozpur,Punjab',
'Lohgarh,Ferozpur,Punjab',
'Machhi Bugra,Ferozpur,Punjab',
'Mahalam,Ferozpur,Punjab',
'Makhu Gate Ferozepur City,Ferozpur,Punjab',
'Mamdot,Ferozpur,Punjab',
'Mana Singh Wala,Ferozpur,Punjab',
'Maste Ke,Ferozpur,Punjab',
'Mehma,Ferozpur,Punjab',
'Mudki,Ferozpur,Punjab',
'Nurpur Sethan,Ferozpur,Punjab',
'Palla Megha,Ferozpur,Punjab',
'Patel Nagar,Ferozpur,Punjab',
'Piareana,Ferozpur,Punjab',
'Rukna Begu,Ferozpur,Punjab',
'S.B.S Engg Colleger Ferozpeur,Ferozpur,Punjab',
'Sabzi Mandi Ferozepur City,Ferozpur,Punjab',
'Sadar Bazar,Ferozpur,Punjab',
'Saidanwala,Ferozpur,Punjab',
'Sandhe Hasham,Ferozpur,Punjab',
'Sayianwala,Ferozpur,Punjab',
'Shahzadi,Ferozpur,Punjab',
'Shakur,Ferozpur,Punjab',
'Sher Khan Wala,Ferozpur,Punjab',
'Sodhi Nagar,Ferozpur,Punjab',
'Sulhani,Ferozpur,Punjab',
'Thethar Kalan,Ferozpur,Punjab',
'Tibbi Khurd,Ferozpur,Punjab',
'Toot,Ferozpur,Punjab',
'Tumber Bhan,Ferozpur,Punjab',
'Wara Bhai Ka,Ferozpur,Punjab',
'Chhanga Khurd,Ferozpur,Punjab',
'Gill,Ferozpur,Punjab',
'Ratta Khera Pb. Singh,Ferozpur,Punjab',
'Ahmad Dhandi,Ferozpur,Punjab',
'Amir Khas,Ferozpur,Punjab',
'Bagge Ke Uttar,Ferozpur,Punjab',
'Bahamni Wala,Ferozpur,Punjab',
'Bsf Campus Chak Araian,Ferozpur,Punjab',
'Chak Badhoke,Ferozpur,Punjab',
'Chak Kherewala,Ferozpur,Punjab',
'Chak Mahantan Wala,Ferozpur,Punjab',
'Chak Saidoke,Ferozpur,Punjab',
'Changa Rai Uttar,Ferozpur,Punjab',
'Ghubaya,Ferozpur,Punjab',
'Guddar Dhandi,Ferozpur,Punjab',
'Guruharsahai,Ferozpur,Punjab',
'Jalalabad (T),Ferozpur,Punjab',
'Jalalabad (W),Ferozpur,Punjab',
'Jandwala,Ferozpur,Punjab',
'Jhariwala,Ferozpur,Punjab',
'Jiwan Araian,Ferozpur,Punjab',
'Khuranj,Ferozpur,Punjab',
'Ladhuwala Uttar,Ferozpur,Punjab',
'Lamochar Kalan,Ferozpur,Punjab',
'Nukerian,Ferozpur,Punjab',
'Pakka Kale Wala,Ferozpur,Punjab',
'Panje Ke Uttar,Ferozpur,Punjab',
'Pindi,Ferozpur,Punjab',
'Ranjitgarh,Ferozpur,Punjab',
'Ratta Khera,Ferozpur,Punjab',
'Roharian Wali,Ferozpur,Punjab',
'Sharienwala,Ferozpur,Punjab',
'Sohangarh Thakkran,Ferozpur,Punjab',
'Bhinder,Ferozpur,Punjab',
'Datta,Ferozpur,Punjab',
'Kokri Wehniwal,Ferozpur,Punjab',
'Manawan,Ferozpur,Punjab',
'Talwandi Mallian,Ferozpur,Punjab',
'Arif Ke,Ferozpur,Punjab',
'Behak Gujjaran,Ferozpur,Punjab',
'Bharana,Ferozpur,Punjab',
'Chuchak Wind,Ferozpur,Punjab',
'Chugatte Wala,Ferozpur,Punjab',
'Dhandian,Ferozpur,Punjab',
'Dhanna Shahid,Ferozpur,Punjab',
'Fatehgarh Sabrah,Ferozpur,Punjab',
'Jhanda Bagga Purana,Ferozpur,Punjab',
'Jhatre,Ferozpur,Punjab',
'Kamal Wala,Ferozpur,Punjab',
'Kassoana,Ferozpur,Punjab',
'Khosa Dal Singh,Ferozpur,Punjab',
'Longodeva,Ferozpur,Punjab',
'Makhu Canal Colony,Ferozpur,Punjab',
'Makhu,Ferozpur,Punjab',
'Mallanwala,Ferozpur,Punjab',
'Malloke,Ferozpur,Punjab',
'Malluwalia Wala,Ferozpur,Punjab',
'Mansoor Deva,Ferozpur,Punjab',
'Markhai,Ferozpur,Punjab',
'Mehar Singh Wala,Ferozpur,Punjab',
'Mohianwala Kalan,Ferozpur,Punjab',
'Pandori Khatrian,Ferozpur,Punjab',
'Pheroke,Ferozpur,Punjab',
'Pir Mohamad,Ferozpur,Punjab',
'Rukne Wala,Ferozpur,Punjab',
'Sanehar,Ferozpur,Punjab',
'Santuwala,Ferozpur,Punjab',
'Sarhali,Ferozpur,Punjab',
'Sekhwan,Ferozpur,Punjab',
'Shah Abu Bakkar,Ferozpur,Punjab',
'Shahid Gurdas Ram Road Zira,Ferozpur,Punjab',
'Shahwala,Ferozpur,Punjab',
'Shazada Sant Singh,Ferozpur,Punjab',
'Shianpari,Ferozpur,Punjab',
'Sodhiwala,Ferozpur,Punjab',
'Sudh Singh Wala,Ferozpur,Punjab',
'Talwandi Bhai,Ferozpur,Punjab',
'Talwandi Jallekhan,Ferozpur,Punjab',
'Thatha Kishan Singh,Ferozpur,Punjab',
'Valtoha,Ferozpur,Punjab',
'Wakilanwali,Ferozpur,Punjab',
'Wara Waryam Singh,Ferozpur,Punjab',
'Zira,Ferozpur,Punjab',
'Adda Umarpura,Gurdaspur,Punjab',
'Akarpura,Gurdaspur,Punjab',
'Aliwal,Gurdaspur,Punjab',
'Athwal,Gurdaspur,Punjab',
'Bal Purian,Gurdaspur,Punjab',
'Ballarwal7,Gurdaspur,Punjab',
'Barila Kalan,Gurdaspur,Punjab',
'Batala City,Gurdaspur,Punjab',
'Batala H.O,Gurdaspur,Punjab',
'Batala Sugar Mills,Gurdaspur,Punjab',
'Bhadal,Gurdaspur,Punjab',
'Bhagowal,Gurdaspur,Punjab',
'Bhagthana Tulian,Gurdaspur,Punjab',
'Bhandari Gate Batala,Gurdaspur,Punjab',
'Bhangowani,Gurdaspur,Punjab',
'Bhole Ke,Gurdaspur,Punjab',
'Bhoman,Gurdaspur,Punjab',
'Bhullar,Gurdaspur,Punjab',
'Bishankot,Gurdaspur,Punjab',
'Bolewal,Gurdaspur,Punjab',
'Buchenangal,Gurdaspur,Punjab',
'Chahal,Gurdaspur,Punjab',
'Cheema Khudi,Gurdaspur,Punjab',
'Chone,Gurdaspur,Punjab',
'Choudharywal,Gurdaspur,Punjab',
'Dabhanwala Kalan,Gurdaspur,Punjab',
'Dadiala,Gurdaspur,Punjab',
'Dadiala Natt,Gurdaspur,Punjab',
'Dakoha,Gurdaspur,Punjab',
'Dalam,Gurdaspur,Punjab',
'Dalelpur,Gurdaspur,Punjab',
'Dalla Chak,Gurdaspur,Punjab',
'Dargabad,Gurdaspur,Punjab',
'Dbn Road Batala,Gurdaspur,Punjab',
'Dehriwal,Gurdaspur,Punjab',
'Dera Baba Nanak,Gurdaspur,Punjab',
'Dhandal,Gurdaspur,Punjab',
'Dhapai,Gurdaspur,Punjab',
'Dharamkot Bagga,Gurdaspur,Punjab',
'Dharamkot Randhawa,Gurdaspur,Punjab',
'Dharowali,Gurdaspur,Punjab',
'Dhianpur,Gurdaspur,Punjab',
'Dial Garh,Gurdaspur,Punjab',
'Fatehgarh Churian,Gurdaspur,Punjab',
'Fattupur,Gurdaspur,Punjab',
'Fazlabad,Gurdaspur,Punjab',
'Fazula Chak,Gurdaspur,Punjab',
'G S T C Batala,Gurdaspur,Punjab',
'G T Road Batala,Gurdaspur,Punjab',
'Gagowali,Gurdaspur,Punjab',
'Ghanie Ke Banger,Gurdaspur,Punjab',
'Ghoga,Gurdaspur,Punjab',
'Ghuman Kalan,Gurdaspur,Punjab',
'Gpt Batala,Gurdaspur,Punjab',
'Gujjarpura,Gurdaspur,Punjab',
'Guru Nanak Nagar,Gurdaspur,Punjab',
'Hakimpur,Gurdaspur,Punjab',
'Hardo Jhande,Gurdaspur,Punjab',
'Hardorwal,Gurdaspur,Punjab',
'Harpura Dhandoi,Gurdaspur,Punjab',
'Haruwal -e,Gurdaspur,Punjab',
'Industrial Estate Batala,Gurdaspur,Punjab',
'Jaito Sarja,Gurdaspur,Punjab',
'Jaura Singha,Gurdaspur,Punjab',
'Kala Afgana,Gurdaspur,Punjab',
'Kalanaur,Gurdaspur,Punjab',
'Kandila,Gurdaspur,Punjab',
'Kastiwal,Gurdaspur,Punjab',
'Khaira,Gurdaspur,Punjab',
'Khojala,Gurdaspur,Punjab',
'Khokhar Faujjian,Gurdaspur,Punjab',
'Khushalpur,Gurdaspur,Punjab',
'Kishankot,Gurdaspur,Punjab',
'Kot Todarmal,Gurdaspur,Punjab',
'Kotli Surat Malhi,Gurdaspur,Punjab',
'Krishna Nagar Batala,Gurdaspur,Punjab',
'Ladha Mundha,Gurdaspur,Punjab',
'Lakhan Kalan,Gurdaspur,Punjab',
'Leel Kalan,Gurdaspur,Punjab',
'Machrai,Gurdaspur,Punjab',
'Man,Gurdaspur,Punjab',
'Marar,Gurdaspur,Punjab',
'Mari Buchian,Gurdaspur,Punjab',
'Mari Panwan,Gurdaspur,Punjab',
'Mari Tanda,Gurdaspur,Punjab',
'Massania,Gurdaspur,Punjab',
'Mirzajan,Gurdaspur,Punjab',
'Nasarke,Gurdaspur,Punjab',
'Naushera Majja Singh,Gurdaspur,Punjab',
'Nehru Gate Batala,Gurdaspur,Punjab',
'Padhe,Gurdaspur,Punjab',
'Pakiwan,Gurdaspur,Punjab',
'Paracha,Gurdaspur,Punjab',
'Parnjgarian,Gurdaspur,Punjab',
'Parowal,Gurdaspur,Punjab',
'Passanwal,Gurdaspur,Punjab',
'Qadian,Gurdaspur,Punjab',
'Qila Lal Singh,Gurdaspur,Punjab',
'Rai Chak,Gurdaspur,Punjab',
'Railway Road Batala,Gurdaspur,Punjab',
'Raimal,Gurdaspur,Punjab',
'Rajeke,Gurdaspur,Punjab',
'Ranger Nangal,Gurdaspur,Punjab',
'Rattar Chattar,Gurdaspur,Punjab',
'Riali,Gurdaspur,Punjab',
'Rudiana,Gurdaspur,Punjab',
'Samrai,Gurdaspur,Punjab',
'Sarchur,Gurdaspur,Punjab',
'Sarupwali,Gurdaspur,Punjab',
'Sarwali,Gurdaspur,Punjab',
'Satkoha,Gurdaspur,Punjab',
'Seikhwan,Gurdaspur,Punjab',
'Shahpur Goraya,Gurdaspur,Punjab',
'Shahpur Jajan,Gurdaspur,Punjab',
'Shahzada,Gurdaspur,Punjab',
'Shankarpura,Gurdaspur,Punjab',
'Shikar,Gurdaspur,Punjab',
'Singhpura,Gurdaspur,Punjab',
'Sirah,Gurdaspur,Punjab',
'Srihargobindpur,Gurdaspur,Punjab',
'Sunaya,Gurdaspur,Punjab',
'Talwandi Lal Singh,Gurdaspur,Punjab',
'Talwandi Rama,Gurdaspur,Punjab',
'Teja Kalan,Gurdaspur,Punjab',
'Udhanwal,Gurdaspur,Punjab',
'Udhowali Khurd,Gurdaspur,Punjab',
'Urban Estate Batala,Gurdaspur,Punjab',
'Villa Baijju,Gurdaspur,Punjab',
'Villa Teja,Gurdaspur,Punjab',
'Wadala Banger,Gurdaspur,Punjab',
'Wadala Granthia,Gurdaspur,Punjab',
'Dunera,Gurdaspur,Punjab',
'Bhopar Saidan,Gurdaspur,Punjab',
'Alma,Gurdaspur,Punjab',
'Aulakh Kalan,Gurdaspur,Punjab',
'Awankha,Gurdaspur,Punjab',
'Babehali,Gurdaspur,Punjab',
'Babri,Gurdaspur,Punjab',
'Babri Jiwan Wal,Gurdaspur,Punjab',
'Bahadurpur Rajoa,Gurdaspur,Punjab',
'Baknaur,Gurdaspur,Punjab',
'Basrai,Gurdaspur,Punjab',
'Behrampur,Gurdaspur,Punjab',
'Beri,Gurdaspur,Punjab',
'Bhaini Mian Khan,Gurdaspur,Punjab',
'Bham,Gurdaspur,Punjab',
'Bhambri,Gurdaspur,Punjab',
'Bharath,Gurdaspur,Punjab',
'Bharath,Gurdaspur,Punjab',
'Bharial,Gurdaspur,Punjab',
'Bhatoya,Gurdaspur,Punjab',
'Bhattian,Gurdaspur,Punjab',
'Bhojraj,Gurdaspur,Punjab',
'Bhumbli,Gurdaspur,Punjab',
'Bianpur-e,Gurdaspur,Punjab',
'Chak Sharif,Gurdaspur,Punjab',
'Chaunta,Gurdaspur,Punjab',
'Chhalle,Gurdaspur,Punjab',
'Chore Sidhwan,Gurdaspur,Punjab',
'Dholowal,Gurdaspur,Punjab',
'Dodwan,Gurdaspur,Punjab',
'Dorangla,Gurdaspur,Punjab',
'Dostpur,Gurdaspur,Punjab',
'Dugri,Gurdaspur,Punjab',
'Fateh Nangal,Gurdaspur,Punjab',
'Galhri,Gurdaspur,Punjab',
'Gandhi Gate Dinanagar,Gurdaspur,Punjab',
'Gazikot,Gurdaspur,Punjab',
'Gaznipur -e,Gurdaspur,Punjab',
'Ghoi,Gurdaspur,Punjab',
'Ghorewah,Gurdaspur,Punjab',
'Gurdas Nangal,Gurdaspur,Punjab',
'Gurdaspur City,Gurdaspur,Punjab',
'Gurdaspur H.O,Gurdaspur,Punjab',
'Gurdaspur Kutchery,Gurdaspur,Punjab',
'Gurdaspur Mandi,Gurdaspur,Punjab',
'Habit Pindi -e,Gurdaspur,Punjab',
'Harchowal,Gurdaspur,Punjab',
'Hardo Chhani,Gurdaspur,Punjab',
'Hayat Nagar,Gurdaspur,Punjab',
'Hemrajpur,Gurdaspur,Punjab',
'Islampur,Gurdaspur,Punjab',
'Jagowal Bet,Gurdaspur,Punjab',
'Jangal,Gurdaspur,Punjab',
'Jaura Chhittran,Gurdaspur,Punjab',
'Jhabkra,Gurdaspur,Punjab',
'Jharoli,Gurdaspur,Punjab',
'Kahnuwan,Gurdaspur,Punjab',
'Kala Bala -e,Gurdaspur,Punjab',
'Kala Nangal,Gurdaspur,Punjab',
'Kaler Kalan,Gurdaspur,Punjab',
'Kalichpur-e,Gurdaspur,Punjab',
'Kalyanpur,Gurdaspur,Punjab',
'Kathlaur,Gurdaspur,Punjab',
'Khojepur,Gurdaspur,Punjab',
'Khunda,Gurdaspur,Punjab',
'Kot Santokh Rai,Gurdaspur,Punjab',
'Kotli Harchandan,Gurdaspur,Punjab',
'Kotli Sainian,Gurdaspur,Punjab',
'Lahri Gujran,Gurdaspur,Punjab',
'Lakhanpal,Gurdaspur,Punjab',
'Langah,Gurdaspur,Punjab',
'Magar Mudian,Gurdaspur,Punjab',
'Mullanwal,Gurdaspur,Punjab',
'Nainakot,Gurdaspur,Punjab',
'Nanowal Jinder,Gurdaspur,Punjab',
'Pakhariwal,Gurdaspur,Punjab',
'Pandori Bainsan,Gurdaspur,Punjab',
'Paniar,Gurdaspur,Punjab',
'Parbodh Chander Nagar,Gurdaspur,Punjab',
'Parmanand,Gurdaspur,Punjab',
'Pindarori,Gurdaspur,Punjab',
'Rattangarh,Gurdaspur,Punjab',
'Sahaura Khurd,Gurdaspur,Punjab',
'Sahowal,Gurdaspur,Punjab',
'Saidipur,Gurdaspur,Punjab',
'Saidowal Kalan,Gurdaspur,Punjab',
'Saidowal Khurd,Gurdaspur,Punjab',
'Sale Chak,Gurdaspur,Punjab',
'Sidhwan,Gurdaspur,Punjab',
'Sohal,Gurdaspur,Punjab',
'Talibpur Pandori,Gurdaspur,Punjab',
'Taragarh,Gurdaspur,Punjab',
'Tibber,Gurdaspur,Punjab',
'Tibri,Gurdaspur,Punjab',
'Tugalwala,Gurdaspur,Punjab',
'Zaffarwal,Gurdaspur,Punjab',
'Abrol Nagar Pathankot,Gurdaspur,Punjab',
'Badhani,Gurdaspur,Punjab',
'Bamial,Gurdaspur,Punjab',
'Beacon Pathankot,Gurdaspur,Punjab',
'Bhabber,Gurdaspur,Punjab',
'Bhanguri,Gurdaspur,Punjab',
'Bharoli,Gurdaspur,Punjab',
'Bhattwan,Gurdaspur,Punjab',
'Bhoa,Gurdaspur,Punjab',
'Chakkar,Gurdaspur,Punjab',
'Chashma,Gurdaspur,Punjab',
'Civil Court Pathankot,Gurdaspur,Punjab',
'Dalhousie Road Pathankot,Gurdaspur,Punjab',
'Datial,Gurdaspur,Punjab',
'Dhangu Road Pathankot,Gurdaspur,Punjab',
'Farida Nagar,Gurdaspur,Punjab',
'Fatehpur,Gurdaspur,Punjab',
'Ferozepur Kalan,Gurdaspur,Punjab',
'Gharota,Gurdaspur,Punjab',
'Ghiala,Gurdaspur,Punjab',
'Gho,Gurdaspur,Punjab',
'Gurdaspur Road Pathankot,Gurdaspur,Punjab',
'Gurrah,Gurdaspur,Punjab',
'Hara,Gurdaspur,Punjab',
'Haryal,Gurdaspur,Punjab',
'Jandwal,Gurdaspur,Punjab',
'Janial,Gurdaspur,Punjab',
'Jhakholari,Gurdaspur,Punjab',
'Karoli,Gurdaspur,Punjab',
'Kaunterpur,Gurdaspur,Punjab',
'Khanpur Chowk Pathankot,Gurdaspur,Punjab',
'Khojeke Chak,Gurdaspur,Punjab',
'Kiri Khurd,Gurdaspur,Punjab',
'Kot,Gurdaspur,Punjab',
'Lahroon,Gurdaspur,Punjab',
'Madhopur,Gurdaspur,Punjab',
'Malakpur,Gurdaspur,Punjab',
'Mamoon,Gurdaspur,Punjab',
'Marara,Gurdaspur,Punjab',
'Mirthal,Gurdaspur,Punjab',
'Mission Road Pathankot,Gurdaspur,Punjab',
'Model Colony Pathankot,Gurdaspur,Punjab',
'Nangal,Gurdaspur,Punjab',
'Narangpur,Gurdaspur,Punjab',
'Narot Mehra,Gurdaspur,Punjab',
'Naushehra Nal Bandan,Gurdaspur,Punjab',
'Pathankot,Gurdaspur,Punjab',
'Pinjore,Gurdaspur,Punjab',
'Rampur,Gurdaspur,Punjab',
'Sarna,Gurdaspur,Punjab',
'Sarti,Gurdaspur,Punjab',
'Shahpur Kandi,Gurdaspur,Punjab',
'Shahpur Kandi Township,Gurdaspur,Punjab',
'Sujanpur,Gurdaspur,Punjab',
'Sunder Chak,Gurdaspur,Punjab',
'Syonti,Gurdaspur,Punjab',
'Tharial,Gurdaspur,Punjab',
'Trihari,Gurdaspur,Punjab',
'Uchathara,Gurdaspur,Punjab',
'Dhariwal,Gurdaspur,Punjab',
'Dharkalan,Gurdaspur,Punjab',
'Dinanagar,Gurdaspur,Punjab',
'Narot Jailmal Singh,Gurdaspur,Punjab',
'Ghoman,Gurdaspur,Punjab',
'Bhatrana,Hoshiarpur,Punjab',
'Lehli Kalan,Hoshiarpur,Punjab',
'Dasuya H.O,Hoshiarpur,Punjab',
'Pandori Bawa Dass,Hoshiarpur,Punjab',
'Bajwara,Hoshiarpur,Punjab',
'Barian Kalan,Hoshiarpur,Punjab',
'Fateh Pur Khurd,Hoshiarpur,Punjab',
'Fateh Pur Kothi,Hoshiarpur,Punjab',
'Fatehgarh Niara,Hoshiarpur,Punjab',
'Gajjar,Hoshiarpur,Punjab',
'Abdulapur,Hoshiarpur,Punjab',
'Adamwal,Hoshiarpur,Punjab',
'Ahrana Klaln,Hoshiarpur,Punjab',
'Aiman Jattan,Hoshiarpur,Punjab',
'Ajnoha,Hoshiarpur,Punjab',
'Ajram,Hoshiarpur,Punjab',
'Alampur,Hoshiarpur,Punjab',
'Ambala Jattan,Hoshiarpur,Punjab',
'Amroh,Hoshiarpur,Punjab',
'Argowal,Hoshiarpur,Punjab',
'Attowal,Hoshiarpur,Punjab',
'Bachhohi,Hoshiarpur,Punjab',
'Baddon,Hoshiarpur,Punjab',
'Badesron,Hoshiarpur,Punjab',
'Badla,Hoshiarpur,Punjab',
'Badla,Hoshiarpur,Punjab',
'Badla Mahi,Hoshiarpur,Punjab',
'Baghpur,Hoshiarpur,Punjab',
'Bahadarpur Bahian,Hoshiarpur,Punjab',
'Bahadurpur Chowk,Hoshiarpur,Punjab',
'Bahera,Hoshiarpur,Punjab',
'Bahowal,Hoshiarpur,Punjab',
'Bahtiwal,Hoshiarpur,Punjab',
'Baich,Hoshiarpur,Punjab',
'Bains Awan,Hoshiarpur,Punjab',
'Bainstani Klan,Hoshiarpur,Punjab',
'Bajja Chak,Hoshiarpur,Punjab',
'Bajrawar,Hoshiarpur,Punjab',
'Bariana,Hoshiarpur,Punjab',
'Bariowal,Hoshiarpur,Punjab',
'Basiala,Hoshiarpur,Punjab',
'Bassi Ballo,Hoshiarpur,Punjab',
'Bassi Daulat Khan,Hoshiarpur,Punjab',
'Bassi Gulaam Hussain,Hoshiarpur,Punjab',
'Bassi Jalal Khan,Hoshiarpur,Punjab',
'Bassi Kalan,Hoshiarpur,Punjab',
'Bassi Purani,Hoshiarpur,Punjab',
'Bassi Wajid,Hoshiarpur,Punjab',
'Bathian Brahmnan,Hoshiarpur,Punjab',
'Beghampur Jandiala,Hoshiarpur,Punjab',
'Behbalmanj,Hoshiarpur,Punjab',
'Behbalpur,Hoshiarpur,Punjab',
'Behkushala,Hoshiarpur,Punjab',
'Behlakhan,Hoshiarpur,Punjab',
'Bershah,Hoshiarpur,Punjab',
'Bhabwnaur,Hoshiarpur,Punjab',
'Bhagowal,Hoshiarpur,Punjab',
'Bhagran,Hoshiarpur,Punjab',
'Bham,Hoshiarpur,Punjab',
'Bhambotar,Hoshiarpur,Punjab',
'Bhangala,Hoshiarpur,Punjab',
'Bhanna,Hoshiarpur,Punjab',
'Bhanowal,Hoshiarpur,Punjab',
'Bharowal,Hoshiarpur,Punjab',
'Bharwain Road,Hoshiarpur,Punjab',
'Bhater,Hoshiarpur,Punjab',
'Bhawanipur,Hoshiarpur,Punjab',
'Bhera,Hoshiarpur,Punjab',
'Bhikhowal,Hoshiarpur,Punjab',
'Bhilowal,Hoshiarpur,Punjab',
'Bhunga,Hoshiarpur,Punjab',
'Bhungarani,Hoshiarpur,Punjab',
'Bihala,Hoshiarpur,Punjab',
'Binewal,Hoshiarpur,Punjab',
'Binjon,Hoshiarpur,Punjab',
'Birampur,Hoshiarpur,Punjab',
'Bodal Garna Sahib,Hoshiarpur,Punjab',
'Bohan,Hoshiarpur,Punjab',
'Bombeli,Hoshiarpur,Punjab',
'Bora,Hoshiarpur,Punjab',
'Bringli,Hoshiarpur,Punjab',
'Budhawar,Hoshiarpur,Punjab',
'Budhipind,Hoshiarpur,Punjab',
'Bulhowal,Hoshiarpur,Punjab',
'Chabbewal,Hoshiarpur,Punjab',
'Chagran,Hoshiarpur,Punjab',
'Chahalpur,Hoshiarpur,Punjab',
'Chak Sadu,Hoshiarpur,Punjab',
'Chak Singha,Hoshiarpur,Punjab',
'Chan Ladian,Hoshiarpur,Punjab',
'Chang Basoa,Hoshiarpur,Punjab',
'Changala,Hoshiarpur,Punjab',
'Channaur,Hoshiarpur,Punjab',
'Chathial Khurd,Hoshiarpur,Punjab',
'Chautala,Hoshiarpur,Punjab',
'Chipra,Hoshiarpur,Punjab',
'Chohal,Hoshiarpur,Punjab',
'Choki Patiari,Hoshiarpur,Punjab',
'Dada,Hoshiarpur,Punjab',
'Daddar,Hoshiarpur,Punjab',
'Dadhe Fateh Singh,Hoshiarpur,Punjab',
'Dadial,Hoshiarpur,Punjab',
'Dadupur Garoa,Hoshiarpur,Punjab',
'Dadyal,Hoshiarpur,Punjab',
'Daffar,Hoshiarpur,Punjab',
'Dagana Klan,Hoshiarpur,Punjab',
'Daggan,Hoshiarpur,Punjab',
'Dandoh,Hoshiarpur,Punjab',
'Darapur,Hoshiarpur,Punjab',
'Datarpur,Hoshiarpur,Punjab',
'Degham,Hoshiarpur,Punjab',
'Dehri Wal,Hoshiarpur,Punjab',
'Denowal Klan,Hoshiarpur,Punjab',
'Deopur,Hoshiarpur,Punjab',
'Dhada Klan,Hoshiarpur,Punjab',
'Dhakkowal,Hoshiarpur,Punjab',
'Dhamai,Hoshiarpur,Punjab',
'Dhamian,Hoshiarpur,Punjab',
'Dhanoa,Hoshiarpur,Punjab',
'Dharampur,Hoshiarpur,Punjab',
'Dhola Khera,Hoshiarpur,Punjab',
'Dholwaha,Hoshiarpur,Punjab',
'Dhoot Kalan,Hoshiarpur,Punjab',
'Dhuggan Kalan,Hoshiarpur,Punjab',
'Dihana,Hoshiarpur,Punjab',
'Factory Area Chohal,Hoshiarpur,Punjab',
'Fatehpur,Hoshiarpur,Punjab',
'Fatehpur Bhatlan,Hoshiarpur,Punjab',
'Gandhowal,Hoshiarpur,Punjab',
'Ganeshpur Bharta,Hoshiarpur,Punjab',
'Gardhiwala,Hoshiarpur,Punjab',
'Garhi Mansowal,Hoshiarpur,Punjab',
'Garhi Matton,Hoshiarpur,Punjab',
'Garhshanker,Hoshiarpur,Punjab',
'Gaushala Bazar,Hoshiarpur,Punjab',
'Gera,Hoshiarpur,Punjab',
'Ghaghwal,Hoshiarpur,Punjab',
'Ghoghra,Hoshiarpur,Punjab',
'Ghorewaha,Hoshiarpur,Punjab',
'Gignowal,Hoshiarpur,Punjab',
'Gobindpur Khun Khun,Hoshiarpur,Punjab',
'Gondpur,Hoshiarpur,Punjab',
'Government College,Hoshiarpur,Punjab',
'Haibowal,Hoshiarpur,Punjab',
'Hajipur,Hoshiarpur,Punjab',
'Hakumatpur,Hoshiarpur,Punjab',
'Handwal,Hoshiarpur,Punjab',
'Hardo Khund Pur,Hoshiarpur,Punjab',
'Hardo Neknama,Hoshiarpur,Punjab',
'Hardokhanpur,Hoshiarpur,Punjab',
'Hariana,Hoshiarpur,Punjab',
'Harse Mansar,Hoshiarpur,Punjab',
'Harsipind,Hoshiarpur,Punjab',
'Harta,Hoshiarpur,Punjab',
'Hookran,Hoshiarpur,Punjab',
'Hoshiarpur City,Hoshiarpur,Punjab',
'Hoshiarpur H.O,Hoshiarpur,Punjab',
'Hoshiarpur Kalota,Hoshiarpur,Punjab',
'Hussain Pur Lalowal,Hoshiarpur,Punjab',
'Ibrahimpur,Hoshiarpur,Punjab',
'Jahana Khelan,Hoshiarpur,Punjab',
'Jaijon,Hoshiarpur,Punjab',
'Jajja,Hoshiarpur,Punjab',
'Jalalpur,Hoshiarpur,Punjab',
'Jallowal Khanoor,Hoshiarpur,Punjab',
'Jalota,Hoshiarpur,Punjab',
'Janauri,Hoshiarpur,Punjab',
'Jandaur,Hoshiarpur,Punjab',
'Jandiala,Hoshiarpur,Punjab',
'Jandoli,Hoshiarpur,Punjab',
'Jandwal,Hoshiarpur,Punjab',
'Jangliana,Hoshiarpur,Punjab',
'Jassowal,Hoshiarpur,Punjab',
'Jaura,Hoshiarpur,Punjab',
'Jeewanpur Jattan,Hoshiarpur,Punjab',
'Jhawan,Hoshiarpur,Punjab',
'Jhingar Kalan,Hoshiarpur,Punjab',
'Johal,Hoshiarpur,Punjab',
'Kadiana,Hoshiarpur,Punjab',
'Kahri,Hoshiarpur,Punjab',
'Kakkon,Hoshiarpur,Punjab',
'Kalewal,Hoshiarpur,Punjab',
'Kalewal Bhagtan,Hoshiarpur,Punjab',
'Kaluwahar,Hoshiarpur,Punjab',
'Kamahi Devi,Hoshiarpur,Punjab',
'Kamalpur,Hoshiarpur,Punjab',
'Kandhala Jattan,Hoshiarpur,Punjab',
'Kandhala Sheikhan,Hoshiarpur,Punjab',
'Kandhali Narangpur,Hoshiarpur,Punjab',
'Karari,Hoshiarpur,Punjab',
'Kathe Adhkare,Hoshiarpur,Punjab',
'Khadiala,Hoshiarpur,Punjab',
'Khanpur,Hoshiarpur,Punjab',
'Khanpur,Hoshiarpur,Punjab',
'Khanpur Latifpur,Hoshiarpur,Punjab',
'Kharar Achharwal,Hoshiarpur,Punjab',
'Kharaudi,Hoshiarpur,Punjab',
'Kharkan Camp,Hoshiarpur,Punjab',
'Khera,Hoshiarpur,Punjab',
'Khiala Bulanda,Hoshiarpur,Punjab',
'Khnoura,Hoshiarpur,Punjab',
'Khudda,Hoshiarpur,Punjab',
'Khunkhun Kalan,Hoshiarpur,Punjab',
'Kitna,Hoshiarpur,Punjab',
'Koi,Hoshiarpur,Punjab',
'Kot Abdul Khaliq,Hoshiarpur,Punjab',
'Kotfathui,Hoshiarpur,Punjab',
'Kotlanaudh Singh,Hoshiarpur,Punjab',
'Kotli Khas,Hoshiarpur,Punjab',
'Kotmaira,Hoshiarpur,Punjab',
'Kukanet,Hoshiarpur,Punjab',
'Kukkran,Hoshiarpur,Punjab',
'Kurala Kalan,Hoshiarpur,Punjab',
'Lachowal,Hoshiarpur,Punjab',
'Lakhinder,Hoshiarpur,Punjab',
'Laksian,Hoshiarpur,Punjab',
'Lalwan,Hoshiarpur,Punjab',
'Lambra Kangri,Hoshiarpur,Punjab',
'Lamin Pandori,Hoshiarpur,Punjab',
'Langeri,Hoshiarpur,Punjab',
'Mahilpur,Hoshiarpur,Punjab',
'Mahota,Hoshiarpur,Punjab',
'Maili,Hoshiarpur,Punjab',
'Makhsoospur,Hoshiarpur,Punjab',
'Manakdheri,Hoshiarpur,Punjab',
'Mananhana,Hoshiarpur,Punjab',
'Mand Pandher,Hoshiarpur,Punjab',
'Mandial,Hoshiarpur,Punjab',
'Manguwalnari,Hoshiarpur,Punjab',
'Manolian,Hoshiarpur,Punjab',
'Mansoorpur,Hoshiarpur,Punjab',
'Maseet Pal Kot,Hoshiarpur,Punjab',
'Mazara Dingrian,Hoshiarpur,Punjab',
'Meghowal,Hoshiarpur,Punjab',
'Meghowal Ganjyan,Hoshiarpur,Punjab',
'Mehand Wani,Hoshiarpur,Punjab',
'Mehlanwali,Hoshiarpur,Punjab',
'Mehngarwal,Hoshiarpur,Punjab',
'Mehngarwal Doaba,Hoshiarpur,Punjab',
'Mehtabpur,Hoshiarpur,Punjab',
'Mehtiana,Hoshiarpur,Punjab',
'Miani,Hoshiarpur,Punjab',
'Model Town,Hoshiarpur,Punjab',
'Moela Wahidpur,Hoshiarpur,Punjab',
'Mona Klan,Hoshiarpur,Punjab',
'Moranwali,Hoshiarpur,Punjab',
'Muggowal,Hoshiarpur,Punjab',
'Mukerian,Hoshiarpur,Punjab',
'Mukhliana,Hoshiarpur,Punjab',
'Munak Kalan,Hoshiarpur,Punjab',
'Mundian Jattan,Hoshiarpur,Punjab',
'Muradpur Naryal,Hoshiarpur,Punjab',
'Musahibpur,Hoshiarpur,Punjab',
'Mustapur,Hoshiarpur,Punjab',
'Nadalon,Hoshiarpur,Punjab',
'Nainowal Jattan,Hoshiarpur,Punjab',
'Nainwan,Hoshiarpur,Punjab',
'Nandachaur,Hoshiarpur,Punjab',
'Nangal Bihalan,Hoshiarpur,Punjab',
'Nangal Kalan,Hoshiarpur,Punjab',
'Nangal Khunga,Hoshiarpur,Punjab',
'Nangal Khurd,Hoshiarpur,Punjab',
'Nangal Shahidan,Hoshiarpur,Punjab',
'Nara,Hoshiarpur,Punjab',
'Narangpur,Hoshiarpur,Punjab',
'Naru Nangal,Hoshiarpur,Punjab',
'Nasrala,Hoshiarpur,Punjab',
'Nathupur,Hoshiarpur,Punjab',
'Naushehara,Hoshiarpur,Punjab',
'Pach Nangal Khushalpur,Hoshiarpur,Punjab',
'Paddi Sura Singh,Hoshiarpur,Punjab',
'Padrana,Hoshiarpur,Punjab',
'Pajjodeotta,Hoshiarpur,Punjab',
'Pakhowal,Hoshiarpur,Punjab',
'Paldi,Hoshiarpur,Punjab',
'Pandori Ganga Singh,Hoshiarpur,Punjab',
'Pandori Atwal,Hoshiarpur,Punjab',
'Pandori Bibi,Hoshiarpur,Punjab',
'Pandori Ladha Singh,Hoshiarpur,Punjab',
'Pandori Phagurian,Hoshiarpur,Punjab',
'Pandori Rajputan,Hoshiarpur,Punjab',
'Pandorikad,Hoshiarpur,Punjab',
'Panjaura,Hoshiarpur,Punjab',
'Panwan,Hoshiarpur,Punjab',
'Parika,Hoshiarpur,Punjab',
'Parsowal,Hoshiarpur,Punjab',
'Passi Kandi,Hoshiarpur,Punjab',
'Patial,Hoshiarpur,Punjab',
'Patti,Hoshiarpur,Punjab',
'Phambian,Hoshiarpur,Punjab',
'Phuglana,Hoshiarpur,Punjab',
'Piplanwala,Hoshiarpur,Punjab',
'Posi,Hoshiarpur,Punjab',
'Purhiran,Hoshiarpur,Punjab',
'Railway Road,Hoshiarpur,Punjab',
'Rajpur Bhayian,Hoshiarpur,Punjab',
'Rajpur Gahot,Hoshiarpur,Punjab',
'Rajwal,Hoshiarpur,Punjab',
'Ram Colony Camp,Hoshiarpur,Punjab',
'Ramgarh Sikri,Hoshiarpur,Punjab',
'Rampur Bilron,Hoshiarpur,Punjab',
'Rampur Haler,Hoshiarpur,Punjab',
'Rampur Jhanjowal,Hoshiarpur,Punjab',
'Ranipind,Hoshiarpur,Punjab',
'Ror Mazara,Hoshiarpur,Punjab',
'Rupowal,Hoshiarpur,Punjab',
'Sadhu Ashram,Hoshiarpur,Punjab',
'Safdarpur,Hoshiarpur,Punjab',
'Saggran,Hoshiarpur,Punjab',
'Sahri,Hoshiarpur,Punjab',
'Saidpur,Hoshiarpur,Punjab',
'Saila Kalan,Hoshiarpur,Punjab',
'Saila Khurd,Hoshiarpur,Punjab',
'Sakruli,Hoshiarpur,Punjab',
'Saleempur,Hoshiarpur,Punjab',
'Saleempur,Hoshiarpur,Punjab',
'Salempur,Hoshiarpur,Punjab',
'Sandhra,Hoshiarpur,Punjab',
'Sandhra Sodhian,Hoshiarpur,Punjab',
'Sango Katrala,Hoshiarpur,Punjab',
'Sansarpur,Hoshiarpur,Punjab',
'Sarangwal,Hoshiarpur,Punjab',
'Sarhala Kalan,Hoshiarpur,Punjab',
'Sarhala Khurd,Hoshiarpur,Punjab',
'Sarhala Mundian,Hoshiarpur,Punjab',
'Sariana,Hoshiarpur,Punjab',
'Sasoli,Hoshiarpur,Punjab',
'Sataur,Hoshiarpur,Punjab',
'Satnaur,Hoshiarpur,Punjab',
'Seeprian,Hoshiarpur,Punjab',
'Sham Chaurasi,Hoshiarpur,Punjab',
'Shergarh,Hoshiarpur,Punjab',
'Sikri,Hoshiarpur,Punjab',
'Singhpur,Hoshiarpur,Punjab',
'Soos,Hoshiarpur,Punjab',
'Suni,Hoshiarpur,Punjab',
'Tahli,Hoshiarpur,Punjab',
'Talwandi Arayan,Hoshiarpur,Punjab',
'Talwandi Didian,Hoshiarpur,Punjab',
'Talwandi Sallan,Hoshiarpur,Punjab',
'Talwara Township,Hoshiarpur,Punjab',
'Talwara Village,Hoshiarpur,Punjab',
'Tanda Ram Sahai,Hoshiarpur,Punjab',
'Tanda,Hoshiarpur,Punjab',
'Tanuli,Hoshiarpur,Punjab',
'Taragarh,Hoshiarpur,Punjab',
'Terkiana,Hoshiarpur,Punjab',
'Thakrowal,Hoshiarpur,Punjab',
'Thinda,Hoshiarpur,Punjab',
'Thowana,Hoshiarpur,Punjab',
'Todarpur,Hoshiarpur,Punjab',
'Tranglian,Hoshiarpur,Punjab',
'Tuto Mazara,Hoshiarpur,Punjab',
'Umarpur,Hoshiarpur,Punjab',
'Urmar,Hoshiarpur,Punjab',
'Usman Shaheed,Hoshiarpur,Punjab',
'Zahura,Hoshiarpur,Punjab',
'CRPF Campus Sarai Khas,Kapurthala,Punjab',
'Kahlinan,Kapurthala,Punjab',
'Phul Gudewal,Kapurthala,Punjab',
'Sarai Khas,Kapurthala,Punjab',
'Adampur Ad,Jalandhar,Punjab',
'Adampur Doaba,Jalandhar,Punjab',
'Adarsh Nagar,Jalandhar,Punjab',
'Adda Kathar,Jalandhar,Punjab',
'Alawalpur,Jalandhar,Punjab',
'Athola,Jalandhar,Punjab',
'Bal,Jalandhar,Punjab',
'Basti Bawa Khel,Jalandhar,Punjab',
'Basti Danishmanda,Jalandhar,Punjab',
'Basti Guzan,Jalandhar,Punjab',
'Basti Nau,Jalandhar,Punjab',
'Basti Sheikh,Jalandhar,Punjab',
'Bazar Nauhrian,Jalandhar,Punjab',
'Bazar Shahidan,Jalandhar,Punjab',
'Beas Pind,Jalandhar,Punjab',
'Behram Sarista,Jalandhar,Punjab',
'Bhagat Bazar,Jalandhar,Punjab',
'Bhargava Camp,Jalandhar,Punjab',
'Bhatnura Lubana,Jalandhar,Punjab',
'Bhogpur,Jalandhar,Punjab',
'Bhojowal,Jalandhar,Punjab',
'Bikrampura,Jalandhar,Punjab',
'Binpalke,Jalandhar,Punjab',
'Bolina Doaba,Jalandhar,Punjab',
'Bsf Campus Jalandhar Cantt,Jalandhar,Punjab',
'Budhiana,Jalandhar,Punjab',
'Chamiara,Jalandhar,Punjab',
'Charanjitpura,Jalandhar,Punjab',
'Chitti,Jalandhar,Punjab',
'Chogittie,Jalandhar,Punjab',
'Cholang,Jalandhar,Punjab',
'Chukhiara,Jalandhar,Punjab',
'Civil Secretariate,Jalandhar,Punjab',
'Dakoha,Jalandhar,Punjab',
'Damunda,Jalandhar,Punjab',
'Daroli Kalan,Jalandhar,Punjab',
'Daroli Khurd,Jalandhar,Punjab',
'Dav College,Jalandhar,Punjab',
'Dhanowali,Jalandhar,Punjab',
'Dhariwal,Jalandhar,Punjab',
'Dhogri,Jalandhar,Punjab',
'Dingrian,Jalandhar,Punjab',
'Dolike Sunderpur,Jalandhar,Punjab',
'Duhre,Jalandhar,Punjab',
'Fentonganj,Jalandhar,Punjab',
'G R D Road,Jalandhar,Punjab',
'Gakhlan,Jalandhar,Punjab',
'Garha,Jalandhar,Punjab',
'General Bus Stand,Jalandhar,Punjab',
'Ghurial,Jalandhar,Punjab',
'Grain Market,Jalandhar,Punjab',
'Guru Amar Dass Nagar,Jalandhar,Punjab',
'Haripur Sirowal,Jalandhar,Punjab',
'Hazara,Jalandhar,Punjab',
'Hellor,Jalandhar,Punjab',
'Hoshiarpur Road,Jalandhar,Punjab',
'Ind Town,Jalandhar,Punjab',
'Isharwal,Jalandhar,Punjab',
'Jaitewali,Jalandhar,Punjab',
'Jalandhar Cantt H.O,Jalandhar,Punjab',
'Jalandhar City H.O,Jalandhar,Punjab',
'Jalbhe,Jalandhar,Punjab',
'Jalowal,Jalandhar,Punjab',
'Jamsher,Jalandhar,Punjab',
'Jandir,Jalandhar,Punjab',
'Jandu Singha,Jalandhar,Punjab',
'Kala Bakra,Jalandhar,Punjab',
'Kalra,Jalandhar,Punjab',
'Kalyanpur,Jalandhar,Punjab',
'Kandhala Guru,Jalandhar,Punjab',
'Kandola,Jalandhar,Punjab',
'Kapur Pind,Jalandhar,Punjab',
'Khambra,Jalandhar,Punjab',
'Khurdpur,Jalandhar,Punjab',
'Khurla,Jalandhar,Punjab',
'Khusropur,Jalandhar,Punjab',
'Kingra Chowala,Jalandhar,Punjab',
'Kishangarh,Jalandhar,Punjab',
'Kishanpur,Jalandhar,Punjab',
'Kohala,Jalandhar,Punjab',
'Kotla,Jalandhar,Punjab',
'Kotli Than Singh,Jalandhar,Punjab',
'Kukar Pind,Jalandhar,Punjab',
'Ladhewali,Jalandhar,Punjab',
'Ladhra,Jalandhar,Punjab',
'Lajpat Nagar,Jalandhar,Punjab',
'Lallian,Jalandhar,Punjab',
'Lambra,Jalandhar,Punjab',
'Laroi,Jalandhar,Punjab',
'Laroya,Jalandhar,Punjab',
'Lidhran,Jalandhar,Punjab',
'Lohar Partapura,Jalandhar,Punjab',
'Loharan,Jalandhar,Punjab',
'Lyalpur Khalsa College,Jalandhar,Punjab',
'M R D Pura,Jalandhar,Punjab',
'Madar,Jalandhar,Punjab',
'Madhopur,Jalandhar,Punjab',
'Malko Tarar,Jalandhar,Punjab',
'Manakrai,Jalandhar,Punjab',
'Mand,Jalandhar,Punjab',
'Manjit Nagar,Jalandhar,Punjab',
'Manko,Jalandhar,Punjab',
'Massani,Jalandhar,Punjab',
'Millitary Hospital,Jalandhar,Punjab',
'Mithapur,Jalandhar,Punjab',
'Model House,Jalandhar,Punjab',
'Model Town,Jalandhar,Punjab',
'Mohadipur,Jalandhar,Punjab',
'N R Colony,Jalandhar,Punjab',
'Nagra,Jalandhar,Punjab',
'Najka,Jalandhar,Punjab',
'Nangal Shama,Jalandhar,Punjab',
'Naugajja,Jalandhar,Punjab',
'Nurpur,Jalandhar,Punjab',
'Nussi,Jalandhar,Punjab',
'Pachranga,Jalandhar,Punjab',
'Padhiana,Jalandhar,Punjab',
'Pandori Nijjran,Jalandhar,Punjab',
'Pap Lines Jalandhar Cantt,Jalandhar,Punjab',
'Parasrampur,Jalandhar,Punjab',
'Patara,Jalandhar,Punjab',
'Patial,Jalandhar,Punjab',
'Phoolpur Dhanal,Jalandhar,Punjab',
'Phophliwar,Jalandhar,Punjab',
'Preet Nagar,Jalandhar,Punjab',
'Qadian Wali,Jalandhar,Punjab',
'Railway Road,Jalandhar,Punjab',
'Raipur Rasulpur,Jalandhar,Punjab',
'Rajpur,Jalandhar,Punjab',
'Ram Nagar,Jalandhar,Punjab',
'Rama Mandi,Jalandhar,Punjab',
'Randhawa Masanda,Jalandhar,Punjab',
'Rasta Mohalla,Jalandhar,Punjab',
'Rec Jalandhar,Jalandhar,Punjab',
'Reru,Jalandhar,Punjab',
'Rohjari,Jalandhar,Punjab',
'S U S Nagar,Jalandhar,Punjab',
'Sadana,Jalandhar,Punjab',
'Sadar Bazar Jalandhar Cantt,Jalandhar,Punjab',
'Salala,Jalandhar,Punjab',
'Samipur,Jalandhar,Punjab',
'Sanaura,Jalandhar,Punjab',
'Sansarpur,Jalandhar,Punjab',
'Sant Nagar,Jalandhar,Punjab',
'Sarobad,Jalandhar,Punjab',
'Session Court,Jalandhar,Punjab',
'Shakti Nagar,Jalandhar,Punjab',
'Sheikhe Pind,Jalandhar,Punjab',
'Sikandarpur,Jalandhar,Punjab',
'Sodal Road Jal,Jalandhar,Punjab',
'Sofi Pind,Jalandhar,Punjab',
'Suranussi Od,Jalandhar,Punjab',
'Tajpur,Jalandhar,Punjab',
'Talhan,Jalandhar,Punjab',
'Tower Town Colony,Jalandhar,Punjab',
'Ucha,Jalandhar,Punjab',
'Udhopur,Jalandhar,Punjab',
'Urban Estate,Jalandhar,Punjab',
'Wadala,Jalandhar,Punjab',
'Mustafapur,Kapurthala,Punjab',
'Rahimpur,Kapurthala,Punjab',
'Kartarpur,Kapurthala,Punjab',
'Adarman,Kapurthala,Punjab',
'Akbarpur Kalan,Kapurthala,Punjab',
'Baloki,Kapurthala,Punjab',
'Bara Sidhpur,Kapurthala,Punjab',
'Bhallowal,Kapurthala,Punjab',
'Bhandal Himmat,Kapurthala,Punjab',
'Bhodipur,Kapurthala,Punjab',
'Bhullar,Kapurthala,Punjab',
'Billi Chuharmi,Kapurthala,Punjab',
'Bulanda,Kapurthala,Punjab',
'Chak Chela,Kapurthala,Punjab',
'Chuheki,Kapurthala,Punjab',
'Danewal,Kapurthala,Punjab',
'Daulatpur Dhadde,Kapurthala,Punjab',
'Gandhran,Kapurthala,Punjab',
'Gill Seowal,Kapurthala,Punjab',
'Gumtala,Kapurthala,Punjab',
'Gumtali,Kapurthala,Punjab',
'Haripur,Kapurthala,Punjab',
'Kandola Kalan,Kapurthala,Punjab',
'Kangnah,Kapurthala,Punjab',
'Khanpur Dhadde,Kapurthala,Punjab',
'Kot Badal Khan,Kapurthala,Punjab',
'Lidhran,Kapurthala,Punjab',
'Malri,Kapurthala,Punjab',
'Malupur,Kapurthala,Punjab',
'Muridwal,Kapurthala,Punjab',
'Nawanpind Jattan,Kapurthala,Punjab',
'Nihaluwal,Kapurthala,Punjab',
'Nurmahal,Kapurthala,Punjab',
'Nurpur,Kapurthala,Punjab',
'Pandori Khas,Kapurthala,Punjab',
'Parjian Kalan,Kapurthala,Punjab',
'Ramewal,Kapurthala,Punjab',
'Rupewali,Kapurthala,Punjab',
'Saidowal,Kapurthala,Punjab',
'Sangowal,Kapurthala,Punjab',
'Shadipur,Kapurthala,Punjab',
'Shahpur,Kapurthala,Punjab',
'Singhpur,Kapurthala,Punjab',
'Tandaura,Kapurthala,Punjab',
'Tut Kalan,Kapurthala,Punjab',
'Udhowal,Kapurthala,Punjab',
'Umarpur Kalan,Kapurthala,Punjab',
'Umarwal Billa,Kapurthala,Punjab',
'Uppal Bhupa,Kapurthala,Punjab',
'Uppal Jagir,Kapurthala,Punjab',
'D.G.Nakoder,Kapurthala,Punjab',
'Malsian,Kapurthala,Punjab',
'Mehatpur,Kapurthala,Punjab',
'Motor Terminas Nakoder,Kapurthala,Punjab',
'Nakoder Mandi,Kapurthala,Punjab',
'Nakoder,Kapurthala,Punjab',
'G.M. Nurmahal,Kapurthala,Punjab',
'Apra,Jalandhar,Punjab',
'Atti,Jalandhar,Punjab',
'Bara Pind,Jalandhar,Punjab',
'Bharsingpura,Jalandhar,Punjab',
'Birbansian,Jalandhar,Punjab',
'Chachrari,Jalandhar,Punjab',
'Chak Desraj,Jalandhar,Punjab',
'Chhokran,Jalandhar,Punjab',
'Dayalpur,Jalandhar,Punjab',
'Dhaleta,Jalandhar,Punjab',
'Dhesian Sangh,Jalandhar,Punjab',
'Dosanj Kalan,Jalandhar,Punjab',
'Ganachaur,Jalandhar,Punjab',
'Gohawar,Jalandhar,Punjab',
'Goraya,Jalandhar,Punjab',
'Haripur Khalsa,Jalandhar,Punjab',
'Herian,Jalandhar,Punjab',
'Ind Area Phillaur,Jalandhar,Punjab',
'Kang Jagir,Jalandhar,Punjab',
'Kariana,Jalandhar,Punjab',
'Khaira,Jalandhar,Punjab',
'Landhran,Jalandhar,Punjab',
'Mahal,Jalandhar,Punjab',
'Majara Nau Abad,Jalandhar,Punjab',
'Malo Mazara,Jalandhar,Punjab',
'Mandi,Jalandhar,Punjab',
'Mansurpur,Jalandhar,Punjab',
'Mathada Kalan,Jalandhar,Punjab',
'Mathada Khurd,Jalandhar,Punjab',
'Moron,Jalandhar,Punjab',
'Nagar,Jalandhar,Punjab',
'P T S Phillaur,Jalandhar,Punjab',
'Paddi Jagir,Jalandhar,Punjab',
'Phalpota,Jalandhar,Punjab',
'Phambra,Jalandhar,Punjab',
'Phillaur,Jalandhar,Punjab',
'Raipur Dhaba,Jalandhar,Punjab',
'Ratinda,Jalandhar,Punjab',
'Rurka Khurd,Jalandhar,Punjab',
'Samrai,Jalandhar,Punjab',
'Sargundi,Jalandhar,Punjab',
'Shahpur Bhattian,Jalandhar,Punjab',
'Tehang,Jalandhar,Punjab',
'Thalla,Jalandhar,Punjab',
'Lohian,Kapurthala,Punjab',
'Ahmedpur,Kapurthala,Punjab',
'Dhapai,Kapurthala,Punjab',
'Hadiabad,Kapurthala,Punjab',
'Begowal,Kapurthala,Punjab',
'Akbarpur,Kapurthala,Punjab',
'Alampur Bhakha,Kapurthala,Punjab',
'Awan Bikeshah,Kapurthala,Punjab',
'Bariar,Kapurthala,Punjab',
'Bhadas,Kapurthala,Punjab',
'Bhandal Bet,Kapurthala,Punjab',
'Bholath,Kapurthala,Punjab',
'Bopa Rai Kalan,Kapurthala,Punjab',
'Boparai,Kapurthala,Punjab',
'Butala,Kapurthala,Punjab',
'Butter,Kapurthala,Punjab',
'Chakoki,Kapurthala,Punjab',
'Dhaliwal Bet,Kapurthala,Punjab',
'Ibrahimwal,Kapurthala,Punjab',
'Jaid,Kapurthala,Punjab',
'Khassan,Kapurthala,Punjab',
'Kudowal,Kapurthala,Punjab',
'Lakhan Ke Padde,Kapurthala,Punjab',
'Mana Talwandi,Kapurthala,Punjab',
'Maqsoodpur,Kapurthala,Punjab',
'Miani Bakerpur,Kapurthala,Punjab',
'Mirzapur,Kapurthala,Punjab',
'Muddowal,Kapurthala,Punjab',
'Nadala,Kapurthala,Punjab',
'Nangal Ambian,Kapurthala,Punjab',
'Nangal Lubana,Kapurthala,Punjab',
'Nurpur Lubana,Kapurthala,Punjab',
'Raipur Arryan,Kapurthala,Punjab',
'Raipur Pir Bux Wala,Kapurthala,Punjab',
'Ramgarh,Kapurthala,Punjab',
'Ramidi,Kapurthala,Punjab',
'Saiflabad,Kapurthala,Punjab',
'Sangojla,Kapurthala,Punjab',
'Sher Singh Wala,Kapurthala,Punjab',
'Subhanpur,Kapurthala,Punjab',
'Surkhpur,Kapurthala,Punjab',
'Talwara,Kapurthala,Punjab',
'Dhilwan,Kapurthala,Punjab',
'Kala Sanghian,Kapurthala,Punjab',
'Adhi,Kapurthala,Punjab',
'Amrit Bazar(Kapurthala),Kapurthala,Punjab',
'Aujla Jogi,Kapurthala,Punjab',
'Bahamanian,Kapurthala,Punjab',
'Bajwa Kalan,Kapurthala,Punjab',
'Baler Khanpur,Kapurthala,Punjab',
'Bath Kalan,Kapurthala,Punjab',
'Bhanolanga,Kapurthala,Punjab',
'Bhawanipur,Kapurthala,Punjab',
'Bhulana,Kapurthala,Punjab',
'Burewal,Kapurthala,Punjab',
'BusStand(Kapurthala),Kapurthala,Punjab',
'Dadwindi,Kapurthala,Punjab',
'Dialpur,Kapurthala,Punjab',
'Fattu Dhinga,Kapurthala,Punjab',
'Gohir,Kapurthala,Punjab',
'Herran,Kapurthala,Punjab',
'Ibban,Kapurthala,Punjab',
'Jagatjit Nagar,Kapurthala,Punjab',
'Jallowal Madhopur,Kapurthala,Punjab',
'Kang Saboo,Kapurthala,Punjab',
'Kanjli,Kapurthala,Punjab',
'Kapurthala H.O,Kapurthala,Punjab',
'Kapurthala Mandi,Kapurthala,Punjab',
'Kapurthala Town,Kapurthala,Punjab',
'Khaira Dona,Kapurthala,Punjab',
'Khaira Majha,Kapurthala,Punjab',
'Khalu,Kapurthala,Punjab',
'Khanowal,Kapurthala,Punjab',
'Khiranwali,Kapurthala,Punjab',
'Khiwa,Kapurthala,Punjab',
'Khukhrain,Kapurthala,Punjab',
'Khusropur,Kapurthala,Punjab',
'Killi,Kapurthala,Punjab',
'Kotli Gujjran,Kapurthala,Punjab',
'Kular,Kapurthala,Punjab',
'Lakhan Kalan,Kapurthala,Punjab',
'Lassori,Kapurthala,Punjab',
'Mahabalipur,Kapurthala,Punjab',
'Maheem,Kapurthala,Punjab',
'Mansoorwal,Kapurthala,Punjab',
'Merripur,Kapurthala,Punjab',
'Miani Bhagopurian,Kapurthala,Punjab',
'Mianwal Arrayan,Kapurthala,Punjab',
'Mianwal,Kapurthala,Punjab',
'Mothanwala,Kapurthala,Punjab',
'Mullewal Khera,Kapurthala,Punjab',
'Mundh,Kapurthala,Punjab',
'Nasirpur,Kapurthala,Punjab',
'Nathu Chahal,Kapurthala,Punjab',
'Nijjran,Kapurthala,Punjab',
'Pattar Kalan,Kapurthala,Punjab',
'Poonian,Kapurthala,Punjab',
'Rahimpur,Kapurthala,Punjab',
'Rail Coach Factory,Kapurthala,Punjab',
'Rasulpur Kalan,Kapurthala,Punjab',
'Saidowal,Kapurthala,Punjab',
'Saidpur,Kapurthala,Punjab',
'Sainik School Kapurthala,Kapurthala,Punjab',
'Sainiwal,Kapurthala,Punjab',
'Sandhu Chatha,Kapurthala,Punjab',
'Shahkot,Kapurthala,Punjab',
'Shankar,Kapurthala,Punjab',
'Sheikhupur,Kapurthala,Punjab',
'Sidhwan Dona,Kapurthala,Punjab',
'Sidhwan R.S.,Kapurthala,Punjab',
'Sindhar,Kapurthala,Punjab',
'Talwan,Kapurthala,Punjab',
'Talwandi Bhairon,Kapurthala,Punjab',
'Talwandi Buttian,Kapurthala,Punjab',
'Talwandi Madho,Kapurthala,Punjab',
'Talwandi Saleem,Kapurthala,Punjab',
'Thatha Jadid,Kapurthala,Punjab',
'Tibba,Kapurthala,Punjab',
'Uggi,Kapurthala,Punjab',
'Wadala Kalan,Kapurthala,Punjab',
'Talwandi Chaudharian,Kapurthala,Punjab',
'Bagga,Kapurthala,Punjab',
'Chak Kalan,Kapurthala,Punjab',
'Chak Mughlani,Kapurthala,Punjab',
'Kanian Kalan,Kapurthala,Punjab',
'Kotla Surajmal,Kapurthala,Punjab',
'Nawan Qilla,Kapurthala,Punjab',
'Raunt,Kapurthala,Punjab',
'Sadiqpur,Kapurthala,Punjab',
'Sandhewal,Kapurthala,Punjab',
'Sharakpur,Kapurthala,Punjab',
'Sohal Jagir,Kapurthala,Punjab',
'Talwandi Sanghera,Kapurthala,Punjab',
'Athouli,Kapurthala,Punjab',
'Banga Road Phagwara,Kapurthala,Punjab',
'Barn,Kapurthala,Punjab',
'Bazar Sarafan Phagwara,Kapurthala,Punjab',
'Bhabiana,Kapurthala,Punjab',
'Bhangala,Kapurthala,Punjab',
'Bhangana,Kapurthala,Punjab',
'Bhanoki,Kapurthala,Punjab',
'Bhardwajian,Kapurthala,Punjab',
'Bhullarai,Kapurthala,Punjab',
'Bilga,Kapurthala,Punjab',
'Birk,Kapurthala,Punjab',
'Birpind,Kapurthala,Punjab',
'Bohani,Kapurthala,Punjab',
'Bundala,Kapurthala,Punjab',
'Bus Stand Phagwara,Kapurthala,Punjab',
'Chachoki,Kapurthala,Punjab',
'Chak Prema,Kapurthala,Punjab',
'Chak Vendal,Kapurthala,Punjab',
'Chanian,Kapurthala,Punjab',
'Chehru,Kapurthala,Punjab',
'Daduwal,Kapurthala,Punjab',
'Dhaliwal,Kapurthala,Punjab',
'Dhanipind,Kapurthala,Punjab',
'Dhesian Kahna,Kapurthala,Punjab',
'Domeli,Kapurthala,Punjab',
'Ghurka,Kapurthala,Punjab',
'Gure,Kapurthala,Punjab',
'Hadiabad Phagwara,Kapurthala,Punjab',
'Hardasspur,Kapurthala,Punjab',
'Jandiali,Kapurthala,Punjab',
'Kangniwal,Kapurthala,Punjab',
'Khajurla,Kapurthala,Punjab',
'Khokhewal,Kapurthala,Punjab',
'Khothra Kalan,Kapurthala,Punjab',
'Lakhanpal,Kapurthala,Punjab',
'Lakhpur,Kapurthala,Punjab',
'Littran,Kapurthala,Punjab',
'Madhopur,Kapurthala,Punjab',
'Manak,Kapurthala,Punjab',
'Mauli,Kapurthala,Punjab',
'Mayopatti,Kapurthala,Punjab',
'Meheru,Kapurthala,Punjab',
'Mehli,Kapurthala,Punjab',
'Mehli Gate Phagwara,Kapurthala,Punjab',
'Mehtan,Kapurthala,Punjab',
'Mithra,Kapurthala,Punjab',
'Mowai,Kapurthala,Punjab',
'Nagra,Kapurthala,Punjab',
'Nangal Majha,Kapurthala,Punjab',
'Narur,Kapurthala,Punjab',
'Nawapind,Kapurthala,Punjab',
'P.C.Jamalpur,Kapurthala,Punjab',
'Pabwan,Kapurthala,Punjab',
'Palahi,Kapurthala,Punjab',
'Panchhat,Kapurthala,Punjab',
'Pandori,Kapurthala,Punjab',
'Partappura,Kapurthala,Punjab',
'Pasla,Kapurthala,Punjab',
'Phagwara H.O,Kapurthala,Punjab',
'Pharwala,Kapurthala,Punjab',
'Powadhra,Kapurthala,Punjab',
'Railway Road Phagwara,Kapurthala,Punjab',
'Raipur,Kapurthala,Punjab',
'Rampur Sunara,Kapurthala,Punjab',
'Ranipur,Kapurthala,Punjab',
'Rawalpindi Gulab Shah,Kapurthala,Punjab',
'Rehana Jattan,Kapurthala,Punjab',
'Rorkee,Kapurthala,Punjab',
'Rurka Kalan,Kapurthala,Punjab',
'Sahni,Kapurthala,Punjab',
'Samrai,Kapurthala,Punjab',
'Sangatpur,Kapurthala,Punjab',
'Sarai Jattan,Kapurthala,Punjab',
'Sarhali,Kapurthala,Punjab',
'Sarih,Kapurthala,Punjab',
'Satnampura,Kapurthala,Punjab',
'Sunner Kalan,Kapurthala,Punjab',
'Tahli,Kapurthala,Punjab',
'Thamanwal,Kapurthala,Punjab',
'Thaper Colony Phagwara,Kapurthala,Punjab',
'Wazooha Khurd,Kapurthala,Punjab',
'Jandiala,Kapurthala,Punjab',
'Kang Arryan,Kapurthala,Punjab',
'Mau Mianwal,Kapurthala,Punjab',
'Mehsumpurn,Kapurthala,Punjab',
'Bara Jodh Singh,Kapurthala,Punjab',
'Dalla,Kapurthala,Punjab',
'Gidder Pindi,Kapurthala,Punjab',
'Gnqc Sultanpur,Kapurthala,Punjab',
'Kabirpur,Kapurthala,Punjab',
'Kang Kalan,Kapurthala,Punjab',
'Kang Khurd,Kapurthala,Punjab',
'Manak,Kapurthala,Punjab',
'Nahal,Kapurthala,Punjab',
'Nawanpind Danewal,Kapurthala,Punjab',
'Paramjitpur,Kapurthala,Punjab',
'Rampur Jagir,Kapurthala,Punjab',
'Sarai Jattan,Kapurthala,Punjab',
'Sherpur Dona,Kapurthala,Punjab',
'Sultanpur Lodhi,Kapurthala,Punjab',
'Turna,Kapurthala,Punjab',
'Usafpur Darewal,Kapurthala,Punjab',
'Baggakhurd,Ludhiana City,Punjab',
'Bhattia,Ludhiana City,Punjab',
'Boothgarh,Ludhiana City,Punjab',
'Hawas,Ludhiana City,Punjab',
'Karyana Kalan,Ludhiana City,Punjab',
'Khwajke,Ludhiana City,Punjab',
'Lodhowal,Ludhiana City,Punjab',
'Lohora,Ludhiana City,Punjab',
'Mangat,Ludhiana City,Punjab',
'Mattewara,Ludhiana City,Punjab',
'New Courts,Ludhiana City,Punjab',
'Noorwala,Ludhiana City,Punjab',
'Nurpurbet,Ludhiana City,Punjab',
'Partapsinghwala,Ludhiana City,Punjab',
'Ludhiana H.O,Ludhiana City,Punjab',
'Akhara,Ludhiana Moffusil,Punjab',
'Bodalwala,Ludhiana Moffusil,Punjab',
'Chachrari,Ludhiana Moffusil,Punjab',
'Chimna,Ludhiana Moffusil,Punjab',
'Dholan,Ludhiana Moffusil,Punjab',
'Galib Kalan,Ludhiana Moffusil,Punjab',
'Hans Kalan,Ludhiana Moffusil,Punjab',
'Jagraon City,Ludhiana Moffusil,Punjab',
'Jagraon H.O,Ludhiana Moffusil,Punjab',
'Jagraon Tehsil,Ludhiana Moffusil,Punjab',
'Malak,Ludhiana Moffusil,Punjab',
'Sowaddi,Ludhiana Moffusil,Punjab',
'Srs Nagar,Ludhiana Moffusil,Punjab',
'Sujapur,Ludhiana Moffusil,Punjab',
'A.S.College(Khanna),Ludhiana Moffusil,Punjab',
'Amloh Road(Khanna),Ludhiana Moffusil,Punjab',
'Bahomajra,Ludhiana Moffusil,Punjab',
'Bhamaddi,Ludhiana Moffusil,Punjab',
'Daheru,Ludhiana Moffusil,Punjab',
'Ghungrali Rajputan,Ludhiana Moffusil,Punjab',
'Ikolaha,Ludhiana Moffusil,Punjab',
'Khanna H.O,Ludhiana Moffusil,Punjab',
'Kishangarh,Ludhiana Moffusil,Punjab',
'Libra,Ludhiana Moffusil,Punjab',
'Mohanpur,Ludhiana Moffusil,Punjab',
'Nai Mandi Khanna,Ludhiana Moffusil,Punjab',
'Rajewal,Ludhiana Moffusil,Punjab',
'Bhutal Kalan,Sangrur,Punjab',
'Chajjli,Sangrur,Punjab',
'Chathe Roti Ram,Sangrur,Punjab',
'Cheema,Sangrur,Punjab',
'Chhahar,Sangrur,Punjab',
'Daska,Sangrur,Punjab',
'Dehla,Sangrur,Punjab',
'Dharamgarh,Sangrur,Punjab',
'Dhindsa,Sangrur,Punjab',
'Dirba,Sangrur,Punjab',
'Dudian,Sangrur,Punjab',
'Ganduan,Sangrur,Punjab',
'Jakhepal,Sangrur,Punjab',
'Jharon,Sangrur,Punjab',
'Khadial,Sangrur,Punjab',
'Kotra Amru,Sangrur,Punjab',
'Lehragaga,Sangrur,Punjab',
'Moonak,Sangrur,Punjab',
'N K Sunam,Sangrur,Punjab',
'Nilowal,Sangrur,Punjab',
'Pakki Khanauri,Sangrur,Punjab',
'Shahpur,Sangrur,Punjab',
'Sunam City,Sangrur,Punjab',
'Sunam,Sangrur,Punjab',
'Moom,Sangrur,Punjab',
'Ramgarh,Sangrur,Punjab',
'Sher Singh Pura,Sangrur,Punjab',
'Ghunas,Sangrur,Punjab',
'Mauran,Sangrur,Punjab',
'Pakho Kalan,Sangrur,Punjab',
'Sukhpura Maur,Sangrur,Punjab',
'Tajoke,Sangrur,Punjab',
'Ugoke,Sangrur,Punjab',
'Dikchu,Sikkim,Sikkim',
'Gor,Sikkim,Sikkim',
'Lumlingthyang,Sikkim,Sikkim',
'Rakdong,Sikkim,Sikkim',
'Raley Khesey,Sikkim,Sikkim',
'Samdong,Sikkim,Sikkim',
'Bhusuk,Sikkim,Sikkim',
'Bojoghari,Sikkim,Sikkim',
'Deorali,Sikkim,Sikkim',
'Dhajey,Sikkim,Sikkim',
'Gangtok Bazar,Sikkim,Sikkim',
'Gangtok H.O,Sikkim,Sikkim',
'Gnathang,Sikkim,Sikkim',
'Kyanglasha,Sikkim,Sikkim',
'Lingdok,Sikkim,Sikkim',
'Yangyang,Sikkim,Sikkim',
'Chungthang,Sikkim,Sikkim',
'Lachen,Sikkim,Sikkim',
'Lachung,Sikkim,Sikkim',
'Naga,Sikkim,Sikkim',
'Shipgyare,Sikkim,Sikkim',
'Kabi,Sikkim,Sikkim',
'Lingthem,Sikkim,Sikkim',
'Lingthem,Sikkim,Sikkim',
'Lower Dzongu,Sikkim,Sikkim',
'Mangan,Sikkim,Sikkim',
'Manul,Sikkim,Sikkim',
'Men Rong Rong,Sikkim,Sikkim',
'Namok,Sikkim,Sikkim',
'Phamtam,Sikkim,Sikkim',
'Phensong,Sikkim,Sikkim',
'Phudong,Sikkim,Sikkim',
'Ramthang,Sikkim,Sikkim',
'Rangrang,Sikkim,Sikkim',
'Sangkalan,Sikkim,Sikkim',
'Singhik,Sikkim,Sikkim',
'Tingchim,Sikkim,Sikkim',
'Tingvong,Sikkim,Sikkim',
'Okharey,Sikkim,Sikkim',
'Pipalay,Sikkim,Sikkim',
'Reshi,Sikkim,Sikkim',
'Ribdi-bhareng,Sikkim,Sikkim',
'Sanchabarey Daramdim,Sikkim,Sikkim',
'Sanganath,Sikkim,Sikkim',
'Sombaria,Sikkim,Sikkim',
'Soreng,Sikkim,Sikkim',
'Kerabari,Sikkim,Sikkim',
'Lungchuk,Sikkim,Sikkim',
'Manpur,Sikkim,Sikkim',
'Melli Bazar,Sikkim,Sikkim',
'Melli Dara,Sikkim,Sikkim',
'Payiong,Sikkim,Sikkim',
'Rateypani,Sikkim,Sikkim',
'Sadam,Sikkim,Sikkim',
'Sumbuk,Sikkim,Sikkim',
'Turuk,Sikkim,Sikkim',
'Assangthang,Sikkim,Sikkim',
'Damthang,Sikkim,Sikkim',
'Kitam,Sikkim,Sikkim',
'Kupup,Sikkim,Sikkim',
'Maniram,Sikkim,Sikkim',
'Mic Khola,Sikkim,Sikkim',
'Namchi,Sikkim,Sikkim',
'Nandugaon,Sikkim,Sikkim',
'Pabong,Sikkim,Sikkim',
'Perbing,Sikkim,Sikkim',
'Phalidara,Sikkim,Sikkim',
'Poklok,Sikkim,Sikkim',
'Rong,Sikkim,Sikkim',
'Shalghari,Sikkim,Sikkim',
'Singhithang,Sikkim,Sikkim',
'Sorok,Sikkim,Sikkim',
'Wok,Sikkim,Sikkim',
'Barfung,Sikkim,Sikkim',
'Ben,Sikkim,Sikkim',
'Berang,Sikkim,Sikkim',
'Kewzing,Sikkim,Sikkim',
'Phamtam,Sikkim,Sikkim',
'Ralang,Sikkim,Sikkim',
'Ravangla,Sikkim,Sikkim',
'Sangmoo,Sikkim,Sikkim',
'Tingmoo,Sikkim,Sikkim',
'Tinkitam,Sikkim,Sikkim',
'Arithang,Sikkim,Sikkim',
'Bhaluthang,Sikkim,Sikkim',
'Chingthang,Sikkim,Sikkim',
'Gayzing,Sikkim,Sikkim',
'Gerathang,Sikkim,Sikkim',
'Karjee,Sikkim,Sikkim',
'Legship,Sikkim,Sikkim',
'Lingchom,Sikkim,Sikkim',
'Rangship,Sikkim,Sikkim',
'Rinchenpong,Sikkim,Sikkim',
'Sinek,Sikkim,Sikkim',
'Tashiding,Sikkim,Sikkim',
'Yangtey,Sikkim,Sikkim',
'Yangthang,Sikkim,Sikkim',
'Arubotay,Sikkim,Sikkim',
'Budang,Sikkim,Sikkim',
'Buriakhop,Sikkim,Sikkim',
'Chakung,Sikkim,Sikkim',
'Chumbong,Sikkim,Sikkim',
'Majitar,Sikkim,Sikkim',
'Malbasey,Sikkim,Sikkim',
'Naya Bazar,Sikkim,Sikkim',
'Sri Badam,Sikkim,Sikkim',
'Suldung,Sikkim,Sikkim',
'Takuthang,Sikkim,Sikkim',
'Tharpu,Sikkim,Sikkim',
'Tikpur,Sikkim,Sikkim',
'Timburbong,Sikkim,Sikkim',
'Zoom,Sikkim,Sikkim',
'Darap,Sikkim,Sikkim',
'Dentam,Sikkim,Sikkim',
'Hee Gaon,Sikkim,Sikkim',
'Kaluk,Sikkim,Sikkim',
'Karmatar,Sikkim,Sikkim',
'Khechuperi,Sikkim,Sikkim',
'Mechi Aching,Sikkim,Sikkim',
'Namphu,Sikkim,Sikkim',
'Pelling,Sikkim,Sikkim',
'Radhu Khandu,Sikkim,Sikkim',
'Rimbi,Sikkim,Sikkim',
'Thingling,Sikkim,Sikkim',
'Uttarey,Sikkim,Sikkim',
'Yuksom,Sikkim,Sikkim',
'Abhanga,Dharmanagar,Tripura',
'Apareshkar,Dharmanagar,Tripura',
'Ambassa,Dharmanagar,Tripura',
'Chandraipara,Dharmanagar,Tripura',
'Harincherra,Dharmanagar,Tripura',
'Kamalacherra,Dharmanagar,Tripura',
'Kanchanpur Colony,Dharmanagar,Tripura',
'Karnamunipara,Dharmanagar,Tripura',
'Lakraichowdhuripara,Dharmanagar,Tripura',
'Sikaribari,Dharmanagar,Tripura',
'Bagaicherri,Dharmanagar,Tripura',
'Balarambazar,Dharmanagar,Tripura',
'Baligaon,Dharmanagar,Tripura',
'Bamancherra,Dharmanagar,Tripura',
'Baralutma,Dharmanagar,Tripura',
'Bhagirathpara,Dharmanagar,Tripura',
'Bullongbassa,Dharmanagar,Tripura',
'Chailengta,Dharmanagar,Tripura',
'Chawmanu,Dharmanagar,Tripura',
'Chengkap,Dharmanagar,Tripura',
'Chotosarma,Dharmanagar,Tripura',
'Dalapatipara,Dharmanagar,Tripura',
'Demchedrra Colony,Dharmanagar,Tripura',
'Dhumacherra,Dharmanagar,Tripura',
'Ganganagar Tribalcolony,Dharmanagar,Tripura',
'Halahali,Dharmanagar,Tripura',
'Singibill,Dharmanagar,Tripura',
'Jagabandhu Para,Dharmanagar,Tripura',
'Jarulcherra,Dharmanagar,Tripura',
'Jamthing,Dharmanagar,Tripura',
'Kachucherra,Dharmanagar,Tripura',
'Garodtilla,Dharmanagar,Tripura',
'Fulcherri,Dharmanagar,Tripura',
'Kamalpur Aerodrome,Dharmanagar,Tripura',
'Kamalpur Bazar,Dharmanagar,Tripura',
'Kamalpur,Dharmanagar,Tripura',
'Karatichesdrra,Dharmanagar,Tripura',
'Katalutma,Dharmanagar,Tripura',
'Kuchainala,Dharmanagar,Tripura',
'Kulaibazar,Dharmanagar,Tripura',
'Laldingabari,Dharmanagar,Tripura',
'Laxmipur,Dharmanagar,Tripura',
'Longtharai,Dharmanagar,Tripura',
'Maharani Bus Stop,Dharmanagar,Tripura',
'Mainerma,Dharmanagar,Tripura',
'Manikbhander,Dharmanagar,Tripura',
'Manikpur,Dharmanagar,Tripura',
'Manughat,Dharmanagar,Tripura',
'Maracherra,Dharmanagar,Tripura',
'East Masli,Dharmanagar,Tripura',
'Maslicherra,Dharmanagar,Tripura',
'Ramdurlavpur,Dharmanagar,Tripura',
'Mechuria,Dharmanagar,Tripura',
'Mendihaor,Dharmanagar,Tripura',
'Nagbangshi,Dharmanagar,Tripura',
'Nalicherra,Dharmanagar,Tripura',
'Natinmanu,Dharmanagar,Tripura',
'Noagoan,Dharmanagar,Tripura',
'Paschim Dalucherra,Dharmanagar,Tripura',
'Ranipukur,Dharmanagar,Tripura',
'Salema,Dharmanagar,Tripura',
'Sarma,Dharmanagar,Tripura',
'Sindhukumarpara,Dharmanagar,Tripura',
'Srirampur Lambucherra,Dharmanagar,Tripura',
'Baburbazar,Dharmanagar,Tripura',
'Sayedabari,Dharmanagar,Tripura',
'Anandabazar,Dharmanagar,Tripura',
'Bagbassa,Dharmanagar,Tripura',
'Balicherra,Dharmanagar,Tripura',
'Baithangbari,Dharmanagar,Tripura',
'Balidhum,Dharmanagar,Tripura',
'Algapur,Dharmanagar,Tripura',
'Baruakandi,Dharmanagar,Tripura',
'Purba Betcherra,Dharmanagar,Tripura',
'Betcherra,Dharmanagar,Tripura',
'Bhagabannagar,Dharmanagar,Tripura',
'Bhagyapur,Dharmanagar,Tripura',
'Belianchief,Dharmanagar,Tripura',
'Dalugaon,Dharmanagar,Tripura',
'Birchandranagar,Dharmanagar,Tripura',
'Bakbaki,Dharmanagar,Tripura',
'Rakhalgang,Dharmanagar,Tripura',
'Hmungchuan,Dharmanagar,Tripura',
'Phuldengsai,Dharmanagar,Tripura',
'Sailo,Dharmanagar,Tripura',
'Emrapassa,Dharmanagar,Tripura',
'Paschimratacherra,Dharmanagar,Tripura',
'Zaithang,Dharmanagar,Tripura',
'Zarultali,Dharmanagar,Tripura',
'Amarpur,Agartala,Tripura',
'Ampinagar,Agartala,Tripura',
'Anandapur,Agartala,Tripura',
'Bagma,Agartala,Tripura',
'Beloniya,Agartala,Tripura',
'Garjee,Agartala,Tripura',
'Hrishyamukh,Agartala,Tripura',
'Gomti Project,Agartala,Tripura',
'Jolaibari,Agartala,Tripura',
'Kakraban,Agartala,Tripura',
'Manubazar,Agartala,Tripura',
'Satchand,Agartala,Tripura',
'Matai,Agartala,Tripura',
'Muhuripur,Agartala,Tripura',
'Radhakishorepur H.O,Agartala,Tripura',
'Radhanagar,Agartala,Tripura',
'Rajnagar,Agartala,Tripura',
'Sabroom,Agartala,Tripura',
'Santirbazar,Agartala,Tripura',
'Gakulpur,Agartala,Tripura',
'Tripureswari Colony,Agartala,Tripura',
'Udaipur Court,Agartala,Tripura',
'Asharambari,Dharmanagar,Tripura',
'Bachaibari,Dharmanagar,Tripura',
'Rajnagar Khowai,Dharmanagar,Tripura',
'Banbazar,Dharmanagar,Tripura',
'Barmaidan Bazar,Dharmanagar,Tripura',
'Barmura Project,Dharmanagar,Tripura',
'Behalabari,Dharmanagar,Tripura',
'Bdelchedrra,Dharmanagar,Tripura',
'Bharatsardarbari,Dharmanagar,Tripura',
'Birendranagar,Agartala,Tripura',
'Bishalgarh,Agartala,Tripura',
'Harishnagar Camp,Agartala,Tripura',
'Bishramganj,Agartala,Tripura',
'Boxonagar,Agartala,Tripura',
'Brahmacherra,Dharmanagar,Tripura',
'Chakmaghat,Dharmanagar,Tripura',
'Chankhala,Dharmanagar,Tripura',
'Chebri,Dharmanagar,Tripura',
'Baijalbari,Dharmanagar,Tripura',
'Durgapur,Dharmanagar,Tripura',
'Kalyanpur T. E,Dharmanagar,Tripura',
'Gakulbari,Dharmanagar,Tripura',
'Uttar Gakulnagar,Dharmanagar,Tripura',
'Ganki,Dharmanagar,Tripura',
'Ghilatali,Dharmanagar,Tripura',
'Tripura Engineering College,Agartala,Tripura',
'Golabari,Dharmanagar,Tripura',
'Hadrai,Dharmanagar,Tripura',
'Howaibari,Dharmanagar,Tripura',
'Kalyanpur,Dharmanagar,Tripura',
'Paschim Kalyanpur,Dharmanagar,Tripura',
'Kamalghat,Agartala,Tripura',
'Karailong,Dharmanagar,Tripura',
'Kathalia,Agartala,Tripura',
'Khasiamangal,Dharmanagar,Tripura',
'Khayerpur,Agartala,Tripura',
'Khowai Court,Dharmanagar,Tripura',
'Khowai,Dharmanagar,Tripura',
'Khowai T. E,Dharmanagar,Tripura',
'Subashpark,Dharmanagar,Tripura',
'Paschim Kunjaban,Dharmanagar,Tripura',
'Gouranga Tilla,Dharmanagar,Tripura',
'Mongtukupara,Dharmanagar,Tripura',
'Maharanipur,Dharmanagar,Tripura',
'Maigonga,Dharmanagar,Tripura',
'Melaghar,Agartala,Tripura',
'Mohanpur,Agartala,Tripura',
'Moharcherra,Dharmanagar,Tripura',
'Nunacherra,Dharmanagar,Tripura',
'Paglabari,Dharmanagar,Tripura',
'Paharmora,Dharmanagar,Tripura',
'Ramdayal Lendless Colony,Dharmanagar,Tripura',
'Karingicherra,Dharmanagar,Tripura',
'Paschim Laxmicherra,Dharmanagar,Tripura',
'Agagartilla,Dharmanagar,Tripura',
'Paschim Belcherra,Dharmanagar,Tripura',
'Dwarikapur,Dharmanagar,Tripura',
'Dakshin Promode L. L.Colony,Dharmanagar,Tripura',
'Uttat Pulinpur,Dharmanagar,Tripura',
'East Bachaibari,Dharmanagar,Tripura',
'Champahaor,Dharmanagar,Tripura',
'Ramchandraghat,Dharmanagar,Tripura',
'Ranirbazar,Agartala,Tripura',
'Ratanpurbazar,Dharmanagar,Tripura',
'Ratia,Dharmanagar,Tripura',
'Rupacherra,Dharmanagar,Tripura',
'Abhoynagar,Agartala,Tripura',
'Agartala Aerodrome,Agartala,Tripura',
'Agartala College,Agartala,Tripura',
'Agartala H.O,Agartala,Tripura',
'Agartala ONGC,Agartala,Tripura',
'Arundhutinagar,Agartala,Tripura',
'Bimangarh,Agartala,Tripura',
'Dhaleswar,Agartala,Tripura',
'Jogendranagar,Agartala,Tripura',
'Kunjaban,Agartala,Tripura',
'Ramnagar,Agartala,Tripura',
'Salbagan,Agartala,Tripura',
'Samatal Padmabil,Dharmanagar,Tripura',
'Nabakumar Rankhal Para,Dharmanagar,Tripura',
'Paschim Santinagar,Dharmanagar,Tripura',
'Sekerkote,Agartala,Tripura',
'Sidhai,Agartala,Tripura',
'Simna,Agartala,Tripura',
'Singicherra,Dharmanagar,Tripura',
'Sonamura,Agartala,Tripura',
'Sonatala,Dharmanagar,Tripura',
'Tablabari,Dharmanagar,Tripura',
'Ataromura,Dharmanagar,Tripura',
'Kalitilla,Dharmanagar,Tripura',
'Netajinagar,Dharmanagar,Tripura',
'Teliamura,Dharmanagar,Tripura',
'Uttarchebri,Dharmanagar,Tripura',
'Lambagara,Almora,Uttarakhand',
'Almora College,Almora,Uttarakhand',
'Almora Court,Almora,Uttarakhand',
'Almora H.O,Almora,Uttarakhand',
'Ayarpani,Almora,Uttarakhand',
'Bajwar,Almora,Uttarakhand',
'Baldhoti,Almora,Uttarakhand',
'Balta,Almora,Uttarakhand',
'Barechhina,Almora,Uttarakhand',
'Barsimi,Almora,Uttarakhand',
'Basoli,Almora,Uttarakhand',
'Bergaon,Almora,Uttarakhand',
'Bey,Almora,Uttarakhand',
'Bhainsiachhana,Almora,Uttarakhand',
'Bhainsori,Almora,Uttarakhand',
'Bhatkola,Almora,Uttarakhand',
'Birora,Almora,Uttarakhand',
'Chamu Uchyur,Almora,Uttarakhand',
'Chaunsli,Almora,Uttarakhand',
'Chitai,Almora,Uttarakhand',
'Dal,Almora,Uttarakhand',
'Darmar Tikhun,Almora,Uttarakhand',
'Deolikhan,Almora,Uttarakhand',
'Dhamas,Almora,Uttarakhand',
'Dhaura,Almora,Uttarakhand',
'Dinapani,Almora,Uttarakhand',
'Dova,Almora,Uttarakhand',
'Gurkande,Almora,Uttarakhand',
'Hawalbagh,Almora,Uttarakhand',
'I.T.I. Almora,Almora,Uttarakhand',
'Jamrari,Almora,Uttarakhand',
'Jeoli,Almora,Uttarakhand',
'Kafarkhan,Almora,Uttarakhand',
'Kanarichhina,Almora,Uttarakhand',
'Kathpuria,Almora,Uttarakhand',
'Kayala,Almora,Uttarakhand',
'Kharaun,Almora,Uttarakhand',
'Khastilari,Almora,Uttarakhand',
'Kirara,Almora,Uttarakhand',
'Kosi,Almora,Uttarakhand',
'Lala Bazar,Almora,Uttarakhand',
'Laxmeshwar,Almora,Uttarakhand',
'Lodhia,Almora,Uttarakhand',
'Mangalta,Almora,Uttarakhand',
'Maniagar,Almora,Uttarakhand',
'Nagarkhan,Almora,Uttarakhand',
'Naraindewal,Almora,Uttarakhand',
'Palyun,Almora,Uttarakhand',
'Patia,Almora,Uttarakhand',
'Petshal,Almora,Uttarakhand',
'Pokharkhali,Almora,Uttarakhand',
'Ranikhet H.O,Almora,Uttarakhand',
'Sainj,Almora,Uttarakhand',
'Salla Bhatkote,Almora,Uttarakhand',
'Shitalakhet,Almora,Uttarakhand',
'Sunoli,Almora,Uttarakhand',
'Suri,Almora,Uttarakhand',
'Syalidhar,Almora,Uttarakhand',
'Thana Bazar,Almora,Uttarakhand',
'Zoor,Almora,Uttarakhand',
'Pilkha,Almora,Uttarakhand',
'Andoli,Almora,Uttarakhand',
'Badiyar,Almora,Uttarakhand',
'Bamanswal,Almora,Uttarakhand',
'Banthok,Almora,Uttarakhand',
'Bhanoli,Almora,Uttarakhand',
'Birkola,Almora,Uttarakhand',
'Chagethi,Almora,Uttarakhand',
'Chamtola,Almora,Uttarakhand',
'Charchalikhan,Almora,Uttarakhand',
'Chaun Dungri,Almora,Uttarakhand',
'Chelchhina,Almora,Uttarakhand',
'Dania,Almora,Uttarakhand',
'Dasolibadiyar,Almora,Uttarakhand',
'Dauligarh,Almora,Uttarakhand',
'Dhauladevi,Almora,Uttarakhand',
'Dhaulchhina,Almora,Uttarakhand',
'Dhura,Almora,Uttarakhand',
'Dhyari,Almora,Uttarakhand',
'Doram,Almora,Uttarakhand',
'Dunar,Almora,Uttarakhand',
'Garurabanj,Almora,Uttarakhand',
'Gunaditya,Almora,Uttarakhand',
'Jageshwar,Almora,Uttarakhand',
'Jhankarsaim,Almora,Uttarakhand',
'Jingoli Toli,Almora,Uttarakhand',
'Kafalisuwakhan,Almora,Uttarakhand',
'Kafalni,Almora,Uttarakhand',
'Kasermanya,Almora,Uttarakhand',
'Khatiyola,Almora,Uttarakhand',
'Kheti,Almora,Uttarakhand',
'Khola,Almora,Uttarakhand',
'Maharagaon,Almora,Uttarakhand',
'Mayoli,Almora,Uttarakhand',
'Mirtola,Almora,Uttarakhand',
'Naini,Almora,Uttarakhand',
'Nali,Almora,Uttarakhand',
'Neoliharara,Almora,Uttarakhand',
'Panuwanaula,Almora,Uttarakhand',
'Pitoli,Almora,Uttarakhand',
'Pokhari,Almora,Uttarakhand',
'Salparh,Almora,Uttarakhand',
'Sona Shilling,Almora,Uttarakhand',
'Tapani,Almora,Uttarakhand',
'Thali,Almora,Uttarakhand',
'Thikalna,Almora,Uttarakhand',
'Airari Bisht,Almora,Uttarakhand',
'Basai,Almora,Uttarakhand',
'Bawari Kichar,Almora,Uttarakhand',
'Bhatronjkhan,Almora,Uttarakhand',
'Bhikiyasen,Almora,Uttarakhand',
'Bisrakhet,Almora,Uttarakhand',
'Chachroti,Almora,Uttarakhand',
'Chaunallia,Almora,Uttarakhand',
'Daula,Almora,Uttarakhand',
'Deghat,Almora,Uttarakhand',
'Gudlekh,Almora,Uttarakhand',
'Jayanteshwar Simalchaura,Almora,Uttarakhand',
'Kelani,Almora,Uttarakhand',
'Khadalgaon,Almora,Uttarakhand',
'Kulanteshwar,Almora,Uttarakhand',
'Matela,Almora,Uttarakhand',
'Maulekhal,Almora,Uttarakhand',
'Nail Chaukote,Almora,Uttarakhand',
'Patharkhola,Almora,Uttarakhand',
'Pipalkhal,Almora,Uttarakhand',
'Rudoli,Almora,Uttarakhand',
'Sarikhet,Almora,Uttarakhand',
'Syalde,Almora,Uttarakhand',
'Tamadhaun,Almora,Uttarakhand',
'Udepur,Almora,Uttarakhand',
'Bhairongkhal,Nainital,Uttarakhand',
'Bhagoti,Almora,Uttarakhand',
'Bhatkote,Almora,Uttarakhand',
'Bheltgaon,Almora,Uttarakhand',
'Chhitar,Almora,Uttarakhand',
'Dhamdewal,Almora,Uttarakhand',
'Gairkhet,Almora,Uttarakhand',
'Ganai,Almora,Uttarakhand',
'Godi,Almora,Uttarakhand',
'Jairambakhal,Almora,Uttarakhand',
'Jaurasi,Almora,Uttarakhand',
'Jharkote,Almora,Uttarakhand',
'Khatyari,Almora,Uttarakhand',
'Khira,Almora,Uttarakhand',
'Marku Bakhal,Almora,Uttarakhand',
'Masi,Almora,Uttarakhand',
'Naikana,Almora,Uttarakhand',
'Naula,Almora,Uttarakhand',
'Panduwakhal,Almora,Uttarakhand',
'Rampur,Almora,Uttarakhand',
'Rotapani,Almora,Uttarakhand',
'Sanara,Almora,Uttarakhand',
'Taragtal,Almora,Uttarakhand',
'Timilkhal,Almora,Uttarakhand',
'Turachaura,Almora,Uttarakhand',
'Dwarahat,Almora,Uttarakhand',
'Kafara,Almora,Uttarakhand',
'Jalali,Almora,Uttarakhand',
'Asgoli,Almora,Uttarakhand',
'Bagwalipokhar,Almora,Uttarakhand',
'Kausani Estate,Almora,Uttarakhand',
'Kausani,Almora,Uttarakhand',
'Anuli,Almora,Uttarakhand',
'Bagswar,Almora,Uttarakhand',
'Basantpur,Almora,Uttarakhand',
'Bedchula,Almora,Uttarakhand',
'Bhabu,Almora,Uttarakhand',
'Birkham,Almora,Uttarakhand',
'Chaikhan,Almora,Uttarakhand',
'Chhana Kharkota,Almora,Uttarakhand',
'Dharkhola,Almora,Uttarakhand',
'Dhyuli,Almora,Uttarakhand',
'Jainti,Almora,Uttarakhand',
'Jakh,Almora,Uttarakhand',
'Jalna,Almora,Uttarakhand',
'Jhaldungra,Almora,Uttarakhand',
'Mathena,Almora,Uttarakhand',
'Motiapathar,Almora,Uttarakhand',
'Nail,Almora,Uttarakhand',
'Naura,Almora,Uttarakhand',
'Pubhaon,Almora,Uttarakhand',
'Rajyura,Almora,Uttarakhand',
'Satyun,Almora,Uttarakhand',
'Shaharphatak,Almora,Uttarakhand',
'Syunai,Almora,Uttarakhand',
'Aina,Almora,Uttarakhand',
'Ajoli Malli,Almora,Uttarakhand',
'Almiankande,Almora,Uttarakhand',
'Amyari,Almora,Uttarakhand',
'Bamsyun,Almora,Uttarakhand',
'Barangal,Almora,Uttarakhand',
'Basbhira,Almora,Uttarakhand',
'Basot,Almora,Uttarakhand',
'Bayeri,Almora,Uttarakhand',
'Bhainsoli,Almora,Uttarakhand',
'Bhaunkhal,Almora,Uttarakhand',
'Bhujan,Almora,Uttarakhand',
'Bilekh,Almora,Uttarakhand',
'Binta,Almora,Uttarakhand',
'Bitholi,Almora,Uttarakhand',
'Chakargaon,Almora,Uttarakhand',
'Chamarkhan,Almora,Uttarakhand',
'Chantharia,Almora,Uttarakhand',
'Chaubattia,Almora,Uttarakhand',
'Chaukuni,Almora,Uttarakhand',
'Chhana,Almora,Uttarakhand',
'Chhatena,Almora,Uttarakhand',
'Chhatgulla,Almora,Uttarakhand',
'Chilianaula,Almora,Uttarakhand',
'Chitreshwar,Almora,Uttarakhand',
'Dabhra,Almora,Uttarakhand',
'Darmar,Almora,Uttarakhand',
'Daurakhal,Almora,Uttarakhand',
'Deolikhet,Almora,Uttarakhand',
'Dhamera,Almora,Uttarakhand',
'Dunagiri,Almora,Uttarakhand',
'Dwarson,Almora,Uttarakhand',
'Ganiadeoli,Almora,Uttarakhand',
'Gewar,Almora,Uttarakhand',
'Ghatti,Almora,Uttarakhand',
'Ghuguti Kelani,Almora,Uttarakhand',
'Haldiyani,Almora,Uttarakhand',
'Harara,Almora,Uttarakhand',
'Irah,Almora,Uttarakhand',
'Jaikhal,Almora,Uttarakhand',
'Jakh,Almora,Uttarakhand',
'Jamoli,Almora,Uttarakhand',
'Kalika Estate,Almora,Uttarakhand',
'Kanoli,Almora,Uttarakhand',
'Khalna,Almora,Uttarakhand',
'Khirkhet,Almora,Uttarakhand',
'Kotagiwai,Almora,Uttarakhand',
'Kotar,Almora,Uttarakhand',
'Kotuli Malli,Almora,Uttarakhand',
'Kulsibi,Almora,Uttarakhand',
'Kunhil,Almora,Uttarakhand',
'Kuwali,Almora,Uttarakhand',
'Machhor,Almora,Uttarakhand',
'Mahakaleshwar,Almora,Uttarakhand',
'Majkhali,Almora,Uttarakhand',
'Manela,Almora,Uttarakhand',
'Mangdoli,Almora,Uttarakhand',
'Manila,Almora,Uttarakhand',
'Manuli,Almora,Uttarakhand',
'Masar,Almora,Uttarakhand',
'Mirai Malli,Almora,Uttarakhand',
'Munani,Almora,Uttarakhand',
'Nagarjhan,Almora,Uttarakhand',
'Naila,Almora,Uttarakhand',
'Naubara,Almora,Uttarakhand',
'Naulakote,Almora,Uttarakhand',
'Paithani,Almora,Uttarakhand',
'Pali,Almora,Uttarakhand',
'Pandekota,Almora,Uttarakhand',
'Pantgaon,Almora,Uttarakhand',
'Pantkotuli,Almora,Uttarakhand',
'Panuwadeokhan,Almora,Uttarakhand',
'Pilkholi,Almora,Uttarakhand',
'Querala,Almora,Uttarakhand',
'Ranikhet Kutchery,Almora,Uttarakhand',
'Ranikhet Sadar Bazar,Almora,Uttarakhand',
'Ratgal,Almora,Uttarakhand',
'Rokhon,Almora,Uttarakhand',
'Sagneti,Almora,Uttarakhand',
'Sainmanpur,Almora,Uttarakhand',
'Saknara,Almora,Uttarakhand',
'Sauni,Almora,Uttarakhand',
'Seem,Almora,Uttarakhand',
'Shishuwa,Almora,Uttarakhand',
'Silor Mahadev,Almora,Uttarakhand',
'Sinar,Almora,Uttarakhand',
'Sinora,Almora,Uttarakhand',
'Sure,Almora,Uttarakhand',
'Tarikhet,Almora,Uttarakhand',
'Taya,Almora,Uttarakhand',
'Timtha,Almora,Uttarakhand',
'Tolyun,Almora,Uttarakhand',
'Totam,Almora,Uttarakhand',
'Ugalia,Almora,Uttarakhand',
'Ujrar,Almora,Uttarakhand',
'Uprari Chaukote,Almora,Uttarakhand',
'Uprari,Almora,Uttarakhand',
'Amdhar,Almora,Uttarakhand',
'Bangidhar,Almora,Uttarakhand',
'Bhyari,Almora,Uttarakhand',
'Chamkana,Almora,Uttarakhand',
'Debikhal,Almora,Uttarakhand',
'Garkote Malla,Almora,Uttarakhand',
'Jhimar,Almora,Uttarakhand',
'Kafalata Malla,Almora,Uttarakhand',
'Khumar,Almora,Uttarakhand',
'Maithani,Almora,Uttarakhand',
'Manhet,Almora,Uttarakhand',
'Painsia,Almora,Uttarakhand',
'Pipna,Almora,Uttarakhand',
'Bainskhet,Almora,Uttarakhand',
'Baninsargaon,Almora,Uttarakhand',
'Bhagtola,Almora,Uttarakhand',
'Bhoolgaon,Almora,Uttarakhand',
'Chanoda,Almora,Uttarakhand',
'Dhaulaghat,Almora,Uttarakhand',
'Dhaulara Totashilling,Almora,Uttarakhand',
'Dhaularh,Almora,Uttarakhand',
'Dhaunigarh,Almora,Uttarakhand',
'Gewapani,Almora,Uttarakhand',
'Golchhina,Almora,Uttarakhand',
'Jhupulchaura,Almora,Uttarakhand',
'Kantali,Almora,Uttarakhand',
'Lakhani,Almora,Uttarakhand',
'Laubanj,Almora,Uttarakhand',
'Lod,Almora,Uttarakhand',
'Lweshal,Almora,Uttarakhand',
'Manan,Almora,Uttarakhand',
'Naughar Estate,Almora,Uttarakhand',
'Patalibangar,Almora,Uttarakhand',
'Pokhari,Almora,Uttarakhand',
'Ramara,Almora,Uttarakhand',
'Ranban,Almora,Uttarakhand',
'Rasyaragaon,Almora,Uttarakhand',
'Rikhe,Almora,Uttarakhand',
'Someshwar,Almora,Uttarakhand',
'Takula,Almora,Uttarakhand',
'Thapania,Almora,Uttarakhand',
'Amsarkote,Almora,Uttarakhand',
'Are,Almora,Uttarakhand',
'Ason,Almora,Uttarakhand',
'Ason Mallakote,Almora,Uttarakhand',
'Bageshwar,Almora,Uttarakhand',
'Bahuli,Almora,Uttarakhand',
'Baisani,Almora,Uttarakhand',
'Bauri,Almora,Uttarakhand',
'Bhairu Chaubatta,Almora,Uttarakhand',
'Bhataura,Almora,Uttarakhand',
'Bhatoli,Almora,Uttarakhand',
'Billori,Almora,Uttarakhand',
'Bilonasera,Almora,Uttarakhand',
'Bohala,Almora,Uttarakhand',
'Chamarthal,Almora,Uttarakhand',
'Chaura,Almora,Uttarakhand',
'Chhani,Almora,Uttarakhand',
'Chirang,Almora,Uttarakhand',
'Darimthok,Almora,Uttarakhand',
'Dewalchaura,Almora,Uttarakhand',
'Dewaldhar,Almora,Uttarakhand',
'Doba Katyur,Almora,Uttarakhand',
'Dug Bazar,Almora,Uttarakhand',
'Falyati,Almora,Uttarakhand',
'Gairar,Almora,Uttarakhand',
'Ghingartola,Almora,Uttarakhand',
'Ghiroli,Almora,Uttarakhand',
'Gurna Kamsyar,Almora,Uttarakhand',
'Harbarh,Almora,Uttarakhand',
'Harsila,Almora,Uttarakhand',
'Jagthana,Almora,Uttarakhand',
'Janoti Palari,Almora,Uttarakhand',
'Jaulkande,Almora,Uttarakhand',
'Kafaligair,Almora,Uttarakhand',
'Kanyalikote,Almora,Uttarakhand',
'Kathayatbara,Almora,Uttarakhand',
'Kathpurchhina,Almora,Uttarakhand',
'Khankar,Almora,Uttarakhand',
'Khaulsir,Almora,Uttarakhand',
'Lob,Almora,Uttarakhand',
'Malta,Almora,Uttarakhand',
'Mandalsera,Almora,Uttarakhand',
'Okhalisirod,Almora,Uttarakhand',
'Pandrapali,Almora,Uttarakhand',
'Queralli,Almora,Uttarakhand',
'Simyari,Almora,Uttarakhand',
'Syaldova,Almora,Uttarakhand',
'Tachhani,Almora,Uttarakhand',
'Tuper,Almora,Uttarakhand',
'Udera,Almora,Uttarakhand',
'Anna,Almora,Uttarakhand',
'Baijnath,Almora,Uttarakhand',
'Bamrari,Almora,Uttarakhand',
'Bantoli,Almora,Uttarakhand',
'Bheta,Almora,Uttarakhand',
'Bhilkote,Almora,Uttarakhand',
'Charson,Almora,Uttarakhand',
'Dangoli,Almora,Uttarakhand',
'Deonai,Almora,Uttarakhand',
'Gagarigole,Almora,Uttarakhand',
'Jakhera,Almora,Uttarakhand',
'Kandhar,Almora,Uttarakhand',
'Kapkoti,Almora,Uttarakhand',
'Kotiyura,Almora,Uttarakhand',
'Kulaon,Almora,Uttarakhand',
'Maigri Estate,Almora,Uttarakhand',
'Matena,Almora,Uttarakhand',
'Mostgaon,Almora,Uttarakhand',
'Okhalson,Almora,Uttarakhand',
'Patli,Almora,Uttarakhand',
'Payya,Almora,Uttarakhand',
'Pinglow,Almora,Uttarakhand',
'Ratisera,Almora,Uttarakhand',
'Rawaikhal,Almora,Uttarakhand',
'Salani,Almora,Uttarakhand',
'Sirkote,Almora,Uttarakhand',
'Tilsari,Almora,Uttarakhand',
'Wajyula,Almora,Uttarakhand',
'Bantola,Almora,Uttarakhand',
'Dewal Bichral,Almora,Uttarakhand',
'Dhapolasera,Almora,Uttarakhand',
'Dhapti,Almora,Uttarakhand',
'Jakhani,Almora,Uttarakhand',
'Jethai,Almora,Uttarakhand',
'Jhankra,Almora,Uttarakhand',
'Kameridevi,Almora,Uttarakhand',
'Kanda,Almora,Uttarakhand',
'Kapoori,Almora,Uttarakhand',
'Khantoli,Almora,Uttarakhand',
'Khatigaon,Almora,Uttarakhand',
'Mahruri,Almora,Uttarakhand',
'Malsoona,Almora,Uttarakhand',
'Mantoli,Almora,Uttarakhand',
'Nargoli,Almora,Uttarakhand',
'Rawatsera,Almora,Uttarakhand',
'Sani Udiyar,Almora,Uttarakhand',
'Simkuna,Almora,Uttarakhand',
'Syankote,Almora,Uttarakhand',
'Uprara,Almora,Uttarakhand',
'Vijaipur,Almora,Uttarakhand',
'Badiakote,Almora,Uttarakhand',
'Baghar,Almora,Uttarakhand',
'Baira,Almora,Uttarakhand',
'Banlekh,Almora,Uttarakhand',
'Bhanar,Almora,Uttarakhand',
'Bharari,Almora,Uttarakhand',
'Daula,Almora,Uttarakhand',
'Dofar,Almora,Uttarakhand',
'Farsali,Almora,Uttarakhand',
'Fulwari,Almora,Uttarakhand',
'Gadera,Almora,Uttarakhand',
'Gasi,Almora,Uttarakhand',
'Gogina,Almora,Uttarakhand',
'Guler,Almora,Uttarakhand',
'Harkote,Almora,Uttarakhand',
'Harsingiabaghar,Almora,Uttarakhand',
'Horali,Almora,Uttarakhand',
'Jarati,Almora,Uttarakhand',
'Jhuni,Almora,Uttarakhand',
'Junayal,Almora,Uttarakhand',
'Kafali,Almora,Uttarakhand',
'Kanoli,Almora,Uttarakhand',
'Kapkote,Almora,Uttarakhand',
'Karmi,Almora,Uttarakhand',
'Khati,Almora,Uttarakhand',
'Kheti(Danpur),Almora,Uttarakhand',
'Lahur,Almora,Uttarakhand',
'Lathi,Almora,Uttarakhand',
'Lili,Almora,Uttarakhand',
'Liti,Almora,Uttarakhand',
'Loharkhet,Almora,Uttarakhand',
'Nachati,Almora,Uttarakhand',
'Namik,Almora,Uttarakhand',
'Namtichetabagar,Almora,Uttarakhand',
'Nargarha,Almora,Uttarakhand',
'Papon,Almora,Uttarakhand',
'Pothing,Almora,Uttarakhand',
'Purkuni,Almora,Uttarakhand',
'Ratirketi,Almora,Uttarakhand',
'Saneti,Almora,Uttarakhand',
'Sangarh,Almora,Uttarakhand',
'Shama,Almora,Uttarakhand',
'Sorag,Almora,Uttarakhand',
'Supi,Almora,Uttarakhand',
'Utraura,Almora,Uttarakhand',
'Gananath Vidyapeeth,Almora,Uttarakhand',
'Bachher,Chamoli,Uttarakhand',
'Bagana,Chamoli,Uttarakhand',
'Bairangana,Chamoli,Uttarakhand',
'Bansbara,Chamoli,Uttarakhand',
'Bemaru,Chamoli,Uttarakhand',
'Bhimtalla,Chamoli,Uttarakhand',
'Chamoli,Chamoli,Uttarakhand',
'Chhinka,Chamoli,Uttarakhand',
'Dewarkhadora,Chamoli,Uttarakhand',
'Gadora,Chamoli,Uttarakhand',
'Gari,Chamoli,Uttarakhand',
'Gauna,Chamoli,Uttarakhand',
'Gopeshwar Collectorate,Chamoli,Uttarakhand',
'Gopeshwar Degree College,Chamoli,Uttarakhand',
'Gopeshwar H.O,Chamoli,Uttarakhand',
'Gwardewaldhar,Chamoli,Uttarakhand',
'Irani,Chamoli,Uttarakhand',
'Kandai-manakhi,Chamoli,Uttarakhand',
'Khunana,Chamoli,Uttarakhand',
'Lasiyari,Chamoli,Uttarakhand',
'Maikot,Chamoli,Uttarakhand',
'Maithana,Chamoli,Uttarakhand',
'Mandal,Chamoli,Uttarakhand',
'Masson,Chamoli,Uttarakhand',
'Matai,Chamoli,Uttarakhand',
'Mayapur,Chamoli,Uttarakhand',
'Mokh,Chamoli,Uttarakhand',
'Nandprayag,Chamoli,Uttarakhand',
'Palethi,Chamoli,Uttarakhand',
'Ropa,Chamoli,Uttarakhand',
'Saikot,Chamoli,Uttarakhand',
'Sakand,Chamoli,Uttarakhand',
'Sonla Baunli,Chamoli,Uttarakhand',
'Tangsa,Chamoli,Uttarakhand',
'Malai,Chamoli,Uttarakhand',
'Adibadri,Chamoli,Uttarakhand',
'Andrapa,Chamoli,Uttarakhand',
'Bachhuwaban,Chamoli,Uttarakhand',
'Beena Lohba,Chamoli,Uttarakhand',
'Bhatoli,Chamoli,Uttarakhand',
'Chaurasain,Chamoli,Uttarakhand',
'Dewalkot,Chamoli,Uttarakhand',
'Farkande Talli,Chamoli,Uttarakhand',
'Gairsain,Chamoli,Uttarakhand',
'Gaul,Chamoli,Uttarakhand',
'Jhumakhet,Chamoli,Uttarakhand',
'Kansuwa,Chamoli,Uttarakhand',
'Kheti,Chamoli,Uttarakhand',
'Kirsal,Chamoli,Uttarakhand',
'Koonigarh Bichali,Chamoli,Uttarakhand',
'Majiyari Malli,Chamoli,Uttarakhand',
'Majiyari Talli,Chamoli,Uttarakhand',
'Malkot,Chamoli,Uttarakhand',
'Marora,Chamoli,Uttarakhand',
'Mehalchauri,Chamoli,Uttarakhand',
'Nagali,Chamoli,Uttarakhand',
'Nailkhansar,Chamoli,Uttarakhand',
'Nauti,Chamoli,Uttarakhand',
'Panchali,Chamoli,Uttarakhand',
'Pindwali,Chamoli,Uttarakhand',
'Ramra,Chamoli,Uttarakhand',
'Rohira,Chamoli,Uttarakhand',
'Sainji,Chamoli,Uttarakhand',
'Saring Gaon,Chamoli,Uttarakhand',
'Sarkot,Chamoli,Uttarakhand',
'Silpata,Chamoli,Uttarakhand',
'Tentura,Chamoli,Uttarakhand',
'Ujjwal Pur,Chamoli,Uttarakhand',
'Malethi,Chamoli,Uttarakhand',
'Bangali,Chamoli,Uttarakhand',
'Banjbagar,Chamoli,Uttarakhand',
'Bhenti,Chamoli,Uttarakhand',
'Bura Alla,Chamoli,Uttarakhand',
'Ghat,Chamoli,Uttarakhand',
'Ghooni,Chamoli,Uttarakhand',
'Gulari,Chamoli,Uttarakhand',
'Kanol,Chamoli,Uttarakhand',
'Kurur,Chamoli,Uttarakhand',
'Lankhi,Chamoli,Uttarakhand',
'Luntra,Chamoli,Uttarakhand',
'Pagna,Chamoli,Uttarakhand',
'Perisutol,Chamoli,Uttarakhand',
'Ramani,Chamoli,Uttarakhand',
'Sema,Chamoli,Uttarakhand',
'Senti,Chamoli,Uttarakhand',
'Sung,Chamoli,Uttarakhand',
'Sutol,Chamoli,Uttarakhand',
'Ustoli,Chamoli,Uttarakhand',
'Badrinath Seasonal,Chamoli,Uttarakhand',
'Bampa Seasonal,Chamoli,Uttarakhand',
'Baragaon,Chamoli,Uttarakhand',
'Bharki,Chamoli,Uttarakhand',
'Bhyundhar,Chamoli,Uttarakhand',
'Chain,Chamoli,Uttarakhand',
'Dhak,Chamoli,Uttarakhand',
'Dumak,Chamoli,Uttarakhand',
'Dweeng,Chamoli,Uttarakhand',
'Ganaimolta,Chamoli,Uttarakhand',
'Garurganga,Chamoli,Uttarakhand',
'Govindghat,Chamoli,Uttarakhand',
'Gulabkoti,Chamoli,Uttarakhand',
'Hanuman Chatti,Chamoli,Uttarakhand',
'Jakhola,Chamoli,Uttarakhand',
'Jelam,Chamoli,Uttarakhand',
'Joshimath,Chamoli,Uttarakhand',
'Lambagar,Chamoli,Uttarakhand',
'Langsi,Chamoli,Uttarakhand',
'Lata,Chamoli,Uttarakhand',
'Malari Seasonal,Chamoli,Uttarakhand',
'Mana,Chamoli,Uttarakhand',
'Narsing Mandir,Chamoli,Uttarakhand',
'Niti,Chamoli,Uttarakhand',
'Pagnapainkhanda,Chamoli,Uttarakhand',
'Paini,Chamoli,Uttarakhand',
'Pandukeshwar,Chamoli,Uttarakhand',
'Pipalkoti,Chamoli,Uttarakhand',
'Pokhani,Chamoli,Uttarakhand',
'Rainipalla,Chamoli,Uttarakhand',
'Regari,Chamoli,Uttarakhand',
'Ruingdranagiri,Chamoli,Uttarakhand',
'Salurdungra,Chamoli,Uttarakhand',
'Selang,Chamoli,Uttarakhand',
'Subhain,Chamoli,Uttarakhand',
'Sunil,Chamoli,Uttarakhand',
'Suraithota,Chamoli,Uttarakhand',
'Tangani,Chamoli,Uttarakhand',
'Tapoban,Chamoli,Uttarakhand',
'Thaing,Chamoli,Uttarakhand',
'Triveni,Chamoli,Uttarakhand',
'Urgam,Chamoli,Uttarakhand',
'Vishnupuram,Chamoli,Uttarakhand',
'Bagoli,Chamoli,Uttarakhand',
'Bainoli,Chamoli,Uttarakhand',
'Barmoli,Chamoli,Uttarakhand',
'Bartoli,Chamoli,Uttarakhand',
'Chaundali,Chamoli,Uttarakhand',
'Dhunglwali,Chamoli,Uttarakhand',
'Dimmar,Chamoli,Uttarakhand',
'Gairoli,Chamoli,Uttarakhand',
'Gauchar,Chamoli,Uttarakhand',
'Ghandiyal,Chamoli,Uttarakhand',
'Jainta,Chamoli,Uttarakhand',
'Jakh,Chamoli,Uttarakhand',
'Kalusain,Chamoli,Uttarakhand',
'Kamera,Chamoli,Uttarakhand',
'Kanchula,Chamoli,Uttarakhand',
'Kanda Maikhura,Chamoli,Uttarakhand',
'Kankhul,Chamoli,Uttarakhand',
'Kanoth,Chamoli,Uttarakhand',
'Karanprayag,Chamoli,Uttarakhand',
'Karchhuna,Chamoli,Uttarakhand',
'Kedarukhal,Chamoli,Uttarakhand',
'Khandura,Chamoli,Uttarakhand',
'Kharsain,Chamoli,Uttarakhand',
'Kimoli,Chamoli,Uttarakhand',
'Koladungri,Chamoli,Uttarakhand',
'Kotkandara,Chamoli,Uttarakhand',
'Langasu,Chamoli,Uttarakhand',
'Naini Chandpur,Chamoli,Uttarakhand',
'Nainisain,Chamoli,Uttarakhand',
'Nauli,Chamoli,Uttarakhand',
'Ranoun,Chamoli,Uttarakhand',
'Ratura,Chamoli,Uttarakhand',
'Saliyana,Chamoli,Uttarakhand',
'Sari,Chamoli,Uttarakhand',
'Senu,Chamoli,Uttarakhand',
'Shantisadan,Chamoli,Uttarakhand',
'Sidoli,Chamoli,Uttarakhand',
'Simali,Chamoli,Uttarakhand',
'Sonla,Chamoli,Uttarakhand',
'Tefna,Chamoli,Uttarakhand',
'Thirpak,Chamoli,Uttarakhand',
'Umatta Chatti,Chamoli,Uttarakhand',
'Ali,Chamoli,Uttarakhand',
'Beena Malla,Chamoli,Uttarakhand',
'Bhikona,Chamoli,Uttarakhand',
'Bishalkhal,Chamoli,Uttarakhand',
'Harishankar,Chamoli,Uttarakhand',
'Izzar,Chamoli,Uttarakhand',
'Jakhamala,Chamoli,Uttarakhand',
'Jilasu,Chamoli,Uttarakhand',
'Kalsir,Chamoli,Uttarakhand',
'Khal,Chamoli,Uttarakhand',
'Kujasu,Chamoli,Uttarakhand',
'Kweenthi,Chamoli,Uttarakhand',
'Masoli,Chamoli,Uttarakhand',
'Pokhari Nagnath,Chamoli,Uttarakhand',
'Raduwa,Chamoli,Uttarakhand',
'Rauta,Chamoli,Uttarakhand',
'Salna,Chamoli,Uttarakhand',
'Saranaairas,Chamoli,Uttarakhand',
'Simlasu,Chamoli,Uttarakhand',
'Siwai,Chamoli,Uttarakhand',
'Thalabair,Chamoli,Uttarakhand',
'Trisula,Chamoli,Uttarakhand',
'Udamanda,Chamoli,Uttarakhand',
'Duwa,Chamoli,Uttarakhand',
'Aser Simli,Chamoli,Uttarakhand',
'Balan,Chamoli,Uttarakhand',
'Ban,Chamoli,Uttarakhand',
'Beradhar,Chamoli,Uttarakhand',
'Bhagoti,Chamoli,Uttarakhand',
'Boragarh,Chamoli,Uttarakhand',
'Burjola,Chamoli,Uttarakhand',
'Chaliyapani,Chamoli,Uttarakhand',
'Chaur,Chamoli,Uttarakhand',
'Cheproun,Chamoli,Uttarakhand',
'Chhekura,Chamoli,Uttarakhand',
'Chiringa,Chamoli,Uttarakhand',
'Chopta,Chamoli,Uttarakhand',
'Choting,Chamoli,Uttarakhand',
'Debal,Chamoli,Uttarakhand',
'Devsari,Chamoli,Uttarakhand',
'Dungri Karakot,Chamoli,Uttarakhand',
'Dungri Pindarpar,Chamoli,Uttarakhand',
'Gabani,Chamoli,Uttarakhand',
'Gadsira,Chamoli,Uttarakhand',
'Gairbaram,Chamoli,Uttarakhand',
'Garkot,Chamoli,Uttarakhand',
'Gerur,Chamoli,Uttarakhand',
'Ghesh,Chamoli,Uttarakhand',
'Gwaldam,Chamoli,Uttarakhand',
'Harmani,Chamoli,Uttarakhand',
'Jainbisht,Chamoli,Uttarakhand',
'Jakhapatiyun,Chamoli,Uttarakhand',
'Jhinjhoni,Chamoli,Uttarakhand',
'Kafoli Malli,Chamoli,Uttarakhand',
'Khainoli,Chamoli,Uttarakhand',
'Kheta,Chamoli,Uttarakhand',
'Kimani,Chamoli,Uttarakhand',
'Kimoli,Chamoli,Uttarakhand',
'Kobthan,Chamoli,Uttarakhand',
'Kooni,Chamoli,Uttarakhand',
'Kothuli,Chamoli,Uttarakhand',
'Kulsari,Chamoli,Uttarakhand',
'Kurar,Chamoli,Uttarakhand',
'Lodla,Chamoli,Uttarakhand',
'Lwani,Chamoli,Uttarakhand',
'Maita,Chamoli,Uttarakhand',
'Mauna,Chamoli,Uttarakhand',
'Melkhet,Chamoli,Uttarakhand',
'Ming Gadhera,Chamoli,Uttarakhand',
'Mundoli,Chamoli,Uttarakhand',
'Naini,Chamoli,Uttarakhand',
'Nakholi,Chamoli,Uttarakhand',
'Nalgaun,Chamoli,Uttarakhand',
'Nandkeshari,Chamoli,Uttarakhand',
'Narainbagar,Chamoli,Uttarakhand',
'Paithani,Chamoli,Uttarakhand',
'Rain,Chamoli,Uttarakhand',
'Ratgaon,Chamoli,Uttarakhand',
'Sawar,Chamoli,Uttarakhand',
'Silori,Chamoli,Uttarakhand',
'Sunaonbhenta,Chamoli,Uttarakhand',
'Sunla,Chamoli,Uttarakhand',
'Suya,Chamoli,Uttarakhand',
'Talwari,Chamoli,Uttarakhand',
'Tharali,Chamoli,Uttarakhand',
'Torti,Chamoli,Uttarakhand',
'Tungeshwar,Chamoli,Uttarakhand',
'Ulangra,Chamoli,Uttarakhand',
'Chalthi,Pithoragarh,Uttarakhand',
'Champawat,Pithoragarh,Uttarakhand',
'Deuri,Pithoragarh,Uttarakhand',
'Dhamisaun,Pithoragarh,Uttarakhand',
'Dhaun,Pithoragarh,Uttarakhand',
'Dudhpokhra,Pithoragarh,Uttarakhand',
'Fungar,Pithoragarh,Uttarakhand',
'Kotajamrari,Pithoragarh,Uttarakhand',
'Kotkendri,Pithoragarh,Uttarakhand',
'Manch,Pithoragarh,Uttarakhand',
'Maurari,Pithoragarh,Uttarakhand',
'Neer,Pithoragarh,Uttarakhand',
'Pungla Amori,Pithoragarh,Uttarakhand',
'Ramaila,Pithoragarh,Uttarakhand',
'Riyansi,Pithoragarh,Uttarakhand',
'Saindark,Pithoragarh,Uttarakhand',
'Shyamlatal,Pithoragarh,Uttarakhand',
'Simiyan,Pithoragarh,Uttarakhand',
'Sukhidhang,Pithoragarh,Uttarakhand',
'Swala,Pithoragarh,Uttarakhand',
'Tamli,Pithoragarh,Uttarakhand',
'Abbotmount,Pithoragarh,Uttarakhand',
'Bagoti,Pithoragarh,Uttarakhand',
'Banku,Pithoragarh,Uttarakhand',
'Bapru,Pithoragarh,Uttarakhand',
'Barakote,Pithoragarh,Uttarakhand',
'Bardakhan,Pithoragarh,Uttarakhand',
'Bhingrara,Pithoragarh,Uttarakhand',
'Bhumbari,Pithoragarh,Uttarakhand',
'Bhumlai,Pithoragarh,Uttarakhand',
'Bibil,Pithoragarh,Uttarakhand',
'Birgul,Pithoragarh,Uttarakhand',
'Chanda Regru,Pithoragarh,Uttarakhand',
'Chaumel,Pithoragarh,Uttarakhand',
'Chaurakote,Pithoragarh,Uttarakhand',
'Chauramehta,Pithoragarh,Uttarakhand',
'Chilkote,Pithoragarh,Uttarakhand',
'Chirra,Pithoragarh,Uttarakhand',
'Devidhura,Pithoragarh,Uttarakhand',
'Dhorja,Pithoragarh,Uttarakhand',
'Dhunaghat,Pithoragarh,Uttarakhand',
'Digalichaur,Pithoragarh,Uttarakhand',
'Gagar,Pithoragarh,Uttarakhand',
'Galchaura,Pithoragarh,Uttarakhand',
'Gallagaon,Pithoragarh,Uttarakhand',
'Gunthgarsari,Pithoragarh,Uttarakhand',
'Ijara,Pithoragarh,Uttarakhand',
'Jankandey,Pithoragarh,Uttarakhand',
'Jhudeli,Pithoragarh,Uttarakhand',
'Kanakote,Pithoragarh,Uttarakhand',
'Karnkarayat,Pithoragarh,Uttarakhand',
'Khateramalla,Pithoragarh,Uttarakhand',
'Khetikhan,Pithoragarh,Uttarakhand',
'Khunabora,Pithoragarh,Uttarakhand',
'Kothera,Pithoragarh,Uttarakhand',
'Koyati,Pithoragarh,Uttarakhand',
'Leti,Pithoragarh,Uttarakhand',
'Lohaghat,Pithoragarh,Uttarakhand',
'Machiyar,Pithoragarh,Uttarakhand',
'Madhuwa,Pithoragarh,Uttarakhand',
'Madlak,Pithoragarh,Uttarakhand',
'Mau,Pithoragarh,Uttarakhand',
'Mayawati,Pithoragarh,Uttarakhand',
'Mulakote,Pithoragarh,Uttarakhand',
'Nidil,Pithoragarh,Uttarakhand',
'Pati,Pithoragarh,Uttarakhand',
'Pulhindola,Pithoragarh,Uttarakhand',
'Raigaon,Pithoragarh,Uttarakhand',
'Rausal,Pithoragarh,Uttarakhand',
'Rithakhal,Pithoragarh,Uttarakhand',
'Sango,Pithoragarh,Uttarakhand',
'Shillinga,Pithoragarh,Uttarakhand',
'Simalkhet,Pithoragarh,Uttarakhand',
'Sungarkhal,Pithoragarh,Uttarakhand',
'Thanta,Pithoragarh,Uttarakhand',
'Timla,Pithoragarh,Uttarakhand',
'Banbassa Canal,Nainital,Uttarakhand',
'Chandani,Nainital,Uttarakhand',
'Lohia Head,Nainital,Uttarakhand',
'Tanakpur,Nainital,Uttarakhand',
'Narsan Kalan,Dehradun,Uttarakhand',
'Barontha,Dehradun,Uttarakhand',
'Maletha,Dehradun,Uttarakhand',
'Badho,Dehradun,Uttarakhand',
'Baila,Dehradun,Uttarakhand',
'Barwa,Dehradun,Uttarakhand',
'Bhandrauli,Dehradun,Uttarakhand',
'Bijau,Dehradun,Uttarakhand',
'Birmau,Dehradun,Uttarakhand',
'Bullard,Dehradun,Uttarakhand',
'Chakrata,Dehradun,Uttarakhand',
'Chhibroo,Dehradun,Uttarakhand',
'Dassau,Dehradun,Uttarakhand',
'Datnu,Dehradun,Uttarakhand',
'Dawla,Dehradun,Uttarakhand',
'Dessau,Dehradun,Uttarakhand',
'Dimau,Dehradun,Uttarakhand',
'Dungiara,Dehradun,Uttarakhand',
'Gadsar,Dehradun,Uttarakhand',
'Gangroo,Dehradun,Uttarakhand',
'Ghanta,Dehradun,Uttarakhand',
'Haripur,Dehradun,Uttarakhand',
'Haza,Dehradun,Uttarakhand',
'Ichhari,Dehradun,Uttarakhand',
'Jaddi,Dehradun,Uttarakhand',
'Jissau,Dehradun,Uttarakhand',
'Jogio,Dehradun,Uttarakhand',
'Kailana,Dehradun,Uttarakhand',
'Kamla,Dehradun,Uttarakhand',
'Kandoi,Dehradun,Uttarakhand',
'Khabau,Dehradun,Uttarakhand',
'Khadar,Dehradun,Uttarakhand',
'Khamrauli,Dehradun,Uttarakhand',
'Kharora,Dehradun,Uttarakhand',
'Kharsi,Dehradun,Uttarakhand',
'Korwa,Dehradun,Uttarakhand',
'Kota,Dehradun,Uttarakhand',
'Kothi,Dehradun,Uttarakhand',
'Koti,Dehradun,Uttarakhand',
'Koti,Dehradun,Uttarakhand',
'Kunawa,Dehradun,Uttarakhand',
'Kunna,Dehradun,Uttarakhand',
'Kuwanoo,Dehradun,Uttarakhand',
'Kyari,Dehradun,Uttarakhand',
'Lakhamandal,Dehradun,Uttarakhand',
'Lakhwar,Dehradun,Uttarakhand',
'Laksyar,Dehradun,Uttarakhand',
'Lohari,Dehradun,Uttarakhand',
'Lohari,Dehradun,Uttarakhand',
'Lorli,Dehradun,Uttarakhand',
'Ludhera,Dehradun,Uttarakhand',
'Marlau,Dehradun,Uttarakhand',
'Masak,Dehradun,Uttarakhand',
'Matiyawa,Dehradun,Uttarakhand',
'Mindal,Dehradun,Uttarakhand',
'Mundhan,Dehradun,Uttarakhand',
'Myunda,Dehradun,Uttarakhand',
'Nada,Dehradun,Uttarakhand',
'Nagau,Dehradun,Uttarakhand',
'Nagthat,Dehradun,Uttarakhand',
'Naraya,Dehradun,Uttarakhand',
'Sahiya,Dehradun,Uttarakhand',
'Sainj,Dehradun,Uttarakhand',
'Samalta,Dehradun,Uttarakhand',
'Sujau,Dehradun,Uttarakhand',
'Thaina,Dehradun,Uttarakhand',
'Tuini,Dehradun,Uttarakhand',
'Tungra,Dehradun,Uttarakhand',
'Ubhreau,Dehradun,Uttarakhand',
'Ambiwala,Dehradun,Uttarakhand',
'Dehradun City,Dehradun,Uttarakhand',
'Balawala,Dehradun,Uttarakhand',
'Ajabpur,Dehradun,Uttarakhand',
'Anarwala,Dehradun,Uttarakhand',
'Araghar,Dehradun,Uttarakhand',
'Arahat Bazar,Dehradun,Uttarakhand',
'Arkediagrant,Dehradun,Uttarakhand',
'Badonwala,Dehradun,Uttarakhand',
'Badripur,Dehradun,Uttarakhand',
'Ballupur,Dehradun,Uttarakhand',
'Banjarawala,Dehradun,Uttarakhand',
'Barasi,Dehradun,Uttarakhand',
'Barlowganj,Dehradun,Uttarakhand',
'Bhagwantpur,Dehradun,Uttarakhand',
'Bhauwala,Dehradun,Uttarakhand',
'Bidholi,Dehradun,Uttarakhand',
'Bullawala,Dehradun,Uttarakhand',
'Cannaught Place,Dehradun,Uttarakhand',
'CDA(A.F),Dehradun,Uttarakhand',
'Chauki Dhaulas,Dehradun,Uttarakhand',
'Chhiddarwala,Dehradun,Uttarakhand',
'Clementtown,Dehradun,Uttarakhand',
'Dakra,Dehradun,Uttarakhand',
'Defence Colony,Dehradun,Uttarakhand',
'Dehradun G.P.O.,Dehradun,Uttarakhand',
'Dehradun Kty,Dehradun,Uttarakhand',
'Dilaram Bazar,Dehradun,Uttarakhand',
'Dodhli,Dehradun,Uttarakhand',
'Doiwala Bazar,Dehradun,Uttarakhand',
'Doiwala,Dehradun,Uttarakhand',
'Dwara,Dehradun,Uttarakhand',
'Fatehpur Tanda,Dehradun,Uttarakhand',
'Ghangora,Dehradun,Uttarakhand',
'Govindgarh,Dehradun,Uttarakhand',
'Gujrara,Dehradun,Uttarakhand',
'Harrawala,Dehradun,Uttarakhand',
'Hathi Barkala Estate,Dehradun,Uttarakhand',
'Hathi Barkala,Dehradun,Uttarakhand',
'I.I.P.,Dehradun,Uttarakhand',
'I.M.A.,Dehradun,Uttarakhand',
'I.N.C.,Dehradun,Uttarakhand',
'I.P.E.,Dehradun,Uttarakhand',
'Jhanda Bazar,Dehradun,Uttarakhand',
'Kandoli,Dehradun,Uttarakhand',
'Kanwali,Dehradun,Uttarakhand',
'Kanwali Road,Dehradun,Uttarakhand',
'Karanpur,Dehradun,Uttarakhand',
'Kaulagarh,Dehradun,Uttarakhand',
'Khairi,Dehradun,Uttarakhand',
'Khurbura,Dehradun,Uttarakhand',
'Kingcraig,Dehradun,Uttarakhand',
'Kishanpur,Dehradun,Uttarakhand',
'Kulhan,Dehradun,Uttarakhand',
'Lachhiwala,Dehradun,Uttarakhand',
'Majra,Dehradun,Uttarakhand',
'Maldevta,Dehradun,Uttarakhand',
'Manduwala,Dehradun,Uttarakhand',
'Markhamgarant,Dehradun,Uttarakhand',
'Mehuwala,Dehradun,Uttarakhand',
'Mohbewala,Dehradun,Uttarakhand',
'Mothrowala,Dehradun,Uttarakhand',
'Nagal Bulandawala,Dehradun,Uttarakhand',
'Nagal Jwalapur,Dehradun,Uttarakhand',
'Nakronda,Dehradun,Uttarakhand',
'Nathuwala,Dehradun,Uttarakhand',
'Nawada,Dehradun,Uttarakhand',
'Nehrugram,Dehradun,Uttarakhand',
'Neshvilla Road,Dehradun,Uttarakhand',
'Newforest,Dehradun,Uttarakhand',
'Nivh,Dehradun,Uttarakhand',
'Panditwari,Dehradun,Uttarakhand',
'Patel Nagar,Dehradun,Uttarakhand',
'Prem Nagar,Dehradun,Uttarakhand',
'Raipur(O.F),Dehradun,Uttarakhand',
'Rajawala,Dehradun,Uttarakhand',
'Ranjhawala,Dehradun,Uttarakhand',
'Refugee Camp,Dehradun,Uttarakhand',
'Resham Majri,Dehradun,Uttarakhand',
'Rispana,Dehradun,Uttarakhand',
'Sahstradhara,Dehradun,Uttarakhand',
'Sarona,Dehradun,Uttarakhand',
'Saura Sarauli,Dehradun,Uttarakhand',
'Sayedwala,Dehradun,Uttarakhand',
'Seemadwar,Dehradun,Uttarakhand',
'Shahanshahi Ashram,Dehradun,Uttarakhand',
'Shamshergarh,Dehradun,Uttarakhand',
'Sinola,Dehradun,Uttarakhand',
'Subhashnagar,Dehradun,Uttarakhand',
'Tapovan,Dehradun,Uttarakhand',
'Telbhawan,Dehradun,Uttarakhand',
'Tunwala,Dehradun,Uttarakhand',
'Turner Road,Dehradun,Uttarakhand',
'Umedpur,Dehradun,Uttarakhand',
'Dalanwala,Dehradun,Uttarakhand',
'Rajpur,Dehradun,Uttarakhand',
'Karbari Grant,Dehradun,Uttarakhand',
'Dehradun Cantt H.O,Dehradun,Uttarakhand',
'Kalsi Gate,Dehradun,Uttarakhand',
'Kalsi,Dehradun,Uttarakhand',
'Hathipaon,Dehradun,Uttarakhand',
'Jharipani,Dehradun,Uttarakhand',
'Landaur Cantt.,Dehradun,Uttarakhand',
'Landaur,Dehradun,Uttarakhand',
'Naa,Dehradun,Uttarakhand',
'Savoy Hotel,Dehradun,Uttarakhand',
'Mussoorie,Dehradun,Uttarakhand',
'Bhaniawala,Dehradun,Uttarakhand',
'Bhogpur,Dehradun,Uttarakhand',
'Dharkot,Dehradun,Uttarakhand',
'Raiwala,Dehradun,Uttarakhand',
'Rishikesh,Dehradun,Uttarakhand',
'Ashutoshnagar,Dehradun,Uttarakhand',
'Badogal,Dehradun,Uttarakhand',
'Dandi,Dehradun,Uttarakhand',
'Gumaniwala,Dehradun,Uttarakhand',
'Haldwari,Dehradun,Uttarakhand',
'Haripur Kalan,Dehradun,Uttarakhand',
'Ithrana,Dehradun,Uttarakhand',
'Jolly Grant,Dehradun,Uttarakhand',
'K.P.Kshetra,Dehradun,Uttarakhand',
'Pashulok,Dehradun,Uttarakhand',
'Satshilling,Pithoragarh,Uttarakhand',
'Sel,Pithoragarh,Uttarakhand',
'Seloni,Pithoragarh,Uttarakhand',
'Serikumdar,Pithoragarh,Uttarakhand',
'Shilling,Pithoragarh,Uttarakhand',
'Shillingatoli,Pithoragarh,Uttarakhand',
'Shivalaya,Pithoragarh,Uttarakhand',
'Siltham,Pithoragarh,Uttarakhand',
'Simalkote,Pithoragarh,Uttarakhand',
'Sirkuch,Pithoragarh,Uttarakhand',
'Tharkote,Pithoragarh,Uttarakhand',
'Toli,Pithoragarh,Uttarakhand',
'Totanaula,Pithoragarh,Uttarakhand',
'Wadda,Pithoragarh,Uttarakhand',
'Baste,Pithoragarh,Uttarakhand',
'Arkhund,Chamoli,Uttarakhand',
'Baksir,Chamoli,Uttarakhand',
'Barsir,Chamoli,Uttarakhand',
'Budna,Chamoli,Uttarakhand',
'Chaura,Chamoli,Uttarakhand',
'Chauriyabhardar,Chamoli,Uttarakhand',
'Chirbatiya,Chamoli,Uttarakhand',
'Devidharmamani,Chamoli,Uttarakhand',
'Jakhal,Chamoli,Uttarakhand',
'Jakhanoli,Chamoli,Uttarakhand',
'Jakholi,Chamoli,Uttarakhand',
'Kanda,Chamoli,Uttarakhand',
'Khaliyan,Chamoli,Uttarakhand',
'Kumerisimli,Chamoli,Uttarakhand',
'Kurchhola,Chamoli,Uttarakhand',
'Kweelakhal,Chamoli,Uttarakhand',
'Mayali,Chamoli,Uttarakhand',
'Munnadewal,Chamoli,Uttarakhand',
'Mussadhung,Chamoli,Uttarakhand',
'Pandrola,Chamoli,Uttarakhand',
'Panjana,Chamoli,Uttarakhand',
'Paunthi,Chamoli,Uttarakhand',
'Purviyana,Chamoli,Uttarakhand',
'Sakalana,Chamoli,Uttarakhand',
'Saurakhal,Chamoli,Uttarakhand',
'Semlta,Chamoli,Uttarakhand',
'Serabhardar,Chamoli,Uttarakhand',
'Sidhsaur,Chamoli,Uttarakhand',
'Sirwari,Chamoli,Uttarakhand',
'Syurbangar,Chamoli,Uttarakhand',
'Taila,Chamoli,Uttarakhand',
'Timli Badama,Chamoli,Uttarakhand',
'Tuneta,Chamoli,Uttarakhand',
'Uchhola,Chamoli,Uttarakhand',
'Uttarsu,Chamoli,Uttarakhand',
'Kotbangar,Chamoli,Uttarakhand',
'Phata,Chamoli,Uttarakhand',
'Andrwari,Chamoli,Uttarakhand',
'Badasu,Chamoli,Uttarakhand',
'Barab,Chamoli,Uttarakhand',
'Bareth,Chamoli,Uttarakhand',
'Basti,Chamoli,Uttarakhand',
'Basukedar,Chamoli,Uttarakhand',
'Bhiri,Chamoli,Uttarakhand',
'Byung,Chamoli,Uttarakhand',
'Chandra Nagar,Chamoli,Uttarakhand',
'Chandrapuri,Chamoli,Uttarakhand',
'Daira,Chamoli,Uttarakhand',
'Dhartondla,Chamoli,Uttarakhand',
'Fafanj,Chamoli,Uttarakhand',
'Gaurikund,Chamoli,Uttarakhand',
'Guptkashi,Chamoli,Uttarakhand',
'Jagoth,Chamoli,Uttarakhand',
'Jaltalla,Chamoli,Uttarakhand',
'Kalimath,Chamoli,Uttarakhand',
'Kandara,Chamoli,Uttarakhand',
'Kedarnath Seasional,Chamoli,Uttarakhand',
'Kotma,Chamoli,Uttarakhand',
'Kyark Barsuri,Chamoli,Uttarakhand',
'Lamgondi,Chamoli,Uttarakhand',
'Machkandi,Chamoli,Uttarakhand',
'Makoomath,Chamoli,Uttarakhand',
'Mansoona,Chamoli,Uttarakhand',
'Nagjagai,Chamoli,Uttarakhand',
'Nainipondar,Chamoli,Uttarakhand',
'Narainkoti,Chamoli,Uttarakhand',
'Okhimath,Chamoli,Uttarakhand',
'Paldwari,Chamoli,Uttarakhand',
'Parkandi,Chamoli,Uttarakhand',
'Pilloo,Chamoli,Uttarakhand',
'Rampur,Chamoli,Uttarakhand',
'Ransi,Chamoli,Uttarakhand',
'Raunlenk,Chamoli,Uttarakhand',
'Sari,Chamoli,Uttarakhand',
'Sursal,Chamoli,Uttarakhand',
'Thatigadgu,Chamoli,Uttarakhand',
'Trijuginarain,Chamoli,Uttarakhand',
'Tulanga,Chamoli,Uttarakhand',
'Uchadhungi,Chamoli,Uttarakhand',
'Uniyana,Chamoli,Uttarakhand',
'Vidhyapeeth,Chamoli,Uttarakhand',
'Vinobapuri,Chamoli,Uttarakhand',
'Bansu,Chamoli,Uttarakhand',
'Agar,Chamoli,Uttarakhand',
'Augustmuni,Chamoli,Uttarakhand',
'Barsudi,Chamoli,Uttarakhand',
'Bawai,Chamoli,Uttarakhand',
'Bhatwari,Chamoli,Uttarakhand',
'Bhaunsal,Chamoli,Uttarakhand',
'Bijarakot,Chamoli,Uttarakhand',
'Biron,Chamoli,Uttarakhand',
'Chopra,Chamoli,Uttarakhand',
'Dadoli,Chamoli,Uttarakhand',
'Dangwal Gaon,Chamoli,Uttarakhand',
'Durgadhar,Chamoli,Uttarakhand',
'Falasi,Chamoli,Uttarakhand',
'Gaharkhal,Chamoli,Uttarakhand',
'Ghandiyalka,Chamoli,Uttarakhand',
'Ghimtoli,Chamoli,Uttarakhand',
'Gholtir,Chamoli,Uttarakhand',
'Haretikhal,Chamoli,Uttarakhand',
'Jakhani,Chamoli,Uttarakhand',
'Jakhdhar,Chamoli,Uttarakhand',
'Kamera,Chamoli,Uttarakhand',
'Kandai,Chamoli,Uttarakhand',
'Kandai,Chamoli,Uttarakhand',
'Khankara,Chamoli,Uttarakhand',
'Kimana,Chamoli,Uttarakhand',
'Kolli,Chamoli,Uttarakhand',
'Kotmalla,Chamoli,Uttarakhand',
'Kurjhan,Chamoli,Uttarakhand',
'Kyuri,Chamoli,Uttarakhand',
'Kyuridasjula,Chamoli,Uttarakhand',
'Ladoli,Chamoli,Uttarakhand',
'Maiki Marhi,Chamoli,Uttarakhand',
'Narkota,Chamoli,Uttarakhand',
'Nawasu,Chamoli,Uttarakhand',
'Pallabazar,Chamoli,Uttarakhand',
'Pathalidhar,Chamoli,Uttarakhand',
'Pauri Nishni,Chamoli,Uttarakhand',
'Pokhata,Chamoli,Uttarakhand',
'Ratura,Chamoli,Uttarakhand',
'Rudraprayag,Chamoli,Uttarakhand',
'Rumsi,Chamoli,Uttarakhand',
'Saterakhal,Chamoli,Uttarakhand',
'Silli,Chamoli,Uttarakhand',
'Sumerpur,Chamoli,Uttarakhand',
'Tilwara,Chamoli,Uttarakhand',
'Maikoti,Chamoli,Uttarakhand',
'Darogi,Tehri,Uttarakhand',
'Jamnikhal,Tehri,Uttarakhand',
'Nakot,Tehri,Uttarakhand',
'Sain,Tehri,Uttarakhand',
'Amni,Tehri,Uttarakhand',
'Bhainskot,Tehri,Uttarakhand',
'Bhallegaon,Tehri,Uttarakhand',
'Deoprayag Bazar,Tehri,Uttarakhand',
'Hindolakhal,Tehri,Uttarakhand',
'Hinsriyakhal,Tehri,Uttarakhand',
'Kuddi,Tehri,Uttarakhand',
'Laloorikhal,Tehri,Uttarakhand',
'Mahad,Tehri,Uttarakhand',
'Palethi,Tehri,Uttarakhand',
'Pujargaon,Tehri,Uttarakhand',
'Sinwalidhar,Tehri,Uttarakhand',
'Souru,Tehri,Uttarakhand',
'Tyuna,Tehri,Uttarakhand',
'Kumalda,Dehradun,Uttarakhand',
'Yamunapul,Dehradun,Uttarakhand',
'Bangar,Tehri,Uttarakhand',
'Bangsil,Tehri,Uttarakhand',
'Bhalkatal,Tehri,Uttarakhand',
'Bhawan,Tehri,Uttarakhand',
'Chulyani,Tehri,Uttarakhand',
'Dhanolti,Tehri,Uttarakhand',
'Dwargarh,Tehri,Uttarakhand',
'Khyarsi,Tehri,Uttarakhand',
'Parogi,Tehri,Uttarakhand',
'Ragar Gaon,Tehri,Uttarakhand',
'Sadav,Tehri,Uttarakhand',
'Sirs,Tehri,Uttarakhand',
'Suwakholi,Tehri,Uttarakhand',
'Kempty,Dehradun,Uttarakhand',
'Kotipav,Tehri,Uttarakhand',
'Maror,Tehri,Uttarakhand',
'Mogi,Tehri,Uttarakhand',
'Myanilaloor,Tehri,Uttarakhand',
'Pantwari,Tehri,Uttarakhand',
'Sendul,Tehri,Uttarakhand',
'Sigunisera,Tehri,Uttarakhand',
'Srikot,Tehri,Uttarakhand',
'Thatyur,Tehri,Uttarakhand',
'Tikri,Tehri,Uttarakhand',
'Kinsoo,Tehri,Uttarakhand',
'Siree,Tehri,Uttarakhand',
'Amsari,Tehri,Uttarakhand',
'Chaka,Tehri,Uttarakhand',
'Gajja,Tehri,Uttarakhand',
'Jakholi,Tehri,Uttarakhand',
'Kathud,Tehri,Uttarakhand',
'Khaand,Tehri,Uttarakhand',
'Kothi,Tehri,Uttarakhand',
'Lawa,Tehri,Uttarakhand',
'Maroragaad,Tehri,Uttarakhand',
'Naicholi,Tehri,Uttarakhand',
'Palkot,Tehri,Uttarakhand',
'Pokhri,Tehri,Uttarakhand',
'Ranakot,Tehri,Uttarakhand',
'Shantipur Sondi,Tehri,Uttarakhand',
'Akhori,Tehri,Uttarakhand',
'Bajiyalgaon,Tehri,Uttarakhand',
'Barkot,Tehri,Uttarakhand',
'Beena,Tehri,Uttarakhand',
'Bhaatgaon,Tehri,Uttarakhand',
'Bhaneldi,Tehri,Uttarakhand',
'Bhatgaon,Tehri,Uttarakhand',
'Bhatwara,Tehri,Uttarakhand',
'Bhigun,Tehri,Uttarakhand',
'Chamiyala,Tehri,Uttarakhand',
'Chandreshwar,Tehri,Uttarakhand',
'Chanji,Tehri,Uttarakhand',
'Dalla Argrh,Tehri,Uttarakhand',
'Dangi,Tehri,Uttarakhand',
'Devtadhar,Tehri,Uttarakhand',
'Dewath,Tehri,Uttarakhand',
'Dhopardhar,Tehri,Uttarakhand',
'Dhounikhal,Tehri,Uttarakhand',
'Falenda,Tehri,Uttarakhand',
'Gadoliya,Tehri,Uttarakhand',
'Ghansali,Tehri,Uttarakhand',
'Ghonti,Tehri,Uttarakhand',
'Ghuttu,Tehri,Uttarakhand',
'Gona,Tehri,Uttarakhand',
'Hadiyanakholi,Tehri,Uttarakhand',
'Jakhniyali,Tehri,Uttarakhand',
'Kafolgaon,Tehri,Uttarakhand',
'Kandarsyun,Tehri,Uttarakhand',
'Kathoor,Tehri,Uttarakhand',
'Khawara,Tehri,Uttarakhand',
'Kireth,Tehri,Uttarakhand',
'Kothiyara,Tehri,Uttarakhand',
'Maighadhar,Tehri,Uttarakhand',
'Malgaon,Tehri,Uttarakhand',
'Malyakot,Tehri,Uttarakhand',
'Mandar,Tehri,Uttarakhand',
'Muyalgaon,Tehri,Uttarakhand',
'Odadhar,Tehri,Uttarakhand',
'Pangriyana,Tehri,Uttarakhand',
'Pilkhi,Tehri,Uttarakhand',
'Pokhar,Tehri,Uttarakhand',
'Purwalgaon,Tehri,Uttarakhand',
'Samangaon,Tehri,Uttarakhand',
'Sankri,Tehri,Uttarakhand',
'Semandidhar,Tehri,Uttarakhand',
'Siliyara,Tehri,Uttarakhand',
'Sounp,Tehri,Uttarakhand',
'Sunargaon,Tehri,Uttarakhand',
'Thati,Tehri,Uttarakhand',
'Tisriyara,Tehri,Uttarakhand',
'Binaykhal,Tehri,Uttarakhand',
'Anjanisain,Tehri,Uttarakhand',
'Chheti,Tehri,Uttarakhand',
'Gomukh,Tehri,Uttarakhand',
'Jakhnidhar,Tehri,Uttarakhand',
'Khandogi,Tehri,Uttarakhand',
'Panchoor,Tehri,Uttarakhand',
'Patniyadevi,Tehri,Uttarakhand',
'Paurikhal,Tehri,Uttarakhand',
'Pipola,Tehri,Uttarakhand',
'Radhudhar,Tehri,Uttarakhand',
'Raurdhar,Tehri,Uttarakhand',
'Tipri,Tehri,Uttarakhand',
'Toli,Tehri,Uttarakhand',
'Garakot,Tehri,Uttarakhand',
'Badiyargarh,Tehri,Uttarakhand',
'Badon,Tehri,Uttarakhand',
'Chourikhal,Tehri,Uttarakhand',
'Dharidhungsir,Tehri,Uttarakhand',
'Dharkot,Tehri,Uttarakhand',
'Dugadda,Tehri,Uttarakhand',
'Jakhand,Tehri,Uttarakhand',
'Kilkileshwar,Tehri,Uttarakhand',
'Kirtinagar,Tehri,Uttarakhand',
'Magron,Tehri,Uttarakhand',
'Maletha,Tehri,Uttarakhand',
'Manjkot,Tehri,Uttarakhand',
'Nyuli,Tehri,Uttarakhand',
'Silkakhal,Tehri,Uttarakhand',
'Takoli,Tehri,Uttarakhand',
'Talli Ringoli,Tehri,Uttarakhand',
'Thati Dagar,Tehri,Uttarakhand',
'Daang,Tehri,Uttarakhand',
'Dangchoura,Tehri,Uttarakhand',
'Ghandiyaldhr,Tehri,Uttarakhand',
'Jakhidagar,Tehri,Uttarakhand',
'Kafna,Tehri,Uttarakhand',
'Khola,Tehri,Uttarakhand',
'Poukhal,Tehri,Uttarakhand',
'Jajal,Tehri,Uttarakhand',
'Agar,Tehri,Uttarakhand',
'Bachhelikhal,Tehri,Uttarakhand',
'Bagi,Tehri,Uttarakhand',
'Bairaigaon,Tehri,Uttarakhand',
'Banali,Tehri,Uttarakhand',
'Berni,Tehri,Uttarakhand',
'Chamolgaon,Tehri,Uttarakhand',
'Gulardogi,Tehri,Uttarakhand',
'Kharsadi,Tehri,Uttarakhand',
'Manderigaon,Tehri,Uttarakhand',
'Nagni,Tehri,Uttarakhand',
'Odada,Tehri,Uttarakhand',
'Shivanand Nagar,Tehri,Uttarakhand',
'Shivpuri,Tehri,Uttarakhand',
'Silkani,Tehri,Uttarakhand',
'Manjiyari,Tehri,Uttarakhand',
'Atali -byasi,Tehri,Uttarakhand',
'Banskatal,Tehri,Uttarakhand',
'Bharpur,Tehri,Uttarakhand',
'Duwadhar,Tehri,Uttarakhand',
'Dyuli,Tehri,Uttarakhand',
'Fakot,Tehri,Uttarakhand',
'Jardhargaon,Tehri,Uttarakhand',
'Kakhoor,Tehri,Uttarakhand',
'Kaudiyala,Tehri,Uttarakhand',
'Mindath,Tehri,Uttarakhand',
'Mundala,Tehri,Uttarakhand',
'Munikireti,Tehri,Uttarakhand',
'Naidogi,Tehri,Uttarakhand',
'Narendra Nagar,Tehri,Uttarakhand',
'Tapoban,Tehri,Uttarakhand',
'Timli,Tehri,Uttarakhand',
'Kyara,Tehri,Uttarakhand',
'Nelda,Tehri,Uttarakhand',
'Rajakhet,Tehri,Uttarakhand',
'Kotalgaon,Tehri,Uttarakhand',
'Madan Negi,Tehri,Uttarakhand',
'Pratap Nagar,Tehri,Uttarakhand',
'Raika,Tehri,Uttarakhand',
'Raimer,Tehri,Uttarakhand',
'Roulakot,Tehri,Uttarakhand',
'Rounad,Tehri,Uttarakhand',
'Rouniya,Tehri,Uttarakhand',
'Serabagwan,Tehri,Uttarakhand',
'Newsari,Tehri,Uttarakhand',
'Bharkot,Tehri,Uttarakhand',
'Dhountri,Tehri,Uttarakhand',
'Gairi,Tehri,Uttarakhand',
'Kandiyalgaon,Tehri,Uttarakhand',
'Khambakhal,Tehri,Uttarakhand',
'Lambgaon,Tehri,Uttarakhand',
'Majafgaon,Tehri,Uttarakhand',
'Mukhem,Tehri,Uttarakhand',
'Pathiyana,Tehri,Uttarakhand',
'Thapla,Tehri,Uttarakhand',
'Khalargaon,Tehri,Uttarakhand',
'Aleru,Tehri,Uttarakhand',
'Anandchowk,Tehri,Uttarakhand',
'Badshahithaul,Tehri,Uttarakhand',
'Bagiyal,Tehri,Uttarakhand',
'Bahera,Tehri,Uttarakhand',
'Baurari,Tehri,Uttarakhand',
'Bhagirathipuram,Tehri,Uttarakhand',
'Bhladiana,Tehri,Uttarakhand',
'Chamani,Tehri,Uttarakhand',
'Chamma,Tehri,Uttarakhand',
'Chham,Tehri,Uttarakhand',
'Chherabdhar,Tehri,Uttarakhand',
'Chopriyalgaon,Tehri,Uttarakhand',
'Dharkot,Tehri,Uttarakhand',
'Dharkot-udaikot,Tehri,Uttarakhand',
'Gyansoo,Tehri,Uttarakhand',
'Hatwalgaon,Tehri,Uttarakhand',
'Jaakhchoura,Tehri,Uttarakhand',
'Jad Gaon,Tehri,Uttarakhand',
'Jamthiyal Gaon,Tehri,Uttarakhand',
'Joulangi,Tehri,Uttarakhand',
'Kafal Pani,Tehri,Uttarakhand',
'Kakhwari,Tehri,Uttarakhand',
'Kamand,Tehri,Uttarakhand',
'Kanatal,Tehri,Uttarakhand',
'Kandikhal,Tehri,Uttarakhand',
'Kaushal,Tehri,Uttarakhand',
'Kotmaniyar,Tehri,Uttarakhand',
'Kuttha,Tehri,Uttarakhand',
'Lamkot,Tehri,Uttarakhand',
'Lawani,Tehri,Uttarakhand',
'Maindkhal,Tehri,Uttarakhand',
'Manjhgaon,Tehri,Uttarakhand',
'Nagdev Kudiyal Gaon,Tehri,Uttarakhand',
'Nagrajadhar,Tehri,Uttarakhand',
'Nail,Tehri,Uttarakhand',
'Newtehri Collectrate,Tehri,Uttarakhand',
'Okhla,Tehri,Uttarakhand',
'Pali,Tehri,Uttarakhand',
'Pangerkhal,Tehri,Uttarakhand',
'Ranichauri,Tehri,Uttarakhand',
'Ratnomalla,Tehri,Uttarakhand',
'Ringalgarh,Tehri,Uttarakhand',
'Sabli,Tehri,Uttarakhand',
'Saud,Tehri,Uttarakhand',
'Sour Uppu,Tehri,Uttarakhand',
'Sweer,Tehri,Uttarakhand',
'Tehri H.O,Tehri,Uttarakhand',
'Thouldhar,Tehri,Uttarakhand',
'Tingri,Tehri,Uttarakhand',
'Tungoli,Tehri,Uttarakhand',
'Uniyalgaon,Tehri,Uttarakhand',
'V.K.Puram,Tehri,Uttarakhand',
'Kyari,Tehri,Uttarakhand',
'Sarot,Tehri,Uttarakhand',
'Teehri Kutchery,Tehri,Uttarakhand',
'Bannakhera,Nainital,Uttarakhand',
'Barhani,Nainital,Uttarakhand',
'Bazpur,Nainital,Uttarakhand',
'Bhajuanagla,Nainital,Uttarakhand',
'Doraha,Nainital,Uttarakhand',
'Fauzi Coloney,Nainital,Uttarakhand',
'Gular Bhoj Canal Coloney,Nainital,Uttarakhand',
'Haripur Harsan,Nainital,Uttarakhand',
'Jogipura,Nainital,Uttarakhand',
'S.F. Bazpur,Nainital,Uttarakhand',
'Sultanpur,Nainital,Uttarakhand',
'Adarshnagar,Nainital,Uttarakhand',
'Gadarpur,Nainital,Uttarakhand',
'Gadarpura,Nainital,Uttarakhand',
'Jhagarpuri,Nainital,Uttarakhand',
'Kalinagar,Nainital,Uttarakhand',
'Kelakhera,Nainital,Uttarakhand',
'Majra Anand Singh,Nainital,Uttarakhand',
'Narainpur Dohania,Nainital,Uttarakhand',
'Premnagar,Nainital,Uttarakhand',
'Subashnagar,Nainital,Uttarakhand',
'Dineshpur,Nainital,Uttarakhand',
'Barionwala,Nainital,Uttarakhand',
'Dharampur,Nainital,Uttarakhand',
'Jaspur,Nainital,Uttarakhand',
'Raipur,Nainital,Uttarakhand',
'S.M. Nadehi,Nainital,Uttarakhand',
'Anandnagar,Nainital,Uttarakhand',
'Chattarpur,Nainital,Uttarakhand',
'Chaukhandi,Nainital,Uttarakhand',
'Danpur,Nainital,Uttarakhand',
'Dhakia No 1,Nainital,Uttarakhand',
'Dhanauri,Nainital,Uttarakhand',
'Ganeshnagar,Nainital,Uttarakhand',
'Karanpur,Nainital,Uttarakhand',
'Kashipur,Nainital,Uttarakhand',
'Khanpur,Nainital,Uttarakhand',
'Kila Street,Nainital,Uttarakhand',
'Kunda,Nainital,Uttarakhand',
'Kundeshwari,Nainital,Uttarakhand',
'Mahuwakhera,Nainital,Uttarakhand',
'Maldhanchaur,Nainital,Uttarakhand',
'Pratappur,Nainital,Uttarakhand',
'R.T.C. Hempur,Nainital,Uttarakhand',
'S.M. Kashipur,Nainital,Uttarakhand',
'Shivrajpur,Nainital,Uttarakhand',
'Spinning Mill Kashipur,Nainital,Uttarakhand',
'Thari,Nainital,Uttarakhand',
'Beria Majhola,Nainital,Uttarakhand',
'Bhura Kishani,Nainital,Uttarakhand',
'Bigra Bagh,Nainital,Uttarakhand',
'Chakarpur,Nainital,Uttarakhand',
'Charubetta,Nainital,Uttarakhand',
'Gaujhariya,Nainital,Uttarakhand',
'Gidhaur,Nainital,Uttarakhand',
'Jamaur,Nainital,Uttarakhand',
'Jhankat,Nainital,Uttarakhand',
'Khali Mahuwat,Nainital,Uttarakhand',
'Khatima,Nainital,Uttarakhand',
'Naugaon Nath,Nainital,Uttarakhand',
'Naugaon Thagoo,Nainital,Uttarakhand',
'Nausar,Nainital,Uttarakhand',
'Sripur Bichwa,Nainital,Uttarakhand',
'Bagwara,Nainital,Uttarakhand',
'Bara,Nainital,Uttarakhand',
'Bhanga,Nainital,Uttarakhand',
'Bhurarani,Nainital,Uttarakhand',
'Bhuria Coloney,Nainital,Uttarakhand',
'D.F. Nagla,Nainital,Uttarakhand',
'Darau,Nainital,Uttarakhand',
'Deoria,Nainital,Uttarakhand',
'Gandhi Chowk Rudarpur,Nainital,Uttarakhand',
'Gokul Nagar,Nainital,Uttarakhand',
'Haldi,Nainital,Uttarakhand',
'Kichha,Nainital,Uttarakhand',
'Kunwarpur Sisaya,Nainital,Uttarakhand',
'Lalpur,Nainital,Uttarakhand',
'Manua Patti,Nainital,Uttarakhand',
'Nakatpura,Nainital,Uttarakhand',
'Narayanpur,Nainital,Uttarakhand',
'Pantnagar,Nainital,Uttarakhand',
'Patharchatta,Nainital,Uttarakhand',
'Pratappur,Nainital,Uttarakhand',
'Rudarpur,Nainital,Uttarakhand',
'Sahdaura,Nainital,Uttarakhand',
'Shantpuri,Nainital,Uttarakhand',
'Suryanagar,Nainital,Uttarakhand',
'Uttamnagar,Nainital,Uttarakhand',
'Uttarsia,Nainital,Uttarakhand',
'Peerumadra,Nainital,Uttarakhand',
'31st Bn Pac Rudarpur,Nainital,Uttarakhand',
'T.C. Rudarpur,Nainital,Uttarakhand',
'Baruabagh,Nainital,Uttarakhand',
'Bidora,Nainital,Uttarakhand',
'Bijitipattia,Nainital,Uttarakhand',
'Ghusari,Nainital,Uttarakhand',
'Hardaspur,Nainital,Uttarakhand',
'Lamakhera,Nainital,Uttarakhand',
'Nakulia,Nainital,Uttarakhand',
'Nanakmatta,Nainital,Uttarakhand',
'Pandari,Nainital,Uttarakhand',
'Pratappur,Nainital,Uttarakhand',
'S.A.I. Camp,Nainital,Uttarakhand',
'Sarasaria,Nainital,Uttarakhand',
'Shaktifarm,Nainital,Uttarakhand',
'Sisona,Nainital,Uttarakhand',
'Sittarganj,Nainital,Uttarakhand',
'Bhatwari,Tehri,Uttarakhand',
'Mahidanda,Tehri,Uttarakhand',
'Maneri,Tehri,Uttarakhand',
'Soura,Tehri,Uttarakhand',
'Bagasu,Tehri,Uttarakhand',
'Bhansadi,Tehri,Uttarakhand',
'Bhatiya,Tehri,Uttarakhand',
'Burkot,Tehri,Uttarakhand',
'Damta,Tehri,Uttarakhand',
'Dewal,Tehri,Uttarakhand',
'Diyari,Tehri,Uttarakhand',
'Gaatu,Tehri,Uttarakhand',
'Gadoli,Tehri,Uttarakhand',
'Gangani,Tehri,Uttarakhand',
'Gangtari,Tehri,Uttarakhand',
'Hanuman Chatti,Tehri,Uttarakhand',
'Jamunachatti,Tehri,Uttarakhand',
'Jankimai Chatti,Tehri,Uttarakhand',
'Kafnol,Tehri,Uttarakhand',
'Kalogi,Tehri,Uttarakhand',
'Kandari,Tehri,Uttarakhand',
'Kharsali,Tehri,Uttarakhand',
'Kotiyalgaon,Tehri,Uttarakhand',
'Kunwa,Tehri,Uttarakhand',
'Nagangaon,Tehri,Uttarakhand',
'Naugaon,Tehri,Uttarakhand',
'Odgaon,Tehri,Uttarakhand',
'Pounthi,Tehri,Uttarakhand',
'Pujeli,Tehri,Uttarakhand',
'Rajgarhi,Tehri,Uttarakhand',
'Rana,Tehri,Uttarakhand',
'Rikhaown,Tehri,Uttarakhand',
'Sarigadkhamundi,Tehri,Uttarakhand',
'Sarnol,Tehri,Uttarakhand',
'Badhangaon,Tehri,Uttarakhand',
'Bagori,Tehri,Uttarakhand',
'Baldogi,Tehri,Uttarakhand',
'Banchaura,Tehri,Uttarakhand',
'Bangaon,Tehri,Uttarakhand',
'Bhatwari-dhanari,Tehri,Uttarakhand',
'Chiniyalisour,Tehri,Uttarakhand',
'Chotimani,Tehri,Uttarakhand',
'Dharashu,Tehri,Uttarakhand',
'Dichli,Tehri,Uttarakhand',
'Diwarikhol,Tehri,Uttarakhand',
'Dunda,Tehri,Uttarakhand',
'Fold-dhanari,Tehri,Uttarakhand',
'Gadoli,Tehri,Uttarakhand',
'Geonla,Tehri,Uttarakhand',
'Jogath,Tehri,Uttarakhand',
'Junga,Tehri,Uttarakhand',
'Kali Gaon,Tehri,Uttarakhand',
'Kalyani,Tehri,Uttarakhand',
'Kansi,Tehri,Uttarakhand',
'Katkhet,Tehri,Uttarakhand',
'Khaand,Tehri,Uttarakhand',
'Khalsi,Tehri,Uttarakhand',
'Khurmola,Tehri,Uttarakhand',
'Kotdhar,Tehri,Uttarakhand',
'Kyari,Tehri,Uttarakhand',
'Latasera,Tehri,Uttarakhand',
'Manjgaon,Tehri,Uttarakhand',
'Margaon,Tehri,Uttarakhand',
'Naggaon,Tehri,Uttarakhand',
'Patara,Tehri,Uttarakhand',
'Pujargaon,Tehri,Uttarakhand',
'Ranari,Tehri,Uttarakhand',
'Rounthal,Tehri,Uttarakhand',
'Siguni,Tehri,Uttarakhand',
'Siyansu,Tehri,Uttarakhand',
'Srikot,Tehri,Uttarakhand',
'Tarakot,Tehri,Uttarakhand',
'Thandi,Tehri,Uttarakhand',
'Thati-dhanari,Tehri,Uttarakhand',
'Tipri,Tehri,Uttarakhand',
'Udri,Tehri,Uttarakhand',
'Arakot,Tehri,Uttarakhand',
'Bhankoli-ranwain,Tehri,Uttarakhand',
'Bhutanu,Tehri,Uttarakhand',
'Chinwa,Tehri,Uttarakhand',
'Devjani,Tehri,Uttarakhand',
'Dhakara,Tehri,Uttarakhand',
'Dhatmeer,Tehri,Uttarakhand',
'Doni,Tehri,Uttarakhand',
'Fitari,Tehri,Uttarakhand',
'Gaddugaad,Tehri,Uttarakhand',
'Gangar,Tehri,Uttarakhand',
'Guniyatgaon,Tehri,Uttarakhand',
'Hudoli,Tehri,Uttarakhand',
'Jakholi,Tehri,Uttarakhand',
'Kantari,Tehri,Uttarakhand',
'Masri,Tehri,Uttarakhand',
'Moltari,Tehri,Uttarakhand',
'Mori,Tehri,Uttarakhand',
'Naitwar,Tehri,Uttarakhand',
'Purola,Tehri,Uttarakhand',
'Sankri,Tehri,Uttarakhand',
'Thadiyar,Tehri,Uttarakhand',
'Tikochi,Tehri,Uttarakhand',
'Barsali,Tehri,Uttarakhand',
'Barsu,Tehri,Uttarakhand',
'Bhankoli,Tehri,Uttarakhand',
'Bharangaon,Tehri,Uttarakhand',
'Bonga,Tehri,Uttarakhand',
'Boun,Tehri,Uttarakhand',
'Gangori,Tehri,Uttarakhand',
'Gangtari,Tehri,Uttarakhand',
'Gawana,Tehri,Uttarakhand',
'Gyansu,Tehri,Uttarakhand',
'Joshiyara,Tehri,Uttarakhand',
'Kallyani,Tehri,Uttarakhand',
'Malla,Tehri,Uttarakhand',
'Manpur,Tehri,Uttarakhand',
'Matli,Tehri,Uttarakhand',
'Mustik Sour,Tehri,Uttarakhand',
'Netala,Tehri,Uttarakhand',
'New Barsali,Tehri,Uttarakhand',
'Pata,Tehri,Uttarakhand',
'Rainthal,Tehri,Uttarakhand',
'Raturisera,Tehri,Uttarakhand',
'Sald,Tehri,Uttarakhand',
'Uttarkashi Collectorate,Tehri,Uttarakhand',
'Uttarkashi,Tehri,Uttarakhand',
'Uttaron,Tehri,Uttarakhand',
'Jhalla,Tehri,Uttarakhand',
'M.D. Colony,Tehri,Uttarakhand',
'Gangnani,Tehri,Uttarakhand',
'Purbasthali,Burdwan,West Bengal',
'Samudragarh,Burdwan,West Bengal',
'Simlon,Burdwan,West Bengal',
'Singhi,Burdwan,West Bengal',
'Srikhanda,Burdwan,West Bengal',
'Sudpur,Burdwan,West Bengal',
'Akui,Bankura,West Bengal',
'Anchuri Salboni,Bankura,West Bengal',
'Andharthole,Bankura,West Bengal',
'Bankati,Bankura,West Bengal',
'Bankura DSB,Bankura,West Bengal',
'Bankura H.O,Bankura,West Bengal',
'Bhadul,Bankura,West Bengal',
'Bhagabandh,Bankura,West Bengal',
'Bhalukgenjar,Bankura,West Bengal',
'Bikurdih,Bankura,West Bengal',
'Cheleiama-sunukpahari,Bankura,West Bengal',
'Chhatarkanali,Bankura,West Bengal',
'Feder Road,Bankura,West Bengal',
'Jagadalla,Bankura,West Bengal',
'Jalahari,Bankura,West Bengal',
'Jambedia,Bankura,West Bengal',
'Junbedia,Bankura,West Bengal',
'Kalpathar,Bankura,West Bengal',
'Kanchanpur,Bankura,West Bengal',
'Kenduadihi,Bankura,West Bengal',
'Kenjakura,Bankura,West Bengal',
'Kesiakole,Bankura,West Bengal',
'Kumidya,Bankura,West Bengal',
'Lalbazar,Bankura,West Bengal',
'Lokepur,Bankura,West Bengal',
'Mankanali,Bankura,West Bengal',
'Narrah,Bankura,West Bengal',
'Nutanchati,Bankura,West Bengal',
'Papurdih,Bankura,West Bengal',
'Pilgrim Road,Bankura,West Bengal',
'Purandapur,Bankura,West Bengal',
'Rajagram,Bankura,West Bengal',
'Ratanpur,Bankura,West Bengal',
'Sanbandha,Bankura,West Bengal',
'Sendra,Bankura,West Bengal',
'Sirsara,Bankura,West Bengal',
'West-sanabandh,Bankura,West Bengal',
'Barbendya,Bankura,West Bengal',
'Barjora,Bankura,West Bengal',
'Barkura,Bankura,West Bengal',
'Beliatore,Bankura,West Bengal',
'Bhattapara,Bankura,West Bengal',
'Chhandar,Bankura,West Bengal',
'Dhabani,Bankura,West Bengal',
'Dodhimukha,Bankura,West Bengal',
'Godardihi,Bankura,West Bengal',
'Hatasuria,Bankura,West Bengal',
'Jagannathpur,Bankura,West Bengal',
'Krishnanagar,Bankura,West Bengal',
'Maliara,Bankura,West Bengal',
'Manohar,Bankura,West Bengal',
'Metali,Bankura,West Bengal',
'Muktatore,Bankura,West Bengal',
'Pirrabani,Bankura,West Bengal',
'Radhakantapur,Bankura,West Bengal',
'Ramharipur,Bankura,West Bengal',
'Salbedia,Bankura,West Bengal',
'Shitla,Bankura,West Bengal',
'Tajpur Purakona,Bankura,West Bengal',
'Unara Jambedia,Bankura,West Bengal',
'Kowerpur,Burdwan,West Bengal',
'Jiabandi,Bankura,West Bengal',
'Morar,Bankura,West Bengal',
'Ajodhya,Bankura,West Bengal',
'Amral,Bankura,West Bengal',
'Bankadaha,Bankura,West Bengal',
'Basantimela,Bankura,West Bengal',
'Bhara,Bankura,West Bengal',
'Bishnupur,Bankura,West Bengal',
'Bishnupur Stn Rd,Bankura,West Bengal',
'Bonradhanagar,Bankura,West Bengal',
'Chakdaha,Bankura,West Bengal',
'Chumosina,Bankura,West Bengal',
'Dwarika,Bankura,West Bengal',
'Gokulnagar,Bankura,West Bengal',
'Gossainpur,Bankura,West Bengal',
'Janta,Bankura,West Bengal',
'Joykrinhspur,Bankura,West Bengal',
'Lalbandh,Bankura,West Bengal',
'Latbeliara,Bankura,West Bengal',
'Layekbandh,Bankura,West Bengal',
'Lokhasole,Bankura,West Bengal',
'Muninagar,Bankura,West Bengal',
'Peardoba,Bankura,West Bengal',
'Rasikganj,Bankura,West Bengal',
'Uliara,Bankura,West Bengal',
'Ghutgoria,Bankura,West Bengal',
'Alijhara,Bankura,West Bengal',
'Arrah,Bankura,West Bengal',
'Baidyalokhesole,Bankura,West Bengal',
'Besora,Bankura,West Bengal',
'Bhalaidiha,Bankura,West Bengal',
'Budhanpur,Bankura,West Bengal',
'Chamtagora,Bankura,West Bengal',
'Chhatna,Bankura,West Bengal',
'Dhaban,Bankura,West Bengal',
'Garhdubrajpur,Bankura,West Bengal',
'Gholgoria,Bankura,West Bengal',
'Gouripur,Bankura,West Bengal',
'Jamtora,Bankura,West Bengal',
'Jhantipahari,Bankura,West Bengal',
'Jorehira,Bankura,West Bengal',
'Kamalpur,Bankura,West Bengal',
'Kantapahari,Bankura,West Bengal',
'Karrah,Bankura,West Bengal',
'Keshbandi,Bankura,West Bengal',
'Kharbona,Bankura,West Bengal',
'Mandalkesra,Bankura,West Bengal',
'Montumra,Bankura,West Bengal',
'Nischintapur,Bankura,West Bengal',
'Saldiha Pithabaid,Bankura,West Bengal',
'Satyayatan,Bankura,West Bengal',
'Sihika,Bankura,West Bengal',
'Susunia,Bankura,West Bengal',
'Sunri-chitra,Bankura,West Bengal',
'Amarkanan,Bankura,West Bengal',
'Banasuria,Bankura,West Bengal',
'Barkona,Bankura,West Bengal',
'Bisinda,Bankura,West Bengal',
'Durlavpur,Bankura,West Bengal',
'Gobindadham,Bankura,West Bengal',
'Kapista,Bankura,West Bengal',
'Keshiara,Bankura,West Bengal',
'Kukhrajhore,Bankura,West Bengal',
'Kusthalia,Bankura,West Bengal',
'Laxmanpur,Bankura,West Bengal',
'Beharjuria,Bankura,West Bengal',
'Brindabanpur Barsala,Bankura,West Bengal',
'Brindabanpur-barsal,Bankura,West Bengal',
'Chousal,Bankura,West Bengal',
'Gangajalghati,Bankura,West Bengal',
'Mejia Th Power Station,Bankura,West Bengal',
'Nityanandapur,Bankura,West Bengal',
'Ukhradihi,Bankura,West Bengal',
'Bhojda,Bankura,West Bengal',
'Bhuakana,Bankura,West Bengal',
'Dighi,Bankura,West Bengal',
'Gobarda,Bankura,West Bengal',
'Gopalpur,Bankura,West Bengal',
'Guniada,Bankura,West Bengal',
'Hatirampur,Bankura,West Bengal',
'Hirbandh,Bankura,West Bengal',
'Jhoriakocha,Bankura,West Bengal',
'Molian,Bankura,West Bengal',
'Mosanjhar,Bankura,West Bengal',
'Mosiara,Bankura,West Bengal',
'Ranga,Bankura,West Bengal',
'Saluipahari,Bankura,West Bengal',
'Simlabandh,Bankura,West Bengal',
'Akhrasole,Bankura,West Bengal',
'Amrul,Bankura,West Bengal',
'Dighalgram,Bankura,West Bengal',
'Gangarampur Bamnia,Bankura,West Bengal',
'Indas,Bankura,West Bengal',
'Khorsee,Bankura,West Bengal',
'Mandra,Bankura,West Bengal',
'Ratra,Bankura,West Bengal',
'Trisalan,Bankura,West Bengal',
'Ahanda,Bankura,West Bengal',
'Araldihi,Bankura,West Bengal',
'Bagdiha,Bankura,West Bengal',
'Bankata,Bankura,West Bengal',
'Bansidih,Bankura,West Bengal',
'Barachingra,Bankura,West Bengal',
'Bhatra,Bankura,West Bengal',
'Bheduasole,Bankura,West Bengal',
'Boga,Bankura,West Bengal',
'Bouridihi,Bankura,West Bengal',
'Brahmandiha,Bankura,West Bengal',
'Brajarajpur,Bankura,West Bengal',
'Chakaltore,Bankura,West Bengal',
'Chourabaid,Bankura,West Bengal',
'Danga-barbendya,Bankura,West Bengal',
'Dubarajpur,Bankura,West Bengal',
'Fulkusma-khattagram,Bankura,West Bengal',
'Gossainjanara,Bankura,West Bengal',
'Gourbazar,Bankura,West Bengal',
'Gunnath,Bankura,West Bengal',
'Hatagram,Bankura,West Bengal',
'Indpur,Bankura,West Bengal',
'Jeorda,Bankura,West Bengal',
'Jorda,Bankura,West Bengal',
'Kayabaid,Bankura,West Bengal',
'Keliapathar,Bankura,West Bengal',
'Nabadeulvera,Bankura,West Bengal',
'Natherdanga,Bankura,West Bengal',
'Nayada,Bankura,West Bengal',
'Puara,Bankura,West Bengal',
'Purusottampur,Bankura,West Bengal',
'Rampur,Bankura,West Bengal',
'Saldiha,Bankura,West Bengal',
'Silpajambedia,Bankura,West Bengal',
'Sonardanga,Bankura,West Bengal',
'Asurali,Bankura,West Bengal',
'Ayma,Bankura,West Bengal',
'Baital,Bankura,West Bengal',
'Bansichandipur,Bankura,West Bengal',
'Basubati,Bankura,West Bengal',
'Beliadangarpara,Bankura,West Bengal',
'Belsulia,Bankura,West Bengal',
'Bhagaldighi,Bankura,West Bengal',
'Dhara,Bankura,West Bengal',
'Digpar,Bankura,West Bengal',
'Gelia,Bankura,West Bengal',
'Gopalnagar,Bankura,West Bengal',
'Hetia,Bankura,West Bengal',
'Hijaldihi,Bankura,West Bengal',
'J.J.Mirjapur,Bankura,West Bengal',
'Joypur,Bankura,West Bengal',
'Jujur,Bankura,West Bengal',
'Karakberia Sadhuadal,Bankura,West Bengal',
'Kuchiakole,Bankura,West Bengal',
'Magura,Bankura,West Bengal',
'Moynapur,Bankura,West Bengal',
'Rahagram,Bankura,West Bengal',
'Routhkhanda,Bankura,West Bengal',
'Salda,Bankura,West Bengal',
'Shyamnagar,Bankura,West Bengal',
'Biswaramba,Burdwan,West Bengal',
'Chakbamongaria,Burdwan,West Bengal',
'Charmaniknagar,Burdwan,West Bengal',
'Chatni,Burdwan,West Bengal',
'Chupi,Burdwan,West Bengal',
'Dupsa,Burdwan,West Bengal',
'Haldinawapara,Burdwan,West Bengal',
'Hapania,Burdwan,West Bengal',
'Jahannagar,Burdwan,West Bengal',
'Jhaudanga,Burdwan,West Bengal',
'Kasthashali,Burdwan,West Bengal',
'Kutirpara,Burdwan,West Bengal',
'Lakshmipur,Burdwan,West Bengal',
'Majida,Burdwan,West Bengal',
'Mertala,Burdwan,West Bengal',
'Minapur,Burdwan,West Bengal',
'Moail,Burdwan,West Bengal',
'Mukshinpara,Burdwan,West Bengal',
'Nasaratpur,Burdwan,West Bengal',
'Parulia,Burdwan,West Bengal',
'Patuli Station Bazar,Burdwan,West Bengal',
'Raidogachi,Burdwan,West Bengal',
'Raipur,Burdwan,West Bengal',
'Sutra,Burdwan,West Bengal',
'Tamaghata,Burdwan,West Bengal',
'Ukhra Sarangpur,Burdwan,West Bengal',
'Alampur,Burdwan,West Bengal',
'Bandhmura,Burdwan,West Bengal',
'Barampur,Burdwan,West Bengal',
'Bileswar,Burdwan,West Bengal',
'Churpuni,Burdwan,West Bengal',
'Gourdanga,Burdwan,West Bengal',
'Khatundi,Burdwan,West Bengal',
'Kosigram,Burdwan,West Bengal',
'Kurchi,Burdwan,West Bengal',
'Mulgram,Burdwan,West Bengal',
'Multikrishnanagar,Burdwan,West Bengal',
'Mustafapur,Burdwan,West Bengal',
'Okarsa,Burdwan,West Bengal',
'Sribati,Burdwan,West Bengal',
'Arkama,Bankura,West Bengal',
'Baidyanathpur,Bankura,West Bengal',
'Chaka,Bankura,West Bengal',
'Darsole,Bankura,West Bengal',
'Hetiasole,Bankura,West Bengal',
'Jamda,Bankura,West Bengal',
'Kakradara,Bankura,West Bengal',
'Kashipur,Bankura,West Bengal',
'Kesia,Bankura,West Bengal',
'Kharidungri,Bankura,West Bengal',
'Khatra,Bankura,West Bengal',
'Muragram,Bankura,West Bengal',
'Nagri,Bankura,West Bengal',
'Shyambazar,Bankura,West Bengal',
'Supur,Bankura,West Bengal',
'Tiring,Bankura,West Bengal',
'Ahritola,Kolkata North,West Bengal',
'Alambazar,Kolkata North,West Bengal',
'Amrita Bazar Partika,Kolkata North,West Bengal',
'Archana,Kolkata North,West Bengal',
'Ashokegarh,Kolkata North,West Bengal',
'Baghbazar,Kolkata North,West Bengal',
'Baranagar,Kolkata North,West Bengal',
'Beadon Street,Kolkata North,West Bengal',
'Bediapara,Kolkata North,West Bengal',
'Belgachia Road,Kolkata North,West Bengal',
'Belgachia,Kolkata North,West Bengal',
'Bengal Immunity,Kolkata North,West Bengal',
'Bidhan Sarani,Kolkata North,West Bengal',
'Bonhooghly,Kolkata North,West Bengal',
'Cossipore Gun Factory,Kolkata North,West Bengal',
'Cossipore H.O,Kolkata North,West Bengal',
'Deshbandhu Road,Kolkata North,West Bengal',
'Dumdum Road,Kolkata North,West Bengal',
'Dumdum,Kolkata North,West Bengal',
'Durganagar,Kolkata North,West Bengal',
'Ghugudanga,Kolkata North,West Bengal',
'Girish Avenue,Kolkata North,West Bengal',
'Hatkhola,Kolkata North,West Bengal',
'Health Institute,Kolkata North,West Bengal',
'Indian Research,Kolkata North,West Bengal',
'ISI Po,Kolkata North,West Bengal',
'Jawpore,Kolkata North,West Bengal',
'Jessore Road,Kolkata North,West Bengal',
'Jorasanko,Kolkata North,West Bengal',
'Jugipara Satganchi,Kolkata North,West Bengal',
'Kalakar Street,Kolkata North,West Bengal',
'Kamalapur,Kolkata North,West Bengal',
'Kendriya Vihar,Kolkata North,West Bengal',
'Kolkata Airport Po,Kolkata North,West Bengal',
'Kolkata Airport,Kolkata North,West Bengal',
'Kolkata Armed Police,Kolkata North,West Bengal',
'Kumarpara,Kolkata North,West Bengal',
'Kuthighat Road,Kolkata North,West Bengal',
'Lily Biscuit,Kolkata North,West Bengal',
'Mall Road,Kolkata North,West Bengal',
'Manicktala,Kolkata North,West Bengal',
'Motijheel,Kolkata North,West Bengal',
'Nagerbazar,Kolkata North,West Bengal',
'Netaji Colony,Kolkata North,West Bengal',
'Noapara,Kolkata North,West Bengal',
'Northern Avenue,Kolkata North,West Bengal',
'Ordnance Factory,Kolkata North,West Bengal',
'Paikapara,Kolkata North,West Bengal',
'Pathuriaghata,Kolkata North,West Bengal',
'Postal Stores Depot,Kolkata North,West Bengal',
'Purba Sinthee,Kolkata North,West Bengal',
'R.G.Kar Medical College,Kolkata North,West Bengal',
'Rabindra Nagar,Kolkata North,West Bengal',
'Rajabagan,Kolkata North,West Bengal',
'Sahitya Parisad,Kolkata North,West Bengal',
'Satchasipara,Kolkata North,West Bengal',
'Sethbagan,Kolkata North,West Bengal',
'Shyambazar Mail,Kolkata North,West Bengal',
'Simla,Kolkata North,West Bengal',
'Sinthee,Kolkata North,West Bengal',
'South Sinhee,Kolkata North,West Bengal',
'Subhas Nagar,Kolkata North,West Bengal',
'Tala,Kolkata North,West Bengal',
'Ultadanga Main Road,Kolkata North,West Bengal',
'Ultadanga,Kolkata North,West Bengal',
'Vaishya Sabha,Kolkata North,West Bengal',
'Amdahi,Bankura,West Bengal',
'Aswinkota,Bankura,West Bengal',
'Balitha,Bankura,West Bengal',
'Bhagalpur,Bankura,West Bengal',
'Darapur,Bankura,West Bengal',
'Dashere,Bankura,West Bengal',
'Dehuapara,Bankura,West Bengal',
'Deshra,Bankura,West Bengal',
'Gopinathpur,Bankura,West Bengal',
'Jayrambati,Bankura,West Bengal',
'Kankatabati,Bankura,West Bengal',
'Karakberia,Bankura,West Bengal',
'Kotalpur,Bankura,West Bengal',
'Lego,Bankura,West Bengal',
'Lougram,Bankura,West Bengal',
'Madhanmohanpur,Bankura,West Bengal',
'Panua,Bankura,West Bengal',
'Raibaghini,Bankura,West Bengal',
'Samantakhanda,Bankura,West Bengal',
'Sihar,Bankura,West Bengal',
'Sihas,Bankura,West Bengal',
'Tajpurgram,Bankura,West Bengal',
'Ardhagram,Bankura,West Bengal',
'Barakalibari,Bankura,West Bengal',
'Benabaid,Bankura,West Bengal',
'Dangmejhia,Bankura,West Bengal',
'Japamali,Bankura,West Bengal',
'Kansara,Bankura,West Bengal',
'Mejhia,Bankura,West Bengal',
'Pairasole,Bankura,West Bengal',
'Sadhana Rangamati,Bankura,West Bengal',
'Sripatpurnia,Bankura,West Bengal',
'Thakurbari Ramchandrapur,Bankura,West Bengal',
'Banjora,Bankura,West Bengal',
'Chakshanjandi,Burdwan,West Bengal',
'Agarda,Bankura,West Bengal',
'Arabani,Bankura,West Bengal',
'Baliara,Bankura,West Bengal',
'Chhagulia,Bankura,West Bengal',
'Chingani,Bankura,West Bengal',
'Damodarbati,Bankura,West Bengal',
'Garh Kotalpur,Bankura,West Bengal',
'Gholkunda,Bankura,West Bengal',
'Gorasole,Bankura,West Bengal',
'Helna Susunia,Bankura,West Bengal',
'Hirapur,Bankura,West Bengal',
'Jamjuri,Bankura,West Bengal',
'Kantabari,Bankura,West Bengal',
'Kostia,Bankura,West Bengal',
'Lodna,Bankura,West Bengal',
'Louda,Bankura,West Bengal',
'Majdiha,Bankura,West Bengal',
'Makorkole,Bankura,West Bengal',
'Mandarboni,Bankura,West Bengal',
'Mankhamar,Bankura,West Bengal',
'Medinipurgram,Bankura,West Bengal',
'Murakata,Bankura,West Bengal',
'Nabajibanpur,Bankura,West Bengal',
'Nakaijuri,Bankura,West Bengal',
'Natungram,Bankura,West Bengal',
'Nikunjapur,Bankura,West Bengal',
'Onda,Bankura,West Bengal',
'Palassboni,Bankura,West Bengal',
'Patpur,Bankura,West Bengal',
'Punisole,Bankura,West Bengal',
'Ramsagar,Bankura,West Bengal',
'Ranikhamar,Bankura,West Bengal',
'Teleberia,Bankura,West Bengal',
'Balsi,Bankura,West Bengal',
'Bamira,Bankura,West Bengal',
'Bankisole,Bankura,West Bengal',
'Belut,Bankura,West Bengal',
'Betur,Bankura,West Bengal',
'Ghoradanga,Bankura,West Bengal',
'Hamirpur,Bankura,West Bengal',
'Hatkrishnanagar,Bankura,West Bengal',
'Jamkuri,Bankura,West Bengal',
'Kabirchak,Bankura,West Bengal',
'Kakatia,Bankura,West Bengal',
'Kenety,Bankura,West Bengal',
'Kushadwip,Bankura,West Bengal',
'Majurdanga,Bankura,West Bengal',
'Pandua,Bankura,West Bengal',
'Parulia,Bankura,West Bengal',
'Patit,Bankura,West Bengal',
'Patrasayer,Bankura,West Bengal',
'Salna,Bankura,West Bengal',
'Akhuapal,Bankura,West Bengal',
'Amchura,Bankura,West Bengal',
'Barikul,Bankura,West Bengal',
'Chingra,Bankura,West Bengal',
'Dudhya,Bankura,West Bengal',
'Dumurtore,Bankura,West Bengal',
'Dundar,Bankura,West Bengal',
'Fulkusma,Bankura,West Bengal',
'Fulsusunia,Bankura,West Bengal',
'Garhraipur,Bankura,West Bengal',
'Kharigeria,Bankura,West Bengal',
'Mandalkuli,Bankura,West Bengal',
'Melera,Bankura,West Bengal',
'Motgoda,Bankura,West Bengal',
'Moulasole,Bankura,West Bengal',
'Nutangarh,Bankura,West Bengal',
'Pairaguri,Bankura,West Bengal',
'Pali,Bankura,West Bengal',
'Parkura-anara,Bankura,West Bengal',
'Penchakola,Bankura,West Bengal',
'Raidihi,Bankura,West Bengal',
'Satpatta,Bankura,West Bengal',
'Shyamsundarpur,Bankura,West Bengal',
'Siromonipur,Bankura,West Bengal',
'Sonagara,Bankura,West Bengal',
'Akkhuta,Bankura,West Bengal',
'Ambikanagar,Bankura,West Bengal',
'Bhethuala,Bankura,West Bengal',
'Birkham,Bankura,West Bengal',
'Dabri,Bankura,West Bengal',
'Deuli,Bankura,West Bengal',
'Dhadanga,Bankura,West Bengal',
'Dhagara,Bankura,West Bengal',
'Ghagra-haludkanali,Bankura,West Bengal',
'Gorabari,Bankura,West Bengal',
'Gunpura,Bankura,West Bengal',
'Haludkanali,Bankura,West Bengal',
'Hijlitilabani,Bankura,West Bengal',
'Jhilimili,Bankura,West Bengal',
'Kadmagarh,Bankura,West Bengal',
'Kamo,Bankura,West Bengal',
'Metha-am,Bankura,West Bengal',
'Muchikata,Bankura,West Bengal',
'Nabachiada,Bankura,West Bengal',
'Puddi,Bankura,West Bengal',
'Puranpani,Bankura,West Bengal',
'Ranibandh,Bankura,West Bengal',
'Routara,Bankura,West Bengal',
'Rudra,Bankura,West Bengal',
'Sindri-am,Bankura,West Bengal',
'Tungcharar,Bankura,West Bengal',
'Bakulia,Bankura,West Bengal',
'Bamuntore,Bankura,West Bengal',
'Bishjore,Bankura,West Bengal',
'Chandra,Bankura,West Bengal',
'Gogra,Bankura,West Bengal',
'Gossindihi,Bankura,West Bengal',
'Kanuri,Bankura,West Bengal',
'Kultuka,Bankura,West Bengal',
'Matukbani,Bankura,West Bengal',
'Murlu,Bankura,West Bengal',
'Pabra,Bankura,West Bengal',
'Salma,Bankura,West Bengal',
'Salroha,Bankura,West Bengal',
'Saltora,Bankura,West Bengal',
'Shyampur,Bankura,West Bengal',
'Tiluri,Bankura,West Bengal',
'Baragarrah,Bankura,West Bengal',
'Basudebpur,Bankura,West Bengal',
'Choutar,Bankura,West Bengal',
'Gangnala,Bankura,West Bengal',
'Gargaria,Bankura,West Bengal',
'Jambani,Bankura,West Bengal',
'Moukura,Bankura,West Bengal',
'Penchara Deuli,Bankura,West Bengal',
'Sarenga,Bankura,West Bengal',
'Sukhadali,Bankura,West Bengal',
'Tapta-damdi,Bankura,West Bengal',
'Bandubrajpur,Bankura,West Bengal',
'Bansarenga,Bankura,West Bengal',
'Baricha,Bankura,West Bengal',
'Bhedua,Bankura,West Bengal',
'Bhutsahar,Bankura,West Bengal',
'Bikrampur,Bankura,West Bengal',
'Dahala,Bankura,West Bengal',
'Doldere,Bankura,West Bengal',
'Hetyagora,Bankura,West Bengal',
'Jirabaid,Bankura,West Bengal',
'Lakshmisagar,Bankura,West Bengal',
'Layekpara,Bankura,West Bengal',
'Machatora,Bankura,West Bengal',
'Maidhara,Bankura,West Bengal',
'Mandalgram,Bankura,West Bengal',
'Mukundapur,Bankura,West Bengal',
'Nemaipur,Bankura,West Bengal',
'Parsola,Bankura,West Bengal',
'Pathardoba,Bankura,West Bengal',
'Puipal,Bankura,West Bengal',
'Pukhuria,Bankura,West Bengal',
'Putiadaha,Bankura,West Bengal',
'Simlapal,Bankura,West Bengal',
'Tilabani,Bankura,West Bengal',
'Amritpara,Bankura,West Bengal',
'Birsinghpur,Bankura,West Bengal',
'Bonbirsingha,Bankura,West Bengal',
'Dhansimla,Bankura,West Bengal',
'Dipara,Bankura,West Bengal',
'Gopikantapur,Bankura,West Bengal',
'Hadal Narayanpur,Bankura,West Bengal',
'Hamirhati,Bankura,West Bengal',
'Ichharia,Bankura,West Bengal',
'Kochdihi,Bankura,West Bengal',
'Kundapuskarani,Bankura,West Bengal',
'Machdoba,Bankura,West Bengal',
'Majirdanga,Bankura,West Bengal',
'Manikbazar,Bankura,West Bengal',
'Nabasan,Bankura,West Bengal',
'Nutanbalarampur,Bankura,West Bengal',
'Pakhanna,Bankura,West Bengal',
'Palashdanga,Bankura,West Bengal',
'Panchal,Bankura,West Bengal',
'Pearberia,Bankura,West Bengal',
'Radhamohanpur,Bankura,West Bengal',
'Ranpur,Bankura,West Bengal',
'Rapatganj,Bankura,West Bengal',
'Sonamukhi Rath Tala,Bankura,West Bengal',
'Sonamukhi,Bankura,West Bengal',
'Ladabrahmandiha,Bankura,West Bengal',
'Bhalukbasa,Bankura,West Bengal',
'Biborda,Bankura,West Bengal',
'Chawkshyampur,Bankura,West Bengal',
'Dauni,Bankura,West Bengal',
'Fulmati,Bankura,West Bengal',
'Harmasra,Bankura,West Bengal',
'Kadma,Bankura,West Bengal',
'Khalagram,Bankura,West Bengal',
'Khulyamuri,Bankura,West Bengal',
'Kitchka,Bankura,West Bengal',
'Mamra,Bankura,West Bengal',
'Methana,Bankura,West Bengal',
'Murakati Saltora,Bankura,West Bengal',
'Nachna,Bankura,West Bengal',
'Paksara,Bankura,West Bengal',
'Panchmura,Bankura,West Bengal',
'Parardanga,Bankura,West Bengal',
'Pratappur,Bankura,West Bengal',
'Sabrakone,Bankura,West Bengal',
'Saralia,Bankura,West Bengal',
'Satmouli,Bankura,West Bengal',
'Taldangra,Bankura,West Bengal',
'Agriculture Farm,Burdwan,West Bengal',
'Ajhapur,Burdwan,West Bengal',
'Akalpoush,Burdwan,West Bengal',
'Amadpur,Burdwan,West Bengal',
'Amaragarh,Burdwan,West Bengal',
'Arjunpur,Burdwan,West Bengal',
'Aruar,Burdwan,West Bengal',
'Atuhatpara,Burdwan,West Bengal',
'Ausgram,Burdwan,West Bengal',
'Bagnapara,Burdwan,West Bengal',
'Baidyapur,Burdwan,West Bengal',
'Bajepratappur NDDF,Burdwan,West Bengal',
'Bamnabagram,Burdwan,West Bengal',
'Bamunpara,Burdwan,West Bengal',
'Banwaribad Raj,Burdwan,West Bengal',
'Barabelun,Burdwan,West Bengal',
'Baramitrapara,Burdwan,West Bengal',
'Barapalashan,Burdwan,West Bengal',
'Barsul Unnayani,Burdwan,West Bengal',
'Bhaduripara,Burdwan,West Bengal',
'Bhatar,Burdwan,West Bengal',
'Bhatkunda,Burdwan,West Bengal',
'Bhedia,Burdwan,West Bengal',
'Bhuri,Burdwan,West Bengal',
'Bohar,Burdwan,West Bengal',
'Bonpas,Burdwan,West Bengal',
'Budbud,Burdwan,West Bengal',
'Burdwan Bar Library,Burdwan,West Bengal',
'Burdwan District School Board,Burdwan,West Bengal',
'Burdwan Medical College,Burdwan,West Bengal',
'Burdwan Rajbari,Burdwan,West Bengal',
'Burdwan Rs,Burdwan,West Bengal',
'Burdwan University,Burdwan,West Bengal',
'Chakdighi,Burdwan,West Bengal',
'Chotonilpur,Burdwan,West Bengal',
'Dainhat,Burdwan,West Bengal',
'Dhatrigram,Burdwan,West Bengal',
'Durgapur Alloy Steel Probject,Asansol,West Bengal',
'Galsi,Burdwan,West Bengal',
'Ghordourchati,Burdwan,West Bengal',
'Golapbag,Burdwan,West Bengal',
'Gonpur,Burdwan,West Bengal',
'Gushkara New Town,Burdwan,West Bengal',
'Gushkara,Burdwan,West Bengal',
'Harisava,Burdwan,West Bengal',
'Hatgobindapur,Burdwan,West Bengal',
'Hatkirtinagar,Burdwan,West Bengal',
'Ichlabad,Burdwan,West Bengal',
'Jamalpur,Burdwan,West Bengal',
'Kalna Court,Burdwan,West Bengal',
'Kalna,Burdwan,West Bengal',
'Kamalakanta Kalibari,Burdwan,West Bengal',
'Kandra,Burdwan,West Bengal',
'Kasenagar,Burdwan,West Bengal',
'Katwa Bazar,Burdwan,West Bengal',
'Katwa College,Burdwan,West Bengal',
'Katwa Station Bazar,Burdwan,West Bengal',
'Ketugram,Burdwan,West Bengal',
'Khajurdihi,Burdwan,West Bengal',
'Khaluibill,Burdwan,West Bengal',
'Khana Jn.,Burdwan,West Bengal',
'Khandaghosh,Burdwan,West Bengal',
'Kotalhat,Burdwan,West Bengal',
'Koychor,Burdwan,West Bengal',
'Mandalgram,Burdwan,West Bengal',
'Mankar,Burdwan,West Bengal',
'Manteswar,Burdwan,West Bengal',
'Memari Bazar,Burdwan,West Bengal',
'Memari,Burdwan,West Bengal',
'Muraripur,Burdwan,West Bengal',
'Nabagram,Burdwan,West Bengal',
'Nadanghat,Burdwan,West Bengal',
'Narayanapur,Burdwan,West Bengal',
'Nasigram,Burdwan,West Bengal',
'Nibhuji Bazar,Burdwan,West Bengal',
'Nrisinghapur,Burdwan,West Bengal',
'Nutanganj,Burdwan,West Bengal',
'Nutanhat,Burdwan,West Bengal',
'Nutanpalli,Burdwan,West Bengal',
'Orgram,Burdwan,West Bengal',
'Paharhati,Burdwan,West Bengal',
'Panagar Bazara,Burdwan,West Bengal',
'Panagar,Burdwan,West Bengal',
'Panuhat,Burdwan,West Bengal',
'Patuli,Burdwan,West Bengal',
'Raina,Burdwan,West Bengal',
'Ranisayar,Burdwan,West Bengal',
'Rannagar Gram,Asansol,West Bengal',
'Rasulpur,Burdwan,West Bengal',
'Saktigarh,Burdwan,West Bengal',
'Sankharipukur,Burdwan,West Bengal',
'Sarbamangala Bari,Burdwan,West Bengal',
'Satgachia,Burdwan,West Bengal',
'Sehara,Burdwan,West Bengal',
'Shilampur,Burdwan,West Bengal',
'Shyamsundar,Burdwan,West Bengal',
'Singerkone,Burdwan,West Bengal',
'Sripalli,Burdwan,West Bengal',
'Suata,Burdwan,West Bengal',
'Sudhanpur,Burdwan,West Bengal',
'Sundarghat,Burdwan,West Bengal',
'Trilokchandpur,Burdwan,West Bengal',
'Uchalan,Burdwan,West Bengal',
'Uniatatarpur,Burdwan,West Bengal',
'Ura,Burdwan,West Bengal',
'Andal,Asansol,West Bengal',
'Andal South Bazar,Asansol,West Bengal',
'Andalgram,Asansol,West Bengal',
'Baktarnagar,Asansol,West Bengal',
'Dakhin Khanda,Asansol,West Bengal',
'Dhandadihi,Asansol,West Bengal',
'Kajoragram,Asansol,West Bengal',
'Madanpur,Asansol,West Bengal',
'Madhusudhanpur,Asansol,West Bengal',
'Moira Colliery,Asansol,West Bengal',
'Parascole,Asansol,West Bengal',
'Srirampur,Asansol,West Bengal',
'Asansol Bazar,Asansol,West Bengal',
'Asansol Court,Asansol,West Bengal',
'Burnpur Mkt,Asansol,West Bengal',
'Burnpur,Asansol,West Bengal',
'Burnpur Works,Asansol,West Bengal',
'Chotodighari,Asansol,West Bengal',
'Dakhin Dhadka,Asansol,West Bengal',
'Damra,Asansol,West Bengal',
'Dharampur,Asansol,West Bengal',
'Hill View,Asansol,West Bengal',
'Hirapur,Asansol,West Bengal',
'Hutton Road,Asansol,West Bengal',
'Jhingri Mohallah,Asansol,West Bengal',
'Kalajhoria,Asansol,West Bengal',
'Kalipahari,Asansol,West Bengal',
'Kalla Central Hospital,Asansol,West Bengal',
'Kumarpur,Asansol,West Bengal',
'Mohishila,Asansol,West Bengal',
'Mohishila Colony,Asansol,West Bengal',
'Narsinghbandh,Asansol,West Bengal',
'Palashbagan,Asansol,West Bengal',
'Radhanagar,Asansol,West Bengal',
'Rahmatdanga,Asansol,West Bengal',
'Railpar,Asansol,West Bengal',
'Rambandh,Asansol,West Bengal',
'Rambandhutalaw,Asansol,West Bengal',
'Rotibati,Asansol,West Bengal',
'S.B.Gorai Road,Asansol,West Bengal',
'S.D.Hospital,Asansol,West Bengal',
'Santa,Asansol,West Bengal',
'Santinagar,Asansol,West Bengal',
'Sripur Bazar,Asansol,West Bengal',
'Suryanagar,Asansol,West Bengal',
'U C Danga,Asansol,West Bengal',
'Ushagram,Asansol,West Bengal',
'Asansol H.O,Asansol,West Bengal',
'Baraboni,Asansol,West Bengal',
'Bhanora,Asansol,West Bengal',
'Birkulti,Asansol,West Bengal',
'Charanpur,Asansol,West Bengal',
'Domahani Bazar,Asansol,West Bengal',
'Jamgram,Asansol,West Bengal',
'Kankhaya,Asansol,West Bengal',
'Kanyapur,Asansol,West Bengal',
'Kapista,Asansol,West Bengal',
'Kelejora,Asansol,West Bengal',
'Lalganj,Asansol,West Bengal',
'Majhiara,Asansol,West Bengal',
'Nandi,Asansol,West Bengal',
'Nischinta,Asansol,West Bengal',
'Nuni,Asansol,West Bengal',
'Panuria,Asansol,West Bengal',
'Pariharpur,Asansol,West Bengal',
'Raghunathchak,Asansol,West Bengal',
'Roshna,Asansol,West Bengal',
'Barakar,Asansol,West Bengal',
'Amarun,Burdwan,West Bengal',
'Amarun Bazar,Burdwan,West Bengal',
'Aogram,Burdwan,West Bengal',
'Asanpur,Burdwan,West Bengal',
'Athghara,Burdwan,West Bengal',
'Auria,Burdwan,West Bengal',
'Bamsor,Burdwan,West Bengal',
'Barashyambazar,Burdwan,West Bengal',
'Basuda,Burdwan,West Bengal',
'Bazar Bankapashi,Burdwan,West Bengal',
'Bhalgram,Burdwan,West Bengal',
'Chakuria,Burdwan,West Bengal',
'Chandipur Kanpur,Burdwan,West Bengal',
'Debpur,Burdwan,West Bengal',
'Denur,Burdwan,West Bengal',
'Dhenria,Burdwan,West Bengal',
'Fulgram,Burdwan,West Bengal',
'Gobordhanpur,Burdwan,West Bengal',
'Hargram,Burdwan,West Bengal',
'Hossainpur,Burdwan,West Bengal',
'Jabagram,Burdwan,West Bengal',
'Jamra,Burdwan,West Bengal',
'Jhilu,Burdwan,West Bengal',
'Jogeswardihi,Burdwan,West Bengal',
'Kaigram,Burdwan,West Bengal',
'Kalapahari,Burdwan,West Bengal',
'Kalui,Burdwan,West Bengal',
'Karui,Burdwan,West Bengal',
'Kasa,Burdwan,West Bengal',
'Kherur,Burdwan,West Bengal',
'Khirgram,Burdwan,West Bengal',
'Kuara,Burdwan,West Bengal',
'Kulai,Burdwan,West Bengal',
'Kunda,Burdwan,West Bengal',
'Lohar,Burdwan,West Bengal',
'Majhigram,Burdwan,West Bengal',
'Maldanga,Burdwan,West Bengal',
'Mathrun,Burdwan,West Bengal',
'Mongalkote,Burdwan,West Bengal',
'Muratipur,Burdwan,West Bengal',
'Nigun,Burdwan,West Bengal',
'Nityanandapur,Burdwan,West Bengal',
'Pachim Kharampur,Burdwan,West Bengal',
'Palar,Burdwan,West Bengal',
'Palishgram,Burdwan,West Bengal',
'Palita,Burdwan,West Bengal',
'Palsona,Burdwan,West Bengal',
'Panjua,Burdwan,West Bengal',
'Pindira Boura,Burdwan,West Bengal',
'Poshla,Burdwan,West Bengal',
'Puini,Burdwan,West Bengal',
'Purba Gopalpur,Burdwan,West Bengal',
'Purbo Khanpur Bamunpara,Burdwan,West Bengal',
'Purbo Noaapara,Burdwan,West Bengal',
'Ratanpur,Burdwan,West Bengal',
'Sahebganj,Burdwan,West Bengal',
'Sanchalida,Burdwan,West Bengal',
'Shimulia Danga,Burdwan,West Bengal',
'Shyamnabagram,Burdwan,West Bengal',
'Singholi,Burdwan,West Bengal',
'Sunur,Burdwan,West Bengal',
'Tarasusunia,Burdwan,West Bengal',
'Thangapara,Burdwan,West Bengal',
'Saragram,Burdwan,West Bengal',
'Bhatakul,Burdwan,West Bengal',
'Bhojpur,Burdwan,West Bengal',
'Boinchee,Burdwan,West Bengal',
'Golatun,Burdwan,West Bengal',
'Khaithan,Burdwan,West Bengal',
'Jubila,Burdwan,West Bengal',
'Abujhati,Burdwan,West Bengal',
'Adrahati,Burdwan,West Bengal',
'Aduria,Burdwan,West Bengal',
'Amila,Burdwan,West Bengal',
'Bahirghanna,Burdwan,West Bengal',
'Baikunthapur,Burdwan,West Bengal',
'Bajekumarpur,Burdwan,West Bengal',
'Bankati,Burdwan,West Bengal',
'Barabainan,Burdwan,West Bengal',
'Belan,Burdwan,West Bengal',
'Belar Bhurkunda,Burdwan,West Bengal',
'Belkas,Burdwan,West Bengal',
'Bhaita,Burdwan,West Bengal',
'Bharatpur,Burdwan,West Bengal',
'Bhita,Burdwan,West Bengal',
'Bijpur,Burdwan,West Bengal',
'Birudiha,Burdwan,West Bengal',
'Bolpur,Burdwan,West Bengal',
'Bontir,Burdwan,West Bengal',
'Borar,Burdwan,West Bengal',
'Bowai,Burdwan,West Bengal',
'Bujrukhdighi,Burdwan,West Bengal',
'Burdwan H.O,Burdwan,West Bengal',
'Chagram,Burdwan,West Bengal',
'Chakmuria,Burdwan,West Bengal',
'Chandipur Berugram,Burdwan,West Bengal',
'Chandrahati,Burdwan,West Bengal',
'Chotobainan,Burdwan,West Bengal',
'Chotobelun,Burdwan,West Bengal',
'Chotoramchandrapur,Burdwan,West Bengal',
'Debsala,Burdwan,West Bengal',
'Dwarnari,Burdwan,West Bengal',
'Eklakhi,Burdwan,West Bengal',
'Fagupur,Burdwan,West Bengal',
'Giur,Burdwan,West Bengal',
'Gohagram,Burdwan,West Bengal',
'Golgram,Burdwan,West Bengal',
'Golgrammathurapur,Burdwan,West Bengal',
'Gopalbera,Burdwan,West Bengal',
'Gourbazar,Asansol,West Bengal',
'Hijalna,Burdwan,West Bengal',
'Huria,Burdwan,West Bengal',
'Irkona,Burdwan,West Bengal',
'Jamar,Burdwan,West Bengal',
'Jharul,Burdwan,West Bengal',
'Joykrishnapur,Burdwan,West Bengal',
'Kaiti,Burdwan,West Bengal',
'Kaligram,Burdwan,West Bengal',
'Kamalpur,Burdwan,West Bengal',
'Kamarhati,Burdwan,West Bengal',
'Kanchannagar,Burdwan,West Bengal',
'Kanksa,Burdwan,West Bengal',
'Karjanachati,Burdwan,West Bengal',
'Kasba,Burdwan,West Bengal',
'Kendur,Burdwan,West Bengal',
'Keshabpur,Burdwan,West Bengal',
'Keunta,Burdwan,West Bengal',
'Korar,Burdwan,West Bengal',
'Kota,Burdwan,West Bengal',
'Koyar,Burdwan,West Bengal',
'Kshetia,Burdwan,West Bengal',
'Kubajpur,Burdwan,West Bengal',
'Kumarganj,Burdwan,West Bengal',
'Kurmun,Burdwan,West Bengal',
'Lakurdi,Burdwan,West Bengal',
'Machkhanda,Burdwan,West Bengal',
'Madabdihi,Burdwan,West Bengal',
'Madanagar,Burdwan,West Bengal',
'Mahachanda,Burdwan,West Bengal',
'Masidpur,Burdwan,West Bengal',
'Meral,Burdwan,West Bengal',
'Mirjapur,Burdwan,West Bengal',
'Mohara,Burdwan,West Bengal',
'Mollasarul,Burdwan,West Bengal',
'Monoharsujapur,Burdwan,West Bengal',
'Narugram,Burdwan,West Bengal',
'Nishchintapur,Burdwan,West Bengal',
'Nole,Burdwan,West Bengal',
'Nurkona,Burdwan,West Bengal',
'Oari,Burdwan,West Bengal',
'Pahalanpur,Burdwan,West Bengal',
'Painta,Burdwan,West Bengal',
'Palashan,Burdwan,West Bengal',
'Paraj,Burdwan,West Bengal',
'Pasanda,Burdwan,West Bengal',
'Purangaon,Burdwan,West Bengal',
'Pursa,Burdwan,West Bengal',
'Pursura,Burdwan,West Bengal',
'Rajganj Asthal,Burdwan,West Bengal',
'Rambati,Burdwan,West Bengal',
'Ramgopalpur,Burdwan,West Bengal',
'Rayan,Burdwan,West Bengal',
'Rondia,Burdwan,West Bengal',
'Rupsa,Burdwan,West Bengal',
'Sagrai,Burdwan,West Bengal',
'Sahajpur Hattala,Burdwan,West Bengal',
'Saknara,Burdwan,West Bengal',
'Saloon,Burdwan,West Bengal',
'Sankari,Burdwan,West Bengal',
'Saranga,Burdwan,West Bengal',
'Sasanga,Burdwan,West Bengal',
'Serorai,Burdwan,West Bengal',
'Sherpur,Burdwan,West Bengal',
'Shyamdasbati,Burdwan,West Bengal',
'Somsar,Burdwan,West Bengal',
'Sonai,Burdwan,West Bengal',
'Teandul,Burdwan,West Bengal',
'Telua,Burdwan,West Bengal',
'Torkona,Burdwan,West Bengal',
'Uchhagram,Burdwan,West Bengal',
'Ukhrid,Burdwan,West Bengal',
'Durgapur Re College,Asansol,West Bengal',
'Amrabati,Asansol,West Bengal',
'Amrai,Asansol,West Bengal',
'Angadpur,Asansol,West Bengal',
'Benachity Market,Asansol,West Bengal',
'Benachity,Asansol,West Bengal',
'Bhiringi,Asansol,West Bengal',
'Bidhannagar,Asansol,West Bengal',
'City Centre,Asansol,West Bengal',
'Dhabani,Asansol,West Bengal',
'Durgapur Abl Township,Asansol,West Bengal',
'Durgapur ASP SB Bureau,Asansol,West Bengal',
'Durgapur Brick Field,Asansol,West Bengal',
'Durgapur C Zone,Asansol,West Bengal',
'Durgapur Chemicals,Asansol,West Bengal',
'Durgapur Coke Oven Colony,Asansol,West Bengal',
'Durgapur CRPF Camp,Asansol,West Bengal',
'Durgapur DSP SB Bureau,Asansol,West Bengal',
'Durgapur Heavy Engg Plant,Asansol,West Bengal',
'Durgapur Mg Avenue,Asansol,West Bengal',
'Durgapur Project B Zone,Asansol,West Bengal',
'Durgapur RS,Asansol,West Bengal',
'Durgapur Sagarbhanga Colony,Asansol,West Bengal',
'Durgapur Steel Project,Asansol,West Bengal',
'Durgapur Steel Town East,Asansol,West Bengal',
'Durgapur Steel Town West,Asansol,West Bengal',
'Durgapur Thermal Power Station,Asansol,West Bengal',
'Fuljhore,Asansol,West Bengal',
'Gopinathpur,Asansol,West Bengal',
'Kamalpur,Asansol,West Bengal',
'Naudiha,Asansol,West Bengal',
'Oyaria,Asansol,West Bengal',
'Pratappur,Asansol,West Bengal',
'V.K.Nagar,Asansol,West Bengal',
'Durgapur H.O,Asansol,West Bengal',
'Abhirampur,Burdwan,West Bengal',
'Amar,Burdwan,West Bengal',
'Bara Balgona,Burdwan,West Bengal',
'Barakashiara,Burdwan,West Bengal',
'Belari,Burdwan,West Bengal',
'Belgram,Burdwan,West Bengal',
'Berenda,Burdwan,West Bengal',
'Bhaghar,Burdwan,West Bengal',
'Chandul,Burdwan,West Bengal',
'Deoradanga,Burdwan,West Bengal',
'Digha,Burdwan,West Bengal',
'Dignagar,Burdwan,West Bengal',
'Eral,Burdwan,West Bengal',
'Gannya Deriapur,Burdwan,West Bengal',
'Gramdighi,Burdwan,West Bengal',
'Hedogora,Burdwan,West Bengal',
'Jadabganj,Burdwan,West Bengal',
'Jaipur,Burdwan,West Bengal',
'Keleti,Burdwan,West Bengal',
'Kerotia,Burdwan,West Bengal',
'Kuldiha,Burdwan,West Bengal',
'Kurumba,Burdwan,West Bengal',
'Mahata,Burdwan,West Bengal',
'Mandarbati,Burdwan,West Bengal',
'Mohanpur,Burdwan,West Bengal',
'Narayanpur,Burdwan,West Bengal',
'Pachkula,Burdwan,West Bengal',
'Paligram,Burdwan,West Bengal',
'Panduk,Burdwan,West Bengal',
'Parisha,Burdwan,West Bengal',
'Pichkuri,Burdwan,West Bengal',
'Pratappur,Burdwan,West Bengal',
'Rairamchandrapur,Burdwan,West Bengal',
'Saha Basantapur,Burdwan,West Bengal',
'Samantapara,Burdwan,West Bengal',
'Sanko,Burdwan,West Bengal',
'Sarulia,Burdwan,West Bengal',
'Satinandi,Burdwan,West Bengal',
'Shar,Burdwan,West Bengal',
'Shibda,Burdwan,West Bengal',
'Shyamsundarpur,Burdwan,West Bengal',
'Simdal,Burdwan,West Bengal',
'Somaipur,Burdwan,West Bengal',
'Takipur,Burdwan,West Bengal',
'Talit,Burdwan,West Bengal',
'Uttarramnagar,Burdwan,West Bengal',
'Bhota,Burdwan,West Bengal',
'Bhuera,Burdwan,West Bengal',
'Goligram,Burdwan,West Bengal',
'Khandaridanga,Burdwan,West Bengal',
'Khano,Burdwan,West Bengal',
'Khurul,Burdwan,West Bengal',
'Kolkol,Burdwan,West Bengal',
'Nrisinghapur,Burdwan,West Bengal',
'Bahadurpur,Asansol,West Bengal',
'Benali,Asansol,West Bengal',
'Bhuri,Asansol,West Bengal',
'Bogra,Asansol,West Bengal',
'Chinchuria,Asansol,West Bengal',
'Churulia,Asansol,West Bengal',
'Devchandnagar,Asansol,West Bengal',
'Hijalgora,Asansol,West Bengal',
'Ikrah,Asansol,West Bengal',
'Jemahari,Asansol,West Bengal',
'Jote Janki,Asansol,West Bengal',
'Kenda,Asansol,West Bengal',
'Mandalpur,Asansol,West Bengal',
'Ningha,Asansol,West Bengal',
'Parasea,Asansol,West Bengal',
'Satgram,Asansol,West Bengal',
'Shivpur,Asansol,West Bengal',
'Taltore,Asansol,West Bengal',
'Toposi,Asansol,West Bengal',
'Jamuriahat,Asansol,West Bengal',
'Anukhal,Burdwan,West Bengal',
'Astogoria,Burdwan,West Bengal',
'Badla,Burdwan,West Bengal',
'Begpur,Burdwan,West Bengal',
'Belerhat,Burdwan,West Bengal',
'Bhagra,Burdwan,West Bengal',
'Bijur,Burdwan,West Bengal',
'Bitra,Burdwan,West Bengal',
'Dewania,Burdwan,West Bengal',
'Dirghapara,Burdwan,West Bengal',
'Falishpur,Burdwan,West Bengal',
'Goda Annada,Burdwan,West Bengal',
'Hatbele,Burdwan,West Bengal',
'Ibrahambadsonadanga,Burdwan,West Bengal',
'Jamna,Burdwan,West Bengal',
'Jhikra,Burdwan,West Bengal',
'Kanpur,Burdwan,West Bengal',
'Karanda,Burdwan,West Bengal',
'Katshihi,Burdwan,West Bengal',
'Khandraparulia,Burdwan,West Bengal',
'Krishnadebpur,Burdwan,West Bengal',
'Kuley,Burdwan,West Bengal',
'Kulut,Burdwan,West Bengal',
'Kusumgram,Burdwan,West Bengal',
'Mamudpur,Burdwan,West Bengal',
'Mangalpur,Burdwan,West Bengal',
'Medgachi,Burdwan,West Bengal',
'Nandai,Burdwan,West Bengal',
'Nowapara,Burdwan,West Bengal',
'Piplon,Burdwan,West Bengal',
'Purguna,Burdwan,West Bengal',
'Raigram,Burdwan,West Bengal',
'Sahajpur,Burdwan,West Bengal',
'Sotla,Burdwan,West Bengal',
'Tehatta,Burdwan,West Bengal',
'Amlajora,Asansol,West Bengal',
'Bamunara,Asansol,West Bengal',
'Burdwan Arrah,Asansol,West Bengal',
'Gopalpur,Asansol,West Bengal',
'Jemua,Asansol,West Bengal',
'Kuldiha,Asansol,West Bengal',
'Malandighi,Asansol,West Bengal',
'Rajbandh,Asansol,West Bengal',
'Rakhitpur,Asansol,West Bengal',
'Shibpur,Asansol,West Bengal',
'Agardanga,Burdwan,West Bengal',
'Agradwi R.S.,Burdwan,West Bengal',
'Amgoria,Burdwan,West Bengal',
'Amul,Burdwan,West Bengal',
'Ankhona,Burdwan,West Bengal',
'Ankra,Burdwan,West Bengal',
'Baharan,Burdwan,West Bengal',
'Ballavpara,Burdwan,West Bengal',
'Bamundi,Burdwan,West Bengal',
'Bera,Burdwan,West Bengal',
'Bhagyabantapur,Burdwan,West Bengal',
'Brahmanigram,Burdwan,West Bengal',
'Chakta,Burdwan,West Bengal',
'Chanduli,Burdwan,West Bengal',
'Deasin,Burdwan,West Bengal',
'Ehiapur,Burdwan,West Bengal',
'Gandhpur,Burdwan,West Bengal',
'Gangatikuri,Burdwan,West Bengal',
'Gidhgram,Burdwan,West Bengal',
'Hatkalua,Burdwan,West Bengal',
'Islampur,Burdwan,West Bengal',
'Kachutia,Burdwan,West Bengal',
'Kalikapur,Burdwan,West Bengal',
'Kantodihi,Burdwan,West Bengal',
'Karajgram,Burdwan,West Bengal',
'Katwa H.O,Burdwan,West Bengal',
'Keuguri,Burdwan,West Bengal',
'Khanji,Burdwan,West Bengal',
'Komarpur,Burdwan,West Bengal',
'Masthuli,Burdwan,West Bengal',
'Masundi,Burdwan,West Bengal',
'Mougram,Burdwan,West Bengal',
'Nabagram,Burdwan,West Bengal',
'Nirol,Burdwan,West Bengal',
'Pachundi,Burdwan,West Bengal',
'Rajoor,Burdwan,West Bengal',
'Roundi Srirampur,Burdwan,West Bengal',
'Sadipur Berugram,Burdwan,West Bengal',
'Sankai,Burdwan,West Bengal',
'Shibloon,Burdwan,West Bengal',
'Sitahati,Burdwan,West Bengal',
'Srigopalpur,Burdwan,West Bengal',
'Srigram,Burdwan,West Bengal',
'Aldihi,Asansol,West Bengal',
'Asanboni,Asansol,West Bengal',
'Baltoria,Asansol,West Bengal',
'Baradhemo,Asansol,West Bengal',
'Begunia Bazar,Asansol,West Bengal',
'Bejdih,Asansol,West Bengal',
'Bidyanandapur,Asansol,West Bengal',
'Chinakuri,Asansol,West Bengal',
'Disergarh,Asansol,West Bengal',
'Ethora,Asansol,West Bengal',
'Gangutia,Asansol,West Bengal',
'Kalyaneshwari,Asansol,West Bengal',
'Kendua,Asansol,West Bengal',
'Kulti,Asansol,West Bengal',
'Lalbazar,Asansol,West Bengal',
'Mithani,Asansol,West Bengal',
'Neamatpur,Asansol,West Bengal',
'Old Sitarampur,Asansol,West Bengal',
'Patmohana,Asansol,West Bengal',
'Radhanagar Rly Colony,Asansol,West Bengal',
'Ramnagar,Asansol,West Bengal',
'Sitalpur,Asansol,West Bengal',
'Sitarampur,Asansol,West Bengal',
'Sunderchak,Asansol,West Bengal',
'Amdahi,Asansol,West Bengal',
'Balijuri,Asansol,West Bengal',
'Gogla,Asansol,West Bengal',
'Ichapur,Asansol,West Bengal',
'Jamgora,Asansol,West Bengal',
'Jhanjhra,Asansol,West Bengal',
'Khandra,Asansol,West Bengal',
'Kumardihi,Asansol,West Bengal',
'Laudoha,Asansol,West Bengal',
'Nabagram,Asansol,West Bengal',
'Nakrakonda,Asansol,West Bengal',
'Nutandanga,Asansol,West Bengal',
'Patsora,Asansol,West Bengal',
'Sankarpur,Asansol,West Bengal',
'Sarpi,Asansol,West Bengal',
'Ukhra Puratanhattala,Asansol,West Bengal',
'Ukhra,Asansol,West Bengal',
'Bonogram,Burdwan,West Bengal',
'Anguna,Burdwan,West Bengal',
'Bagila,Burdwan,West Bengal',
'Bahabpur,Burdwan,West Bengal',
'Bahadurpur,Burdwan,West Bengal',
'Balgona,Burdwan,West Bengal',
'Bara Mahesh,Burdwan,West Bengal',
'Begut,Burdwan,West Bengal',
'Belna,Burdwan,West Bengal',
'Berugram,Burdwan,West Bengal',
'Bhandardihi,Burdwan,West Bengal',
'Biruha,Burdwan,West Bengal',
'Bishnubati,Burdwan,West Bengal',
'Borar,Burdwan,West Bengal',
'Boro Balaram,Burdwan,West Bengal',
'Chanchai,Burdwan,West Bengal',
'Chotkhanda,Burdwan,West Bengal',
'Debip R.S.,Burdwan,West Bengal',
'Debipur,Burdwan,West Bengal',
'Deriapur,Burdwan,West Bengal',
'Dhuluk,Burdwan,West Bengal',
'Faridpur,Burdwan,West Bengal',
'Ghosh,Burdwan,West Bengal',
'Gontar,Burdwan,West Bengal',
'Habaspur,Burdwan,West Bengal',
'Hatsridharpur,Burdwan,West Bengal',
'Ilsara,Burdwan,West Bengal',
'Jabui,Burdwan,West Bengal',
'Jaragram,Burdwan,West Bengal',
'Jaugram,Burdwan,West Bengal',
'Jotsrirampur,Burdwan,West Bengal',
'Kalanabagram,Burdwan,West Bengal',
'Kalibele,Burdwan,West Bengal',
'Kamargoria,Burdwan,West Bengal',
'Kamarkita,Burdwan,West Bengal',
'Kashiara,Burdwan,West Bengal',
'Kasthakurumba,Burdwan,West Bengal',
'Keotara,Burdwan,West Bengal',
'Khagrakaranda,Burdwan,West Bengal',
'Kuchut,Burdwan,West Bengal',
'Kulingram,Burdwan,West Bengal',
'Maheshdanga,Burdwan,West Bengal',
'Malamba,Burdwan,West Bengal',
'Masagram,Burdwan,West Bengal',
'Nabastha,Burdwan,West Bengal',
'Natumohanpur,Burdwan,West Bengal',
'Nimo,Burdwan,West Bengal',
'Palla,Burdwan,West Bengal',
'Palla R.S.,Burdwan,West Bengal',
'Panchra,Burdwan,West Bengal',
'Paratal,Burdwan,West Bengal',
'Parbatpur,Burdwan,West Bengal',
'Radhakantapur,Burdwan,West Bengal',
'Ramchandrapur,Burdwan,West Bengal',
'Reora Gopalpur,Burdwan,West Bengal',
'Runkini Mahalla,Burdwan,West Bengal',
'Sadipur,Burdwan,West Bengal',
'Sah Hossainpur,Burdwan,West Bengal',
'Samanti,Burdwan,West Bengal',
'Sanchra,Burdwan,West Bengal',
'Sanktia,Burdwan,West Bengal',
'Sasinara,Burdwan,West Bengal',
'Sodda,Burdwan,West Bengal',
'Sonapalashi,Burdwan,West Bengal',
'Sonargaria,Burdwan,West Bengal',
'Suhari,Burdwan,West Bengal',
'Sukur,Burdwan,West Bengal',
'Sultanpur,Burdwan,West Bengal',
'Surekanla,Burdwan,West Bengal',
'Susunia,Burdwan,West Bengal',
'Untia,Burdwan,West Bengal',
'Kenna,Burdwan,West Bengal',
'Bahula,Asansol,West Bengal',
'Haripur,Asansol,West Bengal',
'Kendra,Asansol,West Bengal',
'Khottadihi,Asansol,West Bengal',
'Semallya,Asansol,West Bengal',
'Siduli,Asansol,West Bengal',
'Sonepur,Asansol,West Bengal',
'Sripur,Asansol,West Bengal',
'Pandaveshwar,Asansol,West Bengal',
'Amrasota,Asansol,West Bengal',
'Amritnagar,Asansol,West Bengal',
'Ballavpur,Asansol,West Bengal',
'Bansra,Asansol,West Bengal',
'Bidhanbag,Asansol,West Bengal',
'Bijpur,Asansol,West Bengal',
'Bilpahari,Asansol,West Bengal',
'Chelod,Asansol,West Bengal',
'Egara,Asansol,West Bengal',
'Kharsuli Bazar,Asansol,West Bengal',
'Nimcha,Asansol,West Bengal',
'Nupur,Asansol,West Bengal',
'Searsole Rajbari,Asansol,West Bengal',
'Raniganj H.O,Asansol,West Bengal',
'Achra,Asansol,West Bengal',
'Amladahi,Asansol,West Bengal',
'Basudevpur Jemari,Asansol,West Bengal',
'Chittaranjan,Asansol,West Bengal',
'Chittaranjan TS,Asansol,West Bengal',
'Hindustan Cables,Asansol,West Bengal',
'Rupnarayanpur Bazar,Asansol,West Bengal',
'Salanpur,Asansol,West Bengal',
'Samdi,Asansol,West Bengal',
'Seakulberia,Asansol,West Bengal',
'Simjuri,Asansol,West Bengal',
'Churar,Bhirbhum,West Bengal',
'Paigora,Bhirbhum,West Bengal',
'Ranipathar,Bhirbhum,West Bengal',
'Abadanga,Bhirbhum,West Bengal',
'Abinashpur,Bhirbhum,West Bengal',
'Adityapur,Bhirbhum,West Bengal',
'Ahmadpur,Bhirbhum,West Bengal',
'Albandha,Bhirbhum,West Bengal',
'Aligarh,Bhirbhum,West Bengal',
'Aligram,Bhirbhum,West Bengal',
'Ambhua,Bhirbhum,West Bengal',
'Amdole,Bhirbhum,West Bengal',
'Amjolpahari,Bhirbhum,West Bengal',
'Anantapurkanaipur,Bhirbhum,West Bengal',
'Atla,Bhirbhum,West Bengal',
'Ayas,Bhirbhum,West Bengal',
'B.Collectorate,Bhirbhum,West Bengal',
'Babuijore,Bhirbhum,West Bengal',
'Bagdola,Bhirbhum,West Bengal',
'Bagdowra,Bhirbhum,West Bengal',
'Bagrakonda,Bhirbhum,West Bengal',
'Bahadurpur,Bhirbhum,West Bengal',
'Bahiri,Bhirbhum,West Bengal',
'Bahutali,Bhirbhum,West Bengal',
'Baidyanathpur,Bhirbhum,West Bengal',
'Bakreswar,Bhirbhum,West Bengal',
'Baliharpur,Bhirbhum,West Bengal',
'Balijuri,Bhirbhum,West Bengal',
'Banagram,Bhirbhum,West Bengal',
'Bandar,Bhirbhum,West Bengal',
'Bandhaipur,Bhirbhum,West Bengal',
'Bandhkhola,Bhirbhum,West Bengal',
'Bangachhatra,Bhirbhum,West Bengal',
'Bangsabati,Bhirbhum,West Bengal',
'Banior,Bhirbhum,West Bengal',
'Bansanka,Bhirbhum,West Bengal',
'Bara,Bhirbhum,West Bengal',
'Baraalunda,Bhirbhum,West Bengal',
'Barabagan,Bhirbhum,West Bengal',
'Barakartickchungri,Bhirbhum,West Bengal',
'Baram,Bhirbhum,West Bengal',
'Barapahari,Bhirbhum,West Bengal',
'Barasija,Bhirbhum,West Bengal',
'Barha,Bhirbhum,West Bengal',
'Barhra,Bhirbhum,West Bengal',
'Barla,Bhirbhum,West Bengal',
'Barsal,Bhirbhum,West Bengal',
'Baruipara,Bhirbhum,West Bengal',
'Basudevpur,Bhirbhum,West Bengal',
'Baswa,Bhirbhum,West Bengal',
'Bataspur,Bhirbhum,West Bengal',
'Batikar,Bhirbhum,West Bengal',
'Bautia,Bhirbhum,West Bengal',
'Begunia,Bhirbhum,West Bengal',
'Belai,Bhirbhum,West Bengal',
'Belatisultanpur,Bhirbhum,West Bengal',
'Belhati,Bhirbhum,West Bengal',
'Belia,Bhirbhum,West Bengal',
'Beliakuricha,Bhirbhum,West Bengal',
'Beliamritunjoypur,Bhirbhum,West Bengal',
'Beliapalsa,Bhirbhum,West Bengal',
'Benuria,Bhirbhum,West Bengal',
'Bergram,Bhirbhum,West Bengal',
'Bhabanandapur,Bhirbhum,West Bengal',
'Bhabanipur,Bhirbhum,West Bengal',
'Bhabanipur Bhatra,Bhirbhum,West Bengal',
'Bhadista,Bhirbhum,West Bengal',
'Bhadrapur,Bhirbhum,West Bengal',
'Bhadulia,Bhirbhum,West Bengal',
'Bhalas,Bhirbhum,West Bengal',
'Bhalkuti,Bhirbhum,West Bengal',
'Bharkata,Bhirbhum,West Bengal',
'Bhatra,Bhirbhum,West Bengal',
'Bheramari,Bhirbhum,West Bengal',
'Bhimpur,Bhirbhum,West Bengal',
'Bhoromorekol,Bhirbhum,West Bengal',
'Bhurkuna,Bhirbhum,West Bengal',
'Bipranandigram,Bhirbhum,West Bengal',
'Bipratikuri,Bhirbhum,West Bengal',
'Birchandrapur,Bhirbhum,West Bengal',
'Bishnukhanda,Bhirbhum,West Bengal',
'Bishnupur,Bhirbhum,West Bengal',
'Bishnupurkulkuri,Bhirbhum,West Bengal',
'Bishore,Bhirbhum,West Bengal',
'Bk.T.P.P,Bhirbhum,West Bengal',
'Bolpur Bazar,Bhirbhum,West Bengal',
'Bolpur Court,Bhirbhum,West Bengal',
'Bolpur,Bhirbhum,West Bengal',
'Bolpur Trisulapatty,Bhirbhum,West Bengal',
'Bolpur Ukilpatty,Bhirbhum,West Bengal',
'Bonha,Bhirbhum,West Bengal',
'Bon-mohurapur,Bhirbhum,West Bengal',
'Bonorampur,Bhirbhum,West Bengal',
'Boruagopalpur,Bhirbhum,West Bengal',
'Brahmanbahara,Bhirbhum,West Bengal',
'Brahmandihi,Bhirbhum,West Bengal',
'Brahmankhanda,Bhirbhum,West Bengal',
'Brahmanpara,Bhirbhum,West Bengal',
'Budhigram,Bhirbhum,West Bengal',
'Bujung,Bhirbhum,West Bengal',
'Bunia,Bhirbhum,West Bengal',
'Ch.Nanoor,Bhirbhum,West Bengal',
'Chakaipur,Bhirbhum,West Bengal',
'Chakdaha,Bhirbhum,West Bengal',
'Chakpara,Bhirbhum,West Bengal',
'Chandipur Tarapith,Bhirbhum,West Bengal',
'Chandpara,Bhirbhum,West Bengal',
'Changuria,Bhirbhum,West Bengal',
'Charicha,Bhirbhum,West Bengal',
'Charkolgram,Bhirbhum,West Bengal',
'Chatra,Bhirbhum,West Bengal',
'Chautara,Bhirbhum,West Bengal',
'Chhamna,Bhirbhum,West Bengal',
'Chhatina,Bhirbhum,West Bengal',
'Chhototurigram,Bhirbhum,West Bengal',
'Chilinpur,Bhirbhum,West Bengal',
'Chinpai,Bhirbhum,West Bengal',
'Choto-sangra,Bhirbhum,West Bengal',
'Chowhatta,Bhirbhum,West Bengal',
'Chunpalasi,Bhirbhum,West Bengal',
'Dabuk,Bhirbhum,West Bengal',
'Dadpur,Bhirbhum,West Bengal',
'Dakhalbati,Bhirbhum,West Bengal',
'Dakshingram,Bhirbhum,West Bengal',
'Damdama,Bhirbhum,West Bengal',
'Damra,Bhirbhum,West Bengal',
'Dantura,Bhirbhum,West Bengal',
'Daranda,Bhirbhum,West Bengal',
'Daronda Ranipara,Bhirbhum,West Bengal',
'Darpasila,Bhirbhum,West Bengal',
'Daskalgram,Bhirbhum,West Bengal',
'Daspalsa,Bhirbhum,West Bengal',
'Debagram Anaipur,Bhirbhum,West Bengal',
'Debagram,Bhirbhum,West Bengal',
'Debagramchuramali,Bhirbhum,West Bengal',
'Debiparulia,Bhirbhum,West Bengal',
'Dekhuria,Bhirbhum,West Bengal',
'Delora,Bhirbhum,West Bengal',
'Deriapur,Bhirbhum,West Bengal',
'Derpur,Bhirbhum,West Bengal',
'Deucha,Bhirbhum,West Bengal',
'Dewas Chandpur,Bhirbhum,West Bengal',
'Dhalla,Bhirbhum,West Bengal',
'Dhananjoypur,Bhirbhum,West Bengal',
'Dholtikuri,Bhirbhum,West Bengal',
'Dhrubabati,Bhirbhum,West Bengal',
'Digha,Bhirbhum,West Bengal',
'Dighalgram,Bhirbhum,West Bengal',
'Diha,Bhirbhum,West Bengal',
'Dohira,Bhirbhum,West Bengal',
'Dubrajpur,Bhirbhum,West Bengal',
'Dumrut,Bhirbhum,West Bengal',
'Dumurgram,Bhirbhum,West Bengal',
'Dunigram,Bhirbhum,West Bengal',
'Duria,Bhirbhum,West Bengal',
'Dwarka,Bhirbhum,West Bengal',
'Dwaruri,Bhirbhum,West Bengal',
'Edrakpur,Bhirbhum,West Bengal',
'Fewgram,Bhirbhum,West Bengal',
'Fulur,Bhirbhum,West Bengal',
'Gadadharpur,Bhirbhum,West Bengal',
'Gadadharpur R.S.,Bhirbhum,West Bengal',
'Gaganpur,Bhirbhum,West Bengal',
'Ganeshpur,Bhirbhum,West Bengal',
'Gannaserandi,Bhirbhum,West Bengal',
'Ganra,Bhirbhum,West Bengal',
'Gargaria,Bhirbhum,West Bengal',
'Geruapahari,Bhirbhum,West Bengal',
'Ghatdurlavpur,Bhirbhum,West Bengal',
'Gheedaha,Bhirbhum,West Bengal',
'Ghoratori,Bhirbhum,West Bengal',
'Ghoshgram,Bhirbhum,West Bengal',
'Ghurisha,Bhirbhum,West Bengal',
'Goalmal,Bhirbhum,West Bengal',
'Gohaliara,Bhirbhum,West Bengal',
'Gonpur,Bhirbhum,West Bengal',
'Gopalchak,Bhirbhum,West Bengal',
'Gopalpur,Bhirbhum,West Bengal',
'Gopegram,Bhirbhum,West Bengal',
'Gorola,Bhirbhum,West Bengal',
'Gosainpur,Bhirbhum,West Bengal',
'Gug,Bhirbhum,West Bengal',
'Gunutia,Bhirbhum,West Bengal',
'Hansra,Bhirbhum,West Bengal',
'Haraipur,Bhirbhum,West Bengal',
'Haridaspur,Bhirbhum,West Bengal',
'Harinsingha,Bhirbhum,West Bengal',
'Harioka,Bhirbhum,West Bengal',
'Harowa,Bhirbhum,West Bengal',
'Hatia,Bhirbhum,West Bengal',
'Hatjanbazar,Bhirbhum,West Bengal',
'Hatora,Bhirbhum,West Bengal',
'Hatserandi,Bhirbhum,West Bengal',
'Hazratpur,Bhirbhum,West Bengal',
'Hetampur Rajbati,Bhirbhum,West Bengal',
'Hilora,Bhirbhum,West Bengal',
'Ikra,Bhirbhum,West Bengal',
'Ikra Hazrapur,Bhirbhum,West Bengal',
'Illambazar,Bhirbhum,West Bengal',
'Indus,Bhirbhum,West Bengal',
'Ishakpur,Bhirbhum,West Bengal',
'Iswarpurndtso,Bhirbhum,West Bengal',
'Itagoria,Bhirbhum,West Bengal',
'Jahidpur,Bhirbhum,West Bengal',
'Jajigram,Bhirbhum,West Bengal',
'Jalandi,Bhirbhum,West Bengal',
'Jangaldubrajpur,Bhirbhum,West Bengal',
'Janubazar,Bhirbhum,West Bengal',
'Januri,Bhirbhum,West Bengal',
'Jatra,Bhirbhum,West Bengal',
'Jesthabhabanipur,Bhirbhum,West Bengal',
'Jhirul,Bhirbhum,West Bengal',
'Jiwe,Bhirbhum,West Bengal',
'Jogai,Bhirbhum,West Bengal',
'Joplai,Bhirbhum,West Bengal',
'Joydevkenduli,Bhirbhum,West Bengal',
'Joykrishnapur,Bhirbhum,West Bengal',
'Joypur,Bhirbhum,West Bengal',
'Junidpur,Bhirbhum,West Bengal',
'Kabilpur,Bhirbhum,West Bengal',
'Kahinagar,Bhirbhum,West Bengal',
'Kaitha,Bhirbhum,West Bengal',
'Kajipara,Bhirbhum,West Bengal',
'Kalahapur,Bhirbhum,West Bengal',
'Kaleswar,Bhirbhum,West Bengal',
'Kalitha,Bhirbhum,West Bengal',
'Kaluha,Bhirbhum,West Bengal',
'Kamadpur,Bhirbhum,West Bengal',
'Kanachi,Bhirbhum,West Bengal',
'Kanaighat,Bhirbhum,West Bengal',
'Kanakpur,Bhirbhum,West Bengal',
'Kandighi,Bhirbhum,West Bengal',
'Kankartala,Bhirbhum,West Bengal',
'Kanserhat,Bhirbhum,West Bengal',
'Kanspai,Bhirbhum,West Bengal',
'Kantagoria,Bhirbhum,West Bengal',
'Kanutia,Bhirbhum,West Bengal',
'Kapista,Bhirbhum,West Bengal',
'Karidhya,Bhirbhum,West Bengal',
'Karkaria,Bhirbhum,West Bengal',
'Kasba,Bhirbhum,West Bengal',
'Kasimnagar,Bhirbhum,West Bengal',
'Kastogoria,Bhirbhum,West Bengal',
'Kathia,Bhirbhum,West Bengal',
'Katigram,Bhirbhum,West Bengal',
'Kendragoria,Bhirbhum,West Bengal',
'Khandagram,Bhirbhum,West Bengal',
'Khanjanpur,Bhirbhum,West Bengal',
'Khanpur,Bhirbhum,West Bengal',
'Khantanga,Bhirbhum,West Bengal',
'Kharbona,Bhirbhum,West Bengal',
'Kharun,Bhirbhum,West Bengal',
'Khemedda,Bhirbhum,West Bengal',
'Kheyerpara,Bhirbhum,West Bengal',
'Khoyrasole,Bhirbhum,West Bengal',
'Khujutipara,Bhirbhum,West Bengal',
'Kirnahar,Bhirbhum,West Bengal',
'Kogram,Bhirbhum,West Bengal',
'Konarpur,Bhirbhum,West Bengal',
'Koreya,Bhirbhum,West Bengal',
'Kota,Bhirbhum,West Bengal',
'Kotasur,Bhirbhum,West Bengal',
'Koyemba,Bhirbhum,West Bengal',
'Koyra,Bhirbhum,West Bengal',
'Krishnapur,Bhirbhum,West Bengal',
'Kuchligopalpur,Bhirbhum,West Bengal',
'Kuchuighata,Bhirbhum,West Bengal',
'Kukhudihi,Bhirbhum,West Bengal',
'Kukutia,Bhirbhum,West Bengal',
'Kuliara,Bhirbhum,West Bengal',
'Kumarpur,Bhirbhum,West Bengal',
'Kundala,Bhirbhum,West Bengal',
'Kundira,Bhirbhum,West Bengal',
'Kuniara,Bhirbhum,West Bengal',
'Kunuri,Bhirbhum,West Bengal',
'Kurmitha,Bhirbhum,West Bengal',
'Kurulmetia,Bhirbhum,West Bengal',
'Kurumgram,Bhirbhum,West Bengal',
'Kurumsha,Bhirbhum,West Bengal',
'Kurunnahar,Bhirbhum,West Bengal',
'Kusmore,Bhirbhum,West Bengal',
'Kusumba,Bhirbhum,West Bengal',
'Kusumba,Bhirbhum,West Bengal',
'Kusumi,Bhirbhum,West Bengal',
'Labpur Mastali,Bhirbhum,West Bengal',
'Labpur,Bhirbhum,West Bengal',
'Laghosa,Bhirbhum,West Bengal',
'Laha,Bhirbhum,West Bengal',
'Lakshmi Narayan Pur,Bhirbhum,West Bengal',
'Laldaha,Bhirbhum,West Bengal',
'Langalhata,Bhirbhum,West Bengal',
'Langulia,Bhirbhum,West Bengal',
'Latbhabanipur,Bhirbhum,West Bengal',
'Lauberia,Bhirbhum,West Bengal',
'Laujore,Bhirbhum,West Bengal',
'Loba,Bhirbhum,West Bengal',
'Lohapur,Bhirbhum,West Bengal',
'Lokpur,Bhirbhum,West Bengal',
'Madhaipur,Bhirbhum,West Bengal',
'Mahajanpatty,Bhirbhum,West Bengal',
'Maheshpur,Bhirbhum,West Bengal',
'Mahodory,Bhirbhum,West Bengal',
'Majhigram,Bhirbhum,West Bengal',
'Majiara,Bhirbhum,West Bengal',
'Majkhanda,Bhirbhum,West Bengal',
'Makdamnagar,Bhirbhum,West Bengal',
'Malaypur,Bhirbhum,West Bengal',
'Mallarpur,Bhirbhum,West Bengal',
'Mallickpur,Bhirbhum,West Bengal',
'Mangaldihi,Bhirbhum,West Bengal',
'Margram,Bhirbhum,West Bengal',
'Mathpalsa,Bhirbhum,West Bengal',
'Matikona,Bhirbhum,West Bengal',
'Mayureswar,Bhirbhum,West Bengal',
'Md.Bazar,Bhirbhum,West Bengal',
'Md.Bazar Town Ship,Bhirbhum,West Bengal',
'Metela,Bhirbhum,West Bengal',
'Mitrapur,Bhirbhum,West Bengal',
'Modhura,Bhirbhum,West Bengal',
'Mohanpur,Bhirbhum,West Bengal',
'Mohubona,Bhirbhum,West Bengal',
'Mohula,Bhirbhum,West Bengal',
'Mohurapur,Bhirbhum,West Bengal',
'Monoharpur,Bhirbhum,West Bengal',
'Moukhira,Bhirbhum,West Bengal',
'Muktipur,Bhirbhum,West Bengal',
'Muluk,Bhirbhum,West Bengal',
'Murarai,Bhirbhum,West Bengal',
'Muruli Dangal,Bhirbhum,West Bengal',
'Mustofadanga,Bhirbhum,West Bengal',
'Nabasan,Bhirbhum,West Bengal',
'Nachansaha,Bhirbhum,West Bengal',
'Nagari,Bhirbhum,West Bengal',
'Nahina,Bhirbhum,West Bengal',
'Nakrakonda,Bhirbhum,West Bengal',
'Nalhati,Bhirbhum,West Bengal',
'Nalhati Township,Bhirbhum,West Bengal',
'Narasinghapur,Bhirbhum,West Bengal',
'Narayanpur,Bhirbhum,West Bengal',
'Nayagram,Bhirbhum,West Bengal',
'Netaipur,Bhirbhum,West Bengal',
'Nimdaspur,Bhirbhum,West Bengal',
'Nimgoria,Bhirbhum,West Bengal',
'Ningha,Bhirbhum,West Bengal',
'Niramoy Sanetorium Giridangaed,Bhirbhum,West Bengal',
'Nirisha,Bhirbhum,West Bengal',
'Nischintapur Jagatpur,Bhirbhum,West Bengal',
'Nischintapur,Bhirbhum,West Bengal',
'Noapara,Bhirbhum,West Bengal',
'Nonadanga,Bhirbhum,West Bengal',
'Nowaparamahadipa,Bhirbhum,West Bengal',
'Nurpur,Bhirbhum,West Bengal',
'Omarpur,Bhirbhum,West Bengal',
'Pachhiara,Bhirbhum,West Bengal',
'Pafuri,Bhirbhum,West Bengal',
'Paharpur,Bhirbhum,West Bengal',
'Paikar,Bhirbhum,West Bengal',
'Paikpara,Bhirbhum,West Bengal',
'Paikuni,Bhirbhum,West Bengal',
'Pakhuria,Bhirbhum,West Bengal',
'Pakurhans,Bhirbhum,West Bengal',
'Palita,Bhirbhum,West Bengal',
'Palsa,Bhirbhum,West Bengal',
'Panchahar,Bhirbhum,West Bengal',
'Panchrahat,Bhirbhum,West Bengal',
'Panchsowa,Bhirbhum,West Bengal',
'Panditpur,Bhirbhum,West Bengal',
'Panrui,Bhirbhum,West Bengal',
'Panuria,Bhirbhum,West Bengal',
'Paruldanga,Bhirbhum,West Bengal',
'Parulia,Bhirbhum,West Bengal',
'Paruliahazrapur,Bhirbhum,West Bengal',
'Paschimnarayanpur,Bhirbhum,West Bengal',
'Patadanga,Bhirbhum,West Bengal',
'Pathai,Bhirbhum,West Bengal',
'Patharchapuri,Bhirbhum,West Bengal',
'Patnil,Bhirbhum,West Bengal',
'Payer,Bhirbhum,West Bengal',
'Peruagopalpur,Bhirbhum,West Bengal',
'Poprasahapur,Bhirbhum,West Bengal',
'Pranabanandapally,Bhirbhum,West Bengal',
'Puranagram,Bhirbhum,West Bengal',
'Purbakadipur,Bhirbhum,West Bengal',
'Purbasiur,Bhirbhum,West Bengal',
'Pursundi,Bhirbhum,West Bengal',
'Purundarpur,Bhirbhum,West Bengal',
'Pusulia,Bhirbhum,West Bengal',
'R K Sikshapith,Bhirbhum,West Bengal',
'Railpar,Bhirbhum,West Bengal',
'Raipur,Bhirbhum,West Bengal',
'Rajatpur,Bhirbhum,West Bengal',
'Rajganj,Bhirbhum,West Bengal',
'Rajgaon,Bhirbhum,West Bengal',
'Rajgramgram,Bhirbhum,West Bengal',
'Rajnagar,Bhirbhum,West Bengal',
'Rakhakalitala,Bhirbhum,West Bengal',
'Ramchandrapur,Bhirbhum,West Bengal',
'Ramnagar,Bhirbhum,West Bengal',
'Rampur,Bhirbhum,West Bengal',
'Rampurhat H.O,Bhirbhum,West Bengal',
'Rangaipur,Bhirbhum,West Bengal',
'Ranigram,Bhirbhum,West Bengal',
'Rasa,Bhirbhum,West Bengal',
'Raturi,Bhirbhum,West Bengal',
'Rautara,Bhirbhum,West Bengal',
'Rudranagar,Bhirbhum,West Bengal',
'Rupaspur,Bhirbhum,West Bengal',
'Ruppur,Bhirbhum,West Bengal',
'Ruprampur,Bhirbhum,West Bengal',
'Sagarbhanga,Bhirbhum,West Bengal',
'Sahapur,Bhirbhum,West Bengal',
'Sahora,Bhirbhum,West Bengal',
'Sainthia Bazar,Bhirbhum,West Bengal',
'Sainthia,Bhirbhum,West Bengal',
'Sajina,Bhirbhum,West Bengal',
'Sakodda,Bhirbhum,West Bengal',
'Salisanda,Bhirbhum,West Bengal',
'Sanakpur,Bhirbhum,West Bengal',
'Sandhigorabazar,Bhirbhum,West Bengal',
'Sandhyajole,Bhirbhum,West Bengal',
'Sansat,Bhirbhum,West Bengal',
'Santiniketan,Bhirbhum,West Bengal',
'Saraswatibazar,Bhirbhum,West Bengal',
'Sardha,Bhirbhum,West Bengal',
'Sarenda,Bhirbhum,West Bengal',
'Satpalsa,Bhirbhum,West Bengal',
'Sattore,Bhirbhum,West Bengal',
'Saugram,Bhirbhum,West Bengal',
'Sauta,Bhirbhum,West Bengal',
'Sehelaraipur,Bhirbhum,West Bengal',
'Seherakuri,Bhirbhum,West Bengal',
'Sekpur,Bhirbhum,West Bengal',
'Sian,Bhirbhum,West Bengal',
'Sidhori,Bhirbhum,West Bengal',
'Sikarpur,Bhirbhum,West Bengal',
'Sindurtopa,Bhirbhum,West Bengal',
'Singhee,Bhirbhum,West Bengal',
'Sirsha,Bhirbhum,West Bengal',
'Sitalgram,Bhirbhum,West Bengal',
'Sitapur,Bhirbhum,West Bengal',
'Sonarkundu,Bhirbhum,West Bengal',
'Sonatoresuri,Bhirbhum,West Bengal',
'Sonj,Bhirbhum,West Bengal',
'Srikrishnapur,Bhirbhum,West Bengal',
'Sriniketan,Bhirbhum,West Bengal',
'Srirampur,Bhirbhum,West Bengal',
'Sultanpur,Bhirbhum,West Bengal',
'Sunmuni,Bhirbhum,West Bengal',
'Supur,Bhirbhum,West Bengal',
'Suri Dist. School Board,Bhirbhum,West Bengal',
'Suri H.O,Bhirbhum,West Bengal',
'Suribazar,Bhirbhum,West Bengal',
'Suricollege,Bhirbhum,West Bengal',
'Swadhinpur,Bhirbhum,West Bengal',
'Tabadumra,Bhirbhum,West Bengal',
'Talibpur,Bhirbhum,West Bengal',
'Taloan,Bhirbhum,West Bengal',
'Tantipara,Bhirbhum,West Bengal',
'Tapaspur,Bhirbhum,West Bengal',
'Tarachua,Bhirbhum,West Bengal',
'Tarapur,Bhirbhum,West Bengal',
'Tatinapara,Bhirbhum,West Bengal',
'Tejhati,Bhirbhum,West Bengal',
'Tentulia,Bhirbhum,West Bengal',
'Thiba,Bhirbhum,West Bengal',
'Thupsara,Bhirbhum,West Bengal',
'Tirogram,Bhirbhum,West Bengal',
'Turigram,Bhirbhum,West Bengal',
'Uchkaran,Bhirbhum,West Bengal',
'Uchpur,Bhirbhum,West Bengal',
'Ujirpur,Bhirbhum,West Bengal',
'Ukrandi,Bhirbhum,West Bengal',
'Ulkunda,Bhirbhum,West Bengal',
'Ushardihi,Bhirbhum,West Bengal',
'Uttarbonogram,Bhirbhum,West Bengal',
'Uttarkhayerbuni,Bhirbhum,West Bengal',
'Chepani,Cooch Behar,West Bengal',
'Gopaldashat,Cooch Behar,West Bengal',
'Jogendranagar,Cooch Behar,West Bengal',
'Sonapur,Cooch Behar,West Bengal',
'Bangchatra,Cooch Behar,West Bengal',
'Airani Chitalia,Cooch Behar,West Bengal',
'Ambari,Cooch Behar,West Bengal',
'Baikunthapur,Cooch Behar,West Bengal',
'Baneswar,Cooch Behar,West Bengal',
'Bhatlaguri,Cooch Behar,West Bengal',
'Bhelakopa,Cooch Behar,West Bengal',
'Bhelapeta,Cooch Behar,West Bengal',
'Bokalirmath,Cooch Behar,West Bengal',
'Chagalber,Cooch Behar,West Bengal',
'Chakchaka,Cooch Behar,West Bengal',
'Chandanchaura,Cooch Behar,West Bengal',
'Charaljani,Cooch Behar,West Bengal',
'Chaudanga,Cooch Behar,West Bengal',
'Chhatbarachauki,Cooch Behar,West Bengal',
'Chhatoa,Cooch Behar,West Bengal',
'Chhoto Khairatibari,Cooch Behar,West Bengal',
'Cooch Behar Bazar,Cooch Behar,West Bengal',
'Cooch Behar New Town,Cooch Behar,West Bengal',
'Cooch Behar Railway Station,Cooch Behar,West Bengal',
'Dawaguri,Cooch Behar,West Bengal',
'Dhangdhinguri,Cooch Behar,West Bengal',
'Dudherkuthi Dewanbash,Cooch Behar,West Bengal',
'Durgabari Subhash Pally,Cooch Behar,West Bengal',
'East Sakunibala,Cooch Behar,West Bengal',
'Ghughumari,Cooch Behar,West Bengal',
'Gopalpur,Cooch Behar,West Bengal',
'Gunjabari,Cooch Behar,West Bengal',
'Guriahati,Cooch Behar,West Bengal',
'Hatiduba,Cooch Behar,West Bengal',
'Holongerkuthi,Cooch Behar,West Bengal',
'Kalika Bazar,Cooch Behar,West Bengal',
'Kaljani,Cooch Behar,West Bengal',
'Khagrabari,Cooch Behar,West Bengal',
'Khapaidanga,Cooch Behar,West Bengal',
'Kharija Kakribari,Cooch Behar,West Bengal',
'Kharimala Khagrbari,Cooch Behar,West Bengal',
'Konamali Khapaidanga,Cooch Behar,West Bengal',
'Krishnapur,Cooch Behar,West Bengal',
'Madhupur,Cooch Behar,West Bengal',
'Mahish Bathan,Cooch Behar,West Bengal',
'Mara Nadir Kuthi,Cooch Behar,West Bengal',
'Maruganj,Cooch Behar,West Bengal',
'Nayarhat,Cooch Behar,West Bengal',
'New Cooch Behar,Cooch Behar,West Bengal',
'Nilkuthi,Cooch Behar,West Bengal',
'Patakura,Cooch Behar,West Bengal',
'Patlakhawa,Cooch Behar,West Bengal',
'Pestarjhar,Cooch Behar,West Bengal',
'Pundibari,Cooch Behar,West Bengal',
'Purba Gopalpur,Cooch Behar,West Bengal',
'Rajarhat,Cooch Behar,West Bengal',
'Rashidanga,Cooch Behar,West Bengal',
'Sajerpar Ghoramara,Cooch Behar,West Bengal',
'Siddheswari,Cooch Behar,West Bengal',
'Sonari,Cooch Behar,West Bengal',
'Sukhdhanerkuthi,Cooch Behar,West Bengal',
'Takagachh,Cooch Behar,West Bengal',
'Talliguri,Cooch Behar,West Bengal',
'Tapurhat,Cooch Behar,West Bengal',
'Uttar Ambari,Cooch Behar,West Bengal',
'Cooch Behar H.O,Cooch Behar,West Bengal',
'Bajejama Pakhihaga,Cooch Behar,West Bengal',
'Balairhat,Cooch Behar,West Bengal',
'Balakandi,Cooch Behar,West Bengal',
'Bamanhat,Cooch Behar,West Bengal',
'Bara Atiabari,Cooch Behar,West Bengal',
'Baranachina,Cooch Behar,West Bengal',
'Baranatabari,Cooch Behar,West Bengal',
'Barasakdal,Cooch Behar,West Bengal',
'Baravita,Cooch Behar,West Bengal',
'Bhagni Parti,Cooch Behar,West Bengal',
'Bhalka Putimari,Cooch Behar,West Bengal',
'Bhetaguri,Cooch Behar,West Bengal',
'Bhulki,Cooch Behar,West Bengal',
'Bhutkura,Cooch Behar,West Bengal',
'Borodanga,Cooch Behar,West Bengal',
'Brahmanir Chauki,Cooch Behar,West Bengal',
'Brahmottar Chatra,Cooch Behar,West Bengal',
'Chamta,Cooch Behar,West Bengal',
'Chanderkuthi,Cooch Behar,West Bengal',
'Chekadera,Cooch Behar,West Bengal',
'Chhoto Atiabari,Cooch Behar,West Bengal',
'Chorekhata,Cooch Behar,West Bengal',
'Chowdhurihat,Cooch Behar,West Bengal',
'Dewanhat,Cooch Behar,West Bengal',
'Dhumerkhata,Cooch Behar,West Bengal',
'Dhumpur Balasi,Cooch Behar,West Bengal',
'Dighaltari,Cooch Behar,West Bengal',
'Dinhata Bazar,Cooch Behar,West Bengal',
'Dinhata,Cooch Behar,West Bengal',
'Durganagar,Cooch Behar,West Bengal',
'Gheghirhat,Cooch Behar,West Bengal',
'Gitaldaha Atiabari,Cooch Behar,West Bengal',
'Gitaldaha,Cooch Behar,West Bengal',
'Gobrasara,Cooch Behar,West Bengal',
'Gossanimari,Cooch Behar,West Bengal',
'Haribhanga,Cooch Behar,West Bengal',
'Hatiram Salbari,Cooch Behar,West Bengal',
'Hokadaha,Cooch Behar,West Bengal',
'Jamadarerbash,Cooch Behar,West Bengal',
'Jarabari,Cooch Behar,West Bengal',
'Jatigara,Cooch Behar,West Bengal',
'Jiranpur,Cooch Behar,West Bengal',
'Kajlikura,Cooch Behar,West Bengal',
'Kalmati,Cooch Behar,West Bengal',
'Kamat Seoraguri,Cooch Behar,West Bengal',
'Karala,Cooch Behar,West Bengal',
'Kawrai,Cooch Behar,West Bengal',
'Khatamari,Cooch Behar,West Bengal',
'Khochabari,Cooch Behar,West Bengal',
'Khutamara,Cooch Behar,West Bengal',
'Kismat Adabari,Cooch Behar,West Bengal',
'Kismat Dasgram,Cooch Behar,West Bengal',
'Koalidaha,Cooch Behar,West Bengal',
'Kuchni,Cooch Behar,West Bengal',
'Kumarganj,Cooch Behar,West Bengal',
'Mansab Seoraguri,Cooch Behar,West Bengal',
'Masanpath,Cooch Behar,West Bengal',
'Matalhat,Cooch Behar,West Bengal',
'Moamari,Cooch Behar,West Bengal',
'Nakarjan,Cooch Behar,West Bengal',
'Nandina,Cooch Behar,West Bengal',
'Natkobarihat,Cooch Behar,West Bengal',
'Nazirhat,Cooch Behar,West Bengal',
'Nigamnagar,Cooch Behar,West Bengal',
'Nutanbash,Cooch Behar,West Bengal',
'Pakhihaga,Cooch Behar,West Bengal',
'Panikhawa,Cooch Behar,West Bengal',
'Panisala,Cooch Behar,West Bengal',
'Petla,Cooch Behar,West Bengal',
'Pushnadanga,Cooch Behar,West Bengal',
'Putimari,Cooch Behar,West Bengal',
'Rakhalmari,Cooch Behar,West Bengal',
'Ratinandan Konamukta Payesthi,Cooch Behar,West Bengal',
'Ruerkuthi,Cooch Behar,West Bengal',
'Sahebganj,Cooch Behar,West Bengal',
'Salmara,Cooch Behar,West Bengal',
'Silduar,Cooch Behar,West Bengal',
'Singimari Madnakura,Cooch Behar,West Bengal',
'Sitaihat,Cooch Behar,West Bengal',
'Souldhukri,Cooch Behar,West Bengal',
'Subachanirpath,Cooch Behar,West Bengal',
'Sukarurkuthi,Cooch Behar,West Bengal',
'Tharaikhana,Cooch Behar,West Bengal',
'Tiadaha,Cooch Behar,West Bengal',
'Ashokebari,Jalpaiguri,West Bengal',
'Bara Haldibari,Jalpaiguri,West Bengal',
'Boxiganj,Jalpaiguri,West Bengal',
'Daripattani,Jalpaiguri,West Bengal',
'Debottar Boxiganj,Jalpaiguri,West Bengal',
'Dewanganj,Jalpaiguri,West Bengal',
'Fatehmamud,Jalpaiguri,West Bengal',
'Kharkharia,Jalpaiguri,West Bengal',
'Manikganjhat,Jalpaiguri,West Bengal',
'Satkura,Jalpaiguri,West Bengal',
'Uttar Daribash,Jalpaiguri,West Bengal',
'Boalmari,Jalpaiguri,West Bengal',
'Akrarhat Bandar,Cooch Behar,West Bengal',
'Andaran Pakhihaga,Cooch Behar,West Bengal',
'Angerkata Paradubi,Cooch Behar,West Bengal',
'Bairati,Cooch Behar,West Bengal',
'Bamanpara,Cooch Behar,West Bengal',
'Bamunia West,Jalpaiguri,West Bengal',
'Baramaricha,Cooch Behar,West Bengal',
'Barogharia Garkuta,Cooch Behar,West Bengal',
'Barogodaikhora,Cooch Behar,West Bengal',
'Bhangamore,Cooch Behar,West Bengal',
'Bhawairthana,Cooch Behar,West Bengal',
'Bhogmara,Cooch Behar,West Bengal',
'Bhogramguri,Jalpaiguri,West Bengal',
'Buraburi,Jalpaiguri,West Bengal',
'Chhoto Salbari,Cooch Behar,West Bengal',
'Chilkirhat,Cooch Behar,West Bengal',
'Dewankot Jayduar,Cooch Behar,West Bengal',
'Domuka Nayarhat,Cooch Behar,West Bengal',
'Elajanerkuthi,Cooch Behar,West Bengal',
'Gadaler Kuthi,Cooch Behar,West Bengal',
'Ghoksadanga,Cooch Behar,West Bengal',
'Golenawhati,Cooch Behar,West Bengal',
'Gossairhat Bandar,Cooch Behar,West Bengal',
'Jatamari,Cooch Behar,West Bengal',
'Jorepatki,Cooch Behar,West Bengal',
'Kalpani,Cooch Behar,West Bengal',
'Kanfata,Cooch Behar,West Bengal',
'Kawardera,Cooch Behar,West Bengal',
'Khalishamari,Cooch Behar,West Bengal',
'Khattimari,Cooch Behar,West Bengal',
'Kurshamari,Cooch Behar,West Bengal',
'Lalbazar Part-II,Cooch Behar,West Bengal',
'Lotapata,Jalpaiguri,West Bengal',
'Madhyam Madhusudan,Cooch Behar,West Bengal',
'Maghpala,Cooch Behar,West Bengal',
'Mahishcharu,Cooch Behar,West Bengal',
'Mahishmuri,Cooch Behar,West Bengal',
'Mathabhanga,Cooch Behar,West Bengal',
'Matiarkuthi,Cooch Behar,West Bengal',
'Nagarlal Bazar,Cooch Behar,West Bengal',
'Nishiganj,Cooch Behar,West Bengal',
'Pachagarh,Cooch Behar,West Bengal',
'Panigram,Jalpaiguri,West Bengal',
'Patakamari,Cooch Behar,West Bengal',
'Patchhara,Cooch Behar,West Bengal',
'Patpishu,Cooch Behar,West Bengal',
'Purba Sitalkuchi,Cooch Behar,West Bengal',
'Putimari Fuleswari,Cooch Behar,West Bengal',
'Shibpur,Cooch Behar,West Bengal',
'Shikarpur,Cooch Behar,West Bengal',
'Shildanga,Cooch Behar,West Bengal',
'Sitalkuchi,Cooch Behar,West Bengal',
'South Bhangamore,Cooch Behar,West Bengal',
'Sutarpara,Cooch Behar,West Bengal',
'Unishbisha,Cooch Behar,West Bengal',
'Baradhaperchatra,Cooch Behar,West Bengal',
'Alok Jhari,Jalpaiguri,West Bengal',
'Amguri Bazar,Jalpaiguri,West Bengal',
'Bagdokra,Jalpaiguri,West Bengal',
'Bairagirhat,Jalpaiguri,West Bengal',
'Barogopalpur,Jalpaiguri,West Bengal',
'Bhotebari,Jalpaiguri,West Bengal',
'Dhulia Baldihati,Jalpaiguri,West Bengal',
'Dhulia Khalisa,Jalpaiguri,West Bengal',
'Dhulia Uchalpukuri,Jalpaiguri,West Bengal',
'Doradabri,Jalpaiguri,West Bengal',
'Fulkadabri,Jalpaiguri,West Bengal',
'Keshoribari,Jalpaiguri,West Bengal',
'Kuchlibari,Jalpaiguri,West Bengal',
'N U Kuchlibari,Jalpaiguri,West Bengal',
'Niztaraf,Jalpaiguri,West Bengal',
'Thunkirjhar,Jalpaiguri,West Bengal',
'Uchalpukuri,Jalpaiguri,West Bengal',
'Upen Chowki Kuchlibari,Jalpaiguri,West Bengal',
'Andaran Fulbari,Cooch Behar,West Bengal',
'Andaranfulbari West,Cooch Behar,West Bengal',
'Bakla,Cooch Behar,West Bengal',
'Bakshirhat,Cooch Behar,West Bengal',
'Balabhut,Cooch Behar,West Bengal',
'Balaghat,Cooch Behar,West Bengal',
'Balakuthi,Cooch Behar,West Bengal',
'Balapukuri,Cooch Behar,West Bengal',
'Barashalbari,Cooch Behar,West Bengal',
'Barokodali,Cooch Behar,West Bengal',
'Begarkhata,Cooch Behar,West Bengal',
'Bhainskuthi,Cooch Behar,West Bengal',
'Bhandijelash,Cooch Behar,West Bengal',
'Bhanukumari,Cooch Behar,West Bengal',
'Bhurkush,Cooch Behar,West Bengal',
'Bilshi,Cooch Behar,West Bengal',
'Chhat Fulbari,Cooch Behar,West Bengal',
'Chhatrampur,Cooch Behar,West Bengal',
'Chhitbaralaukuthi,Cooch Behar,West Bengal',
'Chilakhana,Cooch Behar,West Bengal',
'Colony Chamta,Cooch Behar,West Bengal',
'Debagram,Cooch Behar,West Bengal',
'Deocharai,Cooch Behar,West Bengal',
'Dhadial,Cooch Behar,West Bengal',
'Dhalpal,Cooch Behar,West Bengal',
'Dorkochengtimari,Cooch Behar,West Bengal',
'Dwiperpar,Cooch Behar,West Bengal',
'Falimari,Cooch Behar,West Bengal',
'Ghogarkuthi,Cooch Behar,West Bengal',
'Harirhat,Cooch Behar,West Bengal',
'Jaigir Chilakhana,Cooch Behar,West Bengal',
'Jhaljhali,Cooch Behar,West Bengal',
'Jhaokuthi,Cooch Behar,West Bengal',
'Kamat Fulbari,Cooch Behar,West Bengal',
'Kashidanga,Cooch Behar,West Bengal',
'Langalgram,Cooch Behar,West Bengal',
'Mansai,Cooch Behar,West Bengal',
'Nagurhat,Cooch Behar,West Bengal',
'Nakarkhana,Cooch Behar,West Bengal',
'Natabari,Cooch Behar,West Bengal',
'Rasikbil,Cooch Behar,West Bengal',
'Shalbari,Cooch Behar,West Bengal',
'Shilghagri,Cooch Behar,West Bengal',
'Tufanganj New Town,Cooch Behar,West Bengal',
'Tufanganj,Cooch Behar,West Bengal',
'Uttar Andaranfulbari,Cooch Behar,West Bengal',
'Uttar Falimari,Cooch Behar,West Bengal',
'Uttar Ghogarkuthi,Cooch Behar,West Bengal',
'Badamtam,Darjeeling,West Bengal',
'Bagrakote,Jalpaiguri,West Bengal',
'Bannersberg,Darjeeling,West Bengal',
'Bhanugram,Darjeeling,West Bengal',
'Bhutia Busty,Darjeeling,West Bengal',
'Bijanbari,Darjeeling,West Bengal',
'Bloom Field,Darjeeling,West Bengal',
'Chhotapubong,Darjeeling,West Bengal',
'Chowpukuria,Darjeeling,West Bengal',
'Darjeeling Bazar,Darjeeling,West Bengal',
'Darjeeling Court,Darjeeling,West Bengal',
'Darjeeling H.O,Darjeeling,West Bengal',
'Dooteriah,Darjeeling,West Bengal',
'Dowhill,Darjeeling,West Bengal',
'Geile Banjyang,Darjeeling,West Bengal',
'Ghoom,Darjeeling,West Bengal',
'Gumba,Darjeeling,West Bengal',
'Jalpahar,Darjeeling,West Bengal',
'Lebong,Darjeeling,West Bengal',
'Lingia,Darjeeling,West Bengal',
'Lower Chongtong,Darjeeling,West Bengal',
'Marybong,Darjeeling,West Bengal',
'Mineral Spring,Darjeeling,West Bengal',
'North Point,Darjeeling,West Bengal',
'Pulbazar,Darjeeling,West Bengal',
'Pussimbing,Darjeeling,West Bengal',
'Rajbari,Darjeeling,West Bengal',
'Rangbull,Darjeeling,West Bengal',
'Rangli Rangliot,Darjeeling,West Bengal',
'Risheehat,Darjeeling,West Bengal',
'Rose Bank,Darjeeling,West Bengal',
'Simkuna,Darjeeling,West Bengal',
'Singla,Darjeeling,West Bengal',
'Singtam,Darjeeling,West Bengal',
'Soom,Darjeeling,West Bengal',
'Tamsang,Darjeeling,West Bengal',
'Teesta Valley,Darjeeling,West Bengal',
'Tukvar,Darjeeling,West Bengal',
'Udaigram,Darjeeling,West Bengal',
'Ahlay,Jalpaiguri,West Bengal',
'Ambeok,Jalpaiguri,West Bengal',
'7th Mile Kalimpong,Darjeeling,West Bengal',
'Bankim Park,Darjeeling,West Bengal',
'Bar Dara,Darjeeling,West Bengal',
'Bong Busty,Darjeeling,West Bengal',
'Chhumirchin Manchu,Darjeeling,West Bengal',
'Chibo Busty,Darjeeling,West Bengal',
'Dhajea,Darjeeling,West Bengal',
'Echhey,Darjeeling,West Bengal',
'Gitdubling,Darjeeling,West Bengal',
'Kafer,Darjeeling,West Bengal',
'Kagay Bazar,Darjeeling,West Bengal',
'Kalijhora,Darjeeling,West Bengal',
'Kalimpong Bazar,Darjeeling,West Bengal',
'Kalimpong,Darjeeling,West Bengal',
'Lava,Darjeeling,West Bengal',
'Lolay,Darjeeling,West Bengal',
'Mahakal Dara,Darjeeling,West Bengal',
'Malat Bazar,Darjeeling,West Bengal',
'Mangarjung,Darjeeling,West Bengal',
'Mungpoo,Darjeeling,West Bengal',
'Munsong,Darjeeling,West Bengal',
'Nimbong,Darjeeling,West Bengal',
'Pabring Tar,Darjeeling,West Bengal',
'Pagag Gumpa,Darjeeling,West Bengal',
'Pedong,Darjeeling,West Bengal',
'Peshok,Darjeeling,West Bengal',
'Pudung,Darjeeling,West Bengal',
'Reang,Darjeeling,West Bengal',
'Rousay Bazar,Darjeeling,West Bengal',
'Sakyong,Darjeeling,West Bengal',
'Samthar,Darjeeling,West Bengal',
'Santook Mirik,Darjeeling,West Bengal',
'Seokbir,Darjeeling,West Bengal',
'Sindebong,Darjeeling,West Bengal',
'Suruk,Darjeeling,West Bengal',
'Swansay,Darjeeling,West Bengal',
'Takling,Darjeeling,West Bengal',
'Tashiding,Darjeeling,West Bengal',
'Tendrabong,Darjeeling,West Bengal',
'Tista Bridge,Darjeeling,West Bengal',
'Topkhana,Darjeeling,West Bengal',
'Upper Dalapchand,Darjeeling,West Bengal',
'Yangmakum Pambu,Darjeeling,West Bengal',
'Sinji,Darjeeling,West Bengal',
'Algarah,Darjeeling,West Bengal',
'Phuguri,Darjeeling,West Bengal',
'Ambootia,Darjeeling,West Bengal',
'Bagora,Darjeeling,West Bengal',
'Balasun,Darjeeling,West Bengal',
'Bansbotey,Darjeeling,West Bengal',
'Batasia,Darjeeling,West Bengal',
'Chunbhati,Darjeeling,West Bengal',
'Dara Goan,Darjeeling,West Bengal',
'Deorali,Darjeeling,West Bengal',
'Dumaram Busty,Darjeeling,West Bengal',
'Duptin-10,Darjeeling,West Bengal',
'Gayabari,Darjeeling,West Bengal',
'Goke Bazar,Darjeeling,West Bengal',
'Gopal Dhara,Darjeeling,West Bengal',
'Jamdar Vitta,Darjeeling,West Bengal',
'Jhepi,Darjeeling,West Bengal',
'Kaijalia,Darjeeling,West Bengal',
'Kolbong,Darjeeling,West Bengal',
'Kurseong,Darjeeling,West Bengal',
'Lama Goan,Darjeeling,West Bengal',
'Lamahatta,Darjeeling,West Bengal',
'Lodhomahat,Darjeeling,West Bengal',
'Lopchu,Darjeeling,West Bengal',
'Lower Soureni,Darjeeling,West Bengal',
'Mahanadi,Darjeeling,West Bengal',
'Maney Dara,Darjeeling,West Bengal',
'Maneybhanjeng,Darjeeling,West Bengal',
'Margarets Hope,Darjeeling,West Bengal',
'Mim,Darjeeling,West Bengal',
'Mirik,Darjeeling,West Bengal',
'Moonda Koti,Darjeeling,West Bengal',
'Nagrispur,Darjeeling,West Bengal',
'Nalichor,Darjeeling,West Bengal',
'Norbung,Darjeeling,West Bengal',
'Ookayati,Darjeeling,West Bengal',
'Pankhabari,Darjeeling,West Bengal',
'Plungdung,Darjeeling,West Bengal',
'Pokhriabong,Darjeeling,West Bengal',
'Rangbang,Darjeeling,West Bengal',
'Rangmook,Darjeeling,West Bengal',
'Relling,Darjeeling,West Bengal',
'Rimbick,Darjeeling,West Bengal',
'Ringtong,Darjeeling,West Bengal',
'School Dhura,Darjeeling,West Bengal',
'Seeyok,Darjeeling,West Bengal',
'Selimbong,Darjeeling,West Bengal',
'Singbulli,Darjeeling,West Bengal',
'Singritam,Darjeeling,West Bengal',
'Sonada,Darjeeling,West Bengal',
'Soureni Bazar,Darjeeling,West Bengal',
'St.Mary\'s Hill,Darjeeling,West Bengal',
'Sukhiapokhari,Darjeeling,West Bengal',
'Sukna,Darjeeling,West Bengal',
'Takdah,Darjeeling,West Bengal',
'Tamsing Dhura,Darjeeling,West Bengal',
'Thurbo,Darjeeling,West Bengal',
'Tinchuley,Darjeeling,West Bengal',
'Tindharia,Darjeeling,West Bengal',
'Tung,Darjeeling,West Bengal',
'Gairibas,Jalpaiguri,West Bengal',
'Kumai,Jalpaiguri,West Bengal',
'Adhikari,Darjeeling,West Bengal',
'Badrajote,Darjeeling,West Bengal',
'Bagdogra Air Port,Darjeeling,West Bengal',
'Bagdogra,Darjeeling,West Bengal',
'Baigunta Pur,Darjeeling,West Bengal',
'Belgachi,Darjeeling,West Bengal',
'Bendubi,Darjeeling,West Bengal',
'Bhajanpur Jote,Darjeeling,West Bengal',
'Bhaktinagar,Darjeeling,West Bengal',
'Bilaksu,Darjeeling,West Bengal',
'Buraganj,Darjeeling,West Bengal',
'Champasari,Darjeeling,West Bengal',
'Chathat,Darjeeling,West Bengal',
'Chitalghatta,Darjeeling,West Bengal',
'Dabgram,Darjeeling,West Bengal',
'Desbandhupara,Darjeeling,West Bengal',
'Dulal Jote,Darjeeling,West Bengal',
'East Bhaktinagar,Darjeeling,West Bengal',
'Fulbari Hat,Darjeeling,West Bengal',
'Gayanganga,Darjeeling,West Bengal',
'Ghugumali,Darjeeling,West Bengal',
'Gossaipur,Darjeeling,West Bengal',
'Gulma,Darjeeling,West Bengal',
'Haidarpara,Darjeeling,West Bengal',
'Hardigachh,Darjeeling,West Bengal',
'Hatighisa,Darjeeling,West Bengal',
'Jyoti Nagar,Darjeeling,West Bengal',
'Kadamtala,Darjeeling,West Bengal',
'Kalachandgach,Darjeeling,West Bengal',
'Kamala Bagan,Darjeeling,West Bengal',
'Kantivitta,Darjeeling,West Bengal',
'Khoribari,Darjeeling,West Bengal',
'Lake Town,Darjeeling,West Bengal',
'Latpanchar,Darjeeling,West Bengal',
'Lensipokhari,Darjeeling,West Bengal',
'Lohapool,Darjeeling,West Bengal',
'Madati,Darjeeling,West Bengal',
'Mahananda Bridge,Darjeeling,West Bengal',
'Mahananda Project,Darjeeling,West Bengal',
'Matigara,Darjeeling,West Bengal',
'Naksalbari,Darjeeling,West Bengal',
'Nemai,Darjeeling,West Bengal',
'New Chumta,Darjeeling,West Bengal',
'New Rangia,Darjeeling,West Bengal',
'Nijbari,Darjeeling,West Bengal',
'North Bengal University,Darjeeling,West Bengal',
'Pani Ghatta,Darjeeling,West Bengal',
'Phansidewa,Darjeeling,West Bengal',
'Pradhan Nagar,Darjeeling,West Bengal',
'Putung,Darjeeling,West Bengal',
'Rabindra Sarani,Darjeeling,West Bengal',
'Rangali,Darjeeling,West Bengal',
'Rangapani,Darjeeling,West Bengal',
'Ranidanga,Darjeeling,West Bengal',
'Ranju Valley,Darjeeling,West Bengal',
'Rath Khola,Darjeeling,West Bengal',
'Sahabad,Darjeeling,West Bengal',
'Saktigarh,Darjeeling,West Bengal',
'Salugarah,Darjeeling,West Bengal',
'Satellite Township,Darjeeling,West Bengal',
'School Dhura,Darjeeling,West Bengal',
'Selpu,Darjeeling,West Bengal',
'Sevoke Road,Darjeeling,West Bengal',
'Siliguri Bazar,Darjeeling,West Bengal',
'Siliguri H.O,Darjeeling,West Bengal',
'Siliguri Junction,Darjeeling,West Bengal',
'Siliguri New Market,Darjeeling,West Bengal',
'Siliguri Road,Darjeeling,West Bengal',
'Siliguri Town,Darjeeling,West Bengal',
'Simulbari,Darjeeling,West Bengal',
'Sitong,Darjeeling,West Bengal',
'Subashpally,Darjeeling,West Bengal',
'Sushrut Nagar,Darjeeling,West Bengal',
'Tarbandha,Darjeeling,West Bengal',
'Tharjhorabagan,Darjeeling,West Bengal',
'Vivekanandapally,Darjeeling,West Bengal',
'Tentulmuri,Contai,West Bengal',
'Garhkamalpur,Tamluk,West Bengal',
'Ajodhyapur,Contai,West Bengal',
'Ajoya,Contai,West Bengal',
'Alamchak Belda,Contai,West Bengal',
'Alangiri,Contai,West Bengal',
'Alankarpur,Contai,West Bengal',
'Alukaranbarh,Contai,West Bengal',
'Amarpur,Contai,West Bengal',
'Amarshi,Contai,West Bengal',
'Amtalia,Contai,West Bengal',
'Analberia,Contai,West Bengal',
'Angua,Contai,West Bengal',
'Arankiarana,Tamluk,West Bengal',
'Argoal,Contai,West Bengal',
'Argora,Contai,West Bengal',
'Arjunnagar,Contai,West Bengal',
'Astichak,Contai,West Bengal',
'Aswathapur,Contai,West Bengal',
'Atbati,Contai,West Bengal',
'Aurai,Contai,West Bengal',
'Ayma Barbaria,Contai,West Bengal',
'Baharganj,Contai,West Bengal',
'Bahitrakunda,Contai,West Bengal',
'Baikunthapur,Contai,West Bengal',
'Baita Bazar,Contai,West Bengal',
'Baksispur,Contai,West Bengal',
'Balageria,Contai,West Bengal',
'Balighai,Contai,West Bengal',
'Balisai,Contai,West Bengal',
'Ballyagobindapur,Contai,West Bengal',
'Bamanbarh,Contai,West Bengal',
'Banamalichatta,Contai,West Bengal',
'Bankibheri,Contai,West Bengal',
'Bankiput,Contai,West Bengal',
'Bansgora Bazar,Contai,West Bengal',
'Barabantalia,Contai,West Bengal',
'Barabari South,Contai,West Bengal',
'Barabatia,Contai,West Bengal',
'Barada Bazar,Contai,West Bengal',
'Baranihary,Contai,West Bengal',
'Baratala,Contai,West Bengal',
'Baraudaypur,Contai,West Bengal',
'Barhat,Contai,West Bengal',
'Barida Bazar,Contai,West Bengal',
'Barmakhal,Contai,West Bengal',
'Bartana,Contai,West Bengal',
'Basantia,Contai,West Bengal',
'Basudebberia,Contai,West Bengal',
'Basudebpur,Contai,West Bengal',
'Bathuary,Contai,West Bengal',
'Battala,Contai,West Bengal',
'Belda,Contai,West Bengal',
'Benachakri,Contai,West Bengal',
'Benichak,Contai,West Bengal',
'Bhagwanpur,Tamluk,West Bengal',
'Gopinathpur,Tamluk,West Bengal',
'Majnaberia,Tamluk,West Bengal',
'Pairachali,Tamluk,West Bengal',
'Uttarkotebarh,Tamluk,West Bengal',
'Bahadurpur,Tamluk,West Bengal',
'Barbaria,Tamluk,West Bengal',
'Madhabpur,Tamluk,West Bengal',
'Illaspur,Tamluk,West Bengal',
'Lalpur,Tamluk,West Bengal',
'Mahammadpur,Tamluk,West Bengal',
'Naba Anantapur,Tamluk,West Bengal',
'Nabatajpur,Tamluk,West Bengal',
'Paikbheri,Tamluk,West Bengal',
'Srikantapur,Tamluk,West Bengal',
'Gurgram,Tamluk,West Bengal',
'Bhajachauli,Contai,West Bengal',
'Bhatda,Contai,West Bengal',
'Bhawanichak,Contai,West Bengal',
'Ektarpur,Tamluk,West Bengal',
'Bhimeswaribazar,Contai,West Bengal',
'Bhuniajibarh,Contai,West Bengal',
'Bhupatinagar,Contai,West Bengal',
'Bibhisanpur,Contai,West Bengal',
'Bidurpur,Contai,West Bengal',
'Bishnupur,Contai,West Bengal',
'Biswanathpur,Contai,West Bengal',
'Bodhra,Contai,West Bengal',
'Boga,Contai,West Bengal',
'Bolkhusda,Contai,West Bengal',
'Brajaballavpur,Contai,West Bengal',
'Bulakipur,Contai,West Bengal',
'Chakbhabani,Contai,West Bengal',
'Chandanpur,Contai,West Bengal',
'Chandanpur,Contai,West Bengal',
'Chandanpurhat,Contai,West Bengal',
'Baroj,Tamluk,West Bengal',
'Brajalalchak,Tamluk,West Bengal',
'Brindabanpur,Tamluk,West Bengal',
'Iswarpur,Tamluk,West Bengal',
'Paschimpatna,Tamluk,West Bengal',
'Srikrishnapur,Tamluk,West Bengal',
'Chapatala,Contai,West Bengal',
'Chatla,Contai,West Bengal',
'Chauddachulli,Contai,West Bengal',
'Chaulkhola,Contai,West Bengal',
'Chhatri,Contai,West Bengal',
'Chhoto Srikrishnapur,Contai,West Bengal',
'Chingurdania,Contai,West Bengal',
'Chirulia,Contai,West Bengal',
'Chorpalia,Contai,West Bengal',
'Athilagori,Contai,West Bengal',
'Contai Bazar,Contai,West Bengal',
'Contai H.O,Contai,West Bengal',
'Contai Super Market,Contai,West Bengal',
'Dakshin Dauki,Contai,West Bengal',
'Karkuli,Contai,West Bengal',
'Monoharchak,Contai,West Bengal',
'Dakshin Kalamdan,Contai,West Bengal',
'Daisai,Contai,West Bengal',
'Dakhin Sandalpur,Contai,West Bengal',
'Dakhin Badalpur,Contai,West Bengal',
'Dadanpatrabarh,Contai,West Bengal',
'Dakshin Kalyanpur,Contai,West Bengal',
'Damodarpur,Contai,West Bengal',
'Damodarpur- Contai,Contai,West Bengal',
'Dariapur,Contai,West Bengal',
'Darua,Contai,West Bengal',
'Kultikri-ghatal,Tamluk,West Bengal',
'Daudpur,Contai,West Bengal',
'Dekhali,Contai,West Bengal',
'Depal,Contai,West Bengal',
'Deshdattabarh,Contai,West Bengal',
'Deulbarh,Contai,West Bengal',
'Deuli,Contai,West Bengal',
'Deulpota Keshabchak,Contai,West Bengal',
'Dhandalibarh,Contai,West Bengal',
'Dhangaon,Contai,West Bengal',
'Dhanghara,Contai,West Bengal',
'Dhankrabanka,Contai,West Bengal',
'Dholmari,Contai,West Bengal',
'Digha New Township,Contai,West Bengal',
'Digha,Contai,West Bengal',
'Dighadari,Contai,West Bengal',
'Dubda,Contai,West Bengal',
'Durmuth,Contai,West Bengal',
'Egra Kasba,Contai,West Bengal',
'Egra,Contai,West Bengal',
'Erenda,Contai,West Bengal',
'Fuleswar,Contai,West Bengal',
'Gangadharchak,Contai,West Bengal',
'Garia,Contai,West Bengal',
'Ghatua Purusottampur,Contai,West Bengal',
'Ghoraghata,Contai,West Bengal',
'Gobra,Contai,West Bengal',
'Gokulpur,Contai,West Bengal',
'Gopalchak,Contai,West Bengal',
'Gopichak,Contai,West Bengal',
'Haipur,Contai,West Bengal',
'Barbajitpur,Tamluk,West Bengal',
'Barbasudevpur,Tamluk,West Bengal',
'Chakdwipa,Tamluk,West Bengal',
'Dakshinchak,Tamluk,West Bengal',
'Debhog,Tamluk,West Bengal',
'Hadia,Tamluk,West Bengal',
'Iswardahajalpai,Tamluk,West Bengal',
'Kumarpur,Tamluk,West Bengal',
'Balughata,Tamluk,West Bengal',
'Barghasipur,Tamluk,West Bengal',
'Bhuniaraychak,Tamluk,West Bengal',
'Durgachak Colony,Tamluk,West Bengal',
'Durgachak,Tamluk,West Bengal',
'H.I.T,Tamluk,West Bengal',
'Haldia O.R,Tamluk,West Bengal',
'Haldia Port,Tamluk,West Bengal',
'Haldia,Tamluk,West Bengal',
'Haldia T.S,Tamluk,West Bengal',
'Hatiberia,Tamluk,West Bengal',
'Pitambarchak,Tamluk,West Bengal',
'Purbasrikrishnapur,Tamluk,West Bengal',
'Haldia Patna,Contai,West Bengal',
'Khanjanchak,Tamluk,West Bengal',
'Haludbari,Contai,West Bengal',
'Haria,Contai,West Bengal',
'Hatbaincha,Contai,West Bengal',
'Hatgopalpur,Contai,West Bengal',
'Hirapur,Contai,West Bengal',
'Ichhabari,Contai,West Bengal',
'Islampur,Contai,West Bengal',
'Itaberia,Contai,West Bengal',
'Jabda,Contai,West Bengal',
'Jahanabad,Contai,West Bengal',
'Jamua Sankarpur,Contai,West Bengal',
'Jamualachimpur,Contai,West Bengal',
'Janka,Contai,West Bengal',
'Jasteghori,Contai,West Bengal',
'Jerthan,Contai,West Bengal',
'Jhawa,Contai,West Bengal',
'Jhawgeria,Contai,West Bengal',
'Jukhia Bazar,Contai,West Bengal',
'Juki,Contai,West Bengal',
'Jumki,Contai,West Bengal',
'Junboni,Contai,West Bengal',
'Junput,Contai,West Bengal',
'Kaithore,Contai,West Bengal',
'Ashutia,Tamluk,West Bengal',
'Baraibarh,Tamluk,West Bengal',
'Barsimulbari,Tamluk,West Bengal',
'Charabarh,Tamluk,West Bengal',
'Garbari,Tamluk,West Bengal',
'Kajlagarh,Tamluk,West Bengal',
'Kismatbajkul,Tamluk,West Bengal',
'Kotebarh,Tamluk,West Bengal',
'Madhusudanchak,Tamluk,West Bengal',
'Narayandari,Tamluk,West Bengal',
'Nazirbaza5r,Tamluk,West Bengal',
'Porachingra,Tamluk,West Bengal',
'Sukrullapur,Tamluk,West Bengal',
'Tiorkhali,Tamluk,West Bengal',
'Kajli,Contai,West Bengal',
'Kalagachia,Contai,West Bengal',
'Kalindi,Contai,West Bengal',
'Kalindi Teghari,Contai,West Bengal',
'Kalsi,Contai,West Bengal',
'Kalyanpur Tentulmuri,Contai,West Bengal',
'Kamarda Bazar,Contai,West Bengal',
'Kanaidighi,Contai,West Bengal',
'Kanakpur,Contai,West Bengal',
'Kandagram,Contai,West Bengal',
'Kantai,Contai,West Bengal',
'Karaldanimakbarh,Contai,West Bengal',
'Karanji,Contai,West Bengal',
'Kartickkhali,Contai,West Bengal',
'Kasaria,Contai,West Bengal',
'Kasbagola,Contai,West Bengal',
'Katka Debichak,Contai,West Bengal',
'Katranka,Contai,West Bengal',
'Kayemgeria,Contai,West Bengal',
'Kekai,Contai,West Bengal',
'Keunchia,Contai,West Bengal',
'Keutgeria,Contai,West Bengal',
'Khagda,Contai,West Bengal',
'Khalisabhanga,Contai,West Bengal',
'Khar,Contai,West Bengal',
'Kharuigarh,Contai,West Bengal',
'Khejurda,Contai,West Bengal',
'Khejuri,Contai,West Bengal',
'Khurutia,Contai,West Bengal',
'Koria,Contai,West Bengal',
'Krishnanagar Contai,Contai,West Bengal',
'Kulanjara,Contai,West Bengal',
'Kultikri Aranga,Contai,West Bengal',
'Kumirda,Contai,West Bengal',
'Kunjapur,Contai,West Bengal',
'Lakhi,Contai,West Bengal',
'Lakshmanchak,Contai,West Bengal',
'Lalua,Contai,West Bengal',
'Madanmohanpur,Contai,West Bengal',
'Mahespur,Contai,West Bengal',
'Amritberia,Tamluk,West Bengal',
'Bamunia,Tamluk,West Bengal',
'Baruttarhingli,Tamluk,West Bengal',
'Basulia,Tamluk,West Bengal',
'Champi,Tamluk,West Bengal',
'Deulpota,Tamluk,West Bengal',
'Geondab,Tamluk,West Bengal',
'Geonkhali,Tamluk,West Bengal',
'Ghasipur,Tamluk,West Bengal',
'Gopalpur,Tamluk,West Bengal',
'Jagatpur,Tamluk,West Bengal',
'Kalikakundu,Tamluk,West Bengal',
'Kanchanpur,Tamluk,West Bengal',
'Kapasaria,Tamluk,West Bengal',
'Keshabpur,Tamluk,West Bengal',
'Keshabpurjalpai,Tamluk,West Bengal',
'Lakshya,Tamluk,West Bengal',
'Madhyahingli,Tamluk,West Bengal',
'Mahisadal,Tamluk,West Bengal',
'Mayachar,Tamluk,West Bengal',
'Mirpur,Tamluk,West Bengal',
'Natshal,Tamluk,West Bengal',
'Purbasrirampur,Tamluk,West Bengal',
'Rajaniganj,Tamluk,West Bengal',
'Rajarampur,Tamluk,West Bengal',
'Rambag,Tamluk,West Bengal',
'Rangibasan,Tamluk,West Bengal',
'Mahisagote,Contai,West Bengal',
'Maisali,Contai,West Bengal',
'Maitana,Contai,West Bengal',
'Majna,Contai,West Bengal',
'Makrampur,Contai,West Bengal',
'Mandar,Contai,West Bengal',
'Mandarpur,Contai,West Bengal',
'Manglamaro,Contai,West Bengal',
'Manikabasan,Contai,West Bengal',
'Manikjore,Contai,West Bengal',
'Marisda,Contai,West Bengal',
'Mathura,Contai,West Bengal',
'Medakhali,Contai,West Bengal',
'Ghoshkira,Midnapore,West Bengal',
'Mirgoda,Contai,West Bengal',
'Mohati,Contai,West Bengal',
'Asnan,Tamluk,West Bengal',
'Goramahal,Tamluk,West Bengal',
'Moynakalagachia,Tamluk,West Bengal',
'Purbachilka,Tamluk,West Bengal',
'Bakcha,Tamluk,West Bengal',
'Barakurmarchak,Tamluk,West Bengal',
'Bargoda,Tamluk,West Bengal',
'Changra,Tamluk,West Bengal',
'Changrachak,Tamluk,West Bengal',
'Changrakalaganda,Tamluk,West Bengal',
'Dakshin Changrachak,Tamluk,West Bengal',
'Dakshinmoyna,Tamluk,West Bengal',
'Donachak,Tamluk,West Bengal',
'Gobradan,Tamluk,West Bengal',
'Gourangachak,Tamluk,West Bengal',
'Jaigirchak,Tamluk,West Bengal',
'Kalikadari,Tamluk,West Bengal',
'Kiarana,Tamluk,West Bengal',
'Kishorechak,Tamluk,West Bengal',
'Mirikpur,Tamluk,West Bengal',
'Moyna,Tamluk,West Bengal',
'Paramanandapur,Tamluk,West Bengal',
'Paschimchilka,Tamluk,West Bengal',
'Paschimnaichanpur,Tamluk,West Bengal',
'Purbadakshinmoyna,Tamluk,West Bengal',
'Putputia,Tamluk,West Bengal',
'Raichak,Tamluk,West Bengal',
'Rajnagar Baharjola,Tamluk,West Bengal',
'Ramchakmoyna,Tamluk,West Bengal',
'Ramchandrapur,Tamluk,West Bengal',
'Srikantha,Tamluk,West Bengal',
'Srirampur Mid,Tamluk,West Bengal',
'Sudampur,Tamluk,West Bengal',
'Sulochanarambhadrapur,Tamluk,West Bengal',
'Tilkhoja,Tamluk,West Bengal',
'Mugberia,Contai,West Bengal',
'Murisai,Contai,West Bengal',
'Nachinda Bazar,Contai,West Bengal',
'Naipur,Contai,West Bengal',
'Namal,Contai,West Bengal',
'Namaldiha,Contai,West Bengal',
'Barabhuniakhali,Tamluk,West Bengal',
'Barakamarda,Tamluk,West Bengal',
'Bargodagodar,Tamluk,West Bengal',
'Byabattarhat,Tamluk,West Bengal',
'Chaknan,Tamluk,West Bengal',
'Dakhinkasimnagar,Tamluk,West Bengal',
'Dakshin Narikelda,Tamluk,West Bengal',
'Dakshindamodarpur,Tamluk,West Bengal',
'Dakshinsrikrishnapur,Tamluk,West Bengal',
'Dayaldasi,Tamluk,West Bengal',
'Dhanyaghar,Tamluk,West Bengal',
'Etamogra,Tamluk,West Bengal',
'Ganjanarayanpur,Tamluk,West Bengal',
'Jalpai,Tamluk,West Bengal',
'Kalyanchak,Tamluk,West Bengal',
'Kalyanpur,Tamluk,West Bengal',
'Khanchi,Tamluk,West Bengal',
'Kumarara,Tamluk,West Bengal',
'Kumarchak,Tamluk,West Bengal',
'Mirzanagar,Tamluk,West Bengal',
'Motilalchak,Tamluk,West Bengal',
'Nandakumar,Tamluk,West Bengal',
'Narghat L.S,Tamluk,West Bengal',
'Sitalpur,Tamluk,West Bengal',
'Uttar Sautanchak,Tamluk,West Bengal',
'Uttarsonamui,Tamluk,West Bengal',
'Amratala,Tamluk,West Bengal',
'Asadtala,Tamluk,West Bengal',
'Boyal,Tamluk,West Bengal',
'Daudpurnandi,Tamluk,West Bengal',
'Durgapur,Tamluk,West Bengal',
'Garhchakraberia,Tamluk,West Bengal',
'Gokulnagar,Tamluk,West Bengal',
'Haripur,Tamluk,West Bengal',
'Kalicharanpur,Tamluk,West Bengal',
'Kiakhali,Tamluk,West Bengal',
'Manuchak,Tamluk,West Bengal',
'Mathchandipur,Tamluk,West Bengal',
'Muradpur,Tamluk,West Bengal',
'Nandapur,Tamluk,West Bengal',
'Nandigram,Tamluk,West Bengal',
'Naynan,Tamluk,West Bengal',
'Nilpur,Tamluk,West Bengal',
'Osmanchak,Tamluk,West Bengal',
'Parulbari,Tamluk,West Bengal',
'Priyanagar,Tamluk,West Bengal',
'Purbagopalchak,Tamluk,West Bengal',
'Rajaramchak,Tamluk,West Bengal',
'Rampur,Tamluk,West Bengal',
'Samsabad,Tamluk,West Bengal',
'Sarberia,Tamluk,West Bengal',
'Saudkhali,Tamluk,West Bengal',
'Sonachura,Tamluk,West Bengal',
'Tajpur,Tamluk,West Bengal',
'Tekhalibazar,Tamluk,West Bengal',
'Terapakhia,Tamluk,West Bengal',
'Kamalpur,Tamluk,West Bengal',
'Amgachia,Tamluk,West Bengal',
'Bhekutia,Tamluk,West Bengal',
'Kendamari,Tamluk,West Bengal',
'Amdabad,Tamluk,West Bengal',
'Simulkundu,Tamluk,West Bengal',
'Ashutiabarh,Tamluk,West Bengal',
'Atattar,Tamluk,West Bengal',
'Kakra,Tamluk,West Bengal',
'Kandapasra,Tamluk,West Bengal',
'Khagdabirgram,Tamluk,West Bengal',
'Narghat,Tamluk,West Bengal',
'Sultanpurbazar,Tamluk,West Bengal',
'Narandia,Contai,West Bengal',
'Narkuli,Contai,West Bengal',
'Naskarpur,Contai,West Bengal',
'Nayaput,Contai,West Bengal',
'Negua,Contai,West Bengal',
'Nijkasba,Contai,West Bengal',
'Noonhanda,Contai,West Bengal',
'North Biswanathpur,Contai,West Bengal',
'Pailachhanpur,Contai,West Bengal',
'Paldhui,Contai,West Bengal',
'Palpara,Contai,West Bengal',
'Balidangri,Tamluk,West Bengal',
'Panchahari,Contai,West Bengal',
'Panchetgarh,Contai,West Bengal',
'Panchrol,Contai,West Bengal',
'Panchuria,Contai,West Bengal',
'Pania,Contai,West Bengal',
'Panichiary,Contai,West Bengal',
'Paniparul,Contai,West Bengal',
'Pankhai,Contai,West Bengal',
'Amalhara,Tamluk,West Bengal',
'Bakulda,Tamluk,West Bengal',
'Bara Gokul Nagar,Tamluk,West Bengal',
'Bhogpur,Tamluk,West Bengal',
'Bijoyramchak,Tamluk,West Bengal',
'Chapda,Tamluk,West Bengal',
'Dabuapukur,Tamluk,West Bengal',
'Dalpara,Tamluk,West Bengal',
'Dehati,Tamluk,West Bengal',
'Deulia,Tamluk,West Bengal',
'Dhuliapur,Tamluk,West Bengal',
'Dobandi,Tamluk,West Bengal',
'Dumdun,Tamluk,West Bengal',
'Goleghat,Tamluk,West Bengal',
'Gopalnagar Hat,Tamluk,West Bengal',
'Gopalnagar,Tamluk,West Bengal',
'Harijhama,Tamluk,West Bengal',
'Jagannathpur,Tamluk,West Bengal',
'Jasora,Tamluk,West Bengal',
'Jiakhali,Tamluk,West Bengal',
'Jotenarayan,Tamluk,West Bengal',
'Kalagechhia Bara,Tamluk,West Bengal',
'Kalukhanra,Tamluk,West Bengal',
'Keshapat,Tamluk,West Bengal',
'Kishorepur,Tamluk,West Bengal',
'Lakshyakuri,Tamluk,West Bengal',
'Maguri Jagannathchak,Tamluk,West Bengal',
'Maguri Uttarsai,Tamluk,West Bengal',
'Meghadangar,Tamluk,West Bengal',
'Naranda,Tamluk,West Bengal',
'Panskura,Tamluk,West Bengal',
'Patanda,Tamluk,West Bengal',
'Pratappur,Tamluk,West Bengal',
'Rain,Tamluk,West Bengal',
'Ratulia,Tamluk,West Bengal',
'Sajinagechhia,Tamluk,West Bengal',
'Sijgeria,Tamluk,West Bengal',
'Sundarnagar,Tamluk,West Bengal',
'Upalda,Tamluk,West Bengal',
'Kolaghat RS,Tamluk,West Bengal',
'Arisanda,Tamluk,West Bengal',
'Chakradhaban,Tamluk,West Bengal',
'Deriachak,Tamluk,West Bengal',
'Mahadole,Tamluk,West Bengal',
'Namalbarh,Tamluk,West Bengal',
'Panskura R.S,Tamluk,West Bengal',
'Shyamsundarpatna,Tamluk,West Bengal',
'Siddha,Tamluk,West Bengal',
'Sitalaparamanandapur,Tamluk,West Bengal',
'Uttarjianda,Tamluk,West Bengal',
'Uttarmechogram,Tamluk,West Bengal',
'Arror,Tamluk,West Bengal',
'Baharpota,Tamluk,West Bengal',
'Baishnabchak,Tamluk,West Bengal',
'Kharui,Tamluk,West Bengal',
'Kolaghat Natun Bazar,Tamluk,West Bengal',
'Kolaghat,Tamluk,West Bengal',
'Narayanchak,Tamluk,West Bengal',
'Paikpari,Tamluk,West Bengal',
'Payag,Tamluk,West Bengal',
'Pulsita,Tamluk,West Bengal',
'Purba Itara,Tamluk,West Bengal',
'Raghunathbari,Tamluk,West Bengal',
'Sagarbarh,Tamluk,West Bengal',
'Saluka,Tamluk,West Bengal',
'Sitapur,Tamluk,West Bengal',
'Sulani,Tamluk,West Bengal',
'Paschim Bamunia,Contai,West Bengal',
'Paschim Manikpur,Contai,West Bengal',
'Patashpur,Contai,West Bengal',
'Paushi,Contai,West Bengal',
'Paya-medinipur,Contai,West Bengal',
'Pichabani,Contai,West Bengal',
'Pirijkhanbarh,Contai,West Bengal',
'Pratapdighi,Contai,West Bengal',
'Purba Madhabpur,Contai,West Bengal',
'Purbaradhapur,Contai,West Bengal',
'Raipur Paschimbarh,Contai,West Bengal',
'Ramchak,Contai,West Bengal',
'Ramnagar,Contai,West Bengal',
'Ranisai,Contai,West Bengal',
'Rasan,Contai,West Bengal',
'Akandabari,Tamluk,West Bengal',
'Baraghuni,Tamluk,West Bengal',
'Bheturia,Tamluk,West Bengal',
'Birulia,Tamluk,West Bengal',
'Debipur,Tamluk,West Bengal',
'Garh Krishna Nagar,Tamluk,West Bengal',
'Gholpukuria,Tamluk,West Bengal',
'Hanschara,Tamluk,West Bengal',
'Hanubhunia,Tamluk,West Bengal',
'Khodambari,Tamluk,West Bengal',
'Kulbari,Tamluk,West Bengal',
'Monoharpur,Tamluk,West Bengal',
'Reapara,Tamluk,West Bengal',
'Runkinipur,Tamluk,West Bengal',
'Shibrampur,Tamluk,West Bengal',
'Sabajput,Contai,West Bengal',
'Sadihat,Contai,West Bengal',
'Sadikpur,Contai,West Bengal',
'Safiabad,Contai,West Bengal',
'Sagareswar,Contai,West Bengal',
'Sahara,Contai,West Bengal',
'Alinan,Tamluk,West Bengal',
'Ballukhat,Tamluk,West Bengal',
'Barnan,Tamluk,West Bengal',
'Burarihat,Tamluk,West Bengal',
'Demarihat,Tamluk,West Bengal',
'Hogla,Tamluk,West Bengal',
'Jamitya,Tamluk,West Bengal',
'Ktpp,Tamluk,West Bengal',
'Ktpp T.S,Tamluk,West Bengal',
'Nonakuribazar,Tamluk,West Bengal',
'Ramtarak Hat,Tamluk,West Bengal',
'Sankarara,Tamluk,West Bengal',
'Dhalhara,Tamluk,West Bengal',
'Gobindapur,Tamluk,West Bengal',
'Jawfullybibichak,Tamluk,West Bengal',
'Joybalarampur,Tamluk,West Bengal',
'Mechada,Tamluk,West Bengal',
'Sarada,Contai,West Bengal',
'Saridaspur,Contai,West Bengal',
'Saripur,Contai,West Bengal',
'Sarpai,Contai,West Bengal',
'Satbahini,Contai,West Bengal',
'Satilapur,Contai,West Bengal',
'Satkhanda Sahebnagar,Contai,West Bengal',
'Satmile,Contai,West Bengal',
'Saulabheri,Contai,West Bengal',
'Selmabad,Contai,West Bengal',
'Serkhanchak,Contai,West Bengal',
'Shipur,Contai,West Bengal',
'Shyampur,Contai,West Bengal',
'Sillyaberia,Contai,West Bengal',
'Sisusadan,Contai,West Bengal',
'Srirampur,Contai,West Bengal',
'Srirampur- Contai,Contai,West Bengal',
'Subdi,Contai,West Bengal',
'Sukhakhola,Contai,West Bengal',
'Susunia,Contai,West Bengal',
'Agadoro,Tamluk,West Bengal',
'Anantapur,Tamluk,West Bengal',
'Barabari,Tamluk,West Bengal',
'Baroda,Tamluk,West Bengal',
'Basanchak,Tamluk,West Bengal',
'Basudevpur,Tamluk,West Bengal',
'Chaitannyapur,Tamluk,West Bengal',
'Dhekua,Tamluk,West Bengal',
'Dorojoynagar,Tamluk,West Bengal',
'Dorokashipur,Tamluk,West Bengal',
'Dorokrishnanagar,Tamluk,West Bengal',
'Dwariberia,Tamluk,West Bengal',
'Gobindapurbajitpur,Tamluk,West Bengal',
'Golapchak,Tamluk,West Bengal',
'Kukrahati,Tamluk,West Bengal',
'Raghurampur,Tamluk,West Bengal',
'Shibramnagar,Tamluk,West Bengal',
'Sutahata,Tamluk,West Bengal',
'Tabakhali,Tamluk,West Bengal',
'Tajnagar,Tamluk,West Bengal',
'Tagaria,Contai,West Bengal',
'Taghari,Contai,West Bengal',
'Takapura,Contai,West Bengal',
'Bahichard,Tamluk,West Bengal',
'Chakjiandighi,Tamluk,West Bengal',
'Chanserpur,Tamluk,West Bengal',
'Kulberia,Tamluk,West Bengal',
'Padumbasan,Tamluk,West Bengal',
'Parbatipur,Tamluk,West Bengal',
'Simulia,Tamluk,West Bengal',
'Tamluk H.O,Tamluk,West Bengal',
'Teghorijoteviram,Tamluk,West Bengal',
'Abasbari,Tamluk,West Bengal',
'Bainchberia,Tamluk,West Bengal',
'Bargabhima,Tamluk,West Bengal',
'Harasankar,Tamluk,West Bengal',
'Haridaspur,Tamluk,West Bengal',
'Hijalberia,Tamluk,West Bengal',
'Kakgechia,Tamluk,West Bengal',
'Kelomal,Tamluk,West Bengal',
'Kurpai,Tamluk,West Bengal',
'Naikuri,Tamluk,West Bengal',
'Nakibasan,Tamluk,West Bengal',
'Radhaballavpur,Tamluk,West Bengal',
'Salgechhia,Tamluk,West Bengal',
'Salikagarchak,Tamluk,West Bengal',
'Telami,Contai,West Bengal',
'Tengunia,Contai,West Bengal',
'Thakurnagar,Contai,West Bengal',
'Tikashi,Contai,West Bengal',
'Totanala,Contai,West Bengal',
'Udbadal,Contai,West Bengal',
'Urdhabpur,Contai,West Bengal',
'Ururi,Contai,West Bengal',
'Uttar Amtalia,Contai,West Bengal',
'Uttar Asda,Contai,West Bengal',
'Uttar Badalpur,Contai,West Bengal',
'Uttar Gobindapur,Contai,West Bengal',
'Uttar Kalamdan,Contai,West Bengal',
'Uttar Kanpur,Contai,West Bengal',
'Uttarharaschak,Contai,West Bengal',
'Uttar-tajpur,Contai,West Bengal',
'Ballaldighi,Hooghly North,West Bengal',
'Chenchua,Hooghly North,West Bengal',
'Dharampur,Hooghly North,West Bengal',
'Jangalapara,Hooghly South,West Bengal',
'Jolekul,Hooghly North,West Bengal',
'Kamdebpur,Hooghly North,West Bengal',
'Kanakshally,Hooghly North,West Bengal',
'Katsara,Hooghly North,West Bengal',
'Mohisgoria,Hooghly North,West Bengal',
'Singherbheri,Hooghly South,West Bengal',
'Sogandha,Hooghly North,West Bengal',
'Addconagar,Hooghly North,West Bengal',
'Arambagh Court,Hooghly North,West Bengal',
'Arambagh H.O,Hooghly North,West Bengal',
'Arandi,Hooghly North,West Bengal',
'Bachhanari,Hooghly North,West Bengal',
'Baira-kanpur,Hooghly North,West Bengal',
'Balipur,Hooghly South,West Bengal',
'Balundi,Hooghly North,West Bengal',
'Baradangal,Hooghly North,West Bengal',
'Batanal,Hooghly North,West Bengal',
'Bhalia,Hooghly North,West Bengal',
'Bhangamora,Hooghly South,West Bengal',
'Chandraban,Hooghly North,West Bengal',
'Chiladangi,Hooghly South,West Bengal',
'Chuadanga,Hooghly North,West Bengal',
'Daharkunda,Hooghly North,West Bengal',
'Dakshin Rasulpur,Hooghly North,West Bengal',
'Dihi Bagnan,Hooghly North,West Bengal',
'Dihiboira,Hooghly North,West Bengal',
'Gholdigrui,Hooghly South,West Bengal',
'Ghole,Hooghly South,West Bengal',
'Golta,Hooghly North,West Bengal',
'Gourhati,Hooghly North,West Bengal',
'Gujrat,Hooghly North,West Bengal',
'Harinkhola,Hooghly North,West Bengal',
'Hatbasantapur,Hooghly North,West Bengal',
'Hiatpur,Hooghly North,West Bengal',
'Jasar,Hooghly North,West Bengal',
'Karui,Hooghly North,West Bengal',
'Keshabpur,Hooghly North,West Bengal',
'Kishorepur,Hooghly North,West Bengal',
'Krishnapur,Hooghly North,West Bengal',
'Madhabpur,Hooghly North,West Bengal',
'Madhurpur,Hooghly North,West Bengal',
'Mahisgot,Hooghly North,West Bengal',
'Maigram,Hooghly North,West Bengal',
'Manikpat,Hooghly North,West Bengal',
'Mayalbandipur,Hooghly North,West Bengal',
'Mayapur,Hooghly North,West Bengal',
'Moloypur,Hooghly North,West Bengal',
'Mriga Chatra,Hooghly North,West Bengal',
'Narayanpur,Hooghly North,West Bengal',
'Natunbazar,Hooghly North,West Bengal',
'Netaji Mahavidyalaya,Hooghly North,West Bengal',
'Parabagnan,Hooghly North,West Bengal',
'Pilkhan,Hooghly North,West Bengal',
'Pratapnagar,Hooghly North,West Bengal',
'Purba Krishnapur,Hooghly North,West Bengal',
'Pursurah,Hooghly South,West Bengal',
'Ragpur,Hooghly North,West Bengal',
'Rasulpur,Hooghly South,West Bengal',
'Santoshpur,Hooghly North,West Bengal',
'Thakuranichak,Hooghly North,West Bengal',
'Balagarh,Hooghly North,West Bengal',
'Basna,Hooghly North,West Bengal',
'Jirat,Hooghly North,West Bengal',
'Khamargachi,Hooghly North,West Bengal',
'Milangarh,Hooghly North,West Bengal',
'Panchpara,Hooghly North,West Bengal',
'Patuligram,Hooghly North,West Bengal',
'Sripur Bazar,Hooghly North,West Bengal',
'Bandel Junction,Hooghly North,West Bengal',
'Debanandapur,Hooghly North,West Bengal',
'Ektarpur,Hooghly North,West Bengal',
'Inchura Bazar,Hooghly North,West Bengal',
'Manaspur,Hooghly North,West Bengal',
'Naldanga,Hooghly North,West Bengal',
'Rajhat,Hooghly North,West Bengal',
'Somra,Hooghly North,West Bengal',
'Bansberia Bazar,Hooghly North,West Bengal',
'Bansberia,Hooghly North,West Bengal',
'Chawk Bansberia.,Hooghly North,West Bengal',
'Belmuri,Hooghly North,West Bengal',
'Alipur Nayanagar,Hooghly North,West Bengal',
'Bhandarhati,Hooghly North,West Bengal',
'Bagnan Chaitanyabati,Hooghly North,West Bengal',
'Dakshin Basudebpur,Hooghly North,West Bengal',
'Kanui Banka,Hooghly North,West Bengal',
'Mandra,Hooghly North,West Bengal',
'New Chandpur,Hooghly North,West Bengal',
'Balindar,Hooghly North,West Bengal',
'Barul,Hooghly North,West Bengal',
'Berela,Hooghly North,West Bengal',
'Bhonpur,Hooghly North,West Bengal',
'Bilsara,Hooghly North,West Bengal',
'Boinchi,Hooghly North,West Bengal',
'Hanraldaspur,Hooghly North,West Bengal',
'Hatni,Hooghly North,West Bengal',
'Insura,Hooghly North,West Bengal',
'Raijamna,Hooghly North,West Bengal',
'Talbona,Hooghly North,West Bengal',
'Boinchigram,Hooghly North,West Bengal',
'Baidyapur Shibtala,Hooghly South,West Bengal',
'Gotan,Hooghly South,West Bengal',
'Bighati,Hooghly South,West Bengal',
'K G R S Path,Hooghly South,West Bengal',
'Kristarampur,Hooghly South,West Bengal',
'Kundughat,Hooghly South,West Bengal',
'Mankundu,Hooghly South,West Bengal',
'Palpara,Hooghly South,West Bengal',
'Aimapaharpur,Hooghly South,West Bengal',
'Amarpur,Hooghly South,West Bengal',
'Anandanagar,Hooghly South,West Bengal',
'Angus,Hooghly South,West Bengal',
'Ankri-serampore,Hooghly South,West Bengal',
'Antisara,Hooghly South,West Bengal',
'Astara,Hooghly South,West Bengal',
'Bahirkhand,Hooghly South,West Bengal',
'Bajemalia,Hooghly South,West Bengal',
'Bajitpur,Hooghly South,West Bengal',
'Balarambati,Hooghly South,West Bengal',
'Baligori,Hooghly South,West Bengal',
'Bandipur,Hooghly South,West Bengal',
'Basubati,Hooghly South,West Bengal',
'Basuri,Hooghly South,West Bengal',
'Beraberi,Hooghly South,West Bengal',
'Bhadreswar,Hooghly South,West Bengal',
'Bhata,Hooghly South,West Bengal',
'Binagram,Hooghly South,West Bengal',
'Bishnupur,Hooghly South,West Bengal',
'Bora,Hooghly South,West Bengal',
'Borai,Hooghly South,West Bengal',
'Boraichanditala,Hooghly South,West Bengal',
'Brahmanpara,Hooghly South,West Bengal',
'Champadanga,Hooghly South,West Bengal',
'Champdani,Hooghly South,West Bengal',
'Chandannagar Barasat,Hooghly South,West Bengal',
'Chandannagar R.S,Hooghly South,West Bengal',
'Chandannagar,Hooghly South,West Bengal',
'Chandanpur,Hooghly South,West Bengal',
'Chaulpatty,Hooghly South,West Bengal',
'Chinamore,Hooghly South,West Bengal',
'Chitrasali,Hooghly South,West Bengal',
'Dalapatipur,Hooghly South,West Bengal',
'Dearah,Hooghly South,West Bengal',
'Dewanbheri,Hooghly South,West Bengal',
'Dihiratanpur,Hooghly South,West Bengal',
'Duttapur,Hooghly South,West Bengal',
'Dwarhatta,Hooghly South,West Bengal',
'Ganderpukur,Hooghly South,West Bengal',
'Gondalpara,Hooghly South,West Bengal',
'Gopalnagar Harharia,Hooghly South,West Bengal',
'Haripal,Hooghly South,West Bengal',
'Haripur Chak,Hooghly South,West Bengal',
'Harishnagar,Hooghly South,West Bengal',
'Hawakhana,Hooghly South,West Bengal',
'Jagalgori,Hooghly South,West Bengal',
'Jagatnagar,Hooghly South,West Bengal',
'Jalaghata,Hooghly South,West Bengal',
'Jamdara,Hooghly South,West Bengal',
'Jarura,Hooghly South,West Bengal',
'Jejur,Hooghly South,West Bengal',
'Kaikala,Hooghly South,West Bengal',
'Kalachara,Hooghly South,West Bengal',
'Kamarkundu,Hooghly South,West Bengal',
'Karicharbheri,Hooghly South,West Bengal',
'Kashipur,Hooghly South,West Bengal',
'Keshabchak,Hooghly South,West Bengal',
'Ketera,Hooghly South,West Bengal',
'Khalisani,Hooghly South,West Bengal',
'Khamarchandi,Hooghly South,West Bengal',
'Kinkarbati,Hooghly South,West Bengal',
'Kumrul,Hooghly South,West Bengal',
'Madpur,Hooghly South,West Bengal',
'Malia,Hooghly South,West Bengal',
'Mankundu Govt.Colony,Hooghly South,West Bengal',
'Mirjapur Bankipur,Hooghly South,West Bengal',
'Mohistikri,Hooghly South,West Bengal',
'Moktarpur,Hooghly South,West Bengal',
'Mollasimla,Hooghly South,West Bengal',
'Mora,Hooghly South,West Bengal',
'Muidipur,Hooghly South,West Bengal',
'Musapur,Hooghly South,West Bengal',
'Nalikul,Hooghly South,West Bengal',
'Nanda,Hooghly South,West Bengal',
'Nasibpur,Hooghly South,West Bengal',
'Noapara,Hooghly South,West Bengal',
'Pahalampur,Hooghly South,West Bengal',
'Paltagarh,Hooghly South,West Bengal',
'Paniseola,Hooghly South,West Bengal',
'Pargopalnagar,Hooghly South,West Bengal',
'Parshyampur,Hooghly South,West Bengal',
'Paschimgopinathpur,Hooghly South,West Bengal',
'Rajabazar,Hooghly South,West Bengal',
'Rajbalhat,Hooghly South,West Bengal',
'Ramnagar,Hooghly South,West Bengal',
'Ramnarayanpur,Hooghly South,West Bengal',
'Sainta,Hooghly South,West Bengal',
'Samserpur,Hooghly South,West Bengal',
'Saradapally,Hooghly South,West Bengal',
'Shyampur,Hooghly South,West Bengal',
'Singur,Hooghly South,West Bengal',
'Soaluk,Hooghly South,West Bengal',
'Talpur,Hooghly South,West Bengal',
'Tarakeswar Math,Hooghly South,West Bengal',
'Tarakeswar,Hooghly South,West Bengal',
'Teghari,Hooghly South,West Bengal',
'Telinipara,Hooghly South,West Bengal',
'Chandrahati,Hooghly North,West Bengal',
'Chinsurah Bazar,Hooghly North,West Bengal',
'Chinsurah Court,Hooghly North,West Bengal',
'Chinsurah H.O,Hooghly North,West Bengal',
'Chinsurah RS,Hooghly North,West Bengal',
'Kamarparabazar,Hooghly North,West Bengal',
'Kapasdanga Roybazarcolony,Hooghly North,West Bengal',
'Keotalatbagan,Hooghly North,West Bengal',
'Pipulpati,Hooghly North,West Bengal',
'Pratappur,Hooghly North,West Bengal',
'Rabindranagar,Hooghly North,West Bengal',
'Sahaganj,Hooghly North,West Bengal',
'Sandeswartala J.C.,Hooghly North,West Bengal',
'Tamlipara,Hooghly North,West Bengal',
'Dasghara,Hooghly North,West Bengal',
'Gopinagar,Hooghly North,West Bengal',
'Nimdanga,Hooghly North,West Bengal',
'Routhpur,Hooghly North,West Bengal',
'Sahabazar,Hooghly North,West Bengal',
'Boso,Hooghly North,West Bengal',
'Dedhara,Hooghly North,West Bengal',
'Dhaniakhali,Hooghly North,West Bengal',
'Hazipur,Hooghly North,West Bengal',
'Kananadi,Hooghly North,West Bengal',
'Kankrakuli,Hooghly North,West Bengal',
'Lokabati,Hooghly North,West Bengal',
'Mazinan,Hooghly North,West Bengal',
'Rudrani,Hooghly North,West Bengal',
'Anur,Bankura,West Bengal',
'Mandaran,Hooghly North,West Bengal',
'Paschimpara,Hooghly North,West Bengal',
'Aslahari,Hooghly North,West Bengal',
'Bajua,Hooghly North,West Bengal',
'Balidewanganj,Hooghly North,West Bengal',
'Bhadur,Hooghly North,West Bengal',
'Chandur,Hooghly North,West Bengal',
'Dahia Kanda,Hooghly North,West Bengal',
'Damodarpur,Hooghly North,West Bengal',
'Dhulepur,Hooghly North,West Bengal',
'Gobindapur,Hooghly North,West Bengal',
'Kumursha,Hooghly North,West Bengal',
'Laluka,Hooghly North,West Bengal',
'Muktarpur Belekusma,Hooghly North,West Bengal',
'Naisarai,Hooghly North,West Bengal',
'Nakunda,Hooghly North,West Bengal',
'Paba,Hooghly North,West Bengal',
'Radhaballavpur,Hooghly North,West Bengal',
'Raghubati,Hooghly North,West Bengal',
'Ramnagar Mobarakpur,Hooghly North,West Bengal',
'Ratanpur,Hooghly North,West Bengal',
'Salepur,Hooghly North,West Bengal',
'Saora,Hooghly North,West Bengal',
'Singrapur,Hooghly North,West Bengal',
'Sunia,Hooghly North,West Bengal',
'Tirol,Hooghly North,West Bengal',
'Asudkhola,Hooghly North,West Bengal',
'Badanganj,Hooghly North,West Bengal',
'Bengai.,Hooghly North,West Bengal',
'Bhurkunda,Hooghly North,West Bengal',
'Debkhanda,Hooghly North,West Bengal',
'Fului,Hooghly North,West Bengal',
'Goghat.,Hooghly North,West Bengal',
'Jharia,Hooghly North,West Bengal',
'Kadra,Hooghly North,West Bengal',
'Kamarpukur,Hooghly North,West Bengal',
'Kantali,Hooghly North,West Bengal',
'Khatul,Hooghly North,West Bengal',
'Pandugram,Hooghly North,West Bengal',
'Salikona,Hooghly North,West Bengal',
'Santipur,Hooghly North,West Bengal',
'Satberia,Hooghly North,West Bengal',
'Selampur,Hooghly North,West Bengal',
'Senai,Hooghly North,West Bengal',
'Shyambazar,Hooghly North,West Bengal',
'Sripur,Hooghly North,West Bengal',
'Tarahat,Hooghly North,West Bengal',
'Tilari,Hooghly North,West Bengal',
'Aidakismat,Hooghly North,West Bengal',
'Bakuliagram,Hooghly North,West Bengal',
'Dhobapara,Hooghly North,West Bengal',
'Digra,Hooghly North,West Bengal',
'Guptipara,Hooghly North,West Bengal',
'Krishanbatichar,Hooghly North,West Bengal',
'Purba Satgachia,Hooghly North,West Bengal',
'Balidaha,Hooghly North,West Bengal',
'Bhastara,Hooghly North,West Bengal',
'Cheragram,Hooghly North,West Bengal',
'Ghosla,Hooghly North,West Bengal',
'Gurap,Hooghly North,West Bengal',
'Khanpur,Hooghly North,West Bengal',
'Palasi,Hooghly North,West Bengal',
'Sankarpur,Hooghly North,West Bengal',
'Bikramnagar Bali,Hooghly North,West Bengal',
'Hooghly,Hooghly North,West Bengal',
'Jamgram,Hooghly North,West Bengal',
'Arjuna,Hooghly North,West Bengal',
'Gram Kulti,Hooghly North,West Bengal',
'Gramchagram,Hooghly North,West Bengal',
'Brindabanpur,Hooghly North,West Bengal',
'Gajinadaspur,Hooghly North,West Bengal',
'Mohipalpur,Hooghly North,West Bengal',
'Pindira,Hooghly North,West Bengal',
'Baharkuli,Hooghly North,West Bengal',
'Chatosarsa,Hooghly North,West Bengal',
'Haridaspur,Hooghly North,West Bengal',
'Hoera,Hooghly North,West Bengal',
'Radhanagar,Hooghly North,West Bengal',
'Baneswarpur,Hooghly North,West Bengal',
'Dumurdaha,Hooghly North,West Bengal',
'Sonatikri,Hooghly North,West Bengal',
'Udaypur,Hooghly North,West Bengal',
'Balaichak,Hooghly North,West Bengal',
'Balpai,Hooghly North,West Bengal',
'Bonhijli,Hooghly North,West Bengal',
'Chakhayatpur,Hooghly North,West Bengal',
'Chingra,Hooghly North,West Bengal',
'Dharasimul,Hooghly North,West Bengal',
'Harishchak,Hooghly North,West Bengal',
'Jagatpur,Hooghly North,West Bengal',
'Mar0khana,Hooghly North,West Bengal',
'Mostafapur,Hooghly North,West Bengal',
'Nandanpur,Hooghly North,West Bengal',
'Natibpur,Hooghly North,West Bengal',
'Pole,Hooghly North,West Bengal',
'Rajhati Bandar,Hooghly North,West Bengal',
'Ranjitbati,Hooghly North,West Bengal',
'Routh Khana,Hooghly North,West Bengal',
'Helan,Hooghly North,West Bengal',
'Khanakul,Hooghly North,West Bengal',
'Kaiba,Hooghly North,West Bengal',
'Kedarpur,Hooghly North,West Bengal',
'Nangulpara,Hooghly North,West Bengal',
'Tantisal,Hooghly North,West Bengal',
'Palaspai,Hooghly North,West Bengal',
'Sabalsingpur,Hooghly North,West Bengal',
'Hirapur,Hooghly North,West Bengal',
'Mainan,Hooghly North,West Bengal',
'Patul,Hooghly North,West Bengal',
'Beniajole,Hooghly North,West Bengal',
'Chunait,Hooghly North,West Bengal',
'Duadanda,Hooghly North,West Bengal',
'Ghoshpur,Hooghly North,West Bengal',
'Kupsit,Hooghly North,West Bengal',
'Chopa,Hooghly North,West Bengal',
'Gurbari,Hooghly North,West Bengal',
'Kharua,Hooghly North,West Bengal',
'Siptai,Hooghly North,West Bengal',
'Akna,Hooghly North,West Bengal',
'Barunanpara,Hooghly North,West Bengal',
'Digsui,Hooghly North,West Bengal',
'Itachuna,Hooghly North,West Bengal',
'Magra,Hooghly North,West Bengal',
'Nayasarai,Hooghly North,West Bengal',
'Pakri,Hooghly North,West Bengal',
'Patna,Hooghly North,West Bengal',
'Ramnathpur,Hooghly North,West Bengal',
'Shibpur Bansberia,Hooghly North,West Bengal',
'Sultangacha,Hooghly North,West Bengal',
'Talandu,Hooghly North,West Bengal',
'Tribeni,Hooghly North,West Bengal',
'Gopalpur,Hooghly North,West Bengal',
'Amra,Hooghly North,West Bengal',
'Aymanawabpur,Hooghly North,West Bengal',
'Beloon,Hooghly North,West Bengal',
'Bhitasin,Hooghly North,West Bengal',
'Chandpur,Hooghly North,West Bengal',
'Dabra,Hooghly North,West Bengal',
'Dwarbasini,Hooghly North,West Bengal',
'Hanral,Hooghly North,West Bengal',
'Ilsobamondalai,Hooghly North,West Bengal',
'Jayer,Hooghly North,West Bengal',
'Khajurdaha,Hooghly North,West Bengal',
'Khanyan,Hooghly North,West Bengal',
'Magura,Hooghly North,West Bengal',
'Megshar,Hooghly North,West Bengal',
'Melki,Hooghly North,West Bengal',
'Mohanad,Hooghly North,West Bengal',
'Panchgora,Hooghly North,West Bengal',
'Pandua,Hooghly North,West Bengal',
'Rameswarpur,Hooghly North,West Bengal',
'Ranagarh,Hooghly North,West Bengal',
'Rosna,Hooghly North,West Bengal',
'Sarai,Hooghly North,West Bengal',
'Satithan,Hooghly North,West Bengal',
'Simlagarh,Hooghly North,West Bengal',
'Tinna,Hooghly North,West Bengal',
'Polba,Hooghly North,West Bengal',
'Alipur,Hooghly North,West Bengal',
'Ati,Hooghly North,West Bengal',
'Babnan,Hooghly North,West Bengal',
'Danrpur,Hooghly North,West Bengal',
'Gobarara,Hooghly North,West Bengal',
'Goswamimalipara,Hooghly North,West Bengal',
'Harit,Hooghly North,West Bengal',
'Makalpur,Hooghly North,West Bengal',
'Nagbal,Hooghly North,West Bengal',
'Pawnan,Hooghly North,West Bengal',
'Porabazar,Hooghly North,West Bengal',
'Puinan,Hooghly North,West Bengal',
'Sinhet,Hooghly North,West Bengal',
'Alati,Hooghly North,West Bengal',
'Baikunthapur,Hooghly North,West Bengal',
'Baradigrui,Hooghly North,West Bengal',
'Bhuerah,Hooghly North,West Bengal',
'Ghargohal,Hooghly North,West Bengal',
'Hati,Hooghly North,West Bengal',
'Kulbatpur,Hooghly North,West Bengal',
'Nachipur,Hooghly North,West Bengal',
'Nimdangi,Hooghly North,West Bengal',
'Saidpur,Hooghly North,West Bengal',
'Deulpara.,Hooghly North,West Bengal',
'Daminya Kabikankan,Hooghly North,West Bengal',
'Akuni,Hooghly South,West Bengal',
'Aniya,Hooghly South,West Bengal',
'Antpur,Hooghly South,West Bengal',
'Baganda,Hooghly South,West Bengal',
'Bahirserampore,Hooghly South,West Bengal',
'Baidyabati,Hooghly South,West Bengal',
'Baksha,Hooghly South,West Bengal',
'Bamunari,Hooghly South,West Bengal',
'Bandhpur,Hooghly South,West Bengal',
'Bangurpark,Hooghly South,West Bengal',
'Barabahera,Hooghly South,West Bengal',
'Baratajpur,Hooghly South,West Bengal',
'Baruipara,Hooghly South,West Bengal',
'Begampur,Hooghly South,West Bengal',
'Belumilki,Hooghly South,West Bengal',
'Bhadrakali,Hooghly South,West Bengal',
'Bhagabatipur,Hooghly South,West Bengal',
'Chakundi,Hooghly South,West Bengal',
'Chanditala,Hooghly South,West Bengal',
'Charpur,Hooghly South,West Bengal',
'Chatra,Hooghly South,West Bengal',
'Chikranda,Hooghly South,West Bengal',
'Criper Road,Hooghly South,West Bengal',
'Dakshindihi,Hooghly South,West Bengal',
'Dankuni Coal Complex,Hooghly South,West Bengal',
'Dankuni,Hooghly South,West Bengal',
'Dilakash,Hooghly South,West Bengal',
'Dingalhati,Hooghly South,West Bengal',
'Furfura,Hooghly South,West Bengal',
'Gandhisarak,Hooghly South,West Bengal',
'Gangadharpur Bazar,Hooghly South,West Bengal',
'Garalgacha,Hooghly South,West Bengal',
'Guti,Hooghly South,West Bengal',
'Haripur,Hooghly South,West Bengal',
'Hindmotor,Hooghly South,West Bengal',
'Illahipur,Hooghly South,West Bengal',
'Janai,Hooghly South,West Bengal',
'Jangalpara Bazar,Hooghly South,West Bengal',
'Jangipara,Hooghly South,West Bengal',
'Kalachara,Hooghly South,West Bengal',
'Kalbazar,Hooghly South,West Bengal',
'Kanaipur,Hooghly South,West Bengal',
'Kharsarai,Hooghly South,West Bengal',
'Konnagar,Hooghly South,West Bengal',
'Krishanagar,Hooghly South,West Bengal',
'Kulakash,Hooghly South,West Bengal',
'Kumarpara,Hooghly South,West Bengal',
'Kumirmorah,Hooghly South,West Bengal',
'Lakshmandur,Hooghly South,West Bengal',
'Mahesh -1,Hooghly South,West Bengal',
'Mahesh 2,Hooghly South,West Bengal',
'Makhla,Hooghly South,West Bengal',
'Mallickpara,Hooghly South,West Bengal',
'Manicktala Bazar,Hooghly South,West Bengal',
'Maniktala Bazar,Hooghly South,West Bengal',
'Masat,Hooghly South,West Bengal',
'Masjidlane,Hooghly South,West Bengal',
'Mollerberh,Hooghly South,West Bengal',
'Monirampur,Hooghly South,West Bengal',
'Morepukur,Hooghly South,West Bengal',
'Mrigala,Hooghly South,West Bengal',
'Mundalika,Hooghly South,West Bengal',
'Nabagram,Hooghly South,West Bengal',
'Naity,Hooghly South,West Bengal',
'Nawabpur,Hooghly South,West Bengal',
'Nutangram,Hooghly South,West Bengal',
'Panchgharabazar,Hooghly South,West Bengal',
'Paschimtajpur,Hooghly South,West Bengal',
'Poshpur,Hooghly South,West Bengal',
'Prabasnagar,Hooghly South,West Bengal',
'Prasadpur,Hooghly South,West Bengal',
'Raghunathpur,Hooghly South,West Bengal',
'Rahimpur,Hooghly South,West Bengal',
'Rajendra Avenue,Hooghly South,West Bengal',
'Rashidpur,Hooghly South,West Bengal',
'Rishra,Hooghly South,West Bengal',
'Satghara,Hooghly South,West Bengal',
'Seakhala,Hooghly South,West Bengal',
'Serampore Court,Hooghly South,West Bengal',
'Serampore H.O,Hooghly South,West Bengal',
'Sheoraphuli,Hooghly South,West Bengal',
'Simla,Hooghly South,West Bengal',
'Uttarpara Bazar,Hooghly South,West Bengal',
'Uttarpara,Hooghly South,West Bengal',
'Btps,Hooghly North,West Bengal',
'Buroshibtala,Hooghly North,West Bengal',
'A.Guha Road,Howrah,West Bengal',
'A.Road(Bamungachi),Howrah,West Bengal',
'Abhoynagar,Howrah,West Bengal',
'Agunshi,Howrah,West Bengal',
'Ajodhyaghat,Howrah,West Bengal',
'Alipur,Howrah,West Bengal',
'Amaragori,Howrah,West Bengal',
'Amardah,Howrah,West Bengal',
'Amta,Howrah,West Bengal',
'Anandanagar,Howrah,West Bengal',
'Anantapur,Howrah,West Bengal',
'Andul -mouri,Howrah,West Bengal',
'Andul Road,Howrah,West Bengal',
'Antila,Howrah,West Bengal',
'Anulia,Howrah,West Bengal',
'Argori,Howrah,West Bengal',
'B.Garden,Howrah,West Bengal',
'Bachhri,Howrah,West Bengal',
'Baganda,Howrah,West Bengal',
'Bagnan,Howrah,West Bengal',
'Bagua,Howrah,West Bengal',
'Bahira,Howrah,West Bengal',
'Baidyanathpur,Howrah,West Bengal',
'Bainan,Howrah,West Bengal',
'Bairakurchi,Howrah,West Bengal',
'Baisnabpara Bazar,Howrah,West Bengal',
'Baksara,Howrah,West Bengal',
'Bakshi,Howrah,West Bengal',
'Bakultala,Howrah,West Bengal',
'Balichaturi,Howrah,West Bengal',
'Balitikuri,Howrah,West Bengal',
'Bally Goswami Rd,Howrah,West Bengal',
'Bally,Howrah,West Bengal',
'Baluhati,Howrah,West Bengal',
'Bamangachi,Howrah,West Bengal',
'Bandhaghat,Howrah,West Bengal',
'Bangalpur,Howrah,West Bengal',
'Banharishpur,Howrah,West Bengal',
'Baniban,Howrah,West Bengal',
'Banipur,Howrah,West Bengal',
'Banitala,Howrah,West Bengal',
'Bankra,Howrah,West Bengal',
'Bankura Bo(Howrah),Howrah,West Bengal',
'Bantul,Howrah,West Bengal',
'Baramahera,Howrah,West Bengal',
'Barda,Howrah,West Bengal',
'Bargachia,Howrah,West Bengal',
'Bargarchumuk,Howrah,West Bengal',
'Bargram,Howrah,West Bengal',
'Barunda,Howrah,West Bengal',
'Basudebpur,Howrah,West Bengal',
'Batai,Howrah,West Bengal',
'Batiatala,Howrah,West Bengal',
'Bauria,Howrah,West Bengal',
'Begri,Howrah,West Bengal',
'Belari,Howrah,West Bengal',
'Beldubi,Howrah,West Bengal',
'Belgachia Mansatala,Howrah,West Bengal',
'Belkulai,Howrah,West Bengal',
'Belur Bazar,Howrah,West Bengal',
'Belur Math,Howrah,West Bengal',
'Benapur Chandanpara,Howrah,West Bengal',
'Bhairab Dutta Lane,Howrah,West Bengal',
'Bhandardaha,Howrah,West Bengal',
'Bhandargacha,Howrah,West Bengal',
'Bharat Cooperative,Howrah,West Bengal',
'Bhatora,Howrah,West Bengal',
'Bhattanagar,Howrah,West Bengal',
'Bhekutal,Howrah,West Bengal',
'Bikihakola,Howrah,West Bengal',
'Biprannapara,Howrah,West Bengal',
'Birampur,Howrah,West Bengal',
'Birshibpur,Howrah,West Bengal',
'Brindabanpur,Howrah,West Bengal',
'Burikhali,Howrah,West Bengal',
'Chackasi,Howrah,West Bengal',
'Chakpara,Howrah,West Bengal',
'Chakraberia,Howrah,West Bengal',
'Chakur,Howrah,West Bengal',
'Chamrail,Howrah,West Bengal',
'Chatterjee Hat,Howrah,West Bengal',
'Chaturbhujkati,Howrah,West Bengal',
'Chengail,Howrah,West Bengal',
'Chitnan,Howrah,West Bengal',
'Chitrasenpur,Howrah,West Bengal',
'Circular Rd.,Howrah,West Bengal',
'Cows Ghat Rd,Howrah,West Bengal',
'D.G.Road,Howrah,West Bengal',
'Dafarpur,Howrah,West Bengal',
'Dakshin Durgapur,Howrah,West Bengal',
'Dakshin Hirapur,Howrah,West Bengal',
'Dakshin Jhapardaha,Howrah,West Bengal',
'Dakshin Radhanagar,Howrah,West Bengal',
'Dakshin Ramchandrapur,Howrah,West Bengal',
'Dakshin Santoshpur,Howrah,West Bengal',
'Dakshin Shibpur,Howrah,West Bengal',
'Danesh Sk.Lane,Howrah,West Bengal',
'Dasbhaga,Howrah,West Bengal',
'Dasnagar,Howrah,West Bengal',
'Daws Temple Rd,Howrah,West Bengal',
'Debandi,Howrah,West Bengal',
'Delta Mil,Howrah,West Bengal',
'Deoly,Howrah,West Bengal',
'Deora,Howrah,West Bengal',
'Deul Gram,Howrah,West Bengal',
'Deulpur,Howrah,West Bengal',
'Deulti,Howrah,West Bengal',
'Dhamsia,Howrah,West Bengal',
'Dharmatala Rd,Howrah,West Bengal',
'Dharsa,Howrah,West Bengal',
'Dhulagori,Howrah,West Bengal',
'Dhulasimla,Howrah,West Bengal',
'Dhulopur,Howrah,West Bengal',
'Dhunki,Howrah,West Bengal',
'Dhurkhali,Howrah,West Bengal',
'Dihibhursut,Hooghly South,West Bengal',
'Dihimondal Ghat,Howrah,West Bengal',
'Dinabandhu Instt.,Howrah,West Bengal',
'Dingakhola,Howrah,West Bengal',
'Domjur,Howrah,West Bengal',
'Duillya,Howrah,West Bengal',
'Durgapur,Howrah,West Bengal',
'Fortgloster,Howrah,West Bengal',
'Fuleswar,Howrah,West Bengal',
'Gabberia,Howrah,West Bengal',
'Gangadharpur,Howrah,West Bengal',
'Garbalia,Howrah,West Bengal',
'Gaza,Howrah,West Bengal',
'Gazipur,Howrah,West Bengal',
'Geneshpur,Howrah,West Bengal',
'Ghoshpara,Howrah,West Bengal',
'Ghoshpur,Howrah,West Bengal',
'Ghusuri,Howrah,West Bengal',
'Gip Colony,Howrah,West Bengal',
'Goabaria,Howrah,West Bengal',
'Gobardhanbati,Howrah,West Bengal',
'Gobindapur,Howrah,West Bengal',
'Gobindapur Shibtala,Howrah,West Bengal',
'Gohalberia,Howrah,West Bengal',
'Gondalpara,Howrah,West Bengal',
'Gourangachak,Howrah,West Bengal',
'Gurepole,Howrah,West Bengal',
'Gutinagari,Howrah,West Bengal',
'Guzarpur,Howrah,West Bengal',
'Hallyan,Howrah,West Bengal',
'Hantal Anantabati,Howrah,West Bengal',
'Harali,Howrah,West Bengal',
'Harishpur,Howrah,West Bengal',
'Harop,Howrah,West Bengal',
'Hatgacha,Howrah,West Bengal',
'Haturia,Howrah,West Bengal',
'Hirapur,Howrah,West Bengal',
'Hooghly Dock,Howrah,West Bengal',
'Howrah H.O,Howrah,West Bengal',
'Howrah Loco Depot,Howrah,West Bengal',
'Howrah R.S,Howrah,West Bengal',
'Howrah Vic.Cot.Mill,Howrah,West Bengal',
'Ichapur Rd,Howrah,West Bengal',
'Islampur,Howrah,West Bengal',
'J.P.Hat,Howrah,West Bengal',
'Jadhuberia,Howrah,West Bengal',
'Jagacha,Howrah,West Bengal',
'Jagadishpur,Howrah,West Bengal',
'Jagatballavpur,Howrah,West Bengal',
'Jagriti,Howrah,West Bengal',
'Jalabiswanathpur,Howrah,West Bengal',
'Jalalshi,Howrah,West Bengal',
'Jallabaj,Howrah,West Bengal',
'Jhamtia,Howrah,West Bengal',
'Jhinkra,Howrah,West Bengal',
'Jhorehat,Howrah,West Bengal',
'Jhumjhumi,Howrah,West Bengal',
'Joargori,Howrah,West Bengal',
'Joka,Howrah,West Bengal',
'Joynagar,Howrah,West Bengal',
'Joypur,Howrah,West Bengal',
'Joypur Bill,Howrah,West Bengal',
'Joypur Fakirdas,Howrah,West Bengal',
'Jujursa,Howrah,West Bengal',
'Kadamtala,Howrah,West Bengal',
'Kaijuri,Howrah,West Bengal',
'Kalidaha,Howrah,West Bengal',
'Kalyanpur,Howrah,West Bengal',
'Kanjiakhali,Howrah,West Bengal',
'Kankrol,Howrah,West Bengal',
'Kanpur,Howrah,West Bengal',
'Kanupath Majhpara,Howrah,West Bengal',
'Karatberia,Howrah,West Bengal',
'Kashmul,Howrah,West Bengal',
'Kendua,Howrah,West Bengal',
'Keorapara,Howrah,West Bengal',
'Keshabpur,Howrah,West Bengal',
'Khadinan,Howrah,West Bengal',
'Khajutti,Howrah,West Bengal',
'Khalisani,Howrah,West Bengal',
'Khalna,Howrah,West Bengal',
'Khantaberia,Howrah,West Bengal',
'Khantapukur,Howrah,West Bengal',
'Khantora,Howrah,West Bengal',
'Khariamoynapur,Howrah,West Bengal',
'Kharuberia,Howrah,West Bengal',
'Khasmahal Balichak,Howrah,West Bengal',
'Khasmali,Howrah,West Bengal',
'Khasmora,Howrah,West Bengal',
'Khila,Howrah,West Bengal',
'Khorop,Howrah,West Bengal',
'Khosalpur,Howrah,West Bengal',
'Khurut Rd,Howrah,West Bengal',
'Kolora,Howrah,West Bengal',
'Kona,Howrah,West Bengal',
'Kotra,Howrah,West Bengal',
'Kuldanga,Howrah,West Bengal',
'Kulgachia,Howrah,West Bengal',
'Kulitapara,Howrah,West Bengal',
'Kultikari,Howrah,West Bengal',
'Kumarchak,Howrah,West Bengal',
'Kurigachi,Howrah,West Bengal',
'Kushberia,Howrah,West Bengal',
'Kushberia,Howrah,West Bengal',
'Lakshmanpur,Howrah,West Bengal',
'Latibpur,Howrah,West Bengal',
'Liluah,Howrah,West Bengal',
'M.B.Road,Howrah,West Bengal',
'Madhabpur,Howrah,West Bengal',
'Mahishrekha,Howrah,West Bengal',
'Maju,Howrah,West Bengal',
'Makardaha,Howrah,West Bengal',
'Manikura,Howrah,West Bengal',
'Mankur,Howrah,West Bengal',
'Mansinghpur,Howrah,West Bengal',
'Mansuka,Howrah,West Bengal',
'Mashila,Howrah,West Bengal',
'Mato,Howrah,West Bengal',
'Mellock,Howrah,West Bengal',
'Mollahat,Howrah,West Bengal',
'Mugkalyan,Howrah,West Bengal',
'Munshidanga,Howrah,West Bengal',
'Munshirhat,Howrah,West Bengal',
'Nabaghara,Howrah,West Bengal',
'Nabagram Sikipur,Howrah,West Bengal',
'Nakol,Howrah,West Bengal',
'Nalpur,Howrah,West Bengal',
'Narit,Howrah,West Bengal',
'Narna,Howrah,West Bengal',
'Naskarpur,Howrah,West Bengal',
'Naul,Howrah,West Bengal',
'Nawpala,Howrah,West Bengal',
'Nayachak,Howrah,West Bengal',
'Netajigarh,Howrah,West Bengal',
'New Kolora,Howrah,West Bengal',
'Nibra,Howrah,West Bengal',
'Nijbalia,Howrah,West Bengal',
'Noapara,Howrah,West Bengal',
'Nonakundu,Howrah,West Bengal',
'Olabibitala,Howrah,West Bengal',
'Olanpara,Howrah,West Bengal',
'Old Jagacha,Howrah,West Bengal',
'Orphuli,Howrah,West Bengal',
'Pachalbazar,Howrah,West Bengal',
'Pacharul,Howrah,West Bengal',
'Paikpara,Howrah,West Bengal',
'Panchanantala Road,Howrah,West Bengal',
'Panchla,Howrah,West Bengal',
'Paniara,Howrah,West Bengal',
'Panitras,Howrah,West Bengal',
'Panpur,Howrah,West Bengal',
'Parbatipur,Howrah,West Bengal',
'Patihal,Howrah,West Bengal',
'Penro,Howrah,West Bengal',
'Pichaldaha,Howrah,West Bengal',
'Pirpur,Howrah,West Bengal',
'Podra,Howrah,West Bengal',
'Polgustia,Howrah,West Bengal',
'Prosastha,Howrah,West Bengal',
'Qumaresh,Howrah,West Bengal',
'Rabibhag,Howrah,West Bengal',
'Radhadasi,Howrah,West Bengal',
'Radhanagar,Howrah,West Bengal',
'Radhapur,Howrah,West Bengal',
'Raghudebbati,Howrah,West Bengal',
'Raghunathpur,Howrah,West Bengal',
'Raichak,Howrah,West Bengal',
'Ramchandrapur Bo (Sank.),Howrah,West Bengal',
'Ramchandrapur,Howrah,West Bengal',
'Rameswarnagar,Howrah,West Bengal',
'Ramkrishnapur,Howrah,West Bengal',
'Ramnagar,Howrah,West Bengal',
'Rampur,Howrah,West Bengal',
'Ramrajatala,Howrah,West Bengal',
'Rashpur,Howrah,West Bengal',
'Ross Road,Howrah,West Bengal',
'Rudrapur,Howrah,West Bengal',
'Rupasgori,Howrah,West Bengal',
'Sahapur,Howrah,West Bengal',
'Salkia H.O,Howrah,West Bengal',
'Salop,Howrah,West Bengal',
'Saltighat Gujarpur,Howrah,West Bengal',
'Samabaypalli,Howrah,West Bengal',
'Samruk,Howrah,West Bengal',
'Samta,Howrah,West Bengal',
'Sankrail Dakshinpara,Howrah,West Bengal',
'Sankrail,Howrah,West Bengal',
'Santoshnagar,Howrah,West Bengal',
'Santoshpur,Howrah,West Bengal',
'Santragachi,Howrah,West Bengal',
'Sapuipara,Howrah,West Bengal',
'Sarat Chatterjee Rd.,Howrah,West Bengal',
'Sarda,Howrah,West Bengal',
'Sarenga,Howrah,West Bengal',
'Sasati,Howrah,West Bengal',
'Sauria,Howrah,West Bengal',
'Sealdanga,Howrah,West Bengal',
'Shalimar,Howrah,West Bengal',
'Shibganj,Howrah,West Bengal',
'Shibtala Liluah,Howrah,West Bengal',
'Shyampur,Howrah,West Bengal',
'Sibnarayanchak,Howrah,West Bengal',
'Sibpur Bazar,Howrah,West Bengal',
'Sibpur,Howrah,West Bengal',
'Siddheswar,Howrah,West Bengal',
'Sijberia,Howrah,West Bengal',
'Singti Sibpur,Howrah,West Bengal',
'Sonagachi,Howrah,West Bengal',
'Sonamui,Howrah,West Bengal',
'Sonatala,Howrah,West Bengal',
'South Joychanditala,Howrah,West Bengal',
'Subhararah,Howrah,West Bengal',
'Subsit,Howrah,West Bengal',
'Sumda,Howrah,West Bengal',
'Sundarpur,Howrah,West Bengal',
'T.M.G Lane,Howrah,West Bengal',
'Tajpur,Howrah,West Bengal',
'Tehatta,Howrah,West Bengal',
'Tentulkuli,Howrah,West Bengal',
'Thalia,Howrah,West Bengal',
'Tulsiberia,Howrah,West Bengal',
'Udang,Howrah,West Bengal',
'Udaynarayanpur,Howrah,West Bengal',
'Ula,Howrah,West Bengal',
'Uluberia R.S,Howrah,West Bengal',
'Uluberia,Howrah,West Bengal',
'Unsani,Howrah,West Bengal',
'Uttar Durgapur,Howrah,West Bengal',
'Uttar Jharpardah,Howrah,West Bengal',
'Uttar Manasri,Howrah,West Bengal',
'Wadipur,Howrah,West Bengal',
'Alipurduar Court,Cooch Behar,West Bengal',
'Alipurduar Junction,Cooch Behar,West Bengal',
'Alipurduar New Town,Cooch Behar,West Bengal',
'Alipurduar,Cooch Behar,West Bengal',
'Atiabaribagan,Cooch Behar,West Bengal',
'Bakla Schooldanga,Cooch Behar,West Bengal',
'Bakshaduar,Cooch Behar,West Bengal',
'Banchukamari,Cooch Behar,West Bengal',
'Baniadabri,Cooch Behar,West Bengal',
'Baniagaon,Cooch Behar,West Bengal',
'Barachaukirbash,Cooch Behar,West Bengal',
'Bararangrash,Cooch Behar,West Bengal',
'Barobisha,Cooch Behar,West Bengal',
'Barodaldali,Cooch Behar,West Bengal',
'Baruipara,Cooch Behar,West Bengal',
'Bhatibari,Cooch Behar,West Bengal',
'Bhelukdabri,Cooch Behar,West Bengal',
'Bholardabri,Cooch Behar,West Bengal',
'Bindipara,Cooch Behar,West Bengal',
'Birpara Alipurduar,Cooch Behar,West Bengal',
'Boragari,Cooch Behar,West Bengal',
'Brajerkuthi,Cooch Behar,West Bengal',
'Chalnirpak,Cooch Behar,West Bengal',
'Chaparerpar,Cooch Behar,West Bengal',
'Chikliguri,Cooch Behar,West Bengal',
'Chinchula,Cooch Behar,West Bengal',
'Chuapara,Cooch Behar,West Bengal',
'Chuniajhora,Cooch Behar,West Bengal',
'Dakshin Chakoakheti,Cooch Behar,West Bengal',
'Dakshin Dhalkar,Cooch Behar,West Bengal',
'Dakshin Kamaskhyaguri,Cooch Behar,West Bengal',
'Dakshin Kamsingram,Cooch Behar,West Bengal',
'Dakshin Latabari,Cooch Behar,West Bengal',
'Dakshin Mahakalguri,Cooch Behar,West Bengal',
'Dakshin Nararthali,Cooch Behar,West Bengal',
'Dakshin Patkapara,Cooch Behar,West Bengal',
'Dakshin Satali,Cooch Behar,West Bengal',
'Dalshingpara,Cooch Behar,West Bengal',
'Damanpur,Cooch Behar,West Bengal',
'Damsibad,Cooch Behar,West Bengal',
'Dhaolajhora,Cooch Behar,West Bengal',
'Garopara,Cooch Behar,West Bengal',
'Ghagra,Cooch Behar,West Bengal',
'Gharghariahat,Cooch Behar,West Bengal',
'Hamiltonganj,Cooch Behar,West Bengal',
'Hasimara,Cooch Behar,West Bengal',
'Hatidhura,Cooch Behar,West Bengal',
'Hatipotha,Cooch Behar,West Bengal',
'Hemaguri,Cooch Behar,West Bengal',
'Jaigaon,Cooch Behar,West Bengal',
'Jainti,Cooch Behar,West Bengal',
'Jaldapara,Cooch Behar,West Bengal',
'Jasodanga,Cooch Behar,West Bengal',
'Jorai,Cooch Behar,West Bengal',
'Kadampur,Cooch Behar,West Bengal',
'Kaijali Basti,Cooch Behar,West Bengal',
'Kalabaria,Cooch Behar,West Bengal',
'Kalchini,Cooch Behar,West Bengal',
'Kalipur,Cooch Behar,West Bengal',
'Kamaskhyaguri,Cooch Behar,West Bengal',
'Kartik Choupathi,Cooch Behar,West Bengal',
'Khoardanga,Cooch Behar,West Bengal',
'Khochabarihat,Cooch Behar,West Bengal',
'Kholta,Cooch Behar,West Bengal',
'Kohinoor Tea Estate,Cooch Behar,West Bengal',
'Kumargramduar,Cooch Behar,West Bengal',
'Kumarijan,Cooch Behar,West Bengal',
'Lalchandpur,Cooch Behar,West Bengal',
'Madhubagan,Cooch Behar,West Bengal',
'Majherdabri,Cooch Behar,West Bengal',
'Majidkhana,Cooch Behar,West Bengal',
'Marakhata,Cooch Behar,West Bengal',
'Marichbari,Cooch Behar,West Bengal',
'Mathurabagan,Cooch Behar,West Bengal',
'Nathuatari,Cooch Behar,West Bengal',
'New Lands,Cooch Behar,West Bengal',
'New Market Jaigaon,Cooch Behar,West Bengal',
'Nimti Domohani,Cooch Behar,West Bengal',
'Panabasti,Cooch Behar,West Bengal',
'Panbari,Cooch Behar,West Bengal',
'Panchkolguri,Cooch Behar,West Bengal',
'Paschim Chepani,Cooch Behar,West Bengal',
'Paschim Khalisamari,Cooch Behar,West Bengal',
'Paschim Satali,Cooch Behar,West Bengal',
'Paschim Shalbari,Cooch Behar,West Bengal',
'Pukurigram,Cooch Behar,West Bengal',
'Purba Khalisamari,Cooch Behar,West Bengal',
'Purba Satali,Cooch Behar,West Bengal',
'Purba Shalbari,Cooch Behar,West Bengal',
'Radhanagar,Cooch Behar,West Bengal',
'Raidak,Cooch Behar,West Bengal',
'Rajabhat Tea Estate,Cooch Behar,West Bengal',
'Rajabhatkhawa,Cooch Behar,West Bengal',
'Rampur,Cooch Behar,West Bengal',
'Salkumarhat,Cooch Behar,West Bengal',
'Salsalabari,Cooch Behar,West Bengal',
'Saontalpur,Cooch Behar,West Bengal',
'Satali Mandal Para,Cooch Behar,West Bengal',
'Shilbarihat,Cooch Behar,West Bengal',
'Sidhabari,Cooch Behar,West Bengal',
'Soudpara,Cooch Behar,West Bengal',
'Taleshwarguri,Cooch Behar,West Bengal',
'Tapshikhata,Cooch Behar,West Bengal',
'Tatpara,Cooch Behar,West Bengal',
'Telepara,Cooch Behar,West Bengal',
'Turturi,Cooch Behar,West Bengal',
'Uttar Mendabari,Cooch Behar,West Bengal',
'Uttar Nararthali,Cooch Behar,West Bengal',
'Uttar Parokata,Cooch Behar,West Bengal',
'Uttar Shibkhata,Cooch Behar,West Bengal',
'Uttar Simlabari,Cooch Behar,West Bengal',
'Uttarpatkapara,Cooch Behar,West Bengal',
'Birpara,Jalpaiguri,West Bengal',
'Altagram Magurmari,Jalpaiguri,West Bengal',
'Ambari Bagan,Jalpaiguri,West Bengal',
'Bagribarihat,Jalpaiguri,West Bengal',
'Bairatiguri,Jalpaiguri,West Bengal',
'Bamni,Jalpaiguri,West Bengal',
'Banarhat,Jalpaiguri,West Bengal',
'Barogharia,Jalpaiguri,West Bengal',
'Bhandani,Jalpaiguri,West Bengal',
'Dakhin Khattimari,Jalpaiguri,West Bengal',
'Daukimari,Jalpaiguri,West Bengal',
'Debpara,Jalpaiguri,West Bengal',
'Fulbari,Jalpaiguri,West Bengal',
'Gairkata,Jalpaiguri,West Bengal',
'Garialtari,Jalpaiguri,West Bengal',
'Gopal Bagan,Jalpaiguri,West Bengal',
'Gossairhat,Jalpaiguri,West Bengal',
'Jharsalbari,Jalpaiguri,West Bengal',
'Jurapani,Jalpaiguri,West Bengal',
'Kalirhat,Jalpaiguri,West Bengal',
'Karbala,Jalpaiguri,West Bengal',
'Kathalguri,Jalpaiguri,West Bengal',
'Kathapara,Jalpaiguri,West Bengal',
'Kheti,Jalpaiguri,West Bengal',
'Laxmikantapara,Jalpaiguri,West Bengal',
'Mogolkata,Jalpaiguri,West Bengal',
'Nathuahat,Jalpaiguri,West Bengal',
'Paschim Mallick Para,Jalpaiguri,West Bengal',
'Patkidaha,Jalpaiguri,West Bengal',
'Pradhanpara,Jalpaiguri,West Bengal',
'Purbaduramari,Jalpaiguri,West Bengal',
'Rangalibazna,Jalpaiguri,West Bengal',
'Red Bank,Jalpaiguri,West Bengal',
'Sakoajhora,Jalpaiguri,West Bengal',
'Salbari,Jalpaiguri,West Bengal',
'Vidyashram,Jalpaiguri,West Bengal',
'Vivekananda Pally,Jalpaiguri,West Bengal',
'Dhupguri,Jalpaiguri,West Bengal',
'Alinagar,Jalpaiguri,West Bengal',
'Atpukuria Nayahat,Jalpaiguri,West Bengal',
'Badaitari,Jalpaiguri,West Bengal',
'Baganbari,Jalpaiguri,West Bengal',
'Beltoli Bhandani,Jalpaiguri,West Bengal',
'Bhutnirghat,Jalpaiguri,West Bengal',
'Chuakhola,Jalpaiguri,West Bengal',
'Dakhin Dhulagaon,Jalpaiguri,West Bengal',
'Dakhin Parengarpar,Jalpaiguri,West Bengal',
'Dalimpur,Jalpaiguri,West Bengal',
'Deogaon,Jalpaiguri,West Bengal',
'Ethelbari Crossing,Jalpaiguri,West Bengal',
'Falakata,Jalpaiguri,West Bengal',
'Jateswar,Jalpaiguri,West Bengal',
'Jogendra Pur,Jalpaiguri,West Bengal',
'Kushiarbari,Jalpaiguri,West Bengal',
'Mairadanga,Jalpaiguri,West Bengal',
'Nabanagar,Jalpaiguri,West Bengal',
'Narsingpur,Jalpaiguri,West Bengal',
'Parangerpar,Jalpaiguri,West Bengal',
'Raichenga,Jalpaiguri,West Bengal',
'Satpukuria,Jalpaiguri,West Bengal',
'Talukertari,Jalpaiguri,West Bengal',
'Tasati,Jalpaiguri,West Bengal',
'Jaldhaka Hydel Project,Jalpaiguri,West Bengal',
'Rango,Jalpaiguri,West Bengal',
'Haldibari,Jalpaiguri,West Bengal',
'Hemkumari,Jalpaiguri,West Bengal',
'Khayerbari,Jalpaiguri,West Bengal',
'Paschim Hemkumari,Jalpaiguri,West Bengal',
'Bahadur,Jalpaiguri,West Bengal',
'Barapatia Natunbas,Jalpaiguri,West Bengal',
'Belocoba,Jalpaiguri,West Bengal',
'Berubari,Jalpaiguri,West Bengal',
'Bhabani Nagar,Jalpaiguri,West Bengal',
'Bhaktipara,Jalpaiguri,West Bengal',
'Bhutkidangapara,Jalpaiguri,West Bengal',
'Brajapur,Jalpaiguri,West Bengal',
'Chaulhati,Jalpaiguri,West Bengal',
'Dangapara,Jalpaiguri,West Bengal',
'Danguajhar,Jalpaiguri,West Bengal',
'Debithakurbari,Jalpaiguri,West Bengal',
'Debnagar,Jalpaiguri,West Bengal',
'Dhapganj,Jalpaiguri,West Bengal',
'Futkipara,Jalpaiguri,West Bengal',
'Garalbari,Jalpaiguri,West Bengal',
'Helapakri,Jalpaiguri,West Bengal',
'Jalpaiguri Bank,Jalpaiguri,West Bengal',
'Jpg College Para,Jalpaiguri,West Bengal',
'Jpg Court,Jalpaiguri,West Bengal',
'Jpg Dist. School Board,Jalpaiguri,West Bengal',
'Jpg Hindustan Ins.,Jalpaiguri,West Bengal',
'Jpg.Govt Engg College,Jalpaiguri,West Bengal',
'Kachua,Jalpaiguri,West Bengal',
'Kadamtala,Jalpaiguri,West Bengal',
'Kadobarihat,Jalpaiguri,West Bengal',
'Kamarvita,Jalpaiguri,West Bengal',
'Kamatpara,Jalpaiguri,West Bengal',
'Kantipara,Jalpaiguri,West Bengal',
'Karjipara,Jalpaiguri,West Bengal',
'Kharia,Jalpaiguri,West Bengal',
'Kharija Berubari,Jalpaiguri,West Bengal',
'Kunderdighi,Jalpaiguri,West Bengal',
'Kuripara,Jalpaiguri,West Bengal',
'Malkanipara Nayahat,Jalpaiguri,West Bengal',
'Mandalghat,Jalpaiguri,West Bengal',
'Mantadari,Jalpaiguri,West Bengal',
'Menghora,Jalpaiguri,West Bengal',
'Milanpally,Jalpaiguri,West Bengal',
'Mohantapara,Jalpaiguri,West Bengal',
'Mohitnagar,Jalpaiguri,West Bengal',
'Monuaganj,Jalpaiguri,West Bengal',
'Paharpur,Jalpaiguri,West Bengal',
'Pandapara Kalibari,Jalpaiguri,West Bengal',
'Pangasahebbari,Jalpaiguri,West Bengal',
'Panpara,Jalpaiguri,West Bengal',
'Patkata,Jalpaiguri,West Bengal',
'Payachari,Jalpaiguri,West Bengal',
'Promodnagar,Jalpaiguri,West Bengal',
'Rajbari Para,Jalpaiguri,West Bengal',
'Rangdhamali,Jalpaiguri,West Bengal',
'Ranirhat,Jalpaiguri,West Bengal',
'Sahudangirhat,Jalpaiguri,West Bengal',
'Sajnapara,Jalpaiguri,West Bengal',
'Saraswatipur Bagan,Jalpaiguri,West Bengal',
'Satkhamar,Jalpaiguri,West Bengal',
'Senpara,Jalpaiguri,West Bengal',
'Silpasamiti Para,Jalpaiguri,West Bengal',
'Sirampara,Jalpaiguri,West Bengal',
'Tahsildarbari,Jalpaiguri,West Bengal',
'Uttar Dhantala,Jalpaiguri,West Bengal',
'West Congress Para,Jalpaiguri,West Bengal',
'Race Cource Para,Jalpaiguri,West Bengal',
'Adarpara,Jalpaiguri,West Bengal',
'Bowbazar,Jalpaiguri,West Bengal',
'Dinbazar,Jalpaiguri,West Bengal',
'Jalpaiguri H.O,Jalpaiguri,West Bengal',
'Madarihat,Jalpaiguri,West Bengal',
'Ramjhora,Jalpaiguri,West Bengal',
'Birpara Bazar,Jalpaiguri,West Bengal',
'Bundapani,Jalpaiguri,West Bengal',
'Chamurchi,Jalpaiguri,West Bengal',
'Choto Salkumar,Jalpaiguri,West Bengal',
'Dakhin Khyerbari,Jalpaiguri,West Bengal',
'Dimdima,Jalpaiguri,West Bengal',
'Dumchipara,Jalpaiguri,West Bengal',
'Garganda,Jalpaiguri,West Bengal',
'Huntapara,Jalpaiguri,West Bengal',
'Khagenhat,Jalpaiguri,West Bengal',
'Khowchand Para,Jalpaiguri,West Bengal',
'Lankaparahat,Jalpaiguri,West Bengal',
'M R Bazna,Jalpaiguri,West Bengal',
'Madhya Khayerbari,Jalpaiguri,West Bengal',
'Madhya Madarihat,Jalpaiguri,West Bengal',
'Makrapara,Jalpaiguri,West Bengal',
'Mujnai,Jalpaiguri,West Bengal',
'Nakugach,Jalpaiguri,West Bengal',
'Nangdala,Jalpaiguri,West Bengal',
'Shibnathpur,Jalpaiguri,West Bengal',
'Totopara,Jalpaiguri,West Bengal',
'Tukra Jateswar,Jalpaiguri,West Bengal',
'Binnaguri Cantt,Jalpaiguri,West Bengal',
'Ananda Pur,Jalpaiguri,West Bengal',
'Bataigole Bazar,Jalpaiguri,West Bengal',
'Binnaguri,Jalpaiguri,West Bengal',
'Carron,Jalpaiguri,West Bengal',
'Chakmoulani,Jalpaiguri,West Bengal',
'Chanda Company,Jalpaiguri,West Bengal',
'Chapadanga,Jalpaiguri,West Bengal',
'Damdim,Jalpaiguri,West Bengal',
'Fagu,Jalpaiguri,West Bengal',
'Gajaldoba,Jalpaiguri,West Bengal',
'Haihaipathar,Jalpaiguri,West Bengal',
'Jabramali,Jalpaiguri,West Bengal',
'Kailashpur,Jalpaiguri,West Bengal',
'Kajoldighi,Jalpaiguri,West Bengal',
'Kamat Changrabandha,Jalpaiguri,West Bengal',
'Kathambari,Jalpaiguri,West Bengal',
'Khairanti,Jalpaiguri,West Bengal',
'Krantihat,Jalpaiguri,West Bengal',
'Lataguri,Jalpaiguri,West Bengal',
'Mal H.O,Jalpaiguri,West Bengal',
'Malhati,Jalpaiguri,West Bengal',
'Manabari,Jalpaiguri,West Bengal',
'Neora,Jalpaiguri,West Bengal',
'Oodlabari,Jalpaiguri,West Bengal',
'Panwar Basty,Jalpaiguri,West Bengal',
'Patharjhora,Jalpaiguri,West Bengal',
'Purbadalaigaon,Jalpaiguri,West Bengal',
'Rajadanga,Jalpaiguri,West Bengal',
'Ramsaihat,Jalpaiguri,West Bengal',
'Rungamuttee,Jalpaiguri,West Bengal',
'Todaygaon,Jalpaiguri,West Bengal',
'Mathachulka,Jalpaiguri,West Bengal',
'Samsing,Jalpaiguri,West Bengal',
'Balasunder,Jalpaiguri,West Bengal',
'Baroshoulmari,Jalpaiguri,West Bengal',
'Giladanga,Jalpaiguri,West Bengal',
'Ramthenga,Jalpaiguri,West Bengal',
'Singijani,Jalpaiguri,West Bengal',
'Tengramari,Jalpaiguri,West Bengal',
'Baradighi,Jalpaiguri,West Bengal',
'Batabari,Jalpaiguri,West Bengal',
'Chalsa,Jalpaiguri,West Bengal',
'Indong,Jalpaiguri,West Bengal',
'Matelli,Jalpaiguri,West Bengal',
'Bagjan,Jalpaiguri,West Bengal',
'Bakali,Jalpaiguri,West Bengal',
'Banesh Jn,Jalpaiguri,West Bengal',
'Barakamat,Jalpaiguri,West Bengal',
'Benkandi,Jalpaiguri,West Bengal',
'Bhangamali,Jalpaiguri,West Bengal',
'Bhangerhat,Jalpaiguri,West Bengal',
'Bhotepatty,Jalpaiguri,West Bengal',
'Bhuskadanga,Jalpaiguri,West Bengal',
'Boulbari,Jalpaiguri,West Bengal',
'Churabhander,Jalpaiguri,West Bengal',
'Dakhin Moamari,Jalpaiguri,West Bengal',
'Dangapara Ashram,Jalpaiguri,West Bengal',
'Dharampur,Jalpaiguri,West Bengal',
'Dhawlaguri,Jalpaiguri,West Bengal',
'Domohani,Jalpaiguri,West Bengal',
'Jalpesh Mandir,Jalpaiguri,West Bengal',
'Jorepakri,Jalpaiguri,West Bengal',
'Kumarpara,Jalpaiguri,West Bengal',
'Madhabdanga,Jalpaiguri,West Bengal',
'Madhya Khagrabari,Jalpaiguri,West Bengal',
'Maynaguri,Jalpaiguri,West Bengal',
'Nutan Bazar,Jalpaiguri,West Bengal',
'Padamati,Jalpaiguri,West Bengal',
'Panbari,Jalpaiguri,West Bengal',
'Putimari,Jalpaiguri,West Bengal',
'Saptibari,Jalpaiguri,West Bengal',
'Singimari,Jalpaiguri,West Bengal',
'Tekatuli,Jalpaiguri,West Bengal',
'Ulladabri,Jalpaiguri,West Bengal',
'Uttar Saptibari,Jalpaiguri,West Bengal',
'Brahamattar Kuchilibari,Jalpaiguri,West Bengal',
'Changrabandha,Jalpaiguri,West Bengal',
'Joresimuli,Jalpaiguri,West Bengal',
'Mekhliganj,Jalpaiguri,West Bengal',
'Shoulmari,Jalpaiguri,West Bengal',
'Jamaldah,Jalpaiguri,West Bengal',
'Angrabhasa,Jalpaiguri,West Bengal',
'Champaguri,Jalpaiguri,West Bengal',
'Chengmari,Jalpaiguri,West Bengal',
'Jiti,Jalpaiguri,West Bengal',
'Kalabari Bagan,Jalpaiguri,West Bengal',
'Nagrakata,Jalpaiguri,West Bengal',
'Sadhupur Chengmari,Jalpaiguri,West Bengal',
'Sulkapara,Jalpaiguri,West Bengal',
'Balaram,Jalpaiguri,West Bengal',
'Fatapukur,Jalpaiguri,West Bengal',
'Gadra,Jalpaiguri,West Bengal',
'Kukurjan,Jalpaiguri,West Bengal',
'Mohanvita,Jalpaiguri,West Bengal',
'Rajganj,Jalpaiguri,West Bengal',
'Sahebpara,Jalpaiguri,West Bengal',
'Sawdavita,Jalpaiguri,West Bengal',
'Sikarpur,Jalpaiguri,West Bengal',
'Talma,Jalpaiguri,West Bengal',
'Prasannanagar,Jalpaiguri,West Bengal',
'Sailihat,Jalpaiguri,West Bengal',
'Daulatpur,Calcutta South Presidency,West Bengal',
'Memanpur Chandannagar,Calcutta South Presidency,West Bengal',
'Tangra,Kolkata East,West Bengal',
'Abinash Chaowdhury Lane,Kolkata East,West Bengal',
'Raja Ram Mohan Sarani,Kolkata East,West Bengal',
'Beleghata H.O,Kolkata East,West Bengal',
'Subhash Sarabor,Kolkata East,West Bengal',
'Circus Avenue,Kolkata East,West Bengal',
'Bengal Chemical,Kolkata East,West Bengal',
'Kankurgachi,Kolkata East,West Bengal',
'Ram Krishna Samadhi Road,Kolkata East,West Bengal',
'A.J.C.Bose Road,Calcutta South,West Bengal',
'Alipore Bodyguard Line,Calcutta South,West Bengal',
'Alipore Civil Court,Calcutta South,West Bengal',
'Alipore Dist Board,Calcutta South,West Bengal',
'Alipore H.O,Calcutta South,West Bengal',
'Asylum Lane,Kolkata Central,West Bengal',
'Badartala,Calcutta South,West Bengal',
'Baghajatin,Calcutta South,West Bengal',
'Bakery Road,Calcutta South,West Bengal',
'Ballygunge RS,Calcutta South,West Bengal',
'Ballygunge,Calcutta South,West Bengal',
'Ballygunge Sc College,Calcutta South,West Bengal',
'Bamboovila,Kolkata East,West Bengal',
'Barabazar H.O,Barabazaar Gpo,West Bengal',
'Barisha,Calcutta South,West Bengal',
'Bartala,Calcutta South,West Bengal',
'Behala Municipal Market,Calcutta South,West Bengal',
'Behala,Calcutta South,West Bengal',
'Bhawanipore,Calcutta South,West Bengal',
'Bidhangarh,Calcutta South,West Bengal',
'Bijoygarh,Calcutta South,West Bengal',
'Bosepukur Road,Calcutta South,West Bengal',
'Bowbazar,Kolkata Central,West Bengal',
'Brace Bridge,Calcutta South,West Bengal',
'Brahma Samaj Road,Calcutta South,West Bengal',
'Chetla,Calcutta South,West Bengal',
'Chittaranjan Avenue,Kolkata Central,West Bengal',
'Cmda Abasan,Kolkata East,West Bengal',
'College Square,Kolkata Central,West Bengal',
'Colootola,Kolkata Central,West Bengal',
'Council House Street,Kolkata Central,West Bengal',
'Customs House,Kolkata Central,West Bengal',
'Dhakuria,Calcutta South,West Bengal',
'Dharmatala,Kolkata Central,West Bengal',
'Dover Lane,Calcutta South,West Bengal',
'E.K.T,Calcutta South,West Bengal',
'Elliot Road,Kolkata Central,West Bengal',
'Esplanade,Kolkata Central,West Bengal',
'Fort William,Kolkata Central,West Bengal',
'Ganguly Bagan,Calcutta South,West Bengal',
'Garcha Road,Calcutta South,West Bengal',
'Garden Reach,Calcutta South,West Bengal',
'Garfa,Calcutta South,West Bengal',
'Garia BT,Calcutta South,West Bengal',
'Gariahat Market,Calcutta South,West Bengal',
'Gobinda Khatick Road,Kolkata East,West Bengal',
'Gokhel Road,Calcutta South,West Bengal',
'Golf Green,Calcutta South,West Bengal',
'Golpark,Calcutta South,West Bengal',
'Great Eastern Hotel,Kolkata Central,West Bengal',
'Haltu,Calcutta South,West Bengal',
'Haridevpur,Calcutta South,West Bengal',
'Hastings,Calcutta South,West Bengal',
'Hindustan Building,Kolkata Central,West Bengal',
'Hyde Road,Calcutta South,West Bengal',
'Income Tax Building,Kolkata Central,West Bengal',
'Indrani Park,Calcutta South,West Bengal',
'Intally,Kolkata East,West Bengal',
'Jadavgarh,Calcutta South,West Bengal',
'Jadavpur University,Calcutta South,West Bengal',
'Jairampur,Calcutta South,West Bengal',
'Jayshree Park,Calcutta South,West Bengal',
'Jhowtala,Kolkata East,West Bengal',
'Jodhpur Park,Calcutta South,West Bengal',
'Joramandir,Kolkata East,West Bengal',
'K.C.Mills,Calcutta South,West Bengal',
'K.G Bose Sarani,Kolkata East,West Bengal',
'K.M.Hospital,Calcutta South,West Bengal',
'K.P.Bazar,Calcutta South,West Bengal',
'K.P.Roy Lane,Calcutta South,West Bengal',
'Kalabagan,Calcutta South,West Bengal',
'Kalagachia,Calcutta South,West Bengal',
'Kalighat,Calcutta South,West Bengal',
'Kalikapur,Calcutta South,West Bengal',
'Kalimandir,Calcutta South,West Bengal',
'Kasba,Calcutta South,West Bengal',
'Kasthadanga,Calcutta South,West Bengal',
'Keoratala,Calcutta South,West Bengal',
'Khengrapatti,Kolkata Central,West Bengal',
'Khiddirpore,Calcutta South,West Bengal',
'Kolkata Mint,Calcutta South,West Bengal',
'Kolkata University,Kolkata Central,West Bengal',
'Kolkatta G.P.O.,Kolkata Gpo,West Bengal',
'L.R.Sarani,Calcutta South,West Bengal',
'Lake Gardens,Calcutta South,West Bengal',
'Lake Market,Calcutta South,West Bengal',
'Lalbazar,Kolkata Central,West Bengal',
'Lansdowne Market,Calcutta South,West Bengal',
'Linton Street,Kolkata East,West Bengal',
'Little Russel Street,Kolkata Central,West Bengal',
'Madrassa,Kolkata Central,West Bengal',
'Mahendra Banerjee Road,Calcutta South,West Bengal',
'Mansatala,Calcutta South,West Bengal',
'Middleton Row,Kolkata Central,West Bengal',
'Mominpur,Calcutta South,West Bengal',
'Mott Lane,Kolkata Central,West Bengal',
'Mukundapur,Calcutta South,West Bengal',
'N.R.Avenue,Calcutta South,West Bengal',
'Naktala,Calcutta South,West Bengal',
'Natioinal Library,Calcutta South,West Bengal',
'Netaji Nagar,Calcutta South,West Bengal',
'New Alipore,Calcutta South,West Bengal',
'New Market,Kolkata Central,West Bengal',
'New Secretariat Bldg.,Kolkata Central,West Bengal',
'P.G.Reach,Calcutta South,West Bengal',
'Panchanantala,Calcutta South,West Bengal',
'Panchasayar,Calcutta South,West Bengal',
'Park Street H.O,Kolkata Central,West Bengal',
'Parnasree Pally,Calcutta South,West Bengal',
'Paschim Barisha,Calcutta South,West Bengal',
'Paschim Putiari,Calcutta South,West Bengal',
'Pgh Shah Road,Calcutta South,West Bengal',
'Princep Street,Kolkata Central,West Bengal',
'R.K.Seva Pratisthan,Calcutta South,West Bengal',
'R.N. Mukherjee Road,Kolkata Central,West Bengal',
'Rabindra Nagar,Calcutta South,West Bengal',
'Radha Bazar,Kolkata Central,West Bengal',
'Raipur Jorabagan Road,Calcutta South,West Bengal',
'Raja J.N.Market,Calcutta South,West Bengal',
'Rajabagan Dock Yard,Calcutta South,West Bengal',
'Ramkrishna Park,Calcutta South,West Bengal',
'Rash Behari Avenue,Calcutta South,West Bengal',
'Regent Estate,Calcutta South,West Bengal',
'Regent Park,Calcutta South,West Bengal',
'Reserve Bank Building,Kolkata Central,West Bengal',
'Russa,Calcutta South,West Bengal',
'Russel Street,Kolkata Central,West Bengal',
'S.R.F.T.I.,Calcutta South,West Bengal',
'Sahanagar,Calcutta South,West Bengal',
'Sahapur,Calcutta South,West Bengal',
'Sales Tax Building,Kolkata East,West Bengal',
'Santoshpur Avenue,Calcutta South,West Bengal',
'Santoshpur,Calcutta South,West Bengal',
'Sarat Bose Road,Calcutta South,West Bengal',
'Sarsoona,Calcutta South,West Bengal',
'Seal Lane,Kolkata East,West Bengal',
'Senhati,Calcutta South,West Bengal',
'Shakespeare Sarani,Kolkata Central,West Bengal',
'Sirity,Calcutta South,West Bengal',
'Sonai,Calcutta South,West Bengal',
'Sooterkin Street,Kolkata Central,West Bengal',
'South Eastern Railway,Calcutta South,West Bengal',
'Southern Market,Calcutta South,West Bengal',
'Strand Road,Kolkata Central,West Bengal',
'T.C.Road,Calcutta South,West Bengal',
'T.G.Road,Calcutta South,West Bengal',
'Taratala Road,Calcutta South,West Bengal',
'Telecom Factory,Calcutta South,West Bengal',
'Telephone Bhawan,Kolkata Central,West Bengal',
'Thakurpukur,Calcutta South,West Bengal',
'Tiretta Bazar,Kolkata Central,West Bengal',
'Tollygunge H.O,Calcutta South,West Bengal',
'Treasury Building,Kolkata Central,West Bengal',
'Viveknagar,Calcutta South,West Bengal',
'W.B.Assembly House,Kolkata Central,West Bengal',
'W.B.Governors Camp.,Kolkata Central,West Bengal',
'Watgunge,Calcutta South,West Bengal',
'Writer\'s Building,Kolkata Central,West Bengal',
'Yogayog Bhawan,Kolkata Central,West Bengal',
'Narkeldanga,Kolkata East,West Bengal',
'Kalindi Housing Estate,Kolkata East,West Bengal',
'Park Circus,Kolkata East,West Bengal',
'Parsibagan,Kolkata East,West Bengal',
'Phulbagan,Kolkata East,West Bengal',
'Sankaritola,Kolkata East,West Bengal',
'Sealdah,Kolkata East,West Bengal',
'Taltala,Kolkata East,West Bengal',
'Hamidpur,Malda,West Bengal',
'Umakantatola,Malda,West Bengal',
'Khoribari,Malda,West Bengal',
'Mayna,Malda,West Bengal',
'Amarsinghi,Malda,West Bengal',
'Samsi,Malda,West Bengal',
'Gurutola,Malda,West Bengal',
'Khejuriaghat,Malda,West Bengal',
'Nandalalpur,Malda,West Bengal',
'Pubarun,Malda,West Bengal',
'Sukdevpur,Malda,West Bengal',
'Bamangola,Malda,West Bengal',
'Dubakhoksan,West Dinajpur,West Bengal',
'Jagdala,Malda,West Bengal',
'Khutadaha,Malda,West Bengal',
'Madnabati,West Dinajpur,West Bengal',
'Nalagola,West Dinajpur,West Bengal',
'Pakuahat,Malda,West Bengal',
'Sujapur,Malda,West Bengal',
'Bulbulchadi,Malda,West Bengal',
'Arbora,Malda,West Bengal',
'Baldiapukur,Malda,West Bengal',
'Bhado,Malda,West Bengal',
'Bheba,Malda,West Bengal',
'Bhingole,Malda,West Bengal',
'Birosthali,Malda,West Bengal',
'Boroi,Malda,West Bengal',
'Brahmangram,Malda,West Bengal',
'Chanchal,Malda,West Bengal',
'Chandipur,Malda,West Bengal',
'Chandrapara,Malda,West Bengal',
'Ekborna,Malda,West Bengal',
'Galimpur,Malda,West Bengal',
'Goalpara,Malda,West Bengal',
'Goraksha,Malda,West Bengal',
'Hatinda,Malda,West Bengal',
'Hazarat Jalalpur,Malda,West Bengal',
'Ishadpur,Malda,West Bengal',
'Ismailpur,Malda,West Bengal',
'Jagannathpur Maltola,Malda,West Bengal',
'Jitarpur,Malda,West Bengal',
'Kaligaon,Malda,West Bengal',
'Kandaran,Malda,West Bengal',
'Khoilsona,Malda,West Bengal',
'Kushmai,Malda,West Bengal',
'Malatipur,Malda,West Bengal',
'Malikan,Malda,West Bengal',
'Mallikpara,Malda,West Bengal',
'Mirjatpur,Malda,West Bengal',
'Motiharpur,Malda,West Bengal',
'Mulaibari,Malda,West Bengal',
'Naikanda,Malda,West Bengal',
'Noorganj,Malda,West Bengal',
'Paraninagar,Malda,West Bengal',
'Paranpur,Malda,West Bengal',
'Pukhuria,Malda,West Bengal',
'Rasulpur,Malda,West Bengal',
'Sadarpur,Malda,West Bengal',
'Serpur Mukdumpur,Malda,West Bengal',
'Singhia,Malda,West Bengal',
'Sonarai,Malda,West Bengal',
'Charianantapur,Malda,West Bengal',
'Chorolmoni,Malda,West Bengal',
'Purbasaidpur,Malda,West Bengal',
'Dalla Madhyapara,Malda,West Bengal',
'Damaipur,Malda,West Bengal',
'Dhaoel,Malda,West Bengal',
'Dighalbar,Malda,West Bengal',
'K.B Jhowbona,Malda,West Bengal',
'Amrity,Malda,West Bengal',
'Atgama,Malda,West Bengal',
'Bairachhi,Malda,West Bengal',
'Baluchar,Malda,West Bengal',
'Bansbari,Malda,West Bengal',
'Barkol,Malda,West Bengal',
'Bhabanipur,Malda,West Bengal',
'Budhia,Malda,West Bengal',
'Dhumadighi,Malda,West Bengal',
'District School Board,Malda,West Bengal',
'Fulbari,Malda,West Bengal',
'Gopalpur,Malda,West Bengal',
'Gour,Malda,West Bengal',
'Jadupur,Malda,West Bengal',
'Jatradanga,Malda,West Bengal',
'Jhaljhalia Railway Colony,Malda,West Bengal',
'Jote Basanta,Malda,West Bengal',
'Kajigram Chandipur,Malda,West Bengal',
'Kamalabari,Malda,West Bengal',
'Kanchantar,Malda,West Bengal',
'Khaskol Chandipur,Malda,West Bengal',
'Koklamari,Malda,West Bengal',
'Madapur,Malda,West Bengal',
'Mahadipur,Malda,West Bengal',
'Malda Court,Malda,West Bengal',
'Malda H.O,Malda,West Bengal',
'Milki,Malda,West Bengal',
'Mirchak,Malda,West Bengal',
'Mothabari,Malda,West Bengal',
'Mukdumpur,Malda,West Bengal',
'Nagharia,Malda,West Bengal',
'Narayanpur,Malda,West Bengal',
'Netaji Subhas Road,Malda,West Bengal',
'Niamatpur,Malda,West Bengal',
'Phulbaria,Malda,West Bengal',
'Pirpur,Malda,West Bengal',
'Popra,Malda,West Bengal',
'Rabindra Avenue,Malda,West Bengal',
'Rajbati Ramnagar,Malda,West Bengal',
'Rathbari,Malda,West Bengal',
'Sarbamangalapally,Malda,West Bengal',
'Sattari,Malda,West Bengal',
'Sovanagar,Malda,West Bengal',
'Uttar Mahadipur,Malda,West Bengal',
'Akalpur,Malda,West Bengal',
'Alal,Malda,West Bengal',
'Arjunpur,Malda,West Bengal',
'Babupur,Malda,West Bengal',
'Badnagra,Malda,West Bengal',
'Bagsarai,Malda,West Bengal',
'Deotala,Malda,West Bengal',
'Dohil,Malda,West Bengal',
'Gajol,Malda,West Bengal',
'Hatimari,Malda,West Bengal',
'Ichahar,Malda,West Bengal',
'Kamaldanga,Malda,West Bengal',
'Katikandar,Malda,West Bengal',
'Katna,Malda,West Bengal',
'Khanta,Malda,West Bengal',
'Lakshmipur,Malda,West Bengal',
'Mahakalbona,Malda,West Bengal',
'Malipara,Malda,West Bengal',
'Molladighi,Malda,West Bengal',
'Mudapur,Malda,West Bengal',
'Panchpara,Malda,West Bengal',
'Parail,Malda,West Bengal',
'Taherpur,Malda,West Bengal',
'Salaidanga,Malda,West Bengal',
'Shivajinagar,Malda,West Bengal',
'Gangadevi,Malda,West Bengal',
'Chandmoni,Malda,West Bengal',
'Gouramari,Malda,West Bengal',
'Aiho,Malda,West Bengal',
'Sapmari,Malda,West Bengal',
'Agra Harishchandrapur,Malda,West Bengal',
'Ahil,Malda,West Bengal',
'Araji Jalsa,Malda,West Bengal',
'Asrafpur,Malda,West Bengal',
'Binodpur,Malda,West Bengal',
'Dharmadanga,Malda,West Bengal',
'Gopalpurhat,Malda,West Bengal',
'Habibpur,Malda,West Bengal',
'Jagjibanpur,Malda,West Bengal',
'Kendpukur,Malda,West Bengal',
'Manikora,Malda,West Bengal',
'Masheshpur,Malda,West Bengal',
'Nakail,Malda,West Bengal',
'Pannapur,Malda,West Bengal',
'Parbatidanga,Malda,West Bengal',
'Purba Ranipur,Malda,West Bengal',
'Rahutara,Malda,West Bengal',
'Singabad,Malda,West Bengal',
'Ahora,Malda,West Bengal',
'Gandhinagar,Malda,West Bengal',
'Hardamnagar,Malda,West Bengal',
'Baghua,Malda,West Bengal',
'Bangrua,Malda,West Bengal',
'Bansdol Daulatpur,Malda,West Bengal',
'Barduary,Malda,West Bengal',
'Bhaluka Bazar,Malda,West Bengal',
'Bhatolchandipur,Malda,West Bengal',
'Bishanpur,Malda,West Bengal',
'Dahua,Malda,West Bengal',
'Daulatnagar,Malda,West Bengal',
'Dhangara,Malda,West Bengal',
'Fatehpur,Malda,West Bengal',
'Harishchandrapur Bazar,Malda,West Bengal',
'Harishchandrapur,Malda,West Bengal',
'Jabra,Malda,West Bengal',
'Kariali,Malda,West Bengal',
'Khopakati,Malda,West Bengal',
'Mahanandatola,Malda,West Bengal',
'Mahendrapur,Malda,West Bengal',
'Maniknagar,Malda,West Bengal',
'New Sadlichak,Malda,West Bengal',
'Ramsimul,Malda,West Bengal',
'Sambalpur,Malda,West Bengal',
'Sultannagar,Malda,West Bengal',
'Debiganj,Malda,West Bengal',
'Jagannathpur,Malda,West Bengal',
'Kadamtala,Malda,West Bengal',
'Jotparam,Malda,West Bengal',
'Akandabaria,Malda,West Bengal',
'Alipur,Malda,West Bengal',
'Bahadurpur,Malda,West Bengal',
'Bakharpur,Malda,West Bengal',
'Baliadanga,Malda,West Bengal',
'Bamangram,Malda,West Bengal',
'Char Sujapur Mandai,Malda,West Bengal',
'Charbabupur,Malda,West Bengal',
'Chhoto Sujapur,Malda,West Bengal',
'Dakshin Lakshmipur,Malda,West Bengal',
'Duisatabighi,Malda,West Bengal',
'Fatehkhani,Malda,West Bengal',
'Gangaprasad,Malda,West Bengal',
'Gayeshbari,Malda,West Bengal',
'Golapganj,Malda,West Bengal',
'Jalalpur,Malda,West Bengal',
'Jaluabadhal Mallikpara,Malda,West Bengal',
'Jamirghata Sarkarpara,Malda,West Bengal',
'Joyenpur,Malda,West Bengal',
'Madhugaht Filature Estate,Malda,West Bengal',
'Mosimpur,Malda,West Bengal',
'Nabinagar,Malda,West Bengal',
'Nawada,Malda,West Bengal',
'Nayagram,Malda,West Bengal',
'Palgachhi,Malda,West Bengal',
'Rajnagar,Malda,West Bengal',
'Ramnagar,Malda,West Bengal',
'Sabdalpur,Malda,West Bengal',
'Sahabazpur,Malda,West Bengal',
'Shashani,Malda,West Bengal',
'Shersahi,Malda,West Bengal',
'South Kadamtala,Malda,West Bengal',
'Srirampur,Malda,West Bengal',
'Sultanganj,Malda,West Bengal',
'Uttar Lakshmipur,Malda,West Bengal',
'Meherapur,Malda,West Bengal',
'Alinagar,Malda,West Bengal',
'Bangitola,Malda,West Bengal',
'Baluachara,Malda,West Bengal',
'Bholaichak,Malda,West Bengal',
'Chaspara,Malda,West Bengal',
'Kaliachak,Malda,West Bengal',
'Khaschandpur,Malda,West Bengal',
'Sherpur,Malda,West Bengal',
'Jagul,Midnapore,West Bengal',
'Janardanpur,Midnapore,West Bengal',
'Jatrabishnupur,Midnapore,West Bengal',
'Jayantinarayanchak,Midnapore,West Bengal',
'Jayantipur,Midnapore,West Bengal',
'Jhalka,Midnapore,West Bengal',
'Jhentla,Midnapore,West Bengal',
'Jhikuria,Midnapore,West Bengal',
'Jirapara,Midnapore,West Bengal',
'Kadra,Midnapore,West Bengal',
'Kalagram,Midnapore,West Bengal',
'Kalakari,Midnapore,West Bengal',
'Kalidan,Midnapore,West Bengal',
'Kalla,Midnapore,West Bengal',
'Kamargeria,Midnapore,West Bengal',
'Kanasole,Midnapore,West Bengal',
'Kanikha,Midnapore,West Bengal',
'Kantapahari,Midnapore,West Bengal',
'Keshadal,Midnapore,West Bengal',
'Keshpur,Midnapore,West Bengal',
'Khalakpur,Midnapore,West Bengal',
'Khamarbarh,Midnapore,West Bengal',
'Kharigeria,Midnapore,West Bengal',
'Kharkusma,Midnapore,West Bengal',
'Khelna,Midnapore,West Bengal',
'Khirati,Midnapore,West Bengal',
'Khunkhunia,Midnapore,West Bengal',
'Kiaboni,Midnapore,West Bengal',
'Kiageria,Midnapore,West Bengal',
'Kiamacha,Midnapore,West Bengal',
'Kismat Angua,Midnapore,West Bengal',
'Kongarer Ayma,Midnapore,West Bengal',
'Korasia,Midnapore,West Bengal',
'Krishnanagar,Midnapore,West Bengal',
'Krishnapur,Midnapore,West Bengal',
'Kuanpur,Midnapore,West Bengal',
'Kuliara,Midnapore,West Bengal',
'Lachipur,Midnapore,West Bengal',
'Lowada,Midnapore,West Bengal',
'Lutunia,Midnapore,West Bengal',
'Madanmohanchak,Midnapore,West Bengal',
'Magra,Midnapore,West Bengal',
'Mahatabnagar,Midnapore,West Bengal',
'Mahespur Murakata,Midnapore,West Bengal',
'Mahisda,Midnapore,West Bengal',
'Makli,Midnapore,West Bengal',
'Malbandi,Midnapore,West Bengal',
'Mangalbandhi,Midnapore,West Bengal',
'Manglapur,Midnapore,West Bengal',
'Mataldanga,Midnapore,West Bengal',
'Mayta,Midnapore,West Bengal',
'Midnapore Collectorate,Midnapore,West Bengal',
'Midnapore Court,Midnapore,West Bengal',
'Midnapore DSB,Midnapore,West Bengal',
'Midnapore H.O,Midnapore,West Bengal',
'Midnapore Police Line,Midnapore,West Bengal',
'Midnapore Sitala,Midnapore,West Bengal',
'Mohoboni,Midnapore,West Bengal',
'Monidaha,Midnapore,West Bengal',
'Moulaparamanandapur,Midnapore,West Bengal',
'Mugbasan,Midnapore,West Bengal',
'Nadasuli,Midnapore,West Bengal',
'Nalbana,Midnapore,West Bengal',
'Narma,Midnapore,West Bengal',
'Natunbazar,Midnapore,West Bengal',
'Nayabasat,Midnapore,West Bengal',
'Nayagram Benasuli,Midnapore,West Bengal',
'Nepura,Midnapore,West Bengal',
'Neradeul,Midnapore,West Bengal',
'Nohari,Midnapore,West Bengal',
'Paikmajita,Midnapore,West Bengal',
'Panchgeria,Midnapore,West Bengal',
'Panchkhuri,Midnapore,West Bengal',
'Pandua,Midnapore,West Bengal',
'Panikotor,Midnapore,West Bengal',
'Parsura,Midnapore,West Bengal',
'Patharpara,Midnapore,West Bengal',
'Pathartoria,Midnapore,West Bengal',
'Patnabazar,Midnapore,West Bengal',
'Pindrui,Midnapore,West Bengal',
'Pingboni,Midnapore,West Bengal',
'Prasadchak,Midnapore,West Bengal',
'Ragpur,Midnapore,West Bengal',
'Rajganj,Midnapore,West Bengal',
'Ramgarh,Midnapore,West Bengal',
'Ramjibanpur,Midnapore,West Bengal',
'Ranimadhabpur,Midnapore,West Bengal',
'Raskundu,Midnapore,West Bengal',
'Reserve Bank Nm Ltd.,Midnapore,West Bengal',
'Routa,Midnapore,West Bengal',
'Routara,Midnapore,West Bengal',
'Saharda,Midnapore,West Bengal',
'Sahaspur,Midnapore,West Bengal',
'Saidpur,Midnapore,West Bengal',
'Sainthal,Midnapore,West Bengal',
'Saiyadbali,Midnapore,West Bengal',
'Sanatorium Digri,Midnapore,West Bengal',
'Sandhipur,Midnapore,West Bengal',
'Sanmura,Midnapore,West Bengal',
'Sanpdaha,Midnapore,West Bengal',
'Sarisakhola,Midnapore,West Bengal',
'Satbankura,Midnapore,West Bengal',
'Sekendari,Midnapore,West Bengal',
'Shalboni Raghunathpur,Midnapore,West Bengal',
'Shalboni,Midnapore,West Bengal',
'Shyamchandpur,Midnapore,West Bengal',
'Sijua,Midnapore,West Bengal',
'Sirisdanga,Midnapore,West Bengal',
'Siromoni,Midnapore,West Bengal',
'Sirsa,Midnapore,West Bengal',
'Srinagar,Midnapore,West Bengal',
'Supaparsuri,Midnapore,West Bengal',
'Talbandhi,Midnapore,West Bengal',
'Tantigeria,Midnapore,West Bengal',
'Tatarpur,Midnapore,West Bengal',
'Tenpur,Midnapore,West Bengal',
'Toria,Midnapore,West Bengal',
'Uchitpur,Midnapore,West Bengal',
'Uriasai,Midnapore,West Bengal',
'Uttarbil,Midnapore,West Bengal',
'Vidyasagar University,Midnapore,West Bengal',
'Kotai,Midnapore,West Bengal',
'Mirzapur Belda,Contai,West Bengal',
'Mohanpur Market,Contai,West Bengal',
'Mohanpur,Contai,West Bengal',
'Morchi,Contai,West Bengal',
'Murabani,Contai,West Bengal',
'Mustafapur,Contai,West Bengal',
'Nachhipur,Contai,West Bengal',
'Nagripada,Contai,West Bengal',
'Nankarmaguria,Contai,West Bengal',
'Narayangarh,Contai,West Bengal',
'Narda,Contai,West Bengal',
'Nayagram,Contai,West Bengal',
'Nekrasole,Contai,West Bengal',
'Nekurseni,Contai,West Bengal',
'Nilda,Contai,West Bengal',
'Paika,Contai,West Bengal',
'Palsandapur,Contai,West Bengal',
'Joteghanashyam,Tamluk,West Bengal',
'Paragana,Contai,West Bengal',
'Paroi,Contai,West Bengal',
'Pathra,Contai,West Bengal',
'Phandar,Contai,West Bengal',
'Porolda,Contai,West Bengal',
'Purunda,Contai,West Bengal',
'Rajnagar,Contai,West Bengal',
'Rampura,Contai,West Bengal',
'Ranbonia,Contai,West Bengal',
'Rautarabari,Contai,West Bengal',
'Rautarapur,Contai,West Bengal',
'Remu,Contai,West Bengal',
'Renjura,Contai,West Bengal',
'Reripur,Contai,West Bengal',
'Rohini,Contai,West Bengal',
'Sabra,Contai,West Bengal',
'Beuncha,Midnapore,West Bengal',
'Bhadutala,Midnapore,West Bengal',
'Gohaldihi,Midnapore,West Bengal',
'Karnagarh,Midnapore,West Bengal',
'Kashijora,Midnapore,West Bengal',
'Salikotha,Contai,West Bengal',
'Saljora,Contai,West Bengal',
'Saluka,Contai,West Bengal',
'Sansadgopinathpur,Contai,West Bengal',
'Santrapur,Contai,West Bengal',
'Saorapin,Contai,West Bengal',
'Sarrang,Contai,West Bengal',
'Sarta,Contai,West Bengal',
'Satpautia,Contai,West Bengal',
'Sauri,Contai,West Bengal',
'Sautia,Contai,West Bengal',
'Singaijamuna,Contai,West Bengal',
'Siyalsai,Contai,West Bengal',
'Sonakonia,Contai,West Bengal',
'Sukharole,Contai,West Bengal',
'Susinda,Contai,West Bengal',
'Tilaboni Mahisamunda,Contai,West Bengal',
'Talda Ratanchak,Contai,West Bengal',
'Tanua,Contai,West Bengal',
'Tararui,Contai,West Bengal',
'Tarua,Contai,West Bengal',
'Tentuliabhumjan,Contai,West Bengal',
'Thakurchak,Contai,West Bengal',
'Tufuria Kamalpur,Contai,West Bengal',
'Turka Garh,Contai,West Bengal',
'Turkagarh,Contai,West Bengal',
'Uchudiha,Contai,West Bengal',
'Uparjagatpur,Contai,West Bengal',
'Uttar Dumurkhola,Contai,West Bengal',
'Uttar Ranibarh,Contai,West Bengal',
'Etmadpur,Agra,Uttar Pradesh',
'Kalayanpur Bhagirathpur,Aligarh,Uttar Pradesh',
'509command,Agra,Uttar Pradesh',
'Agra Barrcks,Agra,Uttar Pradesh',
'Agra Chauk,Agra,Uttar Pradesh',
'Agra City,Agra,Uttar Pradesh',
'Agra Fort H.O,Agra,Uttar Pradesh',
'Agra H.O,Agra,Uttar Pradesh',
'Agra University,Agra,Uttar Pradesh',
'Artoni,Agra,Uttar Pradesh',
'B.M. Khan,Agra,Uttar Pradesh',
'B.P Oilmill,Agra,Uttar Pradesh',
'B.V. Bichpuri,Agra,Uttar Pradesh',
'Bainpur,Agra,Uttar Pradesh',
'Balu Ganj,Agra,Uttar Pradesh',
'Bamrauli Ahir,Agra,Uttar Pradesh',
'Bamrauli Katara,Agra,Uttar Pradesh',
'Barara,Agra,Uttar Pradesh',
'Barauli Ahir,Agra,Uttar Pradesh',
'Barauli Gujar,Agra,Uttar Pradesh',
'Belan Ganj,Agra,Uttar Pradesh',
'Bhogipura,Agra,Uttar Pradesh',
'Billoch Pura,Agra,Uttar Pradesh',
'Bodla,Agra,Uttar Pradesh',
'Budhana Mustkil,Agra,Uttar Pradesh',
'C.O.D.,Agra,Uttar Pradesh',
'Chhipitola,Agra,Uttar Pradesh',
'Chimman Lal Road,Agra,Uttar Pradesh',
'Civil Court,Agra,Uttar Pradesh',
'Civil Line,Agra,Uttar Pradesh',
'Collectrate,Agra,Uttar Pradesh',
'Dahtora,Agra,Uttar Pradesh',
'Dayal Bagh,Agra,Uttar Pradesh',
'Deoretha,Agra,Uttar Pradesh',
'Deori,Agra,Uttar Pradesh',
'Digner,Agra,Uttar Pradesh',
'Foundry Nagar,Agra,Uttar Pradesh',
'G. L. Emporiaumi,Agra,Uttar Pradesh',
'G.G Industries,Agra,Uttar Pradesh',
'G.M Khan,Agra,Uttar Pradesh',
'Gandhi Nagar,Agra,Uttar Pradesh',
'Garsani,Agra,Uttar Pradesh',
'Gokulpura,Agra,Uttar Pradesh',
'Gutila,Agra,Uttar Pradesh',
'Holiday In.,Agra,Uttar Pradesh',
'Hospital Road,Agra,Uttar Pradesh',
'Hotal Clarkshiraj,Agra,Uttar Pradesh',
'I. A. F.,Agra,Uttar Pradesh',
'Idgha Colony,Agra,Uttar Pradesh',
'Industrial Estate,Agra,Uttar Pradesh',
'Jaganpur,Agra,Uttar Pradesh',
'Jagdish Pura,Agra,Uttar Pradesh',
'Jarua Katra,Agra,Uttar Pradesh',
'John\'s Mill,Agra,Uttar Pradesh',
'Johri Bazar,Agra,Uttar Pradesh',
'K.H.Sansthan,Agra,Uttar Pradesh',
'Kailash,Agra,Uttar Pradesh',
'Kakua,Agra,Uttar Pradesh',
'Kalal Kheria,Agra,Uttar Pradesh',
'Kalibari,Agra,Uttar Pradesh',
'Kalwari,Agra,Uttar Pradesh',
'Kamala Nagar,Agra,Uttar Pradesh',
'Karodhana Kala,Agra,Uttar Pradesh',
'Khandri,Agra,Uttar Pradesh',
'Kheria Airport,Agra,Uttar Pradesh',
'Kundaul,Agra,Uttar Pradesh',
'Labour Colony,Agra,Uttar Pradesh',
'Lajpat Kunj,Agra,Uttar Pradesh',
'Loha Mandi,Agra,Uttar Pradesh',
'Malpura,Agra,Uttar Pradesh',
'Malviya Kunj,Agra,Uttar Pradesh',
'Mankeda,Agra,Uttar Pradesh',
'Medical College,Agra,Uttar Pradesh',
'Midhakur,Agra,Uttar Pradesh',
'Moti Katara,Agra,Uttar Pradesh',
'N.M.Palika,Agra,Uttar Pradesh',
'N.V.Colony,Agra,Uttar Pradesh',
'Nagla Kali,Agra,Uttar Pradesh',
'Nai Ki Mandi,Agra,Uttar Pradesh',
'Nainana Jat,Agra,Uttar Pradesh',
'Namner,Agra,Uttar Pradesh',
'Naraich,Agra,Uttar Pradesh',
'New Agra,Agra,Uttar Pradesh',
'Nunhai,Agra,Uttar Pradesh',
'P.R.R,Agra,Uttar Pradesh',
'Pathauli,Agra,Uttar Pradesh',
'Phulatti Bazar,Agra,Uttar Pradesh',
'PRTC,Agra,Uttar Pradesh',
'R.B.S.College,Agra,Uttar Pradesh',
'Raja Mandi,Agra,Uttar Pradesh',
'Rajpur,Agra,Uttar Pradesh',
'Rakabganj,Agra,Uttar Pradesh',
'Rawatpara,Agra,Uttar Pradesh',
'Rohta,Agra,Uttar Pradesh',
'Sadar Bazar,Agra,Uttar Pradesh',
'Sadarbhatti,Agra,Uttar Pradesh',
'Sahara,Agra,Uttar Pradesh',
'Saket Colony,Agra,Uttar Pradesh',
'Sanjay Place,Agra,Uttar Pradesh',
'Sarai Khawaja,Agra,Uttar Pradesh',
'Semri,Agra,Uttar Pradesh',
'Seola Jat,Agra,Uttar Pradesh',
'Shahaganj,Agra,Uttar Pradesh',
'Shahganj Bazar,Agra,Uttar Pradesh',
'Shahi,Agra,Uttar Pradesh',
'Shoe Market,Agra,Uttar Pradesh',
'Shyamo,Agra,Uttar Pradesh',
'Sikandra,Agra,Uttar Pradesh',
'Sultan Pura,Agra,Uttar Pradesh',
'Sunari,Agra,Uttar Pradesh',
'T.P. Nagar,Agra,Uttar Pradesh',
'Taj,Agra,Uttar Pradesh',
'Tajganj,Agra,Uttar Pradesh',
'Wazir Pura,Agra,Uttar Pradesh',
'Yamuna Bridge,Agra,Uttar Pradesh',
'Yamuna Kinara,Agra,Uttar Pradesh',
'Arnota,Agra,Uttar Pradesh',
'Bah,Agra,Uttar Pradesh',
'Bamrauli,Agra,Uttar Pradesh',
'Barenda,Agra,Uttar Pradesh',
'Basoni,Agra,Uttar Pradesh',
'Bateshwar,Agra,Uttar Pradesh',
'Bhadrauli,Agra,Uttar Pradesh',
'Bichola,Agra,Uttar Pradesh',
'Biprawali,Agra,Uttar Pradesh',
'Bitholi,Agra,Uttar Pradesh',
'Chamraua,Agra,Uttar Pradesh',
'Chaurangahar,Agra,Uttar Pradesh',
'Chitra Hat,Agra,Uttar Pradesh',
'Gajaura,Agra,Uttar Pradesh',
'Garhwar,Agra,Uttar Pradesh',
'Gonseli,Agra,Uttar Pradesh',
'Holi Pura,Agra,Uttar Pradesh',
'Jaitpur,Agra,Uttar Pradesh',
'Jarar,Agra,Uttar Pradesh',
'Kachora Ghat,Agra,Uttar Pradesh',
'Kamtari,Agra,Uttar Pradesh',
'Karkoli,Agra,Uttar Pradesh',
'Khilawali,Agra,Uttar Pradesh',
'Kukapur,Agra,Uttar Pradesh',
'Kukthari,Agra,Uttar Pradesh',
'Kwari,Agra,Uttar Pradesh',
'Maloni,Agra,Uttar Pradesh',
'Manikpura,Agra,Uttar Pradesh',
'Mau,Agra,Uttar Pradesh',
'Nadgawan,Agra,Uttar Pradesh',
'Naugawan,Agra,Uttar Pradesh',
'Parna,Agra,Uttar Pradesh',
'Pharera,Agra,Uttar Pradesh',
'Pidhora,Agra,Uttar Pradesh',
'Pinahat,Agra,Uttar Pradesh',
'Pura Guman Singh,Agra,Uttar Pradesh',
'Pura Kanhera,Agra,Uttar Pradesh',
'Pura Tinnet,Agra,Uttar Pradesh',
'Rajora,Agra,Uttar Pradesh',
'Ratoti,Agra,Uttar Pradesh',
'Reha,Agra,Uttar Pradesh',
'Richhpura,Agra,Uttar Pradesh',
'Rudhmuli,Agra,Uttar Pradesh',
'Sabora,Agra,Uttar Pradesh',
'Sanjeti,Agra,Uttar Pradesh',
'Shahpur Brahman,Agra,Uttar Pradesh',
'Shiaupura,Agra,Uttar Pradesh',
'Shiv Nagar,Agra,Uttar Pradesh',
'Sidhaoli,Agra,Uttar Pradesh',
'Tasond,Agra,Uttar Pradesh',
'Umretha,Agra,Uttar Pradesh',
'Vikrampur,Agra,Uttar Pradesh',
'Poiya Tarrakpur,Agra,Uttar Pradesh',
'Agwar,Agra,Uttar Pradesh',
'Aharan,Agra,Uttar Pradesh',
'Anwal Khera,Agra,Uttar Pradesh',
'Arela,Agra,Uttar Pradesh',
'Baman,Agra,Uttar Pradesh',
'Barhan,Agra,Uttar Pradesh',
'Basona,Agra,Uttar Pradesh',
'Behrampur,Agra,Uttar Pradesh',
'Bhagupur,Agra,Uttar Pradesh',
'Chamraula,Agra,Uttar Pradesh',
'Chaoli,Agra,Uttar Pradesh',
'Chhalesar,Agra,Uttar Pradesh',
'Chokda,Agra,Uttar Pradesh',
'Dharera,Agra,Uttar Pradesh',
'Dhaurra,Agra,Uttar Pradesh',
'Hasanpur,Agra,Uttar Pradesh',
'Hazipur Khera,Agra,Uttar Pradesh',
'Kanjauli,Agra,Uttar Pradesh',
'Khanda,Agra,Uttar Pradesh',
'Khandauli,Agra,Uttar Pradesh',
'Mahwatpur,Agra,Uttar Pradesh',
'Malupur,Agra,Uttar Pradesh',
'Mitaoli,Agra,Uttar Pradesh',
'Mukhbar,Agra,Uttar Pradesh',
'Murthar Alipur,Agra,Uttar Pradesh',
'Nagla Bari,Agra,Uttar Pradesh',
'Nagla Bel,Agra,Uttar Pradesh',
'Nagla Sabla,Agra,Uttar Pradesh',
'Pent Khera,Agra,Uttar Pradesh',
'Rehan Kalan,Agra,Uttar Pradesh',
'Sarai,Agra,Uttar Pradesh',
'Sawain,Agra,Uttar Pradesh',
'Semera,Agra,Uttar Pradesh',
'Siktara,Agra,Uttar Pradesh',
'Tehu,Agra,Uttar Pradesh',
'Uncha,Agra,Uttar Pradesh',
'Ushmanpur,Agra,Uttar Pradesh',
'Dhanaula Kalan,Agra,Uttar Pradesh',
'Bhalokhara,Agra,Uttar Pradesh',
'Bihari,Agra,Uttar Pradesh',
'Bijhamai,Agra,Uttar Pradesh',
'Chitaura,Agra,Uttar Pradesh',
'Dauki,Agra,Uttar Pradesh',
'Dhandupura,Agra,Uttar Pradesh',
'Dhim Shree,Agra,Uttar Pradesh',
'Fatehabad Bazaar,Agra,Uttar Pradesh',
'Fatehabad,Agra,Uttar Pradesh',
'Garhi Lal Kalan,Agra,Uttar Pradesh',
'Gubroth,Agra,Uttar Pradesh',
'H.N.Khera,Agra,Uttar Pradesh',
'Jagrajpur,Agra,Uttar Pradesh',
'Jarari,Agra,Uttar Pradesh',
'Kaulara Kalan,Agra,Uttar Pradesh',
'Khander,Agra,Uttar Pradesh',
'Kurra Chittaipur,Agra,Uttar Pradesh',
'Lahra,Agra,Uttar Pradesh',
'Lakhurani,Agra,Uttar Pradesh',
'Maharajpur,Agra,Uttar Pradesh',
'Mehra Chudhary,Agra,Uttar Pradesh',
'Nagar Chand,Agra,Uttar Pradesh',
'Nagaria,Agra,Uttar Pradesh',
'Nibohara,Agra,Uttar Pradesh',
'Palia,Agra,Uttar Pradesh',
'Pentikhera,Agra,Uttar Pradesh',
'Phool Pur,Agra,Uttar Pradesh',
'Rasoolpur,Agra,Uttar Pradesh',
'Samsabad,Agra,Uttar Pradesh',
'Shahpur Toola,Agra,Uttar Pradesh',
'Sikrara,Agra,Uttar Pradesh',
'Swara,Agra,Uttar Pradesh',
'Tanora Noorpur,Agra,Uttar Pradesh',
'Tarauli Gujar,Agra,Uttar Pradesh',
'Thana Shankar Dwari,Agra,Uttar Pradesh',
'Therai,Agra,Uttar Pradesh',
'Tiwaha,Agra,Uttar Pradesh',
'Wazitpur,Agra,Uttar Pradesh',
'Barobara Khurd,Agra,Uttar Pradesh',
'Nagla Patam,Agra,Uttar Pradesh',
'Basai Jagner,Agra,Uttar Pradesh',
'Kagrol,Agra,Uttar Pradesh',
'Ayela,Agra,Uttar Pradesh',
'Bamnai Kalan,Agra,Uttar Pradesh',
'Barwar,Agra,Uttar Pradesh',
'Berichahar,Agra,Uttar Pradesh',
'Bhakar,Agra,Uttar Pradesh',
'Bhara,Agra,Uttar Pradesh',
'Bhilawali,Agra,Uttar Pradesh',
'Bikapur Tap Kharga,Agra,Uttar Pradesh',
'Birai,Agra,Uttar Pradesh',
'Birharu,Agra,Uttar Pradesh',
'Birthala,Agra,Uttar Pradesh',
'Bisalpur,Agra,Uttar Pradesh',
'Cheet,Agra,Uttar Pradesh',
'Dankasha,Agra,Uttar Pradesh',
'Darki,Agra,Uttar Pradesh',
'Dehgawan,Agra,Uttar Pradesh',
'Dhanina,Agra,Uttar Pradesh',
'Digrauta,Agra,Uttar Pradesh',
'Garh Mukha,Agra,Uttar Pradesh',
'Garshan,Agra,Uttar Pradesh',
'Hironda,Agra,Uttar Pradesh',
'Iradat Nagar,Agra,Uttar Pradesh',
'Jagner,Agra,Uttar Pradesh',
'Jajau,Agra,Uttar Pradesh',
'Jonai,Agra,Uttar Pradesh',
'Kheragarh,Agra,Uttar Pradesh',
'Kheria,Agra,Uttar Pradesh',
'Ladhu Khera,Agra,Uttar Pradesh',
'Mahab,Agra,Uttar Pradesh',
'Mihawa,Agra,Uttar Pradesh',
'Murkia,Agra,Uttar Pradesh',
'Nadeem,Agra,Uttar Pradesh',
'Noni,Agra,Uttar Pradesh',
'Puseta,Agra,Uttar Pradesh',
'Rahlai,Agra,Uttar Pradesh',
'Rasoolpur,Agra,Uttar Pradesh',
'Richoba,Agra,Uttar Pradesh',
'Rithori,Agra,Uttar Pradesh',
'Saiyan,Agra,Uttar Pradesh',
'Sarendha,Agra,Uttar Pradesh',
'Sarendi,Agra,Uttar Pradesh',
'Singaich,Agra,Uttar Pradesh',
'Soni Khera,Agra,Uttar Pradesh',
'Tehra,Agra,Uttar Pradesh',
'Tnatpur,Agra,Uttar Pradesh',
'Nagla Dulhe Khan,Agra,Uttar Pradesh',
'Achnera Mandi,Agra,Uttar Pradesh',
'Achnera,Agra,Uttar Pradesh',
'Akhabai,Agra,Uttar Pradesh',
'Arhera,Agra,Uttar Pradesh',
'Arsena,Agra,Uttar Pradesh',
'Atoos,Agra,Uttar Pradesh',
'Aulanda,Agra,Uttar Pradesh',
'Baharawati,Agra,Uttar Pradesh',
'Baseri Chahar,Agra,Uttar Pradesh',
'Baseri Kazi,Agra,Uttar Pradesh',
'Beman,Agra,Uttar Pradesh',
'Bharkol,Agra,Uttar Pradesh',
'Chauma Shahpur,Agra,Uttar Pradesh',
'Churiyari,Agra,Uttar Pradesh',
'Dabar,Agra,Uttar Pradesh',
'Daoli,Agra,Uttar Pradesh',
'Dhanoli,Agra,Uttar Pradesh',
'Doora,Agra,Uttar Pradesh',
'Dulhara,Agra,Uttar Pradesh',
'Fatehapursikari,Agra,Uttar Pradesh',
'Gurki Mandi,Agra,Uttar Pradesh',
'Jaingara,Agra,Uttar Pradesh',
'Jajau,Agra,Uttar Pradesh',
'Jajauli,Agra,Uttar Pradesh',
'Kachaura,Agra,Uttar Pradesh',
'Karahara,Agra,Uttar Pradesh',
'Kathwari,Agra,Uttar Pradesh',
'Keetham,Agra,Uttar Pradesh',
'Kheria,Agra,Uttar Pradesh',
'Kiraoli,Agra,Uttar Pradesh',
'Korai,Agra,Uttar Pradesh',
'Kukthala,Agra,Uttar Pradesh',
'Mahuar,Agra,Uttar Pradesh',
'Mandi Mirja Khan,Agra,Uttar Pradesh',
'Mangrol Jat,Agra,Uttar Pradesh',
'Mehdau,Agra,Uttar Pradesh',
'Nagar,Agra,Uttar Pradesh',
'Nahchani,Agra,Uttar Pradesh',
'Panwari,Agra,Uttar Pradesh',
'Patsal,Agra,Uttar Pradesh',
'Puramana,Agra,Uttar Pradesh',
'Raibha,Agra,Uttar Pradesh',
'Rampur,Agra,Uttar Pradesh',
'Rojholi,Agra,Uttar Pradesh',
'Runkata,Agra,Uttar Pradesh',
'Sahata,Agra,Uttar Pradesh',
'Salemabad,Agra,Uttar Pradesh',
'Samara,Agra,Uttar Pradesh',
'Sandhan,Agra,Uttar Pradesh',
'Sikraondha,Agra,Uttar Pradesh',
'Turkia,Agra,Uttar Pradesh',
'Ujarai,Agra,Uttar Pradesh',
'Undera,Agra,Uttar Pradesh',
'Waha,Agra,Uttar Pradesh',
'Biara,Agra,Uttar Pradesh',
'Hansela,Agra,Uttar Pradesh',
'Daultabad,Agra,Uttar Pradesh',
'Arrua Khas,Agra,Uttar Pradesh',
'Akola,Agra,Uttar Pradesh',
'Aisi,Aligarh,Uttar Pradesh',
'Akrawat,Aligarh,Uttar Pradesh',
'Andla,Aligarh,Uttar Pradesh',
'Atrauli Ro R.S.,Aligarh,Uttar Pradesh',
'Badholi,Aligarh,Uttar Pradesh',
'Badon,Aligarh,Uttar Pradesh',
'Bannadevi,Aligarh,Uttar Pradesh',
'Barla,Aligarh,Uttar Pradesh',
'Beharipur,Aligarh,Uttar Pradesh',
'Bhagatpur,Aligarh,Uttar Pradesh',
'Bharpur,Aligarh,Uttar Pradesh',
'Bhilet Ramnagar,Aligarh,Uttar Pradesh',
'Digsi,Aligarh,Uttar Pradesh',
'Dodhpur,Aligarh,Uttar Pradesh',
'Dunai,Aligarh,Uttar Pradesh',
'Form Press,Aligarh,Uttar Pradesh',
'Ismailpur,Aligarh,Uttar Pradesh',
'Jamuna,Aligarh,Uttar Pradesh',
'Jiroli Dor,Aligarh,Uttar Pradesh',
'Karanpur,Aligarh,Uttar Pradesh',
'Kaseru,Aligarh,Uttar Pradesh',
'Kazimabad,Aligarh,Uttar Pradesh',
'Khanoli,Aligarh,Uttar Pradesh',
'Kiratpur Nimana,Aligarh,Uttar Pradesh',
'Klyanpur,Aligarh,Uttar Pradesh',
'Madha Habibpur,Aligarh,Uttar Pradesh',
'Majupur,Aligarh,Uttar Pradesh',
'Pairi,Aligarh,Uttar Pradesh',
'Pipoli,Aligarh,Uttar Pradesh',
'Rait,Aligarh,Uttar Pradesh',
'Sahnaul,Aligarh,Uttar Pradesh',
'Shikharan,Aligarh,Uttar Pradesh',
'Takipura,Aligarh,Uttar Pradesh',
'Abhaipur Behlolpur,Aligarh,Uttar Pradesh',
'Achna,Aligarh,Uttar Pradesh',
'Adaun,Aligarh,Uttar Pradesh',
'Ahmedpur,Aligarh,Uttar Pradesh',
'Ahraula,Aligarh,Uttar Pradesh',
'Aidalpur,Aligarh,Uttar Pradesh',
'Akrabad,Aligarh,Uttar Pradesh',
'Alampur Fatehpur,Aligarh,Uttar Pradesh',
'Alampur Rani Barla,Aligarh,Uttar Pradesh',
'Aligarh City,Aligarh,Uttar Pradesh',
'Aligarh Dairy Farm,Aligarh,Uttar Pradesh',
'Aligarh H.O,Aligarh,Uttar Pradesh',
'Aligarh Muslim University,Aligarh,Uttar Pradesh',
'Allahdadpur Aisi,Aligarh,Uttar Pradesh',
'Amrauli,Aligarh,Uttar Pradesh',
'Amritpur,Aligarh,Uttar Pradesh',
'Arrana,Aligarh,Uttar Pradesh',
'Atrauli,Aligarh,Uttar Pradesh',
'Badesara,Aligarh,Uttar Pradesh',
'Badhari Bujurg,Aligarh,Uttar Pradesh',
'Bahadurpur Kota,Aligarh,Uttar Pradesh',
'Bain Kalan,Aligarh,Uttar Pradesh',
'Bajauta,Aligarh,Uttar Pradesh',
'Balwant Nagaria,Aligarh,Uttar Pradesh',
'Bamani,Aligarh,Uttar Pradesh',
'Bamoti,Aligarh,Uttar Pradesh',
'Bankner,Aligarh,Uttar Pradesh',
'Baranadi,Aligarh,Uttar Pradesh',
'Baraula,Aligarh,Uttar Pradesh',
'Barauli,Aligarh,Uttar Pradesh',
'Barotha,Aligarh,Uttar Pradesh',
'Basai Kazi,Aligarh,Uttar Pradesh',
'Beethna,Aligarh,Uttar Pradesh',
'Bembirpur,Aligarh,Uttar Pradesh',
'Bena,Aligarh,Uttar Pradesh',
'Beswan,Aligarh,Uttar Pradesh',
'Bhadesi,Aligarh,Uttar Pradesh',
'Bhaiyan,Aligarh,Uttar Pradesh',
'Bhamora Kalan,Aligarh,Uttar Pradesh',
'Bhangra,Aligarh,Uttar Pradesh',
'Bhankri Ahiwasi,Aligarh,Uttar Pradesh',
'Bhankri Niranjankot,Aligarh,Uttar Pradesh',
'Bharatpur,Aligarh,Uttar Pradesh',
'Bhavigarh,Aligarh,Uttar Pradesh',
'Bhemti,Aligarh,Uttar Pradesh',
'Bhikampur,Aligarh,Uttar Pradesh',
'Bhimpur,Aligarh,Uttar Pradesh',
'Bhojpur Nuri,Aligarh,Uttar Pradesh',
'Bidirka,Aligarh,Uttar Pradesh',
'Bijaigarh,Aligarh,Uttar Pradesh',
'Bijauli,Aligarh,Uttar Pradesh',
'Bilona Chitsari,Aligarh,Uttar Pradesh',
'Birpura,Aligarh,Uttar Pradesh',
'Bisara,Aligarh,Uttar Pradesh',
'Bistauli,Aligarh,Uttar Pradesh',
'Bonai,Aligarh,Uttar Pradesh',
'Budha Gaon,Aligarh,Uttar Pradesh',
'Budhansi,Aligarh,Uttar Pradesh',
'Chakathal,Aligarh,Uttar Pradesh',
'Chandaiya,Aligarh,Uttar Pradesh',
'Chandaua Goverdhanapur,Aligarh,Uttar Pradesh',
'Chandaus,Aligarh,Uttar Pradesh',
'Changeri,Aligarh,Uttar Pradesh',
'Chhabilpur,Aligarh,Uttar Pradesh',
'Chhadawali,Aligarh,Uttar Pradesh',
'Chhaichhau,Aligarh,Uttar Pradesh',
'Chhalesar,Aligarh,Uttar Pradesh',
'Chharra,Aligarh,Uttar Pradesh',
'Chherat,Aligarh,Uttar Pradesh',
'Chhonk,Aligarh,Uttar Pradesh',
'Chilawati,Aligarh,Uttar Pradesh',
'Civil Court,Aligarh,Uttar Pradesh',
'D S College,Aligarh,Uttar Pradesh',
'Dabha,Aligarh,Uttar Pradesh',
'Dadon,Aligarh,Uttar Pradesh',
'Daheli,Aligarh,Uttar Pradesh',
'Datawali,Aligarh,Uttar Pradesh',
'Daupur,Aligarh,Uttar Pradesh',
'Dayal Nagar,Aligarh,Uttar Pradesh',
'Debthala,Aligarh,Uttar Pradesh',
'Dedamai,Aligarh,Uttar Pradesh',
'Deopur,Aligarh,Uttar Pradesh',
'Deorau,Aligarh,Uttar Pradesh',
'Deta Khurd,Aligarh,Uttar Pradesh',
'Dewa Hamidpur,Aligarh,Uttar Pradesh',
'Dhanipur,Aligarh,Uttar Pradesh',
'Dhansari,Aligarh,Uttar Pradesh',
'Dhantauli,Aligarh,Uttar Pradesh',
'Digsari,Aligarh,Uttar Pradesh',
'Dinapur,Aligarh,Uttar Pradesh',
'Dudhma,Aligarh,Uttar Pradesh',
'Fatehgarhi,Aligarh,Uttar Pradesh',
'Gabhana,Aligarh,Uttar Pradesh',
'Gadrana,Aligarh,Uttar Pradesh',
'Gandhi Eye Hospital,Aligarh,Uttar Pradesh',
'Gangiri,Aligarh,Uttar Pradesh',
'Gangrol,Aligarh,Uttar Pradesh',
'Ganiyabali,Aligarh,Uttar Pradesh',
'Gehtoli Nirmal,Aligarh,Uttar Pradesh',
'Gharbara,Aligarh,Uttar Pradesh',
'Ghazipur,Aligarh,Uttar Pradesh',
'Gidauli,Aligarh,Uttar Pradesh',
'Godha,Aligarh,Uttar Pradesh',
'Gomat,Aligarh,Uttar Pradesh',
'Gonda,Aligarh,Uttar Pradesh',
'Gorai,Aligarh,Uttar Pradesh',
'Gorola,Aligarh,Uttar Pradesh',
'Govindpur Fagoi,Aligarh,Uttar Pradesh',
'Gurusena,Aligarh,Uttar Pradesh',
'Gurushikharan,Aligarh,Uttar Pradesh',
'Habibganj,Aligarh,Uttar Pradesh',
'Haranpur Kalan,Aligarh,Uttar Pradesh',
'Harautha,Aligarh,Uttar Pradesh',
'Hardoi,Aligarh,Uttar Pradesh',
'Harduaganj,Aligarh,Uttar Pradesh',
'Harnaut,Aligarh,Uttar Pradesh',
'Hasona Jagmohanpur,Aligarh,Uttar Pradesh',
'Hastpur Chandfari,Aligarh,Uttar Pradesh',
'Hetalpur,Aligarh,Uttar Pradesh',
'Hinsel,Aligarh,Uttar Pradesh',
'I T I Road,Aligarh,Uttar Pradesh',
'Iglas,Aligarh,Uttar Pradesh',
'Iglas Thana,Aligarh,Uttar Pradesh',
'Industrial Area Aligarh,Aligarh,Uttar Pradesh',
'Izzatpur,Aligarh,Uttar Pradesh',
'J D Singh,Aligarh,Uttar Pradesh',
'Jaidpura,Aligarh,Uttar Pradesh',
'Jaiganj,Aligarh,Uttar Pradesh',
'Jalali,Aligarh,Uttar Pradesh',
'Jalalpur,Aligarh,Uttar Pradesh',
'Jalalpur,Aligarh,Uttar Pradesh',
'Jallupur Sehore,Aligarh,Uttar Pradesh',
'Jalokhari,Aligarh,Uttar Pradesh',
'Jamaun,Aligarh,Uttar Pradesh',
'Jamonka,Aligarh,Uttar Pradesh',
'Jarara,Aligarh,Uttar Pradesh',
'Jatrauli,Aligarh,Uttar Pradesh',
'Jattari,Aligarh,Uttar Pradesh',
'Jatwar,Aligarh,Uttar Pradesh',
'Jawan,Aligarh,Uttar Pradesh',
'Jhijharka,Aligarh,Uttar Pradesh',
'Jirauli,Aligarh,Uttar Pradesh',
'Jiroli Hira Singh,Aligarh,Uttar Pradesh',
'K G W Sasni,Aligarh,Uttar Pradesh',
'Kajrauth,Aligarh,Uttar Pradesh',
'Kakethal,Aligarh,Uttar Pradesh',
'Kalai,Aligarh,Uttar Pradesh',
'Kalua Bhilet,Aligarh,Uttar Pradesh',
'Kalwa,Aligarh,Uttar Pradesh',
'Kalyanpur,Aligarh,Uttar Pradesh',
'Kamalpur,Aligarh,Uttar Pradesh',
'Kandauli,Aligarh,Uttar Pradesh',
'Kanobi,Aligarh,Uttar Pradesh',
'Kanoi,Aligarh,Uttar Pradesh',
'Karanpur,Aligarh,Uttar Pradesh',
'Kaser,Aligarh,Uttar Pradesh',
'Kasimpur,Aligarh,Uttar Pradesh',
'Kasison,Aligarh,Uttar Pradesh',
'Kathera,Aligarh,Uttar Pradesh',
'Kauriyaganj,Aligarh,Uttar Pradesh',
'Kemthal,Aligarh,Uttar Pradesh',
'Kesopur Jafri,Aligarh,Uttar Pradesh',
'Khair Mandi,Aligarh,Uttar Pradesh',
'Khair,Aligarh,Uttar Pradesh',
'Khan Alampur,Aligarh,Uttar Pradesh',
'Khandeha,Aligarh,Uttar Pradesh',
'Khandua,Aligarh,Uttar Pradesh',
'Khera Bujurg,Aligarh,Uttar Pradesh',
'Khera Narain Singh,Aligarh,Uttar Pradesh',
'Khera Sattu,Aligarh,Uttar Pradesh',
'Khirsauli,Aligarh,Uttar Pradesh',
'Khurrampur,Aligarh,Uttar Pradesh',
'Kilpur,Aligarh,Uttar Pradesh',
'Komari,Aligarh,Uttar Pradesh',
'Konchhor,Aligarh,Uttar Pradesh',
'Korah Rustampur,Aligarh,Uttar Pradesh',
'Kutchery,Aligarh,Uttar Pradesh',
'Kutubour Amarpur,Aligarh,Uttar Pradesh',
'Ladhaua,Aligarh,Uttar Pradesh',
'Lehra,Aligarh,Uttar Pradesh',
'Lodha,Aligarh,Uttar Pradesh',
'Lohgarh,Aligarh,Uttar Pradesh',
'Lutsan,Aligarh,Uttar Pradesh',
'Madanpur,Aligarh,Uttar Pradesh',
'Madar Darwaja,Aligarh,Uttar Pradesh',
'Madhaula,Aligarh,Uttar Pradesh',
'Madholi,Aligarh,Uttar Pradesh',
'Madrak,Aligarh,Uttar Pradesh',
'Mahavir Ganj,Aligarh,Uttar Pradesh',
'Mahua,Aligarh,Uttar Pradesh',
'Maisubhasgram,Aligarh,Uttar Pradesh',
'Majhola,Aligarh,Uttar Pradesh',
'Malav,Aligarh,Uttar Pradesh',
'Malikpura,Aligarh,Uttar Pradesh',
'Malviya Nagar,Aligarh,Uttar Pradesh',
'Manai,Aligarh,Uttar Pradesh',
'Mandanpur,Aligarh,Uttar Pradesh',
'Mandpur,Aligarh,Uttar Pradesh',
'Manena Ummedpur,Aligarh,Uttar Pradesh',
'Manik Chowk,Aligarh,Uttar Pradesh',
'Manti Basai,Aligarh,Uttar Pradesh',
'Matroi,Aligarh,Uttar Pradesh',
'Maur,Aligarh,Uttar Pradesh',
'Medical College,Aligarh,Uttar Pradesh',
'Mehgora,Aligarh,Uttar Pradesh',
'Mehrawal,Aligarh,Uttar Pradesh',
'Mirpur Khas,Aligarh,Uttar Pradesh',
'Mohkampur Garia,Aligarh,Uttar Pradesh',
'Mohrena,Aligarh,Uttar Pradesh',
'Mohreni,Aligarh,Uttar Pradesh',
'Mukandpur,Aligarh,Uttar Pradesh',
'Musepur Jalal,Aligarh,Uttar Pradesh',
'N C Kasimpur,Aligarh,Uttar Pradesh',
'Nagla Birkhu,Aligarh,Uttar Pradesh',
'Nagla Devi,Aligarh,Uttar Pradesh',
'Nagla Jagdeo,Aligarh,Uttar Pradesh',
'Nagla Jhujhar,Aligarh,Uttar Pradesh',
'Nagla Padam,Aligarh,Uttar Pradesh',
'Nagla Sarua,Aligarh,Uttar Pradesh',
'Naglamandir,Aligarh,Uttar Pradesh',
'Nah,Aligarh,Uttar Pradesh',
'Nahal,Aligarh,Uttar Pradesh',
'Narainpur,Aligarh,Uttar Pradesh',
'Narona Akapur,Aligarh,Uttar Pradesh',
'Narupura,Aligarh,Uttar Pradesh',
'Naugawan,Aligarh,Uttar Pradesh',
'Naurangabad,Aligarh,Uttar Pradesh',
'Ogipur,Aligarh,Uttar Pradesh',
'Orani Dalpatpur,Aligarh,Uttar Pradesh',
'Pachawari,Aligarh,Uttar Pradesh',
'Pahari Pur,Aligarh,Uttar Pradesh',
'Pahawati,Aligarh,Uttar Pradesh',
'Paindapur,Aligarh,Uttar Pradesh',
'Paitra Nawabpur,Aligarh,Uttar Pradesh',
'Pala Aisi,Aligarh,Uttar Pradesh',
'Pala Chand,Aligarh,Uttar Pradesh',
'Pala Kastali,Aligarh,Uttar Pradesh',
'Pali Mukimpur,Aligarh,Uttar Pradesh',
'Palirajapur,Aligarh,Uttar Pradesh',
'Palsera,Aligarh,Uttar Pradesh',
'Panehra,Aligarh,Uttar Pradesh',
'Panethi,Aligarh,Uttar Pradesh',
'Parki,Aligarh,Uttar Pradesh',
'Pempur,Aligarh,Uttar Pradesh',
'Phusauli,Aligarh,Uttar Pradesh',
'Pilkhana,Aligarh,Uttar Pradesh',
'Pilona,Aligarh,Uttar Pradesh',
'Pipari,Aligarh,Uttar Pradesh',
'Pisawah,Aligarh,Uttar Pradesh',
'Polytechnic,Aligarh,Uttar Pradesh',
'Pothi,Aligarh,Uttar Pradesh',
'Pureni,Aligarh,Uttar Pradesh',
'Quarsi,Aligarh,Uttar Pradesh',
'Rajatau,Aligarh,Uttar Pradesh',
'Rajawal,Aligarh,Uttar Pradesh',
'Rajmau,Aligarh,Uttar Pradesh',
'Rajpur,Aligarh,Uttar Pradesh',
'Rajpur Khas,Aligarh,Uttar Pradesh',
'Ramghat Road,Aligarh,Uttar Pradesh',
'Ramnagar,Aligarh,Uttar Pradesh',
'Rampur Chandyana,Aligarh,Uttar Pradesh',
'Rampur Shahpur,Aligarh,Uttar Pradesh',
'Rani,Aligarh,Uttar Pradesh',
'Ranjeet Garhi,Aligarh,Uttar Pradesh',
'Rasal Ganj,Aligarh,Uttar Pradesh',
'Rehsupur,Aligarh,Uttar Pradesh',
'Resari,Aligarh,Uttar Pradesh',
'Rukhala,Aligarh,Uttar Pradesh',
'Sabalpur,Aligarh,Uttar Pradesh',
'Sadhu Ashram,Aligarh,Uttar Pradesh',
'Sahajpur,Aligarh,Uttar Pradesh',
'Sahara Khurd,Aligarh,Uttar Pradesh',
'Sahjahanpur Baijna,Aligarh,Uttar Pradesh',
'Salarpur,Aligarh,Uttar Pradesh',
'Salempur,Aligarh,Uttar Pradesh',
'Salpur,Aligarh,Uttar Pradesh',
'Sankra,Aligarh,Uttar Pradesh',
'Sarai Khirni,Aligarh,Uttar Pradesh',
'Sarai Kutub,Aligarh,Uttar Pradesh',
'Sarai Labaria,Aligarh,Uttar Pradesh',
'Sarsol,Aligarh,Uttar Pradesh',
'Sasni Gate,Aligarh,Uttar Pradesh',
'Satha,Aligarh,Uttar Pradesh',
'Sathini,Aligarh,Uttar Pradesh',
'Sawai Raghunathpur,Aligarh,Uttar Pradesh',
'Sehri Madangarhi,Aligarh,Uttar Pradesh',
'Shadipur,Aligarh,Uttar Pradesh',
'Shahabajpur,Aligarh,Uttar Pradesh',
'Shahagarh,Aligarh,Uttar Pradesh',
'Shahpur Kutub,Aligarh,Uttar Pradesh',
'Shahpur Madrak,Aligarh,Uttar Pradesh',
'Sheikhupur,Aligarh,Uttar Pradesh',
'Shiwala,Aligarh,Uttar Pradesh',
'Siarol,Aligarh,Uttar Pradesh',
'Sikandarpur Kota,Aligarh,Uttar Pradesh',
'Sikharna,Aligarh,Uttar Pradesh',
'Sikshak Bandhu,Aligarh,Uttar Pradesh',
'Sikur,Aligarh,Uttar Pradesh',
'Simardhari,Aligarh,Uttar Pradesh',
'Simrauthi,Aligarh,Uttar Pradesh',
'Siroli,Aligarh,Uttar Pradesh',
'Siya Khas,Aligarh,Uttar Pradesh',
'Somna,Aligarh,Uttar Pradesh',
'Songra,Aligarh,Uttar Pradesh',
'Subhash Road,Aligarh,Uttar Pradesh',
'Sudama Ka Bas,Aligarh,Uttar Pradesh',
'Sudeshpur,Aligarh,Uttar Pradesh',
'Suhawali,Aligarh,Uttar Pradesh',
'Sujanpur,Aligarh,Uttar Pradesh',
'Sumera,Aligarh,Uttar Pradesh',
'Sunamai,Aligarh,Uttar Pradesh',
'Sunpahar,Aligarh,Uttar Pradesh',
'T R M M Aligarh,Aligarh,Uttar Pradesh',
'Talesara,Aligarh,Uttar Pradesh',
'Talib Nagar,Aligarh,Uttar Pradesh',
'Tamkoli,Aligarh,Uttar Pradesh',
'Tamotia,Aligarh,Uttar Pradesh',
'Tappal,Aligarh,Uttar Pradesh',
'Tatarpur,Aligarh,Uttar Pradesh',
'Teothu,Aligarh,Uttar Pradesh',
'Tuamai,Aligarh,Uttar Pradesh',
'Udaipur,Aligarh,Uttar Pradesh',
'Ukhlana,Aligarh,Uttar Pradesh',
'Umri,Aligarh,Uttar Pradesh',
'Untasani,Aligarh,Uttar Pradesh',
'Upperkot,Aligarh,Uttar Pradesh',
'Usram,Aligarh,Uttar Pradesh',
'Utra,Aligarh,Uttar Pradesh',
'Utwara,Aligarh,Uttar Pradesh',
'Vishnupuri,Aligarh,Uttar Pradesh',
'Zafar Manzil,Aligarh,Uttar Pradesh',
'Ghoorpur,Allahabad,Uttar Pradesh',
'Karela Bagh,Allahabad,Uttar Pradesh',
'Akorha,Allahabad,Uttar Pradesh',
'Alam Chand,Allahabad,Uttar Pradesh',
'Baserhi,Allahabad,Uttar Pradesh',
'Agriculture Institute,Allahabad,Uttar Pradesh',
'Ahmadganj,Allahabad,Uttar Pradesh',
'Ahmedpur Asrauli,Allahabad,Uttar Pradesh',
'Ahmedpur Pawan,Allahabad,Uttar Pradesh',
'Allahabad Chowk,Allahabad,Uttar Pradesh',
'Allahabad City,Allahabad,Uttar Pradesh',
'Allahabad Fort,Allahabad,Uttar Pradesh',
'Allahabad H.O,Allahabad,Uttar Pradesh',
'Allahabad High Court,Allahabad,Uttar Pradesh',
'Allahabad Kty. H.O,Allahabad,Uttar Pradesh',
'Allahabad New Cantt,Allahabad,Uttar Pradesh',
'Amitco,Allahabad,Uttar Pradesh',
'Anapur,Allahabad,Uttar Pradesh',
'Arail,Allahabad,Uttar Pradesh',
'Asrawey Kalan,Allahabad,Uttar Pradesh',
'Atrampur,Allahabad,Uttar Pradesh',
'Attarsuiya,Allahabad,Uttar Pradesh',
'Bagbana,Allahabad,Uttar Pradesh',
'Bahadurganj,Allahabad,Uttar Pradesh',
'Bahraicha,Allahabad,Uttar Pradesh',
'Bai Ka Bagh,Allahabad,Uttar Pradesh',
'Balapur,Allahabad,Uttar Pradesh',
'Bamhrauli Uparhar,Allahabad,Uttar Pradesh',
'Bampur,Allahabad,Uttar Pradesh',
'Bamrauli Air Port,Allahabad,Uttar Pradesh',
'Bamrauli,Allahabad,Uttar Pradesh',
'Bara,Allahabad,Uttar Pradesh',
'Barha,Allahabad,Uttar Pradesh',
'Bedauli,Allahabad,Uttar Pradesh',
'Begumsarai,Allahabad,Uttar Pradesh',
'Belamundi,Allahabad,Uttar Pradesh',
'Belsara,Allahabad,Uttar Pradesh',
'Bhagwatpur,Allahabad,Uttar Pradesh',
'Bhanjanpur,Allahabad,Uttar Pradesh',
'Bharat Nagar,Allahabad,Uttar Pradesh',
'Bharatganj,Allahabad,Uttar Pradesh',
'Bhita,Allahabad,Uttar Pradesh',
'Bisauna,Allahabad,Uttar Pradesh',
'Buxie Khurde,Allahabad,Uttar Pradesh',
'C D A (P),Allahabad,Uttar Pradesh',
'Cavellary Lines,Allahabad,Uttar Pradesh',
'Chaka,Allahabad,Uttar Pradesh',
'Chamu,Allahabad,Uttar Pradesh',
'Chhapar,Allahabad,Uttar Pradesh',
'Chhatahra,Allahabad,Uttar Pradesh',
'Chheoki,Allahabad,Uttar Pradesh',
'Chhiri,Allahabad,Uttar Pradesh',
'Chilla,Allahabad,Uttar Pradesh',
'Dandi Bazar,Allahabad,Uttar Pradesh',
'Dandupur,Allahabad,Uttar Pradesh',
'Darashahazmal,Allahabad,Uttar Pradesh',
'Dariyabad,Allahabad,Uttar Pradesh',
'Daswar,Allahabad,Uttar Pradesh',
'Dhara,Allahabad,Uttar Pradesh',
'Dhoomanganj,Allahabad,Uttar Pradesh',
'Distt.Board,Allahabad,Uttar Pradesh',
'Dohatha,Allahabad,Uttar Pradesh',
'Dubaha,Allahabad,Uttar Pradesh',
'Fatehpur Ghat,Allahabad,Uttar Pradesh',
'Ganja,Allahabad,Uttar Pradesh',
'Gauspur Katahula,Allahabad,Uttar Pradesh',
'George Town,Allahabad,Uttar Pradesh',
'Ghiya Ngr,Allahabad,Uttar Pradesh',
'Hata,Allahabad,Uttar Pradesh',
'Himkalyan,Allahabad,Uttar Pradesh',
'Hindi Sahitya Sammelan,Allahabad,Uttar Pradesh',
'I L C,Allahabad,Uttar Pradesh',
'I T I,Allahabad,Uttar Pradesh',
'Indian Press,Allahabad,Uttar Pradesh',
'Jalalpur Ghosi,Allahabad,Uttar Pradesh',
'Jari Bazar,Allahabad,Uttar Pradesh',
'K G Marg,Allahabad,Uttar Pradesh',
'K N Marg,Allahabad,Uttar Pradesh',
'Kalyani Devi,Allahabad,Uttar Pradesh',
'Kamlanagar,Allahabad,Uttar Pradesh',
'Kanti,Allahabad,Uttar Pradesh',
'Kapraura,Allahabad,Uttar Pradesh',
'Karehnda,Allahabad,Uttar Pradesh',
'Karma,Allahabad,Uttar Pradesh',
'Katghar,Allahabad,Uttar Pradesh',
'Kaundhiyra,Allahabad,Uttar Pradesh',
'Kayastha Pathshala,Allahabad,Uttar Pradesh',
'Kesaria Road,Allahabad,Uttar Pradesh',
'Kheraht Khurd,Allahabad,Uttar Pradesh',
'Khiri,Allahabad,Uttar Pradesh',
'Khoonta,Allahabad,Uttar Pradesh',
'Kosda Kalan,Allahabad,Uttar Pradesh',
'Krishna Nagar,Allahabad,Uttar Pradesh',
'Lalapur Bhatpura,Allahabad,Uttar Pradesh',
'Leader Road,Allahabad,Uttar Pradesh',
'Leader,Allahabad,Uttar Pradesh',
'Lendiyari,Allahabad,Uttar Pradesh',
'Leondi,Allahabad,Uttar Pradesh',
'Lohgara,Allahabad,Uttar Pradesh',
'M G Marg,Allahabad,Uttar Pradesh',
'M L N Engg.Coll.,Allahabad,Uttar Pradesh',
'Mahgaon,Allahabad,Uttar Pradesh',
'Maida,Allahabad,Uttar Pradesh',
'Majhigaown,Allahabad,Uttar Pradesh',
'Malaka,Allahabad,Uttar Pradesh',
'Manauri AF,Allahabad,Uttar Pradesh',
'Manauri,Allahabad,Uttar Pradesh',
'Manda,Allahabad,Uttar Pradesh',
'Mandardeeh Mafi,Allahabad,Uttar Pradesh',
'Manpur,Allahabad,Uttar Pradesh',
'Mau Aima,Allahabad,Uttar Pradesh',
'Mohdpur Taluka,Allahabad,Uttar Pradesh',
'Mutthiganj,Allahabad,Uttar Pradesh',
'Naganpur,Allahabad,Uttar Pradesh',
'Naini Pac,Allahabad,Uttar Pradesh',
'Naini,Allahabad,Uttar Pradesh',
'Naudhiya Tarhar,Allahabad,Uttar Pradesh',
'Nayanwar,Allahabad,Uttar Pradesh',
'Nehru Nagar,Allahabad,Uttar Pradesh',
'New Bairahana,Allahabad,Uttar Pradesh',
'Nibi,Allahabad,Uttar Pradesh',
'Niralachowk,Allahabad,Uttar Pradesh',
'Othgi Tarhar,Allahabad,Uttar Pradesh',
'Palpatti,Allahabad,Uttar Pradesh',
'Panduwa,Allahabad,Uttar Pradesh',
'Panwar,Allahabad,Uttar Pradesh',
'Panwari,Allahabad,Uttar Pradesh',
'Pipalgaon,Allahabad,Uttar Pradesh',
'Prayag Mahila Vidyapith,Allahabad,Uttar Pradesh',
'Public Service Commission,Allahabad,Uttar Pradesh',
'Purshottam Nagar,Allahabad,Uttar Pradesh',
'Purwa Khas,Allahabad,Uttar Pradesh',
'Rajapur,Allahabad,Uttar Pradesh',
'Rajrooppur,Allahabad,Uttar Pradesh',
'Ranipur,Allahabad,Uttar Pradesh',
'S N Marg,Allahabad,Uttar Pradesh',
'S R Marg,Allahabad,Uttar Pradesh',
'Sahson,Allahabad,Uttar Pradesh',
'Saidabad,Allahabad,Uttar Pradesh',
'Sallahpur,Allahabad,Uttar Pradesh',
'Satti Chaura,Allahabad,Uttar Pradesh',
'Shergarh,Allahabad,Uttar Pradesh',
'Shukulpur,Allahabad,Uttar Pradesh',
'Sohbatia Bagh,Allahabad,Uttar Pradesh',
'Sonversa,Allahabad,Uttar Pradesh',
'Soraon,Allahabad,Uttar Pradesh',
'Subedarganj,Allahabad,Uttar Pradesh',
'Subhash Ngr,Allahabad,Uttar Pradesh',
'Sujani,Allahabad,Uttar Pradesh',
'T S L,Allahabad,Uttar Pradesh',
'Tagore Town,Allahabad,Uttar Pradesh',
'Tatarganj,Allahabad,Uttar Pradesh',
'Tirath Raj Aushadhalaya,Allahabad,Uttar Pradesh',
'Trisentulapur,Allahabad,Uttar Pradesh',
'Triveni Marg,Allahabad,Uttar Pradesh',
'Udyog Nagar,Allahabad,Uttar Pradesh',
'Ugrasen Pur,Allahabad,Uttar Pradesh',
'Umarpur Neewan,Allahabad,Uttar Pradesh',
'University,Allahabad,Uttar Pradesh',
'V N Marg,Allahabad,Uttar Pradesh',
'Allahpur,Allahabad,Uttar Pradesh',
'G T B Nagar,Allahabad,Uttar Pradesh',
'Allenganj,Allahabad,Uttar Pradesh',
'Aladadpur,Allahabad,Uttar Pradesh',
'Mansoorabad,Allahabad,Uttar Pradesh',
'Mendara,Allahabad,Uttar Pradesh',
'Prem Misirpur Korali,Allahabad,Uttar Pradesh',
'Pure Ghasi,Allahabad,Uttar Pradesh',
'Shringverpur,Allahabad,Uttar Pradesh',
'Bajha Mazra Lohia Nagar,Allahabad,Uttar Pradesh',
'Balraj Nagar,Allahabad,Uttar Pradesh',
'Masni Jagdishpur,Allahabad,Uttar Pradesh',
'Mubarakpur,Allahabad,Uttar Pradesh',
'Pachdeora,Allahabad,Uttar Pradesh',
'Saraswatipur Urf Kaudhiyar,Allahabad,Uttar Pradesh',
'Serawan,Allahabad,Uttar Pradesh',
'Ulda,Allahabad,Uttar Pradesh',
'Basahra Uparhar,Allahabad,Uttar Pradesh',
'Bemra,Allahabad,Uttar Pradesh',
'Bhandiwar,Allahabad,Uttar Pradesh',
'Bihariya,Allahabad,Uttar Pradesh',
'Newadhiya Uparhar,Allahabad,Uttar Pradesh',
'Shankargarh,Allahabad,Uttar Pradesh',
'Atraura,Allahabad,Uttar Pradesh',
'Aura,Allahabad,Uttar Pradesh',
'Baraut,Allahabad,Uttar Pradesh',
'Bhelsi,Allahabad,Uttar Pradesh',
'Bhiti,Allahabad,Uttar Pradesh',
'Bithauli,Allahabad,Uttar Pradesh',
'Dhobaha,Allahabad,Uttar Pradesh',
'Girdkot,Allahabad,Uttar Pradesh',
'Jaswan,Allahabad,Uttar Pradesh',
'Kewai Buzurg,Allahabad,Uttar Pradesh',
'Lokmanpur,Allahabad,Uttar Pradesh',
'Mahajna,Allahabad,Uttar Pradesh',
'Pure Kanta,Allahabad,Uttar Pradesh',
'Tela,Allahabad,Uttar Pradesh',
'Audhan,Allahabad,Uttar Pradesh',
'Bigahra Usmanpur,Allahabad,Uttar Pradesh',
'Gauspur,Allahabad,Uttar Pradesh',
'Imli Gaon,Allahabad,Uttar Pradesh',
'Newada,Allahabad,Uttar Pradesh',
'Noorpur,Allahabad,Uttar Pradesh',
'Purkhas,Allahabad,Uttar Pradesh',
'Sayed Serawan,Allahabad,Uttar Pradesh',
'Sikandarpur Bazha,Allahabad,Uttar Pradesh',
'Tilhapur,Allahabad,Uttar Pradesh',
'Daraganj,Allahabad,Uttar Pradesh',
'Babuganj,Allahabad,Uttar Pradesh',
'Bagai Khurd,Allahabad,Uttar Pradesh',
'Bamaila,Allahabad,Uttar Pradesh',
'Beerapur,Allahabad,Uttar Pradesh',
'Bhopatpur,Allahabad,Uttar Pradesh',
'Handia,Allahabad,Uttar Pradesh',
'Haripur Marron,Allahabad,Uttar Pradesh',
'Jagdishpur,Allahabad,Uttar Pradesh',
'Jaguwa,Allahabad,Uttar Pradesh',
'Katahra,Allahabad,Uttar Pradesh',
'Lakshagrih,Allahabad,Uttar Pradesh',
'Mawaiya Hindwani,Allahabad,Uttar Pradesh',
'Prithvipur,Allahabad,Uttar Pradesh',
'Shahipur,Allahabad,Uttar Pradesh',
'Sirsa Chauraha,Allahabad,Uttar Pradesh',
'Siyadeeh,Allahabad,Uttar Pradesh',
'Mugarshan,Allahabad,Uttar Pradesh',
'Jamunipur,Allahabad,Uttar Pradesh',
'Barethi,Allahabad,Uttar Pradesh',
'Dubawal,Allahabad,Uttar Pradesh',
'Hanumanganj,Allahabad,Uttar Pradesh',
'Hetapur,Allahabad,Uttar Pradesh',
'Jagatpur,Allahabad,Uttar Pradesh',
'Katwaroopur,Allahabad,Uttar Pradesh',
'Kotwa,Allahabad,Uttar Pradesh',
'Leelapur Kala,Allahabad,Uttar Pradesh',
'Ramaipur,Allahabad,Uttar Pradesh',
'Sarai Inayat,Allahabad,Uttar Pradesh',
'Barai Harakh,Allahabad,Uttar Pradesh',
'Bhagwatipurkhutana,Allahabad,Uttar Pradesh',
'Holagarh,Allahabad,Uttar Pradesh',
'Niyayipur,Allahabad,Uttar Pradesh',
'Purabnara,Allahabad,Uttar Pradesh',
'Sarai Madan Urf Chanti,Allahabad,Uttar Pradesh',
'Mukundpur,Allahabad,Uttar Pradesh',
'Anuwa,Allahabad,Uttar Pradesh',
'Chanethu,Allahabad,Uttar Pradesh',
'Janghai Bazar,Allahabad,Uttar Pradesh',
'Kishundaspur,Allahabad,Uttar Pradesh',
'Koraur,Allahabad,Uttar Pradesh',
'Maharchha,Allahabad,Uttar Pradesh',
'Mandwa Bazar,Allahabad,Uttar Pradesh',
'Newada,Allahabad,Uttar Pradesh',
'Nibi Bari,Allahabad,Uttar Pradesh',
'Nindula,Allahabad,Uttar Pradesh',
'Jasra,Allahabad,Uttar Pradesh',
'Patwa,Allahabad,Uttar Pradesh',
'Pipari,Allahabad,Uttar Pradesh',
'Bhatewra Kathar,Allahabad,Uttar Pradesh',
'Chhatnag,Allahabad,Uttar Pradesh',
'Chhibaiya,Allahabad,Uttar Pradesh',
'Jhunsi,Allahabad,Uttar Pradesh',
'Malawan Khurd,Allahabad,Uttar Pradesh',
'Nibi Kalan,Allahabad,Uttar Pradesh',
'Kara,Allahabad,Uttar Pradesh',
'Karchhana,Allahabad,Uttar Pradesh',
'Arai,Allahabad,Uttar Pradesh',
'Baraon,Allahabad,Uttar Pradesh',
'Bendon,Allahabad,Uttar Pradesh',
'Deora,Allahabad,Uttar Pradesh',
'Dhanaura,Allahabad,Uttar Pradesh',
'Harduwa,Allahabad,Uttar Pradesh',
'Issauta,Allahabad,Uttar Pradesh',
'Karchha R.S.,Allahabad,Uttar Pradesh',
'Konhdar,Allahabad,Uttar Pradesh',
'Mungari,Allahabad,Uttar Pradesh',
'Pathra,Allahabad,Uttar Pradesh',
'Pindi,Allahabad,Uttar Pradesh',
'Pipraon,Allahabad,Uttar Pradesh',
'Silaundhi,Allahabad,Uttar Pradesh',
'Sonai,Allahabad,Uttar Pradesh',
'Tilakhwar,Allahabad,Uttar Pradesh',
'Katra,Allahabad,Uttar Pradesh',
'Basahi,Allahabad,Uttar Pradesh',
'Bhunda,Allahabad,Uttar Pradesh',
'Birpur,Allahabad,Uttar Pradesh',
'Deeha,Allahabad,Uttar Pradesh',
'Ghodedeeh,Allahabad,Uttar Pradesh',
'Khain,Allahabad,Uttar Pradesh',
'Mahori,Allahabad,Uttar Pradesh',
'Panasa,Allahabad,Uttar Pradesh',
'Rokari,Allahabad,Uttar Pradesh',
'Ayodhya,Allahabad,Uttar Pradesh',
'Badaur,Allahabad,Uttar Pradesh',
'Badokhar,Allahabad,Uttar Pradesh',
'Beri,Allahabad,Uttar Pradesh',
'Bhageshar,Allahabad,Uttar Pradesh',
'Bisari,Allahabad,Uttar Pradesh',
'Chiraon,Allahabad,Uttar Pradesh',
'Deoghat,Allahabad,Uttar Pradesh',
'Garha,Allahabad,Uttar Pradesh',
'Handia Manpur,Allahabad,Uttar Pradesh',
'Kapasi Kalan,Allahabad,Uttar Pradesh',
'Karpia,Allahabad,Uttar Pradesh',
'Khajuri,Allahabad,Uttar Pradesh',
'Koraon,Allahabad,Uttar Pradesh',
'Kush Fara,Allahabad,Uttar Pradesh',
'Mahuli,Allahabad,Uttar Pradesh',
'Misirpur,Allahabad,Uttar Pradesh',
'Nathupur,Allahabad,Uttar Pradesh',
'Pachera,Allahabad,Uttar Pradesh',
'Paintiha,Allahabad,Uttar Pradesh',
'Ramgarh,Allahabad,Uttar Pradesh',
'Rampur Kalan,Allahabad,Uttar Pradesh',
'Saji,Allahabad,Uttar Pradesh',
'Sansarpur,Allahabad,Uttar Pradesh',
'Biharia,Allahabad,Uttar Pradesh',
'Andhiyaari,Allahabad,Uttar Pradesh',
'Rampur Kotwa,Allahabad,Uttar Pradesh',
'Lalgopal Ganj,Allahabad,Uttar Pradesh',
'Nidura,Allahabad,Uttar Pradesh',
'Parewa Narainpur,Allahabad,Uttar Pradesh',
'Piyari Urf Bijlipur,Allahabad,Uttar Pradesh',
'Bakajalalpur,Allahabad,Uttar Pradesh',
'Chhata,Allahabad,Uttar Pradesh',
'Chhitpalgarh,Allahabad,Uttar Pradesh',
'Harisenganj,Allahabad,Uttar Pradesh',
'Kiraon,Allahabad,Uttar Pradesh',
'Mehraunda,Allahabad,Uttar Pradesh',
'Mohd.Pur Gheempur,Allahabad,Uttar Pradesh',
'Nai Bazar,Allahabad,Uttar Pradesh',
'Narainganj,Allahabad,Uttar Pradesh',
'Newada,Allahabad,Uttar Pradesh',
'Siswan,Allahabad,Uttar Pradesh',
'Tejpur,Allahabad,Uttar Pradesh',
'Umariasari,Allahabad,Uttar Pradesh',
'Achhola,Allahabad,Uttar Pradesh',
'Amilia Kalan,Allahabad,Uttar Pradesh',
'Amora,Allahabad,Uttar Pradesh',
'Aunta,Allahabad,Uttar Pradesh',
'Babhani Hethar,Allahabad,Uttar Pradesh',
'Barha Kalan,Allahabad,Uttar Pradesh',
'Basahra,Allahabad,Uttar Pradesh',
'Belhat,Allahabad,Uttar Pradesh',
'Bhaganpur,Allahabad,Uttar Pradesh',
'Bhaiyan,Allahabad,Uttar Pradesh',
'Bharari,Allahabad,Uttar Pradesh',
'Bhatauti,Allahabad,Uttar Pradesh',
'Bigahuna,Allahabad,Uttar Pradesh',
'Bikikalan,Allahabad,Uttar Pradesh',
'Bilari,Allahabad,Uttar Pradesh',
'Chawki,Allahabad,Uttar Pradesh',
'Dari,Allahabad,Uttar Pradesh',
'Dohariya,Allahabad,Uttar Pradesh',
'Dubeypur,Allahabad,Uttar Pradesh',
'Gunai Gaharpur,Allahabad,Uttar Pradesh',
'Jawaniya,Allahabad,Uttar Pradesh',
'Katrauli,Allahabad,Uttar Pradesh',
'Kurki Kalan,Allahabad,Uttar Pradesh',
'Lutar,Allahabad,Uttar Pradesh',
'Madra Mukundpur,Allahabad,Uttar Pradesh',
'Masauli,Allahabad,Uttar Pradesh',
'Meja Road,Allahabad,Uttar Pradesh',
'Meja,Allahabad,Uttar Pradesh',
'Newadhiya,Allahabad,Uttar Pradesh',
'Nibaiya,Allahabad,Uttar Pradesh',
'Paranipur,Allahabad,Uttar Pradesh',
'Pasna,Allahabad,Uttar Pradesh',
'Ramnagar,Allahabad,Uttar Pradesh',
'Samhan,Allahabad,Uttar Pradesh',
'Sirsa,Allahabad,Uttar Pradesh',
'Tigza,Allahabad,Uttar Pradesh',
'Unchdeeh,Allahabad,Uttar Pradesh',
'Upraura,Allahabad,Uttar Pradesh',
'Uruwa,Allahabad,Uttar Pradesh',
'Zera,Allahabad,Uttar Pradesh',
'Gohari,Allahabad,Uttar Pradesh',
'Hathigahan,Allahabad,Uttar Pradesh',
'Ismailganj,Allahabad,Uttar Pradesh',
'Jagdishpur,Allahabad,Uttar Pradesh',
'Madhonagar Bigahia,Allahabad,Uttar Pradesh',
'Malak Harhar,Allahabad,Uttar Pradesh',
'Phaphamau,Allahabad,Uttar Pradesh',
'Sewaith,Allahabad,Uttar Pradesh',
'Bahadurgarh Arwasi,Allahabad,Uttar Pradesh',
'Chamrupur Urf Nantaut,Allahabad,Uttar Pradesh',
'Chandopara,Allahabad,Uttar Pradesh',
'Deewanganj,Allahabad,Uttar Pradesh',
'Deoli,Allahabad,Uttar Pradesh',
'Gorigon,Allahabad,Uttar Pradesh',
'Jalalpur Kasba,Allahabad,Uttar Pradesh',
'Kanethi,Allahabad,Uttar Pradesh',
'Kapsa,Allahabad,Uttar Pradesh',
'Katrauli,Allahabad,Uttar Pradesh',
'Mailahan,Allahabad,Uttar Pradesh',
'Phoolpur,Allahabad,Uttar Pradesh',
'Ramgarh Kothari,Allahabad,Uttar Pradesh',
'Prayag,Allahabad,Uttar Pradesh',
'Babhan Kuiyan,Allahabad,Uttar Pradesh',
'Belwa,Allahabad,Uttar Pradesh',
'Deonahri,Allahabad,Uttar Pradesh',
'Garapur,Allahabad,Uttar Pradesh',
'Hetapatti,Allahabad,Uttar Pradesh',
'Mendewa,Allahabad,Uttar Pradesh',
'Singra Mau,Allahabad,Uttar Pradesh',
'Umari,Allahabad,Uttar Pradesh',
'Arahkala,Allahabad,Uttar Pradesh',
'Ashey Pur,Allahabad,Uttar Pradesh',
'Basgit Bazar,Allahabad,Uttar Pradesh',
'Buir,Allahabad,Uttar Pradesh',
'Chaka,Allahabad,Uttar Pradesh',
'Dhokari,Allahabad,Uttar Pradesh',
'Dumduma,Allahabad,Uttar Pradesh',
'Khaptiha,Allahabad,Uttar Pradesh',
'Motiha,Allahabad,Uttar Pradesh',
'Sikikhurda,Allahabad,Uttar Pradesh',
'Utraon,Allahabad,Uttar Pradesh',
'Bomapur,Allahabad,Uttar Pradesh',
'Kahli,Allahabad,Uttar Pradesh',
'Kumhawa,Allahabad,Uttar Pradesh',
'Kamlanagar,Allahabad,Uttar Pradesh',
'Karnaipur,Allahabad,Uttar Pradesh',
'Sikandra,Allahabad,Uttar Pradesh',
'Badagaon,Allahabad,Uttar Pradesh',
'Bari,Allahabad,Uttar Pradesh',
'Chandpur,Allahabad,Uttar Pradesh',
'Karaundi,Allahabad,Uttar Pradesh',
'Khargapur,Allahabad,Uttar Pradesh',
'Nasratpur,Allahabad,Uttar Pradesh',
'Prem Nagar Chauraha,Allahabad,Uttar Pradesh',
'Shivgarh,Allahabad,Uttar Pradesh',
'Barasta Kalan,Allahabad,Uttar Pradesh',
'Basna,Allahabad,Uttar Pradesh',
'Bhogwara,Allahabad,Uttar Pradesh',
'Khakhaicha,Allahabad,Uttar Pradesh',
'Soron,Allahabad,Uttar Pradesh',
'Jainti,Faizabad,Uttar Pradesh',
'Bandipur,Faizabad,Uttar Pradesh',
'Bangaondihwa,Faizabad,Uttar Pradesh',
'Bariyawan,Faizabad,Uttar Pradesh',
'Bewana,Faizabad,Uttar Pradesh',
'Bhupatipur,Faizabad,Uttar Pradesh',
'Jagdishpur,Faizabad,Uttar Pradesh',
'Adampur Tiloni,Faizabad,Uttar Pradesh',
'Akbarpur H.O,Faizabad,Uttar Pradesh',
'Arjunpur,Faizabad,Uttar Pradesh',
'Ashapur,Faizabad,Uttar Pradesh',
'Bahorikpur,Faizabad,Uttar Pradesh',
'Bandan Deeh,Faizabad,Uttar Pradesh',
'Baramadpur Jariyari,Faizabad,Uttar Pradesh',
'Baramadpur Lohra,Faizabad,Uttar Pradesh',
'Baraura,Faizabad,Uttar Pradesh',
'Basohari,Faizabad,Uttar Pradesh',
'Bela,Faizabad,Uttar Pradesh',
'Benipur,Faizabad,Uttar Pradesh',
'Bhaupur,Faizabad,Uttar Pradesh',
'Bhikharipur,Faizabad,Uttar Pradesh',
'Bhiti,Faizabad,Uttar Pradesh',
'Bus Station Akbarpur,Faizabad,Uttar Pradesh',
'Chakiya,Faizabad,Uttar Pradesh',
'Chanaipur,Faizabad,Uttar Pradesh',
'Chapra,Faizabad,Uttar Pradesh',
'Chiotipara,Faizabad,Uttar Pradesh',
'Dandupur,Faizabad,Uttar Pradesh',
'Daridiha,Faizabad,Uttar Pradesh',
'Daudpur,Faizabad,Uttar Pradesh',
'Dharamganj,Faizabad,Uttar Pradesh',
'Hiri Pakaria,Faizabad,Uttar Pradesh',
'Jafarganj,Faizabad,Uttar Pradesh',
'Jaitoopur,Faizabad,Uttar Pradesh',
'Jamu Kalan,Faizabad,Uttar Pradesh',
'Kadipur Khas,Faizabad,Uttar Pradesh',
'Kalhuwa Kaura,Faizabad,Uttar Pradesh',
'Katariya Yaqubpur,Faizabad,Uttar Pradesh',
'Katehari,Faizabad,Uttar Pradesh',
'Keotahi,Faizabad,Uttar Pradesh',
'Khemapur,Faizabad,Uttar Pradesh',
'Kotwa Mohamadpur,Faizabad,Uttar Pradesh',
'Kudia Chitauna,Faizabad,Uttar Pradesh',
'Kurcha,Faizabad,Uttar Pradesh',
'Lodipur,Faizabad,Uttar Pradesh',
'Lohjhara,Faizabad,Uttar Pradesh',
'Lorpur,Faizabad,Uttar Pradesh',
'Madhupur,Faizabad,Uttar Pradesh',
'Maharajganj,Faizabad,Uttar Pradesh',
'Maharuwa Gola,Faizabad,Uttar Pradesh',
'Makhdumsarai,Faizabad,Uttar Pradesh',
'Manauri Samaisa,Faizabad,Uttar Pradesh',
'Mansapur,Faizabad,Uttar Pradesh',
'Mathani,Faizabad,Uttar Pradesh',
'Meerpur Sheikhpur,Faizabad,Uttar Pradesh',
'Mijhaura,Faizabad,Uttar Pradesh',
'Mirzapur,Faizabad,Uttar Pradesh',
'Mubarakpur Daiyadeeh,Faizabad,Uttar Pradesh',
'Mumrejpur,Faizabad,Uttar Pradesh',
'Mundehra,Faizabad,Uttar Pradesh',
'Mustafabad,Faizabad,Uttar Pradesh',
'Narharpur,Faizabad,Uttar Pradesh',
'Nasirpur,Faizabad,Uttar Pradesh',
'Naugaon,Faizabad,Uttar Pradesh',
'Paekauli Bazar,Faizabad,Uttar Pradesh',
'Pahitipur,Faizabad,Uttar Pradesh',
'Pakhanpurbichaila,Faizabad,Uttar Pradesh',
'Purebadalhi,Faizabad,Uttar Pradesh',
'Ram Nagar Karri,Faizabad,Uttar Pradesh',
'Rambaba,Faizabad,Uttar Pradesh',
'Rampur Jaisingh,Faizabad,Uttar Pradesh',
'Rampur Mungradilla,Faizabad,Uttar Pradesh',
'Rampursakarwari,Faizabad,Uttar Pradesh',
'Ratna,Faizabad,Uttar Pradesh',
'Rudaupur,Faizabad,Uttar Pradesh',
'Sahzadpur,Faizabad,Uttar Pradesh',
'Saidapur,Faizabad,Uttar Pradesh',
'Saidpur Bhitari,Faizabad,Uttar Pradesh',
'Samar Singhpur,Faizabad,Uttar Pradesh',
'Saya,Faizabad,Uttar Pradesh',
'Seehmaikarirat,Faizabad,Uttar Pradesh',
'Sehra Jalalpur,Faizabad,Uttar Pradesh',
'Semari,Faizabad,Uttar Pradesh',
'Shikrohar,Faizabad,Uttar Pradesh',
'Sijhauli,Faizabad,Uttar Pradesh',
'Songaon,Faizabad,Uttar Pradesh',
'Subhakarpur,Faizabad,Uttar Pradesh',
'Surapur,Faizabad,Uttar Pradesh',
'Tajpur,Faizabad,Uttar Pradesh',
'Tara Khurd,Faizabad,Uttar Pradesh',
'Tewaripur Sabna,Faizabad,Uttar Pradesh',
'U.P.S.S. Mill,Faizabad,Uttar Pradesh',
'Ahirauli,Faizabad,Uttar Pradesh',
'Atwari,Faizabad,Uttar Pradesh',
'Fatehpur Belabagh,Faizabad,Uttar Pradesh',
'Hath Pakar,Faizabad,Uttar Pradesh',
'Ramdas Patti,Faizabad,Uttar Pradesh',
'Sonawan,Faizabad,Uttar Pradesh',
'Ashrafpur Barwa,Faizabad,Uttar Pradesh',
'Bangaon,Faizabad,Uttar Pradesh',
'Bathua,Faizabad,Uttar Pradesh',
'Bhadar,Faizabad,Uttar Pradesh',
'Bhari Diha,Faizabad,Uttar Pradesh',
'Deohat,Faizabad,Uttar Pradesh',
'Husainpur,Faizabad,Uttar Pradesh',
'Kahi,Faizabad,Uttar Pradesh',
'Kakardilla,Faizabad,Uttar Pradesh',
'Karampur,Faizabad,Uttar Pradesh',
'Karnaipur,Faizabad,Uttar Pradesh',
'Kartora,Faizabad,Uttar Pradesh',
'Kela Lal Khan,Faizabad,Uttar Pradesh',
'Khajawan,Faizabad,Uttar Pradesh',
'Khewar,Faizabad,Uttar Pradesh',
'Kurki Bazar,Faizabad,Uttar Pradesh',
'Madarbhari,Faizabad,Uttar Pradesh',
'Malawan,Faizabad,Uttar Pradesh',
'Marthua Saraiya,Faizabad,Uttar Pradesh',
'Pariyawan,Faizabad,Uttar Pradesh',
'Parwar Bhari,Faizabad,Uttar Pradesh',
'Pratappur Chamurkha,Faizabad,Uttar Pradesh',
'Pyare Pur,Faizabad,Uttar Pradesh',
'Rampur Rampatti,Faizabad,Uttar Pradesh',
'Tendwa Paharpur,Faizabad,Uttar Pradesh',
'Umrawan,Faizabad,Uttar Pradesh',
'Yarkee,Faizabad,Uttar Pradesh',
'Achhati,Faizabad,Uttar Pradesh',
'Admapur,Faizabad,Uttar Pradesh',
'Ahirauli Ranimau,Faizabad,Uttar Pradesh',
'Akhtara Narainpur,Faizabad,Uttar Pradesh',
'Alauddinur,Faizabad,Uttar Pradesh',
'Alaupur,Faizabad,Uttar Pradesh',
'Amadarveshpur,Faizabad,Uttar Pradesh',
'Amartal,Faizabad,Uttar Pradesh',
'Annapur,Faizabad,Uttar Pradesh',
'Aribpur,Faizabad,Uttar Pradesh',
'Aribpur Ramnagar,Faizabad,Uttar Pradesh',
'Asnara,Faizabad,Uttar Pradesh',
'Bairi Buzurg,Faizabad,Uttar Pradesh',
'Baniyani,Faizabad,Uttar Pradesh',
'Bankata Bujurg,Faizabad,Uttar Pradesh',
'Baskhari,Faizabad,Uttar Pradesh',
'Bela Parsa,Faizabad,Uttar Pradesh',
'Bemaval,Faizabad,Uttar Pradesh',
'Bidhar,Faizabad,Uttar Pradesh',
'Bijli Tihayatpur,Faizabad,Uttar Pradesh',
'Bsaiya Ganga Sagar,Faizabad,Uttar Pradesh',
'Bukia,Faizabad,Uttar Pradesh',
'Chahoraghat,Faizabad,Uttar Pradesh',
'Chak Bhadaya,Faizabad,Uttar Pradesh',
'Chandipur Khurd,Faizabad,Uttar Pradesh',
'Deoria,Faizabad,Uttar Pradesh',
'Dhenkara,Faizabad,Uttar Pradesh',
'Garha,Faizabad,Uttar Pradesh',
'Gharwal,Faizabad,Uttar Pradesh',
'Gohila,Faizabad,Uttar Pradesh',
'Hanswar,Faizabad,Uttar Pradesh',
'Haridaspur,Faizabad,Uttar Pradesh',
'Hariharpur,Faizabad,Uttar Pradesh',
'Hisamuddinpur Pipra,Faizabad,Uttar Pradesh',
'Indaipur,Faizabad,Uttar Pradesh',
'Jahangirganj,Faizabad,Uttar Pradesh',
'Jamaloopur,Faizabad,Uttar Pradesh',
'Jogipur Dhanikpur,Faizabad,Uttar Pradesh',
'Kalyanpur,Faizabad,Uttar Pradesh',
'Kaurahi,Faizabad,Uttar Pradesh',
'Kawahianjanpur,Faizabad,Uttar Pradesh',
'Khamariyanghat,Faizabad,Uttar Pradesh',
'Kharuwaon,Faizabad,Uttar Pradesh',
'Lakhandih,Faizabad,Uttar Pradesh',
'Lakhanpur,Faizabad,Uttar Pradesh',
'Lakhmipur,Faizabad,Uttar Pradesh',
'Lakhnipatti,Faizabad,Uttar Pradesh',
'Lalmanpur,Faizabad,Uttar Pradesh',
'Madainiya,Faizabad,Uttar Pradesh',
'Madarmau,Faizabad,Uttar Pradesh',
'Majhgawan,Faizabad,Uttar Pradesh',
'Makoiya,Faizabad,Uttar Pradesh',
'Makrahi,Faizabad,Uttar Pradesh',
'Manikpur,Faizabad,Uttar Pradesh',
'Mubarakpurpikar,Faizabad,Uttar Pradesh',
'Mujahidpur,Faizabad,Uttar Pradesh',
'Mundiyari,Faizabad,Uttar Pradesh',
'Musepur,Faizabad,Uttar Pradesh',
'Nariyawa,Faizabad,Uttar Pradesh',
'Narwa Pitambarpur,Faizabad,Uttar Pradesh',
'Naurahni Rampur,Faizabad,Uttar Pradesh',
'Neeba,Faizabad,Uttar Pradesh',
'Nikaspur,Faizabad,Uttar Pradesh',
'Persanpur,Faizabad,Uttar Pradesh',
'Rajesultanpur,Faizabad,Uttar Pradesh',
'Ram Nagar,Faizabad,Uttar Pradesh',
'Rambag Baragaon,Faizabad,Uttar Pradesh',
'Rasoolpur Mundera,Faizabad,Uttar Pradesh',
'Sabukpur,Faizabad,Uttar Pradesh',
'Saidpur Lurvadih,Faizabad,Uttar Pradesh',
'Samdih,Faizabad,Uttar Pradesh',
'Sarawan,Faizabad,Uttar Pradesh',
'Semaur,Faizabad,Uttar Pradesh',
'Semra Nasirpur,Faizabad,Uttar Pradesh',
'Shahpur Bangawan,Faizabad,Uttar Pradesh',
'Shajana Hamjapur,Faizabad,Uttar Pradesh',
'Sheotara,Faizabad,Uttar Pradesh',
'Sikraura Kanchanpur,Faizabad,Uttar Pradesh',
'Sirsiya Jamunipur,Faizabad,Uttar Pradesh',
'Sukul Bazar,Faizabad,Uttar Pradesh',
'Sultanpur Kabirpur,Faizabad,Uttar Pradesh',
'Sutharpara,Faizabad,Uttar Pradesh',
'Tandwa Bharatpur,Faizabad,Uttar Pradesh',
'Tandwa Jalal,Faizabad,Uttar Pradesh',
'Tarauli Mubarakpur,Faizabad,Uttar Pradesh',
'Tendwai Kalan,Faizabad,Uttar Pradesh',
'Tikoria Buzurg,Faizabad,Uttar Pradesh',
'Umari Jalal,Faizabad,Uttar Pradesh',
'Yadavpur,Faizabad,Uttar Pradesh',
'Zainuddinpur,Faizabad,Uttar Pradesh',
'Ahirauli Govind Sahab,Faizabad,Uttar Pradesh',
'Ajmalpur,Faizabad,Uttar Pradesh',
'Ambarpur,Faizabad,Uttar Pradesh',
'Arai,Faizabad,Uttar Pradesh',
'Ashrafpur Majhagawan,Faizabad,Uttar Pradesh',
'Baragaon Sheikhpur,Faizabad,Uttar Pradesh',
'Barepur,Faizabad,Uttar Pradesh',
'Begikol,Faizabad,Uttar Pradesh',
'Bhadohi,Faizabad,Uttar Pradesh',
'Bhaukuwan,Faizabad,Uttar Pradesh',
'Bhiyaon,Faizabad,Uttar Pradesh',
'Bhujgi,Faizabad,Uttar Pradesh',
'Bishambharpur,Faizabad,Uttar Pradesh',
'Daulatabad,Faizabad,Uttar Pradesh',
'Deeh Bhilon,Faizabad,Uttar Pradesh',
'Dhaurua,Faizabad,Uttar Pradesh',
'Dulahoopur,Faizabad,Uttar Pradesh',
'Fatehpur,Faizabad,Uttar Pradesh',
'Gomunpur,Faizabad,Uttar Pradesh',
'Hajpura,Faizabad,Uttar Pradesh',
'Hakeem Pur,Faizabad,Uttar Pradesh',
'Ismailpur Tahepur,Faizabad,Uttar Pradesh',
'Itauri,Faizabad,Uttar Pradesh',
'Jalalpur,Faizabad,Uttar Pradesh',
'Kalepur Mahuwal,Faizabad,Uttar Pradesh',
'Kannoopur,Faizabad,Uttar Pradesh',
'Kar Misripur,Faizabad,Uttar Pradesh',
'Katgharmusa,Faizabad,Uttar Pradesh',
'Katui,Faizabad,Uttar Pradesh',
'Khajuri,Faizabad,Uttar Pradesh',
'Khalispur,Faizabad,Uttar Pradesh',
'Larpur,Faizabad,Uttar Pradesh',
'Lawaiya Pratappur,Faizabad,Uttar Pradesh',
'Machhiligaon,Faizabad,Uttar Pradesh',
'Mahulia,Faizabad,Uttar Pradesh',
'Mainpur,Faizabad,Uttar Pradesh',
'Majgaon,Faizabad,Uttar Pradesh',
'Makhdoom Baramadpur,Faizabad,Uttar Pradesh',
'Malipur,Faizabad,Uttar Pradesh',
'Marahara,Faizabad,Uttar Pradesh',
'Masorha,Faizabad,Uttar Pradesh',
'Mathia,Faizabad,Uttar Pradesh',
'Mathura Rasoolpur,Faizabad,Uttar Pradesh',
'Mokalpur,Faizabad,Uttar Pradesh',
'Nagpur,Faizabad,Uttar Pradesh',
'Nathu Pur Laudhana,Faizabad,Uttar Pradesh',
'Neori,Faizabad,Uttar Pradesh',
'Noorpur Kalan,Faizabad,Uttar Pradesh',
'Paruiya Ashram,Faizabad,Uttar Pradesh',
'Pethia,Faizabad,Uttar Pradesh',
'Pindoria,Faizabad,Uttar Pradesh',
'Rajepur Kopa,Faizabad,Uttar Pradesh',
'Rakba Amola,Faizabad,Uttar Pradesh',
'Rukunpur Kasimpur,Faizabad,Uttar Pradesh',
'Rukunuddinpur,Faizabad,Uttar Pradesh',
'Saidahi,Faizabad,Uttar Pradesh',
'Sarjupur,Faizabad,Uttar Pradesh',
'Setha Kalan,Faizabad,Uttar Pradesh',
'Sheopal,Faizabad,Uttar Pradesh',
'Sikandarpur,Faizabad,Uttar Pradesh',
'Sulhantara,Faizabad,Uttar Pradesh',
'Sulhantara,Faizabad,Uttar Pradesh',
'Sultangarh,Faizabad,Uttar Pradesh',
'Surhurpur,Faizabad,Uttar Pradesh',
'Tighara,Faizabad,Uttar Pradesh',
'Udaipur,Faizabad,Uttar Pradesh',
'Amari,Faizabad,Uttar Pradesh',
'Ainawa,Faizabad,Uttar Pradesh',
'Ajmeri Badshahpur,Faizabad,Uttar Pradesh',
'Arsawan,Faizabad,Uttar Pradesh',
'Asopur,Faizabad,Uttar Pradesh',
'Avsanpur,Faizabad,Uttar Pradesh',
'Balaiya Jagdishpur,Faizabad,Uttar Pradesh',
'Baragaon Brahimpur,Faizabad,Uttar Pradesh',
'Bharsari,Faizabad,Uttar Pradesh',
'Bhidur,Faizabad,Uttar Pradesh',
'Brahimpur Kusma,Faizabad,Uttar Pradesh',
'Chandpur,Faizabad,Uttar Pradesh',
'Chhajapur,Faizabad,Uttar Pradesh',
'Chitoi,Faizabad,Uttar Pradesh',
'Dargah Rasoolpur,Faizabad,Uttar Pradesh',
'Debipur,Faizabad,Uttar Pradesh',
'Dhiwa Daulatpur,Faizabad,Uttar Pradesh',
'Faridpur Kalan,Faizabad,Uttar Pradesh',
'Gaura Mohammadpur,Faizabad,Uttar Pradesh',
'Gayaspur Samsuddinpur,Faizabad,Uttar Pradesh',
'Hajlapur,Faizabad,Uttar Pradesh',
'Husainpur Girant,Faizabad,Uttar Pradesh',
'Husainpur Sudnaha,Faizabad,Uttar Pradesh',
'Iltifatganj,Faizabad,Uttar Pradesh',
'Jamunipur,Faizabad,Uttar Pradesh',
'Jeewat,Faizabad,Uttar Pradesh',
'Kedarnagar,Faizabad,Uttar Pradesh',
'Khaspur,Faizabad,Uttar Pradesh',
'Khukhutara,Faizabad,Uttar Pradesh',
'Kichhauccha,Faizabad,Uttar Pradesh',
'Makhdoom Nagar,Faizabad,Uttar Pradesh',
'Mubarakpur,Faizabad,Uttar Pradesh',
'Naipura,Faizabad,Uttar Pradesh',
'Nandapur,Faizabad,Uttar Pradesh',
'Paras Katui,Faizabad,Uttar Pradesh',
'Pirthivipur,Faizabad,Uttar Pradesh',
'Rampur Kalan,Faizabad,Uttar Pradesh',
'Shadipur,Faizabad,Uttar Pradesh',
'Tanda City,Faizabad,Uttar Pradesh',
'Tanda,Faizabad,Uttar Pradesh',
'Tanda Tehseel,Faizabad,Uttar Pradesh',
'Tandwa Maulai,Faizabad,Uttar Pradesh',
'Vidhut Nagar,Faizabad,Uttar Pradesh',
'Alipur,Etawah,Uttar Pradesh',
'Khetupur,Etawah,Uttar Pradesh',
'Adhasi,Etawah,Uttar Pradesh',
'Aghara,Etawah,Uttar Pradesh',
'Ajitmal,Etawah,Uttar Pradesh',
'Amaota,Etawah,Uttar Pradesh',
'Ata,Etawah,Uttar Pradesh',
'Atsoo,Etawah,Uttar Pradesh',
'Auraiya H.O,Etawah,Uttar Pradesh',
'Ayana,Etawah,Uttar Pradesh',
'Babain,Etawah,Uttar Pradesh',
'Babarpur,Etawah,Uttar Pradesh',
'Badera,Etawah,Uttar Pradesh',
'Badharipur,Etawah,Uttar Pradesh',
'Bakhriya,Etawah,Uttar Pradesh',
'Ballapur,Etawah,Uttar Pradesh',
'Bamuripur,Etawah,Uttar Pradesh',
'Belhupur,Etawah,Uttar Pradesh',
'Bhagya Nagar,Etawah,Uttar Pradesh',
'Bhareh,Etawah,Uttar Pradesh',
'Bharsen,Etawah,Uttar Pradesh',
'Bhason,Etawah,Uttar Pradesh',
'Bhaupur,Etawah,Uttar Pradesh',
'Bhikhepur,Etawah,Uttar Pradesh',
'Bhurepurkalan,Etawah,Uttar Pradesh',
'Bijhai,Etawah,Uttar Pradesh',
'Bilawan,Etawah,Uttar Pradesh',
'Binpurapur,Etawah,Uttar Pradesh',
'Birhuni,Etawah,Uttar Pradesh',
'Burhadana,Etawah,Uttar Pradesh',
'Chapta,Etawah,Uttar Pradesh',
'Chirhuli,Etawah,Uttar Pradesh',
'Dahgaon,Etawah,Uttar Pradesh',
'Dakhlipur,Etawah,Uttar Pradesh',
'Daulatpur,Etawah,Uttar Pradesh',
'Dhupkari,Etawah,Uttar Pradesh',
'Dibiapur,Etawah,Uttar Pradesh',
'Dibiapura Mandi,Etawah,Uttar Pradesh',
'Fatehpur Beni,Etawah,Uttar Pradesh',
'Gada Kasda,Etawah,Uttar Pradesh',
'Gauhani Kalan,Etawah,Uttar Pradesh',
'Gulariha,Etawah,Uttar Pradesh',
'Haidarpur,Etawah,Uttar Pradesh',
'Ikaurapur,Etawah,Uttar Pradesh',
'Jaitapur,Etawah,Uttar Pradesh',
'Janishnagar,Etawah,Uttar Pradesh',
'Jua,Etawah,Uttar Pradesh',
'Juhikha,Etawah,Uttar Pradesh',
'Kakhaotoo,Etawah,Uttar Pradesh',
'Kakor Buzurg,Etawah,Uttar Pradesh',
'Kanchausi Bazar,Etawah,Uttar Pradesh',
'Kanhausi,Etawah,Uttar Pradesh',
'Karampur,Etawah,Uttar Pradesh',
'Kariawali,Etawah,Uttar Pradesh',
'Keontra,Etawah,Uttar Pradesh',
'Khanpur,Etawah,Uttar Pradesh',
'Kharka,Etawah,Uttar Pradesh',
'Lahrapur,Etawah,Uttar Pradesh',
'Luhiapur,Etawah,Uttar Pradesh',
'Madhwapur,Etawah,Uttar Pradesh',
'Mahmoodpur,Etawah,Uttar Pradesh',
'Malhosi,Etawah,Uttar Pradesh',
'Muradganj,Etawah,Uttar Pradesh',
'Murhi,Etawah,Uttar Pradesh',
'N. T. P. C. Dibiapur,Etawah,Uttar Pradesh',
'Narainpur,Etawah,Uttar Pradesh',
'Nauli,Etawah,Uttar Pradesh',
'Navgawan,Etawah,Uttar Pradesh',
'Nigra,Etawah,Uttar Pradesh',
'Panhar,Etawah,Uttar Pradesh',
'Phaphund,Etawah,Uttar Pradesh',
'Phariha,Etawah,Uttar Pradesh',
'Piparpur,Etawah,Uttar Pradesh',
'Purakalan,Etawah,Uttar Pradesh',
'Roshangpur,Etawah,Uttar Pradesh',
'Ruruganj,Etawah,Uttar Pradesh',
'Sahabda,Etawah,Uttar Pradesh',
'Sahayal,Etawah,Uttar Pradesh',
'Salhapur,Etawah,Uttar Pradesh',
'Sanphar,Etawah,Uttar Pradesh',
'Seengpurva Mana,Etawah,Uttar Pradesh',
'Sehud,Etawah,Uttar Pradesh',
'Senganpur,Etawah,Uttar Pradesh',
'Sherpur Saraiya,Etawah,Uttar Pradesh',
'Sikharna,Etawah,Uttar Pradesh',
'Sohari Garhia,Etawah,Uttar Pradesh',
'Sondhemau,Etawah,Uttar Pradesh',
'Tilak Nagar,Etawah,Uttar Pradesh',
'Ucha,Etawah,Uttar Pradesh',
'Umri,Etawah,Uttar Pradesh',
'Achhalda,Etawah,Uttar Pradesh',
'Ailly,Etawah,Uttar Pradesh',
'Airwa Katra,Etawah,Uttar Pradesh',
'Asjana,Etawah,Uttar Pradesh',
'Badhin,Etawah,Uttar Pradesh',
'Baghaipur,Etawah,Uttar Pradesh',
'Bandhmau,Etawah,Uttar Pradesh',
'Bansi,Etawah,Uttar Pradesh',
'Banthara,Etawah,Uttar Pradesh',
'Barahar,Etawah,Uttar Pradesh',
'Barauna Kalan,Etawah,Uttar Pradesh',
'Bela,Etawah,Uttar Pradesh',
'Bhadpur,Etawah,Uttar Pradesh',
'Bhainsol,Etawah,Uttar Pradesh',
'Bhaipur,Etawah,Uttar Pradesh',
'Bhikhara,Etawah,Uttar Pradesh',
'Bidhuna,Etawah,Uttar Pradesh',
'Chhachhund,Etawah,Uttar Pradesh',
'Dashehra,Etawah,Uttar Pradesh',
'Deoraon,Etawah,Uttar Pradesh',
'Dondapur,Etawah,Uttar Pradesh',
'Gailly,Etawah,Uttar Pradesh',
'Gapchariapur,Etawah,Uttar Pradesh',
'Ghasara,Etawah,Uttar Pradesh',
'Goora,Etawah,Uttar Pradesh',
'Gwari,Etawah,Uttar Pradesh',
'Harchandpur,Etawah,Uttar Pradesh',
'Hardoo,Etawah,Uttar Pradesh',
'Harvanspur,Etawah,Uttar Pradesh',
'Indapamau,Etawah,Uttar Pradesh',
'Itailly,Etawah,Uttar Pradesh',
'Jalalpur,Etawah,Uttar Pradesh',
'Kaithawa,Etawah,Uttar Pradesh',
'Kalabhoj,Etawah,Uttar Pradesh',
'Kamara,Etawah,Uttar Pradesh',
'Kudarkot,Etawah,Uttar Pradesh',
'Kursi,Etawah,Uttar Pradesh',
'Madahadaspur,Etawah,Uttar Pradesh',
'Madokmeet,Etawah,Uttar Pradesh',
'Mahoo,Etawah,Uttar Pradesh',
'Masoodpur,Etawah,Uttar Pradesh',
'Muhammdabad,Etawah,Uttar Pradesh',
'Nagaria,Etawah,Uttar Pradesh',
'Narainpur,Etawah,Uttar Pradesh',
'Nevilganj,Etawah,Uttar Pradesh',
'Pasuwa,Etawah,Uttar Pradesh',
'Pata R.S.,Etawah,Uttar Pradesh',
'Patna Airwa,Etawah,Uttar Pradesh',
'Piprauli Shiv,Etawah,Uttar Pradesh',
'Purva Jain,Etawah,Uttar Pradesh',
'Purwa Bhikha,Etawah,Uttar Pradesh',
'Pusauli,Etawah,Uttar Pradesh',
'Rajaumau,Etawah,Uttar Pradesh',
'Rathgaon,Etawah,Uttar Pradesh',
'Rurukalan,Etawah,Uttar Pradesh',
'Sahar,Etawah,Uttar Pradesh',
'Sahbad,Etawah,Uttar Pradesh',
'Samayan,Etawah,Uttar Pradesh',
'Sarai Sheesgram,Etawah,Uttar Pradesh',
'Saraipukhta,Etawah,Uttar Pradesh',
'Shivganj,Etawah,Uttar Pradesh',
'Surendha,Etawah,Uttar Pradesh',
'Tilakpur Farm,Etawah,Uttar Pradesh',
'Umrain,Etawah,Uttar Pradesh',
'Yakubpur,Etawah,Uttar Pradesh',
'Gajendra Patti Bhidaura,Azamgarh,Uttar Pradesh',
'Amari,Azamgarh,Uttar Pradesh',
'Ataraith,Azamgarh,Uttar Pradesh',
'Ataraulia,Azamgarh,Uttar Pradesh',
'Badaya,Azamgarh,Uttar Pradesh',
'Ban Kat Jagdeesh,Azamgarh,Uttar Pradesh',
'Bansgaon,Azamgarh,Uttar Pradesh',
'Baraipur,Azamgarh,Uttar Pradesh',
'Base Pur Dandava,Azamgarh,Uttar Pradesh',
'Bhagat Pur,Azamgarh,Uttar Pradesh',
'Bhilampur Chhapra,Azamgarh,Uttar Pradesh',
'Bilari,Azamgarh,Uttar Pradesh',
'Chhitauna,Azamgarh,Uttar Pradesh',
'Daniyalpur,Azamgarh,Uttar Pradesh',
'Deora Patti,Azamgarh,Uttar Pradesh',
'Edilpur,Azamgarh,Uttar Pradesh',
'Gaura,Azamgarh,Uttar Pradesh',
'Gauri,Azamgarh,Uttar Pradesh',
'Govind Pur,Azamgarh,Uttar Pradesh',
'Huse Pur,Azamgarh,Uttar Pradesh',
'Kabiruddin Pur,Azamgarh,Uttar Pradesh',
'Kakarahi,Azamgarh,Uttar Pradesh',
'Kaudia,Azamgarh,Uttar Pradesh',
'Keshav Pur,Azamgarh,Uttar Pradesh',
'Kothwa Jalal Pur,Azamgarh,Uttar Pradesh',
'Kushmahara,Azamgarh,Uttar Pradesh',
'Lahar Par,Azamgarh,Uttar Pradesh',
'Lohara,Azamgarh,Uttar Pradesh',
'Mahagu Pur,Azamgarh,Uttar Pradesh',
'Mangit Pur,Azamgarh,Uttar Pradesh',
'Mir Pur,Azamgarh,Uttar Pradesh',
'Mokhalish Pur,Azamgarh,Uttar Pradesh',
'Nandana,Azamgarh,Uttar Pradesh',
'Pakar Deeha,Azamgarh,Uttar Pradesh',
'Pipari,Azamgarh,Uttar Pradesh',
'Rasul Pur Pasi Pur,Azamgarh,Uttar Pradesh',
'Rithia,Azamgarh,Uttar Pradesh',
'Sarain,Azamgarh,Uttar Pradesh',
'Sen Pur,Azamgarh,Uttar Pradesh',
'Tahar Wajid Pur,Azamgarh,Uttar Pradesh',
'Vinoa Puri,Azamgarh,Uttar Pradesh',
'Youdhisthirpatti.,Azamgarh,Uttar Pradesh',
'Aharaula,Azamgarh,Uttar Pradesh',
'Basahia,Azamgarh,Uttar Pradesh',
'Bharauli,Azamgarh,Uttar Pradesh',
'Bhedaura,Azamgarh,Uttar Pradesh',
'Khajuri,Azamgarh,Uttar Pradesh',
'Samsabad,Azamgarh,Uttar Pradesh',
'Koilsa,Azamgarh,Uttar Pradesh',
'Punapar,Azamgarh,Uttar Pradesh',
'Madia Par,Azamgarh,Uttar Pradesh',
'Gambhir Ban,Azamgarh,Uttar Pradesh',
'Kanaila,Azamgarh,Uttar Pradesh',
'Kisun Pur,Azamgarh,Uttar Pradesh',
'Samaida,Azamgarh,Uttar Pradesh',
'Bahadur Pur,Azamgarh,Uttar Pradesh',
'Baksh Pur,Azamgarh,Uttar Pradesh',
'Belaon,Azamgarh,Uttar Pradesh',
'Beohara,Azamgarh,Uttar Pradesh',
'Bhopalpur,Azamgarh,Uttar Pradesh',
'Bithuwa,Azamgarh,Uttar Pradesh',
'Chirkihit,Azamgarh,Uttar Pradesh',
'Dev Gaon,Azamgarh,Uttar Pradesh',
'Gambhirpur,Azamgarh,Uttar Pradesh',
'Gopalpur Sethuli,Azamgarh,Uttar Pradesh',
'Irani,Azamgarh,Uttar Pradesh',
'Jamuawan,Azamgarh,Uttar Pradesh',
'Kalicha Bad,Azamgarh,Uttar Pradesh',
'Kammar Pur,Azamgarh,Uttar Pradesh',
'Kanjahit,Azamgarh,Uttar Pradesh',
'Kariya Gopal Pur,Azamgarh,Uttar Pradesh',
'Karsara,Azamgarh,Uttar Pradesh',
'Katauli Kala,Azamgarh,Uttar Pradesh',
'Khaniara,Azamgarh,Uttar Pradesh',
'Lahuwan,Azamgarh,Uttar Pradesh',
'Lal Ganj,Azamgarh,Uttar Pradesh',
'Lasara Khurd,Azamgarh,Uttar Pradesh',
'Mohammad Pur Dharang,Azamgarh,Uttar Pradesh',
'Murhar,Azamgarh,Uttar Pradesh',
'Narsingh Pur,Azamgarh,Uttar Pradesh',
'Palhana,Azamgarh,Uttar Pradesh',
'Ram Pur Katharawa,Azamgarh,Uttar Pradesh',
'Sarai Mohan,Azamgarh,Uttar Pradesh',
'Sarai Paltu,Azamgarh,Uttar Pradesh',
'Sikraur,Azamgarh,Uttar Pradesh',
'Sri Kant Pur,Azamgarh,Uttar Pradesh',
'Tarawa,Azamgarh,Uttar Pradesh',
'Thekma,Azamgarh,Uttar Pradesh',
'Ashwania,Azamgarh,Uttar Pradesh',
'Bangaon,Azamgarh,Uttar Pradesh',
'Bardah,Azamgarh,Uttar Pradesh',
'Bargahan,Azamgarh,Uttar Pradesh',
'Bela Klichpur,Azamgarh,Uttar Pradesh',
'Bharathipur,Azamgarh,Uttar Pradesh',
'Bhawarpur,Azamgarh,Uttar Pradesh',
'Bheera,Azamgarh,Uttar Pradesh',
'Chewar Pachhim,Azamgarh,Uttar Pradesh',
'Dama,Azamgarh,Uttar Pradesh',
'Dandwal,Azamgarh,Uttar Pradesh',
'Diriapur Newada,Azamgarh,Uttar Pradesh',
'Gomadih,Azamgarh,Uttar Pradesh',
'Jaitipur,Azamgarh,Uttar Pradesh',
'Jeoli,Azamgarh,Uttar Pradesh',
'Kubakhas,Azamgarh,Uttar Pradesh',
'Maholi,Azamgarh,Uttar Pradesh',
'Mehanazpur,Azamgarh,Uttar Pradesh',
'Naurasia,Azamgarh,Uttar Pradesh',
'Nehula,Azamgarh,Uttar Pradesh',
'Pakari,Azamgarh,Uttar Pradesh',
'Safipur,Azamgarh,Uttar Pradesh',
'Salempur,Azamgarh,Uttar Pradesh',
'Sarawan,Azamgarh,Uttar Pradesh',
'Sidhauna,Azamgarh,Uttar Pradesh',
'Sihuka Abhirpur,Azamgarh,Uttar Pradesh',
'Tandadeeh,Azamgarh,Uttar Pradesh',
'Tandawa,Azamgarh,Uttar Pradesh',
'Tilkhara Pura Dani,Azamgarh,Uttar Pradesh',
'Ubarpur,Azamgarh,Uttar Pradesh',
'Udiawan,Azamgarh,Uttar Pradesh',
'Bansgaon,Azamgarh,Uttar Pradesh',
'Bindra Bazar,Azamgarh,Uttar Pradesh',
'Deeha,Azamgarh,Uttar Pradesh',
'Mujaffarpur,Azamgarh,Uttar Pradesh',
'Pandaha,Azamgarh,Uttar Pradesh',
'Aira Bujurg,Azamgarh,Uttar Pradesh',
'Babu Ki Khajuri,Azamgarh,Uttar Pradesh',
'Bachhawal,Azamgarh,Uttar Pradesh',
'Benupur,Azamgarh,Uttar Pradesh',
'Bibipur,Azamgarh,Uttar Pradesh',
'Bisham,Azamgarh,Uttar Pradesh',
'Dewait,Azamgarh,Uttar Pradesh',
'Gaura,Azamgarh,Uttar Pradesh',
'Gopalpur,Azamgarh,Uttar Pradesh',
'Haraura,Azamgarh,Uttar Pradesh',
'Hardaspur,Azamgarh,Uttar Pradesh',
'Kalanderpur,Azamgarh,Uttar Pradesh',
'Kamahariya,Azamgarh,Uttar Pradesh',
'Karauti,Azamgarh,Uttar Pradesh',
'Khargpur,Azamgarh,Uttar Pradesh',
'Kharihani,Azamgarh,Uttar Pradesh',
'Mangrawa,Azamgarh,Uttar Pradesh',
'Mehnagar,Azamgarh,Uttar Pradesh',
'Nai,Azamgarh,Uttar Pradesh',
'Pawani Kala,Azamgarh,Uttar Pradesh',
'Phulaieh Khajura,Azamgarh,Uttar Pradesh',
'Pithaupur Rasti,Azamgarh,Uttar Pradesh',
'Rasoolpur,Azamgarh,Uttar Pradesh',
'Renda,Azamgarh,Uttar Pradesh',
'Singhpur,Azamgarh,Uttar Pradesh',
'Uchahuwan,Azamgarh,Uttar Pradesh',
'Beenapara,Azamgarh,Uttar Pradesh',
'Niauj,Azamgarh,Uttar Pradesh',
'Chhaon,Azamgarh,Uttar Pradesh',
'Dayalpur,Azamgarh,Uttar Pradesh',
'Ranipur Razamo,Azamgarh,Uttar Pradesh',
'Abusaidpur,Azamgarh,Uttar Pradesh',
'Ambarpur,Azamgarh,Uttar Pradesh',
'Badagaon,Azamgarh,Uttar Pradesh',
'Badaharia,Azamgarh,Uttar Pradesh',
'Badasara Aima,Azamgarh,Uttar Pradesh',
'Badasara Khalsa,Azamgarh,Uttar Pradesh',
'Bairampur,Azamgarh,Uttar Pradesh',
'Barikhas,Azamgarh,Uttar Pradesh',
'Bhimal Patti,Azamgarh,Uttar Pradesh',
'Bhuidharpur,Azamgarh,Uttar Pradesh',
'Fariha,Azamgarh,Uttar Pradesh',
'Firuddin Pur,Azamgarh,Uttar Pradesh',
'Gahaji,Azamgarh,Uttar Pradesh',
'Jamalpur,Azamgarh,Uttar Pradesh',
'Khaliasemari,Azamgarh,Uttar Pradesh',
'Khutia,Azamgarh,Uttar Pradesh',
'Kisundaspur,Azamgarh,Uttar Pradesh',
'Kujiyari,Azamgarh,Uttar Pradesh',
'Madharsia,Azamgarh,Uttar Pradesh',
'Maniyar Pur,Azamgarh,Uttar Pradesh',
'Meh Mauni,Azamgarh,Uttar Pradesh',
'Mirja Pur,Azamgarh,Uttar Pradesh',
'Mohammad Pur,Azamgarh,Uttar Pradesh',
'Mohanath,Azamgarh,Uttar Pradesh',
'Nandaon,Azamgarh,Uttar Pradesh',
'Nardah,Azamgarh,Uttar Pradesh',
'Nizamabad,Azamgarh,Uttar Pradesh',
'Ora,Azamgarh,Uttar Pradesh',
'Rajapur Sikaraur,Azamgarh,Uttar Pradesh',
'Sanjar Pur,Azamgarh,Uttar Pradesh',
'Saraimeer,Azamgarh,Uttar Pradesh',
'Shiwali,Azamgarh,Uttar Pradesh',
'Sodhari,Azamgarh,Uttar Pradesh',
'Tika Pur,Azamgarh,Uttar Pradesh',
'Towa,Azamgarh,Uttar Pradesh',
'Zamin Katghar,Azamgarh,Uttar Pradesh',
'Chandabhari,Azamgarh,Uttar Pradesh',
'Gandhuai,Azamgarh,Uttar Pradesh',
'Ambari,Azamgarh,Uttar Pradesh',
'Bahauddinpur.,Azamgarh,Uttar Pradesh',
'Bhani Pur,Azamgarh,Uttar Pradesh',
'Chitara Mahamud Pur,Azamgarh,Uttar Pradesh',
'Didarganj,Azamgarh,Uttar Pradesh',
'Fulesh,Azamgarh,Uttar Pradesh',
'Galib Pur,Azamgarh,Uttar Pradesh',
'Godhana,Azamgarh,Uttar Pradesh',
'Guwai,Azamgarh,Uttar Pradesh',
'Hubbi Ganj,Azamgarh,Uttar Pradesh',
'Khairuddinpur,Azamgarh,Uttar Pradesh',
'Kohanda,Azamgarh,Uttar Pradesh',
'Mahul,Azamgarh,Uttar Pradesh',
'Malgaon,Azamgarh,Uttar Pradesh',
'Mir Ahmedpur Sahjada,Azamgarh,Uttar Pradesh',
'Mittupur,Azamgarh,Uttar Pradesh',
'Oril,Azamgarh,Uttar Pradesh',
'Palia Maphi,Azamgarh,Uttar Pradesh',
'Pawai,Azamgarh,Uttar Pradesh',
'Phool Pur,Azamgarh,Uttar Pradesh',
'Phool Pur Town,Azamgarh,Uttar Pradesh',
'Sukhi Pur,Azamgarh,Uttar Pradesh',
'Sumhadeeh,Azamgarh,Uttar Pradesh',
'Surahan,Azamgarh,Uttar Pradesh',
'Bhadaon,Azamgarh,Uttar Pradesh',
'Ahirauli,Azamgarh,Uttar Pradesh',
'Babu Ki Basti,Azamgarh,Uttar Pradesh',
'Bakhara,Azamgarh,Uttar Pradesh',
'Balaipur,Azamgarh,Uttar Pradesh',
'Banbirpur,Azamgarh,Uttar Pradesh',
'Barauna,Azamgarh,Uttar Pradesh',
'Bhormau,Azamgarh,Uttar Pradesh',
'Bunda,Azamgarh,Uttar Pradesh',
'Buxpur Mejawa,Azamgarh,Uttar Pradesh',
'Chhittepur,Azamgarh,Uttar Pradesh',
'Dharmdaspur Newada,Azamgarh,Uttar Pradesh',
'Dubara,Azamgarh,Uttar Pradesh',
'Durbasa,Azamgarh,Uttar Pradesh',
'Faridpur,Azamgarh,Uttar Pradesh',
'Ishapur,Azamgarh,Uttar Pradesh',
'Jagdishpur,Azamgarh,Uttar Pradesh',
'Kalafatpur,Azamgarh,Uttar Pradesh',
'Karui,Azamgarh,Uttar Pradesh',
'Kaura Gahani,Azamgarh,Uttar Pradesh',
'Khandaura,Azamgarh,Uttar Pradesh',
'Khanjahan Pur,Azamgarh,Uttar Pradesh',
'Khurasan,Azamgarh,Uttar Pradesh',
'Khutauli,Azamgarh,Uttar Pradesh',
'Loniadeeh,Azamgarh,Uttar Pradesh',
'Mahuja Newada,Azamgarh,Uttar Pradesh',
'Martin Ganj,Azamgarh,Uttar Pradesh',
'Mundiyar,Azamgarh,Uttar Pradesh',
'Mundwar,Azamgarh,Uttar Pradesh',
'Mutkallipur,Azamgarh,Uttar Pradesh',
'Naharpur,Azamgarh,Uttar Pradesh',
'Nauhara,Azamgarh,Uttar Pradesh',
'Nurvey,Azamgarh,Uttar Pradesh',
'Palthi,Azamgarh,Uttar Pradesh',
'Pichhaura,Azamgarh,Uttar Pradesh',
'Raida,Azamgarh,Uttar Pradesh',
'Rangdih,Azamgarh,Uttar Pradesh',
'Sikaraur Sahabari,Azamgarh,Uttar Pradesh',
'Sonhara,Azamgarh,Uttar Pradesh',
'Pushpnagar,Azamgarh,Uttar Pradesh',
'Sohauli,Azamgarh,Uttar Pradesh',
'Rama Pur,Azamgarh,Uttar Pradesh',
'Ajampur,Azamgarh,Uttar Pradesh',
'Amilo,Azamgarh,Uttar Pradesh',
'Ashona,Azamgarh,Uttar Pradesh',
'Azamgarh City,Azamgarh,Uttar Pradesh',
'Azamgarh H.O,Azamgarh,Uttar Pradesh',
'Azamgarh Kachhehari,,Azamgarh,Uttar Pradesh',
'Azamgarh, R.S,Azamgarh,Uttar Pradesh',
'Badaura,Azamgarh,Uttar Pradesh',
'Baddo Pur,Azamgarh,Uttar Pradesh',
'Bamhaur,Azamgarh,Uttar Pradesh',
'Barahalaganj,Azamgarh,Uttar Pradesh',
'Basgit,Azamgarh,Uttar Pradesh',
'Bhagwat,Azamgarh,Uttar Pradesh',
'Bhangaha,Azamgarh,Uttar Pradesh',
'Bhavar Nath,Azamgarh,Uttar Pradesh',
'Bhujahi,Azamgarh,Uttar Pradesh',
'Bibipur,Azamgarh,Uttar Pradesh',
'Bind Mathia,Azamgarh,Uttar Pradesh',
'Chak Inami,Azamgarh,Uttar Pradesh',
'Chandai,Azamgarh,Uttar Pradesh',
'Chandesar,Azamgarh,Uttar Pradesh',
'Daulatabad,Azamgarh,Uttar Pradesh',
'Dharwara,Azamgarh,Uttar Pradesh',
'Gauri Narayanpur,Azamgarh,Uttar Pradesh',
'Gopal Pur Sadar,Azamgarh,Uttar Pradesh',
'Gujar Par,Azamgarh,Uttar Pradesh',
'Hafiz Pur,Azamgarh,Uttar Pradesh',
'Harra Ki Chungi,Azamgarh,Uttar Pradesh',
'Hira Patti,Azamgarh,Uttar Pradesh',
'Jahana Ganj,Azamgarh,Uttar Pradesh',
'Jamal Pur,Azamgarh,Uttar Pradesh',
'Jigar Sandi,Azamgarh,Uttar Pradesh',
'Jolhapur,Azamgarh,Uttar Pradesh',
'Kandhara Pur,Azamgarh,Uttar Pradesh',
'Karisath,Azamgarh,Uttar Pradesh',
'Kerama,Azamgarh,Uttar Pradesh',
'Khoulukhor,Azamgarh,Uttar Pradesh',
'Koilari,Azamgarh,Uttar Pradesh',
'Koilari,Azamgarh,Uttar Pradesh',
'Kote,Azamgarh,Uttar Pradesh',
'Kotila.,Azamgarh,Uttar Pradesh',
'Lapsipur,Azamgarh,Uttar Pradesh',
'Lohara,Azamgarh,Uttar Pradesh',
'Maharaj Pur,Azamgarh,Uttar Pradesh',
'Mahuyamurarpur,Azamgarh,Uttar Pradesh',
'Mande,Azamgarh,Uttar Pradesh',
'Mataulipur,Azamgarh,Uttar Pradesh',
'Mittupur,Azamgarh,Uttar Pradesh',
'Mohamdalla,Azamgarh,Uttar Pradesh',
'Mubarak Pur,Azamgarh,Uttar Pradesh',
'Nasiruddinpur,Azamgarh,Uttar Pradesh',
'Pahi,Azamgarh,Uttar Pradesh',
'Palhani,Azamgarh,Uttar Pradesh',
'Parasi,Azamgarh,Uttar Pradesh',
'Patkhauli,Azamgarh,Uttar Pradesh',
'Punargi,Azamgarh,Uttar Pradesh',
'Rani Ki Sarai,Azamgarh,Uttar Pradesh',
'Rasepur,Azamgarh,Uttar Pradesh',
'Raut Mau,Azamgarh,Uttar Pradesh',
'Sathion,Azamgarh,Uttar Pradesh',
'Sema,Azamgarh,Uttar Pradesh',
'Sewata,Azamgarh,Uttar Pradesh',
'Shah Garh,Azamgarh,Uttar Pradesh',
'Shbili,Azamgarh,Uttar Pradesh',
'Sherpur,Azamgarh,Uttar Pradesh',
'Shethawal,Azamgarh,Uttar Pradesh',
'Sidhari,,Azamgarh,Uttar Pradesh',
'Sirsal,Azamgarh,Uttar Pradesh',
'Sutarahi,Azamgarh,Uttar Pradesh',
'Tamauli,Azamgarh,Uttar Pradesh',
'Tegar Pur,Azamgarh,Uttar Pradesh',
'Uchagaon,Azamgarh,Uttar Pradesh',
'Zafarpur,Azamgarh,Uttar Pradesh',
'Ajagara Masharki,Azamgarh,Uttar Pradesh',
'Ajaji Dewara Karkhia,Azamgarh,Uttar Pradesh',
'Ajamat Garh Estate,Azamgarh,Uttar Pradesh',
'Amuwari,Azamgarh,Uttar Pradesh',
'Anjam Shhid,Azamgarh,Uttar Pradesh',
'Araji Amani,Azamgarh,Uttar Pradesh',
'Baijabari,Azamgarh,Uttar Pradesh',
'Bankat,Azamgarh,Uttar Pradesh',
'Bankatia,Azamgarh,Uttar Pradesh',
'Bardiha,Azamgarh,Uttar Pradesh',
'Barohi Fetahpur,Azamgarh,Uttar Pradesh',
'Bazar Gosain,Azamgarh,Uttar Pradesh',
'Berama,Azamgarh,Uttar Pradesh',
'Bhaisha,Azamgarh,Uttar Pradesh',
'Bhimbar,Azamgarh,Uttar Pradesh',
'Bilaria Ganj,Azamgarh,Uttar Pradesh',
'Bindawal,Azamgarh,Uttar Pradesh',
'Chaklal Chand,Azamgarh,Uttar Pradesh',
'Chan Patti,Azamgarh,Uttar Pradesh',
'Chewata,Azamgarh,Uttar Pradesh',
'Chhapra Sultanpur,Azamgarh,Uttar Pradesh',
'Chhattarpur Khushahal,Azamgarh,Uttar Pradesh',
'Chhihi,Azamgarh,Uttar Pradesh',
'Dewara Jadid,Azamgarh,Uttar Pradesh',
'Dewara Jadidi,Azamgarh,Uttar Pradesh',
'Dewara Khas Raja,Azamgarh,Uttar Pradesh',
'Dighwania Kaji,Azamgarh,Uttar Pradesh',
'Dighwania Majhuwa,Azamgarh,Uttar Pradesh',
'Emalipur,Azamgarh,Uttar Pradesh',
'Esmail Pir,Azamgarh,Uttar Pradesh',
'Gaddopur,Azamgarh,Uttar Pradesh',
'Garerua,Azamgarh,Uttar Pradesh',
'Haidarabad,Azamgarh,Uttar Pradesh',
'Haji Pur,Azamgarh,Uttar Pradesh',
'Haraia,Azamgarh,Uttar Pradesh',
'Harkhpura Khas,Azamgarh,Uttar Pradesh',
'Jagdishpur,Azamgarh,Uttar Pradesh',
'Jairajpur,Azamgarh,Uttar Pradesh',
'Jameel Pur,Azamgarh,Uttar Pradesh',
'Jameen Bilari,Azamgarh,Uttar Pradesh',
'Jameen Harkhori,Azamgarh,Uttar Pradesh',
'Jameen Rasulpur,Azamgarh,Uttar Pradesh',
'Jiyanpur,Azamgarh,Uttar Pradesh',
'Jokhara,Azamgarh,Uttar Pradesh',
'Jurarampur,Azamgarh,Uttar Pradesh',
'Kakarahatta,Azamgarh,Uttar Pradesh',
'Karkhia Rutam Sarai,Azamgarh,Uttar Pradesh',
'Khalispur,Azamgarh,Uttar Pradesh',
'Khan Pur Bhagatpatti,Azamgarh,Uttar Pradesh',
'Lat Ghat,Azamgarh,Uttar Pradesh',
'Lilapatti Bankatia,Azamgarh,Uttar Pradesh',
'Luchui,Azamgarh,Uttar Pradesh',
'Maharaj Ganj,Azamgarh,Uttar Pradesh',
'Mahesh Pur,Azamgarh,Uttar Pradesh',
'Mahulia Bojhia,Azamgarh,Uttar Pradesh',
'Mandanpur,Azamgarh,Uttar Pradesh',
'Matia,Azamgarh,Uttar Pradesh',
'Maukutubpur,Azamgarh,Uttar Pradesh',
'Mohmmadpur,Azamgarh,Uttar Pradesh',
'Molana Pur,Azamgarh,Uttar Pradesh',
'Naraipur,Azamgarh,Uttar Pradesh',
'Narhankhas,Azamgarh,Uttar Pradesh',
'Nauwarar Dewara Jadid,Azamgarh,Uttar Pradesh',
'Newada,Azamgarh,Uttar Pradesh',
'Pach Khaura,Azamgarh,Uttar Pradesh',
'Patila Gaosh Pur,Azamgarh,Uttar Pradesh',
'Patwadh Kautuk,Azamgarh,Uttar Pradesh',
'Pihar,Azamgarh,Uttar Pradesh',
'Ramgarh,Azamgarh,Uttar Pradesh',
'Rasulpur Nandalal,Azamgarh,Uttar Pradesh',
'Rauna Par,Azamgarh,Uttar Pradesh',
'Sagari,Azamgarh,Uttar Pradesh',
'Sardaha,Azamgarh,Uttar Pradesh',
'Shekhupur,Azamgarh,Uttar Pradesh',
'Shivpur,Azamgarh,Uttar Pradesh',
'Singhwara,Azamgarh,Uttar Pradesh',
'Sirahi,Azamgarh,Uttar Pradesh',
'Tahir Pur,Azamgarh,Uttar Pradesh',
'Tarauka,Azamgarh,Uttar Pradesh',
'Terahi,Azamgarh,Uttar Pradesh',
'Urdiha,Azamgarh,Uttar Pradesh',
'Vijayapar,Azamgarh,Uttar Pradesh',
'Maltari,Azamgarh,Uttar Pradesh',
'Ahera,Meerut,Uttar Pradesh',
'Badarkha,Meerut,Uttar Pradesh',
'Baghpat,Meerut,Uttar Pradesh',
'Baghpat Sugar Mill,Meerut,Uttar Pradesh',
'Chhaprauli,Meerut,Uttar Pradesh',
'Dhikauli,Meerut,Uttar Pradesh',
'Doghat,Meerut,Uttar Pradesh',
'Gandhi Chowk Baraut,Meerut,Uttar Pradesh',
'Khatta,Meerut,Uttar Pradesh',
'Kurri,Meerut,Uttar Pradesh',
'Sisana,Meerut,Uttar Pradesh',
'Agarwal Mandi,Meerut,Uttar Pradesh',
'Alwalpur,Meerut,Uttar Pradesh',
'Aminagar Sarai,Meerut,Uttar Pradesh',
'Asara,Meerut,Uttar Pradesh',
'Asarfabad Thal,Meerut,Uttar Pradesh',
'Azampur Mulsam,Meerut,Uttar Pradesh',
'Bali,Meerut,Uttar Pradesh',
'Bamnauli,Meerut,Uttar Pradesh',
'Baoli,Meerut,Uttar Pradesh',
'Baragaon,Meerut,Uttar Pradesh',
'Baraut H.O,Meerut,Uttar Pradesh',
'Barawad,Meerut,Uttar Pradesh',
'Barka,Meerut,Uttar Pradesh',
'Barnawa,Meerut,Uttar Pradesh',
'Barwala,Meerut,Uttar Pradesh',
'Basaudh,Meerut,Uttar Pradesh',
'Basauli,Meerut,Uttar Pradesh',
'Bassi,Meerut,Uttar Pradesh',
'Bazidpur,Meerut,Uttar Pradesh',
'Begmabad Garhi,Meerut,Uttar Pradesh',
'Bhagot,Meerut,Uttar Pradesh',
'Bharal,Meerut,Uttar Pradesh',
'Bijrol,Meerut,Uttar Pradesh',
'Bijwara,Meerut,Uttar Pradesh',
'Bilochpura,Meerut,Uttar Pradesh',
'Binauli,Meerut,Uttar Pradesh',
'Bodha,Meerut,Uttar Pradesh',
'Budhera,Meerut,Uttar Pradesh',
'Budhpur,Meerut,Uttar Pradesh',
'Budhsaini,Meerut,Uttar Pradesh',
'Chamrawal,Meerut,Uttar Pradesh',
'Chandyan,Meerut,Uttar Pradesh',
'Chaubli,Meerut,Uttar Pradesh',
'Daha,Meerut,Uttar Pradesh',
'Daula,Meerut,Uttar Pradesh',
'Dhanaura Silver Nagar,Meerut,Uttar Pradesh',
'Dhanaura Tikri,Meerut,Uttar Pradesh',
'Dhikana,Meerut,Uttar Pradesh',
'Dohja,Meerut,Uttar Pradesh',
'Duttnagar,Meerut,Uttar Pradesh',
'Faizpur Ninana,Meerut,Uttar Pradesh',
'Fakharpur,Meerut,Uttar Pradesh',
'Fatehpur Poothi,Meerut,Uttar Pradesh',
'Fazalpur,Meerut,Uttar Pradesh',
'Gaidbara,Meerut,Uttar Pradesh',
'Galheta,Meerut,Uttar Pradesh',
'Garhi,Meerut,Uttar Pradesh',
'Garhi Hazurabad,Meerut,Uttar Pradesh',
'Garhi Kalanjiri,Meerut,Uttar Pradesh',
'Gauripur,Meerut,Uttar Pradesh',
'Ghitora,Meerut,Uttar Pradesh',
'Gothra,Meerut,Uttar Pradesh',
'Gunga Kheri,Meerut,Uttar Pradesh',
'Gurana,Meerut,Uttar Pradesh',
'Gwali Khera,Meerut,Uttar Pradesh',
'Hewa,Meerut,Uttar Pradesh',
'Hilwari,Meerut,Uttar Pradesh',
'Hisauda,Meerut,Uttar Pradesh',
'Ibrahimpur Mazra,Meerut,Uttar Pradesh',
'Idrishpur,Meerut,Uttar Pradesh',
'Jaunmana,Meerut,Uttar Pradesh',
'Jhundpur,Meerut,Uttar Pradesh',
'Jiwana,Meerut,Uttar Pradesh',
'Jiwana,Meerut,Uttar Pradesh',
'Johri,Meerut,Uttar Pradesh',
'Kakor Kalan,Meerut,Uttar Pradesh',
'Kakripur,Meerut,Uttar Pradesh',
'Kandera,Meerut,Uttar Pradesh',
'Kanhar,Meerut,Uttar Pradesh',
'Kasimpur Khari,Meerut,Uttar Pradesh',
'Khatta Prahladpur,Meerut,Uttar Pradesh',
'Khekra,Meerut,Uttar Pradesh',
'Khera Hatana,Meerut,Uttar Pradesh',
'Kherki,Meerut,Uttar Pradesh',
'Khwaja Nagla,Meerut,Uttar Pradesh',
'Kirthal,Meerut,Uttar Pradesh',
'Kishanpur Baral,Meerut,Uttar Pradesh',
'Kotana,Meerut,Uttar Pradesh',
'Lalyana,Meerut,Uttar Pradesh',
'Lohadda,Meerut,Uttar Pradesh',
'Luhari,Meerut,Uttar Pradesh',
'Lumb,Meerut,Uttar Pradesh',
'Malakpur,Meerut,Uttar Pradesh',
'Mawi Kalan,Meerut,Uttar Pradesh',
'Mitli,Meerut,Uttar Pradesh',
'Mozizabad Nangal,Meerut,Uttar Pradesh',
'Mubarikpur,Meerut,Uttar Pradesh',
'Muzaffarpur Kanwara,Meerut,Uttar Pradesh',
'Muzampur Kamala,Meerut,Uttar Pradesh',
'Nai Mandi Baraut,Meerut,Uttar Pradesh',
'Nehru Rd. Baraut,Meerut,Uttar Pradesh',
'Nerojpur Gujar,Meerut,Uttar Pradesh',
'Nibali,Meerut,Uttar Pradesh',
'Nirpura,Meerut,Uttar Pradesh',
'Pabla Begmabad,Meerut,Uttar Pradesh',
'Palra,Meerut,Uttar Pradesh',
'Palri,Meerut,Uttar Pradesh',
'Phulera,Meerut,Uttar Pradesh',
'Pilana,Meerut,Uttar Pradesh',
'Pusar,Meerut,Uttar Pradesh',
'Rajpur Khampur,Meerut,Uttar Pradesh',
'Ram Nagar,Meerut,Uttar Pradesh',
'Ramala,Meerut,Uttar Pradesh',
'Ranchhar,Meerut,Uttar Pradesh',
'Rataul,Meerut,Uttar Pradesh',
'Rathaura,Meerut,Uttar Pradesh',
'Rly. Road Khekra,Meerut,Uttar Pradesh',
'Sabga,Meerut,Uttar Pradesh',
'Sadiqpur Sinoli,Meerut,Uttar Pradesh',
'Sankrodh,Meerut,Uttar Pradesh',
'Sarurpur Kalan,Meerut,Uttar Pradesh',
'Shahpur Banoli,Meerut,Uttar Pradesh',
'Sherpur Luhari,Meerut,Uttar Pradesh',
'Shikohpur,Meerut,Uttar Pradesh',
'Singhaoli Ahir,Meerut,Uttar Pradesh',
'Sirsalgarh,Meerut,Uttar Pradesh',
'Soop,Meerut,Uttar Pradesh',
'Sujra,Meerut,Uttar Pradesh',
'Sujti,Meerut,Uttar Pradesh',
'Sunehra,Meerut,Uttar Pradesh',
'Teodhi,Meerut,Uttar Pradesh',
'Tera,Meerut,Uttar Pradesh',
'Tikri,Meerut,Uttar Pradesh',
'Titroda,Meerut,Uttar Pradesh',
'Tugana,Meerut,Uttar Pradesh',
'Saidbhar,Meerut,Uttar Pradesh',
'Silana,Meerut,Uttar Pradesh',
'Sirsali,Meerut,Uttar Pradesh',
'Ailo,Bahraich,Uttar Pradesh',
'Aliabulbul,Bahraich,Uttar Pradesh',
'Bahrai R.S.,Bahraich,Uttar Pradesh',
'Bahraich City,Bahraich,Uttar Pradesh',
'Bahraich H.O,Bahraich,Uttar Pradesh',
'Basanera,Bahraich,Uttar Pradesh',
'Begampur,Bahraich,Uttar Pradesh',
'Bhausawan,Bahraich,Uttar Pradesh',
'Bisheswarganj,Bahraich,Uttar Pradesh',
'Chaukhariya,Bahraich,Uttar Pradesh',
'Chhwani Bazar,Bahraich,Uttar Pradesh',
'Chilwaria,Bahraich,Uttar Pradesh',
'Chittuara,Bahraich,Uttar Pradesh',
'Dargah,Bahraich,Uttar Pradesh',
'Dhauli,Bahraich,Uttar Pradesh',
'Diha,Bahraich,Uttar Pradesh',
'Farda Sumerpur,Bahraich,Uttar Pradesh',
'Ganga Jamuni,Bahraich,Uttar Pradesh',
'Gangwal,Bahraich,Uttar Pradesh',
'Gudari Bazar,Bahraich,Uttar Pradesh',
'Jhingha Road,Bahraich,Uttar Pradesh',
'Kalpipara,Bahraich,Uttar Pradesh',
'Kashijot,Bahraich,Uttar Pradesh',
'Katra Bahadurpur,Bahraich,Uttar Pradesh',
'Khanpur Mallah,Bahraich,Uttar Pradesh',
'Khariha,Bahraich,Uttar Pradesh',
'Kot Bazar,Bahraich,Uttar Pradesh',
'Kursaha,Bahraich,Uttar Pradesh',
'Lakkharampur,Bahraich,Uttar Pradesh',
'Lalpur,Bahraich,Uttar Pradesh',
'Laukahi,Bahraich,Uttar Pradesh',
'Mankapur Kala,Bahraich,Uttar Pradesh',
'Metkaha,Bahraich,Uttar Pradesh',
'Mohammad Nagar,Bahraich,Uttar Pradesh',
'Payagpur Bus Station,Bahraich,Uttar Pradesh',
'Payagpur,Bahraich,Uttar Pradesh',
'Puraina,Bahraich,Uttar Pradesh',
'Qanoongopura,Bahraich,Uttar Pradesh',
'Ramnagar Khajuri,Bahraich,Uttar Pradesh',
'Raniapur Gobrahi,Bahraich,Uttar Pradesh',
'Reoli,Bahraich,Uttar Pradesh',
'Satpediya,Bahraich,Uttar Pradesh',
'Semariyawan,Bahraich,Uttar Pradesh',
'Shivdaha,Bahraich,Uttar Pradesh',
'Shivpur Bairagi,Bahraich,Uttar Pradesh',
'Sohariyawan,Bahraich,Uttar Pradesh',
'Soharwa,Bahraich,Uttar Pradesh',
'Station Road,Bahraich,Uttar Pradesh',
'Tallab Baghel,Bahraich,Uttar Pradesh',
'Turahni Rajjab,Bahraich,Uttar Pradesh',
'Ikauna,Bahraich,Uttar Pradesh',
'Babhnanpurwa,Bahraich,Uttar Pradesh',
'Badrauli,Bahraich,Uttar Pradesh',
'Birahimpur,Bahraich,Uttar Pradesh',
'Gandara,Bahraich,Uttar Pradesh',
'Gorahia,Bahraich,Uttar Pradesh',
'Naugoia,Bahraich,Uttar Pradesh',
'Tappah Sipah,Bahraich,Uttar Pradesh',
'Ailiha,Bahraich,Uttar Pradesh',
'Arai Umari,Bahraich,Uttar Pradesh',
'Babkapur,Bahraich,Uttar Pradesh',
'Badholi,Bahraich,Uttar Pradesh',
'Balchandpur,Bahraich,Uttar Pradesh',
'Bamiyari,Bahraich,Uttar Pradesh',
'Basantapur,Bahraich,Uttar Pradesh',
'Baundi,Bahraich,Uttar Pradesh',
'Belwa Padum,Bahraich,Uttar Pradesh',
'Bhaggarwa,Bahraich,Uttar Pradesh',
'Bhangha,Bahraich,Uttar Pradesh',
'Bhartha,Bahraich,Uttar Pradesh',
'Bhilora Basu,Bahraich,Uttar Pradesh',
'Chakujot,Bahraich,Uttar Pradesh',
'Dahaura,Bahraich,Uttar Pradesh',
'Fakharpur,Bahraich,Uttar Pradesh',
'Gajadharpur,Bahraich,Uttar Pradesh',
'Gujra,Bahraich,Uttar Pradesh',
'Gureharipur,Bahraich,Uttar Pradesh',
'Haiveriya,Bahraich,Uttar Pradesh',
'Harchanda,Bahraich,Uttar Pradesh',
'Hariharpur,Bahraich,Uttar Pradesh',
'Huzoorpur,Bahraich,Uttar Pradesh',
'Imilia,Bahraich,Uttar Pradesh',
'Jagtapur,Bahraich,Uttar Pradesh',
'Jaitapur,Bahraich,Uttar Pradesh',
'Jarwal Road,Bahraich,Uttar Pradesh',
'Jarwal,Bahraich,Uttar Pradesh',
'Jataura,Bahraich,Uttar Pradesh',
'Jiganiamahipal,Bahraich,Uttar Pradesh',
'Kaiserganj,Bahraich,Uttar Pradesh',
'Kandra,Bahraich,Uttar Pradesh',
'Katghara Kala,Bahraich,Uttar Pradesh',
'Katka Bhagatpurwa,Bahraich,Uttar Pradesh',
'Kaudha,Bahraich,Uttar Pradesh',
'Khairabazar,Bahraich,Uttar Pradesh',
'Khanpur,Bahraich,Uttar Pradesh',
'Khapurwa,Bahraich,Uttar Pradesh',
'Kundasar,Bahraich,Uttar Pradesh',
'Kundaspara,Bahraich,Uttar Pradesh',
'Madhavpur,Bahraich,Uttar Pradesh',
'Maholi,Bahraich,Uttar Pradesh',
'Mahuri Kala,Bahraich,Uttar Pradesh',
'Maila Saraiya,Bahraich,Uttar Pradesh',
'Majhanwa Takuli,Bahraich,Uttar Pradesh',
'Meerpur Koniya,Bahraich,Uttar Pradesh',
'Mundki,Bahraich,Uttar Pradesh',
'Mustafabad,Bahraich,Uttar Pradesh',
'Naiwashi,Bahraich,Uttar Pradesh',
'Nandwal,Bahraich,Uttar Pradesh',
'Narounda,Bahraich,Uttar Pradesh',
'Parsendi,Bahraich,Uttar Pradesh',
'Parsia,Bahraich,Uttar Pradesh',
'Patupur,Bahraich,Uttar Pradesh',
'Payrepur,Bahraich,Uttar Pradesh',
'Piparia Mahipal Singh,Bahraich,Uttar Pradesh',
'Raipura,Bahraich,Uttar Pradesh',
'Ramgarhi,Bahraich,Uttar Pradesh',
'Rani Bazar,Bahraich,Uttar Pradesh',
'Sarai Jagna,Bahraich,Uttar Pradesh',
'Sarsa,Bahraich,Uttar Pradesh',
'Shukulpurwa,Bahraich,Uttar Pradesh',
'Singhpur,Bahraich,Uttar Pradesh',
'Sutaouli,Bahraich,Uttar Pradesh',
'Tendwa Mahant,Bahraich,Uttar Pradesh',
'Umari,Bahraich,Uttar Pradesh',
'Vairi Maheshpur,Bahraich,Uttar Pradesh',
'Bakaina Bazar,Bahraich,Uttar Pradesh',
'Bhabnoti Shankarpur,Bahraich,Uttar Pradesh',
'Chok Sahar,Bahraich,Uttar Pradesh',
'Curaipurwa,Bahraich,Uttar Pradesh',
'Fattepur,Bahraich,Uttar Pradesh',
'Gadamar Kuurd,Bahraich,Uttar Pradesh',
'Gopchandpur,Bahraich,Uttar Pradesh',
'Hardi,Bahraich,Uttar Pradesh',
'Jot Chandpara,Bahraich,Uttar Pradesh',
'Kapoorpur,Bahraich,Uttar Pradesh',
'Kharighat,Bahraich,Uttar Pradesh',
'Khasha Mohd.Pur,Bahraich,Uttar Pradesh',
'Kishunpur Meetha,Bahraich,Uttar Pradesh',
'Lakkha Baundi,Bahraich,Uttar Pradesh',
'Mahasi,Bahraich,Uttar Pradesh',
'Mahasi Tahsil,Bahraich,Uttar Pradesh',
'Maikupurwa,Bahraich,Uttar Pradesh',
'Maurauwa Bazar,Bahraich,Uttar Pradesh',
'Mukeria,Bahraich,Uttar Pradesh',
'Nautala,Bahraich,Uttar Pradesh',
'Newada,Bahraich,Uttar Pradesh',
'Pachdevri,Bahraich,Uttar Pradesh',
'Pipri,Bahraich,Uttar Pradesh',
'Raipur,Bahraich,Uttar Pradesh',
'Rajapur Kalan,Bahraich,Uttar Pradesh',
'Rampurwa,Bahraich,Uttar Pradesh',
'Rehuwa Mansoor,Bahraich,Uttar Pradesh',
'Sablapur,Bahraich,Uttar Pradesh',
'Sadhuwapur,Bahraich,Uttar Pradesh',
'Sasia Chunamani,Bahraich,Uttar Pradesh',
'Shekhdahir,Bahraich,Uttar Pradesh',
'Sikandarpur,Bahraich,Uttar Pradesh',
'Vanshpurwa,Bahraich,Uttar Pradesh',
'Barnapur,Bahraich,Uttar Pradesh',
'Tandwabasantpur,Bahraich,Uttar Pradesh',
'Garethi Gurudutt Singh,Bahraich,Uttar Pradesh',
'Raza Bazar,Bahraich,Uttar Pradesh',
'Ambarpur,Bahraich,Uttar Pradesh',
'Amwa Molvi,Bahraich,Uttar Pradesh',
'Amwa Pokhar,Bahraich,Uttar Pradesh',
'Argorwa,Bahraich,Uttar Pradesh',
'Aswa Mohd.Pur,Bahraich,Uttar Pradesh',
'Babaganj,Bahraich,Uttar Pradesh',
'Baibahi,Bahraich,Uttar Pradesh',
'Balai Goan,Bahraich,Uttar Pradesh',
'Balbhaddrapur,Bahraich,Uttar Pradesh',
'Baldoopurwa,Bahraich,Uttar Pradesh',
'Balha,Bahraich,Uttar Pradesh',
'Balsinghpur,Bahraich,Uttar Pradesh',
'Banjaria,Bahraich,Uttar Pradesh',
'Banjaria,Bahraich,Uttar Pradesh',
'Bankashi,Bahraich,Uttar Pradesh',
'Bardaha,Bahraich,Uttar Pradesh',
'Barkharia,Bahraich,Uttar Pradesh',
'Basantapur,Bahraich,Uttar Pradesh',
'Belhan,Bahraich,Uttar Pradesh',
'Bhaukhara,Bahraich,Uttar Pradesh',
'Bhawaniapur,Bahraich,Uttar Pradesh',
'Bhopatpur,Bahraich,Uttar Pradesh',
'Bichhiya,Bahraich,Uttar Pradesh',
'Bitania,Bahraich,Uttar Pradesh',
'Botania,Bahraich,Uttar Pradesh',
'Boundi,Bahraich,Uttar Pradesh',
'Bulbul Newaj,Bahraich,Uttar Pradesh',
'Chafaria Bazar,Bahraich,Uttar Pradesh',
'Chahalwa,Bahraich,Uttar Pradesh',
'Chamarpurwa,Bahraich,Uttar Pradesh',
'Chandanpur K. Pur,Bahraich,Uttar Pradesh',
'Charda,Bahraich,Uttar Pradesh',
'Dandey Kuinya,Bahraich,Uttar Pradesh',
'Daulatpur,Bahraich,Uttar Pradesh',
'Deorania,Bahraich,Uttar Pradesh',
'Devra,Bahraich,Uttar Pradesh',
'Dhannigaon,Bahraich,Uttar Pradesh',
'Dharampur,Bahraich,Uttar Pradesh',
'Dharmanpur,Bahraich,Uttar Pradesh',
'Dharmapur,Bahraich,Uttar Pradesh',
'Dihwa,Bahraich,Uttar Pradesh',
'Fakirpuri,Bahraich,Uttar Pradesh',
'Gaighat,Bahraich,Uttar Pradesh',
'Gangapur,Bahraich,Uttar Pradesh',
'Gaurapipra,Bahraich,Uttar Pradesh',
'Girdharpur,Bahraich,Uttar Pradesh',
'Girijapuri Coloney,Bahraich,Uttar Pradesh',
'Goorh,Bahraich,Uttar Pradesh',
'Gopia,Bahraich,Uttar Pradesh',
'Gotutti,Bahraich,Uttar Pradesh',
'Govindpur Pandit,Bahraich,Uttar Pradesh',
'Gurghutta,Bahraich,Uttar Pradesh',
'Handa Basehri,Bahraich,Uttar Pradesh',
'Hardutt Nagar,Bahraich,Uttar Pradesh',
'Harkhapur,Bahraich,Uttar Pradesh',
'Intaha,Bahraich,Uttar Pradesh',
'J. Bhawanipur,Bahraich,Uttar Pradesh',
'Jalalpur,Bahraich,Uttar Pradesh',
'Kakraha,Bahraich,Uttar Pradesh',
'Kakri,Bahraich,Uttar Pradesh',
'Karanpur,Bahraich,Uttar Pradesh',
'Karikot,Bahraich,Uttar Pradesh',
'Katraniaghat,Bahraich,Uttar Pradesh',
'Kewalpur,Bahraich,Uttar Pradesh',
'Kewalpur,Bahraich,Uttar Pradesh',
'Khaira Dhaukal,Bahraich,Uttar Pradesh',
'Khaira Kala,Bahraich,Uttar Pradesh',
'Kotwa,Bahraich,Uttar Pradesh',
'Kundwa,Bahraich,Uttar Pradesh',
'Lakhai Kalan,Bahraich,Uttar Pradesh',
'Laluhi,Bahraich,Uttar Pradesh',
'Lohiya Nagar,Bahraich,Uttar Pradesh',
'Madhavpur Nidaona,Bahraich,Uttar Pradesh',
'Madhwapur,Bahraich,Uttar Pradesh',
'Maina Newaria,Bahraich,Uttar Pradesh',
'Majhara,Bahraich,Uttar Pradesh',
'Makanpur,Bahraich,Uttar Pradesh',
'Mangouriha,Bahraich,Uttar Pradesh',
'Manikpur,Bahraich,Uttar Pradesh',
'Mansoor Nagar,Bahraich,Uttar Pradesh',
'Manwaria Diwan,Bahraich,Uttar Pradesh',
'Matehi,Bahraich,Uttar Pradesh',
'Matera Kalan,Bahraich,Uttar Pradesh',
'Matera RS,Bahraich,Uttar Pradesh',
'Mihinpurwa,Bahraich,Uttar Pradesh',
'Moharba,Bahraich,Uttar Pradesh',
'Motipur,Bahraich,Uttar Pradesh',
'Murtiha,Bahraich,Uttar Pradesh',
'Nainiha,Bahraich,Uttar Pradesh',
'Nanpara Bazar,Bahraich,Uttar Pradesh',
'Nanpara R.S.,Bahraich,Uttar Pradesh',
'Nanpara,Bahraich,Uttar Pradesh',
'Naruttampur,Bahraich,Uttar Pradesh',
'Nausurgumtiha,Bahraich,Uttar Pradesh',
'Nawab Ganj Alia Bad,Bahraich,Uttar Pradesh',
'Newada,Bahraich,Uttar Pradesh',
'Nidhipurwa,Bahraich,Uttar Pradesh',
'Nisangora,Bahraich,Uttar Pradesh',
'P.B. Bux,Bahraich,Uttar Pradesh',
'Pakara Deoria,Bahraich,Uttar Pradesh',
'Pandri Tara,Bahraich,Uttar Pradesh',
'Pargahawa,Bahraich,Uttar Pradesh',
'Parwani Gauri,Bahraich,Uttar Pradesh',
'Patna Ghesiyari,Bahraich,Uttar Pradesh',
'Patrahiya,Bahraich,Uttar Pradesh',
'Petraha,Bahraich,Uttar Pradesh',
'Prahalad Gaon,Bahraich,Uttar Pradesh',
'Pratappur Jungal Matera,Bahraich,Uttar Pradesh',
'Rahmatogaon,Bahraich,Uttar Pradesh',
'Raibojha,Bahraich,Uttar Pradesh',
'Raiganj,Bahraich,Uttar Pradesh',
'Raipur,Bahraich,Uttar Pradesh',
'Rajapur Kala,Bahraich,Uttar Pradesh',
'Ram Nagar Semara,Bahraich,Uttar Pradesh',
'Rampur Dhobia,Bahraich,Uttar Pradesh',
'Risia,Bahraich,Uttar Pradesh',
'Rupaidiha,Bahraich,Uttar Pradesh',
'Sangwa,Bahraich,Uttar Pradesh',
'Saraa Kalan,Bahraich,Uttar Pradesh',
'Sarra Maundri,Bahraich,Uttar Pradesh',
'Sarraiya,Bahraich,Uttar Pradesh',
'Semari Bazar,Bahraich,Uttar Pradesh',
'Shahpur Kalan,Bahraich,Uttar Pradesh',
'Shankarpur,Bahraich,Uttar Pradesh',
'Shankarpur Laxmanpur,Bahraich,Uttar Pradesh',
'Shivpur,Bahraich,Uttar Pradesh',
'Sohbatia,Bahraich,Uttar Pradesh',
'Sujauli,Bahraich,Uttar Pradesh',
'Tiwari Gaon,Bahraich,Uttar Pradesh',
'Umaria,Bahraich,Uttar Pradesh',
'Urra Bazar,Bahraich,Uttar Pradesh',
'Jamui,Ballia,Uttar Pradesh',
'Kaithauli,Ballia,Uttar Pradesh',
'Achalgarh,Ballia,Uttar Pradesh',
'Babubel,Ballia,Uttar Pradesh',
'Baghaunch,Ballia,Uttar Pradesh',
'Bahuara,Ballia,Uttar Pradesh',
'Bairia,Ballia,Uttar Pradesh',
'Balihar,Ballia,Uttar Pradesh',
'Bhagwanpur,Ballia,Uttar Pradesh',
'Bhopalpur,Ballia,Uttar Pradesh',
'Chakia,Ballia,Uttar Pradesh',
'Chand Diar,Ballia,Uttar Pradesh',
'Chandpur,Ballia,Uttar Pradesh',
'Chheridih,Ballia,Uttar Pradesh',
'Dalchapra,Ballia,Uttar Pradesh',
'Dallan Chhapra,Ballia,Uttar Pradesh',
'Daya Chhapra,Ballia,Uttar Pradesh',
'Dokati,Ballia,Uttar Pradesh',
'Dubey Chhapra,Ballia,Uttar Pradesh',
'Durjanpur,Ballia,Uttar Pradesh',
'Gangapur,Ballia,Uttar Pradesh',
'Gonhia Chapra,Ballia,Uttar Pradesh',
'Gopalnagar,Ballia,Uttar Pradesh',
'Ibrahima Bad,Ballia,Uttar Pradesh',
'Ibrahimabad Uprwar,Ballia,Uttar Pradesh',
'Jagdeva,Ballia,Uttar Pradesh',
'Jai Prakash Nagar,Ballia,Uttar Pradesh',
'Jamalpur,Ballia,Uttar Pradesh',
'Jawahi,Ballia,Uttar Pradesh',
'Jawahi Dear,Ballia,Uttar Pradesh',
'Jharkataha,Ballia,Uttar Pradesh',
'Karanchhapa,Ballia,Uttar Pradesh',
'Karmanpur,Ballia,Uttar Pradesh',
'Kodahara Uparwar,Ballia,Uttar Pradesh',
'Lalganj,Ballia,Uttar Pradesh',
'Laxman Chapra,Ballia,Uttar Pradesh',
'Madhubani,Ballia,Uttar Pradesh',
'Moonchapra,Ballia,Uttar Pradesh',
'Murli Chhapra,Ballia,Uttar Pradesh',
'Narayengarh,Ballia,Uttar Pradesh',
'Pandey Pur,Ballia,Uttar Pradesh',
'Ram Nagar,Ballia,Uttar Pradesh',
'Raniganj Bazar,Ballia,Uttar Pradesh',
'Rudrapur,Ballia,Uttar Pradesh',
'Sawan Chapra,Ballia,Uttar Pradesh',
'Semaria,Ballia,Uttar Pradesh',
'Shobha Chapra,Ballia,Uttar Pradesh',
'Sonaki Bhat,Ballia,Uttar Pradesh',
'Sonbarsa,Ballia,Uttar Pradesh',
'Sri Nagar,Ballia,Uttar Pradesh',
'Sripalpur,Ballia,Uttar Pradesh',
'Suremanpur,Ballia,Uttar Pradesh',
'Suryabhanpur,Ballia,Uttar Pradesh',
'Tengarihi,Ballia,Uttar Pradesh',
'Agrauli,Ballia,Uttar Pradesh',
'Akhar,Ballia,Uttar Pradesh',
'Akhtiyarpur,Ballia,Uttar Pradesh',
'Amaon,Ballia,Uttar Pradesh',
'Amghat,Ballia,Uttar Pradesh',
'Anjorpur,Ballia,Uttar Pradesh',
'Baghuna,Ballia,Uttar Pradesh',
'Baheri,Ballia,Uttar Pradesh',
'Ballia City,Ballia,Uttar Pradesh',
'Ballia H.O,Ballia,Uttar Pradesh',
'Bansdih Road,Ballia,Uttar Pradesh',
'Barhwalia,Ballia,Uttar Pradesh',
'Basantpur,Ballia,Uttar Pradesh',
'Basarik Pah,Ballia,Uttar Pradesh',
'Belahari,Ballia,Uttar Pradesh',
'Bharauli,Ballia,Uttar Pradesh',
'Bharsar,Ballia,Uttar Pradesh',
'Bhriguashram,Ballia,Uttar Pradesh',
'Bisukia,Ballia,Uttar Pradesh',
'Chaura,Ballia,Uttar Pradesh',
'Cherueyan,Ballia,Uttar Pradesh',
'Chhata,Ballia,Uttar Pradesh',
'Chitbaragaon,Ballia,Uttar Pradesh',
'Civillines,Ballia,Uttar Pradesh',
'Daulatpur,Ballia,Uttar Pradesh',
'Dawani,Ballia,Uttar Pradesh',
'Deokali,Ballia,Uttar Pradesh',
'Dighar,Ballia,Uttar Pradesh',
'Dubhar,Ballia,Uttar Pradesh',
'Dumari,Ballia,Uttar Pradesh',
'Garwar,Ballia,Uttar Pradesh',
'Haldi,Ballia,Uttar Pradesh',
'Hanumanganj,Ballia,Uttar Pradesh',
'Hariharpur,Ballia,Uttar Pradesh',
'Jagdishpur,Ballia,Uttar Pradesh',
'Janari,Ballia,Uttar Pradesh',
'Janaupur,Ballia,Uttar Pradesh',
'Jigini,Ballia,Uttar Pradesh',
'Kanchanpur,Ballia,Uttar Pradesh',
'Karnai,Ballia,Uttar Pradesh',
'Karon,Ballia,Uttar Pradesh',
'Katharia,Ballia,Uttar Pradesh',
'Kharahatar,Ballia,Uttar Pradesh',
'Khoripakar,Ballia,Uttar Pradesh',
'Korantadih,Ballia,Uttar Pradesh',
'Kotwa Narayenpur,Ballia,Uttar Pradesh',
'Kummhaila,Ballia,Uttar Pradesh',
'Kurejee,Ballia,Uttar Pradesh',
'Majhauli,Ballia,Uttar Pradesh',
'Majhua,Ballia,Uttar Pradesh',
'Middha,Ballia,Uttar Pradesh',
'Nagwa,Ballia,Uttar Pradesh',
'Narhi,Ballia,Uttar Pradesh',
'Nasirpurkalan,Ballia,Uttar Pradesh',
'Pachkhora,Ballia,Uttar Pradesh',
'Phehpana,Ballia,Uttar Pradesh',
'Piprakal;a,Ballia,Uttar Pradesh',
'Piyaraunta,Ballia,Uttar Pradesh',
'Raghunath Pur Piparpatti,Ballia,Uttar Pradesh',
'Ramgarh,Ballia,Uttar Pradesh',
'Rampur Chit,Ballia,Uttar Pradesh',
'Ratsar,Ballia,Uttar Pradesh',
'Repura,Ballia,Uttar Pradesh',
'Sagarpali,Ballia,Uttar Pradesh',
'Saharaspali,Ballia,Uttar Pradesh',
'Salempur,Ballia,Uttar Pradesh',
'Sanwaru Bandh,Ballia,Uttar Pradesh',
'Saraya,Ballia,Uttar Pradesh',
'Shahidpark,Ballia,Uttar Pradesh',
'Shahpur,Ballia,Uttar Pradesh',
'Sher,Ballia,Uttar Pradesh',
'Shivpur Datiwar,Ballia,Uttar Pradesh',
'Shivpur Dier,Ballia,Uttar Pradesh',
'Singhpur,Ballia,Uttar Pradesh',
'Sitakund,Ballia,Uttar Pradesh',
'Sonwani,Ballia,Uttar Pradesh',
'Surahi,Ballia,Uttar Pradesh',
'Suryapura,Ballia,Uttar Pradesh',
'T.D.College,Ballia,Uttar Pradesh',
'Takarsand,Ballia,Uttar Pradesh',
'Thamhanpura,Ballia,Uttar Pradesh',
'Tikhampur,Ballia,Uttar Pradesh',
'Tutuwari,Ballia,Uttar Pradesh',
'Zeera Basti,Ballia,Uttar Pradesh',
'Apail,Ballia,Uttar Pradesh',
'Bakawan,Ballia,Uttar Pradesh',
'Bansdih,Ballia,Uttar Pradesh',
'Barasari Jageer,Ballia,Uttar Pradesh',
'Beruarbari,Ballia,Uttar Pradesh',
'Bharakhara,Ballia,Uttar Pradesh',
'Bhikharia,Ballia,Uttar Pradesh',
'Bhojchapra,Ballia,Uttar Pradesh',
'Bigahi,Ballia,Uttar Pradesh',
'Binaha,Ballia,Uttar Pradesh',
'Bisauli,Ballia,Uttar Pradesh',
'Chhotaki Seriya,Ballia,Uttar Pradesh',
'Chnd Pur,Ballia,Uttar Pradesh',
'Deodih,Ballia,Uttar Pradesh',
'Dhanauti,Ballia,Uttar Pradesh',
'Dumariya,Ballia,Uttar Pradesh',
'Gaighat,Ballia,Uttar Pradesh',
'Halpur,Ballia,Uttar Pradesh',
'Hardattpur,Ballia,Uttar Pradesh',
'Hariahan Kalan,Ballia,Uttar Pradesh',
'Husainabad,Ballia,Uttar Pradesh',
'Karammar,Ballia,Uttar Pradesh',
'Kewara,Ballia,Uttar Pradesh',
'Kharauni,Ballia,Uttar Pradesh',
'Kheosar,Ballia,Uttar Pradesh',
'Kirtupur,Ballia,Uttar Pradesh',
'Kusaura,Ballia,Uttar Pradesh',
'Kusauri,Ballia,Uttar Pradesh',
'Mairitar,Ballia,Uttar Pradesh',
'Malhaua Chorkaind,Ballia,Uttar Pradesh',
'Maniar,Ballia,Uttar Pradesh',
'Manikpur,Ballia,Uttar Pradesh',
'Muradih,Ballia,Uttar Pradesh',
'Muriyari,Ballia,Uttar Pradesh',
'Parvatpur,Ballia,Uttar Pradesh',
'Puras,Ballia,Uttar Pradesh',
'Rajpur,Ballia,Uttar Pradesh',
'Rampur,Ballia,Uttar Pradesh',
'Reoti,Ballia,Uttar Pradesh',
'Rohuan,Ballia,Uttar Pradesh',
'Sahatwar,Ballia,Uttar Pradesh',
'Sakarpura,Ballia,Uttar Pradesh',
'Sukhpura,Ballia,Uttar Pradesh',
'Sultanpur,Ballia,Uttar Pradesh',
'V.B.Narayanpur,Ballia,Uttar Pradesh',
'Sahodih,Ballia,Uttar Pradesh',
'Dudhaila Kalan,Ballia,Uttar Pradesh',
'Jamuaon,Ballia,Uttar Pradesh',
'Akhop,Ballia,Uttar Pradesh',
'Auria Kalan,Ballia,Uttar Pradesh',
'Bahorawan,Ballia,Uttar Pradesh',
'Banspar Bahorwa,Ballia,Uttar Pradesh',
'Barauli,Ballia,Uttar Pradesh',
'Bhimpura,Ballia,Uttar Pradesh',
'Bilthara Bazar,Ballia,Uttar Pradesh',
'Chainpur Gulaura,Ballia,Uttar Pradesh',
'Chandi,Ballia,Uttar Pradesh',
'Indauli,Ballia,Uttar Pradesh',
'Inds0,Ballia,Uttar Pradesh',
'Jiutpura,Ballia,Uttar Pradesh',
'Kundail,Ballia,Uttar Pradesh',
'Parasia,Ballia,Uttar Pradesh',
'Pasuhari,Ballia,Uttar Pradesh',
'Sarya Dihu Bhagat,Ballia,Uttar Pradesh',
'Sonadih,Ballia,Uttar Pradesh',
'Tadi Bada Gaon,Ballia,Uttar Pradesh',
'Turtipar,Ballia,Uttar Pradesh',
'Ubhaon,Ballia,Uttar Pradesh',
'Farsatar,Ballia,Uttar Pradesh',
'Piparauli,Ballia,Uttar Pradesh',
'Sikarhata,Ballia,Uttar Pradesh',
'Telma,Ballia,Uttar Pradesh',
'Lahasani,Ballia,Uttar Pradesh',
'Barawan Ratipatti,Ballia,Uttar Pradesh',
'Babhanauli,Ballia,Uttar Pradesh',
'Bahuta Chak Upadhyay,Ballia,Uttar Pradesh',
'Bhimpura,Ballia,Uttar Pradesh',
'Bhujaini,Ballia,Uttar Pradesh',
'Bilthra Road RS,Ballia,Uttar Pradesh',
'Chandadih,Ballia,Uttar Pradesh',
'Charauan,Ballia,Uttar Pradesh',
'Gauapar,Ballia,Uttar Pradesh',
'Govindpur,Ballia,Uttar Pradesh',
'Haldi Rampur,Ballia,Uttar Pradesh',
'Jajauli No-2,Ballia,Uttar Pradesh',
'Kasoundar,Ballia,Uttar Pradesh',
'Khandwa,Ballia,Uttar Pradesh',
'Kidihirapur,Ballia,Uttar Pradesh',
'Mahari,Ballia,Uttar Pradesh',
'Mohammadpur,Ballia,Uttar Pradesh',
'Palia Khas,Ballia,Uttar Pradesh',
'Patoi,Ballia,Uttar Pradesh',
'Rachauli,Ballia,Uttar Pradesh',
'Rampur Kanungoa,Ballia,Uttar Pradesh',
'Rupwar Bhagwanpur,Ballia,Uttar Pradesh',
'Semaria,Ballia,Uttar Pradesh',
'Sisyandkala,Ballia,Uttar Pradesh',
'Udharan,Ballia,Uttar Pradesh',
'Uskar,Ballia,Uttar Pradesh',
'Visrup,Ballia,Uttar Pradesh',
'Awayen,Ballia,Uttar Pradesh',
'Ibrahimpatti,Ballia,Uttar Pradesh',
'Amahara,Ballia,Uttar Pradesh',
'Amaharpatti Uttar,Ballia,Uttar Pradesh',
'Asanwar,Ballia,Uttar Pradesh',
'Atarsua,Ballia,Uttar Pradesh',
'Athialapura,Ballia,Uttar Pradesh',
'Atrauli,Ballia,Uttar Pradesh',
'Aundi,Ballia,Uttar Pradesh',
'Bachhaipur,Ballia,Uttar Pradesh',
'Baijalpur,Ballia,Uttar Pradesh',
'Bhelai,Ballia,Uttar Pradesh',
'Biharaharpur,Ballia,Uttar Pradesh',
'Birpura,Ballia,Uttar Pradesh',
'Budhuan,Ballia,Uttar Pradesh',
'Chachaya,Ballia,Uttar Pradesh',
'Chandrawar,Ballia,Uttar Pradesh',
'Chhibbi,Ballia,Uttar Pradesh',
'Chilkahar,Ballia,Uttar Pradesh',
'Chintamanpur,Ballia,Uttar Pradesh',
'Deoriha,Ballia,Uttar Pradesh',
'Dumari,Ballia,Uttar Pradesh',
'Gopalpur,Ballia,Uttar Pradesh',
'Gothain,Ballia,Uttar Pradesh',
'Hajauli,Ballia,Uttar Pradesh',
'Isari Salempur,Ballia,Uttar Pradesh',
'Jam,Ballia,Uttar Pradesh',
'Kajhari,Ballia,Uttar Pradesh',
'Khanwar,Ballia,Uttar Pradesh',
'Khari,Ballia,Uttar Pradesh',
'Kharuaon,Ballia,Uttar Pradesh',
'Kodai,Ballia,Uttar Pradesh',
'Kopawan,Ballia,Uttar Pradesh',
'Kotwari,Ballia,Uttar Pradesh',
'Kurem,Ballia,Uttar Pradesh',
'Maharajpur,Ballia,Uttar Pradesh',
'Malapharsenpur,Ballia,Uttar Pradesh',
'Mundera,Ballia,Uttar Pradesh',
'Nagahar,Ballia,Uttar Pradesh',
'Nagpur,Ballia,Uttar Pradesh',
'Nagra,Ballia,Uttar Pradesh',
'Nanaura,Ballia,Uttar Pradesh',
'Naraon,Ballia,Uttar Pradesh',
'Narhi,Ballia,Uttar Pradesh',
'Nawapura,Ballia,Uttar Pradesh',
'Nikasi,Ballia,Uttar Pradesh',
'Parasia,Ballia,Uttar Pradesh',
'Pradhanpur,Ballia,Uttar Pradesh',
'Rampur,Ballia,Uttar Pradesh',
'Rasoolpur,Ballia,Uttar Pradesh',
'Rasra H.O,Ballia,Uttar Pradesh',
'Rasra Town,Ballia,Uttar Pradesh',
'Sanwara,Ballia,Uttar Pradesh',
'Saraybharti,Ballia,Uttar Pradesh',
'Sardaspur,Ballia,Uttar Pradesh',
'Sarya Bagdaura,Ballia,Uttar Pradesh',
'Sawan,Ballia,Uttar Pradesh',
'Sikariyan Kalan,Ballia,Uttar Pradesh',
'Sinhachawar,Ballia,Uttar Pradesh',
'Siswar,Ballia,Uttar Pradesh',
'Sohaon,Ballia,Uttar Pradesh',
'Sultanpur,Ballia,Uttar Pradesh',
'Takha,Ballia,Uttar Pradesh',
'Tikadeori,Ballia,Uttar Pradesh',
'Uchera,Ballia,Uttar Pradesh',
'Kazipur,Ballia,Uttar Pradesh',
'Bachhapar,Ballia,Uttar Pradesh',
'Chak Usaraila,Ballia,Uttar Pradesh',
'Asan,Ballia,Uttar Pradesh',
'Balupur,Ballia,Uttar Pradesh',
'Banahra,Ballia,Uttar Pradesh',
'Bara Gaon,Ballia,Uttar Pradesh',
'Charawan Barwan,Ballia,Uttar Pradesh',
'Chetankishor,Ballia,Uttar Pradesh',
'Dihwa,Ballia,Uttar Pradesh',
'Ekail,Ballia,Uttar Pradesh',
'Gosain Pur,Ballia,Uttar Pradesh',
'Hathaunj,Ballia,Uttar Pradesh',
'Jagadara,Ballia,Uttar Pradesh',
'Jigirasand,Ballia,Uttar Pradesh',
'Karmauta,Ballia,Uttar Pradesh',
'Pakari,Ballia,Uttar Pradesh',
'Panicha,Ballia,Uttar Pradesh',
'Prasadpur,Ballia,Uttar Pradesh',
'Thohilpali,Ballia,Uttar Pradesh',
'Ukachhi,Ballia,Uttar Pradesh',
'Usasa,Ballia,Uttar Pradesh',
'Baghuri,Ballia,Uttar Pradesh',
'Bahadura,Ballia,Uttar Pradesh',
'Bharthaon,Ballia,Uttar Pradesh',
'Deokali,Ballia,Uttar Pradesh',
'Dhoridih,Ballia,Uttar Pradesh',
'Duhabihra,Ballia,Uttar Pradesh',
'Garhmalpur,Ballia,Uttar Pradesh',
'Isarpitha Patti,Ballia,Uttar Pradesh',
'Jajauli,Ballia,Uttar Pradesh',
'Karsi,Ballia,Uttar Pradesh',
'Kathaura,Ballia,Uttar Pradesh',
'Kharasara,Ballia,Uttar Pradesh',
'Khathghara,Ballia,Uttar Pradesh',
'Khejuri,Ballia,Uttar Pradesh',
'Koth,Ballia,Uttar Pradesh',
'Lilkar,Ballia,Uttar Pradesh',
'Masoompur,Ballia,Uttar Pradesh',
'Nanhul,Ballia,Uttar Pradesh',
'Nawanagar,Ballia,Uttar Pradesh',
'Pandah,Ballia,Uttar Pradesh',
'Pur,Ballia,Uttar Pradesh',
'Ratsi Mehmanpur,Ballia,Uttar Pradesh',
'Rudrawar,Ballia,Uttar Pradesh',
'Sikanderpur Bus Stand,Ballia,Uttar Pradesh',
'Sikanderpur,Ballia,Uttar Pradesh',
'Sisotar,Ballia,Uttar Pradesh',
'Siwankala,Ballia,Uttar Pradesh',
'Mathura Bazar,Gonda,Uttar Pradesh',
'Sriduttganj,Gonda,Uttar Pradesh',
'Badalpur,Gonda,Uttar Pradesh',
'Bahre Kuiya,Gonda,Uttar Pradesh',
'Balrampur City,Gonda,Uttar Pradesh',
'Balrampur Degree College,Gonda,Uttar Pradesh',
'Balrampur H.O,Gonda,Uttar Pradesh',
'Bargadhi,Gonda,Uttar Pradesh',
'Beer Pur Khairaniya,Gonda,Uttar Pradesh',
'Belha,Gonda,Uttar Pradesh',
'Bhagautiganj,Gonda,Uttar Pradesh',
'Bhangaha Hussain Nagar,Gonda,Uttar Pradesh',
'Bhatpurwa,Gonda,Uttar Pradesh',
'Bhatpurwa Kala,Gonda,Uttar Pradesh',
'Bheekh Pur,Gonda,Uttar Pradesh',
'Birahin Pur,Gonda,Uttar Pradesh',
'Bishunipur,Gonda,Uttar Pradesh',
'Bishunpur Bel Bharia,Gonda,Uttar Pradesh',
'Deoria,Gonda,Uttar Pradesh',
'Deoria Rani Jot,Gonda,Uttar Pradesh',
'Farenda,Gonda,Uttar Pradesh',
'Gajaihwa,Gonda,Uttar Pradesh',
'Gulriha,Gonda,Uttar Pradesh',
'Jabdha,Gonda,Uttar Pradesh',
'Jewnar,Gonda,Uttar Pradesh',
'Jhalidham,Gonda,Uttar Pradesh',
'Kamrawan,Gonda,Uttar Pradesh',
'Katra Shankar Nagar,Gonda,Uttar Pradesh',
'Koilara,Gonda,Uttar Pradesh',
'Lai Budwa,Gonda,Uttar Pradesh',
'Mahrajganj,Gonda,Uttar Pradesh',
'Mirjapur,Gonda,Uttar Pradesh',
'Mujehani,Gonda,Uttar Pradesh',
'Mundila,Gonda,Uttar Pradesh',
'Pandari,Gonda,Uttar Pradesh',
'Pipra Bhodhar,Gonda,Uttar Pradesh',
'Pirwartara,Gonda,Uttar Pradesh',
'Purab Tola,Gonda,Uttar Pradesh',
'Sehrinwa,Gonda,Uttar Pradesh',
'Sisai Jangal,Gonda,Uttar Pradesh',
'Sugganagar,Gonda,Uttar Pradesh',
'Achalpur Kaithawalia,Gonda,Uttar Pradesh',
'Mnohrapur,Gonda,Uttar Pradesh',
'Tirlokpur,Gonda,Uttar Pradesh',
'Achkawapur,Gonda,Uttar Pradesh',
'Adamtara,Gonda,Uttar Pradesh',
'Amauli Dhamali,Gonda,Uttar Pradesh',
'Amwabas,Gonda,Uttar Pradesh',
'Badhara,Gonda,Uttar Pradesh',
'Bairihwa,Gonda,Uttar Pradesh',
'Bakaulirajpur,Gonda,Uttar Pradesh',
'Baldev Nagar,Gonda,Uttar Pradesh',
'Bangai,Gonda,Uttar Pradesh',
'Banghusri,Gonda,Uttar Pradesh',
'Bankatwa,Gonda,Uttar Pradesh',
'Bardaulia,Gonda,Uttar Pradesh',
'Bargadha Sohna,Gonda,Uttar Pradesh',
'Bargadwa,Gonda,Uttar Pradesh',
'Belhsa,Gonda,Uttar Pradesh',
'Bemiha,Gonda,Uttar Pradesh',
'Bethaniya Karihniya,Gonda,Uttar Pradesh',
'Bhagwanpur,Gonda,Uttar Pradesh',
'Bhagwanpur Khadar,Gonda,Uttar Pradesh',
'Bhagwanpur Kondar,Gonda,Uttar Pradesh',
'Bhangaha Kala,Gonda,Uttar Pradesh',
'Bhathar,Gonda,Uttar Pradesh',
'Bhojpur Tharu,Gonda,Uttar Pradesh',
'Bisunpur,Gonda,Uttar Pradesh',
'Bisunpur Vishram,Gonda,Uttar Pradesh',
'Chandanpur,Gonda,Uttar Pradesh',
'Chaudhary Deeh,Gonda,Uttar Pradesh',
'Chauhattar Kalan,Gonda,Uttar Pradesh',
'Chauhattar Khurd,Gonda,Uttar Pradesh',
'Deopura,Gonda,Uttar Pradesh',
'Dhabauliya,Gonda,Uttar Pradesh',
'Dharampur,Gonda,Uttar Pradesh',
'Dhawai,Gonda,Uttar Pradesh',
'Dumri,Gonda,Uttar Pradesh',
'Gainsari,Gonda,Uttar Pradesh',
'Ganeshpur,Gonda,Uttar Pradesh',
'Ganeshpur,Gonda,Uttar Pradesh',
'Gudra,Gonda,Uttar Pradesh',
'Gugauli,Gonda,Uttar Pradesh',
'Gulriha Sandwa,Gonda,Uttar Pradesh',
'Hasanpur,Gonda,Uttar Pradesh',
'Jahandaria,Gonda,Uttar Pradesh',
'Jamuni Kala,Gonda,Uttar Pradesh',
'Jarwa,Gonda,Uttar Pradesh',
'Kataiyabhari,Gonda,Uttar Pradesh',
'Kauwapur,Gonda,Uttar Pradesh',
'Khamahariya,Gonda,Uttar Pradesh',
'Kodri,Gonda,Uttar Pradesh',
'Kohar Gaddi,Gonda,Uttar Pradesh',
'Kondari,Gonda,Uttar Pradesh',
'Kundwa,Gonda,Uttar Pradesh',
'Kutti Ram Talha,Gonda,Uttar Pradesh',
'Laliya,Gonda,Uttar Pradesh',
'Laukahwa,Gonda,Uttar Pradesh',
'Laxmi Nagar,Gonda,Uttar Pradesh',
'Madha Nagar,Gonda,Uttar Pradesh',
'Madni,Gonda,Uttar Pradesh',
'Majgaon,Gonda,Uttar Pradesh',
'Malda,Gonda,Uttar Pradesh',
'Mangra Kohal,Gonda,Uttar Pradesh',
'Manikapur,Gonda,Uttar Pradesh',
'Manpur,Gonda,Uttar Pradesh',
'Motipur,Gonda,Uttar Pradesh',
'Mutera,Gonda,Uttar Pradesh',
'Naikiniya,Gonda,Uttar Pradesh',
'Newal Garh,Gonda,Uttar Pradesh',
'Pachperwa,Gonda,Uttar Pradesh',
'Parasrampur,Gonda,Uttar Pradesh',
'Parasrampur Rajahana,Gonda,Uttar Pradesh',
'Pipriha Jamuni,Gonda,Uttar Pradesh',
'Pranpur,Gonda,Uttar Pradesh',
'Puraina,Gonda,Uttar Pradesh',
'Purani Bazar Pachperwa,Gonda,Uttar Pradesh',
'Rajdarwa Tharu,Gonda,Uttar Pradesh',
'Ram Nagar,Gonda,Uttar Pradesh',
'Ramwapur,Gonda,Uttar Pradesh',
'Rani Jot,Gonda,Uttar Pradesh',
'Raniyapur,Gonda,Uttar Pradesh',
'Rehra Cahuki,Gonda,Uttar Pradesh',
'Shankar Nagar,Gonda,Uttar Pradesh',
'Shankarpur Kalan,Gonda,Uttar Pradesh',
'Shivpur Mhadev,Gonda,Uttar Pradesh',
'Shivpura,Gonda,Uttar Pradesh',
'Sonpur,Gonda,Uttar Pradesh',
'Sonpur,Gonda,Uttar Pradesh',
'Suganagar Dumri,Gonda,Uttar Pradesh',
'Thakurapur,Gonda,Uttar Pradesh',
'Tulsipur,Gonda,Uttar Pradesh',
'Udaipur,Gonda,Uttar Pradesh',
'Vijay Nagar,Gonda,Uttar Pradesh',
'Visunpur Tantanwa,Gonda,Uttar Pradesh',
'Hallaura,Gonda,Uttar Pradesh',
'Bisunpur Grant,Gonda,Uttar Pradesh',
'Kotia,Gonda,Uttar Pradesh',
'Alipur Bujurg,Gonda,Uttar Pradesh',
'Badhya Fareed Khan,Gonda,Uttar Pradesh',
'Bank Bazar,Gonda,Uttar Pradesh',
'Barhara Bhitaura,Gonda,Uttar Pradesh',
'Bhairampur,Gonda,Uttar Pradesh',
'Bhdhipur,Gonda,Uttar Pradesh',
'Bhelya Madanpur,Gonda,Uttar Pradesh',
'Bishunpur Sagar,Gonda,Uttar Pradesh',
'Chamrupur,Gonda,Uttar Pradesh',
'Chhitarpara,Gonda,Uttar Pradesh',
'Dari Chaura,Gonda,Uttar Pradesh',
'Datauli,Gonda,Uttar Pradesh',
'Deoria Inayat,Gonda,Uttar Pradesh',
'Deoria Mubarakpur,Gonda,Uttar Pradesh',
'Dhaurahara,Gonda,Uttar Pradesh',
'Dualata Bad Grant,Gonda,Uttar Pradesh',
'Entai Rampur,Gonda,Uttar Pradesh',
'Fakirapur,Gonda,Uttar Pradesh',
'Gaindas Bujurg,Gonda,Uttar Pradesh',
'Gajpur Grant,Gonda,Uttar Pradesh',
'Godahana,Gonda,Uttar Pradesh',
'Golahipur,Gonda,Uttar Pradesh',
'Gumri,Gonda,Uttar Pradesh',
'Husaina Bad Grant,Gonda,Uttar Pradesh',
'Intai Abdullah,Gonda,Uttar Pradesh',
'Intai,Gonda,Uttar Pradesh',
'Jaiprabha Gram,Gonda,Uttar Pradesh',
'Jaita Pur,Gonda,Uttar Pradesh',
'Khajuria,Gonda,Uttar Pradesh',
'Kharhawa Deehwa,Gonda,Uttar Pradesh',
'Lokiya Tahir,Gonda,Uttar Pradesh',
'Maddo Chaura,Gonda,Uttar Pradesh',
'Mahdaiya State,Gonda,Uttar Pradesh',
'Mahuwa,Gonda,Uttar Pradesh',
'Maniyaria,Gonda,Uttar Pradesh',
'Maruia Bujurga,Gonda,Uttar Pradesh',
'Nandauri,Gonda,Uttar Pradesh',
'Naubasta Mundila,Gonda,Uttar Pradesh',
'Obarideeh,Gonda,Uttar Pradesh',
'Parsona,Gonda,Uttar Pradesh',
'Pehar,Gonda,Uttar Pradesh',
'Pipra Ram Chandar,Gonda,Uttar Pradesh',
'Puraina Wajid,Gonda,Uttar Pradesh',
'Ramapur Grant,Gonda,Uttar Pradesh',
'Rampur Banghusra,Gonda,Uttar Pradesh',
'Rehar Mafi,Gonda,Uttar Pradesh',
'Rehra Bazar,Gonda,Uttar Pradesh',
'Sadullanagar,Gonda,Uttar Pradesh',
'Saraikhas,Gonda,Uttar Pradesh',
'Sukhuiya,Gonda,Uttar Pradesh',
'Terhawa Nabad,Gonda,Uttar Pradesh',
'Utraula Bazar,Gonda,Uttar Pradesh',
'Utraula,Gonda,Uttar Pradesh',
'Bisanda,Banda,Uttar Pradesh',
'Achharaund,Banda,Uttar Pradesh',
'Adri,Banda,Uttar Pradesh',
'Ajeetpur,Banda,Uttar Pradesh',
'Akuna,Banda,Uttar Pradesh',
'Aliha,Banda,Uttar Pradesh',
'Alona,Banda,Uttar Pradesh',
'Amara,Banda,Uttar Pradesh',
'Amlikaur,Banda,Uttar Pradesh',
'Amlor,Banda,Uttar Pradesh',
'Anathuwa,Banda,Uttar Pradesh',
'Arjunah,Banda,Uttar Pradesh',
'Armar,Banda,Uttar Pradesh',
'Atarahat,Banda,Uttar Pradesh',
'Atarra,Banda,Uttar Pradesh',
'Audaha,Banda,Uttar Pradesh',
'Augasi,Banda,Uttar Pradesh',
'Baberu,Banda,Uttar Pradesh',
'Bachhaundha,Banda,Uttar Pradesh',
'Bachhaunha,Banda,Uttar Pradesh',
'Badagaon,Banda,Uttar Pradesh',
'Badausa,Banda,Uttar Pradesh',
'Badokhar Bujurg,Banda,Uttar Pradesh',
'Badokhar Khurd,Banda,Uttar Pradesh',
'Bagehta,Banda,Uttar Pradesh',
'Bagha,Banda,Uttar Pradesh',
'Baghelabari,Banda,Uttar Pradesh',
'Baheri,Banda,Uttar Pradesh',
'Ballan,Banda,Uttar Pradesh',
'Banda H.O,Banda,Uttar Pradesh',
'Banda Kty,Banda,Uttar Pradesh',
'Bansi,Banda,Uttar Pradesh',
'Banthari,Banda,Uttar Pradesh',
'Baragaon,Banda,Uttar Pradesh',
'Baraimanpur,Banda,Uttar Pradesh',
'Basahari,Banda,Uttar Pradesh',
'Benda,Banda,Uttar Pradesh',
'Beonja,Banda,Uttar Pradesh',
'Berraon,Banda,Uttar Pradesh',
'Bhabhua,Banda,Uttar Pradesh',
'Bhadedu,Banda,Uttar Pradesh',
'Bhujrakh,Banda,Uttar Pradesh',
'Bichhwahi,Banda,Uttar Pradesh',
'Bilgaon,Banda,Uttar Pradesh',
'Bira,Banda,Uttar Pradesh',
'Birauna,Banda,Uttar Pradesh',
'Bisandi,Banda,Uttar Pradesh',
'Budhauli,Banda,Uttar Pradesh',
'Chandwara,Banda,Uttar Pradesh',
'Chandwara,Banda,Uttar Pradesh',
'Charka,Banda,Uttar Pradesh',
'Chausar,Banda,Uttar Pradesh',
'Chhehraon,Banda,Uttar Pradesh',
'Chhenahra Lalpur,Banda,Uttar Pradesh',
'Chhoti Bazar,Banda,Uttar Pradesh',
'Chillatara,Banda,Uttar Pradesh',
'Chillolar,Banda,Uttar Pradesh',
'Dadhwamanpur,Banda,Uttar Pradesh',
'Dharikhera,Banda,Uttar Pradesh',
'Dighwat,Banda,Uttar Pradesh',
'Durendi,Banda,Uttar Pradesh',
'Gadaria,Banda,Uttar Pradesh',
'Ganaon,Banda,Uttar Pradesh',
'Ganchchha,Banda,Uttar Pradesh',
'Garchappa,Banda,Uttar Pradesh',
'Gauri Kalan,Banda,Uttar Pradesh',
'Gazipur,Banda,Uttar Pradesh',
'Ghauraunda,Banda,Uttar Pradesh',
'Girwan,Banda,Uttar Pradesh',
'Goeramugli,Banda,Uttar Pradesh',
'Goiya Kalan,Banda,Uttar Pradesh',
'Gokhia,Banda,Uttar Pradesh',
'Gugauli,Banda,Uttar Pradesh',
'Gumanganj,Banda,Uttar Pradesh',
'Gureh,Banda,Uttar Pradesh',
'Gurha Kalan,Banda,Uttar Pradesh',
'Hanna Vinaika,Banda,Uttar Pradesh',
'Harbamafi,Banda,Uttar Pradesh',
'Hardauli,Banda,Uttar Pradesh',
'Hastam,Banda,Uttar Pradesh',
'Hathaura,Banda,Uttar Pradesh',
'Ingua,Banda,Uttar Pradesh',
'Jabrapur,Banda,Uttar Pradesh',
'Jalalpur,Banda,Uttar Pradesh',
'Jamalpur,Banda,Uttar Pradesh',
'Jamoo,Banda,Uttar Pradesh',
'Jamwara,Banda,Uttar Pradesh',
'Jaria,Banda,Uttar Pradesh',
'Jaspura,Banda,Uttar Pradesh',
'Jauharpur,Banda,Uttar Pradesh',
'Jaurahi,Banda,Uttar Pradesh',
'Jhanjhari Ka Purwa,Banda,Uttar Pradesh',
'Kailnjar,Banda,Uttar Pradesh',
'Kairikhurd,Banda,Uttar Pradesh',
'Kamasin,Banda,Uttar Pradesh',
'Kanwara,Banda,Uttar Pradesh',
'Karaundi Kalan,Banda,Uttar Pradesh',
'Kartal,Banda,Uttar Pradesh',
'Katra,Banda,Uttar Pradesh',
'Katrawal,Banda,Uttar Pradesh',
'Khambhaura,Banda,Uttar Pradesh',
'Kharauli,Banda,Uttar Pradesh',
'Khaunda,Banda,Uttar Pradesh',
'Khurand R.S.,Banda,Uttar Pradesh',
'Khurhand,Banda,Uttar Pradesh',
'Korrahi,Banda,Uttar Pradesh',
'Kulsari,Banda,Uttar Pradesh',
'Lahureta,Banda,Uttar Pradesh',
'Lakhanpur,Banda,Uttar Pradesh',
'Lama,Banda,Uttar Pradesh',
'Lohda,Banda,Uttar Pradesh',
'Lohra,Banda,Uttar Pradesh',
'Lucktara,Banda,Uttar Pradesh',
'Madauli Kalan,Banda,Uttar Pradesh',
'Mahokhar,Banda,Uttar Pradesh',
'Mahua,Banda,Uttar Pradesh',
'Mahui,Banda,Uttar Pradesh',
'Mahuta,Banda,Uttar Pradesh',
'Majhila,Banda,Uttar Pradesh',
'Majhiwan,Banda,Uttar Pradesh',
'Makri,Banda,Uttar Pradesh',
'Malehra Newada,Banda,Uttar Pradesh',
'Mamsi Khurd,Banda,Uttar Pradesh',
'Manipur,Banda,Uttar Pradesh',
'Marauli,Banda,Uttar Pradesh',
'Marjha,Banda,Uttar Pradesh',
'Marka,Banda,Uttar Pradesh',
'Masuri,Banda,Uttar Pradesh',
'Mau,Banda,Uttar Pradesh',
'Mawai,Banda,Uttar Pradesh',
'Mawaighat,Banda,Uttar Pradesh',
'Mohanpurwa,Banda,Uttar Pradesh',
'Mungus,Banda,Uttar Pradesh',
'Murwal,Banda,Uttar Pradesh',
'Museewan,Banda,Uttar Pradesh',
'Naditaura,Banda,Uttar Pradesh',
'Nagnedi,Banda,Uttar Pradesh',
'Nahri,Banda,Uttar Pradesh',
'Nandadeo,Banda,Uttar Pradesh',
'Nandin Kurmiyan,Banda,Uttar Pradesh',
'Naraini,Banda,Uttar Pradesh',
'Narauli,Banda,Uttar Pradesh',
'Narayanpur,Banda,Uttar Pradesh',
'Nari,Banda,Uttar Pradesh',
'Nauhai,Banda,Uttar Pradesh',
'Nibhaur,Banda,Uttar Pradesh',
'Nilathu,Banda,Uttar Pradesh',
'Ora,Banda,Uttar Pradesh',
'Oraha,Banda,Uttar Pradesh',
'Oran,Banda,Uttar Pradesh',
'P G College Attara,Banda,Uttar Pradesh',
'Pachnehi,Banda,Uttar Pradesh',
'Pachokhar,Banda,Uttar Pradesh',
'Padarathpur,Banda,Uttar Pradesh',
'Padmai,Banda,Uttar Pradesh',
'Padohra,Banda,Uttar Pradesh',
'Padui,Banda,Uttar Pradesh',
'Paigambarpur,Banda,Uttar Pradesh',
'Pailani,Banda,Uttar Pradesh',
'Palhari,Banda,Uttar Pradesh',
'Palra,Banda,Uttar Pradesh',
'Pangara,Banda,Uttar Pradesh',
'Pannah,Banda,Uttar Pradesh',
'Paprenda,Banda,Uttar Pradesh',
'Para,Banda,Uttar Pradesh',
'Paras,Banda,Uttar Pradesh',
'Parsahar,Banda,Uttar Pradesh',
'Parsauli,Banda,Uttar Pradesh',
'Parsaunda,Banda,Uttar Pradesh',
'Pathara,Banda,Uttar Pradesh',
'Patwan,Banda,Uttar Pradesh',
'Pauhar,Banda,Uttar Pradesh',
'Pawaiya,Banda,Uttar Pradesh',
'Pindaran,Banda,Uttar Pradesh',
'Pindkhar,Banda,Uttar Pradesh',
'Pipargawan,Banda,Uttar Pradesh',
'Piprahari,Banda,Uttar Pradesh',
'Piprodar,Banda,Uttar Pradesh',
'Piyar,Banda,Uttar Pradesh',
'Pongari,Banda,Uttar Pradesh',
'Punahur,Banda,Uttar Pradesh',
'Rampur,Banda,Uttar Pradesh',
'Ranipur,Banda,Uttar Pradesh',
'Rasin,Banda,Uttar Pradesh',
'Rauli Kalyanpur,Banda,Uttar Pradesh',
'Risaura,Banda,Uttar Pradesh',
'Sabada,Banda,Uttar Pradesh',
'Sadimadanpur,Banda,Uttar Pradesh',
'Sahewa,Banda,Uttar Pradesh',
'Samgara,Banda,Uttar Pradesh',
'Sandasani,Banda,Uttar Pradesh',
'Sarha,Banda,Uttar Pradesh',
'Sathi,Banda,Uttar Pradesh',
'Satnyaon,Banda,Uttar Pradesh',
'Saunta Syondha,Banda,Uttar Pradesh',
'Saya,Banda,Uttar Pradesh',
'Semri Basilpur,Banda,Uttar Pradesh',
'Sheo,Banda,Uttar Pradesh',
'Sikahula,Banda,Uttar Pradesh',
'Simauni,Banda,Uttar Pradesh',
'Sindhan Kalan,Banda,Uttar Pradesh',
'Singhpur,Banda,Uttar Pradesh',
'Tilausa,Banda,Uttar Pradesh',
'Tindura,Banda,Uttar Pradesh',
'Tindwara,Banda,Uttar Pradesh',
'Tindwari,Banda,Uttar Pradesh',
'Trivedi,Banda,Uttar Pradesh',
'Turra,Banda,Uttar Pradesh',
'Umarahni,Banda,Uttar Pradesh',
'Station Road Rudauli,Barabanki,Uttar Pradesh',
'Anwari,Barabanki,Uttar Pradesh',
'Atahara,Barabanki,Uttar Pradesh',
'Baddoopur,Barabanki,Uttar Pradesh',
'Bahrauli,Barabanki,Uttar Pradesh',
'Bajgahni,Barabanki,Uttar Pradesh',
'Bandagi Nagar,Barabanki,Uttar Pradesh',
'Barhaidih Maholia,Barabanki,Uttar Pradesh',
'Basantpur,Barabanki,Uttar Pradesh',
'Basara,Barabanki,Uttar Pradesh',
'Basauli,Barabanki,Uttar Pradesh',
'Belahara,Barabanki,Uttar Pradesh',
'Bhadras,Barabanki,Uttar Pradesh',
'Bheriya,Barabanki,Uttar Pradesh',
'Bishunpur,Barabanki,Uttar Pradesh',
'Chheda,Barabanki,Uttar Pradesh',
'Dadera,Barabanki,Uttar Pradesh',
'Darawan,Barabanki,Uttar Pradesh',
'Daulatpur,Barabanki,Uttar Pradesh',
'Gariya Bazar,Barabanki,Uttar Pradesh',
'Gaura,Barabanki,Uttar Pradesh',
'Gheri,Barabanki,Uttar Pradesh',
'Ghunghter,Barabanki,Uttar Pradesh',
'Gudauli,Barabanki,Uttar Pradesh',
'Hansuwapara,Barabanki,Uttar Pradesh',
'Hasanpur Tanda,Barabanki,Uttar Pradesh',
'Hazratpur,Barabanki,Uttar Pradesh',
'Israuli,Barabanki,Uttar Pradesh',
'Itaunja,Barabanki,Uttar Pradesh',
'Jagsenda,Barabanki,Uttar Pradesh',
'Jhanjhari,Barabanki,Uttar Pradesh',
'Jharsawan,Barabanki,Uttar Pradesh',
'Kaji Behta,Barabanki,Uttar Pradesh',
'Kandarwal,Barabanki,Uttar Pradesh',
'Kandraula,Barabanki,Uttar Pradesh',
'Katuri Kalan,Barabanki,Uttar Pradesh',
'Khansi Sarai,Barabanki,Uttar Pradesh',
'Khapurwa,Barabanki,Uttar Pradesh',
'Khinjhana,Barabanki,Uttar Pradesh',
'Kursi,Barabanki,Uttar Pradesh',
'Kutloopur,Barabanki,Uttar Pradesh',
'Madanpur,Barabanki,Uttar Pradesh',
'Majhgawan Sharif,Barabanki,Uttar Pradesh',
'Mithwara,Barabanki,Uttar Pradesh',
'Mohammad Pur Khaley,Barabanki,Uttar Pradesh',
'Mohsand,Barabanki,Uttar Pradesh',
'Nindoora,Barabanki,Uttar Pradesh',
'Pandari,Barabanki,Uttar Pradesh',
'Patna,Barabanki,Uttar Pradesh',
'Rahilamau,Barabanki,Uttar Pradesh',
'Ralbhari,Barabanki,Uttar Pradesh',
'Ram Mandai,Barabanki,Uttar Pradesh',
'Rasoolpur,Barabanki,Uttar Pradesh',
'Sadrapur,Barabanki,Uttar Pradesh',
'Salempur,Barabanki,Uttar Pradesh',
'Sarhemau,Barabanki,Uttar Pradesh',
'Sarsawan,Barabanki,Uttar Pradesh',
'Shafipur,Barabanki,Uttar Pradesh',
'Shahpur Bhagauli,Barabanki,Uttar Pradesh',
'Shailie Keeratpur,Barabanki,Uttar Pradesh',
'Sihali,Barabanki,Uttar Pradesh',
'Sirauli Surjanpur,Barabanki,Uttar Pradesh',
'Sirsaipur,Barabanki,Uttar Pradesh',
'Sulemabad,Barabanki,Uttar Pradesh',
'Sundhiyamau,Barabanki,Uttar Pradesh',
'Suratganj,Barabanki,Uttar Pradesh',
'Talgaon,Barabanki,Uttar Pradesh',
'Tehsil Fateh Pur,Barabanki,Uttar Pradesh',
'Terhwa,Barabanki,Uttar Pradesh',
'Tikaitganj,Barabanki,Uttar Pradesh',
'Watia,Barabanki,Uttar Pradesh',
'Jagatpur,Barabanki,Uttar Pradesh',
'Ansari,Barabanki,Uttar Pradesh',
'Asandra,Barabanki,Uttar Pradesh',
'Bara,Barabanki,Uttar Pradesh',
'Beejapur,Barabanki,Uttar Pradesh',
'Bhikhara,Barabanki,Uttar Pradesh',
'Bhilwal,Barabanki,Uttar Pradesh',
'Bhitaura Lakhan,Barabanki,Uttar Pradesh',
'Bibiapur,Barabanki,Uttar Pradesh',
'Bibipur Garh,Barabanki,Uttar Pradesh',
'Chaubeesi,Barabanki,Uttar Pradesh',
'Chiraiya,Barabanki,Uttar Pradesh',
'Dandoopur,Barabanki,Uttar Pradesh',
'Dayalpur,Barabanki,Uttar Pradesh',
'Dhanauli,Barabanki,Uttar Pradesh',
'Dhanaura,Barabanki,Uttar Pradesh',
'Dharoopur,Barabanki,Uttar Pradesh',
'Gajpatipur,Barabanki,Uttar Pradesh',
'Ganehari,Barabanki,Uttar Pradesh',
'Garhi,Barabanki,Uttar Pradesh',
'Gerawan,Barabanki,Uttar Pradesh',
'Ghar Kuiyan,Barabanki,Uttar Pradesh',
'Haidergarh,Barabanki,Uttar Pradesh',
'Hasanpur,Barabanki,Uttar Pradesh',
'Inayatpur,Barabanki,Uttar Pradesh',
'Islampur,Barabanki,Uttar Pradesh',
'Jameen Husainabad,Barabanki,Uttar Pradesh',
'Jarauli,Barabanki,Uttar Pradesh',
'Jargawan,Barabanki,Uttar Pradesh',
'Jaurass,Barabanki,Uttar Pradesh',
'Kaboolpur,Barabanki,Uttar Pradesh',
'Kakari,Barabanki,Uttar Pradesh',
'Kamela,Barabanki,Uttar Pradesh',
'Kanwan,Barabanki,Uttar Pradesh',
'Khaira Kankoo,Barabanki,Uttar Pradesh',
'Khanpur,Barabanki,Uttar Pradesh',
'Kharsatiya,Barabanki,Uttar Pradesh',
'Khwajapur,Barabanki,Uttar Pradesh',
'Kothi,Barabanki,Uttar Pradesh',
'Lahi,Barabanki,Uttar Pradesh',
'Lohangpur,Barabanki,Uttar Pradesh',
'Loni Katra,Barabanki,Uttar Pradesh',
'Magauwan,Barabanki,Uttar Pradesh',
'Malhauli,Barabanki,Uttar Pradesh',
'Manodharpur,Barabanki,Uttar Pradesh',
'Mansara,Barabanki,Uttar Pradesh',
'Mohabbatpur,Barabanki,Uttar Pradesh',
'Mohammadpur,Barabanki,Uttar Pradesh',
'Motikpur,Barabanki,Uttar Pradesh',
'Neochhana,Barabanki,Uttar Pradesh',
'Paigamberpur,Barabanki,Uttar Pradesh',
'Palia,Barabanki,Uttar Pradesh',
'Pareewan,Barabanki,Uttar Pradesh',
'Pokhra,Barabanki,Uttar Pradesh',
'Poore Chandraman,Barabanki,Uttar Pradesh',
'Ramnagar Pareeva,Barabanki,Uttar Pradesh',
'Ratauli,Barabanki,Uttar Pradesh',
'Rauli,Barabanki,Uttar Pradesh',
'Ruknuddinpur,Barabanki,Uttar Pradesh',
'Saalpur,Barabanki,Uttar Pradesh',
'Sarai Gopi,Barabanki,Uttar Pradesh',
'Sarai Rawat,Barabanki,Uttar Pradesh',
'Sarsa,Barabanki,Uttar Pradesh',
'Semrawan,Barabanki,Uttar Pradesh',
'Sharifabad,Barabanki,Uttar Pradesh',
'Shivnaam,Barabanki,Uttar Pradesh',
'Sidhaur,Barabanki,Uttar Pradesh',
'Sohawan,Barabanki,Uttar Pradesh',
'Subeha,Barabanki,Uttar Pradesh',
'Tejwapur,Barabanki,Uttar Pradesh',
'Thalwara,Barabanki,Uttar Pradesh',
'Tikariya Saidkhanpur,Barabanki,Uttar Pradesh',
'Tilokpur Usmanpur,Barabanki,Uttar Pradesh',
'Trivediganj,Barabanki,Uttar Pradesh',
'Uchita,Barabanki,Uttar Pradesh',
'Umrawal Kirsia,Barabanki,Uttar Pradesh',
'Usmanpur,Barabanki,Uttar Pradesh',
'Loharpur,Barabanki,Uttar Pradesh',
'Barauli Malik,Barabanki,Uttar Pradesh',
'Ahmadpur,Barabanki,Uttar Pradesh',
'Akhtiyarpur Sharifabad,Barabanki,Uttar Pradesh',
'Ambaur,Barabanki,Uttar Pradesh',
'Aseni,Barabanki,Uttar Pradesh',
'Baburi Gaon,Barabanki,Uttar Pradesh',
'Baghaura,Barabanki,Uttar Pradesh',
'Banki,Barabanki,Uttar Pradesh',
'Bansa Sharif,Barabanki,Uttar Pradesh',
'Banwa,Barabanki,Uttar Pradesh',
'Barabanki Bazar,Barabanki,Uttar Pradesh',
'Barabanki City,Barabanki,Uttar Pradesh',
'Barabanki Collectorate,Barabanki,Uttar Pradesh',
'Barabanki H.O,Barabanki,Uttar Pradesh',
'Barabanki Sugar Mill,Barabanki,Uttar Pradesh',
'Baragaon,Barabanki,Uttar Pradesh',
'Barail,Barabanki,Uttar Pradesh',
'Barain,Barabanki,Uttar Pradesh',
'Barauli Jata,Barabanki,Uttar Pradesh',
'Basti,Barabanki,Uttar Pradesh',
'Behta,Barabanki,Uttar Pradesh',
'Bhanauli,Barabanki,Uttar Pradesh',
'Bhanmau,Barabanki,Uttar Pradesh',
'Bhayara,Barabanki,Uttar Pradesh',
'Bhitauli Kalan,Barabanki,Uttar Pradesh',
'Birahimabad,Barabanki,Uttar Pradesh',
'Budhwara,Barabanki,Uttar Pradesh',
'Dadra,Barabanki,Uttar Pradesh',
'Daravpur,Barabanki,Uttar Pradesh',
'Darhara,Barabanki,Uttar Pradesh',
'Daulatpur,Barabanki,Uttar Pradesh',
'Dewa Sharif,Barabanki,Uttar Pradesh',
'Dharampur,Barabanki,Uttar Pradesh',
'Dhaurahra,Barabanki,Uttar Pradesh',
'Gadia,Barabanki,Uttar Pradesh',
'Galhamau,Barabanki,Uttar Pradesh',
'Gandhi Aashram,Barabanki,Uttar Pradesh',
'Garhi Rakhmau,Barabanki,Uttar Pradesh',
'Gehendwar,Barabanki,Uttar Pradesh',
'Harakh,Barabanki,Uttar Pradesh',
'Harrai,Barabanki,Uttar Pradesh',
'Ismailpur,Barabanki,Uttar Pradesh',
'Jahangeerabad Raj,Barabanki,Uttar Pradesh',
'Jaruwa,Barabanki,Uttar Pradesh',
'Kamarkha,Barabanki,Uttar Pradesh',
'Kasimganj,Barabanki,Uttar Pradesh',
'Khanwaha,Barabanki,Uttar Pradesh',
'Kheoli,Barabanki,Uttar Pradesh',
'Khijirpur,Barabanki,Uttar Pradesh',
'Kola,Barabanki,Uttar Pradesh',
'Kondari,Barabanki,Uttar Pradesh',
'Lachhbar Bajaha,Barabanki,Uttar Pradesh',
'Laxmanpur,Barabanki,Uttar Pradesh',
'Madhopur,Barabanki,Uttar Pradesh',
'Malookpur,Barabanki,Uttar Pradesh',
'Manpur,Barabanki,Uttar Pradesh',
'Markhapur,Barabanki,Uttar Pradesh',
'Masauli,Barabanki,Uttar Pradesh',
'Mittai,Barabanki,Uttar Pradesh',
'Mujeebpur,Barabanki,Uttar Pradesh',
'Munshiganj,Barabanki,Uttar Pradesh',
'Muradabad,Barabanki,Uttar Pradesh',
'Nainamau,Barabanki,Uttar Pradesh',
'Nanmau,Barabanki,Uttar Pradesh',
'Narain Bhari,Barabanki,Uttar Pradesh',
'Naseernagar,Barabanki,Uttar Pradesh',
'Neola Karsanda,Barabanki,Uttar Pradesh',
'Neoli,Barabanki,Uttar Pradesh',
'Niyamatpur,Barabanki,Uttar Pradesh',
'Palhari,Barabanki,Uttar Pradesh',
'Para Khandauli,Barabanki,Uttar Pradesh',
'Patmau,Barabanki,Uttar Pradesh',
'Peend,Barabanki,Uttar Pradesh',
'Ram Van Kuteer,Barabanki,Uttar Pradesh',
'Rasauli,Barabanki,Uttar Pradesh',
'Rasoolpur,Barabanki,Uttar Pradesh',
'Sadruddinpur,Barabanki,Uttar Pradesh',
'Safderganj,Barabanki,Uttar Pradesh',
'Safedabad,Barabanki,Uttar Pradesh',
'Sarai Kayasthan,Barabanki,Uttar Pradesh',
'Sarai Parsanda,Barabanki,Uttar Pradesh',
'Sarsaundi,Barabanki,Uttar Pradesh',
'Satrikh,Barabanki,Uttar Pradesh',
'Sethmau,Barabanki,Uttar Pradesh',
'Shahabpur,Barabanki,Uttar Pradesh',
'Somaiya Nagar,Barabanki,Uttar Pradesh',
'Teergaon,Barabanki,Uttar Pradesh',
'Tera Kalan,Barabanki,Uttar Pradesh',
'Tikra,Barabanki,Uttar Pradesh',
'Tindola,Barabanki,Uttar Pradesh',
'Udhauli,Barabanki,Uttar Pradesh',
'Ukhari,Barabanki,Uttar Pradesh',
'Yakootganj,Barabanki,Uttar Pradesh',
'Zaidpur,Barabanki,Uttar Pradesh',
'Kusfar,Barabanki,Uttar Pradesh',
'Aliabad,Barabanki,Uttar Pradesh',
'Amahia,Barabanki,Uttar Pradesh',
'Ashrafpur,Barabanki,Uttar Pradesh',
'Badshahnagar,Barabanki,Uttar Pradesh',
'Bangawan,Barabanki,Uttar Pradesh',
'Bansgaon,Barabanki,Uttar Pradesh',
'Belpur,Barabanki,Uttar Pradesh',
'Bhawaniyapur Kheoli,Barabanki,Uttar Pradesh',
'Bhikharpur,Barabanki,Uttar Pradesh',
'Chauri Aladadpur,Barabanki,Uttar Pradesh',
'Chirra,Barabanki,Uttar Pradesh',
'Dariya Bad,Barabanki,Uttar Pradesh',
'Dariyabad R.S.,Barabanki,Uttar Pradesh',
'Dhanauli Thakuran,Barabanki,Uttar Pradesh',
'Digsari,Barabanki,Uttar Pradesh',
'Dilauna,Barabanki,Uttar Pradesh',
'Fattapur Kalan,Barabanki,Uttar Pradesh',
'Hakami,Barabanki,Uttar Pradesh',
'Hassaur,Barabanki,Uttar Pradesh',
'Hathaunda,Barabanki,Uttar Pradesh',
'Hunsepur,Barabanki,Uttar Pradesh',
'Imliha,Barabanki,Uttar Pradesh',
'Itaura,Barabanki,Uttar Pradesh',
'Kheorajpur,Barabanki,Uttar Pradesh',
'Khetasarai,Barabanki,Uttar Pradesh',
'Khutauli,Barabanki,Uttar Pradesh',
'Kithaiya,Barabanki,Uttar Pradesh',
'Kithoori Daroga,Barabanki,Uttar Pradesh',
'Manjhela,Barabanki,Uttar Pradesh',
'Maugorpur,Barabanki,Uttar Pradesh',
'Maulahara,Barabanki,Uttar Pradesh',
'Meruwa,Barabanki,Uttar Pradesh',
'Pahroopur,Barabanki,Uttar Pradesh',
'Panapur,Barabanki,Uttar Pradesh',
'Patulki,Barabanki,Uttar Pradesh',
'Puredalai,Barabanki,Uttar Pradesh',
'Ram Sanehi Ghat,Barabanki,Uttar Pradesh',
'Ranimau Tarai,Barabanki,Uttar Pradesh',
'Rasoolpur,Barabanki,Uttar Pradesh',
'Sanauli,Barabanki,Uttar Pradesh',
'Sarai Barai,Barabanki,Uttar Pradesh',
'Sarai Dunauli,Barabanki,Uttar Pradesh',
'Shahpur,Barabanki,Uttar Pradesh',
'Sikari Jeewal,Barabanki,Uttar Pradesh',
'Silhaur,Barabanki,Uttar Pradesh',
'Sukhipur,Barabanki,Uttar Pradesh',
'Surajpur,Barabanki,Uttar Pradesh',
'Tarapur,Barabanki,Uttar Pradesh',
'Thorthia,Barabanki,Uttar Pradesh',
'Tiwaripur,Barabanki,Uttar Pradesh',
'Udwat Nagar,Barabanki,Uttar Pradesh',
'Achhechha,Barabanki,Uttar Pradesh',
'Amoli Kalan,Barabanki,Uttar Pradesh',
'Baburiha,Barabanki,Uttar Pradesh',
'Bahramghat,Barabanki,Uttar Pradesh',
'Banarki,Barabanki,Uttar Pradesh',
'Bhitauli,Barabanki,Uttar Pradesh',
'Bilakhiya,Barabanki,Uttar Pradesh',
'Bindaura,Barabanki,Uttar Pradesh',
'Bindaura Dhartharia,Barabanki,Uttar Pradesh',
'Budhera,Barabanki,Uttar Pradesh',
'Burhwal Sugar Mill,Barabanki,Uttar Pradesh',
'Hetmapur,Barabanki,Uttar Pradesh',
'Jafarpur,Barabanki,Uttar Pradesh',
'Lalpur Karauta,Barabanki,Uttar Pradesh',
'Lodhaura,Barabanki,Uttar Pradesh',
'Mahmoodpur,Barabanki,Uttar Pradesh',
'Malauli,Barabanki,Uttar Pradesh',
'Mallapur,Barabanki,Uttar Pradesh',
'Nahamau,Barabanki,Uttar Pradesh',
'Puremanbhawan Singh,Barabanki,Uttar Pradesh',
'Ramnagar,Barabanki,Uttar Pradesh',
'Raniganj Bazar,Barabanki,Uttar Pradesh',
'Ruhera,Barabanki,Uttar Pradesh',
'Semrai,Barabanki,Uttar Pradesh',
'Sirauli Kalan,Barabanki,Uttar Pradesh',
'Sirkauli,Barabanki,Uttar Pradesh',
'Telwari,Barabanki,Uttar Pradesh',
'Telyani,Barabanki,Uttar Pradesh',
'Tilokpur,Barabanki,Uttar Pradesh',
'Mawai,Barabanki,Uttar Pradesh',
'Meermau,Barabanki,Uttar Pradesh',
'Abboopur,Barabanki,Uttar Pradesh',
'Aihar,Barabanki,Uttar Pradesh',
'Akhtiyarpur,Barabanki,Uttar Pradesh',
'Amraigaon,Barabanki,Uttar Pradesh',
'Bari,Barabanki,Uttar Pradesh',
'Bhelsar,Barabanki,Uttar Pradesh',
'Bihara,Barabanki,Uttar Pradesh',
'Chandramau,Barabanki,Uttar Pradesh',
'Dewait,Barabanki,Uttar Pradesh',
'Ferozpur Makhdoomi,Barabanki,Uttar Pradesh',
'Giraunda,Barabanki,Uttar Pradesh',
'Hansrajpur,Barabanki,Uttar Pradesh',
'Hariharpur Kayasthan,Barabanki,Uttar Pradesh',
'Hunhuna,Barabanki,Uttar Pradesh',
'Jakhauli,Barabanki,Uttar Pradesh',
'Jarauli Kalan,Barabanki,Uttar Pradesh',
'Karaundi,Barabanki,Uttar Pradesh',
'Kasari,Barabanki,Uttar Pradesh',
'Khari,Barabanki,Uttar Pradesh',
'Manjanpur,Barabanki,Uttar Pradesh',
'Mathanewada,Barabanki,Uttar Pradesh',
'Narauli,Barabanki,Uttar Pradesh',
'Neora,Barabanki,Uttar Pradesh',
'Neoti,Barabanki,Uttar Pradesh',
'Paharpur,Barabanki,Uttar Pradesh',
'Patranga R.S.,Barabanki,Uttar Pradesh',
'Pure Kamgar,Barabanki,Uttar Pradesh',
'Rampur Janak,Barabanki,Uttar Pradesh',
'Rani Mau Bhatthi,Barabanki,Uttar Pradesh',
'Rauzagaon,Barabanki,Uttar Pradesh',
'Rudauli City,Barabanki,Uttar Pradesh',
'Rudauli,Barabanki,Uttar Pradesh',
'Saidpur,Barabanki,Uttar Pradesh',
'Samsi,Barabanki,Uttar Pradesh',
'Sandawa,Barabanki,Uttar Pradesh',
'Saraitha,Barabanki,Uttar Pradesh',
'Seonrahara,Barabanki,Uttar Pradesh',
'Shahpur,Barabanki,Uttar Pradesh',
'Sherpur,Barabanki,Uttar Pradesh',
'Shujaganj,Barabanki,Uttar Pradesh',
'Sithauli,Barabanki,Uttar Pradesh',
'Sunba,Barabanki,Uttar Pradesh',
'Talgaon,Barabanki,Uttar Pradesh',
'Tanda Sufi,Barabanki,Uttar Pradesh',
'Umapur,Barabanki,Uttar Pradesh',
'Saadatganj,Barabanki,Uttar Pradesh',
'Tikait Nagar,Barabanki,Uttar Pradesh',
'Kothri Gauriya,Barabanki,Uttar Pradesh',
'Sirauli Gaus Pur,Barabanki,Uttar Pradesh',
'Addra,Barabanki,Uttar Pradesh',
'Badosarai,Barabanki,Uttar Pradesh',
'Bhainsuriya,Barabanki,Uttar Pradesh',
'Chaila,Barabanki,Uttar Pradesh',
'Dadrauli Bhawaniapur,Barabanki,Uttar Pradesh',
'Danapur Shukla,Barabanki,Uttar Pradesh',
'Ghazipur,Barabanki,Uttar Pradesh',
'Gidrapur,Barabanki,Uttar Pradesh',
'Hadha,Barabanki,Uttar Pradesh',
'Jariyari,Barabanki,Uttar Pradesh',
'Kamoli,Barabanki,Uttar Pradesh',
'Kandhaipur,Barabanki,Uttar Pradesh',
'Katka,Barabanki,Uttar Pradesh',
'Khajuri,Barabanki,Uttar Pradesh',
'Kintoor,Barabanki,Uttar Pradesh',
'Kotwa Dham,Barabanki,Uttar Pradesh',
'Madhawapur,Barabanki,Uttar Pradesh',
'Mahmoodabad,Barabanki,Uttar Pradesh',
'Mailaraiganj,Barabanki,Uttar Pradesh',
'Markamau,Barabanki,Uttar Pradesh',
'Maulabad,Barabanki,Uttar Pradesh',
'Mushkabad,Barabanki,Uttar Pradesh',
'Neoli Danapur,Barabanki,Uttar Pradesh',
'Pyarepur,Barabanki,Uttar Pradesh',
'Qusba Ichauli,Barabanki,Uttar Pradesh',
'Qyampur,Barabanki,Uttar Pradesh',
'Ram Sahai,Barabanki,Uttar Pradesh',
'Rampur Katra,Barabanki,Uttar Pradesh',
'Ranikatra,Barabanki,Uttar Pradesh',
'Said Khanpur,Barabanki,Uttar Pradesh',
'Saidanpur,Barabanki,Uttar Pradesh',
'Saifpur,Barabanki,Uttar Pradesh',
'Alampur Jafarabad,Bareilly,Uttar Pradesh',
'Aliganj,Bareilly,Uttar Pradesh',
'Anurudhpur,Bareilly,Uttar Pradesh',
'Aonla Katra,Bareilly,Uttar Pradesh',
'Aonla Kila,Bareilly,Uttar Pradesh',
'Aonla,Bareilly,Uttar Pradesh',
'Atarchhedi,Bareilly,Uttar Pradesh',
'Balai Bhagwantpur,Bareilly,Uttar Pradesh',
'Baragoan,Bareilly,Uttar Pradesh',
'Barser Sikandarpur,Bareilly,Uttar Pradesh',
'Basantpur,Bareilly,Uttar Pradesh',
'Beodhan Khurd,Bareilly,Uttar Pradesh',
'Deochara,Bareilly,Uttar Pradesh',
'Digoi,Bareilly,Uttar Pradesh',
'Gaini,Bareilly,Uttar Pradesh',
'Gotha Khandua,Bareilly,Uttar Pradesh',
'Guleli,Bareilly,Uttar Pradesh',
'Gurgaon,Bareilly,Uttar Pradesh',
'Hardaspur,Bareilly,Uttar Pradesh',
'Himmatpur,Bareilly,Uttar Pradesh',
'Iffcotownship,Bareilly,Uttar Pradesh',
'Jitaur,Bareilly,Uttar Pradesh',
'Kaimua,Bareilly,Uttar Pradesh',
'Kalyanpur,Bareilly,Uttar Pradesh',
'Kangaon,Bareilly,Uttar Pradesh',
'Kangawan Shyam,Bareilly,Uttar Pradesh',
'Kasumara,Bareilly,Uttar Pradesh',
'Katsari,Bareilly,Uttar Pradesh',
'Kesarpur,Bareilly,Uttar Pradesh',
'Khelam,Bareilly,Uttar Pradesh',
'Kundaria Faizulapur,Bareilly,Uttar Pradesh',
'Kusari,Bareilly,Uttar Pradesh',
'Labhari,Bareilly,Uttar Pradesh',
'Langura,Bareilly,Uttar Pradesh',
'Lilaur,Bareilly,Uttar Pradesh',
'Majhgawan,Bareilly,Uttar Pradesh',
'Malgoan,Bareilly,Uttar Pradesh',
'Mandora,Bareilly,Uttar Pradesh',
'Manona,Bareilly,Uttar Pradesh',
'Mau Chandpur,Bareilly,Uttar Pradesh',
'Mehmoodpur,Bareilly,Uttar Pradesh',
'Milak Majhera,Bareilly,Uttar Pradesh',
'Mohammadpur Pathra,Bareilly,Uttar Pradesh',
'Naugawan Bramhanan,Bareilly,Uttar Pradesh',
'Naugawan Thakuran,Bareilly,Uttar Pradesh',
'Naurangpur,Bareilly,Uttar Pradesh',
'Nisui,Bareilly,Uttar Pradesh',
'Noorpur,Bareilly,Uttar Pradesh',
'Phulasi,Bareilly,Uttar Pradesh',
'Rajupur,Bareilly,Uttar Pradesh',
'Rajupur Kalan,Bareilly,Uttar Pradesh',
'Ram Nagar,Bareilly,Uttar Pradesh',
'Reoti,Bareilly,Uttar Pradesh',
'Sahasa,Bareilly,Uttar Pradesh',
'Sarau,Bareilly,Uttar Pradesh',
'Sardar Nagar Ghat,Bareilly,Uttar Pradesh',
'Shivpuri,Bareilly,Uttar Pradesh',
'Singha,Bareilly,Uttar Pradesh',
'Sirauli,Bareilly,Uttar Pradesh',
'Sirohi,Bareilly,Uttar Pradesh',
'Sona,Bareilly,Uttar Pradesh',
'Sudanpur,Bareilly,Uttar Pradesh',
'Tanda,Bareilly,Uttar Pradesh',
'Tehsil Aonla,Bareilly,Uttar Pradesh',
'Urla,Bareilly,Uttar Pradesh',
'Baheri,Bareilly,Uttar Pradesh',
'Basudharan,Bareilly,Uttar Pradesh',
'Bhura Bahadur Pur,Bareilly,Uttar Pradesh',
'Chathia,Bareilly,Uttar Pradesh',
'Damkhoda,Bareilly,Uttar Pradesh',
'Dandia Nagla,Bareilly,Uttar Pradesh',
'Deorania,Bareilly,Uttar Pradesh',
'Dunda Sumali,Bareilly,Uttar Pradesh',
'Faridpur,Bareilly,Uttar Pradesh',
'Girdharpur,Bareilly,Uttar Pradesh',
'Gularia Mohammad Hussain,Bareilly,Uttar Pradesh',
'Itau Dhura,Bareilly,Uttar Pradesh',
'Jasai Nagar,Bareilly,Uttar Pradesh',
'Jokhanpur,Bareilly,Uttar Pradesh',
'K.S.W.Tulsi Nagar,Bareilly,Uttar Pradesh',
'Kanman,Bareilly,Uttar Pradesh',
'Khera Ramnagar,Bareilly,Uttar Pradesh',
'Man Pur,Bareilly,Uttar Pradesh',
'Mundia Jagir,Bareilly,Uttar Pradesh',
'Mundia Nabi Bux,Bareilly,Uttar Pradesh',
'Nadeli,Bareilly,Uttar Pradesh',
'Nazarganj,Bareilly,Uttar Pradesh',
'Pachpera,Bareilly,Uttar Pradesh',
'Pindari Ashok,Bareilly,Uttar Pradesh',
'Rasoolpur,Bareilly,Uttar Pradesh',
'Rath,Bareilly,Uttar Pradesh',
'Rehpura Ganimat,Bareilly,Uttar Pradesh',
'Rohili,Bareilly,Uttar Pradesh',
'Sharif Nagar,Bareilly,Uttar Pradesh',
'Siatheri,Bareilly,Uttar Pradesh',
'Yaqoobganj,Bareilly,Uttar Pradesh',
'Agras,Bareilly,Uttar Pradesh',
'Air Force Station Bareilly,Bareilly,Uttar Pradesh',
'Akha,Bareilly,Uttar Pradesh',
'Atamanda,Bareilly,Uttar Pradesh',
'Aundh,Bareilly,Uttar Pradesh',
'B R Factory,Bareilly,Uttar Pradesh',
'Balipur,Bareilly,Uttar Pradesh',
'Baljati,Bareilly,Uttar Pradesh',
'Ballia,Bareilly,Uttar Pradesh',
'Bamanpuri,Bareilly,Uttar Pradesh',
'Bareilly Cantt,Bareilly,Uttar Pradesh',
'Bareilly City,Bareilly,Uttar Pradesh',
'Bareilly College,Bareilly,Uttar Pradesh',
'Bareilly H.O,Bareilly,Uttar Pradesh',
'Bareilly Kty,Bareilly,Uttar Pradesh',
'Bareilly R.S,Bareilly,Uttar Pradesh',
'Bhairpura,Bareilly,Uttar Pradesh',
'Bhamora,Bareilly,Uttar Pradesh',
'Bhandsar,Bareilly,Uttar Pradesh',
'Bhitaura,Bareilly,Uttar Pradesh',
'Bhojipura,Bareilly,Uttar Pradesh',
'Bhoor,Bareilly,Uttar Pradesh',
'Bhuta,Bareilly,Uttar Pradesh',
'Biharman Nagla,Bareilly,Uttar Pradesh',
'Bilwa,Bareilly,Uttar Pradesh',
'Bisharatganj,Bareilly,Uttar Pradesh',
'Bithri Chainpur,Bareilly,Uttar Pradesh',
'Bohit,Bareilly,Uttar Pradesh',
'C.A.R.I,Bareilly,Uttar Pradesh',
'C.B. Ganj,Bareilly,Uttar Pradesh',
'Chakdah,Bareilly,Uttar Pradesh',
'Chanehti,Bareilly,Uttar Pradesh',
'Chaubari,Bareilly,Uttar Pradesh',
'Chaupla,Bareilly,Uttar Pradesh',
'Dauli Raghuwar Dayal,Bareilly,Uttar Pradesh',
'Dhaura,Bareilly,Uttar Pradesh',
'Gauntara,Bareilly,Uttar Pradesh',
'Ghunsa,Bareilly,Uttar Pradesh',
'Gulab Nager,Bareilly,Uttar Pradesh',
'Haraulia,Bareilly,Uttar Pradesh',
'Izzat Nagar,Bareilly,Uttar Pradesh',
'Jogither,Bareilly,Uttar Pradesh',
'K.K.Niazia,Bareilly,Uttar Pradesh',
'Kareli,Bareilly,Uttar Pradesh',
'Khalilpur,Bareilly,Uttar Pradesh',
'Khanpur,Bareilly,Uttar Pradesh',
'Kiara,Bareilly,Uttar Pradesh',
'Kila,Bareilly,Uttar Pradesh',
'Koharapeer,Bareilly,Uttar Pradesh',
'Kunwar Pur,Bareilly,Uttar Pradesh',
'Kunwarpur Banzaria,Bareilly,Uttar Pradesh',
'Malook Pur,Bareilly,Uttar Pradesh',
'Mandauli,Bareilly,Uttar Pradesh',
'Mango Road,Bareilly,Uttar Pradesh',
'Marhinath Road,Bareilly,Uttar Pradesh',
'Marwari Ganj,Bareilly,Uttar Pradesh',
'Masjid Domni,Bareilly,Uttar Pradesh',
'Meerapur Rafiabad,Bareilly,Uttar Pradesh',
'Mehtarpur,Bareilly,Uttar Pradesh',
'Mission Hospital,Bareilly,Uttar Pradesh',
'Mohammad Ganj,Bareilly,Uttar Pradesh',
'Mohanpur,Bareilly,Uttar Pradesh',
'Mundia Ahamad Nagar,Bareilly,Uttar Pradesh',
'Municipal Board,Bareilly,Uttar Pradesh',
'Nandausi,Bareilly,Uttar Pradesh',
'Nc Lines Bareilly,Bareilly,Uttar Pradesh',
'Nekpur,Bareilly,Uttar Pradesh',
'Ner Workshop,Bareilly,Uttar Pradesh',
'Nrmc,Bareilly,Uttar Pradesh',
'Old City,Bareilly,Uttar Pradesh',
'P.A.C.Dso,Bareilly,Uttar Pradesh',
'Pachdeora Kalan,Bareilly,Uttar Pradesh',
'Prem Nagar,Bareilly,Uttar Pradesh',
'R.K.University,Bareilly,Uttar Pradesh',
'Rajau Paraspur,Bareilly,Uttar Pradesh',
'Rajendra Nagar,Bareilly,Uttar Pradesh',
'Richha,Bareilly,Uttar Pradesh',
'Rithora,Bareilly,Uttar Pradesh',
'Sadar Bazar,Bareilly,Uttar Pradesh',
'Saidpur Hakins,Bareilly,Uttar Pradesh',
'Sarai Talfi,Bareilly,Uttar Pradesh',
'Shahi,Bareilly,Uttar Pradesh',
'Shamat Ganj,Bareilly,Uttar Pradesh',
'Shergarh,Bareilly,Uttar Pradesh',
'Shivaji Marg,Bareilly,Uttar Pradesh',
'Shubhash Market,Bareilly,Uttar Pradesh',
'Shubhash Nagar,Bareilly,Uttar Pradesh',
'Shyam Ganj,Bareilly,Uttar Pradesh',
'Simra Boripur,Bareilly,Uttar Pradesh',
'Sirsa Jagir,Bareilly,Uttar Pradesh',
'Soraha,Bareilly,Uttar Pradesh',
'Surkha,Bareilly,Uttar Pradesh',
'Surla,Bareilly,Uttar Pradesh',
'Swale Nagar,Bareilly,Uttar Pradesh',
'Teolia,Bareilly,Uttar Pradesh',
'Thiria Nizawatkhan,Bareilly,Uttar Pradesh',
'Tiliapurbo,Bareilly,Uttar Pradesh',
'Umarsia,Bareilly,Uttar Pradesh',
'Padarathpur,Bareilly,Uttar Pradesh',
'Shehdana Colony,Bareilly,Uttar Pradesh',
'Khazuria Sampat,Bareilly,Uttar Pradesh',
'Kudha,Bareilly,Uttar Pradesh',
'Angadpur Khamaria,Bareilly,Uttar Pradesh',
'Athana,Bareilly,Uttar Pradesh',
'Bargawan,Bareilly,Uttar Pradesh',
'Budhauuli,Bareilly,Uttar Pradesh',
'Dalpura,Bareilly,Uttar Pradesh',
'Dhakni Rajpuri,Bareilly,Uttar Pradesh',
'Faiznagar,Bareilly,Uttar Pradesh',
'Faridpur,Bareilly,Uttar Pradesh',
'Fateh Ganj (E),Bareilly,Uttar Pradesh',
'Hazipur Khazuria B,Bareilly,Uttar Pradesh',
'Jaraul,Bareilly,Uttar Pradesh',
'Kakra Kalan,Bareilly,Uttar Pradesh',
'Khateli,Bareilly,Uttar Pradesh',
'Kuan Tanda,Bareilly,Uttar Pradesh',
'Marhi Sukatia,Bareilly,Uttar Pradesh',
'Nagaria Kalan,Bareilly,Uttar Pradesh',
'Nagaria Vikram,Bareilly,Uttar Pradesh',
'Nawada Bilsandi,Bareilly,Uttar Pradesh',
'Pachomi,Bareilly,Uttar Pradesh',
'Piperthara,Bareilly,Uttar Pradesh',
'Qadarganj,Bareilly,Uttar Pradesh',
'Raipur Hans,Bareilly,Uttar Pradesh',
'Rampura Ratan,Bareilly,Uttar Pradesh',
'Sarkara,Bareilly,Uttar Pradesh',
'Shahpur Baniyan,Bareilly,Uttar Pradesh',
'Shivpuri Raudhauli,Bareilly,Uttar Pradesh',
'Simra Bahor Nagla,Bareilly,Uttar Pradesh',
'Sunha,Bareilly,Uttar Pradesh',
'Tara Khas,Bareilly,Uttar Pradesh',
'Tiswa,Bareilly,Uttar Pradesh',
'Laungpur,Bareilly,Uttar Pradesh',
'Bairamnagar,Bareilly,Uttar Pradesh',
'Balli,Bareilly,Uttar Pradesh',
'Behroli,Bareilly,Uttar Pradesh',
'Dhaneli,Bareilly,Uttar Pradesh',
'Dhaneta,Bareilly,Uttar Pradesh',
'Dibna,Bareilly,Uttar Pradesh',
'Dunka,Bareilly,Uttar Pradesh',
'Gehluiya,Bareilly,Uttar Pradesh',
'Goola,Bareilly,Uttar Pradesh',
'Gugai,Bareilly,Uttar Pradesh',
'Gularia,Bareilly,Uttar Pradesh',
'Haldi,Bareilly,Uttar Pradesh',
'Hurhuri,Bareilly,Uttar Pradesh',
'Junahi,Bareilly,Uttar Pradesh',
'Kanakpuri,Bareilly,Uttar Pradesh',
'Kulchha,Bareilly,Uttar Pradesh',
'Mandanpur,Bareilly,Uttar Pradesh',
'Mawai Kazian,Bareilly,Uttar Pradesh',
'Meerganj,Bareilly,Uttar Pradesh',
'Mehmoodpur,Bareilly,Uttar Pradesh',
'Nagaria Sobarni,Bareilly,Uttar Pradesh',
'Narkhera,Bareilly,Uttar Pradesh',
'Sahora,Bareilly,Uttar Pradesh',
'Samaspur,Bareilly,Uttar Pradesh',
'Sheeshgarh,Bareilly,Uttar Pradesh',
'Simaria,Bareilly,Uttar Pradesh',
'Bus Stand Mirganj,Bareilly,Uttar Pradesh',
'Senthal,Bareilly,Uttar Pradesh',
'Abhayrajpur,Bareilly,Uttar Pradesh',
'Ahemdabad,Bareilly,Uttar Pradesh',
'Alahiya,Bareilly,Uttar Pradesh',
'Attangachandpur,Bareilly,Uttar Pradesh',
'Baboora,Bareilly,Uttar Pradesh',
'Bapu Nagar,Bareilly,Uttar Pradesh',
'Baraur,Bareilly,Uttar Pradesh',
'Barhepura,Bareilly,Uttar Pradesh',
'Bhadpura,Bareilly,Uttar Pradesh',
'Bhauwa Bazar,Bareilly,Uttar Pradesh',
'Bijamau,Bareilly,Uttar Pradesh',
'Bilasnagar,Bareilly,Uttar Pradesh',
'Dalelnagar,Bareilly,Uttar Pradesh',
'Dhaurera,Bareilly,Uttar Pradesh',
'Grem,Bareilly,Uttar Pradesh',
'Hafizganj,Bareilly,Uttar Pradesh',
'Harharpur,Bareilly,Uttar Pradesh',
'Jeoti Jagir,Bareilly,Uttar Pradesh',
'Keolaria,Bareilly,Uttar Pradesh',
'Khajuria Sriram,Bareilly,Uttar Pradesh',
'Mundia Bhikampur,Bareilly,Uttar Pradesh',
'Mundia Teli,Bareilly,Uttar Pradesh',
'Narharpur Gaurikhera,Bareilly,Uttar Pradesh',
'Nawabganj,Bareilly,Uttar Pradesh',
'Paiga,Bareilly,Uttar Pradesh',
'Parasrampur,Bareilly,Uttar Pradesh',
'Ratna,Bareilly,Uttar Pradesh',
'Rukumpur,Bareilly,Uttar Pradesh',
'Sardarnagar,Bareilly,Uttar Pradesh',
'Sundari Amsah,Bareilly,Uttar Pradesh',
'Gonare,Basti,Uttar Pradesh',
'Ahra,Basti,Uttar Pradesh',
'Baghari,Basti,Uttar Pradesh',
'Bai.Mustahkam,Basti,Uttar Pradesh',
'Bansgoan,Basti,Uttar Pradesh',
'Basti Bs,Basti,Uttar Pradesh',
'Basti Huchhary,Basti,Uttar Pradesh',
'Bhangura,Basti,Uttar Pradesh',
'Bodwal,Basti,Uttar Pradesh',
'Chhardahi,Basti,Uttar Pradesh',
'Civil Line,Basti,Uttar Pradesh',
'Dakhin Darwaza,Basti,Uttar Pradesh',
'Delhwa,Basti,Uttar Pradesh',
'Dihukpura,Basti,Uttar Pradesh',
'Dingrapur,Basti,Uttar Pradesh',
'Gaighat,Basti,Uttar Pradesh',
'Gandhinagar,Basti,Uttar Pradesh',
'Gauspur,Basti,Uttar Pradesh',
'ITI,Basti,Uttar Pradesh',
'Kalwari,Basti,Uttar Pradesh',
'Kanaila,Basti,Uttar Pradesh',
'Kudraha,Basti,Uttar Pradesh',
'Kusaura,Basti,Uttar Pradesh',
'Manuwa,Basti,Uttar Pradesh',
'Orijote,Basti,Uttar Pradesh',
'Pandey Bazar,Basti,Uttar Pradesh',
'Parsaon,Basti,Uttar Pradesh',
'Pipragautam,Basti,Uttar Pradesh',
'Rajpur Bairihwa,Basti,Uttar Pradesh',
'T B Clinic,Basti,Uttar Pradesh',
'Umaria,Basti,Uttar Pradesh',
'Belhara,Basti,Uttar Pradesh',
'Sansarpur,Basti,Uttar Pradesh',
'Siarapar,Basti,Uttar Pradesh',
'Walterganj,Basti,Uttar Pradesh',
'Babhni Misra,Basti,Uttar Pradesh',
'Baghnagar,Basti,Uttar Pradesh',
'Bahadurpur,Basti,Uttar Pradesh',
'Bai Pokhar,Basti,Uttar Pradesh',
'Bajahara,Basti,Uttar Pradesh',
'Bankata,Basti,Uttar Pradesh',
'Bankati Bazar,Basti,Uttar Pradesh',
'Banpur,Basti,Uttar Pradesh',
'Banskhor Kalan,Basti,Uttar Pradesh',
'Barahuwan,Basti,Uttar Pradesh',
'Basti H.O,Basti,Uttar Pradesh',
'Basti Sugar Factory,Basti,Uttar Pradesh',
'Beili,Basti,Uttar Pradesh',
'Bhagausa,Basti,Uttar Pradesh',
'Bharwalia,Basti,Uttar Pradesh',
'Bhawanipur,Basti,Uttar Pradesh',
'Bhelkha,Basti,Uttar Pradesh',
'Bhitani,Basti,Uttar Pradesh',
'Bhitiya,Basti,Uttar Pradesh',
'Bhivra,Basti,Uttar Pradesh',
'Burhi Belhar,Basti,Uttar Pradesh',
'Chhagulia Bagulia,Basti,Uttar Pradesh',
'Chhapia Sheobaran,Basti,Uttar Pradesh',
'Dandwakala,Basti,Uttar Pradesh',
'Danokuiya,Basti,Uttar Pradesh',
'Deisand,Basti,Uttar Pradesh',
'Dewapar,Basti,Uttar Pradesh',
'Dudhara,Basti,Uttar Pradesh',
'Dudhaura,Basti,Uttar Pradesh',
'Ekdangi,Basti,Uttar Pradesh',
'Ganeshpur,Basti,Uttar Pradesh',
'Gaura,Basti,Uttar Pradesh',
'Gaura Upadhyay,Basti,Uttar Pradesh',
'Gulariha Sirma,Basti,Uttar Pradesh',
'Gunakhor,Basti,Uttar Pradesh',
'Hathiagarh,Basti,Uttar Pradesh',
'Hatwa,Basti,Uttar Pradesh',
'Jamadashahi,Basti,Uttar Pradesh',
'Jeodhara,Basti,Uttar Pradesh',
'Joorie,Basti,Uttar Pradesh',
'Karah Pithia,Basti,Uttar Pradesh',
'Karahi,Basti,Uttar Pradesh',
'Karma Khan,Basti,Uttar Pradesh',
'Kasaila,Basti,Uttar Pradesh',
'Kathar Jungle,Basti,Uttar Pradesh',
'Katya,Basti,Uttar Pradesh',
'Khairati,Basti,Uttar Pradesh',
'Kharka,Basti,Uttar Pradesh',
'Khatiyawan,Basti,Uttar Pradesh',
'Khoria,Basti,Uttar Pradesh',
'Kohriyawan,Basti,Uttar Pradesh',
'Kondra Pandey,Basti,Uttar Pradesh',
'Kothwa,Basti,Uttar Pradesh',
'Kuriyar,Basti,Uttar Pradesh',
'Kusuru Khurd,Basti,Uttar Pradesh',
'Labnapar,Basti,Uttar Pradesh',
'Lakhanahat,Basti,Uttar Pradesh',
'Lalganj,Basti,Uttar Pradesh',
'Lauki Lala,Basti,Uttar Pradesh',
'Madwanagar,Basti,Uttar Pradesh',
'Mahani,Basti,Uttar Pradesh',
'Mahripur,Basti,Uttar Pradesh',
'Mahson,Basti,Uttar Pradesh',
'Majahuwameer,Basti,Uttar Pradesh',
'Majhauwa Khajuri,Basti,Uttar Pradesh',
'Manjharia Vikram,Basti,Uttar Pradesh',
'Marwatia Baboo,Basti,Uttar Pradesh',
'Marwatia Kasaila,Basti,Uttar Pradesh',
'Meetanjot,Basti,Uttar Pradesh',
'Melan Khurd,Basti,Uttar Pradesh',
'Mudadeehabeg,Basti,Uttar Pradesh',
'Munderwa,Basti,Uttar Pradesh',
'Nagahara,Basti,Uttar Pradesh',
'Nagar Bazar,Basti,Uttar Pradesh',
'Naguwa,Basti,Uttar Pradesh',
'Naraiyanpur,Basti,Uttar Pradesh',
'Newari,Basti,Uttar Pradesh',
'Niranjanpur,Basti,Uttar Pradesh',
'Orawara,Basti,Uttar Pradesh',
'Pachawa,Basti,Uttar Pradesh',
'Padari,Basti,Uttar Pradesh',
'Pagar,Basti,Uttar Pradesh',
'Pakari Araji,Basti,Uttar Pradesh',
'Pakari Dhaurahra,Basti,Uttar Pradesh',
'Pakri Jai,Basti,Uttar Pradesh',
'Parsa Jhakaria,Basti,Uttar Pradesh',
'Pokharni,Basti,Uttar Pradesh',
'Puraina Mansoor,Basti,Uttar Pradesh',
'Puraina Pandey,Basti,Uttar Pradesh',
'Purani Basti,Basti,Uttar Pradesh',
'Pursia,Basti,Uttar Pradesh',
'Raghunathpur,Basti,Uttar Pradesh',
'Rampur,Basti,Uttar Pradesh',
'Rampur,Basti,Uttar Pradesh',
'Ranipur,Basti,Uttar Pradesh',
'Rasoolpur,Basti,Uttar Pradesh',
'Rautapar,Basti,Uttar Pradesh',
'Saithawalia,Basti,Uttar Pradesh',
'Samaspur,Basti,Uttar Pradesh',
'Sanda,Basti,Uttar Pradesh',
'Sangath,Basti,Uttar Pradesh',
'Semara,Basti,Uttar Pradesh',
'Semariyawan,Basti,Uttar Pradesh',
'Sillo,Basti,Uttar Pradesh',
'Sonkhar,Basti,Uttar Pradesh',
'Subdeiyakala,Basti,Uttar Pradesh',
'Sumha,Basti,Uttar Pradesh',
'Thokwsa,Basti,Uttar Pradesh',
'Tilja,Basti,Uttar Pradesh',
'Tinharimafi,Basti,Uttar Pradesh',
'Unchgaon,Basti,Uttar Pradesh',
'Ushara Shahid,Basti,Uttar Pradesh',
'Amarediha,Basti,Uttar Pradesh',
'Amrauli Sumali,Basti,Uttar Pradesh',
'Asnahra,Basti,Uttar Pradesh',
'Bishunpurwa,Basti,Uttar Pradesh',
'Chaukwa,Basti,Uttar Pradesh',
'Dhaurahra,Basti,Uttar Pradesh',
'Dhawai,Basti,Uttar Pradesh',
'Dhosar,Basti,Uttar Pradesh',
'Jahlipur,Basti,Uttar Pradesh',
'Jinswa,Basti,Uttar Pradesh',
'Karmahiya,Basti,Uttar Pradesh',
'Lapsi,Basti,Uttar Pradesh',
'Majhauwa Khurd,Basti,Uttar Pradesh',
'Piraila Garib,Basti,Uttar Pradesh',
'Ramnagar,Basti,Uttar Pradesh',
'Saltauwa,Basti,Uttar Pradesh',
'Shivpur,Basti,Uttar Pradesh',
'Sihari Sardaha,Basti,Uttar Pradesh',
'Sonha,Basti,Uttar Pradesh',
'Teliha Deeh,Basti,Uttar Pradesh',
'Tusail,Basti,Uttar Pradesh',
'Bargadwa,Basti,Uttar Pradesh',
'Dasia,Basti,Uttar Pradesh',
'Bhanpur Babu,Basti,Uttar Pradesh',
'Parsa Damya,Basti,Uttar Pradesh',
'Mansoornagar,Basti,Uttar Pradesh',
'Ainpur,Basti,Uttar Pradesh',
'Ajgaiba Jungle,Basti,Uttar Pradesh',
'Amari Bazar,Basti,Uttar Pradesh',
'Amorha,Basti,Uttar Pradesh',
'Babhnan,Basti,Uttar Pradesh',
'Bairagal,Basti,Uttar Pradesh',
'Bairikhala,Basti,Uttar Pradesh',
'Barahpur,Basti,Uttar Pradesh',
'Barahpur,Basti,Uttar Pradesh',
'Bardia Kunwar,Basti,Uttar Pradesh',
'Barhata,Basti,Uttar Pradesh',
'Barhni,Basti,Uttar Pradesh',
'Barhya,Basti,Uttar Pradesh',
'Belbharia Ram Gulam,Basti,Uttar Pradesh',
'Belghat,Basti,Uttar Pradesh',
'Belsar,Basti,Uttar Pradesh',
'Belwaria Jungle,Basti,Uttar Pradesh',
'Bemhari,Basti,Uttar Pradesh',
'Bhadawal,Basti,Uttar Pradesh',
'Bhainsa Chaubey,Basti,Uttar Pradesh',
'Bhainsaha,Basti,Uttar Pradesh',
'Bishesharganj,Basti,Uttar Pradesh',
'Captainganj,Basti,Uttar Pradesh',
'Chilma Bazar,Basti,Uttar Pradesh',
'Chorkhari,Basti,Uttar Pradesh',
'Dailapur,Basti,Uttar Pradesh',
'Deferi,Basti,Uttar Pradesh',
'Dhenugawan,Basti,Uttar Pradesh',
'Dhirauli Babu,Basti,Uttar Pradesh',
'Diwakarpur,Basti,Uttar Pradesh',
'Dubauli Dubey,Basti,Uttar Pradesh',
'Dubaulia,Basti,Uttar Pradesh',
'Garha,Basti,Uttar Pradesh',
'Gauhania,Basti,Uttar Pradesh',
'Gaur Rs,Basti,Uttar Pradesh',
'Ghorsayen,Basti,Uttar Pradesh',
'Gopiapar,Basti,Uttar Pradesh',
'Gopinathpur,Basti,Uttar Pradesh',
'Govindpara,Basti,Uttar Pradesh',
'Haribanshpur,Basti,Uttar Pradesh',
'Harish Nagar,Basti,Uttar Pradesh',
'Harraiya,Basti,Uttar Pradesh',
'Hiyaroopur,Basti,Uttar Pradesh',
'Hundrakunwar,Basti,Uttar Pradesh',
'Itbahara,Basti,Uttar Pradesh',
'Itwakungai,Basti,Uttar Pradesh',
'Jagdishpur,Basti,Uttar Pradesh',
'Jaitapur,Basti,Uttar Pradesh',
'Jajupur,Basti,Uttar Pradesh',
'Jitipur,Basti,Uttar Pradesh',
'Kachhia,Basti,Uttar Pradesh',
'Kataria,Basti,Uttar Pradesh',
'Kaudikol,Basti,Uttar Pradesh',
'Keshwapur,Basti,Uttar Pradesh',
'Kewarimustahkam,Basti,Uttar Pradesh',
'Kharawan Kunwsar,Basti,Uttar Pradesh',
'Khesuwa,Basti,Uttar Pradesh',
'Kodai,Basti,Uttar Pradesh',
'Kurda,Basti,Uttar Pradesh',
'Lalpur,Basti,Uttar Pradesh',
'Mahadewa,Basti,Uttar Pradesh',
'Mahrajganj,Basti,Uttar Pradesh',
'Mahuwadabar,Basti,Uttar Pradesh',
'Mahuwalakhanpur,Basti,Uttar Pradesh',
'Mahuwapar,Basti,Uttar Pradesh',
'Majhauwa Babu,Basti,Uttar Pradesh',
'Malauli Gosain,Basti,Uttar Pradesh',
'Manjhilgaon,Basti,Uttar Pradesh',
'Naikapar,Basti,Uttar Pradesh',
'Nande Kuwan,Basti,Uttar Pradesh',
'Nandnagar,Basti,Uttar Pradesh',
'Nedula,Basti,Uttar Pradesh',
'Ojhaganj,Basti,Uttar Pradesh',
'Pachwas,Basti,Uttar Pradesh',
'Paikolia,Basti,Uttar Pradesh',
'Pak. Bakhtawar,Basti,Uttar Pradesh',
'Parasrampur,Basti,Uttar Pradesh',
'Pendar,Basti,Uttar Pradesh',
'Pikaura,Basti,Uttar Pradesh',
'Pipra Kazi,Basti,Uttar Pradesh',
'Pokhara,Basti,Uttar Pradesh',
'Raghunathpur,Basti,Uttar Pradesh',
'Raghwapur,Basti,Uttar Pradesh',
'Roopgarh,Basti,Uttar Pradesh',
'Salempur,Basti,Uttar Pradesh',
'Sangrampur,Basti,Uttar Pradesh',
'Sardaha Sukul,Basti,Uttar Pradesh',
'Sarraiya Atibal,Basti,Uttar Pradesh',
'Shankarpur,Basti,Uttar Pradesh',
'Sikandarpur,Basti,Uttar Pradesh',
'Sringinari,Basti,Uttar Pradesh',
'Sudipur,Basti,Uttar Pradesh',
'Sukrauli,Basti,Uttar Pradesh',
'Sukrauli Chaudhary,Basti,Uttar Pradesh',
'Thana Khas,Basti,Uttar Pradesh',
'Tharuapur,Basti,Uttar Pradesh',
'Tilakpur,Basti,Uttar Pradesh',
'Tinich,Basti,Uttar Pradesh',
'Turasi,Basti,Uttar Pradesh',
'Turkipur,Basti,Uttar Pradesh',
'Unji,Basti,Uttar Pradesh',
'Vedipur,Basti,Uttar Pradesh',
'Naghara,Basti,Uttar Pradesh',
'Ambari,Basti,Uttar Pradesh',
'Athadama,Basti,Uttar Pradesh',
'Bankatia,Basti,Uttar Pradesh',
'Bhitehara,Basti,Uttar Pradesh',
'Dandwapandey,Basti,Uttar Pradesh',
'Hanumanganj,Basti,Uttar Pradesh',
'Kerauna,Basti,Uttar Pradesh',
'Khambha,Basti,Uttar Pradesh',
'Kohra,Basti,Uttar Pradesh',
'Mahuswar,Basti,Uttar Pradesh',
'Mahuwar,Basti,Uttar Pradesh',
'Majhauwa Baikunth,Basti,Uttar Pradesh',
'Misraulia Bhaiya,Basti,Uttar Pradesh',
'Raunakala,Basti,Uttar Pradesh',
'Rayath,Basti,Uttar Pradesh',
'Rudranagar,Basti,Uttar Pradesh',
'Sabra,Basti,Uttar Pradesh',
'Sehuda Kala,Basti,Uttar Pradesh',
'Surwarkalan,Basti,Uttar Pradesh',
'Agri,Bijnor,Uttar Pradesh',
'Bakherpur Garhi,Bijnor,Uttar Pradesh',
'Bharaira,Bijnor,Uttar Pradesh',
'Bijnor H.O,Bijnor,Uttar Pradesh',
'Daranagar Ganj,Bijnor,Uttar Pradesh',
'Dharm Nagri,Bijnor,Uttar Pradesh',
'Faridpur Bhogi,Bijnor,Uttar Pradesh',
'Fatehpur Kalan,Bijnor,Uttar Pradesh',
'Gajraula Shiv,Bijnor,Uttar Pradesh',
'Kharak Jeetpur,Bijnor,Uttar Pradesh',
'Mangolpura Roopchand,Bijnor,Uttar Pradesh',
'Mo. Pur Mandawali,Bijnor,Uttar Pradesh',
'Nasiri,Bijnor,Uttar Pradesh',
'Naya Gaon,Bijnor,Uttar Pradesh',
'Prithvipur,Bijnor,Uttar Pradesh',
'Qaziwala,Bijnor,Uttar Pradesh',
'Sabdalpur Rehra,Bijnor,Uttar Pradesh',
'Saidabad,Bijnor,Uttar Pradesh',
'Sardhani,Bijnor,Uttar Pradesh',
'Suwheri,Bijnor,Uttar Pradesh',
'Uledha,Bijnor,Uttar Pradesh',
'Vidur Kuti,Bijnor,Uttar Pradesh',
'Aheerpura,Bijnor,Uttar Pradesh',
'Ajdev Khanpur,Bijnor,Uttar Pradesh',
'Akondha,Bijnor,Uttar Pradesh',
'Allauddinpur,Bijnor,Uttar Pradesh',
'Amhera,Bijnor,Uttar Pradesh',
'Aurangabad Urf Sikanderpur,Bijnor,Uttar Pradesh',
'Azampur,Bijnor,Uttar Pradesh',
'Baberpur,Bijnor,Uttar Pradesh',
'Bagarpur,Bijnor,Uttar Pradesh',
'Bahmanshora,Bijnor,Uttar Pradesh',
'Bakaina,Bijnor,Uttar Pradesh',
'Bakhrabad Urf Khatai,Bijnor,Uttar Pradesh',
'Baldiya,Bijnor,Uttar Pradesh',
'Basantpur,Bijnor,Uttar Pradesh',
'Bashta,Bijnor,Uttar Pradesh',
'Bhaisa,Bijnor,Uttar Pradesh',
'Bilai,Bijnor,Uttar Pradesh',
'Chanda Nagli,Bijnor,Uttar Pradesh',
'Chandpur,Bijnor,Uttar Pradesh',
'Chandpur Sugar Factory,Bijnor,Uttar Pradesh',
'Chowkpuri,Bijnor,Uttar Pradesh',
'Darbara,Bijnor,Uttar Pradesh',
'Datiyana,Bijnor,Uttar Pradesh',
'Dhanaura,Bijnor,Uttar Pradesh',
'Dharupur,Bijnor,Uttar Pradesh',
'Dhokalpur,Bijnor,Uttar Pradesh',
'Fazalpur Dhaki,Bijnor,Uttar Pradesh',
'Gandhore,Bijnor,Uttar Pradesh',
'Gangu Nagla,Bijnor,Uttar Pradesh',
'Haldaur,Bijnor,Uttar Pradesh',
'Heempur Buzurg,Bijnor,Uttar Pradesh',
'Heempur Deepa,Bijnor,Uttar Pradesh',
'Imliya,Bijnor,Uttar Pradesh',
'Ismailpur,Bijnor,Uttar Pradesh',
'Jalilpur,Bijnor,Uttar Pradesh',
'Jhalu,Bijnor,Uttar Pradesh',
'Khari,Bijnor,Uttar Pradesh',
'Kumharpura Urf Ibrahimpur,Bijnor,Uttar Pradesh',
'Maseet,Bijnor,Uttar Pradesh',
'Mehamdabad,Bijnor,Uttar Pradesh',
'Mirzapur Khader,Bijnor,Uttar Pradesh',
'Murhat,Bijnor,Uttar Pradesh',
'Mustafabad,Bijnor,Uttar Pradesh',
'Nagal Jat,Bijnor,Uttar Pradesh',
'Nawada,Bijnor,Uttar Pradesh',
'Nayak Nagla,Bijnor,Uttar Pradesh',
'Noorpur,Bijnor,Uttar Pradesh',
'Paijaniya,Bijnor,Uttar Pradesh',
'Pawati,Bijnor,Uttar Pradesh',
'Pheena,Bijnor,Uttar Pradesh',
'Pipli Jat,Bijnor,Uttar Pradesh',
'Rasoolpur Nagla,Bijnor,Uttar Pradesh',
'Ratagarh,Bijnor,Uttar Pradesh',
'Roniya,Bijnor,Uttar Pradesh',
'Saindwar,Bijnor,Uttar Pradesh',
'Shadipur Milak,Bijnor,Uttar Pradesh',
'Sherpur Kalyan,Bijnor,Uttar Pradesh',
'Shiwala Kalan,Bijnor,Uttar Pradesh',
'Siau,Bijnor,Uttar Pradesh',
'Singha,Bijnor,Uttar Pradesh',
'Sisauna,Bijnor,Uttar Pradesh',
'Sudnipur Rawati,Bijnor,Uttar Pradesh',
'Umri,Bijnor,Uttar Pradesh',
'Aasfabad Chaman,Bijnor,Uttar Pradesh',
'Afzalgarh,Bijnor,Uttar Pradesh',
'Akhera,Bijnor,Uttar Pradesh',
'Alaidadpur Mubarak,Bijnor,Uttar Pradesh',
'Alampur Ganvri,Bijnor,Uttar Pradesh',
'Allhapurmohkam,Bijnor,Uttar Pradesh',
'Amkhera Sanjarpur,Bijnor,Uttar Pradesh',
'Anwarpur Chandka,Bijnor,Uttar Pradesh',
'Asgaripur,Bijnor,Uttar Pradesh',
'Athai Sheikh,Bijnor,Uttar Pradesh',
'Bagwara,Bijnor,Uttar Pradesh',
'Bairmabad Garhi,Bijnor,Uttar Pradesh',
'Bakshanpur,Bijnor,Uttar Pradesh',
'Begrajpur,Bijnor,Uttar Pradesh',
'Bhanauti,Bijnor,Uttar Pradesh',
'Bhatiyana Khushalpur,Bijnor,Uttar Pradesh',
'Bhatpura,Bijnor,Uttar Pradesh',
'Bheekhawala,Bijnor,Uttar Pradesh',
'Bhogpur,Bijnor,Uttar Pradesh',
'Birla Farm,Bijnor,Uttar Pradesh',
'Bishanpur,Bijnor,Uttar Pradesh',
'Budhanpur,Bijnor,Uttar Pradesh',
'Daultabad,Bijnor,Uttar Pradesh',
'Dhakka Karamchand,Bijnor,Uttar Pradesh',
'Dhampur H.O,Bijnor,Uttar Pradesh',
'Gordhanpur,Bijnor,Uttar Pradesh',
'Habibwala,Bijnor,Uttar Pradesh',
'Hafizabad,Bijnor,Uttar Pradesh',
'Haldua Mafi,Bijnor,Uttar Pradesh',
'Haraivli,Bijnor,Uttar Pradesh',
'Harganpur Sajauli,Bijnor,Uttar Pradesh',
'Hassupura,Bijnor,Uttar Pradesh',
'Hidayatpur,Bijnor,Uttar Pradesh',
'Jamalpur Kirat,Bijnor,Uttar Pradesh',
'Jamanwala,Bijnor,Uttar Pradesh',
'Jatpura,Bijnor,Uttar Pradesh',
'Jheeran,Bijnor,Uttar Pradesh',
'Kalluwala,Bijnor,Uttar Pradesh',
'Kasampur Garhi,Bijnor,Uttar Pradesh',
'Khaspura,Bijnor,Uttar Pradesh',
'Kiwar,Bijnor,Uttar Pradesh',
'Kmala,Bijnor,Uttar Pradesh',
'Kolasagar,Bijnor,Uttar Pradesh',
'Lodhipur Milak,Bijnor,Uttar Pradesh',
'Mahua,Bijnor,Uttar Pradesh',
'Maniyawala,Bijnor,Uttar Pradesh',
'Manjhola Billoch,Bijnor,Uttar Pradesh',
'Mankuaa,Bijnor,Uttar Pradesh',
'Manpurshivpuri,Bijnor,Uttar Pradesh',
'Maqsoodpur,Bijnor,Uttar Pradesh',
'Maujampur Suraj,Bijnor,Uttar Pradesh',
'Mauri Kedarpur,Bijnor,Uttar Pradesh',
'Mauzampur Jaitra,Bijnor,Uttar Pradesh',
'Meharlipur,Bijnor,Uttar Pradesh',
'Mehmoodpur,Bijnor,Uttar Pradesh',
'Mewa Nawada,Bijnor,Uttar Pradesh',
'Milak Mukeempur,Bijnor,Uttar Pradesh',
'Milak Puranpur,Bijnor,Uttar Pradesh',
'Mirzapur,Bijnor,Uttar Pradesh',
'Mohammedpur Kamil,Bijnor,Uttar Pradesh',
'Mohammedpur Rajauri,Bijnor,Uttar Pradesh',
'Morna,Bijnor,Uttar Pradesh',
'Mukarabpuri,Bijnor,Uttar Pradesh',
'Nagli Pathwari,Bijnor,Uttar Pradesh',
'Nakibpur Khajoori,Bijnor,Uttar Pradesh',
'Narayan Kheri,Bijnor,Uttar Pradesh',
'Nasirpur Banwari,Bijnor,Uttar Pradesh',
'Nawada Kesho,Bijnor,Uttar Pradesh',
'Neendru,Bijnor,Uttar Pradesh',
'Nehtaur,Bijnor,Uttar Pradesh',
'Nwadasaidpur Jalal,Bijnor,Uttar Pradesh',
'Padli Basera,Bijnor,Uttar Pradesh',
'Palanpur,Bijnor,Uttar Pradesh',
'Phoolsanda,Bijnor,Uttar Pradesh',
'Pipalsana,Bijnor,Uttar Pradesh',
'Rahu Nagli,Bijnor,Uttar Pradesh',
'Raja-ka-tajpur,Bijnor,Uttar Pradesh',
'Rampur Bidar,Bijnor,Uttar Pradesh',
'Rasoolabad,Bijnor,Uttar Pradesh',
'Rawana Shikarpur,Bijnor,Uttar Pradesh',
'Rehar,Bijnor,Uttar Pradesh',
'Rustampur Sherpali Jat,Bijnor,Uttar Pradesh',
'Sabdalpur,Bijnor,Uttar Pradesh',
'Sadafal,Bijnor,Uttar Pradesh',
'Sadaranpur,Bijnor,Uttar Pradesh',
'Saddobair,Bijnor,Uttar Pradesh',
'Sadruddin Nagar,Bijnor,Uttar Pradesh',
'Sahaspur,Bijnor,Uttar Pradesh',
'Sarkara Chakrajmal,Bijnor,Uttar Pradesh',
'Sarkathal Sahni,Bijnor,Uttar Pradesh',
'Sedha,Bijnor,Uttar Pradesh',
'Seohara,Bijnor,Uttar Pradesh',
'Shahnagar Kurali,Bijnor,Uttar Pradesh',
'Shahpur Kheri,Bijnor,Uttar Pradesh',
'Shahzadpur,Bijnor,Uttar Pradesh',
'Shergarh,Bijnor,Uttar Pradesh',
'Sherkot,Bijnor,Uttar Pradesh',
'Sherpur Balla,Bijnor,Uttar Pradesh',
'Sikri Buzurg,Bijnor,Uttar Pradesh',
'Sipahiwala,Bijnor,Uttar Pradesh',
'Sirwasuchand,Bijnor,Uttar Pradesh',
'Suawala,Bijnor,Uttar Pradesh',
'Taharpur Said,Bijnor,Uttar Pradesh',
'Tibri,Bijnor,Uttar Pradesh',
'Udaipur,Bijnor,Uttar Pradesh',
'Umri,Bijnor,Uttar Pradesh',
'Alaihdajpur Khajuba,Bijnor,Uttar Pradesh',
'Alladinpur Bhogi,Bijnor,Uttar Pradesh',
'Badhapur,Bijnor,Uttar Pradesh',
'Baibalpur,Bijnor,Uttar Pradesh',
'Barkhera,Bijnor,Uttar Pradesh',
'Barooki,Bijnor,Uttar Pradesh',
'Bhagwanpur,Bijnor,Uttar Pradesh',
'Bhogli,Bijnor,Uttar Pradesh',
'Haijarpur,Bijnor,Uttar Pradesh',
'Harbanspur Dharam,Bijnor,Uttar Pradesh',
'Harganpur,Bijnor,Uttar Pradesh',
'Hirawali,Bijnor,Uttar Pradesh',
'Islamabad,Bijnor,Uttar Pradesh',
'Jeetpur Paldi,Bijnor,Uttar Pradesh',
'Jhilmila,Bijnor,Uttar Pradesh',
'Kotwali,Bijnor,Uttar Pradesh',
'Lakhuwala,Bijnor,Uttar Pradesh',
'Maheswari Jat,Bijnor,Uttar Pradesh',
'Majhera Shakroo,Bijnor,Uttar Pradesh',
'Manawwarpur Said,Bijnor,Uttar Pradesh',
'Mirzapur Mahesh Urf Bankpur,Bijnor,Uttar Pradesh',
'Nagina,Bijnor,Uttar Pradesh',
'Nainpura,Bijnor,Uttar Pradesh',
'Pakhanpur,Bijnor,Uttar Pradesh',
'Rajapur Sadat,Bijnor,Uttar Pradesh',
'Saidpura Sultan,Bijnor,Uttar Pradesh',
'Saidpuri Mahichand,Bijnor,Uttar Pradesh',
'Shadipur,Bijnor,Uttar Pradesh',
'Sunpata,Bijnor,Uttar Pradesh',
'Tanda Shahuwala,Bijnor,Uttar Pradesh',
'Ganjalpur,Bijnor,Uttar Pradesh',
'Akbarabad,Bijnor,Uttar Pradesh',
'Bahadarpur Sherfuddin,Bijnor,Uttar Pradesh',
'Bahupura,Bijnor,Uttar Pradesh',
'Balawali,Bijnor,Uttar Pradesh',
'Barampur,Bijnor,Uttar Pradesh',
'Bhaguwala,Bijnor,Uttar Pradesh',
'Bhojpur,Bijnor,Uttar Pradesh',
'Bijauri,Bijnor,Uttar Pradesh',
'Budgara,Bijnor,Uttar Pradesh',
'Chandanpura,Bijnor,Uttar Pradesh',
'Chandok R.S.,Bijnor,Uttar Pradesh',
'Chitawar,Bijnor,Uttar Pradesh',
'Dhansini,Bijnor,Uttar Pradesh',
'Doodhli,Bijnor,Uttar Pradesh',
'Fazalpur,Bijnor,Uttar Pradesh',
'Gaindi Khata,Bijnor,Uttar Pradesh',
'Gajraula Paimar,Bijnor,Uttar Pradesh',
'Guniapur,Bijnor,Uttar Pradesh',
'Hussainpur,Bijnor,Uttar Pradesh',
'Jahanabad Khovra,Bijnor,Uttar Pradesh',
'Jalalabad (Bijnor),Bijnor,Uttar Pradesh',
'Jalpur,Bijnor,Uttar Pradesh',
'Jatpura Bonda,Bijnor,Uttar Pradesh',
'Jhakaki,Bijnor,Uttar Pradesh',
'Jogirampuri,Bijnor,Uttar Pradesh',
'Khanpur Madho,Bijnor,Uttar Pradesh',
'Khirni Barkatpur,Bijnor,Uttar Pradesh',
'Kiratpur,Bijnor,Uttar Pradesh',
'Kishanpur Amvla,Bijnor,Uttar Pradesh',
'Kotkader,Bijnor,Uttar Pradesh',
'Kumhera,Bijnor,Uttar Pradesh',
'Lal Dhang,Bijnor,Uttar Pradesh',
'Mahawatpur Billoch,Bijnor,Uttar Pradesh',
'Maheswari Nagla,Bijnor,Uttar Pradesh',
'Mandawali,Bijnor,Uttar Pradesh',
'Mandawar,Bijnor,Uttar Pradesh',
'Mauzzampur Narayan,Bijnor,Uttar Pradesh',
'Meman Bhanera,Bijnor,Uttar Pradesh',
'Mithi Beri,Bijnor,Uttar Pradesh',
'Mohanpur,Bijnor,Uttar Pradesh',
'Mohd.Pur Devmal,Bijnor,Uttar Pradesh',
'Mohiddinpur,Bijnor,Uttar Pradesh',
'Nagal,Bijnor,Uttar Pradesh',
'Najibabad,Bijnor,Uttar Pradesh',
'Narayanpur,Bijnor,Uttar Pradesh',
'Padla,Bijnor,Uttar Pradesh',
'Raipur Berisal,Bijnor,Uttar Pradesh',
'Raipur Sadat,Bijnor,Uttar Pradesh',
'Rajpur Nawada,Bijnor,Uttar Pradesh',
'Rampur Bishna,Bijnor,Uttar Pradesh',
'Rawli,Bijnor,Uttar Pradesh',
'Sabdalpur Bitra,Bijnor,Uttar Pradesh',
'Sahanpur,Bijnor,Uttar Pradesh',
'Sikanderpur Basi,Bijnor,Uttar Pradesh',
'Simla Kalan,Bijnor,Uttar Pradesh',
'Sofatpur,Bijnor,Uttar Pradesh',
'Tanda Maidas,Bijnor,Uttar Pradesh',
'Tisotra,Bijnor,Uttar Pradesh',
'Sirasaul,Budaun,Uttar Pradesh',
'Nagla Ajmeri,Budaun,Uttar Pradesh',
'Bhatauli,Budaun,Uttar Pradesh',
'Bhoor Bisauli,Budaun,Uttar Pradesh',
'Bondri Bhoora Bhadraul,Budaun,Uttar Pradesh',
'Chitaura,Budaun,Uttar Pradesh',
'Dakarapukhta,Budaun,Uttar Pradesh',
'Danbri,Budaun,Uttar Pradesh',
'Faizganj Behta,Budaun,Uttar Pradesh',
'Gangoli,Budaun,Uttar Pradesh',
'Gauntara,Budaun,Uttar Pradesh',
'Gura Barala,Budaun,Uttar Pradesh',
'Kakheri,Budaun,Uttar Pradesh',
'Kichhla,Budaun,Uttar Pradesh',
'Laxmipur,Budaun,Uttar Pradesh',
'Mahclai,Budaun,Uttar Pradesh',
'Mansanagla,Budaun,Uttar Pradesh',
'Manunagar,Budaun,Uttar Pradesh',
'Miaoo,Budaun,Uttar Pradesh',
'Mohkampur,Budaun,Uttar Pradesh',
'Nizamuddin Purshah,Budaun,Uttar Pradesh',
'Noorpur,Budaun,Uttar Pradesh',
'Phakawali,Budaun,Uttar Pradesh',
'Qazi Mohalla,Budaun,Uttar Pradesh',
'Sahanagar Patpar Ganj,Budaun,Uttar Pradesh',
'Sakhanu,Budaun,Uttar Pradesh',
'Sangrampur,Budaun,Uttar Pradesh',
'Sikri,Budaun,Uttar Pradesh',
'Singraura,Budaun,Uttar Pradesh',
'Sisaraka,Budaun,Uttar Pradesh',
'Uraula,Budaun,Uttar Pradesh',
'Allahpur Samaspur,Budaun,Uttar Pradesh',
'Ambiapur,Budaun,Uttar Pradesh',
'Bairmai Khurd,Budaun,Uttar Pradesh',
'Bans Barolia,Budaun,Uttar Pradesh',
'Behta Gusain,Budaun,Uttar Pradesh',
'Bhusaya,Budaun,Uttar Pradesh',
'Bilsi,Budaun,Uttar Pradesh',
'Chandoi,Budaun,Uttar Pradesh',
'Dudhauni,Budaun,Uttar Pradesh',
'Gudhani,Budaun,Uttar Pradesh',
'Haibatpur,Budaun,Uttar Pradesh',
'Islamnagar,Budaun,Uttar Pradesh',
'Mirzapura Sohra,Budaun,Uttar Pradesh',
'Musepur,Budaun,Uttar Pradesh',
'Paharpur,Budaun,Uttar Pradesh',
'Parauli,Budaun,Uttar Pradesh',
'Pindol,Budaun,Uttar Pradesh',
'Rajthal,Budaun,Uttar Pradesh',
'Reonai,Budaun,Uttar Pradesh',
'Sarah Bagholi,Budaun,Uttar Pradesh',
'Sarah Barolia,Budaun,Uttar Pradesh',
'Sarup Pur,Budaun,Uttar Pradesh',
'Sateti,Budaun,Uttar Pradesh',
'Simarra Bhojpur,Budaun,Uttar Pradesh',
'Sirtaul,Budaun,Uttar Pradesh',
'Sitholi,Budaun,Uttar Pradesh',
'Surahi,Budaun,Uttar Pradesh',
'Agthra,Budaun,Uttar Pradesh',
'Atarpura,Budaun,Uttar Pradesh',
'Bagrain,Budaun,Uttar Pradesh',
'Beor Kasimabad,Budaun,Uttar Pradesh',
'Bhavipur,Budaun,Uttar Pradesh',
'Bisauli,Budaun,Uttar Pradesh',
'Chani,Budaun,Uttar Pradesh',
'Dabtori,Budaun,Uttar Pradesh',
'Gandhrauli,Budaun,Uttar Pradesh',
'Garikhanpur,Budaun,Uttar Pradesh',
'Hatsa,Budaun,Uttar Pradesh',
'Ikh Khera,Budaun,Uttar Pradesh',
'Jasrathpur,Budaun,Uttar Pradesh',
'Kangwagugna,Budaun,Uttar Pradesh',
'Karanpur,Budaun,Uttar Pradesh',
'Kariamai,Budaun,Uttar Pradesh',
'Kasaraira,Budaun,Uttar Pradesh',
'Katgaon,Budaun,Uttar Pradesh',
'Khajuria,Budaun,Uttar Pradesh',
'Khandwa,Budaun,Uttar Pradesh',
'Marandpur,Budaun,Uttar Pradesh',
'Mewali,Budaun,Uttar Pradesh',
'Mohamadpurmi,Budaun,Uttar Pradesh',
'Mundia Dhure Ki,Budaun,Uttar Pradesh',
'Nagla Barah,Budaun,Uttar Pradesh',
'Nauli Harnathpur,Budaun,Uttar Pradesh',
'Noorpur Binoni,Budaun,Uttar Pradesh',
'Parveznagar,Budaun,Uttar Pradesh',
'Pepal,Budaun,Uttar Pradesh',
'Pipri Raghunathpur,Budaun,Uttar Pradesh',
'Prithvipur,Budaun,Uttar Pradesh',
'Rehariya,Budaun,Uttar Pradesh',
'Saidpur,Budaun,Uttar Pradesh',
'Sareli Pukhta,Budaun,Uttar Pradesh',
'Sigthara,Budaun,Uttar Pradesh',
'Tara Pathakpur,Budaun,Uttar Pradesh',
'Ughaiti,Budaun,Uttar Pradesh',
'Wazirganj,Budaun,Uttar Pradesh',
'Khitaura,Budaun,Uttar Pradesh',
'Nagarjhoona,Budaun,Uttar Pradesh',
'Naithura,Budaun,Uttar Pradesh',
'Rudauin,Budaun,Uttar Pradesh',
'Bhanpur,Budaun,Uttar Pradesh',
'Khurampur Bhamori,Budaun,Uttar Pradesh',
'Urena,Budaun,Uttar Pradesh',
'Arifpur Nawada,Budaun,Uttar Pradesh',
'Asis Berkhin,Budaun,Uttar Pradesh',
'Asrasi,Budaun,Uttar Pradesh',
'Bankota,Budaun,Uttar Pradesh',
'Barachirra,Budaun,Uttar Pradesh',
'Barategdar,Budaun,Uttar Pradesh',
'Baror Amanullapur,Budaun,Uttar Pradesh',
'Baudaun Kty,Budaun,Uttar Pradesh',
'Beoli,Budaun,Uttar Pradesh',
'Beor,Budaun,Uttar Pradesh',
'Bharkuian,Budaun,Uttar Pradesh',
'Bilhat,Budaun,Uttar Pradesh',
'Binawar,Budaun,Uttar Pradesh',
'Brahmpur,Budaun,Uttar Pradesh',
'Buda R.S.,Budaun,Uttar Pradesh',
'Budaun City,Budaun,Uttar Pradesh',
'Budaun H.O,Budaun,Uttar Pradesh',
'Budhawai,Budaun,Uttar Pradesh',
'Chaudhary Sarai,Budaun,Uttar Pradesh',
'Civil Liens,Budaun,Uttar Pradesh',
'Deorijeet,Budaun,Uttar Pradesh',
'Dugraiya,Budaun,Uttar Pradesh',
'Fatehpur,Budaun,Uttar Pradesh',
'Gaurami,Budaun,Uttar Pradesh',
'Gotha,Budaun,Uttar Pradesh',
'Gularia,Budaun,Uttar Pradesh',
'Gurgaon,Budaun,Uttar Pradesh',
'Halwai Chawk,Budaun,Uttar Pradesh',
'Hatra,Budaun,Uttar Pradesh',
'Ikri,Budaun,Uttar Pradesh',
'Jagat,Budaun,Uttar Pradesh',
'Jakheli,Budaun,Uttar Pradesh',
'Jalalpur,Budaun,Uttar Pradesh',
'Jinaura,Budaun,Uttar Pradesh',
'Kakora,Budaun,Uttar Pradesh',
'Kartoli,Budaun,Uttar Pradesh',
'Katinna Berchau,Budaun,Uttar Pradesh',
'Kendela,Budaun,Uttar Pradesh',
'Kudah Shahpur,Budaun,Uttar Pradesh',
'Kumargaon,Budaun,Uttar Pradesh',
'Kurau,Budaun,Uttar Pradesh',
'Lakhanpur,Budaun,Uttar Pradesh',
'Lani Faridpur,Budaun,Uttar Pradesh',
'Maraura,Budaun,Uttar Pradesh',
'Mn Sulra,Budaun,Uttar Pradesh',
'Mongar,Budaun,Uttar Pradesh',
'Musajhag,Budaun,Uttar Pradesh',
'Nauli Fatuhabad,Budaun,Uttar Pradesh',
'Naushera,Budaun,Uttar Pradesh',
'Nizampur,Budaun,Uttar Pradesh',
'Patiali Sarai,Budaun,Uttar Pradesh',
'Police Line,Budaun,Uttar Pradesh',
'Puthi Sarai,Budaun,Uttar Pradesh',
'Qadarchawk,Budaun,Uttar Pradesh',
'Rahma,Budaun,Uttar Pradesh',
'Ram Zanpur,Budaun,Uttar Pradesh',
'Roop Pur,Budaun,Uttar Pradesh',
'Rota,Budaun,Uttar Pradesh',
'Sakri Kasimpur,Budaun,Uttar Pradesh',
'Salarpur,Budaun,Uttar Pradesh',
'Santigarh (Ujhani),Budaun,Uttar Pradesh',
'Sheikhupur,Budaun,Uttar Pradesh',
'Shyam Nagar,Budaun,Uttar Pradesh',
'Sikrauri,Budaun,Uttar Pradesh',
'Sirsa Babarai,Budaun,Uttar Pradesh',
'Sohi,Budaun,Uttar Pradesh',
'Sotha,Budaun,Uttar Pradesh',
'Station Road,Budaun,Uttar Pradesh',
'Sursena,Budaun,Uttar Pradesh',
'Ujhani,Budaun,Uttar Pradesh',
'Gidhaul,Budaun,Uttar Pradesh',
'Asafpur,Budaun,Uttar Pradesh',
'Abhigaon,Budaun,Uttar Pradesh',
'Allapur,Budaun,Uttar Pradesh',
'Azampur Bisaria,Budaun,Uttar Pradesh',
'Bela Dandi,Budaun,Uttar Pradesh',
'Bhau Nagla,Budaun,Uttar Pradesh',
'Bhundi,Budaun,Uttar Pradesh',
'Chitri,Budaun,Uttar Pradesh',
'Daharpur Kalan,Budaun,Uttar Pradesh',
'Dataganj,Budaun,Uttar Pradesh',
'Dehemu,Budaun,Uttar Pradesh',
'Gandah,Budaun,Uttar Pradesh',
'Ghilaur,Budaun,Uttar Pradesh',
'Gularia,Budaun,Uttar Pradesh',
'Gurhana,Budaun,Uttar Pradesh',
'Hazratpur,Budaun,Uttar Pradesh',
'Husainpur Pukhata,Budaun,Uttar Pradesh',
'Jamalpur,Budaun,Uttar Pradesh',
'Jeora Parrwala,Budaun,Uttar Pradesh',
'Jhuksa,Budaun,Uttar Pradesh',
'Kakrala,Budaun,Uttar Pradesh',
'Kama,Budaun,Uttar Pradesh',
'Karanpur,Budaun,Uttar Pradesh',
'Katiyan,Budaun,Uttar Pradesh',
'Katra Sadatganj,Budaun,Uttar Pradesh',
'Katra Sadatganj,Budaun,Uttar Pradesh',
'Khera Jalalpur,Budaun,Uttar Pradesh',
'Khukri,Budaun,Uttar Pradesh',
'Labhari,Budaun,Uttar Pradesh',
'Lilwan,Budaun,Uttar Pradesh',
'Mailha,Budaun,Uttar Pradesh',
'Manikapur Kaur,Budaun,Uttar Pradesh',
'Mausampur,Budaun,Uttar Pradesh',
'Mehtabpur,Budaun,Uttar Pradesh',
'Mehua Hasanganj,Budaun,Uttar Pradesh',
'Nagaria Khanu,Budaun,Uttar Pradesh',
'Nana Khera,Budaun,Uttar Pradesh',
'Nauni,Budaun,Uttar Pradesh',
'Naviganj,Budaun,Uttar Pradesh',
'Nawada Madhukar,Budaun,Uttar Pradesh',
'Palia Gujar,Budaun,Uttar Pradesh',
'Palia Pukhta,Budaun,Uttar Pradesh',
'Papar Hamzapur,Budaun,Uttar Pradesh',
'Pipla,Budaun,Uttar Pradesh',
'Prasidhpur,Budaun,Uttar Pradesh',
'Puraini,Budaun,Uttar Pradesh',
'Reonaiya,Budaun,Uttar Pradesh',
'Rizola,Budaun,Uttar Pradesh',
'Sadullaganj,Budaun,Uttar Pradesh',
'Saijani,Budaun,Uttar Pradesh',
'Salempur,Budaun,Uttar Pradesh',
'Samrer,Budaun,Uttar Pradesh',
'Sarai Piparia,Budaun,Uttar Pradesh',
'Sikandrabad,Budaun,Uttar Pradesh',
'Sisaiya Gusain,Budaun,Uttar Pradesh',
'Sukhaura,Budaun,Uttar Pradesh',
'Usawan,Budaun,Uttar Pradesh',
'Usehat,Budaun,Uttar Pradesh',
'Majhara,Budaun,Uttar Pradesh',
'Pipraul Pukhta,Budaun,Uttar Pradesh',
'Baksena,Budaun,Uttar Pradesh',
'Asadpur,Budaun,Uttar Pradesh',
'Bairpur Maharaji,Budaun,Uttar Pradesh',
'Bandarai,Budaun,Uttar Pradesh',
'Bhakrauli,Budaun,Uttar Pradesh',
'Dabthara Harlal,Budaun,Uttar Pradesh',
'Dhandwara,Budaun,Uttar Pradesh',
'Ghosali Bahan,Budaun,Uttar Pradesh',
'Gunnaur,Budaun,Uttar Pradesh',
'I.A. Babrala,Budaun,Uttar Pradesh',
'Isampur Danda,Budaun,Uttar Pradesh',
'Kashipur,Budaun,Uttar Pradesh',
'Lahara Nagla Shyam,Budaun,Uttar Pradesh',
'Madkawali,Budaun,Uttar Pradesh',
'Nadrauli,Budaun,Uttar Pradesh',
'Pataria,Budaun,Uttar Pradesh',
'Pusawali,Budaun,Uttar Pradesh',
'Rewara,Budaun,Uttar Pradesh',
'Sarai Brahman,Budaun,Uttar Pradesh',
'Babrala,Budaun,Uttar Pradesh',
'Bhirawati,Budaun,Uttar Pradesh',
'Chhapra,Budaun,Uttar Pradesh',
'Dhanari,Budaun,Uttar Pradesh',
'Dinaura,Budaun,Uttar Pradesh',
'Dupta Kalan,Budaun,Uttar Pradesh',
'Gari Bichola,Budaun,Uttar Pradesh',
'Harphari,Budaun,Uttar Pradesh',
'Hirauni,Budaun,Uttar Pradesh',
'Ikona,Budaun,Uttar Pradesh',
'Jarwar,Budaun,Uttar Pradesh',
'Jijora,Budaun,Uttar Pradesh',
'Kail,Budaun,Uttar Pradesh',
'Khaill Pur,Budaun,Uttar Pradesh',
'Mehmoodpur,Budaun,Uttar Pradesh',
'Neora,Budaun,Uttar Pradesh',
'Rajpura,Budaun,Uttar Pradesh',
'Saitua,Budaun,Uttar Pradesh',
'Shahjanabad,Budaun,Uttar Pradesh',
'Sigholi Kallu,Budaun,Uttar Pradesh',
'Singhaula Daulatsingh,Budaun,Uttar Pradesh',
'Gawan,Budaun,Uttar Pradesh',
'Afjalpur Chhaganpur,Budaun,Uttar Pradesh',
'Aslaur,Budaun,Uttar Pradesh',
'Baksar,Budaun,Uttar Pradesh',
'Bhagta Nagla,Budaun,Uttar Pradesh',
'Bhamori,Budaun,Uttar Pradesh',
'Bhawampur Kheru,Budaun,Uttar Pradesh',
'Dahagawan,Budaun,Uttar Pradesh',
'Danpur,Budaun,Uttar Pradesh',
'Danpur,Budaun,Uttar Pradesh',
'Dharampur Tappa Vaish,Budaun,Uttar Pradesh',
'Kariyaban,Budaun,Uttar Pradesh',
'Kolhai,Budaun,Uttar Pradesh',
'Kotha,Budaun,Uttar Pradesh',
'Malpurtatera,Budaun,Uttar Pradesh',
'Mithappur,Budaun,Uttar Pradesh',
'Musta Fabad Jaretha,Budaun,Uttar Pradesh',
'Nadail,Budaun,Uttar Pradesh',
'Nadha,Budaun,Uttar Pradesh',
'Narsena,Budaun,Uttar Pradesh',
'Qadrarabad,Budaun,Uttar Pradesh',
'Qaji Tola,Budaun,Uttar Pradesh',
'Rasoolpur Bela,Budaun,Uttar Pradesh',
'Rasoolpur Kalan,Budaun,Uttar Pradesh',
'Sagrai,Budaun,Uttar Pradesh',
'Sahaswan,Budaun,Uttar Pradesh',
'Samspurmalik Fatta,Budaun,Uttar Pradesh',
'Shahnagar Patpara Ganj,Budaun,Uttar Pradesh',
'Silhari,Budaun,Uttar Pradesh',
'Sirsa Khurd,Budaun,Uttar Pradesh',
'Sujawali,Budaun,Uttar Pradesh',
'Sukrullapur,Budaun,Uttar Pradesh',
'Tehra,Budaun,Uttar Pradesh',
'Tigra,Budaun,Uttar Pradesh',
'Usmanpur,Budaun,Uttar Pradesh',
'Zarifnagar,Budaun,Uttar Pradesh',
'Dhamraoli,Bulandshahar,Uttar Pradesh',
'Bansuri,Bulandshahar,Uttar Pradesh',
'Charora,Bulandshahar,Uttar Pradesh',
'Darora,Bulandshahar,Uttar Pradesh',
'Dhalana,Bulandshahar,Uttar Pradesh',
'Guraoli,Bulandshahar,Uttar Pradesh',
'Jaleel Pur,Bulandshahar,Uttar Pradesh',
'Jatpura,Bulandshahar,Uttar Pradesh',
'Kakrai,Bulandshahar,Uttar Pradesh',
'Khalor,Bulandshahar,Uttar Pradesh',
'Khanoda,Bulandshahar,Uttar Pradesh',
'Navi Nagar,Bulandshahar,Uttar Pradesh',
'Sakhani,Bulandshahar,Uttar Pradesh',
'Tauli,Bulandshahar,Uttar Pradesh',
'Titota Veer,Bulandshahar,Uttar Pradesh',
'Roop Wash,Bulandshahar,Uttar Pradesh',
'Ahar,Bulandshahar,Uttar Pradesh',
'Amargarh,Bulandshahar,Uttar Pradesh',
'Bibayana,Bulandshahar,Uttar Pradesh',
'Darawer,Bulandshahar,Uttar Pradesh',
'Jirouly,Bulandshahar,Uttar Pradesh',
'Malakpur,Bulandshahar,Uttar Pradesh',
'Mauwa Khera,Bulandshahar,Uttar Pradesh',
'Mohersha,Bulandshahar,Uttar Pradesh',
'Shikoi,Bulandshahar,Uttar Pradesh',
'Sirora Banger,Bulandshahar,Uttar Pradesh',
'Surajpur Makhena,Bulandshahar,Uttar Pradesh',
'Thana Gajraula,Bulandshahar,Uttar Pradesh',
'Andhiyar,Bulandshahar,Uttar Pradesh',
'Anupshahr,Bulandshahar,Uttar Pradesh',
'Bagsara,Bulandshahar,Uttar Pradesh',
'Barhpura,Bulandshahar,Uttar Pradesh',
'Bhaipur,Bulandshahar,Uttar Pradesh',
'Bhargava Pharmacy,Bulandshahar,Uttar Pradesh',
'Chandauk,Bulandshahar,Uttar Pradesh',
'Doulatpur Kala,Bulandshahar,Uttar Pradesh',
'Jahangirabad,Bulandshahar,Uttar Pradesh',
'Katiyawaly,Bulandshahar,Uttar Pradesh',
'Khailiya Kalyanpur,Bulandshahar,Uttar Pradesh',
'Khandoi,Bulandshahar,Uttar Pradesh',
'Ksc Mill Anupshahr,Bulandshahar,Uttar Pradesh',
'Mandi Anupshahr,Bulandshahar,Uttar Pradesh',
'Mawai,Bulandshahar,Uttar Pradesh',
'Narsena,Bulandshahar,Uttar Pradesh',
'Parly,Bulandshahar,Uttar Pradesh',
'Rewara,Bulandshahar,Uttar Pradesh',
'Uncha Gaon,Bulandshahar,Uttar Pradesh',
'Jahangirabad Mandi,Bulandshahar,Uttar Pradesh',
'Ghungharwaly,Bulandshahar,Uttar Pradesh',
'Ag School,Bulandshahar,Uttar Pradesh',
'Agaura Hameerpur,Bulandshahar,Uttar Pradesh',
'Agouta,Bulandshahar,Uttar Pradesh',
'Ajnara,Bulandshahar,Uttar Pradesh',
'Akabarpur,Bulandshahar,Uttar Pradesh',
'Asawar,Bulandshahar,Uttar Pradesh',
'Asfabad Chandpura,Bulandshahar,Uttar Pradesh',
'Ashwari,Bulandshahar,Uttar Pradesh',
'Aulina,Bulandshahar,Uttar Pradesh',
'Auranga Bad Taherpur,Bulandshahar,Uttar Pradesh',
'Baghwala,Bulandshahar,Uttar Pradesh',
'Balka,Bulandshahar,Uttar Pradesh',
'Banboai,Bulandshahar,Uttar Pradesh',
'Banhpur,Bulandshahar,Uttar Pradesh',
'Baral,Bulandshahar,Uttar Pradesh',
'Benipur,Bulandshahar,Uttar Pradesh',
'Bhatauna,Bulandshahar,Uttar Pradesh',
'Bhoor,Bulandshahar,Uttar Pradesh',
'Bhudhana,Bulandshahar,Uttar Pradesh',
'Bihta,Bulandshahar,Uttar Pradesh',
'Birouli,Bulandshahar,Uttar Pradesh',
'Birouly,Bulandshahar,Uttar Pradesh',
'Bulandshahr Kutchery,Bulandshahar,Uttar Pradesh',
'Bulandshahr H.O,Bulandshahar,Uttar Pradesh',
'Bulandshahr Tehsil,Bulandshahar,Uttar Pradesh',
'Chanderu,Bulandshahar,Uttar Pradesh',
'Chaprawat,Bulandshahar,Uttar Pradesh',
'Chitson,Bulandshahar,Uttar Pradesh',
'Chitsona Ali Pur,Bulandshahar,Uttar Pradesh',
'Dariyapur,Bulandshahar,Uttar Pradesh',
'Dav College Bulandshahr,Bulandshahar,Uttar Pradesh',
'Deputy Ganj Bulandshahr,Bulandshahar,Uttar Pradesh',
'Dhamera Keerat,Bulandshahar,Uttar Pradesh',
'Dhanoura,Bulandshahar,Uttar Pradesh',
'Dhatori,Bulandshahar,Uttar Pradesh',
'Garhiya Manpur,Bulandshahar,Uttar Pradesh',
'Ghunghraoli Banwaripur,Bulandshahar,Uttar Pradesh',
'Ginora Shekh,Bulandshahar,Uttar Pradesh',
'Gulaothi,Bulandshahar,Uttar Pradesh',
'Guthaoli,Bulandshahar,Uttar Pradesh',
'Harchana,Bulandshahar,Uttar Pradesh',
'Hattmabad,Bulandshahar,Uttar Pradesh',
'Ipdc Bulandshahr,Bulandshahar,Uttar Pradesh',
'Isapur,Bulandshahar,Uttar Pradesh',
'Jadoul,Bulandshahar,Uttar Pradesh',
'Jauly Garh,Bulandshahar,Uttar Pradesh',
'Jhal Khera,Bulandshahar,Uttar Pradesh',
'Jugsana Kalan,Bulandshahar,Uttar Pradesh',
'Kahira,Bulandshahar,Uttar Pradesh',
'Khushhalpur,Bulandshahar,Uttar Pradesh',
'Kisoli,Bulandshahar,Uttar Pradesh',
'Kota,Bulandshahar,Uttar Pradesh',
'Krishananagar,Bulandshahar,Uttar Pradesh',
'Kurli,Bulandshahar,Uttar Pradesh',
'Lalkuan,Bulandshahar,Uttar Pradesh',
'Luharaly Ludhiyana,Bulandshahar,Uttar Pradesh',
'Maithna Jagatpur,Bulandshahar,Uttar Pradesh',
'Malagarh,Bulandshahar,Uttar Pradesh',
'Manglore,Bulandshahar,Uttar Pradesh',
'Mirjapur,Bulandshahar,Uttar Pradesh',
'Mohana,Bulandshahar,Uttar Pradesh',
'Mukeempur,Bulandshahar,Uttar Pradesh',
'Naithala Hasanpur,Bulandshahar,Uttar Pradesh',
'Naya Gaon,Bulandshahar,Uttar Pradesh',
'Obs Gulaothi,Bulandshahar,Uttar Pradesh',
'Oledha,Bulandshahar,Uttar Pradesh',
'Panni Nagar,Bulandshahar,Uttar Pradesh',
'Paswasara,Bulandshahar,Uttar Pradesh',
'Pitubash,Bulandshahar,Uttar Pradesh',
'Pondhery,Bulandshahar,Uttar Pradesh',
'Rangpur,Bulandshahar,Uttar Pradesh',
'Raura,Bulandshahar,Uttar Pradesh',
'Rehamapur Siyawali,Bulandshahar,Uttar Pradesh',
'Ronda,Bulandshahar,Uttar Pradesh',
'Sarai Chhabila,Bulandshahar,Uttar Pradesh',
'Sarai Ghashi,Bulandshahar,Uttar Pradesh',
'Senta,Bulandshahar,Uttar Pradesh',
'Shahkarinagar,Bulandshahar,Uttar Pradesh',
'Shikhera,Bulandshahar,Uttar Pradesh',
'Shiwaly,Bulandshahar,Uttar Pradesh',
'Surjawaly,Bulandshahar,Uttar Pradesh',
'Utrouly,Bulandshahar,Uttar Pradesh',
'Visundhara,Bulandshahar,Uttar Pradesh',
'Asadpur Gher,Bulandshahar,Uttar Pradesh',
'Behlolpur,Bulandshahar,Uttar Pradesh',
'Belon,Bulandshahar,Uttar Pradesh',
'Bhikampur,Bulandshahar,Uttar Pradesh',
'Biroura,Bulandshahar,Uttar Pradesh',
'Chehla,Bulandshahar,Uttar Pradesh',
'Chhatary,Bulandshahar,Uttar Pradesh',
'Choundhera,Bulandshahar,Uttar Pradesh',
'Dangarh,Bulandshahar,Uttar Pradesh',
'Danpur,Bulandshahar,Uttar Pradesh',
'Daoulatpurkalan,Bulandshahar,Uttar Pradesh',
'Daurau,Bulandshahar,Uttar Pradesh',
'Debai Bazar,Bulandshahar,Uttar Pradesh',
'Debai,Bulandshahar,Uttar Pradesh',
'Dharakpur,Bulandshahar,Uttar Pradesh',
'Dharmpur,Bulandshahar,Uttar Pradesh',
'Dighi,Bulandshahar,Uttar Pradesh',
'Dogawan,Bulandshahar,Uttar Pradesh',
'Donka,Bulandshahar,Uttar Pradesh',
'Fazalpur,Bulandshahar,Uttar Pradesh',
'Ganga Garh,Bulandshahar,Uttar Pradesh',
'Indoure Khera,Bulandshahar,Uttar Pradesh',
'Jargawan,Bulandshahar,Uttar Pradesh',
'Kamona,Bulandshahar,Uttar Pradesh',
'Karanbash,Bulandshahar,Uttar Pradesh',
'Kaser Kalan,Bulandshahar,Uttar Pradesh',
'Kaser Khurd,Bulandshahar,Uttar Pradesh',
'Keeratpur,Bulandshahar,Uttar Pradesh',
'Khakhunda,Bulandshahar,Uttar Pradesh',
'Kharikbari,Bulandshahar,Uttar Pradesh',
'Khushalabad,Bulandshahar,Uttar Pradesh',
'Kunwarpur,Bulandshahar,Uttar Pradesh',
'Muradpur,Bulandshahar,Uttar Pradesh',
'Napp,Bulandshahar,Uttar Pradesh',
'Narau,Bulandshahar,Uttar Pradesh',
'Narora,Bulandshahar,Uttar Pradesh',
'Pahasu,Bulandshahar,Uttar Pradesh',
'Pilkhana,Bulandshahar,Uttar Pradesh',
'Pindrawal,Bulandshahar,Uttar Pradesh',
'Poothery Kalan,Bulandshahar,Uttar Pradesh',
'Rahim Kot,Bulandshahar,Uttar Pradesh',
'Raj Ghat,Bulandshahar,Uttar Pradesh',
'Ramghat,Bulandshahar,Uttar Pradesh',
'Rampur,Bulandshahar,Uttar Pradesh',
'Runsi,Bulandshahar,Uttar Pradesh',
'Sahar,Bulandshahar,Uttar Pradesh',
'Satoha,Bulandshahar,Uttar Pradesh',
'Satwara,Bulandshahar,Uttar Pradesh',
'Shekhpur,Bulandshahar,Uttar Pradesh',
'Soi,Bulandshahar,Uttar Pradesh',
'Talwar,Bulandshahar,Uttar Pradesh',
'Tyore Buzurg,Bulandshahar,Uttar Pradesh',
'Uamrara,Bulandshahar,Uttar Pradesh',
'Vijay Nagliya,Bulandshahar,Uttar Pradesh',
'Lalner,Bulandshahar,Uttar Pradesh',
'Arniya,Bulandshahar,Uttar Pradesh',
'Asgarpur,Bulandshahar,Uttar Pradesh',
'Aterna,Bulandshahar,Uttar Pradesh',
'Bada Gaon,Bulandshahar,Uttar Pradesh',
'Badshahpur Pachgain,Bulandshahar,Uttar Pradesh',
'Bagrai Khurd,Bulandshahar,Uttar Pradesh',
'Banail,Bulandshahar,Uttar Pradesh',
'Bhadaura Kamalpur,Bulandshahar,Uttar Pradesh',
'Bhatwara,Bulandshahar,Uttar Pradesh',
'Bichoula,Bulandshahar,Uttar Pradesh',
'Dabar,Bulandshahar,Uttar Pradesh',
'Dashhera Kherli,Bulandshahar,Uttar Pradesh',
'Devrala,Bulandshahar,Uttar Pradesh',
'Dharpa Chuhar Pur,Bulandshahar,Uttar Pradesh',
'Dinoul,Bulandshahar,Uttar Pradesh',
'Farkana Gangagarhi,Bulandshahar,Uttar Pradesh',
'Gangawaly,Bulandshahar,Uttar Pradesh',
'Gt Road Khurja,Bulandshahar,Uttar Pradesh',
'Gwarauly,Bulandshahar,Uttar Pradesh',
'Jarara,Bulandshahar,Uttar Pradesh',
'Jawal,Bulandshahar,Uttar Pradesh',
'Kalena,Bulandshahar,Uttar Pradesh',
'Karora,Bulandshahar,Uttar Pradesh',
'Kehroula,Bulandshahar,Uttar Pradesh',
'Khurja Chowk,Bulandshahar,Uttar Pradesh',
'Khurja Jn RS,Bulandshahar,Uttar Pradesh',
'Khurja H.O,Bulandshahar,Uttar Pradesh',
'Kirra,Bulandshahar,Uttar Pradesh',
'Meerpur,Bulandshahar,Uttar Pradesh',
'Munda Khera,Bulandshahar,Uttar Pradesh',
'Muni,Bulandshahar,Uttar Pradesh',
'Nagla Mahiuddinpur,Bulandshahar,Uttar Pradesh',
'Nagliya Udaibhan,Bulandshahar,Uttar Pradesh',
'Raipur Palda,Bulandshahar,Uttar Pradesh',
'Rampur Manpur,Bulandshahar,Uttar Pradesh',
'Raniaoli,Bulandshahar,Uttar Pradesh',
'Roop Wash Pachgain,Bulandshahar,Uttar Pradesh',
'Sabitgarh,Bulandshahar,Uttar Pradesh',
'Samashpur,Bulandshahar,Uttar Pradesh',
'Sarangpur,Bulandshahar,Uttar Pradesh',
'Seekri,Bulandshahar,Uttar Pradesh',
'Senda Faridpur,Bulandshahar,Uttar Pradesh',
'Shahbaz Pur,Bulandshahar,Uttar Pradesh',
'Sonda Habibpur,Bulandshahar,Uttar Pradesh',
'Subhash Road Khurja,Bulandshahar,Uttar Pradesh',
'Surjawaly,Bulandshahar,Uttar Pradesh',
'Ahmadgarh,Bulandshahar,Uttar Pradesh',
'Anchrookalan,Bulandshahar,Uttar Pradesh',
'Bohich,Bulandshahar,Uttar Pradesh',
'Daduwa Mutafabad,Bulandshahar,Uttar Pradesh',
'Kailawan,Bulandshahar,Uttar Pradesh',
'Salempur,Bulandshahar,Uttar Pradesh',
'Sarawa,Bulandshahar,Uttar Pradesh',
'Shikarpur,Bulandshahar,Uttar Pradesh',
'Utrawaly,Bulandshahar,Uttar Pradesh',
'Sanota,Bulandshahar,Uttar Pradesh',
'Bharana,Bulandshahar,Uttar Pradesh',
'Bilsoory,Bulandshahar,Uttar Pradesh',
'Dankaur,Bulandshahar,Uttar Pradesh',
'Gajipur,Bulandshahar,Uttar Pradesh',
'Geshupur,Bulandshahar,Uttar Pradesh',
'Gurukul Sikandrabad,Bulandshahar,Uttar Pradesh',
'Industrial Estate Sikandrabad,Bulandshahar,Uttar Pradesh',
'Ishmail Pur,Bulandshahar,Uttar Pradesh',
'Kakore,Bulandshahar,Uttar Pradesh',
'Kanwra,Bulandshahar,Uttar Pradesh',
'Kayasthwara Sikandrabad,Bulandshahar,Uttar Pradesh',
'Mahepa,Bulandshahar,Uttar Pradesh',
'Prangarh,Bulandshahar,Uttar Pradesh',
'Sikandrabad,Bulandshahar,Uttar Pradesh',
'Til Begum Pur,Bulandshahar,Uttar Pradesh',
'Aurangabad Aheer,Bulandshahar,Uttar Pradesh',
'Jakheta,Bulandshahar,Uttar Pradesh',
'Ahemedanagar,Bulandshahar,Uttar Pradesh',
'Akapur Tiyana,Bulandshahar,Uttar Pradesh',
'Amarpur,Bulandshahar,Uttar Pradesh',
'Aurangabad,Bulandshahar,Uttar Pradesh',
'Baddha Bazidpur,Bulandshahar,Uttar Pradesh',
'Barhana,Bulandshahar,Uttar Pradesh',
'Barkatpur,Bulandshahar,Uttar Pradesh',
'Barouli Basdev Pur,Bulandshahar,Uttar Pradesh',
'Bb Nagar,Bulandshahar,Uttar Pradesh',
'Bhainsaura,Bulandshahar,Uttar Pradesh',
'Bhainshakhur,Bulandshahar,Uttar Pradesh',
'Bhanshrouli,Bulandshahar,Uttar Pradesh',
'Bharkau,Bulandshahar,Uttar Pradesh',
'Bigraou,Bulandshahar,Uttar Pradesh',
'Bihra,Bulandshahar,Uttar Pradesh',
'Bugrasi,Bulandshahar,Uttar Pradesh',
'Buklana,Bulandshahar,Uttar Pradesh',
'Chandiyana,Bulandshahar,Uttar Pradesh',
'Chithera,Bulandshahar,Uttar Pradesh',
'Dhaniya Wali,Bulandshahar,Uttar Pradesh',
'Gesupur Barwala,Bulandshahar,Uttar Pradesh',
'Ginoura Nagly,Bulandshahar,Uttar Pradesh',
'Giroura,Bulandshahar,Uttar Pradesh',
'Hazipur,Bulandshahar,Uttar Pradesh',
'Hingwara,Bulandshahar,Uttar Pradesh',
'Jalalpur,Bulandshahar,Uttar Pradesh',
'Kamalpur,Bulandshahar,Uttar Pradesh',
'Kanauna,Bulandshahar,Uttar Pradesh',
'Khad Mohan Nagar,Bulandshahar,Uttar Pradesh',
'Khanpur,Bulandshahar,Uttar Pradesh',
'Kisola,Bulandshahar,Uttar Pradesh',
'Kuchesar,Bulandshahar,Uttar Pradesh',
'Lad Pur,Bulandshahar,Uttar Pradesh',
'Lakhaoti,Bulandshahar,Uttar Pradesh',
'Madona Jafara Bad,Bulandshahar,Uttar Pradesh',
'Mahav,Bulandshahar,Uttar Pradesh',
'Mankari,Bulandshahar,Uttar Pradesh',
'Mundi Bakapur,Bulandshahar,Uttar Pradesh',
'Nimchana,Bulandshahar,Uttar Pradesh',
'Nishurkha,Bulandshahar,Uttar Pradesh',
'Pali Partapur,Bulandshahar,Uttar Pradesh',
'Partapur,Bulandshahar,Uttar Pradesh',
'Parwana,Bulandshahar,Uttar Pradesh',
'Raghunathpur,Bulandshahar,Uttar Pradesh',
'Saidpur,Bulandshahar,Uttar Pradesh',
'Sathala,Bulandshahar,Uttar Pradesh',
'Sega Jagatpur,Bulandshahar,Uttar Pradesh',
'Shekhpur Gadwa,Bulandshahar,Uttar Pradesh',
'Shera,Bulandshahar,Uttar Pradesh',
'Sihi,Bulandshahar,Uttar Pradesh',
'Siyana,Bulandshahar,Uttar Pradesh',
'Sonjhana Jhaya,Bulandshahar,Uttar Pradesh',
'Tajpur,Bulandshahar,Uttar Pradesh',
'Waira Firozpur,Bulandshahar,Uttar Pradesh',
'Amaon,Varanasi East,Uttar Pradesh',
'Amdaha,Varanasi East,Uttar Pradesh',
'Amilia,Varanasi East,Uttar Pradesh',
'Baraura,Varanasi East,Uttar Pradesh',
'Bentairi,Varanasi East,Uttar Pradesh',
'Bhabhaura,Varanasi East,Uttar Pradesh',
'Bhaisahi,Varanasi East,Uttar Pradesh',
'Bhatraul,Varanasi East,Uttar Pradesh',
'Bhikhampur,Varanasi East,Uttar Pradesh',
'Bhorsar,Varanasi East,Uttar Pradesh',
'Chakarghatta,Varanasi East,Uttar Pradesh',
'Chakia,Varanasi East,Uttar Pradesh',
'Dhunnoo,Varanasi East,Uttar Pradesh',
'Gaighat,Varanasi East,Uttar Pradesh',
'Illia,Varanasi East,Uttar Pradesh',
'Karnaul,Varanasi East,Uttar Pradesh',
'Katwamafi,Varanasi East,Uttar Pradesh',
'Keraigaon,Varanasi East,Uttar Pradesh',
'Khakhara,Varanasi East,Uttar Pradesh',
'Kharaujha,Varanasi East,Uttar Pradesh',
'Khilchi,Varanasi East,Uttar Pradesh',
'Majhghain,Varanasi East,Uttar Pradesh',
'Musakhan,Varanasi East,Uttar Pradesh',
'Naugarh,Varanasi East,Uttar Pradesh',
'Pachwania,Varanasi East,Uttar Pradesh',
'Piparia,Varanasi East,Uttar Pradesh',
'Rampurkala,Varanasi East,Uttar Pradesh',
'Sahabganj,Varanasi East,Uttar Pradesh',
'Saidupur,Varanasi East,Uttar Pradesh',
'Shamsherpur,Varanasi East,Uttar Pradesh',
'Sikanderpur,Varanasi East,Uttar Pradesh',
'Sikarganj,Varanasi East,Uttar Pradesh',
'Tiyara,Varanasi East,Uttar Pradesh',
'Tiyari,Varanasi East,Uttar Pradesh',
'Utraut,Varanasi East,Uttar Pradesh',
'Adsand,Varanasi East,Uttar Pradesh',
'Akorha,Varanasi East,Uttar Pradesh',
'Alampur,Varanasi East,Uttar Pradesh',
'Alinagar,Varanasi East,Uttar Pradesh',
'Amara,Varanasi East,Uttar Pradesh',
'Arangi,Varanasi East,Uttar Pradesh',
'Asana,Varanasi East,Uttar Pradesh',
'Baburi,Varanasi East,Uttar Pradesh',
'Bagahikumbhapur,Varanasi East,Uttar Pradesh',
'Barahani,Varanasi East,Uttar Pradesh',
'Barthara Kalan,Varanasi East,Uttar Pradesh',
'Basila,Varanasi East,Uttar Pradesh',
'Bhadauliya,Varanasi East,Uttar Pradesh',
'Bharchha,Varanasi East,Uttar Pradesh',
'Bhatiza,Varanasi East,Uttar Pradesh',
'Bhujana,Varanasi East,Uttar Pradesh',
'Bishauri,Varanasi East,Uttar Pradesh',
'Chandasi,Varanasi East,Uttar Pradesh',
'Chandauli,Varanasi East,Uttar Pradesh',
'Chiraigaon,Varanasi East,Uttar Pradesh',
'Dandi,Varanasi East,Uttar Pradesh',
'Derwakalan,Varanasi East,Uttar Pradesh',
'Dhaneja,Varanasi East,Uttar Pradesh',
'Dharauli,Varanasi East,Uttar Pradesh',
'Dharde,Varanasi East,Uttar Pradesh',
'Dul;hipur,Varanasi East,Uttar Pradesh',
'Fesuda,Varanasi East,Uttar Pradesh',
'Gauri,Varanasi East,Uttar Pradesh',
'Ghosawa,Varanasi East,Uttar Pradesh',
'Hanumanpur,Varanasi East,Uttar Pradesh',
'Imilia,Varanasi East,Uttar Pradesh',
'Jagdish Sarai,Varanasi East,Uttar Pradesh',
'Jalilpur,Varanasi East,Uttar Pradesh',
'Jamunipur,Varanasi East,Uttar Pradesh',
'Jarkhor,Varanasi East,Uttar Pradesh',
'Jeori,Varanasi East,Uttar Pradesh',
'Kanta,Varanasi East,Uttar Pradesh',
'Khagwal,Varanasi East,Uttar Pradesh',
'Khurja,Varanasi East,Uttar Pradesh',
'Kurahana,Varanasi East,Uttar Pradesh',
'Launda,Varanasi East,Uttar Pradesh',
'Mavaiya,Varanasi East,Uttar Pradesh',
'Mugalsarai,Varanasi East,Uttar Pradesh',
'Naubatpur,Varanasi East,Uttar Pradesh',
'Niyamatabad,Varanasi East,Uttar Pradesh',
'Oyarchak,Varanasi East,Uttar Pradesh',
'Pachokhar,Varanasi East,Uttar Pradesh',
'Parasikalan,Varanasi East,Uttar Pradesh',
'Pasahi,Varanasi East,Uttar Pradesh',
'Patelnagar,Varanasi East,Uttar Pradesh',
'Railway Colony Mugalsarai,Varanasi East,Uttar Pradesh',
'Rampur,Varanasi East,Uttar Pradesh',
'Rewasa,Varanasi East,Uttar Pradesh',
'Sahupuri,Varanasi East,Uttar Pradesh',
'Saiyadraja,Varanasi East,Uttar Pradesh',
'Seruka,Varanasi East,Uttar Pradesh',
'Shivpur,Varanasi East,Uttar Pradesh',
'Sikari,Varanasi East,Uttar Pradesh',
'Sogai,Varanasi East,Uttar Pradesh',
'Vishunpura,Varanasi East,Uttar Pradesh',
'Majhwarkhas,Varanasi East,Uttar Pradesh',
'Marhi,Varanasi East,Uttar Pradesh',
'Amara,Varanasi East,Uttar Pradesh',
'Babhniyaon Raipur,Varanasi East,Uttar Pradesh',
'Dabaria,Varanasi East,Uttar Pradesh',
'Dharaon,Varanasi East,Uttar Pradesh',
'Hingutarjagdishpur,Varanasi East,Uttar Pradesh',
'Sakrari,Varanasi East,Uttar Pradesh',
'Torwan,Varanasi East,Uttar Pradesh',
'Amilai,Varanasi East,Uttar Pradesh',
'Arkaura,Varanasi East,Uttar Pradesh',
'Awajapur,Varanasi East,Uttar Pradesh',
'Awati,Varanasi East,Uttar Pradesh',
'Baghari,Varanasi East,Uttar Pradesh',
'Ballipur,Varanasi East,Uttar Pradesh',
'Baluwa,Varanasi East,Uttar Pradesh',
'Barahan,Varanasi East,Uttar Pradesh',
'Bathawar,Varanasi East,Uttar Pradesh',
'Bhojapur,Varanasi East,Uttar Pradesh',
'Chhapara,Varanasi East,Uttar Pradesh',
'Chilabali,Varanasi East,Uttar Pradesh',
'Darahara,Varanasi East,Uttar Pradesh',
'Derhgaonwa,Varanasi East,Uttar Pradesh',
'Dhanapur,Varanasi East,Uttar Pradesh',
'Dheena,Varanasi East,Uttar Pradesh',
'Dighghi,Varanasi East,Uttar Pradesh',
'Dighwat,Varanasi East,Uttar Pradesh',
'Farsandpurmohanpur,Varanasi East,Uttar Pradesh',
'Gurera,Varanasi East,Uttar Pradesh',
'Hetampur,Varanasi East,Uttar Pradesh',
'Jalalpur,Varanasi East,Uttar Pradesh',
'Janso Ki Marai,Varanasi East,Uttar Pradesh',
'Jurahardhan,Varanasi East,Uttar Pradesh',
'Kadirabad,Varanasi East,Uttar Pradesh',
'Kamalpur,Varanasi East,Uttar Pradesh',
'Kamharia,Varanasi East,Uttar Pradesh',
'Kamharia,Varanasi East,Uttar Pradesh',
'Kavarua,Varanasi East,Uttar Pradesh',
'Kawaipaharpur,Varanasi East,Uttar Pradesh',
'Kawanr,Varanasi East,Uttar Pradesh',
'Keshavpur,Varanasi East,Uttar Pradesh',
'Kharan,Varanasi East,Uttar Pradesh',
'Kharkhara,Varanasi East,Uttar Pradesh',
'Kori,Varanasi East,Uttar Pradesh',
'Laxmangarh,Varanasi East,Uttar Pradesh',
'Maharkha,Varanasi East,Uttar Pradesh',
'Mahesua Nai Bazar,Varanasi East,Uttar Pradesh',
'Mahuwarikhas,Varanasi East,Uttar Pradesh',
'Mahuwarkalan,Varanasi East,Uttar Pradesh',
'Maniyarpur,Varanasi East,Uttar Pradesh',
'Marufpur,Varanasi East,Uttar Pradesh',
'Mathela,Varanasi East,Uttar Pradesh',
'Meerasarai,Varanasi East,Uttar Pradesh',
'Merahan,Varanasi East,Uttar Pradesh',
'Nadi Nidhaura,Varanasi East,Uttar Pradesh',
'Naikot,Varanasi East,Uttar Pradesh',
'Nairhi,Varanasi East,Uttar Pradesh',
'Naraina,Varanasi East,Uttar Pradesh',
'Noori,Varanasi East,Uttar Pradesh',
'Papaura,Varanasi East,Uttar Pradesh',
'Patti,Varanasi East,Uttar Pradesh',
'Paura,Varanasi East,Uttar Pradesh',
'Pipari,Varanasi East,Uttar Pradesh',
'Prabhupur,Varanasi East,Uttar Pradesh',
'Raiytha,Varanasi East,Uttar Pradesh',
'Ramgarh,Varanasi East,Uttar Pradesh',
'Ranepur,Varanasi East,Uttar Pradesh',
'Rupetha,Varanasi East,Uttar Pradesh',
'Sadalpura,Varanasi East,Uttar Pradesh',
'Saifpur,Varanasi East,Uttar Pradesh',
'Sakaldiha Bazar,Varanasi East,Uttar Pradesh',
'Sakaldiha,Varanasi East,Uttar Pradesh',
'Samudpur,Varanasi East,Uttar Pradesh',
'Sanghati,Varanasi East,Uttar Pradesh',
'Sewari,Varanasi East,Uttar Pradesh',
'Shaheedgaon,Varanasi East,Uttar Pradesh',
'Sishaurakalan,Varanasi East,Uttar Pradesh',
'Tanda Kalan,Varanasi East,Uttar Pradesh',
'Targaonajgara,Varanasi East,Uttar Pradesh',
'Tulsiashram Nonar,Varanasi East,Uttar Pradesh',
'Verdisanda,Varanasi East,Uttar Pradesh',
'Ramakhurd,Banda,Uttar Pradesh',
'Agarahunda,Banda,Uttar Pradesh',
'Ainchwara,Banda,Uttar Pradesh',
'Asoh,Banda,Uttar Pradesh',
'Audaha,Banda,Uttar Pradesh',
'Bachharan,Banda,Uttar Pradesh',
'Baramafi,Banda,Uttar Pradesh',
'Bardwara,Banda,Uttar Pradesh',
'Bargarh,Banda,Uttar Pradesh',
'Barha Kotra,Banda,Uttar Pradesh',
'Baria,Banda,Uttar Pradesh',
'Barua,Banda,Uttar Pradesh',
'Basila,Banda,Uttar Pradesh',
'Beohara,Banda,Uttar Pradesh',
'Bhadedu,Banda,Uttar Pradesh',
'Bhaisaundha,Banda,Uttar Pradesh',
'Bhanri,Banda,Uttar Pradesh',
'Biharwan,Banda,Uttar Pradesh',
'Biyawal,Banda,Uttar Pradesh',
'Chakla,Banda,Uttar Pradesh',
'Chandramara,Banda,Uttar Pradesh',
'Chaura,Banda,Uttar Pradesh',
'Chhibon,Banda,Uttar Pradesh',
'Chillimal,Banda,Uttar Pradesh',
'Chitrakot,Banda,Uttar Pradesh',
'Darsenda,Banda,Uttar Pradesh',
'Ganiwa Parsidhpur,Banda,Uttar Pradesh',
'Ghuretanpur,Banda,Uttar Pradesh',
'Hardoli,Banda,Uttar Pradesh',
'Hariharpur,Banda,Uttar Pradesh',
'Hatwa,Banda,Uttar Pradesh',
'Itwan,Banda,Uttar Pradesh',
'Itwan Dundela,Banda,Uttar Pradesh',
'Jankikund,Banda,Uttar Pradesh',
'Kalwalia,Banda,Uttar Pradesh',
'Kapna Itaura,Banda,Uttar Pradesh',
'Karwara Bujurg,Banda,Uttar Pradesh',
'Karwi,Banda,Uttar Pradesh',
'Kaubra,Banda,Uttar Pradesh',
'Khandeho,Banda,Uttar Pradesh',
'Khaptiha,Banda,Uttar Pradesh',
'Khatwara,Banda,Uttar Pradesh',
'Khohi,Banda,Uttar Pradesh',
'Lauri,Banda,Uttar Pradesh',
'Lodhwara,Banda,Uttar Pradesh',
'Mamsi Buzurg,Banda,Uttar Pradesh',
'Mandaur,Banda,Uttar Pradesh',
'Manikpur,Banda,Uttar Pradesh',
'Markundi,Banda,Uttar Pradesh',
'Mauchhibu,Banda,Uttar Pradesh',
'Murka,Banda,Uttar Pradesh',
'Nai Bazar Karwi,Banda,Uttar Pradesh',
'Nibi,Banda,Uttar Pradesh',
'Pahari Bujurg Sani,Banda,Uttar Pradesh',
'Pahari,Banda,Uttar Pradesh',
'Pardawan,Banda,Uttar Pradesh',
'Parsaunja,Banda,Uttar Pradesh',
'Purab Patai,Banda,Uttar Pradesh',
'Purwa Tarauha,Banda,Uttar Pradesh',
'Ragauli,Banda,Uttar Pradesh',
'Raipura,Banda,Uttar Pradesh',
'Rajapur,Banda,Uttar Pradesh',
'Ram Nagar,Banda,Uttar Pradesh',
'Saraiya,Banda,Uttar Pradesh',
'Sardhuwa,Banda,Uttar Pradesh',
'Semardaha,Banda,Uttar Pradesh',
'Semaria Charandasi,Banda,Uttar Pradesh',
'Semaria Jagannathpurbasi,Banda,Uttar Pradesh',
'Sidhpur,Banda,Uttar Pradesh',
'Sigwan,Banda,Uttar Pradesh',
'Sirwawal,Banda,Uttar Pradesh',
'Titihara,Banda,Uttar Pradesh',
'Unchadih,Banda,Uttar Pradesh',
'Nai Bazar,Deoria,Uttar Pradesh',
'Garer,Deoria,Uttar Pradesh',
'Labkani,Deoria,Uttar Pradesh',
'Andila,Deoria,Uttar Pradesh',
'Bara Dixit,Deoria,Uttar Pradesh',
'Barakagaon,Deoria,Uttar Pradesh',
'Barhaj,Deoria,Uttar Pradesh',
'Bhagalpur,Deoria,Uttar Pradesh',
'Bhaidava,Deoria,Uttar Pradesh',
'Bhaluani,Deoria,Uttar Pradesh',
'Bhulaipur,Deoria,Uttar Pradesh',
'Bishunpura Dewar,Deoria,Uttar Pradesh',
'Deosia,Deoria,Uttar Pradesh',
'Dhaula Pandit,Deoria,Uttar Pradesh',
'Garauna,Deoria,Uttar Pradesh',
'Gaura Jai Nagar,Deoria,Uttar Pradesh',
'Israuli,Deoria,Uttar Pradesh',
'Kaparwar,Deoria,Uttar Pradesh',
'Karail Shukla,Deoria,Uttar Pradesh',
'Karjahan,Deoria,Uttar Pradesh',
'Karmtar Sher Khan,Deoria,Uttar Pradesh',
'Kasili,Deoria,Uttar Pradesh',
'Khori,Deoria,Uttar Pradesh',
'Koraya,Deoria,Uttar Pradesh',
'Kotpur Pipra,Deoria,Uttar Pradesh',
'Langra Bazar,Deoria,Uttar Pradesh',
'Mahen,Deoria,Uttar Pradesh',
'Marhawa,Deoria,Uttar Pradesh',
'Markara,Deoria,Uttar Pradesh',
'Mauna Garhwa,Deoria,Uttar Pradesh',
'Mirjapur,Deoria,Uttar Pradesh',
'Nandana,Deoria,Uttar Pradesh',
'Nariaon,Deoria,Uttar Pradesh',
'Nawapar,Deoria,Uttar Pradesh',
'Nema,Deoria,Uttar Pradesh',
'Paina,Deoria,Uttar Pradesh',
'Parsia Dewar,Deoria,Uttar Pradesh',
'Reoli,Deoria,Uttar Pradesh',
'Satraon,Deoria,Uttar Pradesh',
'Sonari,Deoria,Uttar Pradesh',
'Takia,Deoria,Uttar Pradesh',
'Tekua,Deoria,Uttar Pradesh',
'Telia Kalan,Deoria,Uttar Pradesh',
'Thakur Deoria,Deoria,Uttar Pradesh',
'Tikar,Deoria,Uttar Pradesh',
'Ahirauli Baghel,Deoria,Uttar Pradesh',
'Bahiari Baghel,Deoria,Uttar Pradesh',
'Balua,Deoria,Uttar Pradesh',
'Bankata Amethia,Deoria,Uttar Pradesh',
'Bankata,Deoria,Uttar Pradesh',
'Bankul,Deoria,Uttar Pradesh',
'Bansopatti,Deoria,Uttar Pradesh',
'Barka Gaon,Deoria,Uttar Pradesh',
'Bhathwa Tiwari,Deoria,Uttar Pradesh',
'Bhatpar Rani,Deoria,Uttar Pradesh',
'Bhawani Chapar,Deoria,Uttar Pradesh',
'Bhingari Bazar,Deoria,Uttar Pradesh',
'Bhopatpura,Deoria,Uttar Pradesh',
'Ghanti,Deoria,Uttar Pradesh',
'Hata,Deoria,Uttar Pradesh',
'Khampar,Deoria,Uttar Pradesh',
'Khurwasia,Deoria,Uttar Pradesh',
'Kothilwa,Deoria,Uttar Pradesh',
'Kukur Ghanti,Deoria,Uttar Pradesh',
'Maripar,Deoria,Uttar Pradesh',
'Pakri Baboo,Deoria,Uttar Pradesh',
'Paratappur,Deoria,Uttar Pradesh',
'Pipra Uttar Patti,Deoria,Uttar Pradesh',
'Rahimpur,Deoria,Uttar Pradesh',
'Ratsia,Deoria,Uttar Pradesh',
'Sarya,Deoria,Uttar Pradesh',
'Sawarenji,Deoria,Uttar Pradesh',
'Tikampar,Deoria,Uttar Pradesh',
'Inguri Bazar,Deoria,Uttar Pradesh',
'Parsia Chhitani Singh,Deoria,Uttar Pradesh',
'Sohanpur,Deoria,Uttar Pradesh',
'Bhatni,Deoria,Uttar Pradesh',
'Ametahi,Deoria,Uttar Pradesh',
'Baliawan,Deoria,Uttar Pradesh',
'Belwa,Deoria,Uttar Pradesh',
'Bhikhampura,Deoria,Uttar Pradesh',
'Deoria Budhoo Khan,Deoria,Uttar Pradesh',
'Gaura,Deoria,Uttar Pradesh',
'Govindpur,Deoria,Uttar Pradesh',
'Khaira Banua,Deoria,Uttar Pradesh',
'Mathura Chhapar,Deoria,Uttar Pradesh',
'Paikauli Maharaj,Deoria,Uttar Pradesh',
'Patherdewa,Deoria,Uttar Pradesh',
'Pipra Madan Gopal,Deoria,Uttar Pradesh',
'Rampur,Deoria,Uttar Pradesh',
'Sidhua,Deoria,Uttar Pradesh',
'Tarkulwa,Deoria,Uttar Pradesh',
'Baghauchghat,Deoria,Uttar Pradesh',
'Babhani,Deoria,Uttar Pradesh',
'Badhaya Buzurg,Deoria,Uttar Pradesh',
'Baghara,Deoria,Uttar Pradesh',
'Bairauna,Deoria,Uttar Pradesh',
'Baitalpur,Deoria,Uttar Pradesh',
'Bajaratar Mahuawa,Deoria,Uttar Pradesh',
'Bakhara Khas,Deoria,Uttar Pradesh',
'Banjaria,Deoria,Uttar Pradesh',
'Bardgonia,Deoria,Uttar Pradesh',
'Barhara,Deoria,Uttar Pradesh',
'Bariarpur,Deoria,Uttar Pradesh',
'Barpar,Deoria,Uttar Pradesh',
'Batrauli,Deoria,Uttar Pradesh',
'Batulahi,Deoria,Uttar Pradesh',
'Baurdih Tiwari,Deoria,Uttar Pradesh',
'Belkunda,Deoria,Uttar Pradesh',
'Belwania,Deoria,Uttar Pradesh',
'Bishunpura Bazar,Deoria,Uttar Pradesh',
'Chariayan Buzurg,Deoria,Uttar Pradesh',
'Chhitahi Bazar,Deoria,Uttar Pradesh',
'Deogaon,Deoria,Uttar Pradesh',
'Deoria H.O,Deoria,Uttar Pradesh',
'Deoria Kutchary,Deoria,Uttar Pradesh',
'Deoria Meer,Deoria,Uttar Pradesh',
'Deoria New Colony,Deoria,Uttar Pradesh',
'Deoria Sadar R.S.,Deoria,Uttar Pradesh',
'Dhanauti Khurd,Deoria,Uttar Pradesh',
'G.I.Estate,Deoria,Uttar Pradesh',
'Gauri Bazar,Deoria,Uttar Pradesh',
'Gotha Rasoolpur,Deoria,Uttar Pradesh',
'Hanuman Mandir,Deoria,Uttar Pradesh',
'Hata Banuadih,Deoria,Uttar Pradesh',
'Indupur,Deoria,Uttar Pradesh',
'Jogam,Deoria,Uttar Pradesh',
'Kalaban,Deoria,Uttar Pradesh',
'Kanchanpur,Deoria,Uttar Pradesh',
'Karjahan,Deoria,Uttar Pradesh',
'Karmajeetpur,Deoria,Uttar Pradesh',
'Kataura,Deoria,Uttar Pradesh',
'Katrari,Deoria,Uttar Pradesh',
'Kauntey Nagar,Deoria,Uttar Pradesh',
'Khairatia,Deoria,Uttar Pradesh',
'Khukhundoo,Deoria,Uttar Pradesh',
'Kotwa Misir,Deoria,Uttar Pradesh',
'Kushahari,Deoria,Uttar Pradesh',
'Lahilpar,Deoria,Uttar Pradesh',
'Lerha,Deoria,Uttar Pradesh',
'Madrapali Bharth Rai,Deoria,Uttar Pradesh',
'Mahuapatan,Deoria,Uttar Pradesh',
'Majhgaon,Deoria,Uttar Pradesh',
'Mathia Sahu,Deoria,Uttar Pradesh',
'Mehaharhangpur,Deoria,Uttar Pradesh',
'Mushari,Deoria,Uttar Pradesh',
'Pakaha,Deoria,Uttar Pradesh',
'Pandaypur,Deoria,Uttar Pradesh',
'Parsia Jaddu,Deoria,Uttar Pradesh',
'Patherhat,Deoria,Uttar Pradesh',
'Phulwaria Lachhi,Deoria,Uttar Pradesh',
'Pipara Chandrabhan,Deoria,Uttar Pradesh',
'Piperpanti,Deoria,Uttar Pradesh',
'Piprajham,Deoria,Uttar Pradesh',
'Ram Gulam Tola,Deoria,Uttar Pradesh',
'Rampur Awasthi,Deoria,Uttar Pradesh',
'Rampur Mahuabari,Deoria,Uttar Pradesh',
'Rampurgarh,Deoria,Uttar Pradesh',
'Ranihawa,Deoria,Uttar Pradesh',
'S.V.Marg,Deoria,Uttar Pradesh',
'Sadhopur,Deoria,Uttar Pradesh',
'Sakutai,Deoria,Uttar Pradesh',
'Shahjahanpur,Deoria,Uttar Pradesh',
'Shahpur Shukla,Deoria,Uttar Pradesh',
'Sirjam Khas,Deoria,Uttar Pradesh',
'Sirsia Gotha,Deoria,Uttar Pradesh',
'Sirsia Khohia,Deoria,Uttar Pradesh',
'Siswa Panday,Deoria,Uttar Pradesh',
'Sohasa,Deoria,Uttar Pradesh',
'Sohnaria,Deoria,Uttar Pradesh',
'Sonughat,Deoria,Uttar Pradesh',
'Udhopur,Deoria,Uttar Pradesh',
'Baida,Deoria,Uttar Pradesh',
'Baraon,Deoria,Uttar Pradesh',
'Bardihadal,Deoria,Uttar Pradesh',
'Baurdih,Deoria,Uttar Pradesh',
'Belawa Dubauli,Deoria,Uttar Pradesh',
'Bhelaur,Deoria,Uttar Pradesh',
'Chakarwa,Deoria,Uttar Pradesh',
'Chhapauli,Deoria,Uttar Pradesh',
'Ekauna,Deoria,Uttar Pradesh',
'Ekla Mishraulia,Deoria,Uttar Pradesh',
'Fatehpur,Deoria,Uttar Pradesh',
'Jamira,Deoria,Uttar Pradesh',
'Jogia Buzurg,Deoria,Uttar Pradesh',
'Jokaha Khas,Deoria,Uttar Pradesh',
'Kanhauli,Deoria,Uttar Pradesh',
'Karauta,Deoria,Uttar Pradesh',
'Khareshar,Deoria,Uttar Pradesh',
'Koilgarha,Deoria,Uttar Pradesh',
'Korawa,Deoria,Uttar Pradesh',
'Laxmipur,Deoria,Uttar Pradesh',
'Madanpur,Deoria,Uttar Pradesh',
'Mahiganj,Deoria,Uttar Pradesh',
'Majha Narain,Deoria,Uttar Pradesh',
'Manga Kodar,Deoria,Uttar Pradesh',
'Nagawa Khas,Deoria,Uttar Pradesh',
'Naipur,Deoria,Uttar Pradesh',
'Nakail,Deoria,Uttar Pradesh',
'Pach Lari,Deoria,Uttar Pradesh',
'Pachrukha,Deoria,Uttar Pradesh',
'Pipara Kachhar,Deoria,Uttar Pradesh',
'Rudrapur,Deoria,Uttar Pradesh',
'Samogar,Deoria,Uttar Pradesh',
'Saraon,Deoria,Uttar Pradesh',
'Shitalmajha,Deoria,Uttar Pradesh',
'Tara Sara,Deoria,Uttar Pradesh',
'Tiwai,Deoria,Uttar Pradesh',
'Ahirauli,Deoria,Uttar Pradesh',
'Ajana,Deoria,Uttar Pradesh',
'Babhnauli Pandey,Deoria,Uttar Pradesh',
'Bagaha,Deoria,Uttar Pradesh',
'Baidauli,Deoria,Uttar Pradesh',
'Baikunth Pur,Deoria,Uttar Pradesh',
'Bakuchi,Deoria,Uttar Pradesh',
'Balepur,Deoria,Uttar Pradesh',
'Balua Afgan,Deoria,Uttar Pradesh',
'Bankata Misir,Deoria,Uttar Pradesh',
'Bardiha Parsuram,Deoria,Uttar Pradesh',
'Barhara,Deoria,Uttar Pradesh',
'Barthi,Deoria,Uttar Pradesh',
'Baurdih,Deoria,Uttar Pradesh',
'Belwa Baboo,Deoria,Uttar Pradesh',
'Bharahey Chaura,Deoria,Uttar Pradesh',
'Bhera Pakar,Deoria,Uttar Pradesh',
'Bijapur Jhantaur,Deoria,Uttar Pradesh',
'Chakarawa Bahordas,Deoria,Uttar Pradesh',
'Chanuki,Deoria,Uttar Pradesh',
'Chero,Deoria,Uttar Pradesh',
'Chordiha,Deoria,Uttar Pradesh',
'Churia,Deoria,Uttar Pradesh',
'D.B. Ashram,Deoria,Uttar Pradesh',
'Deoria Urf Shampur,Deoria,Uttar Pradesh',
'Dharmer,Deoria,Uttar Pradesh',
'Dol Chhapra,Deoria,Uttar Pradesh',
'Dumari,Deoria,Uttar Pradesh',
'Dumwalia,Deoria,Uttar Pradesh',
'Itahua Chandauli,Deoria,Uttar Pradesh',
'Jaitpura,Deoria,Uttar Pradesh',
'Karaundi,Deoria,Uttar Pradesh',
'Kharwania,Deoria,Uttar Pradesh',
'Khema Dei,Deoria,Uttar Pradesh',
'Kodara,Deoria,Uttar Pradesh',
'Lar Road,Deoria,Uttar Pradesh',
'Lar,Deoria,Uttar Pradesh',
'Madhawapur,Deoria,Uttar Pradesh',
'Mahuja,Deoria,Uttar Pradesh',
'Majhauli Raj,Deoria,Uttar Pradesh',
'Majhwalia,Deoria,Uttar Pradesh',
'Malkauli `,Deoria,Uttar Pradesh',
'Matiara Jagdish,Deoria,Uttar Pradesh',
'Mehraunaghat,Deoria,Uttar Pradesh',
'Nadauli,Deoria,Uttar Pradesh',
'Naini,Deoria,Uttar Pradesh',
'Nonapar,Deoria,Uttar Pradesh',
'Noonkhar,Deoria,Uttar Pradesh',
'Padari Bazar,Deoria,Uttar Pradesh',
'Panika Bazar,Deoria,Uttar Pradesh',
'Parsia Mishir,Deoria,Uttar Pradesh',
'Payasi,Deoria,Uttar Pradesh',
'Peokol,Deoria,Uttar Pradesh',
'Pindi,Deoria,Uttar Pradesh',
'Pipara Bithal,Deoria,Uttar Pradesh',
'Pipara Dixit,Deoria,Uttar Pradesh',
'Pipara Mishir,Deoria,Uttar Pradesh',
'Pipara Ramdhar,Deoria,Uttar Pradesh',
'Pipara Shukul,Deoria,Uttar Pradesh',
'Puraini,Deoria,Uttar Pradesh',
'Raibari,Deoria,Uttar Pradesh',
'Rampur Buzurg,Deoria,Uttar Pradesh',
'Rampur Khori Bari,Deoria,Uttar Pradesh',
'Rawatpar Amethia,Deoria,Uttar Pradesh',
'Ropan Chhapara,Deoria,Uttar Pradesh',
'Sajaon,Deoria,Uttar Pradesh',
'Salaempur,Deoria,Uttar Pradesh',
'Sallahpur,Deoria,Uttar Pradesh',
'Sisawa,Deoria,Uttar Pradesh',
'Sohnag,Deoria,Uttar Pradesh',
'Srinagar,Deoria,Uttar Pradesh',
'Sutawar,Deoria,Uttar Pradesh',
'Thengval Dubey,Deoria,Uttar Pradesh',
'Tulsi Bara,Deoria,Uttar Pradesh',
'Akbarpurkot,Etah,Uttar Pradesh',
'Aliganj,Etah,Uttar Pradesh',
'Alipur,Etah,Uttar Pradesh',
'Alliyapur,Etah,Uttar Pradesh',
'Amraulirattanpur,Etah,Uttar Pradesh',
'Angriya,Etah,Uttar Pradesh',
'Barahpur,Etah,Uttar Pradesh',
'Barna,Etah,Uttar Pradesh',
'Baroliya,Etah,Uttar Pradesh',
'Bhalol,Etah,Uttar Pradesh',
'Bhargain,Etah,Uttar Pradesh',
'Bhaupura,Etah,Uttar Pradesh',
'Bijora,Etah,Uttar Pradesh',
'Bilsad,Etah,Uttar Pradesh',
'Daheliya,Etah,Uttar Pradesh',
'Daheliyapooth,Etah,Uttar Pradesh',
'Datauli,Etah,Uttar Pradesh',
'Datingara,Etah,Uttar Pradesh',
'Dharoli,Etah,Uttar Pradesh',
'Dhumri,Etah,Uttar Pradesh',
'Fagnaul,Etah,Uttar Pradesh',
'Gahi,Etah,Uttar Pradesh',
'Gariya Jagannath,Etah,Uttar Pradesh',
'Jaithra,Etah,Uttar Pradesh',
'Jasmai,Etah,Uttar Pradesh',
'Jasrathpur,Etah,Uttar Pradesh',
'Jiroliya,Etah,Uttar Pradesh',
'Junedpur,Etah,Uttar Pradesh',
'Kaila,Etah,Uttar Pradesh',
'Kakora,Etah,Uttar Pradesh',
'Kalua Teel Pur,Etah,Uttar Pradesh',
'Kasela,Etah,Uttar Pradesh',
'Kharsulia,Etah,Uttar Pradesh',
'Khirya Nagar Shah,Etah,Uttar Pradesh',
'Luhari Kherra,Etah,Uttar Pradesh',
'Majhola,Etah,Uttar Pradesh',
'Meidupura,Etah,Uttar Pradesh',
'Mohammadnagar Bajhera,Etah,Uttar Pradesh',
'Mokampur,Etah,Uttar Pradesh',
'Nadrala,Etah,Uttar Pradesh',
'Nagla Gajpat,Etah,Uttar Pradesh',
'Nagla Leeladhar,Etah,Uttar Pradesh',
'Pardanapur,Etah,Uttar Pradesh',
'Pinjari,Etah,Uttar Pradesh',
'Raja Ka Rampur,Etah,Uttar Pradesh',
'Rupdhani,Etah,Uttar Pradesh',
'Sahadat Nagar,Etah,Uttar Pradesh',
'Sarai Aghat,Etah,Uttar Pradesh',
'Sarauth,Etah,Uttar Pradesh',
'Sarutiya,Etah,Uttar Pradesh',
'Shahpur Tehla,Etah,Uttar Pradesh',
'Shikhpura,Etah,Uttar Pradesh',
'Suhagpur,Etah,Uttar Pradesh',
'Targawan,Etah,Uttar Pradesh',
'Ubhai Asadnagar,Etah,Uttar Pradesh',
'Udaipura,Etah,Uttar Pradesh',
'Ahamdabad,Etah,Uttar Pradesh',
'Ahemadpur Nagla Dhanu,Etah,Uttar Pradesh',
'Ambarpur Rejor,Etah,Uttar Pradesh',
'Angadpur,Etah,Uttar Pradesh',
'Aruna Nagar,Etah,Uttar Pradesh',
'Aun,Etah,Uttar Pradesh',
'Awagarh,Etah,Uttar Pradesh',
'Babsa,Etah,Uttar Pradesh',
'Banthal Kutukpur,Etah,Uttar Pradesh',
'Barai,Etah,Uttar Pradesh',
'Barauli,Etah,Uttar Pradesh',
'Barigawan,Etah,Uttar Pradesh',
'Basundhara,Etah,Uttar Pradesh',
'Begaur,Etah,Uttar Pradesh',
'Bhadwas,Etah,Uttar Pradesh',
'Bhagipur,Etah,Uttar Pradesh',
'Bhagwala,Etah,Uttar Pradesh',
'Bhartoli,Etah,Uttar Pradesh',
'Bijauri,Etah,Uttar Pradesh',
'Brahm Sajiwan,Etah,Uttar Pradesh',
'Burhenabad,Etah,Uttar Pradesh',
'Chaprai Sikandarpur,Etah,Uttar Pradesh',
'Chhachena,Etah,Uttar Pradesh',
'Chhoti Nidhaoli,Etah,Uttar Pradesh',
'Collectorate Compound,Etah,Uttar Pradesh',
'Datai,Etah,Uttar Pradesh',
'Dhiramai,Etah,Uttar Pradesh',
'Etah H.O,Etah,Uttar Pradesh',
'Gandhi Market,Etah,Uttar Pradesh',
'Garhi,Etah,Uttar Pradesh',
'Garia Sheelam,Etah,Uttar Pradesh',
'Girora,Etah,Uttar Pradesh',
'Gobra,Etah,Uttar Pradesh',
'Hirondi,Etah,Uttar Pradesh',
'Ishara Purbi,Etah,Uttar Pradesh',
'Jalalpur Santhal,Etah,Uttar Pradesh',
'Jamlapur,Etah,Uttar Pradesh',
'Jeskhpur,Etah,Uttar Pradesh',
'Jirsimi,Etah,Uttar Pradesh',
'Jitauli,Etah,Uttar Pradesh',
'Jogamai Kalan,Etah,Uttar Pradesh',
'Kagrool,Etah,Uttar Pradesh',
'Kakrawali,Etah,Uttar Pradesh',
'Kansuri,Etah,Uttar Pradesh',
'Kantore,Etah,Uttar Pradesh',
'Kartala,Etah,Uttar Pradesh',
'Kashon,Etah,Uttar Pradesh',
'Kawar,Etah,Uttar Pradesh',
'Khaddua,Etah,Uttar Pradesh',
'Lalgarhi,Etah,Uttar Pradesh',
'Lodhamai,Etah,Uttar Pradesh',
'Lothra,Etah,Uttar Pradesh',
'Loya Badshapur,Etah,Uttar Pradesh',
'Mahua Khaira,Etah,Uttar Pradesh',
'Malwan,Etah,Uttar Pradesh',
'Marehara,Etah,Uttar Pradesh',
'Marthara Bhagwandas,Etah,Uttar Pradesh',
'Milawali,Etah,Uttar Pradesh',
'Mirehachi,Etah,Uttar Pradesh',
'Mohanpura,Etah,Uttar Pradesh',
'Muiddinpur,Etah,Uttar Pradesh',
'Nagla Galu,Etah,Uttar Pradesh',
'Nagla Khilli,Etah,Uttar Pradesh',
'Nagla Pawal,Etah,Uttar Pradesh',
'Nandpur Bailamay,Etah,Uttar Pradesh',
'Naya Bans,Etah,Uttar Pradesh',
'Neorai,Etah,Uttar Pradesh',
'Nidholi Kalan,Etah,Uttar Pradesh',
'Nigoh Hasanpur,Etah,Uttar Pradesh',
'Pamas,Etah,Uttar Pradesh',
'Parson,Etah,Uttar Pradesh',
'Patiali Gate,Etah,Uttar Pradesh',
'Peepal Khairia,Etah,Uttar Pradesh',
'Phaphoto,Etah,Uttar Pradesh',
'Pilua,Etah,Uttar Pradesh',
'Puraon,Etah,Uttar Pradesh',
'Rajpur,Etah,Uttar Pradesh',
'Rarpatti,Etah,Uttar Pradesh',
'Rijor,Etah,Uttar Pradesh',
'Rustamgarh,Etah,Uttar Pradesh',
'Saina Kalan,Etah,Uttar Pradesh',
'Sakeet,Etah,Uttar Pradesh',
'Sarnau,Etah,Uttar Pradesh',
'Sarvodaya Ashram,Etah,Uttar Pradesh',
'Sheetal Pur,Etah,Uttar Pradesh',
'Sheorai,Etah,Uttar Pradesh',
'Sirsa Tippu,Etah,Uttar Pradesh',
'Songra,Etah,Uttar Pradesh',
'Sonhar,Etah,Uttar Pradesh',
'Isauli,Etah,Uttar Pradesh',
'Sarai Neem,Etah,Uttar Pradesh',
'Simrau,Etah,Uttar Pradesh',
'Badhawali,Etah,Uttar Pradesh',
'Berni,Etah,Uttar Pradesh',
'Bhondela,Etah,Uttar Pradesh',
'Chirgawan,Etah,Uttar Pradesh',
'Dalshahpur,Etah,Uttar Pradesh',
'Dholeswar,Etah,Uttar Pradesh',
'Gahaitoo,Etah,Uttar Pradesh',
'Ganehspur,Etah,Uttar Pradesh',
'Gudaun,Etah,Uttar Pradesh',
'Jainpura,Etah,Uttar Pradesh',
'Jalesar,Etah,Uttar Pradesh',
'Jamon,Etah,Uttar Pradesh',
'Jhinwar,Etah,Uttar Pradesh',
'Manora,Etah,Uttar Pradesh',
'Margayan,Etah,Uttar Pradesh',
'Misauli,Etah,Uttar Pradesh',
'Mitraul,Etah,Uttar Pradesh',
'Nagla Anni,Etah,Uttar Pradesh',
'Narau,Etah,Uttar Pradesh',
'Naukhera,Etah,Uttar Pradesh',
'Neem Khera,Etah,Uttar Pradesh',
'Pilkhatra,Etah,Uttar Pradesh',
'Punhera,Etah,Uttar Pradesh',
'Rajmal,Etah,Uttar Pradesh',
'Rajwali,Etah,Uttar Pradesh',
'Rejua,Etah,Uttar Pradesh',
'Shahnagar Timarua,Etah,Uttar Pradesh',
'Shakrauli,Etah,Uttar Pradesh',
'Takhawan,Etah,Uttar Pradesh',
'Tikathar,Etah,Uttar Pradesh',
'Ummargarh,Etah,Uttar Pradesh',
'Maksud Pur,Etah,Uttar Pradesh',
'Barabhodela,Etah,Uttar Pradesh',
'Baraikalyanpur,Etah,Uttar Pradesh',
'Borakalan,Etah,Uttar Pradesh',
'Gahrana,Etah,Uttar Pradesh',
'Jalukhera,Etah,Uttar Pradesh',
'Jarani Kalan,Etah,Uttar Pradesh',
'Khatout,Etah,Uttar Pradesh',
'Narura,Etah,Uttar Pradesh',
'Pipehra,Etah,Uttar Pradesh',
'Pondari,Etah,Uttar Pradesh',
'Rohina Mirjapur,Etah,Uttar Pradesh',
'Magrauli,Etah,Uttar Pradesh',
'Abhaipura,Etah,Uttar Pradesh',
'Achalpur,Etah,Uttar Pradesh',
'Amanpur,Etah,Uttar Pradesh',
'Amirasa,Etah,Uttar Pradesh',
'Arjunpur Nauabad,Etah,Uttar Pradesh',
'Badria,Etah,Uttar Pradesh',
'Bahadurpur,Etah,Uttar Pradesh',
'Barahdwari,Etah,Uttar Pradesh',
'Baznagar,Etah,Uttar Pradesh',
'Behta,Etah,Uttar Pradesh',
'Beri,Etah,Uttar Pradesh',
'Bilram,Etah,Uttar Pradesh',
'Devri Prahlad Pur,Etah,Uttar Pradesh',
'Dholna,Etah,Uttar Pradesh',
'Faroli,Etah,Uttar Pradesh',
'Ganga Garh,Etah,Uttar Pradesh',
'Gaupura,Etah,Uttar Pradesh',
'Gorha,Etah,Uttar Pradesh',
'Goyati,Etah,Uttar Pradesh',
'Harsena,Etah,Uttar Pradesh',
'Jahangirpur,Etah,Uttar Pradesh',
'Jakhera,Etah,Uttar Pradesh',
'Kachhela,Etah,Uttar Pradesh',
'Kadarwadi,Etah,Uttar Pradesh',
'Kanar Kheraa,Etah,Uttar Pradesh',
'Karsana,Etah,Uttar Pradesh',
'Kasganj RS,Etah,Uttar Pradesh',
'Kasganj,Etah,Uttar Pradesh',
'Kayampur Baheria,Etah,Uttar Pradesh',
'Khairpur,Etah,Uttar Pradesh',
'Khojpur,Etah,Uttar Pradesh',
'Kinawa,Etah,Uttar Pradesh',
'Kisarauli,Etah,Uttar Pradesh',
'Kudhar,Etah,Uttar Pradesh',
'Kumraua,Etah,Uttar Pradesh',
'Kutukpur Kaseri,Etah,Uttar Pradesh',
'Mahawar,Etah,Uttar Pradesh',
'Mahdva,Etah,Uttar Pradesh',
'Malikpur,Etah,Uttar Pradesh',
'Mehmood Pur Pukhata,Etah,Uttar Pradesh',
'Mehni Sora,Etah,Uttar Pradesh',
'Mihari,Etah,Uttar Pradesh',
'Mohani Mamoorganj,Etah,Uttar Pradesh',
'Mubarik Pur Mafi,Etah,Uttar Pradesh',
'Myasur,Etah,Uttar Pradesh',
'Nadarmai,Etah,Uttar Pradesh',
'Nadrai,Etah,Uttar Pradesh',
'Nagla Katila,Etah,Uttar Pradesh',
'Nameni,Etah,Uttar Pradesh',
'Nawab Ganj,Etah,Uttar Pradesh',
'Neoli,Etah,Uttar Pradesh',
'Pachgain,Etah,Uttar Pradesh',
'Partappur,Etah,Uttar Pradesh',
'Pathreki,Etah,Uttar Pradesh',
'Pidora,Etah,Uttar Pradesh',
'Piwari,Etah,Uttar Pradesh',
'Rekhpur,Etah,Uttar Pradesh',
'Roshan Nagar,Etah,Uttar Pradesh',
'Salai,Etah,Uttar Pradesh',
'Salempur Bebe,Etah,Uttar Pradesh',
'Salempur Pironda,Etah,Uttar Pradesh',
'Samaspur Dengri,Etah,Uttar Pradesh',
'Sarsai Narau,Etah,Uttar Pradesh',
'Sirawali,Etah,Uttar Pradesh',
'Soron,Etah,Uttar Pradesh',
'Sujrai,Etah,Uttar Pradesh',
'Tharachithara,Etah,Uttar Pradesh',
'Tilsai,Etah,Uttar Pradesh',
'Tirlokpur,Etah,Uttar Pradesh',
'Virahampuri,Etah,Uttar Pradesh',
'Wazirpur,Etah,Uttar Pradesh',
'Yakootganj,Etah,Uttar Pradesh',
'Ashokpur,Etah,Uttar Pradesh',
'Aurangabad,Etah,Uttar Pradesh',
'Bahdola,Etah,Uttar Pradesh',
'Bahora,Etah,Uttar Pradesh',
'Bahrojpur,Etah,Uttar Pradesh',
'Ballia,Etah,Uttar Pradesh',
'Bastarmau,Etah,Uttar Pradesh',
'Bhensrasi,Etah,Uttar Pradesh',
'Bhujpura,Etah,Uttar Pradesh',
'Chirola,Etah,Uttar Pradesh',
'Dhondhara,Etah,Uttar Pradesh',
'Fatehpur,Etah,Uttar Pradesh',
'Garka,Etah,Uttar Pradesh',
'Ghansinghpur,Etah,Uttar Pradesh',
'Gunjdundwara,Etah,Uttar Pradesh',
'Hathodaban,Etah,Uttar Pradesh',
'Jagpura,Etah,Uttar Pradesh',
'Kadarganj,Etah,Uttar Pradesh',
'Kamalpur,Etah,Uttar Pradesh',
'Karampur,Etah,Uttar Pradesh',
'Khaduya,Etah,Uttar Pradesh',
'Khiriya Patti,Etah,Uttar Pradesh',
'Magthara,Etah,Uttar Pradesh',
'Midhola Bujurg,Etah,Uttar Pradesh',
'Mohanpur,Etah,Uttar Pradesh',
'Myau,Etah,Uttar Pradesh',
'Nagla Bhimsen,Etah,Uttar Pradesh',
'Nagla Pohpi,Etah,Uttar Pradesh',
'Nardoli,Etah,Uttar Pradesh',
'Narthar,Etah,Uttar Pradesh',
'Naugaon,Etah,Uttar Pradesh',
'Patiali,Etah,Uttar Pradesh',
'Pilkhuni,Etah,Uttar Pradesh',
'Pithanpur,Etah,Uttar Pradesh',
'Raja Rijola,Etah,Uttar Pradesh',
'Rajepur Kurra,Etah,Uttar Pradesh',
'Sahawar,Etah,Uttar Pradesh',
'Sahori,Etah,Uttar Pradesh',
'Samaspur,Etah,Uttar Pradesh',
'Sanauri Khas,Etah,Uttar Pradesh',
'Sarawal,Etah,Uttar Pradesh',
'Sikehara,Etah,Uttar Pradesh',
'Singpur,Etah,Uttar Pradesh',
'Sirhpura,Etah,Uttar Pradesh',
'Sultanpur,Etah,Uttar Pradesh',
'Sunngarhi,Etah,Uttar Pradesh',
'Thana Darioganj,Etah,Uttar Pradesh',
'Aheripur,Etawah,Uttar Pradesh',
'Anantraam Sonasi,Etawah,Uttar Pradesh',
'Andawa,Etawah,Uttar Pradesh',
'Baharpura,Etawah,Uttar Pradesh',
'Bakauli,Etawah,Uttar Pradesh',
'Bakewar,Etawah,Uttar Pradesh',
'Beena,Etawah,Uttar Pradesh',
'Ber,Etawah,Uttar Pradesh',
'Bhadsan,Etawah,Uttar Pradesh',
'Bharthana,Etawah,Uttar Pradesh',
'Bijoli,Etawah,Uttar Pradesh',
'Birondhi,Etawah,Uttar Pradesh',
'Bojha,Etawah,Uttar Pradesh',
'Chaubia,Etawah,Uttar Pradesh',
'Colleger Road Bharthana,Etawah,Uttar Pradesh',
'Darbatpur,Etawah,Uttar Pradesh',
'Durgapura,Etawah,Uttar Pradesh',
'Fatehpura,Etawah,Uttar Pradesh',
'Garhwana,Etawah,Uttar Pradesh',
'Ghughsina,Etawah,Uttar Pradesh',
'Girdharipura,Etawah,Uttar Pradesh',
'Gulabpura,Etawah,Uttar Pradesh',
'Indraukhi,Etawah,Uttar Pradesh',
'Ingurri,Etawah,Uttar Pradesh',
'Kadampur,Etawah,Uttar Pradesh',
'Kakrahi,Etawah,Uttar Pradesh',
'Kandheshi Pachar,Etawah,Uttar Pradesh',
'Karri,Etawah,Uttar Pradesh',
'Kauwa,Etawah,Uttar Pradesh',
'Kharagpur Saraiya,Etawah,Uttar Pradesh',
'Kudrail,Etawah,Uttar Pradesh',
'Kunetha,Etawah,Uttar Pradesh',
'Kunwara,Etawah,Uttar Pradesh',
'Kushna,Etawah,Uttar Pradesh',
'Ludhiani,Etawah,Uttar Pradesh',
'Malhausi,Etawah,Uttar Pradesh',
'Maman,Etawah,Uttar Pradesh',
'Mandir Mahewa,Etawah,Uttar Pradesh',
'Merhi Dudhi,Etawah,Uttar Pradesh',
'Moonj,Etawah,Uttar Pradesh',
'Niwarikalan,Etawah,Uttar Pradesh',
'Pali Khurd,Etawah,Uttar Pradesh',
'Parasana,Etawah,Uttar Pradesh',
'Phoolpur,Etawah,Uttar Pradesh',
'Pilkhana,Etawah,Uttar Pradesh',
'Prithvirampur,Etawah,Uttar Pradesh',
'Punja,Etawah,Uttar Pradesh',
'Purana Bharthana,Etawah,Uttar Pradesh',
'Puraoli,Etawah,Uttar Pradesh',
'Purela,Etawah,Uttar Pradesh',
'Ramain,Etawah,Uttar Pradesh',
'Sainfi,Etawah,Uttar Pradesh',
'Samhon,Etawah,Uttar Pradesh',
'Samthar,Etawah,Uttar Pradesh',
'Sarai Chauri,Etawah,Uttar Pradesh',
'Sarawa,Etawah,Uttar Pradesh',
'Sarsai Helu,Etawah,Uttar Pradesh',
'Sarsai Nawar,Etawah,Uttar Pradesh',
'Sekhupur Adhar Singh,Etawah,Uttar Pradesh',
'Sherpur,Etawah,Uttar Pradesh',
'Takha,Etawah,Uttar Pradesh',
'Ujhiani,Etawah,Uttar Pradesh',
'Umarsenda,Etawah,Uttar Pradesh',
'Ureng,Etawah,Uttar Pradesh',
'Usrahar,Etawah,Uttar Pradesh',
'Jagannathpur,Etawah,Uttar Pradesh',
'Nagaria Yadwan,Etawah,Uttar Pradesh',
'Bachheri,Etawah,Uttar Pradesh',
'Bahadurpurghar,Etawah,Uttar Pradesh',
'Bansari,Etawah,Uttar Pradesh',
'Barechha,Etawah,Uttar Pradesh',
'Bidauri,Etawah,Uttar Pradesh',
'Bidhipura,Etawah,Uttar Pradesh',
'Bindwa Kalan,Etawah,Uttar Pradesh',
'Bindwa Khurd,Etawah,Uttar Pradesh',
'Bithauli,Etawah,Uttar Pradesh',
'Chakar Nagar,Etawah,Uttar Pradesh',
'Chandrapura,Etawah,Uttar Pradesh',
'Chindauli,Etawah,Uttar Pradesh',
'Ekari,Etawah,Uttar Pradesh',
'Eknaur,Etawah,Uttar Pradesh',
'Gauhani,Etawah,Uttar Pradesh',
'Kandheshi Dhar,Etawah,Uttar Pradesh',
'Lakhana,Etawah,Uttar Pradesh',
'Lavedi,Etawah,Uttar Pradesh',
'Nandgaon,Etawah,Uttar Pradesh',
'Paharpura,Etawah,Uttar Pradesh',
'Piproli Gadhia,Etawah,Uttar Pradesh',
'Rajpur,Etawah,Uttar Pradesh',
'Sahson,Etawah,Uttar Pradesh',
'Sindaus,Etawah,Uttar Pradesh',
'Takrupur,Etawah,Uttar Pradesh',
'Titawali,Etawah,Uttar Pradesh',
'Chaurela,Etawah,Uttar Pradesh',
'Jagtauli,Etawah,Uttar Pradesh',
'Ajabpur,Etawah,Uttar Pradesh',
'Ashok Nagar,Etawah,Uttar Pradesh',
'Bahuri,Etawah,Uttar Pradesh',
'Baisolighat,Etawah,Uttar Pradesh',
'Bajaria,Etawah,Uttar Pradesh',
'Baralokpur,Etawah,Uttar Pradesh',
'Barauli Jamunapar,Etawah,Uttar Pradesh',
'Barhpura,Etawah,Uttar Pradesh',
'Basrehar,Etawah,Uttar Pradesh',
'Birari,Etawah,Uttar Pradesh',
'Chandanpur,Etawah,Uttar Pradesh',
'Chitbhawan,Etawah,Uttar Pradesh',
'Dadora,Etawah,Uttar Pradesh',
'Distt Board Etawah,Etawah,Uttar Pradesh',
'Ekdil,Etawah,Uttar Pradesh',
'Etawah City,Etawah,Uttar Pradesh',
'Etawah H.O,Etawah,Uttar Pradesh',
'Etawah Kutchary,Etawah,Uttar Pradesh',
'Etawah New City,Etawah,Uttar Pradesh',
'Garhaita,Etawah,Uttar Pradesh',
'Gati,Etawah,Uttar Pradesh',
'I. T. I. Etawah,Etawah,Uttar Pradesh',
'Jaitpura Par,Etawah,Uttar Pradesh',
'Jarhauli,Etawah,Uttar Pradesh',
'K. K. D. C. Etawah,Etawah,Uttar Pradesh',
'Kamet,Etawah,Uttar Pradesh',
'Karba Bujurg,Etawah,Uttar Pradesh',
'Lalpura Etawah,Etawah,Uttar Pradesh',
'Maniamau,Etawah,Uttar Pradesh',
'Manikpur Bissu,Etawah,Uttar Pradesh',
'Mugalpur Naraini,Etawah,Uttar Pradesh',
'Murong,Etawah,Uttar Pradesh',
'Musaoli,Etawah,Uttar Pradesh',
'Pachhayagaon,Etawah,Uttar Pradesh',
'Pilkhar,Etawah,Uttar Pradesh',
'Pratapner,Etawah,Uttar Pradesh',
'Prithvipur,Etawah,Uttar Pradesh',
'Ram Lila Road,Etawah,Uttar Pradesh',
'Ritaur,Etawah,Uttar Pradesh',
'Satyawadi Etawah,Etawah,Uttar Pradesh',
'Udi,Etawah,Uttar Pradesh',
'Balrai,Etawah,Uttar Pradesh',
'Bauth,Etawah,Uttar Pradesh',
'Bibamau,Etawah,Uttar Pradesh',
'Dhanua,Etawah,Uttar Pradesh',
'Dharwar,Etawah,Uttar Pradesh',
'Garhi Ram Dhan,Etawah,Uttar Pradesh',
'Jagsora,Etawah,Uttar Pradesh',
'Jasohan,Etawah,Uttar Pradesh',
'Jaswant Nagar Bazar,Etawah,Uttar Pradesh',
'Jaswant Nagar,Etawah,Uttar Pradesh',
'Jhabrapura,Etawah,Uttar Pradesh',
'Kaisth,Etawah,Uttar Pradesh',
'Kukaoli,Etawah,Uttar Pradesh',
'Kursena,Etawah,Uttar Pradesh',
'Malajani,Etawah,Uttar Pradesh',
'Nagla Ram Sunder,Etawah,Uttar Pradesh',
'Nagla Taur,Etawah,Uttar Pradesh',
'Niloi,Etawah,Uttar Pradesh',
'Sirhaul,Etawah,Uttar Pradesh',
'Sishat,Etawah,Uttar Pradesh',
'Vijaypura,Etawah,Uttar Pradesh',
'Abhinaypur Pathakpur,Etawah,Uttar Pradesh',
'Adhiyapur,Etawah,Uttar Pradesh',
'Baroli Khurd,Etawah,Uttar Pradesh',
'Chakwa Bujurg,Etawah,Uttar Pradesh',
'Dataoli,Etawah,Uttar Pradesh',
'Ginja,Etawah,Uttar Pradesh',
'Hardoi,Etawah,Uttar Pradesh',
'Heonra,Etawah,Uttar Pradesh',
'Kathua,Etawah,Uttar Pradesh',
'Kharduli,Etawah,Uttar Pradesh',
'Kharkauli,Etawah,Uttar Pradesh',
'Kheda Helu,Etawah,Uttar Pradesh',
'Kuiya,Etawah,Uttar Pradesh',
'Kumahwar,Etawah,Uttar Pradesh',
'Larkhaur,Etawah,Uttar Pradesh',
'Rahin,Etawah,Uttar Pradesh',
'Saifai,Etawah,Uttar Pradesh',
'Santoshpur Ghat,Etawah,Uttar Pradesh',
'Sarangpura,Etawah,Uttar Pradesh',
'Sirsa,Etawah,Uttar Pradesh',
'Vaidpura,Etawah,Uttar Pradesh',
'Banghusara,Faizabad,Uttar Pradesh',
'Chwardhar,Faizabad,Uttar Pradesh',
'Adilpur,Faizabad,Uttar Pradesh',
'Anjana,Faizabad,Uttar Pradesh',
'Arsath,Faizabad,Uttar Pradesh',
'Asrewa,Faizabad,Uttar Pradesh',
'Bainti,Faizabad,Uttar Pradesh',
'Ballipur,Faizabad,Uttar Pradesh',
'Banket,Faizabad,Uttar Pradesh',
'Banswar Kalan,Faizabad,Uttar Pradesh',
'Baraon,Faizabad,Uttar Pradesh',
'Barehta,Faizabad,Uttar Pradesh',
'Basantpur,Faizabad,Uttar Pradesh',
'Belarambagh,Faizabad,Uttar Pradesh',
'Beni Gaddopur,Faizabad,Uttar Pradesh',
'Benipur,Faizabad,Uttar Pradesh',
'Bhadauli,Faizabad,Uttar Pradesh',
'Bhaironpur Tikari,Faizabad,Uttar Pradesh',
'Bharatkund,Faizabad,Uttar Pradesh',
'Bhav Nathpur,Faizabad,Uttar Pradesh',
'Bhawapur,Faizabad,Uttar Pradesh',
'Bhitergaon,Faizabad,Uttar Pradesh',
'Bikapur,Faizabad,Uttar Pradesh',
'Chamela,Faizabad,Uttar Pradesh',
'Chaurebazar,Faizabad,Uttar Pradesh',
'Dahema,Faizabad,Uttar Pradesh',
'Dashrathpur,Faizabad,Uttar Pradesh',
'Dehriyawan,Faizabad,Uttar Pradesh',
'Dharehata Dashrathpur,Faizabad,Uttar Pradesh',
'Gangauli,Faizabad,Uttar Pradesh',
'Gaura,Faizabad,Uttar Pradesh',
'Gayaspur,Faizabad,Uttar Pradesh',
'Gayasuddinpur,Faizabad,Uttar Pradesh',
'Ghuritikar,Faizabad,Uttar Pradesh',
'Gundhaur,Faizabad,Uttar Pradesh',
'Haiderganj,Faizabad,Uttar Pradesh',
'Hathigo,Faizabad,Uttar Pradesh',
'Jagdishpur,Faizabad,Uttar Pradesh',
'Jaishingmau,Faizabad,Uttar Pradesh',
'Jalapur Bhaggoo,Faizabad,Uttar Pradesh',
'Janabazar,Faizabad,Uttar Pradesh',
'Janjwara,Faizabad,Uttar Pradesh',
'Jyoti Sadan,Faizabad,Uttar Pradesh',
'Kailkeshopur,Faizabad,Uttar Pradesh',
'Kakauli,Faizabad,Uttar Pradesh',
'Kannawan,Faizabad,Uttar Pradesh',
'Katari,Faizabad,Uttar Pradesh',
'Kesharuabujurg,Faizabad,Uttar Pradesh',
'Khamipurnidhiywan,Faizabad,Uttar Pradesh',
'Khapraila Bazar,Faizabad,Uttar Pradesh',
'Kodaila,Faizabad,Uttar Pradesh',
'Konchha,Faizabad,Uttar Pradesh',
'Koro Raghopur,Faizabad,Uttar Pradesh',
'Kumbhiya,Faizabad,Uttar Pradesh',
'Kurha,Faizabad,Uttar Pradesh',
'Mahawan,Faizabad,Uttar Pradesh',
'Majurddinpur,Faizabad,Uttar Pradesh',
'Malethu Buzurg,Faizabad,Uttar Pradesh',
'Malethukanak,Faizabad,Uttar Pradesh',
'Mangari,Faizabad,Uttar Pradesh',
'Marui Sahai Singh,Faizabad,Uttar Pradesh',
'Mian Ganj,Faizabad,Uttar Pradesh',
'Mumrej Nagar,Faizabad,Uttar Pradesh',
'Naipura,Faizabad,Uttar Pradesh',
'Netwari Chaturpur,Faizabad,Uttar Pradesh',
'Ninhiyawan Bazar,Faizabad,Uttar Pradesh',
'Nuawan Baidara,Faizabad,Uttar Pradesh',
'Pachgawan,Faizabad,Uttar Pradesh',
'Pachiyana,Faizabad,Uttar Pradesh',
'Paliachalpur,Faizabad,Uttar Pradesh',
'Para Tajpur,Faizabad,Uttar Pradesh',
'Paraspur Sathra,Faizabad,Uttar Pradesh',
'Paroma,Faizabad,Uttar Pradesh',
'Parsawan,Faizabad,Uttar Pradesh',
'Pohpi,Faizabad,Uttar Pradesh',
'Punhad,Faizabad,Uttar Pradesh',
'Raithua,Faizabad,Uttar Pradesh',
'Ramnagar Chaukia,Faizabad,Uttar Pradesh',
'Rampur Bhagan,Faizabad,Uttar Pradesh',
'Rauhari,Faizabad,Uttar Pradesh',
'Ruroo,Faizabad,Uttar Pradesh',
'Sagar Pati Pandhula,Faizabad,Uttar Pradesh',
'Sarai Khargi,Faizabad,Uttar Pradesh',
'Saraibhanauli,Faizabad,Uttar Pradesh',
'Sherpur Para,Faizabad,Uttar Pradesh',
'Sihipur,Faizabad,Uttar Pradesh',
'Sihoriya,Faizabad,Uttar Pradesh',
'Singhora,Faizabad,Uttar Pradesh',
'Sohawal Saloni,Faizabad,Uttar Pradesh',
'Sonaura Gaupur,Faizabad,Uttar Pradesh',
'Sonbarsa,Faizabad,Uttar Pradesh',
'Sulhepur,Faizabad,Uttar Pradesh',
'Sulhepur,Faizabad,Uttar Pradesh',
'Taarun Blgara,Faizabad,Uttar Pradesh',
'Teria,Faizabad,Uttar Pradesh',
'Tharia Kalan,Faizabad,Uttar Pradesh',
'Tikari,Faizabad,Uttar Pradesh',
'Toron Darab Ganj,Faizabad,Uttar Pradesh',
'Udharna,Faizabad,Uttar Pradesh',
'Urwa Vaish,Faizabad,Uttar Pradesh',
'Acharya Nagar,Faizabad,Uttar Pradesh',
'Achhora,Faizabad,Uttar Pradesh',
'Alnabhari,Faizabad,Uttar Pradesh',
'Alwalpur,Faizabad,Uttar Pradesh',
'Amsin,Faizabad,Uttar Pradesh',
'Ankaripur,Faizabad,Uttar Pradesh',
'Asgawan,Faizabad,Uttar Pradesh',
'Atraura,Faizabad,Uttar Pradesh',
'Ayodhya RS,Faizabad,Uttar Pradesh',
'Ayodhya,Faizabad,Uttar Pradesh',
'Babuapur,Faizabad,Uttar Pradesh',
'Baihari,Faizabad,Uttar Pradesh',
'Bakarganj,Faizabad,Uttar Pradesh',
'Bala Paikauli,Faizabad,Uttar Pradesh',
'Balrampur,Faizabad,Uttar Pradesh',
'Bandanpur,Faizabad,Uttar Pradesh',
'Bankegaon,Faizabad,Uttar Pradesh',
'Basantpur,Faizabad,Uttar Pradesh',
'Benawa,Faizabad,Uttar Pradesh',
'Beraspur,Faizabad,Uttar Pradesh',
'Bhoya,Faizabad,Uttar Pradesh',
'Chachikpur,Faizabad,Uttar Pradesh',
'Chandrikaganj,Faizabad,Uttar Pradesh',
'Chirra Mohammad Pur,Faizabad,Uttar Pradesh',
'Dabha Samer,Faizabad,Uttar Pradesh',
'Dadera,Faizabad,Uttar Pradesh',
'Dalpatpur,Faizabad,Uttar Pradesh',
'Darshan Nagar,Faizabad,Uttar Pradesh',
'Dasauli,Faizabad,Uttar Pradesh',
'Deogarh,Faizabad,Uttar Pradesh',
'Deokali,Faizabad,Uttar Pradesh',
'Dharamarg,Faizabad,Uttar Pradesh',
'Dhrampur,Faizabad,Uttar Pradesh',
'Dilasiganj,Faizabad,Uttar Pradesh',
'Faizabad Cantt,Faizabad,Uttar Pradesh',
'Faizabad City,Faizabad,Uttar Pradesh',
'Faizabad H.O,Faizabad,Uttar Pradesh',
'Faizabad Kutchery,Faizabad,Uttar Pradesh',
'Faizabad RS,Faizabad,Uttar Pradesh',
'Fatehganj,Faizabad,Uttar Pradesh',
'Fatehpur Kamasin,Faizabad,Uttar Pradesh',
'Gadopur Majhwa,Faizabad,Uttar Pradesh',
'Golaghat,Faizabad,Uttar Pradesh',
'Gopalpur,Faizabad,Uttar Pradesh',
'Goshaiganj,Faizabad,Uttar Pradesh',
'Gurukul,Faizabad,Uttar Pradesh',
'Gyanpur,Faizabad,Uttar Pradesh',
'Haripur Jalalabad,Faizabad,Uttar Pradesh',
'Itaura,Faizabad,Uttar Pradesh',
'J.K.I.C. Arwat,Faizabad,Uttar Pradesh',
'Jaitpur Nidhiyawan,Faizabad,Uttar Pradesh',
'Janapur,Faizabad,Uttar Pradesh',
'Janpad Chikitsalaya,Faizabad,Uttar Pradesh',
'Jarhi,Faizabad,Uttar Pradesh',
'Kandhari Bazar,Faizabad,Uttar Pradesh',
'Karampur Barsawan,Faizabad,Uttar Pradesh',
'Khajurahat,Faizabad,Uttar Pradesh',
'Khandasa,Faizabad,Uttar Pradesh',
'Khapradih,Faizabad,Uttar Pradesh',
'Kondri,Faizabad,Uttar Pradesh',
'Kot Sarai,Faizabad,Uttar Pradesh',
'Lalbagh,Faizabad,Uttar Pradesh',
'Lalpur,Faizabad,Uttar Pradesh',
'Madna,Faizabad,Uttar Pradesh',
'Mahawan,Faizabad,Uttar Pradesh',
'Mahboobganj,Faizabad,Uttar Pradesh',
'Mahuwari,Faizabad,Uttar Pradesh',
'Mandi Samiti,Faizabad,Uttar Pradesh',
'Mau Yaduwanshpur,Faizabad,Uttar Pradesh',
'Maya,Faizabad,Uttar Pradesh',
'Motibagah,Faizabad,Uttar Pradesh',
'Motinagar,Faizabad,Uttar Pradesh',
'Mumtaj Nagar,Faizabad,Uttar Pradesh',
'Naka Muzzafra,Faizabad,Uttar Pradesh',
'Narain Ashram,Faizabad,Uttar Pradesh',
'Narainpur,Faizabad,Uttar Pradesh',
'Niywan,Faizabad,Uttar Pradesh',
'Pausara,Faizabad,Uttar Pradesh',
'Pora,Faizabad,Uttar Pradesh',
'Purah,Faizabad,Uttar Pradesh',
'Rajapur Sraiya,Faizabad,Uttar Pradesh',
'Ramapur,Faizabad,Uttar Pradesh',
'Ramkot,Faizabad,Uttar Pradesh',
'Ramnagar Colony,Faizabad,Uttar Pradesh',
'Rampur Sardha,Faizabad,Uttar Pradesh',
'Raniwan,Faizabad,Uttar Pradesh',
'Ranopali,Faizabad,Uttar Pradesh',
'Rasulabad,Faizabad,Uttar Pradesh',
'Rauwa Lohangpur,Faizabad,Uttar Pradesh',
'Rohiyawan,Faizabad,Uttar Pradesh',
'Sadar Bazar,Faizabad,Uttar Pradesh',
'Sahadatganj,Faizabad,Uttar Pradesh',
'Sahebganj,Faizabad,Uttar Pradesh',
'Samda,Faizabad,Uttar Pradesh',
'Sanethu,Faizabad,Uttar Pradesh',
'Sarai Sagar,Faizabad,Uttar Pradesh',
'Sariyawan,Faizabad,Uttar Pradesh',
'Shahnawan,Faizabad,Uttar Pradesh',
'Sherawa Ghat,Faizabad,Uttar Pradesh',
'Srai Rasi,Faizabad,Uttar Pradesh',
'Swarg Dwar,Faizabad,Uttar Pradesh',
'Tandauli,Faizabad,Uttar Pradesh',
'Teliagarh,Faizabad,Uttar Pradesh',
'Terhi Bazar,Faizabad,Uttar Pradesh',
'Utrethu,Faizabad,Uttar Pradesh',
'Water Works,Faizabad,Uttar Pradesh',
'Barun,Faizabad,Uttar Pradesh',
'Aghiyari,Faizabad,Uttar Pradesh',
'Ahiran Subansh,Faizabad,Uttar Pradesh',
'Amaniganj,Faizabad,Uttar Pradesh',
'Anjrauli,Faizabad,Uttar Pradesh',
'Astikaan,Faizabad,Uttar Pradesh',
'Bakauli,Faizabad,Uttar Pradesh',
'Bakchuna,Faizabad,Uttar Pradesh',
'Barauli,Faizabad,Uttar Pradesh',
'Basawan,Faizabad,Uttar Pradesh',
'Bawan,Faizabad,Uttar Pradesh',
'Bhakhauli,Faizabad,Uttar Pradesh',
'Bhimatali,Faizabad,Uttar Pradesh',
'Birauli,Faizabad,Uttar Pradesh',
'Bodahari,Faizabad,Uttar Pradesh',
'Chandaura,Faizabad,Uttar Pradesh',
'Chirauli,Faizabad,Uttar Pradesh',
'Chitaura,Faizabad,Uttar Pradesh',
'Deogaon,Faizabad,Uttar Pradesh',
'Deorhi,Faizabad,Uttar Pradesh',
'Dhanaicha,Faizabad,Uttar Pradesh',
'Dharauli,Faizabad,Uttar Pradesh',
'Dhema Vaish,Faizabad,Uttar Pradesh',
'Gaddopur,Faizabad,Uttar Pradesh',
'Gauhania,Faizabad,Uttar Pradesh',
'Gauhanna Qanoongo,Faizabad,Uttar Pradesh',
'Ghatauli,Faizabad,Uttar Pradesh',
'Ghorwal,Faizabad,Uttar Pradesh',
'Ghurehta,Faizabad,Uttar Pradesh',
'Gokula,Faizabad,Uttar Pradesh',
'Gothwara,Faizabad,Uttar Pradesh',
'Harakhpur,Faizabad,Uttar Pradesh',
'Hardoiya,Faizabad,Uttar Pradesh',
'Harringtonganj,Faizabad,Uttar Pradesh',
'Inayatnagar,Faizabad,Uttar Pradesh',
'Jorium,Faizabad,Uttar Pradesh',
'Kadanpur,Faizabad,Uttar Pradesh',
'Kadipur,Faizabad,Uttar Pradesh',
'Kahuwa,Faizabad,Uttar Pradesh',
'Kalyanpur Keotani,Faizabad,Uttar Pradesh',
'Khanpur,Faizabad,Uttar Pradesh',
'Kinauli,Faizabad,Uttar Pradesh',
'Kinhupur,Faizabad,Uttar Pradesh',
'Kotdeeh,Faizabad,Uttar Pradesh',
'Kotiya,Faizabad,Uttar Pradesh',
'Kuchera,Faizabad,Uttar Pradesh',
'Kumarganj,Faizabad,Uttar Pradesh',
'Kumbhi,Faizabad,Uttar Pradesh',
'Kurawan,Faizabad,Uttar Pradesh',
'Mahmedpur,Faizabad,Uttar Pradesh',
'Mahuwa,Faizabad,Uttar Pradesh',
'Majnai,Faizabad,Uttar Pradesh',
'Mamudiha,Faizabad,Uttar Pradesh',
'Manjhanpur,Faizabad,Uttar Pradesh',
'Marui Ganeshpur,Faizabad,Uttar Pradesh',
'Mawai Kalan,Faizabad,Uttar Pradesh',
'Mehnauna,Faizabad,Uttar Pradesh',
'Mewapur,Faizabad,Uttar Pradesh',
'Milkipur,Faizabad,Uttar Pradesh',
'Mubarakpur Umarni,Faizabad,Uttar Pradesh',
'Nandauli,Faizabad,Uttar Pradesh',
'Nimari,Faizabad,Uttar Pradesh',
'Palia Jagmohan Singh,Faizabad,Uttar Pradesh',
'Paliya Pratapshah,Faizabad,Uttar Pradesh',
'Parsawan Khurd,Faizabad,Uttar Pradesh',
'Pithila,Faizabad,Uttar Pradesh',
'Raipatti,Faizabad,Uttar Pradesh',
'Ramnagar Amawan Sufi,Faizabad,Uttar Pradesh',
'Ranapur,Faizabad,Uttar Pradesh',
'Rani Bazar,Faizabad,Uttar Pradesh',
'Rasoolpur Lilha,Faizabad,Uttar Pradesh',
'Rautawan,Faizabad,Uttar Pradesh',
'Reona,Faizabad,Uttar Pradesh',
'Sarauli,Faizabad,Uttar Pradesh',
'Sari,Faizabad,Uttar Pradesh',
'Seora,Faizabad,Uttar Pradesh',
'Shahganj,Faizabad,Uttar Pradesh',
'Shekhanpur,Faizabad,Uttar Pradesh',
'Sidhari Bazar,Faizabad,Uttar Pradesh',
'Sidhauna,Faizabad,Uttar Pradesh',
'Sirhir,Faizabad,Uttar Pradesh',
'Sondhiyawan,Faizabad,Uttar Pradesh',
'Taksara,Faizabad,Uttar Pradesh',
'Taldholi,Faizabad,Uttar Pradesh',
'Tarauli,Faizabad,Uttar Pradesh',
'Tendha Khurd,Faizabad,Uttar Pradesh',
'Uchhahpali,Faizabad,Uttar Pradesh',
'Upadhyapur,Faizabad,Uttar Pradesh',
'Palpur,Faizabad,Uttar Pradesh',
'Sohkhawan,Faizabad,Uttar Pradesh',
'Arthar,Faizabad,Uttar Pradesh',
'Baidarapur,Faizabad,Uttar Pradesh',
'Baragaon RS,Faizabad,Uttar Pradesh',
'Barwa,Faizabad,Uttar Pradesh',
'Bhitaura,Faizabad,Uttar Pradesh',
'Dillisaraiya,Faizabad,Uttar Pradesh',
'Gondwa,Faizabad,Uttar Pradesh',
'Hajipur,Faizabad,Uttar Pradesh',
'Ismail Nagar Singra,Faizabad,Uttar Pradesh',
'Jaganpur,Faizabad,Uttar Pradesh',
'Kandai Kalan,Faizabad,Uttar Pradesh',
'Kareru,Faizabad,Uttar Pradesh',
'Khirauni,Faizabad,Uttar Pradesh',
'Kundurkha Khurd,Faizabad,Uttar Pradesh',
'Lakhauri,Faizabad,Uttar Pradesh',
'Magalsi,Faizabad,Uttar Pradesh',
'Maholi Uprahar,Faizabad,Uttar Pradesh',
'Majnawa,Faizabad,Uttar Pradesh',
'Meerpur,Faizabad,Uttar Pradesh',
'Moiyabegumganj,Faizabad,Uttar Pradesh',
'Mubarakganj,Faizabad,Uttar Pradesh',
'Nawada,Faizabad,Uttar Pradesh',
'Panditpur,Faizabad,Uttar Pradesh',
'Pilkhawan,Faizabad,Uttar Pradesh',
'Pirkhauli,Faizabad,Uttar Pradesh',
'Ramnagar Dhaurahra,Faizabad,Uttar Pradesh',
'Raunahi,Faizabad,Uttar Pradesh',
'Sanaha,Faizabad,Uttar Pradesh',
'Sarangpur,Faizabad,Uttar Pradesh',
'Seewar,Faizabad,Uttar Pradesh',
'Sohawal RS,Faizabad,Uttar Pradesh',
'Surwari,Faizabad,Uttar Pradesh',
'Tandwa,Faizabad,Uttar Pradesh',
'Bharka,Fatehgarh,Uttar Pradesh',
'Ghatiaghat,Fatehgarh,Uttar Pradesh',
'Maseni,Fatehgarh,Uttar Pradesh',
'Sarah,Fatehgarh,Uttar Pradesh',
'Ahmadganj,Fatehgarh,Uttar Pradesh',
'Akbarpur,Fatehgarh,Uttar Pradesh',
'Aligarh,Fatehgarh,Uttar Pradesh',
'Amlaiya Ashanand,Fatehgarh,Uttar Pradesh',
'Amratpur,Fatehgarh,Uttar Pradesh',
'Arjunpur,Fatehgarh,Uttar Pradesh',
'Ataipur,Fatehgarh,Uttar Pradesh',
'Awajpur,Fatehgarh,Uttar Pradesh',
'Babna,Fatehgarh,Uttar Pradesh',
'Bara Biku,Fatehgarh,Uttar Pradesh',
'Barai,Fatehgarh,Uttar Pradesh',
'Barakeshav,Fatehgarh,Uttar Pradesh',
'Baraun,Fatehgarh,Uttar Pradesh',
'Barhpur,Fatehgarh,Uttar Pradesh',
'Barjhala,Fatehgarh,Uttar Pradesh',
'Barkhera,Fatehgarh,Uttar Pradesh',
'Barkhiriya,Fatehgarh,Uttar Pradesh',
'Bazaria Farrukhabad,Fatehgarh,Uttar Pradesh',
'Bazaza Bazar,Fatehgarh,Uttar Pradesh',
'Behta Ballu,Fatehgarh,Uttar Pradesh',
'Bhainsiapur,Fatehgarh,Uttar Pradesh',
'Bhatasa,Fatehgarh,Uttar Pradesh',
'Bhojpur,Fatehgarh,Uttar Pradesh',
'Bholeypur,Fatehgarh,Uttar Pradesh',
'Bhopat Patti,Fatehgarh,Uttar Pradesh',
'Bibiganj,Fatehgarh,Uttar Pradesh',
'Bihar,Fatehgarh,Uttar Pradesh',
'Bilsari,Fatehgarh,Uttar Pradesh',
'Central Jail,Fatehgarh,Uttar Pradesh',
'Chapra,Fatehgarh,Uttar Pradesh',
'Chilsara,Fatehgarh,Uttar Pradesh',
'Chiyasar,Fatehgarh,Uttar Pradesh',
'Civil Lines,Fatehgarh,Uttar Pradesh',
'College Rd. Kaimganj,Fatehgarh,Uttar Pradesh',
'Danmandi,Fatehgarh,Uttar Pradesh',
'Daraura,Fatehgarh,Uttar Pradesh',
'Dhirpur,Fatehgarh,Uttar Pradesh',
'Distt. Jail,Fatehgarh,Uttar Pradesh',
'Farrukhabad R. S.,Fatehgarh,Uttar Pradesh',
'Farrukhabad,Fatehgarh,Uttar Pradesh',
'Fatehgarh H.O,Fatehgarh,Uttar Pradesh',
'Fatehgarh R.S.,Fatehgarh,Uttar Pradesh',
'Gadanpur Deorajpur,Fatehgarh,Uttar Pradesh',
'Gadanpur Turra,Fatehgarh,Uttar Pradesh',
'Gaisinghpur,Fatehgarh,Uttar Pradesh',
'Gandhi,Fatehgarh,Uttar Pradesh',
'Ganga Darwaja Kmj.,Fatehgarh,Uttar Pradesh',
'Gosarpur,Fatehgarh,Uttar Pradesh',
'Gutasi,Fatehgarh,Uttar Pradesh',
'Guthina,Fatehgarh,Uttar Pradesh',
'Hariharpur,Fatehgarh,Uttar Pradesh',
'Harsinghpur,Fatehgarh,Uttar Pradesh',
'Harsinghpur Goa,Fatehgarh,Uttar Pradesh',
'I.T.E.,Fatehgarh,Uttar Pradesh',
'J.N.V.Road,Fatehgarh,Uttar Pradesh',
'Jahanganj,Fatehgarh,Uttar Pradesh',
'Jainpur Maheshpur,Fatehgarh,Uttar Pradesh',
'Jaitpur,Fatehgarh,Uttar Pradesh',
'Jarari,Fatehgarh,Uttar Pradesh',
'Jhasi,Fatehgarh,Uttar Pradesh',
'Jyonta,Fatehgarh,Uttar Pradesh',
'K K W,Fatehgarh,Uttar Pradesh',
'K. P. Ghat,Fatehgarh,Uttar Pradesh',
'Kadhar,Fatehgarh,Uttar Pradesh',
'Kaimganj,Fatehgarh,Uttar Pradesh',
'Kamalganj,Fatehgarh,Uttar Pradesh',
'Kampil,Fatehgarh,Uttar Pradesh',
'Kanasi,Fatehgarh,Uttar Pradesh',
'Kandhrapur,Fatehgarh,Uttar Pradesh',
'Kanheypur,Fatehgarh,Uttar Pradesh',
'Kanjhiana,Fatehgarh,Uttar Pradesh',
'Kankapur,Fatehgarh,Uttar Pradesh',
'Karanpur Dutt,Fatehgarh,Uttar Pradesh',
'Katrauli Patti,Fatehgarh,Uttar Pradesh',
'Khalwara,Fatehgarh,Uttar Pradesh',
'Khandauli,Fatehgarh,Uttar Pradesh',
'Khimseypur,Fatehgarh,Uttar Pradesh',
'Khinmini,Fatehgarh,Uttar Pradesh',
'Khinmini,Fatehgarh,Uttar Pradesh',
'Khudaganj,Fatehgarh,Uttar Pradesh',
'Kila,Fatehgarh,Uttar Pradesh',
'Kisrauli,Fatehgarh,Uttar Pradesh',
'Kotwali Road Ftg.,Fatehgarh,Uttar Pradesh',
'Kuiyan Khera,Fatehgarh,Uttar Pradesh',
'Kumhraur,Fatehgarh,Uttar Pradesh',
'Kurar,Fatehgarh,Uttar Pradesh',
'Kutchery Fatehgarh,Fatehgarh,Uttar Pradesh',
'Lahra,Fatehgarh,Uttar Pradesh',
'Lakhanpur,Fatehgarh,Uttar Pradesh',
'Lal Sarai,Fatehgarh,Uttar Pradesh',
'Lindsayganj,Fatehgarh,Uttar Pradesh',
'Madanpur,Fatehgarh,Uttar Pradesh',
'Mahoi,Fatehgarh,Uttar Pradesh',
'Manjhana,Fatehgarh,Uttar Pradesh',
'Mathia Devi,Fatehgarh,Uttar Pradesh',
'Mau Rashidabad,Fatehgarh,Uttar Pradesh',
'Mau Rashidabad,Fatehgarh,Uttar Pradesh',
'Maudha,Fatehgarh,Uttar Pradesh',
'Merapur,Fatehgarh,Uttar Pradesh',
'Mistni Bahbalpur,Fatehgarh,Uttar Pradesh',
'Mohamdabad,Fatehgarh,Uttar Pradesh',
'Musakhiria,Fatehgarh,Uttar Pradesh',
'Nadaura,Fatehgarh,Uttar Pradesh',
'Nagla Bagh Rathaura,Fatehgarh,Uttar Pradesh',
'Nagla Kel Champat,Fatehgarh,Uttar Pradesh',
'Nagla Nan,Fatehgarh,Uttar Pradesh',
'Narainamau,Fatehgarh,Uttar Pradesh',
'Nawabganj,Fatehgarh,Uttar Pradesh',
'Nehru Road,Fatehgarh,Uttar Pradesh',
'Nibkarori,Fatehgarh,Uttar Pradesh',
'Nitganja,Fatehgarh,Uttar Pradesh',
'Pachpukhra,Fatehgarh,Uttar Pradesh',
'Paithan,Fatehgarh,Uttar Pradesh',
'Pakhna,Fatehgarh,Uttar Pradesh',
'Panda Bagh,Fatehgarh,Uttar Pradesh',
'Pilkhana,Fatehgarh,Uttar Pradesh',
'Pipergaon,Fatehgarh,Uttar Pradesh',
'Pitaura,Fatehgarh,Uttar Pradesh',
'Pithnapur,Fatehgarh,Uttar Pradesh',
'Puthari,Fatehgarh,Uttar Pradesh',
'Raipur,Fatehgarh,Uttar Pradesh',
'Rajendra Nagar,Fatehgarh,Uttar Pradesh',
'Rajeypur Tappa Mandal,Fatehgarh,Uttar Pradesh',
'Rajipur,Fatehgarh,Uttar Pradesh',
'Rampur Majhgaon,Fatehgarh,Uttar Pradesh',
'Rashidabad Tiwariyan,Fatehgarh,Uttar Pradesh',
'Rasidpur Mai,Fatehgarh,Uttar Pradesh',
'Raukari,Fatehgarh,Uttar Pradesh',
'Rly. Road Kaimganj,Fatehgarh,Uttar Pradesh',
'Rohila,Fatehgarh,Uttar Pradesh',
'Roop Nagar,Fatehgarh,Uttar Pradesh',
'Roshnabad,Fatehgarh,Uttar Pradesh',
'RRC Fatehgarh,Fatehgarh,Uttar Pradesh',
'Rudain,Fatehgarh,Uttar Pradesh',
'Rutaul,Fatehgarh,Uttar Pradesh',
'Sabalpur,Fatehgarh,Uttar Pradesh',
'Sahaspur,Fatehgarh,Uttar Pradesh',
'Sakwai,Fatehgarh,Uttar Pradesh',
'Sankisa,Fatehgarh,Uttar Pradesh',
'Shamshabad,Fatehgarh,Uttar Pradesh',
'Shukrullapur,Fatehgarh,Uttar Pradesh',
'Sikanderpur Khas,Fatehgarh,Uttar Pradesh',
'Silsanda,Fatehgarh,Uttar Pradesh',
'Singhirampur,Fatehgarh,Uttar Pradesh',
'Sirauli,Fatehgarh,Uttar Pradesh',
'Sirmaura Banger,Fatehgarh,Uttar Pradesh',
'Sitauli,Fatehgarh,Uttar Pradesh',
'Siwara Khas,Fatehgarh,Uttar Pradesh',
'Tajpur,Fatehgarh,Uttar Pradesh',
'Ugarpur,Fatehgarh,Uttar Pradesh',
'Ugrapur Sultan Patti,Fatehgarh,Uttar Pradesh',
'Ukhra,Fatehgarh,Uttar Pradesh',
'Yaqutganj,Fatehgarh,Uttar Pradesh',
'Abhaipur,Fatehpur,Uttar Pradesh',
'Aboonagar,Fatehpur,Uttar Pradesh',
'Afoi,Fatehpur,Uttar Pradesh',
'Ahewa,Fatehpur,Uttar Pradesh',
'Ahmadpur Kusumbha,Fatehpur,Uttar Pradesh',
'Ailai,Fatehpur,Uttar Pradesh',
'Ainjhi,Fatehpur,Uttar Pradesh',
'Ajamatpur,Fatehpur,Uttar Pradesh',
'Akbarpur Churai,Fatehpur,Uttar Pradesh',
'Alamganj,Fatehpur,Uttar Pradesh',
'Alampur,Fatehpur,Uttar Pradesh',
'Alampur Giriya,Fatehpur,Uttar Pradesh',
'Allipur,Fatehpur,Uttar Pradesh',
'Amaon,Fatehpur,Uttar Pradesh',
'Amauli,Fatehpur,Uttar Pradesh',
'Amilihapal,Fatehpur,Uttar Pradesh',
'Andipur,Fatehpur,Uttar Pradesh',
'Anjana Bhairaon,Fatehpur,Uttar Pradesh',
'Arhaiya,Fatehpur,Uttar Pradesh',
'Arhauli,Fatehpur,Uttar Pradesh',
'Arhawal,Fatehpur,Uttar Pradesh',
'Asani,Fatehpur,Uttar Pradesh',
'Ashok Nagar Bharsawan,Fatehpur,Uttar Pradesh',
'Asother,Fatehpur,Uttar Pradesh',
'Aung,Fatehpur,Uttar Pradesh',
'Aurai,Fatehpur,Uttar Pradesh',
'Ayah,Fatehpur,Uttar Pradesh',
'Bahrampur,Fatehpur,Uttar Pradesh',
'Bahua,Fatehpur,Uttar Pradesh',
'Baigaon,Fatehpur,Uttar Pradesh',
'Bakewar Sarai,Fatehpur,Uttar Pradesh',
'Bamharauli,Fatehpur,Uttar Pradesh',
'Banarsi,Fatehpur,Uttar Pradesh',
'Bandipur,Fatehpur,Uttar Pradesh',
'Banthara,Fatehpur,Uttar Pradesh',
'Bara,Fatehpur,Uttar Pradesh',
'Baragaon,Fatehpur,Uttar Pradesh',
'Baraipur,Fatehpur,Uttar Pradesh',
'Baranpur,Fatehpur,Uttar Pradesh',
'Barigawan,Fatehpur,Uttar Pradesh',
'Basant Khera,Fatehpur,Uttar Pradesh',
'Baswa,Fatehpur,Uttar Pradesh',
'Belain,Fatehpur,Uttar Pradesh',
'Beonti,Fatehpur,Uttar Pradesh',
'Beragarhiwa,Fatehpur,Uttar Pradesh',
'Berraon,Fatehpur,Uttar Pradesh',
'Berui,Fatehpur,Uttar Pradesh',
'Bhadba,Fatehpur,Uttar Pradesh',
'Bhaisauli,Fatehpur,Uttar Pradesh',
'Bhakharana,Fatehpur,Uttar Pradesh',
'Bhitaura,Fatehpur,Uttar Pradesh',
'Bijauli,Fatehpur,Uttar Pradesh',
'Bijuri,Fatehpur,Uttar Pradesh',
'Bilanda,Fatehpur,Uttar Pradesh',
'Bilandpur,Fatehpur,Uttar Pradesh',
'Bindki,Fatehpur,Uttar Pradesh',
'Birnai,Fatehpur,Uttar Pradesh',
'Budhramau,Fatehpur,Uttar Pradesh',
'Budwan,Fatehpur,Uttar Pradesh',
'Burhwan,Fatehpur,Uttar Pradesh',
'Chak Korra Sadat,Fatehpur,Uttar Pradesh',
'Chakas Karan,Fatehpur,Uttar Pradesh',
'Chakhendi,Fatehpur,Uttar Pradesh',
'Chandapur,Fatehpur,Uttar Pradesh',
'Chandiyana,Fatehpur,Uttar Pradesh',
'Chandpur,Fatehpur,Uttar Pradesh',
'Chheolaha,Fatehpur,Uttar Pradesh',
'Chhichha,Fatehpur,Uttar Pradesh',
'Chhichhni,Fatehpur,Uttar Pradesh',
'Chitauli,Fatehpur,Uttar Pradesh',
'Chitishapur,Fatehpur,Uttar Pradesh',
'Churiyani,Fatehpur,Uttar Pradesh',
'Damapur,Fatehpur,Uttar Pradesh',
'Dampur,Fatehpur,Uttar Pradesh',
'Dapsaura,Fatehpur,Uttar Pradesh',
'Datauli,Fatehpur,Uttar Pradesh',
'Dawatpur,Fatehpur,Uttar Pradesh',
'Dayalnagar,Fatehpur,Uttar Pradesh',
'Deegh,Fatehpur,Uttar Pradesh',
'Dendasai,Fatehpur,Uttar Pradesh',
'Deolan,Fatehpur,Uttar Pradesh',
'Deomai,Fatehpur,Uttar Pradesh',
'Deori Bujurg,Fatehpur,Uttar Pradesh',
'Devrar,Fatehpur,Uttar Pradesh',
'Dhakauli,Fatehpur,Uttar Pradesh',
'Dhamina Khurd,Fatehpur,Uttar Pradesh',
'Dharmpur Saton,Fatehpur,Uttar Pradesh',
'Dhata,Fatehpur,Uttar Pradesh',
'Digharua,Fatehpur,Uttar Pradesh',
'Dugrai,Fatehpur,Uttar Pradesh',
'Ekdala,Fatehpur,Uttar Pradesh',
'Erayan,Fatehpur,Uttar Pradesh',
'Farshi,Fatehpur,Uttar Pradesh',
'Fatehpur City,Fatehpur,Uttar Pradesh',
'Fatehpur Court,Fatehpur,Uttar Pradesh',
'Fatehpur H.O,Fatehpur,Uttar Pradesh',
'Fatehpur Tekari,Fatehpur,Uttar Pradesh',
'Fatehpur Town,Fatehpur,Uttar Pradesh',
'Gambhari,Fatehpur,Uttar Pradesh',
'Garha,Fatehpur,Uttar Pradesh',
'Gaura,Fatehpur,Uttar Pradesh',
'Gaura Bujurg,Fatehpur,Uttar Pradesh',
'Gauri Aura,Fatehpur,Uttar Pradesh',
'Gauri,Fatehpur,Uttar Pradesh',
'Gharwasipur,Fatehpur,Uttar Pradesh',
'Ghazipur,Fatehpur,Uttar Pradesh',
'Ghoori Bujurg,Fatehpur,Uttar Pradesh',
'Gohrari,Fatehpur,Uttar Pradesh',
'Gugauli,Fatehpur,Uttar Pradesh',
'Guneer,Fatehpur,Uttar Pradesh',
'Hardon,Fatehpur,Uttar Pradesh',
'Hariharganj,Fatehpur,Uttar Pradesh',
'Hasaupur,Fatehpur,Uttar Pradesh',
'Haswa,Fatehpur,Uttar Pradesh',
'Hathgaon,Fatehpur,Uttar Pradesh',
'Husainganj,Fatehpur,Uttar Pradesh',
'Ijura Bujurg,Fatehpur,Uttar Pradesh',
'Itaily,Fatehpur,Uttar Pradesh',
'Jafarganj,Fatehpur,Uttar Pradesh',
'Jafrabad,Fatehpur,Uttar Pradesh',
'Jahangirnagar Gahura,Fatehpur,Uttar Pradesh',
'Jairampur,Fatehpur,Uttar Pradesh',
'Jam,Fatehpur,Uttar Pradesh',
'Jamraon,Fatehpur,Uttar Pradesh',
'Jarauli,Fatehpur,Uttar Pradesh',
'Jonihan,Fatehpur,Uttar Pradesh',
'Kalyanpur Kachrauli,Fatehpur,Uttar Pradesh',
'Kalyanpur,Fatehpur,Uttar Pradesh',
'Kandhi,Fatehpur,Uttar Pradesh',
'Kandhiya,Fatehpur,Uttar Pradesh',
'Kapil Kalan,Fatehpur,Uttar Pradesh',
'Karmon,Fatehpur,Uttar Pradesh',
'Kasba Sohan,Fatehpur,Uttar Pradesh',
'Kaseruwa,Fatehpur,Uttar Pradesh',
'Katoghan,Fatehpur,Uttar Pradesh',
'Katra Kasimpur,Fatehpur,Uttar Pradesh',
'Kaundar,Fatehpur,Uttar Pradesh',
'Kaunh,Fatehpur,Uttar Pradesh',
'Khadra,Fatehpur,Uttar Pradesh',
'Khaga,Fatehpur,Uttar Pradesh',
'Khaga Town,Fatehpur,Uttar Pradesh',
'Khajuha,Fatehpur,Uttar Pradesh',
'Khakhreru,Fatehpur,Uttar Pradesh',
'Kharai,Fatehpur,Uttar Pradesh',
'Kharsendwa,Fatehpur,Uttar Pradesh',
'Khas Mau,Fatehpur,Uttar Pradesh',
'Khesahan,Fatehpur,Uttar Pradesh',
'Khotila Sijauli,Fatehpur,Uttar Pradesh',
'Khuta,Fatehpur,Uttar Pradesh',
'Kishandaspur,Fatehpur,Uttar Pradesh',
'Kishanpur,Fatehpur,Uttar Pradesh',
'Kora Jahanabad,Fatehpur,Uttar Pradesh',
'Korai,Fatehpur,Uttar Pradesh',
'Korra Kanak,Fatehpur,Uttar Pradesh',
'Korsam,Fatehpur,Uttar Pradesh',
'Kot,Fatehpur,Uttar Pradesh',
'Kotiya,Fatehpur,Uttar Pradesh',
'Kulli,Fatehpur,Uttar Pradesh',
'Kumbhipur,Fatehpur,Uttar Pradesh',
'Kusumbhi,Fatehpur,Uttar Pradesh',
'Ladigaon,Fatehpur,Uttar Pradesh',
'Lalauli,Fatehpur,Uttar Pradesh',
'Lalpur,Fatehpur,Uttar Pradesh',
'Lamehata,Fatehpur,Uttar Pradesh',
'Lateefpur,Fatehpur,Uttar Pradesh',
'Laugaon,Fatehpur,Uttar Pradesh',
'Madokipur,Fatehpur,Uttar Pradesh',
'Mahakhera,Fatehpur,Uttar Pradesh',
'Mahana,Fatehpur,Uttar Pradesh',
'Mahoi,Fatehpur,Uttar Pradesh',
'Mahraha,Fatehpur,Uttar Pradesh',
'Makarandpur,Fatehpur,Uttar Pradesh',
'Malaon,Fatehpur,Uttar Pradesh',
'Malookbari,Fatehpur,Uttar Pradesh',
'Malwan R.S.,Fatehpur,Uttar Pradesh',
'Malwan Town,Fatehpur,Uttar Pradesh',
'Manawan,Fatehpur,Uttar Pradesh',
'Manda Sarai,Fatehpur,Uttar Pradesh',
'Mandraon,Fatehpur,Uttar Pradesh',
'Mandwan,Fatehpur,Uttar Pradesh',
'Mauhar,Fatehpur,Uttar Pradesh',
'Maujmabad,Fatehpur,Uttar Pradesh',
'Mawai,Fatehpur,Uttar Pradesh',
'Mawaiya,Fatehpur,Uttar Pradesh',
'Meoli,Fatehpur,Uttar Pradesh',
'Mirai,Fatehpur,Uttar Pradesh',
'Missi,Fatehpur,Uttar Pradesh',
'Mohamdabad,Fatehpur,Uttar Pradesh',
'Mohammad Pur Gaunti,Fatehpur,Uttar Pradesh',
'Muraon,Fatehpur,Uttar Pradesh',
'Musafa,Fatehpur,Uttar Pradesh',
'Muttaur,Fatehpur,Uttar Pradesh',
'Naraicha,Fatehpur,Uttar Pradesh',
'Naraini,Fatehpur,Uttar Pradesh',
'Narauli,Fatehpur,Uttar Pradesh',
'Narsinghpur Kabraha,Fatehpur,Uttar Pradesh',
'Naugaon,Fatehpur,Uttar Pradesh',
'Nizamuddinpur,Fatehpur,Uttar Pradesh',
'Padhara,Fatehpur,Uttar Pradesh',
'Paharpur,Fatehpur,Uttar Pradesh',
'Paigamberpur,Fatehpur,Uttar Pradesh',
'Paina Khurd,Fatehpur,Uttar Pradesh',
'Pallawan,Fatehpur,Uttar Pradesh',
'Pamrauli,Fatehpur,Uttar Pradesh',
'Patti,Fatehpur,Uttar Pradesh',
'Pauli,Fatehpur,Uttar Pradesh',
'Purain,Fatehpur,Uttar Pradesh',
'Purani Bindki,Fatehpur,Uttar Pradesh',
'Raipur Bhasraul,Fatehpur,Uttar Pradesh',
'Raipur Muwari,Fatehpur,Uttar Pradesh',
'Ram Nagar Kauhan,Fatehpur,Uttar Pradesh',
'Ramwan,Fatehpur,Uttar Pradesh',
'Rari,Fatehpur,Uttar Pradesh',
'Rari Bujurg,Fatehpur,Uttar Pradesh',
'Rewari Bujurg,Fatehpur,Uttar Pradesh',
'Rithwa Awajipur,Fatehpur,Uttar Pradesh',
'Rithwan Bhairwan,Fatehpur,Uttar Pradesh',
'Sahjahanpur Selraha,Fatehpur,Uttar Pradesh',
'Saibasi,Fatehpur,Uttar Pradesh',
'Saidpur Pachmai,Fatehpur,Uttar Pradesh',
'Salempur,Fatehpur,Uttar Pradesh',
'Salhepur,Fatehpur,Uttar Pradesh',
'Sangaon,Fatehpur,Uttar Pradesh',
'Saraisaba,Fatehpur,Uttar Pradesh',
'Sarauli,Fatehpur,Uttar Pradesh',
'Sarkandi,Fatehpur,Uttar Pradesh',
'Sarkee,Fatehpur,Uttar Pradesh',
'Sawant,Fatehpur,Uttar Pradesh',
'Selawan,Fatehpur,Uttar Pradesh',
'Semramanapur,Fatehpur,Uttar Pradesh',
'Sewramau,Fatehpur,Uttar Pradesh',
'Shadipur,Fatehpur,Uttar Pradesh',
'Shah,Fatehpur,Uttar Pradesh',
'Shahpur,Fatehpur,Uttar Pradesh',
'Shankha,Fatehpur,Uttar Pradesh',
'Sheorajpur,Fatehpur,Uttar Pradesh',
'Sidhaon,Fatehpur,Uttar Pradesh',
'Silmi,Fatehpur,Uttar Pradesh',
'Sithaura,Fatehpur,Uttar Pradesh',
'Sothrapur,Fatehpur,Uttar Pradesh',
'Suketi,Fatehpur,Uttar Pradesh',
'Sultangarh,Fatehpur,Uttar Pradesh',
'Sultanpurghosh,Fatehpur,Uttar Pradesh',
'Tapani,Fatehpur,Uttar Pradesh',
'Tarapur,Fatehpur,Uttar Pradesh',
'Teliyani,Fatehpur,Uttar Pradesh',
'Teni,Fatehpur,Uttar Pradesh',
'Tesahi Bujurg,Fatehpur,Uttar Pradesh',
'Thariyaon,Fatehpur,Uttar Pradesh',
'Tikar,Fatehpur,Uttar Pradesh',
'Tyonja,Fatehpur,Uttar Pradesh',
'Ukathu,Fatehpur,Uttar Pradesh',
'Umari,Fatehpur,Uttar Pradesh',
'Vijaeepur,Fatehpur,Uttar Pradesh',
'Yauhan,Fatehpur,Uttar Pradesh',
'Baghai,Mainpuri,Uttar Pradesh',
'Dolupura,Mainpuri,Uttar Pradesh',
'Kaytha,Etah,Uttar Pradesh',
'Akalabad Hasanpur,Mainpuri,Uttar Pradesh',
'Alhadadpur,Mainpuri,Uttar Pradesh',
'Ali Nagar Kenjra,Mainpuri,Uttar Pradesh',
'Asafabad,Mainpuri,Uttar Pradesh',
'Asan,Mainpuri,Uttar Pradesh',
'Bachhagaon,Mainpuri,Uttar Pradesh',
'Bartara,Mainpuri,Uttar Pradesh',
'Basai Mohammadpur,Mainpuri,Uttar Pradesh',
'Bilhena,Mainpuri,Uttar Pradesh',
'Chandwar,Mainpuri,Uttar Pradesh',
'Chulhawali,Mainpuri,Uttar Pradesh',
'Collectorate -firozabad,Mainpuri,Uttar Pradesh',
'Datawali,Mainpuri,Uttar Pradesh',
'Dev Kherha,Mainpuri,Uttar Pradesh',
'Dheerpura,Mainpuri,Uttar Pradesh',
'Dodsa Mohammadpur,Mainpuri,Uttar Pradesh',
'Dokeli,Mainpuri,Uttar Pradesh',
'Firozabad Bazar,Mainpuri,Uttar Pradesh',
'Firozabad H.O,Mainpuri,Uttar Pradesh',
'Gagani,Mainpuri,Uttar Pradesh',
'Gazipur,Mainpuri,Uttar Pradesh',
'Gonchh,Mainpuri,Uttar Pradesh',
'Gondai,Mainpuri,Uttar Pradesh',
'Gwari Nagla Singhi,Mainpuri,Uttar Pradesh',
'Himmatpur,Mainpuri,Uttar Pradesh',
'Hirangaon,Mainpuri,Uttar Pradesh',
'Husainpur,Mainpuri,Uttar Pradesh',
'Jakhai,Mainpuri,Uttar Pradesh',
'Jalalpur,Mainpuri,Uttar Pradesh',
'Jarakhi,Mainpuri,Uttar Pradesh',
'Jarauli Kalan,Mainpuri,Uttar Pradesh',
'Jatau,Mainpuri,Uttar Pradesh',
'Jaundhary,Mainpuri,Uttar Pradesh',
'Katki,Mainpuri,Uttar Pradesh',
'Kotaki,Mainpuri,Uttar Pradesh',
'Kotla,Mainpuri,Uttar Pradesh',
'Kurri Kuppa,Mainpuri,Uttar Pradesh',
'Labour Collony Firozabad,Mainpuri,Uttar Pradesh',
'Main Bazar,Mainpuri,Uttar Pradesh',
'Mainpuri Gate Firozabad,Mainpuri,Uttar Pradesh',
'Matsena,Mainpuri,Uttar Pradesh',
'Mersena,Mainpuri,Uttar Pradesh',
'Mohammadi,Mainpuri,Uttar Pradesh',
'Muiddinpur,Mainpuri,Uttar Pradesh',
'Nagla Beech,Mainpuri,Uttar Pradesh',
'Nagla Dutt,Mainpuri,Uttar Pradesh',
'Nagla Sikander,Mainpuri,Uttar Pradesh',
'Narakhi,Mainpuri,Uttar Pradesh',
'Nepai,Mainpuri,Uttar Pradesh',
'Oef Firozabad,Mainpuri,Uttar Pradesh',
'Okhara,Mainpuri,Uttar Pradesh',
'Pachokhara,Mainpuri,Uttar Pradesh',
'Pachwan,Mainpuri,Uttar Pradesh',
'Pamari,Mainpuri,Uttar Pradesh',
'Railway Road Firozabad,Mainpuri,Uttar Pradesh',
'Raipura,Mainpuri,Uttar Pradesh',
'Rasoolabad,Mainpuri,Uttar Pradesh',
'Rupaspur,Mainpuri,Uttar Pradesh',
'S N H Road Firozabad,Mainpuri,Uttar Pradesh',
'Salempur,Mainpuri,Uttar Pradesh',
'Sarhamai,Mainpuri,Uttar Pradesh',
'Tikari,Mainpuri,Uttar Pradesh',
'Tundla Chauraha,Mainpuri,Uttar Pradesh',
'Tundla,Mainpuri,Uttar Pradesh',
'Usayani,Mainpuri,Uttar Pradesh',
'Gudaun,Mainpuri,Uttar Pradesh',
'Bachhela Bachheli,Mainpuri,Uttar Pradesh',
'Balipur,Mainpuri,Uttar Pradesh',
'Bara Gaon,Mainpuri,Uttar Pradesh',
'Bhadan,Mainpuri,Uttar Pradesh',
'Garhsan,Mainpuri,Uttar Pradesh',
'Kadipur,Mainpuri,Uttar Pradesh',
'Kaurari Kherha,Mainpuri,Uttar Pradesh',
'Keshpura,Mainpuri,Uttar Pradesh',
'Kharaua,Mainpuri,Uttar Pradesh',
'Kharit,Mainpuri,Uttar Pradesh',
'Kheria Patikara,Mainpuri,Uttar Pradesh',
'Konder,Mainpuri,Uttar Pradesh',
'Mustfabad,Mainpuri,Uttar Pradesh',
'Nagla Dheer,Mainpuri,Uttar Pradesh',
'Nagla Gulal,Mainpuri,Uttar Pradesh',
'Nagla Kanchan,Mainpuri,Uttar Pradesh',
'Pilakhatar,Mainpuri,Uttar Pradesh',
'Ruchan Manikpur,Mainpuri,Uttar Pradesh',
'Ukhrend,Mainpuri,Uttar Pradesh',
'Urawar--hastref,Mainpuri,Uttar Pradesh',
'Usneedha,Mainpuri,Uttar Pradesh',
'Akbarpur Kutukpur,Mainpuri,Uttar Pradesh',
'Bahat,Mainpuri,Uttar Pradesh',
'Banbara,Mainpuri,Uttar Pradesh',
'Bhadana,Mainpuri,Uttar Pradesh',
'Bhagner,Mainpuri,Uttar Pradesh',
'Eka,Mainpuri,Uttar Pradesh',
'Farida,Mainpuri,Uttar Pradesh',
'Gopalpur,Mainpuri,Uttar Pradesh',
'Jasrana,Mainpuri,Uttar Pradesh',
'Jhapara,Mainpuri,Uttar Pradesh',
'Kailai,Mainpuri,Uttar Pradesh',
'Katana,Mainpuri,Uttar Pradesh',
'Kaurara Bujurga,Mainpuri,Uttar Pradesh',
'Kushiyari,Mainpuri,Uttar Pradesh',
'Milawali,Mainpuri,Uttar Pradesh',
'Nagla Nahar,Mainpuri,Uttar Pradesh',
'Parham,Mainpuri,Uttar Pradesh',
'Patti,Mainpuri,Uttar Pradesh',
'Pendat,Mainpuri,Uttar Pradesh',
'Phariha,Mainpuri,Uttar Pradesh',
'Salempur,Mainpuri,Uttar Pradesh',
'Suraya,Mainpuri,Uttar Pradesh',
'Uresar,Mainpuri,Uttar Pradesh',
'Badshahpur,Mainpuri,Uttar Pradesh',
'A G M Bhawali,Mainpuri,Uttar Pradesh',
'Amaur Nagla Jeevan,Mainpuri,Uttar Pradesh',
'Asua,Mainpuri,Uttar Pradesh',
'Bara Bazar Shikohabad,Mainpuri,Uttar Pradesh',
'Bharaul,Mainpuri,Uttar Pradesh',
'Dakhinara,Mainpuri,Uttar Pradesh',
'Dhatari,Mainpuri,Uttar Pradesh',
'Ghaghau,Mainpuri,Uttar Pradesh',
'Gurha,Mainpuri,Uttar Pradesh',
'Harha,Mainpuri,Uttar Pradesh',
'I L C Shikohabad,Mainpuri,Uttar Pradesh',
'Jajumai,Mainpuri,Uttar Pradesh',
'Jaymai,Mainpuri,Uttar Pradesh',
'Kanwara,Mainpuri,Uttar Pradesh',
'Karhara,Mainpuri,Uttar Pradesh',
'Keshari,Mainpuri,Uttar Pradesh',
'Ketana Harsha,Mainpuri,Uttar Pradesh',
'Khair Garh,Mainpuri,Uttar Pradesh',
'Madanpur,Mainpuri,Uttar Pradesh',
'Madhoganj,Mainpuri,Uttar Pradesh',
'Makkhanpur,Mainpuri,Uttar Pradesh',
'Mandai,Mainpuri,Uttar Pradesh',
'Nagla Bajdar,Mainpuri,Uttar Pradesh',
'Nasirpur,Mainpuri,Uttar Pradesh',
'Paigu,Mainpuri,Uttar Pradesh',
'Pariyar,Mainpuri,Uttar Pradesh',
'Pratappur,Mainpuri,Uttar Pradesh',
'Saray Bhartara,Mainpuri,Uttar Pradesh',
'Saray Murlidhar,Mainpuri,Uttar Pradesh',
'Sekhupur Hatwant,Mainpuri,Uttar Pradesh',
'Shikohabad RS,Mainpuri,Uttar Pradesh',
'Shikohabad,Mainpuri,Uttar Pradesh',
'Sirsaganj,Mainpuri,Uttar Pradesh',
'Sothara,Mainpuri,Uttar Pradesh',
'Thanumai,Mainpuri,Uttar Pradesh',
'Tilyani,Mainpuri,Uttar Pradesh',
'Urmura,Mainpuri,Uttar Pradesh',
'Viltigarh,Mainpuri,Uttar Pradesh',
'Sarhupur,Mainpuri,Uttar Pradesh',
'Tugalpur,Ghaziabad,Uttar Pradesh',
'Achheja,Ghaziabad,Uttar Pradesh',
'Bisara,Ghaziabad,Uttar Pradesh',
'Bisrakh,Ghaziabad,Uttar Pradesh',
'Bambawar,Ghaziabad,Uttar Pradesh',
'Baraula,Ghaziabad,Uttar Pradesh',
'Behhrampur,Ghaziabad,Uttar Pradesh',
'Chainsa,Ghaziabad,Uttar Pradesh',
'Chhajarsi,Ghaziabad,Uttar Pradesh',
'Chhaprauli Bengar,Ghaziabad,Uttar Pradesh',
'Chholas,Ghaziabad,Uttar Pradesh',
'Chithera,Ghaziabad,Uttar Pradesh',
'Dujana,Ghaziabad,Uttar Pradesh',
'Gejha,Ghaziabad,Uttar Pradesh',
'Ghori,Ghaziabad,Uttar Pradesh',
'Jarcha,Ghaziabad,Uttar Pradesh',
'Kachera Versabad,Ghaziabad,Uttar Pradesh',
'Kalaunda,Ghaziabad,Uttar Pradesh',
'Kasna,Ghaziabad,Uttar Pradesh',
'Khandara,Ghaziabad,Uttar Pradesh',
'Khatana,Ghaziabad,Uttar Pradesh',
'Kheri Bhanauta,Ghaziabad,Uttar Pradesh',
'Khora Gaon,Ghaziabad,Uttar Pradesh',
'Kot,Ghaziabad,Uttar Pradesh',
'Kulesra,Ghaziabad,Uttar Pradesh',
'Luharli,Ghaziabad,Uttar Pradesh',
'Nagla Charandas,Ghaziabad,Uttar Pradesh',
'Pali,Ghaziabad,Uttar Pradesh',
'Parthala Khanjarpur,Ghaziabad,Uttar Pradesh',
'Sainthli,Ghaziabad,Uttar Pradesh',
'Sakipur,Ghaziabad,Uttar Pradesh',
'Sarfabad,Ghaziabad,Uttar Pradesh',
'Tilapta Karanwas,Ghaziabad,Uttar Pradesh',
'Vedpura,Ghaziabad,Uttar Pradesh',
'Dhoomedso,Ghaziabad,Uttar Pradesh',
'Ahamedpur Chauroli,Bulandshahar,Uttar Pradesh',
'Dhanouri Kalan,Bulandshahar,Uttar Pradesh',
'Mirzapur Niloni,Bulandshahar,Uttar Pradesh',
'Nawada,Bulandshahar,Uttar Pradesh',
'Parsol,Bulandshahar,Uttar Pradesh',
'Astauly,Bulandshahar,Uttar Pradesh',
'Baroda,Bulandshahar,Uttar Pradesh',
'Chiti,Bulandshahar,Uttar Pradesh',
'Deota,Bulandshahar,Uttar Pradesh',
'Rashol Rithaury,Bulandshahar,Uttar Pradesh',
'Salempur Gujar,Bulandshahar,Uttar Pradesh',
'Wair,Bulandshahar,Uttar Pradesh',
'Jahangirpur,Bulandshahar,Uttar Pradesh',
'Jewar,Bulandshahar,Uttar Pradesh',
'Rabupura,Bulandshahar,Uttar Pradesh',
'Thora,Bulandshahar,Uttar Pradesh',
'Bankapur,Bulandshahar,Uttar Pradesh',
'Bhaipur Brahmanan,Bulandshahar,Uttar Pradesh',
'Bhaipur,Bulandshahar,Uttar Pradesh',
'Bhunna Jattan,Bulandshahar,Uttar Pradesh',
'Chanchaly,Bulandshahar,Uttar Pradesh',
'Chhapana,Bulandshahar,Uttar Pradesh',
'Chingrawly,Bulandshahar,Uttar Pradesh',
'Chiroury,Bulandshahar,Uttar Pradesh',
'Dayanatpur,Bulandshahar,Uttar Pradesh',
'Faleda,Bulandshahar,Uttar Pradesh',
'Firoujpur,Bulandshahar,Uttar Pradesh',
'Gotheny,Bulandshahar,Uttar Pradesh',
'Jawan,Bulandshahar,Uttar Pradesh',
'Kanigarhi,Bulandshahar,Uttar Pradesh',
'Karauli Banger,Bulandshahar,Uttar Pradesh',
'Kishore Pur,Bulandshahar,Uttar Pradesh',
'Kureb,Bulandshahar,Uttar Pradesh',
'Lodana,Bulandshahar,Uttar Pradesh',
'Manchad,Bulandshahar,Uttar Pradesh',
'Mangrouly,Bulandshahar,Uttar Pradesh',
'Narmohamadpur,Bulandshahar,Uttar Pradesh',
'Neemka,Bulandshahar,Uttar Pradesh',
'Ram Garhi,Bulandshahar,Uttar Pradesh',
'Ranhera,Bulandshahar,Uttar Pradesh',
'Ronija,Bulandshahar,Uttar Pradesh',
'Sabouta Jafrabad,Bulandshahar,Uttar Pradesh',
'Shahpur Kala,Bulandshahar,Uttar Pradesh',
'Tirthaly,Bulandshahar,Uttar Pradesh',
'Mansoor Pur Hasanpur,Bulandshahar,Uttar Pradesh',
'Maicha,Ghaziabad,Uttar Pradesh',
'Alpha Greater Noida,Ghaziabad,Uttar Pradesh',
'Dadri,Ghaziabad,Uttar Pradesh',
'I.A. Surajpur,Ghaziabad,Uttar Pradesh',
'Maharishi Nagar,Ghaziabad,Uttar Pradesh',
'Nepz Post Office,Ghaziabad,Uttar Pradesh',
'Noida H.O,Ghaziabad,Uttar Pradesh',
'Sec-12 Noida,Ghaziabad,Uttar Pradesh',
'Sec-16 Noida,Ghaziabad,Uttar Pradesh',
'Sec-30 Noida,Ghaziabad,Uttar Pradesh',
'Sec-34 Noida,Ghaziabad,Uttar Pradesh',
'Sec-37 Noida,Ghaziabad,Uttar Pradesh',
'Sec-45 Noida,Ghaziabad,Uttar Pradesh',
'Sec-55 Noida,Ghaziabad,Uttar Pradesh',
'Sec-62 Noida,Ghaziabad,Uttar Pradesh',
'Vidyut Nagar,Ghaziabad,Uttar Pradesh',
'Piyaoli,Ghaziabad,Uttar Pradesh',
'Salarpur Kalan,Ghaziabad,Uttar Pradesh',
'Banchawaly,Bulandshahar,Uttar Pradesh',
'Bichat Sujanpur,Bulandshahar,Uttar Pradesh',
'Bilaspur,Bulandshahar,Uttar Pradesh',
'Chol R.S.,Bulandshahar,Uttar Pradesh',
'Jhajhar,Bulandshahar,Uttar Pradesh',
'Khabra Khanpur,Bulandshahar,Uttar Pradesh',
'Mahamdpur Jadon,Bulandshahar,Uttar Pradesh',
'Salempur Jat,Bulandshahar,Uttar Pradesh',
'Sunpera,Bulandshahar,Uttar Pradesh',
'Wailana,Bulandshahar,Uttar Pradesh',
'Biroundi Tajpur,Bulandshahar,Uttar Pradesh',
'Ator Nagla,Ghaziabad,Uttar Pradesh',
'Aurangabad Ristal,Ghaziabad,Uttar Pradesh',
'Bhup Kheri,Ghaziabad,Uttar Pradesh',
'Chhaprola,Ghaziabad,Uttar Pradesh',
'Chhipyana,Ghaziabad,Uttar Pradesh',
'Dhara,Ghaziabad,Uttar Pradesh',
'Kandaula,Ghaziabad,Uttar Pradesh',
'Parpa,Ghaziabad,Uttar Pradesh',
'Samana,Ghaziabad,Uttar Pradesh',
'Solana,Ghaziabad,Uttar Pradesh',
'Biraj Ghat,Ghaziabad,Uttar Pradesh',
'Abupur,Ghaziabad,Uttar Pradesh',
'Adhyatmic Nagar,Ghaziabad,Uttar Pradesh',
'Alttc,Ghaziabad,Uttar Pradesh',
'Arya Nagar,Ghaziabad,Uttar Pradesh',
'Ashok Nagar,Ghaziabad,Uttar Pradesh',
'B.B.Nagar,Ghaziabad,Uttar Pradesh',
'Badshahnpur Siroli,Ghaziabad,Uttar Pradesh',
'Basantpur Sainthli,Ghaziabad,Uttar Pradesh',
'Behta Hazipur,Ghaziabad,Uttar Pradesh',
'Bhadoli,Ghaziabad,Uttar Pradesh',
'Bharat Nagar,Ghaziabad,Uttar Pradesh',
'Bhikanpur,Ghaziabad,Uttar Pradesh',
'Chander Nagar,Ghaziabad,Uttar Pradesh',
'Chaupla,Ghaziabad,Uttar Pradesh',
'Chikamberpur,Ghaziabad,Uttar Pradesh',
'Chrori,Ghaziabad,Uttar Pradesh',
'Dasna Gate Ed,Ghaziabad,Uttar Pradesh',
'Dasna R.S.,Ghaziabad,Uttar Pradesh',
'Dasna,Ghaziabad,Uttar Pradesh',
'Delhi Road,Ghaziabad,Uttar Pradesh',
'Dhaulana,Ghaziabad,Uttar Pradesh',
'Didoli,Ghaziabad,Uttar Pradesh',
'Dosa Bangerpur,Ghaziabad,Uttar Pradesh',
'Duhai,Ghaziabad,Uttar Pradesh',
'Dundahara,Ghaziabad,Uttar Pradesh',
'Farrukh Nagar,Ghaziabad,Uttar Pradesh',
'Galand,Ghaziabad,Uttar Pradesh',
'Ghaziabad City,Ghaziabad,Uttar Pradesh',
'Ghaziabad H.O,Ghaziabad,Uttar Pradesh',
'Govindpuram,Ghaziabad,Uttar Pradesh',
'Hasanpur Bhowapur,Ghaziabad,Uttar Pradesh',
'Hassanpur,Ghaziabad,Uttar Pradesh',
'Hindan Nagar,Ghaziabad,Uttar Pradesh',
'Hindon Air Field,Ghaziabad,Uttar Pradesh',
'I.E.Sahibabad,Ghaziabad,Uttar Pradesh',
'Jalalabad,Ghaziabad,Uttar Pradesh',
'Jalalpur Dhindar,Ghaziabad,Uttar Pradesh',
'Jaoli,Ghaziabad,Uttar Pradesh',
'Jindal Nagar,Ghaziabad,Uttar Pradesh',
'Kaila,Ghaziabad,Uttar Pradesh',
'Kakra,Ghaziabad,Uttar Pradesh',
'Kamla Nehru Nagar,Ghaziabad,Uttar Pradesh',
'Kanauja,Ghaziabad,Uttar Pradesh',
'Kaushambi,Ghaziabad,Uttar Pradesh',
'Kavi Nagar,Ghaziabad,Uttar Pradesh',
'Khimawati,Ghaziabad,Uttar Pradesh',
'Kumhera,Ghaziabad,Uttar Pradesh',
'Kushlia,Ghaziabad,Uttar Pradesh',
'Loni,Ghaziabad,Uttar Pradesh',
'Makanpur,Ghaziabad,Uttar Pradesh',
'Mandola,Ghaziabad,Uttar Pradesh',
'Meerut Road,Ghaziabad,Uttar Pradesh',
'Model Town,Ghaziabad,Uttar Pradesh',
'Mohan Nagar,Ghaziabad,Uttar Pradesh',
'Murad Nagar Bazar,Ghaziabad,Uttar Pradesh',
'Murad Nagar,Ghaziabad,Uttar Pradesh',
'Nahal,Ghaziabad,Uttar Pradesh',
'Nasratpura,Ghaziabad,Uttar Pradesh',
'Nehru Nagar,Ghaziabad,Uttar Pradesh',
'Nekpur,Ghaziabad,Uttar Pradesh',
'New Market Pilkhauwa,Ghaziabad,Uttar Pradesh',
'New Raj Nagar,Ghaziabad,Uttar Pradesh',
'Noorpur,Ghaziabad,Uttar Pradesh',
'Old Raj Nagar,Ghaziabad,Uttar Pradesh',
'Pilkhauwa Post Office,Ghaziabad,Uttar Pradesh',
'Police Line Harsaon,Ghaziabad,Uttar Pradesh',
'Postal Staff College (I),Ghaziabad,Uttar Pradesh',
'Raispur,Ghaziabad,Uttar Pradesh',
'Rajapur,Ghaziabad,Uttar Pradesh',
'Ramte Ram Road,Ghaziabad,Uttar Pradesh',
'Raoli Kalan,Ghaziabad,Uttar Pradesh',
'Rewri Rewra,Ghaziabad,Uttar Pradesh',
'Sadarpur,Ghaziabad,Uttar Pradesh',
'Sahibabad,Ghaziabad,Uttar Pradesh',
'Sec-41 Noida,Ghaziabad,Uttar Pradesh',
'Shahpur,Ghaziabad,Uttar Pradesh',
'Shalimar Bagh,Ghaziabad,Uttar Pradesh',
'Sultanpur,Ghaziabad,Uttar Pradesh',
'Surana,Ghaziabad,Uttar Pradesh',
'Surya Nagar,Ghaziabad,Uttar Pradesh',
'Teela Sahbazpur,Ghaziabad,Uttar Pradesh',
'Udai Rampur Nagla,Ghaziabad,Uttar Pradesh',
'Vasundhra,Ghaziabad,Uttar Pradesh',
'Vijai Nagar,Ghaziabad,Uttar Pradesh',
'Achheja,Ghaziabad,Uttar Pradesh',
'Alamnagar,Ghaziabad,Uttar Pradesh',
'Alipur,Ghaziabad,Uttar Pradesh',
'Anwarpur,Ghaziabad,Uttar Pradesh',
'Asaura,Ghaziabad,Uttar Pradesh',
'Athsaini,Ghaziabad,Uttar Pradesh',
'Atola,Ghaziabad,Uttar Pradesh',
'Atrauli,Ghaziabad,Uttar Pradesh',
'Babugarh,Ghaziabad,Uttar Pradesh',
'Bachhlota,Ghaziabad,Uttar Pradesh',
'Bagarpur,Ghaziabad,Uttar Pradesh',
'Bahadurgarh,Ghaziabad,Uttar Pradesh',
'Bajhera Kalan,Ghaziabad,Uttar Pradesh',
'Bajhera Khurd,Ghaziabad,Uttar Pradesh',
'Bankhanda,Ghaziabad,Uttar Pradesh',
'Bhadauli,Ghaziabad,Uttar Pradesh',
'Bhadsiyana,Ghaziabad,Uttar Pradesh',
'Bhaina Dholpur,Ghaziabad,Uttar Pradesh',
'Bhatiyana,Ghaziabad,Uttar Pradesh',
'Bhojpur,Ghaziabad,Uttar Pradesh',
'Bihuni,Ghaziabad,Uttar Pradesh',
'Chajarsi,Ghaziabad,Uttar Pradesh',
'Chamri,Ghaziabad,Uttar Pradesh',
'Chhajupur,Ghaziabad,Uttar Pradesh',
'Churiyala,Ghaziabad,Uttar Pradesh',
'Dadri,Ghaziabad,Uttar Pradesh',
'Dahana,Ghaziabad,Uttar Pradesh',
'Dehpa Azampur,Ghaziabad,Uttar Pradesh',
'Dehra Rampur,Ghaziabad,Uttar Pradesh',
'Dhanaura,Ghaziabad,Uttar Pradesh',
'Doohri,Ghaziabad,Uttar Pradesh',
'Dotai,Ghaziabad,Uttar Pradesh',
'Farid Nagar,Ghaziabad,Uttar Pradesh',
'Gandu Nagla,Ghaziabad,Uttar Pradesh',
'Garh Town,Ghaziabad,Uttar Pradesh',
'Garhmukteswar,Ghaziabad,Uttar Pradesh',
'Ghungrala,Ghaziabad,Uttar Pradesh',
'Girdharpur Tmrel,Ghaziabad,Uttar Pradesh',
'Gohrs Alamgirpur,Ghaziabad,Uttar Pradesh',
'Govindpuri,Ghaziabad,Uttar Pradesh',
'Gyan Lok,Ghaziabad,Uttar Pradesh',
'Haidarpur,Ghaziabad,Uttar Pradesh',
'Hapur H.O,Ghaziabad,Uttar Pradesh',
'Hapur Mandi,Ghaziabad,Uttar Pradesh',
'Harsinghpur,Ghaziabad,Uttar Pradesh',
'Hosdarpur,Ghaziabad,Uttar Pradesh',
'I.E.Hapur,Ghaziabad,Uttar Pradesh',
'Iklahdi,Ghaziabad,Uttar Pradesh',
'Jakhera Rahmatpur,Ghaziabad,Uttar Pradesh',
'Jharina,Ghaziabad,Uttar Pradesh',
'Kalchina,Ghaziabad,Uttar Pradesh',
'Kanya Kalyanpur,Ghaziabad,Uttar Pradesh',
'Kastala,Ghaziabad,Uttar Pradesh',
'Kathikhera,Ghaziabad,Uttar Pradesh',
'Kharkhari,Ghaziabad,Uttar Pradesh',
'Khera,Ghaziabad,Uttar Pradesh',
'Kishan Ganj,Ghaziabad,Uttar Pradesh',
'Luhari,Ghaziabad,Uttar Pradesh',
'Madarsa Sadat,Ghaziabad,Uttar Pradesh',
'Mahmoodpur,Ghaziabad,Uttar Pradesh',
'Mahmoodpur Palwara,Ghaziabad,Uttar Pradesh',
'Mathurawali,Ghaziabad,Uttar Pradesh',
'Matnaurs,Ghaziabad,Uttar Pradesh',
'Modi Nagar,Ghaziabad,Uttar Pradesh',
'Mohd. Pur Khudaliya,Ghaziabad,Uttar Pradesh',
'Mubarikpur,Ghaziabad,Uttar Pradesh',
'Mukeempur,Ghaziabad,Uttar Pradesh',
'Muradpur Janupura,Ghaziabad,Uttar Pradesh',
'Nagola,Ghaziabad,Uttar Pradesh',
'Nali Husainpur,Ghaziabad,Uttar Pradesh',
'Nan,Ghaziabad,Uttar Pradesh',
'Nanpur,Ghaziabad,Uttar Pradesh',
'Nek Nanpur Nanai,Ghaziabad,Uttar Pradesh',
'Phagota,Ghaziabad,Uttar Pradesh',
'Phuldehra,Ghaziabad,Uttar Pradesh',
'Raghunathpur,Ghaziabad,Uttar Pradesh',
'Rajethi,Ghaziabad,Uttar Pradesh',
'Rampur Puth,Ghaziabad,Uttar Pradesh',
'Rasulpur,Ghaziabad,Uttar Pradesh',
'Rly Road Hapur,Ghaziabad,Uttar Pradesh',
'Rori,Ghaziabad,Uttar Pradesh',
'Sadullapur,Ghaziabad,Uttar Pradesh',
'Saidpur,Ghaziabad,Uttar Pradesh',
'Sakhpur,Ghaziabad,Uttar Pradesh',
'Salarpur,Ghaziabad,Uttar Pradesh',
'Samaipur,Ghaziabad,Uttar Pradesh',
'Sapnawat,Ghaziabad,Uttar Pradesh',
'Sara,Ghaziabad,Uttar Pradesh',
'Shah Mohiuddinpur,Ghaziabad,Uttar Pradesh',
'Sharpur,Ghaziabad,Uttar Pradesh',
'Shyampur Jatt,Ghaziabad,Uttar Pradesh',
'Sikandarpur Kakori,Ghaziabad,Uttar Pradesh',
'Sikhera,Ghaziabad,Uttar Pradesh',
'Simbhaoli,Ghaziabad,Uttar Pradesh',
'Talhata,Ghaziabad,Uttar Pradesh',
'Tatarpur,Ghaziabad,Uttar Pradesh',
'Tyori,Ghaziabad,Uttar Pradesh',
'Upera,Ghaziabad,Uttar Pradesh',
'Wait,Ghaziabad,Uttar Pradesh',
'Ingram Institute,Ghaziabad,Uttar Pradesh',
'Khanjarpur,Ghaziabad,Uttar Pradesh',
'Khiluai,Ghaziabad,Uttar Pradesh',
'Baxur,Ghaziabad,Uttar Pradesh',
'Begmabad,Ghaziabad,Uttar Pradesh',
'Bharna,Ghaziabad,Uttar Pradesh',
'Dhana,Ghaziabad,Uttar Pradesh',
'Gyaspur,Ghaziabad,Uttar Pradesh',
'Harmukhpuri,Ghaziabad,Uttar Pradesh',
'Khindora,Ghaziabad,Uttar Pradesh',
'Mahendrapuri,Ghaziabad,Uttar Pradesh',
'Modipon,Ghaziabad,Uttar Pradesh',
'Nagla Akhu,Ghaziabad,Uttar Pradesh',
'Niwari,Ghaziabad,Uttar Pradesh',
'Painga,Ghaziabad,Uttar Pradesh',
'Patla,Ghaziabad,Uttar Pradesh',
'Saunda,Ghaziabad,Uttar Pradesh',
'Shahjahanpur,Ghaziabad,Uttar Pradesh',
'Sikri Kalan,Ghaziabad,Uttar Pradesh',
'Sikri Khurd,Ghaziabad,Uttar Pradesh',
'Tibra,Ghaziabad,Uttar Pradesh',
'Morta,Ghaziabad,Uttar Pradesh',
'Murad Nagar Town,Ghaziabad,Uttar Pradesh',
'Nistoli,Ghaziabad,Uttar Pradesh',
'Sec-27 Noida,Ghaziabad,Uttar Pradesh',
'Pasonda,Ghaziabad,Uttar Pradesh',
'Roza Yakubpur,Ghaziabad,Uttar Pradesh',
'Shahpur Bamheta,Ghaziabad,Uttar Pradesh',
'Datiyana,Ghaziabad,Uttar Pradesh',
'Akarmpur Banjaripur,Ghazipur,Uttar Pradesh',
'Alawalpur,Ghazipur,Uttar Pradesh',
'Andhau,Ghazipur,Uttar Pradesh',
'Arakhpur,Ghazipur,Uttar Pradesh',
'Atwa Fatehpur,Ghazipur,Uttar Pradesh',
'Badhupur,Ghazipur,Uttar Pradesh',
'Baipur Deokali,Ghazipur,Uttar Pradesh',
'Barahi,Ghazipur,Uttar Pradesh',
'Belwa Urf Rasulpur,Ghazipur,Uttar Pradesh',
'Bharsar,Ghazipur,Uttar Pradesh',
'Bhojapur,Ghazipur,Uttar Pradesh',
'Bijaura,Ghazipur,Uttar Pradesh',
'Bikapur,Ghazipur,Uttar Pradesh',
'Birbalpur,Ghazipur,Uttar Pradesh',
'Bogna,Ghazipur,Uttar Pradesh',
'Buzurga Gouspur,Ghazipur,Uttar Pradesh',
'Chak Abdul Sattar,Ghazipur,Uttar Pradesh',
'Chaubepur,Ghazipur,Uttar Pradesh',
'Chaukiya,Ghazipur,Uttar Pradesh',
'Chaurabojh,Ghazipur,Uttar Pradesh',
'Chhawani Line,Ghazipur,Uttar Pradesh',
'Degree College,Ghazipur,Uttar Pradesh',
'Dhanespur,Ghazipur,Uttar Pradesh',
'Dharmagatpur,Ghazipur,Uttar Pradesh',
'Dorasar,Ghazipur,Uttar Pradesh',
'Fadanpur,Ghazipur,Uttar Pradesh',
'Gahali Basarakpur,Ghazipur,Uttar Pradesh',
'Gai,Ghazipur,Uttar Pradesh',
'Ghariha,Ghazipur,Uttar Pradesh',
'Ghazipur City,Ghazipur,Uttar Pradesh',
'Ghazipur H.O,Ghazipur,Uttar Pradesh',
'Ghazipur RS,Ghazipur,Uttar Pradesh',
'Gobindpur,Ghazipur,Uttar Pradesh',
'Gumma,Ghazipur,Uttar Pradesh',
'Harhari,Ghazipur,Uttar Pradesh',
'Hussainpur,Ghazipur,Uttar Pradesh',
'Indaur,Ghazipur,Uttar Pradesh',
'Jaitpura,Ghazipur,Uttar Pradesh',
'Kaithwalia,Ghazipur,Uttar Pradesh',
'Kansahari,Ghazipur,Uttar Pradesh',
'Kataila,Ghazipur,Uttar Pradesh',
'Kelhi,Ghazipur,Uttar Pradesh',
'Khalispur,Ghazipur,Uttar Pradesh',
'Kondari,Ghazipur,Uttar Pradesh',
'Mahrajganj,Ghazipur,Uttar Pradesh',
'Manpur,Ghazipur,Uttar Pradesh',
'Mardah,Ghazipur,Uttar Pradesh',
'Markeenganj,Ghazipur,Uttar Pradesh',
'Matehu,Ghazipur,Uttar Pradesh',
'Nakhatpur,Ghazipur,Uttar Pradesh',
'Noorpur,Ghazipur,Uttar Pradesh',
'Pahetia,Ghazipur,Uttar Pradesh',
'Pandepur Radhey,Ghazipur,Uttar Pradesh',
'Para,Ghazipur,Uttar Pradesh',
'Peernagar,Ghazipur,Uttar Pradesh',
'Permeth,Ghazipur,Uttar Pradesh',
'Pipnar,Ghazipur,Uttar Pradesh',
'Pithapur,Ghazipur,Uttar Pradesh',
'Prithvipur,Ghazipur,Uttar Pradesh',
'Rampur Jiwan,Ghazipur,Uttar Pradesh',
'Ranipur,Ghazipur,Uttar Pradesh',
'Rasulpur Kanhwara,Ghazipur,Uttar Pradesh',
'Rauza,Ghazipur,Uttar Pradesh',
'Ruhipur,Ghazipur,Uttar Pradesh',
'Sarai Gokul,Ghazipur,Uttar Pradesh',
'Singera,Ghazipur,Uttar Pradesh',
'Sohilapur,Ghazipur,Uttar Pradesh',
'Subhashnagar,Ghazipur,Uttar Pradesh',
'Talwal,Ghazipur,Uttar Pradesh',
'Tilesara,Ghazipur,Uttar Pradesh',
'Zangipur,Ghazipur,Uttar Pradesh',
'Birno,Ghazipur,Uttar Pradesh',
'Alipur Madara,Ghazipur,Uttar Pradesh',
'Bajidpur,Ghazipur,Uttar Pradesh',
'Baragaon,Ghazipur,Uttar Pradesh',
'Basewa,Ghazipur,Uttar Pradesh',
'Bhurkura,Ghazipur,Uttar Pradesh',
'Burhanpur,Ghazipur,Uttar Pradesh',
'Chauja,Ghazipur,Uttar Pradesh',
'Chaura,Ghazipur,Uttar Pradesh',
'Dhamupur,Ghazipur,Uttar Pradesh',
'Dullahpur,Ghazipur,Uttar Pradesh',
'Guraini,Ghazipur,Uttar Pradesh',
'Hansrajpur,Ghazipur,Uttar Pradesh',
'Hardaspur Kalan,Ghazipur,Uttar Pradesh',
'Jakhania,Ghazipur,Uttar Pradesh',
'Jalalabad,Ghazipur,Uttar Pradesh',
'Jalalpurdhani,Ghazipur,Uttar Pradesh',
'Jhotna,Ghazipur,Uttar Pradesh',
'Kharwadih,Ghazipur,Uttar Pradesh',
'Khatibpur,Ghazipur,Uttar Pradesh',
'Lediha,Ghazipur,Uttar Pradesh',
'Malikpura,Ghazipur,Uttar Pradesh',
'Manihari,Ghazipur,Uttar Pradesh',
'Oralai,Ghazipur,Uttar Pradesh',
'Orasan,Ghazipur,Uttar Pradesh',
'Rampur Balbhadra,Ghazipur,Uttar Pradesh',
'Rehti Malipur,Ghazipur,Uttar Pradesh',
'Sadarjahanpur,Ghazipur,Uttar Pradesh',
'Sadat,Ghazipur,Uttar Pradesh',
'Sarai Gobind,Ghazipur,Uttar Pradesh',
'Sauri,Ghazipur,Uttar Pradesh',
'Shadiabad,Ghazipur,Uttar Pradesh',
'Sikhari,Ghazipur,Uttar Pradesh',
'Surhurpur,Ghazipur,Uttar Pradesh',
'Tirchhi,Ghazipur,Uttar Pradesh',
'Yusufpur,Ghazipur,Uttar Pradesh',
'Padumpur,Ghazipur,Uttar Pradesh',
'Bahadurganj,Ghazipur,Uttar Pradesh',
'Yusufpur Bazar,Ghazipur,Uttar Pradesh',
'Asawar,Ghazipur,Uttar Pradesh',
'Nonhara,Ghazipur,Uttar Pradesh',
'Joga Musahib,Ghazipur,Uttar Pradesh',
'Kamupur,Ghazipur,Uttar Pradesh',
'Karimuddinpur,Ghazipur,Uttar Pradesh',
'Kasimabad,Ghazipur,Uttar Pradesh',
'Khajurgaon,Ghazipur,Uttar Pradesh',
'Khardiha,Ghazipur,Uttar Pradesh',
'Khetabpur,Ghazipur,Uttar Pradesh',
'Kundesar,Ghazipur,Uttar Pradesh',
'Lauwadih,Ghazipur,Uttar Pradesh',
'Maharaur,Ghazipur,Uttar Pradesh',
'Mata,Ghazipur,Uttar Pradesh',
'Mundera,Ghazipur,Uttar Pradesh',
'Rajapur Katya,Ghazipur,Uttar Pradesh',
'Shekhanpur,Ghazipur,Uttar Pradesh',
'Sherpur Kalan,Ghazipur,Uttar Pradesh',
'Sidhaut,Ghazipur,Uttar Pradesh',
'Siyari,Ghazipur,Uttar Pradesh',
'Tajpur Dehma,Ghazipur,Uttar Pradesh',
'Amrupur,Ghazipur,Uttar Pradesh',
'Banki Khurd,Ghazipur,Uttar Pradesh',
'Jashdeopur,Ghazipur,Uttar Pradesh',
'Mirzabad Mania,Ghazipur,Uttar Pradesh',
'Ramgarh,Ghazipur,Uttar Pradesh',
'Abadan Bairan,Ghazipur,Uttar Pradesh',
'Abishahan,Ghazipur,Uttar Pradesh',
'Alawalpur,Ghazipur,Uttar Pradesh',
'Awathahi,Ghazipur,Uttar Pradesh',
'Bagend,Ghazipur,Uttar Pradesh',
'Balapur,Ghazipur,Uttar Pradesh',
'Barachawar,Ghazipur,Uttar Pradesh',
'Bareji,Ghazipur,Uttar Pradesh',
'Basudeopur,Ghazipur,Uttar Pradesh',
'Bauri,Ghazipur,Uttar Pradesh',
'Bhala,Ghazipur,Uttar Pradesh',
'Bharauli Kalan,Ghazipur,Uttar Pradesh',
'Bhawarkol,Ghazipur,Uttar Pradesh',
'Bhikham Amhat,Ghazipur,Uttar Pradesh',
'Birpur,Ghazipur,Uttar Pradesh',
'Dahendu,Ghazipur,Uttar Pradesh',
'Deoria,Ghazipur,Uttar Pradesh',
'Dhotari,Ghazipur,Uttar Pradesh',
'Dubiha,Ghazipur,Uttar Pradesh',
'Gandhinagar,Ghazipur,Uttar Pradesh',
'Gangauli,Ghazipur,Uttar Pradesh',
'Gathia,Ghazipur,Uttar Pradesh',
'Gauspur,Ghazipur,Uttar Pradesh',
'Gondaur,Ghazipur,Uttar Pradesh',
'Goshalpur,Ghazipur,Uttar Pradesh',
'Hajipur Baresar,Ghazipur,Uttar Pradesh',
'Hartmanpur,Ghazipur,Uttar Pradesh',
'Jahurabad,Ghazipur,Uttar Pradesh',
'Kanuwan,Ghazipur,Uttar Pradesh',
'Kataria,Ghazipur,Uttar Pradesh',
'Kathar,Ghazipur,Uttar Pradesh',
'Khairabari,Ghazipur,Uttar Pradesh',
'Lawa,Ghazipur,Uttar Pradesh',
'Loharpur,Ghazipur,Uttar Pradesh',
'Machhati,Ghazipur,Uttar Pradesh',
'Mahend,Ghazipur,Uttar Pradesh',
'Mahespur Kalan,Ghazipur,Uttar Pradesh',
'Mahuwari,Ghazipur,Uttar Pradesh',
'Mason,Ghazipur,Uttar Pradesh',
'Maura,Ghazipur,Uttar Pradesh',
'Miranpur,Ghazipur,Uttar Pradesh',
'Mohammedabad Yusufpur,Ghazipur,Uttar Pradesh',
'Mubarakpur,Ghazipur,Uttar Pradesh',
'Murki Kalan,Ghazipur,Uttar Pradesh',
'Murtazipur,Ghazipur,Uttar Pradesh',
'Narainpur,Ghazipur,Uttar Pradesh',
'Pakhanpura,Ghazipur,Uttar Pradesh',
'Pali,Ghazipur,Uttar Pradesh',
'Parasa,Ghazipur,Uttar Pradesh',
'Patar,Ghazipur,Uttar Pradesh',
'Patepur,Ghazipur,Uttar Pradesh',
'Rajapur,Ghazipur,Uttar Pradesh',
'Renga,Ghazipur,Uttar Pradesh',
'Reosara,Ghazipur,Uttar Pradesh',
'Salamatpur,Ghazipur,Uttar Pradesh',
'Semara,Ghazipur,Uttar Pradesh',
'Semaur,Ghazipur,Uttar Pradesh',
'Shahbazkuli,Ghazipur,Uttar Pradesh',
'Sonwani,Ghazipur,Uttar Pradesh',
'Sukhdehra,Ghazipur,Uttar Pradesh',
'Tamalpura,Ghazipur,Uttar Pradesh',
'Tandawan,Ghazipur,Uttar Pradesh',
'Taraon Balua,Ghazipur,Uttar Pradesh',
'Tiwaripur,Ghazipur,Uttar Pradesh',
'Utraon,Ghazipur,Uttar Pradesh',
'Pardhan Ki Bareji,Ghazipur,Uttar Pradesh',
'Akbarpur,Ghazipur,Uttar Pradesh',
'Alipur Bangawan,Ghazipur,Uttar Pradesh',
'Ameda,Ghazipur,Uttar Pradesh',
'Amehta,Ghazipur,Uttar Pradesh',
'Anauni,Ghazipur,Uttar Pradesh',
'Aurihar,Ghazipur,Uttar Pradesh',
'Bahariabad,Ghazipur,Uttar Pradesh',
'Bahediya,Ghazipur,Uttar Pradesh',
'Baheri,Ghazipur,Uttar Pradesh',
'Barhat,Ghazipur,Uttar Pradesh',
'Barwa Kalan,Ghazipur,Uttar Pradesh',
'Basuchak,Ghazipur,Uttar Pradesh',
'Basupur,Ghazipur,Uttar Pradesh',
'Baurawan,Ghazipur,Uttar Pradesh',
'Belhari,Ghazipur,Uttar Pradesh',
'Belsari,Ghazipur,Uttar Pradesh',
'Bhala Khurd,Ghazipur,Uttar Pradesh',
'Bhimapar,Ghazipur,Uttar Pradesh',
'Bhitari,Ghazipur,Uttar Pradesh',
'Bhuwarpur,Ghazipur,Uttar Pradesh',
'Bikrampur,Ghazipur,Uttar Pradesh',
'Chaktaj Katghara,Ghazipur,Uttar Pradesh',
'Chandipur,Ghazipur,Uttar Pradesh',
'Chilar,Ghazipur,Uttar Pradesh',
'Dadara,Ghazipur,Uttar Pradesh',
'Dahra Kalan,Ghazipur,Uttar Pradesh',
'Darhwal,Ghazipur,Uttar Pradesh',
'Daulatnagar,Ghazipur,Uttar Pradesh',
'Daulatpur,Ghazipur,Uttar Pradesh',
'Deochandpur,Ghazipur,Uttar Pradesh',
'Bahauddinpur,Sultanpur,Uttar Pradesh',
'Bangaondih,Jaunpur,Uttar Pradesh',
'Banke Gaon,Sultanpur,Uttar Pradesh',
'Barauna Dih,Sultanpur,Uttar Pradesh',
'Barwaripur,Sultanpur,Uttar Pradesh',
'Basupur,Sultanpur,Uttar Pradesh',
'Bethara,Sultanpur,Uttar Pradesh',
'Bhatauta Tulsi Patti,Sultanpur,Uttar Pradesh',
'Bhelara,Jaunpur,Uttar Pradesh',
'Bhilampur,Sultanpur,Uttar Pradesh',
'Biraipur,Sultanpur,Uttar Pradesh',
'Biri Hajipur,Sultanpur,Uttar Pradesh',
'Birsinghpur,Sultanpur,Uttar Pradesh',
'Burhana,Sultanpur,Uttar Pradesh',
'Chhitepatti,Sultanpur,Uttar Pradesh',
'Daria Amrethu,Sultanpur,Uttar Pradesh',
'Deara,Sultanpur,Uttar Pradesh',
'Deorajpur,Sultanpur,Uttar Pradesh',
'Dhanaupur,Sultanpur,Uttar Pradesh',
'Dharsauli,Sultanpur,Uttar Pradesh',
'Dhema,Sultanpur,Uttar Pradesh',
'Dih Dhaggupur,Sultanpur,Uttar Pradesh',
'Dostpur,Sultanpur,Uttar Pradesh',
'Faridpur,Sultanpur,Uttar Pradesh',
'Gaura Tikari,Sultanpur,Uttar Pradesh',
'Gosaisinghpur,Sultanpur,Uttar Pradesh',
'Hamidpur,Sultanpur,Uttar Pradesh',
'Hamjapur Pathan,Sultanpur,Uttar Pradesh',
'Hamzabad,Sultanpur,Uttar Pradesh',
'Haripur,Sultanpur,Uttar Pradesh',
'Harpur,Jaunpur,Uttar Pradesh',
'Harthua Babhanpur,Sultanpur,Uttar Pradesh',
'Hatiyawan,Sultanpur,Uttar Pradesh',
'Hinduabad,Sultanpur,Uttar Pradesh',
'Imligaon,Sultanpur,Uttar Pradesh',
'Jamalpur Jajrahi,Sultanpur,Uttar Pradesh',
'Kachha Bhitaura,Sultanpur,Uttar Pradesh',
'Kadipur Khurd,Sultanpur,Uttar Pradesh',
'Kadipur,Sultanpur,Uttar Pradesh',
'Kaithi Jalalpur,Sultanpur,Uttar Pradesh',
'Kalan,Jaunpur,Uttar Pradesh',
'Kamtaganj,Sultanpur,Uttar Pradesh',
'Katghara Patti,Sultanpur,Uttar Pradesh',
'Katsari,Sultanpur,Uttar Pradesh',
'Khalispur Dingur,Sultanpur,Uttar Pradesh',
'Kharsara,Sultanpur,Uttar Pradesh',
'Kisundaspur,Sultanpur,Uttar Pradesh',
'Kumbhi,Sultanpur,Uttar Pradesh',
'Kunda Bhairavpur,Sultanpur,Uttar Pradesh',
'Lama Bankata,Sultanpur,Uttar Pradesh',
'Loknathpur,Sultanpur,Uttar Pradesh',
'Magarsan Kala,Sultanpur,Uttar Pradesh',
'Malikpur Nonara,Sultanpur,Uttar Pradesh',
'Mangrawan,Sultanpur,Uttar Pradesh',
'Meopur,Sultanpur,Uttar Pradesh',
'Mirpur Saraiya,Sultanpur,Uttar Pradesh',
'Motigarpur,Sultanpur,Uttar Pradesh',
'Mungar,Sultanpur,Uttar Pradesh',
'Musatafabad Saraiya,Sultanpur,Uttar Pradesh',
'Nanemau,Sultanpur,Uttar Pradesh',
'Narayanpur,Sultanpur,Uttar Pradesh',
'Narayanpur Kalan,Sultanpur,Uttar Pradesh',
'Narharpur,Sultanpur,Uttar Pradesh',
'Numayen Merai,Sultanpur,Uttar Pradesh',
'Paharpur,Sultanpur,Uttar Pradesh',
'Paharpur Rai Patti,Sultanpur,Uttar Pradesh',
'Paharpur Sarai Bhikham,Sultanpur,Uttar Pradesh',
'Pakarpur,Sultanpur,Uttar Pradesh',
'Palia,Sultanpur,Uttar Pradesh',
'Palia Golpur,Sultanpur,Uttar Pradesh',
'Paras Patti,Sultanpur,Uttar Pradesh',
'Paudhan Rampur,Sultanpur,Uttar Pradesh',
'Purushottampur,Sultanpur,Uttar Pradesh',
'Raibigo,Sultanpur,Uttar Pradesh',
'Rawania,Sultanpur,Uttar Pradesh',
'Rohiyawan Jalalpur,Sultanpur,Uttar Pradesh',
'Rupaipur,Jaunpur,Uttar Pradesh',
'Rupinpur,Sultanpur,Uttar Pradesh',
'Sarsawan,Sultanpur,Uttar Pradesh',
'Satanpur,Sultanpur,Uttar Pradesh',
'Seotari,Sultanpur,Uttar Pradesh',
'Shahabuddinpur,Sultanpur,Uttar Pradesh',
'Sukulpur,Sultanpur,Uttar Pradesh',
'Surapur,Sultanpur,Uttar Pradesh',
'Surhurpur,Sultanpur,Uttar Pradesh',
'Tajuddinpur,Sultanpur,Uttar Pradesh',
'Tawakkalpur Nagra,Sultanpur,Uttar Pradesh',
'Trilokpur Newada,Sultanpur,Uttar Pradesh',
'Ugharpur Bhatpura,Sultanpur,Uttar Pradesh',
'Umarpur,Sultanpur,Uttar Pradesh',
'Unurkha,Sultanpur,Uttar Pradesh',
'Usrauli,Sultanpur,Uttar Pradesh',
'Arjunpur,Sultanpur,Uttar Pradesh',
'Ausanpur,Sultanpur,Uttar Pradesh',
'Bahrauli,Sultanpur,Uttar Pradesh',
'Bainti Kalan,Sultanpur,Uttar Pradesh',
'Barsara,Sultanpur,Uttar Pradesh',
'Barua,Sultanpur,Uttar Pradesh',
'Belahi,Sultanpur,Uttar Pradesh',
'Bhadaiyan,Sultanpur,Uttar Pradesh',
'Bhardhipur,Sultanpur,Uttar Pradesh',
'Bharkhare,Sultanpur,Uttar Pradesh',
'Bhua Pathkauli,Sultanpur,Uttar Pradesh',
'Budhapur,Sultanpur,Uttar Pradesh',
'Chaukia,Sultanpur,Uttar Pradesh',
'Chhapar,Sultanpur,Uttar Pradesh',
'Dewarh,Sultanpur,Uttar Pradesh',
'Garabpur,Sultanpur,Uttar Pradesh',
'Garayen,Sultanpur,Uttar Pradesh',
'Ghatampur,Sultanpur,Uttar Pradesh',
'Hardaspur,Sultanpur,Uttar Pradesh',
'Harha,Sultanpur,Uttar Pradesh',
'Jamkhuri,Sultanpur,Uttar Pradesh',
'Jhauara,Sultanpur,Uttar Pradesh',
'Kaithapur,Sultanpur,Uttar Pradesh',
'Kandhaipur,Sultanpur,Uttar Pradesh',
'Khanpur,Sultanpur,Uttar Pradesh',
'Koiripur,Sultanpur,Uttar Pradesh',
'Kothara Khurd,Sultanpur,Uttar Pradesh',
'Kuchhmuchh,Sultanpur,Uttar Pradesh',
'Lambhua,Sultanpur,Uttar Pradesh',
'Maharani Pachchhim,Sultanpur,Uttar Pradesh',
'Mahdeva,Sultanpur,Uttar Pradesh',
'Maksudan,Sultanpur,Uttar Pradesh',
'Malhipur,Sultanpur,Uttar Pradesh',
'Misirpur,Sultanpur,Uttar Pradesh',
'Narendapur,Sultanpur,Uttar Pradesh',
'Pakhrauli,Sultanpur,Uttar Pradesh',
'Parasurampur,Sultanpur,Uttar Pradesh',
'Patipur,Sultanpur,Uttar Pradesh',
'Raipur,Sultanpur,Uttar Pradesh',
'Raja Umari,Sultanpur,Uttar Pradesh',
'Ramgarh,Sultanpur,Uttar Pradesh',
'Rampur,Sultanpur,Uttar Pradesh',
'Ranipur,Sultanpur,Uttar Pradesh',
'Rikhpur,Sultanpur,Uttar Pradesh',
'Sadarpur,Sultanpur,Uttar Pradesh',
'Safipur,Sultanpur,Uttar Pradesh',
'Shahpur Harbansh,Sultanpur,Uttar Pradesh',
'Shankarpur,Sultanpur,Uttar Pradesh',
'Sheshanpur,Sultanpur,Uttar Pradesh',
'Shivgarh,Sultanpur,Uttar Pradesh',
'Sonawan,Sultanpur,Uttar Pradesh',
'Sukul Umari,Sultanpur,Uttar Pradesh',
'Suryabhan Patti,Sultanpur,Uttar Pradesh',
'Tamarsepur,Sultanpur,Uttar Pradesh',
'Tato Muraini,Sultanpur,Uttar Pradesh',
'Waini,Sultanpur,Uttar Pradesh',
'Arhanpur,Sultanpur,Uttar Pradesh',
'Asarfpur,Sultanpur,Uttar Pradesh',
'Ataula,Sultanpur,Uttar Pradesh',
'Aurangabad,Sultanpur,Uttar Pradesh',
'Bahurahwan,Sultanpur,Uttar Pradesh',
'Baqghauna,Sultanpur,Uttar Pradesh',
'Baranpur,Sultanpur,Uttar Pradesh',
'Barehti,Sultanpur,Uttar Pradesh',
'Barmhauli,Sultanpur,Uttar Pradesh',
'Barsanda,Sultanpur,Uttar Pradesh',
'Bazar Baldirai,Sultanpur,Uttar Pradesh',
'Bhakhari,Sultanpur,Uttar Pradesh',
'Bhanauli,Sultanpur,Uttar Pradesh',
'Bhikhipur,Sultanpur,Uttar Pradesh',
'Bisara Pashchim,Sultanpur,Uttar Pradesh',
'Bisawan,Sultanpur,Uttar Pradesh',
'Chanauki,Sultanpur,Uttar Pradesh',
'Dadra,Sultanpur,Uttar Pradesh',
'Dehriyawan,Sultanpur,Uttar Pradesh',
'Deokali,Sultanpur,Uttar Pradesh',
'Dih,Sultanpur,Uttar Pradesh',
'Dobhiara,Sultanpur,Uttar Pradesh',
'Domadih,Sultanpur,Uttar Pradesh',
'Dulari Nagar,Sultanpur,Uttar Pradesh',
'Gai Mau,Sultanpur,Uttar Pradesh',
'Gajanpur Duaria,Sultanpur,Uttar Pradesh',
'Gaura Loharia,Sultanpur,Uttar Pradesh',
'Goriabad,Sultanpur,Uttar Pradesh',
'Gunnaur,Sultanpur,Uttar Pradesh',
'Haliapur,Sultanpur,Uttar Pradesh',
'Hardoia,Sultanpur,Uttar Pradesh',
'Hari Mau,Sultanpur,Uttar Pradesh',
'Harkaranpur,Sultanpur,Uttar Pradesh',
'Harkhumau,Sultanpur,Uttar Pradesh',
'Hussainganj Kala,Sultanpur,Uttar Pradesh',
'Ichhuti,Sultanpur,Uttar Pradesh',
'Imligaon Chupi,Sultanpur,Uttar Pradesh',
'Isauli,Sultanpur,Uttar Pradesh',
'Jagdishpur Industrial Area,Sultanpur,Uttar Pradesh',
'Jagdishpur,Sultanpur,Uttar Pradesh',
'Jagesarganj,Sultanpur,Uttar Pradesh',
'Jarai Kalan,Sultanpur,Uttar Pradesh',
'Kampa,Sultanpur,Uttar Pradesh',
'Kamrauli,Sultanpur,Uttar Pradesh',
'Kanehti,Sultanpur,Uttar Pradesh',
'Kankupur,Sultanpur,Uttar Pradesh',
'Kisni,Sultanpur,Uttar Pradesh',
'Mahemau,Sultanpur,Uttar Pradesh',
'Mahona,Sultanpur,Uttar Pradesh',
'Makhdoompur,Sultanpur,Uttar Pradesh',
'Mangauli,Sultanpur,Uttar Pradesh',
'Mangrauli,Sultanpur,Uttar Pradesh',
'Mardanpur,Sultanpur,Uttar Pradesh',
'Mau Atwara,Sultanpur,Uttar Pradesh',
'Mayas,Sultanpur,Uttar Pradesh',
'Meghmau,Sultanpur,Uttar Pradesh',
'Muhammadpur,Sultanpur,Uttar Pradesh',
'Musafirkhana,Sultanpur,Uttar Pradesh',
'Nandauli,Sultanpur,Uttar Pradesh',
'Narsara,Sultanpur,Uttar Pradesh',
'Naudar,Sultanpur,Uttar Pradesh',
'Nayakot Dharauli,Sultanpur,Uttar Pradesh',
'Pali,Sultanpur,Uttar Pradesh',
'Para,Sultanpur,Uttar Pradesh',
'Phatefpur,Sultanpur,Uttar Pradesh',
'Pichhaura,Sultanpur,Uttar Pradesh',
'Pindara,Sultanpur,Uttar Pradesh',
'Pipari,Sultanpur,Uttar Pradesh',
'Purab Bisara,Sultanpur,Uttar Pradesh',
'Purab Gaon,Sultanpur,Uttar Pradesh',
'Purab Kasthuni,Sultanpur,Uttar Pradesh',
'Rachkheta,Sultanpur,Uttar Pradesh',
'Raincha,Sultanpur,Uttar Pradesh',
'Rajupur,Sultanpur,Uttar Pradesh',
'Raniganj,Sultanpur,Uttar Pradesh',
'Rasulpur,Sultanpur,Uttar Pradesh',
'Rudauli,Sultanpur,Uttar Pradesh',
'Sadipur,Sultanpur,Uttar Pradesh',
'Saini,Sultanpur,Uttar Pradesh',
'Sansarpur,Sultanpur,Uttar Pradesh',
'Saraiya Mafi,Sultanpur,Uttar Pradesh',
'Saresar,Sultanpur,Uttar Pradesh',
'Sathyain,Sultanpur,Uttar Pradesh',
'Seora,Sultanpur,Uttar Pradesh',
'Sidhiawan,Sultanpur,Uttar Pradesh',
'Sikari,Sultanpur,Uttar Pradesh',
'Sindurwa,Sultanpur,Uttar Pradesh',
'Soraon,Sultanpur,Uttar Pradesh',
'Sukul Ka Bazar,Sultanpur,Uttar Pradesh',
'Tarwa,Sultanpur,Uttar Pradesh',
'Taudhikpur,Sultanpur,Uttar Pradesh',
'Teosi,Sultanpur,Uttar Pradesh',
'Thauri,Sultanpur,Uttar Pradesh',
'Tirhut,Sultanpur,Uttar Pradesh',
'Umara,Sultanpur,Uttar Pradesh',
'Unchgaon,Sultanpur,Uttar Pradesh',
'Unchgaon,Sultanpur,Uttar Pradesh',
'Wallipur,Sultanpur,Uttar Pradesh',
'Baharpur,Sultanpur,Uttar Pradesh',
'Bariauna,Sultanpur,Uttar Pradesh',
'Agai,Sultanpur,Uttar Pradesh',
'Ahimane,Sultanpur,Uttar Pradesh',
'Ainjar,Sultanpur,Uttar Pradesh',
'Akorhi,Sultanpur,Uttar Pradesh',
'Aliganj Bazar,Sultanpur,Uttar Pradesh',
'Angnakol,Sultanpur,Uttar Pradesh',
'Athaisi,Sultanpur,Uttar Pradesh',
'Baburi,Sultanpur,Uttar Pradesh',
'Bahadurpur,Sultanpur,Uttar Pradesh',
'Bahlolpur,Sultanpur,Uttar Pradesh',
'Baidaha,Sultanpur,Uttar Pradesh',
'Baijapur,Sultanpur,Uttar Pradesh',
'Ballipur,Sultanpur,Uttar Pradesh',
'Bandhua Kalan,Sultanpur,Uttar Pradesh',
'Bankepur,Sultanpur,Uttar Pradesh',
'Bansi,Sultanpur,Uttar Pradesh',
'Baregaon,Sultanpur,Uttar Pradesh',
'Baura Jagdishpur,Sultanpur,Uttar Pradesh',
'Bela Pashchim,Sultanpur,Uttar Pradesh',
'Bhandara,Sultanpur,Uttar Pradesh',
'Bhanti,Sultanpur,Uttar Pradesh',
'Bhapta,Sultanpur,Uttar Pradesh',
'Bhikhupur,Sultanpur,Uttar Pradesh',
'Bijhuri,Sultanpur,Uttar Pradesh',
'Bikana,Sultanpur,Uttar Pradesh',
'Bikwajitpur,Sultanpur,Uttar Pradesh',
'Bingi,Sultanpur,Uttar Pradesh',
'Chakchurawanpur,Sultanpur,Uttar Pradesh',
'Chandaur,Sultanpur,Uttar Pradesh',
'Chandipur,Sultanpur,Uttar Pradesh',
'Chhatauna,Sultanpur,Uttar Pradesh',
'Chorma,Sultanpur,Uttar Pradesh',
'Dadupur,Sultanpur,Uttar Pradesh',
'Damodarpur,Sultanpur,Uttar Pradesh',
'Deora,Sultanpur,Uttar Pradesh',
'Dhajai Keshavpur,Sultanpur,Uttar Pradesh',
'Dhakwa,Sultanpur,Uttar Pradesh',
'Dharawan,Sultanpur,Uttar Pradesh',
'Dheka Pakhanpur,Sultanpur,Uttar Pradesh',
'Dhundhu,Sultanpur,Uttar Pradesh',
'Dubepur,Sultanpur,Uttar Pradesh',
'Fatehpur Sangat,Sultanpur,Uttar Pradesh',
'Ferozpur Kala,Sultanpur,Uttar Pradesh',
'Ganpat Sahai Degree College,Sultanpur,Uttar Pradesh',
'Gaura,Sultanpur,Uttar Pradesh',
'Gorabarik,Sultanpur,Uttar Pradesh',
'Guptarganj,Sultanpur,Uttar Pradesh',
'Haji Patti,Sultanpur,Uttar Pradesh',
'Hanumanganj,Sultanpur,Uttar Pradesh',
'Hayatnagar,Sultanpur,Uttar Pradesh',
'Inayatpur,Sultanpur,Uttar Pradesh',
'Isur,Sultanpur,Uttar Pradesh',
'Jajjaur,Sultanpur,Uttar Pradesh',
'Jasapara,Sultanpur,Uttar Pradesh',
'Jura Patti,Sultanpur,Uttar Pradesh',
'Jurupur,Sultanpur,Uttar Pradesh',
'Kaithwara,Sultanpur,Uttar Pradesh',
'Kanauli,Sultanpur,Uttar Pradesh',
'Kareban,Sultanpur,Uttar Pradesh',
'Katawan,Sultanpur,Uttar Pradesh',
'Khadar Basantpur,Sultanpur,Uttar Pradesh',
'Khokhipur,Sultanpur,Uttar Pradesh',
'Kotia,Sultanpur,Uttar Pradesh',
'Kotwa Lahangrai,Sultanpur,Uttar Pradesh',
'Lahauta,Sultanpur,Uttar Pradesh',
'Lohra Mau,Sultanpur,Uttar Pradesh',
'Madhavpur Chhatauna,Sultanpur,Uttar Pradesh',
'Mahmoodpur,Sultanpur,Uttar Pradesh',
'Mahrajganj,Sultanpur,Uttar Pradesh',
'Majhana,Sultanpur,Uttar Pradesh',
'Makdoomnagar,Sultanpur,Uttar Pradesh',
'Manipur Patna,Sultanpur,Uttar Pradesh',
'Maniyarpur,Sultanpur,Uttar Pradesh',
'Misrauli,Sultanpur,Uttar Pradesh',
'Motiganj,Sultanpur,Uttar Pradesh',
'Murua,Sultanpur,Uttar Pradesh',
'Nachana,Sultanpur,Uttar Pradesh',
'Nandrai,Sultanpur,Uttar Pradesh',
'Naugawan Raitasi,Sultanpur,Uttar Pradesh',
'Naugawan Tir,Sultanpur,Uttar Pradesh',
'Padare,Sultanpur,Uttar Pradesh',
'Palahipur,Sultanpur,Uttar Pradesh',
'Parsa Darwa,Sultanpur,Uttar Pradesh',
'Parsara,Sultanpur,Uttar Pradesh',
'Parsipur,Sultanpur,Uttar Pradesh',
'Parwar,Sultanpur,Uttar Pradesh',
'Peero Saraia,Sultanpur,Uttar Pradesh',
'Pipargaon,Sultanpur,Uttar Pradesh',
'Pratap Pur,Sultanpur,Uttar Pradesh',
'Rajupur Ikdala,Sultanpur,Uttar Pradesh',
'Ramapur,Sultanpur,Uttar Pradesh',
'Ramnagar Kot,Sultanpur,Uttar Pradesh',
'Rupapur,Sultanpur,Uttar Pradesh',
'Saidkhanpur,Sultanpur,Uttar Pradesh',
'Saifullaganj,Sultanpur,Uttar Pradesh',
'Sarkaura,Sultanpur,Uttar Pradesh',
'Seur Chamurkha,Sultanpur,Uttar Pradesh',
'Shahpur,Sultanpur,Uttar Pradesh',
'Singhni,Sultanpur,Uttar Pradesh',
'Sohgauli,Sultanpur,Uttar Pradesh',
'Sonara,Sultanpur,Uttar Pradesh',
'Teary,Sultanpur,Uttar Pradesh',
'Tirchhe,Sultanpur,Uttar Pradesh',
'Ugharpur,Sultanpur,Uttar Pradesh',
'Uturi,Sultanpur,Uttar Pradesh',
'Abhiya Kalan,Sultanpur,Uttar Pradesh',
'Atarsuma,Sultanpur,Uttar Pradesh',
'Baraunsa,Sultanpur,Uttar Pradesh',
'Belahari,Sultanpur,Uttar Pradesh',
'Bus Station,Sultanpur,Uttar Pradesh',
'Civil Lines Sultanpur,Sultanpur,Uttar Pradesh',
'Dhammaur,Sultanpur,Uttar Pradesh',
'Dwarikaganj,Sultanpur,Uttar Pradesh',
'Gosainganj,Sultanpur,Uttar Pradesh',
'Hasanpur,Sultanpur,Uttar Pradesh',
'Jaisinghpur,Sultanpur,Uttar Pradesh',
'Kamla Nehru Institute,Sultanpur,Uttar Pradesh',
'Karaundia,Sultanpur,Uttar Pradesh',
'Khairabad,Sultanpur,Uttar Pradesh',
'Kurebhar,Sultanpur,Uttar Pradesh',
'Kurwar,Sultanpur,Uttar Pradesh',
'Loco Colony,Sultanpur,Uttar Pradesh',
'Mahmoodpur Semri,Sultanpur,Uttar Pradesh',
'Mayang,Sultanpur,Uttar Pradesh',
'Shyamnagar,Sultanpur,Uttar Pradesh',
'Sultanpur (Avadh) H.O,Sultanpur,Uttar Pradesh',
'Sultanpur City,Sultanpur,Uttar Pradesh',
'Kumbhi,Kanpur Moffusil,Uttar Pradesh',
'Bihar,Kanpur Moffusil,Uttar Pradesh',
'Badora,Kanpur Moffusil,Uttar Pradesh',
'Baigaon,Kanpur Moffusil,Uttar Pradesh',
'Bhatnag,Kanpur Moffusil,Uttar Pradesh',
'Bhopatpur,Kanpur Moffusil,Uttar Pradesh',
'Bichhiya,Kanpur Moffusil,Uttar Pradesh',
'Chetra,Kanpur Moffusil,Uttar Pradesh',
'Dela,Kanpur Moffusil,Uttar Pradesh',
'Dhannapur,Kanpur Moffusil,Uttar Pradesh',
'Madarpur Narainpur,Kanpur Moffusil,Uttar Pradesh',
'Majhgawa,Kanpur Moffusil,Uttar Pradesh',
'Mirzapur Sumbhari,Kanpur Moffusil,Uttar Pradesh',
'Mohmmedpur,Kanpur Moffusil,Uttar Pradesh',
'Nathikhera,Kanpur Moffusil,Uttar Pradesh',
'Nevarna,Kanpur Moffusil,Uttar Pradesh',
'Orhar,Kanpur Moffusil,Uttar Pradesh',
'Padri Kalan,Kanpur Moffusil,Uttar Pradesh',
'Padri Khurd,Kanpur Moffusil,Uttar Pradesh',
'Targaon,Kanpur Moffusil,Uttar Pradesh',
'Taura,Kanpur Moffusil,Uttar Pradesh',
'Tripurarpur,Kanpur Moffusil,Uttar Pradesh',
'Zargaon,Kanpur Moffusil,Uttar Pradesh',
'Atwa,Kanpur Moffusil,Uttar Pradesh',
'Bandakhera,Kanpur Moffusil,Uttar Pradesh',
'Bandakhera,Kanpur Moffusil,Uttar Pradesh',
'Bhadsar Nausahra,Kanpur Moffusil,Uttar Pradesh',
'Dabauli,Kanpur Moffusil,Uttar Pradesh',
'Daldalha,Kanpur Moffusil,Uttar Pradesh',
'Darauli,Kanpur Moffusil,Uttar Pradesh',
'Devgaon,Kanpur Moffusil,Uttar Pradesh',
'Fatehpur Chaurasi,Kanpur Moffusil,Uttar Pradesh',
'Gangadas Pur,Kanpur Moffusil,Uttar Pradesh',
'Kanjaura,Kanpur Moffusil,Uttar Pradesh',
'Korari Khurd,Kanpur Moffusil,Uttar Pradesh',
'Lawani Kalan,Kanpur Moffusil,Uttar Pradesh',
'Mraunda Majhwara,Kanpur Moffusil,Uttar Pradesh',
'Munda,Kanpur Moffusil,Uttar Pradesh',
'Mundha,Kanpur Moffusil,Uttar Pradesh',
'Mustafabad Pakhrora,Kanpur Moffusil,Uttar Pradesh',
'Osiya,Kanpur Moffusil,Uttar Pradesh',
'Pariyar,Kanpur Moffusil,Uttar Pradesh',
'Rahat Ganj,Kanpur Moffusil,Uttar Pradesh',
'Sarai Sakhan,Kanpur Moffusil,Uttar Pradesh',
'Unnwa,Kanpur Moffusil,Uttar Pradesh',
'Vamhna,Kanpur Moffusil,Uttar Pradesh',
'Zamuniya Kachh,Kanpur Moffusil,Uttar Pradesh',
'Jajamau,Kanpur Moffusil,Uttar Pradesh',
'Udtar,Kanpur Moffusil,Uttar Pradesh',
'Rampur Gaderuwa,Kanpur Moffusil,Uttar Pradesh',
'Aakampur,Kanpur Moffusil,Uttar Pradesh',
'Achalganj,Kanpur Moffusil,Uttar Pradesh',
'Aderuwa,Kanpur Moffusil,Uttar Pradesh',
'Ahesa,Kanpur Moffusil,Uttar Pradesh',
'Ajgain,Kanpur Moffusil,Uttar Pradesh',
'Akbarpur,Kanpur Moffusil,Uttar Pradesh',
'Akohari,Kanpur Moffusil,Uttar Pradesh',
'Akrampur,Kanpur Moffusil,Uttar Pradesh',
'Akwabad,Kanpur Moffusil,Uttar Pradesh',
'Alipur,Kanpur Moffusil,Uttar Pradesh',
'Aon,Kanpur Moffusil,Uttar Pradesh',
'Argoopur,Kanpur Moffusil,Uttar Pradesh',
'Arjunamau,Kanpur Moffusil,Uttar Pradesh',
'Asawar,Kanpur Moffusil,Uttar Pradesh',
'Asha Khera,Kanpur Moffusil,Uttar Pradesh',
'Ashayash,Kanpur Moffusil,Uttar Pradesh',
'Asoha,Kanpur Moffusil,Uttar Pradesh',
'Aterdhani,Kanpur Moffusil,Uttar Pradesh',
'Atesuwa,Kanpur Moffusil,Uttar Pradesh',
'Atwabaik,Kanpur Moffusil,Uttar Pradesh',
'Auras,Kanpur Moffusil,Uttar Pradesh',
'Bachhaauli,Kanpur Moffusil,Uttar Pradesh',
'Badarka,Kanpur Moffusil,Uttar Pradesh',
'Badhwa Kola,Kanpur Moffusil,Uttar Pradesh',
'Ballapur,Kanpur Moffusil,Uttar Pradesh',
'Band Hamirpur,Kanpur Moffusil,Uttar Pradesh',
'Bangermau,Kanpur Moffusil,Uttar Pradesh',
'Banigaon,Kanpur Moffusil,Uttar Pradesh',
'Banther,Kanpur Moffusil,Uttar Pradesh',
'Bara,Kanpur Moffusil,Uttar Pradesh',
'Bardaha,Kanpur Moffusil,Uttar Pradesh',
'Barithana,Kanpur Moffusil,Uttar Pradesh',
'Baxer,Kanpur Moffusil,Uttar Pradesh',
'Behta Bhawani,Kanpur Moffusil,Uttar Pradesh',
'Bether,Kanpur Moffusil,Uttar Pradesh',
'Bhadohi,Kanpur Moffusil,Uttar Pradesh',
'Bhagwant Nagar,Kanpur Moffusil,Uttar Pradesh',
'Bhauli,Kanpur Moffusil,Uttar Pradesh',
'Bhikharipur Patsiya,Kanpur Moffusil,Uttar Pradesh',
'Bhusandi,Kanpur Moffusil,Uttar Pradesh',
'Bighapur,Kanpur Moffusil,Uttar Pradesh',
'Birsinghpur,Kanpur Moffusil,Uttar Pradesh',
'Bisen Mau,Kanpur Moffusil,Uttar Pradesh',
'Byohani,Kanpur Moffusil,Uttar Pradesh',
'Chainpur,Kanpur Moffusil,Uttar Pradesh',
'Chamiyani,Kanpur Moffusil,Uttar Pradesh',
'Chamrauli,Kanpur Moffusil,Uttar Pradesh',
'Chanden Pur,Kanpur Moffusil,Uttar Pradesh',
'Chandpur Jhalaei,Kanpur Moffusil,Uttar Pradesh',
'Chauper,Kanpur Moffusil,Uttar Pradesh',
'Chharihara,Kanpur Moffusil,Uttar Pradesh',
'Collectorate Unnao,Kanpur Moffusil,Uttar Pradesh',
'Csa Colony,Kanpur Moffusil,Uttar Pradesh',
'Darehata,Kanpur Moffusil,Uttar Pradesh',
'Deeh,Kanpur Moffusil,Uttar Pradesh',
'Devmay,Kanpur Moffusil,Uttar Pradesh',
'Devra Kalan,Kanpur Moffusil,Uttar Pradesh',
'Dhani Khera,Kanpur Moffusil,Uttar Pradesh',
'Dhanikhera,Kanpur Moffusil,Uttar Pradesh',
'Dhankoli,Kanpur Moffusil,Uttar Pradesh',
'Dhaura,Kanpur Moffusil,Uttar Pradesh',
'Dipwal,Kanpur Moffusil,Uttar Pradesh',
'Dodiya Khera,Kanpur Moffusil,Uttar Pradesh',
'Drehata,Kanpur Moffusil,Uttar Pradesh',
'Dubeypur,Kanpur Moffusil,Uttar Pradesh',
'Dundpur Jhthra,Kanpur Moffusil,Uttar Pradesh',
'Faridpur Katter,Kanpur Moffusil,Uttar Pradesh',
'Ganga Ghat,Kanpur Moffusil,Uttar Pradesh',
'Ganj Jalalabad,Kanpur Moffusil,Uttar Pradesh',
'Ganj Moradabad,Kanpur Moffusil,Uttar Pradesh',
'Garha Kola,Kanpur Moffusil,Uttar Pradesh',
'Gaura,Kanpur Moffusil,Uttar Pradesh',
'Gauraiya Kalan,Kanpur Moffusil,Uttar Pradesh',
'Ghatampur,Kanpur Moffusil,Uttar Pradesh',
'Gulauli,Kanpur Moffusil,Uttar Pradesh',
'Gulriha,Kanpur Moffusil,Uttar Pradesh',
'Hafizabad,Kanpur Moffusil,Uttar Pradesh',
'Haraha,Kanpur Moffusil,Uttar Pradesh',
'Hariyapur,Kanpur Moffusil,Uttar Pradesh',
'Hasanganj,Kanpur Moffusil,Uttar Pradesh',
'Hedrabad,Kanpur Moffusil,Uttar Pradesh',
'Indemau,Kanpur Moffusil,Uttar Pradesh',
'Itauli,Kanpur Moffusil,Uttar Pradesh',
'Jagatnagar,Kanpur Moffusil,Uttar Pradesh',
'Jagatpur,Kanpur Moffusil,Uttar Pradesh',
'Jaitipur,Kanpur Moffusil,Uttar Pradesh',
'Jamuka,Kanpur Moffusil,Uttar Pradesh',
'Jawaher Nager,Kanpur Moffusil,Uttar Pradesh',
'Jogo Kot,Kanpur Moffusil,Uttar Pradesh',
'Kakehrwa,Kanpur Moffusil,Uttar Pradesh',
'Kalwari,Kanpur Moffusil,Uttar Pradesh',
'Kanchanpur,Kanpur Moffusil,Uttar Pradesh',
'Kanjaura,Kanpur Moffusil,Uttar Pradesh',
'Kanta Guljarpur,Kanpur Moffusil,Uttar Pradesh',
'Kantha,Kanpur Moffusil,Uttar Pradesh',
'Kardaha,Kanpur Moffusil,Uttar Pradesh',
'Karowan,Kanpur Moffusil,Uttar Pradesh',
'Katehru,Kanpur Moffusil,Uttar Pradesh',
'Kesar Ganj,Kanpur Moffusil,Uttar Pradesh',
'Khambhauli,Kanpur Moffusil,Uttar Pradesh',
'Kharoli,Kanpur Moffusil,Uttar Pradesh',
'Kodara Sandana,Kanpur Moffusil,Uttar Pradesh',
'Kodra,Kanpur Moffusil,Uttar Pradesh',
'Korari Kalan,Kanpur Moffusil,Uttar Pradesh',
'Kulaha Bagha,Kanpur Moffusil,Uttar Pradesh',
'Kundenpur,Kanpur Moffusil,Uttar Pradesh',
'Kursath,Kanpur Moffusil,Uttar Pradesh',
'Kusumbhi,Kanpur Moffusil,Uttar Pradesh',
'Laglesra,Kanpur Moffusil,Uttar Pradesh',
'Lohana,Kanpur Moffusil,Uttar Pradesh',
'Lowa Singhan Khera,Kanpur Moffusil,Uttar Pradesh',
'Magarwara,Kanpur Moffusil,Uttar Pradesh',
'Magraiyar,Kanpur Moffusil,Uttar Pradesh',
'Mahesh Khera,Kanpur Moffusil,Uttar Pradesh',
'Majhgawa,Kanpur Moffusil,Uttar Pradesh',
'Majhgawan Sevak,Kanpur Moffusil,Uttar Pradesh',
'Makhi,Kanpur Moffusil,Uttar Pradesh',
'Malona,Kanpur Moffusil,Uttar Pradesh',
'Manjra Bhikhna,Kanpur Moffusil,Uttar Pradesh',
'Manjra Piper Khera,Kanpur Moffusil,Uttar Pradesh',
'Mankapur,Kanpur Moffusil,Uttar Pradesh',
'Marhapur,Kanpur Moffusil,Uttar Pradesh',
'Maswasi,Kanpur Moffusil,Uttar Pradesh',
'Maula Bankipur,Kanpur Moffusil,Uttar Pradesh',
'Maurawan,Kanpur Moffusil,Uttar Pradesh',
'Mawai,Kanpur Moffusil,Uttar Pradesh',
'Mawai Dhamiyan,Kanpur Moffusil,Uttar Pradesh',
'Mehramau,Kanpur Moffusil,Uttar Pradesh',
'Mirrikalan,Kanpur Moffusil,Uttar Pradesh',
'Mirzapur Ajgaon,Kanpur Moffusil,Uttar Pradesh',
'Mirzapur,Kanpur Moffusil,Uttar Pradesh',
'Miyanganj,Kanpur Moffusil,Uttar Pradesh',
'Mohan,Kanpur Moffusil,Uttar Pradesh',
'Mouddinpur,Kanpur Moffusil,Uttar Pradesh',
'Muktemau,Kanpur Moffusil,Uttar Pradesh',
'Mustafabad,Kanpur Moffusil,Uttar Pradesh',
'Narain Das Khera,Kanpur Moffusil,Uttar Pradesh',
'Nawabganj,Kanpur Moffusil,Uttar Pradesh',
'Nawai,Kanpur Moffusil,Uttar Pradesh',
'Nevalganj,Kanpur Moffusil,Uttar Pradesh',
'Nibai,Kanpur Moffusil,Uttar Pradesh',
'Osaina,Kanpur Moffusil,Uttar Pradesh',
'Osiya,Kanpur Moffusil,Uttar Pradesh',
'Pakrakhurd,Kanpur Moffusil,Uttar Pradesh',
'Pali,Kanpur Moffusil,Uttar Pradesh',
'Panai Kalan,Kanpur Moffusil,Uttar Pradesh',
'Panhan,Kanpur Moffusil,Uttar Pradesh',
'Pansariya (E.U.P.9189),Kanpur Moffusil,Uttar Pradesh',
'Para,Kanpur Moffusil,Uttar Pradesh',
'Parenda,Kanpur Moffusil,Uttar Pradesh',
'Parsanda,Kanpur Moffusil,Uttar Pradesh',
'Pasakhera,Kanpur Moffusil,Uttar Pradesh',
'Patan,Kanpur Moffusil,Uttar Pradesh',
'Patari,Kanpur Moffusil,Uttar Pradesh',
'Patiyara,Kanpur Moffusil,Uttar Pradesh',
'Pidna,Kanpur Moffusil,Uttar Pradesh',
'Pokhri,Kanpur Moffusil,Uttar Pradesh',
'Poora N Pansari,Kanpur Moffusil,Uttar Pradesh',
'Purthiyawa,Kanpur Moffusil,Uttar Pradesh',
'Purwa,Kanpur Moffusil,Uttar Pradesh',
'Qila,Kanpur Moffusil,Uttar Pradesh',
'Raghurampur,Kanpur Moffusil,Uttar Pradesh',
'Rainapur,Kanpur Moffusil,Uttar Pradesh',
'Raipur Garhi (M),Kanpur Moffusil,Uttar Pradesh',
'Raithana,Kanpur Moffusil,Uttar Pradesh',
'Rajepur,Kanpur Moffusil,Uttar Pradesh',
'Rampur,Kanpur Moffusil,Uttar Pradesh',
'Ranipur,Kanpur Moffusil,Uttar Pradesh',
'Rasulabad,Kanpur Moffusil,Uttar Pradesh',
'Rasupur Bankiya,Kanpur Moffusil,Uttar Pradesh',
'Raukarna,Kanpur Moffusil,Uttar Pradesh',
'Rawal Kalan,Kanpur Moffusil,Uttar Pradesh',
'Rithnai,Kanpur Moffusil,Uttar Pradesh',
'Rujhai,Kanpur Moffusil,Uttar Pradesh',
'Rupau,Kanpur Moffusil,Uttar Pradesh',
'Ruri Sadikpur,Kanpur Moffusil,Uttar Pradesh',
'S.N.C.,Kanpur Moffusil,Uttar Pradesh',
'Safipur,Kanpur Moffusil,Uttar Pradesh',
'Sagoli,Kanpur Moffusil,Uttar Pradesh',
'Sagwar,Kanpur Moffusil,Uttar Pradesh',
'Sahjani,Kanpur Moffusil,Uttar Pradesh',
'Sahrawa,Kanpur Moffusil,Uttar Pradesh',
'Sainta,Kanpur Moffusil,Uttar Pradesh',
'Saipur Sagaura,Kanpur Moffusil,Uttar Pradesh',
'Samadha,Kanpur Moffusil,Uttar Pradesh',
'Samadpur Hardas,Kanpur Moffusil,Uttar Pradesh',
'Sandana,Kanpur Moffusil,Uttar Pradesh',
'Saray Malkaadim,Kanpur Moffusil,Uttar Pradesh',
'Sarosi,Kanpur Moffusil,Uttar Pradesh',
'Sarwan,Kanpur Moffusil,Uttar Pradesh',
'Sawaen,Kanpur Moffusil,Uttar Pradesh',
'Shadipur,Kanpur Moffusil,Uttar Pradesh',
'Shahpur Tonda,Kanpur Moffusil,Uttar Pradesh',
'Shankerpur Sarai,Kanpur Moffusil,Uttar Pradesh',
'Shekh Pur Nari,Kanpur Moffusil,Uttar Pradesh',
'Shukla Khera,Kanpur Moffusil,Uttar Pradesh',
'Sijni,Kanpur Moffusil,Uttar Pradesh',
'Sikandarpur Karan,Kanpur Moffusil,Uttar Pradesh',
'Sikandarpur Sihura,Kanpur Moffusil,Uttar Pradesh',
'Singrosi,Kanpur Moffusil,Uttar Pradesh',
'Sohramau,Kanpur Moffusil,Uttar Pradesh',
'Sonic,Kanpur Moffusil,Uttar Pradesh',
'Sorauli Khanpur,Kanpur Moffusil,Uttar Pradesh',
'Sumerpur,Kanpur Moffusil,Uttar Pradesh',
'Sursaini,Kanpur Moffusil,Uttar Pradesh',
'Terha,Kanpur Moffusil,Uttar Pradesh',
'Thana,Kanpur Moffusil,Uttar Pradesh',
'Tikra,Kanpur Moffusil,Uttar Pradesh',
'Tisra,Kanpur Moffusil,Uttar Pradesh',
'Tiyar,Kanpur Moffusil,Uttar Pradesh',
'Udshah,Kanpur Moffusil,Uttar Pradesh',
'Ugoo,Kanpur Moffusil,Uttar Pradesh',
'Unchgaon Sani,Kanpur Moffusil,Uttar Pradesh',
'Unnao H.O,Kanpur Moffusil,Uttar Pradesh',
'Utmaanpur,Kanpur Moffusil,Uttar Pradesh',
'Vazidpur,Kanpur Moffusil,Uttar Pradesh',
'Vyoli Islamabad,Kanpur Moffusil,Uttar Pradesh',
'Yakoor,Kanpur Moffusil,Uttar Pradesh',
'Zamipur,Kanpur Moffusil,Uttar Pradesh',
'Asawar,Kanpur Moffusil,Uttar Pradesh',
'Chiurapur,Varanasi West,Uttar Pradesh',
'Amauli,Varanasi East,Uttar Pradesh',
'Bhopapur,Varanasi West,Uttar Pradesh',
'Kaithauli,Varanasi West,Uttar Pradesh',
'39 Gtd,Varanasi West,Uttar Pradesh',
'Ajgara,Varanasi East,Uttar Pradesh',
'Akorha,Varanasi West,Uttar Pradesh',
'Amarpatti,Varanasi East,Uttar Pradesh',
'Ambba,Varanasi East,Uttar Pradesh',
'Anai,Varanasi West,Uttar Pradesh',
'Ardely Bazar,Varanasi West,Uttar Pradesh',
'Ashapur,Varanasi East,Uttar Pradesh',
'Assi,Varanasi East,Uttar Pradesh',
'Aurangabad,Varanasi West,Uttar Pradesh',
'Ayar,Varanasi West,Uttar Pradesh',
'Babatpur Ad,Varanasi West,Uttar Pradesh',
'Babiaon,Varanasi East,Uttar Pradesh',
'Bachhaon,Varanasi East,Uttar Pradesh',
'Banakat,Varanasi West,Uttar Pradesh',
'Banakat Newada,Varanasi West,Uttar Pradesh',
'Baragaon,Varanasi West,Uttar Pradesh',
'Barahi Newada,Varanasi West,Uttar Pradesh',
'Barain,Varanasi East,Uttar Pradesh',
'Bariyasanpur,Varanasi East,Uttar Pradesh',
'Barki,Varanasi West,Uttar Pradesh',
'Barthara Khurd,Varanasi East,Uttar Pradesh',
'Bartharakalan Edso,Varanasi East,Uttar Pradesh',
'Basani,Varanasi West,Uttar Pradesh',
'Basant Nagar,Varanasi East,Uttar Pradesh',
'Basantpur,Varanasi West,Uttar Pradesh',
'Bathauli,Varanasi East,Uttar Pradesh',
'Bazardiha,Varanasi West,Uttar Pradesh',
'Bela,Varanasi East,Uttar Pradesh',
'Belpco,Varanasi West,Uttar Pradesh',
'Belwan,Varanasi West,Uttar Pradesh',
'Bengalitola,Varanasi East,Uttar Pradesh',
'Benipur Kundariya,Varanasi West,Uttar Pradesh',
'Bhagwanpur,Varanasi East,Uttar Pradesh',
'Bhelupura,Varanasi West,Uttar Pradesh',
'Bhikhampur,Varanasi West,Uttar Pradesh',
'Bhitkuri,Varanasi West,Uttar Pradesh',
'Bhonda,Varanasi West,Uttar Pradesh',
'Bhulanpur Pac,Varanasi West,Uttar Pradesh',
'Birapatti,Varanasi West,Uttar Pradesh',
'Birbhanpur,Varanasi West,Uttar Pradesh',
'Chamaon,Varanasi West,Uttar Pradesh',
'Chandrawati,Varanasi East,Uttar Pradesh',
'Chaubepurkhurd,Varanasi East,Uttar Pradesh',
'Chaubeypur,Varanasi East,Uttar Pradesh',
'Chaukhamba,Varanasi East,Uttar Pradesh',
'Chetganj,Varanasi East,Uttar Pradesh',
'Chhitauni,Varanasi East,Uttar Pradesh',
'Chirai Gaon,Varanasi East,Uttar Pradesh',
'Cholapur,Varanasi East,Uttar Pradesh',
'Christ Nagar,Varanasi West,Uttar Pradesh',
'Clark Hotel,Varanasi West,Uttar Pradesh',
'D.L.W.,Varanasi West,Uttar Pradesh',
'Dabethuwa,Varanasi West,Uttar Pradesh',
'Dafi,Varanasi East,Uttar Pradesh',
'Daipur,Varanasi West,Uttar Pradesh',
'Danganj Bazar,Varanasi East,Uttar Pradesh',
'Danupur,Varanasi West,Uttar Pradesh',
'Daranagar,Varanasi East,Uttar Pradesh',
'Dasaswmedh,Varanasi East,Uttar Pradesh',
'Deochandpur,Varanasi West,Uttar Pradesh',
'Dhandhorpur,Varanasi West,Uttar Pradesh',
'Dhaurahra,Varanasi East,Uttar Pradesh',
'Domaila,Varanasi West,Uttar Pradesh',
'Drmo,Varanasi West,Uttar Pradesh',
'Durgakund,Varanasi East,Uttar Pradesh',
'Dwarikapur,Varanasi West,Uttar Pradesh',
'Gaighat,Varanasi East,Uttar Pradesh',
'Gangapur,Varanasi West,Uttar Pradesh',
'Garhwasi Tola,Varanasi East,Uttar Pradesh',
'Garkhara,Varanasi West,Uttar Pradesh',
'Garthama,Varanasi West,Uttar Pradesh',
'Gdk,Varanasi West,Uttar Pradesh',
'Ghamahapur,Varanasi West,Uttar Pradesh',
'Gobraha,Varanasi East,Uttar Pradesh',
'Gorai,Varanasi West,Uttar Pradesh',
'Gosaipurmohawn,Varanasi East,Uttar Pradesh',
'H.P.S.,Varanasi West,Uttar Pradesh',
'Hanuman Phathak,Varanasi East,Uttar Pradesh',
'Hanumanghat,Varanasi East,Uttar Pradesh',
'Harhua,Varanasi West,Uttar Pradesh',
'Hariadih,Varanasi East,Uttar Pradesh',
'Hariharpur,Varanasi West,Uttar Pradesh',
'Harshosh,Varanasi West,Uttar Pradesh',
'Hasanpur Biraon,Varanasi West,Uttar Pradesh',
'Hathi Bazar,Varanasi West,Uttar Pradesh',
'Hathiyarkalan,Varanasi East,Uttar Pradesh',
'Hindu Vishwa Vidhyalaya,Varanasi East,Uttar Pradesh',
'Hiramanpur,Varanasi West,Uttar Pradesh',
'Hyderabad Colony,Varanasi East,Uttar Pradesh',
'Industrial Estate,Varanasi West,Uttar Pradesh',
'Iswargangi,Varanasi East,Uttar Pradesh',
'Jagatpur,Varanasi West,Uttar Pradesh',
'Jagdishpur,Varanasi East,Uttar Pradesh',
'Jagdishpur,Varanasi West,Uttar Pradesh',
'Jaitpura,Varanasi East,Uttar Pradesh',
'Jakhini,Varanasi West,Uttar Pradesh',
'Jalhupur,Varanasi East,Uttar Pradesh',
'Jansa Bazar,Varanasi West,Uttar Pradesh',
'Jawahar Nagar,Varanasi West,Uttar Pradesh',
'Jhanjhaur,Varanasi West,Uttar Pradesh',
'Kabirchaura,Varanasi East,Uttar Pradesh',
'Kaithaur,Varanasi East,Uttar Pradesh',
'Kaithi,Varanasi East,Uttar Pradesh',
'Kajisarai,Varanasi West,Uttar Pradesh',
'Kalikabara,Varanasi West,Uttar Pradesh',
'Kamachha,Varanasi West,Uttar Pradesh',
'Kamauli,Varanasi East,Uttar Pradesh',
'Kanakpur,Varanasi West,Uttar Pradesh',
'Kandawa,Varanasi West,Uttar Pradesh',
'Kaniyar,Varanasi West,Uttar Pradesh',
'Kapsethi,Varanasi West,Uttar Pradesh',
'Kardhana,Varanasi West,Uttar Pradesh',
'Karkhiaon,Varanasi West,Uttar Pradesh',
'Kashi Vidhya Pith,Varanasi West,Uttar Pradesh',
'Kashi Viswnath Mandir,Varanasi East,Uttar Pradesh',
'Kashipur,Varanasi West,Uttar Pradesh',
'Kasi Rs,Varanasi East,Uttar Pradesh',
'Kateshar,Varanasi East,Uttar Pradesh',
'Kathiraon,Varanasi West,Uttar Pradesh',
'Katuna,Varanasi West,Uttar Pradesh',
'Kedarghat,Varanasi East,Uttar Pradesh',
'Khajuri,Varanasi West,Uttar Pradesh',
'Khalispur,Varanasi West,Uttar Pradesh',
'Khataura,Varanasi West,Uttar Pradesh',
'Khetalpur,Varanasi East,Uttar Pradesh',
'Khewali,Varanasi West,Uttar Pradesh',
'Khochawan,Varanasi West,Uttar Pradesh',
'Khojwa Bazar,Varanasi West,Uttar Pradesh',
'Kohashi,Varanasi East,Uttar Pradesh',
'Konia,Varanasi East,Uttar Pradesh',
'Koruta Bazar,Varanasi West,Uttar Pradesh',
'Kotwa Koraut,Varanasi West,Uttar Pradesh',
'Kuar,Varanasi West,Uttar Pradesh',
'Kundi,Varanasi West,Uttar Pradesh',
'Kurahuwan,Varanasi East,Uttar Pradesh',
'Kuru,Varanasi West,Uttar Pradesh',
'Kusthashram,Varanasi East,Uttar Pradesh',
'Lahartara,Varanasi West,Uttar Pradesh',
'Lakhanpur,Varanasi East,Uttar Pradesh',
'Lamahi,Varanasi East,Uttar Pradesh',
'Lanka,Varanasi East,Uttar Pradesh',
'Laskarpur,Varanasi East,Uttar Pradesh',
'Lohta,Varanasi West,Uttar Pradesh',
'Luthakalan,Varanasi East,Uttar Pradesh',
'Luxa,Varanasi West,Uttar Pradesh',
'Madanpura,Varanasi East,Uttar Pradesh',
'Madhumakhiya,Varanasi West,Uttar Pradesh',
'Mahamandal,Varanasi East,Uttar Pradesh',
'Mahgaon,Varanasi West,Uttar Pradesh',
'Mahmoorganj,Varanasi West,Uttar Pradesh',
'Malviya Nagar,Varanasi East,Uttar Pradesh',
'Manduadih,Varanasi West,Uttar Pradesh',
'Mangari,Varanasi West,Uttar Pradesh',
'Mankaiya,Varanasi West,Uttar Pradesh',
'Marui,Varanasi West,Uttar Pradesh',
'Marui,Varanasi West,Uttar Pradesh',
'Mata Kund,Varanasi West,Uttar Pradesh',
'Mehandiganj,Varanasi West,Uttar Pradesh',
'Mirzamurad,Varanasi West,Uttar Pradesh',
'Moonari,Varanasi East,Uttar Pradesh',
'Murdaha Bazar,Varanasi West,Uttar Pradesh',
'Mustafabad,Varanasi East,Uttar Pradesh',
'Nagar Maha Palika,Varanasi West,Uttar Pradesh',
'Nahiyan,Varanasi West,Uttar Pradesh',
'Naipurakhurd,Varanasi East,Uttar Pradesh',
'Narainpur,Varanasi East,Uttar Pradesh',
'Naya Chowk,Varanasi East,Uttar Pradesh',
'Nayepur Chaumuhani,Varanasi West,Uttar Pradesh',
'Niyar,Varanasi East,Uttar Pradesh',
'Odar,Varanasi West,Uttar Pradesh',
'Pachraon,Varanasi East,Uttar Pradesh',
'Pahariya Mandi,Varanasi East,Uttar Pradesh',
'Palahipatti,Varanasi West,Uttar Pradesh',
'Paniyara,Varanasi West,Uttar Pradesh',
'Parsara,Varanasi West,Uttar Pradesh',
'Phulawaria,Varanasi West,Uttar Pradesh',
'Phulpur,Varanasi West,Uttar Pradesh',
'Pindarai,Varanasi West,Uttar Pradesh',
'Pindra,Varanasi West,Uttar Pradesh',
'Pisaur,Varanasi West,Uttar Pradesh',
'Pisnaharia,Varanasi West,Uttar Pradesh',
'Piyari,Varanasi East,Uttar Pradesh',
'Puarikalan,Varanasi West,Uttar Pradesh',
'Pure Raghunathpur,Varanasi West,Uttar Pradesh',
'Raghupur,Varanasi West,Uttar Pradesh',
'Raisipur,Varanasi West,Uttar Pradesh',
'Rajapur,Varanasi East,Uttar Pradesh',
'Rajatalab,Varanasi West,Uttar Pradesh',
'Rajpur,Varanasi West,Uttar Pradesh',
'Rajwari,Varanasi East,Uttar Pradesh',
'Ram Nagar Pac,Varanasi East,Uttar Pradesh',
'Ramaipatti,Varanasi West,Uttar Pradesh',
'Ramapur Hathiwar,Varanasi West,Uttar Pradesh',
'Ramapura,Varanasi East,Uttar Pradesh',
'Ramchandipur,Varanasi East,Uttar Pradesh',
'Ramdih,Varanasi West,Uttar Pradesh',
'Rameswar,Varanasi West,Uttar Pradesh',
'Ramna,Varanasi East,Uttar Pradesh',
'Ramnagar,Varanasi East,Uttar Pradesh',
'Rani Bhawani Katra,Varanasi East,Uttar Pradesh',
'Rasoolgarh,Varanasi East,Uttar Pradesh',
'Rasoolpur,Varanasi West,Uttar Pradesh',
'Rohana,Varanasi West,Uttar Pradesh',
'Rupchandpur,Varanasi West,Uttar Pradesh',
'S.V.V.,Varanasi West,Uttar Pradesh',
'Sajoi,Varanasi West,Uttar Pradesh',
'Sakalpur,Varanasi West,Uttar Pradesh',
'Saraimohana,Varanasi East,Uttar Pradesh',
'Saraiya No.-1,Varanasi East,Uttar Pradesh',
'Sarauni,Varanasi West,Uttar Pradesh',
'Sarnath,Varanasi East,Uttar Pradesh',
'Sarsawan,Varanasi West,Uttar Pradesh',
'Sarva Seva Sangh,Varanasi East,Uttar Pradesh',
'Sathwa,Varanasi East,Uttar Pradesh',
'Seergoverdhan,Varanasi East,Uttar Pradesh',
'Sehamalpur,Varanasi West,Uttar Pradesh',
'Sewapuri,Varanasi West,Uttar Pradesh',
'Shahanshahpur,Varanasi West,Uttar Pradesh',
'Shivala,Varanasi East,Uttar Pradesh',
'Shivdasa,Varanasi East,Uttar Pradesh',
'Shivrampur,Varanasi West,Uttar Pradesh',
'Sigra,Varanasi West,Uttar Pradesh',
'Sikhari Barki,Varanasi West,Uttar Pradesh',
'Sindhora,Varanasi West,Uttar Pradesh',
'Singhpur,Varanasi East,Uttar Pradesh',
'Sisawan,Varanasi West,Uttar Pradesh',
'Srikanthpur,Varanasi East,Uttar Pradesh',
'Sultanipur,Varanasi East,Uttar Pradesh',
'Sultanpur,Varanasi East,Uttar Pradesh',
'Sunderpur,Varanasi East,Uttar Pradesh',
'Surahi,Varanasi West,Uttar Pradesh',
'Susuwahi,Varanasi East,Uttar Pradesh',
'Tapowanashram,Varanasi East,Uttar Pradesh',
'Tari,Varanasi West,Uttar Pradesh',
'Tekuri,Varanasi East,Uttar Pradesh',
'Telibagh,Varanasi West,Uttar Pradesh',
'Tewar,Varanasi East,Uttar Pradesh',
'Thaney Rampur,Varanasi West,Uttar Pradesh',
'Thathara,Varanasi West,Uttar Pradesh',
'Tikari,Varanasi East,Uttar Pradesh',
'Tiwaripur,Varanasi East,Uttar Pradesh',
'U.P. Collage,Varanasi West,Uttar Pradesh',
'Udaipur,Varanasi East,Uttar Pradesh',
'Ukathi,Varanasi East,Uttar Pradesh',
'Umrahan,Varanasi East,Uttar Pradesh',
'Varanasi Cantt H.O,Varanasi West,Uttar Pradesh',
'Varanasi City,Varanasi East,Uttar Pradesh',
'Varanasi H.O,Varanasi East,Uttar Pradesh',
'Vijay Sirohi Nagar,Varanasi East,Uttar Pradesh',
'Vsi Kutchhery,Varanasi West,Uttar Pradesh',
'Vsi Shivpur,Varanasi West,Uttar Pradesh',
'West Colony,Varanasi West,Uttar Pradesh',
'Karuppilakattalai,Tiruchirapalli,Tamil Nadu',
'Adhanakurichi,Tiruchirapalli,Tamil Nadu',
'Adhikudikadu,Tiruchirapalli,Tamil Nadu',
'Alathiyur,Tiruchirapalli,Tamil Nadu',
'Ambapur,Tiruchirapalli,Tamil Nadu',
'Ameenabad,Tiruchirapalli,Tamil Nadu',
'Anandavadi,Tiruchirapalli,Tamil Nadu',
'Anganur,Tiruchirapalli,Tamil Nadu',
'Annanagar,Tiruchirapalli,Tamil Nadu',
'Ariyalur Bazaar,Tiruchirapalli,Tamil Nadu',
'Ariyalur Cement Factory,Tiruchirapalli,Tamil Nadu',
'Ariyalur,Tiruchirapalli,Tamil Nadu',
'Arungal,Tiruchirapalli,Tamil Nadu',
'Asaveerankudikadu,Tiruchirapalli,Tamil Nadu',
'Ayanathur,Tiruchirapalli,Tamil Nadu',
'Ayanthattanur,Tiruchirapalli,Tamil Nadu',
'Cement Nagar Dalavoy,Tiruchirapalli,Tamil Nadu',
'Dalavoy,Tiruchirapalli,Tamil Nadu',
'Edayakurichi,Tiruchirapalli,Tamil Nadu',
'Edayathangudi,Tiruchirapalli,Tamil Nadu',
'Elangaicheri,Tiruchirapalli,Tamil Nadu',
'Govindapuram,Tiruchirapalli,Tamil Nadu',
'Govindaputhur,Tiruchirapalli,Tamil Nadu',
'Hasthinapuram,Tiruchirapalli,Tamil Nadu',
'Idanganni,Tiruchirapalli,Tamil Nadu',
'Iluppaiyur,Tiruchirapalli,Tamil Nadu',
'Inam Athur,Tiruchirapalli,Tamil Nadu',
'Irugaiyur,Tiruchirapalli,Tamil Nadu',
'Kadambur,Tiruchirapalli,Tamil Nadu',
'Kadugur,Tiruchirapalli,Tamil Nadu',
'Kaduvettankurichi,Tiruchirapalli,Tamil Nadu',
'Kallankurichi,Tiruchirapalli,Tamil Nadu',
'Karaikurichi,Tiruchirapalli,Tamil Nadu',
'Kargudi,Tiruchirapalli,Tamil Nadu',
'Karuppur Senapathy,Tiruchirapalli,Tamil Nadu',
'Kasankottai,Tiruchirapalli,Tamil Nadu',
'Kavanur,Tiruchirapalli,Tamil Nadu',
'Keelamichaelpatti,Tiruchirapalli,Tamil Nadu',
'Kilaiyur,Tiruchirapalli,Tamil Nadu',
'Kilamaligai,Tiruchirapalli,Tamil Nadu',
'Kilapaluvur,Tiruchirapalli,Tamil Nadu',
'Kodukkur,Tiruchirapalli,Tamil Nadu',
'Kottiyal,Tiruchirapalli,Tamil Nadu',
'Kulumur,Tiruchirapalli,Tamil Nadu',
'Kunamangalam,Tiruchirapalli,Tamil Nadu',
'Kuvagam,Tiruchirapalli,Tamil Nadu',
'Lingathadimedu,Tiruchirapalli,Tamil Nadu',
'Malathankulam,Tiruchirapalli,Tamil Nadu',
'Manakudayan,Tiruchirapalli,Tamil Nadu',
'Manakudi,Tiruchirapalli,Tamil Nadu',
'Manapathur,Tiruchirapalli,Tamil Nadu',
'Marudur,Tiruchirapalli,Tamil Nadu',
'Maruvathur,Tiruchirapalli,Tamil Nadu',
'Mathur,Tiruchirapalli,Tamil Nadu',
'Muthuvancheri,Tiruchirapalli,Tamil Nadu',
'Naduvalur,Tiruchirapalli,Tamil Nadu',
'Nagamangalam,Tiruchirapalli,Tamil Nadu',
'Nakkambadi,Tiruchirapalli,Tamil Nadu',
'Nallampalayam,Tiruchirapalli,Tamil Nadu',
'Neivanam,Tiruchirapalli,Tamil Nadu',
'O Koothur,Tiruchirapalli,Tamil Nadu',
'Ottakoil,Tiruchirapalli,Tamil Nadu',
'P.Kudikadu,Tiruchirapalli,Tamil Nadu',
'Palanganatham,Tiruchirapalli,Tamil Nadu',
'Periathirukonam,Tiruchirapalli,Tamil Nadu',
'Periyakurichi,Tiruchirapalli,Tamil Nadu',
'Periyanagalur,Tiruchirapalli,Tamil Nadu',
'Ponparappi,Tiruchirapalli,Tamil Nadu',
'Pottaveli,Tiruchirapalli,Tamil Nadu',
'Poyyadhanallur,Tiruchirapalli,Tamil Nadu',
'Pungangudi,Tiruchirapalli,Tamil Nadu',
'Rajajinagar,Tiruchirapalli,Tamil Nadu',
'Rayambaram,Tiruchirapalli,Tamil Nadu',
'Reddipalayam,Tiruchirapalli,Tamil Nadu',
'Sannasinallur,Tiruchirapalli,Tamil Nadu',
'Sannavur,Tiruchirapalli,Tamil Nadu',
'Sathambadi,Tiruchirapalli,Tamil Nadu',
'Sedankudikadu,Tiruchirapalli,Tamil Nadu',
'Sendurai,Tiruchirapalli,Tamil Nadu',
'Sennivanam,Tiruchirapalli,Tamil Nadu',
'Siluppanur,Tiruchirapalli,Tamil Nadu',
'Sirukalathur,Tiruchirapalli,Tamil Nadu',
'Siruvalur,Tiruchirapalli,Tamil Nadu',
'Solankudikadu,Tiruchirapalli,Tamil Nadu',
'Srinivasapuram,Tiruchirapalli,Tamil Nadu',
'Sripurandan,Tiruchirapalli,Tamil Nadu',
'Subbarayapuram,Tiruchirapalli,Tamil Nadu',
'Sundakudi,Tiruchirapalli,Tamil Nadu',
'Suthamalli,Tiruchirapalli,Tamil Nadu',
'Tamaraikulam,Tiruchirapalli,Tamil Nadu',
'Telur,Tiruchirapalli,Tamil Nadu',
'Thavuthaikulam,Tiruchirapalli,Tamil Nadu',
'Thengachiperumalnatham,Tiruchirapalli,Tamil Nadu',
'Therkupatti,Tiruchirapalli,Tamil Nadu',
'Thular,Tiruchirapalli,Tamil Nadu',
'Thuthur,Tiruchirapalli,Tamil Nadu',
'Ulliakudi,Tiruchirapalli,Tamil Nadu',
'Unjini,Tiruchirapalli,Tamil Nadu',
'Valajanagaram,Tiruchirapalli,Tamil Nadu',
'Vanjinapuram,Tiruchirapalli,Tamil Nadu',
'Varanavasi,Tiruchirapalli,Tamil Nadu',
'Vazhaikurichi,Tiruchirapalli,Tamil Nadu',
'Vellur,Tiruchirapalli,Tamil Nadu',
'Vettiyur,Tiruchirapalli,Tamil Nadu',
'Vilangudi,Tiruchirapalli,Tamil Nadu',
'Alagapuram,Tiruchirapalli,Tamil Nadu',
'Alathipallam,Tiruchirapalli,Tamil Nadu',
'Anaikudam,Tiruchirapalli,Tamil Nadu',
'Andimadam,Tiruchirapalli,Tamil Nadu',
'Angarayanallur,Tiruchirapalli,Tamil Nadu',
'Attukurichi,Tiruchirapalli,Tamil Nadu',
'Ayuthakulam,Tiruchirapalli,Tamil Nadu',
'Ayyappanaickenpettai,Tiruchirapalli,Tamil Nadu',
'Ayyur,Tiruchirapalli,Tamil Nadu',
'Chinnavalayam,Tiruchirapalli,Tamil Nadu',
'Devamangalam,Tiruchirapalli,Tamil Nadu',
'Devanur,Tiruchirapalli,Tamil Nadu',
'Edayar,Tiruchirapalli,Tamil Nadu',
'Gangaikondacholapuram,Tiruchirapalli,Tamil Nadu',
'Ilaiyur,Tiruchirapalli,Tamil Nadu',
'Ilayaperumanallur,Tiruchirapalli,Tamil Nadu',
'Irumbilikurichi,Tiruchirapalli,Tamil Nadu',
'Jayamkondacholapuram,Tiruchirapalli,Tamil Nadu',
'Jayamkondacholapuram West,Tiruchirapalli,Tamil Nadu',
'Kallathur Thandalai,Tiruchirapalli,Tamil Nadu',
'Kaluvanthondi,Tiruchirapalli,Tamil Nadu',
'Kandiankollai,Tiruchirapalli,Tamil Nadu',
'Karadikulam,Tiruchirapalli,Tamil Nadu',
'Kattagaram,Tiruchirapalli,Tamil Nadu',
'Kavarapalayam,Tiruchirapalli,Tamil Nadu',
'Kidaramkondan,Tiruchirapalli,Tamil Nadu',
'Kilakudiyiruppu,Tiruchirapalli,Tamil Nadu',
'Kilaneduvoi,Tiruchirapalli,Tamil Nadu',
'Kilaveli,Tiruchirapalli,Tamil Nadu',
'Kodali,Tiruchirapalli,Tamil Nadu',
'Kodalikaruppur,Tiruchirapalli,Tamil Nadu',
'Kollapuram,Tiruchirapalli,Tamil Nadu',
'Kumiliam,Tiruchirapalli,Tamil Nadu',
'Kundaveli,Tiruchirapalli,Tamil Nadu',
'Kuruvalapparkoil,Tiruchirapalli,Tamil Nadu',
'Managethi,Tiruchirapalli,Tamil Nadu',
'Meikavalputhur,Tiruchirapalli,Tamil Nadu',
'Melanikuli,Tiruchirapalli,Tamil Nadu',
'Minsuritti,Tiruchirapalli,Tamil Nadu',
'Muthuservaimadam,Tiruchirapalli,Tamil Nadu',
'Nagalkuli,Tiruchirapalli,Tamil Nadu',
'Nagampandal,Tiruchirapalli,Tamil Nadu',
'Nayanganaipiriyal,Tiruchirapalli,Tamil Nadu',
'Olaiyur,Tiruchirapalli,Tamil Nadu',
'Padanilai,Tiruchirapalli,Tamil Nadu',
'Palayakudi,Tiruchirapalli,Tamil Nadu',
'Papakudi,Tiruchirapalli,Tamil Nadu',
'Paranam,Tiruchirapalli,Tamil Nadu',
'Parukkal,Tiruchirapalli,Tamil Nadu',
'Pattanamkurichi,Tiruchirapalli,Tamil Nadu',
'Periakrishnapuram,Tiruchirapalli,Tamil Nadu',
'Periyavalayam,Tiruchirapalli,Tamil Nadu',
'Pichanur,Tiruchirapalli,Tamil Nadu',
'Pilakurichi,Tiruchirapalli,Tamil Nadu',
'Pilichikuli,Tiruchirapalli,Tamil Nadu',
'Pudukudi,Tiruchirapalli,Tamil Nadu',
'Rangiam,Tiruchirapalli,Tamil Nadu',
'Saluppai,Tiruchirapalli,Tamil Nadu',
'Sengunthapuram,Tiruchirapalli,Tamil Nadu',
'Silambur,Tiruchirapalli,Tamil Nadu',
'Solamadevi,Tiruchirapalli,Tamil Nadu',
'T.Solankurichi,Tiruchirapalli,Tamil Nadu',
'Tattanur,Tiruchirapalli,Tamil Nadu',
'Thaluthalaimedu,Tiruchirapalli,Tamil Nadu',
'Thathampettai Palur,Tiruchirapalli,Tamil Nadu',
'Thennur,Tiruchirapalli,Tamil Nadu',
'Tirukalappur,Tiruchirapalli,Tamil Nadu',
'Udayanatham,Tiruchirapalli,Tamil Nadu',
'Udayarpalayam West,Tiruchirapalli,Tamil Nadu',
'Ulkottai,Tiruchirapalli,Tamil Nadu',
'Vanarathirayankuppam,Tiruchirapalli,Tamil Nadu',
'Vanathirayanpattinam,Tiruchirapalli,Tamil Nadu',
'Vanavanallur,Tiruchirapalli,Tamil Nadu',
'Vangudi,Tiruchirapalli,Tamil Nadu',
'Varadarajanpettai,Tiruchirapalli,Tamil Nadu',
'Variankaval,Tiruchirapalli,Tamil Nadu',
'Venmankondan,Tiruchirapalli,Tamil Nadu',
'Zamin Suthamalli,Tiruchirapalli,Tamil Nadu',
'Anikduichan,Tiruchirapalli,Tamil Nadu',
'Eravangudi,Tiruchirapalli,Tamil Nadu',
'Udayarpalayam,Tiruchirapalli,Tamil Nadu',
'Kalleri,Tiruchirapalli,Tamil Nadu',
'Kattathur,Tiruchirapalli,Tamil Nadu',
'Koovathur,Tiruchirapalli,Tamil Nadu',
'Kulathur,Tiruchirapalli,Tamil Nadu',
'Kumiliankuli,Tiruchirapalli,Tamil Nadu',
'Vadugarpalayam,Tiruchirapalli,Tamil Nadu',
'Vettiarvettu,Tiruchirapalli,Tamil Nadu',
'Vizhapallam,Tiruchirapalli,Tamil Nadu',
'Z.Melur,Tiruchirapalli,Tamil Nadu',
'Sriraman,Cuddalore,Tamil Nadu',
'Alagiamanavalam,Tiruchirapalli,Tamil Nadu',
'Aranmanaikurichi,Tiruchirapalli,Tamil Nadu',
'Edayathimangalam,Tiruchirapalli,Tamil Nadu',
'Elakurichi,Tiruchirapalli,Tamil Nadu',
'Ilandaikudam,Tiruchirapalli,Tamil Nadu',
'Kamarasavalli,Tiruchirapalli,Tamil Nadu',
'Kandirathitham,Tiruchirapalli,Tamil Nadu',
'Kilakavattankurichi,Tiruchirapalli,Tamil Nadu',
'Kilakolathur,Tiruchirapalli,Tamil Nadu',
'Koilesanai,Tiruchirapalli,Tamil Nadu',
'Kokkudi,Tiruchirapalli,Tamil Nadu',
'Kuhur,Tiruchirapalli,Tamil Nadu',
'Kulamanickam,Tiruchirapalli,Tamil Nadu',
'Kuruvadi,Tiruchirapalli,Tamil Nadu',
'Manjamedu Karaipakkam,Tiruchirapalli,Tamil Nadu',
'Poondi,Tiruchirapalli,Tamil Nadu',
'Pudukkottai-thirumazhapadi,Tiruchirapalli,Tamil Nadu',
'Sullangudi,Tiruchirapalli,Tamil Nadu',
'Thirumanur,Tiruchirapalli,Tamil Nadu',
'Thirumazhapadi,Tiruchirapalli,Tamil Nadu',
'Tiruppeyar,Tiruchirapalli,Tamil Nadu',
'Venganur,Tiruchirapalli,Tamil Nadu',
'Government Estate,Chennai City Central,Tamil Nadu',
'Tiruvanmiyur North,Chennai City South,Tamil Nadu',
'Tidel Park,Chennai City South,Tamil Nadu',
'Anna Nagar Western Extn,Chennai City North,Tamil Nadu',
'Chamiers Road,Chennai City Central,Tamil Nadu',
'Abiramapuram,Chennai City Central,Tamil Nadu',
'Anna Road H.O,Anna Road Ho,Tamil Nadu',
'Chennai G.P.O.,Chennai Gpo,Tamil Nadu',
'Chepauk,Chennai City Central,Tamil Nadu',
'Chintadripet,Chennai City Central,Tamil Nadu',
'Choolaimedu,Chennai City Central,Tamil Nadu',
'Eldams Road,Chennai City Central,Tamil Nadu',
'Erukkancheri,Tambaram,Tamil Nadu',
'Gaudiyamath Road,Chennai City Central,Tamil Nadu',
'Gopalapuram,Chennai City Central,Tamil Nadu',
'Greams Road,Chennai City Central,Tamil Nadu',
'Hindi Prachar Sabha,Chennai City Central,Tamil Nadu',
'Jam Bazaar,Chennai City Central,Tamil Nadu',
'Krishnampet,Chennai City Central,Tamil Nadu',
'Lloyds Estate,Chennai City Central,Tamil Nadu',
'Loyola College,Chennai City Central,Tamil Nadu',
'Madras Electricity System,Chennai City Central,Tamil Nadu',
'Madras Presidency College,Chennai City Central,Tamil Nadu',
'Madras University,Chennai City Central,Tamil Nadu',
'Mandaveli,Chennai City Central,Tamil Nadu',
'Mylapore H.O,Chennai City Central,Tamil Nadu',
'Nungambakkam Bazaar,Chennai City Central,Tamil Nadu',
'Nungambakkam High Road,Chennai City Central,Tamil Nadu',
'Nungambakkam,Chennai City Central,Tamil Nadu',
'Nungambakkam,Chennai City Central,Tamil Nadu',
'Old College Buildings,Chennai City Central,Tamil Nadu',
'Parthasarathy Koil,Chennai City Central,Tamil Nadu',
'Pr. Accountatn General,Chennai City Central,Tamil Nadu',
'Pudupakkam,Chennai City Central,Tamil Nadu',
'Royapettah High Road,Chennai City Central,Tamil Nadu',
'Royapettah,Chennai City Central,Tamil Nadu',
'Rv Nagar,Tambaram,Tamil Nadu',
'Santhome,Chennai City Central,Tamil Nadu',
'Shastri Bhavan,Chennai City Central,Tamil Nadu',
'Teynampet,Chennai City Central,Tamil Nadu',
'Teynampet South,Chennai City Central,Tamil Nadu',
'Teynampet West,Chennai City Central,Tamil Nadu',
'Thygaraya Nagar H.O,Chennai City Central,Tamil Nadu',
'Thygaraya Nagar North,Chennai City Central,Tamil Nadu',
'Thygaraya Nagar South,Chennai City Central,Tamil Nadu',
'Tiruvallikkeni,Chennai City Central,Tamil Nadu',
'Triplicane South,Chennai City Central,Tamil Nadu',
'Vivekananda College Madras,Chennai City Central,Tamil Nadu',
'Kodungaiyur,Tambaram,Tamil Nadu',
'Adyar,Chennai City South,Tamil Nadu',
'Ashoknagar,Chennai City South,Tamil Nadu',
'Besantnagar,Chennai City South,Tamil Nadu',
'Central Institute Of Technolog,Chennai City South,Tamil Nadu',
'Central Leather Research Insti,Chennai City South,Tamil Nadu',
'Chennai Race Course,Chennai City South,Tamil Nadu',
'Defence Officer\'s Colony,Chennai City South,Tamil Nadu',
'Directorate Of Tech Education,Chennai City South,Tamil Nadu',
'Ekkaduthangal,Chennai City South,Tamil Nadu',
'Engineering College,Chennai City South,Tamil Nadu',
'Foreshore Estate,Chennai City South,Tamil Nadu',
'Guindy Industrial Estate,Chennai City South,Tamil Nadu',
'Guindy North,Chennai City South,Tamil Nadu',
'Indian Institute Of Technology,Chennai City South,Tamil Nadu',
'Indira Nagar,Chennai City South,Tamil Nadu',
'Jafferkhanpet,Chennai City South,Tamil Nadu',
'Kalaignar Karunanidhi Nagar,Chennai City South,Tamil Nadu',
'Kasturibai Nagar,Chennai City South,Tamil Nadu',
'Kdm West(Mer With Kdm),Chennai City South,Tamil Nadu',
'Kodambakkam,Chennai City South,Tamil Nadu',
'Kotturpuram,Chennai City South,Tamil Nadu',
'Koyambedu Wholesale Market Com,Chennai City South,Tamil Nadu',
'Kumaran Nagar,Chennai City South,Tamil Nadu',
'Mambalam R.S.,Chennai City South,Tamil Nadu',
'Mettupalayam(Mer With West Mam,Chennai City South,Tamil Nadu',
'Nandanam,Chennai City South,Tamil Nadu',
'Raja Annamalaipuram,Chennai City South,Tamil Nadu',
'Rajbhavan,Chennai City South,Tamil Nadu',
'Ramakrishna Nagar,Chennai City South,Tamil Nadu',
'Rangarajapuram,Chennai City South,Tamil Nadu',
'Saidapet North,Chennai City South,Tamil Nadu',
'Saidapet,Chennai City South,Tamil Nadu',
'Saidapet West(Mer With Sdp),Chennai City South,Tamil Nadu',
'Saligramam,Chennai City South,Tamil Nadu',
'Shastri Nagar,Chennai City South,Tamil Nadu',
'Sri Ayyappa Nagar,Chennai City South,Tamil Nadu',
'Theosophical Society,Chennai City South,Tamil Nadu',
'Tiruvanmiyur,Chennai City South,Tamil Nadu',
'Ttti Taramani,Chennai City South,Tamil Nadu',
'Vadapalani,Chennai City South,Tamil Nadu',
'Velacheri,Chennai City South,Tamil Nadu',
'Virugambakkam,Chennai City South,Tamil Nadu',
'West Mambalam,Chennai City South,Tamil Nadu',
'Ethiraj Salai,Chennai City North,Tamil Nadu',
'Aminjikarai,Chennai City North,Tamil Nadu',
'Anna Nagar,Chennai City North,Tamil Nadu',
'Chetput,Chennai City North,Tamil Nadu',
'D G Vaishnav College,Chennai City North,Tamil Nadu',
'Egmore,Chennai City North,Tamil Nadu',
'Egmore,Chennai City North,Tamil Nadu',
'P C Hostel,Chennai City North,Tamil Nadu',
'Pudupet,Chennai City North,Tamil Nadu',
'Rayapuram,Chennai City North,Tamil Nadu',
'Royapuram Market,Chennai City North,Tamil Nadu',
'Shenoy Nagar,Chennai City North,Tamil Nadu',
'World University Centre,Chennai City North,Tamil Nadu',
'Arumbakkam,Chennai City North,Tamil Nadu',
'Koyambedu,Chennai City North,Tamil Nadu',
'Nerkundram,Chennai City North,Tamil Nadu',
'Agaram,Chennai City North,Tamil Nadu',
'Anna Nagar East,Chennai City North,Tamil Nadu',
'Aynavaram,Chennai City North,Tamil Nadu',
'Choolai,Chennai City North,Tamil Nadu',
'Decosters Road,Chennai City North,Tamil Nadu',
'Flowers Road,Chennai City North,Tamil Nadu',
'Icf Colony,Chennai City North,Tamil Nadu',
'Jawahar Nagar,Chennai City North,Tamil Nadu',
'Kilpauk Medical College,Chennai City North,Tamil Nadu',
'Kilpauk,Chennai City North,Tamil Nadu',
'Kosapet,Chennai City North,Tamil Nadu',
'New Avadi Road,Chennai City North,Tamil Nadu',
'Perambur Barracks,Chennai City North,Tamil Nadu',
'Perambur High Road,Chennai City North,Tamil Nadu',
'Perambur North,Chennai City North,Tamil Nadu',
'Perambur,Chennai City North,Tamil Nadu',
'Puliyanthope,Chennai City North,Tamil Nadu',
'Purasawalkam,Chennai City North,Tamil Nadu',
'Rajathottam,Chennai City North,Tamil Nadu',
'Sembiam,Chennai City North,Tamil Nadu',
'Strahans Road,Chennai City North,Tamil Nadu',
'Venkatesapuram,Chennai City North,Tamil Nadu',
'Vepery,Chennai City North,Tamil Nadu',
'G K M Colony,Chennai City North,Tamil Nadu',
'Broadway,Chennai City North,Tamil Nadu',
'Cemetry Road,Chennai City North,Tamil Nadu',
'Dr. Ambedkar Nagar,Chennai City North,Tamil Nadu',
'Edapalayam,Chennai City North,Tamil Nadu',
'Fort St George,Chennai City North,Tamil Nadu',
'Govt Stanley Hospital,Chennai City North,Tamil Nadu',
'High Court Building,Chennai City North,Tamil Nadu',
'Kalmandapam,Chennai City North,Tamil Nadu',
'Madras Medical College,Chennai City North,Tamil Nadu',
'Mannady,Chennai City North,Tamil Nadu',
'Mint Building,Chennai City North,Tamil Nadu',
'Muthialpet(MS),Chennai City North,Tamil Nadu',
'Park Town H.O,Chennai City North,Tamil Nadu',
'Ripon Buildings,Chennai City North,Tamil Nadu',
'Seven Wells,Chennai City North,Tamil Nadu',
'Sowcarpet,Chennai City North,Tamil Nadu',
'Sowcarpet,Chennai City North,Tamil Nadu',
'Tondiarpet Bazaar,Chennai City North,Tamil Nadu',
'Tondiarpet,Chennai City North,Tamil Nadu',
'Tondiarpet West,Chennai City North,Tamil Nadu',
'Vyasar Nagar Colony,Chennai City North,Tamil Nadu',
'Vyasarpadi,Chennai City North,Tamil Nadu',
'Washermanpet East,Chennai City North,Tamil Nadu',
'Washermanpet,Chennai City North,Tamil Nadu',
'MPT AO,Chennai City North,Tamil Nadu',
'Golluvar Agraharam Road,Chennai City North,Tamil Nadu',
'Korrukupet,Chennai City North,Tamil Nadu',
'Alagumalai,Tirupur,Tamil Nadu',
'Bhujanganur,Tirupur,Tamil Nadu',
'Kandiankoil,Tirupur,Tamil Nadu',
'Karavalur,Tirupur,Tamil Nadu',
'Koduvoi,Tirupur,Tamil Nadu',
'Medur,Tirupur,Tamil Nadu',
'Nambiampalayam,Tirupur,Tamil Nadu',
'Pallikalipalayam,Tirupur,Tamil Nadu',
'Peruntholuvu,Tirupur,Tamil Nadu',
'Ramanathapuram,Tirupur,Tamil Nadu',
'Seeliyur,Tirupur,Tamil Nadu',
'Sirukinar,Tirupur,Tamil Nadu',
'Somanur,Tirupur,Tamil Nadu',
'Thekkampatti,Tirupur,Tamil Nadu',
'Tholampalayam,Tirupur,Tamil Nadu',
'Thonguttipalayam,Tirupur,Tamil Nadu',
'Uppilipalayam,Tirupur,Tamil Nadu',
'Vettuvapalayam,Tirupur,Tamil Nadu',
'Vivekanandapuram,Tirupur,Tamil Nadu',
'Avanash,Tirupur,Tamil Nadu',
'Kalapatti,Coimbatore,Tamil Nadu',
'Kuppandampalayam,Tirupur,Tamil Nadu',
'Periyayipalayam,Tirupur,Tamil Nadu',
'Pudupalayam,Tirupur,Tamil Nadu',
'Rakkiapalayam,Tirupur,Tamil Nadu',
'Sembianallur,Tirupur,Tamil Nadu',
'Sundakkampalayam,Tirupur,Tamil Nadu',
'Thekkalur,Tirupur,Tamil Nadu',
'Thulukkamuthur,Tirupur,Tamil Nadu',
'Vadavalli,Coimbatore,Tamil Nadu',
'Vadugapalayam,Tirupur,Tamil Nadu',
'Velayuthampalayam,Tirupur,Tamil Nadu',
'15 Velampalayam,Tirupur,Tamil Nadu',
'Alathur,Tirupur,Tamil Nadu',
'Allapalayam,Tirupur,Tamil Nadu',
'Annur-mettupalayam,Tirupur,Tamil Nadu',
'Cheyur,Tirupur,Tamil Nadu',
'Ellapalayam,Tirupur,Tamil Nadu',
'Kanjapalli,Tirupur,Tamil Nadu',
'Kanur,Tirupur,Tamil Nadu',
'Karegoundenpalayam,Tirupur,Tamil Nadu',
'Karukkankattupudur,Tirupur,Tamil Nadu',
'Komarapalayam,Tirupur,Tamil Nadu',
'Kuppanur,Tirupur,Tamil Nadu',
'Mangarasavalayapalayam,Tirupur,Tamil Nadu',
'Muriandampalayam,Tirupur,Tamil Nadu',
'Nagammapudur,Tirupur,Tamil Nadu',
'Nallichettipalayam,Tirupur,Tamil Nadu',
'Odderpalayam,Tirupur,Tamil Nadu',
'Pappankulam,Tirupur,Tamil Nadu',
'Pasur-avanashi,Tirupur,Tamil Nadu',
'Periaputhur,Tirupur,Tamil Nadu',
'Pilliappampalayam,Tirupur,Tamil Nadu',
'Pogalur,Tirupur,Tamil Nadu',
'Ranganathapuram,Tirupur,Tamil Nadu',
'Sokkampalayam,Tirupur,Tamil Nadu',
'Thandukaranpalayam,Tirupur,Tamil Nadu',
'Thomaspuram,Tirupur,Tamil Nadu',
'Tirumuruganpoondi,Tirupur,Tamil Nadu',
'Vadakkalur,Tirupur,Tamil Nadu',
'Vadavalli-karamadai,Tirupur,Tamil Nadu',
'Annur,Tirupur,Tamil Nadu',
'Therampalayam,Tirupur,Tamil Nadu',
'Veerapandi-tadagam,Coimbatore,Tamil Nadu',
'Kuttagam,Erode,Tamil Nadu',
'Merkupathi,Erode,Tamil Nadu',
'Vallipuram,Erode,Tamil Nadu',
'Agraharasamakulam,Coimbatore,Tamil Nadu',
'Anaikatti,Coimbatore,Tamil Nadu',
'Athipalayam,Coimbatore,Tamil Nadu',
'Bilichi,Coimbatore,Tamil Nadu',
'Cherannagar,Coimbatore,Tamil Nadu',
'Coimbatore Press Colony,Coimbatore,Tamil Nadu',
'Edayarpalayam,Coimbatore,Tamil Nadu',
'Ganesapuram,Coimbatore,Tamil Nadu',
'Gnanambika Mills,Coimbatore,Tamil Nadu',
'Govt.College Of Technology,Coimbatore,Tamil Nadu',
'Gudalur-coimbatore,Coimbatore,Tamil Nadu',
'Idigarai,Coimbatore,Tamil Nadu',
'Jothipuram,Coimbatore,Tamil Nadu',
'Kallipalayam,Coimbatore,Tamil Nadu',
'Kattampatti-coimbatore,Coimbatore,Tamil Nadu',
'Kavundampalayam,Coimbatore,Tamil Nadu',
'Kavundampalayam Colony,Coimbatore,Tamil Nadu',
'Keeranatham,Coimbatore,Tamil Nadu',
'Kondayampalayam,Coimbatore,Tamil Nadu',
'Kottaipalayam,Coimbatore,Tamil Nadu',
'Kunnathurpudur,Coimbatore,Tamil Nadu',
'Kuppaipalayam,Coimbatore,Tamil Nadu',
'Kurumbapalayam,Coimbatore,Tamil Nadu',
'Masagoundenchettipalayam,Coimbatore,Tamil Nadu',
'N.G.G.O Colony,Coimbatore,Tamil Nadu',
'Naickenpalayam,Coimbatore,Tamil Nadu',
'Nanjundapuram-tadagam,Coimbatore,Tamil Nadu',
'Narasimhanaickenpalayam,Coimbatore,Tamil Nadu',
'Pachapalayam,Coimbatore,Tamil Nadu',
'Pannimadai,Coimbatore,Tamil Nadu',
'Pathanjalipuri,Coimbatore,Tamil Nadu',
'Periyanaickenpalayam,Coimbatore,Tamil Nadu',
'Ponnegoundenpudur,Coimbatore,Tamil Nadu',
'Rakkipalayam,Coimbatore,Tamil Nadu',
'Samichettipalayam,Coimbatore,Tamil Nadu',
'Saravanampatti,Coimbatore,Tamil Nadu',
'Sarkarsamakulam,Coimbatore,Tamil Nadu',
'Sengalipalayam,Coimbatore,Tamil Nadu',
'Somayampalayam,Coimbatore,Tamil Nadu',
'Sri Ramakrishna Vidyalaya,Coimbatore,Tamil Nadu',
'Tadagam,Coimbatore,Tamil Nadu',
'Thekkupalayam,Coimbatore,Tamil Nadu',
'Thoppampatti,Coimbatore,Tamil Nadu',
'Tudiyalur,Coimbatore,Tamil Nadu',
'Vadamadurai Kurudampalayam,Coimbatore,Tamil Nadu',
'Vadugapalayam,Coimbatore,Tamil Nadu',
'Vaiyampalayam,Coimbatore,Tamil Nadu',
'Veerapandi Periyanaickenpalaya,Coimbatore,Tamil Nadu',
'Vellakinar,Coimbatore,Tamil Nadu',
'Vellamadai,Coimbatore,Tamil Nadu',
'Vellanaipatti,Coimbatore,Tamil Nadu',
'Vilankurichi,Coimbatore,Tamil Nadu',
'Alandurai,Coimbatore,Tamil Nadu',
'Arisipalayam,Coimbatore,Tamil Nadu',
'Bharathiyar University,Coimbatore,Tamil Nadu',
'Bodipalayam,Coimbatore,Tamil Nadu',
'CBE Mpl.Central Busstand,Coimbatore,Tamil Nadu',
'Chettipalayam,Coimbatore,Tamil Nadu',
'Chinnavedampatti,Coimbatore,Tamil Nadu',
'Coimbatore Aerodrome,Coimbatore,Tamil Nadu',
'Coimbatore Anupparpalayam,Coimbatore,Tamil Nadu',
'Coimbatore Bazaar,Coimbatore,Tamil Nadu',
'Coimbatore Central,Coimbatore,Tamil Nadu',
'Coimbatore Collectorate,Coimbatore,Tamil Nadu',
'Coimbatore Courts,Coimbatore,Tamil Nadu',
'Coimbatore Fort,Coimbatore,Tamil Nadu',
'Coimbatore H.O,Coimbatore,Tamil Nadu',
'Coimbatore Industrial Estate,Coimbatore,Tamil Nadu',
'Coimbatore Racecourse,Coimbatore,Tamil Nadu',
'Coimbatore South,Coimbatore,Tamil Nadu',
'Coimbatore Ukkadam,Coimbatore,Tamil Nadu',
'Coimbatore West,Coimbatore,Tamil Nadu',
'Commercial Tax Office Building,Coimbatore,Tamil Nadu',
'Deenampalayam,Coimbatore,Tamil Nadu',
'Devarayapuram,Coimbatore,Tamil Nadu',
'Dhaliyur,Coimbatore,Tamil Nadu',
'Eachanari,Coimbatore,Tamil Nadu',
'Edayapalayam,Coimbatore,Tamil Nadu',
'Elur,Coimbatore,Tamil Nadu',
'Ettimadai,Coimbatore,Tamil Nadu',
'Ganapathy,Coimbatore,Tamil Nadu',
'Gandhimaanagar,Coimbatore,Tamil Nadu',
'Gandhipuram,Coimbatore,Tamil Nadu',
'Ikkarai Boluvampatti,Coimbatore,Tamil Nadu',
'Jakkirnaickenpalayam,Coimbatore,Tamil Nadu',
'Kalampalayam,Coimbatore,Tamil Nadu',
'Kallapalayam,Coimbatore,Tamil Nadu',
'Kandegounden Salai,Coimbatore,Tamil Nadu',
'Karunyanagar,Coimbatore,Tamil Nadu',
'Komarapalayam,Coimbatore,Tamil Nadu',
'Konavaikalpalayam,Coimbatore,Tamil Nadu',
'Kovaipudur,Coimbatore,Tamil Nadu',
'Krishnarayapuram,Coimbatore,Tamil Nadu',
'Krishnaswamy Nagar,Coimbatore,Tamil Nadu',
'Kumittipathi,Coimbatore,Tamil Nadu',
'Kuniamuthur,Coimbatore,Tamil Nadu',
'Kuppakonanpudur,Coimbatore,Tamil Nadu',
'Kuppanur,Coimbatore,Tamil Nadu',
'Lawley Road,Coimbatore,Tamil Nadu',
'Madampatti,Coimbatore,Tamil Nadu',
'Madhvarayapuram,Coimbatore,Tamil Nadu',
'Madukkarai Cusba,Coimbatore,Tamil Nadu',
'Madukkarai,Coimbatore,Tamil Nadu',
'Malumichampatti,Coimbatore,Tamil Nadu',
'Maniakarampalayam,Coimbatore,Tamil Nadu',
'Marudamalai,Coimbatore,Tamil Nadu',
'Masthigoundenpathi,Coimbatore,Tamil Nadu',
'Mathipalayam,Coimbatore,Tamil Nadu',
'Meenakshipuram,Coimbatore,Tamil Nadu',
'Mylampatti,Coimbatore,Tamil Nadu',
'Myleripalayam,Coimbatore,Tamil Nadu',
'Nandanagar,Coimbatore,Tamil Nadu',
'Nanjundapuram,Coimbatore,Tamil Nadu',
'Narasipuram,Coimbatore,Tamil Nadu',
'Nathegoundenpudur,Coimbatore,Tamil Nadu',
'Neelikonampalayam,Coimbatore,Tamil Nadu',
'Nilambur,Coimbatore,Tamil Nadu',
'Odayampalayam,Coimbatore,Tamil Nadu',
'Ondipudur,Coimbatore,Tamil Nadu',
'Othakkalmandapam,Coimbatore,Tamil Nadu',
'P&t Staff Quarters,Coimbatore,Tamil Nadu',
'Palathurai,Coimbatore,Tamil Nadu',
'Panapatti,Coimbatore,Tamil Nadu',
'Pappampatti,Coimbatore,Tamil Nadu',
'Pappanaickenpalayam,Coimbatore,Tamil Nadu',
'Pappanaickenpalayam West,Coimbatore,Tamil Nadu',
'Pappanaickenpudur,Coimbatore,Tamil Nadu',
'Pattanam,Coimbatore,Tamil Nadu',
'Peelamedu East,Coimbatore,Tamil Nadu',
'Peelamedu,Coimbatore,Tamil Nadu',
'Periyakuyilai,Coimbatore,Tamil Nadu',
'Perur Chettipalayam,Coimbatore,Tamil Nadu',
'Perur,Coimbatore,Tamil Nadu',
'Pichanur,Coimbatore,Tamil Nadu',
'Pidampalli,Coimbatore,Tamil Nadu',
'Podanur Newtown,Coimbatore,Tamil Nadu',
'Podanur,Coimbatore,Tamil Nadu',
'Puliyakulam,Coimbatore,Tamil Nadu',
'Puluvapatti,Coimbatore,Tamil Nadu',
'R.S.Puram East,Coimbatore,Tamil Nadu',
'R.S.Puram South,Coimbatore,Tamil Nadu',
'R.S.Puram West,Coimbatore,Tamil Nadu',
'Ramanathapuram,Coimbatore,Tamil Nadu',
'Ramnagar,Coimbatore,Tamil Nadu',
'Rathinapuri,Coimbatore,Tamil Nadu',
'Rathinasabapathy Puram H.O,Coimbatore,Tamil Nadu',
'Redfields,Coimbatore,Tamil Nadu',
'S.B.Institute,Coimbatore,Tamil Nadu',
'Sahs College,Coimbatore,Tamil Nadu',
'Saibaba Mission,Coimbatore,Tamil Nadu',
'Seeranaickenpalayam,Coimbatore,Tamil Nadu',
'Selvapuram,Coimbatore,Tamil Nadu',
'Semmedu,Coimbatore,Tamil Nadu',
'Siddhapudur,Coimbatore,Tamil Nadu',
'Singanallur,Coimbatore,Tamil Nadu',
'Sinnanavakkarai,Coimbatore,Tamil Nadu',
'Sinniampalayam,Coimbatore,Tamil Nadu',
'Siruvani Adivaram,Coimbatore,Tamil Nadu',
'Sowripalayam,Coimbatore,Tamil Nadu',
'Sugunapuram,Coimbatore,Tamil Nadu',
'Sukkirawarapettai,Coimbatore,Tamil Nadu',
'Sundakkamuthur,Coimbatore,Tamil Nadu',
'Sundapalayam,Coimbatore,Tamil Nadu',
'Sundarapuram,Coimbatore,Tamil Nadu',
'Tatabad,Coimbatore,Tamil Nadu',
'Telungupalayam,Coimbatore,Tamil Nadu',
'Tenkarai,Coimbatore,Tamil Nadu',
'Thennamanallur,Coimbatore,Tamil Nadu',
'Thirumalayampalayam,Coimbatore,Tamil Nadu',
'Thondamuthur,Coimbatore,Tamil Nadu',
'Titipalayam,Coimbatore,Tamil Nadu',
'Uppilipalayam,Coimbatore,Tamil Nadu',
'Valukkuparai,Coimbatore,Tamil Nadu',
'Vedapatti,Coimbatore,Tamil Nadu',
'Veerakeralam,Coimbatore,Tamil Nadu',
'Velandipalayam,Coimbatore,Tamil Nadu',
'Vellalapalayam Podanur,Coimbatore,Tamil Nadu',
'Vellalore,Coimbatore,Tamil Nadu',
'Venkitapuram,Coimbatore,Tamil Nadu',
'Viraliyur,Coimbatore,Tamil Nadu',
'Pattampalayam,Erode,Tamil Nadu',
'Sokkanur,Erode,Tamil Nadu',
'Thirumalaigoundenpalayam,Erode,Tamil Nadu',
'Karamadai,Tirupur,Tamil Nadu',
'Pillurdam,Tirupur,Tamil Nadu',
'Sirumugai,Tirupur,Tamil Nadu',
'Akkaraisengapalli,Tirupur,Tamil Nadu',
'Alancombu,Tirupur,Tamil Nadu',
'Belladi,Tirupur,Tamil Nadu',
'Bellaipalayam,Tirupur,Tamil Nadu',
'Chikkarampalayam,Tirupur,Tamil Nadu',
'Dasanur,Tirupur,Tamil Nadu',
'Doddapura,Tirupur,Tamil Nadu',
'Illuppapalayam,Tirupur,Tamil Nadu',
'Kallar,Tirupur,Tamil Nadu',
'Kariampalayam,Tirupur,Tamil Nadu',
'Mahadevapuram,Tirupur,Tamil Nadu',
'Mangalakaraipudur,Tirupur,Tamil Nadu',
'Marudur,Tirupur,Tamil Nadu',
'Mettupalayam Bazaar,Tirupur,Tamil Nadu',
'Mettupalayam East,Tirupur,Tamil Nadu',
'Mettupalayam H.O,Tirupur,Tamil Nadu',
'Nellithurai,Tirupur,Tamil Nadu',
'Palapatti,Tirupur,Tamil Nadu',
'Paralipower House,Tirupur,Tamil Nadu',
'Periakallipatti,Tirupur,Tamil Nadu',
'Pillurdam,Tirupur,Tamil Nadu',
'Sinnakallipatti,Tirupur,Tamil Nadu',
'Thimmanur,Tirupur,Tamil Nadu',
'Velliankadu,Tirupur,Tamil Nadu',
'Jadayampalayam,Tirupur,Tamil Nadu',
'63 Velampalayam,Tirupur,Tamil Nadu',
'Agraharapudur,Tirupur,Tamil Nadu',
'Annupapatti,Tirupur,Tamil Nadu',
'Appanaickenpatti,Tirupur,Tamil Nadu',
'Arasur,Tirupur,Tamil Nadu',
'Athappagoundenpudur,Tirupur,Tamil Nadu',
'Bogampatti,Tirupur,Tamil Nadu',
'Chandrapuram,Tirupur,Tamil Nadu',
'Chennappachettipudur,Tirupur,Tamil Nadu',
'Chinthamanipudur,Tirupur,Tamil Nadu',
'Chittambalam,Tirupur,Tamil Nadu',
'Devanampalayam,Tirupur,Tamil Nadu',
'Doddampatti,Tirupur,Tamil Nadu',
'Giddampalayam,Tirupur,Tamil Nadu',
'Golenpet,Tirupur,Tamil Nadu',
'Ichipatti,Tirupur,Tamil Nadu',
'Irugur,Tirupur,Tamil Nadu',
'J.Krishnapuram,Tirupur,Tamil Nadu',
'Jalakarichal,Tirupur,Tamil Nadu',
'Jallipatti,Tirupur,Tamil Nadu',
'K.Ayyampalayam,Tirupur,Tamil Nadu',
'Kadampadi,Tirupur,Tamil Nadu',
'Kaduvettipalayam,Tirupur,Tamil Nadu',
'Kalingal,Tirupur,Tamil Nadu',
'Kallivelampatti,Tirupur,Tamil Nadu',
'Kamanaickenpalayam,Tirupur,Tamil Nadu',
'Kamatchipuram,Tirupur,Tamil Nadu',
'Kammalapatti,Tirupur,Tamil Nadu',
'Kangayampalayam,Tirupur,Tamil Nadu',
'Kaniyur-palladam,Tirupur,Tamil Nadu',
'Kannampalayam,Tirupur,Tamil Nadu',
'Karadibavi,Tirupur,Tamil Nadu',
'Karavalimadapur,Tirupur,Tamil Nadu',
'Karumathampatti,Tirupur,Tamil Nadu',
'Kettanur,Tirupur,Tamil Nadu',
'Kodangipalayam,Tirupur,Tamil Nadu',
'Komarapalayam,Tirupur,Tamil Nadu',
'Ksn Puram,Tirupur,Tamil Nadu',
'Lakshminaickenpalayam,Tirupur,Tamil Nadu',
'Madapur,Tirupur,Tamil Nadu',
'Malayadipalayam,Tirupur,Tamil Nadu',
'Mandiripalayam,Tirupur,Tamil Nadu',
'Moperipalayam,Tirupur,Tamil Nadu',
'Muthugoundenpudur,Tirupur,Tamil Nadu',
'Naranapuram,Tirupur,Tamil Nadu',
'Nathagoundenpalayam,Tirupur,Tamil Nadu',
'Ngr Road,Tirupur,Tamil Nadu',
'Oddarpalayam,Tirupur,Tamil Nadu',
'P.Vadugapalayam,Tirupur,Tamil Nadu',
'Paduvampalli,Tirupur,Tamil Nadu',
'Palladam,Tirupur,Tamil Nadu',
'Pallapalayam,Tirupur,Tamil Nadu',
'Panickampatti,Tirupur,Tamil Nadu',
'Paruvoi,Tirupur,Tamil Nadu',
'Pongalur,Tirupur,Tamil Nadu',
'Poomalur,Tirupur,Tamil Nadu',
'Puliamarathupalayam,Tirupur,Tamil Nadu',
'Puliampatti,Tirupur,Tamil Nadu',
'Purandampalayam,Tirupur,Tamil Nadu',
'Rasipalayam,Tirupur,Tamil Nadu',
'Ravathur,Tirupur,Tamil Nadu',
'S.Ayyampalayam,Tirupur,Tamil Nadu',
'Samalapuram,Tirupur,Tamil Nadu',
'Semmandampalayam,Tirupur,Tamil Nadu',
'Senjeri,Tirupur,Tamil Nadu',
'Senjeriputhur,Tirupur,Tamil Nadu',
'Siddanaickenpalayam,Tirupur,Tamil Nadu',
'Subarayanpudur,Tirupur,Tamil Nadu',
'Sukkampalayam,Tirupur,Tamil Nadu',
'Sultanpet,Tirupur,Tamil Nadu',
'Sulur,Tirupur,Tamil Nadu',
'Talakarai,Tirupur,Tamil Nadu',
'V.Kallipalayam,Tirupur,Tamil Nadu',
'V.Vadamalaipalayam,Tirupur,Tamil Nadu',
'Vadambacherry,Tirupur,Tamil Nadu',
'Vadavedampatti,Tirupur,Tamil Nadu',
'Vadugankallipalayam,Tirupur,Tamil Nadu',
'Vaharayampalayam,Tirupur,Tamil Nadu',
'Vanjipalayam,Tirupur,Tamil Nadu',
'Vavipalayamkettanur,Tirupur,Tamil Nadu',
'Velappanaickenpalayam,Tirupur,Tamil Nadu',
'Vengitapuram,Tirupur,Tamil Nadu',
'Ganganaickenpalayam,Tirupur,Tamil Nadu',
'Achipatti,Pollachi,Tamil Nadu',
'Akilandapuram,Pollachi,Tamil Nadu',
'Akkamalai,Pollachi,Tamil Nadu',
'Alagirichettipalayam,Pollachi,Tamil Nadu',
'Aliyar Nagar,Pollachi,Tamil Nadu',
'Ambarampalayam,Pollachi,Tamil Nadu',
'Anaimalai,Pollachi,Tamil Nadu',
'Andipalayam,Pollachi,Tamil Nadu',
'Angalakurichi,Pollachi,Tamil Nadu',
'Arasampalayam,Pollachi,Tamil Nadu',
'Athu Pollachi,Pollachi,Tamil Nadu',
'Chinna Negamam,Pollachi,Tamil Nadu',
'Chinnakallar,Pollachi,Tamil Nadu',
'Chinnappampalayam,Pollachi,Tamil Nadu',
'Cinchona East,Pollachi,Tamil Nadu',
'Cinchona,Pollachi,Tamil Nadu',
'Dasanaicken Palayam,Pollachi,Tamil Nadu',
'Devambadi,Pollachi,Tamil Nadu',
'Devarayapuram,Pollachi,Tamil Nadu',
'Devenampalayam,Pollachi,Tamil Nadu',
'Divansapudur,Pollachi,Tamil Nadu',
'Ganapathipalayam,Pollachi,Tamil Nadu',
'Gandhi Market,Pollachi,Tamil Nadu',
'High Forest,Pollachi,Tamil Nadu',
'Iyerpadi,Pollachi,Tamil Nadu',
'Jakkarpalayam,Pollachi,Tamil Nadu',
'Kadamparai Power House,Pollachi,Tamil Nadu',
'Kakkadavoo,Pollachi,Tamil Nadu',
'Kaliapuram,Pollachi,Tamil Nadu',
'Kaliapuram,Pollachi,Tamil Nadu',
'Kambalapatti,Pollachi,Tamil Nadu',
'Kanjampatti,Pollachi,Tamil Nadu',
'Kappalankarai,Pollachi,Tamil Nadu',
'Karamalai Bazaar,Pollachi,Tamil Nadu',
'Karuppampalayam,Pollachi,Tamil Nadu',
'Kattampatti,Pollachi,Tamil Nadu',
'Kinathukadavoo,Pollachi,Tamil Nadu',
'Kondagoundenpalayam,Pollachi,Tamil Nadu',
'Kondampatti,Pollachi,Tamil Nadu',
'Korangumudi,Pollachi,Tamil Nadu',
'Kothavadi,Pollachi,Tamil Nadu',
'Kovilpalayam,Pollachi,Tamil Nadu',
'Kurumbapalayam,Pollachi,Tamil Nadu',
'Kurunallipalayam,Pollachi,Tamil Nadu',
'Mahalinga Puram,Pollachi,Tamil Nadu',
'Makkinaicken Patti,Pollachi,Tamil Nadu',
'Malayandipattinam,Pollachi,Tamil Nadu',
'Manamboli,Pollachi,Tamil Nadu',
'Mannur,Pollachi,Tamil Nadu',
'Mappillaigoundenpudur,Pollachi,Tamil Nadu',
'Mettubavi,Pollachi,Tamil Nadu',
'Mettupalayam,Pollachi,Tamil Nadu',
'Minparai,Pollachi,Tamil Nadu',
'Mohavanur,Pollachi,Tamil Nadu',
'Moongiltholuvu,Pollachi,Tamil Nadu',
'Mount Stuart,Pollachi,Tamil Nadu',
'Mudis,Pollachi,Tamil Nadu',
'Murugali Bazaar,Pollachi,Tamil Nadu',
'Muthur,Pollachi,Tamil Nadu',
'N.G.M College,Pollachi,Tamil Nadu',
'Nallamudi,Pollachi,Tamil Nadu',
'Nallatipalayam,Pollachi,Tamil Nadu',
'Nalluthukuli,Pollachi,Tamil Nadu',
'Navamalai Camp,Pollachi,Tamil Nadu',
'Negamam,Pollachi,Tamil Nadu',
'Nirar Dam,Pollachi,Tamil Nadu',
'Odayakulam,Pollachi,Tamil Nadu',
'Old Valparai,Pollachi,Tamil Nadu',
'Palanigoundenpudur,Pollachi,Tamil Nadu',
'Palarpathy,Pollachi,Tamil Nadu',
'Pannimade,Pollachi,Tamil Nadu',
'Paralai,Pollachi,Tamil Nadu',
'Periapodu,Pollachi,Tamil Nadu',
'Periya Kallar,Pollachi,Tamil Nadu',
'Pethanaickanur,Pollachi,Tamil Nadu',
'Pollachi Bazaar,Pollachi,Tamil Nadu',
'Pollachi H.O,Pollachi,Tamil Nadu',
'Pollachi R.S,Pollachi,Tamil Nadu',
'Poravipalayam,Pollachi,Tamil Nadu',
'Puliampatti,Pollachi,Tamil Nadu',
'R.Ponnapuram,Pollachi,Tamil Nadu',
'Ramachandrapuram,Pollachi,Tamil Nadu',
'Ramanamudali Pudur,Pollachi,Tamil Nadu',
'Ramapattinam,Pollachi,Tamil Nadu',
'Reddiarur,Pollachi,Tamil Nadu',
'Samathur,Pollachi,Tamil Nadu',
'Sarkarpathi,Pollachi,Tamil Nadu',
'Senguttaipalayam,Pollachi,Tamil Nadu',
'Sethumadai,Pollachi,Tamil Nadu',
'Settiakkapalayam,Pollachi,Tamil Nadu',
'Sheikalmudi,Pollachi,Tamil Nadu',
'Sholayar Nagar,Pollachi,Tamil Nadu',
'Sholayar,Pollachi,Tamil Nadu',
'Singarampalayam,Pollachi,Tamil Nadu',
'Sirukalandai,Pollachi,Tamil Nadu',
'Sirukundra,Pollachi,Tamil Nadu',
'Sokkanur,Pollachi,Tamil Nadu',
'Solvampalayam,Pollachi,Tamil Nadu',
'Somandurai,Pollachi,Tamil Nadu',
'Subbegoundenpudur,Pollachi,Tamil Nadu',
'Sulakkal,Pollachi,Tamil Nadu',
'Suleeswaran Patti,Pollachi,Tamil Nadu',
'T.Kottampatti,Pollachi,Tamil Nadu',
'Thalakarai,Pollachi,Tamil Nadu',
'Thalanar,Pollachi,Tamil Nadu',
'Thamaraikulam,Pollachi,Tamil Nadu',
'Thathur,Pollachi,Tamil Nadu',
'Thimmankothu,Pollachi,Tamil Nadu',
'Thondamuthur,Pollachi,Tamil Nadu',
'Topslip,Pollachi,Tamil Nadu',
'Unjavelampatti,Pollachi,Tamil Nadu',
'Upper Aliyar Dam,Pollachi,Tamil Nadu',
'Urulikkal,Pollachi,Tamil Nadu',
'Uthukuli Zamin,Pollachi,Tamil Nadu',
'Vadakkipalayam,Pollachi,Tamil Nadu',
'Vadasithur,Pollachi,Tamil Nadu',
'Vagatholuvu,Pollachi,Tamil Nadu',
'Valaparai,Pollachi,Tamil Nadu',
'Vedasanthur,Pollachi,Tamil Nadu',
'Veeralpatti,Pollachi,Tamil Nadu',
'Vellalapalayam,Pollachi,Tamil Nadu',
'Vellamalai,Pollachi,Tamil Nadu',
'Vellonie,Pollachi,Tamil Nadu',
'Vettaikaran Pudur,Pollachi,Tamil Nadu',
'Virugalpatti,Pollachi,Tamil Nadu',
'Water Falls Estate,Pollachi,Tamil Nadu',
'Waverly,Pollachi,Tamil Nadu',
'Zamin Kottampatti,Pollachi,Tamil Nadu',
'Zamin Muthur,Pollachi,Tamil Nadu',
'Andipalayam,Tirupur,Tamil Nadu',
'Anuppapalayam,Tirupur,Tamil Nadu',
'Arasampalayam,Tirupur,Tamil Nadu',
'Ayyankalipalayam,Tirupur,Tamil Nadu',
'Elavanthi,Tirupur,Tamil Nadu',
'Gandhinagar,Tirupur,Tamil Nadu',
'Iduvampalayam,Tirupur,Tamil Nadu',
'Iduvoi,Tirupur,Tamil Nadu',
'Ittiveerampalayam,Tirupur,Tamil Nadu',
'Kallampalayam Road,Tirupur,Tamil Nadu',
'Kannakkampalayam,Tirupur,Tamil Nadu',
'Karunampathi,Tirupur,Tamil Nadu',
'Karuvampalayam,Tirupur,Tamil Nadu',
'Kathankanni,Tirupur,Tamil Nadu',
'Katturpalldam,Tirupur,Tamil Nadu',
'Knp Colony,Tirupur,Tamil Nadu',
'Kumarnagar,Tirupur,Tamil Nadu',
'Mangalam,Tirupur,Tamil Nadu',
'Mannarai,Tirupur,Tamil Nadu',
'Manur,Tirupur,Tamil Nadu',
'Maruduraiyanvalasu,Tirupur,Tamil Nadu',
'Mudalipalayam,Tirupur,Tamil Nadu',
'Muthanampalayam,Tirupur,Tamil Nadu',
'Nachipalayam,Tirupur,Tamil Nadu',
'Nallur,Tirupur,Tamil Nadu',
'Perumanallur,Tirupur,Tamil Nadu',
'Pichampalayampudur,Tirupur,Tamil Nadu',
'Pn Road,Tirupur,Tamil Nadu',
'Pongupalayam,Tirupur,Tamil Nadu',
'Puluvapatti,Tirupur,Tamil Nadu',
'Sirupuluvapatti,Tirupur,Tamil Nadu',
'T.C.Market,Tirupur,Tamil Nadu',
'Tea Nagar,Tirupur,Tamil Nadu',
'Tiruneelakandapuram,Tirupur,Tamil Nadu',
'Tirupur Bazaar,Tirupur,Tamil Nadu',
'Tirupur East,Tirupur,Tamil Nadu',
'Tirupur H.O,Tirupur,Tamil Nadu',
'Tirupur North,Tirupur,Tamil Nadu',
'Vavipalayam,Tirupur,Tamil Nadu',
'Veerapandi,Tirupur,Tamil Nadu',
'Vijayapuram,Tirupur,Tamil Nadu',
'Chellappampalayam,Pollachi,Tamil Nadu',
'A.Nagore,Pollachi,Tamil Nadu',
'Amandakadavoo,Pollachi,Tamil Nadu',
'Amaravathi Nagar,Pollachi,Tamil Nadu',
'Ammapatti,Pollachi,Tamil Nadu',
'Andigoundanur,Pollachi,Tamil Nadu',
'Athukinathupatti,Pollachi,Tamil Nadu',
'Deepalapatti,Pollachi,Tamil Nadu',
'Devanurpudur,Pollachi,Tamil Nadu',
'Dhully,Pollachi,Tamil Nadu',
'Doddampatti,Pollachi,Tamil Nadu',
'Elayamuthur,Pollachi,Tamil Nadu',
'Eripalayam,Pollachi,Tamil Nadu',
'Eripatti,Pollachi,Tamil Nadu',
'Erisinampatti,Pollachi,Tamil Nadu',
'Ganapathipalayam,Pollachi,Tamil Nadu',
'Gandhinagar,Pollachi,Tamil Nadu',
'Gomangalam,Pollachi,Tamil Nadu',
'Gudimangalam,Pollachi,Tamil Nadu',
'Jallipatti,Pollachi,Tamil Nadu',
'Jothampatti,Pollachi,Tamil Nadu',
'Kadathur,Pollachi,Tamil Nadu',
'Kallapuram,Pollachi,Tamil Nadu',
'Kaniyur,Pollachi,Tamil Nadu',
'Kannamanaickanur,Pollachi,Tamil Nadu',
'Karatholuvu,Pollachi,Tamil Nadu',
'Kodingium,Pollachi,Tamil Nadu',
'Kolarpatti,Pollachi,Tamil Nadu',
'Kolumam,Pollachi,Tamil Nadu',
'Komaralingam,Pollachi,Tamil Nadu',
'Kondampatti,Pollachi,Tamil Nadu',
'Kongalnagaram,Pollachi,Tamil Nadu',
'Kottamangalam,Pollachi,Tamil Nadu',
'Krishnapuram,Pollachi,Tamil Nadu',
'Kuralkuttai,Pollachi,Tamil Nadu',
'Kurichikottai,Pollachi,Tamil Nadu',
'Lakshmapuram,Pollachi,Tamil Nadu',
'Madathukulam,Pollachi,Tamil Nadu',
'Manupatti,Pollachi,Tamil Nadu',
'Metrathi,Pollachi,Tamil Nadu',
'Munduvelampatti,Pollachi,Tamil Nadu',
'Myvadi,Pollachi,Tamil Nadu',
'Nallannagoundanpudur,Pollachi,Tamil Nadu',
'Pallapalayam,Pollachi,Tamil Nadu',
'Pappankulam,Pollachi,Tamil Nadu',
'Pedappampatti,Pollachi,Tamil Nadu',
'Periakomarapalayam,Pollachi,Tamil Nadu',
'Periapatti,Pollachi,Tamil Nadu',
'Poosaripatti,Pollachi,Tamil Nadu',
'Pottikkampalayam,Pollachi,Tamil Nadu',
'Pudupalayam,Pollachi,Tamil Nadu',
'Pukkulam,Pollachi,Tamil Nadu',
'Pulankinar,Pollachi,Tamil Nadu',
'Pulavadi,Pollachi,Tamil Nadu',
'Pungamuthur,Pollachi,Tamil Nadu',
'Ravanapuram,Pollachi,Tamil Nadu',
'Rudrapalayam,Pollachi,Tamil Nadu',
'Samarayapatti,Pollachi,Tamil Nadu',
'Saminathapuram,Pollachi,Tamil Nadu',
'Sarkarkannadipudur,Pollachi,Tamil Nadu',
'Seelakkampatti,Pollachi,Tamil Nadu',
'Sengattupalayam,Pollachi,Tamil Nadu',
'Senjellappagoundenpudur,Pollachi,Tamil Nadu',
'Solamadevi,Pollachi,Tamil Nadu',
'Sundakkampalayam,Pollachi,Tamil Nadu',
'Thenkumarapalayam,Pollachi,Tamil Nadu',
'Thippampatti,Pollachi,Tamil Nadu',
'Thirumurthi Nagar,Pollachi,Tamil Nadu',
'Thumbalapatti,Pollachi,Tamil Nadu',
'Thungavi,Pollachi,Tamil Nadu',
'Udamalpet Bazaar,Pollachi,Tamil Nadu',
'Udamalpet East,Pollachi,Tamil Nadu',
'Udamalpet H.O,Pollachi,Tamil Nadu',
'Udamalpet South,Pollachi,Tamil Nadu',
'Udukkampalayam,Pollachi,Tamil Nadu',
'Uralpatti,Pollachi,Tamil Nadu',
'Vadugapalayam,Pollachi,Tamil Nadu',
'Valavadi,Pollachi,Tamil Nadu',
'Vedapatti,Pollachi,Tamil Nadu',
'Venkatesa Mills,Pollachi,Tamil Nadu',
'Vilamarathupatti,Pollachi,Tamil Nadu',
'Bodipatti,Pollachi,Tamil Nadu',
'Elleri,Cuddalore,Tamil Nadu',
'Small Bazaar,Cuddalore,Tamil Nadu',
'Chidambaram West,Cuddalore,Tamil Nadu',
'Ammapettai,Cuddalore,Tamil Nadu',
'Athipatu,Cuddalore,Tamil Nadu',
'Karuppur,Cuddalore,Tamil Nadu',
'Salianthoppu,Cuddalore,Tamil Nadu',
'Vadakkumangudi,Cuddalore,Tamil Nadu',
'Vaiyur,Cuddalore,Tamil Nadu',
'Agaram,Cuddalore,Tamil Nadu',
'Alapakkam,Cuddalore,Tamil Nadu',
'Annamalai University,Cuddalore,Tamil Nadu',
'Annamalainagar,Cuddalore,Tamil Nadu',
'Ariyakoshti,Cuddalore,Tamil Nadu',
'Ayyanur Akkaramangalam,Cuddalore,Tamil Nadu',
'Azhisikudi,Cuddalore,Tamil Nadu',
'B.Adivaraganallur,Cuddalore,Tamil Nadu',
'B.Mutlur,Cuddalore,Tamil Nadu',
'daiyur,Cuddalore,Tamil Nadu',
'Bhuvanagiri,Cuddalore,Tamil Nadu',
'Budavarayanpettai,Cuddalore,Tamil Nadu',
'C.Arasur,Cuddalore,Tamil Nadu',
'C.Mutlur,Cuddalore,Tamil Nadu',
'C.Pudupettai,Cuddalore,Tamil Nadu',
'C.Sathamangalam,Cuddalore,Tamil Nadu',
'C.Veeracholagam,Cuddalore,Tamil Nadu',
'Chidambaram Cutcherry,Cuddalore,Tamil Nadu',
'Chidambaram East,Cuddalore,Tamil Nadu',
'Chidambaram H.O,Cuddalore,Tamil Nadu',
'Chidambaram North,Cuddalore,Tamil Nadu',
'Chidambaram R.S.,Cuddalore,Tamil Nadu',
'Ennanagaram,Cuddalore,Tamil Nadu',
'Gavarappattu,Cuddalore,Tamil Nadu',
'Jayankondapattinam,Cuddalore,Tamil Nadu',
'K.Adur,Cuddalore,Tamil Nadu',
'K.Alambadi,Cuddalore,Tamil Nadu',
'Kanagasabainagar,Cuddalore,Tamil Nadu',
'Keelamoongiladi,Cuddalore,Tamil Nadu',
'Keelanuvampattu,Cuddalore,Tamil Nadu',
'Keerapalayam,Cuddalore,Tamil Nadu',
'Killai,Cuddalore,Tamil Nadu',
'Kollimalai Kilpathi,Cuddalore,Tamil Nadu',
'Kollimalai Melpathi,Cuddalore,Tamil Nadu',
'Kollumedu,Cuddalore,Tamil Nadu',
'Kothattai,Cuddalore,Tamil Nadu',
'Kothavacheri,Cuddalore,Tamil Nadu',
'Kovilampoondi,Cuddalore,Tamil Nadu',
'Krishnapuram,Cuddalore,Tamil Nadu',
'Kummidimulai,Cuddalore,Tamil Nadu',
'Kuriamangalam,Cuddalore,Tamil Nadu',
'Lalpuram,Cuddalore,Tamil Nadu',
'M.Odaiyur,Cuddalore,Tamil Nadu',
'M.Puliyangudi,Cuddalore,Tamil Nadu',
'Maduranthaganallur,Cuddalore,Tamil Nadu',
'Maniadur,Cuddalore,Tamil Nadu',
'Manikollai,Cuddalore,Tamil Nadu',
'Manjakollai,Cuddalore,Tamil Nadu',
'Manjakuli,Cuddalore,Tamil Nadu',
'Mariappanagar,Cuddalore,Tamil Nadu',
'Melamanakudi,Cuddalore,Tamil Nadu',
'Melaparuthikudi,Cuddalore,Tamil Nadu',
'Melavanniyur,Cuddalore,Tamil Nadu',
'Miralur,Cuddalore,Tamil Nadu',
'Mullangudi,Cuddalore,Tamil Nadu',
'Nakkaravanthankudi,Cuddalore,Tamil Nadu',
'Nanjalur,Cuddalore,Tamil Nadu',
'Nanjamahathuvazkai,Cuddalore,Tamil Nadu',
'Neyvasal,Cuddalore,Tamil Nadu',
'Odakkanallur,Cuddalore,Tamil Nadu',
'Orathur,Cuddalore,Tamil Nadu',
'Pannapattu,Cuddalore,Tamil Nadu',
'Paradur,Cuddalore,Tamil Nadu',
'Parangipettai,Cuddalore,Tamil Nadu',
'Perampattu,Cuddalore,Tamil Nadu',
'Periyakomatti,Cuddalore,Tamil Nadu',
'Pichavaram,Cuddalore,Tamil Nadu',
'Pillaiyarthangal,Cuddalore,Tamil Nadu',
'Pinnathur,Cuddalore,Tamil Nadu',
'Ponnanthittu,Cuddalore,Tamil Nadu',
'Puduchatram,Cuddalore,Tamil Nadu',
'Pulamedu,Cuddalore,Tamil Nadu',
'Puvalai,Cuddalore,Tamil Nadu',
'Sakkangudi,Cuddalore,Tamil Nadu',
'Samiyarpettai,Cuddalore,Tamil Nadu',
'Sathapadi,Cuddalore,Tamil Nadu',
'Sivapuri,Cuddalore,Tamil Nadu',
'Suravilandur,Cuddalore,Tamil Nadu',
'Temmur,Cuddalore,Tamil Nadu',
'Thatchakadu,Cuddalore,Tamil Nadu',
'Theethampalayam,Cuddalore,Tamil Nadu',
'Thillaividangan,Cuddalore,Tamil Nadu',
'Tirunaraiyur,Cuddalore,Tamil Nadu',
'Uthamacholamangalam,Cuddalore,Tamil Nadu',
'Vakkur,Cuddalore,Tamil Nadu',
'Vallampadugai,Cuddalore,Tamil Nadu',
'Vannaiyur,Cuddalore,Tamil Nadu',
'Vayalur,Cuddalore,Tamil Nadu',
'Villiyanallur,Cuddalore,Tamil Nadu',
'Adinarayananpuram,Cuddalore,Tamil Nadu',
'Adur Agaram,Cuddalore,Tamil Nadu',
'Akkarai Gori,Cuddalore,Tamil Nadu',
'Alaginatham,Cuddalore,Tamil Nadu',
'Ambalavananpettai,Cuddalore,Tamil Nadu',
'Andarmullipallam,Cuddalore,Tamil Nadu',
'Annavalli,Cuddalore,Tamil Nadu',
'Anukkampattu,Cuddalore,Tamil Nadu',
'Arangamangalam,Cuddalore,Tamil Nadu',
'Ayikuppam,Cuddalore,Tamil Nadu',
'Bharathi Road,Cuddalore,Tamil Nadu',
'Capperquary,Cuddalore,Tamil Nadu',
'Chellanchery,Pondicherry,Tamil Nadu',
'Chinnakannadi,Cuddalore,Tamil Nadu',
'Cuddalore Court Buildings,Cuddalore,Tamil Nadu',
'Cuddalore H.O,Cuddalore,Tamil Nadu',
'Cuddalore Old Town,Cuddalore,Tamil Nadu',
'Cuddalore Ot Bazaar,Cuddalore,Tamil Nadu',
'Cuddalore Port,Cuddalore,Tamil Nadu',
'Cuddalore Public Offices,Cuddalore,Tamil Nadu',
'Fort St.David,Cuddalore,Tamil Nadu',
'Gandhi Nagar,Cuddalore,Tamil Nadu',
'Gudithangi,Cuddalore,Tamil Nadu',
'Gunamangalam,Cuddalore,Tamil Nadu',
'Gundu Uppalavadi,Cuddalore,Tamil Nadu',
'Guruvappanpettai,Cuddalore,Tamil Nadu',
'Kalaiyur,Cuddalore,Tamil Nadu',
'Kalkunam,Cuddalore,Tamil Nadu',
'Kilarungunam,Cuddalore,Tamil Nadu',
'Kilur,Cuddalore,Tamil Nadu',
'Kodukkanpalayam,Cuddalore,Tamil Nadu',
'Kondur,Cuddalore,Tamil Nadu',
'Krishnankuppam,Cuddalore,Tamil Nadu',
'Kullanchavadi,Cuddalore,Tamil Nadu',
'Kundiyamallur,Cuddalore,Tamil Nadu',
'Kurinjipadi,Cuddalore,Tamil Nadu',
'M.Pudur,Cuddalore,Tamil Nadu',
'Madanagopalapuram,Cuddalore,Tamil Nadu',
'Manjakkuppam,Cuddalore,Tamil Nadu',
'Mariasusainagar,Cuddalore,Tamil Nadu',
'Marudadu,Cuddalore,Tamil Nadu',
'Mathalapattu,Pondicherry,Tamil Nadu',
'Melpathi,Cuddalore,Tamil Nadu',
'Nallathur,Pondicherry,Tamil Nadu',
'Nathapattu,Cuddalore,Tamil Nadu',
'Pachayankuppam,Cuddalore,Tamil Nadu',
'Padirikuppam,Cuddalore,Tamil Nadu',
'Periyakuppam,Cuddalore,Tamil Nadu',
'Pethanaickenkuppam,Cuddalore,Tamil Nadu',
'Poochimedu,Cuddalore,Tamil Nadu',
'Poondiyankuppam,Cuddalore,Tamil Nadu',
'Poovanikkuppam,Cuddalore,Tamil Nadu',
'Pudupalayam,Cuddalore,Tamil Nadu',
'Puliyur,Cuddalore,Tamil Nadu',
'Ramapuram,Cuddalore,Tamil Nadu',
'Reddichavadi,Pondicherry,Tamil Nadu',
'Samattikuppam,Cuddalore,Tamil Nadu',
'Sangolikuppam,Cuddalore,Tamil Nadu',
'Sathankuppam,Cuddalore,Tamil Nadu',
'Sedapalayam,Cuddalore,Tamil Nadu',
'Seemanthottam,Cuddalore,Tamil Nadu',
'Sellankuppam,Cuddalore,Tamil Nadu',
'Semmandalam,Cuddalore,Tamil Nadu',
'Sholavalli,Cuddalore,Tamil Nadu',
'Silambimangalam,Cuddalore,Tamil Nadu',
'Singirikoil,Pondicherry,Tamil Nadu',
'Sipcot Cuddalore,Cuddalore,Tamil Nadu',
'Suba Uppalavadi,Cuddalore,Tamil Nadu',
'Subramaniyapuram,Cuddalore,Tamil Nadu',
'Sundaravandi,Cuddalore,Tamil Nadu',
'T.Palayam,Cuddalore,Tamil Nadu',
'Theerthanagiri,Cuddalore,Tamil Nadu',
'Thiyagavalli,Cuddalore,Tamil Nadu',
'Thokkanambakkam,Pondicherry,Tamil Nadu',
'Thondamanatham,Cuddalore,Tamil Nadu',
'Tirukandeeswaram,Cuddalore,Tamil Nadu',
'Tirumanikuzhi,Cuddalore,Tamil Nadu',
'Tirupadiripuliyur,Cuddalore,Tamil Nadu',
'Tiruppadiripuliyur Bazaar,Cuddalore,Tamil Nadu',
'Tiruppadiripuliyur West,Cuddalore,Tamil Nadu',
'Tiruvendhipuram,Cuddalore,Tamil Nadu',
'Valisodanaipalayam,Cuddalore,Tamil Nadu',
'Valudalampattu,Cuddalore,Tamil Nadu',
'Vanamadevi,Cuddalore,Tamil Nadu',
'Vandipalayam,Cuddalore,Tamil Nadu',
'Vanpakkam,Cuddalore,Tamil Nadu',
'Varakalpattu,Cuddalore,Tamil Nadu',
'Vasanankuppam,Cuddalore,Tamil Nadu',
'Vasantharayanpalayam,Cuddalore,Tamil Nadu',
'Vehakollai,Cuddalore,Tamil Nadu',
'Vellakarai,Cuddalore,Tamil Nadu',
'Vellapakkam,Cuddalore,Tamil Nadu',
'Venkatampettai,Cuddalore,Tamil Nadu',
'Venugopalapuram,Cuddalore,Tamil Nadu',
'Vilvarayanatham,Cuddalore,Tamil Nadu',
'Virupakshi,Cuddalore,Tamil Nadu',
'B.Kolakudi,Cuddalore,Tamil Nadu',
'Sholathiram,Cuddalore,Tamil Nadu',
'Valakollai,Cuddalore,Tamil Nadu',
'Perur,Cuddalore,Tamil Nadu',
'Rajendra Pattinam,Cuddalore,Tamil Nadu',
'Udayargudi,Cuddalore,Tamil Nadu',
'Ramapuram,Cuddalore,Tamil Nadu',
'Agara Alambadi,Cuddalore,Tamil Nadu',
'Alkondanatham,Cuddalore,Tamil Nadu',
'Ambapuram,Cuddalore,Tamil Nadu',
'Arantangi,Cuddalore,Tamil Nadu',
'Ayangudi,Cuddalore,Tamil Nadu',
'Budangudi,Cuddalore,Tamil Nadu',
'Chettithangal,Cuddalore,Tamil Nadu',
'Chinnanargunam,Cuddalore,Tamil Nadu',
'Erumbur,Cuddalore,Tamil Nadu',
'Eyyalur,Cuddalore,Tamil Nadu',
'Kandakumaran,Cuddalore,Tamil Nadu',
'Kandamangalam,Cuddalore,Tamil Nadu',
'Kanjankollai,Cuddalore,Tamil Nadu',
'Kanur,Cuddalore,Tamil Nadu',
'Karunakaranallur,Cuddalore,Tamil Nadu',
'Kattumannarkoil,Cuddalore,Tamil Nadu',
'Kavalakudi,Cuddalore,Tamil Nadu',
'Kavanur,Cuddalore,Tamil Nadu',
'Komaratchi,Cuddalore,Tamil Nadu',
'Kothavasal,Cuddalore,Tamil Nadu',
'Kozhai,Cuddalore,Tamil Nadu',
'Kuduveli,Cuddalore,Tamil Nadu',
'Kumarakud,Cuddalore,Tamil Nadu',
'Kunamangalam,Cuddalore,Tamil Nadu',
'Kunjimedu,Cuddalore,Tamil Nadu',
'Lalpet,Cuddalore,Tamil Nadu',
'M.Adhanur,Cuddalore,Tamil Nadu',
'M.Kolakudi,Cuddalore,Tamil Nadu',
'Mamangalam,Cuddalore,Tamil Nadu',
'Marudur,Cuddalore,Tamil Nadu',
'Marungur,Cuddalore,Tamil Nadu',
'Melakadambur,Cuddalore,Tamil Nadu',
'Melapalachanallur,Cuddalore,Tamil Nadu',
'Mogaiyur,Cuddalore,Tamil Nadu',
'Movur,Cuddalore,Tamil Nadu',
'Mudikandanallur,Cuddalore,Tamil Nadu',
'Muttam,Cuddalore,Tamil Nadu',
'Nagarapadi,Cuddalore,Tamil Nadu',
'Nandesswaramangalam,Cuddalore,Tamil Nadu',
'Nangudi,Cuddalore,Tamil Nadu',
'Nattarmangalam,Cuddalore,Tamil Nadu',
'Omampuliyur,Cuddalore,Tamil Nadu',
'Palayamkottai Melpathy,Cuddalore,Tamil Nadu',
'Palayamkottai(CDL),Cuddalore,Tamil Nadu',
'Periyanellikkollai,Cuddalore,Tamil Nadu',
'Perungalur,Cuddalore,Tamil Nadu',
'Pinnalur,Cuddalore,Tamil Nadu',
'Poondi,Cuddalore,Tamil Nadu',
'Pudaiyur,Cuddalore,Tamil Nadu',
'Rajendra Cholagam,Cuddalore,Tamil Nadu',
'Reddiyur,Cuddalore,Tamil Nadu',
'Sethiathope,Cuddalore,Tamil Nadu',
'Shandan,Cuddalore,Tamil Nadu',
'Sirukattur,Cuddalore,Tamil Nadu',
'Sithamalli,Cuddalore,Tamil Nadu',
'Sri Adivaraganallur,Cuddalore,Tamil Nadu',
'Sri Pudur,Cuddalore,Tamil Nadu',
'Sri Vakkaramari,Cuddalore,Tamil Nadu',
'Srimushnam,Cuddalore,Tamil Nadu',
'Srinedunjeri,Cuddalore,Tamil Nadu',
'T.Nedunjeri,Cuddalore,Tamil Nadu',
'Terkuviruthangam,Cuddalore,Tamil Nadu',
'Vadakkupalayam,Cuddalore,Tamil Nadu',
'Vadathalaikulam,Cuddalore,Tamil Nadu',
'Valasakkadu,Cuddalore,Tamil Nadu',
'Valayamadevi,Cuddalore,Tamil Nadu',
'Vanamadevi,Cuddalore,Tamil Nadu',
'Vattathur,Cuddalore,Tamil Nadu',
'Veeramudayanatham,Cuddalore,Tamil Nadu',
'Veeranandapuram,Cuddalore,Tamil Nadu',
'Vilagam,Cuddalore,Tamil Nadu',
'Kondasamudram,Cuddalore,Tamil Nadu',
'A.Kuravankuppam,Cuddalore,Tamil Nadu',
'Akkadavalli,Cuddalore,Tamil Nadu',
'Alagaperumalkuppam,Cuddalore,Tamil Nadu',
'Ammeri,Cuddalore,Tamil Nadu',
'Anguchettipalayam,Cuddalore,Tamil Nadu',
'Arasadikkuppam,Cuddalore,Tamil Nadu',
'Aviyanur,Cuddalore,Tamil Nadu',
'Badrakottai,Cuddalore,Tamil Nadu',
'Bandarakottai,Cuddalore,Tamil Nadu',
'Block 1, Neyveli,Cuddalore,Tamil Nadu',
'Block 10,neyveli,Cuddalore,Tamil Nadu',
'Block 18, Neyveli,Cuddalore,Tamil Nadu',
'Block 24, Neyveli,Cuddalore,Tamil Nadu',
'Block 26, Neyveli,Cuddalore,Tamil Nadu',
'Block 27,. Neyveli,Cuddalore,Tamil Nadu',
'Block 29, Neyveli,Cuddalore,Tamil Nadu',
'Block 3, Neyveli,Cuddalore,Tamil Nadu',
'Block 5, Neyveli,Cuddalore,Tamil Nadu',
'Chinnapanaickenpalayam,Cuddalore,Tamil Nadu',
'Edayarkuppam,Cuddalore,Tamil Nadu',
'Elumedu,Cuddalore,Tamil Nadu',
'Enathirimangalam,Cuddalore,Tamil Nadu',
'Iruppu,Cuddalore,Tamil Nadu',
'Kadambuliyur,Cuddalore,Tamil Nadu',
'Kalinjikuppam,Cuddalore,Tamil Nadu',
'Kandrakottai,Cuddalore,Tamil Nadu',
'Kanisapakkam,Cuddalore,Tamil Nadu',
'Karumbur,Cuddalore,Tamil Nadu',
'Karunguli,Cuddalore,Tamil Nadu',
'Kattamuthupalayam,Cuddalore,Tamil Nadu',
'Kattugudalur,Cuddalore,Tamil Nadu',
'Kiliruppu,Cuddalore,Tamil Nadu',
'Kilkangeyankuppam,Cuddalore,Tamil Nadu',
'Kilkavarappattu,Cuddalore,Tamil Nadu',
'Kilmampattu,Cuddalore,Tamil Nadu',
'Kongarayanur,Cuddalore,Tamil Nadu',
'Kottagam,Cuddalore,Tamil Nadu',
'Kudimiyankuppam,Cuddalore,Tamil Nadu',
'Kumaramangalam,Cuddalore,Tamil Nadu',
'Lakshminarayanapuram,Cuddalore,Tamil Nadu',
'Maligaimedu,Cuddalore,Tamil Nadu',
'Maligampattu,Cuddalore,Tamil Nadu',
'Manamthavizhnthaputhur,Cuddalore,Tamil Nadu',
'Marungur,Cuddalore,Tamil Nadu',
'Maruvai,Cuddalore,Tamil Nadu',
'Melakolakudi,Cuddalore,Tamil Nadu',
'Melakuppam,Cuddalore,Tamil Nadu',
'Melkavrapattu,Cuddalore,Tamil Nadu',
'Melmampattu,Cuddalore,Tamil Nadu',
'Melpattambakkam,Cuddalore,Tamil Nadu',
'Mettukkuppam,Cuddalore,Tamil Nadu',
'Moolakuppam,Cuddalore,Tamil Nadu',
'Mudapuli,Cuddalore,Tamil Nadu',
'N.Moolakuppam,Cuddalore,Tamil Nadu',
'Nadukkuppam,Cuddalore,Tamil Nadu',
'Naduveerappattu,Cuddalore,Tamil Nadu',
'Natham,Cuddalore,Tamil Nadu',
'Nellikkuppam East,Cuddalore,Tamil Nadu',
'Nellikkuppam,Cuddalore,Tamil Nadu',
'Nellikuppam Bazaar,Cuddalore,Tamil Nadu',
'Neyveli 1,Cuddalore,Tamil Nadu',
'Neyveli 2,Cuddalore,Tamil Nadu',
'Neyveli 3,Cuddalore,Tamil Nadu',
'Neyveli General Hospital,Cuddalore,Tamil Nadu',
'Neyveli Ii Thermal Station,Cuddalore,Tamil Nadu',
'Neyveli Second Mines,Cuddalore,Tamil Nadu',
'Neyveli Thermal Bus Stand,Cuddalore,Tamil Nadu',
'Odappankuppam,Cuddalore,Tamil Nadu',
'Oraiyur,Cuddalore,Tamil Nadu',
'Pagandai,Cuddalore,Tamil Nadu',
'Pallavarayanatham,Cuddalore,Tamil Nadu',
'Palur,Cuddalore,Tamil Nadu',
'Panikuppam,Cuddalore,Tamil Nadu',
'Panruti Bazaar,Cuddalore,Tamil Nadu',
'Panruti East,Cuddalore,Tamil Nadu',
'Panruti,Cuddalore,Tamil Nadu',
'Panruti West,Cuddalore,Tamil Nadu',
'Periyakappankulam,Cuddalore,Tamil Nadu',
'Perperiyankuppam,Cuddalore,Tamil Nadu',
'Perumalnaickenpalayam,Cuddalore,Tamil Nadu',
'Pulavanur,Cuddalore,Tamil Nadu',
'Puthupet (CDL),Cuddalore,Tamil Nadu',
'Pythambadi,Cuddalore,Tamil Nadu',
'Sathipattu,Cuddalore,Tamil Nadu',
'Semmedu,Cuddalore,Tamil Nadu',
'Semokottai,Cuddalore,Tamil Nadu',
'Seplanatham,Cuddalore,Tamil Nadu',
'Serakuppam,Cuddalore,Tamil Nadu',
'Silambinathanpettai,Cuddalore,Tamil Nadu',
'Sirugramam,Cuddalore,Tamil Nadu',
'Siruthondamadevi,Cuddalore,Tamil Nadu',
'Siruvathur,Cuddalore,Tamil Nadu',
'Sornavur Melpathi,Cuddalore,Tamil Nadu',
'Thandavankuppam,Cuddalore,Tamil Nadu',
'Thattampalayam,Cuddalore,Tamil Nadu',
'Tiruthuraiyur,Cuddalore,Tamil Nadu',
'Tiruvamur,Cuddalore,Tamil Nadu',
'Tiruvatigai,Cuddalore,Tamil Nadu',
'Vadakkuvelur,Cuddalore,Tamil Nadu',
'Vadakuthu,Cuddalore,Tamil Nadu',
'Vadalur,Cuddalore,Tamil Nadu',
'Vallam,Cuddalore,Tamil Nadu',
'Vanathirayapuram,Cuddalore,Tamil Nadu',
'Varinjipakkam,Cuddalore,Tamil Nadu',
'Veerraperumanallur,Cuddalore,Tamil Nadu',
'Visoor,Cuddalore,Tamil Nadu',
'Akkanur,Vriddhachalam,Tamil Nadu',
'Alambadi,Vriddhachalam,Tamil Nadu',
'Alathur,Vriddhachalam,Tamil Nadu',
'Avatti,Vriddhachalam,Tamil Nadu',
'E.Keeranur,Vriddhachalam,Tamil Nadu',
'Eluthur,Vriddhachalam,Tamil Nadu',
'Gudalur,Vriddhachalam,Tamil Nadu',
'Kilacheruvoi,Vriddhachalam,Tamil Nadu',
'Kilakalpoondi,Vriddhachalam,Tamil Nadu',
'Kilimangalam,Vriddhachalam,Tamil Nadu',
'Korakkavadi,Vriddhachalam,Tamil Nadu',
'Kothattai,Vriddhachalam,Tamil Nadu',
'Lakkur,Vriddhachalam,Tamil Nadu',
'Ma Podaiyur,Vriddhachalam,Tamil Nadu',
'Malayanur,Vriddhachalam,Tamil Nadu',
'Mangalur,Vriddhachalam,Tamil Nadu',
'Melur,Vriddhachalam,Tamil Nadu',
'Murugangudi,Vriddhachalam,Tamil Nadu',
'Orangur,Vriddhachalam,Tamil Nadu',
'Pelandurai,Vriddhachalam,Tamil Nadu',
'Pennadam R.S.,Vriddhachalam,Tamil Nadu',
'Perumulai,Vriddhachalam,Tamil Nadu',
'Pothiramangalam,Vriddhachalam,Tamil Nadu',
'Sathanatham,Vriddhachalam,Tamil Nadu',
'Sevveri,Vriddhachalam,Tamil Nadu',
'Sirumulai,Vriddhachalam,Tamil Nadu',
'Thachur,Vriddhachalam,Tamil Nadu',
'Tiruvattathurai,Vriddhachalam,Tamil Nadu',
'Tittagudi,Vriddhachalam,Tamil Nadu',
'Tolar,Vriddhachalam,Tamil Nadu',
'Toludur,Vriddhachalam,Tamil Nadu',
'Vagaiyur,Vriddhachalam,Tamil Nadu',
'Vaithianathapuram,Vriddhachalam,Tamil Nadu',
'Vallimaduram,Vriddhachalam,Tamil Nadu',
'Venganur,Vriddhachalam,Tamil Nadu',
'Avinangudi,Vriddhachalam,Tamil Nadu',
'Konur,Vriddhachalam,Tamil Nadu',
'Kosapallam,Vriddhachalam,Tamil Nadu',
'Pennadam,Vriddhachalam,Tamil Nadu',
'Sirupakkam,Vriddhachalam,Tamil Nadu',
'Adari,Vriddhachalam,Tamil Nadu',
'Budamur,Vriddhachalam,Tamil Nadu',
'C Keeranur,Vriddhachalam,Tamil Nadu',
'Chinnaparur,Vriddhachalam,Tamil Nadu',
'Deevalur,Vriddhachalam,Tamil Nadu',
'Dharmanallur,Vriddhachalam,Tamil Nadu',
'Edaiyur,Vriddhachalam,Tamil Nadu',
'Erumanur,Vriddhachalam,Tamil Nadu',
'Gopalapuram,Vriddhachalam,Tamil Nadu',
'Idaichittur,Vriddhachalam,Tamil Nadu',
'Kaludur,Vriddhachalam,Tamil Nadu',
'Kammapuram,Vriddhachalam,Tamil Nadu',
'Kargudal,Vriddhachalam,Tamil Nadu',
'Karnatham,Vriddhachalam,Tamil Nadu',
'Karuvepilankurichi,Vriddhachalam,Tamil Nadu',
'Kathazhai,Vriddhachalam,Tamil Nadu',
'Kattumailur,Vriddhachalam,Tamil Nadu',
'Kilapalaiyur,Vriddhachalam,Tamil Nadu',
'Ko Adhanur,Vriddhachalam,Tamil Nadu',
'Ko Pavalangudi,Vriddhachalam,Tamil Nadu',
'Konankuppam,Vriddhachalam,Tamil Nadu',
'Kotteri,Vriddhachalam,Tamil Nadu',
'Kuppanatham,Vriddhachalam,Tamil Nadu',
'Manavalanallur,Vriddhachalam,Tamil Nadu',
'Mangalam (SA),Vriddhachalam,Tamil Nadu',
'Mathur,Vriddhachalam,Tamil Nadu',
'Mudanai,Vriddhachalam,Tamil Nadu',
'Mukhasaparur,Vriddhachalam,Tamil Nadu',
'N. Naraiyur,Vriddhachalam,Tamil Nadu',
'Nagar,Vriddhachalam,Tamil Nadu',
'Nallur,Vriddhachalam,Tamil Nadu',
'Nithinatham,Vriddhachalam,Tamil Nadu',
'Oomangalam,Vriddhachalam,Tamil Nadu',
'Ottimedu,Vriddhachalam,Tamil Nadu',
'Palayapattinam,Vriddhachalam,Tamil Nadu',
'Pali,Vriddhachalam,Tamil Nadu',
'Paravalur,Vriddhachalam,Tamil Nadu',
'Pasar,Vriddhachalam,Tamil Nadu',
'Perambalur,Vriddhachalam,Tamil Nadu',
'Periyakottumulai,Vriddhachalam,Tamil Nadu',
'Periyanesalur,Vriddhachalam,Tamil Nadu',
'Pillur,Vriddhachalam,Tamil Nadu',
'Poolambadi,Vriddhachalam,Tamil Nadu',
'Poynapadi,Vriddhachalam,Tamil Nadu',
'Puvanur,Vriddhachalam,Tamil Nadu',
'Rettakurichi,Vriddhachalam,Tamil Nadu',
'Sathamangalam,Vriddhachalam,Tamil Nadu',
'Sathapadi,Vriddhachalam,Tamil Nadu',
'Sathiyam,Vriddhachalam,Tamil Nadu',
'Sathiyavadi,Vriddhachalam,Tamil Nadu',
'Sathukudal,Vriddhachalam,Tamil Nadu',
'Seppakkam,Vriddhachalam,Tamil Nadu',
'Sirumangalam,Vriddhachalam,Tamil Nadu',
'T Gopurapuram,Vriddhachalam,Tamil Nadu',
'Therku Vadakku Puthur,Vriddhachalam,Tamil Nadu',
'Thoravalur,Vriddhachalam,Tamil Nadu',
'Thottikuppam,Vriddhachalam,Tamil Nadu',
'U Agaram,Vriddhachalam,Tamil Nadu',
'Uttangal,Vriddhachalam,Tamil Nadu',
'Varambanur,Vriddhachalam,Tamil Nadu',
'Veppur (SA),Vriddhachalam,Tamil Nadu',
'Vijayamanagaram,Vriddhachalam,Tamil Nadu',
'Vilangattur,Vriddhachalam,Tamil Nadu',
'Vriddhachalam Bazaar,Vriddhachalam,Tamil Nadu',
'Vriddhachalam Cutchery,Vriddhachalam,Tamil Nadu',
'Vriddhachalam H.O,Vriddhachalam,Tamil Nadu',
'D Thurinjipatti,Dharmapuri,Tamil Nadu',
'Dinnabelur,Dharmapuri,Tamil Nadu',
'Kandagavundanur,Dharmapuri,Tamil Nadu',
'Kathanahalli,Dharmapuri,Tamil Nadu',
'Odasahalli,Dharmapuri,Tamil Nadu',
'Vennampatti,Dharmapuri,Tamil Nadu',
'A.Gollahalli,Dharmapuri,Tamil Nadu',
'A.Jettihalli,Dharmapuri,Tamil Nadu',
'A.Sappanipatti,Dharmapuri,Tamil Nadu',
'Adiyamankottai,Dharmapuri,Tamil Nadu',
'Akkamanahalli,Dharmapuri,Tamil Nadu',
'Annasagaram,Dharmapuri,Tamil Nadu',
'Arasampatti,Dharmapuri,Tamil Nadu',
'Baisuhalli,Dharmapuri,Tamil Nadu',
'Balajangamanahalli,Dharmapuri,Tamil Nadu',
'Barur,Dharmapuri,Tamil Nadu',
'Bendrahalli,Dharmapuri,Tamil Nadu',
'Bommidi,Dharmapuri,Tamil Nadu',
'Boodanahalli,Dharmapuri,Tamil Nadu',
'Buddireddipatti,Dharmapuri,Tamil Nadu',
'Dharmapuri Collectorate,Dharmapuri,Tamil Nadu',
'Dharmapuri Fort,Dharmapuri,Tamil Nadu',
'Dharmapuri H.O,Dharmapuri,Tamil Nadu',
'Dharmapuri Pub. Offices,Dharmapuri,Tamil Nadu',
'Dharmapuri R.S,Dharmapuri,Tamil Nadu',
'Dharmapuri South,Dharmapuri,Tamil Nadu',
'Dokkubothanahalli,Dharmapuri,Tamil Nadu',
'Elagiri,Dharmapuri,Tamil Nadu',
'Esalpatti,Dharmapuri,Tamil Nadu',
'Gendiganahalli,Dharmapuri,Tamil Nadu',
'Hale Dharmapuri,Dharmapuri,Tamil Nadu',
'Ichampatti,Dharmapuri,Tamil Nadu',
'Irumathur,Dharmapuri,Tamil Nadu',
'Jingalkathirampatti,Dharmapuri,Tamil Nadu',
'Kammampatti,Dharmapuri,Tamil Nadu',
'Kannipatti,Dharmapuri,Tamil Nadu',
'Komarasamipatti,Dharmapuri,Tamil Nadu',
'Kottumaranahalli,Dharmapuri,Tamil Nadu',
'Kovilur,Dharmapuri,Tamil Nadu',
'Kuppangarai,Dharmapuri,Tamil Nadu',
'Kuppur,Dharmapuri,Tamil Nadu',
'Mademangalam,Dharmapuri,Tamil Nadu',
'Mallikuttai,Dharmapuri,Tamil Nadu',
'Maniyadahalli,Dharmapuri,Tamil Nadu',
'Maravadi,Dharmapuri,Tamil Nadu',
'Mathikonpalayam,Dharmapuri,Tamil Nadu',
'Matlamapatti,Dharmapuri,Tamil Nadu',
'Mittadinnahalli,Dharmapuri,Tamil Nadu',
'Mittanoolahalli,Dharmapuri,Tamil Nadu',
'Modur,Dharmapuri,Tamil Nadu',
'Moolakadu,Dharmapuri,Tamil Nadu',
'Nallasenahalli,Dharmapuri,Tamil Nadu',
'Narthampatti,Dharmapuri,Tamil Nadu',
'Pagalahalli,Dharmapuri,Tamil Nadu',
'Palayam,Dharmapuri,Tamil Nadu',
'Periyanahalli,Dharmapuri,Tamil Nadu',
'Pulidikarai,Dharmapuri,Tamil Nadu',
'Samichettipatti,Dharmapuri,Tamil Nadu',
'Settikarai,Dharmapuri,Tamil Nadu',
'Solaikottai,Dharmapuri,Tamil Nadu',
'T.Ganigarahalli,Dharmapuri,Tamil Nadu',
'Thathampatti,Dharmapuri,Tamil Nadu',
'Thokkampatti,Dharmapuri,Tamil Nadu',
'Ungaranahalli,Dharmapuri,Tamil Nadu',
'Venkatenahalli,Dharmapuri,Tamil Nadu',
'Achalvadi,Dharmapuri,Tamil Nadu',
'Agraharam,Dharmapuri,Tamil Nadu',
'Ammampalayam,Salem East,Tamil Nadu',
'Andiyur,Dharmapuri,Tamil Nadu',
'Bairnaickenpatti,Dharmapuri,Tamil Nadu',
'Batchapet,Dharmapuri,Tamil Nadu',
'Chellampatti,Dharmapuri,Tamil Nadu',
'Chinnankuppam,Dharmapuri,Tamil Nadu',
'Dasarahalli,Dharmapuri,Tamil Nadu',
'Doddampatti,Dharmapuri,Tamil Nadu',
'Eachambadi,Dharmapuri,Tamil Nadu',
'Elavadai,Dharmapuri,Tamil Nadu',
'Ellapudayampatti,Dharmapuri,Tamil Nadu',
'Gobichettipalayam,Dharmapuri,Tamil Nadu',
'Gobinathampatti,Dharmapuri,Tamil Nadu',
'Gudalur,Dharmapuri,Tamil Nadu',
'Hanumantheertham,Dharmapuri,Tamil Nadu',
'Harur Bazaar,Dharmapuri,Tamil Nadu',
'Harur,Dharmapuri,Tamil Nadu',
'Ichambadi,Dharmapuri,Tamil Nadu',
'Ittiampatti,Dharmapuri,Tamil Nadu',
'Ittiampatti,Dharmapuri,Tamil Nadu',
'Jakkupatti,Dharmapuri,Tamil Nadu',
'K.Vetrapatti,Dharmapuri,Tamil Nadu',
'Kalasapadi,Dharmapuri,Tamil Nadu',
'Kambainallore,Dharmapuri,Tamil Nadu',
'Kathiripatti,Dharmapuri,Tamil Nadu',
'Katteri,Dharmapuri,Tamil Nadu',
'Keelkuppam,Dharmapuri,Tamil Nadu',
'Keeraipatti,Dharmapuri,Tamil Nadu',
'Kelavalli,Dharmapuri,Tamil Nadu',
'Keraikodahalli,Dharmapuri,Tamil Nadu',
'Kolagampatti,Dharmapuri,Tamil Nadu',
'Kongarapatti,Dharmapuri,Tamil Nadu',
'Kongavembu,Dharmapuri,Tamil Nadu',
'Kottapatti,Dharmapuri,Tamil Nadu',
'Krishnapuram,Dharmapuri,Tamil Nadu',
'Mampatti,Dharmapuri,Tamil Nadu',
'Maruthipatti,Dharmapuri,Tamil Nadu',
'Mobiripatti,Dharmapuri,Tamil Nadu',
'Morappur,Dharmapuri,Tamil Nadu',
'Mukkanahalli,Dharmapuri,Tamil Nadu',
'Murukkampatti,Dharmapuri,Tamil Nadu',
'Naripalli,Dharmapuri,Tamil Nadu',
'Navalai,Dharmapuri,Tamil Nadu',
'Nochikuttai,Dharmapuri,Tamil Nadu',
'Parayapatti,Dharmapuri,Tamil Nadu',
'Parayapattipudur,Dharmapuri,Tamil Nadu',
'Pereripudur,Dharmapuri,Tamil Nadu',
'Periyapatti,Dharmapuri,Tamil Nadu',
'Petatampatti,Dharmapuri,Tamil Nadu',
'Polayampalli,Dharmapuri,Tamil Nadu',
'Poyyapatti,Dharmapuri,Tamil Nadu',
'Sandapatti,Dharmapuri,Tamil Nadu',
'Sikkalur,Dharmapuri,Tamil Nadu',
'Sitrapatti,Dharmapuri,Tamil Nadu',
'Sitteri,Dharmapuri,Tamil Nadu',
'Sittilingi,Dharmapuri,Tamil Nadu',
'Thippampatti,Dharmapuri,Tamil Nadu',
'Thumbalammaepettai,Dharmapuri,Tamil Nadu',
'Tirtamalai,Dharmapuri,Tamil Nadu',
'Vagurappampatti,Dharmapuri,Tamil Nadu',
'Vedakattumaduvu,Dharmapuri,Tamil Nadu',
'Vedarampatti,Dharmapuri,Tamil Nadu',
'Veerappanaickenpatti,Dharmapuri,Tamil Nadu',
'Velanur,Dharmapuri,Tamil Nadu',
'Vellalapatti,Dharmapuri,Tamil Nadu',
'Veppampatti,Dharmapuri,Tamil Nadu',
'Laligam,Dharmapuri,Tamil Nadu',
'Nallampalli,Dharmapuri,Tamil Nadu',
'Thoppur,Dharmapuri,Tamil Nadu',
'Ammanimallapuram,Dharmapuri,Tamil Nadu',
'Attornahalli,Dharmapuri,Tamil Nadu',
'Begarahalli,Dharmapuri,Tamil Nadu',
'Belarahalli,Dharmapuri,Tamil Nadu',
'Bettamugulalam,Dharmapuri,Tamil Nadu',
'Bommanur,Dharmapuri,Tamil Nadu',
'Chikkadornabetta,Dharmapuri,Tamil Nadu',
'Dandukaranahalli,Dharmapuri,Tamil Nadu',
'Erranahalli,Dharmapuri,Tamil Nadu',
'Gujjarahalli,Dharmapuri,Tamil Nadu',
'Hanumanthapuram,Dharmapuri,Tamil Nadu',
'Indur,Dharmapuri,Tamil Nadu',
'Jakkasamudram,Dharmapuri,Tamil Nadu',
'Jertalav,Dharmapuri,Tamil Nadu',
'Jittandahalli,Dharmapuri,Tamil Nadu',
'Kandenahalli,Dharmapuri,Tamil Nadu',
'Kattampatti,Dharmapuri,Tamil Nadu',
'M.Maravadi,Dharmapuri,Tamil Nadu',
'Mahendramangalam,Dharmapuri,Tamil Nadu',
'Mallupatti,Dharmapuri,Tamil Nadu',
'Marandahalli Bazaar,Dharmapuri,Tamil Nadu',
'Marandahalli,Dharmapuri,Tamil Nadu',
'Nammanadahalli,Dharmapuri,Tamil Nadu',
'P.Chettihalli,Dharmapuri,Tamil Nadu',
'Palacode,Dharmapuri,Tamil Nadu',
'Panjapalli,Dharmapuri,Tamil Nadu',
'Pappinaickenpatti,Dharmapuri,Tamil Nadu',
'Poduthampatti,Dharmapuri,Tamil Nadu',
'Pulikarai,Dharmapuri,Tamil Nadu',
'Samanur,Dharmapuri,Tamil Nadu',
'Seeriyanahalli,Dharmapuri,Tamil Nadu',
'Sunnampatti,Dharmapuri,Tamil Nadu',
'Thirumalvadi,Dharmapuri,Tamil Nadu',
'Thumjepalli,Dharmapuri,Tamil Nadu',
'Veppalahalli,Dharmapuri,Tamil Nadu',
'Yelangalpatti,Dharmapuri,Tamil Nadu',
'A.Pallipatti,Dharmapuri,Tamil Nadu',
'Adikarapatti,Dharmapuri,Tamil Nadu',
'Alamelupuram,Dharmapuri,Tamil Nadu',
'Alapuram,Dharmapuri,Tamil Nadu',
'Bairnatham,Dharmapuri,Tamil Nadu',
'Chintalpadi,Dharmapuri,Tamil Nadu',
'Jammanahalli,Dharmapuri,Tamil Nadu',
'Kadathur,Dharmapuri,Tamil Nadu',
'Kalipettai,Dharmapuri,Tamil Nadu',
'Kandagavundanur,Dharmapuri,Tamil Nadu',
'Kathirinaickenahalli,Dharmapuri,Tamil Nadu',
'Kokkarapatti,Dharmapuri,Tamil Nadu',
'Kombur,Dharmapuri,Tamil Nadu',
'Kurubarahalli,Dharmapuri,Tamil Nadu',
'Lakshmapuram,Dharmapuri,Tamil Nadu',
'Maniyambadi,Dharmapuri,Tamil Nadu',
'Menisi,Dharmapuri,Tamil Nadu',
'Molayanur,Dharmapuri,Tamil Nadu',
'Mottankurichi,Dharmapuri,Tamil Nadu',
'Mullikadu,Dharmapuri,Tamil Nadu',
'Obilinaickenahalli,Dharmapuri,Tamil Nadu',
'Pappambadi,Dharmapuri,Tamil Nadu',
'Pappireddipatti,Dharmapuri,Tamil Nadu',
'Pattukonampatti,Dharmapuri,Tamil Nadu',
'Pilparuthi,Dharmapuri,Tamil Nadu',
'Pudupatti,Dharmapuri,Tamil Nadu',
'Ramenahalli,Dharmapuri,Tamil Nadu',
'Ranimookanur,Dharmapuri,Tamil Nadu',
'Regadahalli,Dharmapuri,Tamil Nadu',
'Sillarahalli,Dharmapuri,Tamil Nadu',
'Tenkaraikottai,Dharmapuri,Tamil Nadu',
'Thalanatham,Dharmapuri,Tamil Nadu',
'Thippireddihalli,Dharmapuri,Tamil Nadu',
'Thurinjipatti,Dharmapuri,Tamil Nadu',
'Vaguthupatti,Dharmapuri,Tamil Nadu',
'Venkatadrihalli,Dharmapuri,Tamil Nadu',
'Venkatasamudram,Dharmapuri,Tamil Nadu',
'Veppilaimuthampatti,Dharmapuri,Tamil Nadu',
'Giddanahalli,Dharmapuri,Tamil Nadu',
'Adagapadi,Dharmapuri,Tamil Nadu',
'Ajjanahalli,Dharmapuri,Tamil Nadu',
'Anjehalli,Dharmapuri,Tamil Nadu',
'Arakasanahalli,Dharmapuri,Tamil Nadu',
'Badrahalli,Dharmapuri,Tamil Nadu',
'Bedrahalli,Dharmapuri,Tamil Nadu',
'Bikkampatti,Dharmapuri,Tamil Nadu',
'Biliyanur Agraharam,Dharmapuri,Tamil Nadu',
'Chetthalli,Dharmapuri,Tamil Nadu',
'Chinnampalli,Dharmapuri,Tamil Nadu',
'Dalavaihalli,Dharmapuri,Tamil Nadu',
'Donnakuttahalli,Dharmapuri,Tamil Nadu',
'Errapayanahalli,Dharmapuri,Tamil Nadu',
'Erupalli,Dharmapuri,Tamil Nadu',
'Gendenahalli,Dharmapuri,Tamil Nadu',
'Hogenakkal,Dharmapuri,Tamil Nadu',
'Kadagathur,Dharmapuri,Tamil Nadu',
'Kalappambadi,Dharmapuri,Tamil Nadu',
'Konangihalli,Dharmapuri,Tamil Nadu',
'Koothapadi,Dharmapuri,Tamil Nadu',
'Makkanur,Dharmapuri,Tamil Nadu',
'Manchinayakkanahalli,Dharmapuri,Tamil Nadu',
'Mangarai,Dharmapuri,Tamil Nadu',
'Manjarahalli,Dharmapuri,Tamil Nadu',
'Nagamarai,Dharmapuri,Tamil Nadu',
'Nagarkudal,Dharmapuri,Tamil Nadu',
'Nettadahalli,Dharmapuri,Tamil Nadu',
'Noolahalli,Dharmapuri,Tamil Nadu',
'Onnappagoundanahalli,Dharmapuri,Tamil Nadu',
'P.Agraharam,Dharmapuri,Tamil Nadu',
'Padi,Dharmapuri,Tamil Nadu',
'Palavadi,Dharmapuri,Tamil Nadu',
'Paupparapatti,Dharmapuri,Tamil Nadu',
'Pennagaram,Dharmapuri,Tamil Nadu',
'Perumbalai,Dharmapuri,Tamil Nadu',
'Pikkili,Dharmapuri,Tamil Nadu',
'Pungunatham,Dharmapuri,Tamil Nadu',
'Rajagollahalli,Dharmapuri,Tamil Nadu',
'Ramagondahalli,Dharmapuri,Tamil Nadu',
'Sathiyanathapuram,Dharmapuri,Tamil Nadu',
'Selliampatti,Dharmapuri,Tamil Nadu',
'Senganur,Dharmapuri,Tamil Nadu',
'Sogathur,Dharmapuri,Tamil Nadu',
'Somenahalli,Dharmapuri,Tamil Nadu',
'Sunchalnatham,Dharmapuri,Tamil Nadu',
'Vattuvanahalli,Dharmapuri,Tamil Nadu',
'Soolapuram,Karur,Tamil Nadu',
'19 Pudur,Dindigul,Tamil Nadu',
'A.Nadupatti,Dindigul,Tamil Nadu',
'Achanampatti,Dindigul,Tamil Nadu',
'Adalur,Dindigul,Tamil Nadu',
'Adiyanuthu,Dindigul,Tamil Nadu',
'Agaram,Dindigul,Tamil Nadu',
'Alagapuri,Dindigul,Tamil Nadu',
'Alamarathupatti,Dindigul,Tamil Nadu',
'Alambadi,Dindigul,Tamil Nadu',
'Alambadimines,Dindigul,Tamil Nadu',
'Amarapundi,Dindigul,Tamil Nadu',
'Ambathurai,Dindigul,Tamil Nadu',
'Ambathurai R.S,Dindigul,Tamil Nadu',
'Ambilikai,Dindigul,Tamil Nadu',
'Ammapatti,Dindigul,Tamil Nadu',
'Ammapatti,Dindigul,Tamil Nadu',
'Ammayanaickanur,Dindigul,Tamil Nadu',
'Anaipatti,Dindigul,Tamil Nadu',
'Anaipatti,Dindigul,Tamil Nadu',
'Andipatti,Dindigul,Tamil Nadu',
'Angunagar,Dindigul,Tamil Nadu',
'Anjukulipatti,Dindigul,Tamil Nadu',
'Appanuthu,Dindigul,Tamil Nadu',
'Aranmanaivalasu,Dindigul,Tamil Nadu',
'Arasappapillaipatti,Dindigul,Tamil Nadu',
'Athikombai,Dindigul,Tamil Nadu',
'Attur,Dindigul,Tamil Nadu',
'Avichipatti,Dindigul,Tamil Nadu',
'Avilipatti,Dindigul,Tamil Nadu',
'Ayakudi,Dindigul,Tamil Nadu',
'Ayyalur,Dindigul,Tamil Nadu',
'Ayyankottai,Dindigul,Tamil Nadu',
'Balakrishnapurampudur,Dindigul,Tamil Nadu',
'Balasamudram,Dindigul,Tamil Nadu',
'Batlagundu Bazar,Dindigul,Tamil Nadu',
'Batlagundu,Dindigul,Tamil Nadu',
'Begampur,Dindigul,Tamil Nadu',
'Bharathipuram,Dindigul,Tamil Nadu',
'Bodikamanvadi,Dindigul,Tamil Nadu',
'Boduvarpatti,Dindigul,Tamil Nadu',
'Bojanampatti,Dindigul,Tamil Nadu',
'Boothagudi,Dindigul,Tamil Nadu',
'Chatirapatti,Dindigul,Tamil Nadu',
'Chatrapatti,Dindigul,Tamil Nadu',
'Chettiapatti,Dindigul,Tamil Nadu',
'Chinnakalayamputhur,Dindigul,Tamil Nadu',
'Chinnakkampatti,Dindigul,Tamil Nadu',
'Chinnalapatti,Dindigul,Tamil Nadu',
'Chinnamandavadi,Dindigul,Tamil Nadu',
'Chittoor,Dindigul,Tamil Nadu',
'D.Gudalur,Dindigul,Tamil Nadu',
'Dasaripatti,Dindigul,Tamil Nadu',
'Devarappanpatti,Dindigul,Tamil Nadu',
'Devathur,Dindigul,Tamil Nadu',
'Dharmathupatti,Dindigul,Tamil Nadu',
'Dindigul Bus Stand,Dindigul,Tamil Nadu',
'Dindigul Collectorate,Dindigul,Tamil Nadu',
'Dindigul East,Dindigul,Tamil Nadu',
'Dindigul Fort,Dindigul,Tamil Nadu',
'Dindigul H.O,Dindigul,Tamil Nadu',
'Dindigul North,Dindigul,Tamil Nadu',
'Dindigul Santhaipettai,Dindigul,Tamil Nadu',
'Dindigul South,Dindigul,Tamil Nadu',
'Emakkalapuram,Dindigul,Tamil Nadu',
'Eriyodu,Dindigul,Tamil Nadu',
'Erramanaickenpatti,Dindigul,Tamil Nadu',
'Ethilodu,Dindigul,Tamil Nadu',
'G.Thummalapatti,Dindigul,Tamil Nadu',
'Gandhigram,Dindigul,Tamil Nadu',
'Gurunathanaickanur,Dindigul,Tamil Nadu',
'Guziliamparai,Dindigul,Tamil Nadu',
'Hanumantharayankottai,Dindigul,Tamil Nadu',
'I.Vadipatti,Dindigul,Tamil Nadu',
'Idayakottai,Dindigul,Tamil Nadu',
'Iyyampalayam,Dindigul,Tamil Nadu',
'Jambudarikottai,Dindigul,Tamil Nadu',
'Jambuliapatti,Dindigul,Tamil Nadu',
'Javadhupatti,Dindigul,Tamil Nadu',
'Jenankottai,Dindigul,Tamil Nadu',
'Jogipatti,Dindigul,Tamil Nadu',
'Jothampatti,Dindigul,Tamil Nadu',
'K.Ayyapatti,Dindigul,Tamil Nadu',
'K.C.Patti,Dindigul,Tamil Nadu',
'K.Keeranur,Dindigul,Tamil Nadu',
'K.Pudukottai,Dindigul,Tamil Nadu',
'K.Rajathanikottai,Dindigul,Tamil Nadu',
'K.Singarakottai,Dindigul,Tamil Nadu',
'Kalanampatti,Dindigul,Tamil Nadu',
'Kalanjipatti,Dindigul,Tamil Nadu',
'Kalayamputhur,Dindigul,Tamil Nadu',
'Kalikkampatti,Dindigul,Tamil Nadu',
'Kallimandayam,Dindigul,Tamil Nadu',
'Kallipatti,Dindigul,Tamil Nadu',
'Kamanur,Dindigul,Tamil Nadu',
'Kamatchipuram,Dindigul,Tamil Nadu',
'Kambiliampatti,Dindigul,Tamil Nadu',
'Kanakkanpatti,Dindigul,Tamil Nadu',
'Kanalkadu,Dindigul,Tamil Nadu',
'Kanapadi,Dindigul,Tamil Nadu',
'Kanavoipatti,Dindigul,Tamil Nadu',
'Kanavoipatti,Dindigul,Tamil Nadu',
'Kanniapuram,Dindigul,Tamil Nadu',
'Kannivadi,Dindigul,Tamil Nadu',
'Kappalapatti,Dindigul,Tamil Nadu',
'Kappiliapatti,Dindigul,Tamil Nadu',
'Kariampatti,Dindigul,Tamil Nadu',
'Kariampatti,Dindigul,Tamil Nadu',
'Karikali,Dindigul,Tamil Nadu',
'Karikaranpudur,Dindigul,Tamil Nadu',
'Kasampatti,Dindigul,Tamil Nadu',
'Kasavanampatti,Dindigul,Tamil Nadu',
'Kasipalayam,Dindigul,Tamil Nadu',
'Kattakamanpatti,Dindigul,Tamil Nadu',
'Kattakoothanpatti,Dindigul,Tamil Nadu',
'Kattupatti,Dindigul,Tamil Nadu',
'Kavalapatti,Dindigul,Tamil Nadu',
'Kaveriammapatti,Dindigul,Tamil Nadu',
'Kaviakadu,Dindigul,Tamil Nadu',
'Kavunji,Dindigul,Tamil Nadu',
'Kazhutharukkipalayam,Dindigul,Tamil Nadu',
'Keeranur(MA),Dindigul,Tamil Nadu',
'Kethaiyarumbu,Dindigul,Tamil Nadu',
'Kilanavayal,Dindigul,Tamil Nadu',
'Kilavarai,Dindigul,Tamil Nadu',
'Kodagipatti,Dindigul,Tamil Nadu',
'Kodaikanal Observatory,Dindigul,Tamil Nadu',
'Kodaikanal,Dindigul,Tamil Nadu',
'Kodaimangalam,Dindigul,Tamil Nadu',
'Kodairoad R.S.,Dindigul,Tamil Nadu',
'Kodalangadu,Dindigul,Tamil Nadu',
'Kodanginaickenpatti,Dindigul,Tamil Nadu',
'Kodangipatti,Dindigul,Tamil Nadu',
'Kolinjipatti,Dindigul,Tamil Nadu',
'Kollapatti,Dindigul,Tamil Nadu',
'Kollapatti,Dindigul,Tamil Nadu',
'Komberipatti,Dindigul,Tamil Nadu',
'Konapatti,Dindigul,Tamil Nadu',
'Konur,Dindigul,Tamil Nadu',
'Kookal,Dindigul,Tamil Nadu',
'Koovakkapatti,Dindigul,Tamil Nadu',
'Koovanuthu,Dindigul,Tamil Nadu',
'Kosavapatti,Dindigul,Tamil Nadu',
'Kosikurichi,Dindigul,Tamil Nadu',
'Kothayam,Dindigul,Tamil Nadu',
'Kottaipatti,Dindigul,Tamil Nadu',
'Kottaiyur,Dindigul,Tamil Nadu',
'Kottanatham,Dindigul,Tamil Nadu',
'Kottapatti,Dindigul,Tamil Nadu',
'Kottathurai,Dindigul,Tamil Nadu',
'Kottur,Dindigul,Tamil Nadu',
'Kovilammapatti,Dindigul,Tamil Nadu',
'Kovilur,Dindigul,Tamil Nadu',
'Kovilur,Dindigul,Tamil Nadu',
'Kulathupatti,Dindigul,Tamil Nadu',
'Kulathur,Dindigul,Tamil Nadu',
'Kullichettipatti,Dindigul,Tamil Nadu',
'Kumbaraiyur,Dindigul,Tamil Nadu',
'Kumbur,Dindigul,Tamil Nadu',
'Kumbur,Dindigul,Tamil Nadu',
'Kunnuvarankottai,Dindigul,Tamil Nadu',
'Kuppammalpatti,Dindigul,Tamil Nadu',
'Kusavapatti,Dindigul,Tamil Nadu',
'Kuthiluppai,Dindigul,Tamil Nadu',
'Kuttampundi,Dindigul,Tamil Nadu',
'Kuttathupatti,Dindigul,Tamil Nadu',
'Kuttupatti,Dindigul,Tamil Nadu',
'Kuzhipatti,Dindigul,Tamil Nadu',
'Landakottai,Dindigul,Tamil Nadu',
'Lingavadi,Dindigul,Tamil Nadu',
'M.N.Patti,Dindigul,Tamil Nadu',
'M.Vadipatti,Dindigul,Tamil Nadu',
'Ma.Athappanpatti,Dindigul,Tamil Nadu',
'Madur,Dindigul,Tamil Nadu',
'Mallanampatti,Dindigul,Tamil Nadu',
'Mallapuram,Dindigul,Tamil Nadu',
'Mallayapuram,Dindigul,Tamil Nadu',
'Malvarpatti,Dindigul,Tamil Nadu',
'Manakkattur,Dindigul,Tamil Nadu',
'Mandavadi,Dindigul,Tamil Nadu',
'Mangarai,Dindigul,Tamil Nadu',
'Manjalpirappu,Dindigul,Tamil Nadu',
'Manjanaickenpatti,Dindigul,Tamil Nadu',
'Mannavanur,Dindigul,Tamil Nadu',
'Manur,Dindigul,Tamil Nadu',
'Marambadi,Dindigul,Tamil Nadu',
'Marichilambu,Dindigul,Tamil Nadu',
'Markampatti,Dindigul,Tamil Nadu',
'Markkampatti,Dindigul,Tamil Nadu',
'Marunoothu,Dindigul,Tamil Nadu',
'Maruthanathi-project,Dindigul,Tamil Nadu',
'Melkaraipatti,Dindigul,Tamil Nadu',
'Mengles Road,Dindigul,Tamil Nadu',
'Mettupatti,Dindigul,Tamil Nadu',
'Mettupatti,Dindigul,Tamil Nadu',
'Metturgate,Dindigul,Tamil Nadu',
'Micheal Palayam,Dindigul,Tamil Nadu',
'Moolaiyar,Dindigul,Tamil Nadu',
'Moongilpatti,Dindigul,Tamil Nadu',
'Morepatti,Dindigul,Tamil Nadu',
'Mottanampatti,Dindigul,Tamil Nadu',
'Mulaiyur,Dindigul,Tamil Nadu',
'Mullipadi,Dindigul,Tamil Nadu',
'Munnilakottai,Dindigul,Tamil Nadu',
'Murunellikottai,Dindigul,Tamil Nadu',
'Musuvanuthu,Dindigul,Tamil Nadu',
'Muthalagupatti,Dindigul,Tamil Nadu',
'Muthanampattipudur,Dindigul,Tamil Nadu',
'Muthunaickenpatti,Dindigul,Tamil Nadu',
'N.G.O.Colony,Dindigul,Tamil Nadu',
'N.Panjampatti,Dindigul,Tamil Nadu',
'N.Paraipatti,Dindigul,Tamil Nadu',
'N.Pudupatti,Dindigul,Tamil Nadu',
'Nadakottai,Dindigul,Tamil Nadu',
'Nadumandalam,Dindigul,Tamil Nadu',
'Nadupatti,Dindigul,Tamil Nadu',
'Naduvanur,Dindigul,Tamil Nadu',
'Nagalnagar,Dindigul,Tamil Nadu',
'Nagayakottai,Dindigul,Tamil Nadu',
'Nallamanaickenpatti,Dindigul,Tamil Nadu',
'Nallamanarkottai,Dindigul,Tamil Nadu',
'Nallurkadu,Dindigul,Tamil Nadu',
'Nalupulikottai,Dindigul,Tamil Nadu',
'Narasingapuram,Dindigul,Tamil Nadu',
'Narikalpatti,Dindigul,Tamil Nadu',
'Nariyuthu,Dindigul,Tamil Nadu',
'Natham East,Dindigul,Tamil Nadu',
'Natham Koilpatti,Dindigul,Tamil Nadu',
'Natham,Dindigul,Tamil Nadu',
'Nathambazar,Dindigul,Tamil Nadu',
'Nathapatti,Dindigul,Tamil Nadu',
'Neelamalaikottai,Dindigul,Tamil Nadu',
'Neikkarapatti,Dindigul,Tamil Nadu',
'Nellur,Dindigul,Tamil Nadu',
'Nilakottai H.O,Dindigul,Tamil Nadu',
'Nuthalapuram,Dindigul,Tamil Nadu',
'Odaipatti,Dindigul,Tamil Nadu',
'Oddanchatram North,Dindigul,Tamil Nadu',
'Oddanchatram,Dindigul,Tamil Nadu',
'Old Batlagundu,Dindigul,Tamil Nadu',
'Old Oddanchatram,Dindigul,Tamil Nadu',
'Oruthattu,Dindigul,Tamil Nadu',
'Ottupatti,Dindigul,Tamil Nadu',
'Pachalur,Dindigul,Tamil Nadu',
'Pachamalayankottai,Dindigul,Tamil Nadu',
'Padiyur,Dindigul,Tamil Nadu',
'Paganattam,Dindigul,Tamil Nadu',
'Palakkanuthu,Dindigul,Tamil Nadu',
'Palani Bazaar,Dindigul,Tamil Nadu',
'Palani Devastanam,Dindigul,Tamil Nadu',
'Palani East,Dindigul,Tamil Nadu',
'Palani H.O,Dindigul,Tamil Nadu',
'Palani North,Dindigul,Tamil Nadu',
'Palani R.S,Dindigul,Tamil Nadu',
'Palani West,Dindigul,Tamil Nadu',
'Palappanpatti,Dindigul,Tamil Nadu',
'Palarparundalar Dam,Dindigul,Tamil Nadu',
'Palayakannivadi,Dindigul,Tamil Nadu',
'Palayam,Dindigul,Tamil Nadu',
'Palayankottai,Dindigul,Tamil Nadu',
'Pallapatti,Dindigul,Tamil Nadu',
'Pallathukalvai,Dindigul,Tamil Nadu',
'Pambarpuram,Dindigul,Tamil Nadu',
'Pandianagar,Dindigul,Tamil Nadu',
'Pandithakaranur,Dindigul,Tamil Nadu',
'Pandrimalai,Dindigul,Tamil Nadu',
'Pannaikadu,Dindigul,Tamil Nadu',
'Pannaipatti,Dindigul,Tamil Nadu',
'Pappampatti,Dindigul,Tamil Nadu',
'Pappanampatti,Dindigul,Tamil Nadu',
'Paraipatti,Dindigul,Tamil Nadu',
'Paruthiyur,Dindigul,Tamil Nadu',
'Pattiveeranpatti,Dindigul,Tamil Nadu',
'Pazhamputhur,Dindigul,Tamil Nadu',
'Periakuzhipatti,Dindigul,Tamil Nadu',
'Perichipalayam,Dindigul,Tamil Nadu',
'Periyakalayamputhur,Dindigul,Tamil Nadu',
'Periyakottai,Dindigul,Tamil Nadu',
'Periyakottai,Dindigul,Tamil Nadu',
'Periyamottanuthu,Dindigul,Tamil Nadu',
'Periyur,Dindigul,Tamil Nadu',
'Perumalkoilpatti,Dindigul,Tamil Nadu',
'Perumalnaickenvalasu,Dindigul,Tamil Nadu',
'Perumalpudur,Dindigul,Tamil Nadu',
'Perumbarai,Dindigul,Tamil Nadu',
'Pethanaickenpatti,Dindigul,Tamil Nadu',
'Pilathu,Dindigul,Tamil Nadu',
'Pillamanaickenpatti,Dindigul,Tamil Nadu',
'Pillayarnatham,Dindigul,Tamil Nadu',
'Pillayarnatham,Dindigul,Tamil Nadu',
'Pithalaipatti,Dindigul,Tamil Nadu',
'Polur,Dindigul,Tamil Nadu',
'Ponnimandurai,Dindigul,Tamil Nadu',
'Poolampati,Dindigul,Tamil Nadu',
'Poombarai,Dindigul,Tamil Nadu',
'Poosaripatti,Dindigul,Tamil Nadu',
'Poothampatti,Dindigul,Tamil Nadu',
'Porulur,Dindigul,Tamil Nadu',
'Puduchatram,Dindigul,Tamil Nadu',
'Pudur(NTM),Dindigul,Tamil Nadu',
'Pudurchettiapatti,Dindigul,Tamil Nadu',
'Pulathur,Dindigul,Tamil Nadu',
'Puliamarathukottai,Dindigul,Tamil Nadu',
'Puliampatti,Dindigul,Tamil Nadu',
'Puliyurnatham,Dindigul,Tamil Nadu',
'Pundi,Dindigul,Tamil Nadu',
'Punnapatti,Dindigul,Tamil Nadu',
'Pushpathur,Dindigul,Tamil Nadu',
'Puthuputhur,Dindigul,Tamil Nadu',
'Puthur,Dindigul,Tamil Nadu',
'R.Iyyampalayam,Dindigul,Tamil Nadu',
'R.Kombai,Dindigul,Tamil Nadu',
'R.Pudukottai,Dindigul,Tamil Nadu',
'R.Vellodu,Dindigul,Tamil Nadu',
'Ragalapuram,Dindigul,Tamil Nadu',
'Rajakkapatti,Dindigul,Tamil Nadu',
'Rajampatti,Dindigul,Tamil Nadu',
'Rajathanikottai,Dindigul,Tamil Nadu',
'Ramagiri,Dindigul,Tamil Nadu',
'Ramarajapuram,Dindigul,Tamil Nadu',
'Reddiapatti,Dindigul,Tamil Nadu',
'Reddiapatti,Dindigul,Tamil Nadu',
'Reddiapatti,Dindigul,Tamil Nadu',
'Reddiarchatram,Dindigul,Tamil Nadu',
'S.R.G.Pudur,Dindigul,Tamil Nadu',
'S.Vadipatti,Dindigul,Tamil Nadu',
'Sadayampatti,Dindigul,Tamil Nadu',
'Sakkampatti,Dindigul,Tamil Nadu',
'Sakkiliankodai,Dindigul,Tamil Nadu',
'Samiyarpatti,Dindigul,Tamil Nadu',
'Samudrapatti,Dindigul,Tamil Nadu',
'Sanarpatti,Dindigul,Tamil Nadu',
'Sandaiyur,Dindigul,Tamil Nadu',
'Sangalpatty,Dindigul,Tamil Nadu',
'Sangampalayam,Dindigul,Tamil Nadu',
'Sangareddikottai,Dindigul,Tamil Nadu',
'Sankarapuram,Dindigul,Tamil Nadu',
'Sathampadi,Dindigul,Tamil Nadu',
'Sedapatti,Dindigul,Tamil Nadu',
'Sellamanthadi,Dindigul,Tamil Nadu',
'Sembatti,Dindigul,Tamil Nadu',
'Sendurai,Dindigul,Tamil Nadu',
'Sengurichi,Dindigul,Tamil Nadu',
'Senkattampatti,Dindigul,Tamil Nadu',
'Sennamanaickenpatti,Dindigul,Tamil Nadu',
'Servaikaranpatti,Dindigul,Tamil Nadu',
'Sethur,Dindigul,Tamil Nadu',
'Settinaickenpatti,Dindigul,Tamil Nadu',
'Sevugampatti,Dindigul,Tamil Nadu',
'Silaipadi,Dindigul,Tamil Nadu',
'Silukkuvarpatti,Dindigul,Tamil Nadu',
'Siluvathur,Dindigul,Tamil Nadu',
'Silvarpatti,Dindigul,Tamil Nadu',
'Sindalagundu,Dindigul,Tamil Nadu',
'Singarakottai.V.,Dindigul,Tamil Nadu',
'Sirugudi,Dindigul,Tamil Nadu',
'Sirumalai,Dindigul,Tamil Nadu',
'Sirumalaipudur,Dindigul,Tamil Nadu',
'Sirunaickenpatti,Dindigul,Tamil Nadu',
'Sirunaickenpatti,Dindigul,Tamil Nadu',
'Sitharevu,Dindigul,Tamil Nadu',
'Sithargalnatham,Dindigul,Tamil Nadu',
'Sithayankottai,Dindigul,Tamil Nadu',
'Sithuvarpatti,Dindigul,Tamil Nadu',
'Solaikadu,Dindigul,Tamil Nadu',
'Sreerankattupatti,Dindigul,Tamil Nadu',
'Sriramapuram,Dindigul,Tamil Nadu',
'Sriramapuram,Dindigul,Tamil Nadu',
'St.Marys Estate,Dindigul,Tamil Nadu',
'Sukkampatti,Dindigul,Tamil Nadu',
'Sukkampatti,Dindigul,Tamil Nadu',
'Sullerumbu,Dindigul,Tamil Nadu',
'T.Panjampatti,Dindigul,Tamil Nadu',
'T.Pudupatti,Dindigul,Tamil Nadu',
'T.Vadugapatti,Dindigul,Tamil Nadu',
'Tadicombu,Dindigul,Tamil Nadu',
'Tandigudi,Dindigul,Tamil Nadu',
'Teppakulathupatti,Dindigul,Tamil Nadu',
'Thalaiyuthu,Dindigul,Tamil Nadu',
'Thamaraikulam,Dindigul,Tamil Nadu',
'Thamaraipadi,Dindigul,Tamil Nadu',
'Thangachiammapatti,Dindigul,Tamil Nadu',
'Thathanaickenpatti,Dindigul,Tamil Nadu',
'Thattarapatti,Dindigul,Tamil Nadu',
'Thavasimadai,Dindigul,Tamil Nadu',
'Thazhakadai,Dindigul,Tamil Nadu',
'Theethagoundenvalasu,Dindigul,Tamil Nadu',
'Thennampatti,Dindigul,Tamil Nadu',
'Theppathupatti,Dindigul,Tamil Nadu',
'Thettupatti,Dindigul,Tamil Nadu',
'Thimmanallur,Dindigul,Tamil Nadu',
'Thonimalai,Dindigul,Tamil Nadu',
'Thoppampatti,Dindigul,Tamil Nadu',
'Thottanampatti,Dindigul,Tamil Nadu',
'Thottanuthu,Dindigul,Tamil Nadu',
'Thozhipatti,Dindigul,Tamil Nadu',
'Thummalagundu,Dindigul,Tamil Nadu',
'Thummalapatti,Dindigul,Tamil Nadu',
'Tirukoornam,Dindigul,Tamil Nadu',
'Tirumalaigoundenvalasu,Dindigul,Tamil Nadu',
'Ulliyakottai,Dindigul,Tamil Nadu',
'Undarpatti,Dindigul,Tamil Nadu',
'Uralipatti,Dindigul,Tamil Nadu',
'Usilampatti,Dindigul,Tamil Nadu',
'Uthupatti,Dindigul,Tamil Nadu',
'V.S.K.Kurumbapatti,Dindigul,Tamil Nadu',
'Vadagadu,Dindigul,Tamil Nadu',
'Vadakattupudur,Dindigul,Tamil Nadu',
'Vadamadurai,Dindigul,Tamil Nadu',
'Vadugampadi,Dindigul,Tamil Nadu',
'Vagarai,Dindigul,Tamil Nadu',
'Vaithilathoppampatti,Dindigul,Tamil Nadu',
'Vakkampatti,Dindigul,Tamil Nadu',
'Valayapatti,Dindigul,Tamil Nadu',
'Vallipatti,Dindigul,Tamil Nadu',
'Vanikarai,Dindigul,Tamil Nadu',
'Vannampatti,Dindigul,Tamil Nadu',
'Varthamanathi Dam Project,Dindigul,Tamil Nadu',
'Vathipatti,Dindigul,Tamil Nadu',
'Vedasandur,Dindigul,Tamil Nadu',
'Veerakkal,Dindigul,Tamil Nadu',
'Veeralapatti,Dindigul,Tamil Nadu',
'Veerasinnnampatti,Dindigul,Tamil Nadu',
'Velampatti,Dindigul,Tamil Nadu',
'Velampatti,Dindigul,Tamil Nadu',
'Vellodu,Dindigul,Tamil Nadu',
'Velvarkottai,Dindigul,Tamil Nadu',
'Vembarpatti,Dindigul,Tamil Nadu',
'Vengalapatti,Dindigul,Tamil Nadu',
'Venkatasrikottai,Dindigul,Tamil Nadu',
'Veriyappur,Dindigul,Tamil Nadu',
'Vilampatti,Dindigul,Tamil Nadu',
'Viralimayanpatti,Dindigul,Tamil Nadu',
'Viralipatti,Dindigul,Tamil Nadu',
'Viralipatti,Dindigul,Tamil Nadu',
'Virupatchi,Dindigul,Tamil Nadu',
'Viruveedu,Dindigul,Tamil Nadu',
'Yeluvanampatti,Dindigul,Tamil Nadu',
'Adukkam,Dindigul,Tamil Nadu',
'Attuvampatti,Dindigul,Tamil Nadu',
'Kumburvayal,Dindigul,Tamil Nadu',
'Machur,Dindigul,Tamil Nadu',
'Melpallam,Dindigul,Tamil Nadu',
'Naidupuram,Dindigul,Tamil Nadu',
'Palamalai,Dindigul,Tamil Nadu',
'Pallangi,Dindigul,Tamil Nadu',
'Perumalmalai,Dindigul,Tamil Nadu',
'Perumpallam,Dindigul,Tamil Nadu',
'Prakasapuram,Dindigul,Tamil Nadu',
'Shenbaganur,Dindigul,Tamil Nadu',
'Srinivasapuram,Dindigul,Tamil Nadu',
'Vadagounji,Dindigul,Tamil Nadu',
'Vellagavi,Dindigul,Tamil Nadu',
'Vilpatti,Dindigul,Tamil Nadu',
'Kalladipatti,Dindigul,Tamil Nadu',
'Kullalagundu,Dindigul,Tamil Nadu',
'Malayagondanpatti,Dindigul,Tamil Nadu',
'Pallapatti,Dindigul,Tamil Nadu',
'Devinaickenpatti,Dindigul,Tamil Nadu',
'Kalvarpatti,Dindigul,Tamil Nadu',
'Kuttam,Dindigul,Tamil Nadu',
'Minukampatti,Dindigul,Tamil Nadu',
'Poonuthu,Dindigul,Tamil Nadu',
'Viruthalaipatti,Dindigul,Tamil Nadu',
'Alampalayam,Tirupur,Tamil Nadu',
'Bellampatti,Tirupur,Tamil Nadu',
'Devarajapattinam,Tirupur,Tamil Nadu',
'Emmammpoondi,Tirupur,Tamil Nadu',
'Kambiliampatti,Tirupur,Tamil Nadu',
'Kokkampalayam,Tirupur,Tamil Nadu',
'Kundadam,Tirupur,Tamil Nadu',
'Mangalapatti,Tirupur,Tamil Nadu',
'Muthugoundenpalayam,Tirupur,Tamil Nadu',
'Muthur,Tirupur,Tamil Nadu',
'Nallimadam,Tirupur,Tamil Nadu',
'Nochipalayam,Tirupur,Tamil Nadu',
'Olalakoil,Tirupur,Tamil Nadu',
'Pothampalayam,Tirupur,Tamil Nadu',
'Pulipar,Tirupur,Tamil Nadu',
'Punganthurai,Tirupur,Tamil Nadu',
'Punjaithamaraikulam,Tirupur,Tamil Nadu',
'Rudravathi,Tirupur,Tamil Nadu',
'Sadayapalayam,Tirupur,Tamil Nadu',
'Savakattupalayam,Tirupur,Tamil Nadu',
'Surianallur,Tirupur,Tamil Nadu',
'Thayamapalayam,Tirupur,Tamil Nadu',
'Vellierichal,Tirupur,Tamil Nadu',
'Kalipalayam,Tirupur,Tamil Nadu',
'Sirukinar,Tirupur,Tamil Nadu',
'Vengampur,Erode,Tamil Nadu',
'Nandavanampalayam,Tirupur,Tamil Nadu',
'Kilankundal,Tirupur,Tamil Nadu',
'Ponnivadi,Tirupur,Tamil Nadu',
'Achur,Tirupur,Tamil Nadu',
'Alampalayam,Tirupur,Tamil Nadu',
'Alangiam,Tirupur,Tamil Nadu',
'Anangur,Karur,Tamil Nadu',
'Arikkaranvalasu,Karur,Tamil Nadu',
'Bagavankoil,Tirupur,Tamil Nadu',
'Bommanallur,Tirupur,Tamil Nadu',
'Chinnamarudur,Tirupur,Tamil Nadu',
'Chinnaputhur,Tirupur,Tamil Nadu',
'Chitravuthampalayam,Tirupur,Tamil Nadu',
'Cholakkadai Street,Tirupur,Tamil Nadu',
'Dalavoipattinam,Tirupur,Tamil Nadu',
'Dasarapatti,Tirupur,Tamil Nadu',
'Dharapuram Bazaar,Tirupur,Tamil Nadu',
'Dharapuram H.O,Tirupur,Tamil Nadu',
'Dharapuram South,Tirupur,Tamil Nadu',
'Edakkalpadi,Karur,Tamil Nadu',
'Ellisnagar,Tirupur,Tamil Nadu',
'Erachapadi,Karur,Tamil Nadu',
'Erasinampalayam,Tirupur,Tamil Nadu',
'Gethalrev,Tirupur,Tamil Nadu',
'Govindapuram,Tirupur,Tamil Nadu',
'Hanumanthapuram,Tirupur,Tamil Nadu',
'Kallivalasu,Tirupur,Tamil Nadu',
'Kannivadi,Karur,Tamil Nadu',
'Karaiyur,Tirupur,Tamil Nadu',
'Kolathupalayam,Tirupur,Tamil Nadu',
'Kolinjivadi,Tirupur,Tamil Nadu',
'Komarapalayam,Tirupur,Tamil Nadu',
'Koneripatti,Tirupur,Tamil Nadu',
'Kottaimulanur,Tirupur,Tamil Nadu',
'Kullaipalayam,Tirupur,Tamil Nadu',
'Malamedu,Karur,Tamil Nadu',
'Mambadi,Tirupur,Tamil Nadu',
'Manakadavu,Tirupur,Tamil Nadu',
'Mettuvalasu,Tirupur,Tamil Nadu',
'Mulanur,Tirupur,Tamil Nadu',
'Nagalingapuram,Tirupur,Tamil Nadu',
'Nallampalayam,Tirupur,Tamil Nadu',
'Nanjaithalaiyur,Karur,Tamil Nadu',
'Nanjiampalayam,Tirupur,Tamil Nadu',
'Nanjundapuram,Tirupur,Tamil Nadu',
'Nathachennigoundenvalasu,Tirupur,Tamil Nadu',
'Nathapalayam,Tirupur,Tamil Nadu',
'Orathupalyaam,Tirupur,Tamil Nadu',
'Pattuthurai,Tirupur,Tamil Nadu',
'Peramium,Tirupur,Tamil Nadu',
'Pichakalpatti,Tirupur,Tamil Nadu',
'Ponnapuram,Tirupur,Tamil Nadu',
'Puliampatti,Tirupur,Tamil Nadu',
'Rakkiavalasu,Tirupur,Tamil Nadu',
'Rettalavalasu,Tirupur,Tamil Nadu',
'Sankarandampalayam,Tirupur,Tamil Nadu',
'Selampalayam,Tirupur,Tamil Nadu',
'Semmangarai,Tirupur,Tamil Nadu',
'Therpatti,Tirupur,Tamil Nadu',
'Thoppampatti,Tirupur,Tamil Nadu',
'Thottiapalayam,Tirupur,Tamil Nadu',
'Thurambadi,Tirupur,Tamil Nadu',
'Undarapatti,Tirupur,Tamil Nadu',
'Vadugapatti,Tirupur,Tamil Nadu',
'Veerajimangalam,Tirupur,Tamil Nadu',
'Velampundi,Karur,Tamil Nadu',
'Vellavavipudur,Tirupur,Tamil Nadu',
'Nelali,Tirupur,Tamil Nadu',
'A.Sembulichampalayam,Erode,Tamil Nadu',
'Akkaraikodiveri,Erode,Tamil Nadu',
'Alampalayam,Erode,Tamil Nadu',
'Alathur,Erode,Tamil Nadu',
'Alingiam(Gobi),Erode,Tamil Nadu',
'Alukuli,Erode,Tamil Nadu',
'Ammankoil,Erode,Tamil Nadu',
'Ammapettai,Erode,Tamil Nadu',
'Anaipalayam,Erode,Tamil Nadu',
'Anjanur(Vemandampalayam),Erode,Tamil Nadu',
'Anjur,Erode,Tamil Nadu',
'Anthiyur,Erode,Tamil Nadu',
'Appakudal,Erode,Tamil Nadu',
'Arachalur,Erode,Tamil Nadu',
'Arakkankottai,Erode,Tamil Nadu',
'Arasur,Erode,Tamil Nadu',
'Atavanani Hanumanpalli,Erode,Tamil Nadu',
'Athani,Erode,Tamil Nadu',
'Athiyur,Erode,Tamil Nadu',
'Avalpundurai,Erode,Tamil Nadu',
'Avudayarparai,Erode,Tamil Nadu',
'Ayalur,Erode,Tamil Nadu',
'Ayyampalayam,Erode,Tamil Nadu',
'Ayyampalayam,Erode,Tamil Nadu',
'Bargur-anthiyur,Erode,Tamil Nadu',
'Basuvanapuram,Erode,Tamil Nadu',
'Basuvapatti,Erode,Tamil Nadu',
'Bhavani Cutcherry,Erode,Tamil Nadu',
'Bhavani H.O,Erode,Tamil Nadu',
'Bhavani Kudal,Erode,Tamil Nadu',
'Brahmadesam,Erode,Tamil Nadu',
'Budapadi,Erode,Tamil Nadu',
'Chennampatti,Erode,Tamil Nadu',
'Chennimalai,Erode,Tamil Nadu',
'Chikkaiah Naicker College,Erode,Tamil Nadu',
'Chinnapallam,Erode,Tamil Nadu',
'Chinniampalayam(Kunathur),Erode,Tamil Nadu',
'Chittode,Erode,Tamil Nadu',
'Dalavaipettai,Erode,Tamil Nadu',
'Dalavoipalayam,Erode,Tamil Nadu',
'Dasappagoundanpudur,Erode,Tamil Nadu',
'Edayankattuvalsu,Erode,Tamil Nadu',
'Elathur Chettipalayam,Erode,Tamil Nadu',
'Elavamalai,Erode,Tamil Nadu',
'Elavanatham,Erode,Tamil Nadu',
'Elumathur,Erode,Tamil Nadu',
'Ennamanagalam,Erode,Tamil Nadu',
'Erangattur,Erode,Tamil Nadu',
'Erode Collectorate,Erode,Tamil Nadu',
'Erode East,Erode,Tamil Nadu',
'Erode Fort,Erode,Tamil Nadu',
'Erode H.O,Erode,Tamil Nadu',
'Erode Market,Erode,Tamil Nadu',
'Erode North,Erode,Tamil Nadu',
'Erode Railway Colony,Erode,Tamil Nadu',
'Erode South,Erode,Tamil Nadu',
'Ganapathipalayam,Erode,Tamil Nadu',
'Gangapuram,Erode,Tamil Nadu',
'Getticheyur,Erode,Tamil Nadu',
'Gettisamudram,Erode,Tamil Nadu',
'Gettisamudram Colony,Erode,Tamil Nadu',
'Gnanipalayam,Erode,Tamil Nadu',
'Gobichettipalayam East,Erode,Tamil Nadu',
'Gobichettipalayam H.O,Erode,Tamil Nadu',
'Gobichettipalayam South,Erode,Tamil Nadu',
'Greynagar,Erode,Tamil Nadu',
'Gudakkarai,Erode,Tamil Nadu',
'Guruvareddiyur,Erode,Tamil Nadu',
'Guthialathur,Erode,Tamil Nadu',
'Ichipalayam,Erode,Tamil Nadu',
'Ingur,Erode,Tamil Nadu',
'Injampalli,Erode,Tamil Nadu',
'Irugalur,Erode,Tamil Nadu',
'Jambai,Erode,Tamil Nadu',
'Kadappanalur,Erode,Tamil Nadu',
'Kadathur,Erode,Tamil Nadu',
'Kadayampatti,Erode,Tamil Nadu',
'Kadirampatti,Erode,Tamil Nadu',
'Kadukkampalayam,Erode,Tamil Nadu',
'Kagam,Erode,Tamil Nadu',
'Kaikolapalayam,Erode,Tamil Nadu',
'Kalbhavi,Erode,Tamil Nadu',
'Kaliappampalayam,Erode,Tamil Nadu',
'Kalichettipalayam,Erode,Tamil Nadu',
'Kalingarayanpalayam Pudur,Erode,Tamil Nadu',
'Kalingiam,Erode,Tamil Nadu',
'Kalkadambur,Erode,Tamil Nadu',
'Kallipatti,Erode,Tamil Nadu',
'Kambiliyampatti,Erode,Tamil Nadu',
'Kanagapuram,Erode,Tamil Nadu',
'Kanakkampalayam,Erode,Tamil Nadu',
'Kandappagoundenvalasu,Erode,Tamil Nadu',
'Kandasamipalayam,Erode,Tamil Nadu',
'Kandikattuvalasu,Erode,Tamil Nadu',
'Kanjikovil,Erode,Tamil Nadu',
'Kannadipalayam,Erode,Tamil Nadu',
'Karalayam,Erode,Tamil Nadu',
'Karattadipalayam,Erode,Tamil Nadu',
'Karattupalayam,Erode,Tamil Nadu',
'Karukkampalayam,Erode,Tamil Nadu',
'Karumandisellipalayam,Erode,Tamil Nadu',
'Karungalpalayam,Erode,Tamil Nadu',
'Kasbapettai,Erode,Tamil Nadu',
'Kasipalayam,Erode,Tamil Nadu',
'Kasipalayam,Erode,Tamil Nadu',
'Kasthurbagarm,Erode,Tamil Nadu',
'Kasthuripalayam,Erode,Tamil Nadu',
'Kavindapadi,Erode,Tamil Nadu',
'Kavundichipalayam,Erode,Tamil Nadu',
'Kavuthampalayam,Erode,Tamil Nadu',
'Kembanaickenpalayam,Erode,Tamil Nadu',
'Kesarimangalam,Erode,Tamil Nadu',
'Kidarai,Erode,Tamil Nadu',
'Kilwani,Erode,Tamil Nadu',
'Kodiveri,Erode,Tamil Nadu',
'Kodumanal,Erode,Tamil Nadu',
'Kodumudi,Erode,Tamil Nadu',
'Kolanalli,Erode,Tamil Nadu',
'Kolappalur,Erode,Tamil Nadu',
'Kolathupalayam,Erode,Tamil Nadu',
'Kollampalayam,Erode,Tamil Nadu',
'Komarayanur,Erode,Tamil Nadu',
'Komarayeevalasu,Erode,Tamil Nadu',
'Kondapanaickenpalayam,Erode,Tamil Nadu',
'Kondayampalayam(Bhavani),Erode,Tamil Nadu',
'Kongarpalayam,Erode,Tamil Nadu',
'Koothampalayam,Erode,Tamil Nadu',
'Koothampatti,Erode,Tamil Nadu',
'Koothampoondi,Erode,Tamil Nadu',
'Koshanam,Erode,Tamil Nadu',
'Kottupullampalayam,Erode,Tamil Nadu',
'Kovilpalayam,Erode,Tamil Nadu',
'Kugalur,Erode,Tamil Nadu',
'Kullampalayam,Erode,Tamil Nadu',
'Kummakalipalayam,Erode,Tamil Nadu',
'Kunnathur,Erode,Tamil Nadu',
'Kuppandampalayam,Erode,Tamil Nadu',
'Kurichi,Erode,Tamil Nadu',
'Kurichi-kunnathur,Erode,Tamil Nadu',
'Kurumandur,Erode,Tamil Nadu',
'Kurupanaickenpalayam,Erode,Tamil Nadu',
'Kuthambi,Erode,Tamil Nadu',
'Kuttipalayam,Erode,Tamil Nadu',
'L.M.Palapalayam,Erode,Tamil Nadu',
'Lakkapuram,Erode,Tamil Nadu',
'Malayampalayam,Erode,Tamil Nadu',
'Mannathampalayam,Erode,Tamil Nadu',
'Maravapalayam,Erode,Tamil Nadu',
'Mathur,Erode,Tamil Nadu',
'Melapalayam,Erode,Tamil Nadu',
'Mettupalayam,Erode,Tamil Nadu',
'Mevani,Erode,Tamil Nadu',
'Michaelpalayam,Erode,Tamil Nadu',
'Minnapalayam,Erode,Tamil Nadu',
'Modakurichi,Erode,Tamil Nadu',
'Morattupalayam,Erode,Tamil Nadu',
'Mukasi Hanumanpalli,Erode,Tamil Nadu',
'Mukasipidariyur,Erode,Tamil Nadu',
'Mukasipudur,Erode,Tamil Nadu',
'Mulapalayam,Erode,Tamil Nadu',
'Mullampatti,Erode,Tamil Nadu',
'Murali,Erode,Tamil Nadu',
'Murungatholuvu,Erode,Tamil Nadu',
'Muthayeepalayam,Erode,Tamil Nadu',
'Mylambadi,Erode,Tamil Nadu',
'Nadupatti,Erode,Tamil Nadu',
'Nagadevampalayam,Erode,Tamil Nadu',
'Nagalur,Erode,Tamil Nadu',
'Nallampatti,Erode,Tamil Nadu',
'Nambiyur,Erode,Tamil Nadu',
'Nanjagoundenpalayam,Erode,Tamil Nadu',
'Nanjai Puliampatti,Erode,Tamil Nadu',
'Nanjai Uttukuli,Erode,Tamil Nadu',
'Nasiyanur,Erode,Tamil Nadu',
'Nathagoundenpalayam,Erode,Tamil Nadu',
'Nerinjipettai,Erode,Tamil Nadu',
'Nichampalayam,Erode,Tamil Nadu',
'Odathurai,Erode,Tamil Nadu',
'Odayagoundenpalayam,Erode,Tamil Nadu',
'Olagadam,Erode,Tamil Nadu',
'Olapalayam,Erode,Tamil Nadu',
'Oricheri,Erode,Tamil Nadu',
'Pachampalayam,Erode,Tamil Nadu',
'Palakarai,Erode,Tamil Nadu',
'Palakuttaipattipudur,Erode,Tamil Nadu',
'Pallagoundenpalayam,Erode,Tamil Nadu',
'Pallapalayam,Erode,Tamil Nadu',
'Palliyuthu,Erode,Tamil Nadu',
'Pandiampalayam,Erode,Tamil Nadu',
'Pappampalayam,Erode,Tamil Nadu',
'Pappampalayam,Erode,Tamil Nadu',
'Pariyur Vellalapalayam,Erode,Tamil Nadu',
'Paruvachi,Erode,Tamil Nadu',
'Pasur,Erode,Tamil Nadu',
'Patlur,Erode,Tamil Nadu',
'Pattakaranpalayam,Erode,Tamil Nadu',
'Pattimaniakaranpalayam,Erode,Tamil Nadu',
'Peria Agraharam,Erode,Tamil Nadu',
'Peria Semur,Erode,Tamil Nadu',
'Periapuliyur,Erode,Tamil Nadu',
'Periavattam,Erode,Tamil Nadu',
'Periaveerasangli,Erode,Tamil Nadu',
'Periyavettuvapalayam,Erode,Tamil Nadu',
'Perode,Erode,Tamil Nadu',
'Perumugaipudur,Erode,Tamil Nadu',
'Perundalaiyur,Erode,Tamil Nadu',
'Perundur R.S.,Erode,Tamil Nadu',
'Perundurai,Erode,Tamil Nadu',
'Perundurai Sanitorium,Erode,Tamil Nadu',
'Perundurai West,Erode,Tamil Nadu',
'Pethampalayam,Erode,Tamil Nadu',
'Pichandampalayam,Erode,Tamil Nadu',
'Polavakalipalayam,Erode,Tamil Nadu',
'Polavapalayam,Erode,Tamil Nadu',
'Ponmudi,Erode,Tamil Nadu',
'Pudukkaraipudur,Erode,Tamil Nadu',
'Pudupalayam,Erode,Tamil Nadu',
'Pudur,Erode,Tamil Nadu',
'Pullappanaickenpalayam,Erode,Tamil Nadu',
'Pundurai Semur,Erode,Tamil Nadu',
'Pungambadi,Erode,Tamil Nadu',
'Punjaipalatholuvu,Erode,Tamil Nadu',
'Punjaithuraiyampalayam,Erode,Tamil Nadu',
'Punnam,Erode,Tamil Nadu',
'Purappalikattuvalasu,Erode,Tamil Nadu',
'Ramalingapuram,Erode,Tamil Nadu',
'Ramanathapuram Pudur,Erode,Tamil Nadu',
'Rangampalayam,Erode,Tamil Nadu',
'Rasampalayam,Erode,Tamil Nadu',
'Reddipalayam,Erode,Tamil Nadu',
'Sakthinagar,Erode,Tamil Nadu',
'Salaipudur,Erode,Tamil Nadu',
'Salangapalayam,Erode,Tamil Nadu',
'Sanarpalayam,Erode,Tamil Nadu',
'Sankarapalayam,Erode,Tamil Nadu',
'Sanyasipatti,Erode,Tamil Nadu',
'Satamugai,Erode,Tamil Nadu',
'Sathyamangalam Road,Erode,Tamil Nadu',
'Veerapandi,Theni,Tamil Nadu',
'Venkatachalapuram,Theni,Tamil Nadu',
'Appipatti,Theni,Tamil Nadu',
'Poomalaikundu,Theni,Tamil Nadu',
'Anamalayanpatti,Theni,Tamil Nadu',
'C.Pudupatti,Theni,Tamil Nadu',
'Chinnamanur Bazar,Theni,Tamil Nadu',
'Chinnamanur,Theni,Tamil Nadu',
'Chinnaovalapuram,Theni,Tamil Nadu',
'Cumbum,Theni,Tamil Nadu',
'Cumbum West,Theni,Tamil Nadu',
'Dharmapuri,Theni,Tamil Nadu',
'Erasakkanayakanur,Theni,Tamil Nadu',
'Gandhinagar (Cumbum),Theni,Tamil Nadu',
'Gokilapuram,Theni,Tamil Nadu',
'Gudalur,Theni,Tamil Nadu',
'Hanumanthanpatti,Theni,Tamil Nadu',
'Highwavys,Theni,Tamil Nadu',
'Jangalpatti,Theni,Tamil Nadu',
'Kamatchipuram,Theni,Tamil Nadu',
'Kamayakoundanpatti,Theni,Tamil Nadu',
'Kanniservaipatti,Theni,Tamil Nadu',
'Keelagudalur,Theni,Tamil Nadu',
'Kombai,Theni,Tamil Nadu',
'Koolayanur,Theni,Tamil Nadu',
'Krishnampatti,Theni,Tamil Nadu',
'Kujjanur,Theni,Tamil Nadu',
'Kuppinayakanpatti,Theni,Tamil Nadu',
'Lakshminayakanpatti,Theni,Tamil Nadu',
'Manalar,Theni,Tamil Nadu',
'Markeyankottai,Theni,Tamil Nadu',
'Melasindalachery,Theni,Tamil Nadu',
'Muthulapuram,Theni,Tamil Nadu',
'Narayanathevanpatti,Theni,Tamil Nadu',
'Odaipatti,Theni,Tamil Nadu',
'Pallavarayanpatti,Theni,Tamil Nadu',
'Pannaipuram,Theni,Tamil Nadu',
'Periyar Project,Theni,Tamil Nadu',
'Pulikuthi,Theni,Tamil Nadu',
'Royappanpatti,Theni,Tamil Nadu',
'Sankarapuram,Theni,Tamil Nadu',
'Seepalakottai,Theni,Tamil Nadu',
'Sindalacherry,Theni,Tamil Nadu',
'Sukkangalpatti,Theni,Tamil Nadu',
'Surulipatti,Theni,Tamil Nadu',
'Suruliyar Lower Camp,Theni,Tamil Nadu',
'T.Meenatchipuram,Theni,Tamil Nadu',
'Thamminayakanpatti,Theni,Tamil Nadu',
'Thevaram,Theni,Tamil Nadu',
'U.Ammapatti,Theni,Tamil Nadu',
'Uthamapalayam Bazar,Theni,Tamil Nadu',
'Uthamapalayam,Theni,Tamil Nadu',
'Uthamapalayam West,Theni,Tamil Nadu',
'Vellaiyammalpuram,Theni,Tamil Nadu',
'Venniar Estate,Theni,Tamil Nadu',
'Craw Ford Colony,Tiruchirapalli,Tamil Nadu',
'Punjai Sangendai,Tiruchirapalli,Tamil Nadu',
'Salainagar,Tiruchirapalli,Tamil Nadu',
'Alundalaipur,Tiruchirapalli,Tamil Nadu',
'Kallakudi North,Tiruchirapalli,Tamil Nadu',
'Kallakudi TR,Tiruchirapalli,Tamil Nadu',
'Kanakiliyanallur,Tiruchirapalli,Tamil Nadu',
'Malvoy,Tiruchirapalli,Tamil Nadu',
'Malvoy Kannanur,Tiruchirapalli,Tamil Nadu',
'Melarasur,Tiruchirapalli,Tamil Nadu',
'Mettupatti,Tiruchirapalli,Tamil Nadu',
'Mullal,Tiruchirapalli,Tamil Nadu',
'Peruvalappur,Tiruchirapalli,Tamil Nadu',
'Sirukalappur,Tiruchirapalli,Tamil Nadu',
'Sirumayankudi,Tiruchirapalli,Tamil Nadu',
'Tappay,Tiruchirapalli,Tamil Nadu',
'Thinniam,Tiruchirapalli,Tamil Nadu',
'Vadugarpet,Tiruchirapalli,Tamil Nadu',
'Vallam,Tiruchirapalli,Tamil Nadu',
'Varakuppai,Tiruchirapalli,Tamil Nadu',
'Nungavaram,Karur,Tamil Nadu',
'Agalanganallur,Tiruchirapalli,Tamil Nadu',
'Alambadi,Tiruchirapalli,Tamil Nadu',
'Alambakkam,Tiruchirapalli,Tamil Nadu',
'Alangudi Mahajanam,Tiruchirapalli,Tamil Nadu',
'Ambil,Tiruchirapalli,Tamil Nadu',
'Angarai,Tiruchirapalli,Tamil Nadu',
'Ariyur,Tiruchirapalli,Tamil Nadu',
'Athigudi,Tiruchirapalli,Tamil Nadu',
'Edangimangalam,Tiruchirapalli,Tamil Nadu',
'Esanakorai,Tiruchirapalli,Tamil Nadu',
'Kallagam,Tiruchirapalli,Tamil Nadu',
'Kannakudi,Tiruchirapalli,Tamil Nadu',
'Kattur Puvalur,Tiruchirapalli,Tamil Nadu',
'Keelarasur,Tiruchirapalli,Tamil Nadu',
'Konnagudi,Tiruchirapalli,Tamil Nadu',
'Kovandakurichi,Tiruchirapalli,Tamil Nadu',
'Kovilur,Tiruchirapalli,Tamil Nadu',
'Kumulur,Tiruchirapalli,Tamil Nadu',
'Lalgudi H.O,Tiruchirapalli,Tamil Nadu',
'Manakkal,Tiruchirapalli,Tamil Nadu',
'Manthurai,Tiruchirapalli,Tamil Nadu',
'Marudur,Srirangam,Tamil Nadu',
'Melaperungavur,Tiruchirapalli,Tamil Nadu',
'Melavalady,Tiruchirapalli,Tamil Nadu',
'Nagar,Tiruchirapalli,Tamil Nadu',
'Nathamangudi,Tiruchirapalli,Tamil Nadu',
'Pallapuram,Tiruchirapalli,Tamil Nadu',
'Pallividai,Srirangam,Tamil Nadu',
'Periavarsili,Tiruchirapalli,Tamil Nadu',
'Peruvalanallur,Tiruchirapalli,Tamil Nadu',
'Pudur Uthamanur,Tiruchirapalli,Tamil Nadu',
'Pudurpalayam,Tiruchirapalli,Tamil Nadu',
'Pullambadi,Tiruchirapalli,Tamil Nadu',
'Puvalur,Tiruchirapalli,Tamil Nadu',
'Sathamangalam,Tiruchirapalli,Tamil Nadu',
'Sengaraiyur,Tiruchirapalli,Tamil Nadu',
'Sillakkudi,Tiruchirapalli,Tamil Nadu',
'Sivankoil,Tiruchirapalli,Tamil Nadu',
'Thachankurichi,Tiruchirapalli,Tamil Nadu',
'Thirumangalam,Tiruchirapalli,Tamil Nadu',
'Tirumanamedu,Tiruchirapalli,Tamil Nadu',
'Valaldi,Tiruchirapalli,Tamil Nadu',
'Vandalaigudalur,Tiruchirapalli,Tamil Nadu',
'Venkatachalapuram,Tiruchirapalli,Tamil Nadu',
'Viragalur,Tiruchirapalli,Tamil Nadu',
'Cholanganallur,Srirangam,Tamil Nadu',
'Devimangalam,Srirangam,Tamil Nadu',
'Kilianallur,Srirangam,Tamil Nadu',
'Kovathakudi,Srirangam,Tamil Nadu',
'Manachanalloor North,Srirangam,Tamil Nadu',
'Manachanalloor,Srirangam,Tamil Nadu',
'Poonampalayam,Srirangam,Tamil Nadu',
'Pukkathurai,Srirangam,Tamil Nadu',
'Rajampalayam,Srirangam,Tamil Nadu',
'Samayapuram,Srirangam,Tamil Nadu',
'Sennakarai,Srirangam,Tamil Nadu',
'Sirugambur,Srirangam,Tamil Nadu',
'Sirupathur,Srirangam,Tamil Nadu',
'Tattamangalam,Srirangam,Tamil Nadu',
'Tirupanjili,Srirangam,Tamil Nadu',
'Todaiyur,Srirangam,Tamil Nadu',
'Valaiyur,Srirangam,Tamil Nadu',
'Alagiamanavalam,Srirangam,Tamil Nadu',
'Bikshandarkoil,Srirangam,Tamil Nadu',
'C.Ayyampalayam,Srirangam,Tamil Nadu',
'Kalpalayam,Srirangam,Tamil Nadu',
'Kariyamanickam,Srirangam,Tamil Nadu',
'Konalai,Srirangam,Tamil Nadu',
'Kuthur,Srirangam,Tamil Nadu',
'Nochiam,Srirangam,Tamil Nadu',
'Omandur,Srirangam,Tamil Nadu',
'Perahambi,Srirangam,Tamil Nadu',
'Shanamangalam,Srirangam,Tamil Nadu',
'T.Valaiyur,Srirangam,Tamil Nadu',
'Thalakudi,Srirangam,Tamil Nadu',
'Thiruvasi,Srirangam,Tamil Nadu',
'Tiruvellerai,Srirangam,Tamil Nadu',
'Velur,Srirangam,Tamil Nadu',
'A.Pudupatti,Karur,Tamil Nadu',
'Adhigaram,Karur,Tamil Nadu',
'Alagagoundanpatti,Karur,Tamil Nadu',
'Alipatti,Karur,Tamil Nadu',
'Amayapuram,Karur,Tamil Nadu',
'Anampatti,Karur,Tamil Nadu',
'Aniyapur,Karur,Tamil Nadu',
'Avarampatti,Karur,Tamil Nadu',
'Ayanporuvai,Karur,Tamil Nadu',
'Chettiapatti,Karur,Tamil Nadu',
'Chithanatham,Karur,Tamil Nadu',
'Elamanam,Karur,Tamil Nadu',
'Elangakurichi,Karur,Tamil Nadu',
'Endapuli,Karur,Tamil Nadu',
'Firka Kilaiyur,Karur,Tamil Nadu',
'Ikkaraikosikurichi,Karur,Tamil Nadu',
'Inamponnambalapatti,Karur,Tamil Nadu',
'K.Periyapatti,Karur,Tamil Nadu',
'Kalingapatti,Karur,Tamil Nadu',
'Kallupatti,Karur,Tamil Nadu',
'Kalpatti,Karur,Tamil Nadu',
'Kanjanaickenpatti,Karur,Tamil Nadu',
'Kannivadugapatti,Karur,Tamil Nadu',
'Kannudayanpatti,Karur,Tamil Nadu',
'Kannuthu,Karur,Tamil Nadu',
'Karaipatti,Karur,Tamil Nadu',
'Karumakavundanpatti,Karur,Tamil Nadu',
'Karumalai,Karur,Tamil Nadu',
'Karungulam,Karur,Tamil Nadu',
'Karuppur (Manaparai),Karur,Tamil Nadu',
'Kodumbapatti,Karur,Tamil Nadu',
'Kovilpatti,Karur,Tamil Nadu',
'Kumaravadi,Karur,Tamil Nadu',
'Malayadipatti,Karur,Tamil Nadu',
'Manaparai R.S,Karur,Tamil Nadu',
'Manaparai,Karur,Tamil Nadu',
'Maniyankurichi,Karur,Tamil Nadu',
'Manjampatti,Karur,Tamil Nadu',
'Marungapuri,Karur,Tamil Nadu',
'Mohavanur,Karur,Tamil Nadu',
'Mutalvarapatti,Karur,Tamil Nadu',
'Muthapudayanpatti,Karur,Tamil Nadu',
'N.Poolampatti,Karur,Tamil Nadu',
'Nadupatti,Karur,Tamil Nadu',
'Nallampillai,Karur,Tamil Nadu',
'Palakurichi,Karur,Tamil Nadu',
'Palayakottai,Karur,Tamil Nadu',
'Palayapalayam,Karur,Tamil Nadu',
'Paluvanji,Karur,Tamil Nadu',
'Pannankombu,Karur,Tamil Nadu',
'Pannipatti,Karur,Tamil Nadu',
'Periya Anaikaraipatti,Karur,Tamil Nadu',
'Pillupatti,Karur,Tamil Nadu',
'Piranpatti (Manaparai),Karur,Tamil Nadu',
'Poigaipatti,Karur,Tamil Nadu',
'Ponnaiar Dam,Karur,Tamil Nadu',
'Poosaripatti,Karur,Tamil Nadu',
'Porathakudi,Karur,Tamil Nadu',
'Pothamettupatti,Karur,Tamil Nadu',
'Pudukkottai (Vaiyampatti),Karur,Tamil Nadu',
'Puthanatham,Karur,Tamil Nadu',
'Samudram,Karur,Tamil Nadu',
'Sevalpatti,Karur,Tamil Nadu',
'Sevalur,Karur,Tamil Nadu',
'T.Idayapatti,Karur,Tamil Nadu',
'Tadakkavundanpatti,Karur,Tamil Nadu',
'Thavalaveeranpatti,Karur,Tamil Nadu',
'Thenur (Manaparai),Karur,Tamil Nadu',
'Thethur,Karur,Tamil Nadu',
'Thiagesaralai,Karur,Tamil Nadu',
'Thoppanaickenpatti,Karur,Tamil Nadu',
'Thottiapatti,Karur,Tamil Nadu',
'Thuvarankurichi,Karur,Tamil Nadu',
'Tirunellipatti,Karur,Tamil Nadu',
'V.Periyapatti,Karur,Tamil Nadu',
'Vaiyampatti,Karur,Tamil Nadu',
'Valanadu,Karur,Tamil Nadu',
'Valayapatti (Manaparai),Karur,Tamil Nadu',
'Vellalapatti,Karur,Tamil Nadu',
'Vengaikurichi,Karur,Tamil Nadu',
'Yagapuram,Karur,Tamil Nadu',
'A.A. College,Srirangam,Tamil Nadu',
'Abinimangalam,Srirangam,Tamil Nadu',
'Alagapuri,Srirangam,Tamil Nadu',
'Ammangudi,Srirangam,Tamil Nadu',
'Amur,Srirangam,Tamil Nadu',
'Angiyam,Srirangam,Tamil Nadu',
'Appanallur,Srirangam,Tamil Nadu',
'Arachi,Srirangam,Tamil Nadu',
'Arasalur,Srirangam,Tamil Nadu',
'Ayyampalayam,Srirangam,Tamil Nadu',
'Balasamudram,Srirangam,Tamil Nadu',
'Chinnakodunthurai,Srirangam,Tamil Nadu',
'Devanur,Srirangam,Tamil Nadu',
'Edumalai,Srirangam,Tamil Nadu',
'Evur,Srirangam,Tamil Nadu',
'Gunasilam,Srirangam,Tamil Nadu',
'Jadamangalam,Srirangam,Tamil Nadu',
'Jambumadai,Srirangam,Tamil Nadu',
'Jambunathapuram,Srirangam,Tamil Nadu',
'Jayankondam,Srirangam,Tamil Nadu',
'Kargudi,Srirangam,Tamil Nadu',
'Karikali,Srirangam,Tamil Nadu',
'Kattukulam,Srirangam,Tamil Nadu',
'Kolakkudi,Srirangam,Tamil Nadu',
'Konappampatti,Srirangam,Tamil Nadu',
'Kottathur,Srirangam,Tamil Nadu',
'M.Pudupatti,Srirangam,Tamil Nadu',
'M.Puthur,Srirangam,Tamil Nadu',
'Mahadevi,Srirangam,Tamil Nadu',
'Mambarai,Srirangam,Tamil Nadu',
'Mangalam,Srirangam,Tamil Nadu',
'Mavilipatti,Srirangam,Tamil Nadu',
'Mettupalayam,Srirangam,Tamil Nadu',
'Mettupatti,Srirangam,Tamil Nadu',
'Moovanur,Srirangam,Tamil Nadu',
'Musiri,Srirangam,Tamil Nadu',
'Neeliampatti,Srirangam,Tamil Nadu',
'Neiveli,Srirangam,Tamil Nadu',
'Paithamparai,Srirangam,Tamil Nadu',
'Peramangalam,Srirangam,Tamil Nadu',
'Perur,Srirangam,Tamil Nadu',
'Pillapalayam,Srirangam,Tamil Nadu',
'Poolancheri,Srirangam,Tamil Nadu',
'Pulivalam,Srirangam,Tamil Nadu',
'Puthanampatti,Srirangam,Tamil Nadu',
'Sergudi,Srirangam,Tamil Nadu',
'Sithambur,Srirangam,Tamil Nadu',
'Sittalarai,Srirangam,Tamil Nadu',
'Sundaikkai,Srirangam,Tamil Nadu',
'Surampatti,Srirangam,Tamil Nadu',
'T,pudupatti,Srirangam,Tamil Nadu',
'T.Sathanur,Srirangam,Tamil Nadu',
'Thandalai,Srirangam,Tamil Nadu',
'Thandalaiputhur,Srirangam,Tamil Nadu',
'Thathiengarpet,Srirangam,Tamil Nadu',
'Thinnakonam,Srirangam,Tamil Nadu',
'Thinnanur,Srirangam,Tamil Nadu',
'Thirunarayanapuram,Srirangam,Tamil Nadu',
'Thiruthalaiyur,Srirangam,Tamil Nadu',
'Thulayanatham,Srirangam,Tamil Nadu',
'Thumbalam,Srirangam,Tamil Nadu',
'Tiruthiamalai,Srirangam,Tamil Nadu',
'Urakkarai,Srirangam,Tamil Nadu',
'Vadamalaipatti,Srirangam,Tamil Nadu',
'Valaiyeduppu,Srirangam,Tamil Nadu',
'Valasiramani,Srirangam,Tamil Nadu',
'Valavandhi,Srirangam,Tamil Nadu',
'Vathalai Gudalur,Srirangam,Tamil Nadu',
'Veeramanipatti,Srirangam,Tamil Nadu',
'Velakkanatham,Srirangam,Tamil Nadu',
'Vellalapatti,Srirangam,Tamil Nadu',
'Velur-ayyampalayam,Srirangam,Tamil Nadu',
'Kondayampettai,Srirangam,Tamil Nadu',
'Melur,Srirangam,Tamil Nadu',
'Renganagar,Srirangam,Tamil Nadu',
'Srinivasanagar,Srirangam,Tamil Nadu',
'Srirangam H.O,Srirangam,Tamil Nadu',
'Srirangam North,Srirangam,Tamil Nadu',
'Srirangam West,Srirangam,Tamil Nadu',
'Tiruvalarsolai,Srirangam,Tamil Nadu',
'Tiruvanaikoil,Srirangam,Tamil Nadu',
'Uthamaseri,Srirangam,Tamil Nadu',
'Alagarai,Srirangam,Tamil Nadu',
'Arangoor,Srirangam,Tamil Nadu',
'Chinnapallipalayam,Srirangam,Tamil Nadu',
'Kaduvetti,Srirangam,Tamil Nadu',
'Kamalapuram,Srirangam,Tamil Nadu',
'Kattuputhur,Srirangam,Tamil Nadu',
'Kidaram,Srirangam,Tamil Nadu',
'Manamedu,Srirangam,Tamil Nadu',
'Minnathampatti,Srirangam,Tamil Nadu',
'Murungai,Srirangam,Tamil Nadu',
'Murungai Kalathur,Srirangam,Tamil Nadu',
'Nagaiyanallur,Srirangam,Tamil Nadu',
'Natham Balasamudram,Srirangam,Tamil Nadu',
'Odayalampudur,Srirangam,Tamil Nadu',
'Pidaramangalam,Srirangam,Tamil Nadu',
'Servaikaranpatti,Srirangam,Tamil Nadu',
'Silaipillaiyarputhur,Srirangam,Tamil Nadu',
'Srinivasanallur,Srirangam,Tamil Nadu',
'Sriramasamudram,Srirangam,Tamil Nadu',
'Thalamalaipatti,Srirangam,Tamil Nadu',
'Thiruvengimalai,Srirangam,Tamil Nadu',
'Tholurpatti,Srirangam,Tamil Nadu',
'Thottiam,Srirangam,Tamil Nadu',
'Unniyur,Srirangam,Tamil Nadu',
'Varadarajapuram,Srirangam,Tamil Nadu',
'Yelurpatti,Srirangam,Tamil Nadu',
'Adavathur,Tiruchirapalli,Tamil Nadu',
'Administrative Office(BHEL),Tiruchirapalli,Tamil Nadu',
'Alathur,Tiruchirapalli,Tamil Nadu',
'Allur,Tiruchirapalli,Tamil Nadu',
'Ambikapuram,Tiruchirapalli,Tamil Nadu',
'Andanallur,Tiruchirapalli,Tamil Nadu',
'Annanagar,Tiruchirapalli,Tamil Nadu',
'Arasangudi,Tiruchirapalli,Tamil Nadu',
'Ariyamangalam,Tiruchirapalli,Tamil Nadu',
'Ariyavur,Tiruchirapalli,Tamil Nadu',
'Asoor,Tiruchirapalli,Tamil Nadu',
'Ayyampatti,Tiruchirapalli,Tamil Nadu',
'Bharathidasan University,Tiruchirapalli,Tamil Nadu',
'Bheemanagar,Tiruchirapalli,Tamil Nadu',
'Boiler Project - TR,Tiruchirapalli,Tamil Nadu',
'C Sector (BHEL) - TR,Tiruchirapalli,Tamil Nadu',
'Clock Tower,Tiruchirapalli,Tamil Nadu',
'Edamalaipatti Pudur,Tiruchirapalli,Tamil Nadu',
'Ettarai,Tiruchirapalli,Tamil Nadu',
'Fathimanagar,Tiruchirapalli,Tamil Nadu',
'Golden Rock Market,Tiruchirapalli,Tamil Nadu',
'Golden Rock North,Tiruchirapalli,Tamil Nadu',
'Golden Rock,Tiruchirapalli,Tamil Nadu',
'Gundur,Tiruchirapalli,Tamil Nadu',
'Hapf Township,Tiruchirapalli,Tamil Nadu',
'Inamkulathur R.S.,Tiruchirapalli,Tamil Nadu',
'Inampuliyur,Tiruchirapalli,Tamil Nadu',
'Industrial Colony,Tiruchirapalli,Tamil Nadu',
'Jainagar,Tiruchirapalli,Tamil Nadu',
'Jamal Mohamed College,Tiruchirapalli,Tamil Nadu',
'Jiyapuram,Tiruchirapalli,Tamil Nadu',
'K.K.Nagar,Tiruchirapalli,Tamil Nadu',
'K.Sathanur,Tiruchirapalli,Tamil Nadu',
'Kamarajanagar,Tiruchirapalli,Tamil Nadu',
'Kamarajapuram (BHEL),Tiruchirapalli,Tamil Nadu',
'Kambarasampettai,Tiruchirapalli,Tamil Nadu',
'Khajamalai Colony,Tiruchirapalli,Tamil Nadu',
'Khajanagar,Tiruchirapalli,Tamil Nadu',
'Kilakalkandarkottai,Tiruchirapalli,Tamil Nadu',
'Kilakurichi,Tiruchirapalli,Tamil Nadu',
'Kodiyalam,Tiruchirapalli,Tamil Nadu',
'Koothapar,Tiruchirapalli,Tamil Nadu',
'Koppu,Tiruchirapalli,Tamil Nadu',
'Kulumani,Tiruchirapalli,Tamil Nadu',
'Kumaravayalur,Tiruchirapalli,Tamil Nadu',
'Malaiadivaram,Tiruchirapalli,Tamil Nadu',
'Malliampattu,Tiruchirapalli,Tamil Nadu',
'Manikandam,Tiruchirapalli,Tamil Nadu',
'Mannarpuram,Tiruchirapalli,Tamil Nadu',
'Maruthandakurichi,Tiruchirapalli,Tamil Nadu',
'Mekkudi,Tiruchirapalli,Tamil Nadu',
'Melakalkandarkottai,Tiruchirapalli,Tamil Nadu',
'Mutharasanallur,Tiruchirapalli,Tamil Nadu',
'Nagamangalam,Tiruchirapalli,Tamil Nadu',
'Natarajapuram,Tiruchirapalli,Tamil Nadu',
'Navalpattu,Tiruchirapalli,Tamil Nadu',
'Navalurkottapattu,Tiruchirapalli,Tamil Nadu',
'Ordnance Estate - TR,Tiruchirapalli,Tamil Nadu',
'P & T Colony,Tiruchirapalli,Tamil Nadu',
'Paganur,Tiruchirapalli,Tamil Nadu',
'Palakarai,Tiruchirapalli,Tamil Nadu',
'Palanganangudi,Tiruchirapalli,Tamil Nadu',
'Pallakadu,Tiruchirapalli,Tamil Nadu',
'Pappakurichi Kattur,Tiruchirapalli,Tamil Nadu',
'Pathalapettai,Tiruchirapalli,Tamil Nadu',
'Perugamani,Tiruchirapalli,Tamil Nadu',
'Pettavaithalai,Tiruchirapalli,Tamil Nadu',
'Pirattiyur,Tiruchirapalli,Tamil Nadu',
'Ponmalaipatti,Tiruchirapalli,Tamil Nadu',
'Ponnagar,Tiruchirapalli,Tamil Nadu',
'Ponniah School Buildings,Tiruchirapalli,Tamil Nadu',
'Pudukottai,Tiruchirapalli,Tamil Nadu',
'Pulangulathupatti,Tiruchirapalli,Tamil Nadu',
'Pushpanagar,Tiruchirapalli,Tamil Nadu',
'Puthur,Tiruchirapalli,Tamil Nadu',
'Ramalinganagar South,Tiruchirapalli,Tamil Nadu',
'Ramjeenagar,Tiruchirapalli,Tamil Nadu',
'Ranjithapuram,Tiruchirapalli,Tamil Nadu',
'Regional Engineering College .,Tiruchirapalli,Tamil Nadu',
'Rock Fort,Tiruchirapalli,Tamil Nadu',
'Senthannirpuram,Tiruchirapalli,Tamil Nadu',
'Sirathope,Tiruchirapalli,Tamil Nadu',
'Sircarpalayam,Tiruchirapalli,Tamil Nadu',
'Sirugamani,Tiruchirapalli,Tamil Nadu',
'Somarasampettai,Tiruchirapalli,Tamil Nadu',
'Subramaniapuram,Tiruchirapalli,Tamil Nadu',
'Sundararajanagar,Tiruchirapalli,Tamil Nadu',
'Suriyur,Tiruchirapalli,Tamil Nadu',
'Tennur East,Tiruchirapalli,Tamil Nadu',
'Tennur,Tiruchirapalli,Tamil Nadu',
'Teppakulam,Tiruchirapalli,Tamil Nadu',
'Thayanur,Tiruchirapalli,Tamil Nadu',
'Thillai Nagar,Tiruchirapalli,Tamil Nadu',
'Thiruverumbur,Tiruchirapalli,Tamil Nadu',
'Thuvakudi,Tiruchirapalli,Tamil Nadu',
'Thuvakudimalai,Tiruchirapalli,Tamil Nadu',
'Tiruchirappalli Airport,Tiruchirapalli,Tamil Nadu',
'Tiruchirappalli Collectorate,Tiruchirapalli,Tamil Nadu',
'Tiruchirappalli Contonment,Tiruchirapalli,Tamil Nadu',
'Tiruchirappalli East,Tiruchirapalli,Tamil Nadu',
'Tiruchirappalli Fort,Tiruchirapalli,Tamil Nadu',
'Tiruchirappalli H.O,Tiruchirapalli,Tamil Nadu',
'Tiruchirappalli R.S.,Tiruchirapalli,Tamil Nadu',
'Tiruchirappalli Townhall,Tiruchirapalli,Tamil Nadu',
'Tirunedungulam,Tiruchirapalli,Tamil Nadu',
'Tirupparaithurai,Tiruchirapalli,Tamil Nadu',
'Uyyakondanthirumalai,Tiruchirapalli,Tamil Nadu',
'Valavandankottai,Tiruchirapalli,Tamil Nadu',
'Vengur,Tiruchirapalli,Tamil Nadu',
'Woriur Bazaar,Tiruchirapalli,Tamil Nadu',
'Woriur,Tiruchirapalli,Tamil Nadu',
'Irungalur,Srirangam,Tamil Nadu',
'Nedungur,Srirangam,Tamil Nadu',
'Neikuppai,Srirangam,Tamil Nadu',
'Periyakurukkai,Srirangam,Tamil Nadu',
'Purathakudi,Srirangam,Tamil Nadu',
'R.Valavanur,Srirangam,Tamil Nadu',
'Reddimangudi,Srirangam,Tamil Nadu',
'Siruganur,Srirangam,Tamil Nadu',
'Tirupattur,Srirangam,Tamil Nadu',
'Adhanur,Srirangam,Tamil Nadu',
'Alathudayanpatti,Srirangam,Tamil Nadu',
'Ammapatti,Srirangam,Tamil Nadu',
'B.Mettur,Srirangam,Tamil Nadu',
'Baderpettai,Srirangam,Tamil Nadu',
'Balakrishnampatti,Srirangam,Tamil Nadu',
'Devarappampatti,Srirangam,Tamil Nadu',
'Erakudi,Srirangam,Tamil Nadu',
'Govindapuram,Srirangam,Tamil Nadu',
'Iyyampalayam,Srirangam,Tamil Nadu',
'K.Palayam,Srirangam,Tamil Nadu',
'Kalingamudayanpatti,Srirangam,Tamil Nadu',
'Kaliyampatti,Srirangam,Tamil Nadu',
'Kalladipatti,Srirangam,Tamil Nadu',
'Kannanur,Srirangam,Tamil Nadu',
'Karattampatti,Srirangam,Tamil Nadu',
'Kattanampatti,Srirangam,Tamil Nadu',
'Kilakunnupatti,Srirangam,Tamil Nadu',
'Kinathur,Srirangam,Tamil Nadu',
'Kirambur,Srirangam,Tamil Nadu',
'Koppampatti,Srirangam,Tamil Nadu',
'Kothampatti,Srirangam,Tamil Nadu',
'Kottaiyur,Srirangam,Tamil Nadu',
'Kottapalayam,Srirangam,Tamil Nadu',
'Kurichi,Srirangam,Tamil Nadu',
'Manalodai,Srirangam,Tamil Nadu',
'Maradi,Srirangam,Tamil Nadu',
'Maruvathur,Srirangam,Tamil Nadu',
'Murukkur,Srirangam,Tamil Nadu',
'Muthiyampalayam,Srirangam,Tamil Nadu',
'Nachilipatti,Srirangam,Tamil Nadu',
'Naduvalur,Srirangam,Tamil Nadu',
'Nagalapuram,Srirangam,Tamil Nadu',
'Nagamanaickenpatti,Srirangam,Tamil Nadu',
'Naganallur,Srirangam,Tamil Nadu',
'Nettavelampatti,Srirangam,Tamil Nadu',
'Oddampatti,Srirangam,Tamil Nadu',
'Okkarai,Srirangam,Tamil Nadu',
'Pachaperumalpatti,Srirangam,Tamil Nadu',
'Pagalavadi,Srirangam,Tamil Nadu',
'Periyamangalam,Srirangam,Tamil Nadu',
'Perumalpalayam,Srirangam,Tamil Nadu',
'Ponnusangampatti,Srirangam,Tamil Nadu',
'Pudur,Srirangam,Tamil Nadu',
'Puthur,Srirangam,Tamil Nadu',
'Reddiapatti,Srirangam,Tamil Nadu',
'Sangampatti,Srirangam,Tamil Nadu',
'Sellipalayam,Srirangam,Tamil Nadu',
'Sembulichampatti,Srirangam,Tamil Nadu',
'Senappanallur,Srirangam,Tamil Nadu',
'Sengattupatti,Srirangam,Tamil Nadu',
'Sikkathambur,Srirangam,Tamil Nadu',
'Singalandapuram,Srirangam,Tamil Nadu',
'Sirunavalur,Srirangam,Tamil Nadu',
'Sobanapuram,Srirangam,Tamil Nadu',
'Sorathur,Srirangam,Tamil Nadu',
'T.Baderpettai,Srirangam,Tamil Nadu',
'T.Murungaipatti,Srirangam,Tamil Nadu',
'T.Narasingapuram,Srirangam,Tamil Nadu',
'T.Renganathapuram,Srirangam,Tamil Nadu',
'Thalugaimangapattipudur,Srirangam,Tamil Nadu',
'Thanneerpallam,Srirangam,Tamil Nadu',
'Top Sengattupatti,Srirangam,Tamil Nadu',
'Turaiyur Bus Stand,Srirangam,Tamil Nadu',
'Turaiyur Extension,Srirangam,Tamil Nadu',
'Turaiyur H.O,Srirangam,Tamil Nadu',
'Uppliapuram,Srirangam,Tamil Nadu',
'Veeramachampatti,Srirangam,Tamil Nadu',
'Vengadathanur,Srirangam,Tamil Nadu',
'Venkatachalapuram,Srirangam,Tamil Nadu',
'Venkatesapuram,Srirangam,Tamil Nadu',
'Vishalakshi Ammal Samudram,Srirangam,Tamil Nadu',
'Viswambalsamudram,Srirangam,Tamil Nadu',
'Vyrichettipalayam,Srirangam,Tamil Nadu',
'Kunjaram,Vriddhachalam,Tamil Nadu',
'Alwarkurichi,Tirunelveli,Tamil Nadu',
'Anuvijay Township,Tirunelveli,Tamil Nadu',
'K Kailasapuram,Tirunelveli,Tamil Nadu',
'Kadana Anaithittam,Tirunelveli,Tamil Nadu',
'Karisulthamangalam,Tirunelveli,Tamil Nadu',
'Kodiyankulam,Tirunelveli,Tamil Nadu',
'Mannarkoil,Tirunelveli,Tamil Nadu',
'Merku Alwarkurichi,Tirunelveli,Tamil Nadu',
'Papanasam Upper Dam,Tirunelveli,Tamil Nadu',
'Piranjeri,Tirunelveli,Tamil Nadu',
'Rajaputhukudi,Tirunelveli,Tamil Nadu',
'Seelathikulam,Tirunelveli,Tamil Nadu',
'Seliyanallur,Tirunelveli,Tamil Nadu',
'Sembankulam,Tirunelveli,Tamil Nadu',
'Servalar Camp,Tirunelveli,Tamil Nadu',
'Sivasailam,Tirunelveli,Tamil Nadu',
'Vellalankulam,Tirunelveli,Tamil Nadu',
'Veppankulam,Tirunelveli,Tamil Nadu',
'Adaikalapttinam,Kovilpatti,Tamil Nadu',
'Alangulam Bazaar,Kovilpatti,Tamil Nadu',
'Alangulam,Kovilpatti,Tamil Nadu',
'Anaintha Perumal Nadanur,Tirunelveli,Tamil Nadu',
'Andipatti,Kovilpatti,Tamil Nadu',
'Anjankattalai,Kovilpatti,Tamil Nadu',
'Ayyanarkulam,Kovilpatti,Tamil Nadu',
'Kaduvetti,Tirunelveli,Tamil Nadu',
'Kalathimadam,Kovilpatti,Tamil Nadu',
'Kaluneerkulam,Kovilpatti,Tamil Nadu',
'Kidanganeri,Kovilpatti,Tamil Nadu',
'Kidarakulam,Kovilpatti,Tamil Nadu',
'Koviloothu,Tirunelveli,Tamil Nadu',
'Kuruvankottai,Kovilpatti,Tamil Nadu',
'Kuthapanjan,Kovilpatti,Tamil Nadu',
'Marandai,Kovilpatti,Tamil Nadu',
'Maruthamputhur,Kovilpatti,Tamil Nadu',
'Mayamankurichi,Kovilpatti,Tamil Nadu',
'Nallur,Kovilpatti,Tamil Nadu',
'Odaimarichan,Tirunelveli,Tamil Nadu',
'Pavoorchatram,Kovilpatti,Tamil Nadu',
'Pethanadarpatti,Kovilpatti,Tamil Nadu',
'Poolankulam,Tirunelveli,Tamil Nadu',
'Pudupatti,Kovilpatti,Tamil Nadu',
'Pudur,Kovilpatti,Tamil Nadu',
'Sivalarkulam,Kovilpatti,Tamil Nadu',
'Sivanadanur,Kovilpatti,Tamil Nadu',
'Theertharappapuram,Tirunelveli,Tamil Nadu',
'Thuppakudi,Tirunelveli,Tamil Nadu',
'Vengadampatti,Tirunelveli,Tamil Nadu',
'Adaichani,Tirunelveli,Tamil Nadu',
'Agasthiarpatti,Tirunelveli,Tamil Nadu',
'Aladiyur,Tirunelveli,Tamil Nadu',
'Ambalavanapuram,Tirunelveli,Tamil Nadu',
'Ambasamudram Angadi,Tirunelveli,Tamil Nadu',
'Ambasamudram East,Tirunelveli,Tamil Nadu',
'Ambasamudram H.O,Tirunelveli,Tamil Nadu',
'Ambasamudram Pudukudi,Tirunelveli,Tamil Nadu',
'Attalanallur,Tirunelveli,Tamil Nadu',
'Ayanthiruvaleeswaram,Tirunelveli,Tamil Nadu',
'Brahmadesam,Tirunelveli,Tamil Nadu',
'Cheranmahadevi R.S,Tirunelveli,Tamil Nadu',
'Cheranmahadevi,Tirunelveli,Tamil Nadu',
'Gopalasamudram,Tirunelveli,Tamil Nadu',
'Govindaperi,Tirunelveli,Tamil Nadu',
'Harikesavanallur,Tirunelveli,Tamil Nadu',
'Idaikal,Tirunelveli,Tamil Nadu',
'Kabaliparai,Tirunelveli,Tamil Nadu',
'Kadayam,Tirunelveli,Tamil Nadu',
'Kallidaikurichi,Tirunelveli,Tamil Nadu',
'Karaikurichi,Tirunelveli,Tamil Nadu',
'Karisalpatti,Tirunelveli,Tamil Nadu',
'Karuthapillaiyur,Tirunelveli,Tamil Nadu',
'Kila Ambur,Tirunelveli,Tamil Nadu',
'Kilakulam,Tirunelveli,Tamil Nadu',
'Kodarankulam,Tirunelveli,Tamil Nadu',
'Kothayarmel Thangal,Tirunelveli,Tamil Nadu',
'Kottaitheru,Tirunelveli,Tamil Nadu',
'Kuniyur,Tirunelveli,Tamil Nadu',
'Manimuthar Project,Tirunelveli,Tamil Nadu',
'Manjolai,Tirunelveli,Tamil Nadu',
'Manthiyoor,Tirunelveli,Tamil Nadu',
'Mathapuram,Tirunelveli,Tamil Nadu',
'Melasadayamankulam,Tirunelveli,Tamil Nadu',
'Melaseval,Tirunelveli,Tamil Nadu',
'Mettur,Kovilpatti,Tamil Nadu',
'Mudaliarpatti,Tirunelveli,Tamil Nadu',
'Mukkudal,Tirunelveli,Tamil Nadu',
'Mukkudal Vadakku,Tirunelveli,Tamil Nadu',
'Nalumukku,Tirunelveli,Tamil Nadu',
'Oothu,Tirunelveli,Tamil Nadu',
'Papanasam Mills,Tirunelveli,Tamil Nadu',
'Papanasam Project,Tirunelveli,Tamil Nadu',
'Pappagudi,Tirunelveli,Tamil Nadu',
'Pappankulam,Tirunelveli,Tamil Nadu',
'Pattamadai,Tirunelveli,Tamil Nadu',
'Pottal,Tirunelveli,Tamil Nadu',
'Pottalpudur,Tirunelveli,Tamil Nadu',
'Pungampatti,Tirunelveli,Tamil Nadu',
'Ravanasamudram,Tirunelveli,Tamil Nadu',
'Rengasamudram,Tirunelveli,Tamil Nadu',
'Sadayappapuram,Tirunelveli,Tamil Nadu',
'Sattupathu,Tirunelveli,Tamil Nadu',
'Servaikaranpatti,Tirunelveli,Tamil Nadu',
'Singamparai,Tirunelveli,Tamil Nadu',
'Singampatti,Tirunelveli,Tamil Nadu',
'Sivandipuram,Tirunelveli,Tamil Nadu',
'Tana,Tirunelveli,Tamil Nadu',
'Therku Madathur,Tirunelveli,Tamil Nadu',
'Therkupappankulam,Tirunelveli,Tamil Nadu',
'Thiruppudaimarudur,Tirunelveli,Tamil Nadu',
'Thiruviruthanpulli,Tirunelveli,Tamil Nadu',
'Tulukkapatti,Tirunelveli,Tamil Nadu',
'Uchankulam,Tirunelveli,Tamil Nadu',
'Urkad,Tirunelveli,Tamil Nadu',
'Vadakku Ariyanayagipuram Petta,Tirunelveli,Tamil Nadu',
'Vairavikulam,Tirunelveli,Tamil Nadu',
'Vellankuli,Tirunelveli,Tamil Nadu',
'Vickramasingapuram,Tirunelveli,Tamil Nadu',
'Viravanallur,Tirunelveli,Tamil Nadu',
'Varaganur,Virudhunagar,Tamil Nadu',
'A. Sathankulam,Tirunelveli,Tamil Nadu',
'Alwaneri,Tirunelveli,Tamil Nadu',
'Ambalam,Tirunelveli,Tamil Nadu',
'Battarpuram,Tirunelveli,Tamil Nadu',
'Chidamabarapuram,Tirunelveli,Tamil Nadu',
'Chinthamani,Tirunelveli,Tamil Nadu',
'Dalapathisamudram,Tirunelveli,Tamil Nadu',
'Deivanayagaperi,Tirunelveli,Tamil Nadu',
'Devanallur,Tirunelveli,Tamil Nadu',
'Dohnavur,Tirunelveli,Tamil Nadu',
'Dohnavur,Tirunelveli,Tamil Nadu',
'Elankulam,Tirunelveli,Tamil Nadu',
'Emankulam,Tirunelveli,Tamil Nadu',
'Eruvadi,Tirunelveli,Tamil Nadu',
'Idaiyankulam,Tirunelveli,Tamil Nadu',
'Kadamboduvalvu,Tirunelveli,Tamil Nadu',
'Kalakad,Tirunelveli,Tamil Nadu',
'Kalladichidambarapuram,Tirunelveli,Tamil Nadu',
'Kallikulam,Tirunelveli,Tamil Nadu',
'Kannanallur,Tirunelveli,Tamil Nadu',
'Karankadu,Tirunelveli,Tamil Nadu',
'Karuppukatti,Tirunelveli,Tamil Nadu',
'Keela Kaduvetty,Tirunelveli,Tamil Nadu',
'Keelakaruvelankulam,Tirunelveli,Tamil Nadu',
'Kilakku Kalakad,Tirunelveli,Tamil Nadu',
'Kodaiseri,Tirunelveli,Tamil Nadu',
'Kovaikulam,Tirunelveli,Tamil Nadu',
'Kovilammalpuram,Tirunelveli,Tamil Nadu',
'Kundakulam,Tirunelveli,Tamil Nadu',
'Mannarpuram,Tirunelveli,Tamil Nadu',
'Maruthakulam,Tirunelveli,Tamil Nadu',
'Mavadi,Tirunelveli,Tamil Nadu',
'Mulaikaraipatti,Tirunelveli,Tamil Nadu',
'Munanjipatti,Tirunelveli,Tamil Nadu',
'Mundradaippu,Tirunelveli,Tamil Nadu',
'Naduchalaiputhur,Tirunelveli,Tamil Nadu',
'Nallankulam,Tirunelveli,Tamil Nadu',
'Nambinagar,Tirunelveli,Tamil Nadu',
'Nambithalaivanpattaiyam,Tirunelveli,Tamil Nadu',
'Nanguneri,Tirunelveli,Tamil Nadu',
'Padalaiyarkulam,Tirunelveli,Tamil Nadu',
'Padmaneri,Tirunelveli,Tamil Nadu',
'Panankulam,Tirunelveli,Tamil Nadu',
'Pappankulam,Tirunelveli,Tamil Nadu',
'Paruthipadu,Tirunelveli,Tamil Nadu',
'Pathai,Tirunelveli,Tamil Nadu',
'Puliyurkurichi,Tirunelveli,Tamil Nadu',
'Rajakkamangalam,Tirunelveli,Tamil Nadu',
'Ramakrishnapuram,Tirunelveli,Tamil Nadu',
'Salainainarpallivasal,Tirunelveli,Tamil Nadu',
'Sankankulam,Tirunelveli,Tamil Nadu',
'Sengalakurichi,Tirunelveli,Tamil Nadu',
'Shenbagaramanallur,Tirunelveli,Tamil Nadu',
'Singampathu,Tirunelveli,Tamil Nadu',
'Singaneri,Tirunelveli,Tamil Nadu',
'Singikulam,Tirunelveli,Tamil Nadu',
'Surangudi,Tirunelveli,Tamil Nadu',
'T.Vijayanarayanam,Tirunelveli,Tamil Nadu',
'Thottakudi,Tirunelveli,Tamil Nadu',
'Tirukurungudi,Tirunelveli,Tamil Nadu',
'Tirumalapuram,Tirunelveli,Tamil Nadu',
'Tiruvengadanathapuram,Tirunelveli,Tamil Nadu',
'Unnankulam,Tirunelveli,Tamil Nadu',
'Vadukatchimadil,Tirunelveli,Tamil Nadu',
'Valliammalpuram,Tirunelveli,Tamil Nadu',
'Venkatarayapuram,Tirunelveli,Tamil Nadu',
'Vijayanarayanam Naval Base,Tirunelveli,Tamil Nadu',
'Karandaneri,Tirunelveli,Tamil Nadu',
'Burkitmanagaram,Tirunelveli,Tamil Nadu',
'Jawahar Nagar (Tirunelveli),Tirunelveli,Tamil Nadu',
'Karungulam,Tirunelveli,Tamil Nadu',
'Keelapattam,Tirunelveli,Tamil Nadu',
'Kila Omanallur,Tirunelveli,Tamil Nadu',
'Kizhanatham,Tirunelveli,Tamil Nadu',
'Konganthanparai,Tirunelveli,Tamil Nadu',
'Krishnapuram,Tirunelveli,Tamil Nadu',
'Kulavanickerpuram,Tirunelveli,Tamil Nadu',
'Maharajangar,Tirunelveli,Tamil Nadu',
'Manappadaiveedu,Tirunelveli,Tamil Nadu',
'Marudur,Tirunelveli,Tamil Nadu',
'Melakulam,Tirunelveli,Tamil Nadu',
'Melapalayam Bazaar(Tirunelveli,Tirunelveli,Tamil Nadu',
'Melapalayam,Tirunelveli,Tamil Nadu',
'Melapattam,Tirunelveli,Tamil Nadu',
'Melaputhaneri,Tirunelveli,Tamil Nadu',
'Munnirpallam,Tirunelveli,Tamil Nadu',
'Murugankurichi (TVL),Tirunelveli,Tamil Nadu',
'Naduvakrichi,Tirunelveli,Tamil Nadu',
'Palayankottai Courts,Tirunelveli,Tamil Nadu',
'Palayankottai H.O,Tirunelveli,Tamil Nadu',
'Palayankottai High Grounds,Tirunelveli,Tamil Nadu',
'Perumalpuram,Tirunelveli,Tamil Nadu',
'Ponnakudi,Tirunelveli,Tamil Nadu',
'Reddiarpatti,Tirunelveli,Tamil Nadu',
'Samadanapuram,Tirunelveli,Tamil Nadu',
'Santhinagar,Tirunelveli,Tamil Nadu',
'Sengulam,Tirunelveli,Tamil Nadu',
'Sivalaperi,Tirunelveli,Tamil Nadu',
'Sivanthipatti,Tirunelveli,Tamil Nadu',
'Taruvai,Tirunelveli,Tamil Nadu',
'Thidiyur,Tirunelveli,Tamil Nadu',
'Timmarajapuram,Tirunelveli,Tamil Nadu',
'V.M.Chatram,Tirunelveli,Tamil Nadu',
'Vannarpettai,Tirunelveli,Tamil Nadu',
'Kizhavaneri,Tirunelveli,Tamil Nadu',
'A Thirumalapuram,Tirunelveli,Tamil Nadu',
'Achampadu,Tirunelveli,Tamil Nadu',
'Alagappapuram,Tirunelveli,Tamil Nadu',
'Anaigudi,Tirunelveli,Tamil Nadu',
'Anaikarai,Tirunelveli,Tamil Nadu',
'Anaikulam,Tirunelveli,Tamil Nadu',
'Avaraikulam,Tirunelveli,Tamil Nadu',
'Chidamabarapuram,Tirunelveli,Tamil Nadu',
'Duraikudiyiruppu,Tirunelveli,Tamil Nadu',
'Erukkanthurai,Tirunelveli,Tamil Nadu',
'Idayangudi,Tirunelveli,Tamil Nadu',
'Idindakarai,Tirunelveli,Tamil Nadu',
'Ittamozhi,Tirunelveli,Tamil Nadu',
'Jacobpuram,Tirunelveli,Tamil Nadu',
'Kakkarai,Tirunelveli,Tamil Nadu',
'Kalandapanai,Tirunelveli,Tamil Nadu',
'Kalikumarapuram,Tirunelveli,Tamil Nadu',
'Kannankulam,Tirunelveli,Tamil Nadu',
'Karaichuthupudur,Tirunelveli,Tamil Nadu',
'Kasthurirengapuram,Tirunelveli,Tamil Nadu',
'Kavalkinaru,Tirunelveli,Tamil Nadu',
'Kila Uvari,Tirunelveli,Tamil Nadu',
'Kooduthalai,Tirunelveli,Tamil Nadu',
'Koottapanai,Tirunelveli,Tamil Nadu',
'Kottai Karungulam,Tirunelveli,Tamil Nadu',
'Kudankulam,Tirunelveli,Tamil Nadu',
'Kumarapuram,Tirunelveli,Tamil Nadu',
'Kurugapuram,Tirunelveli,Tamil Nadu',
'Kuthenkuli,Tirunelveli,Tamil Nadu',
'Kuttam,Tirunelveli,Tamil Nadu',
'Kuttapuli,Tirunelveli,Tamil Nadu',
'Leninjipuram,Tirunelveli,Tamil Nadu',
'Mahadevankulam,Tirunelveli,Tamil Nadu',
'Mahendragiri,Tirunelveli,Tamil Nadu',
'Moolaikadu,Tirunelveli,Tamil Nadu',
'Muthukrishnapuram,Tirunelveli,Tamil Nadu',
'Muthumathanmonmozhi,Tirunelveli,Tamil Nadu',
'Nakkaneri,Tirunelveli,Tamil Nadu',
'Navaladi,Tirunelveli,Tamil Nadu',
'Palavoor,Tirunelveli,Tamil Nadu',
'Panagudi,Tirunelveli,Tamil Nadu',
'Panrimalai,Tirunelveli,Tamil Nadu',
'Parameswarapuram,Tirunelveli,Tamil Nadu',
'Parappadi,Tirunelveli,Tamil Nadu',
'Perumanal,Tirunelveli,Tamil Nadu',
'Perungudi,Tirunelveli,Tamil Nadu',
'Pettaikulam,Tirunelveli,Tamil Nadu',
'Pushpavanam,Tirunelveli,Tamil Nadu',
'Radhapuram,Tirunelveli,Tamil Nadu',
'Rajakrishnapuram,Tirunelveli,Tamil Nadu',
'Samaria,Tirunelveli,Tamil Nadu',
'Samugarengapuram,Tirunelveli,Tamil Nadu',
'Sankanapuram,Tirunelveli,Tamil Nadu',
'Settikulam,Tirunelveli,Tamil Nadu',
'Soundarapandiapuram,Tirunelveli,Tamil Nadu',
'Sriregunathapuram,Tirunelveli,Tamil Nadu',
'Suviseshapuram,Tirunelveli,Tamil Nadu',
'Terku Vallioor,Tirunelveli,Tamil Nadu',
'Terkukallikulam,Tirunelveli,Tamil Nadu',
'Terkukarungulam,Tirunelveli,Tamil Nadu',
'Thulukkarpatti,Tirunelveli,Tamil Nadu',
'Tiruvembalapuram,Tirunelveli,Tamil Nadu',
'Tisayanvillai,Tirunelveli,Tamil Nadu',
'Urumankulam,Tirunelveli,Tamil Nadu',
'Uthayathur,Tirunelveli,Tamil Nadu',
'Uvari,Tirunelveli,Tamil Nadu',
'Vadakangulam,Tirunelveli,Tamil Nadu',
'Vadakku Veppilangulam,Tirunelveli,Tamil Nadu',
'Vadalivilai,Tirunelveli,Tamil Nadu',
'Vallioor Perundunilayam,Tirunelveli,Tamil Nadu',
'Vallioor,Tirunelveli,Tamil Nadu',
'Vijaya Achampadu,Tirunelveli,Tamil Nadu',
'Vijayanarayanam,Tirunelveli,Tamil Nadu',
'Vijayapathi,Tirunelveli,Tamil Nadu',
'Alagapuri,Kovilpatti,Tamil Nadu',
'Alagunatchiapuram,Kovilpatti,Tamil Nadu',
'Alkondarkulam,Kovilpatti,Tamil Nadu',
'Ariyanayagipuram,Kovilpatti,Tamil Nadu',
'Athuvazhi,Kovilpatti,Tamil Nadu',
'Ayyaneri,Kovilpatti,Tamil Nadu',
'Ayyapuram,Kovilpatti,Tamil Nadu',
'Azhaganeri,Kovilpatti,Tamil Nadu',
'Chatrapatti,Kovilpatti,Tamil Nadu',
'Chiambarapuram,Kovilpatti,Tamil Nadu',
'Chitrampatti,Kovilpatti,Tamil Nadu',
'Chocknatchiapuram,Kovilpatti,Tamil Nadu',
'Devarkulam,Kovilpatti,Tamil Nadu',
'Devipattinam,Kovilpatti,Tamil Nadu',
'Gomathimuthupuram,Kovilpatti,Tamil Nadu',
'Ichanda,Kovilpatti,Tamil Nadu',
'Ilyarasanendal,Kovilpatti,Tamil Nadu',
'Kalappakulam,Kovilpatti,Tamil Nadu',
'Kalingapatti,Kovilpatti,Tamil Nadu',
'Karisalkulam,Kovilpatti,Tamil Nadu',
'Karisalkulam,Kovilpatti,Tamil Nadu',
'Karisathan,Kovilpatti,Tamil Nadu',
'Karivalamvandanallur,Kovilpatti,Tamil Nadu',
'Kilanilithanallur,Kovilpatti,Tamil Nadu',
'Kilavirasigamani,Kovilpatti,Tamil Nadu',
'Kulakkattakurichi,Kovilpatti,Tamil Nadu',
'Kulasekaramangalam,Kovilpatti,Tamil Nadu',
'Kulasekaraperi,Kovilpatti,Tamil Nadu',
'Kurinjakulam,Kovilpatti,Tamil Nadu',
'Kurukkalpatti,Kovilpatti,Tamil Nadu',
'Kuruvikulam,Kovilpatti,Tamil Nadu',
'Kuvalaikanni,Kovilpatti,Tamil Nadu',
'Maipparai,Kovilpatti,Tamil Nadu',
'Manalur,Kovilpatti,Tamil Nadu',
'Maruthankinar,Kovilpatti,Tamil Nadu',
'Melailanthaikulam,Kovilpatti,Tamil Nadu',
'Melanarikudi,Kovilpatti,Tamil Nadu',
'Melanilithanallur,Kovilpatti,Tamil Nadu',
'Muthammalpuram,Kovilpatti,Tamil Nadu',
'Muvirunthali,Kovilpatti,Tamil Nadu',
'Naduvakurichi,Kovilpatti,Tamil Nadu',
'Nochikulam,Kovilpatti,Tamil Nadu',
'Northachampatti,Kovilpatti,Tamil Nadu',
'Pambukoilshandy,Kovilpatti,Tamil Nadu',
'Panaiyur,Kovilpatti,Tamil Nadu',
'Panavadalichatram,Kovilpatti,Tamil Nadu',
'Pandapuli,Kovilpatti,Tamil Nadu',
'Paruvakkudi,Kovilpatti,Tamil Nadu',
'Pazhankottai,Kovilpatti,Tamil Nadu',
'Periyakoilankulam,Kovilpatti,Tamil Nadu',
'Periyur,Kovilpatti,Tamil Nadu',
'Perumalpatti,Kovilpatti,Tamil Nadu',
'Perumkottur,Kovilpatti,Tamil Nadu',
'Perumpattur,Kovilpatti,Tamil Nadu',
'Pogai,Kovilpatti,Tamil Nadu',
'Ramanathapuram(SNL),Kovilpatti,Tamil Nadu',
'Reddiapatti,Kovilpatti,Tamil Nadu',
'Sambakulam,Kovilpatti,Tamil Nadu',
'Sangupuram,Kovilpatti,Tamil Nadu',
'Sankarankovil Bazaar,Kovilpatti,Tamil Nadu',
'Sankarankovil H.O,Kovilpatti,Tamil Nadu',
'Sathirakondan,Kovilpatti,Tamil Nadu',
'Sayamalai,Kovilpatti,Tamil Nadu',
'Sennikulam,Kovilpatti,Tamil Nadu',
'Senthattiapuram,Kovilpatti,Tamil Nadu',
'Serndamangalam,Kovilpatti,Tamil Nadu',
'Sevalkulam,Kovilpatti,Tamil Nadu',
'Srigomathipuram,Kovilpatti,Tamil Nadu',
'Subbulapuram,Kovilpatti,Tamil Nadu',
'Thannuthu,Kovilpatti,Tamil Nadu',
'Thiruvettanallur,Kovilpatti,Tamil Nadu',
'Tiruvengadam,Kovilpatti,Tamil Nadu',
'Umaithalaivanpatti,Kovilpatti,Tamil Nadu',
'Uthankulam,Kovilpatti,Tamil Nadu',
'Vadakkupudur,Kovilpatti,Tamil Nadu',
'Vadamalapuram,Kovilpatti,Tamil Nadu',
'Vadanathampatti,Kovilpatti,Tamil Nadu',
'Vagaikulam,Kovilpatti,Tamil Nadu',
'Vannikonendal,Kovilpatti,Tamil Nadu',
'Veeriruppu,Kovilpatti,Tamil Nadu',
'Vellakulam,Kovilpatti,Tamil Nadu',
'Vellalankulam,Kovilpatti,Tamil Nadu',
'Vellapaneri,Kovilpatti,Tamil Nadu',
'Virasigamani,Kovilpatti,Tamil Nadu',
'Dhamodarnagar,Kovilpatti,Tamil Nadu',
'Elathur,Kovilpatti,Tamil Nadu',
'Karisalkudiyiruppu,Kovilpatti,Tamil Nadu',
'Karkudi,Kovilpatti,Tamil Nadu',
'Kattalaikudiyiruppu,Kovilpatti,Tamil Nadu',
'Melur,Kovilpatti,Tamil Nadu',
'Panpuli,Kovilpatti,Tamil Nadu',
'Piranur,Kovilpatti,Tamil Nadu',
'Poolankudiyiruppu,Kovilpatti,Tamil Nadu',
'Puliyara,Kovilpatti,Tamil Nadu',
'Sambavarvadakarai,Kovilpatti,Tamil Nadu',
'Sengottai RS,Kovilpatti,Tamil Nadu',
'Sengottai,Kovilpatti,Tamil Nadu',
'Vadakarai,Kovilpatti,Tamil Nadu',
'Vadakaraikilpidagai,Kovilpatti,Tamil Nadu',
'Vavanagaram,Kovilpatti,Tamil Nadu',
'Arugankulam,Kovilpatti,Tamil Nadu',
'Duraisamypuram,Kovilpatti,Tamil Nadu',
'Gudalur,Kovilpatti,Tamil Nadu',
'Inamlkoilpatti,Kovilpatti,Tamil Nadu',
'Mullikulam,Kovilpatti,Tamil Nadu',
'Naranapuram,Kovilpatti,Tamil Nadu',
'Puliyangudi,Kovilpatti,Tamil Nadu',
'Ramanathapuram(VSD),Kovilpatti,Tamil Nadu',
'Royagiri,Kovilpatti,Tamil Nadu',
'Sivagiri,Kovilpatti,Tamil Nadu',
'Sivagiri South,Kovilpatti,Tamil Nadu',
'Thirumalapuram,Kovilpatti,Tamil Nadu',
'Vellanaikottai,Kovilpatti,Tamil Nadu',
'Viswanathaperi,Kovilpatti,Tamil Nadu',
'Ariyur,Kovilpatti,Tamil Nadu',
'Chinthamani,Kovilpatti,Tamil Nadu',
'Malayadikurichi,Kovilpatti,Tamil Nadu',
'Nagaram,Kovilpatti,Tamil Nadu',
'Nelkattumseval,Kovilpatti,Tamil Nadu',
'Puliyangudi Bazaar,Kovilpatti,Tamil Nadu',
'Ramasamipuram,Kovilpatti,Tamil Nadu',
'Sankanaperi,Kovilpatti,Tamil Nadu',
'T.N.Puthukudi,Kovilpatti,Tamil Nadu',
'Tenmalai,Kovilpatti,Tamil Nadu',
'Thalaivankottai,Kovilpatti,Tamil Nadu',
'Vadugapatti,Kovilpatti,Tamil Nadu',
'Vasudevanallur,Kovilpatti,Tamil Nadu',
'Achanpudur,Kovilpatti,Tamil Nadu',
'Agarakattu,Kovilpatti,Tamil Nadu',
'Avudaiyanur,Kovilpatti,Tamil Nadu',
'Ayikudi,Kovilpatti,Tamil Nadu',
'Ayiraperi,Kovilpatti,Tamil Nadu',
'Ayyapuram,Kovilpatti,Tamil Nadu',
'Boganallur,Kovilpatti,Tamil Nadu',
'Chockammpatti,Kovilpatti,Tamil Nadu',
'Courtallam Bus Stand,Kovilpatti,Tamil Nadu',
'Courtallam,Kovilpatti,Tamil Nadu',
'Gunaramanallur,Kovilpatti,Tamil Nadu',
'Idaikal(TKS),Kovilpatti,Tamil Nadu',
'Ilanji,Kovilpatti,Tamil Nadu',
'Kadabokathi,Kovilpatti,Tamil Nadu',
'Kadayanallur Bazar,Kovilpatti,Tamil Nadu',
'Kadayanallur Pettai,Kovilpatti,Tamil Nadu',
'Kadayanallur,Kovilpatti,Tamil Nadu',
'Kambapacheri,Kovilpatti,Tamil Nadu',
'Kanakkupillaivalasai,Kovilpatti,Tamil Nadu',
'Kasidharmam,Kovilpatti,Tamil Nadu',
'Kasimajorpuram,Kovilpatti,Tamil Nadu',
'Kilankadu,Kovilpatti,Tamil Nadu',
'Kilapavur,Kovilpatti,Tamil Nadu',
'Kizhapuliyur,Kovilpatti,Tamil Nadu',
'Kodikurichi,Kovilpatti,Tamil Nadu',
'Kottakulam,Kovilpatti,Tamil Nadu',
'Krishnapuram (TVL),Kovilpatti,Tamil Nadu',
'Kulasekarapatti,Kovilpatti,Tamil Nadu',
'Kumanthapuram,Kovilpatti,Tamil Nadu',
'Kuthukalvalasai,Kovilpatti,Tamil Nadu',
'Mangalapuram,Kovilpatti,Tamil Nadu',
'Mathalamparai,Kovilpatti,Tamil Nadu',
'Mavadikal,Kovilpatti,Tamil Nadu',
'Melagaram,Kovilpatti,Tamil Nadu',
'Melakadayanallur,Kovilpatti,Tamil Nadu',
'Melapavur,Kovilpatti,Tamil Nadu',
'Muthukrishnapuram,Kovilpatti,Tamil Nadu',
'Nainaragaram,Kovilpatti,Tamil Nadu',
'Pattakurichi,Kovilpatti,Tamil Nadu',
'Periyapillaivalasi,Kovilpatti,Tamil Nadu',
'Poigai,Kovilpatti,Tamil Nadu',
'Rajapandi,Kovilpatti,Tamil Nadu',
'Sundapandiapuram,Kovilpatti,Tamil Nadu',
'Sundaresapuram,Kovilpatti,Tamil Nadu',
'Tenkasi H.O,Kovilpatti,Tamil Nadu',
'Tenkasi RS,Kovilpatti,Tamil Nadu',
'Thenpothai,Kovilpatti,Tamil Nadu',
'Tippanampatti,Kovilpatti,Tamil Nadu',
'Urmelalagian,Kovilpatti,Tamil Nadu',
'Valasai,Kovilpatti,Tamil Nadu',
'Vallam,Kovilpatti,Tamil Nadu',
'Tirunelveli Collectorate,Tirunelveli,Tamil Nadu',
'Ramayanpatti,Tirunelveli,Tamil Nadu',
'Alagiapandiapuram,Tirunelveli,Tamil Nadu',
'Azhaganeri,Tirunelveli,Tamil Nadu',
'Ettankulam,Tirunelveli,Tamil Nadu',
'Gandhinagar,Tirunelveli,Tamil Nadu',
'Gangaikondan,Tirunelveli,Tamil Nadu',
'Industrial Colony Pettai,Tirunelveli,Tamil Nadu',
'Kailasapuram,Tirunelveli,Tamil Nadu',
'Kalakudi,Tirunelveli,Tamil Nadu',
'Kallur,Tirunelveli,Tamil Nadu',
'Kanarpatti,Tirunelveli,Tamil Nadu',
'Karaiyiruppu,Tirunelveli,Tamil Nadu',
'Kattarankulam,Tirunelveli,Tamil Nadu',
'Kiramangalam,Tirunelveli,Tamil Nadu',
'Kodaganallur,Tirunelveli,Tamil Nadu',
'Kunnathur,Tirunelveli,Tamil Nadu',
'Madavakurichi,Tirunelveli,Tamil Nadu',
'Manonmaniam Sundaranar Univers,Tirunelveli,Tamil Nadu',
'Manur,Tirunelveli,Tamil Nadu',
'Mavadi,Tirunelveli,Tamil Nadu',
'Melathiru Vengadanathapuram,Tirunelveli,Tamil Nadu',
'Minatchipuram,Tirunelveli,Tamil Nadu',
'Nanajankulam,Tirunelveli,Tamil Nadu',
'Naranammalpuram,Tirunelveli,Tamil Nadu',
'Narasinganallur,Tirunelveli,Tamil Nadu',
'Pallaikottai,Tirunelveli,Tamil Nadu',
'Pillaiyarkulam,Tirunelveli,Tamil Nadu',
'Rajavallipuram,Tirunelveli,Tamil Nadu',
'Sankarnagar,Tirunelveli,Tamil Nadu',
'Seethaparpanallur,Tirunelveli,Tamil Nadu',
'Sethurayanputhur,Tirunelveli,Tamil Nadu',
'Suttamally,Tirunelveli,Tamil Nadu',
'Tachanallur,Tirunelveli,Tamil Nadu',
'Tenkulam,Tirunelveli,Tamil Nadu',
'Therkupatti,Tirunelveli,Tamil Nadu',
'Tirunelveli East,Tirunelveli,Tamil Nadu',
'Tirunelveli H.O,Tirunelveli,Tamil Nadu',
'Tirunelveli Merku,Tirunelveli,Tamil Nadu',
'Tirunelveli Nagarmandram,Tirunelveli,Tamil Nadu',
'Tirunelveli Pettai East,Tirunelveli,Tamil Nadu',
'Tirunelveli Pettai,Tirunelveli,Tamil Nadu',
'Tirunelveli R.S,Tirunelveli,Tamil Nadu',
'Tirunelveli Terku,Tirunelveli,Tamil Nadu',
'Tirunelveli Town,Tirunelveli,Tamil Nadu',
'Tiruppanikarisalkulam,Tirunelveli,Tamil Nadu',
'Tondar Bazar,Tirunelveli,Tamil Nadu',
'Ukkirankottai,Tirunelveli,Tamil Nadu',
'Vaduganpatti,Tirunelveli,Tamil Nadu',
'Vagaikulam,Tirunelveli,Tamil Nadu',
'Viraraghavapuram,Tirunelveli,Tamil Nadu',
'Senthimanagalam,Tirunelveli,Tamil Nadu',
'Achankuttam,Kovilpatti,Tamil Nadu',
'Anaikulam,Kovilpatti,Tamil Nadu',
'Balapadraramapuram,Kovilpatti,Tamil Nadu',
'Bungalowsurandai,Kovilpatti,Tamil Nadu',
'E.Meenakshipuram,Kovilpatti,Tamil Nadu',
'Kadayalurutti,Kovilpatti,Tamil Nadu',
'Karuvanda,Kovilpatti,Tamil Nadu',
'Kavaakurichi,Kovilpatti,Tamil Nadu',
'Kilakalangal,Kovilpatti,Tamil Nadu',
'Kulayaneri,Kovilpatti,Tamil Nadu',
'Kurichanpatti,Kovilpatti,Tamil Nadu',
'Marukkalankulam,Kovilpatti,Tamil Nadu',
'Melamarudappapuram,Kovilpatti,Tamil Nadu',
'Nettur,Kovilpatti,Tamil Nadu',
'Parankundrapuram,Kovilpatti,Tamil Nadu',
'Rajagopalaperi,Kovilpatti,Tamil Nadu',
'Rukmaniammalpuram,Kovilpatti,Tamil Nadu',
'Sivagurunathapuram,Kovilpatti,Tamil Nadu',
'Surandai,Kovilpatti,Tamil Nadu',
'Uthumalai,Kovilpatti,Tamil Nadu',
'Vadi,Kovilpatti,Tamil Nadu',
'Veeranam,Kovilpatti,Tamil Nadu',
'Vellakal,Kovilpatti,Tamil Nadu',
'Venkateswarapuram,Kovilpatti,Tamil Nadu',
'Virakeralmpudur,Kovilpatti,Tamil Nadu',
'Melakalangal,Kovilpatti,Tamil Nadu',
'Sippiparai,Kovilpatti,Tamil Nadu',
'Cvrde,Tambaram,Tamil Nadu',
'Ernavur,Tambaram,Tamil Nadu',
'Gandhinagar,Tambaram,Tamil Nadu',
'Tiruvottiyur West,Tambaram,Tamil Nadu',
'Valasaravakkam,Chennai City South,Tamil Nadu',
'Ambattur H.O,Tambaram,Tamil Nadu',
'Ambattur Indl Estate,Tambaram,Tamil Nadu',
'Ambattur West,Tambaram,Tamil Nadu',
'Andarkuppam,Tambaram,Tamil Nadu',
'Athipattu,Tambaram,Tamil Nadu',
'Ennore RS,Tambaram,Tamil Nadu',
'Ennore Thermal Station,Tambaram,Tamil Nadu',
'Jagadambigainagar,Tambaram,Tamil Nadu',
'Kadirvedu,Tambaram,Tamil Nadu',
'Kaladipet,Tambaram,Tamil Nadu',
'Kamarajnagar,Tambaram,Tamil Nadu',
'Kolathur,Tambaram,Tamil Nadu',
'Konnur East,Tambaram,Tamil Nadu',
'Korattur RS,Tambaram,Tamil Nadu',
'Korattur,Tambaram,Tamil Nadu',
'Korattur West,Tambaram,Tamil Nadu',
'Lakshmipuram,Tambaram,Tamil Nadu',
'Madhavaram Milk Colony,Tambaram,Tamil Nadu',
'Madhavaram,Tambaram,Tamil Nadu',
'Manali New Town,Tambaram,Tamil Nadu',
'Manali,Tambaram,Tamil Nadu',
'Menambedu,Tambaram,Tamil Nadu',
'Mogappair,Tambaram,Tamil Nadu',
'Mogappair West,Tambaram,Tamil Nadu',
'Moolakadai,Tambaram,Tamil Nadu',
'Nandiambakkam,Tambaram,Tamil Nadu',
'North Chennai Thermal PP,Tambaram,Tamil Nadu',
'Oragadam,Tambaram,Tamil Nadu',
'Padi,Tambaram,Tamil Nadu',
'Padi South,Tambaram,Tamil Nadu',
'Padianallur,Tambaram,Tamil Nadu',
'Ponniammanmedu,Tambaram,Tamil Nadu',
'Prithivipakkam,Tambaram,Tamil Nadu',
'Rajajinagar,Tambaram,Tamil Nadu',
'Redhills Bazar,Tambaram,Tamil Nadu',
'Shanmugapuram,Tambaram,Tamil Nadu',
'Sidco Estate,Tambaram,Tamil Nadu',
'Srinivasanagar,Tambaram,Tamil Nadu',
'Subbareddypalayam,Tambaram,Tamil Nadu',
'Thiruvengadnagar,Tambaram,Tamil Nadu',
'Tirumangalam Road,Tambaram,Tamil Nadu',
'Tiruvottiyur,Tambaram,Tamil Nadu',
'Tondiarpet Rly Colony,Tambaram,Tamil Nadu',
'Vadaperumbakkam,Tambaram,Tamil Nadu',
'Vallur,Tambaram,Tamil Nadu',
'Vellivoyalchavadi,Tambaram,Tamil Nadu',
'Vichoor,Tambaram,Tamil Nadu',
'Vijayalakshmipuram,Tambaram,Tamil Nadu',
'Villivakkam North,Tambaram,Tamil Nadu',
'Villivakkam,Tambaram,Tamil Nadu',
'Wimco Nagar,Tambaram,Tamil Nadu',
'Alwarthirunagar,Chennai City South,Tamil Nadu',
'Arambakkam,Tambaram,Tamil Nadu',
'Devampattu,Tambaram,Tamil Nadu',
'Edoor,Tambaram,Tamil Nadu',
'Elavur,Tambaram,Tamil Nadu',
'Gummidipundi,Tambaram,Tamil Nadu',
'Iguvarpalayam,Tambaram,Tamil Nadu',
'Kallur,Tambaram,Tamil Nadu',
'Kannankottai,Tambaram,Tamil Nadu',
'Madarpakkam,Tambaram,Tamil Nadu',
'Manellore,Tambaram,Tamil Nadu',
'Mangavaram,Tambaram,Tamil Nadu',
'New Gummidipundi,Tambaram,Tamil Nadu',
'Pallavada,Tambaram,Tamil Nadu',
'Periaobulapuam,Tambaram,Tamil Nadu',
'Roshanagaram,Tambaram,Tamil Nadu',
'Siddharajakandigai,Tambaram,Tamil Nadu',
'Sirupulalpettai,Tambaram,Tamil Nadu',
'Sunnambukulam,Tambaram,Tamil Nadu',
'Thanipoondi,Tambaram,Tamil Nadu',
'Thervoy,Tambaram,Tamil Nadu',
'Tervali,Tambaram,Tamil Nadu',
'Podiyarankulam,Tambaram,Tamil Nadu',
'Adivaragapuram,Kanchipuram,Tamil Nadu',
'Bommarajupeta,Kanchipuram,Tamil Nadu',
'C.N.Kandigai,Kanchipuram,Tamil Nadu',
'Chanurmallavaram,Kanchipuram,Tamil Nadu',
'Echambadi,Kanchipuram,Tamil Nadu',
'Erumbi,Kanchipuram,Tamil Nadu',
'Jangalapalli,Kanchipuram,Tamil Nadu',
'Kakalur,Kanchipuram,Tamil Nadu',
'Karimbedu,Kanchipuram,Tamil Nadu',
'Keechalam,Kanchipuram,Tamil Nadu',
'Kolathur,Kanchipuram,Tamil Nadu',
'Konetampet,Kanchipuram,Tamil Nadu',
'Kumararajupeta,Kanchipuram,Tamil Nadu',
'Melapudi,Kanchipuram,Tamil Nadu',
'Myladumparai,Kanchipuram,Tamil Nadu',
'Nedigallu,Kanchipuram,Tamil Nadu',
'Nediyam,Kanchipuram,Tamil Nadu',
'Paivalasa,Kanchipuram,Tamil Nadu',
'Pallipat Bazzar,Kanchipuram,Tamil Nadu',
'Pallipat,Kanchipuram,Tamil Nadu',
'Pandravedu,Kanchipuram,Tamil Nadu',
'Peddanagapudi,Kanchipuram,Tamil Nadu',
'Peddaramapuram,Kanchipuram,Tamil Nadu',
'Perumanallur,Kanchipuram,Tamil Nadu',
'Pettaikandigai,Kanchipuram,Tamil Nadu',
'Podaturpetawest,Kanchipuram,Tamil Nadu',
'Punyam,Kanchipuram,Tamil Nadu',
'Rangapuram,Kanchipuram,Tamil Nadu',
'Samanthavada,Kanchipuram,Tamil Nadu',
'Sanakuppam,Kanchipuram,Tamil Nadu',
'Srikalikapuram,Kanchipuram,Tamil Nadu',
'Thamaraikulam,Kanchipuram,Tamil Nadu',
'V.P.R.Puram,Kanchipuram,Tamil Nadu',
'Vediyangadu,Kanchipuram,Tamil Nadu',
'Veeramangalam,Kanchipuram,Tamil Nadu',
'Veliagaram,Kanchipuram,Tamil Nadu',
'Venkatarajakuppam,Kanchipuram,Tamil Nadu',
'Podaturpeta,Kanchipuram,Tamil Nadu',
'Aladu,Tambaram,Tamil Nadu',
'Alamathi,Tambaram,Tamil Nadu',
'Alamathi Cattle Farm,Tambaram,Tamil Nadu',
'Alinjivakkam,Tambaram,Tamil Nadu',
'Amoor,Tambaram,Tamil Nadu',
'Anuppampattu,Tambaram,Tamil Nadu',
'Arasur,Tambaram,Tamil Nadu',
'Arni CPT,Tambaram,Tamil Nadu',
'Boochiathipattu,Tambaram,Tamil Nadu',
'Budur,Tambaram,Tamil Nadu',
'Chinnambedu,Tambaram,Tamil Nadu',
'Devadanam,Tambaram,Tamil Nadu',
'Erumaivettipalayam,Tambaram,Tamil Nadu',
'Guruvoyal,Tambaram,Tamil Nadu',
'Jagannathapuram,Tambaram,Tamil Nadu',
'Jothi Nagar,Tambaram,Tamil Nadu',
'Kattur,Tambaram,Tamil Nadu',
'Kavarapettai,Tambaram,Tamil Nadu',
'Kilikodi,Tambaram,Tamil Nadu',
'Kilmudalambedu,Tambaram,Tamil Nadu',
'Kolur,Tambaram,Tamil Nadu',
'Krishnapuram,Tambaram,Tamil Nadu',
'Medur,Tambaram,Tamil Nadu',
'Minjur,Tambaram,Tamil Nadu',
'Mondiyamman Nagar,Tambaram,Tamil Nadu',
'Nallur,Tambaram,Tamil Nadu',
'Nayar,Tambaram,Tamil Nadu',
'Neidavoyal,Tambaram,Tamil Nadu',
'Orakadu,Tambaram,Tamil Nadu',
'Pammadukulam,Tambaram,Tamil Nadu',
'Panayancheri,Tambaram,Tamil Nadu',
'Panjetti,Tambaram,Tamil Nadu',
'Perumbedu,Tambaram,Tamil Nadu',
'Pondavakkam,Tambaram,Tamil Nadu',
'Ponneri Public Office,Tambaram,Tamil Nadu',
'Ponneri,Tambaram,Tamil Nadu',
'Pozhal,Tambaram,Tamil Nadu',
'Puduvoyal,Tambaram,Tamil Nadu',
'Pulicat,Tambaram,Tamil Nadu',
'Puvalambedu,Tambaram,Tamil Nadu',
'Rallapadi,Tambaram,Tamil Nadu',
'Reddipalayam,Tambaram,Tamil Nadu',
'Redhills,Tambaram,Tamil Nadu',
'Seemapuram South,Tambaram,Tamil Nadu',
'Sholavaram,Tambaram,Tamil Nadu',
'Spicto Industrial Estate,Tambaram,Tamil Nadu',
'Thirupalavanam,Tambaram,Tamil Nadu',
'Thriuvellavoyal,Tambaram,Tamil Nadu',
'Vadakarai,Tambaram,Tamil Nadu',
'Velur,Tambaram,Tamil Nadu',
'Vilangadupakkam,Tambaram,Tamil Nadu',
'Voyalur,Tambaram,Tamil Nadu',
'Maduravoyal,Tambaram,Tamil Nadu',
'Poonamallee,Tambaram,Tamil Nadu',
'Arignar Anna Nagar,Tambaram,Tamil Nadu',
'Avadi AF Quarters,Tambaram,Tamil Nadu',
'Avadi Camp H.O,Tambaram,Tamil Nadu',
'Avadi IAF,Tambaram,Tamil Nadu',
'Avadi,Tambaram,Tamil Nadu',
'Ayanambakkam,Tambaram,Tamil Nadu',
'Ayapakkam,Tambaram,Tamil Nadu',
'Central Vehicle Depot,Tambaram,Tamil Nadu',
'CRP camp,Tambaram,Tamil Nadu',
'Kamarajnagar,Tambaram,Tamil Nadu',
'Kattupakkam,Tambaram,Tamil Nadu',
'Koduvalli,Tambaram,Tamil Nadu',
'Kolappancheri,Tambaram,Tamil Nadu',
'Kovilpadagai,Tambaram,Tamil Nadu',
'Kuttambakkam,Tambaram,Tamil Nadu',
'Malayambakkam,Tambaram,Tamil Nadu',
'Mittanamalli,Tambaram,Tamil Nadu',
'Morai,Tambaram,Tamil Nadu',
'Nazarethpettai,Tambaram,Tamil Nadu',
'Nemam,Tambaram,Tamil Nadu',
'Nolambur,Tambaram,Tamil Nadu',
'Numbal,Tambaram,Tamil Nadu',
'Palavedu,Tambaram,Tamil Nadu',
'Pandeeswaram,Tambaram,Tamil Nadu',
'Paruthipattu,Tambaram,Tamil Nadu',
'Pattabiram East,Tambaram,Tamil Nadu',
'Pattabiram,Tambaram,Tamil Nadu',
'Poonamallee East,Tambaram,Tamil Nadu',
'Puduchatram,Tambaram,Tamil Nadu',
'Railway Carshed Complex,Tambaram,Tamil Nadu',
'Sathyamurthynagar,Tambaram,Tamil Nadu',
'Sembarambakkam,Tambaram,Tamil Nadu',
'Senneerkuppam,Tambaram,Tamil Nadu',
'Senthilnagar,Tambaram,Tamil Nadu',
'Soranjeri,Tambaram,Tamil Nadu',
'Tank Factory Avadi,Tambaram,Tamil Nadu',
'Thandarai,Tambaram,Tamil Nadu',
'Thirumullaivoyal,Tambaram,Tamil Nadu',
'Thirumushi,Tambaram,Tamil Nadu',
'Thiruverkadu,Tambaram,Tamil Nadu',
'Udayarkoil,Tambaram,Tamil Nadu',
'Vanagaram,Tambaram,Tamil Nadu',
'Veeraraghavapuram,Tambaram,Tamil Nadu',
'Vellanur,Tambaram,Tamil Nadu',
'Vellavedu,Tambaram,Tamil Nadu',
'Voyalanallur,Tambaram,Tamil Nadu',
'Ramakrishnarajupeta,Kanchipuram,Tamil Nadu',
'Nemilichery,Kanchipuram,Tamil Nadu',
'Perambakkam,Kanchipuram,Tamil Nadu',
'Agooru,Kanchipuram,Tamil Nadu',
'Ammaneri,Kanchipuram,Tamil Nadu',
'Ammavarikuppam,Kanchipuram,Tamil Nadu',
'Arungolam,Kanchipuram,Tamil Nadu',
'Athimanjeri,Kanchipuram,Tamil Nadu',
'Athimanjeripeta,Kanchipuram,Tamil Nadu',
'Athipattu,Kanchipuram,Tamil Nadu',
'Balakrishnapuram,Kanchipuram,Tamil Nadu',
'Balapuram,Kanchipuram,Tamil Nadu',
'Chandravilasapuram,Kanchipuram,Tamil Nadu',
'Chivada,Kanchipuram,Tamil Nadu',
'Kadananagaram,Kanchipuram,Tamil Nadu',
'Karlambakkam,Kanchipuram,Tamil Nadu',
'Karthikeyapuram,Kanchipuram,Tamil Nadu',
'Kasavarajpetta,Kanchipuram,Tamil Nadu',
'Kg Kandigai,Kanchipuram,Tamil Nadu',
'Kodivalasa,Kanchipuram,Tamil Nadu',
'Konasamudram,Kanchipuram,Tamil Nadu',
'Kothakuppam,Kanchipuram,Tamil Nadu',
'Madduru,Kanchipuram,Tamil Nadu',
'Mahankalikapuram,Kanchipuram,Tamil Nadu',
'Murukkambattu,Kanchipuram,Tamil Nadu',
'Nallathur,Kanchipuram,Tamil Nadu',
'Nemili,Kanchipuram,Tamil Nadu',
'Netterikandigai,Kanchipuram,Tamil Nadu',
'Nochili,Kanchipuram,Tamil Nadu',
'Ponpadi,Kanchipuram,Tamil Nadu',
'Srinivasapuram,Kanchipuram,Tamil Nadu',
'Suryanagaram,Kanchipuram,Tamil Nadu',
'Thalavedu,Kanchipuram,Tamil Nadu',
'Thyagapuram,Kanchipuram,Tamil Nadu',
'Tirutani Hills,Kanchipuram,Tamil Nadu',
'Tiruvelangadu,Kanchipuram,Tamil Nadu',
'Upper Tirutani,Kanchipuram,Tamil Nadu',
'Vanganur,Kanchipuram,Tamil Nadu',
'Veeranathur,Kanchipuram,Tamil Nadu',
'Velanjeri,Kanchipuram,Tamil Nadu',
'Arcot,Kanchipuram,Tamil Nadu',
'Beerakuppam,Kanchipuram,Tamil Nadu',
'Buchireddipalli,Kanchipuram,Tamil Nadu',
'Cherukkanur,Kanchipuram,Tamil Nadu',
'Chinnammapet,Kanchipuram,Tamil Nadu',
'Emrkandigai,Kanchipuram,Tamil Nadu',
'Harichandrapuram,Kanchipuram,Tamil Nadu',
'Illuppur,Kanchipuram,Tamil Nadu',
'Kanakammachatram,Kanchipuram,Tamil Nadu',
'Kanchipadi,Kanchipuram,Tamil Nadu',
'Koramangalam,Kanchipuram,Tamil Nadu',
'Krishnasamudram,Kanchipuram,Tamil Nadu',
'Kunnavalam,Kanchipuram,Tamil Nadu',
'Kurmavilasapuram,Kanchipuram,Tamil Nadu',
'Mambakkam,Kanchipuram,Tamil Nadu',
'Mannur,Kanchipuram,Tamil Nadu',
'Muthukondapuram,Kanchipuram,Tamil Nadu',
'Nabalur,Kanchipuram,Tamil Nadu',
'Nedambaram,Kanchipuram,Tamil Nadu',
'Pakasala,Kanchipuram,Tamil Nadu',
'Palayanur,Kanchipuram,Tamil Nadu',
'Pattabiramapuram,Kanchipuram,Tamil Nadu',
'Peddakalakattur,Kanchipuram,Tamil Nadu',
'Ponpadi Rs,Kanchipuram,Tamil Nadu',
'Poonimangadu,Kanchipuram,Tamil Nadu',
'Rajanagaram,Kanchipuram,Tamil Nadu',
'Ramanjeri,Kanchipuram,Tamil Nadu',
'Ramapuram,Kanchipuram,Tamil Nadu',
'Ramasamudram,Kanchipuram,Tamil Nadu',
'S.Agraharam,Kanchipuram,Tamil Nadu',
'Saraswathinagar,Kanchipuram,Tamil Nadu',
'Savattur,Kanchipuram,Tamil Nadu',
'Sgbkandigai,Kanchipuram,Tamil Nadu',
'Sirugumi,Kanchipuram,Tamil Nadu',
'Sorakayapeta,Kanchipuram,Tamil Nadu',
'T.C.Kandigai,Kanchipuram,Tamil Nadu',
'T.T.Kandigai,Kanchipuram,Tamil Nadu',
'Thadur,Kanchipuram,Tamil Nadu',
'Tiruttani,Kanchipuram,Tamil Nadu',
'Tiruttanieast,Kanchipuram,Tamil Nadu',
'Tiruttanisouth,Kanchipuram,Tamil Nadu',
'Tiruttaniwest,Kanchipuram,Tamil Nadu',
'V.K.N.Kandigai,Kanchipuram,Tamil Nadu',
'Veerakaverirajapuram,Kanchipuram,Tamil Nadu',
'Veeraraghavapuram,Kanchipuram,Tamil Nadu',
'Vyasapuram,Kanchipuram,Tamil Nadu',
'Allikuzhi,Kanchipuram,Tamil Nadu',
'Aranvoyal,Kanchipuram,Tamil Nadu',
'Damaraipakkam,Kanchipuram,Tamil Nadu',
'Devandavakkam,Kanchipuram,Tamil Nadu',
'Egattur,Kanchipuram,Tamil Nadu',
'Enambakkam,Kanchipuram,Tamil Nadu',
'Ikkadu,Kanchipuram,Tamil Nadu',
'Illupur,Kanchipuram,Tamil Nadu',
'Kadambathur,Kanchipuram,Tamil Nadu',
'Kaivandur,Kanchipuram,Tamil Nadu',
'Kakalur Ind Estate,Kanchipuram,Tamil Nadu',
'Kalambakkam,Kanchipuram,Tamil Nadu',
'Kalpattu,Kanchipuram,Tamil Nadu',
'Karikalavakkam,Kanchipuram,Tamil Nadu',
'Karlapakkam,Kanchipuram,Tamil Nadu',
'Kilanur,Kanchipuram,Tamil Nadu',
'Kilnallathur,Kanchipuram,Tamil Nadu',
'Komakkambedu,Kanchipuram,Tamil Nadu',
'Koppur,Kanchipuram,Tamil Nadu',
'Kottamedu,Kanchipuram,Tamil Nadu',
'Lakshipuram,Kanchipuram,Tamil Nadu',
'Manavalanagar,Kanchipuram,Tamil Nadu',
'Melnallathur,Kanchipuram,Tamil Nadu',
'Meyyur,Kanchipuram,Tamil Nadu',
'Monnavedu,Kanchipuram,Tamil Nadu',
'Nambakkam,Kanchipuram,Tamil Nadu',
'Neiveli,Kanchipuram,Tamil Nadu',
'Nelvoy,Kanchipuram,Tamil Nadu',
'Nggo Colony Tiruvallur,Kanchipuram,Tamil Nadu',
'Nungambakkam,Kanchipuram,Tamil Nadu',
'Odappai,Kanchipuram,Tamil Nadu',
'Odikkadu,Kanchipuram,Tamil Nadu',
'Pakkam,Kanchipuram,Tamil Nadu',
'Palavakkam,Kanchipuram,Tamil Nadu',
'Pandur,Kanchipuram,Tamil Nadu',
'Papparambakkam,Kanchipuram,Tamil Nadu',
'Pattaraiperumbudur,Kanchipuram,Tamil Nadu',
'Pennaluripeta,Kanchipuram,Tamil Nadu',
'Perattur,Kanchipuram,Tamil Nadu',
'Perumalpattu,Kanchipuram,Tamil Nadu',
'Placepalayam,Kanchipuram,Tamil Nadu',
'Polivakkam,Kanchipuram,Tamil Nadu',
'Poorivakkam,Kanchipuram,Tamil Nadu',
'Pudumavilangai,Kanchipuram,Tamil Nadu',
'Pullarambakkam,Kanchipuram,Tamil Nadu',
'Putlur,Kanchipuram,Tamil Nadu',
'Sandarayanpalayam,Kanchipuram,Tamil Nadu',
'Selai,Kanchipuram,Tamil Nadu',
'Sembedu,Kanchipuram,Tamil Nadu',
'Sengadu,Kanchipuram,Tamil Nadu',
'Senji,Kanchipuram,Tamil Nadu',
'Sivanvoyal,Kanchipuram,Tamil Nadu',
'Thalakancheri,Kanchipuram,Tamil Nadu',
'Thozhur,Kanchipuram,Tamil Nadu',
'Timmaboopalapuram,Kanchipuram,Tamil Nadu',
'Tirukandalam,Kanchipuram,Tamil Nadu',
'Tiruninravur Rs,Kanchipuram,Tamil Nadu',
'Tiruninravur,Kanchipuram,Tamil Nadu',
'Tirupasur,Kanchipuram,Tamil Nadu',
'Tirur Cpt,Kanchipuram,Tamil Nadu',
'Tiruvallur Bazaar,Kanchipuram,Tamil Nadu',
'Tiruvallur H.O,Kanchipuram,Tamil Nadu',
'Tiruvallur Nethaji Road,Kanchipuram,Tamil Nadu',
'Vadattur,Kanchipuram,Tamil Nadu',
'Vellathukottai,Kanchipuram,Tamil Nadu',
'Velliyur,Kanchipuram,Tamil Nadu',
'Veppambattu,Kanchipuram,Tamil Nadu',
'Vidaiyur,Kanchipuram,Tamil Nadu',
'Poondi,Kanchipuram,Tamil Nadu',
'Alamelumangapuram,Kanchipuram,Tamil Nadu',
'Athivakkam,Kanchipuram,Tamil Nadu',
'Goonipalayam,Kanchipuram,Tamil Nadu',
'Kannigaipair,Kanchipuram,Tamil Nadu',
'Majankaranai,Kanchipuram,Tamil Nadu',
'Mambakkam,Kanchipuram,Tamil Nadu',
'Mukkarambakkam,Kanchipuram,Tamil Nadu',
'Nelvoy,Kanchipuram,Tamil Nadu',
'Perandur,Kanchipuram,Tamil Nadu',
'Periapalayam,Kanchipuram,Tamil Nadu',
'Pondavakkam,Kanchipuram,Tamil Nadu',
'Seethanjeri,Kanchipuram,Tamil Nadu',
'Sulaimeni,Kanchipuram,Tamil Nadu',
'Thandalam,Kanchipuram,Tamil Nadu',
'Tharakshi,Kanchipuram,Tamil Nadu',
'Uttukottai,Kanchipuram,Tamil Nadu',
'Vadamadurai,Kanchipuram,Tamil Nadu',
'Vengal,Kanchipuram,Tamil Nadu',
'Adanur,Tiruvannamalai,Tamil Nadu',
'Devanur,Tiruvannamalai,Tamil Nadu',
'Irumbedu,Tiruvannamalai,Tamil Nadu',
'Karungalikuppam,Tiruvannamalai,Tamil Nadu',
'Mamandur,Tiruvannamalai,Tamil Nadu',
'Meyyur,Tiruvannamalai,Tamil Nadu',
'Molugampundi,Tiruvannamalai,Tamil Nadu',
'Paiyur,Tiruvannamalai,Tamil Nadu',
'Sathiyavizayanagaram,Tiruvannamalai,Tamil Nadu',
'Thalavanaickenpettai,Tiruvannamalai,Tamil Nadu',
'Veeranandal,Tiruvannamalai,Tamil Nadu',
'Velapadi,Tiruvannamalai,Tamil Nadu',
'Velleri,Tiruvannamalai,Tamil Nadu',
'Adiyanur,Tiruvannamalai,Tamil Nadu',
'Agraharapalayam,Tiruvannamalai,Tamil Nadu',
'Ammapalayam,Tiruvannamalai,Tamil Nadu',
'Ananthapuram,Tiruvannamalai,Tamil Nadu',
'Ariyapadi,Tiruvannamalai,Tamil Nadu',
'Arni Bazar,Tiruvannamalai,Tamil Nadu',
'Arni Fort,Tiruvannamalai,Tamil Nadu',
'Arni H.O,Tiruvannamalai,Tamil Nadu',
'Arunagirichatram,Tiruvannamalai,Tamil Nadu',
'Athurai,Tiruvannamalai,Tamil Nadu',
'Ayyampalayam,Tiruvannamalai,Tamil Nadu',
'Badur,Tiruvannamalai,Tamil Nadu',
'Budamangalam,Tiruvannamalai,Tamil Nadu',
'Chevur,Tiruvannamalai,Tamil Nadu',
'Devikapuram,Tiruvannamalai,Tamil Nadu',
'Kalasamudram,Tiruvannamalai,Tamil Nadu',
'Kannamangalam Bazaar,Tiruvannamalai,Tamil Nadu',
'Kannamangalam,Tiruvannamalai,Tamil Nadu',
'Kulathur,Tiruvannamalai,Tamil Nadu',
'Kunnathur Arni,Tiruvannamalai,Tamil Nadu',
'Kuppam,Tiruvannamalai,Tamil Nadu',
'Mansurabad,Tiruvannamalai,Tamil Nadu',
'Melnagar,Tiruvannamalai,Tamil Nadu',
'Modaiyur,Tiruvannamalai,Tamil Nadu',
'Mullandrum,Arakkonam,Tamil Nadu',
'Mullipattu,Tiruvannamalai,Tamil Nadu',
'Nambedu,Tiruvannamalai,Tamil Nadu',
'Narasingapuram,Tiruvannamalai,Tamil Nadu',
'Nesal,Tiruvannamalai,Tamil Nadu',
'Onnupuram,Tiruvannamalai,Tamil Nadu',
'Panaiyur,Arakkonam,Tamil Nadu',
'Poosimalaikuppam,Arakkonam,Tamil Nadu',
'Puthur,Tiruvannamalai,Tamil Nadu',
'Puthur,Arakkonam,Tamil Nadu',
'Ragunathapuram,Tiruvannamalai,Tamil Nadu',
'Rattinamangalam,Tiruvannamalai,Tamil Nadu',
'Saidapettai Arni,Tiruvannamalai,Tamil Nadu',
'Sedarampattu,Tiruvannamalai,Tamil Nadu',
'Sevarapundi,Tiruvannamalai,Tamil Nadu',
'Sirumur,Tiruvannamalai,Tamil Nadu',
'Srinivasaudayanavaram,Tiruvannamalai,Tamil Nadu',
'Thatchambadi,Tiruvannamalai,Tamil Nadu',
'Thumbur,Tiruvannamalai,Tamil Nadu',
'Vadugasathu,Tiruvannamalai,Tamil Nadu',
'Vallam Kannamangalam,Tiruvannamalai,Tamil Nadu',
'Vannankulam,Tiruvannamalai,Tamil Nadu',
'Vazhiyur,Tiruvannamalai,Tamil Nadu',
'Velliambakkam,Tiruvannamalai,Tamil Nadu',
'Vethajipuram,Arakkonam,Tamil Nadu',
'Vettiyantholuvam,Tiruvannamalai,Tamil Nadu',
'Vinnamangalamarni,Tiruvannamalai,Tamil Nadu',
'Padiagraharam,Tiruvannamalai,Tamil Nadu',
'Alathur,Tiruvannamalai,Tamil Nadu',
'Andipattu,Tiruvannamalai,Tamil Nadu',
'Arasankanni,Tiruvannamalai,Tamil Nadu',
'Arattavadi,Tiruvannamalai,Tamil Nadu',
'Athipadi,Tiruvannamalai,Tamil Nadu',
'Bhimarapatti,Tiruvannamalai,Tamil Nadu',
'C Nammiandal,Tiruvannamalai,Tamil Nadu',
'Chengam,Tiruvannamalai,Tamil Nadu',
'Chennasamudram,Tiruvannamalai,Tamil Nadu',
'Chinniampettai,Tiruvannamalai,Tamil Nadu',
'Edathanur,Tiruvannamalai,Tamil Nadu',
'Elangunni,Tiruvannamalai,Tamil Nadu',
'Eraiyur,Tiruvannamalai,Tamil Nadu',
'Japthikariandal,Tiruvannamalai,Tamil Nadu',
'Kallarai Padi,Tiruvannamalai,Tamil Nadu',
'Kallathur,Tiruvannamalai,Tamil Nadu',
'Kanji,Tiruvannamalai,Tamil Nadu',
'Karapattu,Tiruvannamalai,Tamil Nadu',
'Kariamangalam,Tiruvannamalai,Tamil Nadu',
'Kayambattu,Tiruvannamalai,Tamil Nadu',
'Kilaiyur,Tiruvannamalai,Tamil Nadu',
'Kilkuppam,Tiruvannamalai,Tamil Nadu',
'Kilpaliyapattu,Tiruvannamalai,Tamil Nadu',
'Kilsirupakkam,Tiruvannamalai,Tamil Nadu',
'Kilvanakkambadi,Tiruvannamalai,Tamil Nadu',
'Kolundampattu,Tiruvannamalai,Tamil Nadu',
'Kuppanatham,Tiruvannamalai,Tamil Nadu',
'Kuttar,Tiruvannamalai,Tamil Nadu',
'Kuyilam,Tiruvannamalai,Tamil Nadu',
'Malamanjanur,Tiruvannamalai,Tamil Nadu',
'Melarvandavadi,Tiruvannamalai,Tamil Nadu',
'Melchengam,Tiruvannamalai,Tamil Nadu',
'Melchengam West,Tiruvannamalai,Tamil Nadu',
'Melmudiyanur,Tiruvannamalai,Tamil Nadu',
'Melnachipattu,Tiruvannamalai,Tamil Nadu',
'Melpadur,Tiruvannamalai,Tamil Nadu',
'Melpallipattu,Tiruvannamalai,Tamil Nadu',
'Melpennathur,Tiruvannamalai,Tamil Nadu',
'Melpuludiyur,Tiruvannamalai,Tamil Nadu',
'Melvanakakambadi,Tiruvannamalai,Tamil Nadu',
'Mottakkal,Tiruvannamalai,Tamil Nadu',
'Munnurmangalam,Tiruvannamalai,Tamil Nadu',
'Nachipattu,Tiruvannamalai,Tamil Nadu',
'Narayanakuppam,Tiruvannamalai,Tamil Nadu',
'Neepathurai,Tiruvannamalai,Tamil Nadu',
'Oorgoundanur,Tiruvannamalai,Tamil Nadu',
'P Quilam,Tiruvannamalai,Tamil Nadu',
'Pachal,Tiruvannamalai,Tamil Nadu',
'Pakkiripalayam,Tiruvannamalai,Tamil Nadu',
'Paramanandal,Tiruvannamalai,Tamil Nadu',
'Periyakolapadi,Tiruvannamalai,Tamil Nadu',
'Perunkolathur,Tiruvannamalai,Tamil Nadu',
'Pinjur,Tiruvannamalai,Tamil Nadu',
'Pudupalayam,Tiruvannamalai,Tamil Nadu',
'Pudupattu,Tiruvannamalai,Tamil Nadu',
'Pudur Chekkadi,Tiruvannamalai,Tamil Nadu',
'Pudur Chengam,Tiruvannamalai,Tamil Nadu',
'Puliyampatti,Tiruvannamalai,Tamil Nadu',
'Radhapuram,Tiruvannamalai,Tamil Nadu',
'Rayandapuram,Tiruvannamalai,Tamil Nadu',
'Reddiarpalayam,Tiruvannamalai,Tamil Nadu',
'S Sorpanandal,Tiruvannamalai,Tamil Nadu',
'Sathanur,Tiruvannamalai,Tamil Nadu',
'Sathanurdam,Tiruvannamalai,Tamil Nadu',
'Tandarampattu,Tiruvannamalai,Tamil Nadu',
'Tanipadi,Tiruvannamalai,Tamil Nadu',
'Taradapattu,Tiruvannamalai,Tamil Nadu',
'Thenmudiyanur,Tiruvannamalai,Tamil Nadu',
'Thittandapattu,Tiruvannamalai,Tamil Nadu',
'Thorapadi,Tiruvannamalai,Tamil Nadu',
'Thukkapettai,Tiruvannamalai,Tamil Nadu',
'Tiruvadathanur,Tiruvannamalai,Tamil Nadu',
'Vadamathur,Tiruvannamalai,Tamil Nadu',
'Valayampattu,Tiruvannamalai,Tamil Nadu',
'Vasudevampattu,Tiruvannamalai,Tamil Nadu',
'Veppurchekkadi,Tiruvannamalai,Tamil Nadu',
'Alathur,Tiruvannamalai,Tamil Nadu',
'Anaputhur,Tiruvannamalai,Tamil Nadu',
'Anmarudai,Tiruvannamalai,Tamil Nadu',
'Arasanipalai,Tiruvannamalai,Tamil Nadu',
'Arugavur,Tiruvannamalai,Tamil Nadu',
'Avaniapuram,Tiruvannamalai,Tamil Nadu',
'Azhividathangi,Tiruvannamalai,Tamil Nadu',
'Brammadesam,Arakkonam,Tamil Nadu',
'Cheyyar,Tiruvannamalai,Tamil Nadu',
'Cheyyatrai Venran,Tiruvannamalai,Tamil Nadu',
'Chinnaelacheri,Tiruvannamalai,Tamil Nadu',
'Dusi,Tiruvannamalai,Tamil Nadu',
'Elanirkundram,Tiruvannamalai,Tamil Nadu',
'Erumaivetti,Tiruvannamalai,Tamil Nadu',
'Kaganam,Tiruvannamalai,Tamil Nadu',
'Kaliyur,Tiruvannamalai,Tamil Nadu',
'Kodanagar,Tiruvannamalai,Tamil Nadu',
'Korakai,Tiruvannamalai,Tamil Nadu',
'Kunnathur,Tiruvannamalai,Tamil Nadu',
'Kuthanur,Tiruvannamalai,Tamil Nadu',
'Madipakkam,Tiruvannamalai,Tamil Nadu',
'Maligaipattu,Tiruvannamalai,Tamil Nadu',
'Mamandur Kanchipuram,Tiruvannamalai,Tamil Nadu',
'Mathur,Tiruvannamalai,Tamil Nadu',
'Melsishamangalam,Tiruvannamalai,Tamil Nadu',
'Menalur,Tiruvannamalai,Tamil Nadu',
'Moranam,Tiruvannamalai,Tamil Nadu',
'Mukkur,Tiruvannamalai,Tamil Nadu',
'Munugapattu,Tiruvannamalai,Tamil Nadu',
'Murukattampundi,Tiruvannamalai,Tamil Nadu',
'Namandi,Tiruvannamalai,Tamil Nadu',
'Natteri,Arakkonam,Tamil Nadu',
'Nedumbarai,Tiruvannamalai,Tamil Nadu',
'Palli,Tiruvannamalai,Tamil Nadu',
'Pappanthangal,Tiruvannamalai,Tamil Nadu',
'Parasur,Tiruvannamalai,Tamil Nadu',
'Perumpalai,Tiruvannamalai,Tamil Nadu',
'Perungulathur,Tiruvannamalai,Tamil Nadu',
'Pudupalayam,Tiruvannamalai,Tamil Nadu',
'Pulivalam- Sunaipattu,Arakkonam,Tamil Nadu',
'Purisai,Tiruvannamalai,Tamil Nadu',
'Ramakrishnapuram,Tiruvannamalai,Tamil Nadu',
'Randam,Tiruvannamalai,Tamil Nadu',
'Sattuvanthangal,Arakkonam,Tamil Nadu',
'Sengattankundil,Tiruvannamalai,Tamil Nadu',
'Sozhavaram,Tiruvannamalai,Tamil Nadu',
'Sumangali,Tiruvannamalai,Tamil Nadu',
'Thennampattu,Arakkonam,Tamil Nadu',
'Thethurai,Tiruvannamalai,Tamil Nadu',
'Thozhupedu,Tiruvannamalai,Tamil Nadu',
'Tirumani,Tiruvannamalai,Tamil Nadu',
'Tiruppanangadu,Tiruvannamalai,Tamil Nadu',
'Tiruvettipuram Cutcherry,Tiruvannamalai,Tamil Nadu',
'Tiruvettipuram,Tiruvannamalai,Tamil Nadu',
'Ukkal,Tiruvannamalai,Tamil Nadu',
'Vadailluppai,Arakkonam,Tamil Nadu',
'Vadakalpakkm,Tiruvannamalai,Tamil Nadu',
'Vadamanapakkam,Tiruvannamalai,Tamil Nadu',
'Vadathinnalur,Tiruvannamalai,Tamil Nadu',
'Valkadai,Tiruvannamalai,Tamil Nadu',
'Vembakkam,Tiruvannamalai,Tamil Nadu',
'Vinnavadi,Tiruvannamalai,Tamil Nadu',
'Chithathur,Tiruvannamalai,Tamil Nadu',
'A K Padavedu,Tiruvannamalai,Tamil Nadu',
'Adamangalam,Tiruvannamalai,Tamil Nadu',
'Allialamangalam,Tiruvannamalai,Tamil Nadu',
'Arayalam,Tiruvannamalai,Tamil Nadu',
'Arjunapuram,Tiruvannamalai,Tamil Nadu',
'Athimoor Tindivanam,Tiruvannamalai,Tamil Nadu',
'Athipattu(T),Tirupattur,Tamil Nadu',
'Athipet,Tirupattur,Tamil Nadu',
'Athuvambadi,Tiruvannamalai,Tamil Nadu',
'Attiyanur,Tirupattur,Tamil Nadu',
'Banambattu,Tiruvannamalai,Tamil Nadu',
'Chettupattu Polur,Tiruvannamalai,Tamil Nadu',
'Elathur,Tiruvannamalai,Tamil Nadu',
'Ettivadi,Tiruvannamalai,Tamil Nadu',
'Gangavaram,Tiruvannamalai,Tamil Nadu',
'Gudalur,Tiruvannamalai,Tamil Nadu',
'Gunikanthur,Tirupattur,Tamil Nadu',
'Jamanamarathur,Tirupattur,Tamil Nadu',
'Kadaladi,Tiruvannamalai,Tamil Nadu',
'Kalambur,Tiruvannamalai,Tamil Nadu',
'Kalasapakkam,Tiruvannamalai,Tamil Nadu',
'Kalur,Tiruvannamalai,Tamil Nadu',
'Kalvasal,Tiruvannamalai,Tamil Nadu',
'Kamakkur,Tiruvannamalai,Tamil Nadu',
'Kangeyanur,Tiruvannamalai,Tamil Nadu',
'Kanthapalayam,Tiruvannamalai,Tamil Nadu',
'Kappalur,Tiruvannamalai,Tamil Nadu',
'Karapundi,Tiruvannamalai,Tamil Nadu',
'Karkonam,Tiruvannamalai,Tamil Nadu',
'Kasthambadi,Tiruvannamalai,Tamil Nadu',
'Kattukanur,Tiruvannamalai,Tamil Nadu',
'Kelur,Tiruvannamalai,Tamil Nadu',
'Kesavapuram,Tiruvannamalai,Tamil Nadu',
'Kettavarampalayam,Tiruvannamalai,Tamil Nadu',
'Kidampalayam,Tiruvannamalai,Tamil Nadu',
'Kilpalur,Tiruvannamalai,Tamil Nadu',
'Kovilur,Tirupattur,Tamil Nadu',
'Krishnapuram,Tiruvannamalai,Tamil Nadu',
'Kuruvimalai,Tiruvannamalai,Tamil Nadu',
'Kuttakarai,Tirupattur,Tamil Nadu',
'Kuttathur,Tirupattur,Tamil Nadu',
'Ladavaram,Tiruvannamalai,Tamil Nadu',
'Mambattu,Tiruvannamalai,Tamil Nadu',
'Mandakolathur,Tiruvannamalai,Tamil Nadu',
'Mandaparai,Tirupattur,Tamil Nadu',
'Maruthuvampadi,Tiruvannamalai,Tamil Nadu',
'Melpattu (T),Tirupattur,Tamil Nadu',
'Melsilambadi,Tirupattur,Tamil Nadu',
'Melsolankuppam,Tiruvannamalai,Tamil Nadu',
'Morakkannianur,Tiruvannamalai,Tamil Nadu',
'Mukkurumbai,Tiruvannamalai,Tamil Nadu',
'Murugapadi,Tiruvannamalai,Tamil Nadu',
'Nachamalai,Tirupattur,Tamil Nadu',
'Nadukuppam,Tiruvannamalai,Tamil Nadu',
'Nirmalarani Colony,Tiruvannamalai,Tamil Nadu',
'Odalavadi,Tiruvannamalai,Tamil Nadu',
'Padagam,Tiruvannamalai,Tamil Nadu',
'Palamarathur,Tirupattur,Tamil Nadu',
'Palampettai,Tiruvannamalai,Tamil Nadu',
'Palankoil,Tiruvannamalai,Tamil Nadu',
'Pathiyavadi,Tiruvannamalai,Tamil Nadu',
'Pattaraikadu,Tirupattur,Tamil Nadu',
'Pelasur,Tiruvannamalai,Tamil Nadu',
'Periagaram,Tiruvannamalai,Tamil Nadu',
'Polur,Tiruvannamalai,Tamil Nadu',
'Polur Town,Tiruvannamalai,Tamil Nadu',
'Potharai,Tiruvannamalai,Tamil Nadu',
'Pulavanpadi,Tiruvannamalai,Tamil Nadu',
'Pulivanandal,Tiruvannamalai,Tamil Nadu',
'Puliyur (T),Tirupattur,Tamil Nadu',
'Pundi Polur,Tiruvannamalai,Tamil Nadu',
'Punganbadi,Tiruvannamalai,Tamil Nadu',
'R.Kunnathur,Tiruvannamalai,Tamil Nadu',
'Ramanathapuram,Tiruvannamalai,Tamil Nadu',
'Saduperipalayam,Tiruvannamalai,Tamil Nadu',
'Sanikkavadi,Tiruvannamalai,Tamil Nadu',
'Santhavasal,Tiruvannamalai,Tamil Nadu',
'Semmiyamangalam,Tiruvannamalai,Tamil Nadu',
'Sengunam,Tiruvannamalai,Tamil Nadu',
'Siruvallur,Tiruvannamalai,Tamil Nadu',
'Susainagar,Tiruvannamalai,Tamil Nadu',
'Thatchur,Tiruvannamalai,Tamil Nadu',
'Thenmahadevamangalam,Tiruvannamalai,Tamil Nadu',
'Thenpallipattu,Tiruvannamalai,Tamil Nadu',
'Thumbakkadu,Tiruvannamalai,Tamil Nadu',
'Tirumala,Tiruvannamalai,Tamil Nadu',
'Tirusur,Tiruvannamalai,Tamil Nadu',
'Ulagampattu,Tiruvannamalai,Tamil Nadu',
'Vadamadimangalam,Tiruvannamalai,Tamil Nadu',
'Vasur,Tiruvannamalai,Tamil Nadu',
'Veerappanur,Tirupattur,Tamil Nadu',
'Vellur,Tiruvannamalai,Tamil Nadu',
'Vilapakkam,Tiruvannamalai,Tamil Nadu',
'Vilvarani,Tiruvannamalai,Tamil Nadu',
'Viralur,Tiruvannamalai,Tamil Nadu',
'Perumanam,Tiruvannamalai,Tamil Nadu',
'Kikkalur,Tiruvannamalai,Tamil Nadu',
'Kattampoondi,Tiruvannamalai,Tamil Nadu',
'Vaipur,Tiruvannamalai,Tamil Nadu',
'Kalasthambadi,Tiruvannamalai,Tamil Nadu',
'Nallavanpalayam,Tiruvannamalai,Tamil Nadu',
'Tandarai,Tiruvannamalai,Tamil Nadu',
'Tiruvannamalai Bazaar,Tiruvannamalai,Tamil Nadu',
'Sorakolathur,Tiruvannamalai,Tamil Nadu',
'Tiruvannamalai RS,Tiruvannamalai,Tamil Nadu',
'Thennagaram,Tiruvannamalai,Tamil Nadu',
'Veluganandal,Tiruvannamalai,Tamil Nadu',
'Adaiyur,Tiruvannamalai,Tamil Nadu',
'Adiannamalai,Tiruvannamalai,Tamil Nadu',
'Allikondapattu,Tiruvannamalai,Tamil Nadu',
'Andampallam,Tiruvannamalai,Tamil Nadu',
'Aradapattu,Tiruvannamalai,Tamil Nadu',
'Arpakkam,Tiruvannamalai,Tamil Nadu',
'Arudirapattu,Tiruvannamalai,Tamil Nadu',
'Ayyampalayam,Tiruvannamalai,Tamil Nadu',
'Ayyankulam,Tiruvannamalai,Tamil Nadu',
'Chellankuppam,Tiruvannamalai,Tamil Nadu',
'Chinnakallapadi,Tiruvannamalai,Tamil Nadu',
'Devanambattu,Tiruvannamalai,Tamil Nadu',
'Elayankanni,Tiruvannamalai,Tamil Nadu',
'Esanyamadam,Tiruvannamalai,Tamil Nadu',
'Gangapattu,Tiruvannamalai,Tamil Nadu',
'Gudalur,Tiruvannamalai,Tamil Nadu',
'Inamkariyandal,Tiruvannamalai,Tamil Nadu',
'Isukkalikatteri,Tiruvannamalai,Tamil Nadu',
'Kadagaman,Tiruvannamalai,Tamil Nadu',
'Kallayee Sorathur,Tiruvannamalai,Tamil Nadu',
'Kalnagar,Tiruvannamalai,Tamil Nadu',
'Kanalapadi,Tiruvannamalai,Tamil Nadu',
'Kattumalayanur,Tiruvannamalai,Tamil Nadu',
'Kilkarippur,Tiruvannamalai,Tamil Nadu',
'Kilnachipattu,Tiruvannamalai,Tamil Nadu',
'Kilpennathur,Tiruvannamalai,Tamil Nadu',
'Kolakkaravadi,Tiruvannamalai,Tamil Nadu',
'Kolakudi,Tiruvannamalai,Tamil Nadu',
'Konalur,Tiruvannamalai,Tamil Nadu',
'Kothandavadi,Tiruvannamalai,Tamil Nadu',
'Kulathur,Tiruvannamalai,Tamil Nadu',
'Madurampattu,Tiruvannamalai,Tamil Nadu',
'Malappambadi,Tiruvannamalai,Tamil Nadu',
'Mallavadi,Tiruvannamalai,Tamil Nadu',
'Mangalam,Tiruvannamalai,Tamil Nadu',
'Maruthuvambadi,Tiruvannamalai,Tamil Nadu',
'Mekkalur,Tiruvannamalai,Tamil Nadu',
'Meyyur,Tiruvannamalai,Tamil Nadu',
'Moongilthuraipattu,Vriddhachalam,Tamil Nadu',
'Naraiyur,Tiruvannamalai,Tamil Nadu',
'Nariyapattu,Tiruvannamalai,Tamil Nadu',
'Nayudumangalam,Tiruvannamalai,Tamil Nadu',
'Neivanatham,Tiruvannamalai,Tamil Nadu',
'Nookambadi,Tiruvannamalai,Tamil Nadu',
'Northampoondi,Tiruvannamalai,Tamil Nadu',
'Olaipadi,Tiruvannamalai,Tamil Nadu',
'Palanandal,Tiruvannamalai,Tamil Nadu',
'Palavalam,Tiruvannamalai,Tamil Nadu',
'Palayanur,Tiruvannamalai,Tamil Nadu',
'Pallikondapattu,Tiruvannamalai,Tamil Nadu',
'Pandithapattu,Tiruvannamalai,Tamil Nadu',
'Parayampattu,Tiruvannamalai,Tamil Nadu',
'Pavithiram,Tiruvannamalai,Tamil Nadu',
'Periyakilambadi,Tiruvannamalai,Tamil Nadu',
'Perunthuraipattu,Tiruvannamalai,Tamil Nadu',
'Porkunam,Tiruvannamalai,Tamil Nadu',
'Serpapattu,Tiruvannamalai,Tamil Nadu',
'Somasipadi,Tiruvannamalai,Tamil Nadu',
'Sriramanashramam,Tiruvannamalai,Tamil Nadu',
'Su Andapattu,Tiruvannamalai,Tamil Nadu',
'Su Papambadi,Tiruvannamalai,Tamil Nadu',
'Su Valavetti,Tiruvannamalai,Tamil Nadu',
'Thatchampattu,Tiruvannamalai,Tamil Nadu',
'Thenkarimbalur,Tiruvannamalai,Tamil Nadu',
'Thenmathur,Tiruvannamalai,Tamil Nadu',
'Tiruvannamalai H.O,Tiruvannamalai,Tamil Nadu',
'Turinjapuram,Tiruvannamalai,Tamil Nadu',
'Valavachanur,Tiruvannamalai,Tamil Nadu',
'Vallivagai,Tiruvannamalai,Tamil Nadu',
'Vanapuram,Tiruvannamalai,Tamil Nadu',
'Varagur,Tiruvannamalai,Tamil Nadu',
'Vedanatham,Tiruvannamalai,Tamil Nadu',
'Vedanthavadi,Tiruvannamalai,Tamil Nadu',
'Velayampakkam,Tiruvannamalai,Tamil Nadu',
'Vengikkal,Tiruvannamalai,Tamil Nadu',
'Veraiyur,Tiruvannamalai,Tamil Nadu',
'Vettavalam,Tiruvannamalai,Tamil Nadu',
'Avur,Tiruvannamalai,Tamil Nadu',
'Rajapalayam,Tiruvannamalai,Tamil Nadu',
'Kiliyapattu,Tiruvannamalai,Tamil Nadu',
'Rayampettai,Tiruvannamalai,Tamil Nadu',
'Sirunathur,Tiruvannamalai,Tamil Nadu',
'Valudalangunam,Tiruvannamalai,Tamil Nadu',
'Erumpoondi,Tiruvannamalai,Tamil Nadu',
'Sanipundi,Tiruvannamalai,Tamil Nadu',
'Akkur,Tiruvannamalai,Tamil Nadu',
'Alliyandal,Tiruvannamalai,Tamil Nadu',
'Ammayapattu,Tiruvannamalai,Tamil Nadu',
'Amudur,Tiruvannamalai,Tamil Nadu',
'Arasampattu,Tiruvannamalai,Tamil Nadu',
'Arasur,Tiruvannamalai,Tamil Nadu',
'Ayalpadi,Tiruvannamalai,Tamil Nadu',
'Chitragavur Pudur,Tiruvannamalai,Tamil Nadu',
'Desur,Tiruvannamalai,Tamil Nadu',
'Echur,Tiruvannamalai,Tamil Nadu',
'Embalam,Tiruvannamalai,Tamil Nadu',
'Endal,Tiruvannamalai,Tamil Nadu',
'Erumbur,Tiruvannamalai,Tamil Nadu',
'Hasanamapettai,Tiruvannamalai,Tamil Nadu',
'Ilangadu,Tiruvannamalai,Tamil Nadu',
'Indiravanam,Tiruvannamalai,Tamil Nadu',
'Injimedu,Tiruvannamalai,Tamil Nadu',
'Irumbedu,Tiruvannamalai,Tamil Nadu',
'Japthikarani,Tiruvannamalai,Tamil Nadu',
'Kadambai,Tiruvannamalai,Tamil Nadu',
'Kadavaratti,Tiruvannamalai,Tamil Nadu',
'Kaduganur,Tiruvannamalai,Tamil Nadu',
'Kilkodungalur,Tiruvannamalai,Tamil Nadu',
'Kilkovalavedu,Tiruvannamalai,Tamil Nadu',
'Kilnamandi,Tiruvannamalai,Tamil Nadu',
'Kilnarma,Tiruvannamalai,Tamil Nadu',
'Kilputhur,Tiruvannamalai,Tamil Nadu',
'Kilvillivalam,Tiruvannamalai,Tamil Nadu',
'Kodanallur,Tiruvannamalai,Tamil Nadu',
'Kodiyalam,Tiruvannamalai,Tamil Nadu',
'Kolappalur,Tiruvannamalai,Tamil Nadu',
'Kottai,Tiruvannamalai,Tamil Nadu',
'Kovilur,Tiruvannamalai,Tamil Nadu',
'Kunnakampoondi,Tiruvannamalai,Tamil Nadu',
'Kuvalai,Tiruvannamalai,Tamil Nadu',
'Mahamayee Tirumani,Tiruvannamalai,Tamil Nadu',
'Malayur,Tiruvannamalai,Tamil Nadu',
'Manganallur,Tiruvannamalai,Tamil Nadu',
'Marudadu,Tiruvannamalai,Tamil Nadu',
'Matam,Tiruvannamalai,Tamil Nadu',
'Melachery,Tiruvannamalai,Tamil Nadu',
'Melathangal,Tiruvannamalai,Tamil Nadu',
'Melma,Tiruvannamalai,Tamil Nadu',
'Melnemili,Tiruvannamalai,Tamil Nadu',
'Melpathi,Tiruvannamalai,Tamil Nadu',
'Mosavadi,Tiruvannamalai,Tamil Nadu',
'Nallur,Tiruvannamalai,Tamil Nadu',
'Namathodu,Tiruvannamalai,Tamil Nadu',
'Nambedu,Tiruvannamalai,Tamil Nadu',
'Narayanamangalam,Tiruvannamalai,Tamil Nadu',
'Navalpakkam,Tiruvannamalai,Tamil Nadu',
'Nedungunam,Tiruvannamalai,Tamil Nadu',
'Nelliyankulam,Tiruvannamalai,Tamil Nadu',
'Nerkunam,Tiruvannamalai,Tamil Nadu',
'Osur,Tiruvannamalai,Tamil Nadu',
'Pennattagaram,Tiruvannamalai,Tamil Nadu',
'Pernamallur,Tiruvannamalai,Tamil Nadu',
'Pillanthangal,Tiruvannamalai,Tamil Nadu',
'Ponnur,Tiruvannamalai,Tamil Nadu',
'Ragunathasamudram,Tiruvannamalai,Tamil Nadu',
'Salukkai,Tiruvannamalai,Tamil Nadu',
'Salvedu,Tiruvannamalai,Tamil Nadu',
'Sathapundi,Tiruvannamalai,Tamil Nadu',
'Semmambadi,Tiruvannamalai,Tamil Nadu',
'Senal,Tiruvannamalai,Tamil Nadu',
'Sengadu,Tiruvannamalai,Tamil Nadu',
'Sennavaram,Tiruvannamalai,Tamil Nadu',
'Shronavalpakkam,Tiruvannamalai,Tamil Nadu',
'Tellar,Tiruvannamalai,Tamil Nadu',
'Thaiyar,Tiruvannamalai,Tamil Nadu',
'Thenelapakkam,Tiruvannamalai,Tamil Nadu',
'Thennankur,Tiruvannamalai,Tamil Nadu',
'Thennathur,Tiruvannamalai,Tamil Nadu',
'Therasapuram,Tiruvannamalai,Tamil Nadu',
'Tirumpundi,Tiruvannamalai,Tamil Nadu',
'Ulundai,Tiruvannamalai,Tamil Nadu',
'Vadavanakambadi,Tiruvannamalai,Tamil Nadu',
'Vallam Arni,Tiruvannamalai,Tamil Nadu',
'Vandavasi Cutcherry,Tiruvannamalai,Tamil Nadu',
'Vandavasi,Tiruvannamalai,Tamil Nadu',
'Vayalamoor,Tiruvannamalai,Tamil Nadu',
'Vayalur,Tiruvannamalai,Tamil Nadu',
'Vazhur,Tiruvannamalai,Tamil Nadu',
'Vedal,Tiruvannamalai,Tamil Nadu',
'Veeppambattu,Tiruvannamalai,Tamil Nadu',
'Veerambakkam-pudur,Tiruvannamalai,Tamil Nadu',
'Vengalathur,Tiruvannamalai,Tamil Nadu',
'Vengaram,Tiruvannamalai,Tamil Nadu',
'Anukkavur,Tiruvannamalai,Tamil Nadu',
'Melmattaivinnamangalam,Tiruvannamalai,Tamil Nadu',
'Tellur,Tiruvannamalai,Tamil Nadu',
'Mavalavadi,Tiruvannamalai,Tamil Nadu',
'Asesham,Thanjavur,Tamil Nadu',
'Kilapalam,Thanjavur,Tamil Nadu',
'Mannarkudi South,Thanjavur,Tamil Nadu',
'Melavasal,Thanjavur,Tamil Nadu',
'Muvanallur,Thanjavur,Tamil Nadu',
'Nagai,Thanjavur,Tamil Nadu',
'Neduvakottai,Thanjavur,Tamil Nadu',
'Serumangalam,Thanjavur,Tamil Nadu',
'Sundarakottai,Thanjavur,Tamil Nadu',
'Vanakkara Street,Thanjavur,Tamil Nadu',
'Agaraohai,Kumbakonam,Tamil Nadu',
'Ammayappan,Nagapattinam,Tamil Nadu',
'Arasavanangadu,Kumbakonam,Tamil Nadu',
'Athisolamangalam,Nagapattinam,Tamil Nadu',
'Elavangargudi,Nagapattinam,Tamil Nadu',
'Erukattur,Nagapattinam,Tamil Nadu',
'Kadalangudi,Kumbakonam,Tamil Nadu',
'Kamalapuram,Nagapattinam,Tamil Nadu',
'Kandramanickam,Kumbakonam,Tamil Nadu',
'Kankoduthavanitham,Nagapattinam,Tamil Nadu',
'Kattur,Nagapattinam,Tamil Nadu',
'Kilapalaiyur,Kumbakonam,Tamil Nadu',
'Kodavasal,Kumbakonam,Tamil Nadu',
'Kulikarai,Nagapattinam,Tamil Nadu',
'Kundalur,Kumbakonam,Tamil Nadu',
'Manakal Ayyampet,Nagapattinam,Tamil Nadu',
'Manjakudi,Kumbakonam,Tamil Nadu',
'Melapalayur,Kumbakonam,Tamil Nadu',
'Moolangudi,Kumbakonam,Tamil Nadu',
'Mugunthanur,Nagapattinam,Tamil Nadu',
'Pakkamparuthiyur,Kumbakonam,Tamil Nadu',
'Perumpannaiyur,Kumbakonam,Tamil Nadu',
'Pudukudi,Kumbakonam,Tamil Nadu',
'Pudukudi,Kumbakonam,Tamil Nadu',
'Sarabojirajapuram,Mayiladuthurai,Tamil Nadu',
'Sarguneswarapuram,Kumbakonam,Tamil Nadu',
'Sembangudi,Kumbakonam,Tamil Nadu',
'Sengalipuram,Kumbakonam,Tamil Nadu',
'Senganur,Kumbakonam,Tamil Nadu',
'Serukalathur,Kumbakonam,Tamil Nadu',
'Sidakkamangalam,Kumbakonam,Tamil Nadu',
'Simili,Kumbakonam,Tamil Nadu',
'Sithadi,Kumbakonam,Tamil Nadu',
'Solachery,Nagapattinam,Tamil Nadu',
'Srivanjiam,Kumbakonam,Tamil Nadu',
'Thazhakudi,Nagapattinam,Tamil Nadu',
'Tiruchirai,Kumbakonam,Tamil Nadu',
'Tirukannamangai,Nagapattinam,Tamil Nadu',
'Tiruvidacherry,Kumbakonam,Tamil Nadu',
'Vadaver,Kumbakonam,Tamil Nadu',
'Veedhividangan,Kumbakonam,Tamil Nadu',
'Vellakulam,Kumbakonam,Tamil Nadu',
'Vikrapandiyam,Kumbakonam,Tamil Nadu',
'Vilagam,Kumbakonam,Tamil Nadu',
'Paruthiyur,Kumbakonam,Tamil Nadu',
'Abivirthiswaram,Kumbakonam,Tamil Nadu',
'Barakadabad,Kumbakonam,Tamil Nadu',
'Hanumanthapuram,Kumbakonam,Tamil Nadu',
'Ilaiyur,Kumbakonam,Tamil Nadu',
'Kalathur,Kumbakonam,Tamil Nadu',
'Kilariam,Kumbakonam,Tamil Nadu',
'Oorgudi,Kumbakonam,Tamil Nadu',
'Pathur,Kumbakonam,Tamil Nadu',
'Perumalagaram,Kumbakonam,Tamil Nadu',
'Vennavasal,Kumbakonam,Tamil Nadu',
'Adichapuram,Thanjavur,Tamil Nadu',
'Alankottai,Thanjavur,Tamil Nadu',
'Budamangalam,Nagapattinam,Tamil Nadu',
'Elavanur,Thanjavur,Tamil Nadu',
'Gopalasamudram,Thanjavur,Tamil Nadu',
'Ida Melaiyur,Thanjavur,Tamil Nadu',
'Idakilaiyur,Thanjavur,Tamil Nadu',
'Irulneeki,Thanjavur,Tamil Nadu',
'Kalanjimodu,Thanjavur,Tamil Nadu',
'Kalavaikarai,Thanjavur,Tamil Nadu',
'Kandithampettai,Thanjavur,Tamil Nadu',
'Kaniyakurichi,Thanjavur,Tamil Nadu',
'Karaikottai,Thanjavur,Tamil Nadu',
'Karunavur,Thanjavur,Tamil Nadu',
'Karunavur,Thanjavur,Tamil Nadu',
'Karuppakilar,Thanjavur,Tamil Nadu',
'Karuvakurichi,Thanjavur,Tamil Nadu',
'Kattakudi,Thanjavur,Tamil Nadu',
'Keeralathur,Nagapattinam,Tamil Nadu',
'Kezhuvathur,Thanjavur,Tamil Nadu',
'Kilapanaiyur,Thanjavur,Tamil Nadu',
'Koopachikottai,Thanjavur,Tamil Nadu',
'Koothanallur,Thanjavur,Tamil Nadu',
'Kottur,Thanjavur,Tamil Nadu',
'Kunniyur,Thanjavur,Tamil Nadu',
'Lakshmangudi,Thanjavur,Tamil Nadu',
'Mahadevapattinam,Thanjavur,Tamil Nadu',
'Mannargudi Bazaar,Thanjavur,Tamil Nadu',
'Mannargudi H.O,Thanjavur,Tamil Nadu',
'Mannargudi West,Thanjavur,Tamil Nadu',
'Mannukkumundan,Thanjavur,Tamil Nadu',
'Mavattagudi,Thanjavur,Tamil Nadu',
'Melanatham,Thanjavur,Tamil Nadu',
'Melanemmeli,Thanjavur,Tamil Nadu',
'Melapanaiyur,Thanjavur,Tamil Nadu',
'Moovarkottai,Thanjavur,Tamil Nadu',
'Mukkul.Am Sathanur,Thanjavur,Tamil Nadu',
'Naduvakalappal,Thanjavur,Tamil Nadu',
'Nallikottai,Thanjavur,Tamil Nadu',
'Nallur-ttp,Thanjavur,Tamil Nadu',
'Naruvelikalappal,Thanjavur,Tamil Nadu',
'Nemmeli-mng,Thanjavur,Tamil Nadu',
'Painganadu,Thanjavur,Tamil Nadu',
'Paingattur,Thanjavur,Tamil Nadu',
'Palaiyur,Thanjavur,Tamil Nadu',
'Palayakottai,Thanjavur,Tamil Nadu',
'Pamani-mng,Thanjavur,Tamil Nadu',
'Paravakottai,Thanjavur,Tamil Nadu',
'Peraiyur,Thanjavur,Tamil Nadu',
'Periyakuruvadi,Thanjavur,Tamil Nadu',
'Peruvazhandan,Thanjavur,Tamil Nadu',
'Pulithikudi,Thanjavur,Tamil Nadu',
'Puthagaram,Thanjavur,Tamil Nadu',
'Radhanarasimhapuram,Thanjavur,Tamil Nadu',
'Rajappaiyanchavadi,Thanjavur,Tamil Nadu',
'Renganathapuram,Thanjavur,Tamil Nadu',
'Sadayarkoil,Thanjavur,Tamil Nadu',
'Sendamangalam(TTP),Thanjavur,Tamil Nadu',
'Serangolam,Thanjavur,Tamil Nadu',
'Seruvamani,Nagapattinam,Tamil Nadu',
'Sithamalli,Thanjavur,Tamil Nadu',
'Sokkanavur,Thanjavur,Tamil Nadu',
'Solapandi,Thanjavur,Tamil Nadu',
'Talayamangalam(MNG),Thanjavur,Tamil Nadu',
'Tenparai,Thanjavur,Tamil Nadu',
'Terkunanallur,Thanjavur,Tamil Nadu',
'Tirukalar,Thanjavur,Tamil Nadu',
'Tirumakottai,Thanjavur,Tamil Nadu',
'Tirunellikaval,Nagapattinam,Tamil Nadu',
'Tirupalakudi,Thanjavur,Tamil Nadu',
'Tiruvanduthurai,Thanjavur,Tamil Nadu',
'Ullikottai,Thanjavur,Tamil Nadu',
'Vadapathimangalam,Thanjavur,Tamil Nadu',
'Vaduvur,Thanjavur,Tamil Nadu',
'Vaduvur Thenpathi,Thanjavur,Tamil Nadu',
'Vaduvur Vadapathi,Thanjavur,Tamil Nadu',
'Vallur,Thanjavur,Tamil Nadu',
'Vattar,Thanjavur,Tamil Nadu',
'Velukudi,Nagapattinam,Tamil Nadu',
'Vikkirapandiyam,Nagapattinam,Tamil Nadu',
'Haridranathi,Thanjavur,Tamil Nadu',
'Suranur,Nagapattinam,Tamil Nadu',
'Achuthamangalam,Nagapattinam,Tamil Nadu',
'Adambar,Nagapattinam,Tamil Nadu',
'Agarathirumalam,Mayiladuthurai,Tamil Nadu',
'Alangudi,Nagapattinam,Tamil Nadu',
'Alathur,Mayiladuthurai,Tamil Nadu',
'Anaikuppam,Nagapattinam,Tamil Nadu',
'Injikudi,Mayiladuthurai,Tamil Nadu',
'Kaliyakudi,Mayiladuthurai,Tamil Nadu',
'Keeranur,Mayiladuthurai,Tamil Nadu',
'Kollapuram,Nagapattinam,Tamil Nadu',
'Kollumangudi,Mayiladuthurai,Tamil Nadu',
'Koothanur,Mayiladuthurai,Tamil Nadu',
'Kurungulam,Nagapattinam,Tamil Nadu',
'Manandakudi,Mayiladuthurai,Tamil Nadu',
'Mappilaikuppam,Nagapattinam,Tamil Nadu',
'Maruduvancheri,Mayiladuthurai,Tamil Nadu',
'Menangudi,Nagapattinam,Tamil Nadu',
'Moongilkudi,Nagapattinam,Tamil Nadu',
'Mudikondan,Nagapattinam,Tamil Nadu',
'Nannilam Cutchery,Nagapattinam,Tamil Nadu',
'Nannilam,Nagapattinam,Tamil Nadu',
'Nedungulam,Mayiladuthurai,Tamil Nadu',
'Nemmeli,Nagapattinam,Tamil Nadu',
'Panangudi,Nagapattinam,Tamil Nadu',
'Pavattakudi,Mayiladuthurai,Tamil Nadu',
'Peralam,Mayiladuthurai,Tamil Nadu',
'Pillur,Mayiladuthurai,Tamil Nadu',
'Punthottam,Mayiladuthurai,Tamil Nadu',
'Saliperi,Nagapattinam,Tamil Nadu',
'Selvapuram,Nagapattinam,Tamil Nadu',
'Sembiyanallur,Mayiladuthurai,Tamil Nadu',
'Sirupuliyur,Mayiladuthurai,Tamil Nadu',
'Thuthukudi,Nagapattinam,Tamil Nadu',
'Tirukottaram,Nagapattinam,Tamil Nadu',
'Tirumeichur,Mayiladuthurai,Tamil Nadu',
'Ubayavedanthapuram,Nagapattinam,Tamil Nadu',
'Vadagudi,Nagapattinam,Tamil Nadu',
'Velangudi,Nagapattinam,Tamil Nadu',
'Visalur,Nagapattinam,Tamil Nadu',
'Adangudi,Thanjavur,Tamil Nadu',
'Adanur(KVN),Thanjavur,Tamil Nadu',
'Alangudi,Thanjavur,Tamil Nadu',
'Aravoor,Thanjavur,Tamil Nadu',
'Chettichatram,Thanjavur,Tamil Nadu',
'Chittamalli-nid,Thanjavur,Tamil Nadu',
'Devangudi,Thanjavur,Tamil Nadu',
'Harischandrapuram,Thanjavur,Tamil Nadu',
'Kalacheri,Thanjavur,Tamil Nadu',
'Kilapattu,Thanjavur,Tamil Nadu',
'Koothanallur East,Thanjavur,Tamil Nadu',
'Kothangudi,Thanjavur,Tamil Nadu',
'Kottugacheri,Thanjavur,Tamil Nadu',
'Kovilvenni Bazaar,Thanjavur,Tamil Nadu',
'Kovilvenni,Thanjavur,Tamil Nadu',
'Kudithangicheri,Thanjavur,Tamil Nadu',
'Manjanavadi,Thanjavur,Tamil Nadu',
'Melalavandaseri,Thanjavur,Tamil Nadu',
'Mullaivasal,Thanjavur,Tamil Nadu',
'Munnavalkottai,Thanjavur,Tamil Nadu',
'Nahangudi,Thanjavur,Tamil Nadu',
'Narasingamangalam,Thanjavur,Tamil Nadu',
'Nidamangalam Bazaar,Thanjavur,Tamil Nadu',
'Nidamangalam,Thanjavur,Tamil Nadu',
'Olimidi,Thanjavur,Tamil Nadu',
'Palayanur-ktn,Thanjavur,Tamil Nadu',
'Perambur,Thanjavur,Tamil Nadu',
'Podakudi,Thanjavur,Tamil Nadu',
'Pullamangalam,Thanjavur,Tamil Nadu',
'Pullavarayankudikadu,Thanjavur,Tamil Nadu',
'Puvanur,Thanjavur,Tamil Nadu',
'Rayapuram,Thanjavur,Tamil Nadu',
'Sathanur(KTN),Thanjavur,Tamil Nadu',
'Savalakkaran,Thanjavur,Tamil Nadu',
'Segarai,Thanjavur,Tamil Nadu',
'Sendangudi,Thanjavur,Tamil Nadu',
'Tanneerkunnam,Thanjavur,Tamil Nadu',
'Vadakovanur,Thanjavur,Tamil Nadu',
'Melanammankurichi,Pattukottai,Tamil Nadu',
'Alangadu,Pattukottai,Tamil Nadu',
'Alangadu Uppur,Pattukottai,Tamil Nadu',
'Alathambadi,Nagapattinam,Tamil Nadu',
'Andankarai,Nagapattinam,Tamil Nadu',
'Ariyalur,Pattukottai,Tamil Nadu',
'Devadanam,Pattukottai,Tamil Nadu',
'Divammapuram,Pattukottai,Tamil Nadu',
'Ezhilur,Pattukottai,Tamil Nadu',
'Idaiyur,Pattukottai,Tamil Nadu',
'Idumbavanam,Pattukottai,Tamil Nadu',
'Jambavanodai,Pattukottai,Tamil Nadu',
'Kachanam,Nagapattinam,Tamil Nadu',
'Kadiacheri,Pattukottai,Tamil Nadu',
'Karpaganatharkulam,Pattukottai,Tamil Nadu',
'Kattimodu,Pattukottai,Tamil Nadu',
'Keerakalur,Pattukottai,Tamil Nadu',
'Kilanammankurichi,Pattukottai,Tamil Nadu',
'Kilapandi,Pattukottai,Tamil Nadu',
'Kilaperumalai,Pattukottai,Tamil Nadu',
'Korukkai,Pattukottai,Tamil Nadu',
'Kothamangalam,Pattukottai,Tamil Nadu',
'Kovilur,Pattukottai,Tamil Nadu',
'Kulamanickam,Pattukottai,Tamil Nadu',
'Kummattitidal,Pattukottai,Tamil Nadu',
'Kunnalur,Pattukottai,Tamil Nadu',
'Kunnur,Nagapattinam,Tamil Nadu',
'Manali,Nagapattinam,Tamil Nadu',
'Mangudi,Thanjavur,Tamil Nadu',
'Marudavanam,Thanjavur,Tamil Nadu',
'Melamarudur,Pattukottai,Tamil Nadu',
'Melaperumalai,Pattukottai,Tamil Nadu',
'Mettupalayam,Pattukottai,Tamil Nadu',
'Mutupet,Pattukottai,Tamil Nadu',
'Nedumbalam,Pattukottai,Tamil Nadu',
'Ovarur,Pattukottai,Tamil Nadu',
'Pamani-TTP,Pattukottai,Tamil Nadu',
'Pettai,Pattukottai,Tamil Nadu',
'Pichankottagam,Pattukottai,Tamil Nadu',
'Pinnathur,Pattukottai,Tamil Nadu',
'Ponnirai,Nagapattinam,Tamil Nadu',
'Rayanallur,Pattukottai,Tamil Nadu',
'Sembadavankadu,Pattukottai,Tamil Nadu',
'Thambikottai,Pattukottai,Tamil Nadu',
'Thillaivilagam,Pattukottai,Tamil Nadu',
'Thillaivilagam South,Pattukottai,Tamil Nadu',
'Tiruturaipundi Bazaar,Pattukottai,Tamil Nadu',
'Tiruturaipundi H.O,Pattukottai,Tamil Nadu',
'Tiruturaipundi R.S.,Pattukottai,Tamil Nadu',
'Tondiakkadu,Pattukottai,Tamil Nadu',
'Udayamarthandapuram,Pattukottai,Tamil Nadu',
'Vadiakadu,Pattukottai,Tamil Nadu',
'Vellur-ttp,Pattukottai,Tamil Nadu',
'Veppancheri,Pattukottai,Tamil Nadu',
'Vilakudi,Pattukottai,Tamil Nadu',
'Vittukatti,Pattukottai,Tamil Nadu',
'Ammanur,Nagapattinam,Tamil Nadu',
'Komal,Nagapattinam,Tamil Nadu',
'Adiakkamangalam,Nagapattinam,Tamil Nadu',
'Alivalam,Nagapattinam,Tamil Nadu',
'Amur,Nagapattinam,Tamil Nadu',
'Andipalayam,Nagapattinam,Tamil Nadu',
'Authur,Nagapattinam,Tamil Nadu',
'Dakshinamurthi Mutt,Nagapattinam,Tamil Nadu',
'Kallikudi,Nagapattinam,Tamil Nadu',
'Kalyanamahadevi,Nagapattinam,Tamil Nadu',
'Kekkarai,Nagapattinam,Tamil Nadu',
'Kidarankondan,Nagapattinam,Tamil Nadu',
'Kilamanali,Nagapattinam,Tamil Nadu',
'Kilapadugai,Nagapattinam,Tamil Nadu',
'Kodikalpalayam,Nagapattinam,Tamil Nadu',
'Koradacheri,Kumbakonam,Tamil Nadu',
'Madapuram,Nagapattinam,Tamil Nadu',
'Mangudi,Nagapattinam,Tamil Nadu',
'Mavoor,Nagapattinam,Tamil Nadu',
'Meiporul Nagar,Nagapattinam,Tamil Nadu',
'Nadapur,Nagapattinam,Tamil Nadu',
'New Street,Nagapattinam,Tamil Nadu',
'Palayavalam,Nagapattinam,Tamil Nadu',
'Pudupathur,Nagapattinam,Tamil Nadu',
'Pulivalam,Nagapattinam,Tamil Nadu',
'Sellur,Kumbakonam,Tamil Nadu',
'Semangalam,Nagapattinam,Tamil Nadu',
'Thandalai,Nagapattinam,Tamil Nadu',
'Thappalampuliyur,Nagapattinam,Tamil Nadu',
'Tirukaravasal,Nagapattinam,Tamil Nadu',
'Tirunattiyathankudi,Nagapattinam,Tamil Nadu',
'Tiruneipair,Nagapattinam,Tamil Nadu',
'Tiruvarur H.O,Nagapattinam,Tamil Nadu',
'Tiruvarur North,Nagapattinam,Tamil Nadu',
'Vaipur,Nagapattinam,Tamil Nadu',
'Vilamal,Nagapattinam,Tamil Nadu',
'Adichamangalam,Thanjavur,Tamil Nadu',
'Andankoil,Thanjavur,Tamil Nadu',
'Avalivanallur,Thanjavur,Tamil Nadu',
'Avoor,Thanjavur,Tamil Nadu',
'Chandrasekarapuram,Thanjavur,Tamil Nadu',
'Govindakudi,Thanjavur,Tamil Nadu',
'Haridwaramangalam,Thanjavur,Tamil Nadu',
'Kuvalaiveli,Thanjavur,Tamil Nadu',
'Manakkondu,Thanjavur,Tamil Nadu',
'Manickamangalam,Thanjavur,Tamil Nadu',
'Maruvathur,Thanjavur,Tamil Nadu',
'Mathur-nid,Thanjavur,Tamil Nadu',
'Melamaravathy,Thanjavur,Tamil Nadu',
'Melavidayal Ramnagar,Thanjavur,Tamil Nadu',
'Muniyur,Thanjavur,Tamil Nadu',
'Nallur,Thanjavur,Tamil Nadu',
'Narthangudi,Thanjavur,Tamil Nadu',
'Oothucadu,Thanjavur,Tamil Nadu',
'Padagacheri,Thanjavur,Tamil Nadu',
'Sathanur-psm,Thanjavur,Tamil Nadu',
'Sithanvalur,Thanjavur,Tamil Nadu',
'Terkupattam,Thanjavur,Tamil Nadu',
'Tholuvur,Thanjavur,Tamil Nadu',
'Vadakarai Alathur,Thanjavur,Tamil Nadu',
'Valangaman,Thanjavur,Tamil Nadu',
'Vilathur,Thanjavur,Tamil Nadu',
'Chinnamalaikundru,Kovilpatti,Tamil Nadu',
'Ettaiyapuram,Kovilpatti,Tamil Nadu',
'Ilambuvanam,Kovilpatti,Tamil Nadu',
'Kalugachalapuram,Kovilpatti,Tamil Nadu',
'Karuppur,Virudhunagar,Tamil Nadu',
'Kilairal,Kovilpatti,Tamil Nadu',
'Masarpatti,Virudhunagar,Tamil Nadu',
'Mavilpatti,Virudhunagar,Tamil Nadu',
'Muthulapuram,Kovilpatti,Tamil Nadu',
'Naduvirpatti,Kovilpatti,Tamil Nadu',
'Nambipuram,Kovilpatti,Tamil Nadu',
'Padanthapuli,Kovilpatti,Tamil Nadu',
'Perilovanpatti,Kovilpatti,Tamil Nadu',
'Pillaiyarnatham,Kovilpatti,Tamil Nadu',
'Pugavarnatham,Kovilpatti,Tamil Nadu',
'Sholpuram,Kovilpatti,Tamil Nadu',
'Sindalakarai,Kovilpatti,Tamil Nadu',
'Thalaikattupuram,Kovilpatti,Tamil Nadu',
'Ahilandapuram,Kovilpatti,Tamil Nadu',
'Alagappapuram,Kovilpatti,Tamil Nadu',
'Alampatti,Kovilpatti,Tamil Nadu',
'Athikulam,Kovilpatti,Tamil Nadu',
'Avalnatham,Kovilpatti,Tamil Nadu',
'Ayyanaruthu,Kovilpatti,Tamil Nadu',
'Chettikurichi,Kovilpatti,Tamil Nadu',
'East Pandavarmangalam,Kovilpatti,Tamil Nadu',
'G.V.N.Kalluri,Kovilpatti,Tamil Nadu',
'Idaiseval,Kovilpatti,Tamil Nadu',
'Ilavelangal,Kovilpatti,Tamil Nadu',
'Illupaiyurani,Kovilpatti,Tamil Nadu',
'Irachi,Kovilpatti,Tamil Nadu',
'K. Alankulam,Kovilpatti,Tamil Nadu',
'K.R.Nagar,Kovilpatti,Tamil Nadu',
'K.Sivagnanapuram,Kovilpatti,Tamil Nadu',
'Kadalai,Kovilpatti,Tamil Nadu',
'Kadambur,Kovilpatti,Tamil Nadu',
'Kalugumalai,Kovilpatti,Tamil Nadu',
'Kamanaickanpatti,Kovilpatti,Tamil Nadu',
'Kappulingampatti,Kovilpatti,Tamil Nadu',
'Karadikulam,Kovilpatti,Tamil Nadu',
'Kattalankulam,Kovilpatti,Tamil Nadu',
'Kayathar,Kovilpatti,Tamil Nadu',
'Kilavaippar,Kovilpatti,Tamil Nadu',
'Koppampatti,Kovilpatti,Tamil Nadu',
'Kottali,Kovilpatti,Tamil Nadu',
'Kovilpatti H.O,Kovilpatti,Tamil Nadu',
'Kovilpatti Town,Kovilpatti,Tamil Nadu',
'Kulathur (TVL),Kovilpatti,Tamil Nadu',
'Kuppanapuram,Kovilpatti,Tamil Nadu',
'Kurumalai,Kovilpatti,Tamil Nadu',
'Lakshmipuram,Kovilpatti,Tamil Nadu',
'Lingampatti,Kovilpatti,Tamil Nadu',
'Manthithope,Kovilpatti,Tamil Nadu',
'Moortheeswaram,Kovilpatti,Tamil Nadu',
'Mudukkalankulam,Kovilpatti,Tamil Nadu',
'Nachiyarpuram,Kovilpatti,Tamil Nadu',
'Naickerpatti,Kovilpatti,Tamil Nadu',
'Nalatinputhur,Kovilpatti,Tamil Nadu',
'Padanthapuli 2,Kovilpatti,Tamil Nadu',
'Parivillikottai,Kovilpatti,Tamil Nadu',
'Pillaiyarnatham,Kovilpatti,Tamil Nadu',
'Semmapudur,Kovilpatti,Tamil Nadu',
'Sippikulam,Kovilpatti,Tamil Nadu',
'Tennampatti,Kovilpatti,Tamil Nadu',
'Therkkuilandaikulam,Kovilpatti,Tamil Nadu',
'Turaiyur,Kovilpatti,Tamil Nadu',
'Uthupatti,Kovilpatti,Tamil Nadu',
'Vadakkuvandanam,Kovilpatti,Tamil Nadu',
'Vaippar,Kovilpatti,Tamil Nadu',
'Vanaramutti,Kovilpatti,Tamil Nadu',
'Vedanatham,Kovilpatti,Tamil Nadu',
'Velayuthapuram,Kovilpatti,Tamil Nadu',
'Vellalankottai,Kovilpatti,Tamil Nadu',
'Venkatesawarapuram,Kovilpatti,Tamil Nadu',
'Veppalodai,Kovilpatti,Tamil Nadu',
'Vijayapuri,Kovilpatti,Tamil Nadu',
'Villiseri,Kovilpatti,Tamil Nadu',
'Zamindevarkulam,Kovilpatti,Tamil Nadu',
'Achankulam,Kovilpatti,Tamil Nadu',
'Adanur,Kovilpatti,Tamil Nadu',
'Arungulam,Kovilpatti,Tamil Nadu',
'Duraisamypuram,Tuticorin,Tamil Nadu',
'Jambulingapuram,Tuticorin,Tamil Nadu',
'K.Duraisamypuram,Kovilpatti,Tamil Nadu',
'Kurukkuchalai,Kovilpatti,Tamil Nadu',
'Meenakshipuram,Kovilpatti,Tamil Nadu',
'Melaseithalai,Kovilpatti,Tamil Nadu',
'Nagampatti,Kovilpatti,Tamil Nadu',
'Nainapuram,Tuticorin,Tamil Nadu',
'Ottanatham,Tuticorin,Tamil Nadu',
'Pudiyamputhur,Tuticorin,Tamil Nadu',
'Pudupatcheri,Tuticorin,Tamil Nadu',
'Sakkammalpuram,Kovilpatti,Tamil Nadu',
'Sillankulam,Kovilpatti,Tamil Nadu',
'Sivagnanapuram,Kovilpatti,Tamil Nadu',
'Swaminatham,Tuticorin,Tamil Nadu',
'Taruvaikulam,Tuticorin,Tamil Nadu',
'Maniyac R.S.,Tuticorin,Tamil Nadu',
'Akilandapuram,Tuticorin,Tamil Nadu',
'Akkanaickenpatti,Tuticorin,Tamil Nadu',
'Dalavaipuram,Tuticorin,Tamil Nadu',
'Eppodumvendran,Kovilpatti,Tamil Nadu',
'Kailasapuram,Tuticorin,Tamil Nadu',
'Kandasamypuram,Tuticorin,Tamil Nadu',
'Katcheri Dhalavaipuram,Tuticorin,Tamil Nadu',
'Kilamudiman,Tuticorin,Tamil Nadu',
'Kollankinar,Tuticorin,Tamil Nadu',
'Kulasekaranallur,Tuticorin,Tamil Nadu',
'Marudanvalvoo,Tuticorin,Tamil Nadu',
'Muramban,Tuticorin,Tamil Nadu',
'Naraikinar,Tuticorin,Tamil Nadu',
'Otapidaram,Tuticorin,Tamil Nadu',
'Paraikuttam,Tuticorin,Tamil Nadu',
'Pasuvandanai,Kovilpatti,Tamil Nadu',
'Puliyampatti,Tuticorin,Tamil Nadu',
'Puvani,Tuticorin,Tamil Nadu',
'Savalaperi,Tuticorin,Tamil Nadu',
'Savarimangalam,Tuticorin,Tamil Nadu',
'Umarikottai,Tuticorin,Tamil Nadu',
'Vellaram,Tuticorin,Tamil Nadu',
'Ariyanayagipuram,Tuticorin,Tamil Nadu',
'Kalangaraipatti,Kovilpatti,Tamil Nadu',
'Asirvathapuram,Tuticorin,Tamil Nadu',
'Alagappapuram,Tuticorin,Tamil Nadu',
'Alankinar,Tuticorin,Tamil Nadu',
'Ambalaseri,Tuticorin,Tamil Nadu',
'Anandapuram,Tuticorin,Tamil Nadu',
'Anbinnagaram,Tuticorin,Tamil Nadu',
'Chettikulam,Tuticorin,Tamil Nadu',
'Chinnamadankudiyiruppu,Tuticorin,Tamil Nadu',
'Eluvaraimukki,Tuticorin,Tamil Nadu',
'Idaichivilai,Tuticorin,Tamil Nadu',
'Kadakulam,Tuticorin,Tamil Nadu',
'Kadashapuram,Tuticorin,Tamil Nadu',
'Kalinguvilai,Tuticorin,Tamil Nadu',
'Karunkadal,Tuticorin,Tamil Nadu',
'Karuvelampadu,Tuticorin,Tamil Nadu',
'Katchanavilai,Tuticorin,Tamil Nadu',
'Kattarimangalam,Tuticorin,Tamil Nadu',
'Kolunthuthattu,Tuticorin,Tamil Nadu',
'Kombankulam,Tuticorin,Tamil Nadu',
'Kommadikottai,Tuticorin,Tamil Nadu',
'Kurippankulam,Tuticorin,Tamil Nadu',
'Mirankulam,Tuticorin,Tamil Nadu',
'Mudalur,Tuticorin,Tamil Nadu',
'Mukuperi,Tuticorin,Tamil Nadu',
'Naduvakurichi,Tuticorin,Tamil Nadu',
'Nallur-kommadikottai,Tuticorin,Tamil Nadu',
'Nazareth R S,Tuticorin,Tamil Nadu',
'Nazareth,Tuticorin,Tamil Nadu',
'Nedungulam,Tuticorin,Tamil Nadu',
'Neivilai,Tuticorin,Tamil Nadu',
'Oyyangudi,Tuticorin,Tamil Nadu',
'Padukkapathu,Tuticorin,Tamil Nadu',
'Palaniappapuram,Tuticorin,Tamil Nadu',
'Palankulam,Tuticorin,Tamil Nadu',
'Pallakurichi,Tuticorin,Tamil Nadu',
'Pandarapuram,Tuticorin,Tamil Nadu',
'Pannamparai,Tuticorin,Tamil Nadu',
'Pattakarai,Tuticorin,Tamil Nadu',
'Periyathalai,Tuticorin,Tamil Nadu',
'Pillaiyanmanai,Tuticorin,Tamil Nadu',
'Pitchivilai,Tuticorin,Tamil Nadu',
'Polayarpuram,Tuticorin,Tamil Nadu',
'Pothakalanvilai,Tuticorin,Tamil Nadu',
'Puchikadu,Tuticorin,Tamil Nadu',
'Pudukulam,Tuticorin,Tamil Nadu',
'Puliankulam,Tuticorin,Tamil Nadu',
'Puthantharuvai,Tuticorin,Tamil Nadu',
'Sankarankudiyiruppu,Tuticorin,Tamil Nadu',
'Satankulam East,Tuticorin,Tamil Nadu',
'Satankulam,Tuticorin,Tamil Nadu',
'Savariarkulam,Tuticorin,Tamil Nadu',
'Sokkankudiyiruppu,Tuticorin,Tamil Nadu',
'Subbarayapuram,Tuticorin,Tamil Nadu',
'Subramaniapuram,Tuticorin,Tamil Nadu',
'Sundankottai,Tuticorin,Tamil Nadu',
'Tattarmadam,Tuticorin,Tamil Nadu',
'Thailapuram,Tuticorin,Tamil Nadu',
'Thatchanvilai,Tuticorin,Tamil Nadu',
'Theripanai,Tuticorin,Tamil Nadu',
'Therkankulam,Tuticorin,Tamil Nadu',
'Thoppuvalam,Tuticorin,Tamil Nadu',
'Tirumaraiyur,Tuticorin,Tamil Nadu',
'Udayarkulam,Tuticorin,Tamil Nadu',
'Uyarathukudiyiruppu,Tuticorin,Tamil Nadu',
'Vellamadam,Tuticorin,Tamil Nadu',
'Vijayaramapuram,Tuticorin,Tamil Nadu',
'Alwarkarkulam,Tuticorin,Tamil Nadu',
'Anavaradanallur,Tuticorin,Tamil Nadu',
'Aniaparanallur,Tuticorin,Tamil Nadu',
'Arampannai,Tuticorin,Tamil Nadu',
'Arumugamangalam,Tuticorin,Tamil Nadu',
'Athalikulam,Tuticorin,Tamil Nadu',
'Athichanallur,Tuticorin,Tamil Nadu',
'Cherakulam,Tuticorin,Tamil Nadu',
'Chockalingapuram,Tuticorin,Tamil Nadu',
'Ellanaickenpatti,Tuticorin,Tamil Nadu',
'Eral,Tuticorin,Tamil Nadu',
'Idaiyarkadu,Tuticorin,Tamil Nadu',
'Iruvappapuram,Tuticorin,Tamil Nadu',
'Kaliyavoor,Tuticorin,Tamil Nadu',
'Kalvoy,Tuticorin,Tamil Nadu',
'Karungulam,Tuticorin,Tamil Nadu',
'Kattalangulam,Tuticorin,Tamil Nadu',
'Kollampirambu-dalavaipuram,Tuticorin,Tamil Nadu',
'Kongarayankurichi,Tuticorin,Tamil Nadu',
'Korkai,Tuticorin,Tamil Nadu',
'Kothalarivilai,Tuticorin,Tamil Nadu',
'Kottarakurichi,Tuticorin,Tamil Nadu',
'Manakarai,Tuticorin,Tamil Nadu',
'Maramangalam,Tuticorin,Tamil Nadu',
'Mudittanendal Pudur,Tuticorin,Tamil Nadu',
'Mudittanendal,Tuticorin,Tamil Nadu',
'Murappanad,Tuticorin,Tamil Nadu',
'Naduvakurichi,Tuticorin,Tamil Nadu',
'Nattathi,Tuticorin,Tamil Nadu',
'Padmanabamangalam,Tuticorin,Tamil Nadu',
'Pandaravilai,Tuticorin,Tamil Nadu',
'Pannaivilai,Tuticorin,Tamil Nadu',
'Parakkiramapandi,Tuticorin,Tamil Nadu',
'Patemanagaram,Tuticorin,Tamil Nadu',
'Perungulam,Tuticorin,Tamil Nadu',
'Perur,Tuticorin,Tamil Nadu',
'Pottalurani,Tuticorin,Tamil Nadu',
'Pudupatti,Tuticorin,Tamil Nadu',
'Puthukudi,Tuticorin,Tamil Nadu',
'Ramanujampudur,Tuticorin,Tamil Nadu',
'Sawyerpuram,Tuticorin,Tamil Nadu',
'Sebathiahpuram,Tuticorin,Tamil Nadu',
'Sekkarakudi,Tuticorin,Tamil Nadu',
'Seydunganallur,Tuticorin,Tamil Nadu',
'Singathakurichi,Tuticorin,Tamil Nadu',
'Siruthondanallur,Tuticorin,Tamil Nadu',
'Sivagalai,Tuticorin,Tamil Nadu',
'Srimoolakarai,Tuticorin,Tamil Nadu',
'Sriparangusanallur,Tuticorin,Tamil Nadu',
'Srivaikuntam H.O,Tuticorin,Tamil Nadu',
'Subramaniapuram,Tuticorin,Tamil Nadu',
'Thathankulam,Tuticorin,Tamil Nadu',
'Thimmarajapuraam,Tuticorin,Tamil Nadu',
'Tirupuliyangudi,Tuticorin,Tamil Nadu',
'Vadakkukariseri,Tuticorin,Tamil Nadu',
'Valasakaran Vilai,Tuticorin,Tamil Nadu',
'Vallakulam,Tuticorin,Tamil Nadu',
'Vallanad,Tuticorin,Tamil Nadu',
'Vallavallan,Tuticorin,Tamil Nadu',
'Varthagareddipatti,Tuticorin,Tamil Nadu',
'Vasavappapuram,Tuticorin,Tamil Nadu',
'Velur,Tuticorin,Tamil Nadu',
'Vittilapuram,Tuticorin,Tamil Nadu',
'Adaikalapuram,Tuticorin,Tamil Nadu',
'Agaram,Tuticorin,Tamil Nadu',
'Alanthalai,Tuticorin,Tamil Nadu',
'Alwarthope West,Tuticorin,Tamil Nadu',
'Alwartirunagari,Tuticorin,Tamil Nadu',
'Alwartirunagari West,Tuticorin,Tamil Nadu',
'Amalinagar,Tuticorin,Tamil Nadu',
'Ammanpuram,Tuticorin,Tamil Nadu',
'Anaiyur,Tuticorin,Tamil Nadu',
'Appankoil,Tuticorin,Tamil Nadu',
'Arumuganeri,Tuticorin,Tamil Nadu',
'Autoor,Tuticorin,Tamil Nadu',
'Campbellabad,Tuticorin,Tamil Nadu',
'Idaiyanvilai,Tuticorin,Tamil Nadu',
'Ilanganathapuram,Tuticorin,Tamil Nadu',
'Jerusalempatnam,Tuticorin,Tamil Nadu',
'Kadayanodaiai,Tuticorin,Tamil Nadu',
'Kalankudiyiruppu,Tuticorin,Tamil Nadu',
'Kallamozhi,Tuticorin,Tamil Nadu',
'Kalvilai,Tuticorin,Tamil Nadu',
'Kanam,Tuticorin,Tamil Nadu',
'Kandasamypuram,Tuticorin,Tamil Nadu',
'Kayalpatnam Bazaar,Tuticorin,Tamil Nadu',
'Kayalpatnam,Tuticorin,Tamil Nadu',
'Kayamozhi,Tuticorin,Tamil Nadu',
'Keelaramasamypuram,Tuticorin,Tamil Nadu',
'Keeranur,Tuticorin,Tamil Nadu',
'Kootankadu,Tuticorin,Tamil Nadu',
'Kovankadu,Tuticorin,Tamil Nadu',
'Kulasekarapatnam,Tuticorin,Tamil Nadu',
'Kulasekarapatnam South,Tuticorin,Tamil Nadu',
'Kurangani,Tuticorin,Tamil Nadu',
'Kurukattur,Tuticorin,Tamil Nadu',
'Kurumbur,Tuticorin,Tamil Nadu',
'Kuthiraimozhi,Tuticorin,Tamil Nadu',
'Lakshmimanagaram,Tuticorin,Tamil Nadu',
'Lakshmipuram,Tuticorin,Tamil Nadu',
'Madavankurichi,Tuticorin,Tamil Nadu',
'Manaduthandapathu,Tuticorin,Tamil Nadu',
'Manakad,Tuticorin,Tamil Nadu',
'Manapad,Tuticorin,Tamil Nadu',
'Mannanvilai,Tuticorin,Tamil Nadu',
'Megnanapuram,Tuticorin,Tamil Nadu',
'Mela Autoor,Tuticorin,Tamil Nadu',
'Mela Tiruchendur,Tuticorin,Tamil Nadu',
'Melaputhukudi,Tuticorin,Tamil Nadu',
'Meyoor,Tuticorin,Tamil Nadu',
'Moolakarai,Tuticorin,Tamil Nadu',
'Mukkani,Tuticorin,Tamil Nadu',
'Nadunallumoolaikinar,Tuticorin,Tamil Nadu',
'Nallur,Tuticorin,Tamil Nadu',
'Nalumavadi,Tuticorin,Tamil Nadu',
'Nathankinar,Tuticorin,Tamil Nadu',
'Omarikadu,Tuticorin,Tamil Nadu',
'Pallipathu,Tuticorin,Tamil Nadu',
'Panickanadarkudiyiruppu,Tuticorin,Tamil Nadu',
'Paramankurichi,Tuticorin,Tamil Nadu',
'Pazhaiyalkayal,Tuticorin,Tamil Nadu',
'Peyanvilai,Tuticorin,Tamil Nadu',
'Pitchivilai,Tuticorin,Tamil Nadu',
'Pudumanai,Tuticorin,Tamil Nadu',
'Punnakayal,Tuticorin,Tamil Nadu',
'Puraiyur,Tuticorin,Tamil Nadu',
'Rajamaniapuram,Tuticorin,Tamil Nadu',
'Sahupuram,Tuticorin,Tamil Nadu',
'Seerkatchi,Tuticorin,Tamil Nadu',
'Seerudaiyarpuram,Tuticorin,Tamil Nadu',
'Semmarikulam,Tuticorin,Tamil Nadu',
'Sendamangalam,Tuticorin,Tamil Nadu',
'Sethukuvaithan,Tuticorin,Tamil Nadu',
'Settiapathu,Tuticorin,Tamil Nadu',
'Sirunadarkudiyiruppu,Tuticorin,Tamil Nadu',
'Solaikudiyiruppu,Tuticorin,Tamil Nadu',
'Sonaganvilai,Tuticorin,Tamil Nadu',
'Subramaniapuram,Tuticorin,Tamil Nadu',
'Suganthalai,Tuticorin,Tamil Nadu',
'Thandavankadu,Tuticorin,Tamil Nadu',
'Thenthiruperai,Tuticorin,Tamil Nadu',
'Therikudiyiruppu,Tuticorin,Tamil Nadu',
'Therku Autoor,Tuticorin,Tamil Nadu',
'Tiruchendur Devasthanam,Tuticorin,Tamil Nadu',
'Tiruchendur H.O,Tuticorin,Tamil Nadu',
'Tirukkalur,Tuticorin,Tamil Nadu',
'Udangudi Christianagaram,Tuticorin,Tamil Nadu',
'Uthiramadankudiyiruppu,Tuticorin,Tamil Nadu',
'Vadakkur(KSM),Tuticorin,Tamil Nadu',
'Vallivilai,Tuticorin,Tamil Nadu',
'Varandiavel,Tuticorin,Tamil Nadu',
'Vedakottaivilai,Tuticorin,Tamil Nadu',
'Vellalanvilai,Tuticorin,Tamil Nadu',
'Viramanickam,Tuticorin,Tamil Nadu',
'Virapandianpatanam,Tuticorin,Tamil Nadu',
'Komarudappapuram,Kovilpatti,Tamil Nadu',
'Punniahpuram,Kovilpatti,Tamil Nadu',
'Alagesapuram,Tuticorin,Tamil Nadu',
'Arockiapuram,Tuticorin,Tamil Nadu',
'Athimarapatti,Tuticorin,Tamil Nadu',
'C.G.S. Colony,Tuticorin,Tamil Nadu',
'Chidambaranagar,Tuticorin,Tamil Nadu',
'Cruz Fernandespuram,Tuticorin,Tamil Nadu',
'Gibsonpuram,Tuticorin,Tamil Nadu',
'Heavy Water Project Colony,Tuticorin,Tamil Nadu',
'Keelashanmugapuram,Tuticorin,Tamil Nadu',
'Keelatattaparai,Tuticorin,Tamil Nadu',
'Kilavilathikulam\',Kovilpatti,Tamil Nadu',
'Kootampuli,Tuticorin,Tamil Nadu',
'Korampollam,Tuticorin,Tamil Nadu',
'Kovilpatti Indl.Estate,Kovilpatti,Tamil Nadu',
'Kovilpatti North,Kovilpatti,Tamil Nadu',
'Kovilpatti R.S,Kovilpatti,Tamil Nadu',
'Kulayankarisal,Tuticorin,Tamil Nadu',
'Levingipuram,Tuticorin,Tamil Nadu',
'Madathur,Tuticorin,Tamil Nadu',
'Mangalagiri,Tuticorin,Tamil Nadu',
'Mappillaiyurani,Tuticorin,Tamil Nadu',
'Maravanmadam,Tuticorin,Tamil Nadu',
'Melaarasadi,Tuticorin,Tamil Nadu',
'Melakootudankadu,Tuticorin,Tamil Nadu',
'Melatattaparai,Tuticorin,Tamil Nadu',
'Melur Tuticorin,Tuticorin,Tamil Nadu',
'Milavittan R S,Tuticorin,Tamil Nadu',
'Millerpuram,Tuticorin,Tamil Nadu',
'Mullaakadu,Tuticorin,Tamil Nadu',
'Muthiahpuram,Tuticorin,Tamil Nadu',
'New Colony,Tuticorin,Tamil Nadu',
'Pannikulam,Kovilpatti,Tamil Nadu',
'Periyanayagipuram,Tuticorin,Tamil Nadu',
'Polenaikcenpettai,Tuticorin,Tamil Nadu',
'Pudukottai,Tuticorin,Tamil Nadu',
'Puthukudi 3rd Mile,Tuticorin,Tamil Nadu',
'Sankaraperi,Tuticorin,Tamil Nadu',
'Servaikaranmadam,Tuticorin,Tamil Nadu',
'Siluvaipatti,Tuticorin,Tamil Nadu',
'Tattaparai,Tuticorin,Tamil Nadu',
'Therkusilukkanpatti,Tuticorin,Tamil Nadu',
'Therkuvirapandiapuram,Tuticorin,Tamil Nadu',
'Thermal Nagagr,Tuticorin,Tamil Nadu',
'Toovipuram,Tuticorin,Tamil Nadu',
'Tt. Thermal Power Plant,Tuticorin,Tamil Nadu',
'Tuticorin Cathedral,Tuticorin,Tamil Nadu',
'Tuticorin Central Bus Stand,Tuticorin,Tamil Nadu',
'Tuticorin H.O,Tuticorin,Tamil Nadu',
'Tuticorin Harbour Estate,Tuticorin,Tamil Nadu',
'Tuticorin Keelur,Tuticorin,Tamil Nadu',
'Vadakkur Tuticorin,Tuticorin,Tamil Nadu',
'Vetrivelpuram,Tuticorin,Tamil Nadu',
'Victoria Extension Road,Tuticorin,Tamil Nadu',
'Ariyanayagipuram,Kovilpatti,Tamil Nadu',
'Attankarai,Kovilpatti,Tamil Nadu',
'Bommiahpuram,Kovilpatti,Tamil Nadu',
'Boothalapuram,Kovilpatti,Tamil Nadu',
'Duraisamypuram,Kovilpatti,Tamil Nadu',
'Guruvarpatti,Kovilpatti,Tamil Nadu',
'Karisalkulam,Kovilpatti,Tamil Nadu',
'Kilakarandai,Kovilpatti,Tamil Nadu',
'Meenakshipuram,Kovilpatti,Tamil Nadu',
'Melmandai,Kovilpatti,Tamil Nadu',
'Nagalapuram,Kovilpatti,Tamil Nadu',
'Ramachandrapuram,Kovilpatti,Tamil Nadu',
'Sankaralingapuram,Kovilpatti,Tamil Nadu',
'Surangudi,Kovilpatti,Tamil Nadu',
'Tattaneri,Kovilpatti,Tamil Nadu',
'Vedapatti,Kovilpatti,Tamil Nadu',
'Vowalthothi,Kovilpatti,Tamil Nadu',
'Kadalkudi,Kovilpatti,Tamil Nadu',
'Kandasamypuram,Kovilpatti,Tamil Nadu',
'Kilaarunachalapuram,Kovilpatti,Tamil Nadu',
'L.Venkateswarapuram,Kovilpatti,Tamil Nadu',
'Maniyakaranpatti,Kovilpatti,Tamil Nadu',
'Mettilpatti,Kovilpatti,Tamil Nadu',
'Periyasamipuram,Kovilpatti,Tamil Nadu',
'Pudur,Kovilpatti,Tamil Nadu',
'Sennamareddipatti,Kovilpatti,Tamil Nadu',
'Sivalarpatti,Kovilpatti,Tamil Nadu',
'V.Vedapatti,Kovilpatti,Tamil Nadu',
'Vadamalaisamudram,Kovilpatti,Tamil Nadu',
'Vembar,Kovilpatti,Tamil Nadu',
'Vembur,Kovilpatti,Tamil Nadu',
'Vilathikulam,Kovilpatti,Tamil Nadu',
'Peenjamandai,Vellore,Tamil Nadu',
'Rangapuram,Vellore,Tamil Nadu',
'Dharanampet,Tirupattur,Tamil Nadu',
'Paravathur,Arakkonam,Tamil Nadu',
'Poongulam,Tirupattur,Tamil Nadu',
'Pudur Nadu,Tirupattur,Tamil Nadu',
'Akkachikuppam,Arakkonam,Tamil Nadu',
'Ammanur,Arakkonam,Tamil Nadu',
'Anaipakkam,Arakkonam,Tamil Nadu',
'Anvardhikhanpet,Arakkonam,Tamil Nadu',
'Arakkonam H.O,Arakkonam,Tamil Nadu',
'Arigilapadi,Arakkonam,Tamil Nadu',
'Asamandhur,Arakkonam,Tamil Nadu',
'Ashoknagar,Arakkonam,Tamil Nadu',
'Attupakkam,Arakkonam,Tamil Nadu',
'Ayal,Arakkonam,Tamil Nadu',
'Ayarpadi,Arakkonam,Tamil Nadu',
'Ayipedu,Arakkonam,Tamil Nadu',
'Banavaram,Arakkonam,Tamil Nadu',
'Chitteri,Arakkonam,Tamil Nadu',
'Ekhunagar,Arakkonam,Tamil Nadu',
'Ganapathipuram,Arakkonam,Tamil Nadu',
'Govindacherrykuppam,Arakkonam,Tamil Nadu',
'Gudalur,Arakkonam,Tamil Nadu',
'Guruvarajpet,Arakkonam,Tamil Nadu',
'Ichiputhur,Arakkonam,Tamil Nadu',
'Iluppaithandalam,Arakkonam,Tamil Nadu',
'Ins Rajali,Arakkonam,Tamil Nadu',
'Jagirthandalam,Arakkonam,Tamil Nadu',
'Jambukulam,Arakkonam,Tamil Nadu',
'Jothinagar,Arakkonam,Tamil Nadu',
'Kadambainallore,Arakkonam,Tamil Nadu',
'Kainoor,Arakkonam,Tamil Nadu',
'Kalathur,Arakkonam,Tamil Nadu',
'Karikkal,Arakkonam,Tamil Nadu',
'Karnavur,Arakkonam,Tamil Nadu',
'Kattupakkam,Arakkonam,Tamil Nadu',
'Kavanur,Arakkonam,Tamil Nadu',
'Kesavanankuppam,Arakkonam,Tamil Nadu',
'Kilandur,Arakkonam,Tamil Nadu',
'Kilandurai,Arakkonam,Tamil Nadu',
'Kilkuppam,Arakkonam,Tamil Nadu',
'Kilpakkam,Arakkonam,Tamil Nadu',
'Kilveedhi,Arakkonam,Tamil Nadu',
'Kilveeranam,Arakkonam,Tamil Nadu',
'Kilvenkatapuram,Arakkonam,Tamil Nadu',
'Kizhavanam,Arakkonam,Tamil Nadu',
'Kodakkal,Arakkonam,Tamil Nadu',
'Kondapalayam,Arakkonam,Tamil Nadu',
'Kumpinipet,Arakkonam,Tamil Nadu',
'Kunnathur,Arakkonam,Tamil Nadu',
'Mahendravadi,Arakkonam,Tamil Nadu',
'Manamadurai,Arakkonam,Tamil Nadu',
'Mangattucherry,Arakkonam,Tamil Nadu',
'Melapulam,Arakkonam,Tamil Nadu',
'Meleri,Arakkonam,Tamil Nadu',
'Melkalathur,Arakkonam,Tamil Nadu',
'Minnal,Arakkonam,Tamil Nadu',
'Mittapettai,Arakkonam,Tamil Nadu',
'Mosur,Arakkonam,Tamil Nadu',
'Mudur,Arakkonam,Tamil Nadu',
'Nagavedu,Arakkonam,Tamil Nadu',
'Namali,Arakkonam,Tamil Nadu',
'Nandiveduthangal,Arakkonam,Tamil Nadu',
'Nangamangalam,Arakkonam,Tamil Nadu',
'Ocheri,Arakkonam,Tamil Nadu',
'Palanipet,Arakkonam,Tamil Nadu',
'Palayapalayamottur,Arakkonam,Tamil Nadu',
'Pallur,Arakkonam,Tamil Nadu',
'Panapakkam,Arakkonam,Tamil Nadu',
'Pandianallore,Arakkonam,Tamil Nadu',
'Paranji,Arakkonam,Tamil Nadu',
'Parithiputhur,Arakkonam,Tamil Nadu',
'Perumbulipakkam,Arakkonam,Tamil Nadu',
'Perumuchi,Arakkonam,Tamil Nadu',
'Perungalathur,Arakkonam,Tamil Nadu',
'Perunkanchi,Arakkonam,Tamil Nadu',
'Peruvalayam,Arakkonam,Tamil Nadu',
'Pillaipakkam,Arakkonam,Tamil Nadu',
'Polipakkam,Arakkonam,Tamil Nadu',
'Pulivalam,Arakkonam,Tamil Nadu',
'Puliyamangalam,Arakkonam,Tamil Nadu',
'Rajajinagar,Arakkonam,Tamil Nadu',
'Reddivalam,Arakkonam,Tamil Nadu',
'Rendadi,Arakkonam,Tamil Nadu',
'Sagayathottam,Arakkonam,Tamil Nadu',
'Sayanavaram,Arakkonam,Tamil Nadu',
'Sendamangalam,Arakkonam,Tamil Nadu',
'Seyyoor,Arakkonam,Tamil Nadu',
'Sholingur Bazaar,Arakkonam,Tamil Nadu',
'Sholingur,Arakkonam,Tamil Nadu',
'Sirukarumbur,Arakkonam,Tamil Nadu',
'Sirunamalli,Arakkonam,Tamil Nadu',
'Somasamudram,Arakkonam,Tamil Nadu',
'Surai,Arakkonam,Tamil Nadu',
'Suraksha Cisf Campus,Arakkonam,Tamil Nadu',
'Takkolam,Arakkonam,Tamil Nadu',
'Talikkal,Arakkonam,Tamil Nadu',
'Thanigaipolur,Arakkonam,Tamil Nadu',
'Tirumalpur,Arakkonam,Tamil Nadu',
'Ulianallore,Arakkonam,Tamil Nadu',
'Uriyur,Arakkonam,Tamil Nadu',
'Vadamambakkam,Arakkonam,Tamil Nadu',
'Valaikulam,Arakkonam,Tamil Nadu',
'Vangupattu,Arakkonam,Tamil Nadu',
'Winterpet,Arakkonam,Tamil Nadu',
'Agaram,Arakkonam,Tamil Nadu',
'Anaimallur,Arakkonam,Tamil Nadu',
'Ananthangal,Arakkonam,Tamil Nadu',
'Arcot Bazaar,Arakkonam,Tamil Nadu',
'Arcot East,Arakkonam,Tamil Nadu',
'Arcot,Arakkonam,Tamil Nadu',
'Arcot West,Arakkonam,Tamil Nadu',
'Arumbakkam,Arakkonam,Tamil Nadu',
'Chennasamudram,Arakkonam,Tamil Nadu',
'Damarapakkam,Arakkonam,Tamil Nadu',
'Durgam,Arakkonam,Tamil Nadu',
'Esayanur,Arakkonam,Tamil Nadu',
'G.B.Nagar,Arakkonam,Tamil Nadu',
'Gundaleri,Arakkonam,Tamil Nadu',
'Irungur,Tiruvannamalai,Tamil Nadu',
'Jagirvalavanur,Arakkonam,Tamil Nadu',
'Jawaharpuram,Arakkonam,Tamil Nadu',
'Kalavai,Arakkonam,Tamil Nadu',
'Kaniyanur,Arakkonam,Tamil Nadu',
'Karikkanthangal,Arakkonam,Tamil Nadu',
'Kavanur,Arakkonam,Tamil Nadu',
'Ladavaram,Arakkonam,Tamil Nadu',
'Mambakkam,Arakkonam,Tamil Nadu',
'Mazharyur,Arakkonam,Tamil Nadu',
'Mecheri,Arakkonam,Tamil Nadu',
'Melapudupakkam,Arakkonam,Tamil Nadu',
'Melnathambakkam,Arakkonam,Tamil Nadu',
'Mohamedpet,Arakkonam,Tamil Nadu',
'Muppathuvetti,Arakkonam,Tamil Nadu',
'Nambarai,Arakkonam,Tamil Nadu',
'Palayamangadu,Arakkonam,Tamil Nadu',
'Palayanur,Arakkonam,Tamil Nadu',
'Paradarami,Arakkonam,Tamil Nadu',
'Pennagar,Arakkonam,Tamil Nadu',
'Pudupadi,Arakkonam,Tamil Nadu',
'Pudur- Kaniyanur,Arakkonam,Tamil Nadu',
'Punganur,Arakkonam,Tamil Nadu',
'Sakkaramallur,Arakkonam,Tamil Nadu',
'Sambasivapuram,Arakkonam,Tamil Nadu',
'Sattur,Arakkonam,Tamil Nadu',
'Senganavaram,Arakkonam,Tamil Nadu',
'Soraiyur,Arakkonam,Tamil Nadu',
'Tajpura,Arakkonam,Tamil Nadu',
'Thoppukhana,Arakkonam,Tamil Nadu',
'Timiri,Arakkonam,Tamil Nadu',
'Uppupettai,Arakkonam,Tamil Nadu',
'Valapandal,Arakkonam,Tamil Nadu',
'Valayathur,Arakkonam,Tamil Nadu',
'Varagur,Arakkonam,Tamil Nadu',
'Vellambi,Arakkonam,Tamil Nadu',
'Velur- Kalavai,Arakkonam,Tamil Nadu',
'Vembi,Arakkonam,Tamil Nadu',
'Venkatapuram,Arakkonam,Tamil Nadu',
'Vilapakkam,Arakkonam,Tamil Nadu',
'Agraharam,Tirupattur,Tamil Nadu',
'Ananganallore,Tirupattur,Tamil Nadu',
'Arangaldurgam,Tirupattur,Tamil Nadu',
'Aravatla,Tirupattur,Tamil Nadu',
'Bhuvaneswaripet,Tirupattur,Tamil Nadu',
'Chendathur,Tirupattur,Tamil Nadu',
'Chettikuppam,Tirupattur,Tamil Nadu',
'Chinnadamalcheruvu,Tirupattur,Tamil Nadu',
'Chinnakarumbur,Tirupattur,Tamil Nadu',
'Chinnathottalam,Tirupattur,Tamil Nadu',
'Chinnavarikam,Tirupattur,Tamil Nadu',
'Dakshinapathapalyaam,Tirupattur,Tamil Nadu',
'Dharnampet,Tirupattur,Tamil Nadu',
'Erathangal,Tirupattur,Tamil Nadu',
'Erikutti,Tirupattur,Tamil Nadu',
'Erukkambattu,Tirupattur,Tamil Nadu',
'Gudanagaram,Tirupattur,Tamil Nadu',
'Gudiyattam Cutcherry,Tirupattur,Tamil Nadu',
'Gudiyattam H.O,Tirupattur,Tamil Nadu',
'Gudiyattam South,Tirupattur,Tamil Nadu',
'Kadhavalam,Tirupattur,Tamil Nadu',
'Kallapadi,Tirupattur,Tamil Nadu',
'Kamalapuram,Tirupattur,Tamil Nadu',
'Karapattu,Tirupattur,Tamil Nadu',
'Kilalathur,Tirupattur,Tamil Nadu',
'Kilpatti,Tirupattur,Tamil Nadu',
'Kokkalur,Tirupattur,Tamil Nadu',
'Kosavanpudur,Tirupattur,Tamil Nadu',
'Kottamitta,Tirupattur,Tamil Nadu',
'Kottur,Tirupattur,Tamil Nadu',
'Mailpatti,Tirupattur,Tamil Nadu',
'Masigam,Tirupattur,Tamil Nadu',
'Melalathur,Tirupattur,Tamil Nadu',
'Melmuttukur,Tirupattur,Tamil Nadu',
'Melvayathinankuppam,Tirupattur,Tamil Nadu',
'Mittalam,Tirupattur,Tamil Nadu',
'Modikuppam,Tirupattur,Tamil Nadu',
'Morasapalli,Tirupattur,Tamil Nadu',
'Mordhana,Tirupattur,Tamil Nadu',
'Nariyambattu,Tirupattur,Tamil Nadu',
'Oomerabad,Tirupattur,Tamil Nadu',
'Pakkamvenkatapuram,Tirupattur,Tamil Nadu',
'Pallalakuppam,Tirupattur,Tamil Nadu',
'Paradarami,Tirupattur,Tamil Nadu',
'Pasumathur,Tirupattur,Tamil Nadu',
'Pernambut,Tirupattur,Tamil Nadu',
'Pogalur,Tirupattur,Tamil Nadu',
'Puttavaripalli,Tirupattur,Tamil Nadu',
'Rajakkal,Tirupattur,Tamil Nadu',
'Rajakuppam,Tirupattur,Tamil Nadu',
'Ramalai,Tirupattur,Tamil Nadu',
'Sathambakkam,Tirupattur,Tamil Nadu',
'Sathugudi,Tirupattur,Tamil Nadu',
'Sedukarai,Tirupattur,Tamil Nadu',
'Sembedu,Tirupattur,Tamil Nadu',
'Sempalli,Tirupattur,Tamil Nadu',
'Sengundram,Tirupattur,Tamil Nadu',
'Sethubandai,Tirupattur,Tamil Nadu',
'Sevur,Tirupattur,Tamil Nadu',
'Thattaparai,Tirupattur,Tamil Nadu',
'Thattimanapalli,Tirupattur,Tamil Nadu',
'Thottithuraimottur,Tirupattur,Tamil Nadu',
'Thuthipattu,Tirupattur,Tamil Nadu',
'Ulli,Tirupattur,Tamil Nadu',
'Valathoor,Tirupattur,Tamil Nadu',
'Varadareddipalli,Tirupattur,Tamil Nadu',
'Veerichettipalli,Tirupattur,Tamil Nadu',
'Venkatasamudram,Tirupattur,Tamil Nadu',
'Veppur,Tirupattur,Tamil Nadu',
'Viludonpalayam,Tirupattur,Tamil Nadu',
'Chengalnatham,Arakkonam,Tamil Nadu',
'Chennankuppam,Tirupattur,Tamil Nadu',
'Devarishikuppam,Tirupattur,Tamil Nadu',
'Gandhinagar East,Vellore,Tamil Nadu',
'Gandhinagar,Vellore,Tamil Nadu',
'Gandhinagar West,Vellore,Tamil Nadu',
'Gollamangalam,Tirupattur,Tamil Nadu',
'Gudiyattam RS,Tirupattur,Tamil Nadu',
'Kandaneri,Tirupattur,Tamil Nadu',
'Kanguppam,Tirupattur,Tamil Nadu',
'Katpadi North,Vellore,Tamil Nadu',
'Katpadi,Vellore,Tamil Nadu',
'Keerasathu,Arakkonam,Tamil Nadu',
'Kilvayathinankuppam,Tirupattur,Tamil Nadu',
'Kokkeri,Arakkonam,Tamil Nadu',
'Kondakuppam,Arakkonam,Tamil Nadu',
'Kuppireddithangal,Arakkonam,Tamil Nadu',
'Latteri,Vellore,Tamil Nadu',
'Machanur,Tirupattur,Tamil Nadu',
'Mahimandalam,Arakkonam,Tamil Nadu',
'Melkavanur,Tirupattur,Tamil Nadu',
'Melmankuppam,Tirupattur,Tamil Nadu',
'Melmayil,Tirupattur,Tamil Nadu',
'Melpadi,Arakkonam,Tamil Nadu',
'Odiyathur,Tirupattur,Tamil Nadu',
'Palayakrishnapuram,Tirupattur,Tamil Nadu',
'Pallikonda Bazaar,Tirupattur,Tamil Nadu',
'Pallikonda,Tirupattur,Tamil Nadu',
'Periamittoor,Arakkonam,Tamil Nadu',
'Perumalkuppam,Arakkonam,Tamil Nadu',
'Perumankuppam,Tirupattur,Tamil Nadu',
'Ponnai,Arakkonam,Tamil Nadu',
'Ruhsa Campus,Tirupattur,Tamil Nadu',
'Thathireddipalle,Arakkonam,Tamil Nadu',
'Thengal,Arakkonam,Tamil Nadu',
'Tippasamudram,Tirupattur,Tamil Nadu',
'Vallimalai,Arakkonam,Tamil Nadu',
'Vasur,Arakkonam,Tamil Nadu',
'Vennampalle,Arakkonam,Tamil Nadu',
'Veppalai,Arakkonam,Tamil Nadu',
'Vettuvanam,Tirupattur,Tamil Nadu',
'Achamangalam,Tirupattur,Tamil Nadu',
'Adiyur,Tirupattur,Tamil Nadu',
'Agaram(TPT),Tirupattur,Tamil Nadu',
'Agraharam,Tirupattur,Tamil Nadu',
'Alasandapuram,Tirupattur,Tamil Nadu',
'Ambalur,Tirupattur,Tamil Nadu',
'Andiappanur,Tirupattur,Tamil Nadu',
'Asiriyar Nagar,Tirupattur,Tamil Nadu',
'Athurkuppam,Tirupattur,Tamil Nadu',
'Avarankuppam,Tirupattur,Tamil Nadu',
'Bandarapalli,Tirupattur,Tamil Nadu',
'Bommikuppam,Tirupattur,Tamil Nadu',
'Chandrapuram,Tirupattur,Tamil Nadu',
'Chikkanankuppam,Tirupattur,Tamil Nadu',
'Chinnakandili,Tirupattur,Tamil Nadu',
'Chinnasamudram,Tirupattur,Tamil Nadu',
'Chinnavattanur,Tirupattur,Tamil Nadu',
'Chittoor,Tirupattur,Tamil Nadu',
'Christukula Ashram,Tirupattur,Tamil Nadu',
'Cutcherry Street,Tirupattur,Tamil Nadu',
'Damalerimuthur,Tirupattur,Tamil Nadu',
'Eachangal,Tirupattur,Tamil Nadu',
'East Badanavadi,Tirupattur,Tamil Nadu',
'Elagiri,Tirupattur,Tamil Nadu',
'Elavampatti,Tirupattur,Tamil Nadu',
'Gandhipet - TPT,Tirupattur,Tamil Nadu',
'Gummidigampatti,Tirupattur,Tamil Nadu',
'Irunapattu,Tirupattur,Tamil Nadu',
'Jamnapudur,Tirupattur,Tamil Nadu',
'Jangalapuram,Tirupattur,Tamil Nadu',
'Jayapuram,Tirupattur,Tamil Nadu',
'Jolarpettai,Tirupattur,Tamil Nadu',
'Kadirimangalam,Tirupattur,Tamil Nadu',
'Kakankar R.S.,Tirupattur,Tamil Nadu',
'Kambugudi,Tirupattur,Tamil Nadu',
'Kandili,Tirupattur,Tamil Nadu',
'Karuppanur,Tirupattur,Tamil Nadu',
'Kathari,Tirupattur,Tamil Nadu',
'Kethandapatti,Tirupattur,Tamil Nadu',
'Kethandapatti Sugar Mills,Tirupattur,Tamil Nadu',
'Kilanur,Tirupattur,Tamil Nadu',
'Kilur,Tirupattur,Tamil Nadu',
'Kodayanchi,Tirupattur,Tamil Nadu',
'Kodiyur,Tirupattur,Tamil Nadu',
'Kodumampalli,Tirupattur,Tamil Nadu',
'Kombai,Tirupattur,Tamil Nadu',
'Koratti,Tirupattur,Tamil Nadu',
'Kothur,Tirupattur,Tamil Nadu',
'Kottaiyur,Tirupattur,Tamil Nadu',
'Kurumbakeri,Tirupattur,Tamil Nadu',
'Kurumberi,Tirupattur,Tamil Nadu',
'Kurusilapattu,Tirupattur,Tamil Nadu',
'Lakkinaickenpatti,Tirupattur,Tamil Nadu',
'Lalapettai,Tirupattur,Tamil Nadu',
'Madavalam,Tirupattur,Tamil Nadu',
'Malaiyandipatti,Tirupattur,Tamil Nadu',
'Mallagunta,Tirupattur,Tamil Nadu',
'Mallapalli,Tirupattur,Tamil Nadu',
'Mandalanayanagunda,Tirupattur,Tamil Nadu',
'Mandalavadi,Tirupattur,Tamil Nadu',
'Mangalam,Tirupattur,Tamil Nadu',
'Marimanikuppam,Tirupattur,Tamil Nadu',
'Matrapalli,Tirupattur,Tamil Nadu',
'Melpattu,Tirupattur,Tamil Nadu',
'Mittur,Tirupattur,Tamil Nadu',
'Mukkanur,Tirupattur,Tamil Nadu',
'Nachiarkuppam,Tirupattur,Tamil Nadu',
'Nadukuppam,Tirupattur,Tamil Nadu',
'Nariyaneri,Tirupattur,Tamil Nadu',
'Natham,Tirupattur,Tamil Nadu',
'Natrampalli,Tirupattur,Tamil Nadu',
'Nayakkanur,Tirupattur,Tamil Nadu',
'Nayanacheruvu,Tirupattur,Tamil Nadu',
'Nellipattu,Tirupattur,Tamil Nadu',
'Nellivasalnadu,Tirupattur,Tamil Nadu',
'Newtown Vaniyambadi,Tirupattur,Tamil Nadu',
'Nilavur,Tirupattur,Tamil Nadu',
'Pachal,Tirupattur,Tamil Nadu',
'Pachur,Tirupattur,Tamil Nadu',
'Pakkirithakka,Tirupattur,Tamil Nadu',
'Pallathur,Tirupattur,Tamil Nadu',
'Pallavalli,Tirupattur,Tamil Nadu',
'Paniyandapalli,Tirupattur,Tamil Nadu',
'Parandapalli,Tirupattur,Tamil Nadu',
'Perambattu,Tirupattur,Tamil Nadu',
'Periagaram,Tirupattur,Tamil Nadu',
'Periyakannalapatti,Tirupattur,Tamil Nadu',
'Periyakasinaickenpatti,Tirupattur,Tamil Nadu',
'Periyakonapattu,Tirupattur,Tamil Nadu',
'Periyakunichi,Tirupattur,Tamil Nadu',
'Perumapattu,Tirupattur,Tamil Nadu',
'Perumpalli,Tirupattur,Tamil Nadu',
'Ponneri,Tirupattur,Tamil Nadu',
'Pudukottai,Tirupattur,Tamil Nadu',
'Pudupettai,Tirupattur,Tamil Nadu',
'Pudur J.H.,Tirupattur,Tamil Nadu',
'Puliyur Tpt,Tirupattur,Tamil Nadu',
'Pullaneri,Tirupattur,Tamil Nadu',
'Puthagaram,Tirupattur,Tamil Nadu',
'Rachamangalam,Tirupattur,Tamil Nadu',
'Rajapalayam,Tirupattur,Tamil Nadu',
'Ramanaickenpettai,Tirupattur,Tamil Nadu',
'Reddiyur,Tirupattur,Tamil Nadu',
'Selandampalli,Tirupattur,Tamil Nadu',
'Sevathur,Tirupattur,Tamil Nadu',
'Simnapudur,Tirupattur,Tamil Nadu',
'Somanaickenpatti,Tirupattur,Tamil Nadu',
'Sorakayalnatham,Tirupattur,Tamil Nadu',
'Sundarampalli,Tirupattur,Tamil Nadu',
'Thagarakuppam,Tirupattur,Tamil Nadu',
'Thekkupattu,Tirupattur,Tamil Nadu',
'Thimmampet,Tirupattur,Tamil Nadu',
'Thimmanamuthur,Tirupattur,Tamil Nadu',
'Thokkiyam,Tirupattur,Tamil Nadu',
'Thornampathy,Tirupattur,Tamil Nadu',
'Tiriyalam,Tirupattur,Tamil Nadu',
'Tirupattur Bazaar,Tirupattur,Tamil Nadu',
'Tirupattur Fort,Tirupattur,Tamil Nadu',
'Tirupattur H.O,Tirupattur,Tamil Nadu',
'Udayamuthur,Tirupattur,Tamil Nadu',
'Vadakkupattu,Tirupattur,Tamil Nadu',
'Vakkanampatti,Tirupattur,Tamil Nadu',
'Velakalnatham,Tirupattur,Tamil Nadu',
'Vengalapuram,Tirupattur,Tamil Nadu',
'Veppalnatham,Tirupattur,Tamil Nadu',
'Vettapattu,Tirupattur,Tamil Nadu',
'Vishamangalam,Tirupattur,Tamil Nadu',
'Yelagiri Hills,Tirupattur,Tamil Nadu',
'Palayapalayam,Tirupattur,Tamil Nadu',
'Agaram,Tirupattur,Tamil Nadu',
'Agaramcherry,Tirupattur,Tamil Nadu',
'Alangayam,Tirupattur,Tamil Nadu',
'Alankuppam,Tirupattur,Tamil Nadu',
'Ambur Bazaar,Tirupattur,Tamil Nadu',
'Ambur,Tirupattur,Tamil Nadu',
'Athiperumanur,Tirupattur,Tamil Nadu',
'Bheemakulam,Tirupattur,Tamil Nadu',
'Chettiappanur,Tirupattur,Tamil Nadu',
'Chinnapallikuppam,Tirupattur,Tamil Nadu',
'Devalapuram,Tirupattur,Tamil Nadu',
'Devasthanam,Tirupattur,Tamil Nadu',
'Gangapuram,Tirupattur,Tamil Nadu',
'Girisamudram,Tirupattur,Tamil Nadu',
'Govindapuram,Tirupattur,Tamil Nadu',
'Ilayanagaram,Tirupattur,Tamil Nadu',
'Jaffarabad,Tirupattur,Tamil Nadu',
'Kalendira,Tirupattur,Tamil Nadu',
'Karungali,Tirupattur,Tamil Nadu',
'Kavalur,Tirupattur,Tamil Nadu',
'Khaderpet,Tirupattur,Tamil Nadu',
'Kilmurungai,Tirupattur,Tamil Nadu',
'Kothakottai,Tirupattur,Tamil Nadu',
'Kumaramangalam,Tirupattur,Tamil Nadu',
'Madanancherry,Tirupattur,Tamil Nadu',
'Madanur,Tirupattur,Tamil Nadu',
'Mandarakuttai,Tirupattur,Tamil Nadu',
'Minnur,Tirupattur,Tamil Nadu',
'Naickaneri,Tirupattur,Tamil Nadu',
'Naickanur,Tirupattur,Tamil Nadu',
'Narasingapuram,Tirupattur,Tamil Nadu',
'Nimmiyambattu,Tirupattur,Tamil Nadu',
'Palur,Tirupattur,Tamil Nadu',
'Peddur,Tirupattur,Tamil Nadu',
'Periyankuppam,Tirupattur,Tamil Nadu',
'Periyapet,Tirupattur,Tamil Nadu',
'Perumalpet,Tirupattur,Tamil Nadu',
'Pudur Vaniyambadi,Tirupattur,Tamil Nadu',
'Shanankuppam,Tirupattur,Tamil Nadu',
'Somalapuram,Tirupattur,Tamil Nadu',
'Thennambattu,Tirupattur,Tamil Nadu',
'Thollapalli,Tirupattur,Tamil Nadu',
'Thottalam,Tirupattur,Tamil Nadu',
'Thumberi,Tirupattur,Tamil Nadu',
'Udayendiram,Tirupattur,Tamil Nadu',
'Vadacheri,Tirupattur,Tamil Nadu',
'Vadakkathipatti,Tirupattur,Tamil Nadu',
'Vadapudupet,Tirupattur,Tamil Nadu',
'Valayalkarapatti,Tirupattur,Tamil Nadu',
'Valayambattu,Tirupattur,Tamil Nadu',
'Vallipattu,Tirupattur,Tamil Nadu',
'Vaniyambadi R.S,Tirupattur,Tamil Nadu',
'Vaniyambadi,Tirupattur,Tamil Nadu',
'Vasanthapuram,Tirupattur,Tamil Nadu',
'Vellakuttai,Tirupattur,Tamil Nadu',
'Vengili,Tirupattur,Tamil Nadu',
'Vinnamangalam,Tirupattur,Tamil Nadu',
'Abdullapuram,Vellore,Tamil Nadu',
'Ampuram,Vellore,Tamil Nadu',
'Anaikkattu,Vellore,Tamil Nadu',
'Appukal,Vellore,Tamil Nadu',
'Ariyur,Vellore,Tamil Nadu',
'Bagayam,Vellore,Tamil Nadu',
'Bakiyath,Vellore,Tamil Nadu',
'Bye Pass Road,Vellore,Tamil Nadu',
'Chitteri,Vellore,Tamil Nadu',
'Cholavaram,Vellore,Tamil Nadu',
'CMC H,Vellore,Tamil Nadu',
'CMC,Vellore,Tamil Nadu',
'Gandhiroad,Vellore,Tamil Nadu',
'Guruvarajapalayam,Vellore,Tamil Nadu',
'Kagithapattarai,Vellore,Tamil Nadu',
'Kammasamudram,Tiruvannamalai,Tamil Nadu',
'Kammavanpettai,Tiruvannamalai,Tamil Nadu',
'Kangeyanallur,Vellore,Tamil Nadu',
'Kaniyambadi,Vellore,Tamil Nadu',
'Kasba,Vellore,Tamil Nadu',
'Kattazhambattu,Tiruvannamalai,Tamil Nadu',
'Kattuputhur,Vellore,Tamil Nadu',
'Kilarasampattu,Tiruvannamalai,Tamil Nadu',
'Konavattam,Vellore,Tamil Nadu',
'Kosapet,Vellore,Tamil Nadu',
'Krishnanagar,Vellore,Tamil Nadu',
'M Palayam,Vellore,Tamil Nadu',
'Melmonavur,Vellore,Tamil Nadu',
'Mottakkal,Tiruvannamalai,Tamil Nadu',
'Munjurpattu,Vellore,Tamil Nadu',
'Nagalur,Vellore,Tamil Nadu',
'Nanjukondapuram,Tiruvannamalai,Tamil Nadu',
'Odugathur,Vellore,Tamil Nadu',
'Old District Board Buildings,Vellore,Tamil Nadu',
'Old Town,Vellore,Tamil Nadu',
'Pennathur,Vellore,Tamil Nadu',
'Ramanayanikuppam,Vellore,Tamil Nadu',
'Saidapet,Vellore,Tamil Nadu',
'Sainathapuram,Vellore,Tamil Nadu',
'Sankaranpalayam,Vellore,Tamil Nadu',
'Sathuvacahri Extension,Vellore,Tamil Nadu',
'Sathuvachari,Vellore,Tamil Nadu',
'Sathyamangalam,Vellore,Tamil Nadu',
'Shenbakkam,Vellore,Tamil Nadu',
'Slr Sanatorium,Vellore,Tamil Nadu',
'Sullivanpet,Vellore,Tamil Nadu',
'Tbsanatorium,Vellore,Tamil Nadu',
'TEL,Vellore,Tamil Nadu',
'Thorapadi,Vellore,Tamil Nadu',
'Ussoor,Vellore,Tamil Nadu',
'Vaduganthangal,Vellore,Tamil Nadu',
'Varagur Pudur,Tiruvannamalai,Tamil Nadu',
'Velapadi,Vellore,Tamil Nadu',
'Vellore Bazaar,Vellore,Tamil Nadu',
'Vellore Collectorate,Vellore,Tamil Nadu',
'Vellore Fort,Vellore,Tamil Nadu',
'Vellore Institute Of Technolog,Vellore,Tamil Nadu',
'Vellore Market,Vellore,Tamil Nadu',
'Vellore South,Vellore,Tamil Nadu',
'Veppampattu,Vellore,Tamil Nadu',
'Virnjipuram,Vellore,Tamil Nadu',
'Virudhambattu,Vellore,Tamil Nadu',
'Virupakshipuram,Vellore,Tamil Nadu',
'Voorhees College,Vellore,Tamil Nadu',
'Vellore H.O,Vellore,Tamil Nadu',
'Vellore Cantonment,Vellore,Tamil Nadu',
'Vannanthangal,Vellore,Tamil Nadu',
'Vandranthangal,Vellore,Tamil Nadu',
'A Kattup[adi,Vellore,Tamil Nadu',
'Alleri,Vellore,Tamil Nadu',
'Amirdhi,Vellore,Tamil Nadu',
'Angarankuppam,Vellore,Tamil Nadu',
'Annangudi,Vellore,Tamil Nadu',
'Arimalai,Vellore,Tamil Nadu',
'Ariyur Spinning Mills,Vellore,Tamil Nadu',
'Arumbakkam,Vellore,Tamil Nadu',
'Arumparuthi,Vellore,Tamil Nadu',
'Asanamabattu,Vellore,Tamil Nadu',
'Bn Palayam,Vellore,Tamil Nadu',
'Bramhapuram,Vellore,Tamil Nadu',
'Budur,Vellore,Tamil Nadu',
'Chinnapalampakkam,Vellore,Tamil Nadu',
'Chinnapallikuppam,Vellore,Tamil Nadu',
'Christianpet,Vellore,Tamil Nadu',
'Dc Kuppam,Vellore,Tamil Nadu',
'Edayansathu,Vellore,Tamil Nadu',
'Elavambadi,Vellore,Tamil Nadu',
'Erayangadu,Vellore,Tamil Nadu',
'Eripudhur,Vellore,Tamil Nadu',
'Eriyur Amirdhi,Vellore,Tamil Nadu',
'Eriyur,Vellore,Tamil Nadu',
'Ganganallur,Vellore,Tamil Nadu',
'Gr Palayam,Vellore,Tamil Nadu',
'Jaffarapettai,Vellore,Tamil Nadu',
'Jordhankollai,Vellore,Tamil Nadu',
'Ka Farm,Vellore,Tamil Nadu',
'Kalambattu,Vellore,Tamil Nadu',
'Kandhipedu,Vellore,Tamil Nadu',
'Karasamangalam,Vellore,Tamil Nadu',
'Karigiri,Vellore,Tamil Nadu',
'Karugambathur,Vellore,Tamil Nadu',
'Kattipattu,Vellore,Tamil Nadu',
'Kavasampattu,Vellore,Tamil Nadu',
'Kilkothur,Vellore,Tamil Nadu',
'Kilmuttukur,Vellore,Tamil Nadu',
'Kilsaranakuppam,Vellore,Tamil Nadu',
'Koranthangal,Vellore,Tamil Nadu',
'Kothamangalam,Vellore,Tamil Nadu',
'Kovilandur,Vellore,Tamil Nadu',
'Melarasambattu,Vellore,Tamil Nadu',
'Melkuppachinna,Vellore,Tamil Nadu',
'Mr Kuppam,Vellore,Tamil Nadu',
'Mudinampattu,Vellore,Tamil Nadu',
'Mv Palayam,Vellore,Tamil Nadu',
'Nadanur,Vellore,Tamil Nadu',
'Naganadhi,Vellore,Tamil Nadu',
'Nammiyambattu,Vellore,Tamil Nadu',
'Nelvoy,Vellore,Tamil Nadu',
'Nemandhapura,m,Vellore,Tamil Nadu',
'Ongapadi,Vellore,Tamil Nadu',
'Pakkampalayam,Vellore,Tamil Nadu',
'Palamathi,Vellore,Tamil Nadu',
'Palambattu,Vellore,Tamil Nadu',
'Palaparambattu,Vellore,Tamil Nadu',
'Pallikuppam,Vellore,Tamil Nadu',
'Panamadangi,Vellore,Tamil Nadu',
'Periyapudhur,Vellore,Tamil Nadu',
'Perumugai,Vellore,Tamil Nadu',
'Pinnathurai,Vellore,Tamil Nadu',
'Poigai,Vellore,Tamil Nadu',
'Poigaimottur,Vellore,Tamil Nadu',
'Pulimedu,Vellore,Tamil Nadu',
'Saduperi,Vellore,Tamil Nadu',
'Sathupalayam,Vellore,Tamil Nadu',
'Sedhuvalai,Vellore,Tamil Nadu',
'Sekkanur,Vellore,Tamil Nadu',
'Sembedu,Vellore,Tamil Nadu',
'Senji,Vellore,Tamil Nadu',
'Senur,Vellore,Tamil Nadu',
'Serkadu,Vellore,Tamil Nadu',
'Sevur,Vellore,Tamil Nadu',
'Sivanathapuram,Vellore,Tamil Nadu',
'Sozhamur,Vellore,Tamil Nadu',
'Tellai,Vellore,Tamil Nadu',
'Tellur,Vellore,Tamil Nadu',
'Thandalam Krishnapuram,Vellore,Tamil Nadu',
'Thondanthualsi,Vellore,Tamil Nadu',
'Thongumalai,Vellore,Tamil Nadu',
'Thuthikkadu,Vellore,Tamil Nadu',
'Thuthipattu,Vellore,Tamil Nadu',
'Tirumani,Vellore,Tamil Nadu',
'Unai,Vellore,Tamil Nadu',
'Unai Vaniyambadi,Vellore,Tamil Nadu',
'Unaipalathur,Vellore,Tamil Nadu',
'Vallandramam,Vellore,Tamil Nadu',
'Varadalambattu,Vellore,Tamil Nadu',
'Velangadu,Vellore,Tamil Nadu',
'Veppankuppam,Vellore,Tamil Nadu',
'Serpadi,Vellore,Tamil Nadu',
'Alapakkam,Arakkonam,Tamil Nadu',
'Ammoor,Arakkonam,Tamil Nadu',
'Ammundi,Arakkonam,Tamil Nadu',
'Anandhalai,Arakkonam,Tamil Nadu',
'Arapakkam,Arakkonam,Tamil Nadu',
'Arungundram,Arakkonam,Tamil Nadu',
'Ayilam,Arakkonam,Tamil Nadu',
'Bhel Ranipet,Arakkonam,Tamil Nadu',
'Ekambaranallur,Arakkonam,Tamil Nadu',
'Eranthangal,Arakkonam,Tamil Nadu',
'Federation Buildings,Arakkonam,Tamil Nadu',
'Gudimallur,Arakkonam,Tamil Nadu',
'Gugainallore,Arakkonam,Tamil Nadu',
'Hakeemnagar,Arakkonam,Tamil Nadu',
'Kadaperi,Arakkonam,Tamil Nadu',
'Kalmelkuppam,Arakkonam,Tamil Nadu',
'Karai,Arakkonam,Tamil Nadu',
'Karnambut,Arakkonam,Tamil Nadu',
'Katrambakkam,Arakkonam,Tamil Nadu',
'Kaveripak,Arakkonam,Tamil Nadu',
'Kilminnal,Arakkonam,Tamil Nadu',
'Kilvisharam,Arakkonam,Tamil Nadu',
'Manthangal,Arakkonam,Tamil Nadu',
'Marudhalam,Arakkonam,Tamil Nadu',
'Melakuppam,Arakkonam,Tamil Nadu',
'Melvisharam,Arakkonam,Tamil Nadu',
'Mukundarayapuram,Arakkonam,Tamil Nadu',
'Nandiyalam,Arakkonam,Tamil Nadu',
'Navalpur,Arakkonam,Tamil Nadu',
'Neelakandarayanpattai,Arakkonam,Tamil Nadu',
'Ozhughur,Arakkonam,Tamil Nadu',
'Pagaveli,Arakkonam,Tamil Nadu',
'Periasengadu,Arakkonam,Tamil Nadu',
'Poondi,Arakkonam,Tamil Nadu',
'Puliyankannu,Arakkonam,Tamil Nadu',
'Puttuthakku,Arakkonam,Tamil Nadu',
'Ranipet East,Arakkonam,Tamil Nadu',
'Ranipet Industrial Estate,Arakkonam,Tamil Nadu',
'Ratnagiri Kilminnal,Arakkonam,Tamil Nadu',
'Rottukadai,Arakkonam,Tamil Nadu',
'Sathambakkam,Arakkonam,Tamil Nadu',
'Sembarayanallur,Arakkonam,Tamil Nadu',
'Seri,Arakkonam,Tamil Nadu',
'Sumaithangi,Arakkonam,Tamil Nadu',
'Tempalle,Arakkonam,Tamil Nadu',
'Thalangai,Arakkonam,Tamil Nadu',
'Thengal,Arakkonam,Tamil Nadu',
'Thenkadapanthangal,Arakkonam,Tamil Nadu',
'Thirumalaicheryy,Arakkonam,Tamil Nadu',
'Thiruparkadal,Arakkonam,Tamil Nadu',
'Thuraiperumbakkam,Arakkonam,Tamil Nadu',
'Tiruvalam,Arakkonam,Tamil Nadu',
'Valluvambakkam,Arakkonam,Tamil Nadu',
'Vanapadi,Arakkonam,Tamil Nadu',
'Vangur,Arakkonam,Tamil Nadu',
'Vannivedu,Arakkonam,Tamil Nadu',
'Velam,Arakkonam,Tamil Nadu',
'Vellore Sugar Mills,Arakkonam,Tamil Nadu',
'Walajapet Bazaar,Arakkonam,Tamil Nadu',
'Walajapet,Arakkonam,Tamil Nadu',
'Ranipet H.O,Arakkonam,Tamil Nadu',
'Seekarajapuram,Arakkonam,Tamil Nadu',
'Nallathur,Vriddhachalam,Tamil Nadu',
'T Athipakkam,Vriddhachalam,Tamil Nadu',
'Vilambar,Vriddhachalam,Tamil Nadu',
'Mundiyambakkam,Pondicherry,Tamil Nadu',
'Avalurpet,Pondicherry,Tamil Nadu',
'Gingee Bazaar,Pondicherry,Tamil Nadu',
'Gingee,Pondicherry,Tamil Nadu',
'Illodu,Pondicherry,Tamil Nadu',
'Agarakottalam,Vriddhachalam,Tamil Nadu',
'Ammaiyagaram,Vriddhachalam,Tamil Nadu',
'Ammakalathur,Vriddhachalam,Tamil Nadu',
'Anumanandal,Vriddhachalam,Tamil Nadu',
'Arampoondi,Vriddhachalam,Tamil Nadu',
'Asakalathur,Vriddhachalam,Tamil Nadu',
'Chellampattu,Vriddhachalam,Tamil Nadu',
'Chinnasalem,Vriddhachalam,Tamil Nadu',
'Dagamtheerthapuram,Vriddhachalam,Tamil Nadu',
'Eduthavainatham,Vriddhachalam,Tamil Nadu',
'Emapper,Vriddhachalam,Tamil Nadu',
'Eruvaipattinam,Vriddhachalam,Tamil Nadu',
'Eyyanur,Vriddhachalam,Tamil Nadu',
'Innadu,Vriddhachalam,Tamil Nadu',
'Iriyur,Vriddhachalam,Tamil Nadu',
'K.Alambalam,Vriddhachalam,Tamil Nadu',
'Kachirapalayam,Vriddhachalam,Tamil Nadu',
'Kallakurichi H.O,Vriddhachalam,Tamil Nadu',
'Kallakurichi South,Vriddhachalam,Tamil Nadu',
'Kaniyamur,Vriddhachalam,Tamil Nadu',
'Karadichittur,Vriddhachalam,Tamil Nadu',
'Kariyalur,Vriddhachalam,Tamil Nadu',
'Karunthalakurichi,Vriddhachalam,Tamil Nadu',
'Kodumathi,Vriddhachalam,Tamil Nadu',
'Kongarayapalayam,Vriddhachalam,Tamil Nadu',
'Kottapudur,Vriddhachalam,Tamil Nadu',
'Kudiraichandal,Vriddhachalam,Tamil Nadu',
'Kugaiyur Gds,Vriddhachalam,Tamil Nadu',
'Madavacherry,Vriddhachalam,Tamil Nadu',
'Madhur,Vriddhachalam,Tamil Nadu',
'Madur,Vriddhachalam,Tamil Nadu',
'Malaikottalam,Vriddhachalam,Tamil Nadu',
'Maligaimedu,Vriddhachalam,Tamil Nadu',
'Malliyapadi,Vriddhachalam,Tamil Nadu',
'Maniyampalayam,Vriddhachalam,Tamil Nadu',
'Manmalai,Vriddhachalam,Tamil Nadu',
'Mathur,Vriddhachalam,Tamil Nadu',
'Mattaparai,Vriddhachalam,Tamil Nadu',
'Melnariyappanur,Vriddhachalam,Tamil Nadu',
'Melur,Vriddhachalam,Tamil Nadu',
'Moongilpadi,Vriddhachalam,Tamil Nadu',
'Mudiyanur,Vriddhachalam,Tamil Nadu',
'Mundiyur,Vriddhachalam,Tamil Nadu',
'Nagalur,Vriddhachalam,Tamil Nadu',
'Neelamangalam,Vriddhachalam,Tamil Nadu',
'Nochimedu,Vriddhachalam,Tamil Nadu',
'Olagankathan,Vriddhachalam,Tamil Nadu',
'Olagiyanallur,Vriddhachalam,Tamil Nadu',
'Paithanthurai,Vriddhachalam,Tamil Nadu',
'Pakkampadi,Vriddhachalam,Tamil Nadu',
'Palayasiruvangur,Vriddhachalam,Tamil Nadu',
'Pallagacherry,Vriddhachalam,Tamil Nadu',
'Pandiyankuppam,Vriddhachalam,Tamil Nadu',
'Peelamedu,Vriddhachalam,Tamil Nadu',
'Periyamampattu,Vriddhachalam,Tamil Nadu',
'Perumangalam,Vriddhachalam,Tamil Nadu',
'Pethanur,Vriddhachalam,Tamil Nadu',
'Porasakurichi,Vriddhachalam,Tamil Nadu',
'Pottiyam,Vriddhachalam,Tamil Nadu',
'Prithivimangalam,Vriddhachalam,Tamil Nadu',
'Pudu Uchimedu,Vriddhachalam,Tamil Nadu',
'Pukkiravari,Vriddhachalam,Tamil Nadu',
'S. Naraiyur,Vriddhachalam,Tamil Nadu',
'S. Ohaiyur,Vriddhachalam,Tamil Nadu',
'Sethuvarayankuppam,Vriddhachalam,Tamil Nadu',
'Siruvangur,Vriddhachalam,Tamil Nadu',
'Siruvathur,Vriddhachalam,Tamil Nadu',
'Sithalur,Vriddhachalam,Tamil Nadu',
'Somandargudi,Vriddhachalam,Tamil Nadu',
'Sulankurichi,Vriddhachalam,Tamil Nadu',
'Thachur,Vriddhachalam,Tamil Nadu',
'Thandalai,Vriddhachalam,Tamil Nadu',
'Thengiyanatham,Vriddhachalam,Tamil Nadu',
'Thenkeeranur,Vriddhachalam,Tamil Nadu',
'Thensiruvalur,Vriddhachalam,Tamil Nadu',
'Thenthorasalur,Vriddhachalam,Tamil Nadu',
'Thottapadi,Vriddhachalam,Tamil Nadu',
'Thottiyam,Vriddhachalam,Tamil Nadu',
'Throadipattu,Vriddhachalam,Tamil Nadu',
'Timmalai,Vriddhachalam,Tamil Nadu',
'Tiyagadrug,Vriddhachalam,Tamil Nadu',
'Tiyagai,Vriddhachalam,Tamil Nadu',
'Uppur,Vriddhachalam,Tamil Nadu',
'V Alambalam,Vriddhachalam,Tamil Nadu',
'V Mamandur,Vriddhachalam,Tamil Nadu',
'Vadakkanandal,Vriddhachalam,Tamil Nadu',
'Vadathorasalur,Vriddhachalam,Tamil Nadu',
'Varanjaram,Vriddhachalam,Tamil Nadu',
'Vazhapadi,Vriddhachalam,Tamil Nadu',
'Veeracholapuram,Vriddhachalam,Tamil Nadu',
'Vellimalai,Vriddhachalam,Tamil Nadu',
'Vengaivadi,Vriddhachalam,Tamil Nadu',
'Venkatampettai,Vriddhachalam,Tamil Nadu',
'Vettiperumalagaram,Vriddhachalam,Tamil Nadu',
'Vilakkur,Vriddhachalam,Tamil Nadu',
'Virugavur,Vriddhachalam,Tamil Nadu',
'Anathur,Cuddalore,Tamil Nadu',
'Melthaniyalampattu,Cuddalore,Tamil Nadu',
'Somasipalayam,Cuddalore,Tamil Nadu',
'Murarbad,Vriddhachalam,Tamil Nadu',
'Alathur,Vriddhachalam,Tamil Nadu',
'Arasampattu,Vriddhachalam,Tamil Nadu',
'Arur,Vriddhachalam,Tamil Nadu',
'B. Arulambadi,Vriddhachalam,Tamil Nadu',
'Brammakundam,Vriddhachalam,Tamil Nadu',
'Cholampattu,Vriddhachalam,Tamil Nadu',
'Irudayampattu,Vriddhachalam,Tamil Nadu',
'Kilakkadu,Vriddhachalam,Tamil Nadu',
'Kilapattu,Vriddhachalam,Tamil Nadu',
'Komalur,Vriddhachalam,Tamil Nadu',
'Kosapadi,Vriddhachalam,Tamil Nadu',
'La- Gudalur,Vriddhachalam,Tamil Nadu',
'Lakkinayakkanpatti,Vriddhachalam,Tamil Nadu',
'Mandagapadi,Vriddhachalam,Tamil Nadu',
'Manjaputhur,Vriddhachalam,Tamil Nadu',
'Melsiruvallur,Vriddhachalam,Tamil Nadu',
'Michaelpuram,Vriddhachalam,Tamil Nadu',
'Mookanur,Vriddhachalam,Tamil Nadu',
'Mottampatti,Vriddhachalam,Tamil Nadu',
'Munivalai,Vriddhachalam,Tamil Nadu',
'Nedumanur,Vriddhachalam,Tamil Nadu',
'Nurolai,Vriddhachalam,Tamil Nadu',
'Pandalam,Vriddhachalam,Tamil Nadu',
'Pasar,Vriddhachalam,Tamil Nadu',
'Perumbur,Vriddhachalam,Tamil Nadu',
'Pootai,Vriddhachalam,Tamil Nadu',
'Porasapattu,Vriddhachalam,Tamil Nadu',
'Pounjipattu,Vriddhachalam,Tamil Nadu',
'Poykunam,Vriddhachalam,Tamil Nadu',
'Pudupalapattu,Vriddhachalam,Tamil Nadu',
'Pudupattu,Vriddhachalam,Tamil Nadu',
'Puthirampattu,Vriddhachalam,Tamil Nadu',
'Rangappanur,Vriddhachalam,Tamil Nadu',
'Ravathanallur,Vriddhachalam,Tamil Nadu',
'Rishivandiyam,Vriddhachalam,Tamil Nadu',
'S.Kolathur,Vriddhachalam,Tamil Nadu',
'Sankarapuram,Vriddhachalam,Tamil Nadu',
'Sathaputhur,Vriddhachalam,Tamil Nadu',
'Seedevi,Vriddhachalam,Tamil Nadu',
'Serapattu,Vriddhachalam,Tamil Nadu',
'Sikkadu,Vriddhachalam,Tamil Nadu',
'Soundaravallipalayam,Vriddhachalam,Tamil Nadu',
'Thekkampattu,Vriddhachalam,Tamil Nadu',
'Vadaponparappi,Vriddhachalam,Tamil Nadu',
'Vanjikuli,Vriddhachalam,Tamil Nadu',
'Vellarikadu,Vriddhachalam,Tamil Nadu',
'Vengodu,Vriddhachalam,Tamil Nadu',
'Viriyur,Vriddhachalam,Tamil Nadu',
'Sathyamagalam,Pondicherry,Tamil Nadu',
'Adavallikuthan,Pondicherry,Tamil Nadu',
'Akkur,Pondicherry,Tamil Nadu',
'Akshipakkam,Pondicherry,Tamil Nadu',
'Alagrammam,Pondicherry,Tamil Nadu',
'Alampoondi,Pondicherry,Tamil Nadu',
'Alankuppam,Pondicherry,Tamil Nadu',
'Alathur,Pondicherry,Tamil Nadu',
'Anaiyeri,Pondicherry,Tamil Nadu',
'Anangur,Pondicherry,Tamil Nadu',
'Anathur,Pondicherry,Tamil Nadu',
'Andapattu,Pondicherry,Tamil Nadu',
'Annamangalam,Pondicherry,Tamil Nadu',
'Anumandai,Pondicherry,Tamil Nadu',
'Arugavur,Pondicherry,Tamil Nadu',
'Athipakkam,Pondicherry,Tamil Nadu',
'Athipattu,Pondicherry,Tamil Nadu',
'Attur,Pondicherry,Tamil Nadu',
'Avanipur,Pondicherry,Tamil Nadu',
'Avarapakkam,Pondicherry,Tamil Nadu',
'Aviyur,Pondicherry,Tamil Nadu',
'Ayyanthoppu,Pondicherry,Tamil Nadu',
'Brahmadesam,Pondicherry,Tamil Nadu',
'Chellapiratti,Pondicherry,Tamil Nadu',
'Chendur,Pondicherry,Tamil Nadu',
'Chinnanerkunam,Pondicherry,Tamil Nadu',
'Dadapuram,Pondicherry,Tamil Nadu',
'Devadanampettai,Pondicherry,Tamil Nadu',
'Devandavadi,Pondicherry,Tamil Nadu',
'Devanur,Pondicherry,Tamil Nadu',
'Eachur,Pondicherry,Tamil Nadu',
'Endiyur,Pondicherry,Tamil Nadu',
'Eraiyanur,Pondicherry,Tamil Nadu',
'Eraiyur,Pondicherry,Tamil Nadu',
'Eyyakunam,Pondicherry,Tamil Nadu',
'Guduvampoondi,Pondicherry,Tamil Nadu',
'Idapattu,Pondicherry,Tamil Nadu',
'Jayankondam,Pondicherry,Tamil Nadu',
'Kadali,Pondicherry,Tamil Nadu',
'Kadambur,Pondicherry,Tamil Nadu',
'Kalaiyur,Pondicherry,Tamil Nadu',
'Kallapuliyur,Pondicherry,Tamil Nadu',
'Kalleri,Pondicherry,Tamil Nadu',
'Kanakkankuppam,Pondicherry,Tamil Nadu',
'Kandadu,Pondicherry,Tamil Nadu',
'Kappai,Pondicherry,Tamil Nadu',
'Kappalampadi,Pondicherry,Tamil Nadu',
'Karattai,Pondicherry,Tamil Nadu',
'Karnavur,Pondicherry,Tamil Nadu',
'Karuvampakkam,Pondicherry,Tamil Nadu',
'Katrambakkam,Pondicherry,Tamil Nadu',
'Kattalai,Pondicherry,Tamil Nadu',
'Kattusiviri,Pondicherry,Tamil Nadu',
'Kiladanur,Pondicherry,Tamil Nadu',
'Kiledayalam,Pondicherry,Tamil Nadu',
'Kiliyanur,Pondicherry,Tamil Nadu',
'Kilmavilangai,Pondicherry,Tamil Nadu',
'Kilsevur,Pondicherry,Tamil Nadu',
'Kodiyam,Pondicherry,Tamil Nadu',
'Kodukkur,Pondicherry,Tamil Nadu',
'Kolathur,Pondicherry,Tamil Nadu',
'Kollar,Pondicherry,Tamil Nadu',
'Konai,Pondicherry,Tamil Nadu',
'Kongarapattu,Pondicherry,Tamil Nadu',
'Korakeni,Pondicherry,Tamil Nadu',
'Kottapoondi,Pondicherry,Tamil Nadu',
'Kovilporaiyur,Pondicherry,Tamil Nadu',
'Kunimedu,Pondicherry,Tamil Nadu',
'Kunnapakkam,Pondicherry,Tamil Nadu',
'Kurunjipai,Pondicherry,Tamil Nadu',
'Kutteripattu,Pondicherry,Tamil Nadu',
'Madurapakkam,Pondicherry,Tamil Nadu',
'Mahadevimangalam,Pondicherry,Tamil Nadu',
'Mailam,Pondicherry,Tamil Nadu',
'Manalapadi,Pondicherry,Tamil Nadu',
'Manandal,Pondicherry,Tamil Nadu',
'Mandava,Pondicherry,Tamil Nadu',
'Markanum,Pondicherry,Tamil Nadu',
'Markonam,Pondicherry,Tamil Nadu',
'Melacheri,Pondicherry,Tamil Nadu',
'Melathipakkam,Pondicherry,Tamil Nadu',
'Meledayalam,Pondicherry,Tamil Nadu',
'Melmalayanur,Pondicherry,Tamil Nadu',
'Melmannur,Pondicherry,Tamil Nadu',
'Melolakkur,Pondicherry,Tamil Nadu',
'Melpettai,Pondicherry,Tamil Nadu',
'Melsevalambadi,Pondicherry,Tamil Nadu',
'Melsevur,Pondicherry,Tamil Nadu',
'Melsithamur,Pondicherry,Tamil Nadu',
'Melvailamur,Pondicherry,Tamil Nadu',
'Minambur,Pondicherry,Tamil Nadu',
'Modaiyur,Pondicherry,Tamil Nadu',
'Molasur,Pondicherry,Tamil Nadu',
'Munnur,Pondicherry,Tamil Nadu',
'Muppuli,Pondicherry,Tamil Nadu',
'Nadukuppam,Pondicherry,Tamil Nadu',
'Naduvanthangal,Pondicherry,Tamil Nadu',
'Nagar,Pondicherry,Tamil Nadu',
'Nallanpillaipetral,Pondicherry,Tamil Nadu',
'Nallavur,Pondicherry,Tamil Nadu',
'Naranamangalam,Pondicherry,Tamil Nadu',
'Nayambadi,Pondicherry,Tamil Nadu',
'Nedimoliyanur,Pondicherry,Tamil Nadu',
'Neganur,Pondicherry,Tamil Nadu',
'Nochalur,Pondicherry,Tamil Nadu',
'Nolambur,Pondicherry,Tamil Nadu',
'Odiampet,Pondicherry,Tamil Nadu',
'Olagapuram,Pondicherry,Tamil Nadu',
'Olakkur,Pondicherry,Tamil Nadu',
'Olundiapet,Pondicherry,Tamil Nadu',
'Omandur,Pondicherry,Tamil Nadu',
'Omipper,Pondicherry,Tamil Nadu',
'Ongur,Pondicherry,Tamil Nadu',
'Padipallam,Pondicherry,Tamil Nadu',
'Padirapuliyur,Pondicherry,Tamil Nadu',
'Pakkam,Pondicherry,Tamil Nadu',
'Palakuppam,Pondicherry,Tamil Nadu',
'Palapadi,Pondicherry,Tamil Nadu',
'Palapattu,Pondicherry,Tamil Nadu',
'Pallikulam,Pondicherry,Tamil Nadu',
'Panchalam,Pondicherry,Tamil Nadu',
'Pankolathur,Pondicherry,Tamil Nadu',
'Pennangar,Pondicherry,Tamil Nadu',
'Peramandur,Pondicherry,Tamil Nadu',
'Periyanmur,Pondicherry,Tamil Nadu',
'Periyanolambai,Pondicherry,Tamil Nadu',
'Perumbakkam,Pondicherry,Tamil Nadu',
'Perumukkal,Pondicherry,Tamil Nadu',
'Perungappur,Pondicherry,Tamil Nadu',
'Peruvalur,Pondicherry,Tamil Nadu',
'Pudupakkam,Pondicherry,Tamil Nadu',
'Pulichapllam,Pondicherry,Tamil Nadu',
'Radhhapuram,Pondicherry,Tamil Nadu',
'Rettanai,Pondicherry,Tamil Nadu',
'Saram ( Tindivanam ),Pondicherry,Tamil Nadu',
'Semangalam,Pondicherry,Tamil Nadu',
'Semmedu,Pondicherry,Tamil Nadu',
'Sepettai,Pondicherry,Tamil Nadu',
'Seshangur,Pondicherry,Tamil Nadu',
'Sevalapuri,Pondicherry,Tamil Nadu',
'Sholangunam,Pondicherry,Tamil Nadu',
'Singanur,Pondicherry,Tamil Nadu',
'Siruthalaipoondi,Pondicherry,Tamil Nadu',
'Sithani,Pondicherry,Tamil Nadu',
'Sokuppam,Pondicherry,Tamil Nadu',
'Thadagam,Pondicherry,Tamil Nadu',
'Thailapuram,Pondicherry,Tamil Nadu',
'Thaiyur,Pondicherry,Tamil Nadu',
'Thalangadu,Pondicherry,Tamil Nadu',
'Thalangunam,Pondicherry,Tamil Nadu',
'Thalavanur,Pondicherry,Tamil Nadu',
'Thaludali,Pondicherry,Tamil Nadu',
'Thamanur,Pondicherry,Tamil Nadu',
'Thandavasamudram,Pondicherry,Tamil Nadu',
'Thaniyal,Pondicherry,Tamil Nadu',
'Thayanur,Pondicherry,Tamil Nadu',
'Thenkalavoy,Pondicherry,Tamil Nadu',
'Thenkodipakkam,Pondicherry,Tamil Nadu',
'Thenpalai,Pondicherry,Tamil Nadu',
'Thenpasiyar,Pondicherry,Tamil Nadu',
'Thenputhur,Pondicherry,Tamil Nadu',
'Thensiruvalur,Pondicherry,Tamil Nadu',
'Theppirampattu,Pondicherry,Tamil Nadu',
'Thiruvampattu,Pondicherry,Tamil Nadu',
'Thiruvathikunnam,Pondicherry,Tamil Nadu',
'Thiurvakkarai,Pondicherry,Tamil Nadu',
'Thorapadi,Pondicherry,Tamil Nadu',
'Tindivanam Bazaar,Pondicherry,Tamil Nadu',
'Tindivanam East,Pondicherry,Tamil Nadu',
'Tindivanam H.O,Pondicherry,Tamil Nadu',
'Tindivanam West,Pondicherry,Tamil Nadu',
'Tirumangalam,Pondicherry,Tamil Nadu',
'Tivanur,Pondicherry,Tamil Nadu',
'Ural,Pondicherry,Tamil Nadu',
'V.Parangani,Pondicherry,Tamil Nadu',
'Vadanerkunam,Pondicherry,Tamil Nadu',
'Vadapalai,Pondicherry,Tamil Nadu',
'Vaidapakkam,Pondicherry,Tamil Nadu',
'Vakkur,Pondicherry,Tamil Nadu',
'Valathi,Pondicherry,Tamil Nadu',
'Vallam,Pondicherry,Tamil Nadu',
'Velanthangal,Pondicherry,Tamil Nadu',
'Veliyanur,Pondicherry,Tamil Nadu',
'Vellimeudpettai,Pondicherry,Tamil Nadu',
'Velur (SA),Pondicherry,Tamil Nadu',
'Vengandur,Pondicherry,Tamil Nadu',
'Vilukkam,Pondicherry,Tamil Nadu',
'Viranamur,Pondicherry,Tamil Nadu',
'Kaveripakkam,Pondicherry,Tamil Nadu',
'Sorapattu,Pondicherry,Tamil Nadu',
'Eyyal,Pondicherry,Tamil Nadu',
'Hemerjickx Cente,Pondicherry,Tamil Nadu',
'Nallathur,Pondicherry,Tamil Nadu',
'Sathambadi,Pondicherry,Tamil Nadu',
'Siruvadi,Pondicherry,Tamil Nadu',
'Vairapuram,Pondicherry,Tamil Nadu',
'Adichanur,Vriddhachalam,Tamil Nadu',
'Alambadi,Vriddhachalam,Tamil Nadu',
'Amur,Vriddhachalam,Tamil Nadu',
'Andrayanur,Vriddhachalam,Tamil Nadu',
'Arakandanallur,Vriddhachalam,Tamil Nadu',
'Arcadu,Vriddhachalam,Tamil Nadu',
'Ariyalur,Vriddhachalam,Tamil Nadu',
'Ariyur,Vriddhachalam,Tamil Nadu',
'Arulavadi,Vriddhachalam,Tamil Nadu',
'Arunkurukkai,Vriddhachalam,Tamil Nadu',
'Aruthangudi,Vriddhachalam,Tamil Nadu',
'Athiyur Thirukkai,Vriddhachalam,Tamil Nadu',
'Ayandur,Vriddhachalam,Tamil Nadu',
'C Meyyur,Vriddhachalam,Tamil Nadu',
'Cholavandipuram,Vriddhachalam,Tamil Nadu',
'Devanur,Vriddhachalam,Tamil Nadu',
'Devaradiyarkuppam,Vriddhachalam,Tamil Nadu',
'Deviagaram,Vriddhachalam,Tamil Nadu',
'Edapalayam,Vriddhachalam,Tamil Nadu',
'Eduthanur,Vriddhachalam,Tamil Nadu',
'Elayanarkuppam,Vriddhachalam,Tamil Nadu',
'Elrampattu,Vriddhachalam,Tamil Nadu',
'Emappur,Vriddhachalam,Tamil Nadu',
'Endal,Vriddhachalam,Tamil Nadu',
'Gramam,Vriddhachalam,Tamil Nadu',
'Jambai,Vriddhachalam,Tamil Nadu',
'Kadaganur,Vriddhachalam,Tamil Nadu',
'Kadambur,Vriddhachalam,Tamil Nadu',
'Kaduvanur,Vriddhachalam,Tamil Nadu',
'Kandachipuram,Vriddhachalam,Tamil Nadu',
'Kangeyanur,Vriddhachalam,Tamil Nadu',
'Kannarampattu,Vriddhachalam,Tamil Nadu',
'Karadi,Vriddhachalam,Tamil Nadu',
'Karanai,Vriddhachalam,Tamil Nadu',
'Kattu Edaiyur,Vriddhachalam,Tamil Nadu',
'Kattupaiyur,Vriddhachalam,Tamil Nadu',
'Kazhumalam,Vriddhachalam,Tamil Nadu',
'Keelathalanur,Vriddhachalam,Tamil Nadu',
'Kongarayanaur,Vriddhachalam,Tamil Nadu',
'Kottamrudur,Vriddhachalam,Tamil Nadu',
'Kuladeepamangalam,Vriddhachalam,Tamil Nadu',
'Kuvanur,Vriddhachalam,Tamil Nadu',
'Madam,Vriddhachalam,Tamil Nadu',
'Maiyanur,Vriddhachalam,Tamil Nadu',
'Malavanthangal,Vriddhachalam,Tamil Nadu',
'Manakuppam,Vriddhachalam,Tamil Nadu',
'Manalurpet,Vriddhachalam,Tamil Nadu',
'Manampoondi,Vriddhachalam,Tamil Nadu',
'Marangiyur,Vriddhachalam,Tamil Nadu',
'Melvalai,Vriddhachalam,Tamil Nadu',
'Memalur,Vriddhachalam,Tamil Nadu',
'Mogaiyur,Vriddhachalam,Tamil Nadu',
'Murukkambadi,Vriddhachalam,Tamil Nadu',
'Nallapalayam,Vriddhachalam,Tamil Nadu',
'Oddampattu,Vriddhachalam,Tamil Nadu',
'Odiyathur,Vriddhachalam,Tamil Nadu',
'Padiyandal,Vriddhachalam,Tamil Nadu',
'Paiyur,Vriddhachalam,Tamil Nadu',
'Pakkam,Vriddhachalam,Tamil Nadu',
'Paranur,Vriddhachalam,Tamil Nadu',
'Pavandur,Vriddhachalam,Tamil Nadu',
'Pazhangur,Vriddhachalam,Tamil Nadu',
'Periyakolliyur,Vriddhachalam,Tamil Nadu',
'Periyasevalai,Vriddhachalam,Tamil Nadu',
'Pilrampattu,Vriddhachalam,Tamil Nadu',
'S.Kodungal,Vriddhachalam,Tamil Nadu',
'Sangiyam,Vriddhachalam,Tamil Nadu',
'Santhapettai,Vriddhachalam,Tamil Nadu',
'Saravanapakkam,Vriddhachalam,Tamil Nadu',
'Sathiyakandanur,Vriddhachalam,Tamil Nadu',
'Sennakunam,Vriddhachalam,Tamil Nadu',
'Sirpadanallur,Vriddhachalam,Tamil Nadu',
'Sirpanandal,Vriddhachalam,Tamil Nadu',
'Sirumadurai,Vriddhachalam,Tamil Nadu',
'Sithalingamadam,Vriddhachalam,Tamil Nadu',
'Sithathur,Vriddhachalam,Tamil Nadu',
'T . Edayar,Vriddhachalam,Tamil Nadu',
'T . Kolathur,Vriddhachalam,Tamil Nadu',
'T . Kunnathur,Vriddhachalam,Tamil Nadu',
'T . Pudupalayam,Vriddhachalam,Tamil Nadu',
'Thaduthatkondur,Vriddhachalam,Tamil Nadu',
'Thagadi,Vriddhachalam,Tamil Nadu',
'Thapovanam,Vriddhachalam,Tamil Nadu',
'Tholuvanthangal,Vriddhachalam,Tamil Nadu',
'Tirukkoyilur Bazaar,Vriddhachalam,Tamil Nadu',
'Tirukkoyilur Busstand,Vriddhachalam,Tamil Nadu',
'Tirukkoyilur H.O,Vriddhachalam,Tamil Nadu',
'Tirukkoyilur.Athipakkam,Vriddhachalam,Tamil Nadu',
'Tiruppalapandal,Vriddhachalam,Tamil Nadu',
'Tiruvarangam,Vriddhachalam,Tamil Nadu',
'Tiruvennainallur,Vriddhachalam,Tamil Nadu',
'V . Puthur,Vriddhachalam,Tamil Nadu',
'Vadakaraithayanur,Vriddhachalam,Tamil Nadu',
'Vadamarudur,Vriddhachalam,Tamil Nadu',
'Vasanthakrishnapuram,Vriddhachalam,Tamil Nadu',
'Vengamur,Vriddhachalam,Tamil Nadu',
'Vengur,Vriddhachalam,Tamil Nadu',
'Vilandai,Vriddhachalam,Tamil Nadu',
'Virapandi,Vriddhachalam,Tamil Nadu',
'V.Nerkunam,Pondicherry,Tamil Nadu',
'Adaiyur,Vriddhachalam,Tamil Nadu',
'Adhanur,Vriddhachalam,Tamil Nadu',
'Aladi,Vriddhachalam,Tamil Nadu',
'Anganur,Vriddhachalam,Tamil Nadu',
'Arasur,Vriddhachalam,Tamil Nadu',
'Arumpattu,Vriddhachalam,Tamil Nadu',
'Asanur,Vriddhachalam,Tamil Nadu',
'Attur,Vriddhachalam,Tamil Nadu',
'Edaikkal,Vriddhachalam,Tamil Nadu',
'Elavanasur,Vriddhachalam,Tamil Nadu',
'Ellaigramam,Vriddhachalam,Tamil Nadu',
'Enathimangalam,Vriddhachalam,Tamil Nadu',
'Eraiyur,Vriddhachalam,Tamil Nadu',
'Eranji,Vriddhachalam,Tamil Nadu',
'Eruvelipattu,Vriddhachalam,Tamil Nadu',
'Eswarakandanallur,Vriddhachalam,Tamil Nadu',
'Gurupeedapuram,Vriddhachalam,Tamil Nadu',
'Irulakurichi,Vriddhachalam,Tamil Nadu',
'Irundai,Vriddhachalam,Tamil Nadu',
'Kalamarudur,Vriddhachalam,Tamil Nadu',
'Kanaiyar,Vriddhachalam,Tamil Nadu',
'Kiliyur,Vriddhachalam,Tamil Nadu',
'Kizakkumarudur,Vriddhachalam,Tamil Nadu',
'Koo-kallakurichi,Vriddhachalam,Tamil Nadu',
'Kuthakudi,Vriddhachalam,Tamil Nadu',
'Kuvadu,Vriddhachalam,Tamil Nadu',
'Kuvagam,Vriddhachalam,Tamil Nadu',
'Madapattu,Vriddhachalam,Tamil Nadu',
'Madiyanur,Vriddhachalam,Tamil Nadu',
'Ma-kunnathur,Vriddhachalam,Tamil Nadu',
'Moolasamudram,Vriddhachalam,Tamil Nadu',
'Nagar,Vriddhachalam,Tamil Nadu',
'Nannaram,Vriddhachalam,Tamil Nadu',
'Ninnaiyur,Vriddhachalam,Tamil Nadu',
'Orathur,Vriddhachalam,Tamil Nadu',
'Padur,Vriddhachalam,Tamil Nadu',
'Palakollai,Vriddhachalam,Tamil Nadu',
'Pallavadi,Vriddhachalam,Tamil Nadu',
'Pandur,Vriddhachalam,Tamil Nadu',
'Parikkal,Vriddhachalam,Tamil Nadu',
'Parindal,Vriddhachalam,Tamil Nadu',
'Perangiyur,Vriddhachalam,Tamil Nadu',
'Periyakuppam,Vriddhachalam,Tamil Nadu',
'Periyakurukkai,Vriddhachalam,Tamil Nadu',
'Perumbakkam,Vriddhachalam,Tamil Nadu',
'Pinnalavadi,Vriddhachalam,Tamil Nadu',
'Pu.Mambakkam,Vriddhachalam,Tamil Nadu',
'Pugaipatti,Vriddhachalam,Tamil Nadu',
'Pu-killanur,Vriddhachalam,Tamil Nadu',
'Pu-konalavadi,Vriddhachalam,Tamil Nadu',
'Puliyur,Vriddhachalam,Tamil Nadu',
'Pu-malayanur,Vriddhachalam,Tamil Nadu',
'Sembiamadevi,Vriddhachalam,Tamil Nadu',
'Semmanangur,Vriddhachalam,Tamil Nadu',
'Semmar,Vriddhachalam,Tamil Nadu',
'Sendamangalam,Vriddhachalam,Tamil Nadu',
'Sendanadu,Vriddhachalam,Tamil Nadu',
'Senkurichi,Vriddhachalam,Tamil Nadu',
'Sithanangur,Vriddhachalam,Tamil Nadu',
'T.Mavidanthal,Vriddhachalam,Tamil Nadu',
'Tirunavalur,Vriddhachalam,Tamil Nadu',
'Tiruppeyar,Vriddhachalam,Tamil Nadu',
'Ulundurpet Busstand,Vriddhachalam,Tamil Nadu',
'Ulundurpet,Vriddhachalam,Tamil Nadu',
'Valayampattu,Vriddhachalam,Tamil Nadu',
'Vanampattu,Vriddhachalam,Tamil Nadu',
'Vellaiyur,Vriddhachalam,Tamil Nadu',
'Velur,Vriddhachalam,Tamil Nadu',
'Auroville,Pondicherry,Tamil Nadu',
'Kaluperumbakkam,Pondicherry,Tamil Nadu',
'Kilinjikuppam,Pondicherry,Tamil Nadu',
'Tiruchitambalam,Pondicherry,Tamil Nadu',
'Vanur,Pondicherry,Tamil Nadu',
'Pidagam,Pondicherry,Tamil Nadu',
'Adanur,Pondicherry,Tamil Nadu',
'Anangur,Pondicherry,Tamil Nadu',
'Ananthapuram,Pondicherry,Tamil Nadu',
'Anilady,Pondicherry,Tamil Nadu',
'Anniyur,Pondicherry,Tamil Nadu',
'Ariyalur Tirukkai,Pondicherry,Tamil Nadu',
'Ariyur,Pondicherry,Tamil Nadu',
'Arpisampalayam,Pondicherry,Tamil Nadu',
'Asokapuri,Pondicherry,Tamil Nadu',
'Asur,Pondicherry,Tamil Nadu',
'Athiyur,Pondicherry,Tamil Nadu',
'Athiyur Thiruvadi,Pondicherry,Tamil Nadu',
'Avadayarpattu,Pondicherry,Tamil Nadu',
'Ayyur Agaram,Pondicherry,Tamil Nadu',
'Brahmadesam,Pondicherry,Tamil Nadu',
'Chinnababusamudram,Pondicherry,Tamil Nadu',
'Chinthamani,Pondicherry,Tamil Nadu',
'Coudapakkam,Pondicherry,Tamil Nadu',
'Gengarampalayam,Pondicherry,Tamil Nadu',
'Kadaperikuppam,Pondicherry,Tamil Nadu',
'Kakkanur,Pondicherry,Tamil Nadu',
'Kalayampoondi,Pondicherry,Tamil Nadu',
'Kallapattu,Pondicherry,Tamil Nadu',
'Kallipattu,Pondicherry,Tamil Nadu',
'Kalpattu,Pondicherry,Tamil Nadu',
'Kamala Nagar,Pondicherry,Tamil Nadu',
'Kanai,Pondicherry,Tamil Nadu',
'Kandamangalam,Pondicherry,Tamil Nadu',
'Kandambakkam,Pondicherry,Tamil Nadu',
'Kandnamanadi,Pondicherry,Tamil Nadu',
'Kangiyanur,Pondicherry,Tamil Nadu',
'Kanjanur,Pondicherry,Tamil Nadu',
'Kappiyampuliyur,Pondicherry,Tamil Nadu',
'Kappur,Pondicherry,Tamil Nadu',
'Karai,Pondicherry,Tamil Nadu',
'Karuvakshi,Pondicherry,Tamil Nadu',
'Katterikuppam,Pondicherry,Tamil Nadu',
'Kedar,Pondicherry,Tamil Nadu',
'Kilmambattu,Pondicherry,Tamil Nadu',
'Kilperumbakkam,Pondicherry,Tamil Nadu',
'Koliyanur,Pondicherry,Tamil Nadu',
'Konalur,Pondicherry,Tamil Nadu',
'Kondangi,Pondicherry,Tamil Nadu',
'Konur,Pondicherry,Tamil Nadu',
'Kottayampoondi,Pondicherry,Tamil Nadu',
'Kumarakuppam,Pondicherry,Tamil Nadu',
'Kumulam,Pondicherry,Tamil Nadu',
'Kundalapuliyur,Pondicherry,Tamil Nadu',
'Lingareddpalayam,Pondicherry,Tamil Nadu',
'Madugadipet,Pondicherry,Tamil Nadu',
'Maharajapuam,Pondicherry,Tamil Nadu',
'Mambazhapattu,Pondicherry,Tamil Nadu',
'Maragadhapuram,Pondicherry,Tamil Nadu',
'Melakondai,Pondicherry,Tamil Nadu',
'Melkaranai,Pondicherry,Tamil Nadu',
'Melpathi,Pondicherry,Tamil Nadu',
'Mettupalayam,Pondicherry,Tamil Nadu',
'Mokshakulam,Pondicherry,Tamil Nadu',
'Muttathur,Pondicherry,Tamil Nadu',
'Nainarpalayam,Vriddhachalam,Tamil Nadu',
'Nangathur,Pondicherry,Tamil Nadu',
'Nanndu,Pondicherry,Tamil Nadu',
'Naraiyur,Pondicherry,Tamil Nadu',
'Negandur,Pondicherry,Tamil Nadu',
'Nemur,Pondicherry,Tamil Nadu',
'Orathur,Pondicherry,Tamil Nadu',
'Orukodi,Pondicherry,Tamil Nadu',
'P.Villiyanur,Pondicherry,Tamil Nadu',
'Palayam,Pondicherry,Tamil Nadu',
'Palliandur,Pondicherry,Tamil Nadu',
'Pallineliyanur,Pondicherry,Tamil Nadu',
'Pallithennal,Pondicherry,Tamil Nadu',
'Panamalai,Pondicherry,Tamil Nadu',
'Panampattu,Pondicherry,Tamil Nadu',
'Panayapuram,Pondicherry,Tamil Nadu',
'Perani,Pondicherry,Tamil Nadu',
'Periyababusamudram,Pondicherry,Tamil Nadu',
'Periyathatchur,Pondicherry,Tamil Nadu',
'Perumbakkam,Pondicherry,Tamil Nadu',
'Pidaripattu,Pondicherry,Tamil Nadu',
'Pillur,Pondicherry,Tamil Nadu',
'Pombur,Pondicherry,Tamil Nadu',
'Ponnankuppam,Pondicherry,Tamil Nadu',
'Poovarasankuppam,Pondicherry,Tamil Nadu',
'Porur,Pondicherry,Tamil Nadu',
'Poyyapakkam,Pondicherry,Tamil Nadu',
'Puranasingupalayam,Pondicherry,Tamil Nadu',
'Rampakkam,Pondicherry,Tamil Nadu',
'Salayampalayam,Pondicherry,Tamil Nadu',
'Sangeethamangalam,Pondicherry,Tamil Nadu',
'Santhanagopalapuram,Pondicherry,Tamil Nadu',
'Se.Kunnatur,Pondicherry,Tamil Nadu',
'Serndanur,Pondicherry,Tamil Nadu',
'Siruvalai,Pondicherry,Tamil Nadu',
'Suthukeni,Pondicherry,Tamil Nadu',
'T.Mettupalayam,Pondicherry,Tamil Nadu',
'T.Pudupalayam,Pondicherry,Tamil Nadu',
'Teli,Pondicherry,Tamil Nadu',
'Thirubuvanai,Pondicherry,Tamil Nadu',
'Thiruvamathr,Pondicherry,Tamil Nadu',
'Thiruvandarkoil,Pondicherry,Tamil Nadu',
'Thondamanatham,Pondicherry,Tamil Nadu',
'Thoravi,Pondicherry,Tamil Nadu',
'Tirupachanur,Pondicherry,Tamil Nadu',
'V.Budur,Pondicherry,Tamil Nadu',
'V.Marudur,Pondicherry,Tamil Nadu',
'V.Mathur,Pondicherry,Tamil Nadu',
'V.Mathur,Pondicherry,Tamil Nadu',
'V.Nallalam,Pondicherry,Tamil Nadu',
'V.Salai,Pondicherry,Tamil Nadu',
'V.Sathanur,Pondicherry,Tamil Nadu',
'Valavanur,Pondicherry,Tamil Nadu',
'Valudareddy,Pondicherry,Tamil Nadu',
'Valudavur,Pondicherry,Tamil Nadu',
'Vembi,Pondicherry,Tamil Nadu',
'Venkatadri Agaram,Pondicherry,Tamil Nadu',
'Vidur,Pondicherry,Tamil Nadu',
'Vidur Dam,Pondicherry,Tamil Nadu',
'Vikravandi R.S.,Pondicherry,Tamil Nadu',
'Vikravandi,Pondicherry,Tamil Nadu',
'Villupuram East,Pondicherry,Tamil Nadu',
'Villupuram H.O,Pondicherry,Tamil Nadu',
'Villupuram West,Pondicherry,Tamil Nadu',
'Viramur,Pondicherry,Tamil Nadu',
'Vengandur,Pondicherry,Tamil Nadu',
'Kullursandai,Virudhunagar,Tamil Nadu',
'Mudukkankulam,Virudhunagar,Tamil Nadu',
'P Thottiankulam,Virudhunagar,Tamil Nadu',
'Aruppukottai H.O,Virudhunagar,Tamil Nadu',
'Aladipatti,Virudhunagar,Tamil Nadu',
'Amanakkunatham,Virudhunagar,Tamil Nadu',
'Aruppukottai Bazzar,Virudhunagar,Tamil Nadu',
'Aruppukottai East,Virudhunagar,Tamil Nadu',
'Aruppukottai Nehru Maidanam,Virudhunagar,Tamil Nadu',
'Aruppukottai West,Virudhunagar,Tamil Nadu',
'Chettikurichi,Virudhunagar,Tamil Nadu',
'Chidambarapuram,Virudhunagar,Tamil Nadu',
'K.Chettikulam,Virudhunagar,Tamil Nadu',
'Kalayar Karisalkulam,Virudhunagar,Tamil Nadu',
'Kallurani,Virudhunagar,Tamil Nadu',
'Kattangudi,Virudhunagar,Tamil Nadu',
'Kilgudi,Virudhunagar,Tamil Nadu',
'Koppusithampatti,Virudhunagar,Tamil Nadu',
'Kovilangulam,Virudhunagar,Tamil Nadu',
'Kurundamadam,Virudhunagar,Tamil Nadu',
'M.Reddiapatti,Virudhunagar,Tamil Nadu',
'Mandapasalai,Virudhunagar,Tamil Nadu',
'Maravarperungudi,Virudhunagar,Tamil Nadu',
'Palavantham,Virudhunagar,Tamil Nadu',
'Palayampatti,Virudhunagar,Tamil Nadu',
'Pandalgudi,Virudhunagar,Tamil Nadu',
'Paralachi,Virudhunagar,Tamil Nadu',
'Poolangal,Virudhunagar,Tamil Nadu',
'Puliyuran,Virudhunagar,Tamil Nadu',
'Pungamarathupatti,Virudhunagar,Tamil Nadu',
'R.Kallumadam,Virudhunagar,Tamil Nadu',
'Ramasamy Nagar,Virudhunagar,Tamil Nadu',
'Sempatti,Virudhunagar,Tamil Nadu',
'Sengulam,Virudhunagar,Tamil Nadu',
'Sudhamadam,Virudhunagar,Tamil Nadu',
'Sukkilanatham,Virudhunagar,Tamil Nadu',
'T.Meenakshipuram,Virudhunagar,Tamil Nadu',
'Thoppalakarai,Virudhunagar,Tamil Nadu',
'Thummusinnampatti,Virudhunagar,Tamil Nadu',
'Vadakkunatham,Virudhunagar,Tamil Nadu',
'Vadhuvarpatti,Virudhunagar,Tamil Nadu',
'Vedanatham,Virudhunagar,Tamil Nadu',
'Vellayapuram,Virudhunagar,Tamil Nadu',
'Villipathiri,Virudhunagar,Tamil Nadu',
'Alagianallur,Virudhunagar,Tamil Nadu',
'Allalaperi,Virudhunagar,Tamil Nadu',
'Aviyur,Virudhunagar,Tamil Nadu',
'Chatrapuliyankulam,Virudhunagar,Tamil Nadu',
'Chithunundradaippu,Virudhunagar,Tamil Nadu',
'Kalkurichi,Virudhunagar,Tamil Nadu',
'Kambigudi,Virudhunagar,Tamil Nadu',
'Kariapatti,Virudhunagar,Tamil Nadu',
'Kurandi,Virudhunagar,Tamil Nadu',
'Mallanginar,Virudhunagar,Tamil Nadu',
'Manthoppu,Virudhunagar,Tamil Nadu',
'Maraikulam,Virudhunagar,Tamil Nadu',
'Melathulukkankulam,Virudhunagar,Tamil Nadu',
'Musttakurichi,Virudhunagar,Tamil Nadu',
'Pampatti,Virudhunagar,Tamil Nadu',
'Perunjalai Pudupatti,Virudhunagar,Tamil Nadu',
'Vairavanangoor,Virudhunagar,Tamil Nadu',
'Vakkanangundu,Virudhunagar,Tamil Nadu',
'Appayanaickenpatti,Virudhunagar,Tamil Nadu',
'Ayankollangondan,Virudhunagar,Tamil Nadu',
'Chatrapatti,Virudhunagar,Tamil Nadu',
'Chockalingapuram,Virudhunagar,Tamil Nadu',
'Chockanathanpudur,Virudhunagar,Tamil Nadu',
'Cholapuram South,Virudhunagar,Tamil Nadu',
'Devadanam,Virudhunagar,Tamil Nadu',
'Dhalavaipuram,Virudhunagar,Tamil Nadu',
'Gopalapuram,Virudhunagar,Tamil Nadu',
'Kilarajakularaman,Virudhunagar,Tamil Nadu',
'Kilavikulam,Virudhunagar,Tamil Nadu',
'Krishnapuram,Virudhunagar,Tamil Nadu',
'Lakshmipuram,Virudhunagar,Tamil Nadu',
'Meenakshipuram,Virudhunagar,Tamil Nadu',
'Melanmarainadu,Virudhunagar,Tamil Nadu',
'Melapattamkarisalkulam,Virudhunagar,Tamil Nadu',
'Mohamed Sahibpuram,Virudhunagar,Tamil Nadu',
'Muhavur,Virudhunagar,Tamil Nadu',
'Nallamanaickenpatti,Virudhunagar,Tamil Nadu',
'Pottalpatti,Virudhunagar,Tamil Nadu',
'Pudupalayam,Virudhunagar,Tamil Nadu',
'Puthur,Virudhunagar,Tamil Nadu',
'R.Reddiapatti,Virudhunagar,Tamil Nadu',
'Rajapalayam Ambalapuli Bazzar,Virudhunagar,Tamil Nadu',
'Rajapalayam Bazzar,Virudhunagar,Tamil Nadu',
'Rajapalayam Bus Stand,Virudhunagar,Tamil Nadu',
'Rajapalayam H.O,Virudhunagar,Tamil Nadu',
'Ramalingapuram,Virudhunagar,Tamil Nadu',
'Sammandapuram,Virudhunagar,Tamil Nadu',
'Samsigapuram,Virudhunagar,Tamil Nadu',
'Seithur,Virudhunagar,Tamil Nadu',
'Settiyarpatti,Virudhunagar,Tamil Nadu',
'Sivalingapuram,Virudhunagar,Tamil Nadu',
'Solapuram,Virudhunagar,Tamil Nadu',
'Sundaranachiarpuram,Virudhunagar,Tamil Nadu',
'Sundararajapuram,Virudhunagar,Tamil Nadu',
'Tamilnadu Cements Alangulam,Virudhunagar,Tamil Nadu',
'Terkuvenganllur,Virudhunagar,Tamil Nadu',
'Thombakulam,Virudhunagar,Tamil Nadu',
'Vadakarai,Virudhunagar,Tamil Nadu',
'Valayapatti,Virudhunagar,Tamil Nadu',
'Zaminkollangondan,Virudhunagar,Tamil Nadu',
'Kumarasamy Raja Nagar,Virudhunagar,Tamil Nadu',
'A.Ramalingapuram,Virudhunagar,Tamil Nadu',
'Elayirampannai,Virudhunagar,Tamil Nadu',
'Gollapatti,Virudhunagar,Tamil Nadu',
'Guhanparai,Virudhunagar,Tamil Nadu',
'Karisalpatti,Virudhunagar,Tamil Nadu',
'Kosugundu,Virudhunagar,Tamil Nadu',
'Mettamalai,Virudhunagar,Tamil Nadu',
'Mulliseval,Virudhunagar,Tamil Nadu',
'N.Subbiahpuram,Virudhunagar,Tamil Nadu',
'Naduvapatti,Virudhunagar,Tamil Nadu',
'Nalli,Virudhunagar,Tamil Nadu',
'Nathathupatti,Virudhunagar,Tamil Nadu',
'Nenmeni,Virudhunagar,Tamil Nadu',
'Odaipatti,Virudhunagar,Tamil Nadu',
'Othayal Mettupatti,Virudhunagar,Tamil Nadu',
'Padanthal,Virudhunagar,Tamil Nadu',
'Pappakudi,Virudhunagar,Tamil Nadu',
'Ramasamy Raja Nagar,Virudhunagar,Tamil Nadu',
'Sankarapandiapuram,Virudhunagar,Tamil Nadu',
'Sattur,Virudhunagar,Tamil Nadu',
'Sattur West,Virudhunagar,Tamil Nadu',
'Sengamalanachiapuram,Virudhunagar,Tamil Nadu',
'Settudayanpatti,Virudhunagar,Tamil Nadu',
'Sevalpatti,Virudhunagar,Tamil Nadu',
'Surangudi,Virudhunagar,Tamil Nadu',
'Thungareddiapatti,Virudhunagar,Tamil Nadu',
'Uppathur,Virudhunagar,Tamil Nadu',
'Vadamalapuram,Virudhunagar,Tamil Nadu',
'Venkatachalapuram,Virudhunagar,Tamil Nadu',
'Achankulam,Virudhunagar,Tamil Nadu',
'Alamarathupatti,Virudhunagar,Tamil Nadu',
'Alangulam,Virudhunagar,Tamil Nadu',
'Anaiyur,Virudhunagar,Tamil Nadu',
'Anuppankulam,Virudhunagar,Tamil Nadu',
'Appayanaickenpatti,Virudhunagar,Tamil Nadu',
'Boovanathapuram,Virudhunagar,Tamil Nadu',
'Edirkottai,Virudhunagar,Tamil Nadu',
'Erichanatham,Virudhunagar,Tamil Nadu',
'Injar,Virudhunagar,Tamil Nadu',
'Kakkivadanpatti,Virudhunagar,Tamil Nadu',
'Kallamanaickenpatti,Virudhunagar,Tamil Nadu',
'Kangarseval,Virudhunagar,Tamil Nadu',
'Kundayiruppu,Virudhunagar,Tamil Nadu',
'Mangalam,Virudhunagar,Tamil Nadu',
'Maraneri,Virudhunagar,Tamil Nadu',
'Meenampatti,Virudhunagar,Tamil Nadu',
'Mudalipatti,Virudhunagar,Tamil Nadu',
'Naranapuram,Virudhunagar,Tamil Nadu',
'Nathikudi,Virudhunagar,Tamil Nadu',
'Nedungulam,Virudhunagar,Tamil Nadu',
'Panayadipatti,Virudhunagar,Tamil Nadu',
'Pudukottai,Virudhunagar,Tamil Nadu',
'Salvarpatti,Virudhunagar,Tamil Nadu',
'Sinnakamanpatti,Virudhunagar,Tamil Nadu',
'Sithurajapuram,Virudhunagar,Tamil Nadu',
'Sivakasi Bazzar,Virudhunagar,Tamil Nadu',
'Sivakasi Bus Stand,Virudhunagar,Tamil Nadu',
'Sivakasi East,Virudhunagar,Tamil Nadu',
'Sivakasi H.O,Virudhunagar,Tamil Nadu',
'Sivakasi R S,Virudhunagar,Tamil Nadu',
'Sivakasi South,Virudhunagar,Tamil Nadu',
'Sivakasi West,Virudhunagar,Tamil Nadu',
'Subramaniapuram,Virudhunagar,Tamil Nadu',
'Thayilpatti,Virudhunagar,Tamil Nadu',
'Tiruthangal,Virudhunagar,Tamil Nadu',
'Vaithilingapuram,Virudhunagar,Tamil Nadu',
'Vembakottai,Virudhunagar,Tamil Nadu',
'Vetrilaiyurani,Virudhunagar,Tamil Nadu',
'Vijayakarisalkulam,Virudhunagar,Tamil Nadu',
'Vilampatti,Virudhunagar,Tamil Nadu',
'Viswanatham,Virudhunagar,Tamil Nadu',
'Kummapatti,Virudhunagar,Tamil Nadu',
'Madavar Vilagam,Virudhunagar,Tamil Nadu',
'Maharajapuram,Virudhunagar,Tamil Nadu',
'Malli,Virudhunagar,Tamil Nadu',
'Mallipudur,Virudhunagar,Tamil Nadu',
'Pillayarkulam,Virudhunagar,Tamil Nadu',
'Srivilliputhur North,Virudhunagar,Tamil Nadu',
'Srivilliputhur,Virudhunagar,Tamil Nadu',
'Sundarapandiam,Virudhunagar,Tamil Nadu',
'W Pudupatti,Virudhunagar,Tamil Nadu',
'Watrap,Virudhunagar,Tamil Nadu',
'Achanthavirthan,Virudhunagar,Tamil Nadu',
'Athikulam,Virudhunagar,Tamil Nadu',
'Ayanathampatti,Virudhunagar,Tamil Nadu',
'Ilandaikulam,Virudhunagar,Tamil Nadu',
'Inamkarisalkulam,Virudhunagar,Tamil Nadu',
'Kadaneri,Virudhunagar,Tamil Nadu',
'Kansapuram,Virudhunagar,Tamil Nadu',
'Karisalkulam,Virudhunagar,Tamil Nadu',
'Kottaiyur,Virudhunagar,Tamil Nadu',
'Kunnur,Virudhunagar,Tamil Nadu',
'Kunnur South,Virudhunagar,Tamil Nadu',
'Mamsapuram,Virudhunagar,Tamil Nadu',
'Meenakshipuram,Virudhunagar,Tamil Nadu',
'Moovaraivendran,Virudhunagar,Tamil Nadu',
'Nachiyarkoil,Virudhunagar,Tamil Nadu',
'Nathampatti,Virudhunagar,Tamil Nadu',
'P.Ramachandrapuram,Virudhunagar,Tamil Nadu',
'P.Sallipatti,Virudhunagar,Tamil Nadu',
'Pilavakkaldam,Virudhunagar,Tamil Nadu',
'Pillayarnatham,Virudhunagar,Tamil Nadu',
'S.Ramachandrapuram,Virudhunagar,Tamil Nadu',
'Seshapuram,Virudhunagar,Tamil Nadu',
'Sethunarayanapuram,Virudhunagar,Tamil Nadu',
'T.Managaseri,Virudhunagar,Tamil Nadu',
'Thailapuram,Virudhunagar,Tamil Nadu',
'Villupanur,Virudhunagar,Tamil Nadu',
'Alagapuri,Virudhunagar,Tamil Nadu',
'Anaikulam,Virudhunagar,Tamil Nadu',
'Dharmam,Virudhunagar,Tamil Nadu',
'Iluppaiyur,Virudhunagar,Tamil Nadu',
'Irunjirai,Virudhunagar,Tamil Nadu',
'Isali,Virudhunagar,Tamil Nadu',
'Karendal,Virudhunagar,Tamil Nadu',
'Kuchampatti,Virudhunagar,Tamil Nadu',
'Nalur,Virudhunagar,Tamil Nadu',
'Narikudi,Virudhunagar,Tamil Nadu',
'Panaiyur,Virudhunagar,Tamil Nadu',
'Pervelangudi,Virudhunagar,Tamil Nadu',
'Sennilaikudi,Virudhunagar,Tamil Nadu',
'Siruvanur,Virudhunagar,Tamil Nadu',
'Tamilpadi,Virudhunagar,Tamil Nadu',
'Tiruchuli,Virudhunagar,Tamil Nadu',
'Ulagudi,Virudhunagar,Tamil Nadu',
'Viracholan,Virudhunagar,Tamil Nadu',
'Allampatti,Virudhunagar,Tamil Nadu',
'Amathur,Virudhunagar,Tamil Nadu',
'Anaikuttam,Virudhunagar,Tamil Nadu',
'Appayanaickenpatti,Virudhunagar,Tamil Nadu',
'Avudayapuram,Virudhunagar,Tamil Nadu',
'Chatrareddiapatti,Virudhunagar,Tamil Nadu',
'Chockalingapuram,Virudhunagar,Tamil Nadu',
'Inamreddiapatti,Virudhunagar,Tamil Nadu',
'Irukkangaudi,Virudhunagar,Tamil Nadu',
'Kamaraj Nagar,Virudhunagar,Tamil Nadu',
'Kokkalanjeri,Virudhunagar,Tamil Nadu',
'Kotthiyur Gurusamykoil,Virudhunagar,Tamil Nadu',
'M.Pudupatti,Virudhunagar,Tamil Nadu',
'Malaipatti,Virudhunagar,Tamil Nadu',
'Meesalur,Virudhunagar,Tamil Nadu',
'Mepco.Engg.College,Virudhunagar,Tamil Nadu',
'Mettugundu,Virudhunagar,Tamil Nadu',
'Mullipatti,Virudhunagar,Tamil Nadu',
'Muthulapuram,Virudhunagar,Tamil Nadu',
'Pattampudur,Virudhunagar,Tamil Nadu',
'Pavali,Virudhunagar,Tamil Nadu',
'Periaperali,Virudhunagar,Tamil Nadu',
'Periavallikulam,Virudhunagar,Tamil Nadu',
'Pudupatti,Virudhunagar,Tamil Nadu',
'Sankaralingapuram,Virudhunagar,Tamil Nadu',
'Sengundrapuram,Virudhunagar,Tamil Nadu',
'Sennelgudi,Virudhunagar,Tamil Nadu',
'Soolakkarai,Virudhunagar,Tamil Nadu',
'T.Sedapatti,Virudhunagar,Tamil Nadu',
'Thulukkapatti,Virudhunagar,Tamil Nadu',
'Thulukkapatti R.S.,Virudhunagar,Tamil Nadu',
'V.Muthulingapuram,Virudhunagar,Tamil Nadu',
'Vadamalaikurichi,Virudhunagar,Tamil Nadu',
'Valliyur,Virudhunagar,Tamil Nadu',
'Vellur,Virudhunagar,Tamil Nadu',
'Virudhunagar Bazaar,Virudhunagar,Tamil Nadu',
'Virudhunagar Bus Stand,Virudhunagar,Tamil Nadu',
'Virudhunagar Collectorate,Virudhunagar,Tamil Nadu',
'Virudhunagar Extension,Virudhunagar,Tamil Nadu',
'Virudhunagar H.O,Virudhunagar,Tamil Nadu',
'Virudhunagar Housing Unit Colo,Virudhunagar,Tamil Nadu',
'Virudhunagar Industrial Estate,Virudhunagar,Tamil Nadu',
'Virudhunagar North,Virudhunagar,Tamil Nadu',
'Virudhunagar R.S.,Virudhunagar,Tamil Nadu',
'Virudhunagar Town,Virudhunagar,Tamil Nadu',
'Virudhunagar West,Virudhunagar,Tamil Nadu',
'Adarsh Nagar (Ajmer),Ajmer,Rajasthan',
'Ajaiser,Ajmer,Rajasthan',
'Ajmer H.O,Ajmer,Rajasthan',
'Alwar Gate Ajmer,Ajmer,Rajasthan',
'Amba Masina,Ajmer,Rajasthan',
'Ararka,Ajmer,Rajasthan',
'Asha Ganj Ajmer,Ajmer,Rajasthan',
'Ashok Marg Ajmer,Ajmer,Rajasthan',
'Babaicha,Ajmer,Rajasthan',
'Badlia,Ajmer,Rajasthan',
'Beer,Ajmer,Rajasthan',
'Bhagwan Pura,Ajmer,Rajasthan',
'Bhajan Ganj Ajmer,Ajmer,Rajasthan',
'Bhaonta,Ajmer,Rajasthan',
'Bhudol,Ajmer,Rajasthan',
'Bithur,Ajmer,Rajasthan',
'Bubani,Ajmer,Rajasthan',
'Chachiwas,Ajmer,Rajasthan',
'Chorsiawas,Ajmer,Rajasthan',
'Christirin Ganj Ajmer,Ajmer,Rajasthan',
'Crpf Ajmer,Ajmer,Rajasthan',
'Danta,Ajmer,Rajasthan',
'Dargha Shareef Ajmer,Ajmer,Rajasthan',
'Deo Nagar,Ajmer,Rajasthan',
'Dhan Mandi Ajmer,Ajmer,Rajasthan',
'Dhola Bhata Ajmer,Ajmer,Rajasthan',
'Dorai,Ajmer,Rajasthan',
'Dumara,Ajmer,Rajasthan',
'Gagwana,Ajmer,Rajasthan',
'Ganahera,Ajmer,Rajasthan',
'Ganj Ajmer,Ajmer,Rajasthan',
'Gc Road Ajmer,Ajmer,Rajasthan',
'Gegal Akhari,Ajmer,Rajasthan',
'Glo Ajmer,Ajmer,Rajasthan',
'Googhra,Ajmer,Rajasthan',
'Gujar Dharti Ajmer,Ajmer,Rajasthan',
'Gulab Bari Ajmer,Ajmer,Rajasthan',
'Hatikhera,Ajmer,Rajasthan',
'Hatundi,Ajmer,Rajasthan',
'Hmt Ajmer Dtso,Ajmer,Rajasthan',
'Ie Makhu Pura Ajmer,Ajmer,Rajasthan',
'Jln Hospital Ajmer,Ajmer,Rajasthan',
'Jones Ganj Ajmer,Ajmer,Rajasthan',
'Kaiser Ganj Ajmer,Ajmer,Rajasthan',
'Kaklana,Ajmer,Rajasthan',
'Kanas,Ajmer,Rajasthan',
'Kanwalai,Ajmer,Rajasthan',
'Karel,Ajmer,Rajasthan',
'Kayar,Ajmer,Rajasthan',
'Kesarpura,Ajmer,Rajasthan',
'Kharkheri,Ajmer,Rajasthan',
'Khori,Ajmer,Rajasthan',
'Kotaj,Ajmer,Rajasthan',
'Kutchery,Ajmer,Rajasthan',
'Ladpura,Ajmer,Rajasthan',
'Loco Work Shop Ajmer,Ajmer,Rajasthan',
'Maday,Ajmer,Rajasthan',
'Magara,Ajmer,Rajasthan',
'Magari,Ajmer,Rajasthan',
'Makarwali,Ajmer,Rajasthan',
'Makhupura,Ajmer,Rajasthan',
'Makrera,Ajmer,Rajasthan',
'Maya Pur,Ajmer,Rajasthan',
'Mayo,Ajmer,Rajasthan',
'Mds University Ajmer,Ajmer,Rajasthan',
'Mohami,Ajmer,Rajasthan',
'Mss Hatundi,Ajmer,Rajasthan',
'Mundri Mohalla Ajmer,Ajmer,Rajasthan',
'Nagra Ajmer,Ajmer,Rajasthan',
'Naka Madar Ajmer,Ajmer,Rajasthan',
'Nareli,Ajmer,Rajasthan',
'Narwar,Ajmer,Rajasthan',
'Nawab Ka Bera Ajmer,Ajmer,Rajasthan',
'Naya Bazar,Ajmer,Rajasthan',
'Nooriawas,Ajmer,Rajasthan',
'Nosar,Ajmer,Rajasthan',
'Pal Beesla Ajmer,Ajmer,Rajasthan',
'Palran,Ajmer,Rajasthan',
'Purani Mandi Ajmer,Ajmer,Rajasthan',
'Pushakar Bazar,Ajmer,Rajasthan',
'Pushkar,Ajmer,Rajasthan',
'Raj Garh,Ajmer,Rajasthan',
'Raj. Edu. Board Ajmer,Ajmer,Rajasthan',
'Ram Ganj Ajmer,Ajmer,Rajasthan',
'Ram Nagar Ajmer,Ajmer,Rajasthan',
'Rasoolpura,Ajmer,Rajasthan',
'Regimental Bazar,Ajmer,Rajasthan',
'Regional College Ajmer,Ajmer,Rajasthan',
'RPSC Ajmer,Ajmer,Rajasthan',
'Saradhana,Ajmer,Rajasthan',
'Session Court Ajmer,Ajmer,Rajasthan',
'Shastri Nagar,Ajmer,Rajasthan',
'Somalpur,Ajmer,Rajasthan',
'Srinagar,Ajmer,Rajasthan',
'Tabiji,Ajmer,Rajasthan',
'Untra,Ajmer,Rajasthan',
'Vaishali Nagar Ajmer,Ajmer,Rajasthan',
'Alipura,Beawar,Rajasthan',
'Anakar,Beawar,Rajasthan',
'Andheri Deori,Beawar,Rajasthan',
'Arjunpura,Beawar,Rajasthan',
'Asan,Beawar,Rajasthan',
'Badkochara,Beawar,Rajasthan',
'Balad,Beawar,Rajasthan',
'Bamena Heda,Beawar,Rajasthan',
'Banjari,Beawar,Rajasthan',
'Barakhan,Beawar,Rajasthan',
'Barakhera,Beawar,Rajasthan',
'Bayala,Beawar,Rajasthan',
'Beawar [Raj] H.O,Beawar,Rajasthan',
'Beawar City,Beawar,Rajasthan',
'Beawar Khas,Beawar,Rajasthan',
'Beawar R.S.,Beawar,Rajasthan',
'Begliawas,Beawar,Rajasthan',
'Bhadsuri,Beawar,Rajasthan',
'Bhimpura,Beawar,Rajasthan',
'Biliya Was,Beawar,Rajasthan',
'Birikchyawas,Beawar,Rajasthan',
'Borwa,Beawar,Rajasthan',
'Budhwara,Beawar,Rajasthan',
'Dantra,Beawar,Rajasthan',
'Daulatpura,Beawar,Rajasthan',
'Dedpura,Beawar,Rajasthan',
'Delwara,Beawar,Rajasthan',
'Deo Khera,Beawar,Rajasthan',
'Deomali,Beawar,Rajasthan',
'Dewas,Beawar,Rajasthan',
'Dewata,Beawar,Rajasthan',
'Dholadata,Beawar,Rajasthan',
'Dodiana,Beawar,Rajasthan',
'Dungarh Kheara,Beawar,Rajasthan',
'Durgawas,Beawar,Rajasthan',
'Fathepura,Beawar,Rajasthan',
'Gohana,Beawar,Rajasthan',
'Gola,Beawar,Rajasthan',
'Harrajpura,Beawar,Rajasthan',
'Industrial Area,Beawar,Rajasthan',
'Jain Gurukul,Beawar,Rajasthan',
'Jalia-i,Beawar,Rajasthan',
'Jamola,Beawar,Rajasthan',
'Jawaja,Beawar,Rajasthan',
'Jhak,Beawar,Rajasthan',
'Jhipian,Beawar,Rajasthan',
'Jiwana,Beawar,Rajasthan',
'Kabra,Beawar,Rajasthan',
'Kalesara,Beawar,Rajasthan',
'Kalinjer,Beawar,Rajasthan',
'Kanakhera,Beawar,Rajasthan',
'Kharwa,Beawar,Rajasthan',
'Kheempura,Beawar,Rajasthan',
'Khodmal,Beawar,Rajasthan',
'Kirap,Beawar,Rajasthan',
'Kishanpura,Beawar,Rajasthan',
'Kotra,Beawar,Rajasthan',
'Laget Khera,Beawar,Rajasthan',
'Lamana,Beawar,Rajasthan',
'Lamba Kund Ka,Beawar,Rajasthan',
'Leeri,Beawar,Rajasthan',
'Leeswa,Beawar,Rajasthan',
'Lotiyana,Beawar,Rajasthan',
'Lulwa,Beawar,Rajasthan',
'Malpura,Beawar,Rajasthan',
'Malto Ki Ber,Beawar,Rajasthan',
'Mangliawas,Beawar,Rajasthan',
'Manpura,Beawar,Rajasthan',
'Masuda,Beawar,Rajasthan',
'Mayala,Beawar,Rajasthan',
'Mewaria,Beawar,Rajasthan',
'Moyana,Beawar,Rajasthan',
'Nagelao,Beawar,Rajasthan',
'Nai Kalan,Beawar,Rajasthan',
'Nandwara,Beawar,Rajasthan',
'Narbad Khera,Beawar,Rajasthan',
'NehruNagar(beawar),Beawar,Rajasthan',
'Nundri Maendratan,Beawar,Rajasthan',
'Nundri Mal Deo,Beawar,Rajasthan',
'Pagaran,Beawar,Rajasthan',
'Palri,Beawar,Rajasthan',
'Piplaj,Beawar,Rajasthan',
'Pisangan,Beawar,Rajasthan',
'Rajiawas,Beawar,Rajasthan',
'Ramgarh,Beawar,Rajasthan',
'Rampura Dabla,Beawar,Rajasthan',
'Rawatmal,Beawar,Rajasthan',
'Roop Nagar Arnali,Beawar,Rajasthan',
'Roopnagar,Beawar,Rajasthan',
'Rudlai,Beawar,Rajasthan',
'Sarmalia,Beawar,Rajasthan',
'Saroth,Beawar,Rajasthan',
'Sarvena,Beawar,Rajasthan',
'Satawaria,Beawar,Rajasthan',
'Sedaria,Beawar,Rajasthan',
'SendraRoad(Beawar),Beawar,Rajasthan',
'Shahpura,Beawar,Rajasthan',
'Shahpura Mohalla( Beawar ),Beawar,Rajasthan',
'Shergarh,Beawar,Rajasthan',
'Shivpura Ghata,Beawar,Rajasthan',
'Shyamgarh,Beawar,Rajasthan',
'Soniana,Beawar,Rajasthan',
'Suhawa,Beawar,Rajasthan',
'Suredia,Beawar,Rajasthan',
'Taragarh Dandholi,Beawar,Rajasthan',
'Todgarh,Beawar,Rajasthan',
'Atitmand,Beawar,Rajasthan',
'Bubkia,Beawar,Rajasthan',
'Barala,Beawar,Rajasthan',
'Bhinai,Beawar,Rajasthan',
'Chhachhundra,Beawar,Rajasthan',
'Chmapaneri,Beawar,Rajasthan',
'Dhatol,Beawar,Rajasthan',
'Jharwasa,Beawar,Rajasthan',
'Kanai Kalan,Beawar,Rajasthan',
'Kanai Khurd,Beawar,Rajasthan',
'Karanti,Beawar,Rajasthan',
'Khayda,Beawar,Rajasthan',
'Kumharia,Beawar,Rajasthan',
'Kurthal,Beawar,Rajasthan',
'Nagola,Beawar,Rajasthan',
'Nandsi,Beawar,Rajasthan',
'Nayara,Beawar,Rajasthan',
'Padalia,Beawar,Rajasthan',
'Paranga,Beawar,Rajasthan',
'Sobri,Beawar,Rajasthan',
'Surkhand,Beawar,Rajasthan',
'Bijainagar,Beawar,Rajasthan',
'Ajgara,Beawar,Rajasthan',
'Aloli,Beawar,Rajasthan',
'Bajata,Beawar,Rajasthan',
'Bharai,Beawar,Rajasthan',
'Bhimrawas,Beawar,Rajasthan',
'Bisundri,Beawar,Rajasthan',
'Bogla,Beawar,Rajasthan',
'Chitiawas,Beawar,Rajasthan',
'Chosla,Beawar,Rajasthan',
'Deogaon,Beawar,Rajasthan',
'Dhundhari,Beawar,Rajasthan',
'Ghatiyali,Beawar,Rajasthan',
'Gordha,Beawar,Rajasthan',
'Gulgaon,Beawar,Rajasthan',
'Hingonia,Beawar,Rajasthan',
'Jetpura,Beawar,Rajasthan',
'Karonj,Beawar,Rajasthan',
'Kekri Bazar,Beawar,Rajasthan',
'Kekri,Beawar,Rajasthan',
'Kerot,Beawar,Rajasthan',
'Khawas,Beawar,Rajasthan',
'Khejri,Beawar,Rajasthan',
'Kohda,Beawar,Rajasthan',
'Kunwar Ji Ka Kalera,Beawar,Rajasthan',
'Kushayata,Beawar,Rajasthan',
'Lalai,Beawar,Rajasthan',
'Lasadia,Beawar,Rajasthan',
'Mehru Kalan,Beawar,Rajasthan',
'Mevada Kalan,Beawar,Rajasthan',
'Molkiya,Beawar,Rajasthan',
'Napa Khera,Beawar,Rajasthan',
'Para,Beawar,Rajasthan',
'Pharkia,Beawar,Rajasthan',
'Piplaj,Beawar,Rajasthan',
'Pranhera,Beawar,Rajasthan',
'Rampali,Beawar,Rajasthan',
'Sadara,Beawar,Rajasthan',
'Salari,Beawar,Rajasthan',
'Sankariya,Beawar,Rajasthan',
'Sanmpla,Beawar,Rajasthan',
'Sarsari,Beawar,Rajasthan',
'Sawar,Beawar,Rajasthan',
'Sunpa,Beawar,Rajasthan',
'Tankawas,Beawar,Rajasthan',
'Taswaria,Beawar,Rajasthan',
'Khandach,Ajmer,Rajasthan',
'Raghunath Pura,Ajmer,Rajasthan',
'Aditya Mills,Ajmer,Rajasthan',
'Arain,Ajmer,Rajasthan',
'Bandar Sindari,Ajmer,Rajasthan',
'Barna,Ajmer,Rajasthan',
'Bhadoon,Ajmer,Rajasthan',
'Bhat Mohalla,Ajmer,Rajasthan',
'Bhogadeet,Ajmer,Rajasthan',
'Buharu,Ajmer,Rajasthan',
'Chandra Colony,Ajmer,Rajasthan',
'Chhota Naraina,Ajmer,Rajasthan',
'Chitakhera,Ajmer,Rajasthan',
'Dadia,Ajmer,Rajasthan',
'Dang,Ajmer,Rajasthan',
'Dhan Mandi - Kishan Garh,Ajmer,Rajasthan',
'Dhasook,Ajmer,Rajasthan',
'Dindwara,Ajmer,Rajasthan',
'Gagunda,Ajmer,Rajasthan',
'Harmara,Ajmer,Rajasthan',
'Jajota,Ajmer,Rajasthan',
'Karkeri,Ajmer,Rajasthan',
'Khatoli,Ajmer,Rajasthan',
'Kishan Garh,Ajmer,Rajasthan',
'Kotdi,Ajmer,Rajasthan',
'Kuchil,Ajmer,Rajasthan',
'Lamba,Ajmer,Rajasthan',
'Nalu,Ajmer,Rajasthan',
'Nawa,Ajmer,Rajasthan',
'Nosal,Ajmer,Rajasthan',
'Paner,Ajmer,Rajasthan',
'Picholia,Ajmer,Rajasthan',
'Pinglod,Ajmer,Rajasthan',
'Salemabad,Ajmer,Rajasthan',
'Sandolia,Ajmer,Rajasthan',
'Sardar Singh Ki Dhani,Ajmer,Rajasthan',
'Sargoan,Ajmer,Rajasthan',
'Shivaji Nagar,Ajmer,Rajasthan',
'Silora,Ajmer,Rajasthan',
'Singara,Ajmer,Rajasthan',
'Sinodia,Ajmer,Rajasthan',
'Sironj,Ajmer,Rajasthan',
'Thal,Ajmer,Rajasthan',
'Tikawara,Ajmer,Rajasthan',
'Tiloniya,Ajmer,Rajasthan',
'Tilora,Ajmer,Rajasthan',
'Tityari,Ajmer,Rajasthan',
'Tyod,Ajmer,Rajasthan',
'Akodia,Ajmer,Rajasthan',
'Amarpura,Ajmer,Rajasthan',
'Bhamolao,Ajmer,Rajasthan',
'Deo Puri,Ajmer,Rajasthan',
'Gothiana,Ajmer,Rajasthan',
'Jheerota,Ajmer,Rajasthan',
'Kalanada,Ajmer,Rajasthan',
'Katsura,Ajmer,Rajasthan',
'Kishanpura,Ajmer,Rajasthan',
'Madanganj Kishangarh H.O,Ajmer,Rajasthan',
'Mudoti,Ajmer,Rajasthan',
'Mundolao,Ajmer,Rajasthan',
'Nand,Ajmer,Rajasthan',
'Nitooti,Ajmer,Rajasthan',
'Patan,Ajmer,Rajasthan',
'Roopnagar,Ajmer,Rajasthan',
'Sanwatsar,Ajmer,Rajasthan',
'Sursara,Ajmer,Rajasthan',
'Udaipur Kalan,Ajmer,Rajasthan',
'Ralaota,Ajmer,Rajasthan',
'Farkia,Ajmer,Rajasthan',
'Akal Singha,Beawar,Rajasthan',
'Arwar,Beawar,Rajasthan',
'Asha Pura,Beawar,Rajasthan',
'Badi,Beawar,Rajasthan',
'Baghera,Beawar,Rajasthan',
'Baghsuri,Beawar,Rajasthan',
'Bandanwara,Beawar,Rajasthan',
'Banewara,Beawar,Rajasthan',
'Baral,Beawar,Rajasthan',
'Barali,Beawar,Rajasthan',
'Barol,Beawar,Rajasthan',
'Bhagawant Pura,Beawar,Rajasthan',
'Bhatiyani,Beawar,Rajasthan',
'Bhwani Khera,Beawar,Rajasthan',
'Bidla,Beawar,Rajasthan',
'Bijainagar R.S,Beawar,Rajasthan',
'Borada,Beawar,Rajasthan',
'Bubania,Beawar,Rajasthan',
'Dabrella,Beawar,Rajasthan',
'Daulatpura,Beawar,Rajasthan',
'Deolia Kalan,Beawar,Rajasthan',
'Derathu,Beawar,Rajasthan',
'Dhal,Beawar,Rajasthan',
'Dilwara,Beawar,Rajasthan',
'Fathegarh,Beawar,Rajasthan',
'Goyala,Beawar,Rajasthan',
'Gudha Khurd,Beawar,Rajasthan',
'Hanutiya,Beawar,Rajasthan',
'Hera Pura,Beawar,Rajasthan',
'J0tayan,Beawar,Rajasthan',
'Jadhol,Beawar,Rajasthan',
'Jalia -II,Beawar,Rajasthan',
'Jhalawara,Ajmer,Rajasthan',
'Junia,Beawar,Rajasthan',
'K.K.Gopal,Beawar,Rajasthan',
'Kadera,Beawar,Rajasthan',
'Kana Kheri,Ajmer,Rajasthan',
'Kaniya,Beawar,Rajasthan',
'Kanpura,Ajmer,Rajasthan',
'Kaseer,Beawar,Rajasthan',
'Kebania,Beawar,Rajasthan',
'Kitap,Beawar,Rajasthan',
'Lamagra,Beawar,Rajasthan',
'Lawera,Beawar,Rajasthan',
'Lodiyana,Beawar,Rajasthan',
'Loharwara,Beawar,Rajasthan',
'Mandawaria,Beawar,Rajasthan',
'Manoharpura,Beawar,Rajasthan',
'Mawasia,Beawar,Rajasthan',
'Morajhari,Beawar,Rajasthan',
'Morjhari,Beawar,Rajasthan',
'Motipura,Beawar,Rajasthan',
'Nandla,Beawar,Rajasthan',
'Nasirabad [Raj] H.O,Beawar,Rajasthan',
'Nasirabad Sadar Bazar,Beawar,Rajasthan',
'Nimera,Beawar,Rajasthan',
'Rajosi,Beawar,Rajasthan',
'Ramalia,Beawar,Rajasthan',
'Ramsar,Beawar,Rajasthan',
'Ratakot,Beawar,Rajasthan',
'Samparoda,Beawar,Rajasthan',
'Sanod,Beawar,Rajasthan',
'Sarana,Beawar,Rajasthan',
'Sathana,Beawar,Rajasthan',
'Sher Garh,Beawar,Rajasthan',
'Shikhrani,Beawar,Rajasthan',
'Shokalia,Beawar,Rajasthan',
'Singhawal,Beawar,Rajasthan',
'Siyar,Beawar,Rajasthan',
'Tantoti,Beawar,Rajasthan',
'Tihari,Ajmer,Rajasthan',
'Tilana,Beawar,Rajasthan',
'Govind Garh,Beawar,Rajasthan',
'Jethana,Beawar,Rajasthan',
'Bhagwan Pura,Beawar,Rajasthan',
'Jadana,Beawar,Rajasthan',
'Khiriya,Beawar,Rajasthan',
'Sarwar,Beawar,Rajasthan',
'Satolav,Beawar,Rajasthan',
'Adarsh Colony,Alwar,Rajasthan',
'Dariba Project,Alwar,Rajasthan',
'Akbarpur,Alwar,Rajasthan',
'Alwar Bus Stand,Alwar,Rajasthan',
'Alwar H.O,Alwar,Rajasthan',
'Aryanagar Alwar,Alwar,Rajasthan',
'Bagarrajput,Alwar,Rajasthan',
'Bahadurpur,Alwar,Rajasthan',
'Bahala,Alwar,Rajasthan',
'Balata,Alwar,Rajasthan',
'Bamboli,Alwar,Rajasthan',
'Barkhera,Alwar,Rajasthan',
'Beejwar,Alwar,Rajasthan',
'Bhageet,Alwar,Rajasthan',
'Bhajera,Alwar,Rajasthan',
'Bhoggore,Alwar,Rajasthan',
'Burja,Alwar,Rajasthan',
'Chandoli,Alwar,Rajasthan',
'Chikani,Alwar,Rajasthan',
'Chorotipahar,Alwar,Rajasthan',
'Delhi Gate Alwar,Alwar,Rajasthan',
'Desula,Alwar,Rajasthan',
'Dhakpuri,Alwar,Rajasthan',
'Diwakari,Alwar,Rajasthan',
'Ghat,Alwar,Rajasthan',
'H.B.Colony Alwar,Alwar,Rajasthan',
'Haldeena,Alwar,Rajasthan',
'Itarana Alwar,Alwar,Rajasthan',
'Jamalpur,Alwar,Rajasthan',
'Jatiyana,Alwar,Rajasthan',
'Jatpur,Alwar,Rajasthan',
'Kakrali Meo,Alwar,Rajasthan',
'Kalsara,Alwar,Rajasthan',
'Karoli,Alwar,Rajasthan',
'Kerwawal,Alwar,Rajasthan',
'Khanpur Jat,Alwar,Rajasthan',
'Khareda,Alwar,Rajasthan',
'Kherajahar,Alwar,Rajasthan',
'Kherli Syed,Alwar,Rajasthan',
'Khuteta Kalan,Alwar,Rajasthan',
'Kithoor,Alwar,Rajasthan',
'Leeli,Alwar,Rajasthan',
'Machari,Alwar,Rajasthan',
'Madhogarh,Alwar,Rajasthan',
'Mahuakhurd,Alwar,Rajasthan',
'Malakhera Gate Alwar,Alwar,Rajasthan',
'Malakhera,Alwar,Rajasthan',
'Matasya Ind. Area,Alwar,Rajasthan',
'Moti Doongri Alwar H.O,Alwar,Rajasthan',
'Nangli Megha,Alwar,Rajasthan',
'Nithari,Alwar,Rajasthan',
'Pala,Alwar,Rajasthan',
'Parisal,Alwar,Rajasthan',
'Prithvipura,Alwar,Rajasthan',
'Raibka,Alwar,Rajasthan',
'Railway Station Alwar,Alwar,Rajasthan',
'Raisis,Alwar,Rajasthan',
'Rata Khurd,Alwar,Rajasthan',
'Salpur,Alwar,Rajasthan',
'Sectt. Alwar,Alwar,Rajasthan',
'Shahdoli,Alwar,Rajasthan',
'Shahpur,Alwar,Rajasthan',
'Shivajee Park Alwar,Alwar,Rajasthan',
'Siliserh,Alwar,Rajasthan',
'Toolera,Alwar,Rajasthan',
'Tripoliya Alwar,Alwar,Rajasthan',
'Umren,Alwar,Rajasthan',
'Untwal,Alwar,Rajasthan',
'Vijai Mandir,Alwar,Rajasthan',
'Aklimpur,Alwar,Rajasthan',
'Anantpura,Alwar,Rajasthan',
'Bahror H.O,Alwar,Rajasthan',
'Bahror Jat,Alwar,Rajasthan',
'Barrod,Alwar,Rajasthan',
'Basai,Alwar,Rajasthan',
'Budhwal,Alwar,Rajasthan',
'Dooghera,Alwar,Rajasthan',
'Doomroli,Alwar,Rajasthan',
'Dosod,Alwar,Rajasthan',
'gadoj,Alwar,Rajasthan',
'Gandala,Alwar,Rajasthan',
'Gunti,Alwar,Rajasthan',
'Guwana,Alwar,Rajasthan',
'Hamidpur,Alwar,Rajasthan',
'Jaguwas,Alwar,Rajasthan',
'Jainpurwas,Alwar,Rajasthan',
'Jakhrana,Alwar,Rajasthan',
'Jalawas,Alwar,Rajasthan',
'Kanhawas,Alwar,Rajasthan',
'Kankardopa,Alwar,Rajasthan',
'Karoda,Alwar,Rajasthan',
'Kayasa,Alwar,Rajasthan',
'Khatankhera,Alwar,Rajasthan',
'Khohar,Alwar,Rajasthan',
'Khohrana,Alwar,Rajasthan',
'Khohri,Alwar,Rajasthan',
'Kolila,Alwar,Rajasthan',
'Maharajawas,Alwar,Rajasthan',
'Majari Kalan,Alwar,Rajasthan',
'Majrikanhawas,Alwar,Rajasthan',
'Manchal,Alwar,Rajasthan',
'Mohammedpur,Alwar,Rajasthan',
'Nangal Khoria,Alwar,Rajasthan',
'Pahari,Alwar,Rajasthan',
'Peepli,Alwar,Rajasthan',
'Rewali,Alwar,Rajasthan',
'Sanoli,Alwar,Rajasthan',
'Sherpur,Alwar,Rajasthan',
'Talwana,Alwar,Rajasthan',
'Tasing,Alwar,Rajasthan',
'Bansur,Alwar,Rajasthan',
'Bhupsera,Alwar,Rajasthan',
'Buteri,Alwar,Rajasthan',
'Choola,Alwar,Rajasthan',
'Fetehpur,Alwar,Rajasthan',
'Girudi,Alwar,Rajasthan',
'Gunta,Alwar,Rajasthan',
'Hamirpur,Alwar,Rajasthan',
'Hazipur,Alwar,Rajasthan',
'Holawas,Alwar,Rajasthan',
'Khera,Alwar,Rajasthan',
'Khori,Alwar,Rajasthan',
'Lakkakanagal,Alwar,Rajasthan',
'Lekri,Alwar,Rajasthan',
'Mahanpur,Alwar,Rajasthan',
'Rampur,Alwar,Rajasthan',
'Ratanpura,Alwar,Rajasthan',
'Santhalpur,Alwar,Rajasthan',
'Shyampura,Alwar,Rajasthan',
'Alamdika,Alwar,Rajasthan',
'Bagheri Kalan,Alwar,Rajasthan',
'Machhroli,Alwar,Rajasthan',
'Nangal Salia,Alwar,Rajasthan',
'Baghore,Alwar,Rajasthan',
'Bambora,Alwar,Rajasthan',
'Baskripal Nagar,Alwar,Rajasthan',
'Bhindoosi,Alwar,Rajasthan',
'Ghasoli,Alwar,Rajasthan',
'Gothra,Alwar,Rajasthan',
'Kalgaon,Alwar,Rajasthan',
'Khanpur Mewan,Alwar,Rajasthan',
'Kishan Garh Bass,Alwar,Rajasthan',
'Langerwas,Alwar,Rajasthan',
'Mahond,Alwar,Rajasthan',
'Mancha,Alwar,Rajasthan',
'Mandha,Alwar,Rajasthan',
'Moosakhera,Alwar,Rajasthan',
'Mothuka,Alwar,Rajasthan',
'Tarwala,Alwar,Rajasthan',
'Tehnoli,Alwar,Rajasthan',
'Thons,Alwar,Rajasthan',
'Veersingh Pur,Alwar,Rajasthan',
'Beelaheri,Alwar,Rajasthan',
'Bhagana,Alwar,Rajasthan',
'Ikrotia,Alwar,Rajasthan',
'Jodia,Alwar,Rajasthan',
'Kalgaon,Alwar,Rajasthan',
'KHanpur,Alwar,Rajasthan',
'Khutabpura,Alwar,Rajasthan',
'Kotkassim,Alwar,Rajasthan',
'Ladpur,Alwar,Rajasthan',
'Matalwas,Alwar,Rajasthan',
'Palpur,Alwar,Rajasthan',
'Pur,Alwar,Rajasthan',
'Ujoli,Alwar,Rajasthan',
'Barodameo,Alwar,Rajasthan',
'Beda,Alwar,Rajasthan',
'Buntoli,Alwar,Rajasthan',
'Butiyana,Alwar,Rajasthan',
'Deenar,Alwar,Rajasthan',
'Gandura,Alwar,Rajasthan',
'Itera,Alwar,Rajasthan',
'Molia,Alwar,Rajasthan',
'Nibhera,Alwar,Rajasthan',
'Nizamnagar,Alwar,Rajasthan',
'Sadhka,Alwar,Rajasthan',
'Barodakan,Alwar,Rajasthan',
'Bichgaon,Alwar,Rajasthan',
'Dantia,Alwar,Rajasthan',
'Daroda,Alwar,Rajasthan',
'Doroli,Alwar,Rajasthan',
'Garu,Alwar,Rajasthan',
'Harsana,Alwar,Rajasthan',
'Hasanpur,Alwar,Rajasthan',
'Jadla,Alwar,Rajasthan',
'Jaoli,Alwar,Rajasthan',
'Kalwari,Alwar,Rajasthan',
'Kherli Mandi,Alwar,Rajasthan',
'Kherli Rail,Alwar,Rajasthan',
'Kherli,Alwar,Rajasthan',
'Khudiana,Alwar,Rajasthan',
'Laxman Garh,Alwar,Rajasthan',
'Leeli,Alwar,Rajasthan',
'Nangalkhanjadi,Alwar,Rajasthan',
'Natoj,Alwar,Rajasthan',
'Noorpurganjpur,Alwar,Rajasthan',
'Ramnagar,Alwar,Rajasthan',
'Samuchi,Alwar,Rajasthan',
'Sonkher,Alwar,Rajasthan',
'Sonkheri,Alwar,Rajasthan',
'Sorai,Alwar,Rajasthan',
'Toda,Alwar,Rajasthan',
'Bedar,Alwar,Rajasthan',
'Berla,Alwar,Rajasthan',
'Bharkol,Alwar,Rajasthan',
'Chhilori,Alwar,Rajasthan',
'Chimrauli Gaur,Alwar,Rajasthan',
'Devli,Alwar,Rajasthan',
'Khoramalawali,Alwar,Rajasthan',
'Mauj Pur,Alwar,Rajasthan',
'Arwa,Alwar,Rajasthan',
'Bahtookalan,Alwar,Rajasthan',
'Baseth,Alwar,Rajasthan',
'Isrota,Alwar,Rajasthan',
'Kathumar,Alwar,Rajasthan',
'Kherameda,Alwar,Rajasthan',
'Masari,Alwar,Rajasthan',
'Mathuraheda,Alwar,Rajasthan',
'Methna,Alwar,Rajasthan',
'Reta,Alwar,Rajasthan',
'Sonkh,Alwar,Rajasthan',
'Sudiana,Alwar,Rajasthan',
'Tasai,Alwar,Rajasthan',
'Tikri,Alwar,Rajasthan',
'Titpuri,Alwar,Rajasthan',
'Dongri,Alwar,Rajasthan',
'Govind Garh Alwar,Alwar,Rajasthan',
'Harsauli,Alwar,Rajasthan',
'Khera Mahmood,Alwar,Rajasthan',
'Phari,Alwar,Rajasthan',
'Rambas,Alwar,Rajasthan',
'Sedampur,Alwar,Rajasthan',
'Semla Khurd,Alwar,Rajasthan',
'A.G.Dadhiya,Alwar,Rajasthan',
'Ajerka,Alwar,Rajasthan',
'Alanpur,Alwar,Rajasthan',
'Babari,Alwar,Rajasthan',
'Babaria,Alwar,Rajasthan',
'Bahroj,Alwar,Rajasthan',
'Balluwas,Alwar,Rajasthan',
'Bamanwas,Alwar,Rajasthan',
'Basai Kalan,Alwar,Rajasthan',
'Basmenpur,Alwar,Rajasthan',
'Basni,Alwar,Rajasthan',
'Beejwar Chauhan,Alwar,Rajasthan',
'Bhagukawas,Alwar,Rajasthan',
'Bhanot,Alwar,Rajasthan',
'Bhungra Ahir,Alwar,Rajasthan',
'Chandpur,Alwar,Rajasthan',
'Gaduwas,Alwar,Rajasthan',
'Ghatla,Alwar,Rajasthan',
'Gopipura,Alwar,Rajasthan',
'Harsauli,Alwar,Rajasthan',
'Harsora,Alwar,Rajasthan',
'Hatoondi,Alwar,Rajasthan',
'Ismailpur,Alwar,Rajasthan',
'Jasai,Alwar,Rajasthan',
'Jatiyana,Alwar,Rajasthan',
'Jindoli,Alwar,Rajasthan',
'Jonal,Alwar,Rajasthan',
'Karni Kot,Alwar,Rajasthan',
'Khairthal,Alwar,Rajasthan',
'Khanpur Ahir,Alwar,Rajasthan',
'Kutina,Alwar,Rajasthan',
'Mandawar,Alwar,Rajasthan',
'Manka,Alwar,Rajasthan',
'Mator,Alwar,Rajasthan',
'Mirjapur,Alwar,Rajasthan',
'Mundanwara Kalan,Alwar,Rajasthan',
'Nagli,Alwar,Rajasthan',
'Noor Nagar,Alwar,Rajasthan',
'Padmara Khurd,Alwar,Rajasthan',
'Pahel,Alwar,Rajasthan',
'Patalia,Alwar,Rajasthan',
'Patan Mewan,Alwar,Rajasthan',
'Peepli,Alwar,Rajasthan',
'Raisarana,Alwar,Rajasthan',
'Rajwara,Alwar,Rajasthan',
'Ranoth,Alwar,Rajasthan',
'Rasgan,Alwar,Rajasthan',
'Santo,Alwar,Rajasthan',
'Saraikalan,Alwar,Rajasthan',
'Seelgaon,Alwar,Rajasthan',
'Shamda,Alwar,Rajasthan',
'Sheopur,Alwar,Rajasthan',
'Sihalikalan,Alwar,Rajasthan',
'Siryani,Alwar,Rajasthan',
'Sodawas,Alwar,Rajasthan',
'Sorkha Kalan,Alwar,Rajasthan',
'Tatarpur,Alwar,Rajasthan',
'Vallabhgram,Alwar,Rajasthan',
'Chaubara,Alwar,Rajasthan',
'Dabarwas,Alwar,Rajasthan',
'Gheelot,Alwar,Rajasthan',
'Giglana,Alwar,Rajasthan',
'Gugalkota,Alwar,Rajasthan',
'Huria Kalan,Alwar,Rajasthan',
'Jonicha Khurd,Alwar,Rajasthan',
'Jonichakalan,Alwar,Rajasthan',
'Kathoowas,Alwar,Rajasthan',
'Khoondrot,Alwar,Rajasthan',
'Mandhan,Alwar,Rajasthan',
'Mehtawas,Alwar,Rajasthan',
'Naghori,Alwar,Rajasthan',
'Nanagwas,Alwar,Rajasthan',
'Neemrana,Alwar,Rajasthan',
'Palwa,Alwar,Rajasthan',
'Partapur,Alwar,Rajasthan',
'Pholadpur,Alwar,Rajasthan',
'Pratapsinghpura,Alwar,Rajasthan',
'Rodwal,Alwar,Rajasthan',
'Sakatpura (Bawad),Alwar,Rajasthan',
'Shahjahanpur,Alwar,Rajasthan',
'Adoli,Alwar,Rajasthan',
'Bahali,Alwar,Rajasthan',
'Baldeogarh,Alwar,Rajasthan',
'Ballupura,Alwar,Rajasthan',
'Barer,Alwar,Rajasthan',
'Barkokhurd,Alwar,Rajasthan',
'Beleta,Alwar,Rajasthan',
'Bhajera,Alwar,Rajasthan',
'Bhandodi,Alwar,Rajasthan',
'Bhanokhar,Alwar,Rajasthan',
'Bhanwar,Alwar,Rajasthan',
'Bhikhaheri,Alwar,Rajasthan',
'Bhuda,Alwar,Rajasthan',
'Bighota,Alwar,Rajasthan',
'Binjari,Alwar,Rajasthan',
'Bulari,Alwar,Rajasthan',
'Chandupura,Alwar,Rajasthan',
'Dera,Alwar,Rajasthan',
'Devti,Alwar,Rajasthan',
'Dhamred,Alwar,Rajasthan',
'Dhigawara,Alwar,Rajasthan',
'Doroli,Alwar,Rajasthan',
'Dubbi,Alwar,Rajasthan',
'Garhi Sawai Ram,Alwar,Rajasthan',
'Ghewar,Alwar,Rajasthan',
'Golakabas,Alwar,Rajasthan',
'Gordhanpura,Alwar,Rajasthan',
'Gothra,Alwar,Rajasthan',
'Intoli,Alwar,Rajasthan',
'Jamdoli,Alwar,Rajasthan',
'Jatpur,Alwar,Rajasthan',
'Jatwara,Alwar,Rajasthan',
'Jhalatala,Alwar,Rajasthan',
'Kanethi,Alwar,Rajasthan',
'Karanpura,Alwar,Rajasthan',
'Karoth,Alwar,Rajasthan',
'Keelpurkhera,Alwar,Rajasthan',
'Kheda Kalyanpur,Alwar,Rajasthan',
'Kheramangal Singh,Alwar,Rajasthan',
'Khoh,Alwar,Rajasthan',
'Khoh,Alwar,Rajasthan',
'Khonkhar,Alwar,Rajasthan',
'Koondla,Alwar,Rajasthan',
'Machari,Alwar,Rajasthan',
'Machari Chowk,rajgarh,Alwar,Rajasthan',
'Moonpur,Alwar,Rajasthan',
'Motiwara,Alwar,Rajasthan',
'Mundia,Alwar,Rajasthan',
'Nathalwara,Alwar,Rajasthan',
'Nawalpura,Alwar,Rajasthan',
'Neemla,Alwar,Rajasthan',
'Pada,Alwar,Rajasthan',
'Palwa,Alwar,Rajasthan',
'Parbeni,Alwar,Rajasthan',
'Patan,Alwar,Rajasthan',
'Pinan,Alwar,Rajasthan',
'Poonkher,Alwar,Rajasthan',
'Pragpura,Alwar,Rajasthan',
'Rajgarh R.S.,Alwar,Rajasthan',
'Rajgarh,Alwar,Rajasthan',
'Rajpur,Alwar,Rajasthan',
'Reni,Alwar,Rajasthan',
'Ronijathan,Alwar,Rajasthan',
'Sahari,Alwar,Rajasthan',
'Sakat,Alwar,Rajasthan',
'Saloli,Alwar,Rajasthan',
'Salwari,Alwar,Rajasthan',
'Sehra,Alwar,Rajasthan',
'Srichandpura,Alwar,Rajasthan',
'Surer,Alwar,Rajasthan',
'Syaluta,Alwar,Rajasthan',
'Talab,Alwar,Rajasthan',
'Tehla,Alwar,Rajasthan',
'Tehtra,Alwar,Rajasthan',
'Thana,Alwar,Rajasthan',
'Tilwar,Alwar,Rajasthan',
'Todanagar,Alwar,Rajasthan',
'Vabeli,Alwar,Rajasthan',
'Alaora,Alwar,Rajasthan',
'Beejwa,Alwar,Rajasthan',
'Cheerwa,Alwar,Rajasthan',
'Chomu,Alwar,Rajasthan',
'Dhanwari,Alwar,Rajasthan',
'Indpura,Alwar,Rajasthan',
'KHERI,Alwar,Rajasthan',
'khilora,Alwar,Rajasthan',
'Kkoh,Alwar,Rajasthan',
'Malpur,Alwar,Rajasthan',
'Milakpur,Alwar,Rajasthan',
'Mubarikpur,Alwar,Rajasthan',
'Naswari,Alwar,Rajasthan',
'Neekuch,Alwar,Rajasthan',
'Nogaon,Alwar,Rajasthan',
'Pata,Alwar,Rajasthan',
'Peproli,Alwar,Rajasthan',
'Raghunathgarh,Alwar,Rajasthan',
'Ramgarh,Alwar,Rajasthan',
'Rasgaon,Alwar,Rajasthan',
'Sainthli,Alwar,Rajasthan',
'Sirmor,Alwar,Rajasthan',
'Agar,Alwar,Rajasthan',
'Ajabgarh,Alwar,Rajasthan',
'Jhiri,Alwar,Rajasthan',
'Lalpura,Alwar,Rajasthan',
'Nangalbani,Alwar,Rajasthan',
'Padakchapli,Alwar,Rajasthan',
'Piplai,Alwar,Rajasthan',
'Pratap Garh,Alwar,Rajasthan',
'Samra,Alwar,Rajasthan',
'Ajabpura,Alwar,Rajasthan',
'Bamanwas Kankar,Alwar,Rajasthan',
'Basaijogian,Alwar,Rajasthan',
'Bhandrol,Alwar,Rajasthan',
'Bhangroli,Alwar,Rajasthan',
'Bilali,Alwar,Rajasthan',
'Chatarpura,Alwar,Rajasthan',
'Dera Bamanwas,Alwar,Rajasthan',
'Duhar Chogan,Alwar,Rajasthan',
'Dwarapur,Alwar,Rajasthan',
'Garh Basai,Alwar,Rajasthan',
'Garhi,Alwar,Rajasthan',
'Gudhachurani,Alwar,Rajasthan',
'Gyanpura,Alwar,Rajasthan',
'KARANA,Alwar,Rajasthan',
'kherkheri Kalan,Alwar,Rajasthan',
'Kishori,Alwar,Rajasthan',
'Kolahera,Alwar,Rajasthan',
'Malutana,Alwar,Rajasthan',
'Mundawar,Alwar,Rajasthan',
'Narainpur,Alwar,Rajasthan',
'Nayabas,Alwar,Rajasthan',
'Neemuchana,Alwar,Rajasthan',
'Saleta,Alwar,Rajasthan',
'Sariska Palace,Alwar,Rajasthan',
'Seelibaori,Alwar,Rajasthan',
'Suratgarh,Alwar,Rajasthan',
'Thanagazi,Alwar,Rajasthan',
'Vijayapura,Alwar,Rajasthan',
'Bhiwadi,Alwar,Rajasthan',
'Bhiwari Ind. Area. Alwar,Alwar,Rajasthan',
'Khazuri Bass,Alwar,Rajasthan',
'Santhalka,Alwar,Rajasthan',
'Shahdod,Alwar,Rajasthan',
'Sheetal,Alwar,Rajasthan',
'Silarpur,Alwar,Rajasthan',
'Baghora,Alwar,Rajasthan',
'Bandra,Alwar,Rajasthan',
'Bhonker,Alwar,Rajasthan',
'Bichhala,Alwar,Rajasthan',
'Bilaspur,Alwar,Rajasthan',
'Birampur,Alwar,Rajasthan',
'Budhi Bawal,Alwar,Rajasthan',
'Chauharpur,Alwar,Rajasthan',
'Gotoli,Alwar,Rajasthan',
'Gwalda,Alwar,Rajasthan',
'Hameerka,Alwar,Rajasthan',
'Hingwahera,Alwar,Rajasthan',
'Isroda,Alwar,Rajasthan',
'Jeroli,Alwar,Rajasthan',
'Jhiwana,Alwar,Rajasthan',
'Joria,Alwar,Rajasthan',
'Maseet,Alwar,Rajasthan',
'Mehesra,Alwar,Rajasthan',
'Mundana,Alwar,Rajasthan',
'Palpur,Alwar,Rajasthan',
'R.H.B. Bhiwari,Alwar,Rajasthan',
'Rabhana,Alwar,Rajasthan',
'Sarheta,Alwar,Rajasthan',
'Shahbad,Alwar,Rajasthan',
'Tapukara,Alwar,Rajasthan',
'Titarka,Alwar,Rajasthan',
'Tizara,Alwar,Rajasthan',
'Bori,Dungarpur,Rajasthan',
'Chhari,Dungarpur,Rajasthan',
'Jharas,Dungarpur,Rajasthan',
'Kuwania,Dungarpur,Rajasthan',
'Panasi Chhti,Dungarpur,Rajasthan',
'Sagwa,Dungarpur,Rajasthan',
'Saredi Chhoti,Dungarpur,Rajasthan',
'Ador,Dungarpur,Rajasthan',
'Agarpura,Dungarpur,Rajasthan',
'Ajna,Dungarpur,Rajasthan',
'Akhebhanji Ka Gara,Dungarpur,Rajasthan',
'Amarsingh Ka Gara,Dungarpur,Rajasthan',
'Amarthun,Dungarpur,Rajasthan',
'Ambalia,Dungarpur,Rajasthan',
'Amja,Dungarpur,Rajasthan',
'Anandpuri,Dungarpur,Rajasthan',
'Andheshwar,Dungarpur,Rajasthan',
'Arthuna,Dungarpur,Rajasthan',
'Asan,Dungarpur,Rajasthan',
'Asoda,Dungarpur,Rajasthan',
'Bachadiya,Dungarpur,Rajasthan',
'Badana,Dungarpur,Rajasthan',
'Badgoan,Dungarpur,Rajasthan',
'Badgun,Dungarpur,Rajasthan',
'Badi Saredi,Dungarpur,Rajasthan',
'Badi Sarwa,Dungarpur,Rajasthan',
'Badli Pada,Dungarpur,Rajasthan',
'Badliya,Dungarpur,Rajasthan',
'Badliya,Dungarpur,Rajasthan',
'Badrel Khurd,Dungarpur,Rajasthan',
'Badwasa,Dungarpur,Rajasthan',
'Bagidora,Dungarpur,Rajasthan',
'Balwara,Dungarpur,Rajasthan',
'Bamanparda,Dungarpur,Rajasthan',
'Bansala,Dungarpur,Rajasthan',
'Banswara City,Dungarpur,Rajasthan',
'Banswara H.O,Dungarpur,Rajasthan',
'Banswara Ind. Area,Dungarpur,Rajasthan',
'Banswara Mahi Colony,Dungarpur,Rajasthan',
'Banswara Prathvi Ganj,Dungarpur,Rajasthan',
'Bareth,Dungarpur,Rajasthan',
'Bari,Dungarpur,Rajasthan',
'Barjodia,Dungarpur,Rajasthan',
'Barodia,Dungarpur,Rajasthan',
'Bassi,Dungarpur,Rajasthan',
'Bassi Badi,Dungarpur,Rajasthan',
'Berwa,Dungarpur,Rajasthan',
'Bhagora,Dungarpur,Rajasthan',
'Bhaler Bhodar,Dungarpur,Rajasthan',
'Bhapor,Dungarpur,Rajasthan',
'Bhatar,Dungarpur,Rajasthan',
'Bhimpur,Dungarpur,Rajasthan',
'Bhimsore,Dungarpur,Rajasthan',
'Bhoyar,Dungarpur,Rajasthan',
'Bhungda,Dungarpur,Rajasthan',
'Bhuwasa,Dungarpur,Rajasthan',
'Biladi,Dungarpur,Rajasthan',
'Biloda,Dungarpur,Rajasthan',
'Bodigama,Dungarpur,Rajasthan',
'Bodigama,Dungarpur,Rajasthan',
'Bor Khaber,Dungarpur,Rajasthan',
'Borda,Dungarpur,Rajasthan',
'Bori,Dungarpur,Rajasthan',
'Bori,Dungarpur,Rajasthan',
'Boriya,Dungarpur,Rajasthan',
'Borpi Khera,Dungarpur,Rajasthan',
'Borwat,Dungarpur,Rajasthan',
'Buda Bassi,Dungarpur,Rajasthan',
'Budwa,Dungarpur,Rajasthan',
'Chacha Kota,Dungarpur,Rajasthan',
'Chanduji Ka Gara,Dungarpur,Rajasthan',
'Chandwara,Dungarpur,Rajasthan',
'Charkani,Dungarpur,Rajasthan',
'Chaura Kalan,Dungarpur,Rajasthan',
'Cheekli Teja,Dungarpur,Rajasthan',
'Cheev,Dungarpur,Rajasthan',
'Chhaja,Dungarpur,Rajasthan',
'Chhinch,Dungarpur,Rajasthan',
'Chhoti Sarwa,Dungarpur,Rajasthan',
'Chhoti Sarwan,Dungarpur,Rajasthan',
'Chokhala,Dungarpur,Rajasthan',
'Chopasang,Dungarpur,Rajasthan',
'Chordi,Dungarpur,Rajasthan',
'Chriyawasa,Dungarpur,Rajasthan',
'Daduka,Dungarpur,Rajasthan',
'Dagal,Dungarpur,Rajasthan',
'Dalwara Lokiya,Dungarpur,Rajasthan',
'Dana Khari,Dungarpur,Rajasthan',
'Danpur,Dungarpur,Rajasthan',
'Devda,Dungarpur,Rajasthan',
'Dhalar,Dungarpur,Rajasthan',
'Dhumath,Dungarpur,Rajasthan',
'Dokar,Dungarpur,Rajasthan',
'Doodka,Dungarpur,Rajasthan',
'Dukawara,Dungarpur,Rajasthan',
'Dungariya,Dungarpur,Rajasthan',
'Dunglavani,Dungarpur,Rajasthan',
'Dungra,Dungarpur,Rajasthan',
'Dungra Chhota,Dungarpur,Rajasthan',
'Dungra Kalan,Dungarpur,Rajasthan',
'Fefar,Dungarpur,Rajasthan',
'Galkiya,Dungarpur,Rajasthan',
'Gamdi,Dungarpur,Rajasthan',
'Gangad Talai,Dungarpur,Rajasthan',
'Ganoda,Dungarpur,Rajasthan',
'Garhi,Dungarpur,Rajasthan',
'Ghantali,Dungarpur,Rajasthan',
'Ghatol,Dungarpur,Rajasthan',
'Godi Tajpur,Dungarpur,Rajasthan',
'Godwara Noren,Dungarpur,Rajasthan',
'Gopinath Ka Garha,Dungarpur,Rajasthan',
'Handi,Dungarpur,Rajasthan',
'Harnathpura,Dungarpur,Rajasthan',
'Himmatgarh,Dungarpur,Rajasthan',
'Itala,Dungarpur,Rajasthan',
'Jagpura,Dungarpur,Rajasthan',
'Jahapura,Dungarpur,Rajasthan',
'Jalampura,Dungarpur,Rajasthan',
'Jambudi,Dungarpur,Rajasthan',
'Jethali,Dungarpur,Rajasthan',
'Jhanjharwa,Dungarpur,Rajasthan',
'Jharkaniya,Dungarpur,Rajasthan',
'Jher Moti,Dungarpur,Rajasthan',
'Jhikali,Dungarpur,Rajasthan',
'Jhupel,Dungarpur,Rajasthan',
'Jolana,Dungarpur,Rajasthan',
'Kajelia,Dungarpur,Rajasthan',
'Kalakhet,Dungarpur,Rajasthan',
'Kalinjara,Dungarpur,Rajasthan',
'Kalinjara,Dungarpur,Rajasthan',
'Kanji Ka Gara,Dungarpur,Rajasthan',
'Kanthao,Dungarpur,Rajasthan',
'Karanpur,Dungarpur,Rajasthan',
'Karji,Dungarpur,Rajasthan',
'Kaserpura,Dungarpur,Rajasthan',
'Katumbi,Dungarpur,Rajasthan',
'Kelamela,Dungarpur,Rajasthan',
'Kesharpura,Dungarpur,Rajasthan',
'Kesharwadi,Dungarpur,Rajasthan',
'Khadalim,Dungarpur,Rajasthan',
'Khajuri,Dungarpur,Rajasthan',
'Khamera,Dungarpur,Rajasthan',
'Khandu,Dungarpur,Rajasthan',
'Kharan Ka Parda,Dungarpur,Rajasthan',
'Kheda,Dungarpur,Rajasthan',
'Kheda Khas,Dungarpur,Rajasthan',
'Kherdabada,Dungarpur,Rajasthan',
'Kherwa,Dungarpur,Rajasthan',
'Khodan,Dungarpur,Rajasthan',
'Khundni Rupa,Dungarpur,Rajasthan',
'Khunta Galia,Dungarpur,Rajasthan',
'Kopda,Dungarpur,Rajasthan',
'Kotada,Dungarpur,Rajasthan',
'Kotra,Dungarpur,Rajasthan',
'Kotra Ranga,Dungarpur,Rajasthan',
'Kundal,Dungarpur,Rajasthan',
'Kundla Kalan,Dungarpur,Rajasthan',
'Kunwala,Dungarpur,Rajasthan',
'Kupda,Dungarpur,Rajasthan',
'Kushal Garh Bazar,Dungarpur,Rajasthan',
'Kushalapada,Dungarpur,Rajasthan',
'Kushalgarh,Dungarpur,Rajasthan',
'Kushalpura,Dungarpur,Rajasthan',
'Kuwaniya,Dungarpur,Rajasthan',
'Lankai,Dungarpur,Rajasthan',
'Lasada,Dungarpur,Rajasthan',
'Lilwani,Dungarpur,Rajasthan',
'Limthan,Dungarpur,Rajasthan',
'Lodha,Dungarpur,Rajasthan',
'Loharia,Dungarpur,Rajasthan',
'Luharia,Dungarpur,Rajasthan',
'Machchar Para,Dungarpur,Rajasthan',
'Madkola,Dungarpur,Rajasthan',
'Madlada,Dungarpur,Rajasthan',
'Magarda Bada,Dungarpur,Rajasthan',
'Maheshpura,Dungarpur,Rajasthan',
'Mahidam,Dungarpur,Rajasthan',
'Mahudi,Dungarpur,Rajasthan',
'Mahudi Maska,Dungarpur,Rajasthan',
'Malana,Dungarpur,Rajasthan',
'Masotiya,Dungarpur,Rajasthan',
'Matwala,Dungarpur,Rajasthan',
'Minapadar,Dungarpur,Rajasthan',
'Miyasa,Dungarpur,Rajasthan',
'Mokampura,Dungarpur,Rajasthan',
'Mokampura,Dungarpur,Rajasthan',
'Mor,Dungarpur,Rajasthan',
'Mordi Nichali,Dungarpur,Rajasthan',
'Mota Goan,Dungarpur,Rajasthan',
'Mota Tanda,Dungarpur,Rajasthan',
'Moti Timbi,Dungarpur,Rajasthan',
'Mudsal,Dungarpur,Rajasthan',
'Mundri,Dungarpur,Rajasthan',
'Mundri,Dungarpur,Rajasthan',
'Nagawara,Dungarpur,Rajasthan',
'Nahali,Dungarpur,Rajasthan',
'Naharpura,Dungarpur,Rajasthan',
'Nalda,Dungarpur,Rajasthan',
'Napla,Dungarpur,Rajasthan',
'Narwali,Dungarpur,Rajasthan',
'Naugama,Dungarpur,Rajasthan',
'Navagoan,Dungarpur,Rajasthan',
'Nawadhara,Dungarpur,Rajasthan',
'Naya Goan,Dungarpur,Rajasthan',
'Nayan,Dungarpur,Rajasthan',
'Nichala Ghantala,Dungarpur,Rajasthan',
'Obla,Dungarpur,Rajasthan',
'Odwara,Dungarpur,Rajasthan',
'Padal Badi,Dungarpur,Rajasthan',
'Padal Chhoti,Dungarpur,Rajasthan',
'Paderi,Dungarpur,Rajasthan',
'Padikalan,Dungarpur,Rajasthan',
'Padoli Gordhan,Dungarpur,Rajasthan',
'Padoli Rathor,Dungarpur,Rajasthan',
'Palaswani,Dungarpur,Rajasthan',
'Pali Kalan,Dungarpur,Rajasthan',
'Paloda,Dungarpur,Rajasthan',
'Panchalwasa,Dungarpur,Rajasthan',
'Panchawara,Dungarpur,Rajasthan',
'Paraheda,Dungarpur,Rajasthan',
'Partapur,Dungarpur,Rajasthan',
'Patan,Dungarpur,Rajasthan',
'Patan,Dungarpur,Rajasthan',
'Peeplod,Dungarpur,Rajasthan',
'Phalwa,Dungarpur,Rajasthan',
'Pindarama,Dungarpur,Rajasthan',
'Pipal Khunt,Dungarpur,Rajasthan',
'Prethvipura,Dungarpur,Rajasthan',
'Raiyana,Dungarpur,Rajasthan',
'Rakho,Dungarpur,Rajasthan',
'Ramgarh,Dungarpur,Rajasthan',
'Ramka Munna,Dungarpur,Rajasthan',
'Rath Dhanraj,Dungarpur,Rajasthan',
'Rohaniya,Dungarpur,Rajasthan',
'Rohaniya Laxman Singh,Dungarpur,Rajasthan',
'Rohanwari,Dungarpur,Rajasthan',
'Rohida,Dungarpur,Rajasthan',
'Runjia,Dungarpur,Rajasthan',
'Rupji Ka Kheda,Dungarpur,Rajasthan',
'Sabalpur,Dungarpur,Rajasthan',
'Sagrod,Dungarpur,Rajasthan',
'Sagwadiya,Dungarpur,Rajasthan',
'Sajjan Garh,Dungarpur,Rajasthan',
'Sakaria,Dungarpur,Rajasthan',
'Salia,Dungarpur,Rajasthan',
'Saliya,Dungarpur,Rajasthan',
'Sallopat,Dungarpur,Rajasthan',
'Samagarha,Dungarpur,Rajasthan',
'Samaria,Dungarpur,Rajasthan',
'Sanawasa,Dungarpur,Rajasthan',
'Sangariya,Dungarpur,Rajasthan',
'Saranpur,Dungarpur,Rajasthan',
'Sarodia,Dungarpur,Rajasthan',
'Semaliya,Dungarpur,Rajasthan',
'Sevna,Dungarpur,Rajasthan',
'Shergarh,Dungarpur,Rajasthan',
'Singhpura,Dungarpur,Rajasthan',
'Sodalpur,Dungarpur,Rajasthan',
'Sowaniya,Dungarpur,Rajasthan',
'Sundanpur,Dungarpur,Rajasthan',
'Sundni,Dungarpur,Rajasthan',
'Sundrao,Dungarpur,Rajasthan',
'Surpur,Dungarpur,Rajasthan',
'Surwania,Dungarpur,Rajasthan',
'Suwala,Dungarpur,Rajasthan',
'Tajpur,Dungarpur,Rajasthan',
'Talwara,Dungarpur,Rajasthan',
'Tambesara,Dungarpur,Rajasthan',
'Tamtiya,Dungarpur,Rajasthan',
'Tamtiya,Dungarpur,Rajasthan',
'Tamtiya Rathor,Dungarpur,Rajasthan',
'Tanda Mangla,Dungarpur,Rajasthan',
'Tandi Kalan,Dungarpur,Rajasthan',
'Thikariya,Dungarpur,Rajasthan',
'Thikariya,Dungarpur,Rajasthan',
'Timbada,Dungarpur,Rajasthan',
'Udaipura,Dungarpur,Rajasthan',
'Umbada,Dungarpur,Rajasthan',
'Ummadgarhi,Dungarpur,Rajasthan',
'Unkala,Dungarpur,Rajasthan',
'Upla Ghantala,Dungarpur,Rajasthan',
'Vajwanaia,Dungarpur,Rajasthan',
'Vakhatpura,Dungarpur,Rajasthan',
'Agar,Kota,Rajasthan',
'Ajnawar,Kota,Rajasthan',
'Anatana,Kota,Rajasthan',
'Ardan,Kota,Rajasthan',
'Asnawar,Kota,Rajasthan',
'Atone,Kota,Rajasthan',
'ATRU,Kota,Rajasthan',
'Badan,Kota,Rajasthan',
'Badipura,Kota,Rajasthan',
'Badora,Kota,Rajasthan',
'Badwa,Kota,Rajasthan',
'Bajrang Garh,Kota,Rajasthan',
'Balda,Kota,Rajasthan',
'Bamangaon,Kota,Rajasthan',
'Bamla,Kota,Rajasthan',
'Bamori,Kota,Rajasthan',
'Bamori Kalan,Kota,Rajasthan',
'Bamorighata,Kota,Rajasthan',
'Banjari,Kota,Rajasthan',
'Bansthuni,Kota,Rajasthan',
'Bapcha,Kota,Rajasthan',
'Baran,Kota,Rajasthan',
'Barana,Kota,Rajasthan',
'Barlan,Kota,Rajasthan',
'Baroni,Kota,Rajasthan',
'Batawada,Kota,Rajasthan',
'Batawada Par,Kota,Rajasthan',
'Beel Kheda,Kota,Rajasthan',
'Beel Kheda Mal,Kota,Rajasthan',
'Bengana,Kota,Rajasthan',
'Benta,Kota,Rajasthan',
'Bhanwargarh,Kota,Rajasthan',
'Bhatwada,Kota,Rajasthan',
'Bhavpura,Kota,Rajasthan',
'Bhensara,Kota,Rajasthan',
'Bhilwada Neecha,Kota,Rajasthan',
'Bhojya Kheri,Kota,Rajasthan',
'Bhoyal,Kota,Rajasthan',
'Bhulon,Kota,Rajasthan',
'Bhuwakheri,Kota,Rajasthan',
'Bichalas,Kota,Rajasthan',
'Bijora,Kota,Rajasthan',
'Bilendi,Kota,Rajasthan',
'Bohat,Kota,Rajasthan',
'Chachoda,Kota,Rajasthan',
'Chardana,Kota,Rajasthan',
'Chhajawa,Kota,Rajasthan',
'Chhatargarh,Kota,Rajasthan',
'Chhinod,Kota,Rajasthan',
'Deori,Kota,Rajasthan',
'Deori,Kota,Rajasthan',
'Dhikwani,Kota,Rajasthan',
'Dholam,Kota,Rajasthan',
'Dhoti,Kota,Rajasthan',
'Dhumar Khedi,Kota,Rajasthan',
'Digod Jagir,Kota,Rajasthan',
'Digod Kalan,Kota,Rajasthan',
'Digodpura,Kota,Rajasthan',
'Dilod,Kota,Rajasthan',
'Fatehpur,Kota,Rajasthan',
'Gagchana,Kota,Rajasthan',
'Gajanpura,Kota,Rajasthan',
'Ganeshpura,Kota,Rajasthan',
'Garda,Kota,Rajasthan',
'Ghatti Colony,Kota,Rajasthan',
'Godia Mehar,Kota,Rajasthan',
'Gordhanpra,Kota,Rajasthan',
'Halgana,Kota,Rajasthan',
'Hana Heri,Kota,Rajasthan',
'Hani Heda,Kota,Rajasthan',
'Harnaoda Shahji,Kota,Rajasthan',
'Hathidilod,Kota,Rajasthan',
'Hingonia,Kota,Rajasthan',
'Iklera,Kota,Rajasthan',
'Ishwarpura,Kota,Rajasthan',
'Jai Nagar,Kota,Rajasthan',
'Jaipla,Kota,Rajasthan',
'Jaloda Tejaji,Kota,Rajasthan',
'Jalwara,Kota,Rajasthan',
'Jarela,Kota,Rajasthan',
'Jhinjhni,Kota,Rajasthan',
'Kachnariya,Kota,Rajasthan',
'Kachra,Kota,Rajasthan',
'Kachri,Kota,Rajasthan',
'Kadia Ban,Kota,Rajasthan',
'Kadia Hat,Kota,Rajasthan',
'Kadia Nohar,Kota,Rajasthan',
'Kalmanda,Kota,Rajasthan',
'Kalmodiya,Kota,Rajasthan',
'Kalpajagir,Kota,Rajasthan',
'Karnaheda,Kota,Rajasthan',
'Karwari Kalan,Kota,Rajasthan',
'Kasba Nonera,Kota,Rajasthan',
'Katawar,Kota,Rajasthan',
'Kelwara,Kota,Rajasthan',
'Khajurana,Kota,Rajasthan',
'Khajurana Kalan,Kota,Rajasthan',
'Khanda Sahrol,Kota,Rajasthan',
'Khandela,Kota,Rajasthan',
'Kharkheda Ramlothan,Kota,Rajasthan',
'Khatka,Kota,Rajasthan',
'Kherli,Kota,Rajasthan',
'Kherli,Kota,Rajasthan',
'Khuri,Kota,Rajasthan',
'Kishan Ganj,Kota,Rajasthan',
'Kishanpura,Kota,Rajasthan',
'Kotrapar,Kota,Rajasthan',
'Kotri,Kota,Rajasthan',
'Krishi Upaj Mandi Baran,Kota,Rajasthan',
'Kulinjara,Kota,Rajasthan',
'Kundi,Kota,Rajasthan',
'Lisadia,Kota,Rajasthan',
'Mahodra,Kota,Rajasthan',
'Mal Bamori,Kota,Rajasthan',
'Manawata,Kota,Rajasthan',
'Mandola,Kota,Rajasthan',
'Mangrol,Kota,Rajasthan',
'Marma Chah,Kota,Rajasthan',
'Mathna,Kota,Rajasthan',
'Mau,Kota,Rajasthan',
'Mawasa,Kota,Rajasthan',
'Melkheri,Kota,Rajasthan',
'Merma Talab,Kota,Rajasthan',
'Mirja Pur,Kota,Rajasthan',
'Missai,Kota,Rajasthan',
'Miyada,Kota,Rajasthan',
'Mohkampura,Kota,Rajasthan',
'Moondla Bisoti,Kota,Rajasthan',
'Mothpur,Kota,Rajasthan',
'Mundiyar,Kota,Rajasthan',
'Mundkya,Kota,Rajasthan',
'Mundla,Kota,Rajasthan',
'Musai Gujaran,Kota,Rajasthan',
'Nahar Garh,Kota,Rajasthan',
'Nanwata,Kota,Rajasthan',
'Nareda,Kota,Rajasthan',
'Natai,Kota,Rajasthan',
'Nipania,Kota,Rajasthan',
'Pachel Kalan,Kota,Rajasthan',
'Pachpada,Kota,Rajasthan',
'Palaitha,Kota,Rajasthan',
'Pali,Kota,Rajasthan',
'Paraniya,Kota,Rajasthan',
'Parna,Kota,Rajasthan',
'Patheda,Kota,Rajasthan',
'Phalia,Kota,Rajasthan',
'Phool Barod,Kota,Rajasthan',
'Piplod,Kota,Rajasthan',
'Piplod Kalan,Kota,Rajasthan',
'Rai,Kota,Rajasthan',
'Raingarh,Kota,Rajasthan',
'Raj Garh,Kota,Rajasthan',
'Rajpur,Kota,Rajasthan',
'Ramgarh,Kota,Rajasthan',
'Ratawad,Kota,Rajasthan',
'Richhanda,Kota,Rajasthan',
'Sahjanpur,Kota,Rajasthan',
'Sahrol Taleti,Kota,Rajasthan',
'Sakatpur,Kota,Rajasthan',
'Sakrawada,Kota,Rajasthan',
'Salpura,Kota,Rajasthan',
'Samrania,Kota,Rajasthan',
'Sanwara,Kota,Rajasthan',
'Sarthal,Kota,Rajasthan',
'Semli,Kota,Rajasthan',
'Sethkolu,Kota,Rajasthan',
'Shahbad,Kota,Rajasthan',
'Shergarh,Kota,Rajasthan',
'Shubhadra Colony,Kota,Rajasthan',
'Simli,Kota,Rajasthan',
'Sorkhand Kalan,Kota,Rajasthan',
'Sorsan,Kota,Rajasthan',
'Sundlak,Kota,Rajasthan',
'Tam Khera,Kota,Rajasthan',
'Tancha,Kota,Rajasthan',
'Teetar Kheri,Kota,Rajasthan',
'Telni,Kota,Rajasthan',
'Thikaria,Kota,Rajasthan',
'Tisaya,Kota,Rajasthan',
'Kunjed,Kota,Rajasthan',
'Sahrod,Kota,Rajasthan',
'Tulsan,Kota,Rajasthan',
'Anta Gas Power Plant,Kota,Rajasthan',
'Anta,Kota,Rajasthan',
'Badgaon,Kota,Rajasthan',
'Baldarah,Kota,Rajasthan',
'Chhabra,Kota,Rajasthan',
'Chhipa Barod,Kota,Rajasthan',
'Patunda,Kota,Rajasthan',
'Raithal,Kota,Rajasthan',
'Richhadia,Kota,Rajasthan',
'Shahpura,Kota,Rajasthan',
'Siswali,Kota,Rajasthan',
'Tisaya,Kota,Rajasthan',
'Udpura,Kota,Rajasthan',
'Kartia,Barmer,Rajasthan',
'Mungeria,Barmer,Rajasthan',
'Akadara,Barmer,Rajasthan',
'Baitu Bhimji,Barmer,Rajasthan',
'Baitu Chimanji,Barmer,Rajasthan',
'Baitu Panji,Barmer,Rajasthan',
'Baitu,Barmer,Rajasthan',
'Bhimarl R.S.,Barmer,Rajasthan',
'Bhimarlai,Barmer,Rajasthan',
'Bhojasar,Barmer,Rajasthan',
'Chandesara,Barmer,Rajasthan',
'Chidiya,Barmer,Rajasthan',
'Dudhwa,Barmer,Rajasthan',
'Go R.S.,Barmer,Rajasthan',
'Kharapar,Barmer,Rajasthan',
'Khattu,Barmer,Rajasthan',
'Kolu,Barmer,Rajasthan',
'Madhasar,Barmer,Rajasthan',
'Panawara,Barmer,Rajasthan',
'Santara,Barmer,Rajasthan',
'Somesara,Barmer,Rajasthan',
'Uttarni,Barmer,Rajasthan',
'Asada,Barmer,Rajasthan',
'Asotra,Barmer,Rajasthan',
'Balotra IA,Barmer,Rajasthan',
'Balotra,Barmer,Rajasthan',
'Balotra SB,Barmer,Rajasthan',
'Bhunka,Barmer,Rajasthan',
'Bithuja,Barmer,Rajasthan',
'Budiwara,Barmer,Rajasthan',
'Dakha,Barmer,Rajasthan',
'Jagsa,Barmer,Rajasthan',
'Janiyana,Barmer,Rajasthan',
'Kaludi,Barmer,Rajasthan',
'Kitnod,Barmer,Rajasthan',
'Mungda,Barmer,Rajasthan',
'Sarana,Barmer,Rajasthan',
'Sinli Jagir,Barmer,Rajasthan',
'Tapra,Barmer,Rajasthan',
'Tilwara,Barmer,Rajasthan',
'Atimalani,Barmer,Rajasthan',
'Barmer Agore,Barmer,Rajasthan',
'Barmer Coll,Barmer,Rajasthan',
'Barmer DB,Barmer,Rajasthan',
'Barmer H.O,Barmer,Rajasthan',
'Barmer PR,Barmer,Rajasthan',
'Barmer RS,Barmer,Rajasthan',
'Bhadkha,Barmer,Rajasthan',
'Bhanwarlai,Barmer,Rajasthan',
'Bola,Barmer,Rajasthan',
'Derasar,Barmer,Rajasthan',
'Gangala,Barmer,Rajasthan',
'Garal,Barmer,Rajasthan',
'Gehun,Barmer,Rajasthan',
'Hapon Ki Dhani,Barmer,Rajasthan',
'Hathma,Barmer,Rajasthan',
'Indroi,Barmer,Rajasthan',
'Jalipa,Barmer,Rajasthan',
'Jasai,Barmer,Rajasthan',
'Jaydu,Barmer,Rajasthan',
'Kagau,Barmer,Rajasthan',
'Kapurdi,Barmer,Rajasthan',
'Khadeen,Barmer,Rajasthan',
'Khara Rathodan,Barmer,Rajasthan',
'Kharia Tala,Barmer,Rajasthan',
'Khudasa,Barmer,Rajasthan',
'Kurla,Barmer,Rajasthan',
'Langera,Barmer,Rajasthan',
'Magne Ki Dhani,Barmer,Rajasthan',
'Mahabar,Barmer,Rajasthan',
'Malpura,Barmer,Rajasthan',
'Marudi,Barmer,Rajasthan',
'Mithra Khurd,Barmer,Rajasthan',
'Nokh,Barmer,Rajasthan',
'Para,Barmer,Rajasthan',
'Rohili,Barmer,Rajasthan',
'Shivkar,Barmer,Rajasthan',
'Sinyani,Barmer,Rajasthan',
'Redana,Barmer,Rajasthan',
'Uttarl R.S.,Barmer,Rajasthan',
'Adarsh Basti,Barmer,Rajasthan',
'Asadi,Barmer,Rajasthan',
'Balewa,Barmer,Rajasthan',
'Bandhada,Barmer,Rajasthan',
'Bhadresh,Barmer,Rajasthan',
'Bishala Agore,Barmer,Rajasthan',
'Bishala,Barmer,Rajasthan',
'Chetrodi,Barmer,Rajasthan',
'Chuli,Barmer,Rajasthan',
'Dabar,Barmer,Rajasthan',
'Fogera,Barmer,Rajasthan',
'Girab,Barmer,Rajasthan',
'Harsani,Barmer,Rajasthan',
'Lunukhurd,Barmer,Rajasthan',
'Malwa,Barmer,Rajasthan',
'Nand,Barmer,Rajasthan',
'Sura,Barmer,Rajasthan',
'Unroad,Barmer,Rajasthan',
'Adrim Ka Tala,Barmer,Rajasthan',
'Alamsar,Barmer,Rajasthan',
'Antia,Barmer,Rajasthan',
'Baori Kallan,Barmer,Rajasthan',
'Bhojaria,Barmer,Rajasthan',
'Binjasar,Barmer,Rajasthan',
'Binjrad,Barmer,Rajasthan',
'Booth Rathodan,Barmer,Rajasthan',
'Burhan Ka Tala,Barmer,Rajasthan',
'Chohtan,Barmer,Rajasthan',
'Dedusar,Barmer,Rajasthan',
'Dhanau,Barmer,Rajasthan',
'Dharasar,Barmer,Rajasthan',
'Dhok,Barmer,Rajasthan',
'Gohar Ka Tala,Barmer,Rajasthan',
'Gumane Ka Tala,Barmer,Rajasthan',
'Intada,Barmer,Rajasthan',
'Jaisar,Barmer,Rajasthan',
'Jalila,Barmer,Rajasthan',
'Juna Lakhwara,Barmer,Rajasthan',
'Kaprau,Barmer,Rajasthan',
'Kelnoor,Barmer,Rajasthan',
'Kharia Rathodan,Barmer,Rajasthan',
'Konra,Barmer,Rajasthan',
'Lakhwara,Barmer,Rajasthan',
'Mate Ka Tala,Barmer,Rajasthan',
'Mitharau,Barmer,Rajasthan',
'Mithe Ka Tala,Barmer,Rajasthan',
'Navatala Jetmal,Barmer,Rajasthan',
'Nehron Ka Tala,Barmer,Rajasthan',
'Netrad,Barmer,Rajasthan',
'Paradia,Barmer,Rajasthan',
'Punjasar,Barmer,Rajasthan',
'Rabasar,Barmer,Rajasthan',
'Ramjan Ki Gaffan,Barmer,Rajasthan',
'Ratasar,Barmer,Rajasthan',
'Saiyon Ka Tala,Barmer,Rajasthan',
'Sanwa,Barmer,Rajasthan',
'Sarupe Ka Tala,Barmer,Rajasthan',
'Shobhala,Barmer,Rajasthan',
'Shobhala Jetmal,Barmer,Rajasthan',
'Somarad,Barmer,Rajasthan',
'Sriramwala,Barmer,Rajasthan',
'Uparla,Barmer,Rajasthan',
'Alamsariya,Barmer,Rajasthan',
'Arniyali,Barmer,Rajasthan',
'Bachhrau,Barmer,Rajasthan',
'Bamarla,Barmer,Rajasthan',
'Bamnore Amarshah,Barmer,Rajasthan',
'Bhag Bhare Ki Beri,Barmer,Rajasthan',
'Bhalikhal,Barmer,Rajasthan',
'Bhalisar,Barmer,Rajasthan',
'Bherudi,Barmer,Rajasthan',
'Bhimthal,Barmer,Rajasthan',
'Bhunia,Barmer,Rajasthan',
'Bisarniya,Barmer,Rajasthan',
'Boli,Barmer,Rajasthan',
'Bore Charnan,Barmer,Rajasthan',
'Chalkana,Barmer,Rajasthan',
'Dhorimana,Barmer,Rajasthan',
'Dudhu,Barmer,Rajasthan',
'Gora,Barmer,Rajasthan',
'Kabooli,Barmer,Rajasthan',
'Katarla,Barmer,Rajasthan',
'Kekar,Barmer,Rajasthan',
'Khari,Barmer,Rajasthan',
'Kitnoria,Barmer,Rajasthan',
'Koja,Barmer,Rajasthan',
'Koliyana,Barmer,Rajasthan',
'Kothala,Barmer,Rajasthan',
'Kundawa,Barmer,Rajasthan',
'Loharwa,Barmer,Rajasthan',
'Lukhu,Barmer,Rajasthan',
'Mangta,Barmer,Rajasthan',
'Manki,Barmer,Rajasthan',
'Mithara Khurd,Barmer,Rajasthan',
'Ogala,Barmer,Rajasthan',
'Panoria,Barmer,Rajasthan',
'Purawa,Barmer,Rajasthan',
'Ranasar Kallan,Barmer,Rajasthan',
'Rohila,Barmer,Rajasthan',
'Rohila West,Barmer,Rajasthan',
'Sonari,Barmer,Rajasthan',
'Udasar,Barmer,Rajasthan',
'Bandasar,Barmer,Rajasthan',
'Boothia,Barmer,Rajasthan',
'Chandi Ka Par,Barmer,Rajasthan',
'Gadra Road,Barmer,Rajasthan',
'Jaisindh R.S.,Barmer,Rajasthan',
'Jaisindhar,Barmer,Rajasthan',
'Khaniyani,Barmer,Rajasthan',
'Leelma,Barmer,Rajasthan',
'Medusar,Barmer,Rajasthan',
'Munabao,Barmer,Rajasthan',
'Panchala,Barmer,Rajasthan',
'Rohidi,Barmer,Rajasthan',
'Shahdad Ka Par,Barmer,Rajasthan',
'Sundra,Barmer,Rajasthan',
'Tamlore,Barmer,Rajasthan',
'Alpura,Barmer,Rajasthan',
'Banta,Barmer,Rajasthan',
'Bhakharpura,Barmer,Rajasthan',
'Bhedana,Barmer,Rajasthan',
'Daboi,Barmer,Rajasthan',
'Dangaria,Barmer,Rajasthan',
'Gandhavkallan,Barmer,Rajasthan',
'Gudamalani,Barmer,Rajasthan',
'Jalikheda,Barmer,Rajasthan',
'Junwa Jagir,Barmer,Rajasthan',
'Nagarnava,Barmer,Rajasthan',
'Piprali,Barmer,Rajasthan',
'Ratanpura,Barmer,Rajasthan',
'Sindhasawa Chauhan,Barmer,Rajasthan',
'Sindhasawa Harniyan,Barmer,Rajasthan',
'Undari Juni,Barmer,Rajasthan',
'Dedawas,Barmer,Rajasthan',
'Arang,Barmer,Rajasthan',
'Gunga,Barmer,Rajasthan',
'Hadwa,Barmer,Rajasthan',
'Jhampli Kallan,Barmer,Rajasthan',
'Khudal,Barmer,Rajasthan',
'Rajdal,Barmer,Rajasthan',
'Swamy Ka Gaon,Barmer,Rajasthan',
'Jasol,Barmer,Rajasthan',
'Asarwa [Araba],Barmer,Rajasthan',
'Bagawas,Barmer,Rajasthan',
'Balau Jati,Barmer,Rajasthan',
'Doli Rajguran,Barmer,Rajasthan',
'Dolikallan,Barmer,Rajasthan',
'Godawas,Barmer,Rajasthan',
'Gwalnada,Barmer,Rajasthan',
'Kalyanpur,Barmer,Rajasthan',
'Korna,Barmer,Rajasthan',
'Mandali,Barmer,Rajasthan',
'Nagana,Barmer,Rajasthan',
'Neori,Barmer,Rajasthan',
'Raniadashipura,Barmer,Rajasthan',
'Sarwadi Purohitan,Barmer,Rajasthan',
'Soorpura,Barmer,Rajasthan',
'Thumbali,Barmer,Rajasthan',
'Bandra,Barmer,Rajasthan',
'Batadu,Barmer,Rajasthan',
'Bhimda,Barmer,Rajasthan',
'Bhurtia,Barmer,Rajasthan',
'Chitar Ka Par,Barmer,Rajasthan',
'Chokhala,Barmer,Rajasthan',
'Harkhali,Barmer,Rajasthan',
'Hudon Ki Dhani,Barmer,Rajasthan',
'Jhak,Barmer,Rajasthan',
'Kavas,Barmer,Rajasthan',
'Kosariya,Barmer,Rajasthan',
'Lunada,Barmer,Rajasthan',
'Madpura Barwala,Barmer,Rajasthan',
'Madpura Sani,Barmer,Rajasthan',
'Rateu,Barmer,Rajasthan',
'Uttarlai Mines,Barmer,Rajasthan',
'Mewanagar,Barmer,Rajasthan',
'Bhagwa,Barmer,Rajasthan',
'Dhiran,Barmer,Rajasthan',
'Kathadi,Barmer,Rajasthan',
'Khandap,Barmer,Rajasthan',
'Kundal,Barmer,Rajasthan',
'Mahilawas,Barmer,Rajasthan',
'Mokalsar,Barmer,Rajasthan',
'Motisara,Barmer,Rajasthan',
'Rakhi,Barmer,Rajasthan',
'Ramania,Barmer,Rajasthan',
'Sella,Barmer,Rajasthan',
'Jethantri,Barmer,Rajasthan',
'Badnava,Barmer,Rajasthan',
'Bhandiyawas,Barmer,Rajasthan',
'Chilanadi,Barmer,Rajasthan',
'Gopari,Barmer,Rajasthan',
'Kalewa,Barmer,Rajasthan',
'Khanoda,Barmer,Rajasthan',
'Kharda BS,Barmer,Rajasthan',
'Khardi,Barmer,Rajasthan',
'Khokhsar,Barmer,Rajasthan',
'Kudi,Barmer,Rajasthan',
'Kumpalia,Barmer,Rajasthan',
'Newai,Barmer,Rajasthan',
'Pachpadra City,Barmer,Rajasthan',
'Pachpadra Salt,Barmer,Rajasthan',
'Pareu,Barmer,Rajasthan',
'Patau Khurd,Barmer,Rajasthan',
'Patodi,Barmer,Rajasthan',
'Patodi Navatala,Barmer,Rajasthan',
'Richholi,Barmer,Rajasthan',
'Sajiyali Pk,Barmer,Rajasthan',
'Sathuni Purohitan,Barmer,Rajasthan',
'Simarkhiya Khara,Barmer,Rajasthan',
'Simarkhiya Purohitan,Barmer,Rajasthan',
'Thob,Barmer,Rajasthan',
'Tirsinghdi,Barmer,Rajasthan',
'Bhata,Barmer,Rajasthan',
'Dhanwa,Barmer,Rajasthan',
'Dharna,Barmer,Rajasthan',
'Itwaya,Barmer,Rajasthan',
'Juna Mitha Kheda,Barmer,Rajasthan',
'Kankhi,Barmer,Rajasthan',
'Mithoda,Barmer,Rajasthan',
'Padru,Barmer,Rajasthan',
'Pau,Barmer,Rajasthan',
'Kanana,Barmer,Rajasthan',
'Kankrala,Barmer,Rajasthan',
'Kharwa,Barmer,Rajasthan',
'Parlu,Barmer,Rajasthan',
'Sillore,Barmer,Rajasthan',
'Umarlai,Barmer,Rajasthan',
'Abhey Ka Par,Barmer,Rajasthan',
'Babuguleria,Barmer,Rajasthan',
'Bhachbhar,Barmer,Rajasthan',
'Bhilon Ka Par,Barmer,Rajasthan',
'Bukar,Barmer,Rajasthan',
'Chadi,Barmer,Rajasthan',
'Detani,Barmer,Rajasthan',
'Gagaria,Barmer,Rajasthan',
'Gardia,Barmer,Rajasthan',
'Kachhabe Ki Dhani,Barmer,Rajasthan',
'Kantal Ka Par,Barmer,Rajasthan',
'Kharchi,Barmer,Rajasthan',
'Kharia Kallan,Barmer,Rajasthan',
'Pandhi Ka Par,Barmer,Rajasthan',
'Ramsar,Barmer,Rajasthan',
'Ranasar,Barmer,Rajasthan',
'Sajan Ka Par,Barmer,Rajasthan',
'Setrau,Barmer,Rajasthan',
'Tamliyar,Barmer,Rajasthan',
'Akoda,Barmer,Rajasthan',
'Balau,Barmer,Rajasthan',
'Balera,Barmer,Rajasthan',
'Dudhwakhurd,Barmer,Rajasthan',
'Goliar,Barmer,Rajasthan',
'Junapatrasar,Barmer,Rajasthan',
'Radwa,Barmer,Rajasthan',
'Ranigaon,Barmer,Rajasthan',
'Sanau,Barmer,Rajasthan',
'Sanwlore,Barmer,Rajasthan',
'Taratara,Barmer,Rajasthan',
'Taratara Math,Barmer,Rajasthan',
'Undkha,Barmer,Rajasthan',
'Borwa,Barmer,Rajasthan',
'Chawa,Barmer,Rajasthan',
'Kharantia Khurd,Barmer,Rajasthan',
'Punion Ki Basti,Barmer,Rajasthan',
'Ramsar Ka Kua,Barmer,Rajasthan',
'Rawatsar,Barmer,Rajasthan',
'Sanjata,Barmer,Rajasthan',
'Sarli,Barmer,Rajasthan',
'Sarnu,Barmer,Rajasthan',
'Sewaniyala,Barmer,Rajasthan',
'Taku Beri,Barmer,Rajasthan',
'Ajit,Barmer,Rajasthan',
'Arthandi,Barmer,Rajasthan',
'Bamseen,Barmer,Rajasthan',
'Bhalron Ka Bada,Barmer,Rajasthan',
'Deedhas,Barmer,Rajasthan',
'Kamon Ka Bada,Barmer,Rajasthan',
'Karmawas,Barmer,Rajasthan',
'Khejadiyali,Barmer,Rajasthan',
'Kotari,Barmer,Rajasthan',
'Majal,Barmer,Rajasthan',
'Rampura,Barmer,Rajasthan',
'Ranideshipura,Barmer,Rajasthan',
'Ratri,Barmer,Rajasthan',
'Samdari RS,Barmer,Rajasthan',
'Samdari,Barmer,Rajasthan',
'Sewali,Barmer,Rajasthan',
'Booth Jetmal,Barmer,Rajasthan',
'Dudhiya Kallan,Barmer,Rajasthan',
'Hathitala,Barmer,Rajasthan',
'Ishrol,Barmer,Rajasthan',
'Jakhdon Ki Dhani,Barmer,Rajasthan',
'Leelsar,Barmer,Rajasthan',
'Mehlu,Barmer,Rajasthan',
'Ramdeoria,Barmer,Rajasthan',
'Sanawara,Barmer,Rajasthan',
'Sodiyar,Barmer,Rajasthan',
'Arti,Barmer,Rajasthan',
'Bakhasar,Barmer,Rajasthan',
'Bamarwala,Barmer,Rajasthan',
'Bhalgaon,Barmer,Rajasthan',
'Bhanwar,Barmer,Rajasthan',
'Bhawaria,Barmer,Rajasthan',
'Bisasar,Barmer,Rajasthan',
'Chinchrasar,Barmer,Rajasthan',
'Ekal,Barmer,Rajasthan',
'Gangasara,Barmer,Rajasthan',
'Gidan,Barmer,Rajasthan',
'Harpalia,Barmer,Rajasthan',
'Hathala,Barmer,Rajasthan',
'Janpalia,Barmer,Rajasthan',
'Jaton Ka Bera,Barmer,Rajasthan',
'Jharpa,Barmer,Rajasthan',
'Kundanpura,Barmer,Rajasthan',
'Moolani,Barmer,Rajasthan',
'Navatala Bakhasar,Barmer,Rajasthan',
'Pandhi Ka Niwan,Barmer,Rajasthan',
'Phagalia,Barmer,Rajasthan',
'Salaria,Barmer,Rajasthan',
'Sarla,Barmer,Rajasthan',
'Sata,Barmer,Rajasthan',
'Sedwa,Barmer,Rajasthan',
'Sinhaniya,Barmer,Rajasthan',
'Sinhar,Barmer,Rajasthan',
'Balai,Barmer,Rajasthan',
'Balasar,Barmer,Rajasthan',
'Bhinyad,Barmer,Rajasthan',
'Bissukallan,Barmer,Rajasthan',
'Chochra,Barmer,Rajasthan',
'Dhani Jan Singh Ki Beri,Barmer,Rajasthan',
'Dharvi Kallan,Barmer,Rajasthan',
'Dharvi Khurd,Barmer,Rajasthan',
'Jasa Ka Gaon,Barmer,Rajasthan',
'Jhankali,Barmer,Rajasthan',
'Junejon Ki Basti,Barmer,Rajasthan',
'Kanasar,Barmer,Rajasthan',
'Kashmir,Barmer,Rajasthan',
'Kotra,Barmer,Rajasthan',
'Mokhab,Barmer,Rajasthan',
'Nagarda,Barmer,Rajasthan',
'Nimbla,Barmer,Rajasthan',
'Pusad,Barmer,Rajasthan',
'Shiv,Barmer,Rajasthan',
'Tanu Mansingh,Barmer,Rajasthan',
'Thumbali,Barmer,Rajasthan',
'Undu,Barmer,Rajasthan',
'Adel,Barmer,Rajasthan',
'Band,Barmer,Rajasthan',
'Chadon Ki Dhani,Barmer,Rajasthan',
'Chhotu,Barmer,Rajasthan',
'Dandali,Barmer,Rajasthan',
'Dhanne Ki Dhani,Barmer,Rajasthan',
'Ed Sindhari,Barmer,Rajasthan',
'Golia Jet,Barmer,Rajasthan',
'Hodu,Barmer,Rajasthan',
'Jogasar,Barmer,Rajasthan',
'Kamthai,Barmer,Rajasthan',
'Khara Mahechan,Barmer,Rajasthan',
'Kharia Khurd,Barmer,Rajasthan',
'Khudala,Barmer,Rajasthan',
'Koslu,Barmer,Rajasthan',
'Lolawa,Barmer,Rajasthan',
'Mandawala,Barmer,Rajasthan',
'Mangle Ki Beri,Barmer,Rajasthan',
'Nehron Ki Dhani,Barmer,Rajasthan',
'Nimbalkot,Barmer,Rajasthan',
'Nokhada,Barmer,Rajasthan',
'Nosar,Barmer,Rajasthan',
'Panyala Kallan,Barmer,Rajasthan',
'Ranasar Khurd,Barmer,Rajasthan',
'Sada,Barmer,Rajasthan',
'Sadecha,Barmer,Rajasthan',
'Sanpa Manji,Barmer,Rajasthan',
'Shobhala Jetmal II,Barmer,Rajasthan',
'Sindhari,Barmer,Rajasthan',
'Deora,Barmer,Rajasthan',
'Devandi,Barmer,Rajasthan',
'Golia Bhailan,Barmer,Rajasthan',
'Gudanal,Barmer,Rajasthan',
'Indrana,Barmer,Rajasthan',
'Kuship,Barmer,Rajasthan',
'Maori,Barmer,Rajasthan',
'Meli Bandha,Barmer,Rajasthan',
'Moothali,Barmer,Rajasthan',
'Padarli,Barmer,Rajasthan',
'Siner,Barmer,Rajasthan',
'Siwana,Barmer,Rajasthan',
'Thapan,Barmer,Rajasthan',
'Gida,Barmer,Rajasthan',
'Hire Ki Dhani,Barmer,Rajasthan',
'Jajwa,Barmer,Rajasthan',
'Jakhada,Barmer,Rajasthan',
'Kanod,Barmer,Rajasthan',
'Keshumbla Bhatian,Barmer,Rajasthan',
'Lapundara Tarli,Barmer,Rajasthan',
'Manpura Kharda,Barmer,Rajasthan',
'Punion Ka Tala,Barmer,Rajasthan',
'Shahar,Barmer,Rajasthan',
'Shohda,Barmer,Rajasthan',
'Swau Moolraj,Barmer,Rajasthan',
'Swau Padamsingh,Barmer,Rajasthan',
'Khimpsar,Barmer,Rajasthan',
'Bharatpur H.O,Bharatpur,Rajasthan',
'Band Baretha,Dholpur,Rajasthan',
'Bayana,Dholpur,Rajasthan',
'Bazariya Bayana,Dholpur,Rajasthan',
'Gajipur,Dholpur,Rajasthan',
'Jain Gali Bayana,Dholpur,Rajasthan',
'Kachahri Bayana,Dholpur,Rajasthan',
'Khareri,Dholpur,Rajasthan',
'Mehrawar,Dholpur,Rajasthan',
'Nibhera,Dholpur,Rajasthan',
'Rudawal,Dholpur,Rajasthan',
'Sadpura,Dholpur,Rajasthan',
'Sikandara,Dholpur,Rajasthan',
'Thana Tang,Dholpur,Rajasthan',
'Adda,Dholpur,Rajasthan',
'Aroda,Dholpur,Rajasthan',
'Bagren,Dholpur,Rajasthan',
'Banshi Paharpur,Dholpur,Rajasthan',
'Baroda,Dholpur,Rajasthan',
'Bhawanpura,Dholpur,Rajasthan',
'Bidiyari,Dholpur,Rajasthan',
'Brahmbad,Dholpur,Rajasthan',
'Chak Samri,Dholpur,Rajasthan',
'Chenkora,Dholpur,Rajasthan',
'Dahgaon,Dholpur,Rajasthan',
'Dahina Gaon,Dholpur,Rajasthan',
'Damdama,Dholpur,Rajasthan',
'Dana Khedli,Dholpur,Rajasthan',
'Daulat Garh,Dholpur,Rajasthan',
'Dhadhren,Dholpur,Rajasthan',
'Dorda,Dholpur,Rajasthan',
'Dumaria,Dholpur,Rajasthan',
'Farso,Dholpur,Rajasthan',
'Garhi Bajna,Dholpur,Rajasthan',
'Gobra,Dholpur,Rajasthan',
'Ibrahimpur,Dholpur,Rajasthan',
'Jatmasi,Dholpur,Rajasthan',
'Jotroli,Dholpur,Rajasthan',
'Kakraua,Dholpur,Rajasthan',
'Kanavar,Dholpur,Rajasthan',
'Kapoora Malooka,Dholpur,Rajasthan',
'Karwari,Dholpur,Rajasthan',
'Keir,Dholpur,Rajasthan',
'Khan Kheda,Dholpur,Rajasthan',
'Khan Surjapur,Dholpur,Rajasthan',
'Khanwa,Dholpur,Rajasthan',
'Khera Thakur,Dholpur,Rajasthan',
'Khohra,Dholpur,Rajasthan',
'Khunt Kheda,Dholpur,Rajasthan',
'Kot,Dholpur,Rajasthan',
'Lehchora Kalan,Dholpur,Rajasthan',
'Madanpur,Dholpur,Rajasthan',
'Madha Pura,Dholpur,Rajasthan',
'Mahaloni,Dholpur,Rajasthan',
'Mahalpur Choora,Dholpur,Rajasthan',
'Mahmadpura,Dholpur,Rajasthan',
'Maloni,Dholpur,Rajasthan',
'Mandoli,Dholpur,Rajasthan',
'Mertha,Dholpur,Rajasthan',
'Milsama,Dholpur,Rajasthan',
'Moroli Dang,Dholpur,Rajasthan',
'Nagla Tula,Dholpur,Rajasthan',
'Nahroli,Dholpur,Rajasthan',
'Naroli,Dholpur,Rajasthan',
'Navali,Dholpur,Rajasthan',
'Noharda,Dholpur,Rajasthan',
'Ondelgaddi,Dholpur,Rajasthan',
'Pali Dang,Dholpur,Rajasthan',
'Paraua,Dholpur,Rajasthan',
'Purabai Kheda,Dholpur,Rajasthan',
'Raroda,Dholpur,Rajasthan',
'Rasilpur,Dholpur,Rajasthan',
'Salabad,Dholpur,Rajasthan',
'Samogar,Dholpur,Rajasthan',
'Samri,Dholpur,Rajasthan',
'Shahpur Dang,Dholpur,Rajasthan',
'Shergarh,Dholpur,Rajasthan',
'Singhada,Dholpur,Rajasthan',
'Singhania,Dholpur,Rajasthan',
'Sirrond,Dholpur,Rajasthan',
'Soopa,Dholpur,Rajasthan',
'Tarsuma,Dholpur,Rajasthan',
'Turtipura,Dholpur,Rajasthan',
'Abhorra,Bharatpur,Rajasthan',
'Aghapur,Bharatpur,Rajasthan',
'Ajan,Bharatpur,Rajasthan',
'Ajau,Bharatpur,Rajasthan',
'Akata,Bharatpur,Rajasthan',
'Akhaigarh,Bharatpur,Rajasthan',
'Alamshah,Bharatpur,Rajasthan',
'Alghani,Bharatpur,Rajasthan',
'Alipur,Bharatpur,Rajasthan',
'Amoli,Bharatpur,Rajasthan',
'Anahgatebharatpur,Bharatpur,Rajasthan',
'Anand Dadri,Bharatpur,Rajasthan',
'Anchera,Bharatpur,Rajasthan',
'Andhiyari,Bharatpur,Rajasthan',
'Astawan,Bharatpur,Rajasthan',
'Atari,Bharatpur,Rajasthan',
'Au,Bharatpur,Rajasthan',
'Awar,Bharatpur,Rajasthan',
'Babekhar,Bharatpur,Rajasthan',
'Baben,Bharatpur,Rajasthan',
'Bachhamdi,Bharatpur,Rajasthan',
'Bachhamdi Noh,Bharatpur,Rajasthan',
'Bachhren,Bharatpur,Rajasthan',
'Badangarh,Bharatpur,Rajasthan',
'Badipur,Bharatpur,Rajasthan',
'Bahaj,Bharatpur,Rajasthan',
'Bahtana,Bharatpur,Rajasthan',
'Ballabhgarh,Bharatpur,Rajasthan',
'Bamanwari,Bharatpur,Rajasthan',
'Bansi,Bharatpur,Rajasthan',
'Bansi Khurd,Bharatpur,Rajasthan',
'Barakhur,Bharatpur,Rajasthan',
'Barauli Chhar,Bharatpur,Rajasthan',
'Barauli Dhau,Bharatpur,Rajasthan',
'Bareh Mafi,Bharatpur,Rajasthan',
'Bargha,Bharatpur,Rajasthan',
'Barkheda,Bharatpur,Rajasthan',
'Baroli,Bharatpur,Rajasthan',
'Baroli Chuth,Bharatpur,Rajasthan',
'Baroli Ran,Bharatpur,Rajasthan',
'Barso,Bharatpur,Rajasthan',
'Bedham,Bharatpur,Rajasthan',
'Behnera,Bharatpur,Rajasthan',
'Belara,Bharatpur,Rajasthan',
'Berru,Bharatpur,Rajasthan',
'Bhadira,Bharatpur,Rajasthan',
'Bhainsa,Bharatpur,Rajasthan',
'Bhaiseena,Bharatpur,Rajasthan',
'Bhandara,Bharatpur,Rajasthan',
'Bhandore,Bharatpur,Rajasthan',
'Bharatpur Agency,Bharatpur,Rajasthan',
'Bharatpur City,Bharatpur,Rajasthan',
'Bharatpur,Bharatpur,Rajasthan',
'Bhatawali,Bharatpur,Rajasthan',
'Bhatpura,Bharatpur,Rajasthan',
'Bhonri,Bharatpur,Rajasthan',
'Bhont,Bharatpur,Rajasthan',
'Bhusawar,Bharatpur,Rajasthan',
'Bhutoli,Bharatpur,Rajasthan',
'Bijwari,Bharatpur,Rajasthan',
'Bilond,Bharatpur,Rajasthan',
'Bilong,Bharatpur,Rajasthan',
'Bilothi,Bharatpur,Rajasthan',
'Birheru,Bharatpur,Rajasthan',
'Bodoli Dahar,Bharatpur,Rajasthan',
'Bolkhera,Bharatpur,Rajasthan',
'Boodli,Bharatpur,Rajasthan',
'Borai,Bharatpur,Rajasthan',
'Bus Stand Kaman,Bharatpur,Rajasthan',
'Chauburja Bharatpur,Bharatpur,Rajasthan',
'Chentoli,Bharatpur,Rajasthan',
'Chhichhalwari,Bharatpur,Rajasthan',
'Chhonkarwara Kalan,Bharatpur,Rajasthan',
'Chichana,Bharatpur,Rajasthan',
'Chiksana,Bharatpur,Rajasthan',
'Chulhera,Bharatpur,Rajasthan',
'Collectorate BTP,Bharatpur,Rajasthan',
'Dandera,Bharatpur,Rajasthan',
'Dantlothi,Bharatpur,Rajasthan',
'Dawak,Bharatpur,Rajasthan',
'Deeg H.O,Bharatpur,Rajasthan',
'Dehra,Bharatpur,Rajasthan',
'Dehra,Bharatpur,Rajasthan',
'Dhamari,Bharatpur,Rajasthan',
'Dhanota,Bharatpur,Rajasthan',
'Dhanwara,Bharatpur,Rajasthan',
'Dharsoni,Bharatpur,Rajasthan',
'Dhilawati,Bharatpur,Rajasthan',
'Dhoolet,Bharatpur,Rajasthan',
'Dhormui,Bharatpur,Rajasthan',
'Didawali,Bharatpur,Rajasthan',
'Diwali,Bharatpur,Rajasthan',
'Dundawal,Bharatpur,Rajasthan',
'Ekta,Bharatpur,Rajasthan',
'Forest Lodge,Bharatpur,Rajasthan',
'Gadauli,Bharatpur,Rajasthan',
'Gagwana,Bharatpur,Rajasthan',
'Gangora,Bharatpur,Rajasthan',
'Gangrauli,Bharatpur,Rajasthan',
'Gaomdi,Bharatpur,Rajasthan',
'Gaomri,Bharatpur,Rajasthan',
'Garh Ajan,Bharatpur,Rajasthan',
'Ghatmika,Bharatpur,Rajasthan',
'Ghatri,Bharatpur,Rajasthan',
'Ghosinga,Bharatpur,Rajasthan',
'Ghusiyari,Bharatpur,Rajasthan',
'Gogera,Bharatpur,Rajasthan',
'Gopalgarh,Bharatpur,Rajasthan',
'Gopalgarh BTP,Bharatpur,Rajasthan',
'Gudawali,Bharatpur,Rajasthan',
'Guhana,Bharatpur,Rajasthan',
'Gulpada,Bharatpur,Rajasthan',
'Gunsara,Bharatpur,Rajasthan',
'Halena,Bharatpur,Rajasthan',
'Hantra,Bharatpur,Rajasthan',
'Hatheni,Bharatpur,Rajasthan',
'Hathodi,Bharatpur,Rajasthan',
'Hatizar,Bharatpur,Rajasthan',
'Helak,Bharatpur,Rajasthan',
'Hingota,Bharatpur,Rajasthan',
'Iklera,Bharatpur,Rajasthan',
'Ikran,Bharatpur,Rajasthan',
'Ind.Area BTP,Bharatpur,Rajasthan',
'Indrauli,Bharatpur,Rajasthan',
'Ishapur Katara,Bharatpur,Rajasthan',
'Jaghina,Bharatpur,Rajasthan',
'Jahaj,Bharatpur,Rajasthan',
'Jahangirpur,Bharatpur,Rajasthan',
'Jai Sri,Bharatpur,Rajasthan',
'Jalalpur,Bharatpur,Rajasthan',
'Jaluki,Bharatpur,Rajasthan',
'Janoothar,Bharatpur,Rajasthan',
'Jasupura,Bharatpur,Rajasthan',
'Jateri,Bharatpur,Rajasthan',
'Jatoli Rathbhan,Bharatpur,Rajasthan',
'Jatoli Thoon,Bharatpur,Rajasthan',
'Jhanjhar,Bharatpur,Rajasthan',
'Jharauti,Bharatpur,Rajasthan',
'Jharkai,Bharatpur,Rajasthan',
'Jharoli,Bharatpur,Rajasthan',
'Jotri Peepal,Bharatpur,Rajasthan',
'Jotruhalla,Bharatpur,Rajasthan',
'Jurhera,Bharatpur,Rajasthan',
'K.U.M.Bharatpur,Bharatpur,Rajasthan',
'Kaithwara,Bharatpur,Rajasthan',
'Kakrala,Bharatpur,Rajasthan',
'Kalsada,Bharatpur,Rajasthan',
'Kamalpura,Bharatpur,Rajasthan',
'Kamanlsg,Bharatpur,Rajasthan',
'Kanjoli Line,Bharatpur,Rajasthan',
'Karai,Bharatpur,Rajasthan',
'Karawali,Bharatpur,Rajasthan',
'Karili,Bharatpur,Rajasthan',
'Kasoda,Bharatpur,Rajasthan',
'Kasot,Bharatpur,Rajasthan',
'Kathol,Bharatpur,Rajasthan',
'Kawai,Bharatpur,Rajasthan',
'Khakhawali,Bharatpur,Rajasthan',
'Khandeola,Bharatpur,Rajasthan',
'Khangri,Bharatpur,Rajasthan',
'Khatoti,Bharatpur,Rajasthan',
'Kheri Devi Singh,Bharatpur,Rajasthan',
'Kherli Gadasia,Bharatpur,Rajasthan',
'Kherli Gujar,Bharatpur,Rajasthan',
'Khesti,Bharatpur,Rajasthan',
'Khoh,Bharatpur,Rajasthan',
'Khohri,Bharatpur,Rajasthan',
'Khohri,Bharatpur,Rajasthan',
'Konrer,Bharatpur,Rajasthan',
'Kotwalibharatpur,Bharatpur,Rajasthan',
'Krishna Colony BTP,Bharatpur,Rajasthan',
'Kumha,Bharatpur,Rajasthan',
'Kumher,Bharatpur,Rajasthan',
'Kumhergate BTP,Bharatpur,Rajasthan',
'Kurka,Bharatpur,Rajasthan',
'Ladamka,Bharatpur,Rajasthan',
'Lakhanpur,Bharatpur,Rajasthan',
'Ludhawai,Bharatpur,Rajasthan',
'Luhasa,Bharatpur,Rajasthan',
'Luhesor,Bharatpur,Rajasthan',
'M.V.Peeth Bhusawar,Bharatpur,Rajasthan',
'Madhoni,Bharatpur,Rajasthan',
'Mahua,Bharatpur,Rajasthan',
'Mai,Bharatpur,Rajasthan',
'Mainapura,Bharatpur,Rajasthan',
'Majajpur,Bharatpur,Rajasthan',
'Malah,Bharatpur,Rajasthan',
'Manjhi,Bharatpur,Rajasthan',
'Manota Kalan,Bharatpur,Rajasthan',
'Mathura Gate BTP,Bharatpur,Rajasthan',
'Matuki,Bharatpur,Rajasthan',
'Mehrawar,Bharatpur,Rajasthan',
'Milakpur,Bharatpur,Rajasthan',
'Moloni,Bharatpur,Rajasthan',
'Moondoti,Bharatpur,Rajasthan',
'Moroli,Bharatpur,Rajasthan',
'Moroli,Bharatpur,Rajasthan',
'Moroli Kalan,Bharatpur,Rajasthan',
'Mudhera,Bharatpur,Rajasthan',
'Mudia Sadh,Bharatpur,Rajasthan',
'Mudiya Lalita,Bharatpur,Rajasthan',
'Mudota,Bharatpur,Rajasthan',
'Mundiya,Bharatpur,Rajasthan',
'Murwara,Bharatpur,Rajasthan',
'Musepur,Bharatpur,Rajasthan',
'Nadbai,Bharatpur,Rajasthan',
'Nadbai Town,Bharatpur,Rajasthan',
'Nagar,Bharatpur,Rajasthan',
'Nagla Satwari,Bharatpur,Rajasthan',
'Nagla Tehriyan,Bharatpur,Rajasthan',
'Naom,Bharatpur,Rajasthan',
'Narharpur,Bharatpur,Rajasthan',
'Naroli,Bharatpur,Rajasthan',
'Nayabas,Bharatpur,Rajasthan',
'Nayagaom Khalsa,Bharatpur,Rajasthan',
'Nehra Chauth,Bharatpur,Rajasthan',
'Nekpur,Bharatpur,Rajasthan',
'New Mandi BTP,Bharatpur,Rajasthan',
'Newada,Bharatpur,Rajasthan',
'Nigoi,Bharatpur,Rajasthan',
'Nithar,Bharatpur,Rajasthan',
'Niyotha,Bharatpur,Rajasthan',
'Nogaom,Bharatpur,Rajasthan',
'Nonera,Bharatpur,Rajasthan',
'Olanda,Bharatpur,Rajasthan',
'Padalwas,Bharatpur,Rajasthan',
'Pahari,Bharatpur,Rajasthan',
'Paharsar,Bharatpur,Rajasthan',
'Pai,Bharatpur,Rajasthan',
'Pala,Bharatpur,Rajasthan',
'Pali,Bharatpur,Rajasthan',
'Palka,Bharatpur,Rajasthan',
'Panhori,Bharatpur,Rajasthan',
'Papra,Bharatpur,Rajasthan',
'Paprera,Bharatpur,Rajasthan',
'Par,Bharatpur,Rajasthan',
'Paraswara,Bharatpur,Rajasthan',
'Parmadra,Bharatpur,Rajasthan',
'Pasopa,Bharatpur,Rajasthan',
'Pasta,Bharatpur,Rajasthan',
'Pathena,Bharatpur,Rajasthan',
'Pathroli,Bharatpur,Rajasthan',
'Pendka,Bharatpur,Rajasthan',
'Penghore,Bharatpur,Rajasthan',
'Phulwara,Bharatpur,Rajasthan',
'Pichumar,Bharatpur,Rajasthan',
'Pichuna,Bharatpur,Rajasthan',
'Pili,Bharatpur,Rajasthan',
'Pingora,Bharatpur,Rajasthan',
'Pipalkheda,Bharatpur,Rajasthan',
'Pipla,Bharatpur,Rajasthan',
'Piprau,Bharatpur,Rajasthan',
'Poonchhari,Bharatpur,Rajasthan',
'Raisis,Bharatpur,Rajasthan',
'Randhirgarh,Bharatpur,Rajasthan',
'Ranf,Bharatpur,Rajasthan',
'Ranjeet Nagar BTP,Bharatpur,Rajasthan',
'Rareh,Bharatpur,Rajasthan',
'Ronija,Bharatpur,Rajasthan',
'Sablana,Bharatpur,Rajasthan',
'Sabora,Bharatpur,Rajasthan',
'Sadpuri,Bharatpur,Rajasthan',
'Saheda,Bharatpur,Rajasthan',
'Saindhli,Bharatpur,Rajasthan',
'Salempur Kalan,Bharatpur,Rajasthan',
'Salempur Khurd,Bharatpur,Rajasthan',
'Samai Kheda,Bharatpur,Rajasthan',
'Samler,Bharatpur,Rajasthan',
'Santruk,Bharatpur,Rajasthan',
'Sarsena,Bharatpur,Rajasthan',
'Satwas,Bharatpur,Rajasthan',
'Saumka,Bharatpur,Rajasthan',
'Sehna,Bharatpur,Rajasthan',
'Sehson,Bharatpur,Rajasthan',
'Semla Kalan,Bharatpur,Rajasthan',
'Semli,Bharatpur,Rajasthan',
'Sewar,Bharatpur,Rajasthan',
'Shekhpur,Bharatpur,Rajasthan',
'Shiswara,Bharatpur,Rajasthan',
'Sihi,Bharatpur,Rajasthan',
'Sikri,Bharatpur,Rajasthan',
'Sikrori,Bharatpur,Rajasthan',
'Sinsini,Bharatpur,Rajasthan',
'Sirthala,Bharatpur,Rajasthan',
'Sogar,Bharatpur,Rajasthan',
'Suhari,Bharatpur,Rajasthan',
'Sunari,Bharatpur,Rajasthan',
'Sundrawali,Bharatpur,Rajasthan',
'Sunhera,Bharatpur,Rajasthan',
'Syorawali,Bharatpur,Rajasthan',
'Takha,Bharatpur,Rajasthan',
'Talchhera,Bharatpur,Rajasthan',
'Talfara,Bharatpur,Rajasthan',
'Tamrer,Bharatpur,Rajasthan',
'Tarondar,Bharatpur,Rajasthan',
'Teski,Bharatpur,Rajasthan',
'Thairawar,Bharatpur,Rajasthan',
'Thoon,Bharatpur,Rajasthan',
'Tuhiya,Bharatpur,Rajasthan',
'Ubhaka,Bharatpur,Rajasthan',
'Uchain,Bharatpur,Rajasthan',
'Udaka,Bharatpur,Rajasthan',
'Unch,Bharatpur,Rajasthan',
'Uncha Gaom,Bharatpur,Rajasthan',
'Unchera,Bharatpur,Rajasthan',
'Undra,Bharatpur,Rajasthan',
'Ushrani,Bharatpur,Rajasthan',
'Utarda,Bharatpur,Rajasthan',
'Veerampura,Bharatpur,Rajasthan',
'Nayagaon,Dholpur,Rajasthan',
'Roopbas,Dholpur,Rajasthan',
'Roopbas Town,Dholpur,Rajasthan',
'Rundh,Dholpur,Rajasthan',
'Bajhera Kalan,Dholpur,Rajasthan',
'Bansi,Dholpur,Rajasthan',
'Hishamada,Dholpur,Rajasthan',
'Jagjiwanpur,Dholpur,Rajasthan',
'Jeewad,Dholpur,Rajasthan',
'Lakhanpur,Dholpur,Rajasthan',
'Muhari,Dholpur,Rajasthan',
'Rahimgarh,Dholpur,Rajasthan',
'Samraya,Dholpur,Rajasthan',
'Siras,Dholpur,Rajasthan',
'Suhans,Dholpur,Rajasthan',
'Umrend,Dholpur,Rajasthan',
'Weir,Dholpur,Rajasthan',
'Weir Town,Dholpur,Rajasthan',
'Amarwasi,Bhilwara,Rajasthan',
'Azad Nagar,Bhilwara,Rajasthan',
'Barantia,Bhilwara,Rajasthan',
'Bhojras,Bhilwara,Rajasthan',
'Dabla,Bhilwara,Rajasthan',
'Ganeshpura,Bhilwara,Rajasthan',
'Gharta,Bhilwara,Rajasthan',
'Jamoli,Bhilwara,Rajasthan',
'Kasuriya,Bhilwara,Rajasthan',
'Kaylias,Bhilwara,Rajasthan',
'Rupaheli,Bhilwara,Rajasthan',
'Sagreo,Bhilwara,Rajasthan',
'Sirdiyas,Bhilwara,Rajasthan',
'Tumkarwar,Bhilwara,Rajasthan',
'Adsipura,Bhilwara,Rajasthan',
'Agucha,Bhilwara,Rajasthan',
'Akarsada,Bhilwara,Rajasthan',
'Akola,Bhilwara,Rajasthan',
'Almas,Bhilwara,Rajasthan',
'Ama,Bhilwara,Rajasthan',
'Amalda,Bhilwara,Rajasthan',
'Amalda CO,Bhilwara,Rajasthan',
'Amargarh,Bhilwara,Rajasthan',
'Amarwasi,Bhilwara,Rajasthan',
'Amesar,Bhilwara,Rajasthan',
'Amli,Bhilwara,Rajasthan',
'Amli Kalan,Bhilwara,Rajasthan',
'Amli,Bhilwara,Rajasthan',
'Antali,Bhilwara,Rajasthan',
'Arjiya,Bhilwara,Rajasthan',
'Arnia,Bhilwara,Rajasthan',
'Arnia Ghoda,Bhilwara,Rajasthan',
'Arnia Rasa,Bhilwara,Rajasthan',
'Aroli,Bhilwara,Rajasthan',
'Arwar,Bhilwara,Rajasthan',
'Ashaholi,Bhilwara,Rajasthan',
'Asind,Bhilwara,Rajasthan',
'Atun,Bhilwara,Rajasthan',
'Babrana,Bhilwara,Rajasthan',
'Bachkhera,Bhilwara,Rajasthan',
'Badla,Bhilwara,Rajasthan',
'Badla,Bhilwara,Rajasthan',
'Badnore,Bhilwara,Rajasthan',
'Bagolia,Bhilwara,Rajasthan',
'Bagore,Bhilwara,Rajasthan',
'Bagudar,Bhilwara,Rajasthan',
'Bai,Bhilwara,Rajasthan',
'Bajunda,Bhilwara,Rajasthan',
'Baldarkha,Bhilwara,Rajasthan',
'Baldarkha CO,Bhilwara,Rajasthan',
'Balesaria,Bhilwara,Rajasthan',
'Bamnia,Bhilwara,Rajasthan',
'Ban Ka Kheda,Bhilwara,Rajasthan',
'Banera,Bhilwara,Rajasthan',
'Bankda,Bhilwara,Rajasthan',
'Baori,Bhilwara,Rajasthan',
'Bapunagar Bhilwara,Bhilwara,Rajasthan',
'Bara Mahuwa,Bhilwara,Rajasthan',
'Baran,Bhilwara,Rajasthan',
'Barana,Bhilwara,Rajasthan',
'Bardod,Bhilwara,Rajasthan',
'Barliyas,Bhilwara,Rajasthan',
'Baroda,Bhilwara,Rajasthan',
'Barsani,Bhilwara,Rajasthan',
'Barundani,Bhilwara,Rajasthan',
'Basera,Bhilwara,Rajasthan',
'Bavdi,Bhilwara,Rajasthan',
'Bavlas,Bhilwara,Rajasthan',
'Bemali,Bhilwara,Rajasthan',
'Bera,Bhilwara,Rajasthan',
'Bhabhana,Bhilwara,Rajasthan',
'Bhadsi,Bhilwara,Rajasthan',
'Bhadu,Bhilwara,Rajasthan',
'Bhagunagar,Bhilwara,Rajasthan',
'Bhagwanpura,Bhilwara,Rajasthan',
'Bhaktvilas,Bhilwara,Rajasthan',
'Bharak,Bhilwara,Rajasthan',
'Bharni Kalan,Bhilwara,Rajasthan',
'Bheemdiyas,Bhilwara,Rajasthan',
'Bheeta,Bhilwara,Rajasthan',
'Bhilwara City,Bhilwara,Rajasthan',
'Bhilwara Court,Bhilwara,Rajasthan',
'Bhilwara H.O,Bhilwara,Rajasthan',
'Bhilwara Rly Station,Bhilwara,Rajasthan',
'Bhojpur,Bhilwara,Rajasthan',
'Bhojpura,Bhilwara,Rajasthan',
'Bholi,Bhilwara,Rajasthan',
'Bhopalgarh,Bhilwara,Rajasthan',
'Bhopatpura,Bhilwara,Rajasthan',
'Bhunas,Bhilwara,Rajasthan',
'Bhunas,Bhilwara,Rajasthan',
'Bigod,Bhilwara,Rajasthan',
'Bihada,Bhilwara,Rajasthan',
'Bihada,Bhilwara,Rajasthan',
'Bijolia Khurd,Bhilwara,Rajasthan',
'Bijolian,Bhilwara,Rajasthan',
'Bikampura,Bhilwara,Rajasthan',
'Bikaran,Bhilwara,Rajasthan',
'Biletha,Bhilwara,Rajasthan',
'Biliya,Bhilwara,Rajasthan',
'Birdhol,Bhilwara,Rajasthan',
'Bishniya,Bhilwara,Rajasthan',
'Bor,Bhilwara,Rajasthan',
'Borana CO,Bhilwara,Rajasthan',
'Borani,Bhilwara,Rajasthan',
'Borda,Bhilwara,Rajasthan',
'Borda,Bhilwara,Rajasthan',
'Borela,Bhilwara,Rajasthan',
'Boriapura,Bhilwara,Rajasthan',
'Brahmano Ki Sareri,Bhilwara,Rajasthan',
'Chainpura,Bhilwara,Rajasthan',
'Chamanpura,Bhilwara,Rajasthan',
'Chand Ji Ki Kheri,Bhilwara,Rajasthan',
'Chandras,Bhilwara,Rajasthan',
'Chankhed,Bhilwara,Rajasthan',
'Chatarpur,Bhilwara,Rajasthan',
'Chawandia,Bhilwara,Rajasthan',
'Cheerkheda,Bhilwara,Rajasthan',
'Chhaprel,Bhilwara,Rajasthan',
'Chileshwar,Bhilwara,Rajasthan',
'Chitamba,Bhilwara,Rajasthan',
'Dabla Chanda,Bhilwara,Rajasthan',
'Dahimatha,Bhilwara,Rajasthan',
'Danthal,Bhilwara,Rajasthan',
'Dantra,Bhilwara,Rajasthan',
'Dantra,Bhilwara,Rajasthan',
'Dantra,Bhilwara,Rajasthan',
'Darawat CO,Bhilwara,Rajasthan',
'Dariba,Bhilwara,Rajasthan',
'Daulatgarh,Bhilwara,Rajasthan',
'Delana,Bhilwara,Rajasthan',
'Deoli,Bhilwara,Rajasthan',
'Deoria,Bhilwara,Rajasthan',
'Deoriya,Bhilwara,Rajasthan',
'Dhakarkhedi,Bhilwara,Rajasthan',
'Dhamnia,Bhilwara,Rajasthan',
'Dhanmandi,Bhilwara,Rajasthan',
'Dhanop,Bhilwara,Rajasthan',
'Dhikola,Bhilwara,Rajasthan',
'Dholi,Bhilwara,Rajasthan',
'Dhor,Bhilwara,Rajasthan',
'Dhosar,Bhilwara,Rajasthan',
'Dhuwala,Bhilwara,Rajasthan',
'Dhuwala,Bhilwara,Rajasthan',
'Dhuwala,Bhilwara,Rajasthan',
'Dohriya,Bhilwara,Rajasthan',
'Dudiya,Bhilwara,Rajasthan',
'Gadoli,Bhilwara,Rajasthan',
'Gadoli,Bhilwara,Rajasthan',
'Gageda,Bhilwara,Rajasthan',
'Gahuli,Bhilwara,Rajasthan',
'Galwa,Bhilwara,Rajasthan',
'Gandher,Bhilwara,Rajasthan',
'Gangapur,Bhilwara,Rajasthan',
'Gangithala,Bhilwara,Rajasthan',
'Ganglas,Bhilwara,Rajasthan',
'Gega Ka Khera,Bhilwara,Rajasthan',
'Gendlia,Bhilwara,Rajasthan',
'Genoli,Bhilwara,Rajasthan',
'Ghadwala Ka Kheda,Bhilwara,Rajasthan',
'Ghodas,Bhilwara,Rajasthan',
'Gopalpura,Bhilwara,Rajasthan',
'Gorkhiya,Bhilwara,Rajasthan',
'Gudha,Bhilwara,Rajasthan',
'Gudha,Bhilwara,Rajasthan',
'Gulabpura Bazar,Bhilwara,Rajasthan',
'Gulabpura,Bhilwara,Rajasthan',
'Gundli,Bhilwara,Rajasthan',
'Gurlan,Bhilwara,Rajasthan',
'Gyangarh,Bhilwara,Rajasthan',
'Haled,Bhilwara,Rajasthan',
'Hamirgarh,Bhilwara,Rajasthan',
'Hukumpura,Bhilwara,Rajasthan',
'Hurda,Bhilwara,Rajasthan',
'Indra Market,Bhilwara,Rajasthan',
'Iras,Bhilwara,Rajasthan',
'Itmaria,Bhilwara,Rajasthan',
'Itunda,Bhilwara,Rajasthan',
'Jagpura,Bhilwara,Rajasthan',
'Jahazpur,Bhilwara,Rajasthan',
'Jaitgarh,Bhilwara,Rajasthan',
'Jalampura,Bhilwara,Rajasthan',
'Jalia,Bhilwara,Rajasthan',
'Jalindri,Bhilwara,Rajasthan',
'Jamali,Bhilwara,Rajasthan',
'Jassu Ji Ka Khera,Bhilwara,Rajasthan',
'Jawal,Bhilwara,Rajasthan',
'Jeeva Ka Khera,Bhilwara,Rajasthan',
'Jhadol,Bhilwara,Rajasthan',
'Jhalriya,Bhilwara,Rajasthan',
'Jhanjhola,Bhilwara,Rajasthan',
'Jitya,Bhilwara,Rajasthan',
'Jojwa,Bhilwara,Rajasthan',
'Joravarpura,Bhilwara,Rajasthan',
'Junawas,Bhilwara,Rajasthan',
'Kabradia,Bhilwara,Rajasthan',
'Kachola,Bhilwara,Rajasthan',
'Kadisahna,Bhilwara,Rajasthan',
'Kaliyas,Bhilwara,Rajasthan',
'Kalsans,Bhilwara,Rajasthan',
'Kalyanpura,Bhilwara,Rajasthan',
'Kanda,Bhilwara,Rajasthan',
'Kanechan Kalan,Bhilwara,Rajasthan',
'Kanechan Khurd,Bhilwara,Rajasthan',
'Kangani,Bhilwara,Rajasthan',
'Kankolia,Bhilwara,Rajasthan',
'Kankrolia,Bhilwara,Rajasthan',
'Karjaliya,Bhilwara,Rajasthan',
'Karoi CO,Bhilwara,Rajasthan',
'Kashipuri Bhilwara,Bhilwara,Rajasthan',
'Kasya Kala,Bhilwara,Rajasthan',
'Katar,Bhilwara,Rajasthan',
'Kavlas,Bhilwara,Rajasthan',
'Keriya,Bhilwara,Rajasthan',
'Khachrol,Bhilwara,Rajasthan',
'Khajuri,Bhilwara,Rajasthan',
'Khamore,Bhilwara,Rajasthan',
'Khankhala,Bhilwara,Rajasthan',
'Khankhermala,Bhilwara,Rajasthan',
'Khatwara,Bhilwara,Rajasthan',
'Khedela,Bhilwara,Rajasthan',
'Khedliya,Bhilwara,Rajasthan',
'Khejri,Bhilwara,Rajasthan',
'Khemana,Bhilwara,Rajasthan',
'Kherabad,Bhilwara,Rajasthan',
'Kheruna,Bhilwara,Rajasthan',
'Kidimal,Bhilwara,Rajasthan',
'Kishangarh,Bhilwara,Rajasthan',
'Kochoria,Bhilwara,Rajasthan',
'Kodu Kota,Bhilwara,Rajasthan',
'Koshithal,Bhilwara,Rajasthan',
'Kot,Bhilwara,Rajasthan',
'Kothaj,Bhilwara,Rajasthan',
'Kothian,Bhilwara,Rajasthan',
'Kotri Bhado Ki,Bhilwara,Rajasthan',
'Kotri,Bhilwara,Rajasthan',
'Krisi Upaj Mandi Bwa,Bhilwara,Rajasthan',
'Kundgate Shahpura,Bhilwara,Rajasthan',
'Kundia Kalan,Bhilwara,Rajasthan',
'Kunwar,Bhilwara,Rajasthan',
'Kuradia,Bhilwara,Rajasthan',
'Labour Colony,Bhilwara,Rajasthan',
'Lachura,Bhilwara,Rajasthan',
'Ladpura,Bhilwara,Rajasthan',
'Laduwas,Bhilwara,Rajasthan',
'Lakhola,Bhilwara,Rajasthan',
'Lamba Khari Ka,Bhilwara,Rajasthan',
'Lambia Kalan,Bhilwara,Rajasthan',
'Lambia Khurd,Bhilwara,Rajasthan',
'Lambia Station,Bhilwara,Rajasthan',
'Lasadia,Bhilwara,Rajasthan',
'Lasadiya,Bhilwara,Rajasthan',
'Leswa,Bhilwara,Rajasthan',
'Luharikala,Bhilwara,Rajasthan',
'Luhariya,Bhilwara,Rajasthan',
'Lulas,Bhilwara,Rajasthan',
'Mahendragarh,Bhilwara,Rajasthan',
'Mahuwa,Bhilwara,Rajasthan',
'Mahuwa,Bhilwara,Rajasthan',
'Mahuwakhurd,Bhilwara,Rajasthan',
'Majhawas,Bhilwara,Rajasthan',
'Makredi,Bhilwara,Rajasthan',
'Malka Khera,Bhilwara,Rajasthan',
'Malola,Bhilwara,Rajasthan',
'Mandal,Bhilwara,Rajasthan',
'Mandalgarh,Bhilwara,Rajasthan',
'Mangrop,Bhilwara,Rajasthan',
'Mangthala,Bhilwara,Rajasthan',
'Manoharpura,Bhilwara,Rajasthan',
'Manpura,Bhilwara,Rajasthan',
'Mansha,Bhilwara,Rajasthan',
'Marewada,Bhilwara,Rajasthan',
'Mata Ji Ka Khera,Bhilwara,Rajasthan',
'Megras,Bhilwara,Rajasthan',
'Meja,Bhilwara,Rajasthan',
'Mindolia,Bhilwara,Rajasthan',
'Mod Ka Nimbahera,Bhilwara,Rajasthan',
'Mogar,Bhilwara,Rajasthan',
'Mohanpura,Bhilwara,Rajasthan',
'Mokhunda,Bhilwara,Rajasthan',
'Motipur,Bhilwara,Rajasthan',
'Motras,Bhilwara,Rajasthan',
'Munshi,Bhilwara,Rajasthan',
'Nahari,Bhilwara,Rajasthan',
'Nandrai,Bhilwara,Rajasthan',
'Nandsha,Bhilwara,Rajasthan',
'Nandsha J,Bhilwara,Rajasthan',
'Narayan Khera,Bhilwara,Rajasthan',
'Nathdiyas,Bhilwara,Rajasthan',
'Naya Nagar,Bhilwara,Rajasthan',
'Negdia,Bhilwara,Rajasthan',
'Negdia Ka Khera,Bhilwara,Rajasthan',
'Nimbahera Jatan,Bhilwara,Rajasthan',
'Nimbahera Kalan,Bhilwara,Rajasthan',
'Ojayada,Bhilwara,Rajasthan',
'Ojhiyana,Bhilwara,Rajasthan',
'Palran,Bhilwara,Rajasthan',
'Palri,Bhilwara,Rajasthan',
'Pander,Bhilwara,Rajasthan',
'Pansal,Bhilwara,Rajasthan',
'Parasoli,Bhilwara,Rajasthan',
'Paroli,Bhilwara,Rajasthan',
'Patan,Bhilwara,Rajasthan',
'Phalamada,Bhilwara,Rajasthan',
'Phulia Kalan,Bhilwara,Rajasthan',
'Phulia Khurd,Bhilwara,Rajasthan',
'Pipli,Bhilwara,Rajasthan',
'Piplund,Bhilwara,Rajasthan',
'Pitha Ka Khera,Bhilwara,Rajasthan',
'Pithas,Bhilwara,Rajasthan',
'Potlan,Bhilwara,Rajasthan',
'Pur,Bhilwara,Rajasthan',
'Pura,Bhilwara,Rajasthan',
'Ragunathpura,Bhilwara,Rajasthan',
'Ragurajpura,Bhilwara,Rajasthan',
'Rahad,Bhilwara,Rajasthan',
'Railagaon,Bhilwara,Rajasthan',
'Railaroad,Bhilwara,Rajasthan',
'Raipur,Bhilwara,Rajasthan',
'Raja Ji Ka Kareda,Bhilwara,Rajasthan',
'Rajgarh,Bhilwara,Rajasthan',
'Rakshi,Bhilwara,Rajasthan',
'Ralayata,Bhilwara,Rajasthan',
'Rampura,Bhilwara,Rajasthan',
'Rampuria,Bhilwara,Rajasthan',
'Rampuria,Bhilwara,Rajasthan',
'Rased,Bhilwara,Rajasthan',
'Ratanpura,Bhilwara,Rajasthan',
'Rawatkhera,Bhilwara,Rajasthan',
'Redwas,Bhilwara,Rajasthan',
'Reeth,Bhilwara,Rajasthan',
'Richda,Bhilwara,Rajasthan',
'Rooppura,Bhilwara,Rajasthan',
'Ropan,Bhilwara,Rajasthan',
'Rupaheli,Bhilwara,Rajasthan',
'Rupaheli Khurd,Bhilwara,Rajasthan',
'Sahada,Bhilwara,Rajasthan',
'Salawatia,Bhilwara,Rajasthan',
'Salera,Bhilwara,Rajasthan',
'Sanganer,Bhilwara,Rajasthan',
'Sangari,Bhilwara,Rajasthan',
'Sangramgarh,Bhilwara,Rajasthan',
'Sangria,Bhilwara,Rajasthan',
'Sangriya,Bhilwara,Rajasthan',
'Sangwa,Bhilwara,Rajasthan',
'Sankda,Bhilwara,Rajasthan',
'Santokpura,Bhilwara,Rajasthan',
'Sarana,Bhilwara,Rajasthan',
'Sardarnagar,Bhilwara,Rajasthan',
'Sareri CO,Bhilwara,Rajasthan',
'Sarewadi,Bhilwara,Rajasthan',
'Sargaon,Bhilwara,Rajasthan',
'Sarsiya,Bhilwara,Rajasthan',
'Sarthala,Bhilwara,Rajasthan',
'Satliyas,Bhilwara,Rajasthan',
'Satola Ka Khera,Bhilwara,Rajasthan',
'Seedriyas,Bhilwara,Rajasthan',
'Sethuria,Bhilwara,Rajasthan',
'Shahpura Bazarndtso,Bhilwara,Rajasthan',
'Shahpura Raj,Bhilwara,Rajasthan',
'Shakkargarh,Bhilwara,Rajasthan',
'Shambhugarh,Bhilwara,Rajasthan',
'Shastri Nagar Gangapur,Bhilwara,Rajasthan',
'Shekhawas,Bhilwara,Rajasthan',
'Shivpur,Bhilwara,Rajasthan',
'Shivrati,Bhilwara,Rajasthan',
'Shyampura,Bhilwara,Rajasthan',
'Singoli,Bhilwara,Rajasthan',
'Sodar,Bhilwara,Rajasthan',
'Soniyana,Bhilwara,Rajasthan',
'Srinagar,Bhilwara,Rajasthan',
'Subhash Nagar-Bhilwara,Bhilwara,Rajasthan',
'Suras,Bhilwara,Rajasthan',
'Suras,Bhilwara,Rajasthan',
'Surawas,Bhilwara,Rajasthan',
'Suthepa,Bhilwara,Rajasthan',
'Suwana,Bhilwara,Rajasthan',
'Swaipur,Bhilwara,Rajasthan',
'Swaroopganj,Bhilwara,Rajasthan',
'Taswaria,Bhilwara,Rajasthan',
'Taswaria Khurd,Bhilwara,Rajasthan',
'Taswariya,Bhilwara,Rajasthan',
'Tehnal,Bhilwara,Rajasthan',
'Thala,Bhilwara,Rajasthan',
'Thala,Bhilwara,Rajasthan',
'Thana,Bhilwara,Rajasthan',
'Tharoda,Bhilwara,Rajasthan',
'Tikar,Bhilwara,Rajasthan',
'Tiliswa,Bhilwara,Rajasthan',
'Tiloli,Bhilwara,Rajasthan',
'Titoda,Bhilwara,Rajasthan',
'Titoda Tehla,Bhilwara,Rajasthan',
'Titodi,Bhilwara,Rajasthan',
'Tunka,Bhilwara,Rajasthan',
'Udliyas,Bhilwara,Rajasthan',
'Ullai,Bhilwara,Rajasthan',
'Ullela,Bhilwara,Rajasthan',
'Uma Ji Ka Kheda,Bhilwara,Rajasthan',
'Umari,Bhilwara,Rajasthan',
'Uncha,Bhilwara,Rajasthan',
'Upreda,Bhilwara,Rajasthan',
'Jalabsar,Bikaner,Rajasthan',
'Mithdiya,Bikaner,Rajasthan',
'Nathusar,Bikaner,Rajasthan',
'Sowa,Bikaner,Rajasthan',
'Sui,Bikaner,Rajasthan',
'17 K.Y.D.,Bikaner,Rajasthan',
'2 K.L.D.,Bikaner,Rajasthan',
'61 Head,Bikaner,Rajasthan',
'Aadsar,Bikaner,Rajasthan',
'Akasar,Bikaner,Rajasthan',
'Amarpura,Bikaner,Rajasthan',
'Ambasar,Bikaner,Rajasthan',
'Ankhisar,Bikaner,Rajasthan',
'Arjansar,Bikaner,Rajasthan',
'Bachasar,Bikaner,Rajasthan',
'Badela,Bikaner,Rajasthan',
'Badhnu,Bikaner,Rajasthan',
'Bagadsar,Bikaner,Rajasthan',
'Bainisar,Bikaner,Rajasthan',
'Bajju,Bikaner,Rajasthan',
'Baladesar,Bikaner,Rajasthan',
'Bamanwali,Bikaner,Rajasthan',
'Bambloo,Bikaner,Rajasthan',
'Bana,Bikaner,Rajasthan',
'Bandhra,Bikaner,Rajasthan',
'Bangalanagar,Bikaner,Rajasthan',
'Bapeu,Bikaner,Rajasthan',
'Barjangsar,Bikaner,Rajasthan',
'Barsalpur,Bikaner,Rajasthan',
'Barsingsar,Bikaner,Rajasthan',
'Beejhansar,Bikaner,Rajasthan',
'Beekasar,Bikaner,Rajasthan',
'Belasar,Bikaner,Rajasthan',
'Berasar,Bikaner,Rajasthan',
'Bhalda,Bikaner,Rajasthan',
'Bhaluri,Bikaner,Rajasthan',
'Bhamatsar,Bikaner,Rajasthan',
'Bhanekagaon,Bikaner,Rajasthan',
'Bheloo,Bikaner,Rajasthan',
'Bhikhnera,Bikaner,Rajasthan',
'Bhinasar,Bikaner,Rajasthan',
'Bholasar Budhan,Bikaner,Rajasthan',
'Bichhwal Ind.Area,Bikaner,Rajasthan',
'Bigga,Bikaner,Rajasthan',
'Biggabas Ramsara,Bikaner,Rajasthan',
'Bijeri,Bikaner,Rajasthan',
'Bikampur,Bikaner,Rajasthan',
'Bikaner City,Bikaner,Rajasthan',
'Bikaner H.O,Bikaner,Rajasthan',
'Bikaner Kutchery,Bikaner,Rajasthan',
'Bithnok,Bikaner,Rajasthan',
'Chak 8 Kyd,Bikaner,Rajasthan',
'Chani,Bikaner,Rajasthan',
'Charkra,Bikaner,Rajasthan',
'Chhatararh,Bikaner,Rajasthan',
'Chitana,Bikaner,Rajasthan',
'D.ffice,Bikaner,Rajasthan',
'Dandi,Bikaner,Rajasthan',
'Dantaur,Bikaner,Rajasthan',
'Dasori,Bikaner,Rajasthan',
'Dawa,Bikaner,Rajasthan',
'Delitalai,Bikaner,Rajasthan',
'Delwan,Bikaner,Rajasthan',
'Derajsar,Bikaner,Rajasthan',
'Desalsar,Bikaner,Rajasthan',
'Deshnoke,Bikaner,Rajasthan',
'Dhaneru,Bikaner,Rajasthan',
'Dharnok,Bikaner,Rajasthan',
'Dheerdesar Chotiyan,Bikaner,Rajasthan',
'Dheerera R.S.,Bikaner,Rajasthan',
'Dheerera Village,Bikaner,Rajasthan',
'Dhingsari,Bikaner,Rajasthan',
'Dhoopaliya,Bikaner,Rajasthan',
'Diyatra,Bikaner,Rajasthan',
'Dulchasar,Bikaner,Rajasthan',
'Dulmera,Bikaner,Rajasthan',
'Dungar College,Bikaner,Rajasthan',
'Dusarna,Bikaner,Rajasthan',
'Gadhwala,Bikaner,Rajasthan',
'Gajroopdesar,Bikaner,Rajasthan',
'Gajsukhdesar,Bikaner,Rajasthan',
'Gangashahar,Bikaner,Rajasthan',
'Garabdesar,Bikaner,Rajasthan',
'Gariyala,Bikaner,Rajasthan',
'Gersar,Bikaner,Rajasthan',
'Ghatoo,Bikaner,Rajasthan',
'Girajsar,Bikaner,Rajasthan',
'Godoo,Bikaner,Rajasthan',
'Gogariyawala,Bikaner,Rajasthan',
'Gondusar,Bikaner,Rajasthan',
'Grandhi,Bikaner,Rajasthan',
'Gura,Bikaner,Rajasthan',
'Gusainsar,Bikaner,Rajasthan',
'Gusainsar,Bikaner,Rajasthan',
'Hadan,Bikaner,Rajasthan',
'Hadlan Bhatiyan,Bikaner,Rajasthan',
'Hansasar,Bikaner,Rajasthan',
'Hansera,Bikaner,Rajasthan',
'Himatsar,Bikaner,Rajasthan',
'Hiyadesar,Bikaner,Rajasthan',
'Indpalsar,Bikaner,Rajasthan',
'Jaimalsar,Bikaner,Rajasthan',
'Jaisalsar,Bikaner,Rajasthan',
'Jaisingdesar,Bikaner,Rajasthan',
'Jaitpur,Bikaner,Rajasthan',
'Jakhasar,Bikaner,Rajasthan',
'Jalwali,Bikaner,Rajasthan',
'Jamsar,Bikaner,Rajasthan',
'Jangloo,Bikaner,Rajasthan',
'Jasrasar,Bikaner,Rajasthan',
'Jesalsar,Bikaner,Rajasthan',
'Jetasar,Bikaner,Rajasthan',
'Jhadeli,Bikaner,Rajasthan',
'Jodhasar,Bikaner,Rajasthan',
'Kakoo,Bikaner,Rajasthan',
'Kakra,Bikaner,Rajasthan',
'Kalasar,Bikaner,Rajasthan',
'Kalu,Bikaner,Rajasthan',
'Kalubas,Bikaner,Rajasthan',
'Kalyansar,Bikaner,Rajasthan',
'Kanasar,Bikaner,Rajasthan',
'Kankarwala,Bikaner,Rajasthan',
'Kapoorisar,Bikaner,Rajasthan',
'Karamwala,Bikaner,Rajasthan',
'Karnisar Bhatiyan,Bikaner,Rajasthan',
'Kawani,Bikaner,Rajasthan',
'Keetasar,Bikaner,Rajasthan',
'Kelan,Bikaner,Rajasthan',
'Kesardesarjatan,Bikaner,Rajasthan',
'Keu,Bikaner,Rajasthan',
'Khajuwala,Bikaner,Rajasthan',
'Khara,Bikaner,Rajasthan',
'Kharbara,Bikaner,Rajasthan',
'Kharda,Bikaner,Rajasthan',
'Khari Charnan,Bikaner,Rajasthan',
'Khindasar,Bikaner,Rajasthan',
'Khinyera,Bikaner,Rajasthan',
'Khokhrana,Bikaner,Rajasthan',
'Kisnasar,Bikaner,Rajasthan',
'Kolasar,Bikaner,Rajasthan',
'Koo Dsoo,Bikaner,Rajasthan',
'Kotegate,Bikaner,Rajasthan',
'Kotri,Bikaner,Rajasthan',
'Kuchor Aguni,Bikaner,Rajasthan',
'Kuchor Athuni,Bikaner,Rajasthan',
'Kumbhasariya,Bikaner,Rajasthan',
'Kunpalsar,Bikaner,Rajasthan',
'Kuntasar,Bikaner,Rajasthan',
'Lakhasar,Bikaner,Rajasthan',
'Lakhusar,Bikaner,Rajasthan',
'Lalamdesar Bara,Bikaner,Rajasthan',
'Lalgarh Road,Bikaner,Rajasthan',
'Lalkar,Bikaner,Rajasthan',
'Lalmdesar,Bikaner,Rajasthan',
'Likhmadesar,Bikaner,Rajasthan',
'Likhmisar,Bikaner,Rajasthan',
'Loonkhan,Bikaner,Rajasthan',
'M.G.Road,Bikaner,Rajasthan',
'Madh,Bikaner,Rajasthan',
'Mahadevwali,Bikaner,Rajasthan',
'Mainsar,Bikaner,Rajasthan',
'Malasar,Bikaner,Rajasthan',
'Malkisar,Bikaner,Rajasthan',
'Manakarasar,Bikaner,Rajasthan',
'Mankasar,Bikaner,Rajasthan',
'Mansoori,Bikaner,Rajasthan',
'Migsariya,Bikaner,Rajasthan',
'Mithriya,Bikaner,Rajasthan',
'Mohta Chowk,Bikaner,Rajasthan',
'Momasar,Bikaner,Rajasthan',
'Moondar,Bikaner,Rajasthan',
'Moondsar,Bikaner,Rajasthan',
'Morkhana Athuna,Bikaner,Rajasthan',
'Motigarh,Bikaner,Rajasthan',
'Nagrasar,Bikaner,Rajasthan',
'Nal Bari,Bikaner,Rajasthan',
'Napasar,Bikaner,Rajasthan',
'Nathwana,Bikaner,Rajasthan',
'Nokha Villege,Bikaner,Rajasthan',
'Nokhara,Bikaner,Rajasthan',
'Norangdesar,Bikaner,Rajasthan',
'Pabubari,Bikaner,Rajasthan',
'Panchoo,Bikaner,Rajasthan',
'Parwa,Bikaner,Rajasthan',
'Pawanpuri,Bikaner,Rajasthan',
'Phulasar Khurd,Bikaner,Rajasthan',
'Poogal,Bikaner,Rajasthan',
'Pundalsar,Bikaner,Rajasthan',
'Punrasar,Bikaner,Rajasthan',
'Railway Workshop,Bikaner,Rajasthan',
'Raisar,Bikaner,Rajasthan',
'Raj.Krishi Vishwavidhyalaya,Bikaner,Rajasthan',
'Rajasar Bhatiyan,Bikaner,Rajasthan',
'Rajasar Karnisar,Bikaner,Rajasthan',
'Rajedoo,Bikaner,Rajasthan',
'Rambag,Bikaner,Rajasthan',
'Ramsar,Bikaner,Rajasthan',
'Raner,Bikaner,Rajasthan',
'Rani Bazar,Bikaner,Rajasthan',
'Ranjeetpura,Bikaner,Rajasthan',
'Rasisar,Bikaner,Rajasthan',
'Rawansar,Bikaner,Rajasthan',
'Rcp Colony,Bikaner,Rajasthan',
'Ridmalsar,Bikaner,Rajasthan',
'Rojan,Bikaner,Rajasthan',
'Rora,Bikaner,Rajasthan',
'Runiya Bara Bas,Bikaner,Rajasthan',
'Sadhasar,Bikaner,Rajasthan',
'Sadhoona,Bikaner,Rajasthan',
'Sadul Colony,Bikaner,Rajasthan',
'Sahjrasar,Bikaner,Rajasthan',
'Saisar,Bikaner,Rajasthan',
'Sanwatsar,Bikaner,Rajasthan',
'Saroopdesar,Bikaner,Rajasthan',
'Sarunda,Bikaner,Rajasthan',
'Satasar,Bikaner,Rajasthan',
'Seeniwala,Bikaner,Rajasthan',
'Serera,Bikaner,Rajasthan',
'Shekhsar,Bikaner,Rajasthan',
'Sherpura,Bikaner,Rajasthan',
'Sheruna,Bikaner,Rajasthan',
'Shiv Bari,Bikaner,Rajasthan',
'Shri Dungargarh,Bikaner,Rajasthan',
'Sinjguru,Bikaner,Rajasthan',
'Sinthal,Bikaner,Rajasthan',
'Sitla Gate,Bikaner,Rajasthan',
'Siyana Bhatiyana,Bikaner,Rajasthan',
'Siyasar Panchkosa,Bikaner,Rajasthan',
'Siyasarchogan,Bikaner,Rajasthan',
'Sodhwali,Bikaner,Rajasthan',
'Somalsar,Bikaner,Rajasthan',
'Soniyasar,Bikaner,Rajasthan',
'Sri Kolayat Ji,Bikaner,Rajasthan',
'Station Road,Bikaner,Rajasthan',
'Sudsar,Bikaner,Rajasthan',
'Surdhana Chauhanan,Bikaner,Rajasthan',
'Surjansar,Bikaner,Rajasthan',
'Surjara,Bikaner,Rajasthan',
'Surnana,Bikaner,Rajasthan',
'Surpura,Bikaner,Rajasthan',
'Takhatpura,Bikaner,Rajasthan',
'Tejrasar,Bikaner,Rajasthan',
'Thakariyasar,Bikaner,Rajasthan',
'Thawariya,Bikaner,Rajasthan',
'Toliyasar,Bikaner,Rajasthan',
'Udairamsar,Bikaner,Rajasthan',
'Udasar,Bikaner,Rajasthan',
'Udasar,Bikaner,Rajasthan',
'Udrasar,Bikaner,Rajasthan',
'Udsar,Bikaner,Rajasthan',
'Upni,Bikaner,Rajasthan',
'Utmamdesar,Bikaner,Rajasthan',
'Saloondiya,Bikaner,Rajasthan',
'Lunkaransar,Bikaner,Rajasthan',
'Mahajan,Bikaner,Rajasthan',
'Nokha,Bikaner,Rajasthan',
'Basni,Tonk,Rajasthan',
'Abar,Tonk,Rajasthan',
'Ajanda,Tonk,Rajasthan',
'Ajeta,Tonk,Rajasthan',
'Akoda,Tonk,Rajasthan',
'Alod,Tonk,Rajasthan',
'Alphanagar,Tonk,Rajasthan',
'Amli,Tonk,Rajasthan',
'Anghora,Tonk,Rajasthan',
'Antarda,Tonk,Rajasthan',
'Anthada,Tonk,Rajasthan',
'Arnetha,Tonk,Rajasthan',
'Babai,Tonk,Rajasthan',
'Bachola,Tonk,Rajasthan',
'Bada Kheda,Tonk,Rajasthan',
'Badodiya,Tonk,Rajasthan',
'Bajar,Tonk,Rajasthan',
'Balapura,Tonk,Rajasthan',
'Balban,Tonk,Rajasthan',
'Balchand Para Bundi,Tonk,Rajasthan',
'Balkasa,Tonk,Rajasthan',
'Ballop,Tonk,Rajasthan',
'Bamangaon,Tonk,Rajasthan',
'Bamori,Tonk,Rajasthan',
'Bansi,Tonk,Rajasthan',
'Baranaya Gaon,Tonk,Rajasthan',
'Barundhan,Tonk,Rajasthan',
'Basoli,Tonk,Rajasthan',
'Baswada,Tonk,Rajasthan',
'Bhajneri,Tonk,Rajasthan',
'Bhawanipura,Tonk,Rajasthan',
'Bherupura Antri,Tonk,Rajasthan',
'Bherupura Ojhha,Tonk,Rajasthan',
'Bhiya,Tonk,Rajasthan',
'Borda,Tonk,Rajasthan',
'Borda Kachhiyan,Tonk,Rajasthan',
'Borkhandi,Tonk,Rajasthan',
'Budhpura,Tonk,Rajasthan',
'Bundi H.O,Tonk,Rajasthan',
'Chainpuria,Tonk,Rajasthan',
'Chanda Khurd,Tonk,Rajasthan',
'Chardana,Tonk,Rajasthan',
'Chatarganj,Tonk,Rajasthan',
'Phulwara,Sawaimadhopur,Rajasthan',
'Sanet,Sawaimadhopur,Rajasthan',
'Shantiveer Nagar,Sawaimadhopur,Rajasthan',
'Sherpur,Sawaimadhopur,Rajasthan',
'Shri Mahaveerji R S,Sawaimadhopur,Rajasthan',
'Shrimahaveerji,Sawaimadhopur,Rajasthan',
'Sikroda Meena,Sawaimadhopur,Rajasthan',
'Somla,Sawaimadhopur,Rajasthan',
'Station Road Hindaun,Sawaimadhopur,Rajasthan',
'Todupura,Sawaimadhopur,Rajasthan',
'Vajeda,Sawaimadhopur,Rajasthan',
'Vajna Kalan,Sawaimadhopur,Rajasthan',
'Vijaypura,Sawaimadhopur,Rajasthan',
'Rajor,Sawaimadhopur,Rajasthan',
'Ata,Sawaimadhopur,Rajasthan',
'Ateiwa,Sawaimadhopur,Rajasthan',
'Bariya,Sawaimadhopur,Rajasthan',
'Barkheda,Sawaimadhopur,Rajasthan',
'Bhawali,Sawaimadhopur,Rajasthan',
'Bijalpur,Sawaimadhopur,Rajasthan',
'Chainpur,Sawaimadhopur,Rajasthan',
'Chhabar,Sawaimadhopur,Rajasthan',
'Court Karauli,Sawaimadhopur,Rajasthan',
'Dhanda,Sawaimadhopur,Rajasthan',
'Fatehpur,Sawaimadhopur,Rajasthan',
'Gadholi,Sawaimadhopur,Rajasthan',
'Gairai,Sawaimadhopur,Rajasthan',
'Gubreda,Sawaimadhopur,Rajasthan',
'Gudla,Sawaimadhopur,Rajasthan',
'Gunesera,Sawaimadhopur,Rajasthan',
'Harnagar,Sawaimadhopur,Rajasthan',
'Jahangirpur,Sawaimadhopur,Rajasthan',
'Jamura,Sawaimadhopur,Rajasthan',
'Kailadevi,Sawaimadhopur,Rajasthan',
'Kalyani,Sawaimadhopur,Rajasthan',
'Kanchanpura,Sawaimadhopur,Rajasthan',
'Karauli,Sawaimadhopur,Rajasthan',
'Karsai,Sawaimadhopur,Rajasthan',
'Kashipura,Sawaimadhopur,Rajasthan',
'Khedia,Sawaimadhopur,Rajasthan',
'Khohri,Sawaimadhopur,Rajasthan',
'Khoobnagar,Sawaimadhopur,Rajasthan',
'Khunda,Sawaimadhopur,Rajasthan',
'Kondar,Sawaimadhopur,Rajasthan',
'Kota,Sawaimadhopur,Rajasthan',
'Lohara,Sawaimadhopur,Rajasthan',
'Maholi,Sawaimadhopur,Rajasthan',
'Makanpur,Sawaimadhopur,Rajasthan',
'Manchi,Sawaimadhopur,Rajasthan',
'Mandakheda,Sawaimadhopur,Rajasthan',
'Masalpur,Sawaimadhopur,Rajasthan',
'Narayana,Sawaimadhopur,Rajasthan',
'Parita,Sawaimadhopur,Rajasthan',
'Phoota Kot Karauli,Sawaimadhopur,Rajasthan',
'Pipalpura,Sawaimadhopur,Rajasthan',
'Raghuvanshi,Sawaimadhopur,Rajasthan',
'Rampur Dhabai,Sawaimadhopur,Rajasthan',
'Ratiyapura,Sawaimadhopur,Rajasthan',
'Rondkala,Sawaimadhopur,Rajasthan',
'Rundh Ka Pura,Sawaimadhopur,Rajasthan',
'Saingarpura,Sawaimadhopur,Rajasthan',
'Saiypur,Sawaimadhopur,Rajasthan',
'Samerda,Sawaimadhopur,Rajasthan',
'Sasedi,Sawaimadhopur,Rajasthan',
'Siloti,Sawaimadhopur,Rajasthan',
'Sunderpura,Sawaimadhopur,Rajasthan',
'Suroth,Sawaimadhopur,Rajasthan',
'Tali,Sawaimadhopur,Rajasthan',
'Tulsipura,Sawaimadhopur,Rajasthan',
'Aound,Sawaimadhopur,Rajasthan',
'Bhankari,Sawaimadhopur,Rajasthan',
'Bugdar,Sawaimadhopur,Rajasthan',
'Chandelipura,Sawaimadhopur,Rajasthan',
'Dhoreta,Sawaimadhopur,Rajasthan',
'Gurda,Sawaimadhopur,Rajasthan',
'Kased,Sawaimadhopur,Rajasthan',
'Langra,Sawaimadhopur,Rajasthan',
'Mandrail,Sawaimadhopur,Rajasthan',
'Mongepura,Sawaimadhopur,Rajasthan',
'Ninder,Sawaimadhopur,Rajasthan',
'Pancholi,Sawaimadhopur,Rajasthan',
'Ranipura,Sawaimadhopur,Rajasthan',
'Rodhai,Sawaimadhopur,Rajasthan',
'Badagaon,Sawaimadhopur,Rajasthan',
'Badasawata,Sawaimadhopur,Rajasthan',
'Bagor,Sawaimadhopur,Rajasthan',
'Bardala,Sawaimadhopur,Rajasthan',
'Bhilapada,Sawaimadhopur,Rajasthan',
'Chainpura,Sawaimadhopur,Rajasthan',
'Chirawada,Sawaimadhopur,Rajasthan',
'Daharia,Sawaimadhopur,Rajasthan',
'Dalpura,Sawaimadhopur,Rajasthan',
'Dholeta,Sawaimadhopur,Rajasthan',
'Garhkheda,Sawaimadhopur,Rajasthan',
'Garhmoran,Sawaimadhopur,Rajasthan',
'Gudhachandraji,Sawaimadhopur,Rajasthan',
'Jahira,Sawaimadhopur,Rajasthan',
'Jirna,Sawaimadhopur,Rajasthan',
'Jitkipur,Sawaimadhopur,Rajasthan',
'Kamalpura,Sawaimadhopur,Rajasthan',
'Kema,Sawaimadhopur,Rajasthan',
'Kemla,Sawaimadhopur,Rajasthan',
'Kemri,Sawaimadhopur,Rajasthan',
'Kheda Malupada,Sawaimadhopur,Rajasthan',
'Kunjela,Sawaimadhopur,Rajasthan',
'Lawad,Sawaimadhopur,Rajasthan',
'Mohanpura,Sawaimadhopur,Rajasthan',
'Nadoti,Sawaimadhopur,Rajasthan',
'Pal,Sawaimadhopur,Rajasthan',
'Rajaheda,Sawaimadhopur,Rajasthan',
'Rajpura,Sawaimadhopur,Rajasthan',
'Raysana,Sawaimadhopur,Rajasthan',
'Ronsi,Sawaimadhopur,Rajasthan',
'Salavad,Sawaimadhopur,Rajasthan',
'Shahar,Sawaimadhopur,Rajasthan',
'Sop,Sawaimadhopur,Rajasthan',
'Talawada,Sawaimadhopur,Rajasthan',
'Tesgaon,Sawaimadhopur,Rajasthan',
'Timawa,Sawaimadhopur,Rajasthan',
'Amargarh Dang,Sawaimadhopur,Rajasthan',
'Amarwad,Sawaimadhopur,Rajasthan',
'Bagida,Sawaimadhopur,Rajasthan',
'Bahadurpur,Sawaimadhopur,Rajasthan',
'Bajna,Sawaimadhopur,Rajasthan',
'Baloti,Sawaimadhopur,Rajasthan',
'Baroda Gajrajpal,Sawaimadhopur,Rajasthan',
'Bhartun,Sawaimadhopur,Rajasthan',
'Bukna,Sawaimadhopur,Rajasthan',
'Chauragon,Sawaimadhopur,Rajasthan',
'Daulatpura,Sawaimadhopur,Rajasthan',
'Eaket,Sawaimadhopur,Rajasthan',
'Fatehpur,Sawaimadhopur,Rajasthan',
'Gothra,Sawaimadhopur,Rajasthan',
'Hadoti,Sawaimadhopur,Rajasthan',
'Inayati,Sawaimadhopur,Rajasthan',
'Jakhoda,Sawaimadhopur,Rajasthan',
'Jirota,Sawaimadhopur,Rajasthan',
'Jiwatkheda,Sawaimadhopur,Rajasthan',
'Jodli,Sawaimadhopur,Rajasthan',
'Kachroda,Sawaimadhopur,Rajasthan',
'Kalyanpura,Sawaimadhopur,Rajasthan',
'Karanpur,Sawaimadhopur,Rajasthan',
'Kherla,Sawaimadhopur,Rajasthan',
'Khidarpur,Sawaimadhopur,Rajasthan',
'Kishorpura,Sawaimadhopur,Rajasthan',
'Kurgaon,Sawaimadhopur,Rajasthan',
'Ledia,Sawaimadhopur,Rajasthan',
'Luloj,Sawaimadhopur,Rajasthan',
'Mandawra,Sawaimadhopur,Rajasthan',
'Marmada,Sawaimadhopur,Rajasthan',
'Masawata,Sawaimadhopur,Rajasthan',
'Mehmedpur,Sawaimadhopur,Rajasthan',
'Nanpur,Sawaimadhopur,Rajasthan',
'Narauli Dang,Sawaimadhopur,Rajasthan',
'Nibhera,Sawaimadhopur,Rajasthan',
'Nimoda R S,Sawaimadhopur,Rajasthan',
'Ramthara,Sawaimadhopur,Rajasthan',
'Sapotara,Sawaimadhopur,Rajasthan',
'Shaikhpura,Sawaimadhopur,Rajasthan',
'Vapoti,Sawaimadhopur,Rajasthan',
'Dabra,Sawaimadhopur,Rajasthan',
'Toda,Sawaimadhopur,Rajasthan',
'Ajijpur,Sawaimadhopur,Rajasthan',
'Badleta Khurd,Sawaimadhopur,Rajasthan',
'Balghat,Sawaimadhopur,Rajasthan',
'Bhaisa,Sawaimadhopur,Rajasthan',
'Bhajeda,Sawaimadhopur,Rajasthan',
'Bhanakpura,Sawaimadhopur,Rajasthan',
'Bhandari Anduruni,Sawaimadhopur,Rajasthan',
'Bhopar,Sawaimadhopur,Rajasthan',
'Bonl,Sawaimadhopur,Rajasthan',
'Dadanpur,Sawaimadhopur,Rajasthan',
'Dhawan,Sawaimadhopur,Rajasthan',
'Dorawali,Sawaimadhopur,Rajasthan',
'Ghatabalaji,Sawaimadhopur,Rajasthan',
'Gorda,Sawaimadhopur,Rajasthan',
'Jhadisa,Sawaimadhopur,Rajasthan',
'Jonl,Sawaimadhopur,Rajasthan',
'Kanjoli,Sawaimadhopur,Rajasthan',
'Kariri,Sawaimadhopur,Rajasthan',
'Katara Ajij,Sawaimadhopur,Rajasthan',
'Khedi,Sawaimadhopur,Rajasthan',
'Kherli Gurjar,Sawaimadhopur,Rajasthan',
'Khohra,Sawaimadhopur,Rajasthan',
'Khudawal,Sawaimadhopur,Rajasthan',
'Lapawali,Sawaimadhopur,Rajasthan',
'Machadi,Sawaimadhopur,Rajasthan',
'Maheswa,Sawaimadhopur,Rajasthan',
'Manderu,Sawaimadhopur,Rajasthan',
'Mannauj,Sawaimadhopur,Rajasthan',
'Matasula,Sawaimadhopur,Rajasthan',
'Mirzapur,Sawaimadhopur,Rajasthan',
'Mohammedpur,Sawaimadhopur,Rajasthan',
'Morda,Sawaimadhopur,Rajasthan',
'Mundia,Sawaimadhopur,Rajasthan',
'Nangal Lat,Sawaimadhopur,Rajasthan',
'Nangal Pahadi,Sawaimadhopur,Rajasthan',
'Nisura,Sawaimadhopur,Rajasthan',
'Padampura,Sawaimadhopur,Rajasthan',
'Pahadi,Sawaimadhopur,Rajasthan',
'Pahadiyanagar,Sawaimadhopur,Rajasthan',
'Parla Khalsa,Sawaimadhopur,Rajasthan',
'Patoli,Sawaimadhopur,Rajasthan',
'Ranoli,Sawaimadhopur,Rajasthan',
'Salempur,Sawaimadhopur,Rajasthan',
'Sankarwada,Sawaimadhopur,Rajasthan',
'Shahrakhar,Sawaimadhopur,Rajasthan',
'Shekhpura,Sawaimadhopur,Rajasthan',
'Singhania,Sawaimadhopur,Rajasthan',
'Thigharia,Sawaimadhopur,Rajasthan',
'Todabhim,Sawaimadhopur,Rajasthan',
'Urden,Sawaimadhopur,Rajasthan',
'Ayana,Kota,Rajasthan',
'Ayani,Kota,Rajasthan',
'Durjanpura,Kota,Rajasthan',
'Jaloda Khatian,Kota,Rajasthan',
'Laxmi Pura,Kota,Rajasthan',
'Luhawad,Kota,Rajasthan',
'Mandeeta,Kota,Rajasthan',
'Bapawar,Kota,Rajasthan',
'Khedia,Kota,Rajasthan',
'Labaniya,Kota,Rajasthan',
'Laturi,Kota,Rajasthan',
'Moi Kalan,Kota,Rajasthan',
'Sulia,Kota,Rajasthan',
'Aamli,Kota,Rajasthan',
'Aditya Nagar,Kota,Rajasthan',
'Alod,Kota,Rajasthan',
'Amarpura,Kota,Rajasthan',
'Anwan,Kota,Rajasthan',
'Aralia Jagir,Kota,Rajasthan',
'Aran Kheda,Kota,Rajasthan',
'Arjunpura,Kota,Rajasthan',
'Bagli,Kota,Rajasthan',
'Baluheda,Kota,Rajasthan',
'Balupa,Kota,Rajasthan',
'Bambolia Kalan,Kota,Rajasthan',
'Bambori,Kota,Rajasthan',
'Banethia,Kota,Rajasthan',
'Baniani,Kota,Rajasthan',
'Bansya,Kota,Rajasthan',
'Bapawar,Kota,Rajasthan',
'Barod,Kota,Rajasthan',
'Barodia Kalan,Kota,Rajasthan',
'Bhanda Heda,Kota,Rajasthan',
'Bhanwaria,Kota,Rajasthan',
'Bhaura,Kota,Rajasthan',
'Binayaka,Kota,Rajasthan',
'Borabas,Kota,Rajasthan',
'Borda,Kota,Rajasthan',
'Borina Kalan,Kota,Rajasthan',
'Borkheda,Kota,Rajasthan',
'Budh Khan,Kota,Rajasthan',
'Budha Deet,Kota,Rajasthan',
'Cable Nagar,Kota,Rajasthan',
'Chechat,Kota,Rajasthan',
'Chhapol,Kota,Rajasthan',
'Chhawni Ram Chandra Pura,Kota,Rajasthan',
'Choma Malian,Kota,Rajasthan',
'Dadwara Colony Kota,Kota,Rajasthan',
'Darrah,Kota,Rajasthan',
'Deoli,Kota,Rajasthan',
'Deoli,Kota,Rajasthan',
'Deoli Khurd,Kota,Rajasthan',
'Dhaba,Kota,Rajasthan',
'Dhakadkhedi,Kota,Rajasthan',
'Dhani Kasar,Kota,Rajasthan',
'Dhanwa,Kota,Rajasthan',
'Dhipari,Kota,Rajasthan',
'Dhoti,Kota,Rajasthan',
'Dhulet,Kota,Rajasthan',
'Digod,Kota,Rajasthan',
'Digod,Kota,Rajasthan',
'Dolya,Kota,Rajasthan',
'Dungarja,Kota,Rajasthan',
'Engineering College Kota,Kota,Rajasthan',
'Gadepan,Kota,Rajasthan',
'Gainta,Kota,Rajasthan',
'Gandiphali,Kota,Rajasthan',
'Ganeshganj,Kota,Rajasthan',
'Ghanta Ghar Kota,Kota,Rajasthan',
'Ghatoli,Kota,Rajasthan',
'Girdharpura,Kota,Rajasthan',
'Golana,Kota,Rajasthan',
'Golya Hedi,Kota,Rajasthan',
'Gopalpura,Kota,Rajasthan',
'Goyanda,Kota,Rajasthan',
'Gumanpura Kota,Kota,Rajasthan',
'Haripura,Kota,Rajasthan',
'Hatiya Kheri,Kota,Rajasthan',
'Hingi,Kota,Rajasthan',
'Hingonia,Kota,Rajasthan',
'Indira Gamdhi Nagar Kota,Kota,Rajasthan',
'Industerial Estate Kota,Kota,Rajasthan',
'Itawa,Kota,Rajasthan',
'Jakhora,Kota,Rajasthan',
'Jatwada,Kota,Rajasthan',
'Jhargaon,Kota,Rajasthan',
'Jorawarpura,Kota,Rajasthan',
'Julmi,Kota,Rajasthan',
'Kaithun,Kota,Rajasthan',
'Kaithuni Pole Kota,Kota,Rajasthan',
'Kakrawada,Kota,Rajasthan',
'Kamalpura,Kota,Rajasthan',
'Kamolar,Kota,Rajasthan',
'Kanwas,Kota,Rajasthan',
'Karwad,Kota,Rajasthan',
'Khairabad,Kota,Rajasthan',
'Khajuri,Kota,Rajasthan',
'Khandgaon,Kota,Rajasthan',
'Kharula,Kota,Rajasthan',
'Khatoli,Kota,Rajasthan',
'Kheemuch,Kota,Rajasthan',
'Kherdarasoolpur,Kota,Rajasthan',
'Kherli,Kota,Rajasthan',
'Kherli Tanwaran,Kota,Rajasthan',
'Khurad,Kota,Rajasthan',
'Khyawada,Kota,Rajasthan',
'Kishan Pura Takiya,Kota,Rajasthan',
'Kishanpura,Kota,Rajasthan',
'Kishorepura,Kota,Rajasthan',
'Kota City,Kota,Rajasthan',
'Kota H.O,Kota,Rajasthan',
'Kota Ho,Kota,Rajasthan',
'Kota Jn.,Kota,Rajasthan',
'Kota Kutchery,Kota,Rajasthan',
'Kotari Gordhanpura Kota,Kota,Rajasthan',
'Kotradeep Singh,Kota,Rajasthan',
'Kotsuan,Kota,Rajasthan',
'Kudaila,Kota,Rajasthan',
'Kukra Khurd,Kota,Rajasthan',
'Kumbhkot,Kota,Rajasthan',
'Kunadanpur,Kota,Rajasthan',
'Kunadi Kota,Kota,Rajasthan',
'Kuradia,Kota,Rajasthan',
'Lakh Sanija,Kota,Rajasthan',
'Mahaveer Nagar Kota,Kota,Rajasthan',
'Mamore,Kota,Rajasthan',
'Manasgaon,Kota,Rajasthan',
'Mandana,Kota,Rajasthan',
'Mandanpura,Kota,Rajasthan',
'Mandap,Kota,Rajasthan',
'Mandawara,Kota,Rajasthan',
'Mandlya,Kota,Rajasthan',
'Mawasa,Kota,Rajasthan',
'Miyana,Kota,Rajasthan',
'Morak Gaon,Kota,Rajasthan',
'Morak,Kota,Rajasthan',
'Morpa,Kota,Rajasthan',
'Nanta,Kota,Rajasthan',
'Nautara,Kota,Rajasthan',
'Naya Nohra,Kota,Rajasthan',
'Nayapura Kota,Kota,Rajasthan',
'New Railway Colony Kota,Kota,Rajasthan',
'Ngm Ho Kota H.O,Kota,Rajasthan',
'Ngm Ho Kota,Kota,Rajasthan',
'Nimoda,Kota,Rajasthan',
'Nimola,Kota,Rajasthan',
'Nonera,Kota,Rajasthan',
'P.I.P. Kota,Kota,Rajasthan',
'Parlia,Kota,Rajasthan',
'Pipa Khedi,Kota,Rajasthan',
'Piplda,Kota,Rajasthan',
'Polai Kalan,Kota,Rajasthan',
'Pushod,Kota,Rajasthan',
'Rajopa,Kota,Rajasthan',
'Ram Ganj Mandi Bazar,Kota,Rajasthan',
'Ram Ganj Mandi,Kota,Rajasthan',
'Ranodia,Kota,Rajasthan',
'Ranpur,Kota,Rajasthan',
'Rel,Kota,Rajasthan',
'Rolana,Kota,Rajasthan',
'Ruddha Kheda,Kota,Rajasthan',
'Salawad Khurd,Kota,Rajasthan',
'Sangod,Kota,Rajasthan',
'Sarota,Kota,Rajasthan',
'Satal Khedi,Kota,Rajasthan',
'Sawan Bhadon,Kota,Rajasthan',
'Shahnawda,Kota,Rajasthan',
'Shoppin Centre Kota,Kota,Rajasthan',
'Shyampura,Kota,Rajasthan',
'Simlia,Kota,Rajasthan',
'Small Ind.Estate Kota,Kota,Rajasthan',
'Sogaria,Kota,Rajasthan',
'Subhash Marg Kota,Kota,Rajasthan',
'Subzi Mandi Kota,Kota,Rajasthan',
'Suhana,Kota,Rajasthan',
'Suket,Kota,Rajasthan',
'Sultanpur,Kota,Rajasthan',
'Suraj Pole Kota,Kota,Rajasthan',
'Takarwada,Kota,Rajasthan',
'Talab,Kota,Rajasthan',
'Talwandi Kota,Kota,Rajasthan',
'Tathed,Kota,Rajasthan',
'Thermal Colony Kota,Kota,Rajasthan',
'Toran,Kota,Rajasthan',
'Udyog Puri Kota,Kota,Rajasthan',
'Ukalda,Kota,Rajasthan',
'Umedpura,Kota,Rajasthan',
'Ummedpura,Kota,Rajasthan',
'Undwa,Kota,Rajasthan',
'Vigyan Nagar Kota,Kota,Rajasthan',
'Vinod Khurd,Kota,Rajasthan',
'Wegan Repair Colony Kota,Kota,Rajasthan',
'Alatawa,Nagaur,Rajasthan',
'Asarwa,Nagaur,Rajasthan',
'Badabara,Nagaur,Rajasthan',
'Badu,Nagaur,Rajasthan',
'Bajoli,Nagaur,Rajasthan',
'Bajwas,Nagaur,Rajasthan',
'Bamana,Nagaur,Rajasthan',
'Barana,Nagaur,Rajasthan',
'Barnel,Nagaur,Rajasthan',
'Besroli,Nagaur,Rajasthan',
'Bhadawa,Nagaur,Rajasthan',
'Bhinchawa,Nagaur,Rajasthan',
'Bhiyankallan,Nagaur,Rajasthan',
'Binthwaliya,Nagaur,Rajasthan',
'Chandaroon,Nagaur,Rajasthan',
'Chandi,Nagaur,Rajasthan',
'Chindaliya,Nagaur,Rajasthan',
'Chosali,Nagaur,Rajasthan',
'Chuwa,Nagaur,Rajasthan',
'Damboi Khurd,Nagaur,Rajasthan',
'Degana,Nagaur,Rajasthan',
'Degana Village,Nagaur,Rajasthan',
'Dhananwa,Nagaur,Rajasthan',
'Dobarikallan,Nagaur,Rajasthan',
'Dobariya,Nagaur,Rajasthan',
'Dotina,Nagaur,Rajasthan',
'Dugorachala,Nagaur,Rajasthan',
'Gachhipura,Nagaur,Rajasthan',
'Gaondi,Nagaur,Rajasthan',
'Gular,Nagaur,Rajasthan',
'Harnawa,Nagaur,Rajasthan',
'Harsore,Nagaur,Rajasthan',
'Heerani,Nagaur,Rajasthan',
'Idwa,Nagaur,Rajasthan',
'Indokha,Nagaur,Rajasthan',
'Itawalakha,Nagaur,Rajasthan',
'Jakhara,Nagaur,Rajasthan',
'Janjila,Nagaur,Rajasthan',
'Jaswantpura,Nagaur,Rajasthan',
'Kasari,Nagaur,Rajasthan',
'Khardiya,Nagaur,Rajasthan',
'Kharesh,Nagaur,Rajasthan',
'Kherileela,Nagaur,Rajasthan',
'Kheriseela,Nagaur,Rajasthan',
'Khojas,Nagaur,Rajasthan',
'Khunkhuna,Nagaur,Rajasthan',
'Khurikallan,Nagaur,Rajasthan',
'Kiro R.S.,Nagaur,Rajasthan',
'Kitalsar,Nagaur,Rajasthan',
'Kuchipala,Nagaur,Rajasthan',
'Kundari,Nagaur,Rajasthan',
'Kurdada,Nagaur,Rajasthan',
'Lalana Khurd,Nagaur,Rajasthan',
'Langod,Nagaur,Rajasthan',
'Mandaljodhan,Nagaur,Rajasthan',
'Mandukara,Nagaur,Rajasthan',
'Manjhi,Nagaur,Rajasthan',
'Midiyan,Nagaur,Rajasthan',
'Mithariya,Nagaur,Rajasthan',
'Moriallan,Nagaur,Rajasthan',
'Morikhurd,Nagaur,Rajasthan',
'Nawad,Nagaur,Rajasthan',
'Netiyas,Nagaur,Rajasthan',
'Nimbri,Nagaur,Rajasthan',
'Nimbrikallan,Nagaur,Rajasthan',
'Nundara,Nagaur,Rajasthan',
'Paliyas,Nagaur,Rajasthan',
'Palrikallan,Nagaur,Rajasthan',
'Pawa,Nagaur,Rajasthan',
'Peeh,Nagaur,Rajasthan',
'Pirwa,Nagaur,Rajasthan',
'Poonlota,Nagaur,Rajasthan',
'Rajapura,Nagaur,Rajasthan',
'Rajlota,Nagaur,Rajasthan',
'Ramsari,Nagaur,Rajasthan',
'Ramsia,Nagaur,Rajasthan',
'Ranigaon,Nagaur,Rajasthan',
'Rid,Nagaur,Rajasthan',
'Sania,Nagaur,Rajasthan',
'Sanju,Nagaur,Rajasthan',
'Sarnawara,Nagaur,Rajasthan',
'Serani Ki Dhani,Nagaur,Rajasthan',
'Sirsu,Nagaur,Rajasthan',
'Thata,Nagaur,Rajasthan',
'Thebari,Nagaur,Rajasthan',
'Tilanesh,Nagaur,Rajasthan',
'Kharwaliya,Nagaur,Rajasthan',
'Kherwa,Nagaur,Rajasthan',
'Agoonta,Nagaur,Rajasthan',
'Ajawa,Nagaur,Rajasthan',
'Akoda,Nagaur,Rajasthan',
'Ambapa,Nagaur,Rajasthan',
'Bansa,Nagaur,Rajasthan',
'Banthri,Nagaur,Rajasthan',
'Barangana,Nagaur,Rajasthan',
'Bardawa,Nagaur,Rajasthan',
'Bari Khatu,Nagaur,Rajasthan',
'Barichhapri,Nagaur,Rajasthan',
'Barikallan,Nagaur,Rajasthan',
'Begsar,Nagaur,Rajasthan',
'Berichhoti,Nagaur,Rajasthan',
'Berwa,Nagaur,Rajasthan',
'Bhadasar,Nagaur,Rajasthan',
'Chawandia,Nagaur,Rajasthan',
'Chhapara,Nagaur,Rajasthan',
'Chholukhan,Nagaur,Rajasthan',
'Chhotichhapri,Nagaur,Rajasthan',
'Chhotikhatu,Nagaur,Rajasthan',
'D.M.Didwana,Nagaur,Rajasthan',
'Dabara,Nagaur,Rajasthan',
'Daudsar,Nagaur,Rajasthan',
'Daulatpura,Nagaur,Rajasthan',
'Dayalpura,Nagaur,Rajasthan',
'Dhankoli,Nagaur,Rajasthan',
'Dhyawa,Nagaur,Rajasthan',
'Didwana H.O,Nagaur,Rajasthan',
'Dikawa,Nagaur,Rajasthan',
'Dindarpura,Nagaur,Rajasthan',
'Firwasi,Nagaur,Rajasthan',
'Ganeshpura,Nagaur,Rajasthan',
'Girroda Mitha,Nagaur,Rajasthan',
'Jaswantgarh,Nagaur,Rajasthan',
'Jharod,Nagaur,Rajasthan',
'Kalwani,Nagaur,Rajasthan',
'Kerap,Nagaur,Rajasthan',
'Khariya,Nagaur,Rajasthan',
'Khatiyabasani,Nagaur,Rajasthan',
'Koliya,Nagaur,Rajasthan',
'Kyamsar,Nagaur,Rajasthan',
'Lachhari,Nagaur,Rajasthan',
'Mamroda,Nagaur,Rajasthan',
'Marwarbalia,Nagaur,Rajasthan',
'Maulasar,Nagaur,Rajasthan',
'Mawa,Nagaur,Rajasthan',
'Mithri,Nagaur,Rajasthan',
'Mithri,Nagaur,Rajasthan',
'Modiawat,Nagaur,Rajasthan',
'Nimbikhurd,Nagaur,Rajasthan',
'Nuwa,Nagaur,Rajasthan',
'Palot,Nagaur,Rajasthan',
'Parewari,Nagaur,Rajasthan',
'Phogari,Nagaur,Rajasthan',
'Raidhana,Nagaur,Rajasthan',
'Ramsabas,Nagaur,Rajasthan',
'Ransisar,Nagaur,Rajasthan',
'Ratau,Nagaur,Rajasthan',
'Reengan,Nagaur,Rajasthan',
'Sagoobari,Nagaur,Rajasthan',
'Sanwarad,Nagaur,Rajasthan',
'Sardarpura Khurd,Nagaur,Rajasthan',
'Sardi,Nagaur,Rajasthan',
'Sewa,Nagaur,Rajasthan',
'Singhana,Nagaur,Rajasthan',
'Singrawatkallan,Nagaur,Rajasthan',
'Station Road Didwana,Nagaur,Rajasthan',
'Sudarasan,Nagaur,Rajasthan',
'Supaka,Nagaur,Rajasthan',
'Toshina,Nagaur,Rajasthan',
'Khinwaj,Nagaur,Rajasthan',
'Lalsari,Nagaur,Rajasthan',
'Payali,Nagaur,Rajasthan',
'Khakholi,Nagaur,Rajasthan',
'Barnel,Nagaur,Rajasthan',
'Chhajoli,Nagaur,Rajasthan',
'Dugastau,Nagaur,Rajasthan',
'Dugoli,Nagaur,Rajasthan',
'Gudha Jodhan,Nagaur,Rajasthan',
'Gugaryali,Nagaur,Rajasthan',
'Jael,Nagaur,Rajasthan',
'Jochina,Nagaur,Rajasthan',
'Kathoti,Nagaur,Rajasthan',
'Khinyala,Nagaur,Rajasthan',
'Rajod,Nagaur,Rajasthan',
'Rotoo,Nagaur,Rajasthan',
'Silanwad,Nagaur,Rajasthan',
'Achina,Nagaur,Rajasthan',
'Akala Hamiran,Nagaur,Rajasthan',
'Bairathal,Nagaur,Rajasthan',
'Bhanwanda,Nagaur,Rajasthan',
'Birloka,Nagaur,Rajasthan',
'Kantiya,Nagaur,Rajasthan',
'Khatora,Nagaur,Rajasthan',
'Khinwsar,Nagaur,Rajasthan',
'Kurchi,Nagaur,Rajasthan',
'Madpura,Nagaur,Rajasthan',
'Manakpura,Nagaur,Rajasthan',
'Nagari,Nagaur,Rajasthan',
'Narwakallan,Nagaur,Rajasthan',
'Panchlasidha,Nagaur,Rajasthan',
'Tadas,Nagaur,Rajasthan',
'Dhandholi,Nagaur,Rajasthan',
'Asotapura,Nagaur,Rajasthan',
'Bakalia,Nagaur,Rajasthan',
'Baldu,Nagaur,Rajasthan',
'Balsamand,Nagaur,Rajasthan',
'Bhadlia,Nagaur,Rajasthan',
'Chandrai,Nagaur,Rajasthan',
'Dabari,Nagaur,Rajasthan',
'Dhingasari,Nagaur,Rajasthan',
'Dholia,Nagaur,Rajasthan',
'Dhurila,Nagaur,Rajasthan',
'Dudoli,Nagaur,Rajasthan',
'Dujar,Nagaur,Rajasthan',
'Genana,Nagaur,Rajasthan',
'Gorau,Nagaur,Rajasthan',
'Kasumbi,Nagaur,Rajasthan',
'Khamiyad,Nagaur,Rajasthan',
'Ladariya,Nagaur,Rajasthan',
'Ladnun Lsg,Nagaur,Rajasthan',
'Ladnuncity,Nagaur,Rajasthan',
'Ledi,Nagaur,Rajasthan',
'Malgaon,Nagaur,Rajasthan',
'Nandolichandawatan,Nagaur,Rajasthan',
'Nimbijodhan,Nagaur,Rajasthan',
'Odit,Nagaur,Rajasthan',
'Pahelipatti Ladnun,Nagaur,Rajasthan',
'Rahugate Ladnun,Nagaur,Rajasthan',
'Rasidpura,Nagaur,Rajasthan',
'Rodu,Nagaur,Rajasthan',
'Sinwa,Nagaur,Rajasthan',
'Sunari,Nagaur,Rajasthan',
'Gelasar,Nagaur,Rajasthan',
'Borawar,Nagaur,Rajasthan',
'Makrana H.O,Nagaur,Rajasthan',
'Maroth,Nagaur,Rajasthan',
'Marwar Mundwa,Nagaur,Rajasthan',
'Akeli \'a\',Nagaur,Rajasthan',
'Alaniyawas,Nagaur,Rajasthan',
'Antroli Khurd,Nagaur,Rajasthan',
'Arniyala,Nagaur,Rajasthan',
'Asawari,Nagaur,Rajasthan',
'Badayali,Nagaur,Rajasthan',
'Badighati,Nagaur,Rajasthan',
'Baggar,Nagaur,Rajasthan',
'Banwarala,Nagaur,Rajasthan',
'Bargaon,Nagaur,Rajasthan',
'Basni Sejan,Nagaur,Rajasthan',
'Beetan,Nagaur,Rajasthan',
'Bhanwal,Nagaur,Rajasthan',
'Bherunda,Nagaur,Rajasthan',
'Bhikarniyakallan,Nagaur,Rajasthan',
'Bhuriyasani,Nagaur,Rajasthan',
'Bijathal,Nagaur,Rajasthan',
'Butati,Nagaur,Rajasthan',
'Chawandiyakallan,Nagaur,Rajasthan',
'Chhapri,Nagaur,Rajasthan',
'Choliyas,Nagaur,Rajasthan',
'Chundiya,Nagaur,Rajasthan',
'Dangawas,Nagaur,Rajasthan',
'Datani,Nagaur,Rajasthan',
'Dhadhwara,Nagaur,Rajasthan',
'Dhandhalas,Nagaur,Rajasthan',
'Dhaneriya,Nagaur,Rajasthan',
'Dhanipura,Nagaur,Rajasthan',
'Dhawa,Nagaur,Rajasthan',
'Dodiyana,Nagaur,Rajasthan',
'Gagrana,Nagaur,Rajasthan',
'Ganthiya,Nagaur,Rajasthan',
'Gawardi,Nagaur,Rajasthan',
'Gotan,Nagaur,Rajasthan',
'Indawar,Nagaur,Rajasthan',
'Jal R.S.,Nagaur,Rajasthan',
'Jalsu Nanak,Nagaur,Rajasthan',
'Jalsukallan,Nagaur,Rajasthan',
'Jaroda,Nagaur,Rajasthan',
'Jasnagar,Nagaur,Rajasthan',
'Jaswantabad,Nagaur,Rajasthan',
'Jatawas,Nagaur,Rajasthan',
'Jhintiya,Nagaur,Rajasthan',
'Jogimagara,Nagaur,Rajasthan',
'Kalru,Nagaur,Rajasthan',
'Kanwariyat,Nagaur,Rajasthan',
'Katyasani,Nagaur,Rajasthan',
'Khakharki,Nagaur,Rajasthan',
'Kheduli,Nagaur,Rajasthan',
'Khinyas,Nagaur,Rajasthan',
'Kod,Nagaur,Rajasthan',
'Kum Merta,Nagaur,Rajasthan',
'Kupras,Nagaur,Rajasthan',
'Kurdayan,Nagaur,Rajasthan',
'Ladawa,Nagaur,Rajasthan',
'Ladpura,Nagaur,Rajasthan',
'Lambajatan,Nagaur,Rajasthan',
'Lampolai,Nagaur,Rajasthan',
'Liliya,Nagaur,Rajasthan',
'Medas,Nagaur,Rajasthan',
'Merta City,Nagaur,Rajasthan',
'Merta Road,Nagaur,Rajasthan',
'Merta,Nagaur,Rajasthan',
'Mewara,Nagaur,Rajasthan',
'Mokala,Nagaur,Rajasthan',
'Morra,Nagaur,Rajasthan',
'Mugadara,Nagaur,Rajasthan',
'Nathawara,Nagaur,Rajasthan',
'Netariya,Nagaur,Rajasthan',
'Nimbola Bishwa,Nagaur,Rajasthan',
'Nimbolakallan,Nagaur,Rajasthan',
'Oladan,Nagaur,Rajasthan',
'Padukallan,Nagaur,Rajasthan',
'Padukhurd,Nagaur,Rajasthan',
'Punas,Nagaur,Rajasthan',
'Pundlu,Nagaur,Rajasthan',
'Rajod,Nagaur,Rajasthan',
'Rasaliyawas,Nagaur,Rajasthan',
'Ratrana,Nagaur,Rajasthan',
'Ren,Nagaur,Rajasthan',
'Riyan,Nagaur,Rajasthan',
'Rohisa,Nagaur,Rajasthan',
'Sathana,Nagaur,Rajasthan',
'Satlas,Nagaur,Rajasthan',
'Sensara,Nagaur,Rajasthan',
'Sirasana,Nagaur,Rajasthan',
'Sudwar,Nagaur,Rajasthan',
'Tehla,Nagaur,Rajasthan',
'Thanwala,Nagaur,Rajasthan',
'Bhadora,Nagaur,Rajasthan',
'Bhatnokha,Nagaur,Rajasthan',
'Dhadhariyakallan,Nagaur,Rajasthan',
'Gawalu,Nagaur,Rajasthan',
'Gowankallan,Nagaur,Rajasthan',
'Janana,Nagaur,Rajasthan',
'Khajwana,Nagaur,Rajasthan',
'Kuchera,Nagaur,Rajasthan',
'Mori,Nagaur,Rajasthan',
'Mundiyar,Nagaur,Rajasthan',
'Palrijodhan,Nagaur,Rajasthan',
'Roon,Nagaur,Rajasthan',
'Sankhawas,Nagaur,Rajasthan',
'Sheelgaon,Nagaur,Rajasthan',
'Akeli \'b\',Nagaur,Rajasthan',
'Akora,Nagaur,Rajasthan',
'Anwaliyasar,Nagaur,Rajasthan',
'Arwar,Nagaur,Rajasthan',
'Bachhwari,Nagaur,Rajasthan',
'Balaya,Nagaur,Rajasthan',
'Bansiwala Temple Ndtso Nagaur,Nagaur,Rajasthan',
'Barangaon,Nagaur,Rajasthan',
'Basni,Nagaur,Rajasthan',
'Bhadana,Nagaur,Rajasthan',
'Bhadana,Nagaur,Rajasthan',
'Bhadwasi,Nagaur,Rajasthan',
'Bhakrod,Nagaur,Rajasthan',
'Bhaola,Nagaur,Rajasthan',
'Bhundel,Nagaur,Rajasthan',
'Boodhi,Nagaur,Rajasthan',
'Borwa,Nagaur,Rajasthan',
'Bugarda,Nagaur,Rajasthan',
'Burdi,Nagaur,Rajasthan',
'Chau,Nagaur,Rajasthan',
'Chawandiya,Nagaur,Rajasthan',
'Chenar,Nagaur,Rajasthan',
'Chhapara,Nagaur,Rajasthan',
'Chhawata Khurd,Nagaur,Rajasthan',
'Chiloo,Nagaur,Rajasthan',
'Chuntisara,Nagaur,Rajasthan',
'Daru,Nagaur,Rajasthan',
'Datina,Nagaur,Rajasthan',
'Deh,Nagaur,Rajasthan',
'Dehari,Nagaur,Rajasthan',
'Deu,Nagaur,Rajasthan',
'Didiyakallan,Nagaur,Rajasthan',
'Gagwana,Nagaur,Rajasthan',
'Gajoo,Nagaur,Rajasthan',
'Ganthilasar,Nagaur,Rajasthan',
'Geloli,Nagaur,Rajasthan',
'Gogelao,Nagaur,Rajasthan',
'Gothara,Nagaur,Rajasthan',
'Gudhabhagwandas,Nagaur,Rajasthan',
'Inana,Nagaur,Rajasthan',
'Jalaniyasar,Nagaur,Rajasthan',
'Janewa,Nagaur,Rajasthan',
'Jhareli,Nagaur,Rajasthan',
'Jharisara,Nagaur,Rajasthan',
'Kalri,Nagaur,Rajasthan',
'Kameria,Nagaur,Rajasthan',
'Karlu,Nagaur,Rajasthan',
'Kasnau,Nagaur,Rajasthan',
'Khanwar,Nagaur,Rajasthan',
'Kharikaramsota,Nagaur,Rajasthan',
'Kharnal,Nagaur,Rajasthan',
'Kumari,Nagaur,Rajasthan',
'Lunsara,Nagaur,Rajasthan',
'Manglod,Nagaur,Rajasthan',
'Merwas,Nagaur,Rajasthan',
'Nagaur H.O,Nagaur,Rajasthan',
'Nagaurcity,Nagaur,Rajasthan',
'Nimbrichandawatan,Nagaur,Rajasthan',
'Panchori,Nagaur,Rajasthan',
'Pharrod,Nagaur,Rajasthan',
'Phirod,Nagaur,Rajasthan',
'Pipasar,Nagaur,Rajasthan',
'Police Line Nagaur,Nagaur,Rajasthan',
'Raidhanu,Nagaur,Rajasthan',
'Ratanga,Nagaur,Rajasthan',
'Rohina,Nagaur,Rajasthan',
'Rohini,Nagaur,Rajasthan',
'Rol,Nagaur,Rajasthan',
'Sadokan,Nagaur,Rajasthan',
'Sandila,Nagaur,Rajasthan',
'Satheran,Nagaur,Rajasthan',
'Sewari,Nagaur,Rajasthan',
'Shyamsar,Nagaur,Rajasthan',
'Singar,Nagaur,Rajasthan',
'Sinod,Nagaur,Rajasthan',
'Somana,Nagaur,Rajasthan',
'Sribalaji,Nagaur,Rajasthan',
'Sukhwasi,Nagaur,Rajasthan',
'Surjaniyawas,Nagaur,Rajasthan',
'Surpalia,Nagaur,Rajasthan',
'Tankala,Nagaur,Rajasthan',
'Tantwas,Nagaur,Rajasthan',
'Tanwara,Nagaur,Rajasthan',
'Tarnau,Nagaur,Rajasthan',
'Tausar,Nagaur,Rajasthan',
'Thirod,Nagaur,Rajasthan',
'Unthwaliya,Nagaur,Rajasthan',
'Bher,Nagaur,Rajasthan',
'Jodhiyasi,Nagaur,Rajasthan',
'Karnu,Nagaur,Rajasthan',
'Soneli,Nagaur,Rajasthan',
'Ubasi,Nagaur,Rajasthan',
'Anandpura,Nagaur,Rajasthan',
'Araksar,Nagaur,Rajasthan',
'Banwaligudha,Nagaur,Rajasthan',
'Bhagwanpura,Nagaur,Rajasthan',
'Bhanwata,Nagaur,Rajasthan',
'Bhooni,Nagaur,Rajasthan',
'Charanwas,Nagaur,Rajasthan',
'Chitawa,Nagaur,Rajasthan',
'Chosala,Nagaur,Rajasthan',
'Dalelpura,Nagaur,Rajasthan',
'Daulatpura,Nagaur,Rajasthan',
'Deolikallan,Nagaur,Rajasthan',
'Gedakallan,Nagaur,Rajasthan',
'Gingaliya,Nagaur,Rajasthan',
'Govindi,Nagaur,Rajasthan',
'Hariyajun,Nagaur,Rajasthan',
'Hudeel,Nagaur,Rajasthan',
'I.A.Nawacity,Nagaur,Rajasthan',
'Indokha,Nagaur,Rajasthan',
'Jabdinagar,Nagaur,Rajasthan',
'Jijoth,Nagaur,Rajasthan',
'Jiliya,Nagaur,Rajasthan',
'Kankariya,Nagaur,Rajasthan',
'Khardiya,Nagaur,Rajasthan',
'Khorandi,Nagaur,Rajasthan',
'Kuchamancity,Nagaur,Rajasthan',
'Kukanwali,Nagaur,Rajasthan',
'Ladoli,Nagaur,Rajasthan',
'Lalas,Nagaur,Rajasthan',
'Lichana,Nagaur,Rajasthan',
'Lunwa,Nagaur,Rajasthan',
'Mamroli,Nagaur,Rajasthan',
'Motipura,Nagaur,Rajasthan',
'Mundghasoi,Nagaur,Rajasthan',
'Muwana,Nagaur,Rajasthan',
'Nagwara,Nagaur,Rajasthan',
'Nalot,Nagaur,Rajasthan',
'Nandoli Mertiyan,Nagaur,Rajasthan',
'Narainpura,Nagaur,Rajasthan',
'Nawacity Lsg,Nagaur,Rajasthan',
'Palara,Nagaur,Rajasthan',
'Palrinawa,Nagaur,Rajasthan',
'Panchota,Nagaur,Rajasthan',
'Prempura,Nagaur,Rajasthan',
'Rajaliya,Nagaur,Rajasthan',
'Rasal,Nagaur,Rajasthan',
'Rooppura,Nagaur,Rajasthan',
'S.Padampura,Nagaur,Rajasthan',
'S.R. Kuchamancity,Nagaur,Rajasthan',
'Sabalpura,Nagaur,Rajasthan',
'Shimbhupura,Nagaur,Rajasthan',
'Shiv,Nagaur,Rajasthan',
'Shyamgarh,Nagaur,Rajasthan',
'Thikariya Khurd,Nagaur,Rajasthan',
'Todas,Nagaur,Rajasthan',
'Sabalpura,Nagaur,Rajasthan',
'Bansed,Nagaur,Rajasthan',
'Banwal,Nagaur,Rajasthan',
'Barwala,Nagaur,Rajasthan',
'Barwali,Nagaur,Rajasthan',
'Bassi,Nagaur,Rajasthan',
'Bhadasiya,Nagaur,Rajasthan',
'Bharnai,Nagaur,Rajasthan',
'Bhinchawa,Nagaur,Rajasthan',
'Bidiad,Nagaur,Rajasthan',
'Billoo,Nagaur,Rajasthan',
'Chitai,Nagaur,Rajasthan',
'Dabariya,Nagaur,Rajasthan',
'Dhadhota,Nagaur,Rajasthan',
'Dildhani,Nagaur,Rajasthan',
'Gangawa,Nagaur,Rajasthan',
'Gunawati,Nagaur,Rajasthan',
'Hudia,Nagaur,Rajasthan',
'I.A.Bidiad,Nagaur,Rajasthan',
'Jakhali,Nagaur,Rajasthan',
'Jhalara,Nagaur,Rajasthan',
'Jiwadiya,Nagaur,Rajasthan',
'Jusari,Nagaur,Rajasthan',
'Jusariya,Nagaur,Rajasthan',
'Kalwa,Nagaur,Rajasthan',
'Khakharki,Nagaur,Rajasthan',
'Khanpur\',Nagaur,Rajasthan',
'Khokhar,Nagaur,Rajasthan',
'Kinsariya,Nagaur,Rajasthan',
'Kukrod,Nagaur,Rajasthan',
'Loroli,Nagaur,Rajasthan',
'Makrana Rs,Nagaur,Rajasthan',
'Makrana S.B.,Nagaur,Rajasthan',
'Manana,Nagaur,Rajasthan',
'Manglana,Nagaur,Rajasthan',
'Mayapur,Nagaur,Rajasthan',
'Modicharana,Nagaur,Rajasthan',
'Morer,Nagaur,Rajasthan',
'Neniya,Nagaur,Rajasthan',
'Parbatsar,Nagaur,Rajasthan',
'Peeplad,Nagaur,Rajasthan',
'Rabariyad,Nagaur,Rajasthan',
'Rohindi,Nagaur,Rajasthan',
'Saferkallan,Nagaur,Rajasthan',
'Taparwara,Nagaur,Rajasthan',
'Amaliya,Pali,Rajasthan',
'Bali Bazar,Pali,Rajasthan',
'Bali,Pali,Rajasthan',
'Barwa,Pali,Rajasthan',
'Beejapur,Pali,Rajasthan',
'Bhandar,Pali,Rajasthan',
'Bhatund,Pali,Rajasthan',
'Bheemana,Pali,Rajasthan',
'Bheetwara,Pali,Rajasthan',
'Boya,Pali,Rajasthan',
'Chamunderi,Pali,Rajasthan',
'Dantiwara,Pali,Rajasthan',
'Deotra,Pali,Rajasthan',
'Dhani,Pali,Rajasthan',
'Dudapura,Pali,Rajasthan',
'Falna I. E.,Pali,Rajasthan',
'Falna,Pali,Rajasthan',
'Falna Village,Pali,Rajasthan',
'Goriya,Pali,Rajasthan',
'Gudalass,Pali,Rajasthan',
'Kot- Baliyan,Pali,Rajasthan',
'Kothar,Pali,Rajasthan',
'Koyalbao,Pali,Rajasthan',
'Kumatiya,Pali,Rajasthan',
'Lalrai,Pali,Rajasthan',
'Latara,Pali,Rajasthan',
'Lunawa,Pali,Rajasthan',
'Malnoo,Pali,Rajasthan',
'Mirgesar,Pali,Rajasthan',
'Morkha,Pali,Rajasthan',
'Mundara,Pali,Rajasthan',
'Nana,Pali,Rajasthan',
'Padarla,Pali,Rajasthan',
'Panchalwara,Pali,Rajasthan',
'Sela,Pali,Rajasthan',
'Sena,Pali,Rajasthan',
'Sewari,Pali,Rajasthan',
'Sheotalao,Pali,Rajasthan',
'Ana,Pali,Rajasthan',
'Bagol,Pali,Rajasthan',
'Banta R.S.,Pali,Rajasthan',
'Banta Town,Pali,Rajasthan',
'Barod,Pali,Rajasthan',
'Beerami,Pali,Rajasthan',
'Bhadarlau,Pali,Rajasthan',
'Bheemaliya,Pali,Rajasthan',
'Bijowa,Pali,Rajasthan',
'Boosi,Pali,Rajasthan',
'Chanchori,Pali,Rajasthan',
'Dadai,Pali,Rajasthan',
'Dayalana,Pali,Rajasthan',
'Deoli Pabuji,Pali,Rajasthan',
'Desuri,Pali,Rajasthan',
'Dhalop,Pali,Rajasthan',
'Dhana,Pali,Rajasthan',
'Dutariya,Pali,Rajasthan',
'Ghanerao,Pali,Rajasthan',
'Ghenri,Pali,Rajasthan',
'Inderwara,Pali,Rajasthan',
'Itendra Charnan,Pali,Rajasthan',
'Jeewand Kalan,Pali,Rajasthan',
'Kerli,Pali,Rajasthan',
'Kesooli,Pali,Rajasthan',
'Kharda,Pali,Rajasthan',
'Khatukara,Pali,Rajasthan',
'Kheemel,Pali,Rajasthan',
'Kishanpura,Pali,Rajasthan',
'Kotri,Pali,Rajasthan',
'Lapod,Pali,Rajasthan',
'Mada,Pali,Rajasthan',
'Mandal,Pali,Rajasthan',
'Mandigarh,Pali,Rajasthan',
'Mokampura,Pali,Rajasthan',
'Mori Bera,Pali,Rajasthan',
'Nadana-bhatan,Pali,Rajasthan',
'Nadol,Pali,Rajasthan',
'Narlai,Pali,Rajasthan',
'Neembara,Pali,Rajasthan',
'Neepal,Pali,Rajasthan',
'Panchetiya,Pali,Rajasthan',
'Pilowani,Pali,Rajasthan',
'Prithviraj Ka Gurha,Pali,Rajasthan',
'Raipuriya,Pali,Rajasthan',
'Ranakpur,Pali,Rajasthan',
'Rani Gaon,Pali,Rajasthan',
'Rani,Pali,Rajasthan',
'Rani Sadar Bazar,Pali,Rajasthan',
'Sadri,Pali,Rajasthan',
'Saleriya,Pali,Rajasthan',
'Sanwalta,Pali,Rajasthan',
'Sesli,Pali,Rajasthan',
'Sindharli,Pali,Rajasthan',
'Somesar,Pali,Rajasthan',
'Sumer,Pali,Rajasthan',
'Varkana,Pali,Rajasthan',
'Vidhyawari,Pali,Rajasthan',
'Agewa,Pali,Rajasthan',
'Asarlai,Pali,Rajasthan',
'Babra,Pali,Rajasthan',
'Balada,Pali,Rajasthan',
'Balunda,Pali,Rajasthan',
'Banjakuri,Pali,Rajasthan',
'Bar,Pali,Rajasthan',
'Ber - Kalan,Pali,Rajasthan',
'Bhoombaliya,Pali,Rajasthan',
'Birantiya Kalan,Pali,Rajasthan',
'Birantiya Khurd,Pali,Rajasthan',
'Birol,Pali,Rajasthan',
'Deoli Kalan,Pali,Rajasthan',
'Deoria,Pali,Rajasthan',
'Dhaneriya,Pali,Rajasthan',
'Digarna,Pali,Rajasthan',
'Dlf Rabriyawas,Pali,Rajasthan',
'Falka - Kalan,Pali,Rajasthan',
'Garniya,Pali,Rajasthan',
'Ghorawar,Pali,Rajasthan',
'Jaitaran,Pali,Rajasthan',
'Jhujanda,Pali,Rajasthan',
'Kanwaliya Kalan,Pali,Rajasthan',
'Kekindra,Pali,Rajasthan',
'Kharadi,Pali,Rajasthan',
'Khinawari,Pali,Rajasthan',
'Kurki,Pali,Rajasthan',
'Lambiya,Pali,Rajasthan',
'Leelamba,Pali,Rajasthan',
'Lototi,Pali,Rajasthan',
'Mohrai,Pali,Rajasthan',
'Nimaj,Pali,Rajasthan',
'Nimbera- Kalan,Pali,Rajasthan',
'Nimbol,Pali,Rajasthan',
'Patwa,Pali,Rajasthan',
'Phoolmal,Pali,Rajasthan',
'Rabriyawas,Pali,Rajasthan',
'Rajadand,Pali,Rajasthan',
'Ramawas,Pali,Rajasthan',
'Rampura - Kalan,Pali,Rajasthan',
'Raniwal,Pali,Rajasthan',
'Sangawas,Pali,Rajasthan',
'Sinla,Pali,Rajasthan',
'Talkiya,Pali,Rajasthan',
'Anandpur Kalu,Pali,Rajasthan',
'Khinwara,Pali,Rajasthan',
'Phulad,Pali,Rajasthan',
'Guda Kesarsingh,Pali,Rajasthan',
'Malsabaori,Pali,Rajasthan',
'Guda Ramsingh,Pali,Rajasthan',
'Marwar Jn. H.O,Pali,Rajasthan',
'Auwa,Pali,Rajasthan',
'Barsa,Pali,Rajasthan',
'Basni Jojawar,Pali,Rajasthan',
'Bhagora,Pali,Rajasthan',
'Bithora Kalan,Pali,Rajasthan',
'Bopari,Pali,Rajasthan',
'Borimada,Pali,Rajasthan',
'Chawariya,Pali,Rajasthan',
'Chelawas,Pali,Rajasthan',
'Chirpatiya,Pali,Rajasthan',
'Chokariya,Pali,Rajasthan',
'Deoli Auwa,Pali,Rajasthan',
'Dhamli,Pali,Rajasthan',
'Dhanla,Pali,Rajasthan',
'Dhareshwar,Pali,Rajasthan',
'Dhundhla,Pali,Rajasthan',
'Gadhana,Pali,Rajasthan',
'Gajnipura,Pali,Rajasthan',
'Guda Soorsingh,Pali,Rajasthan',
'Hemaliyawas Kalan,Pali,Rajasthan',
'Hemaliyawas Khurd,Pali,Rajasthan',
'Hingola Khurd,Pali,Rajasthan',
'Isali,Pali,Rajasthan',
'Jadan,Pali,Rajasthan',
'Januda,Pali,Rajasthan',
'Jojawar,Pali,Rajasthan',
'Kantaliya,Pali,Rajasthan',
'Karadi,Pali,Rajasthan',
'Khairwa,Pali,Rajasthan',
'Kharachi,Pali,Rajasthan',
'Khardi,Pali,Rajasthan',
'Khariya-soda,Pali,Rajasthan',
'Kot- Solankiyan,Pali,Rajasthan',
'Lambiya,Pali,Rajasthan',
'Magartalab,Pali,Rajasthan',
'Neembli- Manda,Pali,Rajasthan',
'Panota,Pali,Rajasthan',
'Radawas,Pali,Rajasthan',
'Ranawas,Pali,Rajasthan',
'Sansari,Pali,Rajasthan',
'Sapooni,Pali,Rajasthan',
'Saran,Pali,Rajasthan',
'Seeriyari,Pali,Rajasthan',
'Sehwaj,Pali,Rajasthan',
'Shekhawas,Pali,Rajasthan',
'Sinla,Pali,Rajasthan',
'Siwas,Pali,Rajasthan',
'Thakurwas,Pali,Rajasthan',
'Wandar,Pali,Rajasthan',
'Dhola,Pali,Rajasthan',
'Keerwa,Pali,Rajasthan',
'Kerla,Pali,Rajasthan',
'Koorna,Pali,Rajasthan',
'Mandiya,Pali,Rajasthan',
'Manihari,Pali,Rajasthan',
'Neembli-uran,Pali,Rajasthan',
'Pali City,Pali,Rajasthan',
'Pali Marwar H.O,Pali,Rajasthan',
'Pali Veer Durgadas Nagar,Pali,Rajasthan',
'Rana,Pali,Rajasthan',
'Rupawas,Pali,Rajasthan',
'Sardar-samand,Pali,Rajasthan',
'Sodawas,Pali,Rajasthan',
'Sonai Manji,Pali,Rajasthan',
'Tewali,Pali,Rajasthan',
'Thakurla,Pali,Rajasthan',
'Giradra,Pali,Rajasthan',
'Gundoj,Pali,Rajasthan',
'Khod,Pali,Rajasthan',
'Pali Housing Board,Pali,Rajasthan',
'Pali M.R.I.A,Pali,Rajasthan',
'Pali Railway Station,Pali,Rajasthan',
'Jawali,Pali,Rajasthan',
'Balrai,Pali,Rajasthan',
'Bhakriwala,Pali,Rajasthan',
'Bhangesar,Pali,Rajasthan',
'Bhanwari,Pali,Rajasthan',
'Bomadara,Pali,Rajasthan',
'Dari,Pali,Rajasthan',
'Dayalpura,Pali,Rajasthan',
'Deegai,Pali,Rajasthan',
'Denda,Pali,Rajasthan',
'Dhariya,Pali,Rajasthan',
'Guda Endla,Pali,Rajasthan',
'Hemawas,Pali,Rajasthan',
'Itendra Mertiyan,Pali,Rajasthan',
'Pali Industrial Estate,Pali,Rajasthan',
'Pali Kutchery,Pali,Rajasthan',
'Pali Mahaveer Udhyog Nagar,Pali,Rajasthan',
'Pali Suraj Pole,Pali,Rajasthan',
'Bagiara,Pali,Rajasthan',
'Bagri Kalaliya,Pali,Rajasthan',
'Bansiya,Pali,Rajasthan',
'Bootiwas,Pali,Rajasthan',
'Chang,Pali,Rajasthan',
'Chawandiya,Pali,Rajasthan',
'Chittar,Pali,Rajasthan',
'Deepwas,Pali,Rajasthan',
'Giri,Pali,Rajasthan',
'Guriya,Pali,Rajasthan',
'Hajiwas,Pali,Rajasthan',
'Haripur,Pali,Rajasthan',
'Jhoontha,Pali,Rajasthan',
'Kalab-kalan,Pali,Rajasthan',
'Kalaliya,Pali,Rajasthan',
'Kanuja,Pali,Rajasthan',
'Karmawas Maliyan,Pali,Rajasthan',
'Karmawas Patta,Pali,Rajasthan',
'Kirana,Pali,Rajasthan',
'Mesiya,Pali,Rajasthan',
'Mohra - Kalan,Pali,Rajasthan',
'Nanana,Pali,Rajasthan',
'Pachanpura,Pali,Rajasthan',
'Pratap - Garh,Pali,Rajasthan',
'Raira Kalan,Pali,Rajasthan',
'Ras,Pali,Rajasthan',
'Ratadiya,Pali,Rajasthan',
'Relra,Pali,Rajasthan',
'Sabalpura,Pali,Rajasthan',
'Sewariya,Pali,Rajasthan',
'Sumel,Pali,Rajasthan',
'Toonkra,Pali,Rajasthan',
'Amarpura,Pali,Rajasthan',
'Raipur Marwar,Pali,Rajasthan',
'Sendra,Pali,Rajasthan',
'Kushalpura,Pali,Rajasthan',
'Pipliya Kalan,Pali,Rajasthan',
'Bayad,Pali,Rajasthan',
'Beethu,Pali,Rajasthan',
'Chenda,Pali,Rajasthan',
'Chotila,Pali,Rajasthan',
'Dhabar Kalan,Pali,Rajasthan',
'Diwandi,Pali,Rajasthan',
'Dudiya,Pali,Rajasthan',
'Gadwara,Pali,Rajasthan',
'Gelawas,Pali,Rajasthan',
'Jheetra,Pali,Rajasthan',
'Kalali,Pali,Rajasthan',
'Khandi,Pali,Rajasthan',
'Kharda,Pali,Rajasthan',
'Kulthana,Pali,Rajasthan',
'Mandawas,Pali,Rajasthan',
'Rohat R.S.,Pali,Rajasthan',
'Rohat,Pali,Rajasthan',
'Alawas,Pali,Rajasthan',
'Atabara,Pali,Rajasthan',
'Babhan,Pali,Rajasthan',
'Bagri Nagar,Pali,Rajasthan',
'Basna,Pali,Rajasthan',
'Beelawas,Pali,Rajasthan',
'Bhaisana,Pali,Rajasthan',
'Bornadi,Pali,Rajasthan',
'Chadwas,Pali,Rajasthan',
'Chandawal,Pali,Rajasthan',
'Chanddawal R.S.,Pali,Rajasthan',
'Chopra,Pali,Rajasthan',
'Deoli Hulla,Pali,Rajasthan',
'Dhakri,Pali,Rajasthan',
'Dhinawas,Pali,Rajasthan',
'Gajnai,Pali,Rajasthan',
'Guda Binja,Pali,Rajasthan',
'Guda Kalan,Pali,Rajasthan',
'Guda-shama,Pali,Rajasthan',
'Hariyamali,Pali,Rajasthan',
'Hingawas,Pali,Rajasthan',
'Jeejardi,Pali,Rajasthan',
'Kelwad,Pali,Rajasthan',
'Khariya-neev,Pali,Rajasthan',
'Khodiya,Pali,Rajasthan',
'Khokhra,Pali,Rajasthan',
'Manda,Pali,Rajasthan',
'Mandla,Pali,Rajasthan',
'Meo,Pali,Rajasthan',
'Murdawa,Pali,Rajasthan',
'Musaliya,Pali,Rajasthan',
'Pachunda - Kalan,Pali,Rajasthan',
'Piplad,Pali,Rajasthan',
'Rajola - Kalan,Pali,Rajasthan',
'Rajola - Khurd,Pali,Rajasthan',
'Ramasani - Bala,Pali,Rajasthan',
'Rendri,Pali,Rajasthan',
'Reprawas,Pali,Rajasthan',
'Roopawas,Pali,Rajasthan',
'Sandiya,Pali,Rajasthan',
'Sawrad,Pali,Rajasthan',
'Seesarwada,Pali,Rajasthan',
'Shivpura,Pali,Rajasthan',
'Siyat,Pali,Rajasthan',
'Sojat Ind. Area,Pali,Rajasthan',
'Sojat Road,Pali,Rajasthan',
'Sojat Bazar,Pali,Rajasthan',
'Sojat,Pali,Rajasthan',
'Surayta,Pali,Rajasthan',
'Anoppura,Pali,Rajasthan',
'B.M.G. Hospital Ramnagar,Pali,Rajasthan',
'Babagaon,Pali,Rajasthan',
'Balana,Pali,Rajasthan',
'Balupura,Pali,Rajasthan',
'Bamnera,Pali,Rajasthan',
'Bankli,Pali,Rajasthan',
'Basant,Pali,Rajasthan',
'Beethora,Pali,Rajasthan',
'Bharunda,Pali,Rajasthan',
'Bisalpur,Pali,Rajasthan',
'Chanod,Pali,Rajasthan',
'Dudni,Pali,Rajasthan',
'Dujana,Pali,Rajasthan',
'Fattapura,Pali,Rajasthan',
'Gogra,Pali,Rajasthan',
'Jawai Bandh,Pali,Rajasthan',
'Kakaradi,Pali,Rajasthan',
'Kanpura,Pali,Rajasthan',
'Kheemara,Pali,Rajasthan',
'Khiwandi,Pali,Rajasthan',
'Koliwara,Pali,Rajasthan',
'Korta,Pali,Rajasthan',
'Netra,Pali,Rajasthan',
'Novi,Pali,Rajasthan',
'Palri-jod,Pali,Rajasthan',
'Pawa,Pali,Rajasthan',
'Perwa,Pali,Rajasthan',
'Pomawa,Pali,Rajasthan',
'Sanderao,Pali,Rajasthan',
'Sindru,Pali,Rajasthan',
'Sumerpur Krishi Upaj Mandi,Pali,Rajasthan',
'Sumerpur,Pali,Rajasthan',
'Tagatgarh,Pali,Rajasthan',
'Aagaria,Udaipur,Rajasthan',
'Bansa,Udaipur,Rajasthan',
'Bikawas,Udaipur,Rajasthan',
'Gosundi,Udaipur,Rajasthan',
'Goval,Udaipur,Rajasthan',
'Janawad,Udaipur,Rajasthan',
'Jeeran,Udaipur,Rajasthan',
'Jhilwara,Udaipur,Rajasthan',
'Kalaguman,Udaipur,Rajasthan',
'Khakharmala,Udaipur,Rajasthan',
'Kharnota,Udaipur,Rajasthan',
'Kuanthal,Udaipur,Rajasthan',
'Lambodi,Udaipur,Rajasthan',
'Liki,Udaipur,Rajasthan',
'Mad,Udaipur,Rajasthan',
'Manawaton Ka Guda,Udaipur,Rajasthan',
'Nanana,Udaipur,Rajasthan',
'Narana,Udaipur,Rajasthan',
'Rinchhed,Udaipur,Rajasthan',
'Sathia,Udaipur,Rajasthan',
'Selaguda,Udaipur,Rajasthan',
'Sevantri,Udaipur,Rajasthan',
'Sunkhar,Udaipur,Rajasthan',
'Thurawad,Udaipur,Rajasthan',
'Tikar,Udaipur,Rajasthan',
'Todawara Gujran,Udaipur,Rajasthan',
'Umarwas,Udaipur,Rajasthan',
'Baggad,Udaipur,Rajasthan',
'Hamelon Ki Bar,Udaipur,Rajasthan',
'Kachhabali,Udaipur,Rajasthan',
'Lakha Guda,Udaipur,Rajasthan',
'Mandawar,Udaipur,Rajasthan',
'Miyala,Udaipur,Rajasthan',
'Thikarwas,Udaipur,Rajasthan',
'Charbhuja Road,Udaipur,Rajasthan',
'Anjana,Udaipur,Rajasthan',
'Bagana,Udaipur,Rajasthan',
'Barjal,Udaipur,Rajasthan',
'Chhaplian,Udaipur,Rajasthan',
'Daver,Udaipur,Rajasthan',
'Isharmand,Udaipur,Rajasthan',
'Kakrod,Udaipur,Rajasthan',
'Kalesaria,Udaipur,Rajasthan',
'Khamlighat,Udaipur,Rajasthan',
'Kundwa,Udaipur,Rajasthan',
'Lasani,Udaipur,Rajasthan',
'Madaria,Udaipur,Rajasthan',
'Nardaska Guda,Udaipur,Rajasthan',
'Pardi,Udaipur,Rajasthan',
'Pipli,Udaipur,Rajasthan',
'Ranchhedi,Udaipur,Rajasthan',
'Savadari,Udaipur,Rajasthan',
'Tal,Udaipur,Rajasthan',
'Gilund,Udaipur,Rajasthan',
'Khad Bamnia,Udaipur,Rajasthan',
'Kkundia,Udaipur,Rajasthan',
'Pachhamata,Udaipur,Rajasthan',
'Panotia,Udaipur,Rajasthan',
'B K Kalwana,Udaipur,Rajasthan',
'Bhanpura,Udaipur,Rajasthan',
'Bokhada,Udaipur,Rajasthan',
'Diyan,Udaipur,Rajasthan',
'Ganawal,Udaipur,Rajasthan',
'Jemli,Udaipur,Rajasthan',
'Kamol,Udaipur,Rajasthan',
'Padrada,Udaipur,Rajasthan',
'Palasma,Udaipur,Rajasthan',
'Punawali,Udaipur,Rajasthan',
'Roachh,Udaipur,Rajasthan',
'Semad,Udaipur,Rajasthan',
'Singhara,Udaipur,Rajasthan',
'Suavaton Ka Guda,Udaipur,Rajasthan',
'Tarpal,Udaipur,Rajasthan',
'Mohi,Udaipur,Rajasthan',
'T F Kankroli,Udaipur,Rajasthan',
'Balicha,Udaipur,Rajasthan',
'Kadmal,Udaipur,Rajasthan',
'Khamnore,Udaipur,Rajasthan',
'Molela,Udaipur,Rajasthan',
'Saloda,Udaipur,Rajasthan',
'Sema,Udaipur,Rajasthan',
'Semal,Udaipur,Rajasthan',
'Unwas,Udaipur,Rajasthan',
'Vati,Udaipur,Rajasthan',
'Koaria,Udaipur,Rajasthan',
'Kotharia,Udaipur,Rajasthan',
'Antri,Udaipur,Rajasthan',
'Bankora,Udaipur,Rajasthan',
'Baradara,Udaipur,Rajasthan',
'Kadia,Udaipur,Rajasthan',
'Kankrwa,Udaipur,Rajasthan',
'Kanooja,Udaipur,Rajasthan',
'Kelwara,Udaipur,Rajasthan',
'Kesar,Udaipur,Rajasthan',
'Kuncholi,Udaipur,Rajasthan',
'Majera,Udaipur,Rajasthan',
'Oda,Udaipur,Rajasthan',
'Taladari,Udaipur,Rajasthan',
'Kuraj,Udaipur,Rajasthan',
'Dowra,Udaipur,Rajasthan',
'Jilola,Udaipur,Rajasthan',
'Lawa Sardargarh,Udaipur,Rajasthan',
'Lodiyana,Udaipur,Rajasthan',
'Olanakhera,Udaipur,Rajasthan',
'Panotia,Udaipur,Rajasthan',
'Sakroda,Udaipur,Rajasthan',
'Dhaneria,Udaipur,Rajasthan',
'Jewana,Udaipur,Rajasthan',
'Khartana,Udaipur,Rajasthan',
'Morath,Udaipur,Rajasthan',
'Akodara,Udaipur,Rajasthan',
'Bagol,Udaipur,Rajasthan',
'Bamanhera,Udaipur,Rajasthan',
'Bhada Bhanuja,Udaipur,Rajasthan',
'Bhensa Kamed,Udaipur,Rajasthan',
'Bijnol,Udaipur,Rajasthan',
'Bilota,Udaipur,Rajasthan',
'Chirwa,Udaipur,Rajasthan',
'Delwara,Udaipur,Rajasthan',
'Dhayla,Udaipur,Rajasthan',
'Goanguda,Udaipur,Rajasthan',
'Gunjol,Udaipur,Rajasthan',
'Jhalon Ki Madar,Udaipur,Rajasthan',
'Kailashpuri,Udaipur,Rajasthan',
'Kaliwas,Udaipur,Rajasthan',
'Karoli,Udaipur,Rajasthan',
'Kessuli,Udaipur,Rajasthan',
'Koshiwara,Udaipur,Rajasthan',
'Kunthwa,Udaipur,Rajasthan',
'Lal Madri,Udaipur,Rajasthan',
'Machind,Udaipur,Rajasthan',
'Maja,Udaipur,Rajasthan',
'Manakwas,Udaipur,Rajasthan',
'Mandiyana,Udaipur,Rajasthan',
'Morcha,Udaipur,Rajasthan',
'Namana,Udaipur,Rajasthan',
'Nathdwara,Udaipur,Rajasthan',
'Negadia,Udaipur,Rajasthan',
'Odan,Udaipur,Rajasthan',
'Pakhand,Udaipur,Rajasthan',
'Pipli,Udaipur,Rajasthan',
'Rama,Udaipur,Rajasthan',
'Salore,Udaipur,Rajasthan',
'Sameecha,Udaipur,Rajasthan',
'Shishoda,Udaipur,Rajasthan',
'Shishvi,Udaipur,Rajasthan',
'Tantol,Udaipur,Rajasthan',
'Usar,Udaipur,Rajasthan',
'Nathdwara Chaupati,Udaipur,Rajasthan',
'Sakroda,Udaipur,Rajasthan',
'Sanghat Kalan,Udaipur,Rajasthan',
'Sayon Ka Khera,Udaipur,Rajasthan',
'Sundarcha,Udaipur,Rajasthan',
'Bamnia Kalan,Udaipur,Rajasthan',
'Banerian,Udaipur,Rajasthan',
'Charana,Udaipur,Rajasthan',
'Chowkdi,Udaipur,Rajasthan',
'Dariba,Udaipur,Rajasthan',
'Gawaardi,Udaipur,Rajasthan',
'Gogathala,Udaipur,Rajasthan',
'Jitawas,Udaipur,Rajasthan',
'Junda,Udaipur,Rajasthan',
'Kabra,Udaipur,Rajasthan',
'Khandel,Udaipur,Rajasthan',
'Kotri,Udaipur,Rajasthan',
'Lapsia,Udaipur,Rajasthan',
'Pipli Dadiyan,Udaipur,Rajasthan',
'Railmagra,Udaipur,Rajasthan',
'Rajpura,Udaipur,Rajasthan',
'Sadri,Udaipur,Rajasthan',
'Sakrawas,Udaipur,Rajasthan',
'Sansera,Udaipur,Rajasthan',
'Charbhuja,Udaipur,Rajasthan',
'Aidana,Udaipur,Rajasthan',
'Ajitgarh,Udaipur,Rajasthan',
'Antalia,Udaipur,Rajasthan',
'Atma,Udaipur,Rajasthan',
'Badrada,Udaipur,Rajasthan',
'Balli Ijassa Kheda,Udaipur,Rajasthan',
'Barar,Udaipur,Rajasthan',
'Bhana,Udaipur,Rajasthan',
'Bhatoli,Udaipur,Rajasthan',
'Bhim,Udaipur,Rajasthan',
'Binol,Udaipur,Rajasthan',
'Boraj,Udaipur,Rajasthan',
'Dansaria,Udaipur,Rajasthan',
'Deogarh,Udaipur,Rajasthan',
'Dhaneen,Udaipur,Rajasthan',
'Dhanyla,Udaipur,Rajasthan',
'Dhoinda,Udaipur,Rajasthan',
'Emdi,Udaipur,Rajasthan',
'Galwa,Udaipur,Rajasthan',
'Ghata,Udaipur,Rajasthan',
'Godhaji Ja Gaon,Udaipur,Rajasthan',
'Jetpura,Udaipur,Rajasthan',
'Jhanjhar,Udaipur,Rajasthan',
'Jhor,Udaipur,Rajasthan',
'Kaladeh,Udaipur,Rajasthan',
'Kalinjar,Udaipur,Rajasthan',
'Kankroli H.O,Udaipur,Rajasthan',
'Kelwa,Udaipur,Rajasthan',
'Khatmala,Udaipur,Rajasthan',
'Koyal,Udaipur,Rajasthan',
'Kukar Khera,Udaipur,Rajasthan',
'Kukra,Udaipur,Rajasthan',
'Mahalon Ki Pipli,Udaipur,Rajasthan',
'Masatiyon Ki Madri,Udaipur,Rajasthan',
'Merda Khalsa,Udaipur,Rajasthan',
'Mundol,Udaipur,Rajasthan',
'Naogama,Udaipur,Rajasthan',
'Padasali,Udaipur,Rajasthan',
'Pasund,Udaipur,Rajasthan',
'Pharara,Udaipur,Rajasthan',
'Phiyawadi,Udaipur,Rajasthan',
'Piparda,Udaipur,Rajasthan',
'Pipli Ahiran,Udaipur,Rajasthan',
'Punawali,Udaipur,Rajasthan',
'Rajiawas,Udaipur,Rajasthan',
'Rajsamand,Udaipur,Rajasthan',
'Samliya,Udaipur,Rajasthan',
'Sapol,Udaipur,Rajasthan',
'Siyana,Udaipur,Rajasthan',
'Tansol,Udaipur,Rajasthan',
'Togi,Udaipur,Rajasthan',
'Tunkra,Udaipur,Rajasthan',
'Piplantri,Udaipur,Rajasthan',
'Bhawa,Udaipur,Rajasthan',
'Aruda PSSK,Sawaimadhopur,Rajasthan',
'Ganvadi Meena PSSK,Sawaimadhopur,Rajasthan',
'Maharajpura,Sawaimadhopur,Rajasthan',
'Piprani PSSK,Sawaimadhopur,Rajasthan',
'Amavragarh,Sawaimadhopur,Rajasthan',
'Badila,Sawaimadhopur,Rajasthan',
'Bairada,Sawaimadhopur,Rajasthan',
'Bamanwas,Sawaimadhopur,Rajasthan',
'Barnala,Sawaimadhopur,Rajasthan',
'Batoda,Sawaimadhopur,Rajasthan',
'Bhanwar,Sawaimadhopur,Rajasthan',
'Bhanwara,Sawaimadhopur,Rajasthan',
'Bichhoch,Sawaimadhopur,Rajasthan',
'Bichpuri,Sawaimadhopur,Rajasthan',
'Binjari,Sawaimadhopur,Rajasthan',
'Chandanholi,Sawaimadhopur,Rajasthan',
'Dabar,Sawaimadhopur,Rajasthan',
'Datasuti P T,Sawaimadhopur,Rajasthan',
'Dungarwada,Sawaimadhopur,Rajasthan',
'Jahra,Sawaimadhopur,Rajasthan',
'Jiwad,Sawaimadhopur,Rajasthan',
'Kakrala,Sawaimadhopur,Rajasthan',
'Kherli,Sawaimadhopur,Rajasthan',
'Koyla,Sawaimadhopur,Rajasthan',
'Liwali,Sawaimadhopur,Rajasthan',
'Mandal,Sawaimadhopur,Rajasthan',
'Meena Koleta,Sawaimadhopur,Rajasthan',
'Mehrawar,Sawaimadhopur,Rajasthan',
'Morpa,Sawaimadhopur,Rajasthan',
'Narauli Chaur,Sawaimadhopur,Rajasthan',
'Palasod,Sawaimadhopur,Rajasthan',
'Phulwada,Sawaimadhopur,Rajasthan',
'Piplai,Sawaimadhopur,Rajasthan',
'Radhopura,Sawaimadhopur,Rajasthan',
'Ranila,Sawaimadhopur,Rajasthan',
'Riwali,Sawaimadhopur,Rajasthan',
'Sancholi,Sawaimadhopur,Rajasthan',
'Shafipura,Sawaimadhopur,Rajasthan',
'Sitod,Sawaimadhopur,Rajasthan',
'Sukar,Sawaimadhopur,Rajasthan',
'Sumel,Sawaimadhopur,Rajasthan',
'Sundery,Sawaimadhopur,Rajasthan',
'Tundila,Sawaimadhopur,Rajasthan',
'Bagdoli,Sawaimadhopur,Rajasthan',
'Bapui,Sawaimadhopur,Rajasthan',
'Bara Gao Sarwar,Sawaimadhopur,Rajasthan',
'Bonli,Sawaimadhopur,Rajasthan',
'Borda,Sawaimadhopur,Rajasthan',
'Datooli,Sawaimadhopur,Rajasthan',
'Didwadi,Sawaimadhopur,Rajasthan',
'Galad Kalan,Sawaimadhopur,Rajasthan',
'Gotod,Sawaimadhopur,Rajasthan',
'Gungorad,Sawaimadhopur,Rajasthan',
'Hathdoli,Sawaimadhopur,Rajasthan',
'Hindupura,Sawaimadhopur,Rajasthan',
'Jastana,Sawaimadhopur,Rajasthan',
'Jhanun,Sawaimadhopur,Rajasthan',
'Kodyai,Sawaimadhopur,Rajasthan',
'Kolada,Sawaimadhopur,Rajasthan',
'Kushalpura,Sawaimadhopur,Rajasthan',
'Lakhanpur,Sawaimadhopur,Rajasthan',
'Mamdoli,Sawaimadhopur,Rajasthan',
'Mitrapura,Sawaimadhopur,Rajasthan',
'Moran,Sawaimadhopur,Rajasthan',
'Nimod,Sawaimadhopur,Rajasthan',
'Pipalda,Sawaimadhopur,Rajasthan',
'Pipalwada,Sawaimadhopur,Rajasthan',
'Rathod,Sawaimadhopur,Rajasthan',
'Udgaon,Sawaimadhopur,Rajasthan',
'Adalwada Kalan,Sawaimadhopur,Rajasthan',
'Ancher,Sawaimadhopur,Rajasthan',
'Badagaon Didayach,Sawaimadhopur,Rajasthan',
'Bagina,Sawaimadhopur,Rajasthan',
'Balaria,Sawaimadhopur,Rajasthan',
'Bhagwatgarh,Sawaimadhopur,Rajasthan',
'Bhedola,Sawaimadhopur,Rajasthan',
'Binjari,Sawaimadhopur,Rajasthan',
'Chauth Ka Barwara,Sawaimadhopur,Rajasthan',
'Isharda,Sawaimadhopur,Rajasthan',
'Jhopra,Sawaimadhopur,Rajasthan',
'Jonla,Sawaimadhopur,Rajasthan',
'Mahapura,Sawaimadhopur,Rajasthan',
'Panwdera,Sawaimadhopur,Rajasthan',
'Rajmana,Sawaimadhopur,Rajasthan',
'Sarsop,Sawaimadhopur,Rajasthan',
'Tapur,Sawaimadhopur,Rajasthan',
'Shiwar,Sawaimadhopur,Rajasthan',
'Ahmadpur,Sawaimadhopur,Rajasthan',
'Amargarh Chaur,Sawaimadhopur,Rajasthan',
'Badhkalan,Sawaimadhopur,Rajasthan',
'Baglai,Sawaimadhopur,Rajasthan',
'Baman Baroda,Sawaimadhopur,Rajasthan',
'Baroli,Sawaimadhopur,Rajasthan',
'Binega,Sawaimadhopur,Rajasthan',
'Bucholai,Sawaimadhopur,Rajasthan',
'Chhawa,Sawaimadhopur,Rajasthan',
'Choti Udai,Sawaimadhopur,Rajasthan',
'Chuli,Sawaimadhopur,Rajasthan',
'Gangapur Bazar,Sawaimadhopur,Rajasthan',
'Gangapur H.O,Sawaimadhopur,Rajasthan',
'Jiwali,Sawaimadhopur,Rajasthan',
'Khandeep,Sawaimadhopur,Rajasthan',
'Khanpur Baroda,Sawaimadhopur,Rajasthan',
'Krishi Upaj Mandi Gangapur,Sawaimadhopur,Rajasthan',
'Lalpur Umri,Sawaimadhopur,Rajasthan',
'Mahanandpur,Sawaimadhopur,Rajasthan',
'Mahukala,Sawaimadhopur,Rajasthan',
'Medi,Sawaimadhopur,Rajasthan',
'Meena Baroda,Sawaimadhopur,Rajasthan',
'Mohcha,Sawaimadhopur,Rajasthan',
'Narayanpur Tatwara,Sawaimadhopur,Rajasthan',
'New Mandi Gangapur,Sawaimadhopur,Rajasthan',
'Nogaon,Sawaimadhopur,Rajasthan',
'Phoolwada Popat,Sawaimadhopur,Rajasthan',
'Piloda,Sawaimadhopur,Rajasthan',
'Railway Colony Gangapur,Sawaimadhopur,Rajasthan',
'Raipur,Sawaimadhopur,Rajasthan',
'Rendayal Gurjar,Sawaimadhopur,Rajasthan',
'Salempur,Sawaimadhopur,Rajasthan',
'Seva,Sawaimadhopur,Rajasthan',
'Shyaroli,Sawaimadhopur,Rajasthan',
'Talawada,Sawaimadhopur,Rajasthan',
'Toksi,Sawaimadhopur,Rajasthan',
'Udaikalan,Sawaimadhopur,Rajasthan',
'Wazirpur,Sawaimadhopur,Rajasthan',
'Khoontala,Sawaimadhopur,Rajasthan',
'Pawata Gaddi,Sawaimadhopur,Rajasthan',
'Akhaigarh,Sawaimadhopur,Rajasthan',
'Alapur,Sawaimadhopur,Rajasthan',
'Aniyala,Sawaimadhopur,Rajasthan',
'Badwas,Sawaimadhopur,Rajasthan',
'Baharnwanda Khurd,Sawaimadhopur,Rajasthan',
'Baler,Sawaimadhopur,Rajasthan',
'Barnawada,Sawaimadhopur,Rajasthan',
'Barod,Sawaimadhopur,Rajasthan',
'Bhahraonda Kalan,Sawaimadhopur,Rajasthan',
'Bhoori Pahari,Sawaimadhopur,Rajasthan',
'Bichpuri Gujran,Sawaimadhopur,Rajasthan',
'Chhan,Sawaimadhopur,Rajasthan',
'Daulatpura,Sawaimadhopur,Rajasthan',
'Doongri,Sawaimadhopur,Rajasthan',
'Gandawar,Sawaimadhopur,Rajasthan',
'Goth Bihari,Sawaimadhopur,Rajasthan',
'Gothra,Sawaimadhopur,Rajasthan',
'Khandar,Sawaimadhopur,Rajasthan',
'Kosra Chhareta Tod,Sawaimadhopur,Rajasthan',
'Kuredi,Sawaimadhopur,Rajasthan',
'Kyarda Kalan,Sawaimadhopur,Rajasthan',
'Mai Kalan,Sawaimadhopur,Rajasthan',
'Naypur,Sawaimadhopur,Rajasthan',
'Padri,Sawaimadhopur,Rajasthan',
'Redawat,Sawaimadhopur,Rajasthan',
'Singor Kalan,Sawaimadhopur,Rajasthan',
'Talwada,Sawaimadhopur,Rajasthan',
'Malrna Chaur,Sawaimadhopur,Rajasthan',
'Malrna Doongar,Sawaimadhopur,Rajasthan',
'Nimod,Sawaimadhopur,Rajasthan',
'Sankara,Sawaimadhopur,Rajasthan',
'Bhadoti,Sawaimadhopur,Rajasthan',
'Bichhi Doona,Sawaimadhopur,Rajasthan',
'Gambhira,Sawaimadhopur,Rajasthan',
'Jolanda,Sawaimadhopur,Rajasthan',
'Khirni,Sawaimadhopur,Rajasthan',
'Maksudanpura,Sawaimadhopur,Rajasthan',
'Malarna R S,Sawaimadhopur,Rajasthan',
'Shesha,Sawaimadhopur,Rajasthan',
'Taranpur,Sawaimadhopur,Rajasthan',
'Behted,Sawaimadhopur,Rajasthan',
'Bhooka,Sawaimadhopur,Rajasthan',
'Falsawata,Sawaimadhopur,Rajasthan',
'Rampura PSSK,Sawaimadhopur,Rajasthan',
'Adarsh Nagar,Sawaimadhopur,Rajasthan',
'Ajnoti,Sawaimadhopur,Rajasthan',
'Alanpur,Sawaimadhopur,Rajasthan',
'Atunkalan,Sawaimadhopur,Rajasthan',
'Aulwada,Sawaimadhopur,Rajasthan',
'Badolas,Sawaimadhopur,Rajasthan',
'Bhadlav,Sawaimadhopur,Rajasthan',
'Chakeri,Sawaimadhopur,Rajasthan',
'Chharoda,Sawaimadhopur,Rajasthan',
'Chitara,Sawaimadhopur,Rajasthan',
'Dakwa,Sawaimadhopur,Rajasthan',
'Dangarwada,Sawaimadhopur,Rajasthan',
'Dhamun Khurd,Sawaimadhopur,Rajasthan',
'Dhanoli,Sawaimadhopur,Rajasthan',
'Dubbi,Sawaimadhopur,Rajasthan',
'Dumoda,Sawaimadhopur,Rajasthan',
'Endwa,Sawaimadhopur,Rajasthan',
'Ghimeera,Sawaimadhopur,Rajasthan',
'Jadawata,Sawaimadhopur,Rajasthan',
'Jatwara Kalan,Sawaimadhopur,Rajasthan',
'Jinapur,Sawaimadhopur,Rajasthan',
'Karmoda,Sawaimadhopur,Rajasthan',
'Khandeola,Sawaimadhopur,Rajasthan',
'Khatupura,Sawaimadhopur,Rajasthan',
'Khijuri,Sawaimadhopur,Rajasthan',
'Kundera,Sawaimadhopur,Rajasthan',
'Kustala,Sawaimadhopur,Rajasthan',
'Lahsoda,Sawaimadhopur,Rajasthan',
'Lorwara,Sawaimadhopur,Rajasthan',
'Mainpura,Sawaimadhopur,Rajasthan',
'Makholi,Sawaimadhopur,Rajasthan',
'Mui,Sawaimadhopur,Rajasthan',
'Nindarda,Sawaimadhopur,Rajasthan',
'Padana,Sawaimadhopur,Rajasthan',
'Pali PSSK,Sawaimadhopur,Rajasthan',
'Pancholas,Sawaimadhopur,Rajasthan',
'Phalodi,Sawaimadhopur,Rajasthan',
'Phalodi Quarry,Sawaimadhopur,Rajasthan',
'Ramdi,Sawaimadhopur,Rajasthan',
'Rawal,Sawaimadhopur,Rajasthan',
'Rawanjana Chaur,Sawaimadhopur,Rajasthan',
'Rawanjana Doongar,Sawaimadhopur,Rajasthan',
'Sawaimadhopur Bazar,Sawaimadhopur,Rajasthan',
'Sawaimadhopur H.O,Sawaimadhopur,Rajasthan',
'Sawaimadhopur Town,Sawaimadhopur,Rajasthan',
'Selu,Sawaimadhopur,Rajasthan',
'Shayampura,Sawaimadhopur,Rajasthan',
'Sherpur Khilchipur,Sawaimadhopur,Rajasthan',
'Sherpur PSSK,Sawaimadhopur,Rajasthan',
'Soorwal,Sawaimadhopur,Rajasthan',
'Sunari,Sawaimadhopur,Rajasthan',
'Banura,Sikar,Rajasthan',
'Bhudoli,Sikar,Rajasthan',
'Birodi Chotti,Sikar,Rajasthan',
'Birodibadi,Sikar,Rajasthan',
'Chala,Sikar,Rajasthan',
'Churi Miyon,Sikar,Rajasthan',
'Dabla,Sikar,Rajasthan',
'Deorala,Sikar,Rajasthan',
'Doodwa,Sikar,Rajasthan',
'Garoda,Sikar,Rajasthan',
'Godawas,Sikar,Rajasthan',
'Govindpura,Sikar,Rajasthan',
'Hapawali,Sikar,Rajasthan',
'Jassika Kabas,Sikar,Rajasthan',
'Kanchanpur,Sikar,Rajasthan',
'Karad,Sikar,Rajasthan',
'Kasli,Sikar,Rajasthan',
'Khadra,Sikar,Rajasthan',
'Kheerwa,Sikar,Rajasthan',
'Khinwasar,Sikar,Rajasthan',
'Kotra,Sikar,Rajasthan',
'Ladhana,Sikar,Rajasthan',
'Mahawa,Sikar,Rajasthan',
'Mandholi,Sikar,Rajasthan',
'Nayabas,Sikar,Rajasthan',
'Nimod,Sikar,Rajasthan',
'Pachar,Sikar,Rajasthan',
'Palas,Sikar,Rajasthan',
'Panlawa,Sikar,Rajasthan',
'Pithalpur,Sikar,Rajasthan',
'Puranabas,Sikar,Rajasthan',
'Raghonathgarh,Sikar,Rajasthan',
'Rajpura,Sikar,Rajasthan',
'Sesam,Sikar,Rajasthan',
'Akwa,Sikar,Rajasthan',
'Almas,Sikar,Rajasthan',
'Athwas,Sikar,Rajasthan',
'Badhadhar,Sikar,Rajasthan',
'Badusar,Sikar,Rajasthan',
'Bagri,Sikar,Rajasthan',
'Bagroda,Sikar,Rajasthan',
'Bairas,Sikar,Rajasthan',
'Balod Bhakaran,Sikar,Rajasthan',
'Balod Chhoti,Sikar,Rajasthan',
'Banthod,Sikar,Rajasthan',
'Bari,Sikar,Rajasthan',
'Batranau,Sikar,Rajasthan',
'Bhagasara,Sikar,Rajasthan',
'Bheenchari,Sikar,Rajasthan',
'Bhooma Bada,Sikar,Rajasthan',
'Bibipur,Sikar,Rajasthan',
'Birania,Sikar,Rajasthan',
'Chachiwad,Sikar,Rajasthan',
'Chuwas,Sikar,Rajasthan',
'Dabri,Sikar,Rajasthan',
'Dantru,Sikar,Rajasthan',
'Deenwa,Sikar,Rajasthan',
'Dewas,Sikar,Rajasthan',
'Dhakas,Sikar,Rajasthan',
'Dhanani,Sikar,Rajasthan',
'Dinwa,Sikar,Rajasthan',
'Disnau,Sikar,Rajasthan',
'Fadanpura,Sikar,Rajasthan',
'Fatehpur Shekhawati,Sikar,Rajasthan',
'Gangiasar,Sikar,Rajasthan',
'Garinda,Sikar,Rajasthan',
'Gassu,Sikar,Rajasthan',
'Godia Bada,Sikar,Rajasthan',
'Hamirpura,Sikar,Rajasthan',
'Harsawa,Sikar,Rajasthan',
'Hirna,Sikar,Rajasthan',
'Hudera,Sikar,Rajasthan',
'Jalalsar,Sikar,Rajasthan',
'Jasrasar,Sikar,Rajasthan',
'Juliasar,Sikar,Rajasthan',
'Karanga Bada,Sikar,Rajasthan',
'Kaswali,Sikar,Rajasthan',
'Kheri Radan,Sikar,Rajasthan',
'Khotiya,Sikar,Rajasthan',
'Kumas,Sikar,Rajasthan',
'Lalasi,Sikar,Rajasthan',
'Madhopura,Sikar,Rajasthan',
'Mandela Bada,Sikar,Rajasthan',
'Mandela Chhota,Sikar,Rajasthan',
'Mangloona,Sikar,Rajasthan',
'Nabipura,Sikar,Rajasthan',
'Narodara,Sikar,Rajasthan',
'Narsas,Sikar,Rajasthan',
'Nayabas,Sikar,Rajasthan',
'Neemakidhani,Sikar,Rajasthan',
'Nethwa,Sikar,Rajasthan',
'Palthana,Sikar,Rajasthan',
'Rahnawa,Sikar,Rajasthan',
'Rajas,Sikar,Rajasthan',
'Rajpura,Sikar,Rajasthan',
'Ramshisar,Sikar,Rajasthan',
'Rashidpura,Sikar,Rajasthan',
'Rosawa,Sikar,Rajasthan',
'Sahnusar,Sikar,Rajasthan',
'Sankhu,Sikar,Rajasthan',
'Sanwaloda Dhayalan,Sikar,Rajasthan',
'Sanwloda Ladkhani,Sikar,Rajasthan',
'Sanwloda Purohitan,Sikar,Rajasthan',
'Sekhisar,Sikar,Rajasthan',
'Singodra,Sikar,Rajasthan',
'Tajsar,Sikar,Rajasthan',
'Takhalsar,Sikar,Rajasthan',
'Thedi,Sikar,Rajasthan',
'Thimoli,Sikar,Rajasthan',
'Tihay,Sikar,Rajasthan',
'Beedasar,Sikar,Rajasthan',
'Beswa,Sikar,Rajasthan',
'Dhandhan,Sikar,Rajasthan',
'Fatehpur Bazar,Sikar,Rajasthan',
'Jajod,Sikar,Rajasthan',
'Kayamsar,Sikar,Rajasthan',
'Khuri Badi,Sikar,Rajasthan',
'Ramgarh Bazar,Sikar,Rajasthan',
'Ramgarh Shekhawati,Sikar,Rajasthan',
'Rolsabsar,Sikar,Rajasthan',
'Roru Badi,Sikar,Rajasthan',
'Sadinsar,Sikar,Rajasthan',
'Sikaria Baza-Fatehpur,Sikar,Rajasthan',
'Tihawali,Sikar,Rajasthan',
'Lachhmangarh Bazar,Sikar,Rajasthan',
'Lachhmangarh,Sikar,Rajasthan',
'Nayama Baza- Lachhmangarh,Sikar,Rajasthan',
'Athbigha,Sikar,Rajasthan',
'Ballupura,Sikar,Rajasthan',
'Bamanwas,Sikar,Rajasthan',
'Barsinghpura,Sikar,Rajasthan',
'Basri,Sikar,Rajasthan',
'Basri Khurd,Sikar,Rajasthan',
'Bhadwari,Sikar,Rajasthan',
'Bhagoth,Sikar,Rajasthan',
'Bhagwanpura,Sikar,Rajasthan',
'Bhojpur,Sikar,Rajasthan',
'Bihar,Sikar,Rajasthan',
'Biharipur,Sikar,Rajasthan',
'Chhajakinangal,Sikar,Rajasthan',
'Chiplata,Sikar,Rajasthan',
'Chowkri,Sikar,Rajasthan',
'Dalpatpura,Sikar,Rajasthan',
'Dariba,Sikar,Rajasthan',
'Dayalkinangal,Sikar,Rajasthan',
'Dayara,Sikar,Rajasthan',
'Deepawas,Sikar,Rajasthan',
'Dhani Guman Singh,Sikar,Rajasthan',
'Dhani Jorawarsingh,Sikar,Rajasthan',
'Dokan,Sikar,Rajasthan',
'Doongakinangal,Sikar,Rajasthan',
'Dudhwalonkabas,Sikar,Rajasthan',
'Fatehpura,Sikar,Rajasthan',
'Ganeshwar,Sikar,Rajasthan',
'Ganwari,Sikar,Rajasthan',
'Garh Bhopji,Sikar,Rajasthan',
'Ghasipura,Sikar,Rajasthan',
'Gokulkabas,Sikar,Rajasthan',
'Guhala,Sikar,Rajasthan',
'Gurara,Sikar,Rajasthan',
'Hamspur,Sikar,Rajasthan',
'Hardaskabas,Sikar,Rajasthan',
'Haripura,Sikar,Rajasthan',
'Harjanpura,Sikar,Rajasthan',
'Hasampur,Sikar,Rajasthan',
'Hathideh,Sikar,Rajasthan',
'Hod,Sikar,Rajasthan',
'Holikabas,Sikar,Rajasthan',
'Jairampura,Sikar,Rajasthan',
'Jharli,Sikar,Rajasthan',
'Jillo,Sikar,Rajasthan',
'Jugalpura,Sikar,Rajasthan',
'Kalyanpura,Sikar,Rajasthan',
'Kanw R.S.,Sikar,Rajasthan',
'Kanwat Town,Sikar,Rajasthan',
'Kardka,Sikar,Rajasthan',
'Kerpura,Sikar,Rajasthan',
'Khandela,Sikar,Rajasthan',
'Khatundra,Sikar,Rajasthan',
'Khiroti,Sikar,Rajasthan',
'Kotri,Sikar,Rajasthan',
'Ladikabas,Sikar,Rajasthan',
'Lorwara,Sikar,Rajasthan',
'Makri,Sikar,Rajasthan',
'Maonda Kalan,Sikar,Rajasthan',
'Maonda Khurd,Sikar,Rajasthan',
'Maonda RS,Sikar,Rajasthan',
'Mokalwas,Sikar,Rajasthan',
'N.P.Khandela,Sikar,Rajasthan',
'Narsinghpuri,Sikar,Rajasthan',
'Nathakinangal,Sikar,Rajasthan',
'Neemki,Sikar,Rajasthan',
'Nimkathana,Sikar,Rajasthan',
'Nimkathana Town,Sikar,Rajasthan',
'Paniharwas,Sikar,Rajasthan',
'Patan,Sikar,Rajasthan',
'Pritampuri,Sikar,Rajasthan',
'Raipur,Sikar,Rajasthan',
'Rajpura,Sikar,Rajasthan',
'Rampura,Sikar,Rajasthan',
'Rampura,Sikar,Rajasthan',
'Rampura,Sikar,Rajasthan',
'Ramsinghkidhani,Sikar,Rajasthan',
'Rooppura,Sikar,Rajasthan',
'Royal,Sikar,Rajasthan',
'Sakraimata,Sikar,Rajasthan',
'Saledipura,Sikar,Rajasthan',
'Samrathpura,Sikar,Rajasthan',
'Sanwalpura Shekhawatan,Sikar,Rajasthan',
'Sanwalpura Tanwaran,Sikar,Rajasthan',
'Shyamgarh,Sikar,Rajasthan',
'Shyampura,Sikar,Rajasthan',
'Sihori,Sikar,Rajasthan',
'Simrala,Sikar,Rajasthan',
'Sirohi,Sikar,Rajasthan',
'Surani,Sikar,Rajasthan',
'Thoi,Sikar,Rajasthan',
'Tiwarikidhani,Sikar,Rajasthan',
'Toda,Sikar,Rajasthan',
'Abhaipura,Sikar,Rajasthan',
'Ajabpura,Sikar,Rajasthan',
'Alkhpura Bogan,Sikar,Rajasthan',
'Anokhu,Sikar,Rajasthan',
'Antri,Sikar,Rajasthan',
'Badalwas,Sikar,Rajasthan',
'Bajaj Road-Sikar,Sikar,Rajasthan',
'Bajajgram,Sikar,Rajasthan',
'Bajore,Sikar,Rajasthan',
'Balaran,Sikar,Rajasthan',
'Baral,Sikar,Rajasthan',
'Barsinghpura,Sikar,Rajasthan',
'Bathot,Sikar,Rajasthan',
'Beri,Sikar,Rajasthan',
'Bhadwasi,Sikar,Rajasthan',
'Bhagatpura,Sikar,Rajasthan',
'Bhaironpura,Sikar,Rajasthan',
'Bhilunda,Sikar,Rajasthan',
'Bhirana,Sikar,Rajasthan',
'Bhojasar,Sikar,Rajasthan',
'Bhuma,Sikar,Rajasthan',
'Bhuwala,Sikar,Rajasthan',
'Bidoli,Sikar,Rajasthan',
'Binjasi,Sikar,Rajasthan',
'Bochi,Sikar,Rajasthan',
'Bosana,Sikar,Rajasthan',
'Chandpura,Sikar,Rajasthan',
'Chimanpura,Sikar,Rajasthan',
'Chirasara,Sikar,Rajasthan',
'Dadia,Sikar,Rajasthan',
'Deogarh,Sikar,Rajasthan',
'Devipura,Sikar,Rajasthan',
'Dher Ka Bas,Sikar,Rajasthan',
'Dhod,Sikar,Rajasthan',
'Dinarpura,Sikar,Rajasthan',
'Dookia,Sikar,Rajasthan',
'Dudhwa,Sikar,Rajasthan',
'Dugoli,Sikar,Rajasthan',
'Dujod,Sikar,Rajasthan',
'Fatehpura,Sikar,Rajasthan',
'Fatehpuri Gate,Sikar,Rajasthan',
'Gandhinagar,Sikar,Rajasthan',
'Ganeri,Sikar,Rajasthan',
'Ghana,Sikar,Rajasthan',
'Ghirnia Bada,Sikar,Rajasthan',
'Gokulpura,Sikar,Rajasthan',
'Gordhanpura,Sikar,Rajasthan',
'Goriyan,Sikar,Rajasthan',
'Gothra Bhukaran,Sikar,Rajasthan',
'Gothra Taglan,Sikar,Rajasthan',
'Govati,Sikar,Rajasthan',
'Govindpura,Sikar,Rajasthan',
'Gudha Chhota,Sikar,Rajasthan',
'Gunatoo,Sikar,Rajasthan',
'Gungara,Sikar,Rajasthan',
'Hapas,Sikar,Rajasthan',
'Hardayalpura,Sikar,Rajasthan',
'Harsh,Sikar,Rajasthan',
'Hospital Road,Sikar,Rajasthan',
'Jachas,Sikar,Rajasthan',
'Jana,Sikar,Rajasthan',
'Jeenmata,Sikar,Rajasthan',
'Jeenwas,Sikar,Rajasthan',
'Jheegar Chhoti,Sikar,Rajasthan',
'Jurathara,Sikar,Rajasthan',
'Kachhwa,Sikar,Rajasthan',
'Kanwarpura,Sikar,Rajasthan',
'Kashikabas,Sikar,Rajasthan',
'Katrathal,Sikar,Rajasthan',
'Khakholi,Sikar,Rajasthan',
'Khandelsar,Sikar,Rajasthan',
'Khanri,Sikar,Rajasthan',
'Khoor,Sikar,Rajasthan',
'Kirdoli,Sikar,Rajasthan',
'Kochhore,Sikar,Rajasthan',
'Kolida,Sikar,Rajasthan',
'Koodan,Sikar,Rajasthan',
'Kothyari,Sikar,Rajasthan',
'Kudli,Sikar,Rajasthan',
'Kumas,Sikar,Rajasthan',
'Kushalpura,Sikar,Rajasthan',
'Losal Bazar,Sikar,Rajasthan',
'Losal Chhoti,Sikar,Rajasthan',
'Losal,Sikar,Rajasthan',
'Mandawara,Sikar,Rajasthan',
'Mandha Madni,Sikar,Rajasthan',
'Mandota,Sikar,Rajasthan',
'Miran,Sikar,Rajasthan',
'Mochiwara,Sikar,Rajasthan',
'Mohanpura,Sikar,Rajasthan',
'Molyasi,Sikar,Rajasthan',
'Mordunga,Sikar,Rajasthan',
'Mundawara,Sikar,Rajasthan',
'Nagwa,Sikar,Rajasthan',
'Nathawatpura,Sikar,Rajasthan',
'Nechhwa,Sikar,Rajasthan',
'Netarwas,Sikar,Rajasthan',
'Nimera,Sikar,Rajasthan',
'Palasara,Sikar,Rajasthan',
'Palri,Sikar,Rajasthan',
'Palsana,Sikar,Rajasthan',
'Palwas,Sikar,Rajasthan',
'Pardoli Badi,Sikar,Rajasthan',
'Patoda,Sikar,Rajasthan',
'Pewa,Sikar,Rajasthan',
'Phagalwa,Sikar,Rajasthan',
'Piprali,Sikar,Rajasthan',
'Posani,Sikar,Rajasthan',
'Prithvipura,Sikar,Rajasthan',
'Puran Badi,Sikar,Rajasthan',
'Purohitkabas,Sikar,Rajasthan',
'Rajpur,Sikar,Rajasthan',
'Rajpura,Sikar,Rajasthan',
'Ralwata,Sikar,Rajasthan',
'Ranoli,Sikar,Rajasthan',
'Reta,Sikar,Rajasthan',
'Rewasa,Sikar,Rajasthan',
'Roopgarh,Sikar,Rajasthan',
'Rulyana Mali,Sikar,Rajasthan',
'Rulyani,Sikar,Rajasthan',
'Sabalpura,Sikar,Rajasthan',
'Sami,Sikar,Rajasthan',
'Sangarwa,Sikar,Rajasthan',
'Sangliya,Sikar,Rajasthan',
'Sarwari,Sikar,Rajasthan',
'Sewa,Sikar,Rajasthan',
'Sewad Badi,Sikar,Rajasthan',
'Shahpura,Sikar,Rajasthan',
'Sherpura Sujas,Sikar,Rajasthan',
'Shishu,Sikar,Rajasthan',
'Shyampura,Sikar,Rajasthan',
'Shyampura,Sikar,Rajasthan',
'Sihot Badi,Sikar,Rajasthan',
'Sihot Chhoti,Sikar,Rajasthan',
'Sikar H.O,Sikar,Rajasthan',
'Singhasan,Sikar,Rajasthan',
'Singrawat,Sikar,Rajasthan',
'Sola,Sikar,Rajasthan',
'Subhash Nagar,Sikar,Rajasthan',
'Sujanpura,Sikar,Rajasthan',
'Sunderpura,Sikar,Rajasthan',
'Sutod,Sikar,Rajasthan',
'Sutot,Sikar,Rajasthan',
'Tarpura,Sikar,Rajasthan',
'Tasar Badi,Sikar,Rajasthan',
'Tatanwa,Sikar,Rajasthan',
'Tiroki Badi,Sikar,Rajasthan',
'Trilokpura,Sikar,Rajasthan',
'Tunwa,Sikar,Rajasthan',
'Ved Ki Dhani,Sikar,Rajasthan',
'Yalsar,Sikar,Rajasthan',
'Abhawas,Sikar,Rajasthan',
'Ajitgarh Amarsar,Sikar,Rajasthan',
'Ajmeri,Sikar,Rajasthan',
'Aloda,Sikar,Rajasthan',
'Arnia,Sikar,Rajasthan',
'Aspura,Sikar,Rajasthan',
'Bagriawas,Sikar,Rajasthan',
'Bajiawas,Sikar,Rajasthan',
'Banathala,Sikar,Rajasthan',
'Baori,Sikar,Rajasthan',
'Bassi,Sikar,Rajasthan',
'Baya,Sikar,Rajasthan',
'Bharija,Sikar,Rajasthan',
'Bharni,Sikar,Rajasthan',
'Bhopatpura,Sikar,Rajasthan',
'Bhurdonkabas,Sikar,Rajasthan',
'Chakgopinathpura,Sikar,Rajasthan',
'Charanwas,Sikar,Rajasthan',
'Chomupurohitan,Sikar,Rajasthan',
'Dadia Rampura,Sikar,Rajasthan',
'Dansroli,Sikar,Rajasthan',
'Danta Ramgarh,Sikar,Rajasthan',
'Danta,Sikar,Rajasthan',
'Dhabawali,Sikar,Rajasthan',
'Dhaliawas,Sikar,Rajasthan',
'Dhingpur,Sikar,Rajasthan',
'Dholasari,Sikar,Rajasthan',
'Ganora,Sikar,Rajasthan',
'Garh Taknet,Sikar,Rajasthan',
'Goriyan,Sikar,Rajasthan',
'Gudha,Sikar,Rajasthan',
'Jajod,Sikar,Rajasthan',
'Jalund,Sikar,Rajasthan',
'Jankipura,Sikar,Rajasthan',
'Jetusar,Sikar,Rajasthan',
'Jugrajpura,Sikar,Rajasthan',
'Kankra,Sikar,Rajasthan',
'Kantia,Sikar,Rajasthan',
'Kasarda,Sikar,Rajasthan',
'Khachariawas,Sikar,Rajasthan',
'Khatushyamjika,Sikar,Rajasthan',
'Khora,Sikar,Rajasthan',
'Kishorepura,Sikar,Rajasthan',
'Koolie,Sikar,Rajasthan',
'Kotri,Sikar,Rajasthan',
'Kotri Dhayalan,Sikar,Rajasthan',
'Ladpur,Sikar,Rajasthan',
'Ladpur,Sikar,Rajasthan',
'Lakhani,Sikar,Rajasthan',
'Lamiya,Sikar,Rajasthan',
'Lampuwa,Sikar,Rajasthan',
'Likhma Ka Bas,Sikar,Rajasthan',
'Lisariya,Sikar,Rajasthan',
'Mahroli,Sikar,Rajasthan',
'Malikpur,Sikar,Rajasthan',
'Mandha Surera,Sikar,Rajasthan',
'Mandusiya,Sikar,Rajasthan',
'Mau,Sikar,Rajasthan',
'Meirajanpura,Sikar,Rajasthan',
'Mota Ki Dhani,Sikar,Rajasthan',
'Motlawas,Sikar,Rajasthan',
'Mundiawas,Sikar,Rajasthan',
'Mundru,Sikar,Rajasthan',
'Nangal Bhim,Sikar,Rajasthan',
'Nangal Nathusar,Sikar,Rajasthan',
'Nathusar,Sikar,Rajasthan',
'Neemawas,Sikar,Rajasthan',
'Nimera,Sikar,Rajasthan',
'Patwari Ka Bas,Sikar,Rajasthan',
'Prithvipura,Sikar,Rajasthan',
'Raipur Jagir,Sikar,Rajasthan',
'Rajpura Nosal,Sikar,Rajasthan',
'Ralawata,Sikar,Rajasthan',
'Ratanpura,Sikar,Rajasthan',
'Ringas,Sikar,Rajasthan',
'Ringas Town,Sikar,Rajasthan',
'Rulana,Sikar,Rajasthan',
'Samer,Sikar,Rajasthan',
'Sargoth,Sikar,Rajasthan',
'Sawaipura,Sikar,Rajasthan',
'Seepur,Sikar,Rajasthan',
'Shahpura,Sikar,Rajasthan',
'Shola,Sikar,Rajasthan',
'Shyampura,Sikar,Rajasthan',
'Simarla Pironka,Sikar,Rajasthan',
'Srimadhopur Bazar,Sikar,Rajasthan',
'Srimadhopur H.O,Sikar,Rajasthan',
'Srimadhopur R.S.,Sikar,Rajasthan',
'Suliawas,Sikar,Rajasthan',
'Surani Bazar Srimadhopur,Sikar,Rajasthan',
'Surera,Sikar,Rajasthan',
'Tapiplya,Sikar,Rajasthan',
'Tatera,Sikar,Rajasthan',
'Thikaria,Sikar,Rajasthan',
'Tiwari Ki Dhani,Sikar,Rajasthan',
'Umara,Sikar,Rajasthan',
'Vijaypura,Sikar,Rajasthan',
'A.I.A. Aburoad,Sirohi,Rajasthan',
'Aburoad Bazar,Sirohi,Rajasthan',
'Aburoad Disel Shed,Sirohi,Rajasthan',
'Aburoad Gandhi Nagar,Sirohi,Rajasthan',
'Achpura,Sirohi,Rajasthan',
'Ajari,Sirohi,Rajasthan',
'Akrabhatta,Sirohi,Rajasthan',
'Alpa,Sirohi,Rajasthan',
'Amlari,Sirohi,Rajasthan',
'Amli,Sirohi,Rajasthan',
'Amthala,Sirohi,Rajasthan',
'Andore,Sirohi,Rajasthan',
'Arathwara,Sirohi,Rajasthan',
'Awal,Sirohi,Rajasthan',
'Badgaon,Sirohi,Rajasthan',
'Bagseen,Sirohi,Rajasthan',
'Bahadurpura,Sirohi,Rajasthan',
'Bant,Sirohi,Rajasthan',
'Barloot,Sirohi,Rajasthan',
'Basan,Sirohi,Rajasthan',
'Basantgarh,Sirohi,Rajasthan',
'Bharja,Sirohi,Rajasthan',
'Bhatana,Sirohi,Rajasthan',
'Bhawari,Sirohi,Rajasthan',
'Bherugarh,Sirohi,Rajasthan',
'Bhev,Sirohi,Rajasthan',
'Bhimana R.S.,Sirohi,Rajasthan',
'Bhula,Sirohi,Rajasthan',
'Bhutgaon,Sirohi,Rajasthan',
'Chadual,Sirohi,Rajasthan',
'Chandela,Sirohi,Rajasthan',
'Chandrawati,Sirohi,Rajasthan',
'Channar,Sirohi,Rajasthan',
'Chhibagaon,Sirohi,Rajasthan',
'Chuli,Sirohi,Rajasthan',
'Dabani,Sirohi,Rajasthan',
'Dak,Sirohi,Rajasthan',
'Dattani,Sirohi,Rajasthan',
'Deldar,Sirohi,Rajasthan',
'Deldear,Sirohi,Rajasthan',
'Delwara,Sirohi,Rajasthan',
'Derri,Sirohi,Rajasthan',
'Dhan,Sirohi,Rajasthan',
'Dhanari,Sirohi,Rajasthan',
'Dhavli,Sirohi,Rajasthan',
'Dhurbana,Sirohi,Rajasthan',
'Doytra,Sirohi,Rajasthan',
'Ganka,Sirohi,Rajasthan',
'Girwar,Sirohi,Rajasthan',
'Gohili,Sirohi,Rajasthan',
'Gol,Sirohi,Rajasthan',
'Gulabganj,Sirohi,Rajasthan',
'Haliwara,Sirohi,Rajasthan',
'Hathal,Sirohi,Rajasthan',
'Ishra,Sirohi,Rajasthan',
'Jamburi,Sirohi,Rajasthan',
'Janapur,Sirohi,Rajasthan',
'Jayadara,Sirohi,Rajasthan',
'Jeerwal,Sirohi,Rajasthan',
'Jela,Sirohi,Rajasthan',
'Jetawara,Sirohi,Rajasthan',
'Jetpura,Sirohi,Rajasthan',
'Jhadoli,Sirohi,Rajasthan',
'Jhadoliveer,Sirohi,Rajasthan',
'Jogapura,Sirohi,Rajasthan',
'Jolapur,Sirohi,Rajasthan',
'Joyla,Sirohi,Rajasthan',
'Kachholi,Sirohi,Rajasthan',
'Kermandwara,Sirohi,Rajasthan',
'Kesharpura,Sirohi,Rajasthan',
'Khadat,Sirohi,Rajasthan',
'Khambal,Sirohi,Rajasthan',
'Khandera,Sirohi,Rajasthan',
'Kiverli,Sirohi,Rajasthan',
'Kojra,Sirohi,Rajasthan',
'Krishnaganj,Sirohi,Rajasthan',
'Kyariya,Sirohi,Rajasthan',
'Lass,Sirohi,Rajasthan',
'Lunol,Sirohi,Rajasthan',
'Madia,Sirohi,Rajasthan',
'Magriwara,Sirohi,Rajasthan',
'Makawal,Sirohi,Rajasthan',
'Makroda,Sirohi,Rajasthan',
'Malgaon,Sirohi,Rajasthan',
'Mamawali,Sirohi,Rajasthan',
'Manadar,Sirohi,Rajasthan',
'Mandani,Sirohi,Rajasthan',
'Mandwa,Sirohi,Rajasthan',
'Mandwara,Sirohi,Rajasthan',
'Mandwarakhalsa,Sirohi,Rajasthan',
'Mandwaria,Sirohi,Rajasthan',
'Manora,Sirohi,Rajasthan',
'Marol,Sirohi,Rajasthan',
'Mawal,Sirohi,Rajasthan',
'Mermandwara,Sirohi,Rajasthan',
'Mohabbatnagar,Sirohi,Rajasthan',
'Moras,Sirohi,Rajasthan',
'Morli,Sirohi,Rajasthan',
'Morthala,Sirohi,Rajasthan',
'Muderla,Sirohi,Rajasthan',
'Mungthala,Sirohi,Rajasthan',
'Nagani,Sirohi,Rajasthan',
'Nandia,Sirohi,Rajasthan',
'Naradara,Sirohi,Rajasthan',
'Nawara,Sirohi,Rajasthan',
'Nichalagarh,Sirohi,Rajasthan',
'Nimbaj,Sirohi,Rajasthan',
'Nitora,Sirohi,Rajasthan',
'Oda,Sirohi,Rajasthan',
'Ore,Sirohi,Rajasthan',
'Oriya,Sirohi,Rajasthan',
'Paba,Sirohi,Rajasthan',
'Padar,Sirohi,Rajasthan',
'Padiv,Sirohi,Rajasthan',
'Pamera,Sirohi,Rajasthan',
'Pehsua,Sirohi,Rajasthan',
'Phungani,Sirohi,Rajasthan',
'Pithapura,Sirohi,Rajasthan',
'Positra,Sirohi,Rajasthan',
'Raipur,Sirohi,Rajasthan',
'Rampura,Sirohi,Rajasthan',
'Rowada,Sirohi,Rajasthan',
'Sangana,Sirohi,Rajasthan',
'Sanpur,Sirohi,Rajasthan',
'Santpur,Sirohi,Rajasthan',
'Sanwara,Sirohi,Rajasthan',
'Sanwara,Sirohi,Rajasthan',
'Sartara,Sirohi,Rajasthan',
'Sheoganj Subji Mandi,Sirohi,Rajasthan',
'Sildar,Sirohi,Rajasthan',
'Sindrath,Sirohi,Rajasthan',
'Sirodi,Sirohi,Rajasthan',
'Sirohi Bazar,Sirohi,Rajasthan',
'Sirohi Bhatkra,Sirohi,Rajasthan',
'Sirohi Road,Sirohi,Rajasthan',
'Sirohi Sarupvilas,Sirohi,Rajasthan',
'Sivera,Sirohi,Rajasthan',
'Siyawa,Sirohi,Rajasthan',
'Soorpagla,Sirohi,Rajasthan',
'Sorda,Sirohi,Rajasthan',
'Tankiya,Sirohi,Rajasthan',
'Tanwari,Sirohi,Rajasthan',
'Tartoli,Sirohi,Rajasthan',
'Telpur,Sirohi,Rajasthan',
'Udd,Sirohi,Rajasthan',
'Udwaria,Sirohi,Rajasthan',
'Uplagarh,Sirohi,Rajasthan',
'Uthman,Sirohi,Rajasthan',
'Utraj,Sirohi,Rajasthan',
'Valdra,Sirohi,Rajasthan',
'Valoriya,Sirohi,Rajasthan',
'Van,Sirohi,Rajasthan',
'Varada,Sirohi,Rajasthan',
'Varli,Sirohi,Rajasthan',
'Varman,Sirohi,Rajasthan',
'Vasa,Sirohi,Rajasthan',
'Vasda,Sirohi,Rajasthan',
'Vatera,Sirohi,Rajasthan',
'Vellangari,Sirohi,Rajasthan',
'Verwara,Sirohi,Rajasthan',
'Abu,Sirohi,Rajasthan',
'Aburoad,Sirohi,Rajasthan',
'Rohida,Sirohi,Rajasthan',
'Sarupganj,Sirohi,Rajasthan',
'Shantivan,Sirohi,Rajasthan',
'Binanigram,Sirohi,Rajasthan',
'Jkpuram,Sirohi,Rajasthan',
'Pindwara,Sirohi,Rajasthan',
'Anadra,Sirohi,Rajasthan',
'Dantrai,Sirohi,Rajasthan',
'Mandar,Sirohi,Rajasthan',
'Reodar,Sirohi,Rajasthan',
'Posalia,Sirohi,Rajasthan',
'Sheoganj,Sirohi,Rajasthan',
'Balda,Sirohi,Rajasthan',
'Dhanta,Sirohi,Rajasthan',
'Dodua,Sirohi,Rajasthan',
'Jawal,Sirohi,Rajasthan',
'Kalandari,Sirohi,Rajasthan',
'Palri M,Sirohi,Rajasthan',
'Sirohi H.O,Sirohi,Rajasthan',
'Avikanagar,Tonk,Rajasthan',
'Hamirpur,Tonk,Rajasthan',
'Lawa,Tonk,Rajasthan',
'Pachewar,Tonk,Rajasthan',
'Khirgi,Tonk,Rajasthan',
'Aligarh,Tonk,Rajasthan',
'Aliyari,Tonk,Rajasthan',
'Ambapura Colony Daulta,Tonk,Rajasthan',
'Amli,Tonk,Rajasthan',
'Antoli,Tonk,Rajasthan',
'Anwan,Tonk,Rajasthan',
'Arniya Kedar,Tonk,Rajasthan',
'Awara,Tonk,Rajasthan',
'Bagari,Tonk,Rajasthan',
'Bagdawa,Tonk,Rajasthan',
'Bahad,Tonk,Rajasthan',
'Balithal,Tonk,Rajasthan',
'Balunda,Tonk,Rajasthan',
'Bambore,Tonk,Rajasthan',
'Banasthali Vidya Peeth,Tonk,Rajasthan',
'Banetha,Tonk,Rajasthan',
'Bansera,Tonk,Rajasthan',
'Banthali,Tonk,Rajasthan',
'Baori,Tonk,Rajasthan',
'Baroni,Tonk,Rajasthan',
'Barwas,Tonk,Rajasthan',
'Bassi,Tonk,Rajasthan',
'Beejwad,Tonk,Rajasthan',
'Bhanwata,Tonk,Rajasthan',
'Bharni,Tonk,Rajasthan',
'Bhartala,Tonk,Rajasthan',
'Bhasu,Tonk,Rajasthan',
'Bheepur,Tonk,Rajasthan',
'Bilota,Tonk,Rajasthan',
'Bisalpur,Tonk,Rajasthan',
'Borkhandi,Tonk,Rajasthan',
'Bosariya,Tonk,Rajasthan',
'Botunda,Tonk,Rajasthan',
'Budha Dewal,Tonk,Rajasthan',
'Chainpura,Tonk,Rajasthan',
'Chainpuria,Tonk,Rajasthan',
'Chanani,Tonk,Rajasthan',
'Chandlai,Tonk,Rajasthan',
'Chandli,Tonk,Rajasthan',
'Chandsen,Tonk,Rajasthan',
'Chandwar,Tonk,Rajasthan',
'Charnet,Tonk,Rajasthan',
'Chaturbhujpura,Tonk,Rajasthan',
'Chavandia,Tonk,Rajasthan',
'Chhan,Tonk,Rajasthan',
'Chogai,Tonk,Rajasthan',
'Choru,Tonk,Rajasthan',
'Chosla,Tonk,Rajasthan',
'Crp Lines Deoli,Tonk,Rajasthan',
'Dabar Kalan,Tonk,Rajasthan',
'Dabardumba,Tonk,Rajasthan',
'Dakhiya,Tonk,Rajasthan',
'Dangarthal,Tonk,Rajasthan',
'Dardahind,Tonk,Rajasthan',
'Dardaturki,Tonk,Rajasthan',
'Datob,Tonk,Rajasthan',
'Datwas,Tonk,Rajasthan',
'Dehlod,Tonk,Rajasthan',
'Deoli,Tonk,Rajasthan',
'Deoli Bazar,Tonk,Rajasthan',
'Deoli Bhanchi,Tonk,Rajasthan',
'Deoli Gaon,Tonk,Rajasthan',
'Deoli,Tonk,Rajasthan',
'Deshma,Tonk,Rajasthan',
'Dewarawas,Tonk,Rajasthan',
'Dholi,Tonk,Rajasthan',
'Dhuwan,Tonk,Rajasthan',
'Diggi,Tonk,Rajasthan',
'Dodwari,Tonk,Rajasthan',
'Dungri Kalan,Tonk,Rajasthan',
'Duni,Tonk,Rajasthan',
'Galod,Tonk,Rajasthan',
'Ganeti,Tonk,Rajasthan',
'Ganwar,Tonk,Rajasthan',
'Gaonri,Tonk,Rajasthan',
'Geroli,Tonk,Rajasthan',
'Ghad,Tonk,Rajasthan',
'Ghas,Tonk,Rajasthan',
'Gothara,Tonk,Rajasthan',
'Govt.College Tonk,Tonk,Rajasthan',
'Gurai,Tonk,Rajasthan',
'Harchandera,Tonk,Rajasthan',
'Hatuna,Tonk,Rajasthan',
'Hedri Pura,Tonk,Rajasthan',
'Hisampur,Tonk,Rajasthan',
'Indokia,Tonk,Rajasthan',
'Indoli,Tonk,Rajasthan',
'Jamdoli,Tonk,Rajasthan',
'Jaulan,Tonk,Rajasthan',
'Jharli,Tonk,Rajasthan',
'Jhilai,Tonk,Rajasthan',
'Jhirana,Tonk,Rajasthan',
'Jhundwa,Tonk,Rajasthan',
'Jugalpura,Tonk,Rajasthan',
'Jumma Masjid Tonk,Tonk,Rajasthan',
'Juniya,Tonk,Rajasthan',
'Kabra,Tonk,Rajasthan',
'Kacholia,Tonk,Rajasthan',
'Kachrawata,Tonk,Rajasthan',
'Kadila,Tonk,Rajasthan',
'Kakalwad,Tonk,Rajasthan',
'Kakor,Tonk,Rajasthan',
'Kalmanda,Tonk,Rajasthan',
'Kantoli,Tonk,Rajasthan',
'Kanwara,Tonk,Rajasthan',
'Kaseer,Tonk,Rajasthan',
'Kashipura,Tonk,Rajasthan',
'Kathmana,Tonk,Rajasthan',
'Khandewat,Tonk,Rajasthan',
'Khandwa,Tonk,Rajasthan',
'Khareda,Tonk,Rajasthan',
'Khareda Bujurg,Tonk,Rajasthan',
'Khatoli,Tonk,Rajasthan',
'Khelniya,Tonk,Rajasthan',
'Kholiya,Tonk,Rajasthan',
'Kookar,Tonk,Rajasthan',
'Kuharakalan,Tonk,Rajasthan',
'Kunder,Tonk,Rajasthan',
'Kurar,Tonk,Rajasthan',
'Lalwadi,Tonk,Rajasthan',
'Lamba,Tonk,Rajasthan',
'Lamba Hari Singh,Tonk,Rajasthan',
'Lamba Kalan,Tonk,Rajasthan',
'Lawadar,Tonk,Rajasthan',
'Laxmipura,Tonk,Rajasthan',
'Loharwara,Tonk,Rajasthan',
'Luhara,Tonk,Rajasthan',
'Mahapura,Tonk,Rajasthan',
'Maleda,Tonk,Rajasthan',
'Malikpur,Tonk,Rajasthan',
'Malpura,Tonk,Rajasthan',
'Mandawara,Tonk,Rajasthan',
'Mandolai,Tonk,Rajasthan',
'Mehandwas,Tonk,Rajasthan',
'Mehrun,Tonk,Rajasthan',
'Moar,Tonk,Rajasthan',
'Mohammed Garh,Tonk,Rajasthan',
'Mohammed Pura,Tonk,Rajasthan',
'Mor Bhatiyan,Tonk,Rajasthan',
'Morla,Tonk,Rajasthan',
'Mundia,Tonk,Rajasthan',
'Mundia Kalan,Tonk,Rajasthan',
'Nagar,Tonk,Rajasthan',
'Nagarfort,Tonk,Rajasthan',
'Naner,Tonk,Rajasthan',
'Nasirda,Tonk,Rajasthan',
'Natwara,Tonk,Rajasthan',
'Nayagaon,Tonk,Rajasthan',
'Newai RS,Tonk,Rajasthan',
'Newai,Tonk,Rajasthan',
'Nimera,Tonk,Rajasthan',
'Niwaria,Tonk,Rajasthan',
'Nohata,Tonk,Rajasthan',
'Pahari,Tonk,Rajasthan',
'Palai,Tonk,Rajasthan',
'Palai,Tonk,Rajasthan',
'Palda,Tonk,Rajasthan',
'Panwalia,Tonk,Rajasthan',
'Panwar,Tonk,Rajasthan',
'Parana,Tonk,Rajasthan',
'Parli,Tonk,Rajasthan',
'Pasrotia,Tonk,Rajasthan',
'Payga,Tonk,Rajasthan',
'Pchala,Tonk,Rajasthan',
'Peeplu,Tonk,Rajasthan',
'Phuleta,Tonk,Rajasthan',
'Phyawadi,Tonk,Rajasthan',
'Polyada,Tonk,Rajasthan',
'Purani Tonk,Tonk,Rajasthan',
'Quafala Bazar Tonk,Tonk,Rajasthan',
'Raholi,Tonk,Rajasthan',
'Raj.State Tennries Ltd.,Tonk,Rajasthan',
'Rajkot,Tonk,Rajasthan',
'Rajmahal,Tonk,Rajasthan',
'Rajpura,Tonk,Rajasthan',
'Rajwas,Tonk,Rajasthan',
'Ranipura,Tonk,Rajasthan',
'Ranoli,Tonk,Rajasthan',
'Reendliya,Tonk,Rajasthan',
'Reendliya Rampura,Tonk,Rajasthan',
'Roop Pura,Tonk,Rajasthan',
'Roopwas,Tonk,Rajasthan',
'Sandera,Tonk,Rajasthan',
'Sankhana,Tonk,Rajasthan',
'Santhali,Tonk,Rajasthan',
'Sanwaria,Tonk,Rajasthan',
'Sanwatgarh,Tonk,Rajasthan',
'Satwara,Tonk,Rajasthan',
'Seedra,Tonk,Rajasthan',
'Shop,Tonk,Rajasthan',
'Siras,Tonk,Rajasthan',
'Sirohi,Tonk,Rajasthan',
'Sitapura,Tonk,Rajasthan',
'Sitarampura,Tonk,Rajasthan',
'Soda,Tonk,Rajasthan',
'Soda Baori,Tonk,Rajasthan',
'Sohela,Tonk,Rajasthan',
'Sonwa,Tonk,Rajasthan',
'Soran,Tonk,Rajasthan',
'Sunara,Tonk,Rajasthan',
'Sunthra,Tonk,Rajasthan',
'Sureli,Tonk,Rajasthan',
'Takholi,Tonk,Rajasthan',
'Thadoli,Tonk,Rajasthan',
'Thanwala,Tonk,Rajasthan',
'Tilanju,Tonk,Rajasthan',
'Titaria,Tonk,Rajasthan',
'Titonli(Badagaon),Tonk,Rajasthan',
'Todarai Singh,Tonk,Rajasthan',
'Tonk Raj H.O,Tonk,Rajasthan',
'Tonkrawas,Tonk,Rajasthan',
'Tordisagar,Tonk,Rajasthan',
'Uniara Khurd,Tonk,Rajasthan',
'Uniara,Tonk,Rajasthan',
'Wazirpura,Tonk,Rajasthan',
'Budel,Udaipur,Rajasthan',
'Chansda,Udaipur,Rajasthan',
'Dhundi,Udaipur,Rajasthan',
'Harshawara,Udaipur,Rajasthan',
'Kharwa,Udaipur,Rajasthan',
'Kolar,Udaipur,Rajasthan',
'Nayagaon,Udaipur,Rajasthan',
'Umaramines,Udaipur,Rajasthan',
'Badgaon,Udaipur,Rajasthan',
'Barda,Udaipur,Rajasthan',
'Bedla,Udaipur,Rajasthan',
'Bhutala,Udaipur,Rajasthan',
'Godach,Udaipur,Rajasthan',
'Iswal,Udaipur,Rajasthan',
'Kadia,Udaipur,Rajasthan',
'Lakhawali,Udaipur,Rajasthan',
'Losing,Udaipur,Rajasthan',
'Loyra,Udaipur,Rajasthan',
'Madar,Udaipur,Rajasthan',
'Nedach,Udaipur,Rajasthan',
'Sapetia,Udaipur,Rajasthan',
'Shobhagpura,Udaipur,Rajasthan',
'Thoor,Udaipur,Rajasthan',
'Agad,Udaipur,Rajasthan',
'Akola,Udaipur,Rajasthan',
'Amar Pura,Udaipur,Rajasthan',
'Amar Pura,Udaipur,Rajasthan',
'Anjani,Udaipur,Rajasthan',
'Arinda,Udaipur,Rajasthan',
'Arnia,Udaipur,Rajasthan',
'Baalicha,Udaipur,Rajasthan',
'Badgaon,Udaipur,Rajasthan',
'Baggad,Udaipur,Rajasthan',
'Bansada,Udaipur,Rajasthan',
'Barodia,Udaipur,Rajasthan',
'Batharda Kalan,Udaipur,Rajasthan',
'Batharda Khurd,Udaipur,Rajasthan',
'Bharev,Udaipur,Rajasthan',
'Bhopa Khera,Udaipur,Rajasthan',
'Chargadia,Udaipur,Rajasthan',
'Daroli,Udaipur,Rajasthan',
'Deolia,Udaipur,Rajasthan',
'Dhamniya,Udaipur,Rajasthan',
'Dhikiya,Udaipur,Rajasthan',
'Dholia,Udaipur,Rajasthan',
'Dhundia,Udaipur,Rajasthan',
'Gupri,Udaipur,Rajasthan',
'Hinta,Udaipur,Rajasthan',
'Kali Bhit,Udaipur,Rajasthan',
'Kharsan,Udaipur,Rajasthan',
'Khedi,Udaipur,Rajasthan',
'Kkunthwas,Udaipur,Rajasthan',
'Kun,Udaipur,Rajasthan',
'Kundai,Udaipur,Rajasthan',
'Laku Ka Lewa,Udaipur,Rajasthan',
'Lasadia,Udaipur,Rajasthan',
'Lunda,Udaipur,Rajasthan',
'Majawada,Udaipur,Rajasthan',
'Menar,Udaipur,Rajasthan',
'Merta,Udaipur,Rajasthan',
'Modi,Udaipur,Rajasthan',
'Motida,Udaipur,Rajasthan',
'Nandwel,Udaipur,Rajasthan',
'Onarsingh Ki Bhagal,Udaipur,Rajasthan',
'Pithalpura,Udaipur,Rajasthan',
'Saleda,Udaipur,Rajasthan',
'Sarangpura,Udaipur,Rajasthan',
'Sarangpura,Udaipur,Rajasthan',
'Vana,Udaipur,Rajasthan',
'Add,Udaipur,Rajasthan',
'Anant,Udaipur,Rajasthan',
'Bharkundi,Udaipur,Rajasthan',
'Bhojpur,Udaipur,Rajasthan',
'Boria,Udaipur,Rajasthan',
'Chari,Udaipur,Rajasthan',
'Dantalia,Udaipur,Rajasthan',
'Devla,Udaipur,Rajasthan',
'Dhariawad,Udaipur,Rajasthan',
'Gadriawas,Udaipur,Rajasthan',
'Gadwas,Udaipur,Rajasthan',
'Gopalpura,Udaipur,Rajasthan',
'Jhadoli,Udaipur,Rajasthan',
'Keshariawad,Udaipur,Rajasthan',
'Khunta,Udaipur,Rajasthan',
'Lodia,Udaipur,Rajasthan',
'Lohagarh,Udaipur,Rajasthan',
'Managaon,Udaipur,Rajasthan',
'Mandvi,Udaipur,Rajasthan',
'Mungana,Udaipur,Rajasthan',
'Nalva,Udaipur,Rajasthan',
'Pahada,Udaipur,Rajasthan',
'Parel,Udaipur,Rajasthan',
'Parsola,Udaipur,Rajasthan',
'Piplia,Udaipur,Rajasthan',
'Sihar,Udaipur,Rajasthan',
'Tothada,Udaipur,Rajasthan',
'Alsigarh,Udaipur,Rajasthan',
'Baghpura,Udaipur,Rajasthan',
'Bari Undri,Udaipur,Rajasthan',
'Bujhra,Udaipur,Rajasthan',
'Jekra,Udaipur,Rajasthan',
'Madla,Udaipur,Rajasthan',
'Madri,Udaipur,Rajasthan',
'Makradeo,Udaipur,Rajasthan',
'Pai,Udaipur,Rajasthan',
'Pipalwara,Udaipur,Rajasthan',
'Saradeet,Udaipur,Rajasthan',
'Adwas,Udaipur,Rajasthan',
'Ajbara,Udaipur,Rajasthan',
'Balicha,Udaipur,Rajasthan',
'Bambora,Udaipur,Rajasthan',
'Bari Tb (S),Udaipur,Rajasthan',
'Bemla,Udaipur,Rajasthan',
'Bhalon Ka Guda,Udaipur,Rajasthan',
'Bhensda Kalan,Udaipur,Rajasthan',
'Bhoiyon Ki Pancholi,Udaipur,Rajasthan',
'Bhuwana,Udaipur,Rajasthan',
'Bichhadi,Udaipur,Rajasthan',
'Chansda,Udaipur,Rajasthan',
'Dakan Kotra,Udaipur,Rajasthan',
'Dantesar,Udaipur,Rajasthan',
'Debari,Udaipur,Rajasthan',
'Deopura,Udaipur,Rajasthan',
'Dhinkli,Udaipur,Rajasthan',
'Fatehpur,Udaipur,Rajasthan',
'Gudli,Udaipur,Rajasthan',
'Jagat,Udaipur,Rajasthan',
'Jawad,Udaipur,Rajasthan',
'Jawar,Udaipur,Rajasthan',
'Jhamar Kotra,Udaipur,Rajasthan',
'Kaladwas,Udaipur,Rajasthan',
'Kanpur,Udaipur,Rajasthan',
'Karda,Udaipur,Rajasthan',
'Kathar,Udaipur,Rajasthan',
'Kewda Khurd,Udaipur,Rajasthan',
'Kharwa,Udaipur,Rajasthan',
'Kurawar,Udaipur,Rajasthan',
'Lakadwas,Udaipur,Rajasthan',
'Mahuwara,Udaipur,Rajasthan',
'Matoon,Udaipur,Rajasthan',
'Methudi,Udaipur,Rajasthan',
'Nai,Udaipur,Rajasthan',
'Naijhar,Udaipur,Rajasthan',
'Padla,Udaipur,Rajasthan',
'Palodara,Udaipur,Rajasthan',
'Paner,Udaipur,Rajasthan',
'Piladhar,Udaipur,Rajasthan',
'Royda,Udaipur,Rajasthan',
'Sakroda,Udaipur,Rajasthan',
'Saveena,Udaipur,Rajasthan',
'Semal,Udaipur,Rajasthan',
'Shishvi,Udaipur,Rajasthan',
'Singhatwara,Udaipur,Rajasthan',
'Sisarma,Udaipur,Rajasthan',
'Titardi,Udaipur,Rajasthan',
'Udaipur City,Udaipur,Rajasthan',
'Udaipur Fatehpura,Udaipur,Rajasthan',
'Udaipur H Magri,Udaipur,Rajasthan',
'Udaipur H.O,Udaipur,Rajasthan',
'Udaipur Industrial Area,Udaipur,Rajasthan',
'Udaipur Macchala Magra,Udaipur,Rajasthan',
'Udaipur Naya Sarafa,Udaipur,Rajasthan',
'Udaipur Palace Road,Udaipur,Rajasthan',
'Udaipur Pratapnagar,Udaipur,Rajasthan',
'Udaipur Railway Station,Udaipur,Rajasthan',
'Udaipur Rani Road,Udaipur,Rajasthan',
'Udaipur Shastri Circle,Udaipur,Rajasthan',
'Udaipur Station Road,Udaipur,Rajasthan',
'Udaipur Surajpole,Udaipur,Rajasthan',
'Udaipur University Campus,Udaipur,Rajasthan',
'Wali,Udaipur,Rajasthan',
'Zawar Mines,Udaipur,Rajasthan',
'Zinc Smelter,Udaipur,Rajasthan',
'Bagdunda,Udaipur,Rajasthan',
'Bekria,Udaipur,Rajasthan',
'Bhadviguda,Udaipur,Rajasthan',
'Chatia Khedi,Udaipur,Rajasthan',
'Chhali,Udaipur,Rajasthan',
'Chorbaori,Udaipur,Rajasthan',
'Dhol,Udaipur,Rajasthan',
'Gogrood,Udaipur,Rajasthan',
'Gogunda,Udaipur,Rajasthan',
'Jaswantgarh,Udaipur,Rajasthan',
'Jhadoli,Udaipur,Rajasthan',
'Kachhaba,Udaipur,Rajasthan',
'Kyari,Udaipur,Rajasthan',
'Loharcha,Udaipur,Rajasthan',
'Mada,Udaipur,Rajasthan',
'Majawad,Udaipur,Rajasthan',
'Majawadi,Udaipur,Rajasthan',
'Malwa Ka Chora,Udaipur,Rajasthan',
'Mewaron Ka Math,Udaipur,Rajasthan',
'Modi,Udaipur,Rajasthan',
'Morwal,Udaipur,Rajasthan',
'Nal,Udaipur,Rajasthan',
'Nandeshma,Udaipur,Rajasthan',
'Obra Kalan,Udaipur,Rajasthan',
'Pipla,Udaipur,Rajasthan',
'Rao Madra,Udaipur,Rajasthan',
'Ravlia Khurd,Udaipur,Rajasthan',
'Rawalia Kalan,Udaipur,Rajasthan',
'Saidem,Udaipur,Rajasthan',
'Surajgarh,Udaipur,Rajasthan',
'Teja Ka Was,Udaipur,Rajasthan',
'Ambassa,Udaipur,Rajasthan',
'Amiwara,Udaipur,Rajasthan',
'Amlia,Udaipur,Rajasthan',
'Beerothi,Udaipur,Rajasthan',
'Bichhiwara,Udaipur,Rajasthan',
'Daiya,Udaipur,Rajasthan',
'Gejvi,Udaipur,Rajasthan',
'Jhadol (P),Udaipur,Rajasthan',
'Kolyari,Udaipur,Rajasthan',
'Lathuni,Udaipur,Rajasthan',
'Manpur,Udaipur,Rajasthan',
'Nichli Sigri,Udaipur,Rajasthan',
'Oda,Udaipur,Rajasthan',
'Ogna,Udaipur,Rajasthan',
'Padawali,Udaipur,Rajasthan',
'Phalasia,Udaipur,Rajasthan',
'Sameeja,Udaipur,Rajasthan',
'Som,Udaipur,Rajasthan',
'Upreta,Udaipur,Rajasthan',
'Vass,Udaipur,Rajasthan',
'Adiwali,Udaipur,Rajasthan',
'Badla,Udaipur,Rajasthan',
'Balicha,Udaipur,Rajasthan',
'Balua,Udaipur,Rajasthan',
'Barapal,Udaipur,Rajasthan',
'Barothi,Udaipur,Rajasthan',
'Bawalwara,Udaipur,Rajasthan',
'Bayri,Udaipur,Rajasthan',
'Bhanda,Udaipur,Rajasthan',
'Bhudar,Udaipur,Rajasthan',
'Bilakh,Udaipur,Rajasthan',
'Chanawada,Udaipur,Rajasthan',
'Chhani,Udaipur,Rajasthan',
'Dabaycha,Udaipur,Rajasthan',
'Deri,Udaipur,Rajasthan',
'Dhinkwas,Udaipur,Rajasthan',
'Garnalakotra,Udaipur,Rajasthan',
'Ghodi,Udaipur,Rajasthan',
'Godawat Gorimba,Udaipur,Rajasthan',
'Jawas,Udaipur,Rajasthan',
'Jayra,Udaipur,Rajasthan',
'Kagdar,Udaipur,Rajasthan',
'Kanbai,Udaipur,Rajasthan',
'Kanuwara,Udaipur,Rajasthan',
'Karawada,Udaipur,Rajasthan',
'Karchha,Udaipur,Rajasthan',
'Katarwas,Udaipur,Rajasthan',
'Kaya,Udaipur,Rajasthan',
'Khandiobri,Udaipur,Rajasthan',
'Khanmeen,Udaipur,Rajasthan',
'Kherwara,Udaipur,Rajasthan',
'Kojawara,Udaipur,Rajasthan',
'Larathi,Udaipur,Rajasthan',
'Massaron Ki Obri,Udaipur,Rajasthan',
'Nayagaon,Udaipur,Rajasthan',
'Paderi,Udaipur,Rajasthan',
'Paduna,Udaipur,Rajasthan',
'Pal Kharwad,Udaipur,Rajasthan',
'Pareda,Udaipur,Rajasthan',
'Patia,Udaipur,Rajasthan',
'Pipli (A),Udaipur,Rajasthan',
'Pipli (B),Udaipur,Rajasthan',
'Pograkalan,Udaipur,Rajasthan',
'Rishabhdeo,Udaipur,Rajasthan',
'Sagwara,Udaipur,Rajasthan',
'Sarera,Udaipur,Rajasthan',
'Saroli,Udaipur,Rajasthan',
'Sarupal,Udaipur,Rajasthan',
'Sulai,Udaipur,Rajasthan',
'Sundra,Udaipur,Rajasthan',
'Suveri,Udaipur,Rajasthan',
'Thana,Udaipur,Rajasthan',
'Tidi,Udaipur,Rajasthan',
'Ugamna Kotra,Udaipur,Rajasthan',
'Bakhel,Udaipur,Rajasthan',
'Barli,Udaipur,Rajasthan',
'Bikarni,Udaipur,Rajasthan',
'Dhedmaria,Udaipur,Rajasthan',
'Guran,Udaipur,Rajasthan',
'Jed,Udaipur,Rajasthan',
'Jogiwara,Udaipur,Rajasthan',
'Juda,Udaipur,Rajasthan',
'Kagwas,Udaipur,Rajasthan',
'Khajuria,Udaipur,Rajasthan',
'Kotra,Udaipur,Rajasthan',
'Mahad,Udaipur,Rajasthan',
'Mahadi,Udaipur,Rajasthan',
'Mamer,Udaipur,Rajasthan',
'Mandawal,Udaipur,Rajasthan',
'Mandwa,Udaipur,Rajasthan',
'Medi,Udaipur,Rajasthan',
'Merpur,Udaipur,Rajasthan',
'Nayawas,Udaipur,Rajasthan',
'Sada,Udaipur,Rajasthan',
'Samoli,Udaipur,Rajasthan',
'Sandraf,Udaipur,Rajasthan',
'Kanore,Udaipur,Rajasthan',
'Badgaon,Udaipur,Rajasthan',
'Bhansol Garwara,Udaipur,Rajasthan',
'Bhimal,Udaipur,Rajasthan',
'Bijanwas,Udaipur,Rajasthan',
'Boyana,Udaipur,Rajasthan',
'Chandesara,Udaipur,Rajasthan',
'Changedi,Udaipur,Rajasthan',
'Dholi Magri,Udaipur,Rajasthan',
'Fatehnagar,Udaipur,Rajasthan',
'Gadoli,Udaipur,Rajasthan',
'Ghasa,Udaipur,Rajasthan',
'Intali,Udaipur,Rajasthan',
'Jawad,Udaipur,Rajasthan',
'Khemli,Udaipur,Rajasthan',
'Khempur,Udaipur,Rajasthan',
'Ladani,Udaipur,Rajasthan',
'Lopada,Udaipur,Rajasthan',
'Mahuda,Udaipur,Rajasthan',
'Mavli Jn H.O,Udaipur,Rajasthan',
'Nahar Magra,Udaipur,Rajasthan',
'Noorda,Udaipur,Rajasthan',
'Palan Kalan,Udaipur,Rajasthan',
'Palana Khurd,Udaipur,Rajasthan',
'Phalichada,Udaipur,Rajasthan',
'Rakhyawal,Udaipur,Rajasthan',
'Sakroda,Udaipur,Rajasthan',
'Salera Kalan,Udaipur,Rajasthan',
'Sangwa,Udaipur,Rajasthan',
'Sanwar,Udaipur,Rajasthan',
'Sindhu,Udaipur,Rajasthan',
'Thamla,Udaipur,Rajasthan',
'Uthnol,Udaipur,Rajasthan',
'Vadiyar,Udaipur,Rajasthan',
'Vasni Kalan,Udaipur,Rajasthan',
'Veerdholia,Udaipur,Rajasthan',
'Wanri,Udaipur,Rajasthan',
'Adkalia,Udaipur,Rajasthan',
'Adkalia,Udaipur,Rajasthan',
'Amloda,Udaipur,Rajasthan',
'B K Kherwara,Udaipur,Rajasthan',
'Badawali,Udaipur,Rajasthan',
'Ballabh,Udaipur,Rajasthan',
'Bamnia,Udaipur,Rajasthan',
'Banoda,Udaipur,Rajasthan',
'Baroda,Udaipur,Rajasthan',
'Bassi,Udaipur,Rajasthan',
'Bassi Junjawat,Udaipur,Rajasthan',
'Bedawal,Udaipur,Rajasthan',
'Bhabrana,Udaipur,Rajasthan',
'Bhoraipal,Udaipur,Rajasthan',
'Chiboda,Udaipur,Rajasthan',
'Dagar,Udaipur,Rajasthan',
'Dal,Udaipur,Rajasthan',
'Damana,Udaipur,Rajasthan',
'Deogam,Udaipur,Rajasthan',
'Dewas,Udaipur,Rajasthan',
'Dharod,Udaipur,Rajasthan',
'Dhavdi,Udaipur,Rajasthan',
'Dheemari,Udaipur,Rajasthan',
'Dholgiri Ka Khera,Udaipur,Rajasthan',
'Dodawali,Udaipur,Rajasthan',
'Gamda Pal,Udaipur,Rajasthan',
'Ghated,Udaipur,Rajasthan',
'Gingla,Udaipur,Rajasthan',
'Godana,Udaipur,Rajasthan',
'Godasar,Udaipur,Rajasthan',
'Gogala,Udaipur,Rajasthan',
'Gorana,Udaipur,Rajasthan',
'Gudel,Udaipur,Rajasthan',
'Idana,Udaipur,Rajasthan',
'Intali Khera,Udaipur,Rajasthan',
'Intali Pal,Udaipur,Rajasthan',
'Isarwas Dangiyan,Udaipur,Rajasthan',
'Jambuda,Udaipur,Rajasthan',
'Jetana,Udaipur,Rajasthan',
'Jhallara,Udaipur,Rajasthan',
'Jodhpur Khurd,Udaipur,Rajasthan',
'Kalyankalan,Udaipur,Rajasthan',
'Karakalan,Udaipur,Rajasthan',
'Karawali,Udaipur,Rajasthan',
'Katev,Udaipur,Rajasthan',
'Khakhad,Udaipur,Rajasthan',
'Kharka,Udaipur,Rajasthan',
'Kherad,Udaipur,Rajasthan',
'Mallada,Udaipur,Rajasthan',
'Malpur,Udaipur,Rajasthan',
'Manpur,Udaipur,Rajasthan',
'Matasula,Udaipur,Rajasthan',
'Mayada,Udaipur,Rajasthan',
'Mohd. Phalasia,Udaipur,Rajasthan',
'Morila,Udaipur,Rajasthan',
'Noli,Udaipur,Rajasthan',
'Orwaria,Udaipur,Rajasthan',
'Pandiyawara,Udaipur,Rajasthan',
'Panund,Udaipur,Rajasthan',
'Payara,Udaipur,Rajasthan',
'Phila,Udaipur,Rajasthan',
'Rathora,Udaipur,Rajasthan',
'Salumber,Udaipur,Rajasthan',
'Samoda,Udaipur,Rajasthan',
'Saradi,Udaipur,Rajasthan',
'Seria,Udaipur,Rajasthan',
'Shaktawat Ka Guda,Udaipur,Rajasthan',
'Shaktawato Ka Guda,Udaipur,Rajasthan',
'Sheshpur,Udaipur,Rajasthan',
'Sihad,Udaipur,Rajasthan',
'Sulawas,Udaipur,Rajasthan',
'Tekan,Udaipur,Rajasthan',
'Thada,Udaipur,Rajasthan',
'Toda,Udaipur,Rajasthan',
'Tokar,Udaipur,Rajasthan',
'Utharda,Udaipur,Rajasthan',
'Badgaon,Udaipur,Rajasthan',
'Bana Khurd,Udaipur,Rajasthan',
'Chandora,Udaipur,Rajasthan',
'Chatpur,Udaipur,Rajasthan',
'Chawand,Udaipur,Rajasthan',
'Chorai,Udaipur,Rajasthan',
'Dayli,Udaipur,Rajasthan',
'Depur,Udaipur,Rajasthan',
'Dhankiwara,Udaipur,Rajasthan',
'Dhelana,Udaipur,Rajasthan',
'Dhingri,Udaipur,Rajasthan',
'Ghatod,Udaipur,Rajasthan',
'Jambuda,Udaipur,Rajasthan',
'Jhadol (S),Udaipur,Rajasthan',
'Kalyanpur,Udaipur,Rajasthan',
'Kantora,Udaipur,Rajasthan',
'Katanwara,Udaipur,Rajasthan',
'Kejad,Udaipur,Rajasthan',
'Kunda,Udaipur,Rajasthan',
'Kuradia,Udaipur,Rajasthan',
'Medi Dhani,Udaipur,Rajasthan',
'Nathara,Udaipur,Rajasthan',
'Navda,Udaipur,Rajasthan',
'Pal Nimboda,Udaipur,Rajasthan',
'Pal Sarara,Udaipur,Rajasthan',
'Parsad,Udaipur,Rajasthan',
'Rajol,Udaipur,Rajasthan',
'Sagtara,Udaipur,Rajasthan',
'Sagtari,Udaipur,Rajasthan',
'Sallada,Udaipur,Rajasthan',
'Sarara,Udaipur,Rajasthan',
'Sarsia,Udaipur,Rajasthan',
'Semari,Udaipur,Rajasthan',
'Shayampura,Udaipur,Rajasthan',
'Shyampura,Udaipur,Rajasthan',
'Surkhand Ka Khera,Udaipur,Rajasthan',
'Thana,Udaipur,Rajasthan',
'Udaipuria Jagir,Udaipur,Rajasthan',
'Veerpura,Udaipur,Rajasthan',
'Sayra,Udaipur,Rajasthan',
'Kheroda,Udaipur,Rajasthan',
'ARS Station,Udaipur,Rajasthan',
'Balathal,Udaipur,Rajasthan',
'Bhatewaar,Udaipur,Rajasthan',
'Bhinder,Udaipur,Rajasthan',
'Dabok,Udaipur,Rajasthan',
'Dhamania,Udaipur,Rajasthan',
'Karanpur,Udaipur,Rajasthan',
'Kikawas,Udaipur,Rajasthan',
'Nawania,Udaipur,Rajasthan',
'Puria Kheri,Udaipur,Rajasthan',
'Rundera,Udaipur,Rajasthan',
'Tarawat,Udaipur,Rajasthan',
'Vallabhnagar,Udaipur,Rajasthan'
]

export default Locations;

